/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./.gallery/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 643);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(702);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScreenFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ServerStatusCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpContentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return downloadsFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tempFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return thumbnailsFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return iconsFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return openedFilesFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultFolderIconFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bgMediaFolder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__optimization__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_ProfilePage_selectors__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__containers_ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_Editor_actions__ = __webpack_require__(14);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;























var defaultBrandIcon = __webpack_require__(1037);
var defaultMultiAppBarIcon = __webpack_require__(1038);
var defaultMultiAppIcon = __webpack_require__(1039);
var I18n = __webpack_require__(5).I18n;
var ScreenFormat;
(function (ScreenFormat) {
    ScreenFormat["Tablet"] = "tablet";
    ScreenFormat["Mobile"] = "mobile";
    ScreenFormat["Desktop"] = "desktop";
})(ScreenFormat || (ScreenFormat = {}));
var ServerStatusCode;
(function (ServerStatusCode) {
    ServerStatusCode[ServerStatusCode["OK"] = 200] = "OK";
    ServerStatusCode[ServerStatusCode["NO_CONTENT"] = 204] = "NO_CONTENT";
    ServerStatusCode[ServerStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ServerStatusCode[ServerStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    ServerStatusCode[ServerStatusCode["CONFLICT"] = 409] = "CONFLICT";
    ServerStatusCode[ServerStatusCode["LOCKED"] = 423] = "LOCKED";
})(ServerStatusCode || (ServerStatusCode = {}));
var HttpHeaderType;
(function (HttpHeaderType) {
    HttpHeaderType["CONTENT_TYPE"] = "Content-Type";
    HttpHeaderType["LOCATION"] = "Location";
})(HttpHeaderType || (HttpHeaderType = {}));
var HttpContentType;
(function (HttpContentType) {
    HttpContentType["JSON"] = "application/json; charset=utf-8";
    HttpContentType["URLENCODED"] = "application/x-www-form-urlencoded";
})(HttpContentType || (HttpContentType = {}));
var downloadsFolder = 'downloads';
var tempFolder = 'tmp';
var thumbnailsFolder = 'thumbnails';
var iconsFolder = 'icons';
var openedFilesFolder = 'openedFiles';
var defaultFolderIconFolder = 'defaultFolderIcon';
var bgMediaFolder = 'bgMedia';
var MAX_RETRIES = 3;
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.getMediaId = function (item) {
        var regexMatches = /^\$\{media\}(.+)$/.exec(item);
        return regexMatches !== null ? parseInt(regexMatches[1], 10) : -1;
    };
    Utils.getFilenameFromMediaId = function (mediaId) {
        var filenameResult = /^\$media\$(.+)$/.exec(mediaId);
        return filenameResult ? filenameResult[1] : '';
    };
    Utils.formatFileSize = function (size) {
        var units = ['o', 'Ko', 'Mo', 'Go', 'To'];
        var tmpSize = size;
        var i;
        for (i = 0; i < units.length; i++) {
            if (tmpSize < 1024) {
                return tmpSize.toFixed(1) + " " + units[i];
            }
            tmpSize = tmpSize / 1024;
        }
        return tmpSize.toFixed(1) + " " + units[i];
    };
    Utils.getSvgIcon = function (iconFileName, attributes) {
        if (attributes === void 0) { attributes = {}; }
        var useNode = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', { xlinkHref: "#svgicon-" + iconFileName });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg', attributes, useNode);
    };
    Utils.nl2br = function (str) {
        return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    };
    Utils.promiseXHR = function (protocol, url, headers, isAsync, dataInUrl, dataInBody, attempt, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId) {
        var _this = this;
        if (headers === void 0) { headers = []; }
        if (isAsync === void 0) { isAsync = true; }
        if (dataInUrl === void 0) { dataInUrl = null; }
        if (dataInBody === void 0) { dataInBody = undefined; }
        if (attempt === void 0) { attempt = 0; }
        if (ignoreConnectionStatus === void 0) { ignoreConnectionStatus = false; }
        if (withCredentials === void 0) { withCredentials = true; }
        if (preventRedirect === void 0) { preventRedirect = true; }
        return new Promise(function (resolve, reject) {
            var isOnline = __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isOnline();
            if (ignoreConnectionStatus === false && isOnline !== true) {
                if (isOnline === false) {
                    console.warn('xhr rejected: connection status is false', url);
                    reject();
                }
                console.warn('xhr rejected: connection status not initialised', url);
                reject();
            }
            var urlWithParams = url;
            var payload = dataInBody;
            if (dataInUrl && !Utils.isEmptyObject(dataInUrl)) {
                urlWithParams += Utils.getUrlSeparator(urlWithParams) + Utils.dataToUrl(dataInUrl);
            }
            if (preventRedirect) {
                urlWithParams += Utils.getUrlSeparator(urlWithParams) + 'preventRedirect=true';
            }
            var xhr = new XMLHttpRequest();
            if (requestId) {
                Utils.cancelableRequests[requestId] = xhr;
            }
            xhr.withCredentials = withCredentials;
            xhr.open(protocol, urlWithParams, isAsync);
            headers.forEach(function (header) {
                if (header.key === 'overrideMimeType') {
                    xhr.overrideMimeType(header.value);
                }
                else {
                    xhr.setRequestHeader(header.key, header.value);
                }
            });
            xhr.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                var status, responseURL, isForbiddenRequest, isLockedResource, userName, message, URLS_WITHOUT_SESSION_CHECKING, shouldCheckSession;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            status = xhr.status, responseURL = xhr.responseURL;
                            isForbiddenRequest = [
                                ServerStatusCode.UNAUTHORIZED,
                                ServerStatusCode.FORBIDDEN,
                            ].includes(status) && !responseURL.includes('logout');
                            if (isForbiddenRequest) {
                                return [2 /*return*/, Utils.handleForbiddenRequest(xhr, resolve, reject, protocol, url, headers, isAsync, dataInUrl, dataInBody, attempt, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId)];
                            }
                            isLockedResource = status === ServerStatusCode.LOCKED;
                            if (isLockedResource) {
                                userName = '';
                                try {
                                    message = JSON.parse(xhr.responseText).message;
                                    userName = message.split('--')[1];
                                    // tslint:disable-next-line
                                }
                                catch (error) { }
                                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__containers_Editor_actions__["T" /* showLockedEditorPopup */])(userName));
                                return [2 /*return*/];
                            }
                            resolve(xhr);
                            if (requestId) {
                                delete Utils.cancelableRequests[requestId];
                            }
                            URLS_WITHOUT_SESSION_CHECKING = [
                                __WEBPACK_IMPORTED_MODULE_4__url__["a" /* ApiUrls */].AUTH + "refresh",
                                __WEBPACK_IMPORTED_MODULE_4__url__["a" /* ApiUrls */].AUTH + "check",
                                __WEBPACK_IMPORTED_MODULE_4__url__["a" /* ApiUrls */].AUTH + "logout",
                                __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].checkOnlineStatusDomain,
                            ];
                            shouldCheckSession = URLS_WITHOUT_SESSION_CHECKING.every(function (urlWithoutSessionChecking) { return !url.includes(urlWithoutSessionChecking); });
                            if (!shouldCheckSession) return [3 /*break*/, 2];
                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__containers_MultiAppAuthentication_actions__["b" /* checkActiveSession */])())];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); };
            xhr.onabort = function () {
                reject(xhr);
                if (requestId) {
                    delete Utils.cancelableRequests[requestId];
                }
            };
            // The hack resolving the promise if (xhr.readyState === 4 && xhr.status === 0) has been deleted, it may be useful for cross domain requests
            xhr.onerror = function () {
                var isNativeApiCall = url.includes(__WEBPACK_IMPORTED_MODULE_3__nativeApi__["b" /* default */].targetUrl);
                if (isNativeApiCall) {
                    Utils.handleNativeApiBug(xhr, resolve, reject, protocol, url, headers, isAsync, dataInUrl, dataInBody, attempt, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId);
                    return;
                }
                reject(xhr);
                if (requestId) {
                    delete Utils.cancelableRequests[requestId];
                }
            };
            if (onProgress) {
                xhr.upload.onprogress = Object(__WEBPACK_IMPORTED_MODULE_18__optimization__["b" /* throttle */])(onProgress, Utils.UPLOAD_PROGRESS_DELAY);
            }
            xhr.send(payload);
        });
    };
    Utils.handleForbiddenRequest = function (xhr, resolve, reject, protocol, url, headers, isAsync, dataInUrl, dataInBody, attempt, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId) {
        return __awaiter(this, void 0, void 0, function () {
            var status, responseText, isInvalidCredentials, isAuthenticationFailure, isAnotherUserLogin, isMobileApp, location, isRedirectToExternalLoginPage, _a, origin, currentRoute, domain, _b, _c, host, loginUrl, recallForbiddenRequest, credentials, isLoggedIn, _d, method, company, config;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        status = xhr.status, responseText = xhr.responseText;
                        isInvalidCredentials = responseText.includes('INVALID_CREDENTIALS');
                        isAuthenticationFailure = responseText.includes('AUTHENTICATION_FAILURE');
                        isAnotherUserLogin = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().multiAppAuthenticationInfos.isAnotherUserLogin;
                        isMobileApp = __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp;
                        if (isInvalidCredentials || isAnotherUserLogin || isAuthenticationFailure) {
                            return [2 /*return*/, reject(xhr)];
                        }
                        location = xhr.getResponseHeader(HttpHeaderType.LOCATION);
                        isRedirectToExternalLoginPage = status === ServerStatusCode.FORBIDDEN && location && location !== '#';
                        if (!(isRedirectToExternalLoginPage && !isMobileApp)) return [3 /*break*/, 1];
                        _a = window.location, origin = _a.origin, currentRoute = _a.href;
                        domain = origin;
                        if (origin.includes('localhost')) { // for dev only
                            _b = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().galleryInfos.config.service, _c = (_b === void 0 ? {} : _b).host, host = _c === void 0 ? 'https://migrationv3.zone-secure.net' : _c;
                            domain = Utils.getUrlWithHttpsProtocol(host);
                        }
                        else if (location && location.includes('http')) {
                            domain = '';
                        }
                        loginUrl = "" + domain + location + "&redirectTo=" + encodeURIComponent(currentRoute);
                        window.location.href = loginUrl;
                        return [3 /*break*/, 12];
                    case 1:
                        if (!(attempt <= MAX_RETRIES)) return [3 /*break*/, 11];
                        recallForbiddenRequest = function () { return __awaiter(_this, void 0, void 0, function () {
                            var token, urlWithToken, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        token = __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].token;
                                        urlWithToken = url.includes('token=')
                                            ? url.replace(/(token=)[^\&]+/, '$1' + token)
                                            : "" + url + Utils.getUrlSeparator(url) + "token=" + token;
                                        return [4 /*yield*/, Utils.promiseXHR(protocol, urlWithToken, headers, isAsync, dataInUrl, dataInBody, attempt + 1, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId)];
                                    case 1:
                                        response = _a.sent();
                                        resolve(response);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!Utils.isFreeUrlApp()) return [3 /*break*/, 4];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__containers_MultiAppAuthentication_actions__["d" /* freeUrlAppLogin */])())];
                    case 2:
                        _e.sent();
                        return [4 /*yield*/, recallForbiddenRequest()];
                    case 3:
                        _e.sent();
                        return [2 /*return*/];
                    case 4:
                        credentials = Utils.getMultiAppCredentials();
                        isLoggedIn = credentials && credentials.login;
                        if (!isLoggedIn) return [3 /*break*/, 10];
                        _d = credentials, method = _d.method, company = _d.company;
                        if (!(method === __WEBPACK_IMPORTED_MODULE_16__containers_MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication)) return [3 /*break*/, 7];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__containers_MultiAppAuthentication_actions__["b" /* checkActiveSession */])(true))];
                    case 5:
                        _e.sent();
                        return [4 /*yield*/, recallForbiddenRequest()];
                    case 6:
                        _e.sent();
                        return [3 /*break*/, 10];
                    case 7:
                        config = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().galleryInfos.config;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__containers_MultiAppAuthentication_actions__["h" /* orgLogin */])(config, company))];
                    case 8:
                        _e.sent();
                        return [4 /*yield*/, recallForbiddenRequest()];
                    case 9:
                        _e.sent();
                        _e.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        reject(xhr);
                        _e.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    Utils.dataToUrl = function (data, mustEncode) {
        if (mustEncode === void 0) { mustEncode = true; }
        var url = '';
        for (var i in data) {
            if (data[i] instanceof Array) {
                for (var j = 0; j < data[i].length; j++) {
                    var key = mustEncode ? encodeURIComponent("" + i) : "" + i;
                    var value = mustEncode ? encodeURIComponent(data[i][j]) : data[i][j];
                    url += "&" + key + "=" + value;
                }
            }
            else {
                if (url) {
                    url += '&';
                }
                url += i + "=" + (mustEncode ? encodeURIComponent(data[i]) : data[i]);
            }
        }
        return url;
    };
    Utils.fetchJson = function (url, protocol, isAsync, ignoreConnectionStatus, dataInUrl, dataInBody, contentType, withCredentials, preventRedirect, preventSecurityHeader, onProgress, requestId) {
        if (protocol === void 0) { protocol = 'GET'; }
        if (isAsync === void 0) { isAsync = true; }
        if (ignoreConnectionStatus === void 0) { ignoreConnectionStatus = false; }
        if (dataInUrl === void 0) { dataInUrl = null; }
        if (dataInBody === void 0) { dataInBody = undefined; }
        if (contentType === void 0) { contentType = undefined; }
        if (withCredentials === void 0) { withCredentials = true; }
        if (preventRedirect === void 0) { preventRedirect = true; }
        if (preventSecurityHeader === void 0) { preventSecurityHeader = false; }
        return Utils.fetchText(url, protocol, isAsync, ignoreConnectionStatus, dataInUrl, dataInBody, contentType, withCredentials, preventRedirect, preventSecurityHeader, onProgress, requestId)
            .then(function (responseText) { return responseText && JSON.parse(responseText); });
    };
    Utils.encodeFormPayload = function (fields) {
        var fieldKeys = Object.keys(fields);
        var uriParameters = [];
        fieldKeys.forEach(function (fieldKey) {
            var encodedKey = encodeURIComponent(fieldKey);
            var value = fields[fieldKey];
            var encodedValues = Array.isArray(value)
                ? value.map(function (value) { return encodeURIComponent(String(value)); })
                : [encodeURIComponent(fields[fieldKey])];
            uriParameters.push.apply(uriParameters, __spread(encodedValues.map(function (encodedValue) { return encodedKey + "=" + encodedValue; })));
        });
        return uriParameters.join('&');
    };
    Utils.fetchText = function (url, protocol, isAsync, ignoreConnectionStatus, dataInUrl, dataInBody, contentType, withCredentials, preventRedirect, preventSecurityHeader, onProgress, requestId) {
        if (protocol === void 0) { protocol = 'GET'; }
        if (isAsync === void 0) { isAsync = true; }
        if (ignoreConnectionStatus === void 0) { ignoreConnectionStatus = false; }
        if (dataInUrl === void 0) { dataInUrl = null; }
        if (dataInBody === void 0) { dataInBody = undefined; }
        if (contentType === void 0) { contentType = undefined; }
        if (withCredentials === void 0) { withCredentials = true; }
        if (preventRedirect === void 0) { preventRedirect = true; }
        if (preventSecurityHeader === void 0) { preventSecurityHeader = false; }
        var headers = __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].getSecurityHeaderIfNeeded(preventSecurityHeader);
        if (contentType) {
            headers.push({
                key: HttpHeaderType.CONTENT_TYPE,
                value: contentType,
            });
        }
        return Utils.promiseXHR(protocol, url, headers, isAsync, dataInUrl, dataInBody, undefined, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId)
            .then(function (response) {
            return [
                0,
                ServerStatusCode.OK,
                ServerStatusCode.NO_CONTENT,
            ].includes(response.status)
                ? Promise.resolve(response.responseText)
                : Promise.reject(response);
        })
            .catch(function (error) {
            return Promise.reject(error);
        });
    };
    Utils.isResourceAvailable = function (url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.timeout = 1000;
            xhr.open('GET', url, true);
            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve(xhr);
                }
                else {
                    reject(xhr);
                }
            };
            xhr.ontimeout = function () {
                if (xhr.status === 0) {
                    resolve(xhr);
                }
                else {
                    reject(xhr);
                }
            };
            xhr.send();
        });
    };
    Utils.parseDate = function (dateString) {
        var dateStringSplit = dateString.split(' ');
        var dateSplit = dateStringSplit[0].split('-').map(function (e) { return parseInt(e, 10); });
        var timeSplit = dateStringSplit[1].split(':').map(function (e) { return parseInt(e, 10); });
        return new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2], timeSplit[0], timeSplit[1], timeSplit[2]);
    };
    Utils.stringIsInStringEnum = function (value, actionKeys) {
        for (var k in actionKeys) {
            if (actionKeys.hasOwnProperty(k) && actionKeys[k] === value) {
                return true;
            }
        }
        return false;
    };
    Utils.getUrlWithCorrectProtocol = function (url) {
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp;
        var isHttpsNeeded = isMobileApp || window.location.protocol === 'https:';
        var newProtocol = isHttpsNeeded ? 'https' : 'http';
        var urlProtocolRegex = /^(.+):\/\//;
        var regexMatch = urlProtocolRegex.exec(url);
        if (regexMatch === null) {
            return newProtocol + "://" + url;
        }
        return url.replace(regexMatch[1], newProtocol);
    };
    Utils.getUrlSeparator = function (url) {
        return url.includes('?') ? '&' : '?';
    };
    Utils.getUrlWithHttpsProtocol = function (url) {
        return url.replace('http:', 'https:');
    };
    Utils.isSameUrl = function (url1, url2) {
        var getUrlWithEndSlash = function (url) { return (url[url.length - 1] === '/' ? url : url + '/'); };
        return Utils.getUrlWithHttpsProtocol(getUrlWithEndSlash(url1)) === Utils.getUrlWithHttpsProtocol(getUrlWithEndSlash(url2));
    };
    Utils.getUrlForSecuredResource = function (url) {
        var appInfos = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().appInfos;
        if (!Utils.isEmbedMode() && (!Utils.isMultiApp(appInfos) || !__WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].token)) {
            return url;
        }
        var urlWithToken = url + (Utils.getUrlSeparator(url) + "token=" + __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].token);
        return Utils.getUrlWithHttpsProtocol(urlWithToken);
    };
    Utils.getFileExtension = function (fileName) {
        if (fileName) {
            var extensionRegex = /(?:\.([^.]+))?(?:\?.*)?$/;
            var regexMatch = extensionRegex.exec(fileName);
            return !!regexMatch && !!regexMatch[1]
                ? regexMatch[1].split('?')[0] // remove query params
                : '';
        }
        return '';
    };
    Utils.getScreenFormat = function () {
        if (__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isPhone()) {
            return ScreenFormat.Mobile;
        }
        else if (__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isTablet()) {
            return ScreenFormat.Tablet;
        }
        else {
            var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (screenWidth < 768) {
                return ScreenFormat.Mobile;
            }
            else if (screenWidth < 1200) {
                return ScreenFormat.Tablet;
            }
            return ScreenFormat.Desktop;
        }
    };
    Utils.getCookie = function (cookieName) {
        var cookieList = document.cookie.split(';');
        var key = cookieName + "=";
        var selectedCookie = cookieList.find(function (element) { return element.includes(cookieName); });
        return selectedCookie ? selectedCookie.substring(key.length) : '';
    };
    Utils.setCookie = function (cookieName, value, expireDays) {
        var expireDate = new Date();
        expireDate.setTime(expireDate.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        document.cookie = cookieName + "=" + value + ";expires=" + expireDate.toUTCString();
    };
    Utils.cancelRequest = function (requestId) {
        var request = Utils.cancelableRequests[requestId];
        if (request) {
            request.abort();
        }
    };
    Utils.getCssClasses = function (classes, conditionalClasses) {
        return Object.keys(conditionalClasses).reduce(function (acc, current) {
            acc += conditionalClasses[current] ? " " + current : '';
            return acc;
        }, classes);
    };
    Utils.isEmptyObject = function (obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    };
    // for use gallApp in iframe in external projects (e.g., backoffice)
    Utils.isEmbedMode = function () {
        return location.href.includes('?embed=true');
    };
    Utils.isEmptyPlaylistMode = function () {
        return location.href.includes('isEmptyPlaylist=true');
    };
    Utils.isPlaylistMode = function () {
        return location.href.includes('isPlaylist=true');
    };
    Utils.isAccessibleVersionMode = function () {
        return location.href.includes('isAccessibleVersion=true');
    };
    Utils.isFreeUrlApp = function () {
        return location.href.includes('wpAccessToken');
    };
    Utils.isOpenedFromAdmin = function () {
        return location.href.includes('token') && !Utils.isFreeUrlApp();
    };
    Utils.getQueryParamFromUrl = function (param) {
        var search = location.search;
        var paramsStringStart = search.indexOf('?') + 1;
        var paramsStringEnd = search.includes('/') ? search.indexOf('/') : undefined;
        var paramsString = search.substring(paramsStringStart, paramsStringEnd);
        var params = paramsString
            .split('&')
            .reduce(function (acc, current) {
            var _a = __read(current.split('='), 2), name = _a[0], value = _a[1];
            acc[name] = value;
            return acc;
        }, {});
        return params[param];
    };
    Utils.isSharedNote = function (id) {
        return id > 0;
    };
    Utils.isDriveItemFetched = function (id) {
        var _a = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState(), config = _a.galleryInfos.config, driveList = _a.driveList, driveItemsFetchStatus = _a.driveList.driveItemsFetchStatus;
        var archiveDirId = Utils.getArchiveDirId(driveList, config);
        var isArchiveDir = id === archiveDirId;
        if ((__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp || Utils.isMaster(config)) && !isArchiveDir) {
            return true;
        }
        return driveItemsFetchStatus[id] && driveItemsFetchStatus[id].metaFetchStatus === __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemList_reducer__["a" /* FetchStatus */].FETCHED;
    };
    Utils.isGalleryMetaFetched = function () {
        var applicationGallery = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().galleryInfos.config.applicationGallery;
        return Utils.isDriveItemFetched(applicationGallery);
    };
    Utils.getGalleryPrefix = function (int, login) {
        return login ? int + "-" + login : int.toString();
    };
    Utils.shouldGetProfileData = function () {
        var _a = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState(), appInfos = _a.appInfos, clientId = _a.profile.clientId;
        var isProfileLoaded = !!clientId;
        return (Utils.isMultiApp(appInfos) || Utils.isEmbedMode()) && !isProfileLoaded;
    };
    Utils.isShareOnlyViaUprezEnabled = function (sharedNetworks) {
        return !sharedNetworks ||
            (sharedNetworks.length === 1 && sharedNetworks[0] === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].ShareNetwork.Uprez);
    };
    Utils.isShareOnlyViaCopyEnabled = function (sharedNetworks) {
        return !!sharedNetworks &&
            sharedNetworks.length === 1 && sharedNetworks[0] === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].ShareNetwork.Copy;
    };
    Utils.isMultipleShareEnabled = function (sharedNetworks) {
        return !!sharedNetworks && sharedNetworks.length > 1;
    };
    Utils.isNumber = function (value) {
        return Number(value) >= 0;
    };
    Utils.handleNativeApiBug = function (xhr, resolve, reject, protocol, url, headers, isAsync, dataInUrl, dataInBody, attempt, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId) {
        if (attempt < MAX_RETRIES) {
            Utils.promiseXHR(protocol, url, headers, isAsync, dataInUrl, dataInBody, attempt + 1, ignoreConnectionStatus, withCredentials, preventRedirect, onProgress, requestId)
                .then(function (res) { return resolve(res); })
                .catch(function (res) { return reject(res); });
        }
        else {
            reject(xhr);
        }
    };
    Utils.UPLOAD_PROGRESS_DELAY = 1000;
    Utils.deviceRootPath = window.location.origin + window.location.pathname.replace('indexConteneur.html', '') + '../..';
    Utils.cancelableRequests = {};
    Utils.isGalleryReady = function (galleryInfos, offlineManager, appInfos) {
        var isConfigAndTemplateReady = galleryInfos.isConfigLoaded && Utils.isTemplateLoaded(appInfos, galleryInfos);
        // In mobile app mode when online, allow content to display before full initialization completes
        // This allows the app to start faster while content structure is prepared in the background
        // However, we still need the root gallery item to be loaded to avoid errors
        if (__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isOnline()) {
            var driveList = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().driveList;
            var rootGalleryId = galleryInfos.config && galleryInfos.config.applicationGallery;
            var isRootGalleryLoaded = rootGalleryId != null && !!driveList.driveItems[rootGalleryId];
            return isConfigAndTemplateReady && isRootGalleryLoaded;
        }
        // In browser mode or offline mode, require full initialization
        return isConfigAndTemplateReady && offlineManager.status === __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["d" /* OfflineManagerStatus */].INITIALIZED;
    };
    Utils.getGalleryName = function (config, driveList, dispatch) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!driveList.driveItems[config.applicationGallery]) return [3 /*break*/, 3];
                    if (!Utils.shouldGetProfileData()) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__containers_ProfilePage_actions__["e" /* getProfileData */])(config.clientId))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(config.applicationGallery));
                    return [2 /*return*/, ''];
                case 3: return [2 /*return*/, I18n.t('page_title.gallery_name', { galleryName: __WEBPACK_IMPORTED_MODULE_12__driveItem__["d" /* default */].getDisplayName(driveList.driveItems[config.applicationGallery]) })];
            }
        });
    }); };
    Utils.isTemplateLoaded = function (appInfos, galleryInfos) {
        var isLocalTemplateLoaded = galleryInfos.isLocalTemplateLoaded, isRemoteTemplateLoaded = galleryInfos.isRemoteTemplateLoaded;
        var isMobileMultiApp = Utils.isMobileMultiApp(appInfos);
        return isMobileMultiApp ? isRemoteTemplateLoaded : isLocalTemplateLoaded;
    };
    Utils.getItemName = function (driveList, id, dispatch) {
        if (!driveList.driveItems[id]) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id));
            return '';
        }
        return __WEBPACK_IMPORTED_MODULE_12__driveItem__["d" /* default */].getDisplayName(driveList.driveItems[id]);
    };
    Utils.getPageTitle = function (route, params, config, driveList, dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var galleryName, castedParams, itemName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Utils.getGalleryName(config, driveList, dispatch)];
                case 1:
                    galleryName = _a.sent();
                    if (!galleryName) {
                        return [2 /*return*/, ''];
                    }
                    // All RoutePath must be in the switch, do not add a default case
                    switch (route) {
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].Default:
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].Home:
                            return [2 /*return*/, galleryName];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].ViewDriveItem:
                            return [2 /*return*/, I18n.t('page_title.view')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].Authentication:
                            return [2 /*return*/, I18n.t('page_title.authentication')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].ParametersPage:
                            return [2 /*return*/, I18n.t('page_title.parameters', { galleryName: galleryName })];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].ProfilePage:
                            return [2 /*return*/, I18n.t('page_title.profile')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].ProposalStatsPage:
                            return [2 /*return*/, I18n.t('page_title.my_sent')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].DriveItemListPage:
                            castedParams = params;
                            return [2 /*return*/, Utils.getDriveItemListPageTitle(castedParams, galleryName, driveList, dispatch)];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].Theater:
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].TheaterList:
                            castedParams = params;
                            itemName = driveList && castedParams.driveItemId ? Utils.getItemName(driveList, castedParams.driveItemId, dispatch) : '';
                            return [2 /*return*/, itemName ? I18n.t('page_title.theater', { galleryName: galleryName, itemName: itemName }) : ''];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].DriveItemDetailPage:
                            castedParams = params;
                            itemName = driveList && castedParams.driveItemId ? Utils.getItemName(driveList, castedParams.driveItemId, dispatch) : '';
                            return [2 /*return*/, itemName ? I18n.t('page_title.details', { galleryName: galleryName, itemName: itemName }) : ''];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].NotFound:
                            return [2 /*return*/, I18n.t('messages.page_not_found')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].StaticPage:
                            castedParams = params;
                            itemName = driveList && castedParams.component ? Utils.getItemName(driveList, parseInt(castedParams.component, 10), dispatch) : '';
                            return [2 /*return*/, itemName + " - " + galleryName];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].Editor:
                            return [2 /*return*/, I18n.t('page_title.editor')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].NotesPage:
                            return [2 /*return*/, I18n.t('page_title.my_notes')];
                        case __WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].SharePage:
                            return [2 /*return*/, I18n.t('page_title.share')];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    Utils.getDriveItemListPageTitle = function (params, galleryName, driveList, dispatch) {
        var origin = params.origin;
        switch (origin) {
            case __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads:
                return I18n.t('page_title.downloads', { galleryName: galleryName });
            case __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Selection:
                return I18n.t('page_title.selection', { galleryName: galleryName });
            case __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder: {
                if (!params.originParam) {
                    return I18n.t('page_title.drive', { galleryName: galleryName });
                }
                var itemName = driveList && params.originParam ? Utils.getItemName(driveList, parseInt(params.originParam, 10), dispatch) : '';
                return itemName ? I18n.t('page_title.folder', { galleryName: galleryName, itemName: itemName }) : '';
            }
            case __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].New:
                return I18n.t('page_title.new', { galleryName: galleryName });
            case __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search:
                return I18n.t('page_title.search', { galleryName: galleryName });
            case __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Assortment:
                return I18n.t('page_title.assortment', { galleryName: galleryName });
        }
    };
    Utils.getBrandLogoName = function (template, logoType) {
        return template.brand && template.brand[logoType] ? template.brand[logoType] : '';
    };
    Utils.getDefaultLogo = function (isHome, isMultiApp) {
        if (isMultiApp) {
            return isHome ? defaultMultiAppIcon : defaultMultiAppBarIcon;
        }
        return defaultBrandIcon;
    };
    Utils.getOriginBrandLogoUrl = function (galleryInfos, isHome, isMultiApp, template) {
        var resolvedTemplate = template || galleryInfos.template;
        var logoType = isHome ? __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["c" /* LogoType */].HOME_LOGO : __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["c" /* LogoType */].BRAND_LOGO;
        if (resolvedTemplate) {
            if (resolvedTemplate.brand && resolvedTemplate.brand[logoType]) {
                var brandLogo = resolvedTemplate.brand[logoType];
                var brandLogoFilename = Utils.getFilenameFromMediaId(brandLogo);
                return __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getItemOriginalFileUrl(galleryInfos.config, brandLogoFilename);
            }
            return Utils.getDefaultLogo(isHome, isMultiApp);
        }
        return '';
    };
    Utils.isMaster = function (galleryConfig) {
        return galleryConfig.mediaPath !== undefined;
    };
    Utils.getComponentUrl = function (galleryInfos, componentId, isAvailableOffline, locale) {
        var componentURL = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getComponentUrl(galleryInfos, componentId);
        if (__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp && isAvailableOffline) {
            componentURL = Utils.getPersistentDownloadsFolder() + "/" + componentId + "/index.html";
        }
        var separator = Utils.getUrlSeparator(componentURL);
        return "" + componentURL + separator + "locale=" + locale;
    };
    Utils.getGalleryCredentials = function (userInfos) {
        if (userInfos === undefined) {
            var storeState = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState();
            userInfos = storeState.authentication.userInfos;
        }
        var mode = userInfos.mode;
        var isConnectedExcel = __WEBPACK_IMPORTED_MODULE_14__authentication__["a" /* default */].isConnected(mode) && __WEBPACK_IMPORTED_MODULE_14__authentication__["a" /* default */].isExcel(mode);
        if (userInfos.needCredentials && isConnectedExcel) {
            return {
                login: userInfos.login,
                password: userInfos.password,
            };
        }
        else {
            return null;
        }
    };
    Utils.getMultiAppCredentials = function () {
        var storeState = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState();
        return storeState.multiAppAuthenticationInfos.credentials;
    };
    Utils.getWelcomePageDownloadUrl = function (galleryInfos, template) {
        var resolvedTemplate = template || galleryInfos.template;
        if (resolvedTemplate && resolvedTemplate.welcomepage) {
            var welcomePageUrl = resolvedTemplate.welcomepage.url;
            var welcomePageId = Utils.getMediaId(welcomePageUrl);
            return Utils.getComponentDownloadUrlById(galleryInfos, welcomePageId);
        }
        return '';
    };
    Utils.getComponentDownloadUrl = function (galleryInfos, component) {
        var componentId = component.id;
        return "" + Utils.getComponentDownloadUrlById(galleryInfos, componentId);
    };
    Utils.getComponentDownloadUrlById = function (galleryInfos, componentId) {
        return "" + __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getResourceZipUrl(galleryInfos.config, componentId);
    };
    Utils.getBrandLogoUrl = function (galleryInfos, offlineManager, isHome, isMultiApp) {
        if (__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp) {
            var thumbType = isHome ? __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["e" /* ThumbType */].HOME_THUMB : __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["e" /* ThumbType */].BRAND_THUMB;
            var logoType = isHome ? __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["c" /* LogoType */].HOME_LOGO : __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["c" /* LogoType */].BRAND_LOGO;
            var _a = offlineManager[thumbType], remoteConfig = _a.remoteConfig, localConfig = _a.localConfig;
            if (galleryInfos.isRemoteTemplateLoaded && remoteConfig.filename && remoteConfig.status === __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                return Utils.getThumbnailsFolder() + "/brand/" + Utils.getFilenameFromMediaId(remoteConfig.filename);
            }
            else if (!remoteConfig.filename && localConfig.filename && localConfig.status === __WEBPACK_IMPORTED_MODULE_8__containers_OfflineManager_reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                return Utils.getThumbnailsFolder() + "/brand/" + Utils.getFilenameFromMediaId(localConfig.filename);
            }
            if (galleryInfos.isRemoteTemplateLoaded && !Utils.getBrandLogoName(galleryInfos.template, logoType)) {
                return Utils.getDefaultLogo(isHome, isMultiApp); // if no logo has been set, we use the webpublication one
            }
            return ''; // if logo is downloading, nothing is rendered to avoid having several logos shown
        }
        return Utils.getOriginBrandLogoUrl(galleryInfos, isHome, isMultiApp);
    };
    Utils.getDeviceThumbnailPath = function (galleryConfig, thumbMap, driveItem, resolutions, isIcon) {
        var thumbPath = isIcon ? __WEBPACK_IMPORTED_MODULE_12__driveItem__["d" /* default */].getIconOriginalPath(driveItem, galleryConfig) : __WEBPACK_IMPORTED_MODULE_12__driveItem__["d" /* default */].getThumbnail(driveItem, galleryConfig, resolutions, true);
        var extension = Utils.getFileExtension(thumbPath);
        if (isIcon) {
            return Utils.getIconsFolder() + "/" + driveItem.id + "." + extension;
        }
        var thumbData = thumbMap[driveItem.id];
        var hasFileName = thumbData && thumbData.fileName;
        if (hasFileName) {
            // Validate that the stored filename has the correct extension
            // This handles cases where thumbnails were downloaded with wrong extensions (e.g., .mp4 instead of .webp for videos)
            var storedExtension = Utils.getFileExtension(thumbData.fileName);
            if (storedExtension !== extension && extension) {
                console.warn("[getDeviceThumbnailPath] Stored thumbnail filename has wrong extension for item " + driveItem.id + ".\n\t\t\t\t\tExpected: " + extension + ", Found: " + storedExtension + ". File: " + thumbData.fileName);
                // Use the correct extension from the thumbnail path instead of the stored filename
                return Utils.getThumbnailsFolder() + "/" + driveItem.id + "/card_thumbnail." + extension + "?version=" + thumbData.version;
            }
            return Utils.getThumbnailsFolder() + "/" + driveItem.id + "/" + thumbData.fileName + "?version=" + thumbData.version;
        }
        // This fallback is for the thumbnails downloaded with Uprez version 3.56 or less. Because filename was not stored at the time.
        return Utils.getThumbnailsFolder() + "/" + driveItem.id + "/card_thumbnail." + (extension || 'jpg') + "?version=" + thumbData.version;
    };
    Utils.getCustomIconUrl = function (galleryConfig, thumbMap, driveItem, resolutions) {
        if (__WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp) {
            return "" + Utils.getDeviceThumbnailPath(galleryConfig, thumbMap, driveItem, resolutions, true);
        }
        return __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getItemOriginalFileUrl(galleryConfig, driveItem.originalFile);
    };
    Utils.getPersistentDownloadsFolder = function () {
        return Utils.deviceRootPath + "/" + downloadsFolder;
    };
    Utils.getRelativeDownloadsFolder = function () {
        return downloadsFolder;
    };
    Utils.getTemporaryDownloadsFolder = function () {
        return Utils.deviceRootPath + "/" + tempFolder;
    };
    Utils.getThumbnailsFolder = function () {
        return Utils.deviceRootPath + "/" + thumbnailsFolder;
    };
    Utils.getIconsFolder = function () {
        return Utils.deviceRootPath + "/" + iconsFolder;
    };
    Utils.getBgMediaFolder = function () {
        return Utils.deviceRootPath + "/" + bgMediaFolder;
    };
    Utils.getPersistentOpenedFilesFolder = function () {
        return Utils.deviceRootPath + "/" + openedFilesFolder;
    };
    Utils.getRelativeOpenedFilesFolder = function () {
        return openedFilesFolder;
    };
    // Only works for pure Json object (functions & dates do not get copied properly)
    Utils.deepCopy = function (source) {
        return JSON.parse(JSON.stringify(source));
    };
    Utils.generateId = function (length) {
        if (length === void 0) { length = 15; }
        var text = '';
        var possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < length; i++) {
            text += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
        }
        return text;
    };
    Utils.isSecure = function (appType, needCredentials) {
        return appType === __WEBPACK_IMPORTED_MODULE_6__containers_App_reducer__["a" /* AppType */].Multiple || needCredentials;
    };
    Utils.isMultiApp = function (appInfos) {
        return appInfos.type === __WEBPACK_IMPORTED_MODULE_6__containers_App_reducer__["a" /* AppType */].Multiple;
    };
    Utils.isMobileMultiApp = function (appInfos) {
        return __WEBPACK_IMPORTED_MODULE_5__userAgent__["a" /* default */].isMobileApp && Utils.isMultiApp(appInfos);
    };
    Utils.isReadOnlyApp = function (userRole) {
        return [
            __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_APPLICATION_VIEWER,
            __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_LIBRARY_ACCOUNT_MANAGER,
        ].includes(userRole);
    };
    Utils.isMenuItemTypeRoute = function (itemType) {
        var nonRouteTypes = [__WEBPACK_IMPORTED_MODULE_17__typings_menu__["b" /* MenuItemType */].Asset, __WEBPACK_IMPORTED_MODULE_17__typings_menu__["b" /* MenuItemType */].Link, __WEBPACK_IMPORTED_MODULE_17__typings_menu__["b" /* MenuItemType */].Folder, __WEBPACK_IMPORTED_MODULE_17__typings_menu__["b" /* MenuItemType */].Page, __WEBPACK_IMPORTED_MODULE_17__typings_menu__["b" /* MenuItemType */].SearchButton];
        return !nonRouteTypes.includes(itemType);
    };
    Utils.uncapitalize = function (captilizedString) {
        return "" + captilizedString.charAt(0).toLowerCase() + captilizedString.substring(1);
    };
    Utils.getCurrentFolderId = function (galleryId, routerParamsHistory) {
        var currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
        var params = currentRoute.params;
        var origin = params.origin, originParam = params.originParam;
        if (origin === __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder) {
            return originParam ? parseInt(originParam, 10) : galleryId;
        }
        return;
    };
    Utils.getGalleryMeta = function (driveList, galleryConfig) {
        var driveItems = driveList.driveItems;
        var galleryId = galleryConfig.applicationGallery;
        return driveItems[galleryId];
    };
    Utils.getPrivateDirId = function (driveList, galleryConfig) {
        var galleryMeta = Utils.getGalleryMeta(driveList, galleryConfig);
        return galleryMeta ? galleryMeta.privateDirId : undefined;
    };
    Utils.getSharedDirId = function (driveList, galleryConfig) {
        var galleryMeta = Utils.getGalleryMeta(driveList, galleryConfig);
        return galleryMeta ? galleryMeta.sharedDirId : undefined;
    };
    Utils.getArchiveDirId = function (driveList, galleryConfig) {
        var galleryMeta = Utils.getGalleryMeta(driveList, galleryConfig);
        return galleryMeta ? galleryMeta.archiveDirId : undefined;
    };
    Utils.getSourcesDirId = function (driveList, galleryConfig) {
        var galleryMeta = Utils.getGalleryMeta(driveList, galleryConfig);
        return galleryMeta ? galleryMeta.sourcesDirId : undefined;
    };
    Utils.getFolderIdForNewResource = function () {
        var _a = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState(), config = _a.galleryInfos.config, routerParamsHistory = _a.routerParamsHistory, driveList = _a.driveList;
        var isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_19__containers_ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState());
        if (!isAccountManagerOrAdmin) {
            return Utils.getFolderIdForNewPrivateResource();
        }
        var currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
        var sharedDirId = Utils.getSharedDirId(driveList, config);
        var archiveDirId = Utils.getArchiveDirId(driveList, config);
        var forbiddenFolderIds = [sharedDirId, archiveDirId];
        if (!currentFolderId || forbiddenFolderIds.includes(currentFolderId)) {
            return Utils.getPrivateDirId(driveList, config);
        }
        return currentFolderId;
    };
    Utils.getFolderIdForNewPrivateResource = function () {
        var _a = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState(), config = _a.galleryInfos.config, routerParamsHistory = _a.routerParamsHistory, driveList = _a.driveList;
        var currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
        var privateDirId = Utils.getPrivateDirId(driveList, config);
        var isPrivateDirDescendant = __WEBPACK_IMPORTED_MODULE_12__driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, privateDirId, driveList.driveItems);
        return currentFolderId && isPrivateDirDescendant
            ? currentFolderId
            : privateDirId;
    };
    Utils.getViewportHeight = function () { return Math.max(document.documentElement.clientHeight, window.innerHeight || 0); };
    // This static property uses getViewportHeight to get its value and must be declared after
    // tslint:disable-next-line
    Utils.initialViewportHeight = Utils.getViewportHeight();
    Utils.getKeyboardHeight = function () { return Utils.getViewportHeight() - Utils.initialViewportHeight; };
    Utils.itemsToById = function (items, idKey) {
        if (idKey === void 0) { idKey = 'id'; }
        return (items.reduce(function (byId, item) {
            byId[item[idKey]] = item;
            return byId;
        }, {}));
    };
    return Utils;
}());
/* harmony default export */ __webpack_exports__["d"] = (Utils);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createGlobalStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return css; });
/* unused harmony export isStyledComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keyframes; });
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetConsumer */
/* unused harmony export StyleSheetContext */
/* unused harmony export StyleSheetManager */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeProvider; });
/* unused harmony export withTheme */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_merge_anything__ = __webpack_require__(822);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).REACT_APP_SC_ATTR || Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).REACT_APP_SC_DISABLE_SPEEDY || Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper (see https://www.styled-components.com/docs/api#css), which ensures the styles are injected correctly.\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.3.2");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.3.2" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.3.2", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.3.2" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" /* default */])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {
        // eslint-disable-next-line no-console
        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
      }

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

var isHMREnabled = "production" !== 'production' && typeof module !== 'undefined' && module.hot;

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_4_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children)
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.attrs, this.props);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, this.props.className, styledComponentId, this.attrs.className, generatedClassName).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? Object(__WEBPACK_IMPORTED_MODULE_8_merge_anything__["a" /* default */])(target.defaultProps, obj) : obj;
    }
  });

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["d"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(66), __webpack_require__(421)(module)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyleColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NewStyleColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return macTopBarHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return notchHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return navBarHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return navBarButtonWrapperStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return navBarIconStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return blurredBackgroundColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(7);

var Format;
(function (Format) {
    Format["SmallSmartphonePortrait"] = "only screen and (max-width : 374px)";
    Format["SmartphonePortrait"] = "only screen and (max-width : 480px) and (orientation : portrait)";
    Format["SmartphonePortraitNotch"] = "only screen and (max-width : 480px) and (orientation : portrait) and (max-aspect-ratio: 1/2)";
    Format["SmartphoneLandscape"] = "only screen and (min-width : 481px) and (max-width : 896px) and (orientation : landscape)";
    Format["Smartphone"] = "only screen and (max-width : 767px)";
    Format["TabletPortrait"] = "only screen and (min-width : 768px) and (max-width : 991px) and (orientation : portrait)";
    Format["TabletLandscape"] = "only screen and (min-width : 768px) and (max-width : 991px) and (orientation : landscape)";
    Format["Tablet"] = "only screen and (min-width : 768px) and (max-width : 991px)";
    Format["SmallDesktop"] = "only screen and (min-width : 992px) and (max-width : 1399px)";
    Format["MediumDesktop"] = "only screen and (min-width : 1400px)";
    Format["LargeDesktop"] = "only screen and (min-width : 1800px)";
})(Format || (Format = {}));
var macTopBarHeight = '34px';
var notchHeight = '36px';
var navBarHeight = '50px';
var navBarButtonWrapperStyle = "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\theight: 30px;\n\tmargin: 1px 12px 0 6px;\n\tpadding: 4px 1px;\n\tbox-sizing: border-box;\n";
var navBarIconStyle = "\n\theight: 100%;\n\twidth: 30px;\n\ttransition: all 0.2s;\n";
var StyleColor = {
    Blue100: '#f5faff',
    Blue300: '#2c75ff',
    Blue500: '#0000ff',
    Blue600: '#087dff',
    Blue800: '#001152',
    Red: '#f14d4d',
    LightRed: '#f47171',
    Green: '#40d775',
    White: '#ffffff',
    Black: '#000000',
    Grey50: '#f3f3f3',
    Grey100: '#e8e8e8',
    Grey200: '#d9d9d9',
    Grey300: '#cecece',
    Grey400: '#c3c3c3',
    Grey450: '#999999',
    Grey500: '#8c8c8c',
    Grey600: '#666666',
    Grey650: '#555555',
    Grey700: '#404040',
    Grey800: '#292929',
    Grey900: '#1e1e1e'
};
var NewStyleColor = {
    White: '#ffffff',
    Grey100: '#f6f6f6',
    Grey200: '#efefef',
    Grey250: '#e0e0e0',
    Grey300: '#eaeaea',
    Grey400: '#a4a4a4',
    Grey500: '#7c7c7c',
    Grey600: '#5f5e5f',
    Grey800: '#4a4a4a',
    Grey900: '#232425',
    Grey1000: '#0e0e0e',
    Black: '#000000',
    Yellow: '#ffda00',
    Red50: '#ffb3b3',
    Red100: '#ff001f',
    Red200: '#f5515f',
    Red300: '#d0021b',
    Red400: '#9f041b',
    Orange: '#f7941e',
    IrishGreen: '#009b23',
    VibrantGreen: '#56A100',
    Green: '#81a536',
    Blue50: '#cde5ff',
    Blue100: '#1e69f2',
    Blue200: '#217cf3',
    Blue300: '#00baff',
    Blue350: '#005a9d',
    Blue400: '#0079ff',
    Blue450: '#0091ff',
    Pink: '#ff7bac',
};
var defaultTemplate = {
    locale: 'en_US',
    commonStyles: {
        primary: {
            actionColor: StyleColor.Blue600,
            backgroundColor: StyleColor.Grey50,
            cardColor: StyleColor.White,
            contentColor: StyleColor.Grey500,
            spacerColor: StyleColor.Grey300,
            strongColor: StyleColor.Grey800,
            topnavColor: StyleColor.White,
            iconsColor: StyleColor.Black,
            thumbBorderColor: StyleColor.Grey300,
            topnavOpacity: 100
        }
    }
};
var blurredBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["b" /* isSupportingBackdropBlur */])() ? Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* hexToRgba */])(StyleColor.White, 50) : StyleColor.Grey50;



/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nReducer = exports.loadTranslations = exports.setLocale = exports.LOAD_TRANSLATIONS = exports.SET_LOCALE = exports.Localize = exports.Translate = exports.I18n = undefined;

var _actions = __webpack_require__(429);

Object.defineProperty(exports, 'SET_LOCALE', {
  enumerable: true,
  get: function get() {
    return _actions.SET_LOCALE;
  }
});
Object.defineProperty(exports, 'LOAD_TRANSLATIONS', {
  enumerable: true,
  get: function get() {
    return _actions.LOAD_TRANSLATIONS;
  }
});
Object.defineProperty(exports, 'setLocale', {
  enumerable: true,
  get: function get() {
    return _actions.setLocale;
  }
});
Object.defineProperty(exports, 'loadTranslations', {
  enumerable: true,
  get: function get() {
    return _actions.loadTranslations;
  }
});

var _reducer = __webpack_require__(767);

Object.defineProperty(exports, 'i18nReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer).default;
  }
});
exports.syncTranslationWithStore = syncTranslationWithStore;

var _reactI18nify = __webpack_require__(768);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.I18n = _reactI18nify.I18n;
exports.Translate = _reactI18nify.Translate;
exports.Localize = _reactI18nify.Localize;
function syncTranslationWithStore(store) {
  _reactI18nify.I18n.setTranslationsGetter(function () {
    return store.getState().i18n.translations || {};
  });
  _reactI18nify.I18n.setLocaleGetter(function () {
    return store.getState().i18n.locale || '';
  });
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Os */
/* unused harmony export Browser */
/* unused harmony export Format */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appType__ = __webpack_require__(287);


var Os;
(function (Os) {
    Os["IOs"] = "iOs";
    Os["Android"] = "android";
    Os["Blackberry"] = "blackberry";
    Os["Firefox"] = "firefox";
    Os["Tizen"] = "tizen";
    Os["Windows"] = "windows";
    Os["Mac"] = "mac";
    Os["Linux"] = "linux";
})(Os || (Os = {}));
var Browser;
(function (Browser) {
    Browser["Safari"] = "safari";
    Browser["Chrome"] = "chrome";
    Browser["Firefox"] = "firefox";
    Browser["Android"] = "android";
    Browser["Tizen"] = "tizen";
    Browser["Blackberry"] = "blackberry";
    Browser["IE"] = "ie";
    Browser["Edge"] = "edge";
})(Browser || (Browser = {}));
var Format;
(function (Format) {
    Format["Phablet"] = "phablet";
    Format["Tablet"] = "tab";
    Format["Phone"] = "phone";
    Format["Desktop"] = "desktop";
})(Format || (Format = {}));
var Unknown = 'unknown';
var toFindArray = [
    'android',
    'blackberry',
    'chrome',
    'edge',
    'firefox',
    'ipad',
    'iphone',
    'linux',
    'mac os',
    'mobile',
    'phone',
    'safari',
    'tablet',
    'tizen',
    'touch',
    'trident',
    'windows'
];
var UserAgentUtils = /** @class */ (function () {
    function UserAgentUtils() {
    }
    UserAgentUtils.initApp = function () {
        UserAgentUtils.isMobileApp = __WEBPACK_IMPORTED_MODULE_1__appType__["a" /* default */].isMobileAppMainView;
        if (UserAgentUtils.isMobileApp) {
            setInterval(function () { UserAgentUtils.updateOnlineStatus(); }, 3000);
        }
    };
    UserAgentUtils.init = function () {
        UserAgentUtils.constructObject();
        UserAgentUtils.os.version = UserAgentUtils.osVersion;
        UserAgentUtils.browser.version = UserAgentUtils.browserVersion;
    };
    Object.defineProperty(UserAgentUtils, "osVersion", {
        get: function () {
            switch (UserAgentUtils.os.name) {
                case Os.IOs:
                    return (/CPU.*Os ([0-9]{1,5})/i.exec(navigator.userAgent) || ['', Unknown])[1];
                case Os.Android:
                    return (/Android ([0-9.]+)/i.exec(navigator.userAgent) || ['', Unknown])[1];
                case Os.Windows:
                    return UserAgentUtils.resolveWindowsVersion();
                case Os.Mac:
                    return UserAgentUtils.resolveMacVersion();
                default:
                    return Unknown;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserAgentUtils, "browserVersion", {
        get: function () {
            switch (UserAgentUtils.browser.name) {
                case Browser.Chrome:
                    return (/Chrome\/([0-9]+)/.exec(navigator.userAgent) || ['', Unknown])[1];
                case Browser.Firefox:
                    return (/Firefox\/([0-9]+)/.exec(navigator.userAgent) || ['', Unknown])[1];
                case Browser.IE:
                    return UserAgentUtils.resolveIeVersion();
                case Browser.Edge:
                    return (/Edge\/([0-9]+)\./.exec(navigator.userAgent) || ['', Unknown])[1];
                case Browser.Safari:
                    return (/Version\/([0-9]+\.[0-9]+)/.exec(navigator.userAgent) || ['', Unknown])[1];
                default:
                    return Unknown;
            }
        },
        enumerable: true,
        configurable: true
    });
    UserAgentUtils.checkOnlineStatusDomain = 'https://app.uprez.fr/online';
    UserAgentUtils.userAgent = navigator.userAgent.toLowerCase();
    UserAgentUtils.os = { name: Unknown, version: Unknown };
    UserAgentUtils.device = { type: Unknown };
    UserAgentUtils.browser = { name: Unknown, version: Unknown };
    UserAgentUtils.connectionIsUpObserver = [];
    UserAgentUtils.connectionIsDownObserver = [];
    UserAgentUtils.isDesktop = function () { return UserAgentUtils.device.type === Format.Desktop; };
    UserAgentUtils.isPhone = function () { return UserAgentUtils.device.type === Format.Phone; };
    UserAgentUtils.isTablet = function () { return UserAgentUtils.device.type === Format.Tablet || UserAgentUtils.device.type === Format.Phablet; };
    UserAgentUtils.isPhablet = function () { return UserAgentUtils.device.type === Format.Phablet; };
    UserAgentUtils.isUnknown = function () { return UserAgentUtils.device.type === Unknown; };
    UserAgentUtils.isIE = function () { return UserAgentUtils.browser.name === Browser.IE; };
    UserAgentUtils.isSafari = function () { return UserAgentUtils.browser.name === Browser.Safari; };
    UserAgentUtils.isChrome = function () { return UserAgentUtils.browser.name === Browser.Chrome; };
    UserAgentUtils.isWindows = function () { return UserAgentUtils.os.name === Os.Windows; };
    UserAgentUtils.isAndroid = function () { return UserAgentUtils.os.name === Os.Android; };
    UserAgentUtils.isIOS = function () { return UserAgentUtils.os.name === Os.IOs; };
    UserAgentUtils.isMac = function () { return UserAgentUtils.os.name === Os.Mac; };
    UserAgentUtils.isWindowsApp = function () { return UserAgentUtils.isWindows() && UserAgentUtils.isMobileApp; };
    UserAgentUtils.isAndroidApp = function () { return UserAgentUtils.isAndroid() && UserAgentUtils.isMobileApp; };
    UserAgentUtils.isIOSApp = function () { return UserAgentUtils.isIOS() && UserAgentUtils.isMobileApp; };
    UserAgentUtils.isMacApp = function () { return UserAgentUtils.isMac() && UserAgentUtils.isMobileApp; };
    UserAgentUtils.isOnline = function () {
        return UserAgentUtils.isMobileApp ? UserAgentUtils.isOnlineValue : true;
    };
    UserAgentUtils.isOnlinePromise = function () {
        return UserAgentUtils.updateOnlineStatus();
    };
    UserAgentUtils.isTouchSupported = function () {
        return 'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0;
    };
    UserAgentUtils.subscribeToConnectionIsUp = function (toCall, isOnce) {
        UserAgentUtils.subscribeConnectionObserver(UserAgentUtils.connectionIsUpObserver, toCall, isOnce);
    };
    UserAgentUtils.subscribeToConnectionIsDown = function (toCall, isOnce) {
        UserAgentUtils.subscribeConnectionObserver(UserAgentUtils.connectionIsDownObserver, toCall, isOnce);
    };
    UserAgentUtils.subscribeConnectionObserver = function (connectionObservers, toCall, isOnce) {
        if (isOnce === void 0) { isOnce = false; }
        connectionObservers.push({
            toCall: toCall,
            isOnce: isOnce,
        });
    };
    UserAgentUtils.getCheckOnlineStatusUrl = function () { return UserAgentUtils.checkOnlineStatusDomain + "/?rand=" + Math.random(); };
    UserAgentUtils.updateOnlineStatus = function () {
        var oldIsOnlineValue;
        var newIsOnlineValue;
        return UserAgentUtils.checkOnlineStatus().then(function (isOnline) {
            oldIsOnlineValue = UserAgentUtils.isOnlineValue;
            newIsOnlineValue = isOnline;
            UserAgentUtils.isOnlineValue = newIsOnlineValue;
            if (oldIsOnlineValue === false && newIsOnlineValue) {
                UserAgentUtils.notifyConnectionIsUpObserver();
            }
            if (oldIsOnlineValue && !newIsOnlineValue) {
                UserAgentUtils.notifyConnectionIsDownObserver();
            }
            return UserAgentUtils.isOnlineValue;
        });
    };
    UserAgentUtils.checkOnlineStatus = function () {
        return new Promise(function (resolve) {
            // Note: withCredentials is explicitly set to false here because this is a public endpoint (app.uprez.fr/online)
            // that doesn't require authentication and may be on a different domain.
            // All other API calls should use the default withCredentials=true (which is the default parameter value).
            // Parameters: url, protocol, isAsync, ignoreConnectionStatus, dataInUrl, dataInBody, contentType, withCredentials, preventRedirect, preventSecurityHeader
            return __WEBPACK_IMPORTED_MODULE_0____["d" /* default */].fetchText(UserAgentUtils.getCheckOnlineStatusUrl(), 'GET', true, true, null, undefined, undefined, false, true, true)
                .then(function (result) {
                resolve(true);
                return true;
            })
                .catch(function (e) {
                resolve(false);
                return false;
            });
        });
    };
    UserAgentUtils.notifyConnectionIsUpObserver = function () {
        UserAgentUtils.notifyObserver(UserAgentUtils.connectionIsUpObserver);
    };
    UserAgentUtils.notifyConnectionIsDownObserver = function () {
        UserAgentUtils.notifyObserver(UserAgentUtils.connectionIsDownObserver);
    };
    UserAgentUtils.notifyObserver = function (connectionObservers) {
        for (var i = connectionObservers.length - 1; i >= 0; i--) {
            var connectionObserver = connectionObservers[i];
            connectionObserver.toCall();
            if (connectionObserver.isOnce) {
                connectionObservers.splice(i, 1);
            }
        }
    };
    UserAgentUtils.resolveWindowsVersion = function () {
        var version = (/Windows Phone ([0-9.]+)/i.exec(navigator.userAgent) || ['', Unknown])[1];
        if (version !== Unknown) {
            return version;
        }
        var nt = (/Windows NT ([0-9.]+)/i.exec(navigator.userAgent) || ['', Unknown])[1];
        switch (nt) {
            case '10.0':
                return '10';
            case '6.3':
                return '8.1';
            case '6.2':
                return '8';
            case '6.1':
                return '7';
            case '6.0':
                return 'Vista';
            case '5.2':
            case '5.1':
                return 'XP';
            case '5.0':
                return '2000';
            default:
                return Unknown;
        }
    };
    UserAgentUtils.resolveMacVersion = function () {
        var version = /Mac Os.* ([0-9_]+)/i.exec(navigator.userAgent);
        if (version && version[1]) {
            return version[1].split('_').slice(0, 2).join('.');
        }
        else {
            return Unknown;
        }
    };
    UserAgentUtils.resolveIeVersion = function () {
        var version = (/rv\:([0-9]+)/.exec(navigator.userAgent) || ['', Unknown])[1];
        if (version === Unknown) {
            version = (/IEMobile\/([0-9]+)/.exec(navigator.userAgent) || ['', Unknown])[1];
        }
        if (version === Unknown) {
            version = (/MSIE\s([0-9]+)/.exec(navigator.userAgent) || ['', Unknown])[1];
        }
        return version;
    };
    UserAgentUtils.constructObject = function () {
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var width = Math.max(screenWidth, screenHeight);
        var toFindPos = {};
        toFindArray.forEach(function (element) {
            toFindPos[element] = UserAgentUtils.userAgent.includes(element);
        });
        // iOs
        // IE cheat and says it's iphone
        if ((toFindPos.iphone || toFindPos.ipad) && !toFindPos.trident) {
            UserAgentUtils.os.name = Os.IOs;
            UserAgentUtils.device.type = Format.Tablet;
            UserAgentUtils.browser.name = Browser.Safari;
            if (toFindPos.iphone) {
                UserAgentUtils.device.type = Format.Phone;
                if (width > 750 && !toFindPos.safari) {
                    UserAgentUtils.device.type = Format.Tablet;
                }
            }
            else if (width < 750) {
                UserAgentUtils.device.type = Format.Phablet;
            }
            return;
        }
        // mac Os
        // IE cheat and says it's mac os
        if (toFindPos['mac os'] && !toFindPos.trident) {
            UserAgentUtils.os.name = Os.Mac;
            UserAgentUtils.device.type = Format.Desktop;
            // Since IOS13, user agent returns Mac OS instead of IOS for IOS devices by default
            // A hack to separate Devices from Desktop is to check if the navigator uses Touch.
            var isNotDesktop = navigator.maxTouchPoints > 0;
            if (isNotDesktop) {
                UserAgentUtils.os.name = Os.IOs;
                UserAgentUtils.device.type = Format.Phone;
                if (width > 750) {
                    UserAgentUtils.device.type = Format.Tablet;
                }
            }
            if (toFindPos.chrome) {
                UserAgentUtils.browser.name = Browser.Chrome;
            }
            else if (toFindPos.firefox) {
                UserAgentUtils.browser.name = Browser.Firefox;
            }
            else {
                UserAgentUtils.browser.name = Browser.Safari;
            }
            return;
        }
        // Windows
        if (toFindPos.windows) {
            UserAgentUtils.os.name = Os.Windows;
            if (toFindPos.chrome) {
                UserAgentUtils.browser.name = Browser.Chrome;
            }
            else if (toFindPos.firefox) {
                UserAgentUtils.browser.name = Browser.Firefox;
            }
            else if (toFindPos.edge) {
                UserAgentUtils.os.name = Os.Windows;
                UserAgentUtils.browser.name = Browser.Edge;
            }
            else {
                UserAgentUtils.browser.name = Browser.IE;
            }
            if (toFindPos.mobile || toFindPos.phone) {
                UserAgentUtils.device.type = Format.Phone;
            }
            else {
                UserAgentUtils.device.type = Format.Desktop;
            }
        }
        // linux
        if (toFindPos.linux) {
            UserAgentUtils.os.name = Os.Linux;
            if (toFindPos.chrome) {
                UserAgentUtils.browser.name = Browser.Chrome;
            }
            else if (toFindPos.firefox) {
                UserAgentUtils.browser.name = Browser.Firefox;
            }
            UserAgentUtils.device.type = Format.Desktop;
        }
        // Tizen
        if (toFindPos.tizen) {
            UserAgentUtils.os.name = Os.Tizen;
            UserAgentUtils.browser.name = Browser.Tizen;
            return;
        }
        // Blackberry
        if (toFindPos.blackberry) {
            UserAgentUtils.os.name = Os.Blackberry;
            UserAgentUtils.browser.name = Browser.Blackberry;
            return;
        }
        // Android
        // IE cheat and says it's android
        if (toFindPos.android && !toFindPos.trident) {
            UserAgentUtils.os.name = Os.Android;
            UserAgentUtils.device.type = Format.Tablet;
            if (toFindPos.chrome) {
                UserAgentUtils.browser.name = Browser.Chrome;
            }
            else if (toFindPos.firefox) {
                UserAgentUtils.browser.name = Browser.Firefox;
            }
            else {
                UserAgentUtils.browser.name = Browser.Android;
            }
        }
        else if (toFindPos.firefox && (toFindPos.mobile || toFindPos.tablet)) {
            // Firefox
            UserAgentUtils.os.name = Os.Firefox;
            UserAgentUtils.browser.name = Browser.Firefox;
        }
        // Check format
        if (toFindPos.mobile) {
            UserAgentUtils.device.type = Format.Phone;
        }
        else if (UserAgentUtils.device.type !== Format.Desktop) {
            if (width / window.devicePixelRatio < 750) {
                UserAgentUtils.device.type = Format.Phablet;
            }
            else if (width / window.devicePixelRatio <= 1280) {
                UserAgentUtils.device.type = Format.Tablet;
            }
            else {
                UserAgentUtils.device.type = Format.Desktop;
            }
        }
    };
    return UserAgentUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (UserAgentUtils);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hexToRgba; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rgbaToHexAndAlpha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return spin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return overlayAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSupportingBackdropBlur; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var hexToRgba = function (color, opacityPercent) {
    if (color === 'transparent') {
        return color;
    }
    var hexToR = parseInt(color.substring(1, 3), 16);
    var hexToG = parseInt(color.substring(3, 5), 16);
    var hexToB = parseInt(color.substring(5, 7), 16);
    var alpha = (opacityPercent / 100).toPrecision(2);
    return "rgba(" + hexToR + ", " + hexToG + ", " + hexToB + ", " + alpha + ")";
};
var rgbaToHexAndAlpha = function (rgba) {
    var parts = rgba.substring(rgba.indexOf('(')).split(',');
    var r = parseInt((parts[0].substring(1)).trim(), 10);
    var g = parseInt((parts[1]).trim(), 10);
    var b = parseInt((parts[2]).trim(), 10);
    var a = parseFloat((parts[3].substring(0, parts[3].length - 1)).trim());
    var red = r.toString(16).padStart(2, '0');
    var green = g.toString(16).padStart(2, '0');
    var blue = b.toString(16).padStart(2, '0');
    return { hexColor: "#" + red + green + blue, alpha: a };
};
var spinKeyFrame = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n"], ["\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n"])));
var spin = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", " ", ""], ["", " ", ""])), spinKeyFrame, '2s linear infinite;');
var overlayAnimation = function (isOpen) {
    return "\n\t\ttransition: opacity .4s cubic-bezier(.25,.8,.25,1);\n\t\topacity: " + (isOpen ? 1 : 0) + ";\n\t\tpointer-events: " + (isOpen ? 'auto' : 'none') + ";\n\t";
};
var isSupportingBackdropBlur = function () {
    if (typeof CSS === 'undefined') {
        // Browsers that don't support this API also don't support backdrop-filter
        return false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isChrome() && __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isDesktop()) {
        // Disabling it for now on chrome desktop
        // Chrome 76 have rendering error when hovering other tabs, https://stackoverflow.com/questions/57736567
        return false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isAndroidApp()) {
        // Disabling it for now on android webview
        // newer version of android's webview says it supports the ruel
        // but the background was fully black instead of transparent and blurry
        return false;
    }
    return CSS.supports('backdrop-filter', 'blur(20px)')
        || CSS.supports('-webkit-backdrop-filter', 'blur(20px)');
};

var templateObject_1, templateObject_2;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getLinkUrlData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getPageSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getSelectedPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getActiveSpreadIndexAfterPagesUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getPageHtmlPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getNumberFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getRoundedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getValueAndUnits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return youtubeUrl; });
/* unused harmony export isYoutubeLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getYoutubeLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getYoutubeVideoCover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getVideoCover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAnimationCover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return mediaParamRegex; });
/* unused harmony export imageParamRegex */
/* unused harmony export hasMediaParam */
/* unused harmony export hasImageParam */
/* unused harmony export getRelUrlFromStringWithMediaParam */
/* unused harmony export getRelUrlFromStringWithImageParam */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getSelectorStylesFromCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getElementSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getElementScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getStylesWithScaledNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getScaleFromStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getTransformStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getTranslateValueFromStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCorrectedLetterSpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getTooltipAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDefaultTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return setElementIsEdited; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return setElementIsHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getUrlWithoutOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getResourceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getMediaUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getBorderWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getLinkTypeFromHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getLinkTypeByValue; });
/* unused harmony export getLinkTypeFromAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return shouldCorrectLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getLinkDataFromAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionEventDynamicProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getLinkAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getButtonLinkParamsFromAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getImageCenteredPositionAndSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getOptimizedImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getStringWithoutSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return isStyleIncludesHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return isEditableButtonLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getStylesArrayWithoutSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getStylesStringWithoutSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getStylesStringWithoutLastSemicolon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return setDataAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getElementId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return hasLockedParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDependencyString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getPublicationPdfImportingId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return isDuplicatedItemInSpread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getClientAndResourceIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return isElementOverlapped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return isElementHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getVerticalAlignClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return setVerticalAlignClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return isTextScriptElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getTextScriptClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getSelectedSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getSliderPreviewUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indesignEditor_constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_selectionManager__ = __webpack_require__(462);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};








var getLinkUrlData = function (url) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].url,
        data: {
            href: url,
        }
    };
};
var defaultLinkData = getLinkUrlData('');
var TooltipAction;
(function (TooltipAction) {
    TooltipAction["SHOW"] = "showTooltip";
    TooltipAction["HIDE"] = "hideTooltip";
})(TooltipAction || (TooltipAction = {}));
var getSpreadPages = function (displayMode, firstFrameMode, possiblePage, totalPages, showAlonePages, pageDimensions) {
    var spreadPossiblePages = [possiblePage, possiblePage + 1];
    var spreadPageNumber = getSpreadPageNumber(displayMode, firstFrameMode, spreadPossiblePages, totalPages, showAlonePages, pageDimensions);
    return spreadPageNumber === 1 ? [possiblePage] : spreadPossiblePages;
};
var getSpreadPageNumber = function (displayMode, firstFrameMode, possiblePages, totalPages, showAlonePages, pageDimensions) {
    var hasOutOfBound = possiblePages[0] < 1 || possiblePages[1] > totalPages;
    var hasCover = firstFrameMode === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].PublicationFirstFrameMode.SINGLE && possiblePages.includes(1);
    var hasShowAlonePages = showAlonePages.some(function (showAlonePage) { return possiblePages.includes(showAlonePage); });
    var isWidePage = pageDimensions && pageDimensions.width > pageDimensions.height;
    if (![__WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].PublicationDisplayMode.AUTO, __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].PublicationDisplayMode.FLIPBOOK].includes(displayMode) ||
        hasOutOfBound ||
        hasCover ||
        hasShowAlonePages ||
        isWidePage) {
        return 1;
    }
    return 2;
};
var getPageSpreads = function (displayMode, firstFrameMode, totalPages, pagesData, pageDimensions) {
    var showAlonePages = pagesData.reduce(function (acc, current, index) {
        if (current.showAlone) {
            acc.push(index + 1);
        }
        return acc;
    }, []);
    var spreads = [];
    var currentPage = 1;
    while (currentPage <= totalPages) {
        var spreadPages = getSpreadPages(displayMode, firstFrameMode, currentPage, totalPages, showAlonePages, pageDimensions);
        spreads.push(spreadPages);
        currentPage += spreadPages.length;
    }
    return spreads;
};
var getSelectedPages = function (selectedSpreadIndices, spreads) { return (selectedSpreadIndices.reduce(function (acc, current) {
    acc = acc.concat(spreads[current]);
    return acc;
}, [])); };
var getActiveSpreadIndexAfterPagesUpdate = function (spreadIndex, spreads, displayMode, pagesData) {
    var isLastSpread = spreadIndex === spreads.length - 1;
    if (!isLastSpread) {
        return spreadIndex + 1;
    }
    var lastSpread = spreads[spreadIndex];
    var isShowAlonePage = lastSpread.some(function (page) { return (pagesData[page - 1] && pagesData[page - 1].showAlone); });
    return (displayMode === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].PublicationDisplayMode.AUTO &&
        lastSpread.length === 1 &&
        !isShowAlonePage)
        ? spreadIndex
        : spreadIndex + 1;
};
var getPageHtmlPath = function (path, page) { return path.replace('%{pageNumber}', page.toString()); };
var getNumberFromString = function (str) {
    var regExp = /[+-]?\d+(\.\d+)?/g;
    var match = str.match(regExp);
    return match ? +match[0] : 0;
};
var getRoundedValue = function (value, decimal) {
    if (decimal === void 0) { decimal = 100; }
    return (Math.round(value * decimal) / decimal);
};
var getValueAndUnits = function (value) {
    var valueWithoutUnits = getNumberFromString(value);
    var units = value.replace(valueWithoutUnits.toString(), '');
    return {
        value: valueWithoutUnits,
        units: units,
    };
};
var youtubeUrl = 'https://www.youtube.com/embed/';
var youtubePreviewUrl = 'https://i.ytimg.com/vi/';
var youtubeUrlRegex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
var getYoutubeVideoId = function (url) {
    var match = url.match(youtubeUrlRegex);
    if (!match) {
        return '';
    }
    return match[2].split('" ')[0];
};
var isYoutubeLink = function (url) { return url.includes(youtubeUrl); };
var getYoutubeLink = function (url) {
    var videoId = getYoutubeVideoId(url);
    return videoId ? "" + youtubeUrl + videoId : '';
};
var getYoutubeVideoCover = function (url) {
    var videoId = getYoutubeVideoId(url);
    return "" + youtubePreviewUrl + videoId + "/0.jpg";
};
var getVideoCover = function (url, isDefaultVideoInHtmlEditor) {
    if (isDefaultVideoInHtmlEditor) {
        return url + "-cover.jpg";
    }
    return url.replace(/\.[^.]+$/, '/cover.jpg');
};
var getAnimationCover = function (url) {
    return url.replace(/\/index\.html+$/, '/cover.jpg');
};
var mediaParamRegex = /\$media\$|\${media}|\$%7Bmedia%7D/;
var imageParamRegex = /\$\{image_quality_folder}/;
var hasMediaParam = function (str) { return !!str.match(mediaParamRegex); };
var hasImageParam = function (str) { return !!str.match(imageParamRegex); };
var getRelUrlFromStringWithParam = function (paramRegex, replacement, str) {
    var match = str.match(paramRegex);
    return match ? str.replace(match[0], replacement) : str;
};
var getRelUrlFromStringWithMediaParam = function (str) {
    return getRelUrlFromStringWithParam(mediaParamRegex, '', str);
};
var getRelUrlFromStringWithImageParam = function (str) {
    return getRelUrlFromStringWithParam(imageParamRegex, 'image', str);
};
var getSelectorStylesFromCss = function (selector, css) {
    // (?=[\s,{:]) — positive lookahead: next char is a space, comma, '{', or ':' (for pseudo-selectors), not consumed
    var regExp = new RegExp(selector + "(?=[\\s,{:]).*?(\\s*\\{[^}]*\\})");
    var extraSymbolsInStylesRegExp = /{|}|\s+(?=(?:[^\'"]*[\'"][^\'"]*[\'"])*[^\'"]*$)/g;
    var match = css.match(regExp);
    return match ? match[1].replace(extraSymbolsInStylesRegExp, '') : '';
};
var getElementSizes = function (id, css) {
    var styles = getSelectorStylesFromCss("#" + id, css);
    return styles
        .split(';')
        .filter(function (style) {
        var styleName = style.split(':')[0];
        return styleName === 'width' || styleName === 'height';
    })
        .reduce(function (acc, current) {
        var _a = __read(current.split(':'), 2), key = _a[0], value = _a[1];
        acc[key] = getNumberFromString(value);
        return acc;
    }, {});
};
var getElementScale = function (element, css) {
    var id = element.id, _a = __WEBPACK_IMPORTED_MODULE_0__indesignEditor_constants__["c" /* default */].animationEndStateDataAttribute, animationClassName = element.dataset[_a];
    var styles = getSelectorStylesFromCss(id, css);
    var regExp = /scale\((.+?)\)/;
    var scale = 1;
    var stylesMatch = styles.match(regExp);
    if (stylesMatch) {
        scale = +stylesMatch[1].split(',')[0];
    }
    if (animationClassName) {
        var animationStyles = getSelectorStylesFromCss(animationClassName, css);
        var animationStylesMatch = animationStyles.match(regExp);
        if (animationStylesMatch) {
            scale = +animationStylesMatch[1].split(',')[0];
        }
    }
    return getRoundedValue(scale);
};
var getStylesWithScaledNumbers = function (stylesString, scale) {
    var styleNames = [
        'font-size',
        'line-height',
        'min-height',
        'padding-top',
        'letter-spacing',
    ];
    var regExp = new RegExp(styleNames
        .map(function (styleName) { return styleName + ":\\s*([+-]?\\d+\\.\\d+|[+-]?\\d+)"; })
        .join('|'), 'g');
    return stylesString.replace(regExp, function (match) {
        var groups = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            groups[_i - 1] = arguments[_i];
        }
        var index = styleNames.findIndex(function (styleName) { return match.includes(styleName); });
        var size = groups[index];
        var scaledNumber = getRoundedValue(getNumberFromString(size) * scale);
        return styleNames[index] + ":" + scaledNumber;
    });
};
var getScaleFromStyle = function (_a) {
    var transform = _a.transform;
    var regExp = /scale\((.+?)\)/;
    var match = transform && transform.match(regExp);
    return match ? +match[1] : 1;
};
var getTransformStyle = function (_a) {
    var transform = _a.transform;
    var regExp = /translate\((.+?)\)/;
    var match = transform && transform.match(regExp);
    return match ? match[0] : '';
};
var getTranslateValueFromStyle = function (_a) {
    var transform = _a.transform;
    var regExp = /translate\((.+?)\)/;
    var match = transform && transform.match(regExp);
    if (!match) {
        return [0, 0];
    }
    var value = match[1];
    return value.split(',').map(function (item) { return getNumberFromString(item); });
};
var getCorrectedLetterSpacing = function (letterSpacing, scale) {
    var letterSpacingValue = getNumberFromString(letterSpacing);
    // We have to ignore small letter-spacing because inDesign sets it almost on each word (span element) and it will cause a huge amount of generated spans in Rich text editors
    // 2px from inDesign === 2px / 20 = 0.1px in backoffice
    var IGNORED_LETTER_SPACING_VALUE = 2;
    var isIgnoredLetterSpacing = Math.abs(letterSpacingValue) < IGNORED_LETTER_SPACING_VALUE;
    return isIgnoredLetterSpacing
        ? 0
        : getRoundedValue(letterSpacingValue * scale, 10);
};
var getTooltipAction = function (action, tooltip) {
    if (tooltip === void 0) { tooltip = ''; }
    return (
    // tslint:disable-next-line: max-line-length
    "javascript:document.dispatchEvent(new CustomEvent(\"WebPublicationAction\", {\"detail\":{\"type\":\"" + action + "\",\"params\":{\"content\": \"" + tooltip + "\"},\"event\":typeof(event) !== \"undefined\" ? event : undefined}})); return false;");
};
// get tooltip in case it was set in inDesign (for video)
var getDefaultTooltip = function (value) {
    if (!value) {
        return '';
    }
    var regExp = /"params":{"content": "(.+?)"}/;
    var match = value.match(regExp);
    return match ? match[1] : '';
};
var setElementIsEdited = function (element) {
    if (!element.classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* editedElementClassName */])) {
        element.classList.add(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* editedElementClassName */]);
    }
};
var setElementIsHidden = function (element) {
    element.setAttribute('hidden', 'true');
    // NB: Do not remove 'src' attribute as it breaks inDesign animations in Reader!
};
var getUrlWithoutOrigin = function (url, isHtmlEditor) {
    var modifiedUrl = url;
    if (isHtmlEditor) {
        if (__WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isMobileApp) {
            var FILES_PATH = 'www/v2/';
            if (url.indexOf(FILES_PATH) !== -1) {
                modifiedUrl = url.substring(url.indexOf(FILES_PATH) + FILES_PATH.length);
            }
        }
        else {
            var href = location.href, search = location.search, hash = location.hash;
            var origin = href.replace("" + search + hash, '');
            modifiedUrl = url.replace(origin, '');
        }
    }
    var regExp = /\$media\$|\${media}|\$%7Bmedia%7D|publication\/contents/;
    var match = modifiedUrl.match(regExp);
    return match && match.index
        // we have to replace some encoded characters to its actual values for proper handling of urls in Reader
        ? modifiedUrl.substring(match.index).replace(/%7B/g, '{').replace(/%7D/g, '}')
        : modifiedUrl;
};
var getResourceUrl = function (url, config, resourceId, isHtmlEditor) {
    var urlWithoutOrigin = getUrlWithoutOrigin(url, isHtmlEditor);
    if (isYoutubeLink(urlWithoutOrigin)) {
        return urlWithoutOrigin;
    }
    else if (hasMediaParam(urlWithoutOrigin) && hasImageParam(urlWithoutOrigin)) {
        var resolvedRelUrlWithMediaParam = getRelUrlFromStringWithMediaParam(urlWithoutOrigin);
        return __WEBPACK_IMPORTED_MODULE_2__utils_url__["b" /* default */].getEditorResourceUrl(config, undefined, getRelUrlFromStringWithImageParam(resolvedRelUrlWithMediaParam));
    }
    else if (hasMediaParam(urlWithoutOrigin)) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_url__["b" /* default */].getEditorResourceUrl(config, undefined, getRelUrlFromStringWithMediaParam(urlWithoutOrigin));
    }
    else if (hasImageParam(urlWithoutOrigin)) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_url__["b" /* default */].getEditorResourceUrl(config, resourceId, getRelUrlFromStringWithImageParam(urlWithoutOrigin));
    }
    return __WEBPACK_IMPORTED_MODULE_2__utils_url__["b" /* default */].getEditorResourceUrl(config, resourceId, urlWithoutOrigin);
};
var getMediaUrl = function (relUrl, iconName) {
    if (iconName) {
        return '${media}' + iconName;
    }
    if (hasMediaParam(relUrl)) {
        return relUrl;
    }
    var endWithSlash = relUrl[relUrl.length - 1] === '/';
    var splitBySlash = relUrl.split('/');
    var idWithExtension = endWithSlash
        ? splitBySlash[splitBySlash.length - 2]
        : splitBySlash[splitBySlash.length - 1];
    return '${media}' + idWithExtension;
};
var getBorderWidth = function (scale, minWidth) {
    if (minWidth === void 0) { minWidth = 2; }
    return (getRoundedValue(minWidth / scale));
};
// used for links inside text fields and images
var getLinkTypeFromHref = function (href, action) {
    var stringToCheck = href === 'javascript:void(0)' ? action : href;
    return getLinkTypeFromAction(stringToCheck);
};
// used for getting link type by its actual value (on page save)
var getLinkTypeByValue = function (value) {
    if (!value || value.startsWith('http')) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].url;
    }
    if (value.includes('@')) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].mailto;
    }
    if (!isNaN(+value)) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage;
    }
    if (value.endsWith('/')) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].popup;
    }
    return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].unsupported;
};
// used for getting link type by its action string (on page load)
var getLinkTypeFromAction = function (action) {
    var regExp = /('|"|\\'|\\")detail('|"|\\'|\\"):{('|"|\\'|\\")type('|"|\\'|\\"):('|"|\\'|\\")(.+?)('|"|\\'|\\")/;
    var match = action.match(regExp);
    if (match) {
        if (Object.values(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */]).includes(match[6])) {
            return match[6];
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].unsupported;
        }
    }
    else {
        if (action.startsWith('http')) {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].url;
        }
        if (action.includes('mailto:') && action.includes('@')) {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].mailto;
        }
        if (isInDesignNativeGoToPageAction(action)) {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage;
        }
        return __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].unsupported;
    }
};
var getActionParamRegExpPattern = function (param) { return ("('|\"|\\\\'|\\\\\")params('|\"|\\\\'|\\\\\"):{('|\"|\\\\'|\\\\\")" + param + "('|\"|\\\\'|\\\\\"):('|\"|\\\\'|\\\\\")?(.+?)('|\"|\\\\'|\\\\\")?}"); };
var shouldCorrectLink = function (linkData) { return (linkData.type === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage && !linkData.data.correctedHref); };
// used for links inside text fields and images
var getLinkDataFromAction = function (action, spreads) {
    if (!action) {
        return null;
    }
    var data = getActionEventData(action);
    if (!data) {
        return null;
    }
    if (data.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].goToPage) {
        return getGotoPageLinkParams(data.params.page, spreads);
    }
    if (data.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].goToChapterId) {
        var chapterData = data;
        var chapterId = chapterData.params.chapterId || '';
        return {
            type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToChapterId,
            data: {
                href: chapterId,
            },
            originalParams: chapterData,
        };
    }
    if (data.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].popup) {
        var popupData = getLinkPopupData(data);
        if (popupData) {
            return popupData;
        }
    }
    return null;
};
var getLinkPopupData = function (popupData) {
    if (!popupData) {
        return null;
    }
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].popup,
        data: {
            item: popupData.params.subAssetDriveItem || popupData.params.assetDriveItem,
            page: popupData.params.pageNumber,
        },
        originalParams: popupData,
    };
};
var actionEventDynamicProperty = ',"event":typeof(event) !== "undefined" ? event : undefined';
var getActionEventData = function (action) {
    var regExp = /.*WebPublicationAction.*({["']detail["']:.*}})\).*/;
    var getDataRegex = new RegExp(regExp);
    var regexMatch = action.match(getDataRegex);
    if (regexMatch) {
        try {
            var dataJsonString = regexMatch[1]
                .replace(actionEventDynamicProperty, '')
                .replace(/'/g, '"')
                .trim();
            var _a = JSON.parse(dataJsonString).detail, type = _a.type, params = _a.params;
            return {
                type: type,
                params: params,
            };
        }
        catch (error) {
            console.error('cannot parse action event data: ', action, error);
        }
    }
    return null;
};
var getActionEventString = function (actionEventData) {
    return "javascript:document.dispatchEvent(new CustomEvent(\"WebPublicationAction\", {\"detail\":" + JSON.stringify(actionEventData) + "}));return false;";
};
var getDefaultPopupActionEventData = function (linkPopupData) {
    if (linkPopupData.originalParams && linkPopupData.originalParams.type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].popup) {
        return __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].deepCopy(linkPopupData.originalParams);
    }
    return {
        type: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].popup,
        params: {
            param: '',
            height: '0',
            width: '0',
            theme: 'THEATER',
            animation: null,
            header: null,
            enable: false,
            assetDriveItem: {},
            subAssetDriveItem: null,
            isTooltipActive: false,
            tooltip: '',
            appearance: {
                customizationEnable: false,
                customizationUrl: null,
                style: 'THEATER',
                width: '0',
                height: '0',
                backgroundColor: '#ffffff',
                backgroundOpacity: '100',
                barBackgroundColor: '#ffffff',
                barBackgroundOpacity: '100%',
                xButtonColor: '#000000',
                xButtonColorOpacity: '100%',
            }
        },
    };
};
// used for getting link action string (on page save)
var getLinkAction = function (linkData) {
    var actionEventData;
    switch (linkData.type) {
        case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].url:
            return linkData.data.href;
        case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage:
            actionEventData = {
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].goToPage,
                params: {
                    page: +linkData.data.correctedHref,
                    spread: +linkData.data.href,
                }
            };
            return getActionEventString(actionEventData);
        case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToChapterId:
            var chapterParams = (linkData.originalParams
                ? __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].deepCopy(linkData.originalParams.params)
                : {});
            actionEventData = {
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].goToChapterId,
                params: __assign({}, chapterParams, { chapterId: linkData.data.href }),
            };
            return getActionEventString(actionEventData);
        case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].mailto:
            actionEventData = {
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ActionEventType */].mailto,
                params: {
                    email: linkData.data.href,
                }
            };
            return getActionEventString(actionEventData);
        case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].popup:
            actionEventData = getDefaultPopupActionEventData(linkData);
            if (actionEventData.params.subAssetDriveItem) {
                actionEventData.params.subAssetDriveItem = linkData.data.item;
                actionEventData.params.pageNumber = linkData.data.page;
            }
            else {
                actionEventData.params.assetDriveItem = linkData.data.item;
                actionEventData.params.pageNumber = linkData.data.page;
            }
            return getActionEventString(actionEventData);
    }
};
// used for links on buttons
var getButtonLinkParamsFromAction = function (action, totalPages, spreads) {
    if (!action) {
        return defaultLinkData;
    }
    var type = getLinkTypeFromAction(action);
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].url) {
        return getLinkUrlData(action);
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage) {
        var data = getActionEventData(action);
        if (data) {
            return getGotoPageLinkParams(data.params.page, spreads);
        }
        if (isInDesignNativeGoToPageAction(action)) {
            var page = +getPageFromInDesignNativeGoToPageAction(action);
            // tslint:disable-next-line: max-line-length
            // when publication is editable a link to last page equals totalPages + 1 (because plugin creates a special service page which is removed after export but gotoPage links on buttons take into account this page)
            if (page === totalPages + 1) {
                page = page - 1;
            }
            return getGotoPageLinkParams(page, spreads);
        }
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToChapterId) {
        var chapterData = getActionEventData(action);
        if (chapterData) {
            var chapterId = chapterData.params.chapterId || '';
            return {
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToChapterId,
                data: {
                    href: chapterId,
                },
                originalParams: chapterData,
            };
        }
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].mailto) {
        var inDesignNativeEmailRegExpPattern = "mailto:(.+?)('|\"|\\\\'|\\\\\")?$";
        var emailRegExp = new RegExp(inDesignNativeEmailRegExpPattern + "|" + getActionParamRegExpPattern(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* LinkParam */].email));
        var match = action.match(emailRegExp);
        if (match) {
            return {
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].mailto,
                data: {
                    href: decodeURIComponent(match[1] || match[8]),
                    correctedHref: '',
                },
            };
        }
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].popup) {
        var actionEventData = getActionEventData(action);
        if (actionEventData) {
            var data = getLinkPopupData(actionEventData);
            if (data) {
                return data;
            }
        }
    }
    return defaultLinkData;
};
var isInDesignNativeGoToPageAction = function (action) {
    var regExp = /.+?-(\d+).xhtml/;
    return !!action.match(regExp);
};
var getPageFromInDesignNativeGoToPageAction = function (action) {
    var inDesignNativeGoToPageRegExp = /.+?-(\d+)$/;
    // format of inDesign native gotoPage action: ${publicationName}-${page}.xhtml
    var splittedAction = action.split('.');
    var actionPartToCheck = splittedAction[splittedAction.length - 2];
    var inDesignNativeGoToPageMatch = actionPartToCheck && actionPartToCheck.match(inDesignNativeGoToPageRegExp);
    return inDesignNativeGoToPageMatch ? inDesignNativeGoToPageMatch[1] : '';
};
var getGotoPageLinkParams = function (page, spreads, spread) {
    if (page) {
        if (spread) {
            return {
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage,
                data: {
                    href: page.toString(),
                    correctedHref: spread.toString(),
                },
            };
        }
        var spreadIndex = spreads.findIndex(function (spread) { return spread.includes(page); });
        return {
            type: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].goToPage,
            data: {
                href: (spreadIndex + 1).toString(),
                correctedHref: page.toString(),
            },
        };
    }
    return null;
};
var getImageCenteredPositionAndSize = function (frameWidth, frameHeight, imageWidth, imageHeight, isPercentageValues) {
    var width = imageWidth;
    var height = imageHeight;
    var scale = 1;
    var isImageWiderThanFrame = imageWidth > frameWidth;
    if (isImageWiderThanFrame) {
        width = frameWidth;
        scale = frameWidth / imageWidth;
        height = imageHeight * scale;
    }
    var isImageHigherThanFrame = height > frameHeight;
    if (isImageHigherThanFrame) {
        height = frameHeight;
        scale = frameHeight / imageHeight;
        width = imageWidth * scale;
    }
    var centeredX = (frameWidth - width) / 2;
    var centeredY = (frameHeight - height) / 2;
    return {
        width: getRoundedValue(isPercentageValues ? (width / frameWidth * 100) : width),
        height: getRoundedValue(isPercentageValues ? (height / frameHeight * 100) : height),
        x: getRoundedValue(isPercentageValues ? (centeredX / frameWidth * 100) : centeredX),
        y: getRoundedValue(isPercentageValues ? (centeredY / frameHeight * 100) : centeredY),
    };
};
var getOptimizedImage = function (driveItem, width, height, maxWidth) {
    var driveList = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getState().driveList;
    var associatedResolutions = driveItem.associatedResolutions, id = driveItem.id, src = driveItem.src, name = driveItem.name;
    var resolutions = driveItem.resolutions || driveList.resolutions;
    var optimizedImage = {
        width: width,
        height: height,
        src: src,
    };
    if (associatedResolutions) {
        var availableResolutionsId = associatedResolutions[id] || 'default';
        if (resolutions[availableResolutionsId]) {
            var optimizedSize = __spread(resolutions[availableResolutionsId].sizes).sort(function (a, b) { return a.width - b.width; })
                .find(function (_a) {
                var width = _a.width;
                return width >= maxWidth;
            });
            if (optimizedSize) {
                var fileExtension = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getFileExtension(name);
                optimizedImage.height = height * (optimizedSize.width / width);
                optimizedImage.width = optimizedSize.width;
                optimizedImage.src = src.replace("." + fileExtension, "_" + (optimizedSize.box ? 'box-' : '') + optimizedSize.width + "x" + optimizedSize.height + "." + fileExtension);
            }
        }
    }
    return optimizedImage;
};
var getStringWithoutSpaces = function (str) { return (str.trim().replace(/>\s+</g, '><')); };
var isStyleIncludesHeight = function (style) {
    var styleWithoutSpaces = style.replace(/\s+/g, '');
    return styleWithoutSpaces.includes('height') && (styleWithoutSpaces.indexOf('height') === 0 ||
        styleWithoutSpaces[styleWithoutSpaces.indexOf('height') - 1] === ';');
};
var isEditableButtonLink = function (linkElement) { return (__spread(linkElement.children).some(function (child) { return (child.className.includes(__WEBPACK_IMPORTED_MODULE_0__indesignEditor_constants__["c" /* default */].editableButtonLinkGraphicsClassName)); })); };
var getStylesArrayWithoutSpaces = function (styles) { return (styles.split(';').reduce(function (acc, current) {
    if (current) {
        var _a = __read(current.split(':'), 2), key = _a[0], value = _a[1];
        acc.push(key.trim() + ":" + value.trim());
    }
    return acc;
}, [])); };
var getStylesStringWithoutSpaces = function (styles) { return (styles.split(';').reduce(function (acc, current) {
    if (current) {
        var _a = __read(current.split(':'), 2), key = _a[0], value = _a[1];
        acc += (key.trim() + ":" + value.trim() + ";");
    }
    return acc;
}, '')); };
var getStylesStringWithoutLastSemicolon = function (styles) { return (styles[styles.length - 1] === ';' ? styles.slice(0, -1) : styles); };
var setDataAttributes = function (element, attributes) {
    Object.entries(attributes).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value) {
            element.setAttribute(key, value.toString());
        }
    });
};
var getElementId = function (element) {
    var parentElement = element.closest("[id*=" + __WEBPACK_IMPORTED_MODULE_0__indesignEditor_constants__["c" /* default */].parentContainerId + "]");
    return parentElement.id;
};
var hasLockedParent = function (element) { return (!!element.closest("[class*=" + __WEBPACK_IMPORTED_MODULE_0__indesignEditor_constants__["c" /* default */].lockedClassName + "]")); };
var getDependencyString = function (globalId) { return "'${media}" + globalId + "'"; };
var getPublicationPdfImportingId = function (globalId, status) { return (globalId + "-pdf-" + status); };
var isDuplicatedItemInSpread = function (className, pageIndexInSpread) {
    var pageIndexInClassNameRegExp = new RegExp(__WEBPACK_IMPORTED_MODULE_0__indesignEditor_constants__["c" /* default */].pageIndexInSpreadClassName + "-(\\d{1})");
    var match = className.match(pageIndexInClassNameRegExp);
    if (!match) {
        // for backward compatibility
        return false;
    }
    return pageIndexInSpread !== +match[1];
};
var getClientAndResourceIds = function () {
    var _a = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getState(), routerParamsHistory = _a.routerParamsHistory, tempGId = _a.editor.preprodPublication.tempGId;
    var _b = routerParamsHistory[routerParamsHistory.length - 1].params, clientId = _b.clientId, resourceId = _b.resourceId;
    return {
        clientId: +clientId,
        originalGId: +resourceId,
        tempGId: tempGId || +resourceId,
    };
};
var isElementOverlapped = function (element) {
    var style = document.createElement('style');
    var styleId = 'editor-temp-styles';
    style.id = styleId;
    // is needed for correct defining of top most element (elementFromPoint doesn't take into account elements with pointer-events: none)
    var tempStyles = __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* PAGE_CONTENT_CLASSNAME */] + " > div * { pointer-events: auto !important; }";
    style.innerHTML = tempStyles;
    document.head.appendChild(style);
    var _a = element.getBoundingClientRect(), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
    var centeredX = left + width / 2;
    var centeredY = top + height / 2;
    var topMostElement = document.elementFromPoint(centeredX, centeredY);
    document.head.removeChild(document.querySelector("#" + styleId));
    return !element.contains(topMostElement);
};
var isElementHidden = function (element) {
    var _a = window.getComputedStyle(element), display = _a.display, opacity = _a.opacity, visibility = _a.visibility;
    return display === 'none' ||
        opacity === '0' ||
        visibility === 'hidden';
};
var verticalAlignClassNameRegExp = /(vertical-align-.+?)(\s|-|$)/;
var getVerticalAlignClassName = function (className) {
    var match = className.match(verticalAlignClassNameRegExp);
    if (!match) {
        return '';
    }
    return match[1];
};
var setVerticalAlignClassName = function (element, newClassName) {
    var match = element.className.match(verticalAlignClassNameRegExp);
    var currentVerticalAlignClassName = match ? match[1] : '';
    if (currentVerticalAlignClassName) {
        element.className = element.className.replace(currentVerticalAlignClassName, newClassName);
    }
    else {
        if (newClassName) {
            element.classList.add(newClassName);
        }
    }
};
var isTextScriptElement = function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* superScriptClassName */]) || className.includes(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* subScriptClassName */])); };
var getTextScriptClassName = function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* superScriptClassName */]) ? __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* superScriptClassName */] : __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* subScriptClassName */]); };
var getSelectedSpreads = function (spreadIndex, allSpreads, prevSelectedSpreadIndices, prevLastSelectedSpreadIndex, prevLastSelectedShiftSpreadIndex, isCtrlPressed, isShiftPressed, isMultiSelection) {
    var selectedSpreadIndices = [];
    var lastSelectedSpreadIndex = -1;
    var lastSelectedShiftSpreadIndex = -1;
    if (isCtrlPressed) {
        selectedSpreadIndices = getSelectedSpreadIndices(spreadIndex, prevSelectedSpreadIndices);
        lastSelectedSpreadIndex = spreadIndex;
    }
    else if (isShiftPressed) {
        if (prevSelectedSpreadIndices.length === 0) {
            selectedSpreadIndices = [spreadIndex];
            lastSelectedSpreadIndex = spreadIndex;
        }
        else {
            var allSpreadIndices = Array.from({ length: allSpreads.length }, function (v, i) { return i; });
            __WEBPACK_IMPORTED_MODULE_7__utils_selectionManager__["a" /* default */].set(prevSelectedSpreadIndices, allSpreadIndices);
            if (prevLastSelectedShiftSpreadIndex > -1) {
                __WEBPACK_IMPORTED_MODULE_7__utils_selectionManager__["a" /* default */].deselectItems(prevLastSelectedShiftSpreadIndex, prevLastSelectedSpreadIndex);
            }
            __WEBPACK_IMPORTED_MODULE_7__utils_selectionManager__["a" /* default */].selectItems(spreadIndex, prevLastSelectedSpreadIndex);
            selectedSpreadIndices = __WEBPACK_IMPORTED_MODULE_7__utils_selectionManager__["a" /* default */].get();
            lastSelectedSpreadIndex = prevLastSelectedSpreadIndex;
            lastSelectedShiftSpreadIndex = spreadIndex;
        }
    }
    else {
        if (isMultiSelection) {
            selectedSpreadIndices = getSelectedSpreadIndices(spreadIndex, prevSelectedSpreadIndices);
        }
        else {
            selectedSpreadIndices = [spreadIndex];
        }
        lastSelectedSpreadIndex = spreadIndex;
    }
    return {
        spreadIndices: selectedSpreadIndices,
        lastSelectedSpreadIndex: lastSelectedSpreadIndex,
        lastSelectedShiftSpreadIndex: lastSelectedShiftSpreadIndex,
    };
};
var getSelectedSpreadIndices = function (spreadIndex, prevSelectedSpreadIndices) { return (prevSelectedSpreadIndices.includes(spreadIndex)
    ? prevSelectedSpreadIndices.filter(function (index) { return index !== spreadIndex; })
    : __spread(prevSelectedSpreadIndices, [spreadIndex]).sort(function (a, b) { return a - b; })); };
var getSliderPreviewUrl = function (config, relUrl, isExternalLink, externalRelUrl, iconName) {
    return isExternalLink
        ? getYoutubeVideoCover(externalRelUrl)
        : getResourceUrl(iconName || (hasMediaParam(relUrl) ? relUrl : relUrl.split('/')[1]) || '', config);
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EditorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditableType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LinkType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionEventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LinkParam; });
/* unused harmony export LinksMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PdfImportingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ZoomType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ShowAloneSide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return VerticalAlignClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return colorMarkClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return linkClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return subScriptClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return superScriptClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return editedElementClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return emptyTextFieldClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IGNORE_PAGE_CLICK_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_PANEL_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SPREAD_BACKGROUND_CLICK_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SETTINGS_PANEL_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PAGE_CONTENT_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EditorMessageTypes; });
var _a;
var EditorType;
(function (EditorType) {
    EditorType["HTML"] = "HTML";
    EditorType["INDESIGN"] = "INDESIGN";
})(EditorType || (EditorType = {}));
var EditableType;
(function (EditableType) {
    EditableType["text"] = "text";
    EditableType["image"] = "image";
    EditableType["video"] = "video";
    EditableType["animation"] = "animation";
    EditableType["iframe"] = "iframe";
    EditableType["link"] = "link";
    EditableType["themes"] = "themes";
    EditableType["slider"] = "slider";
})(EditableType || (EditableType = {}));
var LinkType;
(function (LinkType) {
    LinkType["url"] = "url";
    LinkType["mailto"] = "mailto";
    LinkType["goToPage"] = "goToPage";
    LinkType["goToChapterId"] = "goToChapterId";
    LinkType["popup"] = "popup";
    LinkType["unsupported"] = "unsupported";
})(LinkType || (LinkType = {}));
var ActionEventType;
(function (ActionEventType) {
    ActionEventType["goToPage"] = "goToPage";
    ActionEventType["goToChapterId"] = "goToChapterId";
    ActionEventType["popup"] = "popup";
    ActionEventType["mailto"] = "mailto";
    ActionEventType["unsupported"] = "unsupported";
})(ActionEventType || (ActionEventType = {}));
var LinkParam;
(function (LinkParam) {
    LinkParam["email"] = "email";
    LinkParam["page"] = "page";
    LinkParam["param"] = "param";
    LinkParam["chapterId"] = "chapterId";
})(LinkParam || (LinkParam = {}));
var LinksMap = (_a = {},
    _a[LinkType.mailto] = LinkParam.email,
    _a[LinkType.goToPage] = LinkParam.page,
    _a[LinkType.goToChapterId] = LinkParam.chapterId,
    _a);
var PdfImportingStatus;
(function (PdfImportingStatus) {
    PdfImportingStatus["IMPORTING"] = "IMPORTING";
    PdfImportingStatus["PROCESSING"] = "PROCESSING";
    PdfImportingStatus["REMOVING"] = "REMOVING";
})(PdfImportingStatus || (PdfImportingStatus = {}));
var ZoomType;
(function (ZoomType) {
    ZoomType["OUT"] = "OUT";
    ZoomType["IN"] = "IN";
    ZoomType["FIT"] = "FIT";
})(ZoomType || (ZoomType = {}));
var ShowAloneSide;
(function (ShowAloneSide) {
    ShowAloneSide["LEFT"] = "left";
    ShowAloneSide["CENTER"] = "center";
    ShowAloneSide["RIGHT"] = "right";
})(ShowAloneSide || (ShowAloneSide = {}));
var VerticalAlignClassName;
(function (VerticalAlignClassName) {
    // TOP is not needed because no className is set for this value in inDesign
    VerticalAlignClassName["CENTER"] = "vertical-align-center";
    VerticalAlignClassName["BOTTOM"] = "vertical-align-bottom";
})(VerticalAlignClassName || (VerticalAlignClassName = {}));
var colorMarkClassName = 'rte-font-color';
var linkClassName = 'rte-underline';
var subScriptClassName = 'rte-subscript';
var superScriptClassName = 'rte-superscript';
var editedElementClassName = 'edited';
var emptyTextFieldClassName = 'is-empty';
var IGNORE_PAGE_CLICK_CLASSNAME = 'ignore-page-click';
var EDIT_PANEL_CLASSNAME = 'edit-panel';
var SPREAD_BACKGROUND_CLICK_CLASSNAME = 'spread-background-click';
var SETTINGS_PANEL_CLASSNAME = 'settings-panel';
var PAGE_CONTENT_CLASSNAME = 'page-content';
var EditorMessageTypes;
(function (EditorMessageTypes) {
    EditorMessageTypes["RELOAD_PUBLICATION_SETTINGS"] = "reloadPublicationSettings";
    EditorMessageTypes["NEW_PLAYLIST_ID"] = "newPlaylistId";
})(EditorMessageTypes || (EditorMessageTypes = {}));


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
var Api;
(function (Api) {
    var DriveItemType;
    (function (DriveItemType) {
        DriveItemType[DriveItemType["Directory"] = 0] = "Directory";
        DriveItemType[DriveItemType["Component"] = 1] = "Component";
        DriveItemType[DriveItemType["File"] = 2] = "File";
        DriveItemType[DriveItemType["Template"] = 3] = "Template";
        DriveItemType[DriveItemType["Image"] = 4] = "Image";
        DriveItemType[DriveItemType["Movie"] = 5] = "Movie";
        DriveItemType[DriveItemType["Publication"] = 6] = "Publication";
        DriveItemType[DriveItemType["Sound"] = 7] = "Sound";
        DriveItemType[DriveItemType["V2Gateway"] = 8] = "V2Gateway";
        DriveItemType[DriveItemType["Link"] = 9] = "Link";
        DriveItemType[DriveItemType["AppContainer"] = 10] = "AppContainer";
        DriveItemType[DriveItemType["Gallery"] = 11] = "Gallery";
        DriveItemType[DriveItemType["ExternalLink"] = 12] = "ExternalLink";
    })(DriveItemType = Api.DriveItemType || (Api.DriveItemType = {}));
    var AdditionalItemType;
    (function (AdditionalItemType) {
        AdditionalItemType["Note"] = "Note";
    })(AdditionalItemType = Api.AdditionalItemType || (Api.AdditionalItemType = {}));
    var AspFolderDisplayType;
    (function (AspFolderDisplayType) {
        AspFolderDisplayType["List"] = "LIST";
        AspFolderDisplayType["Grid"] = "GRID";
        AspFolderDisplayType["Masonry"] = "MASONRY";
        AspFolderDisplayType["Coverflow"] = "COVERFLOW";
    })(AspFolderDisplayType = Api.AspFolderDisplayType || (Api.AspFolderDisplayType = {}));
    var OutcomingType;
    (function (OutcomingType) {
        OutcomingType["Directory"] = "DIRECTORY";
        OutcomingType["Component"] = "COMPONENT";
        OutcomingType["File"] = "FILE";
        OutcomingType["Template"] = "TEMPLATE";
        OutcomingType["Image"] = "IMAGE";
        OutcomingType["Movie"] = "MOVIE";
        OutcomingType["Publication"] = "PUBLICATION";
        OutcomingType["Sound"] = "SOUND";
        OutcomingType["V2Gateway"] = "V2GATEWAY";
        OutcomingType["Link"] = "LINK";
        OutcomingType["AppContainer"] = "APP_CONTAINER";
        OutcomingType["Gallery"] = "GALLERY";
        OutcomingType["ExternalLink"] = "EXTERNAL_LINK";
    })(OutcomingType = Api.OutcomingType || (Api.OutcomingType = {}));
    var ShareMethod;
    (function (ShareMethod) {
        ShareMethod["Download"] = "download";
        ShareMethod["Share"] = "share";
    })(ShareMethod = Api.ShareMethod || (Api.ShareMethod = {}));
    var ShareNetwork;
    (function (ShareNetwork) {
        ShareNetwork["Uprez"] = "email";
        ShareNetwork["Copy"] = "copy";
    })(ShareNetwork = Api.ShareNetwork || (Api.ShareNetwork = {}));
    var AssetItemAccessType;
    (function (AssetItemAccessType) {
        AssetItemAccessType["PUBLIC"] = "PUBLIC";
    })(AssetItemAccessType = Api.AssetItemAccessType || (Api.AssetItemAccessType = {}));
    var AssetItemInvoiceStatus;
    (function (AssetItemInvoiceStatus) {
        AssetItemInvoiceStatus["DRAFT"] = "DRAFT";
        AssetItemInvoiceStatus["DEMO"] = "DEMO";
        AssetItemInvoiceStatus["TO_BE_INVOICED"] = "TOBEINVOICED";
        AssetItemInvoiceStatus["INVOICED"] = "INVOICED";
        AssetItemInvoiceStatus["SALESFORCE"] = "SALESFORCE";
        AssetItemInvoiceStatus["PAID"] = "PAID";
        AssetItemInvoiceStatus["CHARMED"] = "CHARMED";
        AssetItemInvoiceStatus["SUSPENDED"] = "SUSPENDED";
        AssetItemInvoiceStatus["PUBLISHED"] = "PUBLISHED";
        AssetItemInvoiceStatus["UNPUBLISHED"] = "UNPUBLISHED";
    })(AssetItemInvoiceStatus = Api.AssetItemInvoiceStatus || (Api.AssetItemInvoiceStatus = {}));
    var AssetItemStatus;
    (function (AssetItemStatus) {
        AssetItemStatus["LIVE"] = "LIVE";
        AssetItemStatus["PROCESSING"] = "PROCESSING";
        AssetItemStatus["ERROR"] = "ERROR";
    })(AssetItemStatus = Api.AssetItemStatus || (Api.AssetItemStatus = {}));
    var AssetItemFileTypes;
    (function (AssetItemFileTypes) {
        AssetItemFileTypes["DIRECTORY"] = "DIRECTORY";
        AssetItemFileTypes["COMPONENT"] = "COMPONENT";
        AssetItemFileTypes["GALLERY"] = "GALLERY";
        AssetItemFileTypes["IMAGE"] = "IMAGE";
        AssetItemFileTypes["PUBLICATION"] = "PUBLICATION";
        AssetItemFileTypes["TEMPLATE"] = "TEMPLATE";
        AssetItemFileTypes["MOVIE"] = "MOVIE";
        AssetItemFileTypes["FILE"] = "FILE";
        AssetItemFileTypes["V2GATEWAY"] = "V2GATEWAY";
        AssetItemFileTypes["EXTERNAL_LINK"] = "EXTERNAL_LINK";
        AssetItemFileTypes["APP_CONTAINER"] = "APP_CONTAINER";
        AssetItemFileTypes["LINK"] = "LINK";
        AssetItemFileTypes["PROPOSAL"] = "PROPOSAL";
        AssetItemFileTypes["DEFAULT"] = "DEFAULT";
    })(AssetItemFileTypes = Api.AssetItemFileTypes || (Api.AssetItemFileTypes = {}));
    var AssetItemFileFormats;
    (function (AssetItemFileFormats) {
        AssetItemFileFormats["DOCUMENT"] = "DOCUMENT";
        AssetItemFileFormats["PRESENTATION"] = "PRESENTATION";
        AssetItemFileFormats["SPREADSHEET"] = "SPREADSHEET";
        AssetItemFileFormats["INDESIGN"] = "INDESIGN";
        AssetItemFileFormats["ILLUSTRATOR"] = "ILLUSTRATOR";
        AssetItemFileFormats["PHOTOSHOP"] = "PHOTOSHOP";
        AssetItemFileFormats["FILE"] = "FILE";
        AssetItemFileFormats["PDF"] = "PDF";
        AssetItemFileFormats["JPG"] = "JPG";
        AssetItemFileFormats["JPEG"] = "JPEG";
        AssetItemFileFormats["PNG"] = "PNG";
        AssetItemFileFormats["SVG"] = "SVG";
        AssetItemFileFormats["GIF"] = "GIF";
        AssetItemFileFormats["MOV"] = "MOV";
        AssetItemFileFormats["MP4"] = "MP4";
        AssetItemFileFormats["AVI"] = "AVI";
    })(AssetItemFileFormats = Api.AssetItemFileFormats || (Api.AssetItemFileFormats = {}));
    var CustomerContextRoles;
    (function (CustomerContextRoles) {
        CustomerContextRoles["ROLE_ALL_RIGHTS"] = "ROLE_ALL_RIGHTS";
        CustomerContextRoles["ROLE_PRODUCTION"] = "ROLE_PRODUCTION";
        CustomerContextRoles["ROLE_COMMERCIAL_SALESFORCE"] = "ROLE_COMMERCIAL_SALESFORCE";
        CustomerContextRoles["ROLE_COMMERCIAL_MANUAL"] = "ROLE_COMMERCIAL_MANUAL";
        CustomerContextRoles["ROLE_AGENCY"] = "ROLE_AGENCY";
        CustomerContextRoles["ROLE_SAAS_ACCOUNT_MANAGER"] = "ROLE_SAAS_ACCOUNT_MANAGER";
        CustomerContextRoles["ROLE_SAAS_USER"] = "ROLE_SAAS_USER";
        CustomerContextRoles["ROLE_CONSUMER"] = "ROLE_CONSUMER";
        CustomerContextRoles["ROLE_APPLICATION_USER"] = "ROLE_APPLICATION_USER";
        CustomerContextRoles["ROLE_APPLICATION_VIEWER"] = "ROLE_APPLICATION_VIEWER";
        CustomerContextRoles["ROLE_LIBRARY_ACCOUNT_MANAGER"] = "ROLE_LIBRARY_ACCOUNT_MANAGER";
    })(CustomerContextRoles = Api.CustomerContextRoles || (Api.CustomerContextRoles = {}));
    var PublicationDisplayMode;
    (function (PublicationDisplayMode) {
        PublicationDisplayMode["AUTO"] = "AUTO";
        PublicationDisplayMode["CROSS_NAV"] = "CROSS_NAV";
        PublicationDisplayMode["SLIDER"] = "SLIDER";
        PublicationDisplayMode["FLIPBOOK"] = "FLIPBOOK";
    })(PublicationDisplayMode = Api.PublicationDisplayMode || (Api.PublicationDisplayMode = {}));
    var PublicationFirstFrameMode;
    (function (PublicationFirstFrameMode) {
        PublicationFirstFrameMode["SINGLE"] = "SINGLE";
        PublicationFirstFrameMode["DOUBLE"] = "DOUBLE";
    })(PublicationFirstFrameMode = Api.PublicationFirstFrameMode || (Api.PublicationFirstFrameMode = {}));
    var ComponentType;
    (function (ComponentType) {
        ComponentType["EPUB"] = "EPUB";
        ComponentType["PDF"] = "PDF";
        ComponentType["ZIP"] = "ZIP";
        ComponentType["ZIP_EDITABLE"] = "ZIP_EDITABLE";
    })(ComponentType = Api.ComponentType || (Api.ComponentType = {}));
    var PublicationFormat;
    (function (PublicationFormat) {
        PublicationFormat["PDF"] = "PDF";
        PublicationFormat["PDF_EDITABLE"] = "PDF_EDITABLE";
        PublicationFormat["EPUB"] = "EPUB";
        PublicationFormat["EPUB_MASTER"] = "EPUB_MASTER";
        PublicationFormat["EPUB_EDITABLE"] = "EPUB_EDITABLE";
        PublicationFormat["EPUB_PRESENTATION"] = "EPUB_PRESENTATION";
        PublicationFormat["EPUB_PUBLI_MASTER"] = "EPUB_PUBLI_MASTER";
        PublicationFormat["EPUB_MODIFIABLE"] = "EPUB_MODIFIABLE";
        PublicationFormat["EPUB_PREVIEW"] = "EPUB_PREVIEW";
        PublicationFormat["EPUB_PLAYLIST"] = "EPUB_PLAYLIST";
    })(PublicationFormat = Api.PublicationFormat || (Api.PublicationFormat = {}));
    var ProposalStatus;
    (function (ProposalStatus) {
        ProposalStatus["DRAFT"] = "DRAFT";
        ProposalStatus["SENT"] = "SENT";
        ProposalStatus["SEEN"] = "SEEN";
    })(ProposalStatus = Api.ProposalStatus || (Api.ProposalStatus = {}));
    var CreationSource;
    (function (CreationSource) {
        CreationSource["DESKTOP"] = "DESKTOP";
        CreationSource["PLUGIN"] = "PLUGIN";
    })(CreationSource = Api.CreationSource || (Api.CreationSource = {}));
    var CombineOption;
    (function (CombineOption) {
        CombineOption["ADVANCED"] = "ADVANCED";
        CombineOption["MULTISELECT"] = "MULTISELECT";
        CombineOption["PLAYLIST"] = "PLAYLIST";
    })(CombineOption = Api.CombineOption || (Api.CombineOption = {}));
    var CRMProviders;
    (function (CRMProviders) {
        CRMProviders["NONE"] = "NONE";
        CRMProviders["HUBSPOT"] = "HUBSPOT";
        CRMProviders["SALESFORCE"] = "SALESFORCE";
    })(CRMProviders = Api.CRMProviders || (Api.CRMProviders = {}));
    var EmailProviders;
    (function (EmailProviders) {
        EmailProviders["NYLAS"] = "NYLAS";
    })(EmailProviders || (EmailProviders = {}));
    var PublicationSettingName;
    (function (PublicationSettingName) {
        PublicationSettingName["customUrl"] = "customUrl";
        PublicationSettingName["downloadPdf"] = "downloadPdf";
        PublicationSettingName["googleAnalyticsUa"] = "googleAnalyticsUa";
    })(PublicationSettingName = Api.PublicationSettingName || (Api.PublicationSettingName = {}));
    var PublicationPdfOption;
    (function (PublicationPdfOption) {
        PublicationPdfOption["FULL"] = "full";
        PublicationPdfOption["CUSTOM"] = "custom";
    })(PublicationPdfOption = Api.PublicationPdfOption || (Api.PublicationPdfOption = {}));
    var PublicationPdfImportResponse;
    (function (PublicationPdfImportResponse) {
        PublicationPdfImportResponse["SYNC"] = "SYNC";
        PublicationPdfImportResponse["ASYNC"] = "ASYNC";
    })(PublicationPdfImportResponse = Api.PublicationPdfImportResponse || (Api.PublicationPdfImportResponse = {}));
    var AccountType;
    (function (AccountType) {
        AccountType["POSTPAID"] = "POSTPAID";
        AccountType["PREPAID"] = "PREPAID";
    })(AccountType = Api.AccountType || (Api.AccountType = {}));
    var OutcomingsLevel;
    (function (OutcomingsLevel) {
        OutcomingsLevel["ALL"] = "ALL";
        OutcomingsLevel["TREE"] = "TREE";
    })(OutcomingsLevel = Api.OutcomingsLevel || (Api.OutcomingsLevel = {}));
})(Api || (Api = {}));



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResolutionDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionButtonStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_OfflineManager_reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_ProfilePage_selectors__ = __webpack_require__(95);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};















var PublicationFormat = __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat;
var I18n = __webpack_require__(5).I18n;
var minimumWidthRow = 360;
var minimumWidth = 720;
var maxOriginalImageSize = 2048;
var ResolutionDisplayType;
(function (ResolutionDisplayType) {
    ResolutionDisplayType["Card"] = "Card";
    ResolutionDisplayType["RowItem"] = "RowItem";
    ResolutionDisplayType["Detail"] = "Detail";
    ResolutionDisplayType["Theater"] = "Theater";
    ResolutionDisplayType["Coverflow"] = "Coverflow";
})(ResolutionDisplayType || (ResolutionDisplayType = {}));
var ActionButton;
(function (ActionButton) {
    ActionButton["Read"] = "read";
    ActionButton["Download"] = "download";
    ActionButton["Update"] = "update";
    ActionButton["Delete"] = "delete";
    ActionButton["Cancel"] = "cancel";
    ActionButton["Required"] = "required";
})(ActionButton || (ActionButton = {}));
var ActionButtonStyle;
(function (ActionButtonStyle) {
    ActionButtonStyle["Bar"] = "Bar";
    ActionButtonStyle["Icon"] = "Icon";
    ActionButtonStyle["ParametersPage"] = "ParametersPage";
})(ActionButtonStyle || (ActionButtonStyle = {}));
var DriveItemUtils = /** @class */ (function () {
    function DriveItemUtils() {
    }
    DriveItemUtils.getDisplayName = function (driveItem) {
        var _a = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState(), driveList = _a.driveList, config = _a.galleryInfos.config;
        var id = driveItem.id, titles = driveItem.titles, label = driveItem.label;
        var multiAppLogin = DriveItemUtils.getMultiAppLogin();
        if (id === __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getSharedDirId(driveList, config)) {
            return I18n.t('messages.shared_with_me');
        }
        if (id === __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getArchiveDirId(driveList, config)) {
            return I18n.t('messages.archive_noun');
        }
        if (id === __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getSourcesDirId(driveList, config)) {
            return I18n.t('messages.sources');
        }
        if (multiAppLogin && id === __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getPrivateDirId(driveList, config)) {
            var specialPrivateDirIds = config.specialPrivateDirIds;
            var isSpecialPrivateDir = specialPrivateDirIds && specialPrivateDirIds.includes(id);
            if (!isSpecialPrivateDir) {
                return I18n.t('messages.my_documents');
            }
        }
        var titleKeys = Object.keys(titles);
        return !!titleKeys.length ? titles[titleKeys[0]] : label;
    };
    DriveItemUtils.getMultiAppLogin = function () {
        var _a = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState(), multiAppAuthenticationInfos = _a.multiAppAuthenticationInfos, appInfos = _a.appInfos;
        var credentials = multiAppAuthenticationInfos.credentials;
        var type = appInfos.type;
        if (type === __WEBPACK_IMPORTED_MODULE_10__containers_App_reducer__["a" /* AppType */].Multiple && credentials && credentials.login) {
            return credentials.login;
        }
        return null;
    };
    DriveItemUtils.getLocale = function (driveItem) {
        var titles = driveItem.titles, descriptions = driveItem.descriptions;
        var titleKeys = Object.keys(titles);
        var descriptionKeys = Object.keys(descriptions);
        return titleKeys[0] || descriptionKeys[0] || '';
    };
    DriveItemUtils.getExtension = function (driveItem, isIcon) {
        if (isIcon === void 0) { isIcon = false; }
        if (isIcon) {
            return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(driveItem.icon);
        }
        switch (driveItem.type) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Gallery:
                return '';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication:
                return I18n.t("messages.extension_flip");
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.ExternalLink:
                return I18n.t("messages.extension_external_link");
        }
        if (driveItem.originalFile) {
            return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(driveItem.originalFile);
        }
        return '';
    };
    DriveItemUtils.isPreviewable = function (driveItem) {
        return [__WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image, __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie, __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Sound].includes(driveItem.type);
    };
    DriveItemUtils.getThumbnail = function (driveItem, galleryConfig, globalResolutions, isBox, displayType) {
        // fallback order :
        // itemOriginalUrl (if same as icon and not too big) > iconWithResolution > iconOriginalUrl > defaultIcon
        var driveItems = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState().driveList.driveItems;
        var resolutions = driveItem.resolutions || globalResolutions;
        var icon = driveItem.icon;
        if (icon) {
            var iconId = this.getIconId(driveItem);
            var iconItem = driveItems[iconId] ? driveItems[iconId] : driveItem;
            // If iconId matches the driveItem's own ID (self-reference), use the icon path directly
            // This prevents videos with icon="$media$ID.webp" from falling back to the video's .mp4 file
            var isSelfReferencingIcon = iconId === driveItem.id && iconId > 0;
            // Check if icon path ends with .webp (or other image extensions) - indicates it's a thumbnail image, not the video file
            var iconExtension = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(icon);
            var isImageIcon = DriveItemUtils.imageExtensions.includes("." + iconExtension.toLowerCase());
            var iconItemNotFound = iconItem === driveItem && iconId > 0 && iconId !== driveItem.id;
            if (!DriveItemUtils.needsResolutions(driveItem)) {
                return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(icon, galleryConfig);
            }
            var currentDisplayType = displayType && displayType === __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row ? ResolutionDisplayType.RowItem : ResolutionDisplayType.Card;
            if (!DriveItemUtils.hasIconMetadata(driveItem, resolutions) || !driveItem.associatedResolutions) {
                // When iconItem is the same as driveItem (self-reference) and the icon path has an image extension,
                // use the icon path directly instead of falling back to originalFile
                // This prevents issues where:
                // - Videos with icon="$media$ID.webp" fall back to .mp4 file
                // - Publications with icon="$media$ID/path/thumb.jpg" fall back to .epub file
                // - Images with icon="$media$ID.webp" fall back to wrong file
                // Also handle cases where icon references another item that doesn't exist in driveItems
                if ((isSelfReferencingIcon && isImageIcon) || (iconItemNotFound && isImageIcon)) {
                    return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(icon, galleryConfig);
                }
                return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getItemOriginalFileUrl(galleryConfig, iconItem.originalFile);
            }
            else if (DriveItemUtils.hasIconMetadata(driveItem, resolutions)) {
                var availableResolutionsId = driveItem.associatedResolutions[iconId] || 'default';
                var availableResolutions = resolutions[availableResolutionsId];
                var resolution = DriveItemUtils.getIdealSizeFromResolutions(availableResolutions, currentDisplayType, isBox);
                return this.getImagePathByResolution(driveItem, galleryConfig, resolution, undefined, true);
            }
            else {
                return this.getDefaultThumbnail(driveItem);
            }
        }
        return this.getDefaultThumbnail(driveItem);
    };
    DriveItemUtils.needsResolutions = function (driveItem) {
        var driveItems = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState().driveList.driveItems;
        var iconId = this.getIconId(driveItem);
        var iconItem = driveItems[iconId] ? driveItems[iconId] : driveItem;
        // For items with self-referencing icons that have image extensions, don't use resolutions
        // This ensures we use the icon path directly instead of falling back to originalFile
        // Examples:
        // - Videos: icon="$media$ID.webp" should use .webp, not .mp4
        // - Publications: icon="$media$ID/path/thumb.jpg" should use .jpg, not .epub
        // - Images: icon="$media$ID.webp" should use .webp, not original file
        var isSelfReferencingIcon = iconId === driveItem.id && iconId > 0;
        if (isSelfReferencingIcon && driveItem.icon) {
            var iconExtension = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(driveItem.icon);
            var isImageIcon = DriveItemUtils.imageExtensions.includes("." + iconExtension.toLowerCase());
            if (isImageIcon) {
                return false;
            }
        }
        return !(iconId < 0 || DriveItemUtils.shouldUseOriginalThumb(iconItem));
    };
    DriveItemUtils.hasIconMetadata = function (driveItem, globalResolutions) {
        if (globalResolutions === void 0) { globalResolutions = undefined; }
        var icon = driveItem.icon, associatedResolutions = driveItem.associatedResolutions, driveItemResolutions = driveItem.resolutions;
        var resolutions = globalResolutions || driveItemResolutions;
        if (icon && associatedResolutions && resolutions) {
            var iconId = this.getIconId(driveItem);
            var availableResolutionsId = associatedResolutions[iconId] || 'default';
            var availableResolutions = resolutions[availableResolutionsId];
            if (icon && !availableResolutions) {
                console.warn('Icon not found in available resolutions', driveItem);
            }
            return availableResolutions !== undefined && DriveItemUtils.isSupportedExtension(driveItem, resolutions) && driveItem.type !== __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie;
        }
        return false;
    };
    DriveItemUtils.getTheaterImage = function (driveItem, galleryConfig, globalResolutions) {
        var resolutions = driveItem.resolutions || globalResolutions;
        var availableResolutionsId = driveItem.associatedResolutions && driveItem.associatedResolutions[driveItem.id] || 'default';
        var availableResolutions = resolutions[availableResolutionsId];
        if (DriveItemUtils.shouldUseOriginalFile(driveItem, ResolutionDisplayType.Theater) || availableResolutions === undefined) {
            return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getItemOriginalFileUrl(galleryConfig, driveItem.originalFile);
        }
        var resolution = DriveItemUtils.getIdealSizeFromResolutions(availableResolutions, ResolutionDisplayType.Theater, true);
        return this.getImagePathByResolution(driveItem, galleryConfig, resolution, false);
    };
    DriveItemUtils.isPreferredExtension = function (extension) {
        var isSvg = extension === 'svg';
        var isGif = extension === 'gif';
        return isSvg || isGif;
    };
    DriveItemUtils.shouldUseOriginalFile = function (driveItem, resolutionDisplayType) {
        var imageWidth = parseInt(DriveItemUtils.getImageWidth(driveItem), 10);
        var targetWidth = DriveItemUtils.getTargetWidth(resolutionDisplayType);
        var extension = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(driveItem.originalFile);
        return !driveItem.associatedResolutions || imageWidth < Math.max(targetWidth, maxOriginalImageSize) || DriveItemUtils.isPreferredExtension(extension);
    };
    DriveItemUtils.shouldUseOriginalThumb = function (driveItem) {
        var extension = driveItem.icon ? __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(driveItem.icon) : '';
        return DriveItemUtils.isPreferredExtension(extension);
    };
    DriveItemUtils.hasIcon = function (driveItem) {
        return !!(driveItem && driveItem.icon);
    };
    DriveItemUtils.getIconId = function (driveItem) {
        if (!driveItem.icon) {
            return -1;
        }
        // Match both patterns: $media$123.ext and $media$123/path.ext
        var regexMatches = /^\$media\$([0-9]+)(?:\..*|\/.*)$/.exec(driveItem.icon);
        return regexMatches !== null
            ? parseInt(regexMatches[1], 10)
            : -1;
    };
    DriveItemUtils.isSupportedExtension = function (driveItem, resolutions) {
        var iconId = this.getIconId(driveItem);
        var resolvedResolution = driveItem.associatedResolutions ? resolutions[driveItem.associatedResolutions[iconId]] : resolutions.default;
        if (resolvedResolution) {
            var supportedExtensions = resolvedResolution.supported;
            var iconExtension = DriveItemUtils.getIconExtension(driveItem);
            return supportedExtensions.includes(iconExtension);
        }
        return false;
    };
    DriveItemUtils.getIconExtension = function (driveItem) {
        if (driveItem.icon) {
            var extensionRegex = /(?:\.([^.]+))?$/;
            var regexMatch = extensionRegex.exec(driveItem.icon);
            return !!regexMatch && !!regexMatch[1] ? regexMatch[1] : '';
        }
        return '';
    };
    DriveItemUtils.getDownloadedFileName = function (driveItem) {
        var extension = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(driveItem.originalFile);
        var fileName;
        if (extension === 'tif') {
            fileName = driveItem.id + ".jpg";
        }
        else {
            fileName = driveItem.id + "." + extension;
        }
        return fileName;
    };
    DriveItemUtils.getTargetWidth = function (type) {
        switch (type) {
            case ResolutionDisplayType.Theater:
                return Math.max(window.innerHeight, window.innerWidth);
            case ResolutionDisplayType.RowItem:
                return minimumWidthRow;
            default:
                return minimumWidth;
        }
    };
    DriveItemUtils.getImageWidth = function (driveItem) {
        if (driveItem.resolution) {
            var widthRegex = /(\d+)x/;
            var regexMatch = widthRegex.exec(driveItem.resolution);
            return !!regexMatch && !!regexMatch[1] ? regexMatch[1] : '';
        }
        return '';
    };
    DriveItemUtils.getIdealSizeFromResolutions = function (availableResolutions, type, isBox) {
        var e_1, _a;
        var targetWidth = DriveItemUtils.getTargetWidth(type);
        // Try to find an associated box that fits
        var resolvedSize = this.getIdealSizeFromSizes(availableResolutions.sizes, targetWidth, isBox);
        // If no box fit, we ignore the isBox parameter
        resolvedSize = resolvedSize || this.getIdealSizeFromSizes(availableResolutions.sizes, targetWidth);
        // If still no box fit, we use the biggest resolution
        if (!resolvedSize) {
            try {
                for (var _b = __values(availableResolutions.sizes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var metaSize = _c.value;
                    if (!resolvedSize || metaSize.width > resolvedSize.width) {
                        resolvedSize = metaSize;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return resolvedSize;
    };
    DriveItemUtils.getIdealSizeFromSizes = function (metaSizes, targetWidth, isBox) {
        var e_2, _a;
        var resolvedSize;
        try {
            for (var metaSizes_1 = __values(metaSizes), metaSizes_1_1 = metaSizes_1.next(); !metaSizes_1_1.done; metaSizes_1_1 = metaSizes_1.next()) {
                var metaSize = metaSizes_1_1.value;
                if ((typeof isBox === 'undefined' || metaSize.box === isBox)
                    && (metaSize.width >= targetWidth && (!resolvedSize || metaSize.width < resolvedSize.width))) {
                    resolvedSize = metaSize;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (metaSizes_1_1 && !metaSizes_1_1.done && (_a = metaSizes_1.return)) _a.call(metaSizes_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return resolvedSize;
    };
    DriveItemUtils.getImagePathByResolution = function (driveItem, galleryConfig, size, isThumb, isIcon) {
        if (isThumb === void 0) { isThumb = true; }
        if (isIcon === void 0) { isIcon = false; }
        var extension = size.extension || (driveItem.type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image ? this.getExtension(driveItem, isIcon) : 'jpg');
        return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getImageUrl(galleryConfig, driveItem, size, extension, isThumb);
    };
    DriveItemUtils.getIconOriginalName = function (driveItem) {
        if (!driveItem.icon) {
            return '';
        }
        return this.getAssetOriginalName(driveItem.icon);
    };
    DriveItemUtils.getAssetOriginalName = function (ressourceUrl) {
        var regexMatches = /^\$media\$(.+)$/.exec(ressourceUrl);
        return regexMatches !== null
            ? regexMatches[1]
            : '';
    };
    DriveItemUtils.getAssetTypeTranslationKey = function (assetType, publicationFormat) {
        if (assetType === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AdditionalItemType.Note) {
            return 'messages.note';
        }
        var isProposal = assetType === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication
            && DriveItemUtils.isProposal(publicationFormat);
        if (isProposal) {
            return 'fileFormat.PROPOSAL';
        }
        return "type.asp-type-" + assetType;
    };
    DriveItemUtils.getIconOriginalPath = function (driveItem, galleryConfig) {
        return this.getAssetOriginalPath(galleryConfig, this.getIconOriginalName(driveItem));
    };
    DriveItemUtils.getAssetOriginalPath = function (galleryConfig, ressourceName) {
        return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getItemOriginalFileUrl(galleryConfig, ressourceName);
    };
    DriveItemUtils.getDefaultFolderIcon = function () {
        var _a = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState(), applicationGallery = _a.galleryInfos.config.applicationGallery, driveItems = _a.driveList.driveItems;
        var defaultCover = driveItems[applicationGallery].defaultCover;
        return defaultCover;
    };
    DriveItemUtils.getDefaultFolderIconPath = function (icon) {
        var _a = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState(), config = _a.galleryInfos.config, offlineManager = _a.offlineManager;
        var src = '';
        if (__WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isMobileApp) {
            // Check if the default folder icon has been downloaded
            var status_1 = offlineManager.defaultFolderIcon.status;
            if (status_1 === __WEBPACK_IMPORTED_MODULE_2__containers_OfflineManager_reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                // Use local file path
                src = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getThumbnailsFolder() + "/" + __WEBPACK_IMPORTED_MODULE_3____["e" /* defaultFolderIconFolder */] + "/" + icon.replace(__WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].mediaParamRegex, '');
            }
            else {
                // Fallback to online URL until download completes
                src = __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(icon, config);
            }
        }
        else {
            src = __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(icon, config);
        }
        return src;
    };
    DriveItemUtils.getFolderBgMediaPath = function (driveItemId, bgMedia) {
        var config = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState().galleryInfos.config;
        var src = '';
        if (__WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isMobileApp) {
            var extension = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(bgMedia);
            src = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getBgMediaFolder() + "/" + driveItemId + "/background." + extension;
        }
        else {
            src = __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(bgMedia, config);
        }
        return src;
    };
    DriveItemUtils.getDefaultThumbnail = function (driveItem) {
        switch (driveItem.type) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory:
                return 'iconset_doc_default';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication:
                return 'iconset_publication';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.File:
                return 'iconset_file';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image:
                return 'iconset_image-bold';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie:
                return 'iconset_video-bold';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Sound:
                return 'iconset_sound-bold';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Link:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.ExternalLink:
                return 'iconset_link';
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Gallery:
                return 'iconset_gallery-bold';
            default:
                return 'iconset_page-bold';
        }
    };
    DriveItemUtils.getDescription = function (driveItem, _a) {
        var locale = _a.locale;
        var descriptionKeys = Object.keys(driveItem.descriptions);
        if (!!descriptionKeys.length) {
            if (driveItem.descriptions[locale]) {
                return driveItem.descriptions[locale];
            }
            return driveItem.descriptions[descriptionKeys[0]];
        }
        return '';
    };
    DriveItemUtils.getPublicationCover = function (path, page) {
        if (page === void 0) { page = 1; }
        return path.replace(/{page}/, page.toString());
    };
    DriveItemUtils.isStored = function (itemId, storage) {
        return storage.includes(itemId);
    };
    DriveItemUtils.getPageByDriveItemId = function (ressources, driveItemId) {
        for (var i = 0; i < ressources.length; i++) {
            if (driveItemId === ressources[i].id) {
                return (1 + Math.floor(i / __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["a" /* DRIVE_ITEM_LIST_PAGE_SIZE */]));
            }
        }
        return -1;
    };
    DriveItemUtils.getShareTitle = function (sharedItems) {
        var firstItem = sharedItems[0];
        if (sharedItems.length > 1) {
            return I18n.t('messages.selection');
        }
        return DriveItemUtils.getDisplayName(firstItem);
    };
    DriveItemUtils.getShareLink = function (sharedItems, galleryConfig, shareOrigin) {
        if (sharedItems.length > 1) {
            return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlDriveItemListPage(galleryConfig, __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Assortment, sharedItems.map(function (driveItem) { return driveItem.id; }).join(), true);
        }
        var firstItem = sharedItems[0];
        if (firstItem.type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory) {
            return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlDriveItemListPage(galleryConfig, __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, firstItem.id.toString(), true);
        }
        switch (shareOrigin) {
            case __WEBPACK_IMPORTED_MODULE_8__containers_Share_actions__["a" /* ShareOrigin */].Detail:
                return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlDriveItemDetailPage(galleryConfig, firstItem.id, undefined, true);
            case __WEBPACK_IMPORTED_MODULE_8__containers_Share_actions__["a" /* ShareOrigin */].Selection:
                return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlDriveItemListPage(galleryConfig, __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Assortment, sharedItems[0].id.toString(), true);
            case __WEBPACK_IMPORTED_MODULE_8__containers_Share_actions__["a" /* ShareOrigin */].Theater:
            default:
                return __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlTheater(galleryConfig, __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, DriveItemUtils.getParentFolderId(firstItem).toString(), firstItem.id, true);
        }
    };
    DriveItemUtils.containsString = function (driveItem, searchString) {
        var tagsRegex = /tags\[(.*)\]/g;
        var match = tagsRegex.exec(searchString);
        var searchTags;
        if (match) {
            searchTags = match[1].split(',');
        }
        var searchText = searchString.replace(tagsRegex, '').toLowerCase();
        var hasAllSearchTags = !searchTags
            ? true
            : DriveItemUtils.hasAllSearchTags(driveItem.tags, searchTags);
        if (!hasAllSearchTags) {
            return false;
        }
        var fieldsToCheck = [
            'label',
            'name',
            'descriptions',
            'tags',
            'titles'
        ];
        for (var i = 0; i < fieldsToCheck.length; i++) {
            var field = fieldsToCheck[i];
            var value = driveItem[field];
            if (typeof (value) === 'object') {
                var subFields = Object.keys(value);
                for (var j = 0; j < subFields.length; j++) {
                    var subField = subFields[j];
                    if (value[subField].toString().toLowerCase().includes(searchText)) {
                        return true;
                    }
                }
            }
            else if (typeof (value) !== 'undefined') {
                if (value.toString().toLowerCase().includes(searchText)) {
                    return true;
                }
            }
        }
        return false;
    };
    DriveItemUtils.hasAllSearchTags = function (driveItemTags, searchTags) {
        return searchTags.every(function (searchTag) { return driveItemTags.includes(searchTag); });
    };
    DriveItemUtils.isDownloadableItemType = function (driveItem) {
        var type = driveItem.type;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.File:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Sound:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Component:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Template:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication:
                return true;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.V2Gateway:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Link:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.AppContainer:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Gallery:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.ExternalLink:
                return false;
        }
    };
    DriveItemUtils.isReadable = function (driveItem, downloadManager) {
        var isOnline = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isOnline();
        var isPersistentlyDownloaded = __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, driveItem.id);
        var isReadable = false;
        switch (driveItem.type) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image:
                isReadable = true;
                break;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.ExternalLink:
                isReadable = isOnline;
                break;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Sound:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Component:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.File:
                isReadable = isOnline || isPersistentlyDownloaded;
                break;
            default:
                break;
        }
        return isReadable;
    };
    DriveItemUtils.isDownloadable = function (driveItem, downloadManager, sharedMethods) {
        var isDownloadableType = DriveItemUtils.isDownloadableItemType(driveItem);
        if (!isDownloadableType) {
            return false;
        }
        var isDesktop = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isDesktop();
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isMobileApp;
        var isSafariMobile = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isSafari() && (!isDesktop && !isMobileApp);
        var isOnline = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isOnline();
        var hasDownloadRights = DriveItemUtils.hasDownloadRights(sharedMethods);
        var isPersistentlyDownloaded = __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, driveItem.id);
        var isDownloadable = false;
        switch (driveItem.type) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.File:
                isDownloadable = isOnline && hasDownloadRights && (!isMobileApp || !isPersistentlyDownloaded);
                break;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Sound:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication:
                // Safari Mobile opens assets instead of downloading them
                isDownloadable = isOnline && hasDownloadRights && (!isMobileApp || !isPersistentlyDownloaded) && !isSafariMobile;
                break;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Component:
                isDownloadable = isOnline && hasDownloadRights && isMobileApp && !isPersistentlyDownloaded;
                break;
            default:
                break;
        }
        return isDownloadable;
    };
    DriveItemUtils.isUpdatable = function (driveItem, downloadManager, sharedMethods) {
        var isOnline = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isOnline();
        var hasDownloadRights = DriveItemUtils.hasDownloadRights(sharedMethods);
        var isPersistentlyDownloaded = __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, driveItem.id);
        var downloadedVersion = -1;
        if (isPersistentlyDownloaded) {
            downloadedVersion = downloadManager.items[driveItem.id].version;
        }
        var isUpdatable = isOnline
            && hasDownloadRights
            && isPersistentlyDownloaded
            && (driveItem.version > downloadedVersion || this.hasUpdatableDependencies(driveItem, downloadManager));
        return isUpdatable;
    };
    DriveItemUtils.hasUpdatableDependencies = function (driveItem, downloadManager) {
        var e_3, _a;
        var itemFromDownloadManager = driveItem && downloadManager.items[driveItem.id] ? downloadManager.items[driveItem.id] : undefined;
        if (!itemFromDownloadManager) {
            return false;
        }
        var dependencies = driveItem.dependencies;
        if (dependencies && dependencies.length > 0) {
            try {
                for (var dependencies_1 = __values(dependencies), dependencies_1_1 = dependencies_1.next(); !dependencies_1_1.done; dependencies_1_1 = dependencies_1.next()) {
                    var dependency = dependencies_1_1.value;
                    var downloadedDependency = downloadManager.items[dependency.id];
                    if (!downloadedDependency || dependency.version > downloadedDependency.version) {
                        return true;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (dependencies_1_1 && !dependencies_1_1.done && (_a = dependencies_1.return)) _a.call(dependencies_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return false;
    };
    DriveItemUtils.isDeletable = function (driveItem, downloadManager) {
        return __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].isRequestedItem(downloadManager, driveItem.id);
    };
    DriveItemUtils.hasDownloadRights = function (sharedMethods) {
        return sharedMethods !== undefined && sharedMethods.includes(__WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ShareMethod.Download);
    };
    DriveItemUtils.isShareable = function (sharedMethods, galleryConfig) {
        return sharedMethods !== undefined &&
            sharedMethods.includes(__WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ShareMethod.Share) &&
            !__WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isMaster(galleryConfig);
    };
    DriveItemUtils.isPublication = function (_a) {
        var type = _a.type;
        return type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication;
    };
    DriveItemUtils.isProposal = function (format) {
        return !!format && [
            __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.PDF_EDITABLE,
            __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB_EDITABLE,
            __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB_MASTER,
        ].includes(format);
    };
    DriveItemUtils.isMasterProposal = function (format) {
        return format === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB_MASTER;
    };
    DriveItemUtils.isDraftProposal = function (driveItem) {
        var format = driveItem.format, proposalStats = driveItem.proposalStats;
        return DriveItemUtils.isProposal(format) &&
            !!proposalStats &&
            proposalStats.status === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ProposalStatus.DRAFT;
    };
    DriveItemUtils.isSentProposal = function (driveItem) {
        var format = driveItem.format, proposalStats = driveItem.proposalStats;
        return DriveItemUtils.isProposal(format) &&
            !!proposalStats &&
            proposalStats.status === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ProposalStatus.SENT;
    };
    DriveItemUtils.isEditableProposal = function (driveItem) {
        var format = driveItem.format, proposalStats = driveItem.proposalStats;
        var isProposal = DriveItemUtils.isProposal(format);
        return isProposal &&
            !!proposalStats &&
            proposalStats.editable &&
            !DriveItemUtils.isForbiddenForUpdateProposal(driveItem);
    };
    DriveItemUtils.isForbiddenForUpdateProposal = function (driveItem) {
        var format = driveItem.format, proposalStats = driveItem.proposalStats;
        var isProposal = DriveItemUtils.isProposal(format);
        return isProposal && !!proposalStats && proposalStats.forbiddenUpdate;
    };
    DriveItemUtils.isMasterPublication = function (format) {
        return format === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB_PUBLI_MASTER;
    };
    DriveItemUtils.isModifiablePublication = function (format) {
        return format === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB_MODIFIABLE;
    };
    DriveItemUtils.isEditable = function (driveItem, isAccountManagerOrAdmin, isPrivateDirDescendant) {
        var format = driveItem.format, componentType = driveItem.componentType;
        var isPresentation = format === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB_PRESENTATION;
        var isEditableComponent = componentType === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ComponentType.ZIP_EDITABLE;
        var isEpubPublication = !!format && format.includes(__WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].PublicationFormat.EPUB);
        if (!isAccountManagerOrAdmin && isPrivateDirDescendant === false) {
            return false;
        }
        if (isAccountManagerOrAdmin && isEpubPublication) {
            return !DriveItemUtils.isProposal(format) ||
                DriveItemUtils.isMasterProposal(format) ||
                DriveItemUtils.isEditableProposal(driveItem);
        }
        return DriveItemUtils.isEditableProposal(driveItem)
            || DriveItemUtils.isModifiablePublication(format)
            || isPresentation
            || isEditableComponent
            || __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isEmbedMode();
    };
    DriveItemUtils.isUnread = function (driveList, readStatus, id) {
        var driveItems = driveList.driveItems;
        var readItems = readStatus.items;
        return readItems[id] ? driveItems[id].version > readItems[id].lastVersionRead : true;
    };
    DriveItemUtils.isValidResourceForPublication = function (_a) {
        var type = _a.type, name = _a.name, componentType = _a.componentType;
        var resourceTypes = [
            __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image,
            __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Movie,
            __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication,
        ];
        var fileExtension = name ? "." + __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(name) : '';
        // we have to set isValidFile to true to fetch content-block before we know 'name' of resource
        var isValidFile = type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.File && (!name
            ? true
            : DriveItemUtils.publicationExtensions.includes(fileExtension));
        // we have to set isValidComponent to true to fetch content-block before we know 'componentType' of resource
        var isValidComponent = type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Component && (!componentType
            ? true
            : ![__WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ComponentType.ZIP, __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ComponentType.ZIP_EDITABLE].includes(componentType));
        return resourceTypes.includes(type) || isValidFile || isValidComponent;
    };
    DriveItemUtils.isValidResourceForPlaylist = function (_a) {
        var format = _a.format;
        return !!format && [PublicationFormat.EPUB, PublicationFormat.EPUB_PRESENTATION, PublicationFormat.EPUB_PUBLI_MASTER, PublicationFormat.EPUB_MODIFIABLE].includes(format);
    };
    DriveItemUtils.convertDisplayTypeFormat = function (aspDisplayType) {
        switch (aspDisplayType) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AspFolderDisplayType.List:
                return __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AspFolderDisplayType.Masonry:
                return __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AspFolderDisplayType.Coverflow:
                return __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AspFolderDisplayType.Grid:
            default:
                return __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid;
        }
    };
    DriveItemUtils.isDirDescendantOf = function (folderId, ancestorDirId, driveItems) {
        if (!folderId || !ancestorDirId || !driveItems[folderId]) {
            return false;
        }
        if (folderId === ancestorDirId) {
            return true;
        }
        var parentId = DriveItemUtils.getParentFolderId(driveItems[folderId]);
        return DriveItemUtils.isDirDescendantOf(parentId, ancestorDirId, driveItems);
    };
    DriveItemUtils.getDriveItemChildren = function (driveItemId) {
        var driveItems = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState().driveList.driveItems;
        var driveItem = driveItems[driveItemId];
        var children = [driveItemId];
        if (driveItem.resources) {
            children = children.concat.apply(children, __spread(driveItem.resources.map(function (resource) { return DriveItemUtils.getDriveItemChildren(resource.id); })));
        }
        return children;
    };
    DriveItemUtils.imageExtensions = ['.webp', '.jpg', '.jpeg', '.png', '.gif'];
    DriveItemUtils.imageWithSvgExtensions = __spread(DriveItemUtils.imageExtensions, ['.svg']);
    // it's possible to set a pdf as image (e.g., in editor); conversion is done on server
    DriveItemUtils.imageWithPdfExtensions = __spread(DriveItemUtils.imageWithSvgExtensions, ['.pdf']);
    DriveItemUtils.imageWithGifExtensions = __spread(DriveItemUtils.imageWithSvgExtensions, ['.gif']);
    DriveItemUtils.videoExtensions = ['.mp4', '.webm', '.avi', '.mov'];
    DriveItemUtils.publicationExtensions = ['.pdf', '.epub', '.ppt', '.pptx', '.doc', '.docx', '.otp', '.odt'];
    DriveItemUtils.componentExtensions = ['.zip'];
    DriveItemUtils.getThumbnailDescriptor = function (driveItem, isBox, offlineManager, config, resolutions, displayType) {
        if (__WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isMobileApp) {
            var thumbMap = offlineManager.thumbMap;
            var driveItemStatus = thumbMap[driveItem.id];
            if (driveItemStatus && driveItemStatus.status === __WEBPACK_IMPORTED_MODULE_2__containers_OfflineManager_reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                // Use local thumbnail if downloaded
                var src = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getDeviceThumbnailPath(config, thumbMap, driveItem, resolutions, false);
                return { isImage: true, src: src };
            }
            else if (DriveItemUtils.hasIcon(driveItem)) {
                // Fallback to online thumbnail if not downloaded yet but has icon
                var src = DriveItemUtils.getThumbnail(driveItem, config, resolutions, isBox, displayType);
                var icon = driveItem.icon;
                var fallbackSrc = '';
                if (icon) {
                    fallbackSrc = __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(icon, config);
                }
                return { isImage: true, src: src, fallbackSrc: fallbackSrc };
            }
        }
        else if (DriveItemUtils.hasIcon(driveItem)) {
            var src = DriveItemUtils.getThumbnail(driveItem, config, resolutions, isBox, displayType);
            var icon = driveItem.icon;
            var fallbackSrc = '';
            if (icon) {
                fallbackSrc = __WEBPACK_IMPORTED_MODULE_5__url__["b" /* default */].getUrlFromRelUrlWithMediaParam(icon, config);
            }
            return { isImage: true, src: src, fallbackSrc: fallbackSrc };
        }
        if (driveItem.type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory) {
            var defaultFolderIcon = DriveItemUtils.getDefaultFolderIcon();
            if (defaultFolderIcon) {
                var src = DriveItemUtils.getDefaultFolderIconPath(defaultFolderIcon);
                return { isImage: true, src: src };
            }
        }
        return { isImage: false, src: DriveItemUtils.getDefaultThumbnail(driveItem) };
    };
    DriveItemUtils.getDisplayType = function (driveList, routerParamsHistory, folderId) {
        var foldersDisplayType = driveList.foldersDisplayType, storeDisplayType = driveList.displayType;
        var _a = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getState(), applicationGallery = _a.galleryInfos.config.applicationGallery, driveItems = _a.driveList.driveItems;
        // handle displayType of New, Downloads, Selection and Search folders
        var folderIdOrOrigin = folderId || __WEBPACK_IMPORTED_MODULE_11__routes__["a" /* default */].getCurrentOrigin(routerParamsHistory);
        // high priority: displayMode which is set inside folder via displayType dropdown
        if (foldersDisplayType[folderIdOrOrigin]) {
            return foldersDisplayType[folderIdOrOrigin];
        }
        // middle priority: displayMode which is set in Parameters page (except Default)
        if (storeDisplayType !== __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Default) {
            return storeDisplayType;
        }
        // low priority: displayMode which is set in backoffice
        if (driveList.driveItems[folderIdOrOrigin]) {
            var aspDisplayType = driveList.driveItems[folderIdOrOrigin].displayMode;
            if (aspDisplayType) {
                return DriveItemUtils.convertDisplayTypeFormat(aspDisplayType);
            }
        }
        // low priority: use root folder displayMode if no other override is set
        if (driveItems[applicationGallery] && driveItems[applicationGallery].displayMode) {
            var displayMode = driveItems[applicationGallery].displayMode;
            return DriveItemUtils.convertDisplayTypeFormat(displayMode);
        }
        // fallback
        return __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid;
    };
    DriveItemUtils.getContextualMenuButtons = function (driveItem, state) {
        var _a, _b, _c;
        var isDownloadable = false;
        var isDownloading = false;
        var isDownloadInProgress = false;
        var hasDownloadErrors = false;
        var isUpdatable = false;
        var isDeletable = false;
        var isAvailableOffline = false;
        var isShareable = false;
        var isEditable = false;
        var isPublicationCopyable = false;
        var isProposalCopyable = false;
        var isProposalNotCopyable = false;
        var isProposalArchivable = false;
        var isRenamable = false;
        var isDeletableFromAsp = false;
        var isCompatibleForTemplate = false;
        var isCustomTemplate = false;
        var isCoverImageEditable = false;
        var isCheckForUpdatePossible = false;
        var isCopyableAsProposal = false;
        var driveList = state.driveList, driveItems = state.driveList.driveItems, customTemplatesIds = state.publicationCreator.fromTemplate.customTemplatesIds, downloadManager = state.downloadManager, _d = state.galleryInfos, config = _d.config, _e = _d.template, sharedMethods = _e.sharedMethods, _f = _e.contextMenuOptions, _g = (_f === void 0 ? {} : _f).alwaysHidden, alwaysHidden = _g === void 0 ? [__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].CreateProposal, __WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].CreateCustomizedProposal] : _g, menuModes = state.menuManager.menuModes, profile = state.profile;
        var isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_14__containers_ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(state);
        var privateDirId = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getPrivateDirId(driveList, config);
        var archiveDirId = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getArchiveDirId(driveList, config);
        var sourceDirId = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getSourcesDirId(driveList, config);
        var sharedDirId = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getSharedDirId(driveList, config);
        // needed in the case an asset is deletedFromAsp while context menu is opened
        if (driveItem) {
            isCustomTemplate = customTemplatesIds.includes(driveItem.id);
            if (isCustomTemplate) {
                return _a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].RemoveTemplate] = true,
                    _a;
            }
            isDownloading = __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].isItemDownloading(downloadManager, driveItem.id);
            isDownloadInProgress = __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].isItemDownloadingInProgress(downloadManager, driveItem.id);
            isDownloadable = DriveItemUtils.isDownloadable(driveItem, downloadManager, sharedMethods) && !isDownloadInProgress;
            isUpdatable = DriveItemUtils.isUpdatable(driveItem, downloadManager, sharedMethods);
            isDeletable = DriveItemUtils.isDeletable(driveItem, downloadManager);
            hasDownloadErrors = __WEBPACK_IMPORTED_MODULE_6__downloadManager__["a" /* default */].hasDownloadErrors(downloadManager, driveItem.id);
            isAvailableOffline = isDeletable && !hasDownloadErrors && !isDownloading;
            isShareable = DriveItemUtils.isShareable(sharedMethods, config);
            isCheckForUpdatePossible = __WEBPACK_IMPORTED_MODULE_4__userAgent__["a" /* default */].isMobileApp;
            if (__WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isReadOnlyApp(profile.role)) {
                return _b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Download] = isDownloadable,
                    _b[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Update] = isUpdatable,
                    _b[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Delete] = isAvailableOffline,
                    _b[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Share] = isShareable,
                    _b[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].CheckForUpdate] = isCheckForUpdatePossible,
                    _b;
            }
            var isPrivateDirDescendant = DriveItemUtils.isDirDescendantOf(driveItem.id, privateDirId, driveItems);
            var isArchiveDirDescendant = DriveItemUtils.isDirDescendantOf(driveItem.id, archiveDirId, driveItems);
            isEditable = DriveItemUtils.isEditable(driveItem, isAccountManagerOrAdmin, isPrivateDirDescendant);
            var isPublication = DriveItemUtils.isPublication(driveItem);
            var isProposal = DriveItemUtils.isProposal(driveItem.format);
            var isDraftProposal = DriveItemUtils.isDraftProposal(driveItem);
            var isSentProposal = DriveItemUtils.isSentProposal(driveItem);
            var isMasterProposal = DriveItemUtils.isMasterProposal(driveItem.format);
            var isMasterPublication = DriveItemUtils.isMasterPublication(driveItem.format);
            var isDeletableFromAspAssetType = !(isProposal || isMasterPublication) ||
                isDraftProposal ||
                isSentProposal ||
                DriveItemUtils.isModifiablePublication(driveItem.format);
            var hasTemplatesOptionInCreateBtn = Object.values(menuModes).some(function (menuPosition) { return (menuPosition.some(function (menuItem) { return (menuItem.type === __WEBPACK_IMPORTED_MODULE_12__typings_menu__["b" /* MenuItemType */].CreateButton &&
                menuItem.options.includes(__WEBPACK_IMPORTED_MODULE_12__typings_menu__["a" /* CreateButtonOption */].publicationFromTemplate)); })); });
            var isSystemFolder = [sourceDirId, sharedDirId].includes(driveItem.id);
            isPublicationCopyable = isMasterPublication ||
                (isAccountManagerOrAdmin && DriveItemUtils.isModifiablePublication(driveItem.format));
            isProposalCopyable = isProposal && !DriveItemUtils.isForbiddenForUpdateProposal(driveItem);
            isProposalNotCopyable = isProposal && DriveItemUtils.isForbiddenForUpdateProposal(driveItem);
            isProposalArchivable = !!archiveDirId &&
                (isAccountManagerOrAdmin || isPrivateDirDescendant) &&
                !isArchiveDirDescendant &&
                isProposal && !isDraftProposal && !isSentProposal && !isMasterProposal;
            isRenamable = !isSystemFolder &&
                (isAccountManagerOrAdmin || isPrivateDirDescendant || isArchiveDirDescendant);
            isDeletableFromAsp = isDeletableFromAspAssetType &&
                (isAccountManagerOrAdmin || isPrivateDirDescendant) &&
                !isSystemFolder;
            isCompatibleForTemplate = hasTemplatesOptionInCreateBtn && DriveItemUtils.isValidResourceForPublication(driveItem);
            isCoverImageEditable = isAccountManagerOrAdmin || isPrivateDirDescendant;
            isCopyableAsProposal = isPublication;
        }
        return DriveItemUtils.hideContextualMenuOptions((_c = {},
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Download] = isDownloadable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Update] = isUpdatable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Delete] = isAvailableOffline,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Share] = isShareable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].ShareWithUser] = isEditable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Edit] = isEditable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].PublicationSaveAs] = isPublicationCopyable || isProposalCopyable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].ProposalNoSaveAs] = isProposalNotCopyable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Rename] = isRenamable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].DeleteFromAsp] = isDeletableFromAsp,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].Archive] = isProposalArchivable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].SetAsTemplate] = isCompatibleForTemplate,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].EditCoverImage] = isCoverImageEditable,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].CheckForUpdate] = isCheckForUpdatePossible,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].CreateProposal] = isCopyableAsProposal,
            _c[__WEBPACK_IMPORTED_MODULE_13__components_ContextualMenu_constants__["a" /* ContextualMenuItemType */].CreateCustomizedProposal] = isCopyableAsProposal,
            _c), alwaysHidden);
    };
    DriveItemUtils.hideContextualMenuOptions = function (contextualMenuButtons, hiddenOptions) {
        var newContextualMenuButtons = __assign({}, contextualMenuButtons);
        hiddenOptions.forEach(function (hiddenOption) {
            newContextualMenuButtons[hiddenOption] = false;
        });
        return newContextualMenuButtons;
    };
    DriveItemUtils.isEmptyContextualMenu = function (driveItem, state) {
        return Object.values(DriveItemUtils.getContextualMenuButtons(driveItem, state)).every(function (button) { return !button; });
    };
    DriveItemUtils.getParentFolderId = function (_a) {
        var linkParentId = _a.linkParentId, parent = _a.parent;
        return linkParentId || parent;
    };
    DriveItemUtils.getRootDirIdForEditMode = function (state) {
        var config = state.galleryInfos.config, driveList = state.driveList;
        var isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_14__containers_ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(state);
        var privateDirId = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getPrivateDirId(driveList, config);
        return isAccountManagerOrAdmin ? config.applicationGallery : privateDirId;
    };
    DriveItemUtils.sanitizeForCSS = function (name) {
        return name.replace(/[^a-zA-Z0-9]/g, function (s) {
            switch (s) {
                case ' ':
                    return '-';
                case '/':
                    return '-or-';
                case '~':
                    return '_';
                default:
                    return s.charCodeAt(0).toString();
            }
        });
    };
    DriveItemUtils.getItemClassName = function (mainClassName, driveItem, tagClasses) {
        var e_4, _a;
        if (!driveItem) {
            return mainClassName;
        }
        var className = mainClassName + " itemType-" + driveItem.type;
        if (driveItem.id) {
            className += " itemId-" + driveItem.id;
        }
        if (driveItem.tags) {
            try {
                for (var _b = __values(driveItem.tags), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var tag = _c.value;
                    if (tagClasses && tagClasses.includes(tag)) {
                        className += " itemTag-" + DriveItemUtils.sanitizeForCSS(tag);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        return className;
    };
    return DriveItemUtils;
}());

/* harmony default export */ __webpack_exports__["d"] = (DriveItemUtils);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return runCallbackAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DriveItemListActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DriveItemOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchDriveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchContentBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return resetFetchAllStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getAllDriveItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getOrFetchDriveItemMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return receiveTemplateItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return receiveDriveItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return receiveResolutions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return updateListDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return updateDriveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return openContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return closeContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return lockContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return unlockContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return viewableInGallery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return viewDriveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return resolveParentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return setReadStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return setBreadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return resetBreadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return updateDriveItemName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return toggleEditMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return removeDriveItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return moveDriveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return moveDriveItemInFolder; });
/* unused harmony export resetDriveOrder */
/* unused harmony export setLoadingStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return setFolderDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return setFoldersDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return resetFoldersDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCustomTemplatesIds; });
/* unused harmony export setCustomTemplatesIds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addCustomTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return removeCustomTemplate; });
/* unused harmony export updateLastFolderTreeUpdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteFromAsp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return archiveProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getAspDriveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return updateFolderTree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReadStatus_actions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__BackToPublication_actions__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_indexedDB_manager__ = __webpack_require__(21);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var _this = this;



























var DriveItemListActionKeys;
(function (DriveItemListActionKeys) {
    DriveItemListActionKeys["REQUEST_DRIVE_META"] = "@@driveList/REQUEST_DRIVE_META";
    DriveItemListActionKeys["RECEIVE_DRIVE_META"] = "@@driveList/RECEIVE_DRIVE_META";
    DriveItemListActionKeys["FETCH_ERROR_DRIVE_META"] = "@@driveList/FETCH_ERROR_DRIVE_META";
    DriveItemListActionKeys["REQUEST_CONTENT_BLOCK"] = "@@driveList/REQUEST_CONTENT_BLOCK";
    DriveItemListActionKeys["RECEIVE_CONTENT_BLOCK"] = "@@driveList/RECEIVE_CONTENT_BLOCK";
    DriveItemListActionKeys["FETCH_ERROR_CONTENT_BLOCK"] = "@@driveList/FETCH_ERROR_CONTENT_BLOCK";
    DriveItemListActionKeys["RECEIVE_DRIVE_ITEMS"] = "@@driveList/RECEIVE_DRIVE_ITEMS";
    DriveItemListActionKeys["REMOVE_DRIVE_ITEMS"] = "@@driveList/REMOVE_DRIVE_ITEMS";
    DriveItemListActionKeys["RECEIVE_RESOLUTIONS"] = "@@driveList/RECEIVE_RESOLUTIONS";
    DriveItemListActionKeys["UPDATE_LIST_DISPLAY_TYPE"] = "@@driveList/UPDATE_LIST_DISPLAY_TYPE";
    DriveItemListActionKeys["UPDATE_DRIVE_ITEM"] = "@@driveList/UPDATE_DRIVE_ITEM";
    DriveItemListActionKeys["RESET_FETCH_ALL_STATUS"] = "@@driveList/RESET_FETCH_ALL_STATUS";
    DriveItemListActionKeys["REQUEST_ALL"] = "@@driveList/REQUEST_ALL";
    DriveItemListActionKeys["RECEIVE_ALL"] = "@@driveList/RECEIVE_ALL";
    DriveItemListActionKeys["OPEN_CONTEXTUAL_MENU"] = "@@driveList/OPEN_CONTEXTUAL_MENU";
    DriveItemListActionKeys["CLOSE_CONTEXTUAL_MENU"] = "@@driveList/CLOSE_CONTEXTUAL_MENU";
    DriveItemListActionKeys["LOCK_CONTEXTUAL_MENU"] = "@@driveList/LOCK_CONTEXTUAL_MENU";
    DriveItemListActionKeys["UNLOCK_CONTEXTUAL_MENU"] = "@@driveList/UNLOCK_CONTEXTUAL_MENU";
    DriveItemListActionKeys["SET_BREADCRUMBS"] = "@@driveList/SET_BREADCRUMBS";
    DriveItemListActionKeys["RESET_BREADCRUMBS"] = "@@driveList/RESET_BREADCRUMBS";
    DriveItemListActionKeys["TOGGLE_EDIT_MODE"] = "@@driveList/TOGGLE_EDIT_MODE";
    DriveItemListActionKeys["MOVE_DRIVE_ITEM"] = "@@driveList/MOVE_DRIVE_ITEM";
    DriveItemListActionKeys["MOVE_DRIVE_ITEM_IN_FOLDER"] = "@@driveList/MOVE_DRIVE_ITEM_IN_FOLDER";
    DriveItemListActionKeys["RESET_DRIVE_ORDER"] = "@@driveList/RESET_DRIVE_ORDER";
    DriveItemListActionKeys["SET_LOADING_STATUS"] = "@@driveList/SET_LOADING_STATUS";
    DriveItemListActionKeys["SET_FOLDER_DISPLAY_TYPE"] = "@@driveList/SET_FOLDER_DISPLAY_TYPE";
    DriveItemListActionKeys["SET_FOLDERS_DISPLAY_TYPE"] = "@@driveList/SET_FOLDERS_DISPLAY_TYPE";
    DriveItemListActionKeys["RESET_FOLDERS_DISPLAY_TYPE"] = "@@driveList/RESET_FOLDERS_DISPLAY_TYPE";
    DriveItemListActionKeys["SET_CUSTOM_TEMPLATES_IDS"] = "@@driveList/SET_CUSTOM_TEMPLATES_IDS";
    DriveItemListActionKeys["ADD_CUSTOM_TEMPLATE"] = "@@driveList/ADD_CUSTOM_TEMPLATE";
    DriveItemListActionKeys["REMOVE_CUSTOM_TEMPLATE"] = "@@driveList/REMOVE_CUSTOM_TEMPLATE";
    DriveItemListActionKeys["START_FOLDER_TREE_UPDATE"] = "@@driveList/START_FOLDER_TREE_UPDATE";
    DriveItemListActionKeys["END_FOLDER_TREE_UPDATE"] = "@@driveList/END_FOLDER_TREE_UPDATE";
    DriveItemListActionKeys["SET_LAST_FOLDER_TREE_UPDATE"] = "@@driveList/SET_LAST_FOLDER_TREE_UPDATE";
})(DriveItemListActionKeys || (DriveItemListActionKeys = {}));
var DriveItemOrigin;
(function (DriveItemOrigin) {
    DriveItemOrigin["List"] = "list";
    DriveItemOrigin["Details"] = "details";
    DriveItemOrigin["Menu"] = "menu";
})(DriveItemOrigin || (DriveItemOrigin = {}));
var ActionType;
(function (ActionType) {
    ActionType["NONE"] = "none";
    ActionType["VIEW_DRIVE_ITEM"] = "viewDriveItem";
    ActionType["SAML_LOGIN"] = "SAMLLogin";
    ActionType["SHARE"] = "share";
})(ActionType || (ActionType = {}));
var fetchDriveItem = function (driveItemId, driveFolderId, forceFetch) {
    return function (dispatch, getState) {
        var driveList = getState().driveList;
        if (!driveList.driveItems[driveItemId]) {
            if (driveFolderId && driveList.driveItems[driveFolderId]) {
                var driveFolder = driveList.driveItems[driveFolderId];
                var resource = driveFolder.resources ? driveFolder.resources.filter(function (resource) { return resource.id === driveItemId; })[0] : undefined;
                if (resource) {
                    return dispatch(fetchContentBlock(driveFolderId, resource.block, forceFetch));
                }
            }
            return dispatch(getOrFetchDriveItemMeta(driveItemId));
        }
        return Promise.resolve(driveList.driveItems[driveItemId]);
    };
};
var resetFetchAllStatus = function () { return ({
    type: DriveItemListActionKeys.RESET_FETCH_ALL_STATUS,
}); };
var getAllDriveItemsPromise;
var getAllDriveItems = function () { return function (dispatch, getState) {
    var _a = getState(), driveList = _a.driveList, galleryInfos = _a.galleryInfos;
    if (driveList.fetchAllFetchStatus === __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* FetchStatus */].NOT_FETCHED) {
        dispatch({ type: DriveItemListActionKeys.REQUEST_ALL });
        var applicationGallery_1 = galleryInfos.config.applicationGallery;
        var initChildrenPromise = dispatch(initChildren());
        getAllDriveItemsPromise = initChildrenPromise
            .then(function () {
            dispatch({ type: DriveItemListActionKeys.RECEIVE_ALL });
            dispatch(updateLastFolderTreeUpdate());
            dispatch(endFolderTreeUpdate());
            var driveItems = getState().driveList.driveItems;
            return Object.keys(driveItems)
                .map(function (id) { return parseInt(id, 10); })
                .filter(function (id) { return id !== applicationGallery_1; });
        });
    }
    return getAllDriveItemsPromise;
}; };
var initChildren = function () { return function (dispatch, getState) {
    var _a = getState(), appInfos = _a.appInfos, clientId = _a.galleryInfos.config.clientId;
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].isMultiApp(appInfos);
    if (isMultiApp) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__ProfilePage_actions__["e" /* getProfileData */])(clientId))
            .then(function () {
            return __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getAppMeta()
                .then(function (appMeta) {
                if (appMeta) {
                    return dispatch(receiveNestedDriveItems(appMeta.app))
                        .then(function () { return appMeta.sharedDir && dispatch(receiveNestedDriveItems(appMeta.sharedDir)); });
                }
                return {};
            });
        });
    }
    return __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getChildrenMeta()
        .then(function (childrenMeta) {
        if (childrenMeta) {
            return dispatch(receiveNestedDriveItems(childrenMeta));
        }
        return {};
    });
}; };
var receiveNestedDriveItems = function (nestedDriveItems) {
    return function (dispatch) {
        return dispatch(receiveDriveItemFullMeta(nestedDriveItems))
            .then(function () {
            var _a = nestedDriveItems.resources, resources = _a === void 0 ? [] : _a;
            // Process resources in batches to avoid blocking the UI thread
            // Smaller batch size (5) ensures UI remains responsive even with deeply nested structures
            // This allows user interactions to be processed between batches
            return processResourcesInBatches(resources, dispatch, 5);
        });
    };
};
// Process resources in batches with yields to the event loop to keep UI responsive
// Smaller batches (5 items) ensure UI remains responsive even with deeply nested structures
// We also yield after processing each item within a batch to maximize responsiveness
var processResourcesInBatches = function (resources, dispatch, batchSize) {
    if (batchSize === void 0) { batchSize = 5; }
    if (resources.length === 0) {
        return Promise.resolve({});
    }
    // Process first batch with yields between items
    var batch = resources.slice(0, batchSize);
    var remaining = resources.slice(batchSize);
    // Process batch items sequentially with yields to maximize UI responsiveness
    var processBatchSequentially = function (items, index) {
        if (index === void 0) { index = 0; }
        if (index >= items.length) {
            return Promise.resolve({});
        }
        return dispatch(receiveNestedDriveItems(items[index]))
            .then(function () {
            // Yield to event loop after each item to allow UI interactions
            return new Promise(function (resolve) {
                setTimeout(function () {
                    resolve(processBatchSequentially(items, index + 1));
                }, 0);
            });
        });
    };
    if (remaining.length === 0) {
        // Last batch, process sequentially with yields
        return processBatchSequentially(batch);
    }
    // Process current batch sequentially, then yield before processing next batch
    return processBatchSequentially(batch)
        .then(function () {
        // Additional yield before processing next batch
        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve(processResourcesInBatches(remaining, dispatch, batchSize));
            }, 0);
        });
    });
};
var receiveDriveItemFullMeta = function (nestedDriveItems) {
    return function (dispatch) {
        var _a;
        // clone nestedDriveItems but removes resolutions
        var resolutions = nestedDriveItems.resolutions, nestedDriveItemsWithoutResolutions = __rest(nestedDriveItems, ["resolutions"]);
        var resources;
        if (nestedDriveItems.resources) {
            var nestedDriveItemsResources = nestedDriveItems.resources;
            resources = nestedDriveItemsResources.map(function (_a) {
                var id = _a.id, type = _a.type, position = _a.position, format = _a.format;
                return ({
                    id: id,
                    type: type,
                    position: position,
                    format: format,
                });
            });
        }
        var driveItem = __assign({}, nestedDriveItemsWithoutResolutions, { resources: resources });
        dispatch(receiveDriveItems((_a = {},
            _a[driveItem.id] = driveItem,
            _a)));
        if (resolutions) {
            dispatch(receiveResolutions(resolutions));
        }
        return Promise.resolve();
    };
};
var canMetaBeFetched = function (metaFetchStatus, forceFetch) {
    return metaFetchStatus === __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* FetchStatus */].NOT_FETCHED
        || forceFetch && metaFetchStatus === __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* FetchStatus */].FETCHED;
};
var getOrFetchDriveItemMeta = function (driveItemId, isInGallery, isAsync, forceFetch) {
    if (isInGallery === void 0) { isInGallery = true; }
    if (isAsync === void 0) { isAsync = true; }
    if (forceFetch === void 0) { forceFetch = false; }
    return function (dispatch, getState) {
        var _a = getState(), driveList = _a.driveList, galleryInfos = _a.galleryInfos;
        var galleryId = galleryInfos.config.applicationGallery;
        var metaFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_2__reducer__["c" /* getDriveItemStatusFromMap */])(driveList.driveItemsFetchStatus, driveItemId).metaFetchStatus;
        var driveItemMeta = driveList.driveItems[driveItemId];
        var isItemFetched = !forceFetch && driveItemMeta && metaFetchStatus === __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* FetchStatus */].FETCHED;
        if (isItemFetched) {
            return Promise.resolve(driveItemMeta);
        }
        if (canMetaBeFetched(metaFetchStatus, forceFetch) && __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isOnline()) {
            dispatch(requestDriveItemMeta(driveItemId));
            return __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getMeta(driveItemId, isAsync)
                .then(function (driveItem) {
                var _a;
                if (driveItem.resolutions) {
                    dispatch(receiveResolutions(driveItem.resolutions));
                }
                dispatch(receiveDriveItems((_a = {}, _a[driveItem.id] = driveItem, _a), isInGallery)).then();
                dispatch(receiveDriveItemMeta(driveItemId));
                if (driveItem.id === galleryId) {
                    dispatch(setAppDisplayType()).then();
                }
                return dispatch(fetchItemIconMeta(driveItem))
                    .then(function () { return driveItem; });
            })
                .catch(function (error) {
                dispatch(fetchErrorDriveItemMeta(driveItemId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.fetch_content_error', { id: driveItemId }));
                return Promise.reject({});
            });
        }
        return Promise.resolve(driveItemMeta || {});
    };
};
var requestDriveItemMeta = function (driveItemId) { return ({
    driveItemId: driveItemId,
    type: DriveItemListActionKeys.REQUEST_DRIVE_META
}); };
var receiveDriveItemMeta = function (driveItemId) { return ({
    driveItemId: driveItemId,
    type: DriveItemListActionKeys.RECEIVE_DRIVE_META
}); };
var fetchErrorDriveItemMeta = function (driveItemId) { return ({
    driveItemId: driveItemId,
    type: DriveItemListActionKeys.FETCH_ERROR_DRIVE_META
}); };
var canDriveListBeFetched = function (driveList, block) {
    return block !== undefined && (!driveList.contentBlocksStatus[block] || driveList.contentBlocksStatus[block] === __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* FetchStatus */].NOT_FETCHED);
};
var fetchContentBlock = function (driveFolderId, block, forceFetch) {
    if (block === void 0) { block = 1; }
    if (forceFetch === void 0) { forceFetch = false; }
    return function (dispatch, getState) {
        var driveList = getState().driveList;
        var driveFolder = driveList.driveItems[driveFolderId];
        var driveItemList = Object(__WEBPACK_IMPORTED_MODULE_2__reducer__["c" /* getDriveItemStatusFromMap */])(driveList.driveItemsFetchStatus, driveFolderId);
        if (driveFolder && (forceFetch || canDriveListBeFetched(driveItemList, block))) {
            var resolutionsBlock = driveFolder.resolutionsBlock;
            // If the first block is not already loaded, we load it, because it contains the resolution
            if (block !== resolutionsBlock && canDriveListBeFetched(driveItemList, resolutionsBlock)) {
                dispatch(fetchContentBlock(driveFolderId, resolutionsBlock));
            }
            dispatch(requestContentBlock(driveFolderId, block));
            return __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getContentBlock(driveFolderId, block)
                .then(function (json) {
                if (json.resolutions) {
                    // Only store default resolution if we have not stored it yet
                    // Will cause problem if the first folder fetched has custom resolution
                    if (driveList.resolutions.default) {
                        delete json.resolutions.default;
                    }
                    dispatch(receiveResolutions(json.resolutions));
                }
                dispatch(receiveDriveItems(json.metas));
                // download thumbnails for newly imported files in mobile app
                if (__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp) {
                    var thumbMap_1 = getState().offlineManager.thumbMap;
                    Object.keys(json.metas)
                        .filter(function (id) { return (!Object.keys(thumbMap_1).includes(id) &&
                        json.metas[id].type !== __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory); })
                        .forEach(function (id) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__OfflineManager_actions__["e" /* downloadThumb */])(parseInt(id, 10), __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["a" /* DownloadPriority */].Normal, false));
                    });
                }
                var fetchIconMetasPromises = Object.keys(json.metas)
                    .map(function (id) { return dispatch(fetchItemIconMeta(json.metas[id], json.resolutions)); });
                return Promise.all(fetchIconMetasPromises)
                    .then(function () { return dispatch(receiveContentBlock(driveFolderId, json, block)); });
            })
                .catch(function (error) {
                dispatch(fetchErrorContentBlock(driveFolderId, block));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.fetch_content_block_error', { id: driveFolderId }));
                return {};
            });
        }
        return Promise.resolve({});
    };
};
var fetchItemIconMeta = function (driveItem, resolutions) {
    if (resolutions === void 0) { resolutions = undefined; }
    return function (dispatch) {
        var iconId = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getIconId(driveItem);
        if (iconId > 0 &&
            iconId !== driveItem.id &&
            __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].needsResolutions(driveItem) &&
            !__WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].hasIconMetadata(driveItem, resolutions)) {
            return dispatch(getOrFetchDriveItemMeta(iconId));
        }
        return Promise.resolve({});
    };
};
var requestContentBlock = function (driveFolderId, block) { return ({
    driveFolderId: driveFolderId,
    type: DriveItemListActionKeys.REQUEST_CONTENT_BLOCK,
    block: block
}); };
var receiveContentBlock = function (driveFolderId, json, block) {
    var metas = json.metas;
    var driveItems = [];
    Object.keys(metas).forEach(function (key) { return driveItems.push(metas[key]); });
    return ({
        driveFolderId: driveFolderId,
        type: DriveItemListActionKeys.RECEIVE_CONTENT_BLOCK,
        block: block
    });
};
var fetchErrorContentBlock = function (driveFolderId, block) { return ({
    driveFolderId: driveFolderId,
    type: DriveItemListActionKeys.FETCH_ERROR_CONTENT_BLOCK,
    block: block
}); };
var receiveTemplateItems = function (templateData) {
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var e_1, _a, e_2, _b, masterTemplates, customTemplates, resolutions, masterTemplates_1, masterTemplates_1_1, driveItem, e_1_1, customTemplates_1, customTemplates_1_1, driveItem, e_2_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    masterTemplates = templateData.masterProposals, customTemplates = templateData.customTemplates, resolutions = templateData.resolutions;
                    if (!(masterTemplates.length > 0)) return [3 /*break*/, 8];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, 7, 8]);
                    masterTemplates_1 = __values(masterTemplates), masterTemplates_1_1 = masterTemplates_1.next();
                    _c.label = 2;
                case 2:
                    if (!!masterTemplates_1_1.done) return [3 /*break*/, 5];
                    driveItem = masterTemplates_1_1.value;
                    return [4 /*yield*/, dispatch(updateTemplateDriveItem(driveItem, true))];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    masterTemplates_1_1 = masterTemplates_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (masterTemplates_1_1 && !masterTemplates_1_1.done && (_a = masterTemplates_1.return)) _a.call(masterTemplates_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8:
                    if (!(customTemplates.length > 0)) return [3 /*break*/, 16];
                    _c.label = 9;
                case 9:
                    _c.trys.push([9, 14, 15, 16]);
                    customTemplates_1 = __values(customTemplates), customTemplates_1_1 = customTemplates_1.next();
                    _c.label = 10;
                case 10:
                    if (!!customTemplates_1_1.done) return [3 /*break*/, 13];
                    driveItem = customTemplates_1_1.value;
                    return [4 /*yield*/, dispatch(updateTemplateDriveItem(driveItem, true))];
                case 11:
                    _c.sent();
                    _c.label = 12;
                case 12:
                    customTemplates_1_1 = customTemplates_1.next();
                    return [3 /*break*/, 10];
                case 13: return [3 /*break*/, 16];
                case 14:
                    e_2_1 = _c.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 16];
                case 15:
                    try {
                        if (customTemplates_1_1 && !customTemplates_1_1.done && (_b = customTemplates_1.return)) _b.call(customTemplates_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 16:
                    dispatch(receiveDriveItems(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].itemsToById(masterTemplates)));
                    dispatch(receiveDriveItems(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].itemsToById(customTemplates)));
                    dispatch(receiveResolutions(resolutions));
                    return [2 /*return*/];
            }
        });
    }); };
};
var updateTemplateDriveItem = function (driveItem, isTemplate) {
    if (isTemplate === void 0) { isTemplate = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var isDownloadableType, updatedDriveItem;
        return __generator(this, function (_a) {
            try {
                isDownloadableType = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].isDownloadableItemType(driveItem);
                if (isDownloadableType) {
                    updatedDriveItem = __assign({}, driveItem, { isTemplate: isTemplate });
                    dispatch(updateDriveItem(updatedDriveItem));
                }
            }
            catch (error) {
                console.error('Failed to update template drive item:', error);
            }
            return [2 /*return*/];
        });
    }); };
};
var receiveDriveItems = function (driveItems, isInGallery) {
    if (isInGallery === void 0) { isInGallery = true; }
    return function (dispatch) {
        return new Promise(function (resolve) {
            var resolvedIsInGallery = !__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp ? undefined : isInGallery;
            var action = {
                type: DriveItemListActionKeys.RECEIVE_DRIVE_ITEMS,
                driveItems: driveItems,
                isInGallery: resolvedIsInGallery,
            };
            dispatch(action);
            resolve();
        });
    };
};
var deleteFromAsp = function (clientId, driveItem) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var undeletableResources, resourcesNotDeleted_1, itemToTrashIds, itemDeletedIds, driveItems_1, parentId, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, 6, 7]);
                dispatch(setLoadingStatus(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].trashResources(clientId, [driveItem.id])];
            case 1:
                undeletableResources = (_a.sent()).undeletableResources;
                resourcesNotDeleted_1 = Object.keys(undeletableResources);
                itemToTrashIds = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getDriveItemChildren(driveItem.id);
                itemDeletedIds = itemToTrashIds.filter(function (driveItemId) { return !resourcesNotDeleted_1.includes(driveItemId.toString()); });
                driveItems_1 = getState().driveList.driveItems;
                itemDeletedIds
                    .map(function (itemDeletedId) { return driveItems_1[itemDeletedId]; })
                    .forEach((function (itemDeleted) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DownloadManager_actions__["c" /* deleteItem */])(itemDeleted)); }));
                dispatch(removeDriveItems(itemDeletedIds));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__Selection_actions__["e" /* removeFromSelection */])(itemDeletedIds));
                if (!(resourcesNotDeleted_1.length > 0)) return [3 /*break*/, 2];
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.asset_not_erasable'));
                return [3 /*break*/, 4];
            case 2:
                parentId = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getParentFolderId(driveItem);
                return [4 /*yield*/, dispatch(getOrFetchDriveItemMeta(parentId, true, true, true))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 7];
            case 5:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.cant_remove_asset'));
                return [3 /*break*/, 7];
            case 6:
                dispatch(setLoadingStatus(false));
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
var removeDriveItems = function (driveItemIds) { return ({
    type: DriveItemListActionKeys.REMOVE_DRIVE_ITEMS,
    driveItemIds: driveItemIds,
}); };
var receiveResolutions = function (resolutions) { return ({
    type: DriveItemListActionKeys.RECEIVE_RESOLUTIONS,
    resolutions: resolutions
}); };
var updateDriveItem = function (item) { return ({
    type: DriveItemListActionKeys.UPDATE_DRIVE_ITEM,
    item: item,
}); };
var openContextualMenu = function (driveItemId) { return ({
    type: DriveItemListActionKeys.OPEN_CONTEXTUAL_MENU,
    driveItemId: driveItemId,
}); };
var closeContextualMenu = function () { return ({
    type: DriveItemListActionKeys.CLOSE_CONTEXTUAL_MENU,
}); };
var lockContextualMenu = function () { return ({
    type: DriveItemListActionKeys.LOCK_CONTEXTUAL_MENU,
}); };
var unlockContextualMenu = function () { return ({
    type: DriveItemListActionKeys.UNLOCK_CONTEXTUAL_MENU,
}); };
var updateDriveItemName = function (assetId, newLabel) {
    return function (dispatch, getState) {
        var driveItems = getState().driveList.driveItems;
        var renamedResource = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].deepCopy(driveItems[assetId]);
        renamedResource.label = newLabel;
        dispatch(updateDriveItem(renamedResource));
    };
};
var updateListDisplayType = function (displayType) {
    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_24__utils_indexedDB_manager__["a" /* default */].setDisplayType(displayType).then();
        dispatch({
            type: DriveItemListActionKeys.UPDATE_LIST_DISPLAY_TYPE,
            displayType: displayType
        });
        __WEBPACK_IMPORTED_MODULE_15__utils_statistics__["a" /* default */].trackDisplayType(displayType);
    };
};
var setReadStatus = function (driveItemId) { return function (dispatch, getState) {
    var _a = getState(), driveList = _a.driveList, readStatus = _a.readStatus;
    var isUnread = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].isUnread(driveList, readStatus, driveItemId);
    if (isUnread) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__ReadStatus_actions__["c" /* updateLastVersionRead */])(driveItemId));
    }
}; };
var viewableInGallery = [
    __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory,
    __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Image,
    __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Movie,
    __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Sound,
    __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Component,
];
var viewDriveItem = function (driveItem, origin, publicationOptions, forceSameTab) {
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, galleryInfos, routerParamsHistory, downloadManager, driveList, galleryConfig, downloadMode, isAndroidApp, windowTarget, isDownloaded, _b, _c, _d, page, _e, hideWelcomePage, _f, customSearchParams, url, downloadFolderPath, publicationPath, publicationUrlParams, localUrl, response, fileName_1, isItemPersistentlyDownloaded, isItemDownloaded, url_1, sourceFolder;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!driveItem) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.open_fail'));
                        return [2 /*return*/];
                    }
                    if (driveItem.endDate && __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].parseDate(driveItem.endDate) < new Date()) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.content_expired', { id: driveItem.id }));
                        return [2 /*return*/];
                    }
                    _a = getState(), galleryInfos = _a.galleryInfos, routerParamsHistory = _a.routerParamsHistory, downloadManager = _a.downloadManager, driveList = _a.driveList;
                    galleryConfig = galleryInfos.config;
                    downloadMode = downloadManager.items[driveItem.id] ? downloadManager.items[driveItem.id].mode : undefined;
                    isAndroidApp = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isAndroidApp();
                    windowTarget = forceSameTab ? '_self' : '_blank';
                    if (driveItem.type !== __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory) {
                        dispatch(setReadStatus(driveItem.id));
                    }
                    isDownloaded = __WEBPACK_IMPORTED_MODULE_14__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, driveItem.id);
                    if (!(!isDownloaded &&
                        ![__WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory, __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.ExternalLink].includes(driveItem.type))) return [3 /*break*/, 3];
                    if (!__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isOnline()) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__MultiAppAuthentication_actions__["b" /* checkActiveSession */])())];
                case 1:
                    _g.sent();
                    return [3 /*break*/, 3];
                case 2:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('info.offline_download_single_asset'));
                    return [2 /*return*/];
                case 3:
                    __WEBPACK_IMPORTED_MODULE_15__utils_statistics__["a" /* default */].trackView(driveItem);
                    _b = driveItem.type;
                    switch (_b) {
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory: return [3 /*break*/, 4];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Image: return [3 /*break*/, 5];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Movie: return [3 /*break*/, 5];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Sound: return [3 /*break*/, 5];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Publication: return [3 /*break*/, 6];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.File: return [3 /*break*/, 8];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.ExternalLink: return [3 /*break*/, 9];
                        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Component: return [3 /*break*/, 10];
                    }
                    return [3 /*break*/, 11];
                case 4:
                    window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_13__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, driveItem.id.toString());
                    return [3 /*break*/, 12];
                case 5:
                    goToTheaterPage(driveItem, routerParamsHistory, galleryConfig, driveList, origin);
                    return [3 /*break*/, 12];
                case 6:
                    _c = publicationOptions || {}, _d = _c.page, page = _d === void 0 ? undefined : _d, _e = _c.hideWelcomePage, hideWelcomePage = _e === void 0 ? undefined : _e, _f = _c.customSearchParams, customSearchParams = _f === void 0 ? {} : _f;
                    url = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getPublicationUrl(galleryConfig, driveItem, page, __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp, false, hideWelcomePage, customSearchParams);
                    if (!__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp) {
                        window.open(url, windowTarget);
                        return [3 /*break*/, 12];
                    }
                    if (isDownloaded) {
                        downloadFolderPath = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getPersistentDownloadsFolder();
                        publicationPath = driveItem.id + "/index.html";
                        publicationUrlParams = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getPublicationUrlParams(page, __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp, hideWelcomePage, customSearchParams);
                        localUrl = downloadFolderPath + "/" + publicationPath + publicationUrlParams;
                        url = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getUrlForSecuredResource(localUrl);
                    }
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].openFrame(url)];
                case 7:
                    response = _g.sent();
                    dispatch(openPublicationCallback(driveItem.id, response));
                    return [3 /*break*/, 12];
                case 8:
                    fileName_1 = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getDownloadedFileName(driveItem);
                    isItemPersistentlyDownloaded = __WEBPACK_IMPORTED_MODULE_14__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, driveItem.id);
                    isItemDownloaded = isItemPersistentlyDownloaded || downloadMode === __WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__["c" /* DownloadMode */].Dependency;
                    if (isAndroidApp && !downloadMode) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DownloadManager_actions__["l" /* requestMobileAppDownload */])(driveItem, __WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__["c" /* DownloadMode */].Temp))
                            .then(function () { return dispatch(openFile(fileName_1, __WEBPACK_IMPORTED_MODULE_9__utils__["i" /* tempFolder */], driveItem)); });
                    }
                    else {
                        if (!isItemDownloaded && downloadMode !== __WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__["c" /* DownloadMode */].Temp) {
                            url_1 = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getItemOriginalFileUrl(galleryConfig, driveItem.originalFile);
                            window.open(url_1, windowTarget);
                        }
                        else {
                            sourceFolder = downloadMode === __WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__["c" /* DownloadMode */].Temp
                                ? __WEBPACK_IMPORTED_MODULE_9__utils__["i" /* tempFolder */]
                                : __WEBPACK_IMPORTED_MODULE_9__utils__["f" /* downloadsFolder */];
                            dispatch(openFile(fileName_1, sourceFolder, driveItem));
                        }
                    }
                    return [3 /*break*/, 12];
                case 9:
                    window.open(driveItem.url, '_blank');
                    return [3 /*break*/, 12];
                case 10:
                    window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_13__utils_routes__["a" /* default */].getPathStaticPage(driveItem.id.toString());
                    return [3 /*break*/, 12];
                case 11:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.open_fail'));
                    // Types to ignore Template, V2Gateway, Link, AppContainer, Gallery
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); };
};
var runCallbackAction = function (action, currentAssetId, currentPage) {
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var _a, assetId, page, publicationOption, driveItemToView, driveItemToShare;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!action) {
                        return [2 /*return*/];
                    }
                    _a = action.type;
                    switch (_a) {
                        case ActionType.NONE: return [3 /*break*/, 1];
                        case ActionType.VIEW_DRIVE_ITEM: return [3 /*break*/, 2];
                        case ActionType.SHARE: return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 6];
                case 1: return [2 /*return*/];
                case 2:
                    assetId = action.assetId, page = action.page;
                    publicationOption = {
                        page: page,
                        hideWelcomePage: !!page
                    };
                    return [4 /*yield*/, dispatch(getOrFetchDriveItemMeta(assetId, false, true))];
                case 3:
                    driveItemToView = _b.sent();
                    dispatch(viewDriveItem(driveItemToView, DriveItemOrigin.Menu, publicationOption));
                    return [2 /*return*/];
                case 4:
                    if (!currentAssetId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(getOrFetchDriveItemMeta(currentAssetId, true, true))];
                case 5:
                    driveItemToShare = _b.sent();
                    // TODO: It seems isPublicationShare can't be true anymore, we should remove all code related to it
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__Share_actions__["k" /* share */])([driveItemToShare], undefined, undefined, {
                        type: ActionType.VIEW_DRIVE_ITEM,
                        assetId: currentAssetId,
                        page: currentPage,
                    }));
                    return [2 /*return*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
var openPublicationCallback = function (publicationId, response) {
    return function (dispatch) {
        if (response) {
            var action = response.action, currentPage = response.currentPage;
            dispatch(runCallbackAction(action, publicationId, currentPage));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__BackToPublication_actions__["c" /* setLastPublication */])(publicationId, currentPage));
        }
    };
};
var openFile = function (fileName, sourceFolder, driveItem) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var id, label, originalFile, sourceUrl, specialCharsRegex, correctedLabel, originalFileExtension, currentFileExtension, isOpenedFilesFolderExist, fileFolder, isFileFolderExist, destUrl, isNewFileExist, openedFilesFolderPath, newFileUrl, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 11, , 12]);
                id = driveItem.id, label = driveItem.label, originalFile = driveItem.originalFile;
                sourceUrl = sourceFolder + "/" + fileName;
                specialCharsRegex = /!|"|#|\$|%|&|'|\*|\+|,|\/|:|;|<|=|>|\?|@|\[|\\|\]|\^|`|{|\||}|~|\s+/g;
                correctedLabel = label.replace(specialCharsRegex, '_');
                originalFileExtension = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getFileExtension(originalFile);
                currentFileExtension = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getFileExtension(correctedLabel);
                if (originalFileExtension !== currentFileExtension) {
                    correctedLabel += "." + originalFileExtension;
                }
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* openedFilesFolder */])];
            case 1:
                isOpenedFilesFolderExist = _a.sent();
                if (!!isOpenedFilesFolderExist) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].createDirectory(__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* openedFilesFolder */])];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                fileFolder = __WEBPACK_IMPORTED_MODULE_9__utils__["h" /* openedFilesFolder */] + "/" + id;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].existDirectory(fileFolder)];
            case 4:
                isFileFolderExist = _a.sent();
                if (!!isFileFolderExist) return [3 /*break*/, 6];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].createDirectory(fileFolder)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                destUrl = fileFolder + "/" + correctedLabel;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].existFile(destUrl)];
            case 7:
                isNewFileExist = _a.sent();
                if (!!isNewFileExist) return [3 /*break*/, 9];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].copyFile(sourceUrl, destUrl)];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].existFile(destUrl)];
            case 10:
                // this checking is needed to ensure that file was copied
                isNewFileExist = _a.sent();
                if (isNewFileExist) {
                    openedFilesFolderPath = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isWindowsApp()
                        ? __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getRelativeOpenedFilesFolder()
                        : __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getPersistentOpenedFilesFolder();
                    newFileUrl = openedFilesFolderPath + "/" + id + "/" + correctedLabel;
                    if (__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isWindowsApp()) {
                        __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].openFileNatively(newFileUrl);
                    }
                    else {
                        window.open(newFileUrl);
                    }
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.open_fail'));
                }
                return [3 /*break*/, 12];
            case 11:
                error_2 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.open_fail'));
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}); }; };
var goToTheaterPage = function (driveItem, routerParamsHistory, galleryConfig, driveList, source) { return __awaiter(_this, void 0, void 0, function () {
    var currentRoute, params, origin, originParam, _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
                params = currentRoute.params;
                if (!(source === DriveItemOrigin.List)) return [3 /*break*/, 6];
                origin = params.origin || __WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder;
                _a = origin;
                switch (_a) {
                    case __WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search: return [3 /*break*/, 4];
                    case __WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Assortment: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 5];
            case 1:
                _b = params.originParam;
                if (_b) return [3 /*break*/, 3];
                return [4 /*yield*/, resolveParentId(driveItem.id, driveList)];
            case 2:
                _b = (_d.sent());
                _d.label = 3;
            case 3:
                originParam = _b;
                if (!originParam) {
                    origin = DriveItemOrigin.Menu;
                }
                return [3 /*break*/, 5];
            case 4:
                originParam = params.originParam;
                return [3 /*break*/, 5];
            case 5: return [3 /*break*/, 10];
            case 6:
                if (!(source === DriveItemOrigin.Details)) return [3 /*break*/, 9];
                origin = params.origin || __WEBPACK_IMPORTED_MODULE_11__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder;
                _c = params.folderId;
                if (_c) return [3 /*break*/, 8];
                return [4 /*yield*/, resolveParentId(driveItem.id, driveList)];
            case 7:
                _c = (_d.sent());
                _d.label = 8;
            case 8:
                originParam = _c;
                return [3 /*break*/, 10];
            case 9:
                origin = DriveItemOrigin.Menu;
                _d.label = 10;
            case 10:
                window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_13__utils_routes__["a" /* default */].getPathTheater(origin, originParam, driveItem.id);
                return [2 /*return*/];
        }
    });
}); };
var resolveParentId = function (driveItemId, driveList) { return __awaiter(_this, void 0, void 0, function () {
    var driveItems, driveItemsKeys, i, folderId, folderMeta, j, resource, driveItem, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                driveItems = driveList.driveItems;
                driveItemsKeys = Object.keys(driveItems);
                for (i = 0; i < driveItemsKeys.length; i++) {
                    folderId = parseInt(driveItemsKeys[i], 10);
                    folderMeta = driveItems[folderId];
                    if (folderMeta && folderMeta.resources) {
                        for (j = 0; j < folderMeta.resources.length; j++) {
                            resource = folderMeta.resources[j];
                            if (resource.id === driveItemId) {
                                return [2 /*return*/, folderId];
                            }
                        }
                    }
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getGalleryAsset(driveItemId)];
            case 2:
                driveItem = _a.sent();
                return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getParentFolderId(driveItem)];
            case 3:
                error_3 = _a.sent();
                // If API call fails like in gallery master, return nothing.
                return [2 /*return*/];
            case 4: return [2 /*return*/];
        }
    });
}); };
var setAppDisplayType = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var storedDisplayType, appDisplayType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_24__utils_indexedDB_manager__["a" /* default */].getDisplayType()];
            case 1:
                storedDisplayType = _a.sent();
                appDisplayType = storedDisplayType || __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ListDisplayType */].Default;
                dispatch(updateListDisplayType(appDisplayType));
                return [2 /*return*/];
        }
    });
}); }; };
var setBreadcrumbs = function (item) { return ({
    type: DriveItemListActionKeys.SET_BREADCRUMBS,
    item: item,
}); };
var resetBreadcrumbs = function () { return ({
    type: DriveItemListActionKeys.RESET_BREADCRUMBS,
}); };
var toggleEditMode = function () { return ({
    type: DriveItemListActionKeys.TOGGLE_EDIT_MODE,
}); };
var getResourceId = function (id) {
    var driveItems = __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].getState().driveList.driveItems;
    var linkId = driveItems[id].linkId;
    // if resource is linked we have to use linkId
    return linkId || id;
};
var moveDriveItem = function (folderId, from, to) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, config, _c, clientId, applicationGallery, routerParamsHistory, driveList, driveItems, currentFolderId, privateDirId, sourcesDirId, sharedDirId, resources, isAppRootFolder, filteredResources, isPrivateDir, sourcesDirIndex, sharedDirIndex, correctedFrom, correctedTo, isMoveToTop, id, resourceId, newIndex, position, newPosition, error_4;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState(), _b = _a.galleryInfos, config = _b.config, _c = _b.config, clientId = _c.clientId, applicationGallery = _c.applicationGallery, routerParamsHistory = _a.routerParamsHistory, driveList = _a.driveList, driveItems = _a.driveList.driveItems;
                currentFolderId = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getCurrentFolderId(applicationGallery, routerParamsHistory);
                privateDirId = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getPrivateDirId(driveList, config);
                sourcesDirId = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSourcesDirId(driveList, config);
                sharedDirId = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSharedDirId(driveList, config);
                resources = driveItems[folderId].resources;
                isAppRootFolder = folderId === applicationGallery;
                filteredResources = isAppRootFolder
                    ? resources.filter(function (_a) {
                        var id = _a.id;
                        return id !== privateDirId;
                    })
                    : resources;
                isPrivateDir = currentFolderId === privateDirId;
                sourcesDirIndex = isPrivateDir
                    ? filteredResources.findIndex(function (_a) {
                        var id = _a.id;
                        return id === sourcesDirId;
                    })
                    : undefined;
                sharedDirIndex = isPrivateDir
                    ? filteredResources.findIndex(function (_a) {
                        var id = _a.id;
                        return id === sharedDirId;
                    })
                    : undefined;
                correctedFrom = from;
                correctedTo = to;
                [sourcesDirIndex, sharedDirIndex].forEach(function (dirIndex) {
                    if (dirIndex !== undefined) {
                        if (dirIndex <= from) {
                            correctedFrom = correctedFrom + 1;
                        }
                        if (dirIndex <= to) {
                            correctedTo = correctedTo + 1;
                        }
                    }
                });
                isMoveToTop = correctedTo - correctedFrom < 0;
                id = filteredResources[correctedFrom].id;
                resourceId = getResourceId(id);
                newIndex = isMoveToTop ? correctedTo : correctedTo - 1;
                position = filteredResources[newIndex].position;
                newPosition = isMoveToTop ? position + 1 : position;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                dispatch({
                    type: DriveItemListActionKeys.MOVE_DRIVE_ITEM,
                    folderId: folderId,
                    from: correctedFrom,
                    to: correctedTo,
                    filteredResources: filteredResources,
                    isAppRootFolder: isAppRootFolder,
                    privateDirId: privateDirId,
                });
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].moveResourcesOrder(clientId, folderId, [resourceId], newPosition)];
            case 2:
                _d.sent();
                return [3 /*break*/, 4];
            case 3:
                error_4 = _d.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.cant_move_asset'));
                dispatch(resetDriveOrder(folderId, resources));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var moveDriveItemInFolder = function (folderId, id) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, clientId, applicationGallery, routerParamsHistory, driveItems, currentFolderId, resources, resourceId, error_5;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getState(), _b = _a.galleryInfos.config, clientId = _b.clientId, applicationGallery = _b.applicationGallery, routerParamsHistory = _a.routerParamsHistory, driveItems = _a.driveList.driveItems;
                currentFolderId = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getCurrentFolderId(applicationGallery, routerParamsHistory);
                if (!currentFolderId) {
                    return [2 /*return*/];
                }
                resources = driveItems[currentFolderId].resources;
                resourceId = getResourceId(id);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, 5, 6]);
                dispatch({
                    type: DriveItemListActionKeys.MOVE_DRIVE_ITEM_IN_FOLDER,
                    folderId: currentFolderId,
                    id: id,
                });
                dispatch(setLoadingStatus(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].moveResources(clientId, folderId, [resourceId])];
            case 2:
                _c.sent();
                return [4 /*yield*/, Promise.all([
                        dispatch(getOrFetchDriveItemMeta(currentFolderId, true, true, true)),
                        dispatch(getOrFetchDriveItemMeta(folderId, true, true, true)),
                        dispatch(getOrFetchDriveItemMeta(resourceId, true, true, true)),
                    ])];
            case 3:
                _c.sent();
                return [3 /*break*/, 6];
            case 4:
                error_5 = _c.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.cant_move_asset'));
                dispatch(resetDriveOrder(currentFolderId, resources));
                return [3 /*break*/, 6];
            case 5:
                dispatch(setLoadingStatus(false));
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
var resetDriveOrder = function (folderId, resources) { return ({
    type: DriveItemListActionKeys.RESET_DRIVE_ORDER,
    folderId: folderId,
    resources: resources,
}); };
var setLoadingStatus = function (isLoading) { return ({
    type: DriveItemListActionKeys.SET_LOADING_STATUS,
    isLoading: isLoading,
}); };
var setFolderDisplayType = function (folderId, displayType) { return function (dispatch, getState) {
    var routerParamsHistory = getState().routerParamsHistory;
    var folderIdOrOrigin = folderId || __WEBPACK_IMPORTED_MODULE_13__utils_routes__["a" /* default */].getCurrentOrigin(routerParamsHistory);
    dispatch({
        type: DriveItemListActionKeys.SET_FOLDER_DISPLAY_TYPE,
        folderId: folderIdOrOrigin,
        displayType: displayType,
    });
    __WEBPACK_IMPORTED_MODULE_24__utils_indexedDB_manager__["a" /* default */].setFolderDisplayType(folderIdOrOrigin, displayType).then();
}; };
var setFoldersDisplayType = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var foldersDisplayType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_24__utils_indexedDB_manager__["a" /* default */].getFoldersDisplayType()];
            case 1:
                foldersDisplayType = (_a.sent()) || {};
                dispatch({
                    type: DriveItemListActionKeys.SET_FOLDERS_DISPLAY_TYPE,
                    data: foldersDisplayType,
                });
                return [2 /*return*/];
        }
    });
}); }; };
var resetFoldersDisplayType = function () { return function (dispatch) {
    dispatch({
        type: DriveItemListActionKeys.RESET_FOLDERS_DISPLAY_TYPE,
    });
    __WEBPACK_IMPORTED_MODULE_24__utils_indexedDB_manager__["a" /* default */].resetFoldersDisplayType().then();
}; };
var getCustomTemplatesIds = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var isLoaded, customTemplates, ids, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 4]);
                isLoaded = getState().driveList.customTemplates.isLoaded;
                if (!__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isOnline() || isLoaded) {
                    return [2 /*return*/];
                }
                dispatch(setLoadingStatus(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getPublicationTemplates()];
            case 1:
                customTemplates = (_a.sent()).customTemplates;
                ids = customTemplates.map(function (_a) {
                    var id = _a.id;
                    return id;
                });
                dispatch(setCustomTemplatesIds(ids));
                return [3 /*break*/, 4];
            case 2:
                error_6 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.fetch_publication_templates_error'));
                return [3 /*break*/, 4];
            case 3:
                dispatch(setLoadingStatus(false));
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var setCustomTemplatesIds = function (ids) { return ({
    type: DriveItemListActionKeys.SET_CUSTOM_TEMPLATES_IDS,
    ids: ids,
}); };
var addCustomTemplate = function (id) { return ({
    type: DriveItemListActionKeys.ADD_CUSTOM_TEMPLATE,
    id: id,
}); };
var removeCustomTemplate = function (id) { return ({
    type: DriveItemListActionKeys.REMOVE_CUSTOM_TEMPLATE,
    id: id,
}); };
var updateLastFolderTreeUpdate = function () {
    var currentTimestamp = Date.now();
    return {
        type: DriveItemListActionKeys.SET_LAST_FOLDER_TREE_UPDATE,
        lastFolderTreeUpdate: currentTimestamp,
    };
};
var startFolderTreeUpdate = function () { return ({
    type: DriveItemListActionKeys.START_FOLDER_TREE_UPDATE,
}); };
var endFolderTreeUpdate = function () { return ({
    type: DriveItemListActionKeys.END_FOLDER_TREE_UPDATE,
}); };
var archiveProposal = function (clientId, driveItem) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var isArchived, _a, driveList, config, archiveDirId, parentId, error_7;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                dispatch(setLoadingStatus(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].archiveResources(clientId, [driveItem.id])];
            case 1:
                isArchived = _b.sent();
                if (!isArchived) return [3 /*break*/, 3];
                dispatch(removeDriveItems([driveItem.id]));
                _a = getState(), driveList = _a.driveList, config = _a.galleryInfos.config;
                archiveDirId = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getArchiveDirId(driveList, config);
                parentId = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getParentFolderId(driveItem);
                return [4 /*yield*/, Promise.all([
                        // is needed to update 'resources' property of parent folder as after resource archiving structure of blocks is changed
                        dispatch(getOrFetchDriveItemMeta(parentId, true, true, true)),
                        dispatch(getOrFetchDriveItemMeta(archiveDirId, true, true, true)),
                    ])];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.proposal_not_archived'));
                _b.label = 4;
            case 4: return [3 /*break*/, 7];
            case 5:
                error_7 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.cant_archive_proposal'));
                return [3 /*break*/, 7];
            case 6:
                dispatch(setLoadingStatus(false));
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
var getAspDriveItem = function (globalId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var driveItem, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_api__["a" /* default */].getResource(globalId)];
            case 1:
                driveItem = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_8 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.cant_get_resource'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, driveItem];
        }
    });
}); }; };
var updateFolderTree = function (isUserAction) { return (function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var driveItems, driveItemIds, folderIds, fetchFolderPromise, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                driveItems = getState().driveList.driveItems;
                if (!__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isOnline()) {
                    if (isUserAction) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('info.offline_update_folder_tree'));
                    }
                    return [2 /*return*/];
                }
                dispatch(startFolderTreeUpdate());
                driveItemIds = Object.keys(driveItems)
                    .map(function (driveItemId) { return parseInt(driveItemId, 10); });
                folderIds = driveItemIds
                    .filter(function (driveItemId) { return driveItems[driveItemId].type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory; });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                fetchFolderPromise = folderIds
                    .map(function (folderId) { return dispatch(getOrFetchDriveItemMeta(folderId, undefined, undefined, true)); });
                return [4 /*yield*/, Promise.all(fetchFolderPromise)];
            case 2:
                _a.sent();
                dispatch(updateLastFolderTreeUpdate());
                return [3 /*break*/, 4];
            case 3:
                error_9 = _a.sent();
                if (isUserAction) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__NotificationBar_actions__["c" /* createNotification */])('error.fetch_folder_tree'));
                }
                return [3 /*break*/, 4];
            case 4:
                dispatch(endFolderTreeUpdate());
                return [2 /*return*/];
        }
    });
}); }); };



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routesUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_hashHistory__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_hashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_hashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__ = __webpack_require__(12);




var RoutesUtils = /** @class */ (function () {
    function RoutesUtils() {
    }
    // paths
    RoutesUtils.historyPush = function (path) {
        __WEBPACK_IMPORTED_MODULE_2_react_router_lib_hashHistory___default.a.push(path + __WEBPACK_IMPORTED_MODULE_2_react_router_lib_hashHistory___default.a.getCurrentLocation().search);
    };
    // paths
    RoutesUtils.getPathDefault = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].Default, keepHashbang);
    };
    RoutesUtils.getPathHome = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].Home, keepHashbang);
    };
    RoutesUtils.getPageNotFound = function () {
        return __WEBPACK_IMPORTED_MODULE_2_react_router_lib_hashHistory___default.a.replace('error404');
    };
    RoutesUtils.getPathStaticPage = function (driveItemId, keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        var path = __WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].StaticPage.replace(':component', driveItemId);
        return this.replaceHashbang(path, keepHashbang);
    };
    RoutesUtils.getPathAuthentication = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].Authentication, keepHashbang);
    };
    RoutesUtils.getPathParameters = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].ParametersPage, keepHashbang);
    };
    RoutesUtils.getPathProfile = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].ProfilePage, keepHashbang);
    };
    RoutesUtils.getPathProposalStats = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].ProposalStatsPage, keepHashbang);
    };
    RoutesUtils.getPathDriveItemListPage = function (origin, originParam, keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        var path = __WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].DriveItemListPage.replace(':origin', origin);
        var originParamReplaceValue = originParam ? "/" + originParam : '';
        path = path.replace('(/:originParam)', originParamReplaceValue);
        return this.replaceHashbang(path, keepHashbang);
    };
    RoutesUtils.getPathDriveItemDetailPage = function (driveItemId, folderId, keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        var path = __WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].DriveItemDetailPage.replace(':driveItemId', driveItemId.toString());
        var folderIdParamReplaceValue = folderId ? "/" + folderId : '';
        path = path.replace('(/:folderId)', folderIdParamReplaceValue);
        return this.replaceHashbang(path, keepHashbang);
    };
    RoutesUtils.getPathTheater = function (origin, originParam, driveItemId, keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        var path;
        if (origin === __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].Menu) {
            path = __WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].Theater
                .replace(':driveItemId', driveItemId.toString());
        }
        else {
            path = __WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].TheaterList
                .replace(':origin', origin)
                .replace(':driveItemId', driveItemId.toString());
            var originParamReplaceValue = originParam ? "/" + originParam : '';
            path = path.replace('(/:originParam)', originParamReplaceValue);
        }
        return this.replaceHashbang(path, keepHashbang);
    };
    RoutesUtils.getPathEditor = function (clientId, resourceId) {
        return "editor/" + clientId + "/" + resourceId;
    };
    RoutesUtils.getPathNotes = function (keepHashbang) {
        if (keepHashbang === void 0) { keepHashbang = false; }
        return this.replaceHashbang(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].NotesPage, keepHashbang);
    };
    RoutesUtils.currentLocationIs = function (routerParamsHistory, location) {
        var currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
        var currentOrigin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
        return location === currentRoute || location === currentOrigin;
    };
    RoutesUtils.replaceHashbang = function (path, keepHashbang) {
        var replaceValue = keepHashbang ? '!/' : '';
        return path.replace(__WEBPACK_IMPORTED_MODULE_0__routes_constants__["b" /* pathHashbang */], replaceValue);
    };
    RoutesUtils.doesRoutesContainsPath = function (path, routes) {
        return !!routes && routes.some(function (route) { return route.path === path; });
    };
    RoutesUtils.isGalleryRoot = function (routerParamsHistory) {
        var currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
        var currentOrigin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
        var currentOriginParam = RoutesUtils.getCurrentOriginParam(routerParamsHistory);
        return currentRoute === __WEBPACK_IMPORTED_MODULE_0__routes_constants__["a" /* RoutePath */].DriveItemListPage && currentOrigin === __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder && !currentOriginParam;
    };
    RoutesUtils.getCurrentRoute = function (routerParamsHistory) {
        var currentRoute = RoutesUtils.getCurrentRouterParam(routerParamsHistory);
        var routes = currentRoute.routes;
        var route = routes[routes.length - 1].path;
        return route;
    };
    RoutesUtils.getCurrentOrigin = function (routerParamsHistory) {
        var currentRoute = RoutesUtils.getCurrentRouterParam(routerParamsHistory);
        var origin = currentRoute.params.origin;
        return origin;
    };
    RoutesUtils.getCurrentOriginParam = function (routerParamsHistory) {
        var currentRoute = RoutesUtils.getCurrentRouterParam(routerParamsHistory);
        var originParam = currentRoute.params.originParam;
        return originParam;
    };
    RoutesUtils.getCurrentRouterParam = function (routerParamsHistory) {
        return routerParamsHistory[routerParamsHistory.length - 1];
    };
    RoutesUtils.redirectToParentDir = function (parentId) {
        RoutesUtils.historyPush(RoutesUtils.getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, parentId.toString()));
    };
    return RoutesUtils;
}());
var routesUtils = new RoutesUtils;
/* harmony default export */ __webpack_exports__["a"] = (RoutesUtils);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sources__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__sources__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__sources__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_1__configs__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spreadBackground__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_2__spreadBackground__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_2__spreadBackground__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__spreadBackground__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_2__spreadBackground__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagesController__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__pagesController__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__thumbnails__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_4__thumbnails__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_4__thumbnails__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_4__thumbnails__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editableItems__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__editableItems__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_6__ui__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pagesSelection__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__combo__ = __webpack_require__(304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_8__combo__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__themes__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_9__themes__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__themes__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__themes__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_9__themes__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__themes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_10__settings__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__settings__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_10__settings__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_10__settings__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_10__settings__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_10__settings__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__preprodPublication__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_11__preprodPublication__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_11__preprodPublication__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__preprodPublication__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__preprodPublication__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__history__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_12__history__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_12__history__["c"]; });















/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BarType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationBarActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createNotification; });
var DEFAULT_TOAST_DISPLAY_TIME = 5000;
var BarType;
(function (BarType) {
    BarType["Error"] = "error";
    BarType["Info"] = "info";
    BarType["Success"] = "success";
})(BarType || (BarType = {}));
var NotificationBarActionKeys;
(function (NotificationBarActionKeys) {
    NotificationBarActionKeys["CREATE_NOTIFICATION"] = "@@notificationBar/CREATE_NOTIFICATION";
    NotificationBarActionKeys["CLEAR_NOTIFICATIONS"] = "@@notificationBar/CLEAR_NOTIFICATIONS";
})(NotificationBarActionKeys || (NotificationBarActionKeys = {}));
var notificationTimer;
var createNotification = function (message, args, timer) {
    return function (dispatch, getState) {
        dispatch({
            type: NotificationBarActionKeys.CREATE_NOTIFICATION,
            barType: message.split('.')[0],
            message: message.split('.')[1],
            args: args,
        });
        dispatch(checkNotificationTimer(timer));
    };
};
var checkNotificationTimer = function (timer) {
    if (timer === void 0) { timer = DEFAULT_TOAST_DISPLAY_TIME; }
    return function (dispatch, getState) {
        if (notificationTimer) {
            clearTimeout(notificationTimer);
        }
        // global.setTimeout() is used because of typescript compiler thinking setTimeout() returns a number
        notificationTimer = timer > 0 ? global.setTimeout(function () { dispatch(clearNotifications()); }, timer) : undefined;
    };
};
var clearNotifications = function () { return ({ type: NotificationBarActionKeys.CLEAR_NOTIFICATIONS }); };


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Authentication_reducer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_selectors__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_utils_html_parse_serialize__ = __webpack_require__(298);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _this = this;









var ApiUtils = /** @class */ (function () {
    function ApiUtils() {
    }
    ApiUtils.isDuplicateFileNameError = function (errorText) {
        var DUPLICATE_NAME_ERROR = 'DUPLICATE_NAME';
        return errorText.includes(DUPLICATE_NAME_ERROR);
    };
    Object.defineProperty(ApiUtils, "galleryConfig", {
        get: function () {
            if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]) {
                console.error('ApiUtils.galleryConfig() is called before store is created');
            }
            var galleryInfos = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState().galleryInfos;
            if (!galleryInfos.isConfigLoaded) {
                console.error('ApiUtils.galleryConfig() is called before galleryInfos.config is loaded');
            }
            return galleryInfos.config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiUtils, "multiAppAuthenticationInfos", {
        get: function () {
            if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]) {
                console.error('ApiUtils.multiAppAuthenticationInfos() is called before store is created');
            }
            var multiAppAuthenticationInfos = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState().multiAppAuthenticationInfos;
            return multiAppAuthenticationInfos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiUtils, "multiAppAuthenticationServer", {
        get: function () {
            return this.multiAppAuthenticationInfos.server;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiUtils, "multiAppAuthenticationToken", {
        get: function () {
            var _a = this.multiAppAuthenticationInfos.credentials, _b = (_a === void 0 ? {} : _a).token, token = _b === void 0 ? null : _b;
            return token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiUtils, "multiAppAuthenticationLastApiCallTimestamp", {
        get: function () {
            var _a = this.multiAppAuthenticationInfos.credentials, _b = (_a === void 0 ? {} : _a).lastApiCallTimestamp, lastApiCallTimestamp = _b === void 0 ? null : _b;
            return lastApiCallTimestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiUtils, "token", {
        get: function () {
            if (__WEBPACK_IMPORTED_MODULE_2____["d" /* default */].isEmbedMode()) {
                return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].getQueryParamFromUrl('token');
            }
            return ApiUtils.multiAppAuthenticationToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiUtils, "lastApiCallTimestamp", {
        get: function () {
            var lastApiCallTimestamp = ApiUtils.multiAppAuthenticationLastApiCallTimestamp;
            return lastApiCallTimestamp ? +lastApiCallTimestamp : null;
        },
        enumerable: true,
        configurable: true
    });
    ApiUtils.checkSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCheckSessionUrl(ApiUtils.galleryConfig), 'GET')];
            });
        });
    };
    ApiUtils.importFile = function (clientId, folderId, file, onProgress, requestId, isOptimizedImageImport, isPublicationDependency) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getImportFileUrl(ApiUtils.galleryConfig, file.name, isOptimizedImageImport);
        var formData = new FormData();
        formData.append('clientId', clientId.toString());
        formData.append('folderGId', folderId.toString());
        formData.append('file', file);
        formData.append('filename', file.name);
        if (isPublicationDependency) {
            formData.append('dependency', 'true');
        }
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, formData, undefined, true, true, false, onProgress, requestId);
    };
    ApiUtils.createComponent = function (clientId, folderId, file, isPublicationDependency) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateComponentUrl(galleryConfig);
        var formData = new FormData();
        formData.append('clientId', clientId.toString());
        formData.append('folderGId', folderId.toString());
        formData.append('file', file);
        formData.append('filename', file.name);
        if (isPublicationDependency) {
            formData.append('dependency', 'true');
        }
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, formData);
    };
    // add a special flag for 'editable app' (app with 'Multiple' type and private dir)
    // to get all resources including expired and unpublished
    ApiUtils.getIncludeAllResourcesParam = function () {
        var _a = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState(), appInfos = _a.appInfos, config = _a.galleryInfos.config, driveList = _a.driveList, role = _a.profile.role;
        var isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState());
        var hasPrivateDir = !!__WEBPACK_IMPORTED_MODULE_2____["d" /* default */].getPrivateDirId(driveList, config);
        if (__WEBPACK_IMPORTED_MODULE_2____["d" /* default */].isReadOnlyApp(role)) {
            return {};
        }
        if (__WEBPACK_IMPORTED_MODULE_2____["d" /* default */].isEmbedMode()
            || (__WEBPACK_IMPORTED_MODULE_2____["d" /* default */].isMultiApp(appInfos) && (__WEBPACK_IMPORTED_MODULE_3__userAgent__["a" /* default */].isMobileApp || isAccountManagerOrAdmin))) {
            return { excludeNP: false };
        }
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].isMultiApp(appInfos) && hasPrivateDir ? { excludeNP: false } : {};
    };
    ApiUtils.loginToAsp = function (credentials, shouldSaveCredentials) {
        var config = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState().galleryInfos.config;
        if (credentials.method === __WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication) {
            var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getLoginToAspUrl(config);
            var login = credentials.login, password = credentials.password, company = credentials.company;
            var data = __assign({ login: login,
                password: password, rememberMe: shouldSaveCredentials }, (company ? { org: company } : {}));
            return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
        }
        else {
            var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getOrgLoginUrl(config);
            var company = credentials.company, token = credentials.token;
            var data = {
                org: company,
                token: token,
            };
            return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
        }
    };
    ApiUtils.freeUrlAppLogin = function () {
        var config = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState().galleryInfos.config;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getFreeUrlAppLoginUrl(config);
        var accessToken = __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].getQueryParamFromUrl('wpAccessToken');
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload({ accessToken: accessToken }), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.refreshSession = function (requestId) {
        var config = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState().galleryInfos.config;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getRefreshSessionUrl(config);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, null, undefined, undefined, true, true, false, function () { return undefined; }, requestId);
    };
    ApiUtils.logoutFromAsp = function () {
        var galleryConfig = ApiUtils.galleryConfig;
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getLogoutFromAspUrl(galleryConfig), 'POST');
    };
    ApiUtils.logoutFromApplication = function () {
        var galleryConfig = ApiUtils.galleryConfig;
        // there can be different application urls from ASP_SERVERS and from galleryConfig
        // in this case logout must be called on both of them
        var multiAppAuthenticationAppUrl = __WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][ApiUtils.multiAppAuthenticationServer].driveUrl;
        var isSameAppUrl = __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].isSameUrl(galleryConfig.applicationUrl, multiAppAuthenticationAppUrl);
        var promises = [
            __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getLogoutFromApplication(galleryConfig), 'POST'),
        ];
        if (!isSameAppUrl) {
            promises.push(__WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getLogoutFromApplication(galleryConfig, true), 'POST'));
        }
        return Promise.all(promises);
    };
    ApiUtils.createAspDemoAccount = function (email, password, phone) {
        var galleryConfig = ApiUtils.galleryConfig;
        var loginData = { email: email, password: password, phone: phone };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateDemoAccountUrl(galleryConfig), 'POST', true, true, loginData)
            .catch(function (error) { return Promise.reject(JSON.parse(error.responseText)); });
    };
    ApiUtils.getOrgAuthMethods = function (company) {
        var galleryConfig = ApiUtils.galleryConfig;
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getAuthMethodsUrl(galleryConfig), 'GET', true, true, { org: company })
            .catch(function (error) { return Promise.reject(JSON.parse(error.responseText)); });
    };
    // TODO: change return type of authenticate
    ApiUtils.authenticate = function (user, pass) {
        // HACK for IOS webviews for call with basic Authentication which can reply with a 401, https://stackoverflow.com/a/13018549
        var isAsync = !__WEBPACK_IMPORTED_MODULE_3__userAgent__["a" /* default */].isIOSApp();
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getLoginUrl(ApiUtils.galleryConfig, user, pass), 'GET', isAsync);
    };
    ApiUtils.getSecurityHeaderIfNeeded = function (preventSecurityHeader) {
        var authentication = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState().authentication;
        var mode = authentication.userInfos.mode;
        var isSamlAuthenticationType = mode && mode.method === __WEBPACK_IMPORTED_MODULE_6__containers_Authentication_reducer__["b" /* Security */].Saml;
        return isSamlAuthenticationType && !preventSecurityHeader
            ? [{
                    key: 'Access-Control-Allow-Credentials',
                    value: 'true',
                }]
            : [];
    };
    ApiUtils.getSecurityType = function () {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getLoginJsonUrl(galleryConfig);
        // HACK for IOS webviews for call with basic Authentication which can reply with a 401, https://stackoverflow.com/a/13018549
        var isAsync = !__WEBPACK_IMPORTED_MODULE_3__userAgent__["a" /* default */].isIOSApp();
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].promiseXHR('GET', url, [], isAsync)
            .then(function (response) {
            var securityType = response.getResponseHeader('Security');
            var samlUrl = response.getResponseHeader('SAML_URL') || '';
            return securityType
                ? Promise.resolve({ securityType: securityType, samlUrl: samlUrl })
                : Promise.resolve(undefined);
        })
            .catch(function (error) {
            return Promise.reject(error);
        });
    };
    ApiUtils.getTemplate = function (server) {
        // HACK for IOS webviews for call with basic Authentication which can reply with a 401, https://stackoverflow.com/a/13018549
        var isAsync = !__WEBPACK_IMPORTED_MODULE_3__userAgent__["a" /* default */].isIOSApp();
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getTemplateUrl('template.json', ApiUtils.galleryConfig, server), 'GET', isAsync);
    };
    ApiUtils.getCustomCSS = function (server) {
        var isAsync = !__WEBPACK_IMPORTED_MODULE_3__userAgent__["a" /* default */].isIOSApp();
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getTemplateUrl('custom.css', ApiUtils.galleryConfig, server), 'GET', isAsync);
    };
    ApiUtils.getConfig = function (clientId, galleryId) {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getConfigUrl(ApiUtils.multiAppAuthenticationServer, clientId, galleryId), 'GET', true, true);
    };
    ApiUtils.getStatistics = function () {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getStatisticsUrl(ApiUtils.galleryConfig));
    };
    ApiUtils.getChildren = function (driveItemId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var resolvedDriveItemId = driveItemId || galleryConfig.applicationGallery;
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getChildrenUrl(ApiUtils.galleryConfig, resolvedDriveItemId), 'GET', true, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.getChildrenMeta = function () {
        var galleryConfig = ApiUtils.galleryConfig, applicationGallery = ApiUtils.galleryConfig.applicationGallery;
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getChildrenMetaUrl(galleryConfig, applicationGallery), 'GET', true, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.getAppMeta = function () {
        var galleryConfig = ApiUtils.galleryConfig, applicationGallery = ApiUtils.galleryConfig.applicationGallery;
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getAppMetaUrl(galleryConfig, applicationGallery), 'GET', true, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.getMeta = function (driveItemId, isAsync, ancestorId) {
        if (isAsync === void 0) { isAsync = true; }
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getMetaUrl(ApiUtils.galleryConfig, driveItemId, ancestorId), 'GET', isAsync, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.getContentBlock = function (driveItemId, block) {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getContentBlockUrl(ApiUtils.galleryConfig, driveItemId, block), 'GET', true, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.getNewContents = function () {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getNewContentsUrl(ApiUtils.galleryConfig));
    };
    ApiUtils.getSearch = function (searchString) {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSearchUrl(ApiUtils.galleryConfig, searchString), 'GET', true, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.getDownloadPDF = function (searchString) {
        return __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getDownloadPDFUrl(ApiUtils.galleryConfig, searchString);
    };
    ApiUtils.getGalleryAsset = function (driveItemId) {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getGalleryAssetUrl(ApiUtils.galleryConfig, driveItemId), 'GET');
    };
    ApiUtils.buildOutcomingsUrl = function (driveItemId, level, excludeTypes, excludeIds) {
        if (excludeTypes === void 0) { excludeTypes = []; }
        if (excludeIds === void 0) { excludeIds = []; }
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getOutcomingsUrl(ApiUtils.galleryConfig, driveItemId);
        var params = new URLSearchParams();
        if (level) {
            params.append('level', level);
        }
        if (excludeTypes.length > 0) {
            excludeTypes.forEach(function (type) { return params.append('exclType', type); });
        }
        if (excludeIds.length > 0) {
            excludeIds.forEach(function (id) { return params.append('exclId', id.toString()); });
        }
        return "" + url + __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].getUrlSeparator(url) + params.toString();
    };
    ApiUtils.getOutcomings = function (driveItemId, level, excludeTypes, excludeIds) {
        if (excludeTypes === void 0) { excludeTypes = []; }
        if (excludeIds === void 0) { excludeIds = []; }
        var finalUrl = ApiUtils.buildOutcomingsUrl(driveItemId, level, excludeTypes, excludeIds);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(finalUrl);
    };
    ApiUtils.getAvailableServers = function () {
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson('https://fr.adminzone-secure.net/services/rest/loginWs/getClosestServer')
            .then(function (res) { return res.servers; });
    };
    ApiUtils.shareContent = function (requestData) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getShareServiceUrl(ApiUtils.galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, JSON.stringify(requestData)); // requestData needs to be stringified
    };
    ApiUtils.getCrmAccounts = function () {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCrmAccountsUrl(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true)
            .then(function (crmAccounts) { return Array.isArray(crmAccounts) ? crmAccounts : []; });
    };
    ApiUtils.createPrivateFolder = function (parentGId, name, resourcesGIds) {
        var galleryConfig = ApiUtils.galleryConfig, clientId = ApiUtils.galleryConfig.clientId;
        if (parentGId) {
            var requestData = {
                driveLabel: name,
                clientId: clientId,
                parentGId: parentGId,
                resourcesGIds: resourcesGIds,
            };
            var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreatePrivateFolderUrl(galleryConfig);
            return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(requestData), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED)
                .then(function (newFolderIdString) { return parseInt(newFolderIdString, 10); });
        }
        return Promise.reject();
    };
    ApiUtils.createExternalLink = function (folderGId, label, linkUrl) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateExternalLinkUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: ApiUtils.galleryConfig.clientId,
            folderGId: folderGId,
            label: label,
            url: linkUrl,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.getIndesignEditorData = function (clientId, publicationGId, allowPreview) {
        var dataInUrl = {
            clientId: clientId,
            publicationGId: publicationGId,
            allowPreview: allowPreview,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getIndesignEditorDataUrl(ApiUtils.galleryConfig), 'GET', true, true, dataInUrl);
    };
    ApiUtils.getHtmlEditorData = function (clientId, pageGId) {
        var dataInUrl = {
            clientId: clientId,
            pageGId: pageGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(__WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getHtmlEditorDataUrl(ApiUtils.galleryConfig), 'GET', true, true, dataInUrl);
    };
    ApiUtils.getEditorResource = function (resourceId, relPath) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getEditorResourceUrl(ApiUtils.galleryConfig, resourceId, relPath);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'GET', true, true, { token: ApiUtils.token });
    };
    ApiUtils.saveIndesignEditorPage = function (clientId, resourceGId, pageNum, htmlContent, requestId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveIndesignEditorPageUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
            pageNum: pageNum,
            htmlContent: htmlContent,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED, true, true, false, function () { return undefined; }, requestId);
    };
    ApiUtils.getResourceStyle = function (resourceUrl) { return __awaiter(_this, void 0, void 0, function () {
        var url, response, text, doc, styleElement, styleContent, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    url = resourceUrl + "?token=" + ApiUtils.token;
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        console.error('Error fetching resource style:', response.statusText);
                        return [2 /*return*/, ''];
                    }
                    return [4 /*yield*/, response.text()];
                case 2:
                    text = _a.sent();
                    doc = Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_utils_html_parse_serialize__["a" /* parseHtmlString */])(text);
                    styleElement = doc.querySelector('style');
                    styleContent = '';
                    if (styleElement) {
                        styleContent = styleElement.textContent || '';
                    }
                    else {
                        console.warn('No "<style>" element found in the resource.');
                    }
                    return [2 /*return*/, styleContent];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error fetching or parsing resource style:', error_1);
                    return [2 /*return*/, ''];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    ApiUtils.saveEditedAccessiblePage = function (clientId, resourceGId, pageNum, htmlContent, requestId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveEditedAccessiblePageUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
            pageNum: pageNum,
            htmlContent: htmlContent,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED, true, true, false, function () { return undefined; }, requestId);
    };
    ApiUtils.saveIndesignEditorConfigs = function (clientId, resourceGId, configs, requestId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveIndesignEditorConfigsUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: resourceGId,
            configsJsonContent: configs,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED, true, true, false, function () { return undefined; }, requestId);
    };
    ApiUtils.saveIndesignEditorThemesCss = function (clientId, publiGId, cssContent) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveIndesignEditorThemesCssUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: publiGId,
            cssContent: cssContent,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.saveHtmlEditorPage = function (clientId, pageGId, htmlContent) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveHtmlEditorPageUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            pageGId: pageGId,
            htmlContent: htmlContent,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.createCombo = function (clientId, resourceGId, resourcesGIds, newLabel) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateComboUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: resourceGId,
            resourcesGIds: resourcesGIds,
            newLabel: newLabel,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.createComboWithExternalSpreads = function (clientId, resourceGId, sourceGId, pages) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateComboWithExternalSpreadsUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: resourceGId,
            srcPubliGId: sourceGId,
            pages: pages,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.getPublicationProgress = function (clientId, publicationGId, onUpdate, onError, onFinish, shouldCancel, onCancel) { return __awaiter(_this, void 0, void 0, function () {
        var GET_PROGRESS_DELAY, getProgressTimer, url, dataInUrl, getProgress;
        var _this = this;
        return __generator(this, function (_a) {
            GET_PROGRESS_DELAY = 2000;
            url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getPublicationProgressUrl(ApiUtils.galleryConfig);
            dataInUrl = {
                clientId: clientId,
                publicationGId: publicationGId,
            };
            getProgress = function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, status_1, percentage, error_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            if (shouldCancel && shouldCancel(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState())) {
                                clearInterval(getProgressTimer);
                                if (onCancel) {
                                    onCancel();
                                }
                            }
                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, dataInUrl)];
                        case 1:
                            _a = _b.sent(), status_1 = _a.status, percentage = _a.percentage;
                            if (status_1 === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AssetItemStatus.PROCESSING) {
                                onUpdate(percentage);
                            }
                            else {
                                clearInterval(getProgressTimer);
                                if (status_1 === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AssetItemStatus.LIVE) {
                                    onFinish();
                                }
                                if (status_1 === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].AssetItemStatus.ERROR) {
                                    onError();
                                }
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _b.sent();
                            onError();
                            clearInterval(getProgressTimer);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            getProgressTimer = window.setInterval(function () {
                getProgress();
            }, GET_PROGRESS_DELAY);
            return [2 /*return*/];
        });
    }); };
    ApiUtils.getPublicationTemplates = function () {
        var galleryConfig = ApiUtils.galleryConfig, applicationGallery = ApiUtils.galleryConfig.applicationGallery;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getPublicationTemplatesUrl(galleryConfig, applicationGallery);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, ApiUtils.getIncludeAllResourcesParam());
    };
    ApiUtils.setAsTemplate = function (clientId, globalId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSetAsTemplateUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            globalId: globalId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.removeTemplate = function (clientId, globalId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getRemoveTemplateUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            globalId: globalId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.createPublicationFromMasterTemplate = function (clientId, applicationGId, folderGId, publicationGId, newLabel) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreatePublicationFromMasterTemplateUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            applicationGId: applicationGId,
            folderGId: folderGId,
            publicationGId: publicationGId,
            newLabel: newLabel,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.createProposalFromDesktopFile = function (file, clientId, folderId, onProgress, requestId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateProposalFromDesktopFileUrl(ApiUtils.galleryConfig);
        var formData = new FormData();
        formData.append('clientId', clientId.toString());
        formData.append('parentDriveGId', folderId.toString());
        formData.append('file', file);
        formData.append('filename', file.name);
        formData.append('creationSource', __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].CreationSource.DESKTOP);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, formData, undefined, true, true, false, onProgress, requestId);
    };
    ApiUtils.createProposalFromDriveItem = function (folderId, clientId, resourceGId, newLabel, requestId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCreateProposalFromDriveItemUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
            newLabel: newLabel,
            parentDriveGId: folderId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED, true, true, false, undefined, requestId);
    };
    ApiUtils.sharePublication = function (clientId, resourceGId, name) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSharePublicationUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
            name: name,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.renameResource = function (clientId, resourceGId, resourceLabel) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getRenameResourceUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
            resourceLabel: resourceLabel,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.trashResources = function (clientId, resourcesGIds) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getTrashResourcesUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourcesGIds: resourcesGIds,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.removePublicationPages = function (clientId, publiGId, pages) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getRemovePublicationPagesUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: publiGId,
            pages: pages,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.movePublicationPages = function (clientId, publiGId, pages, newPosition) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getMovePublicationPagesUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: publiGId,
            pages: pages,
            newPosition: newPosition,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.duplicatePublicationPages = function (clientId, publiGId, pages) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getDuplicatePublicationPagesUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: publiGId,
            pages: pages,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.reprocessPublicationThumbs = function (clientId, publiGId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getReprocessPublicationThumbsUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            publiGId: publiGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.getProfileData = function (clientId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getProfileDataUrl(ApiUtils.galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, { clientId: clientId });
    };
    ApiUtils.editProfileData = function (id, clientId, fields, userAvatar) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getEditProfileDataUrl(ApiUtils.galleryConfig);
        var data = {};
        if (userAvatar.isEdited && !userAvatar.isRemoved) {
            var _a = userAvatar.config, name_1 = _a.name, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
            fields.photoConfig = JSON.stringify({ name: name_1, width: width, height: height, x: x, y: y });
        }
        if (userAvatar.isNew && userAvatar.file) {
            data.profilePic = userAvatar.file;
        }
        if (userAvatar.isRemoved) {
            data.removeProfilePic = 'true';
        }
        data.profileInfo = JSON.stringify(__assign({ id: id,
            clientId: clientId }, fields));
        var formData = Object.entries(data).reduce(function (formData, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            formData.append(key, value);
            return formData;
        }, new FormData());
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'PUT', true, true, null, formData);
    };
    ApiUtils.getProposalsByType = function (clientId, proposalStatus, sortOn, ascending, pageNum, itemsPerPage) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getProposalsByTypeUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            proposalStatus: proposalStatus,
            sortOn: sortOn,
            ascending: ascending,
            pageNum: pageNum,
            itemsPerPage: itemsPerPage,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.moveResourcesOrder = function (clientId, parentDriveGId, resourcesGIds, positionBefore) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getMoveResourcesOrderUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            parentDriveGId: parentDriveGId,
            resourcesGIds: resourcesGIds,
            positionBefore: positionBefore,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.moveResources = function (clientId, newParentGId, resourcesGIds) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getMoveResourcesUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            newParentGId: newParentGId,
            resourcesGIds: resourcesGIds,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.archiveResources = function (clientId, resourcesGIds) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getArchiveResourcesUrl(ApiUtils.galleryConfig);
        var appGId = ApiUtils.galleryConfig.applicationGallery;
        var data = {
            clientId: clientId,
            resourcesGIds: resourcesGIds,
            appGId: appGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.getNotes = function () {
        var galleryConfig = ApiUtils.galleryConfig, applicationGallery = ApiUtils.galleryConfig.applicationGallery;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getNotesUrl(galleryConfig, applicationGallery);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true);
    };
    ApiUtils.saveNote = function (data) {
        var galleryConfig = ApiUtils.galleryConfig, applicationGallery = ApiUtils.galleryConfig.applicationGallery;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveNoteUrl(galleryConfig, applicationGallery);
        var dataToSave = {
            notes: [data],
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, JSON.stringify(dataToSave));
    };
    ApiUtils.removeNote = function (id) {
        var galleryConfig = ApiUtils.galleryConfig, applicationGallery = ApiUtils.galleryConfig.applicationGallery;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSaveNoteUrl(galleryConfig, applicationGallery);
        var dataToSave = {
            deleteIds: [id],
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, JSON.stringify(dataToSave));
    };
    ApiUtils.getResource = function (resourceGId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getResourceUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            resourceGId: resourceGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.getCustomerContext = function () {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getCustomerContextUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.getPublicationSettings = function (publicationGId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getPublicationSettingsUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            publicationGId: publicationGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.savePublicationSettings = function (globalId, values) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSavePublicationSettingsUrl(galleryConfig);
        var data = __assign({ clientId: galleryConfig.clientId, globalId: globalId }, values);
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'PUT', true, true, null, JSON.stringify(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].JSON);
    };
    ApiUtils.getPublicationPdfSettings = function (publicationGId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getPublicationPdfSettingsUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            publicationGId: publicationGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.savePublicationPdfOption = function (publicationGId, pdfOption) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getSavePublicationPdfOptionUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            publicationGId: publicationGId,
            pdfOption: pdfOption,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.importPublicationPdf = function (publicationGId, file, sourcePublication, updateThumbs, onProgress, requestId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getImportPublicationPdfUrl(galleryConfig);
        var formData = new FormData();
        formData.append('clientId', galleryConfig.clientId.toString());
        formData.append('publicationGId', publicationGId.toString());
        formData.append('updateThumbs', updateThumbs.toString());
        if (file) {
            formData.append('file', file);
            formData.append('filename', file.name);
        }
        if (sourcePublication) {
            formData.append('srcPubliGId', sourcePublication.id.toString());
            formData.append('filename', sourcePublication.label);
        }
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, formData, undefined, true, true, false, onProgress, requestId);
    };
    ApiUtils.getPublicationIntegration = function (publicationGId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getPublicationIntegrationUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            publicationGId: publicationGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.updateOriginalPublication = function (tempGId, originalGId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getUpdateOriginalPublicationUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            tempGId: tempGId,
            originGId: originalGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, null, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.acquireLock = function (clientId, resourceGId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getAcquireLockUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.releaseLock = function (clientId, resourceGId) {
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getReleaseLockUrl(ApiUtils.galleryConfig);
        var data = {
            clientId: clientId,
            resourceGId: resourceGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.getShareUsers = function () {
        var galleryConfig = ApiUtils.galleryConfig, _a = ApiUtils.galleryConfig, clientId = _a.clientId, applicationGallery = _a.applicationGallery;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getShareUsersUrl(galleryConfig);
        var data = {
            clientId: clientId,
            appGId: applicationGallery,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    ApiUtils.shareWithUser = function (resourceGId, userId) {
        var galleryConfig = ApiUtils.galleryConfig, _a = ApiUtils.galleryConfig, clientId = _a.clientId, applicationGallery = _a.applicationGallery;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getShareWithUserUrl(galleryConfig);
        var data = {
            clientId: clientId,
            appGId: applicationGallery,
            resGId: resourceGId,
            userId: userId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.changeCoverImage = function (resourceGId, coverGId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getChangeCoverImageUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            resourceGId: resourceGId,
            coverGId: coverGId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchText(url, 'POST', true, true, {}, __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].encodeFormPayload(data), __WEBPACK_IMPORTED_MODULE_2____["a" /* HttpContentType */].URLENCODED);
    };
    ApiUtils.getPublishPrice = function (globalId) {
        var galleryConfig = ApiUtils.galleryConfig;
        var url = __WEBPACK_IMPORTED_MODULE_4__url__["b" /* default */].getPublishPriceUrl(galleryConfig);
        var data = {
            clientId: galleryConfig.clientId,
            globalId: globalId,
        };
        return __WEBPACK_IMPORTED_MODULE_2____["d" /* default */].fetchJson(url, 'GET', true, true, data);
    };
    return ApiUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (ApiUtils);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1423)();
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(826)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(299);
var hasOwn = __webpack_require__(115);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DownloadManager_reducer__ = __webpack_require__(28);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var IndexedDBManager = /** @class */ (function () {
    function IndexedDBManager() {
    }
    IndexedDBManager.setGalleryPrefix = function (int, login) {
        IndexedDBManager.prefix = __WEBPACK_IMPORTED_MODULE_1__index__["d" /* default */].getGalleryPrefix(int, login);
    };
    IndexedDBManager.getGalleryPrefix = function () {
        return IndexedDBManager.prefix;
    };
    IndexedDBManager.getNote = function (id) {
        var store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
        return IndexedDBManager.getItem(id, store);
    };
    IndexedDBManager.getNotes = function () {
        var store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
        return IndexedDBManager.getAllItems(store);
    };
    IndexedDBManager.setNote = function (id, data) {
        var store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
        return IndexedDBManager.setItem(id, data, store);
    };
    IndexedDBManager.setNotes = function (notes) {
        var store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
        var entries = [];
        notes.forEach(function (note) { return entries.push([note.id, note]); });
        return IndexedDBManager.setItems(entries, store);
    };
    IndexedDBManager.updateNote = function (id, newData) {
        var store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
        var updater = function (oldData) { return (__assign({}, oldData, newData)); };
        return IndexedDBManager.updateItem(id, updater, store);
    };
    IndexedDBManager.removeNote = function (id) {
        var store = IndexedDBManager.openStore(IndexedDBManager.NOTES_DB_NAME, IndexedDBManager.NOTES_STORE_NAME);
        return IndexedDBManager.removeItem(id, store);
    };
    // Initial access
    IndexedDBManager.wasIndexedDBInitialized = function (isPerApp) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, isInitialized, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.isIndexedDBInitialized, isPerApp);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        isInitialized = _a.sent();
                        return [2 /*return*/, isInitialized || false];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to get initial access from IndexedDB:', error_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setIndexedDBInitialized = function (isPerAppContainer) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.isIndexedDBInitialized, isPerAppContainer);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, true, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Failed to set initial access in IndexedDB:', error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Downloads
    IndexedDBManager.getDownloads = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.downloadsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Failed to get downloads from IndexedDB:', error_3);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setDownloads = function (downloads) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.downloadsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, downloads, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error('Failed to set downloads in IndexedDB:', error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Download groups
    IndexedDBManager.getDownloadGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.downloadDownloadGroupsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        console.error('Failed to get download groups from IndexedDB:', error_5);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setDownloadGroups = function (group, status) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, downloadGroups, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.downloadDownloadGroupsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, IndexedDBManager.getDownloadGroups()];
                    case 2:
                        downloadGroups = (_a.sent()) || {
                            all: __WEBPACK_IMPORTED_MODULE_2__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted,
                            important: __WEBPACK_IMPORTED_MODULE_2__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted,
                            selected: __WEBPACK_IMPORTED_MODULE_2__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted,
                        };
                        downloadGroups[group] = status;
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, downloadGroups, IndexedDBManager.UPREZ_STORE)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_6 = _a.sent();
                        console.error('Failed to set download groups in IndexedDB:', error_6);
                        throw error_6;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Manual downloads
    IndexedDBManager.getPendingSelectedDownloads = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.pendingSelectedDownloadsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        console.error('Failed to get pending selected downloads from IndexedDB:', error_7);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setPendingSelectedDownloads = function (pendingSelectedDownloads) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.pendingSelectedDownloadsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, pendingSelectedDownloads, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.error('Failed to set pending selected downloads in IndexedDB:', error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // MultiAppCredentials
    IndexedDBManager.setMultiAppCredentials = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.multiAppCredentialsKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, credentials, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        console.error('Failed to set credentials in IndexedDB:', error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getMultiAppCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.multiAppCredentialsKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        console.error('Failed to get credentials from IndexedDB:', error_10);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.removeMultiAppCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.multiAppCredentialsKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_11 = _a.sent();
                        console.error('Failed to remove credentials from IndexedDB:', error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // GalleryConfig
    IndexedDBManager.setGalleryConfig = function (storeGalleryConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.galleryConfigKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, storeGalleryConfig, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_12 = _a.sent();
                        console.error('Failed to set gallery config in IndexedDB:', error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getGalleryConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.galleryConfigKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_13 = _a.sent();
                        console.error('Failed to get gallery config from IndexedDB:', error_13);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.removeGalleryConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.galleryConfigKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_14 = _a.sent();
                        console.error('Failed to remove gallery config from IndexedDB:', error_14);
                        throw error_14;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setPreventAutologin = function (prevent) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.preventAutologinKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!prevent) return [3 /*break*/, 3];
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, true, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, IndexedDBManager.removeItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_15 = _a.sent();
                        console.error('Failed to set prevent autologin flag in IndexedDB:', error_15);
                        throw error_15;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getPreventAutologin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, value, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.preventAutologinKey, false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        value = _a.sent();
                        return [2 /*return*/, value === true];
                    case 3:
                        error_16 = _a.sent();
                        console.error('Failed to get prevent autologin flag from IndexedDB:', error_16);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Don't ask again for download popup
    IndexedDBManager.getDownloadPopupDontAskAgain = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.downloadPopupDontAskAgainKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_17 = _a.sent();
                        console.error('Failed to get DownloadPopupDontAskAgain from IndexedDB:', error_17);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setDownloadPopupDontAskAgain = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.downloadPopupDontAskAgainKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, true, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_18 = _a.sent();
                        console.error('Failed to set DownloadPopupDontAskAgain in IndexedDB:', error_18);
                        throw error_18;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // OfflineManager
    IndexedDBManager.getStoreOfflineManager = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.storeOfflineManagerKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_19 = _a.sent();
                        console.error('Failed to get OfflineManager from IndexedDB:', error_19);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setStoreOfflineManager = function (offlineManager) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.storeOfflineManagerKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, offlineManager, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_20 = _a.sent();
                        console.error('Failed to set OfflineManager in IndexedDB:', error_20);
                        throw error_20;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // DisplayType
    IndexedDBManager.getDisplayType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.displayTypeKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_21 = _a.sent();
                        console.error('Failed to get ListDisplayType from IndexedDB:', error_21);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setDisplayType = function (displayType) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.displayTypeKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, displayType, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_22 = _a.sent();
                        console.error('Failed to set ListDisplayType in IndexedDB:', error_22);
                        throw error_22;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // FoldersDisplayType
    // Folders displayType (is set via dropdown inside each folder and has priority over application or backoffice displayType)
    IndexedDBManager.getFoldersDisplayType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.foldersDisplayTypeKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_23 = _a.sent();
                        console.error('Failed to get FoldersDisplayType from IndexedDB:', error_23);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setFolderDisplayType = function (folderId, displayType) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, storageKey, foldersDisplayType, error_24;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.foldersDisplayTypeKey, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, IndexedDBManager.getFoldersDisplayType()];
                    case 2:
                        foldersDisplayType = _b.sent();
                        if (!foldersDisplayType) {
                            foldersDisplayType = (_a = {},
                                _a[folderId] = displayType,
                                _a);
                        }
                        else {
                            foldersDisplayType[folderId] = displayType;
                        }
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, foldersDisplayType, IndexedDBManager.UPREZ_STORE)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_24 = _b.sent();
                        console.error('Failed to set FoldersDisplayType in IndexedDB:', error_24);
                        throw error_24;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.resetFoldersDisplayType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_25;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.foldersDisplayTypeKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_25 = _a.sent();
                        console.error('Failed to reset FoldersDisplayType in IndexedDB:', error_25);
                        throw error_25;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Selection
    IndexedDBManager.getSelection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_26;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.selectionKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_26 = _a.sent();
                        console.error('Failed to get selection from IndexedDB:', error_26);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setSelection = function (selection) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_27;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.selectionKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, selection, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_27 = _a.sent();
                        console.error('Failed to set selection in IndexedDB:', error_27);
                        throw error_27;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getNotesSelection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_28;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.notesSelectionKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_28 = _a.sent();
                        console.error('Failed to get notes selection from IndexedDB:', error_28);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setNotesSelection = function (selection) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_29;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.notesSelectionKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, selection, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_29 = _a.sent();
                        console.error('Failed to set notes selection in IndexedDB:', error_29);
                        throw error_29;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // New items
    IndexedDBManager.getNewItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_30;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.newItemsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_30 = _a.sent();
                        console.error('Failed to get new items from IndexedDB:', error_30);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setNewItems = function (newItems) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_31;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.newItemsKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, newItems, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_31 = _a.sent();
                        console.error('Failed to set new items in IndexedDB:', error_31);
                        throw error_31;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Read status
    IndexedDBManager.getReadStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_32;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.readStatusKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_32 = _a.sent();
                        console.error('Failed to get read status from IndexedDB:', error_32);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setReadStatus = function (readStatus) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_33;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.readStatusKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, readStatus, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_33 = _a.sent();
                        console.error('Failed to set read status in IndexedDB:', error_33);
                        throw error_33;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Gallery infos
    IndexedDBManager.getGalleryInfos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_34;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.galleryInfosKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_34 = _a.sent();
                        console.error('Failed to get gallery infos from IndexedDB:', error_34);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setGalleryInfos = function (galleryInfos) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_35;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.galleryInfosKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, galleryInfos, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_35 = _a.sent();
                        console.error('Failed to set gallery infos in IndexedDB:', error_35);
                        throw error_35;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Drive list
    IndexedDBManager.getStoreDriveList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_36;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.driveListKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_36 = _a.sent();
                        console.error('Failed to get drive list from IndexedDB:', error_36);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setStoreDriveList = function (driveList) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_37;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.driveListKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, driveList, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_37 = _a.sent();
                        console.error('Failed to set drive list in IndexedDB:', error_37);
                        throw error_37;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Authentication credentials
    IndexedDBManager.setCredentials = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_38;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.userInfosKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, credentials, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_38 = _a.sent();
                        console.error('Failed to set credentials in IndexedDB:', error_38);
                        throw error_38;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_39;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.userInfosKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_39 = _a.sent();
                        console.error('Failed to get credentials from IndexedDB:', error_39);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.removeCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_40;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.userInfosKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_40 = _a.sent();
                        console.error('Failed to remove credentials from IndexedDB:', error_40);
                        throw error_40;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Profile infos
    IndexedDBManager.setProfileInfos = function (profileInfos) {
        return __awaiter(this, void 0, void 0, function () {
            var error_41;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IndexedDBManager.setItem(IndexedDBManager.profileInfosKey, profileInfos, IndexedDBManager.UPREZ_STORE)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_41 = _a.sent();
                        console.error('Failed to set profile infos in IndexedDB:', error_41);
                        throw error_41;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getProfileInfos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_42;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IndexedDBManager.getItem(IndexedDBManager.profileInfosKey, IndexedDBManager.UPREZ_STORE)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_42 = _a.sent();
                        console.error('Failed to get profile infos from IndexedDB:', error_42);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.removeProfileInfos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_43;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(IndexedDBManager.profileInfosKey, IndexedDBManager.UPREZ_STORE)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_43 = _a.sent();
                        console.error('Failed to remove profile infos from IndexedDB:', error_43);
                        throw error_43;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Tracking queue
    IndexedDBManager.getTrackingQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_44;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.trackingQueueKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_44 = _a.sent();
                        console.error('Failed to get tracking queue from IndexedDB:', error_44);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setTrackingQueue = function (trackingQueue) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_45;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!IndexedDBManager.prefix) {
                            return [2 /*return*/];
                        }
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.trackingQueueKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, trackingQueue, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_45 = _a.sent();
                        console.error('Failed to set tracking queue in IndexedDB:', error_45);
                        throw error_45;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.removeTrackingQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_46;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.trackingQueueKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_46 = _a.sent();
                        console.error('Failed to remove tracking queue from IndexedDB:', error_46);
                        throw error_46;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Pending tasks
    IndexedDBManager.getPendingTasks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_47;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.pendingTasksKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_47 = _a.sent();
                        console.error('Failed to get pending tasks from IndexedDB:', error_47);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setPendingTasks = function (pendingTasks) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_48;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.pendingTasksKey, true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, pendingTasks, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_48 = _a.sent();
                        console.error('Failed to set pending tasks in IndexedDB:', error_48);
                        throw error_48;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // User locale
    IndexedDBManager.getUserLocale = function (hasPrefix) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_49;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.userLocaleKey, hasPrefix);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.getItem(storageKey, IndexedDBManager.UPREZ_STORE)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_49 = _a.sent();
                        console.error('Failed to get locale from IndexedDB:', error_49);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.setUserLocale = function (locale, hasPrefix) {
        return __awaiter(this, void 0, void 0, function () {
            var storageKey, error_50;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storageKey = IndexedDBManager.getKey(IndexedDBManager.userLocaleKey, hasPrefix);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, IndexedDBManager.setItem(storageKey, locale, IndexedDBManager.UPREZ_STORE)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_50 = _a.sent();
                        console.error('Failed to set locale in IndexedDB:', error_50);
                        throw error_50;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Multi-app server
    IndexedDBManager.setMultiAppServer = function (server) {
        return __awaiter(this, void 0, void 0, function () {
            var error_51;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IndexedDBManager.setItem(IndexedDBManager.multiAppServerKey, server, IndexedDBManager.UPREZ_STORE)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_51 = _a.sent();
                        console.error('Failed to set multi-app server in IndexedDB:', error_51);
                        throw error_51;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.getMultiAppServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_52;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IndexedDBManager.getItem(IndexedDBManager.multiAppServerKey, IndexedDBManager.UPREZ_STORE)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_52 = _a.sent();
                        console.error('Failed to get multi-app server from IndexedDB:', error_52);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.removeMultiAppServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_53;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, IndexedDBManager.removeItem(IndexedDBManager.multiAppServerKey, IndexedDBManager.UPREZ_STORE)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_53 = _a.sent();
                        console.error('Failed to remove multi-app server from IndexedDB:', error_53);
                        throw error_53;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDBManager.openStore = function (dbName, storeName, hasPrefix) {
        if (hasPrefix === void 0) { hasPrefix = true; }
        // opens existing store or creates a new if it doesn't exist
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["a" /* createStore */])(hasPrefix ? this.prefix + "-" + dbName : "" + dbName, storeName);
    };
    IndexedDBManager.getItem = function (key, store) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["c" /* get */])(key, store);
    };
    IndexedDBManager.getAllItems = function (store) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["g" /* values */])(store);
    };
    // tslint:disable-next-line no-any
    IndexedDBManager.setItem = function (key, value, store) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["d" /* set */])(key, value, store);
    };
    // tslint:disable-next-line no-any
    IndexedDBManager.setItems = function (items, store) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["e" /* setMany */])(items, store);
    };
    IndexedDBManager.updateItem = function (key, updater, store) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["f" /* update */])(key, updater, store);
    };
    IndexedDBManager.removeItem = function (key, store) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_idb_keyval_dist_esm_compat__["b" /* del */])(key, store);
    };
    IndexedDBManager.getKey = function (key, needsPrefix) {
        return needsPrefix ? IndexedDBManager.prefix + "-" + key : key;
    };
    IndexedDBManager.NOTES_DB_NAME = 'gallApp-notes';
    IndexedDBManager.NOTES_STORE_NAME = 'notes';
    IndexedDBManager.UPREZ_DB_NAME = 'UprezAppDB';
    IndexedDBManager.UPREZ_STORE_NAME = 'uprezAppStore';
    IndexedDBManager.UPREZ_STORE = IndexedDBManager.openStore(IndexedDBManager.UPREZ_DB_NAME, IndexedDBManager.UPREZ_STORE_NAME, false);
    IndexedDBManager.isIndexedDBInitialized = 'uprez-isIndexedDBInitialized';
    IndexedDBManager.downloadsKey = 'uprez-downloads';
    IndexedDBManager.downloadDownloadGroupsKey = 'uprez-downloadGroups';
    IndexedDBManager.pendingSelectedDownloadsKey = 'uprez-pendingSelectedDownloads';
    IndexedDBManager.multiAppCredentialsKey = 'uprez-multiAppCredentials';
    IndexedDBManager.galleryConfigKey = 'uprez-galleryConfig';
    IndexedDBManager.preventAutologinKey = 'uprez-preventAutologin';
    IndexedDBManager.downloadPopupDontAskAgainKey = 'uprez-downloadPopupDontAskAgain';
    IndexedDBManager.storeOfflineManagerKey = 'uprez-offlineManager';
    IndexedDBManager.displayTypeKey = 'uprez-driveItemListDisplayType';
    IndexedDBManager.foldersDisplayTypeKey = 'uprez-foldersDisplayType';
    IndexedDBManager.selectionKey = 'uprez-favorites';
    IndexedDBManager.notesSelectionKey = 'uprez-selectedNotes';
    IndexedDBManager.newItemsKey = 'uprez-newItems';
    IndexedDBManager.readStatusKey = 'uprez-readStatus';
    IndexedDBManager.galleryInfosKey = 'uprez-galleryInfos';
    IndexedDBManager.driveListKey = 'uprez-driveList';
    IndexedDBManager.userInfosKey = 'uprez-userInfos';
    IndexedDBManager.profileInfosKey = 'uprez-profileInfos';
    IndexedDBManager.multiAppServerKey = 'uprez-multiAppServer';
    IndexedDBManager.trackingQueueKey = 'uprez-trackingQueue';
    IndexedDBManager.pendingTasksKey = 'uprez-pendingTasks';
    IndexedDBManager.userLocaleKey = 'uprez-userLocale';
    return IndexedDBManager;
}());
// Expose setDownloads to window for console access
if (typeof window !== 'undefined') {
    // tslint:disable-next-line:no-any
    window.setDownloads = function (downloads) {
        return IndexedDBManager.setDownloads(downloads);
    };
}
/* harmony default export */ __webpack_exports__["a"] = (IndexedDBManager);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DriveItemListOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return myDocumentsNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TagMarkers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_api__ = __webpack_require__(10);

var DriveItemListOrigin;
(function (DriveItemListOrigin) {
    DriveItemListOrigin["Folder"] = "folder";
    DriveItemListOrigin["Selection"] = "selection";
    DriveItemListOrigin["New"] = "new";
    DriveItemListOrigin["Search"] = "search";
    DriveItemListOrigin["Assortment"] = "assortment";
    DriveItemListOrigin["Downloads"] = "downloads";
})(DriveItemListOrigin || (DriveItemListOrigin = {}));
var TagMarkers;
(function (TagMarkers) {
    TagMarkers["Start"] = "tags[";
    TagMarkers["End"] = "]";
})(TagMarkers || (TagMarkers = {}));
var myDocumentsNavItems = [
    {
        label: 'downloads',
        type: __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory,
        origin: DriveItemListOrigin.Downloads
    },
    {
        label: 'new',
        type: __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory,
        origin: DriveItemListOrigin.New
    }
];



/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiUrls; });
/* unused harmony export urlUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(51);
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var ApiUrls;
(function (ApiUrls) {
    ApiUrls["AUTH"] = "services/rest/loginWs/";
    ApiUrls["MEMBERSHIP"] = "services/rest/membershipWs/";
    ApiUrls["DRIVE"] = "services/rest/workspaceManagerWs/";
    ApiUrls["ENRICHMENT"] = "services/rest/enrichmentWs/";
    ApiUrls["GENERATION"] = "services/rest/generationWs/";
    ApiUrls["COMPONENT"] = "services/rest/pageManagerWs/";
    ApiUrls["GALLERY"] = "services/rest/galleryManagerWs/";
    ApiUrls["CUSTOMIZATION"] = "services/rest/customizationWs/";
    ApiUrls["LICENCE"] = "services/rest/licenceWs/";
})(ApiUrls || (ApiUrls = {}));
var UrlUtils = /** @class */ (function () {
    function UrlUtils() {
    }
    // ----- URL Generators
    // returns a the result of a final URL function
    UrlUtils.getUrlAuthentication = function (galleryConfig, isSharable) {
        var keepHashbang = isSharable;
        var hash = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].getPathAuthentication(keepHashbang);
        return UrlUtils.getGallAppUrl(galleryConfig, hash);
    };
    UrlUtils.getUrlHome = function (galleryConfig, isSharable) {
        var keepHashbang = isSharable;
        var hash = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].getPathHome(keepHashbang);
        return UrlUtils.getGallAppUrl(galleryConfig, hash);
    };
    UrlUtils.getUrlParameters = function (galleryConfig, isSharable) {
        var keepHashbang = isSharable;
        var hash = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].getPathParameters(keepHashbang);
        return UrlUtils.getGallAppUrl(galleryConfig, hash);
    };
    UrlUtils.getUrlDriveItemListPage = function (galleryConfig, origin, originParam, isSharable) {
        var keepHashbang = isSharable;
        var hash = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].getPathDriveItemListPage(origin, originParam, keepHashbang);
        return UrlUtils.getGallAppUrl(galleryConfig, hash);
    };
    UrlUtils.getUrlDriveItemDetailPage = function (galleryConfig, driveItemId, driveFolderId, isSharable) {
        var keepHashbang = isSharable;
        var hash = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].getPathDriveItemDetailPage(driveItemId, driveFolderId, keepHashbang);
        return UrlUtils.getGallAppUrl(galleryConfig, hash);
    };
    UrlUtils.getUrlTheater = function (galleryConfig, origin, originParam, driveItemId, isSharable) {
        var keepHashbang = isSharable;
        var hash = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */].getPathTheater(origin, originParam, driveItemId, keepHashbang);
        return UrlUtils.getGallAppUrl(galleryConfig, hash);
    };
    UrlUtils.getApiGalleryUrl = function (galleryConfig, api) {
        return this.getApiItemUrl(galleryConfig, galleryConfig.applicationGallery, api);
    };
    UrlUtils.getChildrenUrl = function (galleryConfig, driveItemId) {
        var api = "_children.json";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getChildrenMetaUrl = function (galleryConfig, driveItemId) {
        var api = "_childrenMeta.json";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getAppMetaUrl = function (galleryConfig, driveItemId) {
        var api = "_appMeta.json";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getMetaUrl = function (galleryConfig, driveItemId, ancestorId) {
        // childOf param is needed to get parent folder (linkParentId) id of linked resource (e.g., modifiable publication)
        var api = "_meta.json" + (ancestorId ? "?childOf=" + ancestorId : '');
        var url = UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
        return url;
    };
    UrlUtils.getContentBlockUrl = function (galleryConfig, driveItemId, block) {
        var api = "_content-block-" + block + ".json";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getResourceZipUrl = function (galleryConfig, driveItemId) {
        var api = "_resource.zip";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getAttachmentUrl = function (galleryConfig, driveItemId) {
        var api = "_attachment";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getNewContentsUrl = function (galleryConfig) {
        var api = "_new.json";
        return UrlUtils.getApiGalleryUrl(galleryConfig, api);
    };
    UrlUtils.removeTrailingChar = function (queryString, character) {
        if (character === void 0) { character = '&'; }
        return queryString.slice(-1) === character ? queryString = queryString.slice(0, -1) : queryString;
    };
    UrlUtils.getSearchQuery = function (searchString) {
        var query = '';
        if (searchString) {
            var regex = /tags\[(.*)\]/g;
            var match = regex.exec(searchString);
            if (match) {
                // Remove the match from the searchString
                query += encodeURIComponent(UrlUtils.removeTrailingChar(searchString.replace(match[0], '').trim()));
                // Add each tag to the url
                var tagsArray = match[1].split(',');
                tagsArray.forEach(function (tag) {
                    query += "&tag=" + encodeURIComponent(tag.trim());
                });
            }
            else {
                query += encodeURIComponent(searchString);
            }
        }
        return query;
    };
    UrlUtils.getSearchUrl = function (galleryConfig, searchString) {
        var api = "_search.json?expr=" + this.getSearchQuery(searchString);
        return UrlUtils.getApiGalleryUrl(galleryConfig, api);
    };
    UrlUtils.getDownloadPDFUrl = function (galleryConfig, searchString) {
        var api = "_dlSearchResults.pdf?expr=" + this.getSearchQuery(searchString);
        return UrlUtils.getApiGalleryUrl(galleryConfig, api);
    };
    UrlUtils.getGalleryAssetUrl = function (galleryConfig, driveItemId) {
        var api = "_find.json?id=" + driveItemId;
        return UrlUtils.getApiGalleryUrl(galleryConfig, api);
    };
    UrlUtils.getTemplateUrl = function (fileName, galleryConfig, server) {
        if (server) {
            var driveUrl = __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][server].driveUrl;
            var templateUrl = "" + driveUrl + galleryConfig.clientId + "/" + galleryConfig.applicationGallery + "/.gallery/config/" + fileName;
            return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(templateUrl);
        }
        return UrlUtils.getConfigFileUrl(galleryConfig, fileName);
    };
    UrlUtils.getConfigUrl = function (server, clientId, galleryId) {
        var driveUrl = __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][server].driveUrl;
        var url = "" + driveUrl + clientId + "/" + galleryId + "/.gallery/config/config.json";
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getStatisticsUrl = function (galleryConfig) {
        var fileName = "statistics.xml";
        return UrlUtils.getConfigFileUrl(galleryConfig, fileName);
    };
    UrlUtils.getLoginJsonUrl = function (galleryConfig) {
        return this.getRootApiGallery(galleryConfig) + "_login.json";
    };
    UrlUtils.getSamlAuthenticationPage = function (params) {
        return "https://fr.zone-secure.net/saml-login/" + params;
    };
    UrlUtils.isSamlIframeRedirectionUrl = function (iframeLocation, appConfig) {
        var galleryUrl = "" + this.getRootApiGallery(appConfig);
        return iframeLocation.includes(galleryUrl);
    };
    // ----- Final URLs
    // complete URL with credential if needed
    // Don't add credential to this url, url shared to contacts
    UrlUtils.getGallAppUrl = function (galleryConfig, hash) {
        return this.getRootApiGallery(galleryConfig) + "/#" + hash;
    };
    UrlUtils.getLoginToAspUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "appLogin");
    };
    UrlUtils.getRefreshSessionUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "refresh");
    };
    UrlUtils.getLogoutFromAspUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "logout");
    };
    UrlUtils.getLogoutFromApplication = function (galleryConfig, isDifferentAppUrls) {
        // there can be different application urls from ASP_SERVERS and from galleryConfig
        if (isDifferentAppUrls) {
            var _a = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getState().galleryInfos.config, clientId = _a.clientId, applicationGallery = _a.applicationGallery;
            var appUrl = __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].multiAppAuthenticationServer].driveUrl;
            return "" + appUrl + clientId + "/" + applicationGallery + "_logout";
        }
        return UrlUtils.getApplicationUrl(galleryConfig) + "_logout";
    };
    UrlUtils.getResetAspPasswordUrl = function (galleryConfig, company) {
        var driveUrl = __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].multiAppAuthenticationServer].driveUrl;
        var companyParam = company ? "?org=" + encodeURIComponent(company) : '';
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol(driveUrl + "login/app/" + companyParam + "#forgot_password");
    };
    UrlUtils.getCreateDemoAccountUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.MEMBERSHIP + "createDemoAccount");
    };
    UrlUtils.getFreeUrlAppLoginUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "extAuth");
    };
    UrlUtils.getCrmAccountsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.MEMBERSHIP + "getCrmContacts");
    };
    UrlUtils.getAuthMethodsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "getAuthMethods");
    };
    UrlUtils.getOrgLoginUrl = function (galleryConfig, orgName) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "orgLogin" + (orgName ? "?isApp=" + __WEBPACK_IMPORTED_MODULE_2__userAgent__["a" /* default */].isMobileApp + "&org=" + encodeURIComponent(orgName) : ''));
    };
    UrlUtils.getLoginUrl = function (galleryConfig, login, password) {
        // TODO: Test this method when Secured Galleries applications login form will work again
        var url = UrlUtils.getLoginJsonUrl(galleryConfig);
        return UrlUtils.addCredentials(url, login, password);
    };
    UrlUtils.getCheckSessionUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.AUTH + "check");
    };
    UrlUtils.getItemOriginalFileUrl = function (galleryConfig, originalFile) {
        var url = UrlUtils.getRootApiClient(galleryConfig) + "/" + originalFile;
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getUrlFromRelUrlWithMediaParam = function (relUrl, galleryConfig) {
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(relUrl.replace(UrlUtils.mediaParamRegex, UrlUtils.getRootApiClient(galleryConfig) + "/"));
    };
    UrlUtils.getImageUrl = function (galleryConfig, driveItem, size, extension, isThumb) {
        var useIcon = driveItem.type !== __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Image || isThumb;
        var imageId = useIcon ? __WEBPACK_IMPORTED_MODULE_5__driveItem__["d" /* default */].getIconId(driveItem) : driveItem.id;
        var url = this.getRootApiItem(galleryConfig, imageId) + "_" + (size.box ? 'box-' : '') + size.width + "x" + size.height + "." + extension;
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getPublicationUrl = function (galleryConfig, driveItem, page, isForMobileApp, isShare, hideWelcomePage, customSearchParams) {
        if (page === void 0) { page = 1; }
        if (isForMobileApp === void 0) { isForMobileApp = false; }
        if (isShare === void 0) { isShare = false; }
        if (hideWelcomePage === void 0) { hideWelcomePage = false; }
        if (customSearchParams === void 0) { customSearchParams = {}; }
        var publicationUrlParams = this.getPublicationUrlParams(page, isForMobileApp, hideWelcomePage, customSearchParams);
        var url = this.getRootApiItem(galleryConfig, driveItem.id, !isShare) + "/index.html" + publicationUrlParams;
        if (isShare) {
            return url;
        }
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getPublicationUrlParams = function (page, isForMobileApp, hideWelcomePage, customSearchParams) {
        if (page === void 0) { page = 1; }
        if (isForMobileApp === void 0) { isForMobileApp = false; }
        if (hideWelcomePage === void 0) { hideWelcomePage = false; }
        if (customSearchParams === void 0) { customSearchParams = {}; }
        var e_1, _a;
        var publicationUrlParams = '?';
        if (page !== 1) {
            var startPageParam = "startPage=" + page + "&";
            publicationUrlParams += startPageParam;
        }
        if (customSearchParams) {
            var params = '';
            try {
                for (var _b = __values(Object.entries(customSearchParams)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), paramKey = _d[0], paramValue = _d[1];
                    params += paramKey + "=" + paramValue + "&";
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            publicationUrlParams += params;
        }
        if (isForMobileApp) {
            // nativeReq param is needed to handle a case when calls are made to several domains (different application urls from ASP_SERVERS and from galleryConfig)
            var mobileAppParameters = 'isApp=true&backHome=true&nativeReq=true&';
            publicationUrlParams += mobileAppParameters;
        }
        if (hideWelcomePage) {
            var hideWelcomePageParam = 'initState=nowelcomepage';
            publicationUrlParams += hideWelcomePageParam;
        }
        // Remove "?" from URL if no params are added
        if (page === 1 && !isForMobileApp && !hideWelcomePage) {
            publicationUrlParams = '';
        }
        if (publicationUrlParams[publicationUrlParams.length - 1] === '&') {
            publicationUrlParams = publicationUrlParams.slice(0, -1);
        }
        return publicationUrlParams;
    };
    UrlUtils.getPublicationCoverUrl = function (galleryConfig, driveItem, pageIndex) {
        var rootUrl = UrlUtils.getRootApiClient(galleryConfig);
        var cover = driveItem.thumbsPath ? __WEBPACK_IMPORTED_MODULE_5__driveItem__["d" /* default */].getPublicationCover(driveItem.thumbsPath, pageIndex + 1) : '';
        var url = rootUrl + "/" + driveItem.id + "/" + cover;
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getRootApiClient = function (galleryConfig, forceDefaultDomain) {
        var isMaster = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isMaster(galleryConfig);
        if (isMaster) {
            return this.getMasterRootApi(galleryConfig);
        }
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_2__userAgent__["a" /* default */].isMobileApp;
        if (isMobileApp || "production" !== 'production' || __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isEmbedMode()) {
            return "" + UrlUtils.getConfiguredRootApiClient(galleryConfig, forceDefaultDomain);
        }
        return "" + this.getRelativeRootApi();
    };
    UrlUtils.getConfiguredRootApiClient = function (galleryConfig, forceDefaultDomain) {
        var clientId = galleryConfig.clientId;
        return this.getConfiguredRootApi(galleryConfig, forceDefaultDomain) + "/" + clientId;
    };
    UrlUtils.getRootApiGallery = function (galleryConfig) {
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_2__userAgent__["a" /* default */].isMobileApp;
        if (isMobileApp) {
            var applicationGallery = galleryConfig.applicationGallery;
            return this.getRootApiItem(galleryConfig, applicationGallery);
        }
        return "" + window.location.origin + window.location.pathname;
    };
    UrlUtils.getIndesignEditorDataUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.ENRICHMENT + "getPubliEditData");
    };
    UrlUtils.getHtmlEditorDataUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.COMPONENT + "getPageEnrichmentInfo");
    };
    UrlUtils.getEditorResourceUrl = function (galleryConfig, resourceId, relPath) {
        var resourceRoot = UrlUtils.getRootApiItem(galleryConfig, resourceId);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + resourceRoot + (relPath ? '/' + relPath : ''));
    };
    UrlUtils.getSaveIndesignEditorPageUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.ENRICHMENT + "saveEditedEpubPage");
    };
    UrlUtils.getSaveEditedAccessiblePageUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.ENRICHMENT + "saveEditedAccessiblePage");
    };
    UrlUtils.getSaveIndesignEditorConfigsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.ENRICHMENT + "savePubliConfigsJson");
    };
    UrlUtils.getSaveIndesignEditorThemesCssUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.ENRICHMENT + "saveThemesCss");
    };
    UrlUtils.getSaveHtmlEditorPageUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.COMPONENT + "saveComponentPage");
    };
    UrlUtils.getCreateComboUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "createComboPublication");
    };
    UrlUtils.getCreateComboWithExternalSpreadsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "includeExtPages");
    };
    UrlUtils.getPublicationProgressUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "getPublicationProgress");
    };
    UrlUtils.getImportFileUrl = function (galleryConfig, fileName, isOptimizedImageImport) {
        var host = UrlUtils.getHost(galleryConfig);
        var fileExtension = "." + __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getFileExtension(fileName);
        var service = __WEBPACK_IMPORTED_MODULE_5__driveItem__["d" /* default */].imageWithPdfExtensions.includes(fileExtension) &&
            fileExtension !== '.svg' &&
            isOptimizedImageImport
            ? 'importImage'
            : 'importFile';
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + service);
    };
    UrlUtils.getSetAsTemplateUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "createProposalTpl");
    };
    UrlUtils.getRemoveTemplateUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "deleteProposalTpl");
    };
    UrlUtils.getPublicationTemplatesUrl = function (galleryConfig, driveItemId) {
        var api = "_templates.json";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getCreatePublicationFromMasterTemplateUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "copyPublication");
    };
    UrlUtils.getCreateProposalFromDesktopFileUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "createProposal");
    };
    UrlUtils.getCreateProposalFromDriveItemUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "convertToProposal");
    };
    UrlUtils.getSharePublicationUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "createSharedResourceLink");
    };
    UrlUtils.getRenameResourceUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "updateResourceName");
    };
    UrlUtils.getTrashResourcesUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "trashResources");
    };
    UrlUtils.getRemovePublicationPagesUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "deletePublicationPages");
    };
    UrlUtils.getMovePublicationPagesUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "movePages");
    };
    UrlUtils.getDuplicatePublicationPagesUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "duplicatePages");
    };
    UrlUtils.getReprocessPublicationThumbsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "reprocessPagePrintables");
    };
    UrlUtils.getApplicationUrl = function (galleryConfig) {
        var applicationGallery = galleryConfig.applicationGallery;
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol(this.getRootApiItem(galleryConfig, applicationGallery));
    };
    UrlUtils.getProfileDataUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.MEMBERSHIP + "getProfileInfo");
    };
    UrlUtils.getEditProfileDataUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.MEMBERSHIP + "editProfile");
    };
    UrlUtils.getProposalsByTypeUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "getProposalsByType");
    };
    UrlUtils.getMoveResourcesOrderUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "moveResourcesOrder");
    };
    UrlUtils.getMoveResourcesUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "moveResources");
    };
    UrlUtils.getArchiveResourcesUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GALLERY + "archiveResources");
    };
    UrlUtils.getNotesUrl = function (galleryConfig, driveItemId) {
        var api = '_notes.json';
        var url = UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
        return url;
    };
    UrlUtils.getSaveNoteUrl = function (galleryConfig, driveItemId) {
        var api = '_notes';
        var url = UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
        return url;
    };
    UrlUtils.getResourceUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "getResource");
    };
    UrlUtils.getCustomerContextUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "getCustomerContext");
    };
    UrlUtils.getCreateComponentUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.COMPONENT + "createPage");
    };
    UrlUtils.getPublicationSettingsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "getPublicationSettings");
    };
    UrlUtils.getSavePublicationSettingsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "updatePublicationSettings");
    };
    UrlUtils.getPublicationPdfSettingsUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.CUSTOMIZATION + "getPubliPdfInfo");
    };
    UrlUtils.getSavePublicationPdfOptionUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.CUSTOMIZATION + "updatePdfOption");
    };
    UrlUtils.getImportPublicationPdfUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "updatePdfweb");
    };
    UrlUtils.getPublicationIntegrationUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "getPubliIntegrationInfo");
    };
    UrlUtils.getUpdateOriginalPublicationUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.GENERATION + "copyTempVersion");
    };
    UrlUtils.getAcquireLockUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "acquireLock");
    };
    UrlUtils.getReleaseLockUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "releaseLock");
    };
    UrlUtils.getShareUsersUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.MEMBERSHIP + "getShareUsers");
    };
    UrlUtils.getShareWithUserUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.MEMBERSHIP + "shareWithUser");
    };
    UrlUtils.getChangeCoverImageUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "changeCoverImage");
    };
    UrlUtils.getPublishPriceUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.LICENCE + "getPublishPrice");
    };
    UrlUtils.getItemUrl = function (galleryConfig, driveItemId) {
        var url = UrlUtils.getRootApiItem(galleryConfig, driveItemId);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getApiItemUrl = function (galleryConfig, driveItemId, api) {
        var url = "" + UrlUtils.getRootApiItem(galleryConfig, driveItemId) + api;
        // TODO: check why needToken was needed
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    UrlUtils.getConfigFileUrl = function (galleryConfig, fileName) {
        var url = this.getRootApiGallery(galleryConfig) + "/.gallery/config/" + fileName;
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    // ----- Root URLs
    // not used directly, Final Urls append things to it and add credentials if needed
    UrlUtils.getRootApiItem = function (galleryConfig, driveItemId, forceDefaultDomain) {
        var rootApiClient = this.getRootApiClient(galleryConfig, forceDefaultDomain);
        var normalizedRootApiClient;
        if (driveItemId) {
            normalizedRootApiClient = rootApiClient.endsWith('/') ? rootApiClient.slice(0, -1) : rootApiClient;
        }
        else {
            normalizedRootApiClient = rootApiClient;
        }
        return "" + normalizedRootApiClient + (driveItemId ? '/' + driveItemId : '');
    };
    UrlUtils.getMasterRootApi = function (galleryConfig) {
        var mediaPath = galleryConfig.mediaPath;
        return "" + (mediaPath ? mediaPath : '');
    };
    UrlUtils.getConfiguredRootApi = function (galleryConfig, forceDefaultDomain) {
        if (forceDefaultDomain === void 0) { forceDefaultDomain = true; }
        var applicationUrl = galleryConfig.applicationUrl;
        var driveUrl = __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].multiAppAuthenticationServer].driveUrl;
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_2__userAgent__["a" /* default */].isMobileApp;
        var rootApi = isMobileApp && forceDefaultDomain ?
            driveUrl :
            applicationUrl;
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithCorrectProtocol(rootApi);
    };
    UrlUtils.getRelativeRootApi = function () {
        // Get the part before /${customClientPath}/-/ or /${galleryId}
        return new URL('../', window.location.href).href;
    };
    // ----- Helpers
    UrlUtils.addCredentials = function (url, login, password) {
        var includesSeparator = url.includes('?');
        var startingSeparator = includesSeparator ? '&' : '?';
        var params = [];
        params.push("user=" + encodeURIComponent(login));
        params.push("pass=" + encodeURIComponent(password));
        return "" + url + startingSeparator + params.join('&');
    };
    UrlUtils.getHost = function (galleryConfig) {
        var host = '';
        if (__WEBPACK_IMPORTED_MODULE_2__userAgent__["a" /* default */].isMobileApp) {
            host = __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_constants__["a" /* ASP_SERVERS */][__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].multiAppAuthenticationServer].url;
        }
        else if (galleryConfig.service) {
            var _a = galleryConfig.service, configHost = _a.host, configDirectHost = _a.directHost;
            host = __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isEmbedMode() || __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].isOpenedFromAdmin()
                ? configHost
                : configDirectHost || configHost;
        }
        return host[host.length - 1] === '/' ? host : host + '/';
    };
    UrlUtils.mediaParamRegex = /\$media\$|\${media}/;
    UrlUtils.getOutcomingsUrl = function (galleryConfig, driveItemId) {
        var api = "_outcomings.json";
        return UrlUtils.getApiItemUrl(galleryConfig, driveItemId, api);
    };
    UrlUtils.getWelcomePageUrl = function (galleryInfos) {
        var template = galleryInfos.template, config = galleryInfos.config;
        if (template && template.welcomepage && template.welcomepage.url) {
            return UrlUtils.getItemUrl(config, __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getMediaId(template.welcomepage.url));
        }
        return '';
    };
    UrlUtils.getResourcesGroupUrl = function (galleryConfig, ids) {
        var service = galleryConfig.service, clientId = galleryConfig.clientId;
        if (!service) {
            return '';
        }
        var parsedIds = encodeURIComponent(JSON.stringify(ids));
        var encodedToken = encodeURIComponent(service.token);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithCorrectProtocol(service.host + "/" + service.download.service + "?clientId=" + clientId + "&ids=" + parsedIds + "&token=" + encodedToken);
    };
    UrlUtils.getShareServiceUrl = function (galleryConfig) {
        var applicationGallery = galleryConfig.applicationGallery;
        var shareServiceUrl = UrlUtils.getConfiguredRootApiClient(galleryConfig) + "/" + applicationGallery + "_share";
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(shareServiceUrl);
    };
    UrlUtils.getCreatePrivateFolderUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "createDriveWithLinks");
    };
    UrlUtils.getCreateExternalLinkUrl = function (galleryConfig) {
        var host = UrlUtils.getHost(galleryConfig);
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlWithHttpsProtocol("" + host + ApiUrls.DRIVE + "createExternalLink");
    };
    UrlUtils.getComponentUrl = function (galleryInfos, componentId) {
        var config = galleryInfos.config;
        var url = UrlUtils.getRootApiItem(config, componentId) + '/index.html';
        return __WEBPACK_IMPORTED_MODULE_3____["d" /* default */].getUrlForSecuredResource(url);
    };
    return UrlUtils;
}());
var urlUtils = new UrlUtils;
/* harmony default export */ __webpack_exports__["b"] = (UrlUtils);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DownloadGroupStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DownloadMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DownloadStatus; });
/* harmony export (immutable) */ __webpack_exports__["e"] = downloadManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var getInitialState = function () { return ({
    downloadGroups: getInitialDownloadGroups(),
    isDeletingAll: false,
    isDownloadToastClosed: false,
    isMarkingItemForDeletion: false,
    items: {},
    pendingSelectedDownloads: {},
    totalSelectedDownloadsCount: 0,
    downloadInProgressItems: [],
    downloadInProgressDependencies: [],
}); };
var getInitialDownloadGroups = function () { return ({
    all: getInitialDownloadGroup(),
    important: getInitialDownloadGroup(),
    selected: getInitialDownloadGroup(),
}); };
var getInitialDownloadGroup = function () { return ({
    isDownloading: false,
    status: DownloadGroupStatus.NotStarted,
}); };
var DownloadGroupName;
(function (DownloadGroupName) {
    DownloadGroupName["ALL"] = "all";
    DownloadGroupName["IMPORTANT"] = "important";
    DownloadGroupName["SELECTED"] = "selected";
})(DownloadGroupName || (DownloadGroupName = {}));
var DownloadGroupStatus;
(function (DownloadGroupStatus) {
    DownloadGroupStatus["NotStarted"] = "notStarted";
    DownloadGroupStatus["Started"] = "started";
    DownloadGroupStatus["Finished"] = "finished";
})(DownloadGroupStatus || (DownloadGroupStatus = {}));
var DownloadMode;
(function (DownloadMode) {
    DownloadMode["Temp"] = "temporary";
    DownloadMode["Requested"] = "requested";
    DownloadMode["Dependency"] = "dependency";
    DownloadMode["Required"] = "required";
    DownloadMode["Unspecified"] = "unspecified"; // For cases where the download mode is not defined
})(DownloadMode || (DownloadMode = {}));
var DownloadStatus;
(function (DownloadStatus) {
    DownloadStatus["NOT_DOWNLOADED"] = "NOT_DOWNLOADED";
    DownloadStatus["INIT"] = "INIT";
    DownloadStatus["GETTING_DEPENDENCIES"] = "GETTING_DEPENDENCIES";
    DownloadStatus["NATIVE_DOWNLOADING"] = "NATIVE_DOWNLOADING";
    DownloadStatus["NATIVE_DOWNLOADED"] = "NATIVE_DOWNLOADED";
    DownloadStatus["ERROR"] = "ERROR";
    DownloadStatus["UPDATING"] = "UPDATING";
    DownloadStatus["STARTING_UPDATE"] = "STARTING_UPDATE";
    DownloadStatus["STARTING_DOWNLOAD"] = "STARTING_DOWNLOAD";
    DownloadStatus["RESUMING_DOWNLOAD"] = "RESUMING_DOWNLOAD";
    DownloadStatus["STARTING_DELETION"] = "STARTING_DELETION";
})(DownloadStatus || (DownloadStatus = {}));
var downloadManagerItemInitialState = {
    mode: DownloadMode.Unspecified,
    status: DownloadStatus.NOT_DOWNLOADED,
    version: -1,
    dependencies: [],
    dependents: []
};
function downloadManager(state, action) {
    if (state === void 0) { state = getInitialState(); }
    var newState = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(state);
    var item;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].SET_DOWNLOAD_GROUP_STATUS:
            newState.downloadGroups[action.group].status = action.status;
            newState.downloadGroups[action.group].isDownloading = action.status === DownloadGroupStatus.Started;
            if (action.status === DownloadGroupStatus.Started) {
                newState.isDownloadToastClosed = false;
            }
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].SET_DELETE_ALL_STATUS:
            newState.isDeletingAll = action.isDeletingAll;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].SET_IS_MARKING_ITEM_FOR_DELETION:
            newState.isMarkingItemForDeletion = action.isMarkingItemForDeletion;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].INIT_PREVIOUS_DOWNLOAD_GROUPS:
            newState.downloadGroups.all.status = action.downloadGroupStatus;
            newState.downloadGroups.important.status = action.downloadImportantStatus;
            newState.downloadGroups.selected.status = action.downloadSelectedStatus;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].INIT_DOWNLOADS:
            action.downloads.forEach(function (item) { return newState.items[item.id] = {
                mode: item.mode,
                status: item.status,
                version: item.version,
                dependencies: item.dependencies,
                dependents: item.dependents,
            }; });
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].INIT_SELECTED_DOWNLOADS:
            action.pendingSelectedDownloads.forEach(function (item) {
                if (item && item.driveItemId) {
                    newState.pendingSelectedDownloads[item.driveItemId] = {
                        driveItemId: item.driveItemId,
                    };
                }
            });
            newState.totalSelectedDownloadsCount = action.pendingSelectedDownloads.length;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].ADD_ITEM:
            var newItem = getItemFromMap(newState.items, action.id);
            newItem.mode = action.mode;
            newItem.dependencies = action.dependencies;
            newItem.dependents = action.dependents;
            newItem.version = action.version;
            newItem.status = DownloadStatus.INIT;
            newState.items[action.id] = newItem;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].ADD_SELECTED_DOWNLOAD_ITEM:
            if (newState.pendingSelectedDownloads[action.driveItemId]) {
                return state;
            }
            var newPendingSelectedDownloadItem = getSelectedDownloadItemFromMap(newState.pendingSelectedDownloads, action.driveItemId);
            newPendingSelectedDownloadItem.driveItemId = action.driveItemId;
            newState.pendingSelectedDownloads[action.driveItemId] = newPendingSelectedDownloadItem;
            newState.totalSelectedDownloadsCount = state.totalSelectedDownloadsCount + 1;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].ADD_DOWNLOAD_IN_PROGRESS_ITEM:
            if (!newState.downloadInProgressItems.includes(action.driveItemId)) {
                newState.downloadInProgressItems = __spread(newState.downloadInProgressItems, [action.driveItemId]);
            }
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].ADD_DOWNLOAD_IN_PROGRESS_DEPENDENCY:
            if (!newState.downloadInProgressDependencies.includes(action.dependencyId)) {
                newState.downloadInProgressDependencies = __spread(newState.downloadInProgressDependencies, [action.dependencyId]);
            }
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].UPDATE_STATUS:
            item = getItemFromMap(newState.items, action.id);
            item.status = action.status;
            newState.items[action.id] = item;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].SET_REQUEST_ID:
            item = getItemFromMap(newState.items, action.id);
            item.requestId = action.requestId;
            item.status = action.isUpdating ? DownloadStatus.UPDATING : DownloadStatus.NATIVE_DOWNLOADING;
            newState.items[action.id] = item;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].RECORD_DOWNLOAD_PROGRESS:
            item = getItemFromMap(newState.items, action.id);
            item.progress = action.progress;
            newState.items[action.id] = item;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].UPDATE_DOWNLOAD:
            item = getItemFromMap(newState.items, action.id);
            item.mode = action.mode;
            item.dependencies = action.dependencies;
            item.dependents = action.dependents;
            item.version = action.version;
            newState.items[action.id] = item;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].REMOVE_DOWNLOAD:
            delete newState.items[action.id];
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].REMOVE_PENDING_SELECTED_DOWNLOAD_ITEM:
            delete newState.pendingSelectedDownloads[action.driveItemId];
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].REMOVE_DOWNLOAD_IN_PROGRESS_ITEM:
            newState.downloadInProgressItems = newState.downloadInProgressItems.filter(function (id) { return id !== action.driveItemId; });
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].REMOVE_DOWNLOAD_IN_PROGRESS_DEPENDENCY:
            newState.downloadInProgressDependencies = newState.downloadInProgressDependencies.filter(function (id) { return id !== action.dependencyId; });
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].RESET_TOTAL_SELECTED_DOWNLOAD_ITEMS:
            newState.totalSelectedDownloadsCount = 0;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].RESET_PENDING_SELECTED_DOWNLOAD_ITEMS:
            newState.pendingSelectedDownloads = {};
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].CLOSE_DOWNLOAD_GROUP_TOAST:
            newState.isDownloadToastClosed = true;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadManagerActionKeys */].RESET_DOWNLOADS: {
            var initial = getInitialState();
            return __assign({}, state, { downloadGroups: initial.downloadGroups, items: initial.items, pendingSelectedDownloads: initial.pendingSelectedDownloads, totalSelectedDownloadsCount: initial.totalSelectedDownloadsCount, downloadInProgressItems: initial.downloadInProgressItems, downloadInProgressDependencies: initial.downloadInProgressDependencies });
        }
        default:
            return state;
    }
}
function getItemFromMap(items, itemId) {
    return items[itemId] ? items[itemId] : __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(downloadManagerItemInitialState);
}
function getSelectedDownloadItemFromMap(selectedDownloads, itemId) {
    return selectedDownloads[itemId] ? selectedDownloads[itemId] : { driveItemId: itemId };
}


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopupTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);






var PopupTheme;
(function (PopupTheme) {
    PopupTheme["DARK"] = "DARK";
    PopupTheme["LIGHT"] = "LIGHT";
})(PopupTheme || (PopupTheme = {}));
var Popup = function (_a) {
    var isDisplayed = _a.isDisplayed, label = _a.label, onCancel = _a.onCancel, onConfirm = _a.onConfirm, isConfirmDisabled = _a.isConfirmDisabled, children = _a.children, footer = _a.footer, actionButtonColor = _a.actionButtonColor, isLoading = _a.isLoading, className = _a.className, _b = _a.theme, theme = _b === void 0 ? PopupTheme.LIGHT : _b;
    var handleOverlayClick = function (e) {
        if (onCancel && e.target === e.currentTarget) {
            onCancel();
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var handleKeyDown = function (e) {
            if (__WEBPACK_IMPORTED_MODULE_4__utils_keys__["a" /* default */].isEnter(e.key) && onConfirm && !isConfirmDisabled) {
                e.preventDefault();
                onConfirm();
            }
            if (__WEBPACK_IMPORTED_MODULE_4__utils_keys__["a" /* default */].isEsc(e.key) && onCancel) {
                e.preventDefault();
                onCancel();
            }
        };
        if (isDisplayed) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return function () {
            if (isDisplayed) {
                window.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [isDisplayed, onConfirm, onCancel, isConfirmDisabled]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeProvider */], { theme: { theme: theme } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* Overlay */], { isOpen: isDisplayed, className: className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* OverlayBlur */], { onMouseDown: handleOverlayClick, onTouchStart: handleOverlayClick }, isDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* PopupContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["l" /* PopupHeader */], null,
                    onCancel &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonCancel */], { type: "button", color: actionButtonColor, onClick: onCancel },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* Label */], null, label),
                    onConfirm &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* ButtonConfirm */], { type: "button", color: actionButtonColor, onClick: onConfirm, disabled: isConfirmDisabled },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.ok" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["j" /* PopupContentWrapper */], null,
                    isLoading &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Loader */], null,
                            __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* PopupBody */], null, children),
                    footer &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["k" /* PopupFooter */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ButtonAccept */], { type: "button", onClick: footer.onAccept }, footer.label)))))))));
};
/* harmony default export */ __webpack_exports__["b"] = (Popup);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(1421);

var assertThisInitialized = __webpack_require__(31);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1422);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiAppAuthenticationInfosActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initializeMultiAppAuthentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAuthMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return signIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return signOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadGallery; });
/* unused harmony export getServer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setFormValue; });
/* unused harmony export setSessionExpired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return orgLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkActiveSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return freeUrlAppLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Gallery_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_localStorage_manager__ = __webpack_require__(168);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _this = this;
















var MultiAppAuthenticationInfosActionKeys;
(function (MultiAppAuthenticationInfosActionKeys) {
    MultiAppAuthenticationInfosActionKeys["RESET_STATUS"] = "@@multiAppAuthenticationInfos/RESET_STATUS";
    MultiAppAuthenticationInfosActionKeys["LOGIN_SUCCESS"] = "@@multiAppAuthenticationInfos/LOGIN_SUCCESS";
    MultiAppAuthenticationInfosActionKeys["LOGIN_ERROR"] = "@@multiAppAuthenticationInfos/LOGIN_ERROR";
    MultiAppAuthenticationInfosActionKeys["COMPANY_ERROR"] = "@@multiAppAuthenticationInfos/COMPANY_ERROR";
    MultiAppAuthenticationInfosActionKeys["LOGOUT"] = "@@multiAppAuthenticationInfos/LOGOUT";
    MultiAppAuthenticationInfosActionKeys["UPDATE_CLIENT"] = "@@multiAppAuthenticationInfos/UPDATE_CLIENT";
    MultiAppAuthenticationInfosActionKeys["UPDATE_CREDENTIALS"] = "@@multiAppAuthenticationInfos/UPDATE_CREDENTIALS";
    MultiAppAuthenticationInfosActionKeys["UPDATE_ACCESSIBLE_APPS"] = "@@multiAppAuthenticationInfos/UPDATE_ACCESSIBLE_APPS";
    MultiAppAuthenticationInfosActionKeys["UPDATE_AUTH_METHODS"] = "@@multiAppAuthenticationInfos/UPDATE_AUTH_METHODS";
    MultiAppAuthenticationInfosActionKeys["UPDATE_SERVER"] = "@@multiAppAuthenticationInfos/UPDATE_SERVER";
    MultiAppAuthenticationInfosActionKeys["SET_FORM_VALUE"] = "@@multiAppAuthenticationInfos/SET_FORM_VALUE";
    MultiAppAuthenticationInfosActionKeys["SET_SESSION_CHECKING"] = "@@multiAppAuthenticationInfos/SET_SESSION_CHECKING";
    MultiAppAuthenticationInfosActionKeys["TOGGLE_CHECK_SESSION_STATUS"] = "@@multiAppAuthenticationInfos/TOGGLE_CHECK_SESSION_STATUS";
    MultiAppAuthenticationInfosActionKeys["SET_ANOTHER_USER_LOGIN"] = "@@multiAppAuthenticationInfos/SET_ANOTHER_USER_LOGIN";
    MultiAppAuthenticationInfosActionKeys["SET_SESSION_EXPIRED"] = "@@multiAppAuthenticationInfos/SET_SESSION_EXPIRED";
})(MultiAppAuthenticationInfosActionKeys || (MultiAppAuthenticationInfosActionKeys = {}));
var initializeMultiAppAuthentication = function () { return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isOnlinePromise() // needed because isOnline might not be initialized yet
        .then(function (isOnline) {
        // Check if autologin should be prevented (e.g., after explicit logout)
        __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].getPreventAutologin().then(function (shouldPreventAutologin) {
            if (shouldPreventAutologin) {
                // User explicitly logged out, don't autologin
                return;
            }
            __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].getGalleryConfig().then(function (previousGalleryConfig) {
                if (!isOnline) {
                    if (previousGalleryConfig) {
                        dispatch(initGallery(previousGalleryConfig)).then();
                        return;
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('info.offline_login'));
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].getMultiAppCredentials().then(function (storedCredentials) {
                    dispatch(getServer())
                        .then(function () { return __awaiter(_this, void 0, void 0, function () {
                        var stateCredentials, credentials, method, company, loginData, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    stateCredentials = getState().multiAppAuthenticationInfos.credentials;
                                    credentials = stateCredentials || storedCredentials;
                                    if (!(previousGalleryConfig && credentials)) return [3 /*break*/, 4];
                                    method = credentials.method, company = credentials.company;
                                    if (!(method === __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AuthMethod */].Saml)) return [3 /*break*/, 1];
                                    dispatch(orgLogin(previousGalleryConfig, company)).then();
                                    return [3 /*break*/, 4];
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].refreshSession()];
                                case 2:
                                    loginData = _a.sent();
                                    if (loginData.login) {
                                        // Clear prevent autologin flag on successful login
                                        __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setPreventAutologin(false).then();
                                        dispatch(finishLogin(loginData, credentials, true)).then();
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    dispatch({ type: MultiAppAuthenticationInfosActionKeys.LOGIN_ERROR, status: error_1 });
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                });
            });
        });
    });
}; };
var updateCredentials = function (updateCredentialsArgs) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var credentials, newCredentials;
    return __generator(this, function (_a) {
        credentials = getState().multiAppAuthenticationInfos.credentials;
        newCredentials = credentials || __WEBPACK_IMPORTED_MODULE_0__reducer__["b" /* initialCredentials */];
        Object.entries(updateCredentialsArgs).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (value !== undefined) {
                newCredentials[key] = value;
            }
        });
        // Update stored credentials in the background, otherwise changes actions order after login. Refactoring needed to ensure exact order of actions execution
        updateStoredCredentials(newCredentials).then();
        dispatch({
            type: MultiAppAuthenticationInfosActionKeys.UPDATE_CREDENTIALS,
            credentials: newCredentials,
        });
        return [2 /*return*/];
    });
}); }; };
var updateStoredCredentials = function (newCredentials) { return __awaiter(_this, void 0, void 0, function () {
    var storedCredentials;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].getMultiAppCredentials()];
            case 1:
                storedCredentials = _a.sent();
                if (storedCredentials && storedCredentials.token && storedCredentials.token !== newCredentials.token) {
                    storedCredentials.token = newCredentials.token;
                    __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setMultiAppCredentials(storedCredentials).then();
                }
                return [2 /*return*/];
        }
    });
}); };
var getAuthMethods = function (company) { return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].getOrgAuthMethods(company)
        .then(function (response) {
        var orgAuthMethods = response.orgAuthMethods;
        if (orgAuthMethods) {
            dispatch(updateCredentials({ company: company }));
            dispatch({ type: MultiAppAuthenticationInfosActionKeys.UPDATE_AUTH_METHODS, orgAuthMethods: orgAuthMethods });
            return Promise.resolve(orgAuthMethods);
        }
        else {
            return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* AspConnexionStatus */].NO_COMPANY_ERROR);
        }
    })
        .catch(function () { return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* AspConnexionStatus */].NO_COMPANY_ERROR); });
}; };
var signIn = function (credentials, shouldSaveCredentials) { return function (dispatch) {
    if (!shouldSaveCredentials) {
        __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].removeMultiAppCredentials().then();
    }
    return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].loginToAsp(credentials, shouldSaveCredentials)
        .catch(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].removeMultiAppCredentials().then();
            return [2 /*return*/, Promise.reject(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* AspConnexionStatus */].AUTH_ERROR)];
        });
    }); })
        .then(function (response) {
        dispatch(finishLogin(response, credentials, shouldSaveCredentials));
    })
        .catch(function (reason) {
        dispatch({ type: MultiAppAuthenticationInfosActionKeys.LOGIN_ERROR, status: reason });
        return Promise.reject(reason);
    });
}; };
var finishLogin = function (loginData, credentials, shouldSaveCredentials, isRefresh) {
    if (isRefresh === void 0) { isRefresh = false; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var token, login, associatedApps, clientId, oneSessPerUser, org, email, method, company, storedMultiAppCredentials, updatedOrg, userName, companyName, _a, clientId_1, globalId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    token = loginData.token, login = loginData.login, associatedApps = loginData.associatedApps, clientId = loginData.clientId, oneSessPerUser = loginData.oneSessPerUser, org = loginData.org, email = loginData.email;
                    method = credentials.method, company = credentials.company;
                    if (associatedApps === undefined) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.no_application_available'));
                        return [2 /*return*/, Promise.reject(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* AspConnexionStatus */].NO_APP_ERROR)];
                    }
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].getMultiAppCredentials()];
                case 1:
                    storedMultiAppCredentials = _b.sent();
                    updatedOrg = isRefresh && storedMultiAppCredentials ? storedMultiAppCredentials.company : org;
                    userName = method === __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AuthMethod */].Webpublication && !!updatedOrg ? email : login;
                    companyName = method === __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AuthMethod */].Webpublication ? updatedOrg : company;
                    if (shouldSaveCredentials) {
                        __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setMultiAppCredentials({
                            method: method,
                            login: userName,
                            company: companyName,
                            token: token,
                        }).then();
                        // Clear prevent autologin flag on successful login
                        __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setPreventAutologin(false).then();
                    }
                    dispatch(updateCredentials(__assign({}, credentials, { login: userName, company: companyName, token: token, lastApiCallTimestamp: Date.now() })));
                    if (oneSessPerUser) {
                        dispatch({ type: MultiAppAuthenticationInfosActionKeys.SET_SESSION_CHECKING });
                    }
                    dispatch({ type: MultiAppAuthenticationInfosActionKeys.UPDATE_CLIENT, clientId: clientId });
                    dispatch({ type: MultiAppAuthenticationInfosActionKeys.UPDATE_ACCESSIBLE_APPS, accessibleApps: associatedApps });
                    if (associatedApps.length === 1) {
                        _a = associatedApps[0], clientId_1 = _a.clientId, globalId = _a.globalId;
                        dispatch(loadGallery(clientId_1, globalId, shouldSaveCredentials));
                    }
                    return [2 /*return*/, associatedApps.length > 0
                            ? Promise.resolve()
                            : Promise.reject(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* AspConnexionStatus */].NO_APP_ERROR)];
            }
        });
    }); };
};
var signOut = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var error_2, config, appUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 12]);
                return [4 /*yield*/, Promise.all([
                        __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].logoutFromAsp(),
                        __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].logoutFromApplication(),
                    ])];
            case 1:
                _a.sent();
                return [3 /*break*/, 12];
            case 2:
                error_2 = _a.sent();
                if (!__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp) {
                    // reload redirects to external login page in web version in case getting error from server (e.g., another user login)
                    window.location.reload();
                }
                return [3 /*break*/, 12];
            case 3:
                dispatch(logout());
                if (!__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp) return [3 /*break*/, 9];
                return [4 /*yield*/, goToHome()];
            case 4:
                _a.sent();
                Object(__WEBPACK_IMPORTED_MODULE_13__OfflineManager_actions__["b" /* clearUpdateTreeInterval */])();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].removeMultiAppCredentials()];
            case 5:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].removeGalleryConfig()];
            case 6:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].removeProfileInfos()];
            case 7:
                _a.sent();
                // Set flag to prevent autologin after explicit logout
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setPreventAutologin(true)];
            case 8:
                // Set flag to prevent autologin after explicit logout
                _a.sent();
                dispatch(clearCachedCSS());
                dispatch(clearPrivateAssets());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["x" /* resetFetchAllStatus */])());
                return [3 /*break*/, 11];
            case 9:
                config = getState().galleryInfos.config;
                appUrl = __WEBPACK_IMPORTED_MODULE_8__utils_url__["b" /* default */].getApplicationUrl(config);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].promiseXHR('GET', appUrl)];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [7 /*endfinally*/];
            case 12: return [2 /*return*/];
        }
    });
}); }; };
var goToHome = function () { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // TODO: Find a cleaner way to wait before navigation to Home happens
                // Currently, if the user is inside his private folder when disconnecting,
                // the app crashes if we delete private assets from driveList before the user reached home
                __WEBPACK_IMPORTED_MODULE_12__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_12__utils_routes__["a" /* default */].getPathHome());
                return [4 /*yield*/, new Promise(function (resolve) {
                        setTimeout(resolve, 300);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var clearPrivateAssets = function () {
    return function (dispatch, getState) {
        var _a = getState(), config = _a.galleryInfos.config, driveList = _a.driveList, driveItems = _a.driveList.driveItems;
        var privateDirId = __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getPrivateDirId(driveList, config);
        var assetToRemoveIds = Object.keys(driveItems)
            .map(function (driveItemId) { return parseInt(driveItemId, 10); })
            .filter(function (driveItemId) { return __WEBPACK_IMPORTED_MODULE_11__utils_driveItem__["d" /* default */].isDirDescendantOf(driveItemId, privateDirId, driveItems); });
        if (privateDirId) {
            assetToRemoveIds.push(privateDirId);
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["v" /* removeDriveItems */])(assetToRemoveIds));
    };
};
var clearCachedCSS = function () {
    return function (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__Gallery_actions__["f" /* setCustomCSS */])(''));
    };
};
var logout = function () { return ({
    type: MultiAppAuthenticationInfosActionKeys.LOGOUT,
}); };
var loadGallery = function (clientId, galleryId, shouldSaveConfig) {
    if (shouldSaveConfig === void 0) { shouldSaveConfig = false; }
    return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].getConfig(clientId, galleryId)
            .then(function (config) { return dispatch(initGallery(config, shouldSaveConfig)); });
    };
};
var initGallery = function (config, shouldSaveConfig) {
    if (shouldSaveConfig === void 0) { shouldSaveConfig = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var credentials, login;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    credentials = getState().multiAppAuthenticationInfos.credentials;
                    login = credentials && credentials.login ? credentials.login : '';
                    __WEBPACK_IMPORTED_MODULE_14__utils_localStorage_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery, login);
                    __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery, login);
                    dispatch(updateMultiAppConfig(config, shouldSaveConfig));
                    dispatch({ type: MultiAppAuthenticationInfosActionKeys.LOGIN_SUCCESS });
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3__Gallery_actions__["d" /* migrateAppContainerLocalStorageToIndexedDB */])()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
var updateMultiAppConfig = function (data, shouldSave) {
    return function (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__Gallery_actions__["e" /* receiveConfig */])(data));
        if (shouldSave) {
            __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setGalleryConfig(data).then();
        }
    };
};
var getServer = function () { return function (dispatch, getState) {
    var server = getState().multiAppAuthenticationInfos.server;
    if (server) {
        return Promise.resolve();
    }
    return __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].getAvailableServers()
        .then(function (servers) {
        var closestServerKey = '';
        var serverKeys = Object.keys(servers);
        for (var i = 0; i < serverKeys.length; i++) {
            var key = serverKeys[i];
            if (servers[key].closestServer) {
                closestServerKey = key;
                break;
            }
        }
        __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setMultiAppServer(closestServerKey).then();
        dispatch({ type: MultiAppAuthenticationInfosActionKeys.UPDATE_SERVER, server: closestServerKey });
    });
}; };
var setFormValue = function (input, value) { return function (dispatch, getState) {
    dispatch({
        type: MultiAppAuthenticationInfosActionKeys.SET_FORM_VALUE,
        input: input,
        value: value
    });
}; };
var toggleCheckSessionStatus = function (isCheckingSession) { return ({
    type: MultiAppAuthenticationInfosActionKeys.TOGGLE_CHECK_SESSION_STATUS,
    isCheckingSession: isCheckingSession,
}); };
var setAnotherUserLogin = function () { return ({
    type: MultiAppAuthenticationInfosActionKeys.SET_ANOTHER_USER_LOGIN,
}); };
var setSessionExpired = function () { return ({
    type: MultiAppAuthenticationInfosActionKeys.SET_SESSION_EXPIRED,
}); };
var checkSession = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var CHECK_SESSION_DELAY, isCheckingSession, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                CHECK_SESSION_DELAY = 5000;
                isCheckingSession = getState().multiAppAuthenticationInfos.isCheckingSession;
                // to prevent unnecessary calls to api in case several actions are dispatched frequently
                // (for example, typing in forms)
                if (isCheckingSession) {
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(toggleCheckSessionStatus(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].checkSession()];
            case 2:
                _a.sent();
                setTimeout(function () {
                    dispatch(toggleCheckSessionStatus(false));
                }, CHECK_SESSION_DELAY);
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                if (error_3.status === __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* ServerStatusCode */].CONFLICT) {
                    dispatch(setAnotherUserLogin());
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var orgLogin = function (config, company) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var action, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__["b" /* default */].openFrame(__WEBPACK_IMPORTED_MODULE_8__utils_url__["b" /* default */].getOrgLoginUrl(config, company))];
            case 1:
                action = (_a.sent()).action;
                if (action.type === __WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["a" /* ActionType */].SAML_LOGIN) {
                    token = action.token;
                    return [2 /*return*/, dispatch(signIn({ token: token, company: company, method: __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AuthMethod */].Saml }, true))];
                }
                return [2 /*return*/];
        }
    });
}); }; };
var SERVER_SESSION_DURATION_MINUTES = 30;
var checkActiveSession = function (forceCheck) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, appInfos, _b, isConfigLoaded, config, credentials, isLoggedIn, shouldCheckSession, requestId, _c, login, token, isActiveSession, _d, method, company, error_4;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 4, , 5]);
                _a = getState(), appInfos = _a.appInfos, _b = _a.galleryInfos, isConfigLoaded = _b.isConfigLoaded, config = _b.config;
                credentials = __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getMultiAppCredentials();
                isLoggedIn = credentials && credentials.login;
                if (!isConfigLoaded || !__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isMultiApp(appInfos) || !isLoggedIn) {
                    return [2 /*return*/];
                }
                shouldCheckSession = forceCheck ||
                    !__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].lastApiCallTimestamp ||
                    Date.now() - __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].lastApiCallTimestamp >= (SERVER_SESSION_DURATION_MINUTES - 1) * 60 * 1000;
                if (!shouldCheckSession) {
                    return [2 /*return*/];
                }
                requestId = 'refresh-session';
                __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].cancelRequest(requestId);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].refreshSession(requestId)];
            case 1:
                _c = _e.sent(), login = _c.login, token = _c.token;
                isActiveSession = !!login;
                if (!isActiveSession) return [3 /*break*/, 3];
                return [4 /*yield*/, dispatch(updateCredentials({
                        token: token,
                        lastApiCallTimestamp: Date.now(),
                    }))];
            case 2: return [2 /*return*/, _e.sent()];
            case 3:
                if (__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isFreeUrlApp()) {
                    return [2 /*return*/, dispatch(freeUrlAppLogin())];
                }
                if (isLoggedIn) {
                    _d = credentials, method = _d.method, company = _d.company;
                    if (method === __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AuthMethod */].Webpublication) {
                        dispatch(setSessionExpired());
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, dispatch(orgLogin(config, company))];
                }
                return [3 /*break*/, 5];
            case 4:
                error_4 = _e.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var freeUrlAppLogin = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var token, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].freeUrlAppLogin()];
            case 1:
                token = (_a.sent()).token;
                return [2 /*return*/, dispatch(updateCredentials({ token: token }))];
            case 2:
                error_5 = _a.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UiActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setEditorType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setIsEditorLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return toggleEditPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return moveEditPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setActiveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resetActiveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setIsRenaming; });
/* unused harmony export rename */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setRenameError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return zoomPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return showLockedEditorPopup; });
/* unused harmony export hideLockedEditorPopup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setIsAccessibleVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sendRenameRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openAccessibleVersionPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return acquireLock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;










var UiActionKeys;
(function (UiActionKeys) {
    UiActionKeys["SET_EDITOR_TYPE"] = "@@editor/ui/SET_EDITOR_TYPE";
    UiActionKeys["SET_IS_EDITOR_LOADED"] = "@@editor/ui/SET_IS_EDITOR_LOADED";
    UiActionKeys["TOGGLE_EDIT_PANEL"] = "@@editor/ui/TOGGLE_EDIT_PANEL";
    UiActionKeys["MOVE_EDIT_PANEL"] = "@@editor/ui/MOVE_EDIT_PANEL";
    UiActionKeys["SET_ACTIVE_ITEM"] = "@@editor/ui/SET_ACTIVE_ITEM";
    UiActionKeys["RESET_ACTIVE_ITEM"] = "@@editor/ui/RESET_ACTIVE_ITEM";
    UiActionKeys["SET_LABEL"] = "@@editor/ui/SET_LABEL";
    UiActionKeys["SET_IS_RENAMING"] = "@@editor/ui/SET_IS_RENAMING";
    UiActionKeys["RENAME"] = "@@editor/ui/RENAME";
    UiActionKeys["SET_RENAME_ERROR"] = "@@editor/ui/SET_RENAME_ERROR";
    UiActionKeys["SET_VERSION"] = "@@editor/ui/SET_VERSION";
    UiActionKeys["ZOOM_PAGE"] = "@@editor/ui/ZOOM_PAGE";
    UiActionKeys["SHOW_LOCKED_EDITOR_POPUP"] = "@@editor/ui/SHOW_LOCKED_EDITOR_POPUP";
    UiActionKeys["HIDE_LOCKED_EDITOR_POPUP"] = "@@editor/ui/HIDE_LOCKED_EDITOR_POPUP";
    UiActionKeys["RESET"] = "@@editor/ui/RESET";
    UiActionKeys["SET_IS_ACCESSIBLE_VERSION"] = "@@editor/ui/SET_IS_ACCESSIBLE_VERSION";
})(UiActionKeys || (UiActionKeys = {}));
var setEditorType = function (editorType) { return ({
    type: UiActionKeys.SET_EDITOR_TYPE,
    editorType: editorType,
}); };
var setIsEditorLoaded = function (isLoaded) { return ({
    type: UiActionKeys.SET_IS_EDITOR_LOADED,
    isLoaded: isLoaded,
}); };
var toggleEditPanel = function () { return ({
    type: UiActionKeys.TOGGLE_EDIT_PANEL,
}); };
var moveEditPanel = function (x, y) { return ({
    type: UiActionKeys.MOVE_EDIT_PANEL,
    x: x,
    y: y,
}); };
var setActiveItem = function (id, page, parentId) { return ({
    type: UiActionKeys.SET_ACTIVE_ITEM,
    id: id,
    page: page,
    parentId: parentId,
}); };
var resetActiveItem = function () { return ({
    type: UiActionKeys.RESET_ACTIVE_ITEM,
}); };
var setLabel = function (label) { return ({
    type: UiActionKeys.SET_LABEL,
    label: label,
}); };
var setIsRenaming = function (isRenaming) { return ({
    type: UiActionKeys.SET_IS_RENAMING,
    isRenaming: isRenaming,
}); };
var rename = function (newLabel) { return ({
    type: UiActionKeys.RENAME,
    newLabel: newLabel,
}); };
var setRenameError = function (isError) { return ({
    type: UiActionKeys.SET_RENAME_ERROR,
    isError: isError,
}); };
var setVersion = function (version) { return ({
    type: UiActionKeys.SET_VERSION,
    version: version,
}); };
var zoomPage = function (zoom) { return ({
    type: UiActionKeys.ZOOM_PAGE,
    zoom: zoom,
}); };
var showLockedEditorPopup = function (userName) { return ({
    type: UiActionKeys.SHOW_LOCKED_EDITOR_POPUP,
    userName: userName,
}); };
var hideLockedEditorPopup = function () { return ({
    type: UiActionKeys.HIDE_LOCKED_EDITOR_POPUP,
}); };
var reset = function (isIntermediate) { return ({
    type: UiActionKeys.RESET,
    isIntermediate: isIntermediate,
}); };
var setIsAccessibleVersion = function (isAccessibleVersion) { return ({
    type: UiActionKeys.SET_IS_ACCESSIBLE_VERSION,
    isAccessibleVersion: isAccessibleVersion,
}); };
var sendRenameRequest = function (label) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, clientId, tempGId, originalGId, newLabel, shouldUpdatePreviewName, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                _a = Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _a.clientId, tempGId = _a.tempGId, originalGId = _a.originalGId;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].renameResource(clientId, originalGId, label)];
            case 1:
                newLabel = (_b.sent()).newLabel;
                dispatch(rename(newLabel));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["I" /* updateDriveItemName */])(originalGId, newLabel));
                shouldUpdatePreviewName = tempGId !== originalGId;
                if (!shouldUpdatePreviewName) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].renameResource(clientId, tempGId, label)];
            case 2:
                _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["I" /* updateDriveItemName */])(tempGId, newLabel));
                _b.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                error_1 = _b.sent();
                dispatch(setRenameError(true));
                if (__WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].isDuplicateFileNameError(error_1.responseText)) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.duplicate_file_name'));
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.rename_asset_error'));
                }
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var openPreview = function (id) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, spreads, currentSpreadIndex, driveItems, config, driveItem, page, previewUrl;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__MultiAppAuthentication_actions__["b" /* checkActiveSession */])())];
            case 1:
                _c.sent();
                _a = getState(), _b = _a.editor.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, driveItems = _a.driveList.driveItems, config = _a.galleryInfos.config;
                driveItem = driveItems[id];
                page = spreads[currentSpreadIndex][0];
                previewUrl = __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getPublicationUrl(config, driveItem, page, __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp);
                if (__WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp) {
                    __WEBPACK_IMPORTED_MODULE_6__utils_nativeApi__["b" /* default */].openFrame(previewUrl);
                }
                else {
                    window.open(previewUrl);
                }
                return [2 /*return*/];
        }
    });
}); }; };
var openAccessibleVersionPreview = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, currentSpreadIndex, accessibleUrl, accessibleUrlWithToken, previewUrl;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__MultiAppAuthentication_actions__["b" /* checkActiveSession */])())];
            case 1:
                _b.sent();
                _a = getState().editor, currentSpreadIndex = _a.pagesController.currentSpreadIndex, accessibleUrl = _a.paths.accessibleUrl;
                accessibleUrlWithToken = accessibleUrl ? accessibleUrl + (__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getUrlSeparator(accessibleUrl) + "token=" + __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].token) : '';
                previewUrl = accessibleUrlWithToken ? accessibleUrlWithToken + ("#page=" + (currentSpreadIndex + 1)) : '';
                if (previewUrl) {
                    if (__WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp) {
                        __WEBPACK_IMPORTED_MODULE_6__utils_nativeApi__["b" /* default */].openFrame(previewUrl);
                    }
                    else {
                        window.open(previewUrl);
                    }
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.get_accessible_version_url'));
                }
                return [2 /*return*/];
        }
    });
}); }; };
var acquireLock = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, clientId, resourceId, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _a.clientId, resourceId = _a.tempGId;
                dispatch(hideLockedEditorPopup());
                dispatch(reset(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].acquireLock(clientId, resourceId)];
            case 1:
                _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__sources__["c" /* getData */])(clientId, resourceId));
                return [3 /*break*/, 3];
            case 2:
                error_2 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return StyledEditPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return StyledEditPanelInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return StyledIconMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return InputError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HeaderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HeaderButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonRemove_styles__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};







var StyledEditPanel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: ", "px;\n\tpadding: 15px;\n\tpadding-right: 0;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 35px 0 ", ";\n\tcursor: default;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\twidth: ", "px;\n\tpadding: 15px;\n\tpadding-right: 0;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 35px 0 ", ";\n\tcursor: default;\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_3__index__["a" /* EDIT_PANEL_WIDTH */], __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Grey900, Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Black, 50), function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && "\n\t\tpointer-events: none;\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tz-index: 1;\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].Black, 75) + ";\n\t\t}\n\t";
});
var StyledEditPanelInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmax-height: calc(100vh - 75px);\n\tpadding-right: 15px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t", "\n"], ["\n\tmax-height: calc(100vh - 75px);\n\tpadding-right: 15px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* getEditorScrollStyles */])({ width: 4 }));
var StyledIconMove = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 16px;\n\tleft: 7px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: move;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 16px;\n\tleft: 7px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: move;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].White, 50));
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-bottom: 5px;\n\tpadding-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tletter-spacing: 1px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n"], ["\n\tdisplay: block;\n\tmargin-bottom: 5px;\n\tpadding-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tletter-spacing: 1px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n"])), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 0 15px;\n\tborder-radius: 6px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 44px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:disabled {\n\t\topacity: 0.5;\n\t\tpointer-events: none;\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 12px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 0 15px;\n\tborder-radius: 6px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 44px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:disabled {\n\t\topacity: 0.5;\n\t\tpointer-events: none;\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 12px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].White, 75), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].White, 10), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].White, 25), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].White, 30));
var ButtonBack = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: relative;\n\theight: 16px;\n\tpadding: 0;\n\tpadding-left: 20px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 15px;\n\tline-height: 16px;\n\tcolor: ", ";\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 0;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: relative;\n\theight: 16px;\n\tpadding: 0;\n\tpadding-left: 20px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 15px;\n\tline-height: 16px;\n\tcolor: ", ";\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 0;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: currentColor;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Blue450);
var InputWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition: relative;\n\tmargin: ", " 0 20px 0;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\tinput {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\theight: 40px;\n\t\tpadding: 10px ", " 10px 15px;\n\t\tborder: 1px solid ", ";\n\t\toutline: 0;\n\t\tborder-radius: 6px;\n\t\tbackground-color: transparent;\n\t\tfont-family: HelveticaNeue, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tcolor: ", ";\n\t\t-webkit-appearance: none;\n\n\t\t", "\n\t\t&:hover:not(:disabled),\n\t\t&:focus:not(:disabled) {\n\t\t\tborder: 1px solid ", ";\n\t\t}\n\n\t\t&::placeholder {\n\t\t\tcolor: ", ";\n\t\t}\n\t;\n\n\t\t&::-ms-clear {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t// override user agent autofill styles\n\n\t\t&:-webkit-autofill {\n\t\t\t-webkit-background-clip: text;\n\t\t\t-webkit-text-fill-color: ", " !important;\n\t\t}\n\t}\n\n\t", " {\n\t\tposition: absolute;\n\t\ttop: 9px;\n\t\tright: 9px;\n\t}\n"], ["\n\tposition: relative;\n\tmargin: ", " 0 20px 0;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\tinput {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\theight: 40px;\n\t\tpadding: 10px ",
    " 10px 15px;\n\t\tborder: 1px solid ",
    ";\n\t\toutline: 0;\n\t\tborder-radius: 6px;\n\t\tbackground-color: transparent;\n\t\tfont-family: HelveticaNeue, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tcolor: ", ";\n\t\t-webkit-appearance: none;\n\n\t\t", "\n\t\t&:hover:not(:disabled),\n\t\t&:focus:not(:disabled) {\n\t\t\tborder: 1px solid ",
    ";\n\t\t}\n\n\t\t&::placeholder {\n\t\t\tcolor: ", ";\n\t\t}\n\t;\n\n\t\t&::-ms-clear {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t// override user agent autofill styles\n\n\t\t&:-webkit-autofill {\n\t\t\t-webkit-background-clip: text;\n\t\t\t-webkit-text-fill-color: ", " !important;\n\t\t}\n\t}\n\n\t", " {\n\t\tposition: absolute;\n\t\ttop: 9px;\n\t\tright: 9px;\n\t}\n"])), function (props) { return props.hasLabel ? '5px' : '25px'; }, Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].White, 10), function (props) {
    if (props.hasButtonAdd && props.hasButtonRemove) {
        return '70px';
    }
    else if (props.hasButtonRemove) {
        return '40px';
    }
    return '10px';
}, function (props) { return props.isError
    ? __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].LightRed
    : 'transparent'; }, __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var hasNoIcon = _a.hasNoIcon;
    return hasNoIcon && 'padding-left: 10px;';
}, function (props) { return props.isError
    ? "" + __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].LightRed
    : "" + __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].White; }, Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].White, 50), __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__ButtonRemove_styles__["a" /* StyledButtonRemove */]);
var InputError = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 100%;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 100%;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].LightRed);
var Header = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tposition: relative;\n\tmargin-bottom: 20px;\n"], ["\n\tposition: relative;\n\tmargin-bottom: 20px;\n"])));
var HeaderLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tdisplay: block;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n"], ["\n\tdisplay: block;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n"])), Object(__WEBPACK_IMPORTED_MODULE_6__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].White, 75));
var HeaderButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t&:first-of-type {\n\t\tleft: 0;\n\t}\n\n\t&:not(:first-of-type):last-of-type {\n\t\tright: 0;\n\t}\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t&:first-of-type {\n\t\tleft: 0;\n\t}\n\n\t&:not(:first-of-type):last-of-type {\n\t\tright: 0;\n\t}\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Blue450, function (props) { return props.disabled && "\n\t\tpointer-events: none;\n\t\topacity: 0.5;\n\t"; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}


//# sourceMappingURL=invariant.esm.js.map


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(711)();
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusBarColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadPriority; });
/* unused harmony export nativeApi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userAgent__ = __webpack_require__(6);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var Q = __webpack_require__(165);
var I18n = __webpack_require__(5).I18n;
window._GLOBALS = {
    main: {
        javaScriptInterface: {
            callCallBackList: function (pId, data) { return NativeApi.handleDefer(pId, data); }
        }
    }
};
window.webpublicationNamespace = {
    notify: function (type) {
        if (type === 'applicationForeground' && __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isIOS()) {
            NativeApi.killPendingDownloads();
        }
    }
};
var StatusBarColor;
(function (StatusBarColor) {
    StatusBarColor["White"] = "white";
    StatusBarColor["Black"] = "black";
    StatusBarColor["Transparent"] = "transparent";
})(StatusBarColor || (StatusBarColor = {}));
var methodWithCallbackList = [
    'getDirTreeZip',
    'getFileTreeZip',
    'getFreeSpace',
    'getUsedSpace',
    'buyEntity',
    'getBoughtEntities',
    'getPricesForEntities',
    'downloadFile',
    'unzipFile',
    'openFrame',
];
var DownloadPriority;
(function (DownloadPriority) {
    DownloadPriority["Low"] = "low";
    DownloadPriority["Normal"] = "normal";
    DownloadPriority["High"] = "high";
})(DownloadPriority || (DownloadPriority = {}));
var NativeApi = /** @class */ (function () {
    function NativeApi() {
        __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].subscribeToConnectionIsDown(NativeApi.killPendingDownloads);
    }
    NativeApi.targetUrl = 'http://jsinterface.native';
    NativeApi.pId = 0;
    NativeApi.fileId = 0;
    NativeApi.fileIdpIdMap = {};
    NativeApi.defers = {};
    NativeApi.downloadFileQueue = [];
    NativeApi.removeDownloadFromQueue = function (fileId) {
        var downloadRequest = NativeApi.downloadFileQueue.find(function (item) { return item.fileId === fileId; });
        if (downloadRequest) {
            downloadRequest.deferred.reject('cancel');
            NativeApi.downloadFileQueue.splice(NativeApi.downloadFileQueue.indexOf(downloadRequest), 1);
        }
    };
    NativeApi.getNativePath = function () {
        return '../../';
    };
    NativeApi.handleDefer = function (pId, data) {
        var defer = NativeApi.defers[pId];
        if (defer) {
            if (defer.method === 'downloadFile' || defer.method === 'unzipFile') {
                if (typeof (data) === 'object') {
                    defer.deferred.notify(data);
                }
                else if (data === 0 || data === 499) {
                    defer.deferred.reject();
                }
                else {
                    defer.deferred.resolve();
                }
            }
            else {
                defer.deferred.resolve(data);
            }
        }
    };
    NativeApi.stopProcessById = function (pId) { return NativeApi.executeApiCall('stopProcessById', [pId]); };
    /* 	External methods */
    /* 	Directories */
    NativeApi.copyDirectory = function (directory, directoryDest) { return NativeApi.executeApiCall('copyDirectory', [directory, directoryDest]); };
    NativeApi.createDirectory = function (directory) { return NativeApi.executeApiCall('createDirectory', [directory]); };
    NativeApi.existDirectory = function (directory) { return NativeApi.executeApiCall('existDirectory', [directory]); };
    NativeApi.moveDirectory = function (directory, directoryDest) { return NativeApi.executeApiCall('moveDirectory', [directory, directoryDest]); };
    NativeApi.removeDirectory = function (directory) { return NativeApi.executeApiCall('removeDirectory', [directory]); };
    /* 	Files */
    NativeApi.copyFile = function (file, fileDest) { return NativeApi.executeApiCall('copyFile', [file, fileDest]); };
    NativeApi.createFile = function (file, content) { return NativeApi.executeApiCall('createFile', [file, content]); };
    NativeApi.downloadFile = function (galleryConfig, fileUrl, destFolder, destFileName, priority, parameters) {
        if (parameters === void 0) { parameters = ''; }
        var fileId = NativeApi.getFileId();
        var deferred = NativeApi.addToDownloadQueue({ fileId: fileId, galleryConfig: galleryConfig, fileUrl: fileUrl, destFolder: destFolder, destFileName: destFileName, priority: priority, parameters: parameters });
        if (!NativeApi.downloadFilePromise) {
            NativeApi.executeNextDownload();
        }
        return {
            promise: deferred.promise,
            requestId: fileId
        };
    };
    NativeApi.stopDownload = function (requestId) {
        var pId = NativeApi.fileIdpIdMap[requestId];
        if (pId) {
            NativeApi.stopProcessById(pId);
            NativeApi.defers[pId].deferred.reject('cancel');
        }
        else {
            NativeApi.removeDownloadFromQueue(requestId);
        }
    };
    NativeApi.existFile = function (file) { return NativeApi.executeApiCall('existFile', [file]); };
    NativeApi.moveFile = function (file, fileDest) { return NativeApi.executeApiCall('moveFile', [file, fileDest]); };
    NativeApi.removeFile = function (file) { return NativeApi.executeApiCall('removeFile', [file]); };
    NativeApi.unzipFile = function (file) { return NativeApi.executeApiCall('unzipFile', [file]); };
    /* 	General */
    NativeApi.getStatusBarColor = function () { return NativeApi.executeApiCall('getStatusBarColor'); };
    NativeApi.hasStatusBar = function () { return NativeApi.executeApiCall('hasStatusBar'); };
    NativeApi.openActivity = function (url) { return NativeApi.executeApiCall('openActivity', [url]); };
    NativeApi.openFileNatively = function (url) { return NativeApi.executeApiCall('openFileNatively', [url]); };
    NativeApi.openVideoActivity = function (url) { return NativeApi.executeApiCall('openVideoActivity', [url]); };
    NativeApi.setStatusBarColor = function (color) { return NativeApi.executeApiCall('setStatusBarColor', [color]); };
    /* 	Information */
    NativeApi.getFreeSpace = function () { return NativeApi.executeApiCall('getFreeSpace'); };
    NativeApi.getDeviceType = function () { return NativeApi.executeApiCall('getDeviceType'); };
    NativeApi.getUsedSpace = function () { return NativeApi.executeApiCall('getUsedSpace'); };
    NativeApi.getVersion = function () { return NativeApi.executeApiCall('getVersion'); };
    /* 	Social */
    // on Android API 28, the title doesn't seem to work and will display [object Object] instead of te string
    NativeApi.shareApp = function (title, url) { return NativeApi.executeApiCall('shareApp', [title, url, I18n.t('share')]); };
    /* 	In-app purchase */
    // TODO: uncomment when galleryConfig.inAppPurchaseGooglePlayPrefix / galleryConfig.inAppPurchaseiTunesPrefix are defined
    /*public static buyEntity = (galleryConfig: AppConfig, entityStoreId: string): Q.Promise<{}> => {
        const inAppPurchasePrefix = Utils.isAndroid() ? galleryConfig.inAppPurchaseGooglePlayPrefix : galleryConfig.inAppPurchaseiTunesPrefix;
        const resolvedEntityStoreId = inAppPurchasePrefix + entityStoreId;
        return NativeApi.executeApiCall('buyEntity', [resolvedEntityStoreId]);
    }

    public static getBoughtEntities = (): Q.Promise<{}> => NativeApi.executeApiCall('getBoughtEntities');

    public static getPricesForEntities = (galleryConfig: AppConfig, entityStoreIds: string[]): Q.Promise<{}> => {
        if (entityStoreIds) {
            const inAppPurchasePrefix = Utils.isAndroid() ? galleryConfig.inAppPurchaseGooglePlayPrefix : galleryConfig.inAppPurchaseiTunesPrefix;
            let entityStoreIdsStr = '';
            entityStoreIds.forEach(entityStoreId => {
                if (entityStoreIdsStr) {
                    entityStoreIdsStr += ';';
                }
                entityStoreIdsStr += inAppPurchasePrefix + entityStoreId;
            });

            return NativeApi.executeApiCall('getPricesForEntities', [entityStoreIdsStr]);
        }
        return Promise.reject({});
    }*/
    /* 	Legacy */
    NativeApi.createDirJs = function (dirName) { return NativeApi.executeApiCall('createDirJs', [dirName]); };
    NativeApi.writeFileTxtJs = function (contentFile, pathFileName) { return NativeApi.executeApiCall('writeFileTxtJs', [contentFile, pathFileName]); };
    NativeApi.moveFileJs = function (pathFileName, newPathFile) { return NativeApi.executeApiCall('moveFileJs', [pathFileName, newPathFile]); };
    NativeApi.openFrame = function (urlSlider, relatif, x, y, width, height) {
        if (!__WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isMobileApp) {
            window.open(urlSlider);
        }
        return NativeApi.executeApiCall('openFrame', [relatif, urlSlider, x, y, width, height]);
    };
    NativeApi.deleteFileJs = function (pathFileName) { return NativeApi.executeApiCall('deleteFileJs', [pathFileName]); };
    NativeApi.deleteDirJs = function (pathFileName) { return NativeApi.executeApiCall('deleteDirJs', [pathFileName]); };
    NativeApi.getDirTreeZip = function (urlAndCmd, dataJson) { return NativeApi.executeApiCall('get_x_or_y_tree_zip', [urlAndCmd, dataJson]); };
    NativeApi.getFileTreeZip = function (urlAndCmd, dataJson) { return NativeApi.executeApiCall('get_x_or_y_tree_zip', [urlAndCmd, dataJson]); };
    NativeApi.resetDownloads = function () { return NativeApi.executeApiCall('resetDownloads'); };
    NativeApi.killPendingDownloads = function () {
        NativeApi.downloadFileQueue.forEach(function (downloadRequest) { return downloadRequest.deferred.reject('killed'); });
        NativeApi.downloadFileQueue = [];
        Object.keys(NativeApi.defers).forEach(function (key) {
            var pid = parseInt(key, 10);
            var _a = NativeApi.defers[pid], method = _a.method, deferred = _a.deferred;
            if (method === 'downloadFile') {
                deferred.reject('killed');
            }
        });
    };
    NativeApi.copyToClipboard = function (text) { return NativeApi.executeApiCall('copyToClipboard', [text]); };
    NativeApi.copyHtmlToClipboard = function (text, htmlText) { return NativeApi.executeApiCall('copyHtmlToClipboard', [text, htmlText]); };
    NativeApi.getPid = function () { return ++NativeApi.pId; };
    NativeApi.getFileId = function () { return ++NativeApi.fileId; };
    NativeApi.executeApiCall = function (method, args, pId) {
        if (args === void 0) { args = []; }
        if (pId === void 0) { pId = NativeApi.getPid(); }
        var deferred = Q.defer();
        NativeApi.defers[pId] = { deferred: deferred, method: method };
        NativeApi.sendRequest(method, pId, args, deferred);
        return deferred.promise
            .finally(function () { return delete NativeApi.defers[pId]; });
    };
    NativeApi.sendRequest = function (method, pId, args, deferred) {
        if (!__WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isMobileApp) {
            deferred.reject();
            return;
        }
        args.push(pId);
        var requestData = { method: method, 'args[]': __spread(args) };
        var requestUrl = __WEBPACK_IMPORTED_MODULE_0____["d" /* default */].dataToUrl(requestData, true);
        if (__WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isWindows()) {
            if (window.external && window.external.notify) {
                // Windows has a special handler
                window.external.notify(requestUrl);
            }
            else {
                // Windows handler for WebView2
                window.page = {
                    sendMessage: function (requestData) {
                        var requestString = JSON.stringify(requestData);
                        window.chrome.webview.postMessage(requestString);
                    },
                };
                window.page.sendMessage(requestData);
            }
        }
        else {
            var headers = [{ key: 'Content-Type', value: '*; charset=UTF-8' }];
            __WEBPACK_IMPORTED_MODULE_0____["d" /* default */].promiseXHR('GET', NativeApi.targetUrl + "?" + requestUrl, headers, undefined, undefined, undefined, undefined, true)
                .then(function (result) {
                var isMethodInCallbackList = !methodWithCallbackList.includes(method);
                if (isMethodInCallbackList) {
                    var responseText = result.responseText;
                    var response = void 0;
                    switch (responseText) {
                        case 'true':
                            response = true;
                            break;
                        case 'false':
                            response = false;
                            break;
                        default:
                            response = responseText;
                    }
                    NativeApi.handleDefer(pId, response);
                }
            })
                .catch(function (result) { return deferred.reject(result); });
        }
    };
    NativeApi.addToDownloadQueue = function (downloadParams) {
        var deferred = Q.defer();
        var downloadRequest = __assign({}, downloadParams, { deferred: deferred });
        var downloadFileQueueToSort = __spread(NativeApi.downloadFileQueue, [downloadRequest]);
        var lowPriorities = [];
        var normalPriorities = [];
        var highPriorities = [];
        downloadFileQueueToSort.forEach(function (downloadRequest) {
            if (downloadRequest.priority === DownloadPriority.High) {
                highPriorities.push(downloadRequest);
            }
            else if (downloadRequest.priority === DownloadPriority.Normal) {
                normalPriorities.push(downloadRequest);
            }
            else {
                lowPriorities.push(downloadRequest);
            }
        });
        NativeApi.downloadFileQueue = __spread(highPriorities, normalPriorities, lowPriorities);
        return deferred;
    };
    NativeApi.executeNextDownload = function () {
        if (NativeApi.downloadFileQueue.length > 0) {
            var downloadRequest = NativeApi.downloadFileQueue.splice(0, 1)[0];
            var galleryConfig = downloadRequest.galleryConfig, fileUrl = downloadRequest.fileUrl, destFolder_1 = downloadRequest.destFolder, destFileName_1 = downloadRequest.destFileName, parameters_1 = downloadRequest.parameters, deferred_1 = downloadRequest.deferred, fileId_1 = downloadRequest.fileId;
            if (galleryConfig.service) {
                // nativeReq param is needed to handle a case when calls are made to several domains (different application urls from ASP_SERVERS and from galleryConfig)
                var modifiedFileUrl_1 = fileUrl + __WEBPACK_IMPORTED_MODULE_0____["d" /* default */].getUrlSeparator(fileUrl) + 'nativeReq=true';
                var token_1 = galleryConfig.service.token;
                NativeApi.downloadFilePromise = NativeApi.existDirectory(destFolder_1)
                    .then(function (directoryExist) { return directoryExist ? {} : NativeApi.createDirectory(destFolder_1); })
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isIOS() ? __WEBPACK_IMPORTED_MODULE_0____["d" /* default */].isResourceAvailable(modifiedFileUrl_1) : {}; })
                    .then(function () {
                    var pId = NativeApi.getPid();
                    NativeApi.fileIdpIdMap[fileId_1] = pId;
                    return NativeApi.executeApiCall('downloadFile', [modifiedFileUrl_1, destFolder_1 + "/" + destFileName_1, parameters_1, token_1], pId);
                })
                    .progress(function (progress) { return deferred_1.notify(progress); })
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isOnlinePromise(); })
                    .then(function (isOnline) { return isOnline ? deferred_1.resolve() : deferred_1.reject(); })
                    .catch(function (result) { return deferred_1.reject(result); })
                    .finally(function () {
                    delete NativeApi.fileIdpIdMap[fileId_1];
                    NativeApi.downloadFilePromise = undefined;
                    NativeApi.executeNextDownload();
                });
            }
            else {
                NativeApi.executeNextDownload();
            }
        }
    };
    return NativeApi;
}());
var nativeApi = new NativeApi;
/* harmony default export */ __webpack_exports__["b"] = (NativeApi);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuItemType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateButtonOption; });
var MenuPosition;
(function (MenuPosition) {
    MenuPosition["left"] = "left";
    MenuPosition["center"] = "center";
    MenuPosition["right"] = "right";
    MenuPosition["burger"] = "burger";
})(MenuPosition || (MenuPosition = {}));
var CreateButtonOption;
(function (CreateButtonOption) {
    CreateButtonOption["folder"] = "create_folder";
    CreateButtonOption["publicationFromTemplate"] = "create_prop_tpl";
    CreateButtonOption["proposalFromFile"] = "create_prop_file";
    CreateButtonOption["importFile"] = "import_file";
    CreateButtonOption["externalLink"] = "create_ext_link";
})(CreateButtonOption || (CreateButtonOption = {}));
var MenuItemType;
(function (MenuItemType) {
    MenuItemType["Home"] = "goto_homepage";
    MenuItemType["Gallery"] = "goto_gallery";
    MenuItemType["Selection"] = "goto_favorites";
    MenuItemType["New"] = "goto_new";
    MenuItemType["Downloads"] = "goto_downloads";
    MenuItemType["Parameters"] = "goto_parameters";
    MenuItemType["Documents"] = "goto_documents";
    MenuItemType["SharedWithMe"] = "goto_sharedWithMe";
    MenuItemType["Link"] = "link";
    MenuItemType["Asset"] = "asset";
    MenuItemType["Folder"] = "folder";
    MenuItemType["Page"] = "page";
    MenuItemType["Logo"] = "logo";
    MenuItemType["BurgerButton"] = "burger_btn";
    MenuItemType["SelectionButton"] = "favorites_btn";
    MenuItemType["DownloadButton"] = "download_btn";
    MenuItemType["SearchButton"] = "search_btn";
    MenuItemType["ShareButton"] = "share_btn";
    MenuItemType["LogOut"] = "logout_btn";
    MenuItemType["Title"] = "title";
    MenuItemType["CancelButton"] = "cancel";
    MenuItemType["Profile"] = "profile";
    MenuItemType["ProposalStats"] = "proposal_stats";
    MenuItemType["ProposalArchive"] = "proposal_archive";
    MenuItemType["CreateButton"] = "create_btn";
    MenuItemType["CookieSettings"] = "cookie_settings";
    MenuItemType["CreateNote"] = "notes";
    MenuItemType["Notes"] = "notes_list";
    MenuItemType["BackToPublication"] = "back_btn";
})(MenuItemType || (MenuItemType = {}));



/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loader__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driveItem__ = __webpack_require__(11);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var DownloadManagerUtils = /** @class */ (function () {
    function DownloadManagerUtils() {
    }
    DownloadManagerUtils.getDownloadedItems = function (downloadManager) {
        var downloadList = downloadManager.items;
        return Object.keys(downloadList)
            .map(function (id) { return parseInt(id, 10); })
            .filter(function (id) { return DownloadManagerUtils.isItemDownloaded(downloadManager, id); });
    };
    DownloadManagerUtils.getDownloadingItems = function (downloadManager) {
        var downloadList = downloadManager.items;
        return Object.keys(downloadList)
            .map(function (id) { return parseInt(id, 10); })
            .filter(function (id) { return DownloadManagerUtils.isItemDownloading(downloadManager, id); });
    };
    DownloadManagerUtils.getItemLoaderStep = function (downloadManager, driveItemId) {
        if (DownloadManagerUtils.isItemDeleting(downloadManager, driveItemId)) {
            if (downloadManager.items[driveItemId]) {
                var item = downloadManager.items[driveItemId];
                if (DownloadManagerUtils.hasDependenciesBeingDeleted(downloadManager, driveItemId)) {
                    var totalDependenciesDeleted = DownloadManagerUtils.getTotalDependenciesDeleted(downloadManager, driveItemId);
                    return {
                        step: __WEBPACK_IMPORTED_MODULE_1__components_Loader__["a" /* LoaderStepName */].DeletingDependencies,
                        dependenciesDeleted: totalDependenciesDeleted,
                        dependenciesToDelete: item.dependencies.length,
                    };
                }
                var progress = item.progress || {};
                return {
                    step: __WEBPACK_IMPORTED_MODULE_1__components_Loader__["a" /* LoaderStepName */].Deleting,
                    progress: progress
                };
            }
        }
        if (DownloadManagerUtils.isItemDownloading(downloadManager, driveItemId)) {
            if (DownloadManagerUtils.isDownloadingAsset(downloadManager, driveItemId)) {
                var progress = downloadManager.items[driveItemId] && downloadManager.items[driveItemId].progress ? downloadManager.items[driveItemId].progress : {};
                return {
                    step: __WEBPACK_IMPORTED_MODULE_1__components_Loader__["a" /* LoaderStepName */].Downloading,
                    progress: progress
                };
            }
            if (DownloadManagerUtils.isAssetDownloaded(downloadManager, driveItemId) && !DownloadManagerUtils.isDependenciesDownloaded(downloadManager, driveItemId)) {
                if (downloadManager.items[driveItemId]) {
                    var totalDependenciesDownloaded = DownloadManagerUtils.getTotalDependenciesDownloaded(downloadManager, driveItemId);
                    return {
                        step: __WEBPACK_IMPORTED_MODULE_1__components_Loader__["a" /* LoaderStepName */].DownloadingDependencies,
                        dependenciesDownloaded: totalDependenciesDownloaded,
                        dependenciesToDownload: downloadManager.items[driveItemId].dependencies.length,
                    };
                }
            }
        }
        return;
    };
    DownloadManagerUtils.getStartedDownloadGroup = function (downloadGroups) {
        var downloadStatusAll = downloadGroups.all.status, downloadStatusImportant = downloadGroups.important.status, downloadStatusSelected = downloadGroups.selected.status;
        if (downloadStatusAll === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started) {
            return __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].ALL;
        }
        if (downloadStatusImportant === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started) {
            return __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT;
        }
        if (downloadStatusSelected === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started) {
            return __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED;
        }
        return null;
    };
    DownloadManagerUtils.getDownloadingGroup = function (downloadGroups) {
        var isDownloadingAll = downloadGroups.all.isDownloading, isDownloadingImportant = downloadGroups.important.isDownloading, isDownloadingSelected = downloadGroups.selected.isDownloading;
        if (isDownloadingAll) {
            return __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].ALL;
        }
        if (isDownloadingImportant) {
            return __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT;
        }
        if (isDownloadingSelected) {
            return __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED;
        }
        return null;
    };
    DownloadManagerUtils.getGalleryLoaderStep = function (downloadManager, driveList, galleryId, isDownloading, importantAssetTags) {
        // TODO: When download all will not download shared assets anymore as requeted by Armand, we should ignore these assets in the count when importantAssetTags is disabled
        if (isDownloading) {
            return {
                step: __WEBPACK_IMPORTED_MODULE_1__components_Loader__["a" /* LoaderStepName */].DownloadingAll,
                itemsDownloaded: DownloadManagerUtils.getTotalItemsDownloaded(downloadManager, driveList, importantAssetTags),
                itemsToDownload: DownloadManagerUtils.getTotalItemsToDownload(driveList, galleryId, importantAssetTags),
            };
        }
        return;
    };
    DownloadManagerUtils.isItemDownloading = function (downloadManager, driveItemId) {
        return DownloadManagerUtils.isDownloadingAsset(downloadManager, driveItemId)
            || (DownloadManagerUtils.isAssetDownloaded(downloadManager, driveItemId) && !DownloadManagerUtils.fetchedAllDependencies(downloadManager, driveItemId));
    };
    DownloadManagerUtils.isItemUpdating = function (downloadManager, driveItemId) {
        return DownloadManagerUtils.isUpdatingAsset(downloadManager, driveItemId)
            || (DownloadManagerUtils.isAssetDownloaded(downloadManager, driveItemId) && DownloadManagerUtils.isUpdatingAnyDependency(downloadManager, driveItemId));
    };
    DownloadManagerUtils.isItemDownloadingInProgress = function (downloadManager, driveItemId) {
        var downloadInProgressItems = downloadManager.downloadInProgressItems;
        return downloadInProgressItems.some(function (id) { return id === driveItemId; });
    };
    DownloadManagerUtils.isItemDeletingInProgress = function (downloadManager, driveItemId) {
        return DownloadManagerUtils.isItemDeleting(downloadManager, driveItemId);
    };
    DownloadManagerUtils.isRequiredItem = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId]
            && downloadManager.items[driveItemId].mode === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["c" /* DownloadMode */].Required;
    };
    DownloadManagerUtils.isRequestedItem = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId]
            && downloadManager.items[driveItemId].mode === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested;
    };
    DownloadManagerUtils.isPersistentItem = function (item) {
        return item ? [__WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested, __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["c" /* DownloadMode */].Required].includes(item.mode) : false;
    };
    DownloadManagerUtils.isItemPersistentlyDownloaded = function (downloadManager, driveItemId) {
        var driveItemInDownloadManager = downloadManager.items[driveItemId];
        return driveItemInDownloadManager
            && DownloadManagerUtils.isPersistentItem(driveItemInDownloadManager)
            && DownloadManagerUtils.isItemDownloaded(downloadManager, driveItemId);
    };
    DownloadManagerUtils.isItemDownloaded = function (downloadManager, driveItemId) {
        return DownloadManagerUtils.isAssetDownloaded(downloadManager, driveItemId)
            && DownloadManagerUtils.isDependenciesDownloaded(downloadManager, driveItemId);
    };
    DownloadManagerUtils.hasItemsToDownload = function (downloadManager, driveList, galleryInfos, importantAssetTags) {
        var driveItems = driveList.driveItems;
        var driveItemsKeys = Object.keys(driveItems);
        var driveItemsIds = [];
        if (driveItemsKeys.length > 0) {
            var galleryId = galleryInfos.config.applicationGallery;
            driveItemsIds = driveItemsKeys
                .filter(DownloadManagerUtils.filterDownloadableItems(driveItems, galleryId))
                .filter(DownloadManagerUtils.filterImportantItems(driveItems, importantAssetTags));
        }
        var hasItemsToDownload = driveItemsIds.some(function (key) {
            var itemId = parseInt(key, 10);
            var isItemNotDownloaded = !DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, itemId);
            if (isItemNotDownloaded) {
                return true;
            }
            var downloadList = downloadManager.items;
            var needUpdate = !DownloadManagerUtils.isLatestVersion(driveItems[itemId].version, downloadList[itemId].version);
            return needUpdate;
        });
        return hasItemsToDownload;
    };
    DownloadManagerUtils.getEnabledImportantTags = function (importantAssetsConfig) {
        if (!importantAssetsConfig || !importantAssetsConfig.enabled) {
            return [];
        }
        return importantAssetsConfig.tags;
    };
    DownloadManagerUtils.filterImportantItems = function (driveListItems, importantAssetTags) {
        return function (driveItemId) {
            if (importantAssetTags.length === 0) {
                return true;
            }
            var driveItem = driveListItems[driveItemId];
            while (driveItem) {
                if (DownloadManagerUtils.isImportantItem(driveItem, importantAssetTags)) {
                    return true;
                }
                var parentId = __WEBPACK_IMPORTED_MODULE_2__driveItem__["d" /* default */].getParentFolderId(driveItem);
                driveItem = driveListItems[parentId];
            }
            return false;
        };
    };
    DownloadManagerUtils.hasDownloadErrors = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId]
            && downloadManager.items[driveItemId].status === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].ERROR;
    };
    DownloadManagerUtils.isItemDeleting = function (downloadManager, driveItemId) {
        return DownloadManagerUtils.isDeletingAsset(downloadManager, driveItemId);
    };
    DownloadManagerUtils.isImportantItem = function (_a, importantAssetTags) {
        var tags = _a.tags;
        return tags.some(function (itemTag) { return importantAssetTags.includes(itemTag); });
    };
    DownloadManagerUtils.filterDownloadableItems = function (driveItems, galleryId) {
        return function (item) {
            var driveItem = driveItems[item];
            var isInGallery = driveItem.isInGallery;
            var isDownloadableType = __WEBPACK_IMPORTED_MODULE_2__driveItem__["d" /* default */].isDownloadableItemType(driveItem);
            var isTemplate = driveItem.isTemplate;
            var isNotGalleryItself = parseInt(item, 10) !== galleryId;
            return isInGallery && isDownloadableType && isNotGalleryItself && !isTemplate;
        };
    };
    DownloadManagerUtils.getTotalItemsDownloaded = function (downloadManager, driveList, importantAssetTags) {
        var items = downloadManager.items;
        var driveItems = driveList.driveItems;
        var downloadedItemsIds = Object.keys(items)
            .filter(function (item) {
            return DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, parseInt(item, 10)) && driveItems[item];
        })
            .filter(DownloadManagerUtils.filterImportantItems(driveItems, importantAssetTags));
        return downloadedItemsIds.length;
    };
    DownloadManagerUtils.getTotalItemsToDownload = function (driveList, galleryId, importantAssetTags) {
        var driveItems = driveList.driveItems;
        var downloadableItemsIds = Object.keys(driveItems)
            .filter(DownloadManagerUtils.filterDownloadableItems(driveItems, galleryId))
            .filter(DownloadManagerUtils.filterImportantItems(driveItems, importantAssetTags));
        return downloadableItemsIds.length;
    };
    DownloadManagerUtils.getTotalDependenciesDownloaded = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId].dependencies.reduce(DownloadManagerUtils.getTotalDependenciesDownloadedReducer(downloadManager), 0);
    };
    DownloadManagerUtils.getTotalDependenciesDownloadedReducer = function (downloadManager) {
        return function (total, dependencyId) {
            if (downloadManager.items[dependencyId] && downloadManager.items[dependencyId].status === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADED) {
                return total + 1;
            }
            return total;
        };
    };
    DownloadManagerUtils.isDownloadingAsset = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId]
            && [
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].INIT,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].GETTING_DEPENDENCIES,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADING,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_DOWNLOAD,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].RESUMING_DOWNLOAD,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_UPDATE,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].UPDATING,
            ].includes(downloadManager.items[driveItemId].status);
    };
    DownloadManagerUtils.isUpdatingAsset = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId]
            && [
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_UPDATE,
                __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].UPDATING,
            ].includes(downloadManager.items[driveItemId].status);
    };
    DownloadManagerUtils.isAssetDownloaded = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId] && downloadManager.items[driveItemId].status === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADED;
    };
    DownloadManagerUtils.isDependenciesDownloaded = function (downloadManager, driveItemId) {
        var itemFromDownloadManager = downloadManager.items[driveItemId];
        if (itemFromDownloadManager) {
            return itemFromDownloadManager.dependencies.every(function (dependencyId) { return DownloadManagerUtils.isAssetDownloaded(downloadManager, dependencyId); });
        }
        return false;
    };
    DownloadManagerUtils.fetchedAllDependencies = function (downloadManager, driveItemId) {
        var itemFromDownloadManager = downloadManager.items[driveItemId];
        return itemFromDownloadManager.dependencies.every(function (dependencyId) {
            return downloadManager.items[dependencyId] !== undefined &&
                DownloadManagerUtils.isAssetDownloaded(downloadManager, dependencyId);
        });
    };
    DownloadManagerUtils.isUpdatingAnyDependency = function (downloadManager, driveItemId) {
        var itemFromDownloadManager = downloadManager.items[driveItemId];
        return itemFromDownloadManager.dependencies.some(function (dependencyId) {
            return downloadManager.items[dependencyId] !== undefined &&
                DownloadManagerUtils.isUpdatingAsset(downloadManager, dependencyId);
        });
    };
    DownloadManagerUtils.isDeletingAsset = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId]
            && downloadManager.items[driveItemId].status === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_DELETION;
    };
    DownloadManagerUtils.hasDependenciesBeingDeleted = function (downloadManager, driveItemId) {
        var itemFromDownloadManager = downloadManager.items[driveItemId];
        if (itemFromDownloadManager && itemFromDownloadManager.dependencies.length > 0) {
            return itemFromDownloadManager.dependencies.some(function (dependencyId) {
                return downloadManager.items[dependencyId] !== undefined &&
                    downloadManager.items[dependencyId].status === __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_DELETION;
            });
        }
        return false;
    };
    DownloadManagerUtils.getTotalDependenciesDeleted = function (downloadManager, driveItemId) {
        return downloadManager.items[driveItemId].dependencies.reduce(DownloadManagerUtils.getTotalDependenciesDeletedReducer(downloadManager), 0);
    };
    DownloadManagerUtils.getTotalDependenciesDeletedReducer = function (downloadManager) {
        return function (total, dependencyId) {
            var dependencyItem = downloadManager.items[dependencyId];
            // Dependency is deleted if it's no longer in the manager or if it's not in STARTING_DELETION state
            if (!dependencyItem || dependencyItem.status !== __WEBPACK_IMPORTED_MODULE_0__containers_DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_DELETION) {
                return total + 1;
            }
            return total;
        };
    };
    DownloadManagerUtils.isLatestVersion = function (serverVersion, downloadedVersion) { return downloadedVersion >= serverVersion; };
    DownloadManagerUtils.isDependencyOfPersistentDriveItem = function (downloadManagerItems, driveItemId, excludeArray) {
        if (!driveItemId) {
            return false;
        }
        var driveItemInDownloadManager = downloadManagerItems[driveItemId];
        var dependentsId = driveItemInDownloadManager.dependents;
        for (var i = 0; i < dependentsId.length; i++) {
            var dependentId = dependentsId[i];
            var isInExcludeArray = !excludeArray.includes(dependentId);
            if (isInExcludeArray) {
                var dependentInDownloadManager = downloadManagerItems[dependentId];
                if (dependentInDownloadManager && DownloadManagerUtils.isPersistentItem(dependentInDownloadManager)) {
                    return true;
                }
                if (dependentId && DownloadManagerUtils.isDependencyOfPersistentDriveItem(downloadManagerItems, dependentId, __spread(excludeArray, dependentsId))) {
                    return true;
                }
            }
        }
        return false;
    };
    return DownloadManagerUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (DownloadManagerUtils);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnrichmentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accessibleVersionTextElements; });
var constants;
(function (constants) {
    constants["parentContainerId"] = "_idContainer";
    constants["textFieldWrapperClassName"] = "_idGenObjectAttribute";
    constants["textFieldCharacterClassName"] = "CharOverride";
    constants["textFieldClassName"] = "editable-text";
    constants["imageClassName"] = "editable-image";
    constants["videoClassName"] = "editable-video";
    constants["animationClassName"] = "editable-animation";
    constants["iframeClassName"] = "editable-iframe";
    constants["sliderClassName"] = "plugin-slider";
    constants["sliderPreviewClassName"] = "plugin-preview-slider";
    constants["videoOrIframeWrapperId"] = "_idHTMLPageItem";
    constants["buttonClassName"] = "_idGenButton";
    constants["buttonStateClassName"] = "_idGen-Appearance";
    constants["animationStartClassName"] = "_idGenAnimationStart";
    constants["animationEndStateDataAttribute"] = "idgenanimationendstate";
    constants["editableButtonClassName"] = "editable-button";
    constants["editableButtonLinkClassName"] = "editable-button-link";
    constants["editableButtonLinkGraphicsClassName"] = "_idGenObjectStyle";
    constants["lockedClassName"] = "locked";
    constants["lockedIconClassName"] = "locked-icon";
    constants["scrollableAreaClassName"] = "plugin-animationScrollableBox";
    constants["enrichmentClassName"] = "webpublication-enrichment";
    constants["themedItemClassName"] = "webPublication-theme-color";
    constants["pageIndexInSpreadClassName"] = "page-index";
    constants["multiStateObjectClassName"] = "_idGenMSO";
    constants["multiStateObjectDataAttribute"] = "data-idgenobjectstate";
})(constants || (constants = {}));
var EnrichmentType;
(function (EnrichmentType) {
    EnrichmentType["openNewTab"] = "openNewTab";
    EnrichmentType["openSameTab"] = "openSameTab";
    EnrichmentType["popup"] = "popup";
})(EnrichmentType || (EnrichmentType = {}));
var accessibleVersionTextElements = 'h1, h2, h3, h4, h5, h6, p, figcaption, li, code';
/* harmony default export */ __webpack_exports__["c"] = (constants);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SharePanelActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return shareItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setFormFieldsByContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setCrmContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return initiateShare; });
/* unused harmony export retrieveSubFoldersContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return share; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return finishShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return contactKeyByFieldName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeShareActionsPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeShareViaCopyPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCopyMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sharePublicationViaCopy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PendingTasksManager_actions__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_validation__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Selection_actions__ = __webpack_require__(53);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _a;
var _this = this;

















var ShareOrigin;
(function (ShareOrigin) {
    ShareOrigin["Detail"] = "@@ShareOrigin/detail";
    ShareOrigin["Theater"] = "@@ShareOrigin/theater";
    ShareOrigin["Selection"] = "@@ShareOrigin/selection";
})(ShareOrigin || (ShareOrigin = {}));
var SharePanelActionKeys;
(function (SharePanelActionKeys) {
    SharePanelActionKeys["OPEN_PANEL"] = "@@sharePanel/OPEN_PANEL";
    SharePanelActionKeys["CLOSE_PANEL"] = "@@sharePanel/CLOSE_PANEL";
    SharePanelActionKeys["OPEN_SHARE_ACTIONS_POPUP"] = "@@sharePanel/OPEN_SHARE_ACTIONS_POPUP";
    SharePanelActionKeys["CLOSE_SHARE_ACTIONS_POPUP"] = "@@sharePanel/CLOSE_SHARE_ACTIONS_POPUP";
    SharePanelActionKeys["OPEN_SHARE_VIA_COPY_POPUP"] = "@@sharePanel/OPEN_SHARE_VIA_COPY_POPUP";
    SharePanelActionKeys["CLOSE_SHARE_VIA_COPY_POPUP"] = "@@sharePanel/CLOSE_SHARE_VIA_COPY_POPUP";
    SharePanelActionKeys["SET_COPY_MODE"] = "@@sharePanel/SET_COPY_MODE";
    SharePanelActionKeys["START_PROCESSING"] = "@@sharePanel/START_PROCESSING";
    SharePanelActionKeys["FINISH_PROCESSING"] = "@@sharePanel/FINISH_PROCESSING";
    SharePanelActionKeys["SET_SELECTION"] = "@@sharePanel/SET_SELECTION";
    SharePanelActionKeys["SET_METHOD"] = "@@sharePanel/SET_METHOD";
    SharePanelActionKeys["SET_FORM_FIELD"] = "@@sharePanel/SET_FORM_FIELD";
    SharePanelActionKeys["RESET_FORM"] = "@@sharePanel/RESET_FORM";
    SharePanelActionKeys["UPDATE_FOLDERS_CONTENT"] = "@@sharePanel/UPDATE_FOLDERS_CONTENT";
    SharePanelActionKeys["SET_CRM_CONTACTS"] = "@@sharePanel/SET_CRM_CONTACTS";
})(SharePanelActionKeys || (SharePanelActionKeys = {}));
var share = function (sharedItems, sharedNotesIds, isPublicationShare, callbackAction) {
    if (isPublicationShare === void 0) { isPublicationShare = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, appInfos, galleryInfos, authentication, needCredentials, galleryConfig, sharedNetworks, type, isNativeShare, title, url, _b, id, label, format;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = getState(), appInfos = _a.appInfos, galleryInfos = _a.galleryInfos, authentication = _a.authentication;
                    needCredentials = authentication.userInfos.needCredentials;
                    galleryConfig = galleryInfos.config, sharedNetworks = galleryInfos.template.sharedNetworks;
                    type = appInfos.type || __WEBPACK_IMPORTED_MODULE_12__App_reducer__["a" /* AppType */].Single;
                    isNativeShare = __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp && !__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isSecure(type, needCredentials);
                    __WEBPACK_IMPORTED_MODULE_8__utils_statistics__["a" /* default */].trackShare(sharedItems);
                    if (!isNativeShare) return [3 /*break*/, 1];
                    title = __WEBPACK_IMPORTED_MODULE_13__utils_driveItem__["d" /* default */].getShareTitle(sharedItems);
                    url = __WEBPACK_IMPORTED_MODULE_13__utils_driveItem__["d" /* default */].getShareLink(sharedItems, galleryConfig, ShareOrigin.Selection);
                    __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__["b" /* default */].shareApp(title, url);
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["A" /* runCallbackAction */])(callbackAction));
                    return [3 /*break*/, 10];
                case 1:
                    if (!sharedNotesIds) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(setSelectedNotesData(sharedNotesIds))];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    if (!__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isMultipleShareEnabled(sharedNetworks)) return [3 /*break*/, 4];
                    dispatch(openShareActionsPopup(sharedItems, isPublicationShare, callbackAction));
                    return [3 /*break*/, 10];
                case 4:
                    if (!__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isShareOnlyViaUprezEnabled(sharedNetworks)) return [3 /*break*/, 6];
                    return [4 /*yield*/, dispatch(initiateShare(sharedItems, isPublicationShare, __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ShareNetwork.Uprez, callbackAction))];
                case 5:
                    _c.sent();
                    return [3 /*break*/, 10];
                case 6:
                    if (!__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isShareOnlyViaCopyEnabled(sharedNetworks)) return [3 /*break*/, 10];
                    if (!isPublicationShare) return [3 /*break*/, 8];
                    _b = sharedItems[0], id = _b.id, label = _b.label, format = _b.format;
                    return [4 /*yield*/, dispatch(sharePublicationViaCopy(galleryConfig.clientId, id, label, format))];
                case 7:
                    _c.sent();
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, dispatch(initiateShare(sharedItems, false, __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ShareNetwork.Copy, callbackAction))];
                case 9:
                    _c.sent();
                    _c.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
};
var setSelectedNotesData = function (notesIds) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var selectedNotes, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selectedNotes = [];
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < notesIds.length)) return [3 /*break*/, 4];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_15__utils_indexedDB_manager__["a" /* default */].getNote(notesIds[i]).then(function (note) {
                        if (note) {
                            var id = note.id, title = note.title;
                            selectedNotes.push({ id: id, title: title });
                        }
                    })];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4:
                dispatch({
                    type: SharePanelActionKeys.SET_SELECTION,
                    selectedNotes: selectedNotes,
                });
                return [2 /*return*/];
        }
    });
}); }; };
var initiateShare = function (sharedItems, isPublicationShare, shareAction, callbackAction) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var sharedNetworks, action, i, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sharedNetworks = getState().galleryInfos.template.sharedNetworks;
                dispatch({
                    type: SharePanelActionKeys.SET_SELECTION,
                    selectedResources: sharedItems,
                });
                if (__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isShareOnlyViaCopyEnabled(sharedNetworks)) {
                    // to display a loader while resources are being retrieved
                    dispatch(openShareViaCopyPopup([], '', undefined, callbackAction));
                }
                if (shareAction === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ShareNetwork.Uprez) {
                    action = {
                        type: SharePanelActionKeys.OPEN_PANEL,
                        isPublicationShare: isPublicationShare,
                        callbackAction: callbackAction,
                    };
                    dispatch(action);
                }
                dispatch({ type: SharePanelActionKeys.START_PROCESSING });
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < sharedItems.length)) return [3 /*break*/, 4];
                item = sharedItems[i];
                if (!(item.type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory)) return [3 /*break*/, 3];
                return [4 /*yield*/, dispatch(retrieveSubFoldersContent(item.id))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4:
                dispatch({ type: SharePanelActionKeys.FINISH_PROCESSING });
                if (!(shareAction === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].ShareNetwork.Copy)) return [3 /*break*/, 6];
                return [4 /*yield*/, dispatch(shareItems(true))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); }; };
var finishShare = function () { return function (dispatch) {
    dispatch({ type: SharePanelActionKeys.RESET_FORM });
    dispatch({ type: SharePanelActionKeys.CLOSE_PANEL });
    dispatch({ type: SharePanelActionKeys.CLOSE_SHARE_ACTIONS_POPUP });
    dispatch({ type: SharePanelActionKeys.FINISH_PROCESSING });
}; };
var getContactInfo = function (isMultiApp, hasMultipleContacts) {
    return function (dispatch, getState) {
        var form = getState().sharePanel.form;
        var contactEmail = form.contactEmail, company = form.company, firstname = form.firstname, phone = form.phone, position = form.position, surname = form.surname;
        if (!isMultiApp) {
            return undefined;
        }
        else if (hasMultipleContacts) {
            return {};
        }
        else {
            return {
                company: company,
                forename: firstname,
                email: contactEmail,
                name: surname,
                phone: phone,
                position: position
            };
        }
    };
};
var shareItems = function (isShareViaCopy) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, appInfos, sharePanel, locale, driveItems, form, isPublicationShare, selectedResources, callbackAction, userName, userEmail, contactEmail, message, subject, createDeal, isMultiApp, resources, _b, notesToShare, selectedNotesIds, emailsArray, hasInvalidEmail, contactInfo, requestData, isOnline, response, _c, resources_1, notes, pin, draftProposalsIds, i, sharedNotes, error_1, errorMessage;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState(), appInfos = _a.appInfos, sharePanel = _a.sharePanel, locale = _a.i18n.locale, driveItems = _a.driveList.driveItems;
                form = sharePanel.form, isPublicationShare = sharePanel.isPublicationShare, selectedResources = sharePanel.selectedResources, callbackAction = sharePanel.callbackAction;
                userName = form.userName, userEmail = form.userEmail, contactEmail = form.contactEmail, message = form.message, subject = form.subject, createDeal = form.createDeal;
                isMultiApp = __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isMultiApp(appInfos);
                resources = dispatch(retrieveResources());
                return [4 /*yield*/, dispatch(retrieveNotes())];
            case 1:
                _b = _d.sent(), notesToShare = _b.notesToShare, selectedNotesIds = _b.selectedNotesIds;
                emailsArray = contactEmail
                    .split(/[ ,]+/)
                    .filter(function (item) { return item !== ''; });
                hasInvalidEmail = emailsArray.some(function (item) { return !__WEBPACK_IMPORTED_MODULE_11__utils_validation__["a" /* default */].isValidEmail(item); });
                if (hasInvalidEmail) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.invalid_email_address'));
                    return [2 /*return*/];
                }
                contactInfo = dispatch(getContactInfo(isMultiApp, emailsArray.length > 1));
                requestData = {
                    fromName: !isMultiApp ? userName : '',
                    fromEmail: !isMultiApp ? userEmail : '',
                    toAddresses: emailsArray,
                    message: message,
                    language: locale,
                    resources: resources,
                    contactInfo: contactInfo,
                    subject: isMultiApp ? subject : undefined,
                    createDeal: createDeal,
                    forCopy: isShareViaCopy,
                    notes: notesToShare,
                };
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnlinePromise()];
            case 2:
                isOnline = _d.sent();
                if (!isOnline) return [3 /*break*/, 7];
                dispatch({ type: SharePanelActionKeys.START_PROCESSING });
                _d.label = 3;
            case 3:
                _d.trys.push([3, 5, , 6]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].shareContent(requestData)];
            case 4:
                response = _d.sent();
                if (response === 'response=ko') {
                    // If an error occured, the server still return a success
                    // But the response is KO
                    throw (new Error('share failed'));
                }
                dispatch(finishShare());
                if (isShareViaCopy) {
                    _c = JSON.parse(response), resources_1 = _c.resources, notes = _c.notes, pin = _c.pin;
                    dispatch(shareViaCopy(resources_1, notes, pin, callbackAction));
                }
                if (isPublicationShare) {
                    dispatch(finishPublicationSharing(resources[0].id, selectedResources[0].format));
                }
                else {
                    draftProposalsIds = resources
                        .map(function (_a) {
                        var id = _a.id;
                        return id;
                    })
                        .filter(function (id) { return __WEBPACK_IMPORTED_MODULE_13__utils_driveItem__["d" /* default */].isDraftProposal(driveItems[id]); });
                    for (i = 0; i < draftProposalsIds.length; i++) {
                        __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].getMeta(draftProposalsIds[i])
                            .then(function (item) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["H" /* updateDriveItem */])(item));
                        });
                    }
                }
                if (selectedNotesIds.length > 0) {
                    sharedNotes = JSON.parse(response).notes;
                    dispatch(replaceNotes(selectedNotesIds, sharedNotes));
                }
                if (!isShareViaCopy) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["A" /* runCallbackAction */])(callbackAction));
                }
                return [3 /*break*/, 6];
            case 5:
                error_1 = _d.sent();
                errorMessage = isPublicationShare
                    ? getPublicationShareErrorMessage(selectedResources[0].format)
                    : 'error.share_failed_request';
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])(errorMessage));
                dispatch({ type: SharePanelActionKeys.FINISH_PROCESSING });
                return [3 /*break*/, 6];
            case 6: return [3 /*break*/, 8];
            case 7:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__PendingTasksManager_actions__["b" /* addPendingShare */])(requestData));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('info.selection_shared_once_online'));
                dispatch(finishShare());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["A" /* runCallbackAction */])(callbackAction));
                _d.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}); }; };
var shareViaCopy = function (resources, notes, pin, callbackAction) { return function (dispatch, getState) {
    var driveItems = getState().driveList.driveItems;
    var resourceList = [];
    if (resources) {
        resources.forEach(function (_a) {
            var id = _a.id, url = _a.url;
            var label = driveItems[id].label;
            resourceList.push({ url: url, label: label });
        });
    }
    if (notes) {
        notes.forEach(function (_a) {
            var title = _a.title, url = _a.url;
            resourceList.push({ url: url, label: title });
        });
    }
    dispatch(openShareViaCopyPopup(resourceList, pin || '', undefined, callbackAction));
}; };
var retrieveResources = function () { return function (dispatch, getState) {
    var _a = getState(), galleryInfos = _a.galleryInfos, sharePanel = _a.sharePanel;
    var galleryConfig = galleryInfos.config;
    var selectedResources = sharePanel.selectedResources, foldersContent = sharePanel.foldersContent;
    var sharedContent = __spread(selectedResources.filter(function (item) { return item.type !== __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory; }), foldersContent);
    return sharedContent.map(function (item) {
        var type = item.type, id = item.id, originalFile = item.originalFile, src = item.src;
        var url = '';
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Gallery:
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.AppContainer:
                url = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getConfiguredRootApiClient(galleryConfig, false) + "/" + id;
                break;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Publication:
                url = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getPublicationUrl(galleryConfig, item, 1, false, true);
                break;
            case __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.ExternalLink:
                var linkId = src.replace('$media$', '');
                url = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getConfiguredRootApiClient(galleryConfig, false) + "/" + linkId;
                break;
            default:
                url = __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getConfiguredRootApiClient(galleryConfig, false) + "/" + originalFile;
                break;
        }
        return { id: id, url: url };
    });
}; };
var retrieveNotes = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var selectedNotes, notesToShare, selectedNotesIds, _loop_1, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selectedNotes = getState().sharePanel.selectedNotes;
                notesToShare = [];
                selectedNotesIds = [];
                _loop_1 = function (i) {
                    var noteId;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                noteId = selectedNotes[i].id;
                                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_15__utils_indexedDB_manager__["a" /* default */].getNote(noteId).then(function (note) {
                                        if (note) {
                                            notesToShare.push(note);
                                            selectedNotesIds.push(noteId);
                                        }
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < selectedNotes.length)) return [3 /*break*/, 4];
                return [5 /*yield**/, _loop_1(i)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, {
                    notesToShare: notesToShare,
                    selectedNotesIds: selectedNotesIds,
                }];
        }
    });
}); }; };
var addSubFoldersContent = function (item) { return function (dispatch, getState) {
    var sharePanel = getState().sharePanel;
    var selectedResources = sharePanel.selectedResources;
    if (item.id && !selectedResources.some(function (parent) { return parent.id === item.id; })) {
        dispatch({
            type: SharePanelActionKeys.UPDATE_FOLDERS_CONTENT,
            item: item,
        });
    }
}; };
var setCrmContacts = function (crmContacts) { return function (dispatch) {
    var action = {
        type: SharePanelActionKeys.SET_CRM_CONTACTS,
        crmContacts: crmContacts,
    };
    dispatch(action);
}; };
var contactKeyByFieldName = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__["a" /* FormField */].Firstname] = 'firstName',
    _a[__WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__["a" /* FormField */].Surname] = 'lastName',
    _a[__WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__["a" /* FormField */].Email] = 'email',
    _a[__WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__["a" /* FormField */].Company] = 'company',
    _a[__WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__["a" /* FormField */].Position] = 'position',
    _a[__WEBPACK_IMPORTED_MODULE_14__components_Share_UprezForm_typings__["a" /* FormField */].Phone] = 'phone',
    _a);
var setFormFieldByContactField = function (name, value) { return function (dispatch) {
    var action = {
        type: SharePanelActionKeys.SET_FORM_FIELD,
        name: name,
        value: value || '',
    };
    dispatch(action);
}; };
var setFormFieldsByContact = function (crmContact) { return function (dispatch) {
    var formKeys = Object.keys(contactKeyByFieldName);
    formKeys.forEach(function (formKey) {
        var contactKey = contactKeyByFieldName[formKey];
        var contactField = crmContact[contactKey];
        dispatch(setFormFieldByContactField(formKey, contactField));
    });
}; };
var retrieveSubFoldersContent = function (itemId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var driveItems, itemMeta, isFolder, resources, i, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 9, , 10]);
                driveItems = getState().driveList.driveItems;
                itemMeta = driveItems[itemId];
                if (!(!itemMeta || (itemMeta && itemMeta.type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory))) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(itemId))];
            case 1:
                itemMeta = (_a.sent());
                _a.label = 2;
            case 2:
                isFolder = itemMeta.type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory;
                if (!isFolder) return [3 /*break*/, 7];
                resources = itemMeta.resources;
                if (!resources) return [3 /*break*/, 6];
                i = 0;
                _a.label = 3;
            case 3:
                if (!(i < resources.length)) return [3 /*break*/, 6];
                return [4 /*yield*/, dispatch(retrieveSubFoldersContent(resources[i].id))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                i++;
                return [3 /*break*/, 3];
            case 6: return [3 /*break*/, 8];
            case 7:
                dispatch(addSubFoldersContent(itemMeta));
                _a.label = 8;
            case 8: return [3 /*break*/, 10];
            case 9:
                error_2 = _a.sent();
                dispatch({ type: SharePanelActionKeys.FINISH_PROCESSING });
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}); }; };
var openShareActionsPopup = function (sharedItems, isPublicationShare, callbackAction) { return ({
    type: SharePanelActionKeys.OPEN_SHARE_ACTIONS_POPUP,
    sharedItems: sharedItems,
    isPublicationShare: isPublicationShare,
    callbackAction: callbackAction,
}); };
var closeShareActionsPopup = function (shouldResetSelection) { return ({
    type: SharePanelActionKeys.CLOSE_SHARE_ACTIONS_POPUP,
    shouldResetSelection: shouldResetSelection,
}); };
var openShareViaCopyPopup = function (shareViaCopyData, pin, theme, callbackAction) { return ({
    type: SharePanelActionKeys.OPEN_SHARE_VIA_COPY_POPUP,
    shareViaCopyData: shareViaCopyData,
    pin: pin,
    theme: theme,
    callbackAction: callbackAction,
}); };
var closeShareViaCopyPopup = function () { return ({
    type: SharePanelActionKeys.CLOSE_SHARE_VIA_COPY_POPUP,
}); };
var setCopyMode = function (copyMode) { return ({
    type: SharePanelActionKeys.SET_COPY_MODE,
    copyMode: copyMode,
}); };
var finishPublicationSharing = function (resourceId, format) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var resource, driveItems, parentId, error_3, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].getMeta(resourceId)];
            case 1:
                resource = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["H" /* updateDriveItem */])(resource));
                if (__WEBPACK_IMPORTED_MODULE_13__utils_driveItem__["d" /* default */].isProposal(format)) {
                    driveItems = getState().driveList.driveItems;
                    parentId = __WEBPACK_IMPORTED_MODULE_13__utils_driveItem__["d" /* default */].getParentFolderId(driveItems[resourceId]);
                    __WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].redirectToParentDir(parentId);
                }
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                errorMessage = getPublicationShareErrorMessage(format);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])(errorMessage));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var sharePublicationViaCopy = function (clientId, resourceId, label, format, theme) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, pin, resourceUrl, resourceList, error_4, errorMessage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].sharePublication(clientId, resourceId, label)];
            case 1:
                _a = _b.sent(), pin = _a.pin, resourceUrl = _a.resourceUrl;
                dispatch(finishPublicationSharing(resourceId, format));
                resourceList = [];
                resourceList.push({ url: resourceUrl, label: label });
                dispatch(openShareViaCopyPopup(resourceList, pin, theme));
                return [3 /*break*/, 3];
            case 2:
                error_4 = _b.sent();
                errorMessage = getPublicationShareErrorMessage(format);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])(errorMessage));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
// when note is shared it should be replaced with one from server in selection and removed from indexedDB
var replaceNotes = function (selectedNotesIds, sharedNotes) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var i, selectedNoteId, _a, sharedNoteId, date, selectedNote;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                i = 0;
                _b.label = 1;
            case 1:
                if (!(i < selectedNotesIds.length)) return [3 /*break*/, 6];
                selectedNoteId = selectedNotesIds[i];
                _a = sharedNotes[i], sharedNoteId = _a.id, date = _a.date;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_15__utils_indexedDB_manager__["a" /* default */].getNote(selectedNoteId)];
            case 2:
                selectedNote = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__Selection_actions__["f" /* toggleSelection */])(selectedNoteId, __WEBPACK_IMPORTED_MODULE_16__Selection_actions__["b" /* SelectionType */].NOTES));
                if (!selectedNote) return [3 /*break*/, 5];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_15__utils_indexedDB_manager__["a" /* default */].setNote(sharedNoteId, __assign({}, selectedNote, { id: sharedNoteId, date: date }))];
            case 3:
                _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__Selection_actions__["f" /* toggleSelection */])(sharedNoteId, __WEBPACK_IMPORTED_MODULE_16__Selection_actions__["b" /* SelectionType */].NOTES));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_15__utils_indexedDB_manager__["a" /* default */].removeNote(selectedNoteId)];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5:
                i++;
                return [3 /*break*/, 1];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
var getPublicationShareErrorMessage = function (format) { return (__WEBPACK_IMPORTED_MODULE_13__utils_driveItem__["d" /* default */].isProposal(format)
    ? 'error.share_proposal_error'
    : 'error.share_publication_error'); };



/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FileType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ImportManagerActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addFileInImport; });
/* unused harmony export addFilesInImport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateFileInImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeFileFromImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeFilesFromImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelFileImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelFilesImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return restartFilesImport; });
/* unused harmony export addToFilesQueue */
/* unused harmony export removeFromFilesQueue */
/* unused harmony export updateRemainingImportTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return importFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return importDesktopFiles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImportDesktopFile_Toast_selectors__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_nativeApi__ = __webpack_require__(39);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;












var FileType;
(function (FileType) {
    FileType["COMPONENT"] = "component";
})(FileType || (FileType = {}));
var FileError;
(function (FileError) {
    FileError["TYPE"] = "wrong_file_type";
    FileError["IMPORT"] = "file_import_error";
    FileError["PROCESSING"] = "processing_fail";
})(FileError || (FileError = {}));
var ImportManagerActionKeys;
(function (ImportManagerActionKeys) {
    ImportManagerActionKeys["ADD_FILE_IN_IMPORT"] = "@@importManager/ADD_FILE_IN_IMPORT";
    ImportManagerActionKeys["ADD_FILES_IN_IMPORT"] = "@@importManager/ADD_FILES_IN_IMPORT";
    ImportManagerActionKeys["UPDATE_FILE_IN_IMPORT"] = "@@importManager/UPDATE_FILE_IN_IMPORT";
    ImportManagerActionKeys["REMOVE_FILE_FROM_IMPORT"] = "@@importManager/REMOVE_FILE_FROM_IMPORT";
    ImportManagerActionKeys["REMOVE_FILES_FROM_IMPORT"] = "@@importManager/REMOVE_FILES_FROM_IMPORT";
    ImportManagerActionKeys["CANCEL_FILES_IMPORT"] = "@@importManager/CANCEL_FILES_IMPORT";
    ImportManagerActionKeys["RESTART_FILES_IMPORT"] = "@@importManager/RESTART_FILES_IMPORT";
    ImportManagerActionKeys["ADD_TO_FILES_QUEUE"] = "@@importManager/ADD_TO_FILES_QUEUE";
    ImportManagerActionKeys["REMOVE_FROM_FILES_QUEUE"] = "@@importManager/REMOVE_FROM_FILES_QUEUE";
    ImportManagerActionKeys["UPDATE_REMAINING_IMPORT_TIME"] = "@@importManager/UPDATE_REMAINING_IMPORT_TIME";
})(ImportManagerActionKeys || (ImportManagerActionKeys = {}));
var addFileInImport = function (id, data) { return ({
    type: ImportManagerActionKeys.ADD_FILE_IN_IMPORT,
    id: id,
    data: data,
}); };
var addFilesInImport = function (folderId, files, ids) { return ({
    type: ImportManagerActionKeys.ADD_FILES_IN_IMPORT,
    folderId: folderId,
    files: files,
    ids: ids,
}); };
var updateFileInImport = function (id, data) { return ({
    type: ImportManagerActionKeys.UPDATE_FILE_IN_IMPORT,
    id: id,
    data: data,
}); };
var removeFileFromImport = function (id) { return function (dispatch) {
    dispatch({
        type: ImportManagerActionKeys.REMOVE_FILE_FROM_IMPORT,
        id: id,
    });
    __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].cancelRequest(id);
}; };
var removeFilesFromImport = function (ids) { return function (dispatch) {
    dispatch({
        type: ImportManagerActionKeys.REMOVE_FILES_FROM_IMPORT,
        ids: ids,
    });
    ids.forEach(function (id) { return __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].cancelRequest(id); });
}; };
var cancelFileImport = function (id) { return function (dispatch) {
    dispatch(removeFromFilesQueue(id));
    dispatch({
        type: ImportManagerActionKeys.UPDATE_FILE_IN_IMPORT,
        id: id,
        data: {
            isImportCanceled: true,
        },
    });
    __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].cancelRequest(id);
}; };
var cancelFilesImport = function (ids) { return function (dispatch) {
    dispatch({
        type: ImportManagerActionKeys.CANCEL_FILES_IMPORT,
        ids: ids,
    });
    ids.forEach(function (id) { return __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].cancelRequest(id); });
}; };
var restartFilesImport = function (ids) { return function (dispatch, getState) {
    dispatch({
        type: ImportManagerActionKeys.RESTART_FILES_IMPORT,
        ids: ids,
    });
    var byId = getState().importManager.byId;
    var files = ids.map(function (id) { return byId[id].file; });
    dispatch(importDesktopFiles(files, ids));
}; };
var addToFilesQueue = function (ids) { return ({
    type: ImportManagerActionKeys.ADD_TO_FILES_QUEUE,
    ids: ids,
}); };
var removeFromFilesQueue = function (id) { return ({
    type: ImportManagerActionKeys.REMOVE_FROM_FILES_QUEUE,
    id: id,
}); };
var updateRemainingImportTime = function (time) { return ({
    type: ImportManagerActionKeys.UPDATE_REMAINING_IMPORT_TIME,
    time: time,
}); };
var importFile = function (_a) {
    var id = _a.id, file = _a.file, onImport = _a.onImport, folderId = _a.folderId, shouldDisplayInToast = _a.shouldDisplayInToast, fileType = _a.fileType, isOptimizedImageImport = _a.isOptimizedImageImport, isPublicationDependency = _a.isPublicationDependency;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, config, driveList, publicationParentFolderId, resourceId, parentFolderId, loadedBytesAtPrevSecond, onImportProgress, uploadFile, RESOURCE_PROCESSING_DELAY, resourceProcessingTimer, getResourceProcessing, resource, status_1, resourceGId_1, parentId, importResponse, error_1, _c, _d, _e, isImportCanceled;
        var _this = this;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _b = getState(), config = _b.galleryInfos.config, driveList = _b.driveList;
                    if (isPublicationDependency) {
                        resourceId = Object(__WEBPACK_IMPORTED_MODULE_6__Editor_utils_helpers__["g" /* getClientAndResourceIds */])().originalGId;
                        publicationParentFolderId = __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].isEmbedMode()
                            ? __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].getParentFolderId(driveList.driveItems[resourceId])
                            : __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSourcesDirId(driveList, config);
                    }
                    parentFolderId = folderId ||
                        publicationParentFolderId ||
                        __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getPrivateDirId(driveList, config);
                    loadedBytesAtPrevSecond = 0;
                    onImportProgress = function (e) {
                        var percentage = Math.floor((e.loaded / e.total) * 100);
                        if (!shouldDisplayInToast) {
                            dispatch(updateFileInImport(id, {
                                percentage: percentage,
                            }));
                            return;
                        }
                        // At the first second of file import loaded bytes are small which causes remainingTime
                        // to be a very big. To prevent it, remainingTime is not calculated at the first second
                        if (!loadedBytesAtPrevSecond) {
                            loadedBytesAtPrevSecond = e.loaded;
                            return;
                        }
                        var uploadingFilesSize = Object(__WEBPACK_IMPORTED_MODULE_5__ImportDesktopFile_Toast_selectors__["f" /* getUploadingFilesSize */])(getState());
                        var loadSpeed = e.loaded - loadedBytesAtPrevSecond;
                        loadedBytesAtPrevSecond = e.loaded;
                        // e.total and uploadingFilesSize (which is calculated as a sum of file.size of all files)
                        // are not absolutely equal. It can cause remainingBytes to be a negative value.
                        // Math.max is used to prevent it
                        var remainingBytes = Math.max(uploadingFilesSize - e.loaded, 0);
                        var remainingTime = remainingBytes / loadSpeed;
                        dispatch(updateFileInImport(id, {
                            percentage: percentage,
                        }));
                        dispatch(updateRemainingImportTime(remainingTime));
                    };
                    uploadFile = function () { return __awaiter(_this, void 0, void 0, function () {
                        var data, globalId, resource;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(fileType === FileType.COMPONENT)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].createComponent(config.clientId, parentFolderId, file, isPublicationDependency)];
                                case 1:
                                    data = _a.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].importFile(config.clientId, parentFolderId, file, onImportProgress, id, isOptimizedImageImport, isPublicationDependency)];
                                case 3:
                                    data = _a.sent();
                                    _a.label = 4;
                                case 4:
                                    globalId = 'globalId' in data
                                        ? data.globalId
                                        : data.resourceGId;
                                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getMeta(globalId)];
                                case 5:
                                    resource = _a.sent();
                                    return [2 /*return*/, resource];
                            }
                        });
                    }); };
                    RESOURCE_PROCESSING_DELAY = 2000;
                    getResourceProcessing = function (resourceGId) { return __awaiter(_this, void 0, void 0, function () {
                        var resource, status_2, parentId, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getMeta(resourceGId)];
                                case 1:
                                    resource = _a.sent();
                                    status_2 = resource.status;
                                    if (!status_2 || status_2 === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].AssetItemStatus.LIVE) {
                                        clearInterval(resourceProcessingTimer);
                                        parentId = __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].getParentFolderId(resource);
                                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(parentId, true, true, true));
                                        if (shouldDisplayInToast) {
                                            dispatch(updateFileInImport(id, {
                                                isImportFinished: true,
                                            }));
                                        }
                                        else {
                                            dispatch(removeFileFromImport(id));
                                        }
                                    }
                                    else if (status_2 === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].AssetItemStatus.ERROR) {
                                        clearInterval(resourceProcessingTimer);
                                        dispatch(updateFileInImport(id, {
                                            error: FileError.IMPORT,
                                            percentage: 100,
                                        }));
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_2 = _a.sent();
                                    clearInterval(resourceProcessingTimer);
                                    dispatch(updateFileInImport(id, {
                                        error: FileError.IMPORT,
                                        percentage: 100,
                                    }));
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!shouldDisplayInToast) {
                        dispatch(addFileInImport(id, {
                            id: id,
                            folderId: folderId,
                            percentage: 0,
                            error: null,
                        }));
                    }
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 10, , 11]);
                    return [4 /*yield*/, uploadFile()];
                case 2:
                    resource = _f.sent();
                    status_1 = resource.status, resourceGId_1 = resource.id;
                    parentId = __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].getParentFolderId(resource);
                    // server doesn't return 'icon' field until video processing is finished which leads to display of default video icon instead of cover image
                    // for videos 'icon' always has the same form so adding it manually loads a cover image immediately
                    if (resource.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Movie && !resource.icon) {
                        resource.icon = "$media$" + resourceGId_1 + "/cover.jpg";
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["r" /* receiveDriveItems */])((_a = {}, _a[resourceGId_1] = resource, _a)));
                    if (__WEBPACK_IMPORTED_MODULE_10__utils_userAgent__["a" /* default */].isMobileApp) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__OfflineManager_actions__["e" /* downloadThumb */])(resourceGId_1, __WEBPACK_IMPORTED_MODULE_11__utils_nativeApi__["a" /* DownloadPriority */].Normal, false, resource));
                    }
                    if (!(!status_1 || status_1 === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].AssetItemStatus.LIVE)) return [3 /*break*/, 4];
                    return [4 /*yield*/, onImport(resource)];
                case 3:
                    importResponse = _f.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(parentId, true, true, true));
                    if (!importResponse || !importResponse.isError) {
                        if (shouldDisplayInToast) {
                            dispatch(updateFileInImport(id, {
                                isImportFinished: true,
                            }));
                        }
                        else {
                            dispatch(removeFileFromImport(id));
                        }
                    }
                    return [3 /*break*/, 9];
                case 4:
                    if (!(status_1 === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].AssetItemStatus.ERROR)) return [3 /*break*/, 5];
                    dispatch(updateFileInImport(id, {
                        error: FileError.IMPORT,
                    }));
                    return [3 /*break*/, 9];
                case 5:
                    if (!shouldDisplayInToast) return [3 /*break*/, 7];
                    dispatch(updateFileInImport(id, {
                        isImportFinished: true,
                    }));
                    return [4 /*yield*/, onImport(resource)];
                case 6:
                    _f.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(parentId, true, true, true));
                    return [3 /*break*/, 9];
                case 7:
                    dispatch(updateFileInImport(id, {
                        isProcessing: true,
                    }));
                    return [4 /*yield*/, onImport(resource)];
                case 8:
                    _f.sent();
                    resourceProcessingTimer = window.setInterval(function () {
                        getResourceProcessing(resourceGId_1);
                    }, RESOURCE_PROCESSING_DELAY);
                    _f.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10:
                    error_1 = _f.sent();
                    _c = id, _d = getState().importManager.byId[_c], _e = (_d === void 0 ? {} : _d).isImportCanceled, isImportCanceled = _e === void 0 ? false : _e;
                    // to prevent displaying error in Toast if user canceled import
                    if (!isImportCanceled) {
                        dispatch(updateFileInImport(id, {
                            error: FileError.IMPORT,
                            percentage: 100,
                        }));
                    }
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
};
var importDesktopFiles = function (files, prevFilesIds) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var parentFolderId, routerParamsHistory, currentOriginParam, prevFilesQueue, filesIds, filesQueue, id, _a, _b, _c, _d, file, _e, folderId, error_3;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 6]);
                parentFolderId = __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getFolderIdForNewResource();
                if (!parentFolderId) {
                    return [2 /*return*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__NotificationBar_actions__["c" /* createNotification */])('error.file_import_error'))];
                }
                routerParamsHistory = getState().routerParamsHistory;
                currentOriginParam = __WEBPACK_IMPORTED_MODULE_8__utils_routes__["a" /* default */].getCurrentOriginParam(routerParamsHistory);
                if (currentOriginParam !== parentFolderId.toString()) {
                    __WEBPACK_IMPORTED_MODULE_8__utils_routes__["a" /* default */].redirectToParentDir(parentFolderId);
                }
                prevFilesQueue = getState().importManager.filesQueue;
                filesIds = prevFilesIds || files.map(function (file) { return __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].generateId(); });
                // if prevFilesIds is presented, it means that these files are already added in
                // importManager and they are restarted
                if (!prevFilesIds) {
                    dispatch(addFilesInImport(parentFolderId, files, filesIds));
                }
                dispatch(addToFilesQueue(filesIds));
                // in case some prev files are being imported, while loop shouldn't be recalled
                if (prevFilesQueue.length > 0) {
                    return [2 /*return*/];
                }
                filesQueue = getState().importManager.filesQueue;
                _f.label = 1;
            case 1:
                if (!(filesQueue.length > 0)) return [3 /*break*/, 4];
                id = filesQueue[0];
                _a = id, _b = getState().importManager.byId[_a], _c = _b === void 0 ? {} : _b, _d = _c.file, file = _d === void 0 ? undefined : _d, _e = _c.folderId, folderId = _e === void 0 ? parentFolderId : _e;
                if (!file) return [3 /*break*/, 3];
                return [4 /*yield*/, dispatch(importFile({
                        id: id,
                        file: file,
                        onImport: function () { return undefined; },
                        folderId: folderId,
                        shouldDisplayInToast: true,
                    }))];
            case 2:
                _f.sent();
                _f.label = 3;
            case 3:
                dispatch(removeFromFilesQueue(id));
                filesQueue = getState().importManager.filesQueue;
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 6];
            case 5:
                error_3 = _f.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__NotificationBar_actions__["c" /* createNotification */])('error.file_import_error'));
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(187)('wks');
var uid = __webpack_require__(159);
var Symbol = __webpack_require__(57).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HEADER_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE_PADDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditorContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EditorWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SpreadWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Loader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PageElementActionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEditorScrollStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var ACTION_BAR_HEIGHT = 50;
var HEADER_HEIGHT = __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp()
    ? ACTION_BAR_HEIGHT + parseInt(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */], 10)
    : ACTION_BAR_HEIGHT;
var PAGE_PADDING = 27;
var getEditorScrollStyles = function (config) { return !__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp
    ? "\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: " + (config && config.width || 16) + "px;\n\t\t}\n\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 20) + ";\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 20) + ";\n\t\t}\n\n\t\t&::-webkit-scrollbar-corner {\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 20) + ";\n\t\t}"
    : ''; };
var EditorContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"])));
var EditorWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", "px;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\tbackground-color: ", ";\n"], ["\n\tposition: absolute;\n\ttop: ", "px;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\tbackground-color: ", ";\n"])), HEADER_HEIGHT, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey1000);
var ContentWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n"], ["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n"])));
var ContentInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"], ["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"])));
var SpreadWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\toverflow: auto;\n\n\t", "\n"], ["\n\tposition: relative;\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\toverflow: auto;\n\n\t", "\n"])), getEditorScrollStyles());
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: ", ";\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: ", ";\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 75), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, function (_a) {
    var isProcessing = _a.isProcessing;
    return isProcessing && 'z-index: 11;';
});
var PageElementActionButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition:  ", ";\n\ttop: ", ";\n\tleft: 0;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tpadding: 0;\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tbox-shadow: 0 0 5px 0 ", ", 0 2px 14px 0 ", ";\n\tpointer-events: auto;\n\tcursor: pointer;\n\ttransform-origin: 0 0;\n\tmargin-bottom: ", ";\n\tz-index: 100;\n\n\t", "\n\t", "\n\n\tsvg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: currentColor;\n\t\tmargin: 0;\n\t}\n"], ["\n\tposition:  ", ";\n\ttop: ", ";\n\tleft: 0;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tpadding: 0;\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tbox-shadow: 0 0 5px 0 ", ", 0 2px 14px 0 ", ";\n\tpointer-events: auto;\n\tcursor: pointer;\n\ttransform-origin: 0 0;\n\tmargin-bottom: ", ";\n\tz-index: 100;\n\n\t", "\n\t", "\n\n\tsvg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: currentColor;\n\t\tmargin: 0;\n\t}\n"])), function (_a) {
    var isAccessibleVersion = _a.isAccessibleVersion;
    return isAccessibleVersion ? 'relative' : 'absolute';
}, function (_a) {
    var isAccessibleVersion = _a.isAccessibleVersion;
    return isAccessibleVersion ? '25px' : '0';
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 12), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 32), function (_a) {
    var isVisible = _a.isVisible;
    return !isVisible ? '25px' : '0';
}, function (_a) {
    var pageScale = _a.pageScale, spreadZoom = _a.spreadZoom;
    return spreadZoom >= 1 && "transform: scale(" + 1 / pageScale + ");";
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && 'z-index: 1;';
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(57);
var core = __webpack_require__(47);
var hide = __webpack_require__(106);
var redefine = __webpack_require__(108);
var ctx = __webpack_require__(109);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delete__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__download__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__typings__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["l"]; });
/* unused harmony reexport updateDownloadInManager */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__delete__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__delete__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__delete__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__download__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__download__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__delete__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__delete__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__download__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_3__download__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__download__["c"]; });
/* unused harmony reexport addItemInManager */
/* unused harmony reexport recordDownloadProgress */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["e"]; });
/* unused harmony reexport setIsMarkingItemForDeletion */







/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setLocales__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_sessionChecker__ = __webpack_require__(1071);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};








// Enable Redux DevTools
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];
var reduxRouterMiddleware = Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerMiddleware"])(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* hashHistory */]);
var middlewares = [
    __WEBPACK_IMPORTED_MODULE_4_redux_thunk___default.a,
    reduxRouterMiddleware,
    Object(__WEBPACK_IMPORTED_MODULE_7__middlewares_sessionChecker__["a" /* default */])(),
];
if (false) {
    middlewares.push(createLogger());
}
var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* default */], composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(void 0, __spread(middlewares))));
Object(__WEBPACK_IMPORTED_MODULE_6__setLocales__["b" /* default */])(store);
var history = Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* hashHistory */], store);
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, isEmpty, isFunction, isObject, ref,
    hasProp = {}.hasOwnProperty;

  ref = __webpack_require__(94), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty;

  XMLElement = null;

  XMLCData = null;

  XMLComment = null;

  XMLDeclaration = null;

  XMLDocType = null;

  XMLRaw = null;

  XMLText = null;

  XMLProcessingInstruction = null;

  module.exports = XMLNode = (function() {
    function XMLNode(parent) {
      this.parent = parent;
      if (this.parent) {
        this.options = this.parent.options;
        this.stringify = this.parent.stringify;
      }
      this.children = [];
      if (!XMLElement) {
        XMLElement = __webpack_require__(201);
        XMLCData = __webpack_require__(202);
        XMLComment = __webpack_require__(203);
        XMLDeclaration = __webpack_require__(204);
        XMLDocType = __webpack_require__(205);
        XMLRaw = __webpack_require__(210);
        XMLText = __webpack_require__(211);
        XMLProcessingInstruction = __webpack_require__(212);
      }
    }

    XMLNode.prototype.element = function(name, attributes, text) {
      var childNode, item, j, k, key, lastChild, len, len1, ref1, val;
      lastChild = null;
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (Array.isArray(name)) {
        for (j = 0, len = name.length; j < len; j++) {
          item = name[j];
          lastChild = this.element(item);
        }
      } else if (isFunction(name)) {
        lastChild = this.element(name.apply());
      } else if (isObject(name)) {
        for (key in name) {
          if (!hasProp.call(name, key)) continue;
          val = name[key];
          if (isFunction(val)) {
            val = val.apply();
          }
          if ((isObject(val)) && (isEmpty(val))) {
            val = null;
          }
          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
            for (k = 0, len1 = val.length; k < len1; k++) {
              item = val[k];
              childNode = {};
              childNode[key] = item;
              lastChild = this.element(childNode);
            }
          } else if (isObject(val)) {
            lastChild = this.element(key);
            lastChild.element(val);
          } else {
            lastChild = this.element(key, val);
          }
        }
      } else {
        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
          lastChild = this.text(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
          lastChild = this.cdata(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
          lastChild = this.comment(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
          lastChild = this.raw(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) {
          lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
        } else {
          lastChild = this.node(name, attributes, text);
        }
      }
      if (lastChild == null) {
        throw new Error("Could not create any elements with: " + name);
      }
      return lastChild;
    };

    XMLNode.prototype.insertBefore = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.insertAfter = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.remove = function() {
      var i, ref1;
      if (this.isRoot) {
        throw new Error("Cannot remove the root element");
      }
      i = this.parent.children.indexOf(this);
      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref1 = [])), ref1;
      return this.parent;
    };

    XMLNode.prototype.node = function(name, attributes, text) {
      var child, ref1;
      if (name != null) {
        name = name.valueOf();
      }
      attributes || (attributes = {});
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      child = new XMLElement(this, name, attributes);
      if (text != null) {
        child.text(text);
      }
      this.children.push(child);
      return child;
    };

    XMLNode.prototype.text = function(value) {
      var child;
      child = new XMLText(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.commentBefore = function(value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.comment(value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.commentAfter = function(value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.comment(value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.raw = function(value) {
      var child;
      child = new XMLRaw(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.instruction = function(target, value) {
      var insTarget, insValue, instruction, j, len;
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (j = 0, len = target.length; j < len; j++) {
          insTarget = target[j];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        instruction = new XMLProcessingInstruction(this, target, value);
        this.children.push(instruction);
      }
      return this;
    };

    XMLNode.prototype.instructionBefore = function(target, value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.instruction(target, value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.instructionAfter = function(target, value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.instruction(target, value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.declaration = function(version, encoding, standalone) {
      var doc, xmldec;
      doc = this.document();
      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
      if (doc.children[0] instanceof XMLDeclaration) {
        doc.children[0] = xmldec;
      } else {
        doc.children.unshift(xmldec);
      }
      return doc.root() || doc;
    };

    XMLNode.prototype.doctype = function(pubID, sysID) {
      var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
      doc = this.document();
      doctype = new XMLDocType(doc, pubID, sysID);
      ref1 = doc.children;
      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
        child = ref1[i];
        if (child instanceof XMLDocType) {
          doc.children[i] = doctype;
          return doctype;
        }
      }
      ref2 = doc.children;
      for (i = k = 0, len1 = ref2.length; k < len1; i = ++k) {
        child = ref2[i];
        if (child.isRoot) {
          doc.children.splice(i, 0, doctype);
          return doctype;
        }
      }
      doc.children.push(doctype);
      return doctype;
    };

    XMLNode.prototype.up = function() {
      if (this.isRoot) {
        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
      }
      return this.parent;
    };

    XMLNode.prototype.root = function() {
      var node;
      node = this;
      while (node) {
        if (node.isDocument) {
          return node.rootObject;
        } else if (node.isRoot) {
          return node;
        } else {
          node = node.parent;
        }
      }
    };

    XMLNode.prototype.document = function() {
      var node;
      node = this;
      while (node) {
        if (node.isDocument) {
          return node;
        } else {
          node = node.parent;
        }
      }
    };

    XMLNode.prototype.end = function(options) {
      return this.document().end(options);
    };

    XMLNode.prototype.prev = function() {
      var i;
      i = this.parent.children.indexOf(this);
      if (i < 1) {
        throw new Error("Already at the first node");
      }
      return this.parent.children[i - 1];
    };

    XMLNode.prototype.next = function() {
      var i;
      i = this.parent.children.indexOf(this);
      if (i === -1 || i === this.parent.children.length - 1) {
        throw new Error("Already at the last node");
      }
      return this.parent.children[i + 1];
    };

    XMLNode.prototype.importDocument = function(doc) {
      var clonedRoot;
      clonedRoot = doc.root().clone();
      clonedRoot.parent = this;
      clonedRoot.isRoot = false;
      this.children.push(clonedRoot);
      return this;
    };

    XMLNode.prototype.ele = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLNode.prototype.doc = function() {
      return this.document();
    };

    XMLNode.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLNode.prototype.dtd = function(pubID, sysID) {
      return this.doctype(pubID, sysID);
    };

    XMLNode.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.t = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLNode.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    XMLNode.prototype.u = function() {
      return this.up();
    };

    XMLNode.prototype.importXMLBuilder = function(doc) {
      return this.importDocument(doc);
    };

    return XMLNode;

  })();

}).call(this);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectionActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPreviousSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeFromSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__ = __webpack_require__(23);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;




var SelectionType;
(function (SelectionType) {
    SelectionType["RESOURCES"] = "resources";
    SelectionType["NOTES"] = "notes";
})(SelectionType || (SelectionType = {}));
var SelectionActionKeys;
(function (SelectionActionKeys) {
    SelectionActionKeys["TOGGLE_SELECTION"] = "@@selection/TOGGLE_SELECTION";
    SelectionActionKeys["LOAD_SELECTION"] = "@@selection/LOAD_SELECTION";
    SelectionActionKeys["REMOVE_FROM_SELECTION"] = "@@selection/REMOVE_FROM_SELECTION";
    SelectionActionKeys["CLEAR_SELECTION"] = "@@selection/CLEAR_SELECTION";
})(SelectionActionKeys || (SelectionActionKeys = {}));
var loadPreviousSelection = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, resourcesSelection, notesSelection, prevSelection;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].getSelection(),
                    __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].getNotesSelection(),
                ])];
            case 1:
                _b = __read.apply(void 0, [_c.sent(), 2]), resourcesSelection = _b[0], notesSelection = _b[1];
                prevSelection = (_a = {},
                    _a[SelectionType.RESOURCES] = resourcesSelection,
                    _a[SelectionType.NOTES] = notesSelection,
                    _a);
                Object.entries(prevSelection).forEach(function (_a) {
                    var _b = __read(_a, 2), selectionType = _b[0], ids = _b[1];
                    if (ids) {
                        var action = {
                            type: SelectionActionKeys.LOAD_SELECTION,
                            selectionIds: ids,
                            sourceType: selectionType,
                        };
                        dispatch(action);
                    }
                });
                return [2 /*return*/];
        }
    });
}); }; };
var toggleSelection = function (itemId, sourceType) {
    if (sourceType === void 0) { sourceType = SelectionType.RESOURCES; }
    return function (dispatch, getState) {
        var _a = getState(), selection = _a.selection, routerParamsHistory = _a.routerParamsHistory;
        var ids = selection[sourceType];
        var isInSelection = ids.includes(itemId);
        var newSelection = __spread(ids);
        if (isInSelection) {
            newSelection.splice(newSelection.indexOf(itemId), 1);
            if (__WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].currentLocationIs(routerParamsHistory, __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Selection) &&
                sourceType === SelectionType.NOTES &&
                __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].isSharedNote(itemId)) {
                __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].removeNote(itemId);
            }
        }
        else {
            newSelection.push(itemId);
        }
        if (sourceType === SelectionType.RESOURCES) {
            __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setSelection(newSelection).then();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setNotesSelection(newSelection).then();
        }
        var action = {
            type: SelectionActionKeys.TOGGLE_SELECTION,
            selectionIds: newSelection,
            sourceType: sourceType,
        };
        dispatch(action);
    };
};
var removeFromSelection = function (idsToRemove, sourceType) {
    if (sourceType === void 0) { sourceType = SelectionType.RESOURCES; }
    return function (dispatch, getState) {
        var selection = getState().selection;
        var ids = selection[sourceType];
        var newSelection = ids.filter(function (id) { return !idsToRemove.includes(id); });
        if (sourceType === SelectionType.RESOURCES) {
            __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setSelection(newSelection).then();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setNotesSelection(newSelection).then();
        }
        var action = {
            type: SelectionActionKeys.REMOVE_FROM_SELECTION,
            selectionIds: newSelection,
            sourceType: sourceType,
        };
        dispatch(action);
    };
};
var clearSelection = function (selectionTypeToClear) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, selectionStorageHandlers, i, selectionType, action;
    var _this = this;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                selectionStorageHandlers = (_a = {},
                    _a[SelectionType.RESOURCES] = function (ids) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setSelection(ids)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); },
                    _a[SelectionType.NOTES] = function (ids) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setNotesSelection(ids)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); },
                    _a);
                i = 0;
                _b.label = 1;
            case 1:
                if (!(i < Object.values(SelectionType).length)) return [3 /*break*/, 5];
                selectionType = Object.values(SelectionType)[i];
                if (!(!selectionTypeToClear || selectionType === selectionTypeToClear)) return [3 /*break*/, 4];
                if (!(selectionType === SelectionType.NOTES)) return [3 /*break*/, 3];
                return [4 /*yield*/, dispatch(removeSharedNotes())];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                action = {
                    type: SelectionActionKeys.CLEAR_SELECTION,
                    sourceType: selectionType,
                };
                dispatch(action);
                selectionStorageHandlers[selectionType]([]);
                _b.label = 4;
            case 4:
                i++;
                return [3 /*break*/, 1];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var removeSharedNotes = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var notes, i, noteId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                notes = getState().selection.notes;
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < notes.length)) return [3 /*break*/, 4];
                noteId = notes[i];
                if (!__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].isSharedNote(noteId)) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].removeNote(noteId)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMenuButtonIconSrc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMenuButtonIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(1);


var isSvgIcon = function (iconSrc) { return iconSrc.includes('iconset'); };
var getMenuButtonIconSrc = function (icon, driveItems, config, thumbMap, resolutions) {
    if (icon === void 0) { icon = ''; }
    if (isSvgIcon(icon)) {
        return icon;
    }
    var imageSrc = '';
    var iconId = icon && __WEBPACK_IMPORTED_MODULE_1__index__["d" /* default */].getMediaId(icon);
    if (iconId && iconId > -1 && driveItems[iconId]) {
        imageSrc = __WEBPACK_IMPORTED_MODULE_1__index__["d" /* default */].getCustomIconUrl(config, thumbMap, driveItems[iconId], resolutions);
    }
    return imageSrc;
};
var getMenuButtonIcon = function (iconSrc, defaultIcon) {
    if (!iconSrc) {
        return defaultIcon
            ? __WEBPACK_IMPORTED_MODULE_1__index__["d" /* default */].getSvgIcon(defaultIcon)
            : null;
    }
    return isSvgIcon(iconSrc)
        ? __WEBPACK_IMPORTED_MODULE_1__index__["d" /* default */].getSvgIcon(iconSrc)
        : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: iconSrc });
};


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DRIVE_ITEM_LIST_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListDisplayType; });
var DRIVE_ITEM_LIST_PAGE_SIZE = 20;
var ListDisplayType;
(function (ListDisplayType) {
    ListDisplayType["Default"] = "Default";
    ListDisplayType["Grid"] = "Grid";
    ListDisplayType["Row"] = "Row";
    ListDisplayType["Masonry"] = "Masonry";
    ListDisplayType["Coverflow"] = "Coverflow";
})(ListDisplayType || (ListDisplayType = {}));



/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(849);

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pathHashbang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoutePath; });
var pathHashbang = '(!/)';
var RoutePath;
(function (RoutePath) {
    RoutePath["Default"] = "(!/)";
    RoutePath["Home"] = "(!/)home";
    RoutePath["ViewDriveItem"] = "(!/)view/:driveItemId(/:page)";
    RoutePath["Authentication"] = "(!/)authentication";
    RoutePath["ParametersPage"] = "(!/)parameters";
    RoutePath["ProfilePage"] = "(!/)profile";
    RoutePath["DriveItemListPage"] = "(!/)list/:origin(/:originParam)";
    RoutePath["TheaterList"] = "(!/)list/:origin(/:originParam)/theater/:driveItemId";
    RoutePath["Theater"] = "(!/)theater/:driveItemId";
    RoutePath["SharePage"] = "(!/)share/:driveItemId(/:page)";
    RoutePath["DriveItemDetailPage"] = "(!/)detail(/:folderId)/:driveItemId";
    RoutePath["NotFound"] = "*";
    RoutePath["StaticPage"] = "(!/)page/:component";
    RoutePath["Editor"] = "(!/)editor/:clientId/:resourceId";
    RoutePath["ProposalStatsPage"] = "(!/)proposal_stats";
    RoutePath["NotesPage"] = "(!/)notes";
})(RoutePath || (RoutePath = {}));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var callBind = __webpack_require__(170);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isEditablePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return isEditableSpread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editableItems__ = __webpack_require__(884);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__editableItems__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__textFieldsData__ = __webpack_require__(885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__textFieldsData__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__textFieldsData__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__textFieldsData__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__textFieldsData__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__textFieldsData__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spreadBackground__ = __webpack_require__(905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_4__spreadBackground__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__spreadBackground__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__spreadBackground__["b"]; });


var getEditorType = function (state) { return state.editor.type; };
var getEditableData = function (state) { return state.editor.configs.generalData.editablePublication; };
var getCurrentSpread = function (state) { return state.editor.pagesController.spreads[state.editor.pagesController.currentSpreadIndex]; };
var isAccessibleVersion = function (state) { return state.editor.isAccessibleVersion; };
var isEditablePage = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditorType, getEditableData, function (state, page) { return page; }, function (editorType, editableData, page) { return (editorType === __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* EditorType */].HTML || Object.keys(editableData).includes(page.toString())); });
var isEditableSpread = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableData, getCurrentSpread, getEditorType, isAccessibleVersion, function (editableData, currentSpread, editorType, isAccessibleVersion) { return (editorType === __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* EditorType */].HTML ||
    isAccessibleVersion ||
    currentSpread.some(function (page) { return Object.keys(editableData).includes(page.toString()); })); });





/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

var Portal = function (_a) {
    var children = _a.children, parentNode = _a.parentNode;
    return (__WEBPACK_IMPORTED_MODULE_0_react_dom__["createPortal"](children, parentNode));
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(483);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(703);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 66 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Server; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASP_SERVERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AuthMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MultiAppAuthenticationViewMode; });
var _a, _b;
var MultiAppAuthenticationViewMode;
(function (MultiAppAuthenticationViewMode) {
    MultiAppAuthenticationViewMode["Company"] = "company";
    MultiAppAuthenticationViewMode["Creation"] = "creation";
    MultiAppAuthenticationViewMode["Login"] = "login";
    MultiAppAuthenticationViewMode["Password"] = "password";
    MultiAppAuthenticationViewMode["Method"] = "method";
    MultiAppAuthenticationViewMode["OrgLogin"] = "orgLogin";
})(MultiAppAuthenticationViewMode || (MultiAppAuthenticationViewMode = {}));
var Server;
(function (Server) {
    Server["MIGRATIONV3"] = "MIGRATIONV3";
    Server["FR"] = "FR";
    Server["AU"] = "AU";
    Server["AR"] = "AR";
})(Server || (Server = {}));
var AuthMethod;
(function (AuthMethod) {
    AuthMethod["Webpublication"] = "MANAGER_USERS";
    AuthMethod["Saml"] = "SAML";
    AuthMethod["Salesforce"] = "SALESFORCE";
    AuthMethod["Excel"] = "EXCEL";
})(AuthMethod || (AuthMethod = {}));
var AUTH_METHODS = (_a = {},
    _a[AuthMethod.Webpublication] = {
        text: 'messages.webpublication'
    },
    _a[AuthMethod.Saml] = {
        text: 'messages.your_company_account'
    },
    _a[AuthMethod.Salesforce] = {
        text: 'messages.salesforce'
    },
    _a);
var ASP_SERVERS = (_b = {},
    _b[Server.MIGRATIONV3] = {
        name: 'Migration',
        url: 'https://migrationv3.zone-secure.net/',
        driveUrl: 'https://migrationv3.zone-secure.net/drive/',
        actions: {}
    },
    _b[Server.FR] = {
        name: 'France',
        url: 'https://fr.adminzone-secure.net/',
        driveUrl: 'https://app.uprez.fr/',
        actions: {}
    },
    _b[Server.AU] = {
        name: 'Australia',
        url: 'https://v3au.zone-secure.net/',
        driveUrl: 'https://v3au.zone-secure.net/drive/',
        actions: {}
    },
    _b[Server.AR] = {
        name: 'Argentina',
        url: 'https://ar-admin.zone-secure.net/',
        driveUrl: 'https://v3ar.zone-secure.net/',
        actions: {}
    },
    _b);



/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SourcesActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setResourcesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setParentFolderId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setPageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPageHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return parseIndesignEditorPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPublishPrice; });
/* unused harmony export setPublishPrice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__themes__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editableItems__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__preprodPublication__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__externalResources__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__spreadBackground__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_htmlEditor__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProfilePage_selectors__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DriveItemList_actions__ = __webpack_require__(12);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;






















var SourcesActionKeys;
(function (SourcesActionKeys) {
    SourcesActionKeys["SET_DATA"] = "@@editor/sources/SET_DATA";
    SourcesActionKeys["SET_RESOURCES_DATA"] = "@@editor/sources/SET_RESOURCES_DATA";
    SourcesActionKeys["SET_PARENT_FOLDER_ID"] = "@@editor/sources/SET_PARENT_FOLDER_ID";
    SourcesActionKeys["SET_PAGE_DATA"] = "@@editor/sources/SET_PAGE_DATA";
    SourcesActionKeys["ADD_PAGE"] = "@@editor/sources/ADD_PAGE";
    SourcesActionKeys["SET_PUBLISH_PRICE"] = "@@editor/sources/SET_PUBLISH_PRICE";
})(SourcesActionKeys || (SourcesActionKeys = {}));
var setData = function (editorType, data) { return ({
    type: SourcesActionKeys.SET_DATA,
    editorType: editorType,
    data: data,
}); };
var setResourcesData = function (data) { return ({
    type: SourcesActionKeys.SET_RESOURCES_DATA,
    data: data,
}); };
var setParentFolderId = function (id) { return ({
    type: SourcesActionKeys.SET_PARENT_FOLDER_ID,
    id: id,
}); };
var setPageData = function (data) { return ({
    type: SourcesActionKeys.SET_PAGE_DATA,
    data: data,
}); };
var addPage = function (page, width, height) { return ({
    type: SourcesActionKeys.ADD_PAGE,
    page: page,
    width: width,
    height: height,
}); };
var getData = function (clientId, resourceId, shouldLoadSpreadHtml, shouldUpdateVersion, shouldUpdatePreprodPublicationUrl, preprodPublicationData) {
    if (shouldLoadSpreadHtml === void 0) { shouldLoadSpreadHtml = true; }
    if (shouldUpdateVersion === void 0) { shouldUpdateVersion = true; }
    if (shouldUpdatePreprodPublicationUrl === void 0) { shouldUpdatePreprodPublicationUrl = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var resource, parentFolderId, isEditableComponent, editorType, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getResourceMeta */])(resourceId))];
                case 1:
                    resource = _a.sent();
                    parentFolderId = getState().editor.parentFolderId;
                    if (!parentFolderId) {
                        dispatch(setParentFolderId(__WEBPACK_IMPORTED_MODULE_20__utils_driveItem__["d" /* default */].getParentFolderId(resource)));
                    }
                    isEditableComponent = resource.type === __WEBPACK_IMPORTED_MODULE_17__typings_api__["a" /* Api */].DriveItemType.Component && resource.componentType === __WEBPACK_IMPORTED_MODULE_17__typings_api__["a" /* Api */].ComponentType.ZIP_EDITABLE;
                    editorType = isEditableComponent
                        ? __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML
                        : __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["j" /* setEditorType */])(editorType));
                    if (!(editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(getHtmlEditorData(clientId, resourceId))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(getIndesignEditorData(resource, clientId, resourceId, shouldLoadSpreadHtml, shouldUpdateVersion, shouldUpdatePreprodPublicationUrl, preprodPublicationData))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
};
var getHtmlEditorData = function (clientId, resourceId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var data, pagesData, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getHtmlEditorData(clientId, resourceId)];
            case 1:
                data = _a.sent();
                pagesData = [{
                        label: data.label,
                        position: 1,
                    }];
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                    return [2 /*return*/];
                }
                dispatch(setData(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML, data));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["n" /* setLabel */])(data.label));
                // is used for adding as hash to thumbnail urls to avoid browser cache
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["p" /* setVersion */])(Date.now()));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__thumbnails__["b" /* setThumbnails */])(pagesData));
                return [4 /*yield*/, dispatch(getPageHtml(1, resourceId, __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML))];
            case 2:
                _a.sent();
                if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["l" /* setIsEditorLoaded */])(true));
                }
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var getIndesignEditorData = function (resource, clientId, resourceId, shouldLoadSpreadHtml, shouldUpdateVersion, shouldUpdatePreprodPublicationUrl, preprodPublicationData) {
    if (shouldLoadSpreadHtml === void 0) { shouldLoadSpreadHtml = true; }
    if (shouldUpdateVersion === void 0) { shouldUpdateVersion = true; }
    if (shouldUpdatePreprodPublicationUrl === void 0) { shouldUpdatePreprodPublicationUrl = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var isEpubPreview, _a, driveItems, isAccessibleVersion, originalGId, driveItem, isAccountManagerOrAdmin, allowPreview, editorData, _b, aspDriveItem, enrichmentInfo, pagesData, tempGId, isPreprodPublication, format, totalPages, isPdfProposal, label, cssPath, themesCssPath, jsPath, configsPath, _c, spreads, currentSpreadIndex, pages, _d, tempGId_1, originalGId_1, isPublished, error_3;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 10, , 11]);
                    isEpubPreview = resource.format === __WEBPACK_IMPORTED_MODULE_17__typings_api__["a" /* Api */].PublicationFormat.EPUB_PREVIEW;
                    _a = getState(), driveItems = _a.driveList.driveItems, isAccessibleVersion = _a.editor.isAccessibleVersion;
                    originalGId = __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["g" /* getClientAndResourceIds */]().originalGId;
                    driveItem = isEpubPreview ? driveItems[originalGId] : resource;
                    isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_15__ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(getState());
                    if (!__WEBPACK_IMPORTED_MODULE_20__utils_driveItem__["d" /* default */].isEditable(driveItem, isAccountManagerOrAdmin)) {
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_19__utils_routes__["a" /* default */].redirectToParentDir(__WEBPACK_IMPORTED_MODULE_20__utils_driveItem__["d" /* default */].getParentFolderId(resource))];
                    }
                    allowPreview = !isAccessibleVersion;
                    _b = preprodPublicationData;
                    if (_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getIndesignEditorData(clientId, resourceId, allowPreview)];
                case 1:
                    _b = (_e.sent());
                    _e.label = 2;
                case 2:
                    editorData = _b;
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__DriveItemList_actions__["k" /* getAspDriveItem */])(originalGId))];
                case 3:
                    aspDriveItem = _e.sent();
                    enrichmentInfo = editorData.enrichmentInfo, pagesData = editorData.pagesData;
                    enrichmentInfo.invoiceStatus = aspDriveItem && aspDriveItem.invoiceStatus;
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                        return [2 /*return*/];
                    }
                    tempGId = enrichmentInfo.globalId;
                    isPreprodPublication = tempGId !== resourceId;
                    if (isPreprodPublication) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__preprodPublication__["e" /* setPreprodPublicationData */])({
                            tempGId: tempGId,
                            lastUpdateDate: driveItem.lastUpdateDate,
                        }));
                        dispatch(getData(clientId, tempGId, shouldLoadSpreadHtml, shouldUpdateVersion, shouldUpdatePreprodPublicationUrl, editorData));
                        return [2 /*return*/];
                    }
                    format = enrichmentInfo.format, totalPages = enrichmentInfo.totalPages;
                    isPdfProposal = format === __WEBPACK_IMPORTED_MODULE_17__typings_api__["a" /* Api */].PublicationFormat.PDF_EDITABLE;
                    if (isPdfProposal) {
                        enrichmentInfo.nonEpubPages = Array.from({ length: totalPages }, function (v, i) { return i + 1; });
                    }
                    dispatch(setData(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN, enrichmentInfo));
                    label = driveItems[originalGId].label;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["n" /* setLabel */])(label));
                    if (shouldUpdateVersion) {
                        // is used for adding as hash to thumbnail urls to avoid browser cache
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["p" /* setVersion */])(Date.now()));
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__thumbnails__["b" /* setThumbnails */])(pagesData.map(function (_a) {
                        var label = _a.label, position = _a.position, extPage = _a.extPage;
                        return ({ label: label, position: position, extPage: extPage });
                    })));
                    if (isPdfProposal && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__pagesController__["d" /* setPageSpreads */])(pagesData.map(function (page) { return ({ showAlone: false }); }), enrichmentInfo.dimensions));
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["l" /* setIsEditorLoaded */])(true));
                    }
                    if (!!isPdfProposal) return [3 /*break*/, 6];
                    cssPath = enrichmentInfo.cssPath, themesCssPath = enrichmentInfo.themesCssPath, jsPath = enrichmentInfo.jsPath, configsPath = enrichmentInfo.configsPath;
                    return [4 /*yield*/, dispatch(getResourcesData(resourceId, [
                            cssPath,
                            themesCssPath,
                            jsPath,
                            configsPath,
                        ]))];
                case 4:
                    _e.sent();
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["l" /* setIsEditorLoaded */])(true));
                    }
                    if (!shouldLoadSpreadHtml) return [3 /*break*/, 6];
                    _c = getState().editor.pagesController, spreads = _c.spreads, currentSpreadIndex = _c.currentSpreadIndex;
                    pages = spreads[currentSpreadIndex];
                    return [4 /*yield*/, Promise.all(pages.map(function (page) { return dispatch(getPageHtml(page, resourceId)); }))];
                case 5:
                    _e.sent();
                    _e.label = 6;
                case 6:
                    if (!!__WEBPACK_IMPORTED_MODULE_20__utils_driveItem__["d" /* default */].isProposal(format)) return [3 /*break*/, 9];
                    _d = __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["g" /* getClientAndResourceIds */](), tempGId_1 = _d.tempGId, originalGId_1 = _d.originalGId;
                    isPublished = tempGId_1 !== originalGId_1;
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__preprodPublication__["b" /* getPreprodPublicationUrl */])(clientId, tempGId_1, label, shouldUpdatePreprodPublicationUrl))];
                case 7:
                    _e.sent();
                    if (!isPublished) return [3 /*break*/, 9];
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__preprodPublication__["c" /* getPublishedPublicationUrl */])(originalGId_1))];
                case 8:
                    _e.sent();
                    _e.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10:
                    error_3 = _e.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
};
var getResourcesData = function (resourceId, paths) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, isAccessibleVersion, accessibleUrl, resourceStyle, promises, _b, css, themesCss, scripts, configs, resourceCss, config, parsedConfigs, _c, themes, selectedThemeId, error_4;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 4, , 5]);
                _a = getState().editor, isAccessibleVersion = _a.isAccessibleVersion, accessibleUrl = _a.paths.accessibleUrl;
                resourceStyle = '';
                if (!accessibleUrl) return [3 /*break*/, 2];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getResourceStyle(accessibleUrl)];
            case 1:
                resourceStyle = _d.sent();
                _d.label = 2;
            case 2:
                promises = paths.map(function (path) { return (path ? __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getEditorResource(resourceId, path) : Promise.resolve('')); });
                return [4 /*yield*/, Promise.all(promises)];
            case 3:
                _b = __read.apply(void 0, [_d.sent(), 4]), css = _b[0], themesCss = _b[1], scripts = _b[2], configs = _b[3];
                resourceCss = isAccessibleVersion ? resourceStyle : css;
                config = getState().galleryInfos.config;
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                    return [2 /*return*/];
                }
                dispatch(setResourcesData({
                    css: __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__["a" /* default */].getParsedCss(config, resourceCss, resourceId),
                    themesCss: themesCss,
                    scripts: scripts && __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__["a" /* default */].getModifiedScripts(scripts),
                }));
                parsedConfigs = JSON.parse(configs);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__configs__["c" /* setConfigsData */])(parsedConfigs));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__pagesController__["d" /* setPageSpreads */])(parsedConfigs.pagesData));
                if (themesCss) {
                    _c = __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__["a" /* default */].getThemesAndSelectedThemeId(themesCss), themes = _c.themes, selectedThemeId = _c.selectedThemeId;
                    if (themes && selectedThemeId) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__themes__["g" /* setThemes */])(themes));
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__themes__["f" /* selectTheme */])(selectedThemeId, false));
                    }
                }
                return [3 /*break*/, 5];
            case 4:
                error_4 = _d.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var getPageHtml = function (page, resourceId, editorType) {
    if (editorType === void 0) { editorType = __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, pagePath, accessiblePagePath, previewPages, isAccessibleVersion, isPreviewPage, path, modifiedPagePath, pageHtml, pagesData, cssRelUrl, externalId, error_5;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = getState().editor, _b = _a.paths, pagePath = _b.pagePath, accessiblePagePath = _b.accessiblePagePath, previewPages = _a.previewPages, isAccessibleVersion = _a.isAccessibleVersion;
                    isPreviewPage = previewPages.includes(page);
                    if (isPreviewPage) {
                        return [2 /*return*/];
                    }
                    path = !!accessiblePagePath && isAccessibleVersion ? accessiblePagePath : pagePath;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, , 8]);
                    modifiedPagePath = editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML
                        ? pagePath
                        : __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["w" /* getPageHtmlPath */](path, page);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getEditorResource(resourceId, modifiedPagePath)];
                case 2:
                    pageHtml = _c.sent();
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                        return [2 /*return*/];
                    }
                    if (!(editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML)) return [3 /*break*/, 3];
                    dispatch(parseHtmlEditorPage(page, pageHtml));
                    return [3 /*break*/, 6];
                case 3:
                    pagesData = getState().editor.configs.pagesData;
                    cssRelUrl = pagesData[page - 1].cssRelUrl;
                    externalId = cssRelUrl ? __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["u" /* getNumberFromString */](cssRelUrl) : undefined;
                    if (!externalId) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(getExternalPageResources(page, externalId))];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    dispatch(parseIndesignEditorPage(page, pageHtml, resourceId, externalId));
                    _c.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_5 = _c.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
};
var parseHtmlEditorPage = function (page, pageHtml) { return function (dispatch, getState) {
    var isEditable = __WEBPACK_IMPORTED_MODULE_11__selectors__["x" /* isEditablePage */](getState(), page);
    var isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_15__ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(getState());
    var _a = __WEBPACK_IMPORTED_MODULE_13__utils_htmlEditor__["a" /* default */].getModifiedPageData(page, pageHtml, isEditable, isAccountManagerOrAdmin), html = _a.html, defaultHtml = _a.defaultHtml, fontsPath = _a.fontsPath, googleFontsPath = _a.googleFontsPath, editableTextFields = _a.editableTextFields, editableMedia = _a.editableMedia, editableLinks = _a.editableLinks, isError = _a.isError;
    if (isError) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.parse_editor_data_error'));
    }
    if (isEditable && !__WEBPACK_IMPORTED_MODULE_13__utils_htmlEditor__["a" /* default */].isModifiedFromBackoffice(pageHtml)) {
        try {
            // we need to save html with set ids even user hasn't modified anything
            // otherwise next time user goes to this page, new ids will be set and
            // it will break editor
            var _b = __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _b.clientId, resourceId = _b.tempGId;
            __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].saveHtmlEditorPage(clientId, resourceId, defaultHtml);
        }
        catch (error) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.parse_editor_data_error'));
        }
    }
    dispatch(setPageData({
        page: page,
        defaultHtml: defaultHtml,
        html: html,
        fontsPath: fontsPath,
        googleFontsPath: googleFontsPath,
    }));
    if (isEditable) {
        if (editableTextFields.items.length > 0) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__configs__["d" /* setEditableTextFieldsData */])(page, editableTextFields.editableData));
        }
        var editableItemsData = {
            editableTextFields: editableTextFields.items,
            editableMedia: editableMedia,
            editableLinks: editableLinks,
        };
        var hasSomeEditableItems = Object.values(editableItemsData).some(function (data) { return data && data.length > 0; });
        if (hasSomeEditableItems) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__editableItems__["c" /* setEditableItemsData */])(page, editableItemsData));
        }
    }
}; };
var parseIndesignEditorPage = function (page, pageHtml, resourceId, externalId) { return function (dispatch, getState) {
    var _a = getState(), _b = _a.editor, css = _b.resources.css, _c = _b.configs, _d = page, _e = _c.generalData.editablePublication[_d], _f = (_e === void 0 ? {} : _e).modifiedFromBackoffice, modifiedFromBackoffice = _f === void 0 ? false : _f, pagesData = _c.pagesData, _g = _b.pagesController, totalPages = _g.totalPages, spreads = _g.spreads, currentSpreadIndex = _g.currentSpreadIndex, isAccessibleVersion = _b.isAccessibleVersion, config = _a.galleryInfos.config;
    var _h = pagesData[page - 1], pageHeightFromConfig = _h.height, cssRelUrl = _h.cssRelUrl, themesCssRelUrl = _h.themesCssRelUrl;
    var isEditable = __WEBPACK_IMPORTED_MODULE_11__selectors__["x" /* isEditablePage */](getState(), page) || isAccessibleVersion;
    var isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_15__ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(getState());
    var pageIndexInSpread = !isAccessibleVersion ? spreads[currentSpreadIndex].findIndex(function (spreadPage) { return spreadPage === page; }) : -1;
    var _j = __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__["a" /* default */].getModifiedPageData(page, pageIndexInSpread, pageHtml, css, config, resourceId, isEditable, modifiedFromBackoffice, isAccountManagerOrAdmin, totalPages, spreads, pageHeightFromConfig, cssRelUrl, themesCssRelUrl, isAccessibleVersion), html = _j.html, width = _j.width, height = _j.height, editableTextFields = _j.editableTextFields, editableMedia = _j.editableMedia, editableLinks = _j.editableLinks, editableButtons = _j.editableButtons, editableIframes = _j.editableIframes, editableEnrichments = _j.editableEnrichments, editableSliders = _j.editableSliders, themedItems = _j.themedItems, duplicatedItemsInSpread = _j.duplicatedItemsInSpread, isError = _j.isError, backgroundDeps = _j.backgroundDeps;
    if (isError) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.parse_editor_data_error'));
    }
    dispatch(setPageData({
        page: page,
        defaultHtml: pageHtml,
        html: html,
        width: width,
        height: height,
        externalId: externalId,
    }));
    if (isEditable) {
        var hasEditableTextFieldsData = editableTextFields.editableData && Object.values(editableTextFields.editableData).some(function (set) { return set.size > 0; });
        if (!modifiedFromBackoffice && hasEditableTextFieldsData) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__configs__["d" /* setEditableTextFieldsData */])(page, editableTextFields.editableData));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__configs__["b" /* saveConfigs */])());
        }
        var editableItemsData = {
            editableTextFields: editableTextFields.items,
            editableMedia: editableMedia,
            editableLinks: editableLinks,
            editableButtons: editableButtons,
            editableIframes: editableIframes,
            editableEnrichments: editableEnrichments,
            editableSliders: editableSliders,
            themedItems: themedItems,
            duplicatedItemsInSpread: duplicatedItemsInSpread,
        };
        var hasSomeEditableItems = Object.values(editableItemsData).some(function (data) { return data && data.length > 0; });
        if (hasSomeEditableItems) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__editableItems__["c" /* setEditableItemsData */])(page, editableItemsData));
            // e.g., to convert inDesign gotoPage links (change target from page to spread number)
            var isLinkCorrectionNeeded = __spread(editableLinks, editableButtons).some(function (_a) {
                var shouldCorrect = _a.shouldCorrect;
                return shouldCorrect;
            });
            if (isLinkCorrectionNeeded) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__pagesController__["c" /* savePage */])(page));
            }
        }
        if (backgroundDeps) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__spreadBackground__["f" /* updateSpreadBackgroundServiceData */])(page, { deps: backgroundDeps }, false, false));
        }
    }
}; };
var getExternalPageResources = function (page, externalId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, pagesData, externalResources, config, isExternalResourcesLoaded, isExternalResourcesLoading, _c, cssRelUrl, jsRelUrl, themesCssRelUrl, promises, _d, css, scripts, themesCss, parsedCss, parsedScripts, error_6;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 4]);
                _a = getState(), _b = _a.editor, pagesData = _b.configs.pagesData, externalResources = _b.externalResources, config = _a.galleryInfos.config;
                isExternalResourcesLoaded = !!externalResources[externalId] && externalResources[externalId].css;
                isExternalResourcesLoading = !!externalResources[externalId] && externalResources[externalId].isLoading;
                if (!(!isExternalResourcesLoaded && !isExternalResourcesLoading)) return [3 /*break*/, 2];
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__externalResources__["b" /* getExternalResourcesData */])(externalId));
                _c = pagesData[page - 1], cssRelUrl = _c.cssRelUrl, jsRelUrl = _c.jsRelUrl, themesCssRelUrl = _c.themesCssRelUrl;
                promises = [cssRelUrl, jsRelUrl, themesCssRelUrl].map(function (path) { return (path
                    ? __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getEditorResource(undefined, path.replace(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["_2" /* mediaParamRegex */], ''))
                    : Promise.resolve('')); });
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                _d = __read.apply(void 0, [_e.sent(), 3]), css = _d[0], scripts = _d[1], themesCss = _d[2];
                parsedCss = __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__["a" /* default */].getParsedCss(config, css, externalId, cssRelUrl);
                parsedScripts = scripts && __WEBPACK_IMPORTED_MODULE_14__utils_indesignEditor__["a" /* default */].getModifiedScripts(scripts);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__externalResources__["d" /* setExternalResourcesData */])(externalId, {
                    css: parsedCss,
                    scripts: parsedScripts,
                    themesCss: themesCss,
                }));
                _e.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                error_6 = _e.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__externalResources__["c" /* resetExternalResourcesLoading */])(externalId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var getPublishPrice = function (globalId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var data, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_18__utils_api__["a" /* default */].getPublishPrice(globalId)];
            case 1:
                data = _a.sent();
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                    return [2 /*return*/];
                }
                dispatch(setPublishPrice(data));
                return [3 /*break*/, 3];
            case 2:
                error_7 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var setPublishPrice = function (data) { return ({
    type: SourcesActionKeys.SET_PUBLISH_PRICE,
    data: data,
}); };


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OBJECT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLOCK_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INLINE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STYLE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MARK_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MARK_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TEXT_ALIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TEXT_DECORATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TEXT_TRANSFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LIST_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TEXT_SCRIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK_AND_INLINE_TAGS; });
var OBJECT_TYPES;
(function (OBJECT_TYPES) {
    OBJECT_TYPES["block"] = "block";
    OBJECT_TYPES["inline"] = "inline";
    OBJECT_TYPES["text"] = "text";
    OBJECT_TYPES["mark"] = "mark";
})(OBJECT_TYPES || (OBJECT_TYPES = {}));
var BLOCK_TYPES;
(function (BLOCK_TYPES) {
    BLOCK_TYPES["p"] = "paragraph";
    BLOCK_TYPES["h1"] = "heading1";
    BLOCK_TYPES["h2"] = "heading2";
    BLOCK_TYPES["h3"] = "heading3";
    BLOCK_TYPES["h4"] = "heading4";
    BLOCK_TYPES["h5"] = "heading5";
    BLOCK_TYPES["h6"] = "heading6";
    BLOCK_TYPES["ul"] = "unordered_list";
    BLOCK_TYPES["ol"] = "ordered_list";
    BLOCK_TYPES["li"] = "list_item";
    BLOCK_TYPES["section"] = "section";
    BLOCK_TYPES["aside"] = "aside";
})(BLOCK_TYPES || (BLOCK_TYPES = {}));
var INLINE_TYPES;
(function (INLINE_TYPES) {
    INLINE_TYPES["a"] = "link";
})(INLINE_TYPES || (INLINE_TYPES = {}));
var STYLE_TYPES;
(function (STYLE_TYPES) {
    STYLE_TYPES["UNEDITABLE_STYLES"] = "uneditableStyles";
    STYLE_TYPES["FONT_SIZE"] = "font-size";
    STYLE_TYPES["FONT_FAMILY"] = "font-family";
    STYLE_TYPES["FONT_WEIGHT"] = "font-weight";
    STYLE_TYPES["FONT_STYLE"] = "font-style";
    STYLE_TYPES["COLOR"] = "color";
    STYLE_TYPES["TEXT_DECORATION"] = "text-decoration";
    STYLE_TYPES["TEXT_TRANSFORM"] = "text-transform";
    STYLE_TYPES["LETTER_SPACING"] = "letter-spacing";
    STYLE_TYPES["TEXT_SCRIPT"] = "textScript";
    STYLE_TYPES["EMPTY"] = "empty";
})(STYLE_TYPES || (STYLE_TYPES = {}));
// We have to keep order of marks for proper display of formatted text (for example, color of underline)
var MARK_TYPES = [
    STYLE_TYPES.UNEDITABLE_STYLES,
    STYLE_TYPES.FONT_SIZE,
    STYLE_TYPES.FONT_FAMILY,
    STYLE_TYPES.FONT_WEIGHT,
    STYLE_TYPES.FONT_STYLE,
    STYLE_TYPES.COLOR,
    STYLE_TYPES.TEXT_DECORATION,
    STYLE_TYPES.TEXT_TRANSFORM,
    STYLE_TYPES.LETTER_SPACING,
    STYLE_TYPES.TEXT_SCRIPT,
    STYLE_TYPES.EMPTY,
];
var MARK_TAGS;
(function (MARK_TAGS) {
    MARK_TAGS["span"] = "span";
})(MARK_TAGS || (MARK_TAGS = {}));
var TEXT_ALIGN;
(function (TEXT_ALIGN) {
    TEXT_ALIGN["LEFT"] = "left";
    TEXT_ALIGN["CENTER"] = "center";
    TEXT_ALIGN["RIGHT"] = "right";
    TEXT_ALIGN["JUSTIFY"] = "justify";
})(TEXT_ALIGN || (TEXT_ALIGN = {}));
var TEXT_DECORATION;
(function (TEXT_DECORATION) {
    TEXT_DECORATION["NONE"] = "none";
    TEXT_DECORATION["UNDERLINE"] = "underline";
    TEXT_DECORATION["LINE_THROUGH"] = "line-through";
})(TEXT_DECORATION || (TEXT_DECORATION = {}));
var TEXT_TRANSFORM;
(function (TEXT_TRANSFORM) {
    TEXT_TRANSFORM["NONE"] = "none";
    TEXT_TRANSFORM["CAPITALIZE"] = "capitalize";
    TEXT_TRANSFORM["LOWERCASE"] = "lowercase";
    TEXT_TRANSFORM["UPPERCASE"] = "uppercase";
})(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
var LIST_TYPE;
(function (LIST_TYPE) {
    LIST_TYPE["ORDERED"] = "ordered";
    LIST_TYPE["UNORDERED"] = "unordered";
    LIST_TYPE["NONE"] = "none";
})(LIST_TYPE || (LIST_TYPE = {}));
var TEXT_SCRIPT;
(function (TEXT_SCRIPT) {
    TEXT_SCRIPT["SUB"] = "sub";
    TEXT_SCRIPT["SUPER"] = "super";
})(TEXT_SCRIPT || (TEXT_SCRIPT = {}));
var BLOCK_AND_INLINE_TAGS = {
    p: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.p,
    },
    h1: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.h1,
    },
    h2: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.h2,
    },
    h3: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.h3,
    },
    h4: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.h4,
    },
    h5: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.h5,
    },
    h6: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.h6,
    },
    ul: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.ul,
    },
    ol: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.ol,
    },
    li: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.li,
    },
    a: {
        object: OBJECT_TYPES.inline,
        type: INLINE_TYPES.a,
    },
    section: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.section,
    },
    aside: {
        object: OBJECT_TYPES.block,
        type: BLOCK_TYPES.aside,
    },
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(1086);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__common__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks__ = __webpack_require__(1113);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__hooks__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__hooks__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__hooks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(1120);
/* unused harmony namespace reexport */




/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageType; });
var PageType;
(function (PageType) {
    PageType["StaticPage"] = "StaticPage";
    PageType["NotFoundPage"] = "NotFoundPage";
    PageType["ParametersPage"] = "ParametersPage";
    PageType["ProfilePage"] = "ProfilePage";
    PageType["ProposalStatsPage"] = "ProposalStatsPage";
    PageType["NotesPage"] = "NotesPage";
    PageType["DrivePage"] = "DrivePage";
})(PageType || (PageType = {}));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.isVideoChild = isVideoChild;
exports.mergeAndSortChildren = mergeAndSortChildren;
exports.deprecatedWarning = deprecatedWarning;
exports.throttle = throttle;
exports.mediaProperties = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(582));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(362));

var _react = _interopRequireDefault(__webpack_require__(0));

// NaN is the only value in javascript which is not equal to itself.
// eslint-disable-next-line no-self-compare
var isNaN = Number.isNaN || function (value) {
  return value !== value;
};
/**
 * @file format-time.js
 *
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @private
 * @function formatTime
 */


function formatTime() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600); // handle invalid times

  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = '-';
    m = '-';
    s = '-';
  } // Check if we need to show hours


  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.

  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds

  s = s < 10 ? "0".concat(s) : s;
  return h + m + s;
} // Check if the element belongs to a video element
// only accept <source />, <track />,
// <MyComponent isVideoChild />
// elements


function isVideoChild(c) {
  if (c.props && c.props.isVideoChild) {
    return true;
  }

  return c.type === 'source' || c.type === 'track';
}

var find = function find(elements, func) {
  return elements.filter(func)[0];
}; // check if two components are the same type


var isTypeEqual = function isTypeEqual(component1, component2) {
  var type1 = component1.type;
  var type2 = component2.type;

  if (typeof type1 === 'string' || typeof type2 === 'string') {
    return type1 === type2;
  }

  if (typeof type1 === 'function' && typeof type2 === 'function') {
    return type1.displayName === type2.displayName;
  }

  return false;
}; // merge default children
// sort them by `order` property
// filter them by `disabled` property


function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var children = _react["default"].Children.toArray(_children);

  var order = _parentProps.order,
      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent

  return children.filter(function (e) {
    return !e.props.disabled;
  }) // filter the disabled components
  .concat(defaultChildren.filter(function (c) {
    return !find(children, function (component) {
      return isTypeEqual(component, c);
    });
  })).map(function (element) {
    var defaultComponent = find(defaultChildren, function (c) {
      return isTypeEqual(c, element);
    });
    var defaultProps = defaultComponent ? defaultComponent.props : {};
    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);

    var e = _react["default"].cloneElement(element, props, element.props.children);

    return e;
  }).sort(function (a, b) {
    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
  });
}
/**
 * Temporary utility for generating the warnings
 */


function deprecatedWarning(oldMethodCall, newMethodCall) {
  // eslint-disable-next-line no-console
  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
}

function throttle(callback, limit) {
  var _arguments = arguments;
  var wait = false;
  return function () {
    if (!wait) {
      // eslint-disable-next-line prefer-rest-params
      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
exports.mediaProperties = mediaProperties;

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);



var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.editPanel, x = _b.x, y = _b.y, id = _a.activeItem.id, pdfImportingStatus = _a.settings.pdfImportingStatus;
    return {
        x: x,
        y: y,
        activeItemId: id,
        isDisabled: pdfImportingStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* PdfImportingStatus */].PROCESSING,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel__["b" /* default */]));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(157)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(107);
var IE8_DOM_DEFINE = __webpack_require__(379);
var toPrimitive = __webpack_require__(262);
var dP = Object.defineProperty;

exports.f = __webpack_require__(74) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(709);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = appInfos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var AppType;
(function (AppType) {
    AppType["Multiple"] = "multiple";
    AppType["Single"] = "Single";
})(AppType || (AppType = {}));
var initialState = {
    areCookieAccepted: !__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getCookie('areCookieAccepted')
};
function appInfos(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AppInfosActionKeys */].ACCEPT_COOKIE:
            return __assign({}, state, { areCookieAccepted: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AppInfosActionKeys */].SET_APP_TYPE:
            return __assign({}, state, { type: action.appType });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AppInfosActionKeys */].SET_USER_LOCALE:
            return __assign({}, state, { userLocale: action.locale });
        default:
            return state;
    }
}


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return driveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDriveItemStatusFromMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};





var FetchStatus;
(function (FetchStatus) {
    FetchStatus["NOT_FETCHED"] = "NOT_FETCHED";
    FetchStatus["FETCHING"] = "FETCHING";
    FetchStatus["FETCHED"] = "FETCHED";
    FetchStatus["ERROR"] = "ERROR";
})(FetchStatus || (FetchStatus = {}));
var initialState = {
    driveItemsFetchStatus: {},
    driveItems: {},
    resolutions: {},
    folderTreeUpdate: {
        lastDate: undefined,
        isUpdating: true,
    },
    fetchAllFetchStatus: FetchStatus.NOT_FETCHED,
    displayType: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ListDisplayType */].Default,
    foldersDisplayType: {},
    contextualMenu: {
        isOpened: false,
        isLocked: false,
    },
    breadcrumbs: [],
    isEditMode: false,
    isLoading: false,
    customTemplates: {
        ids: [],
        isLoaded: false,
    },
};
var driveItemFolderInitialState = {
    metaFetchStatus: FetchStatus.NOT_FETCHED,
    contentBlocksStatus: {}
};
function driveList(state, action) {
    if (state === void 0) { state = initialState; }
    if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].UPDATE_LIST_DISPLAY_TYPE) {
        return __assign({}, state, { displayType: action.displayType });
    }
    var newState = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(state);
    var driveListItem;
    var driveItemId;
    if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REQUEST_DRIVE_META
        || action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_DRIVE_META
        || action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].FETCH_ERROR_DRIVE_META) {
        driveItemId = action.driveItemId;
    }
    if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REQUEST_CONTENT_BLOCK
        || action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_CONTENT_BLOCK
        || action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].FETCH_ERROR_CONTENT_BLOCK) {
        driveItemId = action.driveFolderId;
    }
    if (driveItemId) {
        driveListItem = getDriveItemStatusFromMap(newState.driveItemsFetchStatus, driveItemId);
    }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REQUEST_DRIVE_META:
            driveListItem.metaFetchStatus = FetchStatus.FETCHING;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_DRIVE_META:
            driveListItem.metaFetchStatus = FetchStatus.FETCHED;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].FETCH_ERROR_DRIVE_META:
            driveListItem.metaFetchStatus = FetchStatus.ERROR;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REQUEST_CONTENT_BLOCK:
            driveListItem.contentBlocksStatus[action.block] = FetchStatus.FETCHING;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_CONTENT_BLOCK:
            driveListItem.contentBlocksStatus[action.block] = FetchStatus.FETCHED;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].FETCH_ERROR_CONTENT_BLOCK:
            driveListItem.contentBlocksStatus[action.block] = FetchStatus.ERROR;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_DRIVE_ITEMS:
            var driveItemsInfos = {};
            for (var driveItemId_1 in action.driveItems) {
                if (action.driveItems.hasOwnProperty(driveItemId_1)) {
                    var driveItemInfo = action.driveItems[driveItemId_1];
                    driveItemsInfos[driveItemId_1] = __assign({}, newState.driveItems[driveItemId_1], driveItemInfo);
                    // if isInGallery does not exist, use the default one sent
                    // (for example it exists in the save in localstorage)
                    if (driveItemsInfos[driveItemId_1].isInGallery === undefined) {
                        driveItemsInfos[driveItemId_1].isInGallery = action.isInGallery;
                    }
                }
            }
            newState.driveItems = mergeDriveItems(newState.driveItems, driveItemsInfos);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REMOVE_DRIVE_ITEMS:
            action.driveItemIds.forEach(function (driveItemId) { return delete newState.driveItems[driveItemId]; });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_RESOLUTIONS:
            newState.resolutions = mergeResolutions(newState.resolutions, action.resolutions);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RESET_FETCH_ALL_STATUS:
            newState.fetchAllFetchStatus = FetchStatus.NOT_FETCHED;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REQUEST_ALL:
            newState.fetchAllFetchStatus = FetchStatus.FETCHING;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RECEIVE_ALL:
            newState.fetchAllFetchStatus = FetchStatus.FETCHED;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].OPEN_CONTEXTUAL_MENU:
            newState.contextualMenu = {
                isOpened: true,
                isLocked: false,
                driveItemId: action.driveItemId,
            };
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].CLOSE_CONTEXTUAL_MENU:
            newState.contextualMenu = {
                isOpened: false,
                isLocked: false,
            };
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].LOCK_CONTEXTUAL_MENU:
            newState.contextualMenu = __assign({}, state.contextualMenu, { isLocked: true });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].UNLOCK_CONTEXTUAL_MENU:
            newState.contextualMenu = __assign({}, state.contextualMenu, { isLocked: false });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].SET_BREADCRUMBS:
            var itemIndex = newState.breadcrumbs.findIndex(function (_a) {
                var id = _a.id;
                return id === action.item.id;
            });
            newState.breadcrumbs = itemIndex === -1
                ? __spread(newState.breadcrumbs, [action.item]) : newState.breadcrumbs.slice(0, itemIndex + 1);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RESET_BREADCRUMBS:
            newState.breadcrumbs = [];
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].UPDATE_DRIVE_ITEM:
            newState.driveItems[action.item.id] = __assign({}, newState.driveItems[action.item.id], action.item);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].TOGGLE_EDIT_MODE:
            newState.isEditMode = !state.isEditMode;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].MOVE_DRIVE_ITEM: {
            var folderId = action.folderId, filteredResources = action.filteredResources, from_1 = action.from, to_1 = action.to, isAppRootFolder = action.isAppRootFolder, privateDirId_1 = action.privateDirId;
            var resourcesWithoutMovedItem_1 = [];
            var isMoveToTop_1 = to_1 - from_1 < 0;
            filteredResources.forEach(function (resource, index) {
                var isMovedItem = index === from_1;
                if (!isMovedItem) {
                    var shouldUpdatePosition = isMoveToTop_1
                        ? index >= to_1 && index <= from_1
                        : index >= from_1 && index <= to_1 - 1;
                    var positionShift = isMoveToTop_1 ? -1 : 1;
                    var updatedResource = shouldUpdatePosition
                        ? __assign({}, resource, { position: resource.position + positionShift }) : resource;
                    resourcesWithoutMovedItem_1.push(updatedResource);
                }
            });
            var movedItem = filteredResources[from_1];
            var newMovedItemIndex = isMoveToTop_1 ? to_1 : to_1 - 1;
            var newMovedItemPosition = filteredResources[newMovedItemIndex].position;
            resourcesWithoutMovedItem_1.splice(newMovedItemIndex, 0, __assign({}, movedItem, { position: newMovedItemPosition }));
            if (isAppRootFolder) {
                // privateDir must be kept in store
                var allResources = newState.driveItems[folderId].resources;
                var privateDir = allResources.find(function (_a) {
                    var id = _a.id;
                    return id === privateDirId_1;
                });
                if (privateDir) {
                    resourcesWithoutMovedItem_1.push(privateDir);
                }
            }
            newState.driveItems[folderId].resources = resourcesWithoutMovedItem_1;
            break;
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].MOVE_DRIVE_ITEM_IN_FOLDER: {
            var resources = newState.driveItems[action.folderId].resources;
            newState.driveItems[action.folderId].resources = resources.filter(function (_a) {
                var id = _a.id;
                return (id !== action.id);
            });
            break;
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RESET_DRIVE_ORDER:
            newState.driveItems[action.folderId].resources = action.resources;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].SET_LOADING_STATUS:
            newState.isLoading = action.isLoading;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].SET_FOLDER_DISPLAY_TYPE:
            newState.foldersDisplayType[action.folderId] = action.displayType;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].SET_FOLDERS_DISPLAY_TYPE:
            newState.foldersDisplayType = action.data;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].RESET_FOLDERS_DISPLAY_TYPE:
            newState.foldersDisplayType = {};
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].SET_CUSTOM_TEMPLATES_IDS:
            newState.customTemplates = {
                ids: action.ids,
                isLoaded: true,
            };
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].ADD_CUSTOM_TEMPLATE:
            newState.customTemplates = __assign({}, newState.customTemplates, { ids: __spread(newState.customTemplates.ids, [
                    action.id,
                ]) });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].REMOVE_CUSTOM_TEMPLATE:
            newState.customTemplates = __assign({}, newState.customTemplates, { ids: newState.customTemplates.ids.filter(function (id) { return id !== action.id; }) });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].SET_LAST_FOLDER_TREE_UPDATE:
            newState.folderTreeUpdate.lastDate = action.lastFolderTreeUpdate;
            newState.folderTreeUpdate.isUpdating = false;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].START_FOLDER_TREE_UPDATE:
            newState.folderTreeUpdate.isUpdating = true;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */].END_FOLDER_TREE_UPDATE:
            newState.folderTreeUpdate.isUpdating = false;
            break;
        default:
            return state;
    }
    if (driveItemId) {
        newState.driveItemsFetchStatus[driveItemId] = driveListItem;
    }
    if (__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].stringIsInStringEnum(action.type, __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* DriveItemListActionKeys */])) {
        if (__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isOnline() && __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp) {
            __WEBPACK_IMPORTED_MODULE_3__utils_indexedDB_manager__["a" /* default */].setStoreDriveList(newState).then();
        }
    }
    return newState;
}
// Function to merge maps of drive items that ensure no information is lost
function mergeDriveItems(map1, map2) {
    var resultMap = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(map1);
    Object.keys(map2).forEach(function (key) {
        var id = parseInt(key, 10);
        if (resultMap[id] && resultMap[id].resources && !map2[id].resources) {
            var resources = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(resultMap[id].resources);
            resultMap[id] = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(map2[id]);
            resultMap[id].resources = resources;
            return;
        }
        resultMap[id] = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(map2[id]);
    });
    return resultMap;
}
// Function to merge maps of resolutions that ensure no resolution is overriden
function mergeResolutions(map1, map2) {
    var resultMap = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(map1);
    Object.keys(map2).forEach(function (key) {
        if (resultMap[key]) {
            var itemFromMap2 = map2[key];
            var itemFromResultMap = resultMap[key];
            if (itemFromMap2.sizes && itemFromResultMap.sizes
                && itemFromMap2.sizes.length > itemFromResultMap.sizes.length) {
                resultMap[key] = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(map2[key]);
            }
        }
        else {
            resultMap[key] = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(map2[key]);
        }
    });
    return resultMap;
}
function getDriveItemStatusFromMap(driveItemsFetchStatus, folderId) {
    return driveItemsFetchStatus[folderId] ? driveItemsFetchStatus[folderId] : __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(driveItemFolderInitialState);
}



/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrandThumbConfigLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ThumbType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LogoType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OfflineManagerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DownloadStatus; });
/* harmony export (immutable) */ __webpack_exports__["f"] = offlineManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_indexedDB_manager__ = __webpack_require__(21);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var BrandThumbConfigLocation;
(function (BrandThumbConfigLocation) {
    BrandThumbConfigLocation["LOCAL_CONFIG"] = "localConfig";
    BrandThumbConfigLocation["REMOTE_CONFIG"] = "remoteConfig";
})(BrandThumbConfigLocation || (BrandThumbConfigLocation = {}));
var ThumbType;
(function (ThumbType) {
    ThumbType["BRAND_THUMB"] = "brandThumb";
    ThumbType["HOME_THUMB"] = "homeThumb";
})(ThumbType || (ThumbType = {}));
var LogoType;
(function (LogoType) {
    LogoType["BRAND_LOGO"] = "logo";
    LogoType["HOME_LOGO"] = "logoHome";
})(LogoType || (LogoType = {}));
var OfflineManagerStatus;
(function (OfflineManagerStatus) {
    OfflineManagerStatus["NOT_INITIALIZED"] = "NOT_INITIALIZED";
    OfflineManagerStatus["INITIALIZING"] = "INITIALIZING";
    OfflineManagerStatus["INITIALIZED"] = "INITIALIZED";
    OfflineManagerStatus["ERROR"] = "ERROR";
})(OfflineManagerStatus || (OfflineManagerStatus = {}));
var DownloadStatus;
(function (DownloadStatus) {
    DownloadStatus["NOT_DOWNLOADED"] = "NOT_DOWNLOADED";
    DownloadStatus["DOWNLOADING"] = "DOWNLOADING";
    DownloadStatus["DOWNLOADED"] = "DOWNLOADED";
    DownloadStatus["ERROR"] = "ERROR";
})(DownloadStatus || (DownloadStatus = {}));
var initialState = {
    status: OfflineManagerStatus.NOT_INITIALIZED,
    thumbMap: {},
    requiredItems: {},
    bgMediaMap: {},
    brandThumb: {
        localConfig: { status: DownloadStatus.NOT_DOWNLOADED },
        remoteConfig: { status: DownloadStatus.NOT_DOWNLOADED }
    },
    homeThumb: {
        localConfig: { status: DownloadStatus.NOT_DOWNLOADED },
        remoteConfig: { status: DownloadStatus.NOT_DOWNLOADED }
    },
    defaultFolderIcon: {
        status: DownloadStatus.NOT_DOWNLOADED,
    },
    isDownloadingThumbs: false,
    isDownloadingRequiredItems: false,
    isPreparingContentStructure: false,
    contentStructureReady: false,
    contentStructureEverCompleted: false,
    isContentStructureToastClosed: false
};
var initialItemState = {
    status: DownloadStatus.NOT_DOWNLOADED,
    version: -1
};
function offlineManager(state, action) {
    if (state === void 0) { state = initialState; }
    var newState = __WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* default */].deepCopy(state);
    var newItem;
    var newOfflineManager;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_THUMB_MAP:
            newOfflineManager = __assign({}, state, { thumbMap: action.thumbMap });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_REQUIRED_ITEMS:
            newOfflineManager = __assign({}, state, { requiredItems: action.requiredItems });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_BG_MEDIA_MAP:
            newOfflineManager = __assign({}, state, { bgMediaMap: action.bgMediaMap });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_LAST_UPDATE_TIMESTAMP:
            newOfflineManager = __assign({}, state, { lastUpdateTimestamp: action.lastUpdateTimestamp });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].START_INITIALIZATION:
            newOfflineManager = __assign({}, state, { status: OfflineManagerStatus.INITIALIZING });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].END_INITIALIZATION:
            newOfflineManager = __assign({}, state, { status: OfflineManagerStatus.INITIALIZED, lastUpdateTimestamp: new Date() });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INITIALIZATION_ERROR:
            newOfflineManager = __assign({}, state, { status: OfflineManagerStatus.ERROR });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_THUMB_STATUS:
            newItem = getItemFromMap(newState.thumbMap, action.driveItemId);
            newItem.status = action.status;
            newItem.version = action.version;
            newItem.fileName = action.fileName;
            newState.thumbMap[action.driveItemId] = newItem;
            newOfflineManager = newState;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_REQUIRED_ITEM_STATUS:
            newItem = getItemFromMap(newState.requiredItems, action.id);
            newItem.status = action.status;
            newItem.version = action.version;
            newItem.url = action.url;
            newItem.isIcon = action.isIcon;
            newState.requiredItems[action.id] = newItem;
            newOfflineManager = newState;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_FOLDER_BG_MEDIA_STATUS:
            newItem = getItemFromMap(newState.bgMediaMap, action.driveItemId);
            newItem.status = action.status;
            newItem.version = action.version;
            newState.bgMediaMap[action.driveItemId] = newItem;
            newOfflineManager = newState;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].REMOVE_REQUIRED_ITEM:
            delete newState.requiredItems[action.id];
            newOfflineManager = newState;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].REMOVE_THUMB:
            delete newState.thumbMap[action.id];
            newOfflineManager = newState;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].REMOVE_FOLDER_BG_MEDIA:
            delete newState.bgMediaMap[action.id];
            newOfflineManager = newState;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_DOWNLOAD_REQUIRED_ITEM_STATUS:
            newOfflineManager = __assign({}, state, { isDownloadingRequiredItems: action.isDownloading });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_DOWNLOAD_THUMBS_STATUS:
            newOfflineManager = __assign({}, state, { isDownloadingThumbs: action.isDownloading });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_BRAND_THUMB:
            return __assign({}, state, { brandThumb: action.brandThumb });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_HOME_THUMB:
            return __assign({}, state, { homeThumb: action.homeThumb });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].INIT_DEFAULT_FOLDER_ICON:
            return __assign({}, state, { defaultFolderIcon: action.defaultFolderIcon });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_BRAND_THUMB:
            newState[action.thumbType][action.configLocation] = {
                status: action.status,
                filename: action.filename
            };
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].UPDATE_DEFAULT_FOLDER_ICON:
            newState.defaultFolderIcon = {
                status: action.status,
                name: action.name,
            };
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].START_CONTENT_STRUCTURE_PREPARATION:
            newOfflineManager = __assign({}, state, { isPreparingContentStructure: true, isContentStructureToastClosed: false });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].END_CONTENT_STRUCTURE_PREPARATION:
            newOfflineManager = __assign({}, state, { isPreparingContentStructure: false, contentStructureReady: true });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].CLEAR_CONTENT_STRUCTURE_READY:
            newOfflineManager = __assign({}, state, { contentStructureReady: false });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].MARK_CONTENT_STRUCTURE_COMPLETED:
            newOfflineManager = __assign({}, state, { contentStructureEverCompleted: true });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */].CLOSE_CONTENT_STRUCTURE_TOAST:
            newOfflineManager = __assign({}, state, { isContentStructureToastClosed: true });
            break;
        case __WEBPACK_IMPORTED_MODULE_1__MultiAppAuthentication_actions__["a" /* MultiAppAuthenticationInfosActionKeys */].LOGOUT:
            newOfflineManager = __assign({}, state, { status: OfflineManagerStatus.NOT_INITIALIZED, isPreparingContentStructure: false, isContentStructureToastClosed: false });
            break;
        default:
            newOfflineManager = state;
            break;
    }
    if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* default */].stringIsInStringEnum(action.type, __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* OfflineManagerActionKeys */])) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline() && __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp) {
            __WEBPACK_IMPORTED_MODULE_4__utils_indexedDB_manager__["a" /* default */].setStoreOfflineManager(newOfflineManager).then();
        }
    }
    return newOfflineManager;
}
function getItemFromMap(items, itemId) {
    return items[itemId] ? items[itemId] : __WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* default */].deepCopy(initialItemState);
}


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OfflineManagerActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadOfflineManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initializeOfflineManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearUpdateTreeInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return downloadThumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return downloadBrandThumbIfNeeded; });
/* unused harmony export updateBrandThumbStatus */
/* unused harmony export updateThumbStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendInitializationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeThumb; });
/* unused harmony export startContentStructurePreparation */
/* unused harmony export endContentStructurePreparation */
/* unused harmony export clearContentStructureReady */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeContentStructureToast; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DriveItemList_New_actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DownloadManager_actions_download__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store__ = __webpack_require__(51);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;





















var Q = __webpack_require__(165);
var OfflineManagerActionKeys;
(function (OfflineManagerActionKeys) {
    OfflineManagerActionKeys["INIT_THUMB_MAP"] = "@@offlineManager/INIT_THUMB_MAP";
    OfflineManagerActionKeys["INIT_REQUIRED_ITEMS"] = "@@offlineManager/INIT_REQUIRED_ITEMS";
    OfflineManagerActionKeys["INIT_LAST_UPDATE_TIMESTAMP"] = "@@offlineManager/INIT_LAST_UPDATE_TIMESTAMP";
    OfflineManagerActionKeys["INIT_BRAND_THUMB"] = "@@offlineManager/INIT_BRAND_THUMB";
    OfflineManagerActionKeys["INIT_HOME_THUMB"] = "@@offlineManager/INIT_HOME_THUMB";
    OfflineManagerActionKeys["INIT_BG_MEDIA_MAP"] = "@@offlineManager/INIT_BG_MEDIA_MAP";
    OfflineManagerActionKeys["INIT_DEFAULT_FOLDER_ICON"] = "@@offlineManager/INIT_DEFAULT_FOLDER_ICON";
    OfflineManagerActionKeys["START_INITIALIZATION"] = "@@offlineManager/START_INITIALIZATION";
    OfflineManagerActionKeys["END_INITIALIZATION"] = "@@offlineManager/END_INITIALIZATION";
    OfflineManagerActionKeys["INITIALIZATION_ERROR"] = "@@offlineManager/INITIALIZATION_ERROR";
    OfflineManagerActionKeys["UPDATE_THUMB_STATUS"] = "@@offlineManager/UPDATE_THUMB_STATUS";
    OfflineManagerActionKeys["UPDATE_REQUIRED_ITEM_STATUS"] = "@@offlineManager/UPDATE_REQUIRED_ITEM_STATUS";
    OfflineManagerActionKeys["UPDATE_BRAND_THUMB"] = "@@offlineManager/UPDATE_BRAND_THUMB";
    OfflineManagerActionKeys["UPDATE_FOLDER_BG_MEDIA_STATUS"] = "@@offlineManager/UPDATE_FOLDER_BG_MEDIA_STATUS";
    OfflineManagerActionKeys["UPDATE_DEFAULT_FOLDER_ICON"] = "@@offlineManager/UPDATE_DEFAULT_FOLDER_ICON";
    OfflineManagerActionKeys["REMOVE_REQUIRED_ITEM"] = "@@offlineManager/REMOVE_REQUIRED_ITEM";
    OfflineManagerActionKeys["REMOVE_FOLDER_BG_MEDIA"] = "@@offlineManager/REMOVE_FOLDER_BG_MEDIA";
    OfflineManagerActionKeys["REMOVE_THUMB"] = "@@offlineManager/REMOVE_THUMB";
    OfflineManagerActionKeys["UPDATE_DOWNLOAD_THUMBS_STATUS"] = "@@offlineManager//UPDATE_DOWNLOAD_THUMBS_STATUS";
    OfflineManagerActionKeys["UPDATE_DOWNLOAD_REQUIRED_ITEM_STATUS"] = "@@offlineManager//UPDATE_DOWNLOAD_REQUIRED_ITEM_STATUS";
    OfflineManagerActionKeys["START_CONTENT_STRUCTURE_PREPARATION"] = "@@offlineManager/START_CONTENT_STRUCTURE_PREPARATION";
    OfflineManagerActionKeys["END_CONTENT_STRUCTURE_PREPARATION"] = "@@offlineManager/END_CONTENT_STRUCTURE_PREPARATION";
    OfflineManagerActionKeys["CLEAR_CONTENT_STRUCTURE_READY"] = "@@offlineManager/CLEAR_CONTENT_STRUCTURE_READY";
    OfflineManagerActionKeys["MARK_CONTENT_STRUCTURE_COMPLETED"] = "@@offlineManager/MARK_CONTENT_STRUCTURE_COMPLETED";
    OfflineManagerActionKeys["CLOSE_CONTENT_STRUCTURE_TOAST"] = "@@offlineManager/CLOSE_CONTENT_STRUCTURE_TOAST";
})(OfflineManagerActionKeys || (OfflineManagerActionKeys = {}));
var loadOfflineManager = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var previousOfflineManagerState, previousThumbMap_1, previousRequiredItems_1, previousBgMediaMap_1, newThumbMap_1, newRequiredItems_1, newBgMediaMap_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_16__utils_indexedDB_manager__["a" /* default */].getStoreOfflineManager()];
            case 1:
                previousOfflineManagerState = _a.sent();
                if (previousOfflineManagerState) {
                    previousThumbMap_1 = previousOfflineManagerState.thumbMap || {};
                    previousRequiredItems_1 = previousOfflineManagerState.requiredItems || {};
                    previousBgMediaMap_1 = previousOfflineManagerState.bgMediaMap || {};
                    newThumbMap_1 = {};
                    newRequiredItems_1 = {};
                    newBgMediaMap_1 = {};
                    Object.keys(previousThumbMap_1).forEach(function (key) {
                        var driveItemId = parseInt(key, 10);
                        var previousThumbStatus = previousThumbMap_1[driveItemId];
                        if (previousThumbStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                            newThumbMap_1[driveItemId] = previousThumbStatus;
                        }
                    });
                    Object.keys(previousRequiredItems_1).forEach(function (key) {
                        var driveItemId = parseInt(key, 10);
                        var previousRequiredItemStatus = previousRequiredItems_1[driveItemId];
                        if (previousRequiredItemStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                            newRequiredItems_1[driveItemId] = previousRequiredItemStatus;
                        }
                    });
                    Object.keys(previousBgMediaMap_1).forEach(function (key) {
                        var driveItemId = parseInt(key, 10);
                        var previousBgMediaStatus = previousBgMediaMap_1[driveItemId];
                        if (previousBgMediaStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                            newBgMediaMap_1[driveItemId] = previousBgMediaStatus;
                        }
                    });
                    dispatch({
                        type: OfflineManagerActionKeys.INIT_THUMB_MAP,
                        thumbMap: newThumbMap_1
                    });
                    dispatch({
                        type: OfflineManagerActionKeys.INIT_REQUIRED_ITEMS,
                        requiredItems: newRequiredItems_1
                    });
                    dispatch({
                        type: OfflineManagerActionKeys.INIT_BG_MEDIA_MAP,
                        bgMediaMap: newBgMediaMap_1
                    });
                    if (previousOfflineManagerState.lastUpdateTimestamp) {
                        dispatch({
                            type: OfflineManagerActionKeys.INIT_LAST_UPDATE_TIMESTAMP,
                            lastUpdateTimestamp: new Date(previousOfflineManagerState.lastUpdateTimestamp)
                        });
                    }
                    if (previousOfflineManagerState.brandThumb) {
                        dispatch({
                            type: OfflineManagerActionKeys.INIT_BRAND_THUMB,
                            brandThumb: previousOfflineManagerState.brandThumb,
                        });
                    }
                    if (previousOfflineManagerState.defaultFolderIcon) {
                        dispatch({
                            type: OfflineManagerActionKeys.INIT_DEFAULT_FOLDER_ICON,
                            defaultFolderIcon: previousOfflineManagerState.defaultFolderIcon,
                        });
                    }
                    // Load contentStructureEverCompleted flag from IndexedDB
                    if (previousOfflineManagerState.contentStructureEverCompleted) {
                        dispatch({
                            type: OfflineManagerActionKeys.MARK_CONTENT_STRUCTURE_COMPLETED,
                        });
                    }
                }
                return [2 /*return*/];
        }
    });
}); }; };
var updateFolderTreeInterval;
var connectionRestoredSubscription = null;
var initializeOfflineManager = function () { return function (dispatch, getState) {
    dispatch(startInitialization());
    var _a = getState(), galleryInfos = _a.galleryInfos, _b = _a.galleryInfos, template = _b.template, _c = _b.config, importantAssets = _c.importantAssets, applicationGallery = _c.applicationGallery;
    if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp) {
        // Subscribe to connection restored event to automatically retry if content structure was never completed
        // Only subscribe once, and only if content structure was never completed
        var contentStructureEverCompleted = getState().offlineManager.contentStructureEverCompleted;
        if (!contentStructureEverCompleted && !connectionRestoredSubscription) {
            connectionRestoredSubscription = function () {
                var currentState = __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].getState();
                var _a = currentState.offlineManager, currentCompleted = _a.contentStructureEverCompleted, status = _a.status;
                // Only retry if still not completed and not already initializing
                if (!currentCompleted && status !== __WEBPACK_IMPORTED_MODULE_6__reducer__["d" /* OfflineManagerStatus */].INITIALIZING && __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline()) {
                    __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].dispatch(initializeOfflineManager());
                }
            };
            __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].subscribeToConnectionIsUp(connectionRestoredSubscription, false);
        }
        if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline()) {
            var requiredItemsDatas_1 = getRequiredItemsDatas(template);
            var shouldDownloadImportantAssets_1 = importantAssets && importantAssets.enabled && importantAssets.isDownloadedOnLaunch;
            // Load cached driveList early so it's available when Continue is clicked during content structure update
            // This prevents errors when downloads are resumed before getAllDriveItems() completes
            __WEBPACK_IMPORTED_MODULE_16__utils_indexedDB_manager__["a" /* default */].getStoreDriveList()
                .then(function (cachedDriveListState) {
                if (cachedDriveListState && cachedDriveListState.driveItems) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["r" /* receiveDriveItems */])(cachedDriveListState.driveItems));
                }
            })
                .catch(function (error) {
                // If cache load fails, continue anyway - it's not critical
                console.warn('Failed to load cached driveList:', error);
            });
            // Start content structure preparation in the background
            // This allows the app to display content immediately while the directory tree is being built
            dispatch(startContentStructurePreparation());
            // First, ensure the root gallery item is loaded so components can access it safely
            // This prevents errors when components try to access driveItems[applicationGallery]
            // We start loading it immediately, and once it's loaded, content can safely display
            var rootGalleryPromise_1 = dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(applicationGallery, undefined, undefined, true))
                .then(function () {
                // Refresh session cookie early to ensure it persists even if app closes before initialization completes
                // This is important because getInitialDependenciesUpdates (which also calls checkActiveSession)
                // only runs after full initialization completes
                // We call it after root gallery loads to ensure config is loaded
                // We await it to ensure the cookie is set before continuing
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__MultiAppAuthentication_actions__["b" /* checkActiveSession */])(true))
                    .catch(function (error) {
                    console.warn('Session refresh failed:', error);
                });
            });
            // Continue building the rest of the directory tree in the background
            Promise.resolve(dispatch(loadDependenciesMetaFromIndexedDB()))
                .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["j" /* getAllDriveItems */])()); })
                .catch(function (error) {
                // Log the error for debugging but don't treat as fatal if app can still function
                console.error('Error loading dependencies or drive items:', error);
                // Show a dismissible error notification (10 seconds) instead of persistent one
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__NotificationBar_actions__["c" /* createNotification */])('error.initialization_fail', { id: galleryInfos.config.applicationGallery }, 10000));
                dispatch(endContentStructurePreparation());
                return dispatch(sendInitializationError());
            })
                .then(function () {
                // Content structure is now ready
                dispatch(endContentStructurePreparation());
                // Continue with the rest of initialization
                return rootGalleryPromise_1
                    .then(function () { return dispatch({
                    type: OfflineManagerActionKeys.UPDATE_DOWNLOAD_REQUIRED_ITEM_STATUS,
                    isDownloading: true
                }); })
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* downloadsFolder */]); })
                    .then(function (directoryExist) { return directoryExist ? {} : __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].createDirectory(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* downloadsFolder */]); })
                    .then(function () { return dispatch(downloadRequiredItems(requiredItemsDatas_1)); })
                    .then(function () {
                    dispatch({
                        type: OfflineManagerActionKeys.UPDATE_DOWNLOAD_REQUIRED_ITEM_STATUS,
                        isDownloading: false
                    });
                    dispatch({
                        type: OfflineManagerActionKeys.UPDATE_DOWNLOAD_THUMBS_STATUS,
                        isDownloading: true
                    });
                })
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* bgMediaFolder */]); })
                    .then(function (directoryExist) { return directoryExist ? {} : __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].createDirectory(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* bgMediaFolder */]); })
                    .then(function () { return dispatch(downloadAllBgMedia(galleryInfos.config.applicationGallery, 0, [])); })
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */]); })
                    .then(function (directoryExist) { return directoryExist ? {} : __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].createDirectory(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */]); })
                    .then(function () { return dispatch(downloadBrandThumbIfNeeded(__WEBPACK_IMPORTED_MODULE_6__reducer__["a" /* BrandThumbConfigLocation */].REMOTE_CONFIG, template, false)); })
                    .then(function () { return dispatch(downloadDefaultFolderIcon()); })
                    .then(function () { return dispatch(downloadThumbs()); })
                    .then(function () {
                    // Always set isDownloadingThumbs to false after thumbnails finish, even if cleanup fails
                    dispatch({
                        type: OfflineManagerActionKeys.UPDATE_DOWNLOAD_THUMBS_STATUS,
                        isDownloading: false
                    });
                    // Clear contentStructureReady after thumbnails finish (with a brief delay to show completion message)
                    setTimeout(function () {
                        dispatch({ type: OfflineManagerActionKeys.CLEAR_CONTENT_STRUCTURE_READY });
                    }, 3000);
                    // Continue with cleanup operations, but don't let failures block the widget from closing
                    return Promise.resolve();
                })
                    .then(function () {
                    return dispatch(deleteObsoleteItems(requiredItemsDatas_1))
                        .catch(function (error) {
                        return []; // Return empty array to continue chain
                    });
                })
                    .then(function () {
                    return dispatch(deleteObsoleteThumbsAndBgMedia())
                        .catch(function (error) {
                        return {}; // Return empty object to continue chain
                    });
                })
                    .then(function () { return dispatch(endInitialization()); })
                    .then(function () { return dispatch(setUpdateTreeInterval()); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__DownloadManager_actions_download__["e" /* getInitialDependenciesUpdates */])()); })
                    .then(function () { return shouldDownloadImportantAssets_1 && dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["f" /* downloadImportantAssets */])()); })
                    .then(function () { return dispatch(removeItemsMarkedForDeletion()); });
            })
                .catch(function (error) {
                // Log the error for debugging
                console.error('Error during initialization:', error);
                // Show a dismissible error notification (5 seconds) instead of persistent one
                // This allows the app to continue functioning even if some initialization steps fail
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__NotificationBar_actions__["c" /* createNotification */])('error.initialization_fail', { id: galleryInfos.config.applicationGallery }, 5000));
                dispatch(endContentStructurePreparation());
                dispatch(sendInitializationError());
            });
            // Return immediately to allow content to display while initialization continues in background
            // The root gallery item will be loaded first (started above), then once it's loaded, isGalleryReady will return true
            return {};
        }
        else {
            // Check if content structure was ever completed successfully
            var contentStructureEverCompleted_1 = getState().offlineManager.contentStructureEverCompleted;
            return __WEBPACK_IMPORTED_MODULE_16__utils_indexedDB_manager__["a" /* default */].getStoreDriveList()
                .then(function (cachedDriveListState) { return __awaiter(_this, void 0, void 0, function () {
                var driveItems, resolutions;
                return __generator(this, function (_a) {
                    if (cachedDriveListState) {
                        driveItems = cachedDriveListState.driveItems, resolutions = cachedDriveListState.resolutions;
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["r" /* receiveDriveItems */])(driveItems));
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["s" /* receiveResolutions */])(resolutions));
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__DriveItemList_New_actions__["d" /* updateNewItemsStoreOffline */])());
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["d" /* deletePendingDownloads */])());
                        return [2 /*return*/, dispatch(endInitialization())];
                    }
                    // If content structure was never completed, show appropriate message
                    // The DownloadGroupToast will display the message and retry button
                    if (!contentStructureEverCompleted_1) {
                        // Don't show the generic "offline_no_config" message
                        // Instead, let the DownloadGroupToast handle the messaging
                        return [2 /*return*/, dispatch(endInitialization())];
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__NotificationBar_actions__["c" /* createNotification */])('info.offline_no_config', { id: galleryInfos.config.applicationGallery }, -1));
                    return [2 /*return*/, dispatch(sendInitializationError())];
                });
            }); });
        }
    }
    return dispatch(endInitialization());
}; };
var setUpdateTreeInterval = function () { return function (dispatch, getState) {
    updateFolderTreeInterval = setInterval(function () { return dispatch(updateFolderTreeIfNeeded()); }, 20 * 60 * 1000);
}; };
var clearUpdateTreeInterval = function () { return clearInterval(updateFolderTreeInterval); };
var updateFolderTreeIfNeeded = function () { return function (dispatch, getState) {
    var MAX_HOURS_BETWEEN_UPDATES = 4;
    var isUpdateNeeded = function (lastUpdateDate, currentDate) {
        var isLastUpdateNotToday = lastUpdateDate.toDateString() !== currentDate.toDateString();
        if (isLastUpdateNotToday) {
            return true;
        }
        var hoursSinceLastUpdate = currentDate.getHours() - lastUpdateDate.getHours();
        return hoursSinceLastUpdate > MAX_HOURS_BETWEEN_UPDATES;
    };
    var lastDate = getState().driveList.folderTreeUpdate.lastDate;
    if (lastDate) {
        var lastUpdateDate = new Date(lastDate);
        var currentDate = new Date();
        if (isUpdateNeeded(lastUpdateDate, currentDate)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__MultiAppAuthentication_actions__["b" /* checkActiveSession */])())
                .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["J" /* updateFolderTree */])(false)); });
        }
    }
}; };
var loadDependenciesMetaFromIndexedDB = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var cachedDriveListState, downloadManager_1, dependencies_1, dependenciesMeta_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_16__utils_indexedDB_manager__["a" /* default */].getStoreDriveList()];
            case 1:
                cachedDriveListState = _a.sent();
                if (cachedDriveListState) {
                    downloadManager_1 = getState().downloadManager;
                    dependencies_1 = [];
                    Object.keys(downloadManager_1.items).forEach(function (id) {
                        var downloadItem = downloadManager_1.items[id];
                        dependencies_1 = __spread(dependencies_1, downloadItem.dependencies);
                    });
                    // Remove duplicate entries
                    dependencies_1 = dependencies_1.reduce(function (uniqueDependencies, dependencyId) { return (uniqueDependencies.includes(dependencyId) ? uniqueDependencies : __spread(uniqueDependencies, [dependencyId])); }, []);
                    dependenciesMeta_1 = {};
                    dependencies_1.forEach(function (dependencyId) {
                        var driveItem = cachedDriveListState.driveItems[dependencyId];
                        if (driveItem && !driveItem.isInGallery) {
                            dependenciesMeta_1[dependencyId] = driveItem;
                        }
                    });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["r" /* receiveDriveItems */])(dependenciesMeta_1));
                }
                return [2 /*return*/];
        }
    });
}); }; };
var getObsoleteOfflineItems = function (offlineItemsMap, currentData) {
    var obsoleteIds = [];
    Object.keys(offlineItemsMap).forEach(function (key) {
        var id = parseInt(key, 10);
        if (!currentData.find(function (data) { return id === data.id; })) {
            obsoleteIds.push(id);
        }
    });
    return obsoleteIds;
};
var deleteObsoleteItems = function (requiredItemsDatas) { return function (dispatch, getState) {
    var offlineManager = getState().offlineManager;
    var requiredItemsStatus = offlineManager.requiredItems;
    var obsoleteItemsIds = getObsoleteOfflineItems(requiredItemsStatus, requiredItemsDatas);
    var promises = obsoleteItemsIds.map(function (id) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id, false))
            .then(function (itemMeta) {
            if (requiredItemsStatus[id].isIcon) {
                return dispatch(deleteThumbOrIcon(itemMeta, true));
            }
            else {
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["c" /* deleteItem */])(itemMeta))
                    .then(function () { return dispatch(removeRequiredItem(id)); });
            }
        });
    });
    return Q.allSettled(promises);
}; };
var downloadRequiredItems = function (requiredItemsDatas) { return function (dispatch, getState) {
    var _a = getState(), offlineManager = _a.offlineManager, driveList = _a.driveList;
    var driveItems = driveList.driveItems;
    var requiredItemsStatus = offlineManager.requiredItems;
    var promises = requiredItemsDatas.map(function (item) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(item.id, false))
            .then(function (itemMeta) {
            var isOutdated = requiredItemsStatus[item.id] && (item.url !== requiredItemsStatus[item.id].url || itemMeta.version > requiredItemsStatus[item.id].version);
            var isDownloadNeeded = !requiredItemsStatus[item.id] || isOutdated;
            if (isDownloadNeeded) {
                if (item.isIcon) {
                    return dispatch(downloadThumb(item.id, __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["a" /* DownloadPriority */].High, true));
                }
                else {
                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["l" /* requestMobileAppDownload */])(itemMeta, __WEBPACK_IMPORTED_MODULE_9__DownloadManager_reducer__["c" /* DownloadMode */].Required))
                        .then(function () { return dispatch(updateRequiredItemStatus(itemMeta, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED, false, item.url)); })
                        .catch(function () { return dispatch(updateRequiredItemStatus(itemMeta, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR, false, item.url)); });
                }
            }
            return {};
        })
            .catch(function () {
            dispatch(updateRequiredItemStatus(driveItems[item.id], __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR, item.isIcon, item.url));
            return Promise.reject({});
        });
    });
    return Q.allSettled(promises);
}; };
var getRequiredItemsDatas = function (template) {
    var requiredItems = [];
    if (template.menu) {
        var menuFormat = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getScreenFormat();
        var menu_1 = template.menu[menuFormat] || template.menu.default;
        var getItemId_1 = function (requiredData, isIcon) {
            var mediaId = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getMediaId(requiredData);
            if (mediaId > 0) {
                requiredItems.push({ id: mediaId, isIcon: isIcon });
            }
        };
        if (template.welcomepage && template.welcomepage.url) {
            requiredItems.push({
                id: __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getMediaId(template.welcomepage.url),
                url: template.welcomepage.url,
                isIcon: false
            });
        }
        Object.keys(menu_1).forEach(function (menuPosition) {
            menu_1[menuPosition].forEach(function (menuItem) {
                if (menuItem.type === __WEBPACK_IMPORTED_MODULE_10__typings_menu__["b" /* MenuItemType */].Page) {
                    getItemId_1(menuItem.target, false);
                }
                if (menuItem.icon) {
                    getItemId_1(menuItem.icon, true);
                }
            });
        });
    }
    // filter out duplicates;
    return requiredItems.filter(function (page, index, self) {
        return index === self.findIndex(function (selfPage) {
            return selfPage.id === page.id;
        });
    });
};
var downloadDirectChildrenThumb = function (driveItemId, level, previousDriveItemIds, isHighPriority) {
    if (isHighPriority === void 0) { isHighPriority = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var driveList, driveItem, resources, currentLevelPromises, childPromises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    driveList = getState().driveList;
                    driveItem = driveList.driveItems[driveItemId];
                    // Gracefully handle missing driveItem - skip if not found
                    if (!driveItem) {
                        return [2 /*return*/];
                    }
                    resources = driveItem.resources;
                    currentLevelPromises = [];
                    if (resources) {
                        currentLevelPromises = resources.map(function (resource) { return dispatch(handleDriveItemThumbnail(resource.id, isHighPriority)); });
                    }
                    childPromises = [];
                    if (resources) {
                        resources.forEach(function (resource) {
                            var isResourceWithChildren = resource.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory || resource.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Gallery;
                            var shouldGoDeeper = isResourceWithChildren && !previousDriveItemIds.includes(resource.id);
                            if (shouldGoDeeper) {
                                // Wrap recursive calls in error handling to prevent crashes
                                childPromises.push(dispatch(downloadDirectChildrenThumb(resource.id, level + 1, __spread(previousDriveItemIds, [driveItemId]), false))
                                    .catch(function (error) {
                                    // Log error but continue processing other children
                                    console.error("Error downloading thumbnails for child " + resource.id + ":", error);
                                    return Promise.resolve();
                                }));
                            }
                        });
                    }
                    return [4 /*yield*/, Q.allSettled(currentLevelPromises)];
                case 1:
                    _a.sent();
                    if (level === 0) {
                        return [2 /*return*/]; // used so that initial call resolve after thumbs of first level are handled
                    }
                    return [4 /*yield*/, Q.allSettled(childPromises)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
var handleDriveItemThumbnail = function (driveItemId, isHighPriority) {
    if (isHighPriority === void 0) { isHighPriority = false; }
    return function (dispatch, getState) {
        var _a = getState(), driveItems = _a.driveList.driveItems, thumbMap = _a.offlineManager.thumbMap;
        var driveItem = driveItems[driveItemId];
        if (driveItem) {
            var driveItemStatus = thumbMap[driveItemId];
            var isOutdated = driveItemStatus && driveItem.version > driveItemStatus.version;
            var isDownloadNeeded = (!driveItemStatus || isOutdated) && __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].hasIcon(driveItem);
            var isRemoveNeeded = driveItemStatus && !__WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].hasIcon(driveItem);
            var priority = isHighPriority ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["a" /* DownloadPriority */].High : __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["a" /* DownloadPriority */].Low;
            if (isDownloadNeeded) {
                return dispatch(downloadThumb(driveItemId, priority, false));
            }
            if (isRemoveNeeded) {
                return dispatch(removeThumb(driveItemId));
            }
        }
        return Q.Promise.resolve({});
    };
};
var downloadAllBgMedia = function (driveItemId, level, previousDriveItemIds) {
    return function (dispatch, getState) {
        var _a = getState(), driveList = _a.driveList, offlineManager = _a.offlineManager, applicationGallery = _a.galleryInfos.config.applicationGallery;
        var driveItems = driveList.driveItems;
        var resources = (driveList &&
            driveList.driveItems &&
            driveList.driveItems[driveItemId] &&
            driveList.driveItems[driveItemId].resources) || [];
        var bgMediaMap = offlineManager.bgMediaMap;
        var promises = [];
        var addToPromisesQueue = function (driveItemId) {
            var driveItem = driveItems[driveItemId];
            if (driveItem) {
                var driveItemStatus = bgMediaMap[driveItemId];
                var isOutdated = driveItemStatus && driveItem.version > driveItemStatus.version;
                var isDownloadNeeded = (!driveItemStatus || isOutdated) && driveItem.bgMedia;
                var isRemoveNeeded = driveItemStatus && !driveItem.bgMedia;
                if (isDownloadNeeded) {
                    promises.push(dispatch(downloadFolderBgMedia(driveItemId, __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["a" /* DownloadPriority */].Normal)));
                }
                if (isRemoveNeeded) {
                    promises.push(dispatch(removeFolderBgMedia(driveItemId)));
                }
            }
        };
        if (driveItemId === applicationGallery) {
            addToPromisesQueue(driveItemId);
        }
        if (resources) {
            resources.forEach(function (resource) { return addToPromisesQueue(resource.id); });
        }
        return Q.allSettled(promises)
            .then(function () {
            var promises = [];
            if (resources) {
                resources.forEach(function (resource) {
                    var isResourceWithChildren = resource.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory || resource.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Gallery;
                    var shouldGoDeeper = isResourceWithChildren && !previousDriveItemIds.includes(resource.id);
                    if (shouldGoDeeper) {
                        promises.push(dispatch(downloadAllBgMedia(resource.id, level + 1, __spread(previousDriveItemIds, [driveItemId]))));
                    }
                });
            }
            return level === 0 ? {} : Q.allSettled(promises);
        });
    };
};
var downloadFolderBgMedia = function (driveItemId, priority) { return function (dispatch, getState) {
    var _a = getState(), galleryInfos = _a.galleryInfos, driveList = _a.driveList, offlineManager = _a.offlineManager;
    var config = galleryInfos.config;
    var driveItems = driveList.driveItems;
    var driveItem = driveItems[driveItemId];
    var bgMediaMap = offlineManager.bgMediaMap;
    var driveItemStatus = bgMediaMap[driveItemId];
    if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline()
        && driveItem.bgMedia
        && !(driveItemStatus && (driveItemStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADING || driveItemStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR))) {
        var extension = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getFileExtension(driveItem.bgMedia);
        var fileName_1 = "background." + extension;
        var folderPath_1 = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* bgMediaFolder */] + "/" + driveItemId;
        return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(folderPath_1)
            .then(function (directoryExist) { return directoryExist
            // is needed to avoid storing of several files with different extensions
            ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + folderPath_1)
            : {}; })
            .then(function () { return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].downloadFile(config, __WEBPACK_IMPORTED_MODULE_5__utils_url__["b" /* default */].getUrlFromRelUrlWithMediaParam(driveItem.bgMedia, config), folderPath_1, fileName_1, priority).promise
            .then(function () {
            return dispatch(updateFolderBgMediaStatus(driveItemId, driveItem.version, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED));
        })
            .catch(function () {
            return dispatch(updateFolderBgMediaStatus(driveItemId, driveItem.version, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR));
        }); });
    }
    return Q.Promise.reject();
}; };
var removeFolderBgMedia = function (driveItemId) { return function (dispatch) {
    var folderPath = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* bgMediaFolder */] + "/" + driveItemId;
    return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(folderPath)
        .then(function (directoryExist) { return directoryExist
        ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + folderPath)
        : {}; })
        .then(function () { return dispatch({
        type: OfflineManagerActionKeys.REMOVE_FOLDER_BG_MEDIA,
        id: driveItemId,
    }); });
}; };
var removeThumb = function (driveItemId, shouldRemoveFromOfflineManager) {
    if (shouldRemoveFromOfflineManager === void 0) { shouldRemoveFromOfflineManager = true; }
    return function (dispatch) {
        var folderPath = __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/" + driveItemId;
        return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(folderPath)
            .then(function (directoryExist) { return directoryExist
            ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + folderPath)
            : {}; })
            .then(function () { return shouldRemoveFromOfflineManager
            ? dispatch({
                type: OfflineManagerActionKeys.REMOVE_THUMB,
                id: driveItemId,
            })
            : {}; });
    };
};
var downloadThumb = function (driveItemId, priority, isIcon, driveItemMeta, forceVersion) { return function (dispatch, getState) {
    var _a = getState(), galleryInfos = _a.galleryInfos, driveList = _a.driveList, offlineManager = _a.offlineManager;
    var config = galleryInfos.config;
    var driveItems = driveList.driveItems, resolutions = driveList.resolutions;
    var driveItem = driveItemMeta || driveItems[driveItemId];
    var thumbMap = offlineManager.thumbMap;
    var driveItemStatus = thumbMap[driveItemId];
    var hasIcon = driveItem ? __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].hasIcon(driveItem) : false;
    var isOnline = __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline();
    var isBlocked = driveItemStatus && (driveItemStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADING ||
        (!forceVersion && driveItemStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR));
    if (isOnline
        && (hasIcon || isIcon)
        && !isBlocked) {
        var thumbnailPath = isIcon ? __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getIconOriginalPath(driveItem, config) : __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getThumbnail(driveItem, config, resolutions, true);
        var extension = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getFileExtension(thumbnailPath);
        var folder = isIcon ? __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* iconsFolder */] : __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/" + driveItemId;
        var fileName_2 = isIcon ? driveItemId + "." + extension : "card_thumbnail." + extension;
        // In the case where the download of a thumb silently failed, forceVersion is here to make sure the redownloaded thumb is being loaded and not a cached version of a missing file
        var thumbnailVersion_1 = forceVersion ?
            -Math.floor(Math.random() * 99999) :
            driveItem.version;
        // Log path details only when retrying a blocked item (Check for Update feature)
        var isRetryingBlockedItem = forceVersion && driveItemStatus && driveItemStatus.status === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR;
        if (isRetryingBlockedItem) {
            console.warn("[downloadThumb] Retrying blocked item " + driveItemId + " - path: " + thumbnailPath + ", extension: " + extension + ", fileName: " + fileName_2);
        }
        return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].downloadFile(config, thumbnailPath, folder, fileName_2, priority)
            .promise
            .then(function () {
            dispatch(isIcon
                ? updateRequiredItemStatus(driveItem, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED, true, undefined, thumbnailVersion_1)
                : updateThumbStatus(driveItemId, thumbnailVersion_1, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED, fileName_2));
            return {};
        })
            .catch(function (error) {
            dispatch(deleteThumbOrIcon(driveItem, isIcon));
            dispatch(isIcon
                ? updateRequiredItemStatus(driveItem, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR, true, undefined, thumbnailVersion_1)
                : updateThumbStatus(driveItemId, thumbnailVersion_1, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR));
            return {};
        });
    }
    else {
        var reason = !isOnline ? 'not online' :
            !(hasIcon || isIcon) ? 'no icon' :
                isBlocked ? "status is " + driveItemStatus.status :
                    'unknown';
        return Q.Promise.reject("Skipped: " + reason);
    }
}; };
var deleteThumbOrIcon = function (driveItem, isIcon) { return function (dispatch, getState) {
    var _a = getState(), galleryInfos = _a.galleryInfos, driveList = _a.driveList;
    var resolutions = driveList.resolutions;
    var thumbnailPath = __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getThumbnail(driveItem, galleryInfos.config, resolutions, isIcon ? false : true);
    var extension = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getFileExtension(thumbnailPath);
    var path = isIcon ? __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* iconsFolder */] + "/" + driveItem.id + "." + extension : __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/" + driveItem.id;
    return isIcon
        ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existFile(path).then(function (fileExist) { return fileExist ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].removeFile(path) : {}; })
        : __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].existDirectory(path).then(function (fileExist) { return fileExist ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + path) : {}; });
}; };
var downloadBrandThumbIfNeeded = function (configLocation, template, isHome) {
    return function (dispatch, getState) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline()) {
            var _a = getState(), galleryInfos_1 = _a.galleryInfos, offlineManager = _a.offlineManager, appInfos = _a.appInfos;
            var thumbType_1 = isHome ? __WEBPACK_IMPORTED_MODULE_6__reducer__["e" /* ThumbType */].HOME_THUMB : __WEBPACK_IMPORTED_MODULE_6__reducer__["e" /* ThumbType */].BRAND_THUMB;
            var logoType = isHome ? __WEBPACK_IMPORTED_MODULE_6__reducer__["c" /* LogoType */].HOME_LOGO : __WEBPACK_IMPORTED_MODULE_6__reducer__["c" /* LogoType */].BRAND_LOGO;
            var logoName_1 = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getBrandLogoName(template, logoType);
            var isMultiApp_1 = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].isMultiApp(appInfos);
            var _b = offlineManager[thumbType_1][configLocation], status_1 = _b.status, filename = _b.filename;
            if (logoName_1 && (filename !== logoName_1 || status_1 !== __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED)) {
                var newFilename_1 = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getFilenameFromMediaId(logoName_1);
                var deletePromise = filename ? Q.Promise.resolve() : __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/brand/" + filename);
                dispatch(updateBrandThumbStatus(configLocation, thumbType_1, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADING, logoName_1));
                return deletePromise
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].downloadFile(galleryInfos_1.config, __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getOriginBrandLogoUrl(galleryInfos_1, isHome, isMultiApp_1, template), __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/brand", "" + newFilename_1, __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["a" /* DownloadPriority */].High).promise; })
                    .then(function () { dispatch(updateBrandThumbStatus(configLocation, thumbType_1, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED, logoName_1)); })
                    .catch(function () { dispatch(updateBrandThumbStatus(configLocation, thumbType_1, __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR, logoName_1)); });
            }
        }
        return Q.Promise.resolve();
    };
};
var downloadDefaultFolderIcon = function () {
    return function (dispatch, getState) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline()) {
            var _a = getState(), config_1 = _a.galleryInfos.config, _b = _a.offlineManager.defaultFolderIcon, status_2 = _b.status, name_1 = _b.name;
            var defaultFolderIcon_1 = __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getDefaultFolderIcon();
            if (!defaultFolderIcon_1) {
                var hasPrevDefaultFolderIcon = name_1 && status_2 === __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED;
                if (hasPrevDefaultFolderIcon) {
                    __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/" + __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* defaultFolderIconFolder */] + "/" + name_1)
                        .then(function () {
                        dispatch(updateDefaultFolderIconStatus(__WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].NOT_DOWNLOADED));
                    })
                        .catch(function () {
                        dispatch(updateDefaultFolderIconStatus(__WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR));
                    });
                }
                return Q.Promise.resolve();
            }
            var newName_1 = defaultFolderIcon_1.replace(__WEBPACK_IMPORTED_MODULE_5__utils_url__["b" /* default */].mediaParamRegex, '');
            if (name_1 !== newName_1 || status_2 !== __WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED) {
                var deletePromise = name_1
                    ? __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/" + __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* defaultFolderIconFolder */] + "/" + name_1)
                    : Q.Promise.resolve();
                dispatch(updateDefaultFolderIconStatus(__WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADING, newName_1));
                return deletePromise
                    .then(function () { return __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].downloadFile(config_1, __WEBPACK_IMPORTED_MODULE_5__utils_url__["b" /* default */].getUrlFromRelUrlWithMediaParam(defaultFolderIcon_1, config_1), __WEBPACK_IMPORTED_MODULE_0__utils__["j" /* thumbnailsFolder */] + "/" + __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* defaultFolderIconFolder */], newName_1, __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["a" /* DownloadPriority */].Normal).promise; })
                    .then(function () {
                    dispatch(updateDefaultFolderIconStatus(__WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].DOWNLOADED, newName_1));
                })
                    .catch(function () {
                    dispatch(updateDefaultFolderIconStatus(__WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* DownloadStatus */].ERROR, newName_1));
                });
            }
        }
        return Q.Promise.resolve();
    };
};
var downloadThumbs = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Wait for all thumbnail downloads to complete before resolving
            return [4 /*yield*/, Promise.all([
                    dispatch(downloadTemplateThumbs()),
                    dispatch(downloadSharedFolderThumbs()),
                    dispatch(downloadAppDirThumbs()),
                ])];
            case 1:
                // Wait for all thumbnail downloads to complete before resolving
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
var downloadAppDirThumbs = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var galleryInfos, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                galleryInfos = getState().galleryInfos;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, dispatch(downloadDirectChildrenThumb(galleryInfos.config.applicationGallery, 0, [], true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                // Gracefully handle errors during thumbnail download - log but don't crash initialization
                console.error('Error downloading app directory thumbnails:', error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var downloadTemplateThumbs = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var templatesData, templateIds, templateThumbsPromises;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_13__utils_api__["a" /* default */].getPublicationTemplates()];
            case 1:
                templatesData = _a.sent();
                templateIds = __spread(templatesData.masterProposals.map(function (_a) {
                    var id = _a.id;
                    return id;
                }), templatesData.customTemplates.map(function (_a) {
                    var id = _a.id;
                    return id;
                }));
                // There are cases where assets in template are not in sharedDir nor app folders but meta is needed to get the thumbnail
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["t" /* receiveTemplateItems */])(templatesData))];
            case 2:
                // There are cases where assets in template are not in sharedDir nor app folders but meta is needed to get the thumbnail
                _a.sent();
                templateThumbsPromises = templateIds
                    .map(function (id) { return dispatch(handleDriveItemThumbnail(id)); });
                return [4 /*yield*/, Q.allSettled(templateThumbsPromises)];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); }; };
var downloadSharedFolderThumbs = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var applicationGallery, _a, driveList, config, sharedDirId, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                applicationGallery = getState().galleryInfos.config.applicationGallery;
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(applicationGallery))];
            case 1:
                _b.sent();
                _a = getState(), driveList = _a.driveList, config = _a.galleryInfos.config;
                sharedDirId = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].getSharedDirId(driveList, config);
                if (!sharedDirId) {
                    return [2 /*return*/];
                }
                _b.label = 2;
            case 2:
                _b.trys.push([2, 4, , 5]);
                return [4 /*yield*/, dispatch(downloadDirectChildrenThumb(sharedDirId, 0, []))];
            case 3:
                _b.sent();
                return [3 /*break*/, 5];
            case 4:
                error_2 = _b.sent();
                // Gracefully handle errors during thumbnail download - log but don't crash initialization
                console.error('Error downloading shared folder thumbnails:', error_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var deleteObsoleteThumbsAndBgMedia = function () {
    return function (dispatch, getState) {
        var _a = getState(), driveItems = _a.driveList.driveItems, _b = _a.offlineManager, thumbMap = _b.thumbMap, bgMediaMap = _b.bgMediaMap;
        var promises = [];
        Object.keys(bgMediaMap).forEach(function (id) {
            if (!driveItems[id]) {
                promises.push(dispatch(removeFolderBgMedia(+id)));
            }
        });
        Object.keys(thumbMap).forEach(function (id) {
            if (!driveItems[id]) {
                promises.push(dispatch(removeThumb(+id)));
            }
        });
        return Q.allSettled(promises);
    };
};
var updateBrandThumbStatus = function (configLocation, thumbType, status, filename) { return ({
    type: OfflineManagerActionKeys.UPDATE_BRAND_THUMB,
    configLocation: configLocation,
    thumbType: thumbType,
    status: status,
    filename: filename
}); };
var updateDefaultFolderIconStatus = function (status, name) { return ({
    type: OfflineManagerActionKeys.UPDATE_DEFAULT_FOLDER_ICON,
    status: status,
    name: name,
}); };
var startInitialization = function () { return ({ type: OfflineManagerActionKeys.START_INITIALIZATION }); };
var endInitialization = function () { return ({ type: OfflineManagerActionKeys.END_INITIALIZATION }); };
var updateThumbStatus = function (driveItemId, version, status, fileName) { return ({
    type: OfflineManagerActionKeys.UPDATE_THUMB_STATUS,
    driveItemId: driveItemId,
    version: version,
    status: status,
    fileName: fileName,
}); };
var updateRequiredItemStatus = function (item, status, isIcon, url, forcedVersion) { return ({
    type: OfflineManagerActionKeys.UPDATE_REQUIRED_ITEM_STATUS,
    version: forcedVersion || item.version,
    id: item.id,
    status: status,
    isIcon: isIcon,
    url: url
}); };
var updateFolderBgMediaStatus = function (driveItemId, version, status) { return ({
    type: OfflineManagerActionKeys.UPDATE_FOLDER_BG_MEDIA_STATUS,
    driveItemId: driveItemId,
    version: version,
    status: status
}); };
var removeRequiredItem = function (id) { return ({
    type: OfflineManagerActionKeys.REMOVE_REQUIRED_ITEM,
    id: id
}); };
var sendInitializationError = function () { return ({ type: OfflineManagerActionKeys.INITIALIZATION_ERROR }); };
var startContentStructurePreparation = function () { return ({ type: OfflineManagerActionKeys.START_CONTENT_STRUCTURE_PREPARATION }); };
var endContentStructurePreparation = function () { return function (dispatch, getState) {
    dispatch({ type: OfflineManagerActionKeys.END_CONTENT_STRUCTURE_PREPARATION });
    // Mark that content structure has been completed successfully at least once
    // This flag persists to IndexedDB and is used to determine if offline mode can work
    dispatch({ type: OfflineManagerActionKeys.MARK_CONTENT_STRUCTURE_COMPLETED });
    // Auto-hide the completion message after 3 seconds, but only if thumbnails are not downloading
    // If thumbnails are downloading, keep showing the widget until they're done
    setTimeout(function () {
        var isDownloadingThumbs = getState().offlineManager.isDownloadingThumbs;
        // Only clear if thumbnails are done downloading
        if (!isDownloadingThumbs) {
            dispatch({ type: OfflineManagerActionKeys.CLEAR_CONTENT_STRUCTURE_READY });
        }
    }, 3000);
}; };
var clearContentStructureReady = function () { return ({ type: OfflineManagerActionKeys.CLEAR_CONTENT_STRUCTURE_READY }); };
var closeContentStructureToast = function () { return ({ type: OfflineManagerActionKeys.CLOSE_CONTENT_STRUCTURE_TOAST }); };
var removeItemsMarkedForDeletion = function () { return function (dispatch, getState) {
    var downloadManager = getState().downloadManager;
    var items = downloadManager.items;
    var promises = [];
    Object.keys(items).forEach(function (key) {
        var downloadItem = items[key];
        var id = parseInt(key, 10);
        // Delete requested mode items and their dependencies
        if (downloadItem.status === __WEBPACK_IMPORTED_MODULE_9__DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_DELETION && downloadItem.mode === __WEBPACK_IMPORTED_MODULE_9__DownloadManager_reducer__["c" /* DownloadMode */].Requested) {
            promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id, false))
                .then(function (driveItem) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["c" /* deleteItem */])(driveItem, true)); })
                .catch(function (error) {
                console.warn("Could not fetch metadata for item " + id + " during deletion cleanup, removing from state and storage", error);
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["k" /* removeDownloadItem */])(id));
            }));
        }
    });
    // Clean up any orphaned dependencies still marked for deletion
    return Q.Promise.all(promises).then(function () {
        var updatedDownloadManager = getState().downloadManager;
        var updatedItems = updatedDownloadManager.items;
        var cleanupPromises = [];
        Object.keys(updatedItems).forEach(function (key) {
            var downloadItem = updatedItems[key];
            var id = parseInt(key, 10);
            if (downloadItem.status === __WEBPACK_IMPORTED_MODULE_9__DownloadManager_reducer__["d" /* DownloadStatus */].STARTING_DELETION && downloadItem.mode === __WEBPACK_IMPORTED_MODULE_9__DownloadManager_reducer__["c" /* DownloadMode */].Dependency) {
                cleanupPromises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id, false))
                    .then(function (driveItem) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["c" /* deleteItem */])(driveItem, true)); })
                    .catch(function (error) {
                    // If we can't fetch the dependency metadata, still remove it from the download manager
                    console.warn("Could not fetch metadata for dependency " + id + " during deletion cleanup, removing from state", error);
                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions__["k" /* removeDownloadItem */])(id));
                }));
            }
        });
        return Q.Promise.all(cleanupPromises);
    });
}; };



/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryInfosActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initializeGallery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return migrateAppContainerLocalStorageToIndexedDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initStatistics; });
/* unused harmony export fetchRemoteTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setForceSplashscreen; });
/* unused harmony export requestConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setCustomCSS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_setLocales__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Authentication_actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MenuManager_constants__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DriveItemList_New_actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Authentication_reducer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DownloadAllPopup_actions__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__OfflineManager_reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__PendingTasksManager_actions__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ReadStatus_actions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__App_actions__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__MultiAppAuthentication_constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_statistics_trackerManager__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__DownloadManager_reducer__ = __webpack_require__(28);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _this = this;
































var GalleryInfosActionKeys;
(function (GalleryInfosActionKeys) {
    GalleryInfosActionKeys["REQUEST_CONFIG"] = "@@gallery/REQUEST_CONFIG";
    GalleryInfosActionKeys["RECEIVE_CONFIG"] = "@@gallery/RECEIVE_CONFIG";
    GalleryInfosActionKeys["REQUEST_LOCAL_TEMPLATE"] = "@@gallery/REQUEST_LOCAL_TEMPLATE";
    GalleryInfosActionKeys["RECEIVE_LOCAL_TEMPLATE"] = "@@gallery/RECEIVE_LOCAL_TEMPLATE";
    GalleryInfosActionKeys["REQUEST_REMOTE_TEMPLATE"] = "@@gallery/REQUEST_REMOTE_TEMPLATE";
    GalleryInfosActionKeys["RECEIVE_REMOTE_TEMPLATE"] = "@@gallery/RECEIVE_REMOTE_TEMPLATE";
    GalleryInfosActionKeys["SET_CUSTOM_CSS"] = "@@gallery/SET_CUSTOM_CSS";
    GalleryInfosActionKeys["FORCE_VIEW_UPDATE"] = "@@gallery/FORCE_VIEW_UPDATE";
    GalleryInfosActionKeys["SET_FORCE_SPLASH_SCREEN"] = "@@gallery/SET_FORCE_SPLASH_SCREEN";
    GalleryInfosActionKeys["UPDATE_TEMPLATE_BRAND"] = "@@gallery/UPDATE_TEMPLATE_BRAND";
    GalleryInfosActionKeys["UPDATE_TEMPLATE_COMMONSTYLES"] = "@@gallery/UPDATE_TEMPLATE_COMMONSTYLES";
})(GalleryInfosActionKeys || (GalleryInfosActionKeys = {}));
var initializeGallery = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, appInfos, authentication, type, mode, clientId, cookie, isGdprEnabled, galleryInfos, storedUserLocale, templateLocale, embedModeLocale, localeToSet, updatedAppInfos, _b, login, token, error_1, config, trackerManager;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getState(), appInfos = _a.appInfos, authentication = _a.authentication;
                type = appInfos.type;
                mode = authentication.userInfos.mode;
                return [4 /*yield*/, dispatch(initIsOnline())];
            case 1:
                _c.sent();
                if (!(type === __WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* AppType */].Single)) return [3 /*break*/, 4];
                return [4 /*yield*/, dispatch(fetchLocalGalleryInfos())];
            case 2:
                _c.sent();
                return [4 /*yield*/, migrateAppContainerLocalStorageToIndexedDB()];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [4 /*yield*/, dispatch(RemoveForceSplashScreenAfterDelay())];
            case 5:
                _c.sent();
                if (!!__WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isConnecting(mode)) return [3 /*break*/, 7];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__Authentication_actions__["c" /* loadPreviousCredentials */])())];
            case 6:
                _c.sent();
                _c.label = 7;
            case 7: return [4 /*yield*/, dispatch(fetchRemoteTemplate())];
            case 8:
                _c.sent();
                return [4 /*yield*/, dispatch(loadPreviousStates())];
            case 9:
                _c.sent();
                if (!__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].shouldGetProfileData()) return [3 /*break*/, 12];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__ProfilePage_actions__["d" /* getCustomerContext */])())];
            case 10:
                _c.sent();
                clientId = getState().galleryInfos.config.clientId;
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__ProfilePage_actions__["e" /* getProfileData */])(clientId))];
            case 11:
                _c.sent();
                _c.label = 12;
            case 12:
                cookie = getState().galleryInfos.template.cookie;
                isGdprEnabled = !!cookie && cookie.gdpr === 'true';
                if (!(!__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isEmbedMode() && !isGdprEnabled)) return [3 /*break*/, 14];
                return [4 /*yield*/, dispatch(initStatistics())];
            case 13:
                _c.sent();
                _c.label = 14;
            case 14:
                galleryInfos = getState().galleryInfos;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getUserLocale(true)];
            case 15:
                storedUserLocale = _c.sent();
                templateLocale = !appInfos.userLocale && galleryInfos.template ? galleryInfos.template.locale : undefined;
                embedModeLocale = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isEmbedMode()
                    ? __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getQueryParamFromUrl('locale')
                    : undefined;
                localeToSet = embedModeLocale || storedUserLocale || templateLocale;
                if (localeToSet) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__store_setLocales__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */], localeToSet);
                }
                if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()) {
                    __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setGalleryInfos(galleryInfos).then();
                }
                if (!__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMaster(galleryInfos.config)) return [3 /*break*/, 17];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__DriveItemList_actions__["j" /* getAllDriveItems */])())];
            case 16:
                _c.sent();
                _c.label = 17;
            case 17:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__["f" /* initializeOfflineManager */])());
                return [4 /*yield*/, dispatch(fetchMenuItemsMeta())];
            case 18:
                _c.sent();
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__DriveItemList_actions__["D" /* setFoldersDisplayType */])())];
            case 19:
                _c.sent();
                updatedAppInfos = getState().appInfos;
                if (!(!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp && __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMultiApp(updatedAppInfos))) return [3 /*break*/, 25];
                _c.label = 20;
            case 20:
                _c.trys.push([20, 24, , 25]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].refreshSession()];
            case 21:
                _b = _c.sent(), login = _b.login, token = _b.token;
                if (!login) return [3 /*break*/, 23];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_28__MultiAppAuthentication_actions__["l" /* updateCredentials */])({
                        method: __WEBPACK_IMPORTED_MODULE_29__MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication,
                        login: login,
                        token: token,
                        lastApiCallTimestamp: Date.now(),
                    }))];
            case 22:
                _c.sent();
                _c.label = 23;
            case 23: return [3 /*break*/, 25];
            case 24:
                error_1 = _c.sent();
                console.error('Error while refreshing session', error_1);
                return [3 /*break*/, 25];
            case 25:
                if (!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp) {
                    // legacy
                    __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeUsername();
                    __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removePassword();
                }
                config = getState().galleryInfos.config;
                trackerManager = __WEBPACK_IMPORTED_MODULE_30__utils_statistics_trackerManager__["a" /* default */].getInstance();
                trackerManager.trackProperty('account_id', config.clientId.toString());
                trackerManager.trackProperty('app_id', config.applicationGallery.toString());
                return [2 /*return*/];
        }
    });
}); }; };
// At first run of the current app container, move any existing localStorage data to IndexedDB
var migrateAppContainerLocalStorageToIndexedDB = function () { return __awaiter(_this, void 0, void 0, function () {
    var wasAppContainerIndexedDBInitialized, localStorageGalleryPrefix, indexDBGalleryPrefix, allOk, prevLocalStorageDownloads, prevLocalStorageDownloadGroups, prevLocalStoragePendingSelectedDownloads, prevLocalStorageDownloadPopupDontAskAgain, prevLocalStorageDisplayType, prevLocalStorageFoldersDisplayType, prevLocalStorageSelection, prevLocalStorageNotesSelection, prevLocalStorageNewItems, prevLocalStorageReadStatus, prevLocalStoragePendingTasks, prevLocalStorageGalleryInfos, prevLocalStorageDriveList, prevLocalStorageOfflineManager, prevLocalStorageCredentials, prevLocalStorageTrackingQueue, prevLocalStorageUserLocale, error_2, error_3, error_4, error_5, error_6, error_7, error_8, error_9, error_10, error_11, error_12, error_13, error_14, error_15, error_16, error_17, error_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].wasIndexedDBInitialized(true)];
            case 1:
                wasAppContainerIndexedDBInitialized = _a.sent();
                localStorageGalleryPrefix = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getGalleryPrefix();
                indexDBGalleryPrefix = __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getGalleryPrefix();
                if (!(!wasAppContainerIndexedDBInitialized && localStorageGalleryPrefix && indexDBGalleryPrefix)) return [3 /*break*/, 74];
                allOk = true;
                prevLocalStorageDownloads = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getDownloads();
                prevLocalStorageDownloadGroups = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getDownloadGroups();
                prevLocalStoragePendingSelectedDownloads = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getPendingSelectedDownloads();
                prevLocalStorageDownloadPopupDontAskAgain = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getDownloadPopupDontAskAgain();
                prevLocalStorageDisplayType = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getDisplayType();
                prevLocalStorageFoldersDisplayType = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getFoldersDisplayType();
                prevLocalStorageSelection = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getSelection();
                prevLocalStorageNotesSelection = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getNotesSelection();
                prevLocalStorageNewItems = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getNewItemsStore();
                prevLocalStorageReadStatus = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getReadStatusStore();
                prevLocalStoragePendingTasks = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getPendingTasks();
                prevLocalStorageGalleryInfos = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getStoreGalleryInfos();
                prevLocalStorageDriveList = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getStoreDriveList();
                prevLocalStorageOfflineManager = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getStoreOfflineManager();
                prevLocalStorageCredentials = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getCredentials();
                prevLocalStorageTrackingQueue = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getTrackingQueue();
                prevLocalStorageUserLocale = __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].getUserLocale(true);
                if (!prevLocalStorageDownloads) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setDownloads(prevLocalStorageDownloads)];
            case 3:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeDownloads();
                return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                console.error('Failed to migrate downloads to IndexedDB', error_2);
                allOk = false;
                return [3 /*break*/, 5];
            case 5:
                if (!prevLocalStorageDownloadGroups) return [3 /*break*/, 11];
                _a.label = 6;
            case 6:
                _a.trys.push([6, 10, , 11]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setDownloadGroups(__WEBPACK_IMPORTED_MODULE_31__DownloadManager_reducer__["a" /* DownloadGroupName */].ALL, prevLocalStorageDownloadGroups.all)];
            case 7:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setDownloadGroups(__WEBPACK_IMPORTED_MODULE_31__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT, prevLocalStorageDownloadGroups.important)];
            case 8:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setDownloadGroups(__WEBPACK_IMPORTED_MODULE_31__DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED, prevLocalStorageDownloadGroups.selected)];
            case 9:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeDownloadGroups();
                return [3 /*break*/, 11];
            case 10:
                error_3 = _a.sent();
                console.error('Failed to migrate download groups to IndexedDB', error_3);
                allOk = false;
                return [3 /*break*/, 11];
            case 11:
                if (!prevLocalStoragePendingSelectedDownloads) return [3 /*break*/, 15];
                _a.label = 12;
            case 12:
                _a.trys.push([12, 14, , 15]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setPendingSelectedDownloads(prevLocalStoragePendingSelectedDownloads)];
            case 13:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removePendingSelectedDownloads();
                return [3 /*break*/, 15];
            case 14:
                error_4 = _a.sent();
                console.error('Failed to migrate pendingSelectedDownloads to IndexedDB', error_4);
                allOk = false;
                return [3 /*break*/, 15];
            case 15:
                if (!prevLocalStorageDownloadPopupDontAskAgain) return [3 /*break*/, 19];
                _a.label = 16;
            case 16:
                _a.trys.push([16, 18, , 19]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setDownloadPopupDontAskAgain()];
            case 17:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeDownloadPopupDontAskAgain();
                return [3 /*break*/, 19];
            case 18:
                error_5 = _a.sent();
                console.error('Failed to migrate downloadPopupDontAskAgain to IndexedDB', error_5);
                allOk = false;
                return [3 /*break*/, 19];
            case 19:
                if (!prevLocalStorageDisplayType) return [3 /*break*/, 23];
                _a.label = 20;
            case 20:
                _a.trys.push([20, 22, , 23]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setDisplayType(prevLocalStorageDisplayType)];
            case 21:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeDisplayType();
                return [3 /*break*/, 23];
            case 22:
                error_6 = _a.sent();
                console.error('Failed to migrate displayType to IndexedDB', error_6);
                allOk = false;
                return [3 /*break*/, 23];
            case 23:
                if (!prevLocalStorageFoldersDisplayType) return [3 /*break*/, 27];
                _a.label = 24;
            case 24:
                _a.trys.push([24, 26, , 27]);
                return [4 /*yield*/, Promise.all(Object.entries(prevLocalStorageFoldersDisplayType).map(function (_a) {
                        var _b = __read(_a, 2), folderId = _b[0], displayType = _b[1];
                        return __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setFolderDisplayType(folderId, displayType);
                    }))];
            case 25:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].resetFoldersDisplayType();
                return [3 /*break*/, 27];
            case 26:
                error_7 = _a.sent();
                console.error('Failed to migrate foldersDisplayType to IndexedDB', error_7);
                allOk = false;
                return [3 /*break*/, 27];
            case 27:
                if (!prevLocalStorageSelection) return [3 /*break*/, 31];
                _a.label = 28;
            case 28:
                _a.trys.push([28, 30, , 31]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setSelection(prevLocalStorageSelection)];
            case 29:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeSelection();
                return [3 /*break*/, 31];
            case 30:
                error_8 = _a.sent();
                console.error('Failed to migrate selection to IndexedDB', error_8);
                allOk = false;
                return [3 /*break*/, 31];
            case 31:
                if (!prevLocalStorageNotesSelection) return [3 /*break*/, 35];
                _a.label = 32;
            case 32:
                _a.trys.push([32, 34, , 35]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setNotesSelection(prevLocalStorageNotesSelection)];
            case 33:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeNotesSelection();
                return [3 /*break*/, 35];
            case 34:
                error_9 = _a.sent();
                console.error('Failed to migrate notesSelection to IndexedDB', error_9);
                allOk = false;
                return [3 /*break*/, 35];
            case 35:
                if (!prevLocalStorageNewItems) return [3 /*break*/, 39];
                _a.label = 36;
            case 36:
                _a.trys.push([36, 38, , 39]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setNewItems(prevLocalStorageNewItems)];
            case 37:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeNewItems();
                return [3 /*break*/, 39];
            case 38:
                error_10 = _a.sent();
                console.error('Failed to migrate newItems to IndexedDB', error_10);
                allOk = false;
                return [3 /*break*/, 39];
            case 39:
                if (!prevLocalStorageReadStatus) return [3 /*break*/, 43];
                _a.label = 40;
            case 40:
                _a.trys.push([40, 42, , 43]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setReadStatus(prevLocalStorageReadStatus)];
            case 41:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeReadStatus();
                return [3 /*break*/, 43];
            case 42:
                error_11 = _a.sent();
                console.error('Failed to migrate readStatus to IndexedDB', error_11);
                allOk = false;
                return [3 /*break*/, 43];
            case 43:
                if (!prevLocalStoragePendingTasks) return [3 /*break*/, 47];
                _a.label = 44;
            case 44:
                _a.trys.push([44, 46, , 47]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setPendingTasks(prevLocalStoragePendingTasks)];
            case 45:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removePendingTasks();
                return [3 /*break*/, 47];
            case 46:
                error_12 = _a.sent();
                console.error('Failed to migrate pendingTasks to IndexedDB', error_12);
                allOk = false;
                return [3 /*break*/, 47];
            case 47:
                if (!prevLocalStorageGalleryInfos) return [3 /*break*/, 51];
                _a.label = 48;
            case 48:
                _a.trys.push([48, 50, , 51]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setGalleryInfos(prevLocalStorageGalleryInfos)];
            case 49:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeStoreGalleryInfos();
                return [3 /*break*/, 51];
            case 50:
                error_13 = _a.sent();
                console.error('Failed to migrate galleryInfos to IndexedDB', error_13);
                allOk = false;
                return [3 /*break*/, 51];
            case 51:
                if (!prevLocalStorageDriveList) return [3 /*break*/, 55];
                _a.label = 52;
            case 52:
                _a.trys.push([52, 54, , 55]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setStoreDriveList(prevLocalStorageDriveList)];
            case 53:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeStoreDriveList();
                return [3 /*break*/, 55];
            case 54:
                error_14 = _a.sent();
                console.error('Failed to migrate driveList to IndexedDB', error_14);
                allOk = false;
                return [3 /*break*/, 55];
            case 55:
                if (!prevLocalStorageOfflineManager) return [3 /*break*/, 59];
                _a.label = 56;
            case 56:
                _a.trys.push([56, 58, , 59]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setStoreOfflineManager(prevLocalStorageOfflineManager)];
            case 57:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeStoreOfflineManager();
                return [3 /*break*/, 59];
            case 58:
                error_15 = _a.sent();
                console.error('Failed to migrate offlineManager to IndexedDB', error_15);
                allOk = false;
                return [3 /*break*/, 59];
            case 59:
                if (!prevLocalStorageCredentials) return [3 /*break*/, 63];
                _a.label = 60;
            case 60:
                _a.trys.push([60, 62, , 63]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setCredentials(prevLocalStorageCredentials)];
            case 61:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeCredentials();
                return [3 /*break*/, 63];
            case 62:
                error_16 = _a.sent();
                console.error('Failed to migrate credentials to IndexedDB', error_16);
                allOk = false;
                return [3 /*break*/, 63];
            case 63:
                if (!prevLocalStorageTrackingQueue) return [3 /*break*/, 67];
                _a.label = 64;
            case 64:
                _a.trys.push([64, 66, , 67]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setTrackingQueue(prevLocalStorageTrackingQueue)];
            case 65:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeTrackingQueue();
                return [3 /*break*/, 67];
            case 66:
                error_17 = _a.sent();
                console.error('Failed to migrate trackingQueue to IndexedDB', error_17);
                allOk = false;
                return [3 /*break*/, 67];
            case 67:
                if (!prevLocalStorageUserLocale) return [3 /*break*/, 71];
                _a.label = 68;
            case 68:
                _a.trys.push([68, 70, , 71]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setUserLocale(prevLocalStorageUserLocale, true)];
            case 69:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].removeUserLocale(true);
                return [3 /*break*/, 71];
            case 70:
                error_18 = _a.sent();
                console.error('Failed to migrate userLocale (prefixed) to IndexedDB', error_18);
                allOk = false;
                return [3 /*break*/, 71];
            case 71:
                if (!allOk) return [3 /*break*/, 73];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setIndexedDBInitialized(true)];
            case 72:
                _a.sent();
                return [3 /*break*/, 74];
            case 73:
                console.error('Failed to migrate app container localStorage to IndexedDB');
                _a.label = 74;
            case 74: return [2 /*return*/];
        }
    });
}); };
var initIsOnline = function () { return function (dispatch, getState) {
    if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnlinePromise();
    }
    return Promise.resolve({});
}; };
var areCredentialsNeeded = function () { return function (dispatch, getState) {
    var _a = getState(), authentication = _a.authentication, appInfos = _a.appInfos;
    if (appInfos.type === __WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* AppType */].Multiple) {
        return Promise.resolve();
    }
    var mode = authentication.userInfos.mode;
    var needSecurityCheck = !mode || __WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isNotConnected(mode);
    if (__WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].needReconnecting(mode)) { // SAML on IOS need to be automatically reauthenticated
        __WEBPACK_IMPORTED_MODULE_19__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_19__utils_routes__["a" /* default */].getPathAuthentication());
        return Promise.reject(undefined);
    }
    if (needSecurityCheck) {
        return __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].getSecurityType()
            .then(function (value) {
            if (value) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__Authentication_actions__["e" /* setNeedCredentials */])(true, value.securityType, value.samlUrl));
                return Promise.reject(undefined);
            }
            return Promise.resolve();
        });
    }
    return Promise.resolve();
}; };
var fetchMenuItemsMeta = function () { return function (dispatch, getState) {
    var _a = getState(), galleryInfos = _a.galleryInfos, authentication = _a.authentication;
    var template = galleryInfos.template;
    var _b = authentication.userInfos, needCredentials = _b.needCredentials, mode = _b.mode;
    var hasAccess = !needCredentials || needCredentials && __WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isConnected(mode);
    if (template.menu && hasAccess && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()) {
        var customMenuItems = getCustomMenuItemsIds(template.menu);
        customMenuItems.forEach(function (item) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(item, false)); });
    }
    return Promise.resolve({});
}; };
var getCustomMenuItemsIds = function (menuConfig) {
    var customMenuItems = [];
    Object.keys(menuConfig).forEach(function (menuFormat) {
        Object.keys(menuConfig[menuFormat]).forEach(function (menuPosition) {
            menuConfig[menuFormat][menuPosition].forEach(function (menuItem, index) {
                if (menuItem.type === __WEBPACK_IMPORTED_MODULE_9__typings_menu__["b" /* MenuItemType */].Asset || menuItem.type === __WEBPACK_IMPORTED_MODULE_9__typings_menu__["b" /* MenuItemType */].Folder || menuItem.type === __WEBPACK_IMPORTED_MODULE_9__typings_menu__["b" /* MenuItemType */].Page) {
                    var targetId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getMediaId(menuItem.target);
                    if (targetId > 0) {
                        customMenuItems.push(targetId);
                    }
                }
                if (menuItem.icon) {
                    var iconId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getMediaId(menuItem.icon);
                    if (iconId > 0) {
                        customMenuItems.push(iconId);
                    }
                }
            });
        });
    });
    return customMenuItems.filter(function (item, index, self) { return index === self.indexOf(item); });
};
var fetchLocalGalleryInfos = function () { return function (dispatch, getState) {
    var galleryInfos = getState().galleryInfos;
    if (galleryInfos.isConfigLoaded) {
        return Promise.resolve(undefined);
    }
    dispatch(requestConfig());
    return __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].fetchJson("./.gallery/config/config.json", 'GET', undefined, true)
        .then(function (config) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isEmbedMode()) {
            // for embed mode a special application is used with no clientId and applicationGallery params in config
            // it allows any user to connect and use these params from url
            var clientId = +__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getQueryParamFromUrl('clientId');
            var rootDriveId = +__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getQueryParamFromUrl('rootDriveId');
            config = __assign({}, config, { clientId: clientId, applicationGallery: rootDriveId });
        }
        __WEBPACK_IMPORTED_MODULE_6__utils_localStorage_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery);
        __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery);
        if (config.type && config.type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.AppContainer) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_26__App_actions__["a" /* AppInfosActionKeys */].SET_APP_TYPE, appType: __WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* AppType */].Multiple });
        }
        dispatch(receiveConfig(config));
    })
        .then(function () { return dispatch(loadPreviousHomeLogo()); })
        .then(function () { return dispatch(fetchTemplateOrLoadPreviousOne()); })
        .then(function (template) {
        if (!template.menu) {
            template.menu = __WEBPACK_IMPORTED_MODULE_16__MenuManager_constants__["c" /* defaultGalleryMenu */];
        }
        dispatch(receiveLocalTemplate(template));
        Object(__WEBPACK_IMPORTED_MODULE_1__store_setLocales__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */], template.locale);
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__["d" /* downloadBrandThumbIfNeeded */])(__WEBPACK_IMPORTED_MODULE_23__OfflineManager_reducer__["a" /* BrandThumbConfigLocation */].LOCAL_CONFIG, template, true));
    })
        .then(function () {
        var hasCustomCSS = getState().galleryInfos.template.hasCustomCSS;
        if (hasCustomCSS) {
            dispatch(fetchCustomCSS())
                .then(function (customCSS) {
                // Check for HTML response with doctype. Potential improvement: use css validator
                if (customCSS.indexOf('<!doctype html>') === -1) {
                    dispatch(setCustomCSS(customCSS));
                }
            });
        }
    });
}; };
var loadPreviousStates = function () { return function (dispatch, getState) {
    return Promise.resolve(dispatch(Object(__WEBPACK_IMPORTED_MODULE_22__DownloadAllPopup_actions__["c" /* closeDownloadAllPopupIfNeeded */])()))
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__["g" /* loadOfflineManager */])()); })
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__PendingTasksManager_actions__["c" /* loadPendingTasksManager */])()); })
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__DownloadManager_actions__["i" /* loadPreviousDownloads */])()); })
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Selection_actions__["d" /* loadPreviousSelection */])()); })
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__ReadStatus_actions__["b" /* loadReadStatusStore */])()); })
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__DriveItemList_New_actions__["c" /* loadNewItemsStore */])()); });
}; };
var loadPreviousHomeLogo = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var previousOfflineManagerState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getStoreOfflineManager()];
            case 1:
                previousOfflineManagerState = _a.sent();
                if (previousOfflineManagerState) {
                    if (previousOfflineManagerState.homeThumb) {
                        dispatch({
                            type: __WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__["a" /* OfflineManagerActionKeys */].INIT_HOME_THUMB,
                            homeThumb: previousOfflineManagerState.homeThumb,
                        });
                    }
                }
                return [2 /*return*/];
        }
    });
}); }; };
var fetchTemplateOrLoadPreviousOne = function () { return function () { return __awaiter(_this, void 0, void 0, function () {
    var cachedTemplate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp && !__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline())) return [3 /*break*/, 2];
                return [4 /*yield*/, getCachedTemplate()];
            case 1:
                cachedTemplate = _a.sent();
                if (cachedTemplate) {
                    return [2 /*return*/, cachedTemplate];
                }
                _a.label = 2;
            case 2: return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].fetchJson("./.gallery/config/template.json", 'GET', undefined, true)];
        }
    });
}); }; };
var fetchCustomCSS = function () { return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].fetchText("./.gallery/config/custom.css", 'GET', undefined, true);
}; };
var initStatistics = function () { return function (dispatch, getState) {
    if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()) {
        return fetchStatistics()
            .catch(function (response) {
            return Promise.resolve(undefined);
        });
    }
    fetchStatisticsWhenOnline();
    return Promise.resolve(undefined);
}; };
var fetchStatisticsWhenOnline = function () {
    __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].subscribeToConnectionIsUp(function () {
        fetchStatistics();
    }, true);
};
var fetchStatistics = function () {
    return __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].getStatistics()
        .then(function (statisticsConfig) {
        __WEBPACK_IMPORTED_MODULE_5__utils_statistics__["a" /* default */].updateConfig(statisticsConfig);
    });
};
var fetchRemoteTemplate = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, galleryInfos, authentication, mode, cachedTemplate, cachedCustomCSS, _b, multiAppAuthenticationInfos, appInfos, isMultiApp, server, template, err_1, hasCustomCSS;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getState(), galleryInfos = _a.galleryInfos, authentication = _a.authentication;
                mode = authentication.userInfos.mode;
                if (!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp) return [3 /*break*/, 10];
                if (!!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()) return [3 /*break*/, 3];
                return [4 /*yield*/, getCachedTemplate()];
            case 1:
                cachedTemplate = _c.sent();
                return [4 /*yield*/, getCachedCustomCSS()];
            case 2:
                cachedCustomCSS = _c.sent();
                if (cachedTemplate) {
                    if (__WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isSaml(mode) && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOSApp()) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__Authentication_actions__["f" /* updateCredentials */])({
                            mode: __assign({}, mode, { onCache: true })
                        }));
                    }
                    dispatch(setCustomCSS(cachedCustomCSS));
                    return [2 /*return*/, dispatch(receiveRemoteTemplate(cachedTemplate))];
                }
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__NotificationBar_actions__["c" /* createNotification */])('info.offline_no_config', { id: galleryInfos.config.applicationGallery }, -1));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__["i" /* sendInitializationError */])());
                throw undefined;
            case 3:
                _b = getState(), multiAppAuthenticationInfos = _b.multiAppAuthenticationInfos, appInfos = _b.appInfos;
                isMultiApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMultiApp(appInfos);
                server = isMultiApp ? multiAppAuthenticationInfos.server : undefined;
                return [4 /*yield*/, dispatch(areCredentialsNeeded())];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5:
                _c.trys.push([5, 8, , 9]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].getTemplate(server)];
            case 6:
                template = _c.sent();
                if (__WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isSaml(mode) && (__WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isNotConnected(mode) || __WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].isConnecting(mode))) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__Authentication_actions__["f" /* updateCredentials */])({
                        mode: __assign({}, mode, { status: __WEBPACK_IMPORTED_MODULE_21__Authentication_reducer__["a" /* ConnectionStatus */].CONNECTED })
                    }));
                }
                if (!template.menu) {
                    template.menu = isMultiApp ? __WEBPACK_IMPORTED_MODULE_16__MenuManager_constants__["b" /* defaultAppMenu */] : __WEBPACK_IMPORTED_MODULE_16__MenuManager_constants__["c" /* defaultGalleryMenu */];
                }
                dispatch(receiveRemoteTemplate(template));
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__OfflineManager_actions__["d" /* downloadBrandThumbIfNeeded */])(__WEBPACK_IMPORTED_MODULE_23__OfflineManager_reducer__["a" /* BrandThumbConfigLocation */].REMOTE_CONFIG, template, true))];
            case 7:
                _c.sent();
                return [3 /*break*/, 9];
            case 8:
                err_1 = _c.sent();
                throw err_1;
            case 9:
                hasCustomCSS = getState().galleryInfos.template.hasCustomCSS;
                if (hasCustomCSS) {
                    __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].getCustomCSS(server)
                        .then(function (customCSS) {
                        dispatch(setCustomCSS(customCSS));
                    });
                }
                return [2 /*return*/];
            case 10: return [2 /*return*/];
        }
    });
}); }; };
var getCachedTemplate = function () { return __awaiter(_this, void 0, void 0, function () {
    var cachedGalleryInfosState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getGalleryInfos()];
            case 1:
                cachedGalleryInfosState = _a.sent();
                return [2 /*return*/, cachedGalleryInfosState ? cachedGalleryInfosState.template : null];
        }
    });
}); };
var getCachedCustomCSS = function () { return __awaiter(_this, void 0, void 0, function () {
    var cachedGalleryInfosState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getGalleryInfos()];
            case 1:
                cachedGalleryInfosState = _a.sent();
                return [2 /*return*/, cachedGalleryInfosState ? cachedGalleryInfosState.customCSS : ''];
        }
    });
}); };
var RemoveForceSplashScreenAfterDelay = function () { return function (dispatch, getState) {
    var mode = getState().authentication.userInfos.mode;
    if (!__WEBPACK_IMPORTED_MODULE_20__utils_authentication__["a" /* default */].needReconnecting(mode) || !__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()) { // SAML automated reconnection on IOS is done behind the splashscreen
        setTimeout(function () {
            dispatch(setForceSplashscreen(false));
        }, 1500);
    }
    return Promise.resolve();
}; };
var setForceSplashscreen = function (isShown) { return ({
    type: GalleryInfosActionKeys.SET_FORCE_SPLASH_SCREEN,
    isShown: isShown
}); };
var requestConfig = function () { return ({ type: GalleryInfosActionKeys.REQUEST_CONFIG }); };
var receiveConfig = function (data) { return ({
    type: GalleryInfosActionKeys.RECEIVE_CONFIG,
    data: data
}); };
var receiveLocalTemplate = function (data) { return ({
    type: GalleryInfosActionKeys.RECEIVE_LOCAL_TEMPLATE,
    data: data
}); };
var receiveRemoteTemplate = function (data) { return ({
    type: GalleryInfosActionKeys.RECEIVE_REMOTE_TEMPLATE,
    data: data
}); };
var setCustomCSS = function (data) { return ({
    type: GalleryInfosActionKeys.SET_CUSTOM_CSS,
    data: data
}); };


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trackerManager__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driveItem__ = __webpack_require__(11);






var StatsUtils = /** @class */ (function () {
    function StatsUtils() {
    }
    StatsUtils.updateConfig = function (config) {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        var galleryCredentials = __WEBPACK_IMPORTED_MODULE_4____["d" /* default */].getGalleryCredentials();
        trackerManager.updateConfig(config, __WEBPACK_IMPORTED_MODULE_3__userAgent__["a" /* default */].isMobileApp, galleryCredentials ? galleryCredentials : undefined);
    };
    StatsUtils.trackPageView = function (route, params) {
        var url = window.location.hash;
        if (StatsUtils.lastTrackedHash === url) {
            return;
        }
        var statsTitle = StatsUtils.getStatsTitle(route, params);
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        trackerManager.trackEvent('navigation', 'open', statsTitle);
        trackerManager.trackPage('page', url, statsTitle);
        StatsUtils.lastTrackedHash = url;
    };
    StatsUtils.trackDisplayType = function (displayType) {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        trackerManager.trackEvent('navigation', "viewMode - " + displayType, "change view mode to " + displayType);
    };
    StatsUtils.trackView = function (driveItem) {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        var viewedAsset = StatsUtils.getDriveItemInfos(driveItem);
        trackerManager.trackEvent('view', "view - " + viewedAsset, "view the asset : " + viewedAsset);
    };
    StatsUtils.trackShare = function (driveItems) {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        var splittedSharedAssets = StatsUtils.getSplittedDriveItemsInfos(driveItems);
        splittedSharedAssets.forEach(function (sharedAssets) {
            trackerManager.trackEvent('share', "share - " + sharedAssets, "share the assets : " + sharedAssets);
        });
    };
    StatsUtils.trackDownload = function (driveItems) {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        var splittedDownloadedAssets = StatsUtils.getSplittedDriveItemsInfos(driveItems);
        splittedDownloadedAssets.forEach(function (downloadedAssets) {
            trackerManager.trackEvent('download', "download - " + downloadedAssets, "download the assets : " + downloadedAssets);
        });
    };
    StatsUtils.trackDownloadAll = function () {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        trackerManager.trackEvent('download', 'download - all', 'download all assets');
    };
    StatsUtils.trackDownloadImportants = function () {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        trackerManager.trackEvent('download', 'download - importants', 'download important assets');
    };
    StatsUtils.trackDownloadSelected = function () {
        var trackerManager = __WEBPACK_IMPORTED_MODULE_0__trackerManager__["a" /* default */].getInstance();
        trackerManager.trackEvent('download', 'download - selected', 'download selected assets');
    };
    // All RoutePath must be in the switch, do not add a default case
    StatsUtils.getStatsTitle = function (route, params) {
        var castedParams;
        switch (route) {
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].Default:
                return "Home Page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].Home:
                return "Home Page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].ViewDriveItem:
                return "View Drive Item";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].Authentication:
                return "Authentication Page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].ParametersPage:
                return "Parameters Page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].ProfilePage:
                return "Profile Page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].ProposalStatsPage:
                return "My sent Page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].DriveItemListPage:
                castedParams = params;
                return StatsUtils.getDriveItemListPageTitle(castedParams);
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].TheaterList:
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].Theater:
                castedParams = params;
                return "Theater Page - " + castedParams.driveItemId;
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].DriveItemDetailPage:
                castedParams = params;
                return "Detail Page - " + castedParams.driveItemId;
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].NotFound:
                return "Page not found";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].SharePage:
                return "Share page";
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].StaticPage:
                castedParams = params;
                return "Page - " + castedParams.component;
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].Editor:
                castedParams = params;
                return "Editor - " + castedParams.clientId + " - " + castedParams.resourceId;
            case __WEBPACK_IMPORTED_MODULE_1__routes_constants__["a" /* RoutePath */].NotesPage:
                return "Notes";
        }
    };
    StatsUtils.getDriveItemListPageTitle = function (params) {
        var origin = params.origin;
        switch (origin) {
            case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads:
                return "Download Page";
            case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Selection:
                return "Selection Page";
            case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder: {
                if (!params.originParam) {
                    return "Gallery Page";
                }
                return "Folder Page - " + params.originParam;
            }
            case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].New:
                return "New Page";
            case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search:
                return "Search Page - " + params.originParam;
            case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Assortment:
                return "Assortment Page - " + params.originParam;
        }
    };
    StatsUtils.getSplittedDriveItemsInfos = function (driveItems) {
        /*
            Google analytics has a limit for event's parameters's length.
            For this reason we split the driveItemInfos so that it doesn't reach this limit.
        */
        var maxEventLabelLength = 500; // Google analytics's limit for action & label is 500 bytes
        var reservedLength = 50; // we reserve 50 chars for the constant part of the event action/label
        var maxSplitLength = maxEventLabelLength - reservedLength;
        var separator = ',';
        var splits = [''];
        var currentSplitIndex = 0;
        var currentSplitLength = 0;
        for (var i = 0; i < driveItems.length; i++) {
            var driveItem = driveItems[i];
            var driveItemInfo = "" + StatsUtils.getDriveItemInfos(driveItem) + separator;
            var driveItemInfoLength = encodeURIComponent(driveItemInfo).length;
            currentSplitLength += driveItemInfoLength;
            if (currentSplitLength < maxSplitLength) {
                splits[currentSplitIndex] += driveItemInfo;
            }
            else {
                currentSplitIndex++;
                splits[currentSplitIndex] = driveItemInfo;
                currentSplitLength = driveItemInfoLength;
            }
        }
        return splits;
    };
    StatsUtils.getDriveItemInfos = function (driveItem) {
        return __WEBPACK_IMPORTED_MODULE_5__driveItem__["d" /* default */].getDisplayName(driveItem) + "-" + driveItem.id;
    };
    return StatsUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (StatsUtils);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);


var AuthUtils = /** @class */ (function () {
    function AuthUtils() {
    }
    AuthUtils.isNotConnected = function (mode) {
        return mode
            ? mode.status === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["a" /* ConnectionStatus */].NOT_CONNECTED || mode.status === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["a" /* ConnectionStatus */].NEED_RECONNECT
            : false;
    };
    AuthUtils.isConnected = function (mode) {
        return mode ? mode.status === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["a" /* ConnectionStatus */].CONNECTED : false;
    };
    AuthUtils.isConnecting = function (mode) {
        return mode ? mode.status === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["a" /* ConnectionStatus */].CONNECTING : false;
    };
    AuthUtils.needReconnecting = function (mode) {
        return mode ? mode.status === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["a" /* ConnectionStatus */].NEED_RECONNECT : false;
    };
    AuthUtils.isOnCache = function (mode) {
        return mode ? mode.onCache === true : false;
    };
    AuthUtils.isExcel = function (mode) {
        return mode ? mode.method === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["b" /* Security */].Excel : false;
    };
    AuthUtils.isSaml = function (mode) {
        return mode ? mode.method === __WEBPACK_IMPORTED_MODULE_0__containers_Authentication_reducer__["b" /* Security */].Saml : false;
    };
    AuthUtils.isLoginView = function (viewMode) {
        return viewMode === __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Login;
    };
    AuthUtils.isMethodView = function (viewMode) {
        return viewMode === __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Method;
    };
    AuthUtils.isCreationView = function (viewMode) {
        return viewMode === __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Creation;
    };
    AuthUtils.isCompanyView = function (viewMode) {
        return viewMode === __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Company;
    };
    AuthUtils.isPasswordView = function (viewMode) {
        return viewMode === __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Password;
    };
    AuthUtils.isOrgLoginView = function (viewMode) {
        return viewMode === __WEBPACK_IMPORTED_MODULE_1__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].OrgLogin;
    };
    return AuthUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (AuthUtils);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileActionKeys; });
/* unused harmony export setProfileData */
/* unused harmony export setProfileIsLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addUserAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateUserAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeUserAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resetUserAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProfileData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return saveProfileData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activateSalesforce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCustomerContext; });
/* unused harmony export setCustomerContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_statistics_trackerManager__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__ = __webpack_require__(21);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;






var ProfileActionKeys;
(function (ProfileActionKeys) {
    ProfileActionKeys["SET_DATA"] = "@@profile/SET_DATA";
    ProfileActionKeys["SET_IS_LOADING"] = "@@profile/SET_IS_LOADING";
    ProfileActionKeys["ADD_USER_AVATAR"] = "@@profile/ADD_USER_AVATAR";
    ProfileActionKeys["UPDATE_USER_AVATAR"] = "@@profile/UPDATE_USER_AVATAR";
    ProfileActionKeys["REMOVE_USER_AVATAR"] = "@@profile/REMOVE_USER_AVATAR";
    ProfileActionKeys["RESET_USER_AVATAR"] = "@@profile/RESET_USER_AVATAR";
    ProfileActionKeys["ENABLE_CRM_PROVIDER"] = "@@profile/ENABLE_CRM_PROVIDER";
    ProfileActionKeys["SET_CUSTOMER_CONTEXT"] = "@@profile/SET_CUSTOMER_CONTEXT";
})(ProfileActionKeys || (ProfileActionKeys = {}));
var setProfileData = function (data) { return ({
    type: ProfileActionKeys.SET_DATA,
    data: data,
}); };
var setProfileIsLoading = function (isLoading) { return ({
    type: ProfileActionKeys.SET_IS_LOADING,
    isLoading: isLoading,
}); };
var addUserAvatar = function (file, isCorrectFileType) { return function (dispatch) {
    if (!isCorrectFileType) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.wrong_file_type'));
    }
    dispatch({
        type: ProfileActionKeys.ADD_USER_AVATAR,
        file: file,
        isCorrectFileType: isCorrectFileType,
    });
}; };
var updateUserAvatar = function (data) { return ({
    type: ProfileActionKeys.UPDATE_USER_AVATAR,
    data: data,
}); };
var removeUserAvatar = function () { return ({
    type: ProfileActionKeys.REMOVE_USER_AVATAR,
}); };
var resetUserAvatar = function () { return ({
    type: ProfileActionKeys.RESET_USER_AVATAR,
}); };
var enableCrmProvider = function (crmProvider) { return ({
    type: ProfileActionKeys.ENABLE_CRM_PROVIDER,
    crmProvider: crmProvider,
}); };
var getProfileData = function (clientId, shouldDisplayLoader) {
    if (shouldDisplayLoader === void 0) { shouldDisplayLoader = true; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var isOnline, data, data, trackerManager, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnlinePromise()];
                            case 1:
                                isOnline = _a.sent();
                                if (!!isOnline) return [3 /*break*/, 3];
                                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getProfileInfos()];
                            case 2:
                                data = _a.sent();
                                if (data) {
                                    dispatch(setProfileData(data));
                                }
                                resolve();
                                return [2 /*return*/];
                            case 3:
                                _a.trys.push([3, 5, 6, 7]);
                                if (shouldDisplayLoader) {
                                    dispatch(setProfileIsLoading(true));
                                }
                                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getProfileData(clientId)];
                            case 4:
                                data = _a.sent();
                                dispatch(setProfileData(data));
                                if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp) {
                                    __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].setProfileInfos(data).then();
                                }
                                trackerManager = __WEBPACK_IMPORTED_MODULE_4__utils_statistics_trackerManager__["a" /* default */].getInstance();
                                trackerManager.trackProperty('client_id', data.id.toString());
                                resolve();
                                return [3 /*break*/, 7];
                            case 5:
                                error_1 = _a.sent();
                                if (isOnline) {
                                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.fetch_profile_data_error'));
                                }
                                reject(error_1);
                                return [3 /*break*/, 7];
                            case 6:
                                dispatch(setProfileIsLoading(false));
                                return [7 /*endfinally*/];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); })];
        });
    }); };
};
var saveProfileData = function (fields) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, id, clientId, userAvatar, data, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getState().profile, id = _a.id, clientId = _a.clientId, userAvatar = _a.userAvatar;
                if (Object.keys(fields).length === 0 && !userAvatar.isEdited) {
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, 4, 5]);
                dispatch(setProfileIsLoading(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].editProfileData(id, clientId, fields, userAvatar)];
            case 2:
                data = _b.sent();
                dispatch(setProfileData(data));
                return [3 /*break*/, 5];
            case 3:
                error_2 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.save_profile_data_error'));
                return [3 /*break*/, 5];
            case 4:
                dispatch(setProfileIsLoading(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var activateSalesforce = function (clientId, clientSecret, callback) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var crmProviders, crmProvidersToSave, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                crmProviders = getState().profile.crmProviders;
                crmProvidersToSave = crmProviders.map(function (item) { return (item.provider === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].CRMProviders.SALESFORCE
                    ? __assign({}, item, { clientId: clientId, clientSecret: clientSecret }) : item); });
                return [4 /*yield*/, dispatch(saveProfileData({
                        crmProviders: crmProvidersToSave,
                    }))];
            case 1:
                _a.sent();
                // we have to enable Salesforce provider locally as server returns 'enabled: false' in response. It is set to true on server only after successful integration.
                // without this action checkbox in CRMSelector jumps to prevously selected option.
                dispatch(enableCrmProvider(__WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].CRMProviders.SALESFORCE));
                callback();
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.save_profile_data_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var getCustomerContext = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var customerContext, error_4, isOnline;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 4, 5]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getCustomerContext()];
            case 1:
                customerContext = _a.sent();
                dispatch(setCustomerContext(customerContext));
                return [3 /*break*/, 5];
            case 2:
                error_4 = _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnlinePromise()];
            case 3:
                isOnline = _a.sent();
                if (isOnline) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.fetch_profile_data_error'));
                }
                return [3 /*break*/, 5];
            case 4:
                dispatch(setProfileIsLoading(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var setCustomerContext = function (data) { return ({
    type: ProfileActionKeys.SET_CUSTOMER_CONTEXT,
    data: data,
}); };


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditableItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editableId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return editorStylesId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return editorFontsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return editorGoogleFontsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return editedMediaScriptAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SupportedParagraphStyle; });
var EditableItem;
(function (EditableItem) {
    EditableItem["Text"] = "data-uprez-text";
    EditableItem["Image"] = "data-uprez-image";
    EditableItem["Video"] = "data-uprez-video";
})(EditableItem || (EditableItem = {}));
var editableId = 'data-uprez-id';
var editorStylesId = 'editor-styles';
var editorFontsId = 'editor-fonts';
var editorGoogleFontsId = 'editor-google-fonts';
var editedMediaScriptAttribute = 'data-uprez-media-script';
var SupportedParagraphStyle;
(function (SupportedParagraphStyle) {
    SupportedParagraphStyle["LineHeight"] = "lineHeight";
    SupportedParagraphStyle["TextAlign"] = "textAlign";
})(SupportedParagraphStyle || (SupportedParagraphStyle = {}));


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PublicationSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PublicationCreationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return publicationCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(119);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var PublicationSource;
(function (PublicationSource) {
    PublicationSource["TEMPLATE"] = "TEMPLATE";
    PublicationSource["PUBLICATION"] = "PUBLICATION";
    PublicationSource["FILE"] = "FILE";
})(PublicationSource || (PublicationSource = {}));
var PublicationCreationStatus;
(function (PublicationCreationStatus) {
    PublicationCreationStatus["IMPORTING"] = "importing";
    PublicationCreationStatus["PROCESSING"] = "processing";
})(PublicationCreationStatus || (PublicationCreationStatus = {}));
var LoadingStatus;
(function (LoadingStatus) {
    LoadingStatus["NOT_LOADED"] = "NOT_LOADED";
    LoadingStatus["LOADING"] = "LOADING";
    LoadingStatus["LOADED"] = "LOADED";
})(LoadingStatus || (LoadingStatus = {}));
var creationProgressInitialState = {
    status: null,
    percentage: 0,
    error: null,
};
var source = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SHOW:
            return action.source;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return null;
        default:
            return state;
    }
};
var masterTemplatesIds = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_PUBLICATION_TEMPLATES:
            return action.masterTemplates.map(function (_a) {
                var id = _a.id;
                return id;
            });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return [];
        default:
            return state;
    }
};
var customTemplatesIds = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_PUBLICATION_TEMPLATES:
            return action.customTemplates.map(function (_a) {
                var id = _a.id;
                return id;
            });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].REMOVE_TEMPLATE_FROM_STORE:
            return state.filter(function (id) { return id !== action.id; });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return [];
        default:
            return state;
    }
};
var loadingStatus = function (state, action) {
    if (state === void 0) { state = LoadingStatus.NOT_LOADED; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].GET_PUBLICATION_TEMPLATES:
            return LoadingStatus.LOADING;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_PUBLICATION_TEMPLATES:
            return LoadingStatus.LOADED;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return LoadingStatus.NOT_LOADED;
        default:
            return state;
    }
};
var selectedTemplate = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SELECT_TEMPLATE:
            return action.data;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return null;
        default:
            return state;
    }
};
var isDisplayed = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SHOW:
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return false;
        default:
            return state;
    }
};
var requestId = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_REQUEST_ID:
            return action.requestId;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].REMOVE_FROM_CREATION_PROGRESS:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return null;
        default:
            return state;
    }
};
var name = function (state, action) {
    if (state === void 0) { state = ''; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_NAME:
            return action.name;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SELECT_TEMPLATE:
            return action.data.label + "-1";
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return '';
        default:
            return state;
    }
};
var error = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_ERROR:
            return action.error;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SELECT_TEMPLATE:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_NAME:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return null;
        default:
            return state;
    }
};
var creationProgress = function (state, action) {
    if (state === void 0) { state = creationProgressInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].SET_CREATION_STATUS:
            return __assign({}, state, { status: action.status, percentage: 0 });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].UPDATE_CREATION_PROGRESS:
            if (!state.status) {
                return state;
            }
            return __assign({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].REMOVE_FROM_CREATION_PROGRESS:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* PublicationCreatorActionKeys */].HIDE:
            return creationProgressInitialState;
        default:
            return state;
    }
};
var publicationCreator = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    source: source,
    isDisplayed: isDisplayed,
    requestId: requestId,
    fromTemplate: Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
        masterTemplatesIds: masterTemplatesIds,
        customTemplatesIds: customTemplatesIds,
        loadingStatus: loadingStatus,
        selectedTemplate: selectedTemplate,
        name: name,
        error: error,
    }),
    fromFile: creationProgress,
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BigButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NewButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var buttonCommonCss = "\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\n\t& > span {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n";
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\toutline: none;\n\tmax-width: 250px;\n\tborder: 1px solid ", ";\n\theight: 40px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\n\ttransition: border 0.2s, color 0.2s, background-color 0.2s;\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder: 1px solid ", ";\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"], ["\n\t", "\n\toutline: none;\n\tmax-width: 250px;\n\tborder: 1px solid ", ";\n\theight: 40px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\n\ttransition: border 0.2s, color 0.2s, background-color 0.2s;\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder: 1px solid ", ";\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"])), buttonCommonCss, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue300, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue300, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue300, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue300);
var BigButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\ttext-transform: uppercase;\n\tmax-width: 430px;\n\theight: 50px;\n\tborder: none;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\topacity: 1;\n\n\ttransition: opacity 0.2s;\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\topacity: 0.7;\n\t\t}\n\t}\n"], ["\n\t", "\n\ttext-transform: uppercase;\n\tmax-width: 430px;\n\theight: 50px;\n\tborder: none;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\topacity: 1;\n\n\ttransition: opacity 0.2s;\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\topacity: 0.7;\n\t\t}\n\t}\n"])), buttonCommonCss, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue300);
var NewButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 50px;\n\tborder-radius: 9px;\n\tcursor: pointer;\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tletter-spacing: 0.17px;\n\tborder: none;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 50px;\n\tborder-radius: 9px;\n\tcursor: pointer;\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tletter-spacing: 0.17px;\n\tborder: none;\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceSelectorTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ResourceSelector_DrivePicker_FromApp__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ResourceSelector_DrivePicker_FromSelection__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ImportManager__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProgressBar__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var ResourceSelectorTheme;
(function (ResourceSelectorTheme) {
    ResourceSelectorTheme["DARK"] = "DARK";
    ResourceSelectorTheme["LIGHT"] = "LIGHT";
})(ResourceSelectorTheme || (ResourceSelectorTheme = {}));
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["desktop"] = "from_desktop";
    ButtonTypes["app"] = "from_app";
    ButtonTypes["youtube"] = "from_youtube";
    ButtonTypes["selection"] = "from_selection";
    ButtonTypes["drive"] = "from_drive";
})(ButtonTypes || (ButtonTypes = {}));
var ResourceSelector = function (_a) {
    var id = _a.id, label = _a.label, isValidResourceFromApp = _a.isValidResourceFromApp, _b = _a.fileExtensions, fileExtensions = _b === void 0 ? [] : _b, isFileExtensionsDisplayed = _a.isFileExtensionsDisplayed, isOptimizedImageImport = _a.isOptimizedImageImport, isPublicationDependency = _a.isPublicationDependency, fileType = _a.fileType, isMultipleSelection = _a.isMultipleSelection, linkPanel = _a.linkPanel, isImportingFile = _a.isImportingFile, importingPercentage = _a.importingPercentage, importingError = _a.importingError, isProcessingVideo = _a.isProcessingVideo, onSelect = _a.onSelect, customImportHandler = _a.customImportHandler, onFileImportCancel = _a.onFileImportCancel, actionButtonColor = _a.actionButtonColor, isFromSelection = _a.isFromSelection, className = _a.className, _c = _a.theme, theme = _c === void 0 ? ResourceSelectorTheme.LIGHT : _c, dispatch = _a.dispatch;
    var _d;
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](''), 2), activePicker = _e[0], setActivePicker = _e[1];
    var handleSelect = function (items) {
        if (importingError) {
            handleFileImportCancel();
        }
        onSelect(items);
    };
    var handleFileImportCancel = function () {
        if (onFileImportCancel) {
            onFileImportCancel();
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_ImportManager_actions__["i" /* removeFileFromImport */])(id));
        }
    };
    var buttonsConfig = (_d = {},
        _d[ButtonTypes.desktop] = {
            label: ButtonTypes.desktop,
            component: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_ImportManager__["a" /* default */], { id: id, triggerComponent: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { as: "div", iconWidth: "21px", iconHeight: "20px" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.from_desktop" }),
                    __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_uprez_from_desktop')), extensions: fileExtensions.join(', '), onImport: function (item) { return customImportHandler ? undefined : handleSelect([item]); }, customImportHandler: customImportHandler, fileType: fileType, isOptimizedImageImport: isOptimizedImageImport, isPublicationDependency: isPublicationDependency, isMultiple: isMultipleSelection })),
        },
        _d[ButtonTypes.app] = {
            label: __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].isEmbedMode() ? ButtonTypes.drive : ButtonTypes.app,
            icon: {
                name: 'iconset_uprez_from_drive',
                width: '24px',
                height: '24px',
            },
            picker: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ResourceSelector_DrivePicker_FromApp__["a" /* default */], { isValidResource: isValidResourceFromApp, onSelect: handleSelect, onClose: function () { return setActivePicker(''); }, actionButtonColor: actionButtonColor, isMultipleSelection: isMultipleSelection, className: className })),
            onClick: function () { return setActivePicker(ButtonTypes.app); },
        },
        _d);
    if (linkPanel) {
        buttonsConfig[ButtonTypes.youtube] = {
            label: ButtonTypes.youtube,
            icon: {
                name: 'iconset_youtube_logo',
                width: '22px',
                height: '22px',
            },
            picker: linkPanel,
            onClick: function () { return setActivePicker(ButtonTypes.youtube); },
        };
    }
    if (isFromSelection) {
        buttonsConfig[ButtonTypes.selection] = {
            label: ButtonTypes.selection,
            icon: {
                name: 'iconset_favorite',
                width: '22px',
                height: '22px',
            },
            picker: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_ResourceSelector_DrivePicker_FromSelection__["a" /* default */], { isValidResource: isValidResourceFromApp, onSelect: handleSelect, onClose: function () { return setActivePicker(''); }, actionButtonColor: actionButtonColor, className: className })),
            onClick: function () { return setActivePicker(ButtonTypes.selection); },
        };
    }
    if (isImportingFile && !importingError) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ProgressBar__["a" /* default */], { percentage: importingPercentage, error: importingError, isProcessing: isProcessingVideo, processingLabel: "messages.video_processing", theme: theme, hasCancelButton: true, onCancel: handleFileImportCancel }));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeProvider */], { theme: { theme: theme } }, activePicker
        ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, buttonsConfig[activePicker].picker)
        : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            isImportingFile && importingError &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ProgressBar__["a" /* default */], { percentage: importingPercentage, error: importingError, isProcessing: isProcessingVideo, processingLabel: "messages.video_processing", theme: theme, hasCancelButton: true, onCancel: handleFileImportCancel }),
            label && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Label */], { value: label }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonsList */], null, Object.values(buttonsConfig).map(function (_a) {
                var label = _a.label, icon = _a.icon, component = _a.component, onClick = _a.onClick;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: label }, component || (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onClick, iconWidth: icon ? icon.width : '', iconHeight: icon ? icon.height : '' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages." + label }),
                    icon && __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon(icon.name)))));
            })),
            isFileExtensionsDisplayed &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* ResourceType */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.type" }), ": " + fileExtensions.map(function (item) { return item.substring(1); }).join(', '))))));
};
/* harmony default export */ __webpack_exports__["b"] = (ResourceSelector);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  var assign, isArray, isEmpty, isFunction, isObject, isPlainObject,
    slice = [].slice,
    hasProp = {}.hasOwnProperty;

  assign = function() {
    var i, key, len, source, sources, target;
    target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (isFunction(Object.assign)) {
      Object.assign.apply(null, arguments);
    } else {
      for (i = 0, len = sources.length; i < len; i++) {
        source = sources[i];
        if (source != null) {
          for (key in source) {
            if (!hasProp.call(source, key)) continue;
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };

  isFunction = function(val) {
    return !!val && Object.prototype.toString.call(val) === '[object Function]';
  };

  isObject = function(val) {
    var ref;
    return !!val && ((ref = typeof val) === 'function' || ref === 'object');
  };

  isArray = function(val) {
    if (isFunction(Array.isArray)) {
      return Array.isArray(val);
    } else {
      return Object.prototype.toString.call(val) === '[object Array]';
    }
  };

  isEmpty = function(val) {
    var key;
    if (isArray(val)) {
      return !val.length;
    } else {
      for (key in val) {
        if (!hasProp.call(val, key)) continue;
        return false;
      }
      return true;
    }
  };

  isPlainObject = function(val) {
    var ctor, proto;
    return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && (typeof ctor === 'function') && (ctor instanceof ctor) && (Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object));
  };

  module.exports.assign = assign;

  module.exports.isFunction = isFunction;

  module.exports.isObject = isObject;

  module.exports.isArray = isArray;

  module.exports.isEmpty = isEmpty;

  module.exports.isPlainObject = isPlainObject;

}).call(this);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvatarUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIsAccountManagerOrAdmin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);



var getApplicationUrl = function (state) { return state.galleryInfos.config.applicationUrl; };
var getNewAvatar = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function (state) { return state.profile.userAvatar.file; }, function (file) { return file ? URL.createObjectURL(file) : ''; });
var getCurrentAvatar = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function (state) { return state.profile.photoPath; }, getApplicationUrl, function (photoPath, applicationUrl) { return photoPath ? __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getUrlForSecuredResource(applicationUrl + "/" + photoPath) : ''; });
var getAvatarUrl = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getNewAvatar, getCurrentAvatar, function (newAvatar, currentAvatar) { return newAvatar || currentAvatar; });
var getCustomerRole = function (state) { return state.profile.role; };
var getIsAccountManager = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCustomerRole, function (role) { return ([
    __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_SAAS_ACCOUNT_MANAGER,
    __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_CONSUMER,
].includes(role)); });
var getIsAdmin = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCustomerRole, function (role) { return ([
    __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_ALL_RIGHTS,
    __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_PRODUCTION,
].includes(role)); });
var getIsAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getIsAccountManager, getIsAdmin, function (isAccountManager, isAdmin) { return isAccountManager || isAdmin; });


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThumbnailsActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setThumbnails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setThumbnailsToUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateThumbnailsIfNeeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleThumbnails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setThumbnailsWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;



var ThumbnailsActionKeys;
(function (ThumbnailsActionKeys) {
    ThumbnailsActionKeys["SET_THUMBNAILS"] = "@@editor/thumbnails/SET_THUMBNAILS";
    ThumbnailsActionKeys["SET_THUMBNAIL_VERSION"] = "@@editor/thumbnails/SET_THUMBNAIL_VERSION";
    ThumbnailsActionKeys["SET_THUMBNAILS_TO_UPDATE"] = "@@editor/thumbnails/SET_THUMBNAILS_TO_UPDATE";
    ThumbnailsActionKeys["TOGGLE_THUMBNAILS"] = "@@editor/thumbnails/TOGGLE_THUMBNAILS";
    ThumbnailsActionKeys["SET_THUMBNAILS_WIDTH"] = "@@editor/thumbnails/SET_THUMBNAILS_WIDTH";
})(ThumbnailsActionKeys || (ThumbnailsActionKeys = {}));
var setThumbnails = function (data) { return ({
    type: ThumbnailsActionKeys.SET_THUMBNAILS,
    data: data,
}); };
var setThumbnailVersion = function (positions, version) { return ({
    type: ThumbnailsActionKeys.SET_THUMBNAIL_VERSION,
    positions: positions,
    version: version,
}); };
var setThumbnailsToUpdate = function (positions) { return ({
    type: ThumbnailsActionKeys.SET_THUMBNAILS_TO_UPDATE,
    positions: positions,
}); };
var updateThumbnailsIfNeeded = function (clientId, resourceId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, type, positionsToUpdate, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                _a = getState().editor, type = _a.type, positionsToUpdate = _a.thumbnails.positionsToUpdate;
                if (!positionsToUpdate || type !== __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN) {
                    return [2 /*return*/];
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) return [3 /*break*/, 2];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].reprocessPublicationThumbs(clientId, resourceId)];
            case 1:
                _b.sent();
                dispatch(setThumbnailVersion(positionsToUpdate, Date.now()));
                dispatch(setThumbnailsToUpdate(null));
                return [3 /*break*/, 3];
            case 2:
                // do not need to wait response as editor is closed
                __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].reprocessPublicationThumbs(clientId, resourceId);
                dispatch(setThumbnailsToUpdate(null));
                _b.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                error_1 = _b.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var toggleThumbnails = function () { return ({
    type: ThumbnailsActionKeys.TOGGLE_THUMBNAILS,
}); };
var setThumbnailsWidth = function (width) { return ({
    type: ThumbnailsActionKeys.SET_THUMBNAILS_WIDTH,
    width: width,
}); };


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagesControllerActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setPageSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changePageSpread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return savePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__history__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer_history__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_htmlEditor__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_indesignEditor__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;













var PagesControllerActionKeys;
(function (PagesControllerActionKeys) {
    PagesControllerActionKeys["SET_PAGE_SPREADS"] = "@@editor/pagesController/SET_PAGE_SPREADS";
    PagesControllerActionKeys["CHANGE_PAGE_SPREAD"] = "@@editor/pagesController/CHANGE_PAGE_SPREAD";
})(PagesControllerActionKeys || (PagesControllerActionKeys = {}));
var setPageSpreads = function (pagesData, pageDimensions) { return function (dispatch, getState) {
    var _a = getState().editor.pagesController, displayMode = _a.displayMode, firstFrameMode = _a.firstFrameMode, totalPages = _a.totalPages;
    var spreads = __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["x" /* getPageSpreads */](displayMode, firstFrameMode, totalPages, pagesData, pageDimensions);
    var action = {
        type: PagesControllerActionKeys.SET_PAGE_SPREADS,
        spreads: spreads,
    };
    dispatch(action);
}; };
var changePageSpread = function (spreadIndex, shouldAddToUndos) {
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var currentSpreadIndex, action, _a, pages, _b, spreads, prevSpreadIndex, isAccessibleVersion, _c, clientId, resourceId, prevSpread, newSpread, _d, width, height;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (shouldAddToUndos) {
                        currentSpreadIndex = getState().editor.pagesController.currentSpreadIndex;
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__history__["b" /* addToUndos */])({
                            source: __WEBPACK_IMPORTED_MODULE_5__reducer_history__["a" /* Source */].CHANGE_SPREAD,
                            data: { currentSpreadIndex: currentSpreadIndex },
                        }));
                    }
                    action = {
                        type: PagesControllerActionKeys.CHANGE_PAGE_SPREAD,
                        spreadIndex: spreadIndex,
                    };
                    dispatch(action);
                    _a = getState().editor, pages = _a.pages, _b = _a.pagesController, spreads = _b.spreads, prevSpreadIndex = _b.prevSpreadIndex, isAccessibleVersion = _a.isAccessibleVersion;
                    _c = __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _c.clientId, resourceId = _c.tempGId;
                    prevSpread = !isAccessibleVersion ? spreads[prevSpreadIndex] : [prevSpreadIndex + 1];
                    newSpread = !isAccessibleVersion ? spreads[spreadIndex] : [spreadIndex + 1];
                    _d = pages[prevSpread[0]], width = _d.width, height = _d.height;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__ui__["s" /* zoomPage */])(__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* ZoomType */].FIT));
                    if (!isAccessibleVersion) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["b" /* addPage */])(spreadIndex + 1, width, height))];
                case 1:
                    _e.sent();
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["d" /* getPageHtml */])(spreadIndex + 1, resourceId))];
                case 2:
                    _e.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, Promise.all(newSpread.map(function (page) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["b" /* addPage */])(page, width, height));
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["d" /* getPageHtml */])(page, resourceId));
                    }))];
                case 4:
                    _e.sent();
                    _e.label = 5;
                case 5:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__thumbnails__["f" /* updateThumbnailsIfNeeded */])(clientId, resourceId));
                    return [2 /*return*/];
            }
        });
    }); };
};
var savePage = function (page) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var requestId, _a, type, _b, _c, defaultHtml, html, _d, sliders, backgroundData, isAccessibleVersion, _e, clientId, resourceId, editableData, backgroundDeps, htmlToSave, error_1;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 8, , 9]);
                requestId = "save-page-" + page;
                __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].cancelRequest(requestId);
                _a = getState().editor, type = _a.type, _b = page, _c = _a.pages[_b], defaultHtml = _c.defaultHtml, html = _c.html, _d = page - 1, sliders = _a.configs.pagesData[_d].sliders, backgroundData = _a.spreadBackground.pagesData, isAccessibleVersion = _a.isAccessibleVersion;
                _e = __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _e.clientId, resourceId = _e.tempGId;
                editableData = {
                    editableTextFields: __WEBPACK_IMPORTED_MODULE_6__selectors__["t" /* getPageEditableTextFields */](getState(), page),
                    editableMedia: __WEBPACK_IMPORTED_MODULE_6__selectors__["p" /* getPageEditableMedia */](getState(), page),
                    editableLinks: __WEBPACK_IMPORTED_MODULE_6__selectors__["n" /* getPageEditableLinks */](getState(), page),
                    editableButtons: __WEBPACK_IMPORTED_MODULE_6__selectors__["h" /* getPageEditableButtons */](getState(), page),
                    editableIframes: __WEBPACK_IMPORTED_MODULE_6__selectors__["l" /* getPageEditableIframes */](getState(), page),
                    editableEnrichments: __WEBPACK_IMPORTED_MODULE_6__selectors__["j" /* getPageEditableEnrichments */](getState(), page),
                    editableSliders: __WEBPACK_IMPORTED_MODULE_6__selectors__["r" /* getPageEditableSliders */](getState(), page),
                };
                backgroundDeps = backgroundData[page] && backgroundData[page].deps;
                htmlToSave = void 0;
                if (type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML) {
                    htmlToSave = __WEBPACK_IMPORTED_MODULE_8__utils_htmlEditor__["a" /* default */].getPageHtmlToSave(defaultHtml, editableData);
                }
                else if (isAccessibleVersion) {
                    htmlToSave = __WEBPACK_IMPORTED_MODULE_9__utils_indesignEditor__["a" /* default */].getAccessiblePageHtmlToSave(defaultHtml, editableData);
                }
                else {
                    htmlToSave = __WEBPACK_IMPORTED_MODULE_9__utils_indesignEditor__["a" /* default */].getPageHtmlToSave(defaultHtml, editableData, sliders, backgroundDeps);
                }
                if (!isAccessibleVersion) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_12__utils_api__["a" /* default */].saveEditedAccessiblePage(clientId, resourceId, page, htmlToSave, requestId)];
            case 1:
                _f.sent();
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["f" /* parseIndesignEditorPage */])(page, htmlToSave, resourceId, undefined))];
            case 2:
                _f.sent();
                return [3 /*break*/, 7];
            case 3:
                if (!(type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML)) return [3 /*break*/, 5];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_12__utils_api__["a" /* default */].saveHtmlEditorPage(clientId, resourceId, htmlToSave)];
            case 4:
                _f.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_12__utils_api__["a" /* default */].saveIndesignEditorPage(clientId, resourceId, page, htmlToSave, requestId)];
            case 6:
                _f.sent();
                _f.label = 7;
            case 7:
                if (!isAccessibleVersion) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["g" /* setPageData */])({
                        page: page,
                        defaultHtml: htmlToSave,
                        html: html,
                    }));
                }
                return [3 /*break*/, 9];
            case 8:
                error_1 = _f.sent();
                // status is 0 for cancelled request, no need to display a notification
                if (error_1.status !== 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__NotificationBar_actions__["c" /* createNotification */])('error.save_editor_data_error'));
                }
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestOpenLeftSideMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestCloseLeftSideMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setMenuConfigMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openCustomItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemList_New_actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiAppAuthentication_actions__ = __webpack_require__(34);










var MenuActionKeys;
(function (MenuActionKeys) {
    MenuActionKeys["REQUEST_OPEN_LEFT_MENU"] = "@@menuManager/REQUEST_OPEN_LEFT_MENU";
    MenuActionKeys["REQUEST_CLOSE_LEFT_MENU"] = "@@menuManager/REQUEST_CLOSE_LEFT_MENU";
    MenuActionKeys["SET_MENU_MODES"] = "@@menuManager/SET_MENU_MODES";
})(MenuActionKeys || (MenuActionKeys = {}));
var requestOpenLeftSideMenu = function () { return function (dispatch, getState) {
    dispatch({ type: MenuActionKeys.REQUEST_OPEN_LEFT_MENU });
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__MultiAppAuthentication_actions__["b" /* checkActiveSession */])())
        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DriveItemList_New_actions__["b" /* fetchNewDriveItems */])()); });
    // to display user info in left menu
    if (__WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].shouldGetProfileData()) {
        var clientId = getState().galleryInfos.config.clientId;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ProfilePage_actions__["e" /* getProfileData */])(clientId));
    }
}; };
var requestCloseLeftSideMenu = function () { return function (dispatch, getState) {
    var menuManager = getState().menuManager;
    if (menuManager.leftMenuIsOpen) {
        dispatch({ type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU });
    }
}; };
var setMenuConfigMode = function (screenFormat) { return function (dispatch, getState) {
    var template = getState().galleryInfos.template;
    var menuConfig = template.menu;
    if (menuConfig) {
        var menuFormat = menuConfig[screenFormat] && Object.keys(menuConfig[screenFormat]).length > 0;
        var menuModes = menuConfig[screenFormat] && menuFormat ? menuConfig[screenFormat] : menuConfig.default;
        dispatch({ type: MenuActionKeys.SET_MENU_MODES, menuModes: menuModes });
    }
}; };
var openCustomItem = function (type, target) { return function (dispatch, getState) {
    var _a = getState(), driveList = _a.driveList, downloadManager = _a.downloadManager;
    var isOnline = __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__["a" /* default */].isOnline();
    var targetId = __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getMediaId(target);
    var resolvedTarget = targetId > 0 ? targetId.toString() : target;
    var isDownloaded = __WEBPACK_IMPORTED_MODULE_7__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, parseInt(resolvedTarget, 10));
    var isAvailableItem = (type === __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Asset || type === __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Page) && (isOnline || isDownloaded);
    var isImage = driveList.driveItems[resolvedTarget] && driveList.driveItems[resolvedTarget].type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Image;
    if (type === __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Link && isOnline) {
        window.open(resolvedTarget, '_blank');
    }
    else if (type === __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Folder || isAvailableItem || isImage) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["L" /* viewDriveItem */])(driveList.driveItems[resolvedTarget], __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["c" /* DriveItemOrigin */].Menu));
    }
    else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('info.offline_download_single_asset'));
        return;
    }
}; };


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);




var TOOLTIP_DELAY = 500;
var TOOLTIP_OFFSET = {
    bottom: 10,
    right: 20
};
var Tooltip = function (props) {
    var id = props.id, text = props.text, isCustom = props.isCustom;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_tooltip__, { id: id, place: "bottom", effect: "solid", delayShow: TOOLTIP_DELAY, offset: TOOLTIP_OFFSET },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* TooltipContent */], null, isCustom
            ? text
            : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: text }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DndItemTypes; });
var DndItemTypes;
(function (DndItemTypes) {
    DndItemTypes["EDITOR_THUMBNAIL"] = "EDITOR_THUMBNAIL";
    DndItemTypes["DRIVE_ITEM"] = "DRIVE_ITEM";
    DndItemTypes["EDITABLE_SLIDE"] = "EDITABLE_SLIDE";
    DndItemTypes["NATIVE_FILE"] = "__NATIVE_FILE__";
})(DndItemTypes || (DndItemTypes = {}));


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Page__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OfflineManager_reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__ = __webpack_require__(6);









/**
 * Gets the appropriate bgMedia path based on download status.
 * If downloaded, returns offline path; otherwise returns online URL.
 * This ensures bgMedia renders immediately after download completes.
 */
var getBgMediaPath = function (driveItemId, bgMedia, bgMediaMap, config) {
    // Check if bgMedia is downloaded for this driveItem
    var bgMediaStatus = bgMediaMap[driveItemId];
    var isDownloaded = bgMediaStatus && bgMediaStatus.status === __WEBPACK_IMPORTED_MODULE_6__OfflineManager_reducer__["b" /* DownloadStatus */].DOWNLOADED;
    // If downloaded and we're on mobile app, use offline path
    if (isDownloaded && __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__["a" /* default */].isMobileApp) {
        return __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__["d" /* default */].getFolderBgMediaPath(driveItemId, bgMedia);
    }
    // Otherwise, use online URL
    return __WEBPACK_IMPORTED_MODULE_7__utils_url__["b" /* default */].getUrlFromRelUrlWithMediaParam(bgMedia, config);
};
var mapStateToProps = function (state) {
    var search = state.search, routerParamsHistory = state.routerParamsHistory, driveItems = state.driveList.driveItems, applicationGallery = state.galleryInfos.config.applicationGallery, bgMediaMap = state.offlineManager.bgMediaMap;
    var prevOriginParam = '';
    var prevRoute = routerParamsHistory[routerParamsHistory.length - 2];
    if (prevRoute && prevRoute.params.origin !== __WEBPACK_IMPORTED_MODULE_4__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search) {
        prevOriginParam = prevRoute.params.originParam;
    }
    var prevDriveItemId = prevOriginParam ? +prevOriginParam : applicationGallery;
    var isPrevDriveItemFetched = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isDriveItemFetched(prevDriveItemId);
    var backgroundColor = (isPrevDriveItemFetched && driveItems[prevDriveItemId])
        ? driveItems[prevDriveItemId].bgColor
        : '';
    var backgroundUrl = (isPrevDriveItemFetched && driveItems[prevDriveItemId])
        ? driveItems[prevDriveItemId].bgMedia
        : '';
    if (backgroundUrl) {
        backgroundUrl = getBgMediaPath(prevDriveItemId, backgroundUrl, bgMediaMap, state.galleryInfos.config);
    }
    var origin = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentOrigin(routerParamsHistory);
    var originParam = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentOriginParam(routerParamsHistory);
    if (origin) {
        var isFolder = origin === __WEBPACK_IMPORTED_MODULE_4__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder;
        var driveItemId = isFolder
            ? +originParam || applicationGallery
            : applicationGallery;
        var isDriveItemFetched = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isDriveItemFetched(driveItemId);
        if (isDriveItemFetched && driveItems[driveItemId]) {
            backgroundColor = driveItems[driveItemId].bgColor;
            backgroundUrl = driveItems[driveItemId].bgMedia;
            if (backgroundUrl) {
                backgroundUrl = getBgMediaPath(driveItemId, backgroundUrl, bgMediaMap, state.galleryInfos.config);
            }
        }
    }
    var isDefaultBackground = !backgroundColor && !backgroundUrl;
    if (isDefaultBackground) {
        backgroundUrl = driveItems[applicationGallery] ? driveItems[applicationGallery].bgMedia : '';
        if (backgroundUrl) {
            backgroundUrl = getBgMediaPath(applicationGallery, backgroundUrl, bgMediaMap, state.galleryInfos.config);
        }
    }
    return {
        showSearchField: search.isShown,
        origin: origin,
        originParam: originParam,
        backgroundUrl: backgroundUrl,
        backgroundColor: backgroundColor,
        isVideoBackground: backgroundUrl &&
            __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__["d" /* default */].videoExtensions.includes("." + __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getFileExtension(backgroundUrl)),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Page__["a" /* default */]));


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ParametersPageButton; });
/* unused harmony export CancelButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InfosFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CheckboxWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_styles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Share_UprezForm_styles__ = __webpack_require__(340);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var InfosFields = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Share_UprezForm_styles__["h" /* FormFieldContainer */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-weight: ", ";\n\twidth: calc(100% - 30px);\n\tpadding: 0 15px;\n\tfont-size: 15px;\n\tletter-spacing: 0.2px;\n\tjustify-content: space-between;\n\tcursor: pointer;\n"], ["\n\tfont-weight: ", ";\n\twidth: calc(100% - 30px);\n\tpadding: 0 15px;\n\tfont-size: 15px;\n\tletter-spacing: 0.2px;\n\tjustify-content: space-between;\n\tcursor: pointer;\n"])), function (props) { return props.isActive ? '700' : '400'; });
var ButtonContainer = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n\tjustify-content: center;\n\tmargin: auto;\n\n\t@media ", " {\n\t\tflex-direction: column;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n\tjustify-content: center;\n\tmargin: auto;\n\n\t@media ", " {\n\t\tflex-direction: column;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Smartphone);
var ParametersPageButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Button_styles__["c" /* NewButton */])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin: 35px 15px 0 15px;\n\twidth: auto;\n\tmin-width: 360px;\n\n\t@media ", " {\n\t\talign-self: center;\n\t}\n\n\t@media ", " {\n\t\tmargin: 25px 0 0;\n\t\twidth: 100%;\n\t\tmin-width: auto;\n\t}\n"], ["\n\tmargin: 35px 15px 0 15px;\n\twidth: auto;\n\tmin-width: 360px;\n\n\t@media ", " {\n\t\talign-self: center;\n\t}\n\n\t@media ", " {\n\t\tmargin: 25px 0 0;\n\t\twidth: 100%;\n\t\tmin-width: auto;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortrait);
var CancelButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(ParametersPageButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["",
    ""])), Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\n\t& > span {\n\t\twidth: 50%;\n\t}\n\n\t& > svg {\n\t\theight: 25px;\n\t\twidth: 25px;\n\t\tanimation: ", ";\n\t}\n"], ["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\n\t& > span {\n\t\twidth: 50%;\n\t}\n\n\t& > svg {\n\t\theight: 25px;\n\t\twidth: 25px;\n\t\tanimation: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_0__utils_style__["e" /* spin */]));
var CheckboxWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin: 20px auto;\n"], ["\n\tmargin: 20px auto;\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(361);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(75);
var createDesc = __webpack_require__(158);
module.exports = __webpack_require__(74) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(57);
var hide = __webpack_require__(106);
var has = __webpack_require__(105);
var SRC = __webpack_require__(159)('src');
var $toString = __webpack_require__(653);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(47).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(381);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(384);
var defined = __webpack_require__(191);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppInfosActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initializeApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setUserLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return acceptCookie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_setLocales__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_appType__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;












var AppInfosActionKeys;
(function (AppInfosActionKeys) {
    AppInfosActionKeys["ACCEPT_COOKIE"] = "@@app/ACCEPT_COOKIE";
    AppInfosActionKeys["SET_APP_TYPE"] = "@@app/SET_APP_TYPE";
    AppInfosActionKeys["SET_USER_LOCALE"] = "@@app/SET_USER_LOCALE";
})(AppInfosActionKeys || (AppInfosActionKeys = {}));
var getAppType = function () {
    return __WEBPACK_IMPORTED_MODULE_9__utils_appType__["a" /* default */].isMultiApp ?
        __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* AppType */].Multiple :
        __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* AppType */].Single;
};
var initializeApp = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var appType, isOpenedFilesFolderExist, storedCredentials, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 8, , 9]);
                appType = getAppType();
                dispatch({ type: AppInfosActionKeys.SET_APP_TYPE, appType: appType });
                if (!__WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isMobileApp) return [3 /*break*/, 5];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_8__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* openedFilesFolder */])];
            case 1:
                isOpenedFilesFolderExist = _a.sent();
                if (isOpenedFilesFolderExist) {
                    __WEBPACK_IMPORTED_MODULE_8__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + __WEBPACK_IMPORTED_MODULE_3__utils__["h" /* openedFilesFolder */]);
                }
                return [4 /*yield*/, migrateGlobalLocalStorageToIndexedDB()];
            case 2:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].getMultiAppCredentials()];
            case 3:
                storedCredentials = _a.sent();
                if (!storedCredentials) return [3 /*break*/, 5];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__MultiAppAuthentication_actions__["l" /* updateCredentials */])(storedCredentials))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                if (!(appType === __WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* AppType */].Multiple)) return [3 /*break*/, 7];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__MultiAppAuthentication_actions__["f" /* initializeMultiAppAuthentication */])())];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.initialization_fail'));
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}); }; };
var setUserLocale = function (locale, hasPrefix, setStorage) {
    if (setStorage === void 0) { setStorage = true; }
    return function (dispatch) {
        if (setStorage) {
            __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setUserLocale(locale, hasPrefix).then();
        }
        dispatch({ type: AppInfosActionKeys.SET_USER_LOCALE, locale: locale });
        Object(__WEBPACK_IMPORTED_MODULE_1__store_setLocales__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */], locale);
    };
};
var acceptCookie = function () { return ({
    type: AppInfosActionKeys.ACCEPT_COOKIE,
}); };
// At first login, move any existing global localStorage data to IndexedDB
var migrateGlobalLocalStorageToIndexedDB = function () { return __awaiter(_this, void 0, void 0, function () {
    var wasIndexedDBInitialized, allOk, prevLocalStorageMultiAppCredentials, prevLocalStorageGalleryConfig, prevLocalStorageProfileInfos, prevLocalStorageUserLocale, prevLocalStorageMultiAppServer, error_2, error_3, error_4, error_5, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].wasIndexedDBInitialized(false)];
            case 1:
                wasIndexedDBInitialized = _a.sent();
                if (!!wasIndexedDBInitialized) return [3 /*break*/, 24];
                allOk = true;
                prevLocalStorageMultiAppCredentials = __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].getMultiAppCredentials();
                prevLocalStorageGalleryConfig = __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].getStoreGalleryConfig();
                prevLocalStorageProfileInfos = __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].getProfileInfos();
                prevLocalStorageUserLocale = __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].getUserLocale(false);
                prevLocalStorageMultiAppServer = __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].getMultiAppServer();
                if (!prevLocalStorageMultiAppCredentials) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setMultiAppCredentials(prevLocalStorageMultiAppCredentials)];
            case 3:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].removeMultiAppCredentials();
                return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                console.error('Failed to migrate multi app credentials to IndexedDB', error_2);
                allOk = false;
                return [3 /*break*/, 5];
            case 5:
                if (!prevLocalStorageGalleryConfig) return [3 /*break*/, 9];
                _a.label = 6;
            case 6:
                _a.trys.push([6, 8, , 9]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setGalleryConfig(prevLocalStorageGalleryConfig)];
            case 7:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].removeStoreGalleryConfig();
                return [3 /*break*/, 9];
            case 8:
                error_3 = _a.sent();
                console.error('Failed to migrate gallery config to IndexedDB', error_3);
                allOk = false;
                return [3 /*break*/, 9];
            case 9:
                if (!prevLocalStorageProfileInfos) return [3 /*break*/, 13];
                _a.label = 10;
            case 10:
                _a.trys.push([10, 12, , 13]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setProfileInfos(prevLocalStorageProfileInfos)];
            case 11:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].removeProfileInfos();
                return [3 /*break*/, 13];
            case 12:
                error_4 = _a.sent();
                console.error('Failed to migrate profile infos to IndexedDB', error_4);
                allOk = false;
                return [3 /*break*/, 13];
            case 13:
                if (!prevLocalStorageUserLocale) return [3 /*break*/, 17];
                _a.label = 14;
            case 14:
                _a.trys.push([14, 16, , 17]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setUserLocale(prevLocalStorageUserLocale, false)];
            case 15:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].removeUserLocale(false);
                return [3 /*break*/, 17];
            case 16:
                error_5 = _a.sent();
                console.error('Failed to migrate user locale to IndexedDB', error_5);
                allOk = false;
                return [3 /*break*/, 17];
            case 17:
                if (!prevLocalStorageMultiAppServer) return [3 /*break*/, 21];
                _a.label = 18;
            case 18:
                _a.trys.push([18, 20, , 21]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setMultiAppServer(prevLocalStorageMultiAppServer)];
            case 19:
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_7__utils_localStorage_manager__["a" /* default */].removeMultiAppServer();
                return [3 /*break*/, 21];
            case 20:
                error_6 = _a.sent();
                console.error('Failed to migrate multi app server to IndexedDB', error_6);
                allOk = false;
                return [3 /*break*/, 21];
            case 21:
                if (!allOk) return [3 /*break*/, 23];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setIndexedDBInitialized(false)];
            case 22:
                _a.sent();
                return [3 /*break*/, 24];
            case 23:
                console.error('Failed to migrate global localStorage to IndexedDB');
                _a.label = 24;
            case 24: return [2 /*return*/];
        }
    });
}); };



/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadPreviousDownloads; });
/* unused harmony export updateDownloadInManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateDownloadStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return removeDownloadItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setRequestId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return recordDownloadProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeDependentFromDependencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return transformTemporaryDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateDependents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return startDownloadGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return finishDownloadGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setIsDeletingAllStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setIsMarkingItemForDeletion; });
/* unused harmony export addItemInManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setDownloadGroupStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeDownloadGroupToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addSelectedDownloadItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return removePendingSelectedDownloadItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return resetTotalSelectedDownloadsInManager; });
/* unused harmony export resetPendingSelectedDownloadsInManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return resetSelectedDownloadItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resetDownloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addDownloadInProgressItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeDownloadInProgressItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDownloadInProgressDependency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeDownloadInProgressDependency; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;






var Q = __webpack_require__(165);
var initPreviousDownloadGroups = function (downloadAllStatus, downloadImportantStatus, downloadSelectedStatus) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].INIT_PREVIOUS_DOWNLOAD_GROUPS,
        downloadGroupStatus: downloadAllStatus,
        downloadImportantStatus: downloadImportantStatus,
        downloadSelectedStatus: downloadSelectedStatus,
    };
};
var setDownloadGroupStatus = function (group, status) {
    __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].setDownloadGroups(group, status).then();
    return {
        type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].SET_DOWNLOAD_GROUP_STATUS,
        group: group,
        status: status,
    };
};
var startDownloadGroup = function (downloadGroupName) { return function (dispatch) {
    dispatch(setDownloadGroupStatus(downloadGroupName, __WEBPACK_IMPORTED_MODULE_0__reducer__["b" /* DownloadGroupStatus */].Started));
}; };
var finishDownloadGroup = function (downloadGroupName) { return function (dispatch) {
    dispatch(setDownloadGroupStatus(downloadGroupName, __WEBPACK_IMPORTED_MODULE_0__reducer__["b" /* DownloadGroupStatus */].Finished));
}; };
var setIsDeletingAllStatus = function (isDeletingAll) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].SET_DELETE_ALL_STATUS,
    isDeletingAll: isDeletingAll
}); };
var setIsMarkingItemForDeletion = function (isMarkingItemForDeletion) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].SET_IS_MARKING_ITEM_FOR_DELETION,
    isMarkingItemForDeletion: isMarkingItemForDeletion
}); };
var loadPreviousDownloads = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var previousDownloads, previousDownloadGroups, previousPendingSelectedDownloads;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getDownloads()];
            case 1:
                previousDownloads = _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getDownloadGroups()];
            case 2:
                previousDownloadGroups = _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getPendingSelectedDownloads()];
            case 3:
                previousPendingSelectedDownloads = _a.sent();
                if (previousDownloads && previousDownloads.length > 0) {
                    dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].INIT_DOWNLOADS,
                        downloads: previousDownloads,
                    });
                }
                if (previousDownloadGroups) {
                    dispatch(initPreviousDownloadGroups(previousDownloadGroups.all, previousDownloadGroups.important, previousDownloadGroups.selected));
                }
                if (previousPendingSelectedDownloads && previousPendingSelectedDownloads.length > 0) {
                    dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].INIT_SELECTED_DOWNLOADS,
                        pendingSelectedDownloads: previousPendingSelectedDownloads,
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
var addItemInManager = function (driveItem, mode, dependencies, dependents) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].ADD_ITEM,
    id: driveItem.id,
    mode: mode,
    dependencies: dependencies,
    dependents: dependents,
    version: driveItem.version,
}); };
var addSelectedDownloadItemInManager = function (driveItemId) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].ADD_SELECTED_DOWNLOAD_ITEM,
    driveItemId: driveItemId,
}); };
var addDownloadInProgressItem = function (driveItemId) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].ADD_DOWNLOAD_IN_PROGRESS_ITEM,
    driveItemId: driveItemId,
}); };
var addDownloadInProgressDependency = function (dependencyId) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].ADD_DOWNLOAD_IN_PROGRESS_DEPENDENCY,
    dependencyId: dependencyId,
}); };
var updateDownloadStatusInManager = function (id, status) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].UPDATE_STATUS,
    id: id,
    status: status
}); };
var updateDownloadInManager = function (driveItem, mode, dependencies, dependents) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].UPDATE_DOWNLOAD,
    id: driveItem.id,
    mode: mode,
    dependencies: dependencies,
    dependents: dependents,
    version: driveItem.version,
}); };
var setRequestId = function (id, requestId, isUpdating) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].SET_REQUEST_ID,
    id: id,
    requestId: requestId,
    isUpdating: isUpdating
}); };
var removeDownloadFromManager = function (id) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].REMOVE_DOWNLOAD,
    id: id
}); };
var removePendingSelectedDownloadFromManager = function (driveItemId) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].REMOVE_PENDING_SELECTED_DOWNLOAD_ITEM,
    driveItemId: driveItemId
}); };
var removeDownloadInProgressItem = function (driveItemId) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].REMOVE_DOWNLOAD_IN_PROGRESS_ITEM,
    driveItemId: driveItemId,
}); };
var removeDownloadInProgressDependency = function (dependencyId) { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].REMOVE_DOWNLOAD_IN_PROGRESS_DEPENDENCY,
    dependencyId: dependencyId,
}); };
var resetTotalSelectedDownloadsInManager = function () { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].RESET_TOTAL_SELECTED_DOWNLOAD_ITEMS,
}); };
var resetPendingSelectedDownloadsInManager = function () { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].RESET_PENDING_SELECTED_DOWNLOAD_ITEMS,
}); };
var resetDownloads = function () { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].RESET_DOWNLOADS,
}); };
var addItem = function (driveItem, downloadMode, dependenciesIds, dependentsIds) {
    return function (dispatch) {
        dispatch(addItemInManager(driveItem, downloadMode, dependenciesIds, dependentsIds));
        dispatch(updateDownloadsInIndexedDB());
    };
};
var updateDownloadStatus = function (id, status) {
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(updateDownloadStatusInManager(id, status))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(updateDownloadsInIndexedDB())];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
var updateDownload = function (driveItem, downloadMode, dependenciesIds, dependentsIds) {
    return function (dispatch) {
        dispatch(updateDownloadInManager(driveItem, downloadMode, dependenciesIds, dependentsIds));
        dispatch(updateDownloadsInIndexedDB());
    };
};
var removeDownloadItem = function (id) {
    return function (dispatch) {
        dispatch(removeDownloadFromManager(id));
        dispatch(updateDownloadsInIndexedDB());
    };
};
var updateDownloadsInIndexedDB = function () { return function (dispatch, getState) {
    return Q.Promise(function (resolve) {
        var downloadsToSave = [];
        var downloadManager = getState().downloadManager;
        var items = downloadManager.items;
        if (items) {
            Object.keys(items).forEach(function (key) {
                var id = parseInt(key, 10);
                var item = items[id];
                if (item && item.mode !== __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Temp) {
                    downloadsToSave.push({
                        id: id,
                        version: item.version,
                        mode: item.mode,
                        status: item.status,
                        dependencies: item.dependencies,
                        dependents: item.dependents,
                    });
                }
            });
            __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].setDownloads(downloadsToSave).then();
            resolve();
        }
        else {
            console.error('updateDownloadsInIndexedDB: items is undefined');
            resolve();
        }
    });
}; };
var addSelectedDownloadItem = function (id) {
    return function (dispatch) {
        dispatch(addSelectedDownloadItemInManager(id));
        dispatch(updatePendingSelectedDownloadsInIndexedDB()).then();
    };
};
var resetSelectedDownloadItems = function () {
    return function (dispatch) {
        dispatch(finishDownloadGroup(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].SELECTED));
        dispatch(resetPendingSelectedDownloadsInManager());
        dispatch(updatePendingSelectedDownloadsInIndexedDB()).then();
        dispatch(resetTotalSelectedDownloadsInManager());
    };
};
var removePendingSelectedDownloadItem = function (id) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch(removePendingSelectedDownloadFromManager(id))];
            case 1:
                _a.sent();
                return [4 /*yield*/, dispatch(updatePendingSelectedDownloadsInIndexedDB())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
var updatePendingSelectedDownloadsInIndexedDB = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var pendingSelectedDownloadsToSave, downloadManager, pendingSelectedDownloads;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pendingSelectedDownloadsToSave = [];
                downloadManager = getState().downloadManager;
                pendingSelectedDownloads = downloadManager.pendingSelectedDownloads;
                Object.keys(pendingSelectedDownloads).forEach(function (key) {
                    var id = parseInt(key, 10);
                    var item = pendingSelectedDownloads[id];
                    pendingSelectedDownloadsToSave.push({
                        driveItemId: item.driveItemId,
                    });
                });
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].setPendingSelectedDownloads(pendingSelectedDownloadsToSave)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
var removeDependentFromDependencies = function (driveItem) {
    return function (dispatch, getState) {
        var driveItemInDownloadManager = getState().downloadManager.items[driveItem.id];
        var dependenciesIds = driveItemInDownloadManager.dependencies;
        var dependenciesInfo = {};
        dependenciesIds.forEach(function (dependencyId) {
            dependenciesInfo[dependencyId] = {
                fromDownloadManager: getState().downloadManager.items[dependencyId],
                fromDriveList: getState().driveList.driveItems[dependencyId],
            };
        });
        for (var dependencyId in dependenciesInfo) {
            if (dependenciesInfo.hasOwnProperty(dependencyId)) {
                var _a = dependenciesInfo[dependencyId], fromDriveList = _a.fromDriveList, fromDownloadManager = _a.fromDownloadManager;
                if (fromDownloadManager !== undefined && fromDriveList !== undefined) { // prevent infinite loop when a dependency and its parent are mutually dependent of each other
                    var newDependentsId = fromDownloadManager.dependents.filter(function (dependent) { return dependent !== driveItem.id; });
                    dispatch(updateDownload(fromDriveList, fromDownloadManager.mode, fromDownloadManager.dependencies, newDependentsId));
                }
            }
        }
    };
};
var transformTemporaryDownload = function (driveItem, itemFromDownloadManager, dependentId) {
    return function (dispatch, getState) {
        var fileName = driveItem.id + "." + __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getFileExtension(driveItem.originalFile);
        var dependencies = itemFromDownloadManager.dependencies, dependents = itemFromDownloadManager.dependents;
        var downloadMode = dependentId === undefined ? __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested : __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency;
        var newDependents = __spread(dependents);
        if (dependentId !== undefined) {
            newDependents = __spread(dependents, [dependentId]);
        }
        return __WEBPACK_IMPORTED_MODULE_2__utils_nativeApi__["b" /* default */].moveFile(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* tempFolder */] + "/" + fileName, __WEBPACK_IMPORTED_MODULE_1__utils__["f" /* downloadsFolder */] + "/" + fileName)
            .then(function (result) {
            if (!result) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__NotificationBar_actions__["c" /* createNotification */])('error.download_fail', { id: driveItem.id }));
            }
            else {
                dispatch(updateDownload(driveItem, downloadMode, dependencies, newDependents));
            }
        });
    };
};
var getMostImportantMode = function (mode1, mode2) {
    var orderOfImportance = [__WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Temp, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Required];
    return orderOfImportance.indexOf(mode1) > orderOfImportance.indexOf(mode2) ? mode1 : mode2;
};
var updateDependents = function (driveItem, itemFromDownloadManager, requestedMode, dependentId) {
    return function (dispatch, getState) {
        var dependencies = itemFromDownloadManager.dependencies, dependents = itemFromDownloadManager.dependents, mode = itemFromDownloadManager.mode;
        var newDependents = __spread(dependents);
        if (dependentId !== undefined && !dependents.includes(dependentId)) {
            newDependents.push(dependentId);
        }
        var newMode = getMostImportantMode(mode, requestedMode);
        dispatch(updateDownload(driveItem, newMode, dependencies, newDependents));
        return Q.Promise.resolve({});
    };
};
var recordDownloadProgress = function (progress, id) {
    return function (dispatch, getState) {
        var downloadManager = getState().downloadManager;
        var lastProgress = downloadManager.items[id] ? downloadManager.items[id].progress : undefined;
        var lastRate = lastProgress && lastProgress.loaded && lastProgress.totalSize ? Math.round(lastProgress.loaded * 100 / lastProgress.totalSize) : 0;
        var currentRate = progress && progress.loaded && progress.totalSize ? Math.round(progress.loaded * 100 / progress.totalSize) : 0;
        if (lastRate !== currentRate) {
            dispatch({
                type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].RECORD_DOWNLOAD_PROGRESS,
                progress: progress,
                id: id
            });
        }
    };
};
var closeDownloadGroupToast = function () { return ({
    type: __WEBPACK_IMPORTED_MODULE_4__typings__["a" /* DownloadManagerActionKeys */].CLOSE_DOWNLOAD_GROUP_TOAST,
}); };



/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(215);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(167);
util.inherits = __webpack_require__(136);
/*</replacement>*/

var Readable = __webpack_require__(437);
var Writable = __webpack_require__(293);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMemoize */
/* unused harmony export createSelectorCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelector; });
/* unused harmony export createStructuredSelector */
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(299);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(935),
    getValue = __webpack_require__(938);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    isEnter: function (key) {
        return key === 'Enter';
    },
    isDelete: function (key) {
        return key === 'Delete';
    },
    isBackSpace: function (key) {
        return key === 'Backspace';
    },
    isArrowUp: function (key) {
        return key === 'ArrowUp';
    },
    isArrowDown: function (key) {
        return key === 'ArrowDown';
    },
    isArrowLeft: function (key) {
        return key === 'ArrowLeft';
    },
    isArrowRight: function (key) {
        return key === 'ArrowRight';
    },
    isEsc: function (key) {
        return key === 'Escape';
    },
});


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublicationCreatorActionKeys; });
/* unused harmony export setPublicationTemplates */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return showPublicationCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hidePublicationCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setName; });
/* unused harmony export setError */
/* unused harmony export setCreationStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return openPublicationCreatorForSaveAs; });
/* unused harmony export updateCreationProgress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeFromCreationProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPublicationTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createPublicationFromMasterTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createProposalFromDesktopFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createProposalFromDriveItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setAsTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NoSaveAsPopup_actions__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__ = __webpack_require__(11);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;












var PublicationCreatorActionKeys;
(function (PublicationCreatorActionKeys) {
    PublicationCreatorActionKeys["GET_PUBLICATION_TEMPLATES"] = "@@publicationCreator/GET_PUBLICATION_TEMPLATES";
    PublicationCreatorActionKeys["SET_PUBLICATION_TEMPLATES"] = "@@publicationCreator/SET_PUBLICATION_TEMPLATES";
    PublicationCreatorActionKeys["SHOW"] = "@@publicationCreator/SHOW";
    PublicationCreatorActionKeys["HIDE"] = "@@publicationCreator/HIDE";
    PublicationCreatorActionKeys["SELECT_TEMPLATE"] = "@@publicationCreator/SELECT_TEMPLATE";
    PublicationCreatorActionKeys["SET_NAME"] = "@@publicationCreator/SET_NAME";
    PublicationCreatorActionKeys["SET_ERROR"] = "@@publicationCreator/SET_ERROR";
    PublicationCreatorActionKeys["SET_REQUEST_ID"] = "@@publicationCreator/SET_REQUEST_ID";
    PublicationCreatorActionKeys["SET_CREATION_STATUS"] = "@@publicationCreator/SET_CREATION_STATUS";
    PublicationCreatorActionKeys["UPDATE_CREATION_PROGRESS"] = "@@publicationCreator/UPDATE_CREATION_PROGRESS";
    PublicationCreatorActionKeys["REMOVE_FROM_CREATION_PROGRESS"] = "@@publicationCreator/REMOVE_FROM_CREATION_PROGRESS";
    PublicationCreatorActionKeys["SET_AS_TEMPLATE"] = "@@publicationCreator/SET_AS_TEMPLATE";
    PublicationCreatorActionKeys["REMOVE_TEMPLATE_FROM_STORE"] = "@@publicationCreator/REMOVE_TEMPLATE_FROM_STORE";
})(PublicationCreatorActionKeys || (PublicationCreatorActionKeys = {}));
var setPublicationTemplates = function (masterTemplates, customTemplates) { return ({
    type: PublicationCreatorActionKeys.SET_PUBLICATION_TEMPLATES,
    masterTemplates: masterTemplates,
    customTemplates: customTemplates,
}); };
var showPublicationCreator = function (source) { return ({
    type: PublicationCreatorActionKeys.SHOW,
    source: source,
}); };
var hidePublicationCreator = function () { return function (dispatch) {
    dispatch(removeFromCreationProgress());
    dispatch({
        type: PublicationCreatorActionKeys.HIDE,
    });
}; };
var selectTemplate = function (data) { return ({
    type: PublicationCreatorActionKeys.SELECT_TEMPLATE,
    data: data,
}); };
var setName = function (name) { return ({
    type: PublicationCreatorActionKeys.SET_NAME,
    name: name,
}); };
var setError = function (error) { return ({
    type: PublicationCreatorActionKeys.SET_ERROR,
    error: error,
}); };
var setCreationStatus = function (status) { return ({
    type: PublicationCreatorActionKeys.SET_CREATION_STATUS,
    status: status,
}); };
var openPublicationCreatorForSaveAs = function (_a) {
    var id = _a.id, label = _a.label, format = _a.format;
    return function (dispatch) {
        dispatch(showPublicationCreator(__WEBPACK_IMPORTED_MODULE_4__reducer__["c" /* PublicationSource */].PUBLICATION));
        dispatch(selectTemplate({
            id: id,
            label: label,
            format: format,
        }));
    };
};
var updateCreationProgress = function (data) { return ({
    type: PublicationCreatorActionKeys.UPDATE_CREATION_PROGRESS,
    data: data,
}); };
var removeFromCreationProgress = function () { return function (dispatch, getState) {
    var requestId = getState().publicationCreator.requestId;
    dispatch({
        type: PublicationCreatorActionKeys.REMOVE_FROM_CREATION_PROGRESS,
    });
    if (requestId) {
        __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].cancelRequest(requestId);
    }
}; };
var getPublicationTemplates = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var templatesData, masterTemplates, customTemplates, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({
                    type: PublicationCreatorActionKeys.GET_PUBLICATION_TEMPLATES,
                });
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getPublicationTemplates()];
            case 1:
                templatesData = _a.sent();
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__DriveItemList_actions__["t" /* receiveTemplateItems */])(templatesData))];
            case 2:
                _a.sent();
                masterTemplates = templatesData.masterProposals, customTemplates = templatesData.customTemplates;
                dispatch(setPublicationTemplates(masterTemplates, customTemplates));
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                dispatch(hidePublicationCreator());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.fetch_publication_templates_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var createPublicationFromMasterTemplate = function (publicationGId, label, format) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var errorMessage, _a, clientId, applicationGallery, folderId, resource, globalId, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                errorMessage = __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].isProposal(format)
                    ? 'error.create_proposal_error'
                    : 'error.create_publication_error';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                _a = getState().galleryInfos.config, clientId = _a.clientId, applicationGallery = _a.applicationGallery;
                folderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getFolderIdForNewResource();
                if (!folderId) {
                    return [2 /*return*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])(errorMessage))];
                }
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].createPublicationFromMasterTemplate(clientId, applicationGallery, folderId, publicationGId, label)];
            case 2:
                resource = (_b.sent()).resource;
                globalId = (resource.referent || resource).globalId;
                dispatch(hidePublicationCreator());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__Editor_actions__["O" /* setParentFolderId */])(folderId));
                __WEBPACK_IMPORTED_MODULE_1__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_1__utils_routes__["a" /* default */].getPathEditor(clientId, globalId));
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(folderId, true, true, true))];
            case 3:
                _b.sent();
                return [3 /*break*/, 5];
            case 4:
                error_2 = _b.sent();
                if (__WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].isDuplicateFileNameError(error_2.responseText)) {
                    dispatch(setError('error.duplicate_file_name'));
                }
                else if (error_2.responseText.includes('PROP_SAVE_FORBIDDEN')) {
                    dispatch(hidePublicationCreator());
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__NoSaveAsPopup_actions__["c" /* openNoSaveAsPopup */])());
                }
                else {
                    dispatch(hidePublicationCreator());
                    return [2 /*return*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])(errorMessage))];
                }
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var getPublicationCreationProgress = function (folderId, clientId, globalId, status) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var onProgressUpdate, onProgressError, onProgressFinish, shouldCancelProgress, onProgressCancel, error_3;
    var _this = this;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                onProgressUpdate = function (percentage) {
                    dispatch(updateCreationProgress({
                        percentage: percentage,
                    }));
                };
                onProgressError = function () {
                    dispatch(updateCreationProgress({
                        error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].PROCESSING,
                        percentage: 100,
                    }));
                };
                onProgressFinish = function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                dispatch(updateCreationProgress({
                                    percentage: 100,
                                }));
                                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(folderId, true, true, true))];
                            case 1:
                                _a.sent();
                                dispatch(hidePublicationCreator());
                                __WEBPACK_IMPORTED_MODULE_1__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_1__utils_routes__["a" /* default */].getPathEditor(clientId, globalId));
                                return [2 /*return*/];
                        }
                    });
                }); };
                shouldCancelProgress = function (state) {
                    return !state.publicationCreator.requestId;
                };
                onProgressCancel = function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].trashResources(clientId, [globalId])];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); };
                if (!![
                    __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemStatus.LIVE,
                    __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemStatus.ERROR,
                ].includes(status)) return [3 /*break*/, 2];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getPublicationProgress(clientId, globalId, onProgressUpdate, onProgressError, onProgressFinish, shouldCancelProgress, onProgressCancel)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                if (status === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemStatus.LIVE) {
                    onProgressFinish();
                }
                if (status === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemStatus.ERROR) {
                    onProgressError();
                }
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                error_3 = _a.sent();
                dispatch(updateCreationProgress({
                    error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].IMPORT,
                    percentage: 100,
                }));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var createProposalFromDesktopFile = function (file, isCorrectFileType, requestId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var fromFile, clientId, folderId, onImportProgress, _a, globalId, status_1, error_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                fromFile = getState().publicationCreator.fromFile;
                // to remove previously selected file (e.g., with wrong type)
                if (fromFile.status) {
                    dispatch(removeFromCreationProgress());
                }
                dispatch({
                    type: PublicationCreatorActionKeys.SET_REQUEST_ID,
                    requestId: requestId,
                });
                dispatch(setCreationStatus(__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* PublicationCreationStatus */].IMPORTING));
                if (!isCorrectFileType) {
                    dispatch(updateCreationProgress({
                        error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].TYPE,
                        percentage: 100,
                    }));
                    return [2 /*return*/];
                }
                clientId = getState().galleryInfos.config.clientId;
                folderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getFolderIdForNewResource();
                if (!folderId) {
                    dispatch(hidePublicationCreator());
                    return [2 /*return*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.create_proposal_error'))];
                }
                onImportProgress = function (e) {
                    var percentage = Math.floor((e.loaded / e.total) * 100);
                    dispatch(updateCreationProgress({
                        percentage: percentage,
                    }));
                };
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].createProposalFromDesktopFile(file, clientId, folderId, onImportProgress, requestId)];
            case 1:
                _a = _b.sent(), globalId = _a.globalId, status_1 = _a.status;
                dispatch(setCreationStatus(__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* PublicationCreationStatus */].PROCESSING));
                return [4 /*yield*/, dispatch(getPublicationCreationProgress(folderId, clientId, globalId, status_1))];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                error_4 = _b.sent();
                dispatch(updateCreationProgress({
                    error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].IMPORT,
                    percentage: 100,
                }));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var createProposalFromDriveItem = function (_a, requestId) {
    var id = _a.id, label = _a.label;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var clientId, folderId, _a, globalId, status_2, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    dispatch({
                        type: PublicationCreatorActionKeys.SET_REQUEST_ID,
                        requestId: requestId,
                    });
                    dispatch(setCreationStatus(__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* PublicationCreationStatus */].IMPORTING));
                    clientId = getState().galleryInfos.config.clientId;
                    folderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getFolderIdForNewResource();
                    if (!folderId) {
                        dispatch(hidePublicationCreator());
                        return [2 /*return*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.create_proposal_error'))];
                    }
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].createProposalFromDriveItem(folderId, clientId, id, label, requestId)];
                case 1:
                    _a = _b.sent(), globalId = _a.globalId, status_2 = _a.status;
                    dispatch(setCreationStatus(__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* PublicationCreationStatus */].PROCESSING));
                    return [4 /*yield*/, dispatch(getPublicationCreationProgress(folderId, clientId, globalId, status_2))];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _b.sent();
                    dispatch(updateCreationProgress({
                        error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].IMPORT,
                        percentage: 100,
                    }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var setAsTemplate = function (clientId, id) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].setAsTemplate(clientId, id)];
            case 1:
                _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__DriveItemList_actions__["d" /* addCustomTemplate */])(id));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('info.set_as_template_success'));
                return [3 /*break*/, 3];
            case 2:
                error_6 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.set_as_template_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var removeTemplateFromStore = function (id) { return ({
    type: PublicationCreatorActionKeys.REMOVE_TEMPLATE_FROM_STORE,
    id: id,
}); };
var removeTemplate = function (clientId, id) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].removeTemplate(clientId, id)];
            case 1:
                _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__DriveItemList_actions__["u" /* removeCustomTemplate */])(id));
                dispatch(removeTemplateFromStore(id));
                return [3 /*break*/, 3];
            case 2:
                error_7 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.remove_template_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MultiAppAuthentication_actions__ = __webpack_require__(34);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var AvatarSize;
(function (AvatarSize) {
    AvatarSize[AvatarSize["SMALL"] = 65] = "SMALL";
    AvatarSize[AvatarSize["BIG"] = 110] = "BIG";
})(AvatarSize || (AvatarSize = {}));
var initialState = {
    isLoading: false,
    userAvatar: {
        file: null,
        isNew: false,
        isEdited: false,
        isRemoved: false,
        isLoaded: true,
        initialImage: null,
        config: {},
    },
};
var profile = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].SET_IS_LOADING:
            return __assign({}, state, { isLoading: action.isLoading });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].SET_DATA:
            return __assign({}, state, action.data, { userAvatar: __assign({}, state.userAvatar, { isNew: !action.data.photoPath, isEdited: false, isRemoved: false, isLoaded: true, initialImage: action.data.photoPath, config: action.data.photoConfig === null || action.data.photoConfig === undefined
                        ? {}
                        : JSON.parse(action.data.photoConfig) }) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].ADD_USER_AVATAR:
            return __assign({}, state, { userAvatar: __assign({}, state.userAvatar, { file: action.file, isNew: true, isEdited: true, isRemoved: false, isLoaded: false, config: __assign({}, state.userAvatar.config, { name: action.file.name, x: 0, y: 0, width: AvatarSize.BIG, height: AvatarSize.BIG }) }) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].UPDATE_USER_AVATAR:
            return __assign({}, state, { userAvatar: __assign({}, state.userAvatar, { isEdited: true, isLoaded: true, config: __assign({}, state.userAvatar.config, action.data) }) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].REMOVE_USER_AVATAR:
            return __assign({}, state, { photoPath: null, userAvatar: __assign({}, state.userAvatar, { file: null, isNew: false, isEdited: true, isRemoved: true, isLoaded: true, config: {} }) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].RESET_USER_AVATAR:
            return __assign({}, state, { photoPath: state.userAvatar.initialImage, userAvatar: __assign({}, state.userAvatar, { file: null, isEdited: false, config: state.photoConfig === null
                        ? {}
                        : JSON.parse(state.photoConfig) }) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].ENABLE_CRM_PROVIDER:
            return __assign({}, state, { crmProviders: state.crmProviders.map(function (item) { return (__assign({}, item, { enabled: item.provider === action.crmProvider })); }) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ProfileActionKeys */].SET_CUSTOMER_CONTEXT:
            return __assign({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_1__MultiAppAuthentication_actions__["a" /* MultiAppAuthenticationInfosActionKeys */].LOGOUT:
            return initialState;
        default:
            return state;
    }
};


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotesActionKeys; });
/* unused harmony export setLoadingStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setNotesStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleNotesEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_lib_hashHistory__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_lib_hashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_lib_hashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuManager_actions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(51);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var _this = this;












var NotesActionKeys;
(function (NotesActionKeys) {
    NotesActionKeys["GET"] = "@@notes/GET";
    NotesActionKeys["SET"] = "@@notes/SET";
    NotesActionKeys["RESET"] = "@@notes/RESET";
    NotesActionKeys["CREATE"] = "@@notes/CREATE";
    NotesActionKeys["UPDATE"] = "@@notes/UPDATE";
    NotesActionKeys["REMOVE"] = "@@notes/REMOVE";
    NotesActionKeys["SET_LOADING_STATUS"] = "@@notes/SET_LOADING_STATUS";
    NotesActionKeys["SET_STATUS"] = "@@notes/SET_STATUS";
    NotesActionKeys["TOGGLE_EDITOR"] = "@@notes/TOGGLE_EDITOR";
})(NotesActionKeys || (NotesActionKeys = {}));
var setNotes = function (items, sourceType) { return ({
    type: NotesActionKeys.SET,
    items: items,
    sourceType: sourceType,
}); };
var setLoadingStatus = function (status) { return ({
    type: NotesActionKeys.SET_LOADING_STATUS,
    status: status,
}); };
var setNotesStatus = function (status) { return ({
    type: NotesActionKeys.SET_STATUS,
    status: status,
}); };
var toggleNotesEditor = function (id) { return function (dispatch, getState) {
    var action = {
        type: NotesActionKeys.TOGGLE_EDITOR,
        id: id,
    };
    dispatch(action);
    var leftMenuIsOpen = getState().menuManager.leftMenuIsOpen;
    if (leftMenuIsOpen) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_3__MenuManager_actions__["a" /* MenuActionKeys */].REQUEST_CLOSE_LEFT_MENU });
    }
}; };
var getNotes = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var localNotes, simplifiedLocalNotes, isOnline, sharedNotes, simplifiedSharedNotes, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, 8, 9]);
                dispatch(setLoadingStatus(__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* LoadingStatus */].LOADING));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getNotes()];
            case 1:
                localNotes = _a.sent();
                simplifiedLocalNotes = localNotes
                    .filter(function (_a) {
                    var id = _a.id;
                    return !__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isSharedNote(id);
                })
                    .map(function (_a) {
                    var content = _a.content, drawing = _a.drawing, restData = __rest(_a, ["content", "drawing"]);
                    return (__assign({}, restData, { hasImage: !!drawing }));
                });
                dispatch(setNotes(simplifiedLocalNotes, __WEBPACK_IMPORTED_MODULE_10__reducer__["b" /* NotesStatus */].LOCAL));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isOnlinePromise()];
            case 2:
                isOnline = _a.sent();
                if (!isOnline) return [3 /*break*/, 5];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */].getNotes()];
            case 3:
                sharedNotes = (_a.sent()).notes;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setNotes(sharedNotes)];
            case 4:
                _a.sent();
                simplifiedSharedNotes = sharedNotes.map(function (_a) {
                    var content = _a.content, drawing = _a.drawing, restData = __rest(_a, ["content", "drawing"]);
                    return (__assign({}, restData, { hasImage: !!drawing }));
                });
                dispatch(setNotes(simplifiedSharedNotes, __WEBPACK_IMPORTED_MODULE_10__reducer__["b" /* NotesStatus */].SHARED));
                return [3 /*break*/, 6];
            case 5:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('info.offline_fetch_notes'));
                _a.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.fetch_notes_error'));
                return [3 /*break*/, 9];
            case 8:
                dispatch(setLoadingStatus(__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* LoadingStatus */].LOADED));
                return [7 /*endfinally*/];
            case 9: return [2 /*return*/];
        }
    });
}); }; };
var resetNotes = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, notes, selection, sharedNotesIds, i, noteId, isSelectedNote;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getState(), notes = _a.notes, selection = _a.selection;
                sharedNotesIds = Object.keys(notes.SHARED);
                dispatch({
                    type: NotesActionKeys.RESET,
                    sourceType: __WEBPACK_IMPORTED_MODULE_10__reducer__["b" /* NotesStatus */].LOCAL,
                });
                dispatch({
                    type: NotesActionKeys.RESET,
                    sourceType: __WEBPACK_IMPORTED_MODULE_10__reducer__["b" /* NotesStatus */].SHARED,
                });
                i = 0;
                _b.label = 1;
            case 1:
                if (!(i < sharedNotesIds.length)) return [3 /*break*/, 4];
                noteId = +sharedNotesIds[i];
                isSelectedNote = selection.notes.includes(noteId);
                if (!!isSelectedNote) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].removeNote(noteId)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var createNote = function (title, _a, drawing) {
    var formattedText = _a.formattedText;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var date, id, data, contentToRemove, drawingToRemove, restData, action;
        return __generator(this, function (_a) {
            try {
                date = Date.now();
                id = -date;
                data = {
                    id: id,
                    content: formattedText,
                    title: title,
                    drawing: drawing,
                    date: date,
                };
                __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].setNote(id, data);
                contentToRemove = data.content, drawingToRemove = data.drawing, restData = __rest(data, ["content", "drawing"]);
                action = {
                    type: NotesActionKeys.CREATE,
                    id: id,
                    data: __assign({}, restData, { hasImage: !!drawing }),
                    sourceType: __WEBPACK_IMPORTED_MODULE_10__reducer__["b" /* NotesStatus */].LOCAL,
                };
                dispatch(action);
                if (!isNotesPageOpened()) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('info.create_note_success', {
                        url: "#" + __WEBPACK_IMPORTED_MODULE_8__utils_routes__["a" /* default */].getPathNotes() + __WEBPACK_IMPORTED_MODULE_0_react_router_lib_hashHistory___default.a.getCurrentLocation().search
                    }));
                }
            }
            catch (error) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.cant_create_note'));
            }
            return [2 /*return*/];
        });
    }); };
};
var updateNote = function (id, data, shouldUpdateDate) {
    if (shouldUpdateDate === void 0) { shouldUpdateDate = true; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var currentStatus, dataToUpdate, response, modifiedOn, content, drawing, restData, action, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    currentStatus = getState().notes.currentStatus;
                    dataToUpdate = __assign({}, data, { id: id });
                    if (shouldUpdateDate && !__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isSharedNote(id)) {
                        dataToUpdate.date = Date.now();
                    }
                    if (!__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isSharedNote(id)) return [3 /*break*/, 2];
                    dispatch(setLoadingStatus(__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* LoadingStatus */].SAVING));
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */].saveNote(dataToUpdate)];
                case 1:
                    response = _a.sent();
                    modifiedOn = response.notes[0].modifiedOn;
                    dataToUpdate.modifiedOn = modifiedOn;
                    _a.label = 2;
                case 2:
                    __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].updateNote(id, dataToUpdate);
                    if (isNotesPageOpened()) {
                        content = dataToUpdate.content, drawing = dataToUpdate.drawing, restData = __rest(dataToUpdate, ["content", "drawing"]);
                        action = {
                            type: NotesActionKeys.UPDATE,
                            id: id,
                            data: __assign({}, restData, { hasImage: !!drawing }),
                            sourceType: currentStatus,
                        };
                        dispatch(action);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.cant_update_note'));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setLoadingStatus(__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* LoadingStatus */].LOADED));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
var removeNote = function (id) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var currentStatus, isSharedNote, action, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                currentStatus = getState().notes.currentStatus;
                isSharedNote = currentStatus === __WEBPACK_IMPORTED_MODULE_10__reducer__["b" /* NotesStatus */].SHARED;
                action = {
                    type: NotesActionKeys.REMOVE,
                    id: id,
                    sourceType: currentStatus,
                };
                dispatch(action);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__Selection_actions__["e" /* removeFromSelection */])([id], __WEBPACK_IMPORTED_MODULE_2__Selection_actions__["b" /* SelectionType */].NOTES));
                if (!isSharedNote) return [3 /*break*/, 2];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */].removeNote(id)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].removeNote(id)];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                error_3 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.cant_remove_note'));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var isNotesPageOpened = function () {
    var routerParamsHistory = __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].getState().routerParamsHistory;
    var currentRoute = __WEBPACK_IMPORTED_MODULE_8__utils_routes__["a" /* default */].getCurrentRoute(routerParamsHistory);
    return currentRoute.includes(__WEBPACK_IMPORTED_MODULE_9__routes_constants__["a" /* RoutePath */].NotesPage);
};


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INIT_COORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BEGIN_DRAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PUBLISH_DRAG_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return END_DRAG; });
var INIT_COORDS = 'dnd-core/INIT_COORDS';
var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = 'dnd-core/HOVER';
var DROP = 'dnd-core/DROP';
var END_DRAG = 'dnd-core/END_DRAG';

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["c"] = noop;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPlainObject;
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// cheap lodash replacements
function isFunction(input) {
  return typeof input === 'function';
}
function noop() {// noop
}

function isObjectLike(input) {
  return _typeof(input) === 'object' && input !== null;
}

function isPlainObject(input) {
  if (!isObjectLike(input)) {
    return false;
  }

  if (Object.getPrototypeOf(input) === null) {
    return true;
  }

  var proto = input;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(input) === proto;
}

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inputBoxHeight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var inputHeight = 48;
var inputBorderWidth = 1;
var inputBoxHeight = inputHeight + 2 * inputBorderWidth;
var Input = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('input')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\toutline: none;\n\tbackground-color: ", ";\n\tborder-radius: 4px;\n\tborder: ", "px solid ", ";\n\tcolor: ", ";\n\tfont-size: 14px;\n\theight: ", "px;\n\tmargin: 0;\n\tpadding: 0 20px;\n\twidth: 100%;\n\tfont-family: inherit;\n\t-webkit-appearance: none;\n\n\t&:focus,\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\t&::placeholder {\n\t\tfont-family: inherit;\n\t\tcolor: ", ";\n\t}\n\n\t&[data-error = true] {\n\t\tborder: 1px solid ", ";\n\t}\n\n\t&[data-error = true]::placeholder {\n\t\tcolor: ", ";\n\t}\n\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\toutline: none;\n\tbackground-color: ", ";\n\tborder-radius: 4px;\n\tborder: ", "px solid ", ";\n\tcolor: ", ";\n\tfont-size: 14px;\n\theight: ", "px;\n\tmargin: 0;\n\tpadding: 0 20px;\n\twidth: 100%;\n\tfont-family: inherit;\n\t-webkit-appearance: none;\n\n\t&:focus,\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\t&::placeholder {\n\t\tfont-family: inherit;\n\t\tcolor: ", ";\n\t}\n\n\t&[data-error = true] {\n\t\tborder: 1px solid ", ";\n\t}\n\n\t&[data-error = true]::placeholder {\n\t\tcolor: ", ";\n\t}\n\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].White, inputBorderWidth, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey700, inputHeight, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey400, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Red, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Red);
var TextArea = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('textarea')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\toutline: none;\n\tbackground-color: ", ";\n\tborder-radius: 4px;\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tfont-size: 14px;\n\theight: 68px;\n\tmargin: 0;\n\tpadding: 20px 20px;\n\twidth: 100%;\n\tfont-family: inherit;\n\tresize: none;\n\n\t-webkit-appearance: none;\n\toverflow: auto;//IE override\n\n\t&:focus,\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\t&::placeholder {\n\t\tfont-family: inherit;\n\t\tcolor: ", ";\n\t}\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-top: 10px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\toutline: none;\n\tbackground-color: ", ";\n\tborder-radius: 4px;\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tfont-size: 14px;\n\theight: 68px;\n\tmargin: 0;\n\tpadding: 20px 20px;\n\twidth: 100%;\n\tfont-family: inherit;\n\tresize: none;\n\n\t-webkit-appearance: none;\n\toverflow: auto;//IE override\n\n\t&:focus,\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\t&::placeholder {\n\t\tfont-family: inherit;\n\t\tcolor: ", ";\n\t}\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-top: 10px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey700, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey400, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].SmallDesktop);

var templateObject_1, templateObject_2;


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HeaderBlock_styles__ = __webpack_require__(341);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        _this.state = { isOpened: props.isOpened };
        return _this;
    }
    Accordion.prototype.render = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, children = _a.children, selectedOption = _a.selectedOption;
        var isOpened = this.state.isOpened;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* StyledAccordion */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* AccordionHeader */], { onClick: this.toggle },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* AccordionTitle */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HeaderBlock_styles__["e" /* Title */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: title })),
                    subtitle &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HeaderBlock_styles__["d" /* Subtitle */], null, subtitle),
                    selectedOption &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HeaderBlock_styles__["c" /* Option */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: selectedOption }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* ToggleButton */], { isOpened: isOpened }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_down'))),
            isOpened &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    children,
                    " ")));
    };
    Accordion.prototype.toggle = function () {
        this.setState({ isOpened: !this.state.isOpened });
    };
    return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Accordion);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonsGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: ", "px;\n\tpadding: 0 12px;\n\tborder-bottom: 1px solid ", ";\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\n\t", "\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: ", "px;\n\tpadding: 0 12px;\n\tborder-bottom: 1px solid ", ";\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\n\t", "\n\t", "\n"])), __WEBPACK_IMPORTED_MODULE_2__styles__["e" /* HEADER_HEIGHT */], Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey450, 50), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isEmbedMode() && 'padding-right: 20px;', __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMacApp() && "padding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";");
var ButtonsGroup = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\n\t& + & {\n\t\tmargin-left: 20px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\n\t& + & {\n\t\tmargin-left: 20px;\n\t}\n"])));
var HeaderButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 35px;\n\twidth: 35px;\n\theight: 35px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t", "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t\tmargin: 0;\n\t}\n\n\t& + & {\n\t\tmargin-left: 6px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 35px;\n\twidth: 35px;\n\theight: 35px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t",
    "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t\tmargin: 0;\n\t}\n\n\t& + & {\n\t\tmargin-left: 6px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 12), function (_a) {
    var color = _a.color;
    return color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
}, function (_a) {
    var iconWidth = _a.iconWidth;
    return iconWidth;
}, function (_a) {
    var iconHeight = _a.iconHeight;
    return iconHeight;
});

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopupBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PopupInputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PopupInputLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(36);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var ButtonsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 30px;\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 30px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Button */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100px;\n\tfont-size: 15px;\n\tjustify-content: center;\n\n\t&:disabled {\n\t\topacity: 0.5;\n\t\tpointer-events: none;\n\t}\n\n\t& + & {\n\t\tmargin-left: 10px;\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 0;\n\t}\n"], ["\n\twidth: 100px;\n\tfont-size: 15px;\n\tjustify-content: center;\n\n\t&:disabled {\n\t\topacity: 0.5;\n\t\tpointer-events: none;\n\t}\n\n\t& + & {\n\t\tmargin-left: 10px;\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 0;\n\t}\n"])));
var PopupBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding: 20px;\n\tcolor: ", ";\n"], ["\n\tpadding: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var PopupInputLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-bottom: 5px;\n\tfont-size: 14px;\n\tline-height: 18px;\n\tcolor: ", ";\n"], ["\n\tdisplay: block;\n\tmargin-bottom: 5px;\n\tfont-size: 14px;\n\tline-height: 18px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var PopupInputWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", " {\n\t\tborder-color: transparent;\n\t\tbackground-color: ", ";\n\t\tfont-size: 16px;\n\t\tcolor: ", ";\n\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t}\n\t}\n\n\t", "\n"], ["\n\t", " {\n\t\tborder-color: transparent;\n\t\tbackground-color: ", ";\n\t\tfont-size: 16px;\n\t\tcolor: ", ";\n\n\t\t&:hover {\n\t\t\tborder-color: ",
    ";\n\t\t}\n\t}\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_4__Form_styles__["a" /* Input */], Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 10), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, function (_a) {
    var isError = _a.isError;
    return isError
        ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].LightRed
        : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White;
}, function (_a) {
    var isError = _a.isError;
    return isError && "\n\t\t" + __WEBPACK_IMPORTED_MODULE_4__Form_styles__["a" /* Input */] + " {\n\t\t\tborder-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].LightRed + ";\n\t\t}\n\n\t\t" + PopupInputLabel + " {\n\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].LightRed + ";\n\t\t}\n\t";
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(720);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(721);
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(723);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(724);
/* unused harmony reexport IndexRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(92);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(272);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(274);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(726);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(411);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(132);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(731);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(732);
/* unused harmony reexport browserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(410);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(48);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(93);

var _Actions = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Security; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectionStatus; });
/* harmony export (immutable) */ __webpack_exports__["c"] = authentication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var Security;
(function (Security) {
    Security["Excel"] = "EXCEL";
    Security["Saml"] = "SAML";
})(Security || (Security = {}));
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["CONNECTED"] = "connected";
    ConnectionStatus["CONNECTING"] = "connecting";
    ConnectionStatus["NEED_RECONNECT"] = "need_reconnect";
    ConnectionStatus["NOT_CONNECTED"] = "not_connected";
})(ConnectionStatus || (ConnectionStatus = {}));
var initialUserInfosState = {
    needCredentials: false,
    login: '',
    password: '',
    mode: undefined
};
var initialState = {
    form: {
        login: '',
        password: '',
    },
    userInfos: initialUserInfosState
};
function authentication(state, action) {
    if (state === void 0) { state = initialState; }
    var newState = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(state);
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AuthenticationActionKeys */].SET_FORM_LOGIN:
            newState.form.login = action.value;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AuthenticationActionKeys */].SET_FORM_PASSWORD:
            newState.form.password = action.value;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AuthenticationActionKeys */].UPDATE_CREDENTIALS:
            newState.userInfos = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(action.userInfos);
            return newState;
        default:
            return state;
    }
}


/***/ }),
/* 136 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoaderStepName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoaderType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(815);



var Translate = __webpack_require__(5).Translate;
var LoaderStepName;
(function (LoaderStepName) {
    LoaderStepName["Creating"] = "Creating";
    LoaderStepName["Downloading"] = "Downloading";
    LoaderStepName["DownloadingDependencies"] = "DownloadingDependencies";
    LoaderStepName["DownloadingAll"] = "DownloadingAll";
    LoaderStepName["LoggingIn"] = "LoggingIn";
    LoaderStepName["Deleting"] = "Deleting";
    LoaderStepName["DeletingDependencies"] = "DeletingDependencies";
})(LoaderStepName || (LoaderStepName = {}));
var LoaderType;
(function (LoaderType) {
    LoaderType["Button"] = "Button";
    LoaderType["Overlay"] = "Overlay";
    LoaderType["ListItem"] = "ListItem";
})(LoaderType || (LoaderType = {}));
var Loader = function (props) {
    var loaderStep = props.loaderStep, type = props.type, isDownloadInProgress = props.isDownloadInProgress, isUpdating = props.isUpdating, isDeletionInProgress = props.isDeletionInProgress, isMarkingItemForDeletion = props.isMarkingItemForDeletion;
    var StyledLoader = __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* LoaderVariants */][type];
    if (type === LoaderType.ListItem) {
        if (loaderStep.step === LoaderStepName.Downloading) {
            var progress = loaderStep.progress;
            var progressValue = '';
            if (progress && progress.loaded && progress.totalSize && !!+progress.totalSize) {
                var progressNumber = Math.floor(progress.loaded * 100 / progress.totalSize);
                progressValue = Math.min(100, progressNumber) + "%";
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledLoader, { step: loaderStep.step },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    isDownloadInProgress && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { key: "loading", value: "messages.loading" }),
                    progressValue)));
        }
        if (loaderStep.step === LoaderStepName.DownloadingDependencies) {
            var dependenciesDownloaded = loaderStep.dependenciesDownloaded, dependenciesToDownload = loaderStep.dependenciesToDownload;
            var message = '';
            if (isUpdating) {
                message = 'messages.updating_asset';
            }
            else if (dependenciesToDownload < 2) {
                message = 'messages.dependency_downloaded_out_of';
            }
            else {
                message = 'messages.dependencies_downloaded_out_of';
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledLoader, { step: loaderStep.step },
                isDownloadInProgress && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: message, dependenciesDownloaded: dependenciesDownloaded, dependenciesToDownload: dependenciesToDownload })));
        }
        if (isMarkingItemForDeletion) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledLoader, { step: LoaderStepName.Deleting },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    isDeletionInProgress && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.deleting" }))));
        }
        if (loaderStep.step === LoaderStepName.Deleting) {
            var progress = loaderStep.progress;
            var progressValue = '';
            if (progress && progress.loaded && progress.totalSize && !!+progress.totalSize) {
                var progressNumber = Math.floor(progress.loaded * 100 / progress.totalSize);
                progressValue = Math.min(100, progressNumber) + "%";
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledLoader, { step: loaderStep.step },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    isDeletionInProgress && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.deleting" }),
                    progressValue)));
        }
        if (loaderStep.step === LoaderStepName.DeletingDependencies) {
            var dependenciesDeleted = loaderStep.dependenciesDeleted, dependenciesToDelete = loaderStep.dependenciesToDelete;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledLoader, { step: loaderStep.step },
                isDeletionInProgress && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.dependencies_deleted_out_of", dependenciesDeleted: dependenciesDeleted, dependenciesToDelete: dependenciesToDelete })));
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledLoader, { step: loaderStep.step },
        __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
        getLoadingMessage(loaderStep)));
};
var getLoadingMessage = function (loaderStep) {
    switch (loaderStep.step) {
        case LoaderStepName.Downloading:
            var progress = loaderStep.progress;
            return [
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { key: "loading", value: "messages.loading" }),
                progress && progress.loaded && progress.totalSize && !!+progress.totalSize && Math.floor(progress.loaded * 100 / progress.totalSize) + "%",
            ];
        case LoaderStepName.DownloadingDependencies:
            var dependenciesDownloaded = loaderStep.dependenciesDownloaded, dependenciesToDownload = loaderStep.dependenciesToDownload;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: dependenciesToDownload < 2 ? 'messages.dependency_downloaded_out_of' : 'messages.dependencies_downloaded_out_of', dependenciesDownloaded: dependenciesDownloaded, dependenciesToDownload: dependenciesToDownload }));
        case LoaderStepName.DownloadingAll:
            var itemsDownloaded = loaderStep.itemsDownloaded, itemsToDownload = loaderStep.itemsToDownload;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: itemsToDownload < 2 ? 'messages.item_downloaded_out_of' : 'messages.items_downloaded_out_of', itemsDownloaded: itemsDownloaded, itemsToDownload: itemsToDownload }));
        case LoaderStepName.Creating:
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.create_demo_account" });
        case LoaderStepName.LoggingIn:
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.logging_in" });
        default:
            return;
    }
};
/* harmony default export */ __webpack_exports__["c"] = (Loader);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ValidationUtils = /** @class */ (function () {
    function ValidationUtils() {
    }
    ValidationUtils.isValidEmail = function (email) {
        var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegex.test(email);
    };
    ValidationUtils.isValidUrl = function (url) {
        var urlRegex = /^http(s)?:\/\/(www\.)?.+[.].+$/;
        return urlRegex.test(url);
    };
    ValidationUtils.isGoogleAnalyticsUaCode = function (value) {
        var uaCodeRegex = /^UA-\d{4,10}-\d{1,4}$|^G-[A-Z0-9]+$/;
        return uaCodeRegex.test(value);
    };
    return ValidationUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (ValidationUtils);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpreadBackgroundActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSpreadBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveSpreadBackgroundPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setIsSpreadBackgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateSpreadBackgroundServiceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return importSlidesToSpreadBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__history__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer_history__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer_configs__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImportManager_actions__ = __webpack_require__(44);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;










var SpreadBackgroundActionKeys;
(function (SpreadBackgroundActionKeys) {
    SpreadBackgroundActionKeys["SET_SPREAD_BACKGROUND"] = "@@editor/spreadBackground/SET_SPREAD_BACKGROUND";
    SpreadBackgroundActionKeys["SET_IS_SPREAD_BACKGROUND_ACTIVE"] = "@@editor/spreadBackground/SET_IS_SPREAD_BACKGROUND_ACTIVE";
    SpreadBackgroundActionKeys["UPDATE_SPREAD_BACKGROUND_SERVICE_DATA"] = "@@editor/spreadBackground/UPDATE_SPREAD_BACKGROUND_SERVICE_DATA";
})(SpreadBackgroundActionKeys || (SpreadBackgroundActionKeys = {}));
var setSpreadBackground = function (spread, data, isGeneralBgData, shouldSave, shouldSetIsEdited, shouldAddToUndos) {
    if (shouldSave === void 0) { shouldSave = true; }
    if (shouldSetIsEdited === void 0) { shouldSetIsEdited = true; }
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = getState().editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, pagesData = _a.configs.pagesData;
            var page = spreads[currentSpreadIndex][0];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].SPREAD_BACKGROUND,
                data: pagesData[page - 1].bgStyle,
                page: page,
            }));
        }
        var action = {
            type: SpreadBackgroundActionKeys.SET_SPREAD_BACKGROUND,
            spread: spread,
            data: data,
            isGeneralBgData: isGeneralBgData,
            shouldSetIsEdited: shouldSetIsEdited,
        };
        dispatch(action);
        if (shouldSave) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__configs__["b" /* saveConfigs */])());
        }
    };
};
var saveSpreadBackgroundPages = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, spreads, currentSpreadIndex, spread;
    return __generator(this, function (_b) {
        _a = getState().editor.pagesController, spreads = _a.spreads, currentSpreadIndex = _a.currentSpreadIndex;
        spread = spreads[currentSpreadIndex];
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__thumbnails__["c" /* setThumbnailsToUpdate */])(spread));
        spread.forEach(function (page) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__pagesController__["c" /* savePage */])(page)); });
        return [2 /*return*/];
    });
}); }; };
var setIsSpreadBackgroundActive = function (isActive) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var isEdited, action;
    return __generator(this, function (_a) {
        isEdited = getState().editor.spreadBackground.isEdited;
        action = {
            type: SpreadBackgroundActionKeys.SET_IS_SPREAD_BACKGROUND_ACTIVE,
            isActive: isActive,
        };
        dispatch(action);
        if (!isActive && isEdited) {
            dispatch(saveSpreadBackgroundPages());
        }
        return [2 /*return*/];
    });
}); }; };
var updateSpreadBackgroundServiceData = function (page, data, shouldSave, shouldUpdateThumbnails) {
    if (shouldSave === void 0) { shouldSave = true; }
    return function (dispatch) {
        var action = {
            type: SpreadBackgroundActionKeys.UPDATE_SPREAD_BACKGROUND_SERVICE_DATA,
            page: page,
            data: data,
        };
        dispatch(action);
        if (shouldUpdateThumbnails) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
        }
        if (shouldSave) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__pagesController__["c" /* savePage */])(page));
        }
    };
};
var importSlidesToSpreadBackground = function (page, newSlidesData, isFromDesktop) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, spreads, currentSpreadIndex, pagesData, spread, backgroundData, currentMedia, defaultMedia, prevSlides, prevImportingSlides, newImportingSlides, importingSlides, _loop_1;
    var _this = this;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getState().editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, pagesData = _a.spreadBackground.pagesData;
                spread = spreads[currentSpreadIndex];
                backgroundData = Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["w" /* getSpreadBgData */])(getState(), spread) || Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["d" /* getGeneralBgData */])(getState());
                currentMedia = backgroundData.currentMedia, defaultMedia = backgroundData.defaultMedia;
                prevSlides = (currentMedia && currentMedia.type === __WEBPACK_IMPORTED_MODULE_5__reducer_configs__["a" /* BackgroundMediaType */].SLIDER && 'slides' in currentMedia
                    ? currentMedia
                    : defaultMedia).slides;
                prevImportingSlides = pagesData[page] && pagesData[page].importingSlides || [];
                newImportingSlides = __spread(prevImportingSlides, newSlidesData);
                dispatch(updateSpreadBackgroundServiceData(page, {
                    importingSlides: newImportingSlides,
                }, false));
                importingSlides = newImportingSlides;
                _loop_1 = function () {
                    var slideData, slideId, file, _a, pagesData_1, byId, currentImportingSlides, getSlidesWithoutImportError;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                slideData = importingSlides[0];
                                if (!isFromDesktop) return [3 /*break*/, 2];
                                slideId = slideData.id, file = slideData.file;
                                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__ImportManager_actions__["h" /* importFile */])({
                                        id: slideId,
                                        file: file,
                                        isOptimizedImageImport: true,
                                        isPublicationDependency: true,
                                        onImport: function (_a) {
                                            var id = _a.id;
                                            return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0: return [4 /*yield*/, dispatch(addSlide(page, slideData, id))];
                                                        case 1: return [2 /*return*/, _b.sent()];
                                                    }
                                                });
                                            });
                                        },
                                    }))];
                            case 1:
                                _b.sent();
                                return [3 /*break*/, 4];
                            case 2: return [4 /*yield*/, dispatch(addSlide(page, slideData))];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4:
                                _a = getState(), pagesData_1 = _a.editor.spreadBackground.pagesData, byId = _a.importManager.byId;
                                currentImportingSlides = pagesData_1 && pagesData_1[page].importingSlides || [];
                                getSlidesWithoutImportError = (function (_a) {
                                    var id = _a.id;
                                    return (byId[id] ? !byId[id].error : true);
                                });
                                importingSlides = currentImportingSlides.filter(getSlidesWithoutImportError);
                                return [2 /*return*/];
                        }
                    });
                };
                _c.label = 1;
            case 1:
                if (!(importingSlides.length > 0)) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _c.sent();
                return [3 /*break*/, 1];
            case 3:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__configs__["b" /* saveConfigs */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__pagesController__["c" /* savePage */])(page));
                if (prevSlides.length === 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
                }
                return [2 /*return*/];
        }
    });
}); }; };
var addSlide = function (page, slideData, resourceGlobalId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var slideId, globalId, aspDriveItem, type, label, relUrl, genericItemId, globalId_1, resolution, iconName, newSlideData, _a, _b, spreads, currentSpreadIndex, pagesData, spread, backgroundData, sliderData, importingSlides, deps, isGeneralBgData;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                slideId = slideData.id, globalId = slideData.globalId;
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DriveItemList_actions__["k" /* getAspDriveItem */])(resourceGlobalId || globalId))];
            case 1:
                aspDriveItem = _c.sent();
                if (aspDriveItem) {
                    type = aspDriveItem.type, label = aspDriveItem.label, relUrl = aspDriveItem.relUrl, genericItemId = aspDriveItem.genericItemId, globalId_1 = aspDriveItem.globalId, resolution = aspDriveItem.resolution, iconName = aspDriveItem.iconName;
                    newSlideData = __assign({}, slideData, { type: type,
                        label: label, relUrl: Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getMediaUrl */])(relUrl), genericItemId: genericItemId,
                        globalId: globalId_1,
                        resolution: resolution,
                        iconName: iconName });
                    _a = getState().editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, pagesData = _a.spreadBackground.pagesData;
                    spread = spreads[currentSpreadIndex];
                    backgroundData = Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["w" /* getSpreadBgData */])(getState(), spread) || Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["d" /* getGeneralBgData */])(getState());
                    sliderData = backgroundData.currentMedia;
                    importingSlides = pagesData[page] && pagesData[page].importingSlides || [];
                    deps = pagesData[page] && pagesData[page].deps || [];
                    isGeneralBgData = !Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["w" /* getSpreadBgData */])(getState(), spread) && !!Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["d" /* getGeneralBgData */])(getState());
                    dispatch(updateSpreadBackgroundServiceData(page, {
                        importingSlides: importingSlides.filter(function (_a) {
                            var id = _a.id;
                            return id !== slideId;
                        }),
                        deps: __spread(deps, [Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* getDependencyString */])(newSlideData.globalId)]),
                    }, false));
                    dispatch(setSpreadBackground(spread, __assign({}, sliderData, { slides: __spread(sliderData.slides, [newSlideData]) }), isGeneralBgData, false, false));
                    return [2 /*return*/];
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__ImportManager_actions__["d" /* addFileInImport */])(slideId, {
                        error: __WEBPACK_IMPORTED_MODULE_9__ImportManager_actions__["a" /* FileError */].IMPORT,
                    }));
                    return [2 /*return*/, { isError: true }];
                }
                return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(98),
    isKey = __webpack_require__(926),
    stringToPath = __webpack_require__(929),
    toString = __webpack_require__(953);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(178),
    getRawTag = __webpack_require__(927),
    objectToString = __webpack_require__(928);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchDriveItemActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchDriveItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleSearchFieldVisibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);






var SearchDriveItemActionKeys;
(function (SearchDriveItemActionKeys) {
    SearchDriveItemActionKeys["REQUEST_SEARCH"] = "@@searchDriveItem/REQUEST_SEARCH";
    SearchDriveItemActionKeys["RECEIVE_SEARCH"] = "@@searchDriveItem/RECEIVE_SEARCH";
    SearchDriveItemActionKeys["RESET_SEARCH"] = "@@searchDriveItem/RESET_SEARCH";
    SearchDriveItemActionKeys["TOGGLE_SEARCH_FIELD_VISIBILITY"] = "@@searchDriveItem/TOGGLE_SEARCH_FIELD_VISIBILITY";
})(SearchDriveItemActionKeys || (SearchDriveItemActionKeys = {}));
var searchDriveItems = function (searchString) {
    if (searchString === void 0) { searchString = ''; }
    return function (dispatch, getState) {
        dispatch(requestSearch(searchString));
        var isMaster = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMaster(getState().galleryInfos.config);
        if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline() && !isMaster) {
            if (searchString) {
                __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getSearch(searchString)
                    .then(function (contentBlock) {
                    if (contentBlock.resolutions) {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["s" /* receiveResolutions */])(contentBlock.resolutions));
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["r" /* receiveDriveItems */])(contentBlock.metas));
                    dispatch(receiveSearch(contentBlock.ordered));
                })
                    .catch(function () {
                    dispatch(resetSearch());
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.search_error'));
                });
            }
            else {
                if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* getAllDriveItems */])())
                        .then(function (driveItemIds) { return dispatch(receiveSearch(driveItemIds)); });
                }
                else {
                    dispatch(receiveSearch([]));
                }
            }
        }
        else {
            var driveList = getState().driveList;
            var driveItems_1 = driveList.driveItems;
            var driveItemsArray = Object.keys(driveItems_1).map(function (key) { return driveItems_1[parseInt(key, 10)]; });
            var filteredArray = driveItemsArray
                .filter(function (driveItem) {
                if (driveItem.isInGallery === false) {
                    return false;
                }
                if (searchString) {
                    return __WEBPACK_IMPORTED_MODULE_1__utils_driveItem__["d" /* default */].containsString(driveItem, searchString);
                }
                return true;
            })
                .sort(function (a, b) { return Date.parse(b.creationDate) - Date.parse(a.creationDate); });
            dispatch(receiveSearch(filteredArray.map(function (driveItem) { return driveItem.id; })));
        }
    };
};
var requestSearch = function (searchString) { return ({
    type: SearchDriveItemActionKeys.REQUEST_SEARCH,
    searchString: searchString,
}); };
var receiveSearch = function (driveItemIds) { return ({
    type: SearchDriveItemActionKeys.RECEIVE_SEARCH,
    driveItemIds: driveItemIds
}); };
var resetSearch = function () { return ({
    type: SearchDriveItemActionKeys.RESET_SEARCH,
}); };
var toggleSearchFieldVisibility = function () { return ({
    type: SearchDriveItemActionKeys.TOGGLE_SEARCH_FIELD_VISIBILITY
}); };


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["d"] = without;
/* unused harmony export isString */
/* harmony export (immutable) */ __webpack_exports__["c"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["e"] = xor;
/* harmony export (immutable) */ __webpack_exports__["b"] = intersection;
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// cheap lodash replacements

/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */
function get(obj, path, defaultValue) {
  return path.split('.').reduce(function (a, c) {
    return a && a[c] ? a[c] : defaultValue || null;
  }, obj);
}
/**
 * drop-in replacement for _.without
 */

function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
/**
 * drop-in replacement for _.isString
 * @param input
 */

function isString(input) {
  return typeof input === 'string';
}
/**
 * drop-in replacement for _.isString
 * @param input
 */

function isObject(input) {
  return _typeof(input) === 'object';
}
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */

function xor(itemsA, itemsB) {
  var map = new Map();

  var insertItem = function insertItem(item) {
    return map.set(item, map.has(item) ? map.get(item) + 1 : 1);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  map.forEach(function (count, key) {
    if (count === 1) {
      result.push(key);
    }
  });
  return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */

function intersection(itemsA, itemsB) {
  return itemsA.filter(function (t) {
    return itemsB.indexOf(t) > -1;
  });
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // suppress the useLayoutEffect warning on server side.

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getDecoratedComponent;
/* unused harmony export isClassComponent */
/* unused harmony export isRefForwardingComponent */
/* harmony export (immutable) */ __webpack_exports__["c"] = isRefable;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDecoratorArguments;
function getDecoratedComponent(instanceRef) {
  var currentRef = instanceRef.current;

  if (currentRef == null) {
    return null;
  } else if (currentRef.decoratedRef) {
    // go through the private field in decorateHandler to avoid the invariant hit
    return currentRef.decoratedRef.current;
  } else {
    return currentRef;
  }
}
function isClassComponent(Component) {
  return Component && Component.prototype && typeof Component.prototype.render === 'function';
}
function isRefForwardingComponent(C) {
  return C && C.$$typeof && C.$$typeof.toString() === 'Symbol(react.forward_ref)';
}
function isRefable(C) {
  return isClassComponent(C) || isRefForwardingComponent(C);
}
function checkDecoratorArguments(functionName, signature) {
  if (false) {
    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i++) {
      var arg = i + 2 < 2 || arguments.length <= i + 2 ? undefined : arguments[i + 2];

      if (arg && arg.prototype && arg.prototype.render) {
        // eslint-disable-next-line no-console
        console.error('You seem to be applying the arguments in the wrong order. ' + "It should be ".concat(functionName, "(").concat(signature, ")(Component), not the other way around. ") + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
        return;
      }
    }
  }
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MenuManager_Header_Logo__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_menuManager__ = __webpack_require__(54);






var mapStateToProps = function (state, ownProps) {
    var galleryInfos = state.galleryInfos, offlineManager = state.offlineManager, appInfos = state.appInfos, routerParamsHistory = state.routerParamsHistory, _a = state.driveList, driveItems = _a.driveItems, resolutions = _a.resolutions, thumbMap = state.offlineManager.thumbMap;
    var icon = ownProps.icon, label = ownProps.label;
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].isMultiApp(appInfos);
    var brandLogoUrl = icon
        ? Object(__WEBPACK_IMPORTED_MODULE_5__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveItems, galleryInfos.config, thumbMap, resolutions)
        : __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getBrandLogoUrl(galleryInfos, offlineManager, false, isMultiApp);
    var brandUrl = label || galleryInfos.template && galleryInfos.template.brand && galleryInfos.template.brand.url;
    var currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
    var isCurrentPageHome = __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].doesRoutesContainsPath(__WEBPACK_IMPORTED_MODULE_3__routes_constants__["a" /* RoutePath */].Home, currentRoute.routes);
    return {
        brandLogoUrl: brandLogoUrl,
        brandUrl: brandUrl,
        isCurrentPageHome: isCurrentPageHome
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4__components_MenuManager_Header_Logo__["a" /* default */]));


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useClickOutside = function (ref, shouldListen, callback) {
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!shouldListen) {
            return;
        }
        var handleClickOutside = function (e) {
            if (ref.current && !ref.current.contains(e.target)) {
                callback();
            }
        };
        window.addEventListener('pointerdown', handleClickOutside);
        return function () {
            window.removeEventListener('pointerdown', handleClickOutside);
        };
    }, [ref, shouldListen, callback]);
};
/* harmony default export */ __webpack_exports__["a"] = (useClickOutside);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return StyledAuthentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ExcelAuthenticationContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SamlIframeOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SamlAuthenticationIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AuthenticationHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AuthenticationContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return blockButtonsStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AuthenticationForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AuthenticationButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticateButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AuthenticationInputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthenticateFormInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_styles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledAuthentication = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var ExcelAuthenticationContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n"], ["\n"])));
var SamlIframeOrigin;
(function (SamlIframeOrigin) {
    SamlIframeOrigin["App"] = "app";
    SamlIframeOrigin["Authentication"] = "authentication";
})(SamlIframeOrigin || (SamlIframeOrigin = {}));
var SamlAuthenticationIframe = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('iframe')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\tborder: none;\n\ttop: 0;\n\tleft: 0;\n\t", "\n"], ["\n\tposition: absolute;\n\tborder: none;\n\ttop: 0;\n\tleft: 0;\n\t",
    "\n"])), function (props) {
    switch (props.origin) {
        case SamlIframeOrigin.App:
            return ("width: 10%;\n\t\t\t\t\theight: 10%;\n\t\t\t\t\tdisplay: none;");
        case SamlIframeOrigin.Authentication:
            return ("width: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tright: 0;");
    }
});
var AuthenticationHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\tz-index: 5;\n\tdisplay: flex;\n\tbox-sizing: border-box;\n\tpadding: 0 15px;\n\twidth: 100%;\n\theight: ", ";\n\tborder: 0;\n\tborder-bottom: 1px solid ", ";\n\tjustify-content: center;\n\talign-items: center;\n\n\t> * {\n\t\tflex-grow: 1;\n\t\tflex-basis: 33%;\n\t}\n\n\t@media ", ", ", " {\n\t\tpadding: 0 5px;\n\t}\n"], ["\n\tbackground-color: ", ";\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\tz-index: 5;\n\tdisplay: flex;\n\tbox-sizing: border-box;\n\tpadding: 0 15px;\n\twidth: 100%;\n\theight: ", ";\n\tborder: 0;\n\tborder-bottom: 1px solid ", ";\n\tjustify-content: center;\n\talign-items: center;\n\n\t> * {\n\t\tflex-grow: 1;\n\t\tflex-basis: 33%;\n\t}\n\n\t@media ", ", ", " {\n\t\tpadding: 0 5px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["h" /* navBarHeight */], __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey200, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Tablet);
var AuthenticationContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"], ["\n\tflex-grow: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"])));
var blockButtonsStyle = "\n\twidth: 100%;\n\tmax-width: 300px;\n\tbox-sizing: border-box;\n";
var AuthenticationForm = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('form')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), blockButtonsStyle);
var authenticateEnabledColor = __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Blue800;
var authenticateDisabledColor = __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey400;
var AuthenticationButtonWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 30px;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 30px;\n"])));
var AuthenticateButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Button_styles__["b" /* Button */])(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmax-height: 33px;\n\tmargin: 0 auto;\n\tborder-radius: 24px;\n\twidth: auto;\n\tpadding: 0 30px;\n\tfont-size: 14px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 400;\n\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"], ["\n\tdisplay: inline-block;\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmax-height: 33px;\n\tmargin: 0 auto;\n\tborder-radius: 24px;\n\twidth: auto;\n\tpadding: 0 30px;\n\tfont-size: 14px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 400;\n\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"])), function (props) { return !props.disabled ? authenticateEnabledColor : authenticateDisabledColor; }, function (props) { return !props.disabled ? authenticateEnabledColor : authenticateDisabledColor; }, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return !props.disabled ? authenticateEnabledColor : authenticateDisabledColor; }, function (props) { return !props.disabled ? authenticateEnabledColor : authenticateDisabledColor; }, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White);
var AuthenticationInputWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\theight: 60px;\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\tjustify-content: flex-end;\n\tpadding-top: 5px;\n\tposition: relative;\n"], ["\n\theight: 60px;\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\tjustify-content: flex-end;\n\tpadding-top: 5px;\n\tposition: relative;\n"])));
var AuthenticateFormInput = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Form_styles__["a" /* Input */])(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\theight: 43px;\n\t&[name=password] {\n\t\tpadding-right: 40px;\n\t}\n\t&::-ms-reveal {\n\t\tdisplay: none;\n\t}\n"], ["\n\theight: 43px;\n\t&[name=password] {\n\t\tpadding-right: 40px;\n\t}\n\t&::-ms-reveal {\n\t\tdisplay: none;\n\t}\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TitleWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledBottomBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BottomBarBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BottomBarHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return bottomBarColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VideoBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__ = __webpack_require__(71);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var PageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tcolor: ", ";\n\tpadding-top: ", ";\n\tbackground: ", ";\n\n\t", "\n\n\t", "\n\n\t", "\n\n\t", "\n\n\t", "\n\n\t@media print {\n\t\tcolor: #000;\n\t\tbackground: #fff;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tcolor: ", ";\n\tpadding-top: ", ";\n\tbackground: ",
    ";\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n\n\t@media print {\n\t\tcolor: #000;\n\t\tbackground: #fff;\n\t}\n"])), function (props) { return props.theme.primary.strongColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], function (_a) {
    var pageType = _a.pageType, isVideoBackground = _a.isVideoBackground, backgroundColor = _a.backgroundColor, theme = _a.theme;
    return pageType === __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].DrivePage && isVideoBackground
        ? 'none'
        : (backgroundColor || theme.primary.backgroundColor);
}, function (_a) {
    var pageType = _a.pageType, backgroundUrl = _a.backgroundUrl, isVideoBackground = _a.isVideoBackground;
    return pageType === __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].DrivePage && backgroundUrl && !isVideoBackground &&
        "background: url(" + backgroundUrl + ");\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: cover;\n\t\tbackground-position: center;";
}, function (props) { return props.isScrollable &&
    "-webkit-overflow-scrolling: touch;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;"; }, function (props) {
    return [
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].NotFoundPage,
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].ParametersPage,
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].ProfilePage,
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].ProposalStatsPage,
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].NotesPage,
    ].includes(props.pageType) &&
        "padding: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */] + " 50px 50px;\n\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\t\tpadding: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */] + " 25px 10px;\n\t\t}";
}, function (props) { return props.pageType === __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].StaticPage &&
    "padding: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */] + " 0 0;"; }, function (props) {
    return [
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].ProposalStatsPage,
        __WEBPACK_IMPORTED_MODULE_2__containers_Page_constants__["a" /* PageType */].NotesPage,
    ].includes(props.pageType) &&
        "display: flex;\n\t\t\tflex-direction: column;\n\t\t\toverflow-y: hidden;\n\t\t\tpadding-bottom: 0;\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\t\t\tpadding-bottom: 0;\n\t\t\t}";
});
var TitleWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding-top: 20px;\n\tpadding-bottom: 15px;\n\n\t@media ", ", ", " {\n\t\tpadding-top: 15px;\n\t}\n"], ["\n\tpadding-top: 20px;\n\tpadding-bottom: 15px;\n\n\t@media ", ", ", " {\n\t\tpadding-top: 15px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape);
var BottomBarHeight = '60px';
var bottomBarColor = __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey700;
var StyledBottomBar = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbackdrop-filter: blur(10px);\n\theight: ", ";\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"], ["\n\tbackdrop-filter: blur(10px);\n\theight: ", ";\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"])), BottomBarHeight);
var BottomBarBackground = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\theight: 100%;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n"], ["\n\theight: 100%;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["d" /* blurredBackgroundColor */]);
var VideoBackground = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('video')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: absolute;\n\tz-index: -1;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: auto;\n\theight: auto;\n\tmin-width: 100%;\n\tmin-height: 100%;\n\tpointer-events: none;\n\tobject-fit: cover;\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: absolute;\n\tz-index: -1;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: auto;\n\theight: auto;\n\tmin-width: 100%;\n\tmin-height: 100%;\n\tpointer-events: none;\n\tobject-fit: cover;\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DriveItemList__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Theater__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NavigationListItem__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_driveItem__ = __webpack_require__(11);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var AbstractDriveItemListPage = /** @class */ (function (_super) {
    __extends(AbstractDriveItemListPage, _super);
    function AbstractDriveItemListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.hasShareButton = false;
        _this.hasDownloadButton = false;
        _this.hasBottomBar = false;
        _this.showUnreadBadge = false;
        _this.state = {
            navigationItems: [],
        };
        return _this;
    }
    AbstractDriveItemListPage.prototype.componentDidMount = function () {
        this.initializeView(this.props);
    };
    AbstractDriveItemListPage.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.params !== nextProps.params) {
            this.initializeView(nextProps);
        }
    };
    AbstractDriveItemListPage.prototype.renderNavigationItems = function () {
        var _a = this.props, isEditMode = _a.driveList.isEditMode, displayType = _a.displayType;
        var navigationItems = this.state.navigationItems;
        return navigationItems.map(function (item) {
            var image = item.image;
            if (item.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Directory) {
                var defaultFolderIcon = __WEBPACK_IMPORTED_MODULE_12__utils_driveItem__["d" /* default */].getDefaultFolderIcon();
                if (defaultFolderIcon) {
                    image = __WEBPACK_IMPORTED_MODULE_12__utils_driveItem__["d" /* default */].getDefaultFolderIconPath(defaultFolderIcon);
                }
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_NavigationListItem__["a" /* default */], { key: "navItem-" + item.label, itemLabel: "messages." + item.label, type: item.type, navigationPath: item.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Directory
                    ? __WEBPACK_IMPORTED_MODULE_8__utils_routes__["a" /* default */].getPathDriveItemListPage(item.origin, null)
                    : undefined, url: item.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.ExternalLink
                    ? item.url
                    : undefined, image: image, displayType: displayType, isEditMode: isEditMode }));
        });
    };
    AbstractDriveItemListPage.prototype.render = function () {
        var _a = this.props, params = _a.params, isReadOnlyApp = _a.isReadOnlyApp;
        var navigationItems = this.state.navigationItems;
        var driveItemId = params.driveItemId, origin = params.origin;
        var driveFolderId = this.getDriveFolderId();
        var driveItemIds = this.getDriveItemIds();
        var resolvedDriveItemIds = this.getResolvedDriveItemIds(driveItemIds);
        var theaterDriveItemIds = this.getTheaterDriveItemIds(resolvedDriveItemIds);
        var isFetching = this.isFetching(resolvedDriveItemIds);
        this.leavePage = this.leavePage.bind(this);
        var driveItemsStore = this.props.driveList.driveItems;
        var driveItems = resolvedDriveItemIds.map(function (id) { return driveItemsStore[id]; });
        var filteredDriveItems = driveItems.filter(function (item) { return item !== undefined; });
        var hasNoItems = !isFetching &&
            resolvedDriveItemIds.length < 1 &&
            navigationItems.length < 1 &&
            this.getAdditionalItemsLength() < 1;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Page__["a" /* default */], { driveItems: filteredDriveItems, hasBottomBar: this.hasBottomBar, isScrollable: false, pageType: __WEBPACK_IMPORTED_MODULE_10__Page_constants__["a" /* PageType */].DrivePage },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ListPageWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__DriveItemList__["a" /* default */], { hasBottomBar: this.hasBottomBar, params: params, driveItemIdsToDisplay: resolvedDriveItemIds, folderId: driveFolderId, isFetching: isFetching, showUnreadBadge: this.showUnreadBadge, title: this.headerLabel, navigationItems: this.renderNavigationItems(), additionalItems: this.renderAdditionalItems(), isFilesDndEnabled: !isReadOnlyApp, shouldDisplayFilesToast: !isReadOnlyApp }),
                    hasNoItems &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* NoItemsContainer */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: this.noItemsLabel })))),
            driveItemId &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Theater__["a" /* default */], { origin: origin, sliderKey: this.sliderKey, driveItemId: parseInt(driveItemId, 10), driveItemIds: theaterDriveItemIds, isLoading: isFetching, leavePage: this.leavePage, folderId: driveFolderId })));
    };
    AbstractDriveItemListPage.prototype.isFetching = function (driveItemIds) {
        var _a = this.props.driveList, driveItemsFetchStatus = _a.driveItemsFetchStatus, driveItems = _a.driveItems;
        for (var i = 0; i < driveItemIds.length; i++) {
            var driveItemId = driveItemIds[i];
            var driveItemFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveItemsFetchStatus, driveItemId);
            var metaFetchStatus = driveItemFetchStatus.metaFetchStatus;
            if ((!driveItems[driveItemId] && metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_2__DriveItemList_reducer__["a" /* FetchStatus */].ERROR) || metaFetchStatus === __WEBPACK_IMPORTED_MODULE_2__DriveItemList_reducer__["a" /* FetchStatus */].FETCHING) {
                return true;
            }
        }
        return false;
    };
    AbstractDriveItemListPage.prototype.getTheaterDriveItemIds = function (driveItemIds) {
        var driveFolderId = this.getDriveFolderId();
        var driveItemsStore = this.props.driveList.driveItems;
        var filteredDriveItemIds = [];
        if (driveFolderId) {
            var driveFolder = driveItemsStore[driveFolderId];
            if (driveFolder) {
                var resources = driveFolder.resources;
                return resources ? resources.filter(function (resource) { return resource.type !== __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Directory; }).map(function (resource) { return resource.id; }) : [];
            }
        }
        else {
            for (var i = 0; i < driveItemIds.length; i++) {
                var driveItemId = driveItemIds[i];
                var driveItem = driveItemsStore[driveItemId];
                if (driveItem) {
                    if (driveItem.type !== __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Directory) {
                        filteredDriveItemIds.push(driveItemId);
                    }
                }
            }
        }
        return filteredDriveItemIds;
    };
    // Filter the list and remove the one that have fetch error (forbidden, expired, deleted, ...)
    AbstractDriveItemListPage.prototype.getResolvedDriveItemIds = function (driveItemIds) {
        var driveItemsFetchStatus = this.props.driveList.driveItemsFetchStatus;
        return driveItemIds.filter(function (driveItemId, index, self) {
            if (self.indexOf(driveItemId) !== index) {
                // Skip duplicate items
                return false;
            }
            var driveItemFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveItemsFetchStatus, driveItemId);
            var metaFetchStatus = driveItemFetchStatus.metaFetchStatus;
            return metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_2__DriveItemList_reducer__["a" /* FetchStatus */].ERROR;
        });
    };
    AbstractDriveItemListPage.prototype.getDriveFolderId = function (props) {
        if (props === void 0) { props = this.props; }
        var galleryId = props.galleryId, params = props.params;
        var origin = params.origin, originParam = params.originParam;
        if (origin === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DriveItemListOrigin */].Folder) {
            return originParam ? parseInt(originParam, 10) : galleryId;
        }
        return;
    };
    AbstractDriveItemListPage.prototype.leavePage = function () {
        var _a = this.props, galleryId = _a.galleryId, params = _a.params;
        var originParam = params.originParam;
        var origin = this.props.params.origin;
        if (origin === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DriveItemListOrigin */].Folder && originParam === galleryId.toString()) {
            originParam = '';
        }
        window.location.hash = "" + __WEBPACK_IMPORTED_MODULE_8__utils_routes__["a" /* default */].getPathDriveItemListPage(origin, originParam || null);
    };
    Object.defineProperty(AbstractDriveItemListPage.prototype, "sliderKey", {
        get: function () {
            var _a = this.props.params, origin = _a.origin, originParam = _a.originParam;
            return "" + origin + (originParam ? '-' + originParam : '');
        },
        enumerable: true,
        configurable: true
    });
    return AbstractDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AbstractDriveItemListPage);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_LinkPanel__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, spreads = _a.pagesController.spreads, type = _a.type, byId = state.importManager.byId;
    var isUrlLinkOnly = ownProps.isUrlLinkOnly;
    return __assign({}, ownProps, { spreads: spreads, isUrlLinkOnly: isUrlLinkOnly !== undefined ? isUrlLinkOnly : type === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].HTML, isImporting: !!byId.linkPanel });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_LinkPanel__["a" /* default */]));


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_ThemesPanel__ = __webpack_require__(1545);


var mapStateToProps = function (state) {
    var _a = state.editor, themes = _a.themes, selectedThemeId = _a.selectedThemeId;
    return {
        themes: themes,
        selectedThemeId: selectedThemeId,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_ThemesPanel__["a" /* default */]));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(257);
var core = __webpack_require__(90);
var ctx = __webpack_require__(1565);
var hide = __webpack_require__(1567);
var has = __webpack_require__(617);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(259)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(383);
var enumBugKeys = __webpack_require__(267);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(265);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Locales; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_i18n__);

var Locales;
(function (Locales) {
    Locales["fr_FR"] = "FR";
    Locales["en_UK"] = "UK";
    Locales["es_ES"] = "ES";
    Locales["ca_ES"] = "CA";
    Locales["de_DE"] = "DE";
    Locales["pt_PT"] = "PT";
    Locales["it_IT"] = "IT";
})(Locales || (Locales = {}));
var DEFAULT_LOCALE = 'fr_FR';
var locales = {
    en_UK: __webpack_require__(775),
    es_ES: __webpack_require__(776),
    ca_ES: __webpack_require__(777),
    fr_FR: __webpack_require__(778),
    de_DE: __webpack_require__(779),
    pt_PT: __webpack_require__(780),
    it_IT: __webpack_require__(781),
};
var getResolvedLocale = function (requestedLocale) {
    var availableLocales = Object.keys(locales);
    if (availableLocales.includes(requestedLocale)) {
        // returns the exact locale if available
        return requestedLocale;
    }
    var localeRegex = /^([a-z][a-z])_([A-Z][A-Z])$/;
    var regexMatch = localeRegex.exec(requestedLocale);
    if (!!regexMatch && !!regexMatch[1]) {
        var requestedLanguage = regexMatch[1];
        var requestedLanguageIndex = availableLocales.indexOf(requestedLanguage);
        if (requestedLanguageIndex >= 0) {
            // returns the requested language
            return availableLocales[requestedLanguageIndex];
        }
        for (var i = 0; i < availableLocales.length; i++) {
            var availableLocale = availableLocales[i];
            var regexMatch_1 = localeRegex.exec(availableLocale);
            if (!!regexMatch_1 && !!regexMatch_1[1]) {
                var availableLanguage = regexMatch_1[1];
                if (availableLanguage === requestedLanguage) {
                    // returns a locale with the requested language
                    return availableLocale;
                }
            }
        }
    }
    return DEFAULT_LOCALE;
};
/* harmony default export */ __webpack_exports__["b"] = (function (store, locale) {
    if (locale === void 0) { locale = DEFAULT_LOCALE; }
    var resolvedLocale = getResolvedLocale(locale);
    Object(__WEBPACK_IMPORTED_MODULE_0_react_redux_i18n__["syncTranslationWithStore"])(store);
    store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux_i18n__["loadTranslations"])(locales));
    store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux_i18n__["setLocale"])(resolvedLocale));
});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2017 Kris Kowal under the terms of the MIT
 * license found at https://github.com/kriskowal/q/blob/v1/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    "use strict";

    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.

    // Montage Require
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);

    // CommonJS
    } else if (true) {
        module.exports = definition();

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
        define(definition);

    // SES (Secure EcmaScript)
    } else if (typeof ses !== "undefined") {
        if (!ses.ok()) {
            return;
        } else {
            ses.makeQ = definition;
        }

    // <script>
    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
        // Prefer window over self for add-on scripts. Use self for
        // non-windowed contexts.
        var global = typeof window !== "undefined" ? window : self;

        // Get the `window` object, save the previous Q global
        // and initialize Q as a global.
        var previousQ = global.Q;
        global.Q = definition();

        // Add a noConflict function so Q can be removed from the
        // global namespace.
        global.Q.noConflict = function () {
            global.Q = previousQ;
            return this;
        };

    } else {
        throw new Error("This environment was not anticipated by Q. Please file a bug.");
    }

})(function () {
"use strict";

var hasStacks = false;
try {
    throw new Error();
} catch (e) {
    hasStacks = !!e.stack;
}

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// Use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick =(function () {
    // linked list of tasks (single, with head node)
    var head = {task: void 0, next: null};
    var tail = head;
    var flushing = false;
    var requestTick = void 0;
    var isNodeJS = false;
    // queue for late tasks, used by unhandled rejection tracking
    var laterQueue = [];

    function flush() {
        /* jshint loopfunc: true */
        var task, domain;

        while (head.next) {
            head = head.next;
            task = head.task;
            head.task = void 0;
            domain = head.domain;

            if (domain) {
                head.domain = void 0;
                domain.enter();
            }
            runSingle(task, domain);

        }
        while (laterQueue.length) {
            task = laterQueue.pop();
            runSingle(task);
        }
        flushing = false;
    }
    // runs a single function in the async queue
    function runSingle(task, domain) {
        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function () {
                    throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    nextTick = function (task) {
        tail = tail.next = {
            task: task,
            domain: isNodeJS && process.domain,
            next: null
        };

        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };

    if (typeof process === "object" &&
        process.toString() === "[object process]" && process.nextTick) {
        // Ensure Q is in a real Node environment, with a `process.nextTick`.
        // To see through fake Node environments:
        // * Mocha test runner - exposes a `process` global without a `nextTick`
        // * Browserify - exposes a `process.nexTick` function that uses
        //   `setTimeout`. In this case `setImmediate` is preferred because
        //    it is faster. Browserify's `process.toString()` yields
        //   "[object Object]", while in a real Node environment
        //   `process.toString()` yields "[object process]".
        isNodeJS = true;

        requestTick = function () {
            process.nextTick(flush);
        };

    } else if (typeof setImmediate === "function") {
        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
        if (typeof window !== "undefined") {
            requestTick = setImmediate.bind(window, flush);
        } else {
            requestTick = function () {
                setImmediate(flush);
            };
        }

    } else if (typeof MessageChannel !== "undefined") {
        // modern browsers
        // http://www.nonblocking.io/2011/06/windownexttick.html
        var channel = new MessageChannel();
        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
        // working message ports the first time a page loads.
        channel.port1.onmessage = function () {
            requestTick = requestPortTick;
            channel.port1.onmessage = flush;
            flush();
        };
        var requestPortTick = function () {
            // Opera requires us to provide a message payload, regardless of
            // whether we use it.
            channel.port2.postMessage(0);
        };
        requestTick = function () {
            setTimeout(flush, 0);
            requestPortTick();
        };

    } else {
        // old browsers
        requestTick = function () {
            setTimeout(flush, 0);
        };
    }
    // runs a task after all other tasks have been run
    // this is useful for unhandled rejection tracking that needs to happen
    // after all `then`d tasks have been run.
    nextTick.runAfter = function (task) {
        laterQueue.push(task);
        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };
    return nextTick;
})();

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this **might** have the nice side-effect of reducing the size of
// the minified code by reducing x.call() to merely x()
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
var call = Function.call;
function uncurryThis(f) {
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_defineProperty = Object.defineProperty || function (obj, prop, descriptor) {
    obj[prop] = descriptor.value;
    return obj;
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

function isObject(value) {
    return value === Object(value);
}

// generator related shims

// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

// FIXME: Remove this helper and Q.return once ES6 generators are in
// SpiderMonkey.
var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible, transform the error stack trace by removing Node and Q
    // cruft, then concatenating with the stack trace of `promise`. See #57.
    if (hasStacks &&
        promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack
    ) {
        var stacks = [];
        for (var p = promise; !!p; p = p.source) {
            if (p.stack && (!error.__minimumStackCounter__ || error.__minimumStackCounter__ > p.stackCounter)) {
                object_defineProperty(error, "__minimumStackCounter__", {value: p.stackCounter, configurable: true});
                stacks.unshift(p.stack);
            }
        }
        stacks.unshift(error.stack);

        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
        var stack = filterStackString(concatedStacks);
        object_defineProperty(error, "stack", {value: stack, configurable: true});
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function getFileNameAndLineNumber(stackLine) {
    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
    // In IE10 function name can have spaces ("Anonymous function") O_o
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) {
        return [attempt1[1], Number(attempt1[2])];
    }

    // Anonymous functions: "at filename:lineNumber:columnNumber"
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) {
        return [attempt2[1], Number(attempt2[2])];
    }

    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) {
        return [attempt3[1], Number(attempt3[2])];
    }
}

function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

    if (!fileNameAndLineNumber) {
        return false;
    }

    var fileName = fileNameAndLineNumber[0];
    var lineNumber = fileNameAndLineNumber[1];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (!hasStacks) {
        return;
    }

    try {
        throw new Error();
    } catch (e) {
        var lines = e.stack.split("\n");
        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
        if (!fileNameAndLineNumber) {
            return;
        }

        qFileName = fileNameAndLineNumber[0];
        return fileNameAndLineNumber[1];
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" &&
            typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative +
                         " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
function Q(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (value instanceof Promise) {
        return value;
    }

    // assimilate thenables
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}
Q.resolve = Q;

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Controls whether or not long stack traces will be on
 */
Q.longStackSupport = false;

/**
 * The counter is used to determine the stopping point for building
 * long stack traces. In makeStackTraceLong we walk backwards through
 * the linked list of promises, only stacks which were created before
 * the rejection are concatenated.
 */
var longStackCounter = 1;

// enable long stacks if Q_DEBUG is set
if (typeof process === "object" && process && Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}) && Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).Q_DEBUG) {
    Q.longStackSupport = true;
}

/**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */
Q.defer = defer;
function defer() {
    // if "messages" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the messages array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the `resolve` function because it handles both fully
    // non-thenable values and other thenables gracefully.
    var messages = [], progressListeners = [], resolvedPromise;

    var deferred = object_create(defer.prototype);
    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (messages) {
            messages.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            Q.nextTick(function () {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        }
    };

    // XXX deprecated
    promise.valueOf = function () {
        if (messages) {
            return promise;
        }
        var nearerValue = nearer(resolvedPromise);
        if (isPromise(nearerValue)) {
            resolvedPromise = nearerValue; // shorten chain
        }
        return nearerValue;
    };

    promise.inspect = function () {
        if (!resolvedPromise) {
            return { state: "pending" };
        }
        return resolvedPromise.inspect();
    };

    if (Q.longStackSupport && hasStacks) {
        try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
            promise.stackCounter = longStackCounter++;
        }
    }

    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
    // consolidating them into `become`, since otherwise we'd create new
    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

    function become(newPromise) {
        resolvedPromise = newPromise;

        if (Q.longStackSupport && hasStacks) {
            // Only hold a reference to the new promise if long stacks
            // are enabled to reduce memory usage
            promise.source = newPromise;
        }

        array_reduce(messages, function (undefined, message) {
            Q.nextTick(function () {
                newPromise.promiseDispatch.apply(newPromise, message);
            });
        }, void 0);

        messages = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(Q(value));
    };

    deferred.fulfill = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(fulfill(value));
    };
    deferred.reject = function (reason) {
        if (resolvedPromise) {
            return;
        }

        become(reject(reason));
    };
    deferred.notify = function (progress) {
        if (resolvedPromise) {
            return;
        }

        array_reduce(progressListeners, function (undefined, progressListener) {
            Q.nextTick(function () {
                progressListener(progress);
            });
        }, void 0);
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */
Q.Promise = promise; // ES6
Q.promise = promise;
function promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("resolver must be a function.");
    }
    var deferred = defer();
    try {
        resolver(deferred.resolve, deferred.reject, deferred.notify);
    } catch (reason) {
        deferred.reject(reason);
    }
    return deferred.promise;
}

promise.race = race; // ES6
promise.all = all; // ES6
promise.reject = reject; // ES6
promise.resolve = Q; // ES6

// XXX experimental.  This method is a way to denote that a local value is
// serializable and should be immediately dispatched to a remote upon request,
// instead of passing a reference.
Q.passByCopy = function (object) {
    //freeze(object);
    //passByCopies.set(object, true);
    return object;
};

Promise.prototype.passByCopy = function () {
    //freeze(object);
    //passByCopies.set(object, true);
    return this;
};

/**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */
Q.join = function (x, y) {
    return Q(x).join(y);
};

Promise.prototype.join = function (that) {
    return Q([this, that]).spread(function (x, y) {
        if (x === y) {
            // TODO: "===" should be Object.is or equiv
            return x;
        } else {
            throw new Error("Q can't join: not the same: " + x + " " + y);
        }
    });
};

/**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */
Q.race = race;
function race(answerPs) {
    return promise(function (resolve, reject) {
        // Switch to this once we can assume at least ES5
        // answerPs.forEach(function (answerP) {
        //     Q(answerP).then(resolve, reject);
        // });
        // Use this in the meantime
        for (var i = 0, len = answerPs.length; i < len; i++) {
            Q(answerPs[i]).then(resolve, reject);
        }
    });
}

Promise.prototype.race = function () {
    return this.then(Q.race);
};

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = Promise;
function Promise(descriptor, fallback, inspect) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error(
                "Promise does not support operation: " + op
            ));
        };
    }
    if (inspect === void 0) {
        inspect = function () {
            return {state: "unknown"};
        };
    }

    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    promise.inspect = inspect;

    // XXX deprecated `valueOf` and `exception` support
    if (inspect) {
        var inspected = inspect();
        if (inspected.state === "rejected") {
            promise.exception = inspected.reason;
        }

        promise.valueOf = function () {
            var inspected = inspect();
            if (inspected.state === "pending" ||
                inspected.state === "rejected") {
                return promise;
            }
            return inspected.value;
        };
    }

    return promise;
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.then = function (fulfilled, rejected, progressed) {
    var self = this;
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, self);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    Q.nextTick(function () {
        self.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    self.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
};

Q.tap = function (promise, callback) {
    return Q(promise).tap(callback);
};

/**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */
Promise.prototype.tap = function (callback) {
    callback = Q(callback);

    return this.then(function (value) {
        return callback.fcall(value).thenResolve(value);
    });
};

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    return Q(value).then(fulfilled, rejected, progressed);
}

Promise.prototype.thenResolve = function (value) {
    return this.then(function () { return value; });
};

Q.thenResolve = function (promise, value) {
    return Q(promise).thenResolve(value);
};

Promise.prototype.thenReject = function (reason) {
    return this.then(function () { throw reason; });
};

Q.thenReject = function (promise, reason) {
    return Q(promise).thenReject(reason);
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */

// XXX should we re-do this?
Q.nearer = nearer;
function nearer(value) {
    if (isPromise(value)) {
        var inspected = value.inspect();
        if (inspected.state === "fulfilled") {
            return inspected.value;
        }
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object instanceof Promise;
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return isObject(object) && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return isPromise(object) && object.inspect().state === "pending";
}

Promise.prototype.isPending = function () {
    return this.inspect().state === "pending";
};

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromise(object) || object.inspect().state === "fulfilled";
}

Promise.prototype.isFulfilled = function () {
    return this.inspect().state === "fulfilled";
};

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    return isPromise(object) && object.inspect().state === "rejected";
}

Promise.prototype.isRejected = function () {
    return this.inspect().state === "rejected";
};

//// BEGIN UNHANDLED REJECTION TRACKING

// This promise library consumes exceptions thrown in handlers so they can be
// handled by a subsequent promise.  The exceptions get added to this array when
// they are created, and removed when they are handled.  Note that in ES6 or
// shimmed environments, this would naturally be a `Set`.
var unhandledReasons = [];
var unhandledRejections = [];
var reportedUnhandledRejections = [];
var trackUnhandledRejections = true;

function resetUnhandledRejections() {
    unhandledReasons.length = 0;
    unhandledRejections.length = 0;

    if (!trackUnhandledRejections) {
        trackUnhandledRejections = true;
    }
}

function trackRejection(promise, reason) {
    if (!trackUnhandledRejections) {
        return;
    }
    if (typeof process === "object" && typeof process.emit === "function") {
        Q.nextTick.runAfter(function () {
            if (array_indexOf(unhandledRejections, promise) !== -1) {
                process.emit("unhandledRejection", reason, promise);
                reportedUnhandledRejections.push(promise);
            }
        });
    }

    unhandledRejections.push(promise);
    if (reason && typeof reason.stack !== "undefined") {
        unhandledReasons.push(reason.stack);
    } else {
        unhandledReasons.push("(no stack) " + reason);
    }
}

function untrackRejection(promise) {
    if (!trackUnhandledRejections) {
        return;
    }

    var at = array_indexOf(unhandledRejections, promise);
    if (at !== -1) {
        if (typeof process === "object" && typeof process.emit === "function") {
            Q.nextTick.runAfter(function () {
                var atReport = array_indexOf(reportedUnhandledRejections, promise);
                if (atReport !== -1) {
                    process.emit("rejectionHandled", unhandledReasons[at], promise);
                    reportedUnhandledRejections.splice(atReport, 1);
                }
            });
        }
        unhandledRejections.splice(at, 1);
        unhandledReasons.splice(at, 1);
    }
}

Q.resetUnhandledRejections = resetUnhandledRejections;

Q.getUnhandledReasons = function () {
    // Make a copy so that consumers can't interfere with our internal state.
    return unhandledReasons.slice();
};

Q.stopUnhandledRejectionTracking = function () {
    resetUnhandledRejections();
    trackUnhandledRejections = false;
};

resetUnhandledRejections();

//// END UNHANDLED REJECTION TRACKING

/**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */
Q.reject = reject;
function reject(reason) {
    var rejection = Promise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                untrackRejection(this);
            }
            return rejected ? rejected(reason) : this;
        }
    }, function fallback() {
        return this;
    }, function inspect() {
        return { state: "rejected", reason: reason };
    });

    // Note that the reason has not been handled.
    trackRejection(rejection, reason);

    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(value) {
    return Promise({
        "when": function () {
            return value;
        },
        "get": function (name) {
            return value[name];
        },
        "set": function (name, rhs) {
            value[name] = rhs;
        },
        "delete": function (name) {
            delete value[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name === null || name === void 0) {
                return value.apply(void 0, args);
            } else {
                return value[name].apply(value, args);
            }
        },
        "apply": function (thisp, args) {
            return value.apply(thisp, args);
        },
        "keys": function () {
            return object_keys(value);
        }
    }, void 0, function inspect() {
        return { state: "fulfilled", value: value };
    });
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    Q.nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return Promise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return Q(object).inspect();
    });
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(value, fulfilled, rejected) {
    return Q(value).spread(fulfilled, rejected);
}

Promise.prototype.spread = function (fulfilled, rejected) {
    return this.all().then(function (array) {
        return fulfilled.apply(void 0, array);
    }, rejected);
};

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;

            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
            // engine that has a deployed base of browsers that support generators.
            // However, SM's generators use the Python-inspired semantics of
            // outdated ES6 drafts.  We would like to support ES6, but we'd also
            // like to make it possible to use generators in deployed browsers, so
            // we also support Python-style generators.  At some point we can remove
            // this block.

            if (typeof StopIteration === "undefined") {
                // ES6 Generators
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    return reject(exception);
                }
                if (result.done) {
                    return Q(result.value);
                } else {
                    return when(result.value, callback, errback);
                }
            } else {
                // SpiderMonkey Generators
                // FIXME: Remove this case when SM does ES6 generators.
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    if (isStopIteration(exception)) {
                        return Q(exception.value);
                    } else {
                        return reject(exception);
                    }
                }
                return when(result, callback, errback);
            }
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "next");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */
Q.spawn = spawn;
function spawn(makeGenerator) {
    Q.done(Q.async(makeGenerator)());
}

// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q["return"] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    return Q(object).dispatch(op, args);
}

Promise.prototype.dispatch = function (op, args) {
    var self = this;
    var deferred = defer();
    Q.nextTick(function () {
        self.promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
};

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = function (object, key) {
    return Q(object).dispatch("get", [key]);
};

Promise.prototype.get = function (key) {
    return this.dispatch("get", [key]);
};

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = function (object, key, value) {
    return Q(object).dispatch("set", [key, value]);
};

Promise.prototype.set = function (key, value) {
    return this.dispatch("set", [key, value]);
};

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q.del = // XXX legacy
Q["delete"] = function (object, key) {
    return Q(object).dispatch("delete", [key]);
};

Promise.prototype.del = // XXX legacy
Promise.prototype["delete"] = function (key) {
    return this.dispatch("delete", [key]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
Q.mapply = // XXX As proposed by "Redsandro"
Q.post = function (object, name, args) {
    return Q(object).dispatch("post", [name, args]);
};

Promise.prototype.mapply = // XXX As proposed by "Redsandro"
Promise.prototype.post = function (name, args) {
    return this.dispatch("post", [name, args]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = // XXX Mark Miller's proposed parlance
Q.mcall = // XXX As proposed by "Redsandro"
Q.invoke = function (object, name /*...args*/) {
    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
};

Promise.prototype.send = // XXX Mark Miller's proposed parlance
Promise.prototype.mcall = // XXX As proposed by "Redsandro"
Promise.prototype.invoke = function (name /*...args*/) {
    return this.dispatch("post", [name, array_slice(arguments, 1)]);
};

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = function (object, args) {
    return Q(object).dispatch("apply", [void 0, args]);
};

Promise.prototype.fapply = function (args) {
    return this.dispatch("apply", [void 0, args]);
};

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] =
Q.fcall = function (object /* ...args*/) {
    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
};

Promise.prototype.fcall = function (/*...args*/) {
    return this.dispatch("apply", [void 0, array_slice(arguments)]);
};

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = function (object /*...args*/) {
    var promise = Q(object);
    var args = array_slice(arguments, 1);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};
Promise.prototype.fbind = function (/*...args*/) {
    var promise = this;
    var args = array_slice(arguments);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */
Q.keys = function (object) {
    return Q(object).dispatch("keys", []);
};

Promise.prototype.keys = function () {
    return this.dispatch("keys", []);
};

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var pendingCount = 0;
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            var snapshot;
            if (
                isPromise(promise) &&
                (snapshot = promise.inspect()).state === "fulfilled"
            ) {
                promises[index] = snapshot.value;
            } else {
                ++pendingCount;
                when(
                    promise,
                    function (value) {
                        promises[index] = value;
                        if (--pendingCount === 0) {
                            deferred.resolve(promises);
                        }
                    },
                    deferred.reject,
                    function (progress) {
                        deferred.notify({ index: index, value: progress });
                    }
                );
            }
        }, void 0);
        if (pendingCount === 0) {
            deferred.resolve(promises);
        }
        return deferred.promise;
    });
}

Promise.prototype.all = function () {
    return all(this);
};

/**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */
Q.any = any;

function any(promises) {
    if (promises.length === 0) {
        return Q.resolve();
    }

    var deferred = Q.defer();
    var pendingCount = 0;
    array_reduce(promises, function (prev, current, index) {
        var promise = promises[index];

        pendingCount++;

        when(promise, onFulfilled, onRejected, onProgress);
        function onFulfilled(result) {
            deferred.resolve(result);
        }
        function onRejected(err) {
            pendingCount--;
            if (pendingCount === 0) {
                var rejection = err || new Error("" + err);

                rejection.message = ("Q can't get fulfillment value from any promise, all " +
                    "promises were rejected. Last error message: " + rejection.message);

                deferred.reject(rejection);
            }
        }
        function onProgress(progress) {
            deferred.notify({
                index: index,
                value: progress
            });
        }
    }, undefined);

    return deferred.promise;
}

Promise.prototype.any = function () {
    return any(this);
};

/**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, Q);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

Promise.prototype.allResolved = function () {
    return allResolved(this);
};

/**
 * @see Promise#allSettled
 */
Q.allSettled = allSettled;
function allSettled(promises) {
    return Q(promises).allSettled();
}

/**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */
Promise.prototype.allSettled = function () {
    return this.then(function (promises) {
        return all(array_map(promises, function (promise) {
            promise = Q(promise);
            function regardless() {
                return promise.inspect();
            }
            return promise.then(regardless, regardless);
        }));
    });
};

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q.fail = // XXX legacy
Q["catch"] = function (object, rejected) {
    return Q(object).then(void 0, rejected);
};

Promise.prototype.fail = // XXX legacy
Promise.prototype["catch"] = function (rejected) {
    return this.then(void 0, rejected);
};

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(object, progressed) {
    return Q(object).then(void 0, void 0, progressed);
}

Promise.prototype.progress = function (progressed) {
    return this.then(void 0, void 0, progressed);
};

/**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q.fin = // XXX legacy
Q["finally"] = function (object, callback) {
    return Q(object)["finally"](callback);
};

Promise.prototype.fin = // XXX legacy
Promise.prototype["finally"] = function (callback) {
    if (!callback || typeof callback.apply !== "function") {
        throw new Error("Q can't apply finally callback");
    }
    callback = Q(callback);
    return this.then(function (value) {
        return callback.fcall().then(function () {
            return value;
        });
    }, function (reason) {
        // TODO attempt to recycle the rejection with "this".
        return callback.fcall().then(function () {
            throw reason;
        });
    });
};

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = function (object, fulfilled, rejected, progress) {
    return Q(object).done(fulfilled, rejected, progress);
};

Promise.prototype.done = function (fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        Q.nextTick(function () {
            makeStackTraceLong(error, promise);
            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promise = fulfilled || rejected || progress ?
        this.then(fulfilled, rejected, progress) :
        this;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }

    promise.then(void 0, onUnhandledError);
};

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = function (object, ms, error) {
    return Q(object).timeout(ms, error);
};

Promise.prototype.timeout = function (ms, error) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        if (!error || "string" === typeof error) {
            error = new Error(error || "Timed out after " + ms + " ms");
            error.code = "ETIMEDOUT";
        }
        deferred.reject(error);
    }, ms);

    this.then(function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    }, deferred.notify);

    return deferred.promise;
};

/**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */
Q.delay = function (object, timeout) {
    if (timeout === void 0) {
        timeout = object;
        object = void 0;
    }
    return Q(object).delay(timeout);
};

Promise.prototype.delay = function (timeout) {
    return this.then(function (value) {
        var deferred = defer();
        setTimeout(function () {
            deferred.resolve(value);
        }, timeout);
        return deferred.promise;
    });
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = function (callback, args) {
    return Q(callback).nfapply(args);
};

Promise.prototype.nfapply = function (args) {
    var deferred = defer();
    var nodeArgs = array_slice(args);
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */
Q.nfcall = function (callback /*...args*/) {
    var args = array_slice(arguments, 1);
    return Q(callback).nfapply(args);
};

Promise.prototype.nfcall = function (/*...args*/) {
    var nodeArgs = array_slice(arguments);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */
Q.nfbind =
Q.denodeify = function (callback /*...args*/) {
    if (callback === undefined) {
        throw new Error("Q can't wrap an undefined function");
    }
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(callback).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nfbind =
Promise.prototype.denodeify = function (/*...args*/) {
    var args = array_slice(arguments);
    args.unshift(this);
    return Q.denodeify.apply(void 0, args);
};

Q.nbind = function (callback, thisp /*...args*/) {
    var baseArgs = array_slice(arguments, 2);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        function bound() {
            return callback.apply(thisp, arguments);
        }
        Q(bound).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nbind = function (/*thisp, ...args*/) {
    var args = array_slice(arguments, 0);
    args.unshift(this);
    return Q.nbind.apply(void 0, args);
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nmapply = // XXX As proposed by "Redsandro"
Q.npost = function (object, name, args) {
    return Q(object).npost(name, args);
};

Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
Promise.prototype.npost = function (name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = // XXX Based on Mark Miller's proposed "send"
Q.nmcall = // XXX Based on "Redsandro's" proposal
Q.ninvoke = function (object, name /*...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
Promise.prototype.ninvoke = function (name /*...args*/) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */
Q.nodeify = nodeify;
function nodeify(object, nodeback) {
    return Q(object).nodeify(nodeback);
}

Promise.prototype.nodeify = function (nodeback) {
    if (nodeback) {
        this.then(function (value) {
            Q.nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            Q.nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return this;
    }
};

Q.noConflict = function() {
    throw new Error("Q.noConflict only works when Q is used as a global");
};

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(288).setImmediate))

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewDriveItemsActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchNewDriveItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadNewItemsStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateNewItemsStoreOffline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;







var NewDriveItemsActionKeys;
(function (NewDriveItemsActionKeys) {
    NewDriveItemsActionKeys["REQUEST_NEW_DRIVE_ITEMS"] = "@@newDriveItem/REQUEST_NEW_DRIVE_ITEMS";
    NewDriveItemsActionKeys["RECEIVE_NEW_DRIVE_ITEMS"] = "@@newDriveItem/RECEIVE_NEW_DRIVE_ITEMS";
    NewDriveItemsActionKeys["UPDATE_NEW_ITEMS"] = "@@newDriveItem/UPDATE_NEW_ITEMS";
})(NewDriveItemsActionKeys || (NewDriveItemsActionKeys = {}));
var loadNewItemsStore = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var storedNewItems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__["a" /* default */].getNewItems()];
            case 1:
                storedNewItems = _a.sent();
                if (storedNewItems) {
                    dispatch({
                        type: NewDriveItemsActionKeys.UPDATE_NEW_ITEMS,
                        ids: storedNewItems.map(function (_a) {
                            var id = _a.id;
                            return id;
                        }),
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
var requestNewDriveItems = function () { return ({
    type: NewDriveItemsActionKeys.REQUEST_NEW_DRIVE_ITEMS,
}); };
var receiveNewDriveItems = function () { return ({
    type: NewDriveItemsActionKeys.RECEIVE_NEW_DRIVE_ITEMS,
}); };
var updateNewItems = function (metas, ordered) { return function (dispatch, getState) {
    var isFolder = function (id) { return metas[id].type === __WEBPACK_IMPORTED_MODULE_0__typings_api__["a" /* Api */].DriveItemType.Directory; };
    var filteredIds = ordered.filter(function (id) { return !isFolder(id); });
    dispatch({
        type: NewDriveItemsActionKeys.UPDATE_NEW_ITEMS,
        ids: filteredIds,
    });
    var newItemsToStore = filteredIds.map(function (id) { return ({
        id: id,
        additionDate: Date.parse(metas[id].creationDate),
    }); });
    __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__["a" /* default */].setNewItems(newItemsToStore).then();
    var driveItems = getState().driveList.driveItems;
    filteredIds.forEach(function (id) {
        if (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp && !driveItems[id]) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__OfflineManager_actions__["e" /* downloadThumb */])(id, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["a" /* DownloadPriority */].Normal, false, metas[id]));
        }
    });
}; };
var fetchNewDriveItems = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, metas, resolutions, ordered, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                dispatch(requestNewDriveItems());
                if (!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()) return [3 /*break*/, 2];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].getNewContents()];
            case 1:
                _a = _b.sent(), metas = _a.metas, resolutions = _a.resolutions, ordered = _a.ordered;
                dispatch(updateNewItems(metas, ordered));
                if (resolutions) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["s" /* receiveResolutions */])(resolutions));
                }
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* receiveDriveItems */])(metas));
                return [3 /*break*/, 3];
            case 2:
                dispatch(updateNewItemsStoreOffline());
                _b.label = 3;
            case 3:
                dispatch(receiveNewDriveItems());
                return [3 /*break*/, 5];
            case 4:
                error_1 = _b.sent();
                dispatch(receiveNewDriveItems());
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var updateNewItemsStoreOffline = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var storedNewItems, MAX_LAST_VISIT_DAYS, MAX_VISIT_DATE_MS, filteredNewItems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__["a" /* default */].getNewItems()];
            case 1:
                storedNewItems = _a.sent();
                if (!storedNewItems) {
                    return [2 /*return*/];
                }
                MAX_LAST_VISIT_DAYS = 30;
                MAX_VISIT_DATE_MS = Date.now() - (1000 * 3600 * 24 * MAX_LAST_VISIT_DAYS);
                filteredNewItems = storedNewItems.filter(function (_a) {
                    var additionDate = _a.additionDate;
                    return additionDate >= MAX_VISIT_DATE_MS;
                });
                dispatch({
                    type: NewDriveItemsActionKeys.UPDATE_NEW_ITEMS,
                    ids: filteredNewItems.map(function (_a) {
                        var id = _a.id;
                        return id;
                    }),
                });
                __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__["a" /* default */].setNewItems(filteredNewItems).then();
                return [2 /*return*/];
        }
    });
}); }; };



/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213).Buffer))

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var LocalStorageManager = /** @class */ (function (_super) {
    __extends(LocalStorageManager, _super);
    function LocalStorageManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalStorageManager.setGalleryPrefix = function (int, login) {
        var prefix = __WEBPACK_IMPORTED_MODULE_2__index__["d" /* default */].getGalleryPrefix(int, login);
        __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].setPrefix(prefix);
    };
    LocalStorageManager.getGalleryPrefix = function () {
        return __WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */].getPrefix();
    };
    LocalStorageManager.setProfileInfos = function (LocalProfileData) {
        LocalStorageManager.setItem(LocalStorageManager.storeProfileInfosKey, LocalProfileData, false);
    };
    LocalStorageManager.getProfileInfos = function () {
        return LocalStorageManager.getItem(LocalStorageManager.storeProfileInfosKey, false);
    };
    LocalStorageManager.removeProfileInfos = function () {
        LocalStorageManager.removeItem(LocalStorageManager.storeProfileInfosKey, false);
    };
    // User Locale
    LocalStorageManager.setUserLocale = function (locale, hasPrefix) {
        LocalStorageManager.setItem(LocalStorageManager.userLocaleKey, locale, hasPrefix);
    };
    LocalStorageManager.getUserLocale = function (hasPrefix) {
        return LocalStorageManager.getItem(LocalStorageManager.userLocaleKey, hasPrefix);
    };
    LocalStorageManager.removeUserLocale = function (hasPrefix) {
        LocalStorageManager.removeItem(LocalStorageManager.userLocaleKey, hasPrefix);
    };
    // DisplayType
    LocalStorageManager.setDisplayType = function (displayType) {
        LocalStorageManager.setItem(LocalStorageManager.displayTypeKey, displayType, true);
    };
    LocalStorageManager.getDisplayType = function () {
        return LocalStorageManager.getItem(LocalStorageManager.displayTypeKey, true);
    };
    LocalStorageManager.removeDisplayType = function () {
        LocalStorageManager.removeItem(LocalStorageManager.displayTypeKey, true);
    };
    // Folders displayType (is set via dropdown inside each folder and has priority over application or backoffice displayType)
    LocalStorageManager.setFolderDisplayType = function (folderId, displayType) {
        var _a;
        var foldersDisplayType = LocalStorageManager.getFoldersDisplayType();
        if (!foldersDisplayType) {
            foldersDisplayType = (_a = {},
                _a[folderId] = displayType,
                _a);
        }
        else {
            foldersDisplayType[folderId] = displayType;
        }
        LocalStorageManager.setItem(LocalStorageManager.foldersDisplayTypeKey, foldersDisplayType, true);
    };
    LocalStorageManager.getFoldersDisplayType = function () {
        return LocalStorageManager.getItem(LocalStorageManager.foldersDisplayTypeKey, true);
    };
    LocalStorageManager.resetFoldersDisplayType = function () {
        LocalStorageManager.removeItem(LocalStorageManager.foldersDisplayTypeKey, true);
    };
    // DownloadPopupDontAskAgain
    LocalStorageManager.setDownloadPopupDontAskAgain = function () {
        LocalStorageManager.setItem(LocalStorageManager.downloadPopupDontAskAgainKey, true, true);
    };
    LocalStorageManager.getDownloadPopupDontAskAgain = function () {
        return LocalStorageManager.getItem(LocalStorageManager.downloadPopupDontAskAgainKey, true);
    };
    LocalStorageManager.removeDownloadPopupDontAskAgain = function () {
        LocalStorageManager.removeItem(LocalStorageManager.downloadPopupDontAskAgainKey, true);
    };
    // Selection
    LocalStorageManager.setSelection = function (selection) {
        LocalStorageManager.setItem(LocalStorageManager.selectionKey, selection, true);
    };
    LocalStorageManager.getSelection = function () {
        return LocalStorageManager.getItem(LocalStorageManager.selectionKey, true);
    };
    LocalStorageManager.removeSelection = function () {
        LocalStorageManager.removeItem(LocalStorageManager.selectionKey, true);
    };
    // Notes selection
    LocalStorageManager.setNotesSelection = function (selection) {
        LocalStorageManager.setItem(LocalStorageManager.notesSelectionKey, selection, true);
    };
    LocalStorageManager.getNotesSelection = function () {
        return LocalStorageManager.getItem(LocalStorageManager.notesSelectionKey, true);
    };
    LocalStorageManager.removeNotesSelection = function () {
        LocalStorageManager.removeItem(LocalStorageManager.notesSelectionKey, true);
    };
    // DownloadGroups
    LocalStorageManager.setDownloadGroups = function (group, status) {
        var downloadGroups = LocalStorageManager.getDownloadGroups() || {
            all: __WEBPACK_IMPORTED_MODULE_1__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted,
            important: __WEBPACK_IMPORTED_MODULE_1__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted,
            selected: __WEBPACK_IMPORTED_MODULE_1__containers_DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted,
        };
        var oldDownloadAllStatusFormat = LocalStorageManager.getDownloadAllStatus();
        if (oldDownloadAllStatusFormat) {
            // this is to handle the first application start after updating to 3.53
            downloadGroups[__WEBPACK_IMPORTED_MODULE_1__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].ALL] = oldDownloadAllStatusFormat;
            LocalStorageManager.removeDownloadAllStatus();
        }
        downloadGroups[group] = status;
        LocalStorageManager.setItem(LocalStorageManager.downloadDownloadGroupsKey, downloadGroups, true);
    };
    LocalStorageManager.getDownloadGroups = function () {
        return LocalStorageManager.getItem(LocalStorageManager.downloadDownloadGroupsKey, true);
    };
    LocalStorageManager.removeDownloadGroups = function () {
        LocalStorageManager.removeItem(LocalStorageManager.downloadDownloadGroupsKey, true);
    };
    // Downloads
    LocalStorageManager.setDownloads = function (downloads) {
        LocalStorageManager.setItem(LocalStorageManager.downloadsKey, downloads, true);
    };
    LocalStorageManager.getDownloads = function () {
        return LocalStorageManager.getItem(LocalStorageManager.downloadsKey, true);
    };
    LocalStorageManager.removeDownloads = function () {
        LocalStorageManager.removeItem(LocalStorageManager.downloadsKey, true);
    };
    LocalStorageManager.setPendingSelectedDownloads = function (driveItemIds) {
        LocalStorageManager.setItem(LocalStorageManager.pendingSelectedDownloadsKey, driveItemIds, true);
    };
    LocalStorageManager.getPendingSelectedDownloads = function () {
        return LocalStorageManager.getItem(LocalStorageManager.pendingSelectedDownloadsKey, true);
    };
    LocalStorageManager.removePendingSelectedDownloads = function () {
        LocalStorageManager.removeItem(LocalStorageManager.pendingSelectedDownloadsKey, true);
    };
    // New Items
    LocalStorageManager.setNewItems = function (newItems) {
        LocalStorageManager.setItem(LocalStorageManager.newItemsKey, newItems, true);
    };
    LocalStorageManager.getNewItemsStore = function () {
        return LocalStorageManager.getItem(LocalStorageManager.newItemsKey, true);
    };
    LocalStorageManager.removeNewItems = function () {
        LocalStorageManager.removeItem(LocalStorageManager.newItemsKey, true);
    };
    // Read Status
    LocalStorageManager.setReadItems = function (readItems) {
        LocalStorageManager.setItem(LocalStorageManager.readStatusKey, readItems, true);
    };
    LocalStorageManager.getReadStatusStore = function () {
        return LocalStorageManager.getItem(LocalStorageManager.readStatusKey, true);
    };
    LocalStorageManager.removeReadStatus = function () {
        LocalStorageManager.removeItem(LocalStorageManager.readStatusKey, true);
    };
    // GalleryConfig
    LocalStorageManager.setStoreGalleryConfig = function (storeGalleryConfig) {
        LocalStorageManager.setItem(LocalStorageManager.storeGalleryConfigKey, storeGalleryConfig, false);
    };
    LocalStorageManager.getStoreGalleryConfig = function () {
        return LocalStorageManager.getItem(LocalStorageManager.storeGalleryConfigKey, false);
    };
    LocalStorageManager.removeStoreGalleryConfig = function () {
        LocalStorageManager.removeItem(LocalStorageManager.storeGalleryConfigKey, false);
    };
    // GalleryInfos
    LocalStorageManager.setStoreGalleryInfos = function (storeGalleryInfos) {
        LocalStorageManager.setItem(LocalStorageManager.storeGalleryInfosKey, storeGalleryInfos, true);
    };
    LocalStorageManager.getStoreGalleryInfos = function () {
        return LocalStorageManager.getItem(LocalStorageManager.storeGalleryInfosKey, true);
    };
    LocalStorageManager.removeStoreGalleryInfos = function () {
        LocalStorageManager.removeItem(LocalStorageManager.storeGalleryInfosKey, true);
    };
    // DriveList
    LocalStorageManager.setStoreDriveList = function (driveList) {
        LocalStorageManager.setItem(LocalStorageManager.storeDriveListKey, driveList, true);
    };
    LocalStorageManager.getStoreDriveList = function () {
        return LocalStorageManager.getItem(LocalStorageManager.storeDriveListKey, true);
    };
    LocalStorageManager.removeStoreDriveList = function () {
        LocalStorageManager.removeItem(LocalStorageManager.storeDriveListKey, true);
    };
    // OfflineManager
    LocalStorageManager.setStoreOfflineManager = function (offlineManager) {
        LocalStorageManager.setItem(LocalStorageManager.storeOfflineManagerKey, offlineManager, true);
    };
    LocalStorageManager.getStoreOfflineManager = function () {
        return LocalStorageManager.getItem(LocalStorageManager.storeOfflineManagerKey, true);
    };
    LocalStorageManager.removeStoreOfflineManager = function () {
        LocalStorageManager.removeItem(LocalStorageManager.storeOfflineManagerKey, true);
    };
    // Credentials
    LocalStorageManager.setCredentials = function (credentials) {
        LocalStorageManager.setItem(LocalStorageManager.storeUserInfosKey, credentials, true);
    };
    LocalStorageManager.getCredentials = function () {
        return LocalStorageManager.getItem(LocalStorageManager.storeUserInfosKey, true);
    };
    LocalStorageManager.removeCredentials = function () {
        LocalStorageManager.removeItem(LocalStorageManager.storeUserInfosKey, true);
    };
    // MultiAppCredentials
    LocalStorageManager.setMultiAppCredentials = function (credentials) {
        LocalStorageManager.setItem(LocalStorageManager.multiAppCredentialsKey, credentials, false);
    };
    LocalStorageManager.getMultiAppCredentials = function () {
        return LocalStorageManager.getItem(LocalStorageManager.multiAppCredentialsKey, false);
    };
    LocalStorageManager.removeMultiAppCredentials = function () {
        LocalStorageManager.removeItem(LocalStorageManager.multiAppCredentialsKey, false);
    };
    // MultiAppServer
    LocalStorageManager.setMultiAppServer = function (server) {
        LocalStorageManager.setItem(LocalStorageManager.multiAppServerKey, server, false);
    };
    LocalStorageManager.getMultiAppServer = function () {
        return LocalStorageManager.getItem(LocalStorageManager.multiAppServerKey, false);
    };
    LocalStorageManager.removeMultiAppServer = function () {
        LocalStorageManager.removeItem(LocalStorageManager.multiAppServerKey, false);
    };
    // TrackingQueue
    LocalStorageManager.setTrackingQueue = function (trackingQueue) {
        LocalStorageManager.setItem(LocalStorageManager.trackingQueueKey, trackingQueue, true);
    };
    LocalStorageManager.getTrackingQueue = function () {
        return LocalStorageManager.getItem(LocalStorageManager.trackingQueueKey, true);
    };
    LocalStorageManager.removeTrackingQueue = function () {
        LocalStorageManager.removeItem(LocalStorageManager.trackingQueueKey, true);
    };
    // PendingTasks
    LocalStorageManager.setPendingTasks = function (pendingTasks) {
        LocalStorageManager.setItem(LocalStorageManager.pendingTasksKey, pendingTasks, true);
    };
    LocalStorageManager.getPendingTasks = function () {
        return LocalStorageManager.getItem(LocalStorageManager.pendingTasksKey, true);
    };
    LocalStorageManager.removePendingTasks = function () {
        LocalStorageManager.removeItem(LocalStorageManager.pendingTasksKey, true);
    };
    // LEGACY
    // DownloadAllStatus
    LocalStorageManager.getDownloadAllStatus = function () {
        return LocalStorageManager.getItem(LocalStorageManager.downloadAllStatusKey, true);
    };
    LocalStorageManager.removeDownloadAllStatus = function () {
        return LocalStorageManager.removeItem(LocalStorageManager.downloadAllStatusKey, true);
    };
    LocalStorageManager.removeUsername = function () {
        return localStorage.removeItem(LocalStorageManager.username);
    };
    LocalStorageManager.removePassword = function () {
        return localStorage.removeItem(LocalStorageManager.password);
    };
    // Migrated to IndexedDBManager
    LocalStorageManager.downloadsKey = 'gallApp-downloads';
    LocalStorageManager.downloadDownloadGroupsKey = 'gallApp-downloadGroups';
    LocalStorageManager.pendingSelectedDownloadsKey = 'gallApp-pendingSelectedDownloads';
    LocalStorageManager.multiAppCredentialsKey = 'gallApp-multiAppCredentials';
    LocalStorageManager.storeGalleryConfigKey = 'gallApp-galleryConfig';
    LocalStorageManager.downloadPopupDontAskAgainKey = 'gallApp-downloadPopupDontAskAgain';
    LocalStorageManager.displayTypeKey = 'gallApp-driveItemListDisplayType';
    LocalStorageManager.foldersDisplayTypeKey = 'gallApp-foldersDisplayType';
    LocalStorageManager.selectionKey = 'gallApp-favorites';
    LocalStorageManager.notesSelectionKey = 'gallApp-selectedNotes';
    LocalStorageManager.newItemsKey = 'gallApp-newItems';
    LocalStorageManager.readStatusKey = 'gallApp-readStatus';
    LocalStorageManager.storeGalleryInfosKey = 'gallApp-galleryInfos';
    LocalStorageManager.storeDriveListKey = 'gallApp-driveList';
    LocalStorageManager.storeOfflineManagerKey = 'gallApp-offlineManager';
    LocalStorageManager.storeUserInfosKey = 'gallApp-userInfos';
    LocalStorageManager.storeProfileInfosKey = 'gallApp-profileInfos';
    LocalStorageManager.multiAppServerKey = 'gallApp-multiAppServer';
    LocalStorageManager.trackingQueueKey = 'gallApp-trackingQueue';
    LocalStorageManager.pendingTasksKey = 'gallApp-pendingTasks';
    LocalStorageManager.userLocaleKey = 'gallApp-userLocale';
    // legacy
    LocalStorageManager.downloadAllStatusKey = 'gallApp-downloadAllStatus';
    // these keys are used in web version and set by external login page
    LocalStorageManager.username = 'username'; // legacy
    LocalStorageManager.password = 'password'; // legacy
    return LocalStorageManager;
}(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (LocalStorageManager);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestWebDownloadItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestMobileAppDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadRecursively; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downloadImportantAssets; });
/* unused harmony export getDependencyIds */
/* unused harmony export getDependenciesWithVersions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateDriveItemWithDependencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return downloadSelectedAssets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getInitialDependenciesUpdates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_promise_allsettled__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_promise_allsettled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_promise_allsettled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__delete__ = __webpack_require__(432);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;
















var Q = __webpack_require__(165);
var requestWebDownloadItem = function (driveItem) { return function (dispatch, getState) {
    var galleryInfos = getState().galleryInfos;
    var config = galleryInfos.config;
    if (__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].isMaster(config)) {
        window.open(__WEBPACK_IMPORTED_MODULE_4__utils_url__["b" /* default */].getItemOriginalFileUrl(config, driveItem.originalFile), '_blank');
    }
    else {
        window.location.href = __WEBPACK_IMPORTED_MODULE_4__utils_url__["b" /* default */].getAttachmentUrl(config, driveItem.id);
    }
}; };
var initialProcessedIds = function () { return new Set(); };
var requestMobileAppDownload = function (driveItem, requestedMode, dependentId, isUpdatable, isDependency, processedIds, isImportantOffline) {
    if (isUpdatable === void 0) { isUpdatable = false; }
    if (isDependency === void 0) { isDependency = false; }
    if (processedIds === void 0) { processedIds = initialProcessedIds(); }
    if (isImportantOffline === void 0) { isImportantOffline = false; }
    return function (dispatch, getState) {
        return Q.Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var downloadManager, itemFromDownloadManager, mode, version, status_1, error_1, error_2, error_3, error_4, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 40, , 41]);
                        downloadManager = getState().downloadManager;
                        itemFromDownloadManager = downloadManager.items[driveItem.id] ? downloadManager.items[driveItem.id] : undefined;
                        if (processedIds.has(driveItem.id)) {
                            resolve();
                            return [2 /*return*/];
                        }
                        processedIds.add(driveItem.id);
                        if (!(requestedMode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested && !isDependency)) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["b" /* addDownloadInProgressItem */])(driveItem.id))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(requestedMode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency || isDependency)) return [3 /*break*/, 4];
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* addDownloadInProgressDependency */])(driveItem.id))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!itemFromDownloadManager) return [3 /*break*/, 31];
                        mode = itemFromDownloadManager.mode, version = itemFromDownloadManager.version, status_1 = itemFromDownloadManager.status;
                        if (!(status_1 === __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].ERROR)) return [3 /*break*/, 6];
                        return [4 /*yield*/, dispatch(downloadItemWithDependencies(driveItem, requestedMode, dependentId, processedIds, isDependency))];
                    case 5:
                        _a.sent();
                        resolve();
                        return [2 /*return*/];
                    case 6:
                        if (!(mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Temp)) return [3 /*break*/, 8];
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["v" /* transformTemporaryDownload */])(driveItem, itemFromDownloadManager, dependentId))];
                    case 7:
                        _a.sent();
                        resolve();
                        return [2 /*return*/];
                    case 8:
                        if (!(requestedMode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency || isDependency)) return [3 /*break*/, 16];
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 14, , 15]);
                        if (!(downloadManager.downloadInProgressDependencies && downloadManager.downloadInProgressDependencies.includes(driveItem.id))) return [3 /*break*/, 11];
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["w" /* updateDependents */])(driveItem, itemFromDownloadManager, requestedMode, dependentId))];
                    case 10:
                        _a.sent();
                        resolve();
                        return [2 /*return*/];
                    case 11: return [4 /*yield*/, dispatch(downloadItemWithDependencies(driveItem, requestedMode, dependentId, processedIds, isDependency))];
                    case 12:
                        _a.sent();
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["j" /* removeDownloadInProgressDependency */])(driveItem.id))];
                    case 13:
                        _a.sent();
                        return [3 /*break*/, 15];
                    case 14:
                        error_1 = _a.sent();
                        console.error("Download error for updatable dependency id " + driveItem.id + ":", error_1);
                        return [3 /*break*/, 15];
                    case 15:
                        resolve();
                        return [2 /*return*/];
                    case 16:
                        if (!(__WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].isLatestVersion(driveItem.version, version) && !isUpdatable)) return [3 /*break*/, 23];
                        _a.label = 17;
                    case 17:
                        _a.trys.push([17, 21, , 22]);
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["w" /* updateDependents */])(driveItem, itemFromDownloadManager, requestedMode, dependentId))];
                    case 18:
                        _a.sent();
                        return [4 /*yield*/, dispatch(removePendingSelectedDownload(driveItem.id))];
                    case 19:
                        _a.sent();
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["k" /* removeDownloadInProgressItem */])(driveItem.id))];
                    case 20:
                        _a.sent();
                        return [3 /*break*/, 22];
                    case 21:
                        error_2 = _a.sent();
                        console.error("Update error for item id " + driveItem.id + ":", error_2);
                        return [3 /*break*/, 22];
                    case 22:
                        resolve();
                        return [2 /*return*/];
                    case 23:
                        if (!isUpdatable) return [3 /*break*/, 30];
                        _a.label = 24;
                    case 24:
                        _a.trys.push([24, 28, , 29]);
                        return [4 /*yield*/, dispatch(downloadItemWithDependencies(driveItem, requestedMode, dependentId, processedIds, isDependency, isImportantOffline))];
                    case 25:
                        _a.sent();
                        return [4 /*yield*/, dispatch(removePendingSelectedDownload(driveItem.id))];
                    case 26:
                        _a.sent();
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["k" /* removeDownloadInProgressItem */])(driveItem.id))];
                    case 27:
                        _a.sent();
                        return [3 /*break*/, 29];
                    case 28:
                        error_3 = _a.sent();
                        console.error("Download error for updatable item id " + driveItem.id + ":", error_3);
                        return [3 /*break*/, 29];
                    case 29:
                        resolve();
                        return [2 /*return*/];
                    case 30: return [3 /*break*/, 39];
                    case 31:
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["c" /* addItem */])(driveItem, requestedMode, [], []));
                        _a.label = 32;
                    case 32:
                        _a.trys.push([32, 37, , 38]);
                        return [4 /*yield*/, dispatch(downloadItemWithDependencies(driveItem, requestedMode, dependentId, processedIds, isDependency))];
                    case 33:
                        _a.sent();
                        return [4 /*yield*/, dispatch(removePendingSelectedDownload(driveItem.id))];
                    case 34:
                        _a.sent();
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["k" /* removeDownloadInProgressItem */])(driveItem.id))];
                    case 35:
                        _a.sent();
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["j" /* removeDownloadInProgressDependency */])(driveItem.id))];
                    case 36:
                        _a.sent();
                        return [3 /*break*/, 38];
                    case 37:
                        error_4 = _a.sent();
                        console.error("Download error for new item id " + driveItem.id + ":", error_4);
                        return [3 /*break*/, 38];
                    case 38:
                        resolve();
                        return [2 /*return*/];
                    case 39:
                        resolve();
                        return [3 /*break*/, 41];
                    case 40:
                        error_5 = _a.sent();
                        console.error("requestMobileAppDownload error for item id " + driveItem.id + ":", error_5);
                        reject(error_5);
                        return [3 /*break*/, 41];
                    case 41: return [2 /*return*/];
                }
            });
        }); });
    };
};
var downloadItemWithDependencies = function (driveItem, mode, dependentId, processedIds, isDependency, isImportantOffline) {
    if (processedIds === void 0) { processedIds = initialProcessedIds(); }
    if (isDependency === void 0) { isDependency = false; }
    if (isImportantOffline === void 0) { isImportantOffline = false; }
    return function (dispatch, getState) {
        var downloadManager = getState().downloadManager;
        var itemFromDownloadManager = downloadManager.items[driveItem.id];
        var allDependenciesPromise = Q.Promise.resolve([]);
        if (!(isDependency || isImportantOffline)) {
            allDependenciesPromise = Q.Promise.resolve(dispatch(getDependenciesWithVersions(driveItem, __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].OutcomingsLevel.ALL)));
        }
        else if (isImportantOffline) {
            var dependencies = driveItem.dependencies;
            if (dependencies && dependencies.length > 0) {
                allDependenciesPromise = Q.Promise.resolve(dependencies);
            }
        }
        return allDependenciesPromise
            .then(function (allDependencies) {
            var currentDependentsIds = itemFromDownloadManager ? itemFromDownloadManager.dependents : [];
            var dependentsIds = dependentId !== undefined
                && !currentDependentsIds.includes(dependentId)
                ? __spread([dependentId], currentDependentsIds) : currentDependentsIds;
            var allDependenciesIds = !isDependency ? allDependencies.map(function (dependency) { return dependency.id; }) : [];
            var isLatestVersion = itemFromDownloadManager ? __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].isLatestVersion(driveItem.version, itemFromDownloadManager.version) : true;
            var promise = Q.Promise.resolve();
            if (itemFromDownloadManager && [__WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].INIT, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].ERROR].includes(itemFromDownloadManager.status)) {
                promise = promise
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["y" /* updateDownloadStatus */])(driveItem.id, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].STARTING_DOWNLOAD)); })
                    .then(function () { return dispatch(nativeDownload(driveItem, mode)); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["x" /* updateDownload */])(driveItem, mode, allDependenciesIds, dependentsIds)); });
            }
            else if (itemFromDownloadManager
                && (!isLatestVersion
                    || ![__WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADED].includes(itemFromDownloadManager.status))) {
                promise = promise
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["y" /* updateDownloadStatus */])(driveItem.id, isLatestVersion ? __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].RESUMING_DOWNLOAD : __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].STARTING_UPDATE)); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["w" /* updateDependents */])(driveItem, itemFromDownloadManager, mode, dependentId)); })
                    .then(function () { return dispatch(nativeDownload(driveItem, mode, !isLatestVersion)); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["x" /* updateDownload */])(driveItem, mode, allDependenciesIds, dependentsIds)); });
            }
            else if (itemFromDownloadManager
                && ![
                    __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].STARTING_DOWNLOAD,
                    __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADING,
                    __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].STARTING_UPDATE,
                    __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].UPDATING,
                    __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].RESUMING_DOWNLOAD
                ].includes(itemFromDownloadManager.status)) {
                promise = promise
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["y" /* updateDownloadStatus */])(driveItem.id, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADED)); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["w" /* updateDependents */])(driveItem, itemFromDownloadManager, mode, dependentId)); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["x" /* updateDownload */])(driveItem, mode, allDependenciesIds, dependentsIds)); });
            }
            if (!isDependency) {
                // Ensure that each dependency is processed sequentially
                promise = allDependencies.reduce(function (acc, updatedDependency) {
                    return acc
                        .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(updatedDependency.id, false)); })
                        .then(function (dependency) {
                        dependency = __assign({}, dependency, { version: updatedDependency.version });
                        var dependencyFromDownloadManager = downloadManager.items[dependency.id];
                        var downloadMode = dependencyFromDownloadManager && [__WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Required].includes(dependencyFromDownloadManager.mode)
                            ? dependencyFromDownloadManager.mode
                            : __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency;
                        if (dependencyFromDownloadManager) {
                            return dispatch(requestMobileAppDownload(dependency, downloadMode, driveItem.id, true, true, processedIds));
                        }
                        else {
                            return dispatch(requestMobileAppDownload(dependency, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency, driveItem.id, false, true, processedIds));
                        }
                    });
                }, promise);
            }
            return promise;
        })
            .catch(function (e) {
            console.error("Error in downloadItemWithDependencies for item " + driveItem.id + ":", e);
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["y" /* updateDownloadStatus */])(driveItem.id, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].ERROR));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__NotificationBar_actions__["c" /* createNotification */])('error.download_fail', { id: driveItem.id }));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__delete__["d" /* nativeDelete */])(driveItem));
            return Q.Promise.reject({});
        });
    };
};
var nativeDownload = function (driveItem, mode, isUpdating) {
    if (isUpdating === void 0) { isUpdating = false; }
    return function (dispatch, getState) {
        var galleryInfos = getState().galleryInfos;
        var config = galleryInfos.config;
        var fileName = driveItem.id + ".zip";
        var url = __WEBPACK_IMPORTED_MODULE_4__utils_url__["b" /* default */].getResourceZipUrl(config, driveItem.id);
        var destFolder = mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Temp ? __WEBPACK_IMPORTED_MODULE_5__utils__["i" /* tempFolder */] : __WEBPACK_IMPORTED_MODULE_5__utils__["f" /* downloadsFolder */];
        var downloadRequest = __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].downloadFile(galleryInfos.config, url, destFolder, fileName, __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["a" /* DownloadPriority */].High);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["t" /* setRequestId */])(driveItem.id, downloadRequest.requestId, isUpdating));
        var minimumTimeBetweenProgress = 500;
        var lastProgressTime = 0;
        return downloadRequest.promise
            .progress(function (progress) {
            var isVisibleDownload = [__WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Temp].includes(mode);
            var currentTime = Date.now();
            var timeSinceLastProgress = currentTime - lastProgressTime;
            var isEnoughTimeSinceLastProgress = timeSinceLastProgress > minimumTimeBetweenProgress;
            if (isEnoughTimeSinceLastProgress && isVisibleDownload) {
                lastProgressTime = currentTime;
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["h" /* recordDownloadProgress */])(progress, driveItem.id));
            }
        })
            .then(function () { return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].unzipFile(destFolder + "/" + fileName); })
            .then(function () { return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].removeFile(destFolder + "/" + fileName); })
            .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["y" /* updateDownloadStatus */])(driveItem.id, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].NATIVE_DOWNLOADED)); });
    };
};
var getDependencyIds = function (driveItem) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, dependenciesExclusionIds, dependenciesExclusionTypes, _c, response, dependencyIds;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState().galleryInfos.config.dependencies, _b = (_a === void 0 ? { exclude: { ids: [], types: [] } } : _a).exclude, dependenciesExclusionIds = _b.ids, dependenciesExclusionTypes = _b.types;
                _c = driveItem.type;
                switch (_c) {
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Publication: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Component: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Template: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Gallery: return [3 /*break*/, 1];
                }
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_8__utils_api__["a" /* default */].getOutcomings(driveItem.id)];
            case 2:
                response = _d.sent();
                if (response.outcomings) {
                    dependencyIds = response.outcomings
                        .filter(function (outcoming) { return !(dependenciesExclusionIds.includes(outcoming.id) || dependenciesExclusionTypes.includes(outcoming.type)); })
                        .map(function (outcoming) { return outcoming.id; });
                    return [2 /*return*/, dependencyIds];
                }
                return [2 /*return*/, []];
            case 3: return [2 /*return*/, Q.Promise.resolve([])];
        }
    });
}); }; };
var getDependenciesWithVersions = function (driveItem, level) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, dependenciesExclusionIds, dependenciesExclusionTypes, _c, updatedDependenciesExclusionTypes, response, dependencyVersions;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = getState().galleryInfos.config.dependencies, _b = (_a === void 0 ? { exclude: { ids: [], types: [] } } : _a).exclude, dependenciesExclusionIds = _b.ids, dependenciesExclusionTypes = _b.types;
                _c = driveItem.type;
                switch (_c) {
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Publication: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Component: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Template: return [3 /*break*/, 1];
                    case __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Gallery: return [3 /*break*/, 1];
                }
                return [3 /*break*/, 3];
            case 1:
                updatedDependenciesExclusionTypes = __spread(dependenciesExclusionTypes);
                if (!updatedDependenciesExclusionTypes.includes(__WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].OutcomingType.Directory)) {
                    updatedDependenciesExclusionTypes.push(__WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].OutcomingType.Directory);
                }
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_8__utils_api__["a" /* default */].getOutcomings(driveItem.id, level, updatedDependenciesExclusionTypes, dependenciesExclusionIds)];
            case 2:
                response = _d.sent();
                if (response.outcomings) {
                    dependencyVersions = response.outcomings
                        .filter(function (outcoming) { return !(dependenciesExclusionIds.includes(outcoming.id) || dependenciesExclusionTypes.includes(outcoming.type)); })
                        .map(function (outcoming) { return ({ id: outcoming.id, version: Number(outcoming.version), type: outcoming.type }); });
                    return [2 /*return*/, dependencyVersions];
                }
                return [2 /*return*/, []];
            case 3: return [2 /*return*/, Q.Promise.resolve([])];
        }
    });
}); }; };
var updateDriveItemWithDependencies = function (driveItem, isManualUpdate) {
    if (isManualUpdate === void 0) { isManualUpdate = false; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, dispatch(getDependenciesWithVersions(driveItem, __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].OutcomingsLevel.ALL))
                    .then(function (dependenciesVersion) {
                    if (!isManualUpdate) {
                        driveItem = __assign({}, driveItem, { dependencies: dependenciesVersion });
                        void dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["H" /* updateDriveItem */])(driveItem));
                        return Promise.resolve();
                    }
                    else {
                        var isInGallery = driveItem.isInGallery;
                        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(driveItem.id, isInGallery))
                            .then(function (updatedDriveItem) {
                            updatedDriveItem = __assign({}, updatedDriveItem, { dependencies: dependenciesVersion });
                            void dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["H" /* updateDriveItem */])(updatedDriveItem));
                        });
                    }
                })
                    .catch(function (error) {
                    console.error('Failed to fetch dependencies version:', error);
                })];
        });
    }); };
};
var getInitialDependenciesUpdates = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, items_1, driveItems_1, downloadedIds, updatePromises, error_6;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = getState(), items_1 = _a.downloadManager.items, driveItems_1 = _a.driveList.driveItems;
                downloadedIds = Object.keys(items_1)
                    .filter(function (key) { return items_1[Number(key)].mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested; })
                    .map(Number);
                updatePromises = downloadedIds.map(function (id) { return dispatch(updateDriveItemWithDependencies(driveItems_1[id])); });
                return [4 /*yield*/, Promise.all(updatePromises)];
            case 1:
                _b.sent();
                return [3 /*break*/, 3];
            case 2:
                error_6 = _b.sent();
                console.error('Error in getInitialDependenciesUpdates:', error_6);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var downloadAll = function () { return function (dispatch, getState) {
    var _a = getState(), driveList = _a.driveList, galleryInfos = _a.galleryInfos, applicationGallery = _a.galleryInfos.config.applicationGallery;
    __WEBPACK_IMPORTED_MODULE_13__utils_statistics__["a" /* default */].trackDownloadAll();
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["u" /* startDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].ALL));
    var sharedDirId = __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSharedDirId(driveList, galleryInfos.config);
    // TODO: Armand asked that the download all should not download the shared dir content
    return dispatch(downloadRecursively(applicationGallery, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, true))
        .finally(function () { return sharedDirId && dispatch(downloadRecursively(sharedDirId, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, true)); })
        .finally(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].ALL)); });
}; };
var downloadImportantAssets = function () { return function (dispatch, getState) {
    var _a = getState(), importantAssets = _a.galleryInfos.config.importantAssets, driveItems = _a.driveList.driveItems;
    __WEBPACK_IMPORTED_MODULE_13__utils_statistics__["a" /* default */].trackDownloadImportants();
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["u" /* startDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].IMPORTANT));
    var enabledImportantTags = __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].getEnabledImportantTags(importantAssets);
    var importantAssetIds = [];
    if (enabledImportantTags.length > 0) {
        var allDriveItemIds = Object.keys(driveItems);
        importantAssetIds = allDriveItemIds
            .filter(__WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].filterImportantItems(driveItems, enabledImportantTags));
    }
    var downloadPromises = importantAssetIds
        .map(function (importantAssetId) { return dispatch(downloadRecursively(parseInt(importantAssetId, 10), __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, false, true)); });
    return __WEBPACK_IMPORTED_MODULE_14_promise_allsettled___default()(downloadPromises)
        .finally(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].IMPORTANT)); });
}; };
var downloadSelectedAssets = function () { return function (dispatch, getState) {
    var pendingSelectedDownloads = getState().downloadManager.pendingSelectedDownloads;
    __WEBPACK_IMPORTED_MODULE_13__utils_statistics__["a" /* default */].trackDownloadSelected();
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["u" /* startDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].SELECTED));
    var pendingSelectedDownloadsIds = Object.keys(pendingSelectedDownloads);
    var downloadPromises = pendingSelectedDownloadsIds
        .map(function (pendingSelectedDownloadsId) {
        return dispatch(downloadRecursively(parseInt(pendingSelectedDownloadsId, 10), __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested, true));
    });
    return __WEBPACK_IMPORTED_MODULE_14_promise_allsettled___default()(downloadPromises);
}; };
var downloadRecursively = function (driveItemId, mode, isManualUpdate, isImportant) {
    if (isManualUpdate === void 0) { isManualUpdate = false; }
    if (isImportant === void 0) { isImportant = false; }
    return function (dispatch, getState) {
        var _a = getState(), driveItems = _a.driveList.driveItems, _b = _a.downloadManager, downloadGroups = _b.downloadGroups, items = _b.items;
        var driveItem = driveItems[driveItemId];
        // If driveItem is not found in current state, try to fetch it from cache
        // This can happen when Continue is clicked during content structure update
        if (!driveItem) {
            return Q.Promise.resolve(__WEBPACK_IMPORTED_MODULE_11__utils_indexedDB_manager__["a" /* default */].getStoreDriveList())
                .then(function (cachedDriveList) {
                var _a;
                if (cachedDriveList && cachedDriveList.driveItems[driveItemId]) {
                    driveItem = cachedDriveList.driveItems[driveItemId];
                    // Dispatch to add it to current state so it's available for future calls
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__DriveItemList_actions__["r" /* receiveDriveItems */])((_a = {}, _a[driveItemId] = driveItem, _a)));
                }
                return driveItem;
            })
                .catch(function () {
                // If cache fetch fails, return undefined to continue with error handling below
                return undefined;
            })
                .then(function (resolvedDriveItem) {
                // Check again after trying cache
                if (!resolvedDriveItem && __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].getDownloadingGroup(downloadGroups) === __WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].SELECTED) {
                    dispatch(removePendingSelectedDownload(driveItemId)).then();
                    return Q.Promise.resolve();
                }
                if (!resolvedDriveItem) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["k" /* removeDownloadInProgressItem */])(driveItemId));
                    return Q.Promise.resolve();
                }
                driveItem = resolvedDriveItem;
                return continueDownloadRecursively(driveItem, driveItemId, mode, isImportant, items, downloadGroups, dispatch);
            });
        }
        return continueDownloadRecursively(driveItem, driveItemId, mode, isImportant, items, downloadGroups, dispatch);
    };
};
var continueDownloadRecursively = function (driveItem, driveItemId, mode, isImportant, items, downloadGroups, dispatch) {
    var itemFromDownloadManager = items[driveItem.id] ? items[driveItem.id] : undefined;
    var promise = Q.Promise.resolve();
    if (!__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isOnline()) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__NotificationBar_actions__["c" /* createNotification */])('info.offline_download_multiple_assets'));
        return Q.Promise.reject({});
    }
    var resources = driveItem.resources;
    if (__WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].isDownloadableItemType(driveItem)) {
        if (itemFromDownloadManager) {
            promise = promise
                .then(function () {
                return dispatch(requestMobileAppDownload(driveItem, mode, undefined, true, false, undefined, isImportant));
            });
        }
        else {
            promise = promise.then(function () { return dispatch(requestMobileAppDownload(driveItem, mode)); });
        }
    }
    else {
        Q.Promise.resolve();
    }
    if (resources) {
        // Ensure that each resource is processed sequentially
        promise = resources.reduce(function (acc, resource) {
            return acc.then(function () { return dispatch(downloadRecursively(resource.id, mode)); });
        }, promise);
    }
    return promise;
};
var removePendingSelectedDownload = function (driveItemId) {
    return function (dispatch, getState) {
        var pendingSelectedDownloads = getState().downloadManager.pendingSelectedDownloads;
        var pendingSelectedDownloadsIds = Object.keys(pendingSelectedDownloads).map(function (key) { return Number(key); });
        if (pendingSelectedDownloadsIds.includes(driveItemId)) {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["m" /* removePendingSelectedDownloadItem */])(driveItemId))
                .then(function () {
                // Get the updated state after removing the item
                var state = getState();
                var pendingSelectedDownloadsIdsCount = Object.keys(state.downloadManager.pendingSelectedDownloads).length;
                if (pendingSelectedDownloadsIdsCount === 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].SELECTED));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__store__["p" /* resetTotalSelectedDownloadsInManager */])());
                }
            });
        }
        else {
            return Promise.resolve();
        }
    };
};



/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(299);
var GetIntrinsic = __webpack_require__(19);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getResourceMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isEditorOpened; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfilePage_selectors__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_constants__ = __webpack_require__(59);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;








var getResourceMeta = function (resourceId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, driveItems, parentFolderId, applicationGallery, resource, _b, driveList, config, isAccountManagerOrAdmin, ancestorId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getState(), driveItems = _a.driveList.driveItems, parentFolderId = _a.editor.parentFolderId, applicationGallery = _a.galleryInfos.config.applicationGallery;
                resource = driveItems[resourceId];
                if (!!resource) return [3 /*break*/, 6];
                if (!!parentFolderId) return [3 /*break*/, 3];
                // this call is needed to get privateDirId
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].getMeta(applicationGallery)];
            case 1:
                // this call is needed to get privateDirId
                _c.sent();
                _b = getState(), driveList = _b.driveList, config = _b.galleryInfos.config;
                isAccountManagerOrAdmin = Object(__WEBPACK_IMPORTED_MODULE_1__ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(getState());
                ancestorId = isAccountManagerOrAdmin
                    ? config.applicationGallery
                    : __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getPrivateDirId(driveList, config);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].getMeta(resourceId, true, ancestorId)];
            case 2:
                resource = _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].getMeta(resourceId)];
            case 4:
                resource = _c.sent();
                // a case when resource is actually outside of application (modifiable publication)
                if (__WEBPACK_IMPORTED_MODULE_5__utils_driveItem__["d" /* default */].getParentFolderId(resource) !== parentFolderId) {
                    resource.linkParentId = parentFolderId;
                }
                _c.label = 5;
            case 5:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__DriveItemList_actions__["H" /* updateDriveItem */])(resource));
                _c.label = 6;
            case 6: return [2 /*return*/, resource];
        }
    });
}); }; };
// this check is used to prevent some actions in case user left Editor before it was loaded
var isEditorOpened = function (state) {
    var routerParamsHistory = (state || __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getState()).routerParamsHistory;
    var currentRoute = __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].getCurrentRoute(routerParamsHistory);
    return currentRoute.includes(__WEBPACK_IMPORTED_MODULE_7__routes_constants__["a" /* RoutePath */].Editor);
};


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HistoryActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addToUndos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return undo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return redo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer_history__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editableItems__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spreadBackground__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var HistoryActionKeys;
(function (HistoryActionKeys) {
    HistoryActionKeys["UNDO"] = "@@editor/history/UNDO";
    HistoryActionKeys["REDO"] = "@@editor/history/REDO";
    HistoryActionKeys["ADD_TO_UNDOS"] = "@@editor/history/ADD_TO_UNDOS";
})(HistoryActionKeys || (HistoryActionKeys = {}));
var getSourceDataAndAction = function (undoRedoState, editorState, dispatch) {
    switch (undoRedoState.source) {
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].TEXT_FIELD: {
            var page_1 = undoRedoState.page, id_1 = undoRedoState.id, data_1 = undoRedoState.data;
            return {
                data: editorState.editableTextFields[page_1][id_1],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["j" /* updateEditableTextField */])(page_1, id_1, data_1, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].MEDIA: {
            var page_2 = undoRedoState.page, id_2 = undoRedoState.id, data_2 = undoRedoState.data;
            return {
                data: editorState.editableMedia[page_2][id_2],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["h" /* updateEditableMedia */])(page_2, id_2, data_2, true, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].BUTTON: {
            var page_3 = undoRedoState.page, id_3 = undoRedoState.id, data_3 = undoRedoState.data;
            return {
                data: editorState.editableButtons[page_3][id_3],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["d" /* updateEditableButton */])(page_3, id_3, data_3, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].LINK: {
            var page_4 = undoRedoState.page, id_4 = undoRedoState.id, data_4 = undoRedoState.data;
            return {
                data: editorState.editableLinks[page_4][id_4],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["g" /* updateEditableLink */])(page_4, id_4, data_4, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].ENRICHMENT: {
            var page_5 = undoRedoState.page, id_5 = undoRedoState.id, data_5 = undoRedoState.data;
            return {
                data: editorState.editableEnrichments[page_5][id_5],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["e" /* updateEditableEnrichment */])(page_5, id_5, data_5, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].IFRAME: {
            var page_6 = undoRedoState.page, id_6 = undoRedoState.id, data_6 = undoRedoState.data;
            return {
                data: editorState.editableIframes[page_6][id_6],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["f" /* updateEditableIframe */])(page_6, id_6, data_6, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].SLIDER: {
            var page_7 = undoRedoState.page, id_7 = undoRedoState.id, data_7 = undoRedoState.data;
            return {
                data: editorState.editableSliders[page_7][id_7],
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__editableItems__["i" /* updateEditableSlider */])(page_7, id_7, data_7, true, true, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].CHANGE_SPREAD: {
            var data_8 = undoRedoState.data;
            return {
                data: { currentSpreadIndex: editorState.pagesController.currentSpreadIndex },
                action: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__pagesController__["b" /* changePageSpread */])(data_8.currentSpreadIndex, false)); },
            };
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].SPREAD_BACKGROUND: {
            var page_8 = undoRedoState.page, data_9 = undoRedoState.data;
            return {
                data: editorState.configs.pagesData[page_8 - 1].bgStyle,
                action: function () {
                    var spread = editorState.pagesController.spreads.find(function (spread) { return spread.includes(page_8); });
                    var epubStyle = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isEmptyObject(data_9)
                        ? null
                        : data_9.epubStyle.backgroundMedia;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__spreadBackground__["e" /* setSpreadBackground */])(spread, epubStyle, false, true, true, false));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__spreadBackground__["c" /* saveSpreadBackgroundPages */])());
                },
            };
        }
    }
};
var mergeHistoryItem = function (item, currentData) { return (__assign({}, item, { data: 'isEditedFromBackoffice' in currentData
        ? __assign({}, currentData, { isEditedFromBackoffice: true }) : currentData })); };
var getHistoryActionItem = function (item, currentData) {
    var castedCurrentData;
    switch (item.source) {
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].TEXT_FIELD: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].MEDIA: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].BUTTON: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].LINK: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].ENRICHMENT: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].IFRAME: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].SLIDER: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].CHANGE_SPREAD: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
        case __WEBPACK_IMPORTED_MODULE_0__reducer_history__["a" /* Source */].SPREAD_BACKGROUND: {
            castedCurrentData = currentData;
            return mergeHistoryItem(item, castedCurrentData);
        }
    }
};
var addToUndos = function (item) { return ({
    type: HistoryActionKeys.ADD_TO_UNDOS,
    item: item,
}); };
var undo = function () { return function (dispatch, getState) {
    var _a = getState(), editor = _a.editor, undos = _a.editor.history.undos;
    var lastUndo = undos[undos.length - 1];
    var _b = getSourceDataAndAction(lastUndo, editor, dispatch), currentData = _b.data, undoAction = _b.action;
    var action = {
        type: HistoryActionKeys.UNDO,
        item: getHistoryActionItem(lastUndo, currentData),
    };
    dispatch(action);
    undoAction();
}; };
var redo = function () { return function (dispatch, getState) {
    var _a = getState(), editor = _a.editor, redos = _a.editor.history.redos;
    var firstRedo = redos[0];
    var _b = getSourceDataAndAction(firstRedo, editor, dispatch), currentData = _b.data, redoAction = _b.action;
    var action = {
        type: HistoryActionKeys.REDO,
        item: getHistoryActionItem(firstRedo, currentData),
    };
    dispatch(action);
    redoAction();
}; };


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return undos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return redos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_history__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_combo__ = __webpack_require__(304);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var Source;
(function (Source) {
    Source["TEXT_FIELD"] = "editableTextFields";
    Source["MEDIA"] = "editableMedia";
    Source["LINK"] = "editableLinks";
    Source["BUTTON"] = "editableButtons";
    Source["IFRAME"] = "editableIframes";
    Source["ENRICHMENT"] = "editableEnrichments";
    Source["SLIDER"] = "editableSliders";
    Source["SPREAD_BACKGROUND"] = "spreadBackground";
    Source["CHANGE_SPREAD"] = "changeSpread";
})(Source || (Source = {}));
var defaultState = [];
var undos = function (state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_history__["a" /* HistoryActionKeys */].UNDO:
            return state.slice(0, state.length - 1);
        case __WEBPACK_IMPORTED_MODULE_0__actions_history__["a" /* HistoryActionKeys */].REDO:
            return __spread(state, [action.item]);
        case __WEBPACK_IMPORTED_MODULE_0__actions_history__["a" /* HistoryActionKeys */].ADD_TO_UNDOS:
            return __spread(state, [action.item]);
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
        case __WEBPACK_IMPORTED_MODULE_2__actions_combo__["a" /* ComboActionKeys */].FINISH_COMBO:
            return defaultState;
        default:
            return state;
    }
};
var redos = function (state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_history__["a" /* HistoryActionKeys */].UNDO:
            return __spread([action.item], state);
        case __WEBPACK_IMPORTED_MODULE_0__actions_history__["a" /* HistoryActionKeys */].REDO:
            return state.slice(1);
        case __WEBPACK_IMPORTED_MODULE_0__actions_history__["a" /* HistoryActionKeys */].ADD_TO_UNDOS:
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
        case __WEBPACK_IMPORTED_MODULE_2__actions_combo__["a" /* ComboActionKeys */].FINISH_COMBO:
            return defaultState;
        default:
            return state;
    }
};


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigsActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setConfigsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setEditableTextFieldsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateEditableSliderConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveConfigs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




var ConfigsActionKeys;
(function (ConfigsActionKeys) {
    ConfigsActionKeys["SET_CONFIGS_DATA"] = "@@editor/configs/SET_CONFIGS_DATA";
    ConfigsActionKeys["SET_EDITABLE_TEXT_FIELDS_DATA"] = "@@editor/configs/SET_EDITABLE_TEXT_FIELDS_DATA";
    ConfigsActionKeys["UPDATE_EDITABLE_SLIDER_CONFIG"] = "@@editor/configs/UPDATE_EDITABLE_SLIDER_CONFIG";
})(ConfigsActionKeys || (ConfigsActionKeys = {}));
var setConfigsData = function (data) { return ({
    type: ConfigsActionKeys.SET_CONFIGS_DATA,
    data: data,
}); };
var setEditableTextFieldsData = function (page, data) { return ({
    type: ConfigsActionKeys.SET_EDITABLE_TEXT_FIELDS_DATA,
    page: page,
    data: data,
}); };
var updateEditableSliderConfig = function (page, id, data, shouldSave) {
    if (shouldSave === void 0) { shouldSave = true; }
    return function (dispatch) {
        var action = {
            type: ConfigsActionKeys.UPDATE_EDITABLE_SLIDER_CONFIG,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        if (shouldSave) {
            dispatch(saveConfigs());
        }
    };
};
var saveConfigs = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var requestId, _a, clientId, resourceId, configs, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                requestId = 'save-configs';
                __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].cancelRequest(requestId);
                _a = Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _a.clientId, resourceId = _a.tempGId;
                configs = getState().editor.configs;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].saveIndesignEditorConfigs(clientId, resourceId, JSON.stringify(configs), requestId)];
            case 1:
                _b.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _b.sent();
                // status is 0 for cancelled request, no need to display a notification
                if (error_1.status !== 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.save_editor_data_error'));
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilesToDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilesToDisplayIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getImportedFilesNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFilesWithErrorNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCanceledFilesNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUploadingFilesSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(114);

var getFilesToDisplay = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function (state) { return state.importManager.byId; }, function (byId) { return (Object.values(byId).filter(function (_a) {
    var shouldDisplayInToast = _a.shouldDisplayInToast;
    return shouldDisplayInToast;
})); });
var getFilesToDisplayIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFilesToDisplay, function (filesToDisplay) { return filesToDisplay.map(function (_a) {
    var id = _a.id;
    return id;
}); });
var getImportedFilesNumber = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFilesToDisplay, function (filesToDisplay) { return filesToDisplay.filter(function (_a) {
    var isImportFinished = _a.isImportFinished;
    return isImportFinished;
}).length; });
var getFilesWithErrorNumber = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFilesToDisplay, function (filesToDisplay) { return filesToDisplay.filter(function (_a) {
    var error = _a.error;
    return !!error;
}).length; });
var getCanceledFilesNumber = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFilesToDisplay, function (filesToDisplay) { return filesToDisplay.filter(function (_a) {
    var isImportCanceled = _a.isImportCanceled;
    return isImportCanceled;
}).length; });
var getUploadingFiles = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getFilesToDisplay, function (filesToDisplay) { return filesToDisplay.filter(function (_a) {
    var isImportFinished = _a.isImportFinished, isImportCanceled = _a.isImportCanceled, error = _a.error;
    return (!isImportFinished && !isImportCanceled && !error);
}); });
var getUploadingFilesSize = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getUploadingFiles, function (uploadingFiles) { return uploadingFiles.reduce(function (acc, current) {
    acc += current.file.size;
    return acc;
}, 0); });


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Annotation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Block; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Data; });
/* unused harmony export Decoration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Document; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Editor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Inline; });
/* unused harmony export KeyUtils */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Leaf$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Mark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Node; });
/* unused harmony export Operation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PathUtils; });
/* unused harmony export Point */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Range; });
/* unused harmony export resetMemoization */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Selection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Text; });
/* unused harmony export TextUtils */
/* unused harmony export useMemoization */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Value; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_plain_object__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_invariant__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_esrever__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_esrever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_esrever__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pick__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_direction__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_direction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_direction__);










/**
 * An auto-incrementing index for generating keys.
 *
 * @type {Number}
 */

var n = void 0;

/**
 * The global key generating function.
 *
 * @type {Function}
 */

var generate = void 0;

/**
 * Create a key, using a provided key if available.
 *
 * @param {String|Void} key
 * @return {String}
 */

function create(key) {
  if (key == null) {
    return generate();
  }

  if (typeof key === 'string') {
    return key;
  }

  throw new Error('Keys must be strings, but you passed: ' + key);
}

/**
 * Set a different unique ID generating `function`.
 *
 * @param {Function} func
 */

function setGenerator(func) {
  generate = func;
}

/**
 * Reset the key generating function to its initial state.
 */

function resetGenerator() {
  n = 0;
  generate = function generate() {
    return '' + n++;
  };
}

/**
 * Set the initial state.
 */

resetGenerator();

/**
 * Export.
 *
 * @type {Object}
 */

var KeyUtils = {
  create: create,
  setGenerator: setGenerator,
  resetGenerator: resetGenerator
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};





var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Compare paths `path` and `target` to see which is before or after.
 *
 * @param {List} path
 * @param {List} target
 * @return {Number|Null}
 */

function compare(path, target) {
  var m = min(path, target);

  for (var i = 0; i < m; i++) {
    var pv = path.get(i);
    var tv = target.get(i);

    // If the path's value is ever less than the target's, it's before.
    if (pv < tv) return -1;

    // If the target's value is ever less than the path's, it's after.
    if (pv > tv) return 1;
  }

  // Paths should now be equal, otherwise something is wrong
  return path.size === target.size ? 0 : null;
}

/**
 * Create a path from `attrs`.
 *
 * @param {Array|List} attrs
 * @return {List}
 */

function create$1(attrs) {
  if (attrs == null) {
    return null;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(attrs)) {
    return attrs;
  }

  if (Array.isArray(attrs)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(attrs);
  }

  throw new Error('Paths can only be created from arrays or lists, but you passed: ' + attrs);
}

/**
 * Crop paths `a` and `b` to an equal size, defaulting to the shortest.
 *
 * @param {List} a
 * @param {List} b
 */

function crop(a, b) {
  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : min(a, b);

  var ca = a.slice(0, size);
  var cb = b.slice(0, size);
  return [ca, cb];
}

/**
 * Decrement a `path` by `n` at `index`, defaulting to the last index.
 *
 * @param {List} path
 * @param {Number} n
 * @param {Number} index
 */

function decrement(path) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : path.size - 1;

  return increment(path, 0 - n, index);
}

/**
 * Get all ancestor paths of th given path.
 *
 * @param {List} path
 * @returns {List}
 */

function getAncestors(path) {
  var ancestors = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])().withMutations(function (list) {
    for (var i = 0; i < path.size; i++) {
      list.push(path.slice(0, i));
    }
  });

  return ancestors;
}

/**
 * Increment a `path` by `n` at `index`, defaulting to the last index.
 *
 * @param {List} path
 * @param {Number} n
 * @param {Number} index
 */

function increment(path) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : path.size - 1;

  var value = path.get(index);
  var newValue = value + n;
  var newPath = path.set(index, newValue);
  return newPath;
}

/**
 * Is a `path` above another `target` path?
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isAbove(path, target) {
  var _crop = crop(path, target),
      _crop2 = slicedToArray(_crop, 2),
      p = _crop2[0],
      t = _crop2[1];

  return path.size < target.size && compare(p, t) === 0;
}

/**
 * Is a `path` after another `target` path in a document?
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isAfter(path, target) {
  var _crop3 = crop(path, target),
      _crop4 = slicedToArray(_crop3, 2),
      p = _crop4[0],
      t = _crop4[1];

  return compare(p, t) === 1;
}

/**
 * Is a `path` before another `target` path in a document?
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isBefore(path, target) {
  var _crop5 = crop(path, target),
      _crop6 = slicedToArray(_crop5, 2),
      p = _crop6[0],
      t = _crop6[1];

  return compare(p, t) === -1;
}

/**
 * Is a `path` equal to another `target` path in a document?
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isEqual(path, target) {
  return path.equals(target);
}

/**
 * Is a `path` older than a `target` path? Meaning that it ends as an older
 * sibling of one of the indexes in the target.
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isOlder(path, target) {
  var index = path.size - 1;

  var _crop7 = crop(path, target, index),
      _crop8 = slicedToArray(_crop7, 2),
      p = _crop8[0],
      t = _crop8[1];

  var pl = path.get(index);
  var tl = target.get(index);
  return isEqual(p, t) && pl > tl;
}

/**
 * Is an `any` object a path?
 *
 * @param {Mixed} any
 * @return {Boolean}
 */

function isPath(any) {
  return (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) || Array.isArray(any)) && any.every(function (n) {
    return typeof n === 'number';
  });
}

/**
 * Is a `path` a sibling of a `target` path?
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isSibling(path, target) {
  if (path.size !== target.size) return false;
  var p = path.butLast();
  var t = target.butLast();
  return p.equals(t);
}

/**
 * Is a `path` younger than a `target` path? Meaning that it ends as a younger
 * sibling of one of the indexes in the target.
 *
 * @param {List} path
 * @param {List} target
 * @return {Boolean}
 */

function isYounger(path, target) {
  var index = path.size - 1;

  var _crop9 = crop(path, target, index),
      _crop10 = slicedToArray(_crop9, 2),
      p = _crop10[0],
      t = _crop10[1];

  var pl = path.get(index);
  var tl = target.get(index);
  return isEqual(p, t) && pl < tl;
}

/**
 * Lift a `path` to refer to its `n`th ancestor.
 *
 * @param {List} path
 * @return {List}
 */

function lift(path) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var ancestor = path.slice(0, -1 * n);
  return ancestor;
}

/**
 * Drop a `path`, returning a relative path from a depth of `n`.
 *
 * @param {List} path
 * @param {Number} n
 * @return {List}
 */

function drop(path) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var relative = path.slice(n);
  return relative;
}

/**
 * Get the maximum length of paths `a` and `b`.
 *
 * @param {List} path
 * @param {List} path
 * @return {Number}
 */

function max(a, b) {
  var n = Math.max(a.size, b.size);
  return n;
}

/**
 * Get the minimum length of paths `a` and `b`.
 *
 * @param {List} path
 * @param {List} path
 * @return {Number}
 */

function min(a, b) {
  var n = Math.min(a.size, b.size);
  return n;
}

/**
 * Get the common ancestor path of path `a` and path `b`.
 *
 * @param {List} a
 * @param {List} b
 * @return {List}
 */

function relate(a, b) {
  var array = [];

  for (var i = 0; i < a.size && i < b.size; i++) {
    var av = a.get(i);
    var bv = b.get(i);

    // If the values aren't equal, they've diverged and don't share an ancestor.
    if (av !== bv) break;

    // Otherwise, the current value is still a common ancestor.
    array.push(av);
  }

  var path = create$1(array);
  return path;
}

/**
 * Transform a `path` by an `operation`, adjusting it to stay current.
 *
 * @param {List} path
 * @param {Operation} operation
 * @return {List<List>}
 */

function transform(path, operation) {
  var type = operation.type,
      position = operation.position,
      p = operation.path;


  if (type === 'add_mark' || type === 'insert_text' || type === 'remove_mark' || type === 'remove_text' || type === 'set_mark' || type === 'set_node' || type === 'set_selection' || type === 'set_value' || type === 'add_annotation' || type === 'remove_annotation' || type === 'set_annotation' || path.size === 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([path]);
  }

  var pIndex = p.size - 1;
  var pEqual = isEqual(p, path);
  var pYounger = isYounger(p, path);
  var pAbove = isAbove(p, path);

  if (type === 'insert_node') {
    if (pEqual || pYounger || pAbove) {
      path = increment(path, 1, pIndex);
    }
  }

  if (type === 'remove_node') {
    if (pYounger) {
      path = decrement(path, 1, pIndex);
    } else if (pEqual || pAbove) {
      path = [];
    }
  }

  if (type === 'merge_node') {
    if (pEqual || pYounger) {
      path = decrement(path, 1, pIndex);
    } else if (pAbove) {
      path = decrement(path, 1, pIndex);
      path = increment(path, position, pIndex + 1);
    }
  }

  if (type === 'split_node') {
    if (pEqual) {
      path = [path, increment(path)];
    } else if (pYounger) {
      path = increment(path, 1, pIndex);
    } else if (pAbove) {
      if (path.get(pIndex + 1) >= position) {
        path = increment(path, 1, pIndex);
        path = decrement(path, position, pIndex + 1);
      }
    }
  }

  if (type === 'move_node') {
    var np = operation.newPath;


    if (isEqual(p, np)) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([path]);
    }

    if (pAbove || pEqual) {
      // We are comparing something that was moved
      // The new path is unaffected unless the old path was the left-sibling of an ancestor
      if (isYounger(p, np) && p.size < np.size) {
        path = decrement(np, 1, min(np, p) - 1).concat(path.slice(p.size));
      } else {
        path = np.concat(path.slice(p.size));
      }
    } else {
      // This is equivalent logic to remove_node for path
      if (pYounger) {
        path = decrement(path, 1, pIndex);
      }

      // This is the equivalent logic to insert_node for newPath
      if (isYounger(np, path) || isEqual(np, path) || isAbove(np, path)) {
        path = increment(path, 1, np.size - 1);
      }
    }
  }

  var paths = Array.isArray(path) ? path : [path];
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(paths);
}

/**
 * Export.
 *
 * @type {Object}
 */

var PathUtils = {
  compare: compare,
  create: create$1,
  crop: crop,
  decrement: decrement,
  getAncestors: getAncestors,
  increment: increment,
  isAbove: isAbove,
  isAfter: isAfter,
  isBefore: isBefore,
  isEqual: isEqual,
  isOlder: isOlder,
  isPath: isPath,
  isSibling: isSibling,
  isYounger: isYounger,
  lift: lift,
  drop: drop,
  max: max,
  min: min,
  relate: relate,
  transform: transform
};

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS = {
  key: undefined,
  offset: undefined,
  path: undefined

  /**
   * Point.
   *
   * @type {Point}
   */

};
var Point = function (_Record) {
  inherits(Point, _Record);

  function Point() {
    classCallCheck(this, Point);
    return possibleConstructorReturn(this, (Point.__proto__ || Object.getPrototypeOf(Point)).apply(this, arguments));
  }

  createClass(Point, [{
    key: 'isAfterPoint',


    /**
     * Check whether the point is after another `point`.
     *
     * @return {Boolean}
     */

    value: function isAfterPoint(point) {
      if (this.isUnset) return false;
      var is$$1 = this.key === point.key && this.offset > point.offset || PathUtils.compare(this.path, point.path) === 1;
      return is$$1;
    }

    /**
     * Check whether the point is after a `range`.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isAfterRange',
    value: function isAfterRange(range) {
      if (this.isUnset) return false;
      var is$$1 = this.isAfterPoint(range.end);
      return is$$1;
    }

    /**
     * Check whether the point is at the end of a `range`.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isAtEndOfRange',
    value: function isAtEndOfRange(range) {
      if (this.isUnset) return false;
      var is$$1 = this.equals(range.end);
      return is$$1;
    }

    /**
     * Check whether the point is at the start of a `range`.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isAtStartOfRange',
    value: function isAtStartOfRange(range) {
      if (this.isUnset) return false;
      var is$$1 = this.equals(range.start);
      return is$$1;
    }

    /**
     * Check whether the point is before another `point`.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isBeforePoint',
    value: function isBeforePoint(point) {
      if (this.isUnset) return false;
      var is$$1 = this.key === point.key && this.offset < point.offset || PathUtils.compare(this.path, point.path) === -1;
      return is$$1;
    }

    /**
     * Check whether the point is before a `range`.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isBeforeRange',
    value: function isBeforeRange(range) {
      if (this.isUnset) return false;
      var is$$1 = this.isBeforePoint(range.start);
      return is$$1;
    }

    /**
     * Check whether the point is inside a `range`.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isInRange',
    value: function isInRange(range) {
      if (this.isUnset) return false;
      var is$$1 = this.equals(range.start) || this.equals(range.end) || this.isAfterPoint(range.start) && this.isBeforePoint(range.end);
      return is$$1;
    }

    /**
     * Check whether the point is at the end of a `node`.
     *
     * @param {Node} node
     * @return {Boolean}
     */

  }, {
    key: 'isAtEndOfNode',
    value: function isAtEndOfNode(node) {
      if (this.isUnset) return false;
      var last = node.getLastText();
      var is$$1 = this.key === last.key && this.offset === last.text.length;
      return is$$1;
    }

    /**
     * Check whether the point is at the start of a `node`.
     *
     * @param {Node} node
     * @return {Boolean}
     */

  }, {
    key: 'isAtStartOfNode',
    value: function isAtStartOfNode(node) {
      if (this.isUnset) return false;

      // PERF: Do a check for a `0` offset first since it's quickest.
      if (this.offset !== 0) return false;

      var first = node.getFirstText();
      var is$$1 = this.key === first.key;
      return is$$1;
    }

    /**
     * Check whether the point is in a `node`.
     *
     * @param {Node} node
     * @return {Boolean}
     */

  }, {
    key: 'isInNode',
    value: function isInNode(node) {
      if (this.isUnset) return false;
      if (node.object === 'text' && node.key === this.key) return true;
      if (node.hasNode(this.key)) return true;
      return false;
    }

    /**
     * Move the point's offset backward `n` characters.
     *
     * @param {Number} n (optional)
     * @return {Point}
     */

  }, {
    key: 'moveBackward',
    value: function moveBackward() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      if (n === 0) return this;
      if (n < 0) return this.moveForward(-n);
      var point = this.setOffset(this.offset - n);
      return point;
    }

    /**
     * Move the point's offset forward `n` characters.
     *
     * @param {Number} n (optional)
     * @return {Point}
     */

  }, {
    key: 'moveForward',
    value: function moveForward() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      if (n === 0) return this;
      if (n < 0) return this.moveBackward(-n);
      var point = this.setOffset(this.offset + n);
      return point;
    }

    /**
     * Move the point's anchor point to a new `path` and `offset`.
     *
     * Optionally, the `path` can be a key string, or omitted entirely in which
     * case it would be the offset number.
     *
     * @param {List|String|Number} path
     * @param {Number} offset
     * @return {Point}
     */

  }, {
    key: 'moveTo',
    value: function moveTo(path) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this.key;

      if (typeof path === 'number') {
        offset = path;
        path = this.path;
      } else if (typeof path === 'string') {
        key = path;
        path = key === this.key ? this.path : null;
      } else {
        key = path.equals(this.path) ? this.key : null;
      }

      var point = this.merge({ key: key, path: path, offset: offset });
      return point;
    }

    /**
     * Move the point's anchor point to the start of a `node`.
     *
     * @param {Node} node
     * @return {Point}
     */

  }, {
    key: 'moveToStartOfNode',
    value: function moveToStartOfNode(node) {
      var first = node.getFirstText();
      var point = this.moveTo(first.key, 0);
      return point;
    }

    /**
     * Move the point's anchor point to the end of a `node`.
     *
     * @param {Node} node
     * @return {Point}
     */

  }, {
    key: 'moveToEndOfNode',
    value: function moveToEndOfNode(node) {
      var last = node.getLastText();
      var point = this.moveTo(last.key, last.text.length);
      return point;
    }

    /**
     * Normalize the point relative to a `node`, ensuring that its key and path
     * reference a text node, or that it gets unset.
     *
     * @param {Node} node
     * @return {Point}
     */

  }, {
    key: 'normalize',
    value: function normalize(node) {
      // If both the key and path are null, there's no reference to a node, so
      // make sure it is entirely unset.
      if (this.key == null && this.path == null) {
        return this.setOffset(null);
      }

      var key = this.key,
          offset = this.offset,
          path = this.path;

      // PERF: this function gets called a lot.
      // to avoid creating the key -> path lookup table, we attempt to look up by path first.

      var target = path && node.getNode(path);

      if (!target) {
        target = node.getNode(key);

        if (target) {
          // There is a misalignment of path and key
          var _point = this.merge({
            path: node.getPath(key)
          });

          return _point;
        }
      }

      if (!target) {
        Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "A point's `path` or `key` invalid and was reset!");

        var text = node.getFirstText();
        if (!text) return Point.create();

        var _point2 = this.merge({
          key: text.key,
          offset: 0,
          path: node.getPath(text.key)
        });

        return _point2;
      }

      if (target.object !== 'text') {
        Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'A point should not reference a non-text node!');

        var _text = target.getTextAtOffset(offset);
        var before = target.getOffset(_text.key);
        var _point3 = this.merge({
          offset: offset - before,
          key: _text.key,
          path: node.getPath(_text.key)
        });

        return _point3;
      }

      if (target && path && key && key !== target.key) {
        Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "A point's `key` did not match its `path`!");

        // TODO: if we look up by path above and it differs by key, do we want to reset it to looking up by key?
      }

      var point = this.merge({
        key: target.key,
        path: path == null ? node.getPath(target.key) : path,
        offset: offset == null ? 0 : Math.min(offset, target.text.length)
      });

      // COMPAT: There is an ambiguity, since a point can exist at the end of a
      // text node, or at the start of the following one. To eliminate it we
      // enforce that if there is a following text node, we always move it there.
      if (point.offset === target.text.length) {
        var block = node.getClosestBlock(point.path);
        // TODO: this next line is broken because `getNextText` takes a path
        var next = block.getNextText();

        if (next) {
          point = point.merge({
            key: next.key,
            path: node.getPath(next.key),
            offset: 0
          });
        }
      }

      return point;
    }

    /**
     * Set the point's key to a new `key`.
     *
     * @param {String} key
     * @return {Point}
     */

  }, {
    key: 'setKey',
    value: function setKey(key) {
      if (key != null) {
        key = KeyUtils.create(key);
      }

      var point = this.set('key', key);
      return point;
    }

    /**
     * Set the point's offset to a new `offset`.
     *
     * @param {Number} offset
     * @return {Point}
     */

  }, {
    key: 'setOffset',
    value: function setOffset(offset) {
      var point = this.set('offset', offset);
      return point;
    }

    /**
     * Set the point's path to a new `path`.
     *
     * @param {List|Array} path
     * @return {Point}
     */

  }, {
    key: 'setPath',
    value: function setPath(path) {
      if (path != null) {
        path = PathUtils.create(path);
      }

      var point = this.set('path', path);
      return point;
    }

    /**
     * Return a JSON representation of the point.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        key: this.key,
        offset: this.offset,
        path: this.path && this.path.toArray()
      };

      if (!options.preserveKeys) {
        delete object.key;
      }

      return object;
    }

    /**
     * Unset the point.
     *
     * @return {Point}
     */

  }, {
    key: 'unset',
    value: function unset() {
      return this.merge({
        key: null,
        offset: null,
        path: null
      });
    }
  }, {
    key: 'isSet',


    /**
     * Check whether all properties of the point are set.
     *
     * @return {Boolean}
     */

    get: function get$$1() {
      return this.key != null && this.offset != null && this.path != null;
    }

    /**
     * Check whether any property of the point is not set.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isUnset',
    get: function get$$1() {
      return !this.isSet;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Point` with `attrs`.
     *
     * @param {Object|Point} attrs
     * @return {Point}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Point.isPoint(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Point.fromJSON(attrs);
      }

      throw new Error('`Point.create` only accepts objects or points, but you passed it: ' + attrs);
    }

    /**
     * Create a dictionary of settable point properties from `attrs`.
     *
     * @param {Object|Point} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Point.isPoint(a)) {
        return {
          key: a.key,
          offset: a.offset,
          path: a.path
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(a)) {
        var p = {};
        if ('key' in a) p.key = a.key;
        if ('offset' in a) p.offset = a.offset;
        if ('path' in a) p.path = PathUtils.create(a.path);

        // If only a path is set, or only a key is set, ensure that the other is
        // set to null so that it can be normalized back to the right value.
        // Otherwise we won't realize that the path and key don't match anymore.
        if ('path' in a && !('key' in a)) p.key = null;
        if ('key' in a && !('path' in a)) p.path = null;

        return p;
      }

      throw new Error('`Point.createProperties` only accepts objects or points, but you passed it: ' + a);
    }

    /**
     * Create a `Point` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Point}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var _object$key = object.key,
          key = _object$key === undefined ? null : _object$key,
          _object$offset = object.offset,
          offset = _object$offset === undefined ? null : _object$offset,
          _object$path = object.path,
          path = _object$path === undefined ? null : _object$path;


      var point = new Point({
        key: key,
        offset: offset,
        path: PathUtils.create(path)
      });

      return point;
    }
  }]);
  return Point;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS));

/**
 * Data.
 *
 * This isn't an immutable record, it's just a thin wrapper around `Map` so that
 * we can allow for more convenient creation.
 *
 * @type {Object}
 */

var Data = function () {
  function Data() {
    classCallCheck(this, Data);
  }

  createClass(Data, null, [{
    key: 'create',

    /**
     * Create a new `Data` with `attrs`.
     *
     * @param {Object|Data|Map} attrs
     * @return {Data} data
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"].isMap(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Data.fromJSON(attrs);
      }

      throw new Error('`Data.create` only accepts objects or maps, but you passed it: ' + attrs);
    }

    /**
     * Create a `Data` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Data}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      return new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](object);
    }

    /**
     * Alias `fromJS`.
     */

  }]);
  return Data;
}();

/**
 * Export.
 *
 * @type {Object}
 */

Data.fromJS = Data.fromJSON;

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$1 = {
  data: undefined,
  type: undefined

  /**
   * Mark.
   *
   * @type {Mark}
   */

};
var Mark = function (_Record) {
  inherits(Mark, _Record);

  function Mark() {
    classCallCheck(this, Mark);
    return possibleConstructorReturn(this, (Mark.__proto__ || Object.getPrototypeOf(Mark)).apply(this, arguments));
  }

  createClass(Mark, [{
    key: 'toJSON',


    /**
     * Return a JSON representation of the mark.
     *
     * @return {Object}
     */

    value: function toJSON() {
      var object = {
        object: this.object,
        type: this.type,
        data: this.data.toJSON()
      };

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Mark` with `attrs`.
     *
     * @param {Object|Mark} attrs
     * @return {Mark}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Mark.isMark(attrs)) {
        return attrs;
      }

      if (typeof attrs === 'string') {
        attrs = { type: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Mark.fromJSON(attrs);
      }

      throw new Error('`Mark.create` only accepts objects, strings or marks, but you passed it: ' + attrs);
    }

    /**
     * Create a set of marks.
     *
     * @param {Array<Object|Mark>} elements
     * @return {Set<Mark>}
     */

  }, {
    key: 'createSet',
    value: function createSet(elements) {
      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"].isSet(elements) || Array.isArray(elements)) {
        var marks = new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"](elements.map(Mark.create));
        return marks;
      }

      if (elements == null) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
      }

      throw new Error('`Mark.createSet` only accepts sets, arrays or null, but you passed it: ' + elements);
    }

    /**
     * Create a dictionary of settable mark properties from `attrs`.
     *
     * @param {Object|String|Mark} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Mark.isMark(attrs)) {
        return {
          data: attrs.data,
          type: attrs.type
        };
      }

      if (typeof attrs === 'string') {
        return { type: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        var props = {};
        if ('type' in attrs) props.type = attrs.type;
        if ('data' in attrs) props.data = Data.create(attrs.data);
        return props;
      }

      throw new Error('`Mark.createProperties` only accepts objects, strings or marks, but you passed it: ' + attrs);
    }

    /**
     * Create a `Mark` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Mark}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          type = object.type;


      if (typeof type !== 'string') {
        throw new Error('`Mark.fromJS` requires a `type` string.');
      }

      var mark = new Mark({
        type: type,
        data: new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](data)
      });

      return mark;
    }

    /**
     * Check if `any` is a set of marks.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isMarkSet',
    value: function isMarkSet(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"].isSet(any) && any.every(function (item) {
        return Mark.isMark(item);
      });
    }
  }]);
  return Mark;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$1));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$2 = {
  type: undefined,
  data: undefined,
  anchor: undefined,
  focus: undefined

  /**
   * Decoration.
   *
   * @type {Decoration}
   */

};
var Decoration = function (_Record) {
  inherits(Decoration, _Record);

  function Decoration() {
    classCallCheck(this, Decoration);
    return possibleConstructorReturn(this, (Decoration.__proto__ || Object.getPrototypeOf(Decoration)).apply(this, arguments));
  }

  createClass(Decoration, [{
    key: 'setProperties',


    /**
     * Set new `properties` on the decoration.
     *
     * @param {Object|Range|Selection} properties
     * @return {Range}
     */

    value: function setProperties(properties) {
      properties = Decoration.createProperties(properties);
      var decoration = this.merge(properties);
      return decoration;
    }

    /**
     * Return a JSON representation of the decoration.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        type: this.type,
        data: this.data.toJSON(),
        anchor: this.anchor.toJSON(options),
        focus: this.focus.toJSON(options)
      };

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Decoration` with `attrs`.
     *
     * @param {Object|Decoration} attrs
     * @return {Decoration}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Decoration.isDecoration(attrs)) {
        return attrs;
      }

      if (Range.isRange(attrs)) {
        return Decoration.fromJSON(Range.createProperties(attrs));
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Decoration.fromJSON(attrs);
      }

      throw new Error('`Decoration.create` only accepts objects or decorations, but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Ranges` from `elements`.
     *
     * @param {Array<Decoration|Object>|List<Decoration|Object>} elements
     * @return {List<Decoration>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(elements) || Array.isArray(elements)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](elements.map(Decoration.create));
        return list;
      }

      throw new Error('`Decoration.createList` only accepts arrays or lists, but you passed it: ' + elements);
    }

    /**
     * Create a dictionary of settable decoration properties from `attrs`.
     *
     * @param {Object|String|Decoration} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Decoration.isDecoration(a)) {
        return {
          type: a.type,
          data: a.data,
          anchor: Point.createProperties(a.anchor),
          focus: Point.createProperties(a.focus),
          mark: Mark.create(a.mark)
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(a)) {
        var p = {};
        if ('type' in a) p.type = a.type;
        if ('data' in a) p.data = Data.create(a.data);
        if ('anchor' in a) p.anchor = Point.create(a.anchor);
        if ('focus' in a) p.focus = Point.create(a.focus);
        return p;
      }

      throw new Error('`Decoration.createProperties` only accepts objects or decorations, but you passed it: ' + a);
    }

    /**
     * Create a `Decoration` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Decoration}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var anchor = object.anchor,
          focus = object.focus;
      var type = object.type,
          data = object.data;


      if (object.mark && !type) {
        Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47 the `decoration.mark` property has been changed to `decoration.type` and `decoration.data` directly.');

        type = object.mark.type;
        data = object.mark.data;
      }

      if (!type) {
        throw new Error('Decorations must be created with a `type`, but you passed: ' + JSON.stringify(object));
      }

      var decoration = new Decoration({
        type: type,
        data: Data.create(data || {}),
        anchor: Point.fromJSON(anchor || {}),
        focus: Point.fromJSON(focus || {})
      });

      return decoration;
    }
  }]);
  return Decoration;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$2));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$3 = {
  anchor: undefined,
  focus: undefined,
  isFocused: undefined,
  marks: undefined

  /**
   * Selection.
   *
   * @type {Selection}
   */

};
var Selection = function (_Record) {
  inherits(Selection, _Record);

  function Selection() {
    classCallCheck(this, Selection);
    return possibleConstructorReturn(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).apply(this, arguments));
  }

  createClass(Selection, [{
    key: 'setIsFocused',


    /**
     * Set the `isFocused` property to a new `value`.
     *
     * @param {Boolean} value
     * @return {Selection}
     */

    value: function setIsFocused(value) {
      var selection = this.set('isFocused', value);
      return selection;
    }

    /**
     * Set the `marks` property to a new set of `marks`.
     *
     * @param {Set} marks
     * @return {Selection}
     */

  }, {
    key: 'setMarks',
    value: function setMarks(marks) {
      var selection = this.set('marks', marks);
      return selection;
    }

    /**
     * Set new `properties` on the selection.
     *
     * @param {Object|Range|Selection} properties
     * @return {Range}
     */

  }, {
    key: 'setProperties',
    value: function setProperties(properties) {
      properties = Selection.createProperties(properties);
      var _properties = properties,
          anchor = _properties.anchor,
          focus = _properties.focus,
          props = objectWithoutProperties(_properties, ['anchor', 'focus']);


      if (anchor) {
        props.anchor = Point.create(anchor);
      }

      if (focus) {
        props.focus = Point.create(focus);
      }

      var selection = this.merge(props);
      return selection;
    }

    /**
     * Return a JSON representation of the selection.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        anchor: this.anchor.toJSON(options),
        focus: this.focus.toJSON(options),
        isFocused: this.isFocused,
        marks: this.marks == null ? null : this.marks.toArray().map(function (m) {
          return m.toJSON();
        })
      };

      return object;
    }
  }, {
    key: 'isBlurred',


    /**
     * Check whether the selection is blurred.
     *
     * @return {Boolean}
     */

    get: function get$$1() {
      return !this.isFocused;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Selection` with `attrs`.
     *
     * @param {Object|Selection} attrs
     * @return {Selection}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Selection.isSelection(attrs)) {
        return attrs;
      }

      if (Range.isRange(attrs)) {
        return Selection.fromJSON(Range.createProperties(attrs));
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Selection.fromJSON(attrs);
      }

      throw new Error('`Selection.create` only accepts objects, ranges or selections, but you passed it: ' + attrs);
    }

    /**
     * Create a dictionary of settable selection properties from `attrs`.
     *
     * @param {Object|String|Selection} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Selection.isSelection(a)) {
        return {
          anchor: Point.createProperties(a.anchor),
          focus: Point.createProperties(a.focus),
          isFocused: a.isFocused,
          marks: a.marks
        };
      }

      if (Range.isRange(a)) {
        return {
          anchor: Point.createProperties(a.anchor),
          focus: Point.createProperties(a.focus)
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(a)) {
        var p = {};
        if ('anchor' in a) p.anchor = Point.create(a.anchor);
        if ('focus' in a) p.focus = Point.create(a.focus);
        if ('isFocused' in a) p.isFocused = a.isFocused;
        if ('marks' in a) p.marks = a.marks == null ? null : Mark.createSet(a.marks);
        return p;
      }

      throw new Error('`Selection.createProperties` only accepts objects, ranges or selections, but you passed it: ' + a);
    }

    /**
     * Create a `Selection` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Selection}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var anchor = object.anchor,
          focus = object.focus,
          _object$isFocused = object.isFocused,
          isFocused = _object$isFocused === undefined ? false : _object$isFocused,
          _object$marks = object.marks,
          marks = _object$marks === undefined ? null : _object$marks;

      var selection = new Selection({
        anchor: Point.fromJSON(anchor || {}),
        focus: Point.fromJSON(focus || {}),
        isFocused: isFocused,
        marks: marks == null ? null : new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"](marks.map(Mark.fromJSON))
      });

      return selection;
    }
  }]);
  return Selection;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$3));

/**
 * Slate-specific object types.
 *
 * @type {Object}
 */

var TYPES = {
  annotation: '@@__SLATE_ANNOTATION__@@',
  block: '@@__SLATE_BLOCK__@@',
  change: '@@__SLATE_CHANGE__@@',
  decoration: '@@__SLATE_DECORATION__@@',
  document: '@@__SLATE_DOCUMENT__@@',
  editor: '@@__SLATE_EDITOR__@@',
  inline: '@@__SLATE_INLINE__@@',
  leaf: '@@__SLATE_LEAF__@@',
  mark: '@@__SLATE_MARK__@@',
  operation: '@@__SLATE_OPERATION__@@',
  point: '@@__SLATE_POINT__@@',
  range: '@@__SLATE_RANGE__@@',
  selection: '@@__SLATE_SELECTION__@@',
  text: '@@__SLATE_TEXT__@@',
  value: '@@__SLATE_VALUE__@@'

  /**
   * Determine whether a `value` is of `type`.
   *
   * @param {string} type
   * @param {any} value
   * @return {boolean}
   */

};function isObject(type, value) {
  return !!(value && value[TYPES[type]]);
}

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$4 = {
  anchor: undefined,
  focus: undefined

  /**
   * Range.
   *
   * @type {Range}
   */

};
var Range = function (_Record) {
  inherits(Range, _Record);

  function Range() {
    classCallCheck(this, Range);
    return possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).apply(this, arguments));
  }

  createClass(Range, [{
    key: 'toJSON',


    /**
     * Return a JSON representation of the range.
     *
     * @param {Object} options
     * @return {Object}
     */

    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        anchor: this.anchor.toJSON(options),
        focus: this.focus.toJSON(options)
      };

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Range` with `attrs`.
     *
     * @param {Object|Range} attrs
     * @return {Range}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Range.isRange(attrs)) {
        if (attrs.object === 'range') {
          return attrs;
        } else {
          return Range.fromJSON(Range.createProperties(attrs));
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Range.fromJSON(attrs);
      }

      throw new Error('`Range.create` only accepts objects or ranges, but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Ranges` from `elements`.
     *
     * @param {Array<Range|Object>|List<Range|Object>} elements
     * @return {List<Range>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(elements) || Array.isArray(elements)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](elements.map(Range.create));
        return list;
      }

      throw new Error('`Range.createList` only accepts arrays or lists, but you passed it: ' + elements);
    }

    /**
     * Create a dictionary of settable range properties from `attrs`.
     *
     * @param {Object|String|Range} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Range.isRange(a)) {
        return {
          anchor: Point.createProperties(a.anchor),
          focus: Point.createProperties(a.focus)
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(a)) {
        var p = {};
        if ('anchor' in a) p.anchor = Point.create(a.anchor);
        if ('focus' in a) p.focus = Point.create(a.focus);
        return p;
      }

      throw new Error('`Range.createProperties` only accepts objects, annotations, decorations, ranges or selections, but you passed it: ' + a);
    }

    /**
     * Create a `Range` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Range}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var anchor = object.anchor,
          focus = object.focus;

      var range = new Range({
        anchor: Point.fromJSON(anchor || {}),
        focus: Point.fromJSON(focus || {})
      });

      return range;
    }

    /**
     * Check if a `value` is a `Range`, or is range-like.
     *
     * @param {Any} value
     * @return {Boolean}
     */

  }, {
    key: 'isRange',
    value: function isRange(value) {
      return isObject('range', value) || Decoration.isDecoration(value) || Selection.isSelection(value);
    }
  }]);
  return Range;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$4));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$5 = {
  key: undefined,
  type: undefined,
  data: undefined,
  anchor: undefined,
  focus: undefined

  /**
   * Annotation.
   *
   * @type {Annotation}
   */

};
var Annotation = function (_Record) {
  inherits(Annotation, _Record);

  function Annotation() {
    classCallCheck(this, Annotation);
    return possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
  }

  createClass(Annotation, [{
    key: 'setProperties',


    /**
     * Set new `properties` on the annotation.
     *
     * @param {Object|Range|Selection} properties
     * @return {Range}
     */

    value: function setProperties(properties) {
      properties = Annotation.createProperties(properties);
      var annotation = this.merge(properties);
      return annotation;
    }

    /**
     * Return a JSON representation of the annotation.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        key: this.key,
        type: this.type,
        data: this.data.toJSON(),
        anchor: this.anchor.toJSON(options),
        focus: this.focus.toJSON(options)
      };

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Annotation` with `attrs`.
     *
     * @param {Object|Annotation} attrs
     * @return {Annotation}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Annotation.isAnnotation(attrs)) {
        return attrs;
      }

      if (Range.isRange(attrs)) {
        return Annotation.fromJSON(Range.createProperties(attrs));
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Annotation.fromJSON(attrs);
      }

      throw new Error('`Annotation.create` only accepts objects or annotations, but you passed it: ' + attrs);
    }

    /**
     * Create a map of annotations from `elements`.
     *
     * @param {Object<String,Annotation>|Map<String,Annotation>} elements
     * @return {Map<String,Annotation>}
     */

  }, {
    key: 'createMap',
    value: function createMap() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"].isMap(elements)) {
        return elements;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(elements)) {
        var obj = {};

        for (var key in elements) {
          var value = elements[key];
          var annotation = Annotation.create(value);
          obj[key] = annotation;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(obj);
      }

      throw new Error('`Annotation.createMap` only accepts arrays or lists, but you passed it: ' + elements);
    }

    /**
     * Create a dictionary of settable annotation properties from `attrs`.
     *
     * @param {Object|String|Annotation} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Annotation.isAnnotation(a)) {
        return {
          key: a.key,
          type: a.type,
          data: a.data,
          anchor: Point.createProperties(a.anchor),
          focus: Point.createProperties(a.focus)
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(a)) {
        var p = {};
        if ('key' in a) p.key = a.key;
        if ('type' in a) p.type = a.type;
        if ('data' in a) p.data = Data.create(a.data);
        if ('anchor' in a) p.anchor = Point.create(a.anchor);
        if ('focus' in a) p.focus = Point.create(a.focus);
        return p;
      }

      throw new Error('`Annotation.createProperties` only accepts objects or annotations, but you passed it: ' + a);
    }

    /**
     * Create a `Annotation` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Annotation}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var key = object.key,
          type = object.type,
          data = object.data,
          anchor = object.anchor,
          focus = object.focus;


      if (!key) {
        throw new Error('Annotations must be created with a `key`, but you passed: ' + JSON.stringify(object));
      }

      if (!type) {
        throw new Error('Annotations must be created with a `type`, but you passed: ' + JSON.stringify(object));
      }

      var annotation = new Annotation({
        key: key,
        type: type,
        data: Data.create(data || {}),
        anchor: Point.fromJSON(anchor || {}),
        focus: Point.fromJSON(focus || {})
      });

      return annotation;
    }
  }]);
  return Annotation;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$5));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$6 = {
  data: undefined,
  key: undefined,
  nodes: undefined

  /**
   * Document.
   *
   * @type {Document}
   */

};
var Document = function (_Record) {
  inherits(Document, _Record);

  function Document() {
    classCallCheck(this, Document);
    return possibleConstructorReturn(this, (Document.__proto__ || Object.getPrototypeOf(Document)).apply(this, arguments));
  }

  createClass(Document, [{
    key: 'toJSON',


    /**
     * Return a JSON representation of the document.
     *
     * @param {Object} options
     * @return {Object}
     */

    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        data: this.data.toJSON(),
        nodes: this.nodes.toArray().map(function (n) {
          return n.toJSON(options);
        })
      };

      if (options.preserveKeys) {
        object.key = this.key;
      }

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Document` with `attrs`.
     *
     * @param {Object|Array|List|Text} attrs
     * @return {Document}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Document.isDocument(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(attrs) || Array.isArray(attrs)) {
        attrs = { nodes: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Document.fromJSON(attrs);
      }

      throw new Error('`Document.create` only accepts objects, arrays, lists or documents, but you passed it: ' + attrs);
    }

    /**
     * Create a `Document` from a JSON `object`.
     *
     * @param {Object|Document} object
     * @return {Document}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      if (Document.isDocument(object)) {
        return object;
      }

      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$key = object.key,
          key = _object$key === undefined ? KeyUtils.create() : _object$key,
          _object$nodes = object.nodes,
          nodes = _object$nodes === undefined ? [] : _object$nodes;


      var document = new Document({
        key: key,
        data: new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](data),
        nodes: Node.createList(nodes)
      });

      return document;
    }
  }]);
  return Document;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$6));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$7 = {
  data: undefined,
  key: undefined,
  nodes: undefined,
  type: undefined

  /**
   * Inline.
   *
   * @type {Inline}
   */

};
var Inline = function (_Record) {
  inherits(Inline, _Record);

  function Inline() {
    classCallCheck(this, Inline);
    return possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  createClass(Inline, [{
    key: 'toJSON',


    /**
     * Return a JSON representation of the inline.
     *
     * @param {Object} options
     * @return {Object}
     */

    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        type: this.type,
        data: this.data.toJSON(),
        nodes: this.nodes.toArray().map(function (n) {
          return n.toJSON(options);
        })
      };

      if (options.preserveKeys) {
        object.key = this.key;
      }

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Inline` with `attrs`.
     *
     * @param {Object|String|Inline} attrs
     * @return {Inline}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Inline.isInline(attrs)) {
        return attrs;
      }

      if (typeof attrs === 'string') {
        attrs = { type: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Inline.fromJSON(attrs);
      }

      throw new Error('`Inline.create` only accepts objects, strings or inlines, but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Inlines` from an array.
     *
     * @param {Array<Inline|Object>|List<Inline|Object>} elements
     * @return {List<Inline>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(elements) || Array.isArray(elements)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](elements.map(Inline.create));
        return list;
      }

      throw new Error('`Inline.createList` only accepts arrays or lists, but you passed it: ' + elements);
    }

    /**
     * Create a `Inline` from a JSON `object`.
     *
     * @param {Object|Inline} object
     * @return {Inline}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      if (Inline.isInline(object)) {
        return object;
      }

      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$key = object.key,
          key = _object$key === undefined ? KeyUtils.create() : _object$key,
          _object$nodes = object.nodes,
          nodes = _object$nodes === undefined ? [] : _object$nodes,
          type = object.type;


      if (typeof type !== 'string') {
        throw new Error('`Inline.fromJS` requires a `type` string.');
      }

      var inline = new Inline({
        key: key,
        type: type,
        data: new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](data),
        nodes: Node.createList(nodes)
      });

      return inline;
    }

    /**
     * Check if `any` is a list of inlines.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isInlineList',
    value: function isInlineList(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) && any.every(function (item) {
        return Inline.isInline(item);
      });
    }
  }]);
  return Inline;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$7));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$8 = {
  key: undefined,
  marks: undefined,
  text: undefined
};

var Leaf = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  text: undefined,
  marks: undefined,
  annotations: undefined,
  decorations: undefined
});

/**
 * Text.
 *
 * @type {Text}
 */

var Text = function (_Record) {
  inherits(Text, _Record);

  function Text() {
    classCallCheck(this, Text);
    return possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  createClass(Text, [{
    key: 'addMark',


    /**
     * Add a `mark`.
     *
     * @param {Mark} mark
     * @return {Text}
     */

    value: function addMark(mark) {
      mark = Mark.create(mark);
      var marks = this.marks;

      var next = marks.add(mark);
      var node = this.set('marks', next);
      return node;
    }

    /**
     * Add a set of `marks`.
     *
     * @param {Set<Mark>} marks
     * @return {Text}
     */

  }, {
    key: 'addMarks',
    value: function addMarks(marks) {
      marks = Mark.createSet(marks);
      var node = this.set('marks', this.marks.union(marks));
      return node;
    }

    /**
     * Get a list of uniquely-formatted leaves for the text node, given its
     * existing marks, and its current `annotations` and `decorations`.
     *
     * @param {Map<String,Annotation>} annotations
     * @param {List<Decoration>} decorations
     * @return {List<Leaf>}
     */

  }, {
    key: 'getLeaves',
    value: function getLeaves(annotations, decorations) {
      var text = this.text,
          marks = this.marks;

      var leaves = [{ text: text, marks: marks, annotations: [], decorations: [] }];

      // Helper to split a leaf into two `at` an offset.
      var split = function split(leaf, at) {
        return [{
          text: leaf.text.slice(0, at),
          marks: leaf.marks,
          annotations: [].concat(toConsumableArray(leaf.annotations)),
          decorations: [].concat(toConsumableArray(leaf.decorations))
        }, {
          text: leaf.text.slice(at),
          marks: leaf.marks,
          annotations: [].concat(toConsumableArray(leaf.annotations)),
          decorations: [].concat(toConsumableArray(leaf.decorations))
        }];
      };

      // Helper to compile the leaves for a `kind` of format.
      var compile = function compile(kind) {
        var formats = kind === 'annotations' ? annotations.values() : decorations;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = formats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var format = _step.value;
            var start = format.start,
                end = format.end;

            var next = [];
            var o = 0;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = leaves[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var leaf = _step2.value;
                var length = leaf.text.length;

                var offset = o;
                o += length;

                // If the range encompases the entire leaf, add the format.
                if (start.offset <= offset && end.offset >= offset + length) {
                  leaf[kind].push(format);
                  next.push(leaf);
                  continue;
                }

                // If the range starts after the leaf, or ends before it, continue.
                if (start.offset > offset + length || end.offset < offset || end.offset === offset && offset !== 0) {
                  next.push(leaf);
                  continue;
                }

                // Otherwise we need to split the leaf, at the start, end, or both,
                // and add the format to the middle intersecting section. Do the end
                // split first since we don't need to update the offset that way.
                var middle = leaf;
                var before = void 0;
                var after = void 0;

                if (end.offset < offset + length) {
                  
                  var _split = split(middle, end.offset - offset);

                  var _split2 = slicedToArray(_split, 2);

                  middle = _split2[0];
                  after = _split2[1];
                }

                if (start.offset > offset) {
                  
                  var _split3 = split(middle, start.offset - offset);

                  var _split4 = slicedToArray(_split3, 2);

                  before = _split4[0];
                  middle = _split4[1];
                }

                middle[kind].push(format);

                if (before) {
                  next.push(before);
                }

                next.push(middle);

                if (after) {
                  next.push(after);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            leaves = next;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };

      compile('annotations');
      compile('decorations');

      leaves = leaves.map(function (leaf) {
        return new Leaf(_extends({}, leaf, {
          annotations: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(leaf.annotations),
          decorations: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(leaf.decorations)
        }));
      });

      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(leaves);
      return list;
    }

    /**
     * Insert `text` at `index`.
     *
     * @param {Number} index
     * @param {String} string
     * @return {Text}
     */

  }, {
    key: 'insertText',
    value: function insertText(index, string) {
      var text = this.text;

      var next = text.slice(0, index) + string + text.slice(index);
      var node = this.set('text', next);
      return node;
    }

    /**
     * Remove a `mark`.
     *
     * @param {Mark} mark
     * @return {Text}
     */

  }, {
    key: 'removeMark',
    value: function removeMark(mark) {
      mark = Mark.create(mark);
      var marks = this.marks;

      var next = marks.remove(mark);
      var node = this.set('marks', next);
      return node;
    }

    /**
     * Remove text from the text node at `index` for `length`.
     *
     * @param {Number} index
     * @param {Number} length
     * @return {Text}
     */

  }, {
    key: 'removeText',
    value: function removeText(index, length) {
      var text = this.text;

      var next = text.slice(0, index) + text.slice(index + length);
      var node = this.set('text', next);
      return node;
    }

    /**
     * Return a JSON representation of the text.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        text: this.text,
        marks: this.marks.toArray().map(function (m) {
          return m.toJSON();
        })
      };

      if (options.preserveKeys) {
        object.key = this.key;
      }

      return object;
    }

    /**
     * Set a `newProperties` on an existing `mark`.
     *
     * @param {Object} mark
     * @param {Object} newProperties
     * @return {Text}
     */

  }, {
    key: 'setMark',
    value: function setMark(properties, newProperties) {
      var marks = this.marks;

      var mark = Mark.create(properties);
      var newMark = mark.merge(newProperties);
      var next = marks.remove(mark).add(newMark);
      var node = this.set('marks', next);
      return node;
    }

    /**
     * Split the node into two at `index`.
     *
     * @param {Number} index
     * @returns {Array<Text>}
     */

  }, {
    key: 'splitText',
    value: function splitText(index) {
      var text = this.text;

      var one = this.set('text', text.slice(0, index));
      var two = this.set('text', text.slice(index)).regenerateKey();
      return [one, two];
    }

    /**
     * Merge the node with an `other` text node.
     *
     * @param {Text} other
     * @returns {Text}
     */

  }, {
    key: 'mergeText',
    value: function mergeText(other) {
      var next = this.text + other.text;
      var node = this.set('text', next);
      return node;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Text` with `attrs`.
     *
     * @param {Object|Array|List|String|Text} attrs
     * @return {Text}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (Text.isText(attrs)) {
        return attrs;
      }

      if (typeof attrs === 'string') {
        attrs = { text: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Text.fromJSON(attrs);
      }

      throw new Error('`Text.create` only accepts objects, arrays, strings or texts, but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Texts` from `elements`.
     *
     * @param {Array<Text|Object>|List<Text|Object>} elements
     * @return {List<Text>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(elements) || Array.isArray(elements)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](elements.map(Text.create));
        return list;
      }

      throw new Error('`Text.createList` only accepts arrays or lists, but you passed it: ' + elements);
    }

    /**
     * Create a `Text` from a JSON `object`.
     *
     * @param {Object|Text} object
     * @return {Text}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      if (Text.isText(object)) {
        return object;
      }

      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(object.leaves == null, 'As of slate@0.46, the `leaves` property of text nodes has been removed! Each individual leaf should be created as a text node instead.');

      var _object$text = object.text,
          text = _object$text === undefined ? '' : _object$text,
          _object$marks = object.marks,
          marks = _object$marks === undefined ? [] : _object$marks,
          _object$key = object.key,
          key = _object$key === undefined ? KeyUtils.create() : _object$key;

      var node = new Text({
        key: key,
        text: text,
        marks: Mark.createSet(marks)
      });

      return node;
    }

    /**
     * Check if `any` is a list of texts.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isTextList',
    value: function isTextList(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) && any.every(function (item) {
        return Text.isText(item);
      });
    }
  }]);
  return Text;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$8));

/**
 * A pseudo-model that is used for its static methods only.
 *
 * @type {Node}
 */

var Node = function () {
  function Node() {
    classCallCheck(this, Node);
  }

  createClass(Node, null, [{
    key: 'create',

    /**
     * Create a new `Node` with `attrs`.
     *
     * @param {Object|Node} attrs
     * @return {Node}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Node.isNode(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        var object = attrs.object;


        if (!object && attrs.kind) {
          Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.32.0, the `kind` property of Slate objects has been renamed to `object`.');

          object = attrs.kind;
        }

        switch (object) {
          case 'block':
            return Block.create(attrs);
          case 'document':
            return Document.create(attrs);
          case 'inline':
            return Inline.create(attrs);
          case 'text':
            return Text.create(attrs);

          default:
            {
              throw new Error('`Node.create` requires a `object` string.');
            }
        }
      }

      throw new Error('`Node.create` only accepts objects or nodes but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Nodes` from an array.
     *
     * @param {Array<Object|Node>} elements
     * @return {List<Node>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(elements) || Array.isArray(elements)) {
        var array = [];

        elements.forEach(function (el) {
          if (el && el.object === 'text' && el.leaves && Array.isArray(el.leaves)) {
            Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.46, the `leaves` property of Text nodes has been removed. Instead, each text node contains a string of text and a unique set of marks and leaves are unnecessary.');

            var texts = Text.createList(el.leaves).toArray();
            array = array.concat(texts);
            return;
          }

          var node = Node.create(el);
          array.push(node);
        });

        var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
        return list;
      }

      throw new Error('`Node.createList` only accepts lists or arrays, but you passed it: ' + elements);
    }

    /**
     * Create a dictionary of settable node properties from `attrs`.
     *
     * @param {Object|String|Node} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Block.isBlock(attrs) || Inline.isInline(attrs)) {
        return {
          data: attrs.data,
          type: attrs.type
        };
      }

      if (typeof attrs === 'string') {
        return { type: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        var props = {};
        if ('type' in attrs) props.type = attrs.type;
        if ('data' in attrs) props.data = Data.create(attrs.data);
        return props;
      }

      throw new Error('`Node.createProperties` only accepts objects, strings, blocks or inlines, but you passed it: ' + attrs);
    }

    /**
     * Create a `Node` from a JSON `value`.
     *
     * @param {Object} value
     * @return {Node}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(value) {
      var object = value.object;


      if (!object && value.kind) {
        Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.32.0, the `kind` property of Slate objects has been renamed to `object`.');

        object = value.kind;
      }

      switch (object) {
        case 'block':
          return Block.fromJSON(value);
        case 'document':
          return Document.fromJSON(value);
        case 'inline':
          return Inline.fromJSON(value);
        case 'text':
          return Text.fromJSON(value);

        default:
          {
            throw new Error('`Node.fromJSON` requires an `object` of either \'block\', \'document\', \'inline\' or \'text\', but you passed: ' + value);
          }
      }
    }

    /**
     * Check if `any` is a `Node`.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isNode',
    value: function isNode(any) {
      return Block.isBlock(any) || Document.isDocument(any) || Inline.isInline(any) || Text.isText(any);
    }

    /**
     * Check if `any` is a list of nodes.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isNodeList',
    value: function isNodeList(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) && any.every(function (item) {
        return Node.isNode(item);
      });
    }
  }]);
  return Node;
}();

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$9 = {
  data: undefined,
  key: undefined,
  nodes: undefined,
  type: undefined

  /**
   * Block.
   *
   * @type {Block}
   */

};
var Block = function (_Record) {
  inherits(Block, _Record);

  function Block() {
    classCallCheck(this, Block);
    return possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).apply(this, arguments));
  }

  createClass(Block, [{
    key: 'toJSON',


    /**
     * Return a JSON representation of the block.
     *
     * @param {Object} options
     * @return {Object}
     */

    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        type: this.type,
        data: this.data.toJSON(),
        nodes: this.nodes.toArray().map(function (n) {
          return n.toJSON(options);
        })
      };

      if (options.preserveKeys) {
        object.key = this.key;
      }

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Block` from `attrs`.
     *
     * @param {Object|String|Block} attrs
     * @return {Block}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Block.isBlock(attrs)) {
        return attrs;
      }

      if (typeof attrs === 'string') {
        attrs = { type: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Block.fromJSON(attrs);
      }

      throw new Error('`Block.create` only accepts objects, strings or blocks, but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Blocks` from `attrs`.
     *
     * @param {Array<Block|Object>|List<Block|Object>} attrs
     * @return {List<Block>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(attrs) || Array.isArray(attrs)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](attrs.map(Block.create));
        return list;
      }

      throw new Error('`Block.createList` only accepts arrays or lists, but you passed it: ' + attrs);
    }

    /**
     * Create a `Block` from a JSON `object`.
     *
     * @param {Object|Block} object
     * @return {Block}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      if (Block.isBlock(object)) {
        return object;
      }

      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$key = object.key,
          key = _object$key === undefined ? KeyUtils.create() : _object$key,
          _object$nodes = object.nodes,
          nodes = _object$nodes === undefined ? [] : _object$nodes,
          type = object.type;


      if (typeof type !== 'string') {
        throw new Error('`Block.fromJSON` requires a `type` string.');
      }

      var block = new Block({
        key: key,
        type: type,
        data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(data),
        nodes: Node.createList(nodes)
      });

      return block;
    }

    /**
     * Check if `any` is a block list.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isBlockList',
    value: function isBlockList(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) && any.every(function (item) {
        return Block.isBlock(item);
      });
    }
  }]);
  return Block;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$9));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$10 = {
  annotations: undefined,
  data: undefined,
  document: undefined,
  selection: undefined

  /**
   * Value.
   *
   * @type {Value}
   */

};
var Value = function (_Record) {
  inherits(Value, _Record);

  function Value() {
    classCallCheck(this, Value);
    return possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).apply(this, arguments));
  }

  createClass(Value, [{
    key: 'addAnnotation',


    /**
     * Add an `annotation` to the value.
     *
     * @param {Annotation} annotation
     * @param {Mark} mark
     * @return {Value}
     */

    value: function addAnnotation(annotation) {
      annotation = Annotation.create(annotation);
      var value = this;
      var _value = value,
          annotations = _value.annotations,
          document = _value.document;
      var _annotation = annotation,
          key = _annotation.key;

      annotation = annotation.updatePoints(function (point) {
        return point.normalize(document);
      });
      annotations = annotations.set(key, annotation);
      value = value.set('annotations', annotations);
      return value;
    }

    /**
     * Add `mark` to text at `path`.
     *
     * @param {List|String} path
     * @param {Mark} mark
     * @return {Value}
     */

  }, {
    key: 'addMark',
    value: function addMark(path, mark) {
      mark = Mark.create(mark);
      var value = this;
      var _value2 = value,
          document = _value2.document;

      document = document.addMark(path, mark);
      value = value.set('document', document);
      return value;
    }

    /**
     * Insert a `node`.
     *
     * @param {List|String} path
     * @param {Node} node
     * @return {Value}
     */

  }, {
    key: 'insertNode',
    value: function insertNode(path, node) {
      var value = this;
      var _value3 = value,
          document = _value3.document;

      document = document.insertNode(path, node);
      value = value.set('document', document);

      value = value.mapRanges(function (range) {
        return range.updatePoints(function (point) {
          return point.setPath(null);
        });
      });

      return value;
    }

    /**
     * Insert `text` at `offset` in node by `path`.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @param {String} text
     * @return {Value}
     */

  }, {
    key: 'insertText',
    value: function insertText(path, offset, text) {
      var value = this;
      var _value4 = value,
          document = _value4.document;

      var node = document.assertNode(path);
      document = document.insertText(path, offset, text);
      node = document.assertNode(path);
      value = value.set('document', document);

      value = value.mapPoints(function (point) {
        if (point.key === node.key && point.offset >= offset) {
          return point.setOffset(point.offset + text.length);
        } else {
          return point;
        }
      });

      return value;
    }

    /**
     * Merge a node backwards its previous sibling.
     *
     * @param {List|Key} path
     * @return {Value}
     */

  }, {
    key: 'mergeNode',
    value: function mergeNode(path) {
      var value = this;
      var _value5 = value,
          document = _value5.document;

      var newDocument = document.mergeNode(path);
      path = document.resolvePath(path);
      var withPath = PathUtils.decrement(path);
      var one = document.getNode(withPath);
      var two = document.getNode(path);
      value = value.set('document', newDocument);

      value = value.mapRanges(function (range) {
        if (two.object === 'text') {
          var max = one.text.length;

          if (range.anchor.key === two.key) {
            range = range.moveAnchorTo(one.key, max + range.anchor.offset);
          }

          if (range.focus.key === two.key) {
            range = range.moveFocusTo(one.key, max + range.focus.offset);
          }
        }

        range = range.updatePoints(function (point) {
          return point.setPath(null);
        });

        return range;
      });

      return value;
    }

    /**
     * Move a node by `path` to `newPath`.
     *
     * A `newIndex` can be provided when move nodes by `key`, to account for not
     * being able to have a key for a location in the tree that doesn't exist yet.
     *
     * @param {List|Key} path
     * @param {List|Key} newPath
     * @param {Number} newIndex
     * @return {Value}
     */

  }, {
    key: 'moveNode',
    value: function moveNode(path, newPath) {
      var newIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var value = this;
      var _value6 = value,
          document = _value6.document;


      if (PathUtils.isEqual(path, newPath)) {
        return value;
      }

      document = document.moveNode(path, newPath, newIndex);
      value = value.set('document', document);
      value = value.mapPoints(function (point) {
        return point.setPath(null);
      });
      return value;
    }

    /**
     * Remove an `annotation` from the value.
     *
     * @param {Annotation} annotation
     * @param {Mark} mark
     * @return {Value}
     */

  }, {
    key: 'removeAnnotation',
    value: function removeAnnotation(annotation) {
      annotation = Annotation.create(annotation);
      var value = this;
      var _value7 = value,
          annotations = _value7.annotations;
      var _annotation2 = annotation,
          key = _annotation2.key;

      annotations = annotations.delete(key);
      value = value.set('annotations', annotations);
      return value;
    }

    /**
     * Remove `mark` at `path`.
     *
     * @param {List|String} path
     * @param {Mark} mark
     * @return {Value}
     */

  }, {
    key: 'removeMark',
    value: function removeMark(path, mark) {
      mark = Mark.create(mark);
      var value = this;
      var _value8 = value,
          document = _value8.document;

      document = document.removeMark(path, mark);
      value = value.set('document', document);
      return value;
    }

    /**
     * Remove a node by `path`.
     *
     * @param {List|String} path
     * @return {Value}
     */

  }, {
    key: 'removeNode',
    value: function removeNode(path) {
      var value = this;
      var _value9 = value,
          document = _value9.document;

      var node = document.assertNode(path);
      var first = node.object === 'text' ? node : node.getFirstText() || node;
      var last = node.object === 'text' ? node : node.getLastText() || node;
      var prev = document.getPreviousText(first.key);
      var next = document.getNextText(last.key);

      document = document.removeNode(path);
      value = value.set('document', document);

      value = value.mapRanges(function (range) {
        var _range = range,
            anchor = _range.anchor,
            focus = _range.focus;


        if (node.hasNode(anchor.key)) {
          range = prev ? range.moveAnchorTo(prev.key, prev.text.length) : next ? range.moveAnchorTo(next.key, 0) : range.unset();
        }

        if (node.hasNode(focus.key)) {
          range = prev ? range.moveFocusTo(prev.key, prev.text.length) : next ? range.moveFocusTo(next.key, 0) : range.unset();
        }

        range = range.updatePoints(function (point) {
          return point.setPath(null);
        });

        return range;
      });

      return value;
    }

    /**
     * Remove `text` at `offset` in node by `path`.
     *
     * @param {List|Key} path
     * @param {Number} offset
     * @param {String} text
     * @return {Value}
     */

  }, {
    key: 'removeText',
    value: function removeText(path, offset, text) {
      var value = this;
      var _value10 = value,
          document = _value10.document;

      var node = document.assertNode(path);
      document = document.removeText(path, offset, text);
      value = value.set('document', document);

      var length = text.length;

      var start = offset;
      var end = offset + length;

      value = value.mapPoints(function (point) {
        if (point.key !== node.key) {
          return point;
        }

        if (point.offset >= end) {
          return point.setOffset(point.offset - length);
        }

        if (point.offset > start) {
          return point.setOffset(start);
        }

        return point;
      });

      return value;
    }

    /**
     * Add an `annotation` to the value.
     *
     * @param {Annotation} annotation
     * @param {Mark} mark
     * @return {Value}
     */

  }, {
    key: 'setAnnotation',
    value: function setAnnotation(properties, newProperties) {
      newProperties = Annotation.createProperties(newProperties);
      var annotation = Annotation.create(properties);
      var next = annotation.merge(newProperties);
      var value = this;
      var _value11 = value,
          annotations = _value11.annotations;
      var key = annotation.key;

      annotations = annotations.set(key, next);
      value = value.set('annotations', annotations);
      return value;
    }

    /**
     * Set `properties` on a node.
     *
     * @param {List|String} path
     * @param {Object} properties
     * @return {Value}
     */

  }, {
    key: 'setNode',
    value: function setNode(path, properties) {
      var value = this;
      var _value12 = value,
          document = _value12.document;

      document = document.setNode(path, properties);
      value = value.set('document', document);
      return value;
    }

    /**
     * Set `properties` on `mark` on text at `offset` and `length` in node.
     *
     * @param {List|String} path
     * @param {Mark} mark
     * @param {Object} properties
     * @return {Value}
     */

  }, {
    key: 'setMark',
    value: function setMark(path, mark, properties) {
      var value = this;
      var _value13 = value,
          document = _value13.document;

      document = document.setMark(path, mark, properties);
      value = value.set('document', document);
      return value;
    }

    /**
     * Set `properties` on the value.
     *
     * @param {Object} properties
     * @return {Value}
     */

  }, {
    key: 'setProperties',
    value: function setProperties(properties) {
      var value = this;
      var _value14 = value,
          document = _value14.document;
      var data = properties.data,
          annotations = properties.annotations;

      var props = {};

      if (data) {
        props.data = data;
      }

      if (annotations) {
        props.annotations = annotations.map(function (a) {
          return a.isSet ? a : document.resolveAnnotation(a);
        });
      }

      value = value.merge(props);
      return value;
    }

    /**
     * Set `properties` on the selection.
     *
     * @param {Value} value
     * @param {Operation} operation
     * @return {Value}
     */

  }, {
    key: 'setSelection',
    value: function setSelection(properties) {
      var value = this;
      var _value15 = value,
          document = _value15.document,
          selection = _value15.selection;

      var next = selection.setProperties(properties);
      selection = document.resolveSelection(next);
      value = value.set('selection', selection);
      return value;
    }

    /**
     * Split a node by `path` at `position` with optional `properties` to apply
     * to the newly split node.
     *
     * @param {List|String} path
     * @param {Number} position
     * @param {Object} properties
     * @return {Value}
     */

  }, {
    key: 'splitNode',
    value: function splitNode(path, position, properties) {
      var value = this;
      var _value16 = value,
          document = _value16.document;

      var newDocument = document.splitNode(path, position, properties);
      var node = document.assertNode(path);
      value = value.set('document', newDocument);

      value = value.mapRanges(function (range) {
        var next = newDocument.getNextText(node.key);
        var _range2 = range,
            anchor = _range2.anchor,
            focus = _range2.focus;

        // If the anchor was after the split, move it to the next node.

        if (node.key === anchor.key && position <= anchor.offset) {
          range = range.moveAnchorTo(next.key, anchor.offset - position);
        }

        // If the focus was after the split, move it to the next node.
        if (node.key === focus.key && position <= focus.offset) {
          range = range.moveFocusTo(next.key, focus.offset - position);
        }

        range = range.updatePoints(function (point) {
          return point.setPath(null);
        });

        return range;
      });

      return value;
    }

    /**
     * Map all range objects to apply adjustments with an `iterator`.
     *
     * @param {Function} iterator
     * @return {Value}
     */

  }, {
    key: 'mapRanges',
    value: function mapRanges(iterator) {
      var value = this;
      var _value17 = value,
          document = _value17.document,
          selection = _value17.selection,
          annotations = _value17.annotations;


      var sel = selection.isSet ? iterator(selection) : selection;
      if (!sel) sel = selection.unset();
      if (sel !== selection) sel = document.createSelection(sel);
      value = value.set('selection', sel);

      var anns = annotations.map(function (annotation) {
        var n = annotation.isSet ? iterator(annotation) : annotation;
        if (n && n !== annotation) n = document.createAnnotation(n);
        return n;
      });

      anns = anns.filter(function (annotation) {
        return !!annotation;
      });
      value = value.set('annotations', anns);
      return value;
    }
  }, {
    key: 'mapPoints',
    value: function mapPoints(iterator) {
      return this.mapRanges(function (range) {
        return range.updatePoints(iterator);
      });
    }

    /**
     * Return a JSON representation of the value.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        document: this.document.toJSON(options)
      };

      if (options.preserveData) {
        object.data = this.data.toJSON(options);
      }

      if (options.preserveAnnotations) {
        object.annotations = this.annotations.map(function (a) {
          return a.toJSON(options);
        }).toObject();
      }

      if (options.preserveSelection) {
        object.selection = this.selection.toJSON(options);
      }

      return object;
    }

    /**
     * Deprecated.
     */

  }, {
    key: 'change',
    value: function change() {
      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42.0, value object are no longer schema-aware, and the `value.change()` method is no longer available. Use the `editor.change()` method on the new `Editor` controller instead.');
    }
  }, {
    key: 'startBlock',


    /**
     * Get the current start text node's closest block parent.
     *
     * @return {Block}
     */

    get: function get$$1() {
      return this.selection.start.key && this.document.getClosestBlock(this.selection.start.key);
    }

    /**
     * Get the current end text node's closest block parent.
     *
     * @return {Block}
     */

  }, {
    key: 'endBlock',
    get: function get$$1() {
      return this.selection.end.key && this.document.getClosestBlock(this.selection.end.key);
    }

    /**
     * Get the current anchor text node's closest block parent.
     *
     * @return {Block}
     */

  }, {
    key: 'anchorBlock',
    get: function get$$1() {
      return this.selection.anchor.key && this.document.getClosestBlock(this.selection.anchor.key);
    }

    /**
     * Get the current focus text node's closest block parent.
     *
     * @return {Block}
     */

  }, {
    key: 'focusBlock',
    get: function get$$1() {
      return this.selection.focus.key && this.document.getClosestBlock(this.selection.focus.key);
    }

    /**
     * Get the current start text node's closest inline parent.
     *
     * @return {Inline}
     */

  }, {
    key: 'startInline',
    get: function get$$1() {
      return this.selection.start.key && this.document.getClosestInline(this.selection.start.key);
    }

    /**
     * Get the current end text node's closest inline parent.
     *
     * @return {Inline}
     */

  }, {
    key: 'endInline',
    get: function get$$1() {
      return this.selection.end.key && this.document.getClosestInline(this.selection.end.key);
    }

    /**
     * Get the current anchor text node's closest inline parent.
     *
     * @return {Inline}
     */

  }, {
    key: 'anchorInline',
    get: function get$$1() {
      return this.selection.anchor.key && this.document.getClosestInline(this.selection.anchor.key);
    }

    /**
     * Get the current focus text node's closest inline parent.
     *
     * @return {Inline}
     */

  }, {
    key: 'focusInline',
    get: function get$$1() {
      return this.selection.focus.key && this.document.getClosestInline(this.selection.focus.key);
    }

    /**
     * Get the current start text node.
     *
     * @return {Text}
     */

  }, {
    key: 'startText',
    get: function get$$1() {
      return this.selection.start.key && this.document.getDescendant(this.selection.start.key);
    }

    /**
     * Get the current end node.
     *
     * @return {Text}
     */

  }, {
    key: 'endText',
    get: function get$$1() {
      return this.selection.end.key && this.document.getDescendant(this.selection.end.key);
    }

    /**
     * Get the current anchor node.
     *
     * @return {Text}
     */

  }, {
    key: 'anchorText',
    get: function get$$1() {
      return this.selection.anchor.key && this.document.getDescendant(this.selection.anchor.key);
    }

    /**
     * Get the current focus node.
     *
     * @return {Text}
     */

  }, {
    key: 'focusText',
    get: function get$$1() {
      return this.selection.focus.key && this.document.getDescendant(this.selection.focus.key);
    }

    /**
     * Get the next block node.
     *
     * @return {Block}
     */

  }, {
    key: 'nextBlock',
    get: function get$$1() {
      return this.selection.end.key && this.document.getNextBlock(this.selection.end.key);
    }

    /**
     * Get the previous block node.
     *
     * @return {Block}
     */

  }, {
    key: 'previousBlock',
    get: function get$$1() {
      return this.selection.start.key && this.document.getPreviousBlock(this.selection.start.key);
    }

    /**
     * Get the next inline node.
     *
     * @return {Inline}
     */

  }, {
    key: 'nextInline',
    get: function get$$1() {
      return this.selection.end.key && this.document.getNextInline(this.selection.end.key);
    }

    /**
     * Get the previous inline node.
     *
     * @return {Inline}
     */

  }, {
    key: 'previousInline',
    get: function get$$1() {
      return this.selection.start.key && this.document.getPreviousInline(this.selection.start.key);
    }

    /**
     * Get the next text node.
     *
     * @return {Text}
     */

  }, {
    key: 'nextText',
    get: function get$$1() {
      return this.selection.end.key && this.document.getNextText(this.selection.end.key);
    }

    /**
     * Get the previous text node.
     *
     * @return {Text}
     */

  }, {
    key: 'previousText',
    get: function get$$1() {
      return this.selection.start.key && this.document.getPreviousText(this.selection.start.key);
    }

    /**
     * Get the marks of the current selection.
     *
     * @return {Set<Mark>}
     */

  }, {
    key: 'marks',
    get: function get$$1() {
      return this.selection.isUnset ? new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"]() : this.selection.marks || this.document.getMarksAtRange(this.selection);
    }

    /**
     * Get the active marks of the current selection.
     *
     * @return {Set<Mark>}
     */

  }, {
    key: 'activeMarks',
    get: function get$$1() {
      return this.selection.isUnset ? new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"]() : this.selection.marks || this.document.getActiveMarksAtRange(this.selection);
    }

    /**
     * Get the block nodes in the current selection.
     *
     * @return {List<Block>}
     */

  }, {
    key: 'blocks',
    get: function get$$1() {
      return this.selection.isUnset ? new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]() : this.document.getLeafBlocksAtRange(this.selection);
    }

    /**
     * Get the fragment of the current selection.
     *
     * @return {Document}
     */

  }, {
    key: 'fragment',
    get: function get$$1() {
      return this.selection.isUnset ? Document.create() : this.document.getFragmentAtRange(this.selection);
    }

    /**
     * Get the bottom-most inline nodes in the current selection.
     *
     * @return {List<Inline>}
     */

  }, {
    key: 'inlines',
    get: function get$$1() {
      return this.selection.isUnset ? new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]() : this.document.getLeafInlinesAtRange(this.selection);
    }

    /**
     * Get the text nodes in the current selection.
     *
     * @return {List<Text>}
     */

  }, {
    key: 'texts',
    get: function get$$1() {
      return this.selection.isUnset ? new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]() : this.document.getTextsAtRange(this.selection);
    }
  }, {
    key: 'history',
    get: function get$$1() {
      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42.0, the `value.history` model no longer exists, and the history is stored in `value.data` instead using plugins.');
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Value` with `attrs`.
     *
     * @param {Object|Value} attrs
     * @param {Object} options
     * @return {Value}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (Value.isValue(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Value.fromJSON(attrs, options);
      }

      throw new Error('`Value.create` only accepts objects or values, but you passed it: ' + attrs);
    }

    /**
     * Create a dictionary of settable value properties from `attrs`.
     *
     * @param {Object|Value} attrs
     * @return {Object}
     */

  }, {
    key: 'createProperties',
    value: function createProperties() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Value.isValue(a)) {
        return {
          annotations: a.annotations,
          data: a.data
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(a)) {
        var p = {};
        if ('annotations' in a) p.annotations = Annotation.createMap(a.annotations);
        if ('data' in a) p.data = Data.create(a.data);
        return p;
      }

      throw new Error('`Value.createProperties` only accepts objects or values, but you passed it: ' + a);
    }

    /**
     * Create a `Value` from a JSON `object`.
     *
     * @param {Object} object
     * @param {Object} options
     *   @property {Boolean} normalize
     *   @property {Array} plugins
     * @return {Value}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$annotations = object.annotations,
          annotations = _object$annotations === undefined ? {} : _object$annotations,
          _object$document = object.document,
          document = _object$document === undefined ? {} : _object$document,
          _object$selection = object.selection,
          selection = _object$selection === undefined ? {} : _object$selection;

      data = Data.fromJSON(data);
      document = Document.fromJSON(document);
      selection = document.createSelection(selection);
      annotations = Annotation.createMap(annotations);

      if (selection.isUnset) {
        var text = document.getFirstText();
        if (text) selection = selection.moveToStartOfNode(text);
        selection = document.createSelection(selection);
      }

      var value = new Value({
        annotations: annotations,
        data: data,
        document: document,
        selection: selection
      });

      return value;
    }
  }]);
  return Value;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$10));

/**
 * Debug.
 *
 * @type {Function}
 */

var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:operation:apply');

/**
 * Apply an `op` to a `value`.
 *
 * @param {Value} value
 * @param {Object|Operation} op
 * @return {Value} value
 */

function applyOperation(value, op) {
  op = Operation.create(op);
  var _op = op,
      type = _op.type;

  debug(type, op);

  switch (type) {
    case 'add_annotation':
      {
        var _op2 = op,
            annotation = _op2.annotation;

        var next = value.addAnnotation(annotation);
        return next;
      }

    case 'add_mark':
      {
        var _op3 = op,
            path = _op3.path,
            mark = _op3.mark;

        var _next = value.addMark(path, mark);
        return _next;
      }

    case 'insert_node':
      {
        var _op4 = op,
            _path = _op4.path,
            node = _op4.node;

        var _next2 = value.insertNode(_path, node);
        return _next2;
      }

    case 'insert_text':
      {
        var _op5 = op,
            _path2 = _op5.path,
            offset = _op5.offset,
            text = _op5.text,
            marks = _op5.marks;

        var _next3 = value.insertText(_path2, offset, text, marks);
        return _next3;
      }

    case 'merge_node':
      {
        var _op6 = op,
            _path3 = _op6.path;

        var _next4 = value.mergeNode(_path3);
        return _next4;
      }

    case 'move_node':
      {
        var _op7 = op,
            _path4 = _op7.path,
            newPath = _op7.newPath;

        var _next5 = value.moveNode(_path4, newPath);
        return _next5;
      }

    case 'remove_annotation':
      {
        var _op8 = op,
            _annotation = _op8.annotation;

        var _next6 = value.removeAnnotation(_annotation);
        return _next6;
      }

    case 'remove_mark':
      {
        var _op9 = op,
            _path5 = _op9.path,
            _mark = _op9.mark;

        var _next7 = value.removeMark(_path5, _mark);
        return _next7;
      }

    case 'remove_node':
      {
        var _op10 = op,
            _path6 = _op10.path;

        var _next8 = value.removeNode(_path6);
        return _next8;
      }

    case 'remove_text':
      {
        var _op11 = op,
            _path7 = _op11.path,
            _offset = _op11.offset,
            _text = _op11.text;

        var _next9 = value.removeText(_path7, _offset, _text);
        return _next9;
      }

    case 'set_annotation':
      {
        var _op12 = op,
            properties = _op12.properties,
            newProperties = _op12.newProperties;

        var _next10 = value.setAnnotation(properties, newProperties);
        return _next10;
      }

    case 'set_mark':
      {
        var _op13 = op,
            _path8 = _op13.path,
            _properties = _op13.properties,
            _newProperties = _op13.newProperties;

        var _next11 = value.setMark(_path8, _properties, _newProperties);
        return _next11;
      }

    case 'set_node':
      {
        var _op14 = op,
            _path9 = _op14.path,
            _newProperties2 = _op14.newProperties;

        var _next12 = value.setNode(_path9, _newProperties2);
        return _next12;
      }

    case 'set_selection':
      {
        var _op15 = op,
            _newProperties3 = _op15.newProperties;

        var _next13 = value.setSelection(_newProperties3);
        return _next13;
      }

    case 'set_value':
      {
        var _op16 = op,
            _newProperties4 = _op16.newProperties;

        var _next14 = value.setProperties(_newProperties4);
        return _next14;
      }

    case 'split_node':
      {
        var _op17 = op,
            _path10 = _op17.path,
            position = _op17.position,
            _properties2 = _op17.properties;

        var _next15 = value.splitNode(_path10, position, _properties2);
        return _next15;
      }

    default:
      {
        throw new Error('Unknown operation type: "' + type + '".');
      }
  }
}

/**
 * Debug.
 *
 * @type {Function}
 */

var debug$1 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:operation:invert');

/**
 * Invert an `op`.
 *
 * @param {Object} op
 * @return {Object}
 */

function invertOperation(op) {
  op = Operation.create(op);
  var _op = op,
      type = _op.type;

  debug$1(type, op);

  switch (type) {
    case 'move_node':
      {
        var _op2 = op,
            newPath = _op2.newPath,
            path = _op2.path;

        // PERF: this case can exit early.

        if (PathUtils.isEqual(newPath, path)) {
          return op;
        }

        var inversePath = PathUtils.transform(path, op).first();

        // Get the true path we are trying to move back to
        // We transform the right-sibling of the path
        // This will end up at the operation.path most of the time
        // But if the newPath is a left-sibling or left-ancestor-sibling, this will account for it
        var inverseNewPath = PathUtils.transform(PathUtils.increment(path), op).first();

        var inverse = op.set('path', inversePath).set('newPath', inverseNewPath);
        return inverse;
      }

    case 'merge_node':
      {
        var _op3 = op,
            _path = _op3.path;

        var _inversePath = PathUtils.decrement(_path);
        var _inverse = op.set('type', 'split_node').set('path', _inversePath);
        return _inverse;
      }

    case 'split_node':
      {
        var _op4 = op,
            _path2 = _op4.path;

        var _inversePath2 = PathUtils.increment(_path2);
        var _inverse2 = op.set('type', 'merge_node').set('path', _inversePath2);
        return _inverse2;
      }

    case 'set_annotation':
    case 'set_node':
    case 'set_value':
    case 'set_selection':
    case 'set_mark':
      {
        var _op5 = op,
            properties = _op5.properties,
            newProperties = _op5.newProperties;

        var _inverse3 = op.set('properties', newProperties).set('newProperties', properties);
        return _inverse3;
      }

    case 'insert_node':
    case 'insert_text':
      {
        var _inverse4 = op.set('type', type.replace('insert_', 'remove_'));
        return _inverse4;
      }

    case 'remove_node':
    case 'remove_text':
      {
        var _inverse5 = op.set('type', type.replace('remove_', 'insert_'));
        return _inverse5;
      }

    case 'add_annotation':
    case 'add_mark':
      {
        var _inverse6 = op.set('type', type.replace('add_', 'remove_'));
        return _inverse6;
      }

    case 'remove_annotation':
    case 'remove_mark':
      {
        var _inverse7 = op.set('type', type.replace('remove_', 'add_'));
        return _inverse7;
      }

    default:
      {
        throw new Error('Unknown operation type: "' + type + '".');
      }
  }
}

/**
 * Operation attributes.
 *
 * @type {Array}
 */

var OPERATION_ATTRIBUTES = {
  add_mark: ['path', 'mark', 'data'],
  add_annotation: ['annotation', 'data'],
  insert_node: ['path', 'node', 'data'],
  insert_text: ['path', 'offset', 'text', 'data'],
  merge_node: ['path', 'position', 'properties', 'target', 'data'],
  move_node: ['path', 'newPath', 'data'],
  remove_annotation: ['annotation', 'data'],
  remove_mark: ['path', 'mark', 'data'],
  remove_node: ['path', 'node', 'data'],
  remove_text: ['path', 'offset', 'text', 'data'],
  set_annotation: ['properties', 'newProperties', 'data'],
  set_mark: ['path', 'properties', 'newProperties', 'data'],
  set_node: ['path', 'properties', 'newProperties', 'data'],
  set_selection: ['properties', 'newProperties', 'data'],
  set_value: ['properties', 'newProperties', 'data'],
  split_node: ['path', 'position', 'properties', 'target', 'data']

  /**
   * Default properties.
   *
   * @type {Object}
   */

};var DEFAULTS$11 = {
  annotation: undefined,
  data: undefined,
  length: undefined,
  mark: undefined,
  marks: undefined,
  newPath: undefined,
  newProperties: undefined,
  node: undefined,
  offset: undefined,
  path: undefined,
  position: undefined,
  properties: undefined,
  target: undefined,
  text: undefined,
  type: undefined

  /**
   * Operation.
   *
   * @type {Operation}
   */

};
var Operation = function (_Record) {
  inherits(Operation, _Record);

  function Operation() {
    classCallCheck(this, Operation);
    return possibleConstructorReturn(this, (Operation.__proto__ || Object.getPrototypeOf(Operation)).apply(this, arguments));
  }

  createClass(Operation, [{
    key: 'apply',


    /**
     * Apply the operation to a `value`.
     *
     * @param {Value} value
     * @return {Value}
     */

    value: function apply(value) {
      var next = applyOperation(value, this);
      return next;
    }

    /**
     * Invert the operation.
     *
     * @return {Operation}
     */

  }, {
    key: 'invert',
    value: function invert() {
      var inverted = invertOperation(this);
      return inverted;
    }

    /**
     * Return a JSON representation of the operation.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var object = this.object,
          type = this.type;

      var json = { object: object, type: type };
      var ATTRIBUTES = OPERATION_ATTRIBUTES[type];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = ATTRIBUTES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var value = this[key];

          if (key === 'annotation' || key === 'mark' || key === 'marks' || key === 'node' || key === 'path' || key === 'newPath') {
            value = value.toJSON();
          }

          if (key === 'properties' && type === 'merge_node') {
            var v = {};
            if ('data' in value) v.data = value.data.toJS();
            if ('type' in value) v.type = value.type;
            value = v;
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_annotation') {
            var _v = {};
            if ('anchor' in value) _v.anchor = value.anchor.toJS();
            if ('focus' in value) _v.focus = value.focus.toJS();
            if ('key' in value) _v.key = value.key;
            if ('data' in value) _v.data = value.data.toJS();
            if ('type' in value) _v.type = value.type;
            value = _v;
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_mark') {
            var _v2 = {};
            if ('data' in value) _v2.data = value.data.toJS();
            if ('type' in value) _v2.type = value.type;
            value = _v2;
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_node') {
            var _v3 = {};
            if ('data' in value) _v3.data = value.data.toJS();
            if ('type' in value) _v3.type = value.type;
            value = _v3;
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_selection') {
            var _v4 = {};
            if ('anchor' in value) _v4.anchor = value.anchor.toJSON();
            if ('focus' in value) _v4.focus = value.focus.toJSON();
            if ('isFocused' in value) _v4.isFocused = value.isFocused;
            if ('marks' in value) _v4.marks = value.marks && value.marks.toJSON();
            value = _v4;
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_value') {
            var _v5 = {};
            if ('data' in value) _v5.data = value.data.toJS();
            value = _v5;
          }

          if (key === 'properties' && type === 'split_node') {
            var _v6 = {};
            if ('data' in value) _v6.data = value.data.toJS();
            if ('type' in value) _v6.type = value.type;
            value = _v6;
          }

          if (key === 'data') {
            value = value.toJSON();
          }

          json[key] = value;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return json;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Operation` with `attrs`.
     *
     * @param {Object|Array|List|String|Operation} attrs
     * @return {Operation}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Operation.isOperation(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Operation.fromJSON(attrs);
      }

      throw new Error('`Operation.create` only accepts objects or operations, but you passed it: ' + attrs);
    }

    /**
     * Create a list of `Operations` from `elements`.
     *
     * @param {Array<Operation|Object>|List<Operation|Object>} elements
     * @return {List<Operation>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(elements) || Array.isArray(elements)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](elements.map(Operation.create));
        return list;
      }

      throw new Error('`Operation.createList` only accepts arrays or lists, but you passed it: ' + elements);
    }

    /**
     * Create a `Operation` from a JSON `object`.
     *
     * @param {Object|Operation} object
     * @return {Operation}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      if (Operation.isOperation(object)) {
        return object;
      }

      var type = object.type;

      var ATTRIBUTES = OPERATION_ATTRIBUTES[type];
      var attrs = { type: type };

      if (!ATTRIBUTES) {
        throw new Error('`Operation.fromJSON` was passed an unrecognized operation type: "' + type + '"');
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = ATTRIBUTES[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          var v = object[key];

          // Default `data` to an empty object.
          if (key === 'data' && v === undefined) {
            v = {};
          }

          if (v === undefined) {
            throw new Error('`Operation.fromJSON` was passed a "' + type + '" operation without the required "' + key + '" attribute.');
          }

          if (key === 'annotation') {
            v = Annotation.create(v);
          }

          if (key === 'path' || key === 'newPath') {
            v = PathUtils.create(v);
          }

          if (key === 'mark') {
            v = Mark.create(v);
          }

          if (key === 'node') {
            v = Node.create(v);
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_annotation') {
            v = Annotation.createProperties(v);
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_mark') {
            v = Mark.createProperties(v);
          }

          if ((key === 'properties' || key === 'newProperties') && (type === 'set_node' || type === 'merge_node' || type === 'split_node')) {
            v = Node.createProperties(v);
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_selection') {
            v = Selection.createProperties(v);
          }

          if ((key === 'properties' || key === 'newProperties') && type === 'set_value') {
            v = Value.createProperties(v);
          }

          if (key === 'data') {
            v = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(v);
          }

          attrs[key] = v;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var op = new Operation(attrs);
      return op;
    }

    /**
     * Check if `any` is a list of operations.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isOperationList',
    value: function isOperationList(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) && any.every(function (item) {
        return Operation.isOperation(item);
      });
    }
  }]);
  return Operation;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$11));

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$12 = {
  operations: undefined,
  value: undefined

  /**
   * Change.
   *
   * @type {Change}
   */

};
var Change = function (_Record) {
  inherits(Change, _Record);

  function Change() {
    classCallCheck(this, Change);
    return possibleConstructorReturn(this, (Change.__proto__ || Object.getPrototypeOf(Change)).apply(this, arguments));
  }

  createClass(Change, [{
    key: 'toJSON',


    /**
     * Return a JSON representation of the change.
     *
     * @param {Object} options
     * @return {Object}
     */

    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        value: this.value.toJSON(options),
        operations: this.operations.toArray().map(function (o) {
          return o.toJSON(options);
        })
      };

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Change` with `attrs`.
     *
     * @param {Object|Change} attrs
     * @return {Change}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Change.isChange(attrs)) {
        return attrs;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Change.fromJSON(attrs);
      }

      throw new Error('`Change.create` only accepts objects or changes, but you passed it: ' + attrs);
    }

    /**
     * Create a `Change` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Change}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var value = object.value,
          _object$operations = object.operations,
          operations = _object$operations === undefined ? [] : _object$operations;


      var change = new Change({
        value: Value.create(value),
        operations: Operation.createList(operations)
      });

      return change;
    }
  }]);
  return Change;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$12));

/**
 * A plugin that adds a set of commands to the editor.
 *
 * @param {Object} commands
 * @return {Object}
 */

function CommandsPlugin() {
  var commands = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /**
   * On command, if it exists in our list of commands, call it.
   *
   * @param {Object} command
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCommand(command, editor, next) {
    var type = command.type,
        args = command.args;

    var fn = commands[type];
    if (!fn) return next();
    editor.command.apply(editor, [fn].concat(toConsumableArray(args)));
  }

  /**
   * On construct, register all the commands.
   *
   * @param {Editor} editor
   * @param {Function} next
   */

  function onConstruct(editor, next) {
    for (var command in commands) {
      editor.registerCommand(command);
    }

    return next();
  }

  /**
   * Return the plugin.
   *
   * @type {Object}
   */

  return {
    onCommand: onCommand,
    onConstruct: onConstruct
  };
}

/**
 * Surrogate pair start and end points.
 *
 * @type {Number}
 */

var SURROGATE_START = 0xd800;
var SURROGATE_END = 0xdfff;

/**
 * A regex to match space characters.
 *
 * @type {RegExp}
 */

var SPACE = /\s/;

/**
 * A regex to match chameleon characters, that count as word characters as long
 * as they are inside of a word.
 *
 * @type {RegExp}
 */

var CHAMELEON = /['\u2018\u2019]/;

/**
 * A regex that matches punctuation.
 *
 * @type {RegExp}
 */

var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;

/**
 * Is a character `code` in a surrogate character.
 *
 * @param {Number} code
 * @return {Boolean}
 */

function isSurrogate(code) {
  return SURROGATE_START <= code && code <= SURROGATE_END;
}

/**
 * Does `code` form Modifier with next one.
 *
 * https://emojipedia.org/modifiers/
 *
 * @param {Number} code
 * @param {String} text
 * @param {Number} offset
 * @return {Boolean}
 */

function isModifier(code, text, offset) {
  if (code === 0xd83c) {
    var next = text.charCodeAt(offset + 1);
    return next <= 0xdfff && next >= 0xdffb;
  }
  return false;
}

/**
 * Is `code` a Variation Selector.
 *
 * https://codepoints.net/variation_selectors
 *
 * @param {Number} code
 * @return {Boolean}
 */

function isVariationSelector(code) {
  return code <= 0xfe0f && code >= 0xfe00;
}

/**
 * Is `code` one of the BMP codes used in emoji sequences.
 *
 * https://emojipedia.org/emoji-zwj-sequences/
 *
 * @param {Number} code
 * @return {Boolean}
 */

function isBMPEmoji(code) {
  // This requires tiny bit of maintanance, better ideas?
  // Fortunately it only happens if new Unicode Standard
  // is released. Fails gracefully if upkeep lags behind,
  // same way Slate previously behaved with all emojis.
  return code === 0x2764 || // heart (❤)
  code === 0x2642 || // male (♂)
  code === 0x2640 || // female (♀)
  code === 0x2620 || // scull (☠)
  code === 0x2695 || // medical (⚕)
  code === 0x2708 || // plane (✈️)
  code === 0x25ef // large circle (◯)
  ;
}

/**
 * Is a character a word character? Needs the `remaining` characters too.
 *
 * @param {String} char
 * @param {String|Void} remaining
 * @return {Boolean}
 */

function isWord(char, remaining) {
  if (SPACE.test(char)) return false;

  // If it's a chameleon character, recurse to see if the next one is or not.
  if (CHAMELEON.test(char)) {
    var next = remaining.charAt(0);
    var length = getCharLength(next);
    next = remaining.slice(0, length);
    var rest = remaining.slice(length);
    if (isWord(next, rest)) return true;
  }

  if (PUNCTUATION.test(char)) return false;
  return true;
}

/**
 * Get the length of a `character`.
 *
 * @param {String} char
 * @return {Number}
 */

function getCharLength(char) {
  return isSurrogate(char.charCodeAt(0)) ? 2 : 1;
}

/**
 * Get the offset to the end of the character(s) in `text`.
 * This function is emoji aware and handles them correctly.
 *
 * @param {String} text
 * @param {Number} chars
 * @param {Boolean} forward
 * @return {Number}
 */

function getCharOffset(text, chars, forward) {
  var offset = 0;

  // Handle end/beginning of node: we have to return 1 in order not to
  // break cursor's jumping to next/previous node. We need to return early
  // because otherwise, ''.charCodeAt(0) returned NaN and, the default
  // handling 'latin characters' at the end of the while loop would
  // would never be reached an we returned '0' as offset.
  if (text === '') return 1;

  // Calculate offset sum of each character
  for (var i = 0; i < chars; i++) {
    // `prev` types (better ideas?):
    // - SURR: surrogate pair
    // - MOD: modifier (technically also surrogate pair)
    // - ZWJ: zero width joiner
    // - VAR: variation selector
    // - BMP: sequenceable character from Basic Multilingual Plane
    var prev = null;
    var charCode = text.charCodeAt(offset);

    while (charCode) {
      if (isSurrogate(charCode)) {
        var modifier = isModifier(charCode, text, offset);

        // Early returns are the heart of this loop where
        // we decide if previous and current codepoints
        // should form a single character (in other words:
        // how many of them should selection jump over).
        if (forward) {
          if (!modifier && prev && prev !== 'ZWJ' || modifier && prev && prev !== 'SURR') {
            break;
          }
        } else if (prev === 'SURR' || prev === 'BMP') {
          break;
        }

        offset += 2;
        prev = modifier ? 'MOD' : 'SURR';
        charCode = text.charCodeAt(offset);
        // It's okay to `continue` without checking
        // because if `charCode` is NaN (which is
        // the case when out of `text` range), next
        // `while` loop won't execute and we're done.
        continue;
      }

      // If zero width joiner
      if (charCode === 0x200d) {
        offset += 1;
        prev = 'ZWJ';
        charCode = text.charCodeAt(offset);
        continue;
      }

      if (isBMPEmoji(charCode)) {
        if (forward && prev === 'VAR' || prev && prev !== 'ZWJ' && prev !== 'VAR') {
          break;
        }

        offset += 1;
        prev = 'BMP';
        charCode = text.charCodeAt(offset);
        continue;
      }

      if (isVariationSelector(charCode)) {
        if (!forward && prev && prev !== 'ZWJ') {
          break;
        }

        offset += 1;
        prev = 'VAR';
        charCode = text.charCodeAt(offset);
        continue;
      }

      // Modifier "fuses" with what ever character is before that
      // (even whitespace), need to look ahead if loop gets here.
      if (forward) {
        var nextCharCode = text.charCodeAt(offset + 1);

        if (isModifier(nextCharCode, text, offset + 1)) {
          offset += 3;
          prev = 'MOD';
          charCode = text.charCodeAt(offset);
          continue;
        }
      } else if (prev === 'MOD') {
        offset += 1;
        break;
      }

      // If while loop ever gets here, we're
      // done (e.g Latin characters, length 1).
      if (prev === null) offset += 1;
      break;
    }
  }

  return offset;
}

/**
 * Get the offset to the end of character(s) before an `offset` in `text`.
 *
 * @param {String} text
 * @param {Number} offset
 * @param {Number} chars
 * @return {Number}
 */

function getCharOffsetBackward(text, offset) {
  var chars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  text = text.slice(0, offset);
  text = Object(__WEBPACK_IMPORTED_MODULE_5_esrever__["reverse"])(text);
  return getCharOffset(text, chars);
}

/**
 * Get the offset to the end of character(s) after an `offset` in `text`.
 *
 * @param {String} text
 * @param {Number} offset
 * @param {Number} chars
 * @return {Number}
 */

function getCharOffsetForward(text, offset) {
  var chars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  text = text.slice(offset);
  return getCharOffset(text, chars, true);
}

/**
 * Get the offset to the end of the first word in `text`.
 *
 * @param {String} text
 * @return {Number}
 */

function getWordOffset(text) {
  var length = 0;
  var i = 0;
  var started = false;
  var char = void 0;

  while (char = text.charAt(i)) {
    var l = getCharLength(char);
    char = text.slice(i, i + l);
    var rest = text.slice(i + l);

    if (isWord(char, rest)) {
      started = true;
      length += l;
    } else if (!started) {
      length += l;
    } else {
      break;
    }

    i += l;
  }

  return length;
}

/**
 * Get the offset to the end of the word before an `offset` in `text`.
 *
 * @param {String} text
 * @param {Number} offset
 * @return {Number}
 */

function getWordOffsetBackward(text, offset) {
  text = text.slice(0, offset);
  text = Object(__WEBPACK_IMPORTED_MODULE_5_esrever__["reverse"])(text);
  var o = getWordOffset(text);
  return o;
}

/**
 * Get the offset to the end of the word after an `offset` in `text`.
 *
 * @param {String} text
 * @param {Number} offset
 * @return {Number}
 */

function getWordOffsetForward(text, offset) {
  text = text.slice(offset);
  var o = getWordOffset(text);
  return o;
}

/**
 * Export.
 *
 * @type {Object}
 */

var TextUtils = {
  getCharLength: getCharLength,
  getCharOffset: getCharOffset,
  getCharOffsetBackward: getCharOffsetBackward,
  getCharOffsetForward: getCharOffsetForward,
  getWordOffset: getWordOffset,
  getWordOffsetBackward: getWordOffsetBackward,
  getWordOffsetForward: getWordOffsetForward,
  isSurrogate: isSurrogate,
  isWord: isWord
};

/**
 * Ensure that an expanded selection is deleted first, and return the updated
 * range to account for the deleted part.
 *
 * @param {Editor}
 */

function deleteExpandedAtRange(editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
  }

  var value = editor.value;
  var document = value.document;
  var _range = range,
      start = _range.start,
      end = _range.end;


  if (document.hasDescendant(start.path)) {
    range = range.moveToStart();
  } else {
    range = range.moveTo(end.path, 0).normalize(document);
  }

  return range;
}

/**
 * Commands.
 *
 * @type {Object}
 */

var Commands$1 = {};

/**
 * Add a new `mark` to the characters at `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Mixed} mark
 */

Commands$1.addMarkAtRange = function (editor, range, mark) {
  if (range.isCollapsed) return;

  var value = editor.value;
  var document = value.document;
  var start = range.start,
      end = range.end;

  var texts = document.getTextsAtRange(range);

  editor.withoutNormalizing(function () {
    texts.forEach(function (node) {
      var key = node.key;

      var index = 0;
      var length = node.text.length;

      if (key === start.key) index = start.offset;
      if (key === end.key) length = end.offset;
      if (key === start.key && key === end.key) length = end.offset - start.offset;

      editor.addMarkByKey(key, index, length, mark);
    });
  });
};

/**
 * Add a list of `marks` to the characters at `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Array<Mixed>} mark
 */

Commands$1.addMarksAtRange = function (editor, range, marks) {
  marks.forEach(function (mark) {
    return editor.addMarkAtRange(range, mark);
  });
};

/**
 * Delete everything in a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteAtRange = function (editor, range) {
  // Snapshot the selection, which creates an extra undo save point, so that
  // when you undo a delete, the expanded selection will be retained.
  editor.snapshotSelection();

  var value = editor.value;
  var start = range.start,
      end = range.end;

  var startKey = start.key;
  var startOffset = start.offset;
  var endKey = end.key;
  var endOffset = end.offset;
  var document = value.document;

  var isStartVoid = document.hasVoidParent(startKey, editor);
  var isEndVoid = document.hasVoidParent(endKey, editor);
  var startBlock = document.getClosestBlock(startKey);
  var endBlock = document.getClosestBlock(endKey);

  // Check if we have a "hanging" selection case where the even though the
  // selection extends into the start of the end node, we actually want to
  // ignore that for UX reasons.
  var isHanging = startOffset === 0 && endOffset === 0 && isStartVoid === false && startKey === startBlock.getFirstText().key && endKey === endBlock.getFirstText().key && startKey !== endKey;

  // If it's a hanging selection, nudge it back to end in the previous text.
  if (isHanging && isEndVoid) {
    var prevText = document.getPreviousText(endKey);
    endKey = prevText.key;
    endOffset = prevText.text.length;
    isEndVoid = document.hasVoidParent(endKey, editor);
  }

  editor.withoutNormalizing(function () {
    // If the start node is inside a void node, remove the void node and update
    // the starting point to be right after it, continuously until the start point
    // is not a void, or until the entire range is handled.
    while (isStartVoid) {
      var startVoid = document.getClosestVoid(startKey, editor);
      var nextText = document.getNextText(startKey);
      editor.removeNodeByKey(startVoid.key);

      // If the start and end keys are the same, we're done.
      if (startKey === endKey) return;

      // If there is no next text node, we're done.
      if (!nextText) return;

      // Continue...
      document = editor.value.document;
      startKey = nextText.key;
      startOffset = 0;
      isStartVoid = document.hasVoidParent(startKey, editor);
    }

    // If the end node is inside a void node, do the same thing but backwards. But
    // we don't need any aborting checks because if we've gotten this far there
    // must be a non-void node that will exit the loop.
    while (isEndVoid) {
      var endVoid = document.getClosestVoid(endKey, editor);
      var _prevText = document.getPreviousText(endKey);
      editor.removeNodeByKey(endVoid.key);

      // Continue...
      document = editor.value.document;
      endKey = _prevText.key;
      endOffset = _prevText.text.length;
      isEndVoid = document.hasVoidParent(endKey, editor);
    }

    // If the start and end key are the same, and it was a hanging selection, we
    // can just remove the entire block.
    if (startKey === endKey && isHanging) {
      editor.removeNodeByKey(startBlock.key);
      return;
    } else if (startKey === endKey) {
      // Otherwise, if it wasn't hanging, we're inside a single text node, so we can
      // simply remove the text in the range.
      var index = startOffset;
      var length = endOffset - startOffset;
      editor.removeTextByKey(startKey, index, length);
      return;
    } else {
      // Otherwise, we need to recursively remove text and nodes inside the start
      // block after the start offset and inside the end block before the end
      // offset. Then remove any blocks that are in between the start and end
      // blocks. Then finally merge the start and end nodes.
      startBlock = document.getClosestBlock(startKey);
      endBlock = document.getClosestBlock(endKey);
      var startText = document.getNode(startKey);
      var endText = document.getNode(endKey);
      var startLength = startText.text.length - startOffset;
      var endLength = endOffset;

      var ancestor = document.getCommonAncestor(startKey, endKey);
      var startChild = ancestor.getFurthestChild(startKey);
      var endChild = ancestor.getFurthestChild(endKey);

      var startParent = document.getParent(startBlock.key);
      var startParentIndex = startParent.nodes.indexOf(startBlock);
      var endParentIndex = startParent.nodes.indexOf(endBlock);

      var child = void 0;

      // Iterate through all of the nodes in the tree after the start text node
      // but inside the end child, and remove them.
      child = startText;

      while (child.key !== startChild.key) {
        var parent = document.getParent(child.key);
        var _index = parent.nodes.indexOf(child);
        var afters = parent.nodes.slice(_index + 1);

        afters.reverse().forEach(function (node) {
          editor.removeNodeByKey(node.key);
        });

        child = parent;
      }

      // Remove all of the middle children.
      var startChildIndex = ancestor.nodes.indexOf(startChild);
      var endChildIndex = ancestor.nodes.indexOf(endChild);
      var middles = ancestor.nodes.slice(startChildIndex + 1, endChildIndex);

      middles.reverse().forEach(function (node) {
        editor.removeNodeByKey(node.key);
      });

      // Remove the nodes before the end text node in the tree.
      child = endText;

      while (child.key !== endChild.key) {
        var _parent = document.getParent(child.key);
        var _index2 = _parent.nodes.indexOf(child);
        var befores = _parent.nodes.slice(0, _index2);

        befores.reverse().forEach(function (node) {
          editor.removeNodeByKey(node.key);
        });

        child = _parent;
      }

      // Remove any overlapping text content from the leaf text nodes.
      if (startLength !== 0) {
        editor.removeTextByKey(startKey, startOffset, startLength);
      }

      if (endLength !== 0) {
        editor.removeTextByKey(endKey, 0, endOffset);
      }

      // If the start and end blocks aren't the same, move and merge the end block
      // into the start block.
      if (startBlock.key !== endBlock.key) {
        document = editor.value.document;
        var onlyChildAncestor = void 0;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = document.ancestors(endBlock.key)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 1);

            var node = _ref2[0];

            if (node.nodes.size > 1) {
              break;
            } else {
              onlyChildAncestor = node;
            }
          }

          // Move the end block to be right after the start block.
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (endParentIndex !== startParentIndex + 1) {
          editor.moveNodeByKey(endBlock.key, startParent.key, startParentIndex + 1);
        }

        // If the selection is hanging, just remove the start block, otherwise
        // merge the end block into it.
        if (isHanging) {
          editor.removeNodeByKey(startBlock.key);
        } else {
          editor.mergeNodeByKey(endBlock.key);
        }

        // If nested empty blocks are left over above the end block, remove them.
        if (onlyChildAncestor) {
          editor.removeNodeByKey(onlyChildAncestor.key);
        }
      }
    }
  });
};

/**
 * Delete backward `n` characters at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Number} n (optional)
 */

Commands$1.deleteBackwardAtRange = function (editor, range) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (n === 0) return;
  var value = editor.value;
  var document = value.document;
  var _range2 = range,
      start = _range2.start,
      focus = _range2.focus;

  // If the range is expanded, perform a regular delete instead.

  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var voidParent = document.getClosestVoid(start.path, editor);

  // If there is a void parent, delete it.
  if (voidParent) {
    editor.removeNodeByKey(voidParent.key);
    return;
  }

  // If the range is at the start of the document, abort.
  if (start.isAtStartOfNode(document)) {
    return;
  }

  var block = document.getClosestBlock(start.path);

  // PERF: If the closest block is empty, remove it. This is just a shortcut,
  // since merging it would result in the same outcome.
  if (document.nodes.size !== 1 && block && block.text === '' && block.nodes.size === 1) {
    editor.removeNodeByKey(block.key);
    return;
  }

  // If the range is at the start of the text node, we need to figure out what
  // is behind it to know how to delete...
  var text = document.getDescendant(start.path);

  if (start.isAtStartOfNode(text)) {
    var prev = document.getPreviousText(text.key);
    var inline = document.getClosestInline(text.key);

    // If the range is at the start of the inline node, and previous text node
    // is empty, take the text node before that, or "prevBlock" would be the
    // same node as "block"
    if (inline && prev.text === '') {
      prev = document.getPreviousText(prev.key);
    }

    var prevBlock = document.getClosestBlock(prev.key);
    var prevVoid = document.getClosestVoid(prev.key, editor);

    // If the previous text node has a void parent, remove it.
    if (prevVoid) {
      editor.removeNodeByKey(prevVoid.key);
      return;
    }

    // If we're deleting by one character and the previous text node is not
    // inside the current block, we need to merge the two blocks together.
    if (n === 1 && prevBlock !== block) {
      range = range.moveAnchorTo(prev.key, prev.text.length);
      editor.deleteAtRange(range);
      return;
    }
  }

  // If the focus offset is farther than the number of characters to delete,
  // just remove the characters backwards inside the current node.
  if (n <= focus.offset) {
    range = range.moveFocusBackward(n);
    editor.deleteAtRange(range);
    return;
  }

  // Otherwise, we need to see how many nodes backwards to go.
  var node = text;
  var offset = 0;
  var traversed = focus.offset;

  while (n > traversed) {
    node = document.getPreviousText(node.key);
    var next = traversed + node.text.length;

    if (n <= next) {
      offset = next - n;
      break;
    } else {
      traversed = next;
    }
  }

  range = range.moveAnchorTo(node.key, offset);
  editor.deleteAtRange(range);
};

/**
 * Delete backward until the character boundary at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteCharBackwardAtRange = function (editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startBlock = document.getClosestBlock(start.path);
  var offset = startBlock.getOffset(start.key);
  var o = offset + start.offset;
  var text = startBlock.text;

  var n = TextUtils.getCharOffsetBackward(text, o);
  editor.deleteBackwardAtRange(range, n);
};

/**
 * Delete forward until the character boundary at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteCharForwardAtRange = function (editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startBlock = document.getClosestBlock(start.path);
  var offset = startBlock.getOffset(start.key);
  var o = offset + start.offset;
  var text = startBlock.text;

  var n = TextUtils.getCharOffsetForward(text, o);
  editor.deleteForwardAtRange(range, n);
};

/**
 * Delete forward `n` characters at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Number} n (optional)
 */

Commands$1.deleteForwardAtRange = function (editor, range) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (n === 0) return;
  var value = editor.value;
  var document = value.document;
  var _range3 = range,
      start = _range3.start,
      focus = _range3.focus;

  // If the range is expanded, perform a regular delete instead.

  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var voidParent = document.getClosestVoid(start.path, editor);

  // If the node has a void parent, delete it.
  if (voidParent) {
    editor.removeNodeByKey(voidParent.key);
    return;
  }

  var block = document.getClosestBlock(start.path);

  // If the closest is not void, but empty, remove it
  if (block && !editor.isVoid(block) && block.text === '' && document.nodes.size !== 1) {
    var nextBlock = document.getNextBlock(block.key);
    editor.removeNodeByKey(block.key);

    if (nextBlock && nextBlock.key) {
      editor.moveToStartOfNode(nextBlock);
    }

    return;
  }

  // If the range is at the start of the document, abort.
  if (start.isAtEndOfNode(document)) {
    return;
  }

  // If the range is at the start of the text node, we need to figure out what
  // is behind it to know how to delete...
  var text = document.getDescendant(start.path);

  if (start.isAtEndOfNode(text)) {
    var next = document.getNextText(text.key);
    var _nextBlock = document.getClosestBlock(next.key);
    var nextVoid = document.getClosestVoid(next.key, editor);

    // If the next text node has a void parent, remove it.
    if (nextVoid) {
      editor.removeNodeByKey(nextVoid.key);
      return;
    }

    // If we're deleting by one character and the previous text node is not
    // inside the current block, we need to merge the two blocks together.
    if (n === 1 && _nextBlock !== block) {
      range = range.moveFocusTo(next.key, 0);
      editor.deleteAtRange(range);
      return;
    }
  }

  // If the remaining characters to the end of the node is greater than or equal
  // to the number of characters to delete, just remove the characters forwards
  // inside the current node.
  if (n <= text.text.length - focus.offset) {
    range = range.moveFocusForward(n);
    editor.deleteAtRange(range);
    return;
  }

  // Otherwise, we need to see how many nodes forwards to go.
  var node = text;
  var offset = focus.offset;
  var traversed = text.text.length - focus.offset;

  while (n > traversed) {
    node = document.getNextText(node.key);
    var _next = traversed + node.text.length;

    if (n <= _next) {
      offset = n - traversed;
      break;
    } else {
      traversed = _next;
    }
  }

  range = range.moveFocusTo(node.key, offset);
  editor.deleteAtRange(range);
};

/**
 * Delete backward until the line boundary at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteLineBackwardAtRange = function (editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startBlock = document.getClosestBlock(start.path);
  var offset = startBlock.getOffset(start.key);
  var o = offset + start.offset;
  editor.deleteBackwardAtRange(range, o);
};

/**
 * Delete forward until the line boundary at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteLineForwardAtRange = function (editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startBlock = document.getClosestBlock(start.path);
  var offset = startBlock.getOffset(start.key);
  var o = offset + start.offset;
  editor.deleteForwardAtRange(range, startBlock.text.length - o);
};

/**
 * Delete backward until the word boundary at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteWordBackwardAtRange = function (editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startBlock = document.getClosestBlock(start.path);
  var offset = startBlock.getOffset(start.key);
  var o = offset + start.offset;
  var text = startBlock.text;

  var n = o === 0 ? 1 : TextUtils.getWordOffsetBackward(text, o);
  editor.deleteBackwardAtRange(range, n);
};

/**
 * Delete forward until the word boundary at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

Commands$1.deleteWordForwardAtRange = function (editor, range) {
  if (range.isExpanded) {
    editor.deleteAtRange(range);
    return;
  }

  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startBlock = document.getClosestBlock(start.path);
  var offset = startBlock.getOffset(start.key);
  var o = offset + start.offset;
  var text = startBlock.text;

  var wordOffset = TextUtils.getWordOffsetForward(text, o);
  var n = wordOffset === 0 ? 1 : wordOffset;
  editor.deleteForwardAtRange(range, n);
};

/**
 * Insert a `block` node at `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Block|String|Object} block
 */

Commands$1.insertBlockAtRange = function (editor, range, block) {
  range = deleteExpandedAtRange(editor, range);
  block = Block.create(block);

  var value = editor.value;
  var document = value.document;
  var _range4 = range,
      start = _range4.start;

  var startKey = start.key;
  var startOffset = start.offset;
  var startBlock = document.getClosestBlock(startKey);
  var startInline = document.getClosestInline(startKey);
  var parent = document.getParent(startBlock.key);
  var index = parent.nodes.indexOf(startBlock);
  var insertionMode = getInsertionMode(editor, range);

  if (insertionMode === 'before') {
    editor.insertNodeByKey(parent.key, index, block);
  } else if (insertionMode === 'behind') {
    editor.insertNodeByKey(parent.key, index + 1, block);
  } else {
    if (startInline && editor.isVoid(startInline)) {
      var atEnd = start.isAtEndOfNode(startInline);
      var siblingText = atEnd ? document.getNextText(startKey) : document.getPreviousText(startKey);

      var splitRange = atEnd ? range.moveToStartOfNode(siblingText) : range.moveToEndOfNode(siblingText);

      startKey = splitRange.start.key;
      startOffset = splitRange.start.offset;
    }

    editor.withoutNormalizing(function () {
      editor.splitDescendantsByKey(startBlock.key, startKey, startOffset);
      editor.insertNodeByKey(parent.key, index + 1, block);
    });
  }
};

/**
 * Check if current block should be split or new block should be added before or behind it.
 *
 * @param {Editor} editor
 * @param {Range} range
 */

var getInsertionMode = function getInsertionMode(editor, range) {
  var value = editor.value;
  var document = value.document;
  var start = range.start;

  var startKey = start.key;
  var startBlock = document.getClosestBlock(startKey);
  var startInline = document.getClosestInline(startKey);

  if (editor.isVoid(startBlock)) {
    if (start.isAtEndOfNode(startBlock)) return 'behind';else return 'before';
  } else if (!startInline && startBlock.text === '') {
    return 'behind';
  } else if (start.isAtStartOfNode(startBlock)) {
    return 'before';
  } else if (start.isAtEndOfNode(startBlock)) {
    return 'behind';
  }
  return 'split';
};

/**
 * Insert a `fragment` at a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Document} fragment
 */

Commands$1.insertFragmentAtRange = function (editor, range, fragment) {
  editor.withoutNormalizing(function () {
    range = deleteExpandedAtRange(editor, range);

    // If the fragment is empty, there's nothing to do after deleting.
    if (!fragment.nodes.size) return;

    // Regenerate the keys for all of the fragments nodes, so that they're
    // guaranteed not to collide with the existing keys in the document. Otherwise
    // they will be regenerated automatically and we won't have an easy way to
    // reference them.
    fragment = fragment.mapDescendants(function (child) {
      return child.regenerateKey();
    });

    // Calculate a few things...
    var _range5 = range,
        start = _range5.start;
    var value = editor.value;
    var document = value.document;

    var startText = document.getDescendant(start.path);
    var startBlock = document.getClosestBlock(startText.key);
    var startChild = startBlock.getFurthestChild(startText.key);
    var isAtStart = start.isAtStartOfNode(startBlock);
    var parent = document.getParent(startBlock.key);
    var index = parent.nodes.indexOf(startBlock);
    var blocks = fragment.getBlocks();
    var firstChild = fragment.nodes.first();
    var lastChild = fragment.nodes.last();
    var firstBlock = blocks.first();
    var lastBlock = blocks.last();
    var insertionNode = findInsertionNode(fragment, document, startBlock.key);

    // If the fragment only contains a void block, use `insertBlock` instead.
    if (firstBlock === lastBlock && editor.isVoid(firstBlock)) {
      editor.insertBlockAtRange(range, firstBlock);
      return;
    }

    // If inserting the entire fragment and it starts or ends with a single
    // nested block, e.g. a table, we do not merge it with existing blocks.
    if (insertionNode === fragment && (firstChild.hasBlockChildren() || lastChild.hasBlockChildren())) {
      // check if reversal is necessary or not
      var insertionMode = getInsertionMode(editor, range);
      var nodes = insertionMode === 'before' ? fragment.nodes : fragment.nodes.reverse();

      nodes.forEach(function (node) {
        editor.insertBlockAtRange(range, node);
      });
      return;
    }

    // If the first and last block aren't the same, we need to insert all of the
    // nodes after the insertion node's first block at the index.
    if (firstBlock !== lastBlock) {
      var lonelyParent = insertionNode.getFurthest(firstBlock.key, function (p) {
        return p.nodes.size === 1;
      });
      var lonelyChild = lonelyParent || firstBlock;

      var startIndex = parent.nodes.indexOf(startBlock);
      var excludingLonelyChild = insertionNode.removeNode(lonelyChild.key);

      excludingLonelyChild.nodes.forEach(function (node, i) {
        var newIndex = startIndex + i + 1;
        editor.insertNodeByKey(parent.key, newIndex, node);
      });
    }

    // Check if we need to split the node.
    if (start.offset !== 0) {
      editor.splitDescendantsByKey(startChild.key, start.key, start.offset);
    }

    // Update our variables with the new value.
    document = editor.value.document;
    startText = document.getDescendant(start.key);
    startBlock = document.getClosestBlock(start.key);
    startChild = startBlock.getFurthestChild(startText.key);

    // If the first and last block aren't the same, we need to move any of the
    // starting block's children after the split into the last block of the
    // fragment, which has already been inserted.
    if (firstBlock !== lastBlock) {
      var nextChild = isAtStart ? startChild : startBlock.getNextSibling(startChild.key);
      var nextNodes = nextChild ? startBlock.nodes.skipUntil(function (n) {
        return n.key === nextChild.key;
      }) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
      var lastIndex = lastBlock.nodes.size;

      nextNodes.forEach(function (node, i) {
        var newIndex = lastIndex + i;
        editor.moveNodeByKey(node.key, lastBlock.key, newIndex);
      });
    }

    // If the starting block is empty, we replace it entirely with the first block
    // of the fragment, since this leads to a more expected behavior for the user.
    if (!editor.isVoid(startBlock) && startBlock.text === '' && !startBlock.findDescendant(function (n) {
      return editor.isVoid(n);
    })) {
      editor.removeNodeByKey(startBlock.key);
      editor.insertNodeByKey(parent.key, index, firstBlock);
    } else {
      // Otherwise, we maintain the starting block, and insert all of the first
      // block's inline nodes into it at the split point.
      var inlineChild = startBlock.getFurthestChild(startText.key);
      var inlineIndex = startBlock.nodes.indexOf(inlineChild);

      firstBlock.nodes.forEach(function (inline, i) {
        var o = start.offset === 0 ? 0 : 1;
        var newIndex = inlineIndex + i + o;
        editor.insertNodeByKey(startBlock.key, newIndex, inline);
      });
    }
  });
};

/**
 * Get the deepest single child block inside `fragment` whose reversed block
 * ancestors match the reversed block ancestors of the `document` starting at
 * the `documentKey`.
 *
 * @param {Document} document
 * @param {string} documentKey
 * @param {Document} fragment
 * @return {Node}
 */

var findInsertionNode = function findInsertionNode(fragment, document, documentKey) {
  // Find the deepest block in a doc with no siblings.
  var deepestSingleBlock = function deepestSingleBlock(doc) {
    var result = doc;

    while (result.nodes.size === 1 && result.nodes.first().object === 'block') {
      result = result.nodes.first();
    }

    return result === doc ? null : result;
  };

  // Return whether every block in the `fragmentAncestors` list has the
  // same type as the block in `documentAncestors` with the same index.
  var ancestorTypesMatch = function ancestorTypesMatch(fragmentAncestors, documentAncestors) {
    return documentAncestors.size >= fragmentAncestors.size && fragmentAncestors.every(function (fragmentNode, i) {
      return documentAncestors.get(i).type === fragmentNode.type;
    });
  };

  // Given two reverse lists of ancestors, check if all fragment ancestor types
  // match the doc ancestors at some position.
  var matchingFragmentAncestor = function matchingFragmentAncestor(documentAncestors, fragmentAncestors) {
    var depthDifference = documentAncestors.size - fragmentAncestors.size;

    // There is nothing to align if the fragment is deeper than the document.
    if (depthDifference < 0) {
      return fragment;
    }

    for (var fragIdx = 0; fragIdx < fragmentAncestors.size; fragIdx++) {
      // The docIdx loop relaxes our check in that we can still match if there
      // are node type differences leaf-side.
      // This is important for example if our fragment inserts multiple siblings
      // or inserts another type while the tree structure remains the same.
      for (var docIdx = 0; docIdx <= depthDifference; docIdx++) {
        if (ancestorTypesMatch(fragmentAncestors.slice(fragIdx), documentAncestors.slice(docIdx))) {
          return fragmentAncestors.get(fragIdx);
        }
      }
    }
    return fragment;
  };

  // Get the type definitions for all ancestors up from node with key `key`,
  // except the document object.
  var getAncestorBlocks = function getAncestorBlocks(doc, key) {
    return doc.getAncestors(key).slice(1).push(doc.getNode(key)).reverse();
  };

  var fragmentStartBlock = deepestSingleBlock(fragment);

  if (!fragmentStartBlock) {
    return fragment;
  }

  var documentAncestors = getAncestorBlocks(document, documentKey);
  var fragmentAncestors = getAncestorBlocks(fragment, fragmentStartBlock.key);

  return matchingFragmentAncestor(documentAncestors, fragmentAncestors);
};

/**
 * Insert an `inline` node at `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Inline|String|Object} inline
 */

Commands$1.insertInlineAtRange = function (editor, range, inline) {
  inline = Inline.create(inline);

  editor.withoutNormalizing(function () {
    range = deleteExpandedAtRange(editor, range);

    var value = editor.value;
    var document = value.document;
    var _range6 = range,
        start = _range6.start;

    var parent = document.getParent(start.path);
    var startText = document.assertDescendant(start.path);
    var index = parent.nodes.indexOf(startText);

    if (editor.isVoid(parent)) {
      return;
    }

    editor.splitNodeByPath(start.path, start.offset);
    editor.insertNodeByKey(parent.key, index + 1, inline);
  });
};

/**
 * Insert `text` at a `range`, with optional `marks`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {String} text
 * @param {Set<Mark>} marks (optional)
 */

Commands$1.insertTextAtRange = function (editor, range, text, marks) {
  editor.withoutNormalizing(function () {
    range = deleteExpandedAtRange(editor, range);

    var value = editor.value;
    var document = value.document;
    var _range7 = range,
        start = _range7.start;

    var offset = start.offset;
    var parent = document.getParent(start.path);

    if (editor.isVoid(parent)) {
      return;
    }

    editor.insertTextByPath(start.path, offset, text, marks);
  });
};

/**
 * Remove an existing `mark` to the characters at `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Mark|String} mark (optional)
 */

Commands$1.removeMarkAtRange = function (editor, range, mark) {
  if (range.isCollapsed) return;

  var value = editor.value;
  var document = value.document;

  var texts = document.getTextsAtRange(range);
  var start = range.start,
      end = range.end;


  editor.withoutNormalizing(function () {
    texts.forEach(function (node) {
      var key = node.key;

      var index = 0;
      var length = node.text.length;

      if (key === start.key) index = start.offset;
      if (key === end.key) length = end.offset;
      if (key === start.key && key === end.key) length = end.offset - start.offset;

      editor.removeMarkByKey(key, index, length, mark);
    });
  });
};

/**
 * Set the `properties` of block nodes in a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Object|String} properties
 */

Commands$1.setBlocksAtRange = function (editor, range, properties) {
  var value = editor.value;
  var document = value.document;

  var blocks = document.getLeafBlocksAtRange(range);

  var start = range.start,
      end = range.end,
      isCollapsed = range.isCollapsed;

  var isStartVoid = document.hasVoidParent(start.path, editor);
  var startBlock = document.getClosestBlock(start.path);
  var endBlock = document.getClosestBlock(end.key);

  // Check if we have a "hanging" selection case where the even though the
  // selection extends into the start of the end node, we actually want to
  // ignore that for UX reasons.
  var isHanging = isCollapsed === false && start.offset === 0 && end.offset === 0 && isStartVoid === false && start.key === startBlock.getFirstText().key && end.key === endBlock.getFirstText().key;

  // If it's a hanging selection, ignore the last block.
  var sets = isHanging ? blocks.slice(0, -1) : blocks;

  editor.withoutNormalizing(function () {
    sets.forEach(function (block) {
      editor.setNodeByKey(block.key, properties);
    });
  });
};

/**
 * Set the `properties` of inline nodes in a `range`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Object|String} properties
 */

Commands$1.setInlinesAtRange = function (editor, range, properties) {
  var value = editor.value;
  var document = value.document;

  var inlines = document.getLeafInlinesAtRange(range);

  editor.withoutNormalizing(function () {
    inlines.forEach(function (inline) {
      editor.setNodeByKey(inline.key, properties);
    });
  });
};

/**
 * Split the block nodes at a `range`, to optional `height`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Number} height (optional)
 */

Commands$1.splitBlockAtRange = function (editor, range) {
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  range = deleteExpandedAtRange(editor, range);

  var _range8 = range,
      start = _range8.start,
      end = _range8.end;
  var value = editor.value;
  var _value = value,
      document = _value.document;

  var node = document.assertDescendant(start.path);
  var parent = document.getClosestBlock(node.key);
  var h = 0;

  while (parent && parent.object === 'block' && h < height) {
    node = parent;
    parent = document.getClosestBlock(parent.key);
    h++;
  }

  editor.withoutNormalizing(function () {
    editor.splitDescendantsByKey(node.key, start.path, start.offset);

    value = editor.value;
    document = value.document;

    if (range.isExpanded) {
      if (range.isBackward) range = range.flip();
      var nextBlock = document.getNextBlock(node.key);
      range = range.moveAnchorToStartOfNode(nextBlock);
      range = range.setFocus(range.focus.setPath(null));

      if (start.path.equals(end.path)) {
        range = range.moveFocusTo(range.anchor.key, end.offset - start.offset);
      }

      range = document.resolveRange(range);
      editor.deleteAtRange(range);
    }
  });
};

/**
 * Split the inline nodes at a `range`, to optional `height`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Number} height (optional)
 */

Commands$1.splitInlineAtRange = function (editor, range) {
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;

  range = deleteExpandedAtRange(editor, range);

  var _range9 = range,
      start = _range9.start;
  var value = editor.value;
  var document = value.document;

  var node = document.assertDescendant(start.path);
  var parent = document.getClosestInline(node.key);
  var h = 0;

  while (parent && parent.object === 'inline' && h < height) {
    node = parent;
    parent = document.getClosestInline(parent.key);
    h++;
  }

  editor.splitDescendantsByKey(node.key, start.path, start.offset);
};

/**
 * Add or remove a `mark` from the characters at `range`, depending on whether
 * it's already there.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Mixed} mark
 */

Commands$1.toggleMarkAtRange = function (editor, range, mark) {
  if (range.isCollapsed) return;

  mark = Mark.create(mark);

  var value = editor.value;
  var document = value.document;

  var marks = document.getActiveMarksAtRange(range);
  var exists = marks.some(function (m) {
    return m.equals(mark);
  });

  if (exists) {
    editor.removeMarkAtRange(range, mark);
  } else {
    editor.addMarkAtRange(range, mark);
  }
};

/**
 * Unwrap all of the block nodes in a `range` from a block with `properties`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {String|Object} properties
 */

Commands$1.unwrapBlockAtRange = function (editor, range, properties) {
  properties = Node.createProperties(properties);

  var value = editor.value;
  var document = value.document;

  var blocks = document.getLeafBlocksAtRange(range);
  var wrappers = blocks.map(function (block) {
    return document.getClosest(block.key, function (parent) {
      if (parent.object !== 'block') return false;
      if (properties.type != null && parent.type !== properties.type) return false;
      if (properties.data != null && !parent.data.isSuperset(properties.data)) return false;
      return true;
    });
  }).filter(function (exists) {
    return exists;
  }).toOrderedSet().toList();

  editor.withoutNormalizing(function () {
    wrappers.forEach(function (block) {
      var first = block.nodes.first();
      var last = block.nodes.last();
      var parent = editor.value.document.getParent(block.key);
      var index = parent.nodes.indexOf(block);

      var children = block.nodes.filter(function (child) {
        return blocks.some(function (b) {
          return child === b || child.hasDescendant(b.key);
        });
      });

      var firstMatch = children.first();
      var lastMatch = children.last();

      if (first === firstMatch && last === lastMatch) {
        block.nodes.forEach(function (child, i) {
          editor.moveNodeByKey(child.key, parent.key, index + i);
        });

        editor.removeNodeByKey(block.key);
      } else if (last === lastMatch) {
        block.nodes.skipUntil(function (n) {
          return n === firstMatch;
        }).forEach(function (child, i) {
          editor.moveNodeByKey(child.key, parent.key, index + 1 + i);
        });
      } else if (first === firstMatch) {
        block.nodes.takeUntil(function (n) {
          return n === lastMatch;
        }).push(lastMatch).forEach(function (child, i) {
          editor.moveNodeByKey(child.key, parent.key, index + i);
        });
      } else {
        var firstText = firstMatch.getFirstText();

        editor.splitDescendantsByKey(block.key, firstText.key, 0);

        document = editor.value.document;

        children.forEach(function (child, i) {
          if (i === 0) {
            var extra = child;
            child = document.getNextBlock(child.key);
            editor.removeNodeByKey(extra.key);
          }

          editor.moveNodeByKey(child.key, parent.key, index + 1 + i);
        });
      }
    });
  });
};

/**
 * Unwrap the inline nodes in a `range` from an inline with `properties`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {String|Object} properties
 */

Commands$1.unwrapInlineAtRange = function (editor, range, properties) {
  properties = Node.createProperties(properties);

  var value = editor.value;
  var document = value.document;

  var texts = document.getTextsAtRange(range);
  var inlines = texts.map(function (text) {
    return document.getClosest(text.key, function (parent) {
      if (parent.object !== 'inline') return false;
      if (properties.type != null && parent.type !== properties.type) return false;
      if (properties.data != null && !parent.data.isSuperset(properties.data)) return false;
      return true;
    });
  }).filter(function (exists) {
    return exists;
  }).toOrderedSet().toList();

  editor.withoutNormalizing(function () {
    inlines.forEach(function (inline) {
      var parent = editor.value.document.getParent(inline.key);
      var index = parent.nodes.indexOf(inline);

      inline.nodes.forEach(function (child, i) {
        editor.moveNodeByKey(child.key, parent.key, index + i);
      });

      editor.removeNodeByKey(inline.key);
    });
  });
};

/**
 * Wrap all of the blocks in a `range` in a new `block`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Block|Object|String} block
 */

Commands$1.wrapBlockAtRange = function (editor, range, block) {
  block = Block.create(block);
  block = block.set('nodes', block.nodes.clear());

  var value = editor.value;
  var document = value.document;


  var blocks = document.getLeafBlocksAtRange(range);
  var firstblock = blocks.first();
  var lastblock = blocks.last();
  var parent = void 0,
      siblings = void 0,
      index = void 0;

  // If there is only one block in the selection then we know the parent and
  // siblings.
  if (blocks.length === 1) {
    parent = document.getParent(firstblock.key);
    siblings = blocks;
  } else {
    // Determine closest shared parent to all blocks in selection.
    parent = document.getClosest(firstblock.key, function (p1) {
      return !!document.getClosest(lastblock.key, function (p2) {
        return p1 === p2;
      });
    });
  }

  // If no shared parent could be found then the parent is the document.
  if (parent == null) parent = document;

  // Create a list of direct children siblings of parent that fall in the
  // selection.
  if (siblings == null) {
    var indexes = parent.nodes.reduce(function (ind, node, i) {
      if (node === firstblock || node.hasDescendant(firstblock.key)) ind[0] = i;
      if (node === lastblock || node.hasDescendant(lastblock.key)) ind[1] = i;
      return ind;
    }, []);

    index = indexes[0];
    siblings = parent.nodes.slice(indexes[0], indexes[1] + 1);
  }

  // Get the index to place the new wrapped node at.
  if (index == null) {
    index = parent.nodes.indexOf(siblings.first());
  }

  editor.withoutNormalizing(function () {
    // Inject the new block node into the parent.
    editor.insertNodeByKey(parent.key, index, block);

    // Move the sibling nodes into the new block node.
    siblings.forEach(function (node, i) {
      editor.moveNodeByKey(node.key, block.key, i);
    });
  });
};

/**
 * Wrap the text and inlines in a `range` in a new `inline`.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {Inline|Object|String} inline
 */

Commands$1.wrapInlineAtRange = function (editor, range, inline) {
  var value = editor.value;
  var document = value.document;
  var start = range.start,
      end = range.end;


  if (range.isCollapsed) {
    // Wrapping an inline void
    var inlineParent = document.getClosestInline(start.path);

    if (!inlineParent) {
      return;
    }

    if (!editor.isVoid(inlineParent)) {
      return;
    }

    return editor.wrapInlineByKey(inlineParent.key, inline);
  }

  inline = Inline.create(inline);
  inline = inline.set('nodes', inline.nodes.clear());

  var blocks = document.getLeafBlocksAtRange(range);
  var startBlock = document.getClosestBlock(start.path);
  var endBlock = document.getClosestBlock(end.path);
  var startInline = document.getClosestInline(start.path);
  var endInline = document.getClosestInline(end.path);
  var startChild = startBlock.getFurthestChild(start.key);
  var endChild = endBlock.getFurthestChild(end.key);

  editor.withoutNormalizing(function () {
    if (!startInline || startInline !== endInline) {
      editor.splitDescendantsByKey(endChild.key, end.key, end.offset);
      editor.splitDescendantsByKey(startChild.key, start.key, start.offset);
    }

    document = editor.value.document;
    startBlock = document.getDescendant(startBlock.key);
    endBlock = document.getDescendant(endBlock.key);
    startChild = startBlock.getFurthestChild(start.key);
    endChild = endBlock.getFurthestChild(end.key);
    var startIndex = startBlock.nodes.indexOf(startChild);
    var endIndex = endBlock.nodes.indexOf(endChild);

    if (startInline && startInline === endInline) {
      var texts = startBlock.getTextsAtRange(range).map(function (text) {
        if (start.key === text.key && end.key === text.key) {
          return text.splitText(start.offset)[1].splitText(end.offset - start.offset)[0].regenerateKey();
        } else if (start.key === text.key) {
          return text.splitText(start.offset)[1].regenerateKey();
        } else if (end.key === text.key) {
          return text.splitText(end.offset)[0].regenerateKey();
        } else {
          return text.regenerateKey();
        }
      });

      inline = inline.set('nodes', texts);
      editor.insertInlineAtRange(range, inline);
    } else if (startBlock === endBlock) {
      document = editor.value.document;
      startBlock = document.getClosestBlock(start.key);
      startChild = startBlock.getFurthestChild(start.key);

      var startInner = document.getNextSibling(startChild.key);
      var startInnerIndex = startBlock.nodes.indexOf(startInner);
      var endInner = start.key === end.key ? startInner : startBlock.getFurthestChild(end.key);
      var inlines = startBlock.nodes.skipUntil(function (n) {
        return n === startInner;
      }).takeUntil(function (n) {
        return n === endInner;
      }).push(endInner);

      var node = inline.regenerateKey();

      editor.insertNodeByKey(startBlock.key, startInnerIndex, node);

      inlines.forEach(function (child, i) {
        editor.moveNodeByKey(child.key, node.key, i);
      });
    } else {
      var startInlines = startBlock.nodes.slice(startIndex + 1);
      var endInlines = endBlock.nodes.slice(0, endIndex + 1);
      var startNode = inline.regenerateKey();
      var endNode = inline.regenerateKey();

      editor.insertNodeByKey(startBlock.key, startIndex + 1, startNode);
      editor.insertNodeByKey(endBlock.key, endIndex, endNode);

      startInlines.forEach(function (child, i) {
        editor.moveNodeByKey(child.key, startNode.key, i);
      });

      endInlines.forEach(function (child, i) {
        editor.moveNodeByKey(child.key, endNode.key, i);
      });

      blocks.slice(1, -1).forEach(function (block) {
        var node = inline.regenerateKey();
        editor.insertNodeByKey(block.key, 0, node);

        block.nodes.forEach(function (child, i) {
          editor.moveNodeByKey(child.key, node.key, i);
        });
      });
    }
  });
};

/**
 * Wrap the text in a `range` in a prefix/suffix.
 *
 * @param {Editor} editor
 * @param {Range} range
 * @param {String} prefix
 * @param {String} suffix (optional)
 */

Commands$1.wrapTextAtRange = function (editor, range, prefix) {
  var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : prefix;
  var start = range.start,
      end = range.end;

  var startRange = range.moveToStart();
  var endRange = range.moveToEnd();

  if (start.path.equals(end.path)) {
    endRange = endRange.moveForward(prefix.length);
  }

  editor.withoutNormalizing(function () {
    editor.insertTextAtRange(startRange, prefix);
    editor.insertTextAtRange(endRange, suffix);
  });
};

/**
 * Commands.
 *
 * @type {Object}
 */

var Commands$2 = {};

/**
 * Add mark to text at `offset` and `length` in node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} offset
 * @param {Number} length
 * @param {Mixed} mark
 */

Commands$2.addMarkByPath = function (editor, path, offset, length, mark) {
  mark = Mark.create(mark);
  editor.addMarksByPath(path, offset, length, [mark]);
};

Commands$2.addMarksByPath = function (editor, path, offset, length, marks) {
  marks = Mark.createSet(marks);

  if (!marks.size) {
    return;
  }

  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);

  editor.withoutNormalizing(function () {
    // If it ends before the end of the node, we'll need to split to create a new
    // text with different marks.
    if (offset + length < node.text.length) {
      editor.splitNodeByPath(path, offset + length);
    }

    // Same thing if it starts after the start. But in that case, we need to
    // update our path and offset to point to the new start.
    if (offset > 0) {
      editor.splitNodeByPath(path, offset);
      path = PathUtils.increment(path);
      offset = 0;
    }

    marks.forEach(function (mark) {
      editor.applyOperation({
        type: 'add_mark',
        path: path,
        mark: Mark.create(mark)
      });
    });
  });
};

/**
 * Sets specific set of marks on the path
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} offset
 * @param {Number} length
 * @param {Array<Object|Mark>} marks
 */

Commands$2.replaceMarksByPath = function (editor, path, offset, length, marks) {
  var marksSet = Mark.createSet(marks);

  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);

  if (node.marks.equals(marksSet)) {
    return;
  }

  editor.withoutNormalizing(function () {
    // If it ends before the end of the node, we'll need to split to create a new
    // text with different marks.
    if (offset + length < node.text.length) {
      editor.splitNodeByPath(path, offset + length);
    }

    // Same thing if it starts after the start. But in that case, we need to
    // update our path and offset to point to the new start.
    if (offset > 0) {
      editor.splitNodeByPath(path, offset);
      path = PathUtils.increment(path);
      offset = 0;
    }

    var marksToApply = marksSet.subtract(node.marks);
    var marksToRemove = node.marks.subtract(marksSet);

    marksToRemove.forEach(function (mark) {
      editor.applyOperation({
        type: 'remove_mark',
        path: path,
        mark: Mark.create(mark)
      });
    });

    marksToApply.forEach(function (mark) {
      editor.applyOperation({
        type: 'add_mark',
        path: path,
        mark: Mark.create(mark)
      });
    });
  });
};

/**
 * Insert a `fragment` at `index` in a node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} index
 * @param {Fragment} fragment
 */

Commands$2.insertFragmentByPath = function (editor, path, index, fragment) {
  fragment.nodes.forEach(function (node, i) {
    editor.insertNodeByPath(path, index + i, node);
  });
};

/**
 * Insert a `node` at `index` in a node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} index
 * @param {Node} node
 */

Commands$2.insertNodeByPath = function (editor, path, index, node) {
  editor.applyOperation({
    type: 'insert_node',
    path: path.concat(index),
    node: node
  });
};

/**
 * Insert `text` at `offset` in node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} offset
 * @param {String} text
 * @param {Set<Mark>} marks (optional)
 */

Commands$2.insertTextByPath = function (editor, path, offset, text, marks) {
  var value = editor.value;
  var annotations = value.annotations,
      document = value.document;

  document.assertNode(path);

  editor.withoutNormalizing(function () {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = annotations.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var annotation = _step.value;
        var start = annotation.start,
            end = annotation.end;

        var isAtomic = editor.isAtomic(annotation);

        if (!isAtomic) {
          continue;
        }

        if (!start.path.equals(path)) {
          continue;
        }

        if (start.offset < offset && (!end.path.equals(path) || end.offset > offset)) {
          editor.removeAnnotation(annotation);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    editor.applyOperation({
      type: 'insert_text',
      path: path,
      offset: offset,
      text: text
    });

    if (marks) {
      editor.replaceMarksByPath(path, offset, text.length, marks);
    }
  });
};

/**
 * Merge a node by `path` with the previous node.
 *
 * @param {Editor} editor
 * @param {Array} path
 */

Commands$2.mergeNodeByPath = function (editor, path) {
  var value = editor.value;
  var document = value.document;

  var original = document.getDescendant(path);
  var previous = document.getPreviousSibling(path);

  if (!previous) {
    throw new Error('Unable to merge node with path "' + path + '", because it has no previous sibling.');
  }

  var position = previous.object === 'text' ? previous.text.length : previous.nodes.size;

  editor.applyOperation({
    type: 'merge_node',
    path: path,
    position: position,
    // for undos to succeed we only need the type and data because
    // these are the only properties that get changed in the merge operation
    properties: {
      type: original.type,
      data: original.data
    },
    target: null
  });
};

/**
 * Move a node by `path` to a new parent by `newParentPath` and `newIndex`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {String} newParentPath
 * @param {Number} newIndex
 */

Commands$2.moveNodeByPath = function (editor, path, newParentPath, newIndex) {
  // If the operation path and newParentPath are the same,
  // this should be considered a NOOP
  if (PathUtils.isEqual(path, newParentPath)) {
    return editor;
  }

  var newPath = newParentPath.concat(newIndex);

  if (PathUtils.isEqual(path, newPath)) {
    return editor;
  }

  editor.applyOperation({
    type: 'move_node',
    path: path,
    newPath: newPath
  });
};

/**
 * Remove mark from text at `offset` and `length` in node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} offset
 * @param {Number} length
 * @param {Mark} mark
 */

Commands$2.removeMarkByPath = function (editor, path, offset, length, mark) {
  mark = Mark.create(mark);
  editor.removeMarksByPath(path, offset, length, [mark]);
};

Commands$2.removeMarksByPath = function (editor, path, offset, length, marks) {
  marks = Mark.createSet(marks);

  if (!marks.size) {
    return;
  }

  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);

  if (marks.intersect(node.marks).isEmpty()) {
    return;
  }

  editor.withoutNormalizing(function () {
    // If it ends before the end of the node, we'll need to split to create a new
    // text with different marks.
    if (offset + length < node.text.length) {
      editor.splitNodeByPath(path, offset + length);
    }

    // Same thing if it starts after the start. But in that case, we need to
    // update our path and offset to point to the new start.
    if (offset > 0) {
      editor.splitNodeByPath(path, offset);
      path = PathUtils.increment(path);
      offset = 0;
    }

    marks.forEach(function (mark) {
      editor.applyOperation({
        type: 'remove_mark',
        path: path,
        offset: offset,
        length: length,
        mark: mark
      });
    });
  });
};

/**
 * Remove all `marks` from node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 */

Commands$2.removeAllMarksByPath = function (editor, path) {
  var state = editor.state;
  var document = state.document;

  var node = document.assertNode(path);

  editor.withoutNormalizing(function () {
    if (node.object === 'text') {
      editor.removeMarksByPath(path, 0, node.text.length, node.marks);
      return;
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = node.texts()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _ref = _step2.value;

        var _ref2 = slicedToArray(_ref, 2);

        var n = _ref2[0];
        var p = _ref2[1];

        var pth = path.concat(p);
        editor.removeMarksByPath(pth, 0, n.text.length, n.marks);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  });
};

/**
 * Remove a node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 */

Commands$2.removeNodeByPath = function (editor, path) {
  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);

  editor.applyOperation({
    type: 'remove_node',
    path: path,
    node: node
  });
};

/**
 * Remove text at `offset` and `length` in node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} offset
 * @param {Number} length
 */

Commands$2.removeTextByPath = function (editor, path, offset, length) {
  var value = editor.value;
  var document = value.document,
      annotations = value.annotations;

  var node = document.assertNode(path);
  var text = node.text.slice(offset, offset + length);

  editor.withoutNormalizing(function () {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = annotations.values()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var annotation = _step3.value;
        var start = annotation.start,
            end = annotation.end;

        var isAtomic = editor.isAtomic(annotation);

        if (!isAtomic) {
          continue;
        }

        if (!start.path.equals(path)) {
          continue;
        }

        if (start.offset < offset && (!end.path.equals(path) || end.offset > offset)) {
          editor.removeAnnotation(annotation);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    editor.applyOperation({
      type: 'remove_text',
      path: path,
      offset: offset,
      text: text
    });
  });
};

/**
`* Replace a `node` with another `node`
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Object|Node} node
 */

Commands$2.replaceNodeByPath = function (editor, path, newNode) {
  newNode = Node.create(newNode);
  var index = path.last();
  var parentPath = PathUtils.lift(path);

  editor.withoutNormalizing(function () {
    editor.removeNodeByPath(path);
    editor.insertNodeByPath(parentPath, index, newNode);
  });
};

/**
 * Replace a `length` of text at `offset` with new `text` and optional `marks`.
 *
 * @param {Editor} editor
 * @param {String} key
 * @param {Number} offset
 * @param {Number} length
 * @param {string} text
 * @param {Set<Mark>} marks (optional)
 */

Commands$2.replaceTextByPath = function (editor, path, offset, length, text, marks) {
  editor.withoutNormalizing(function () {
    editor.removeTextByPath(path, offset, length);
    editor.insertTextByPath(path, offset, text, marks);
  });
};

/**
 * Set `newProperties` on mark on text at `offset` and `length` in node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} offset
 * @param {Number} length
 * @param {Object|Mark} properties
 * @param {Object} newProperties
 */

Commands$2.setMarkByPath = function (editor, path, offset, length, properties, newProperties) {
  properties = Mark.create(properties);
  newProperties = Mark.createProperties(newProperties);

  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);

  editor.withoutNormalizing(function () {
    // If it ends before the end of the node, we'll need to split to create a new
    // text with different marks.
    if (offset + length < node.text.length) {
      editor.splitNodeByPath(path, offset + length);
    }

    // Same thing if it starts after the start. But in that case, we need to
    // update our path and offset to point to the new start.
    if (offset > 0) {
      editor.splitNodeByPath(path, offset);
      path = PathUtils.increment(path);
      offset = 0;
    }

    editor.applyOperation({
      type: 'set_mark',
      path: path,
      properties: properties,
      newProperties: newProperties
    });
  });
};

/**
 * Set `properties` on a node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Object|String} newProperties
 */

Commands$2.setNodeByPath = function (editor, path, newProperties) {
  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);
  newProperties = Node.createProperties(newProperties);
  var prevProperties = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(node, Object.keys(newProperties));

  editor.applyOperation({
    type: 'set_node',
    path: path,
    properties: prevProperties,
    newProperties: newProperties
  });
};

/**
 * Insert `text` at `offset` in node by `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {String} text
 * @param {Set<Mark>} marks (optional)
 */

Commands$2.setTextByPath = function (editor, path, text, marks) {
  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);
  var end = node.text.length;
  editor.replaceTextByPath(path, 0, end, text, marks);
};

/**
 * Split a node by `path` at `position`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Number} position
 * @param {Object} options
 */

Commands$2.splitNodeByPath = function (editor, path, position) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$target = options.target,
      target = _options$target === undefined ? null : _options$target;
  var value = editor.value;
  var document = value.document;

  var node = document.getDescendant(path);

  editor.applyOperation({
    type: 'split_node',
    path: path,
    position: position,
    target: target,
    properties: {
      type: node.type,
      data: node.data
    }
  });
};

/**
 * Split a node deeply down the tree by `path`, `textPath` and `textOffset`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Array} textPath
 * @param {Number} textOffset
 */

Commands$2.splitDescendantsByPath = function (editor, path, textPath, textOffset) {
  if (path.equals(textPath)) {
    editor.splitNodeByPath(textPath, textOffset);
    return;
  }

  var value = editor.value;
  var document = value.document;

  var index = textOffset;
  var lastPath = textPath;

  editor.withoutNormalizing(function () {
    editor.splitNodeByKey(textPath, textOffset);

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = document.ancestors(textPath)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _ref3 = _step4.value;

        var _ref4 = slicedToArray(_ref3, 2);

        var ancestorPath = _ref4[1];

        var target = index;
        index = lastPath.last() + 1;
        lastPath = ancestorPath;
        editor.splitNodeByPath(ancestorPath, index, { target: target });

        if (ancestorPath.equals(path)) {
          break;
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  });
};

/**
 * Unwrap content from an inline parent with `properties`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Object|String} properties
 */

Commands$2.unwrapInlineByPath = function (editor, path, properties) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var node = document.assertNode(path);
  var first = node.getFirstText();
  var last = node.getLastText();
  var range = selection.moveToRangeOfNode(first, last);
  editor.unwrapInlineAtRange(range, properties);
};

/**
 * Unwrap content from a block parent with `properties`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Object|String} properties
 */

Commands$2.unwrapBlockByPath = function (editor, path, properties) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var node = document.assertNode(path);
  var first = node.getFirstText();
  var last = node.getLastText();
  var range = selection.moveToRangeOfNode(first, last);
  editor.unwrapBlockAtRange(range, properties);
};

/**
 * Unwrap a single node from its parent.
 *
 * If the node is surrounded with siblings, its parent will be
 * split. If the node is the only child, the parent is removed, and
 * simply replaced by the node itself.  Cannot unwrap a root node.
 *
 * @param {Editor} editor
 * @param {Array} path
 */

Commands$2.unwrapNodeByPath = function (editor, path) {
  var value = editor.value;
  var document = value.document;

  document.assertNode(path);

  var parentPath = PathUtils.lift(path);
  var parent = document.assertNode(parentPath);
  var index = path.last();
  var parentIndex = parentPath.last();
  var grandPath = PathUtils.lift(parentPath);
  var isFirst = index === 0;
  var isLast = index === parent.nodes.size - 1;

  editor.withoutNormalizing(function () {
    if (parent.nodes.size === 1) {
      editor.moveNodeByPath(path, grandPath, parentIndex + 1);
      editor.removeNodeByPath(parentPath);
    } else if (isFirst) {
      editor.moveNodeByPath(path, grandPath, parentIndex);
    } else if (isLast) {
      editor.moveNodeByPath(path, grandPath, parentIndex + 1);
    } else {
      var updatedPath = PathUtils.increment(path, 1, parentPath.size - 1);
      updatedPath = updatedPath.set(updatedPath.size - 1, 0);
      editor.splitNodeByPath(parentPath, index);
      editor.moveNodeByPath(updatedPath, grandPath, parentIndex + 1);
    }
  });
};

/**
 * Unwrap all of the children of a node, by removing the node and replacing it
 * with the children in the tree.
 *
 * @param {Editor} editor
 * @param {Array} path
 */

Commands$2.unwrapChildrenByPath = function (editor, path) {
  path = PathUtils.create(path);
  var value = editor.value;
  var document = value.document;

  var node = document.assertNode(path);
  var parentPath = PathUtils.lift(path);
  var index = path.last();
  var nodes = node.nodes;


  editor.withoutNormalizing(function () {
    nodes.reverse().forEach(function (child, i) {
      var childIndex = nodes.size - i - 1;
      var childPath = path.push(childIndex);
      editor.moveNodeByPath(childPath, parentPath, index + 1);
    });

    editor.removeNodeByPath(path);
  });
};

/**
 * Wrap a node in a block with `properties`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Block|Object|String} block
 */

Commands$2.wrapBlockByPath = function (editor, path, block) {
  block = Block.create(block);
  block = block.set('nodes', block.nodes.clear());
  var parentPath = PathUtils.lift(path);
  var index = path.last();
  var newPath = PathUtils.increment(path);

  editor.withoutNormalizing(function () {
    editor.insertNodeByPath(parentPath, index, block);
    editor.moveNodeByPath(newPath, path, 0);
  });
};

/**
 * Wrap a node in an inline with `properties`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Block|Object|String} inline
 */

Commands$2.wrapInlineByPath = function (editor, path, inline) {
  inline = Inline.create(inline);
  inline = inline.set('nodes', inline.nodes.clear());
  var parentPath = PathUtils.lift(path);
  var index = path.last();
  var newPath = PathUtils.increment(path);

  editor.withoutNormalizing(function () {
    editor.insertNodeByPath(parentPath, index, inline);
    editor.moveNodeByPath(newPath, path, 0);
  });
};

/**
 * Wrap a node by `path` with `node`.
 *
 * @param {Editor} editor
 * @param {Array} path
 * @param {Node|Object} node
 */

Commands$2.wrapNodeByPath = function (editor, path, node) {
  node = Node.create(node);

  if (node.object === 'block') {
    editor.wrapBlockByPath(path, node);
  } else if (node.object === 'inline') {
    editor.wrapInlineByPath(path, node);
  }
};

/**
 * Mix in `*ByKey` variants.
 */

var COMMANDS = ['addMark', 'insertFragment', 'insertNode', 'insertText', 'mergeNode', 'removeAllMarks', 'removeMark', 'removeNode', 'removeText', 'replaceMarks', 'replaceNode', 'replaceText', 'setMark', 'setNode', 'setText', 'splitNode', 'unwrapBlock', 'unwrapChildren', 'unwrapInline', 'unwrapNode', 'wrapBlock', 'wrapInline', 'wrapNode'];

var _loop = function _loop(method) {
  Commands$2[method + 'ByKey'] = function (editor, key) {
    for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    var value = editor.value;
    var document = value.document;

    var path = document.assertPath(key);
    editor[method + 'ByPath'].apply(editor, [path].concat(args));
  };
};

var _iteratorNormalCompletion5 = true;
var _didIteratorError5 = false;
var _iteratorError5 = undefined;

try {
  for (var _iterator5 = COMMANDS[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
    var method = _step5.value;

    _loop(method);
  }

  // Moving nodes takes two keys, so it's slightly different.
} catch (err) {
  _didIteratorError5 = true;
  _iteratorError5 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion5 && _iterator5.return) {
      _iterator5.return();
    }
  } finally {
    if (_didIteratorError5) {
      throw _iteratorError5;
    }
  }
}

Commands$2.moveNodeByKey = function (editor, key, newKey) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var value = editor.value;
  var document = value.document;

  var path = document.assertPath(key);
  var newPath = document.assertPath(newKey);
  editor.moveNodeByPath.apply(editor, [path, newPath].concat(args));
};

// Splitting descendants takes two keys, so it's slightly different.
Commands$2.splitDescendantsByKey = function (editor, key, textKey) {
  for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }

  var value = editor.value;
  var document = value.document;

  var path = document.assertPath(key);
  var textPath = document.assertPath(textKey);
  editor.splitDescendantsByPath.apply(editor, [path, textPath].concat(args));
};

/**
 * Commands.
 *
 * @type {Object}
 */

var Commands$3 = {};

/**
 * Save an `operation` into the history.
 *
 * @param {Editor} editor
 * @param {Object} operation
 */

Commands$3.save = function (editor, operation) {
  var operations = editor.operations,
      value = editor.value;
  var data = value.data;
  var _editor$tmp = editor.tmp,
      save = _editor$tmp.save,
      merge = _editor$tmp.merge;

  if (save === false || !isValidOperation(operation)) return;

  var undos = data.get('undos') || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var lastBatch = undos.last();
  var lastOperation = lastBatch && lastBatch.last();

  // If `merge` is non-commital, and this is not the first operation in a new
  // editor, then merge, otherwise merge based on the last operation.
  if (merge == null) {
    if (operations.size !== 0) {
      merge = true;
    } else {
      merge = shouldMerge(operation, lastOperation);
    }
  }

  // If the `merge` flag is true, add the operation to the last batch.
  if (merge && lastBatch) {
    var batch = lastBatch.push(operation);
    undos = undos.pop();
    undos = undos.push(batch);
  } else {
    // Otherwise, create a new batch with the operation.
    var _batch = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([operation]);
    undos = undos.push(_batch);
  }

  // Constrain the history to 100 entries for memory's sake.
  if (undos.size > 100) {
    undos = undos.takeLast(100);
  }

  // Clear the redos and update the history.
  editor.withoutSaving(function () {
    var redos = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
    var newData = data.set('undos', undos).set('redos', redos);
    editor.setData(newData);
  });
};

/**
 * Redo to the next value in the history.
 *
 * @param {Editor} editor
 */

Commands$3.redo = function (editor) {
  var value = editor.value;
  var data = value.data;

  var redos = data.get('redos') || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var undos = data.get('undos') || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var batch = redos.last();
  if (!batch) return;

  editor.withoutSaving(function () {
    editor.withoutNormalizing(function () {
      // Replay the batch of operations.
      batch.forEach(function (op) {
        var _op = op,
            type = _op.type,
            newProperties = _op.newProperties;

        // When the operation mutates the selection, omit its `isFocused` value to
        // prevent the editor focus from changing during redoing.

        if (type === 'set_selection') {
          op = op.set('newProperties', __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default()(newProperties, 'isFocused'));
        }

        editor.applyOperation(op);
      });

      // Shift the next value into the undo stack.
      redos = redos.pop();
      undos = undos.push(batch);
      var newData = data.set('undos', undos).set('redos', redos);
      editor.setData(newData);
    });
  });
};

/**
 * Undo the previous operations in the history.
 *
 * @param {Editor} editor
 */

Commands$3.undo = function (editor) {
  var value = editor.value;
  var data = value.data;

  var redos = data.get('redos') || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var undos = data.get('undos') || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var batch = undos.last();
  if (!batch) return;

  editor.withoutSaving(function () {
    editor.withoutNormalizing(function () {
      // Replay the inverse of the previous operations.
      batch.slice().reverse().map(function (op) {
        return op.invert();
      }).forEach(function (inverse) {
        var _inverse = inverse,
            type = _inverse.type,
            newProperties = _inverse.newProperties;

        // When the operation mutates the selection, omit its `isFocused` value to
        // prevent the editor focus from changing during undoing.

        if (type === 'set_selection') {
          inverse = inverse.set('newProperties', __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default()(newProperties, 'isFocused'));
        }

        editor.applyOperation(inverse);
      });

      // Shift the previous operations into the redo stack.
      redos = redos.push(batch);
      undos = undos.pop();
      var newData = data.set('undos', undos).set('redos', redos);
      editor.setData(newData);
    });
  });
};

/**
 * Apply a series of changes inside a synchronous `fn`, without merging any of
 * the new operations into previous save point in the history.
 *
 * @param {Editor} editor
 * @param {Function} fn
 */

Commands$3.withoutMerging = function (editor, fn) {
  var value = editor.tmp.merge;
  editor.tmp.merge = false;
  fn(editor);
  editor.tmp.merge = value;
};

/**
 * Apply a series of changes inside a synchronous `fn`, without saving any of
 * their operations into the history.
 *
 * @param {Editor} editor
 * @param {Function} fn
 */

Commands$3.withoutSaving = function (editor, fn) {
  var value = editor.tmp.save;
  editor.tmp.save = false;
  fn(editor);
  editor.tmp.save = value;
};

/**
 * Check whether to merge a new operation `o` into the previous operation `p`.
 *
 * @param {Object} o
 * @param {Object} p
 * @return {Boolean}
 */

function shouldMerge(o, p) {
  if (!p) return false;

  var merge = o.type === 'set_selection' && p.type === 'set_selection' || o.type === 'insert_text' && p.type === 'insert_text' && o.offset === p.offset + p.text.length && o.path.equals(p.path) || o.type === 'remove_text' && p.type === 'remove_text' && o.offset + o.text.length === p.offset && o.path.equals(p.path);

  return merge;
}

/**
 * Check weather an operation needs to be saved to the history
 * @param {Object} o - operation
 * @returns {Boolean}
 */

function isValidOperation(o) {
  if (o.type === 'set_selection') {
    var _o$newProperties = o.newProperties,
        isFocused = _o$newProperties.isFocused,
        anchor = _o$newProperties.anchor,
        focus = _o$newProperties.focus;

    // this is blur/focus operation, dont need to store it into the history

    if (isFocused !== undefined && !anchor && !focus) {
      return false;
    }
  }
  return true;
}

var Commands$4 = {};

Commands$4.blur = function (editor) {
  editor.select({ isFocused: false });
};

Commands$4.deselect = function (editor) {
  var range = Selection.create();
  editor.select(range);
};

Commands$4.focus = function (editor) {
  editor.select({ isFocused: true });
};

Commands$4.flip = function (editor) {
  editor.command(proxy, 'flip');
};

Commands$4.moveAnchorBackward = function (editor) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  editor.command.apply(editor, [pointBackward, 'anchor'].concat(args));
};

Commands$4.moveAnchorWordBackward = function (editor) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  editor.command.apply(editor, [pointWordBackward, 'anchor'].concat(args));
};

Commands$4.moveAnchorForward = function (editor) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  editor.command.apply(editor, [pointForward, 'anchor'].concat(args));
};

Commands$4.moveAnchorWordForward = function (editor) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  editor.command.apply(editor, [pointWordForward, 'anchor'].concat(args));
};

Commands$4.moveAnchorTo = function (editor) {
  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  editor.command.apply(editor, [proxy, 'moveAnchorTo'].concat(args));
};

Commands$4.moveAnchorToEndOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'anchor', 'end', 'block');
};

Commands$4.moveAnchorToEndOfInline = function (editor) {
  editor.command(pointEdgeObject, 'anchor', 'end', 'inline');
};

Commands$4.moveAnchorToEndOfDocument = function (editor) {
  editor.moveAnchorToEndOfNode(editor.value.document).moveToAnchor();
};

Commands$4.moveAnchorToEndOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'end', 'next', 'block');
};

Commands$4.moveAnchorToEndOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'end', 'next', 'inline');
};

Commands$4.moveAnchorToEndOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'end', 'next', 'text');
};

Commands$4.moveAnchorToEndOfNode = function (editor) {
  for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }

  editor.command.apply(editor, [proxy, 'moveAnchorToEndOfNode'].concat(args));
};

Commands$4.moveAnchorToEndOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'end', 'previous', 'block');
};

Commands$4.moveAnchorToEndOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'end', 'previous', 'inline');
};

Commands$4.moveAnchorToEndOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'end', 'previous', 'text');
};

Commands$4.moveAnchorToEndOfText = function (editor) {
  editor.command(pointEdgeObject, 'anchor', 'end', 'text');
};

Commands$4.moveAnchorToStartOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'anchor', 'start', 'block');
};

Commands$4.moveAnchorToStartOfDocument = function (editor) {
  editor.moveAnchorToStartOfNode(editor.value.document).moveToAnchor();
};

Commands$4.moveAnchorToStartOfInline = function (editor) {
  editor.command(pointEdgeObject, 'anchor', 'start', 'inline');
};

Commands$4.moveAnchorToStartOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'start', 'next', 'block');
};

Commands$4.moveAnchorToStartOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'start', 'next', 'inline');
};

Commands$4.moveAnchorToStartOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'start', 'next', 'text');
};

Commands$4.moveAnchorToStartOfNode = function (editor) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  editor.command.apply(editor, [proxy, 'moveAnchorToStartOfNode'].concat(args));
};

Commands$4.moveAnchorToStartOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'start', 'previous', 'block');
};

Commands$4.moveAnchorToStartOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'start', 'previous', 'inline');
};

Commands$4.moveAnchorToStartOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'anchor', 'start', 'previous', 'text');
};

Commands$4.moveAnchorToStartOfText = function (editor) {
  editor.command(pointEdgeObject, 'anchor', 'start', 'text');
};

Commands$4.moveBackward = function (editor) {
  var chars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (chars === 0) return;

  var value = editor.value;
  var document = value.document,
      selection = value.selection;
  var start = selection.start;

  var startBlock = document.getClosestBlock(start.key);
  var o = startBlock.getOffset(start.key);
  var offset = o + start.offset;
  var text = startBlock.text;

  var charsOffset = TextUtils.getCharOffsetBackward(text, offset, chars);
  editor.moveAnchorBackward(charsOffset).moveFocusBackward(charsOffset);
};

Commands$4.moveWordBackward = function (editor) {
  for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
    args[_key8 - 1] = arguments[_key8];
  }

  editor.moveFocusWordBackward.apply(editor, args).moveToFocus();
};

Commands$4.moveEndBackward = function (editor) {
  for (var _len9 = arguments.length, args = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
    args[_key9 - 1] = arguments[_key9];
  }

  editor.command.apply(editor, [pointBackward, 'end'].concat(args));
};

Commands$4.moveEndWordBackward = function (editor) {
  for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    args[_key10 - 1] = arguments[_key10];
  }

  editor.command.apply(editor, [pointWordBackward, 'end'].concat(args));
};

Commands$4.moveEndForward = function (editor) {
  for (var _len11 = arguments.length, args = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
    args[_key11 - 1] = arguments[_key11];
  }

  editor.command.apply(editor, [pointForward, 'end'].concat(args));
};

Commands$4.moveEndWordForward = function (editor) {
  for (var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
    args[_key12 - 1] = arguments[_key12];
  }

  editor.command.apply(editor, [pointWordForward, 'end'].concat(args));
};

Commands$4.moveEndTo = function (editor) {
  for (var _len13 = arguments.length, args = Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
    args[_key13 - 1] = arguments[_key13];
  }

  editor.command.apply(editor, [proxy, 'moveEndTo'].concat(args));
};

Commands$4.moveEndToEndOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'end', 'end', 'block');
};

Commands$4.moveEndToEndOfDocument = function (editor) {
  editor.moveEndToEndOfNode(editor.value.document).moveToEnd();
};

Commands$4.moveEndToEndOfInline = function (editor) {
  editor.command(pointEdgeObject, 'end', 'end', 'inline');
};

Commands$4.moveEndToEndOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'end', 'next', 'block');
};

Commands$4.moveEndToEndOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'end', 'next', 'inline');
};

Commands$4.moveEndToEndOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'end', 'next', 'text');
};

Commands$4.moveEndToEndOfNode = function (editor) {
  for (var _len14 = arguments.length, args = Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
    args[_key14 - 1] = arguments[_key14];
  }

  editor.command.apply(editor, [proxy, 'moveEndToEndOfNode'].concat(args));
};

Commands$4.moveEndToEndOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'end', 'previous', 'block');
};

Commands$4.moveEndToEndOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'end', 'previous', 'inline');
};

Commands$4.moveEndToEndOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'end', 'previous', 'text');
};

Commands$4.moveEndToEndOfText = function (editor) {
  editor.command(pointEdgeObject, 'end', 'end', 'text');
};

Commands$4.moveEndToStartOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'end', 'start', 'block');
};

Commands$4.moveEndToStartOfDocument = function (editor) {
  editor.moveEndToStartOfNode(editor.value.document).moveToEnd();
};

Commands$4.moveEndToStartOfInline = function (editor) {
  editor.command(pointEdgeObject, 'end', 'start', 'inline');
};

Commands$4.moveEndToStartOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'start', 'next', 'block');
};

Commands$4.moveEndToStartOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'start', 'next', 'inline');
};

Commands$4.moveEndToStartOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'start', 'next', 'text');
};

Commands$4.moveEndToStartOfNode = function (editor) {
  for (var _len15 = arguments.length, args = Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
    args[_key15 - 1] = arguments[_key15];
  }

  editor.command.apply(editor, [proxy, 'moveEndToStartOfNode'].concat(args));
};

Commands$4.moveEndToStartOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'start', 'previous', 'block');
};

Commands$4.moveEndToStartOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'start', 'previous', 'inline');
};

Commands$4.moveEndToStartOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'end', 'start', 'previous', 'text');
};

Commands$4.moveEndToStartOfText = function (editor) {
  editor.command(pointEdgeObject, 'end', 'start', 'text');
};

Commands$4.moveFocusBackward = function (editor) {
  for (var _len16 = arguments.length, args = Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
    args[_key16 - 1] = arguments[_key16];
  }

  editor.command.apply(editor, [pointBackward, 'focus'].concat(args));
};

Commands$4.moveFocusWordBackward = function (editor) {
  for (var _len17 = arguments.length, args = Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
    args[_key17 - 1] = arguments[_key17];
  }

  editor.command.apply(editor, [pointWordBackward, 'focus'].concat(args));
};

Commands$4.moveFocusForward = function (editor) {
  for (var _len18 = arguments.length, args = Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
    args[_key18 - 1] = arguments[_key18];
  }

  editor.command.apply(editor, [pointForward, 'focus'].concat(args));
};

Commands$4.moveFocusWordForward = function (editor) {
  for (var _len19 = arguments.length, args = Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
    args[_key19 - 1] = arguments[_key19];
  }

  editor.command.apply(editor, [pointWordForward, 'focus'].concat(args));
};

Commands$4.moveFocusTo = function (editor) {
  for (var _len20 = arguments.length, args = Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
    args[_key20 - 1] = arguments[_key20];
  }

  editor.command.apply(editor, [proxy, 'moveFocusTo'].concat(args));
};

Commands$4.moveFocusToEndOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'focus', 'end', 'block');
};

Commands$4.moveFocusToEndOfDocument = function (editor) {
  editor.moveFocusToEndOfNode(editor.value.document).moveToFocus();
};

Commands$4.moveFocusToEndOfInline = function (editor) {
  editor.command(pointEdgeObject, 'focus', 'end', 'inline');
};

Commands$4.moveFocusToEndOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'end', 'next', 'block');
};

Commands$4.moveFocusToEndOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'end', 'next', 'inline');
};

Commands$4.moveFocusToEndOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'end', 'next', 'text');
};

Commands$4.moveFocusToEndOfNode = function (editor) {
  for (var _len21 = arguments.length, args = Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
    args[_key21 - 1] = arguments[_key21];
  }

  editor.command.apply(editor, [proxy, 'moveFocusToEndOfNode'].concat(args));
};

Commands$4.moveFocusToEndOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'end', 'previous', 'block');
};

Commands$4.moveFocusToEndOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'end', 'previous', 'inline');
};

Commands$4.moveFocusToEndOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'end', 'previous', 'text');
};

Commands$4.moveFocusToEndOfText = function (editor) {
  editor.command(pointEdgeObject, 'focus', 'end', 'text');
};

Commands$4.moveFocusToStartOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'focus', 'start', 'block');
};

Commands$4.moveFocusToStartOfDocument = function (editor) {
  editor.moveFocusToStartOfNode(editor.value.document).moveToFocus();
};

Commands$4.moveFocusToStartOfInline = function (editor) {
  editor.command(pointEdgeObject, 'focus', 'start', 'inline');
};

Commands$4.moveFocusToStartOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'start', 'next', 'block');
};

Commands$4.moveFocusToStartOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'start', 'next', 'inline');
};

Commands$4.moveFocusToStartOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'start', 'next', 'text');
};

Commands$4.moveFocusToStartOfNode = function (editor) {
  for (var _len22 = arguments.length, args = Array(_len22 > 1 ? _len22 - 1 : 0), _key22 = 1; _key22 < _len22; _key22++) {
    args[_key22 - 1] = arguments[_key22];
  }

  editor.command.apply(editor, [proxy, 'moveFocusToStartOfNode'].concat(args));
};

Commands$4.moveFocusToStartOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'start', 'previous', 'block');
};

Commands$4.moveFocusToStartOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'start', 'previous', 'inline');
};

Commands$4.moveFocusToStartOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'focus', 'start', 'previous', 'text');
};

Commands$4.moveFocusToStartOfText = function (editor) {
  editor.command(pointEdgeObject, 'focus', 'start', 'text');
};

Commands$4.moveForward = function (editor) {
  var chars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (chars === 0) return;

  var value = editor.value;
  var document = value.document,
      selection = value.selection;
  var start = selection.start;

  var startBlock = document.getClosestBlock(start.path);
  var o = startBlock.getOffset(start.key);
  var offset = o + start.offset;
  var text = startBlock.text;

  var charsOffset = TextUtils.getCharOffsetForward(text, offset, chars);
  editor.moveAnchorForward(charsOffset).moveFocusForward(charsOffset);
};

Commands$4.moveWordForward = function (editor) {
  var _editor$moveFocusWord;

  for (var _len23 = arguments.length, args = Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
    args[_key23 - 1] = arguments[_key23];
  }

  (_editor$moveFocusWord = editor.moveFocusWordForward.apply(editor, args)).moveToFocus.apply(_editor$moveFocusWord, args);
};

Commands$4.moveStartBackward = function (editor) {
  for (var _len24 = arguments.length, args = Array(_len24 > 1 ? _len24 - 1 : 0), _key24 = 1; _key24 < _len24; _key24++) {
    args[_key24 - 1] = arguments[_key24];
  }

  editor.command.apply(editor, [pointBackward, 'start'].concat(args));
};

Commands$4.moveStartWordBackward = function (editor) {
  for (var _len25 = arguments.length, args = Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
    args[_key25 - 1] = arguments[_key25];
  }

  editor.command.apply(editor, [pointWordBackward, 'start'].concat(args));
};

Commands$4.moveStartForward = function (editor) {
  for (var _len26 = arguments.length, args = Array(_len26 > 1 ? _len26 - 1 : 0), _key26 = 1; _key26 < _len26; _key26++) {
    args[_key26 - 1] = arguments[_key26];
  }

  editor.command.apply(editor, [pointForward, 'start'].concat(args));
};

Commands$4.moveStartWordForward = function (editor) {
  for (var _len27 = arguments.length, args = Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
    args[_key27 - 1] = arguments[_key27];
  }

  editor.command.apply(editor, [pointWordForward, 'start'].concat(args));
};

Commands$4.moveStartTo = function (editor) {
  for (var _len28 = arguments.length, args = Array(_len28 > 1 ? _len28 - 1 : 0), _key28 = 1; _key28 < _len28; _key28++) {
    args[_key28 - 1] = arguments[_key28];
  }

  editor.command.apply(editor, [proxy, 'moveStartTo'].concat(args));
};

Commands$4.moveStartToEndOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'start', 'end', 'block');
};

Commands$4.moveStartToEndOfDocument = function (editor) {
  editor.moveStartToEndOfNode(editor.value.document).moveToStart();
};

Commands$4.moveStartToEndOfInline = function (editor) {
  editor.command(pointEdgeObject, 'start', 'end', 'inline');
};

Commands$4.moveStartToEndOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'end', 'next', 'block');
};

Commands$4.moveStartToEndOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'end', 'next', 'inline');
};

Commands$4.moveStartToEndOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'end', 'next', 'text');
};

Commands$4.moveStartToEndOfNode = function (editor) {
  for (var _len29 = arguments.length, args = Array(_len29 > 1 ? _len29 - 1 : 0), _key29 = 1; _key29 < _len29; _key29++) {
    args[_key29 - 1] = arguments[_key29];
  }

  editor.command.apply(editor, [proxy, 'moveStartToEndOfNode'].concat(args));
};

Commands$4.moveStartToEndOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'end', 'previous', 'block');
};

Commands$4.moveStartToEndOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'end', 'previous', 'inline');
};

Commands$4.moveStartToEndOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'end', 'previous', 'text');
};

Commands$4.moveStartToEndOfText = function (editor) {
  editor.command(pointEdgeObject, 'start', 'end', 'text');
};

Commands$4.moveStartToStartOfBlock = function (editor) {
  editor.command(pointEdgeObject, 'start', 'start', 'block');
};

Commands$4.moveStartToStartOfDocument = function (editor) {
  editor.moveStartToStartOfNode(editor.value.document).moveToStart();
};

Commands$4.moveStartToStartOfInline = function (editor) {
  editor.command(pointEdgeObject, 'start', 'start', 'inline');
};

Commands$4.moveStartToStartOfNextBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'start', 'next', 'block');
};

Commands$4.moveStartToStartOfNextInline = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'start', 'next', 'inline');
};

Commands$4.moveStartToStartOfNextText = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'start', 'next', 'text');
};

Commands$4.moveStartToStartOfNode = function (editor) {
  for (var _len30 = arguments.length, args = Array(_len30 > 1 ? _len30 - 1 : 0), _key30 = 1; _key30 < _len30; _key30++) {
    args[_key30 - 1] = arguments[_key30];
  }

  editor.command.apply(editor, [proxy, 'moveStartToStartOfNode'].concat(args));
};

Commands$4.moveStartToStartOfPreviousBlock = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'start', 'previous', 'block');
};

Commands$4.moveStartToStartOfPreviousInline = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'start', 'previous', 'inline');
};

Commands$4.moveStartToStartOfPreviousText = function (editor) {
  editor.command(pointEdgeSideObject, 'start', 'start', 'previous', 'text');
};

Commands$4.moveStartToStartOfText = function (editor) {
  editor.command(pointEdgeObject, 'start', 'start', 'text');
};

Commands$4.moveTo = function (editor) {
  for (var _len31 = arguments.length, args = Array(_len31 > 1 ? _len31 - 1 : 0), _key31 = 1; _key31 < _len31; _key31++) {
    args[_key31 - 1] = arguments[_key31];
  }

  editor.command.apply(editor, [proxy, 'moveTo'].concat(args));
};

Commands$4.moveToAnchor = function (editor) {
  editor.command(proxy, 'moveToAnchor');
};

Commands$4.moveToEnd = function (editor) {
  editor.command(proxy, 'moveToEnd');
};

Commands$4.moveToEndOfBlock = function (editor) {
  editor.moveEndToEndOfBlock().moveToEnd();
};

Commands$4.moveToEndOfDocument = function (editor) {
  editor.moveEndToEndOfNode(editor.value.document).moveToEnd();
};

Commands$4.moveToEndOfInline = function (editor) {
  editor.moveEndToEndOfInline().moveToEnd();
};

Commands$4.moveToEndOfNextBlock = function (editor) {
  editor.moveEndToEndOfNextBlock().moveToEnd();
};

Commands$4.moveToEndOfNextInline = function (editor) {
  editor.moveEndToEndOfNextInline().moveToEnd();
};

Commands$4.moveToEndOfNextText = function (editor) {
  editor.moveEndToEndOfNextText().moveToEnd();
};

Commands$4.moveToEndOfNode = function (editor) {
  for (var _len32 = arguments.length, args = Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
    args[_key32 - 1] = arguments[_key32];
  }

  editor.command.apply(editor, [proxy, 'moveToEndOfNode'].concat(args));
};

Commands$4.moveToEndOfPreviousBlock = function (editor) {
  editor.moveStartToEndOfPreviousBlock().moveToStart();
};

Commands$4.moveToEndOfPreviousInline = function (editor) {
  editor.moveStartToEndOfPreviousInline().moveToStart();
};

Commands$4.moveToEndOfPreviousText = function (editor) {
  editor.moveStartToEndOfPreviousText().moveToStart();
};

Commands$4.moveToEndOfText = function (editor) {
  editor.moveEndToEndOfText().moveToEnd();
};

Commands$4.moveToFocus = function (editor) {
  editor.command(proxy, 'moveToFocus');
};

Commands$4.moveToRangeOfDocument = function (editor) {
  editor.moveToRangeOfNode(editor.value.document);
};

Commands$4.moveToRangeOfNode = function (editor) {
  for (var _len33 = arguments.length, args = Array(_len33 > 1 ? _len33 - 1 : 0), _key33 = 1; _key33 < _len33; _key33++) {
    args[_key33 - 1] = arguments[_key33];
  }

  editor.command.apply(editor, [proxy, 'moveToRangeOfNode'].concat(args));
};

Commands$4.moveToStart = function (editor) {
  editor.command(proxy, 'moveToStart');
};

Commands$4.moveToStartOfBlock = function (editor) {
  editor.moveStartToStartOfBlock().moveToStart();
};

Commands$4.moveToStartOfDocument = function (editor) {
  editor.moveStartToStartOfNode(editor.value.document).moveToStart();
};

Commands$4.moveToStartOfInline = function (editor) {
  editor.moveStartToStartOfInline().moveToStart();
};

Commands$4.moveToStartOfNextBlock = function (editor) {
  editor.moveEndToStartOfNextBlock().moveToEnd();
};

Commands$4.moveToStartOfNextInline = function (editor) {
  editor.moveEndToStartOfNextInline().moveToEnd();
};

Commands$4.moveToStartOfNextText = function (editor) {
  editor.moveEndToStartOfNextText().moveToEnd();
};

Commands$4.moveToStartOfNode = function (editor) {
  for (var _len34 = arguments.length, args = Array(_len34 > 1 ? _len34 - 1 : 0), _key34 = 1; _key34 < _len34; _key34++) {
    args[_key34 - 1] = arguments[_key34];
  }

  editor.command.apply(editor, [proxy, 'moveToStartOfNode'].concat(args));
};

Commands$4.moveToStartOfPreviousBlock = function (editor) {
  editor.moveStartToStartOfPreviousBlock().moveToStart();
};

Commands$4.moveToStartOfPreviousInline = function (editor) {
  editor.moveStartToStartOfPreviousInline().moveToStart();
};

Commands$4.moveToStartOfPreviousText = function (editor) {
  editor.moveStartToStartOfPreviousText().moveToStart();
};

Commands$4.moveToStartOfText = function (editor) {
  editor.moveStartToStartOfText().moveToStart();
};

Commands$4.select = function (editor, properties) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  properties = Selection.createProperties(properties);
  var _options$snapshot = options.snapshot,
      snapshot = _options$snapshot === undefined ? false : _options$snapshot;
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var newProperties = {};
  var next = selection.setProperties(properties);
  next = document.resolveSelection(next);

  // Re-compute the properties, to ensure that we get their normalized values.
  properties = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(next, Object.keys(properties));

  // Remove any properties that are already equal to the current selection. And
  // create a dictionary of the previous values for all of the properties that
  // are being changed, for the inverse operation.
  for (var k in properties) {
    if (snapshot === true || !Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["is"])(properties[k], selection[k])) {
      newProperties[k] = properties[k];
    }
  }

  // If the selection moves, clear any marks, unless the new selection
  // properties change the marks in some way.
  if (selection.marks && !newProperties.marks && (newProperties.anchor || newProperties.focus)) {
    newProperties.marks = null;
  }

  // If there are no new properties to set, abort to avoid extra operations.
  if (Object.keys(newProperties).length === 0) {
    return;
  }

  // TODO: for some reason toJSON() is required here (it breaks selections between blocks)? - 2018-10-10
  var prevProperties = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(selection.toJSON(), Object.keys(newProperties));

  editor.applyOperation({
    type: 'set_selection',
    value: value,
    properties: prevProperties,
    newProperties: newProperties
  }, snapshot ? { skip: false, merge: false } : {});
};

Commands$4.setAnchor = function (editor) {
  for (var _len35 = arguments.length, args = Array(_len35 > 1 ? _len35 - 1 : 0), _key35 = 1; _key35 < _len35; _key35++) {
    args[_key35 - 1] = arguments[_key35];
  }

  editor.command.apply(editor, [proxy, 'setAnchor'].concat(args));
};

Commands$4.setEnd = function (editor) {
  for (var _len36 = arguments.length, args = Array(_len36 > 1 ? _len36 - 1 : 0), _key36 = 1; _key36 < _len36; _key36++) {
    args[_key36 - 1] = arguments[_key36];
  }

  editor.command.apply(editor, [proxy, 'setEnd'].concat(args));
};

Commands$4.setFocus = function (editor) {
  for (var _len37 = arguments.length, args = Array(_len37 > 1 ? _len37 - 1 : 0), _key37 = 1; _key37 < _len37; _key37++) {
    args[_key37 - 1] = arguments[_key37];
  }

  editor.command.apply(editor, [proxy, 'setFocus'].concat(args));
};

Commands$4.setStart = function (editor) {
  for (var _len38 = arguments.length, args = Array(_len38 > 1 ? _len38 - 1 : 0), _key38 = 1; _key38 < _len38; _key38++) {
    args[_key38 - 1] = arguments[_key38];
  }

  editor.command.apply(editor, [proxy, 'setStart'].concat(args));
};

Commands$4.snapshotSelection = function (editor) {
  editor.withoutMerging(function () {
    editor.select(editor.value.selection, { snapshot: true });
  });
};

/**
 * Helpers.
 */

function proxy(editor, method) {
  var _editor$value$selecti;

  for (var _len39 = arguments.length, args = Array(_len39 > 2 ? _len39 - 2 : 0), _key39 = 2; _key39 < _len39; _key39++) {
    args[_key39 - 2] = arguments[_key39];
  }

  var range = (_editor$value$selecti = editor.value.selection)[method].apply(_editor$value$selecti, args);
  editor.select(range);
}

function pointEdgeObject(editor, point, edge, object) {
  var Point = point.slice(0, 1).toUpperCase() + point.slice(1);
  var Edge = edge.slice(0, 1).toUpperCase() + edge.slice(1);
  var Object = object.slice(0, 1).toUpperCase() + object.slice(1);
  var method = 'move' + Point + 'To' + Edge + 'OfNode';
  var getNode = object === 'text' ? 'getNode' : 'getClosest' + Object;
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var p = selection[point];
  var node = document[getNode](p.key);
  if (!node) return;
  editor[method](node);
}

function pointEdgeSideObject(editor, point, edge, side, object) {
  var Point = point.slice(0, 1).toUpperCase() + point.slice(1);
  var Edge = edge.slice(0, 1).toUpperCase() + edge.slice(1);
  var Side = side.slice(0, 1).toUpperCase() + side.slice(1);
  var Object = object.slice(0, 1).toUpperCase() + object.slice(1);
  var method = 'move' + Point + 'To' + Edge + 'OfNode';
  var getNode = object === 'text' ? 'getNode' : 'getClosest' + Object;
  var getDirectionNode = 'get' + Side + Object;
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var p = selection[point];
  var node = document[getNode](p.key);
  if (!node) return;
  var target = document[getDirectionNode](node.key);
  if (!target) return;
  editor[method](target);
}

function pointBackward(editor, point) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (n === 0) return;
  if (n < 0) return pointForward(editor, point, -n);

  var Point = point.slice(0, 1).toUpperCase() + point.slice(1);
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var p = selection[point];
  var hasVoidParent = document.hasVoidParent(p.path, editor);

  // what is this?
  if (!hasVoidParent && p.offset - n >= 0) {
    var range = selection['move' + Point + 'Backward'](n);
    editor.select(range);
    return;
  }

  var previous = document.getPreviousText(p.path);
  if (!previous) return;

  var block = document.getClosestBlock(p.path);
  var isInBlock = block.hasNode(previous.key);
  var isPreviousInVoid = previous && document.hasVoidParent(previous.key, editor);
  editor['move' + Point + 'ToEndOfNode'](previous);

  // when is this called?
  if (!hasVoidParent && !isPreviousInVoid && isInBlock) {
    var _range = editor.value.selection['move' + Point + 'Backward'](n);
    editor.select(_range);
  }
}

function pointForward(editor, point) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (n === 0) return;
  if (n < 0) return pointBackward(editor, point, -n);

  var Point = point.slice(0, 1).toUpperCase() + point.slice(1);
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var p = selection[point];
  var text = document.getNode(p.path);
  var hasVoidParent = document.hasVoidParent(p.path, editor);

  // what is this?
  if (!hasVoidParent && p.offset + n <= text.text.length) {
    var range = selection['move' + Point + 'Forward'](n);
    editor.select(range);
    return;
  }

  var next = document.getNextText(p.path);
  if (!next) return;

  var block = document.getClosestBlock(p.path);
  var isInBlock = block.hasNode(next.key);
  var isNextInVoid = document.hasVoidParent(next.key, editor);
  editor['move' + Point + 'ToStartOfNode'](next);

  // when is this called?
  if (!hasVoidParent && !isNextInVoid && isInBlock) {
    var _range2 = editor.value.selection['move' + Point + 'Forward'](n);
    editor.select(_range2);
  }
}

function pointWordBackward(editor, pointName) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var point = selection[pointName];
  var block = document.getClosestBlock(point.key);
  var offset = block.getOffset(point.key);
  var o = offset + point.offset;
  var text = block.text;

  var n = TextUtils.getWordOffsetBackward(text, o);
  editor.command(pointBackward, pointName, n > 0 ? n : 1);
}

function pointWordForward(editor, pointName) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  var point = selection[pointName];
  var block = document.getClosestBlock(point.key);
  var offset = block.getOffset(point.key);
  var o = offset + point.offset;
  var text = block.text;

  var n = TextUtils.getWordOffsetForward(text, o);
  editor.command(pointForward, pointName, n > 0 ? n : 1);
}

/**
 * Commands.
 *
 * @type {Object}
 */

var Commands$5 = {};

/**
 * Set `properties` on the value.
 *
 * @param {Editor} editor
 * @param {Object|Value} properties
 */

Commands$5.setData = function (editor) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var value = editor.value;

  var newProperties = Value.createProperties({ data: data });
  var prevProperties = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(value, Object.keys(newProperties));

  editor.applyOperation({
    type: 'set_value',
    properties: prevProperties,
    newProperties: newProperties
  });
};

Commands$5.addAnnotation = function (editor, annotation) {
  annotation = Annotation.create(annotation);

  editor.applyOperation({
    type: 'add_annotation',
    annotation: annotation
  });
};

Commands$5.removeAnnotation = function (editor, annotation) {
  annotation = Annotation.create(annotation);

  editor.applyOperation({
    type: 'remove_annotation',
    annotation: annotation
  });
};

Commands$5.setAnnotation = function (editor, annotation, newProperties) {
  annotation = Annotation.create(annotation);
  newProperties = Annotation.createProperties(newProperties);

  editor.applyOperation({
    type: 'set_annotation',
    properties: annotation,
    newProperties: newProperties
  });
};

Commands$5.setAnnotations = function (editor) {
  var annotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var value = editor.value;

  var newProperties = Value.createProperties({ annotations: annotations });
  var prevProperties = __WEBPACK_IMPORTED_MODULE_6_lodash_pick___default()(value, Object.keys(newProperties));

  editor.applyOperation({
    type: 'set_value',
    properties: prevProperties,
    newProperties: newProperties
  });
};

/**
 * A plugin that adds a set of queries to the editor.
 *
 * @param {Object} queries
 * @return {Object}
 */

function QueriesPlugin() {
  var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /**
   * On construct, register all the queries.
   *
   * @param {Editor} editor
   * @param {Function} next
   */

  function onConstruct(editor, next) {
    for (var query in queries) {
      editor.registerQuery(query);
    }

    return next();
  }

  /**
   * On query, if it exists in our list of queries, call it.
   *
   * @param {Object} query
   * @param {Editor} editor
   * @param {Function} next
   */

  function onQuery(query, editor, next) {
    var type = query.type,
        args = query.args;

    var fn = queries[type];
    if (!fn) return next();
    var ret = fn.apply(undefined, [editor].concat(toConsumableArray(args)));
    return ret === undefined ? next() : ret;
  }

  /**
   * Return the plugin.
   *
   * @type {Object}
   */

  return {
    onConstruct: onConstruct,
    onQuery: onQuery
  };
}

/**
 * Define a Slate error.
 *
 * @type {SlateError}
 */

var SlateError = function (_Error) {
  inherits(SlateError, _Error);

  function SlateError(code) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, SlateError);

    var _this = possibleConstructorReturn(this, (SlateError.__proto__ || Object.getPrototypeOf(SlateError)).call(this, code));

    _this.code = code;

    for (var key in attrs) {
      _this[key] = attrs[key];
    }

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error().stack;
    }
    return _this;
  }

  return SlateError;
}(Error);

/**
 * Create a plugin from a `schema` definition.
 *
 * @param {Object} schema
 * @return {Object}
 */

function SchemaPlugin(schema) {
  var rules = schema.rules,
      document = schema.document,
      blocks = schema.blocks,
      inlines = schema.inlines,
      marks = schema.marks,
      annotations = schema.annotations,
      decorations = schema.decorations;

  var schemaRules = [];

  if (rules) {
    schemaRules = schemaRules.concat(rules);
  }

  if (document) {
    schemaRules.push(_extends({
      match: [{ object: 'document' }]
    }, document));
  }

  if (blocks) {
    for (var key in blocks) {
      schemaRules.push(_extends({
        match: [{ object: 'block', type: key }]
      }, blocks[key]));
    }
  }

  if (inlines) {
    for (var _key in inlines) {
      schemaRules.push(_extends({
        match: [{ object: 'inline', type: _key }]
      }, inlines[_key]));
    }
  }

  if (marks) {
    for (var _key2 in marks) {
      schemaRules.push(_extends({
        match: [{ object: 'mark', type: _key2 }]
      }, marks[_key2]));
    }
  }

  if (annotations) {
    for (var _key3 in annotations) {
      schemaRules.push(_extends({
        match: [{ object: 'annotation', type: _key3 }]
      }, annotations[_key3]));
    }
  }

  if (decorations) {
    for (var _key4 in decorations) {
      schemaRules.push(_extends({
        match: [{ object: 'decoration', type: _key4 }]
      }, decorations[_key4]));
    }
  }

  /**
   * Check if a `format` is atomic based on the schema rules.
   *
   * @param {Editor} editor
   * @param {Format} format
   * @return {Boolean}
   */

  function isAtomic(editor, format) {
    var rule = schemaRules.find(function (r) {
      return 'isAtomic' in r && testRules(format, r.match);
    });

    return rule && rule.isAtomic;
  }

  /**
   * Check if a `node` is void based on the schema rules.
   *
   * @param {Editor} editor
   * @param {Node} node
   * @return {Boolean}
   */

  function isVoid(editor, node) {
    var rule = schemaRules.find(function (r) {
      return 'isVoid' in r && testRules(node, r.match);
    });

    return rule && rule.isVoid;
  }

  /**
   * Normalize a `node` with the schema rules, returning a function that will
   * fix the invalid node, or void if the node is valid.
   *
   * @param {Node} node
   * @param {Editor} editor
   * @param {Function} next
   * @return {Function|Void}
   */

  function normalizeNode(node, editor, next) {
    var error = validateNode(node, editor, function () {});
    if (!error) return next();

    return function () {
      var rule = error.rule;
      var size = editor.operations.size;

      // First run the user-provided `normalize` function if one exists...

      if (rule.normalize) {
        rule.normalize(editor, error);
      }

      // If the `normalize` function did not add any operations to the editor
      // object, it can't have normalized, so run the default one.
      if (editor.operations.size === size) {
        defaultNormalize(editor, error);
      }
    };
  }

  /**
   * Validate a `node` with the schema rules, returning a `SlateError` if it's
   * invalid.
   *
   * @param {Node} node
   * @param {Editor} editor
   * @param {Function} next
   * @return {Error|Void}
   */

  function validateNode(node, editor, next) {
    var matches = schemaRules.filter(function (r) {
      return testRules(node, r.match);
    });
    var failure = validateRules(node, matches, schemaRules, { every: true });
    if (!failure) return next();
    var error = new SlateError(failure.code, failure);
    return error;
  }

  /**
   * On schema-related queries, respond if we can.
   *
   * @param {Object} query
   * @param {Function} next
   */

  var queries = QueriesPlugin({ isAtomic: isAtomic, isVoid: isVoid });

  /**
   * Return the plugins.
   *
   * @type {Object}
   */

  return [{ normalizeNode: normalizeNode, validateNode: validateNode }, queries];
}

/**
 * Normalize an invalid value with `error` with default remedies.
 *
 * @param {Editor} editor
 * @param {SlateError} error
 */

function defaultNormalize(editor, error) {
  var code = error.code,
      node = error.node,
      child = error.child,
      next = error.next,
      previous = error.previous,
      key = error.key,
      mark = error.mark;


  switch (code) {
    case 'child_max_invalid':
    case 'child_object_invalid':
    case 'child_type_invalid':
    case 'child_unknown':
    case 'first_child_object_invalid':
    case 'first_child_type_invalid':
    case 'last_child_object_invalid':
    case 'last_child_type_invalid':
      {
        return child.object === 'text' && node.object === 'block' && node.nodes.size === 1 ? editor.removeNodeByKey(node.key) : editor.removeNodeByKey(child.key);
      }

    case 'previous_sibling_object_invalid':
    case 'previous_sibling_type_invalid':
      {
        return previous.object === 'text' && node.object === 'block' && node.nodes.size === 1 ? editor.removeNodeByKey(node.key) : editor.removeNodeByKey(previous.key);
      }

    case 'next_sibling_object_invalid':
    case 'next_sibling_type_invalid':
      {
        return next.object === 'text' && node.object === 'block' && node.nodes.size === 1 ? editor.removeNodeByKey(node.key) : editor.removeNodeByKey(next.key);
      }

    case 'child_min_invalid':
    case 'node_text_invalid':
    case 'parent_object_invalid':
    case 'parent_type_invalid':
      {
        return node.object === 'document' ? node.nodes.forEach(function (n) {
          return editor.removeNodeByKey(n.key);
        }) : editor.removeNodeByKey(node.key);
      }

    case 'node_data_invalid':
      {
        return node.data.get(key) === undefined && node.object !== 'document' ? editor.removeNodeByKey(node.key) : editor.setNodeByKey(node.key, { data: node.data.delete(key) });
      }

    case 'node_mark_invalid':
      {
        return node.getTexts().forEach(function (t) {
          return editor.removeMarkByKey(t.key, 0, t.text.length, mark);
        });
      }

    default:
      {
        return editor.removeNodeByKey(node.key);
      }
  }
}

/**
 * Check that an `object` matches one of a set of `rules`.
 *
 * @param {Mixed} object
 * @param {Object|Array} rules
 * @return {Boolean}
 */

function testRules(object, rules) {
  var error = validateRules(object, rules);
  return !error;
}

/**
 * Validate that a `object` matches a `rule` object or array.
 *
 * @param {Mixed} object
 * @param {Object|Array} rule
 * @param {Array|Void} rules
 * @return {Error|Void}
 */

function validateRules(object, rule, rules) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$every = options.every,
      every = _options$every === undefined ? false : _options$every,
      _options$match = options.match,
      match = _options$match === undefined ? null : _options$match;


  if (typeof rule === 'function') {
    var valid = rule(object, match);
    return valid ? null : fail('node_invalid', { rule: rule, node: object });
  }

  if (Array.isArray(rule)) {
    var array = rule.length ? rule : [{}];
    var first = void 0;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var r = _step.value;

        var _error = validateRules(object, r, rules);
        first = first || _error;
        if (every && _error) return _error;
        if (!every && !_error) return;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return first;
  }

  var error = validateObject(object, rule) || validateType(object, rule) || validateData(object, rule) || validateMarks(object, rule) || validateText(object, rule) || validateFirst(object, rule) || validateLast(object, rule) || validateNodes(object, rule, rules);

  return error;
}

function validateObject(node, rule) {
  if (rule.object == null) return;
  if (rule.object === node.object) return;
  if (typeof rule.object === 'function' && rule.object(node.object)) return;
  return fail('node_object_invalid', { rule: rule, node: node });
}

function validateType(node, rule) {
  if (rule.type == null) return;
  if (rule.type === node.type) return;
  if (typeof rule.type === 'function' && rule.type(node.type)) return;
  return fail('node_type_invalid', { rule: rule, node: node });
}

function validateData(node, rule) {
  if (rule.data == null) return;
  if (node.data == null) return;

  if (typeof rule.data === 'function') {
    if (rule.data(node.data)) return;
    return fail('node_data_invalid', { rule: rule, node: node });
  }

  for (var key in rule.data) {
    var fn = rule.data[key];
    var value = node.data && node.data.get(key);
    var valid = typeof fn === 'function' ? fn(value) : fn === value;
    if (valid) continue;
    return fail('node_data_invalid', { rule: rule, node: node, key: key, value: value });
  }
}

function validateMarks(node, rule) {
  if (rule.marks == null) return;

  var marks = node.object === 'text' ? node.marks.toArray() : node.getMarks().toArray();

  var _loop = function _loop(mark) {
    var valid = rule.marks.some(function (def) {
      return typeof def.type === 'function' ? def.type(mark.type) : def.type === mark.type;
    });
    if (valid) return 'continue';
    return {
      v: fail('node_mark_invalid', { rule: rule, node: node, mark: mark })
    };
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = marks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var mark = _step2.value;

      var _ret = _loop(mark);

      switch (_ret) {
        case 'continue':
          continue;

        default:
          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function validateText(node, rule) {
  if (rule.text == null) return;
  var text = node.text;

  var valid = typeof rule.text === 'function' ? rule.text(text) : rule.text.test(text);
  if (valid) return;
  return fail('node_text_invalid', { rule: rule, node: node, text: text });
}

function validateFirst(node, rule) {
  if (rule.first == null) return;
  var first = node.nodes.first();
  if (!first) return;
  var error = validateRules(first, rule.first);
  if (!error) return;
  error.rule = rule;
  error.node = node;
  error.child = first;
  error.code = error.code.replace('node_', 'first_child_');
  return error;
}

function validateLast(node, rule) {
  if (rule.last == null) return;
  var last = node.nodes.last();
  if (!last) return;
  var error = validateRules(last, rule.last);
  if (!error) return;
  error.rule = rule;
  error.node = node;
  error.child = last;
  error.code = error.code.replace('node_', 'last_child_');
  return error;
}

function validateNodes(node, rule) {
  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (node.nodes == null) return;

  var children = node.nodes;
  var defs = rule.nodes != null ? rule.nodes.slice() : [];
  var count = 0;
  var lastCount = 0;
  var min = null;
  var index = -1;
  var def = null;
  var max = null;
  var child = null;
  var previous = null;
  var next = null;

  function nextDef() {
    if (defs.length === 0) return false;
    def = defs.shift();
    lastCount = count;
    count = 0;
    min = def.min || null;
    max = def.max || null;
    return true;
  }

  function nextChild() {
    index += 1;
    previous = index ? children.get(index - 1) : null;
    child = children.get(index);
    next = children.get(index + 1);
    if (!child) return false;
    lastCount = count;
    count += 1;
    return true;
  }

  function rewind() {
    if (index > 0) {
      index -= 1;
      count = lastCount;
    }
  }

  if (rule.nodes != null) {
    nextDef();
  }

  while (nextChild()) {
    var err = validateParent(node, child, rules) || validatePrevious(node, child, previous, index, rules) || validateNext(node, child, next, index, rules);

    if (err) return err;

    if (rule.nodes != null) {
      if (!def) {
        return fail('child_unknown', { rule: rule, node: node, child: child, index: index });
      }

      if (def.match) {
        var error = validateRules(child, def.match);

        if (error) {
          // Since we want to report overflow on last matching child we don't
          // immediately check for count > max, but instead do so once we find
          // a child that doesn't match.
          if (max != null && count - 1 > max) {
            rewind();
            return fail('child_max_invalid', {
              rule: rule,
              node: node,
              index: index,
              child: children.get(index),
              count: count,
              limit: max
            });
          }

          var lastMin = min;

          // If there are more groups after this one then child might actually
          // be valid.
          if (nextDef()) {
            // If we've already satisfied the minimum for the current group,
            // then we can rewind and proceed to the next group.
            if (lastCount - 1 >= lastMin) {
              index -= 1;
              continue;
            }

            // Otherwise we know that current value is underflowing. There are
            // three possible causes for this...

            // 1. There might just not be enough elements for current group, and
            // current child is in fact the first of the next group. If so, the
            // next def will not report errors, in which case we can rewind and
            // report an minimum error.
            if (validateRules(child, def.match) == null) {
              rewind();
              return fail('child_min_invalid', {
                rule: rule,
                node: node,
                index: index,
                count: lastCount - 1,
                limit: lastMin
              });
            }

            // 2. The current group is underflowing, but there is also an
            // invalid child before the next group.
            // 3. Or the current group is not underflowing but it appears so
            // because there's an invalid child between its members.
            // It's either the second or third case. If it's the second then
            // we could report an underflow, but presence of an invalid child
            // is arguably more important, so we report it first. It also lets
            // us avoid checking for which case exactly is it.
            error.rule = rule;
            error.node = node;
            error.child = child;
            error.index = index;
            error.code = error.code.replace('node_', 'child_');
            return error;
          }

          // Otherwise either we exhausted the last group, in which case it's
          // an unknown child, ...
          if (max != null && count > max) {
            return fail('child_unknown', { rule: rule, node: node, child: child, index: index });
          }

          // ... or it's an invalid child for the last group.
          error.rule = rule;
          error.node = node;
          error.child = child;
          error.index = index;
          error.code = error.code.replace('node_', 'child_');
          return error;
        }
      }
    }
  }

  // Since we want to report overflow on last matching child we don't
  // immediately check for count > max, but do so after processing all nodes.
  if (max != null && count > max) {
    return fail('child_max_invalid', {
      rule: rule,
      node: node,
      index: index - 1,
      count: count,
      child: children.get(index - 1),
      limit: max
    });
  }

  if (rule.nodes != null) {
    do {
      if (count < min) {
        return fail('child_min_invalid', {
          rule: rule,
          node: node,
          index: index,
          count: count,
          limit: min
        });
      }
    } while (nextDef());
  }
}

function validateParent(node, child, rules) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = rules[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var rule = _step3.value;

      if (rule.parent == null) continue;
      if (!testRules(child, rule.match)) continue;

      var error = validateRules(node, rule.parent);
      if (!error) continue;

      error.rule = rule;
      error.parent = node;
      error.node = child;
      error.code = error.code.replace('node_', 'parent_');
      return error;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}

function validatePrevious(node, child, previous, index, rules) {
  if (!previous) return;

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = rules[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var rule = _step4.value;

      if (rule.previous == null) continue;
      if (!testRules(child, rule.match)) continue;

      var error = validateRules(previous, rule.previous);
      if (!error) continue;

      error.rule = rule;
      error.node = node;
      error.child = child;
      error.index = index;
      error.previous = previous;
      error.code = error.code.replace('node_', 'previous_sibling_');
      return error;
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}

function validateNext(node, child, next, index, rules) {
  if (!next) return;

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = rules[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var rule = _step5.value;

      if (rule.next == null) continue;
      if (!testRules(child, rule.match)) continue;

      var error = validateRules(next, rule.next, [], { match: child });
      if (!error) continue;

      error.rule = rule;
      error.node = node;
      error.child = child;
      error.index = index;
      error.next = next;
      error.code = error.code.replace('node_', 'next_sibling_');
      return error;
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }
}

/**
 * Create an interim failure object with `code` and `attrs`.
 *
 * @param {String} code
 * @param {Object} attrs
 * @return {Object}
 */

function fail(code, attrs) {
  return _extends({ code: code }, attrs);
}

/**
 * Ensure that an expanded selection is deleted first using the `editor.delete`
 * command. This guarantees that it uses the proper semantic "intent" instead of
 * using `deleteAtRange` under the covers and skipping `delete`.
 *
 * @param {Editor}
 */

function deleteExpanded(editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  }
}

/**
 * Commands.
 *
 * @type {Object}
 */

var Commands$6 = {};

/**
 * Add a `mark` to the characters in the current selection.
 *
 * @param {Editor} editor
 * @param {Mark} mark
 */

Commands$6.addMark = function (editor, mark) {
  mark = Mark.create(mark);
  var value = editor.value;
  var document = value.document,
      selection = value.selection;


  if (selection.isExpanded) {
    editor.addMarkAtRange(selection, mark);
  } else if (selection.marks) {
    var marks = selection.marks.add(mark);
    var sel = selection.set('marks', marks);
    editor.select(sel);
  } else {
    var _marks = document.getActiveMarksAtRange(selection).add(mark);
    var _sel = selection.set('marks', _marks);
    editor.select(_sel);
  }
};

/**
 * Add a list of `marks` to the characters in the current selection.
 *
 * @param {Editor} editor
 * @param {Set<Mark>|Array<Object>} marks
 */

Commands$6.addMarks = function (editor, marks) {
  marks.forEach(function (mark) {
    return editor.addMark(mark);
  });
};

/**
 * Delete at the current selection.
 *
 * @param {Editor} editor
 */

Commands$6.delete = function (editor) {
  var value = editor.value;
  var selection = value.selection;

  editor.deleteAtRange(selection);

  // COMPAT: Ensure that the selection is collapsed, because in certain cases
  // when deleting across inline nodes, when splitting the inline node the end
  // point of the selection will end up after the split point.
  editor.moveToFocus();
};

/**
 * Delete backward `n` characters.
 *
 * @param {Editor} editor
 * @param {Number} n (optional)
 */

Commands$6.deleteBackward = function (editor) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteBackwardAtRange(selection, n);
  }
};

/**
 * Delete backward one character.
 *
 * @param {Editor} editor
 */

Commands$6.deleteCharBackward = function (editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteCharBackwardAtRange(selection);
  }
};

/**
 * Delete backward one line.
 *
 * @param {Editor} editor
 */

Commands$6.deleteLineBackward = function (editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteLineBackwardAtRange(selection);
  }
};

/**
 * Delete backward one word.
 *
 * @param {Editor} editor
 */

Commands$6.deleteWordBackward = function (editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteWordBackwardAtRange(selection);
  }
};

/**
 * Delete backward `n` characters.
 *
 * @param {Editor} editor
 * @param {Number} n (optional)
 */

Commands$6.deleteForward = function (editor) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteForwardAtRange(selection, n);
  }
};

/**
 * Delete backward one character.
 *
 * @param {Editor} editor
 */

Commands$6.deleteCharForward = function (editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteCharForwardAtRange(selection);
  }
};

/**
 * Delete backward one line.
 *
 * @param {Editor} editor
 */

Commands$6.deleteLineForward = function (editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteLineForwardAtRange(selection);
  }
};

/**
 * Delete backward one word.
 *
 * @param {Editor} editor
 */

Commands$6.deleteWordForward = function (editor) {
  var value = editor.value;
  var selection = value.selection;


  if (selection.isExpanded) {
    editor.delete();
  } else {
    editor.deleteWordForwardAtRange(selection);
  }
};

/**
 * Insert a `block` at the current selection.
 *
 * @param {Editor} editor
 * @param {String|Object|Block} block
 */

Commands$6.insertBlock = function (editor, block) {
  deleteExpanded(editor);

  block = Block.create(block);
  var value = editor.value;
  var selection = value.selection;

  editor.insertBlockAtRange(selection, block);

  // If the node was successfully inserted, update the selection.
  var node = editor.value.document.getNode(block.key);
  if (node) editor.moveToEndOfNode(node);
};

/**
 * Insert a `fragment` at the current selection.
 *
 * @param {Editor} editor
 * @param {Document} fragment
 */

Commands$6.insertFragment = function (editor, fragment) {
  if (!fragment.nodes.size) return;

  deleteExpanded(editor);

  var value = editor.value;
  var _value = value,
      document = _value.document,
      selection = _value.selection;
  var start = selection.start;

  var keys = Array.from(document.texts(), function (_ref) {
    var _ref2 = slicedToArray(_ref, 1),
        text = _ref2[0];

    return text.key;
  });

  editor.insertFragmentAtRange(selection, fragment);
  value = editor.value;
  document = value.document;

  var newTexts = document.getTexts().filter(function (n) {
    return !keys.includes(n.key);
  });
  if (newTexts.size === 0) return;
  var fragmentLength = fragment.text.length;

  // Either startText is still here, or we want the first un-previously known text
  var startText = document.getNode(start.key) || newTexts.first();
  // We want the last un-previously known text
  var endText = newTexts.last() || startText;

  if (startText === endText) {
    editor.moveTo(endText.key, fragmentLength);
    return;
  }

  // Everything will be calculated relative to the first common ancestor to optimize speed
  var parent = document.getCommonAncestor(startText.key, endText.key);

  var startOffset = parent.getOffset(startText.key) + (start.key === startText.key ? start.offset : 0);

  // endText might not be the last un-previously known text node, so we precisely pick it by offset
  endText = parent.getTextAtOffset(startOffset + fragmentLength - 1) || endText;

  editor.moveTo(endText.key, startOffset + fragmentLength - parent.getOffset(endText.key));
};

/**
 * Insert an `inline` at the current selection.
 *
 * @param {Editor} editor
 * @param {String|Object|Inline} inline
 */

Commands$6.insertInline = function (editor, inline) {
  deleteExpanded(editor);

  inline = Inline.create(inline);
  var value = editor.value;
  var selection = value.selection;

  editor.insertInlineAtRange(selection, inline);

  // If the node was successfully inserted, update the selection.
  var node = editor.value.document.getNode(inline.key);
  if (node) editor.moveToEndOfNode(node);
};

/**
 * Insert a string of `text` with optional `marks` at the current selection.
 *
 * @param {Editor} editor
 * @param {String} text
 * @param {Set<Mark>} marks (optional)
 */

Commands$6.insertText = function (editor, text, marks) {
  deleteExpanded(editor);

  var value = editor.value;
  var document = value.document,
      selection = value.selection;

  marks = marks || selection.marks || document.getInsertMarksAtRange(selection);

  editor.withoutNormalizing(function () {
    editor.insertTextAtRange(selection, text, marks);

    // If the text was successfully inserted, and the selection had marks on it,
    // unset the selection's marks.
    if (selection.marks && document !== editor.value.document) {
      editor.select({ marks: null });
    }
  });
};

/**
 * Remove a `mark` from the characters in the current selection.
 *
 * @param {Editor} editor
 * @param {Mark} mark
 */

Commands$6.removeMark = function (editor, mark) {
  mark = Mark.create(mark);
  var value = editor.value;
  var document = value.document,
      selection = value.selection;


  if (selection.isExpanded) {
    editor.removeMarkAtRange(selection, mark);
  } else if (selection.marks) {
    var marks = selection.marks.remove(mark);
    var sel = selection.set('marks', marks);
    editor.select(sel);
  } else {
    var _marks2 = document.getActiveMarksAtRange(selection).remove(mark);
    var _sel2 = selection.set('marks', _marks2);
    editor.select(_sel2);
  }
};

/**
 * Replace an `oldMark` with a `newMark` in the characters in the current selection.
 *
 * @param {Editor} editor
 * @param {Mark} oldMark
 * @param {Mark} newMark
 */

Commands$6.replaceMark = function (editor, oldMark, newMark) {
  editor.removeMark(oldMark);
  editor.addMark(newMark);
};

/**
 * Set the `properties` of block nodes.
 *
 * @param {Editor} editor
 * @param {Object|String} properties
 */

Commands$6.setBlocks = function (editor, properties) {
  var value = editor.value;
  var selection = value.selection;

  editor.setBlocksAtRange(selection, properties);
};

/**
 * Set the `properties` of inline nodes.
 *
 * @param {Editor} editor
 * @param {Object|String} properties
 */

Commands$6.setInlines = function (editor, properties) {
  var value = editor.value;
  var selection = value.selection;

  editor.setInlinesAtRange(selection, properties);
};

/**
 * Split the block node at the current selection, to optional `depth`.
 *
 * @param {Editor} editor
 * @param {Number} depth (optional)
 */

Commands$6.splitBlock = function (editor) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  deleteExpanded(editor);

  var value = editor.value;
  var selection = value.selection,
      document = value.document;

  var marks = selection.marks || document.getInsertMarksAtRange(selection);
  editor.splitBlockAtRange(selection, depth).moveToEnd();

  if (marks && marks.size !== 0) {
    editor.select({ marks: marks });
  }
};

/**
 * Split the inline nodes to optional `height`.
 *
 * @param {Editor} editor
 * @param {Number} height (optional)
 */

Commands$6.splitInline = function (editor, height) {
  deleteExpanded(editor);
  var value = editor.value;
  var selection = value.selection;

  editor.splitInlineAtRange(selection, height);
};

/**
 * Add or remove a `mark` from the characters in the current selection,
 * depending on whether it's already there.
 *
 * @param {Editor} editor
 * @param {Mark} mark
 */

Commands$6.toggleMark = function (editor, mark) {
  mark = Mark.create(mark);
  var value = editor.value;

  var exists = value.activeMarks.has(mark);

  if (exists) {
    editor.removeMark(mark);
  } else {
    editor.addMark(mark);
  }
};

/**
 * Unwrap nodes from a block with `properties`.
 *
 * @param {Editor} editor
 * @param {String|Object} properties
 */

Commands$6.unwrapBlock = function (editor, properties) {
  var value = editor.value;
  var selection = value.selection;

  editor.unwrapBlockAtRange(selection, properties);
};

/**
 * Unwrap nodes from an inline with `properties`.
 *
 * @param {Editor} editor
 * @param {String|Object} properties
 */

Commands$6.unwrapInline = function (editor, properties) {
  var value = editor.value;
  var selection = value.selection;

  editor.unwrapInlineAtRange(selection, properties);
};

/**
 * Wrap nodes in a new `block`.
 *
 * @param {Editor} editor
 * @param {Block|Object|String} block
 */

Commands$6.wrapBlock = function (editor, block) {
  var value = editor.value;
  var selection = value.selection;

  editor.wrapBlockAtRange(selection, block);
};

/**
 * Wrap nodes in a new `inline`.
 *
 * @param {Editor} editor
 * @param {Inline|Object|String} inline
 */

Commands$6.wrapInline = function (editor, inline) {
  var value = editor.value;
  var selection = value.selection;

  editor.wrapInlineAtRange(selection, inline);
};

/**
 * Wrap the current selection with prefix/suffix.
 *
 * @param {Editor} editor
 * @param {String} prefix
 * @param {String} suffix
 */

Commands$6.wrapText = function (editor, prefix) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : prefix;
  var value = editor.value;
  var selection = value.selection;

  editor.wrapTextAtRange(selection, prefix, suffix);

  // If the selection was collapsed, it will have moved the start offset too.
  if (selection.isCollapsed) {
    editor.moveStartBackward(prefix.length);
  }

  // Adding the suffix will have pushed the end of the selection further on, so
  // we need to move it back to account for this.
  editor.moveEndBackward(suffix.length);

  // There's a chance that the selection points moved "through" each other,
  // resulting in a now-incorrect selection direction.
  if (selection.isForward !== editor.value.selection.isForward) {
    editor.flip();
  }
};

/**
 * A plugin that defines the core Slate logic.
 *
 * @param {Object} options
 * @return {Object}
 */

function CorePlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$plugins = options.plugins,
      plugins = _options$plugins === undefined ? [] : _options$plugins;

  /**
   * The core Slate commands.
   *
   * @type {Object}
   */

  var commands = CommandsPlugin(_extends({}, Commands$1, Commands$2, Commands$3, Commands$4, Commands$5, Commands$6));

  /**
   * The core Slate queries.
   *
   * @type {Object}
   */

  var queries = QueriesPlugin({
    isAtomic: function isAtomic() {
      return false;
    },
    isVoid: function isVoid() {
      return false;
    }
  });

  /**
   * The core Slate schema.
   *
   * @type {Object}
   */

  var schema = SchemaPlugin({
    rules: [
    // Only allow block nodes in documents.
    {
      match: { object: 'document' },
      nodes: [{
        match: { object: 'block' }
      }]
    },

    // Only allow block nodes or inline and text nodes in blocks.
    {
      match: {
        object: 'block',
        first: { object: 'block' }
      },
      nodes: [{
        match: { object: 'block' }
      }]
    }, {
      match: {
        object: 'block',
        first: [{ object: 'inline' }, { object: 'text' }]
      },
      nodes: [{
        match: [{ object: 'inline' }, { object: 'text' }]
      }]
    },

    // Only allow inline and text nodes in inlines.
    {
      match: { object: 'inline' },
      nodes: [{ match: [{ object: 'inline' }, { object: 'text' }] }]
    },

    // Ensure that block and inline nodes have at least one text child.
    {
      match: [{ object: 'block' }, { object: 'inline' }],
      nodes: [{ min: 1 }],
      normalize: function normalize(editor, error) {
        var code = error.code,
            node = error.node;


        if (code === 'child_min_invalid' && node.nodes.isEmpty()) {
          editor.insertNodeByKey(node.key, 0, Text.create());
        }
      }
    },

    // Ensure that inline nodes are surrounded by text nodes.
    {
      match: { object: 'block' },
      first: [{ object: 'block' }, { object: 'text' }],
      last: [{ object: 'block' }, { object: 'text' }],
      normalize: function normalize(editor, error) {
        var code = error.code,
            node = error.node;

        var text = Text.create();
        var i = void 0;

        if (code === 'first_child_object_invalid') {
          i = 0;
        } else if (code === 'last_child_object_invalid') {
          i = node.nodes.size;
        } else {
          return;
        }

        editor.insertNodeByKey(node.key, i, text);
      }
    }, {
      match: { object: 'inline' },
      first: [{ object: 'block' }, { object: 'text' }],
      last: [{ object: 'block' }, { object: 'text' }],
      previous: [{ object: 'block' }, { object: 'text' }],
      next: [{ object: 'block' }, { object: 'text' }],
      normalize: function normalize(editor, error) {
        var code = error.code,
            node = error.node,
            index = error.index;

        var text = Text.create();
        var i = void 0;

        if (code === 'first_child_object_invalid') {
          i = 0;
        } else if (code === 'last_child_object_invalid') {
          i = node.nodes.size;
        } else if (code === 'previous_sibling_object_invalid') {
          i = index;
        } else if (code === 'next_sibling_object_invalid') {
          i = index + 1;
        } else {
          return;
        }

        editor.insertNodeByKey(node.key, i, text);
      }
    },

    // Merge adjacent text nodes with the same marks.
    {
      match: { object: 'text' },
      next: function next(_next, match) {
        return _next.object !== 'text' || !match.marks.equals(_next.marks);
      },
      normalize: function normalize(editor, error) {
        var code = error.code,
            next = error.next;


        if (code === 'next_sibling_invalid') {
          editor.mergeNodeByKey(next.key);
        }
      }
    },

    // Remove extra adjacent empty text nodes.
    {
      match: { object: 'text' },
      previous: function previous(prev) {
        return prev.object !== 'text' || prev.text !== '';
      },
      next: function next(_next2) {
        return _next2.object !== 'text' || _next2.text !== '';
      },
      normalize: function normalize(editor, error) {
        var code = error.code,
            next = error.next,
            previous = error.previous;


        if (code === 'next_sibling_invalid') {
          editor.removeNodeByKey(next.key);
        } else if (code === 'previous_sibling_invalid') {
          editor.removeNodeByKey(previous.key);
        }
      }
    }]
  });

  /**
   * Return the plugins.
   *
   * @type {Array}
   */

  return [schema].concat(toConsumableArray(plugins), [commands, queries]);
}

/**
 * Debug.
 *
 * @type {Function}
 */

var debug$2 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:editor');

/**
 * Editor.
 *
 * @type {Editor}
 */

var Editor = function () {
  /**
   * Create a new `Editor` with `attrs`.
   *
   * @param {Object} attrs
   * @param {Object} options
   */

  function Editor() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, Editor);
    var _options$controller = options.controller,
        controller = _options$controller === undefined ? this : _options$controller,
        _options$construct = options.construct,
        construct = _options$construct === undefined ? true : _options$construct;
    var _attrs$onChange = attrs.onChange,
        onChange = _attrs$onChange === undefined ? function () {} : _attrs$onChange,
        _attrs$plugins = attrs.plugins,
        plugins = _attrs$plugins === undefined ? [] : _attrs$plugins,
        _attrs$readOnly = attrs.readOnly,
        readOnly = _attrs$readOnly === undefined ? false : _attrs$readOnly,
        _attrs$value = attrs.value,
        value = _attrs$value === undefined ? Value.create() : _attrs$value;


    this.controller = controller;
    this.middleware = {};
    this.onChange = onChange;
    this.operations = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
    this.readOnly = null;
    this.value = null;

    this.tmp = {
      dirty: [],
      flushing: false,
      merge: null,
      normalize: true,
      save: true
    };

    var core = CorePlugin({ plugins: plugins });
    registerPlugin(this, core);

    if (construct) {
      this.run('onConstruct');
      this.setReadOnly(readOnly);
      this.setValue(value, options);
    }
  }

  /**
   * Apply an `operation` to the editor, updating its value.
   *
   * @param {Operation|Object} operation
   * @return {Editor}
   */

  createClass(Editor, [{
    key: 'applyOperation',
    value: function applyOperation(operation) {
      var _this = this;

      var operations = this.operations,
          controller = this.controller;

      var value = this.value;

      // Add in the current `value` in case the operation was serialized.
      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(operation)) {
        operation = _extends({}, operation, { value: value });
      }

      operation = Operation.create(operation);

      // Save the operation into the history. Since `save` is a command, we need
      // to do it without normalizing, since it would have side effects.
      this.withoutNormalizing(function () {
        controller.save(operation);
        value = _this.value;
      });

      // Apply the operation to the value.
      debug$2('apply', { operation: operation });
      this.value = operation.apply(value);
      this.operations = operations.push(operation);

      // Get the paths of the affected nodes, and mark them as dirty.
      var newDirtyPaths = getDirtyPaths(operation);

      var dirty = this.tmp.dirty.map(function (path) {
        path = PathUtils.create(path);
        var transformed = PathUtils.transform(path, operation);
        return transformed.toArray();
      });

      var pathIndex = {};
      var dirtyPaths = Array.prototype.concat.apply(newDirtyPaths, dirty);
      this.tmp.dirty = [];

      // PERF: De-dupe the paths so we don't do extra normalization.
      dirtyPaths.forEach(function (dirtyPath) {
        var key = dirtyPath.join(',');

        if (!pathIndex[key]) {
          _this.tmp.dirty.push(dirtyPath);
        }

        pathIndex[key] = true;
      });

      // If we're not already, queue the flushing process on the next tick.
      if (!this.tmp.flushing) {
        this.tmp.flushing = true;
        Promise.resolve().then(function () {
          return _this.flush();
        });
      }

      return controller;
    }

    /**
     * Flush the editor's current change.
     *
     * @return {Editor}
     */

  }, {
    key: 'flush',
    value: function flush() {
      this.run('onChange');
      var value = this.value,
          operations = this.operations,
          controller = this.controller;

      var change = { value: value, operations: operations };
      this.operations = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
      this.tmp.flushing = false;
      this.onChange(change);
      return controller;
    }

    /**
     * Trigger a command by `type` with `...args`.
     *
     * @param {String|Function} type
     * @param {Any} ...args
     * @return {Editor}
     */

  }, {
    key: 'command',
    value: function command(type) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var controller = this.controller;


      if (typeof type === 'function') {
        type.apply(undefined, [controller].concat(args));
        normalizeDirtyPaths(this);
        return controller;
      }

      debug$2('command', { type: type, args: args });
      var obj = { type: type, args: args };
      this.run('onCommand', obj);
      normalizeDirtyPaths(this);
      return controller;
    }

    /**
     * Checks if a command by `type` has been registered.
     *
     * @param {String} type
     * @return {Boolean}
     */

  }, {
    key: 'hasCommand',
    value: function hasCommand(type) {
      var controller = this.controller;

      var has = type in controller && controller[type].__command;

      return has;
    }

    /**
     * Checks if a query by `type` has been registered.
     *
     * @param {String} type
     * @return {Boolean}
     */

  }, {
    key: 'hasQuery',
    value: function hasQuery(type) {
      var controller = this.controller;

      var has = type in controller && controller[type].__query;

      return has;
    }

    /**
     * Normalize all of the nodes in the document from scratch.
     *
     * @return {Editor}
     */

  }, {
    key: 'normalize',
    value: function normalize() {
      var value = this.value,
          controller = this.controller;
      var document = value.document;

      var table = document.getKeysToPathsTable();
      var paths = Object.values(table).map(PathUtils.create);
      this.tmp.dirty = this.tmp.dirty.concat(paths);
      normalizeDirtyPaths(this);

      var selection = value.selection;

      document = value.document;

      if (selection.isUnset && document.nodes.size) {
        controller.moveToStartOfDocument();
      }

      return controller;
    }

    /**
     * Ask a query by `type` with `...args`.
     *
     * @param {String|Function} type
     * @param {Any} ...args
     * @return {Any}
     */

  }, {
    key: 'query',
    value: function query(type) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var controller = this.controller;


      if (typeof type === 'function') {
        return type.apply(undefined, [controller].concat(args));
      }

      debug$2('query', { type: type, args: args });
      var obj = { type: type, args: args };
      return this.run('onQuery', obj);
    }

    /**
     * Register a command `type` with the editor.
     *
     * @param {String} type
     * @return {Editor}
     */

  }, {
    key: 'registerCommand',
    value: function registerCommand(type) {
      var _this2 = this;

      var controller = this.controller;


      if (type in controller && controller[type].__command) {
        return controller;
      }

      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(!(type in controller), 'You cannot register a `' + type + '` command because it would overwrite an existing property of the `Editor`.');

      var method = function method() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return _this2.command.apply(_this2, [type].concat(args));
      };
      controller[type] = method;
      method.__command = true;
      return controller;
    }

    /**
     * Register a query `type` with the editor.
     *
     * @param {String} type
     * @return {Editor}
     */

  }, {
    key: 'registerQuery',
    value: function registerQuery(type) {
      var _this3 = this;

      var controller = this.controller;


      if (type in controller && controller[type].__query) {
        return controller;
      }

      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(!(type in controller), 'You cannot register a `' + type + '` query because it would overwrite an existing property of the `Editor`.');

      var method = function method() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return _this3.query.apply(_this3, [type].concat(args));
      };
      controller[type] = method;
      method.__query = true;
      return controller;
    }

    /**
     * Run through the middleware stack by `key` with `args`.
     *
     * @param {String} key
     * @param {Any} ...args
     * @return {Any}
     */

  }, {
    key: 'run',
    value: function run(key) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      var controller = this.controller,
          middleware = this.middleware;

      var fns = middleware[key] || [];
      var i = 0;

      function next() {
        var fn = fns[i++];
        if (!fn) return;

        for (var _len6 = arguments.length, overrides = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          overrides[_key6] = arguments[_key6];
        }

        if (overrides.length) {
          args = overrides;
        }

        var ret = fn.apply(undefined, toConsumableArray(args).concat([controller, next]));
        return ret;
      }

      Object.defineProperty(next, 'change', {
        get: function get$$1() {
          Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor` is no longer passed as the third argument to event handlers. You can access it via `change.editor` instead.');
        }
      });

      Object.defineProperty(next, 'onChange', {
        get: function get$$1() {
          Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor` is no longer passed as the third argument to event handlers. You can access it via `change.editor` instead.');
        }
      });

      Object.defineProperty(next, 'props', {
        get: function get$$1() {
          Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor` is no longer passed as the third argument to event handlers. You can access it via `change.editor` instead.');
        }
      });

      Object.defineProperty(next, 'schema', {
        get: function get$$1() {
          Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor` is no longer passed as the third argument to event handlers. You can access it via `change.editor` instead.');
        }
      });

      Object.defineProperty(next, 'stack', {
        get: function get$$1() {
          Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor` is no longer passed as the third argument to event handlers. You can access it via `change.editor` instead.');
        }
      });

      return next();
    }

    /**
     * Set the `readOnly` flag.
     *
     * @param {Boolean} readOnly
     * @return {Editor}
     */

  }, {
    key: 'setReadOnly',
    value: function setReadOnly(readOnly) {
      this.readOnly = readOnly;
      return this;
    }

    /**
     * Set the editor's `value`.
     *
     * @param {Value} value
     * @param {Options} options
     * @return {Editor}
     */

  }, {
    key: 'setValue',
    value: function setValue(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$normalize = options.normalize,
          normalize = _options$normalize === undefined ? value !== this.value : _options$normalize;

      this.value = value;

      if (normalize) {
        this.normalize();
      }

      return this;
    }

    /**
     * Apply a series of changes inside a synchronous `fn`, deferring
     * normalization until after the function has finished executing.
     *
     * @param {Function} fn
     * @return {Editor}
     */

  }, {
    key: 'withoutNormalizing',
    value: function withoutNormalizing(fn) {
      var controller = this.controller;

      var value = this.tmp.normalize;
      this.tmp.normalize = false;
      fn(controller);
      this.tmp.normalize = value;
      normalizeDirtyPaths(this);
      return controller;
    }

    /**
     * Deprecated.
     */

  }, {
    key: 'change',
    value: function change(fn) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of Slate 0.43 the `change` object has been replaced with `editor`, so the `editor.change()` method is deprecated.`');

      for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      fn.apply(undefined, [this.controller].concat(args));
    }
  }, {
    key: 'call',
    value: function call(fn) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of Slate 0.43 the `editor.call(fn)` method has been deprecated, please use `editor.command(fn)` instead.');

      for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      fn.apply(undefined, [this.controller].concat(args));
      return this.controller;
    }
  }, {
    key: 'applyOperations',
    value: function applyOperations(operations) {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of Slate 0.43 the `applyOperations` method is deprecated, please apply each operation in a loop instead.');

      operations.forEach(function (op) {
        return _this4.applyOperation(op);
      });
      return this.controller;
    }
  }, {
    key: 'setOperationFlag',
    value: function setOperationFlag(key, value) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.41 the `change.setOperationFlag` method has been deprecated.');

      this.tmp[key] = value;
      return this;
    }
  }, {
    key: 'getFlag',
    value: function getFlag(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.41 the `change.getFlag` method has been deprecated.');

      return options[key] !== undefined ? options[key] : this.tmp[key];
    }
  }, {
    key: 'unsetOperationFlag',
    value: function unsetOperationFlag(key) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.41 the `change.unsetOperationFlag` method has been deprecated.');

      delete this.tmp[key];
      return this;
    }
  }, {
    key: 'withoutNormalization',
    value: function withoutNormalization(fn) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.41 the `change.withoutNormalization` helper has been renamed to `change.withoutNormalizing`.');

      return this.withoutNormalizing(fn);
    }
  }, {
    key: 'editor',
    get: function get$$1() {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "As of Slate 0.43 the `change` object has been replaced with `editor`, so you don't need to access `change.editor`.");

      return this.controller;
    }
  }]);
  return Editor;
}();

/**
 * Get the "dirty" paths for a given `operation`.
 *
 * @param {Operation} operation
 * @return {Array}
 */

function getDirtyPaths(operation) {
  var type = operation.type,
      node = operation.node,
      path = operation.path,
      newPath = operation.newPath;


  switch (type) {
    case 'add_mark':
    case 'insert_text':
    case 'remove_mark':
    case 'remove_text':
    case 'set_mark':
    case 'set_node':
      {
        var ancestors = PathUtils.getAncestors(path).toArray();
        return [].concat(toConsumableArray(ancestors), [path]);
      }

    case 'insert_node':
      {
        var table = node.getKeysToPathsTable();
        var paths = Object.values(table).map(function (p) {
          return path.concat(p);
        });
        var _ancestors = PathUtils.getAncestors(path).toArray();
        return [].concat(toConsumableArray(_ancestors), [path], toConsumableArray(paths));
      }

    case 'split_node':
      {
        var _ancestors2 = PathUtils.getAncestors(path).toArray();
        var nextPath = PathUtils.increment(path);
        return [].concat(toConsumableArray(_ancestors2), [path, nextPath]);
      }

    case 'merge_node':
      {
        var _ancestors3 = PathUtils.getAncestors(path).toArray();
        var previousPath = PathUtils.decrement(path);
        return [].concat(toConsumableArray(_ancestors3), [previousPath]);
      }

    case 'move_node':
      {
        if (PathUtils.isEqual(path, newPath)) {
          return [];
        }

        var oldAncestors = PathUtils.getAncestors(path).reduce(function (arr, p) {
          arr.push.apply(arr, toConsumableArray(PathUtils.transform(p, operation).toArray()));
          return arr;
        }, []);

        var newAncestors = PathUtils.getAncestors(newPath).reduce(function (arr, p) {
          arr.push.apply(arr, toConsumableArray(PathUtils.transform(p, operation).toArray()));
          return arr;
        }, []);

        return [].concat(toConsumableArray(oldAncestors), toConsumableArray(newAncestors));
      }

    case 'remove_node':
      {
        var _ancestors4 = PathUtils.getAncestors(path).toArray();
        return [].concat(toConsumableArray(_ancestors4));
      }

    default:
      {
        return [];
      }
  }
}

/**
 * Normalize any new "dirty" paths that have been added to the change.
 *
 * @param {Editor}
 */

function normalizeDirtyPaths(editor) {
  if (!editor.tmp.normalize) {
    return;
  }

  if (!editor.tmp.dirty.length) {
    return;
  }

  editor.withoutNormalizing(function () {
    while (editor.tmp.dirty.length) {
      var path = editor.tmp.dirty.pop();
      normalizeNodeByPath(editor, path);
    }
  });
}

/**
 * Normalize the node at a specific `path`.
 *
 * @param {Editor} editor
 * @param {Array} path
 */

function normalizeNodeByPath(editor, path) {
  var controller = editor.controller;
  var value = editor.value;
  var _value = value,
      document = _value.document;

  var node = document.assertNode(path);
  var iterations = 0;
  var max = 100 + (node.object === 'text' ? 1 : node.nodes.size);

  while (node) {
    var fn = node.normalize(controller);

    if (!fn) {
      break;
    }

    // Run the normalize `fn` to fix the node.
    fn(controller);

    // Attempt to re-find the node by path, or by key if it has changed
    // locations in the tree continue iterating.
    value = editor.value;
    document = value.document;
    var _node = node,
        key = _node.key;

    var found = document.getDescendant(path);

    if (found && found.key === key) {
      node = found;
    } else {
      found = document.getDescendant(key);

      if (found) {
        node = found;
        path = document.getPath(key);
      } else {
        // If it no longer exists by key, it was removed, so we're done.
        break;
      }
    }

    // Increment the iterations counter, and check to make sure that we haven't
    // exceeded the max. Without this check, it's easy for the `normalize`
    // function of a schema rule to be written incorrectly and for an infinite
    // invalid loop to occur.
    iterations++;

    if (iterations > max) {
      throw new Error('A schema rule could not be normalized after sufficient iterations. This is usually due to a `rule.normalize` or `plugin.normalizeNode` function of a schema being incorrectly written, causing an infinite loop.');
    }
  }
}

/**
 * Register a `plugin` with the editor.
 *
 * @param {Editor} editor
 * @param {Object|Array|Null} plugin
 */

function registerPlugin(editor, plugin) {
  if (Array.isArray(plugin)) {
    plugin.forEach(function (p) {
      return registerPlugin(editor, p);
    });
    return;
  }

  if (plugin == null) {
    return;
  }

  var commands = plugin.commands,
      queries = plugin.queries,
      schema = plugin.schema,
      rest = objectWithoutProperties(plugin, ['commands', 'queries', 'schema']);


  if (commands) {
    var commandsPlugin = CommandsPlugin(commands);
    registerPlugin(editor, commandsPlugin);
  }

  if (queries) {
    var queriesPlugin = QueriesPlugin(queries);
    registerPlugin(editor, queriesPlugin);
  }

  if (schema) {
    var schemaPlugin = SchemaPlugin(schema);
    registerPlugin(editor, schemaPlugin);
  }

  for (var key in rest) {
    var fn = rest[key];
    var middleware = editor.middleware[key] = editor.middleware[key] || [];
    middleware.push(fn);
  }
}

/**
 * Default properties.
 *
 * @type {Object}
 */

var DEFAULTS$13 = {
  marks: undefined,
  text: undefined

  /**
   * Leaf.
   *
   * @type {Leaf}
   */

};
var Leaf$1 = function (_Record) {
  inherits(Leaf, _Record);

  function Leaf() {
    classCallCheck(this, Leaf);
    return possibleConstructorReturn(this, (Leaf.__proto__ || Object.getPrototypeOf(Leaf)).apply(this, arguments));
  }

  createClass(Leaf, [{
    key: 'updateMark',


    /**
     * Update a `mark` at leaf, replace with newMark
     *
     * @param {Mark} mark
     * @param {Mark} newMark
     * @returns {Leaf}
     */

    value: function updateMark(mark, newMark) {
      var marks = this.marks;

      if (newMark.equals(mark)) return this;
      if (!marks.has(mark)) return this;
      var newMarks = marks.withMutations(function (collection) {
        collection.remove(mark).add(newMark);
      });
      return this.set('marks', newMarks);
    }

    /**
     * Add a `mark` to the leaf.
     *
     * @param {Mark} mark
     * @returns {Text}
     */

  }, {
    key: 'addMark',
    value: function addMark(mark) {
      var marks = this.marks;

      return this.set('marks', marks.add(mark));
    }

    /**
     * Add a `set` of marks to the leaf.
     *
     * @param {Set<Mark>} set
     * @returns {Text}
     */

  }, {
    key: 'addMarks',
    value: function addMarks(set$$1) {
      var marks = this.marks;

      return this.set('marks', marks.union(set$$1));
    }

    /**
     * Insert a text `string` into the leaf at `offset`.
     *
     * @param {Number} offset
     * @param {String} string
     * @return {Leaf}
     */

  }, {
    key: 'insertText',
    value: function insertText(offset, string) {
      var text = this.text;

      var next = text.slice(0, offset) + string + text.slice(offset);
      return this.set('text', next);
    }

    /**
     * Remove a `mark` from the leaf.
     *
     * @param {Mark} mark
     * @returns {Text}
     */

  }, {
    key: 'removeMark',
    value: function removeMark(mark) {
      var marks = this.marks;

      return this.set('marks', marks.remove(mark));
    }

    /**
     * Return a JSON representation of the leaf.
     *
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var object = {
        object: this.object,
        text: this.text,
        marks: this.marks.toArray().map(function (m) {
          return m.toJSON();
        })
      };

      return object;
    }
  }], [{
    key: 'create',

    /**
     * Create a new `Leaf` with `attrs`.
     *
     * @param {Object|Leaf} attrs
     * @return {Leaf}
     */

    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47 the `Leaf` model is deprecated.');

      if (Leaf.isLeaf(attrs)) {
        return attrs;
      }

      if (typeof attrs === 'string') {
        attrs = { text: attrs };
      }

      if (__WEBPACK_IMPORTED_MODULE_1_is_plain_object___default()(attrs)) {
        return Leaf.fromJSON(attrs);
      }

      throw new Error('`Leaf.create` only accepts objects, strings or leaves, but you passed it: ' + attrs);
    }

    /**
     * Create a valid List of `Leaf` from `leaves`
     *
     * @param {List<Leaf>} leaves
     * @return {List<Leaf>}
     */

  }, {
    key: 'createLeaves',
    value: function createLeaves(leaves) {
      if (leaves.size <= 1) return leaves;

      var invalid = false;

      // TODO: we can make this faster with [List] and then flatten
      var result = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])().withMutations(function (cache) {
        // Search from the leaves left end to find invalid node;
        leaves.findLast(function (leaf, index) {
          var firstLeaf = cache.first();

          // If the first leaf of cache exist, check whether the first leaf is connectable with the current leaf
          if (firstLeaf) {
            // If marks equals, then the two leaves can be connected
            if (firstLeaf.marks.equals(leaf.marks)) {
              invalid = true;
              cache.set(0, firstLeaf.set('text', '' + leaf.text + firstLeaf.text));
              return;
            }

            // If the cached leaf is empty, drop the empty leaf with the upcoming leaf
            if (firstLeaf.text === '') {
              invalid = true;
              cache.set(0, leaf);
              return;
            }

            // If the current leaf is empty, drop the leaf
            if (leaf.text === '') {
              invalid = true;
              return;
            }
          }

          cache.unshift(leaf);
        });
      });

      if (!invalid) return leaves;
      return result;
    }

    /**
     * Split a list of leaves to two lists; if the leaves are valid leaves, the returned leaves are also valid
     * Corner Cases:
     *   1. if offset is smaller than 0, then return [List(), leaves]
     *   2. if offset is bigger than the text length, then return [leaves, List()]
     *
     * @param {List<Leaf> leaves
     * @return {Array<List<Leaf>>}
     */

  }, {
    key: 'splitLeaves',
    value: function splitLeaves(leaves, offset) {
      if (offset < 0) return [Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(), leaves];

      if (leaves.size === 0) {
        return [Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()];
      }

      var endOffset = 0;
      var index = -1;
      var left = void 0,
          right = void 0;

      leaves.find(function (leaf) {
        index++;
        var startOffset = endOffset;
        var text = leaf.text;

        endOffset += text.length;

        if (endOffset < offset) return false;
        if (startOffset > offset) return false;

        var length = offset - startOffset;
        left = leaf.set('text', text.slice(0, length));
        right = leaf.set('text', text.slice(length));
        return true;
      });

      if (!left) return [leaves, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()];

      if (left.text === '') {
        if (index === 0) {
          return [__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(left), leaves];
        }

        return [leaves.take(index), leaves.skip(index)];
      }

      if (right.text === '') {
        if (index === leaves.size - 1) {
          return [leaves, __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(right)];
        }

        return [leaves.take(index + 1), leaves.skip(index + 1)];
      }

      return [leaves.take(index).push(left), leaves.skip(index + 1).unshift(right)];
    }

    /**
     * Create a `Leaf` list from `attrs`.
     *
     * @param {Array<Leaf|Object>|List<Leaf|Object>} attrs
     * @return {List<Leaf>}
     */

  }, {
    key: 'createList',
    value: function createList() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(attrs) || Array.isArray(attrs)) {
        var list = new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](attrs.map(Leaf.create));
        return list;
      }

      throw new Error('`Leaf.createList` only accepts arrays or lists, but you passed it: ' + attrs);
    }

    /**
     * Create a `Leaf` from a JSON `object`.
     *
     * @param {Object} object
     * @return {Leaf}
     */

  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var _object$text = object.text,
          text = _object$text === undefined ? '' : _object$text,
          _object$marks = object.marks,
          marks = _object$marks === undefined ? [] : _object$marks;


      var leaf = new Leaf({
        text: text,
        marks: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(marks.map(Mark.fromJSON))
      });

      return leaf;
    }

    /**
     * Check if `any` is a list of leaves.
     *
     * @param {Any} any
     * @return {Boolean}
     */

  }, {
    key: 'isLeafList',
    value: function isLeafList(any) {
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(any) && any.every(function (item) {
        return Leaf.isLeaf(item);
      });
    }
  }]);
  return Leaf;
}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(DEFAULTS$13));

/**
 * Mix in an `Interface` to a `Class`.
 *
 * @param {Class} Interface
 * @param {Class} Class
 */

function mixin(Interface, Classes) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var Class = _step.value;

      // Copy static properties from the interface.
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.getOwnPropertyNames(Interface)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var name = _step2.value;

          if (Class.hasOwnProperty(name)) continue;
          var desc = Object.getOwnPropertyDescriptor(Interface, name);
          Object.defineProperty(Class, name, desc);
        }

        // Copy instance properties from the interface.
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = Object.getOwnPropertyNames(Interface.prototype)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _name = _step3.value;

          if (Class.prototype.hasOwnProperty(_name)) continue;
          var desc = Object.getOwnPropertyDescriptor(Interface.prototype, _name);
          Object.defineProperty(Class.prototype, _name, desc);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/**
 * A factory for the interface that all Slate objects implement.
 *
 * @type {Function}
 */

function create$2(type) {
  var TYPE = TYPES[type];
  var camel = '' + type.charAt(0).toUpperCase() + type.slice(1);
  var is$$1 = 'is' + camel;

  var ObjectInterface = function () {
    function ObjectInterface() {
      classCallCheck(this, ObjectInterface);
    }

    createClass(ObjectInterface, [{
      key: 'object',

      /**
       * Return the type of the object.
       *
       * @return {String}
       */

      get: function get$$1() {
        return type;
      }
    }]);
    return ObjectInterface;
  }();

  ObjectInterface[is$$1] = isObject.bind(null, type);
  ObjectInterface.prototype[TYPE] = true;
  return ObjectInterface;
}

/**
 * Mix in the object interfaces.
 */

Object.entries({
  Annotation: Annotation,
  Block: Block,
  Change: Change,
  Decoration: Decoration,
  Document: Document,
  Editor: Editor,
  Inline: Inline,
  Leaf: Leaf$1,
  Mark: Mark,
  Node: Node,
  Operation: Operation,
  Point: Point,
  Range: Range,
  Selection: Selection,
  Text: Text,
  Value: Value
}).forEach(function (_ref) {
  var _ref2 = slicedToArray(_ref, 2),
      camel = _ref2[0],
      obj = _ref2[1];

  return mixin(create$2(camel.toLowerCase()), [obj]);
});

/**
 * The interface that all Slate models implement.
 *
 * @type {Class}
 */

var ModelInterface = function () {
  function ModelInterface() {
    classCallCheck(this, ModelInterface);
  }

  createClass(ModelInterface, [{
    key: 'toJS',


    /**
     * Alias `toJS`.
     */

    value: function toJS() {
      return this.toJSON.apply(this, arguments);
    }
  }], [{
    key: 'fromJS',

    /**
     * Alias `fromJS`.
     */

    value: function fromJS() {
      return this.fromJSON.apply(this, arguments);
    }
  }]);
  return ModelInterface;
}();

/**
 * Mix in the common interface.
 *
 * @param {Record}
 */

mixin(ModelInterface, [Annotation, Block, Decoration, Document, Inline, Leaf$1, Mark, Node, Operation, Point, Range, Selection, Text, Value]);

/* global WeakMap, Map, Symbol */

/**
 * GLOBAL: True if memoization should is enabled.
 *
 * @type {Boolean}
 */

var ENABLED = true;

/**
 * The leaf node of a cache tree. Used to support variable argument length. A
 * unique object, so that native Maps will key it by reference.
 *
 * @type {Symbol}
 */

var LEAF = Symbol('LEAF');

/**
 * The node of a cache tree for a WeakMap to store cache visited by objects
 *
 * @type {Symbol}
 */

var STORE_KEY = Symbol('STORE_KEY');

/**
 * Values to represent a memoized undefined and null value. Allows efficient value
 * retrieval using Map.get only.
 *
 * @type {Symbol}
 */

var UNDEFINED = Symbol('undefined');
var NULL = Symbol('null');

/**
 * Default value for unset keys in native Maps
 *
 * @type {Undefined}
 */

var UNSET = undefined;

/**
 * Global Store for all cached values
 *
 * @type {WeakMap}
 */

var memoizeStore = new WeakMap();

/**
 * Memoize all of the `properties` on a `object`.
 *
 * @param {Object} object
 * @param {Array} properties
 * @return {Record}
 */

function memoize(object, properties) {
  var _loop = function _loop(property) {
    var original = object[property];

    if (!original) {
      throw new Error('Object does not have a property named "' + property + '".');
    }

    object[property] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // If memoization is disabled, call into the original method.
      if (!ENABLED) return original.apply(this, args);

      if (!memoizeStore.has(this)) {
        memoizeStore.set(this, {
          noArgs: {},
          hasArgs: {}
        });
      }

      var _memoizeStore$get = memoizeStore.get(this),
          noArgs = _memoizeStore$get.noArgs,
          hasArgs = _memoizeStore$get.hasArgs;

      var takesArguments = args.length !== 0;

      var cachedValue = void 0;
      var keys = void 0;

      if (takesArguments) {
        keys = [property].concat(args);
        cachedValue = getIn(hasArgs, keys);
      } else {
        cachedValue = noArgs[property];
      }

      // If we've got a result already, return it.
      if (cachedValue !== UNSET) {
        return cachedValue === UNDEFINED ? undefined : cachedValue;
      }

      // Otherwise calculate what it should be once and cache it.
      var value = original.apply(this, args);
      var v = value === undefined ? UNDEFINED : value;

      if (takesArguments) {
        setIn(hasArgs, keys, v);
      } else {
        noArgs[property] = v;
      }

      return value;
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var property = _step.value;

      _loop(property);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/**
 * Get a value at a key path in a tree of Map.
 *
 * If not set, returns UNSET.
 * If the set value is undefined, returns UNDEFINED.
 *
 * @param {Map} map
 * @param {Array} keys
 * @return {Any|UNSET|UNDEFINED}
 */

function getIn(map, keys) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (key === undefined) {
        key = UNDEFINED;
      } else if (key == null) {
        key = NULL;
      }

      if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
        map = map[STORE_KEY] && map[STORE_KEY].get(key);
      } else {
        map = map[key];
      }

      if (map === UNSET) return UNSET;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return map[LEAF];
}

/**
 * Set a value at a key path in a tree of Map, creating Maps on the go.
 *
 * @param {Map} map
 * @param {Array} keys
 * @param {Any} value
 * @return {Map}
 */

function setIn(map, keys, value) {
  var child = map;

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = keys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var key = _step3.value;

      if (key === undefined) {
        key = UNDEFINED;
      } else if (key == null) {
        key = NULL;
      }

      if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) !== 'object') {
        if (!child[key]) {
          child[key] = {};
        }

        child = child[key];
        continue;
      }

      if (!child[STORE_KEY]) {
        child[STORE_KEY] = new WeakMap();
      }

      if (!child[STORE_KEY].has(key)) {
        var newChild = {};
        child[STORE_KEY].set(key, newChild);
        child = newChild;
        continue;
      }

      child = child[STORE_KEY].get(key);
    }

    // The whole path has been created, so set the value to the bottom most map.
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  child[LEAF] = value;
  return map;
}

/**
 * In DEV mode, clears the previously memoized values, globally.
 *
 * @return {Void}
 */

function resetMemoization() {
  memoizeStore = new WeakMap();
}

/**
 * In DEV mode, enable or disable the use of memoize values, globally.
 *
 * @param {Boolean} enabled
 * @return {Void}
 */

function useMemoization(enabled) {
  ENABLED = enabled;
}

/**
 * The interface that `Document`, `Block` and `Inline` all implement, to make
 * working with the recursive node tree easier.
 *
 * @type {Class}
 */

var NodeInterface = function () {
  function NodeInterface() {
    classCallCheck(this, NodeInterface);
  }

  createClass(NodeInterface, [{
    key: 'getFirstText',

    /**
     * Get the first text node of a node, or the node itself.
     *
     * @return {Node|Null}
     */

    value: function getFirstText() {
      if (this.object === 'text') {
        return this;
      }

      var descendant = null;

      var found = this.nodes.find(function (node) {
        if (node.object === 'text') return true;
        descendant = node.getFirstText();
        return !!descendant;
      });

      return descendant || found;
    }

    /**
     * Get an object mapping all the keys in the node to their paths.
     *
     * @return {Object}
     */

  }, {
    key: 'getKeysToPathsTable',
    value: function getKeysToPathsTable() {
      var ret = defineProperty({}, this.key, []);

      if (this.nodes) {
        this.nodes.forEach(function (node, i) {
          var nested = node.getKeysToPathsTable();

          for (var key in nested) {
            var path = nested[key];

            Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(!(key in ret), 'A node with a duplicate key of "' + key + '" was found! Duplicate keys are not allowed, you should use `node.regenerateKey` before inserting if you are reusing an existing node.');

            ret[key] = [i].concat(toConsumableArray(path));
          }
        });
      }

      return ret;
    }

    /**
     * Get the last text node of a node, or the node itself.
     *
     * @return {Node|Null}
     */

  }, {
    key: 'getLastText',
    value: function getLastText() {
      if (this.object === 'text') {
        return this;
      }

      var descendant = null;

      var found = this.nodes.findLast(function (node) {
        if (node.object === 'text') return true;
        descendant = node.getLastText();
        return descendant;
      });

      return descendant || found;
    }

    /**
     * Get a node in the tree, or the node itself.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getNode',
    value: function getNode(path) {
      path = this.resolvePath(path);
      if (!path) return null;
      if (this.object === 'text' && path.size) return null;
      var node = path.size ? this.getDescendant(path) : this;
      return node;
    }

    /**
     * Find the path to a node.
     *
     * @param {String|List} key
     * @return {List}
     */

  }, {
    key: 'getPath',
    value: function getPath(key) {
      // COMPAT: Handle passing in a path, to match other methods.
      if (__WEBPACK_IMPORTED_MODULE_0_immutable__["List"].isList(key)) {
        return key;
      }

      // COMPAT: Handle a node object by iterating the descendants tree, so that
      // we avoid using keys for the future.
      if (Node.isNode(key) && this.descendants) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.descendants()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var node = _ref2[0];
            var _path = _ref2[1];

            if (key === node) return _path;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var dict = this.getKeysToPathsTable();
      var path = dict[key];
      return path ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(path) : null;
    }

    /**
     * Get the concatenated text string of a node.
     *
     * @return {String}
     */

  }, {
    key: 'getText',
    value: function getText() {
      if (this.object === 'text') {
        return this.text;
      }

      var text = this.nodes.reduce(function (memo, c) {
        return memo + c.text;
      }, '');
      return text;
    }

    /**
     * Check if a node exists.
     *
     * @param {List|String} path
     * @return {Boolean}
     */

  }, {
    key: 'hasNode',
    value: function hasNode(path) {
      var node = this.getNode(path);
      return !!node;
    }

    /**
     * Normalize the text node with an `editor`.
     *
     * @param {Editor} editor
     * @return {Function|Void}
     */

  }, {
    key: 'normalize',
    value: function normalize(editor) {
      var normalizer = editor.run('normalizeNode', this);
      return normalizer;
    }

    /**
     * Regenerate the node's key.
     *
     * @return {Node}
     */

  }, {
    key: 'regenerateKey',
    value: function regenerateKey() {
      var key = KeyUtils.create();
      var node = this.set('key', key);
      return node;
    }

    /**
     * Resolve a path from a path list or key string.
     *
     * An `index` can be provided, in which case paths created from a key string
     * will have the index pushed onto them. This is helpful in cases where you
     * want to accept either a `path` or a `key, index` combination for targeting
     * a location in the tree that doesn't exist yet, like when inserting.
     *
     * @param {List|String} value
     * @param {Number} index
     * @return {List}
     */

  }, {
    key: 'resolvePath',
    value: function resolvePath(path, index) {
      if (typeof path === 'string') {
        path = this.getPath(path);

        if (index != null) {
          path = path.concat(index);
        }
      } else {
        path = PathUtils.create(path);
      }

      return path;
    }

    /**
     * Validate the node with an `editor`.
     *
     * @param {Editor} editor
     * @return {Error|Void}
     */

  }, {
    key: 'validate',
    value: function validate(editor) {
      var error = editor.run('validateNode', this);
      return error;
    }
  }]);
  return NodeInterface;
}();

/**
 * Memoize read methods.
 */

memoize(NodeInterface.prototype, ['getFirstText', 'getKeysToPathsTable', 'getLastText', 'getText', 'normalize', 'validate']);

/**
 * Mix in the node interface.
 */

mixin(NodeInterface, [Block, Document, Inline, Text]);

var global$1 = typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {}

function identity() {
  return true;
}

/**
 * The interface that `Document`, `Block` and `Inline` all implement, to make
 * working with the recursive node tree easier.
 *
 * @type {Class}
 */

var ElementInterface = function () {
  function ElementInterface() {
    classCallCheck(this, ElementInterface);
  }

  createClass(ElementInterface, [{
    key: 'addMark',


    /**
     * Add `mark` to text at `path`.
     *
     * @param {List|String} path
     * @param {Mark} mark
     * @return {Node}
     */

    value: function addMark(path, mark) {
      path = this.resolvePath(path);
      var node = this.assertDescendant(path);
      node = node.addMark(mark);
      var ret = this.replaceNode(path, node);
      return ret;
    }

    /**
     * Create an iteratable for all of the ancestors of the node.
     *
     * @return {Iterable}
     */

  }, {
    key: 'ancestors',
    value: function ancestors(path) {
      var iterable = this.createIterable({
        path: path,
        direction: null,
        downward: false,
        includeTargetAncestors: true,
        includeRoot: true
      });

      return iterable;
    }

    /**
     * Create an iteratable for all of the blocks of a node with `options`.
     *
     * @param {Options}
     * @return {Iterable}
     */

  }, {
    key: 'blocks',
    value: function blocks() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onlyLeaves = options.onlyLeaves,
          onlyRoots = options.onlyRoots,
          onlyTypes = options.onlyTypes,
          _match = options.match,
          rest = objectWithoutProperties(options, ['onlyLeaves', 'onlyRoots', 'onlyTypes', 'match']);

      var iterable = this.descendants(_extends({
        includeDocument: false,
        includeInlines: false,
        includeTexts: false
      }, rest, {
        match: function match(node, path) {
          if (onlyTypes && !onlyTypes.includes(node.type)) {
            return false;
          } else if (onlyRoots && path.size !== 1) {
            return false;
          } else if (onlyLeaves && !node.isLeafBlock()) {
            return false;
          } else if (_match && !_match(node, path)) {
            return false;
          } else {
            return true;
          }
        }
      }));

      return iterable;
    }

    /**
     * Create an annotation with `properties` relative to the node.
     *
     * @param {Object|Annotation} properties
     * @return {Annotation}
     */

  }, {
    key: 'createAnnotation',
    value: function createAnnotation(properties) {
      properties = Annotation.createProperties(properties);
      var annotation = this.resolveAnnotation(properties);
      return annotation;
    }

    /**
     * Create a decoration with `properties` relative to the node.
     *
     * @param {Object|Decoration} properties
     * @return {Decoration}
     */

  }, {
    key: 'createDecoration',
    value: function createDecoration(properties) {
      properties = Decoration.createProperties(properties);
      var decoration = this.resolveDecoration(properties);
      return decoration;
    }

    /**
     * Create an iteratable function starting at `target` path with `options`.
     *
     * @param {Object} options (optional)
     * @return {Function}
     */

  }, {
    key: 'createIterable',
    value: function createIterable() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$direction = options.direction,
          direction = _options$direction === undefined ? 'forward' : _options$direction,
          _options$downward = options.downward,
          downward = _options$downward === undefined ? true : _options$downward,
          _options$upward = options.upward,
          upward = _options$upward === undefined ? true : _options$upward,
          _options$includeBlock = options.includeBlocks,
          includeBlocks = _options$includeBlock === undefined ? true : _options$includeBlock,
          _options$includeDocum = options.includeDocument,
          includeDocument = _options$includeDocum === undefined ? true : _options$includeDocum,
          _options$includeInlin = options.includeInlines,
          includeInlines = _options$includeInlin === undefined ? true : _options$includeInlin,
          _options$includeRoot = options.includeRoot,
          includeRoot = _options$includeRoot === undefined ? false : _options$includeRoot,
          _options$includeTarge = options.includeTarget,
          includeTarget = _options$includeTarge === undefined ? !!options.range : _options$includeTarge,
          _options$includeTarge2 = options.includeTargetAncestors,
          includeTargetAncestors = _options$includeTarge2 === undefined ? false : _options$includeTarge2,
          _options$includeTexts = options.includeTexts,
          includeTexts = _options$includeTexts === undefined ? true : _options$includeTexts,
          _options$match = options.match,
          match = _options$match === undefined ? null : _options$match;


      var root = this;
      var targetPath = null;
      var targetRange = null;

      // You can iterate over either a range or a path, but not both.
      if (options.range) {
        targetRange = root.resolveRange(options.range);
        targetPath = root.resolvePath(targetRange.start.path);
      } else if (options.path) {
        targetPath = root.resolvePath(options.path);
      }

      var targetNode = targetPath && root.assertNode(targetPath);
      var NativeSet = typeof window === 'undefined' ? global$1.Set : window.Set;

      // Return an object that implements the iterable interface.
      return defineProperty({}, Symbol.iterator, function () {
        var visited = new NativeSet();
        var startPath = targetRange && targetRange.start.path;
        var endPath = targetRange && targetRange.end.path;
        var path = targetPath;
        var node = targetNode;
        var includedTarget = false;
        var includedStart = false;
        var includingStart = false;

        var result = function result() {
          // When these are nulled out we've finished iterating.
          if (!path || !node) {
            return { done: true };
          }

          // We often don't want to include the root node itself.
          if (!includeRoot && node === root) {
            return next();
          }

          if (!includeBlocks && node.object === 'block') {
            return next();
          }

          if (!includeDocument && node.object === 'document') {
            return next();
          }

          if (!includeInlines && node.object === 'inline') {
            return next();
          }

          if (!includeTexts && node.object === 'text') {
            return next();
          }

          if (match && !match(node, path)) {
            return next();
          }

          return { value: [node, path], done: false };
        };

        var next = function next() {
          if (!path || !node) {
            return result();
          }

          // When iterating over a range, we need to include the specific
          // ancestors in the start path of the range manually.
          if (startPath && !includedStart) {
            if (!includingStart) {
              includingStart = true;
              path = PathUtils.create([]);
              node = root;
              return result();
            }

            if (path.size === startPath.size - 1) {
              includedStart = true;
              path = targetPath;
              node = targetNode;
              return next();
            }

            path = startPath.slice(0, path.size + 1);
            node = root.assertNode(path);
            return result();
          }

          // Sometimes we want to include the target itself.
          if (includeTarget && !includedTarget) {
            includedTarget = true;
            return result();
          }

          // When iterating over a range, if we get to the end path then exit.
          if (endPath && path.equals(endPath)) {
            node = null;
            path = null;
            return next();
          }

          // If we're allowed to go downward, and we haven't decsended yet, do so.
          if (downward && node.nodes && node.nodes.size && !visited.has(node)) {
            visited.add(node);
            var nextIndex = direction === 'forward' ? 0 : node.nodes.size - 1;
            path = path.push(nextIndex);
            node = root.assertNode(path);
            return result();
          }

          // If we're going forward...
          if (direction === 'forward') {
            var newPath = PathUtils.increment(path);
            var newNode = root.getNode(newPath);

            if (newNode) {
              path = newPath;
              node = newNode;
              return result();
            }
          }

          // If we're going backward...
          if (direction === 'backward' && path.last() !== 0) {
            var _newPath = PathUtils.decrement(path);
            var _newNode = root.getNode(_newPath);

            if (_newNode) {
              path = _newPath;
              node = _newNode;
              return result();
            }
          }

          // If we're going upward...
          if (upward && path.size) {
            path = PathUtils.lift(path);
            node = root.assertNode(path);

            // Sometimes we'll have already visited the node on the way down
            // so we don't want to double count it.
            if (visited.has(node)) {
              return next();
            }

            visited.add(node);

            // If ancestors of the target node shouldn't be included, skip them.
            if (!includeTargetAncestors) {
              return next();
            } else {
              return result();
            }
          }

          path = null;
          node = null;
          return next();
        };

        return { next: next };
      });
    }

    /**
     * Create a point with `properties` relative to the node.
     *
     * @param {Object|Point} properties
     * @return {Range}
     */

  }, {
    key: 'createPoint',
    value: function createPoint(properties) {
      properties = Point.createProperties(properties);
      var point = this.resolvePoint(properties);
      return point;
    }

    /**
     * Create a range with `properties` relative to the node.
     *
     * @param {Object|Range} properties
     * @return {Range}
     */

  }, {
    key: 'createRange',
    value: function createRange(properties) {
      properties = Range.createProperties(properties);
      var range = this.resolveRange(properties);
      return range;
    }

    /**
     * Create a selection with `properties` relative to the node.
     *
     * @param {Object|Selection} properties
     * @return {Selection}
     */

  }, {
    key: 'createSelection',
    value: function createSelection(properties) {
      properties = Selection.createProperties(properties);
      var selection = this.resolveSelection(properties);
      return selection;
    }

    /**
     * Create an iteratable for all of the descendants of the node.
     *
     * @param {Object} options
     * @return {Iterable}
     */

  }, {
    key: 'descendants',
    value: function descendants(options) {
      var iterable = this.createIterable(_extends({ path: [] }, options));
      return iterable;
    }

    /**
     * Find all of the descendants that match a `predicate`.
     *
     * @param {Function} predicate
     * @return {List<Node>}
     */

  }, {
    key: 'filterDescendants',
    value: function filterDescendants() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity;

      var matches = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.descendants()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = slicedToArray(_ref2, 2);

          var node = _ref3[0];
          var path = _ref3[1];

          if (predicate(node, path)) {
            matches.push(node);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(matches);
    }

    /**
     * Find the first descendant that matches a `predicate`.
     *
     * @param {Function} predicate
     * @return {Node|Null}
     */

  }, {
    key: 'findDescendant',
    value: function findDescendant() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.descendants()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref4 = _step2.value;

          var _ref5 = slicedToArray(_ref4, 2);

          var node = _ref5[0];
          var path = _ref5[1];

          if (predicate(node, path)) {
            return node;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    }

    /**
     * Iterate over all descendants, breaking if `predicate` returns false.
     *
     * @param {Function} predicate
     */

  }, {
    key: 'forEachDescendant',
    value: function forEachDescendant() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.descendants()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _next = _step3.value;

          var ret = predicate.apply(undefined, toConsumableArray(_next));

          if (ret === false) {
            return;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }

    /**
     * Get a set of the active marks in a `range`. Active marks are marks that are
     * on every text node in a given range. This is a common distinction for
     * highlighting toolbar buttons for example.
     *
     * TODO: this method needs to be cleaned up, it's very hard to follow and
     * probably doing unnecessary work.
     *
     * @param {Range} range
     * @return {Set<Mark>}
     */

  }, {
    key: 'getActiveMarksAtRange',
    value: function getActiveMarksAtRange(range) {
      range = this.resolveRange(range);

      if (range.isUnset) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
      }

      if (range.isCollapsed) {
        var _range = range,
            _start = _range.start;

        return this.getInsertMarksAtPoint(_start);
      }

      var _range2 = range,
          start = _range2.start,
          end = _range2.end;

      var startPath = start.path;
      var startOffset = start.offset;
      var endPath = end.path;
      var endOffset = end.offset;
      var startText = this.getDescendant(startPath);
      var endText = this.getDescendant(endPath);

      if (!startPath.equals(endPath)) {
        while (!startPath.equals(endPath) && endOffset === 0) {
          
          var _texts = this.texts({
            path: endPath,
            direction: 'backward'
          });

          var _texts2 = slicedToArray(_texts, 1);

          var _texts2$ = slicedToArray(_texts2[0], 2);

          endText = _texts2$[0];
          endPath = _texts2$[1];


          endOffset = endText.text.length;
        }

        while (!startPath.equals(endPath) && startOffset === startText.text.length) {
          
          var _texts3 = this.texts({ path: startPath });

          var _texts4 = slicedToArray(_texts3, 1);

          var _texts4$ = slicedToArray(_texts4[0], 2);

          startText = _texts4$[0];
          startPath = _texts4$[1];

          startOffset = 0;
        }
      }

      if (startPath.equals(endPath)) {
        return startText.marks;
      }

      var startMarks = startText.marks;

      // PERF: if start marks is empty we can return early.
      if (startMarks.size === 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
      }

      var endMarks = endText.marks;
      var marks = startMarks.intersect(endMarks);

      // If marks is already empty, the active marks is empty
      if (marks.size === 0) {
        return marks;
      }

      
      var _texts5 = this.texts({ path: startPath });

      var _texts6 = slicedToArray(_texts5, 1);

      var _texts6$ = slicedToArray(_texts6[0], 2);

      startText = _texts6$[0];
      startPath = _texts6$[1];


      while (!startPath.equals(endPath)) {
        if (startText.text.length !== 0) {
          marks = marks.intersect(startText.marks);

          if (marks.size === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
          }
        }

        
        var _texts7 = this.texts({ path: startPath });

        var _texts8 = slicedToArray(_texts7, 1);

        var _texts8$ = slicedToArray(_texts8[0], 2);

        startText = _texts8$[0];
        startPath = _texts8$[1];
      }

      return marks;
    }

    /**
     * Get a list of the ancestors of a descendant.
     *
     * @param {List|String} path
     * @return {List<Node>|Null}
     */

  }, {
    key: 'getAncestors',
    value: function getAncestors(path) {
      var iterable = this.ancestors(path);
      var array = Array.from(iterable, function (_ref6) {
        var _ref7 = slicedToArray(_ref6, 1),
            node = _ref7[0];

        return node;
      }).reverse();
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get the leaf block descendants of the node.
     *
     * @return {List<Node>}
     */

  }, {
    key: 'getBlocks',
    value: function getBlocks() {
      var iterable = this.blocks({ onlyLeaves: true });
      var array = Array.from(iterable, function (_ref8) {
        var _ref9 = slicedToArray(_ref8, 1),
            node = _ref9[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get all of the leaf blocks that match a `type`.
     *
     * @param {String} type
     * @return {List<Node>}
     */

  }, {
    key: 'getBlocksByType',
    value: function getBlocksByType(type) {
      var iterable = this.blocks({ onlyLeaves: true, onlyTypes: [type] });
      var array = Array.from(iterable, function (_ref10) {
        var _ref11 = slicedToArray(_ref10, 1),
            node = _ref11[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get a child node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getChild',
    value: function getChild(path) {
      path = this.resolvePath(path);

      if (!path || path.size > 1) {
        return null;
      }

      var child = this.nodes.get(path.first());
      return child;
    }

    /**
     * Get closest parent of node that matches a `predicate`.
     *
     * @param {List|String} path
     * @param {Function} predicate
     * @return {Node|Null}
     */

  }, {
    key: 'getClosest',
    value: function getClosest(path, predicate) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.ancestors(path)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref12 = _step4.value;

          var _ref13 = slicedToArray(_ref12, 2);

          var n = _ref13[0];
          var p = _ref13[1];

          if (predicate(n, p)) {
            return n;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return null;
    }

    /**
     * Get the closest block parent of a node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getClosestBlock',
    value: function getClosestBlock(path) {
      var closest = this.getClosest(path, function (n) {
        return n.object === 'block';
      });
      return closest;
    }

    /**
     * Get the closest inline parent of a node by `path`.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getClosestInline',
    value: function getClosestInline(path) {
      var closest = this.getClosest(path, function (n) {
        return n.object === 'inline';
      });
      return closest;
    }

    /**
     * Get the closest void parent of a node by `path`.
     *
     * @param {List|String} path
     * @param {Editor} editor
     * @return {Node|Null}
     */

  }, {
    key: 'getClosestVoid',
    value: function getClosestVoid(path, editor) {
      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(!Value.isValue(editor), 'As of Slate 0.42.0, the `node.getClosestVoid` method takes an `editor` instead of a `value`.');

      var closest = this.getClosest(path, function (n) {
        return editor.isVoid(n);
      });
      return closest;
    }

    /**
     * Get the common ancestor of nodes `a` and `b`.
     *
     * @param {List} a
     * @param {List} b
     * @return {Node}
     */

  }, {
    key: 'getCommonAncestor',
    value: function getCommonAncestor(a, b) {
      a = this.resolvePath(a);
      b = this.resolvePath(b);

      if (!a || !b) {
        return null;
      }

      var path = PathUtils.relate(a, b);
      var node = this.getNode(path);
      return node;
    }

    /**
     * Get the decorations for the node from an `editor`.
     *
     * @param {Editor} editor
     * @return {List}
     */

  }, {
    key: 'getDecorations',
    value: function getDecorations(editor) {
      var decorations = editor.run('decorateNode', this);
      decorations = Decoration.createList(decorations);
      return decorations;
    }

    /**
     * Get the depth of a descendant, with optional `startAt`.
     *
     * @param {List|String} path
     * @param {Number} startAt
     * @return {Number|Null}
     */

  }, {
    key: 'getDepth',
    value: function getDepth(path) {
      var startAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      path = this.resolvePath(path);

      if (!path) {
        return null;
      }

      var node = this.getNode(path);
      var depth = node ? path.size - 1 + startAt : null;
      return depth;
    }

    /**
     * Get a descendant node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getDescendant',
    value: function getDescendant(path) {
      path = this.resolvePath(path);

      if (!path || !path.size) {
        return null;
      }

      var node = this;

      path.forEach(function (index) {
        node = node.getIn(['nodes', index]);
        return !!node;
      });

      return node;
    }

    /**
     * Get all of the descendant nodes in a `range`.
     *
     * @param {Range} range
     * @return {List<Node>}
     */

  }, {
    key: 'getDescendantsAtRange',
    value: function getDescendantsAtRange(range) {
      var iterable = this.descendants({ range: range });
      var array = Array.from(iterable, function (_ref14) {
        var _ref15 = slicedToArray(_ref14, 1),
            node = _ref15[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get a fragment of the node at a `range`.
     *
     * @param {Range} range
     * @return {Document}
     */

  }, {
    key: 'getFragmentAtRange',
    value: function getFragmentAtRange(range) {
      range = this.resolveRange(range);

      if (range.isUnset) {
        return Document.create();
      }

      var _range3 = range,
          start = _range3.start,
          end = _range3.end;

      var node = this;
      var targetPath = end.path;
      var targetPosition = end.offset;
      var side = 'end';

      while (targetPath.size) {
        var index = targetPath.last();
        node = node.splitNode(targetPath, targetPosition);
        targetPosition = index + 1;
        targetPath = PathUtils.lift(targetPath);

        if (!targetPath.size && side === 'end') {
          targetPath = start.path;
          targetPosition = start.offset;
          side = 'start';
        }
      }

      var startIndex = start.path.first() + 1;
      var endIndex = end.path.first() + 2;
      var nodes = node.nodes.slice(startIndex, endIndex);
      var fragment = Document.create({ nodes: nodes });
      return fragment;
    }

    /**
     * Get the furthest ancestors of a node that matches a `predicate`.
     *
     * @param {Path} path
     * @param {Function} predicate
     * @return {Node|Null}
     */

  }, {
    key: 'getFurthest',
    value: function getFurthest(path) {
      var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;

      var iterable = this.ancestors(path);
      var results = Array.from(iterable).reverse();

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = results[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref16 = _step5.value;

          var _ref17 = slicedToArray(_ref16, 2);

          var n = _ref17[0];
          var p = _ref17[1];

          if (predicate(n, p)) {
            return n;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return null;
    }

    /**
     * Get the furthest block parent of a node.
     *
     * @param {Path} path
     * @return {Node|Null}
     */

  }, {
    key: 'getFurthestBlock',
    value: function getFurthestBlock(path) {
      var furthest = this.getFurthest(path, function (n) {
        return n.object === 'block';
      });
      return furthest;
    }

    /**
     * Get the furthest child ancestor of a node at `path`.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getFurthestChild',
    value: function getFurthestChild(path) {
      path = this.resolvePath(path);

      if (!path || !path.size) {
        return null;
      }

      var furthest = this.nodes.get(path.first());
      return furthest;
    }

    /**
     * Get the furthest inline parent of a node.
     *
     * @param {Path} path
     * @return {Node|Null}
     */

  }, {
    key: 'getFurthestInline',
    value: function getFurthestInline(path) {
      var furthest = this.getFurthest(path, function (n) {
        return n.object === 'inline';
      });
      return furthest;
    }

    /**
     * Get the closest inline nodes for each text node in the node.
     *
     * @return {List<Node>}
     */

  }, {
    key: 'getInlines',
    value: function getInlines() {
      var iterable = this.inlines({ onlyLeaves: true });
      var array = Array.from(iterable, function (_ref18) {
        var _ref19 = slicedToArray(_ref18, 1),
            node = _ref19[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get all of the leaf inline nodes that match a `type`.
     *
     * @param {String} type
     * @return {List<Node>}
     */

  }, {
    key: 'getInlinesByType',
    value: function getInlinesByType(type) {
      var iterable = this.inlines({ onlyLeaves: true, onlyTypes: [type] });
      var array = Array.from(iterable, function (_ref20) {
        var _ref21 = slicedToArray(_ref20, 1),
            node = _ref21[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get a set of marks that would occur on the next insert at a `point` in the
     * node. This mimics expected rich text editing behaviors of mark contiuation.
     *
     * @param {Point} point
     * @return {Set<Mark>}
     */

  }, {
    key: 'getInsertMarksAtPoint',
    value: function getInsertMarksAtPoint(point) {
      point = this.resolvePoint(point);
      var _point = point,
          path = _point.path,
          offset = _point.offset;

      var text = this.getDescendant(path);

      // PERF: we can exit early if the offset isn't at the start of the node.
      if (offset !== 0) {
        return text.marks;
      }

      var blockNode = void 0;
      var blockPath = void 0;

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.ancestors(path)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var entry = _step6.value;

          var _entry = slicedToArray(entry, 2),
              n = _entry[0],
              p = _entry[1];

          if (n.object === 'block') {
            blockNode = n;
            blockPath = p;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var relativePath = PathUtils.drop(path, blockPath.size);

      var _blockNode$texts = blockNode.texts({
        path: relativePath,
        direction: 'backward'
      }),
          _blockNode$texts2 = slicedToArray(_blockNode$texts, 1),
          previous = _blockNode$texts2[0];

      // If there's no previous text, we're at the start of the block, so use
      // the current text nodes marks.


      if (!previous) {
        return text.marks;
      }

      // Otherwise, continue with the previous text node's marks instead.

      var _previous = slicedToArray(previous, 1),
          previousText = _previous[0];

      return previousText.marks;
    }

    /**
     * Get a set of marks that would occur on the next insert at a `range`.
     * This mimics expected rich text editing behaviors of mark contiuation.
     *
     * @param {Range} range
     * @return {Set<Mark>}
     */

  }, {
    key: 'getInsertMarksAtRange',
    value: function getInsertMarksAtRange(range) {
      range = this.resolveRange(range);
      var _range4 = range,
          start = _range4.start;


      if (range.isUnset) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
      }

      if (range.isCollapsed) {
        return this.getInsertMarksAtPoint(start);
      }

      var text = this.getDescendant(start.path);
      return text.marks;
    }

    /**
     * Get the bottom-most block descendants in a `range`.
     *
     * @param {Range} range
     * @return {List<Node>}
     */

  }, {
    key: 'getLeafBlocksAtRange',
    value: function getLeafBlocksAtRange(range) {
      var iterable = this.blocks({ range: range, onlyLeaves: true });
      var array = Array.from(iterable, function (_ref22) {
        var _ref23 = slicedToArray(_ref22, 1),
            node = _ref23[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get the bottom-most inline nodes for each text node in a `range`.
     *
     * @param {Range} range
     * @return {List<Node>}
     */

  }, {
    key: 'getLeafInlinesAtRange',
    value: function getLeafInlinesAtRange(range) {
      var iterable = this.inlines({ range: range, onlyLeaves: true });
      var array = Array.from(iterable, function (_ref24) {
        var _ref25 = slicedToArray(_ref24, 1),
            node = _ref25[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get an object mapping all the keys in the node to their paths.
     *
     * @return {Map}
     */

  }, {
    key: 'getNodesToPathsMap',
    value: function getNodesToPathsMap() {
      var root = this;
      var map = typeof window === 'undefined' ? new global$1.Map() : new window.Map();

      map.set(root, PathUtils.create([]));

      root.forEachDescendant(function (node, path) {
        map.set(node, path);
      });

      return map;
    }

    /**
     * Get all of the marks for all of the characters of every text node.
     *
     * @return {OrderedSet<Mark>}
     */

  }, {
    key: 'getMarks',
    value: function getMarks() {
      var iterable = this.marks();
      var array = Array.from(iterable, function (_ref26) {
        var _ref27 = slicedToArray(_ref26, 1),
            mark = _ref27[0];

        return mark;
      });
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(array);
    }

    /**
     * Get a set of the marks in a `range`.
     *
     * @param {Range} range
     * @return {OrderedSet<Mark>}
     */

  }, {
    key: 'getMarksAtRange',
    value: function getMarksAtRange(range) {
      var iterable = this.marks({ range: range });
      var array = Array.from(iterable, function (_ref28) {
        var _ref29 = slicedToArray(_ref28, 1),
            mark = _ref29[0];

        return mark;
      });
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(array);
    }

    /**
     * Get all of the marks that match a `type`.
     *
     * @param {String} type
     * @return {OrderedSet<Mark>}
     */

  }, {
    key: 'getMarksByType',
    value: function getMarksByType(type) {
      var iterable = this.marks({ onlyTypes: [type] });
      var array = Array.from(iterable, function (_ref30) {
        var _ref31 = slicedToArray(_ref30, 1),
            mark = _ref31[0];

        return mark;
      });
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(array);
    }

    /**
     * Get the block node after a descendant text node by `path`.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getNextBlock',
    value: function getNextBlock(path) {
      var _blocks = this.blocks({ path: path, onlyLeaves: true }),
          _blocks2 = slicedToArray(_blocks, 1),
          entry = _blocks2[0];

      var block = entry ? entry[0] : null;
      return block;
    }

    /**
     * Get the next node in the tree, returning siblings or ancestor siblings.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getNextNode',
    value: function getNextNode(path) {
      var iterable = this.createIterable({ path: path, downward: false });

      var _iterable = slicedToArray(iterable, 1),
          entry = _iterable[0];

      var node = entry ? entry[0] : null;
      return node;
    }

    /**
     * Get the next sibling of a node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getNextSibling',
    value: function getNextSibling(path) {
      var _siblings = this.siblings(path),
          _siblings2 = slicedToArray(_siblings, 1),
          entry = _siblings2[0];

      var node = entry ? entry[0] : null;
      return node;
    }

    /**
     * Get the text node after a descendant text node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getNextText',
    value: function getNextText(path) {
      var _texts9 = this.texts({ path: path }),
          _texts10 = slicedToArray(_texts9, 1),
          entry = _texts10[0];

      var node = entry ? entry[0] : null;
      return node;
    }

    /**
     * Get the offset for a descendant text node by `path` or `key`.
     *
     * @param {List|string} path
     * @return {Number}
     */

  }, {
    key: 'getOffset',
    value: function getOffset(path) {
      path = this.resolvePath(path);
      this.assertDescendant(path);

      // Calculate the offset of the nodes before the highest child.
      var index = path.first();

      var offset = this.nodes.slice(0, index).reduce(function (memo, n) {
        return memo + n.text.length;
      }, 0);

      // Recurse if need be.
      var ret = path.size === 1 ? offset : offset + this.nodes.get(index).getOffset(PathUtils.drop(path));

      return ret;
    }

    /**
     * Get the offset from a `range`.
     *
     * @param {Range} range
     * @return {Number}
     */

  }, {
    key: 'getOffsetAtRange',
    value: function getOffsetAtRange(range) {
      range = this.resolveRange(range);

      if (range.isUnset) {
        throw new Error('The range cannot be unset to calculcate its offset.');
      }

      if (range.isExpanded) {
        throw new Error('The range must be collapsed to calculcate its offset.');
      }

      var _range5 = range,
          start = _range5.start;

      var offset = this.getOffset(start.path) + start.offset;
      return offset;
    }

    /**
     * Get the parent of a descendant node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getParent',
    value: function getParent(path) {
      path = this.resolvePath(path);
      if (!path) return null;
      if (!path.size) return null;
      var parentPath = PathUtils.lift(path);
      var parent = this.getNode(parentPath);
      return parent;
    }

    /**
     * Get the block node before a descendant text node by `path`.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getPreviousBlock',
    value: function getPreviousBlock(path) {
      var _blocks3 = this.blocks({
        path: path,
        onlyLeaves: true,
        direction: 'backward'
      }),
          _blocks4 = slicedToArray(_blocks3, 1),
          entry = _blocks4[0];

      var block = entry ? entry[0] : null;
      return block;
    }

    /**
     * Get the previous node from a node in the tree.
     *
     * This will not only check for siblings but instead move up the tree
     * returning the previous ancestor if no sibling is found.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getPreviousNode',
    value: function getPreviousNode(path) {
      var iterable = this.createIterable({
        path: path,
        downward: false,
        direction: 'backward'
      });

      var _iterable2 = slicedToArray(iterable, 1),
          entry = _iterable2[0];

      var node = entry ? entry[0] : null;
      return node;
    }

    /**
     * Get the previous sibling of a node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getPreviousSibling',
    value: function getPreviousSibling(path) {
      var _siblings3 = this.siblings(path, { direction: 'backward' }),
          _siblings4 = slicedToArray(_siblings3, 1),
          entry = _siblings4[0];

      var node = entry ? entry[0] : null;
      return node;
    }

    /**
     * Get the text node before a descendant text node.
     *
     * @param {List|String} path
     * @return {Node|Null}
     */

  }, {
    key: 'getPreviousText',
    value: function getPreviousText(path) {
      var _texts11 = this.texts({ path: path, direction: 'backward' }),
          _texts12 = slicedToArray(_texts11, 1),
          entry = _texts12[0];

      var node = entry ? entry[0] : null;
      return node;
    }

    /**
     * Get only the root block nodes in a `range`.
     *
     * @param {Range} range
     * @return {List}
     */

  }, {
    key: 'getRootBlocksAtRange',
    value: function getRootBlocksAtRange(range) {
      var iterable = this.blocks({ range: range, onlyRoots: true });
      var array = Array.from(iterable, function (_ref32) {
        var _ref33 = slicedToArray(_ref32, 1),
            node = _ref33[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get only the root inline nodes in a `range`.
     *
     * @param {Range} range
     * @return {List}
     */

  }, {
    key: 'getRootInlinesAtRange',
    value: function getRootInlinesAtRange(range) {
      var iterable = this.inlines({ range: range, onlyRoots: true });
      var array = Array.from(iterable, function (_ref34) {
        var _ref35 = slicedToArray(_ref34, 1),
            node = _ref35[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get the descendent text node at an `offset`.
     *
     * @param {String} offset
     * @return {Node|Null}
     */

  }, {
    key: 'getTextAtOffset',
    value: function getTextAtOffset(offset) {
      // PERF: Add a few shortcuts for the obvious cases.
      if (offset === 0) return this.getFirstText();
      if (offset === this.text.length) return this.getLastText();
      if (offset < 0 || offset > this.text.length) return null;

      var length = 0;

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.texts()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref36 = _step7.value;

          var _ref37 = slicedToArray(_ref36, 1);

          var node = _ref37[0];

          length += node.text.length;

          if (length > offset) {
            return node;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return null;
    }

    /**
     * Get the direction of the node's text.
     *
     * @return {String}
     */

  }, {
    key: 'getTextDirection',
    value: function getTextDirection() {
      var dir = __WEBPACK_IMPORTED_MODULE_8_direction___default()(this.text);
      return dir === 'neutral' ? null : dir;
    }

    /**
     * Recursively get all of the child text nodes in order of appearance.
     *
     * @return {List<Node>}
     */

  }, {
    key: 'getTexts',
    value: function getTexts() {
      var iterable = this.texts();
      var array = Array.from(iterable, function (_ref38) {
        var _ref39 = slicedToArray(_ref38, 1),
            node = _ref39[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Get all of the text nodes in a `range` as a List.
     *
     * @param {Range} range
     * @return {List<Node>}
     */

  }, {
    key: 'getTextsAtRange',
    value: function getTextsAtRange(range) {
      var iterable = this.texts({ range: range });
      var array = Array.from(iterable, function (_ref40) {
        var _ref41 = slicedToArray(_ref40, 1),
            node = _ref41[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }

    /**
     * Check if the node has block children.
     *
     * @return {Boolean}
     */

  }, {
    key: 'hasBlockChildren',
    value: function hasBlockChildren() {
      return !!(this.nodes && this.nodes.find(function (n) {
        return n.object === 'block';
      }));
    }

    /**
     * Check if a child node exists.
     *
     * @param {List|String} path
     * @return {Boolean}
     */

  }, {
    key: 'hasChild',
    value: function hasChild(path) {
      var child = this.getChild(path);
      return !!child;
    }

    /**
     * Check if a node has inline children.
     *
     * @return {Boolean}
     */

  }, {
    key: 'hasInlineChildren',
    value: function hasInlineChildren() {
      return !!(this.nodes && this.nodes.find(function (n) {
        return n.object === 'inline' || n.object === 'text';
      }));
    }

    /**
     * Recursively check if a child node exists.
     *
     * @param {List|String} path
     * @return {Boolean}
     */

  }, {
    key: 'hasDescendant',
    value: function hasDescendant(path) {
      var descendant = this.getDescendant(path);
      return !!descendant;
    }

    /**
     * Check if a node has a void parent.
     *
     * @param {List|String} path
     * @param {Editor} editor
     * @return {Boolean}
     */

  }, {
    key: 'hasVoidParent',
    value: function hasVoidParent(path, editor) {
      Object(__WEBPACK_IMPORTED_MODULE_3_tiny_invariant__["a" /* default */])(!Value.isValue(editor), 'As of Slate 0.42.0, the `node.hasVoidParent` method takes an `editor` instead of a `value`.');

      var closest = this.getClosestVoid(path, editor);
      return !!closest;
    }

    /**
     * Create an iteratable for all of the inlines of a node with `options`.
     *
     * @param {Options}
     * @return {Iterable}
     */

  }, {
    key: 'inlines',
    value: function inlines() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onlyLeaves = options.onlyLeaves,
          onlyRoots = options.onlyRoots,
          onlyTypes = options.onlyTypes,
          _match2 = options.match,
          rest = objectWithoutProperties(options, ['onlyLeaves', 'onlyRoots', 'onlyTypes', 'match']);

      var iterable = this.descendants(_extends({
        includeBlocks: false,
        includeTexts: false,
        includeDocument: false
      }, rest, {
        match: function match(node, path) {
          if (onlyTypes && !onlyTypes.includes(node.type)) {
            return false;
          } else if (onlyLeaves && !node.isLeafInline()) {
            return false;
          } else if (onlyRoots && _this.getParent(path).object !== 'block') {
            return false;
          } else if (_match2 && !_match2(node, path)) {
            return false;
          } else {
            return true;
          }
        }
      }));

      return iterable;
    }

    /**
     * Insert a `node`.
     *
     * @param {List|String} path
     * @param {Node} node
     * @return {Node}
     */

  }, {
    key: 'insertNode',
    value: function insertNode(path, node) {
      path = this.resolvePath(path);
      var index = path.last();
      var parentPath = PathUtils.lift(path);
      var parent = this.assertNode(parentPath);
      var nodes = parent.nodes.splice(index, 0, node);
      parent = parent.set('nodes', nodes);
      var ret = this.replaceNode(parentPath, parent);
      return ret;
    }

    /**
     * Insert `text` at `offset` in node by `path`.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @param {String} text
     * @return {Node}
     */

  }, {
    key: 'insertText',
    value: function insertText(path, offset, text) {
      path = this.resolvePath(path);
      var node = this.assertDescendant(path);
      node = node.insertText(offset, text);
      var ret = this.replaceNode(path, node);
      return ret;
    }

    /**
     * Check whether the node is a leaf block.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isLeafBlock',
    value: function isLeafBlock() {
      if (this.object !== 'block') {
        return false;
      }

      if (this.nodes.some(function (n) {
        return n.object === 'block';
      })) {
        return false;
      }

      return true;
    }

    /**
     * Check whether the node is a leaf inline.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isLeafInline',
    value: function isLeafInline() {
      if (this.object !== 'inline') {
        return false;
      }

      if (this.nodes.some(function (n) {
        return n.object === 'inline';
      })) {
        return false;
      }

      return true;
    }

    /**
     * Check whether a descendant node is inside a `range` by `path`.
     *
     * @param {List|String} path
     * @param {Range} range
     * @return {Node}
     */

  }, {
    key: 'isInRange',
    value: function isInRange(path, range) {
      path = this.resolvePath(path);
      range = this.resolveRange(range);

      if (range.isUnset) {
        return false;
      }

      var toStart = PathUtils.compare(path, range.start.path);
      var toEnd = PathUtils.compare(path, range.end.path);
      var isInRange = toStart !== -1 && toEnd !== 1;
      return isInRange;
    }

    /**
     * Map all child nodes, updating them in their parents. This method is
     * optimized to not return a new node if no changes are made.
     *
     * @param {Function} predicate
     * @return {Node}
     */

  }, {
    key: 'mapChildren',
    value: function mapChildren() {
      var _this2 = this;

      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity;
      var nodes = this.nodes;


      nodes.forEach(function (node, i) {
        var ret = predicate(node, i, _this2.nodes);
        if (ret !== node) nodes = nodes.set(ret.key, ret);
      });

      var ret = this.set('nodes', nodes);
      return ret;
    }

    /**
     * Map all descendant nodes, updating them in their parents. This method is
     * optimized to not return a new node if no changes are made.
     *
     * @param {Function} predicate
     * @return {Node}
     */

  }, {
    key: 'mapDescendants',
    value: function mapDescendants() {
      var _this3 = this;

      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity;
      var nodes = this.nodes;


      nodes.forEach(function (node, index) {
        var ret = node;
        if (ret.object !== 'text') ret = ret.mapDescendants(predicate);
        ret = predicate(ret, index, _this3.nodes);
        if (ret === node) return;

        nodes = nodes.set(index, ret);
      });

      var ret = this.set('nodes', nodes);
      return ret;
    }

    /**
     * Create an iteratable for all the marks in text nodes with `options`.
     *
     * @param {Options}
     * @return {Iterable}
     */

  }, {
    key: 'marks',
    value: function marks() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$onlyTypes = options.onlyTypes,
          onlyTypes = _options$onlyTypes === undefined ? null : _options$onlyTypes,
          match = options.match,
          rest = objectWithoutProperties(options, ['onlyTypes', 'match']);

      var texts = this.texts(rest);

      return defineProperty({}, Symbol.iterator, function () {
        var iterator = texts[Symbol.iterator]();
        var node = null;
        var path = null;
        var remaining = [];

        var next = function next() {
          if (remaining.length) {
            var mark = remaining.shift();

            if (onlyTypes && !onlyTypes.includes(mark.type)) {
              return next();
            } else if (match && !match(mark, node, path)) {
              return next();
            }

            return { value: [mark, node, path], done: false };
          }

          var _iterator$next = iterator.next(),
              value = _iterator$next.value,
              done = _iterator$next.done;

          if (done) {
            return { done: true };
          }

          
          var _value = slicedToArray(value, 2);

          node = _value[0];
          path = _value[1];

          remaining = node.marks.toArray();
          return next();
        };

        return { next: next };
      });
    }

    /**
     * Merge a node backwards its previous sibling.
     *
     * @param {List|Key} path
     * @return {Node}
     */

  }, {
    key: 'mergeNode',
    value: function mergeNode(path) {
      var b = this.assertNode(path);
      path = this.resolvePath(path);

      if (path.last() === 0) {
        throw new Error('Unable to merge node because it has no previous sibling: ' + b);
      }

      var withPath = PathUtils.decrement(path);
      var a = this.assertNode(withPath);

      if (a.object !== b.object) {
        throw new Error('Unable to merge two different kinds of nodes: ' + a + ' and ' + b);
      }

      var newNode = a.object === 'text' ? a.mergeText(b) : a.set('nodes', a.nodes.concat(b.nodes));

      var ret = this;
      ret = ret.removeNode(path);
      ret = ret.removeNode(withPath);
      ret = ret.insertNode(withPath, newNode);
      return ret;
    }

    /**
     * Move a node by `path` to `newPath`.
     *
     * A `newIndex` can be provided when move nodes by `key`, to account for not
     * being able to have a key for a location in the tree that doesn't exist yet.
     *
     * @param {List|Key} path
     * @param {List|Key} newPath
     * @param {Number} newIndex
     * @return {Node}
     */

  }, {
    key: 'moveNode',
    value: function moveNode(path, newPath) {
      var newIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var node = this.assertNode(path);
      path = this.resolvePath(path);
      newPath = this.resolvePath(newPath, newIndex);

      var newParentPath = PathUtils.lift(newPath);
      this.assertNode(newParentPath);

      // TODO: this is a bit hacky, re-creating the operation that led to this method being called
      // Alternative 1: pass the operation through from apply -> value.moveNode
      // Alternative 2: add a third property to the operation called "transformedNewPath", pass that through
      var op = Operation.create({
        type: 'move_node',
        path: path,
        newPath: newPath
      });
      newPath = PathUtils.transform(path, op).first();

      var ret = this;
      ret = ret.removeNode(path);
      ret = ret.insertNode(newPath, node);
      return ret;
    }

    /**
     * Remove `mark` from text at `path`.
     *
     * @param {List} path
     * @param {Mark} mark
     * @return {Node}
     */

  }, {
    key: 'removeMark',
    value: function removeMark(path, mark) {
      path = this.resolvePath(path);
      var node = this.assertDescendant(path);
      node = node.removeMark(mark);
      var ret = this.replaceNode(path, node);
      return ret;
    }

    /**
     * Remove a node.
     *
     * @param {List|String} path
     * @return {Node}
     */

  }, {
    key: 'removeNode',
    value: function removeNode(path) {
      this.assertDescendant(path);
      path = this.resolvePath(path);
      var deep = path.flatMap(function (x) {
        return ['nodes', x];
      });
      var ret = this.deleteIn(deep);
      return ret;
    }

    /**
     * Remove `text` at `offset` in node.
     *
     * @param {List|Key} path
     * @param {Number} offset
     * @param {String} text
     * @return {Node}
     */

  }, {
    key: 'removeText',
    value: function removeText(path, offset, text) {
      var node = this.assertDescendant(path);
      node = node.removeText(offset, text.length);
      var ret = this.replaceNode(path, node);
      return ret;
    }

    /**
     * Replace a `node` in the tree.
     *
     * @param {List|Key} path
     * @param {Node} node
     * @return {Node}
     */

  }, {
    key: 'replaceNode',
    value: function replaceNode(path, node) {
      path = this.resolvePath(path);

      if (!path) {
        throw new Error('Unable to replace a node because it could not be found in the first place: ' + path);
      }

      if (!path.size) return node;
      this.assertNode(path);
      var deep = path.flatMap(function (x) {
        return ['nodes', x];
      });
      var ret = this.setIn(deep, node);
      return ret;
    }

    /**
     * Resolve a `annotation`, relative to the node, ensuring that the keys and
     * offsets in the annotation exist and that they are synced with the paths.
     *
     * @param {Annotation|Object} annotation
     * @return {Annotation}
     */

  }, {
    key: 'resolveAnnotation',
    value: function resolveAnnotation(annotation) {
      annotation = Annotation.create(annotation);
      annotation = annotation.normalize(this);
      return annotation;
    }

    /**
     * Resolve a `decoration`, relative to the node, ensuring that the keys and
     * offsets in the decoration exist and that they are synced with the paths.
     *
     * @param {Decoration|Object} decoration
     * @return {Decoration}
     */

  }, {
    key: 'resolveDecoration',
    value: function resolveDecoration(decoration) {
      decoration = Decoration.create(decoration);
      decoration = decoration.normalize(this);
      return decoration;
    }

    /**
     * Resolve a `point`, relative to the node, ensuring that the keys and
     * offsets in the point exist and that they are synced with the paths.
     *
     * @param {Point|Object} point
     * @return {Point}
     */

  }, {
    key: 'resolvePoint',
    value: function resolvePoint(point) {
      point = Point.create(point);
      point = point.normalize(this);
      return point;
    }

    /**
     * Resolve a `range`, relative to the node, ensuring that the keys and
     * offsets in the range exist and that they are synced with the paths.
     *
     * @param {Range|Object} range
     * @return {Range}
     */

  }, {
    key: 'resolveRange',
    value: function resolveRange(range) {
      range = Range.create(range);
      range = range.normalize(this);
      return range;
    }

    /**
     * Resolve a `selection`, relative to the node, ensuring that the keys and
     * offsets in the selection exist and that they are synced with the paths.
     *
     * @param {Selection|Object} selection
     * @return {Selection}
     */

  }, {
    key: 'resolveSelection',
    value: function resolveSelection(selection) {
      selection = Selection.create(selection);
      selection = selection.normalize(this);
      return selection;
    }

    /**
     * Set `properties` on a node.
     *
     * @param {List|String} path
     * @param {Object} properties
     * @return {Node}
     */

  }, {
    key: 'setNode',
    value: function setNode(path, properties) {
      var node = this.assertNode(path);
      node = node.merge(properties);
      var ret = this.replaceNode(path, node);
      return ret;
    }

    /**
     * Set `properties` on `mark` on text at `offset` and `length` in node.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @param {Number} length
     * @param {Mark} mark
     * @param {Object} properties
     * @return {Node}
     */

  }, {
    key: 'setMark',
    value: function setMark(path, properties, newProperties) {
      path = this.resolvePath(path);
      var node = this.assertDescendant(path);
      node = node.setMark(properties, newProperties);
      var ret = this.replaceNode(path, node);
      return ret;
    }

    /**
     * Create an iteratable for the siblings in the tree at `path`.
     *
     * @param {List|Array} path
     * @return {Iterable}
     */

  }, {
    key: 'siblings',
    value: function siblings(path, options) {
      var iterable = this.createIterable(_extends({
        path: path,
        upward: false,
        downward: false
      }, options));

      return iterable;
    }

    /**
     * Split a node by `path` at `position` with optional `properties` to apply
     * to the newly split node.
     *
     * @param {List|String} path
     * @param {Number} position
     * @param {Object} properties
     * @return {Node}
     */

  }, {
    key: 'splitNode',
    value: function splitNode(path, position, properties) {
      var child = this.assertNode(path);
      path = this.resolvePath(path);
      var a = void 0;
      var b = void 0;

      if (child.object === 'text') {
        
        var _child$splitText = child.splitText(position);

        var _child$splitText2 = slicedToArray(_child$splitText, 2);

        a = _child$splitText2[0];
        b = _child$splitText2[1];
      } else {
        var befores = child.nodes.take(position);
        var afters = child.nodes.skip(position);
        a = child.set('nodes', befores);
        b = child.set('nodes', afters).regenerateKey();
      }

      if (properties && child.object !== 'text') {
        b = b.merge(properties);
      }

      var ret = this;
      ret = ret.removeNode(path);
      ret = ret.insertNode(path, b);
      ret = ret.insertNode(path, a);
      return ret;
    }

    /**
     * Create an iteratable for all the text node descendants.
     *
     * @param {Object} options
     * @return {Iterable}
     */

  }, {
    key: 'texts',
    value: function texts(options) {
      var iterable = this.descendants(_extends({
        includeBlocks: false,
        includeInlines: false,
        includeDocument: false
      }, options));

      return iterable;
    }

    /**
     * Deprecated.
     */

  }, {
    key: 'getBlocksAtRange',
    value: function getBlocksAtRange(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.44 the `node.getBlocksAtRange` method has been renamed to `getLeafBlocksAtRange`.');

      return this.getLeafBlocksAtRange(range);
    }
  }, {
    key: 'getBlocksAtRangeAsArray',
    value: function getBlocksAtRangeAsArray(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.44 the `node.getBlocksAtRangeAsArray` method has been renamed to `getLeafBlocksAtRangeAsArray`.');

      return this.getLeafBlocksAtRangeAsArray(range);
    }
  }, {
    key: 'getInlinesAtRange',
    value: function getInlinesAtRange(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.44 the `node.getInlinesAtRange` method has been renamed to `getLeafInlinesAtRange`.');

      return this.getLeafInlinesAtRange(range);
    }
  }, {
    key: 'getInlinesAtRangeAsArray',
    value: function getInlinesAtRangeAsArray(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.44 the `node.getInlinesAtRangeAsArray` method has been renamed to `getLeafInlinesAtRangeAsArray`.');

      return this.getLeafInlinesAtRangeAsArray(range);
    }
  }, {
    key: 'getNextTextAndPath',
    value: function getNextTextAndPath(path) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getNextTextAndPath` method has been renamed to `getNextTextEntry`.');

      return this.getNextTextEntry(path);
    }
  }, {
    key: 'getNextDeepMatchingNodeAndPath',
    value: function getNextDeepMatchingNodeAndPath(path) {
      var iterator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getNextDeepMatchingNodeAndPath` method is deprecated.');

      var match = this.getNextMatchingNodeAndPath(path);

      if (!match) return null;

      var _match3 = slicedToArray(match, 2),
          nextNode = _match3[0],
          nextPath = _match3[1];

      var childMatch = void 0;

      var assign = function assign() {
        childMatch = nextNode.object !== 'text' && nextNode.findFirstDescendantAndPath(iterator, nextPath);
        return childMatch;
      };

      while (assign(childMatch)) {
        var _childMatch = childMatch;

        var _childMatch2 = slicedToArray(_childMatch, 2);

        nextNode = _childMatch2[0];
        nextPath = _childMatch2[1];
      }

      if (!nextNode) return null;

      return iterator(nextNode) ? [nextNode, nextPath] : this.getNextDeepMatchingNodeAndPath(match[1], iterator);
    }
  }, {
    key: 'getPreviousTextAndPath',
    value: function getPreviousTextAndPath(path) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getPreviousTextAndPath` method has been renamed to `getPreviousTextEntry`.');

      return this.getPreviousTextEntry(path);
    }
  }, {
    key: 'findFirstDescendantAndPath',
    value: function findFirstDescendantAndPath(iterator, pathToThisNode) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `findFirstDescendantAndPath` method is deprecated.');

      return this.findDescendantAndPath(iterator, pathToThisNode, false);
    }
  }, {
    key: 'getPreviousMatchingNodeAndPath',
    value: function getPreviousMatchingNodeAndPath(path) {
      var iterator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getPreviousMatchingNodeAndPath` method is deprecated.');

      if (!path) return null;

      for (var i = path.size; i > 0; i--) {
        var p = path.slice(0, i);
        if (p.last() === 0) continue;

        var previousPath = PathUtils.decrement(p);
        var previousNode = this.getNode(previousPath);

        while (previousNode && !iterator(previousNode)) {
          previousPath = PathUtils.decrement(previousPath);
          previousNode = this.getNode(previousPath);
        }

        if (previousNode) return [previousNode, previousPath];
      }

      return null;
    }
  }, {
    key: 'getPreviousDeepMatchingNodeAndPath',
    value: function getPreviousDeepMatchingNodeAndPath(path) {
      var iterator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getPreviousDeepMatchingNodeAndPath` method is deprecated.');

      var match = this.getPreviousMatchingNodeAndPath(path);

      if (!match) return null;

      var _match4 = slicedToArray(match, 2),
          previousNode = _match4[0],
          previousPath = _match4[1];

      var childMatch = void 0;

      var assign = function assign() {
        childMatch = previousNode.object !== 'text' && previousNode.findLastDescendantAndPath(iterator, previousPath);
        return childMatch;
      };

      while (assign(childMatch)) {
        var _childMatch3 = childMatch;

        var _childMatch4 = slicedToArray(_childMatch3, 2);

        previousNode = _childMatch4[0];
        previousPath = _childMatch4[1];
      }

      if (!previousNode) return null;

      return iterator(previousNode) ? [previousNode, previousPath] : this.getPreviousDeepMatchingNodeAndPath(match[1], iterator);
    }
  }, {
    key: 'findLastDescendantAndPath',
    value: function findLastDescendantAndPath(iterator, pathToThisNode) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `findLastDescendantAndPath` method is deprecated.');

      return this.findDescendantAndPath(iterator, pathToThisNode, true);
    }
  }, {
    key: 'findDescendantAndPath',
    value: function findDescendantAndPath(iterator) {
      var pathToThisNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PathUtils.create([]);
      var findLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `findDescendantAndPath` method is deprecated.');

      var found = void 0;
      var foundPath = void 0;

      this.forEachDescendantWithPath(function (node, path, nodes) {
        if (iterator(node, path, nodes)) {
          found = node;
          foundPath = path;
          return false;
        }
      }, pathToThisNode, findLast);

      return found ? [found, foundPath] : null;
    }
  }, {
    key: 'forEachDescendantWithPath',
    value: function forEachDescendantWithPath(iterator) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PathUtils.create([]);
      var findLast = arguments[2];

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `forEachDescendantWithPath` method is deprecated.');

      var nodes = this.nodes;
      var ret = void 0;

      if (findLast) nodes = nodes.reverse();

      nodes.forEach(function (child, i) {
        var childPath = path.concat(i);

        if (iterator(child, childPath, nodes) === false) {
          ret = false;
          return false;
        }

        if (child.object !== 'text') {
          ret = child.forEachDescendantWithPath(iterator, childPath, findLast);
          return ret;
        }
      });

      return ret;
    }
  }, {
    key: 'getNextMatchingNodeAndPath',
    value: function getNextMatchingNodeAndPath(path) {
      var iterator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getNextMatchingNodeAndPath` method is deprecated.');

      if (!path) return null;

      for (var i = path.size; i > 0; i--) {
        var p = path.slice(0, i);

        var nextPath = PathUtils.increment(p);
        var nextNode = this.getNode(nextPath);

        while (nextNode && !iterator(nextNode)) {
          nextPath = PathUtils.increment(nextPath);
          nextNode = this.getNode(nextPath);
        }

        if (nextNode) return [nextNode, nextPath];
      }

      return null;
    }
  }, {
    key: 'getSelectionIndexes',
    value: function getSelectionIndexes(range) {
      var isSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getSelectionIndexes` method is deprecated.');

      var start = range.start,
          end = range.end;

      // PERF: if we're not selected, we can exit early.

      if (!isSelected) {
        return null;
      }

      // PERF: if we've been given an invalid selection we can exit early.
      if (range.isUnset) {
        return null;
      }

      // PERF: if the start and end keys are the same, just check for the child
      // that contains that single key.
      if (start.path.equals(end.path)) {
        var child = this.getFurthestAncestor(start.path);
        var index = child ? this.nodes.indexOf(child) : null;
        return { start: index, end: index + 1 };
      }

      // Otherwise, check all of the children...
      var startIndex = null;
      var endIndex = null;

      this.nodes.forEach(function (child, i) {
        if (child.object === 'text') {
          if (startIndex == null && child.key === start.key) startIndex = i;
          if (endIndex == null && child.key === end.key) endIndex = i + 1;
        } else {
          if (startIndex == null && child.hasDescendant(start.key)) startIndex = i;
          if (endIndex == null && child.hasDescendant(end.key)) endIndex = i + 1;
        }

        // PERF: exit early if both start and end have been found.
        return startIndex == null || endIndex == null;
      });

      if (isSelected && startIndex == null) {
        startIndex = 0;
      }

      if (isSelected && endIndex == null) {
        endIndex = this.nodes.size;
      }

      if (startIndex == null) {
        return null;
      }

      return { start: startIndex, end: endIndex };
    }
  }, {
    key: 'getTextsBetweenPositionsAsArray',
    value: function getTextsBetweenPositionsAsArray(startPath, endPath) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getTextsBetweenPositionsAsArray` method is deprecated.');

      startPath = this.resolvePath(startPath);
      endPath = this.resolvePath(endPath);

      return this.getTextsBetweenPathPositionsAsArray(startPath, endPath);
    }
  }, {
    key: 'getOrderedMarksBetweenPositions',
    value: function getOrderedMarksBetweenPositions(startPath, startOffset, endPath, endOffset) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getOrderedMarksBetweenPositions` method is deprecated.');

      startPath = this.resolvePath(startPath);
      endPath = this.resolvePath(endPath);
      var startText = this.getDescendant(startPath);

      // PERF: if the paths are equal, we can just use the start.
      if (PathUtils.isEqual(startPath, endPath)) {
        return startText.marks;
      }

      var texts = this.getTextsBetweenPathPositionsAsArray(startPath, endPath);

      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])().withMutations(function (result) {
        texts.forEach(function (text) {
          result.union(text.marks);
        });
      });
    }
  }, {
    key: 'getTextsBetweenPathPositionsAsArray',
    value: function getTextsBetweenPathPositionsAsArray(startPath, endPath) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getTextsBetweenPathPositionsAsArray` method is deprecated.');

      // PERF: the most common case is when the range is in a single text node,
      // where we can avoid a lot of iterating of the tree.
      if (startPath && endPath && PathUtils.isEqual(startPath, endPath)) {
        return [this.getDescendant(startPath)];
      } else if (!startPath && !endPath) {
        return this.getTextsAsArray();
      }

      var startIndex = startPath ? startPath.get(0, 0) : 0;
      var endIndex = endPath ? endPath.get(0, this.nodes.size - 1) : this.nodes.size - 1;

      var array = [];

      this.nodes.slice(startIndex, endIndex + 1).forEach(function (node, i) {
        if (node.object === 'text') {
          array.push(node);
        } else {
          // For the node at start and end of this list, we want to provide a start and end path
          // For other nodes, we can just get all their text nodes, they are between the paths
          var childStartPath = startPath && i === 0 ? PathUtils.drop(startPath) : null;
          var childEndPath = endPath && i === endIndex - startIndex ? PathUtils.drop(endPath) : null;

          array = array.concat(node.getTextsBetweenPathPositionsAsArray(childStartPath, childEndPath));
        }
      });

      return array;
    }
  }, {
    key: 'getFurthestAncestor',
    value: function getFurthestAncestor(path) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getFurthestAncestor` method has been renamed to `getFurthestChild`.');

      return this.getFurthestChild(path);
    }
  }, {
    key: 'getLeafBlocksAtRangeAsArray',
    value: function getLeafBlocksAtRangeAsArray(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getLeafBlocksAtRangeAsArray` method is deprecated.');

      range = this.resolveRange(range);
      if (range.isUnset) return [];

      var _range6 = range,
          start = _range6.start,
          end = _range6.end;


      return this.getLeafBlocksBetweenPathPositionsAsArray(start.path, end.path);
    }
  }, {
    key: 'getLeafBlocksBetweenPathPositionsAsArray',
    value: function getLeafBlocksBetweenPathPositionsAsArray(startPath, endPath) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getLeafBlocksBetweenPathPositionsAsArray` method is deprecated.');

      // PERF: the most common case is when the range is in a single block node,
      // where we can avoid a lot of iterating of the tree.
      if (startPath && endPath && PathUtils.isEqual(startPath, endPath)) {
        return [this.getClosestBlock(startPath)];
      } else if (!startPath && !endPath) {
        return this.getBlocksAsArray();
      }

      var startIndex = startPath ? startPath.get(0, 0) : 0;
      var endIndex = endPath ? endPath.get(0, this.nodes.size - 1) : this.nodes.size - 1;

      var array = [];

      this.nodes.slice(startIndex, endIndex + 1).forEach(function (node, i) {
        if (node.object !== 'block') {
          return;
        } else if (node.isLeafBlock()) {
          array.push(node);
        } else {
          var childStartPath = startPath && i === 0 ? PathUtils.drop(startPath) : null;
          var childEndPath = endPath && i === endIndex - startIndex ? PathUtils.drop(endPath) : null;

          array = array.concat(node.getLeafBlocksBetweenPathPositionsAsArray(childStartPath, childEndPath));
        }
      });

      return array;
    }
  }, {
    key: 'getBlocksAsArray',
    value: function getBlocksAsArray() {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getBlocksAsArray` method is deprecated.');

      var iterable = this.blocks({ onlyLeaves: true });
      var array = Array.from(iterable, function (_ref43) {
        var _ref44 = slicedToArray(_ref43, 1),
            node = _ref44[0];

        return node;
      });
      return array;
    }
  }, {
    key: 'getBlocksByTypeAsArray',
    value: function getBlocksByTypeAsArray(type) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getBlocksByTypeAsArray` method is deprecated.');

      var iterable = this.blocks({ onlyLeaves: true, onlyTypes: [type] });
      var array = Array.from(iterable, function (_ref45) {
        var _ref46 = slicedToArray(_ref45, 1),
            node = _ref46[0];

        return node;
      });
      return array;
    }
  }, {
    key: 'getFurthestOnlyChildAncestor',
    value: function getFurthestOnlyChildAncestor(path) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getFurthestOnlyChildAncestor` method is deprecated.');

      var ancestors = this.getAncestors(path);
      if (!ancestors) return null;

      var furthest = ancestors.rest().reverse().takeUntil(function (p) {
        return p.nodes.size > 1;
      }).last();

      return furthest || null;
    }
  }, {
    key: 'getInlinesAsArray',
    value: function getInlinesAsArray() {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getInlinesAsArray` method is deprecated.');

      var array = Array.from(this.inlines({ onlyLeaves: true }), function (_ref47) {
        var _ref48 = slicedToArray(_ref47, 1),
            node = _ref48[0];

        return node;
      });
      return array;
    }
  }, {
    key: 'getInlinesByTypeAsArray',
    value: function getInlinesByTypeAsArray(type) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getInlinesByTypeAsArray` method is deprecated.');

      var array = Array.from(this.inlines({ onlyLeaves: true, onlyTypes: [type] }), function (_ref49) {
        var _ref50 = slicedToArray(_ref49, 1),
            node = _ref50[0];

        return node;
      });
      return array;
    }
  }, {
    key: 'getLeafInlinesAtRangeAsArray',
    value: function getLeafInlinesAtRangeAsArray(range) {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getLeafInlinesAtRangeAsArray` method is deprecated.');

      range = this.resolveRange(range);
      if (range.isUnset) return [];

      var array = this.getTextsAtRangeAsArray(range).map(function (text) {
        return _this4.getClosestInline(text.key);
      }).filter(function (exists) {
        return exists;
      });

      return array;
    }
  }, {
    key: 'getOrderedMarks',
    value: function getOrderedMarks() {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getOrderedMarks` method has been folded into `getMarks`, which will now return an ordered set.');
      return this.getMarks();
    }
  }, {
    key: 'getOrderedMarksAtRange',
    value: function getOrderedMarksAtRange(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getOrderedMarksAtRange` method has been folded into `getMarksAtRange`, which will now return an ordered set.');
      return this.getMarksAtRange(range);
    }
  }, {
    key: 'getOrderedMarksByType',
    value: function getOrderedMarksByType(type) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getOrderedMarksByType` method has been folded into `getMarksByType`, which will now return an ordered set.');
      return this.getMarksByType(type);
    }
  }, {
    key: 'getMarksByTypeAsArray',
    value: function getMarksByTypeAsArray(type) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getMarksByTypeAsArray` method is deprecated.');

      var array = this.nodes.reduce(function (memo, node) {
        return node.object === 'text' ? memo.concat(node.marks.filter(function (m) {
          return m.type === type;
        })) : memo.concat(node.getMarksByTypeAsArray(type));
      }, []);

      return array;
    }
  }, {
    key: 'getMarksAsArray',
    value: function getMarksAsArray() {
      var _ref53;

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getMarksAsArray` method is deprecated.');

      var result = [];

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.texts()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ref51 = _step8.value;

          var _ref52 = slicedToArray(_ref51, 1);

          var node = _ref52[0];

          result.push(node.marks.toArray());
        }

        // PERF: use only one concat rather than multiple for speed.
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var array = (_ref53 = []).concat.apply(_ref53, result);
      return array;
    }
  }, {
    key: 'getRootInlinesAtRangeAsArray',
    value: function getRootInlinesAtRangeAsArray(range) {
      var _this5 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getRootInlinesAtRangeAsArray` method is deprecated.');

      range = this.resolveRange(range);
      if (range.isUnset) return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();

      var array = this.getTextsAtRangeAsArray(range).map(function (text) {
        return _this5.getFurthestInline(text.key);
      }).filter(function (exists) {
        return exists;
      });

      return array;
    }
  }, {
    key: 'getTextsAsArray',
    value: function getTextsAsArray() {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getTextsAsArray` method is deprecated.');

      var iterable = this.texts();
      var array = Array.from(iterable, function (_ref54) {
        var _ref55 = slicedToArray(_ref54, 1),
            node = _ref55[0];

        return node;
      });
      return array;
    }
  }, {
    key: 'getTextsAtRangeAsArray',
    value: function getTextsAtRangeAsArray(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getTextsAtRangeAsArray` method is deprecated.');

      var iterable = this.texts({ range: range });
      var array = Array.from(iterable, function (_ref56) {
        var _ref57 = slicedToArray(_ref56, 1),
            node = _ref57[0];

        return node;
      });
      return array;
    }
  }, {
    key: 'getMarksAtPosition',
    value: function getMarksAtPosition(path, offset) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getMarksAtPosition` method is deprecated.');

      path = this.resolvePath(path);
      var text = this.getDescendant(path);
      var currentMarks = text.marks;

      if (offset !== 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(currentMarks);
      }

      var closestBlock = this.getClosestBlock(path);

      // insert mark for empty block; the empty block are often created by split node or add marks in a range including empty blocks
      if (closestBlock.text === '') {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(currentMarks);
      }

      var _texts13 = this.texts({ path: path, direction: 'backward' }),
          _texts14 = slicedToArray(_texts13, 1),
          previous = _texts14[0];

      if (!previous) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])();
      }

      var _previous2 = slicedToArray(previous, 2),
          previousText = _previous2[0],
          previousPath = _previous2[1];

      if (closestBlock.hasDescendant(previousPath)) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(previousText.marks);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(currentMarks);
    }
  }, {
    key: 'getNodesAtRange',
    value: function getNodesAtRange(range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `getNodesAtRange` method has been renamed to `getDescendantsAtRange`.');

      var iterable = this.descendants({ range: range });
      var array = Array.from(iterable, function (_ref58) {
        var _ref59 = slicedToArray(_ref58, 1),
            node = _ref59[0];

        return node;
      });
      var list = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(array);
      return list;
    }
  }, {
    key: 'isNodeInRange',
    value: function isNodeInRange(path, range) {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, 'As of slate@0.47, the `isNodeInRange` method has been renamed to `isInRange`.');

      return this.isInRange(path, range);
    }
  }, {
    key: 'text',

    /**
     * Get the concatenated text of the node.
     *
     * @return {String}
     */

    get: function get$$1() {
      return this.getText();
    }
  }]);
  return ElementInterface;
}();

/**
 * Mix in assertion variants.
 */

var ASSERTS = ['Child', 'Depth', 'Descendant', 'Node', 'Parent', 'Path'];

var _loop$1 = function _loop(method) {
  ElementInterface.prototype['assert' + method] = function (path) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var ret = this['get' + method].apply(this, [path].concat(args));

    if (ret == null) {
      throw new Error('`Node.assert' + method + '` could not find node with path or key: ' + path);
    }

    return ret;
  };
};

var _iteratorNormalCompletion9 = true;
var _didIteratorError9 = false;
var _iteratorError9 = undefined;

try {
  for (var _iterator9 = ASSERTS[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
    var method$1 = _step9.value;

    _loop$1(method$1);
  }

  /**
   * Memoize read methods.
   */
} catch (err) {
  _didIteratorError9 = true;
  _iteratorError9 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion9 && _iterator9.return) {
      _iterator9.return();
    }
  } finally {
    if (_didIteratorError9) {
      throw _iteratorError9;
    }
  }
}

memoize(ElementInterface.prototype, ['getBlocksAsArray', 'getBlocksByTypeAsArray', 'getDecorations', 'getFragmentAtRange', 'getInlinesAsArray', 'getInlinesByTypeAsArray', 'getInsertMarksAtRange', 'getLeafBlocksAtRangeAsArray', 'getLeafBlocksAtRangeAsArray', 'getLeafInlinesAtRangeAsArray', 'getMarksAsArray', 'getMarksAtPosition', 'getMarksByTypeAsArray', 'getNextBlock', 'getNodesAtRange', 'getNodesToPathsMap', 'getOffset', 'getOffsetAtRange', 'getOrderedMarksBetweenPositions', 'getPreviousBlock', 'getRootBlocksAtRange', 'getRootInlinesAtRangeAsArray', 'getTextAtOffset', 'getTextDirection', 'getTextsAsArray', 'getTextsBetweenPathPositionsAsArray']);

/**
 * Mix in the element interface.
 */

mixin(ElementInterface, [Block, Document, Inline]);

/**
 * The interface that `Decoration`, `Range` and `Selection` all implement, to make
 * working anchor and focus points easier.
 *
 * @type {Class}
 */

var RangeInterface = function () {
  function RangeInterface() {
    classCallCheck(this, RangeInterface);
  }

  createClass(RangeInterface, [{
    key: 'flip',


    /**
     * Flip the range.
     *
     * @return {Range}
     */

    value: function flip() {
      var range = this.setPoints([this.focus, this.anchor]);
      return range;
    }

    /**
     * Move the anchor and focus offsets forward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveForward',
    value: function moveForward(n) {
      return this.updatePoints(function (point) {
        return point.moveForward(n);
      });
    }

    /**
     * Move the anchor and focus offsets backward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveBackward',
    value: function moveBackward(n) {
      return this.updatePoints(function (point) {
        return point.moveBackward(n);
      });
    }

    /**
     * Move the anchor offset backward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveAnchorBackward',
    value: function moveAnchorBackward(n) {
      var range = this.setAnchor(this.anchor.moveBackward(n));
      return range;
    }

    /**
     * Move the anchor offset forward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveAnchorForward',
    value: function moveAnchorForward(n) {
      var range = this.setAnchor(this.anchor.moveForward(n));
      return range;
    }

    /**
     * Move the range's anchor point to a new `path` and `offset`.
     *
     * Optionally, the `path` can be a key string, or omitted entirely in which
     * case it would be the offset number.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @return {Range}
     */

  }, {
    key: 'moveAnchorTo',
    value: function moveAnchorTo(path, offset) {
      var range = this.setAnchor(this.anchor.moveTo(path, offset));
      return range;
    }

    /**
     * Move the range's anchor point to the start of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveAnchorToStartOfNode',
    value: function moveAnchorToStartOfNode(node) {
      var range = this.setAnchor(this.anchor.moveToStartOfNode(node));
      return range;
    }

    /**
     * Move the range's anchor point to the end of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveAnchorToEndOfNode',
    value: function moveAnchorToEndOfNode(node) {
      var range = this.setAnchor(this.anchor.moveToEndOfNode(node));
      return range;
    }

    /**
     * Move the end offset backward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveEndBackward',
    value: function moveEndBackward(n) {
      var range = this.setEnd(this.end.moveBackward(n));
      return range;
    }

    /**
     * Move the end offset forward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveEndForward',
    value: function moveEndForward(n) {
      var range = this.setEnd(this.end.moveForward(n));
      return range;
    }

    /**
     * Move the range's end point to a new `path` and `offset`.
     *
     * Optionally, the `path` can be a key string, or omitted entirely in which
     * case it would be the offset number.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @return {Range}
     */

  }, {
    key: 'moveEndTo',
    value: function moveEndTo(path, offset) {
      var range = this.setEnd(this.end.moveTo(path, offset));
      return range;
    }

    /**
     * Move the range's end point to the start of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveEndToStartOfNode',
    value: function moveEndToStartOfNode(node) {
      var range = this.setEnd(this.end.moveToStartOfNode(node));
      return range;
    }

    /**
     * Move the range's end point to the end of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveEndToEndOfNode',
    value: function moveEndToEndOfNode(node) {
      var range = this.setEnd(this.end.moveToEndOfNode(node));
      return range;
    }

    /**
     * Move the focus offset backward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveFocusBackward',
    value: function moveFocusBackward(n) {
      var range = this.setFocus(this.focus.moveBackward(n));
      return range;
    }

    /**
     * Move the focus offset forward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveFocusForward',
    value: function moveFocusForward(n) {
      var range = this.setFocus(this.focus.moveForward(n));
      return range;
    }

    /**
     * Move the range's focus point to a new `path` and `offset`.
     *
     * Optionally, the `path` can be a key string, or omitted entirely in which
     * case it would be the offset number.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @return {Range}
     */

  }, {
    key: 'moveFocusTo',
    value: function moveFocusTo(path, offset) {
      var range = this.setFocus(this.focus.moveTo(path, offset));
      return range;
    }

    /**
     * Move the range's focus point to the start of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveFocusToStartOfNode',
    value: function moveFocusToStartOfNode(node) {
      var range = this.setFocus(this.focus.moveToStartOfNode(node));
      return range;
    }

    /**
     * Move the range's focus point to the end of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveFocusToEndOfNode',
    value: function moveFocusToEndOfNode(node) {
      var range = this.setFocus(this.focus.moveToEndOfNode(node));
      return range;
    }

    /**
     * Move the start offset backward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveStartBackward',
    value: function moveStartBackward(n) {
      var range = this.setStart(this.start.moveBackward(n));
      return range;
    }

    /**
     * Move the start offset forward `n` characters.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveStartForward',
    value: function moveStartForward(n) {
      var range = this.setStart(this.start.moveForward(n));
      return range;
    }

    /**
     * Move the range's start point to a new `path` and `offset`.
     *
     * Optionally, the `path` can be a key string, or omitted entirely in which
     * case it would be the offset number.
     *
     * @param {List|String} path
     * @param {Number} offset
     * @return {Range}
     */

  }, {
    key: 'moveStartTo',
    value: function moveStartTo(path, offset) {
      var range = this.setStart(this.start.moveTo(path, offset));
      return range;
    }

    /**
     * Move the range's start point to the start of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveStartToStartOfNode',
    value: function moveStartToStartOfNode(node) {
      var range = this.setStart(this.start.moveToStartOfNode(node));
      return range;
    }

    /**
     * Move the range's start point to the end of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveStartToEndOfNode',
    value: function moveStartToEndOfNode(node) {
      var range = this.setStart(this.start.moveToEndOfNode(node));
      return range;
    }

    /**
     * Move range's points to a new `path` and `offset`.
     *
     * @param {Number} n
     * @return {Range}
     */

  }, {
    key: 'moveTo',
    value: function moveTo(path, offset) {
      return this.updatePoints(function (point) {
        return point.moveTo(path, offset);
      });
    }

    /**
     * Move the focus point to the anchor point.
     *
     * @return {Range}
     */

  }, {
    key: 'moveToAnchor',
    value: function moveToAnchor() {
      var range = this.setFocus(this.anchor);
      return range;
    }

    /**
     * Move the start point to the end point.
     *
     * @return {Range}
     */

  }, {
    key: 'moveToEnd',
    value: function moveToEnd() {
      var range = this.setStart(this.end);
      return range;
    }

    /**
     * Move the range's points to the end of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveToEndOfNode',
    value: function moveToEndOfNode(node) {
      return this.updatePoints(function (point) {
        return point.moveToEndOfNode(node);
      });
    }

    /**
     * Move the anchor point to the focus point.
     *
     * @return {Range}
     */

  }, {
    key: 'moveToFocus',
    value: function moveToFocus() {
      var range = this.setAnchor(this.focus);
      return range;
    }

    /**
     * Move to the entire range of `start` and `end` nodes.
     *
     * @param {Node} start
     * @param {Node} end (optional)
     * @return {Range}
     */

  }, {
    key: 'moveToRangeOfNode',
    value: function moveToRangeOfNode(start) {
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start;

      var range = this.setPoints([this.anchor.moveToStartOfNode(start), this.focus.moveToEndOfNode(end)]);

      return range;
    }

    /**
     * Move the end point to the start point.
     *
     * @return {Range}
     */

  }, {
    key: 'moveToStart',
    value: function moveToStart() {
      var range = this.setEnd(this.start);
      return range;
    }

    /**
     * Move the range's points to the start of a `node`.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'moveToStartOfNode',
    value: function moveToStartOfNode(node) {
      return this.updatePoints(function (point) {
        return point.moveToStartOfNode(node);
      });
    }

    /**
     * Normalize the range, relative to a `node`, ensuring that the anchor
     * and focus nodes of the range always refer to leaf text nodes.
     *
     * @param {Node} node
     * @return {Range}
     */

  }, {
    key: 'normalize',
    value: function normalize(node) {
      return this.updatePoints(function (point) {
        return point.normalize(node);
      });
    }

    /**
     * Set the anchor point to a new `anchor`.
     *
     * @param {Point} anchor
     * @return {Range}
     */

  }, {
    key: 'setAnchor',
    value: function setAnchor(anchor) {
      var range = this.set('anchor', anchor);
      return range;
    }

    /**
     * Set the end point to a new `point`.
     *
     * @param {Point} point
     * @return {Range}
     */

  }, {
    key: 'setEnd',
    value: function setEnd(point) {
      var range = this.isBackward ? this.setAnchor(point) : this.setFocus(point);
      return range;
    }

    /**
     * Set the focus point to a new `focus`.
     *
     * @param {Point} focus
     * @return {Range}
     */

  }, {
    key: 'setFocus',
    value: function setFocus(focus) {
      var range = this.set('focus', focus);
      return range;
    }

    /**
     * Set the anchor and focus points to new `values`.
     *
     * @param {Array<Point>} values
     * @return {Range}
     */

  }, {
    key: 'setPoints',
    value: function setPoints(values) {
      var _values = slicedToArray(values, 2),
          anchor = _values[0],
          focus = _values[1];

      var range = this.set('anchor', anchor).set('focus', focus);
      return range;
    }

    /**
     * Set the anchor and focus points with `updater` callback
     *
     * @param {Function} updater
     * @return {Range}
     */

  }, {
    key: 'updatePoints',
    value: function updatePoints(updater) {
      var anchor = this.anchor,
          focus = this.focus;

      anchor = updater(anchor);
      focus = updater(focus);
      return this.merge({ anchor: anchor, focus: focus });
    }

    /**
     * Set the start point to a new `point`.
     *
     * @param {Point} point
     * @return {Range}
     */

  }, {
    key: 'setStart',
    value: function setStart(point) {
      var range = this.isBackward ? this.setFocus(point) : this.setAnchor(point);
      return range;
    }

    /**
     * Set new `properties` on the range.
     *
     * @param {Object|Range} properties
     * @return {Range}
     */

  }, {
    key: 'setProperties',
    value: function setProperties(properties) {
      properties = Range.createProperties(properties);
      var _properties = properties,
          anchor = _properties.anchor,
          focus = _properties.focus,
          props = objectWithoutProperties(_properties, ['anchor', 'focus']);


      if (anchor) {
        props.anchor = Point.create(anchor);
      }

      if (focus) {
        props.focus = Point.create(focus);
      }

      var range = this.merge(props);
      return range;
    }

    /**
     * Return a JSON representation of the range.
     *
     * @param {Object} options
     * @return {Object}
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        anchor: this.anchor.toJSON(options),
        focus: this.focus.toJSON(options)
      };

      return object;
    }

    /**
     * Return a `Range` instance from any range-like instance.
     *
     * @return {Range}
     */

  }, {
    key: 'toRange',
    value: function toRange() {
      var properties = Range.createProperties(this);
      var range = Range.create(properties);
      return range;
    }

    /**
     * Unset the range.
     *
     * @return {Range}
     */

  }, {
    key: 'unset',
    value: function unset() {
      var range = this.updatePoints(function (p) {
        return p.unset();
      });
      return range;
    }
  }, {
    key: 'isCollapsed',

    /**
     * Check whether the range is collapsed.
     *
     * @return {Boolean}
     */

    get: function get$$1() {
      return this.anchor === this.focus || this.anchor.key === this.focus.key && this.anchor.offset === this.focus.offset;
    }

    /**
     * Check whether the range is expanded.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isExpanded',
    get: function get$$1() {
      return !this.isCollapsed;
    }

    /**
     * Check whether the range is backward.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isBackward',
    get: function get$$1() {
      var isUnset = this.isUnset,
          anchor = this.anchor,
          focus = this.focus;


      if (isUnset) {
        return null;
      }

      if (anchor.key === focus.key) {
        return anchor.offset > focus.offset;
      }

      var isBackward = PathUtils.isBefore(focus.path, anchor.path);
      return isBackward;
    }

    /**
     * Check whether the range is forward.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isForward',
    get: function get$$1() {
      var isBackward = this.isBackward;

      var isForward = isBackward == null ? null : !isBackward;
      return isForward;
    }

    /**
     * Check whether the range isn't set.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isUnset',
    get: function get$$1() {
      var anchor = this.anchor,
          focus = this.focus;

      var isUnset = anchor.isUnset || focus.isUnset;
      return isUnset;
    }

    /**
     * Check whether the range is set.
     *
     * @return {Boolean}
     */

  }, {
    key: 'isSet',
    get: function get$$1() {
      return !this.isUnset;
    }

    /**
     * Get the start point.
     *
     * @return {String}
     */

  }, {
    key: 'start',
    get: function get$$1() {
      return this.isBackward ? this.focus : this.anchor;
    }

    /**
     * Get the end point.
     *
     * @return {String}
     */

  }, {
    key: 'end',
    get: function get$$1() {
      return this.isBackward ? this.anchor : this.focus;
    }
  }]);
  return RangeInterface;
}();

/**
 * Mix in the range interface.
 *
 * @param {Record}
 */

mixin(RangeInterface, [Annotation, Decoration, Range, Selection]);

var index = {
  Annotation: Annotation,
  Block: Block,
  Change: Change,
  Data: Data,
  Decoration: Decoration,
  Document: Document,
  Editor: Editor,
  Inline: Inline,
  KeyUtils: KeyUtils,
  Leaf: Leaf$1,
  Mark: Mark,
  Node: Node,
  Operation: Operation,
  PathUtils: PathUtils,
  Point: Point,
  Range: Range,
  resetMemoization: resetMemoization,
  Selection: Selection,
  Text: Text,
  TextUtils: TextUtils,
  useMemoization: useMemoization,
  Value: Value
};

/* unused harmony default export */ var _unused_webpack_default_export = (index);

//# sourceMappingURL=slate.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(311),
    baseAssignValue = __webpack_require__(489);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sources__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagesController__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__thumbnails__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editableItems__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pagesSelection__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__themes__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__combo__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__preprodPublication__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__externalResources__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__spreadBackground__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__history__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__configs__["a"]; });
















var editor = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    type: __WEBPACK_IMPORTED_MODULE_5__ui__["h" /* type */],
    parentFolderId: __WEBPACK_IMPORTED_MODULE_1__sources__["c" /* parentFolderId */],
    label: __WEBPACK_IMPORTED_MODULE_5__ui__["e" /* label */],
    pagesController: __WEBPACK_IMPORTED_MODULE_3__pagesController__["a" /* pagesController */],
    paths: __WEBPACK_IMPORTED_MODULE_1__sources__["d" /* paths */],
    pages: __WEBPACK_IMPORTED_MODULE_1__sources__["b" /* pages */],
    previewPages: __WEBPACK_IMPORTED_MODULE_1__sources__["e" /* previewPages */],
    resources: __WEBPACK_IMPORTED_MODULE_1__sources__["g" /* resources */],
    configs: __WEBPACK_IMPORTED_MODULE_2__configs__["b" /* configs */],
    editableTextFields: __WEBPACK_IMPORTED_MODULE_6__editableItems__["h" /* editableTextFields */],
    editableMedia: __WEBPACK_IMPORTED_MODULE_6__editableItems__["f" /* editableMedia */],
    editableLinks: __WEBPACK_IMPORTED_MODULE_6__editableItems__["e" /* editableLinks */],
    editableButtons: __WEBPACK_IMPORTED_MODULE_6__editableItems__["b" /* editableButtons */],
    editableIframes: __WEBPACK_IMPORTED_MODULE_6__editableItems__["d" /* editableIframes */],
    editableEnrichments: __WEBPACK_IMPORTED_MODULE_6__editableItems__["c" /* editableEnrichments */],
    editableSliders: __WEBPACK_IMPORTED_MODULE_6__editableItems__["g" /* editableSliders */],
    themedItems: __WEBPACK_IMPORTED_MODULE_6__editableItems__["i" /* themedItems */],
    duplicatedItemsInSpread: __WEBPACK_IMPORTED_MODULE_6__editableItems__["a" /* duplicatedItemsInSpread */],
    isEditorLoaded: __WEBPACK_IMPORTED_MODULE_5__ui__["d" /* isEditorLoaded */],
    editPanel: __WEBPACK_IMPORTED_MODULE_5__ui__["b" /* editPanel */],
    thumbnails: __WEBPACK_IMPORTED_MODULE_4__thumbnails__["e" /* thumbnails */],
    activeItem: __WEBPACK_IMPORTED_MODULE_5__ui__["a" /* activeItem */],
    combo: __WEBPACK_IMPORTED_MODULE_9__combo__["a" /* combo */],
    version: __WEBPACK_IMPORTED_MODULE_5__ui__["i" /* version */],
    pagesSelection: __WEBPACK_IMPORTED_MODULE_7__pagesSelection__["a" /* pagesSelection */],
    spreadZoom: __WEBPACK_IMPORTED_MODULE_5__ui__["g" /* spreadZoom */],
    spreadBackground: __WEBPACK_IMPORTED_MODULE_13__spreadBackground__["a" /* spreadBackground */],
    themes: __WEBPACK_IMPORTED_MODULE_8__themes__["b" /* themes */],
    selectedThemeId: __WEBPACK_IMPORTED_MODULE_8__themes__["a" /* selectedThemeId */],
    settings: __WEBPACK_IMPORTED_MODULE_10__settings__["a" /* settings */],
    preprodPublication: __WEBPACK_IMPORTED_MODULE_11__preprodPublication__["a" /* preprodPublication */],
    externalResources: __WEBPACK_IMPORTED_MODULE_12__externalResources__["a" /* externalResources */],
    lockedEditorPopup: __WEBPACK_IMPORTED_MODULE_5__ui__["f" /* lockedEditorPopup */],
    history: Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
        undos: __WEBPACK_IMPORTED_MODULE_14__history__["c" /* undos */],
        redos: __WEBPACK_IMPORTED_MODULE_14__history__["b" /* redos */],
    }),
    invoiceStatus: __WEBPACK_IMPORTED_MODULE_1__sources__["a" /* invoiceStatus */],
    publishPrice: __WEBPACK_IMPORTED_MODULE_1__sources__["f" /* publishPrice */],
    isAccessibleVersion: __WEBPACK_IMPORTED_MODULE_5__ui__["c" /* isAccessibleVersion */],
});


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shallowEqual; });
function shallowEqual(objA, objB, compare, compareContext) {
  var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (compareResult !== void 0) {
    return !!compareResult;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
}


//# sourceMappingURL=shallowequal.esm.js.map


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var PageOverlay = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 11;\n\tbackground: ", ";\n\t", ";\n"], ["\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 11;\n\tbackground: ", ";\n\t", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 80), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["c" /* overlayAnimation */])(props.isOpen); });
var templateObject_1;


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Selection_Toggler__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(53);





var mapStateToProps = function (state, ownProps) {
    var selection = state.selection, galleryInfos = state.galleryInfos;
    var itemId = ownProps.itemId, displayMode = ownProps.displayMode, _a = ownProps.selectionType, selectionType = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* SelectionType */].RESOURCES : _a;
    var primary = galleryInfos.template.commonStyles && galleryInfos.template.commonStyles.primary;
    var isInSelection = selection[selectionType].includes(itemId);
    var color;
    switch (displayMode) {
        case __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["c" /* ResolutionDisplayType */].Detail:
            color = primary ? primary.iconsColor : __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White;
            break;
        case __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["c" /* ResolutionDisplayType */].Card:
        case __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["c" /* ResolutionDisplayType */].Theater:
        default:
            color = isInSelection ? __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Yellow : __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White;
            break;
    }
    return { color: color, isInSelection: isInSelection };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Selection_Toggler__["a" /* SelectionToggler */]));


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return StyledHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ErrorBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return StyledSubHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCancelAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return StyledList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return StyledListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FileIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FileLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FileStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return StatusDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return StatusError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonRestart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonFileCancel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 10;\n\twidth: 320px;\n\tborder-radius: 9px 9px 0 0;\n\tbackground-color: ", ";\n\tbox-shadow: 0 2px 26px 0 ", ";\n\tcolor: ", ";\n\ttransform: ", ";\n\ttransition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 10;\n\twidth: 320px;\n\tborder-radius: 9px 9px 0 0;\n\tbackground-color: ", ";\n\tbox-shadow: 0 2px 26px 0 ", ";\n\tcolor: ", ";\n\ttransform: ", ";\n\ttransition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black, 25), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black, function (props) { return props.isDisplayed ? 'translateY(0)' : 'translateY(150%)'; });
var StyledHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tpadding: 20px;\n\tpadding-right: 15px;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\n\t> span {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tpadding: 20px;\n\tpadding-right: 15px;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\n\t> span {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"])), function (props) { return props.theme.primary.actionColor; });
var Title = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White);
var ErrorBadge = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 5px;\n\theight: 5px;\n\tmargin: 0 10px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n"], ["\n\twidth: 5px;\n\theight: 5px;\n\tmargin: 0 10px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red300);
var buttonCommonStyles = "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\tfill: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t}\n";
var Toggle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\tmargin-left: auto;\n\n\t", "\n\n\tsvg {\n\t\twidth: 11px;\n\t\theight: 11px;\n\t}\n"], ["\n\t", "\n\tmargin-left: auto;\n\n\t", "\n\n\tsvg {\n\t\twidth: 11px;\n\t\theight: 11px;\n\t}\n"])), buttonCommonStyles, function (_a) {
    var isExpanded = _a.isExpanded;
    return !isExpanded && 'transform: rotate(180deg);';
});
var ButtonClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n\n\tsvg {\n\t\twidth: 9px;\n\t\theight: 9px;\n\t}\n"], ["\n\t", "\n\n\tsvg {\n\t\twidth: 9px;\n\t\theight: 9px;\n\t}\n"])), buttonCommonStyles);
var StyledSubHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: 32px;\n\tpadding: 10px 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 16px;\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: 32px;\n\tpadding: 10px 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 16px;\n"])));
var ButtonCancelAll = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 8px;\n\tline-height: 12px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\tletter-spacing: 1.1px;\n\tcursor: pointer;\n"], ["\n\tmargin-left: auto;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 8px;\n\tline-height: 12px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\tletter-spacing: 1.1px;\n\tcursor: pointer;\n"])), function (props) { return props.theme.primary.actionColor; });
var StyledList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tmax-height: 250px;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\toverflow-y: auto;\n\n\t", "\n"], ["\n\tmax-height: 250px;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\toverflow-y: auto;\n\n\t",
    "\n"])), function () { return !__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp && "\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 4px;\n\t\t}\n\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tborder-left: 2px solid " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey400 + ";\n\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t\t}\n\t"; });
var StyledListItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 50px;\n\tpadding: 15px 20px;\n\tborder-top: 1px solid ", ";\n\tfont-size: 12px;\n\tline-height: 16px;\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 50px;\n\tpadding: 15px 20px;\n\tborder-top: 1px solid ", ";\n\tfont-size: 12px;\n\tline-height: 16px;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey300);
var FileIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tsvg {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tsvg {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.theme.primary.actionColor; });
var FileLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tmargin: 0 10px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tmargin: 0 10px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var FileStatus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: auto;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: auto;\n"])));
var StatusDone = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\tposition: relative;\n\tleft: 1px;\n\n\tsvg {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: relative;\n\tleft: 1px;\n\n\tsvg {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.theme.primary.actionColor; });
var StatusError = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 8px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-left: 8px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 8px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-left: 8px;\n\t\tfill: currentColor;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red300);
var ButtonRestart = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\t", "\n\n\tmargin-left: auto;\n\tpadding: 0;\n\tfont-size: 8px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\n\tspan {\n\t\tposition: relative;\n\t\ttop: 1px;\n\t}\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-left: 8px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\t", "\n\n\tmargin-left: auto;\n\tpadding: 0;\n\tfont-size: 8px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\n\tspan {\n\t\tposition: relative;\n\t\ttop: 1px;\n\t}\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-left: 8px;\n\t\tfill: currentColor;\n\t}\n"])), buttonCommonStyles, function (props) { return props.theme.primary.actionColor; });
var ButtonFileCancel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n\t", "\n\n\twidth: 20px;\n\theight: 20px;\n\tmargin-left: 13px;\n\tpadding: 0;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t}\n"], ["\n\t", "\n\n\twidth: 20px;\n\theight: 20px;\n\tmargin-left: 13px;\n\tpadding: 0;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t}\n"])), buttonCommonStyles, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red300);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResourceSelector__ = __webpack_require__(89);


var mapStateToProps = function (state, ownProps) {
    var item = state.importManager.byId[ownProps.id];
    return {
        isImportingFile: !!item,
        importingPercentage: item ? item.percentage : 0,
        importingError: item && item.error,
        isProcessingVideo: item && item.isProcessing,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ResourceSelector__["b" /* default */]));


/***/ }),
/* 186 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(47);
var global = __webpack_require__(57);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(188) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(75).f;
var has = __webpack_require__(105);
var TAG = __webpack_require__(45)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(191);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(45)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(106)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(109);
var call = __webpack_require__(393);
var isArrayIter = __webpack_require__(394);
var anObject = __webpack_require__(107);
var toLength = __webpack_require__(161);
var getIterFn = __webpack_require__(395);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(740);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(414);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(783);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadPreviousCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sendAuthentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return disconnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setNeedCredentials; });
/* unused harmony export setCredentials */
/* unused harmony export unsetCredentials */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateCredentials; });
/* unused harmony export redirectToAuthenticationPageIfNeeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gallery_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_localStorage_manager__ = __webpack_require__(168);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;









var AuthenticationActionKeys;
(function (AuthenticationActionKeys) {
    AuthenticationActionKeys["SET_FORM_LOGIN"] = "@@authentication/SET_FORM_LOGIN";
    AuthenticationActionKeys["SET_FORM_PASSWORD"] = "@@authentication/SET_FORM_PASSWORD";
    AuthenticationActionKeys["REQUEST_AUTHENTICATION"] = "@@authentication/REQUEST_AUTHENTICATION";
    AuthenticationActionKeys["UPDATE_CREDENTIALS"] = "@@authentication/UPDATE_CREDENTIALS";
})(AuthenticationActionKeys || (AuthenticationActionKeys = {}));
var loadPreviousCredentials = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var neededAuthenticationUserInfos, mode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getCredentials()];
            case 1:
                neededAuthenticationUserInfos = _a.sent();
                if (neededAuthenticationUserInfos && neededAuthenticationUserInfos.mode) {
                    mode = __WEBPACK_IMPORTED_MODULE_7__utils_authentication__["a" /* default */].isSaml(neededAuthenticationUserInfos.mode) && __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isIOSApp()
                        ? __assign({}, neededAuthenticationUserInfos.mode, { status: __WEBPACK_IMPORTED_MODULE_7__utils_authentication__["a" /* default */].isNotConnected(neededAuthenticationUserInfos.mode)
                                ? __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* ConnectionStatus */].NOT_CONNECTED
                                : __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* ConnectionStatus */].NEED_RECONNECT }) : neededAuthenticationUserInfos.mode;
                    dispatch(updateCredentials({
                        needCredentials: neededAuthenticationUserInfos.needCredentials,
                        login: neededAuthenticationUserInfos.login,
                        password: neededAuthenticationUserInfos.password,
                        mode: mode
                    }));
                }
                return [2 /*return*/];
        }
    });
}); }; };
var sendAuthentication = function (login, password) {
    return function (dispatch, getState) {
        var config = getState().galleryInfos.config;
        dispatch({ type: AuthenticationActionKeys.REQUEST_AUTHENTICATION });
        __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].authenticate(login, password)
            .then(function (json) {
            dispatch(resetForm());
            __WEBPACK_IMPORTED_MODULE_8__utils_localStorage_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery, login);
            __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery, login);
            dispatch(setCredentials(login, password));
        })
            .then(function () { return Object(__WEBPACK_IMPORTED_MODULE_1__Gallery_actions__["d" /* migrateAppContainerLocalStorageToIndexedDB */])(); })
            .then(function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__Gallery_actions__["c" /* initializeGallery */])());
            __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].getPathDefault());
        })
            .catch(function (response) {
            if (response.status === 401) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.login_or_password_incorrect'));
                return response;
            }
        });
    };
};
var disconnect = function () { return function (dispatch) {
    dispatch(unsetCredentials());
    dispatch(redirectToAuthenticationPageIfNeeded());
}; };
var setNeedCredentials = function (value, security, samlUrl) {
    return function (dispatch, getState) {
        var form = getState().authentication.form;
        if (form.login || form.password) {
            dispatch(resetForm());
        }
        dispatch(updateCredentials({
            needCredentials: value,
            login: '',
            password: '',
            mode: {
                method: security,
                status: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* ConnectionStatus */].NOT_CONNECTED,
                onCache: security === __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* Security */].Excel ? undefined : false,
                samlUrl: security === __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* Security */].Excel ? undefined : samlUrl
            }
        }));
        dispatch(redirectToAuthenticationPageIfNeeded());
    };
};
var setCredentials = function (login, password) { return function (dispatch) {
    dispatch(updateCredentials({
        login: login,
        password: password,
        mode: {
            method: __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* Security */].Excel,
            status: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* ConnectionStatus */].CONNECTED
        }
    }));
}; };
var unsetCredentials = function () { return function (dispatch, getState) {
    var mode = getState().authentication.userInfos.mode;
    var resetMode = mode
        ? {
            method: mode.method,
            status: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* ConnectionStatus */].NOT_CONNECTED,
            samlUrl: mode.method === __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* Security */].Excel ? undefined : '',
            onCache: mode.method === __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* Security */].Excel ? undefined : false
        }
        : undefined;
    dispatch(updateCredentials({
        needCredentials: true,
        login: '',
        password: '',
        mode: resetMode
    }));
}; };
var resetForm = function () { return function (dispatch) {
    dispatch({
        type: AuthenticationActionKeys.SET_FORM_LOGIN,
        value: '',
    });
    dispatch({
        type: AuthenticationActionKeys.SET_FORM_PASSWORD,
        value: '',
    });
}; };
function storeCredentials(userInfos) {
    __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].setCredentials(userInfos).then();
}
var updateCredentials = function (updateCredentialsArgs) { return function (dispatch, getState) {
    var newCredentialsState = getState().authentication.userInfos;
    newCredentialsState.needCredentials = updateCredentialsArgs.needCredentials !== undefined
        ? updateCredentialsArgs.needCredentials
        : newCredentialsState.needCredentials;
    newCredentialsState.login = updateCredentialsArgs.login !== undefined
        ? updateCredentialsArgs.login
        : newCredentialsState.login;
    newCredentialsState.password = updateCredentialsArgs.password !== undefined
        ? updateCredentialsArgs.password
        : newCredentialsState.password;
    newCredentialsState.mode = updateCredentialsArgs.mode !== undefined
        ? updateCredentialsArgs.mode
        : newCredentialsState.mode;
    storeCredentials(newCredentialsState);
    dispatch({
        type: AuthenticationActionKeys.UPDATE_CREDENTIALS,
        userInfos: newCredentialsState,
    });
}; };
var redirectToAuthenticationPageIfNeeded = function () { return function (dispatch, getState) {
    var authentication = getState().authentication;
    var userInfos = authentication.userInfos;
    var needCredentials = userInfos.needCredentials, mode = userInfos.mode;
    if (needCredentials && __WEBPACK_IMPORTED_MODULE_7__utils_authentication__["a" /* default */].isNotConnected(mode)) {
        __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].getPathAuthentication());
    }
}; };


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLAttribute, XMLElement, XMLNode, isFunction, isObject, ref,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ref = __webpack_require__(94), isObject = ref.isObject, isFunction = ref.isFunction;

  XMLNode = __webpack_require__(52);

  XMLAttribute = __webpack_require__(433);

  module.exports = XMLElement = (function(superClass) {
    extend(XMLElement, superClass);

    function XMLElement(parent, name, attributes) {
      XMLElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing element name");
      }
      this.name = this.stringify.eleName(name);
      this.attributes = {};
      if (attributes != null) {
        this.attribute(attributes);
      }
      if (parent.isDocument) {
        this.isRoot = true;
        this.documentObject = parent;
        parent.rootObject = this;
      }
    }

    XMLElement.prototype.clone = function() {
      var att, attName, clonedSelf, ref1;
      clonedSelf = Object.create(this);
      if (clonedSelf.isRoot) {
        clonedSelf.documentObject = null;
      }
      clonedSelf.attributes = {};
      ref1 = this.attributes;
      for (attName in ref1) {
        if (!hasProp.call(ref1, attName)) continue;
        att = ref1[attName];
        clonedSelf.attributes[attName] = att.clone();
      }
      clonedSelf.children = [];
      this.children.forEach(function(child) {
        var clonedChild;
        clonedChild = child.clone();
        clonedChild.parent = clonedSelf;
        return clonedSelf.children.push(clonedChild);
      });
      return clonedSelf;
    };

    XMLElement.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLElement.prototype.removeAttribute = function(name) {
      var attName, i, len;
      if (name == null) {
        throw new Error("Missing attribute name");
      }
      name = name.valueOf();
      if (Array.isArray(name)) {
        for (i = 0, len = name.length; i < len; i++) {
          attName = name[i];
          delete this.attributes[attName];
        }
      } else {
        delete this.attributes[name];
      }
      return this;
    };

    XMLElement.prototype.toString = function(options) {
      return this.options.writer.set(options).element(this);
    };

    XMLElement.prototype.att = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.a = function(name, value) {
      return this.attribute(name, value);
    };

    return XMLElement;

  })(XMLNode);

}).call(this);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLCData = (function(superClass) {
    extend(XMLCData, superClass);

    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text");
      }
      this.text = this.stringify.cdata(text);
    }

    XMLCData.prototype.clone = function() {
      return Object.create(this);
    };

    XMLCData.prototype.toString = function(options) {
      return this.options.writer.set(options).cdata(this);
    };

    return XMLCData;

  })(XMLNode);

}).call(this);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLComment, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLComment = (function(superClass) {
    extend(XMLComment, superClass);

    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text");
      }
      this.text = this.stringify.comment(text);
    }

    XMLComment.prototype.clone = function() {
      return Object.create(this);
    };

    XMLComment.prototype.toString = function(options) {
      return this.options.writer.set(options).comment(this);
    };

    return XMLComment;

  })(XMLNode);

}).call(this);


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDeclaration, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__(94).isObject;

  XMLNode = __webpack_require__(52);

  module.exports = XMLDeclaration = (function(superClass) {
    extend(XMLDeclaration, superClass);

    function XMLDeclaration(parent, version, encoding, standalone) {
      var ref;
      XMLDeclaration.__super__.constructor.call(this, parent);
      if (isObject(version)) {
        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
      }
      if (!version) {
        version = '1.0';
      }
      this.version = this.stringify.xmlVersion(version);
      if (encoding != null) {
        this.encoding = this.stringify.xmlEncoding(encoding);
      }
      if (standalone != null) {
        this.standalone = this.stringify.xmlStandalone(standalone);
      }
    }

    XMLDeclaration.prototype.toString = function(options) {
      return this.options.writer.set(options).declaration(this);
    };

    return XMLDeclaration;

  })(XMLNode);

}).call(this);


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__(94).isObject;

  XMLNode = __webpack_require__(52);

  XMLDTDAttList = __webpack_require__(206);

  XMLDTDEntity = __webpack_require__(207);

  XMLDTDElement = __webpack_require__(208);

  XMLDTDNotation = __webpack_require__(209);

  module.exports = XMLDocType = (function(superClass) {
    extend(XMLDocType, superClass);

    function XMLDocType(parent, pubID, sysID) {
      var ref, ref1;
      XMLDocType.__super__.constructor.call(this, parent);
      this.documentObject = parent;
      if (isObject(pubID)) {
        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
      }
      if (sysID == null) {
        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
      }
      if (pubID != null) {
        this.pubID = this.stringify.dtdPubID(pubID);
      }
      if (sysID != null) {
        this.sysID = this.stringify.dtdSysID(sysID);
      }
    }

    XMLDocType.prototype.element = function(name, value) {
      var child;
      child = new XMLDTDElement(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var child;
      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.entity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, false, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.pEntity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, true, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.notation = function(name, value) {
      var child;
      child = new XMLDTDNotation(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.toString = function(options) {
      return this.options.writer.set(options).docType(this);
    };

    XMLDocType.prototype.ele = function(name, value) {
      return this.element(name, value);
    };

    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
    };

    XMLDocType.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocType.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocType.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    XMLDocType.prototype.up = function() {
      return this.root() || this.documentObject;
    };

    return XMLDocType;

  })(XMLNode);

}).call(this);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDAttList, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLDTDAttList = (function(superClass) {
    extend(XMLDTDAttList, superClass);

    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      XMLDTDAttList.__super__.constructor.call(this, parent);
      if (elementName == null) {
        throw new Error("Missing DTD element name");
      }
      if (attributeName == null) {
        throw new Error("Missing DTD attribute name");
      }
      if (!attributeType) {
        throw new Error("Missing DTD attribute type");
      }
      if (!defaultValueType) {
        throw new Error("Missing DTD attribute default");
      }
      if (defaultValueType.indexOf('#') !== 0) {
        defaultValueType = '#' + defaultValueType;
      }
      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
      }
      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
        throw new Error("Default value only applies to #FIXED or #DEFAULT");
      }
      this.elementName = this.stringify.eleName(elementName);
      this.attributeName = this.stringify.attName(attributeName);
      this.attributeType = this.stringify.dtdAttType(attributeType);
      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
      this.defaultValueType = defaultValueType;
    }

    XMLDTDAttList.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdAttList(this);
    };

    return XMLDTDAttList;

  })(XMLNode);

}).call(this);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDEntity, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__(94).isObject;

  XMLNode = __webpack_require__(52);

  module.exports = XMLDTDEntity = (function(superClass) {
    extend(XMLDTDEntity, superClass);

    function XMLDTDEntity(parent, pe, name, value) {
      XMLDTDEntity.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing entity name");
      }
      if (value == null) {
        throw new Error("Missing entity value");
      }
      this.pe = !!pe;
      this.name = this.stringify.eleName(name);
      if (!isObject(value)) {
        this.value = this.stringify.dtdEntityValue(value);
      } else {
        if (!value.pubID && !value.sysID) {
          throw new Error("Public and/or system identifiers are required for an external entity");
        }
        if (value.pubID && !value.sysID) {
          throw new Error("System identifier is required for a public external entity");
        }
        if (value.pubID != null) {
          this.pubID = this.stringify.dtdPubID(value.pubID);
        }
        if (value.sysID != null) {
          this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        if (value.nData != null) {
          this.nData = this.stringify.dtdNData(value.nData);
        }
        if (this.pe && this.nData) {
          throw new Error("Notation declaration is not allowed in a parameter entity");
        }
      }
    }

    XMLDTDEntity.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdEntity(this);
    };

    return XMLDTDEntity;

  })(XMLNode);

}).call(this);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDElement, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLDTDElement = (function(superClass) {
    extend(XMLDTDElement, superClass);

    function XMLDTDElement(parent, name, value) {
      XMLDTDElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing DTD element name");
      }
      if (!value) {
        value = '(#PCDATA)';
      }
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
      this.name = this.stringify.eleName(name);
      this.value = this.stringify.dtdElementValue(value);
    }

    XMLDTDElement.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdElement(this);
    };

    return XMLDTDElement;

  })(XMLNode);

}).call(this);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDNotation, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLDTDNotation = (function(superClass) {
    extend(XMLDTDNotation, superClass);

    function XMLDTDNotation(parent, name, value) {
      XMLDTDNotation.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing notation name");
      }
      if (!value.pubID && !value.sysID) {
        throw new Error("Public or system identifiers are required for an external entity");
      }
      this.name = this.stringify.eleName(name);
      if (value.pubID != null) {
        this.pubID = this.stringify.dtdPubID(value.pubID);
      }
      if (value.sysID != null) {
        this.sysID = this.stringify.dtdSysID(value.sysID);
      }
    }

    XMLDTDNotation.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdNotation(this);
    };

    return XMLDTDNotation;

  })(XMLNode);

}).call(this);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLNode, XMLRaw,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLRaw = (function(superClass) {
    extend(XMLRaw, superClass);

    function XMLRaw(parent, text) {
      XMLRaw.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing raw text");
      }
      this.value = this.stringify.raw(text);
    }

    XMLRaw.prototype.clone = function() {
      return Object.create(this);
    };

    XMLRaw.prototype.toString = function(options) {
      return this.options.writer.set(options).raw(this);
    };

    return XMLRaw;

  })(XMLNode);

}).call(this);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLNode, XMLText,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLText = (function(superClass) {
    extend(XMLText, superClass);

    function XMLText(parent, text) {
      XMLText.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing element text");
      }
      this.value = this.stringify.eleText(text);
    }

    XMLText.prototype.clone = function() {
      return Object.create(this);
    };

    XMLText.prototype.toString = function(options) {
      return this.options.writer.set(options).text(this);
    };

    return XMLText;

  })(XMLNode);

}).call(this);


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLNode, XMLProcessingInstruction,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__(52);

  module.exports = XMLProcessingInstruction = (function(superClass) {
    extend(XMLProcessingInstruction, superClass);

    function XMLProcessingInstruction(parent, target, value) {
      XMLProcessingInstruction.__super__.constructor.call(this, parent);
      if (target == null) {
        throw new Error("Missing instruction target");
      }
      this.target = this.stringify.insTarget(target);
      if (value) {
        this.value = this.stringify.insValue(value);
      }
    }

    XMLProcessingInstruction.prototype.clone = function() {
      return Object.create(this);
    };

    XMLProcessingInstruction.prototype.toString = function(options) {
      return this.options.writer.set(options).processingInstruction(this);
    };

    return XMLProcessingInstruction;

  })(XMLNode);

}).call(this);


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(801)
var ieee754 = __webpack_require__(802)
var isArray = __webpack_require__(436)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(213)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelActionOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultGalleryMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultAppMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHeaderMenuModes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_menu__ = __webpack_require__(40);

var CancelActionOrigin;
(function (CancelActionOrigin) {
    CancelActionOrigin["Search"] = "search";
    CancelActionOrigin["Share"] = "share";
    CancelActionOrigin["Theater"] = "theater";
})(CancelActionOrigin || (CancelActionOrigin = {}));
var defaultGalleryMenu = {
    default: {
        burger: [
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Home },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Gallery },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Selection },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].New },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Downloads },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Parameters }
        ],
        left: [{ type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].BurgerButton }],
        center: [{ type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Logo }],
        right: [
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].SearchButton },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].ShareButton },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].DownloadButton }
        ]
    }
};
var defaultAppMenu = {
    default: {
        burger: [
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Home },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].New },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Selection },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Documents },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].SharedWithMe },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Parameters }
        ],
        left: [{ type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].BurgerButton }],
        center: [{ type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Logo }],
        right: [
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].SearchButton },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Documents },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Selection }
        ]
    },
    mobile: {
        burger: [
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].SearchButton },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Home },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].New },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Selection },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Documents },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].SharedWithMe },
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Parameters }
        ],
        left: [{ type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].BurgerButton }],
        center: [{ type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Logo }],
        right: [
            { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Selection }
        ]
    },
};
var getActionOrigin = function (isSearch) {
    return isSearch ? CancelActionOrigin.Search : CancelActionOrigin.Share;
};
var getLabel = function (origin) {
    return origin === CancelActionOrigin.Search ? 'messages.search' : 'messages.share';
};
var getActionBarMenu = function (origin) {
    var title = { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].Title, label: getLabel(origin) };
    var cancelButton = { type: __WEBPACK_IMPORTED_MODULE_0__typings_menu__["b" /* MenuItemType */].CancelButton, target: origin };
    return {
        burger: [],
        left: [],
        center: [title],
        right: [cancelButton]
    };
};
var getHeaderMenuModes = function (search, sharePanel, managerMenuModes) {
    var isShown = search.isShown;
    var isOpen = sharePanel.isOpen;
    var isActionBar = isShown || isOpen;
    return isActionBar ? getActionBarMenu(getActionOrigin(isShown)) : managerMenuModes;
};



/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AspConnexionStatus; });
/* unused harmony export initialAuthForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialCredentials; });
/* harmony export (immutable) */ __webpack_exports__["c"] = multiAppAuthenticationInfos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(67);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var AspConnexionStatus;
(function (AspConnexionStatus) {
    AspConnexionStatus["NOT_AUTHENTICATE"] = "notAuthenticate";
    AspConnexionStatus["PENDING"] = "pending";
    AspConnexionStatus["SUCCESS"] = "success";
    AspConnexionStatus["AUTH_ERROR"] = "authError";
    AspConnexionStatus["NO_APP_ERROR"] = "noMultiAppAuthenticationError";
    AspConnexionStatus["NO_COMPANY_ERROR"] = "noCompany";
})(AspConnexionStatus || (AspConnexionStatus = {}));
var initialAuthForm = {
    login: '',
    password: '',
    phone: '',
    company: '',
};
var getInitialState = function () {
    return {
        server: __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* Server */].FR,
        aspConnexionStatus: AspConnexionStatus.NOT_AUTHENTICATE,
        accessibleApps: [],
        orgAuthMethods: [],
        credentials: undefined,
        form: initialAuthForm,
        oneSessPerUser: false,
        isCheckingSession: false,
        isAnotherUserLogin: false,
        isSessionExpired: false,
    };
};
var initialCredentials = {
    login: undefined,
    password: undefined,
    token: undefined,
    company: undefined,
    method: undefined,
    lastApiCallTimestamp: undefined,
};
function multiAppAuthenticationInfos(state, action) {
    if (state === void 0) { state = getInitialState(); }
    var _a;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].RESET_STATUS:
            return __assign({}, state, { aspConnexionStatus: AspConnexionStatus.NOT_AUTHENTICATE });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].LOGIN_SUCCESS:
            return __assign({}, state, { aspConnexionStatus: AspConnexionStatus.SUCCESS });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].LOGIN_ERROR:
            return __assign({}, state, { aspConnexionStatus: action.status });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].COMPANY_ERROR:
            return __assign({}, state, { aspConnexionStatus: AspConnexionStatus.NO_COMPANY_ERROR });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].LOGOUT:
            return getInitialState();
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].UPDATE_CLIENT:
            return __assign({}, state, { clientId: action.clientId });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].UPDATE_ACCESSIBLE_APPS:
            return __assign({}, state, { accessibleApps: action.accessibleApps });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].UPDATE_AUTH_METHODS:
            return __assign({}, state, { orgAuthMethods: action.orgAuthMethods });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].UPDATE_CREDENTIALS:
            return __assign({}, state, { credentials: action.credentials });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].UPDATE_SERVER:
            return __assign({}, state, { server: action.server });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].SET_FORM_VALUE:
            return __assign({}, state, { form: __assign({}, state.form, (_a = {}, _a[action.input] = action.value, _a)) });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].SET_SESSION_CHECKING:
            return __assign({}, state, { oneSessPerUser: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].TOGGLE_CHECK_SESSION_STATUS:
            return __assign({}, state, { isCheckingSession: action.isCheckingSession });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].SET_ANOTHER_USER_LOGIN:
            return __assign({}, state, { isAnotherUserLogin: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MultiAppAuthenticationInfosActionKeys */].SET_SESSION_EXPIRED:
            return __assign({}, state, { isSessionExpired: true });
        default:
            return state;
    }
}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(828);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function requirePromise() {
	if (typeof Promise !== 'function') {
		throw new TypeError('`Promise.allSettled` requires a global `Promise` be available.');
	}
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(836);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuItemType; });
var ContextualMenuItemType;
(function (ContextualMenuItemType) {
    ContextualMenuItemType["SetAsTemplate"] = "SetAsTemplate";
    ContextualMenuItemType["RemoveTemplate"] = "RemoveTemplate";
    ContextualMenuItemType["Download"] = "Download";
    ContextualMenuItemType["Delete"] = "Delete";
    ContextualMenuItemType["Update"] = "Update";
    ContextualMenuItemType["Share"] = "Share";
    ContextualMenuItemType["ShareWithUser"] = "ShareWithUser";
    ContextualMenuItemType["Edit"] = "Edit";
    ContextualMenuItemType["PublicationSaveAs"] = "PublicationSaveAs";
    ContextualMenuItemType["ProposalNoSaveAs"] = "ProposalNoSaveAs";
    ContextualMenuItemType["Rename"] = "Rename";
    ContextualMenuItemType["EditCoverImage"] = "EditCoverImage";
    ContextualMenuItemType["DeleteFromAsp"] = "DeleteFromAsp";
    ContextualMenuItemType["Archive"] = "Archive";
    ContextualMenuItemType["CheckForUpdate"] = "CheckForUpdate";
    ContextualMenuItemType["CreateProposal"] = "CreateProposal";
    ContextualMenuItemType["CreateCustomizedProposal"] = "CreateCustomizedProposal";
})(ContextualMenuItemType || (ContextualMenuItemType = {}));



/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditableItemsActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setEditableItemsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateEditableTextField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateEditableMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateEditableLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateEditableButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateEditableIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateEditableEnrichment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateEditableSlider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return importSlides; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__history__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer_history__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ImportManager_actions__ = __webpack_require__(44);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;









var EditableItemsActionKeys;
(function (EditableItemsActionKeys) {
    EditableItemsActionKeys["SET_EDITABLE_ITEMS_DATA"] = "@@editor/editableItems/SET_EDITABLE_ITEMS_DATA";
    EditableItemsActionKeys["UPDATE_EDITABLE_TEXT_FIELD"] = "@@editor/editableItems/UPDATE_EDITABLE_TEXT_FIELD";
    EditableItemsActionKeys["UPDATE_EDITABLE_MEDIA"] = "@@editor/editableItems/UPDATE_EDITABLE_MEDIA";
    EditableItemsActionKeys["UPDATE_EDITABLE_LINK"] = "@@editor/editableItems/UPDATE_EDITABLE_LINK";
    EditableItemsActionKeys["UPDATE_EDITABLE_BUTTON"] = "@@editor/editableItems/UPDATE_EDITABLE_BUTTON";
    EditableItemsActionKeys["UPDATE_EDITABLE_IFRAME"] = "@@editor/editableItems/UPDATE_EDITABLE_IFRAME";
    EditableItemsActionKeys["UPDATE_EDITABLE_ENRICHMENT"] = "@@editor/editableItems/UPDATE_EDITABLE_ENRICHMENT";
    EditableItemsActionKeys["UPDATE_EDITABLE_SLIDER"] = "@@editor/editableItems/UPDATE_EDITABLE_SLIDER";
})(EditableItemsActionKeys || (EditableItemsActionKeys = {}));
var setEditableItemsData = function (page, data) { return ({
    type: EditableItemsActionKeys.SET_EDITABLE_ITEMS_DATA,
    page: page,
    data: data,
}); };
var updateEditableTextField = function (page, id, data, shouldAddToUndos, isAccessiblePage) {
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    if (isAccessiblePage === void 0) { isAccessiblePage = false; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableTextFields[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].TEXT_FIELD,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_TEXT_FIELD,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
        var editableTextFields = getState().editor.editableTextFields;
        var item = editableTextFields[page][id];
        var className = 'className' in item ? item.className : '';
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
        if (!isAccessiblePage) {
            dispatch(saveAdjacentPageIfNeeded(className, page));
        }
    };
};
var updateEditableMedia = function (page, id, data, shouldSave, shouldAddToUndos) {
    if (shouldSave === void 0) { shouldSave = true; }
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableMedia[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].MEDIA,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_MEDIA,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        if (shouldSave) {
            var isAccessibleVersion = getState().editor.isAccessibleVersion;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
            var editableMedia = getState().editor.editableMedia;
            var item = editableMedia[page][id];
            var className = 'className' in item ? item.className : '';
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
            if (!isAccessibleVersion) {
                dispatch(saveAdjacentPageIfNeeded(className, page));
            }
        }
    };
};
var updateEditableLink = function (page, id, data, shouldAddToUndos) {
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableLinks[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].LINK,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_LINK,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
    };
};
var updateEditableButton = function (page, id, data, shouldAddToUndos) {
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableButtons[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].BUTTON,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_BUTTON,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
        var editableButtons = getState().editor.editableButtons;
        var className = editableButtons[page][id].className;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
        dispatch(saveAdjacentPageIfNeeded(className, page));
    };
};
var updateEditableIframe = function (page, id, data, shouldAddToUndos) {
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableIframes[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].IFRAME,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_IFRAME,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
    };
};
var updateEditableEnrichment = function (page, id, data, shouldAddToUndos) {
    if (shouldAddToUndos === void 0) { shouldAddToUndos = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableEnrichments[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].ENRICHMENT,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_ENRICHMENT,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
    };
};
var updateEditableSlider = function (page, id, data, shouldSave, shouldUpdateThumbnails, shouldAddToUndos) {
    if (shouldSave === void 0) { shouldSave = true; }
    return function (dispatch, getState) {
        if (shouldAddToUndos) {
            var _a = page, _b = id, prevData = getState().editor.editableSliders[_a][_b];
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__history__["b" /* addToUndos */])({
                page: page,
                id: id,
                source: __WEBPACK_IMPORTED_MODULE_4__reducer_history__["a" /* Source */].SLIDER,
                data: __assign({}, prevData, { isEditedFromBackoffice: true }),
            }));
        }
        var action = {
            type: EditableItemsActionKeys.UPDATE_EDITABLE_SLIDER,
            page: page,
            id: id,
            data: data,
        };
        dispatch(action);
        if (shouldUpdateThumbnails) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
        }
        if (shouldSave) {
            var editableSliders = getState().editor.editableSliders;
            var className = editableSliders[page][id].className;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
            dispatch(saveAdjacentPageIfNeeded(className, page));
        }
    };
};
var saveAdjacentPageIfNeeded = function (itemClassName, page) { return function (dispatch, getState) {
    var _a = getState().editor, type = _a.type, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, duplicatedItemsInSpread = _a.duplicatedItemsInSpread;
    if (type === __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* EditorType */].HTML) {
        return;
    }
    var currentSpread = spreads[currentSpreadIndex];
    var adjacentPage = currentSpread.find(function (pageInSpread) { return pageInSpread !== page; });
    if (adjacentPage) {
        var duplicatedItemsInAdjacentPage = duplicatedItemsInSpread[adjacentPage];
        if (duplicatedItemsInAdjacentPage) {
            var hasDuplicatedItem = Object.values(duplicatedItemsInAdjacentPage).find(function (item) { return (item.className.includes(itemClassName)); });
            if (hasDuplicatedItem) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(adjacentPage));
            }
        }
    }
}; };
var importSlides = function (page, sliderId, sliderIdInConfigs, newSlidesData, isFromDesktop) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, editableSliders, _b, sliders, sliderData, prevSlides, prevImportingSlides, newImportingSlides, importingSlides, _loop_1;
    var _this = this;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getState().editor, editableSliders = _a.editableSliders, _b = page - 1, sliders = _a.configs.pagesData[_b].sliders;
                sliderData = sliders[sliderIdInConfigs];
                prevSlides = 'slides' in sliderData ? sliderData.slides : sliderData;
                prevImportingSlides = editableSliders[page][sliderId].importingSlides;
                newImportingSlides = __spread(prevImportingSlides, newSlidesData);
                dispatch(updateEditableSlider(page, sliderId, {
                    importingSlides: newImportingSlides,
                }, false));
                importingSlides = newImportingSlides;
                _loop_1 = function () {
                    var slideData, slideId, file, _a, editableSliders_1, byId, currentImportingSlides, getSlidesWithoutImportError;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                slideData = importingSlides[0];
                                if (!isFromDesktop) return [3 /*break*/, 2];
                                slideId = slideData.id, file = slideData.file;
                                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__ImportManager_actions__["h" /* importFile */])({
                                        id: slideId,
                                        file: file,
                                        isOptimizedImageImport: true,
                                        isPublicationDependency: true,
                                        onImport: function (_a) {
                                            var id = _a.id;
                                            return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0: return [4 /*yield*/, dispatch(addSlide(page, sliderId, sliderIdInConfigs, slideData, id))];
                                                        case 1: return [2 /*return*/, _b.sent()];
                                                    }
                                                });
                                            });
                                        },
                                    }))];
                            case 1:
                                _b.sent();
                                return [3 /*break*/, 4];
                            case 2: return [4 /*yield*/, dispatch(addSlide(page, sliderId, sliderIdInConfigs, slideData))];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4:
                                _a = getState(), editableSliders_1 = _a.editor.editableSliders, byId = _a.importManager.byId;
                                currentImportingSlides = editableSliders_1[page][sliderId].importingSlides;
                                getSlidesWithoutImportError = (function (_a) {
                                    var id = _a.id;
                                    return (byId[id] ? !byId[id].error : true);
                                });
                                importingSlides = currentImportingSlides.filter(getSlidesWithoutImportError);
                                return [2 /*return*/];
                        }
                    });
                };
                _c.label = 1;
            case 1:
                if (!(importingSlides.length > 0)) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _c.sent();
                return [3 /*break*/, 1];
            case 3:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__configs__["b" /* saveConfigs */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__pagesController__["c" /* savePage */])(page));
                if (prevSlides.length === 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__thumbnails__["c" /* setThumbnailsToUpdate */])([page]));
                }
                return [2 /*return*/];
        }
    });
}); }; };
var addSlide = function (page, sliderId, sliderIdInConfigs, slideData, resourceGlobalId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var slideId, globalId, aspDriveItem, type, label, relUrl, genericItemId, globalId_1, resolution, iconName, newSlideData, _a, _b, sliders, editableSliders, sliderData, slides, _c, importingSlides, deps;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                slideId = slideData.id, globalId = slideData.globalId;
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["k" /* getAspDriveItem */])(resourceGlobalId || globalId))];
            case 1:
                aspDriveItem = _d.sent();
                if (aspDriveItem) {
                    type = aspDriveItem.type, label = aspDriveItem.label, relUrl = aspDriveItem.relUrl, genericItemId = aspDriveItem.genericItemId, globalId_1 = aspDriveItem.globalId, resolution = aspDriveItem.resolution, iconName = aspDriveItem.iconName;
                    newSlideData = __assign({}, slideData, { type: type,
                        label: label, relUrl: __WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getMediaUrl */](relUrl), genericItemId: genericItemId,
                        globalId: globalId_1,
                        resolution: resolution,
                        iconName: iconName });
                    _a = getState().editor, _b = page - 1, sliders = _a.configs.pagesData[_b].sliders, editableSliders = _a.editableSliders;
                    sliderData = sliders[sliderIdInConfigs];
                    slides = 'slides' in sliderData ? sliderData.slides : sliderData;
                    _c = editableSliders[page][sliderId], importingSlides = _c.importingSlides, deps = _c.deps;
                    dispatch(updateEditableSlider(page, sliderId, {
                        importingSlides: importingSlides.filter(function (_a) {
                            var id = _a.id;
                            return id !== slideId;
                        }),
                        deps: __spread(deps, [__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* getDependencyString */](newSlideData.globalId)]),
                    }, false));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__configs__["e" /* updateEditableSliderConfig */])(page, sliderIdInConfigs, __spread(slides, [newSlideData]), false));
                    return [2 /*return*/];
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__ImportManager_actions__["d" /* addFileInImport */])(slideId, {
                        error: __WEBPACK_IMPORTED_MODULE_8__ImportManager_actions__["a" /* FileError */].IMPORT,
                    }));
                    return [2 /*return*/, { isError: true }];
                }
                return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PreviewMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackgroundMediaType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return configsDataInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return configs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isequal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_configs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_spreadBackground__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var PreviewMode;
(function (PreviewMode) {
    PreviewMode["DESKTOP"] = "desktop";
    PreviewMode["PHONE"] = "phone";
})(PreviewMode || (PreviewMode = {}));
var BackgroundMediaType;
(function (BackgroundMediaType) {
    BackgroundMediaType["IMAGE"] = "IMAGE";
    BackgroundMediaType["MOVIE"] = "MOVIE";
    BackgroundMediaType["SLIDER"] = "SLIDER";
})(BackgroundMediaType || (BackgroundMediaType = {}));
var configsDataInitialState = {
    generalData: {
        bgStyle: {},
        editablePublication: {},
    },
    pagesData: [],
};
var configs = function (state, action) {
    if (state === void 0) { state = configsDataInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_configs__["a" /* ConfigsActionKeys */].SET_CONFIGS_DATA:
            return __assign({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_1__actions_configs__["a" /* ConfigsActionKeys */].SET_EDITABLE_TEXT_FIELDS_DATA: {
            var newState = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].deepCopy(state);
            var page = action.page, data = action.data;
            var isEmptyData = Object.values(data).every(function (set) { return set.size === 0; });
            if (!isEmptyData) {
                newState.generalData.editablePublication[page].textFieldsData = data;
            }
            newState.generalData.editablePublication[page].modifiedFromBackoffice = true;
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_3__actions_spreadBackground__["a" /* SpreadBackgroundActionKeys */].SET_SPREAD_BACKGROUND: {
            var newState_1 = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].deepCopy(state);
            var spread_1 = action.spread, data_1 = action.data, isGeneralBgData_1 = action.isGeneralBgData;
            spread_1.forEach(function (page) {
                var target = newState_1.pagesData[page - 1];
                var source = isGeneralBgData_1 ? newState_1.generalData : target;
                // handle a case when bgStyle is set only on one page in spread in plugin
                if (__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isEmptyObject(source.bgStyle)) {
                    var adjacentPage = spread_1.find(function (pageInSpread) { return pageInSpread !== page; });
                    if (adjacentPage) {
                        source = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].deepCopy(state.pagesData[adjacentPage - 1]);
                    }
                    else {
                        source.bgStyle = {
                            epubStyle: {},
                        };
                    }
                }
                if (__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isEmptyObject(target.bgStyle)) {
                    target.bgStyle = {
                        epubStyle: {},
                    };
                }
                if (data_1) {
                    var _a = source.bgStyle.epubStyle, defaultBackgroundMedia = _a.defaultBackgroundMedia, backgroundMedia = _a.backgroundMedia, backgroundImage = _a.backgroundImage;
                    if (!defaultBackgroundMedia) {
                        target.bgStyle.epubStyle.defaultBackgroundMedia = backgroundMedia || backgroundImage;
                    }
                    // remove legacy option
                    if (backgroundImage) {
                        delete target.bgStyle.epubStyle.backgroundImage;
                    }
                    target.bgStyle.epubStyle.backgroundMedia = data_1;
                    var isEqualWithDefaultData = __WEBPACK_IMPORTED_MODULE_0_lodash_isequal___default()(data_1, target.bgStyle.epubStyle.defaultBackgroundMedia);
                    if (isEqualWithDefaultData) {
                        delete target.bgStyle.epubStyle.defaultBackgroundMedia;
                    }
                }
                else {
                    target.bgStyle.epubStyle.backgroundMedia = source.bgStyle.epubStyle.defaultBackgroundMedia;
                    delete target.bgStyle.epubStyle.defaultBackgroundMedia;
                }
            });
            return newState_1;
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions_configs__["a" /* ConfigsActionKeys */].UPDATE_EDITABLE_SLIDER_CONFIG: {
            var newState = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].deepCopy(state);
            var page = action.page, id = action.id, data = action.data;
            if ('slides' in newState.pagesData[page - 1].sliders[id]) {
                newState.pagesData[page - 1].sliders[id].slides = data;
            }
            else {
                newState.pagesData[page - 1].sliders[id] = data;
            }
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_2__actions_ui__["a" /* UiActionKeys */].RESET:
            return configsDataInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(134)(module)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array
/*: Array<any> | TouchList*/
, callback
/*: Function*/
)
/*: any*/
{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func
/*: any*/
)
/*: boolean %checks*/
{
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num
/*: any*/
)
/*: boolean %checks*/
{
  return typeof num === 'number' && !isNaN(num);
}

function int(a
/*: string*/
)
/*: number*/
{
  return parseInt(a, 10);
}

function dontSetMe(props
/*: Object*/
, propName
/*: string*/
, componentName
/*: string*/
) {
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VideoParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return youtubeJsApiAttribute; });
var TagName;
(function (TagName) {
    TagName["div"] = "DIV";
    TagName["img"] = "IMG";
    TagName["video"] = "VIDEO";
    TagName["iframe"] = "IFRAME";
})(TagName || (TagName = {}));
var VideoParam;
(function (VideoParam) {
    VideoParam["autoplay"] = "autoplay";
    VideoParam["controls"] = "controls";
    VideoParam["muted"] = "muted";
})(VideoParam || (VideoParam = {}));
var youtubeJsApiAttribute = 'enablejsapi';


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(143),
    isObjectLike = __webpack_require__(116);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(943),
    listCacheDelete = __webpack_require__(944),
    listCacheGet = __webpack_require__(945),
    listCacheHas = __webpack_require__(946),
    listCacheSet = __webpack_require__(947);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(487);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(949);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(228);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreprodPublicationKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setPreprodPublicationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateOriginal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return publish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPreprodPublicationUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPublishedPublicationUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;







var PreprodPublicationKeys;
(function (PreprodPublicationKeys) {
    PreprodPublicationKeys["SET_DATA"] = "@@editor/preprodPublication/SET_DATA";
    PreprodPublicationKeys["SET_IS_UPDATING"] = "@@editor/preprodPublication/SET_IS_UPDATING";
})(PreprodPublicationKeys || (PreprodPublicationKeys = {}));
var setPreprodPublicationData = function (data) { return ({
    type: PreprodPublicationKeys.SET_DATA,
    data: data,
}); };
var setIsUpdating = function (isUpdating) { return ({
    type: PreprodPublicationKeys.SET_IS_UPDATING,
    isUpdating: isUpdating,
}); };
var updateOriginal = function (tempGId, originalGId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var genericItemLastUpdate, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 4]);
                dispatch(setIsUpdating(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].updateOriginalPublication(tempGId, originalGId)];
            case 1:
                genericItemLastUpdate = (_a.sent()).genericItemLastUpdate;
                dispatch(setPreprodPublicationData({ lastUpdateDate: genericItemLastUpdate }));
                return [3 /*break*/, 4];
            case 2:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__NotificationBar_actions__["c" /* createNotification */])('error.update_publication'));
                return [3 /*break*/, 4];
            case 3:
                dispatch(setIsUpdating(false));
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var publish = function (originalGId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var resource, clientId, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 4, 5]);
                dispatch(setIsUpdating(true));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].savePublicationSettings(originalGId, {
                        accessType: __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].AssetItemAccessType.PUBLIC,
                    })];
            case 1:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].getMeta(originalGId)];
            case 2:
                resource = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["H" /* updateDriveItem */])(resource));
                clientId = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */])().clientId;
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sources__["c" /* getData */])(clientId, originalGId, true, false, true));
                return [3 /*break*/, 5];
            case 3:
                error_2 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__NotificationBar_actions__["c" /* createNotification */])('error.publish_publication'));
                return [3 /*break*/, 5];
            case 4:
                dispatch(setIsUpdating(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var getPreprodPublicationUrl = function (clientId, resourceId, label, forceUpdate) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var urlWithPin, resourceUrl, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                urlWithPin = getState().editor.preprodPublication.urlWithPin;
                if (!(!urlWithPin || forceUpdate)) return [3 /*break*/, 2];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].sharePublication(clientId, resourceId, label)];
            case 1:
                resourceUrl = (_a.sent()).resourceUrl;
                dispatch(setPreprodPublicationData({ urlWithPin: resourceUrl }));
                _a.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var getPublishedPublicationUrl = function (resourceId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var projectUrl, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].getPublicationIntegration(resourceId)];
            case 1:
                projectUrl = (_a.sent()).projectUrl;
                dispatch({
                    type: __WEBPACK_IMPORTED_MODULE_3__settings__["a" /* SettingsActionKeys */].SET_SETTINGS,
                    projectUrl: projectUrl,
                });
                return [3 /*break*/, 3];
            case 2:
                error_4 = _a.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FolderCreationPanelActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;






var FolderCreationPanelActionKeys;
(function (FolderCreationPanelActionKeys) {
    FolderCreationPanelActionKeys["OPEN_PANEL"] = "@@folderCreationPanel/OPEN_PANEL";
    FolderCreationPanelActionKeys["CLOSE_PANEL"] = "@@folderCreationPanel/CLOSE_PANEL";
    FolderCreationPanelActionKeys["SET_NAME"] = "@@folderCreationPanel/SET_NAME";
})(FolderCreationPanelActionKeys || (FolderCreationPanelActionKeys = {}));
var openPanel = function (useSelection) {
    if (useSelection === void 0) { useSelection = false; }
    return function (dispatch) {
        var action = {
            type: FolderCreationPanelActionKeys.OPEN_PANEL,
            useSelection: useSelection,
        };
        dispatch(action);
    };
};
var closePanel = function () { return function (dispatch) {
    var action = {
        type: FolderCreationPanelActionKeys.CLOSE_PANEL,
    };
    dispatch(action);
}; };
var setName = function (name) { return function (dispatch) {
    var action = {
        type: FolderCreationPanelActionKeys.SET_NAME,
        name: name
    };
    dispatch(action);
}; };
var createFolder = function (name, useSelection) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var isOnline, parentFolderId, selectionIds, contentIds, newFolderId, newFolderItem, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_userAgent__["a" /* default */].isOnlinePromise()];
            case 1:
                isOnline = _a.sent();
                parentFolderId = __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getFolderIdForNewResource();
                if (!(isOnline && parentFolderId)) return [3 /*break*/, 8];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 7]);
                selectionIds = getState().selection.resources;
                contentIds = useSelection ? selectionIds : [];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */].createPrivateFolder(parentFolderId, name, contentIds)];
            case 3:
                newFolderId = _a.sent();
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(parentFolderId, true, true, true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(newFolderId))];
            case 5:
                newFolderItem = _a.sent();
                dispatch(closePanel());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__["L" /* viewDriveItem */])(newFolderItem, __WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__["c" /* DriveItemOrigin */].List));
                if (useSelection) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__Selection_actions__["c" /* clearSelection */])(__WEBPACK_IMPORTED_MODULE_4__Selection_actions__["b" /* SelectionType */].RESOURCES));
                }
                return [3 /*break*/, 7];
            case 6:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.cant_create_folder'));
                dispatch(closePanel());
                return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 9];
            case 8:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('info.offline_create_folder'));
                dispatch(closePanel());
                _a.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}); }; };



/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INITIAL_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INITIAL_TOTAL_PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ZOOM_STEP; });
var INITIAL_PAGE = 1;
var INITIAL_TOTAL_PAGES = 1;
var DEFAULT_WIDTH = 1000;
var DEFAULT_HEIGHT = 1000;
var ZOOM_STEP = 0.2;


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoSaveAsPopupActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeNoSaveAsPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openNoSaveAsPopup; });
var NoSaveAsPopupActionKeys;
(function (NoSaveAsPopupActionKeys) {
    NoSaveAsPopupActionKeys["CLOSE"] = "@@NoSaveAsPopup/CLOSE";
    NoSaveAsPopupActionKeys["OPEN"] = "@@NoSaveAsPopup/OPEN";
})(NoSaveAsPopupActionKeys || (NoSaveAsPopupActionKeys = {}));
var closeNoSaveAsPopup = function () {
    return function (dispatch) {
        var action = {
            type: NoSaveAsPopupActionKeys.CLOSE,
        };
        dispatch(action);
    };
};
var openNoSaveAsPopup = function () {
    return function (dispatch) {
        var action = {
            type: NoSaveAsPopupActionKeys.OPEN,
        };
        dispatch(action);
    };
};



/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProposalStatsActionKeys; });
/* unused harmony export setIsLoading */
/* unused harmony export setPaginatorData */
/* unused harmony export setNewPage */
/* unused harmony export addPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setProposalStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MultiAppAuthentication_actions__ = __webpack_require__(34);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;







var ProposalStatsActionKeys;
(function (ProposalStatsActionKeys) {
    ProposalStatsActionKeys["SET_IS_LOADING"] = "@@proposalStats/SET_IS_LOADING";
    ProposalStatsActionKeys["SET_PROPOSAL_STATUS"] = "@@proposalStats/SET_PROPOSAL_STATUS";
    ProposalStatsActionKeys["SET_PAGINATOR_DATA"] = "@@proposalStats/SET_PAGINATOR_DATA";
    ProposalStatsActionKeys["SET_NEW_PAGE"] = "@@proposalState/SET_NEW_PAGE";
    ProposalStatsActionKeys["ADD_PAGE"] = "@@proposalStats/ADD_PAGE";
    ProposalStatsActionKeys["SORT"] = "@@proposalStats/SORT";
    ProposalStatsActionKeys["RESET"] = "@@proposalStats/RESET";
})(ProposalStatsActionKeys || (ProposalStatsActionKeys = {}));
var setIsLoading = function (isLoading) { return ({
    type: ProposalStatsActionKeys.SET_IS_LOADING,
    isLoading: isLoading,
}); };
var setPaginatorData = function (data) { return ({
    type: ProposalStatsActionKeys.SET_PAGINATOR_DATA,
    data: data,
}); };
var setNewPage = function () { return ({
    type: ProposalStatsActionKeys.SET_NEW_PAGE,
}); };
var addPage = function (list) { return ({
    type: ProposalStatsActionKeys.ADD_PAGE,
    list: list,
}); };
var getProposals = function (page) {
    if (page === void 0) { page = 0; }
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var _a, clientId, _b, proposalStatus, _c, sortOn, ascending, paginator, _d, currentPage, totalPage, list, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, 3, 4]);
                    dispatch(setIsLoading(true));
                    dispatch(setPaginatorData({
                        page: page,
                    }));
                    _a = getState(), clientId = _a.galleryInfos.config.clientId, _b = _a.proposalStats, proposalStatus = _b.proposalStatus, _c = _b.sort, sortOn = _c.sortOn, ascending = _c.ascending, paginator = _b.paginator;
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getProposalsByType(clientId, proposalStatus, sortOn, ascending, page, paginator.itemsPerPage)];
                case 1:
                    _d = _e.sent(), currentPage = _d.currentPage, totalPage = _d.totalPage, list = _d.list;
                    if (page === 0) {
                        dispatch(setNewPage());
                    }
                    dispatch(setPaginatorData({
                        page: currentPage,
                        totalPages: totalPage,
                    }));
                    dispatch(addPage(list));
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _e.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.fetch_proposal_stats_error'));
                    return [3 /*break*/, 4];
                case 3:
                    dispatch(setIsLoading(false));
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var setProposalStatus = function (status) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: ProposalStatsActionKeys.SET_PROPOSAL_STATUS,
                    status: status,
                });
                return [4 /*yield*/, dispatch(getProposals())];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.fetch_proposal_stats_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var sort = function (sort) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: ProposalStatsActionKeys.SORT,
                    sort: sort,
                });
                return [4 /*yield*/, dispatch(getProposals())];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('error.fetch_proposal_stats_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var reset = function () { return ({
    type: ProposalStatsActionKeys.RESET,
}); };
var openPreview = function (relUrl, type) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var config, relUrlIdOrFile, id, url, driveItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = getState().galleryInfos.config;
                relUrlIdOrFile = relUrl.split('/')[1];
                id = parseFloat(relUrlIdOrFile);
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__MultiAppAuthentication_actions__["b" /* checkActiveSession */])())];
            case 1:
                _a.sent();
                url = '';
                if (type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].AssetItemFileTypes.PUBLICATION) {
                    driveItem = {
                        id: id,
                    };
                    url = __WEBPACK_IMPORTED_MODULE_5__utils_url__["b" /* default */].getPublicationUrl(config, driveItem, 1, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp);
                }
                else {
                    url = __WEBPACK_IMPORTED_MODULE_5__utils_url__["b" /* default */].getItemOriginalFileUrl(config, relUrlIdOrFile);
                }
                if (type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].AssetItemFileTypes.PUBLICATION && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp) {
                    __WEBPACK_IMPORTED_MODULE_4__utils_nativeApi__["b" /* default */].openFrame(url);
                }
                else {
                    window.open(url);
                }
                return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotesStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createNamedWrapperReducer__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var _a;




var NotesStatus;
(function (NotesStatus) {
    NotesStatus["LOCAL"] = "LOCAL";
    NotesStatus["SHARED"] = "SHARED";
})(NotesStatus || (NotesStatus = {}));
var LoadingStatus;
(function (LoadingStatus) {
    LoadingStatus["NOT_LOADED"] = "NOT_LOADED";
    LoadingStatus["LOADING"] = "LOADING";
    LoadingStatus["SAVING"] = "SAVING";
    LoadingStatus["LOADED"] = "LOADED";
})(LoadingStatus || (LoadingStatus = {}));
var defaultCurrentStatusState = NotesStatus.LOCAL;
var defaultEditorState = {
    isOpened: false,
};
var defaultLoadingStatusState = LoadingStatus.NOT_LOADED;
var byId = function (state, action) {
    if (state === void 0) { state = {}; }
    var _a, _b;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].SET:
            return __assign({}, state, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].itemsToById(action.items));
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].RESET:
            return {};
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].CREATE:
            return __assign({}, state, (_a = {}, _a[action.id] = action.data, _a));
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].UPDATE:
            return __assign({}, state, (_b = {}, _b[action.id] = __assign({}, state[action.id], action.data), _b));
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].REMOVE: {
            var _c = action.id, id = state[_c], rest = __rest(state, [typeof _c === "symbol" ? _c : _c + ""]);
            return __assign({}, rest);
        }
        default:
            return state;
    }
};
var currentStatus = function (state, action) {
    if (state === void 0) { state = defaultCurrentStatusState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].SET_STATUS:
            return action.status;
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].RESET:
            return defaultCurrentStatusState;
        default:
            return state;
    }
};
var editor = function (state, action) {
    if (state === void 0) { state = defaultEditorState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].TOGGLE_EDITOR:
            return __assign({}, state, { isOpened: !state.isOpened, noteId: action.id });
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].RESET:
            return defaultEditorState;
        default:
            return state;
    }
};
var loadingStatus = function (state, action) {
    if (state === void 0) { state = defaultLoadingStatusState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].SET_LOADING_STATUS:
            return action.status;
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NotesActionKeys */].RESET:
            return defaultLoadingStatusState;
        default:
            return state;
    }
};
var notes = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_a = {},
    _a[NotesStatus.LOCAL] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_createNamedWrapperReducer__["a" /* createNamedWrapperReducer */])(byId, NotesStatus.LOCAL),
    _a[NotesStatus.SHARED] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_createNamedWrapperReducer__["a" /* createNamedWrapperReducer */])(byId, NotesStatus.SHARED),
    _a.currentStatus = currentStatus,
    _a.editor = editor,
    _a.loadingStatus = loadingStatus,
    _a));


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = createDragDropActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__beginDrag__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__publishDragSource__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hover__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drop__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__endDrag__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(122);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__types__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__types__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__types__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__types__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__types__["f"]; });






function createDragDropActions(manager) {
  return {
    beginDrag: Object(__WEBPACK_IMPORTED_MODULE_0__beginDrag__["a" /* default */])(manager),
    publishDragSource: Object(__WEBPACK_IMPORTED_MODULE_1__publishDragSource__["a" /* default */])(manager),
    hover: Object(__WEBPACK_IMPORTED_MODULE_2__hover__["a" /* default */])(manager),
    drop: Object(__WEBPACK_IMPORTED_MODULE_3__drop__["a" /* default */])(manager),
    endDrag: Object(__WEBPACK_IMPORTED_MODULE_4__endDrag__["a" /* default */])(manager)
  };
}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_TARGET; });
/* harmony export (immutable) */ __webpack_exports__["e"] = addSource;
/* harmony export (immutable) */ __webpack_exports__["f"] = addTarget;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeSource;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeTarget;
var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: targetId
    }
  };
}
function removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: targetId
    }
  };
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = registerTarget;
/* harmony export (immutable) */ __webpack_exports__["a"] = registerSource;
function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}
function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItemBadge; });
/* unused harmony export MenuItemSeparator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledMenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledMenuItemLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var MenuItemSeparator = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: calc(100% - 15px);\n\theight: 1px;\n\tbackground: ", ";\n"], ["\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: calc(100% - 15px);\n\theight: 1px;\n\tbackground: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50);
var StyledMenuItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tfont-weight: 600;\n\n\t> a {\n\t\tcolor: ", ";\n\n\t\t> svg {\n\t\t\tfill:", ";\n\t\t}\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 21px;\n\t\tright: 0;\n\t\theight: 1px;\n\t\tbackground-color: ", ";\n\n\t\t@media ", " {\n\t\t\tleft: 32px;\n\t\t}\n\t}\n\n\t", ";\n"], ["\n\tposition: relative;\n\tfont-weight: 600;\n\n\t> a {\n\t\tcolor: ", ";\n\n\t\t> svg {\n\t\t\tfill:", ";\n\t\t}\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 21px;\n\t\tright: 0;\n\t\theight: 1px;\n\t\tbackground-color: ", ";\n\n\t\t@media ", " {\n\t\t\tleft: 32px;\n\t\t}\n\t}\n\n\t",
    ";\n"])), function (props) { return props.isActive ? props.theme.primary.actionColor : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey800; }, function (props) { return props.isActive || props.isBold ? props.theme.primary.actionColor : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey800; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape, function (props) { return props.isActive && "\n\t\t:before {\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\tz-index: 1;\n\t\t\tleft: 0;\n\t\t\ttop: 6px;\n\t\t\twidth: calc(100% - 12px);\n\t\t\theight: calc(100% - 12px);\n\t\t\tbackground-color: " + props.theme.primary.actionColor + ";\n\t\t\topacity: 0.2;\n\t\t\tborder-radius: 0 30px 30px 0;\n\t\t}"; });
var StyledMenuItemLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('a')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tposition: relative;\n\tz-index: 2;\n\talign-items: center;\n\tpadding: 21px;\n\ttext-decoration: none;\n\tcursor: pointer;\n\tfont-size: 13px;\n\n\t@media ", " {\n\t\tpadding-left: 32px;\n\t}\n\n\t> img {\n\t\tmax-height: 18px;\n\t\tmax-width: 100%;\n\t\tmin-width: 18px;\n\t\tmargin-right: 15px;\n\t\tflex-shrink: 0;\n\t}\n\n\t> svg {\n\t\theight: 18px;\n\t\twidth: 18px;\n\t\tmargin-right: 15px;\n\t\tflex-shrink: 0;\n\t}\n"], ["\n\tdisplay: flex;\n\tposition: relative;\n\tz-index: 2;\n\talign-items: center;\n\tpadding: 21px;\n\ttext-decoration: none;\n\tcursor: pointer;\n\tfont-size: 13px;\n\n\t@media ", " {\n\t\tpadding-left: 32px;\n\t}\n\n\t> img {\n\t\tmax-height: 18px;\n\t\tmax-width: 100%;\n\t\tmin-width: 18px;\n\t\tmargin-right: 15px;\n\t\tflex-shrink: 0;\n\t}\n\n\t> svg {\n\t\theight: 18px;\n\t\twidth: 18px;\n\t\tmargin-right: 15px;\n\t\tflex-shrink: 0;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape);
var MenuItemBadge = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tpadding-left: 15px;\n\tfont-size: 13px;\n\tfont-weight: 300;\n\ttext-align: right;\n\tposition: absolute;\n\tright: 30px;\n\ttop: 50%;\n\ttransform: translate(0, -50%);\n\tcolor: ", ";\n\tletter-spacing: -0.15px;\n\n\t:before {\n\t\tcontent: '';\n\t\twidth: 9px;\n\t\theight: 9px;\n\t\tborder-radius: 50%;\n\t\tbackground: ", ";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 3px;\n\t}\n"], ["\n\tdisplay: inline-block;\n\tpadding-left: 15px;\n\tfont-size: 13px;\n\tfont-weight: 300;\n\ttext-align: right;\n\tposition: absolute;\n\tright: 30px;\n\ttop: 50%;\n\ttransform: translate(0, -50%);\n\tcolor: ", ";\n\tletter-spacing: -0.15px;\n\n\t:before {\n\t\tcontent: '';\n\t\twidth: 9px;\n\t\theight: 9px;\n\t\tborder-radius: 50%;\n\t\tbackground: ", ";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 3px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800, function (props) { return props.theme.primary.actionColor; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledHeaderButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TextButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledCancelButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledBurgerButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledHeaderButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t& > svg {\n\t\t", "\n\t\tfill: ", ";\n\t}\n\n\t& > img {\n\t\theight: 100%;\n\t\tmax-height: 30px;\n\t\tmin-width: 30px;\n\t}\n"], ["\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t& > svg {\n\t\t", "\n\t\tfill: ",
    ";\n\t}\n\n\t& > img {\n\t\theight: 100%;\n\t\tmax-height: 30px;\n\t\tmin-width: 30px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["g" /* navBarButtonWrapperStyle */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["i" /* navBarIconStyle */], function (props) { return props.isActive
    ? props.theme.primary.actionColor
    : props.theme.primary.iconsColor; });
var StyledBurgerButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(StyledHeaderButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 25px;\n\twidth: 25px;\n"], ["\n\theight: 25px;\n\twidth: 25px;\n"])));
var TextButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\theight: 30px;\n\tline-height: 30px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tmargin: 0 5px;\n\tcursor: pointer;\n"], ["\n\theight: 30px;\n\tline-height: 30px;\n\tcolor: ",
    ";\n\tbackground-color: ", ";\n\tmargin: 0 5px;\n\tcursor: pointer;\n"])), function (props) { return props.isActive
    ? props.theme.primary.actionColor
    : props.theme.primary.iconsColor; }, function (props) { return props.theme.primary.topnavColor; });
var StyledCancelButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tcursor: pointer;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\ttext-decoration: none;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tpadding: 6px 20px 0;\n"], ["\n\tcursor: pointer;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\ttext-decoration: none;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tpadding: 6px 20px 0;\n"])), function (props) { return props.isInTheater ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White : props.theme.primary.actionColor; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(1213);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlurPanel__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_customHooks_usePreviousValue__ = __webpack_require__(345);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var ResourceCreationPanel = function (_a) {
    var isOpen = _a.isOpen, icon = _a.icon, fields = _a.fields, onFieldChange = _a.onFieldChange, onConfirm = _a.onConfirm, onCancel = _a.onCancel, _b = _a.errors, errors = _b === void 0 ? {} : _b, label = _a.label, _c = _a.autoFocus, autoFocus = _c === void 0 ? true : _c;
    var inputElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](window.innerHeight), 2), windowHeight = _d[0], setWindowHeight = _d[1];
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var prevErrors = Object(__WEBPACK_IMPORTED_MODULE_7__utils_customHooks_usePreviousValue__["a" /* default */])(errors);
    var hasErrors = Object.values(errors).some(function (error) { return !!error; });
    var handleFieldChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        onFieldChange(name, value);
    };
    var handleFieldClear = function (name) {
        onFieldChange(name, '');
    };
    var handleFieldFocus = function (e) {
        fixKeyboardPush(e);
    };
    var fixKeyboardPush = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(function () {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
        }, 0);
    };
    var handleConfirm = function () {
        var isEmptyField = Object.values(fields).some(function (field) { return !field.value; });
        if (isEmptyField || hasErrors || isLoading) {
            return;
        }
        setIsLoading(true);
        if (inputElement.current) {
            inputElement.current.blur();
        }
        onConfirm(fields);
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var handleResize = function () {
            setWindowHeight(window.innerHeight);
        };
        if (isOpen) {
            // Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', handleResize);
            }
            else {
                window.addEventListener('resize', handleResize);
            }
        }
        return function () {
            if (isOpen) {
                if (window.visualViewport) {
                    window.visualViewport.removeEventListener('resize', handleResize);
                }
                else {
                    window.removeEventListener('resize', handleResize);
                }
            }
        };
    }, [isOpen]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var handleKeyDown = function (e) {
            if (__WEBPACK_IMPORTED_MODULE_6__utils_keys__["a" /* default */].isEnter(e.key)) {
                e.preventDefault();
                handleConfirm();
            }
            if (__WEBPACK_IMPORTED_MODULE_6__utils_keys__["a" /* default */].isEsc(e.key)) {
                e.preventDefault();
                onCancel();
            }
        };
        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return function () {
            if (isOpen) {
                window.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [isOpen, handleConfirm, onCancel]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isOpen && autoFocus && inputElement.current) {
            inputElement.current.focus();
        }
    }, [isOpen]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var isErrorsChanged = !__WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(errors, prevErrors);
        if ((!isOpen || isErrorsChanged) && isLoading) {
            setIsLoading(false);
        }
    }, [isOpen, isLoading, errors]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__BlurPanel__["a" /* default */], { label: label, isOpen: isOpen, onCancelClick: onCancel, onOkClick: handleConfirm },
        isLoading && !hasErrors &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* ResourceCreationLoader */], null,
                __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ResourceCreationContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ResourceCreationIcon */], { key: windowHeight, inputBoxNumber: Object.keys(fields).length }, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon(icon)),
            Object.entries(fields).map(function (_a, index) {
                var _b = __read(_a, 2), name = _b[0], _c = _b[1], value = _c.value, label = _c.label;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* ResourceCreationInputWrapper */], { key: name + "-" + index },
                    errors[name]
                        ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* ResourceCreationError */], { value: errors[name] })
                        : label && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* ResourceCreationInputLabel */], null, label),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* ResourceCreationInput */], { type: "text", name: name, value: value, ref: index === 0 ? inputElement : undefined, "data-error": !!errors[name], onFocus: handleFieldFocus, onChange: handleFieldChange }),
                    value &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* ResourceCreationInputClear */], { type: "button", onClick: function () { return handleFieldClear(name); } }, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_close-2'))));
            }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ResourceCreationPanel);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1236);



var Toggle = function (_a) {
    var items = _a.items, activeId = _a.activeId, onItemClick = _a.onItemClick, width = _a.width;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonsWrapper */], null, items.map(function (_a) {
            var id = _a.id, label = _a.label;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { key: id, type: "button", isActive: id === activeId, width: width, onClick: function () { return onItemClick(id); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label })));
        }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Toggle);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItem__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomMasonry__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Title__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DesktopDragPreview__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TouchDragPreview__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DragScroller__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_ImportDesktopFile_Toast__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_ImportDesktopFile_FilesDndUploader__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CoverFlow__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DisplayTypeDropdown__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TagTrail__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ButtonPDF_styles__ = __webpack_require__(1311);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





















var DriveItemList = /** @class */ (function (_super) {
    __extends(DriveItemList, _super);
    function DriveItemList(props) {
        var _this = _super.call(this, props) || this;
        _this.hasMoreDriveItems = _this.hasMoreDriveItems.bind(_this);
        _this.loadMoreDriveItems = _this.loadMoreDriveItems.bind(_this);
        _this.handleCoverFlowFolderChange = _this.handleCoverFlowFolderChange.bind(_this);
        _this.handleCoverFlowSlideChange = _this.handleCoverFlowSlideChange.bind(_this);
        _this.handleDownloadPDF = _this.handleDownloadPDF.bind(_this);
        _this.state = { page: 0 };
        return _this;
    }
    DriveItemList.prototype.componentDidMount = function () {
        var _a = this.props, shouldGetCustomTemplates = _a.shouldGetCustomTemplates, dispatch = _a.dispatch;
        if (shouldGetCustomTemplates) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["l" /* getCustomTemplatesIds */])());
        }
    };
    DriveItemList.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, driveItemIdsToDisplay = _a.driveItemIdsToDisplay, folderId = _a.folderId, displayType = _a.displayType, storeDriveItems = _a.storeDriveItems, params = _a.params, shouldResetPage = _a.shouldResetPage, isTheaterOpened = _a.isTheaterOpened, dispatch = _a.dispatch;
        var isTheaterToggled = prevProps.isTheaterOpened !== isTheaterOpened;
        var isUrlChanged = prevProps.params && params && (prevProps.params.origin !== params.origin ||
            prevProps.params.originParam !== params.originParam);
        var isDisplayTypeChanged = prevProps.displayType !== displayType;
        var isResetNeeded = !prevProps.shouldResetPage && shouldResetPage;
        if ((!isTheaterToggled && isUrlChanged) || isDisplayTypeChanged || isResetNeeded) {
            this.setState({ page: 0 });
            this.resetEditMode();
            if (this.driveItemListElement) {
                this.driveItemListElement.scrollTop = 0;
            }
        }
        var nbItemToDisplay = Math.min(this.state.page * __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["a" /* DRIVE_ITEM_LIST_PAGE_SIZE */], driveItemIdsToDisplay.length);
        driveItemIdsToDisplay
            .slice(0, nbItemToDisplay)
            .forEach(function (driveItemId) {
            if (!storeDriveItems[driveItemId]) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["i" /* fetchDriveItem */])(driveItemId, folderId));
            }
        });
        // display all drive items in Coverflow mode in mobile app (as all items are already fetched)
        var shouldDisplayAllDriveItems = __WEBPACK_IMPORTED_MODULE_14__utils_userAgent__["a" /* default */].isMobileApp && displayType === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow;
        if (shouldDisplayAllDriveItems && nbItemToDisplay > 0 && nbItemToDisplay !== driveItemIdsToDisplay.length) {
            var pageCount = Math.ceil(driveItemIdsToDisplay.length / __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["a" /* DRIVE_ITEM_LIST_PAGE_SIZE */]);
            this.setState({ page: pageCount });
        }
    };
    DriveItemList.prototype.componentWillUnmount = function () {
        this.resetEditMode();
    };
    DriveItemList.prototype.resetEditMode = function () {
        var _a = this.props, isEditMode = _a.isEditMode, dispatch = _a.dispatch;
        if (isEditMode) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["F" /* toggleEditMode */])());
        }
    };
    DriveItemList.prototype.render = function () {
        var _this = this;
        var _a = this.props, displayType = _a.displayType, driveItemIdsToDisplay = _a.driveItemIdsToDisplay, isFetching = _a.isFetching, showUnreadBadge = _a.showUnreadBadge, navigationItems = _a.navigationItems, additionalItems = _a.additionalItems, hasBottomBar = _a.hasBottomBar, title = _a.title, hasActions = _a.hasActions, hasSelectionIcon = _a.hasSelectionIcon, isMultipleSelection = _a.isMultipleSelection, selectedItemsIds = _a.selectedItemsIds, onDriveItemClick = _a.onDriveItemClick, sharedDirId = _a.sharedDirId, sourcesDirId = _a.sourcesDirId, searchConfig = _a.searchConfig, isEditMode = _a.isEditMode, isEditButtonDisplayed = _a.isEditButtonDisplayed, _b = _a.isDisplayTypeDropdownDisplayed, isDisplayTypeDropdownDisplayed = _b === void 0 ? true : _b, isPrivateDir = _a.isPrivateDir, isLoading = _a.isLoading, isFilesDndEnabled = _a.isFilesDndEnabled, shouldDisplayFilesToast = _a.shouldDisplayFilesToast, folderId = _a.folderId, params = _a.params, dispatch = _a.dispatch, storeDriveItems = _a.storeDriveItems;
        var page = this.state.page;
        var driveItemsToDisplay = this.driveItemsToDisplay;
        var isMasonry = displayType === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry;
        var isCoverFlow = displayType === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow;
        var isLoadingNewItems = (driveItemsToDisplay.length < page * __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["a" /* DRIVE_ITEM_LIST_PAGE_SIZE */])
            && driveItemsToDisplay.length < driveItemIdsToDisplay.length;
        var hasMoreDriveItems = this.hasMoreDriveItems();
        var additionalItemsCount = additionalItems ? additionalItems.length : 0;
        var itemsCount = additionalItemsCount + navigationItems.length + driveItemsToDisplay.length;
        var systemFoldersIds = [sharedDirId, sourcesDirId];
        var draggableItemsCount = isPrivateDir
            ? driveItemsToDisplay.length - systemFoldersIds.length
            : itemsCount;
        var driveItemsElement = driveItemsToDisplay.map(function (driveItem, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_DriveItem__["a" /* default */], { key: driveItem.id, driveItem: driveItem, index: isPrivateDir ? index - systemFoldersIds.length : index, showUnreadBadge: showUnreadBadge, displayType: displayType, hasActions: hasActions, hasSelectionIcon: hasSelectionIcon, isMultipleSelection: isMultipleSelection, isSelectedInMultipleSelection: selectedItemsIds && selectedItemsIds.includes(driveItem.id), isDraggable: !systemFoldersIds.includes(driveItem.id), itemsCount: itemsCount, draggableItemsCount: draggableItemsCount, onClick: onDriveItemClick
                ? function () { return onDriveItemClick(driveItem); }
                : undefined })); });
        var listItemsElement = navigationItems.concat(driveItemsElement);
        if (additionalItems) {
            listItemsElement = listItemsElement.concat(additionalItems);
        }
        var isEmpty = listItemsElement.length + driveItemIdsToDisplay.length === 0;
        var isSearchPage = params && params.origin === __WEBPACK_IMPORTED_MODULE_18__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search;
        var infiniteScrollParams = {
            loadMore: this.loadMoreDriveItems,
            hasMore: !isLoadingNewItems && hasMoreDriveItems,
            useWindow: false,
        };
        var coverflowKey = folderId;
        if (!folderId && params && params.origin) {
            coverflowKey = params.origin;
            if (params.origin === 'search' && params.originParam) {
                coverflowKey = encodeURIComponent(params.originParam);
            }
        }
        var DriveItemListContainerClass = 'DriveItemListContainer';
        if (displayType) {
            DriveItemListContainerClass += " displayType" + displayType;
        }
        var shouldRenderDownloadPDF = isSearchPage && searchConfig && searchConfig.hasDownloadPDF && params && params.originParam;
        var shouldRenderTagTrail = isSearchPage && searchConfig && searchConfig.hasTagTrail;
        var categorySeparatorNew = searchConfig && searchConfig.categorySeparator;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            isEditMode && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__DesktopDragPreview__["a" /* default */], { displayType: displayType }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TouchDragPreview__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__DragScroller__["b" /* default */], { position: __WEBPACK_IMPORTED_MODULE_11__DragScroller__["a" /* DragScrollerPosition */].top, container: this.driveItemListElement }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__DragScroller__["b" /* default */], { position: __WEBPACK_IMPORTED_MODULE_11__DragScroller__["a" /* DragScrollerPosition */].bottom, container: this.driveItemListElement }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["c" /* DriveItemListContainer */], { isEmpty: isEmpty, hasBottomBar: hasBottomBar, className: DriveItemListContainerClass },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["h" /* TitleWrapper */], { className: "TitleWrapper" },
                    title &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Title__["a" /* default */], { title: title }),
                    !isEmpty &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* ButtonsWrapper */], null,
                            isEditButtonDisplayed && !isMasonry && !isCoverFlow && !__WEBPACK_IMPORTED_MODULE_14__utils_userAgent__["a" /* default */].isWindowsApp() &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* ButtonEdit */], { type: "button", isEditMode: isEditMode, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["F" /* toggleEditMode */])()); } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: isEditMode ? 'messages.done' : 'messages.move' })),
                            shouldRenderDownloadPDF &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__ButtonPDF_styles__["a" /* ButtonPDF */], { onClick: this.handleDownloadPDF },
                                    __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_uprez_download_bold'),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Download PDF")),
                            isDisplayTypeDropdownDisplayed &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__DisplayTypeDropdown__["a" /* default */], { folderId: folderId, displayType: displayType, dispatch: dispatch }))),
                shouldRenderTagTrail &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__TagTrail__["a" /* default */], { categorySeparator: categorySeparatorNew, originParam: params && params.originParam }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["f" /* StyledDriveItemList */], { ref: function (element) { _this.driveItemListElement = element; }, isEditMode: isEditMode, isCoverFlow: isCoverFlow, className: "StyledDriveItemList" },
                    isEmpty && !isLoadingNewItems && !isFetching
                        ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null)
                        : isCoverFlow
                            ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__CoverFlow__["a" /* default */]
                            // key is used to reinitialize slider when change a folder
                            , { 
                                // key is used to reinitialize slider when change a folder
                                key: coverflowKey, folderId: folderId, idsToDisplay: driveItemIdsToDisplay.filter(function (id) { return (!!storeDriveItems[id]); }), driveItems: storeDriveItems, navigationItemsLength: navigationItems.length, additionalItemsLength: additionalItems ? additionalItems.length : 0, onFolderChange: this.handleCoverFlowFolderChange, onSlideChange: this.handleCoverFlowSlideChange }, listItemsElement))
                            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["g" /* StyledInfiniteScroll */], __assign({}, infiniteScrollParams), isMasonry
                                ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__CustomMasonry__["a" /* default */], null, listItemsElement)
                                : listItemsElement)),
                    isFetching && hasMoreDriveItems && !isCoverFlow &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["e" /* LoadingStatus */], null,
                            __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
                    isLoading &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["d" /* Loader */], null,
                            __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })))),
            !__WEBPACK_IMPORTED_MODULE_14__utils_userAgent__["a" /* default */].isMobileApp && isFilesDndEnabled && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__containers_ImportDesktopFile_FilesDndUploader__["a" /* default */], null),
            shouldDisplayFilesToast && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__containers_ImportDesktopFile_Toast__["a" /* default */], null)));
    };
    DriveItemList.prototype.hasMoreDriveItems = function () {
        var driveItemIdsToDisplay = this.props.driveItemIdsToDisplay;
        var pageCount = Math.ceil(driveItemIdsToDisplay.length / __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["a" /* DRIVE_ITEM_LIST_PAGE_SIZE */]);
        return this.state.page < pageCount;
    };
    DriveItemList.prototype.loadMoreDriveItems = function () {
        var page = this.state.page + 1;
        this.setState({ page: page });
    };
    Object.defineProperty(DriveItemList.prototype, "driveItemsToDisplay", {
        get: function () {
            var _a = this.props, driveItemIdsToDisplay = _a.driveItemIdsToDisplay, storeDriveItems = _a.storeDriveItems;
            var nbItemToDisplay = Math.min(this.state.page * __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["a" /* DRIVE_ITEM_LIST_PAGE_SIZE */], driveItemIdsToDisplay.length);
            return driveItemIdsToDisplay
                .slice(0, nbItemToDisplay)
                .map(function (driveItemId) { return storeDriveItems[driveItemId]; })
                .filter(function (driveItem) { return !!driveItem; });
        },
        enumerable: true,
        configurable: true
    });
    DriveItemList.prototype.handleCoverFlowFolderChange = function () {
        this.setState({ page: 1 });
    };
    DriveItemList.prototype.handleCoverFlowSlideChange = function (newIndex) {
        var _a = this.props, navigationItems = _a.navigationItems, additionalItems = _a.additionalItems;
        var additionalItemsLength = additionalItems ? additionalItems.length : 0;
        var displayedItemsLength = navigationItems.length + additionalItemsLength + this.driveItemsToDisplay.length;
        if (this.hasMoreDriveItems() && newIndex === displayedItemsLength - 1) {
            this.loadMoreDriveItems();
        }
    };
    DriveItemList.prototype.handleDownloadPDF = function () {
        var params = this.props.params;
        var originParam = params && params.originParam;
        if (originParam) {
            var url = __WEBPACK_IMPORTED_MODULE_19__utils_api__["a" /* default */].getDownloadPDF(originParam);
            if (__WEBPACK_IMPORTED_MODULE_19__utils_api__["a" /* default */].token) {
                url += "&token=" + __WEBPACK_IMPORTED_MODULE_19__utils_api__["a" /* default */].token;
            }
            window.open(url);
        }
    };
    return DriveItemList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DriveItemList);


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }, spec);
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom["default"].findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom["default"].findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return StyledMultiAppAuthentication; });
/* unused harmony export MultiAppAuthenticationWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MultiAppAuthenticationContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FormWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return WebpublicationLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MultiAppAuthenticationTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MultiAppAuthenticationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MultiAppAuthenticationOptionsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SubmitButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ForgotPasswordLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SwitchLoginViewBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SwitchCompanyViewBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SwitchToDemoViewBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SwitchToDemoFormButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MultiAppAuthenticationMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MultiAppAuthenticationMethodButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Authentication_styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_styles__ = __webpack_require__(88);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledMultiAppAuthentication = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: 100%;\n\twidth: 100%;\n\tflex-flow: column nowrap;\n\tposition: relative;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n\tbackground-color: ", ";\n\toverflow: auto;\n"], ["\n\theight: 100%;\n\twidth: 100%;\n\tflex-flow: column nowrap;\n\tposition: relative;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n\tbackground-color: ", ";\n\toverflow: auto;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var MultiAppAuthenticationWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n"])));
var MultiAppAuthenticationContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tmargin: auto;\n\talign-items: center;\n\tmin-height: calc(100% - 60px);\n\n\t@media ", ", ", " {\n\t\twidth: 900px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tmargin: auto;\n\talign-items: center;\n\tmin-height: calc(100% - 60px);\n\n\t@media ", ", ", " {\n\t\twidth: 900px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].MediumDesktop);
var FormWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 300px;\n\talign-items: flex-start;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 300px;\n\talign-items: flex-start;\n"])));
var WebpublicationLogo = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 300px;\n\tpadding-bottom: 40px;\n\n\t> svg {\n\t\theight: 70px;\n\t\twidth: 240px;\n\t}\n\n\t@media ", " {\n\t\twidth: 200px;\n\n\t\t> svg {\n\t\t\theight: 55px;\n\t\t\twidth: 185px;\n\t\t}\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 300px;\n\tpadding-bottom: 40px;\n\n\t> svg {\n\t\theight: 70px;\n\t\twidth: 240px;\n\t}\n\n\t@media ", " {\n\t\twidth: 200px;\n\n\t\t> svg {\n\t\t\theight: 55px;\n\t\t\twidth: 185px;\n\t\t}\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var MultiAppAuthenticationTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tfont-weight: 500;\n\tfont-size: 20px;\n\tmargin-bottom: 10px;\n\ttext-align: left;\n\twidth: 100%;\n\theight: 20px;\n\n\t@media ", " {\n\t\theight: 18px;\n\t\tfont-size: 18px;\n\t}\n"], ["\n\tfont-weight: 500;\n\tfont-size: 20px;\n\tmargin-bottom: 10px;\n\ttext-align: left;\n\twidth: 100%;\n\theight: 20px;\n\n\t@media ", " {\n\t\theight: 18px;\n\t\tfont-size: 18px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var MultiAppAuthenticationError = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tcolor: ", ";\n\ttext-align: left;\n\tmargin-bottom: 2px;\n\tfont-size: 10px;\n\tletter-spacing: 0.4px;\n"], ["\n\tcolor: ", ";\n\ttext-align: left;\n\tmargin-bottom: 2px;\n\tfont-size: 10px;\n\tletter-spacing: 0.4px;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Red);
var MultiAppAuthenticationOptionsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tcolor: ", ";\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-flow: column wrap;\n\tmargin-top: 10px;\n\talign-items: flex-start;\n"], ["\n\tcolor: ", ";\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-flow: column wrap;\n\tmargin-top: 10px;\n\talign-items: flex-start;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey600);
var SubmitButtonWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\ttext-align: right;\n\tmargin-top: ", ";\n\tmargin-bottom: 25px;\n"], ["\n\ttext-align: right;\n\tmargin-top: ", ";\n\tmargin-bottom: 25px;\n"])), function (props) { return !props.isLoginView ? '27px' : '5px'; });
var InputWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tposition: relative;\n\n\tinput[type=\"checkbox\"]{\n\t\tdisplay : none;\n\t}\n\n\t> div:first-of-type {\n\t\tposition: absolute;\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground: #eee;\n\t\tborder: 1px solid #ddd;\n\t\tcursor: pointer;\n\t}\n\n\tdiv:first-of-type:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 9px;\n\t\theight: 5px;\n\t\tbackground: transparent;\n\t\ttop: 2px;\n\t\tleft: 2px;\n\t\tborder: 0;\n\t\ttransform: rotate(-45deg);\n\t}\n\n\tinput[type=\"checkbox\"]:checked + div:first-of-type:after {\n\t\tborder: 2px solid #333;\n\t\tborder-top: none;\n\t\tborder-right: none;\n\t}\n\n\tlabel {\n\t\tposition: relative;\n\t\tmargin-left: 25px;\n\t\tcursor: pointer;\n\t}\n"], ["\n\tposition: relative;\n\n\tinput[type=\"checkbox\"]{\n\t\tdisplay : none;\n\t}\n\n\t> div:first-of-type {\n\t\tposition: absolute;\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground: #eee;\n\t\tborder: 1px solid #ddd;\n\t\tcursor: pointer;\n\t}\n\n\tdiv:first-of-type:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 9px;\n\t\theight: 5px;\n\t\tbackground: transparent;\n\t\ttop: 2px;\n\t\tleft: 2px;\n\t\tborder: 0;\n\t\ttransform: rotate(-45deg);\n\t}\n\n\tinput[type=\"checkbox\"]:checked + div:first-of-type:after {\n\t\tborder: 2px solid #333;\n\t\tborder-top: none;\n\t\tborder-right: none;\n\t}\n\n\tlabel {\n\t\tposition: relative;\n\t\tmargin-left: 25px;\n\t\tcursor: pointer;\n\t}\n"])));
var ForgotPasswordLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('a')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tcolor: ", ";\n\ttext-decoration: none;\n\tfont-size: 14px;\n\tmargin-top: 25px;\n"], ["\n\tcolor: ", ";\n\ttext-decoration: none;\n\tfont-size: 14px;\n\tmargin-top: 25px;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue500);
var SwitchLoginViewBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tcursor: pointer;\n\ttext-align: left;\n\tcolor: ", ";\n\tfont-weight: 500;\n\t", "\n"], ["\n\tcursor: pointer;\n\ttext-align: left;\n\tcolor: ", ";\n\tfont-weight: 500;\n\t", "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue500, function (props) { return !props.isCreationView && 'margin-bottom: 25px;'; });
var SwitchCompanyViewBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(SwitchLoginViewBlock)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tpadding-top: 15px;\n\tmargin-bottom: 0;\n\tdisplay: inline-block;\n"], ["\n\tpadding-top: 15px;\n\tmargin-bottom: 0;\n\tdisplay: inline-block;\n"])));
var SwitchToDemoViewBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\t/* Temporarily hide Demo button */\n\tdisplay: none;\n\twidth: 100%;\n\tmax-width: 300px;\n\tpadding: 5px;\n\tbox-sizing: border-box;\n\tmargin: 20px 0 30px 0;\n\ttext-align: center;\n"], ["\n\t/* Temporarily hide Demo button */\n\tdisplay: none;\n\twidth: 100%;\n\tmax-width: 300px;\n\tpadding: 5px;\n\tbox-sizing: border-box;\n\tmargin: 20px 0 30px 0;\n\ttext-align: center;\n"])));
var SwitchToDemoFormButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Authentication_styles__["a" /* AuthenticateButton */])(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\twidth: 100%;\n\tmax-width: 100%;\n\theight: 45px;\n\tmax-height: 45px;\n\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"], ["\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\twidth: 100%;\n\tmax-width: 100%;\n\theight: 45px;\n\tmax-height: 45px;\n\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue800);
var BackLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\tfont-size: 14px;\n\tletter-spacing: 0.2px;\n\theight: 30px;\n\n\t> svg {\n\t\twidth: 15px;\n\t\theight: 30px;\n\t\tposition: relative;\n\t\ttop: 10px;\n\t\tmargin-right: 8px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tfont-size: 14px;\n\tletter-spacing: 0.2px;\n\theight: 30px;\n\n\t> svg {\n\t\twidth: 15px;\n\t\theight: 30px;\n\t\tposition: relative;\n\t\ttop: 10px;\n\t\tmargin-right: 8px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue500);
var buttonCommonStyle = "\n\tmax-width: none;\n\twidth: 100%;\n\toutline: none;\n";
var MultiAppAuthenticationMethods = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n\t", "\n\tmargin-top: 20px;\n"], ["\n\t", "\n\tmargin-top: 20px;\n"])), __WEBPACK_IMPORTED_MODULE_2__Authentication_styles__["l" /* blockButtonsStyle */]);
var MultiAppAuthenticationMethodButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Button_styles__["b" /* Button */])(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmargin-bottom: 20px;\n\tborder-radius: 3px;\n\t", "\n"], ["\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmargin-bottom: 20px;\n\tborder-radius: 3px;\n\t", "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, buttonCommonStyle);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFullscreenChange = handleFullscreenChange;
exports.activate = activate;
exports.userActivate = userActivate;
exports.play = play;
exports.pause = pause;
exports.togglePlay = togglePlay;
exports.seek = seek;
exports.forward = forward;
exports.replay = replay;
exports.changeRate = changeRate;
exports.changeVolume = changeVolume;
exports.mute = mute;
exports.toggleFullscreen = toggleFullscreen;
exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;

var _fullscreen = _interopRequireDefault(__webpack_require__(577));

var OPERATE = 'video-react/OPERATE';
exports.OPERATE = OPERATE;
var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
exports.USER_ACTIVATE = USER_ACTIVATE;

function handleFullscreenChange(isFullscreen) {
  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: isFullscreen
  };
}

function activate(activity) {
  return {
    type: PLAYER_ACTIVATE,
    activity: activity
  };
}

function userActivate(activity) {
  return {
    type: USER_ACTIVATE,
    activity: activity
  };
}

function play() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'play',
    source: ''
  };
  this.video.play();
  return {
    type: OPERATE,
    operation: operation
  };
}

function pause() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'pause',
    source: ''
  };
  this.video.pause();
  return {
    type: OPERATE,
    operation: operation
  };
}

function togglePlay() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'toggle-play',
    source: ''
  };
  this.video.togglePlay();
  return {
    type: OPERATE,
    operation: operation
  };
} // seek video by time


function seek(time) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'seek',
    source: ''
  };
  this.video.seek(time);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump forward x seconds


function forward(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "forward-".concat(seconds),
    source: ''
  };
  this.video.forward(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump back x seconds


function replay(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "replay-".concat(seconds),
    source: ''
  };
  this.video.replay(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeRate(rate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-rate',
    source: ''
  };
  this.video.playbackRate = rate;
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeVolume(volume) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-volume',
    source: ''
  };
  var v = volume;

  if (volume < 0) {
    v = 0;
  }

  if (volume > 1) {
    v = 1;
  }

  this.video.volume = v;
  return {
    type: OPERATE,
    operation: operation
  };
}

function mute(muted) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: muted ? 'muted' : 'unmuted',
    source: ''
  };
  this.video.muted = muted;
  return {
    type: OPERATE,
    operation: operation
  };
}

function toggleFullscreen(player) {
  if (_fullscreen["default"].enabled) {
    if (_fullscreen["default"].isFullscreen) {
      _fullscreen["default"].exit();
    } else {
      _fullscreen["default"].request(this.rootElement);
    }

    return {
      type: OPERATE,
      operation: {
        action: 'toggle-fullscreen',
        source: ''
      }
    };
  }

  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: !player.isFullscreen
  };
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findElPosition = findElPosition;
exports.getPointerPosition = getPointerPosition;
exports.blurNode = blurNode;
exports.focusNode = focusNode;
exports.hasClass = hasClass;

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {ReactNodeRef} el React Node ref from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var _document = document,
      body = _document.body,
      docEl = _document.documentElement;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round

  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}
/**
 * Get pointer position in a React Node ref
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
 */


function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;
  var evtPageY = event.pageY;
  var evtPageX = event.pageX;

  if (event.changedTouches) {
    evtPageX = event.changedTouches[0].pageX;
    evtPageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
  return position;
} // blur an element


function blurNode(reactNode) {
  if (reactNode && reactNode.blur) {
    reactNode.blur();
  }
} // focus an element


function focusNode(reactNode) {
  if (reactNode && reactNode.focus) {
    reactNode.focus();
  }
} // check if an element has a class name


function hasClass(elm, cls) {
  var classes = elm.className.split(' ');

  for (var i = 0; i < classes.length; i++) {
    if (classes[i].toLowerCase() === cls.toLowerCase()) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainView__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ResourceSelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResourceSelector__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_styles_constants__ = __webpack_require__(4);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};











var isMounted = false;
var ResourcePanel = function (_a) {
    var iconName = _a.iconName, label = _a.label, importManagerId = _a.importManagerId, isImporting = _a.isImporting, isResetButtonDisplayed = _a.isResetButtonDisplayed, dispatch = _a.dispatch, onResourceSelect = _a.onResourceSelect, onResourceReset = _a.onResourceReset, isExternalLinkActive = _a.isExternalLinkActive, linkPanel = _a.linkPanel, _b = _a.isValidResourceFromApp, isValidResourceFromApp = _b === void 0 ? function () { return true; } : _b, fileExtensions = _a.fileExtensions, isFileExtensionsDisplayed = _a.isFileExtensionsDisplayed, isOptimizedImageImport = _a.isOptimizedImageImport, fileType = _a.fileType;
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](isImporting), 2), isResourceSelectorDisplayed = _c[0], setIsResourceSelectorDisplayed = _c[1];
    var handleResourceSelect = function (driveItem) {
        onResourceSelect(driveItem);
        var status = driveItem.status;
        var isProcessing = status && status !== __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].AssetItemStatus.LIVE;
        // do not update state on unmounted component to avoid memory leaks
        if (isMounted && !isProcessing) {
            setIsResourceSelectorDisplayed(false);
        }
    };
    var handleResourceReset = function () {
        if (isImporting) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId));
        }
        if (onResourceReset) {
            onResourceReset();
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        isMounted = true;
        return function () {
            isMounted = false;
        };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setIsResourceSelectorDisplayed(isImporting);
    }, [isImporting]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, !isResourceSelectorDisplayed
        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MainView__["a" /* default */], { iconName: iconName, label: label, linkPanel: linkPanel, isExternalLinkActive: isExternalLinkActive, isResetButtonDisplayed: isResetButtonDisplayed, onReplaceClick: function () { return setIsResourceSelectorDisplayed(true); }, onResetClick: handleResourceReset }))
        : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonBackWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonBack */], { type: "button", onClick: function () { return setIsResourceSelectorDisplayed(false); } },
                    __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_back'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.back" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_ResourceSelector__["a" /* default */], { id: importManagerId, label: "messages.replace_file", isValidResourceFromApp: isValidResourceFromApp, fileExtensions: fileExtensions, isFileExtensionsDisplayed: isFileExtensionsDisplayed, isOptimizedImageImport: isOptimizedImageImport, isPublicationDependency: true, fileType: fileType, linkPanel: linkPanel, onSelect: function (_a) {
                    var _b = __read(_a, 1), item = _b[0];
                    return handleResourceSelect(item);
                }, actionButtonColor: __WEBPACK_IMPORTED_MODULE_10__utils_styles_constants__["c" /* StyleColor */].Blue600, theme: __WEBPACK_IMPORTED_MODULE_6__ResourceSelector__["a" /* ResourceSelectorTheme */].DARK })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ResourcePanel);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var ButtonRemove = function (_a) {
    var onClick = _a.onClick, isDisabled = _a.isDisabled;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledButtonRemove */], { type: "button", disabled: isDisabled, onClick: onClick }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_close-2')));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonRemove);


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UserInfoWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Loader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return InputLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Error; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PopupBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PopupLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserAvatar_styles__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ProfilePage_reducer__ = __webpack_require__(120);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var Header = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: flex-end;\n\tjustify-content: space-between;\n\tmargin-bottom: 30px;\n\n\t", " {\n\t\twidth: ", "px;\n\t\tmargin: 0 auto;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: flex-end;\n\tjustify-content: space-between;\n\tmargin-bottom: 30px;\n\n\t", " {\n\t\twidth: ", "px;\n\t\tmargin: 0 auto;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_4__UserAvatar_styles__["a" /* Image */], __WEBPACK_IMPORTED_MODULE_5__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG);
var UserInfoWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tmin-width: 0;\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tmin-width: 0;\n"])));
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 80), __WEBPACK_IMPORTED_MODULE_3__utils_style__["e" /* spin */]);
var buttonCommonStyles = "\n\tbox-sizing: border-box;\n\tmin-width: 145px;\n\theight: 50px;\n\tpadding: 0 10px;\n\tborder: 0;\n\tborder-radius: 9px;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 18px;\n\tline-height: 50px;\n\tcursor: pointer;\n\ttransition: background-color 0.2s;\n\twhite-space: nowrap;\n";
var ButtonSave = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n\tmargin: 20px 0 10px 15px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t", "\n\n\t&:not(:disabled):hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\t", "\n\tmargin: 20px 0 10px 15px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t",
    "\n\n\t&:not(:disabled):hover {\n\t\tbackground-color: ", ";\n\t}\n"])), buttonCommonStyles, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen, 10), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen, function (props) { return props.disabled && "\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey400 + ";\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t"; }, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen, 25));
var ButtonLogout = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\tmargin-top: 20px;\n\tmargin-left: auto;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t&:not(:disabled):hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\t", "\n\tmargin-top: 20px;\n\tmargin-left: auto;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t&:not(:disabled):hover {\n\t\tbackground-color: ", ";\n\t}\n"])), buttonCommonStyles, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.actionColor, 10); }, function (props) { return props.theme.primary.actionColor; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.actionColor, 25); });
var Input = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('input')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 20px 15px;\n\tborder: 0;\n\tborder-bottom: 1px solid ", ";\n\tborder-radius: 0; /* fix for iOS */\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tcolor: ", ";\n\t-webkit-appearance: none;\n\n\t", "\n\n\t", "\n\n\t&:not(:read-only):focus {\n\t\tborder-color: ", ";\n\t}\n\n\t::placeholder{\n\t\tcolor: ", ";\n\t};\n\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n\n\t:last-child {\n\t\tmargin-bottom: -4px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 20px 15px;\n\tborder: 0;\n\tborder-bottom: 1px solid ", ";\n\tborder-radius: 0; /* fix for iOS */\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tcolor: ", ";\n\t-webkit-appearance: none;\n\n\t", "\n\n\t", "\n\n\t&:not(:read-only):focus {\n\t\tborder-color: ",
    ";\n\t}\n\n\t::placeholder{\n\t\tcolor: ", ";\n\t};\n\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n\n\t:last-child {\n\t\tmargin-bottom: -4px;\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 11.9); }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 59.5); }, function (props) { return props.isError && "border-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red100 + ";"; }, function (props) { return props.readOnly && "background-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey100, 50) + ";"; }, function (props) { return props.isError
    ? "" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red100
    : "" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 35.7); });
var InputLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('label')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black);
var Error = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red100);
var PopupBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tpadding: 20px;\n\n\t", " {\n\t\tmargin-bottom: 20px;\n\t\tpadding: 10px 0;\n\t}\n"], ["\n\tpadding: 20px;\n\n\t", " {\n\t\tmargin-bottom: 20px;\n\t\tpadding: 10px 0;\n\t}\n"])), Input);
var PopupLoader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"])));
var Message = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tpadding: 20px;\n\tborder-radius: 9px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tdisplay: inline-block;\n\tpadding: 20px;\n\tborder-radius: 9px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red100, 10), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red100);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PublicDraggable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConnectedDroppable; });
/* unused harmony export resetServerContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_use_memo_one__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_css_box_model__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_memoize_one__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf_schd__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer__);
















var isProduction = "production" === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log(type, message) {
  var _console;

  if (isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var warning = log.bind(null, 'warn');
var error = log.bind(null, 'error');

function noop() {}

function getOptions(shared, fromBinding) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, shared, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1 = "production" === 'production';
var prefix = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1) {
    throw new RbdInvariant(prefix);
  } else {
    throw new RbdInvariant(prefix + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
         false ? warning("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (false) {
          error(err.message);
        }
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (false) {
        error(err.message);
      }

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  liftInstruction: liftInstruction,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ?  false ? invariant(false) : invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function values(map) {
  return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_core_js_object_values___default()(map);
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (droppables) {
  return values(droppables);
});
var toDraggableList = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (draggables) {
  return values(draggables);
});

var getDraggablesInsideDroppable = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ?  false ? invariant(false, 'Could not find displaced item in set') : invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])(Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["c" /* expand */])(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ?  false ? invariant(false, 'Cannot move in direction without previous impact location') : invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ?  false ? invariant(false) : invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["f" /* offset */])(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["f" /* offset */])(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ?  false ? invariant(false, 'Cannot get clipped area from droppable') : invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, frame, {
    scroll: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ?  false ? invariant(false, 'Should not add placeholder space to home list') : invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ?  false ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ?  false ? invariant(false, 'Cannot remove placeholder form subject when there was none') : invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ?  false ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ?  false ? invariant(false) : invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ?  false ? invariant(false, 'Must be over a destination in SNAP movement mode') : invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ?  false ? invariant(false, 'Expected draggable to be inside home list') : invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var records = {};
var isEnabled = false;

var isTimingsEnabled = function isTimingsEnabled() {
  return isEnabled;
};
var start = function start(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    records[key] = now;
  }
};
var finish = function finish(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    var previous = records[key];

    if (!previous) {
      console.warn('cannot finish timing as no previous time found', key);
      return;
    }

    var result = now - previous;
    var rounded = result.toFixed(2);

    var style = function () {
      if (result < 12) {
        return {
          textColor: 'green',
          symbol: '✅'
        };
      }

      if (result < 40) {
        return {
          textColor: 'orange',
          symbol: '⚠️'
        };
      }

      return {
        textColor: 'red',
        symbol: '❌'
      };
    }();

    console.log(style.symbol + " %cTiming %c" + rounded + " %cms %c" + key, 'color: blue; font-weight: bold;', "color: " + style.textColor + "; font-size: 1.1em;", 'color: grey;', 'color: purple; font-weight: bold;');
  }
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["f" /* offset */])(draggable.client, offset$1);
  var page = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["g" /* withScroll */])(client, initialWindowScroll);

  var moved = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, draggable, {
    placeholder: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ?  false ? invariant(false, 'Expected Droppable to have a frame') : invariant(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var timingsKey = 'Processing dynamic changes';
var publishWhileDraggingInVirtual = (function (_ref) {
  var _extends2, _extends3;

  var state = _ref.state,
      published = _ref.published;
  start(timingsKey);
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.dimensions.droppables, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.dimensions.draggables, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish(timingsKey);

  var draggingState = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    phase: 'DRAGGING'
  }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    phase: 'DROP_PENDING'
  }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ?  false ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    var _extends2;

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, "Collection cannot start from phase " + state.phase) : invariant(false) : void 0;

    var _result = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant(false) : void 0;

    var updated = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ?  false ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant(false) : void 0;

    var _updated = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Cannot move by window in phase " + state.phase) : invariant(false) : void 0;
    !state.isWindowScrollAllowed ?  false ? invariant(false, 'Window scrolling is currently not supported for fixed lists') : invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.viewport, {
      scroll: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, action.type + " received while not in DRAGGING phase") : invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var _extends3;

    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant(false) : void 0;

    var newState = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DROP_PENDING'
    }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot animate drop from phase " + state.phase) : invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys___default()(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
   false ? warning("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
}

function validateDimensions(critical, dimensions) {
  if (false) {
    var insideDestination = getDraggablesInsideDroppable(critical.droppable.id, dimensions.draggables);
    checkIndexes(insideDestination);
  }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ?  false ? invariant(false, 'Unexpected phase to start a drag') : invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot drop in phase: " + state.phase) : invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(getWindowScroll());
  }

  var scheduled = Object(__WEBPACK_IMPORTED_MODULE_10_raf_schd__["a" /* default */])(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop;

  function isActive() {
    return unbind !== noop;
  }

  function start() {
    !!isActive() ?  false ? invariant(false, 'Cannot start scroll listener when already active') : invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ?  false ? invariant(false, 'Cannot stop scroll listener when not active') : invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
       false ? warning('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
       false ? warning("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ?  false ? invariant(false, 'Could not find timer') : invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start(key);
  fn();
  finish(key);
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeCapture as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ?  false ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ?  false ? invariant(false, 'Can only flush responders while dragging') : invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ?  false ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ?  false ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_4_redux__["c" /* compose */];
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* createStore */])(reducer, composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_4_redux__["a" /* applyMiddleware */])(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};

var timingKey = 'Publish collection from DOM';
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start(timingKey);
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;

      var added = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys___default()(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });

      var updated = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys___default()(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });

      var result = {
        additions: added,
        removals: __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_keys___default()(removals),
        modified: updated
      };
      staging = clean$1();
      finish(timingKey);
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ?  false ? invariant(false, 'Cannot find document.documentElement') : invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  var timingKey = 'Initial collection from DOM';
  start(timingKey);
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish(timingKey);
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
     false ? warning("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ?  false ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ?  false ? invariant(false, 'Should only be subscribed when a collection is occurring') : invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ?  false ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ?  false ? invariant(false, 'Invalid result') : invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
     false ? warning("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;

  var now = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default()();

  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = Object(__WEBPACK_IMPORTED_MODULE_10_raf_schd__["a" /* default */])(scrollWindow);
  var scheduleDroppableScroll = Object(__WEBPACK_IMPORTED_MODULE_10_raf_schd__["a" /* default */])(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ?  false ? invariant(false, 'Cannot fluid scroll if not dragging') : invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start('starting fluid scroller');
    !!dragging ?  false ? invariant(false, 'Cannot start auto scrolling when already started') : invariant(false) : void 0;

    var dragStartTime = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default()();

    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish('starting fluid scroller');

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ?  false ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? invariant(false, 'Cannot find the head to append a style to') : invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dynamicRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var setDynamicStyle = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (proposed) {
    var el = dynamicRef.current;
    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (proposed) {
    var el = alwaysRef.current;
    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ?  false ? invariant(false, 'style elements already mounted') : invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ?  false ? invariant(false, 'Cannot unmount ref as it is not set') : invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
     false ? warning("Unable to find any drag handles in the context \"" + contextId + "\"") : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
     false ? warning("Unable to find drag handle with id \"" + draggableId + "\" as no handle with a matching id was found") : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? warning('drag handle needs to be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
  var recordRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var restoreFocusFrameRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var isMountedRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var register = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ?  false ? invariant(false, "Cannot find draggable entry with id [" + id + "]") : invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ?  false ? invariant(false, "Cannot find droppable entry with id [" + id + "]") : invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(createRegistry, []);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ?  false ? invariant(false, 'Cannot find document.body') : invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');
    el.setAttribute('aria-atomic', 'true');

    __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs2_core_js_object_assign___default()(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        getBodyElement().removeChild(el);

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

     false ? warning("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var getId$1 = function getId(contextId) {
  return "rbd-lift-instruction-" + contextId;
};
function useLiftInstruction(contextId, liftInstruction) {
  var id = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return getId$1(contextId);
  }, [contextId]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = liftInstruction;

    __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs2_core_js_object_assign___default()(el.style, {
      display: 'none'
    });

    getBodyElement().appendChild(el);
    return function unmount() {
      getBodyElement().removeChild(el);
    };
  }, [id, liftInstruction]);
  return id;
}

var AppContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

var peerDependencies = {
	react: "^16.8.5",
	"react-dom": "^16.8.5"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ?  false ? invariant(false, "Unable to parse React version " + value) : invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

   false ? warning("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
     false ? warning("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
     false ? warning("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
     false ? warning("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
});

function useDev(useHook) {
  if (false) {
    useHook();
  }
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, __WEBPACK_IMPORTED_MODULE_0_react___default.a.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(current);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    ref.current = current;
  });
  return ref;
}

function create() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ?  false ? invariant(false, 'Cannot claim lock as it is already claimed') : invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ?  false ? invariant(false, 'Cannot release lock when there is no lock') : invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ?  false ? invariant(false, 'Cannot be IDLE') : invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? invariant(false, 'Unexpected phase') : invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(idle$1);
  var unbindEventsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(noop);
  var startCaptureBinding = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ?  false ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(noop$1);
  var startCaptureBinding = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ?  false ? invariant(false, 'Cannot stop capturing a keyboard drag when not capturing') : invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? invariant(false) : invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor$1(api) {
  var phaseRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(idle$2);
  var unbindEventsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(noop);
  var getPhase = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ?  false ? invariant(false, "Cannot start dragging from phase " + phase.type) : invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ?  false ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ?  false ? invariant(false, 'Cannot change the amount of sensor hooks after mounting') : invariant(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["e" /* getRect */])(el.getBoundingClientRect()).center;
});

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement(target)) {
     false ? warning('event.target must be a Element') : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? warning('drag handle must be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
     false ? warning('Draggable element is not a HTMLElement') : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
       false ? warning("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
       false ? warning("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
     false ? warning("Unable to find draggable with id: " + draggableId) : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
     false ? warning("Unable to find draggable element with id: " + draggableId) : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ?  false ? invariant(false, "Cannot lift in phase " + phase) : invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = Object(__WEBPACK_IMPORTED_MODULE_10_raf_schd__["a" /* default */])(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useMouseSensor$1];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
    return create();
  })[0];
  var tryAbandonLock = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(lockAPI.tryAbandon, [lockAPI]);
  var isLockClaimed = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(lockAPI.isClaimed, [lockAPI]);
  var api = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ?  false ? invariant(false, 'Could not find store from lazy ref') : invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      liftInstruction = props.liftInstruction;
  var lazyStoreRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var liftInstructionId = useLiftInstruction(contextId, liftInstruction);
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return createAutoScroller(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (false) {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      liftInstructionId: liftInstructionId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, focusMarshal, getCanLift, getIsMovementAllowed, liftInstructionId, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AppContext.Provider, {
    value: appContext
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */], {
    context: StoreContext,
    store: store
  }, props.children));
}

var instanceCount = 0;
function resetServerContext() {
  instanceCount = 0;
}
function DragDropContext(props) {
  var contextId = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return "" + instanceCount++;
  }, []);
  var liftInstruction = props.liftInstruction || preset.liftInstruction;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorBoundary, null, function (setCallbacks) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      liftInstruction: liftInstruction,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (true) {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ?  false ? invariant(false) : invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

   false ? warning("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

   false ? warning("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["d" /* getBox */])(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["c" /* expand */])(paddingBox, base.border);
  var client = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["b" /* createBox */])({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["g" /* withScroll */])(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["d" /* getBox */])(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["g" /* withScroll */])(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(Context);
  !result ?  false ? invariant(false, 'Could not find required context') : invariant(false) : void 0;
  return result;
}

var count = 0;
function useUniqueId(prefix) {
  var countRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(count++);
  return prefix + "::" + countRef.current;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(descriptor);
  var memoizedUpdateScroll = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (x, y) {
      !whileDraggingRef.current ?  false ? invariant(false, 'Can only update scroll when dragging') : invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_10_raf_schd__["a" /* default */])(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? invariant(false, 'Could not find scroll options while scrolling') : invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (windowScroll, options) {
    !!whileDraggingRef.current ?  false ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ?  false ? invariant(false, 'Cannot collect without a droppable ref') : invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (false) {
        checkForNestedScrollContainers(scrollable);
      }
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? invariant(false, 'Cannot stop drag when no active drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? invariant(false, 'Cannot scroll when there is no drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ?  false ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
         false ? warning('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var tryClearAnimateOpenTimer = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2;
    }

    if (animateOpenTimerRef.current) {
      return noop$2;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Placeholder);

var DroppableContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ?  false ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ?  false ? invariant(false, 'A Droppable requires a droppableId prop') : invariant(false) : void 0;
  !(typeof props.droppableId === 'string') ?  false ? invariant(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ?  false ? invariant(false, 'isDropDisabled must be a boolean') : invariant(false) : void 0;
  !isBoolean(props.isCombineEnabled) ?  false ? invariant(false, 'isCombineEnabled must be a boolean') : invariant(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ?  false ? invariant(false, 'ignoreContainerClipping must be a boolean') : invariant(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

   false ? warning("\n      Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ") : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ?  false ? invariant(false, 'Must provide a clone render function (renderClone) for virtual lists') : invariant(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ?  false ? invariant(false, 'Expected virtual list to not have a placeholder') : invariant(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["a" /* calculateBox */])(borderBox, computedStyles);
  var page = Object(__WEBPACK_IMPORTED_MODULE_6_css_box_model__["g" /* withScroll */])(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (windowScroll) {
    var el = getDraggableRef();
    !el ?  false ? invariant(false, 'Cannot get dimension when no ref is set') : invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(entry);
  var isFirstPublishRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);
  useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ?  false ? invariant(false, 'Draggable requires a draggableId') : invariant(false) : void 0;
    !(typeof id === 'string') ?  false ? invariant(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant(false) : void 0;
    !__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer___default()(props.index) ?  false ? invariant(false, prefix(id) + " requires an integer index prop") : invariant(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ?  false ? invariant(false, prefix(id) + " Unable to find drag handle") : invariant(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ?  false ? invariant(false, 'Draggable isClone prop value changed during component life') : invariant(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var setRef = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (el) {
    ref.current = el;
  }, []);
  var getRef = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      liftInstructionId = _useRequiredContext.liftInstructionId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return isEnabled ? {
      tabIndex: 0,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      'aria-labelledby': liftInstructionId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, draggableId, isEnabled, liftInstructionId]);
  var onMoveEnd = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(getSecondarySnapshot);
  var getMemoizedProps = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateDraggable, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(AppContext);
  !appContext ?  false ? invariant(false, 'Could not find app context') : invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var placeholderRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["a" /* useCallback */])(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = Object(__WEBPACK_IMPORTED_MODULE_1_use_memo_one__["b" /* useMemo */])(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return __WEBPACK_IMPORTED_MODULE_13_react_dom___default.a.createPortal(node, getContainerForClone());
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = Object(__WEBPACK_IMPORTED_MODULE_7_memoize_one__["a" /* default */])(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ?  false ? invariant(false, 'document.body is not ready') : invariant(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;




/***/ }),
/* 257 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1573);
var enumBugKeys = __webpack_require__(622);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 44px;\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 44px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 30px;\n\theight: 30px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t", "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 30px;\n\theight: 30px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t",
    "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-right: 20px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
}, function (_a) {
    var iconWidth = _a.iconWidth;
    return iconWidth;
}, function (_a) {
    var iconHeight = _a.iconHeight;
    return iconHeight;
});

var templateObject_1, templateObject_2;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(58);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(159)('meta');
var isObject = __webpack_require__(58);
var has = __webpack_require__(105);
var setDesc = __webpack_require__(75).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(157)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(57);
var core = __webpack_require__(47);
var LIBRARY = __webpack_require__(188);
var wksExt = __webpack_require__(382);
var defineProperty = __webpack_require__(75).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(187)('keys');
var uid = __webpack_require__(159);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 267 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(107);
var dPs = __webpack_require__(656);
var enumBugKeys = __webpack_require__(267);
var IE_PROTO = __webpack_require__(266)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(380)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(657).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(190);
var TAG = __webpack_require__(45)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(188);
var $export = __webpack_require__(49);
var redefine = __webpack_require__(108);
var hide = __webpack_require__(106);
var Iterators = __webpack_require__(162);
var $iterCreate = __webpack_require__(671);
var setToStringTag = __webpack_require__(189);
var getPrototypeOf = __webpack_require__(672);
var ITERATOR = __webpack_require__(45)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(92);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(727);

var _runTransitionHook = __webpack_require__(276);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(133);

var _PathUtils = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(276);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(730);

var _PathUtils = __webpack_require__(93);

var _runTransitionHook = __webpack_require__(276);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(196);

var _LocationUtils = __webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(133);

var _DOMUtils = __webpack_require__(197);

var _DOMStateStorage = __webpack_require__(412);

var _PathUtils = __webpack_require__(93);

var _ExecutionEnvironment = __webpack_require__(279);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(753);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20), __webpack_require__(421)(module)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint global-require: "off" */
/* eslint no-console: "off" */

var _intl = __webpack_require__(769);

var _intl2 = _interopRequireDefault(_intl);

var _moment = __webpack_require__(430);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(772);

var _Base = __webpack_require__(286);

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  _localeKey: 'en',
  _translationsObject: {},
  _getTranslations: null,
  _getLocale: null,
  _handleMissingTranslation: function _handleMissingTranslation(text) {
    return text.split('.').pop();
  },

  get _translations() {
    return this._getTranslations ? this._getTranslations() : this._translationsObject;
  },

  set _translations(translations) {
    this._translationsObject = translations;
  },

  get _locale() {
    return this._getLocale ? this._getLocale() : this._localeKey;
  },

  set _locale(locale) {
    this._localeKey = locale;
  },

  setLocale: function setLocale(locale) {
    var rerenderComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    this._locale = locale;
    if (rerenderComponents) {
      this.forceComponentsUpdate();
    }
  },
  setTranslations: function setTranslations(translations) {
    var rerenderComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    this._translations = translations;
    if (rerenderComponents) {
      this.forceComponentsUpdate();
    }
  },
  loadTranslations: function loadTranslations(translations) {
    console.error('I18n.loadTranslations is deprecated, please use I18n.setTranslations instead');
    this.setTranslations(translations);
  },
  setTranslationsGetter: function setTranslationsGetter(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Translations getter must be a function');
    }
    this._getTranslations = fn;
  },
  setLocaleGetter: function setLocaleGetter(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Locale getter must be a function');
    }
    this._getLocale = fn;
  },
  setHandleMissingTranslation: function setHandleMissingTranslation(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Handle missing translation must be a function');
    }
    this._handleMissingTranslation = fn;
  },
  t: function t(key) {
    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this._translate(key, replacements);
  },
  l: function l(value, options) {
    return this._localize(value, options);
  },
  _replace: function _replace(translation, replacements) {
    var _this = this;

    if (typeof translation === 'string') {
      var result = translation;
      Object.keys(replacements).forEach(function (replacement) {
        result = result.split('%{' + replacement + '}').join(replacements[replacement]);
      });
      return result;
    }
    if ((typeof translation === 'undefined' ? 'undefined' : _typeof(translation)) === 'object') {
      var _result = {};
      Object.keys(translation).forEach(function (translationKey) {
        _result[translationKey] = _this._replace(translation[translationKey], replacements);
      });
      return _result;
    }
    return null;
  },
  _translate: function _translate(key) {
    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var translation = '';
    try {
      var translationLocale = this._translations[this._locale] ? this._locale : this._locale.split('-')[0];
      translation = this._fetchTranslation(this._translations, translationLocale + '.' + key, replacements.count);
    } catch (err) {
      return this._handleMissingTranslation(key, replacements);
    }
    return this._replace(translation, replacements);
  },
  _localize: function _localize(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (options.dateFormat) {
      return (0, _moment2.default)(value, options.parseFormat, this._locale, Boolean(options.strictParse)).format(this.t(options.dateFormat));
    }
    if (typeof value === 'number') {
      if (global.Intl) {
        if (!(Intl.NumberFormat && Intl.NumberFormat.supportedLocalesOf(this._locale).length === 1)) {
          Intl.NumberFormat = _intl2.default.NumberFormat;
        }
      } else {
        global.Intl = _intl2.default;
      }
      return new Intl.NumberFormat(this._locale, options).format(value);
    }
    return value;
  },
  _fetchTranslation: function _fetchTranslation(translations, key) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _index = key.indexOf('.');
    if (typeof translations === 'undefined') {
      throw new Error('not found');
    }
    if (_index > -1) {
      return this._fetchTranslation(translations[key.substring(0, _index)], key.substr(_index + 1), count);
    }
    if (count !== null) {
      if (translations[key + '_' + count]) {
        // when key = 'items_3' if count is 3
        return translations[key + '_' + count];
      }
      if (count !== 1 && translations[key + '_plural']) {
        // when count is not simply singular, return _plural
        return translations[key + '_plural'];
      }
    }
    if (translations[key]) {
      return translations[key];
    }
    throw new Error('not found');
  },
  forceComponentsUpdate: function forceComponentsUpdate() {
    _Base2.default.rerenderAll();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base = function (_React$Component) {
  _inherits(Base, _React$Component);

  function Base() {
    _classCallCheck(this, Base);

    return _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).apply(this, arguments));
  }

  _createClass(Base, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Base.instances.push(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      Base.instances.splice(Base.instances.indexOf(this), 1);
    }
  }], [{
    key: 'rerenderAll',
    value: function rerenderAll() {
      Base.instances.forEach(function (instance) {
        return instance.forceUpdate();
      });
    }
  }]);

  return Base;
}(_react2.default.Component);

Base.instances = [];
exports.default = Base;

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var promiseXHR = function (fileUrl) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', fileUrl);
        xhr.onload = function () { return resolve(xhr.response); };
        xhr.onerror = function () { return reject({
            status: xhr.status,
            statusText: xhr.statusText
        }); };
        xhr.send();
    });
};
var isFileContentTrue = function (fileUrl) { return __awaiter(_this, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, promiseXHR(fileUrl)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.trim() === 'true'];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
var AppTypeUtils = /** @class */ (function () {
    function AppTypeUtils() {
    }
    AppTypeUtils.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AppTypeUtils.initIsMobileAppMainview()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, AppTypeUtils.initIsMultiApp()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AppTypeUtils, "isMobileAppMainView", {
        get: function () {
            if (AppTypeUtils._isMobileAppMainView === undefined) {
                console.error('AppTypeUtils.isMobileAppMainView is called before being initialized by AppTypeUtils.init()');
                return false;
            }
            return AppTypeUtils._isMobileAppMainView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppTypeUtils, "isMultiApp", {
        get: function () {
            if (!AppTypeUtils._isMobileAppMainView) {
                return false;
            }
            if (AppTypeUtils._isMultiApp === undefined) {
                console.error('AppTypeUtils.isMultiApp is called before being initialized by AppTypeUtils.init()');
                return false;
            }
            return AppTypeUtils._isMultiApp;
        },
        enumerable: true,
        configurable: true
    });
    AppTypeUtils.initIsMobileAppMainview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = AppTypeUtils;
                        return [4 /*yield*/, this.getIsMobileAppMainview()];
                    case 1:
                        _a._isMobileAppMainView = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppTypeUtils.initIsMultiApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = AppTypeUtils;
                        return [4 /*yield*/, this.getIsMultiApp()];
                    case 1:
                        _a._isMultiApp = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppTypeUtils.getIsMobileAppMainview = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, isFileContentTrue('./.gallery/config/isMobileAppMainView')];
            });
        });
    };
    AppTypeUtils.getIsMultiApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, isFileContentTrue('./.gallery/config/isMultiAppEnabled')];
            });
        });
    };
    return AppTypeUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (AppTypeUtils);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(782);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var PiwikTracker = __webpack_require__(786);
var MatomoTracker = __webpack_require__(787);
var WebTrendsTracker = __webpack_require__(788);
var XitiTracker = __webpack_require__(789);
var GoogleTagTracker = __webpack_require__(790);
var PianoTracker = __webpack_require__(791);



var xml2js = __webpack_require__(793).parseString;
function xml2jsPromise(xmlString, parseOptions) {
    return new Promise(function (resolve, reject) {
        xml2js(xmlString, parseOptions, function (err, result) {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
}
var StatsUtils = /** @class */ (function () {
    function StatsUtils() {
        this.parseOptions = {
            async: true,
            explicitChildren: true,
            childkey: 'children',
            attrkey: 'attrs',
        };
        this.queue = [];
        this.trackerList = [];
    }
    StatsUtils.getInstance = function () {
        if (StatsUtils.self === undefined) {
            StatsUtils.self = new StatsUtils();
        }
        return StatsUtils.self;
    };
    StatsUtils.prototype.updateConfig = function (configString, isMobileApp, resourceCredentials) {
        var _this = this;
        this.isMobileApp = isMobileApp;
        this.resourceCredentials = resourceCredentials;
        xml2jsPromise(configString, this.parseOptions)
            .then(function (parsedStatisticsXml) { return __awaiter(_this, void 0, void 0, function () {
            var storedQueue;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(parsedStatisticsXml.Statistics && parsedStatisticsXml.Statistics.children)) return [3 /*break*/, 2];
                        this.config = parsedStatisticsXml.Statistics.children;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__indexedDB_manager__["a" /* default */].getTrackingQueue()];
                    case 1:
                        storedQueue = _a.sent();
                        if (storedQueue && storedQueue.length) {
                            this.queue = storedQueue.concat(this.queue);
                            __WEBPACK_IMPORTED_MODULE_2__indexedDB_manager__["a" /* default */].setTrackingQueue(this.queue).then();
                        }
                        this.createTrackers();
                        this.trackQueue();
                        __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].subscribeToConnectionIsUp(function () { return _this.trackQueue(); });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    StatsUtils.prototype.trackPage = function (page, url, title) {
        var trackingData = {
            type: __WEBPACK_IMPORTED_MODULE_0__typings__["a" /* TrackingType */].Page,
            arguments: {
                page: page,
                url: url,
                title: title,
            }
        };
        this.track(trackingData);
    };
    StatsUtils.prototype.trackEvent = function (category, action, label, value) {
        var trackingData = {
            type: __WEBPACK_IMPORTED_MODULE_0__typings__["a" /* TrackingType */].Event,
            arguments: {
                category: category,
                action: action,
                label: label,
                value: value,
            }
        };
        this.track(trackingData);
    };
    StatsUtils.prototype.trackProperty = function (name, value) {
        var trackingData = {
            type: __WEBPACK_IMPORTED_MODULE_0__typings__["a" /* TrackingType */].Property,
            arguments: {
                name: name,
                value: value,
            }
        };
        this.track(trackingData);
    };
    StatsUtils.prototype.track = function (trackingData) {
        this.queue.push(trackingData);
        __WEBPACK_IMPORTED_MODULE_2__indexedDB_manager__["a" /* default */].setTrackingQueue(this.queue).then();
        this.trackQueue();
    };
    StatsUtils.prototype.createTrackers = function () {
        this.trackerList = [];
        if (this.config.servers && this.config.servers[0]) {
            var serverConfigs = this.config.servers[0].children;
            if (serverConfigs) {
                if (serverConfigs.GoogleAnalytics) {
                    this.createAnalyticsTrackers(serverConfigs.GoogleAnalytics);
                }
                if (serverConfigs.GoogleTag) {
                    this.createGoogleTagTrackers(serverConfigs.GoogleTag);
                }
                if (serverConfigs.Piwik) {
                    this.createPiwikTrackers(serverConfigs.Piwik);
                }
                if (serverConfigs.Matomo) {
                    this.createMatomoTrackers(serverConfigs.Matomo);
                }
                // lib doesnt work in a mobile app
                if (serverConfigs.WebTrends && !this.isMobileApp) {
                    this.createWebTrendsTrackers(serverConfigs.WebTrends);
                }
                // lib doesnt work in a mobile app
                if (serverConfigs.Xiti && !this.isMobileApp) {
                    this.createXitiTrackers(serverConfigs.Xiti);
                }
                if (serverConfigs.Piano) {
                    this.createPianoTrackers(serverConfigs.Piano);
                }
            }
        }
    };
    StatsUtils.prototype.createAnalyticsTrackers = function (analyticsConfigs) {
        for (var i = 0; i < analyticsConfigs.length; i++) {
            var analyticsConfig = analyticsConfigs[i];
            console.error('Google Analytics 3 is deprecated. Please use Google Analytics 4 instead.', analyticsConfig);
            // this.trackerList.push(new AnalyticsTracker(analyticsConfig.attrs));
        }
    };
    StatsUtils.prototype.createGoogleTagTrackers = function (googleTagConfigs) {
        for (var i = 0; i < googleTagConfigs.length; i++) {
            var googleTagConfig = googleTagConfigs[i];
            if (i === 0) {
                this.trackerList.push(new GoogleTagTracker(googleTagConfig.attrs));
            }
            else {
                console.error("Only one GA4 property can be handled at once. Property " + googleTagConfig.attrs.account + " is ignored.");
            }
        }
    };
    StatsUtils.prototype.createPiwikTrackers = function (piwikConfigs) {
        for (var i = 0; i < piwikConfigs.length; i++) {
            var piwikConfig = piwikConfigs[i];
            this.trackerList.push(new PiwikTracker(piwikConfig.attrs));
        }
    };
    StatsUtils.prototype.createMatomoTrackers = function (matomoConfigs) {
        for (var i = 0; i < matomoConfigs.length; i++) {
            var matomoConfig = matomoConfigs[i];
            this.trackerList.push(new MatomoTracker(matomoConfig.attrs));
        }
    };
    StatsUtils.prototype.createWebTrendsTrackers = function (webTrendsConfigs) {
        for (var i = 0; i < webTrendsConfigs.length; i++) {
            var webTrendsConfig = webTrendsConfigs[i];
            this.trackerList.push(new WebTrendsTracker(webTrendsConfig.attrs));
        }
    };
    StatsUtils.prototype.createXitiTrackers = function (xitiConfigs) {
        for (var i = 0; i < xitiConfigs.length; i++) {
            var xitiConfig = xitiConfigs[i];
            if (xitiConfig.attrs.url) {
                xitiConfig.attrs.url = this.addCredentialsIfNeeded(xitiConfig.attrs.url);
            }
            this.trackerList.push(new XitiTracker(xitiConfig.attrs));
        }
    };
    StatsUtils.prototype.createPianoTrackers = function (pianoConfigs) {
        for (var i = 0; i < pianoConfigs.length; i++) {
            var pianoConfig = pianoConfigs[i];
            this.trackerList.push(new PianoTracker(pianoConfig.attrs));
        }
    };
    StatsUtils.prototype.trackQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isOnline, shouldTrack, maxTrackingPerbatch, delayBetweenBatches, i, tracking, trackingPage, trackingPageArgs, trackingEvent, trackingEventArgs, trackingProperty, trackingPropertyArgs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__userAgent__["a" /* default */].isOnlinePromise()];
                    case 1:
                        isOnline = _a.sent();
                        shouldTrack = this.config !== undefined && isOnline;
                        maxTrackingPerbatch = 10;
                        delayBetweenBatches = 2000;
                        if (shouldTrack) {
                            for (i = 0; i < maxTrackingPerbatch; i++) {
                                tracking = this.queue.pop();
                                if (tracking === undefined) {
                                    break;
                                }
                                switch (tracking.type) {
                                    case __WEBPACK_IMPORTED_MODULE_0__typings__["a" /* TrackingType */].Page:
                                        trackingPage = tracking;
                                        trackingPageArgs = trackingPage.arguments;
                                        this.trackPageOnAllTrackers(trackingPageArgs.page, trackingPageArgs.url, trackingPageArgs.title);
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_0__typings__["a" /* TrackingType */].Event:
                                        trackingEvent = tracking;
                                        trackingEventArgs = trackingEvent.arguments;
                                        this.trackEventOnAllTrackers(trackingEventArgs.category, trackingEventArgs.action, trackingEventArgs.label, trackingEventArgs.value);
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_0__typings__["a" /* TrackingType */].Property:
                                        trackingProperty = tracking;
                                        trackingPropertyArgs = trackingProperty.arguments;
                                        this.trackPropertyOnAllTrackers(trackingPropertyArgs.name, trackingPropertyArgs.value);
                                        break;
                                }
                            }
                            __WEBPACK_IMPORTED_MODULE_2__indexedDB_manager__["a" /* default */].setTrackingQueue(this.queue).then();
                            if (this.queue.length > 0) {
                                setTimeout(function () { return _this.trackQueue(); }, delayBetweenBatches);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StatsUtils.prototype.trackPageOnAllTrackers = function (page, url, title) {
        for (var i = 0; i < this.trackerList.length; i++) {
            this.trackPageIfLoaded(this.trackerList[i], page, url, title, 3);
        }
    };
    StatsUtils.prototype.trackEventOnAllTrackers = function (category, action, label, value) {
        for (var i = 0; i < this.trackerList.length; i++) {
            this.trackEventIfLoaded(this.trackerList[i], category, action, label, value, 3);
        }
    };
    StatsUtils.prototype.trackPropertyOnAllTrackers = function (name, value) {
        for (var i = 0; i < this.trackerList.length; i++) {
            this.trackPropertyIfLoaded(this.trackerList[i], name, value, 3);
        }
    };
    // tslint:disable-next-line no-any
    StatsUtils.prototype.trackIfLoaded = function (tracker, trackFunction, args, triesLeft) {
        var _this = this;
        if (tracker.isLoaded()) {
            trackFunction.apply(void 0, __spread(args));
            return;
        }
        if (triesLeft > 0) {
            setTimeout(function () {
                _this.trackIfLoaded(tracker, trackFunction, args, triesLeft - 1);
            }, 2000);
        }
    };
    StatsUtils.prototype.trackPageIfLoaded = function (tracker, page, url, title, triesLeft) {
        this.trackIfLoaded(tracker, tracker.trackPage.bind(tracker), [page, url, title], triesLeft);
    };
    StatsUtils.prototype.trackEventIfLoaded = function (tracker, category, action, label, value, triesLeft) {
        this.trackIfLoaded(tracker, tracker.trackEvent.bind(tracker), [category, action, label, value], triesLeft);
    };
    StatsUtils.prototype.trackPropertyIfLoaded = function (tracker, name, value, triesLeft) {
        if (tracker.trackProperty) {
            this.trackIfLoaded(tracker, tracker.trackProperty.bind(tracker), [name, value], triesLeft);
        }
    };
    StatsUtils.prototype.addCredentialsIfNeeded = function (url) {
        if (this.resourceCredentials === undefined) {
            return url;
        }
        var _a = this.resourceCredentials, login = _a.login, password = _a.password;
        var includesSeparator = url.includes('?');
        var startingSeparator = includesSeparator ? '&' : '?';
        var credentials = startingSeparator + "user=" + login + "&pass=" + password;
        return url + credentials;
    };
    StatsUtils.self = undefined;
    return StatsUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (StatsUtils);


/***/ }),
/* 290 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  exports.defaults = {
    "0.1": {
      explicitCharkey: false,
      trim: true,
      normalize: true,
      normalizeTags: false,
      attrkey: "@",
      charkey: "#",
      explicitArray: false,
      ignoreAttrs: false,
      mergeAttrs: false,
      explicitRoot: false,
      validator: null,
      xmlns: false,
      explicitChildren: false,
      childkey: '@@',
      charsAsChildren: false,
      includeWhiteChars: false,
      async: false,
      strict: true,
      attrNameProcessors: null,
      attrValueProcessors: null,
      tagNameProcessors: null,
      valueProcessors: null,
      emptyTag: ''
    },
    "0.2": {
      explicitCharkey: false,
      trim: false,
      normalize: false,
      normalizeTags: false,
      attrkey: "$",
      charkey: "_",
      explicitArray: true,
      ignoreAttrs: false,
      mergeAttrs: false,
      explicitRoot: true,
      validator: null,
      xmlns: false,
      explicitChildren: false,
      preserveChildrenOrder: false,
      childkey: '$$',
      charsAsChildren: false,
      includeWhiteChars: false,
      async: false,
      strict: true,
      attrNameProcessors: null,
      attrValueProcessors: null,
      tagNameProcessors: null,
      valueProcessors: null,
      rootName: 'root',
      xmldec: {
        'version': '1.0',
        'encoding': 'UTF-8',
        'standalone': true
      },
      doctype: null,
      renderOpts: {
        'pretty': true,
        'indent': '  ',
        'newline': '\n'
      },
      headless: false,
      chunkSize: 10000,
      emptyTag: '',
      cdata: false
    }
  };

}).call(this);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLDeclaration = __webpack_require__(204);

  XMLDocType = __webpack_require__(205);

  XMLCData = __webpack_require__(202);

  XMLComment = __webpack_require__(203);

  XMLElement = __webpack_require__(201);

  XMLRaw = __webpack_require__(210);

  XMLText = __webpack_require__(211);

  XMLProcessingInstruction = __webpack_require__(212);

  XMLDTDAttList = __webpack_require__(206);

  XMLDTDElement = __webpack_require__(208);

  XMLDTDEntity = __webpack_require__(207);

  XMLDTDNotation = __webpack_require__(209);

  XMLWriterBase = __webpack_require__(435);

  module.exports = XMLStringWriter = (function(superClass) {
    extend(XMLStringWriter, superClass);

    function XMLStringWriter(options) {
      XMLStringWriter.__super__.constructor.call(this, options);
    }

    XMLStringWriter.prototype.document = function(doc) {
      var child, i, len, r, ref;
      this.textispresent = false;
      r = '';
      ref = doc.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        r += (function() {
          switch (false) {
            case !(child instanceof XMLDeclaration):
              return this.declaration(child);
            case !(child instanceof XMLDocType):
              return this.docType(child);
            case !(child instanceof XMLComment):
              return this.comment(child);
            case !(child instanceof XMLProcessingInstruction):
              return this.processingInstruction(child);
            default:
              return this.element(child, 0);
          }
        }).call(this);
      }
      if (this.pretty && r.slice(-this.newline.length) === this.newline) {
        r = r.slice(0, -this.newline.length);
      }
      return r;
    };

    XMLStringWriter.prototype.attribute = function(att) {
      return ' ' + att.name + '="' + att.value + '"';
    };

    XMLStringWriter.prototype.cdata = function(node, level) {
      return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
    };

    XMLStringWriter.prototype.comment = function(node, level) {
      return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
    };

    XMLStringWriter.prototype.declaration = function(node, level) {
      var r;
      r = this.space(level);
      r += '<?xml version="' + node.version + '"';
      if (node.encoding != null) {
        r += ' encoding="' + node.encoding + '"';
      }
      if (node.standalone != null) {
        r += ' standalone="' + node.standalone + '"';
      }
      r += this.spacebeforeslash + '?>';
      r += this.newline;
      return r;
    };

    XMLStringWriter.prototype.docType = function(node, level) {
      var child, i, len, r, ref;
      level || (level = 0);
      r = this.space(level);
      r += '<!DOCTYPE ' + node.root().name;
      if (node.pubID && node.sysID) {
        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
      } else if (node.sysID) {
        r += ' SYSTEM "' + node.sysID + '"';
      }
      if (node.children.length > 0) {
        r += ' [';
        r += this.newline;
        ref = node.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          r += (function() {
            switch (false) {
              case !(child instanceof XMLDTDAttList):
                return this.dtdAttList(child, level + 1);
              case !(child instanceof XMLDTDElement):
                return this.dtdElement(child, level + 1);
              case !(child instanceof XMLDTDEntity):
                return this.dtdEntity(child, level + 1);
              case !(child instanceof XMLDTDNotation):
                return this.dtdNotation(child, level + 1);
              case !(child instanceof XMLCData):
                return this.cdata(child, level + 1);
              case !(child instanceof XMLComment):
                return this.comment(child, level + 1);
              case !(child instanceof XMLProcessingInstruction):
                return this.processingInstruction(child, level + 1);
              default:
                throw new Error("Unknown DTD node type: " + child.constructor.name);
            }
          }).call(this);
        }
        r += ']';
      }
      r += this.spacebeforeslash + '>';
      r += this.newline;
      return r;
    };

    XMLStringWriter.prototype.element = function(node, level) {
      var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
      level || (level = 0);
      textispresentwasset = false;
      if (this.textispresent) {
        this.newline = '';
        this.pretty = false;
      } else {
        this.newline = this.newlinedefault;
        this.pretty = this.prettydefault;
      }
      space = this.space(level);
      r = '';
      r += space + '<' + node.name;
      ref = node.attributes;
      for (name in ref) {
        if (!hasProp.call(ref, name)) continue;
        att = ref[name];
        r += this.attribute(att);
      }
      if (node.children.length === 0 || node.children.every(function(e) {
        return e.value === '';
      })) {
        if (this.allowEmpty) {
          r += '></' + node.name + '>' + this.newline;
        } else {
          r += this.spacebeforeslash + '/>' + this.newline;
        }
      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
        r += '>';
        r += node.children[0].value;
        r += '</' + node.name + '>' + this.newline;
      } else {
        if (this.dontprettytextnodes) {
          ref1 = node.children;
          for (i = 0, len = ref1.length; i < len; i++) {
            child = ref1[i];
            if (child.value != null) {
              this.textispresent++;
              textispresentwasset = true;
              break;
            }
          }
        }
        if (this.textispresent) {
          this.newline = '';
          this.pretty = false;
          space = this.space(level);
        }
        r += '>' + this.newline;
        ref2 = node.children;
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          child = ref2[j];
          r += (function() {
            switch (false) {
              case !(child instanceof XMLCData):
                return this.cdata(child, level + 1);
              case !(child instanceof XMLComment):
                return this.comment(child, level + 1);
              case !(child instanceof XMLElement):
                return this.element(child, level + 1);
              case !(child instanceof XMLRaw):
                return this.raw(child, level + 1);
              case !(child instanceof XMLText):
                return this.text(child, level + 1);
              case !(child instanceof XMLProcessingInstruction):
                return this.processingInstruction(child, level + 1);
              default:
                throw new Error("Unknown XML node type: " + child.constructor.name);
            }
          }).call(this);
        }
        if (textispresentwasset) {
          this.textispresent--;
        }
        if (!this.textispresent) {
          this.newline = this.newlinedefault;
          this.pretty = this.prettydefault;
        }
        r += space + '</' + node.name + '>' + this.newline;
      }
      return r;
    };

    XMLStringWriter.prototype.processingInstruction = function(node, level) {
      var r;
      r = this.space(level) + '<?' + node.target;
      if (node.value) {
        r += ' ' + node.value;
      }
      r += this.spacebeforeslash + '?>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.raw = function(node, level) {
      return this.space(level) + node.value + this.newline;
    };

    XMLStringWriter.prototype.text = function(node, level) {
      return this.space(level) + node.value + this.newline;
    };

    XMLStringWriter.prototype.dtdAttList = function(node, level) {
      var r;
      r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
      if (node.defaultValueType !== '#DEFAULT') {
        r += ' ' + node.defaultValueType;
      }
      if (node.defaultValue) {
        r += ' "' + node.defaultValue + '"';
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.dtdElement = function(node, level) {
      return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
    };

    XMLStringWriter.prototype.dtdEntity = function(node, level) {
      var r;
      r = this.space(level) + '<!ENTITY';
      if (node.pe) {
        r += ' %';
      }
      r += ' ' + node.name;
      if (node.value) {
        r += ' "' + node.value + '"';
      } else {
        if (node.pubID && node.sysID) {
          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
        } else if (node.sysID) {
          r += ' SYSTEM "' + node.sysID + '"';
        }
        if (node.nData) {
          r += ' NDATA ' + node.nData;
        }
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.dtdNotation = function(node, level) {
      var r;
      r = this.space(level) + '<!NOTATION ' + node.name;
      if (node.pubID && node.sysID) {
        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
      } else if (node.pubID) {
        r += ' PUBLIC "' + node.pubID + '"';
      } else if (node.sysID) {
        r += ' SYSTEM "' + node.sysID + '"';
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.openNode = function(node, level) {
      var att, name, r, ref;
      level || (level = 0);
      if (node instanceof XMLElement) {
        r = this.space(level) + '<' + node.name;
        ref = node.attributes;
        for (name in ref) {
          if (!hasProp.call(ref, name)) continue;
          att = ref[name];
          r += this.attribute(att);
        }
        r += (node.children ? '>' : '/>') + this.newline;
        return r;
      } else {
        r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
        if (node.pubID && node.sysID) {
          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
        } else if (node.sysID) {
          r += ' SYSTEM "' + node.sysID + '"';
        }
        r += (node.children ? ' [' : '>') + this.newline;
        return r;
      }
    };

    XMLStringWriter.prototype.closeNode = function(node, level) {
      level || (level = 0);
      switch (false) {
        case !(node instanceof XMLElement):
          return this.space(level) + '</' + node.name + '>' + this.newline;
        case !(node instanceof XMLDocType):
          return this.space(level) + ']>' + this.newline;
      }
    };

    return XMLStringWriter;

  })(XMLWriterBase);

}).call(this);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(437);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(293);
exports.Duplex = __webpack_require__(113);
exports.Transform = __webpack_require__(440);
exports.PassThrough = __webpack_require__(808);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(215);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(167);
util.inherits = __webpack_require__(136);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(807)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(438);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(216).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(439);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(113);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(113);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(288).setImmediate, __webpack_require__(20)))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(216).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadAllPopupActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeDownloadAllPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeDownloadAllPopupIfNeeded; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;

var DownloadAllPopupActionKeys;
(function (DownloadAllPopupActionKeys) {
    DownloadAllPopupActionKeys["CLOSE"] = "@@DownloadAllPopup/CLOSE";
})(DownloadAllPopupActionKeys || (DownloadAllPopupActionKeys = {}));
var closeDownloadAllPopup = function (dontAskAgain) {
    if (dontAskAgain === void 0) { dontAskAgain = false; }
    return function (dispatch) {
        if (dontAskAgain) {
            __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].setDownloadPopupDontAskAgain().then();
        }
        dispatch({
            type: DownloadAllPopupActionKeys.CLOSE,
        });
    };
};
var closeDownloadAllPopupIfNeeded = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var downloadPopupDontAskAgain;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_indexedDB_manager__["a" /* default */].getDownloadPopupDontAskAgain()];
            case 1:
                downloadPopupDontAskAgain = _a.sent();
                if (downloadPopupDontAskAgain) {
                    dispatch(closeDownloadAllPopup());
                }
                return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PendingTasksManagerActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadPendingTasksManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addPendingShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




var PendingTasksManagerActionKeys;
(function (PendingTasksManagerActionKeys) {
    PendingTasksManagerActionKeys["INIT_PENDING_TASKS"] = "@@offlineManager/INIT_PENDING_TASKS";
    PendingTasksManagerActionKeys["ADD_PENDING_SHARE"] = "@@offlineManager/ADD_PENDING_SHARE";
    PendingTasksManagerActionKeys["CLEAR_PENDING_SHARES"] = "@@offlineManager/CLEAR_PENDING_SHARES";
})(PendingTasksManagerActionKeys || (PendingTasksManagerActionKeys = {}));
var loadPendingTasksManager = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var previousPendingTasks;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_indexedDB_manager__["a" /* default */].getPendingTasks()];
            case 1:
                previousPendingTasks = _a.sent();
                if (previousPendingTasks) {
                    dispatch(initPendingTasks(previousPendingTasks));
                }
                dispatch(sendPendingShares());
                __WEBPACK_IMPORTED_MODULE_0__utils_userAgent__["a" /* default */].subscribeToConnectionIsUp(function () {
                    dispatch(sendPendingShares());
                });
                return [2 /*return*/];
        }
    });
}); }; };
var sendPendingShares = function () { return function (dispatch, getState) {
    var pendingTasksManager = getState().pendingTasksManager;
    var shares = pendingTasksManager.shares;
    if (__WEBPACK_IMPORTED_MODULE_0__utils_userAgent__["a" /* default */].isOnline() && shares.length !== 0) {
        for (var i = 0; i < shares.length; i++) {
            var pendingShare = shares[i];
            __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].shareContent(pendingShare);
        }
        dispatch(clearPendingShares());
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__NotificationBar_actions__["c" /* createNotification */])('info.selection_sent'));
    }
}; };
var initPendingTasks = function (pendingTasks) { return function (dispatch, getState) {
    var action = {
        type: PendingTasksManagerActionKeys.INIT_PENDING_TASKS,
        pendingTasks: pendingTasks,
    };
    dispatch(action);
}; };
var clearPendingShares = function () { return function (dispatch, getState) {
    var action = {
        type: PendingTasksManagerActionKeys.CLEAR_PENDING_SHARES,
    };
    dispatch(action);
}; };
var addPendingShare = function (pendingShare) { return function (dispatch, getState) {
    var action = {
        type: PendingTasksManagerActionKeys.ADD_PENDING_SHARE,
        pendingShare: pendingShare,
    };
    dispatch(action);
}; };



/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReadItemsStatusActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateLastVersionRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadReadStatusStore; });
/* unused harmony export removeObsoleteReadItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;


var ReadItemsStatusActionKeys;
(function (ReadItemsStatusActionKeys) {
    ReadItemsStatusActionKeys["INIT_READ_STATUS_STORE"] = "@@readStatus/INIT_READ_STATUS_STORE";
    ReadItemsStatusActionKeys["UPDATE_READ_STATUS"] = "@@readStatus/UPDATE_READ_STATUS";
    ReadItemsStatusActionKeys["REMOVE_ITEM"] = "@@readStatus/REMOVE_ITEM";
})(ReadItemsStatusActionKeys || (ReadItemsStatusActionKeys = {}));
var removeObsoleteReadItems = function () { return function (dispatch, getState) {
    var _a = getState(), readStatus = _a.readStatus, driveList = _a.driveList;
    var driveItems = driveList.driveItems;
    var items = readStatus.items;
    Object.keys(items).forEach(function (id) {
        if (!driveItems[id]) {
            dispatch({
                type: ReadItemsStatusActionKeys.REMOVE_ITEM,
                id: id
            });
        }
    });
    return Promise.resolve();
}; };
var loadReadStatusStore = function () { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var storedReadItems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].getReadStatus()];
            case 1:
                storedReadItems = _a.sent();
                if (storedReadItems) {
                    dispatch({
                        type: ReadItemsStatusActionKeys.INIT_READ_STATUS_STORE,
                        storedReadItems: storedReadItems
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
var updateReadItemsLocalStorage = function () { return function (dispatch, getState) {
    var readStatus = getState().readStatus;
    var items = readStatus.items;
    var readItemsToStore = [];
    Object.keys(items).forEach(function (key) {
        var id = parseInt(key, 10);
        var item = items[id];
        readItemsToStore.push({
            id: id,
            lastVersionRead: item.lastVersionRead
        });
    });
    __WEBPACK_IMPORTED_MODULE_1__utils_indexedDB_manager__["a" /* default */].setReadStatus(readItemsToStore).then();
}; };
var updateLastVersionRead = function (id) { return function (dispatch, getState) {
    var _a = getState(), driveList = _a.driveList, downloadManager = _a.downloadManager;
    var driveItems = driveList.driveItems;
    var version = driveItems[id].version;
    var isDownloaded = __WEBPACK_IMPORTED_MODULE_0__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, id);
    var versionToSet = isDownloaded ? downloadManager.items[id].version : version;
    dispatch({
        type: ReadItemsStatusActionKeys.UPDATE_READ_STATUS,
        id: id,
        version: versionToSet
    });
    dispatch(updateReadItemsLocalStorage());
}; };



/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseHtmlString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serializeHtmlToString; });
var parseHtmlString = function (htmlString) {
    htmlString = htmlString.replace(/\s+<li/g, '<li');
    var parser = new DOMParser();
    return parser.parseFromString(htmlString, 'text/html');
};
var serializeHtmlToString = function (htmlDocument) { return (htmlDocument.body.innerHTML); };


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(825);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && __webpack_require__(60)('Object.prototype.toString');

// https://ecma-international.org/ecma-262/6.0/#sec-isarray

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(115);

var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Type, Desc) {
		if (Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

module.exports = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (!predicate(Type, value)) {
		throw new $TypeError(argumentName + ' must be a ' + recordType);
	}
};


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormField; });
var FormField;
(function (FormField) {
    FormField["Company"] = "company";
    FormField["Email"] = "contactEmail";
    FormField["Firstname"] = "firstname";
    FormField["Message"] = "message";
    FormField["Subject"] = "subject";
    FormField["Phone"] = "phone";
    FormField["Position"] = "position";
    FormField["Surname"] = "surname";
    FormField["Contact"] = "contact";
    FormField["Documents"] = "documents";
    FormField["Notes"] = "notes";
    FormField["CreateDeal"] = "createDeal";
})(FormField || (FormField = {}));



/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackToPublicationActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setLastPublication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resumeLastPublication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DriveItemList_actions__ = __webpack_require__(12);

var BackToPublicationActionKeys;
(function (BackToPublicationActionKeys) {
    BackToPublicationActionKeys["SET_LAST_PUBLICATION"] = "@@BackToPublication/SET_LAST_PUBLICATION";
})(BackToPublicationActionKeys || (BackToPublicationActionKeys = {}));
var setLastPublication = function (publicationId, page) {
    return function (dispatch) {
        var action = {
            type: BackToPublicationActionKeys.SET_LAST_PUBLICATION,
            publicationId: publicationId,
            page: page,
        };
        dispatch(action);
    };
};
var resumeLastPublication = function (publicationId, page) {
    return function (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(publicationId))
            .then(function (driveItem) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__DriveItemList_actions__["L" /* viewDriveItem */])(driveItem, __WEBPACK_IMPORTED_MODULE_0__DriveItemList_actions__["c" /* DriveItemOrigin */].Menu, {
                page: page,
                hideWelcomePage: true
            }));
        });
    };
};



/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComboActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetExternalPublicationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectExternalSpread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectAllExternalSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deselectAllExternalSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return zoomExternalSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createCombo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getExternalPublicationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createComboWithExternalSpreads; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_routes__ = __webpack_require__(13);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;











var ComboActionKeys;
(function (ComboActionKeys) {
    ComboActionKeys["CREATE_COMBO"] = "@@editor/combo/CREATE_COMBO";
    ComboActionKeys["UPDATE_COMBO_PERCENTAGE"] = "@@editor/combo/UPDATE_COMBO_PERCENTAGE";
    ComboActionKeys["FINISH_COMBO"] = "@@editor/combo/FINISH_COMBO";
    ComboActionKeys["GET_EXTERNAL_PUBLICATION_DATA"] = "@@editor/combo/GET_EXTERNAL_PUBLICATION_DATA";
    ComboActionKeys["SET_EXTERNAL_PUBLICATION_DATA"] = "@@editor/combo/SET_EXTERNAL_PUBLICATION_DATA";
    ComboActionKeys["RESET_EXTERNAL_PUBLICATION_DATA"] = "@@editor/combo/RESET_EXTERNAL_PUBLICATION_DATA";
    ComboActionKeys["SELECT_EXTERNAL_SPREAD"] = "@@editor/combo/SELECT_EXTERNAL_SPREAD";
    ComboActionKeys["SELECT_ALL_EXTERNAL_SPREADS"] = "@@editor/combo/SELECT_ALL_EXTERNAL_SPREADS";
    ComboActionKeys["DESELECT_ALL_EXTERNAL_SPREADS"] = "@@editor/combo/DESELECT_ALL_EXTERNAL_SPREADS";
    ComboActionKeys["ZOOM_EXTERNAL_SPREADS"] = "@@editor/combo/ZOOM_EXTERNAL_SPREADS";
})(ComboActionKeys || (ComboActionKeys = {}));
var setExternalPublicationData = function (data) { return ({
    type: ComboActionKeys.SET_EXTERNAL_PUBLICATION_DATA,
    data: data,
}); };
var resetExternalPublicationData = function () { return ({
    type: ComboActionKeys.RESET_EXTERNAL_PUBLICATION_DATA,
}); };
var selectExternalSpread = function (spreadIndex, allSpreads, isCtrlPressed, isShiftPressed) { return ({
    type: ComboActionKeys.SELECT_EXTERNAL_SPREAD,
    spreadIndex: spreadIndex,
    allSpreads: allSpreads,
    isCtrlPressed: isCtrlPressed,
    isShiftPressed: isShiftPressed,
}); };
var selectAllExternalSpreads = function () { return ({
    type: ComboActionKeys.SELECT_ALL_EXTERNAL_SPREADS,
}); };
var deselectAllExternalSpreads = function () { return ({
    type: ComboActionKeys.DESELECT_ALL_EXTERNAL_SPREADS,
}); };
var zoomExternalSpreads = function (zoom, autoItemsInRow) { return ({
    type: ComboActionKeys.ZOOM_EXTERNAL_SPREADS,
    zoom: zoom,
    autoItemsInRow: autoItemsInRow,
}); };
var createCombo = function (resource) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, label, spreads, _b, clientId_1, resourceId_1, resourcesGIds, spreadsAmountBeforeCombo_1, status_1, onProgressUpdate, onProgressError, onProgressFinish, shouldCancelProgress, onProgressCancel, error_1;
    var _this = this;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 6]);
                dispatch({
                    type: ComboActionKeys.CREATE_COMBO,
                });
                _a = getState().editor, label = _a.label.label, spreads = _a.pagesController.spreads;
                _b = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId_1 = _b.clientId, resourceId_1 = _b.tempGId;
                resourcesGIds = [resourceId_1, resource.id];
                spreadsAmountBeforeCombo_1 = spreads.length;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* default */].createCombo(clientId_1, resourceId_1, resourcesGIds, label)];
            case 1:
                status_1 = (_c.sent()).status;
                onProgressUpdate = function (percentage) {
                    var action = {
                        type: ComboActionKeys.UPDATE_COMBO_PERCENTAGE,
                        percentage: percentage
                    };
                    dispatch(action);
                };
                onProgressError = function () {
                    dispatch({
                        type: ComboActionKeys.FINISH_COMBO,
                    });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.combine_error'));
                };
                onProgressFinish = function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, dispatch(finishComboCreation(clientId_1, resourceId_1, spreadsAmountBeforeCombo_1))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); };
                shouldCancelProgress = function (state) {
                    return !Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isEditorOpened */])(state);
                };
                onProgressCancel = function () {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["f" /* reset */])(true));
                };
                if (!![
                    __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemStatus.LIVE,
                    __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemStatus.ERROR,
                ].includes(status_1)) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* default */].getPublicationProgress(clientId_1, resourceId_1, onProgressUpdate, onProgressError, onProgressFinish, shouldCancelProgress, onProgressCancel)];
            case 2:
                _c.sent();
                return [3 /*break*/, 4];
            case 3:
                if (status_1 === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemStatus.LIVE) {
                    onProgressFinish();
                }
                if (status_1 === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemStatus.ERROR) {
                    onProgressError();
                }
                _c.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                error_1 = _c.sent();
                dispatch({
                    type: ComboActionKeys.FINISH_COMBO,
                });
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.combine_error'));
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
var getExternalPublicationData = function (globalId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var action, clientId, _a, enrichmentInfo, _b, _c, configsPath, thumbnailPath, spreadPath, displayMode, firstFrameMode, totalPages, format, pagesData, isPdfProposal, spreads, parsedConfigs, configs, data, error_2;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 4, , 5]);
                action = {
                    type: ComboActionKeys.GET_EXTERNAL_PUBLICATION_DATA,
                };
                dispatch(action);
                clientId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["g" /* getClientAndResourceIds */])().clientId;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* default */].getIndesignEditorData(clientId, globalId, false)];
            case 1:
                _a = _d.sent(), enrichmentInfo = _a.enrichmentInfo, _b = _a.enrichmentInfo, _c = _b.configsPath, configsPath = _c === void 0 ? '' : _c, thumbnailPath = _b.thumbnailPath, spreadPath = _b.spreadPath, displayMode = _b.displayMode, firstFrameMode = _b.firstFrameMode, totalPages = _b.totalPages, format = _b.format, pagesData = _a.pagesData;
                isPdfProposal = format === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].PublicationFormat.PDF_EDITABLE;
                spreads = [];
                parsedConfigs = void 0;
                if (!(!isPdfProposal && configsPath)) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* default */].getEditorResource(globalId, configsPath)];
            case 2:
                configs = _d.sent();
                parsedConfigs = JSON.parse(configs);
                _d.label = 3;
            case 3:
                spreads = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["x" /* getPageSpreads */])(displayMode, firstFrameMode, totalPages, isPdfProposal ? pagesData.map(function (page) { return ({ showAlone: false }); }) : parsedConfigs.pagesData, enrichmentInfo.dimensions);
                data = {
                    globalId: globalId,
                    spreads: spreads,
                    thumbnails: pagesData.map(function (_a) {
                        var label = _a.label, position = _a.position;
                        return ({ label: label, position: position });
                    }),
                    thumbnailPath: thumbnailPath,
                    spreadPath: spreadPath,
                };
                if (parsedConfigs) {
                    data.configs = parsedConfigs;
                }
                dispatch(setExternalPublicationData(data));
                return [3 /*break*/, 5];
            case 4:
                error_2 = _d.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.fetch_publication_data'));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var createComboWithExternalSpreads = function (callback) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, spreads, _c, sourceId, externalSpreads_1, selectedSpreadIndices, driveItems, _d, clientId, resourceId, originalGId, externalPages, spreadsAmountBeforeCombo, globalId, isPlaylist, parentOrigin, error_3;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, 4, 5]);
                dispatch({
                    type: ComboActionKeys.CREATE_COMBO,
                });
                _a = getState(), _b = _a.editor, spreads = _b.pagesController.spreads, _c = _b.combo.externalPublication, sourceId = _c.globalId, externalSpreads_1 = _c.spreads, selectedSpreadIndices = _c.selection.spreadIndices, driveItems = _a.driveList.driveItems;
                _d = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _d.clientId, resourceId = _d.tempGId, originalGId = _d.originalGId;
                externalPages = selectedSpreadIndices.reduce(function (acc, current) {
                    acc = acc.concat(externalSpreads_1[current]);
                    return acc;
                }, []);
                spreadsAmountBeforeCombo = spreads.length;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* default */].createComboWithExternalSpreads(clientId, resourceId, sourceId, externalPages)];
            case 1:
                globalId = (_e.sent()).globalId;
                isPlaylist = originalGId && driveItems[originalGId] && driveItems[originalGId].format === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].PublicationFormat.EPUB_PLAYLIST;
                if (!isPlaylist && globalId) {
                    if (__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].isEmbedMode()) {
                        parentOrigin = new URL(document.referrer).origin;
                        window.parent.postMessage({ type: __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* EditorMessageTypes */].NEW_PLAYLIST_ID, globalId: globalId }, parentOrigin);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].getPathEditor(clientId, globalId));
                    }
                }
                return [4 /*yield*/, dispatch(finishComboCreation(clientId, resourceId, spreadsAmountBeforeCombo))];
            case 2:
                _e.sent();
                if (callback && typeof callback === 'function') {
                    callback();
                }
                return [3 /*break*/, 5];
            case 3:
                error_3 = _e.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.combine_error'));
                return [3 /*break*/, 5];
            case 4:
                dispatch({
                    type: ComboActionKeys.FINISH_COMBO,
                });
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var finishComboCreation = function (clientId, resourceId, spreadsAmountBeforeCombo) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var spreads, spreadsAmountAfterCombo, activeSpread, activeSpreadIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["f" /* reset */])(true));
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__sources__["c" /* getData */])(clientId, resourceId, false))];
            case 1:
                _a.sent();
                if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isEditorOpened */])()) {
                    spreads = getState().editor.pagesController.spreads;
                    spreadsAmountAfterCombo = spreads.length;
                    activeSpread = spreadsAmountBeforeCombo === spreadsAmountAfterCombo
                        ? spreads[spreads.length - 1]
                        : spreads[spreadsAmountBeforeCombo];
                    activeSpreadIndex = spreads.indexOf(activeSpread);
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__pagesController__["b" /* changePageSpread */])(activeSpreadIndex, false));
                }
                return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return StyledSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OptionsHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OptionsListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OptionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OptionsListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ListTypeOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var StyledSelect = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 47px;\n\tpadding: 0 10px;\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 47px;\n\tpadding: 0 10px;\n"])));
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-right: auto;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 18px;\n\tcolor: ", ";\n"], ["\n\tmargin-right: auto;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 18px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var ButtonValue = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: 10px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tbackground-color: transparent;\n\tcursor: pointer;\n"], ["\n\tmargin-left: 10px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tbackground-color: transparent;\n\tcursor: pointer;\n"])), __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White);
var ButtonIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 10px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tmargin-left: 14px;\n\t\tfill: ", ";\n\t\ttransform: rotate(180deg);\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 10px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tmargin-left: 14px;\n\t\tfill: ", ";\n\t\ttransform: rotate(180deg);\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 25));
var Color = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 145px;\n\theight: 33px;\n\tborder: 1px solid ", ";\n\tborder-radius: 9px;\n"], ["\n\tbox-sizing: border-box;\n\twidth: 145px;\n\theight: 33px;\n\tborder: 1px solid ", ";\n\tborder-radius: 9px;\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 25));
var Options = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: absolute;\n\tz-index: 2;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding: 15px 0;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n"], ["\n\tposition: absolute;\n\tz-index: 2;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding: 15px 0;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].Grey900);
var OptionsHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition: relative;\n\tpadding: 0 85px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 17px;\n\tline-height: 16px;\n\tcolor: ", ";\n\ttext-align: center;\n"], ["\n\tposition: relative;\n\tpadding: 0 85px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 17px;\n\tline-height: 16px;\n\tcolor: ", ";\n\ttext-align: center;\n"])), __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White);
var OptionsListWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\theight: calc(100% - 35px);\n\tmargin-top: 20px;\n\tpadding: 16px;\n\toverflow-y: auto;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\theight: calc(100% - 35px);\n\tmargin-top: 20px;\n\tpadding: 16px;\n\toverflow-y: auto;\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__styles__["j" /* getEditorScrollStyles */])({ width: 4 }));
var OptionsList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n"], ["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n"])));
var OptionsListItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\n\t&:first-child {\n\t\tborder-radius: 8px 8px 0 0;\n\t}\n\n\t&:last-child {\n\t\tborder-radius: 0 0 8px 8px;\n\t}\n\n\t&:only-child {\n\t\tborder-radius: 8px;\n\t}\n\n\t&:not(:first-child) {\n\t\tposition: relative;\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 15px;\n\t\t\tright: 0;\n\t\t\theight: 1px;\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\n\t\t&::after {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t&:hover + &::after {\n\t\tbackground-color: transparent;\n\t}\n"], ["\n\tbackground-color: ", ";\n\n\t&:first-child {\n\t\tborder-radius: 8px 8px 0 0;\n\t}\n\n\t&:last-child {\n\t\tborder-radius: 0 0 8px 8px;\n\t}\n\n\t&:only-child {\n\t\tborder-radius: 8px;\n\t}\n\n\t&:not(:first-child) {\n\t\tposition: relative;\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 15px;\n\t\t\tright: 0;\n\t\t\theight: 1px;\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\n\t\t&::after {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t&:hover + &::after {\n\t\tbackground-color: transparent;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 10), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 30), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 25));
var ButtonOption = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tposition: relative;\n\theight: 44px;\n\twidth: 100%;\n\tpadding: 0 20px 0 50px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-size: 15px;\n\tline-height: 44px;\n\tcolor: ", ";\n\ttext-align: left;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: pointer;\n\n\t> svg {\n\t\tposition: absolute;\n\t\ttop: 14px;\n\t\tleft: 20px;\n\t\twidth: 17px;\n\t\theight: 15px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: relative;\n\theight: 44px;\n\twidth: 100%;\n\tpadding: 0 20px 0 50px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-size: 15px;\n\tline-height: 44px;\n\tcolor: ", ";\n\ttext-align: left;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: pointer;\n\n\t> svg {\n\t\tposition: absolute;\n\t\ttop: 14px;\n\t\tleft: 20px;\n\t\twidth: 17px;\n\t\theight: 15px;\n\t\tfill: ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].White, 75), __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].Blue450);
var ButtonBack = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonBack */])(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 15px;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 15px;\n"])));
var ListTypeOption = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\tsvg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\tsvg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tfill: currentColor;\n\t}\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rnd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_draggable__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_draggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_re_resizable__ = __webpack_require__(890);




/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var Draggable = __WEBPACK_IMPORTED_MODULE_1_react_draggable___default.a;
var resizableStyle = {
    width: "auto",
    height: "auto",
    display: "inline-block",
    position: "absolute",
    top: 0,
    left: 0,
};
var getEnableResizingByFlag = function (flag) { return ({
    bottom: flag,
    bottomLeft: flag,
    bottomRight: flag,
    left: flag,
    right: flag,
    top: flag,
    topLeft: flag,
    topRight: flag,
}); };
var Rnd = /** @class */ (function (_super) {
    __extends(Rnd, _super);
    function Rnd(props) {
        var _this = _super.call(this, props) || this;
        _this.resizing = false;
        _this.resizingPosition = { x: 0, y: 0 };
        _this.offsetFromParent = { left: 0, top: 0 };
        _this.resizableElement = { current: null };
        _this.refDraggable = function (c) {
            if (!c)
                return;
            _this.draggable = c;
        };
        _this.refResizable = function (c) {
            if (!c)
                return;
            _this.resizable = c;
            _this.resizableElement.current = c.resizable;
        };
        _this.state = {
            original: {
                x: 0,
                y: 0,
            },
            bounds: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
            maxWidth: props.maxWidth,
            maxHeight: props.maxHeight,
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.onResizeStop = _this.onResizeStop.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.onDrag = _this.onDrag.bind(_this);
        _this.onDragStop = _this.onDragStop.bind(_this);
        _this.getMaxSizesFromProps = _this.getMaxSizesFromProps.bind(_this);
        return _this;
    }
    Rnd.prototype.componentDidMount = function () {
        this.updateOffsetFromParent();
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        var _b = this.getDraggablePosition(), x = _b.x, y = _b.y;
        this.draggable.setState({
            x: x - left,
            y: y - top,
        });
        // HACK: Apply position adjustment
        this.forceUpdate();
    };
    // HACK: To get `react-draggable` state x and y.
    Rnd.prototype.getDraggablePosition = function () {
        var _a = this.draggable.state, x = _a.x, y = _a.y;
        return { x: x, y: y };
    };
    Rnd.prototype.getParent = function () {
        return this.resizable && this.resizable.parentNode;
    };
    Rnd.prototype.getParentSize = function () {
        return this.resizable.getParentSize();
    };
    Rnd.prototype.getMaxSizesFromProps = function () {
        var maxWidth = typeof this.props.maxWidth === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth;
        var maxHeight = typeof this.props.maxHeight === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
        return { maxWidth: maxWidth, maxHeight: maxHeight };
    };
    Rnd.prototype.getSelfElement = function () {
        return this.resizable && this.resizable.resizable;
    };
    Rnd.prototype.getOffsetHeight = function (boundary) {
        var scale = this.props.scale;
        switch (this.props.bounds) {
            case "window":
                return window.innerHeight / scale;
            case "body":
                return document.body.offsetHeight / scale;
            default:
                return boundary.offsetHeight;
        }
    };
    Rnd.prototype.getOffsetWidth = function (boundary) {
        var scale = this.props.scale;
        switch (this.props.bounds) {
            case "window":
                return window.innerWidth / scale;
            case "body":
                return document.body.offsetWidth / scale;
            default:
                return boundary.offsetWidth;
        }
    };
    Rnd.prototype.onDragStart = function (e, data) {
        if (this.props.onDragStart) {
            this.props.onDragStart(e, data);
        }
        if (!this.props.bounds)
            return;
        var parent = this.getParent();
        var scale = this.props.scale;
        var boundary;
        if (this.props.bounds === "parent") {
            boundary = parent;
        }
        else if (this.props.bounds === "body") {
            var parentRect_1 = parent.getBoundingClientRect();
            var parentLeft_1 = parentRect_1.left;
            var parentTop_1 = parentRect_1.top;
            var bodyRect = document.body.getBoundingClientRect();
            var left_1 = -(parentLeft_1 - parent.offsetLeft * scale - bodyRect.left) / scale;
            var top_1 = -(parentTop_1 - parent.offsetTop * scale - bodyRect.top) / scale;
            var right = (document.body.offsetWidth - this.resizable.size.width * scale) / scale + left_1;
            var bottom = (document.body.offsetHeight - this.resizable.size.height * scale) / scale + top_1;
            return this.setState({ bounds: { top: top_1, right: right, bottom: bottom, left: left_1 } });
        }
        else if (this.props.bounds === "window") {
            if (!this.resizable)
                return;
            var parentRect_2 = parent.getBoundingClientRect();
            var parentLeft_2 = parentRect_2.left;
            var parentTop_2 = parentRect_2.top;
            var left_2 = -(parentLeft_2 - parent.offsetLeft * scale) / scale;
            var top_2 = -(parentTop_2 - parent.offsetTop * scale) / scale;
            var right = (window.innerWidth - this.resizable.size.width * scale) / scale + left_2;
            var bottom = (window.innerHeight - this.resizable.size.height * scale) / scale + top_2;
            return this.setState({ bounds: { top: top_2, right: right, bottom: bottom, left: left_2 } });
        }
        else {
            boundary = document.querySelector(this.props.bounds);
        }
        if (!(boundary instanceof HTMLElement) || !(parent instanceof HTMLElement)) {
            return;
        }
        var boundaryRect = boundary.getBoundingClientRect();
        var boundaryLeft = boundaryRect.left;
        var boundaryTop = boundaryRect.top;
        var parentRect = parent.getBoundingClientRect();
        var parentLeft = parentRect.left;
        var parentTop = parentRect.top;
        var left = (boundaryLeft - parentLeft) / scale;
        var top = boundaryTop - parentTop;
        if (!this.resizable)
            return;
        this.updateOffsetFromParent();
        var offset = this.offsetFromParent;
        this.setState({
            bounds: {
                top: top - offset.top,
                right: left + (boundary.offsetWidth - this.resizable.size.width) - offset.left / scale,
                bottom: top + (boundary.offsetHeight - this.resizable.size.height) - offset.top,
                left: left - offset.left / scale,
            },
        });
    };
    Rnd.prototype.onDrag = function (e, data) {
        if (this.props.onDrag) {
            var offset = this.offsetFromParent;
            return this.props.onDrag(e, __assign(__assign({}, data), { x: data.x - offset.left, y: data.y - offset.top }));
        }
    };
    Rnd.prototype.onDragStop = function (e, data) {
        if (this.props.onDragStop) {
            var _a = this.offsetFromParent, left = _a.left, top_3 = _a.top;
            return this.props.onDragStop(e, __assign(__assign({}, data), { x: data.x + left, y: data.y + top_3 }));
        }
    };
    Rnd.prototype.onResizeStart = function (e, dir, elementRef) {
        e.stopPropagation();
        this.resizing = true;
        var scale = this.props.scale;
        var offset = this.offsetFromParent;
        var pos = this.getDraggablePosition();
        this.resizingPosition = { x: pos.x + offset.left, y: pos.y + offset.top };
        this.setState({
            original: pos,
        });
        if (this.props.bounds) {
            var parent_1 = this.getParent();
            var boundary = void 0;
            if (this.props.bounds === "parent") {
                boundary = parent_1;
            }
            else if (this.props.bounds === "body") {
                boundary = document.body;
            }
            else if (this.props.bounds === "window") {
                boundary = window;
            }
            else {
                boundary = document.querySelector(this.props.bounds);
            }
            var self_1 = this.getSelfElement();
            if (self_1 instanceof Element &&
                (boundary instanceof HTMLElement || boundary === window) &&
                parent_1 instanceof HTMLElement) {
                var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
                var parentSize = this.getParentSize();
                if (maxWidth && typeof maxWidth === "string") {
                    if (maxWidth.endsWith("%")) {
                        var ratio = Number(maxWidth.replace("%", "")) / 100;
                        maxWidth = parentSize.width * ratio;
                    }
                    else if (maxWidth.endsWith("px")) {
                        maxWidth = Number(maxWidth.replace("px", ""));
                    }
                }
                if (maxHeight && typeof maxHeight === "string") {
                    if (maxHeight.endsWith("%")) {
                        var ratio = Number(maxHeight.replace("%", "")) / 100;
                        maxHeight = parentSize.width * ratio;
                    }
                    else if (maxHeight.endsWith("px")) {
                        maxHeight = Number(maxHeight.replace("px", ""));
                    }
                }
                var selfRect = self_1.getBoundingClientRect();
                var selfLeft = selfRect.left;
                var selfTop = selfRect.top;
                var boundaryRect = this.props.bounds === "window" ? { left: 0, top: 0 } : boundary.getBoundingClientRect();
                var boundaryLeft = boundaryRect.left;
                var boundaryTop = boundaryRect.top;
                var offsetWidth = this.getOffsetWidth(boundary);
                var offsetHeight = this.getOffsetHeight(boundary);
                var hasLeft = dir.toLowerCase().endsWith("left");
                var hasRight = dir.toLowerCase().endsWith("right");
                var hasTop = dir.startsWith("top");
                var hasBottom = dir.startsWith("bottom");
                if (hasLeft && this.resizable) {
                    var max = (selfLeft - boundaryLeft) / scale + this.resizable.size.width;
                    this.setState({ maxWidth: max > Number(maxWidth) ? maxWidth : max });
                }
                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
                if (hasRight || (this.props.lockAspectRatio && !hasLeft)) {
                    var max = offsetWidth + (boundaryLeft - selfLeft) / scale;
                    this.setState({ maxWidth: max > Number(maxWidth) ? maxWidth : max });
                }
                if (hasTop && this.resizable) {
                    var max = (selfTop - boundaryTop) / scale + this.resizable.size.height;
                    this.setState({
                        maxHeight: max > Number(maxHeight) ? maxHeight : max,
                    });
                }
                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
                if (hasBottom || (this.props.lockAspectRatio && !hasTop)) {
                    var max = offsetHeight + (boundaryTop - selfTop) / scale;
                    this.setState({
                        maxHeight: max > Number(maxHeight) ? maxHeight : max,
                    });
                }
            }
        }
        else {
            this.setState({
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
            });
        }
        if (this.props.onResizeStart) {
            this.props.onResizeStart(e, dir, elementRef);
        }
    };
    Rnd.prototype.onResize = function (e, direction, elementRef, delta) {
        // INFO: Apply x and y position adjustments caused by resizing to draggable
        var newPos = { x: this.state.original.x, y: this.state.original.y };
        var left = -delta.width;
        var top = -delta.height;
        var directions = ["top", "left", "topLeft", "bottomLeft", "topRight"];
        if (directions.indexOf(direction) !== -1) {
            if (direction === "bottomLeft") {
                newPos.x += left;
            }
            else if (direction === "topRight") {
                newPos.y += top;
            }
            else {
                newPos.x += left;
                newPos.y += top;
            }
        }
        if (newPos.x !== this.draggable.state.x || newPos.y !== this.draggable.state.y) {
            this.draggable.setState(newPos);
        }
        this.updateOffsetFromParent();
        var offset = this.offsetFromParent;
        var x = this.getDraggablePosition().x + offset.left;
        var y = this.getDraggablePosition().y + offset.top;
        this.resizingPosition = { x: x, y: y };
        if (!this.props.onResize)
            return;
        this.props.onResize(e, direction, elementRef, delta, {
            x: x,
            y: y,
        });
    };
    Rnd.prototype.onResizeStop = function (e, direction, elementRef, delta) {
        this.resizing = false;
        var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
        this.setState({ maxWidth: maxWidth, maxHeight: maxHeight });
        if (this.props.onResizeStop) {
            this.props.onResizeStop(e, direction, elementRef, delta, this.resizingPosition);
        }
    };
    Rnd.prototype.updateSize = function (size) {
        if (!this.resizable)
            return;
        this.resizable.updateSize({ width: size.width, height: size.height });
    };
    Rnd.prototype.updatePosition = function (position) {
        this.draggable.setState(position);
    };
    Rnd.prototype.updateOffsetFromParent = function () {
        var scale = this.props.scale;
        var parent = this.getParent();
        var self = this.getSelfElement();
        if (!parent || self === null) {
            return {
                top: 0,
                left: 0,
            };
        }
        var parentRect = parent.getBoundingClientRect();
        var parentLeft = parentRect.left;
        var parentTop = parentRect.top;
        var selfRect = self.getBoundingClientRect();
        var position = this.getDraggablePosition();
        this.offsetFromParent = {
            left: selfRect.left - parentLeft - position.x * scale,
            top: selfRect.top - parentTop - position.y * scale,
        };
    };
    Rnd.prototype.render = function () {
        var _a = this.props, disableDragging = _a.disableDragging, style = _a.style, dragHandleClassName = _a.dragHandleClassName, position = _a.position, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, dragAxis = _a.dragAxis, dragGrid = _a.dragGrid, bounds = _a.bounds, enableUserSelectHack = _a.enableUserSelectHack, cancel = _a.cancel, children = _a.children, onResizeStart = _a.onResizeStart, onResize = _a.onResize, onResizeStop = _a.onResizeStop, onDragStart = _a.onDragStart, onDrag = _a.onDrag, onDragStop = _a.onDragStop, resizeHandleStyles = _a.resizeHandleStyles, resizeHandleClasses = _a.resizeHandleClasses, resizeHandleComponent = _a.resizeHandleComponent, enableResizing = _a.enableResizing, resizeGrid = _a.resizeGrid, resizeHandleWrapperClass = _a.resizeHandleWrapperClass, resizeHandleWrapperStyle = _a.resizeHandleWrapperStyle, scale = _a.scale, allowAnyClick = _a.allowAnyClick, resizableProps = __rest(_a, ["disableDragging", "style", "dragHandleClassName", "position", "onMouseDown", "onMouseUp", "dragAxis", "dragGrid", "bounds", "enableUserSelectHack", "cancel", "children", "onResizeStart", "onResize", "onResizeStop", "onDragStart", "onDrag", "onDragStop", "resizeHandleStyles", "resizeHandleClasses", "resizeHandleComponent", "enableResizing", "resizeGrid", "resizeHandleWrapperClass", "resizeHandleWrapperStyle", "scale", "allowAnyClick"]);
        var defaultValue = this.props.default ? __assign({}, this.props.default) : undefined;
        // Remove unknown props, see also https://reactjs.org/warnings/unknown-prop.html
        delete resizableProps.default;
        var cursorStyle = disableDragging || dragHandleClassName ? { cursor: "auto" } : { cursor: "move" };
        var innerStyle = __assign(__assign(__assign({}, resizableStyle), cursorStyle), style);
        var _b = this.offsetFromParent, left = _b.left, top = _b.top;
        var draggablePosition;
        if (position) {
            draggablePosition = {
                x: position.x - left,
                y: position.y - top,
            };
        }
        // INFO: Make uncontorolled component when resizing to control position by setPostion.
        var pos = this.resizing ? undefined : draggablePosition;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Draggable, { ref: this.refDraggable, handle: dragHandleClassName ? "." + dragHandleClassName : undefined, defaultPosition: defaultValue, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop, axis: dragAxis, disabled: disableDragging, grid: dragGrid, bounds: bounds ? this.state.bounds : undefined, position: pos, enableUserSelectHack: enableUserSelectHack, cancel: cancel, scale: scale, allowAnyClick: allowAnyClick, nodeRef: this.resizableElement },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_re_resizable__["a" /* Resizable */], __assign({}, resizableProps, { ref: this.refResizable, defaultSize: defaultValue, size: this.props.size, enable: typeof enableResizing === "boolean" ? getEnableResizingByFlag(enableResizing) : enableResizing, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeStop: this.onResizeStop, style: innerStyle, minWidth: this.props.minWidth, minHeight: this.props.minHeight, maxWidth: this.resizing ? this.state.maxWidth : this.props.maxWidth, maxHeight: this.resizing ? this.state.maxHeight : this.props.maxHeight, grid: resizeGrid, handleWrapperClass: resizeHandleWrapperClass, handleWrapperStyle: resizeHandleWrapperStyle, lockAspectRatio: this.props.lockAspectRatio, lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth, lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight, handleStyles: resizeHandleStyles, handleClasses: resizeHandleClasses, handleComponent: resizeHandleComponent, scale: this.props.scale }), children)));
    };
    Rnd.defaultProps = {
        maxWidth: Number.MAX_SAFE_INTEGER,
        maxHeight: Number.MAX_SAFE_INTEGER,
        scale: 1,
        onResizeStart: function () { },
        onResize: function () { },
        onResizeStop: function () { },
        onDragStart: function () { },
        onDrag: function () { },
        onDragStop: function () { },
    };
    return Rnd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));




/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTranslation = getTranslation;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(226);

var _getPrefix = _interopRequireWildcard(__webpack_require__(888));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var matchesSelectorFunc = '';

function matchesSelector(el
/*: Node*/
, selector
/*: string*/
)
/*: boolean*/
{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el
/*: Node*/
, selector
/*: string*/
, baseNode
/*: Node*/
)
/*: boolean*/
{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions);

  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions);

  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
} // Get from offsetParent


function offsetXYFromParent(evt
/*: {clientX: number, clientY: number}*/
, offsetParent
/*: HTMLElement*/
, scale
/*: number*/
)
/*: ControlPosition*/
{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: Object*/
{
  var translation = getTranslation(controlPos, positionOffset, 'px');
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
}

function createSVGTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: string*/
{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref2, positionOffset
/*: PositionOffsetControlPosition*/
, unitSuffix
/*: string*/
)
/*: string*/
{
  var x = _ref2.x,
      y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e
/*: MouseTouchEvent*/
, identifier
/*: number*/
)
/*: ?{clientX: number, clientY: number}*/
{
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e
/*: MouseTouchEvent*/
)
/*: ?number*/
{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themesCss__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts__ = __webpack_require__(1036);




/* harmony default export */ __webpack_exports__["a"] = ({
    getModifiedPageData: __WEBPACK_IMPORTED_MODULE_0__html__["b" /* getModifiedPageData */],
    getPageHtmlToSave: __WEBPACK_IMPORTED_MODULE_0__html__["c" /* getPageHtmlToSave */],
    getParsedCss: __WEBPACK_IMPORTED_MODULE_1__css__["a" /* getParsedCss */],
    getThemesAndSelectedThemeId: __WEBPACK_IMPORTED_MODULE_2__themesCss__["f" /* getThemesAndSelectedThemeId */],
    getCssWithUpdatedThemes: __WEBPACK_IMPORTED_MODULE_2__themesCss__["d" /* getCssWithUpdatedThemes */],
    getCssWithDuplicatedTheme: __WEBPACK_IMPORTED_MODULE_2__themesCss__["a" /* getCssWithDuplicatedTheme */],
    getCssWithoutRemovedTheme: __WEBPACK_IMPORTED_MODULE_2__themesCss__["e" /* getCssWithoutRemovedTheme */],
    getCssWithRenamedTheme: __WEBPACK_IMPORTED_MODULE_2__themesCss__["b" /* getCssWithRenamedTheme */],
    getCssWithUpdatedThemeColor: __WEBPACK_IMPORTED_MODULE_2__themesCss__["c" /* getCssWithUpdatedThemeColor */],
    getModifiedScripts: __WEBPACK_IMPORTED_MODULE_3__scripts__["a" /* getModifiedScripts */],
    getAccessiblePageHtmlToSave: __WEBPACK_IMPORTED_MODULE_0__html__["a" /* getAccessiblePageHtmlToSave */],
});


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(489),
    eq = __webpack_require__(487);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(959),
    isObjectLike = __webpack_require__(116);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(493),
    baseKeys = __webpack_require__(983),
    isArrayLike = __webpack_require__(496);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(483);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 319 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(991),
    stubArray = __webpack_require__(498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(495);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(994),
    Map = __webpack_require__(310),
    Promise = __webpack_require__(995),
    Set = __webpack_require__(996),
    WeakMap = __webpack_require__(997),
    baseGetTag = __webpack_require__(143),
    toSource = __webpack_require__(486);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1000);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarksByType", function() { return getMarksByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontFamily", function() { return getFontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSize", function() { return getFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLetterSpacing", function() { return getLetterSpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getColor", function() { return getColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLineHeight", function() { return getLineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFontWeightBold", function() { return isFontWeightBold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFontStyleItalic", function() { return isFontStyleItalic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextDecorationUnderline", function() { return isTextDecorationUnderline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextDecorationLineThrough", function() { return isTextDecorationLineThrough; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextTransformCapitalize", function() { return isTextTransformCapitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextTransformUpperCase", function() { return isTextTransformUpperCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextTransformLowerCase", function() { return isTextTransformLowerCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSuperScript", function() { return isSuperScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSubScript", function() { return isSubScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextAlignLeft", function() { return isTextAlignLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextAlignCenter", function() { return isTextAlignCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextAlignRight", function() { return isTextAlignRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextAlignJustify", function() { return isTextAlignJustify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontFamilyMark", function() { return getFontFamilyMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeMark", function() { return getFontSizeMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getColorMark", function() { return getColorMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontWeightMark", function() { return getFontWeightMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontStyleMark", function() { return getFontStyleMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextDecorationMark", function() { return getTextDecorationMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextTransformMark", function() { return getTextTransformMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextScriptMark", function() { return getTextScriptMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLetterSpacingMark", function() { return getLetterSpacingMark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__ = __webpack_require__(9);


var getMarksByType = function (marks, type) { return (marks.filter(function (mark) { return mark.type === type; })); };
var getMark = function (type, style, className) { return ({
    type: type,
    data: { style: style, className: className },
}); };
var getFontFamily = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_FAMILY);
    if (!marks.size) {
        return '';
    }
    var fontFamily = marks.first().data.get('style').fontFamily;
    return fontFamily;
};
var getFontSize = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_SIZE);
    if (!marks.size) {
        return '';
    }
    var fontSize = marks.first().data.get('style').fontSize;
    return fontSize;
};
var getLetterSpacing = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].LETTER_SPACING);
    if (!marks.size) {
        return '0px';
    }
    var letterSpacing = marks.first().data.get('style').letterSpacing;
    return letterSpacing;
};
var getColor = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].COLOR);
    if (!marks.size) {
        return '';
    }
    var color = marks.first().data.get('style').color;
    return color;
};
var getLineHeight = function (blocks) {
    if (!blocks.size) {
        return '';
    }
    var style = blocks.first().data.get('style');
    if (!style) {
        return '';
    }
    return style.lineHeight;
};
var isFontWeightBold = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_WEIGHT);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) {
        var fontWeight = mark.data.get('style').fontWeight;
        return fontWeight === 'bold' || fontWeight >= 600;
    });
};
var isFontStyleItalic = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_STYLE);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('style').fontStyle === 'italic'); });
};
var isTextDecorationUnderline = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_DECORATION);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('style').textDecoration === __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* TEXT_DECORATION */].UNDERLINE); });
};
var isTextDecorationLineThrough = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_DECORATION);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('style').textDecoration === __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* TEXT_DECORATION */].LINE_THROUGH); });
};
var isTextTransformCapitalize = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('style').textTransform === __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* TEXT_TRANSFORM */].CAPITALIZE); });
};
var isTextTransformUpperCase = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('style').textTransform === __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* TEXT_TRANSFORM */].UPPERCASE); });
};
var isTextTransformLowerCase = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('style').textTransform === __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* TEXT_TRANSFORM */].LOWERCASE); });
};
var isSuperScript = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('className') === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["u" /* superScriptClassName */]); });
};
var isSubScript = function (marks) {
    var filteredMarks = getMarksByType(marks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT);
    return filteredMarks.size > 0 && filteredMarks.every(function (mark) { return (mark.data.get('className') === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["t" /* subScriptClassName */]); });
};
var getTextDecoration = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_DECORATION);
    if (!marks.size) {
        return __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* TEXT_DECORATION */].NONE;
    }
    var textDecoration = marks.first().data.get('style').textDecoration;
    return textDecoration;
};
var getTextTransform = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM);
    if (!marks.size) {
        return __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* TEXT_TRANSFORM */].NONE;
    }
    var textTransform = marks.first().data.get('style').textTransform;
    return textTransform;
};
var getTextScriptClassName = function (allMarks) {
    var marks = getMarksByType(allMarks, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT);
    if (!marks.size) {
        return '';
    }
    var className = marks.first().data.get('className');
    return className;
};
var checkTextAlign = function (blocks, textAlign) {
    if (!blocks.size) {
        return false;
    }
    return blocks.every(function (block) {
        var style = block.data.get('style');
        return !!style && style.textAlign === textAlign;
    });
};
var isTextAlignLeft = function (blocks) { return checkTextAlign(blocks, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TEXT_ALIGN */].LEFT); };
var isTextAlignCenter = function (blocks) { return checkTextAlign(blocks, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TEXT_ALIGN */].CENTER); };
var isTextAlignRight = function (blocks) { return checkTextAlign(blocks, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TEXT_ALIGN */].RIGHT); };
var isTextAlignJustify = function (blocks) { return checkTextAlign(blocks, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TEXT_ALIGN */].JUSTIFY); };
var getFontFamilyMark = function (fontFamily) { return (getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_FAMILY, { fontFamily: fontFamily })); };
var getFontSizeMark = function (fontSize) { return (getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_SIZE, { fontSize: fontSize })); };
var getColorMark = function (color) { return (getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].COLOR, { color: color }, __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["p" /* colorMarkClassName */])); };
var getFontWeightMark = function (marks) {
    var fontWeight = isFontWeightBold(marks) ? 'normal' : 'bold';
    return getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_WEIGHT, { fontWeight: fontWeight });
};
var getFontStyleMark = function (marks) {
    var fontStyle = isFontStyleItalic(marks) ? 'normal' : 'italic';
    return getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].FONT_STYLE, { fontStyle: fontStyle });
};
var getTextDecorationMark = function (marks, value) {
    var currentTextDecoration = getTextDecoration(marks);
    var newTextDecoration = currentTextDecoration === value
        ? __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* TEXT_DECORATION */].NONE
        : value;
    return getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_DECORATION, { textDecoration: newTextDecoration });
};
var getTextTransformMark = function (marks, value) {
    var currentTextTransform = getTextTransform(marks);
    var newTextTransform = currentTextTransform === value
        ? __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* TEXT_TRANSFORM */].NONE
        : value;
    return getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM, { textTransform: newTextTransform });
};
var getTextScriptMark = function (marks, value) {
    var currentClassName = getTextScriptClassName(marks);
    var className = value === __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* TEXT_SCRIPT */].SUB ? __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["t" /* subScriptClassName */] : __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["u" /* superScriptClassName */];
    var newClassName = currentClassName === className
        ? ''
        : className;
    return getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT, {}, newClassName);
};
var getLetterSpacingMark = function (letterSpacing) { return (getMark(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STYLE_TYPES */].LETTER_SPACING, { letterSpacing: letterSpacing })); };


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideTextXPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SlideTextYPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SliderElementDataAttribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var SlideTextXPosition;
(function (SlideTextXPosition) {
    SlideTextXPosition["LEFT"] = "LEFT";
    SlideTextXPosition["CENTER"] = "CENTER";
    SlideTextXPosition["RIGHT"] = "RIGHT";
})(SlideTextXPosition || (SlideTextXPosition = {}));
var SlideTextYPosition;
(function (SlideTextYPosition) {
    SlideTextYPosition["TOP"] = "TOP";
    SlideTextYPosition["CENTER"] = "CENTER";
    SlideTextYPosition["BOTTOM"] = "BOTTOM";
    SlideTextYPosition["ABOVE_SLIDE"] = "ABOVE_SLIDE";
    SlideTextYPosition["UNDER_SLIDE"] = "UNDER_SLIDE";
})(SlideTextYPosition || (SlideTextYPosition = {}));
var SliderElementDataAttribute;
(function (SliderElementDataAttribute) {
    SliderElementDataAttribute["hidden"] = "data-hidden";
    SliderElementDataAttribute["deps"] = "data-deps";
})(SliderElementDataAttribute || (SliderElementDataAttribute = {}));
var getConfig = function (element, page, pageIndexInSpread, css) {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* getElementId */])(element);
    var filteredClassName = element.className.split(' ').find(function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].sliderClassName)); }) || '';
    if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["W" /* isDuplicatedItemInSpread */])(filteredClassName, pageIndexInSpread)) {
        return {
            page: page,
            id: id,
            className: filteredClassName,
        };
    }
    var isVisible = !(element.getAttribute(SliderElementDataAttribute.hidden) &&
        element.getAttribute(SliderElementDataAttribute.hidden) === 'true');
    var depsAttr = element.getAttribute(SliderElementDataAttribute.deps);
    var deps = depsAttr ? depsAttr.split(';') : [];
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["m" /* getElementSizes */])(id, css), width = _a.width, height = _a.height;
    return {
        page: page,
        id: id,
        idInConfigs: filteredClassName,
        className: filteredClassName,
        isVisible: isVisible,
        deps: deps,
        importingSlides: [],
        width: width,
        height: height,
    };
};
/* harmony default export */ __webpack_exports__["d"] = (function (page, pageIndexInSpread, htmlDocument, css) {
    var items = [];
    var duplicatedItemsInSpread = [];
    var isError = false;
    var sliderElements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].sliderClassName + "]")).filter(function (element) { return !Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["V" /* hasLockedParent */])(element); });
    try {
        sliderElements.forEach(function (element) {
            var config = getConfig(element, page, pageIndexInSpread, css);
            if ('idInConfigs' in config) {
                items.push(config);
            }
            else {
                duplicatedItemsInSpread.push(config);
            }
        });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        duplicatedItemsInSpread: duplicatedItemsInSpread,
        isError: isError,
    };
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemesActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setThemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return duplicateTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return renameTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeThemeColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_indesignEditor__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;






var ThemesActionKeys;
(function (ThemesActionKeys) {
    ThemesActionKeys["SET_THEMES"] = "@@editor/themes/SET_THEMES";
    ThemesActionKeys["SELECT_THEME"] = "@@editor/themes/SELECT_THEME";
    ThemesActionKeys["DUPLICATE_THEME"] = "@@editor/themes/DUPLICATE_THEME";
    ThemesActionKeys["REMOVE_THEME"] = "@@editor/themes/REMOVE_THEME";
    ThemesActionKeys["RENAME_THEME"] = "@@editor/themes/RENAME_THEME";
    ThemesActionKeys["CHANGE_THEME_COLOR"] = "@@editor/themes/CHANGE_THEME_COLOR";
})(ThemesActionKeys || (ThemesActionKeys = {}));
var setThemes = function (themes) { return ({
    type: ThemesActionKeys.SET_THEMES,
    themes: themes,
}); };
var selectTheme = function (id, shouldUpdateCss) { return function (dispatch, getState) {
    var action = {
        type: ThemesActionKeys.SELECT_THEME,
        id: id,
    };
    dispatch(action);
    if (!shouldUpdateCss) {
        return;
    }
    var _a = getState().editor, themesCss = _a.resources.themesCss, selectedThemeId = _a.selectedThemeId;
    var modifiedThemesCss = __WEBPACK_IMPORTED_MODULE_3__utils_indesignEditor__["a" /* default */].getCssWithUpdatedThemes(themesCss, selectedThemeId);
    dispatch(saveThemesCss(modifiedThemesCss));
}; };
var duplicateTheme = function (themeId, name) { return function (dispatch, getState) {
    var themes = getState().editor.themes;
    var colors = themes[themeId].colors;
    var newThemeId = Date.now().toString();
    var newTheme = {
        id: newThemeId,
        name: name,
        colors: colors,
    };
    var action = {
        type: ThemesActionKeys.DUPLICATE_THEME,
        id: newThemeId,
        theme: newTheme,
    };
    dispatch(action);
    var themesCss = getState().editor.resources.themesCss;
    var modifiedThemesCss = __WEBPACK_IMPORTED_MODULE_3__utils_indesignEditor__["a" /* default */].getCssWithDuplicatedTheme(themesCss, themeId, newTheme);
    dispatch(saveThemesCss(modifiedThemesCss));
}; };
var removeTheme = function (themeId) { return function (dispatch, getState) {
    var themes = getState().editor.themes;
    var themeIds = Object.keys(themes).filter(function (id) { return id !== themeId; });
    var newSelectedThemeId = themeIds[0];
    var action = {
        type: ThemesActionKeys.REMOVE_THEME,
        id: themeId,
        newSelectedThemeId: newSelectedThemeId,
    };
    dispatch(action);
    var themesCss = getState().editor.resources.themesCss;
    var modifiedThemesCss = __WEBPACK_IMPORTED_MODULE_3__utils_indesignEditor__["a" /* default */].getCssWithoutRemovedTheme(themesCss, themeId, newSelectedThemeId);
    dispatch(saveThemesCss(modifiedThemesCss));
}; };
var renameTheme = function (themeId, themeName) { return function (dispatch, getState) {
    var action = {
        type: ThemesActionKeys.RENAME_THEME,
        id: themeId,
        name: themeName,
    };
    dispatch(action);
    var themesCss = getState().editor.resources.themesCss;
    var modifiedThemesCss = __WEBPACK_IMPORTED_MODULE_3__utils_indesignEditor__["a" /* default */].getCssWithRenamedTheme(themesCss, themeId, themeName);
    dispatch(saveThemesCss(modifiedThemesCss));
}; };
var changeThemeColor = function (themeId, colorIndex, colorValue) { return function (dispatch, getState) {
    var action = {
        type: ThemesActionKeys.CHANGE_THEME_COLOR,
        themeId: themeId,
        colorIndex: colorIndex,
        colorValue: colorValue,
    };
    dispatch(action);
    var themesCss = getState().editor.resources.themesCss;
    var modifiedThemesCss = __WEBPACK_IMPORTED_MODULE_3__utils_indesignEditor__["a" /* default */].getCssWithUpdatedThemeColor(themesCss, themeId, colorIndex, colorValue);
    dispatch(saveThemesCss(modifiedThemesCss));
}; };
var saveThemesCss = function (themesCss) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var _a, clientId, resourceId, thumbnailsToUpdate, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _a.clientId, resourceId = _a.tempGId;
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sources__["i" /* setResourcesData */])({
                    themesCss: themesCss,
                }));
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* default */].saveIndesignEditorThemesCss(clientId, resourceId, themesCss)];
            case 1:
                thumbnailsToUpdate = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__thumbnails__["c" /* setThumbnailsToUpdate */])(thumbnailsToUpdate));
                return [3 /*break*/, 3];
            case 2:
                error_1 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__NotificationBar_actions__["c" /* createNotification */])('error.save_editor_data_error'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingsActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleSettingsPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPublicationSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return savePublicationSettings; });
/* unused harmony export setPublicationSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setSettingsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return savePublicationPdfOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return importPublicationPdf; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__preprodPublication__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _this = this;










var SettingsActionKeys;
(function (SettingsActionKeys) {
    SettingsActionKeys["TOGGLE_SETTINGS_PANEL"] = "@@editor/settings/TOGGLE_SETTINGS_PANEL";
    SettingsActionKeys["SET_SETTINGS"] = "@@editor/settings/SET_SETTINGS";
    SettingsActionKeys["SET_SETTINGS_ERROR"] = "@@editor/settings/SET_SETTINGS_ERROR";
    SettingsActionKeys["SET_PDF_IMPORTING_STATUS"] = "@@editor/settings/SET_PDF_IMPORTING_STATUS";
})(SettingsActionKeys || (SettingsActionKeys = {}));
var toggleSettingsPanel = function () { return ({
    type: SettingsActionKeys.TOGGLE_SETTINGS_PANEL,
}); };
var setPdfImportingStatus = function (status) { return ({
    type: SettingsActionKeys.SET_PDF_IMPORTING_STATUS,
    status: status,
}); };
var getPublicationSettings = function (id) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var editablePublicationSettings, promises, _a, settings, integrationSettings, pdfSettings, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                editablePublicationSettings = getState().galleryInfos.template.publicationSettings;
                promises = [
                    __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].getPublicationSettings(id),
                    Promise.resolve(undefined),
                    Promise.resolve(undefined),
                ];
                if (editablePublicationSettings.includes(__WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationSettingName.customUrl)) {
                    promises[1] = __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].getPublicationIntegration(id);
                }
                if (editablePublicationSettings.includes(__WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationSettingName.downloadPdf)) {
                    promises[2] = __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].getPublicationPdfSettings(id);
                }
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                _a = __read.apply(void 0, [_b.sent(), 3]), settings = _a[0], integrationSettings = _a[1], pdfSettings = _a[2];
                dispatch(setPublicationSettings(settings, integrationSettings ? integrationSettings.projectUrl : undefined, pdfSettings));
                return [3 /*break*/, 3];
            case 2:
                error_1 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.get_publication_settings'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var savePublicationSettings = function (id, values) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var action, settings, projectUrl, _a, clientId, originalGId, tempGId, isNotPublished, label, error_2, errorMessage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                action = {
                    type: SettingsActionKeys.SET_SETTINGS,
                    fields: values,
                };
                dispatch(action);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].savePublicationSettings(id, values)];
            case 1:
                settings = _b.sent();
                if (!Object.keys(values).includes(__WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationSettingName.customUrl)) return [3 /*break*/, 3];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].getPublicationIntegration(id)];
            case 2:
                projectUrl = (_b.sent()).projectUrl;
                dispatch(setPublicationSettings(settings, projectUrl));
                _a = __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _a.clientId, originalGId = _a.originalGId, tempGId = _a.tempGId;
                isNotPublished = originalGId === tempGId;
                if (isNotPublished) {
                    label = getState().editor.label.label;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__preprodPublication__["b" /* getPreprodPublicationUrl */])(clientId, tempGId, label, true));
                }
                return [2 /*return*/, projectUrl];
            case 3:
                dispatch(setPublicationSettings(settings));
                _b.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                error_2 = _b.sent();
                errorMessage = 'error.save_publication_settings';
                if (error_2.responseText && error_2.responseText.includes('NOT_UNIQUE_ERROR--customUrl')) {
                    errorMessage = 'error.custom_url_used';
                    dispatch(setSettingsError(__WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationSettingName.customUrl, errorMessage));
                }
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])(errorMessage));
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
var setPublicationSettings = function (settings, projectUrl, pdfSettings) { return function (dispatch, getState) {
    var publicationSettings = getState().galleryInfos.template.publicationSettings;
    var fields = publicationSettings.reduce(function (acc, current) {
        if (settings.hasOwnProperty(current)) {
            acc[current] = settings[current];
        }
        return acc;
    }, {});
    var action = {
        type: SettingsActionKeys.SET_SETTINGS,
        fields: fields,
        pdfSettings: pdfSettings,
        projectUrl: projectUrl,
    };
    dispatch(action);
}; };
var setSettingsError = function (name, value) { return function (dispatch) {
    var action = {
        type: SettingsActionKeys.SET_SETTINGS_ERROR,
        name: name,
        value: value,
    };
    dispatch(action);
}; };
var savePublicationPdfOption = function (id, pdfOption) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var pdfSettings, action, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].savePublicationPdfOption(id, pdfOption)];
            case 1:
                pdfSettings = _a.sent();
                action = {
                    type: SettingsActionKeys.SET_SETTINGS,
                    pdfSettings: pdfSettings,
                };
                dispatch(action);
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.save_publication_settings'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var importPublicationPdf = function (publicationId, importManagerId, sourceFile, sourcePublication, updateThumbs, pdfOption) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var isRemovingPublication, pdfImportingStatus, response, notification, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 8]);
                isRemovingPublication = !!sourcePublication && sourcePublication.id === -1;
                pdfImportingStatus = isRemovingPublication
                    ? __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PdfImportingStatus */].REMOVING
                    : __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PdfImportingStatus */].IMPORTING;
                dispatch(setPdfImportingStatus(pdfImportingStatus));
                response = void 0;
                if (!sourceFile) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(importPdfFromFile(publicationId, importManagerId, sourceFile, updateThumbs))];
            case 1:
                response = _a.sent();
                _a.label = 2;
            case 2:
                if (!sourcePublication) return [3 /*break*/, 4];
                return [4 /*yield*/, dispatch(importPdfFromPublication(publicationId, sourcePublication, updateThumbs))];
            case 3:
                response = _a.sent();
                _a.label = 4;
            case 4:
                if (!response) {
                    dispatch(setPdfImportingStatus(null));
                    return [2 /*return*/];
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])()) {
                    notification = isRemovingPublication
                        ? 'info.remove_publication_pdf'
                        : 'info.import_publication_pdf';
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])(notification));
                    return [2 /*return*/];
                }
                return [4 /*yield*/, dispatch(updatePdfSettings(publicationId, sourceFile, isRemovingPublication, pdfOption))];
            case 5:
                _a.sent();
                dispatch(setPdfImportingStatus(null));
                return [4 /*yield*/, dispatch(handlePublicationPdfImportResponse(response, updateThumbs, publicationId))];
            case 6:
                _a.sent();
                return [3 /*break*/, 8];
            case 7:
                error_4 = _a.sent();
                dispatch(setPdfImportingStatus(null));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.import_publication_pdf'));
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}); }; };
var importPdfFromFile = function (publicationId, importManagerId, sourceFile, updateThumbs) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var file, isCorrectFileType, onImportProgress, response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                file = sourceFile.file, isCorrectFileType = sourceFile.isCorrectFileType;
                if (!isCorrectFileType) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["l" /* updateFileInImport */])(importManagerId, {
                        error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].TYPE,
                        percentage: 100,
                    }));
                    return [2 /*return*/];
                }
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["d" /* addFileInImport */])(importManagerId, {
                    id: importManagerId,
                    percentage: 0,
                    error: null,
                }));
                onImportProgress = function (e) {
                    var percentage = Math.floor((e.loaded / e.total) * 100);
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["l" /* updateFileInImport */])(importManagerId, {
                        percentage: percentage,
                    }));
                };
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].importPublicationPdf(publicationId, file, null, updateThumbs, onImportProgress, importManagerId)];
            case 1:
                response = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId));
                return [2 /*return*/, response];
            case 2:
                error_5 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["l" /* updateFileInImport */])(importManagerId, {
                    error: __WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["a" /* FileError */].IMPORT,
                    percentage: 100,
                }));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var importPdfFromPublication = function (publicationId, sourcePublication, updateThumbs) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].importPublicationPdf(publicationId, null, sourcePublication, updateThumbs)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_6 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.import_publication_pdf'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var updatePdfSettings = function (publicationId, sourceFile, isRemovingPublication, pdfOption) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var pdfSettings, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].savePublicationPdfOption(publicationId, pdfOption)];
            case 1:
                pdfSettings = _a.sent();
                if (sourceFile) {
                    pdfSettings.globalId = undefined;
                }
                if (isRemovingPublication) {
                    pdfSettings.globalId = undefined;
                    pdfSettings.label = pdfSettings.label || undefined;
                }
                action = {
                    type: SettingsActionKeys.SET_SETTINGS,
                    pdfSettings: pdfSettings,
                };
                dispatch(action);
                return [2 /*return*/];
        }
    });
}); }; };
var handlePublicationPdfImportResponse = function (response, updateThumbs, publicationId) { return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var importManagerId_1, onProgressUpdate, onProgressError, onProgressFinish, shouldCancelProgress, onProgressCancel, _a, clientId, resourceId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (response === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationPdfImportResponse.SYNC && updateThumbs) {
                    dispatch(updateThumbnailsAfterImportPdf());
                    return [2 /*return*/];
                }
                if (!(response === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationPdfImportResponse.ASYNC)) return [3 /*break*/, 2];
                dispatch(setPdfImportingStatus(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PdfImportingStatus */].PROCESSING));
                importManagerId_1 = __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["y" /* getPublicationPdfImportingId */](publicationId, __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PdfImportingStatus */].PROCESSING);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["d" /* addFileInImport */])(importManagerId_1, {
                    id: importManagerId_1,
                    percentage: 0,
                    error: null,
                }));
                onProgressUpdate = function (percentage) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["l" /* updateFileInImport */])(importManagerId_1, {
                        percentage: percentage,
                    }));
                };
                onProgressError = function () {
                    dispatch(setPdfImportingStatus(null));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId_1));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.import_publication_pdf'));
                };
                onProgressFinish = function () {
                    dispatch(setPdfImportingStatus(null));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId_1));
                    if (updateThumbs) {
                        dispatch(updateThumbnailsAfterImportPdf());
                    }
                };
                shouldCancelProgress = function (state) {
                    return !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isEditorOpened */])(state);
                };
                onProgressCancel = function () {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId_1));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__ui__["f" /* reset */])(true));
                };
                _a = __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _a.clientId, resourceId = _a.tempGId;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].getPublicationProgress(clientId, resourceId, onProgressUpdate, onProgressError, onProgressFinish, shouldCancelProgress, onProgressCancel)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); }; };
var updateThumbnailsAfterImportPdf = function () { return function (dispatch, getState) {
    var totalPages = getState().editor.pagesController.totalPages;
    var positionsToUpdate = Array.from({ length: totalPages }, function (v, i) { return i + 1; });
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__thumbnails__["c" /* setThumbnailsToUpdate */])(positionsToUpdate));
    var _a = __WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _a.clientId, resourceId = _a.tempGId;
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__thumbnails__["f" /* updateThumbnailsIfNeeded */])(clientId, resourceId));
}; };


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MIN_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WIDTH_TO_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return thumbnails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_thumbnails__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var INITIAL_WIDTH = 240;
var MIN_WIDTH = 4;
var MAX_WIDTH = 440;
var WIDTH_TO_HIDE = 100;
var thumbnailsInitialState = {
    items: {},
    isDisplayed: true,
    width: INITIAL_WIDTH,
    positionsToUpdate: null,
};
var thumbnails = function (state, action) {
    if (state === void 0) { state = thumbnailsInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_thumbnails__["a" /* ThumbnailsActionKeys */].SET_THUMBNAILS:
            return __assign({}, state, { items: __assign({}, state.items, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].itemsToById(action.data, 'position')) });
        case __WEBPACK_IMPORTED_MODULE_0__actions_thumbnails__["a" /* ThumbnailsActionKeys */].SET_THUMBNAILS_TO_UPDATE: {
            if (!action.positions) {
                return __assign({}, state, { positionsToUpdate: null });
            }
            return __assign({}, state, { positionsToUpdate: state.positionsToUpdate
                    ? __spread(new Set(__spread(state.positionsToUpdate, action.positions))) : action.positions });
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_thumbnails__["a" /* ThumbnailsActionKeys */].SET_THUMBNAIL_VERSION: {
            var newState = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(state);
            Object.values(newState.items).forEach(function (item) {
                if (action.positions.includes(item.position)) {
                    item.version = action.version;
                }
            });
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_thumbnails__["a" /* ThumbnailsActionKeys */].TOGGLE_THUMBNAILS:
            return __assign({}, state, { isDisplayed: !state.isDisplayed });
        case __WEBPACK_IMPORTED_MODULE_0__actions_thumbnails__["a" /* ThumbnailsActionKeys */].SET_THUMBNAILS_WIDTH:
            return __assign({}, state, { width: action.width });
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            // positionsToUpdate must be kept when close editor to call thumbnails reprocessing
            return __assign({}, state, { items: thumbnailsInitialState.items, isDisplayed: true, width: INITIAL_WIDTH });
        default:
            return state;
    }
};


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssetRenamePanelActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return renameAsset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openAssetRenamePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__ = __webpack_require__(12);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;



var AssetRenamePanelActionKeys;
(function (AssetRenamePanelActionKeys) {
    AssetRenamePanelActionKeys["OPEN_PANEL"] = "@@assetRenamePanel/OPEN_PANEL";
    AssetRenamePanelActionKeys["CLOSE_PANEL"] = "@@assetRenamePanel/CLOSE_PANEL";
    AssetRenamePanelActionKeys["SET_NAME"] = "@@assetRenamePanel/SET_NAME";
    AssetRenamePanelActionKeys["SET_ERROR"] = "@@assetRenamePanel/SET_ERROR";
    AssetRenamePanelActionKeys["SET_DRIVE_ITEM_ID"] = "@@assetRenamePanel/SET_DRIVE_ITEM_ID";
})(AssetRenamePanelActionKeys || (AssetRenamePanelActionKeys = {}));
var openPanel = function () { return ({
    type: AssetRenamePanelActionKeys.OPEN_PANEL,
}); };
var setDriveItemId = function (id) { return ({
    type: AssetRenamePanelActionKeys.SET_DRIVE_ITEM_ID,
    id: id
}); };
var openAssetRenamePanel = function (driveItem) { return function (dispatch) {
    var label = driveItem.label, id = driveItem.id;
    dispatch(openPanel());
    dispatch(setName(label));
    dispatch(setDriveItemId(id));
}; };
var closePanel = function () { return ({
    type: AssetRenamePanelActionKeys.CLOSE_PANEL,
}); };
var setName = function (name) { return ({
    type: AssetRenamePanelActionKeys.SET_NAME,
    name: name
}); };
var setError = function (error) { return ({
    type: AssetRenamePanelActionKeys.SET_ERROR,
    error: error,
}); };
var renameAsset = function (assetId, name) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var clientId, newLabel, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                clientId = getState().galleryInfos.config.clientId;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].renameResource(clientId, assetId, name)];
            case 1:
                newLabel = (_a.sent()).newLabel;
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["I" /* updateDriveItemName */])(assetId, newLabel));
                dispatch(closePanel());
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                if (__WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].isDuplicateFileNameError(error_1.responseText)) {
                    dispatch(setError('error.duplicate_file_name'));
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.rename_asset_error'));
                    dispatch(closePanel());
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };



/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExternalLinkCreationPanelActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createExternalLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routes__ = __webpack_require__(13);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;






var ExternalLinkCreationPanelActionKeys;
(function (ExternalLinkCreationPanelActionKeys) {
    ExternalLinkCreationPanelActionKeys["OPEN_PANEL"] = "@@externalLinkCreationPanel/OPEN_PANEL";
    ExternalLinkCreationPanelActionKeys["CLOSE_PANEL"] = "@@externalLinkCreationPanel/CLOSE_PANEL";
    ExternalLinkCreationPanelActionKeys["SET_VALUE"] = "@@externalLinkCreationPanel/SET_VALUE";
})(ExternalLinkCreationPanelActionKeys || (ExternalLinkCreationPanelActionKeys = {}));
var openPanel = function () { return ({
    type: ExternalLinkCreationPanelActionKeys.OPEN_PANEL,
}); };
var closePanel = function () { return ({
    type: ExternalLinkCreationPanelActionKeys.CLOSE_PANEL,
}); };
var setValue = function (name, value, error) { return ({
    type: ExternalLinkCreationPanelActionKeys.SET_VALUE,
    name: name,
    value: value,
    error: error,
}); };
var createExternalLink = function (name, url) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var isOnline, folderId, routerParamsHistory, currentOriginParam, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_userAgent__["a" /* default */].isOnlinePromise()];
            case 1:
                isOnline = _a.sent();
                folderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getFolderIdForNewResource();
                if (!(isOnline && folderId)) return [3 /*break*/, 8];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, 6, 7]);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].createExternalLink(folderId, name, url)];
            case 3:
                _a.sent();
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(folderId, true, true, true))];
            case 4:
                _a.sent();
                routerParamsHistory = getState().routerParamsHistory;
                currentOriginParam = __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].getCurrentOriginParam(routerParamsHistory);
                if (currentOriginParam !== folderId.toString()) {
                    __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].redirectToParentDir(folderId);
                }
                return [3 /*break*/, 7];
            case 5:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.cant_create_external_link'));
                return [3 /*break*/, 7];
            case 6:
                dispatch(closePanel());
                return [7 /*endfinally*/];
            case 7: return [3 /*break*/, 9];
            case 8:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('info.offline_create_external_link'));
                dispatch(closePanel());
                _a.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}); }; };



/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareWithUserPopupActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShareUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shareWithUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__ = __webpack_require__(15);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;


var ShareWithUserPopupActionKeys;
(function (ShareWithUserPopupActionKeys) {
    ShareWithUserPopupActionKeys["GET_USERS"] = "@@shareWithUser/GET_USERS";
    ShareWithUserPopupActionKeys["SET_USERS"] = "@@shareWithUser/SET_USERS";
    ShareWithUserPopupActionKeys["SELECT_USER"] = "@@shareWithUser/SELECT_USER";
    ShareWithUserPopupActionKeys["RESET"] = "@@shareWithUser/RESET";
})(ShareWithUserPopupActionKeys || (ShareWithUserPopupActionKeys = {}));
var setUsers = function (users) { return ({
    type: ShareWithUserPopupActionKeys.SET_USERS,
    users: users,
}); };
var selectUser = function (userId) { return ({
    type: ShareWithUserPopupActionKeys.SELECT_USER,
    userId: userId,
}); };
var reset = function () { return ({
    type: ShareWithUserPopupActionKeys.RESET,
}); };
var getShareUsers = function (resourceGId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var action, users, currentUserId_1, filteredUsers, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                action = {
                    type: ShareWithUserPopupActionKeys.GET_USERS,
                    resourceGId: resourceGId,
                };
                dispatch(action);
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].getShareUsers()];
            case 1:
                users = _a.sent();
                currentUserId_1 = getState().profile.id;
                filteredUsers = users.filter(function (_a) {
                    var id = _a.id;
                    return id !== currentUserId_1;
                });
                dispatch(setUsers(filteredUsers));
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                dispatch(reset());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.get_share_users'));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var shareWithUser = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, resourceGId, selectedUserId, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, 3, 4]);
                _a = getState().shareWithUserPopup, resourceGId = _a.resourceGId, selectedUserId = _a.selectedUserId;
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0__utils_api__["a" /* default */].shareWithUser(resourceGId, selectedUserId)];
            case 1:
                _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('info.share_with_user_success'));
                return [3 /*break*/, 4];
            case 2:
                error_2 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__NotificationBar_actions__["c" /* createNotification */])('error.share_with_user'));
                return [3 /*break*/, 4];
            case 3:
                dispatch(reset());
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoverImagePanelActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openCoverImagePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeCoverImagePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeCoverImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;








var CoverImagePanelActionKeys;
(function (CoverImagePanelActionKeys) {
    CoverImagePanelActionKeys["OPEN_PANEL"] = "@@coverImagePanel/OPEN_PANEL";
    CoverImagePanelActionKeys["CLOSE_PANEL"] = "@@coverImagePanel/CLOSE_PANEL";
})(CoverImagePanelActionKeys || (CoverImagePanelActionKeys = {}));
var openCoverImagePanel = function (driveItem) { return ({
    type: CoverImagePanelActionKeys.OPEN_PANEL,
    driveItem: driveItem,
}); };
var closeCoverImagePanel = function () { return ({
    type: CoverImagePanelActionKeys.CLOSE_PANEL,
}); };
var changeCoverImage = function (coverGId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var driveItem, driveItemId, resource, isExtensionChanged, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 9, , 10]);
                driveItem = getState().coverImagePanel.driveItem;
                driveItemId = driveItem.id;
                dispatch(closeCoverImagePanel());
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].changeCoverImage(driveItemId, coverGId)];
            case 1:
                _a.sent();
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].getMeta(driveItemId)];
            case 2:
                resource = _a.sent();
                // if there is no cover image, server doesn't return 'icon' field in meta.
                // But it should be there for correct update in store and loading of default cover image
                if (!resource.icon) {
                    resource.icon = '';
                }
                if (!__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp) return [3 /*break*/, 8];
                if (!__WEBPACK_IMPORTED_MODULE_6__utils_driveItem__["d" /* default */].hasIcon(resource)) return [3 /*break*/, 6];
                isExtensionChanged = __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getFileExtension(driveItem.icon) !== __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getFileExtension(resource.icon);
                if (!isExtensionChanged) return [3 /*break*/, 4];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__["h" /* removeThumb */])(driveItemId, false))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__["e" /* downloadThumb */])(driveItemId, __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["a" /* DownloadPriority */].Normal, false, resource))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__["h" /* removeThumb */])(driveItemId))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__DriveItemList_actions__["H" /* updateDriveItem */])(resource));
                return [3 /*break*/, 10];
            case 9:
                error_1 = _a.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__NotificationBar_actions__["c" /* createNotification */])('error.cant_change_cover_image'));
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DndContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createDndContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dnd_core__ = __webpack_require__(1087);


/**
 * Create the React Context
 */

var DndContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({
  dragDropManager: undefined
});
/**
 * Creates the context object we're providing
 * @param backend
 * @param context
 */

function createDndContext(backend, context, options, debugMode) {
  return {
    dragDropManager: Object(__WEBPACK_IMPORTED_MODULE_1_dnd_core__["a" /* createDragDropManager */])(backend, context, options, debugMode)
  };
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDragDropManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_DndContext__ = __webpack_require__(333);



/**
 * A hook to retrieve the DragDropManager from Context
 */

function useDragDropManager() {
  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__common_DndContext__["a" /* DndContext */]),
      dragDropManager = _useContext.dragDropManager;

  Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__["a" /* invariant */])(dragDropManager != null, 'Expected drag drop context');
  return dragDropManager;
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE", function() { return FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "URL", function() { return URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT", function() { return TEXT; });
var FILE = '__NATIVE_FILE__';
var URL = '__NATIVE_URL__';
var TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var Menu = function (_a) {
    var config = _a.config, isDisplayed = _a.isDisplayed, position = _a.position;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledMenu */], { hide: !isDisplayed, position: position }, Object.values(config).map(function (item, i) {
        if (!item) {
            return null;
        }
        var label = item.label, icon = item.icon, component = item.component, hasSeparator = item.hasSeparator, isActive = item.isActive, onClick = item.onClick;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* StyledMenuItem */], { key: label + "-" + i, hasSeparator: hasSeparator }, component || (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledMenuButton */], { type: "button", isActive: isActive, onClick: onClick },
            icon && __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon(icon),
            label))));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (Menu);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledMenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledMenuButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_menu__ = __webpack_require__(40);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledMenu = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tz-index: 10;\n\ttop: calc(100% + 10px);\n\tleft: ", ";\n\tright: ", ";\n\tmax-height: 260px;\n\twidth: 340px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 30px 0 ", ";\n\toverflow-y: auto;\n\tlist-style-type: none;\n\tmargin: 0;\n\tpadding: 0;\n\ttransition: max-height, opacity 100ms;\n\n\t", "\n\n\t@media ", " {\n\t\twidth: 280px;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 4px;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: ", ";\n\t\tborder-radius: 2px;\n\t}\n"], ["\n\tposition: absolute;\n\tz-index: 10;\n\ttop: calc(100% + 10px);\n\tleft: ", ";\n\tright: ", ";\n\tmax-height: 260px;\n\twidth: 340px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 30px 0 ", ";\n\toverflow-y: auto;\n\tlist-style-type: none;\n\tmargin: 0;\n\tpadding: 0;\n\ttransition: max-height, opacity 100ms;\n\n\t", "\n\n\t@media ", " {\n\t\twidth: 280px;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 4px;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: ", ";\n\t\tborder-radius: 2px;\n\t}\n"])), function (_a) {
    var position = _a.position;
    return position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].right ? 'auto' : 0;
}, function (_a) {
    var position = _a.position;
    return position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].right ? 0 : 'auto';
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 10), function (_a) {
    var hide = _a.hide;
    return hide && "max-height: 0; opacity: 0; pointer-events: none";
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallSmartphonePortrait, function (_a) {
    var theme = _a.theme;
    return theme.primary.actionColor;
});
var StyledMenuButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 100%;\n\tmargin: 0;\n\tpadding: 20px 20px 20px 45px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\ttext-align: left;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 10px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tfill: ", ";\n\t\ttransform: translateY(-50%);\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 100%;\n\tmargin: 0;\n\tpadding: 20px 20px 20px 45px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tbackground-color: ",
    ";\n\tcolor: ",
    ";\n\ttext-align: left;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 10px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tfill: ", ";\n\t\ttransform: translateY(-50%);\n\t}\n"])), function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive
        ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 20)
        : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White;
}, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive
        ? theme.primary.actionColor
        : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey800;
}, function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 20);
}, function (_a) {
    var theme = _a.theme;
    return theme.primary.actionColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.primary.actionColor;
});
var StyledMenuItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n\tword-wrap: break-word;\n\n\t&:first-of-type ", " {\n\t\tborder-radius: 6px 6px 0 0;\n\t}\n\n\t&:last-of-type ", " {\n\t\tborder-radius: 0 0 6px 6px;\n\t}\n"], ["\n\t", "\n\tword-wrap: break-word;\n\n\t&:first-of-type ", " {\n\t\tborder-radius: 6px 6px 0 0;\n\t}\n\n\t&:last-of-type ", " {\n\t\tborder-radius: 0 0 6px 6px;\n\t}\n"])), function (props) { return props.hasSeparator && "border-bottom: 1px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey100; }, StyledMenuButton, StyledMenuButton);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportManager__ = __webpack_require__(1182);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_ImportManager__["a" /* default */]));


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GalleryContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryChildrenContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Page; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var GalleryContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n"])));
var GalleryChildrenContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Page = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbackground: ", ";\n\tpadding: ", ";\n\tposition: absolute;\n\ttop: ", ";\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: auto;\n\t-webkit-overflow-scrolling: touch;\n"], ["\n\tbackground: ", ";\n\tpadding: ", ";\n\tposition: absolute;\n\ttop: ", ";\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: auto;\n\t-webkit-overflow-scrolling: touch;\n"])), function (props) { return props.theme.primary.backgroundColor; }, function (props) { return props.withPadding ? '10px' : 0; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */]);
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SharePanelContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FormHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FormBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FormBodyInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SwitchLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonSend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FormFieldContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DocumentsBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return InputField; });
/* unused harmony export shareFontProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EmailText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var shareFontProperties = "\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tletter-spacing: 0.2px;\n\tfont-family: 'HelveticaNeue', sans-serif;\n";
var SharePanelContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n\tz-index: 15;\n\tbackground-color: ", ";\n\ttransform: ", ";\n\n\t", "\n\n\t", "\n\n\t@media print {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbackground: #fff;\n\t\tz-index: 110;\n\t\t", ";\n\t}\n"], ["\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n\tz-index: 15;\n\tbackground-color: ", ";\n\ttransform: ", ";\n\n\t",
    "\n\n\t",
    "\n\n\t@media print {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbackground: #fff;\n\t\tz-index: 110;\n\t\t", ";\n\t}\n"])), function (props) { return props.theme.primary.backgroundColor; }, function (props) { return props.isOpen ? 'translate(0, 0)' : 'translate(0, 100%)'; }, __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t", function (props) { return props.isOpen ? 'translate(0, 0)' : 'display: none;'; });
var Form = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('form')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\t", "\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), shareFontProperties, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 75); });
var FormHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-wrap: wrap;\n\tpadding: 0 20px 10px 20px;\n\n\t> * {\n\t\tmargin-top: 10px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-wrap: wrap;\n\tpadding: 0 20px 10px 20px;\n\n\t> * {\n\t\tmargin-top: 10px;\n\t}\n"])));
var SwitchLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-left: 20px;\n\tmargin-right: 10px;\n\tfont-size: 9px;\n\tline-height: 12px;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n\n\t> span {\n\t\tfont-weight: 700;\n\t\tfont-size: 12px;\n\t}\n"], ["\n\tmargin-left: 20px;\n\tmargin-right: 10px;\n\tfont-size: 9px;\n\tline-height: 12px;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n\n\t> span {\n\t\tfont-weight: 700;\n\t\tfont-size: 12px;\n\t}\n"])), function (props) { return props.theme.primary.strongColor; });
var ButtonCancel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tmargin-right: auto;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n"], ["\n\tmargin-right: auto;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.primary.actionColor;
});
var ButtonSend = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin-left: 20px;\n\tpadding: 8px 25px;\n\tborder: 0;\n\tborder-radius: 20px;\n\toutline: 0;\n\tfont-size: 15px;\n\tline-height: 16px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t&:disabled {\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t}\n"], ["\n\tmargin-left: 20px;\n\tpadding: 8px 25px;\n\tborder: 0;\n\tborder-radius: 20px;\n\toutline: 0;\n\tfont-size: 15px;\n\tline-height: 16px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t&:disabled {\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t}\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.primary.actionColor;
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White);
var FormBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tflex: 1;\n\tpadding: 10px 30px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t@media ", ", ", " {\n\t\tpadding: 10px 45px;\n\t}\n"], ["\n\tflex: 1;\n\tpadding: 10px 30px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t@media ", ", ", " {\n\t\tpadding: 10px 45px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].TabletLandscape);
var FormBodyInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tmax-width: 900px;\n\tmargin: 0 auto;\n"], ["\n\tmax-width: 900px;\n\tmargin: 0 auto;\n"])));
var DocumentsBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n"], ["\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n"])));
var autocompleteSpaceSize = 45;
var FormFieldContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tdisplay: flex;\n\tposition: relative;\n\tflex-flow: row nowrap;\n\tborder-bottom: solid 1px ", ";\n\talign-items: center;\n\t", ";\n\t", "\n\n\t:last-of-type {\n\t\tborder: none;\n\t}\n\n\t> ul {\n\t\tleft: ", "px;\n\t\twidth: calc(100% - ", "px - 50px);\n\n\t\t@media only screen and (max-width: 500px) {\n\t\t\twidth: calc(100% - 10px);\n\t\t\tleft: 5px;\n\t\t}\n\t}\n"], ["\n\tdisplay: flex;\n\tposition: relative;\n\tflex-flow: row nowrap;\n\tborder-bottom: solid 1px ", ";\n\talign-items: center;\n\t",
    ";\n\t",
    "\n\n\t:last-of-type {\n\t\tborder: none;\n\t}\n\n\t> ul {\n\t\tleft: ", "px;\n\t\twidth: calc(100% - ", "px - 50px);\n\n\t\t@media only screen and (max-width: 500px) {\n\t\t\twidth: calc(100% - 10px);\n\t\t\tleft: 5px;\n\t\t}\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 8); }, function (props) { return !props.fieldIsMessage
    ? 'height: 50px;'
    : "height: 100px;\n\t\t\tborder: none;\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\t\t\theight: 120px;\n\t\t\t}"; }, function (props) { return !props.isHeader &&
    "width: calc(100% - 15px);\n\t\tpadding-left: 15px;"; }, autocompleteSpaceSize, autocompleteSpaceSize);
var inputProperties = "\n\twidth: 100%;\n\theight: 40px;\n\t" + shareFontProperties + "\n\toutline: none;\n\tborder: none;\n\tbackground: transparent;\n";
var EmailText = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('textarea')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t", "\n\tcolor: ", ";\n\tfont-weight: 300px;\n\tresize: none;\n\theight: 60px;\n\tpadding: 20px 15px;\n\toverflow: auto; //IE override\n\n\t@media ", " {\n\t\theight: 80px;\n\t}\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\t", "\n\tcolor: ", ";\n\tfont-weight: 300px;\n\tresize: none;\n\theight: 60px;\n\tpadding: 20px 15px;\n\toverflow: auto; //IE override\n\n\t@media ", " {\n\t\theight: 80px;\n\t}\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), inputProperties, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 75); }, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Smartphone);
var InputField = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('input')(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\t", "\n\tcolor: ", ";\n\tmargin-left: 5px;\n\tmax-width: calc(100% - 200px);\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\t", "\n\tcolor: ", ";\n\tmargin-left: 5px;\n\tmax-width: calc(100% - 200px);\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), inputProperties, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 75); });
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 50px;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 16;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 50px;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 16;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.backgroundColor, 50); }, function (props) { return props.theme.primary.strongColor; }, __WEBPACK_IMPORTED_MODULE_3__utils_style__["e" /* spin */]);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderBlockContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderBlockTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Subtitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var HeaderBlockContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: ", ";\n\theight: 50px;\n\tjustify-content: space-between;\n\tpadding-left: 15px;\n\tborder: none;\n\n\t@media print {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: ", ";\n\theight: 50px;\n\tjustify-content: space-between;\n\tpadding-left: 15px;\n\tborder: none;\n\n\t@media print {\n\t\tbackground-color: ", ";\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 3); }, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey50);
var HeaderBlockTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n\tfont-size: 15px;\n\tletter-spacing: 0.2px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\twidth: 100%;\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\tcolor: ", ";\n\tfont-size: 15px;\n\tletter-spacing: 0.2px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\twidth: 100%;\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 50); });
var Title = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-weight: 600;\n\tfont-size: 16px;\n"], ["\n\tfont-weight: 600;\n\tfont-size: 16px;\n"])));
var Subtitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding: 0 3px;\n"], ["\n\tpadding: 0 3px;\n"])));
var Option = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex-grow: 1;\n\ttext-align: right;\n\tpadding: 0 10px;\n"], ["\n\tflex-grow: 1;\n\ttext-align: right;\n\tpadding: 0 10px;\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_customHooks_useClickOutside__ = __webpack_require__(149);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var SelectTheme;
(function (SelectTheme) {
    SelectTheme["DARK"] = "DARK";
    SelectTheme["LIGHT"] = "LIGHT";
})(SelectTheme || (SelectTheme = {}));
var Select = function (_a) {
    var value = _a.value, options = _a.options, placeholder = _a.placeholder, _b = _a.theme, theme = _b === void 0 ? SelectTheme.LIGHT : _b, onChange = _a.onChange;
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isOpen = _c[0], setIsOpen = _c[1];
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_customHooks_useClickOutside__["a" /* default */])(wrapperElement, isOpen, function () { return setIsOpen(false); });
    var handleChange = function (option) {
        onChange(option);
        setIsOpen(false);
    };
    var selectedOption = options.find(function (option) { return option.value === value; });
    var displayedLabel = selectedOption ? selectedOption.label : placeholder;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeProvider */], { theme: { theme: theme } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Wrapper */], { ref: wrapperElement },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* SelectValue */], { isOpen: isOpen, onClick: function () { return setIsOpen(function (prevState) { return !prevState; }); } },
                typeof displayedLabel === 'string'
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: displayedLabel || '' })
                    : displayedLabel,
                __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_down')),
            isOpen &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* SelectDropdown */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* SelectOptions */], null, options.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: option.value },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* SelectOptionButton */], { type: "button", isActive: option.value === value, onClick: function () { return handleChange(option); } }, typeof option.label === 'string'
                            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: option.label || '' })
                            : option.label))); }))))));
};
/* harmony default export */ __webpack_exports__["b"] = (Select);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownMenuListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var DropdownMenuList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: 0;\n\tposition: relative;\n\tborder-radius: 16px;\n\tbox-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.19);\n\tbackground-color: ", ";\n\tlist-style: none;\n\tpadding: 8px 20px;\n\tmin-width: 90px;\n\tmax-height: 90vh;\n\tz-index: 2;\n\toverflow-y: auto;\n"], ["\n\tmargin: 0;\n\tposition: relative;\n\tborder-radius: 16px;\n\tbox-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.19);\n\tbackground-color: ", ";\n\tlist-style: none;\n\tpadding: 8px 20px;\n\tmin-width: 90px;\n\tmax-height: 90vh;\n\tz-index: 2;\n\toverflow-y: auto;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var DropdownMenuListItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding: 8px 0;\n\ttext-align: center;\n\tcursor: pointer;\n\tborder-bottom: 1px solid ", ";\n\tfont-weight: 600;\n\n\t&:last-of-type {\n\t\tborder-bottom: none;\n\t}\n"], ["\n\tpadding: 8px 0;\n\ttext-align: center;\n\tcursor: pointer;\n\tborder-bottom: 1px solid ", ";\n\tfont-weight: 600;\n\n\t&:last-of-type {\n\t\tborder-bottom: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50);

var templateObject_1, templateObject_2;


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Spinner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: ", ";\n\theight: ", ";\n\tcolor: ", ";\n\tborder-radius: 50%;\n\tanimation: ", ";\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tborder-radius: 50%;\n\t}\n\n\t&::before {\n\t\tborder: ", " solid currentColor;\n\t\topacity: 0.2;\n\t}\n\n\t&::after {\n\t\tborder: ", " solid currentColor;\n\t\tborder-top-color: transparent;\n\t}\n"], ["\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: ", ";\n\theight: ", ";\n\tcolor: ", ";\n\tborder-radius: 50%;\n\tanimation: ", ";\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tborder-radius: 50%;\n\t}\n\n\t&::before {\n\t\tborder: ", " solid currentColor;\n\t\topacity: 0.2;\n\t}\n\n\t&::after {\n\t\tborder: ", " solid currentColor;\n\t\tborder-top-color: transparent;\n\t}\n"])), function (props) { return props.width ? props.width : '35px'; }, function (props) { return props.height ? props.height : '35px'; }, function (props) { return props.color ? props.color : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600; }, __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */], function (props) { return props.borderWidth ? props.borderWidth : '4px'; }, function (props) { return props.borderWidth ? props.borderWidth : '4px'; });
var templateObject_1;


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var usePreviousValue = function (value) {
    var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["a"] = (usePreviousValue);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResourceType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-bottom: 10px;\n\tpadding-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\n\t", "\n"], ["\n\tdisplay: block;\n\tmargin-bottom: 10px;\n\tpadding-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ResourceSelectorTheme */].DARK && "\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 75) + ";\n\t";
});
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 0 15px;\n\tborder-radius: 8px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 44px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t", "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: ", ";\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 0 15px;\n\tborder-radius: 8px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 44px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t",
    "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 80), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 13), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 20), function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ResourceSelectorTheme */].DARK && "\n\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 10) + ";\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 75) + ";\n\n\t\t&:hover {\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 25) + ";\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 30) + ";\n\t\t}\n\t";
}, function (_a) {
    var iconWidth = _a.iconWidth;
    return iconWidth;
}, function (_a) {
    var iconHeight = _a.iconHeight;
    return iconHeight;
}, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ResourceSelectorTheme */].DARK ? 'currentColor' : Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 60);
});
var ButtonsList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\n\tli:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n"], ["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\n\tli:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n"])));
var ResourceType = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-top: 8px;\n\tpadding-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 11px;\n\tline-height: 16px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\n\tspan {\n\t\ttext-transform: none;\n\t}\n\n\t", "\n"], ["\n\tdisplay: block;\n\tmargin-top: 8px;\n\tpadding-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 11px;\n\tline-height: 16px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\n\tspan {\n\t\ttext-transform: none;\n\t}\n\n\t",
    "\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 55), function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ResourceSelectorTheme */].DARK && "\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 75) + ";\n\t";
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResourceSelector_DrivePicker_FromApp__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var mapStateToProps = function (state) {
    var galleryInfos = state.galleryInfos, driveList = state.driveList;
    var breadcrumbs = driveList.breadcrumbs;
    return {
        driveList: driveList,
        privateDirId: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getPrivateDirId(driveList, galleryInfos.config),
        sharedDirId: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSharedDirId(driveList, galleryInfos.config),
        sourcesDirId: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSourcesDirId(driveList, galleryInfos.config),
        applicationId: galleryInfos.config.applicationGallery,
        currentDriveId: breadcrumbs.length === 0
            ? undefined
            : breadcrumbs[breadcrumbs.length - 1].id,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ResourceSelector_DrivePicker_FromApp__["a" /* default */]));


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItem__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);




var mapStateToProps = function (state, ownProps) {
    var offlineManager = state.offlineManager, galleryInfos = state.galleryInfos, downloadManager = state.downloadManager, driveList = state.driveList, readStatus = state.readStatus;
    var galleryConfig = galleryInfos.config, tagClasses = galleryInfos.template.tagClasses;
    var contextualMenu = driveList.contextualMenu, resolutions = driveList.resolutions, isEditMode = driveList.isEditMode;
    var driveItem = ownProps.driveItem, showUnreadBadge = ownProps.showUnreadBadge, displayType = ownProps.displayType;
    var isSelectedForContextualMenu = contextualMenu.isOpened
        ? contextualMenu.driveItemId === driveItem.id
        : false;
    var isDownloading = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDownloading(downloadManager, driveItem.id);
    var isDownloaded = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, driveItem.id);
    var isUnread = showUnreadBadge && __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].isUnread(driveList, readStatus, driveItem.id);
    var loaderStep = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getItemLoaderStep(downloadManager, driveItem.id);
    var thumbnailDescriptor = __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getThumbnailDescriptor(driveItem, true, offlineManager, galleryConfig, resolutions, displayType);
    var isDownloadInProgress = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDownloadingInProgress(downloadManager, driveItem.id);
    var isUpdating = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemUpdating(downloadManager, driveItem.id);
    var isDeletionInProgress = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDeletingInProgress(downloadManager, driveItem.id);
    var isMarkingItemForDeletion = downloadManager ? downloadManager.isMarkingItemForDeletion : false;
    return {
        displayType: displayType,
        isSelectedForContextualMenu: isSelectedForContextualMenu,
        isDownloading: isDownloading,
        isDownloaded: isDownloaded,
        isDownloadInProgress: isDownloadInProgress,
        isUpdating: isUpdating,
        isDeletionInProgress: isDeletionInProgress,
        isMarkingItemForDeletion: isMarkingItemForDeletion,
        loaderStep: loaderStep,
        thumbnailDescriptor: thumbnailDescriptor,
        isUnread: isUnread,
        isEditMode: isEditMode,
        tagClasses: tagClasses,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItem__["a" /* default */]));


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd_html5_backend__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Thumbnail__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_ListItem_Infos__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_dnd__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_DropTarget__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_DriveItemList_FolderDropTarget__ = __webpack_require__(555);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












var ListItem = function (_a) {
    var onClick = _a.onClick, displayType = _a.displayType, itemType = _a.itemType, hasActionButton = _a.hasActionButton, label = _a.label, isSelectedForContextualMenu = _a.isSelectedForContextualMenu, isDownloading = _a.isDownloading, isDownloadInProgress = _a.isDownloadInProgress, isUpdating = _a.isUpdating, isDeletionInProgress = _a.isDeletionInProgress, isMarkingItemForDeletion = _a.isMarkingItemForDeletion, loaderStep = _a.loaderStep, thumbnailDescriptor = _a.thumbnailDescriptor, isUnread = _a.isUnread, isEditMode = _a.isEditMode, itemId = _a.itemId, _b = _a.hasSelectionIcon, hasSelectionIcon = _b === void 0 ? true : _b, isDraggable = _a.isDraggable, _c = _a.index, index = _c === void 0 ? -1 : _c, item = _a.item, _d = _a.itemsCount, itemsCount = _d === void 0 ? 0 : _d, _e = _a.draggableItemsCount, draggableItemsCount = _e === void 0 ? 0 : _e, isDragPreview = _a.isDragPreview, selectionType = _a.selectionType, isMultipleSelection = _a.isMultipleSelection, isSelectedInMultipleSelection = _a.isSelectedInMultipleSelection, tagClasses = _a.tagClasses;
    var _f = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isActive = _f[0], setIsActive = _f[1];
    var _g = __read(Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["c" /* useDrag */])({
        item: {
            type: __WEBPACK_IMPORTED_MODULE_9__typings_dnd__["a" /* DndItemTypes */].DRIVE_ITEM,
            index: index,
            driveItem: item,
            displayType: displayType,
        },
        begin: function () {
            // using react state cause performance issues when there are many items in drive
            setTimeout(function () { return document.body.classList.add('is-dragging'); }, 0);
        },
        end: function () {
            document.body.classList.remove('is-dragging');
        },
        collect: function (monitor) { return ({
            isDragging: !!monitor.isDragging(),
        }); },
    }), 3), isDragging = _g[0].isDragging, drag = _g[1], preview = _g[2];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        preview(Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd_html5_backend__["b" /* getEmptyImage */])(), { captureDraggingState: true });
    }, []);
    var handleContextualMenuHover = function (e, isActive) {
        e.stopPropagation();
        setIsActive(isActive);
    };
    var onCardLeave = function (e) {
        handleContextualMenuHover(e, false);
    };
    var onContextualMenuHover = function (e) {
        handleContextualMenuHover(e, true);
    };
    var ListItemContainer = __WEBPACK_IMPORTED_MODULE_5__styles__["d" /* ListItemContainerVariants */][displayType];
    var isActivated = isSelectedForContextualMenu || isActive;
    var ListItemCard = isActivated
        ? __WEBPACK_IMPORTED_MODULE_5__styles__["b" /* ListItemCardVariants */][displayType]
        : __WEBPACK_IMPORTED_MODULE_5__styles__["c" /* ListItemComponentVariants */][displayType];
    var className = __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__["d" /* default */].getItemClassName('ListItemContainer', item, tagClasses);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItemContainer, { className: className, isEditMode: isEditMode, itemsCount: itemsCount },
        isDraggable &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_DropTarget__["a" /* default */], { index: index }),
        isDraggable && index === draggableItemsCount - 1 &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_DropTarget__["a" /* default */], { index: index + 1, isLast: true }),
        isDraggable && itemType === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].DriveItemType.Directory &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__containers_DriveItemList_FolderDropTarget__["a" /* default */], { folderId: itemId }),
        isUnread && displayType !== __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["e" /* ListItemUnreadBadge */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItemCard, { ref: isDraggable ? drag : null, isDraggable: isDraggable, isDragging: isDragging, isDragPreview: isDragPreview, onClick: isDraggable ? undefined : onClick, isSelectedForContextualMenu: isSelectedForContextualMenu, onMouseLeave: onCardLeave },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* ListItemCardInner */], { isRowView: displayType === __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Thumbnail__["a" /* default */], { selectionId: itemId, displayType: displayType, thumbnailDescriptor: thumbnailDescriptor, isActivated: isActivated, hasSelectionIcon: hasSelectionIcon && displayType !== __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow, isMultipleSelection: isMultipleSelection && itemType !== __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].DriveItemType.Directory, isSelectedInMultipleSelection: isSelectedInMultipleSelection, selectionType: selectionType, isDownloading: isDownloading, isDownloadInProgress: isDownloadInProgress, isUpdating: isUpdating, isDeletionInProgress: isDeletionInProgress, loaderStep: loaderStep, isMarkingItemForDeletion: isMarkingItemForDeletion }),
                displayType !== __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_ListItem_Infos__["a" /* default */], { itemId: itemId, itemType: itemType, hasActionButton: hasActionButton, label: label, onContextualMenuHover: onContextualMenuHover, isActiveIcon: isActivated, isRowView: displayType === __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItem);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ListItemContainerVariants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ListItemComponentVariants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListItemCardVariants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ListItemUnreadBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListItemCardInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__ = __webpack_require__(55);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a, _b, _c;




var gridGutter = "11px"; // Will be configurable in the admin in the future
var getEditModeLineColor = function (color) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(color, 30); };
var renderVerticalEditModeLine = function (itemsCount, color) { return "\n\t&::after {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tright: -7px;\n\t\twidth: 1px;\n\t\tbackground-image: linear-gradient(0deg, " + getEditModeLineColor(color) + ", " + getEditModeLineColor(color) + " 33%, transparent 33%, transparent 100%);\n\t\tbackground-size: 1px 30px;\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape + ", " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet + " {\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t}\n\n\t\t&:nth-of-type(2n) {\n\t\t\t&::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t" + (itemsCount < 2 ? "\n\t\t\t&:last-child {\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop + " {\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t}\n\n\t\t&:nth-of-type(3n) {\n\t\t\t&::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t" + (itemsCount < 3 ? "\n\t\t\t&:last-child {\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].MediumDesktop + " {\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t}\n\n\t\t&:nth-of-type(4n) {\n\t\t\t&::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t" + (itemsCount < 4 ? "\n\t\t\t&:last-child {\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\t}\n"; };
var renderHorizontalEditModeLine = function (itemsCount, color) { return "\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tbottom: -4px;\n\t\tleft: 0;\n\t\tright: 0;\n\t\theight: 1px;\n\t\tbackground-image: linear-gradient(90deg, " + getEditModeLineColor(color) + ", " + getEditModeLineColor(color) + " 33%, transparent 33%, transparent 100%);\n\t\tbackground-size: 30px 1px;\n\t}\n\n\t&:last-child {\n\t\t&::before {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape + ", " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet + " {\n\t\t" + (itemsCount % 2 === 0 ? "\n\t\t\t&:nth-last-child(-n+2) {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop + " {\n\t\t" + (itemsCount % 3 === 0 ? "\n\t\t\t&:nth-last-child(-n+3) {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\n\t\t" + (itemsCount % 3 === 2 ? "\n\t\t\t&:nth-last-child(-n+2) {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].MediumDesktop + " {\n\t\t" + (itemsCount % 4 === 0 ? "\n\t\t\t&:nth-last-child(-n+4) {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\n\t\t" + (itemsCount % 4 === 3 ? "\n\t\t\t&:nth-last-child(-n+3) {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\n\t\t" + (itemsCount % 4 === 2 ? "\n\t\t\t&:nth-last-child(-n+2) {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t" : '') + "\n\t}\n"; };
var renderEditModeGrid = function (itemsCount, color) { return "\n\t" + renderVerticalEditModeLine(itemsCount, color) + "\n\t" + renderHorizontalEditModeLine(itemsCount, color) + "\n"; };
var gridBreakpoints = function (isEditMode, itemsCount, color) { return "\n\tposition: relative;\n\tmargin-top: 5px; /* Will be configurable in the admin in the future */\n\tmargin-bottom: 0;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape + ", " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet + " {\n\t\twidth: calc(50% - " + gridGutter + " * 1 / 2);\n\t\tmargin-right: " + gridGutter + ";\n\n\t\t&:nth-of-type(2n) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop + " {\n\t\twidth: calc(33.3% - " + gridGutter + " * 2 / 3);\n\t\tmargin-right: " + gridGutter + ";\n\n\t\t&:nth-of-type(3n) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].MediumDesktop + " {\n\t\twidth: calc(25% - " + gridGutter + " * 3 / 4);\n\t\tmargin-right: " + gridGutter + ";\n\n\t\t&:nth-of-type(4n) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t@media print {\n\t\twidth: calc(50% - " + gridGutter + " * 1 / 2);\n\t}\n\n\t" + (isEditMode ? renderEditModeGrid(itemsCount, color) : '') + "\n"; };
var ListItemContainerVariants = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t", "\n\t"], ["\n\t\t", "\n\t"])), function (_a) {
        var isEditMode = _a.isEditMode, itemsCount = _a.itemsCount, theme = _a.theme;
        return gridBreakpoints(isEditMode, itemsCount, theme.primary.actionColor);
    }),
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t", "\n\t"], ["\n\t\t", "\n\t"])), function (_a) {
        var isEditMode = _a.isEditMode, itemsCount = _a.itemsCount, theme = _a.theme;
        return gridBreakpoints(isEditMode, itemsCount, theme.primary.actionColor);
    }),
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tmargin-top: 5px; /* Will be configurable in the admin in the future */\n\t\tposition: relative;\n\t"], ["\n\t\twidth: 100%;\n\t\tmargin-top: 5px; /* Will be configurable in the admin in the future */\n\t\tposition: relative;\n\t"]))),
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t"], ["\n\t\twidth: 100%;\n\t"]))),
    _a);
var ListItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcursor: ", ";\n\topacity: ", ";\n\tposition: relative;\n\n\t", "\n\n\t", "\n"], ["\n\tcursor: ", ";\n\topacity: ", ";\n\tposition: relative;\n\n\t",
    "\n\n\t",
    "\n"])), function (props) { return props.isDraggable ? 'grab' : 'pointer'; }, function (props) { return props.isDragging ? '0.25' : '1'; }, function (props) { return props.isDraggable && "\n\t\t> * {\n\t\t\tpointer-events: none;\n\t\t}\n\t"; }, function (props) { return props.isDragPreview && "\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 9px;\n\t\t\tbottom: 9px;\n\t\t\tleft: 9px;\n\t\t\tright: 9px;\n\t\t\tz-index: 2;\n\t\t\tborder-radius: 9px;\n\t\t\tbackground: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 25) + ";\n\t\t}\n\t"; });
var ListItemCardInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\twidth: 100%;\n\tborder-radius: 9px;\n\t", "\n\n\t@media print {\n\t\tbreak-inside: avoid;\n\t}\n"], ["\n\twidth: 100%;\n\tborder-radius: 9px;\n\t",
    "\n\n\t@media print {\n\t\tbreak-inside: avoid;\n\t}\n"])), function (props) { return props.isRowView &&
    "display: flex;\n\t\tposition: relative;\n\t\tz-index: 2;\n\n\t\t& > span {\n\t\t\tposition: relative;\n\t\t\tz-index: 3;\n\t\t}\n\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\twidth: calc(100% - 38px);\n\t\t\theight: 100%;\n\t\t\tright: 0;\n\t\t\ttop: 0;\n\t\t\tz-index: 1;\n\t\t\tbox-shadow: 0 9px 39px 1px rgba(0,0,0,0.1);\n\t\t\tborder-radius: 9px;\n\n\t\t\t@media print {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}"; });
var listItemBlockStyle = function (props) { return "\n\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortrait + " {\n\t\tmargin: 7.5px 0;\n\t}\n"; };
var ListItemCardVariants = (_b = {},
    _b[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t\t", "\n\t\tpadding: 9px;\n\t\tbox-sizing: border-box;\n\t\tbackground-color: ", ";\n\t\tborder-radius: 9px;\n\t"], ["\n\t\t", "\n\t\tpadding: 9px;\n\t\tbox-sizing: border-box;\n\t\tbackground-color: ", ";\n\t\tborder-radius: 9px;\n\t"])), function (props) { return listItemBlockStyle(props); }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 4); }),
    _b[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t\tbackground-color: ", ";\n\t\theight: auto;\n\t\tborder-radius: 16px;\n\t\tpadding: 9px;\n\t\tbox-sizing: border-box;\n\t"], ["\n\t\tbackground-color: ", ";\n\t\theight: auto;\n\t\tborder-radius: 16px;\n\t\tpadding: 9px;\n\t\tbox-sizing: border-box;\n\t"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 4); }),
    _b[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t\t", "\n\t\tbox-sizing: border-box;\n\t\tpadding: 9px;\n\t\tborder-radius: 9px;\n\t\tbackground-color: ", ";\n\t"], ["\n\t\t", "\n\t\tbox-sizing: border-box;\n\t\tpadding: 9px;\n\t\tborder-radius: 9px;\n\t\tbackground-color: ", ";\n\t"])), function (props) { return listItemBlockStyle(props); }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 4); }),
    _b[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\t\t", "\n\t"], ["\n\t\t", "\n\t"])), function (props) { return listItemBlockStyle(props); }),
    _b);
var ListItemComponentVariants = (_c = {},
    _c[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t\t", "\n\t\tpadding: 9px; /* this padding matches the card border to prevent displacement */\n\t\tbox-sizing: border-box;\n\t"], ["\n\t\t", "\n\t\tpadding: 9px; /* this padding matches the card border to prevent displacement */\n\t\tbox-sizing: border-box;\n\t"])), function (props) { return listItemBlockStyle(props); }),
    _c[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\t\tpadding: 9px;/* this padding matches the card border to prevent displacement */\n\t\tbox-sizing: border-box;\n\t\theight: auto;\n\t\tborder-radius: 9px;\n\t"], ["\n\t\tpadding: 9px;/* this padding matches the card border to prevent displacement */\n\t\tbox-sizing: border-box;\n\t\theight: auto;\n\t\tborder-radius: 9px;\n\t"]))),
    _c[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\t\t", "\n\t\tpadding: 9px;/* this padding matches the card border to prevent displacement */\n\t"], ["\n\t\t", "\n\t\tpadding: 9px;/* this padding matches the card border to prevent displacement */\n\t"])), function (props) { return listItemBlockStyle(props); }),
    _c[__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(ListItem)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\t\tbackground-color: ", ";\n\t\tborder-radius: 9px;\n\t"], ["\n\t\tbackground-color: ", ";\n\t\tborder-radius: 9px;\n\t"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White),
    _c);
var badgesize = '8px';
var ListItemUnreadBadge = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\twidth: ", ";\n\theight: ", ";\n\tbackground-color: ", ";\n\tposition: absolute;\n\tleft: -5px; /* will need to be recalculated when gutters will be configurable */\n\ttop: 12px; /* will need to be recalculated when gutters will be configurable */\n\tborder-radius: 7px;\n"], ["\n\twidth: ", ";\n\theight: ", ";\n\tbackground-color: ", ";\n\tposition: absolute;\n\tleft: -5px; /* will need to be recalculated when gutters will be configurable */\n\ttop: 12px; /* will need to be recalculated when gutters will be configurable */\n\tborder-radius: 7px;\n"])), badgesize, badgesize, function (props) { return props.theme.primary.actionColor; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

// tslint:disable-next-line no-any
var useResetDrivePage = function (deps) {
    var _a = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), shouldResetDrivePage = _a[0], setShouldResetDrivePage = _a[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setShouldResetDrivePage(true);
        setTimeout(function () {
            setShouldResetDrivePage(false);
        }, 0);
    }, deps);
    return shouldResetDrivePage;
};
/* harmony default export */ __webpack_exports__["a"] = (useResetDrivePage);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThumbnailType; });
var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType["COLUMN"] = "COLUMN";
    ThumbnailType["GRID"] = "GRID";
})(ThumbnailType || (ThumbnailType = {}));


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1323);


var Spinner = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Wrapper */], null, Array.from({ length: 12 }, function (v, i) { return i + 1; }).map(function (i) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: i }); }))); };
/* harmony default export */ __webpack_exports__["a"] = (Spinner);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LabelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProgressLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(89);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-bottom: 20px;\n"], ["\n\tmargin-bottom: 20px;\n"])));
var LabelWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n"])));
var ProgressLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 37px;\n\tline-height: 50px;\n\tletter-spacing: 1.65px;\n\tcolor: ", ";\n\n\t", "\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 37px;\n\tline-height: 50px;\n\tletter-spacing: 1.65px;\n\tcolor: ", ";\n\n\t",
    "\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, 30), function (_a) {
    var theme = _a.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_4____["a" /* ResourceSelectorTheme */].DARK && "\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\t";
});
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\n\t", "\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\n\t",
    "\n"])), function (_a) {
    var isError = _a.isError;
    return isError ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red300 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black;
}, function (_a) {
    var theme = _a.theme, isError = _a.isError;
    return theme === __WEBPACK_IMPORTED_MODULE_4____["a" /* ResourceSelectorTheme */].DARK && "\n\t\tcolor: " + (isError ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].LightRed : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75)) + ";\n\t";
});
var ButtonCancel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex: 0 0 auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tmargin-left: 20px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\toutline: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: ", ";\n\t}\n\n\t", "\n"], ["\n\tflex: 0 0 auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tmargin-left: 20px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\toutline: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: ", ";\n\t}\n\n\t",
    "\n"])), function (_a) {
    var isError = _a.isError;
    return isError ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red300 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey200;
}, function (_a) {
    var isError = _a.isError;
    return isError ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey450;
}, function (_a) {
    var theme = _a.theme, isError = _a.isError;
    return theme === __WEBPACK_IMPORTED_MODULE_4____["a" /* ResourceSelectorTheme */].DARK && "\n\t\tbackground-color: " + (isError ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].LightRed : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 20)) + ";\n\n\t\tsvg {\n\t\t\tfill: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t\t}\n\t";
});
var Bar = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: relative;\n\theight: 3px;\n\tborder-radius: 1px;\n\tbackground-color: ", ";\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: ", ";\n\t\tborder-radius: inherit;\n\t\tbackground-image: ", ";\n\t}\n"], ["\n\tposition: relative;\n\theight: 3px;\n\tborder-radius: 1px;\n\tbackground-color: ", ";\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: ", ";\n\t\tborder-radius: inherit;\n\t\tbackground-image: ",
    ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return props.percentage + "%"; }, function (props) { return "linear-gradient(to right, " + (props.isError
    ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red400 + " 24%, " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200 + " 78%"
    : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue400 + " 56%, " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue300 + " 92%") + ")"; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LinkToDownloadsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 9;\n\twidth: 320px;\n\tborder-radius: 9px 9px 0 0;\n\tbackground-color: ", ";\n\tbox-shadow: 0 2px 26px 0 ", ";\n\tcolor: ", ";\n\ttransform: ", ";\n\ttransition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n"], ["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 9;\n\twidth: 320px;\n\tborder-radius: 9px 9px 0 0;\n\tbackground-color: ", ";\n\tbox-shadow: 0 2px 26px 0 ", ";\n\tcolor: ", ";\n\ttransform: ", ";\n\ttransition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 25), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, function (props) { return props.isDisplayed ? 'translateY(0)' : 'translateY(150%)'; });
var StyledHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tpadding: 20px;\n\tpadding-right: 15px;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\n\t> span {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tpadding: 20px;\n\tpadding-right: 15px;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\n\t> span {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"])), function (props) { return props.theme.primary.actionColor; });
var Title = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White);
var buttonCommonStyles = "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\tfill: " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t}\n";
var Toggle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n\tmargin-left: auto;\n\n\t", "\n\n\tsvg {\n\t\twidth: 11px;\n\t\theight: 11px;\n\t}\n"], ["\n\t", "\n\tmargin-left: auto;\n\n\t", "\n\n\tsvg {\n\t\twidth: 11px;\n\t\theight: 11px;\n\t}\n"])), buttonCommonStyles, function (_a) {
    var isExpanded = _a.isExpanded;
    return !isExpanded && 'transform: rotate(180deg);';
});
var ButtonClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\n\tsvg {\n\t\twidth: 9px;\n\t\theight: 9px;\n\t}\n"], ["\n\t", "\n\n\tsvg {\n\t\twidth: 9px;\n\t\theight: 9px;\n\t}\n"])), buttonCommonStyles);
var ContentWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tpadding: 20px;\n\tfont-size: 12px;\n\tline-height: 16px;\n\n    .icon-and-text {\n        display: flex;\n        align-items: center;\n    }\n\n    svg {\n        height: 20px;\n        width: 20px;\n        margin-right: 5px;\n        animation: ", ";\n    }\n"], ["\n\tpadding: 20px;\n\tfont-size: 12px;\n\tline-height: 16px;\n\n    .icon-and-text {\n        display: flex;\n        align-items: center;\n    }\n\n    svg {\n        height: 20px;\n        width: 20px;\n        margin-right: 5px;\n        animation: ", ";\n    }\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]);
var ButtonContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n"])));
var ContentButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t", "\n\n\tmin-width: 100px;\n\tmargin: 20px auto 0;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: 'HelveticaNeue', sans-serif;\n\tfont-weight: 700;\n\tfont-size: 12px;\n\tline-height: 12px;\n"], ["\n\t", "\n\n\tmin-width: 100px;\n\tmargin: 20px auto 0;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: 'HelveticaNeue', sans-serif;\n\tfont-weight: 700;\n\tfont-size: 12px;\n\tline-height: 12px;\n"])), buttonCommonStyles, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var color = _a.color;
    return color || 'inherit';
});
var LinkToDownloadsPage = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-top: 5px;\n\n\ta {\n\t\tfont-weight: 700;\n\t\ttext-decoration: none;\n\t\tcolor: ", ";\n\t}\n"], ["\n\tdisplay: block;\n\tmargin-top: 5px;\n\n\ta {\n\t\tfont-weight: 700;\n\t\ttext-decoration: none;\n\t\tcolor: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 0;\n\tright: ", ";\n\tz-index: 10;\n\twidth: 320px;\n\tborder-radius: 9px 9px 0 0;\n\tbackground-color: ", ";\n\tbox-shadow: 0 2px 26px 0 ", ";\n\tcolor: ", ";\n\ttransform: ", ";\n\ttransition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, right 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n"], ["\n\tposition: absolute;\n\tbottom: 0;\n\tright: ",
    ";\n\tz-index: 10;\n\twidth: 320px;\n\tborder-radius: 9px 9px 0 0;\n\tbackground-color: ", ";\n\tbox-shadow: 0 2px 26px 0 ", ";\n\tcolor: ", ";\n\ttransform: ", ";\n\ttransition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, right 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n"])), function (props) {
    // If screen is wide enough (> 650px) AND download manager is active, position side by side
    if (props.isDisplayed && props.isDownloadManagerActive && props.screenWidth > 650) {
        return '330px';
    }
    return '0';
}, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 25), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, function (props) { return props.isDisplayed ? 'translateY(0)' : 'translateY(150%)'; });
var StyledHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tpadding: 20px;\n\tpadding-right: 15px;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\n\t> span {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 40px;\n\tpadding: 20px;\n\tpadding-right: 15px;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\n\t> span {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n"])), function (props) { return props.theme.primary.actionColor; });
var Title = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White);
var buttonCommonStyles = "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\n\tsvg {\n\t\tfill: " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t}\n";
var Toggle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n\tmargin-left: auto;\n\n\t", "\n\n\tsvg {\n\t\twidth: 11px;\n\t\theight: 11px;\n\t}\n"], ["\n\t", "\n\tmargin-left: auto;\n\n\t", "\n\n\tsvg {\n\t\twidth: 11px;\n\t\theight: 11px;\n\t}\n"])), buttonCommonStyles, function (_a) {
    var isExpanded = _a.isExpanded;
    return !isExpanded && 'transform: rotate(180deg);';
});
var ButtonClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\n\tsvg {\n\t\twidth: 9px;\n\t\theight: 9px;\n\t}\n"], ["\n\t", "\n\n\tsvg {\n\t\twidth: 9px;\n\t\theight: 9px;\n\t}\n"])), buttonCommonStyles);
var ContentWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tpadding: 20px;\n\tfont-size: 12px;\n\tline-height: 16px;\n\n\t.icon-and-text {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t.text > span {\n\t\tdisplay: block;\n\t}\n\n\tsvg {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tmargin-right: 5px;\n\t\tanimation: ", ";\n\t}\n"], ["\n\tpadding: 20px;\n\tfont-size: 12px;\n\tline-height: 16px;\n\n\t.icon-and-text {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t.text > span {\n\t\tdisplay: block;\n\t}\n\n\tsvg {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tmargin-right: 5px;\n\t\tanimation: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]);
var ButtonContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n"])));
var ContentButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t", "\n\n\tmin-width: 100px;\n\tmargin: 20px auto 0;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: 'HelveticaNeue', sans-serif;\n\tfont-weight: 700;\n\tfont-size: 12px;\n\tline-height: 12px;\n"], ["\n\t", "\n\n\tmin-width: 100px;\n\tmargin: 20px auto 0;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: 'HelveticaNeue', sans-serif;\n\tfont-weight: 700;\n\tfont-size: 12px;\n\tline-height: 12px;\n"])), buttonCommonStyles, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var color = _a.color;
    return color || 'inherit';
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icons.12d99fee.svg";

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MultiAppAuthenticationForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_validation__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Input__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_MultiAppAuthentication_reducer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Authentication_styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_indexedDB_manager__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};














var InputName;
(function (InputName) {
    InputName["Login"] = "login";
    InputName["Phone"] = "phone";
    InputName["Password"] = "password";
    InputName["Company"] = "company";
})(InputName || (InputName = {}));
var PASSWORD_MIN_LENGTH = 6;
var PHONE_MIN_LENGTH = 6;
var MultiAppAuthenticationForm = /** @class */ (function (_super) {
    __extends(MultiAppAuthenticationForm, _super);
    function MultiAppAuthenticationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeFormField = function (e, inputName) {
            var _a;
            var _b = _this.props, credentials = _b.credentials, dispatch = _b.dispatch;
            var shouldDisplayErrorMessage = _this.shouldDisplayErrorMessage;
            var value = e.currentTarget.value;
            if (shouldDisplayErrorMessage) {
                _this.resetErrorMessage();
            }
            if (!value && credentials) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["l" /* updateCredentials */])((_a = {}, _a[inputName] = null, _a))).then(function () {
                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["i" /* setFormValue */])(inputName, value));
                });
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["i" /* setFormValue */])(inputName, value));
            }
        };
        _this.handleSendForm = function (e) {
            e.preventDefault();
            var _a = _this.props, dispatch = _a.dispatch, switchViewMode = _a.switchViewMode, isLoginView = _a.isLoginView, isCompanyView = _a.isCompanyView, isPasswordView = _a.isPasswordView, isCreationView = _a.isCreationView, form = _a.form, setLoader = _a.setLoader;
            var login = form.login, password = form.password, company = form.company;
            var shouldRememberCredentials = _this.state.shouldRememberCredentials;
            if (!__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isOnline()) {
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_NotificationBar_actions__["c" /* createNotification */])('info.offline_login'));
            }
            if (isLoginView) {
                if (!__WEBPACK_IMPORTED_MODULE_7__utils_validation__["a" /* default */].isValidEmail(login)) {
                    _this.setState({ errorMessage: __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["I18n"].t('error.invalid_email_address') });
                    return;
                }
                switchViewMode(__WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Password);
            }
            else if (isCompanyView) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["e" /* getAuthMethods */])(company))
                    .then(function (orgAuthMethods) {
                    if (orgAuthMethods.length === 1) {
                        var method = orgAuthMethods[0];
                        if (method === __WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication) {
                            switchViewMode(__WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Login);
                        }
                        else {
                            switchViewMode(__WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].OrgLogin);
                        }
                    }
                    else {
                        switchViewMode(__WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Method);
                    }
                })
                    .catch(function () { return dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["a" /* MultiAppAuthenticationInfosActionKeys */].COMPANY_ERROR }); });
            }
            else if (isPasswordView) {
                setLoader(true);
                var credentialsPayload = __assign({ login: login,
                    password: password, method: __WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication }, (company ? { company: company } : {}));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["j" /* signIn */])(credentialsPayload, shouldRememberCredentials))
                    .then(function () { return setLoader(false); })
                    .catch(function () { return setLoader(false); });
            }
            else if (isCreationView) {
                _this.createDemoAccount();
            }
        };
        _this.toggleRememberMe = function () {
            var shouldRememberCredentials = _this.state.shouldRememberCredentials;
            if (shouldRememberCredentials) {
                __WEBPACK_IMPORTED_MODULE_13__utils_indexedDB_manager__["a" /* default */].removeMultiAppCredentials().then();
            }
            _this.setState({ shouldRememberCredentials: !shouldRememberCredentials });
        };
        _this.state = {
            shouldRememberCredentials: true,
        };
        _this.onClickForgotPassword = _this.onClickForgotPassword.bind(_this);
        return _this;
    }
    MultiAppAuthenticationForm.prototype.componentWillUpdate = function (nextProps) {
        if (this.props.viewMode !== nextProps.viewMode) {
            this.resetErrorMessage();
        }
    };
    MultiAppAuthenticationForm.prototype.createDemoAccount = function () {
        var _this = this;
        var _a = this.props, dispatch = _a.dispatch, setLoader = _a.setLoader, form = _a.form;
        var login = form.login, password = form.password, phone = form.phone;
        if (!login || !password || !phone) {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_NotificationBar_actions__["c" /* createNotification */])('info.fill_all_input_fields'));
        }
        setLoader(true);
        __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].createAspDemoAccount(login, password, phone)
            .then(function () {
            setLoader(false);
            _this.setState({ errorMessage: undefined });
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["j" /* signIn */])({ login: login, password: password, method: __WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication }, _this.state.shouldRememberCredentials));
        })
            .catch(function (reason) {
            setLoader(false);
            _this.setState({ errorMessage: reason.message });
        });
    };
    MultiAppAuthenticationForm.prototype.resetErrorMessage = function () {
        var _a = this.props, dispatch = _a.dispatch, isPasswordView = _a.isPasswordView, isCompanyView = _a.isCompanyView;
        if (isPasswordView || isCompanyView) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__containers_MultiAppAuthentication_actions__["a" /* MultiAppAuthenticationInfosActionKeys */].RESET_STATUS });
        }
        this.setState({ errorMessage: undefined });
    };
    MultiAppAuthenticationForm.prototype.onClickForgotPassword = function () {
        var _a = this.props, galleryConfig = _a.galleryConfig, form = _a.form;
        var company = form.company;
        var url = __WEBPACK_IMPORTED_MODULE_2__utils_url__["b" /* default */].getResetAspPasswordUrl(galleryConfig, company);
        window.open(url, '_blank');
    };
    Object.defineProperty(MultiAppAuthenticationForm.prototype, "shouldDisplayErrorMessage", {
        get: function () {
            var _a = this.props, isPasswordView = _a.isPasswordView, isCompanyView = _a.isCompanyView, aspConnexionStatus = _a.aspConnexionStatus;
            if (isPasswordView || isCompanyView) {
                return [__WEBPACK_IMPORTED_MODULE_10__containers_MultiAppAuthentication_reducer__["a" /* AspConnexionStatus */].AUTH_ERROR, __WEBPACK_IMPORTED_MODULE_10__containers_MultiAppAuthentication_reducer__["a" /* AspConnexionStatus */].NO_APP_ERROR, __WEBPACK_IMPORTED_MODULE_10__containers_MultiAppAuthentication_reducer__["a" /* AspConnexionStatus */].NO_COMPANY_ERROR].includes(aspConnexionStatus);
            }
            return !!this.state.errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAppAuthenticationForm.prototype, "loginErrorMessageKey", {
        get: function () {
            var _a = this.props, isLoginView = _a.isLoginView, isCreationView = _a.isCreationView, form = _a.form;
            var login = form.login;
            var shouldDisplayErrorMessage = this.shouldDisplayErrorMessage;
            var isInvalidEmail = shouldDisplayErrorMessage && (isLoginView || isCreationView) && !__WEBPACK_IMPORTED_MODULE_7__utils_validation__["a" /* default */].isValidEmail(login);
            var isExistingEmail = shouldDisplayErrorMessage && isCreationView && this.state.errorMessage === 'DUPLICATE_EMAIL--email';
            if (isInvalidEmail) {
                return __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["I18n"].t('error.invalid_email_address');
            }
            else if (isExistingEmail) {
                return __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["I18n"].t('error.duplicate_email');
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAppAuthenticationForm.prototype, "passwordErrorMessageKey", {
        get: function () {
            var _a = this.props, isPasswordView = _a.isPasswordView, isCreationView = _a.isCreationView, form = _a.form;
            var password = form.password;
            var _b = this, shouldDisplayErrorMessage = _b.shouldDisplayErrorMessage, connectionErrorMessageKey = _b.connectionErrorMessageKey;
            var isShortPassword = shouldDisplayErrorMessage && (isPasswordView || isCreationView) && password.length < PASSWORD_MIN_LENGTH;
            var isConnectionError = shouldDisplayErrorMessage && connectionErrorMessageKey;
            if (isConnectionError) {
                return connectionErrorMessageKey;
            }
            else if (isShortPassword) {
                return __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["I18n"].t('error.field_must_have_at_least', { charsCount: PASSWORD_MIN_LENGTH });
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAppAuthenticationForm.prototype, "phoneErrorMessageKey", {
        get: function () {
            var _a = this.props, isCreationView = _a.isCreationView, form = _a.form;
            var phone = form.phone;
            var shouldDisplayErrorMessage = this.shouldDisplayErrorMessage;
            var isShortPhoneNb = shouldDisplayErrorMessage && isCreationView && phone.length < PHONE_MIN_LENGTH;
            return isShortPhoneNb
                ? __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["I18n"].t('error.field_must_have_at_least', { charsCount: PHONE_MIN_LENGTH })
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAppAuthenticationForm.prototype, "companyErrorMessageKey", {
        get: function () {
            var isCompanyView = this.props.isCompanyView;
            var shouldDisplayErrorMessage = this.shouldDisplayErrorMessage;
            return shouldDisplayErrorMessage && isCompanyView ? __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["I18n"].t('error.invalid_company_name') : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAppAuthenticationForm.prototype, "connectionErrorMessageKey", {
        get: function () {
            var _a = this.props, isPasswordView = _a.isPasswordView, aspConnexionStatus = _a.aspConnexionStatus;
            if (isPasswordView) {
                return aspConnexionStatus === __WEBPACK_IMPORTED_MODULE_10__containers_MultiAppAuthentication_reducer__["a" /* AspConnexionStatus */].AUTH_ERROR ? 'error.invalid_auth' : 'error.no_application_available';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    MultiAppAuthenticationForm.prototype.buttonText = function () {
        var _a = this.props, isLoginView = _a.isLoginView, isCompanyView = _a.isCompanyView, isCreationView = _a.isCreationView, isPasswordView = _a.isPasswordView;
        if (isCompanyView || isLoginView) {
            return 'next';
        }
        else if (isPasswordView) {
            return 'connect';
        }
        else if (isCreationView) {
            return 'try_demo';
        }
        else {
            return '';
        }
    };
    MultiAppAuthenticationForm.prototype.isSubmitButtonDisabled = function () {
        var _a = this.props, isLoginView = _a.isLoginView, isCompanyView = _a.isCompanyView, isCreationView = _a.isCreationView, isPasswordView = _a.isPasswordView, form = _a.form;
        var login = form.login, password = form.password, phone = form.phone, company = form.company;
        var shouldDisplayErrorMessage = this.shouldDisplayErrorMessage;
        var enableLoginView = isLoginView && login ? true : false;
        var enablePasswordView = isPasswordView && password ? true : false;
        var enableCompanyView = isCompanyView && company ? true : false;
        var enableCreationView = isCreationView && phone && login && password ? true : false;
        return shouldDisplayErrorMessage || !(enableCompanyView || enableLoginView || enablePasswordView || enableCreationView);
    };
    MultiAppAuthenticationForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLoginView = _a.isLoginView, isCompanyView = _a.isCompanyView, isCreationView = _a.isCreationView, isPasswordView = _a.isPasswordView, switchViewMode = _a.switchViewMode, form = _a.form;
        var login = form.login, password = form.password, company = form.company, phone = form.phone;
        var shouldRememberCredentials = this.state.shouldRememberCredentials;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Authentication_styles__["e" /* AuthenticationForm */], { onSubmit: this.handleSendForm },
            (isLoginView || isCreationView) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* MultiAppAuthenticationInput */], { value: login, key: InputName.Login, name: InputName.Login, onChange: function (e) { return _this.handleChangeFormField(e, InputName.Login); }, errorMessage: this.loginErrorMessageKey }),
            (isPasswordView || isCreationView) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* MultiAppAuthenticationInput */], { value: password, key: InputName.Password, name: InputName.Password, onChange: function (e) { return _this.handleChangeFormField(e, InputName.Password); }, errorMessage: this.passwordErrorMessageKey, autoFocus: isPasswordView ? true : undefined }),
            isCompanyView &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* MultiAppAuthenticationInput */], { value: company, key: InputName.Company, name: InputName.Company, onChange: function (e) { return _this.handleChangeFormField(e, InputName.Company); }, errorMessage: this.companyErrorMessageKey, autoFocus: true }),
            isCreationView &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* MultiAppAuthenticationInput */], { value: phone, key: InputName.Phone, name: InputName.Phone, onChange: function (e) { return _this.handleChangeFormField(e, InputName.Phone); }, errorMessage: this.phoneErrorMessageKey }),
            isLoginView &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["m" /* SwitchCompanyViewBlock */], { onClick: function () { return switchViewMode(__WEBPACK_IMPORTED_MODULE_9__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Company); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.sign_in_options" })),
            isPasswordView &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* MultiAppAuthenticationOptionsWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* InputWrapper */], { onClick: this.toggleRememberMe },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", checked: shouldRememberCredentials, readOnly: true }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.remember_me" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ForgotPasswordLink */], { onClick: this.onClickForgotPassword, href: "javascript:void();" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.forgot_password" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["l" /* SubmitButtonWrapper */], { isLoginView: isLoginView },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Authentication_styles__["a" /* AuthenticateButton */], { type: "submit", disabled: this.isSubmitButtonDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages." + this.buttonText() })))));
    };
    return MultiAppAuthenticationForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledHeaderSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\tz-index: 5;\n\tdisplay: flex;\n\tbox-sizing: border-box;\n\tpadding-left: 22px;\n\tpadding-right: 12px;\n\twidth: 100%;\n\tborder: 0;\n\theight: ", ";\n\talign-items: center;\n\t};\n\tbackground: ", ";\n\t", ";\n\n\t> * {\n\t\tflex-grow: 1;\n\t\tflex-basis: 33%;\n\t}\n\n\t@media ", " {\n\t\tpadding-left: 5px;\n\t\tpadding-right: 5px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\tz-index: 5;\n\tdisplay: flex;\n\tbox-sizing: border-box;\n\tpadding-left: 22px;\n\tpadding-right: 12px;\n\twidth: 100%;\n\tborder: 0;\n\theight: ", ";\n\talign-items: center;\n\t};\n\tbackground: ", ";\n\t",
    ";\n\n\t> * {\n\t\tflex-grow: 1;\n\t\tflex-basis: 33%;\n\t}\n\n\t@media ", " {\n\t\tpadding-left: 5px;\n\t\tpadding-right: 5px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.topnavColor, props.theme.primary.topnavOpacity); }, function (props) { return props.theme.primary.spacerColor && "\n\t\tborder-bottom: 1px solid " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.theme.primary.spacerColor, props.theme.primary.topnavOpacity) + "\n\t"; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var StyledHeaderSection = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tflex-basis: 33%;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\t", "\n"], ["\n\tflex-grow: 1;\n\tflex-basis: 33%;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\t",
    "\n"])), function (props) {
    switch (props.position) {
        case __WEBPACK_IMPORTED_MODULE_2__typings_menu__["c" /* MenuPosition */].center:
            return "justify-content: center;";
        case __WEBPACK_IMPORTED_MODULE_2__typings_menu__["c" /* MenuPosition */].right:
            return 'justify-content: flex-end;';
        case __WEBPACK_IMPORTED_MODULE_2__typings_menu__["c" /* MenuPosition */].left:
        default:
            return 'justify-content: flex-start;';
    }
});
var PageTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Share_ShareButton__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_menuManager__ = __webpack_require__(54);







var mapStateToProps = function (state, ownProps) {
    var galleryInfos = state.galleryInfos, appInfos = state.appInfos, authentication = state.authentication, driveList = state.driveList, routerParamsHistory = state.routerParamsHistory, notes = state.selection.notes, thumbMap = state.offlineManager.thumbMap;
    var driveItems = ownProps.driveItems, icon = ownProps.icon;
    var needCredentials = authentication.userInfos.needCredentials;
    var driveItemsStore = driveList.driveItems;
    var galleryConfig = galleryInfos.config;
    var galleryId = galleryConfig.applicationGallery;
    var type = appInfos.type || __WEBPACK_IMPORTED_MODULE_3__App_reducer__["a" /* AppType */].Single;
    var isNativeShare = __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__["a" /* default */].isMobileApp && !__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* default */].isSecure(type, needCredentials);
    // if Share shouldn't be native and the path is the gallery root, we send the gallery as the shared item
    var isGalleryRoot = __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].isGalleryRoot(routerParamsHistory);
    var sharedItems = !isNativeShare && isGalleryRoot ? [driveItemsStore[galleryId]] : driveItems;
    return {
        galleryConfig: galleryConfig,
        isNativeShare: isNativeShare,
        sharedItems: sharedItems,
        sharedNotesIds: notes,
        iconSrc: Object(__WEBPACK_IMPORTED_MODULE_6__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveItemsStore, galleryConfig, thumbMap, driveList.resolutions),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4__components_Share_ShareButton__["a" /* default */]));


/***/ }),
/* 361 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1420);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLoadStart = handleLoadStart;
exports.handleCanPlay = handleCanPlay;
exports.handleWaiting = handleWaiting;
exports.handleCanPlayThrough = handleCanPlayThrough;
exports.handlePlaying = handlePlaying;
exports.handlePlay = handlePlay;
exports.handlePause = handlePause;
exports.handleEnd = handleEnd;
exports.handleSeeking = handleSeeking;
exports.handleSeeked = handleSeeked;
exports.handleDurationChange = handleDurationChange;
exports.handleTimeUpdate = handleTimeUpdate;
exports.handleVolumeChange = handleVolumeChange;
exports.handleProgressChange = handleProgressChange;
exports.handleRateChange = handleRateChange;
exports.handleSuspend = handleSuspend;
exports.handleAbort = handleAbort;
exports.handleEmptied = handleEmptied;
exports.handleStalled = handleStalled;
exports.handleLoadedMetaData = handleLoadedMetaData;
exports.handleLoadedData = handleLoadedData;
exports.handleResize = handleResize;
exports.handleError = handleError;
exports.handleSeekingTime = handleSeekingTime;
exports.handleEndSeeking = handleEndSeeking;
exports.activateTextTrack = activateTextTrack;
exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
var LOAD_START = 'video-react/LOAD_START';
exports.LOAD_START = LOAD_START;
var CAN_PLAY = 'video-react/CAN_PLAY';
exports.CAN_PLAY = CAN_PLAY;
var WAITING = 'video-react/WAITING';
exports.WAITING = WAITING;
var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
var PLAYING = 'video-react/PLAYING';
exports.PLAYING = PLAYING;
var PLAY = 'video-react/PLAY';
exports.PLAY = PLAY;
var PAUSE = 'video-react/PAUSE';
exports.PAUSE = PAUSE;
var END = 'video-react/END';
exports.END = END;
var SEEKING = 'video-react/SEEKING';
exports.SEEKING = SEEKING;
var SEEKED = 'video-react/SEEKED';
exports.SEEKED = SEEKED;
var SEEKING_TIME = 'video-react/SEEKING_TIME';
exports.SEEKING_TIME = SEEKING_TIME;
var END_SEEKING = 'video-react/END_SEEKING';
exports.END_SEEKING = END_SEEKING;
var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
exports.DURATION_CHANGE = DURATION_CHANGE;
var TIME_UPDATE = 'video-react/TIME_UPDATE';
exports.TIME_UPDATE = TIME_UPDATE;
var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
exports.VOLUME_CHANGE = VOLUME_CHANGE;
var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
var RATE_CHANGE = 'video-react/RATE_CHANGE';
exports.RATE_CHANGE = RATE_CHANGE;
var SUSPEND = 'video-react/SUSPEND';
exports.SUSPEND = SUSPEND;
var ABORT = 'video-react/ABORT';
exports.ABORT = ABORT;
var EMPTIED = 'video-react/EMPTIED';
exports.EMPTIED = EMPTIED;
var STALLED = 'video-react/STALLED';
exports.STALLED = STALLED;
var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
exports.LOADED_META_DATA = LOADED_META_DATA;
var LOADED_DATA = 'video-react/LOADED_DATA';
exports.LOADED_DATA = LOADED_DATA;
var RESIZE = 'video-react/RESIZE';
exports.RESIZE = RESIZE;
var ERROR = 'video-react/ERROR';
exports.ERROR = ERROR;
var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;

function handleLoadStart(videoProps) {
  return {
    type: LOAD_START,
    videoProps: videoProps
  };
}

function handleCanPlay(videoProps) {
  return {
    type: CAN_PLAY,
    videoProps: videoProps
  };
}

function handleWaiting(videoProps) {
  return {
    type: WAITING,
    videoProps: videoProps
  };
}

function handleCanPlayThrough(videoProps) {
  return {
    type: CAN_PLAY_THROUGH,
    videoProps: videoProps
  };
}

function handlePlaying(videoProps) {
  return {
    type: PLAYING,
    videoProps: videoProps
  };
}

function handlePlay(videoProps) {
  return {
    type: PLAY,
    videoProps: videoProps
  };
}

function handlePause(videoProps) {
  return {
    type: PAUSE,
    videoProps: videoProps
  };
}

function handleEnd(videoProps) {
  return {
    type: END,
    videoProps: videoProps
  };
}

function handleSeeking(videoProps) {
  return {
    type: SEEKING,
    videoProps: videoProps
  };
}

function handleSeeked(videoProps) {
  return {
    type: SEEKED,
    videoProps: videoProps
  };
}

function handleDurationChange(videoProps) {
  return {
    type: DURATION_CHANGE,
    videoProps: videoProps
  };
}

function handleTimeUpdate(videoProps) {
  return {
    type: TIME_UPDATE,
    videoProps: videoProps
  };
}

function handleVolumeChange(videoProps) {
  return {
    type: VOLUME_CHANGE,
    videoProps: videoProps
  };
}

function handleProgressChange(videoProps) {
  return {
    type: PROGRESS_CHANGE,
    videoProps: videoProps
  };
}

function handleRateChange(videoProps) {
  return {
    type: RATE_CHANGE,
    videoProps: videoProps
  };
}

function handleSuspend(videoProps) {
  return {
    type: SUSPEND,
    videoProps: videoProps
  };
}

function handleAbort(videoProps) {
  return {
    type: ABORT,
    videoProps: videoProps
  };
}

function handleEmptied(videoProps) {
  return {
    type: EMPTIED,
    videoProps: videoProps
  };
}

function handleStalled(videoProps) {
  return {
    type: STALLED,
    videoProps: videoProps
  };
}

function handleLoadedMetaData(videoProps) {
  return {
    type: LOADED_META_DATA,
    videoProps: videoProps
  };
}

function handleLoadedData(videoProps) {
  return {
    type: LOADED_DATA,
    videoProps: videoProps
  };
}

function handleResize(videoProps) {
  return {
    type: RESIZE,
    videoProps: videoProps
  };
}

function handleError(videoProps) {
  return {
    type: ERROR,
    videoProps: videoProps
  };
}

function handleSeekingTime(time) {
  return {
    type: SEEKING_TIME,
    time: time
  };
}

function handleEndSeeking(time) {
  return {
    type: END_SEEKING,
    time: time
  };
}

function activateTextTrack(textTrack) {
  return {
    type: ACTIVATE_TEXT_TRACK,
    textTrack: textTrack
  };
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var Dom = _interopRequireWildcard(__webpack_require__(252));

var propTypes = {
  className: _propTypes["default"].string,
  onMouseDown: _propTypes["default"].func,
  onMouseMove: _propTypes["default"].func,
  stepForward: _propTypes["default"].func,
  stepBack: _propTypes["default"].func,
  sliderActive: _propTypes["default"].func,
  sliderInactive: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  getPercent: _propTypes["default"].func,
  vertical: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  label: _propTypes["default"].string,
  valuenow: _propTypes["default"].string,
  valuetext: _propTypes["default"].string
};

var Slider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Slider, _Component);

  function Slider(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      document.removeEventListener('keydown', this.handleKeyPress, true);
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      var getPercent = this.props.getPercent;

      if (!getPercent) {
        return 0;
      }

      var progress = getPercent(); // Protect against no duration and other division issues

      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
        progress = 0;
      }

      return progress;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
      // event.stopPropagation();

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: true
      });

      if (this.props.sliderActive) {
        this.props.sliderActive(event);
      }

      this.handleMouseMove(event);

      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var onMouseMove = this.props.onMouseMove;

      if (onMouseMove) {
        onMouseMove(event);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      // On iOS safari, a subsequent mouseup event will be fired after touchend.
      // Its weird event positions make the player seek a wrong time.
      // calling preventDefault (at touchend phase) will prevent the mouseup event
      event.preventDefault();
      var onMouseUp = this.props.onMouseUp;
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: false
      });

      if (this.props.sliderInactive) {
        this.props.sliderInactive(event);
      }

      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.which === 37 || event.which === 40) {
        // Left and Down Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepBack();
      } else if (event.which === 38 || event.which === 39) {
        // Up and Right Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepForward();
      }
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      if (this.props.stepForward) {
        this.props.stepForward();
      }
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      if (this.props.stepBack) {
        this.props.stepBack();
      }
    }
  }, {
    key: "calculateDistance",
    value: function calculateDistance(event) {
      var node = this.slider;
      var position = Dom.getPointerPosition(node, event);

      if (this.props.vertical) {
        return position.y;
      }

      return position.x;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var progress = this.getProgress();
      var percentage = "".concat((progress * 100).toFixed(2), "%");
      return _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          progress: progress,
          percentage: percentage
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          vertical = _this$props.vertical,
          label = _this$props.label,
          valuenow = _this$props.valuenow,
          valuetext = _this$props.valuetext;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, {
          'video-react-slider-vertical': vertical,
          'video-react-slider-horizontal': !vertical,
          'video-react-sliding': this.state.active
        }, 'video-react-slider'),
        ref: function ref(c) {
          _this2.slider = c;
        },
        tabIndex: "0",
        role: "slider",
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleMouseDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        "aria-label": label || '',
        "aria-valuenow": valuenow || '',
        "aria-valuetext": valuetext || '',
        "aria-valuemin": 0,
        "aria-valuemax": 100
      }, this.renderChildren());
    }
  }]);
  return Slider;
}(_react.Component);

exports["default"] = Slider;
Slider.propTypes = propTypes;
Slider.displayName = 'Slider';

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _MenuButton = _interopRequireDefault(__webpack_require__(366));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  rates: _propTypes["default"].array,
  className: _propTypes["default"].string
};
var defaultProps = {
  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
};

var PlaybackRateMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);

  function PlaybackRateMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props = this.props,
          rates = _this$props.rates,
          actions = _this$props.actions;

      if (index >= 0 && index < rates.length) {
        actions.changeRate(rates[index]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rates = _this$props2.rates,
          player = _this$props2.player;
      var items = rates.map(function (rate) {
        return {
          label: "".concat(rate, "x"),
          value: rate
        };
      });
      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Playback Rate"), _react["default"].createElement("div", {
        className: "video-react-playback-rate-value"
      }, "".concat(player.playbackRate.toFixed(2), "x")));
    }
  }]);
  return PlaybackRateMenuButton;
}(_react.Component);

PlaybackRateMenuButton.propTypes = propTypes;
PlaybackRateMenuButton.defaultProps = defaultProps;
PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
var _default = PlaybackRateMenuButton;
exports["default"] = _default;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _Menu = _interopRequireDefault(__webpack_require__(1438));

var _MenuItem = _interopRequireDefault(__webpack_require__(1439));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(601));

var propTypes = {
  inline: _propTypes["default"].bool,
  items: _propTypes["default"].array,
  className: _propTypes["default"].string,
  onSelectItem: _propTypes["default"].func,
  children: _propTypes["default"].any,
  selectedIndex: _propTypes["default"].number
};

var MenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuButton, _Component);

  function MenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
    _this.state = {
      active: false,
      activateIndex: props.selectedIndex || 0
    };
    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.activateMenuItem(this.props.selectedIndex);
      }
    }
  }, {
    key: "commitSelection",
    value: function commitSelection(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "activateMenuItem",
    value: function activateMenuItem(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "handleIndexChange",
    value: function handleIndexChange(index) {
      var onSelectItem = this.props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleUpArrow",
    value: function handleUpArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex - 1;

        if (newIndex < 0) {
          newIndex = items.length ? items.length - 1 : 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleDownArrow",
    value: function handleDownArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex + 1;

        if (newIndex >= items.length) {
          newIndex = 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (this.state.active) {
        e.preventDefault();
        this.commitSelection(this.state.activateIndex);
      }
    }
  }, {
    key: "handleReturn",
    value: function handleReturn(e) {
      e.preventDefault();

      if (this.state.active) {
        this.commitSelection(this.state.activateIndex);
      } else {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "handleEscape",
    value: function handleEscape() {
      this.setState({
        active: false,
        activateIndex: 0
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      // Escape (27) key
      if (event.which === 27) {
        this.handleEscape(event);
      } else if (event.which === 9) {
        // Tab (9) key
        this.handleTab(event);
      } else if (event.which === 13) {
        // Enter (13) key
        this.handleReturn(event);
      } else if (event.which === 38) {
        // Up (38) key
        this.handleUpArrow(event);
      } else if (event.which === 40) {
        // Down (40) key press
        this.handleDownArrow(event);
      }
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(i) {
      this.commitSelection(i);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      var items = this.props.items;
      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
        return _react["default"].createElement(_MenuItem["default"], {
          item: item,
          index: i,
          onSelectItem: _this2.handleSelectItem,
          activateIndex: _this2.state.activateIndex,
          key: "item-".concat(i++)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className;
      return _react["default"].createElement(_ClickableComponent["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-menu-button-inline': !!inline,
          'video-react-menu-button-popup': !inline,
          'video-react-menu-button-active': this.state.active
        }, 'video-react-control video-react-button video-react-menu-button'),
        role: "button",
        tabIndex: "0",
        ref: function ref(c) {
          _this3.menuButton = c;
        },
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props.children, this.renderMenu());
    }
  }]);
  return MenuButton;
}(_react.Component);

exports["default"] = MenuButton;
MenuButton.propTypes = propTypes;
MenuButton.displayName = 'MenuButton';

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioBoxTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1493);


var RadioBoxTheme;
(function (RadioBoxTheme) {
    RadioBoxTheme["DARK"] = "DARK";
    RadioBoxTheme["LIGHT"] = "LIGHT";
})(RadioBoxTheme || (RadioBoxTheme = {}));
var RadioBox = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, isChecked = _a.isChecked, isDisabled = _a.isDisabled, _b = _a.theme, theme = _b === void 0 ? RadioBoxTheme.LIGHT : _b, onChange = _a.onChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Label */], { isActive: isChecked, theme: theme },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "radio", name: name, value: value, checked: isChecked, disabled: isDisabled, onChange: onChange }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Icon */], { isActive: isChecked, theme: theme }),
        label));
};
/* harmony default export */ __webpack_exports__["b"] = (RadioBox);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_VisibilityToggle__ = __webpack_require__(1498);


var mapStateToProps = function (state) {
    var _a = state.editor, spreadZoom = _a.spreadZoom, isAccessibleVersion = _a.isAccessibleVersion;
    return {
        spreadZoom: spreadZoom,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_VisibilityToggle__["a" /* default */]));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(258);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(618);
var defined = __webpack_require__(619);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(627);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PreviewMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SCALE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SpreadBackgroundPanel__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_SpreadBackgroundPanel_SliderPanel__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









var PreviewMode;
(function (PreviewMode) {
    PreviewMode["DESKTOP"] = "desktop";
    PreviewMode["PHONE"] = "phone";
})(PreviewMode || (PreviewMode = {}));
var getPanels = function (defaultMediaType, position, onPositionChange) {
    var _a;
    var props = {
        position: position,
        onPositionChange: onPositionChange,
    };
    var panels = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].image] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SpreadBackgroundPanel__["a" /* default */], __assign({ type: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].image }, props))),
        _a[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].video] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SpreadBackgroundPanel__["a" /* default */], __assign({ type: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].video }, props))),
        _a);
    if (defaultMediaType === __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__["a" /* BackgroundMediaType */].SLIDER) {
        panels[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].slider] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_SpreadBackgroundPanel_SliderPanel__["a" /* default */], null);
    }
    return panels;
};
var isClickOnBackground = function (e) {
    var element = e.target;
    return element.classList.contains(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["l" /* SPREAD_BACKGROUND_CLICK_CLASSNAME */]);
};
var getDefaultPanelType = function (mediaType) {
    switch (mediaType) {
        case __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__["a" /* BackgroundMediaType */].IMAGE:
            return __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].image;
        case __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__["a" /* BackgroundMediaType */].MOVIE:
            return __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].video;
        case __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__["a" /* BackgroundMediaType */].SLIDER:
            return __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].slider;
    }
};
var DEFAULT_SCALE = 1;
var DEFAULT_TOP = 50; // %
var DEFAULT_LEFT = 50; // %
var DEFAULT_POSITION = {
    scale: DEFAULT_SCALE,
    top: DEFAULT_TOP,
    left: DEFAULT_LEFT,
};
var previewModes = [PreviewMode.DESKTOP, PreviewMode.PHONE];
var getInitialValue = function (value, defaultValue) { return (value === undefined ? defaultValue : value); };
var getInitialPosition = function (position) {
    var initialPosition = position ? __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].deepCopy(position) : undefined;
    if (!initialPosition) {
        return {
            desktop: DEFAULT_POSITION,
            phone: DEFAULT_POSITION,
        };
    }
    for (var i = 0; i < previewModes.length; i++) {
        var mode = previewModes[i];
        if (!initialPosition[mode]) {
            initialPosition[mode] = DEFAULT_POSITION;
        }
        else {
            initialPosition[mode] = {
                scale: getInitialValue(initialPosition[mode].scale, DEFAULT_SCALE),
                top: getInitialValue(initialPosition[mode].top, DEFAULT_TOP),
                left: getInitialValue(initialPosition[mode].left, DEFAULT_LEFT),
            };
        }
    }
    return initialPosition;
};
var Background = function (_a) {
    var url = _a.url, colors = _a.colors, initialPosition = _a.position, isHidden = _a.isHidden, isEditable = _a.isEditable, isActive = _a.isActive, isEditPanelDisplayed = _a.isEditPanelDisplayed, mediaType = _a.mediaType, defaultMediaType = _a.defaultMediaType, editorContainer = _a.editorContainer, children = _a.children, thumbnailsWidth = _a.thumbnailsWidth, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](function () { return getInitialPosition(initialPosition); }), 2), position = _b[0], setPosition = _b[1];
    var handleClick = function (e) {
        if ((!url && defaultMediaType !== __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__["a" /* BackgroundMediaType */].SLIDER) || !isEditable || isActive) {
            return;
        }
        if (isClickOnBackground(e)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["M" /* setIsSpreadBackgroundActive */])(true));
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setPosition(getInitialPosition(initialPosition));
    }, [initialPosition]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isActive) {
            return;
        }
        var handleWindowClick = function (e) {
            if (!isClickOnBackground(e)) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["M" /* setIsSpreadBackgroundActive */])(false));
            }
        };
        if (editorContainer) {
            editorContainer.addEventListener('mousedown', handleWindowClick);
        }
        return function () {
            if (editorContainer) {
                editorContainer.removeEventListener('mousedown', handleWindowClick);
            }
        };
    }, [isActive]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Wrapper */], { isHidden: isHidden, colors: colors, onClick: handleClick },
        isActive && isEditPanelDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: getDefaultPanelType(mediaType), panels: getPanels(defaultMediaType, position, setPosition) }),
        (url || defaultMediaType === __WEBPACK_IMPORTED_MODULE_7__containers_Editor_reducer__["a" /* BackgroundMediaType */].SLIDER) &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ImageWrapper */], { className: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["l" /* SPREAD_BACKGROUND_CLICK_CLASSNAME */], isActive: isActive },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Image */], { url: url, position: position, thumbnailsWidth: thumbnailsWidth, className: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["l" /* SPREAD_BACKGROUND_CLICK_CLASSNAME */] })),
        children));
};
/* harmony default export */ __webpack_exports__["c"] = (Background);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = void 0;
var Direction;
(function (Direction) {
    Direction["Right"] = "to right";
    Direction["Left"] = "to left";
    Direction["Down"] = "to bottom";
    Direction["Up"] = "to top";
})(Direction = exports.Direction || (exports.Direction = {}));


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_rnd__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionButton__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var ActionType;
(function (ActionType) {
    ActionType["EDIT_LINK"] = "EDIT_LINK";
    ActionType["RUN_INDESIGN_ACTION"] = "RUN_INDESIGN_ACTION";
    ActionType["TOGGLE_BUTTON_STATE"] = "TOGGLE_BUTTON_STATE";
    ActionType["TOGGLE_VISIBILITY"] = "TOGGLE_VISIBILITY";
})(ActionType || (ActionType = {}));
var PANEL_WIDTH = 50;
var ACTION_BUTTON_HEIGHT = 38 + 6;
var DRAG_DOTS_HEIGHT = 22 + 6;
var GAP = 8;
var ActionsPanel = function (_a) {
    var id = _a.id, actions = _a.actions, pageScale = _a.pageScale, spreadZoom = _a.spreadZoom, onToggle = _a.onToggle;
    var toggleElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var panelElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isOpened = _b[0], setIsOpened = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"]({ x: 0, y: 0 }), 2), position = _c[0], setPosition = _c[1];
    var handleToggle = function () {
        setIsOpened(function (isOpened) { return !isOpened; });
        onToggle();
    };
    var handleDragStop = function (e, _a) {
        var x = _a.x, y = _a.y;
        setPosition({ x: x, y: y });
    };
    var updatePosition = function () {
        if (!toggleElement.current) {
            return;
        }
        var panelHeight = actions.length * ACTION_BUTTON_HEIGHT + DRAG_DOTS_HEIGHT;
        var _a = toggleElement.current.getBoundingClientRect(), top = _a.top, left = _a.left, right = _a.right, height = _a.height;
        setPosition({
            x: left < (PANEL_WIDTH + GAP)
                ? right + GAP
                : left - PANEL_WIDTH - GAP,
            y: top + panelHeight > window.innerHeight
                ? top - panelHeight + height
                : top,
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isOpened) {
            return;
        }
        var handleClickOutside = function (e) {
            var target = e.target;
            if (toggleElement.current &&
                !toggleElement.current.contains(target) &&
                panelElement.current &&
                !panelElement.current.contains(target) &&
                !target.closest("." + __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["b" /* EDIT_PANEL_CLASSNAME */])) {
                setIsOpened(false);
            }
        };
        window.addEventListener('pointerdown', handleClickOutside);
        return function () {
            window.removeEventListener('pointerdown', handleClickOutside);
        };
    }, [isOpened]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isOpened) {
            return;
        }
        if (id) {
            updatePosition();
        }
        else {
            setIsOpened(false);
        }
    }, [id, isOpened]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isOpened) {
            return;
        }
        // Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', updatePosition);
        }
        else {
            window.addEventListener('resize', updatePosition);
        }
        return function () {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', updatePosition);
            }
            else {
                window.removeEventListener('resize', updatePosition);
            }
        };
    }, [isOpened]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* Toggle */], { ref: toggleElement, pageScale: pageScale, spreadZoom: spreadZoom, isOpened: isOpened, onClick: handleToggle }, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_plus')),
        isOpened &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Portal__["a" /* default */], { parentNode: document.body },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_rnd__["a" /* Rnd */], { position: position, onDragStop: handleDragStop, bounds: "parent", cancel: ".prevent-drag", enableResizing: false },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Panel */], { ref: panelElement, className: __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* PanelInner */], { className: "prevent-drag" }, actions.map(function (action) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ActionButton__["a" /* default */], __assign({ key: action.type }, action))); })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* IconMove */], null, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_6dots')))))));
};
/* harmony default export */ __webpack_exports__["b"] = (ActionsPanel);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TableCellInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TableCellImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TableCellImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TableCellButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TableCellTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledTable = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('table')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tcolor: ", ";\n"], ["\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tcolor: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.strongColor, 70);
});
var TableCellInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var TableCellImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 125px;\n\theight: 125px;\n\tborder: 1px solid ", ";\n\tborder-radius: 9px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 0 22px -8px ", ";\n\toverflow: hidden;\n"], ["\n\twidth: 125px;\n\theight: 125px;\n\tborder: 1px solid ", ";\n\tborder-radius: 9px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 0 22px -8px ", ";\n\toverflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.strongColor, 9);
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.strongColor, 17);
});
var TableCellImage = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('img')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
var TableCellButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\twidth: 34px;\n\theight: 34px;\n\tpadding: 8px;\n\tborder: 0;\n\tborder-radius: 4px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t& + & {\n\t\tmargin-left: 4px;\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfill: currentColor;\n\t}\n"], ["\n\twidth: 34px;\n\theight: 34px;\n\tpadding: 8px;\n\tborder: 0;\n\tborder-radius: 4px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t& + & {\n\t\tmargin-left: 4px;\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfill: currentColor;\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 10);
}, function (_a) {
    var theme = _a.theme;
    return theme.primary.actionColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.primary.actionColor;
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var TableCellTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('textarea')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tflex: 1 1 50%;\n\tmargin-left: 30px;\n\tpadding: 10px;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tborder: 1px solid transparent;\n\tborder-radius: 4px;\n\tbackground-color: transparent;\n\n\t", "\n"], ["\n\tflex: 1 1 50%;\n\tmargin-left: 30px;\n\tpadding: 10px;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tborder: 1px solid transparent;\n\tborder-radius: 4px;\n\tbackground-color: transparent;\n\n\t",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primary.strongColor;
}, function (props) { return props.as === 'textarea' && "\n\t\twidth: 100%;\n\t\tmin-height: 40px;\n\t\tfont-family: inherit;\n\t\toutline: 0;\n\t\tresize: none;\n\t\t-webkit-appearance: none;\n\n\t\t&:focus {\n\t\t\tbackground-color: " + function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.strongColor, 3);
} + ";\n\t\t\tborder-color: currentColor;\n\t\t}\n\t"; });
var TableCell = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('td')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 15%;\n\theight: ", ";\n\tpadding: 15px;\n\ttext-align: left;\n\n\t&:first-child {\n\t\twidth: 60%;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tborder-bottom: 1px solid ", ";\n\n\t\ttbody tr:last-child & {\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t", "\n\n\t// mobile\n\t@media only screen and (max-width : 600px) {\n\t\tvertical-align: ", ";\n\n\t\t&:nth-child(2),\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t", " {\n\t\t\tmargin-left: 10px;\n\t\t}\n\n\t\t", ",\n\t\t", " {\n\t\t\tmargin-top: 10px;\n\t\t}\n\n\t\t", "\n\t}\n\n\t// tablet + desktop\n\t@media only screen and (min-width : 601px) {\n\t\t&:first-child ", " {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&:nth-child(3) ", " {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t", "\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 15%;\n\theight: ",
    ";\n\tpadding: 15px;\n\ttext-align: left;\n\n\t&:first-child {\n\t\twidth: 60%;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tborder-bottom: 1px solid ", ";\n\n\t\ttbody tr:last-child & {\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t",
    "\n\n\t// mobile\n\t@media only screen and (max-width : 600px) {\n\t\tvertical-align: ", ";\n\n\t\t&:nth-child(2),\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t", " {\n\t\t\tmargin-left: 10px;\n\t\t}\n\n\t\t", ",\n\t\t", " {\n\t\t\tmargin-top: 10px;\n\t\t}\n\n\t\t",
    "\n\t}\n\n\t// tablet + desktop\n\t@media only screen and (min-width : 601px) {\n\t\t&:first-child ", " {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&:nth-child(3) ", " {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t",
    "\n\t}\n"])), function (_a) {
    var as = _a.as, hasImage = _a.hasImage;
    if (as === 'th') {
        return '30px';
    }
    return hasImage ? '157px' : '60px';
}, function (_a) {
    var theme = _a.theme;
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.strongColor, 9);
}, function (_a) {
    var as = _a.as, theme = _a.theme;
    return as === 'th' && "\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1;\n\t\tbackground-color: " + theme.primary.backgroundColor + ";\n\t\tfont-weight: 400;\n\t\tfont-size: 11px;\n\t\tline-height: 12px;\n\t\tcolor: " + theme.primary.actionColor + ";\n\t";
}, function (_a) {
    var as = _a.as;
    return as === 'th' ? 'middle' : 'top';
}, TableCellTitle, TableCellImageWrapper, TableCellButton, function (_a) {
    var as = _a.as;
    return as === 'th' && "\n\t\t\t&:first-child span:first-child {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t";
}, TableCellImageWrapper, TableCellInner, function (_a) {
    var as = _a.as;
    return as === 'th' && "\n\t\t\t&:first-child span:last-child {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t";
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(646);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(74) && !__webpack_require__(157)(function () {
  return Object.defineProperty(__webpack_require__(380)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
var document = __webpack_require__(57).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(45);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(105);
var toIObject = __webpack_require__(110);
var arrayIndexOf = __webpack_require__(385)(false);
var IE_PROTO = __webpack_require__(266)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(190);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(110);
var toLength = __webpack_require__(161);
var toAbsoluteIndex = __webpack_require__(655);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 386 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(190);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(383);
var hiddenKeys = __webpack_require__(267).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(192);
var createDesc = __webpack_require__(158);
var toIObject = __webpack_require__(110);
var toPrimitive = __webpack_require__(262);
var has = __webpack_require__(105);
var IE8_DOM_DEFINE = __webpack_require__(379);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(74) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(269);
var test = {};
test[__webpack_require__(45)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(108)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(109);
var IObject = __webpack_require__(384);
var toObject = __webpack_require__(193);
var toLength = __webpack_require__(161);
var asc = __webpack_require__(665);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(670)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(270)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(107);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(162);
var ITERATOR = __webpack_require__(45)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(269);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(162);
module.exports = __webpack_require__(47).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(45)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(677);
var defined = __webpack_require__(191);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(45)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(74);
var getKeys = __webpack_require__(160);
var toIObject = __webpack_require__(110);
var isEnum = __webpack_require__(192).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(108);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(718);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(163);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(411);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(48);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(279);

var _DOMUtils = __webpack_require__(197);

var _HashProtocol = __webpack_require__(736);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(278);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(416);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(284);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(752);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(746);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(425);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(281);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(427);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(428);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(763);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(764);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocale = exports.SET_LOCALE = exports.loadTranslations = exports.LOAD_TRANSLATIONS = undefined;

var _index = __webpack_require__(5);

var LOAD_TRANSLATIONS = exports.LOAD_TRANSLATIONS = '@@i18n/LOAD_TRANSLATIONS';
var loadTranslations = exports.loadTranslations = function loadTranslations(translations) {
  return function (dispatch) {
    dispatch({
      type: LOAD_TRANSLATIONS,
      translations: translations
    });
    _index.I18n.forceComponentsUpdate();
  };
};

var SET_LOCALE = exports.SET_LOCALE = '@@i18n/SET_LOCALE';
var setLocale = exports.setLocale = function setLocale(locale) {
  return function (dispatch) {
    dispatch({
      type: SET_LOCALE,
      locale: locale
    });
    _index.I18n.forceComponentsUpdate();
  };
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadManagerActionKeys; });
var DownloadManagerActionKeys;
(function (DownloadManagerActionKeys) {
    DownloadManagerActionKeys["INIT_DOWNLOADS"] = "@@downloadManager/INIT_DOWNLOADS";
    DownloadManagerActionKeys["INIT_PREVIOUS_DOWNLOAD_GROUPS"] = "@@downloadManager/INIT_PREVIOUS_DOWNLOAD_GROUPS";
    DownloadManagerActionKeys["ADD_ITEM"] = "@@downloadManager/ADD_ITEM";
    DownloadManagerActionKeys["UPDATE_STATUS"] = "@@downloadManager/UPDATE_STATUS";
    DownloadManagerActionKeys["UPDATE_DOWNLOAD"] = "@@downloadManager/UPDATE_DOWNLOAD";
    DownloadManagerActionKeys["SET_REQUEST_ID"] = "@@downloadManager/SET_REQUEST_ID";
    DownloadManagerActionKeys["RECORD_DOWNLOAD_PROGRESS"] = "@@downloadManager/RECORD_DOWNLOAD_PROGRESS";
    DownloadManagerActionKeys["REMOVE_DOWNLOAD"] = "@@downloadManager/REMOVE_DOWNLOAD";
    DownloadManagerActionKeys["SET_DOWNLOAD_GROUP_STATUS"] = "@@downloadManager/SET_DOWNLOAD_GROUP_STATUS";
    DownloadManagerActionKeys["SET_DELETE_ALL_STATUS"] = "@@downloadManager/SET_DELETE_ALL_STATUS";
    DownloadManagerActionKeys["SET_IS_MARKING_ITEM_FOR_DELETION"] = "@@downloadManager/SET_IS_MARKING_ITEM_FOR_DELETION";
    DownloadManagerActionKeys["CLOSE_DOWNLOAD_GROUP_TOAST"] = "@@downloadManager/CLOSE_DOWNLOAD_GROUP_TOAST";
    DownloadManagerActionKeys["ADD_SELECTED_DOWNLOAD_ITEM"] = "@@downloadManager/ADD_SELECTED_DOWNLOAD_ITEM";
    DownloadManagerActionKeys["REMOVE_PENDING_SELECTED_DOWNLOAD_ITEM"] = "@@downloadManager/REMOVE_PENDING_SELECTED_DOWNLOAD_ITEM";
    DownloadManagerActionKeys["RESET_TOTAL_SELECTED_DOWNLOAD_ITEMS"] = "@@downloadManager/RESET_TOTAL_SELECTED_DOWNLOAD_ITEMS";
    DownloadManagerActionKeys["RESET_PENDING_SELECTED_DOWNLOAD_ITEMS"] = "@@downloadManager/RESET_PENDING_SELECTED_DOWNLOAD_ITEMS";
    DownloadManagerActionKeys["INIT_SELECTED_DOWNLOADS"] = "@@downloadManager/INIT_SELECTED_DOWNLOADS";
    DownloadManagerActionKeys["ADD_DOWNLOAD_IN_PROGRESS_ITEM"] = "@@downloadManager/ADD_DOWNLOAD_IN_PROGRESS_ITEM";
    DownloadManagerActionKeys["REMOVE_DOWNLOAD_IN_PROGRESS_ITEM"] = "@@downloadManager/REMOVE_DOWNLOAD_IN_PROGRESS_ITEM";
    DownloadManagerActionKeys["ADD_DOWNLOAD_IN_PROGRESS_DEPENDENCY"] = "@@downloadManager/ADD_DOWNLOAD_IN_PROGRESS_DEPENDENCY";
    DownloadManagerActionKeys["REMOVE_DOWNLOAD_IN_PROGRESS_DEPENDENCY"] = "@@downloadManager/REMOVE_DOWNLOAD_IN_PROGRESS_DEPENDENCY";
    DownloadManagerActionKeys["RESET_DOWNLOADS"] = "@@downloadManager/RESET_DOWNLOADS";
})(DownloadManagerActionKeys || (DownloadManagerActionKeys = {}));



/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emptyDownloadCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePendingDownloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return nativeDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeAllDownloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetAllDownloads; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__ = __webpack_require__(21);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;











var Q = __webpack_require__(165);
var emptyDownloadCache = function () { return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_4__utils__["i" /* tempFolder */])
        .then(function (directoryExist) { return directoryExist ? __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + __WEBPACK_IMPORTED_MODULE_4__utils__["i" /* tempFolder */]) : {}; });
}; };
var deleteItem = function (driveItem, isDeletionOnStartUp) {
    if (isDeletionOnStartUp === void 0) { isDeletionOnStartUp = false; }
    return function (dispatch, getState) {
        if (!driveItem) {
            console.error('Trying to delete a non-existent drive item');
            // Trying to delete a drive item which was downloaded but is no longer in the app (e.g. removed from Admin Area)
            return Q.Promise.reject();
        }
        var _a = getState(), downloadManager = _a.downloadManager, resolutions = _a.driveList.resolutions;
        var associatedResolutions = driveItem.associatedResolutions;
        var driveItemInDownloadManager = downloadManager.items[driveItem.id];
        var promise = Q.Promise.resolve();
        if (driveItemInDownloadManager) {
            var dependencies_1 = driveItemInDownloadManager.dependencies, dependents = driveItemInDownloadManager.dependents;
            // Mark the resource and its dependencies that the deletion has started in case the app is closed before the deletion has ended
            if (driveItemInDownloadManager.mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested && !isDeletionOnStartUp) {
                promise = promise
                    .then(function () { return dispatch(markPersistentItemForDeletion(driveItem.id)); });
            }
            var isDependencyWithDependents = driveItemInDownloadManager.mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency && dependents.length > 0;
            var isDependencyOfPersistentDriveItem = __WEBPACK_IMPORTED_MODULE_8__utils_downloadManager__["a" /* default */].isDependencyOfPersistentDriveItem(downloadManager.items, driveItem.id, [driveItem.id]);
            if ((isDependencyOfPersistentDriveItem || isDependencyWithDependents) && !isDeletionOnStartUp) {
                if (driveItemInDownloadManager.mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["x" /* updateDownload */])(driveItem, __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency, dependencies_1, dependents));
                }
                return Q.Promise.resolve();
            }
            else {
                if (associatedResolutions) {
                    var availableResolutionsId = associatedResolutions[driveItem.id] || 'default';
                    if (resolutions[availableResolutionsId]) {
                        var driveItemSizes = resolutions[availableResolutionsId].sizes;
                        if (driveItemSizes) {
                            driveItemSizes.forEach(function (size) {
                                var fileName = "" + driveItem.id + (size.box ? '_box-' : '_') + size.width + "x" + size.height + "." + size.extension;
                                nativeDeleteFile(fileName);
                            });
                        }
                    }
                }
                promise = promise
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["i" /* removeDependentFromDependencies */])(driveItem)); })
                    .then(function () { return dispatch(deleteDependencies(dependencies_1)); })
                    .then(function () { return dispatch(nativeDelete(driveItem)); })
                    .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["l" /* removeDownloadItem */])(driveItem.id)); })
                    .catch(function (error) {
                    console.error("Error deleting item " + driveItem.id + ":", error);
                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.delete_fail', { id: driveItem.id }));
                });
                return promise;
            }
        }
        return dispatch(nativeDelete(driveItem));
    };
};
var deleteDependencies = function (ids) { return function (dispatch, getState) {
    if (!ids || ids.length === 0) {
        return Q.Promise.resolve();
    }
    var _a = getState(), driveList = _a.driveList, downloadManager = _a.downloadManager;
    var driveItems = driveList.driveItems;
    var items = downloadManager.items;
    return ids.reduce(function (promiseChain, dependencyId) {
        if (items[dependencyId] && !__WEBPACK_IMPORTED_MODULE_8__utils_downloadManager__["a" /* default */].isPersistentItem(items[dependencyId])) {
            return promiseChain.then(function () { return dispatch(deleteItem(driveItems[dependencyId])); });
        }
        return promiseChain;
    }, Q.Promise.resolve());
}; };
var nativeDeleteFile = function (fileName) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].existFile(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* downloadsFolder */] + "/" + fileName)
        .then(function (fileExist) { return fileExist ? __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* downloadsFolder */] + "/" + fileName) : {}; });
};
var nativeDeleteFolder = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].existDirectory(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* downloadsFolder */] + "/" + id)
        .then(function (directoryExist) { return directoryExist ? __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + __WEBPACK_IMPORTED_MODULE_4__utils__["f" /* downloadsFolder */] + "/" + id) : {}; });
};
var nativeDelete = function (driveItem) {
    return function (dispatch, getState) {
        return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].existFile(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* downloadsFolder */] + "/" + driveItem.id + ".zip")
            .then(function (fileExist) { return fileExist ? __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].removeFile(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* downloadsFolder */] + "/" + driveItem.id + ".zip") : {}; })
            .then(function () {
            switch (driveItem.type) {
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.Directory:
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.Publication:
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.Component:
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.Template:
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.Gallery:
                    return nativeDeleteFolder(driveItem.id);
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.Movie:
                case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].DriveItemType.File:
                    nativeDeleteFolder(driveItem.id); // Remove the folder containing the cover image
                default:
                    var fileName = __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getDownloadedFileName(driveItem);
                    return nativeDeleteFile(fileName);
            }
        });
    };
};
var deletePendingDownloads = function () { return function (dispatch, getState) {
    var downloadManager = getState().downloadManager;
    var items = downloadManager.items;
    var promises = [];
    Object.keys(items).forEach(function (key) {
        var item = items[key];
        var id = parseInt(key, 10);
        if ((item.mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Required || item.mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Requested) && !__WEBPACK_IMPORTED_MODULE_8__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, id)) {
            promises.push(dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id, false)).then(function (driveItem) { return dispatch(deleteItem(driveItem)); }));
        }
    });
    return Q.Promise.all(promises);
}; };
var removeAllDownloads = function () {
    return function (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["r" /* setIsDeletingAllStatus */])(true));
        if (__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isAndroidApp()) {
            __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].existDirectory("" + __WEBPACK_IMPORTED_MODULE_4__utils__["i" /* tempFolder */])
                .then(function (directoryExist) { return directoryExist ? __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].deleteDirJs("../../" + __WEBPACK_IMPORTED_MODULE_4__utils__["i" /* tempFolder */]) : {}; })
                .catch(function (error) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.delete_fail')); });
        }
        dispatch(deleteAllNonRequiredItems())
            .finally(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["r" /* setIsDeletingAllStatus */])(false)); })
            .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["q" /* setDownloadGroupStatus */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].ALL, __WEBPACK_IMPORTED_MODULE_0__reducer__["b" /* DownloadGroupStatus */].NotStarted)); })
            .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["q" /* setDownloadGroupStatus */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].IMPORTANT, __WEBPACK_IMPORTED_MODULE_0__reducer__["b" /* DownloadGroupStatus */].NotStarted)); })
            .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["q" /* setDownloadGroupStatus */])(__WEBPACK_IMPORTED_MODULE_0__reducer__["a" /* DownloadGroupName */].SELECTED, __WEBPACK_IMPORTED_MODULE_0__reducer__["b" /* DownloadGroupStatus */].NotStarted)); })
            .then(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('info.delete_all')); })
            .catch(function (error) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.delete_fail')); });
    };
};
var deleteAllNonRequiredItems = function () {
    return function (dispatch, getState) {
        var _a = getState(), downloadManager = _a.downloadManager, driveList = _a.driveList;
        var items = downloadManager.items;
        var driveItems = driveList.driveItems;
        var promises = [];
        Object.keys(items).forEach(function (id) {
            if (items[id].mode !== __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Required) {
                promises.push(dispatch(deleteItem(driveItems[id])));
            }
        });
        return Q.allSettled(promises);
    };
};
// Needed for deletion recovery on app restart
var markPersistentItemForDeletion = function (driveItemId) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var downloadManager, driveItemInDownloadManager, dependencies;
    var _this = this;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["s" /* setIsMarkingItemForDeletion */])(true));
                downloadManager = getState().downloadManager;
                driveItemInDownloadManager = downloadManager.items[driveItemId];
                if (!driveItemInDownloadManager) return [3 /*break*/, 3];
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["y" /* updateDownloadStatus */])(driveItemId, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].STARTING_DELETION))];
            case 1:
                _a.sent();
                dependencies = driveItemInDownloadManager.dependencies;
                if (!dependencies || dependencies.length === 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["s" /* setIsMarkingItemForDeletion */])(false));
                    return [2 /*return*/];
                }
                return [4 /*yield*/, dependencies.reduce(function (previousPromise, dependencyId) { return __awaiter(_this, void 0, void 0, function () {
                        var dependencyInDownloadManager, dependencyDependents, isDependencyWithDependents, isDependencyOfPersistentDriveItem;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, previousPromise];
                                case 1:
                                    _a.sent();
                                    dependencyInDownloadManager = downloadManager.items[dependencyId];
                                    dependencyDependents = dependencyInDownloadManager.dependents;
                                    isDependencyWithDependents = dependencyInDownloadManager.mode === __WEBPACK_IMPORTED_MODULE_0__reducer__["c" /* DownloadMode */].Dependency && dependencyDependents.length > 1;
                                    isDependencyOfPersistentDriveItem = __WEBPACK_IMPORTED_MODULE_8__utils_downloadManager__["a" /* default */].isDependencyOfPersistentDriveItem(downloadManager.items, dependencyId, [dependencyId, driveItemId]);
                                    return [2 /*return*/, isDependencyOfPersistentDriveItem || isDependencyWithDependents
                                            ? Promise.resolve()
                                            : dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["y" /* updateDownloadStatus */])(dependencyId, __WEBPACK_IMPORTED_MODULE_0__reducer__["d" /* DownloadStatus */].STARTING_DELETION))];
                            }
                        });
                    }); }, Promise.resolve())];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["s" /* setIsMarkingItemForDeletion */])(false));
                return [2 /*return*/, Promise.resolve()];
            case 4:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["s" /* setIsMarkingItemForDeletion */])(false));
                return [2 /*return*/];
        }
    });
}); }; };
var resetAllDownloads = function () {
    return function (dispatch, getState) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["r" /* setIsDeletingAllStatus */])(true));
        // Call native resetDownloads method
        return __WEBPACK_IMPORTED_MODULE_1__utils_nativeApi__["b" /* default */].resetDownloads()
            .then(function () {
            // Remove all download items from state
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["n" /* resetDownloads */])());
            // Clear IndexedDB downloads
            return __WEBPACK_IMPORTED_MODULE_10__utils_indexedDB_manager__["a" /* default */].setDownloads([]);
        })
            .then(function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["r" /* setIsDeletingAllStatus */])(false));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('info.reset_all_downloads'));
        })
            .catch(function (error) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__store__["r" /* setIsDeletingAllStatus */])(false));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_actions__["c" /* createNotification */])('error.reset_fail'));
            console.error('Error resetting downloads:', error);
        });
    };
};



/***/ }),
/* 433 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLAttribute;

  module.exports = XMLAttribute = (function() {
    function XMLAttribute(parent, name, value) {
      this.options = parent.options;
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing attribute name of element " + parent.name);
      }
      if (value == null) {
        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
      }
      this.name = this.stringify.attName(name);
      this.value = this.stringify.attValue(value);
    }

    XMLAttribute.prototype.clone = function() {
      return Object.create(this);
    };

    XMLAttribute.prototype.toString = function(options) {
      return this.options.writer.set(options).attribute(this);
    };

    return XMLAttribute;

  })();

}).call(this);


/***/ }),
/* 434 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLStringifier,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    hasProp = {}.hasOwnProperty;

  module.exports = XMLStringifier = (function() {
    function XMLStringifier(options) {
      this.assertLegalChar = bind(this.assertLegalChar, this);
      var key, ref, value;
      options || (options = {});
      this.noDoubleEncoding = options.noDoubleEncoding;
      ref = options.stringify || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
    }

    XMLStringifier.prototype.eleName = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.eleText = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(this.elEscape(val));
    };

    XMLStringifier.prototype.cdata = function(val) {
      val = '' + val || '';
      val = val.replace(']]>', ']]]]><![CDATA[>');
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.comment = function(val) {
      val = '' + val || '';
      if (val.match(/--/)) {
        throw new Error("Comment text cannot contain double-hypen: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.raw = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attName = function(val) {
      return val = '' + val || '';
    };

    XMLStringifier.prototype.attValue = function(val) {
      val = '' + val || '';
      return this.attEscape(val);
    };

    XMLStringifier.prototype.insTarget = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.insValue = function(val) {
      val = '' + val || '';
      if (val.match(/\?>/)) {
        throw new Error("Invalid processing instruction value: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlVersion = function(val) {
      val = '' + val || '';
      if (!val.match(/1\.[0-9]+/)) {
        throw new Error("Invalid version number: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlEncoding = function(val) {
      val = '' + val || '';
      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) {
        throw new Error("Invalid encoding: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlStandalone = function(val) {
      if (val) {
        return "yes";
      } else {
        return "no";
      }
    };

    XMLStringifier.prototype.dtdPubID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdSysID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdElementValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttType = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttDefault = function(val) {
      if (val != null) {
        return '' + val || '';
      } else {
        return val;
      }
    };

    XMLStringifier.prototype.dtdEntityValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdNData = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.convertAttKey = '@';

    XMLStringifier.prototype.convertPIKey = '?';

    XMLStringifier.prototype.convertTextKey = '#text';

    XMLStringifier.prototype.convertCDataKey = '#cdata';

    XMLStringifier.prototype.convertCommentKey = '#comment';

    XMLStringifier.prototype.convertRawKey = '#raw';

    XMLStringifier.prototype.assertLegalChar = function(str) {
      var res;
      res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
      if (res) {
        throw new Error("Invalid character in string: " + str + " at index " + res.index);
      }
      return str;
    };

    XMLStringifier.prototype.elEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
    };

    XMLStringifier.prototype.attEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
    };

    return XMLStringifier;

  })();

}).call(this);


/***/ }),
/* 435 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLWriterBase,
    hasProp = {}.hasOwnProperty;

  module.exports = XMLWriterBase = (function() {
    function XMLWriterBase(options) {
      var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
      options || (options = {});
      this.pretty = options.pretty || false;
      this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
      if (this.pretty) {
        this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
        this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
        this.offset = (ref3 = options.offset) != null ? ref3 : 0;
        this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
      } else {
        this.indent = '';
        this.newline = '';
        this.offset = 0;
        this.dontprettytextnodes = 0;
      }
      this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
      if (this.spacebeforeslash === true) {
        this.spacebeforeslash = ' ';
      }
      this.newlinedefault = this.newline;
      this.prettydefault = this.pretty;
      ref6 = options.writer || {};
      for (key in ref6) {
        if (!hasProp.call(ref6, key)) continue;
        value = ref6[key];
        this[key] = value;
      }
    }

    XMLWriterBase.prototype.set = function(options) {
      var key, ref, value;
      options || (options = {});
      if ("pretty" in options) {
        this.pretty = options.pretty;
      }
      if ("allowEmpty" in options) {
        this.allowEmpty = options.allowEmpty;
      }
      if (this.pretty) {
        this.indent = "indent" in options ? options.indent : '  ';
        this.newline = "newline" in options ? options.newline : '\n';
        this.offset = "offset" in options ? options.offset : 0;
        this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
      } else {
        this.indent = '';
        this.newline = '';
        this.offset = 0;
        this.dontprettytextnodes = 0;
      }
      this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
      if (this.spacebeforeslash === true) {
        this.spacebeforeslash = ' ';
      }
      this.newlinedefault = this.newline;
      this.prettydefault = this.pretty;
      ref = options.writer || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
      return this;
    };

    XMLWriterBase.prototype.space = function(level) {
      var indent;
      if (this.pretty) {
        indent = (level || 0) + this.offset + 1;
        if (indent > 0) {
          return new Array(indent).join(this.indent);
        } else {
          return '';
        }
      } else {
        return '';
      }
    };

    return XMLWriterBase;

  })();

}).call(this);


/***/ }),
/* 436 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(215);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(436);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(214).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(438);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(216).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(167);
util.inherits = __webpack_require__(136);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(804);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(805);
var destroyImpl = __webpack_require__(439);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(113);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(294).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(113);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(294).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(66)))

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(214).EventEmitter;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(215);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(113);

/*<replacement>*/
var util = __webpack_require__(167);
util.inherits = __webpack_require__(136);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var prefixMatch;

  prefixMatch = new RegExp(/(?!xmlns)^.*:/);

  exports.normalize = function(str) {
    return str.toLowerCase();
  };

  exports.firstCharLowerCase = function(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  };

  exports.stripPrefix = function(str) {
    return str.replace(prefixMatch, '');
  };

  exports.parseNumbers = function(str) {
    if (!isNaN(str)) {
      str = str % 1 === 0 ? parseInt(str, 10) : parseFloat(str);
    }
    return str;
  };

  exports.parseBooleans = function(str) {
    if (/^(?:true|false)$/i.test(str)) {
      str = str.toLowerCase() === 'true';
    }
    return str;
  };

}).call(this);


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var requirePromise = __webpack_require__(220);

requirePromise();

var PromiseResolve = __webpack_require__(830);
var Type = __webpack_require__(831);
var iterate = __webpack_require__(833);
var map = __webpack_require__(843);
var GetIntrinsic = __webpack_require__(19);
var callBind = __webpack_require__(170);

var all = callBind(GetIntrinsic('%Promise.all%'));
var reject = callBind(GetIntrinsic('%Promise.reject%'));

module.exports = function allSettled(iterable) {
	var C = this;
	if (Type(C) !== 'Object') {
		throw new TypeError('`this` value must be an object');
	}
	var values = iterate(iterable);
	return all(C, map(values, function (item) {
		var onFulfill = function (value) {
			return { status: 'fulfilled', value: value };
		};
		var onReject = function (reason) {
			return { status: 'rejected', reason: reason };
		};
		var itemPromise = PromiseResolve(C, item);
		try {
			return itemPromise.then(onFulfill, onReject);
		} catch (e) {
			return reject(C, e);
		}
	}));
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(844);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ArraySpeciesCreate = __webpack_require__(845);
var Call = __webpack_require__(859);
var CreateDataPropertyOrThrow = __webpack_require__(860);
var Get = __webpack_require__(449);
var HasProperty = __webpack_require__(867);
var IsCallable = __webpack_require__(456);
var ToUint32 = __webpack_require__(868);
var ToObject = __webpack_require__(878);
var ToString = __webpack_require__(879);

var callBound = __webpack_require__(60);

var isString = __webpack_require__(880);

// Check failure of by-index access of string characters (IE < 9) and failure of `0 in boxedString` (Rhino)
var boxedString = Object('a');
var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

var strSplit = callBound('String.prototype.split');

module.exports = function map(callbackfn) {
	var O = ToObject(this);
	var self = splitString && isString(O) ? strSplit(O, '') : O;
	var len = ToUint32(self.length);

	// If no callback function or if callback is not a callable function
	if (!IsCallable(callbackfn)) {
		throw new TypeError('Array.prototype.map callback must be a function');
	}

	var T;
	if (arguments.length > 1) {
		T = arguments[1];
	}

	var A = ArraySpeciesCreate(O, len);
	var k = 0;
	while (k < len) {
		var Pk = ToString(k);
		var kPresent = HasProperty(O, Pk);
		if (kPresent) {
			var kValue = Get(O, Pk);
			var mappedValue = Call(callbackfn, T, [kValue, k, O]);
			CreateDataPropertyOrThrow(A, Pk, mappedValue);
		}
		k += 1;
	}

	return A;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abs = __webpack_require__(847);
var floor = __webpack_require__(848);
var Type = __webpack_require__(56);

var $isNaN = __webpack_require__(448);
var $isFinite = __webpack_require__(850);

// https://tc39.es/ecma262/#sec-isintegralnumber

module.exports = function IsIntegralNumber(argument) {
	if (Type(argument) !== 'Number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

var inspect = __webpack_require__(851);

var IsPropertyKey = __webpack_require__(138);
var Type = __webpack_require__(56);

/**
 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
 * 1. Assert: Type(O) is Object.
 * 2. Assert: IsPropertyKey(P) is true.
 * 3. Return O.[[Get]](P, O).
 */

module.exports = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

// node v0.6 has a bug where array lengths can be Set but not Defined
var hasArrayLengthDefineBug = Object.defineProperty && Object.defineProperty([], 'length', { value: 1 }).length === 0;

// eslint-disable-next-line global-require
var isArray = hasArrayLengthDefineBug && __webpack_require__(857); // this does not depend on any other AOs.

var callBound = __webpack_require__(60);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(301);

var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

module.exports = function FromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = Desc['[[Configurable]]'];
	}
	return obj;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(115);

var assertRecord = __webpack_require__(301);

var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

module.exports = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(448);

// http://262.ecma-international.org/5.1/#sec-9.12

module.exports = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(115);

var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(56);
var ToBoolean = __webpack_require__(455);
var IsCallable = __webpack_require__(456);

// https://262.ecma-international.org/5.1/#sec-8.10.5

module.exports = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (has(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (has(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (has(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (has(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (has(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (has(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
		throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = __webpack_require__(457);


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayMethodBoxesProperly = __webpack_require__(881);

var implementation = __webpack_require__(446);

module.exports = function getPolyfill() {
	var method = Array.prototype.map;
	return arrayMethodBoxesProperly(method) ? method : implementation;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var requirePromise = __webpack_require__(220);

var implementation = __webpack_require__(443);

module.exports = function getPolyfill() {
	requirePromise();
	return typeof Promise.allSettled === 'function' ? Promise.allSettled : implementation;
};


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return throttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterWithMax; });
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Throttling enforces a maximum number of times a function can be called over time
// tslint:disable-next-line no-any
function throttle(f, ms) {
    var isThrottled = false;
    var savedArgs; // tslint:disable-line no-any
    var savedThis; // tslint:disable-line no-any
    // tslint:disable-next-line no-any
    function wrapper() {
        if (isThrottled) {
            savedArgs = arguments;
            savedThis = this;
            return;
        }
        f.apply(this, arguments);
        isThrottled = true;
        setTimeout(function () {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
            }
        }, ms);
    }
    return wrapper;
}
// filterWithMax() will filter an array "array" with the method "condition" and stops after finding a maximum number "maxSize" of elements
// source: https://stackoverflow.com/a/56169001/6246007
function filterWithMax(array, condition, maxSize) {
    var count, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!maxSize || maxSize > array.length) {
                    maxSize = array.length;
                }
                count = 0;
                i = 0;
                _a.label = 1;
            case 1:
                if (!(count < maxSize && i < array.length)) return [3 /*break*/, 4];
                if (!condition(array[i])) return [3 /*break*/, 3];
                return [4 /*yield*/, array[i]];
            case 2:
                _a.sent();
                count++;
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}



/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SelectionManager = /** @class */ (function () {
    function SelectionManager() {
    }
    SelectionManager.prototype.selectItems = function (firstIndex, lastIndex) {
        var _a = this.getMinMaxItemsIndex(firstIndex, lastIndex), min = _a.min, max = _a.max;
        for (var i = min; i <= max; i++) {
            this.addItem(this.allItems[i]);
        }
    };
    SelectionManager.prototype.deselectItems = function (firstIndex, lastIndex) {
        var max = this.getMinMaxItemsIndex(firstIndex, lastIndex).max;
        for (var i = max; i >= 0; i--) {
            this.removeItem(this.allItems[i]);
        }
    };
    SelectionManager.prototype.set = function (selectedItems, allItems) {
        this.selectedItems = selectedItems.sort(function (a, b) { return a - b; });
        this.allItems = allItems;
    };
    SelectionManager.prototype.get = function () {
        return this.selectedItems.sort(function (a, b) { return a - b; });
    };
    SelectionManager.prototype.isGapInSelectedItems = function (items) {
        var isGap = false;
        for (var i = 0; i < items.length; i += 1) {
            if (items[i + 1] - items[i] > 1) {
                isGap = true;
                break;
            }
        }
        return isGap;
    };
    SelectionManager.prototype.addItem = function (item) {
        if (!this.selectedItems.includes(item)) {
            this.selectedItems.push(item);
        }
    };
    SelectionManager.prototype.removeItem = function (item) {
        var index = this.selectedItems.indexOf(item);
        this.selectedItems.splice(index, 1);
    };
    SelectionManager.prototype.getMinMax = function (a, b) {
        return {
            min: Math.min(a, b),
            max: Math.max(a, b),
        };
    };
    SelectionManager.prototype.getIndex = function (item) {
        return this.allItems.indexOf(item);
    };
    SelectionManager.prototype.getMinMaxItemsIndex = function (a, b) {
        return this.getMinMax(this.getIndex(a), this.getIndex(b));
    };
    return SelectionManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (new SelectionManager());


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledButtonRemove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledButtonRemove = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder: 2px solid ", ";\n\tborder-radius: 50%;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\toutline: 0;\n\tcursor: pointer;\n\n\t", "\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder: 2px solid ", ";\n\tborder-radius: 50%;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\toutline: 0;\n\tcursor: pointer;\n\n\t",
    "\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: currentColor;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
});

var templateObject_1;


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDIT_PANEL_WIDTH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_rnd__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_resize_detector__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var EDIT_PANEL_WIDTH = 380;
var GAP = 10;
var EditPanel = function (_a) {
    var defaultType = _a.defaultType, panels = _a.panels, x = _a.x, y = _a.y, activeItemId = _a.activeItemId, isDisabled = _a.isDisabled, dispatch = _a.dispatch, className = _a.className;
    var panelElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](defaultType), 2), type = _b[0], setType = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](0), 2), panelHeight = _c[0], setPanelHeight = _c[1];
    var handleDragStop = function (e, _a) {
        var x = _a.x, y = _a.y;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["q" /* moveEditPanel */])(x, y));
    };
    var setPosition = function () {
        var _a = panelElement.current, panelWidth = _a.offsetWidth, panelHeight = _a.offsetHeight;
        var isFirstDisplay = x === null && y === null;
        if (isFirstDisplay) {
            var defaultX = window.innerWidth - panelWidth - __WEBPACK_IMPORTED_MODULE_5__styles__["g" /* PAGE_PADDING */];
            var defaultY = __WEBPACK_IMPORTED_MODULE_5__styles__["e" /* HEADER_HEIGHT */];
            if (!activeItemId) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["q" /* moveEditPanel */])(defaultX, defaultY));
                return;
            }
            var activeItem = document.querySelector("#" + activeItemId);
            if (activeItem) {
                var _b = activeItem.getBoundingClientRect(), top_1 = _b.top, left = _b.left, right = _b.right;
                var panelBottom = defaultY + panelHeight;
                var panelLeft = defaultX;
                var isActiveItemOverlapped = panelBottom > top_1 && panelLeft < right;
                if (isActiveItemOverlapped) {
                    // display panel to the left of the item
                    defaultX = left - panelWidth - GAP;
                }
                defaultX = defaultX < 0 ? 0 : defaultX;
                defaultY = defaultY < 0 ? 0 : defaultY;
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["q" /* moveEditPanel */])(defaultX, defaultY));
            return;
        }
        var shouldCorrectX = x !== null && x + panelWidth > window.innerWidth;
        var shouldCorrectY = y !== null && y + panelHeight > window.innerHeight;
        if (!shouldCorrectX && !shouldCorrectY) {
            return;
        }
        var correctedX = shouldCorrectX ? window.innerWidth - panelWidth : x;
        var correctedY = shouldCorrectY ? window.innerHeight - panelHeight : y;
        correctedX = correctedX < 0 ? 0 : correctedX;
        correctedY = correctedY < 0 ? 0 : correctedY;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["q" /* moveEditPanel */])(correctedX, correctedY));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setType(defaultType);
    }, [defaultType]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var resizeDetector = __WEBPACK_IMPORTED_MODULE_2_element_resize_detector__({
            strategy: 'scroll',
            callOnAdd: false,
        });
        if (panelElement.current) {
            resizeDetector.listenTo(panelElement.current, function (el) {
                setPanelHeight(el.offsetHeight);
            });
        }
        return function () {
            if (panelElement.current) {
                resizeDetector.uninstall(panelElement.current);
            }
        };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setPosition();
        // Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', setPosition);
        }
        else {
            window.addEventListener('resize', setPosition);
        }
        return function () {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', setPosition);
            }
            else {
                window.removeEventListener('resize', setPosition);
            }
        };
    }, [x, y, panelHeight]);
    var position = {
        x: x === null ? 0 : x,
        y: y === null ? 0 : y,
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Portal__["a" /* default */], { parentNode: document.body },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_rnd__["a" /* Rnd */], { position: position, onDragStop: handleDragStop, bounds: "parent", cancel: ".prevent-drag", enableResizing: false },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* StyledEditPanel */], { ref: panelElement, className: __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] + " " + __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["b" /* EDIT_PANEL_CLASSNAME */] + " " + (className || ''), isDisabled: isDisabled },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["k" /* StyledIconMove */], null, __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_6dots')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */], { type: type, availableTypes: Object.keys(panels), onClick: setType }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["j" /* StyledEditPanelInner */], { className: "prevent-drag" }, panels[type])))));
};
/* harmony default export */ __webpack_exports__["b"] = (EditPanel);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(226);

var _domFns = __webpack_require__(307);

function getBoundPosition(draggable
/*: Draggable*/
, x
/*: number*/
, y
/*: number*/
)
/*: [number, number]*/
{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid
/*: [number, number]*/
, pendingX
/*: number*/
, pendingY
/*: number*/
)
/*: [number, number]*/
{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e
/*: MouseTouchEvent*/
, touchIdentifier
/*: ?number*/
, draggableCore
/*: DraggableCore*/
)
/*: ?ControlPosition*/
{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable
/*: DraggableCore*/
, x
/*: number*/
, y
/*: number*/
)
/*: DraggableData*/
{
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable
/*: Draggable*/
, coreData
/*: DraggableData*/
)
/*: DraggableData*/
{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds
/*: Bounds*/
)
/*: Bounds*/
{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable
/*: Draggable | DraggableCore*/
)
/*: HTMLElement*/
{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__(468).forEach;
var elementUtilsMaker       = __webpack_require__(893);
var listenerHandlerMaker    = __webpack_require__(894);
var idGeneratorMaker        = __webpack_require__(895);
var idHandlerMaker          = __webpack_require__(896);
var reporterMaker           = __webpack_require__(897);
var browserDetector         = __webpack_require__(469);
var batchProcessorMaker     = __webpack_require__(898);
var stateHandler            = __webpack_require__(900);

//Detection strategies.
var objectStrategyMaker     = __webpack_require__(901);
var scrollStrategyMaker     = __webpack_require__(902);

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var importantCssRules = getOption(options, "important", false);
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler,
        important: importantCssRules
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug, important: importantCssRules }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    function initDocument(targetDocument) {
        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall,
        initDocument: initDocument
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdditionalPanelType; });
var AdditionalPanelType;
(function (AdditionalPanelType) {
    AdditionalPanelType["settings"] = "settings";
})(AdditionalPanelType || (AdditionalPanelType = {}));


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html__ = __webpack_require__(906);

/* harmony default export */ __webpack_exports__["a"] = ({
    isModifiedFromBackoffice: __WEBPACK_IMPORTED_MODULE_0__html__["c" /* isModifiedFromBackoffice */],
    getModifiedPageData: __WEBPACK_IMPORTED_MODULE_0__html__["a" /* getModifiedPageData */],
    getPageHtmlToSave: __WEBPACK_IMPORTED_MODULE_0__html__["b" /* getPageHtmlToSave */],
});


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addStylesToEditableTextFieldsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

// Define used styles in editable text fields to use them in RichTextEditor toolbar
var addStylesToEditableTextFieldsData = function (data, stylesString) {
    var dataKeys = {
        'font-family': 'fontFamilies',
        'font-size': 'fontSizes',
        color: 'colors',
        'line-height': 'lineHeights',
        'letter-spacing': 'letterSpacings',
    };
    var stylesArray = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["H" /* getStylesArrayWithoutSpaces */])(stylesString).filter(function (style) {
        var styleName = style.split(':')[0];
        return Object.keys(dataKeys).includes(styleName);
    });
    stylesArray.forEach(function (style) {
        var _a = __read(style.split(':'), 2), key = _a[0], value = _a[1];
        data[dataKeys[key]].add(value);
    });
};


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modifyElementContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var modifyLinks = function (fieldElement) {
    var links = __spread(fieldElement.querySelectorAll('a'));
    links.forEach(function (link) {
        var href = link.href, _a = link.dataset.action, action = _a === void 0 ? '' : _a;
        var isUrlLink = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["q" /* getLinkTypeByValue */])(href) === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LinkType */].url;
        if (!isUrlLink) {
            link.setAttribute('onclick', action);
            link.setAttribute('ontouchend', action);
            link.removeAttribute('data-action');
        }
    });
};
var modifySpanInnerHtml = function (spans, innerText) {
    var _a = spans.reduce(function (acc, _a) {
        var attributes = _a.attributes, className = _a.className;
        if (attributes['style']) { // tslint:disable-line no-string-literal
            acc.style += attributes['style'].value + ";"; // tslint:disable-line no-string-literal
        }
        if (className) {
            acc.className += className + " ";
        }
        return acc;
    }, { style: '', className: '' }), style = _a.style, className = _a.className;
    var span = spans[0];
    span.setAttribute('style', style);
    span.className = className.trim();
    span.innerHTML = innerText;
};
// Transform set of Slate marks (several spans one inside another, each with one inline style) to only one span with all styles
var modifyElementContent = function (fieldElement, modificationFunction) {
    modificationFunction(fieldElement);
    modifyLinks(fieldElement);
    var firstSpans = __spread(fieldElement.querySelectorAll(':not(span) > span'));
    firstSpans.forEach(function (firstSpan) {
        var parentNode = firstSpan.closest('p, a');
        var innerText = firstSpan.innerText;
        // remove unnecessary Slate service empty marks
        if (!innerText && parentNode) {
            return parentNode.removeChild(firstSpan);
        }
        var allSpans = __spread([firstSpan], firstSpan.querySelectorAll('span'));
        return modifySpanInnerHtml(allSpans, innerText);
    });
};


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaElementDataAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isEditedImageElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editableMedia_getData__ = __webpack_require__(475);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};





var MediaElementDataAttribute;
(function (MediaElementDataAttribute) {
    MediaElementDataAttribute["edited"] = "data-uprez-edited";
    MediaElementDataAttribute["label"] = "data-uprez-label";
    MediaElementDataAttribute["tooltip"] = "data-uprez-tooltip";
    MediaElementDataAttribute["tooltipActive"] = "data-uprez-tooltip-active";
    MediaElementDataAttribute["defaultLink"] = "data-uprez-default-link";
    MediaElementDataAttribute["driveLink"] = "data-uprez-drive-link";
    MediaElementDataAttribute["externalLink"] = "data-uprez-external-link";
    MediaElementDataAttribute["externalLinkActive"] = "data-uprez-external-link-active";
    MediaElementDataAttribute["aspectRatio"] = "data-uprez-aspect-ratio";
    MediaElementDataAttribute["defaultStyle"] = "data-uprez-default-style";
})(MediaElementDataAttribute || (MediaElementDataAttribute = {}));
var isImageElement = function (element) { return (element.hasAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Image)); };
var isVideoElement = function (element) { return (element.tagName === __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].video && element.hasAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Video)); };
var isVideoIframeElement = function (element) { return (element.tagName === __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].iframe && element.hasAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Video)); };
// edited image element has wrapper div outside image
var isEditedImageElement = function (element) { return (element.tagName === __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].div && isImageElement(element)); };
var getMediaType = function (element) {
    switch (element.tagName) {
        case __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].img:
        default:
            return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].image;
        case __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].video:
            return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].video;
        case __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].iframe:
            return element.hasAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Video)
                ? __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].video
                : __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].animation;
    }
};
var getElementSources = function (element, isEditedFromBackoffice) {
    if (isEditedFromBackoffice) {
        return {
            defaultLink: element.getAttribute(MediaElementDataAttribute.defaultLink) || '',
            driveLink: element.getAttribute(MediaElementDataAttribute.driveLink) || '',
            externalLink: element.getAttribute(MediaElementDataAttribute.externalLink) || '',
            isExternalLinkActive: element.getAttribute(MediaElementDataAttribute.externalLinkActive) === 'true',
        };
    }
    var elementWithSrc = isVideoElement(element)
        ? element.querySelector('source')
        : element;
    var src = elementWithSrc.src;
    var isVideoIframe = isVideoIframeElement(element);
    var defaultLink = __WEBPACK_IMPORTED_MODULE_2__helpers__["P" /* getUrlWithoutOrigin */](src, true);
    return {
        defaultLink: defaultLink,
        driveLink: '',
        externalLink: isVideoIframe ? defaultLink : '',
        isExternalLinkActive: isVideoIframe,
    };
};
var getMediaData = function (element) {
    var mediaElement = isEditedImageElement(element)
        ? element.querySelector('img')
        : element;
    var frameAspectRatio = element.getAttribute(MediaElementDataAttribute.aspectRatio) !== null
        ? +element.getAttribute(MediaElementDataAttribute.aspectRatio)
        : undefined;
    var isEditedFromBackoffice = element.getAttribute(MediaElementDataAttribute.edited) === 'true';
    var tooltipActionAttribute = element.attributes['onmouseenter'] || {}; // tslint:disable-line no-string-literal
    var defaultTooltipAction = tooltipActionAttribute.value;
    var _a = mediaElement.style, width = _a.width, top = _a.top, left = _a.left;
    return __assign({ type: getMediaType(mediaElement), width: isEditedFromBackoffice
            ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](width)
            : 0, height: 0, x: isEditedFromBackoffice
            ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](left)
            : 0, y: isEditedFromBackoffice
            ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](top)
            : 0, frameAspectRatio: frameAspectRatio, label: element.getAttribute(MediaElementDataAttribute.label) || '', isEditedFromBackoffice: isEditedFromBackoffice, tooltip: element.getAttribute(MediaElementDataAttribute.tooltip) || __WEBPACK_IMPORTED_MODULE_2__helpers__["i" /* getDefaultTooltip */](defaultTooltipAction), isTooltipActive: element.getAttribute(MediaElementDataAttribute.tooltipActive) === 'true', canDragAndResize: isImageElement(element)
            ? isEditedFromBackoffice
            : false, style: (isEditedFromBackoffice
            ? element.getAttribute(MediaElementDataAttribute.defaultStyle)
            : element.getAttribute('style')) || '', videoSettings: Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_getData__["a" /* getVideoSettings */])(mediaElement, isVideoElement(element), isVideoIframeElement(element)) }, getElementSources(element, isEditedFromBackoffice));
};
var getConfig = function (element, page) {
    var id = element.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* editableId */]);
    return __assign({ page: page,
        id: id, importManagerId: id + "-" + page, frameWidth: 0, frameHeight: 0, isLoaded: false }, getMediaData(element));
};
/* harmony default export */ __webpack_exports__["b"] = (function (page, htmlDocument) {
    var items = [];
    var isError = false;
    var editableMediaElements = __spread(htmlDocument.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Image + "]"), htmlDocument.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Video + "]"));
    try {
        editableMediaElements.forEach(function (element) { return (items.push(getConfig(element, page))); });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        isError: isError,
    };
});


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typing__ = __webpack_require__(227);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

var getVideoSettings = function (element, isVideoElement, isVideoIframeElement, defaultSrc) {
    var _a, _b;
    if (isVideoElement) {
        return _a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].autoplay] = element.getAttribute(__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].autoplay) != null,
            _a[__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].controls] = element.getAttribute(__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].controls) != null,
            _a[__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].muted] = element.getAttribute(__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].muted) != null,
            _a;
    }
    else if (isVideoIframeElement) {
        var defaultSettings = (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].autoplay] = false,
            _b[__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].controls] = true,
            _b[__WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].muted] = false,
            _b);
        var src = defaultSrc || element.src; // src can be empty when iframe is hidden
        var attributesString = src.split('?')[1];
        if (!attributesString) {
            return defaultSettings;
        }
        return attributesString.split('&').reduce(function (acc, current) {
            var _a = __read(current.split('='), 2), name = _a[0], value = _a[1];
            if (name !== __WEBPACK_IMPORTED_MODULE_0__typing__["c" /* youtubeJsApiAttribute */]) {
                var attributeName = name === 'mute' ? __WEBPACK_IMPORTED_MODULE_0__typing__["b" /* VideoParam */].muted : name;
                acc[attributeName] = value !== '0';
            }
            return acc;
        }, defaultSettings);
    }
    return;
};


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDriveLinkWithoutHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setTooltipActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typing__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__htmlEditor_constants__ = __webpack_require__(85);




var isIframe = function (type, isExternalLinkActive) { return (type === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].animation ||
    type === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].video && isExternalLinkActive); };
var getImageElement = function (htmlDocument, src) {
    var image = htmlDocument.createElement('img');
    image.src = src;
    return image;
};
var getAnimationElement = function (editorType, htmlDocument, src, className) {
    var iframe = htmlDocument.createElement('iframe');
    if (editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN) {
        iframe.className = className;
    }
    iframe.src = src;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('allowFullScreen', 'true');
    return iframe;
};
var getVideoElement = function (editorType, htmlDocument, src, videoSettings, className) {
    var video = htmlDocument.createElement('video');
    if (editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML) {
        video.setAttribute(__WEBPACK_IMPORTED_MODULE_3__htmlEditor_constants__["a" /* EditableItem */].Video, '');
    }
    else {
        video.className = className;
    }
    video.setAttribute('width', '100%');
    video.setAttribute('height', '100%');
    Object.keys(videoSettings).forEach(function (key) {
        if (videoSettings[key]) {
            video.setAttribute(key, '');
        }
    });
    var source = htmlDocument.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    return video;
};
var getIframeElement = function (editorType, htmlDocument, src, videoSettings, className) {
    var iframe = htmlDocument.createElement('iframe');
    if (editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML) {
        iframe.setAttribute(__WEBPACK_IMPORTED_MODULE_3__htmlEditor_constants__["a" /* EditableItem */].Video, '');
    }
    else {
        iframe.className = className;
    }
    var modifiedSrc = src.split('?')[0]; // remove query params
    modifiedSrc = modifiedSrc + "?" + __WEBPACK_IMPORTED_MODULE_2__typing__["c" /* youtubeJsApiAttribute */];
    Object.keys(videoSettings).forEach(function (key) {
        var attributeName = key === __WEBPACK_IMPORTED_MODULE_2__typing__["b" /* VideoParam */].muted ? 'mute' : key;
        modifiedSrc += "&" + attributeName + "=" + getYoutubeAttributeValue(videoSettings[key]);
    });
    iframe.src = modifiedSrc;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('allowFullScreen', 'true');
    return iframe;
};
var getYoutubeAttributeValue = function (attribute) { return attribute ? 1 : 0; };
var getElement = function (editorType, type, isExternalLinkActive, htmlDocument, src, videoSettings, isVisible, className) {
    var element;
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].animation:
            element = getAnimationElement(editorType, htmlDocument, src, className);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].video:
            element = isExternalLinkActive
                ? getIframeElement(editorType, htmlDocument, src, videoSettings, className)
                : getVideoElement(editorType, htmlDocument, src, videoSettings, className);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].image:
        default:
            element = getImageElement(htmlDocument, src);
    }
    if (isVisible === false) {
        __WEBPACK_IMPORTED_MODULE_1__helpers__["_5" /* setElementIsHidden */](element);
    }
    return element;
};
var getDriveLinkWithoutHash = function (driveLink) { return driveLink.split('?')[0]; };
var setTooltipActions = function (element, tooltip, isTooltipActive) {
    if (isTooltipActive) {
        element.setAttribute('onmouseenter', __WEBPACK_IMPORTED_MODULE_1__helpers__["M" /* getTooltipAction */](__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* TooltipAction */].SHOW, tooltip));
        element.setAttribute('onmouseleave', __WEBPACK_IMPORTED_MODULE_1__helpers__["M" /* getTooltipAction */](__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* TooltipAction */].HIDE));
    }
    else {
        element.removeAttribute('onmouseenter');
        element.removeAttribute('onmouseleave');
    }
};


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__htmlEditor_constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__ = __webpack_require__(42);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};




var getLinkDataFromElement = function (element, spreads) {
    var linkElement = element.closest('a');
    var linkAction = linkElement.getAttribute('onclick') || '';
    if (linkAction) {
        var pluginLinkData = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["p" /* getLinkDataFromAction */])(linkAction, spreads);
        if (pluginLinkData) {
            return pluginLinkData;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["s" /* getLinkUrlData */])(linkElement.href);
};
var getConfig = function (element, page, editorType, spreads, isAccountManagerOrAdmin) {
    var linkData = getLinkDataFromElement(element, spreads);
    var shouldCorrect = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["_7" /* shouldCorrectLink */])(linkData);
    return {
        id: editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN
            ? element.id
            : element.getAttribute(__WEBPACK_IMPORTED_MODULE_2__htmlEditor_constants__["c" /* editableId */]),
        page: page,
        linkData: linkData,
        shouldCorrect: shouldCorrect,
        isEditedFromBackoffice: shouldCorrect,
        isThemedItem: isAccountManagerOrAdmin && !!element.className.includes(__WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].themedItemClassName),
    };
};
var getLinkSelector = function (editorType) {
    if (editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN) {
        return "a > [id*=" + __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].parentContainerId + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].lockedClassName + "])";
    }
    return "a [" + __WEBPACK_IMPORTED_MODULE_2__htmlEditor_constants__["a" /* EditableItem */].Image + "]";
};
var isLockedEditableButton = function (element) {
    var isLinkOnImage = element.className.includes(__WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].imageClassName) ||
        element.getAttribute(__WEBPACK_IMPORTED_MODULE_2__htmlEditor_constants__["a" /* EditableItem */].Image) !== null;
    if (isLinkOnImage) {
        return false;
    }
    var linkElement = element.closest('a');
    var lockedText = linkElement &&
        linkElement.parentElement &&
        linkElement.parentElement.querySelector("[class*=" + __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].textFieldClassName + "][class*=" + __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].lockedClassName + "]");
    return !!lockedText;
};
// ignore links with empty 'href' or 'target' attributes
var isEditableLink = function (element) {
    var linkElement = element.closest('a');
    if (!linkElement) {
        return false;
    }
    var href = linkElement.getAttribute('href');
    var target = linkElement.getAttribute('target');
    return !!(href || target);
};
/* harmony default export */ __webpack_exports__["a"] = (function (page, htmlDocument, editorType, spreads, isAccountManagerOrAdmin) {
    var items = [];
    var isError = false;
    var editableLinkElements = __spread(htmlDocument.querySelectorAll(getLinkSelector(editorType))).filter(function (element) { return (isEditableLink(element) && !isLockedEditableButton(element) && !Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["V" /* hasLockedParent */])(element)); });
    try {
        editableLinkElements.forEach(function (element) { return (items.push(getConfig(element, page, editorType, spreads, isAccountManagerOrAdmin))); });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        isError: isError,
    };
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__htmlEditor_constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__ = __webpack_require__(42);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var updateAttributes = function (element, attributes) {
    Object.entries(attributes).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value) {
            element.setAttribute(key, value);
        }
        else {
            element.removeAttribute(key);
        }
    });
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, links, editorType) {
    links.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, id = _a.id, linkData = _a.linkData;
        if (!isEditedFromBackoffice) {
            return;
        }
        var linkSelector = editorType === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].INDESIGN
            ? "#" + id
            : "[" + __WEBPACK_IMPORTED_MODULE_2__htmlEditor_constants__["c" /* editableId */] + "=" + id + "]";
        var element = htmlDocument.querySelector(linkSelector);
        var linkElement = element && element.closest('a');
        if (linkElement) {
            var isUrlLink = linkData.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LinkType */].url;
            var attributes = {
                href: linkData.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LinkType */].url ? linkData.data.href : 'javascript:void(0)',
                target: isUrlLink ? '_blank' : null,
                onclick: isUrlLink ? null : Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["o" /* getLinkAction */])(linkData),
                ontouchend: isUrlLink ? null : Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["o" /* getLinkAction */])(linkData),
                draggable: isUrlLink ? null : 'false',
            };
            updateAttributes(linkElement, attributes);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["X" /* isEditableButtonLink */])(linkElement)) {
                var parentLinkElement = linkElement.closest("[id*=" + __WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].parentContainerId + "]");
                if (parentLinkElement) {
                    parentLinkElement.classList.add(__WEBPACK_IMPORTED_MODULE_3__indesignEditor_constants__["c" /* default */].editableButtonLinkClassName);
                }
            }
        }
    });
});


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoCoverImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return replaceVideosWithCoverImages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

var getVideoCoverImage = function (element, htmlDocument) {
    var isVideo = element.tagName === 'VIDEO';
    var elementWithSrc = isVideo
        ? element.querySelector('source')
        : element;
    var src = elementWithSrc.src;
    var image = htmlDocument.createElement('img');
    image.src = isVideo ? Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["S" /* getVideoCover */])(src) : Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["U" /* getYoutubeVideoCover */])(src);
    image.alt = '';
    var imageStyle = 'position:absolute;top:0;bottom:0;left:0;right:0;max-width:100%;max-height:100%;width:auto;height:auto;margin:auto;';
    image.setAttribute('style', imageStyle);
    image.setAttribute('onerror', 'this.onerror=null;this.setAttribute("hidden", "true")');
    var defaultImage = htmlDocument.createElement('svg');
    var defaultImageStyle = 'position:absolute;top:0;bottom:0;left:0;right:0;z-index:-1;max-width:100%;max-height:100%;width:50%;height:50%;margin:auto;fill:#a4a4a4';
    defaultImage.setAttribute('style', defaultImageStyle);
    var useElement = htmlDocument.createElement('use');
    useElement.setAttribute('xlink:href', '#svgicon-iconset_uprez_play-button');
    defaultImage.appendChild(useElement);
    return {
        image: image,
        defaultImage: defaultImage,
    };
};
var replaceVideoWithCoverImage = function (element, htmlDocument) {
    var _a = getVideoCoverImage(element, htmlDocument), image = _a.image, defaultImage = _a.defaultImage;
    var parentNode = element.parentNode;
    if (parentNode) {
        parentNode.removeChild(element);
        parentNode.appendChild(image);
        parentNode.appendChild(defaultImage);
    }
};
var replaceVideosWithCoverImages = function (htmlDocument) {
    var videoElements = __spread(htmlDocument.querySelectorAll("video, iframe[src*=\"" + __WEBPACK_IMPORTED_MODULE_0__helpers__["_8" /* youtubeUrl */] + "\"]"));
    videoElements.forEach(function (element) { return replaceVideoWithCoverImage(element, htmlDocument); });
    return htmlDocument;
};


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_serializer__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderers__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marks__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__links__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventHooks__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lists__ = __webpack_require__(1025);
/**
 * Slate library (https://docs.slatejs.org/) is used for implementing rich text editor functionality
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






/* harmony default export */ __webpack_exports__["a"] = (__assign({ html: __WEBPACK_IMPORTED_MODULE_0__html_serializer__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_1__renderers__, __WEBPACK_IMPORTED_MODULE_2__marks__, __WEBPACK_IMPORTED_MODULE_3__links__, __WEBPACK_IMPORTED_MODULE_4__eventHooks__, __WEBPACK_IMPORTED_MODULE_5__lists__));


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var index = (function (condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    console.warn(message);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(142),
    toKey = __webpack_require__(233);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(932),
    mapCacheDelete = __webpack_require__(948),
    mapCacheGet = __webpack_require__(950),
    mapCacheHas = __webpack_require__(951),
    mapCacheSet = __webpack_require__(952);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(143),
    isObject = __webpack_require__(86);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(490);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(960),
    overRest = __webpack_require__(963),
    setToString = __webpack_require__(965);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(488),
    baseClone = __webpack_require__(970),
    baseUnset = __webpack_require__(1011),
    castPath = __webpack_require__(142),
    copyObject = __webpack_require__(179),
    customOmitClone = __webpack_require__(1015),
    flatRest = __webpack_require__(491),
    getAllKeysIn = __webpack_require__(501);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(979),
    isArguments = __webpack_require__(313),
    isArray = __webpack_require__(98),
    isBuffer = __webpack_require__(494),
    isIndex = __webpack_require__(312),
    isTypedArray = __webpack_require__(981);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(63),
    stubFalse = __webpack_require__(980);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(485),
    isLength = __webpack_require__(314);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(493),
    baseKeysIn = __webpack_require__(986),
    isArrayLike = __webpack_require__(496);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(315),
    getPrototype = __webpack_require__(321),
    getSymbols = __webpack_require__(320),
    stubArray = __webpack_require__(498);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(315),
    isArray = __webpack_require__(98);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(500),
    getSymbolsIn = __webpack_require__(499),
    keysIn = __webpack_require__(497);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaElementDataAttribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editableMedia_getData__ = __webpack_require__(475);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};





var MediaElementDataAttribute;
(function (MediaElementDataAttribute) {
    MediaElementDataAttribute["edited"] = "data-edited";
    MediaElementDataAttribute["label"] = "data-label";
    MediaElementDataAttribute["defaultLabel"] = "data-default-label";
    MediaElementDataAttribute["tooltip"] = "data-tooltip";
    MediaElementDataAttribute["tooltipActive"] = "data-tooltip-active";
    MediaElementDataAttribute["defaultLink"] = "data-default-link";
    MediaElementDataAttribute["driveLink"] = "data-drive-link";
    MediaElementDataAttribute["externalLink"] = "data-external-link";
    MediaElementDataAttribute["externalLinkActive"] = "data-external-link-active";
    MediaElementDataAttribute["hidden"] = "data-hidden";
    MediaElementDataAttribute["style"] = "data-original-style";
})(MediaElementDataAttribute || (MediaElementDataAttribute = {}));
var isImageElement = function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].imageClassName)); };
var isVideoElement = function (tagName) { return tagName === __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].video; };
var isVideoIframeElement = function (tagName, className) { return (tagName === __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].iframe && className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].videoClassName)); };
var getFrameData = function (id, css) {
    var _a = __WEBPACK_IMPORTED_MODULE_2__helpers__["m" /* getElementSizes */](id, css), width = _a.width, height = _a.height;
    return {
        frameWidth: width,
        frameHeight: height,
    };
};
var getMediaType = function (_a) {
    var tagName = _a.tagName, className = _a.className;
    switch (tagName) {
        case __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].img:
        default:
            return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].image;
        case __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].video:
            return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].video;
        case __WEBPACK_IMPORTED_MODULE_3__editableMedia_typing__["a" /* TagName */].iframe:
            return className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].videoClassName)
                ? __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].video
                : __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].animation;
    }
};
var getElementId = function (element) {
    if (isImageElement(element.className)) {
        return element.id;
    }
    return __WEBPACK_IMPORTED_MODULE_2__helpers__["k" /* getElementId */](element);
};
var getElementSources = function (element, isEditedFromBackoffice, isVisible) {
    if (isEditedFromBackoffice) {
        return {
            defaultLink: element.getAttribute(MediaElementDataAttribute.defaultLink) || '',
            driveLink: element.getAttribute(MediaElementDataAttribute.driveLink) || '',
            externalLink: element.getAttribute(MediaElementDataAttribute.externalLink) || '',
            isExternalLinkActive: element.getAttribute(MediaElementDataAttribute.externalLinkActive) === 'true',
        };
    }
    var tagName = element.tagName, className = element.className;
    var elementWithSrc = isVideoElement(tagName)
        ? element.querySelector('source')
        : element;
    var src = elementWithSrc.src;
    var isVideoIframe = isVideoIframeElement(tagName, className);
    var defaultSrc = element.getAttribute(MediaElementDataAttribute.defaultLink) || '';
    var defaultLink = __WEBPACK_IMPORTED_MODULE_2__helpers__["P" /* getUrlWithoutOrigin */](isVisible ? src : defaultSrc);
    return {
        defaultLink: defaultLink,
        driveLink: '',
        externalLink: isVideoIframe ? defaultLink : '',
        isExternalLinkActive: isVideoIframe,
    };
};
var getElementLabels = function (element, isEditedFromBackoffice) {
    if (!isEditedFromBackoffice) {
        return {
            label: '',
            defaultLabel: element.getAttribute(MediaElementDataAttribute.label) || '',
        };
    }
    return {
        label: element.getAttribute(MediaElementDataAttribute.label) || '',
        defaultLabel: element.getAttribute(MediaElementDataAttribute.defaultLabel) || '',
    };
};
var getElementTooltip = function (element, isEditedFromBackoffice) {
    var tooltipActionAttribute = element.attributes['onmouseenter'] || {}; // tslint:disable-line no-string-literal
    var defaultTooltipAction = tooltipActionAttribute.value;
    var tooltip = element.getAttribute(MediaElementDataAttribute.tooltip) || __WEBPACK_IMPORTED_MODULE_2__helpers__["i" /* getDefaultTooltip */](defaultTooltipAction);
    return {
        tooltip: tooltip,
        isTooltipActive: isEditedFromBackoffice
            ? element.getAttribute(MediaElementDataAttribute.tooltipActive) === 'true'
            : !!tooltip,
    };
};
var getMediaData = function (element, frameWidth, frameHeight, isAccessible) {
    var mediaElement = isImageElement(element.className)
        ? element.querySelector('img')
        : element;
    var _a = mediaElement.style, width = _a.width, height = _a.height, transform = _a.transform;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_2__helpers__["O" /* getTranslateValueFromStyle */]({ transform: transform }), 2), x = _b[0], y = _b[1];
    var isEditedFromBackoffice = mediaElement.getAttribute(MediaElementDataAttribute.edited) === 'true';
    var isVisible = !(mediaElement.getAttribute(MediaElementDataAttribute.hidden) &&
        mediaElement.getAttribute(MediaElementDataAttribute.hidden) === 'true');
    var defaultSrc = mediaElement.getAttribute(MediaElementDataAttribute.defaultLink) || '';
    var className = element.className, tagName = element.tagName;
    var originalStyle = isAccessible ? mediaElement.getAttribute('style') || '' : '';
    return __assign({ type: getMediaType(element), width: width ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](width) : frameWidth, height: height ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](height) : frameHeight, x: x,
        y: y,
        isEditedFromBackoffice: isEditedFromBackoffice,
        isVisible: isVisible, canDragAndResize: isImageElement(element.className)
            ? isEditedFromBackoffice
            : false, isInsideButton: !!element.closest("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].buttonClassName + "]"), videoSettings: Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_getData__["a" /* getVideoSettings */])(mediaElement, isVideoElement(tagName), isVideoIframeElement(tagName, className), defaultSrc), altAttr: mediaElement.getAttribute('alt') || '', originalStyle: originalStyle }, getElementSources(mediaElement, isEditedFromBackoffice, isVisible), getElementLabels(mediaElement, isEditedFromBackoffice), getElementTooltip(mediaElement, isEditedFromBackoffice));
};
var getConfig = function (element, page, pageIndexInSpread, css, isAccessible) {
    var id = getElementId(element);
    var className = element.className.split(' ').find(function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].imageClassName) ||
        className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].videoClassName) ||
        className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].animationClassName)); }) || '';
    if (__WEBPACK_IMPORTED_MODULE_2__helpers__["W" /* isDuplicatedItemInSpread */](className, pageIndexInSpread)) {
        return {
            page: page,
            id: id,
            className: className,
        };
    }
    var _a = getFrameData(id, css), frameWidth = _a.frameWidth, frameHeight = _a.frameHeight;
    var width = frameWidth ? frameWidth : 0;
    var height = frameHeight ? frameHeight : 0;
    var mediaData = getMediaData(element, width, height, isAccessible);
    return __assign({ page: page,
        id: id,
        className: className, importManagerId: id + "-" + page, frameWidth: frameWidth, frameHeight: frameHeight, isLoaded: true }, mediaData);
};
/* harmony default export */ __webpack_exports__["b"] = (function (page, pageIndexInSpread, htmlDocument, css, isAccessible) {
    var items = [];
    var duplicatedItemsInSpread = [];
    var isError = false;
    var editableMediaElements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].imageClassName + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName + "])"), htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].videoClassName + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName + "])"), htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].animationClassName + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName + "])")).filter(function (element) { return !__WEBPACK_IMPORTED_MODULE_2__helpers__["V" /* hasLockedParent */](element); });
    try {
        editableMediaElements.forEach(function (element) {
            var config = getConfig(element, page, pageIndexInSpread, css, isAccessible);
            if (config) {
                if ('frameWidth' in config) {
                    items.push(config);
                }
                else {
                    duplicatedItemsInSpread.push(config);
                }
            }
        });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        duplicatedItemsInSpread: duplicatedItemsInSpread,
        isError: isError,
    };
});


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACTION_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonElementDataAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeButtonActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var ACTION_TYPE;
(function (ACTION_TYPE) {
    ACTION_TYPE["releaseactions"] = "releaseactions";
    ACTION_TYPE["clickactions"] = "clickactions";
    ACTION_TYPE["rolloveractions"] = "rolloveractions";
    ACTION_TYPE["rolloffactions"] = "rolloffactions";
})(ACTION_TYPE || (ACTION_TYPE = {}));
var ButtonElementDataAttribute;
(function (ButtonElementDataAttribute) {
    ButtonElementDataAttribute["hidden"] = "data-hidden";
    ButtonElementDataAttribute["hasLink"] = "data-has-link";
})(ButtonElementDataAttribute || (ButtonElementDataAttribute = {}));
var getConfig = function (element, page, pageIndexInSpread, isAccountManagerOrAdmin, totalPages, spreads) {
    var filteredClassName = element.className.split(' ').find(function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].editableButtonClassName)); }) || '';
    if (__WEBPACK_IMPORTED_MODULE_1__helpers__["W" /* isDuplicatedItemInSpread */](filteredClassName, pageIndexInSpread)) {
        return {
            page: page,
            id: element.id,
            className: filteredClassName,
        };
    }
    var isLocked = element.className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName) ||
        __WEBPACK_IMPORTED_MODULE_1__helpers__["V" /* hasLockedParent */](element);
    var actionAttr = element.dataset[ACTION_TYPE.releaseactions] ||
        element.dataset[ACTION_TYPE.clickactions] ||
        element.dataset[ACTION_TYPE.rolloveractions] ||
        element.dataset[ACTION_TYPE.rolloffactions] ||
        '';
    var regExp = /goToDestination\(['"`](.+)['"`]\);/;
    var match = actionAttr.match(regExp);
    var action = match ? match[1] : '';
    var inDesignAction = match ? undefined : actionAttr;
    // locked buttons with inDesign action should be rendered as <ButtonEditor> to have ability to run its action
    // otherwise it won't be possible to change MSO state or open/close hidden blocks
    if (isLocked && !inDesignAction) {
        return;
    }
    var linkData = __WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* getButtonLinkParamsFromAction */](action, totalPages, spreads);
    var shouldCorrect = __WEBPACK_IMPORTED_MODULE_1__helpers__["_7" /* shouldCorrectLink */](linkData);
    return {
        page: page,
        id: element.id,
        className: filteredClassName,
        isVisible: !element.getAttribute(ButtonElementDataAttribute.hidden),
        isThemedItem: isAccountManagerOrAdmin && !!element.querySelector("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].themedItemClassName + "]"),
        hasLink: hasLink(element, linkData),
        linkData: linkData,
        actionType: getActionType(element),
        inDesignAction: inDesignAction,
        isLocked: isLocked,
        shouldCorrect: shouldCorrect,
        isEditedFromBackoffice: shouldCorrect,
    };
};
var hasLink = function (element, linkData) {
    if (element.getAttribute(ButtonElementDataAttribute.hasLink)) {
        return true;
    }
    if (linkData.type === __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* LinkType */].url && !linkData.data.href) {
        return false;
    }
    return true;
};
var getActionType = function (element) {
    var actionNames = Object.keys(element.dataset);
    if (actionNames.length === 0) {
        return;
    }
    return actionNames.includes(ACTION_TYPE.clickactions)
        ? ACTION_TYPE.clickactions
        : ACTION_TYPE.releaseactions;
};
var removeButtonActions = function (htmlDocument) {
    var buttons = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].buttonClassName + "]"));
    buttons.forEach(function (button) {
        for (var actionType in ACTION_TYPE) {
            button.removeAttribute("data-" + actionType);
        }
    });
    return htmlDocument;
};
/* harmony default export */ __webpack_exports__["b"] = (function (page, pageIndexInSpread, htmlDocument, isAccountManagerOrAdmin, totalPages, spreads) {
    var items = [];
    var duplicatedItemsInSpread = [];
    var isError = false;
    var buttonElements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].buttonClassName + "]"));
    try {
        buttonElements.forEach(function (element) {
            var config = getConfig(element, page, pageIndexInSpread, isAccountManagerOrAdmin, totalPages, spreads);
            if (config) {
                if ('linkData' in config) {
                    items.push(config);
                }
                else {
                    duplicatedItemsInSpread.push(config);
                }
            }
        });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        duplicatedItemsInSpread: duplicatedItemsInSpread,
        isError: isError,
    };
});


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IframeElementDataAttribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var IframeElementDataAttribute;
(function (IframeElementDataAttribute) {
    IframeElementDataAttribute["edited"] = "data-edited";
    IframeElementDataAttribute["defaultSrc"] = "data-default-src";
    IframeElementDataAttribute["src"] = "data-src";
    IframeElementDataAttribute["hidden"] = "data-hidden";
})(IframeElementDataAttribute || (IframeElementDataAttribute = {}));
var getElementSources = function (element, isEditedFromBackoffice, isVisible) {
    if (isEditedFromBackoffice) {
        return {
            defaultSrc: element.getAttribute(IframeElementDataAttribute.defaultSrc) || '',
            src: element.getAttribute(IframeElementDataAttribute.src) || '',
        };
    }
    var defaultSrc = isVisible
        ? element.src
        : element.getAttribute(IframeElementDataAttribute.defaultSrc) || '';
    return {
        defaultSrc: defaultSrc,
        src: defaultSrc,
    };
};
var getConfig = function (element, page) {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* getElementId */])(element);
    var isEditedFromBackoffice = element.getAttribute(IframeElementDataAttribute.edited) === 'true';
    var isVisible = !(element.getAttribute(IframeElementDataAttribute.hidden) &&
        element.getAttribute(IframeElementDataAttribute.hidden) === 'true');
    return __assign({ page: page,
        id: id,
        isEditedFromBackoffice: isEditedFromBackoffice,
        isVisible: isVisible }, getElementSources(element, isEditedFromBackoffice, isVisible));
};
/* harmony default export */ __webpack_exports__["b"] = (function (page, htmlDocument) {
    var items = [];
    var isError = false;
    var iframeElements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].iframeClassName + "]")).filter(function (element) { return !Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["V" /* hasLockedParent */])(element); });
    try {
        iframeElements.forEach(function (element) { return (items.push(getConfig(element, page))); });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        isError: isError,
    };
});


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnrichmentElementDataAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEnrichmentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var EnrichmentElementDataAttribute;
(function (EnrichmentElementDataAttribute) {
    EnrichmentElementDataAttribute["edited"] = "data-edited";
    EnrichmentElementDataAttribute["defaultResource"] = "data-default-resource";
    EnrichmentElementDataAttribute["deps"] = "data-deps";
})(EnrichmentElementDataAttribute || (EnrichmentElementDataAttribute = {}));
var getEnrichmentData = function (element) {
    var enrichmentDataString = element.getAttribute('onclick');
    if (!enrichmentDataString) {
        return null;
    }
    var enrichmentRegExp = /javascript:document\.dispatchEvent\(new CustomEvent\("WebPublicationAction", {"detail":([\s\S]*?)}\)\); return false;/;
    var dataMatch = enrichmentDataString.match(enrichmentRegExp);
    if (!dataMatch) {
        return null;
    }
    try {
        var _a = JSON.parse(dataMatch[1]
            .replace(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* actionEventDynamicProperty */], '')
            .replace(/'/g, '"')
            .trim()), type = _a.type, params = _a.params;
        return {
            type: type,
            resource: params.assetDriveItem,
            params: params,
        };
    }
    catch (err) {
        return null;
    }
};
var getConfig = function (element, page, type, resource, isAccountManagerOrAdmin) {
    var id = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* getElementId */])(element);
    var isEditedFromBackoffice = element.getAttribute(EnrichmentElementDataAttribute.edited) === 'true';
    var defaultResource = isEditedFromBackoffice
        ? JSON.parse(element.getAttribute(EnrichmentElementDataAttribute.defaultResource))
        : resource;
    var deps = element.getAttribute(EnrichmentElementDataAttribute.deps) || undefined;
    return {
        page: page,
        id: id,
        type: type,
        resource: __assign({}, resource, { deps: deps }),
        defaultResource: defaultResource,
        importManagerId: id + "-" + page,
        isEditedFromBackoffice: isEditedFromBackoffice,
        isThemedItem: isAccountManagerOrAdmin && !!element.closest("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].themedItemClassName + "]"),
    };
};
/* harmony default export */ __webpack_exports__["b"] = (function (page, htmlDocument, isAccountManagerOrAdmin) {
    var items = [];
    var isError = false;
    var elements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].enrichmentClassName + "]")).filter(function (element) { return !Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["V" /* hasLockedParent */])(element); });
    try {
        elements.forEach(function (element) {
            var enrichmentData = getEnrichmentData(element);
            if (enrichmentData) {
                var type = enrichmentData.type, resource = enrichmentData.resource;
                var isSupportedEnrichment = Object.values(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EnrichmentType */]).includes(type);
                if (isSupportedEnrichment) {
                    items.push(getConfig(element, page, type, resource, isAccountManagerOrAdmin));
                }
            }
        });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        isError: isError,
    };
});


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExternalResourcesActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getExternalResourcesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setExternalResourcesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetExternalResourcesLoading; });
var ExternalResourcesActionKeys;
(function (ExternalResourcesActionKeys) {
    ExternalResourcesActionKeys["GET_DATA"] = "@@editor/externalResources/GET_DATA";
    ExternalResourcesActionKeys["SET_DATA"] = "@@editor/externalResources/SET_DATA";
    ExternalResourcesActionKeys["RESET_LOADING"] = "@@editor/externalResources/RESET_LOADING";
})(ExternalResourcesActionKeys || (ExternalResourcesActionKeys = {}));
var getExternalResourcesData = function (id) { return ({
    type: ExternalResourcesActionKeys.GET_DATA,
    id: id,
}); };
var setExternalResourcesData = function (id, data) { return ({
    type: ExternalResourcesActionKeys.SET_DATA,
    id: id,
    data: data,
}); };
var resetExternalResourcesLoading = function (id) { return ({
    type: ExternalResourcesActionKeys.RESET_LOADING,
    id: id,
}); };


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagesSelectionActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setPagesSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetPagesSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectPageSpread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removePages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return movePages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duplicatePages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(17);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;







var PagesSelectionActionKeys;
(function (PagesSelectionActionKeys) {
    PagesSelectionActionKeys["SET_PAGES_SELECTION"] = "@@editor/pagesSelection/SET_PAGES_SELECTION";
    PagesSelectionActionKeys["RESET_PAGES_SELECTION"] = "@@editor/pagesSelection/RESET_PAGES_SELECTION";
    PagesSelectionActionKeys["SELECT_PAGE_SPREAD"] = "@@editor/pagesSelection/SELECT_PAGE_SPREAD";
    PagesSelectionActionKeys["RESTORE_PAGES_SELECTION"] = "@@editor/pagesSelection/RESTORE_PAGES_SELECTION";
})(PagesSelectionActionKeys || (PagesSelectionActionKeys = {}));
var setPagesSelection = function () { return function (dispatch, getState) {
    var currentSpreadIndex = getState().editor.pagesController.currentSpreadIndex;
    var action = {
        type: PagesSelectionActionKeys.SET_PAGES_SELECTION,
        currentSpreadIndex: currentSpreadIndex,
    };
    dispatch(action);
}; };
var resetPagesSelection = function () { return ({
    type: PagesSelectionActionKeys.RESET_PAGES_SELECTION,
}); };
var selectPageSpread = function (spreadIndex, isCtrlPressed, isShiftPressed) { return function (dispatch, getState) {
    var spreads = getState().editor.pagesController.spreads;
    var action = {
        type: PagesSelectionActionKeys.SELECT_PAGE_SPREAD,
        spreadIndex: spreadIndex,
        allSpreads: spreads,
        isCtrlPressed: isCtrlPressed,
        isShiftPressed: isShiftPressed,
    };
    dispatch(action);
}; };
var restorePagesSelection = function (spreadIndices) { return ({
    type: PagesSelectionActionKeys.RESTORE_PAGES_SELECTION,
    spreadIndices: spreadIndices,
}); };
var removePages = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, currentSpreadIndex, spreads, _c, spreadIndices, isActive, _d, clientId, resourceId, spreadsToRemove, firstSpreadIndexToRemove, spreadIndexTogo, pagesToRemove, error_1;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 4]);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* setIsEditorLoaded */])(false));
                _a = getState().editor, _b = _a.pagesController, currentSpreadIndex = _b.currentSpreadIndex, spreads = _b.spreads, _c = _a.pagesSelection, spreadIndices = _c.spreadIndices, isActive = _c.isActive;
                _d = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _d.clientId, resourceId = _d.tempGId;
                spreadsToRemove = isActive ? spreadIndices : spreads[currentSpreadIndex];
                firstSpreadIndexToRemove = isActive ? spreadIndices[0] : currentSpreadIndex;
                spreadIndexTogo = firstSpreadIndexToRemove >= (spreads.length - spreadsToRemove.length)
                    ? firstSpreadIndexToRemove - 1
                    : firstSpreadIndexToRemove;
                pagesToRemove = isActive
                    ? __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["C" /* getSelectedPages */](spreadIndices, spreads)
                    : spreads[currentSpreadIndex];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].removePublicationPages(clientId, resourceId, pagesToRemove)];
            case 1:
                _e.sent();
                return [4 /*yield*/, dispatch(finishPagesUpdate([spreadIndexTogo], isActive))];
            case 2:
                _e.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _e.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* setIsEditorLoaded */])(true));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.remove_page_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var movePages = function (spreadIndices, newSpreadPosition) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, spreads, pagesSelection, _b, clientId, resourceId, isMoveToTop_1, pages, newSpreadIndices, destinationSpread, newPagePosition, error_2;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* setIsEditorLoaded */])(false));
                _a = getState().editor, spreads = _a.pagesController.spreads, pagesSelection = _a.pagesSelection;
                _b = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _b.clientId, resourceId = _b.tempGId;
                isMoveToTop_1 = spreadIndices[0] > newSpreadPosition;
                pages = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["C" /* getSelectedPages */](spreadIndices, spreads);
                newSpreadIndices = spreadIndices.map(function (spreadIndex, index) { return (isMoveToTop_1
                    ? newSpreadPosition + index
                    : newSpreadPosition + index - (spreadIndices.length - 1)); });
                destinationSpread = spreads[newSpreadPosition];
                newPagePosition = destinationSpread[isMoveToTop_1 ? 0 : destinationSpread.length - 1];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].movePublicationPages(clientId, resourceId, pages, newPagePosition)];
            case 1:
                _c.sent();
                return [4 /*yield*/, dispatch(finishPagesUpdate(newSpreadIndices, pagesSelection.isActive))];
            case 2:
                _c.sent();
                return [3 /*break*/, 4];
            case 3:
                error_2 = _c.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* setIsEditorLoaded */])(true));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.move_page_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var duplicatePages = function () { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, currentSpreadIndex, spreads, displayMode, _c, spreadIndices, isActive, pagesData, _d, clientId, resourceId, spreadIndexToDuplicate, newSpreadIndex, pagesToDuplicate, error_3;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 4]);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* setIsEditorLoaded */])(false));
                _a = getState().editor, _b = _a.pagesController, currentSpreadIndex = _b.currentSpreadIndex, spreads = _b.spreads, displayMode = _b.displayMode, _c = _a.pagesSelection, spreadIndices = _c.spreadIndices, isActive = _c.isActive, pagesData = _a.configs.pagesData;
                _d = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _d.clientId, resourceId = _d.tempGId;
                spreadIndexToDuplicate = isActive ? spreadIndices[0] : currentSpreadIndex;
                newSpreadIndex = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["c" /* getActiveSpreadIndexAfterPagesUpdate */](spreadIndexToDuplicate, spreads, displayMode, pagesData);
                pagesToDuplicate = isActive && spreadIndices.length === 1
                    ? __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["C" /* getSelectedPages */](spreadIndices, spreads)
                    : spreads[currentSpreadIndex];
                return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].duplicatePublicationPages(clientId, resourceId, pagesToDuplicate)];
            case 1:
                _e.sent();
                return [4 /*yield*/, dispatch(finishPagesUpdate([newSpreadIndex]))];
            case 2:
                _e.sent();
                return [3 /*break*/, 4];
            case 3:
                error_3 = _e.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* setIsEditorLoaded */])(true));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.duplicate_page_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var finishPagesUpdate = function (newSpreadIndices, isPagesSelectionActive) { return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
    var _a, clientId, resourceId, totalPages, error_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["p" /* setVersion */])(Date.now()));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["f" /* reset */])(true));
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isEditorOpened */])()) return [3 /*break*/, 2];
                _a = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */](), clientId = _a.clientId, resourceId = _a.tempGId;
                return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sources__["c" /* getData */])(clientId, resourceId, false))];
            case 1:
                _b.sent();
                totalPages = getState().editor.pagesController.totalPages;
                if (isPagesSelectionActive && totalPages > 1) {
                    dispatch(restorePagesSelection(newSpreadIndices));
                }
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__pagesController__["b" /* changePageSpread */])(newSpreadIndices[0], false));
                _b.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                error_4 = _b.sent();
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNamedWrapperReducer; });
var createNamedWrapperReducer = function (reducerFunction, reducerName) { return (function (state, action) {
    var sourceType = action.sourceType;
    var isInitializationCall = state === undefined;
    if (sourceType !== reducerName && !isInitializationCall) {
        return state;
    }
    return reducerFunction(state, action);
}); };


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParametersPageActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setUsedSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFreeSpace; });
var ParametersPageActionKeys;
(function (ParametersPageActionKeys) {
    ParametersPageActionKeys["SET_USED_SPACE"] = "@@parametersPage/SET_USED_SPACE";
    ParametersPageActionKeys["SET_FREE_SPACE"] = "@@parametersPage/SET_FREE_SPACE";
})(ParametersPageActionKeys || (ParametersPageActionKeys = {}));
var setUsedSpace = function (value) { return ({
    value: value,
    type: ParametersPageActionKeys.SET_USED_SPACE
}); };
var setFreeSpace = function (value) { return ({
    value: value,
    type: ParametersPageActionKeys.SET_FREE_SPACE
}); };


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RouteParamsActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRouteParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuManager_actions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_statistics__ = __webpack_require__(82);



var RouteParamsActionKeys;
(function (RouteParamsActionKeys) {
    RouteParamsActionKeys["SET_ROUTE_PARAMS"] = "@@routeParams/SET_ROUTE_PARAMS";
})(RouteParamsActionKeys || (RouteParamsActionKeys = {}));
var setRouteParams = function (data, routes) { return function (dispatch, getState) {
    var currentPath = routes[routes.length - 1].path;
    var isOpen = getState().sharePanel.isOpen;
    if (currentPath) {
        __WEBPACK_IMPORTED_MODULE_2__utils_statistics__["a" /* default */].trackPageView(currentPath, data);
    }
    if (isOpen) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__Share_actions__["b" /* SharePanelActionKeys */].CLOSE_PANEL });
    }
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__MenuManager_actions__["c" /* requestCloseLeftSideMenu */])());
    dispatch({ type: RouteParamsActionKeys.SET_ROUTE_PARAMS, data: data, routes: routes });
}; };


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CopyMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sharePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var FormType;
(function (FormType) {
    FormType["Uprez"] = "uprezForm";
    FormType["Webpublication"] = "webpublicationForm";
})(FormType || (FormType = {}));
var CopyMode;
(function (CopyMode) {
    CopyMode["html"] = "html";
    CopyMode["text"] = "text";
})(CopyMode || (CopyMode = {}));
var initialFormState = {
    company: '',
    firstname: '',
    subject: '',
    phone: '',
    position: '',
    surname: '',
    contactEmail: '',
    message: '',
    userEmail: '',
    userName: '',
    createDeal: false,
};
var initialState = {
    isOpen: false,
    isShareActionsPopupOpen: false,
    isShareViaCopyPopupOpen: false,
    copyMode: CopyMode.text,
    shareViaCopyData: [],
    pin: '',
    isProcessing: false,
    selectedResources: [],
    selectedNotes: [],
    foldersContent: [],
    form: initialFormState,
    isPublicationShare: false,
    crmContacts: [],
    callbackAction: undefined,
};
function sharePanel(state, action) {
    if (state === void 0) { state = initialState; }
    var newState = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(state);
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].OPEN_PANEL:
            newState.isOpen = true;
            newState.isPublicationShare = action.isPublicationShare;
            newState.callbackAction = action.callbackAction;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].CLOSE_PANEL:
            newState.isOpen = false;
            newState.isPublicationShare = false;
            newState.foldersContent = [];
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].OPEN_SHARE_ACTIONS_POPUP:
            newState.isShareActionsPopupOpen = true;
            newState.isPublicationShare = action.isPublicationShare;
            newState.selectedResources = action.sharedItems;
            newState.callbackAction = action.callbackAction;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].CLOSE_SHARE_ACTIONS_POPUP:
            newState.isShareActionsPopupOpen = false;
            newState.isPublicationShare = false;
            if (action.shouldResetSelection) {
                newState.selectedResources = [];
                newState.selectedNotes = [];
                newState.callbackAction = undefined;
            }
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].OPEN_SHARE_VIA_COPY_POPUP:
            newState.isShareViaCopyPopupOpen = true;
            newState.shareViaCopyData = action.shareViaCopyData;
            newState.pin = action.pin;
            newState.theme = action.theme;
            newState.callbackAction = action.callbackAction;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].CLOSE_SHARE_VIA_COPY_POPUP:
            newState.isShareViaCopyPopupOpen = false;
            newState.shareViaCopyData = [];
            newState.pin = '';
            newState.theme = undefined;
            newState.callbackAction = undefined;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].SET_COPY_MODE:
            newState.copyMode = action.copyMode;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].START_PROCESSING:
            newState.isProcessing = true;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].FINISH_PROCESSING:
            newState.isProcessing = false;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].RESET_FORM:
            newState.form = initialFormState;
            newState.selectedResources = [];
            newState.selectedNotes = [];
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].SET_SELECTION: {
            if (action.selectedResources) {
                newState.selectedResources = action.selectedResources;
            }
            if (action.selectedNotes) {
                newState.selectedNotes = action.selectedNotes;
            }
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].SET_FORM_FIELD:
            newState.form[action.name] = action.value;
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].UPDATE_FOLDERS_CONTENT:
            newState.foldersContent = __spread(state.foldersContent, [action.item]);
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SharePanelActionKeys */].SET_CRM_CONTACTS:
            newState.crmContacts = action.crmContacts;
            return newState;
        default:
            return state;
    }
}



/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GDPRCookieActionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeGDPRBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openGDPRBanner; });
var GDPRCookieActionKeys;
(function (GDPRCookieActionKeys) {
    GDPRCookieActionKeys["SET_IS_DISPLAYED"] = "@@GDPRCookieAction/SET_IS_DISPLAYED";
})(GDPRCookieActionKeys || (GDPRCookieActionKeys = {}));
var closeGDPRBanner = function () {
    return function (dispatch) {
        dispatch({
            type: GDPRCookieActionKeys.SET_IS_DISPLAYED,
            isDisplayed: false,
        });
    };
};
var openGDPRBanner = function () {
    return function (dispatch) {
        dispatch({
            type: GDPRCookieActionKeys.SET_IS_DISPLAYED,
            isDisplayed: true,
        });
    };
};



/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return proposalStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _a;



var ITEMS_PER_PAGE = 20;
var SortOn;
(function (SortOn) {
    SortOn["TYPE"] = "TYPE";
    SortOn["LABEL"] = "LABEL";
    SortOn["SENT"] = "SENT";
    SortOn["READ"] = "READ";
    SortOn["OPENED"] = "OPENED";
})(SortOn || (SortOn = {}));
var proposalStatusInitialState = __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ProposalStatus.SEEN;
var paginatorInitialState = {
    itemsPerPage: ITEMS_PER_PAGE,
    page: 0,
    totalPages: 1,
};
var sortInitialState = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ProposalStatus.SEEN] = { sortOn: SortOn.OPENED, ascending: false },
    _a[__WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ProposalStatus.SENT] = { sortOn: SortOn.SENT, ascending: false },
    _a);
// only combination of item's globalId and sendingDate is guaranteed to be unique
// because one item can be sent several times
var getItemId = function (_a) {
    var globalId = _a.globalId, sendingDate = _a.sendingDate;
    return (globalId + "-" + sendingDate);
};
var isLoading = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SET_IS_LOADING:
            return action.isLoading;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].RESET:
            return false;
        default:
            return state;
    }
};
var proposalStatus = function (state, action) {
    if (state === void 0) { state = proposalStatusInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SET_PROPOSAL_STATUS:
            return action.status;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].RESET:
            return proposalStatusInitialState;
        default:
            return state;
    }
};
var paginator = function (state, action) {
    if (state === void 0) { state = paginatorInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SET_PAGINATOR_DATA:
            return __assign({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].RESET:
            return paginatorInitialState;
        default:
            return state;
    }
};
var byId = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].ADD_PAGE:
            return __assign({}, state, action.list.reduce(function (byId, item) {
                var id = getItemId(item);
                byId[id] = item;
                return byId;
            }, {}));
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SET_NEW_PAGE:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].RESET:
            return {};
        default:
            return state;
    }
};
var allIds = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].ADD_PAGE:
            return __spread(state, action.list.map(getItemId));
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SET_NEW_PAGE:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].RESET:
            return [];
        default:
            return state;
    }
};
var sort = function (state, action) {
    if (state === void 0) { state = sortInitialState[proposalStatusInitialState]; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SORT:
            return action.sort;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].SET_PROPOSAL_STATUS:
            return sortInitialState[action.status];
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* ProposalStatsActionKeys */].RESET:
            return sortInitialState[proposalStatusInitialState];
        default:
            return state;
    }
};
var proposalStats = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    isLoading: isLoading,
    proposalStatus: proposalStatus,
    paginator: paginator,
    byId: byId,
    allIds: allIds,
    sort: sort,
});


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_COOKIE_URLS; });
var DEFAULT_COOKIE_URLS = {
    ca_ES: 'https://webpublication.es/cookies',
    de_DE: 'https://webpublication.co.uk/cookies',
    en_UK: 'https://webpublication.co.uk/cookies',
    es_ES: 'https://webpublication.es/cookies',
    fr_FR: 'https://webpublication.fr/cookies',
    it_IT: 'https://webpublication.co.uk/cookies',
    pt_PT: 'https://webpublication.co.uk/cookies',
};



/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandlerRole; });
var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchesType;
function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }

  return Array.isArray(targetType) ? targetType.some(function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strictEquality */
/* harmony export (immutable) */ __webpack_exports__["b"] = areCoordsEqual;
/* harmony export (immutable) */ __webpack_exports__["a"] = areArraysEqual;
var strictEquality = function strictEquality(a, b) {
  return a === b;
};
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */

function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */

function areArraysEqual(a, b) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;

  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; ++i) {
    if (!isEqual(a[i], b[i])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL; });
/* harmony export (immutable) */ __webpack_exports__["c"] = areDirty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_utils__ = __webpack_require__(145);

var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */

function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }

  if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
    return true;
  }

  var commonIds = Object(__WEBPACK_IMPORTED_MODULE_0__js_utils__["b" /* intersection */])(handlerIds, dirtyIds);
  return commonIds.length > 0;
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMonitorOutput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useIsomorphicLayoutEffect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useCollector__ = __webpack_require__(520);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function useMonitorOutput(monitor, collect, onCollect) {
  var _useCollector = Object(__WEBPACK_IMPORTED_MODULE_1__useCollector__["a" /* useCollector */])(monitor, collect, onCollect),
      _useCollector2 = _slicedToArray(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  Object(__WEBPACK_IMPORTED_MODULE_0__useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function subscribeToMonitorStateChange() {
    var handlerId = monitor.getHandlerId();

    if (handlerId == null) {
      return undefined;
    }

    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [handlerId]
    });
  }, [monitor, updateCollected]);
  return collected;
}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCollector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_shallowequal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useIsomorphicLayoutEffect__ = __webpack_require__(146);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */

function useCollector(monitor, collect, onUpdate) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(function () {
    return collect(monitor);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      collected = _useState2[0],
      setCollected = _useState2[1];

  var updateCollected = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function () {
    var nextValue = collect(monitor);

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_shallowequal__["a" /* shallowEqual */])(collected, nextValue)) {
      setCollected(nextValue);

      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]); // update the collected properties after the first render
  // and the components are attached to dnd-core

  Object(__WEBPACK_IMPORTED_MODULE_2__useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(updateCollected, []);
  return [collected, updateCollected];
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragSourceMonitorImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl =
/*#__PURE__*/
function () {
  function DragSourceMonitorImpl(manager) {
    _classCallCheck(this, DragSourceMonitorImpl);

    this.sourceId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass(DragSourceMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      if (!this.sourceId) {
        return false;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DragSourceMonitorImpl;
}();

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SourceConnector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapConnectorHooks__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isRef__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__react_dnd_shallowequal__ = __webpack_require__(181);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var SourceConnector =
/*#__PURE__*/
function () {
  function SourceConnector(backend) {
    var _this = this;

    _classCallCheck(this, SourceConnector);

    this.hooks = Object(__WEBPACK_IMPORTED_MODULE_0__wrapConnectorHooks__["a" /* default */])({
      dragSource: function dragSource(node, options) {
        _this.clearDragSource();

        _this.dragSourceOptions = options || null;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_isRef__["a" /* isRef */])(node)) {
          _this.dragSourceRef = node;
        } else {
          _this.dragSourceNode = node;
        }

        _this.reconnectDragSource();
      },
      dragPreview: function dragPreview(node, options) {
        _this.clearDragPreview();

        _this.dragPreviewOptions = options || null;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_isRef__["a" /* isRef */])(node)) {
          _this.dragPreviewRef = node;
        } else {
          _this.dragPreviewNode = node;
        }

        _this.reconnectDragPreview();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dragSourceRef = null;
    this.dragSourceOptionsInternal = null; // The drag preview may either be attached via ref or connect function

    this.dragPreviewRef = null;
    this.dragPreviewOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDragSource = null;
    this.lastConnectedDragSourceOptions = null;
    this.lastConnectedDragPreview = null;
    this.lastConnectedDragPreviewOptions = null;
    this.backend = backend;
  }

  _createClass(SourceConnector, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (this.handlerId === newHandlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      this.reconnectDragSource();
      this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function reconnectDragSource() {
      var dragSource = this.dragSource; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();

      if (didChange) {
        this.disconnectDragSource();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragSource) {
        this.lastConnectedDragSource = dragSource;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragSource = dragSource;
        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function reconnectDragPreview() {
      var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();

      if (!this.handlerId) {
        this.disconnectDragPreview();
      } else if (this.dragPreview && didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragPreview = dragPreview;
        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
        this.disconnectDragPreview();
        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function didConnectedDragSourceChange() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function didConnectedDragPreviewChange() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function didDragSourceOptionsChange() {
      return !Object(__WEBPACK_IMPORTED_MODULE_2__react_dnd_shallowequal__["a" /* shallowEqual */])(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function didDragPreviewOptionsChange() {
      return !Object(__WEBPACK_IMPORTED_MODULE_2__react_dnd_shallowequal__["a" /* shallowEqual */])(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function disconnectDragSource() {
      if (this.dragSourceUnsubscribe) {
        this.dragSourceUnsubscribe();
        this.dragSourceUnsubscribe = undefined;
      }
    }
  }, {
    key: "disconnectDragPreview",
    value: function disconnectDragPreview() {
      if (this.dragPreviewUnsubscribe) {
        this.dragPreviewUnsubscribe();
        this.dragPreviewUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "clearDragSource",
    value: function clearDragSource() {
      this.dragSourceNode = null;
      this.dragSourceRef = null;
    }
  }, {
    key: "clearDragPreview",
    value: function clearDragPreview() {
      this.dragPreviewNode = null;
      this.dragPreviewRef = null;
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function get() {
      return this.dragSourceOptionsInternal;
    },
    set: function set(options) {
      this.dragSourceOptionsInternal = options;
    }
  }, {
    key: "dragPreviewOptions",
    get: function get() {
      return this.dragPreviewOptionsInternal;
    },
    set: function set(options) {
      this.dragPreviewOptionsInternal = options;
    }
  }, {
    key: "dragSource",
    get: function get() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function get() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }]);

  return SourceConnector;
}();

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapConnectorHooks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cloneWithRef__ = __webpack_require__(1116);



function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';
  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
      // <div ref={node => connectDragSource(connectDropTarget(node))}/>

      return node;
    } // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.


    var element = elementOrNode;
    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_cloneWithRef__["a" /* cloneWithRef */])(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};
  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key]; // ref objects should be passed straight through without wrapping

    if (key.endsWith('Ref')) {
      wrappedHooks[key] = hooks[key];
    } else {
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    }
  });
  return wrappedHooks;
}

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRef;
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isRef(obj) {
  return (// eslint-disable-next-line no-prototype-builtins
    obj !== null && _typeof(obj) === 'object' && obj.hasOwnProperty('current')
  );
}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TargetConnector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_shallowequal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapConnectorHooks__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isRef__ = __webpack_require__(524);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var TargetConnector =
/*#__PURE__*/
function () {
  function TargetConnector(backend) {
    var _this = this;

    _classCallCheck(this, TargetConnector);

    this.hooks = Object(__WEBPACK_IMPORTED_MODULE_1__wrapConnectorHooks__["a" /* default */])({
      dropTarget: function dropTarget(node, options) {
        _this.clearDropTarget();

        _this.dropTargetOptions = options;

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_isRef__["a" /* isRef */])(node)) {
          _this.dropTargetRef = node;
        } else {
          _this.dropTargetNode = node;
        }

        _this.reconnect();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dropTargetRef = null;
    this.dropTargetOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDropTarget = null;
    this.lastConnectedDropTargetOptions = null;
    this.backend = backend;
  }

  _createClass(TargetConnector, [{
    key: "reconnect",
    value: function reconnect() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();

      if (didChange) {
        this.disconnectDropTarget();
      }

      var dropTarget = this.dropTarget;

      if (!this.handlerId) {
        return;
      }

      if (!dropTarget) {
        this.lastConnectedDropTarget = dropTarget;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDropTarget = dropTarget;
        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (newHandlerId === this.handlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function didDropTargetChange() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function didOptionsChange() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_shallowequal__["a" /* shallowEqual */])(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function disconnectDropTarget() {
      if (this.unsubscribeDropTarget) {
        this.unsubscribeDropTarget();
        this.unsubscribeDropTarget = undefined;
      }
    }
  }, {
    key: "clearDropTarget",
    value: function clearDropTarget() {
      this.dropTargetRef = null;
      this.dropTargetNode = null;
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dropTarget;
    }
  }, {
    key: "dropTargetOptions",
    get: function get() {
      return this.dropTargetOptionsInternal;
    },
    set: function set(options) {
      this.dropTargetOptionsInternal = options;
    }
  }, {
    key: "dropTarget",
    get: function get() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }]);

  return TargetConnector;
}();

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropTargetMonitorImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


var isCallingCanDrop = false;
var DropTargetMonitorImpl =
/*#__PURE__*/
function () {
  function DropTargetMonitorImpl(manager) {
    _classCallCheck(this, DropTargetMonitorImpl);

    this.targetId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass(DropTargetMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      // Cut out early if the target id has not been set. This should prevent errors
      // where the user has an older version of dnd-core like in
      // https://github.com/react-dnd/react-dnd/issues/1310
      if (!this.targetId) {
        return false;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: "isOver",
    value: function isOver(options) {
      if (!this.targetId) {
        return false;
      }

      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DropTargetMonitorImpl;
}();

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decorateHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js_utils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__disposables__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(147);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }









function decorateHandler(_ref) {
  var DecoratedComponent = _ref.DecoratedComponent,
      createHandler = _ref.createHandler,
      createMonitor = _ref.createMonitor,
      createConnector = _ref.createConnector,
      registerHandler = _ref.registerHandler,
      containerDisplayName = _ref.containerDisplayName,
      getType = _ref.getType,
      collect = _ref.collect,
      options = _ref.options;
  var _options$arePropsEqua = options.arePropsEqual,
      arePropsEqual = _options$arePropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__["a" /* shallowEqual */] : _options$arePropsEqua;
  var Decorated = DecoratedComponent;
  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

  var DragDropContainer =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DragDropContainer, _React$Component);

    function DragDropContainer(props) {
      var _this;

      _classCallCheck(this, DragDropContainer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DragDropContainer).call(this, props));
      _this.decoratedRef = __WEBPACK_IMPORTED_MODULE_0_react__["createRef"]();

      _this.handleChange = function () {
        var nextState = _this.getCurrentState();

        if (!Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__["a" /* shallowEqual */])(nextState, _this.state)) {
          _this.setState(nextState);
        }
      };

      _this.disposable = new __WEBPACK_IMPORTED_MODULE_6__disposables__["c" /* SerialDisposable */]();

      _this.receiveProps(props);

      _this.dispose();

      return _this;
    }

    _createClass(DragDropContainer, [{
      key: "getHandlerId",
      value: function getHandlerId() {
        return this.handlerId;
      }
    }, {
      key: "getDecoratedComponentInstance",
      value: function getDecoratedComponentInstance() {
        Object(__WEBPACK_IMPORTED_MODULE_2__react_dnd_invariant__["a" /* invariant */])(this.decoratedRef.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
        return this.decoratedRef.current;
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !arePropsEqual(nextProps, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__["a" /* shallowEqual */])(nextState, this.state);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.disposable = new __WEBPACK_IMPORTED_MODULE_6__disposables__["c" /* SerialDisposable */]();
        this.currentType = undefined;
        this.receiveProps(this.props);
        this.handleChange();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!arePropsEqual(this.props, prevProps)) {
          this.receiveProps(this.props);
          this.handleChange();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.dispose();
      }
    }, {
      key: "receiveProps",
      value: function receiveProps(props) {
        if (!this.handler) {
          return;
        }

        this.handler.receiveProps(props);
        this.receiveType(getType(props));
      }
    }, {
      key: "receiveType",
      value: function receiveType(type) {
        if (!this.handlerMonitor || !this.manager || !this.handlerConnector) {
          return;
        }

        if (type === this.currentType) {
          return;
        }

        this.currentType = type;

        var _registerHandler = registerHandler(type, this.handler, this.manager),
            _registerHandler2 = _slicedToArray(_registerHandler, 2),
            handlerId = _registerHandler2[0],
            unregister = _registerHandler2[1];

        this.handlerId = handlerId;
        this.handlerMonitor.receiveHandlerId(handlerId);
        this.handlerConnector.receiveHandlerId(handlerId);
        var globalMonitor = this.manager.getMonitor();
        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
          handlerIds: [handlerId]
        });
        this.disposable.setDisposable(new __WEBPACK_IMPORTED_MODULE_6__disposables__["a" /* CompositeDisposable */](new __WEBPACK_IMPORTED_MODULE_6__disposables__["b" /* Disposable */](unsubscribe), new __WEBPACK_IMPORTED_MODULE_6__disposables__["b" /* Disposable */](unregister)));
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.disposable.dispose();

        if (this.handlerConnector) {
          this.handlerConnector.receiveHandlerId(null);
        }
      }
    }, {
      key: "getCurrentState",
      value: function getCurrentState() {
        if (!this.handlerConnector) {
          return {};
        }

        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor, this.props);

        if (false) {
          invariant(isPlainObject(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
        }

        return nextState;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__index__["a" /* DndContext */].Consumer, null, function (_ref2) {
          var dragDropManager = _ref2.dragDropManager;

          _this2.receiveDragDropManager(dragDropManager);

          if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(function () {
              return _this2.handlerConnector.reconnect();
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Decorated, Object.assign({}, _this2.props, _this2.getCurrentState(), {
            // NOTE: if Decorated is a Function Component, decoratedRef will not be populated unless it's a refforwarding component.
            ref: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* isRefable */])(Decorated) ? _this2.decoratedRef : null
          }));
        });
      }
    }, {
      key: "receiveDragDropManager",
      value: function receiveDragDropManager(dragDropManager) {
        if (this.manager !== undefined) {
          return;
        }

        Object(__WEBPACK_IMPORTED_MODULE_2__react_dnd_invariant__["a" /* invariant */])(dragDropManager !== undefined, 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to render a DndProvider component in your top-level component. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

        if (dragDropManager === undefined) {
          return;
        }

        this.manager = dragDropManager;
        this.handlerMonitor = createMonitor(dragDropManager);
        this.handlerConnector = createConnector(dragDropManager.getBackend());
        this.handler = createHandler(this.handlerMonitor, this.decoratedRef);
      }
    }]);

    return DragDropContainer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  DragDropContainer.DecoratedComponent = DecoratedComponent;
  DragDropContainer.displayName = "".concat(containerDisplayName, "(").concat(displayName, ")");
  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(DragDropContainer, DecoratedComponent);
}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(198);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidType;
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isValidType(type, allowArray) {
  return typeof type === 'string' || _typeof(type) === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
    return isValidType(t, false);
  });
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HTML5Backend__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NativeTypes__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getEmptyImage__ = __webpack_require__(1136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__getEmptyImage__["a"]; });
/* unused harmony reexport NativeTypes */





var createBackend = function createBackend(manager, context) {
  return new __WEBPACK_IMPORTED_MODULE_0__HTML5Backend__["a" /* default */](manager, context);
};

/* harmony default export */ __webpack_exports__["a"] = (createBackend);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/* harmony export (immutable) */ __webpack_exports__["c"] = without;
/* harmony export (immutable) */ __webpack_exports__["b"] = union;
// cheap lodash replacements
function memoize(fn) {
  var result = null;

  var memoized = function memoized() {
    if (result == null) {
      result = fn();
    }

    return result;
  };

  return memoized;
}
/**
 * drop-in replacement for _.without
 */

function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
function union(itemsA, itemsB) {
  var set = new Set();

  var insertItem = function insertItem(item) {
    return set.add(item);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  set.forEach(function (key) {
    return result.push(key);
  });
  return result;
}

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFirefox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSafari; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js_utils__ = __webpack_require__(531);

var isFirefox = Object(__WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["a" /* memoize */])(function () {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = Object(__WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["a" /* memoize */])(function () {
  return Boolean(window.safari);
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventShouldStartDrag;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventShouldEndDrag;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTouchEvent;
// Used for MouseEvent.buttons (note the s on the end).
var MouseButtons = {
  Left: 1,
  Right: 2,
  Center: 4
}; // Used for e.button (note the lack of an s on the end).

var MouseButton = {
  Left: 0,
  Center: 1,
  Right: 2
};
/**
 * Only touch events and mouse events where the left button is pressed should initiate a drag.
 * @param {MouseEvent | TouchEvent} e The event
 */

function eventShouldStartDrag(e) {
  // For touch events, button will be undefined. If e.button is defined,
  // then it should be MouseButton.Left.
  return e.button === undefined || e.button === MouseButton.Left;
}
/**
 * Only touch events and mouse events where the left mouse button is no longer held should end a drag.
 * It's possible the user mouse downs with the left mouse button, then mouse down and ups with the right mouse button.
 * We don't want releasing the right mouse button to end the drag.
 * @param {MouseEvent | TouchEvent} e The event
 */

function eventShouldEndDrag(e) {
  // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
  // bit field unset if the left mouse button has been released
  return e.buttons === undefined || (e.buttons & MouseButtons.Left) === 0;
}
function isTouchEvent(e) {
  return !!e.targetTouches;
}

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dnd_multi_backend__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_dnd_multi_backend__["c"]; });
/* unused harmony reexport HTML5DragTransition */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_dnd_multi_backend__["b"]; });
/* unused harmony reexport MouseTransition */
/* unused harmony reexport createTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preview__ = __webpack_require__(1147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Preview__["a"]; });



/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transitions__ = __webpack_require__(1144);
/* unused harmony reexport HTML5DragTransition */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Transitions__["a"]; });
/* unused harmony reexport MouseTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createTransition__ = __webpack_require__(536);
/* unused harmony reexport createTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultiBackend__ = __webpack_require__(1145);
/* unused harmony reexport MultiBackend */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__MultiBackend__["a"]; });




/* harmony default export */ __webpack_exports__["c"] = (function (manager, context, options) {
  return new __WEBPACK_IMPORTED_MODULE_2__MultiBackend__["b" /* default */](manager, context, options);
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (event, check) {
  return {
    _isMBTransition: true,
    event: event,
    check: check
  };
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PostMessageTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PostMessageAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApiEvents__ = __webpack_require__(1154);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var PostMessageTarget;
(function (PostMessageTarget) {
    PostMessageTarget["GallApp"] = "GallApp";
})(PostMessageTarget || (PostMessageTarget = {}));
var PostMessageAction;
(function (PostMessageAction) {
    PostMessageAction["Authentication"] = "authentication";
    PostMessageAction["GoTo"] = "goTo";
    PostMessageAction["OpenDriveItem"] = "openDriveItem";
    PostMessageAction["SwitchLocale"] = "switchLocale";
    PostMessageAction["ToggleSelection"] = "toggleSelection";
    PostMessageAction["GetSelection"] = "getSelection";
})(PostMessageAction || (PostMessageAction = {}));
var ReaderApi = /** @class */ (function () {
    function ReaderApi() {
        this.listeners = [];
        this.listenersBind = [];
        this.tasks = [];
        this.actionReceiver = this.actionReceiver.bind(this);
        this.apiEvents = new __WEBPACK_IMPORTED_MODULE_1__ApiEvents__["a" /* ApiEvents */]();
    }
    ReaderApi.prototype.init = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.ApiReadyResolve = resolve;
            _this.ApiReadyReject = reject;
        });
        this.addListener('getConnection', function (data) {
            data.resolve();
            _this.ApiReadyResolve(data);
        });
        this.requestConnection();
        this.addMessageListeners();
        return promise;
    };
    ReaderApi.prototype.call = function (task, args) {
        var _this = this;
        var taskObjectMessage, taskObject, promise;
        taskObjectMessage = {
            task: task,
            arguments: args,
            id: getGlobalTaskID(),
            type: 'call',
            responseType: 'resolve',
            responseValue: '',
            resolve: null,
            reject: null,
        };
        promise = new Promise(function (resolve, reject) {
            taskObject = __assign({}, taskObjectMessage, { resolve: resolve, reject: reject });
            _this.tasks.push(taskObject);
        });
        this.postMessage(taskObjectMessage);
        return promise;
    };
    ReaderApi.prototype.addListener = function (name, callBack) {
        var _callBack = function (event) {
            callBack(event.data);
        };
        this.listeners.push(callBack);
        this.listenersBind.push(_callBack);
        this.apiEvents.addListener(name, _callBack);
    };
    ReaderApi.prototype.removeListener = function (name, callBack) {
        var listeners = this.listeners;
        var listenersBind = this.listenersBind;
        this.listeners = [];
        this.listenersBind = [];
        for (var i = 0, len = listeners.length; i < len; i++) {
            if (listeners[i] === callBack) {
                this.apiEvents.removeListener(name, listenersBind[i]);
                continue;
            }
            this.listeners.push(listeners[i]);
            this.listenersBind.push(listenersBind[i]);
        }
    };
    ReaderApi.prototype.flush = function () {
        this.removeMessageListeners();
    };
    ReaderApi.prototype.responseCall = function (taskObject) {
        this.postMessage(__assign({}, taskObject, { resolve: null, reject: null, type: 'response' }));
    };
    ReaderApi.prototype.dispatchEvent = function (data) {
        this.apiEvents.fire({
            type: data.task, data: {
                arguments: data.arguments,
                resolve: data.resolve,
                reject: data.reject
            }
        });
    };
    ReaderApi.prototype.postMessage = function (taskObject) {
        if (isSameWindow(window, window.parent) === true) {
            this.ApiReadyReject('there is no child or parent window');
            return;
        }
        window.parent.postMessage(taskObject, '*');
    };
    ReaderApi.prototype.requestConnection = function () {
        var _this = this;
        this.call('getConnection', 'Reader try to make connection with backoffice').then(function (data) {
            _this.ApiReadyResolve(data);
        });
    };
    ReaderApi.prototype.addMessageListeners = function () {
        window.addEventListener('message', this.actionReceiver, false);
    };
    ReaderApi.prototype.removeMessageListeners = function () {
        window.removeEventListener('message', this.actionReceiver, false);
    };
    ReaderApi.prototype.actionReceiver = function (event) {
        var _this = this;
        var tasksLength, promise, data;
        if (!isSameWindow(window.parent, event.source) || (event.data instanceof Object) === false) {
            return;
        }
        data = event.data;
        tasksLength = this.tasks.length;
        this.tasks = this.tasks.filter(function (taskObject) {
            if (taskObject.id !== data.id) {
                return taskObject;
            }
            if (data.responseType === 'resolve') {
                taskObject.resolve(data.arguments);
            }
            else {
                taskObject.reject(data.responseValue);
            }
            return undefined;
        });
        // true, means no change in tasks and it's called from Reader
        if (tasksLength === this.tasks.length) {
            if (data.type === 'response') {
                return;
            }
            promise = new Promise(function (resolve, reject) {
                data.resolve = resolve;
                data.reject = reject;
            });
            promise.then(function (e) {
                data.arguments = e;
                data.responseType = 'resolve';
                data.responseValue = '';
                _this.responseCall(data);
            }).catch(function (e) {
                data.arguments = [];
                data.responseType = 'reject';
                data.responseValue = e;
                _this.responseCall(data);
            });
            this.dispatchEvent(data);
        }
    };
    return ReaderApi;
}());
var getGlobalTaskID = function () {
    var id = 0;
    return function () {
        return 'reader-' + (id++) + Date.now();
    };
}();
// Utils
function isSameWindow(registeredWindow, messageSource) {
    return registeredWindow === messageSource;
}
/* harmony default export */ __webpack_exports__["c"] = (ReaderApi);


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_UserAvatar__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfilePage_selectors__ = __webpack_require__(95);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var _a = state.profile.userAvatar.config, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    return __assign({}, ownProps, { imageSrc: Object(__WEBPACK_IMPORTED_MODULE_2__ProfilePage_selectors__["a" /* getAvatarUrl */])(state), x: x,
        y: y,
        width: width,
        height: height });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_UserAvatar__["a" /* default */]));


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__ = __webpack_require__(120);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var getScale = function (size) { return size / __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG; };
var Image = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: ", ";\n\theight: ", ";\n\tmargin-right: 15px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\toverflow: hidden;\n\n\timg {\n\t\tposition: absolute;\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\ttransform: translate(", ");\n\t}\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"], ["\n\tposition: relative;\n\tflex: ", ";\n\theight: ", ";\n\tmargin-right: 15px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\toverflow: hidden;\n\n\timg {\n\t\tposition: absolute;\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\ttransform: translate(", ");\n\t}\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"])), function (_a) {
    var size = _a.size;
    return "0 0 " + size + "px";
}, function (_a) {
    var size = _a.size;
    return size + "px";
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey100, function (_a) {
    var width = _a.width, size = _a.size;
    return width * getScale(size) + "px";
}, function (_a) {
    var height = _a.height, size = _a.size;
    return height * getScale(size) + "px";
}, function (_a) {
    var x = _a.x, y = _a.y, size = _a.size;
    return x * getScale(size) + "px, " + y * getScale(size) + "px";
});

var templateObject_1;


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_UserInfo__ = __webpack_require__(1176);


var mapStateToProps = function (state) {
    var _a = state.profile, name = _a.name, email = _a.email, position = _a.position, phone = _a.phone;
    return {
        name: name,
        email: email,
        position: position,
        phone: phone,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_UserInfo__["a" /* default */]));


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ButtonCreate__ = __webpack_require__(1178);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_ButtonCreate__["a" /* default */]));


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ButtonCreateNote__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_menuManager__ = __webpack_require__(54);



var mapStateToProps = function (state, ownProps) {
    var isOpened = state.notes.editor.isOpened, config = state.galleryInfos.config, _a = state.driveList, driveItems = _a.driveItems, resolutions = _a.resolutions, thumbMap = state.offlineManager.thumbMap;
    var icon = ownProps.icon;
    return {
        iconSrc: Object(__WEBPACK_IMPORTED_MODULE_2__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveItems, config, thumbMap, resolutions),
        isActive: isOpened,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ButtonCreateNote__["a" /* default */]));


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BackToPublication__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_menuManager__ = __webpack_require__(54);



var mapStateToProps = function (state, ownProps) {
    var _a = state.backToPublication, publicationId = _a.publicationId, page = _a.page, config = state.galleryInfos.config, _b = state.driveList, driveItems = _b.driveItems, resolutions = _b.resolutions, thumbMap = state.offlineManager.thumbMap;
    var icon = ownProps.icon;
    return {
        publicationId: publicationId,
        page: page,
        iconSrc: Object(__WEBPACK_IMPORTED_MODULE_2__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveItems, config, thumbMap, resolutions),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_BackToPublication__["a" /* default */]));


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Authentication__ = __webpack_require__(1188);


var mapStateToProps = function (state) {
    return {
        authentication: state.authentication,
        galleryInfos: state.galleryInfos,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Authentication__["a" /* default */]));


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Container = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmax-height: 110px;\n\tborder-bottom: solid 1px ", ";\n\tpadding: 10px 15px;\n\tfont-size: 13px;\n\toverflow: auto;\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: flex-start;\n\talign-content: flex-start;\n"], ["\n\tmax-height: 110px;\n\tborder-bottom: solid 1px ", ";\n\tpadding: 10px 15px;\n\tfont-size: 13px;\n\toverflow: auto;\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: flex-start;\n\talign-content: flex-start;\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 8); });
var Content = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 150px;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tcolor: ", ";\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tmargin: 10px 30px 10px 0;\n"], ["\n\twidth: 150px;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tcolor: ", ";\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tmargin: 10px 30px 10px 0;\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 75); });

var templateObject_1, templateObject_2;


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DriveListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EmptyFolderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TitleBlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HeaderWithBorder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t", "\n\n\t", "\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var backgroundColor = _a.theme.primary.backgroundColor;
    return backgroundColor !== 'transparent' ? backgroundColor : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White;
}, function (props) { return props.theme.primary.strongColor; }, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var Header = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 0 0 50px;\n\n\t", "\n\n\t", "\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 0 0 50px;\n\n\t",
    "\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var HeaderWithBorder = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 0 0 50px;\n\tpadding: 0 12px;\n\tborder-bottom: 1px solid ", ";\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 0 0 50px;\n\tpadding: 0 12px;\n\tborder-bottom: 1px solid ", ";\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey250, 100), __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "padding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";");
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 15px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t", "\n\n\t", "\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 15px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.primary.actionColor;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\topacity: 0.5;\n\t\tpointer-events: none;\n\t";
}, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\ttop: " + (parseInt(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */], 10) + 15) + "px;\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\ttop: " + (parseInt(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */], 10) + 15) + "px;\n\t\t}\n\t");
var ButtonCancel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tleft: 20px;\n"], ["\n\tleft: 20px;\n"])));
var ButtonConfirm = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tright: 20px;\n"], ["\n\tright: 20px;\n"])));
var DriveListWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 1;\n\tdisplay: flex;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"], ["\n\tposition: relative;\n\tflex: 1;\n\tdisplay: flex;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"])));
var EmptyFolderLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n"])));
var TitleBlack = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tmargin-left: 12px;\n\tmargin-right: auto;\n\tpadding-right: 6px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 600;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tmargin-left: 12px;\n\tmargin-right: auto;\n\tpadding-right: 6px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 600;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black);
var ButtonClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 35px;\n\twidth: 35px;\n\theight: 35px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tmargin-left: 12px;\n\n\t", "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 35px;\n\twidth: 35px;\n\theight: 35px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tmargin-left: 12px;\n\n\t",
    "\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey200, function (_a) {
    var color = _a.color;
    return color || __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey200;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
}, function (_a) {
    var iconWidth = _a.iconWidth;
    return iconWidth;
}, function (_a) {
    var iconHeight = _a.iconHeight;
    return iconHeight;
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);




var ITEMS_TO_DISPLAY_DOTS = 3;
var getLabel = function (label, shouldDisplayDots) { return (shouldDisplayDots ? '...' : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label })); };
var Breadcrumbs = function (_a) {
    var items = _a.items, onItemClick = _a.onItemClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* List */], null, items.map(function (_a, index) {
        var id = _a.id, label = _a.label;
        var isLast = index === items.length - 1;
        var indexToDisplayDots = items.length - ITEMS_TO_DISPLAY_DOTS;
        var isHidden = index > 0 && index < indexToDisplayDots;
        var shouldDisplayDots = index > 0 && index === indexToDisplayDots;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ListItem */], { key: id, hidden: isHidden },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { type: "button", disabled: isLast, onClick: function () { return onItemClick(id, label); } }, getLabel(label, shouldDisplayDots)),
            !isLast && __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_forth')));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (Breadcrumbs);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledDriveItemSelectionIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectionClearerButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledDriveItemSelectionIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\tmargin: 0;\n\t", "\n\t", "\n\n\t& > svg {\n\t\t", "\n\t\tpadding-bottom: ", ";\n\n\t\tfill: ", ";\n\n\t\tstroke: ", ";\n\t\tstroke-width: 1px;\n\t}\n"], ["\n\t", ";\n\tmargin: 0;\n\t",
    "\n\t",
    "\n\n\t& > svg {\n\t\t", "\n\t\tpadding-bottom: ", ";\n\n\t\tfill: ",
    ";\n\n\t\tstroke: ", ";\n\t\tstroke-width: 1px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["g" /* navBarButtonWrapperStyle */], function (props) { return props.isCard &&
    "position: absolute;"; }, function (props) { return props.isRowView
    ? "bottom: 8px;\n\t\tleft: 8px;"
    : "bottom: 15px;\n\t\tleft: 15px;"; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["i" /* navBarIconStyle */], function (props) { return props.needBottomPadding ? '4px' : '0px'; }, function (props) { return props.isInSelection
    ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.fillColor, 80) + "!important"
    : "" + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.fillColor, 80); }, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 40));
var SelectionClearerButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcursor: pointer;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tletter-spacing: 1.2px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n"], ["\n\tcursor: pointer;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tletter-spacing: 1.2px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n"])), function (props) { return props.theme.primary.actionColor; });

var templateObject_1, templateObject_2;


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListItem_ActionButton__ = __webpack_require__(1245);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_ListItem_ActionButton__["a" /* default */]));


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemContextualMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var ItemContextualMenu = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\t", "\n\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t> g > circle {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: absolute;\n\t",
    "\n\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t> g > circle {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"])), function (props) { return props.isRowView ?
    "bottom: 10px;\n\t\tright: 11px;\n\t\tz-index: 3;"
    :
        "bottom: 25px;\n\t\tright: 7px;"; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);

var templateObject_1;


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(553);



var ListItemDownloadStatus = function (_a) {
    var isUpToDate = _a.isUpToDate, isUpdatable = _a.isUpdatable, isRowView = _a.isRowView, isDownloading = _a.isDownloading;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* DownloadStatus */], { isRowView: isRowView }, getStatusElement(isUpToDate, isUpdatable, isDownloading ? isDownloading : false)));
};
var getStatusElement = function (isUpToDate, isUpdatable, isDownloading) {
    if ((!isUpToDate && !isUpdatable) || isDownloading) {
        return null;
    }
    return isUpToDate
        ? __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_check-circle')
        : __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_refresh');
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemDownloadStatus);


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var DownloadStatus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\n\t> svg {\n\t\tvertical-align: bottom;\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n"], ["\n\t",
    "\n\n\t> svg {\n\t\tvertical-align: bottom;\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n"])), function (props) { return props.isRowView
    ? "\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\tbottom: 18px;\n\t\t"
    : "\n\t\t\tdisplay:inline-block;\n\t\t\tmargin-left: 10px;\n\t\t"; });

var templateObject_1;


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__ = __webpack_require__(4);





var ListItemProposalStatus = function (_a) {
    var _b = _a.stats, status = _b.status, readsNbr = _b.readsNbr;
    var color;
    var message;
    var badge;
    switch (status) {
        case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ProposalStatus.SENT:
            color = __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].Orange;
            message = 'messages.sent';
            badge = '';
            break;
        case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ProposalStatus.SEEN:
            color = __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen;
            message = 'messages.seen';
            badge = readsNbr ? ' ' + readsNbr : '';
            break;
        case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ProposalStatus.DRAFT:
        default:
            color = __WEBPACK_IMPORTED_MODULE_4__utils_styles_constants__["c" /* StyleColor */].Grey450;
            message = 'messages.draft';
            badge = '';
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ProposalStatus */], { color: color },
        '| ',
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: message }),
        badge));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemProposalStatus);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_FolderDropTarget__ = __webpack_require__(1250);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_FolderDropTarget__["a" /* default */]));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1253)


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Title__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__ = __webpack_require__(23);




var mapStateToProps = function (state) {
    var routerParamsHistory = state.routerParamsHistory, _a = state.selection, resources = _a.resources, notes = _a.notes;
    var hasClearButton = __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].currentLocationIs(routerParamsHistory, __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Selection) && resources.length + notes.length > 0;
    var hasBreadCrumbs = __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].currentLocationIs(routerParamsHistory, __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder);
    return { hasBreadCrumbs: hasBreadCrumbs, hasClearButton: hasClearButton };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Title__["a" /* default */]));


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: ", ";\n\ttext-decoration: none;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tletter-spacing: 0.5px;\n\tline-height: 30px;\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\tcolor: ", ";\n\ttext-decoration: none;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tletter-spacing: 0.5px;\n\tline-height: 30px;\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), function (props) { return props.theme.primary.strongColor; });
var PageTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(StyledTitle)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding-left: 10px;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding-left: 10px;\n\n\t", "\n"])), function (_a) {
    var hasClearButton = _a.hasClearButton;
    return hasClearButton && 'width: 100%;';
});

var templateObject_1, templateObject_2;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(__webpack_require__(1285));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDriveItemIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFetchingState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var getDriveItemIds = function (resources, _a, isValidResource, extraDriveIds, extraFilterFn) {
    var driveItems = _a.driveItems, driveItemsFetchStatus = _a.driveItemsFetchStatus;
    var filteredDriveItemIds = resources
        .filter(function (item) {
        var driveItemFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveItemsFetchStatus, item.id);
        var metaFetchStatus = driveItemFetchStatus.metaFetchStatus;
        var driveItem = __assign({}, item, { name: driveItems[item.id]
                ? driveItems[item.id].name
                : undefined, componentType: driveItems[item.id]
                ? driveItems[item.id].componentType
                : undefined, format: driveItems[item.id]
                ? driveItems[item.id].format
                : undefined });
        return (driveItem.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory || isValidResource(driveItem))
            && metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__["a" /* FetchStatus */].ERROR
            && (extraFilterFn ? extraFilterFn(driveItem) : true);
    })
        .map(function (_a) {
        var id = _a.id;
        return id;
    });
    return extraDriveIds
        ? __spread(new Set(__spread(extraDriveIds, filteredDriveItemIds))) : filteredDriveItemIds;
};
var isFetchingState = function (driveFolderId, driveItemsFetchStatus) {
    if (driveFolderId && !__WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp) {
        var driveFolderFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveItemsFetchStatus, driveFolderId);
        var contentBlocksStatus = driveFolderFetchStatus.contentBlocksStatus, metaFetchStatus = driveFolderFetchStatus.metaFetchStatus;
        if (metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__["a" /* FetchStatus */].FETCHED && metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__["a" /* FetchStatus */].ERROR) {
            return true;
        }
        var blocks = Object.keys(contentBlocksStatus);
        for (var i = 0; i < blocks.length; i++) {
            var block = blocks[i];
            var blockStatus = contentBlocksStatus[block];
            if (blockStatus === __WEBPACK_IMPORTED_MODULE_0__containers_DriveItemList_reducer__["a" /* FetchStatus */].FETCHING) {
                return true;
            }
        }
    }
    return false;
};


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel_SpreadsSelector__ = __webpack_require__(1312);


var mapStateToProps = function (state) {
    var _a = state.editor.combo, _b = _a.externalPublication, isLoading = _b.isLoading, spreads = _b.spreads, selectedSpreadIndices = _b.selection.spreadIndices, isCombining = _a.isCombining;
    return {
        isLoading: isLoading,
        isCombining: isCombining,
        spreads: spreads,
        selectedSpreadIndices: selectedSpreadIndices,
        isSelectedAll: selectedSpreadIndices.length > 0 && spreads.length === selectedSpreadIndices.length,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel_SpreadsSelector__["a" /* default */]));


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__ = __webpack_require__(9);




var config = [
    {
        icon: 'iconset_uprez_zoom_out',
        zoom: __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["o" /* ZoomType */].OUT,
    },
    {
        icon: 'iconset_uprez_zoom_fit',
        zoom: __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["o" /* ZoomType */].FIT,
    },
    {
        icon: 'iconset_uprez_zoom_in',
        zoom: __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["o" /* ZoomType */].IN,
    },
];
var ButtonZoom = function (_a) {
    var isDisabled = _a.isDisabled, onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["a" /* ButtonsGroup */], null, config.map(function (_a) {
        var icon = _a.icon, zoom = _a.zoom;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["b" /* HeaderButton */], { key: zoom, iconWidth: "35px", iconHeight: "35px", disabled: isDisabled, onClick: function () { return onClick(zoom); } }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon(icon)));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonZoom);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Inner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SelectedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconReference; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 12px;\n\tpadding-bottom: 6px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\tcursor: default !important;\n\tuser-select: none;\n\n\t", "\n\n\t", "\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 12px;\n\tpadding-bottom: 6px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\tcursor: default !important;\n\tuser-select: none;\n\n\t", "\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900;
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var isBlurred = _a.isBlurred;
    return isBlurred && 'opacity: 0.05;';
}, function (_a) {
    var type = _a.type;
    return type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ThumbnailType */].COLUMN && "\n\t\tborder-bottom: 1px solid " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900 + ";\n\t";
}, function (_a) {
    var type = _a.type, itemsInRow = _a.itemsInRow;
    return type === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ThumbnailType */].GRID && itemsInRow && "\n\t\tmargin: 0 15px;\n\t\tmargin-bottom: 7px;\n\t\tborder-radius: 4px;\n\n\t\t" + getGridItemWidth(itemsInRow) + ";\n\t";
});
var getGridItemWidth = function (itemsInRow) {
    if (itemsInRow === 'AUTO') {
        return "\n\t\t\twidth: calc(50% - 30px);\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphoneLandscape + ", " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Tablet + " {\n\t\t\t\twidth: calc(33.33% - 30px);\n\t\t\t}\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmallDesktop + " {\n\t\t\t\twidth: calc(25% - 30px);\n\t\t\t}\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].MediumDesktop + " {\n\t\t\t\twidth: calc(20% - 30px);\n\t\t\t}\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].LargeDesktop + " {\n\t\t\t\twidth: calc(16.66% - 30px);\n\t\t\t}\n\t\t";
    }
    return "width: calc(" + 100 / itemsInRow + "% - 30px)";
};
var Inner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t&:focus {\n\t\toutline: 0;\n\t}\n"], ["\n\t&:focus {\n\t\toutline: 0;\n\t}\n"])));
var SelectedNumber = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: -5px;\n\tright: -5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\tfont-weight: 700;\n\tfont-size: 10px;\n\tcolor: ", ";\n"], ["\n\tposition: absolute;\n\ttop: -5px;\n\tright: -5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\tfont-weight: 700;\n\tfont-size: 10px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600);
var iconCommonStyles = "\n\tbox-sizing: border-box;\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 50%;\n\tbox-shadow: 0 0 5px 0 " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, 12) + ";\n";
var IconEdit = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n"], ["\n\t", "\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n"])), iconCommonStyles, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White);
var IconReference = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n"], ["\n\t", "\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n"])), iconCommonStyles, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White);
var IconCheck = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\n\t", "\n"], ["\n\t", "\n\tborder: 2px solid ", ";\n\tbackground-color: ", ";\n\n\t",
    "\n"])), iconCommonStyles, function (_a) {
    var isChecked = _a.isChecked;
    return isChecked ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White;
}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey200, 20), function (_a) {
    var isChecked = _a.isChecked;
    return isChecked && "\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\twidth: 14px;\n\t\t\theight: 14px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 + ";\n\t\t}\n\t";
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__ = __webpack_require__(9);




var ImageWrapper = function (_a) {
    var thumbnailsData = _a.thumbnailsData;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Wrapper */], null, thumbnailsData.map(function (_a, index) {
        var imageSrc = _a.imageSrc;
        var side = __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["m" /* ShowAloneSide */].CENTER;
        if (thumbnailsData.length > 1) {
            side = index === 0 ? __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["m" /* ShowAloneSide */].LEFT : __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["m" /* ShowAloneSide */].RIGHT;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* default */], { key: index, imageSrc: imageSrc, side: side }));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (ImageWrapper);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1322);


var ItemInfo = function (_a) {
    var spreadIndex = _a.spreadIndex, label = _a.label;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Position */], null, spreadIndex + 1),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Label */], null, label)));
};
/* harmony default export */ __webpack_exports__["a"] = (ItemInfo);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);




var getLabel = function (percentage, error, isProcessing, processingLabel, theme) {
    if (error) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Label */], { value: "error." + error, isError: true, theme: theme }));
    }
    else if (isProcessing) {
        return processingLabel && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Label */], { value: processingLabel, theme: theme }));
    }
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* ProgressLabel */], { theme: theme },
        percentage,
        "%");
};
var ProgressBar = function (_a) {
    var percentage = _a.percentage, error = _a.error, _b = _a.theme, theme = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ResourceSelectorTheme */].LIGHT : _b, isProcessing = _a.isProcessing, processingLabel = _a.processingLabel, hasCancelButton = _a.hasCancelButton, onCancel = _a.onCancel;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* LabelWrapper */], null,
            getLabel(percentage, error, isProcessing, processingLabel, theme),
            hasCancelButton && !isProcessing &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ButtonCancel */], { type: "button", isError: !!error, theme: theme, onClick: onCancel }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_close-2'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Bar */], { isError: !!error, percentage: percentage })));
};
/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopupBodyWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceSelector_ProgressBar_styles__ = __webpack_require__(354);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var PopupBodyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-bottom: 10px;\n\n\t", " li:not(:last-child) {\n\t\tmargin-bottom: 0;\n\n\t\t", " {\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t}\n\t}\n\n\t", " {\n\t\theight: 50px;\n\t\tborder-radius: 0;\n\t\tline-height: 50px;\n\t\tcolor: ", ";\n\t}\n\n\t", " {\n\t\tmargin: 20px;\n\t}\n\n\t", " {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tmargin-bottom: 10px;\n\n\t", " li:not(:last-child) {\n\t\tmargin-bottom: 0;\n\n\t\t", " {\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t}\n\t}\n\n\t", " {\n\t\theight: 50px;\n\t\tborder-radius: 0;\n\t\tline-height: 50px;\n\t\tcolor: ", ";\n\t}\n\n\t", " {\n\t\tmargin: 20px;\n\t}\n\n\t", " {\n\t\tbackground-color: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__["b" /* ButtonsList */], __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__["a" /* Button */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__["a" /* Button */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_3__ResourceSelector_ProgressBar_styles__["f" /* Wrapper */], __WEBPACK_IMPORTED_MODULE_3__ResourceSelector_ProgressBar_styles__["a" /* Bar */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey100);

var templateObject_1;


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);





var NotificationPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, children = _a.children, dispatch = _a.dispatch;
    var popupFooter = {
        label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.back_to_login'),
        onAccept: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_actions__["k" /* signOut */])()); },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.notification'), footer: popupFooter },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* PopupBody */], null, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (NotificationPopup);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadButton__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_menuManager__ = __webpack_require__(54);




var mapStateToProps = function (state, props) {
    var galleryInfos = state.galleryInfos, downloadManager = state.downloadManager, driveList = state.driveList, thumbMap = state.offlineManager.thumbMap;
    var driveItems = props.driveItems, icon = props.icon;
    var isDeletingAll = downloadManager.isDeletingAll;
    var isDownloading = getIsDownloading(downloadManager, driveItems);
    var driveItemId = driveItems[0].id;
    var loaderStep = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getItemLoaderStep(downloadManager, driveItemId);
    return {
        galleryInfos: galleryInfos,
        isDownloading: isDownloading,
        isDeletingAll: isDeletingAll,
        loaderStep: loaderStep,
        iconSrc: Object(__WEBPACK_IMPORTED_MODULE_3__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveList.driveItems, galleryInfos.config, thumbMap, driveList.resolutions),
    };
};
var getIsDownloading = function (downloadManager, driveItems) {
    if (driveItems) {
        return driveItems.some(function (driveItem) { return __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDownloading(downloadManager, driveItem.id); });
    }
    return false;
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadButton__["a" /* default */]));


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_Search_actions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_constants__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__);







var CancelButton = function (props) {
    var handleClick = function (_a) {
        var actionOrigin = _a.actionOrigin, dispatch = _a.dispatch;
        if (actionOrigin === __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_constants__["a" /* CancelActionOrigin */].Search) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_Search_actions__["c" /* toggleSearchFieldVisibility */])());
        }
        else if (actionOrigin === __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_constants__["a" /* CancelActionOrigin */].Share) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Share_actions__["f" /* finishShare */])());
        }
        else if (props.leavePage && actionOrigin === __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_constants__["a" /* CancelActionOrigin */].Theater) {
            props.leavePage();
        }
    };
    var isInTheater = props.actionOrigin === __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_constants__["a" /* CancelActionOrigin */].Theater;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* StyledCancelButton */], { onClick: function () { return handleClick(props); }, isInTheater: isInTheater },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__["Translate"], { value: isInTheater ? 'messages.close' : 'messages.cancel' })));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(CancelButton));


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledTagsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledTag = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tmin-width: 60px;\n\tmargin: 0 10px 10px 0;\n\tpadding: 10px 20px;\n\tborder: 0;\n\tborder-radius: 20px;\n\toutline: 0;\n\tfont-size: 14px;\n\tline-height: 16px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\ttransition: background-color 0.2s, color 0.2s;\n\twhite-space: nowrap;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tmin-width: 60px;\n\tmargin: 0 10px 10px 0;\n\tpadding: 10px 20px;\n\tborder: 0;\n\tborder-radius: 20px;\n\toutline: 0;\n\tfont-size: 14px;\n\tline-height: 16px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\ttransition: background-color 0.2s, color 0.2s;\n\twhite-space: nowrap;\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey50, function (props) { return props.theme.primary.actionColor; }, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive && "\n\t\tbackground-color: " + theme.primary.actionColor + ";\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t";
});
var StyledLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin: 20px 0;\n\tfont-size: 14px;\n\tline-height: 16px;\n\tcolor: ", ";\n"], ["\n\tdisplay: block;\n\tmargin: 20px 0;\n\tfont-size: 14px;\n\tline-height: 16px;\n\tcolor: ", ";\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 50); });
var StyledTagsList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmax-height: 138px;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmax-height: 138px;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Theater */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Content__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Slider__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_statistics__ = __webpack_require__(82);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var Theater = /** @class */ (function (_super) {
    __extends(Theater, _super);
    function Theater(props) {
        var _this = _super.call(this, props) || this;
        _this.newItemId = -1;
        _this.beforeChangeSliderItem = _this.beforeChangeSliderItem.bind(_this);
        _this.afterChangeSliderItem = _this.afterChangeSliderItem.bind(_this);
        return _this;
    }
    Theater.prototype.componentDidMount = function () {
        this.initializeView(this.props);
    };
    Theater.prototype.componentWillReceiveProps = function (nextProps) {
        this.initializeView(nextProps);
    };
    Theater.prototype.render = function () {
        if (this.props.driveItemIds.length > 0) {
            var _a = this.props, driveList = _a.driveList, driveItemId = _a.driveItemId, driveItemIds = _a.driveItemIds, galleryInfos = _a.galleryInfos, leavePage = _a.leavePage;
            var resolutions = driveList.resolutions;
            var driveItem = this.driveItem;
            var driveItemIndex = driveItemIds.indexOf(driveItemId);
            var sliderSettings = this.getSliderSettings(driveItemIndex);
            var sliderChildren = this.renderTheaterContents(galleryInfos, resolutions);
            var sliderKey = this.props.sliderKey;
            if (driveItem) {
                sliderKey = this.props.sliderKey + "-" + driveItem.id;
                this.playMediaOnEnter(driveItemIndex);
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* TheaterOverlay */], null, driveItem ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* TheaterContainer */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], { leavePage: leavePage, sliderIndex: (this.sliderIndex || driveItemIndex) + 1, sliderLength: driveItemIds.length }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Slider__["a" /* default */], { shouldReRender: this.shouldSliderComponentReRender(driveItemIndex), sliderKey: sliderKey, sliderSettings: sliderSettings }, sliderChildren),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Footer__["a" /* default */], { driveItem: driveItem }))
                :
                    null));
        }
        return null;
    };
    Theater.prototype.initializeView = function (props) {
        var driveItemId = props.driveItemId, driveItemIds = props.driveItemIds, isLoading = props.isLoading, origin = props.origin;
        if (driveItemIds.length > 0) {
            if (!this.sliderIndex || driveItemIds[this.sliderIndex] !== driveItemId) {
                this.sliderIndex = driveItemIds.indexOf(driveItemId);
            }
            var dispatch = props.dispatch, folderId = props.folderId;
            if (this.props.driveItemIds.length > props.driveItemIds.length) {
                // When a drive item has been removed from the drive item list
                var oldSliderIndex = this.props.driveItemIds.indexOf(this.props.driveItemId);
                var newSliderIndex = oldSliderIndex < props.driveItemIds.length ? oldSliderIndex : oldSliderIndex - 1;
                __WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* hashHistory */].replace(__WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].getPathTheater(origin, null, props.driveItemIds[newSliderIndex]));
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__DriveItemList_actions__["i" /* fetchDriveItem */])(driveItemId, folderId));
        }
        else if (!isLoading) {
            __WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* hashHistory */].replace(__WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].getPathDriveItemListPage(origin, null));
        }
    };
    Theater.prototype.getSliderSettings = function (initialSlide) {
        return {
            dots: false,
            infinite: false,
            speed: 500,
            lazyLoad: 'ondemand',
            initialSlide: initialSlide,
            beforeChange: this.beforeChangeSliderItem,
            afterChange: this.afterChangeSliderItem,
        };
    };
    Theater.prototype.beforeChangeSliderItem = function (oldSliderIndex, newSliderIndex) {
        this.pauseMediaOnLeave(oldSliderIndex);
    };
    Theater.prototype.pauseMediaOnLeave = function (sliderIndex) {
        this.toggleSliderMedia(sliderIndex, false);
    };
    Theater.prototype.toggleSliderMedia = function (sliderIndex, shouldPlay) {
        // TODO : Find a way to do it without using document.querySelector or React.findDOMNode
        var driveItem = this.driveItemsToDisplay[sliderIndex];
        if (driveItem && (driveItem.type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Movie || driveItem.type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Sound)) {
            var mediaElementName = driveItem.type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Movie ? 'video' : 'audio';
            var mediaElementSelector = ".slick-slide[data-index='" + sliderIndex + "'] " + mediaElementName;
            var media = document.querySelector(mediaElementSelector);
            if (media) {
                if (shouldPlay) {
                    media.play();
                }
                else {
                    media.pause();
                }
            }
        }
    };
    Theater.prototype.afterChangeSliderItem = function (newSliderIndex) {
        var _a = this.props, driveItemIds = _a.driveItemIds, dispatch = _a.dispatch, folderId = _a.folderId;
        this.sliderIndex = newSliderIndex;
        this.updateHashHistoryBySliderIndex(newSliderIndex);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__DriveItemList_actions__["i" /* fetchDriveItem */])(driveItemIds[newSliderIndex], folderId))
            .then(function (response) {
            if (Object.keys(response).length > 0) { // handle case where response is {}
                var driveItem = response;
                var viewableDriveItemTypes = [
                    __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Image,
                    __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Movie,
                    __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Sound,
                ];
                if (viewableDriveItemTypes.includes(driveItem.type)) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__DriveItemList_actions__["E" /* setReadStatus */])(driveItem.id));
                    __WEBPACK_IMPORTED_MODULE_11__utils_statistics__["a" /* default */].trackView(driveItem);
                }
            }
        });
    };
    Theater.prototype.updateHashHistoryBySliderIndex = function (sliderIndex) {
        var driveItemId = this.props.driveItemId;
        var currentHash = __WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* hashHistory */].getCurrentLocation().pathname;
        this.newItemId = this.props.driveItemIds[sliderIndex];
        var newHash = currentHash.replace("/theater/" + driveItemId, "/theater/" + this.newItemId);
        __WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* hashHistory */].replace(newHash);
    };
    Theater.prototype.playMediaOnEnter = function (sliderIndex) {
        this.toggleSliderMedia(sliderIndex, true);
    };
    Theater.prototype.shouldSliderComponentReRender = function (driveItemIndex) {
        return this.isHashChangedManually(driveItemIndex) || !this.isDriveItemAlreadyLoaded();
    };
    Theater.prototype.isHashChangedManually = function (driveItemIndex) {
        return this.props.driveItemIds[driveItemIndex] !== this.newItemId;
    };
    Theater.prototype.isDriveItemAlreadyLoaded = function () {
        var _a = this.props, driveItemId = _a.driveItemId, driveItemIds = _a.driveItemIds;
        if (driveItemIds.length > 0) {
            var driveItemIndex = driveItemIds.indexOf(driveItemId);
            var driveItemsToDisplay = this.driveItemsToDisplay;
            return !!driveItemsToDisplay[driveItemIndex];
        }
        return false;
    };
    Theater.prototype.renderTheaterContents = function (galleryInfos, resolutions) {
        return this.driveItemsToDisplay.map(function (sliderItem, index) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* TheaterItem */], { key: index },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Content__["a" /* default */], { driveItem: sliderItem, galleryInfos: galleryInfos, resolutions: resolutions })));
        });
    };
    Object.defineProperty(Theater.prototype, "driveItemsToDisplay", {
        get: function () {
            var _this = this;
            return this.props.driveItemIds.map(function (driveItemId) { return _this.getDriveItem(driveItemId); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Theater.prototype, "driveItem", {
        get: function () {
            return this.getDriveItem(this.props.driveItemId);
        },
        enumerable: true,
        configurable: true
    });
    Theater.prototype.getDriveItem = function (driveItemId) {
        var driveItemsStore = this.props.driveList.driveItems;
        return driveItemsStore[driveItemId];
    };
    return Theater;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var mapStateToProps = function (state) {
    var galleryInfos = state.galleryInfos, driveList = state.driveList;
    return { galleryInfos: galleryInfos, driveList: driveList };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Theater));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.operationReducer = exports.playerReducer = void 0;

var _player = _interopRequireDefault(__webpack_require__(1429));

var _operation = _interopRequireDefault(__webpack_require__(1430));

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    player: (0, _player["default"])(state.player, action),
    operation: (0, _operation["default"])(state.operation, action)
  };
}

var playerReducer = _player["default"];
exports.playerReducer = playerReducer;
var operationReducer = _operation["default"];
exports.operationReducer = operationReducer;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var Fullscreen =
/*#__PURE__*/
function () {
  function Fullscreen() {
    (0, _classCallCheck2["default"])(this, Fullscreen);
  }

  (0, _createClass2["default"])(Fullscreen, [{
    key: "request",
    value: function request(elm) {
      if (elm.requestFullscreen) {
        elm.requestFullscreen();
      } else if (elm.webkitRequestFullscreen) {
        elm.webkitRequestFullscreen();
      } else if (elm.mozRequestFullScreen) {
        elm.mozRequestFullScreen();
      } else if (elm.msRequestFullscreen) {
        elm.msRequestFullscreen();
      }
    }
  }, {
    key: "exit",
    value: function exit() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(handler) {
      document.addEventListener('fullscreenchange', handler);
      document.addEventListener('webkitfullscreenchange', handler);
      document.addEventListener('mozfullscreenchange', handler);
      document.addEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(handler) {
      document.removeEventListener('fullscreenchange', handler);
      document.removeEventListener('webkitfullscreenchange', handler);
      document.removeEventListener('mozfullscreenchange', handler);
      document.removeEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "isFullscreen",
    get: function get() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }
  }, {
    key: "enabled",
    get: function get() {
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }
  }]);
  return Fullscreen;
}();

var _default = new Fullscreen();

exports["default"] = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  position: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  position: 'left'
};

var BigPlayButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(BigPlayButton, _Component);

  function BigPlayButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, BigPlayButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BigPlayButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "handleClick",
    value: function handleClick() {
      var actions = this.props.actions;
      actions.play();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          player = _this$props.player,
          position = _this$props.position;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])('video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
          'big-play-button-hide': player.hasStarted || !player.currentSrc
        }),
        type: "button",
        "aria-live": "polite",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Play Video"));
    }
  }]);
  return BigPlayButton;
}(_react.Component);

exports["default"] = BigPlayButton;
BigPlayButton.propTypes = propTypes;
BigPlayButton.defaultProps = defaultProps;
BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadingSpinner;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function LoadingSpinner(_ref) {
  var player = _ref.player,
      className = _ref.className;

  if (player.error) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-loading-spinner', className)
  });
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  poster: _propTypes["default"].string,
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function PosterImage(_ref) {
  var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;

  if (!poster || player.hasStarted) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-poster', className),
    style: {
      backgroundImage: "url(\"".concat(poster, "\")")
    },
    onClick: function onClick() {
      if (player.paused) {
        actions.play();
      }
    }
  });
}

PosterImage.propTypes = propTypes;
PosterImage.displayName = 'PosterImage';
var _default = PosterImage;
exports["default"] = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(72);

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  children: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  className: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  crossOrigin: _propTypes["default"].string,
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  onResize: _propTypes["default"].func
};

var Video =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Video, _Component);

  function Video(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Video);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
    _this.video = null; // the html5 video

    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate(); // make sure the children can get the video property

      if (this.video && this.video.textTracks) {
        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
      }
    } // get all video properties

  }, {
    key: "getProperties",
    value: function getProperties() {
      var _this2 = this;

      if (!this.video) {
        return null;
      }

      return _utils.mediaProperties.reduce(function (properties, key) {
        properties[key] = _this2.video[key];
        return properties;
      }, {});
    } // get playback rate

  }, {
    key: "handleTextTrackChange",
    value: function handleTextTrackChange() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (this.video && this.video.textTracks) {
        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
          return textTrack.mode === 'showing';
        });

        if (activeTextTrack !== player.activeTextTrack) {
          actions.activateTextTrack(activeTextTrack);
        }
      }
    } // play the video

  }, {
    key: "play",
    value: function play() {
      var promise = this.video.play();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      var promise = this.video.pause();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // toggle play

  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      try {
        this.video.currentTime = time;
      } catch (e) {// console.log(e, 'Video is not ready.')
      }
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.seek(this.video.currentTime + seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.forward(-seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      actions.toggleFullscreen(player);
    } // Fired when the user agent
    // begins looking for media data

  }, {
    key: "handleLoadStart",
    value: function handleLoadStart() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          onLoadStart = _this$props3.onLoadStart;
      actions.handleLoadStart(this.getProperties());

      if (onLoadStart) {
        onLoadStart.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlay",
    value: function handleCanPlay() {
      var _this$props4 = this.props,
          actions = _this$props4.actions,
          onCanPlay = _this$props4.onCanPlay;
      actions.handleCanPlay(this.getProperties());

      if (onCanPlay) {
        onCanPlay.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlayThrough",
    value: function handleCanPlayThrough() {
      var _this$props5 = this.props,
          actions = _this$props5.actions,
          onCanPlayThrough = _this$props5.onCanPlayThrough;
      actions.handleCanPlayThrough(this.getProperties());

      if (onCanPlayThrough) {
        onCanPlayThrough.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handlePlaying",
    value: function handlePlaying() {
      var _this$props6 = this.props,
          actions = _this$props6.actions,
          onPlaying = _this$props6.onPlaying;
      actions.handlePlaying(this.getProperties());

      if (onPlaying) {
        onPlaying.apply(void 0, arguments);
      }
    } // Fired whenever the media has been started

  }, {
    key: "handlePlay",
    value: function handlePlay() {
      var _this$props7 = this.props,
          actions = _this$props7.actions,
          onPlay = _this$props7.onPlay;
      actions.handlePlay(this.getProperties());

      if (onPlay) {
        onPlay.apply(void 0, arguments);
      }
    } // Fired whenever the media has been paused

  }, {
    key: "handlePause",
    value: function handlePause() {
      var _this$props8 = this.props,
          actions = _this$props8.actions,
          onPause = _this$props8.onPause;
      actions.handlePause(this.getProperties());

      if (onPause) {
        onPause.apply(void 0, arguments);
      }
    } // Fired when the duration of
    // the media resource is first known or changed

  }, {
    key: "handleDurationChange",
    value: function handleDurationChange() {
      var _this$props9 = this.props,
          actions = _this$props9.actions,
          onDurationChange = _this$props9.onDurationChange;
      actions.handleDurationChange(this.getProperties());

      if (onDurationChange) {
        onDurationChange.apply(void 0, arguments);
      }
    } // Fired while the user agent
    // is downloading media data

  }, {
    key: "handleProgress",
    value: function handleProgress() {
      var _this$props10 = this.props,
          actions = _this$props10.actions,
          onProgress = _this$props10.onProgress;

      if (this.video) {
        actions.handleProgressChange(this.getProperties());
      }

      if (onProgress) {
        onProgress.apply(void 0, arguments);
      }
    } // Fired when the end of the media resource
    // is reached (currentTime == duration)

  }, {
    key: "handleEnded",
    value: function handleEnded() {
      var _this$props11 = this.props,
          loop = _this$props11.loop,
          player = _this$props11.player,
          actions = _this$props11.actions,
          onEnded = _this$props11.onEnded;

      if (loop) {
        this.seek(0);
        this.play();
      } else if (!player.paused) {
        this.pause();
      }

      actions.handleEnd(this.getProperties());

      if (onEnded) {
        onEnded.apply(void 0, arguments);
      }
    } // Fired whenever the media begins waiting

  }, {
    key: "handleWaiting",
    value: function handleWaiting() {
      var _this$props12 = this.props,
          actions = _this$props12.actions,
          onWaiting = _this$props12.onWaiting;
      actions.handleWaiting(this.getProperties());

      if (onWaiting) {
        onWaiting.apply(void 0, arguments);
      }
    } // Fired whenever the player
    // is jumping to a new time

  }, {
    key: "handleSeeking",
    value: function handleSeeking() {
      var _this$props13 = this.props,
          actions = _this$props13.actions,
          onSeeking = _this$props13.onSeeking;
      actions.handleSeeking(this.getProperties());

      if (onSeeking) {
        onSeeking.apply(void 0, arguments);
      }
    } // Fired when the player has
    // finished jumping to a new time

  }, {
    key: "handleSeeked",
    value: function handleSeeked() {
      var _this$props14 = this.props,
          actions = _this$props14.actions,
          onSeeked = _this$props14.onSeeked;
      actions.handleSeeked(this.getProperties());

      if (onSeeked) {
        onSeeked.apply(void 0, arguments);
      }
    } // Handle Fullscreen Change

  }, {
    key: "handleFullscreenChange",
    value: function handleFullscreenChange() {} // Fires when the browser is
    // intentionally not getting media data

  }, {
    key: "handleSuspend",
    value: function handleSuspend() {
      var _this$props15 = this.props,
          actions = _this$props15.actions,
          onSuspend = _this$props15.onSuspend;
      actions.handleSuspend(this.getProperties());

      if (onSuspend) {
        onSuspend.apply(void 0, arguments);
      }
    } // Fires when the loading of an audio/video is aborted

  }, {
    key: "handleAbort",
    value: function handleAbort() {
      var _this$props16 = this.props,
          actions = _this$props16.actions,
          onAbort = _this$props16.onAbort;
      actions.handleAbort(this.getProperties());

      if (onAbort) {
        onAbort.apply(void 0, arguments);
      }
    } // Fires when the current playlist is empty

  }, {
    key: "handleEmptied",
    value: function handleEmptied() {
      var _this$props17 = this.props,
          actions = _this$props17.actions,
          onEmptied = _this$props17.onEmptied;
      actions.handleEmptied(this.getProperties());

      if (onEmptied) {
        onEmptied.apply(void 0, arguments);
      }
    } // Fires when the browser is trying to
    // get media data, but data is not available

  }, {
    key: "handleStalled",
    value: function handleStalled() {
      var _this$props18 = this.props,
          actions = _this$props18.actions,
          onStalled = _this$props18.onStalled;
      actions.handleStalled(this.getProperties());

      if (onStalled) {
        onStalled.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // meta data for the audio/video

  }, {
    key: "handleLoadedMetaData",
    value: function handleLoadedMetaData() {
      var _this$props19 = this.props,
          actions = _this$props19.actions,
          onLoadedMetadata = _this$props19.onLoadedMetadata,
          startTime = _this$props19.startTime;

      if (startTime && startTime > 0) {
        this.video.currentTime = startTime;
      }

      actions.handleLoadedMetaData(this.getProperties());

      if (onLoadedMetadata) {
        onLoadedMetadata.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // the current frame of the audio/video

  }, {
    key: "handleLoadedData",
    value: function handleLoadedData() {
      var _this$props20 = this.props,
          actions = _this$props20.actions,
          onLoadedData = _this$props20.onLoadedData;
      actions.handleLoadedData(this.getProperties());

      if (onLoadedData) {
        onLoadedData.apply(void 0, arguments);
      }
    } // Fires when the current
    // playback position has changed

  }, {
    key: "handleTimeUpdate",
    value: function handleTimeUpdate() {
      var _this$props21 = this.props,
          actions = _this$props21.actions,
          onTimeUpdate = _this$props21.onTimeUpdate;
      actions.handleTimeUpdate(this.getProperties());

      if (onTimeUpdate) {
        onTimeUpdate.apply(void 0, arguments);
      }
    }
    /**
     * Fires when the playing speed of the audio/video is changed
     */

  }, {
    key: "handleRateChange",
    value: function handleRateChange() {
      var _this$props22 = this.props,
          actions = _this$props22.actions,
          onRateChange = _this$props22.onRateChange;
      actions.handleRateChange(this.getProperties());

      if (onRateChange) {
        onRateChange.apply(void 0, arguments);
      }
    } // Fires when the volume has been changed

  }, {
    key: "handleVolumeChange",
    value: function handleVolumeChange() {
      var _this$props23 = this.props,
          actions = _this$props23.actions,
          onVolumeChange = _this$props23.onVolumeChange;
      actions.handleVolumeChange(this.getProperties());

      if (onVolumeChange) {
        onVolumeChange.apply(void 0, arguments);
      }
    } // Fires when an error occurred
    // during the loading of an audio/video

  }, {
    key: "handleError",
    value: function handleError() {
      var _this$props24 = this.props,
          actions = _this$props24.actions,
          onError = _this$props24.onError;
      actions.handleError(this.getProperties());

      if (onError) {
        onError.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$props25 = this.props,
          actions = _this$props25.actions,
          onResize = _this$props25.onResize;
      actions.handleResize(this.getProperties());

      if (onResize) {
        onResize.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleKeypress",
    value: function handleKeypress() {}
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;

      var props = (0, _objectSpread2["default"])({}, this.props, {
        video: this.video
      }); // to make sure the children can get video property

      if (!this.video) {
        return null;
      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements


      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
        var cprops;

        if (typeof c.type === 'string') {
          // add onError to <source />
          if (c.type === 'source') {
            cprops = (0, _objectSpread2["default"])({}, c.props);
            var preOnError = cprops.onError;

            cprops.onError = function () {
              if (preOnError) {
                preOnError.apply(void 0, arguments);
              }

              _this3.handleError.apply(_this3, arguments);
            };
          }
        } else {
          cprops = props;
        }

        return _react["default"].cloneElement(c, cprops);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props26 = this.props,
          loop = _this$props26.loop,
          poster = _this$props26.poster,
          preload = _this$props26.preload,
          src = _this$props26.src,
          autoPlay = _this$props26.autoPlay,
          playsInline = _this$props26.playsInline,
          muted = _this$props26.muted,
          crossOrigin = _this$props26.crossOrigin,
          videoId = _this$props26.videoId;
      return _react["default"].createElement("video", {
        className: (0, _classnames["default"])('video-react-video', this.props.className),
        id: videoId,
        crossOrigin: crossOrigin,
        ref: function ref(c) {
          _this4.video = c;
        },
        muted: muted,
        preload: preload,
        loop: loop,
        playsInline: playsInline,
        autoPlay: autoPlay,
        poster: poster,
        src: src,
        onLoadStart: this.handleLoadStart,
        onWaiting: this.handleWaiting,
        onCanPlay: this.handleCanPlay,
        onCanPlayThrough: this.handleCanPlayThrough,
        onPlaying: this.handlePlaying,
        onEnded: this.handleEnded,
        onSeeking: this.handleSeeking,
        onSeeked: this.handleSeeked,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onProgress: this.handleProgress,
        onDurationChange: this.handleDurationChange,
        onError: this.handleError,
        onSuspend: this.handleSuspend,
        onAbort: this.handleAbort,
        onEmptied: this.handleEmptied,
        onStalled: this.handleStalled,
        onLoadedMetadata: this.handleLoadedMetaData,
        onLoadedData: this.handleLoadedData,
        onTimeUpdate: this.handleTimeUpdate,
        onRateChange: this.handleRateChange,
        onVolumeChange: this.handleVolumeChange,
        tabIndex: "-1"
      }, this.renderChildren());
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      if (val > 1) {
        val = 1;
      }

      if (val < 0) {
        val = 0;
      }

      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Video;
}(_react.Component);

exports["default"] = Video;
Video.propTypes = propTypes;
Video.displayName = 'Video';

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1431);

var iterableToArray = __webpack_require__(1432);

var nonIterableSpread = __webpack_require__(1433);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  manager: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var Bezel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Bezel, _Component);

  function Bezel(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bezel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
    _this.timer = null;
    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      hidden: true,
      operation: {}
    };
    return _this;
  }

  (0, _createClass2["default"])(Bezel, [{
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      var _this2 = this;

      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
        if (this.timer) {
          // previous animation is not finished
          clearTimeout(this.timer); // cancel it

          this.timer = null;
        } // show it
        // update operation


        this.setState({
          hidden: false,
          count: state.count,
          operation: state.operation
        }); // hide it after 0.5s

        this.timer = setTimeout(function () {
          _this2.setState({
            hidden: true
          });

          _this2.timer = null;
        }, 500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // only displays for shortcut so far
      if (this.state.operation.source !== 'shortcut') {
        return null;
      }

      var style = this.state.hidden ? {
        display: 'none'
      } : null;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-bezel': true,
          'video-react-bezel-animation': this.state.count % 2 === 0,
          'video-react-bezel-animation-alt': this.state.count % 2 === 1
        }, this.props.className),
        style: style,
        role: "status",
        "aria-label": this.state.operation.action
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
      }));
    }
  }]);
  return Bezel;
}(_react.Component);

exports["default"] = Bezel;
Bezel.propTypes = propTypes;
Bezel.displayName = 'Bezel';

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(361));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(582));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _react = __webpack_require__(0);

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _dom = __webpack_require__(252);

var propTypes = {
  clickable: _propTypes["default"].bool,
  dblclickable: _propTypes["default"].bool,
  manager: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  shortcuts: _propTypes["default"].array
};
var defaultProps = {
  clickable: true,
  dblclickable: true
};

var Shortcut =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Shortcut, _Component);

  function Shortcut(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Shortcut);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
    _this.defaultShortcuts = [{
      keyCode: 32,
      // spacebar
      handle: _this.togglePlay
    }, {
      keyCode: 75,
      // k
      handle: _this.togglePlay
    }, {
      keyCode: 70,
      // f
      handle: _this.toggleFullscreen
    }, {
      keyCode: 37,
      // Left arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(5, {
          action: 'replay-5',
          source: 'shortcut'
        }); // Go back 5 seconds
      }
    }, {
      keyCode: 74,
      // j
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(10, {
          action: 'replay-10',
          source: 'shortcut'
        }); // Go back 10 seconds
      }
    }, {
      keyCode: 39,
      // Right arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(5, {
          action: 'forward-5',
          source: 'shortcut'
        }); // Go forward 5 seconds
      }
    }, {
      keyCode: 76,
      // l
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(10, {
          action: 'forward-10',
          source: 'shortcut'
        }); // Go forward 10 seconds
      }
    }, {
      keyCode: 36,
      // Home
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.seek(0); // Go to beginning of video
      }
    }, {
      keyCode: 35,
      // End
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        } // Go to end of video


        actions.seek(player.duration);
      }
    }, {
      keyCode: 38,
      // Up arrow
      handle: function handle(player, actions) {
        // Increase volume 5%
        var v = player.volume + 0.05;

        if (v > 1) {
          v = 1;
        }

        actions.changeVolume(v, {
          action: 'volume-up',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 40,
      // Down arrow
      handle: function handle(player, actions) {
        // Decrease volume 5%
        var v = player.volume - 0.05;

        if (v < 0) {
          v = 0;
        }

        var action = v > 0 ? 'volume-down' : 'volume-off';
        actions.changeVolume(v, {
          action: action,
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 190,
      // Shift + >
      shift: true,
      handle: function handle(player, actions) {
        // Increase speed
        var playbackRate = player.playbackRate;

        if (playbackRate >= 1.5) {
          playbackRate = 2;
        } else if (playbackRate >= 1.25) {
          playbackRate = 1.5;
        } else if (playbackRate >= 1.0) {
          playbackRate = 1.25;
        } else if (playbackRate >= 0.5) {
          playbackRate = 1.0;
        } else if (playbackRate >= 0.25) {
          playbackRate = 0.5;
        } else if (playbackRate >= 0) {
          playbackRate = 0.25;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-forward',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 188,
      // Shift + <
      shift: true,
      handle: function handle(player, actions) {
        // Decrease speed
        var playbackRate = player.playbackRate;

        if (playbackRate <= 0.5) {
          playbackRate = 0.25;
        } else if (playbackRate <= 1.0) {
          playbackRate = 0.5;
        } else if (playbackRate <= 1.25) {
          playbackRate = 1.0;
        } else if (playbackRate <= 1.5) {
          playbackRate = 1.25;
        } else if (playbackRate <= 2) {
          playbackRate = 1.5;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-rewind',
          source: 'shortcut'
        });
      }
    }];
    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Shortcut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mergeShortcuts();
      document.addEventListener('keydown', this.handleKeyPress);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('dblclick', this.handleDoubleClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.shortcuts !== this.props.shortcuts) {
        this.mergeShortcuts();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('dblclick', this.handleDoubleClick);
    } // merge the shortcuts from props

  }, {
    key: "mergeShortcuts",
    value: function mergeShortcuts() {
      var getShortcutKey = function getShortcutKey(_ref) {
        var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === void 0 ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? false : _ref$alt;
        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
      };

      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
      }, {});
      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
        var keyCode = shortcut.keyCode,
            handle = shortcut.handle;

        if (keyCode && typeof handle === 'function') {
          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
        }

        return shortcuts;
      }, defaultShortcuts);

      var gradeShortcut = function gradeShortcut(s) {
        var score = 0;
        var ps = ['ctrl', 'shift', 'alt'];
        ps.forEach(function (key) {
          if (s[key]) {
            score++;
          }
        });
        return score;
      };

      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
        return mergedShortcuts[key];
      }).sort(function (a, b) {
        return gradeShortcut(b) - gradeShortcut(a);
      });
    }
  }, {
    key: "togglePlay",
    value: function togglePlay(player, actions) {
      if (player.paused) {
        actions.play({
          action: 'play',
          source: 'shortcut'
        });
      } else {
        actions.pause({
          action: 'pause',
          source: 'shortcut'
        });
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(player, actions) {
      actions.toggleFullscreen(player);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (!player.isActive) {
        return;
      }

      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
        return;
      }

      var keyCode = e.keyCode || e.which;
      var ctrl = e.ctrlKey || e.metaKey;
      var shift = e.shiftKey;
      var alt = e.altKey;
      var shortcut = this.shortcuts.filter(function (s) {
        if (!s.keyCode || s.keyCode - keyCode !== 0) {
          return false;
        }

        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
          return false;
        }

        return true;
      })[0];

      if (shortcut) {
        shortcut.handle(player, actions);
        e.preventDefault();
      }
    } // only if player is active and player is ready

  }, {
    key: "canBeClicked",
    value: function canBeClicked(player, e) {
      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
        return false;
      }

      return true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          clickable = _this$props2.clickable;

      if (!this.canBeClicked(player, e) || !clickable) {
        return;
      }

      this.togglePlay(player, actions); // e.preventDefault();
    }
  }, {
    key: "handleDoubleClick",
    value: function handleDoubleClick(e) {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions,
          dblclickable = _this$props3.dblclickable;

      if (!this.canBeClicked(player, e) || !dblclickable) {
        return;
      }

      this.toggleFullscreen(player, actions); // e.preventDefault();
    } // this component dose not render anything
    // it's just for the key down event

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Shortcut;
}(_react.Component);

exports["default"] = Shortcut;
Shortcut.propTypes = propTypes;
Shortcut.defaultProps = defaultProps;
Shortcut.displayName = 'Shortcut';

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(362));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _ProgressControl = _interopRequireDefault(__webpack_require__(586));

var _PlayToggle = _interopRequireDefault(__webpack_require__(591));

var _ForwardControl = _interopRequireDefault(__webpack_require__(592));

var _ReplayControl = _interopRequireDefault(__webpack_require__(594));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(595));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(596));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(597));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(598));

var _TimeDivider = _interopRequireDefault(__webpack_require__(599));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(600));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(365));

var _utils = __webpack_require__(72);

var propTypes = {
  children: _propTypes["default"].any,
  autoHide: _propTypes["default"].bool,
  autoHideTime: _propTypes["default"].number,
  // used in Player
  disableDefaultControls: _propTypes["default"].bool,
  disableCompletely: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  autoHide: true,
  disableCompletely: false
};

var ControlBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ControlBar, _Component);

  function ControlBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ControlBar, [{
    key: "getDefaultChildren",
    value: function getDefaultChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5.1
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 5.2
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 5.3
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 6
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 8
      })];
    }
  }, {
    key: "getFullChildren",
    value: function getFullChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_ReplayControl["default"], {
        key: "replay-control",
        order: 2
      }), _react["default"].createElement(_ForwardControl["default"], {
        key: "forward-control",
        order: 3
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 6
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 7
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 8
      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
        key: "remaining-time-display",
        order: 9
      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
        rates: [1, 1.25, 1.5, 2],
        key: "playback-rate",
        order: 10
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 11
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = _react["default"].Children.toArray(this.props.children);

      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
      var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className

      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoHide = _this$props2.autoHide,
          className = _this$props2.className,
          disableCompletely = _this$props2.disableCompletely;
      var children = this.getChildren();
      return disableCompletely ? null : _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-control-bar', {
          'video-react-control-bar-auto-hide': autoHide
        }, className)
      }, children);
    }
  }]);
  return ControlBar;
}(_react.Component);

exports["default"] = ControlBar;
ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(186));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var Dom = _interopRequireWildcard(__webpack_require__(252));

var _SeekBar = _interopRequireDefault(__webpack_require__(587));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var ProgressControl =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ProgressControl, _Component);

  function ProgressControl(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ProgressControl);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
    _this.state = {
      mouseTime: {
        time: null,
        position: 0
      }
    };
    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ProgressControl, [{
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (!event.pageX) {
        return;
      }

      var duration = this.props.player.duration;
      var node = this.seekBar;
      var newTime = Dom.getPointerPosition(node, event).x * duration;
      var position = event.pageX - Dom.findElPosition(node).left;
      this.setState({
        mouseTime: {
          time: newTime,
          position: position
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      return _react["default"].createElement("div", {
        onMouseMove: this.handleMouseMoveThrottle,
        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
        mouseTime: this.state.mouseTime,
        ref: function ref(c) {
          _this2.seekBar = c;
        }
      }, this.props)));
    }
  }]);
  return ProgressControl;
}(_react.Component);

exports["default"] = ProgressControl;
ProgressControl.propTypes = propTypes;
ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _Slider = _interopRequireDefault(__webpack_require__(364));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(588));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(589));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(590));

var _utils = __webpack_require__(72);

var propTypes = {
  player: _propTypes["default"].object,
  mouseTime: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var SeekBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SeekBar, _Component);

  function SeekBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, SeekBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SeekBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
    /**
     * Get percentage of video played
     *
     * @return {Number} Percentage played
     * @method getPercent
     */

  }, {
    key: "getPercent",
    value: function getPercent() {
      var _this$props$player = this.props.player,
          currentTime = _this$props$player.currentTime,
          seekingTime = _this$props$player.seekingTime,
          duration = _this$props$player.duration;
      var time = seekingTime || currentTime;
      var percent = time / duration;
      return percent >= 1 ? 1 : percent;
    }
  }, {
    key: "getNewTime",
    value: function getNewTime(event) {
      var duration = this.props.player.duration;
      var distance = this.slider.calculateDistance(event);
      var newTime = distance * duration; // Don't let video end while scrubbing.

      return newTime === duration ? newTime - 0.1 : newTime;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {}
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)

      actions.seek(newTime);
      actions.handleEndSeeking(newTime);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event);
      actions.handleSeekingTime(newTime);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var actions = this.props.actions;
      actions.forward(5);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var actions = this.props.actions;
      actions.replay(5);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$player2 = _this$props.player,
          currentTime = _this$props$player2.currentTime,
          seekingTime = _this$props$player2.seekingTime,
          duration = _this$props$player2.duration,
          buffered = _this$props$player2.buffered,
          mouseTime = _this$props.mouseTime;
      var time = seekingTime || currentTime;
      return _react["default"].createElement(_Slider["default"], {
        ref: function ref(input) {
          _this2.slider = input;
        },
        label: "video progress bar",
        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
        valuenow: (this.getPercent() * 100).toFixed(2),
        valuetext: (0, _utils.formatTime)(time, duration),
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        getPercent: this.getPercent,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, _react["default"].createElement(_LoadProgressBar["default"], {
        buffered: buffered,
        currentTime: time,
        duration: duration
      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
        duration: duration,
        mouseTime: mouseTime
      }), _react["default"].createElement(_PlayProgressBar["default"], {
        currentTime: time,
        duration: duration
      }));
    }
  }]);
  return SeekBar;
}(_react.Component);

exports["default"] = SeekBar;
SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PlayProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(72);

var propTypes = {
  currentTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  percentage: _propTypes["default"].string,
  className: _propTypes["default"].string
}; // Shows play progress

function PlayProgressBar(_ref) {
  var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;
  return _react["default"].createElement("div", {
    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
    style: {
      width: percentage
    }
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Progress: ".concat(percentage)));
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  duration: _propTypes["default"].number,
  buffered: _propTypes["default"].object,
  className: _propTypes["default"].string
}; // Shows load progress

function LoadProgressBar(_ref) {
  var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;

  if (!buffered || !buffered.length) {
    return null;
  }

  var bufferedEnd = buffered.end(buffered.length - 1);
  var style = {};

  if (bufferedEnd > duration) {
    bufferedEnd = duration;
  } // get the percent width of a time compared to the total end


  function percentify(time, end) {
    var percent = time / end || 0; // no NaN

    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
  } // the width of the progress bar


  style.width = percentify(bufferedEnd, duration);
  var parts = []; // add child elements to represent the individual buffered time ranges

  for (var i = 0; i < buffered.length; i++) {
    var start = buffered.start(i);
    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)

    var part = _react["default"].createElement("div", {
      style: {
        left: percentify(start, bufferedEnd),
        width: percentify(end - start, bufferedEnd)
      },
      key: "part-".concat(i)
    });

    parts.push(part);
  }

  if (parts.length === 0) {
    parts = null;
  }

  return _react["default"].createElement("div", {
    style: style,
    className: (0, _classnames["default"])('video-react-load-progress', className)
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Loaded: 0%"), parts);
}

LoadProgressBar.propTypes = propTypes;
LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(72);

function MouseTimeDisplay(_ref) {
  var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;

  if (!mouseTime.time) {
    return null;
  }

  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-mouse-display', className),
    style: {
      left: "".concat(mouseTime.position, "px")
    },
    "data-current-time": time
  });
}

MouseTimeDisplay.propTypes = {
  duration: _propTypes["default"].number,
  mouseTime: _propTypes["default"].object,
  className: _propTypes["default"].string
};
MouseTimeDisplay.displayName = 'MouseTimeDisplay';
var _default = MouseTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var PlayToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlayToggle, _Component);

  function PlayToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlayToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlayToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (player.paused) {
        actions.play();
      } else {
        actions.pause();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      var controlText = player.paused ? 'Play' : 'Pause';
      return _react["default"].createElement("button", {
        ref: function ref(c) {
          _this2.button = c;
        },
        className: (0, _classnames["default"])(className, {
          'video-react-play-control': true,
          'video-react-control': true,
          'video-react-button': true,
          'video-react-paused': player.paused,
          'video-react-playing': !player.paused
        }),
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, controlText));
    }
  }]);
  return PlayToggle;
}(_react.Component);

exports["default"] = PlayToggle;
PlayToggle.propTypes = propTypes;
PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(593));

// Pass mode into parent function
var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
ForwardControl.displayName = 'ForwardControl';
var _default = ForwardControl;
exports["default"] = _default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  seconds: _propTypes["default"].oneOf([5, 10, 30])
};
var defaultProps = {
  seconds: 10
};

var _default = function _default(mode) {
  var ForwardReplayControl =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(ForwardReplayControl, _Component);

    function ForwardReplayControl(props, context) {
      var _this;

      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    (0, _createClass2["default"])(ForwardReplayControl, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
            actions = _this$props.actions,
            seconds = _this$props.seconds; // Depends mode to implement different actions

        if (mode === 'forward') {
          actions.forward(seconds);
        } else {
          actions.replay(seconds);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            seconds = _this$props2.seconds,
            className = _this$props2.className;
        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));

        if (className) {
          classNames.push(className);
        }

        return _react["default"].createElement("button", {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: classNames.join(' '),
          type: "button",
          onClick: this.handleClick
        }, _react["default"].createElement("span", {
          className: "video-react-control-text"
        }, "".concat(mode, " ").concat(seconds, " seconds")));
      }
    }]);
    return ForwardReplayControl;
  }(_react.Component);

  ForwardReplayControl.propTypes = propTypes;
  ForwardReplayControl.defaultProps = defaultProps;
  return ForwardReplayControl;
};

exports["default"] = _default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(593));

// Pass mode into parent function
var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
ReplayControl.displayName = 'ReplayControl';
var _default = ReplayControl;
exports["default"] = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var FullscreenToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FullscreenToggle, _Component);

  function FullscreenToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, FullscreenToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(FullscreenToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.toggleFullscreen(player);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])(className, {
          'video-react-icon-fullscreen-exit': player.isFullscreen,
          'video-react-icon-fullscreen': !player.isFullscreen
        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
        ref: function ref(c) {
          _this2.button = c;
        },
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Non-Fullscreen"));
    }
  }]);
  return FullscreenToggle;
}(_react.Component);

exports["default"] = FullscreenToggle;
FullscreenToggle.propTypes = propTypes;
FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(72);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function RemainingTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var remainingTime = duration - currentTime;
  var formattedTime = (0, _utils.formatTime)(remainingTime);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-remaining-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Remaining Time "), "-".concat(formattedTime)));
}

RemainingTimeDisplay.propTypes = propTypes;
RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
var _default = RemainingTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(72);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function CurrentTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-current-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Current Time "), formattedTime));
}

CurrentTimeDisplay.propTypes = propTypes;
CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
var _default = CurrentTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _utils = __webpack_require__(72);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function DurationDisplay(_ref) {
  var duration = _ref.player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
  }, _react["default"].createElement("div", {
    className: "video-react-duration-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Duration Time "), formattedTime));
}

DurationDisplay.propTypes = propTypes;
DurationDisplay.displayName = 'DurationDisplay';
var _default = DurationDisplay;
exports["default"] = _default;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TimeDivider;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  separator: _propTypes["default"].string,
  className: _propTypes["default"].string
};

function TimeDivider(_ref) {
  var separator = _ref.separator,
      className = _ref.className;
  var separatorText = separator || '/';
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
    dir: "ltr"
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
}

TimeDivider.propTypes = propTypes;
TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(186));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _PopupButton = _interopRequireDefault(__webpack_require__(1434));

var _VolumeBar = _interopRequireDefault(__webpack_require__(1436));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  alwaysShowVolume: _propTypes["default"].bool
};
var defaultProps = {
  vertical: false
};

var VolumeMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeMenuButton, _Component);

  function VolumeMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
    _this.state = {
      active: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeMenuButton, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.mute(!player.muted);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        active: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          player = _this$props2.player,
          className = _this$props2.className;
      var inline = !vertical;
      var level = this.volumeLevel;
      return _react["default"].createElement(_PopupButton["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-volume-menu-button-vertical': vertical,
          'video-react-volume-menu-button-horizontal': !vertical,
          'video-react-vol-muted': player.muted,
          'video-react-vol-0': level === 0 && !player.muted,
          'video-react-vol-1': level === 1,
          'video-react-vol-2': level === 2,
          'video-react-vol-3': level === 3,
          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
        }, 'video-react-volume-menu-button'),
        onClick: this.handleClick,
        inline: inline
      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props)));
    }
  }, {
    key: "volumeLevel",
    get: function get() {
      var _this$props$player = this.props.player,
          volume = _this$props$player.volume,
          muted = _this$props$player.muted;
      var level = 3;

      if (volume === 0 || muted) {
        level = 0;
      } else if (volume < 0.33) {
        level = 1;
      } else if (volume < 0.67) {
        level = 2;
      }

      return level;
    }
  }]);
  return VolumeMenuButton;
}(_react.Component);

VolumeMenuButton.propTypes = propTypes;
VolumeMenuButton.defaultProps = defaultProps;
VolumeMenuButton.displayName = 'VolumeMenuButton';
var _default = VolumeMenuButton;
exports["default"] = _default;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(186));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  tagName: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  tagName: 'div'
};

var ClickableComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClickableComponent, _Component);

  function ClickableComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClickableComponent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ClickableComponent, [{
    key: "handleKeypress",
    value: function handleKeypress(event) {
      // Support Space (32) or Enter (13) key operation to fire a click event
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var onClick = this.props.onClick;
      onClick(event);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeypress);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeypress);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Tag = this.props.tagName;
      var props = (0, _objectSpread2["default"])({}, this.props);
      delete props.tagName;
      delete props.className;
      return _react["default"].createElement(Tag, (0, _extends2["default"])({
        className: (0, _classnames["default"])(this.props.className),
        role: "button",
        tabIndex: "0",
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, props));
    }
  }]);
  return ClickableComponent;
}(_react.Component);

exports["default"] = ClickableComponent;
ClickableComponent.propTypes = propTypes;
ClickableComponent.defaultProps = defaultProps;
ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return StyledDriveItemDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HeaderInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionButtonsInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return StandardButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BackgroundImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TitleContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SubTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DescriptionRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DescriptionLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DescriptionText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return InfoRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return InfoLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return InfoText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DriveItemActionIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PublicationCoverContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PublicationCoverImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Button_styles__ = __webpack_require__(88);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledDriveItemDetail = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-size: 14px;\n\tcolor: ", ";\n\tbackground: ", ";\n\tmin-height: 100%;\n"], ["\n\tfont-size: 14px;\n\tcolor: ", ";\n\tbackground: ", ";\n\tmin-height: 100%;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].White);
var Container = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: 0 auto;\n\tmax-width: 100%;\n\tpadding: 0 15px;\n\n\t@media ", " {\n\t\twidth: 720px;\n\t}\n\n\t@media ", " {\n\t\twidth: 960px;\n\t}\n\n\t@media ", " {\n\t\twidth: 1140px;\n\t}\n"], ["\n\tmargin: 0 auto;\n\tmax-width: 100%;\n\tpadding: 0 15px;\n\n\t@media ", " {\n\t\twidth: 720px;\n\t}\n\n\t@media ", " {\n\t\twidth: 960px;\n\t}\n\n\t@media ", " {\n\t\twidth: 1140px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].MediumDesktop);
var Header = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tborder-bottom: 1px solid ", ";\n\tbackground: ", ";\n\tpadding: 15px 0;\n"], ["\n\tborder-bottom: 1px solid ", ";\n\tbackground: ", ";\n\tpadding: 15px 0;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey100, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Blue100);
var HeaderInner = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\n\t> svg {\n\t\theight: 180px;\n\t\twidth: 180px;\n\t\tfill: ", ";\n\t\tmargin-right: 30px;\n\n\t\t@media ", " {\n\t\t\twidth: 120px;\n\t\t}\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\n\t> svg {\n\t\theight: 180px;\n\t\twidth: 180px;\n\t\tfill: ", ";\n\t\tmargin-right: 30px;\n\n\t\t@media ", " {\n\t\t\twidth: 120px;\n\t\t}\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Smartphone);
var ActionButtons = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tborder-bottom: 1px solid ", ";\n"], ["\n\tborder-bottom: 1px solid ", ";\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey100);
var ActionButtonsInner = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\tjustify-content: center;\n"], ["\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\tjustify-content: center;\n"])));
var StandardButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__components_Button_styles__["b" /* Button */])(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin: 20px 5px;\n\t", "\n"], ["\n\tmargin: 20px 5px;\n\t",
    "\n"])), function (props) { return props.disabled
    ? "cursor: auto;\n\t\t\tborder: 1px solid " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey400 + ";\n\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey400 + ";\n\t\t\tfont-size: 14px;\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\t\t\tflex-basis: 25%;\n\t\t\t}\n\t\t"
    : "\t@media " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\t\t\tflex: 0 1 50%;\n\t\t\t}"; });
var mediaCommonStyle = "\n\theight: 180px;\n\twidth: 180px;\n\tmargin-right: 30px;\n\tflex-shrink: 0;\n\n\t@media " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\theight: 120px;\n\t\twidth: 120px;\n\t\tmargin-right: 20px;\n\t}\n";
var BackgroundImage = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tbackground-image: url(\"", "\");\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\t", "\n"], ["\n\tbackground-image: url(\"", "\");\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\t", "\n"])), function (props) { return props.src; }, mediaCommonStyle);
var TitleContainer = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n\tjustify-content: center;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n\tjustify-content: center;\n"])));
var Title = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tfont-size: 18px;\n\toverflow: hidden;\n\tword-break: break-word;\n\tmargin-bottom: 5px;\n"], ["\n\tfont-size: 18px;\n\toverflow: hidden;\n\tword-break: break-word;\n\tmargin-bottom: 5px;\n"])));
var SubTitle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tfont-size: 12px;\n\toverflow: hidden;\n\tword-break: break-all;\n"], ["\n\tfont-size: 12px;\n\toverflow: hidden;\n\tword-break: break-all;\n"])));
var DescriptionRow = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tborder-bottom: 1px solid ", ";\n\tpadding: 40px 0;\n"], ["\n\tborder-bottom: 1px solid ", ";\n\tpadding: 40px 0;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey100);
var DescriptionLabel = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tmargin-bottom: 30px;\n"], ["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tmargin-bottom: 30px;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Black);
var DescriptionText = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\tcolor: ", ";\n\tfont-size: 13px;\n"], ["\n\tcolor: ", ";\n\tfont-size: 13px;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey400);
var InfoRow = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\tborder-bottom: 1px solid ", ";\n\tpadding: 20px 0;\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tborder-bottom: 1px solid ", ";\n\tpadding: 20px 0;\n\tdisplay: flex;\n\talign-items: center;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Grey100);
var InfoLabel = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tflex-shrink: 0;\n\tmargin: 0 10px;\n"], ["\n\tcolor: ", ";\n\tfont-weight: 600;\n\tflex-shrink: 0;\n\tmargin: 0 10px;\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["c" /* StyleColor */].Black);
var InfoText = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n\tflex-grow: 1;\n\ttext-align: right;\n\t", "\n"], ["\n\tflex-grow: 1;\n\ttext-align: right;\n\t", "\n"])), function (props) { return props.uppercase ? 'text-transform: uppercase;' : ''; });
var DriveItemActionIcons = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\n\tsvg {\n\t\ttransition: all 0.2s;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\n\tsvg {\n\t\ttransition: all 0.2s;\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.theme.primary.iconsColor; });
var PublicationCoverContainer = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n\tdisplay: flex;\n\tmargin: 30px 0 0 0;\n\tflex-wrap: nowrap;\n\toverflow: auto;\n"], ["\n\tdisplay: flex;\n\tmargin: 30px 0 0 0;\n\tflex-wrap: nowrap;\n\toverflow: auto;\n"])));
var PublicationCoverImage = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('img')(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n\theight: 180px;\n\twidth: auto;\n\tmargin: 0 20px 30px 0;\n\tflex-shrink: 0;\n\n\t@media ", " {\n\t\theight: 210px;\n\t}\n\n\t@media ", " {\n\t\theight: 230px;\n\t}\n\n\t@media ", " {\n\t\theight: 260px;\n\t}\n"], ["\n\theight: 180px;\n\twidth: auto;\n\tmargin: 0 20px 30px 0;\n\tflex-shrink: 0;\n\n\t@media ", " {\n\t\theight: 210px;\n\t}\n\n\t@media ", " {\n\t\theight: 230px;\n\t}\n\n\t@media ", " {\n\t\theight: 260px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["a" /* Format */].MediumDesktop);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DeleteButton__ = __webpack_require__(1460);


var mapStateToProps = function (state) {
    var _a = state.downloadManager, isDeletingAll = _a.isDeletingAll, _b = _a.downloadGroups, isDownloadingAll = _b.all.isDownloading, isDownloadingImportant = _b.important.isDownloading;
    var isDownloadingGroup = isDownloadingAll || isDownloadingImportant;
    return { isDeletingAll: isDeletingAll, isDownloadingGroup: isDownloadingGroup };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DeleteButton__["a" /* default */]));


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var Checkbox = function (_a) {
    var name = _a.name, label = _a.label, isChecked = _a.isChecked, onChange = _a.onChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", name: name, checked: isChecked, onChange: onChange }),
            isChecked && __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_check-1'),
            label)));
};
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_MediaEditor__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);



var isPropInData = function (prop, data) { return (prop in data ? data[prop] : undefined); };
var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, editorType = _a.type, editableLinks = _a.editableLinks, activeItem = _a.activeItem, isEditPanelDisplayed = _a.editPanel.isDisplayed, isAccessibleVersion = _a.isAccessibleVersion, byId = state.importManager.byId;
    if (ownProps.isCustom) {
        return {};
    }
    var page = ownProps.page, editableMediaItem = ownProps.editableMediaItem;
    var id = editableMediaItem.id;
    var type = editableMediaItem.type, frameWidth = editableMediaItem.frameWidth, frameHeight = editableMediaItem.frameHeight, canDragAndResize = editableMediaItem.canDragAndResize, importManagerId = editableMediaItem.importManagerId, defaultLink = editableMediaItem.defaultLink, driveLink = editableMediaItem.driveLink, externalLink = editableMediaItem.externalLink, isExternalLinkActive = editableMediaItem.isExternalLinkActive, isVisible = editableMediaItem.isVisible, isInsideButton = editableMediaItem.isInsideButton;
    var editableLinksIds = Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["o" /* getPageEditableLinksIds */])(state, page);
    var hasLink = editableLinksIds.includes(id);
    var importManagerItem = byId[importManagerId];
    var isProcessingVideo = !!importManagerItem && !!importManagerItem.isProcessing;
    return {
        editorType: editorType,
        type: type,
        frameWidth: frameWidth,
        frameHeight: frameHeight,
        canDragAndResize: canDragAndResize,
        isActive: id === activeItem.id && page === activeItem.page,
        isEditPanelDisplayed: isEditPanelDisplayed,
        hasLink: hasLink,
        linkValue: hasLink ?
            editableLinks[page][id].linkData ? editableLinks[page][id].linkData : '' :
            undefined,
        isProcessingVideo: isProcessingVideo,
        isDefaultMedia: isExternalLinkActive ? externalLink === defaultLink : !driveLink,
        frameAspectRatio: isPropInData('frameAspectRatio', editableMediaItem),
        defaultStyle: isPropInData('style', editableMediaItem),
        isVisible: isVisible,
        isInsideButton: isInsideButton,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_MediaEditor__["a" /* default */]));


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FileName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonBackWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var FileName = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tmargin-bottom: 15px;\n\tpadding-left: 40px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\n\t> svg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 10px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: relative;\n\tmargin-bottom: 15px;\n\tpadding-left: 40px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\n\t> svg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 10px;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: currentColor;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var ButtonBackWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-bottom: 15px;\n"], ["\n\tmargin-bottom: 15px;\n"])));

var templateObject_1, templateObject_2;


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkPanel_LinkPanelInput_styles__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonRemove__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var YoutubeLinkPanel = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](value), 2), inputValue = _b[0], setInputValue = _b[1];
    var handleInputChange = function (_a) {
        var value = _a.target.value;
        var youtubeLink = Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__["T" /* getYoutubeLink */])(value);
        if (youtubeLink) {
            setInputValue(youtubeLink);
            onChange(youtubeLink);
        }
    };
    var handleRemove = function () {
        setInputValue('');
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setInputValue(value);
    }, [value]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* Label */], { value: "messages.copy_paste_your_link" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* InputWrapper */], { hasLabel: true, hasButtonAdd: false, hasButtonRemove: !!inputValue },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__LinkPanel_LinkPanelInput_styles__["b" /* IconLink */], { isYoutubeIcon: true }, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_youtube_logo')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", value: inputValue, readOnly: !!inputValue, placeholder: "https://www.youtube.com/watch", onChange: handleInputChange }),
            !!inputValue &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ButtonRemove__["a" /* default */], { onClick: handleRemove }))));
};
/* harmony default export */ __webpack_exports__["a"] = (YoutubeLinkPanel);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonAdd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var IconLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 9px;\n\tleft: 9px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 22px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 9px;\n\tleft: 9px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 22px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.isYoutubeIcon ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450; }, function (props) { return props.isYoutubeIcon ? '30px' : '14px'; }, function (props) { return props.isYoutubeIcon ? '22px' : '14px'; }, function (props) { return props.isYoutubeIcon ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Red300 : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White; });
var ButtonAdd = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 9px;\n\tright: 39px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder: 2px solid ", ";\n\tborder-radius: 50%;\n\tbackground-color: transparent;\n\toutline: 0;\n\tcursor: pointer;\n\n\t", "\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\tsvg {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 9px;\n\tright: 39px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder: 2px solid ", ";\n\tborder-radius: 50%;\n\tbackground-color: transparent;\n\toutline: 0;\n\tcursor: pointer;\n\n\t",
    "\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\tsvg {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);

var templateObject_1, templateObject_2;


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RadioButtons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var PageTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 10px 0 5px 10px;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tpadding: 10px 0 5px 10px;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var PageInput = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('input')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 50px!important;\n\tpadding: 10px!important;\n"], ["\n\twidth: 50px!important;\n\tpadding: 10px!important;\n"])));
var RadioButtons = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\twhite-space: nowrap;\n\twidth: 100%;\n\tmax-width: 100%;\n\tmin-width: 0;\n\tmargin-bottom: -15px;\n\n\t> label {\n\t\tdisplay: inline-flex;\n\t\tflex-wrap: nowrap;\n\t\talign-items: center;\n\t\tmargin-bottom: 15px;\n\t\twhite-space: nowrap;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\twhite-space: nowrap;\n\twidth: 100%;\n\tmax-width: 100%;\n\tmin-width: 0;\n\tmargin-bottom: -15px;\n\n\t> label {\n\t\tdisplay: inline-flex;\n\t\tflex-wrap: nowrap;\n\t\talign-items: center;\n\t\tmargin-bottom: 15px;\n\t\twhite-space: nowrap;\n\t}\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaRnd__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var getDefaultImage = function (type) {
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].animation:
            return 'iconset_uprez_animation';
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].video:
            return 'iconset_uprez_play-button';
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].image:
        default:
            return 'iconset_uprez_image';
    }
};
var MediaItem = function (_a) {
    var editorType = _a.editorType, type = _a.type, src = _a.src, scale = _a.scale, isEditedFromBackoffice = _a.isEditedFromBackoffice, isActive = _a.isActive, isLoaded = _a.isLoaded, isDefaultMedia = _a.isDefaultMedia, onAfterLoad = _a.onAfterLoad, page = _a.page, id = _a.id, frameWidth = _a.frameWidth, frameHeight = _a.frameHeight, width = _a.width, height = _a.height, x = _a.x, y = _a.y, canDragAndResize = _a.canDragAndResize, isKeyActionsDisabled = _a.isKeyActionsDisabled, dispatch = _a.dispatch, isCustom = _a.isCustom, parentContainer = _a.parentContainer, iframeContainer = _a.iframeContainer, frameAspectRatio = _a.frameAspectRatio, onLoad = _a.onLoad, onClick = _a.onClick, onClickOutside = _a.onClickOutside, isAccessibleVersion = _a.isAccessibleVersion, originalStyle = _a.originalStyle;
    var imgElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isError = _b[0], setIsError = _b[1];
    var handleLoad = function () {
        setIsError(false);
        if (isLoaded) {
            return;
        }
        if (isCustom && onLoad) {
            var _a = imgElement.current, naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight;
            onLoad(naturalWidth, naturalHeight);
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, {
                isLoaded: true,
                isEditedFromBackoffice: isEditedFromBackoffice,
            }, false, false));
        }
        onAfterLoad();
    };
    var handleClick = function () {
        if (editorType !== __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["e" /* EditorType */].HTML || !parentContainer) {
            return;
        }
        var _a = parentContainer.getBoundingClientRect(), frameWidth = _a.width, frameHeight = _a.height;
        var _b = imgElement.current, naturalWidth = _b.naturalWidth, naturalHeight = _b.naturalHeight, _c = _b.style, width = _c.width, top = _c.top, left = _c.left;
        var imageAspectRatio = naturalHeight / naturalWidth;
        var data = {
            frameWidth: frameWidth,
            frameHeight: frameHeight,
            width: Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(width),
            height: ((frameWidth * Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(width)) * imageAspectRatio) / frameHeight,
            x: Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(left),
            y: Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(top),
            isEditedFromBackoffice: isEditedFromBackoffice,
        };
        if (isDefaultMedia) {
            // keep aspect ratio from default media to calculate height of frame in <MediaEditor>
            // and use it on Reader side too (via data-uprez-aspect-ratio attribute)
            data.frameAspectRatio = imageAspectRatio;
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, data, false));
        if (onClick) {
            onClick();
        }
    };
    // set frame sizes for custom media on component mount
    // it can be done only when parentContainer is rendered
    // IntersectionObserver is used because parentContainer can be hidden on mount (e.g., in slider) so its width equals 0 which causes incorrect calculation
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType !== __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["e" /* EditorType */].HTML || !parentContainer || isDefaultMedia) {
            return;
        }
        var handleIntersect = function (entries) {
            entries.forEach(function (_a) {
                var isIntersecting = _a.isIntersecting;
                if (isIntersecting) {
                    var frameWidth_1 = parentContainer.getBoundingClientRect().width;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, {
                        frameWidth: frameWidth_1,
                        frameHeight: frameWidth_1 * frameAspectRatio,
                    }, false));
                }
            });
        };
        var observer = new IntersectionObserver(handleIntersect);
        observer.observe(parentContainer);
        return function () {
            observer.unobserve(parentContainer);
        };
    }, []);
    var hasImageStyle = editorType === __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["e" /* EditorType */].HTML &&
        type === __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].image &&
        !isActive &&
        !isDefaultMedia;
    var imageStyle;
    if (isAccessibleVersion && originalStyle && type === __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].image) {
        var styleObj_1 = {};
        originalStyle.split(';').forEach(function (rule) {
            var _a = __read(rule.split(':').map(function (s) { return s.trim(); }), 2), key = _a[0], value = _a[1];
            if (key && value) {
                // Convert CSS property names to camelCase for React
                var camelKey = key.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
                styleObj_1[camelKey] = value;
            }
        });
        imageStyle = styleObj_1;
    }
    else if (hasImageStyle) {
        imageStyle = {
            position: 'absolute',
            width: width + "%",
            height: 'auto',
            top: y + "%",
            left: x + "%",
        };
    }
    var Image = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { 
            // prop key is used to remove previous loaded image in order to display new image uploading
            key: src, ref: imgElement, src: src, alt: "", hidden: isError, onLoad: handleLoad, onError: function () { return setIsError(true); }, onDragStart: function (e) { return e.preventDefault(); }, onClick: handleClick, style: imageStyle }),
        isError && __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon(getDefaultImage(type), { onClick: handleClick })));
    if (canDragAndResize) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaRnd__["a" /* default */], { id: id, page: page, frameWidth: frameWidth, frameHeight: frameHeight, width: width, height: height, x: x, y: y, scale: scale, isActive: isActive, isLoaded: isLoaded, isKeyActionsDisabled: isKeyActionsDisabled, dispatch: dispatch, isCustom: isCustom, onClickOutside: onClickOutside, iframeContainer: iframeContainer, isPercentageValues: editorType === __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["e" /* EditorType */].HTML }, Image));
    }
    return Image;
};
/* harmony default export */ __webpack_exports__["a"] = (MediaItem);


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_customHooks_useClickOutside__ = __webpack_require__(149);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var HeaderDropdown = function (_a) {
    var buttonLabel = _a.buttonLabel, dropdownTitle = _a.dropdownTitle, color = _a.color, isDisabled = _a.isDisabled, options = _a.options, onButtonClick = _a.onButtonClick;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isOpened = _b[0], setIsOpened = _b[1];
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_customHooks_useClickOutside__["a" /* default */])(wrapperElement, isOpened, function () { return setIsOpened(false); });
    var hasDropdown = options && options.length > 0;
    var handleButtonClick = function () {
        if (onButtonClick) {
            return onButtonClick();
        }
        setIsOpened(function (isOpened) { return !isOpened; });
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Wrapper */], { ref: wrapperElement },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { color: color, isOpened: isOpened, disabled: isDisabled, hasDropdown: hasDropdown, onClick: handleButtonClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: buttonLabel }),
            hasDropdown && __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_right')),
        isOpened && hasDropdown &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Content */], null,
                dropdownTitle &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ContentHeader */], null, dropdownTitle),
                options.map(function (_a, index) {
                    var label = _a.label, icon = _a.icon, onClick = _a.onClick;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* OptionButton */], { key: label + "-" + index, onClick: onClick, iconWidth: icon ? icon.width : undefined, iconHeight: icon ? icon.height : undefined, isRotatingIcon: icon ? icon.isRotating : undefined },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label }),
                        icon && __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon(icon.name)));
                }))));
};
/* harmony default export */ __webpack_exports__["a"] = (HeaderDropdown);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopupBodyWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var PopupBodyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 15px;\n"], ["\n\tpadding: 15px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 0 15px;\n\tborder-radius: 8px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 44px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t", "\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 12px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 0 15px;\n\tborder-radius: 8px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 44px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t",
    "\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ", ";\n\t}\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 12px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 10), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75), function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tpointer-events: none;\n\t\topacity: 0.5;\n\t";
}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 25), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 30));
var Message = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tmargin-top: 10px;\n\tfont-style: italic;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-right: 5px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tdisplay: flex;\n\tmargin-top: 10px;\n\tfont-style: italic;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tmargin-right: 5px;\n\t\tfill: currentColor;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_keys__ = __webpack_require__(118);




var InnerPanel = function (_a) {
    var onConfirm = _a.onConfirm, onClose = _a.onClose, children = _a.children, isError = _a.isError;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var handleKeyDown = function (e) {
            if (__WEBPACK_IMPORTED_MODULE_3__utils_keys__["a" /* default */].isEnter(e.key)) {
                e.preventDefault();
                onConfirm();
            }
            if (__WEBPACK_IMPORTED_MODULE_3__utils_keys__["a" /* default */].isEsc(e.key)) {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose, onConfirm]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Header */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* HeaderButton */], { onClick: onClose },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* HeaderLabel */], { value: "messages.add" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* HeaderButton */], { disabled: isError, onClick: onConfirm },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.ok" }))),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (InnerPanel);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RichTextEditor_helpers_constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var Select = function (_a) {
    var label = _a.label, value = _a.value, options = _a.options, onChange = _a.onChange, isColorSelect = _a.isColorSelect, isFontSelect = _a.isFontSelect, isLineHeightSelect = _a.isLineHeightSelect, isListTypeSelect = _a.isListTypeSelect, optionsLabel = _a.optionsLabel;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isOptionsDisplayed = _b[0], setIsOptionsDisplayed = _b[1];
    var getSelectedValue = function (value) {
        if (isFontSelect) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { fontFamily: value } }, value.split(',')[0].replace(/\'|\"/g, '')));
        }
        if (isColorSelect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Color */], { style: { backgroundColor: value } });
        }
        if (isLineHeightSelect && value === 'normal') {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.normal" });
        }
        if (isListTypeSelect && value !== __WEBPACK_IMPORTED_MODULE_3__RichTextEditor_helpers_constants__["d" /* LIST_TYPE */].NONE) {
            var icon = value === __WEBPACK_IMPORTED_MODULE_3__RichTextEditor_helpers_constants__["d" /* LIST_TYPE */].ORDERED
                ? 'iconset_uprez_numbered_list'
                : 'iconset_uprez_bulleted_list';
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* ListTypeOption */], null, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon(icon)));
        }
        var selectedOption = options.find(function (_a) {
            var values = _a.values;
            return values.includes(value);
        });
        return selectedOption ? selectedOption.label : value;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["m" /* StyledSelect */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* Label */], { value: label }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* ButtonValue */], { type: "button", onClick: function () { return setIsOptionsDisplayed(true); } }, getSelectedValue(value)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonIcon */], { type: "button", onClick: function () { return setIsOptionsDisplayed(true); } }, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_back')),
        isOptionsDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* Options */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* OptionsHeader */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonBack */], { type: "button", onClick: function () { return setIsOptionsDisplayed(false); } },
                        __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_back'),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.back" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: optionsLabel || label })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["l" /* OptionsListWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["j" /* OptionsList */], null, options.map(function (option) {
                        var isSelected = option.values.includes(value);
                        var handleClick = function () {
                            onChange(option.values[0]);
                        };
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["k" /* OptionsListItem */], { key: option.values[0] },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ButtonOption */], { type: "button", onClick: handleClick },
                                isSelected && __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_uprez_check'),
                                option.displayedLabel || option.label)));
                    }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Select);


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(369);
var IE8_DOM_DEFINE = __webpack_require__(1568);
var toPrimitive = __webpack_require__(1569);
var dP = Object.defineProperty;

exports.f = __webpack_require__(156) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(258);
var document = __webpack_require__(257).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 617 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(1574);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 619 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 620 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(1578)('keys');
var uid = __webpack_require__(1580);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 622 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1583);

/***/ }),
/* 624 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(619);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* unused harmony export combineReducers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(284);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(128);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  Object(__WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1593);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(633);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(634);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(636);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore =
/*#__PURE__*/
createStoreHook();

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(128);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */]);

  if (false) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThumbOverlap = exports.assertUnreachable = exports.voidFn = exports.getTrackBackground = exports.replaceAt = exports.schd = exports.translate = exports.getClosestThumbIndex = exports.translateThumbs = exports.getPaddingAndBorder = exports.getMargin = exports.checkInitialOverlap = exports.checkValuesAgainstBoundaries = exports.checkBoundaries = exports.isVertical = exports.relativeValue = exports.normalizeValue = exports.isStepDivisible = exports.isTouchEvent = exports.getStepDecimals = void 0;
var react_1 = __webpack_require__(0);
var types_1 = __webpack_require__(375);
var getStepDecimals = function (step) {
    var decimals = step.toString().split('.')[1];
    return decimals ? decimals.length : 0;
};
exports.getStepDecimals = getStepDecimals;
function isTouchEvent(event) {
    return ((event.touches && event.touches.length) ||
        (event.changedTouches && event.changedTouches.length));
}
exports.isTouchEvent = isTouchEvent;
function isStepDivisible(min, max, step) {
    var res = (max - min) / step;
    var precision = 8;
    var roundedRes = Number(res.toFixed(precision));
    return parseInt(roundedRes.toString(), 10) === roundedRes;
}
exports.isStepDivisible = isStepDivisible;
function normalizeValue(value, index, min, max, step, allowOverlap, values) {
    var BIG_NUM = 10e10;
    value = Math.round(value * BIG_NUM) / BIG_NUM;
    if (!allowOverlap) {
        var prev = values[index - 1];
        var next = values[index + 1];
        if (prev && prev > value)
            return prev;
        if (next && next < value)
            return next;
    }
    if (value > max)
        return max;
    if (value < min)
        return min;
    // `remainder` is a difference between the given value and a full step value
    // that is closest lower to the given value and is in the range between the min value
    // and the given value
    var remainder = Math.floor(value * BIG_NUM - min * BIG_NUM) %
        Math.floor(step * BIG_NUM);
    var closestLowerNum = Math.floor(value * BIG_NUM - Math.abs(remainder));
    var rounded = remainder === 0 ? value : closestLowerNum / BIG_NUM;
    // Values with a remainder `< step/2` are rounded to the closest lower value
    // while values with a remainder `= > step/2` are rounded to the closest bigger value
    var res = Math.abs(remainder / BIG_NUM) < step / 2
        ? rounded
        : rounded + step;
    var decimalPlaces = exports.getStepDecimals(step);
    return parseFloat(res.toFixed(decimalPlaces));
}
exports.normalizeValue = normalizeValue;
function relativeValue(value, min, max) {
    return (value - min) / (max - min);
}
exports.relativeValue = relativeValue;
function isVertical(direction) {
    return direction === types_1.Direction.Up || direction === types_1.Direction.Down;
}
exports.isVertical = isVertical;
function checkBoundaries(value, min, max) {
    if (min >= max) {
        throw new RangeError("min (" + min + ") is equal/bigger than max (" + max + ")");
    }
    if (value < min) {
        throw new RangeError("value (" + value + ") is smaller than min (" + min + ")");
    }
    if (value > max) {
        throw new RangeError("value (" + value + ") is bigger than max (" + max + ")");
    }
}
exports.checkBoundaries = checkBoundaries;
function checkValuesAgainstBoundaries(value, min, max) {
    if (value < min) {
        // set selectedValue to min
        return min;
    }
    if (value > max) {
        // set selectedValue to max
        return max;
    }
    else {
        return value;
    }
}
exports.checkValuesAgainstBoundaries = checkValuesAgainstBoundaries;
function checkInitialOverlap(values) {
    if (values.length < 2)
        return;
    if (!values.slice(1).every(function (item, i) { return values[i] <= item; })) {
        throw new RangeError("values={[" + values + "]} needs to be sorted when allowOverlap={false}");
    }
}
exports.checkInitialOverlap = checkInitialOverlap;
function getMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        top: parseInt(style['margin-top'], 10),
        bottom: parseInt(style['margin-bottom'], 10),
        left: parseInt(style['margin-left'], 10),
        right: parseInt(style['margin-right'], 10)
    };
}
exports.getMargin = getMargin;
function getPaddingAndBorder(element) {
    var style = window.getComputedStyle(element);
    return {
        top: parseInt(style['padding-top'], 10) + parseInt(style['border-top-width'], 10),
        bottom: parseInt(style['padding-bottom'], 10) + parseInt(style['border-bottom-width'], 10),
        left: parseInt(style['padding-left'], 10) + parseInt(style['border-left-width'], 10),
        right: parseInt(style['padding-right'], 10) + parseInt(style['border-right-width'], 10),
    };
}
exports.getPaddingAndBorder = getPaddingAndBorder;
function translateThumbs(elements, offsets, rtl) {
    var inverter = rtl ? -1 : 1;
    elements.forEach(function (element, index) {
        return translate(element, inverter * offsets[index].x, offsets[index].y);
    });
}
exports.translateThumbs = translateThumbs;
/**
 * Util function for calculating the index of the thumb that is closes to a given position
 * @param thumbs - array of Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */
function getClosestThumbIndex(thumbs, clientX, clientY, direction) {
    var thumbIndex = 0;
    var minThumbDistance = getThumbDistance(thumbs[0], clientX, clientY, direction);
    for (var i = 1; i < thumbs.length; i++) {
        var thumbDistance = getThumbDistance(thumbs[i], clientX, clientY, direction);
        if (thumbDistance < minThumbDistance) {
            minThumbDistance = thumbDistance;
            thumbIndex = i;
        }
    }
    return thumbIndex;
}
exports.getClosestThumbIndex = getClosestThumbIndex;
function translate(element, x, y) {
    element.style.transform = "translate(" + x + "px, " + y + "px)";
}
exports.translate = translate;
// adapted from https://github.com/alexreardon/raf-schd
var schd = function (fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        lastArgs = args;
        if (frameId) {
            return;
        }
        frameId = requestAnimationFrame(function () {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    return wrapperFn;
};
exports.schd = schd;
function replaceAt(values, index, value) {
    var ret = values.slice(0);
    ret[index] = value;
    return ret;
}
exports.replaceAt = replaceAt;
function getTrackBackground(_a) {
    var values = _a.values, colors = _a.colors, min = _a.min, max = _a.max, _b = _a.direction, direction = _b === void 0 ? types_1.Direction.Right : _b, _c = _a.rtl, rtl = _c === void 0 ? false : _c;
    if (rtl && direction === types_1.Direction.Right) {
        direction = types_1.Direction.Left;
    }
    else if (rtl && types_1.Direction.Left) {
        direction = types_1.Direction.Right;
    }
    // sort values ascending
    var progress = values.slice(0).sort(function (a, b) { return a - b; }).map(function (value) { return ((value - min) / (max - min)) * 100; });
    var middle = progress.reduce(function (acc, point, index) {
        return acc + ", " + colors[index] + " " + point + "%, " + colors[index + 1] + " " + point + "%";
    }, '');
    return "linear-gradient(" + direction + ", " + colors[0] + " 0%" + middle + ", " + colors[colors.length - 1] + " 100%)";
}
exports.getTrackBackground = getTrackBackground;
function voidFn() { }
exports.voidFn = voidFn;
function assertUnreachable(x) {
    throw new Error("Didn't expect to get here");
}
exports.assertUnreachable = assertUnreachable;
/**
 * Util function for grabbing the true largest width of a thumb
 * including the label
 * @param thumbEl - Thumb element to grab the largest width from
 * @param value - Thumb value, not label value
 * @param separator - Label separator value
 */
var getThumbWidth = function (thumbEl, value, separator, decimalPlaces, valueToLabel) {
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var width = Math.ceil(__spreadArrays([thumbEl], Array.from(thumbEl.children)).reduce(function (width, el) {
        var elWidth = Math.ceil(el.getBoundingClientRect().width);
        /**
         * If a label contains a merged label value, it won't return the true
         * label width for that Thumb. Clone the label and change the value
         * to that individual Thumb value in order to grab the true width.
         */
        if (el.innerText &&
            el.innerText.includes(separator) &&
            el.childElementCount === 0) {
            var elClone = el.cloneNode(true);
            elClone.innerHTML = valueToLabel(value.toFixed(decimalPlaces));
            elClone.style.visibility = 'hidden';
            document.body.appendChild(elClone);
            elWidth = Math.ceil(elClone.getBoundingClientRect().width);
            document.body.removeChild(elClone);
        }
        return elWidth > width ? elWidth : width;
    }, thumbEl.getBoundingClientRect().width));
    return width;
};
/**
 * Bulk of logic for thumb overlaps
 * Consider a scenario with 5 thumbs;
 * Thumb 1 overlaps with thumb 0 and thumb 2
 * Thumb 2 overlaps with thumb 3
 * We need an array that contains [0, 1, 2, 3]
 * The function needs to return the directly overlapping thumbs
 * and all thumbs overlapping linked to those and so on
 * @param index - Thumb index calculating overlaps for
 * @param offsets - Current Array of Thumb offsets for Range
 * @param thumbs - Array of Thumb elements
 * @param values - Array of Thumb values
 * @param separator - String separator for merged label values
 * @returns overlaps - Array of all overlapping thumbs from the index
 */
var getOverlaps = function (index, offsets, thumbs, values, separator, decimalPlaces, valueToLabel) {
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var overlaps = [];
    /**
     * Recursive function for building the overlaps Array
     * If an overlap is found, find the overlaps for that overlap
     * @param thumbIndex current Thumb index to find overlaps from
     */
    var buildOverlaps = function (thumbIndex) {
        var thumbXWidth = getThumbWidth(thumbs[thumbIndex], values[thumbIndex], separator, decimalPlaces, valueToLabel);
        var thumbX = offsets[thumbIndex].x;
        /**
         * Iterate through the Thumb offsets, if there is a match
         * add the thumbIndex and siblingIndex to the overlaps Array
         *
         * Then build overlaps from the overlapping siblingIndex
         */
        offsets.forEach(function (_a, siblingIndex) {
            var siblingX = _a.x;
            var siblingWidth = getThumbWidth(thumbs[siblingIndex], values[siblingIndex], separator, decimalPlaces, valueToLabel);
            if (thumbIndex !== siblingIndex &&
                ((thumbX >= siblingX && thumbX <= siblingX + siblingWidth) ||
                    (thumbX + thumbXWidth >= siblingX &&
                        thumbX + thumbXWidth <= siblingX + siblingWidth))) {
                if (!overlaps.includes(siblingIndex)) {
                    overlaps.push(thumbIndex);
                    overlaps.push(siblingIndex);
                    overlaps = __spreadArrays(overlaps, [thumbIndex, siblingIndex]);
                    buildOverlaps(siblingIndex);
                }
            }
        });
    };
    buildOverlaps(index);
    // Sort and remove duplicates from the built overlaps
    return Array.from(new Set(overlaps.sort()));
};
/**
 * A custom React Hook for calculating whether a thumb overlaps
 * another and whether labels could/should merge.
 * @param rangeRef - React ref value of Range component
 * @param values - current Range values Array
 * @param index - thumb index
 * @param step - step value, used to calculate the number of decimal places
 * @param separator - string to separate thumb values
 * @returns label value + styling for thumb label
 */
var useThumbOverlap = function (rangeRef, values, index, step, separator, valueToLabel) {
    if (step === void 0) { step = 0.1; }
    if (separator === void 0) { separator = ' - '; }
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var decimalPlaces = exports.getStepDecimals(step);
    // Create initial label style and value. Label value defaults to thumb value
    var _a = react_1.useState({}), labelStyle = _a[0], setLabelStyle = _a[1];
    var _b = react_1.useState(valueToLabel(values[index].toFixed(decimalPlaces))), labelValue = _b[0], setLabelValue = _b[1];
    // When the rangeRef or values change, update the Thumb label values and styling
    react_1.useEffect(function () {
        if (rangeRef) {
            var thumbs = rangeRef.getThumbs();
            if (thumbs.length < 1)
                return;
            var newStyle = {};
            var offsets_1 = rangeRef.getOffsets();
            /**
             * Get any overlaps for the given Thumb index. This must return all linked
             * Thumbs. So if there are 4 Thumbs and Thumbs 2, 3 and 4 overlap. If we are
             * getting the overlaps for Thumb 1 and it overlaps only Thumb 2, we must get
             * 2, 3 and 4 also.
             */
            var overlaps = getOverlaps(index, offsets_1, thumbs, values, separator, decimalPlaces, valueToLabel);
            // Set a default label value of the Thumb value
            var labelValue_1 = valueToLabel(values[index].toFixed(decimalPlaces));
            /**
             * If there are overlaps for the Thumb, we need to calculate the correct
             * Label value along with the relevant styling. We only want to show a Label
             * for the left most Thumb in an overlapping set.
             * All other Thumbs will be set to display: none.
             */
            if (overlaps.length) {
                /**
                 * Get an Array of the offsets for the overlapping Thumbs
                 * This is so we can determine if the Thumb we are looking at
                 * is the left most thumb in an overlapping set
                 */
                var offsetsX = overlaps.reduce(function (a, c, i, s) {
                    return a.length ? __spreadArrays(a, [offsets_1[s[i]].x]) : [offsets_1[s[i]].x];
                }, []);
                /**
                 * If our Thumb is the left most Thumb, we can build a Label value
                 * and set the style for that Label
                 */
                if (Math.min.apply(Math, offsetsX) === offsets_1[index].x) {
                    /**
                     * First calculate the Label value. To do this,
                     * grab all the values for the Thumbs in our overlaps.
                     * Then convert that to a Set and sort it whilst removing duplicates.
                     */
                    var labelValues_1 = [];
                    overlaps.forEach(function (thumb) {
                        labelValues_1.push(values[thumb].toFixed(decimalPlaces));
                    });
                    /**
                     *  Update the labelValue with the resulting Array
                     *  joined by our defined separator
                     */
                    labelValue_1 = Array.from(new Set(labelValues_1.sort(function (a, b) { return parseFloat(a) - parseFloat(b); })))
                        .map(valueToLabel)
                        .join(separator);
                    /**
                     * Lastly, build the label styling. The label styling will
                     * position the label and apply a transform so that it's centered.
                     * We want the center point between the left edge of the left most Thumb
                     * and the right edge of the right most Thumb.
                     */
                    var first = Math.min.apply(Math, offsetsX);
                    var last = Math.max.apply(Math, offsetsX);
                    var lastWidth = thumbs[overlaps[offsetsX.indexOf(last)]].getBoundingClientRect().width;
                    newStyle.left = Math.abs(first - (last + lastWidth)) / 2 + "px";
                    newStyle.transform = 'translate(-50%, 0)';
                }
                else {
                    // If the Thumb isn't the left most Thumb, hide the Label!
                    newStyle.visibility = 'hidden';
                }
            }
            // Update the label value and style
            setLabelValue(labelValue_1);
            setLabelStyle(newStyle);
        }
    }, [rangeRef, values]);
    return [labelValue, labelStyle];
};
exports.useThumbOverlap = useThumbOverlap;
/**
 * Util function for calculating the distance of the center of a thumb
 * form a given mouse/touch target's position
 * @param thumbEl - Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */
function getThumbDistance(thumbEl, clientX, clientY, direction) {
    var _a = thumbEl.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
    return isVertical(direction) ? Math.abs(clientY - (top + height / 2)) : Math.abs(clientX - (left + width / 2));
}


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderManager__ = __webpack_require__(1655);


var mapStateToProps = function (state) {
    var config = state.galleryInfos.config;
    return {
        config: config,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderManager__["a" /* default */]));


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProgressBar__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var getSlideIconName = function (type, isExternalLink) {
    if (isExternalLink) {
        return 'iconset_youtube_logo';
    }
    return type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemFileTypes.IMAGE
        ? 'iconset_gallery-bold'
        : 'iconset_uprez_video_rounded';
};
var PortalAwareItem = function (_a) {
    var index = _a.index, _b = _a.item, id = _b.id, type = _b.type, label = _b.label, isExternalLink = _b.isExternalLink, slideText = _b.slideText, previewUrl = _a.previewUrl, isImporting = _a.isImporting, importPercentage = _a.importPercentage, importError = _a.importError, isDragDisabled = _a.isDragDisabled, onEdit = _a.onEdit, onRemove = _a.onRemove, provided = _a.provided, isDragging = _a.snapshot.isDragging;
    var item = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* Wrapper */], __assign({ ref: provided.innerRef }, provided.draggableProps, { isDragging: isDragging }),
        !isDragDisabled &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* IconMove */], __assign({}, provided.dragHandleProps), __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_6dots')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* PreviewWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* IconType */], { hasText: slideText && slideText.value }, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon(getSlideIconName(type, isExternalLink))),
            isImporting || importError
                ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ProgressBar__["a" /* default */], { percentage: importPercentage, error: importError })
                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* Preview */], { src: previewUrl })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Label */], null, isExternalLink
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.youtube_link" })
            : label),
        !isDragging &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ActionsWrapper */], null,
                !isImporting && !importError &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Button */], { onClick: function () { return onEdit(index); } }, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_uprez_write_bold')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Button */], { onClick: function () { return onRemove(id, index); }, isRemoveButton: true }, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_close-2')))));
    if (isDragging) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Portal__["a" /* default */], { parentNode: document.body }, item));
    }
    return item;
};
var Slide = function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["b" /* Draggable */], { draggableId: props.index.toString(), index: props.index, isDragDisabled: props.isDragDisabled }, function (provided, snapshot) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PortalAwareItem, __assign({}, props, { provided: provided, snapshot: snapshot }))); })); };
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["memo"](Slide));


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_CHROME */
/* unused harmony export IS_OPERA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_FIREFOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IS_SAFARI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_IE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_EDGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ANDROID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IS_IOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IS_MAC; });
/* unused harmony export IS_WINDOWS */
/* unused harmony export ANDROID_API_VERSION */
/* unused harmony export HAS_INPUT_EVENTS_LEVEL_1 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HAS_INPUT_EVENTS_LEVEL_2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(1684);


var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/**
 * Browser matching rules.
 *
 * @type {Array}
 */

var BROWSER_RULES = [['edge', /Edge\/([0-9\._]+)/], ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/], ['opera', /Opera\/([0-9\.]+)(?:\s|$)/], ['opera', /OPR\/([0-9\.]+)(:?\s|$)$/], ['ie', /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/], ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ['ie', /MSIE\s(7\.0)/], ['android', /Android\s([0-9\.]+)/], ['safari', /Version\/([0-9\._]+).*Safari/]];

var browser = void 0;

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = BROWSER_RULES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = slicedToArray(_ref, 2);

      var name = _ref2[0];
      var regexp = _ref2[1];

      if (regexp.test(window.navigator.userAgent)) {
        browser = name;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/**
 * Operating system matching rules.
 *
 * @type {Array}
 */

var OS_RULES = [['ios', /os ([\.\_\d]+) like mac os/i], // must be before the macos rule
['macos', /mac os x/i], ['android', /android/i], ['firefoxos', /mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/i], ['windows', /windows\s*(?:nt)?\s*([\.\_\d]+)/i]];

var os = void 0;

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = OS_RULES[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref3 = _step2.value;

      var _ref4 = slicedToArray(_ref3, 2);

      var _name = _ref4[0];
      var _regexp = _ref4[1];

      if (_regexp.test(window.navigator.userAgent)) {
        os = _name;
        break;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

/**
 * Feature matching rules.
 *
 * @type {Array}
 */

var FEATURE_RULES = [['inputeventslevel1', function (window) {
  var event = window.InputEvent ? new window.InputEvent('input') : {};
  var support = 'inputType' in event;
  return support;
}], ['inputeventslevel2', function (window) {
  var element = window.document.createElement('div');
  element.contentEditable = true;
  var support = 'onbeforeinput' in element;
  return support;
}]];

var features = [];

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = FEATURE_RULES[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _ref5 = _step3.value;

      var _ref6 = slicedToArray(_ref5, 2);

      var _name2 = _ref6[0];
      var test = _ref6[1];

      if (test(window)) {
        features.push(_name2);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}

/**
 * Array of regular expression matchers and their API version
 *
 * @type {Array}
 */

var ANDROID_API_VERSIONS = [[/^9([.]0|)/, 28], [/^8[.]1/, 27], [/^8([.]0|)/, 26], [/^7[.]1/, 25], [/^7([.]0|)/, 24], [/^6([.]0|)/, 23], [/^5[.]1/, 22], [/^5([.]0|)/, 21], [/^4[.]4/, 20]];

/**
 * get the Android API version from the userAgent
 *
 * @return {number} version
 */

function getAndroidApiVersion() {
  if (os !== 'android') return null;
  var userAgent = window.navigator.userAgent;

  var matchData = userAgent.match(/Android\s([0-9\.]+)/);
  if (matchData == null) return null;
  var versionString = matchData[1];

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = ANDROID_API_VERSIONS[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _ref7 = _step4.value;

      var _ref8 = slicedToArray(_ref7, 2);

      var regex = _ref8[0];
      var version = _ref8[1];

      if (versionString.match(regex)) return version;
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return null;
}

/**
 * Export.
 *
 * @type {Boolean}
 */

var IS_CHROME = browser === 'chrome';
var IS_OPERA = browser === 'opera';
var IS_FIREFOX = browser === 'firefox';
var IS_SAFARI = browser === 'safari';
var IS_IE = browser === 'ie';
var IS_EDGE = browser === 'edge';

var IS_ANDROID = os === 'android';
var IS_IOS = os === 'ios';
var IS_MAC = os === 'macos';
var IS_WINDOWS = os === 'windows';

var ANDROID_API_VERSION = getAndroidApiVersion();

var HAS_INPUT_EVENTS_LEVEL_1 = features.includes('inputeventslevel1');
var HAS_INPUT_EVENTS_LEVEL_2 = features.includes('inputeventslevel2') || IS_ANDROID && (ANDROID_API_VERSION === 28 || ANDROID_API_VERSION === null);


//# sourceMappingURL=slate-dev-environment.es.js.map


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreviewPageWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(46);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tpadding: ", "px;\n\ttransform: scale(", ");\n\ttransform-origin: ", ";\n"], ["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tpadding: ", "px;\n\ttransform: scale(", ");\n\ttransform-origin: ", ";\n"])), function (_a) {
    var zoom = _a.zoom;
    return __WEBPACK_IMPORTED_MODULE_1__styles__["g" /* PAGE_PADDING */] / zoom;
}, function (_a) {
    var zoom = _a.zoom;
    return zoom;
}, function (_a) {
    var zoom = _a.zoom;
    return zoom <= 1 ? 'center center' : '0 0';
});
var PreviewPageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 1 1 auto;\n\n\timg {\n\t\tbox-sizing: border-box;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: auto;\n\t\theight: auto;\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t\tmargin: auto;\n\t}\n\n\t&:first-child:not(:only-child) img {\n\t\tmargin-right: 0;\n\t}\n\n\t&:last-child:not(:only-child) img {\n\t\tmargin-left: 0;\n\t}\n"], ["\n\tposition: relative;\n\tflex: 1 1 auto;\n\n\timg {\n\t\tbox-sizing: border-box;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: auto;\n\t\theight: auto;\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t\tmargin: auto;\n\t}\n\n\t&:first-child:not(:only-child) img {\n\t\tmargin-right: 0;\n\t}\n\n\t&:last-child:not(:only-child) img {\n\t\tmargin-left: 0;\n\t}\n"])));

var templateObject_1, templateObject_2;


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TableCellInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TableCellInnerContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Email; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledTable = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('table')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tcolor: ", ";\n"], ["\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tcolor: ", ";\n"])), function (props) { return props.theme.primary.strongColor; });
var TableCell = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('td')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 10%;\n\theight: ", ";\n\tpadding: 4px;\n\n\t&:first-child {\n\t\twidth: 1%;\n\t}\n\n\t&:nth-child(2) {\n\t\twidth: 50%;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tborder-bottom: 1px solid ", ";\n\n\t\ttbody tr:last-child & {\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 10%;\n\theight: ", ";\n\tpadding: 4px;\n\n\t&:first-child {\n\t\twidth: 1%;\n\t}\n\n\t&:nth-child(2) {\n\t\twidth: 50%;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tborder-bottom: 1px solid ", ";\n\n\t\ttbody tr:last-child & {\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t",
    "\n"])), function (props) { return props.as === 'th' ? '30px' : '62px'; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 9); }, function (_a) {
    var as = _a.as, _b = _a.theme.primary, backgroundColor = _b.backgroundColor, strongColor = _b.strongColor;
    return as === 'th' && "\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1;\n\t\tbackground-color: " + (backgroundColor !== 'transparent' ? backgroundColor : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White) + ";\n\t\tfont-weight: 400;\n\t\tfont-size: 11px;\n\t\tline-height: 12px;\n\t\tcolor: " + strongColor + ";\n\t\ttext-align: left;\n\t";
});
var TableCellInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\theight: 100%;\n"], ["\n\tposition: relative;\n\theight: 100%;\n"])));
var TableCellInnerContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\ttransform: translateY(-50%);\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\ttransform: translateY(-50%);\n"])));
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 95.2); });
var Email = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tfont-size: 11px;\n\tline-height: 14px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tfont-size: 11px;\n\tline-height: 14px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(644);
module.exports = __webpack_require__(649);


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(645).enable();
  window.Promise = __webpack_require__(647);
}

// fetch() polyfill for making API calls.
__webpack_require__(648);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(129);


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(378);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(378);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 648 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalStyle", function() { return GlobalStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lazysizes__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lazysizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lazysizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_appType__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;









var GlobalStyle = Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["b" /* createGlobalStyle */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbody {\n\t\toverflow: hidden;\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tfont-family: 'HelveticaNeue', sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\n\t\t&.no-user-select {\n\t\t\tuser-select: none;\n\t\t}\n\n\t\t@media ", " {\n\t\t\ttext-size-adjust: none;\n\t\t}\n\n\t\t@media print {\n\t\t\t@page {\n\t\t\t\tsize: A4;\n\t\t\t\tmargin:0;\n\t\t\t}\n\t\t\t&,\n\t\t\t#root > div {\n\t\t\t\toverflow: visible;\n\t\t\t\tposition: static;\n\t\t\t\tmargin: 0;\n\t\t\t\twidth: 210mm;\n\t\t\t\theight: 297mm;\n\t\t\t}\n\t\t\t.StyledHeader {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.__react_component_tooltip {\n\t\tmargin: 0!important;\n\t\tpadding: 0!important;\n\t\tbackground: none!important;\n\t}\n\n\t.__react_component_tooltip:before,\n\t.__react_component_tooltip:after {\n\t\tcontent: none!important;\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 300;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueUltraLight.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueLight.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueRoman.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueMedium.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 700;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueBold.ttf') format('truetype');\n\t}\n\n\tsvg { // on edge, can't click on the button behind the button icon without this line\n\t\tpointer-events: none;\n\t}\n"], ["\n\tbody {\n\t\toverflow: hidden;\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tfont-family: 'HelveticaNeue', sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\n\t\t&.no-user-select {\n\t\t\tuser-select: none;\n\t\t}\n\n\t\t@media ", " {\n\t\t\ttext-size-adjust: none;\n\t\t}\n\n\t\t@media print {\n\t\t\t@page {\n\t\t\t\tsize: A4;\n\t\t\t\tmargin:0;\n\t\t\t}\n\t\t\t&,\n\t\t\t#root > div {\n\t\t\t\toverflow: visible;\n\t\t\t\tposition: static;\n\t\t\t\tmargin: 0;\n\t\t\t\twidth: 210mm;\n\t\t\t\theight: 297mm;\n\t\t\t}\n\t\t\t.StyledHeader {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.__react_component_tooltip {\n\t\tmargin: 0!important;\n\t\tpadding: 0!important;\n\t\tbackground: none!important;\n\t}\n\n\t.__react_component_tooltip:before,\n\t.__react_component_tooltip:after {\n\t\tcontent: none!important;\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 300;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueUltraLight.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueLight.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueRoman.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueMedium.ttf') format('truetype');\n\t}\n\n\t@font-face {\n\t\tfont-family: 'HelveticaNeue';\n\t\tfont-style: normal;\n\t\tfont-weight: 700;\n\t\tsrc: url('./.gallery/static/media/HelveticaNeueBold.ttf') format('truetype');\n\t}\n\n\tsvg { // on edge, can't click on the button behind the button icon without this line\n\t\tpointer-events: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__["a" /* Format */].SmartphonePortrait);
var init = function () { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // AppTypeUtils must be initialized because a lot of methods/Utils require to know if we are in a mobile app
            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_appType__["a" /* default */].init()];
            case 1:
                // AppTypeUtils must be initialized because a lot of methods/Utils require to know if we are in a mobile app
                _a.sent();
                __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__["a" /* default */].initApp();
                __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */], null),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](GlobalStyle, null)), document.getElementById('root'));
                return [2 /*return*/];
        }
    });
}); };
init();
var templateObject_1;


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_symbol__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_includes__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_from__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_includes__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_ends_with__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_object_values__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_fn_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_fn_object_entries__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_fn_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_fn_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_fn_set__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_fn_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_fn_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_closest__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_closest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_closest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_intersection_observer__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_intersection_observer__);














/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(652);
__webpack_require__(390);
__webpack_require__(659);
__webpack_require__(660);
module.exports = __webpack_require__(47).Symbol;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(57);
var has = __webpack_require__(105);
var DESCRIPTORS = __webpack_require__(74);
var $export = __webpack_require__(49);
var redefine = __webpack_require__(108);
var META = __webpack_require__(263).KEY;
var $fails = __webpack_require__(157);
var shared = __webpack_require__(187);
var setToStringTag = __webpack_require__(189);
var uid = __webpack_require__(159);
var wks = __webpack_require__(45);
var wksExt = __webpack_require__(382);
var wksDefine = __webpack_require__(264);
var enumKeys = __webpack_require__(654);
var isArray = __webpack_require__(387);
var anObject = __webpack_require__(107);
var isObject = __webpack_require__(58);
var toObject = __webpack_require__(193);
var toIObject = __webpack_require__(110);
var toPrimitive = __webpack_require__(262);
var createDesc = __webpack_require__(158);
var _create = __webpack_require__(268);
var gOPNExt = __webpack_require__(658);
var $GOPD = __webpack_require__(389);
var $GOPS = __webpack_require__(386);
var $DP = __webpack_require__(75);
var $keys = __webpack_require__(160);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(388).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(192).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(188)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(106)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187)('native-function-to-string', Function.toString);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(160);
var gOPS = __webpack_require__(386);
var pIE = __webpack_require__(192);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(265);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(75);
var anObject = __webpack_require__(107);
var getKeys = __webpack_require__(160);

module.exports = __webpack_require__(74) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(57).document;
module.exports = document && document.documentElement;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(110);
var gOPN = __webpack_require__(388).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(264)('asyncIterator');


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(264)('observable');


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(662);
module.exports = __webpack_require__(47).Array.includes;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(49);
var $includes = __webpack_require__(385)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(194)('includes');


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(664);
module.exports = __webpack_require__(47).Array.find;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(49);
var $find = __webpack_require__(391)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(194)(KEY);


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(666);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
var isArray = __webpack_require__(387);
var SPECIES = __webpack_require__(45)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(668);
module.exports = __webpack_require__(47).Array.findIndex;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(49);
var $find = __webpack_require__(391)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(194)(KEY);


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(392);
__webpack_require__(673);
module.exports = __webpack_require__(47).Array.from;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(265);
var defined = __webpack_require__(191);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(268);
var descriptor = __webpack_require__(158);
var setToStringTag = __webpack_require__(189);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(106)(IteratorPrototype, __webpack_require__(45)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(105);
var toObject = __webpack_require__(193);
var IE_PROTO = __webpack_require__(266)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(109);
var $export = __webpack_require__(49);
var toObject = __webpack_require__(193);
var call = __webpack_require__(393);
var isArrayIter = __webpack_require__(394);
var toLength = __webpack_require__(161);
var createProperty = __webpack_require__(674);
var getIterFn = __webpack_require__(395);

$export($export.S + $export.F * !__webpack_require__(396)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(75);
var createDesc = __webpack_require__(158);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(676);
module.exports = __webpack_require__(47).String.includes;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(49);
var context = __webpack_require__(397);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(398)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(58);
var cof = __webpack_require__(190);
var MATCH = __webpack_require__(45)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(679);
module.exports = __webpack_require__(47).String.endsWith;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(49);
var toLength = __webpack_require__(161);
var context = __webpack_require__(397);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(398)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(681);
module.exports = __webpack_require__(47).Object.values;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(49);
var $values = __webpack_require__(399)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(683);
module.exports = __webpack_require__(47).Object.entries;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(49);
var $entries = __webpack_require__(399)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(390);
__webpack_require__(392);
__webpack_require__(685);
__webpack_require__(687);
__webpack_require__(693);
__webpack_require__(696);
__webpack_require__(698);
module.exports = __webpack_require__(47).Set;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(686);
var getKeys = __webpack_require__(160);
var redefine = __webpack_require__(108);
var global = __webpack_require__(57);
var hide = __webpack_require__(106);
var Iterators = __webpack_require__(162);
var wks = __webpack_require__(45);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(194);
var step = __webpack_require__(400);
var Iterators = __webpack_require__(162);
var toIObject = __webpack_require__(110);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(270)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(688);
var validate = __webpack_require__(403);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(690)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(75).f;
var create = __webpack_require__(268);
var redefineAll = __webpack_require__(401);
var ctx = __webpack_require__(109);
var anInstance = __webpack_require__(402);
var forOf = __webpack_require__(195);
var $iterDefine = __webpack_require__(270);
var step = __webpack_require__(400);
var setSpecies = __webpack_require__(689);
var DESCRIPTORS = __webpack_require__(74);
var fastKey = __webpack_require__(263).fastKey;
var validate = __webpack_require__(403);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(57);
var dP = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(74);
var SPECIES = __webpack_require__(45)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(57);
var $export = __webpack_require__(49);
var redefine = __webpack_require__(108);
var redefineAll = __webpack_require__(401);
var meta = __webpack_require__(263);
var forOf = __webpack_require__(195);
var anInstance = __webpack_require__(402);
var isObject = __webpack_require__(58);
var fails = __webpack_require__(157);
var $iterDetect = __webpack_require__(396);
var setToStringTag = __webpack_require__(189);
var inheritIfRequired = __webpack_require__(691);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(58);
var setPrototypeOf = __webpack_require__(692).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(58);
var anObject = __webpack_require__(107);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(109)(Function.call, __webpack_require__(389).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(49);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(694)('Set') });


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(269);
var from = __webpack_require__(695);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(195);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(697)('Set');


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(49);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(699)('Set');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(49);
var aFunction = __webpack_require__(381);
var ctx = __webpack_require__(109);
var forOf = __webpack_require__(195);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/index.d9ef15ce.mjs";

/***/ }),
/* 701 */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  if (doc != (this.root && this.root.ownerDocument || document)) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc = (this.root && this.root.ownerDocument || document);

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target) &&
    (!this.root || this.root.ownerDocument == target.ownerDocument);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  if (parent && parent.assignedSlot) {
    // If the parent is distributed in a <slot>, return the parent of a slot.
    return parent.assignedSlot.parentNode;
  }

  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(129),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(129),r=__webpack_require__(704);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(705);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 706 */
/***/ (function(module, exports) {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, function l(window, document, Date) { // Pass in the windoe Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes, lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			cfg: lazySizesCfg,
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, 'ls-is-cached');
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_App__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_SetRouteParams__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Home__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_StaticPage_Router__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NotFoundPage__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_ViewDriveItemPage__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_DriveItemDetailPage__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ParametersPage__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_ProfilePage__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_TheaterPage__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_SharePage__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_Editor__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_ProposalStatsPage__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_NotesPage__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_Authentication__ = __webpack_require__(545);






















var routes = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */], { store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Router */], { history: __WEBPACK_IMPORTED_MODULE_3__store__["b" /* history */] },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Redirect */], { from: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].Default, to: __WEBPACK_IMPORTED_MODULE_19__utils_routes__["a" /* default */].getPathHome() }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].Default, component: Object(__WEBPACK_IMPORTED_MODULE_5__containers_SetRouteParams__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__containers_App__["a" /* default */]) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].Home, component: __WEBPACK_IMPORTED_MODULE_6__containers_Home__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].ViewDriveItem, component: __WEBPACK_IMPORTED_MODULE_9__containers_ViewDriveItemPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].StaticPage, component: __WEBPACK_IMPORTED_MODULE_7__containers_StaticPage_Router__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].ParametersPage, component: __WEBPACK_IMPORTED_MODULE_12__components_ParametersPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].ProfilePage, component: __WEBPACK_IMPORTED_MODULE_13__containers_ProfilePage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].ProposalStatsPage, component: __WEBPACK_IMPORTED_MODULE_17__containers_ProposalStatsPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].DriveItemListPage, component: __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].TheaterList, component: __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemListPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].Theater, component: __WEBPACK_IMPORTED_MODULE_14__containers_TheaterPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].Authentication, component: __WEBPACK_IMPORTED_MODULE_21__containers_Authentication__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].DriveItemDetailPage, component: __WEBPACK_IMPORTED_MODULE_11__containers_DriveItemDetailPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].Editor, component: __WEBPACK_IMPORTED_MODULE_16__containers_Editor__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].NotesPage, component: __WEBPACK_IMPORTED_MODULE_18__containers_NotesPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_20__constants__["a" /* RoutePath */].SharePage, component: __WEBPACK_IMPORTED_MODULE_15__containers_SharePage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Route */], { path: "*", component: __WEBPACK_IMPORTED_MODULE_8__components_NotFoundPage__["a" /* default */] }))))); };
/* harmony default export */ __webpack_exports__["a"] = (routes);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(129);

var emptyObject = __webpack_require__(710);
var _invariant = __webpack_require__(404);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(712);
var invariant = __webpack_require__(404);
var ReactPropTypesSecret = __webpack_require__(713);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(132);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(271);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(132);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(406);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(92);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(132);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(408);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(274);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(163);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(163);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRoute);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(163);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(407);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(728);
var objectAssign = __webpack_require__(129);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(48);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(133);

var _PathUtils = __webpack_require__(93);

var _createHistory = __webpack_require__(278);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(413);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(48);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(279);

var _BrowserProtocol = __webpack_require__(280);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(734);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(197);

var _createHistory = __webpack_require__(278);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(280);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(133);

var _PathUtils = __webpack_require__(93);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(413);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(280);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(91);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(133);

var _DOMUtils = __webpack_require__(197);

var _DOMStateStorage = __webpack_require__(412);

var _PathUtils = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(281);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(198);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(760);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(424);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(749);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(747);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(420);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(751);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(422);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(423);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(424);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(425);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(761);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(281);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(427);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(428);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Gallery_reducer__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Authentication_reducer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemList_New_reducer__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_Search_reducer__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_NotificationBar_reducer__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_MultiAppAuthentication_reducer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_Selection_reducer__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_OfflineManager_reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_PendingTasksManager_reducer__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_ParametersPage_reducer__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_SetRouteParams_reducer__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_Share_reducer__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_FolderCreationPanel_reducer__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_MenuManager_reducer__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__containers_DownloadAllPopup_reducer__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_CookieNotification_GDPRCookie_reducer__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_ReadStatus_reducer__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__containers_Editor_reducer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_ImportManager_reducer__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__containers_PublicationCreator_reducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__containers_AssetRenamePanel_reducer__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__containers_ExternalLinkCreationPanel_reducer__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__containers_ProfilePage_reducer__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__containers_ProposalStatsPage_reducer__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__containers_NoSaveAsPopup_reducer__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__containers_NotesPage_reducer__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__containers_BackToPublication_reducer__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__containers_ShareWithUserPopup_reducer__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__containers_CoverImagePanel_reducer__ = __webpack_require__(1070);



































var rootReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    appInfos: __WEBPACK_IMPORTED_MODULE_3__containers_App_reducer__["b" /* appInfos */],
    authentication: __WEBPACK_IMPORTED_MODULE_5__containers_Authentication_reducer__["c" /* authentication */],
    downloadAllPopup: __WEBPACK_IMPORTED_MODULE_20__containers_DownloadAllPopup_reducer__["a" /* downloadAllPopup */],
    downloadManager: __WEBPACK_IMPORTED_MODULE_9__containers_DownloadManager_reducer__["e" /* downloadManager */],
    driveList: __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_reducer__["b" /* driveList */],
    folderCreationPanel: __WEBPACK_IMPORTED_MODULE_18__containers_FolderCreationPanel_reducer__["a" /* folderCreationPanel */],
    galleryInfos: __WEBPACK_IMPORTED_MODULE_4__containers_Gallery_reducer__["a" /* galleryInfos */],
    i18n: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["i18nReducer"],
    menuManager: __WEBPACK_IMPORTED_MODULE_19__containers_MenuManager_reducer__["a" /* menuManager */],
    multiAppAuthenticationInfos: __WEBPACK_IMPORTED_MODULE_11__containers_MultiAppAuthentication_reducer__["c" /* multiAppAuthenticationInfos */],
    newDriveItems: __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemList_New_reducer__["a" /* newDriveItems */],
    noSaveAsPopup: __WEBPACK_IMPORTED_MODULE_30__containers_NoSaveAsPopup_reducer__["a" /* noSaveAsPopup */],
    notificationBar: __WEBPACK_IMPORTED_MODULE_10__containers_NotificationBar_reducer__["a" /* notificationBar */],
    offlineManager: __WEBPACK_IMPORTED_MODULE_13__containers_OfflineManager_reducer__["f" /* offlineManager */],
    parametersPage: __WEBPACK_IMPORTED_MODULE_15__containers_ParametersPage_reducer__["a" /* parametersPage */],
    pendingTasksManager: __WEBPACK_IMPORTED_MODULE_14__containers_PendingTasksManager_reducer__["a" /* pendingTasksManager */],
    readStatus: __WEBPACK_IMPORTED_MODULE_22__containers_ReadStatus_reducer__["a" /* readStatus */],
    routerParamsHistory: __WEBPACK_IMPORTED_MODULE_16__containers_SetRouteParams_reducer__["a" /* routerParamsHistory */],
    routing: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerReducer"],
    search: __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_Search_reducer__["a" /* search */],
    selection: __WEBPACK_IMPORTED_MODULE_12__containers_Selection_reducer__["a" /* selection */],
    sharePanel: __WEBPACK_IMPORTED_MODULE_17__containers_Share_reducer__["b" /* sharePanel */],
    GDPRCookie: __WEBPACK_IMPORTED_MODULE_21__containers_CookieNotification_GDPRCookie_reducer__["a" /* GDPRCookie */],
    editor: __WEBPACK_IMPORTED_MODULE_23__containers_Editor_reducer__["b" /* editor */],
    importManager: __WEBPACK_IMPORTED_MODULE_24__containers_ImportManager_reducer__["a" /* importManager */],
    publicationCreator: __WEBPACK_IMPORTED_MODULE_25__containers_PublicationCreator_reducer__["d" /* publicationCreator */],
    assetRenamePanel: __WEBPACK_IMPORTED_MODULE_26__containers_AssetRenamePanel_reducer__["a" /* assetRenamePanel */],
    externalLinkCreationPanel: __WEBPACK_IMPORTED_MODULE_27__containers_ExternalLinkCreationPanel_reducer__["a" /* externalLinkCreationPanel */],
    profile: __WEBPACK_IMPORTED_MODULE_28__containers_ProfilePage_reducer__["b" /* profile */],
    proposalStats: __WEBPACK_IMPORTED_MODULE_29__containers_ProposalStatsPage_reducer__["b" /* proposalStats */],
    notes: __WEBPACK_IMPORTED_MODULE_31__containers_NotesPage_reducer__["c" /* notes */],
    backToPublication: __WEBPACK_IMPORTED_MODULE_32__containers_BackToPublication_reducer__["a" /* backToPublication */],
    shareWithUserPopup: __WEBPACK_IMPORTED_MODULE_33__containers_ShareWithUserPopup_reducer__["a" /* shareWithUserPopup */],
    coverImagePanel: __WEBPACK_IMPORTED_MODULE_34__containers_CoverImagePanel_reducer__["a" /* coverImagePanel */],
});
/* harmony default export */ __webpack_exports__["a"] = (rootReducer);


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = __webpack_require__(429);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions.LOAD_TRANSLATIONS:
      return _extends({}, state, {
        translations: action.translations
      });
    case _actions.SET_LOCALE:
      return _extends({}, state, {
        locale: action.locale
      });
    default:
      return state;
  }
};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = __webpack_require__(285);

Object.defineProperty(exports, 'I18n', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_I18n).default;
  }
});

var _Translate = __webpack_require__(773);

Object.defineProperty(exports, 'Translate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Translate).default;
  }
});

var _Localize = __webpack_require__(774);

Object.defineProperty(exports, 'Localize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Localize).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(770);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(771);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 771 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

;(function (global, factory) {
    true ? factory(__webpack_require__(430)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$1 = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$1[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$2 = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap$1 = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm$1 = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals$1 = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize$1 = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm$1(number),
                str = plurals$1[u][pluralForm$1(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months$1 = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    moment.defineLocale('ar', {
        months : months$1,
        monthsShort : months$1,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize$1('s'),
            ss : pluralize$1('s'),
            m : pluralize$1('m'),
            mm : pluralize$1('m'),
            h : pluralize$1('h'),
            hh : pluralize$1('h'),
            d : pluralize$1('d'),
            dd : pluralize$1('d'),
            M : pluralize$1('M'),
            MM : pluralize$1('M'),
            y : pluralize$1('y'),
            yy : pluralize$1('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap$1[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$2[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$3 = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap$2 = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$2[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$3[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$4 = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap$3 = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap$3[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$4[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var months$2 = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural$1(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    moment.defineLocale('cs', {
        months : months$2,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months$2, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months$2)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate$1,
            ss : translate$1,
            m : translate$1,
            mm : translate$1,
            h : translate$1,
            hh : translate$1,
            d : translate$1,
            dd : translate$1,
            M : translate$1,
            MM : translate$1,
            y : translate$1,
            yy : translate$1
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime$1,
            mm : '%d Minuten',
            h : processRelativeTime$1,
            hh : '%d Stunden',
            d : processRelativeTime$1,
            dd : processRelativeTime$1,
            M : processRelativeTime$1,
            MM : processRelativeTime$1,
            y : processRelativeTime$1,
            yy : processRelativeTime$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime$2,
            mm : '%d Minuten',
            h : processRelativeTime$2,
            hh : '%d Stunden',
            d : processRelativeTime$2,
            dd : processRelativeTime$2,
            M : processRelativeTime$2,
            MM : processRelativeTime$2,
            y : processRelativeTime$2,
            yy : processRelativeTime$2
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var months$3 = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    moment.defineLocale('dv', {
        months : months$3,
        monthsShort : months$3,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    //! moment.js locale configuration

    moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$1[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsShortDot$1 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$2[m.month()];
            } else {
                return monthsShortDot$1[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsShortDot$2 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse$1 = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex$1 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$3[m.month()];
            } else {
                return monthsShortDot$2[m.month()];
            }
        },
        monthsRegex : monthsRegex$1,
        monthsShortRegex : monthsRegex$1,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse$1,
        longMonthsParse : monthsParse$1,
        shortMonthsParse : monthsParse$1,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime$3,
            ss     : processRelativeTime$3,
            m      : processRelativeTime$3,
            mm     : processRelativeTime$3,
            h      : processRelativeTime$3,
            hh     : processRelativeTime$3,
            d      : processRelativeTime$3,
            dd     : '%d päeva',
            M      : processRelativeTime$3,
            MM     : processRelativeTime$3,
            y      : processRelativeTime$3,
            yy     : processRelativeTime$3
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$5 = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap$4 = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap$4[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$5[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate$2(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate$2,
            ss : translate$2,
            m : translate$2,
            mm : translate$2,
            h : translate$2,
            hh : translate$2,
            d : translate$2,
            dd : translate$2,
            M : translate$2,
            MM : translate$2,
            y : translate$2,
            yy : translate$2
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var months$4 = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort$4 = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays$1 = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    moment.defineLocale('gd', {
        months : months$4,
        monthsShort : monthsShort$4,
        monthsParseExact : true,
        weekdays : weekdays$1,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime$4,
            ss : processRelativeTime$4,
            m : processRelativeTime$4,
            mm : processRelativeTime$4,
            h : processRelativeTime$4,
            hh : processRelativeTime$4,
            d : processRelativeTime$4,
            dd : processRelativeTime$4,
            M : processRelativeTime$4,
            MM : processRelativeTime$4,
            y : processRelativeTime$4,
            yy : processRelativeTime$4
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    //! moment.js locale configuration

    var symbolMap$6 = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap$5 = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap$5[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$6[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    //! moment.js locale configuration

    var symbolMap$7 = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap$6 = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$6[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$7[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function translate$3(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate$3,
            m      : translate$3,
            mm     : translate$3,
            h      : translate$3,
            hh     : translate$3,
            d      : 'dan',
            dd     : translate$3,
            M      : 'mjesec',
            MM     : translate$3,
            y      : 'godinu',
            yy     : translate$3
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate$4(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate$4,
            ss : translate$4,
            m : translate$4,
            mm : translate$4,
            h : translate$4,
            hh : translate$4,
            d : translate$4,
            dd : translate$4,
            M : translate$4,
            MM : translate$4,
            y : translate$4,
            yy : translate$4
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function plural$2(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate$5,
            ss : translate$5,
            m : translate$5,
            mm : translate$5,
            h : 'klukkustund',
            hh : translate$5,
            d : translate$5,
            dd : translate$5,
            M : translate$5,
            MM : translate$5,
            y : translate$5,
            yy : translate$5
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    //! moment.js locale configuration

    var suffixes$1 = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$8 = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap$7 = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap$7[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$8[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$9 = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap$8 = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap$8[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$9[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    //! moment.js locale configuration

    var suffixes$2 = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кече саат] LT',
            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime$5,
            mm : '%d Minutten',
            h : processRelativeTime$5,
            hh : '%d Stonnen',
            d : processRelativeTime$5,
            dd : '%d Deeg',
            M : processRelativeTime$5,
            MM : '%d Méint',
            y : processRelativeTime$5,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    //! moment.js locale configuration

    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate$6,
            m : translateSingular,
            mm : translate$6,
            h : translateSingular,
            hh : translate$6,
            d : translateSingular,
            dd : translate$6,
            M : translateSingular,
            MM : translate$6,
            y : translateSingular,
            yy : translate$6
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var units$1 = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
        return number + ' ' + format(units$1[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units$1[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural$1,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural$1,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural$1,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural$1,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural$1,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural$1
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    //! moment.js locale configuration

    function translate$7(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate$7,
            ss : translate$7,
            m : translate$7,
            mm : translate$7,
            h : translate$7,
            hh : translate$7,
            d : translate$7,
            dd : translate$7,
            M : translate$7,
            MM : translate$7,
            y : translate$7,
            yy : translate$7
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    //! moment.js locale configuration

    var symbolMap$a = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap$9 = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$9[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$a[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$b = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap$a = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap$a[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$b[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$c = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap$b = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$b[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$c[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsShortWithDots$1 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$1 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse$2 = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex$2 = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$1[m.month()];
            } else {
                return monthsShortWithDots$1[m.month()];
            }
        },

        monthsRegex: monthsRegex$2,
        monthsShortRegex: monthsRegex$2,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse$2,
        longMonthsParse : monthsParse$2,
        shortMonthsParse : monthsParse$2,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsShortWithDots$2 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$2 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse$3 = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex$3 = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$2[m.month()];
            } else {
                return monthsShortWithDots$2[m.month()];
            }
        },

        monthsRegex: monthsRegex$3,
        monthsShortRegex: monthsRegex$3,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse$3,
        longMonthsParse : monthsParse$3,
        shortMonthsParse : monthsParse$3,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$d = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap$c = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap$c[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$d[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural$3(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate$8(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural$3(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural$3(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural$3(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural$3(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural$3(number) ? 'lata' : 'lat');
        }
    }

    moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate$8,
            m : translate$8,
            mm : translate$8,
            h : translate$8,
            hh : translate$8,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate$8,
            y : 'rok',
            yy : translate$8
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    //! moment.js locale configuration

    moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural$2,
            m : 'un minut',
            mm : relativeTimeWithPlural$2,
            h : 'o oră',
            hh : relativeTimeWithPlural$2,
            d : 'o zi',
            dd : relativeTimeWithPlural$2,
            M : 'o lună',
            MM : relativeTimeWithPlural$2,
            y : 'un an',
            yy : relativeTimeWithPlural$2
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function plural$4(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural$4(format[key], +number);
        }
    }
    var monthsParse$4 = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse$4,
        longMonthsParse : monthsParse$4,
        shortMonthsParse : monthsParse$4,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural$3,
            m : relativeTimeWithPlural$3,
            mm : relativeTimeWithPlural$3,
            h : 'час',
            hh : relativeTimeWithPlural$3,
            d : 'день',
            dd : relativeTimeWithPlural$3,
            M : 'месяц',
            MM : relativeTimeWithPlural$3,
            y : 'год',
            yy : relativeTimeWithPlural$3
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var months$5 = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    moment.defineLocale('sd', {
        months : months$5,
        monthsShort : months$5,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    /*jshint -W100*/
    moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    //! moment.js locale configuration

    var months$6 = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort$5 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural$5(n) {
        return (n > 1) && (n < 5);
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    moment.defineLocale('sk', {
        months : months$6,
        monthsShort : monthsShort$5,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate$9,
            ss : translate$9,
            m : translate$9,
            mm : translate$9,
            h : translate$9,
            hh : translate$9,
            d : translate$9,
            dd : translate$9,
            M : translate$9,
            MM : translate$9,
            y : translate$9,
            yy : translate$9
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime$6,
            ss     : processRelativeTime$6,
            m      : processRelativeTime$6,
            mm     : processRelativeTime$6,
            h      : processRelativeTime$6,
            hh     : processRelativeTime$6,
            d      : processRelativeTime$6,
            dd     : processRelativeTime$6,
            M      : processRelativeTime$6,
            MM     : processRelativeTime$6,
            y      : processRelativeTime$6,
            yy     : processRelativeTime$6
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var translator$1 = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator$1.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator$1.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator$1.translate,
            m      : translator$1.translate,
            mm     : translator$1.translate,
            h      : translator$1.translate,
            hh     : translator$1.translate,
            d      : 'дан',
            dd     : translator$1.translate,
            M      : 'месец',
            MM     : translator$1.translate,
            y      : 'годину',
            yy     : translator$1.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var translator$2 = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator$2.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator$2.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator$2.translate,
            m      : translator$2.translate,
            mm     : translator$2.translate,
            h      : translator$2.translate,
            hh     : translator$2.translate,
            d      : 'dan',
            dd     : translator$2.translate,
            M      : 'mesec',
            MM     : translator$2.translate,
            y      : 'godinu',
            yy     : translator$2.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var symbolMap$e = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap$d = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap$d[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$e[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var suffixes$3 = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate$a(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate$a,
            m : 'wa’ tup',
            mm : translate$a,
            h : 'wa’ rep',
            hh : translate$a,
            d : 'wa’ jaj',
            dd : translate$a,
            M : 'wa’ jar',
            MM : translate$a,
            y : 'wa’ DIS',
            yy : translate$a
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    var suffixes$4 = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime$7,
            ss : processRelativeTime$7,
            m : processRelativeTime$7,
            mm : processRelativeTime$7,
            h : processRelativeTime$7,
            hh : processRelativeTime$7,
            d : processRelativeTime$7,
            dd : processRelativeTime$7,
            M : processRelativeTime$7,
            MM : processRelativeTime$7,
            y : processRelativeTime$7,
            yy : processRelativeTime$7
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    //! moment.js locale configuration

    moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js language configuration

    moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    function plural$6(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural$6(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural$4,
            m : relativeTimeWithPlural$4,
            mm : relativeTimeWithPlural$4,
            h : 'годину',
            hh : relativeTimeWithPlural$4,
            d : 'день',
            dd : relativeTimeWithPlural$4,
            M : 'місяць',
            MM : relativeTimeWithPlural$4,
            y : 'рік',
            yy : relativeTimeWithPlural$4
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    var months$7 = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days$1 = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    moment.defineLocale('ur', {
        months : months$7,
        monthsShort : months$7,
        weekdays : days$1,
        weekdaysShort : days$1,
        weekdaysMin : days$1,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    //! moment.js locale configuration

    moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    moment.locale('en');

    return moment;

})));


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(285);

var _I18n2 = _interopRequireDefault(_I18n);

var _Base = __webpack_require__(286);

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Translate = function (_BaseComponent) {
  _inherits(Translate, _BaseComponent);

  function Translate() {
    _classCallCheck(this, Translate);

    return _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).apply(this, arguments));
  }

  _createClass(Translate, [{
    key: 'otherProps',
    value: function otherProps() {
      var result = _extends({}, this.props);
      delete result.value;
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          value = _props.value,
          dangerousHTML = _props.dangerousHTML,
          style = _props.style,
          className = _props.className;

      var translation = _I18n2.default._translate(value, this.otherProps());

      if (dangerousHTML) {
        return _react2.default.createElement(Tag, {
          style: style,
          className: className,
          dangerouslySetInnerHTML: { __html: translation }
        });
      }
      return _react2.default.createElement(
        Tag,
        { style: style, className: className },
        translation
      );
    }
  }]);

  return Translate;
}(_Base2.default);

Translate.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  value: _propTypes2.default.string.isRequired,
  dangerousHTML: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))
};
Translate.defaultProps = {
  tag: 'span'
};
exports.default = Translate;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(285);

var _I18n2 = _interopRequireDefault(_I18n);

var _Base = __webpack_require__(286);

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Localize = function (_BaseComponent) {
  _inherits(Localize, _BaseComponent);

  function Localize() {
    _classCallCheck(this, Localize);

    return _possibleConstructorReturn(this, (Localize.__proto__ || Object.getPrototypeOf(Localize)).apply(this, arguments));
  }

  _createClass(Localize, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          value = _props.value,
          dateFormat = _props.dateFormat,
          _props$options = _props.options,
          options = _props$options === undefined ? {} : _props$options,
          dangerousHTML = _props.dangerousHTML,
          style = _props.style,
          className = _props.className;

      var localization = _I18n2.default._localize(value, _extends({}, options, { dateFormat: dateFormat }));

      if (dangerousHTML) {
        return _react2.default.createElement(Tag, {
          style: style,
          className: className,
          dangerouslySetInnerHTML: { __html: localization }
        });
      }
      return _react2.default.createElement(
        Tag,
        { style: style, className: className },
        localization
      );
    }
  }]);

  return Localize;
}(_Base2.default);

Localize.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]).isRequired,
  options: _propTypes2.default.object,
  dateFormat: _propTypes2.default.string,
  dangerousHTML: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))
};
Localize.defaultProps = {
  tag: 'span'
};
exports.default = Localize;

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/YYYY","long":"DD MMM. YYYY"},"error":{"another_user_login":"You have been logged out because you logged in from another device","asset_not_erasable":"One or more assets were not erasable","authentication_needed":"An error occured, you need to log in again","bundle_content_expired":"%{number} contents are expired","bundle_delete_fail":"%{number} contents could not be deleted","bundle_download_fail":"%{number} contents could not be downloaded","bundle_fetch_content_error":"%{number} contents could not be retrieved","bundle_initialization_fail":"Bundle initialization fail","bundle_open_fail":"%{number} contents could not be opened","cant_archive_proposal":"Can't archive proposal","cant_change_cover_image":"Can't change cover image","cant_create_external_link":"Can't create external link","cant_create_folder":"Can't create this folder","cant_create_note":"Can't create a note","cant_get_resource":"Can't get resource data","cant_move_asset":"Can't move an asset","cant_remove_asset":"Can't remove an asset","cant_remove_note":"Can't remove a note","cant_update_note":"Can't update a note","combine_error":"An error occured while combining","content_expired":"Content (id: %{id}) is expired","create_proposal_error":"Can't create proposal","create_publication_error":"Can't create publication","custom_url_used":"Entered url already exists","delete_fail":"Content (id: %{id}) could not be deleted","download_fail":"The content (id: %{id}) could not be downloaded. Please try downloading it again without minimizing the app or switching to another one.","duplicate_email":"Login used","duplicate_file_name":"File already exists","duplicate_page_error":"Can't duplicate page","duplicate_theme":"Theme name used","fetch_content_block_error":"Contents (parent: %{id}) could not be retrieved","fetch_content_error":"Content (id: %{id}) could not be retrieved","fetch_editor_data_error":"An error occured while loading editor data","fetch_folder_tree":"An error occured while updating folder tree","fetch_notes_error":"An error occured while loading notes","fetch_profile_data_error":"An error occured while loading profile data","fetch_proposal_stats_error":"An error occured while loading proposal stats","fetch_publication_data":"An error occured while loading publication data","fetch_publication_templates_error":"An error occured while loading templates","field_must_have_at_least":"Field must have at least %{charsCount} chars","file_import_error":"An error occured while importing a file","file_import_error_short":"Import error","get_publication_settings":"An error occured while loading publication settings","get_publication_url":"An error occured while getting publication URL","get_share_users":"An error occured while getting users data","import_publication_pdf":"An error occured while importing publication PDF","initialization_fail":"An error occured during initialization, please relaunch the application","invalid_auth":"Invalid login, password or server","invalid_company_name":"Invalid company name","invalid_email_address":"Invalid email address","invalid_page_number":"Invalid page number","invalid_url":"Invalid url","login_or_password_incorrect":"Incorrect login or password","move_page_error":"Can't move page","no_application_available":"No application available","open_fail":"Content could not be opened","parse_editor_data_error":"An error occured while parsing editor data","passwords_do_not_match":"Password and confirmed don't match","processing_fail":"Processing fail","proposal_not_archived":"Proposal wasn't archived","publish_publication":"An error occured while publishing publication","remove_page_error":"Can't remove page","remove_template_error":"Can't remove template","rename_asset_error":"Can't rename asset","reset_fail":"Failed to reset downloads","save_editor_data_error":"An error occured while saving editor data","save_profile_data_error":"An error occured while saving profile data","save_publication_settings":"An error occured while saving publication settings","search_error":"An error occurred while searching","session_expired":"Your session expired","set_as_template_error":"Can't set as template","share_failed_request":"An error occured, your selection couldn't be shared","share_proposal_error":"An error occured while sending proposal","share_publication_error":"An error occured while sending publication","share_with_user":"An error occured while sharing the asset","the_resources_are_restricted_for_sharing":"The resources you are trying to share are restricted.","unexpected_error":"Unexpected error","update_publication":"An error occured while updating publication","wrong_file_type":"Wrong file type"},"fileFormat":{"COMPONENT":"Page","DOCUMENT":"Document","EPUB":"EPUB","FILE":"File","IMAGE":"Image","MOVIE":"Movie","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Presentation","PROPOSAL":"Proposal","PUBLICATION":"Publication"},"info":{"create_note_success":"Your note was saved. <a href=%{url}>View your notes</a>","delete_all":"All content has been deleted","emails_sent":"Your pending email(s) have been sent","fill_all_input_fields":"Please fill all the fields","import_publication_pdf":"Your PDF file was successfully imported","offline_create_external_link":"Please connect to the Internet to create an external link","offline_create_folder":"Please connect to the Internet to create a folder","offline_download_multiple_assets":"Please connect to the Internet to download the contents","offline_download_single_asset":"Please connect to the Internet to download the content","offline_fetch_notes":"Please connect to the Internet to fetch shared notes","offline_login":"Please connect to the Internet to log in","offline_no_config":"You need an Internet connection for the first launch","offline_update_folder_tree":"You need an Internet connection to update folder tree","remove_publication_pdf":"Your PDF publication was successfully removed","reset_all_downloads":"All downloads have been reset","selection_sent":"Your pending selection(s) have been shared","selection_shared_once_online":"Your selection will be shared once you are online","set_as_template_success":"Resource is successfully set as template","share_with_user_success":"The asset was successfully shared","url_copied":"Your URL was copied"},"languages":{"ca_ES":"Catalan","da_DK":"Danish","de_DE":"German","en_AU":"English - AU","en_UK":"English - UK","en_US":"English - US","es_ES":"Spanish","eu_ES":"Basque","fi_FI":"Finnish","fr_FR":"French","gl_ES":"Gallegan","he_IL":"Hebrew","it_IT":"Italian","ja_JP":"Japanese","ko_KR":"Korean","nl_NL":"Dutch","nn_NO":"Norwegian Nynorsk","pl_PL":"Polish","pt_PT":"Portuguese","ro_RO":"Romanian","ru_RU":"Russian","sk_SK":"Slovak","sv_SE":"Swedish","tr_TR":"Turkish","zh_CN":"Chinese - China","zh_SI":"Chinese - Singapore","zh_TR":"Chinese - Traditional","zh_TW":"Chinese - Traditional"},"messages":{"CUSTOM_DOMAIN":"Custom domain","PUBLISH":"Publish","SSO_SECURITY":"SSO Security","WISHLIST":"Wishlist","XLS_SECURITY":"XLS Security","activate_offline_mode":"Activate offline mode","add":"Add","add_file":"Add file","add_pdf_to_download":"Add PDF to download","add_slide":"Add a slide","add_to_selection":"Add to selection","already_member":"Already a member?","alt_attribute":"Alt attribute","animation":"Animation","another_user":"Another user","application_content":"Application content","archive_noun":"Archive","archive_verb":"Archive","assortment":"Assortment","auto_zoom_level":"Auto zoom level","autoplay_delay":"Autoplay delay, s","available_as_template":"Available as template","available_offline":"Available offline","back":"Back","back_to_company":"Back to Company","back_to_home":"Back to Home","back_to_login":"Back to Login","back_to_method_view":"Change authentication method","bg_cover_left_tooltip":"This control will only take effect if the user's screen is cropping the background on the sides","bg_cover_top_tooltip":"This control will only take effect if the user's screen is cropping the background at the top/bottom","bottom":"Bottom","bulleted":"Bulleted","campaign_name":"Campaign name","cancel":"Cancel","change_cover_image":"Change cover image","change_password":"Change password","check_for_updates":"Check for Updates","checking_for_updates":"<b>Checking for updates...</b>","choose_coworker":"Choose a co-worker","clear_selection":"Clear your selection","client_id":"Client id","client_secret":"Client secret","close":"Close","color":"Color","combine":"Combine","combine_by_selecting_pages":"Select the pages to include in your playlist","combining":"Combining %{percentage} %","confirm_password":"Confirm password","confirmation":"Confirmation","connect":"Connect","content_structure_incomplete":"Content structure incomplete","content_structure_never_completed":"To use the app in offline mode, the content structure must be completed first. Please enable your internet connection and try again.","content_structure_ready":"Content structure is now available for offline use","continue":"Continue","continue_downloading":"Resume Download All","continue_downloading_important":"Resume Download Important Assets","cookie_notification":"This website uses cookies to ensure you get the best experience on our services. By browsing this website, you accept the use of these cookies. However, you can modify your browser settings to cancel the automated validation. <a target='_blank' href=%{url}>Learn more.</a>","cookie_settings":"Manage services","copy":"Copy","copy_links_to_share":"Copy, open your mail client and then paste","copy_mode_html":"List of links","copy_mode_text":"Plain text","copy_paste_your_link":"Copy paste your link","coverflow":"Coverflow","create":"Create","create_customized_proposal":"Create customized proposal","create_deal_in_crm":"<span>Create a deal</span><br>in my CRM","create_demo_account":"Creating an account...","create_external_link":"Create an external link","create_folder":"Create a folder","create_from_template":"Create from a Template","create_note":"Create a note","create_proposal":"Create a Proposal","create_proposal_from_file":"Create a Proposal from file","create_proposal_from_template":"Create a Proposal from template","create_publication":"Create a Publication","create_your_slider":"Create your slider","creation_date":"Creation Date","crm":"CRM","custom_pdf":"Custom PDF","customize_url":"Customize the URL","customize_url_hint":"This will customize the end of our domain name with your text","deactivate_offline_mode":"Deactivate offline mode","default":"Default","default_animation":"Default animation","default_file":"Default file","default_image":"Default image","default_video":"Default video","delete":"Delete","delete_assets_sequentially":"Delete Assets Sequentially (Slower)","delete_data":"Delete All Assets","deleting":"Deleting...","dependencies_deleted_out_of":"Deleting %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependencies","dependency_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependency","description":"Description","deselect_all":"Deselect all","desktop":"Desktop","details":"Details","display_mode":"Display","do_not_close_app":"<b>Please do not close the app.</b>","done":"Done","dont_ask_me_again":"Don't ask me again","download":"Download","download_all":"Download All","download_all_important":"Download Important Assets","download_all_toast_in_progress":"Downloading in progress.<br><b>Do not minimize the application!</b>","download_all_toast_paused":"Downloading all assets was paused.<br>Would you like to continue?","download_complete":"Downloads Complete","download_complete_important":"Important Downloads Complete","download_importants_toast_in_progress":"Downloading important assets in progress.<br><b>Do not minimize the application!</b>","download_importants_toast_paused":"Download of important assets was paused.<br>Would you like to continue?","download_manager":"Download manager","download_pdf":"Download PDF","download_selected_toast_in_progress":"Downloading selected assets in progress.<br><b>Do not minimize the application!</b>","download_selected_toast_paused":"Download of selected assets was paused.<br>Would you like to continue?","download_toast_link_to_downloads":"Open <a href=%{url}>Downloads</a> page to view the progress.","download_toast_status":"Downloading %{downloadedItems} | %{totalItems}","downloaded":"Downloaded","downloading":"Downloading","downloading_thumbnails_for_offline_use":"Downloading thumbnails for offline use","downloads":"Downloads","draft":"Draft","duplicate":"Duplicate","duplicate_theme":"Duplicate theme","edit":"Edit","edit_text":"Edit text","email":"Email","email_integration":"Email integration","enabled":"Enabled","end_date":"End Date","enter_image_description":"Enter image description","enter_image_source":"Enter image source","enter_password":"Enter password","enter_your_text":"Enter your text","error":"Error","extension_external_link":"External Link","extension_flip":"Flip","file_size":"File Size","folder":"Folder","folder_name":"Folder Name","font":"Font","forgot_password":"Forgot your password?","format":"Format","free_space":"Free space","from_app":"From App","from_desktop":"From Desktop","from_drive":"From Drive","from_selection":"From My Selection","from_youtube":"From Youtube","full_pdf":"Full PDF","full_publication":"Full publication","gdpr_allowAll":"Accept all","gdpr_message":"This site uses cookies and gives you control over what you want to activate","gdpr_personalize":"Personalize","gdpr_privacy_policy":"Privacy policy","gdpr_reject_all":"Continue without accepting","get_url":"Get URL","goto_page":"Go to page","goto_page_id":"Go to page ID","grid":"Grid","home":"Home","hours_left":"%{hours} hours left","iframe":"Iframe","image":"Image","image_source":"Image source","import_file":"Import a file","imported_all_files":"All files imported","importing":"Importing","importing_files_status":"Importing %{importedFiles} | %{totalFiles}","importing_with_percentage":"Importing %{percentage} %","informations":"Informations","integrate":"Integrate","integrate_ua_code":"Integrate UA Analytics code","integrate_ua_code_hint":"Multiple UA codes must be separated by comma or semicolon","invalid_chapter_id":"Invalid page ID","invite_coworker":"Invite a co-worker","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} item","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} items","keep_it_for_later":"Keep it for later","ken_burns_effect":"Ken Burns effect (auto zoom)","language":"Language","last_update_date":"Last Update Date","left":"Left","less_than_minute_left":"Less than a minute left","library":"Library","line_height":"Line height","link":"Link","list_type":"List type","loading":"Loading...","loading_fetch_content":"Fetching drive content 1/3","loading_required_items":"Downloading required items 2/3","loading_thumbnails":"Downloading thumbnails 3/3","local":"Local","log_out":"Log Out","logging_in":"Logging in...","masonry":"Masonry","menu":"Menu","minutes_left":"%{minutes} minutes left","modify_slide":"Modify slide","move":"Move","my_app":"My App","my_documents":"My Documents","my_downloads":"My Downloads","my_drive":"My Drive","my_gallery":"My Gallery","my_notes":"My notes","my_parameters":"My Settings","my_profile":"My profile","my_selection":"My Selection","my_sent":"My sent","my_templates":"My templates","name":"Name","name_surname":"Name, surname","new":"New","new_content_available_start_download":"New content available. Start the download now?","next":"Next","no_assets":"This folder is empty","no_assortment":"The assortment is empty","no_data_found":"No data found","no_downloads":"You haven't downloaded anything yet","no_new":"No new content","no_results":"No results for this search","no_save_as_info":"The template you want to be duplicated has been updated, please create a new proposal from the new template","no_selection":"You haven't selected anything","no_share_users":"There are no available users in the application","no_target_selected":"Select asset to open","no_templates":"No templates available","no_updates":"No updated content","none":"None","normal":"Normal","note":"Note","notification":"Notification","notification_credits_multiline":"%{credits} credits will be debited from your account for \"%{action}\"","numbered":"Numbered","ok":"OK","one_hour_left":"1 hour left","one_minute_left":"1 minute left","open":"Open","open_in_new_tab":"Open in New tab","open_in_same_tab":"Open in Same tab","open_popup":"Open Pop-Up","opened_date":"Opened date","options":"Options","or_sign_in":"Sign in","page":"Page","page_id":"Page ID","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Page not found","pages_selection":"Playlist","pages_selection_tooltip":"You will be charged for publishing the selected publication in order to use it in a playlist.","parameters":"Parameters","password":"Password","pdf_processing":"PDF processing %{percentage} %","pdf_type":"PDF type","phone":"Phone","phone_number":"Phone number","pin_code":"PIN code","placeholder_company":"Enter your company name","placeholder_email":"Email","placeholder_login":"Login","placeholder_password":"Password","placeholder_phone":"Phone number","placeholder_search_drive_item":"Search","placeholder_share_contact_email":"Recipient's email","placeholder_share_message":"Your message","placeholder_share_name":"Your name","placeholder_share_user_email":"Your email","popup":"Choose asset","popup_label":"Popup","position":"Position","preparing_content_structure":"Preparing content structure...","preview":"Preview","private_folder":"Private folder","processing":"Processing","profile":"Profile","profile_offline_message":"Profile page cannot be edited in offline mode. Try again when you connect to the internet","project_url":"Project URL","proposal_locked":"Proposal is being edited by %{userName}","proposal_name":"Proposal name","publication_locked":"Publication is being edited by %{userName}","publication_name":"Publication name","publish":"Publish","publish_publication":"Publish my publication","published":"Published","publishing":"Publishing","read":"Read","remember_me":"Remember me","remove":"Remove","remove_email_integration":"Are you sure you want to remove email integration?","remove_from_selection":"Remove from selection","remove_template":"Remove this Template","remove_theme":"Remove theme","remove_theme_question":"Do you want to remove current theme?","removing":"Removing","rename":"Rename","rename_theme":"Rename theme","replace":"Replace","replace_file":"Replace the file","reset_all_downloads":"Reset All Downloads","reset_my_preferences":"Reset my preferences","reset_to_default":"Reset to default","resolution":"Resolution","resource_name":"Name","restart":"Restart","restart_all":"Restart all","resuming":"Resuming","retry":"Retry","right":"Right","row":"Row","salesforce":"Salesforce","salesforce_activation":"Salesforce activation","save":"Save","save_as":"Save as","save_in_documents":"Save in Documents","saving":"Saving...","scale":"Scale","search":"Search","search_phrase":"Search phrase","search_results":"Search results","see_preview":"See preview","seen":"Seen","select_all":"Select all","select_application":"Select your application","select_playlist_item":"Select an item to add to your playlist","select_publication_item":"Select an item to add to your publication","select_server":"Select a server","select_this_application":"Select this application","select_this_server":"Choose this server","select_your_tags":"Select your tags","select_your_template":"Select your template","selection":"Selection","send":"Send","send_by_email":"Send by Email","send_my_proposal":"Send my Proposal","send_my_publication":"Send my Publication","send_my_selection":"Send my selection","sent":"Sent","sent_date":"Sent date","session_expired":"Your session expired","set_as_template":"Set as a Template","settings":"Settings","share":"Share","share_by_email":"Share by email","share_my_selection":"Share my selection","share_via_copy":"Copy links","share_via_uprez":"Share by contact form","shared":"Shared","shared_with_me":"Shared with me","sign_in_options":"Sign in Options","sign_up_for_free_trial":"Sign up for a free trial","size":"Size","slider":"Slider","sources":"Sources","spacing":"Spacing","start_to_download":"Start to download","status_read":"Read","templates":"Templates","test_our_demo":"Test our demo","text":"Text","text_style":"Text style","theme":"Theme","theme_name":"Theme name","themes":"Themes","title":"Title","title_and_preview":"Title/preview","top":"Top","try_demo":"Try our demo","tutorial_uprez":"Tutorial Uprez","type":"Type","unlock":"Unlock","unread":"Unread","untitled_note":"Untitled note","update":"Update","update_all":"Update All","update_all_important":"Update All Important Assets","update_folder_tree":"Refresh Folder Tree","update_pdf_thumb":"Update PDF thumbnails","update_pdf_thumb_accept":"I want to generate all the thumbnails","update_pdf_thumb_message":"Your PDF will be replaced with this one","update_published":"Update","updating":"Updating","updating_asset":"Updating...","updating_content_structure":"Updating content structure...","url":"Url","used_space":"Used space","version":"Version","video":"Video","video_processing":"Video processing","view":"View","view_published":"View published","webpublication":"Webpublication","webpublication_method":"Webpublication authentication","your_company_account":"Your company account","your_file":"Your file","your_themes":"Your themes","your_ua_code":"Your UA analytics code","your_url":"Your URL","youtube_link":"Youtube link"},"page_title":{"assortment":"Assortment %{galleryName}","authentication":"Authentication","details":"Details %{itemName} - %{galleryName}","downloads":"Downloads %{galleryName}","drive":"Drive %{galleryName}","editor":"Editor","folder":"Folder %{itemName} - %{galleryName}","gallery":"Gallery","gallery_name":"%{galleryName}","my_documents":"My documents - %{galleryName}","my_notes":"My notes","my_sent":"My sent","new":"New %{galleryName}","parameters":"Settings %{galleryName}","profile":"Profile","search":"Search %{galleryName}","selection":"Selection %{galleryName}","shared_with_me":"Shared with me","theater":"Theater %{itemName} - %{galleryName}"},"share":{"company":"Company","contact":"Recipient Information","contactEmail":"Recipient Email","documents":"Documents","email_body":"Please find below the documents you've wished to receive during our appointment.","email_greeting":"Hello,","email_salutation":"Best regards,","firstname":"Firstname","notes":"Notes","phone":"Phone","position":"Position","subject":"Subject","surname":"Surname"},"type":{"asp-type-0":"Directory","asp-type-1":"Component","asp-type-10":"App","asp-type-11":"Gallery","asp-type-12":"External link","asp-type-2":"File","asp-type-3":"Template","asp-type-4":"Image","asp-type-5":"Movie","asp-type-6":"Publication","asp-type-7":"Sound","asp-type-8":"Publication","asp-type-9":"Link"}}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/YYYY","long":"DD MMM YYYY"},"error":{"another_user_login":"Has sido desconectado porque estás conectado con otro dispositivo","asset_not_erasable":"One or more assets were not erasable","authentication_needed":"Indentificación requerida, por favor reinicie tu sesión","bundle_content_expired":"%{number} elementos han expirado ","bundle_delete_fail":"%{number} elementos no se pueden borrar","bundle_download_fail":"%{number} elementos no se pueden descargar","bundle_fetch_content_error":"%{number} elementos no se pueden recuperar","bundle_initialization_fail":"Fallo en la inicialización del paquete","bundle_open_fail":"%{number} elementos no se pueden abrir","cant_archive_proposal":"Imposible archivar propuesta","cant_change_cover_image":"No se pudo cambiar la imagen de portada","cant_create_external_link":"No es posible crear un enlace externo","cant_create_folder":"No se puede crear esta carpeta","cant_create_note":"No se puede crear la nota","cant_get_resource":"Archivo fuente inaccesible","cant_move_asset":"No se puede mover un activo","cant_remove_asset":"No se puede eliminar un activo","cant_remove_note":"No se puede borrar la nota","cant_update_note":"No se puede actualizar la nota","combine_error":"Se produjo un error al combinar","content_expired":"El elemento (id: %{id}) ha expirado","create_proposal_error":"No se puede crear una propuesta","create_publication_error":"No se pudo crear la publicación","custom_url_used":"Esta url personalizada ya existe","delete_fail":"El elemento (id: %{id}) no puede borrarse","download_fail":"El contenido (id: %{id}) no se pudo descargar. Por favor, intenta descargarlo nuevamente sin minimizar la aplicación ni cambiar a otra.","duplicate_email":"Este correo electrónico ya ha sido utilizado","duplicate_file_name":"El archivo ya existe","duplicate_page_error":"No se puede duplicar la página","duplicate_theme":"Nombre de tema ya usado","fetch_content_block_error":"Los elementos (parent: %{id}) no se pueden recuperar","fetch_content_error":"El elemento (id: %{id}) no se ha encontrado","fetch_editor_data_error":"Se produjo un error al cargar los datos del editor","fetch_folder_tree":"Un error ha ocurrido al actualizar el árbol de contenido","fetch_notes_error":"Ha sucedido un error al cargar notas","fetch_profile_data_error":"Se produjo un error al cargar los datos del perfil","fetch_proposal_stats_error":"Se produjo un error al cargar las estadísticas de la propuesta","fetch_publication_data":"Ocurrió un error al cargar los datos de la publicación","fetch_publication_templates_error":"Error al cargar plantilla","field_must_have_at_least":"El campo debe tener al menos %{charsCount} caracteres.","file_import_error":"Se produjo un error al importar un archivo","file_import_error_short":"Error al importar","get_publication_settings":"Se produjo un error al cargar la configuración de la publicación","get_publication_url":"Ocurrió un error intentando obtener la URL de la publicación","get_share_users":"Ocurrió un error obteniendo los datos de los usuarios","import_publication_pdf":"Se produjo un error al importar el PDF","initialization_fail":"Se produjo un error durante la inicialización, por favor reinicie la aplicación","invalid_auth":"Inicio de sesión o contraseña no válidos","invalid_company_name":"Nombre de empresa inválido","invalid_email_address":"Email inválido","invalid_page_number":"Número de página inválido","invalid_url":"URL invalida","login_or_password_incorrect":"Nombre de usuario o contraseña incorrectos","move_page_error":"No se puede mover la página","no_application_available":"No aplicación disponible","open_fail":"El elemento no se puede abrir","parse_editor_data_error":"Se produjo un error al analizar los datos del editor","passwords_do_not_match":"La contraseña no coincide con la confirmada","processing_fail":"Procesamiento fallido","proposal_not_archived":"La propuesta no fue archivada","publish_publication":"Ocurrió  un error durante la publicación del documento","remove_page_error":"No se puede eliminar la página","remove_template_error":"No es posible borrar la plantilla","rename_asset_error":"No se ha podido cambiar el nombre del archivo","reset_fail":"No se pudieron restablecer las descargas","save_editor_data_error":"Se produjo un error al guardar los datos del editor","save_profile_data_error":"Se produjo un error al guardar los datos del perfil","save_publication_settings":"Se produjo un error guardando la configuración","search_error":"Ocurrió un error en la búsqueda","session_expired":"Tu sesión ha expirado","set_as_template_error":"No se puede configurar como plantilla","share_failed_request":"Se produjo un error, tu selección no se pudo compartir","share_proposal_error":"Se produjo un error al enviar la propuesta","share_publication_error":"Ocurrió un error al enviar la publicación","share_with_user":"Ocurrió un error al compartir el archivo","the_resources_are_restricted_for_sharing":"Los recursos que intenta compartir están restringidos.","unexpected_error":"Error inesperado","update_publication":"Ocurrió  un error durante la actualización del documento","wrong_file_type":"Tipo de archivo incorrecto"},"fileFormat":{"COMPONENT":"Página","DOCUMENT":"Documento","EPUB":"EPUB","FILE":"Archivo","IMAGE":"Imagen","MOVIE":"Vídeo","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Presentación","PROPOSAL":"Propuesta","PUBLICATION":"Publicación"},"info":{"create_note_success":"Tu nota ha sido guardada. <a href=%{url}>Ver tu notas</a>","delete_all":"Se han borrado todos los elementos","emails_sent":"Tu(s) correo(s) pendiente(s) han sido enviados.","fill_all_input_fields":"Por favor completa todos los campos del formulario","import_publication_pdf":"Tu archivo PDF se importó correctamente","offline_create_external_link":"Conéctate a Internet para crear un enlace externo","offline_create_folder":"Verifica que tienes conexión a Internet para poder crear una carpeta.","offline_download_multiple_assets":"Por favor conéctate a Internet para descargar los elementos","offline_download_single_asset":"Por favor conéctate a Internet para descargar el elemento","offline_fetch_notes":"Por favor conéctate a Internet para ir a buscar en tus notas","offline_login":"Por favor contéctate a internet para abrir tu sesión","offline_no_config":"Necesitas una conexión a internet para abrir tu sesión por primera vez","offline_update_folder_tree":"Necesitas una conexión a Internet para actualizar el árbol de contenido","remove_publication_pdf":"Tu PDF se eliminó con éxito","reset_all_downloads":"Todas las descargas se han restablecido","selection_sent":"Tu(s) selección(es) pendiente(s) han sido compartida(s).","selection_shared_once_online":"tu selección se va a compartir cuando te conectes","set_as_template_success":"El archivo ha sido exitosamente configurado como plantilla","share_with_user_success":"El archivo se compartió con éxito","url_copied":"La URL ha sido copiada"},"languages":{"ca_ES":"Catalán","da_DK":"Danés","de_DE":"Alemán","en_AU":"Inglés - AU","en_UK":"Inglés - UK","en_US":"Inglés - US","es_ES":"Español","eu_ES":"Vasco","fi_FI":"Finnés","fr_FR":"Francés","gl_ES":"Gallego","he_IL":"Hebreo","it_IT":"Italiano","ja_JP":"Japonés","ko_KR":"Coreano","nl_NL":"Holandés","nn_NO":"Noruego Nynorsk","pl_PL":"Polaco","pt_PT":"Portugués","ro_RO":"Rumano","ru_RU":"Ruso","sk_SK":"Slovaco","sv_SE":"Sueco","tr_TR":"Turco","zh_CN":"Chino - China","zh_SI":"Chino - Singapur","zh_TR":"Chino - Tradicional","zh_TW":"Chino - Tradicional"},"messages":{"CUSTOM_DOMAIN":"Custom domain","PUBLISH":"Publicar","SSO_SECURITY":"SSO seguridad","WISHLIST":"Lista de deseos","XLS_SECURITY":"XLS seguridad","activate_offline_mode":"Activar modo sin conexión","add":"Agregar","add_file":"Agregar archivo","add_pdf_to_download":"Agregar un PDF para descargar","add_slide":"Agregar un slide","add_to_selection":"Añadir a la selección","already_member":"¿Ya registrado?","alt_attribute":"Atributo alt","animation":"Animación","another_user":"Otro usuario","application_content":"Contenido app","archive_noun":"Archivo","archive_verb":"Archivar","assortment":"Repositorio","auto_zoom_level":"Nivel de zoom automático","autoplay_delay":"Retraso de la reproducción automática (seg.)","available_as_template":"Disponible como plantilla","available_offline":"Disponible sin conexión","back":"Volver","back_to_company":"Volver a la Empresa","back_to_home":"Volver al Inicio","back_to_login":"Volver al Login","back_to_method_view":"Elige otro método de autenticación","bg_cover_left_tooltip":"Este ajuste solo tendrá efecto si la pantalla del usuario recorta el fondo por los lados","bg_cover_top_tooltip":"Este ajuste solo tendrá efecto si la pantalla del usuario recorta el fondo en la parte superior/inferior","bottom":"Abajo","bulleted":"Viñetas","campaign_name":"Nombre de campaña","cancel":"Cancelar","change_cover_image":"Cambiar imagen de portada","change_password":"Cambia la contraseña","check_for_updates":"Buscar Actualizaciones","checking_for_updates":"<b>Comprobando actualizaciones...</b>","choose_coworker":"Elegir un usuario","clear_selection":"Borrar selección","client_id":"Cliente id","client_secret":"Cliente secreto","close":"Cerrar","color":"Color","combine":"Combinar","combine_by_selecting_pages":"Selecciona las páginas para incluir en tu lista","combining":"Combinando %{percentage} %","confirm_password":"Confirmar contraseña","confirmation":"Confirmación","connect":"Conectar","content_structure_incomplete":"Estructura de contenido incompleta","content_structure_never_completed":"Para usar la aplicación en modo sin conexión, primero debe completarse la estructura de contenido. Active su conexión a internet e inténtelo de nuevo.","content_structure_ready":"La estructura de contenido ya está disponible para su uso sin conexión","continue":"Continuar","continue_downloading":"Continuar de descargar todo","continue_downloading_important":"Reanudar la descarga de los archivos importantes","cookie_notification":"Utilizamos cookies propias para mejorar los servicios que te ofrecemos. Si continuas navegando, consideramos que aceptas su uso. De todos modos, si lo prefieres, puedes cambiar la configuración de tu navegador para desactivarlas. <a target='_blank' href=%{url}>Más información aquí.</a>","cookie_settings":"Gestionar servicios","copy":"Copiar","copy_links_to_share":"Copia, abre el correo de tu cliente y pégalo","copy_mode_html":"Lista de enlaces","copy_mode_text":"Texto sin formato","copy_paste_your_link":"Copia y pega tu enlace","coverflow":"Miniaturas","create":"Crear","create_customized_proposal":"Crear una propuesta personalizada","create_deal_in_crm":"<span>Generar una transacción</span><br>en mi CRM","create_demo_account":"Creando una cuenta...","create_external_link":"Crear un enlace externo","create_folder":"Crear una carpeta","create_from_template":"Crear desde una plantilla","create_note":"Crear una nota","create_proposal":"Crear una propuesta","create_proposal_from_file":"Crear una propuesta a partir de un archivo","create_proposal_from_template":"Crear una propuesta a partir de una plantilla","create_publication":"Crear una publicación","create_your_slider":"Crea tu carrusel","creation_date":"Fecha de creación","crm":"CRM","custom_pdf":"PDF personalizado","customize_url":"Personalizar la URL","customize_url_hint":"Texto para personalizar el final de la URL","deactivate_offline_mode":"Desactivar modo sin conexión","default":"Por defecto","default_animation":"Animación por defecto","default_file":"Archivo por defecto","default_image":"Imagen por defecto","default_video":"Video predeterminado","delete":"Borrar","delete_assets_sequentially":"Eliminar los recursos secuencialmente (más lento","delete_data":"Eliminar todos los archivos","deleting":"Eliminando...","dependencies_deleted_out_of":"Eliminando %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependencias","dependency_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependencia","description":"Descripción","deselect_all":"Deseleccionar todo","desktop":"Ordenador","details":"Detalles","display_mode":"Visualización","do_not_close_app":"<b>Por favor, no cierre la aplicación.</b>","done":"Listo","dont_ask_me_again":"No volver a preguntar","download":"Descargar","download_all":"Descargar todo","download_all_important":"Descargar los archivos importantes","download_all_toast_in_progress":"Descarga en curso.<br><b>¡No cierres la aplicación!</b>","download_all_toast_paused":"Se detuvo la descarga de todos los archivos.<br>¿Te gustaría continuar?","download_complete":"Descarga completa","download_complete_important":"Important Downloads Complete","download_importants_toast_in_progress":"Downloading important assets in progress.<br><b>Do not minimize the application!</b>","download_importants_toast_paused":"Download of important assets was paused.<br>Would you like to continue?","download_manager":"Gestor de descargas","download_pdf":"Descargar PDF","download_selected_toast_in_progress":"Descargando activos seleccionados en progreso.<br><b>¡No minimices la aplicación!</b>","download_selected_toast_paused":"La descarga de activos seleccionados se ha pausado.<br>¿Te gustaría continuar?","download_toast_link_to_downloads":"Open <a href=%{url}>Downloads</a> page to view the progress.","download_toast_status":"Descargando %{downloadedItems} | %{totalItems}","downloaded":"Descargado","downloading":"Descargando","downloading_thumbnails_for_offline_use":"Descargando miniaturas para uso sin conexión","downloads":"Descargas","draft":"Borrador","duplicate":"Duplicar","duplicate_theme":"Duplicar tema","edit":"Editar","edit_text":"Editar texto","email":"Email","email_integration":"Integración email","enabled":"Activar","end_date":"Fecha de finalización","enter_image_description":"Ingrese la descripción de la imagen","enter_image_source":"Ingrese el origen de la imagen","enter_password":"Escribir contraseña","enter_your_text":"Escriba su texto","error":"Error","extension_external_link":"Link externo","extension_flip":"Flip","file_size":"Tamaño de archivo","folder":"Carpeta","folder_name":"Nombre de la carpeta","font":"Fuente","forgot_password":"¿Contraseña olvidada?","format":"Formato","free_space":"Espacio libre","from_app":"Desde la App","from_desktop":"Desde el Escritorio","from_drive":"Desde mi cuenta","from_selection":"Desde Mi Selección","from_youtube":"Desde Youtube","full_pdf":"PDF completo","full_publication":"Toda la publicación","gdpr_allowAll":"Aceptar todo","gdpr_message":"Este sitio usa cookies y permite tener control sobre los que se autoriza activar o no","gdpr_personalize":"Personalizar","gdpr_privacy_policy":"Política de confidencialidad","gdpr_reject_all":"Continuar sin aceptar","get_url":"Obtener URL","goto_page":"Ir a la página","goto_page_id":"Ir al ID de página","grid":"Cuadrícula","home":"Inicio","hours_left":"%{hours} horas restantes","iframe":"Iframe","image":"Imagen","image_source":"Origen de la imagen","import_file":"Importar archivo","imported_all_files":"Todos los archivos han sido importados","importing":"Importador","importing_files_status":"Importando %{importedFiles} | %{totalFiles}","importing_with_percentage":"Importando %{percentage} %","informations":"Información","integrate":"Activado","integrate_ua_code":"Integrar código UA de Analytics","integrate_ua_code_hint":"En caso de contar con varios códigos UA a implementar, deben ser separados por una coma","invalid_chapter_id":"ID de página no válida","invite_coworker":"Invitar usuario seleccionado","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} elemento","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} elementos","keep_it_for_later":"Descargar más tarde","ken_burns_effect":"Efecto Ken Burns (zoom automático)","language":"Idioma","last_update_date":"Última actualización","left":"Izquierda","less_than_minute_left":"Falta menos de un minuto","library":"Carpeta compartida","line_height":"Altura de la línea","link":"Enlace","list_type":"Tipo de lista","loading":"Cargando...","loading_fetch_content":"Obteniendo contenido de la unidad 1/3...","loading_required_items":"Descargando el contenido requerido 2/3...","loading_thumbnails":"Descargando pre-visualizaciones 3/3...","local":"Local","log_out":"Cerrar sesión","logging_in":"Iniciar sesión...","masonry":"Мampostería","menu":"Menú","minutes_left":"%{minutes} minutos restantes","modify_slide":"Modificar slide","move":"Mover","my_app":"Mi App","my_documents":"Mis Documentos","my_downloads":"Mis Descargas","my_drive":"Mi Cuenta","my_gallery":"Mi Galería","my_notes":"Mis Notas","my_parameters":"Mis ajustes","my_profile":"Mi perfil","my_selection":"Mi Selección","my_sent":"Mis envíos","my_templates":"Mis plantillas","name":"Nombre","name_surname":"Nombre Apellido","new":"Nuevo","new_content_available_start_download":"Hay nuevo contenido disponible.¿Quieres descargarlo ahora?","next":"Siguiente","no_assets":"Esta carpeta está vacía","no_assortment":"El repositorio se encuentra vacío","no_data_found":"Datos no encontrados","no_downloads":"No has descargado nada","no_new":"No hay nuevo contenido","no_results":"No hay resultados para esta búsqueda","no_save_as_info":"La plantilla que quieres duplicar ha sido actualizado recientemente, por favor crea una nueva propuesta a partir de la nueva plantilla. ","no_selection":"No has seleccionado nada aún","no_share_users":"No hay usuarios disponibles en la aplicación","no_target_selected":"Seleccionar un archivo para abrir","no_templates":"Ninguna plantilla disponible ","no_updates":"No hay contenido actualizado","none":"Ninguno","normal":"Normal","note":"Nota","notification":"Notificación","notification_credits_multiline":"%{credits} créditos serán restados de tu cuenta por \"%{action}\"","numbered":"Numerada","ok":"OK","one_hour_left":"1 hora restante","one_minute_left":"1 minuto restante","open":"Abrir","open_in_new_tab":"Abrir en una nueva pestaña","open_in_same_tab":"Abrir en la misma pestaña","open_popup":"Abrir un pop-up","opened_date":"Fecha de apertura","options":"Opciones","or_sign_in":"Inicia sesión","page":"Página","page_id":"ID de página","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Página no encontrada","pages_selection":"Listas","pages_selection_tooltip":"Se te cobrará por publicar la publicación seleccionada para poder usarla en una lista.","parameters":"Ajustes","password":"Contraseña","pdf_processing":"Procesando PDF %{percentage} %","pdf_type":"Tipo de PDF","phone":"Móvil","phone_number":"Número de teléfono","pin_code":"Código PIN","placeholder_company":"Ingrese el nombre de tu empresa","placeholder_email":"Email","placeholder_login":"Usuario","placeholder_password":"Contraseña","placeholder_phone":"Número de teléfono","placeholder_search_drive_item":"Buscar","placeholder_share_contact_email":"Email del destinatario","placeholder_share_message":"Tu mensaje","placeholder_share_name":"Tu nombre","placeholder_share_user_email":"Tu email","popup":"Seleccionar archivo","popup_label":"Pop-up","position":"Posición","preparing_content_structure":"Preparando la estructura de contenido...","preview":"Previsualizar","private_folder":"Carpeta personal","processing":"Procesando","profile":"Perfil","profile_offline_message":"La página de perfil no puede ser editada en modo offline. Prueba nuevamente cuando está conectado","project_url":"URL del proyecto","proposal_locked":"La propuesta está siendo editada por %{userName}","proposal_name":"Nombre de la propuesta","publication_locked":"La publicación está siendo editada por %{userName}","publication_name":"Nombre de la publicación","publish":"Actualizar","publish_publication":"Publicar mi publicación","published":"Publicado","publishing":"Publicando","read":"Leer","remember_me":"Recuérdame","remove":"Eliminar","remove_email_integration":"Estás seguro querer desactivar la integración de email?","remove_from_selection":"Eliminar de la selección","remove_template":"Eliminar esta plantilla","remove_theme":"Eliminar tema","remove_theme_question":"¿Seguro quieres quitar el tema actual?","removing":"Eliminando","rename":"Renombrar","rename_theme":"Cambiar el nombre del tema","replace":"Reemplazar","replace_file":"Reemplazar el archivo","reset_all_downloads":"Restablecer todas las descargas","reset_my_preferences":"Reiniciar mis preferencias","reset_to_default":"Restablecen a los predeterminados","resolution":"Resolución","resource_name":"Nombre","restart":"Reiniciar","restart_all":"Reiniciar todo","resuming":"Retomar","retry":"Reintentar","right":"Derecha","row":"Fila","salesforce":"Salesforce","salesforce_activation":"Activación de Salesforce","save":"Guardar","save_as":"Guardar como","save_in_documents":"Guardar en Mis documentos","saving":"Guardando..","scale":"Escalar","search":"Buscar","search_phrase":"Frase de búsqueda","search_results":"Resultados de la búsqueda","see_preview":"Vista previa","seen":"Visto","select_all":"Seleccionar todo","select_application":"Elige una aplicación","select_playlist_item":"Seleccione un elemento para agregar a su palylist","select_publication_item":"Seleccione un elemento para agregar a su publicación","select_server":"Seleccione un servidor","select_this_application":"Eligir esta aplicación","select_this_server":"Eligir este servidor","select_your_tags":"Selecciona tus etiquetas","select_your_template":"Eligir tu plantilla","selection":"Selección","send":"Enviar","send_by_email":"Enviar por Email","send_my_proposal":"Enviar mi propuesta","send_my_publication":"Enviar mi publicación","send_my_selection":"Enviar mi selección","sent":"Enviado","sent_date":"Fecha enviada","session_expired":"Tu sesión ha expirado","set_as_template":"Configurar como plantilla","settings":"Configuración","share":"Compartir","share_by_email":"Compartir por email","share_my_selection":"Compartir mi selección","share_via_copy":"Copiar enlaces","share_via_uprez":"Compartir por formulario de contacto","shared":"Compartido","shared_with_me":"Compartido conmigo","sign_in_options":"Opciones de acceso","sign_up_for_free_trial":"Registrarte para una demostración gratuita","size":"Tamaño","slider":"Carrusel","sources":"Fuentes","spacing":"Espaciado","start_to_download":"Descargar ahora","status_read":"Leído","templates":"Plantillas","test_our_demo":"Probar nuestra demo","text":"Texto","text_style":"Estilo de texto","theme":"Tema","theme_name":"Nombre del tema","themes":"Temas","title":"Titulo","title_and_preview":"Titulo/previsualización","top":"Arriba","try_demo":"Crear nueva cuenta","tutorial_uprez":"Tutorial Uprez","type":"Tipo","unlock":"Desbloquear","unread":"No leído","untitled_note":"Nota sin nombre","update":"Actualizar","update_all":"Actualizar todo","update_all_important":"Actualizar todos los archivos importantes","update_folder_tree":"Actualizar todo la árbol de contenido","update_pdf_thumb":"Actualizar miniaturas del PDF","update_pdf_thumb_accept":"Quiero generar todas las miniaturas","update_pdf_thumb_message":"Tu PDF será reemplazado por esté","update_published":"Aplicar cambios","updating":"Actualizando","updating_asset":"Actualizando...","updating_content_structure":"Actualizando la estructura de contenido...","url":"Url","used_space":"Espacio usado","version":"Versión","video":"Vídeo","video_processing":"Procesamiento de video","view":"Vista","view_published":"Ver actualización","webpublication":"Webpublication","webpublication_method":"Webpublication autenticación","your_company_account":"La cuenta de su empresa","your_file":"Tu archivo","your_themes":"Tus temas","your_ua_code":"Tu código UA de Analytics","your_url":"Tu URL","youtube_link":"Enlace a un vídeo de Youtube"},"page_title":{"assortment":"Repositorio %{galleryName}","authentication":"Autenticación","details":"Detalles %{itemName} - %{galleryName}","downloads":"Descargas %{galleryName}","drive":"Drive %{galleryName}","editor":"Editor","folder":"Carpeta %{itemName} - %{galleryName}","gallery":"Galería","gallery_name":"%{galleryName}","my_documents":"Mis documentos - %{galleryName}","my_notes":"Mis Notas","my_sent":"Mis envíos","new":"Nueva %{galleryName}","parameters":"Parámetros %{galleryName}","profile":"Perfil","search":"Buscar %{galleryName}","selection":"Selección %{galleryName}","shared_with_me":"Compartido conmigo","theater":"Theater %{itemName} - %{galleryName}"},"share":{"company":"Еmpresa","contact":"Información del destinatario","contactEmail":"Email del destinatario","documents":"Documentos","email_body":"Encontrarás a continuación los documentos que solicitaste durante nuestra reunión.","email_greeting":"Hola,","email_salutation":"Cordialmente,","firstname":"Nombre","notes":"Notas","phone":"Teléfono","position":"Cargo","subject":"Asunto","surname":"Apellido"},"type":{"asp-type-0":"Directorio","asp-type-1":"Componente","asp-type-10":"App","asp-type-11":"Galería","asp-type-12":"Enlace externo","asp-type-2":"Archivo","asp-type-3":"Modelo","asp-type-4":"Imagen","asp-type-5":"Vídeo","asp-type-6":"Publicación","asp-type-7":"Sonido","asp-type-8":"Publicación","asp-type-9":"Enlace"}}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/AAAA","long":"DD MMM AAAA"},"error":{"another_user_login":"Has estat desconnectat perquè estàs connectat amb un altre dispositiu","asset_not_erasable":"Un o més recursos no es podien suprimir","authentication_needed":"Identificació requerida, si us plau reinicia la sessió","bundle_content_expired":"%{number} elementos han expirado ","bundle_delete_fail":"%{number} elements no es poden esborrar","bundle_download_fail":"%{number} elements no es poden descarregar","bundle_fetch_content_error":"%{number} elements no es poden recuperar","bundle_initialization_fail":"Error en la inicialització del paquet ","bundle_open_fail":"%{number} elements no es poden obrir","cant_archive_proposal":"No es pot arxivar la proposta","cant_change_cover_image":"No s’ha pogut canviar la imatge de portada","cant_create_external_link":"No és possible crear un enllaç extern","cant_create_folder":"No es pot crear aquesta carpeta","cant_create_note":"No es pot crear la nota","cant_get_resource":"Fitxer d’origen inaccessible","cant_move_asset":"No es pot moure un recurs","cant_remove_asset":"No es pot eliminar un recurs","cant_remove_note":"No es pot esborrar la nota","cant_update_note":"No es pot actualitzar la nota","combine_error":"S’ha produït un error en combinar","content_expired":"L’element (id: %{id}) ha expirat","create_proposal_error":"No es pot crear una proposta","create_publication_error":"No s’ha pogut crear la publicació","custom_url_used":"Aquesta URL personalitzada ja existeix","delete_fail":"L’element (id: %{id}) no es pot esborrar","download_fail":"No s’ha pogut descarregar el contingut (id: %{id}). Si us plau, intenta tornar-lo a descarregar sense minimitzar l’aplicació ni canviar a una altra.","duplicate_email":"Aquest correu electrònic ja s’ha utilitzat","duplicate_file_name":"El fitxer ja existeix","duplicate_page_error":"No es pot duplicar la pàgina","duplicate_theme":"Nom del tema ja utilitzat","fetch_content_block_error":"Els elements (parent: %{id}) no es poden recuperar","fetch_content_error":"L’element (id: %{id}) no s’ha trobat","fetch_editor_data_error":"S’ha produït un error en carregar les dades de l’editor","fetch_folder_tree":"S’ha produït un error en actualitzar l’arbre de contingut","fetch_notes_error":"S’ha produït un error en carregar les notes","fetch_profile_data_error":"S’ha produït un error en carregar les dades del perfil","fetch_proposal_stats_error":"S’ha produït un error en carregar les estadístiques de la proposta","fetch_publication_data":"S’ha produït un error en carregar les dades de la publicació","fetch_publication_templates_error":"Error en carregar la plantilla","field_must_have_at_least":"El camp ha de tenir com a mínim %{charsCount} caràcters","file_import_error":"S’ha produït un error en importar un fitxer","file_import_error_short":"Error en importar","get_publication_settings":"S’ha produït un error en carregar la configuració de la publicació","get_publication_url":"S’ha produït un error en intentar obtenir l’URL de la publicació","get_share_users":"S’ha produït un error en obtenir les dades dels usuaris","import_publication_pdf":"S’ha produït un error en importar el PDF","initialization_fail":"S’ha produït un error durant la inicialització, si us plau, reinicia l’aplicació","invalid_auth":"Inici de sessió o contrasenya no vàlids","invalid_company_name":"Nom d’empresa no vàlid","invalid_email_address":"Correu electrònic no vàlid","invalid_page_number":"Número de pàgina no vàlid","invalid_url":"URL no vàlida","login_or_password_incorrect":"Nom d’usuari o contrasenya incorrectes","move_page_error":"No es pot moure la pàgina","no_application_available":"Aplicació no disponible","open_fail":"L’element no es pot obrir","parse_editor_data_error":"S’ha produït un error en analitzar les dades de l’editor","passwords_do_not_match":"La contrasenya no coincideix amb la confirmació","processing_fail":"Processament fallit","proposal_not_archived":"La proposta no s’ha arxivat","publish_publication":"S’ha produït un error durant la publicació del document","remove_page_error":"No es pot eliminar la pàgina","remove_template_error":"No és possible eliminar la plantilla","rename_asset_error":"No s’ha pogut canviar el nom del fitxer","reset_fail":"No s’han pogut restablir les baixades","save_editor_data_error":"S’ha produït un error en desar les dades de l’editor","save_profile_data_error":"S’ha produït un error en desar les dades del perfil","save_publication_settings":"S’ha produït un error en desar la configuració","search_error":"S’ha produït un error en la cerca","session_expired":"La teva sessió ha caducat","set_as_template_error":"No es pot configurar com a plantilla","share_failed_request":"S’ha produït un error, no s’ha pogut compartir la teva selecció","share_proposal_error":"S’ha produït un error en enviar la proposta","share_publication_error":"S’ha produït un error en enviar la publicació","share_with_user":"S’ha produït un error en compartir el fitxer","the_resources_are_restricted_for_sharing":"Els recursos que intenta compartir estan restringits","unexpected_error":"Error inesperat","update_publication":"S’ha produït un error durant l’actualització del document","wrong_file_type":"Format de fitxer incorrecte"},"fileFormat":{"COMPONENT":"Pàgina","DOCUMENT":"Document","EPUB":"EPUB","FILE":"Fitxer","IMAGE":"Imatge","MOVIE":"Vídeo","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Presentació","PROPOSAL":"Proposta","PUBLICATION":"Publicació"},"info":{"create_note_success":"La teva nota s’ha desat. <a href=%{url}>Veure les teves notes</a>","delete_all":"S’han esborrat tots els elements","emails_sent":"S’han enviat els teus correus pendents.","fill_all_input_fields":"Si us plau, completa tots els camps del formulari","import_publication_pdf":"El teu fitxer PDF s’ha importat correctament","offline_create_external_link":"Connecta’t a Internet per crear un enllaç extern","offline_create_folder":"Verifica que tens connexió a Internet per poder crear una carpeta.","offline_download_multiple_assets":"Si us plau, connecta’t a Internet per descarregar els elements","offline_download_single_asset":"Si us plau, connecta’t a Internet per descarregar l’element","offline_fetch_notes":"Si us plau, connecta’t a Internet per cercar a les teves notes","offline_login":"Si us plau, connecta’t a Internet per iniciar la teva sessió","offline_no_config":"Necessites una connexió a Internet per iniciar la teva sessió per primera vegada","offline_update_folder_tree":"Necessites una connexió a Internet per actualitzar l’arbre de contingut","remove_publication_pdf":"El teu PDF s’ha eliminat correctament","reset_all_downloads":"Totes les baixades s’han restablert","selection_sent":"S’han compartit les teves seleccions pendents.","selection_shared_once_online":"La teva selecció es compartirà quan et connectis","set_as_template_success":"El fitxer s’ha configurat correctament com a plantilla","share_with_user_success":"El fitxer s’ha compartit correctament","url_copied":"S’ha copiat l’URL"},"languages":{"ca_ES":"Català","da_DK":"Danès","de_DE":"Alemany","en_AU":"Anglès - AU","en_UK":"Anglès - UK","en_US":"Anglès - EUA","es_ES":"Espanyol","eu_ES":"Basc","fi_FI":"Finès","fr_FR":"Francès","gl_ES":"Gallec","he_IL":"Hebreu","it_IT":"Italià","ja_JP":"Japonès","ko_KR":"Coreà","nl_NL":"Neerlandès","nn_NO":"Noruec Nynorsk","pl_PL":"polonès","pt_PT":"Portuguès","ro_RO":"Romanès","ru_RU":"Rus","sk_SK":"Eslovac","sv_SE":"Suec","tr_TR":"Turc","zh_CN":"Xinès – Xina","zh_SI":"Xinès - Singapur","zh_TR":"Xinès - Tradicional","zh_TW":"Xinès – Taiwan"},"messages":{"CUSTOM_DOMAIN":"Domini personalitzat","PUBLISH":"Publicar","SSO_SECURITY":"Seguretat SSO","WISHLIST":"Llista de desitjos","XLS_SECURITY":"XLS seguretat","activate_offline_mode":"Activar el mode sense connexió","add":"Afegir","add_file":"Afegir fitxer","add_pdf_to_download":"Afegir un PDF per descarregar","add_slide":"Afegir un slide","add_to_selection":"Afegir a la selecció","already_member":"Ja ets usuari?","alt_attribute":"Atribut alt","animation":"Animació","another_user":"Un altre usuari","application_content":"Contingut de l'app","archive_noun":"Fitxer","archive_verb":"Arxivar","assortment":"Repositori","auto_zoom_level":"Nivell de zoom automàtic","autoplay_delay":"Retard de la reproducció automàtica (s)","available_as_template":"Disponible com a plantilla","available_offline":"Disponible sense connexió","back":"Enrere","back_to_company":"Tornar a l’Empresa","back_to_home":"Tornar a l’inici","back_to_login":"Tornar a iniciar sessió","back_to_method_view":"Tria un altre mètode d’autenticació","bg_cover_left_tooltip":"Aquest ajust només tindrà efecte si la pantalla de l’usuari retalla el fons pels costats","bg_cover_top_tooltip":"Aquest ajust només tindrà efecte si la pantalla de l’usuari retalla el fons per la part superior/inferior","bottom":"A baix","bulleted":"Vinyetes","campaign_name":"Nom de la campanya","cancel":"Cancel·lar","change_cover_image":"Canviar la imatge de portada","change_password":"Canvia la contrasenya","check_for_updates":"Cercar actualitzacions","checking_for_updates":"<b>Comprovant actualitzacions...</b>","choose_coworker":"Tria un usuari ","clear_selection":"Esborrar la selecció","client_id":"ID de client","client_secret":"client secret","close":"Tancar","color":"Color","combine":"Combinar","combine_by_selecting_pages":"Selecciona les pàgines per incloure en la teva llista","combining":"Combinant %{percentage} %","confirm_password":"Confirmar contrasenya","confirmation":"Confirmació","connect":"Connectar","content_structure_incomplete":"Estructura de contingut incompleta","content_structure_never_completed":"Per utilitzar l'aplicació en mode fora de línia, primer s'ha de completar l'estructura de contingut. Activeu la connexió a internet i torneu-ho a provar.","content_structure_ready":"L'estructura de contingut ja està disponible per a l'ús fora de línia","continue":"Continuar","continue_downloading":"Continuar la descàrrega de tot","continue_downloading_important":"Reprendre la descàrrega dels fitxers importants","cookie_notification":"Utilitzem galetes pròpies per millorar els serveis que t’oferim. Si continues navegant, considerem que n’acceptes l’ús. En qualsevol cas, si ho prefereixes, pots canviar la configuració del teu navegador per desactivar-les.\r\n<a target='_blank' href=%{url}>Més informació aquí.</a>\r\n\r\n","cookie_settings":"Gestionar serveis","copy":"Copiar","copy_links_to_share":"Copia, obre el correu del teu client i enganxa’l","copy_mode_html":"Llista d’enllaços","copy_mode_text":"Text sense format","copy_paste_your_link":"Copia i enganxa el teu enllaç","coverflow":"Miniatures","create":"Crear","create_customized_proposal":"Crear una proposta personalitzada","create_deal_in_crm":"<span>Generar una transacció</span><br>al meu CRM","create_demo_account":"Creant un compte...","create_external_link":"Crea un enllaç extern","create_folder":"Crea una carpeta","create_from_template":"Crea des d’una plantilla","create_note":"Crea una nota","create_proposal":"Crea una proposta","create_proposal_from_file":"Crea una proposta a partir d’un fitxer","create_proposal_from_template":"Crea una proposta a partir d’una plantilla","create_publication":"Crea una publicació","create_your_slider":"Crea el teu carrusel","creation_date":"Data de creació","crm":"CRM","custom_pdf":"PDF personalitzat","customize_url":"Personalitzar l’URL","customize_url_hint":"Text per personalitzar el final de l’URL","deactivate_offline_mode":"Desactivar el mode sense connexió","default":"Per defecte","default_animation":"Animació per defecte","default_file":"Fitxer per defecte","default_image":"Imatge per defecte","default_video":"Vídeo per defecte","delete":"Esborrar","delete_assets_sequentially":"Suprimeix els recursos seqüencialment (més lent)","delete_data":"Eliminar tots els fitxers","deleting":"Deleting...","dependencies_deleted_out_of":"Deleting %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependències","dependency_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependència","description":"Descripció","deselect_all":"Desselecciona-ho tot","desktop":"Ordinador","details":"Detalls","display_mode":"Visualització","do_not_close_app":"<b>Si us plau, no tanqueu l'aplicació.</b>","done":"Fet","dont_ask_me_again":"No tornar a preguntar","download":"Descarregar","download_all":"Descarregar-ho tot","download_all_important":"Descarregar els fitxers importants","download_all_toast_in_progress":"Descàrrega en curs.<br><b>No tanquis l’aplicació!</b>","download_all_toast_paused":"S’ha aturat la descàrrega de tots els fitxers.<br>Vols continuar?","download_complete":"Descarga completa","download_complete_important":"Descàrregues importants completades","download_importants_toast_in_progress":"S’estan descarregant recursos importants.<br><b>No minimitzis l’aplicació!</b>","download_importants_toast_paused":"Download of important assets was paused.<br>Would you like to continue?","download_manager":"Gestor de descargas","download_pdf":"Descargar PDF","download_selected_toast_in_progress":"Descargando activos seleccionados en progreso.<br><b>¡No minimices la aplicación!</b>","download_selected_toast_paused":"S’ha pausat la descàrrega dels recursos seleccionats.<br>Vols continuar?","download_toast_link_to_downloads":"Obre la pàgina de <a href=%{url}>Descàrregues</a> per veure el progrés.","download_toast_status":"Descarregant %{downloadedItems} | %{totalItems}","downloaded":"Descarregat","downloading":"Descargando","downloading_thumbnails_for_offline_use":"S’estan baixant les miniatures per a ús fora de línia","downloads":"Descargas","draft":"Esborrany","duplicate":"Duplicar","duplicate_theme":"Duplicar tema","edit":"Editar","edit_text":"Editar text","email":"Email","email_integration":"Integració de l’email","enabled":"Activar","end_date":"Data de finalització","enter_image_description":"Introdueix la descripció de la imatge","enter_image_source":"Enter image source","enter_password":"Escriure la contrasenya","enter_your_text":"Escriu el teu text","error":"Error","extension_external_link":"Enllaç extern","extension_flip":"Flip","file_size":"Mida del fitxer","folder":"Carpeta","folder_name":"Nom de la carpeta","font":"Font","forgot_password":"Has oblidat la contrasenya?","format":"Format","free_space":"Espai lliure","from_app":"Des de l'app","from_desktop":"Des de l'escriptori","from_drive":"Des del meu compte","from_selection":"Des de la meva selecció","from_youtube":"Des de Youtube","full_pdf":"PDF complet","full_publication":"Tota la publicació","gdpr_allowAll":"Acceptar-ho tot","gdpr_message":"Aquest lloc utilitza galetes i permet tenir control sobre el que s’autoritza activar o no","gdpr_personalize":"Personalitzar","gdpr_privacy_policy":"Política de confidencialitat","gdpr_reject_all":"Continuar sense acceptar","get_url":"Obtenir l’URL","goto_page":"Anar a la pàgina","goto_page_id":"Anar a l'ID de pàgina","grid":"Quadrícula","home":"Inici","hours_left":"%{hours} hores restants","iframe":"Iframe","image":"Imatge","image_source":"Image source","import_file":"Importar fitxer","imported_all_files":"Tots els fitxers han estat importats","importing":"Importador","importing_files_status":"Important %{importedFiles} | %{totalFiles}","importing_with_percentage":"Important %{percentage} %","informations":"Informació","integrate":"Activat","integrate_ua_code":"Integrar codi UA d’Analytics","integrate_ua_code_hint":"En cas de disposar de diversos codis UA a implementar, s’han de separar amb una coma","invalid_chapter_id":"ID de pàgina no vàlid","invite_coworker":"Convidar l’usuari seleccionat","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} element","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} elements","keep_it_for_later":"Descarregar més tard","ken_burns_effect":"Efecto Ken Burns (zoom automàtic)","language":"Idioma","last_update_date":"Darrera actualització","left":"Esquerra","less_than_minute_left":"Falta menys d’un minut","library":"Carpeta compartida","line_height":"Alçada de la línia","link":"Enllaç","list_type":"Tipus de llista","loading":"Carregant...","loading_fetch_content":"S’està obtenint el contingut de la unitat 1/3...","loading_required_items":"S’està descarregant el contingut requerit 2/3...","loading_thumbnails":"S’estan descarregant les previsualitzacions 3/3...","local":"Local","log_out":"Tancar sessió","logging_in":"Iniciant sessió...","masonry":"Mamposteria","menu":"Menú","minutes_left":"%{minutes} minuts restants","modify_slide":"Modificar slide","move":"Moure","my_app":"La meva App","my_documents":"Els meus Documents","my_downloads":"Les meves descàrregues","my_drive":"El meu compte","my_gallery":"La meva galeria","my_notes":"Les meves Notes","my_parameters":"La meva configuració","my_profile":"El meu perfil","my_selection":"La meva selecció","my_sent":"Els meus enviaments","my_templates":"Les meves plantilles","name":"Nom","name_surname":"Nom Cognom","new":"Nou","new_content_available_start_download":"Hi ha contingut nou disponible. Vols descarregar-lo ara?","next":"Següent","no_assets":"Aquesta carpeta és buida","no_assortment":"El repositori és buit","no_data_found":"Dades no trobades","no_downloads":"No has descarregat res","no_new":"No hi ha contingut nou","no_results":"No hi ha resultats per a aquesta cerca","no_save_as_info":"La plantilla que vols duplicar s’ha actualitzat recentment, si us plau crea una nova proposta a partir de la nova plantilla.","no_selection":"Encara no has seleccionat res","no_share_users":"No hi ha usuaris disponibles a l’aplicació","no_target_selected":"Selecciona un fitxer per obrir","no_templates":"Cap plantilla disponible","no_updates":"No hi ha contingut actualitzat","none":"Cap","normal":"Normal","note":"Nota","notification":"Notificació","notification_credits_multiline":"Se’t descomptaran %{credits} crèdits del teu compte per \"%{action}\"","numbered":"Numerada","ok":"OK","one_hour_left":"1 hora restant","one_minute_left":"1 minuto restant","open":"Obrir","open_in_new_tab":"Obrir en una nova pestanya","open_in_same_tab":"Obrir en la mateixa pestanya","open_popup":"Obrir un pop-up","opened_date":"Data d’obertura","options":"Opcions","or_sign_in":"Inicia sessió","page":"Pàgina","page_id":"ID de pàgina","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Pàgina no trobada","pages_selection":"Llistes","pages_selection_tooltip":"Se’t cobrarà per publicar la publicació seleccionada per poder utilitzar-la en una llista.","parameters":"Configuració","password":"Contrasenya","pdf_processing":"Processant PDF %{percentage} %","pdf_type":"Tipus de PDF","phone":"Mòbil","phone_number":"Número de telèfon","pin_code":"Codi PIN","placeholder_company":"Introdueix el nom de la teva empresa","placeholder_email":"Email","placeholder_login":"Usuari","placeholder_password":"Contrasenya","placeholder_phone":"Número de telèfon","placeholder_search_drive_item":"Cercar","placeholder_share_contact_email":"Email del destinatari","placeholder_share_message":"El teu missatge","placeholder_share_name":"El teu nom","placeholder_share_user_email":"El teu email","popup":"Seleccionar fitxer","popup_label":"Pop-up","position":"Posició","preparing_content_structure":"S'està preparant l'estructura de contingut...","preview":"Previsualitzar","private_folder":"Carpeta personal","processing":"Processant","profile":"Perfil","profile_offline_message":"La pàgina de perfil no es pot editar en mode sense connexió. Torna-ho a provar quan estiguis connectat.","project_url":"URL del projecte","proposal_locked":"La proposta està sent editada per %{userName}","proposal_name":"Nom de la proposta","publication_locked":"La publicación está siendo editada por %{userName}","publication_name":"Nom de la publicació","publish":"Actualitzar","publish_publication":"Publicar la meva publicació","published":"Publicat","publishing":"Publicant","read":"Llegir","remember_me":"Recorda’m","remove":"Eliminar","remove_email_integration":"Estàs segur que vols desactivar la integració de correu electrònic?","remove_from_selection":"Eliminar de la selecció","remove_template":"Eliminar aquesta plantilla","remove_theme":"Eliminar tema","remove_theme_question":"Estàs segur que vols treure el tema actual?","removing":"Eliminant","rename":"Canviar el nom","rename_theme":"Canviar el nom del tema","replace":"Substituir","replace_file":"Substituir el fitxer","reset_all_downloads":"Restableix totes les baixades","reset_my_preferences":"Reiniciar les meves preferències","reset_to_default":"Restablir als valors predeterminats","resolution":"Resolució","resource_name":"Nom","restart":"Reiniciar","restart_all":"Reiniciar-ho tot","resuming":"Reprendre","retry":"Torna-ho a provar","right":"Dreta","row":"Fila","salesforce":"Salesforce","salesforce_activation":"Activació de Salesforce","save":"Desar","save_as":"Desar com a","save_in_documents":"Desar en els meus documents","saving":"Desant...","scale":"Escalar","search":"Cercar","search_phrase":"Frase de cerca","search_results":"Resultats de la cerca","see_preview":"Vista prèvia","seen":"Vist","select_all":"Seleccionar-ho tot","select_application":"Tria una aplicació","select_playlist_item":"Selecciona un element per afegir a la teva playlist","select_publication_item":"Selecciona un element per afegir a la teva publicació","select_server":"Selecciona un servidor","select_this_application":"Triar aquesta aplicació","select_this_server":"Triar aquest servidor","select_your_tags":"Selecciona les teves etiquetes","select_your_template":"Triar la teva plantilla","selection":"Selecció","send":"Enviar","send_by_email":"Enviar per correu electrònic","send_my_proposal":"Enviar la meva proposta","send_my_publication":"Enviar la meva publicació","send_my_selection":"Enviar la meva selecció","sent":"Enviat","sent_date":"Data d'enviament","session_expired":"La teva sessió ha expirat","set_as_template":"Configurar com a plantilla","settings":"Configuració","share":"Compartir","share_by_email":"Compartir per correu electrònic","share_my_selection":"Compartir la meva selecció","share_via_copy":"Copiar enllaços","share_via_uprez":"Compartir per formulari de contacte","shared":"Compartit","shared_with_me":"Compartit amb mi","sign_in_options":"Opcions d'accés","sign_up_for_free_trial":"Registrar-te per a una demostració gratuïta","size":"Mida","slider":"Carrusel","sources":"Fonts","spacing":"Espaiat","start_to_download":"Descarregar ara","status_read":"Llegit","templates":"Plantilles","test_our_demo":"Prova la nostra demo","text":"Text","text_style":"Estil de text","theme":"Tema","theme_name":"Nom del tema","themes":"Temes","title":"Títol","title_and_preview":"Títol/previsualització","top":"A dalt","try_demo":"Crear un compte nou","tutorial_uprez":"Tutorial Uprez","type":"Tipus","unlock":"Desbloquejar","unread":"No llegit","untitled_note":"Nota sense nom","update":"Actualitzar","update_all":"Actualitzar tot","update_all_important":"Actualitzar tots els arxius importants","update_folder_tree":"Actualitzar tot l’arbre de contingut","update_pdf_thumb":"Actualitzar les miniatures del PDF","update_pdf_thumb_accept":"Vull generar totes les miniatures","update_pdf_thumb_message":"El teu PDF serà substituït per aquest","update_published":"Aplicar canvis","updating":"Actualitzant","updating_asset":"Actualitzant...","updating_content_structure":"S'està actualitzant l'estructura de contingut...","url":"Url","used_space":"Espai utilitzat","version":"Versió","video":"Vídeo","video_processing":"Processament de vídeo","view":"Vista","view_published":"Veure actualització","webpublication":"Webpublication","webpublication_method":"Webpublication autenticació","your_company_account":"El compte de la teva empresa","your_file":"El teu fitxer","your_themes":"Els teus temes","your_ua_code":"El teu codi UA d'Analytics","your_url":"La teva URL","youtube_link":"Enllaç a un vídeo de YouTube"},"page_title":{"assortment":"Repositori %{galleryName}","authentication":"Autenticació","details":"Detalls %{itemName} - %{galleryName}","downloads":"Descarregues %{galleryName}","drive":"Drive %{galleryName}","editor":"Editor","folder":"Carpeta %{itemName} - %{galleryName}","gallery":"Galeria","gallery_name":"%{galleryName}","my_documents":"Els meus documents - %{galleryName}","my_notes":"Les meves notes","my_sent":"Els meus enviaments","new":"Nova %{galleryName}","parameters":"Paràmetres %{galleryName}","profile":"Perfil","search":"Cercar %{galleryName}","selection":"Selecció %{galleryName}","shared_with_me":"Compartit amb mi","theater":"Theater %{itemName} - %{galleryName}"},"share":{"company":"Еmpresa","contact":"Informació del destinatari","contactEmail":"Correu electrònic del destinatari","documents":"Documents","email_body":"A continuació trobaràs els documents que vas sol·licitar durant la nostra reunió.","email_greeting":"Hola,","email_salutation":"Cordialment,","firstname":"Nom","notes":"Notes","phone":"Telèfon","position":"Càrrec","subject":"Assumpte","surname":"Cognom"},"type":{"asp-type-0":"Directori","asp-type-1":"Component","asp-type-10":"App","asp-type-11":"Galeria","asp-type-12":"Enllaç extern","asp-type-2":"Fitxer","asp-type-3":"Model","asp-type-4":"Imatge","asp-type-5":"Vídeo","asp-type-6":"Publicació","asp-type-7":"So","asp-type-8":"Publicació","asp-type-9":"Enllaç"}}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/YYYY","long":"DD MMM YYYY"},"error":{"another_user_login":"Vous avez été déconnecté car vous vous êtes connecté depuis un autre appareil","asset_not_erasable":"Au moins un contenu n'était pas effaçable","authentication_needed":"Une erreur s'est produite, veuillez vous reconnecter","bundle_content_expired":"%{number} contenus sont expirés","bundle_delete_fail":"{number} contenus n'ont pas été supprimés","bundle_download_fail":"%{number} contenus n'ont pas été téléchargés","bundle_fetch_content_error":"%{number} contenus n'ont pu être récupérés","bundle_initialization_fail":"Échec de l'initialisation du paquet","bundle_open_fail":"%{number} contenus n'ont pu être ouverts","cant_archive_proposal":"Archivage de cette proposition impossible","cant_change_cover_image":"Impossible de changer l'image de couverture","cant_create_external_link":"Création de lien externe impossible","cant_create_folder":"Création de ce dossier impossible","cant_create_note":"Impossible de créer une note","cant_get_resource":"Impossible d'obtenir les informations de la ressource","cant_move_asset":"Impossible de déplacer un élément","cant_remove_asset":"Impossible de supprimer un élément","cant_remove_note":"Impossible de supprimer une note","cant_update_note":"Impossible de mettre à jour une note","combine_error":"Une erreur s'est produite lors de la combinaison","content_expired":"Le contenu (id: %{id}) est expiré","create_proposal_error":"Impossible de créer une proposition","create_publication_error":"Erreur lors de la création de la publication","custom_url_used":"Url personnalisé entré existe déjà","delete_fail":"Le contenu (id: %{id}) n'a pas été supprimé","download_fail":"Le contenu (id: %{id}) n'a pas pu être téléchargé. Veuillez essayer de le télécharger à nouveau sans réduire l'application ni basculer vers une autre.","duplicate_email":"Email utilisé","duplicate_file_name":"Le fichier existe déjà","duplicate_page_error":"Impossible de dupliquer la page","duplicate_theme":"Nom du thème déjà utilisé","fetch_content_block_error":"Les contenus (parent: %{id}) n'ont pas été récupérés","fetch_content_error":"Le contenu (id: %{id}) n'a pas été récupéré","fetch_editor_data_error":"Une erreur s'est produite lors du chargement des données de l'éditeur","fetch_folder_tree":"Une erreur s'est produite lors de l'actualisation de l'arborescence","fetch_notes_error":"Une erreur est survenu lors du chargement des notes","fetch_profile_data_error":"Une erreur s'est produite lors du chargement des données de profil","fetch_proposal_stats_error":"Une erreur s'est produite lors du chargement des statistiques de la proposition","fetch_publication_data":"Une erreur est survenu lors du chargement des informations de la publication","fetch_publication_templates_error":"Une erreur s'est produite lors du chargement des modèles","field_must_have_at_least":"Le champ doit avoir au moins %{charsCount} caractères.","file_import_error":"Une erreur est survenue lors de l'importation d'un fichier","file_import_error_short":"Erreur lors de l'import","get_publication_settings":"Une erreur est survenu lors du chargement des paramètres de la publication","get_publication_url":"L'URL de la publication n'a pas pu être retrouvé","get_share_users":"Une erreur est survenue lors de la récupération des données utilisateur","import_publication_pdf":"Une erreur est survenu lors de l'importation du PDF de la publication","initialization_fail":"Une erreur s'est produite durant l'initialisation, veuillez relancer l'application","invalid_auth":"Identifiant, mot de passe ou serveur invalide","invalid_company_name":"Nom d'entreprise invalide","invalid_email_address":"Email invalide","invalid_page_number":"Numéro de page invalide","invalid_url":"URL invalide","login_or_password_incorrect":"Identifiant ou mot de passe incorrect","move_page_error":"Impossible de déplacer la page","no_application_available":"Pas d'application disponible","open_fail":"Le contenu (id: %{id}) n'a pas pu s'ouvrir","parse_editor_data_error":"Une erreur s'est produite lors de l'analyse des données de l'éditeur","passwords_do_not_match":"Le mot de passe et la confirmation ne correspondent pas","processing_fail":"Échec du traitement","proposal_not_archived":"La proposition n'a pas été archivée","publish_publication":"Une erreur est survenue en publiant la publication","remove_page_error":"Impossible de supprimer la page","remove_template_error":"Impossible d'enlever le modèle","rename_asset_error":"Impossible de renomer le contenu","reset_fail":"Échec de la réinitialisation des téléchargements","save_editor_data_error":"Une erreur est survenue lors de la sauvegarde des données de l'éditeur","save_profile_data_error":"Une erreur s'est produite lors de l'enregistrement des données de profil","save_publication_settings":"Une erreur est survenu lors de la sauvegarde les paramètres de la publication","search_error":"Une erreur s'est produite lors de la recherche","session_expired":"Votre session a expiré","set_as_template_error":"Impossible de transformer en modèle","share_failed_request":"Une erreur s'est produite, votre sélection n'a pu être partagée","share_proposal_error":"Une erreur s'est produite lors de l'envoi de la proposition","share_publication_error":"Erreur lors de l'envoi de la publication","share_with_user":"Une erreur est survenue lors du partage de l'élément","the_resources_are_restricted_for_sharing":"Les ressources que vous essayez de partager sont restreintes.","unexpected_error":"Erreur inattendue","update_publication":"Une erreur est survenue lors de la mise à jour de la publication","wrong_file_type":"Mauvais type de fichier"},"fileFormat":{"COMPONENT":"Page","DOCUMENT":"Document","EPUB":"EPUB","FILE":"Fichier","IMAGE":"Image","MOVIE":"Vidéo","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Présentation","PROPOSAL":"Proposition","PUBLICATION":"Publication"},"info":{"create_note_success":"Votre note a été sauvegardé. <a href=%{url}>Voir vos notes</a>","delete_all":"Tous les contenus ont été supprimés","emails_sent":"Vos e-mail(s) en attente ont été envoyés","fill_all_input_fields":"Veuillez remplir tous les champs","import_publication_pdf":"Votre fichier PDF a été importé avec succès","offline_create_external_link":"Veuillez vous connecter à internet pour créer des liens externes","offline_create_folder":"Internet est nécessaire pour créer un dossier","offline_download_multiple_assets":"Internet est nécessaire pour télécharger les contenus","offline_download_single_asset":"Internet est nécessaire pour télécharger le contenu","offline_fetch_notes":"Veuillez vous connecter à internet pour récupérer les notes partagées","offline_login":"Internet est nécessaire pour vous connecter","offline_no_config":"Internet est nécessaire lors du premier lancement","offline_update_folder_tree":"Internet est nécessaire pour actualiser l'arborescence","remove_publication_pdf":"Votre publication PDF a été retirée avec succès","reset_all_downloads":"Tous les téléchargements ont été réinitialisés","selection_sent":"Vos sélection(s) en attente ont été partagées","selection_shared_once_online":"Votre sélection sera partagée lorsque vous aurez internet","set_as_template_success":"Votre document à été ajouté à Mes Modèles","share_with_user_success":"L'élément a été partagé avec succès","url_copied":"Votre URL a été copié"},"languages":{"ca_ES":"Catalan","da_DK":"Danois","de_DE":"Allemand","en_AU":"Anglais - AU","en_UK":"Anglais - UK","en_US":"Anglais - US","es_ES":"Espagnol","eu_ES":"Basque","fi_FI":"Finnois","fr_FR":"Français","gl_ES":"Gallegan","he_IL":"Hébreu","it_IT":"Italien","ja_JP":"Japonais","ko_KR":"Coréen","nl_NL":"Hollandais","nn_NO":"Norvégien Nynorsk","pl_PL":"Polonais","pt_PT":"Portugais","ro_RO":"Roumain","ru_RU":"Russe","sk_SK":"Slovaque","sv_SE":"Suédois","tr_TR":"Turque","zh_CN":"Chinois - Chine","zh_SI":"Chinois - Singapour","zh_TR":"Chinois - Traditionel","zh_TW":"Chinois - Traditionel"},"messages":{"CUSTOM_DOMAIN":"Domaine personnalisé","PUBLISH":"Publier","SSO_SECURITY":"Sécurité SSO","WISHLIST":"Wishlist","XLS_SECURITY":"Sécurité XLS","activate_offline_mode":"Rendre disponible hors ligne","add":"Ajouter","add_file":"Ajouter le fichier","add_pdf_to_download":"Ajouter le PDF à télécharger","add_slide":"Ajouter une slide","add_to_selection":"Ajouter à la sélection","already_member":"Déjà inscrit ?","alt_attribute":"Attribut alt","animation":"Animation","another_user":"Un autre utilisateur","application_content":"Contenu de l'application","archive_noun":"Archive","archive_verb":"Archiver","assortment":"Assortiment","auto_zoom_level":"Niveau de zoom automatique","autoplay_delay":"Délais de la lecture automatique, s","available_as_template":"Modèle activé","available_offline":"Disponible hors ligne","back":"Retour","back_to_company":"Retour à l'Entreprise","back_to_home":"Retour vers l'Accueil","back_to_login":"Retour au Login","back_to_method_view":"Changer la méthode d'authentification","bg_cover_left_tooltip":"Ce réglage ne prendra effet seulement si l'écran de l'utilisateur rogne les cotés de l'arrière plan","bg_cover_top_tooltip":"Ce réglage ne prendra effet seulement si l'écran de l'utilisateur rogne le haut/bas de l'arrière plan","bottom":"Bas","bulleted":"Avec puce","campaign_name":"Nom de la campagne","cancel":"Annuler","change_cover_image":"Changer l'image de couverture","change_password":"Changer le mot de passe","check_for_updates":"Vérifier les Mises à Jour","checking_for_updates":"<b>Recherche de mise à jours...</b>","choose_coworker":"Choisir un collègue","clear_selection":"Effacer Ma Sélection","client_id":"Client id","client_secret":"Client secret","close":"Fermer","color":"Couleur","combine":"Combiner","combine_by_selecting_pages":"Sélectionnez les pages à inclure dans votre playlist","combining":"Combiner %{percentage} %","confirm_password":"Confirmer le mot de passe","confirmation":"Confirmation","connect":"Connexion","content_structure_incomplete":"Structure de contenu incomplète","content_structure_never_completed":"Pour utiliser l'application en mode hors ligne, la structure de contenu doit d'abord être complétée. Veuillez activer votre connexion Internet et réessayer.","content_structure_ready":"La structure de contenu est maintenant disponible pour une utilisation hors ligne","continue":"Continuer","continue_downloading":"Continuer de tout télécharger","continue_downloading_important":"Continuer de télécharger les éléments importants","cookie_notification":"Afin de profiter au maximum de votre navigation sur notre site, nous utilisons des cookies. En naviguant sur notre site, vous acceptez l’utilisation de cookies. Toutefois, il est possible de modifier le configuration de votre navigateur pour mettre fin à l’acceptation automatique. Pour plus de détails <a target='_blank' href=%{url}> cliquez ici.</a>","cookie_settings":"Gestion des services","copy":"Copier","copy_links_to_share":"Copier, ouvrez votre client mail et effectuez un « coller »","copy_mode_html":"Liste de liens","copy_mode_text":"Texte brut","copy_paste_your_link":"Copier coller votre lien","coverflow":"Coverflow","create":"Créer","create_customized_proposal":"Créer une proposition personnalisée","create_deal_in_crm":"<span>Créer une transaction</span><br>dans mon CRM","create_demo_account":"Création du compte...","create_external_link":"Créer un lien externe","create_folder":"Créer un dossier","create_from_template":"Créer à partir d'un modèle","create_note":"Créer un note","create_proposal":"Créer une proposition","create_proposal_from_file":"Créer une proposition à partir d'un fichier","create_proposal_from_template":"Créer une proposition à partir d'un modèle","create_publication":"Créer une Publication","create_your_slider":"Créer votre slider","creation_date":"Date de création","crm":"CRM","custom_pdf":"PDF personalisé","customize_url":"Personaliser l'URL","customize_url_hint":"Pour personnaliser la fin de votre URL","deactivate_offline_mode":"Désactiver le mode hors ligne","default":"Défaut","default_animation":"Animation par défaut","default_file":"Fichier par défaut","default_image":"Image par défaut","default_video":"Vidéo par défaut","delete":"Supprimer","delete_assets_sequentially":"Suppression séquentielle (plus lent)","delete_data":"Supprimer tous les éléments","deleting":"Suppression...","dependencies_deleted_out_of":"Suppression %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dépendances","dependency_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dépendance","description":"Description","deselect_all":"Tout désélectionner","desktop":"Desktop","details":"Détails","display_mode":"Affichage","do_not_close_app":"<b>Veuillez ne pas fermer l'application.</b>","done":"Terminer","dont_ask_me_again":"Ne plus demander","download":"Télécharger","download_all":"Tout télécharger","download_all_important":"Télécharger les éléments importants","download_all_toast_in_progress":"Téléchargement en cours.<br><b>Veuillez ne pas minimiser l'application !</b>","download_all_toast_paused":"Le téléchargement a été mis en pause.<br>Voulez-vous le reprendre ?","download_complete":"Téléchargement terminé","download_complete_important":"Téléchargements importants terminés","download_importants_toast_in_progress":"Téléchargements des éléments importants en cours.<br><b>Veuillez ne pas minimiser l'application !</b>","download_importants_toast_paused":"Le téléchargement des éléments importants a été mis en pause.<br>Voulez-vous le reprendre ?","download_manager":"Gestionnaire de téléchargement","download_pdf":"Télécharger le PDF","download_selected_toast_in_progress":"Téléchargements des éléments sélectionnés en cours.<br><b>Veuillez ne pas minimiser l'application !</b>","download_selected_toast_paused":"Le téléchargement des éléments sélectionnés a été mis en pause.<br>Voulez-vous le reprendre ?","download_toast_link_to_downloads":"Open <a href=%{url}>Downloads</a> page to view the progress.","download_toast_status":"Téléchargement en cours %{downloadedItems} | %{totalItems}","downloaded":"Téléchargé","downloading":"Téléchargement","downloading_thumbnails_for_offline_use":"Téléchargement des miniatures pour une utilisation hors ligne","downloads":"Téléchargements","draft":"Brouillon","duplicate":"Dupliquer","duplicate_theme":"Dupliquer le thème","edit":"Modifier","edit_text":"Modifier le texte","email":"Email","email_integration":"Intégration de messagerie","enabled":"Activé","end_date":"Date de fin","enter_image_description":"Entrez la description de l'image","enter_image_source":"Entrez la source de l’image","enter_password":"Entrez le mot de passe","enter_your_text":"Tappez votre texte","error":"Erreur","extension_external_link":"Lien Externe","extension_flip":"Flip","file_size":"Taille du fichier","folder":"Dossier","folder_name":"Nom du dossier","font":"Fonte","forgot_password":"Mot de passe oublié ?","format":"Format","free_space":"Espace disponible","from_app":"À partir de l'application","from_desktop":"À partir du bureau","from_drive":"À partir du Drive","from_selection":"À partir de Ma Sélection","from_youtube":"Depuis Youtube","full_pdf":"PDF entier","full_publication":"Publication entière","gdpr_allowAll":"Tout accepter","gdpr_message":"Ce site utilise des cookies et vous donne le contrôle sur ceux que vous voulez activer.","gdpr_personalize":"Personaliser","gdpr_privacy_policy":"Politique de confidentialité","gdpr_reject_all":"Continuer sans accepter","get_url":"Copier l'URL","goto_page":"Aller à la page","goto_page_id":"Aller à l’ID de page","grid":"Grille","home":"Accueil","hours_left":"%{hours} heures restantes","iframe":"Iframe","image":"Image","image_source":"Source de l’image","import_file":"Importer un fichier","imported_all_files":"Tous les fichiers ont été importés","importing":"Importation","importing_files_status":"import %{importedFiles} | %{totalFiles}","importing_with_percentage":"Importation %{percentage} %","informations":"Informations","integrate":"Intégrer","integrate_ua_code":"Intégrer le code UA Analytics","integrate_ua_code_hint":"Si plusieurs codes UA, separez par une virgule ou un point-virgule","invalid_chapter_id":"ID de page invalide","invite_coworker":"Inviter un collègue","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} élément","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} éléments","keep_it_for_later":"Garder pour plus tard","ken_burns_effect":"Effet Ken Burns (zoom automatique)","language":"Langue","last_update_date":"Dernière mise à jour","left":"Gauche","less_than_minute_left":"Moins d'une minute restante","library":"Bibliothèque","line_height":"Hauteur de la ligne","link":"Lien","list_type":"Type de liste","loading":"Chargement...","loading_fetch_content":"Récupération du contenu du drive 1/3","loading_required_items":"Téléchargement des fichiers requis 2/3","loading_thumbnails":"Téléchargement des thumbnails 3/3","local":"Local","log_out":"Déconnexion","logging_in":"Connexion...","masonry":"Maçonnerie","menu":"Menu","minutes_left":"%{minutes} minutes restantes","modify_slide":"Modifier la slide","move":"Déplacer","my_app":"Mon App","my_documents":"Mes Documents","my_downloads":"Mes Téléchargements","my_drive":"Mon Drive","my_gallery":"Ma Galerie","my_notes":"Mes Notes","my_parameters":"Mes Paramètres","my_profile":"Mon profil","my_selection":"Ma Sélection","my_sent":"Mes envois","my_templates":"Mes Modèles","name":"Prénom","name_surname":"Prénom / nom de famille","new":"Nouveautés","new_content_available_start_download":"Nouveau contenu disponible. Commencer le téléchargement maintenant ?","next":"Suivant","no_assets":"Ce dossier est vide","no_assortment":"Cet assortiment est vide","no_data_found":"Aucune donnée disponible","no_downloads":"Vous n'avez rien téléchargé pour le moment","no_new":"Pas de nouveau contenu","no_results":"Aucun résultat pour cette recherche","no_save_as_info":"Le template que vous souhaitez dupliquer à été mis à jour, veuillez créer une nouvelle proposition à partir du nouveau template","no_selection":"Vous n'avez rien sélectionné","no_share_users":"Il n'y a pas d'utilisateurs disponibles dans l'application","no_target_selected":"Sélectionnez un asset à ouvrir","no_templates":"Aucun modèle disponible","no_updates":"Pas de contenu mis à jour","none":"Aucun","normal":"Normal","note":"Note","notification":"Notification","notification_credits_multiline":"%{credits} crédits seront prélevés de votre compte pour \"%{action}\"","numbered":"Numéroté","ok":"OK","one_hour_left":"1 heure restante","one_minute_left":"1 minute restante","open":"Ouvrir","open_in_new_tab":"Ouvrir dans un nouvel onglet","open_in_same_tab":"Ouvrir dans le même onglet","open_popup":"Ouvrir une popup","opened_date":"Date d'ouverture","options":"Options","or_sign_in":"Connectez-vous","page":"Page","page_id":"ID de page","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Page introuvable","pages_selection":"Playlist","pages_selection_tooltip":"Vous serez facturé pour publier la publication sélectionnée afin de l'utiliser dans une playlist.","parameters":"Paramètres","password":"Mot de passe","pdf_processing":"Traitement du PDF %{percentage} %","pdf_type":"Type de PDF","phone":"Smartphone","phone_number":"Numéro de téléphone","pin_code":"PIN code","placeholder_company":"Entrez le nom de votre entreprise","placeholder_email":"Email","placeholder_login":"Identifiant","placeholder_password":"Mot de passe","placeholder_phone":"Numéro de téléphone","placeholder_search_drive_item":"Rechercher","placeholder_share_contact_email":"Email du destinataire","placeholder_share_message":"Votre message","placeholder_share_name":"Votre nom","placeholder_share_user_email":"Votre email","popup":"Choisir un asset","popup_label":"Popup","position":"Position","preparing_content_structure":"Préparation de la structure de contenu...","preview":"Aperçu","private_folder":"Dossier Privé","processing":"En traitement","profile":"Profil","profile_offline_message":"La page de profil ne peut être éditée hors connexion. Réessayez après vous être connecté à internet","project_url":"URL du projet","proposal_locked":"La proposition est en train d'être éditée par %{userName}","proposal_name":"Nom de la proposition","publication_locked":"La publication est en train d'être éditée par %{userName}","publication_name":"Nom de la Publication","publish":"Publier","publish_publication":"Publier ma publication","published":"Publiée","publishing":"Publication en cours","read":"Lire","remember_me":"Se souvenir de moi","remove":"Supprimer","remove_email_integration":"Êtes-vous sûr de vouloir retirer l'integration de messagerie ?","remove_from_selection":"Retirer de la sélection","remove_template":"Supprimer ce modèle","remove_theme":"Supprimer le thème","remove_theme_question":"Voulez-vous retirer le thème actuel ?","removing":"Suppression","rename":"Renommer","rename_theme":"Renommer le thème","replace":"Remplace","replace_file":"Remplacer le fichier","reset_all_downloads":"Réinitialiser tous les téléchargements","reset_my_preferences":"Reinitialiser mes préférences","reset_to_default":"Réinitialiser aux valeurs par défaut","resolution":"Résolution","resource_name":"Nom","restart":"Relancer","restart_all":"Tout relancer","resuming":"Reprendre","retry":"Réessayer","right":"Droite","row":"Rangée","salesforce":"Salesforce","salesforce_activation":"Activation de Salesforce","save":"Enregistrer","save_as":"Enregistrer sous","save_in_documents":"Enregistrer dans Mes Documents","saving":"Saving...","scale":"Echelle","search":"Recherche","search_phrase":"Mots recherchés","search_results":"Résultats de la recherche","see_preview":"Voir la preview","seen":"Vu","select_all":"Tout sélectionner","select_application":"Choisissez une application","select_playlist_item":"Sélectionnez un élément à ajouter à votre playlist","select_publication_item":"Sélectionnez un élément à ajouter à votre publication","select_server":"Sélectionnez un serveur","select_this_application":"Choisir cette application","select_this_server":"Choisir ce serveur","select_your_tags":"Selectionnez vos tags","select_your_template":"Sélectionnez votre modèle","selection":"Sélection","send":"Envoyer","send_by_email":"Envoyer par email","send_my_proposal":"Envoyer ma proposition","send_my_publication":"Envoyer ma Publication","send_my_selection":"Envoyer ma sélection","sent":"Envoyé","sent_date":"Date envoyée","session_expired":"Votre session a expiré","set_as_template":"Définir comme Modèle","settings":"Paramètres","share":"Partager","share_by_email":"Partager par email","share_my_selection":"Partager Ma Sélection","share_via_copy":"Copier les liens","share_via_uprez":"Partager par formulaire","shared":"Partagé","shared_with_me":"Partagé avec moi","sign_in_options":"Options de connexion","sign_up_for_free_trial":"Créer un compte de démonstration gratuit","size":"Taille","slider":"Slider","sources":"Sources","spacing":"Espacement","start_to_download":"Commencer le téléchargement","status_read":"Lus","templates":"Modèles","test_our_demo":"Tester notre démo","text":"Texte","text_style":"Style de texte","theme":"Thème","theme_name":"Nom du thème","themes":"Thèmes","title":"Titre","title_and_preview":"Titre/aperçu","top":"Haut","try_demo":"Essayer notre démo","tutorial_uprez":"Tutoriel Uprez","type":"Type","unlock":"Déverouiller","unread":"Non lus","untitled_note":"Note sans titre","update":"Mettre à jour","update_all":"Tout mettre à jour","update_all_important":"Mettre à jour les éléments importants","update_folder_tree":"Actualiser l'arborescence","update_pdf_thumb":"Mettre à jour les miniatures du PDF","update_pdf_thumb_accept":"Je veux générer les miniatures de toutes les pages","update_pdf_thumb_message":"Votre PDF va être remplacé par celui-là","update_published":"Mettre à jour","updating":"Mise à jour en cours","updating_asset":"Mise à jour...","updating_content_structure":"Mise à jour de la structure de contenu...","url":"Url","used_space":"Espace utilisé","version":"Version","video":"Vidéo","video_processing":"Traitement vidéo","view":"Affichage","view_published":"Voir la version publiée","webpublication":"Webpublication","webpublication_method":"Authentification par Webpublication","your_company_account":"Votre compte entreprise","your_file":"Votre dossier","your_themes":"Vos thèmes","your_ua_code":"Votre code UA analytics","your_url":"Votre URL","youtube_link":"Lien Youtube"},"page_title":{"assortment":"Assortiment %{galleryName}","authentication":"Authentification","details":"Détails %{itemName} - %{galleryName}","downloads":"Téléchargements %{galleryName}","drive":"Drive %{galleryName}","editor":"Editeur","folder":"Dossier %{itemName} - %{galleryName}","gallery":"Galerie","gallery_name":"%{galleryName}","my_documents":"Mes documents - %{galleryName}","my_notes":"Mes Notes","my_sent":"Mes envois","new":"Nouveautés %{galleryName}","parameters":"Paramètres %{galleryName}","profile":"Profil","search":"Recherche %{galleryName}","selection":"Sélection %{galleryName}","shared_with_me":"Partagé avec moi","theater":"Théâtre %{itemName} - %{galleryName}"},"share":{"company":"Entreprise","contact":"Informations du destinataire","contactEmail":"Email du destinataire","documents":"Documents","email_body":"Veuillez trouver ci-dessous les documents que vous souhaitiez recevoir, suite à notre rendez-vous.","email_greeting":"Bonjour,","email_salutation":"Cordialement,","firstname":"Prénom","notes":"Notes","phone":"Téléphone","position":"Position","subject":"Sujet","surname":"Nom"},"type":{"asp-type-0":"Dossier","asp-type-1":"Composant","asp-type-10":"Application","asp-type-11":"Galerie","asp-type-12":"Lien externe","asp-type-2":"Fichier","asp-type-3":"Template","asp-type-4":"Image","asp-type-5":"Vidéo","asp-type-6":"Publication","asp-type-7":"Audio","asp-type-8":"Publication","asp-type-9":"Lien"}}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/YYYY","long":"DD MMM. YYYY"},"error":{"another_user_login":"Sie wurden abgemeldet, weil Sie sich von einem anderen Gerät aus angemeldet haben","asset_not_erasable":"Ein oder mehrere Vermögenswerte waren nicht löschbar","authentication_needed":"Ein Fehler ist aufgetreten, Sie müssen sich erneut anmelden","bundle_content_expired":"%{number} Inhalte sind abgelaufen","bundle_delete_fail":"%{number} Inhalte konnten nicht gelöscht werden","bundle_download_fail":"%{number} Inhalte konnten nicht heruntergeladen werden","bundle_fetch_content_error":"%{number} Inhalte konnten nicht abgerufen werden","bundle_initialization_fail":"Bundle initialization fail","bundle_open_fail":"%{number} Inhalte konnten nicht geöffnet werden","cant_archive_proposal":"Can't archive proposal","cant_change_cover_image":"Can't change cover image","cant_create_external_link":"Kann keinen externen Link erstellen","cant_create_folder":"Diesen Ordner können Sie nicht erstellen","cant_create_note":"Can't create a note","cant_get_resource":"Can't get resource data","cant_move_asset":"Kann eine Anlage nicht verschieben","cant_remove_asset":"Kann ein Asset nicht entfernen","cant_remove_note":"Can't remove a note","cant_update_note":"Can't update a note","combine_error":"Beim Kombinieren ist ein Fehler aufgetreten","content_expired":"Inhalt (id: %{id}) ist abgelaufen","create_proposal_error":"Kann keinen Vorschlag erstellen","create_publication_error":"Can't create publication","custom_url_used":"Entered url already exists","delete_fail":"Inhalt (id: %{id}) konnte nicht gelöscht","download_fail":"Der Inhalt (ID: %{id}) konnte nicht heruntergeladen werden. Bitte versuchen Sie, ihn erneut herunterzuladen, ohne die App zu minimieren oder zu einer anderen zu wechseln.","duplicate_email":"Login verwendet","duplicate_file_name":"Datei existiert bereits","duplicate_page_error":"Seite kann nicht dupliziert werden","duplicate_theme":"Theme name used","fetch_content_block_error":"Inhalt (Elternteil: %{id}) konnte nicht abgerufen werden","fetch_content_error":"Inhalt (id: %{id}) konnte nicht abgerufen werden","fetch_editor_data_error":"Beim Laden von Editor-Daten ist ein Fehler aufgetreten","fetch_folder_tree":"An error occured while updating folder tree","fetch_notes_error":"An error occured while loading notes","fetch_profile_data_error":"Beim Laden von Profildaten ist ein Fehler aufgetreten","fetch_proposal_stats_error":"Beim Laden der Vorschlagsstatistik ist ein Fehler aufgetreten","fetch_publication_data":"An error occured while loading publication data","fetch_publication_templates_error":"An error occured while loading templates","field_must_have_at_least":"Das Feld muss mindestens %(Zeichenanzahl)-Zeichen enthalten","file_import_error":"Beim Importieren einer Datei ist ein Fehler aufgetreten","file_import_error_short":"Import error","get_publication_settings":"An error occured while loading publication settings","get_publication_url":"An error occured while getting publication URL","get_share_users":"An error occured while getting users data","import_publication_pdf":"An error occured while importing publication pdf","initialization_fail":"Bei der Initialisierung ist ein Fehler aufgetreten, bitte starten Sie die Anwendung neu","invalid_auth":"Ungültige Anmeldung, ungültiges Passwort oder ungültiger Server","invalid_company_name":"Ungültiger Firmenname","invalid_email_address":"Ungültige E-Mail-Adresse","invalid_page_number":"Ungültige Seitenzahl","invalid_url":"Ungültige url","login_or_password_incorrect":"Falsche Anmeldung oder falsches Passwort","move_page_error":"Seite kann nicht verschoben werden","no_application_available":"Keine Anwendung verfügbar","open_fail":"Inhalt konnte nicht geöffnet werden","parse_editor_data_error":"Beim Parsen von Editor-Daten ist ein Fehler aufgetreten","passwords_do_not_match":"Passwort und Bestätigung stimmen nicht überein","processing_fail":"Verarbeitung fehlgeschlagen","proposal_not_archived":"Proposal wasn't archived","publish_publication":"An error occured while publishing publication","remove_page_error":"Seite kann nicht entfernt werden","remove_template_error":"Vorlage kann nicht entfernt werden","rename_asset_error":"Asset kann nicht umbenannt werden","reset_fail":"Downloads konnten nicht zurückgesetzt werden","save_editor_data_error":"Beim Speichern von Editor-Daten ist ein Fehler aufgetreten","save_profile_data_error":"Beim Speichern von Profildaten ist ein Fehler aufgetreten","save_publication_settings":"An error occured while saving publication settings","search_error":"An error occurred while searching","session_expired":"Your session expired","set_as_template_error":"Kann nicht als Vorlage festgelegt werden","share_failed_request":"An error occured, your selection couldn't be shared","share_proposal_error":"Beim Senden des Vorschlags ist ein Fehler aufgetreten","share_publication_error":"An error occured while sending publication","share_with_user":"An error occured while sharing the asset","the_resources_are_restricted_for_sharing":"Die Ressourcen, die Sie teilen möchten, sind eingeschränkt.","unexpected_error":"Unerwarteter Fehler","update_publication":"An error occured while updating publication","wrong_file_type":"Falscher Dateityp"},"fileFormat":{"COMPONENT":"Seite","DOCUMENT":"Dokument","EPUB":"EPUB","FILE":"Datei","IMAGE":"Bild","MOVIE":"Film","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Präsentation","PROPOSAL":"Vorschlag","PUBLICATION":"Veröffentlichung"},"info":{"create_note_success":"Your note was saved. <a href=%{url}>View your notes</a>","delete_all":"Alle Inhalte wurden gelöscht","emails_sent":"Your pending email(s) have been sent","fill_all_input_fields":"Bitte füllen Sie alle Felder aus.","import_publication_pdf":"Your PDF file was successfully imported","offline_create_external_link":"Bitte verbinden Sie sich mit dem Internet, um einen externen Link zu erstellen","offline_create_folder":"Bitte verbinden Sie sich mit dem Internet, um einen Ordner zu erstellen","offline_download_multiple_assets":"Bitte verbinden Sie sich mit dem Internet, um den Inhalt herunterzuladen","offline_download_single_asset":"Bitte verbinden Sie sich mit dem Internet, um den Inhalt herunterzuladen","offline_fetch_notes":"Please connect to the Internet to fetch shared notes","offline_login":"Bitte verbinden Sie sich zum Einloggen mit dem Internet","offline_no_config":"Für den ersten Start benötigen Sie eine Internetverbindung","offline_update_folder_tree":"You need an Internet connection to update folder tree","remove_publication_pdf":"Your PDF publication was successfully removed","reset_all_downloads":"Alle Downloads wurden zurückgesetzt","selection_sent":"Ihre ausstehende Auswahl wurde freigegeben","selection_shared_once_online":"Ihre Auswahl wird freigegeben, sobald Sie online sind.","set_as_template_success":"Ressource ist erfolgreich als Vorlage gesetzt","share_with_user_success":"The asset was successfully shared","url_copied":"Your URL was copied"},"languages":{"ca_ES":"Katalanisch","da_DK":"Dänisch","de_DE":"Deutsch","en_AU":"Englisch","en_UK":"Englisch","en_US":"Englisch","es_ES":"Spanisch","eu_ES":"Baskisch","fi_FI":"Finnisch","fr_FR":"Französisch","gl_ES":"Gallegan","he_IL":"Hebräisch","it_IT":"Italienisch","ja_JP":"Japonês","ko_KR":"Koreanisch","nl_NL":"Dutsh","nn_NO":"Norwegisch Nynorsk","pl_PL":"Polnisch","pt_PT":"Portugiesisch","ro_RO":"Rumänisch","ru_RU":"Russisch","sk_SK":"Slowakisch","sv_SE":"Schwedisch","tr_TR":"Türkisch","zh_CN":"Chinesisch - China","zh_SI":"Chinesisch - Singapur","zh_TR":"Chinesisch - Traditionell","zh_TW":"Chinesisch - Traditionell"},"messages":{"CUSTOM_DOMAIN":"Custom domain","PUBLISH":"Publish","SSO_SECURITY":"SSO Security","WISHLIST":"Wishlist","XLS_SECURITY":"XLS Security","activate_offline_mode":"Offline-Modus aktivieren","add":"Add","add_file":"Datei hinzufügen","add_pdf_to_download":"Add PDF to download","add_slide":"Add a slide","add_to_selection":"Zur Auswahl hinzufügen","already_member":"Sie sind bereits Mitglied?","alt_attribute":"Alt attribute","animation":"Animation","another_user":"Another user","application_content":"Inhalt der Anwendung","archive_noun":"Archiv","archive_verb":"Archivieren","assortment":"Sortiment","auto_zoom_level":"Auto zoom level","autoplay_delay":"Autoplay delay, s","available_as_template":"Als Vorlage verfügbar","available_offline":"Offline verfügbar","back":"Zurück","back_to_company":"Zurück zu Unternehmen","back_to_home":"Zurück zu Home","back_to_login":"Zurück zum Login","back_to_method_view":"Authentifizierungsverfahren ändern","bg_cover_left_tooltip":"This control will only take effect if the user's screen is cropping the background on the sides","bg_cover_top_tooltip":"This control will only take effect if the user's screen is cropping the background at the top/bottom","bottom":"Bottom","bulleted":"Bulleted","campaign_name":"Campaign name","cancel":"Abbrechen","change_cover_image":"Change cover image","change_password":"Passwort ändern","check_for_updates":"Check for Updates","checking_for_updates":"<b>Überprüfe auf Updates...</b>","choose_coworker":"Choose a co-worker","clear_selection":"Löschen Sie Ihre Auswahl","client_id":"Kunden-ID","client_secret":"Kundengeheimnis","close":"schließen","color":"Farbe","combine":"Kombinieren Sie","combine_by_selecting_pages":"Wähle die Seiten aus, die du in deine Wiedergabeliste aufnehmen möchtest","combining":"Zusammengefasst %{Prozentsatz} %","confirm_password":"Passwort bestätigen","confirmation":"Bestätigung","connect":"Verbinden Sie","content_structure_incomplete":"Inhaltsstruktur unvollständig","content_structure_never_completed":"Um die App im Offline-Modus zu verwenden, muss die Inhaltsstruktur zuerst vollständig sein. Bitte aktivieren Sie Ihre Internetverbindung und versuchen Sie es erneut.","content_structure_ready":"Die Inhaltsstruktur ist jetzt für die Offline-Nutzung verfügbar","continue":"Continue","continue_downloading":"Download fortsetzen","continue_downloading_important":"Continue Important Downloads","cookie_notification":"Diese Website verwendet Cookies, um Ihnen die bestmögliche Nutzung unserer Dienste zu gewährleisten. Wenn Sie diese Website besuchen, akzeptieren Sie die Verwendung dieser Cookies. Sie können jedoch die Einstellungen Ihres Browsers ändern, um die automatische Validierung abzubrechen.","cookie_settings":"Datenschutz-Einstellungen","copy":"Kopieren","copy_links_to_share":"Kopieren Sie, öffnen Sie Ihren Mail-Client und fügen Sie ihn ein","copy_mode_html":"Liste der Links","copy_mode_text":"Nur Text","copy_paste_your_link":"Kopieren und Einfügen Ihres Links","coverflow":"Coverflow","create":"Erstellen Sie","create_customized_proposal":"Create customized proposal","create_deal_in_crm":"<span>Geschäft anlegen</span><br>in meinem CRM","create_demo_account":"Ein Konto erstellen...","create_external_link":"Erstellen Sie einen externen Link","create_folder":"Einen Ordner erstellen","create_from_template":"Create from a Template","create_note":"Create a note","create_proposal":"Einen Vorschlag erstellen","create_proposal_from_file":"Einen Vorschlag aus einer Datei erstellen","create_proposal_from_template":"Einen Vorschlag aus Vorlage erstellen","create_publication":"Create a Publication","create_your_slider":"Create your slider","creation_date":"Erstellungsdatum","crm":"CRM","custom_pdf":"Custom PDF","customize_url":"Customize the URL","customize_url_hint":"This will customize the end of our domain name with your text","deactivate_offline_mode":"Offline-Modus deaktivieren","default":"Standardmäßig","default_animation":"Default animation","default_file":"Default file","default_image":"Standard-Bild","default_video":"Standard-Video","delete":"Löschen","delete_assets_sequentially":"Assets nacheinander löschen (langsamer)","delete_data":"Daten löschen","deleting":"Deleting...","dependencies_deleted_out_of":"Deleting %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{AbhängigkeitenDownloaded} / %{dependenciesToDownload}-Abhängigkeiten","dependency_downloaded_out_of":"%{AbhängigkeitenDownloaded} / %{AbhängigkeitenToDownload} Abhängigkeit","description":"Beschreibung","deselect_all":"Deselect all","desktop":"Desktop","details":"Einzelheiten","display_mode":"Anzeige","do_not_close_app":"<b>Bitte schließen Sie die App nicht.</b>","done":"Geschehen","dont_ask_me_again":"Fragen Sie mich nicht noch einmal.","download":"Laden Sie  herunter.","download_all":"Alle herunterladen","download_all_important":"Download All Importants Assets","download_all_toast_in_progress":"Downloading in progress.<br><b>Do not minimize the application!</b>","download_all_toast_paused":"Downloading all assets was paused.<br>Would you like to continue?","download_complete":"Download alle","download_complete_important":"Important Downloads Complete","download_importants_toast_in_progress":"Downloading important assets in progress.<br><b>Do not minimize the application!</b>","download_importants_toast_paused":"Download of important assets was paused.<br>Would you like to continue?","download_manager":"Download-Manager","download_pdf":"PDF Herunterladen","download_selected_toast_in_progress":"Herunterladen ausgewählter Assets läuft.<br><b>Minimieren Sie die Anwendung nicht!</b>","download_selected_toast_paused":"Der Download der ausgewählten Assets wurde pausiert.<br>Möchten Sie fortfahren?","download_toast_link_to_downloads":"Open <a href=%{url}>Downloads</a> page to view the progress.","download_toast_status":"Downloading %{downloadedItems} | %{totalItems}","downloaded":"Heruntergeladen","downloading":"Downloading","downloading_thumbnails_for_offline_use":"Miniaturansichten werden für die Offline-Nutzung heruntergeladen","downloads":"Herunterladen","draft":"Entwurf","duplicate":"Duplicate","duplicate_theme":"Duplicate theme","edit":"bearbeiten","edit_text":"Edit text","email":"Email","email_integration":"E-Mail-Einbindung","enabled":"Aktiviert","end_date":"Enddatum","enter_image_description":"Enter image description","enter_image_source":"Enter image source","enter_password":"Passwort eingeben","enter_your_text":"Enter your text","error":"Fehler","extension_external_link":"Externer Link","extension_flip":"Flip","file_size":"Dateigröße","folder":"Ordner","folder_name":"Name des Ordners","font":"Schriftart","forgot_password":"Haben Sie Ihr Passwort vergessen?","format":"Format","free_space":"Freier Raum","from_app":"Von App","from_desktop":"Vom Schreibtisch aus","from_drive":"From Drive","from_selection":"From My Selection","from_youtube":"From Youtube","full_pdf":"Full PDF","full_publication":"Full publication","gdpr_allowAll":"Accept all","gdpr_message":"This site uses cookies and gives you control over what you want to activate","gdpr_personalize":"Personalize","gdpr_privacy_policy":"Privacy policy","gdpr_reject_all":"Continue without accepting","get_url":"Get URL","goto_page":"Gehe zu Seite","goto_page_id":"Gehe zu Seiten-ID","grid":"Raster","home":"Startseite","hours_left":"%{hours} Stunden links","iframe":"Iframe","image":"Bild","image_source":"Image source","import_file":"Importieren einer Datei","imported_all_files":"Alle Dateien importiert","importing":"Importieren","importing_files_status":"Importieren von %{importedFiles} | %{totalFiles}","importing_with_percentage":"Importing %{percentage} %","informations":"Informationen","integrate":"einbinden","integrate_ua_code":"Integrate UA Analytics code","integrate_ua_code_hint":"Multiple UA codes must be separated by comma or semicolon","invalid_chapter_id":"Ungültige Seiten-ID","invite_coworker":"Invite a co-worker","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} item","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} items","keep_it_for_later":"Bewahren Sie es für später auf","ken_burns_effect":"Ken Burns effect (auto zoom)","language":"Sprache","last_update_date":"Datum der letzten Aktualisierung","left":"Left","less_than_minute_left":"Weniger als eine Minute übrig","library":"Bibliothek","line_height":"Zeilenhöhe","link":"Link","list_type":"List type","loading":"Laden...","loading_fetch_content":"Abrufen von Laufwerksinhalt 1/3","loading_required_items":"Herunterladen der erforderlichen Elemente 2/3","loading_thumbnails":"Herunterladen von Miniaturbildern 3/3","local":"Local","log_out":"Abmelden","logging_in":"Angemeldet...","masonry":"Mauerwerk","menu":"Menü","minutes_left":"%{minutes} verbleibende Minuten","modify_slide":"Modify slide","move":"verschieben","my_app":"meine App","my_documents":"Meine Dokumente","my_downloads":"Meine Downloads","my_drive":"My Drive","my_gallery":"Meine Galerie","my_notes":"My notes","my_parameters":"Meine Einstellungen","my_profile":"Mein Profil","my_selection":"Meine Auswahl","my_sent":"Meine gesendeten","my_templates":"Meine Vorlagen","name":"Nachname","name_surname":"Vorname, Nachname","new":"Neu","new_content_available_start_download":"Neue Inhalte verfügbar. Starten Sie den Download jetzt?","next":"Nächste","no_assets":"Dieser Ordner ist leer.","no_assortment":"Das Sortiment ist leer","no_data_found":"Keine Daten gefunden","no_downloads":"Sie haben noch nichts heruntergeladen","no_new":"Kein neuer Inhalt","no_results":"Keine Ergebnisse für diese Suche","no_save_as_info":"Die Vorlage, die Sie dupliziert haben möchten, wurde aktualisiert. Bitte erstellen Sie einen neuen Vorschlag von der neuen Vorlage","no_selection":"Sie haben nichts ausgewählt","no_share_users":"There are no available users in the application","no_target_selected":"Select asset to open","no_templates":"Keine Vorlagen verfügbar","no_updates":"Kein aktualisierter Inhalt","none":"Keine","normal":"Normal","note":"Note","notification":"Benachrichtigung","notification_credits_multiline":"%{credits} Credits werden für \"%{action}\" von Ihrem Konto abgebucht","numbered":"Numbered","ok":"OK","one_hour_left":"noch 1 Stunde","one_minute_left":"noch 1 Minute","open":"Öffnen Sie","open_in_new_tab":"Open in New tab","open_in_same_tab":"Open in Same tab","open_popup":"Open Pop-Up","opened_date":"Eröffnungsdatum","options":"Options","or_sign_in":"Anmelden","page":"Seite","page_id":"Seiten-ID","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Seite nicht gefunden","pages_selection":"Wiedergabeliste","pages_selection_tooltip":"Sie werden für die Veröffentlichung der ausgewählten Publikation zur Verwendung in einer Playlist berechnet.","parameters":"Parameter","password":"Kennwort","pdf_processing":"PDF processing %{percentage} %","pdf_type":"PDF type","phone":"Phone","phone_number":"Telefonnummer","pin_code":"PIN-Code","placeholder_company":"Geben Sie Ihren Firmennamen ein","placeholder_email":"E-Mail","placeholder_login":"Anmeldung","placeholder_password":"Kennwort","placeholder_phone":"Telefonnummer","placeholder_search_drive_item":"Suche","placeholder_share_contact_email":"E-Mail des Empfängers","placeholder_share_message":"Ihre Nachricht","placeholder_share_name":"Ihr Name","placeholder_share_user_email":"Ihre E-Mail","popup":"Choose asset","popup_label":"Popup","position":"Standpunkt","preparing_content_structure":"Inhaltsstruktur wird vorbereitet...","preview":"Preview","private_folder":"Privater Ordner","processing":"Verarbeitung","profile":"Profil","profile_offline_message":"Die Profilseite kann im Offline-Modus nicht bearbeitet werden. Versuchen Sie es erneut, wenn Sie sich mit dem Internet verbinden","project_url":"Project URL","proposal_locked":"Proposal is being edited by %{userName}","proposal_name":"Name des Vorschlags","publication_locked":"Publication is being edited by %{userName}","publication_name":"Publication name","publish":"Publish","publish_publication":"Veröffentliche meine Publikation","published":"Published","publishing":"Publishing","read":"Lesen Sie","remember_me":"Erinnern Sie sich an mich","remove":"Remove","remove_email_integration":"Sind Sie sicher, dass Sie die E-Mail-Integration entfernen möchten?","remove_from_selection":"Aus der Auswahl entfernen","remove_template":"Diese Vorlage entfernen","remove_theme":"Remove theme","remove_theme_question":"Do you want to remove current theme?","removing":"Removing","rename":"umbenennen","rename_theme":"Rename theme","replace":"Ersetze","replace_file":"Ersetzen Sie die Datei","reset_all_downloads":"Alle Downloads zurücksetzen","reset_my_preferences":"Einstellungen zurücksetzen","reset_to_default":"Auf Standard zurücksetzen","resolution":"Entschließung","resource_name":"Name","restart":"Neustart","restart_all":"Alle neu starten","resuming":"Resuming","retry":"Erneut versuchen","right":"Right","row":"Reihe","salesforce":"Salesforce","salesforce_activation":"Salesforce-Aktivierung","save":"Speichern","save_as":"Speichern unter","save_in_documents":"In Dokumenten speichern","saving":"Saving...","scale":"Scale","search":"Suche","search_phrase":"Suchbegriff","search_results":"Suchergebnisse","see_preview":"See preview","seen":"Gesehen","select_all":"Select all","select_application":"Wählen Sie Ihre Anwendung","select_playlist_item":"Wählen Sie ein Element aus, um es Ihrer Playlist hinzuzufügen","select_publication_item":"Wählen Sie ein Element aus, um es Ihrer Veröffentlichung hinzuzufügen","select_server":"Wählen Sie einen Server","select_this_application":"Wählen Sie diese Anwendung","select_this_server":"Wählen Sie diesen Server","select_your_tags":"Select your tags","select_your_template":"Wählen Sie Ihre Vorlage","selection":"Auswahl","send":"Senden Sie","send_by_email":"Send by Email","send_my_proposal":"Meinen Vorschlag senden","send_my_publication":"Send my Publication","send_my_selection":"Meine Auswahl senden","sent":"Gesendet","sent_date":"Gesendetes Datum","session_expired":"Your session expired","set_as_template":"Als Vorlage festlegen","settings":"Settings","share":"teilen","share_by_email":"Austausch per E-Mail","share_my_selection":"Meine Auswahl mitteilen","share_via_copy":"Links kopieren","share_via_uprez":"Über Uprez teilen","shared":"Shared","shared_with_me":"Mit mir geteilt","sign_in_options":"Anmelden Optionen","sign_up_for_free_trial":"Melden Sie sich für einen kostenlosen Test an","size":"Größe","slider":"Slider","sources":"Sources","spacing":"Abstände","start_to_download":"Start zum Herunterladen","status_read":"Lesen Sie","templates":"Vorlagen","test_our_demo":"Testen Sie unsere Demo","text":"Text","text_style":"Text style","theme":"Theme","theme_name":"Theme name","themes":"Themes","title":"Title","title_and_preview":"Title/preview","top":"Top","try_demo":"Probieren Sie unsere Demo","tutorial_uprez":"Tutorial Uprez","type":"Geben Sie  ein.","unlock":"Unlock","unread":"Ungelesen","untitled_note":"Untitled note","update":"Aktualisierung","update_all":"Update All","update_all_important":"Update All Important Assets","update_folder_tree":"Update Folder Tree","update_pdf_thumb":"Update PDF thumbnails","update_pdf_thumb_accept":"I want to generate all the thumbnails","update_pdf_thumb_message":"Your PDF will be replaced with this one","update_published":"Aktualisierung","updating":"Updating","updating_asset":"Aktualisiere...","updating_content_structure":"Inhaltsstruktur wird aktualisiert...","url":"Url","used_space":"Genutzter Raum","version":"Fassung","video":"Video","video_processing":"Video-Verarbeitung","view":"Siehe","view_published":"View published","webpublication":"Webpublication","webpublication_method":"Authentifizierung von Webpublication","your_company_account":"Ihr Firmenkonto","your_file":"Ihr Dossier","your_themes":"Your themes","your_ua_code":"Your UA analytics code","your_url":"Your url","youtube_link":"Youtube link"},"page_title":{"assortment":"Sortiment %{galleryName}","authentication":"Beglaubigung","details":"Einzelheiten %{itemName} - %{galleryName}","downloads":"Herunterladen %{galleryName}","drive":"Laufwerk %{galleryName}","editor":"Herausgeber","folder":"Ordner %{itemName} - %{galleryName}","gallery":"Galerie","gallery_name":"%{galleryName}","my_documents":"Meine Dokumente - %{galleryName","my_notes":"My notes","my_sent":"Meine gesendeten","new":"Neu %{galleryName}","parameters":"Einstellungen %{galleryName}","profile":"Profil","search":"Suche %{galleryName}","selection":"Auswahl %{galleryName}","shared_with_me":"Mit mir geteilt","theater":"Theater %{itemName} - %{galleryName}"},"share":{"company":"Unternehmen","contact":"Informationen für Empfänger","contactEmail":"E-Mail-Empfänger","documents":"Dokumente","email_body":"Nachstehend finden Sie die Dokumente, die Sie bei unserem Termin erhalten möchten.","email_greeting":"Hallo,","email_salutation":"Mit freundlichen Grüßen","firstname":"Vorname","notes":"Notes","phone":"Telefon","position":"Standpunkt","subject":"Thema","surname":"Nachname"},"type":{"asp-type-0":"Verzeichnis","asp-type-1":"Komponente","asp-type-10":"App","asp-type-11":"Galerie","asp-type-12":"Externer Link","asp-type-2":"Datei","asp-type-3":"Vorlage","asp-type-4":"Bild","asp-type-5":"Film","asp-type-6":"Veröffentlichung","asp-type-7":"Ton","asp-type-8":"Veröffentlichung","asp-type-9":"Link"}}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/YYYY","long":"DD MMM. YYYY"},"error":{"another_user_login":"You have been logged out because you logged in from another device","asset_not_erasable":"One or more assets were not erasable","authentication_needed":"An error occured, you need to log in again","bundle_content_expired":"%{number} contents are expired","bundle_delete_fail":"%{number} contents could not be deleted","bundle_download_fail":"%{number} contents could not be downloaded","bundle_fetch_content_error":"%{number} contents could not be retrieved","bundle_initialization_fail":"Bundle initialization fail","bundle_open_fail":"%{number} contents could not be opened","cant_archive_proposal":"Can't archive proposal","cant_change_cover_image":"Can't change cover image","cant_create_external_link":"Can't create external link","cant_create_folder":"Can't create this folder","cant_create_note":"Can't create a note","cant_get_resource":"Can't get resource data","cant_move_asset":"Can't move an asset","cant_remove_asset":"Can't remove an asset","cant_remove_note":"Can't remove a note","cant_update_note":"Can't update a note","combine_error":"An error occured while combining","content_expired":"Content (id: %{id}) is expired","create_proposal_error":"Can't create proposal","create_publication_error":"Can't create publication","custom_url_used":"Entered url already exists","delete_fail":"Content (id: %{id}) could not be deleted","download_fail":"O conteúdo (ID: %{id}) não pôde ser baixado. Por favor, tente baixá-lo novamente sem minimizar o aplicativo ou mudar para outro.","duplicate_email":"Login used","duplicate_file_name":"File already exists","duplicate_page_error":"Can't duplicate page","duplicate_theme":"Theme name used","fetch_content_block_error":"Contents (parent: %{id}) could not be retrieved","fetch_content_error":"Content (id: %{id}) could not be retrieved","fetch_editor_data_error":"An error occured while loading editor data","fetch_folder_tree":"An error occured while updating folder tree","fetch_notes_error":"An error occured while loading notes","fetch_profile_data_error":"An error occured while loading profile data","fetch_proposal_stats_error":"An error occured while loading proposal stats","fetch_publication_data":"An error occured while loading publication data","fetch_publication_templates_error":"An error occured while loading templates","field_must_have_at_least":"Field must have at least %{charsCount} chars","file_import_error":"An error occured while importing a file","file_import_error_short":"Import error","get_publication_settings":"An error occured while loading publication settings","get_publication_url":"An error occured while getting publication URL","get_share_users":"An error occured while getting users data","import_publication_pdf":"An error occured while importing publication pdf","initialization_fail":"An error occured during initialization, please relaunch the application","invalid_auth":"Invalid login, password or server","invalid_company_name":"Invalid company name","invalid_email_address":"Invalid email address","invalid_page_number":"Invalid page number","invalid_url":"Invalid url","login_or_password_incorrect":"Incorrect login or password","move_page_error":"Can't move page","no_application_available":"No application available","open_fail":"Content could not be opened","parse_editor_data_error":"An error occured while parsing editor data","passwords_do_not_match":"Password and confirmed don't match","processing_fail":"Processing fail","proposal_not_archived":"Proposal wasn't archived","publish_publication":"An error occured while publishing publication","remove_page_error":"Can't remove page","remove_template_error":"Can't remove template","rename_asset_error":"Can't rename asset","reset_fail":"Falha ao repor as transferências","save_editor_data_error":"An error occured while saving editor data","save_profile_data_error":"An error occured while saving profile data","save_publication_settings":"An error occured while saving publication settings","search_error":"An error occurred while searching","session_expired":"Your session expired","set_as_template_error":"Can't set as template","share_failed_request":"An error occured, your selection couldn't be shared","share_proposal_error":"An error occured while sending proposal","share_publication_error":"An error occured while sending publication","share_with_user":"An error occured while sharing the asset","the_resources_are_restricted_for_sharing":"Os recursos que você está tentando compartilhar são restritos.","unexpected_error":"Unexpected error","update_publication":"An error occured while updating publication","wrong_file_type":"Wrong file type"},"fileFormat":{"COMPONENT":"Page","DOCUMENT":"Document","EPUB":"EPUB","FILE":"File","IMAGE":"Image","MOVIE":"Movie","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Presentation","PROPOSAL":"Proposal","PUBLICATION":"Publication"},"info":{"create_note_success":"Your note was saved. <a href=%{url}>View your notes</a>","delete_all":"All content has been deleted","emails_sent":"Your pending email(s) have been sent","fill_all_input_fields":"Please fill all the fields","import_publication_pdf":"Your PDF file was successfully imported","offline_create_external_link":"Please connect to the Internet to create an external link","offline_create_folder":"Please connect to the Internet to create a folder","offline_download_multiple_assets":"Please connect to the Internet to download the contents","offline_download_single_asset":"Please connect to the Internet to download the content","offline_fetch_notes":"Please connect to the Internet to fetch shared notes","offline_login":"Please connect to the Internet to log in","offline_no_config":"You need an Internet connection for the first launch","offline_update_folder_tree":"You need an Internet connection to update folder tree","remove_publication_pdf":"Your PDF publication was successfully removed","reset_all_downloads":"Todas as transferências foram repostas","selection_sent":"Your pending selection has been shared","selection_shared_once_online":"Your selection will be shared once you are online","set_as_template_success":"Resource is successfully set as template","share_with_user_success":"The asset was successfully shared","url_copied":"Your URL was copied"},"languages":{"ca_ES":"Catalan","da_DK":"Danish","de_DE":"German","en_AU":"English - AU","en_UK":"English - UK","en_US":"English - US","es_ES":"Spanish","eu_ES":"Basque","fi_FI":"Finnish","fr_FR":"French","gl_ES":"Gallegan","he_IL":"Hebrew","it_IT":"Italian","ja_JP":"Japanese","ko_KR":"Korean","nl_NL":"Dutch","nn_NO":"Norwegian Nynorsk","pl_PL":"Polish","pt_PT":"Portuguese","ro_RO":"Romanian","ru_RU":"Russian","sk_SK":"Slovak","sv_SE":"Swedish","tr_TR":"Turkish","zh_CN":"Chinese - China","zh_SI":"Chinese - Singapore","zh_TR":"Chinese - Traditional","zh_TW":"Chinese - Traditional"},"messages":{"CUSTOM_DOMAIN":"Custom domain","PUBLISH":"Publish","SSO_SECURITY":"SSO Security","WISHLIST":"Wishlist","XLS_SECURITY":"XLS Security","activate_offline_mode":"Activate offline mode","add":"Add","add_file":"Add file","add_pdf_to_download":"Add PDF to download","add_slide":"Add a slide","add_to_selection":"Add to selection","already_member":"Already a member?","alt_attribute":"Alt attribute","animation":"Animation","another_user":"Another user","application_content":"Application content","archive_noun":"Archive","archive_verb":"Archive","assortment":"Sortido","auto_zoom_level":"Auto zoom level","autoplay_delay":"Autoplay delay, s","available_as_template":"Available as template","available_offline":"Available offline","back":"Voltar","back_to_company":"Back to Company","back_to_home":"Back to Home","back_to_login":"Back to Login","back_to_method_view":"Change authentication method","bg_cover_left_tooltip":"This control will only take effect if the user's screen is cropping the background on the sides","bg_cover_top_tooltip":"This control will only take effect if the user's screen is cropping the background at the top/bottom","bottom":"Bottom","bulleted":"Bulleted","campaign_name":"Campaign name","cancel":"Cancel","change_cover_image":"Change cover image","change_password":"Change password","check_for_updates":"Check for Updates","checking_for_updates":"<b>Verificando atualizações...</b>","choose_coworker":"Choose a co-worker","clear_selection":"Clear your selection","client_id":"Client id","client_secret":"Client secret","close":"Fechar","color":"Color","combine":"Combine","combine_by_selecting_pages":"Wybierz strony do uwzględnienia na swojej liście odtwarzania","combining":"Combining %{percentage} %","confirm_password":"Confirm password","confirmation":"Confirmation","connect":"Connect","content_structure_incomplete":"Estrutura de conteúdos incompleta","content_structure_never_completed":"Para utilizar a aplicação em modo offline, a estrutura de conteúdos deve ser concluída primeiro. Ative a sua ligação à internet e tente novamente.","content_structure_ready":"A estrutura de conteúdos está agora disponível para uso offline","continue":"Continue","continue_downloading":"Continue Downloading","continue_downloading_important":"Continue Important Downloads","cookie_notification":"This website uses cookies to ensure you get the best experience on our services. By browsing this website, you accept the use of these cookies. However, you can modify your browser settings to cancel the automated validation. <a target='_blank' href=%{url}>Learn more.</a>","cookie_settings":"Gerenciar serviços","copy":"Copy","copy_links_to_share":"Copy links of shared resources and paste in your mail client","copy_mode_html":"Lista de links","copy_mode_text":"Texto simples","copy_paste_your_link":"Copy paste your link","coverflow":"Coverflow","create":"Create","create_customized_proposal":"Create customized proposal","create_deal_in_crm":"<span>Create a deal</span><br>in my CRM","create_demo_account":"Creating an account...","create_external_link":"Create an external link","create_folder":"Create a folder","create_from_template":"Create from a Template","create_note":"Create a note","create_proposal":"Create a Proposal","create_proposal_from_file":"Create a Proposal from file","create_proposal_from_template":"Create a Proposal from template","create_publication":"Create a Publication","create_your_slider":"Create your slider","creation_date":"Creation Date","crm":"CRM","custom_pdf":"Custom PDF","customize_url":"Customize the URL","customize_url_hint":"This will customize the end of our domain name with your text","deactivate_offline_mode":"Desativar o modo offline","default":"Default","default_animation":"Default animation","default_file":"Default file","default_image":"Default image","default_video":"Default video","delete":"Delete","delete_assets_sequentially":"Eliminar os recursos sequencialmente (mais lento)","delete_data":"Delete Data","deleting":"Deleting...","dependencies_deleted_out_of":"Deleting %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependencies","dependency_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dependency","description":"Description","deselect_all":"Deselect all","desktop":"Desktop","details":"Details","display_mode":"Display","do_not_close_app":"<b>Por favor, não feche a aplicação.</b>","done":"Done","dont_ask_me_again":"Don't ask me again","download":"Baixar","download_all":"Download All","download_all_important":"Download All Importants Assets","download_all_toast_in_progress":"Downloading in progress.<br><b>Do not minimize the application!</b>","download_all_toast_paused":"Downloading all assets was paused.<br>Would you like to continue?","download_complete":"Download Complete","download_complete_important":"Important Downloads Complete","download_importants_toast_in_progress":"Downloading important assets in progress.<br><b>Do not minimize the application!</b>","download_importants_toast_paused":"Download of important assets was paused.<br>Would you like to continue?","download_manager":"Gerenciador de downloads","download_pdf":"Baixar PDF","download_selected_toast_in_progress":"Baixando ativos selecionados em andamento.<br><b>Não minimize o aplicativo!</b>","download_selected_toast_paused":"O download dos ativos selecionados foi pausado.<br>Você gostaria de continuar?","download_toast_link_to_downloads":"Open <a href=%{url}>Downloads</a> page to view the progress.","download_toast_status":"Downloading %{downloadedItems} | %{totalItems}","downloaded":"Downloaded","downloading":"Downloading","downloading_thumbnails_for_offline_use":"A transferir miniaturas para utilização offline","downloads":"Downloads","draft":"Draft","duplicate":"Duplicate","duplicate_theme":"Duplicate theme","edit":"Modificar","edit_text":"Edit text","email":"Email","email_integration":"Email integration","enabled":"Enabled","end_date":"End Date","enter_image_description":"Enter image description","enter_image_source":"Enter image source","enter_password":"Enter password","enter_your_text":"Enter your text","error":"Error","extension_external_link":"External Link","extension_flip":"Flip","file_size":"File Size","folder":"Folder","folder_name":"Folder Name","font":"Font","forgot_password":"Forgot your password?","format":"Format","free_space":"Free space","from_app":"From App","from_desktop":"From Desktop","from_drive":"From Drive","from_selection":"From My Selection","from_youtube":"From Youtube","full_pdf":"Full PDF","full_publication":"Full publication","gdpr_allowAll":"Accept all","gdpr_message":"This site uses cookies and gives you control over what you want to activate","gdpr_personalize":"Personalize","gdpr_privacy_policy":"Privacy policy","gdpr_reject_all":"Continue without accepting","get_url":"Get URL","goto_page":"Go to page","goto_page_id":"Go to page ID","grid":"Grid","home":"Inicio","hours_left":"%{hours} hours left","iframe":"Iframe","image":"Image","image_source":"Image source","import_file":"Import a file","imported_all_files":"All files imported","importing":"Importing","importing_files_status":"Importing %{importedFiles} | %{totalFiles}","importing_with_percentage":"Importing %{percentage} %","informations":"Informations","integrate":"Integrate","integrate_ua_code":"Integrate UA Analytics code","integrate_ua_code_hint":"Multiple UA codes must be separated by comma or semicolon","invalid_chapter_id":"Invalid page ID","invite_coworker":"Invite a co-worker","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} item","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} items","keep_it_for_later":"Keep it for later","ken_burns_effect":"Ken Burns effect (auto zoom)","language":"Language","last_update_date":"Last Update Date","left":"Left","less_than_minute_left":"Less than a minute left","library":"Library","line_height":"Line height","link":"Link","list_type":"List type","loading":"Loading...","loading_fetch_content":"Fetching drive content 1/3","loading_required_items":"Downloading required items 2/3","loading_thumbnails":"Downloading thumbnails 3/3","local":"Local","log_out":"Log Out","logging_in":"Logging in...","masonry":"Masonry","menu":"Menu","minutes_left":"%{minutes} minutes left","modify_slide":"Modify slide","move":"Move","my_app":"My App","my_documents":"My Documents","my_downloads":"My Downloads","my_drive":"My Drive","my_gallery":"My Gallery","my_notes":"My notes","my_parameters":"My Settings","my_profile":"My profile","my_selection":"Minha seleção","my_sent":"My sent","my_templates":"My templates","name":"Name","name_surname":"Name, surname","new":"New","new_content_available_start_download":"New content available. Start the download now?","next":"Next","no_assets":"This folder is empty","no_assortment":"The assortment is empty","no_data_found":"No data found","no_downloads":"You haven't downloaded anything yet","no_new":"No new content","no_results":"No results for this search","no_save_as_info":"The template you want to be duplicated has been updated, please create a new proposal from the new template","no_selection":"You haven't selected anything","no_share_users":"There are no available users in the application","no_target_selected":"Select asset to open","no_templates":"No templates available","no_updates":"No updated content","none":"None","normal":"Normal","note":"Note","notification":"Notification","notification_credits_multiline":"%{credits} créditos serão debitados da sua conta para \"%{action}\"","numbered":"Numbered","ok":"OK","one_hour_left":"1 hour left","one_minute_left":"1 minute left","open":"Open","open_in_new_tab":"Open in New tab","open_in_same_tab":"Open in Same tab","open_popup":"Open Pop-Up","opened_date":"Opened date","options":"Options","or_sign_in":"Sign in","page":"Page","page_id":"Page ID","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Page not found","pages_selection":"Playlist","pages_selection_tooltip":"Opłata za opublikowanie wybranej publikacji w celu wykorzystania jej na liście odtwarzania zostanie pobrana.","parameters":"Parameters","password":"Password","pdf_processing":"PDF processing %{percentage} %","pdf_type":"PDF type","phone":"Phone","phone_number":"Phone number","pin_code":"PIN code","placeholder_company":"Enter your company name","placeholder_email":"Email","placeholder_login":"Login","placeholder_password":"Password","placeholder_phone":"Phone number","placeholder_search_drive_item":"Search","placeholder_share_contact_email":"Email do destinatário","placeholder_share_message":"Comentário\r\n\t\r\n\r\n","placeholder_share_name":"Teu nome","placeholder_share_user_email":"Teu email","popup":"Choose asset","popup_label":"Popup","position":"Position","preparing_content_structure":"A preparar a estrutura de conteúdos...","preview":"Preview","private_folder":"Private folder","processing":"Processing","profile":"Profile","profile_offline_message":"Profile page cannot be edited in offline mode. Try again when you connect to the internet","project_url":"Project URL","proposal_locked":"Proposal is being edited by %{userName}","proposal_name":"Proposal name","publication_locked":"Publication is being edited by %{userName}","publication_name":"Publication name","publish":"Publish","publish_publication":"Publique minha publicação","published":"Published","publishing":"Publishing","read":"Read","remember_me":"Remember me","remove":"Remove","remove_email_integration":"Are you sure you want to remove email integration?","remove_from_selection":"Remove from selection","remove_template":"Remove this Template","remove_theme":"Remove theme","remove_theme_question":"Do you want to remove current theme?","removing":"Removing","rename":"Rename","rename_theme":"Rename theme","replace":"Replace","replace_file":"Replace the file","reset_all_downloads":"Repor todas as transferências","reset_my_preferences":"Reset my preferences","reset_to_default":"Reset to default","resolution":"Resolution","resource_name":"Name","restart":"Restart","restart_all":"Restart all","resuming":"Resuming","retry":"Tentar novamente","right":"Right","row":"Row","salesforce":"Salesforce","salesforce_activation":"Salesforce activation","save":"Save","save_as":"Save as","save_in_documents":"Save in Documents","saving":"Saving...","scale":"Scale","search":"Search","search_phrase":"Frase de pesquisa","search_results":"Search results","see_preview":"See preview","seen":"Seen","select_all":"Select all","select_application":"Select your application","select_playlist_item":"Selecione um item para adicionar à sua playlist","select_publication_item":"Selecione um item para adicionar à sua publicação","select_server":"Selecione um servidor","select_this_application":"Select this application","select_this_server":"Escolha este servidor","select_your_tags":"Select your tags","select_your_template":"Select your template","selection":"Selection","send":"Send","send_by_email":"Send by Email","send_my_proposal":"Send my Proposal","send_my_publication":"Send my Publication","send_my_selection":"Send my selection","sent":"Enviar","sent_date":"Sent date","session_expired":"Your session expired","set_as_template":"Set as a Template","settings":"Settings","share":"Compartilhar","share_by_email":"Share by email","share_my_selection":"Partilhar minha seleção","share_via_copy":"Share via copy","share_via_uprez":"Share via Uprez","shared":"Shared","shared_with_me":"Shared with me","sign_in_options":"Sign in Options","sign_up_for_free_trial":"Sign up for a free trial","size":"Size","slider":"Slider","sources":"Sources","spacing":"Spacing","start_to_download":"Start to download","status_read":"Read","templates":"Templates","test_our_demo":"Test our demo","text":"Text","text_style":"Text style","theme":"Theme","theme_name":"Theme name","themes":"Themes","title":"Title","title_and_preview":"Title/preview","top":"Top","try_demo":"Try our demo","tutorial_uprez":"Tutorial Uprez","type":"Type","unlock":"Unlock","unread":"Unread","untitled_note":"Untitled note","update":"Update","update_all":"Update All","update_all_important":"Update All Important Assets","update_folder_tree":"Update Folder Tree","update_pdf_thumb":"Update PDF thumbnails","update_pdf_thumb_accept":"I want to generate all the thumbnails","update_pdf_thumb_message":"Your PDF will be replaced with this one","update_published":"Update","updating":"Updating","updating_asset":"Atualizando...","updating_content_structure":"A atualizar a estrutura de conteúdos...","url":"Url","used_space":"Used space","version":"Version","video":"Video","video_processing":"Video processing","view":"View","view_published":"View published","webpublication":"Webpublication","webpublication_method":"Webpublication authentication","your_company_account":"Your company account","your_file":"Your file","your_themes":"Your themes","your_ua_code":"Your UA analytics code","your_url":"Your url","youtube_link":"Youtube link"},"page_title":{"assortment":"Assortment %{galleryName}","authentication":"Authentication","details":"Details %{itemName} - %{galleryName}","downloads":"Downloads %{galleryName}","drive":"Drive %{galleryName}","editor":"Editor","folder":"Folder %{itemName} - %{galleryName}","gallery":"Gallery","gallery_name":"%{galleryName}","my_documents":"My documents - %{galleryName}","my_notes":"My notes","my_sent":"My sent","new":"New %{galleryName}","parameters":"Settings %{galleryName}","profile":"Profile","search":"Search %{galleryName}","selection":"Selecionar %{galleryName}","shared_with_me":"Shared with me","theater":"Theater %{itemName} - %{galleryName}"},"share":{"company":"Company","contact":"Recipient Information","contactEmail":"Recipient Email","documents":"Documents","email_body":"Please find below the documents you've wished to receive during our appointment.","email_greeting":"Hello,","email_salutation":"Best regards,","firstname":"Firstname","notes":"Notes","phone":"Phone","position":"Position","subject":"Subject","surname":"Surname"},"type":{"asp-type-0":"Directory","asp-type-1":"Component","asp-type-10":"App","asp-type-11":"Gallery","asp-type-12":"External link","asp-type-2":"File","asp-type-3":"Template","asp-type-4":"Image","asp-type-5":"Movie","asp-type-6":"Publication","asp-type-7":"Sound","asp-type-8":"Publication","asp-type-9":"Link"}}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = {"date_format":{"digital_slash":"DD/MM/YYYY","long":"DD MMM YYYY"},"error":{"another_user_login":"L'utente è stato disconnesso perché ha effettuato l'accesso da un altro dispositivo.","asset_not_erasable":"Una o più attività non erano cancellabili","authentication_needed":"Si è verificato un errore, è necessario effettuare nuovamente il login.","bundle_content_expired":"Il %{number} dei contenuti è scaduto","bundle_delete_fail":"Non è stato possibile cancellare il %{number} del contenuto","bundle_download_fail":"Non è stato possibile scaricare il %{number} del contenuto","bundle_fetch_content_error":"Non è stato possibile recuperare il %{number} del contenuto","bundle_initialization_fail":"Bundle initialization fail","bundle_open_fail":"Non è stato possibile aprire il %{number} del contenuto","cant_archive_proposal":"Impossibile archiviare la proposta","cant_change_cover_image":"Non è possibile modificare l'immagine di copertina","cant_create_external_link":"Impossibile creare un collegamento esterno","cant_create_folder":"Non è possibile creare questa cartella","cant_create_note":"Non è possibile creare una nota","cant_get_resource":"Non è possibile ottenere i dati delle attività","cant_move_asset":"Non è possibile spostare un'attività","cant_remove_asset":"Non è possibile rimuovere una nota","cant_remove_note":"Non è possibile rimuovere un'attività","cant_update_note":"Non è possibile aggiornare una nota","combine_error":"Si è verificato un errore durante il processo di associazione","content_expired":"Il contenuto (id: %{id}) è scaduto","create_proposal_error":"Non è possibile creare una proposta","create_publication_error":"Non è possibile creare una pubblicazione","custom_url_used":"L'url inserito esiste già","delete_fail":"Non è stato possibile eliminare il contenuto (id: %{id})","download_fail":"Il contenuto (ID: %{id}) non può essere scaricato. Ti preghiamo di provare a scaricarlo nuovamente senza minimizzare l'app o passare a un'altra.","duplicate_email":"Accesso utilizzato","duplicate_file_name":"Il file esiste già","duplicate_page_error":"Impossibile duplicare la pagina","duplicate_theme":"Nome del tema utilizzato","fetch_content_block_error":"Non è stato possibile recuperare il contenuto (parent: %{id}).","fetch_content_error":"Non è stato possibile recuperare il contenuto (id: %{id}).","fetch_editor_data_error":"Si è verificato un errore durante il caricamento dei dati dell'editor","fetch_folder_tree":"Si è verificato un errore durante l'aggiornamento della struttura delle cartelle","fetch_notes_error":"Si è verificato un errore durante il caricamento delle note","fetch_profile_data_error":"Si è verificato un errore durante il caricamento dei dati del profilo","fetch_proposal_stats_error":"Si è verificato un errore durante il caricamento delle statistiche della proposta","fetch_publication_data":"Si è verificato un errore durante il caricamento dei dati di pubblicazione","fetch_publication_templates_error":"Si è verificato un errore durante il caricamento dei modelli","field_must_have_at_least":"Il campo deve avere almeno %{charsCount} caratteri","file_import_error":"Si è verificato un errore durante l'importazione di un file","file_import_error_short":"Errore di importazione","get_publication_settings":"Si è verificato un errore durante il caricamento delle impostazioni di pubblicazione","get_publication_url":"Si è verificato un errore durante l'ottenimento dell'URL di pubblicazione","get_share_users":"Si è verificato un errore durante l'acquisizione dei dati degli utenti","import_publication_pdf":"Si è verificato un errore durante l'importazione di una pubblicazione PDF","initialization_fail":"Si è verificato un errore durante l'inizializzazione, si prega di rilanciare l'applicazione.","invalid_auth":"Login, password o server non validi","invalid_company_name":"Nome dell'azienda non valido","invalid_email_address":"Indirizzo e-mail non valido","invalid_page_number":"Numero di pagina non valido","invalid_url":"URL non valido","login_or_password_incorrect":"Login o password errati","move_page_error":"Non è possibile spostare la pagina","no_application_available":"Nessuna applicazione disponibile","open_fail":"Impossibile aprire il contenuto (id: %{id})","parse_editor_data_error":"Si è verificato un errore durante l'analisi dei dati dell'editor","passwords_do_not_match":"Login, password o server non validi","processing_fail":"Fallimento dell'elaborazione","proposal_not_archived":"La proposta non è stata archiviata","publish_publication":"Si è verificato un errore durante la pubblicazione","remove_page_error":"Non è possibile rimuovere la pagina","remove_template_error":"Impossibile rimuovere il template","rename_asset_error":"Non è possibile rinominare l'attività","reset_fail":"Impossibile reimpostare i download","save_editor_data_error":"Si è verificato un errore durante il salvataggio dei dati dell'editor","save_profile_data_error":"Si è verificato un errore durante il salvataggio dei dati del profilo","save_publication_settings":"Si è verificato un errore durante il salvataggio delle impostazioni di pubblicazione","search_error":"Si è verificato un errore durante la ricerca","session_expired":"La sessione è scaduta","set_as_template_error":"Non è possibile impostare come template","share_failed_request":"Si è verificato un errore, non è stato possibile condividere la selezione","share_proposal_error":"Si è verificato un errore durante l'invio della proposta","share_publication_error":"Si è verificato un errore durante l'invio della pubblicazione","share_with_user":"Si è verificato un errore durante la condivisione dell'attività","the_resources_are_restricted_for_sharing":"Le attività che si sta cercando di condividere sono limitate.","unexpected_error":"Errore imprevisto","update_publication":"Si è verificato un errore durante l'aggiornamento della pubblicazione","wrong_file_type":"Tipo di file errato"},"fileFormat":{"COMPONENT":"Pagina","DOCUMENT":"Documento","EPUB":"EPUB","FILE":"File","IMAGE":"Immagine","MOVIE":"Film","PDF":"PDF","PLAYLIST":"Playlist","PRESENTATION":"Presentazione","PROPOSAL":"Proposta","PUBLICATION":"Pubblicazione"},"info":{"create_note_success":"La nota è stata salvata. <a href=%{url}>Vedi le tue note</a>","delete_all":"Tutti i contenuti sono stati cancellati","emails_sent":"Your pending email(s) have been sent","fill_all_input_fields":"Compilare tutti i campi","import_publication_pdf":"Il file PDF è stato importato con successo","offline_create_external_link":"Connettersi a Internet per creare un link esterno","offline_create_folder":"Collegarsi a Internet per creare una cartella","offline_download_multiple_assets":"Collegarsi a Internet per scaricare i contenuti","offline_download_single_asset":"Connettersi a Internet per scaricare il contenuto","offline_fetch_notes":"Connettersi a Internet per recuperare le note condivise","offline_login":"Connettersi a Internet per effettuare il login","offline_no_config":"Per il primo avvio è necessaria una connessione a Internet","offline_update_folder_tree":"Per aggiornare la struttura delle cartelle è necessaria una connessione a Internet","remove_publication_pdf":"La pubblicazione in PDF è stata rimossa con successo","reset_all_downloads":"Tutti i download sono stati reimpostati","selection_sent":"La selezione in corso è stata condivisa","selection_shared_once_online":"La selezione sarà condivisa una volta che si è online","set_as_template_success":"L'attività è stata impostata con successo come template","share_with_user_success":"L'attività è stata condivisa con successo","url_copied":"L'URL è stato copiato"},"languages":{"ca_ES":"Catalano","da_DK":"Danese","de_DE":"Tedesco","en_AU":"Inglese - AU","en_UK":"Inglese - UK","en_US":"Inglese - US","es_ES":"Spagnolo","eu_ES":"Basco","fi_FI":"Finlandese","fr_FR":"Francese","gl_ES":"Galiziano","he_IL":"Ebraico","it_IT":"Italiano","ja_JP":"Giapponese","ko_KR":"Coreano","nl_NL":"Olandese","nn_NO":"Norvegese nynorsk","pl_PL":"Polacco","pt_PT":"Portoghese","ro_RO":"Rumeno","ru_RU":"Russo","sk_SK":"Slovacco","sv_SE":"Svedese","tr_TR":"Turco","zh_CN":"Cinese - Cina","zh_SI":"Cinese - Singapore","zh_TR":"Cinese tradizionale","zh_TW":"Cinese tradizionale"},"messages":{"CUSTOM_DOMAIN":"Custom domain","PUBLISH":"Publish","SSO_SECURITY":"SSO Security","WISHLIST":"Wishlist","XLS_SECURITY":"XLS Security","activate_offline_mode":"Attivare la modalità offline","add":"Aggiungi","add_file":"Aggiungi file","add_pdf_to_download":"Aggiungi PDF al download","add_slide":"Aggiungi una diapositiva","add_to_selection":"Aggiungi alla selezione","already_member":"Sei già membro?","alt_attribute":"Alt attribute","animation":"Animazione","another_user":"Un altro utente","application_content":"Contenuto dell'applicazione","archive_noun":"Archivio","archive_verb":"Archivio","assortment":"Assortimento","auto_zoom_level":"Livello di zoom automatico","autoplay_delay":"Ritardo di riproduzione automatica, s","available_as_template":"Disponibile come template","available_offline":"Disponibile offline","back":"Indietro","back_to_company":"Torna all'azienda","back_to_home":"Torna alla home","back_to_login":"Torna al login","back_to_method_view":"Cambia il metodo di autenticazione","bg_cover_left_tooltip":"Questo controllo avrà effetto solo se lo schermo dell'utente ritaglia lo sfondo ai lati","bg_cover_top_tooltip":"Questo controllo avrà effetto solo se lo schermo dell'utente ritaglia lo sfondo nella parte superiore/inferiore","bottom":"In basso","bulleted":"Puntato","campaign_name":"Nome della campagna","cancel":"Annulla","change_cover_image":"Modifica immagine di copertina","change_password":"Modifica password","check_for_updates":"Check for Updates","checking_for_updates":"<b>Verifica aggiornamenti...</b>","choose_coworker":"Scegli un collega","clear_selection":"Cancella la tua selezione","client_id":"CId cliente","client_secret":"Segreto del cliente","close":"Chiudi","color":"Colore","combine":"Associa","combine_by_selecting_pages":"Seleziona le pagine da includere nella tua playlist","combining":"CIn associazione %{percentage} %","confirm_password":"Conferma la password","confirmation":"Conferma","connect":"Collega","content_structure_incomplete":"Struttura dei contenuti incompleta","content_structure_never_completed":"Per utilizzare l'app in modalità offline, la struttura dei contenuti deve essere completata prima. Attiva la connessione a internet e riprova.","content_structure_ready":"La struttura dei contenuti è ora disponibile per l'uso offline","continue":"Continua","continue_downloading":"Riprendi Download di tutto","continue_downloading_important":"Riprendi Download attività importanti","cookie_notification":"Questo sito web utilizza i cookies per garantire un'esperienza ottimale dei nostri servizi. Navigando su questo sito web, accetti l'uso di questi cookies. Tuttavia, è possibile modificare le impostazioni del browser per annullare la convalida automatica. <a target='_blank' href=%{url}>Scopri di più.</a>","cookie_settings":"Gestisci i servizi","copy":"Copia","copy_links_to_share":"Copia, apri il client di posta e « incolla »","copy_mode_html":"Elenco dei link","copy_mode_text":"Testo normale","copy_paste_your_link":"Copia incolla il tuo link","coverflow":"Coverflow","create":"Crea","create_customized_proposal":"Create customized proposal","create_deal_in_crm":"<span>Crea un accordo</span><br> nel mio CRM","create_demo_account":"Crea un account...","create_external_link":"Crea un collegamento esterno","create_folder":"Crea una cartella","create_from_template":"Crea da un template","create_note":"Crea una nota","create_proposal":"Crea una proposta","create_proposal_from_file":"Crea una proposta da un file","create_proposal_from_template":"Crea una proposta da un template","create_publication":"Immagine predefinita","create_your_slider":"Crea lo slider","creation_date":"Data di creazione","crm":"CRM","custom_pdf":"PDF personalizzato","customize_url":"Personalizza l'URL","customize_url_hint":"Questo personalizzerà la fine del nostro nome di dominio con il tuo testo","deactivate_offline_mode":"Disattiva la modalità offline","default":"Predefinito","default_animation":"Animazione predefinita","default_file":"File predefinito","default_image":"Immagine predefinita","default_video":"Video predefinito","delete":"Cancella","delete_assets_sequentially":"Elimina le risorse in modo sequenziale (più lento)","delete_data":"Cancella tutte le attività","deleting":"Deleting...","dependencies_deleted_out_of":"Deleting %{dependenciesDeleted} / %{dependenciesToDelete}","dependencies_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dipendenze","dependency_downloaded_out_of":"%{dependenciesDownloaded} / %{dependenciesToDownload} dipendenza","description":"Descrizione","deselect_all":"Deseleziona tutto","desktop":"Desktop","details":"Dettagli","display_mode":"Display","do_not_close_app":"<b>Per favore non chiudere l'app.</b>","done":"Fatto","dont_ask_me_again":"Non chiedermelo più","download":"Download","download_all":"Download di tutto","download_all_important":"Download attività importanti","download_all_toast_in_progress":"Download in corso.<br><b>Non ridurre a icona l'applicazione!</b>","download_all_toast_paused":"Il download di tutte le attività è stato messo in pausa.<br>Vuoi continuare?","download_complete":"Download completati","download_complete_important":"Download importanti completati","download_importants_toast_in_progress":"Download di attività importanti in corso.<br><b>Non ridurre a icona l'applicazione!</b>","download_importants_toast_paused":"Il download delle attività importanti è stato messo in pausa.<br>Vuoi continuare?","download_manager":"Gestore dei download","download_pdf":"Télécharger le PDF","download_selected_toast_in_progress":"Download di attività selezionate in corso.<br><b>Non ridurre a icona l'applicazione!</b>","download_selected_toast_paused":"Il download delle attività selezionate è stato messo in pausa.<br>Vuoi continuare?","download_toast_link_to_downloads":"Apri la pagina <a href=%{url}>Download</a> per visualizzare l'avanzamento.","download_toast_status":"Download in corso di %{downloadedItems} | %{totalItems}","downloaded":"Scaricato","downloading":"In fase di download","downloading_thumbnails_for_offline_use":"Download delle miniature per l’uso offline","downloads":"Downloads","draft":"Bozza","duplicate":"Duplica","duplicate_theme":"Duplica tema","edit":"Modifica","edit_text":"Modifica testo","email":"Email","email_integration":"Integrazione delle e-mail","enabled":"Abilitato","end_date":"Data di fine","enter_image_description":"Enter image description","enter_image_source":"Enter image source","enter_password":"Inserisci password","enter_your_text":"Inserisci il testo","error":"Errore","extension_external_link":"Collegamento esterno","extension_flip":"Capovolgi","file_size":"Dimensione del file","folder":"Cartella","folder_name":"Nome della cartella","font":"Carattere","forgot_password":"Hai dimenticato la password?","format":"Formato","free_space":"Spazio libero","from_app":"Da App","from_desktop":"Da Desktop","from_drive":"Da Drive","from_selection":"Dalla mia selezione","from_youtube":"Da Youtube","full_pdf":"PDF completo","full_publication":"Pubblicazione completa","gdpr_allowAll":"Accetta tutto","gdpr_message":"Questo sito utilizza i cookie e consente all'utente di controllare quali attivare","gdpr_personalize":"Personalizza","gdpr_privacy_policy":"Informativa sulla privacy","gdpr_reject_all":"Continua senza accettare","get_url":"Ottieni l'URL","goto_page":"Vai alla pagina","goto_page_id":"Vai all'ID pagina","grid":"Griglia","home":"Home","hours_left":"%{hours} ore rimaste","iframe":"Iframe","image":"Immagine","image_source":"Image source","import_file":"Importa un file","imported_all_files":"Tutti i file importati","importing":"Importazione","importing_files_status":"Importazione di %{importedFiles} | %{totalFiles}","importing_with_percentage":"Importazione %{percentage} %","informations":"Ottieni l'URL","integrate":"Integra","integrate_ua_code":"Integra il codice di UA Analytics","integrate_ua_code_hint":"SI codici UA multipli devono essere separati da una virgola o da un punto e virgola","invalid_chapter_id":"ID pagina non valido","invite_coworker":"Invita un collega","item_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} elemento","items_downloaded_out_of":"%{itemsDownloaded} / %{itemsToDownload} elementi","keep_it_for_later":"Conservalo per dopo","ken_burns_effect":"Effetto Ken Burns (zoom automatico)","language":"Lingua","last_update_date":"Data dell'ultimo aggiornamento","left":"A sinistra","less_than_minute_left":"Manca meno di un minuto","library":"Biblioteca","line_height":"Altezza della linea","link":"Collegamento","list_type":"TTipo di elenco","loading":"In fase di caricamento...","loading_fetch_content":"Recupero del contenuto dell'unità 1/3","loading_required_items":"Download degli elementi richiesti 2/3","loading_thumbnails":"Scarica le anteprime 3/3","local":"Locale","log_out":"Disconnettiti","logging_in":"In fase di accesso...","masonry":"Masonry","menu":"Menu","minutes_left":"%{minutes} minuti rimasti","modify_slide":"Modifica la diapositiva","move":"Sposta","my_app":"La mia applicazione","my_documents":"I miei documenti","my_downloads":"I miei download","my_drive":"Il mio Drive","my_gallery":"La mia galleria","my_notes":"I miei appunti","my_parameters":"I miei appunti","my_profile":"Il mio profilo","my_selection":"La mia selezione","my_sent":"I mie invii","my_templates":"I miei template","name":"Nome","name_surname":"Nome / cognome","new":"Nuovo","new_content_available_start_download":"Nuovi contenuti disponibili. Avvia subito il download?","next":"Avanti","no_assets":"Questa cartella è vuota","no_assortment":"L'assortimento è vuoto","no_data_found":"Nessun dato trovato","no_downloads":"Non hai ancora scaricato nulla","no_new":"Nessun nuovo contenuto","no_results":"Nessun risultato per questa ricerca","no_save_as_info":"Il template che vuoi duplicare è stato aggiornato, crea una nuova proposta dal nuovo template","no_selection":"Non hai selezionato nulla","no_share_users":"Non ci sono utenti disponibili nell'applicazione","no_target_selected":"Sélectionnez un asset à ouvrir","no_templates":"Nessun template disponibile","no_updates":"Nessun contenuto aggiornato","none":"Nessuno","normal":"Normale","note":"Nota","notification":"Notifica","notification_credits_multiline":"%{credits} crediti saranno addebitati dal tuo conto per \"%{action}\"","numbered":"Numerato","ok":"OK","one_hour_left":"Manca 1 ora","one_minute_left":"Manca 1 minuto","open":"Apri","open_in_new_tab":"Apri in una nuova scheda","open_in_same_tab":"Apri nella stessa scheda","open_popup":"Apri il pop-up","opened_date":"Data di apertura","options":"Opzioni","or_sign_in":"Accedi","page":"Pagina","page_id":"ID pagina","page_index":"%{index} <span style='font-weight: 400;'>|</span> %{count}","page_not_found":"Pagina non trovata","pages_selection":"Playlist","pages_selection_tooltip":"Devi pubblicare la pubblicazione prima di selezionare le pagine dalla stessa","parameters":"Parametri","password":"Password","pdf_processing":"Traitement du PDF %{percentage} %","pdf_type":"Type de PDF","phone":"Smartphone","phone_number":"Numero di telefono","pin_code":"Ricerca","placeholder_company":"Entrez le nom de votre entreprise","placeholder_email":"E-mail","placeholder_login":"Identifiant","placeholder_password":"Password","placeholder_phone":"Numéro de téléphone","placeholder_search_drive_item":"Rechercher","placeholder_share_contact_email":"E-mail del destinatario","placeholder_share_message":"Il tuo messaggio","placeholder_share_name":"Il tuo nome","placeholder_share_user_email":"Il tuo indirizzo e-mail","popup":"Choisir un asset","popup_label":"Popup","position":"Posizione","preparing_content_structure":"Preparazione della struttura dei contenuti...","preview":"Anteprima","private_folder":"Cartella privata","processing":"Elaborazione","profile":"Profilo","profile_offline_message":"La pagina del profilo non può essere modificata in modalità offline. Riprova quando sei connesso a Internet","project_url":"Progetto URL","proposal_locked":"La proposta è in corso di modifica da parte di %{userName}","proposal_name":"Nome della proposta","publication_locked":"La pubblicazione è in corso di modifica da parte di %{userName}","publication_name":"Nome della proposta","publish":"Pubblica","publish_publication":"Pubblica la mia pubblicazione","published":"Pubblicato","publishing":"Pubblicazione","read":"Leggi","remember_me":"Ricordati di me","remove":"Rimuovi","remove_email_integration":"Vuoi davvero rimuovere l'integrazione delle e-mail?","remove_from_selection":"Rimuovi dalla selezione","remove_template":"Rimuovi questo template","remove_theme":"Rimuovi tema","remove_theme_question":"Vuoi rimuovere il tema attuale?","removing":"Rimozione","rename":"Rinomina","rename_theme":"Rinomina il tema","replace":"Sostituisci","replace_file":"Sostituisci il file","reset_all_downloads":"Reimposta tutti i download","reset_my_preferences":"Reimposta le mie preferenze","reset_to_default":"Ripristino delle impostazioni predefinite","resolution":"Risoluzione","resource_name":"Nome","restart":"Riavvio","restart_all":"Riavvia tutto","resuming":"Riprendi","retry":"Riprova","right":"Dritto","row":"Fila","salesforce":"Salesforce","salesforce_activation":"Attivazione di salesforce","save":"Salva","save_as":"Salvataggio in corso...","save_in_documents":"Salva in Documenti","saving":"Scala...","scale":"Ricerca","search":"Recherche","search_phrase":"Mots recherchés","search_results":"Résultats de la recherche","see_preview":"Voir la preview","seen":"Visto","select_all":"Seleziona tutti","select_application":"Seleziona l'applicazione","select_playlist_item":"Seleziona un elemento da aggiungere alla tua playlist","select_publication_item":"Seleziona un elemento da aggiungere alla tua pubblicazione","select_server":"Sélectionnez un serveur","select_this_application":"Seleziona questa applicazione","select_this_server":"Choisir ce serveur","select_your_tags":"Seleziona i tag","select_your_template":"Seleziona il template","selection":"Selezione","send":"Invia","send_by_email":"Invia per e-mail","send_my_proposal":"Invia la mia proposta","send_my_publication":"Invia la mia pubblicazione","send_my_selection":"Invia la mia selezione","sent":"Inviato","sent_date":"Data di invio","session_expired":"La sessione è scaduta","set_as_template":"Imposta come template","settings":"Impostazioni","share":"Condividi","share_by_email":"Condividi per e-mail","share_my_selection":"Condividi la mia selezione","share_via_copy":"Copia i link","share_via_uprez":"Condividi tramite modulo di contatto","shared":"Condiviso","shared_with_me":"Condiviso con me","sign_in_options":"Opzioni di accesso","sign_up_for_free_trial":"Iscriviti alla prova gratuita","size":"Dimensione","slider":"Cursore","sources":"Fonti","spacing":"Spaziatura","start_to_download":"Avvia il download","status_read":"Leggi","templates":"Template","test_our_demo":"Prova la nostra demo","text":"Testo","text_style":"Stile del testo","theme":"Tema","theme_name":"Nome del tema","themes":"Temi","title":"Titolo","title_and_preview":"Titolo/anteprima","top":"In alto","try_demo":"Prova la nostra demo","tutorial_uprez":"Tutorial Uprez","type":"Tipo","unlock":"Sblocca","unread":"Non lettov","untitled_note":"Nota senza titolo","update":"Aggiorna","update_all":"Aggiorna tutti","update_all_important":"Aggiorna tutte le attività importanti","update_folder_tree":"Aggiorna la struttura delle cartelle","update_pdf_thumb":"Aggiorna le miniature dei PDF","update_pdf_thumb_accept":"Voglio generare tutte le miniature","update_pdf_thumb_message":"Il tuo PDF sarà sostituito da questo","update_published":"Aggiorna","updating":"Aggiornamento","updating_asset":"Aggiornamento...","updating_content_structure":"Aggiornamento della struttura dei contenuti...","url":"Url","used_space":"Spazio usato","version":"Versione","video":"Video","video_processing":"Elaborazione video","view":"Visualizza","view_published":"Visualizza pubblicato","webpublication":"Webpublication","webpublication_method":"Autenticazione della Webpublication","your_company_account":"Il tuo conto aziendale","your_file":"Il tuo file","your_themes":"I tuoi temi","your_ua_code":"Il tuo codice di analisi UA","your_url":"Il tuo URL","youtube_link":"Collegamento a Youtube"},"page_title":{"assortment":"Assortimento %{galleryName}","authentication":"Autenticazione","details":"Dettagli %{itemName} - %{galleryName}","downloads":"Download %{galleryName}","drive":"Guida %{galleryName}","editor":"Editor","folder":"Cartella %{itemName} - %{galleryName}","gallery":"Galleria","gallery_name":"%{galleryName}","my_documents":"I miei documenti - %{galleryName}","my_notes":"I miei appunti","my_sent":"I mie invii","new":"Nuovo %{galleryName}","parameters":"Impostazioni %{galleryName}","profile":"Profilo","search":"Cerca %{galleryName}","selection":"Selezione %{galleryName}","shared_with_me":"Condiviso con me","theater":"Teatro %{itemName} - %{galleryName}"},"share":{"company":"Azienda","contact":"Informazioni sul destinatario","contactEmail":"Email del destinatario","documents":"Documenti","email_body":"Di seguito trovi i documenti che desideri ricevere durante il nostro appuntamento.","email_greeting":"Ciao,","email_salutation":"Cordiali saluti,","firstname":"Nome","notes":"Note","phone":"Telefono","position":"Posizione","subject":"Oggetto","surname":"Cognome"},"type":{"asp-type-0":"Directory","asp-type-1":"Componente","asp-type-10":"App","asp-type-11":"Galleria","asp-type-12":"Collegamento esterno","asp-type-2":"File","asp-type-3":"Template","asp-type-4":"Immagine","asp-type-5":"Film","asp-type-6":"Pubblicazione","asp-type-7":"Suono","asp-type-8":"Pubblicazione","asp-type-9":"Lien"}}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(66)))

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createRouterHistory;

var _useRouterHistory = __webpack_require__(784);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(275);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(277);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return del; });
/* unused harmony export entries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return get; });
/* unused harmony export getMany */
/* unused harmony export keys */
/* unused harmony export promisifyRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setMany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return values; });
function promisifyRequest(request) {
  return new Promise(function (resolve, reject) {
    // @ts-ignore - file size hacks
    request.oncomplete = request.onsuccess = function () {
      return resolve(request.result);
    }; // @ts-ignore - file size hacks


    request.onabort = request.onerror = function () {
      return reject(request.error);
    };
  });
}

function createStore(dbName, storeName) {
  var request = indexedDB.open(dbName);

  request.onupgradeneeded = function () {
    return request.result.createObjectStore(storeName);
  };

  var dbp = promisifyRequest(request);
  return function (txMode, callback) {
    return dbp.then(function (db) {
      return callback(db.transaction(storeName, txMode).objectStore(storeName));
    });
  };
}

var defaultGetStoreFunc;

function defaultGetStore() {
  if (!defaultGetStoreFunc) {
    defaultGetStoreFunc = createStore('keyval-store', 'keyval');
  }

  return defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function get(key) {
  var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
  return customStore('readonly', function (store) {
    return promisifyRequest(store.get(key));
  });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function set(key, value) {
  var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetStore();
  return customStore('readwrite', function (store) {
    store.put(value, key);
    return promisifyRequest(store.transaction);
  });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function setMany(entries) {
  var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
  return customStore('readwrite', function (store) {
    entries.forEach(function (entry) {
      return store.put(entry[1], entry[0]);
    });
    return promisifyRequest(store.transaction);
  });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function getMany(keys) {
  var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
  return customStore('readonly', function (store) {
    return Promise.all(keys.map(function (key) {
      return promisifyRequest(store.get(key));
    }));
  });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function update(key, updater) {
  var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetStore();
  return customStore('readwrite', function (store) {
    return (// Need to create the promise manually.
      // If I try to chain promises, the transaction closes in browsers
      // that use a promise polyfill (IE10/11).
      new Promise(function (resolve, reject) {
        store.get(key).onsuccess = function () {
          try {
            store.put(updater(this.result), key);
            resolve(promisifyRequest(store.transaction));
          } catch (err) {
            reject(err);
          }
        };
      })
    );
  });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function del(key) {
  var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
  return customStore('readwrite', function (store) {
    store.delete(key);
    return promisifyRequest(store.transaction);
  });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function clear() {
  var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
  return customStore('readwrite', function (store) {
    store.clear();
    return promisifyRequest(store.transaction);
  });
}

function eachCursor(customStore, callback) {
  return customStore('readonly', function (store) {
    // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
    // And openKeyCursor isn't supported by Safari.
    store.openCursor().onsuccess = function () {
      if (!this.result) return;
      callback(this.result);
      this.result.continue();
    };

    return promisifyRequest(store.transaction);
  });
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function keys() {
  var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
  var items = [];
  return eachCursor(customStore, function (cursor) {
    return items.push(cursor.key);
  }).then(function () {
    return items;
  });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function values() {
  var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
  var items = [];
  return eachCursor(customStore, function (cursor) {
    return items.push(cursor.value);
  }).then(function () {
    return items;
  });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */


function entries() {
  var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
  var items = [];
  return eachCursor(customStore, function (cursor) {
    return items.push([cursor.key, cursor.value]);
  }).then(function () {
    return items;
  });
}




/***/ }),
/* 786 */
/***/ (function(module, exports) {

  var _piwikTrackerLoaded = false;
  var _initializeTracker = null;
  
  /**
  * An object to manage Piwik as a PiwikManager plugin
  * @constructs PiwikTracker
  * @memberof Class
  * @author Alessandro Cipolletti
  */
  function PiwikTracker(serverConfNode) {
	
	this.account = serverConfNode.id;
	this.accountUrl = serverConfNode.url.replace("piwik.php", "").replace("piwik.js", "");
	this.loadTracker();
	
}

PiwikTracker.prototype.isLoaded = function () {
	return _piwikTrackerLoaded;
}

/**
* Load the piwik tracker
* @author Alessandro Cipolletti, Bruno Sabot
*/
PiwikTracker.prototype.loadTracker = function () {
	
	if (_piwikTrackerLoaded) {
		return;
	}
	
	_initializeTracker = new Promise(function (resolve) {
		window.piwikAsyncInit = resolve;
	});
	
	// Inclusion du script Piwik
	var g = document.createElement("script");
	var s = document.getElementsByTagName("script")[0];
	g.type = "text/javascript";
	g.async = true;
	g.defer = true;
	g.onload = function () {
		_piwikTrackerLoaded = true;
	};
	g.src = this.accountUrl + "piwik.js";
	s.parentNode.insertBefore(g, s);
	
	
};

/**
* Track a page view
* @param  {String} page  The page code name viewed
* @param  {String} hash  The hash of the page viewed
* @param  {String} title The page title
* @author Alessandro Cipolletti, Bruno Sabot
*/
PiwikTracker.prototype.trackPage = function (page, url, title) {
	
	// Need the Piwik tracker to be ready
	_initializeTracker.then(function () {
		
		// Track
		var piwikTracker = Piwik.getTracker(this.accountUrl + "piwik.php", this.account);
		piwikTracker.setCustomUrl(url);
		piwikTracker.setDocumentTitle(title);
		piwikTracker.trackPageView();
		
	}.bind(this));
	
};

/**
* Track a page event
* @param  {String}  category The event category
* @param  {String}  action   The event name
* @param  {String}  label    The action label
* @param  {integer} value    A complementary figure
* @author Alessandro Cipolletti, Bruno Sabot
*/
PiwikTracker.prototype.trackEvent = function (category, action, label, value) {
	
	// Need the Piwik tracker to be ready
	_initializeTracker.then(function () {
		
		var piwikTracker = Piwik.getTracker(this.accountUrl + "piwik.php", this.account);
		if (value) {
			piwikTracker.trackEvent(action, label);
		} else {
			piwikTracker.trackEvent(action, label, value);
		}
		
	}.bind(this));
	
};

module.exports = PiwikTracker;


/***/ }),
/* 787 */
/***/ (function(module, exports) {

var _matomoTrackerLoaded = false;

/**
 * An object to manage Matomo tracking
 * @constructs MatomoTracker
 * @memberof Class
 * @author Andreï Cavoleau
 */
function MatomoTracker(config) {
	/*
	  For Matomo, all 3 properties are needed,
	  for Matomo Tag Manager, only scriptUrl is needed
	*/
	this.siteId = config.id;
	this.trackerUrl = config.trackerUrl;
	this.scriptUrl = config.scriptUrl;
	this.loadTracker();
}

MatomoTracker.prototype.isLoaded = function () {
	return _matomoTrackerLoaded;
}

/**
 * Load the Matomo tracker
 * @author Andreï Cavoleau
 */
MatomoTracker.prototype.loadTracker = function () {

	if (_matomoTrackerLoaded) {
		return;
	}

	window._paq = window._paq || [];
	window._paq.push(['enableLinkTracking']);
	if (this.trackerUrl) {
		window._paq.push(['setTrackerUrl', this.trackerUrl]);
	}
	if (this.siteId) {
		window._paq.push(['setSiteId', this.siteId]);
	}
	var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
	g.async = true; 
	g.src = this.scriptUrl; 
	s.parentNode.insertBefore(g, s);

	_matomoTrackerLoaded = true;

};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} url   The URL of the page viewed
 * @param  {String} title The page title
 * @author Andreï Cavoleau
 */
MatomoTracker.prototype.trackPage = function (page, url, title) {
	window._paq.push(['setCustomUrl', url]);
	window._paq.push(['setDocumentTitle', title]);
	window._paq.push(['trackPageView']);
};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Andreï Cavoleau
 */
MatomoTracker.prototype.trackEvent = function (category, action, label, value) {
	window._paq.push(['trackEvent', category, action, label, value]);
};

module.exports = MatomoTracker;


/***/ }),
/* 788 */
/***/ (function(module, exports) {

var _webTrendsTrackerLoaded = false;

/**
 * An object to manage WebTrends Analytics as a TrackerManager plugin
 * @constructs WebTrendsTracker
 * @memberof Class
 * @author Alessandro Cipolletti
 */
function WebTrendsTracker(serverConfNode) {

	this.account = serverConfNode.id;
	this.domain = serverConfNode.domain;
	this.url = serverConfNode.url;

	this.loadTracker();

}

WebTrendsTracker.prototype.isLoaded = function () {
	return _webTrendsTrackerLoaded;
}

/**
 * Load the analytics tracker
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.loadTracker = function () {

	if (_webTrendsTrackerLoaded) {
		return;
	}

	window.webtrendsAsyncInit = WebTrendsTracker.prototype.init.bind({}, {
		account: this.account,
		domain: this.domain
	});

	var g = document.createElement("script");
	var s = document.getElementsByTagName("script")[0];
	g.type = "text/javascript";
	g.async = true;
	g.defer = true;
	g.onload = function () {
		_webTrendsTrackerLoaded = true;
	};
	g.src = this.url + "webtrends.min.js";
	s.parentNode.insertBefore(g, s);

};

/**
 * Init Webtrends dcs track object
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.init = function (config) {

	window.dcs = new Webtrends.dcs().init({
		dcsid: config.account,
		dcsdelay: 20,
		delayAll: true,
		domain: config.domain,
		enabled: true,
		preserve: false,
		timezone: -5,
		i18n: true,
		adimpressions: true,
		adsparam: "WT.ac",
		offsite: true,
		download: true,
		downloadtypes: "xls,doc,pdf,txt,csv,zip,docx,xlsx,rar,gzip",
		anchor: true,
		javascript: true,
		onsitedoms: 'uat-www.ds.ssga.com',
		plugins: {
			facebook: {
				src: "//s.webtrends.com/js/webtrends.fb.js"
			},
			yt: {
				src: "//s.webtrends.com/js/webtrends.yt.js"
			}
		}
	}).track();

};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.trackPage = function (page, url, title) {

	dcsMultiTrackIfExists(url, title, 0, 5);

	// dcsMultiTrack("DCS.dcsuri", url, "WT.ti", title, "WT.dl", 0);
	

};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.trackEvent = function (category, action, label, value) {
	dcsMultiTrackIfExists(action, label, 20, 5);
};

// Needed because the first stat call is done too soon
function dcsMultiTrackIfExists( type, name, code, triesLeft ) {
	if (window.dcsMultiTrack !== undefined) {
		dcsMultiTrack("DCS.dcsuri", type, "WT.ti", name, "WT.dl", code);
		return;
	}
	if (triesLeft > 0) {
		setTimeout(function(){
			dcsMultiTrackIfExists(type, name, code, triesLeft - 1);
		}, 2000);
	}
}

module.exports = WebTrendsTracker;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

var _xitiTrackerLoaded = false;

/**
* An object to manage Xiti Analytics as a TrackerManager plugin
* @constructs XitiTracker
* @memberof Class
* @author Alessandro Cipolletti
*/
function XitiTracker(serverConfNode) {
	var _self = this;
	
	_self.trackerUrl = serverConfNode.url;
	_self.loadTracker();
}

XitiTracker.prototype.isLoaded = function () {
	return _xitiTrackerLoaded;
}

/**
* Load the analytics tracker
* @author Alessandro Cipolletti
*/
XitiTracker.prototype.loadTracker = function () {
	var _self = this;
	
	if (_xitiTrackerLoaded) {
		_self.tag = new ATInternet.Tracker.Tag();
		return;
	}
	
	// Inclusion du script Xiti
	var script = document.createElement("script");
	script.setAttribute("type", "text/javascript");
	script.onload = function () {
		_self.tag = new ATInternet.Tracker.Tag();
		_xitiTrackerLoaded = true;
	};
	script.src = this.trackerUrl;
	document.head.appendChild(script);
	

};

/**
* Track a page view
* @param  {String} page  The page code name viewed
* @param  {String} hash  The hash of the page viewed
* @param  {String} title The page title
* @author Alessandro Cipolletti
*/
XitiTracker.prototype.trackPage = function (page, url, title) {
	this.tag.page.send({
		name: page,
		customObject: {
			page: page,
			url: url,
			title: title
		}
	});
};

/**
* Track a page event
* @param  {String}  category The event category
* @param  {String}  action   The event name
* @param  {String}  label    The action label
* @param  {integer} value    A complementary figure
* @author Alessandro Cipolletti
*/
XitiTracker.prototype.trackEvent = function (category, action, label, value) {
	this.tag.click.send({
		type: category,
		customObject: {
			category: category,
			action: action,
			label: label,
			value: value
		}
	});
};

module.exports = XitiTracker;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

var _googleTagTrackerLoaded = false;

/**
 * An object to manage Google Tag as a TrackerManager plugin
 * @constructs GoogleTagTracker
 * @memberof Class
 * @author Andreï Cavoleau
 */
function GoogleTagTracker(config) {
	this.account = config.account;
	this.anonymize = config.anonymize === 'true';

	// The tracker name should be only lowercase chars and numbers
	this.trackerName = 'tracker' + this.account.replace(/-/gi, '').toLowerCase();
	this.loadTracker();
}

GoogleTagTracker.prototype.isLoaded = function () {
	return _googleTagTrackerLoaded;
}

/**
 * Load the googleTag tracker
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.loadTracker = function () {
	if (_googleTagTrackerLoaded) {
		return;
	}

	var libraryUrl = (this.anonymize ?
		'https://gtm.zone-secure.net/gtag/js?id=' :
		'https://www.googletagmanager.com/gtag/js?id=') + this.account;

	var s = document.createElement("script");
	s.src = libraryUrl;
	s.setAttribute('async', '');
	document.head.append(s);

	window.dataLayer = window.dataLayer || [];

	// Firebase Tracking
	this.logEvent = function (name, params) {
		if (!name) {
			return;
		}

		if (window.AnalyticsWebInterface) {
			// Call Android interface
			window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
		} else if (window.webkit &&
			window.webkit.messageHandlers &&
			window.webkit.messageHandlers.firebase) {
			// Call iOS interface
			var message = {
				command: 'logEvent',
				name: name,
				parameters: params
			};
			window.webkit.messageHandlers.firebase.postMessage(message);
		} else {
			// No Android or iOS interface found
		}
	}

	this.setUserProperty = function (name, value) {
		if (!name || !value) {
			return;
		}

		if (window.AnalyticsWebInterface) {
			// Call Android interface
			window.AnalyticsWebInterface.setUserProperty(name, value);
		} else if (window.webkit &&
			window.webkit.messageHandlers &&
			window.webkit.messageHandlers.firebase) {
			// Call iOS interface
			var message = {
				command: 'setUserProperty',
				name: name,
				value: value
			};
			window.webkit.messageHandlers.firebase.postMessage(message);
		} else {
			// No Android or iOS interface found
		}
	}

	this.gtag = function () {
		dataLayer.push(arguments);
		switch (arguments[0]) {
			case 'set':
				var params = arguments[2];
				if (params) {
					Object.keys(params).forEach(function (name) {
						this.setUserProperty(name, params[name]);
					}.bind(this));
				}
				break;
			case 'event':
				this.logEvent(arguments[1], arguments[2]);
				break;
		}
	}

	this.gtag('js', new Date());

	this.createTracker();

	_googleTagTrackerLoaded = true;
};

/**
 * Create the analytics tracker
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.createTracker = function () {
	// To use the GA4 Debug View add the following property to the parameters object - debug_mode: true,
	this.gtag('config', this.account, {
		send_page_view: false,
		anonymize_ip: this.anonymize,
	});
};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.trackPage = function (page, url, title) {
	this.gtag('event', 'page_view', {
		page_title: title,
		page_location: url,
		page_path: page,
		send_to: this.account
	});
};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Andreï Cavoleau
 */
GoogleTagTracker.prototype.trackEvent = function (category, action, label, value) {
	this.gtag('event', category, {
		'wpAction': action,
		'wpLabel': label,
		'wpValue': value
	});

};

GoogleTagTracker.prototype.trackProperty = function (name, value) {
	var params = {};
	params[name] = value;
	this.gtag('set', 'user_properties', params);
};

module.exports = GoogleTagTracker;


/***/ }),
/* 791 */
/***/ (function(module, exports) {

var PianoTrackerStatus = {
	NOT_LOADED: 'NOT_LOADED',
	LOADING: 'LOADING',
	LOADED: 'LOADED',
};
var _pianoTrackerStatus = PianoTrackerStatus.NOT_LOADED;

/**
 * An object to manage Piano Analytics as a TrackerManager plugin
 * @constructs PianoTracker
 * @memberof Class
 * @author Andreï Cavoleau
 */
function PianoTracker(serverConfNode) {
	this.onScriptLoad = this.onScriptLoad.bind(this);

	this.siteId = serverConfNode.id;
	this.collectDomain = serverConfNode.collectDomain;
	this.loadTracker();
}

function isPaLoaded() {
	if (!window.pa) {
		console.error("Piano Analytics's pa global variable is not loaded");
		return false;
	}
	return true;
}

PianoTracker.prototype.isLoaded = function () {
	return _pianoTrackerStatus === PianoTrackerStatus.LOADED;
};

/**
 * Load the analytics tracker
 * @author Andreï Cavoleau
 */
PianoTracker.prototype.loadTracker = function () {
	if (_pianoTrackerStatus !== PianoTrackerStatus.NOT_LOADED) {
		return;
	}
	_pianoTrackerStatus = PianoTrackerStatus.LOADING;
	// Inclusion du script Piano
	var script = document.createElement("script");
	script.setAttribute("type", "text/javascript");
	script.onload = this.onScriptLoad;
	script.src = 'https://tag.aticdn.net/piano-analytics.js';
	document.head.appendChild(script);

};

PianoTracker.prototype.onScriptLoad = function () {
	_pianoTrackerStatus = PianoTrackerStatus.LOADED;
	if (!isPaLoaded()) {
		return;
	}
	window.pa.setConfigurations({
		site: this.siteId,
		collectDomain: this.collectDomain,
	});
};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Andreï Cavoleau
 */
PianoTracker.prototype.trackPage = function (page, url, title) {
	if (!isPaLoaded()) {
		return;
	}
	window.pa.sendEvent('page.display', {
		page: title,
		url: url,
		wp_publication_path: page,
	});
};

/**
 * Track a page event
 * @param  {String}  wp_category The event category
 * @param  {String}  wp_action   The event name
 * @param  {String}  wp_label    The action label
 * @param  {integer} wp_value    A complementary figure
 * @author Andreï Cavoleau
 */
PianoTracker.prototype.trackEvent = function (wp_category, wp_action, wp_label, wp_value) {
	if (!isPaLoaded()) {
		return;
	}
	window.pa.sendEvent('wp_event', {
		wp_category: wp_category,
		wp_action: wp_action,
		wp_label: wp_label,
		wp_value: wp_value,
	});

};

module.exports = PianoTracker;

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackingType; });
var TrackingType;
(function (TrackingType) {
    TrackingType["Page"] = "Page";
    TrackingType["Event"] = "Event";
    TrackingType["Property"] = "Property";
})(TrackingType || (TrackingType = {}));


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var builder, defaults, parser, processors,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  defaults = __webpack_require__(290);

  builder = __webpack_require__(794);

  parser = __webpack_require__(799);

  processors = __webpack_require__(441);

  exports.defaults = defaults.defaults;

  exports.processors = processors;

  exports.ValidationError = (function(superClass) {
    extend(ValidationError, superClass);

    function ValidationError(message) {
      this.message = message;
    }

    return ValidationError;

  })(Error);

  exports.Builder = builder.Builder;

  exports.Parser = parser.Parser;

  exports.parseString = parser.parseString;

}).call(this);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var builder, defaults, escapeCDATA, requiresCDATA, wrapCDATA,
    hasProp = {}.hasOwnProperty;

  builder = __webpack_require__(795);

  defaults = __webpack_require__(290).defaults;

  requiresCDATA = function(entry) {
    return typeof entry === "string" && (entry.indexOf('&') >= 0 || entry.indexOf('>') >= 0 || entry.indexOf('<') >= 0);
  };

  wrapCDATA = function(entry) {
    return "<![CDATA[" + (escapeCDATA(entry)) + "]]>";
  };

  escapeCDATA = function(entry) {
    return entry.replace(']]>', ']]]]><![CDATA[>');
  };

  exports.Builder = (function() {
    function Builder(opts) {
      var key, ref, value;
      this.options = {};
      ref = defaults["0.2"];
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this.options[key] = value;
      }
      for (key in opts) {
        if (!hasProp.call(opts, key)) continue;
        value = opts[key];
        this.options[key] = value;
      }
    }

    Builder.prototype.buildObject = function(rootObj) {
      var attrkey, charkey, render, rootElement, rootName;
      attrkey = this.options.attrkey;
      charkey = this.options.charkey;
      if ((Object.keys(rootObj).length === 1) && (this.options.rootName === defaults['0.2'].rootName)) {
        rootName = Object.keys(rootObj)[0];
        rootObj = rootObj[rootName];
      } else {
        rootName = this.options.rootName;
      }
      render = (function(_this) {
        return function(element, obj) {
          var attr, child, entry, index, key, value;
          if (typeof obj !== 'object') {
            if (_this.options.cdata && requiresCDATA(obj)) {
              element.raw(wrapCDATA(obj));
            } else {
              element.txt(obj);
            }
          } else if (Array.isArray(obj)) {
            for (index in obj) {
              if (!hasProp.call(obj, index)) continue;
              child = obj[index];
              for (key in child) {
                entry = child[key];
                element = render(element.ele(key), entry).up();
              }
            }
          } else {
            for (key in obj) {
              if (!hasProp.call(obj, key)) continue;
              child = obj[key];
              if (key === attrkey) {
                if (typeof child === "object") {
                  for (attr in child) {
                    value = child[attr];
                    element = element.att(attr, value);
                  }
                }
              } else if (key === charkey) {
                if (_this.options.cdata && requiresCDATA(child)) {
                  element = element.raw(wrapCDATA(child));
                } else {
                  element = element.txt(child);
                }
              } else if (Array.isArray(child)) {
                for (index in child) {
                  if (!hasProp.call(child, index)) continue;
                  entry = child[index];
                  if (typeof entry === 'string') {
                    if (_this.options.cdata && requiresCDATA(entry)) {
                      element = element.ele(key).raw(wrapCDATA(entry)).up();
                    } else {
                      element = element.ele(key, entry).up();
                    }
                  } else {
                    element = render(element.ele(key), entry).up();
                  }
                }
              } else if (typeof child === "object") {
                element = render(element.ele(key), child).up();
              } else {
                if (typeof child === 'string' && _this.options.cdata && requiresCDATA(child)) {
                  element = element.ele(key).raw(wrapCDATA(child)).up();
                } else {
                  if (child == null) {
                    child = '';
                  }
                  element = element.ele(key, child.toString()).up();
                }
              }
            }
          }
          return element;
        };
      })(this);
      rootElement = builder.create(rootName, this.options.xmldec, this.options.doctype, {
        headless: this.options.headless,
        allowSurrogateChars: this.options.allowSurrogateChars
      });
      return render(rootElement, rootObj).end(this.options.renderOpts);
    };

    return Builder;

  })();

}).call(this);


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;

  ref = __webpack_require__(94), assign = ref.assign, isFunction = ref.isFunction;

  XMLDocument = __webpack_require__(796);

  XMLDocumentCB = __webpack_require__(797);

  XMLStringWriter = __webpack_require__(291);

  XMLStreamWriter = __webpack_require__(798);

  module.exports.create = function(name, xmldec, doctype, options) {
    var doc, root;
    if (name == null) {
      throw new Error("Root element needs a name");
    }
    options = assign({}, xmldec, doctype, options);
    doc = new XMLDocument(options);
    root = doc.element(name);
    if (!options.headless) {
      doc.declaration(options);
      if ((options.pubID != null) || (options.sysID != null)) {
        doc.doctype(options);
      }
    }
    return root;
  };

  module.exports.begin = function(options, onData, onEnd) {
    var ref1;
    if (isFunction(options)) {
      ref1 = [options, onData], onData = ref1[0], onEnd = ref1[1];
      options = {};
    }
    if (onData) {
      return new XMLDocumentCB(options, onData, onEnd);
    } else {
      return new XMLDocument(options);
    }
  };

  module.exports.stringWriter = function(options) {
    return new XMLStringWriter(options);
  };

  module.exports.streamWriter = function(stream, options) {
    return new XMLStreamWriter(stream, options);
  };

}).call(this);


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isPlainObject = __webpack_require__(94).isPlainObject;

  XMLNode = __webpack_require__(52);

  XMLStringifier = __webpack_require__(434);

  XMLStringWriter = __webpack_require__(291);

  module.exports = XMLDocument = (function(superClass) {
    extend(XMLDocument, superClass);

    function XMLDocument(options) {
      XMLDocument.__super__.constructor.call(this, null);
      options || (options = {});
      if (!options.writer) {
        options.writer = new XMLStringWriter();
      }
      this.options = options;
      this.stringify = new XMLStringifier(options);
      this.isDocument = true;
    }

    XMLDocument.prototype.end = function(writer) {
      var writerOptions;
      if (!writer) {
        writer = this.options.writer;
      } else if (isPlainObject(writer)) {
        writerOptions = writer;
        writer = this.options.writer.set(writerOptions);
      }
      return writer.document(this);
    };

    XMLDocument.prototype.toString = function(options) {
      return this.options.writer.set(options).document(this);
    };

    return XMLDocument;

  })(XMLNode);

}).call(this);


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, isFunction, isObject, isPlainObject, ref,
    hasProp = {}.hasOwnProperty;

  ref = __webpack_require__(94), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject;

  XMLElement = __webpack_require__(201);

  XMLCData = __webpack_require__(202);

  XMLComment = __webpack_require__(203);

  XMLRaw = __webpack_require__(210);

  XMLText = __webpack_require__(211);

  XMLProcessingInstruction = __webpack_require__(212);

  XMLDeclaration = __webpack_require__(204);

  XMLDocType = __webpack_require__(205);

  XMLDTDAttList = __webpack_require__(206);

  XMLDTDEntity = __webpack_require__(207);

  XMLDTDElement = __webpack_require__(208);

  XMLDTDNotation = __webpack_require__(209);

  XMLAttribute = __webpack_require__(433);

  XMLStringifier = __webpack_require__(434);

  XMLStringWriter = __webpack_require__(291);

  module.exports = XMLDocumentCB = (function() {
    function XMLDocumentCB(options, onData, onEnd) {
      var writerOptions;
      options || (options = {});
      if (!options.writer) {
        options.writer = new XMLStringWriter(options);
      } else if (isPlainObject(options.writer)) {
        writerOptions = options.writer;
        options.writer = new XMLStringWriter(writerOptions);
      }
      this.options = options;
      this.writer = options.writer;
      this.stringify = new XMLStringifier(options);
      this.onDataCallback = onData || function() {};
      this.onEndCallback = onEnd || function() {};
      this.currentNode = null;
      this.currentLevel = -1;
      this.openTags = {};
      this.documentStarted = false;
      this.documentCompleted = false;
      this.root = null;
    }

    XMLDocumentCB.prototype.node = function(name, attributes, text) {
      var ref1;
      if (name == null) {
        throw new Error("Missing node name");
      }
      if (this.root && this.currentLevel === -1) {
        throw new Error("Document can only have one root node");
      }
      this.openCurrent();
      name = name.valueOf();
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      this.currentNode = new XMLElement(this, name, attributes);
      this.currentNode.children = false;
      this.currentLevel++;
      this.openTags[this.currentLevel] = this.currentNode;
      if (text != null) {
        this.text(text);
      }
      return this;
    };

    XMLDocumentCB.prototype.element = function(name, attributes, text) {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.dtdElement.apply(this, arguments);
      } else {
        return this.node(name, attributes, text);
      }
    };

    XMLDocumentCB.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (!this.currentNode || this.currentNode.children) {
        throw new Error("att() can only be used immediately after an ele() call in callback mode");
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLDocumentCB.prototype.text = function(value) {
      var node;
      this.openCurrent();
      node = new XMLText(this, value);
      this.onData(this.writer.text(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.cdata = function(value) {
      var node;
      this.openCurrent();
      node = new XMLCData(this, value);
      this.onData(this.writer.cdata(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.comment = function(value) {
      var node;
      this.openCurrent();
      node = new XMLComment(this, value);
      this.onData(this.writer.comment(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.raw = function(value) {
      var node;
      this.openCurrent();
      node = new XMLRaw(this, value);
      this.onData(this.writer.raw(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.instruction = function(target, value) {
      var i, insTarget, insValue, len, node;
      this.openCurrent();
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (i = 0, len = target.length; i < len; i++) {
          insTarget = target[i];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        node = new XMLProcessingInstruction(this, target, value);
        this.onData(this.writer.processingInstruction(node, this.currentLevel + 1));
      }
      return this;
    };

    XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
      var node;
      this.openCurrent();
      if (this.documentStarted) {
        throw new Error("declaration() must be the first node");
      }
      node = new XMLDeclaration(this, version, encoding, standalone);
      this.onData(this.writer.declaration(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
      this.openCurrent();
      if (root == null) {
        throw new Error("Missing root node name");
      }
      if (this.root) {
        throw new Error("dtd() must come before the root node");
      }
      this.currentNode = new XMLDocType(this, pubID, sysID);
      this.currentNode.rootNodeName = root;
      this.currentNode.children = false;
      this.currentLevel++;
      this.openTags[this.currentLevel] = this.currentNode;
      return this;
    };

    XMLDocumentCB.prototype.dtdElement = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDElement(this, name, value);
      this.onData(this.writer.dtdElement(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var node;
      this.openCurrent();
      node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.onData(this.writer.dtdAttList(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.entity = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDEntity(this, false, name, value);
      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.pEntity = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDEntity(this, true, name, value);
      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.notation = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDNotation(this, name, value);
      this.onData(this.writer.dtdNotation(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.up = function() {
      if (this.currentLevel < 0) {
        throw new Error("The document node has no parent");
      }
      if (this.currentNode) {
        if (this.currentNode.children) {
          this.closeNode(this.currentNode);
        } else {
          this.openNode(this.currentNode);
        }
        this.currentNode = null;
      } else {
        this.closeNode(this.openTags[this.currentLevel]);
      }
      delete this.openTags[this.currentLevel];
      this.currentLevel--;
      return this;
    };

    XMLDocumentCB.prototype.end = function() {
      while (this.currentLevel >= 0) {
        this.up();
      }
      return this.onEnd();
    };

    XMLDocumentCB.prototype.openCurrent = function() {
      if (this.currentNode) {
        this.currentNode.children = true;
        return this.openNode(this.currentNode);
      }
    };

    XMLDocumentCB.prototype.openNode = function(node) {
      if (!node.isOpen) {
        if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) {
          this.root = node;
        }
        this.onData(this.writer.openNode(node, this.currentLevel));
        return node.isOpen = true;
      }
    };

    XMLDocumentCB.prototype.closeNode = function(node) {
      if (!node.isClosed) {
        this.onData(this.writer.closeNode(node, this.currentLevel));
        return node.isClosed = true;
      }
    };

    XMLDocumentCB.prototype.onData = function(chunk) {
      this.documentStarted = true;
      return this.onDataCallback(chunk);
    };

    XMLDocumentCB.prototype.onEnd = function() {
      this.documentCompleted = true;
      return this.onEndCallback();
    };

    XMLDocumentCB.prototype.ele = function() {
      return this.element.apply(this, arguments);
    };

    XMLDocumentCB.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLDocumentCB.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLDocumentCB.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLDocumentCB.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLDocumentCB.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
      return this.doctype(root, pubID, sysID);
    };

    XMLDocumentCB.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLDocumentCB.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLDocumentCB.prototype.t = function(value) {
      return this.text(value);
    };

    XMLDocumentCB.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLDocumentCB.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLDocumentCB.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLDocumentCB.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocumentCB.prototype.att = function() {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.attList.apply(this, arguments);
      } else {
        return this.attribute.apply(this, arguments);
      }
    };

    XMLDocumentCB.prototype.a = function() {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.attList.apply(this, arguments);
      } else {
        return this.attribute.apply(this, arguments);
      }
    };

    XMLDocumentCB.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocumentCB.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocumentCB.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    return XMLDocumentCB;

  })();

}).call(this);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLDeclaration = __webpack_require__(204);

  XMLDocType = __webpack_require__(205);

  XMLCData = __webpack_require__(202);

  XMLComment = __webpack_require__(203);

  XMLElement = __webpack_require__(201);

  XMLRaw = __webpack_require__(210);

  XMLText = __webpack_require__(211);

  XMLProcessingInstruction = __webpack_require__(212);

  XMLDTDAttList = __webpack_require__(206);

  XMLDTDElement = __webpack_require__(208);

  XMLDTDEntity = __webpack_require__(207);

  XMLDTDNotation = __webpack_require__(209);

  XMLWriterBase = __webpack_require__(435);

  module.exports = XMLStreamWriter = (function(superClass) {
    extend(XMLStreamWriter, superClass);

    function XMLStreamWriter(stream, options) {
      XMLStreamWriter.__super__.constructor.call(this, options);
      this.stream = stream;
    }

    XMLStreamWriter.prototype.document = function(doc) {
      var child, i, j, len, len1, ref, ref1, results;
      ref = doc.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        child.isLastRootNode = false;
      }
      doc.children[doc.children.length - 1].isLastRootNode = true;
      ref1 = doc.children;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        child = ref1[j];
        switch (false) {
          case !(child instanceof XMLDeclaration):
            results.push(this.declaration(child));
            break;
          case !(child instanceof XMLDocType):
            results.push(this.docType(child));
            break;
          case !(child instanceof XMLComment):
            results.push(this.comment(child));
            break;
          case !(child instanceof XMLProcessingInstruction):
            results.push(this.processingInstruction(child));
            break;
          default:
            results.push(this.element(child));
        }
      }
      return results;
    };

    XMLStreamWriter.prototype.attribute = function(att) {
      return this.stream.write(' ' + att.name + '="' + att.value + '"');
    };

    XMLStreamWriter.prototype.cdata = function(node, level) {
      return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
    };

    XMLStreamWriter.prototype.comment = function(node, level) {
      return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
    };

    XMLStreamWriter.prototype.declaration = function(node, level) {
      this.stream.write(this.space(level));
      this.stream.write('<?xml version="' + node.version + '"');
      if (node.encoding != null) {
        this.stream.write(' encoding="' + node.encoding + '"');
      }
      if (node.standalone != null) {
        this.stream.write(' standalone="' + node.standalone + '"');
      }
      this.stream.write(this.spacebeforeslash + '?>');
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.docType = function(node, level) {
      var child, i, len, ref;
      level || (level = 0);
      this.stream.write(this.space(level));
      this.stream.write('<!DOCTYPE ' + node.root().name);
      if (node.pubID && node.sysID) {
        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
      } else if (node.sysID) {
        this.stream.write(' SYSTEM "' + node.sysID + '"');
      }
      if (node.children.length > 0) {
        this.stream.write(' [');
        this.stream.write(this.endline(node));
        ref = node.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          switch (false) {
            case !(child instanceof XMLDTDAttList):
              this.dtdAttList(child, level + 1);
              break;
            case !(child instanceof XMLDTDElement):
              this.dtdElement(child, level + 1);
              break;
            case !(child instanceof XMLDTDEntity):
              this.dtdEntity(child, level + 1);
              break;
            case !(child instanceof XMLDTDNotation):
              this.dtdNotation(child, level + 1);
              break;
            case !(child instanceof XMLCData):
              this.cdata(child, level + 1);
              break;
            case !(child instanceof XMLComment):
              this.comment(child, level + 1);
              break;
            case !(child instanceof XMLProcessingInstruction):
              this.processingInstruction(child, level + 1);
              break;
            default:
              throw new Error("Unknown DTD node type: " + child.constructor.name);
          }
        }
        this.stream.write(']');
      }
      this.stream.write(this.spacebeforeslash + '>');
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.element = function(node, level) {
      var att, child, i, len, name, ref, ref1, space;
      level || (level = 0);
      space = this.space(level);
      this.stream.write(space + '<' + node.name);
      ref = node.attributes;
      for (name in ref) {
        if (!hasProp.call(ref, name)) continue;
        att = ref[name];
        this.attribute(att);
      }
      if (node.children.length === 0 || node.children.every(function(e) {
        return e.value === '';
      })) {
        if (this.allowEmpty) {
          this.stream.write('></' + node.name + '>');
        } else {
          this.stream.write(this.spacebeforeslash + '/>');
        }
      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
        this.stream.write('>');
        this.stream.write(node.children[0].value);
        this.stream.write('</' + node.name + '>');
      } else {
        this.stream.write('>' + this.newline);
        ref1 = node.children;
        for (i = 0, len = ref1.length; i < len; i++) {
          child = ref1[i];
          switch (false) {
            case !(child instanceof XMLCData):
              this.cdata(child, level + 1);
              break;
            case !(child instanceof XMLComment):
              this.comment(child, level + 1);
              break;
            case !(child instanceof XMLElement):
              this.element(child, level + 1);
              break;
            case !(child instanceof XMLRaw):
              this.raw(child, level + 1);
              break;
            case !(child instanceof XMLText):
              this.text(child, level + 1);
              break;
            case !(child instanceof XMLProcessingInstruction):
              this.processingInstruction(child, level + 1);
              break;
            default:
              throw new Error("Unknown XML node type: " + child.constructor.name);
          }
        }
        this.stream.write(space + '</' + node.name + '>');
      }
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.processingInstruction = function(node, level) {
      this.stream.write(this.space(level) + '<?' + node.target);
      if (node.value) {
        this.stream.write(' ' + node.value);
      }
      return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
    };

    XMLStreamWriter.prototype.raw = function(node, level) {
      return this.stream.write(this.space(level) + node.value + this.endline(node));
    };

    XMLStreamWriter.prototype.text = function(node, level) {
      return this.stream.write(this.space(level) + node.value + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdAttList = function(node, level) {
      this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
      if (node.defaultValueType !== '#DEFAULT') {
        this.stream.write(' ' + node.defaultValueType);
      }
      if (node.defaultValue) {
        this.stream.write(' "' + node.defaultValue + '"');
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdElement = function(node, level) {
      this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdEntity = function(node, level) {
      this.stream.write(this.space(level) + '<!ENTITY');
      if (node.pe) {
        this.stream.write(' %');
      }
      this.stream.write(' ' + node.name);
      if (node.value) {
        this.stream.write(' "' + node.value + '"');
      } else {
        if (node.pubID && node.sysID) {
          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
        } else if (node.sysID) {
          this.stream.write(' SYSTEM "' + node.sysID + '"');
        }
        if (node.nData) {
          this.stream.write(' NDATA ' + node.nData);
        }
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdNotation = function(node, level) {
      this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
      if (node.pubID && node.sysID) {
        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
      } else if (node.pubID) {
        this.stream.write(' PUBLIC "' + node.pubID + '"');
      } else if (node.sysID) {
        this.stream.write(' SYSTEM "' + node.sysID + '"');
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.endline = function(node) {
      if (!node.isLastRootNode) {
        return this.newline;
      } else {
        return '';
      }
    };

    return XMLStreamWriter;

  })(XMLWriterBase);

}).call(this);


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var bom, defaults, events, isEmpty, processItem, processors, sax, setImmediate,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  sax = __webpack_require__(800);

  events = __webpack_require__(214);

  bom = __webpack_require__(813);

  processors = __webpack_require__(441);

  setImmediate = __webpack_require__(288).setImmediate;

  defaults = __webpack_require__(290).defaults;

  isEmpty = function(thing) {
    return typeof thing === "object" && (thing != null) && Object.keys(thing).length === 0;
  };

  processItem = function(processors, item, key) {
    var i, len, process;
    for (i = 0, len = processors.length; i < len; i++) {
      process = processors[i];
      item = process(item, key);
    }
    return item;
  };

  exports.Parser = (function(superClass) {
    extend(Parser, superClass);

    function Parser(opts) {
      this.parseString = bind(this.parseString, this);
      this.reset = bind(this.reset, this);
      this.assignOrPush = bind(this.assignOrPush, this);
      this.processAsync = bind(this.processAsync, this);
      var key, ref, value;
      if (!(this instanceof exports.Parser)) {
        return new exports.Parser(opts);
      }
      this.options = {};
      ref = defaults["0.2"];
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this.options[key] = value;
      }
      for (key in opts) {
        if (!hasProp.call(opts, key)) continue;
        value = opts[key];
        this.options[key] = value;
      }
      if (this.options.xmlns) {
        this.options.xmlnskey = this.options.attrkey + "ns";
      }
      if (this.options.normalizeTags) {
        if (!this.options.tagNameProcessors) {
          this.options.tagNameProcessors = [];
        }
        this.options.tagNameProcessors.unshift(processors.normalize);
      }
      this.reset();
    }

    Parser.prototype.processAsync = function() {
      var chunk, err;
      try {
        if (this.remaining.length <= this.options.chunkSize) {
          chunk = this.remaining;
          this.remaining = '';
          this.saxParser = this.saxParser.write(chunk);
          return this.saxParser.close();
        } else {
          chunk = this.remaining.substr(0, this.options.chunkSize);
          this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length);
          this.saxParser = this.saxParser.write(chunk);
          return setImmediate(this.processAsync);
        }
      } catch (error1) {
        err = error1;
        if (!this.saxParser.errThrown) {
          this.saxParser.errThrown = true;
          return this.emit(err);
        }
      }
    };

    Parser.prototype.assignOrPush = function(obj, key, newValue) {
      if (!(key in obj)) {
        if (!this.options.explicitArray) {
          return obj[key] = newValue;
        } else {
          return obj[key] = [newValue];
        }
      } else {
        if (!(obj[key] instanceof Array)) {
          obj[key] = [obj[key]];
        }
        return obj[key].push(newValue);
      }
    };

    Parser.prototype.reset = function() {
      var attrkey, charkey, ontext, stack;
      this.removeAllListeners();
      this.saxParser = sax.parser(this.options.strict, {
        trim: false,
        normalize: false,
        xmlns: this.options.xmlns
      });
      this.saxParser.errThrown = false;
      this.saxParser.onerror = (function(_this) {
        return function(error) {
          _this.saxParser.resume();
          if (!_this.saxParser.errThrown) {
            _this.saxParser.errThrown = true;
            return _this.emit("error", error);
          }
        };
      })(this);
      this.saxParser.onend = (function(_this) {
        return function() {
          if (!_this.saxParser.ended) {
            _this.saxParser.ended = true;
            return _this.emit("end", _this.resultObject);
          }
        };
      })(this);
      this.saxParser.ended = false;
      this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
      this.resultObject = null;
      stack = [];
      attrkey = this.options.attrkey;
      charkey = this.options.charkey;
      this.saxParser.onopentag = (function(_this) {
        return function(node) {
          var key, newValue, obj, processedKey, ref;
          obj = {};
          obj[charkey] = "";
          if (!_this.options.ignoreAttrs) {
            ref = node.attributes;
            for (key in ref) {
              if (!hasProp.call(ref, key)) continue;
              if (!(attrkey in obj) && !_this.options.mergeAttrs) {
                obj[attrkey] = {};
              }
              newValue = _this.options.attrValueProcessors ? processItem(_this.options.attrValueProcessors, node.attributes[key], key) : node.attributes[key];
              processedKey = _this.options.attrNameProcessors ? processItem(_this.options.attrNameProcessors, key) : key;
              if (_this.options.mergeAttrs) {
                _this.assignOrPush(obj, processedKey, newValue);
              } else {
                obj[attrkey][processedKey] = newValue;
              }
            }
          }
          obj["#name"] = _this.options.tagNameProcessors ? processItem(_this.options.tagNameProcessors, node.name) : node.name;
          if (_this.options.xmlns) {
            obj[_this.options.xmlnskey] = {
              uri: node.uri,
              local: node.local
            };
          }
          return stack.push(obj);
        };
      })(this);
      this.saxParser.onclosetag = (function(_this) {
        return function() {
          var cdata, emptyStr, key, node, nodeName, obj, objClone, old, s, xpath;
          obj = stack.pop();
          nodeName = obj["#name"];
          if (!_this.options.explicitChildren || !_this.options.preserveChildrenOrder) {
            delete obj["#name"];
          }
          if (obj.cdata === true) {
            cdata = obj.cdata;
            delete obj.cdata;
          }
          s = stack[stack.length - 1];
          if (obj[charkey].match(/^\s*$/) && !cdata) {
            emptyStr = obj[charkey];
            delete obj[charkey];
          } else {
            if (_this.options.trim) {
              obj[charkey] = obj[charkey].trim();
            }
            if (_this.options.normalize) {
              obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
            }
            obj[charkey] = _this.options.valueProcessors ? processItem(_this.options.valueProcessors, obj[charkey], nodeName) : obj[charkey];
            if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
              obj = obj[charkey];
            }
          }
          if (isEmpty(obj)) {
            obj = _this.options.emptyTag !== '' ? _this.options.emptyTag : emptyStr;
          }
          if (_this.options.validator != null) {
            xpath = "/" + ((function() {
              var i, len, results;
              results = [];
              for (i = 0, len = stack.length; i < len; i++) {
                node = stack[i];
                results.push(node["#name"]);
              }
              return results;
            })()).concat(nodeName).join("/");
            (function() {
              var err;
              try {
                return obj = _this.options.validator(xpath, s && s[nodeName], obj);
              } catch (error1) {
                err = error1;
                return _this.emit("error", err);
              }
            })();
          }
          if (_this.options.explicitChildren && !_this.options.mergeAttrs && typeof obj === 'object') {
            if (!_this.options.preserveChildrenOrder) {
              node = {};
              if (_this.options.attrkey in obj) {
                node[_this.options.attrkey] = obj[_this.options.attrkey];
                delete obj[_this.options.attrkey];
              }
              if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
                node[_this.options.charkey] = obj[_this.options.charkey];
                delete obj[_this.options.charkey];
              }
              if (Object.getOwnPropertyNames(obj).length > 0) {
                node[_this.options.childkey] = obj;
              }
              obj = node;
            } else if (s) {
              s[_this.options.childkey] = s[_this.options.childkey] || [];
              objClone = {};
              for (key in obj) {
                if (!hasProp.call(obj, key)) continue;
                objClone[key] = obj[key];
              }
              s[_this.options.childkey].push(objClone);
              delete obj["#name"];
              if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
                obj = obj[charkey];
              }
            }
          }
          if (stack.length > 0) {
            return _this.assignOrPush(s, nodeName, obj);
          } else {
            if (_this.options.explicitRoot) {
              old = obj;
              obj = {};
              obj[nodeName] = old;
            }
            _this.resultObject = obj;
            _this.saxParser.ended = true;
            return _this.emit("end", _this.resultObject);
          }
        };
      })(this);
      ontext = (function(_this) {
        return function(text) {
          var charChild, s;
          s = stack[stack.length - 1];
          if (s) {
            s[charkey] += text;
            if (_this.options.explicitChildren && _this.options.preserveChildrenOrder && _this.options.charsAsChildren && (_this.options.includeWhiteChars || text.replace(/\\n/g, '').trim() !== '')) {
              s[_this.options.childkey] = s[_this.options.childkey] || [];
              charChild = {
                '#name': '__text__'
              };
              charChild[charkey] = text;
              if (_this.options.normalize) {
                charChild[charkey] = charChild[charkey].replace(/\s{2,}/g, " ").trim();
              }
              s[_this.options.childkey].push(charChild);
            }
            return s;
          }
        };
      })(this);
      this.saxParser.ontext = ontext;
      return this.saxParser.oncdata = (function(_this) {
        return function(text) {
          var s;
          s = ontext(text);
          if (s) {
            return s.cdata = true;
          }
        };
      })(this);
    };

    Parser.prototype.parseString = function(str, cb) {
      var err;
      if ((cb != null) && typeof cb === "function") {
        this.on("end", function(result) {
          this.reset();
          return cb(null, result);
        });
        this.on("error", function(err) {
          this.reset();
          return cb(err);
        });
      }
      try {
        str = str.toString();
        if (str.trim() === '') {
          this.emit("end", null);
          return true;
        }
        str = bom.stripBOM(str);
        if (this.options.async) {
          this.remaining = str;
          setImmediate(this.processAsync);
          return this.saxParser;
        }
        return this.saxParser.write(str).close();
      } catch (error1) {
        err = error1;
        if (!(this.saxParser.errThrown || this.saxParser.ended)) {
          this.emit('error', err);
          return this.saxParser.errThrown = true;
        } else if (this.saxParser.ended) {
          throw err;
        }
      }
    };

    return Parser;

  })(events.EventEmitter);

  exports.parseString = function(str, a, b) {
    var cb, options, parser;
    if (b != null) {
      if (typeof b === 'function') {
        cb = b;
      }
      if (typeof a === 'object') {
        options = a;
      }
    } else {
      if (typeof a === 'function') {
        cb = a;
      }
      options = {};
    }
    parser = new exports.Parser(options);
    return parser.parseString(str, cb);
  };

}).call(this);


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = __webpack_require__(803).Stream
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = __webpack_require__(294).StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})( false ? this.sax = {} : exports)

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213).Buffer))

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 802 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(214).EventEmitter;
var inherits = __webpack_require__(136);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(292);
Stream.Writable = __webpack_require__(809);
Stream.Duplex = __webpack_require__(810);
Stream.Transform = __webpack_require__(811);
Stream.PassThrough = __webpack_require__(812);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 804 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(216).Buffer;
var util = __webpack_require__(806);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(440);

/*<replacement>*/
var util = __webpack_require__(167);
util.inherits = __webpack_require__(136);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(293);


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(113);


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(292).Transform


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(292).PassThrough


/***/ }),
/* 813 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  exports.stripBOM = function(str) {
    if (str[0] === '\uFEFF') {
      return str.substring(1);
    } else {
      return str;
    }
  };

}).call(this);


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var LocalStorageUtils = /** @class */ (function () {
    function LocalStorageUtils() {
    }
    LocalStorageUtils.setPrefix = function (prefix) {
        this.prefix = prefix;
    };
    LocalStorageUtils.getPrefix = function () {
        return this.prefix;
    };
    LocalStorageUtils.setItem = function (key, value, needPrefix) {
        var storageKey = this.getKey(key, needPrefix);
        localStorage.setItem(storageKey, JSON.stringify(value));
    };
    LocalStorageUtils.getItem = function (key, needPrefix) {
        var storageKey = this.getKey(key, needPrefix);
        var rawItem = localStorage.getItem(storageKey);
        if (rawItem === null) {
            return null;
        }
        try {
            return JSON.parse(rawItem);
        }
        catch (e) {
            return null;
        }
    };
    LocalStorageUtils.removeItem = function (key, needPrefix) {
        var storageKey = this.getKey(key, needPrefix);
        localStorage.removeItem(storageKey);
    };
    LocalStorageUtils.getKey = function (key, needPrefix) {
        return needPrefix ? this.prefix + "-" + key : key;
    };
    return LocalStorageUtils;
}());
/* harmony default export */ __webpack_exports__["a"] = (LocalStorageUtils);


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoaderVariants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(137);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;




var loader = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: default;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t& > :last-child {\n\t\tmargin: 0 5px;\n\t}\n\n\t& > svg {\n\t\tposition: relative;\n\t\tanimation: ", ";\n\t}\n"], ["\n\tcursor: default;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t& > :last-child {\n\t\tmargin: 0 5px;\n\t}\n\n\t& > svg {\n\t\tposition: relative;\n\t\tanimation: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_style__["e" /* spin */]);
var LoaderVariants = (_a = {},
    _a['Button'] = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["",
        ""])), Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t", "\n\t\t& > svg {\n\t\t\theight: 25px;\n\t\t\twidth: 25px;\n\t\t\tmargin-left: ", ";\n\t\t\tmargin-right: ", ";\n\t\t}\n\t"], ["\n\t\t", "\n\t\t& > svg {\n\t\t\theight: 25px;\n\t\t\twidth: 25px;\n\t\t\tmargin-left: ", ";\n\t\t\tmargin-right: ", ";\n\t\t}\n\t"])), loader, function (props) { return props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].DownloadingAll ? "-25px" : "0"; }, function (props) { return props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].DownloadingAll ? "15px" : "5px"; })),
    _a['Overlay'] = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["",
        ""])), Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t", "\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\topacity: 0.9;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: 4;\n\t\tborder-radius: 7px;\n\n\t\t& > svg {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\t"], ["\n\t\t", "\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\topacity: 0.9;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: 4;\n\t\tborder-radius: 7px;\n\n\t\t& > svg {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\t"])), loader, function (props) { return props.theme.primary.backgroundColor; }, function (props) { return props.theme.primary.strongColor; })),
    _a['ListItem'] = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["",
        ""])), Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\t", "\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\topacity: 0.9;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding-bottom: 5px;\n\t\tz-index: 4;\n\t\tborder-radius: 7px;\n\t\ttext-align: center;\n\t\tbox-sizing: border-box;\n\n\t\tsvg {\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t\tmargin-right: 5px;\n\t\t\tanimation: ", ";\n\t\t\t", "\n\t\t}\n\n\t\t", "\n\t\t", "\n\t\t", "\n\t"], ["\n\t\t", "\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\topacity: 0.9;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding-bottom: 5px;\n\t\tz-index: 4;\n\t\tborder-radius: 7px;\n\t\ttext-align: center;\n\t\tbox-sizing: border-box;\n\n\t\tsvg {\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t\tmargin-right: 5px;\n\t\t\tanimation: ", ";\n\t\t\t",
        "\n\t\t}\n\n\t\t",
        "\n\t\t",
        "\n\t\t",
        "\n\t"])), loader, function (props) { return props.theme.primary.backgroundColor; }, function (props) { return props.theme.primary.strongColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_style__["e" /* spin */], function (props) { return (props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].Deleting || props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].DeletingDependencies)
        && "fill: " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["b" /* NewStyleColor */].Red300 + ";"; }, function (props) { return (props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].Downloading || props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].Deleting) && "\n\t\t\tflex-wrap: wrap;\n\n\t\t\t> span {\n\t\t\t\tpadding-top: 5px;\n\t\t\t}\n\n\t\t\t> div {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tpadding: 5px;\n\t\t\t\tpadding-bottom: 0;\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t"; }, function (props) { return (props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].DownloadingDependencies || props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].DeletingDependencies)
        && 'padding: 5px;'; }, function (props) { return (props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].Deleting || props.step === __WEBPACK_IMPORTED_MODULE_3__index__["a" /* LoaderStepName */].DeletingDependencies)
        && "color: " + __WEBPACK_IMPORTED_MODULE_0__utils_styles_constants__["b" /* NewStyleColor */].Red300 + ";"; })),
    _a);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(821);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_what__ = __webpack_require__(823);


function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(newComer)) {
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin))
        ? Object.keys(origin)
            .reduce(function (carry, key) {
            var targetVal = origin[key];
            // @ts-ignore
            if (!Object.keys(newComer).includes(key))
                carry[key] = targetVal;
            return carry;
        }, {})
        : {};
    return Object.keys(newComer)
        .reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin))
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // early return when targetVal === undefined
        if (targetVal === undefined) {
            carry[key] = newVal;
            return carry;
        }
        // When newVal is an object do the merge recursively
        if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(newVal)) {
            carry[key] = mergeRecursively(targetVal, newVal, extensions);
            return carry;
        }
        // all the rest
        carry[key] = newVal;
        return carry;
    }, newObject);
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function index (origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getType */
/* unused harmony export isUndefined */
/* unused harmony export isNull */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPlainObject; });
/* unused harmony export isObject */
/* unused harmony export isAnyObject */
/* unused harmony export isObjectLike */
/* unused harmony export isFunction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/* unused harmony export isString */
/* unused harmony export isFullString */
/* unused harmony export isEmptyString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isRegExp */
/* unused harmony export isDate */
/* unused harmony export isSymbol */
/* unused harmony export isPrimitive */
/* unused harmony export isType */
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return (payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype);
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function
 *
 * @param {*} payload
 * @returns {payload is Function}
 */
function isFunction(payload) {
    return getType(payload) === 'Function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number
 *
 * This will return false for NaN
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return (getType(payload) === 'Number' && !isNaN(payload));
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a date, and that the date is Valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return (getType(payload) === 'Date' && !isNaN(payload));
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is Symbol}
 */
function isSymbol(payload) {
    return (getType(payload) === 'Symbol');
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {*}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!type.hasOwnProperty('prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return (getType(payload) === name) || Boolean(payload && (payload.constructor === type));
}




/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(170);
var define = __webpack_require__(219);

var requirePromise = __webpack_require__(220);
var implementation = __webpack_require__(443);
var getPolyfill = __webpack_require__(460);
var shim = __webpack_require__(883);

requirePromise();
var bound = callBind(getPolyfill());

var rebindable = function allSettled(iterable) {
	// eslint-disable-next-line no-invalid-this
	return bound(typeof this === 'undefined' ? Promise : this, iterable);
};

define(rebindable, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = rebindable;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(827);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(442);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(829);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(442); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);
var callBind = __webpack_require__(170);

var $resolve = GetIntrinsic('%Promise.resolve%', true);
var $PromiseResolve = $resolve && callBind($resolve);

// https://262.ecma-international.org/9.0/#sec-promise-resolve

module.exports = function PromiseResolve(C, x) {
	if (!$PromiseResolve) {
		throw new SyntaxError('This environment does not support Promises.');
	}
	return $PromiseResolve(C, x);
};



/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(832);

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getIterator = __webpack_require__(834);
var $TypeError = TypeError;
var iterate = __webpack_require__(842);

module.exports = function iterateValue(iterable) {
	var iterator = getIterator(iterable);
	if (!iterator) {
		throw new $TypeError('non-iterable value provided');
	}
	if (arguments.length > 1) {
		return iterate(iterator, arguments[1]);
	}
	return iterate(iterator);
};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.

var isArguments = __webpack_require__(835);

if (__webpack_require__(837)() || __webpack_require__(444)()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	module.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray = __webpack_require__(838);
	var isString = __webpack_require__(839);
	var GetIntrinsic = __webpack_require__(19);
	var $Map = GetIntrinsic('%Map%', true);
	var $Set = GetIntrinsic('%Set%', true);
	var callBound = __webpack_require__(60);
	var $arrayPush = callBound('Array.prototype.push');
	var $charCodeAt = callBound('String.prototype.charCodeAt');
	var $stringSlice = callBound('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray(iterable) || isArguments(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		module.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap = __webpack_require__(840);
		var isSet = __webpack_require__(841);

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound('Map.prototype.forEach', true);
		var $setForEach = callBound('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound('Map.prototype.iterator', true);
			var $setIterator = callBound('Set.prototype.iterator', true);
			var getStopIterationIterator = function (iterator) {
				var done = false;
				return {
					next: function next() {
						try {
							return {
								done: done,
								value: done ? undefined : iterator.next()
							};
						} catch (e) {
							done = true;
							return {
								done: true,
								value: undefined
							};
						}
					}
				};
			};
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		module.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(221)();
var callBound = __webpack_require__(60);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(444);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 838 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(221)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Map) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x);
		if ($setHas) {
			try {
				$setHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Set) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas.call(x);
		if ($mapHas) {
			try {
				$mapHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
module.exports = function iterateIterator(iterator) {
	if (!iterator || typeof iterator.next !== 'function') {
		throw new $TypeError('iterator must be an object with a `next` method');
	}
	if (arguments.length > 1) {
		var callback = arguments[1];
		if (typeof callback !== 'function') {
			throw new $TypeError('`callback`, if provided, must be a function');
		}
	}
	var values = callback || [];
	var result;
	while ((result = iterator.next()) && !result.done) {
		if (callback) {
			callback(result.value); // eslint-disable-line callback-return
		} else {
			values.push(result.value);
		}
	}
	if (!callback) {
		return values;
	}
};


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(219);
var RequireObjectCoercible = __webpack_require__(445);
var callBound = __webpack_require__(60);

var implementation = __webpack_require__(446);
var getPolyfill = __webpack_require__(459);
var polyfill = getPolyfill();
var shim = __webpack_require__(882);

var $slice = callBound('Array.prototype.slice');

// eslint-disable-next-line no-unused-vars
var boundMapShim = function map(array, callbackfn) {
	RequireObjectCoercible(array);
	return polyfill.apply(array, $slice(arguments, 1));
};
define(boundMapShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundMapShim;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var ArrayCreate = __webpack_require__(846);
var Get = __webpack_require__(449);
var IsArray = __webpack_require__(300);
var IsConstructor = __webpack_require__(853);
var IsIntegralNumber = __webpack_require__(447);
var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/12.0/#sec-arrayspeciescreate

module.exports = function ArraySpeciesCreate(originalArray, length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};



/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $ArrayPrototype = GetIntrinsic('%Array.prototype%');
var $RangeError = GetIntrinsic('%RangeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var IsIntegralNumber = __webpack_require__(447);

var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = GetIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/12.0/#sec-arraycreate

module.exports = function ArrayCreate(length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
    OrdinaryDefineOwnProperty(A, 'length', {
        '[[Configurable]]': false,
        '[[Enumerable]]': false,
        '[[Value]]': length,
        '[[Writable]]': true
    });
    */
	return A;
};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $abs = GetIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function abs(x) {
	return $abs(x);
};


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = __webpack_require__(852).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 852 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(854);

var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = __webpack_require__(855);
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: remove, semver-major

module.exports = __webpack_require__(19);


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(856);
var DefineOwnProperty = __webpack_require__(450);

var FromPropertyDescriptor = __webpack_require__(451);
var IsAccessorDescriptor = __webpack_require__(858);
var IsDataDescriptor = __webpack_require__(452);
var IsPropertyKey = __webpack_require__(138);
var SameValue = __webpack_require__(453);
var ToPropertyDescriptor = __webpack_require__(454);
var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

module.exports = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var has = __webpack_require__(115);
var $TypeError = GetIntrinsic('%TypeError%');

module.exports = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (has(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && __webpack_require__(60)('Object.prototype.toString');

// https://ecma-international.org/ecma-262/6.0/#sec-isarray

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(115);

var assertRecord = __webpack_require__(301);

var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

module.exports = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);
var callBound = __webpack_require__(60);

var $TypeError = GetIntrinsic('%TypeError%');

var IsArray = __webpack_require__(300);

var $apply = GetIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

module.exports = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

var CreateDataProperty = __webpack_require__(861);
var IsPropertyKey = __webpack_require__(138);
var Type = __webpack_require__(56);

// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

module.exports = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError('unable to create data property');
	}
	return success;
};


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(450);

var FromPropertyDescriptor = __webpack_require__(451);
var OrdinaryGetOwnProperty = __webpack_require__(862);
var IsDataDescriptor = __webpack_require__(452);
var IsExtensible = __webpack_require__(866);
var IsPropertyKey = __webpack_require__(138);
var SameValue = __webpack_require__(453);
var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

module.exports = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var immutable = oldDesc && (!oldDesc['[[Writable]]'] || !oldDesc['[[Configurable]]']);
	if (immutable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $gOPD = __webpack_require__(863);
var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(60);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

var has = __webpack_require__(115);

var IsArray = __webpack_require__(300);
var IsPropertyKey = __webpack_require__(138);
var IsRegExp = __webpack_require__(864);
var ToPropertyDescriptor = __webpack_require__(454);
var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

module.exports = function OrdinaryGetOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!has(O, P)) {
		return void 0;
	}
	if (!$gOPD) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor($gOPD(O, P));
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $match = GetIntrinsic('%Symbol.match%', true);

var hasRegExpMatcher = __webpack_require__(865);

var ToBoolean = __webpack_require__(455);

// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

module.exports = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return hasRegExpMatcher(argument);
};


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(60);
var hasToStringTag = __webpack_require__(221)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $Object = GetIntrinsic('%Object%');

var isPrimitive = __webpack_require__(458);

var $preventExtensions = $Object.preventExtensions;
var $isExtensible = $Object.isExtensible;

// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

module.exports = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(138);
var Type = __webpack_require__(56);

// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

module.exports = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(869);

// http://262.ecma-international.org/5.1/#sec-9.6

module.exports = function ToUint32(x) {
	return ToNumber(x) >>> 0;
};


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $TypeError = GetIntrinsic('%TypeError%');
var $Number = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $parseInteger = GetIntrinsic('%parseInt%');

var callBound = __webpack_require__(60);
var regexTester = __webpack_require__(870);
var isPrimitive = __webpack_require__(458);

var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};

var ToPrimitive = __webpack_require__(871);

// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

module.exports = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $test = GetIntrinsic('RegExp.prototype.test');

var callBind = __webpack_require__(170);

module.exports = function regexTester(regex) {
	return callBind($test, regex);
};


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toPrimitive = __webpack_require__(872);

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(873);
var isCallable = __webpack_require__(457);
var isDate = __webpack_require__(874);
var isSymbol = __webpack_require__(875);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(876)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(877);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 17], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $Object = GetIntrinsic('%Object%');

var RequireObjectCoercible = __webpack_require__(445);

// https://ecma-international.org/ecma-262/6.0/#sec-toobject

module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(19);

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(221)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = function properlyBoxed(method) {
	// Check node 0.6.21 bug where third parameter is not boxed
	var properlyBoxesNonStrict = true;
	var properlyBoxesStrict = true;
	var threwException = false;
	if (typeof method === 'function') {
		try {
			// eslint-disable-next-line max-params
			method.call('f', function (_, __, O) {
				if (typeof O !== 'object') {
					properlyBoxesNonStrict = false;
				}
			});

			method.call(
				[null],
				function () {
					'use strict';

					properlyBoxesStrict = typeof this === 'string'; // eslint-disable-line no-invalid-this
				},
				'x'
			);
		} catch (e) {
			threwException = true;
		}
		return !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
	}
	return false;
};


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(219);
var getPolyfill = __webpack_require__(459);

module.exports = function shimArrayPrototypeMap() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ map: polyfill },
		{ map: function () { return Array.prototype.map !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var requirePromise = __webpack_require__(220);

var getPolyfill = __webpack_require__(460);
var define = __webpack_require__(219);

module.exports = function shimAllSettled() {
	requirePromise();

	var polyfill = getPolyfill();
	define(Promise, { allSettled: polyfill }, {
		allSettled: function testAllSettled() {
			return Promise.allSettled !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPageEditableTextFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPageEditableMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPageEditableLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPageEditableButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPageEditableIframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPageEditableEnrichments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPageEditableSliders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPageEditableTextFieldsIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPageEditableMediaIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPageEditableLinksIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPageEditableButtonsIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPageEditableIframesIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPageEditableEnrichmentsIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPageEditableSlidersIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getPageThemedItemsIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(114);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

var getCurrentSpread = function (state) { return state.editor.pagesController.spreads[state.editor.pagesController.currentSpreadIndex]; };
var getPageEditableItems = function (items, page, duplicatedItemsInSpread, spread) {
    if (!items[page]) {
        return [];
    }
    var pageItems = Object.values(items[page]);
    if (!duplicatedItemsInSpread || !spread) {
        return pageItems;
    }
    var adjacentPage = spread.find(function (pageInSpread) { return pageInSpread !== page; });
    if (!adjacentPage || !items[adjacentPage]) {
        return pageItems;
    }
    var adjacentPageItems = Object.values(items[adjacentPage]);
    var duplicatedItems = Object.values(duplicatedItemsInSpread[page]).reduce(function (acc, current) {
        var duplicatedItemData = adjacentPageItems.find(function (item) { return ('className' in item && !!item.className && item.className.includes(current.className)); });
        if (duplicatedItemData) {
            acc.push(__assign({}, duplicatedItemData, current));
        }
        return acc;
    }, []);
    return __spread(pageItems, duplicatedItems);
};
var getEditableTextFields = function (state) { return state.editor.editableTextFields; };
var getEditableMedia = function (state) { return state.editor.editableMedia; };
var getEditableLinks = function (state) { return state.editor.editableLinks; };
var getEditableButtons = function (state) { return state.editor.editableButtons; };
var getEditableIframes = function (state) { return state.editor.editableIframes; };
var getEditableEnrichments = function (state) { return state.editor.editableEnrichments; };
var getEditableSliders = function (state) { return state.editor.editableSliders; };
var getThemedItems = function (state) { return state.editor.themedItems; };
var getDuplicatedItemsInSpread = function (state) { return state.editor.duplicatedItemsInSpread; };
var getPageEditableTextFields = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableTextFields, getDuplicatedItemsInSpread, getCurrentSpread, function (state, page) { return page; }, function (items, duplicatedItemsInSpread, spread, page) { return (getPageEditableItems(items, page, duplicatedItemsInSpread, spread)); });
var getPageEditableMedia = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableMedia, getDuplicatedItemsInSpread, getCurrentSpread, function (state, page) { return page; }, function (items, duplicatedItemsInSpread, spread, page) { return (getPageEditableItems(items, page, duplicatedItemsInSpread, spread)); });
var getPageEditableLinks = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableLinks, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page); });
var getPageEditableButtons = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableButtons, getDuplicatedItemsInSpread, getCurrentSpread, function (state, page) { return page; }, function (items, duplicatedItemsInSpread, spread, page) { return (getPageEditableItems(items, page, duplicatedItemsInSpread, spread)); });
var getPageEditableIframes = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableIframes, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page); });
var getPageEditableEnrichments = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableEnrichments, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page); });
var getPageEditableSliders = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableSliders, getDuplicatedItemsInSpread, getCurrentSpread, function (state, page) { return page; }, function (items, duplicatedItemsInSpread, spread, page) { return (getPageEditableItems(items, page, duplicatedItemsInSpread, spread)); });
var getPageEditableTextFieldsIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableTextFields, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageEditableMediaIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableMedia, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageEditableLinksIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableLinks, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageEditableButtonsIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableButtons, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageEditableIframesIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableIframes, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageEditableEnrichmentsIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableEnrichments, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageEditableSlidersIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getEditableSliders, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });
var getPageThemedItemsIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getThemedItems, function (state, page) { return page; }, function (items, page) { return getPageEditableItems(items, page).map(function (item) { return item.id; }); });


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFontFamilyOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFontSizeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColorOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLineHeightOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLetterSpacingOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_EditPanel_Select_styles__ = __webpack_require__(305);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};





var getEditableData = function (state) { return state.editor.configs.generalData.editablePublication; };
var getPageTextFieldsData = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["a" /* createSelector */])(getEditableData, function (state, page) { return page; }, function (editableData, page) { return editableData[page] && editableData[page].textFieldsData; });
// tslint:disable-next-line: max-line-length
// some options (font-size, line-height, letter-spacing) can have very close values set in inDesign, e.g., '12px' and '12.2px'. Both of these values should be kept for defining if the value is selected in edit panel but only one rounded value ('12px') should be displayed
var getOptions = function (data, decimal) {
    if (decimal === void 0) { decimal = 1; }
    var dataObject = __spread(data).reduce(function (acc, current) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["Q" /* getValueAndUnits */])(current), value = _a.value, units = _a.units;
        var label = "" + Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["A" /* getRoundedValue */])(value, decimal) + units;
        if (!acc[label]) {
            acc[label] = {
                label: label,
                values: [current],
            };
        }
        else {
            acc[label].values.push(current);
        }
        return acc;
    }, {});
    return Object.keys(dataObject)
        .map(function (key) { return ({
        label: key,
        values: dataObject[key].values,
    }); })
        .sort(function (a, b) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["u" /* getNumberFromString */])(a.label) - Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["u" /* getNumberFromString */])(b.label); });
};
var getFontFamilyOptions = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["a" /* createSelector */])(getPageTextFieldsData, function (data) {
    if (!data) {
        return [];
    }
    return __spread(data.fontFamilies).map(function (fontFamily) { return ({
        values: [fontFamily],
        label: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { fontFamily: fontFamily } }, fontFamily.split(',')[0].replace(/\'|\"/g, ''))),
    }); });
});
var getFontSizeOptions = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["a" /* createSelector */])(getPageTextFieldsData, function (data) {
    if (!data) {
        return [];
    }
    return getOptions(data.fontSizes);
});
var getColorOptions = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["a" /* createSelector */])(getPageTextFieldsData, function (data) {
    if (!data) {
        return [];
    }
    return __spread(data.colors).map(function (color) { return ({
        values: [color],
        label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Editor_EditPanel_Select_styles__["e" /* Color */], { style: { background: color } }),
    }); });
});
var getLineHeightOptions = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["a" /* createSelector */])(getPageTextFieldsData, function (data) {
    if (!data) {
        return [];
    }
    var options = getOptions(data.lineHeights);
    if (__spread(data.lineHeights).includes('normal')) {
        options.push({
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.normal'),
            values: ['normal'],
        });
    }
    return options;
});
var getLetterSpacingOptions = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["a" /* createSelector */])(getPageTextFieldsData, function (data) {
    if (!data) {
        return [];
    }
    return getOptions(__spread(['0px'], data.letterSpacings), 10);
});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(887),
    Draggable = _require.default,
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = DraggableCore;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DraggableCore", {
  enumerable: true,
  get: function get() {
    return _DraggableCore.default;
  }
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(38));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _classnames = _interopRequireDefault(__webpack_require__(141));

var _domFns = __webpack_require__(307);

var _positionFns = __webpack_require__(465);

var _shims = __webpack_require__(226);

var _DraggableCore = _interopRequireDefault(__webpack_require__(889));

var _log = _interopRequireDefault(__webpack_require__(466));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// Define <Draggable>
//
var Draggable = /*#__PURE__*/function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  _createClass(Draggable, null, [{
    key: "getDerivedStateFromProps",
    // React 16.3+
    // Arity (props, state)
    value: function getDerivedStateFromProps(_ref, _ref2) {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition;

      // Set x/y if a new position is provided in props that is different than the previous.
      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  function Draggable(props
  /*: DraggableProps*/
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log.default)('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log.default)('Draggable: onDragStop: %j', coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      return this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: ReactElement<any>*/
    {
      var _classNames;

      var _this$props = this.props,
          axis = _this$props.axis,
          bounds = _this$props.bounds,
          children = _this$props.children,
          defaultPosition = _this$props.defaultPosition,
          defaultClassName = _this$props.defaultClassName,
          defaultClassNameDragging = _this$props.defaultClassNameDragging,
          defaultClassNameDragged = _this$props.defaultClassNameDragged,
          position = _this$props.position,
          positionOffset = _this$props.positionOffset,
          scale = _this$props.scale,
          draggableCoreProps = _objectWithoutProperties(_this$props, ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"]);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
      } // Mark with class while dragging


      var className = (0, _classnames.default)(children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }]);

  return Draggable;
}(React.Component);

exports.default = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    bottom: _propTypes.default.number
  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
  defaultClassName: _propTypes.default.string,
  defaultClassNameDragging: _propTypes.default.string,
  defaultClassNameDragged: _propTypes.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),
  positionOffset: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  position: null,
  scale: 1
}));

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports.default = void 0;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()
/*: string*/
{
  var prop
  /*: string*/
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Checking specifically for 'window.document' is for pseudo-browser server-side
  // environments that define 'window' as the global context.
  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
  var style = window.document.documentElement.style;
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str
/*: string*/
)
/*: string*/
{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = getPrefix();

exports.default = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(38));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _domFns = __webpack_require__(307);

var _positionFns = __webpack_require__(465);

var _shims = __webpack_require__(226);

var _log = _interopRequireDefault(__webpack_require__(466));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Simple abstraction for dragging events names.
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/

/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/

/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/

/*:: export type ControlPosition = {x: number, y: number};*/

/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/

/*:: export type DraggableCoreProps = {
  allowAnyClick: boolean,
  cancel: string,
  children: ReactElement<any>,
  disabled: boolean,
  enableUserSelectHack: boolean,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/

//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var DraggableCore = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log.default)('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents')
          /*: any*/
          )
          /*: MouseTouchEvent*/
          ); // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      return this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render() {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See 
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

exports.default = DraggableCore;

_defineProperty(DraggableCore, "displayName", 'DraggableCore');

_defineProperty(DraggableCore, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props
  /*: DraggableCoreProps*/
  , propName
  /*: $Keys<DraggableCoreProps>*/
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,

  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,

  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  cancel: null,
  disabled: false,
  enableUserSelectHack: true,
  offsetParent: null,
  handle: null,
  grid: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Resizable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resizer__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_memoize__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_memoize__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto',
};
var clamp = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (n, min, max) { return Math.max(Math.min(n, max), min); });
var snap = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (n, size) { return Math.round(n / size) * size; });
var hasDirection = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (dir, target) {
    return new RegExp(dir, 'i').test(target);
});
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var isTouchEvent = function (event) {
    return Boolean(event.touches && event.touches.length);
};
var isMouseEvent = function (event) {
    return Boolean((event.clientX || event.clientX === 0) &&
        (event.clientY || event.clientY === 0));
};
var findClosestSnap = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (n, snapArray, snapGap) {
    if (snapGap === void 0) { snapGap = 0; }
    var closestGapIndex = snapArray.reduce(function (prev, curr, index) { return (Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev); }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var endsWith = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var getStringSize = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (n) {
    n = n.toString();
    if (n === 'auto') {
        return n;
    }
    if (endsWith(n, 'px')) {
        return n;
    }
    if (endsWith(n, '%')) {
        return n;
    }
    if (endsWith(n, 'vh')) {
        return n;
    }
    if (endsWith(n, 'vw')) {
        return n;
    }
    if (endsWith(n, 'vmax')) {
        return n;
    }
    if (endsWith(n, 'vmin')) {
        return n;
    }
    return n + "px";
});
var getPixelSize = function (size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === 'string') {
        if (endsWith(size, 'px')) {
            return Number(size.replace('px', ''));
        }
        if (endsWith(size, '%')) {
            var ratio = Number(size.replace('%', '')) / 100;
            return parentSize * ratio;
        }
        if (endsWith(size, 'vw')) {
            var ratio = Number(size.replace('vw', '')) / 100;
            return innerWidth * ratio;
        }
        if (endsWith(size, 'vh')) {
            var ratio = Number(size.replace('vh', '')) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var calculateNewMax = __WEBPACK_IMPORTED_MODULE_2_fast_memoize___default()(function (parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight),
    };
});
var definedProps = [
    'as',
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap',
];
// HACK: This class is used to calculate % size.
var baseClassName = '__resizable_base__';
var Resizable = /** @class */ (function (_super) {
    __extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function () {
            if (!_this.resizable || !_this.window) {
                return null;
            }
            var parent = _this.parentNode;
            if (!parent) {
                return null;
            }
            var element = _this.window.document.createElement('div');
            element.style.width = '100%';
            element.style.height = '100%';
            element.style.position = 'absolute';
            element.style.transform = 'scale(0, 0)';
            element.style.left = '0';
            element.style.flex = '0';
            if (element.classList) {
                element.classList.add(baseClassName);
            }
            else {
                element.className += baseClassName;
            }
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function (base) {
            var parent = _this.parentNode;
            if (!parent) {
                return;
            }
            parent.removeChild(base);
        };
        _this.ref = function (c) {
            if (c) {
                _this.resizable = c;
            }
        };
        _this.state = {
            isResizing: false,
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined'
                ? 'auto'
                : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined'
                ? 'auto'
                : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            backgroundStyle: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: 'auto',
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0',
            },
            flexBasis: undefined,
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function () {
            if (!this.resizable) {
                return null;
            }
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function () {
            if (!this.resizable) {
                return null;
            }
            if (!this.resizable.ownerDocument) {
                return null;
            }
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function () {
            return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function () {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') {
                    this.resizable.style.position = 'relative';
                }
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function () {
            var _this = this;
            var size = this.props.size;
            var getSize = function (key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') {
                    return 'auto';
                }
                if (_this.propsSize && _this.propsSize[key] && endsWith(_this.propsSize[key].toString(), '%')) {
                    if (endsWith(_this.state[key].toString(), '%')) {
                        return _this.state[key].toString();
                    }
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = (value / parentSize[key]) * 100;
                    return percent + "%";
                }
                return getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing
                ? getStringSize(size.width)
                : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing
                ? getStringSize(size.height)
                : getSize('height');
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function () {
        if (!this.parentNode) {
            if (!this.window) {
                return { width: 0, height: 0 };
            }
            return { width: this.window.innerWidth, height: this.window.innerHeight };
        }
        var base = this.appendBase();
        if (!base) {
            return { width: 0, height: 0 };
        }
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
            // HACK: Use relative to get parent padding size
        }
        base.style.position = 'relative';
        base.style.minWidth = '100%';
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight,
        };
        if (wrapChanged) {
            this.parentNode.style.flexWrap = wrap;
        }
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function () {
        if (this.window) {
            this.window.addEventListener('mouseup', this.onMouseUp);
            this.window.addEventListener('mousemove', this.onMouseMove);
            this.window.addEventListener('mouseleave', this.onMouseUp);
            this.window.addEventListener('touchmove', this.onMouseMove, {
                capture: true,
                passive: false,
            });
            this.window.addEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function () {
        if (this.window) {
            this.window.removeEventListener('mouseup', this.onMouseUp);
            this.window.removeEventListener('mousemove', this.onMouseMove);
            this.window.removeEventListener('mouseleave', this.onMouseUp);
            this.window.removeEventListener('touchmove', this.onMouseMove, true);
            this.window.removeEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function () {
        if (!this.resizable || !this.window) {
            return;
        }
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined,
        });
    };
    Resizable.prototype.componentWillUnmount = function () {
        if (this.window) {
            this.unbindEvents();
        }
    };
    Resizable.prototype.createSizeForCssProperty = function (newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' &&
            this.state.original[kind] === newSize &&
            (typeof propsSize === 'undefined' || propsSize === 'auto')
            ? 'auto'
            : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function (maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_1 = this.parentNode;
            if (parent_1) {
                var boundWidth = parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_1.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        }
        else if (this.props.bounds === 'window') {
            if (this.window) {
                var boundWidth = this.window.innerWidth - this.resizableLeft;
                var boundHeight = this.window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        }
        else if (this.props.bounds) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return { maxWidth: maxWidth, maxHeight: maxHeight };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function (clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (hasDirection('right', direction)) {
            newWidth = original.width + ((clientX - original.x) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection('left', direction)) {
            newWidth = original.width - ((clientX - original.x) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection('bottom', direction)) {
            newHeight = original.height + ((clientY - original.y) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        if (hasDirection('top', direction)) {
            newHeight = original.height - ((clientY - original.y) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        return { newWidth: newWidth, newHeight: newHeight };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function (newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        }
        else {
            newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return { newWidth: newWidth, newHeight: newHeight };
    };
    Resizable.prototype.setBoundingClientRect = function () {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== 'string') {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function (event, direction) {
        if (!this.resizable || !this.window) {
            return;
        }
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) {
                return;
            }
        }
        else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) {
                    return;
                }
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
                this.setState({ height: this.props.size.height });
            }
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
                this.setState({ width: this.props.size.width });
            }
        }
        // For lockAspectRatio case
        this.ratio =
            typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== 'auto') {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith('row') ? 'row' : 'column';
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height,
            },
            isResizing: true,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(event.target).cursor || 'auto' }),
            direction: direction,
            flexBasis: flexBasis,
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function (event) {
        if (!this.state.isResizing || !this.resizable || !this.window) {
            return;
        }
        if (this.window.TouchEvent && isTouchEvent(event)) {
            try {
                event.preventDefault();
                event.stopPropagation();
            }
            catch (e) {
                // Ignore on fail
            }
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, { width: boundaryMax.maxWidth, height: boundaryMax.maxHeight }, { width: minWidth, height: minHeight });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = snap(newWidth, this.props.grid[0]);
            var newGridHeight = snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) {
            newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        }
        if (this.props.snap && this.props.snap.y) {
            newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height,
        };
        if (width && typeof width === 'string') {
            if (endsWith(width, '%')) {
                var percent = (newWidth / parentSize.width) * 100;
                newWidth = percent + "%";
            }
            else if (endsWith(width, 'vw')) {
                var vw = (newWidth / this.window.innerWidth) * 100;
                newWidth = vw + "vw";
            }
            else if (endsWith(width, 'vh')) {
                var vh = (newWidth / this.window.innerHeight) * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if (endsWith(height, '%')) {
                var percent = (newHeight / parentSize.height) * 100;
                newHeight = percent + "%";
            }
            else if (endsWith(height, 'vw')) {
                var vw = (newHeight / this.window.innerWidth) * 100;
                newHeight = vw + "vw";
            }
            else if (endsWith(height, 'vh')) {
                var vh = (newHeight / this.window.innerHeight) * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height'),
        };
        if (this.flexDir === 'row') {
            newState.flexBasis = newState.width;
        }
        else if (this.flexDir === 'column') {
            newState.flexBasis = newState.height;
        }
        this.setState(newState);
        if (this.props.onResize) {
            this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function (event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) {
            return;
        }
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height,
        };
        if (this.props.onResizeStop) {
            this.props.onResizeStop(event, direction, this.resizable, delta);
        }
        if (this.props.size) {
            this.setState(this.props.size);
        }
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: 'auto' }),
        });
    };
    Resizable.prototype.updateSize = function (size) {
        this.setState({ width: size.width, height: size.height });
    };
    Resizable.prototype.renderResizer = function () {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) {
            return null;
        }
        var resizers = Object.keys(enable).map(function (dir) {
            if (enable[dir] !== false) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__resizer__["a" /* Resizer */], { key: dir, direction: dir, onResizeStart: _this.onResizeStart, replaceStyles: handleStyles && handleStyles[dir], className: handleClasses && handleClasses[dir] }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null));
            }
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: handleWrapperClass, style: handleWrapperStyle }, resizers));
    };
    Resizable.prototype.render = function () {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function (acc, key) {
            if (definedProps.indexOf(key) !== -1) {
                return acc;
            }
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = __assign(__assign(__assign({ position: 'relative', userSelect: this.state.isResizing ? 'none' : 'auto' }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: 'border-box', flexShrink: 0 });
        if (this.state.flexBasis) {
            style.flexBasis = this.state.flexBasis;
        }
        var Wrapper = this.props.as || 'div';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper, __assign({ ref: this.ref, style: style, className: this.props.className }, extendsProps),
            this.state.isResizing && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.state.backgroundStyle }),
            this.props.children,
            this.renderResizer()));
    };
    Resizable.defaultProps = {
        as: 'div',
        onResizeStart: function () { },
        onResize: function () { },
        onResizeStop: function () { },
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true,
        },
        style: {},
        grid: [1, 1],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0,
    };
    return Resizable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));



/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Resizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize',
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize',
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize',
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize',
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize',
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize',
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize',
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize',
    },
};
var Resizer = /** @class */ (function (_super) {
    __extends(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function (e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className || '', style: __assign(__assign({ position: 'absolute', userSelect: 'none' }, styles[this.props.direction]), (this.props.replaceStyles || {})), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children));
    };
    return Resizer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));



/***/ }),
/* 892 */
/***/ (function(module, exports) {

//
// Main
//

function memoize (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3)
  var cacheKey = serializer(args)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null)
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
}

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
}

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value
}

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
}

//
// API
//

module.exports = memoize
module.exports.strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
}


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(899);

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__(469);

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);

            if(!object) {
                throw new Error("Element is not detectable by this strategy.");
            }

            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";

        return (rules.join(seperator) + seperator).trim();
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none"]);

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.setProperty("position", "relative", options.important ? "important" : "");

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style.setProperty(property, "0", options.important ? "important" : "");
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            var state = getState(element);
                            if (state.checkForObjectDocumentTimeoutId) {
                                window.clearTimeout(state.checkForObjectDocumentTimeoutId);
                            }
                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
                                state.checkForObjectDocumentTimeoutId = 0;
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                if (!getState(element)) {
                    // The element has been uninstalled before the actual loading happened.
                    return;
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if (!getState(element)) {
            return;
        }

        var object = getObject(element);

        if (!object) {
            return;
        }

        if (browserDetector.isIE(8)) {
            element.detachEvent("onresize", object.proxy);
        } else {
            element.removeChild(object);
        }

        if (getState(element).checkForObjectDocumentTimeoutId) {
            window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
        }

        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__(468).forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";

    function initDocument(targetDocument) {
        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
    }

    initDocument(window.document);

    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";

        return (rules.join(seperator) + seperator).trim();
    }

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = buildCssTextString(["position: absolute", "width: " + width*2 + "px", "height: " + height*2 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);

        var container = document.createElement("div");
        container.style.cssText = buildCssTextString(["position: absolute", "width: " + width + "px", "height: " + height + "px", "overflow: scroll", "visibility: none", "top: " + -width*3 + "px", "left: " + -height*3 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(targetDocument, styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                targetDocument.head.appendChild(element);
            };

            var styleElement = targetDocument.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!targetDocument.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n";
            style += "." + containerAnimationActiveClass + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + containerAnimationClass, "animation-name: " + containerAnimationClass]) + " }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = window.getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]);
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.setProperty("position", "relative",options.important ? "important" : "");

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return ["left: " + left, "top: " + top, "right: " + right, "bottom: " + bottom];
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]);
            var containerStyle          = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
            var expandStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
            var shrinkStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
            var expandChildStyle        = buildCssTextString(["position: absolute", "left: 0", "top: 0"]);
            var shrinkChildStyle        = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]);

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!sizeChanged) {
                        return;
                    }

                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
                    // been restored to the original size, which will have changed the scrollbar positions.

                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (sizeChanged && done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                updateDetectorElements(notifyListenersIfNeeded);
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall,
        initDocument: initDocument
    };
};


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(904);
var _a;






var panelTypeTranslationMap = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].animation] = 'messages.animation',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].iframe] = 'messages.iframe',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].image] = 'messages.image',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].link] = 'messages.link',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].text] = 'messages.text',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].video] = 'messages.video',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].themes] = 'messages.themes',
    _a[__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["c" /* EditableType */].slider] = 'messages.slider',
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_constants__["a" /* EnrichmentType */].openNewTab] = 'messages.open_in_new_tab',
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_constants__["a" /* EnrichmentType */].openSameTab] = 'messages.open_in_same_tab',
    _a[__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_constants__["a" /* EnrichmentType */].popup] = 'messages.open_popup',
    _a[__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* AdditionalPanelType */].settings] = 'messages.settings',
    _a);
var EditPanelLabel = function (_a) {
    var type = _a.type, availableTypes = _a.availableTypes, onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* Label */], { className: "prevent-drag" }, availableTypes.map(function (panelType) {
        var isActive = panelType === type;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* LabelItem */], { key: panelType },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Button */], { type: "button", isActive: isActive, disabled: isActive, onClick: function () { return onClick(panelType); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: panelTypeTranslationMap[panelType] }))));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (EditPanelLabel);


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LabelItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tmargin: 0 0 15px 30px;\n\tpadding: 0;\n\tpadding-right: 15px;\n\tlist-style-type: none;\n"], ["\n\tdisplay: flex;\n\tmargin: 0 0 15px 30px;\n\tpadding: 0;\n\tpadding-right: 15px;\n\tlist-style-type: none;\n"])));
var LabelItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex: 1 0 25%;\n\tbackground-color: ", ";\n\n\t&:first-child {\n\t\tborder-radius: 8px 0 0 8px;\n\t}\n\n\t&:last-child {\n\t\tborder-radius: 0 8px 8px 0;\n\t}\n\n\t&:only-child {\n\t\tborder-radius: 8px;\n\t}\n"], ["\n\tflex: 1 0 25%;\n\tbackground-color: ", ";\n\n\t&:first-child {\n\t\tborder-radius: 8px 0 0 8px;\n\t}\n\n\t&:last-child {\n\t\tborder-radius: 0 8px 8px 0;\n\t}\n\n\t&:only-child {\n\t\tborder-radius: 8px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 10));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 30px;\n\tpadding: 0 5px;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 600;\n\tfont-size: 13px;\n\tline-height: 30px;\n\tletter-spacing: 0.15px;\n\ttext-align: center;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\tborder-radius: 8px;\n\tborder: 0;\n\toutline: 0;\n\tcursor: ", ";\n\n\t", "\n"], ["\n\twidth: 100%;\n\theight: 30px;\n\tpadding: 0 5px;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 600;\n\tfont-size: 13px;\n\tline-height: 30px;\n\tletter-spacing: 0.15px;\n\ttext-align: center;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\tborder-radius: 8px;\n\tborder: 0;\n\toutline: 0;\n\tcursor: ", ";\n\n\t",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White : Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 50);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? 'default' : 'pointer';
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && "\n\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 20) + ";\n\t";
});

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSpreadBgData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGeneralBgData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIsTransparentPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var getConfigs = function (state) { return state.editor.configs; };
var getDataFromBgStyle = function (bgStyle) {
    if (__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].isEmptyObject(bgStyle) || __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].isEmptyObject(bgStyle.epubStyle)) {
        return undefined;
    }
    var _a = bgStyle.epubStyle, backgroundMedia = _a.backgroundMedia, backgroundImage = _a.backgroundImage, defaultBackgroundMedia = _a.defaultBackgroundMedia, backgroundColor = _a.backgroundColor;
    return {
        currentMedia: backgroundMedia || backgroundImage,
        defaultMedia: defaultBackgroundMedia,
        defaultColors: [backgroundColor],
    };
};
var getSpreadBgData = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getConfigs, function (state, spread) { return spread; }, function (_a, spread) {
    var pagesData = _a.pagesData;
    if (pagesData.length === 0) {
        return undefined;
    }
    var leftPage = spread[0];
    var bgStyle = pagesData[leftPage - 1].bgStyle;
    var leftPageData = getDataFromBgStyle(bgStyle);
    if (spread.length > 1) {
        var rightPage = spread[1];
        var bgStyle_1 = pagesData[rightPage - 1].bgStyle;
        var rightPageData = getDataFromBgStyle(bgStyle_1);
        if (!leftPageData) {
            if (rightPageData) {
                rightPageData.defaultColors.unshift(undefined);
            }
            return rightPageData;
        }
        var rightPageColor = rightPageData ? rightPageData.defaultColors[0] : undefined;
        leftPageData.defaultColors.push(rightPageColor);
    }
    return leftPageData;
});
var getGeneralBgData = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getConfigs, function (_a) {
    var generalData = _a.generalData;
    return (getDataFromBgStyle(generalData.bgStyle));
});
var getIsTransparentPage = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getConfigs, function (state, page) { return page; }, function (_a, page) {
    var pagesData = _a.pagesData;
    return (pagesData.length > 0
        ? pagesData[page - 1].isTransparent
        : false);
});


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isModifiedFromBackoffice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getModifiedPageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPageHtmlToSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editableTextFields_getData__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editableTextFields_saveData__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editableLinks_getData__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editableLinks_saveData__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__videos__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(9);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};











var getAllEditableElementsSelector = function () {
    var editableElementsSelectors = [
        "[" + __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Text + "]",
        "[" + __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Image + "]",
        "[" + __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Video + "]",
    ];
    return editableElementsSelectors.join(',');
};
var getEditableElements = function (htmlDocument) { return __spread(htmlDocument.querySelectorAll(getAllEditableElementsSelector())); };
var isText = function (element) { return element.hasAttribute(__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Text); };
var isImage = function (element) { return element.hasAttribute(__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Image); };
var isModifiedFromBackoffice = function (htmlString) { return (htmlString.includes(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* editableId */])); };
var setIdsToEditableElements = function (htmlString) {
    var regExp = new RegExp(__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Text + "|" + __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Image + "|" + __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Video, 'g');
    return htmlString.replace(regExp, function (match) {
        var id = "edit-" + __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].generateId();
        return match + " " + __WEBPACK_IMPORTED_MODULE_8__constants__["c" /* editableId */] + "=\"" + id + "\"";
    });
};
var removeEditableElements = function (htmlDocument) {
    var elements = getEditableElements(htmlDocument);
    elements.forEach(function (element) {
        if (isText(element)) {
            element.innerHTML = '';
        }
        else {
            var div = document.createElement('div');
            var type = isImage(element) ? __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Image : __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* EditableItem */].Video;
            div.setAttribute(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* editableId */], element.getAttribute(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* editableId */]));
            div.setAttribute(type, '');
            var styles = element.getAttribute('style');
            if (styles) {
                div.setAttribute('style', styles);
            }
            var classes = element.getAttribute('class');
            if (classes) {
                div.setAttribute('class', classes);
            }
            element.parentNode.replaceChild(div, element);
        }
    });
    return htmlDocument;
};
var removeHrefFromLinks = function (htmlDocument) {
    var linkElements = __spread(htmlDocument.querySelectorAll('a'));
    linkElements.forEach(function (element) {
        element.removeAttribute('href');
    });
    return htmlDocument;
};
var getFontsPaths = function (htmlDocument) {
    // this path to fonts css file is hardcoded for now
    // and must be set in initial html document prepared by user
    var FONTS_URL = 'font/fonts.css';
    var GOOGLE_FONTS_URL = 'fonts.googleapis.com';
    var linkElements = __spread(htmlDocument.head.querySelectorAll('link'));
    var fontsLinkElement = linkElements.find(function (_a) {
        var href = _a.href;
        return href.includes(FONTS_URL);
    });
    var googleFontsLinkElement = linkElements.find(function (_a) {
        var href = _a.href;
        return href.includes(GOOGLE_FONTS_URL);
    });
    var fontsPath = fontsLinkElement ? FONTS_URL : '';
    var googleFontsPath = googleFontsLinkElement ? googleFontsLinkElement.href : '';
    return {
        fontsPath: fontsPath,
        googleFontsPath: googleFontsPath,
    };
};
var getModifiedPageData = function (page, htmlString, isEditablePage, isAccountManagerOrAdmin) {
    var pageData = {
        html: htmlString,
        defaultHtml: htmlString,
        isError: false,
    };
    // try catch block is used to avoid app breaking in case something went wrong in parsing of html document
    try {
        var defaultHtmlString = htmlString; // used as default html for getting data from editable elements
        if (isEditablePage && !isModifiedFromBackoffice(htmlString)) {
            defaultHtmlString = setIdsToEditableElements(htmlString);
        }
        var htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(defaultHtmlString);
        var defaultHtmlDocument = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(defaultHtmlString);
        if (isEditablePage) {
            htmlDocument = removeEditableElements(htmlDocument);
            htmlDocument = removeHrefFromLinks(htmlDocument);
        }
        else {
            htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_7__videos__["b" /* replaceVideosWithCoverImages */])(htmlDocument);
        }
        pageData.html = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["b" /* serializeHtmlToString */])(htmlDocument);
        pageData.defaultHtml = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["b" /* serializeHtmlToString */])(defaultHtmlDocument);
        if (isEditablePage) {
            var _a = getFontsPaths(defaultHtmlDocument), fontsPath = _a.fontsPath, googleFontsPath = _a.googleFontsPath;
            var editableTextFields = Object(__WEBPACK_IMPORTED_MODULE_1__editableTextFields_getData__["a" /* default */])(page, defaultHtmlDocument, isModifiedFromBackoffice(htmlString));
            var editableMedia = Object(__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["b" /* default */])(page, defaultHtmlDocument);
            var editableLinks = Object(__WEBPACK_IMPORTED_MODULE_5__editableLinks_getData__["a" /* default */])(page, defaultHtmlDocument, __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* EditorType */].HTML, [], isAccountManagerOrAdmin);
            pageData.fontsPath = fontsPath;
            pageData.googleFontsPath = googleFontsPath;
            pageData.editableTextFields = editableTextFields;
            pageData.editableMedia = editableMedia.items;
            pageData.editableLinks = editableLinks.items;
            pageData.isError = editableTextFields.isError || editableMedia.isError || editableLinks.isError;
        }
    }
    catch (error) {
        pageData.isError = true;
    }
    return pageData;
};
var getPageHtmlToSave = function (htmlString, _a) {
    var editableTextFields = _a.editableTextFields, editableMedia = _a.editableMedia, editableLinks = _a.editableLinks;
    var htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString);
    Object(__WEBPACK_IMPORTED_MODULE_2__editableTextFields_saveData__["a" /* default */])(htmlDocument, editableTextFields);
    Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__["a" /* default */])(htmlDocument, editableMedia);
    Object(__WEBPACK_IMPORTED_MODULE_6__editableLinks_saveData__["a" /* default */])(htmlDocument, editableLinks, __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* EditorType */].HTML);
    return Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["b" /* serializeHtmlToString */])(htmlDocument);
};


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__ = __webpack_require__(472);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};




var getTextElementsFromStyles = function (styles, innerHTML, className) {
    var stylesArray = __WEBPACK_IMPORTED_MODULE_2__helpers__["H" /* getStylesArrayWithoutSpaces */](styles);
    // text-decoration style is needed for proper work of <RichTextEditor> component
    if (!styles.includes('text-decoration')) {
        stylesArray.push('text-decoration:none');
    }
    var spanElements = stylesArray.map(function (style, index, array) {
        var span = document.createElement('span');
        // A special class is needed for proper color of underline (managed in css)
        if (style.includes('color')) {
            span.classList.add(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* colorMarkClassName */]);
        }
        span.setAttribute('style', style);
        var isLast = index === array.length - 1;
        if (isLast) {
            span.innerHTML = innerHTML;
        }
        return span;
    });
    if (className) {
        var spanWithClassName = document.createElement('span');
        spanWithClassName.className = className;
        spanElements.unshift(spanWithClassName);
    }
    return spanElements;
};
var replaceTextElements = function (oldElement, newElements) {
    for (var i = 1; i < newElements.length; i += 1) {
        newElements[i - 1].appendChild(newElements[i]);
    }
    oldElement.parentNode.replaceChild(newElements[0], oldElement);
};
var setTextElementsContent = function (elements, editableData) {
    elements.forEach(function (element) {
        var styles = element.getAttribute('style');
        var className = element.getAttribute('class');
        var customClassName = className
            ? className.replace(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* colorMarkClassName */], '').trim()
            : '';
        if (styles) {
            // By default Slate adds line-break symbol to each paragraph of external pasted text. It should be removed for proper display
            var innerHTML = element.innerHTML.replace(/\n/g, '');
            var textElements = getTextElementsFromStyles(styles, innerHTML, customClassName);
            replaceTextElements(element, textElements);
            Object(__WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__["a" /* addStylesToEditableTextFieldsData */])(editableData, styles);
        }
    });
};
var replaceBrTagsToEmptyParagraphs = function (element) {
    var brElements = __spread(element.querySelectorAll('br'));
    // do not change <br> inside paragraphs to keep structure of default html
    var filteredBrElements = brElements.filter(function (element) { return (element.parentElement && element.parentElement.tagName !== 'P'); });
    filteredBrElements.forEach(function (element) {
        var paragraph = document.createElement('p');
        element.parentNode.replaceChild(paragraph, element);
    });
};
var setHeadingOrParagraphStyles = function (element, editableData) {
    var stylesString = element.getAttribute('style');
    if (stylesString) {
        Object(__WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__["a" /* addStylesToEditableTextFieldsData */])(editableData, stylesString);
    }
    var editableElements = __spread(element.querySelectorAll('h1, h2, h3, h4, h5, h6, p'));
    Object.values(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SupportedParagraphStyle */]).forEach(function (styleName) {
        var styleValue = element.style[styleName];
        editableElements.forEach(function (editableElement) {
            if (!editableElement.style[styleName]) {
                if (styleValue) {
                    editableElement.style[styleName] = styleValue;
                }
            }
            else {
                // add individual line-height of heading or paragraph to editable data
                var stylesString_1 = editableElement.getAttribute('style');
                if (stylesString_1 && stylesString_1.includes('line-height')) {
                    var lineHeightStyleString = stylesString_1
                        .split(';')
                        .filter(function (style) { return style.includes('line-height'); })
                        .join();
                    Object(__WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__["a" /* addStylesToEditableTextFieldsData */])(editableData, lineHeightStyleString);
                }
            }
        });
    });
};
var trimInnerHtml = function (element) {
    for (var i = 0; i < element.childNodes.length; i++) {
        var childNode = element.childNodes[i];
        if (childNode.innerHTML) {
            childNode.innerHTML = childNode.innerHTML.trim();
            trimInnerHtml(childNode);
        }
    }
};
var getContent = function (element, editableData, isModifiedFromBackoffice) {
    replaceBrTagsToEmptyParagraphs(element);
    setHeadingOrParagraphStyles(element, editableData);
    if (!isModifiedFromBackoffice) {
        // to remove unnecessary spaces/tabs from initial html (otherwise they will be kept in RTE)
        trimInnerHtml(element);
    }
    var textElements = __spread(element.querySelectorAll('span'));
    setTextElementsContent(textElements, editableData);
    // We have to remove unnecessary spaces between tags for proper render in RTE
    return __WEBPACK_IMPORTED_MODULE_2__helpers__["G" /* getStringWithoutSpaces */](element.innerHTML);
};
var getConfig = function (element, page, editableData, isModifiedFromBackoffice) {
    var id = element.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* editableId */]);
    var _a = element.style, width = _a.width, height = _a.height;
    return {
        page: page,
        id: id,
        width: width,
        height: height,
        content: getContent(element, editableData, isModifiedFromBackoffice),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (function (page, htmlDocument, isModifiedFromBackoffice) {
    var items = [];
    var editableData = {
        fontFamilies: new Set(),
        fontSizes: new Set(),
        colors: new Set(),
        lineHeights: new Set(),
        letterSpacings: new Set(),
    };
    var editableTextFieldElements = __spread(htmlDocument.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* EditableItem */].Text + "]"));
    var isError = false;
    try {
        editableTextFieldElements.forEach(function (fieldElement) { return (items.push(getConfig(fieldElement, page, editableData, isModifiedFromBackoffice))); });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        editableData: editableData,
        isError: isError,
    };
});


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editableTextFields_saveData__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(85);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var modifyEmptyParagraphs = function (fieldElement) {
    var emptyParagraphs = __spread(fieldElement.querySelectorAll('p')).filter(function (p) { return !p.innerText; });
    emptyParagraphs.forEach(function (paragraph) {
        var brElement = document.createElement('br');
        paragraph.parentNode.replaceChild(brElement, paragraph);
    });
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, fields) {
    fields.forEach(function (_a) {
        var id = _a.id, content = _a.content, isEditedFromBackoffice = _a.isEditedFromBackoffice;
        if (!isEditedFromBackoffice) {
            return;
        }
        var fieldElement = htmlDocument.querySelector("[" + __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* editableId */] + "=" + id + "]");
        if (fieldElement) {
            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["_4" /* setElementIsEdited */])(fieldElement);
            fieldElement.innerHTML = content;
            Object(__WEBPACK_IMPORTED_MODULE_1__editableTextFields_saveData__["a" /* modifyElementContent */])(fieldElement, modifyEmptyParagraphs);
        }
    });
});


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getData__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableMedia_saveData__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};





var setImageFrameStyle = function (element, _a) {
    var frameHeight = _a.frameHeight, defaultStyle = _a.defaultStyle;
    var style = "position:relative;display:inline-block;vertical-align:middle;overflow:hidden;width:100%;height:" + frameHeight + "px;" + defaultStyle;
    element.setAttribute('style', style);
};
var setImageStyle = function (element, _a) {
    var width = _a.width, x = _a.x, y = _a.y;
    var style = "position:absolute;width:" + width + "%;height:auto;top:" + y + "%;left:" + x + "%";
    element.setAttribute('style', style);
};
var setElementContent = function (htmlDocument, element, id, type, defaultStyle) {
    var editableTypeAttr = type === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].image ? __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Image : __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Video;
    element.setAttribute(editableTypeAttr, '');
    element.setAttribute(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* editableId */], id);
    if (defaultStyle) {
        element.setAttribute('style', defaultStyle);
    }
    var oldElement = htmlDocument.querySelector("[" + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* editableId */] + "=" + id + "]");
    var classes = oldElement.getAttribute('class');
    if (classes) {
        element.setAttribute('class', classes);
    }
    oldElement.parentNode.replaceChild(element, oldElement);
};
// is needed for handling height of edited media in Reader
var EDITED_MEDIA_SCRIPTS = "\n\t<script src=\"https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver\" " + __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* editedMediaScriptAttribute */] + "></script>\n\t<script " + __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* editedMediaScriptAttribute */] + ">\n\t\tvar editedMediaSelector = '[" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Image + "][" + __WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].edited + "], iframe[" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Video + "][" + __WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].edited + "]';\n\t\tvar editedMedia = document.querySelectorAll(editedMediaSelector);\n\t\tvar editedMediaArray = Array.prototype.slice.call(editedMedia);\n\t\tvar observer = new IntersectionObserver(handleIntersect);\n\n\t\tfor (var i = 0; i < editedMediaArray.length; i++) {\n\t\t\tvar editedMedia = editedMediaArray[i];\n\t\t\tobserver.observe(editedMedia);\n\t\t}\n\n\t\tfunction handleIntersect(entries, observer) {\n\t\t\tfor (var i = 0; i < entries.length; i++) {\n\t\t\t\tvar entry = entries[i];\n\t\t\t\tif (entry.isIntersecting) {\n\t\t\t\t\tsetMediaHeight(entry.target);\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\n\t\tfunction handleResize() {\n\t\t\tfor (var i = 0; i < editedMediaArray.length; i++) {\n\t\t\t\tsetMediaHeight(editedMediaArray[i]);\n\t\t\t}\n\t\t};\n\n\t\tfunction setMediaHeight(mediaElement) {\n\t\t\tvar defaultStyle = mediaElement.getAttribute('" + __WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].defaultStyle + "');\n\n\t\t\tif (defaultStyle && isStyleIncludesHeight(defaultStyle)) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tvar width = mediaElement.getBoundingClientRect().width;\n\t\t\tvar aspectRatio = mediaElement.getAttribute('" + __WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].aspectRatio + "');\n\t\t\tmediaElement.style.height = width * aspectRatio + 'px';\n\t\t};\n\n\t\tfunction isStyleIncludesHeight(style) {\n\t\t\tvar styleWithoutSpaces = style.replace(/\\s+/g, '');\n\t\t\treturn styleWithoutSpaces.indexOf('height') !== -1 && (\n\t\t\t\tstyleWithoutSpaces.indexOf('height') === 0 ||\n\t\t\t\tstyleWithoutSpaces[styleWithoutSpaces.indexOf('height') - 1] === ';'\n\t\t\t);\n\t\t};\n\n\t\t// Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport\n\t\tif (window.visualViewport) {\n\t\t\twindow.visualViewport.addEventListener('resize', handleResize);\n\t\t} else {\n\t\t\twindow.addEventListener('resize', handleResize);\n\t\t}\n\t</script>\n";
var addOrRemoveEditedMediaScripts = function (htmlDocument) {
    var editedMediaSelector = "[" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Image + "][" + __WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].edited + "], iframe[" + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Video + "][" + __WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].edited + "]";
    var editedMedia = __spread(htmlDocument.querySelectorAll(editedMediaSelector));
    var hasEditedMedia = editedMedia.length > 0;
    var editedMediaScripts = __spread(htmlDocument.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* editedMediaScriptAttribute */] + "]"));
    var hasEditedMediaScripts = editedMediaScripts.length > 0;
    if (hasEditedMedia && !hasEditedMediaScripts) {
        htmlDocument.body.innerHTML += EDITED_MEDIA_SCRIPTS;
    }
    if (!hasEditedMedia && hasEditedMediaScripts) {
        editedMediaScripts.forEach(function (script) { return (script.parentNode.removeChild(script)); });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, mediaItems) {
    mediaItems.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, type = _a.type, id = _a.id, defaultLink = _a.defaultLink, driveLink = _a.driveLink, externalLink = _a.externalLink, isExternalLinkActive = _a.isExternalLinkActive, frameHeight = _a.frameHeight, width = _a.width, x = _a.x, y = _a.y, label = _a.label, tooltip = _a.tooltip, isTooltipActive = _a.isTooltipActive, frameAspectRatio = _a.frameAspectRatio, defaultStyle = _a.style, videoSettings = _a.videoSettings;
        var _b, _c;
        if (!isEditedFromBackoffice) {
            return;
        }
        var modifiedDriveLink = Object(__WEBPACK_IMPORTED_MODULE_3__editableMedia_saveData__["a" /* getDriveLinkWithoutHash */])(driveLink);
        var src = (isExternalLinkActive ? externalLink : modifiedDriveLink) || defaultLink;
        var element = Object(__WEBPACK_IMPORTED_MODULE_3__editableMedia_saveData__["b" /* getElement */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EditorType */].HTML, type, isExternalLinkActive, htmlDocument, src, videoSettings);
        var isCustomLink = (src !== defaultLink) || (isExternalLinkActive && !!modifiedDriveLink);
        if (type === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* EditableType */].image) {
            if (isCustomLink) {
                var imageFrame = htmlDocument.querySelector("[" + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* editableId */] + "=" + id + "]");
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__getData__["c" /* isEditedImageElement */])(imageFrame)) {
                    var newImageFrame = htmlDocument.createElement('div');
                    newImageFrame.setAttribute(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EditableItem */].Image, '');
                    newImageFrame.setAttribute(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* editableId */], id);
                    var classes = imageFrame.getAttribute('class');
                    if (classes) {
                        newImageFrame.setAttribute('class', classes);
                    }
                    imageFrame.parentNode.replaceChild(newImageFrame, imageFrame);
                    imageFrame = newImageFrame;
                }
                Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["_3" /* setDataAttributes */])(imageFrame, (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].edited] = true,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].label] = label,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].defaultLink] = defaultLink,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].driveLink] = modifiedDriveLink,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].externalLink] = externalLink,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].externalLinkActive] = isExternalLinkActive,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].defaultStyle] = defaultStyle,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].aspectRatio] = frameAspectRatio,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].tooltip] = tooltip,
                    _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].tooltipActive] = isTooltipActive,
                    _b));
                Object(__WEBPACK_IMPORTED_MODULE_3__editableMedia_saveData__["d" /* setTooltipActions */])(imageFrame, tooltip, isTooltipActive);
                setImageFrameStyle(imageFrame, { frameHeight: frameHeight, defaultStyle: defaultStyle });
                setImageStyle(element, { width: width, x: x, y: y });
                imageFrame.innerHTML = '';
                imageFrame.appendChild(element);
            }
            else {
                setElementContent(htmlDocument, element, id, type, defaultStyle);
            }
        }
        else {
            if (isCustomLink) {
                Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["_3" /* setDataAttributes */])(element, (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].edited] = true,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].label] = label,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].defaultLink] = defaultLink,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].driveLink] = modifiedDriveLink,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].externalLink] = externalLink,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].externalLinkActive] = isExternalLinkActive,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].defaultStyle] = defaultStyle,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].aspectRatio] = frameAspectRatio,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].tooltip] = tooltip,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* MediaElementDataAttribute */].tooltipActive] = isTooltipActive,
                    _c));
                Object(__WEBPACK_IMPORTED_MODULE_3__editableMedia_saveData__["d" /* setTooltipActions */])(element, tooltip, isTooltipActive);
            }
            setElementContent(htmlDocument, element, id, type, defaultStyle);
        }
    });
    addOrRemoveEditedMediaScripts(htmlDocument);
});


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getModifiedPageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPageHtmlToSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAccessiblePageHtmlToSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editableTextFields_getData__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editableTextFields_saveData__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editableLinks_getData__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editableLinks_saveData__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editableButtons_getData__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editableButtons_saveData__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editableIframes_getData__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editableIframes_saveData__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editableEnrichments_getData__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__editableEnrichments_saveData__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editableSliders_getData__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editableSliders_saveData__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__themedItems_getData__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__backgroundDeps__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__videos__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};






















var getPageSize = function (htmlDocument) {
    var wrapperDiv = htmlDocument.querySelector('div[style]');
    if (!wrapperDiv) {
        return { width: 1000, height: 1000 };
    }
    var _a = wrapperDiv.style, width = _a.width, height = _a.height;
    return {
        width: Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["u" /* getNumberFromString */])(width),
        height: Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["u" /* getNumberFromString */])(height),
    };
};
var updateUrlsInPageHtml = function (htmlDocument, config, resourceId) {
    var elementsWithSrc = __spread(htmlDocument.querySelectorAll("[src]:not([class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].iframeClassName + "])"));
    elementsWithSrc.forEach(function (element) {
        var url = Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["z" /* getResourceUrl */])(element.src, config, resourceId);
        element.setAttribute('src', url);
    });
    return htmlDocument;
};
var getAllEditableElementsSelector = function () {
    var editableElementsSelectors = [
        "[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].textFieldClassName + "]",
        "[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].imageClassName + "]",
        "[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoClassName + "]",
        "[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].animationClassName + "]",
        "[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].iframeClassName + "]",
        "[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].sliderClassName + "]",
    ];
    return editableElementsSelectors
        .map(function (item) { return item + ":not([class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedClassName + "])"; })
        .join(',');
};
var getEditableElements = function (htmlDocument) { return __spread(htmlDocument.querySelectorAll(getAllEditableElementsSelector())); };
var removeEditableElements = function (htmlDocument) {
    var elements = getEditableElements(htmlDocument).filter(function (element) { return !Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["V" /* hasLockedParent */])(element); });
    elements.forEach(function (element) {
        var isVideoOrIframe = [
            __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoClassName,
            __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].animationClassName,
            __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].iframeClassName,
        ].some(function (className) { return element.className.includes(className); });
        var elementToHide = isVideoOrIframe
            ? element.closest("[id*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoOrIframeWrapperId + "], [class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoOrIframeWrapperId + "]") || element
            : element.querySelector("#" + element.id + " > *");
        if (elementToHide) {
            elementToHide.parentNode.removeChild(elementToHide);
        }
    });
    return htmlDocument;
};
var addStylesToLockedElements = function (htmlDocument) {
    var elements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedClassName + "]"));
    elements.forEach(function (element) {
        element.style.overflow = 'visible';
        var iconWrapper = htmlDocument.createElement('div');
        iconWrapper.className = __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedIconClassName;
        var iconWrapperStyle = "\n\t\t\tposition:absolute;\n\t\t\tbottom:0;\n\t\t\tright:0;\n\t\t\tdisplay:flex;\n\t\t\talign-items:center;\n\t\t\tjustify-content:center;\n\t\t\twidth:24px;\n\t\t\theight:24px;\n\t\t\tborder-radius:50%;\n\t\t\ttransform-origin:bottom right;\n\t\t";
        iconWrapper.setAttribute('style', iconWrapperStyle);
        var icon = htmlDocument.createElement('svg');
        var iconStyle = 'width:100%;height:100%;';
        icon.setAttribute('style', iconStyle);
        var useElement = htmlDocument.createElement('use');
        useElement.setAttribute('xlink:href', '#svgicon-iconset_uprez_padlock');
        icon.appendChild(useElement);
        iconWrapper.appendChild(icon);
        var isVideo = element.className.includes(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoClassName);
        var isMultiStateObject = element.className.includes(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].multiStateObjectClassName);
        if (isVideo) {
            var parentNode = element.parentNode;
            if (parentNode) {
                var videoWrapper = element.closest("[id*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoOrIframeWrapperId + "], [class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].videoOrIframeWrapperId + "]");
                var _a = Object(__WEBPACK_IMPORTED_MODULE_17__videos__["a" /* getVideoCoverImage */])(element, htmlDocument), image = _a.image, defaultImage = _a.defaultImage;
                if (videoWrapper) {
                    videoWrapper.classList.add(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedClassName);
                }
                parentNode.removeChild(element);
                parentNode.appendChild(image);
                parentNode.appendChild(defaultImage);
                parentNode.appendChild(iconWrapper);
            }
        }
        else if (isMultiStateObject) {
            var children = __spread(element.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].multiStateObjectDataAttribute + "]"));
            children.forEach(function (child) {
                child.appendChild(iconWrapper.cloneNode(true));
            });
        }
        else {
            element.appendChild(iconWrapper);
        }
    });
    return htmlDocument;
};
var parseLinks = function (htmlDocument) {
    var linkElements = __spread(htmlDocument.querySelectorAll('a'));
    linkElements.forEach(function (linkElement) {
        linkElement.removeAttribute('href');
        if (Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["X" /* isEditableButtonLink */])(linkElement)) {
            var parentLinkElement = linkElement.closest("[id*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].parentContainerId + "]");
            if (parentLinkElement) {
                parentLinkElement.classList.add(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].editableButtonLinkClassName);
                var lockedText = parentLinkElement.querySelector("[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].textFieldClassName + "][class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedClassName + "]");
                if (lockedText) {
                    lockedText.className = lockedText.className.replace(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedClassName, '');
                    parentLinkElement.classList.add(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].lockedClassName);
                }
            }
        }
    });
    return htmlDocument;
};
var removeSliderPreviews = function (htmlDocument) {
    var sliderElements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].sliderClassName + "]"));
    sliderElements.forEach(function (sliderElement) {
        sliderElement.innerHTML = '';
    });
    return htmlDocument;
};
var removeLinksToExternalCss = function (htmlDocument, externalCssRelUrl, externalThemesCssRelUrl) {
    var linkElements = [htmlDocument.querySelector("link[href=\"" + externalCssRelUrl + "\"]")];
    if (externalThemesCssRelUrl) {
        linkElements.push(htmlDocument.querySelector("link[href=\"" + externalThemesCssRelUrl + "\"]"));
    }
    linkElements.forEach(function (linkElement) {
        if (linkElement) {
            linkElement.parentNode.removeChild(linkElement);
        }
    });
    return htmlDocument;
};
var wrapElements = function (htmlDocument) {
    var body = htmlDocument.body;
    var pageContainer = htmlDocument.createElement('div');
    pageContainer.id = 'page-container';
    while (body.firstChild) {
        pageContainer.appendChild(body.firstChild);
    }
    body.appendChild(pageContainer);
    var editableElements = __spread(pageContainer.querySelectorAll(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* accessibleVersionTextElements */] + ", img"));
    editableElements.forEach(function (element, index) {
        // Create editable wrapper (outer)
        var editableWrapper = htmlDocument.createElement('div');
        var isImage = element.tagName === 'IMG';
        editableWrapper.id = "doc-1__idContainer" + index;
        if (isImage) {
            editableWrapper.className = __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].imageClassName + "-" + index;
            var stylesWrapper = htmlDocument.createElement('div');
            var originalStyle = element.getAttribute('style');
            if (originalStyle) {
                element.setAttribute(__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["a" /* MediaElementDataAttribute */].style, originalStyle);
            }
            element.parentNode.insertBefore(editableWrapper, element);
            editableWrapper.appendChild(stylesWrapper);
            stylesWrapper.appendChild(element);
        }
        else {
            editableWrapper.className = __WEBPACK_IMPORTED_MODULE_18__constants__["c" /* default */].textFieldClassName + "-" + index;
            var stylesWrapper = htmlDocument.createElement('div');
            // Wrap the element with the styles wrapper first
            element.parentNode.insertBefore(editableWrapper, element);
            editableWrapper.appendChild(stylesWrapper);
            stylesWrapper.appendChild(element);
        }
    });
    return htmlDocument;
};
var getModifiedPageData = function (page, pageIndexInSpread, htmlString, css, config, resourceId, isEditablePage, isModifiedFromBackoffice, isAccountManagerOrAdmin, totalPages, spreads, pageHeightFromConfig, externalCssRelUrl, externalThemesCssRelUrl, isAccessible) {
    var pageData = {
        html: htmlString,
        width: 0,
        height: 0,
        isError: false,
    };
    // try catch block is used to avoid app breaking in case something went wrong in parsing of inDesign html document
    try {
        var defaultHtmlDocument = isAccessible ? wrapElements(Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString)) : Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString);
        var htmlDocument = isAccessible ? wrapElements(Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString)) : Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString);
        if (isEditablePage) {
            htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_7__editableButtons_getData__["c" /* removeButtonActions */])(htmlDocument);
            htmlDocument = removeEditableElements(htmlDocument);
            htmlDocument = parseLinks(htmlDocument);
        }
        // this method should be called after removeEditableElements to not update urls on editable images/videos as they will be removed anyway
        htmlDocument = updateUrlsInPageHtml(htmlDocument, config, resourceId);
        htmlDocument = removeSliderPreviews(htmlDocument);
        if (externalCssRelUrl) {
            htmlDocument = removeLinksToExternalCss(htmlDocument, externalCssRelUrl, externalThemesCssRelUrl);
        }
        if (isEditablePage) {
            // this method should be called after updateUrlsInPageHtml as locked videos should be replaced with cover images with correct urls
            htmlDocument = addStylesToLockedElements(htmlDocument);
        }
        if (!isEditablePage) {
            htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_17__videos__["b" /* replaceVideosWithCoverImages */])(htmlDocument);
        }
        var _a = getPageSize(htmlDocument), width = _a.width, height = _a.height;
        pageData.html = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["b" /* serializeHtmlToString */])(htmlDocument);
        pageData.width = width;
        pageData.height = pageHeightFromConfig || height;
        if (isEditablePage) {
            var editableTextFields = Object(__WEBPACK_IMPORTED_MODULE_1__editableTextFields_getData__["a" /* default */])(page, pageIndexInSpread, defaultHtmlDocument, css, isModifiedFromBackoffice, isAccessible);
            var editableMedia = Object(__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["b" /* default */])(page, pageIndexInSpread, defaultHtmlDocument, css, isAccessible);
            var editableLinks = Object(__WEBPACK_IMPORTED_MODULE_5__editableLinks_getData__["a" /* default */])(page, defaultHtmlDocument, __WEBPACK_IMPORTED_MODULE_19__constants__["e" /* EditorType */].INDESIGN, spreads, isAccountManagerOrAdmin);
            var editableButtons = Object(__WEBPACK_IMPORTED_MODULE_7__editableButtons_getData__["b" /* default */])(page, pageIndexInSpread, defaultHtmlDocument, isAccountManagerOrAdmin, totalPages, spreads);
            var editableIframes = Object(__WEBPACK_IMPORTED_MODULE_9__editableIframes_getData__["b" /* default */])(page, defaultHtmlDocument);
            var editableEnrichments = Object(__WEBPACK_IMPORTED_MODULE_11__editableEnrichments_getData__["b" /* default */])(page, defaultHtmlDocument, isAccountManagerOrAdmin);
            var editableSliders = Object(__WEBPACK_IMPORTED_MODULE_13__editableSliders_getData__["d" /* default */])(page, pageIndexInSpread, defaultHtmlDocument, css);
            var themedItems = Object(__WEBPACK_IMPORTED_MODULE_15__themedItems_getData__["a" /* default */])(page, defaultHtmlDocument, isAccountManagerOrAdmin);
            pageData.editableTextFields = editableTextFields;
            pageData.editableMedia = editableMedia.items;
            pageData.editableLinks = editableLinks.items;
            pageData.editableButtons = editableButtons.items;
            pageData.editableIframes = editableIframes.items;
            pageData.editableEnrichments = editableEnrichments.items;
            pageData.editableSliders = editableSliders.items;
            pageData.themedItems = themedItems.items;
            pageData.duplicatedItemsInSpread = __spread(editableTextFields.duplicatedItemsInSpread, editableMedia.duplicatedItemsInSpread, editableButtons.duplicatedItemsInSpread, editableSliders.duplicatedItemsInSpread);
            pageData.isError =
                editableTextFields.isError ||
                    editableMedia.isError ||
                    editableLinks.isError ||
                    editableButtons.isError ||
                    editableIframes.isError ||
                    editableEnrichments.isError ||
                    editableSliders.isError ||
                    themedItems.isError;
            pageData.backgroundDeps = Object(__WEBPACK_IMPORTED_MODULE_16__backgroundDeps__["a" /* getBackgroundDeps */])(htmlDocument);
        }
    }
    catch (error) {
        pageData.isError = true;
    }
    return pageData;
};
var getPageHtmlToSave = function (htmlString, _a, pageSlidersData, backgroundDeps) {
    var editableTextFields = _a.editableTextFields, editableMedia = _a.editableMedia, editableLinks = _a.editableLinks, editableButtons = _a.editableButtons, editableIframes = _a.editableIframes, editableEnrichments = _a.editableEnrichments, editableSliders = _a.editableSliders;
    var htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString);
    Object(__WEBPACK_IMPORTED_MODULE_2__editableTextFields_saveData__["a" /* default */])(htmlDocument, editableTextFields);
    Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__["a" /* default */])(htmlDocument, editableMedia);
    Object(__WEBPACK_IMPORTED_MODULE_6__editableLinks_saveData__["a" /* default */])(htmlDocument, editableLinks, __WEBPACK_IMPORTED_MODULE_19__constants__["e" /* EditorType */].INDESIGN);
    Object(__WEBPACK_IMPORTED_MODULE_8__editableButtons_saveData__["a" /* default */])(htmlDocument, editableButtons);
    Object(__WEBPACK_IMPORTED_MODULE_10__editableIframes_saveData__["a" /* default */])(htmlDocument, editableIframes);
    Object(__WEBPACK_IMPORTED_MODULE_12__editableEnrichments_saveData__["a" /* default */])(htmlDocument, editableEnrichments);
    Object(__WEBPACK_IMPORTED_MODULE_14__editableSliders_saveData__["a" /* default */])(htmlDocument, editableSliders, pageSlidersData);
    Object(__WEBPACK_IMPORTED_MODULE_16__backgroundDeps__["b" /* saveBackgroundDeps */])(htmlDocument, backgroundDeps);
    return Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["b" /* serializeHtmlToString */])(htmlDocument);
};
/**
 * Processes the HTML string by replacing editable text fields as specified.
 *
 * @param htmlString - The original HTML string.
 * @param editableData - The data containing editable items.
 * @returns The modified HTML string.
 */
var getAccessiblePageHtmlToSave = function (htmlString, _a) {
    var editableTextFields = _a.editableTextFields, editableMedia = _a.editableMedia;
    var htmlDocument = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(htmlString);
    // Filter only IndesignTextFieldsConfig items
    var indesignTextFields = editableTextFields.filter(function (item) {
        return item.content !== undefined;
    });
    var indesignImageFields = editableMedia.filter(function (item) {
        return item.isVisible !== undefined;
    });
    saveAccessibleEditableFields(htmlDocument, indesignTextFields, indesignImageFields);
    return Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["b" /* serializeHtmlToString */])(htmlDocument);
};
var saveAccessibleEditableFields = function (htmlDocument, editableTextFields, editableMediaFields) {
    var textElements = __spread(htmlDocument.querySelectorAll(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* accessibleVersionTextElements */]));
    var imageElements = __spread(htmlDocument.querySelectorAll('img'));
    var editableTextIndex = 0;
    var editableImageIndex = 0;
    if (textElements && textElements.length > 0) {
        textElements.forEach(function (element) {
            if (editableTextIndex < editableTextFields.length) {
                var editableField = editableTextFields[editableTextIndex];
                if (editableField && editableField.content) {
                    var newContentDoc = Object(__WEBPACK_IMPORTED_MODULE_0__html_parse_serialize__["a" /* parseHtmlString */])(editableField.content);
                    var newElements = __spread(newContentDoc.querySelectorAll(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* accessibleVersionTextElements */]));
                    newElements.forEach(function (newElement, index) {
                        // Clone the new element to avoid moving it from the parsed document
                        var clonedNewElement = newElement.cloneNode(true);
                        // Insert the cloned new element before the original element
                        element.parentNode.insertBefore(clonedNewElement, element);
                    });
                    // Remove the original element after inserting new elements
                    element.parentNode.removeChild(element);
                }
                editableTextIndex++;
            }
        });
    }
    if (imageElements && imageElements.length > 0) {
        imageElements.forEach(function (element) {
            var _a;
            if (editableImageIndex < editableMediaFields.length) {
                var editableField = editableMediaFields[editableImageIndex];
                if (editableField) {
                    // Restore original style attribute
                    if (editableField.originalStyle) {
                        element.setAttribute('style', editableField.originalStyle);
                    }
                    if (editableField.isVisible !== undefined) {
                        if (!editableField.isVisible) {
                            element.setAttribute('hidden', 'true');
                            __WEBPACK_IMPORTED_MODULE_20__helpers__["_3" /* setDataAttributes */](element, (_a = {},
                                _a[__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["a" /* MediaElementDataAttribute */].hidden] = true,
                                _a[__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["a" /* MediaElementDataAttribute */].defaultLink] = editableField.defaultLink,
                                _a));
                        }
                        else {
                            element.removeAttribute('hidden');
                            element.removeAttribute(__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["a" /* MediaElementDataAttribute */].hidden);
                            element.removeAttribute(__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["a" /* MediaElementDataAttribute */].defaultLink);
                        }
                    }
                    if (editableField.altAttr !== undefined) {
                        element.setAttribute('alt', editableField.altAttr);
                    }
                    if (editableField.driveLink) {
                        element.setAttribute('src', editableField.driveLink);
                    }
                    // Clean up temporary data attribute
                    element.removeAttribute(__WEBPACK_IMPORTED_MODULE_3__editableMedia_getData__["a" /* MediaElementDataAttribute */].style);
                }
                editableImageIndex++;
            }
        });
    }
    return htmlDocument;
};


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_RichTextEditor_helpers__ = __webpack_require__(480);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};





var getTextElementsFromStyles = function (styles, innerHTML) {
    var stylesArray = styles.split(';').filter(function (style) { return style; });
    // inDesign doesn't export text-decoration style. But it is needed for proper work of <RichTextEditor> component
    if (!styles.includes('text-decoration')) {
        stylesArray.push('text-decoration:none');
    }
    return stylesArray.map(function (style, index, array) {
        var span = document.createElement('span');
        // A special class is needed for proper color of underline (managed in css)
        if (style.includes('color')) {
            span.classList.add(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* colorMarkClassName */]);
        }
        span.setAttribute('style', style);
        var isLast = index === array.length - 1;
        if (isLast) {
            span.innerHTML = innerHTML;
        }
        return span;
    });
};
var replaceTextElements = function (oldElement, newElements) {
    for (var i = 1; i < newElements.length; i += 1) {
        newElements[i - 1].appendChild(newElements[i]);
    }
    oldElement.parentNode.replaceChild(newElements[0], oldElement);
};
var replaceTextElementsAccessible = function (originalElement, newSpans) {
    // Create a clone of the original element to preserve its tag and attributes
    var newElement = originalElement.cloneNode(false);
    var sanitizeSpan = function (span) {
        var hasContent = span.textContent && span.textContent.trim() !== '';
        var hasStyles = span.style.cssText && span.style.cssText.trim() !== '';
        if (!hasContent || !hasStyles) {
            return null;
        }
        var newSpan = document.createElement('span');
        // Copy only the necessary styles
        if (span.style.textDecoration !== 'none') {
            newSpan.style.textDecoration = span.style.textDecoration;
        }
        newSpan.innerHTML = span.innerHTML;
        return newSpan;
    };
    newSpans.forEach(function (span) {
        var sanitizedSpan = sanitizeSpan(span);
        if (sanitizedSpan) {
            newElement.appendChild(sanitizedSpan);
        }
    });
    if (originalElement.parentNode) {
        originalElement.parentNode.replaceChild(newElement, originalElement);
    }
};
var getModifiedParagraphElementsStyle = function (elements, scale) {
    elements.forEach(function (element) {
        var styles = element.getAttribute('style');
        if (styles) {
            var modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["J" /* getStylesStringWithoutSpaces */](styles);
            modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["I" /* getStylesStringWithoutLastSemicolon */](modifiedStyles);
            modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["K" /* getStylesWithScaledNumbers */](modifiedStyles, scale);
            element.setAttribute('style', modifiedStyles);
        }
        return element;
    });
};
var getModifiedTextElementsContent = function (elements, scale) {
    elements.forEach(function (element) {
        var styles = element.getAttribute('style');
        if (styles) {
            var modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["K" /* getStylesWithScaledNumbers */](styles, scale);
            // By default Slate adds line-break symbol to each paragraph of external pasted text. It should be removed for proper display
            var innerHTML = element.innerHTML.replace(/\n/g, '');
            var textElements = getTextElementsFromStyles(modifiedStyles, innerHTML);
            if (__WEBPACK_IMPORTED_MODULE_2__helpers__["_1" /* isTextScriptElement */](element.className)) {
                var textScriptSpan = document.createElement('span');
                textScriptSpan.className = __WEBPACK_IMPORTED_MODULE_2__helpers__["L" /* getTextScriptClassName */](element.className);
                var lastTextElement = textElements[textElements.length - 1];
                var content = lastTextElement.innerHTML;
                textScriptSpan.innerHTML = content;
                lastTextElement.innerHTML = '';
                textElements.push(textScriptSpan);
            }
            replaceTextElements(element, textElements);
        }
    });
};
var getTextElementsStyles = function (textElements, css, scale, editableData) { return (textElements.reduce(function (acc, current) {
    var className = current.className, classList = current.classList;
    // generated css for text elements has selectors like span.CharOverride-1 but text elements can have several classes. We have to remove another classes from selector
    var filteredClassName = __spread(classList).find(function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldCharacterClassName)); });
    if (acc[className]) {
        return acc;
    }
    var styles = __WEBPACK_IMPORTED_MODULE_2__helpers__["E" /* getSelectorStylesFromCss */]("\\." + filteredClassName, css);
    if (styles) {
        var modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["K" /* getStylesWithScaledNumbers */](styles, scale);
        if (editableData) {
            Object(__WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__["a" /* addStylesToEditableTextFieldsData */])(editableData, modifiedStyles);
        }
        acc[className] = modifiedStyles;
    }
    return acc;
}, {})); };
var getTextElementInlineStyles = function (textElement, scale, editableData) {
    var stylesToCheck = ['letter-spacing'];
    var styles = stylesToCheck
        .reduce(function (acc, current) {
        var style = textElement.style;
        if (style[current]) {
            acc.push(current + ":" + style[current] + ";");
        }
        return acc;
    }, [])
        .map(function (style) {
        if (style.includes('letter-spacing')) {
            var value = style.split(':')[1];
            var correctedValue = __WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* getCorrectedLetterSpacing */](value, scale);
            return correctedValue ? "letter-spacing:" + correctedValue + "px;" : '';
        }
        return style;
    })
        .join('');
    if (editableData) {
        Object(__WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__["a" /* addStylesToEditableTextFieldsData */])(editableData, styles);
    }
    return styles;
};
var getUnmodifiedParagraphElementsStyle = function (parentClassName, elements, css, scale, editableData, isAccessible) {
    elements.forEach(function (element, index) {
        // remove all inDesign classes to avoid styles collision
        if (!isAccessible) {
            element.removeAttribute('class');
        }
        var textFieldClassNameRegExp = new RegExp(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldClassName + "-\\d+_\\d+");
        var match = parentClassName.match(textFieldClassNameRegExp);
        var textFieldClassName = match && match[0];
        if (!textFieldClassName) {
            return;
        }
        var selector = "\\[class\\*=\\\"" + textFieldClassName + "\\\"\\] p:nth-of-type\\(" + (index + 1) + "\\)";
        var styles = __WEBPACK_IMPORTED_MODULE_2__helpers__["E" /* getSelectorStylesFromCss */](selector, css);
        if (styles) {
            var modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["I" /* getStylesStringWithoutLastSemicolon */](styles);
            modifiedStyles = __WEBPACK_IMPORTED_MODULE_2__helpers__["K" /* getStylesWithScaledNumbers */](modifiedStyles, scale);
            if (editableData) {
                Object(__WEBPACK_IMPORTED_MODULE_3__editableTextFields_textFieldsEditableData__["a" /* addStylesToEditableTextFieldsData */])(editableData, modifiedStyles);
            }
            element.setAttribute('style', modifiedStyles);
        }
    });
};
var getUnmodifiedTextElementsContent = function (elements, css, scale, editableData, isAccessible) {
    var textElementsStyles = getTextElementsStyles(elements, css, scale, editableData);
    var textElementInnerHtml = '';
    var isReplacementNeeded = true;
    elements.forEach(function (element, index, elements) {
        var currentElement = element;
        var nextElement = elements[index + 1];
        var currentElementInlineStyles = getTextElementInlineStyles(currentElement, scale, editableData);
        var currentElementStyles = "" + textElementsStyles[currentElement.className] + currentElementInlineStyles;
        var elementToReplace = currentElement;
        if (nextElement) {
            var nextElementInlineStyles = getTextElementInlineStyles(nextElement, scale, editableData);
            var nextElementStyles = "" + textElementsStyles[nextElement.className] + nextElementInlineStyles;
            var isSiblings = currentElement.parentNode === nextElement.parentNode;
            var isSameStyles = currentElementStyles === nextElementStyles;
            if (isSiblings && isSameStyles) {
                isReplacementNeeded = false;
                currentElement.parentNode.removeChild(currentElement);
                elementToReplace = nextElement;
            }
            else {
                isReplacementNeeded = true;
            }
        }
        else {
            isReplacementNeeded = true;
        }
        textElementInnerHtml += currentElement.innerHTML;
        if (isReplacementNeeded) {
            var newElements = getTextElementsFromStyles(currentElementStyles, textElementInnerHtml);
            if (isAccessible) {
                replaceTextElementsAccessible(elementToReplace, newElements);
            }
            else {
                replaceTextElements(elementToReplace, newElements);
            }
            textElementInnerHtml = '';
        }
    });
};
var getContent = function (parentClassName, element, css, scale, isEditedFromBackoffice, editableData, isAccessible) {
    var paragraphElements = isAccessible
        ? __spread(element.querySelectorAll('#page-container'))
        : __spread(element.querySelectorAll('p, li'));
    var textElements = isAccessible
        ? __spread(element.querySelectorAll('h1, h2, h3, h4, h5, h6, p'))
        : __spread(element.querySelectorAll('p span, li span'));
    if (isEditedFromBackoffice && !isAccessible) {
        getModifiedParagraphElementsStyle(paragraphElements, scale);
        getModifiedTextElementsContent(textElements, scale);
    }
    else {
        getUnmodifiedParagraphElementsStyle(parentClassName, paragraphElements, css, scale, editableData, isAccessible);
        getUnmodifiedTextElementsContent(textElements, css, scale, editableData, isAccessible);
    }
    var content = isEditedFromBackoffice || isAccessible
        ? element.innerHTML
        // We have to remove unnecessary spaces generated by inDesign for proper render in <RichTextEditor />
        : __WEBPACK_IMPORTED_MODULE_2__helpers__["G" /* getStringWithoutSpaces */](element.innerHTML);
    // tslint:disable-next-line: max-line-length
    // is needed to have the same html string in store and <RichTextEditor /> inner state in order to prevent issues when text field was focused and then blurred without any modification:
    // 1) unexpected saving of page with the text field;
    // 2) creation of instance in history state.
    var deserializedContent = __WEBPACK_IMPORTED_MODULE_4__components_Editor_RichTextEditor_helpers__["a" /* default */].html.deserialize(content);
    var serializedContent = __WEBPACK_IMPORTED_MODULE_4__components_Editor_RichTextEditor_helpers__["a" /* default */].html.serialize(deserializedContent);
    return serializedContent;
};
// in some cases (text frame inside animated frame) we have to change some styles of text frame parent element. To achieve it we have to know parent id
var getParentId = function (element) {
    var elementWrapperSelector = "[id*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].parentContainerId + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldClassName + "]) > div[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldWrapperClassName + "]";
    var elementWrapper = element.closest(elementWrapperSelector);
    var elementWrapperParent = elementWrapper && elementWrapper.parentNode;
    return elementWrapperParent ? elementWrapperParent.id : null;
};
var getConfig = function (element, page, pageIndexInSpread, css, editableData, isAccessible) {
    var id = element.id, className = element.className, classList = element.classList;
    var innerDiv = element.querySelector('div');
    if (!innerDiv) {
        return;
    }
    var filteredClassName = className.split(' ').find(function (className) { return (className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldClassName)); }) || '';
    if (__WEBPACK_IMPORTED_MODULE_2__helpers__["W" /* isDuplicatedItemInSpread */](filteredClassName, pageIndexInSpread)) {
        return {
            page: page,
            id: id,
            className: filteredClassName,
        };
    }
    var style = innerDiv.style || {};
    var scale = __WEBPACK_IMPORTED_MODULE_2__helpers__["B" /* getScaleFromStyle */](style) || 1;
    var width = style.width ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](style.width) * scale : undefined;
    var height = style.height ? __WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* getNumberFromString */](style.height) * scale : undefined;
    width = width || 0;
    height = height || 0;
    var isEditedFromBackoffice = classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* editedElementClassName */]);
    return {
        page: page,
        width: width,
        height: height,
        id: id,
        className: filteredClassName,
        parentId: getParentId(element),
        transformStyle: __WEBPACK_IMPORTED_MODULE_2__helpers__["N" /* getTransformStyle */](style),
        content: getContent(className, innerDiv, css, scale, isEditedFromBackoffice, editableData, isAccessible),
        scale: scale,
        // some text fields have transform: scale property. We have to take it into account to calculate correct outline width of active text frame
        selfScale: __WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* getElementScale */](element, css),
        verticalAlignClassName: __WEBPACK_IMPORTED_MODULE_2__helpers__["R" /* getVerticalAlignClassName */](className),
        isThemedItem: className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].themedItemClassName),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (function (page, pageIndexInSpread, htmlDocument, css, isModifiedFromBackoffice, isAccessible) {
    if (isAccessible === void 0) { isAccessible = false; }
    var items = [];
    var duplicatedItemsInSpread = [];
    var editableData = isModifiedFromBackoffice
        ? undefined
        : {
            fontFamilies: new Set(),
            fontSizes: new Set(),
            colors: new Set(),
            lineHeights: new Set(),
            letterSpacings: new Set(),
        };
    var editableTextFieldElements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldClassName + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName + "])")).filter(function (element) { return !__WEBPACK_IMPORTED_MODULE_2__helpers__["V" /* hasLockedParent */](element); });
    var isError = false;
    try {
        editableTextFieldElements.forEach(function (fieldElement) {
            var config = getConfig(fieldElement, page, pageIndexInSpread, css, editableData, isAccessible);
            if (config) {
                if ('content' in config) {
                    items.push(config);
                }
                else {
                    duplicatedItemsInSpread.push(config);
                }
            }
        });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        duplicatedItemsInSpread: duplicatedItemsInSpread,
        editableData: editableData,
        isError: isError,
    };
});


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slate_html_serializer__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_styles__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_css_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__ = __webpack_require__(8);






/**
 * Slate uses 'nodes' for rendering blocks with text and 'marks' for rendering formatting options (like bold, italic, etc).
 */
// This object defines how to convert input html tags (blocks, hyperlinks) to Slate objects (deserialize) and vice versa (serialize)
var nodeRules = {
    // tslint:disable-next-line no-any
    deserialize: function (el, next) {
        var elData = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* BLOCK_AND_INLINE_TAGS */][el.tagName.toLowerCase()];
        if (elData) {
            var type = elData.type, object = elData.object;
            return {
                object: object,
                type: type,
                data: {
                    style: __WEBPACK_IMPORTED_MODULE_2_css_styles___default.a.parse(el.getAttribute('style')),
                    className: el.getAttribute('class'),
                    href: el.getAttribute('href'),
                    action: el.getAttribute('onclick') || el.getAttribute('data-action'),
                    'aria-label': el.getAttribute('aria-label'),
                },
                nodes: next(el.childNodes),
            };
        }
    },
    // tslint:disable-next-line no-any
    serialize: function (_a, children) {
        var object = _a.object, type = _a.type, data = _a.data, text = _a.text;
        if (object === __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].block) {
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].p) {
                if ((!data.get('style') || !data.get('style').lineHeight) && (!text || text.trim().length === 0)) {
                    return null;
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].h1) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].h2) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].h3) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].h4) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].h5) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].h6) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].ul) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].ol) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ol", { style: data.get('style'), className: data.get('className') }, children));
            }
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].li) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { style: data.get('style'), className: data.get('className') }, children));
            }
        }
        if (object === __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].inline) {
            if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INLINE_TYPES */].a) {
                // We have to remove link when all text for link was deleted
                if (!text) {
                    return null;
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: data.get('href'), "data-action": data.get('action'), target: "_blank", className: data.get('className') || __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["s" /* linkClassName */] }, children));
            }
        }
        if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].section) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { style: data.get('style'), className: data.get('className'), "aria-label": data.get('aria-label') }, children));
        }
        if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BLOCK_TYPES */].aside) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("aside", { style: data.get('style'), className: data.get('className'), "aria-label": data.get('aria-label') }, children));
        }
        return;
    },
};
// This object defines how to convert input html tags (marks) to Slate objects (deserialize) and vice versa (serialize)
var markRules = {
    // tslint:disable-next-line no-any
    deserialize: function (el, next) {
        if (el.tagName.toLowerCase() === __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* MARK_TAGS */].span) {
            var style = el.getAttribute('style');
            var className = el.getAttribute('class');
            if (style) {
                var styleName = style.split(':')[0];
                return {
                    object: __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].mark,
                    type: __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* MARK_TYPES */].includes(styleName) ? styleName : __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* STYLE_TYPES */].UNEDITABLE_STYLES,
                    data: {
                        className: className,
                        style: __WEBPACK_IMPORTED_MODULE_2_css_styles___default.a.parse(style),
                    },
                    nodes: next(el.childNodes),
                };
            }
            if (className) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__["_1" /* isTextScriptElement */])(className)) {
                    return {
                        object: __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].mark,
                        type: __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT,
                        data: {
                            className: Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__["L" /* getTextScriptClassName */])(className),
                        },
                        nodes: next(el.childNodes),
                    };
                }
                return {
                    object: __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].mark,
                    type: __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* STYLE_TYPES */].UNEDITABLE_STYLES,
                    data: {
                        className: className,
                    },
                    nodes: next(el.childNodes),
                };
            }
            return {
                object: __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].mark,
                type: __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* STYLE_TYPES */].EMPTY,
                nodes: next(el.childNodes),
            };
        }
    },
    // tslint:disable-next-line no-any
    serialize: function (_a, children) {
        var object = _a.object, type = _a.type, data = _a.data;
        if (object === __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* OBJECT_TYPES */].mark) {
            if (__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* MARK_TYPES */].includes(type)) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: data.get('className'), style: data.get('style') }, children));
            }
        }
        return;
    },
};
var rules = [nodeRules, markRules];
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_slate_html_serializer__["a" /* default */]({ rules: rules }));


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_type_of__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_type_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_type_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slate__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);






var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * String.
 *
 * @type {String}
 */

var String = new __WEBPACK_IMPORTED_MODULE_4_immutable__["Record"]({
  object: 'string',
  text: ''
});

/**
 * A rule to (de)serialize text nodes. This is automatically added to the HTML
 * serializer so that users don't have to worry about text-level serialization.
 *
 * @type {Object}
 */

var TEXT_RULE = {
  deserialize: function deserialize(el) {
    if (el.tagName && el.tagName.toLowerCase() === 'br') {
      return {
        object: 'text',
        text: '\n',
        marks: []
      };
    }

    if (el.nodeName === '#text') {
      if (el.nodeValue && el.nodeValue.match(/<!--.*?-->/)) return;

      return {
        object: 'text',
        text: el.nodeValue,
        marks: []
      };
    }
  },
  serialize: function serialize(obj, children) {
    if (obj.object === 'string') {
      return children.split('\n').reduce(function (array, text, i) {
        if (i !== 0) array.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { key: i }));
        array.push(text);
        return array;
      }, []);
    }
  }
};

/**
 * A default `parseHtml` function that returns the `<body>` using `DOMParser`.
 *
 * @param {String} html
 * @return {Object}
 */

function defaultParseHtml(html) {
  if (typeof DOMParser == 'undefined') {
    throw new Error('The native `DOMParser` global which the `Html` serializer uses by default is not present in this environment. You must supply the `options.parseHtml` function instead.');
  }

  var parsed = new DOMParser().parseFromString(html, 'text/html');
  var body = parsed.body;
  // COMPAT: in IE 11 body is null if html is an empty string

  return body || window.document.createElement('body');
}

/**
 * HTML serializer.
 *
 * @type {Html}
 */

var Html =
/**
 * Create a new serializer with `rules`.
 *
 * @param {Object} options
 *   @property {Array} rules
 *   @property {String|Object|Block} defaultBlock
 *   @property {Function} parseHtml
 */

function Html() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  classCallCheck(this, Html);

  _initialiseProps.call(this);

  var _options$defaultBlock = options.defaultBlock,
      defaultBlock = _options$defaultBlock === undefined ? 'paragraph' : _options$defaultBlock,
      _options$parseHtml = options.parseHtml,
      parseHtml = _options$parseHtml === undefined ? defaultParseHtml : _options$parseHtml,
      _options$rules = options.rules,
      rules = _options$rules === undefined ? [] : _options$rules;


  defaultBlock = __WEBPACK_IMPORTED_MODULE_3_slate__["i" /* Node */].createProperties(defaultBlock);

  this.rules = [].concat(toConsumableArray(rules), [TEXT_RULE]);
  this.defaultBlock = defaultBlock;
  this.parseHtml = parseHtml;
};

/**
 * Add a unique key to a React `element`.
 *
 * @param {Element} element
 * @return {Element}
 */

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.deserialize = function (html) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$toJSON = options.toJSON,
        toJSON = _options$toJSON === undefined ? false : _options$toJSON;
    var defaultBlock = _this.defaultBlock,
        parseHtml = _this.parseHtml;

    var fragment = parseHtml(html);
    var children = Array.from(fragment.childNodes);
    var nodes = _this.deserializeElements(children);

    // COMPAT: ensure that all top-level inline nodes are wrapped into a block.
    nodes = nodes.reduce(function (memo, node, i, original) {
      if (node.object === 'block') {
        memo.push(node);
        return memo;
      }

      if (i > 0 && original[i - 1].object !== 'block') {
        var _block = memo[memo.length - 1];
        _block.nodes.push(node);
        return memo;
      }

      var block = _extends({
        object: 'block',
        data: {}
      }, defaultBlock, {
        nodes: [node]
      });

      memo.push(block);
      return memo;
    }, []);

    // TODO: pretty sure this is no longer needed.
    if (nodes.length === 0) {
      nodes = [_extends({
        object: 'block',
        data: {}
      }, defaultBlock, {
        nodes: [{
          object: 'text',
          text: '',
          marks: []
        }]
      })];
    }

    var json = {
      object: 'value',
      document: {
        object: 'document',
        data: {},
        nodes: nodes
      }
    };

    var ret = toJSON ? json : __WEBPACK_IMPORTED_MODULE_3_slate__["n" /* Value */].fromJSON(json);
    return ret;
  };

  this.deserializeElements = function () {
    var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var nodes = [];

    elements.filter(_this.cruftNewline).forEach(function (element) {
      var node = _this.deserializeElement(element);

      switch (__WEBPACK_IMPORTED_MODULE_2_type_of___default()(node)) {
        case 'array':
          nodes = nodes.concat(node);
          break;
        case 'object':
          nodes.push(node);
          break;
      }
    });

    return nodes;
  };

  this.deserializeElement = function (element) {
    var node = void 0;

    if (!element.tagName) {
      element.tagName = '';
    }

    var next = function next(elements) {
      if (Object.prototype.toString.call(elements) === '[object NodeList]') {
        elements = Array.from(elements);
      }

      switch (__WEBPACK_IMPORTED_MODULE_2_type_of___default()(elements)) {
        case 'array':
          return _this.deserializeElements(elements);
        case 'object':
          return _this.deserializeElement(elements);
        case 'null':
        case 'undefined':
          return;
        default:
          throw new Error('The `next` argument was called with invalid children: "' + elements + '".');
      }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _this.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var rule = _step.value;

        if (!rule.deserialize) continue;
        var ret = rule.deserialize(element, next);
        var type = __WEBPACK_IMPORTED_MODULE_2_type_of___default()(ret);

        if (type !== 'array' && type !== 'object' && type !== 'null' && type !== 'undefined') {
          throw new Error('A rule returned an invalid deserialized representation: "' + node + '".');
        }

        if (ret === undefined) {
          continue;
        } else if (ret === null) {
          return null;
        } else if (ret.object === 'mark') {
          node = _this.deserializeMark(ret);
        } else {
          node = ret;
        }

        if (node.object === 'block' || node.object === 'inline') {
          node.data = node.data || {};
          node.nodes = node.nodes || [];
        } else if (node.object === 'text') {
          node.marks = node.marks || [];
          node.text = node.text || '';
        }

        break;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return node || next(element.childNodes);
  };

  this.deserializeMark = function (mark) {
    var type = mark.type,
        data = mark.data;


    var applyMark = function applyMark(node) {
      if (node.object === 'mark') {
        var ret = _this.deserializeMark(node);
        return ret;
      } else if (node.object === 'text') {
        node.marks = node.marks || [];
        node.marks.push({ type: type, data: data });
      } else if (node.nodes) {
        node.nodes = node.nodes.map(applyMark);
      }

      return node;
    };

    return mark.nodes.reduce(function (nodes, node) {
      var ret = applyMark(node);
      if (Array.isArray(ret)) return nodes.concat(ret);
      nodes.push(ret);
      return nodes;
    }, []);
  };

  this.serialize = function (value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var document = value.document;

    var elements = document.nodes.map(_this.serializeNode).filter(function (el) {
      return el;
    });
    if (options.render === false) return elements;

    var html = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__["renderToStaticMarkup"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'body',
      null,
      elements
    ));
    var inner = html.slice(6, -7);
    return inner;
  };

  this.serializeNode = function (node) {
    if (node.object === 'text') {
      var string = new String({ text: node.text });
      var text = _this.serializeString(string);

      return node.marks.reduce(function (children, mark) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this.rules[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var rule = _step2.value;

            if (!rule.serialize) continue;
            var ret = rule.serialize(mark, children);
            if (ret === null) return;
            if (ret) return addKey(ret);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        throw new Error('No serializer defined for mark of type "' + mark.type + '".');
      }, text);
    }

    var children = node.nodes.map(_this.serializeNode);

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = _this.rules[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var rule = _step3.value;

        if (!rule.serialize) continue;
        var ret = rule.serialize(node, children);
        if (ret === null) return;
        if (ret) return addKey(ret);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    throw new Error('No serializer defined for node of type "' + node.type + '".');
  };

  this.serializeString = function (string) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = _this.rules[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var rule = _step4.value;

        if (!rule.serialize) continue;
        var ret = rule.serialize(string, string.text);
        if (ret) return ret;
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  };

  this.cruftNewline = function (element) {
    return !(element.nodeName === '#text' && element.nodeValue === '\n');
  };
};

var key = 0;

function addKey(element) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(element, { key: key++ });
}

/* harmony default export */ __webpack_exports__["a"] = (Html);
//# sourceMappingURL=slate-html-serializer.es.js.map


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(915);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(129),q=__webpack_require__(0);function aa(a,b,d,c,f,e,h,g){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var D=[d,c,f,e,h,g],B=0;a=Error(b.replace(/%s/g,function(){return D[B++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function r(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var v="function"===typeof Symbol&&Symbol.for,ba=v?Symbol.for("react.portal"):60106,x=v?Symbol.for("react.fragment"):60107,ca=v?Symbol.for("react.strict_mode"):60108,da=v?Symbol.for("react.profiler"):60114,z=v?Symbol.for("react.provider"):60109,ea=v?Symbol.for("react.context"):60110,fa=v?Symbol.for("react.concurrent_mode"):60111,ha=v?Symbol.for("react.forward_ref"):60112,A=v?Symbol.for("react.suspense"):60113,ia=v?Symbol.for("react.memo"):60115,ja=v?Symbol.for("react.lazy"):60116;
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fa:return"ConcurrentMode";case x:return"Fragment";case ba:return"Portal";case da:return"Profiler";case ca:return"StrictMode";case A:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ea:return"Context.Consumer";case z:return"Context.Provider";case ha:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case ia:return C(a.type);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var E=q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;E.hasOwnProperty("ReactCurrentDispatcher")||(E.ReactCurrentDispatcher={current:null});var ka={};function F(a,b){for(var d=a._threadCount|0;d<=b;d++)a[d]=a._currentValue2,a._threadCount=d+1}
function la(a,b,d){var c=a.contextType;if("object"===typeof c&&null!==c)return F(c,d),c[d];if(a=a.contextTypes){d={};for(var f in a)d[f]=b[f];b=d}else b=ka;return b}for(var G=new Uint16Array(16),H=0;15>H;H++)G[H]=H+1;G[15]=0;
var ma=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,na=Object.prototype.hasOwnProperty,oa={},pa={};
function qa(a){if(na.call(pa,a))return!0;if(na.call(oa,a))return!1;if(ma.test(a))return pa[a]=!0;oa[a]=!0;return!1}function ra(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function sa(a,b,d,c){if(null===b||"undefined"===typeof b||ra(a,b,d,c))return!0;if(c)return!1;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=f;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a,null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){J[a]=new I(a,1,!1,a.toLowerCase(),null)});var ta=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ta.exec(a);if(b){var d="",c,f=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==c&&(d+=a.substring(f,c));f=c+1;d+=b}a=f!==c?d+a.substring(f,c):d}return a}var N=null,O=null,P=null,Q=!1,S=!1,T=null,U=0;function V(){null===N?r("321"):void 0;return N}
function ua(){0<U&&r("312");return{memoizedState:null,queue:null,next:null}}function W(){null===P?null===O?(Q=!1,O=P=ua()):(Q=!0,P=O):null===P.next?(Q=!1,P=P.next=ua()):(Q=!0,P=P.next);return P}function va(a,b,d,c){for(;S;)S=!1,U+=1,P=null,d=a(b,c);O=N=null;U=0;P=T=null;return d}function wa(a,b){return"function"===typeof b?b(a):b}
function xa(a,b,d){N=V();P=W();if(Q){var c=P.queue;b=c.dispatch;if(null!==T&&(d=T.get(c),void 0!==d)){T.delete(c);c=P.memoizedState;do c=a(c,d.action),d=d.next;while(null!==d);P.memoizedState=c;return[c,b]}return[P.memoizedState,b]}a=a===wa?"function"===typeof b?b():b:void 0!==d?d(b):b;P.memoizedState=a;a=P.queue={last:null,dispatch:null};a=a.dispatch=ya.bind(null,N,a);return[P.memoizedState,a]}
function ya(a,b,d){25>U?void 0:r("301");if(a===N)if(S=!0,a={action:d,next:null},null===T&&(T=new Map),d=T.get(b),void 0===d)T.set(b,a);else{for(b=d;null!==b.next;)b=b.next;b.next=a}}function za(){}
var X=0,Aa={readContext:function(a){var b=X;F(a,b);return a[b]},useContext:function(a){V();var b=X;F(a,b);return a[b]},useMemo:function(a,b){N=V();P=W();b=void 0===b?null:b;if(null!==P){var d=P.memoizedState;if(null!==d&&null!==b){a:{var c=d[1];if(null===c)c=!1;else{for(var f=0;f<c.length&&f<b.length;f++){var e=b[f],h=c[f];if((e!==h||0===e&&1/e!==1/h)&&(e===e||h===h)){c=!1;break a}}c=!0}}if(c)return d[0]}}a=a();P.memoizedState=[a,b];return a},useReducer:xa,useRef:function(a){N=V();P=W();var b=P.memoizedState;
return null===b?(a={current:a},P.memoizedState=a):b},useState:function(a){return xa(wa,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:za,useEffect:za,useDebugValue:za},Ba={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function Ca(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Da={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ea=p({menuitem:!0},Da),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Fa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Fa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Ga=/([A-Z])/g,Ha=/^ms-/,Z=q.Children.toArray,Ia=E.ReactCurrentDispatcher,Ja={listing:!0,pre:!0,textarea:!0},Ka=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,La={},Ma={};function Na(a){if(void 0===a||null===a)return a;var b="";q.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Oa=Object.prototype.hasOwnProperty,Pa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Qa(a,b){void 0===a&&r("152",C(b)||"Component")}
function Ra(a,b,d){function c(c,f){var e=la(f,b,d),g=[],h=!1,l={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===g)return null},enqueueReplaceState:function(a,b){h=!0;g=[b]},enqueueSetState:function(a,b){if(null===g)return null;g.push(b)}},k=void 0;if(f.prototype&&f.prototype.isReactComponent){if(k=new f(c.props,e,l),"function"===typeof f.getDerivedStateFromProps){var t=f.getDerivedStateFromProps.call(null,c.props,k.state);null!=t&&(k.state=p({},k.state,t))}}else if(N={},k=f(c.props,
e,l),k=va(f,c.props,k,e),null==k||null==k.render){a=k;Qa(a,f);return}k.props=c.props;k.context=e;k.updater=l;l=k.state;void 0===l&&(k.state=l=null);if("function"===typeof k.UNSAFE_componentWillMount||"function"===typeof k.componentWillMount)if("function"===typeof k.componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.componentWillMount(),"function"===typeof k.UNSAFE_componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.UNSAFE_componentWillMount(),g.length){l=g;var m=
h;g=null;h=!1;if(m&&1===l.length)k.state=l[0];else{t=m?l[0]:k.state;var u=!0;for(m=m?1:0;m<l.length;m++){var w=l[m];w="function"===typeof w?w.call(k,t,c.props,e):w;null!=w&&(u?(u=!1,t=p({},t,w)):p(t,w))}k.state=t}}else g=null;a=k.render();Qa(a,f);c=void 0;if("function"===typeof k.getChildContext&&(e=f.childContextTypes,"object"===typeof e)){c=k.getChildContext();for(var R in c)R in e?void 0:r("108",C(f)||"Unknown",R)}c&&(b=p({},b,c))}for(;q.isValidElement(a);){var f=a,e=f.type;if("function"!==typeof e)break;
c(f,e)}return{child:a,context:b}}
var Sa=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");q.isValidElement(b)?b.type!==x?b=[b]:(b=b.props.children,b=q.isValidElement(b)?[b]:Z(b)):b=Z(b);b={type:null,domNamespace:Ba.html,children:b,childIndex:0,context:ka,footer:""};var c=G[0];if(0===c){var f=G;c=f.length;var e=2*c;65536>=e?void 0:r("304");var h=new Uint16Array(e);h.set(f);G=h;G[0]=c+1;for(f=c;f<e-1;f++)G[f]=f+1;G[e-1]=0}else G[0]=G[c];this.threadID=c;this.stack=[b];this.exhausted=
!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;G[a]=G[0];G[0]=a}};a.prototype.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,f=this.threadID;F(c,f);var e=c[f];this.contextStack[b]=c;this.contextValueStack[b]=e;c[f]=a.props.value};a.prototype.popProvider=
function(){var a=this.contextIndex,d=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;d[this.threadID]=c};a.prototype.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};a.prototype.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ia.current;Ia.current=Aa;try{for(var f=[""],e=!1;f[0].length<a;){if(0===this.stack.length){this.exhausted=
!0;var h=this.threadID;G[h]=G[0];G[0]=h;break}var g=this.stack[this.stack.length-1];if(e||g.childIndex>=g.children.length){var D=g.footer;""!==D&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===g.type)this.currentSelectValue=null;else if(null!=g.type&&null!=g.type.type&&g.type.type.$$typeof===z)this.popProvider(g.type);else if(g.type===A){this.suspenseDepth--;var B=f.pop();if(e){e=!1;var n=g.fallbackFrame;n?void 0:r("303");this.stack.push(n);continue}else f[this.suspenseDepth]+=B}f[this.suspenseDepth]+=
D}else{var l=g.children[g.childIndex++],k="";try{k+=this.render(l,g.context,g.domNamespace)}catch(t){throw t;}finally{}f.length<=this.suspenseDepth&&f.push("");f[this.suspenseDepth]+=k}}return f[0]}finally{Ia.current=c,X=b}};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=!0;return M(c)}d=Ra(a,d,this.threadID);a=d.child;d=d.context;
if(null===a||!1===a)return"";if(!q.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ba?r("257"):void 0;r("258",b.toString())}a=Z(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ca:case fa:case da:case x:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case A:r("294")}if("object"===
typeof b&&null!==b)switch(b.$$typeof){case ha:N={};var e=b.render(a.props,a.ref);e=va(b.render,a.props,e,a.ref);e=Z(e);this.stack.push({type:null,domNamespace:c,children:e,childIndex:0,context:d,footer:""});return"";case ia:return a=[q.createElement(b.type,p({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case z:return b=Z(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),
"";case ea:b=a.type;e=a.props;var h=this.threadID;F(b,h);b=Z(e.children(b[h]));this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""});return"";case ja:r("295")}r("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===Ba.html&&Ca(b);La.hasOwnProperty(b)||(Ka.test(b)?void 0:r("65",b),La[b]=!0);var e=a.props;if("input"===b)e=p({type:void 0},e,{defaultChecked:void 0,defaultValue:void 0,value:null!=e.value?e.value:e.defaultValue,
checked:null!=e.checked?e.checked:e.defaultChecked});else if("textarea"===b){var h=e.value;if(null==h){h=e.defaultValue;var g=e.children;null!=g&&(null!=h?r("92"):void 0,Array.isArray(g)&&(1>=g.length?void 0:r("93"),g=g[0]),h=""+g);null==h&&(h="")}e=p({},e,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=e.value?e.value:e.defaultValue,e=p({},e,{value:void 0});else if("option"===b){g=this.currentSelectValue;var D=Na(e.children);if(null!=g){var B=null!=e.value?e.value+
"":D;h=!1;if(Array.isArray(g))for(var n=0;n<g.length;n++){if(""+g[n]===B){h=!0;break}}else h=""+g===B;e=p({selected:void 0,children:void 0},e,{selected:h,children:D})}}if(h=e)Ea[b]&&(null!=h.children||null!=h.dangerouslySetInnerHTML?r("137",b,""):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?r("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:r("61")),null!=h.style&&"object"!==typeof h.style?r("62",""):void 0;h=e;g=this.makeStaticMarkup;
D=1===this.stack.length;B="<"+a.type;for(y in h)if(Oa.call(h,y)){var l=h[y];if(null!=l){if("style"===y){n=void 0;var k="",t="";for(n in l)if(l.hasOwnProperty(n)){var m=0===n.indexOf("--"),u=l[n];if(null!=u){var w=n;if(Ma.hasOwnProperty(w))w=Ma[w];else{var R=w.replace(Ga,"-$1").toLowerCase().replace(Ha,"-ms-");w=Ma[w]=R}k+=t+w+":";t=n;m=null==u||"boolean"===typeof u||""===u?"":m||"number"!==typeof u||0===u||Y.hasOwnProperty(t)&&Y[t]?(""+u).trim():u+"px";k+=m;t=";"}}l=k||null}n=null;b:if(m=b,u=h,-1===
m.indexOf("-"))m="string"===typeof u.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)Pa.hasOwnProperty(y)||(n=y,n=qa(n)&&null!=l?n+"="+('"'+M(l)+'"'):"");else{m=y;n=l;l=J.hasOwnProperty(m)?J[m]:null;if(u="style"!==m)u=null!==l?0===l.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;u||sa(m,n,l,!1)?n="":null!==
l?(m=l.attributeName,l=l.type,n=3===l||4===l&&!0===n?m+'=""':m+"="+('"'+M(n)+'"')):n=qa(m)?m+"="+('"'+M(n)+'"'):""}n&&(B+=" "+n)}}g||D&&(B+=' data-reactroot=""');var y=B;h="";Da.hasOwnProperty(b)?y+="/>":(y+=">",h="</"+a.type+">");a:{g=e.dangerouslySetInnerHTML;if(null!=g){if(null!=g.__html){g=g.__html;break a}}else if(g=e.children,"string"===typeof g||"number"===typeof g){g=M(g);break a}g=null}null!=g?(e=[],Ja[b]&&"\n"===g.charAt(0)&&(y+="\n"),y+=g):e=Z(e.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===
c?Ca(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:e,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return y};return a}(),Ta={renderToString:function(a){a=new Sa(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Sa(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){r("207")},renderToStaticNodeStream:function(){r("208")},
version:"16.8.6"},Ua={default:Ta},Va=Ua&&Ta||Ua;module.exports=Va.default||Va;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Function]': return 'function'
    case '[object Date]': return 'date'
    case '[object RegExp]': return 'regexp'
    case '[object Arguments]': return 'arguments'
    case '[object Array]': return 'array'
    case '[object String]': return 'string'
  }

  if (typeof val == 'object' && val && typeof val.length == 'number') {
    try {
      if (typeof val.callee == 'function') return 'arguments';
    } catch (ex) {
      if (ex instanceof TypeError) {
        return 'arguments';
      }
    }
  }

  if (val === null) return 'null'
  if (val === undefined) return 'undefined'
  if (val && val.nodeType === 1) return 'element'
  if (val === Object(val)) return 'object'

  return typeof val
}


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(918);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__(920)(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__(921);
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */


  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;



/***/ }),
/* 921 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/esrever v0.2.0 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var regexSymbolWithCombiningMarks = /([\0-\u02FF\u0370-\u1AAF\u1B00-\u1DBF\u1E00-\u20CF\u2100-\uD7FF\uE000-\uFE1F\uFE30-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])([\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]+)/g;
	var regexSurrogatePair = /([\uD800-\uDBFF])([\uDC00-\uDFFF])/g;

	var reverse = function(string) {
		// Step 1: deal with combining marks and astral symbols (surrogate pairs)
		string = string
			// Swap symbols with their combining marks so the combining marks go first
			.replace(regexSymbolWithCombiningMarks, function($0, $1, $2) {
				// Reverse the combining marks so they will end up in the same order
				// later on (after another round of reversing)
				return reverse($2) + $1;
			})
			// Swap high and low surrogates so the low surrogates go first
			.replace(regexSurrogatePair, '$2$1');
		// Step 2: reverse the code units in the string
		var result = '';
		var index = string.length;
		while (index--) {
			result += string.charAt(index);
		}
		return result;
	};

	/*--------------------------------------------------------------------------*/

	var esrever = {
		'version': '0.2.0',
		'reverse': reverse
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return esrever;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = esrever;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in esrever) {
				esrever.hasOwnProperty(key) && (freeExports[key] = esrever[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.esrever = esrever;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module), __webpack_require__(20)))

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(924),
    flatRest = __webpack_require__(491);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(925),
    hasIn = __webpack_require__(956);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(482),
    baseSet = __webpack_require__(955),
    castPath = __webpack_require__(142);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(98),
    isSymbol = __webpack_require__(228);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(178);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(930);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(931);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(484);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(933),
    ListCache = __webpack_require__(230),
    Map = __webpack_require__(310);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(934),
    hashDelete = __webpack_require__(939),
    hashGet = __webpack_require__(940),
    hashHas = __webpack_require__(941),
    hashSet = __webpack_require__(942);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(229);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(485),
    isMasked = __webpack_require__(936),
    isObject = __webpack_require__(86),
    toSource = __webpack_require__(486);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(937);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 939 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(229);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(229);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(229);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(231);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(232);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(232);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(232);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(232);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(954);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(178),
    arrayMap = __webpack_require__(488),
    isArray = __webpack_require__(98),
    isSymbol = __webpack_require__(228);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(311),
    castPath = __webpack_require__(142),
    isIndex = __webpack_require__(312),
    isObject = __webpack_require__(86),
    toKey = __webpack_require__(233);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(957),
    hasPath = __webpack_require__(958);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(142),
    isArguments = __webpack_require__(313),
    isArray = __webpack_require__(98),
    isIndex = __webpack_require__(312),
    isLength = __webpack_require__(314),
    toKey = __webpack_require__(233);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(143),
    isObjectLike = __webpack_require__(116);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(961);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(315),
    isFlattenable = __webpack_require__(962);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(178),
    isArguments = __webpack_require__(313),
    isArray = __webpack_require__(98);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(964);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 964 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(966),
    shortOut = __webpack_require__(969);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(967),
    defineProperty = __webpack_require__(490),
    identity = __webpack_require__(968);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 968 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(971),
    arrayEach = __webpack_require__(977),
    assignValue = __webpack_require__(311),
    baseAssign = __webpack_require__(978),
    baseAssignIn = __webpack_require__(985),
    cloneBuffer = __webpack_require__(988),
    copyArray = __webpack_require__(989),
    copySymbols = __webpack_require__(990),
    copySymbolsIn = __webpack_require__(992),
    getAllKeys = __webpack_require__(993),
    getAllKeysIn = __webpack_require__(501),
    getTag = __webpack_require__(322),
    initCloneArray = __webpack_require__(998),
    initCloneByTag = __webpack_require__(999),
    initCloneObject = __webpack_require__(1005),
    isArray = __webpack_require__(98),
    isBuffer = __webpack_require__(494),
    isMap = __webpack_require__(1007),
    isObject = __webpack_require__(86),
    isSet = __webpack_require__(1009),
    keys = __webpack_require__(316);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(230),
    stackClear = __webpack_require__(972),
    stackDelete = __webpack_require__(973),
    stackGet = __webpack_require__(974),
    stackHas = __webpack_require__(975),
    stackSet = __webpack_require__(976);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(230);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 974 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 975 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(230),
    Map = __webpack_require__(310),
    MapCache = __webpack_require__(484);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 977 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(179),
    keys = __webpack_require__(316);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 979 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(982),
    baseUnary = __webpack_require__(317),
    nodeUtil = __webpack_require__(318);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(143),
    isLength = __webpack_require__(314),
    isObjectLike = __webpack_require__(116);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(319),
    nativeKeys = __webpack_require__(984);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(495);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(179),
    keysIn = __webpack_require__(497);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86),
    isPrototype = __webpack_require__(319),
    nativeKeysIn = __webpack_require__(987);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 987 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(63);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 989 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(179),
    getSymbols = __webpack_require__(320);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 991 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(179),
    getSymbolsIn = __webpack_require__(499);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(500),
    getSymbols = __webpack_require__(320),
    keys = __webpack_require__(316);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(117),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(323),
    cloneDataView = __webpack_require__(1001),
    cloneRegExp = __webpack_require__(1002),
    cloneSymbol = __webpack_require__(1003),
    cloneTypedArray = __webpack_require__(1004);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(323);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(178);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(323);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1006),
    getPrototype = __webpack_require__(321),
    isPrototype = __webpack_require__(319);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1008),
    baseUnary = __webpack_require__(317),
    nodeUtil = __webpack_require__(318);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(322),
    isObjectLike = __webpack_require__(116);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1010),
    baseUnary = __webpack_require__(317),
    nodeUtil = __webpack_require__(318);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(322),
    isObjectLike = __webpack_require__(116);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(142),
    last = __webpack_require__(1012),
    parent = __webpack_require__(1013),
    toKey = __webpack_require__(233);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(482),
    baseSlice = __webpack_require__(1014);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(1016);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(143),
    getPrototype = __webpack_require__(321),
    isObjectLike = __webpack_require__(116);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GROUP_LEFT_TO_RIGHT,
    GROUP_RIGHT_TO_LEFT,
    EXPRESSION_LEFT_TO_RIGHT,
    EXPRESSION_RIGHT_TO_LEFT;

/*
 * Character ranges of left-to-right characters.
 */

GROUP_LEFT_TO_RIGHT = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' +
    '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' +
    '\uFE00-\uFE6F\uFEFD-\uFFFF';

/*
 * Character ranges of right-to-left characters.
 */

GROUP_RIGHT_TO_LEFT = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';

/*
 * Expression to match a left-to-right string.
 *
 * Matches the start of a string, followed by zero or
 * more non-right-to-left characters, followed by a
 * left-to-right character.
 */

EXPRESSION_LEFT_TO_RIGHT = new RegExp(
    '^[^' + GROUP_RIGHT_TO_LEFT + ']*[' + GROUP_LEFT_TO_RIGHT + ']'
);

/*
 * Expression to match a right-to-left string.
 *
 * Matches the start of a string, followed by zero or
 * more non-left-to-right characters, followed by a
 * right-to-left character.
 */

EXPRESSION_RIGHT_TO_LEFT = new RegExp(
    '^[^' + GROUP_LEFT_TO_RIGHT + ']*[' + GROUP_RIGHT_TO_LEFT + ']'
);

/**
 * Detect the direction of text.
 *
 * @param {string} value - value to stringify and check.
 * @return {string} - One of `"rtl"`, `"ltr"`, or
 *   `"neutral"`.
 */
function direction(value) {
    value = value.toString();

    if (EXPRESSION_RIGHT_TO_LEFT.test(value)) {
        return 'rtl';
    }

    if (EXPRESSION_LEFT_TO_RIGHT.test(value)) {
        return 'ltr';
    }

    return 'neutral';
}

/*
 * Expose `direction`.
 */

module.exports = direction;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

const camelcase = __webpack_require__(1019)
const decamelize = __webpack_require__(1020)

module.exports.parse = function (string) {
  if (!string) return {}

  return string.split(';').reduce(function (memo, declaration) {
    if (!declaration) return memo

    var keyEndIndex = declaration.indexOf(':')
    const key = declaration.substring(0, keyEndIndex)
    const prop = declaration.substring(keyEndIndex + 1).trim()

    memo[camelcase(key)] = prop
    return memo
  }, {})
}

module.exports.stringify = function (styles) {
  if (!styles) return

  return Object.keys(styles).reduce(function (memo, key) {
    return memo + decamelize(key, '-') + ': ' + styles[key] + '; '
  }, '').trim()
}


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function () {
	var str = [].map.call(arguments, function (str) {
		return str.trim();
	}).filter(function (str) {
		return str.length;
	}).join('-');

	if (!str.length) {
		return '';
	}

	if (str.length === 1 || !(/[_.\- ]+/).test(str) ) {
		if (str[0] === str[0].toLowerCase() && str.slice(1) !== str.slice(1).toLowerCase()) {
			return str;
		}

		return str.toLowerCase();
	}

	return str
	.replace(/^[_.\- ]+/, '')
	.toLowerCase()
	.replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
		return p1.toUpperCase();
	});
};


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str, sep) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	sep = typeof sep === 'undefined' ? '_' : sep;

	return str
		.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2')
		.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + sep + '$2')
		.toLowerCase();
};


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderBlock", function() { return renderBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderInline", function() { return renderInline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderMark", function() { return renderMark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marks__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




// tslint:disable-next-line no-any
var renderBlock = function (props, editor, next) {
    var _a = props.node, type = _a.type, data = _a.data, attributes = props.attributes, children = props.children;
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].p) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].h1) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].h2) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].h3) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].h4) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].h5) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].h6) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].ul) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].ol) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ol", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].li) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", __assign({}, attributes, { style: data.get('style'), className: data.get('className') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].section) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", __assign({}, attributes, { style: data.get('style'), className: data.get('className'), "aria-label": data.get('aria-label') }), children));
    }
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].aside) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("aside", __assign({}, attributes, { style: data.get('style'), className: data.get('className'), "aria-label": data.get('aria-label') }), children));
    }
    return next();
};
// tslint:disable-next-line no-any
var renderInline = function (props, editor, next) {
    var _a = props.node, type = _a.type, data = _a.data, text = _a.text, nodes = _a.nodes, attributes = props.attributes, children = props.children;
    if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* INLINE_TYPES */].a) {
        // We have to remove link when all text for link was deleted
        if (!text) {
            return children;
        }
        var hasColorMarks = nodes.every(function (node) {
            if (!node) {
                return false;
            }
            var color = Object(__WEBPACK_IMPORTED_MODULE_2__marks__["getColor"])(node.marks);
            return !!color;
        });
        // this style is used when no color style set in link text from initial html
        var style = hasColorMarks ? undefined : { textDecoration: __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* TEXT_DECORATION */].UNDERLINE };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", __assign({}, attributes, { href: data.get('href'), "data-action": data.get('action'), className: data.get('className') || __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["s" /* linkClassName */], style: style }), children));
    }
    return next();
};
var renderMark = function (_a) {
    var mark = _a.mark, marks = _a.marks, attributes = _a.attributes, leaf = _a.children;
    var isFirstMark = mark === marks.first();
    if (!isFirstMark) {
        return;
    }
    var orderedMarks = [];
    __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* MARK_TYPES */].forEach(function (markType) {
        var mark = marks.find(function (_a) {
            var type = _a.type;
            return type === markType;
        });
        if (mark) {
            orderedMarks.unshift(mark);
        }
    });
    return orderedMarks.reduce(function (children, mark) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, attributes, { className: mark.data.get('className'), style: mark.data.get('style') }), children)); }, leaf);
};


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLinks", function() { return getLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLinkData", function() { return getLinkData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateLink", function() { return updateLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__ = __webpack_require__(9);



var getLinks = function (inlines) { return (inlines.filter(function (_a) {
    var type = _a.type, text = _a.text;
    return type === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* INLINE_TYPES */].a && !!text;
})); };
var getLinkData = function (inlines, spreads) {
    var links = getLinks(inlines);
    if (!links.size) {
        return null;
    }
    var data = links.first().data;
    var type = Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_utils_helpers__["r" /* getLinkTypeFromHref */])(data.get('href'), data.get('action'));
    var linkData = type === __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].url
        ? Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_utils_helpers__["s" /* getLinkUrlData */])(data.get('href'))
        : Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_utils_helpers__["p" /* getLinkDataFromAction */])(data.get('action'), spreads);
    return linkData;
};
var getInlineLinkData = function (linkData) {
    if (linkData.type === __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].url) {
        return {
            href: linkData.data.href,
        };
    }
    return {
        href: 'javascript:void(0)',
        action: Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_utils_helpers__["o" /* getLinkAction */])(linkData),
    };
};
var createLink = function (editor, linkData) {
    editor.wrapInline({
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* INLINE_TYPES */].a,
        data: getInlineLinkData(linkData),
    });
};
var removeLink = function (editor) {
    editor.unwrapInline(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* INLINE_TYPES */].a);
};
var updateLink = function (editor, editorValue, linkData) {
    var inlines = editorValue.inlines, selection = editorValue.selection;
    var links = getLinks(inlines);
    if (!links.size) {
        if (selection.isExpanded && linkData) {
            createLink(editor, linkData);
        }
    }
    else {
        links.forEach(function (_a) {
            var key = _a.key;
            if (linkData) {
                editor.setNodeByKey(key, {
                    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* INLINE_TYPES */].a,
                    data: getInlineLinkData(linkData),
                });
            }
            else {
                removeLink(editor);
            }
        });
    }
};


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleBeforeInput", function() { return handleBeforeInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePaste", function() { return handlePaste; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleCopy", function() { return handleCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleKeyDown", function() { return handleKeyDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatUtils__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_keys__ = __webpack_require__(118);



var handleBeforeInput = function (e, editor, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__formatUtils__["c" /* isStartPointInBlock */](editor.value)) {
        __WEBPACK_IMPORTED_MODULE_0__formatUtils__["b" /* formatInsertionToStartPointOfBlock */](editor);
    }
    return next();
};
var handlePaste = function (e, editor, next) {
    e.preventDefault();
    if (!e.clipboardData) {
        return next();
    }
    // We have to keep existing format of copied value in case it was copied from rich text editor.
    var isCopiedFromRte = e.clipboardData.getData('isCopiedFromRte') === 'true';
    if (isCopiedFromRte) {
        return next();
    }
    var onInsert = function () {
        if (!e.clipboardData) {
            return;
        }
        var pastedValue = e.clipboardData.getData('text');
        // Split pasted value by line-breaks
        var pastedValueParagraphs = pastedValue.split(/\r?\n|\r/g);
        editor.insertText(pastedValueParagraphs[0]);
        var _a = editor.value, blocks = _a.blocks, marks = _a.marks;
        var firstParagraphData = blocks.first().get('data');
        pastedValueParagraphs.slice(1).forEach(function (p) {
            editor.insertBlock({
                type: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BLOCK_TYPES */].p,
                data: firstParagraphData,
                nodes: [{
                        object: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* OBJECT_TYPES */].text,
                        text: p,
                        marks: marks,
                    }],
            });
        });
    };
    if (__WEBPACK_IMPORTED_MODULE_0__formatUtils__["c" /* isStartPointInBlock */](editor.value)) {
        __WEBPACK_IMPORTED_MODULE_0__formatUtils__["b" /* formatInsertionToStartPointOfBlock */](editor);
    }
    else if (__WEBPACK_IMPORTED_MODULE_0__formatUtils__["d" /* isStartPointInEmptyBlock */](editor.value)) {
        __WEBPACK_IMPORTED_MODULE_0__formatUtils__["a" /* formatInsertionToEmptyBlock */](editor);
    }
    onInsert();
};
var handleCopy = function (e, editor, next) {
    if (e.clipboardData) {
        e.clipboardData.setData('isCopiedFromRte', 'true');
    }
    e.preventDefault();
    return next();
};
var handleKeyDown = function (e, editor, next) {
    if ((__WEBPACK_IMPORTED_MODULE_2__utils_keys__["a" /* default */].isDelete(e.key) || __WEBPACK_IMPORTED_MODULE_2__utils_keys__["a" /* default */].isBackSpace(e.key))
        && __WEBPACK_IMPORTED_MODULE_0__formatUtils__["c" /* isStartPointInBlock */](editor.value)) {
        __WEBPACK_IMPORTED_MODULE_0__formatUtils__["b" /* formatInsertionToStartPointOfBlock */](editor);
    }
    return next();
};


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isStartPointInBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStartPointInEmptyBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatInsertionToStartPointOfBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatInsertionToEmptyBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(69);

var isStartPointInBlock = function (_a) {
    var selection = _a.selection, blocks = _a.blocks;
    var block = blocks.first();
    var isEmptyBlock = block && !block.text;
    var isStartPoint = selection.start.offset === 0;
    return !isEmptyBlock && isStartPoint;
};
var isStartPointInEmptyBlock = function (_a) {
    var selection = _a.selection, blocks = _a.blocks;
    var block = blocks.first();
    var isEmptyBlock = block && !block.text;
    var isStartPoint = selection.isCollapsed && selection.start.offset === 0;
    return isEmptyBlock && isStartPoint;
};
// tslint:disable-next-line: max-line-length
// By default Slate creates a new span without any marks in case of typing or pasting text in the start point of paragraph. This method gets marks from the first character of existing text and sets it to added text. This method is needed only if block contents inline nodes (links)
var formatInsertionToStartPointOfBlock = function (editor) {
    var _a = editor.value, blocks = _a.blocks, marks = _a.marks;
    var block = blocks.first();
    var inlineNode = block.nodes.find(function (node) { return node.object === __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* OBJECT_TYPES */].inline; });
    if (!inlineNode) {
        return;
    }
    var blockMarks = block.getMarks();
    editor.insertText(''); // insertion of empty character helps to apply marks to the first inserted character in case some text in paragraph was previously selected
    marks.map(function (mark) { return editor.removeMark(mark); });
    blockMarks.forEach(function (mark) { return editor.addMark(mark); });
};
// By default Slate doesn't set any marks when external text is passed to empty block. This method gets last applied marks and applies it to pasted text
var formatInsertionToEmptyBlock = function (editor) {
    var marks = editor.value.marks;
    var marksToReplace = marks;
    marks.map(function (mark) { return editor.removeMark(mark); });
    marksToReplace.forEach(function (mark) { return editor.addMark(mark); });
};


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getListType", function() { return getListType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addList", function() { return addList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeList", function() { return removeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateList", function() { return updateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addListItemsStyles", function() { return addListItemsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateListItemsStyles", function() { return updateListItemsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeListItemsStyles", function() { return removeListItemsStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marks__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var getListType = function (_a) {
    var blocks = _a.blocks, document = _a.document;
    if (!blocks.size) {
        return __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].NONE;
    }
    var hasListItem = blocks.some(function (block) { return !!block && block.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].li; });
    if (!hasListItem) {
        return __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].NONE;
    }
    var parent = document.getParent(blocks.first().key);
    if (!parent) {
        return __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].NONE;
    }
    var listType = parent.type;
    return listType === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ol ? __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].ORDERED : __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].UNORDERED;
};
var addList = function (editor, listType) {
    var blockType = listType === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].UNORDERED ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ul : __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ol;
    editor
        .setBlocks(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].li)
        .wrapBlock(blockType);
};
var removeList = function (editor) {
    editor
        .setBlocks(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].p)
        .unwrapBlock(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ul)
        .unwrapBlock(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ol);
};
var updateList = function (editor, listType) {
    var prevBlockType = listType === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].UNORDERED ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ol : __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ul;
    var newBlockType = listType === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LIST_TYPE */].UNORDERED ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ul : __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ol;
    editor
        .unwrapBlock(prevBlockType)
        .wrapBlock(newBlockType);
};
// A max font-size from list items must be set on list element (<ol> or <ul>) for correct calculation of padding-left (based on em)
var setFontSizeToListBlock = function (editor, block, fontSize) {
    var key = block.key, type = block.type, data = block.data;
    var newData = {
        style: __assign({}, data.get('style'), { fontSize: fontSize }),
    };
    editor.setNodeByKey(key, {
        type: type,
        data: newData,
    });
};
// This method is used for adding list item styles from text inside list item so list item marker has the same styles
var addListItemsStyles = function (editor) {
    var blocks = editor.value.blocks;
    var maxFontSize = '0px';
    blocks.forEach(function (block, index) {
        var key = block.key, type = block.type, currentData = block.data, nodes = block.nodes;
        var textNode = nodes.find(function (node) { return !!node && node.object === 'text'; });
        if (textNode) {
            var textNodeMarks = textNode.marks;
            if (textNodeMarks) {
                var fontFamily = __WEBPACK_IMPORTED_MODULE_1__marks__["getFontFamily"](textNodeMarks);
                var fontSize = __WEBPACK_IMPORTED_MODULE_1__marks__["getFontSize"](textNodeMarks);
                var fontWeight = __WEBPACK_IMPORTED_MODULE_1__marks__["isFontWeightBold"](textNodeMarks) ? 'bold' : 'normal';
                var fontStyle = __WEBPACK_IMPORTED_MODULE_1__marks__["isFontStyleItalic"](textNodeMarks) ? 'italic' : 'normal';
                var color = __WEBPACK_IMPORTED_MODULE_1__marks__["getColor"](textNodeMarks);
                var newData = {
                    style: __assign({}, currentData.get('style'), { fontFamily: fontFamily,
                        fontSize: fontSize,
                        fontWeight: fontWeight,
                        fontStyle: fontStyle,
                        color: color }),
                };
                editor.setNodeByKey(key, {
                    type: type,
                    data: newData,
                });
                if (Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(fontSize) > Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(maxFontSize)) {
                    maxFontSize = fontSize;
                }
            }
        }
        var isLastBlock = index === blocks.size - 1;
        if (isLastBlock) {
            var listBlock = editor.value.document.getParent(block.key);
            if (listBlock) {
                setFontSizeToListBlock(editor, listBlock, maxFontSize);
            }
        }
    });
};
// tslint:disable-next-line: max-line-length
// This method is used for updating list item styles when some mark inside list item is changed so list item marker has the same styles as text inside list item. Styles should be updated only when all text inside list item is selected. The only way to check that is to compare selected text from each block in value.fragment (it stores all selected blocks with actual selected text inside each block) with text from corresponding block in value.blocks (it stores all selected blocks with all text inside each block)
var updateListItemsStyles = function (editor, newStyle) {
    var _a = editor.value, blocks = _a.blocks, fragment = _a.fragment;
    var listItemBlocksInFragment = [];
    fragment.nodes.forEach(function (node) {
        if (node && node.object === 'block') {
            var isList = [__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ul, __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].ol].includes(node.type);
            if (isList) {
                node.nodes.forEach(function (childNode) {
                    if (childNode && childNode.object === 'block') {
                        listItemBlocksInFragment.push(childNode);
                    }
                });
            }
        }
    });
    var listItemBlocksInSelection = [];
    blocks.forEach(function (block) {
        var isListItemBlock = block && block.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BLOCK_TYPES */].li;
        if (isListItemBlock) {
            listItemBlocksInSelection.push(block);
        }
    });
    var listBlockKeys = [];
    listItemBlocksInSelection.forEach(function (block, index) {
        var isAllTextInBlockSelected = block.text === listItemBlocksInFragment[index].text;
        if (isAllTextInBlockSelected) {
            var key = block.key, type = block.type, currentData = block.data;
            var newData = {
                style: __assign({}, currentData.get('style'), newStyle),
            };
            editor.setNodeByKey(key, {
                type: type,
                data: newData,
            });
            var fontSize = newStyle.fontSize;
            if (fontSize) {
                var listBlock = editor.value.document.getParent(key);
                if (listBlock && !listBlockKeys.includes(listBlock.key)) {
                    listBlockKeys.push(listBlock.key);
                }
            }
        }
    });
    if (newStyle.fontSize) {
        listBlockKeys.forEach(function (key) {
            var listBlock = editor.value.document.getNode(key);
            if (listBlock) {
                var listItemBlocks = listBlock.nodes;
                var listItemFontSizes_1 = [];
                listItemBlocks.forEach(function (listItemBlock) {
                    var listItemFontSize = listItemBlock.data.get('style').fontSize;
                    listItemFontSizes_1.push(listItemFontSize);
                });
                listItemFontSizes_1.sort(function (a, b) { return Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(a) - Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(b); });
                var maxFontSize = listItemFontSizes_1[listItemFontSizes_1.length - 1];
                setFontSizeToListBlock(editor, listBlock, maxFontSize);
            }
        });
    }
};
var removeListItemsStyles = function (editor) {
    var blocks = editor.value.blocks;
    blocks.forEach(function (block) {
        var key = block.key, type = block.type, data = block.data;
        var newStyle = __assign({}, data.get('style'));
        [
            'fontFamily',
            'fontSize',
            'fontWeight',
            'fontStyle',
            'color',
        ].forEach(function (style) {
            delete newStyle[style];
        });
        editor.setNodeByKey(key, {
            type: type,
            data: { style: newStyle },
        });
    });
};


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editableTextFields_saveData__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(9);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};




// Set min-height property equal line-height to all empty paragraphs for proper display in Reader
var modifyEmptyParagraphs = function (fieldElement) {
    var emptyParagraphs = __spread(fieldElement.querySelectorAll('p')).filter(function (p) { return !p.innerText; });
    emptyParagraphs.forEach(function (p) {
        if (p.style.minHeight === 'auto') {
            p.style.minHeight = p.style.lineHeight;
        }
    });
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, fields) {
    fields.forEach(function (_a) {
        var id = _a.id, content = _a.content, isEditedFromBackoffice = _a.isEditedFromBackoffice, isEmpty = _a.isEmpty, verticalAlignClassName = _a.verticalAlignClassName;
        if (!isEditedFromBackoffice) {
            return;
        }
        var fieldElement = htmlDocument.querySelector("#" + id);
        if (fieldElement) {
            __WEBPACK_IMPORTED_MODULE_0__helpers__["_4" /* setElementIsEdited */](fieldElement);
            __WEBPACK_IMPORTED_MODULE_0__helpers__["_6" /* setVerticalAlignClassName */](fieldElement, verticalAlignClassName);
            fieldElement.classList.toggle(__WEBPACK_IMPORTED_MODULE_3__constants__["r" /* emptyTextFieldClassName */], !!isEmpty);
            var innerDiv = fieldElement.querySelector('div');
            var scale = __WEBPACK_IMPORTED_MODULE_0__helpers__["B" /* getScaleFromStyle */](innerDiv.style);
            var _b = innerDiv.style, transform = _b.transform, width = _b.width, height = _b.height;
            innerDiv.style.transform = transform.replace(/scale\((.+?)\)/, '');
            innerDiv.style.width = __WEBPACK_IMPORTED_MODULE_0__helpers__["u" /* getNumberFromString */](width) * scale + "px";
            innerDiv.style.height = __WEBPACK_IMPORTED_MODULE_0__helpers__["u" /* getNumberFromString */](height) * scale + "px";
            innerDiv.innerHTML = content;
            Object(__WEBPACK_IMPORTED_MODULE_1__editableTextFields_saveData__["a" /* modifyElementContent */])(fieldElement, modifyEmptyParagraphs);
            var parentElement = fieldElement.closest("[id*=" + __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* default */].parentContainerId + "]:not([class*=" + __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* default */].textFieldClassName + "])");
            if (parentElement) {
                var linkElement = parentElement.querySelector('a');
                if (linkElement && __WEBPACK_IMPORTED_MODULE_0__helpers__["X" /* isEditableButtonLink */](linkElement)) {
                    parentElement.classList.add(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* default */].editableButtonLinkClassName);
                }
            }
        }
    });
});


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getData__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__ = __webpack_require__(476);





var setStyle = function (element, _a) {
    var width = _a.width, height = _a.height, x = _a.x, y = _a.y;
    var style = "width:" + width + "px;height:" + height + "px;transform:translate(" + x + "px, " + y + "px);-webkit-transform:translate(" + x + "px, " + y + "px)";
    element.setAttribute('style', style);
};
var setElementContent = function (htmlDocument, element, id, type, isExternalLinkActive, isVisible) {
    var frame = htmlDocument.querySelector("#" + id);
    __WEBPACK_IMPORTED_MODULE_2__helpers__["_4" /* setElementIsEdited */](frame);
    frame.innerHTML = '';
    if (!isVisible) {
        frame.style.pointerEvents = 'none';
    }
    else {
        frame.style.removeProperty('pointer-events');
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__["c" /* isIframe */])(type, isExternalLinkActive)) {
        // tslint:disable-next-line: max-line-length
        // when embed Youtube video, inline-style 'transform: scale(0.99)' is set for iframe parent element in Safari (it seems that it comes from Reader code). It breaks correct position of iframe parent element. To fix it we have to add element between iframe and its parent element (object element is added because Reader has already correct styles for this element)
        var object = htmlDocument.createElement('object');
        object.className = __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].videoOrIframeWrapperId;
        object.appendChild(element);
        frame.appendChild(object);
    }
    else {
        frame.appendChild(element);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, mediaItems, isAccessible) {
    mediaItems.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, type = _a.type, id = _a.id, className = _a.className, defaultLink = _a.defaultLink, driveLink = _a.driveLink, externalLink = _a.externalLink, isExternalLinkActive = _a.isExternalLinkActive, width = _a.width, height = _a.height, x = _a.x, y = _a.y, label = _a.label, defaultLabel = _a.defaultLabel, tooltip = _a.tooltip, isTooltipActive = _a.isTooltipActive, videoSettings = _a.videoSettings, isVisible = _a.isVisible, originalStyle = _a.originalStyle;
        var _b, _c, _d;
        if (!isEditedFromBackoffice) {
            return;
        }
        var modifiedDriveLink = Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__["a" /* getDriveLinkWithoutHash */])(driveLink);
        var src = (isExternalLinkActive ? externalLink : modifiedDriveLink) || defaultLink;
        var element = Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__["b" /* getElement */])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* EditorType */].INDESIGN, type, isExternalLinkActive, htmlDocument, src, videoSettings, isVisible, className);
        var isCustomLink = (src !== defaultLink) || (isExternalLinkActive && !!modifiedDriveLink);
        if (isAccessible && type === __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].image && originalStyle) {
            element.setAttribute('style', originalStyle);
        }
        else if (type === __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EditableType */].image && isCustomLink) {
            setStyle(element, { width: width, height: height, x: x, y: y });
        }
        if (isCustomLink) {
            __WEBPACK_IMPORTED_MODULE_2__helpers__["_3" /* setDataAttributes */](element, (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].edited] = true,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].label] = isExternalLinkActive ? '' : label,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].defaultLabel] = defaultLabel,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].defaultLink] = defaultLink,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].driveLink] = modifiedDriveLink,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].externalLink] = externalLink,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].externalLinkActive] = isExternalLinkActive,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].tooltip] = tooltip,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].tooltipActive] = isTooltipActive,
                _b[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].hidden] = !isVisible,
                _b));
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2__helpers__["_3" /* setDataAttributes */](element, (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].label] = defaultLabel,
                _c));
            if (!isVisible) {
                __WEBPACK_IMPORTED_MODULE_2__helpers__["_3" /* setDataAttributes */](element, (_d = {},
                    _d[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].hidden] = true,
                    _d[__WEBPACK_IMPORTED_MODULE_3__getData__["a" /* MediaElementDataAttribute */].defaultLink] = defaultLink,
                    _d));
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__editableMedia_saveData__["d" /* setTooltipActions */])(element, tooltip, isTooltipActive);
        setElementContent(htmlDocument, element, id, type, isExternalLinkActive, isVisible);
    });
});


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getData__ = __webpack_require__(503);


var getAction = function (linkData) { return ("goToDestination(`" + Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["o" /* getLinkAction */])(linkData) + "`);"); };
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, buttons) {
    buttons.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, id = _a.id, isVisible = _a.isVisible, hasLink = _a.hasLink, linkData = _a.linkData, actionType = _a.actionType;
        if (!isEditedFromBackoffice) {
            return;
        }
        var button = htmlDocument.querySelector("#" + id);
        if (hasLink) {
            button.setAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["a" /* ButtonElementDataAttribute */].hasLink, 'true');
            if (linkData) {
                button.dataset[actionType] = getAction(linkData);
            }
            else {
                delete button.dataset[actionType];
            }
        }
        if (isVisible) {
            button.removeAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["a" /* ButtonElementDataAttribute */].hidden);
        }
        else {
            button.setAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["a" /* ButtonElementDataAttribute */].hidden, 'true');
        }
    });
});


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getData__ = __webpack_require__(504);



var getIframeElement = function (htmlDocument, src, isVisible) {
    var iframeElement = htmlDocument.createElement('iframe');
    iframeElement.className = __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].iframeClassName;
    iframeElement.src = src;
    iframeElement.setAttribute('frameborder', '0');
    iframeElement.setAttribute('width', '100%');
    iframeElement.setAttribute('height', '100%');
    if (isVisible === false) {
        __WEBPACK_IMPORTED_MODULE_1__helpers__["_5" /* setElementIsHidden */](iframeElement);
    }
    return iframeElement;
};
var setElementContent = function (htmlDocument, iframeElement, id, isVisible) {
    var frame = htmlDocument.querySelector("#" + id);
    __WEBPACK_IMPORTED_MODULE_1__helpers__["_4" /* setElementIsEdited */](frame);
    frame.innerHTML = '';
    if (!isVisible) {
        frame.style.pointerEvents = 'none';
    }
    else {
        frame.style.removeProperty('pointer-events');
    }
    // tslint:disable-next-line: max-line-length
    // when embed an iframe, inline-style 'transform: scale(0.99)' is set for iframe parent element in Safari (it seems that it comes from Reader code). It breaks correct position of iframe parent element. To fix it we have to add element between iframe and its parent element (object element is added because Reader has already correct styles for this element)
    var object = htmlDocument.createElement('object');
    object.className = __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].videoOrIframeWrapperId;
    object.appendChild(iframeElement);
    frame.appendChild(object);
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, iframes) {
    iframes.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, id = _a.id, defaultSrc = _a.defaultSrc, src = _a.src, isVisible = _a.isVisible;
        var _b, _c;
        if (!isEditedFromBackoffice) {
            return;
        }
        var iframeElement = getIframeElement(htmlDocument, src, isVisible);
        if (src !== defaultSrc) {
            __WEBPACK_IMPORTED_MODULE_1__helpers__["_3" /* setDataAttributes */](iframeElement, (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* IframeElementDataAttribute */].edited] = true,
                _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* IframeElementDataAttribute */].defaultSrc] = defaultSrc,
                _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* IframeElementDataAttribute */].src] = src,
                _b[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* IframeElementDataAttribute */].hidden] = !isVisible,
                _b));
        }
        else {
            if (!isVisible) {
                __WEBPACK_IMPORTED_MODULE_1__helpers__["_3" /* setDataAttributes */](iframeElement, (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* IframeElementDataAttribute */].hidden] = true,
                    _c[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* IframeElementDataAttribute */].defaultSrc] = defaultSrc,
                    _c));
            }
        }
        setElementContent(htmlDocument, iframeElement, id, isVisible);
    });
});


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getData__ = __webpack_require__(505);



var getEnrichmentParam = function (_a) {
    var isExternalLink = _a.isExternalLink, externalRelUrl = _a.externalRelUrl, globalId = _a.globalId;
    return isExternalLink ? externalRelUrl : globalId + '/';
};
var setElementContent = function (htmlDocument, id, resource, defaultResource) {
    var _a;
    var element = htmlDocument.querySelector("#" + id + " [class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].enrichmentClassName + "]");
    var defaultRelUrl = defaultResource.isExternalLink
        ? defaultResource.externalRelUrl
        : defaultResource.relUrl;
    var relUrl = resource.isExternalLink
        ? resource.externalRelUrl
        : resource.relUrl;
    var isDefaultResource = relUrl === defaultRelUrl;
    var oldEnrichmentData = Object(__WEBPACK_IMPORTED_MODULE_2__getData__["c" /* getEnrichmentData */])(element);
    if (!oldEnrichmentData) {
        return;
    }
    var params = oldEnrichmentData.params;
    var newResource = isDefaultResource ? defaultResource : resource;
    var newParam = getEnrichmentParam(newResource);
    params.param = newParam;
    params.assetDriveItem = newResource;
    var oldDataString = element.getAttribute('onclick');
    var newDataString = oldDataString.replace(/"params":([\s\S]*?),"event"/, function (match, group) { return (match.replace(group, JSON.stringify(params))); });
    element.setAttribute('onclick', newDataString);
    element.setAttribute('ontouchend', newDataString);
    if (isDefaultResource) {
        element.removeAttribute(__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].edited);
        element.removeAttribute(__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].defaultResource);
        element.removeAttribute(__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].deps);
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["_3" /* setDataAttributes */])(element, (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].edited] = true,
            _a[__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].defaultResource] = JSON.stringify(defaultResource),
            _a));
        if (resource.deps) {
            element.setAttribute(__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].deps, resource.deps);
        }
        else {
            element.removeAttribute(__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* EnrichmentElementDataAttribute */].deps);
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, items) {
    items.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, id = _a.id, resource = _a.resource, defaultResource = _a.defaultResource;
        if (!isEditedFromBackoffice) {
            return;
        }
        setElementContent(htmlDocument, id, resource, defaultResource);
    });
});


/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getData__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);




var getSliderPreview = function (_a) {
    var isExternalLink = _a.isExternalLink, relUrl = _a.relUrl, iconName = _a.iconName, externalRelUrl = _a.externalRelUrl, type = _a.type;
    var sliderPreview = document.createElement('img');
    sliderPreview.className = "" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].sliderPreviewClassName;
    sliderPreview.src = isExternalLink
        ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["U" /* getYoutubeVideoCover */])(externalRelUrl)
        : Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["t" /* getMediaUrl */])(relUrl, type === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].AssetItemFileTypes.MOVIE && iconName || '');
    return sliderPreview;
};
/* harmony default export */ __webpack_exports__["a"] = (function (htmlDocument, items, pageSlidersData) {
    items.forEach(function (_a) {
        var isEditedFromBackoffice = _a.isEditedFromBackoffice, id = _a.id, idInConfigs = _a.idInConfigs, isVisible = _a.isVisible, deps = _a.deps;
        if (!isEditedFromBackoffice) {
            return;
        }
        var element = htmlDocument.querySelector("#" + id);
        var sliderData = pageSlidersData && pageSlidersData[idInConfigs];
        if (sliderData) {
            var firstSlideData = 'slides' in sliderData ? sliderData.slides[0] : sliderData[0];
            if (firstSlideData) {
                var sliderPreview = getSliderPreview(firstSlideData);
                element.innerHTML = '';
                element.appendChild(sliderPreview);
            }
            else {
                element.innerHTML = '';
            }
        }
        else {
            element.innerHTML = '';
        }
        if (deps.length > 0) {
            element.setAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["c" /* SliderElementDataAttribute */].deps, deps.join(';'));
        }
        else {
            element.removeAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["c" /* SliderElementDataAttribute */].deps);
        }
        if (isVisible) {
            element.removeAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["c" /* SliderElementDataAttribute */].hidden);
        }
        else {
            element.setAttribute(__WEBPACK_IMPORTED_MODULE_1__getData__["c" /* SliderElementDataAttribute */].hidden, 'true');
        }
    });
});


/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var getConfig = function (element, page) { return ({
    page: page,
    id: Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* getElementId */])(element),
}); };
/* harmony default export */ __webpack_exports__["a"] = (function (page, htmlDocument, isAccountManagerOrAdmin) {
    if (!isAccountManagerOrAdmin) {
        return {
            items: [],
            isError: false,
        };
    }
    var items = [];
    var isError = false;
    var elements = __spread(htmlDocument.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].themedItemClassName + "]"));
    try {
        elements
            .filter(function (element) {
            var isEnrichmentElement = !!element.querySelector("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].enrichmentClassName + "]");
            var isButton = !!element.closest("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].buttonClassName + "]");
            var isLink = !!element.closest('a');
            var isTextField = element.className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].textFieldClassName);
            var isLocked = element.className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName);
            var MSOParent = element.closest("[class*=" + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].multiStateObjectClassName + "]");
            var isLockedMSOParent = !!MSOParent && MSOParent.className.includes(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* default */].lockedClassName);
            return !isEnrichmentElement &&
                !isButton &&
                !isLink &&
                !isTextField &&
                !isLocked &&
                !isLockedMSOParent;
        })
            .forEach(function (element) { return items.push(getConfig(element, page)); });
    }
    catch (err) {
        isError = true;
    }
    return {
        items: items,
        isError: isError,
    };
});


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBackgroundDeps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveBackgroundDeps; });
var BackgroundDataAttribute;
(function (BackgroundDataAttribute) {
    BackgroundDataAttribute["deps"] = "data-deps";
})(BackgroundDataAttribute || (BackgroundDataAttribute = {}));
var getBackgroundDeps = function (htmlDocument) {
    var wrapperDiv = htmlDocument.body.firstElementChild;
    var depsAttr = wrapperDiv.getAttribute(BackgroundDataAttribute.deps);
    return depsAttr ? depsAttr.split(';') : undefined;
};
var saveBackgroundDeps = function (htmlDocument, deps) {
    var wrapperDiv = htmlDocument.body.firstElementChild;
    if (deps && deps.length > 0) {
        wrapperDiv.setAttribute(BackgroundDataAttribute.deps, deps.join(';'));
    }
    else {
        wrapperDiv.removeAttribute(BackgroundDataAttribute.deps);
    }
};


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParsedCss; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api__ = __webpack_require__(17);


var urlRegExp = /url\((['"]?)(.+?)\1\)/g;
var getCssWithUpdatedUrls = function (galleryConfig, css, resourceId) {
    // replace relative urls from inDesign css file to absolute urls
    return css.replace(urlRegExp, function (match, quote, relPath) {
        var url = __WEBPACK_IMPORTED_MODULE_0__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, resourceId, relPath);
        return "url(\"" + url + "?token=" + __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].token + "&preventRedirect=true\")";
    });
};
var getExternalCssWithUpdatedUrls = function (galleryConfig, css, resourceId, cssRelUrl) {
    // replace relative urls from inDesign css file to absolute urls
    return css.replace(urlRegExp, function (match, quote, relPath) {
        var correctedRelPath = relPath.replace('../', getPathFromCssRelUrl(cssRelUrl, resourceId));
        var url = __WEBPACK_IMPORTED_MODULE_0__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, resourceId, correctedRelPath);
        return "url(\"" + url + "?token=" + __WEBPACK_IMPORTED_MODULE_1__utils_api__["a" /* default */].token + "&preventRedirect=true\")";
    });
};
var getPathFromCssRelUrl = function (cssRelUrl, resourceId) {
    var regExp = new RegExp(resourceId + "\\/(.*?)css\\/");
    var match = cssRelUrl.match(regExp);
    return match ? match[1] : '';
};
var getCssWithUpdatedAnimations = function (css) {
    return css
        // setting animation-duration to 0s doesn't play animation
        .replace(/(animation-duration:\s?)(\d+(\.\d+)?)/g, '$1' + '0.001')
        .replace(/(animation-delay:\s?)(\d+(\.\d+)?)/g, '$1' + '0.001')
        // play animations only once
        .replace(/(animation-iteration-count:\s?)(\d+(\.\d+)?|infinite)/g, '$1' + '1');
};
var getParsedCss = function (galleryConfig, css, resourceId, extCssRelUrl) {
    var parsedCss = extCssRelUrl
        ? getExternalCssWithUpdatedUrls(galleryConfig, css, resourceId, extCssRelUrl)
        : getCssWithUpdatedUrls(galleryConfig, css, resourceId);
    parsedCss = getCssWithUpdatedAnimations(parsedCss);
    return parsedCss;
};


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getThemesAndSelectedThemeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCssWithUpdatedThemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCssWithDuplicatedTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCssWithoutRemovedTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCssWithRenamedTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCssWithUpdatedThemeColor; });
var THEME_REG_EXP = /\/\* webPublication-theme[\s\S]*? BEGIN[\s\S]*?webPublication-theme END \*\//gm;
var THEME_ID_REG_EXP = /id\:(\d+);/;
var THEME_NAME_REG_EXP = /name\:([\s\S]*?);/;
var THEME_COLOR_VALUE_REG_EXP = /rgba\(.*\)/g;
var getThemesAndSelectedThemeId = function (css) {
    var themesMatch = css.match(THEME_REG_EXP);
    if (!themesMatch) {
        return {
            themes: null,
            selectedThemeId: null,
        };
    }
    var themes = {};
    var selectedThemeId = null;
    themesMatch.forEach(function (themeMatch) {
        var themeIdMatch = themeMatch.match(THEME_ID_REG_EXP);
        var themeNameMatch = themeMatch.match(THEME_NAME_REG_EXP);
        var themeColorValuesMatch = themeMatch.match(THEME_COLOR_VALUE_REG_EXP);
        if (themeIdMatch && themeNameMatch && themeColorValuesMatch) {
            var id = themeIdMatch[1];
            themes[id] = {
                id: id,
                name: themeNameMatch[1],
                colors: themeColorValuesMatch,
            };
            if (themeMatch.includes('!important')) {
                selectedThemeId = id;
            }
        }
    });
    return {
        themes: themes,
        selectedThemeId: selectedThemeId,
    };
};
var getCssWithUpdatedThemes = function (css, themeId) {
    return css.replace(THEME_REG_EXP, function (themeMatch) {
        return themeMatch.includes(themeId)
            ? themeMatch.replace(/\)\;/g, '\)\ !important;')
            : themeMatch.replace(/ !important;/g, '\;');
    });
};
var getThemeByIdRegExp = function (id) { return new RegExp("\\/\\* webPublication-theme id:" + id + "[\\s\\S]*? BEGIN[\\s\\S]*?webPublication-theme END \\*\\/", 'gm'); };
var getCssWithDuplicatedTheme = function (css, sourceThemeId, _a) {
    var id = _a.id, name = _a.name;
    var sourceThemeDataRegExp = getThemeByIdRegExp(sourceThemeId);
    var sourceThemeData = css.match(sourceThemeDataRegExp);
    if (!sourceThemeData) {
        return css;
    }
    var newThemeData = sourceThemeData[0]
        .replace(THEME_ID_REG_EXP, function (idMatch, sourceThemeId) {
        return idMatch.replace(sourceThemeId, id);
    })
        .replace(THEME_NAME_REG_EXP, function (nameMatch, sourceThemeName) {
        return nameMatch.replace(sourceThemeName, name);
    });
    return css.replace(THEME_REG_EXP, function (themeMatch) {
        return themeMatch.replace(/ !important;/g, '\;');
    }) + ("\n" + newThemeData);
};
var getCssWithoutRemovedTheme = function (css, themeId, newSelectedThemeId) {
    var themesMatch = css.match(THEME_REG_EXP);
    if (!themesMatch) {
        return css;
    }
    var themeToRemove = themesMatch.find(function (themeMatch) { return themeMatch.includes(themeId); });
    if (!themeToRemove) {
        return css;
    }
    var cssWithoutRemovedTheme = css.replace(themeToRemove, '');
    return getCssWithUpdatedThemes(cssWithoutRemovedTheme, newSelectedThemeId).trim();
};
var getCssWithRenamedTheme = function (css, themeId, themeName) {
    return css.replace(THEME_REG_EXP, function (themeMatch) {
        if (themeMatch.includes(themeId)) {
            var themeNameMatch = themeMatch.match(THEME_NAME_REG_EXP);
            return themeNameMatch
                ? themeMatch.replace(themeNameMatch[0], "name:" + themeName + ";")
                : themeMatch;
        }
        return themeMatch;
    });
};
var getCssWithUpdatedThemeColor = function (css, themeId, colorIndex, colorValue) {
    return css.replace(THEME_REG_EXP, function (themeMatch) {
        if (themeMatch.includes(themeId)) {
            var themeColorRegExp = new RegExp("\\[class\\*=\"webPublication-theme-color-" + colorIndex + "\"\\][\\s\\S]*?{[\\s\\S]*?}", 'g');
            var themeColorMatch = themeMatch.match(themeColorRegExp);
            return themeColorMatch
                ? themeMatch.replace(themeColorMatch[0], function (str) { return (str.replace(THEME_COLOR_VALUE_REG_EXP, colorValue)); })
                : themeMatch;
        }
        return themeMatch;
    });
};


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getModifiedScripts; });
var getModifiedScripts = function (scripts) {
    // we have to remove these statements from inDesign generated script for enabling text selection in buttons
    var eventStatementsToReplace = 'event\\.stopPropagation\\(\\);|event\\.preventDefault\\(\\);';
    var eventStatementsRegExp = new RegExp(eventStatementsToReplace, 'g');
    // tslint:disable-next-line: max-line-length
    // Some methods in inDesign generated script (e.g., handleAnimationInMSOState) get className property for each element inside MSO including elements which are added in Editor like action buttons. These buttons have svg icons inside. The className property on an svg element returns an object, not a string as for any html element. So calling indexOf on this object breaks inDesign script. The solution is to exclude <svg> and <use> elements.
    var selectorStatementsToReplace = "getElementsByTagName\\(\\'\\*\\'\\);";
    var selectorStatementsRegExp = new RegExp(selectorStatementsToReplace, 'g');
    return scripts
        .replace(eventStatementsRegExp, '')
        .replace(selectorStatementsRegExp, "querySelectorAll('*:not(svg):not(use)');");
};


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/webpublication.1f77029a.svg";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/uprez_bar.002c010f.svg";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/uprez.f51f5d5a.svg";

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = galleryInfos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var initialState = {
    isConfigLoaded: false,
    isConfigFetching: false,
    isLocalTemplateLoaded: false,
    isLocalTemplateFetching: false,
    isRemoteTemplateLoaded: false,
    isRemoteTemplateFetching: false,
    forceViewUpdateCount: 0,
    forceSplashScreen: true,
    template: __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["e" /* defaultTemplate */],
    customCSS: '',
};
function galleryInfos(state, action) {
    if (state === void 0) { state = initialState; }
    var propertiesToUpdate;
    var newState = __assign({}, state);
    var newTemplate;
    var newCommonStyles;
    var customCSS;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].REQUEST_CONFIG:
            return __assign({}, state, { isConfigFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].RECEIVE_CONFIG:
            return __assign({}, state, { isConfigFetching: false, isConfigLoaded: true, config: action.data });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].REQUEST_LOCAL_TEMPLATE:
            return __assign({}, state, { isLocalTemplateFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].RECEIVE_LOCAL_TEMPLATE:
            // Merge templates instead of replacing in case the remote template is incomplete
            newTemplate = __WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* default */].deepCopy(action.data);
            newCommonStyles = state.template.commonStyles;
            updateObjectProperties(newCommonStyles, newTemplate.commonStyles);
            newTemplate.commonStyles = newCommonStyles;
            return __assign({}, state, { isLocalTemplateFetching: false, isLocalTemplateLoaded: true, template: newTemplate });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].SET_CUSTOM_CSS:
            customCSS = action.data;
            return __assign({}, state, { customCSS: customCSS });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].REQUEST_REMOTE_TEMPLATE:
            return __assign({}, state, { isRemoteTemplateFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].RECEIVE_REMOTE_TEMPLATE:
            // Merge templates instead of replacing in case the remote template is incomplete
            newTemplate = __WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* default */].deepCopy(action.data);
            newCommonStyles = state.template.commonStyles;
            updateObjectProperties(newCommonStyles, newTemplate.commonStyles);
            newTemplate.commonStyles = newCommonStyles;
            return __assign({}, state, { isRemoteTemplateFetching: false, isRemoteTemplateLoaded: true, template: newTemplate });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].FORCE_VIEW_UPDATE:
            return __assign({}, state, { forceViewUpdateCount: state.forceViewUpdateCount + 1 });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].SET_FORCE_SPLASH_SCREEN:
            return __assign({}, state, { forceSplashScreen: action.isShown });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].UPDATE_TEMPLATE_BRAND:
            newState = __WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* default */].deepCopy(state);
            propertiesToUpdate = action.value;
            if (newState.template.brand) {
                updateObjectProperties(newState.template.brand, propertiesToUpdate);
            }
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GalleryInfosActionKeys */].UPDATE_TEMPLATE_COMMONSTYLES:
            newState = __WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* default */].deepCopy(state);
            propertiesToUpdate = action.value;
            if (newState.template.commonStyles) {
                updateObjectProperties(newState.template.commonStyles, propertiesToUpdate);
            }
            return newState;
        default:
            return state;
    }
}
function updateObjectProperties(object, propertiesToUpdate) {
    if (object) {
        for (var k in propertiesToUpdate) {
            if (propertiesToUpdate.hasOwnProperty(k)) {
                var updateValue = propertiesToUpdate[k];
                if (object[k] !== null && typeof object[k] === 'object') {
                    object[k] = updateObjectProperties(object[k], updateValue);
                }
                else {
                    object[k] = updateValue !== undefined ? updateValue : object[k];
                }
            }
        }
    }
    return object;
}


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newDriveItems;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(166);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    ids: [],
    isFetching: false,
};
function newDriveItems(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* NewDriveItemsActionKeys */].REQUEST_NEW_DRIVE_ITEMS:
            return __assign({}, state, { isFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* NewDriveItemsActionKeys */].RECEIVE_NEW_DRIVE_ITEMS:
            return __assign({}, state, { isFetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* NewDriveItemsActionKeys */].UPDATE_NEW_ITEMS:
            return __assign({}, state, { ids: action.ids });
        default:
            return state;
    }
}


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(144);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    isFetching: false,
    driveItemIds: [],
    isShown: false
};
function search(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SearchDriveItemActionKeys */].REQUEST_SEARCH:
            return __assign({}, state, { searchString: action.searchString, isFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SearchDriveItemActionKeys */].RECEIVE_SEARCH:
            return __assign({}, state, { isFetching: false, driveItemIds: action.driveItemIds });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SearchDriveItemActionKeys */].RESET_SEARCH:
            return __assign({}, state, { isFetching: false, driveItemIds: [] });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SearchDriveItemActionKeys */].TOGGLE_SEARCH_FIELD_VISIBILITY:
            return __assign({}, state, { isShown: !state.isShown });
        default:
            return state;
    }
}


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notificationBar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

var initialState = {
    history: []
};
function notificationBar(state, action) {
    if (state === void 0) { state = initialState; }
    var newHistory;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* NotificationBarActionKeys */].CREATE_NOTIFICATION:
            newHistory = __spread(state.history, [{
                    date: new Date(),
                    message: action.message,
                    barType: action.barType,
                    args: action.args
                }]);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* NotificationBarActionKeys */].CLEAR_NOTIFICATIONS:
            newHistory = [];
            break;
        default:
            return state;
    }
    return __assign({}, state, { history: newHistory });
}


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createNamedWrapperReducer__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(53);
var _a;



var initialState = [];
var ids = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SelectionActionKeys */].LOAD_SELECTION:
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SelectionActionKeys */].TOGGLE_SELECTION:
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SelectionActionKeys */].REMOVE_FROM_SELECTION:
            return action.selectionIds;
        case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SelectionActionKeys */].CLEAR_SELECTION:
            return initialState;
        default:
            return state;
    }
};
var selection = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* SelectionType */].RESOURCES] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_createNamedWrapperReducer__["a" /* createNamedWrapperReducer */])(ids, __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* SelectionType */].RESOURCES),
    _a[__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* SelectionType */].NOTES] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_createNamedWrapperReducer__["a" /* createNamedWrapperReducer */])(ids, __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* SelectionType */].NOTES),
    _a));


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pendingTasksManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_indexedDB_manager__ = __webpack_require__(21);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};




var initialState = {
    shares: [],
};
function pendingTasksManager(state, action) {
    if (state === void 0) { state = initialState; }
    var newPendingTasksManager;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* PendingTasksManagerActionKeys */].INIT_PENDING_TASKS:
            newPendingTasksManager = action.pendingTasks;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* PendingTasksManagerActionKeys */].CLEAR_PENDING_SHARES:
            newPendingTasksManager = __assign({}, state, { shares: [] });
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* PendingTasksManagerActionKeys */].ADD_PENDING_SHARE:
            newPendingTasksManager = __assign({}, state, { shares: __spread(state.shares, [action.pendingShare]) });
            break;
        default:
            newPendingTasksManager = state;
            break;
    }
    if (__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].stringIsInStringEnum(action.type, __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* PendingTasksManagerActionKeys */]) && __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMobileApp) {
        __WEBPACK_IMPORTED_MODULE_3__utils_indexedDB_manager__["a" /* default */].setPendingTasks(newPendingTasksManager).then();
    }
    return newPendingTasksManager;
}



/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parametersPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var initialState = {
    usedSpace: '--',
    freeSpace: '--'
};
function parametersPage(state, action) {
    if (state === void 0) { state = initialState; }
    var newState = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(state);
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ParametersPageActionKeys */].SET_USED_SPACE:
            newState.usedSpace = action.value;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ParametersPageActionKeys */].SET_FREE_SPACE:
            newState.freeSpace = action.value;
            break;
        default:
            return state;
    }
    return newState;
}


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerParamsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var initialState = [];
function routerParamsHistory(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* RouteParamsActionKeys */].SET_ROUTE_PARAMS:
            return __spread(state, [
                {
                    params: __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(action.data),
                    routes: __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(action.routes)
                }
            ]);
        default:
            return state;
    }
}


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return folderCreationPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(235);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    isOpen: false,
    useSelection: false,
    name: '',
};
function folderCreationPanel(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* FolderCreationPanelActionKeys */].OPEN_PANEL:
            return __assign({}, state, { isOpen: true, useSelection: action.useSelection });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* FolderCreationPanelActionKeys */].CLOSE_PANEL:
            return initialState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* FolderCreationPanelActionKeys */].SET_NAME:
            return __assign({}, state, { name: action.name });
        default:
            return state;
    }
}



/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(99);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    leftMenuIsOpen: false
};
function menuManager(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MenuActionKeys */].REQUEST_OPEN_LEFT_MENU:
            return __assign({}, state, { leftMenuIsOpen: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MenuActionKeys */].REQUEST_CLOSE_LEFT_MENU:
            return __assign({}, state, { leftMenuIsOpen: false });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* MenuActionKeys */].SET_MENU_MODES:
            return __assign({}, state, { menuModes: action.menuModes });
        default:
            return state;
    }
}



/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = downloadAllPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(295);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    closedByUser: false,
};
function downloadAllPopup(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* DownloadAllPopupActionKeys */].CLOSE:
            return __assign({}, state, { closedByUser: true });
        default:
            return state;
    }
}


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GDPRCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(512);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    isDisplayed: false,
};
function GDPRCookie(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* GDPRCookieActionKeys */].SET_IS_DISPLAYED:
            return __assign({}, state, { isDisplayed: action.isDisplayed });
        default:
            return state;
    }
}


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var driveItemReadInitialState = {
    lastVersionRead: 0
};
var initialState = {
    items: {}
};
function readStatus(state, action) {
    if (state === void 0) { state = initialState; }
    var newState = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(state);
    var item;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ReadItemsStatusActionKeys */].INIT_READ_STATUS_STORE:
            action.storedReadItems.forEach(function (item) { return newState.items[item.id] = {
                lastVersionRead: item.lastVersionRead
            }; });
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ReadItemsStatusActionKeys */].REMOVE_ITEM:
            delete newState.items[action.id];
            return newState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ReadItemsStatusActionKeys */].UPDATE_READ_STATUS:
            item = getItemFromMap(newState.items, action.id);
            item.lastVersionRead = action.version;
            newState.items[action.id] = item;
            return newState;
        default:
            return state;
    }
}
function getItemFromMap(items, itemId) {
    return items[itemId] ? items[itemId] : __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].deepCopy(driveItemReadInitialState);
}



/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return paths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return previewPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parentFolderId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invoiceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return publishPrice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(236);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _a;




var pathsInitialState = {
    pagePath: '',
    cssPath: '',
    themesCssPath: '',
    jsPath: '',
    configsPath: '',
    imagePath: '',
    thumbnailPath: '',
    spreadPath: '',
};
var getPageDefaultData = function (page, width, height) {
    if (width === void 0) { width = __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* DEFAULT_WIDTH */]; }
    if (height === void 0) { height = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DEFAULT_HEIGHT */]; }
    return ({
        page: page,
        defaultHtml: '',
        html: '',
        width: width,
        height: height,
        fontsPath: '',
        googleFontsPath: '',
    });
};
var pagesInitialState = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INITIAL_PAGE */]] = getPageDefaultData(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INITIAL_PAGE */]),
    _a);
var previewPagesInitialState = [];
var resourcesInitialState = {
    css: '',
};
var publishPriceInitialState = {
    actionCredits: {},
};
var paths = function (state, action) {
    if (state === void 0) { state = pathsInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_DATA: {
            if (action.editorType === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].INDESIGN) {
                var _a = action.data, pagePath = _a.pagePath, cssPath = _a.cssPath, themesCssPath = _a.themesCssPath, jsPath = _a.jsPath, configsPath = _a.configsPath, imagePath = _a.imagePath, thumbnailPath = _a.thumbnailPath, spreadPath = _a.spreadPath, accessiblePagePath = _a.accessiblePagePath, accessibleUrl = _a.accessibleUrl;
                return __assign({}, state, { pagePath: pagePath,
                    cssPath: cssPath,
                    themesCssPath: themesCssPath,
                    jsPath: jsPath,
                    configsPath: configsPath,
                    imagePath: imagePath,
                    thumbnailPath: thumbnailPath,
                    spreadPath: spreadPath,
                    accessiblePagePath: accessiblePagePath,
                    accessibleUrl: accessibleUrl });
            }
            else {
                var pagePath = action.data.pagePath;
                return __assign({}, state, { pagePath: pagePath });
            }
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return pathsInitialState;
        default:
            return state;
    }
};
var pages = function (state, action) {
    if (state === void 0) { state = pagesInitialState; }
    var _a, _b;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].ADD_PAGE: {
            var page = action.page, width = action.width, height = action.height;
            return __assign({}, state, (_a = {}, _a[page] = getPageDefaultData(page, width, height), _a));
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_PAGE_DATA:
            return __assign({}, state, (_b = {}, _b[action.data.page] = __assign({}, state[action.data.page], action.data), _b));
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return pagesInitialState;
        default:
            return state;
    }
};
var previewPages = function (state, action) {
    if (state === void 0) { state = previewPagesInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_DATA: {
            if (action.editorType === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].INDESIGN) {
                var nonEpubPages = action.data.nonEpubPages;
                return nonEpubPages
                    ? __spread(state, nonEpubPages) : state;
            }
            else {
                return state;
            }
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return previewPagesInitialState;
        default:
            return state;
    }
};
var resources = function (state, action) {
    if (state === void 0) { state = resourcesInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_RESOURCES_DATA:
            return __assign({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return resourcesInitialState;
        default:
            return state;
    }
};
var parentFolderId = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_PARENT_FOLDER_ID:
            return action.id;
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return null;
        default:
            return state;
    }
};
var invoiceStatus = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_DATA: {
            if (action.editorType === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].INDESIGN) {
                var invoiceStatus_1 = action.data.invoiceStatus;
                return invoiceStatus_1 ? invoiceStatus_1 : state;
            }
            else {
                return state;
            }
        }
        default:
            return state;
    }
};
var publishPrice = function (state, action) {
    if (state === void 0) { state = publishPriceInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_sources__["a" /* SourcesActionKeys */].SET_PUBLISH_PRICE:
            return __assign({}, state, action.data);
        default:
            return state;
    }
};


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagesController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_pagesController__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_sources__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_api__ = __webpack_require__(10);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var pagesControllerInitialState = {
    currentSpreadIndex: 0,
    prevSpreadIndex: 0,
    totalPages: __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* INITIAL_TOTAL_PAGES */],
    spreads: [[__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INITIAL_PAGE */]]],
    displayMode: __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].PublicationDisplayMode.SLIDER,
    firstFrameMode: __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].PublicationFirstFrameMode.SINGLE,
    accessiblePages: __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* INITIAL_TOTAL_PAGES */],
};
var pagesController = function (state, action) {
    if (state === void 0) { state = pagesControllerInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_sources__["a" /* SourcesActionKeys */].SET_DATA: {
            if (action.editorType === __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* EditorType */].INDESIGN) {
                var _a = action.data, totalPages = _a.totalPages, displayMode = _a.displayMode, firstFrameMode = _a.firstFrameMode, accessiblePages = _a.accessiblePages;
                return __assign({}, state, { totalPages: totalPages,
                    displayMode: displayMode,
                    firstFrameMode: firstFrameMode,
                    accessiblePages: accessiblePages });
            }
            else {
                return state;
            }
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_pagesController__["a" /* PagesControllerActionKeys */].SET_PAGE_SPREADS:
            return __assign({}, state, { spreads: action.spreads });
        case __WEBPACK_IMPORTED_MODULE_0__actions_pagesController__["a" /* PagesControllerActionKeys */].CHANGE_PAGE_SPREAD: {
            var spreadIndex = action.spreadIndex && action.spreadIndex >= 0 ? action.spreadIndex : 0;
            return __assign({}, state, { currentSpreadIndex: spreadIndex, prevSpreadIndex: state.currentSpreadIndex });
        }
        case __WEBPACK_IMPORTED_MODULE_2__actions_ui__["a" /* UiActionKeys */].RESET:
            return pagesControllerInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEditorLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return spreadZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return lockedEditorPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isAccessibleVersion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_spreadBackground__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var labelInitialState = {
    label: '',
    isError: false,
    isRenaming: false,
};
var editPanelInitialState = {
    isDisplayed: false,
    x: null,
    y: null,
};
var activeItemInitialState = {
    id: '',
    page: null,
    parentId: null,
};
var lockedEditorPopupInitialState = {
    isDisplayed: false,
    userName: '',
};
var type = function (state, action) {
    if (state === void 0) { state = __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].HTML; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_EDITOR_TYPE:
            return action.editorType;
        default:
            return state;
    }
};
var label = function (state, action) {
    if (state === void 0) { state = labelInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_LABEL:
            return __assign({}, state, { label: action.label });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_IS_RENAMING:
            return __assign({}, state, { isRenaming: action.isRenaming });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RENAME:
            return __assign({}, state, { label: action.newLabel, isRenaming: false });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_RENAME_ERROR:
            return __assign({}, state, { isError: action.isError });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET:
            return labelInitialState;
        default:
            return state;
    }
};
var isEditorLoaded = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_IS_EDITOR_LOADED:
            return action.isLoaded;
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET:
            return false;
        default:
            return state;
    }
};
var editPanel = function (state, action) {
    if (state === void 0) { state = editPanelInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].TOGGLE_EDIT_PANEL:
            return __assign({}, state, { isDisplayed: !state.isDisplayed });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_ACTIVE_ITEM:
            return __assign({}, state, { x: null, y: null });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET_ACTIVE_ITEM:
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SHOW_LOCKED_EDITOR_POPUP:
            return __assign({}, state, { isDisplayed: false, x: null, y: null });
        case __WEBPACK_IMPORTED_MODULE_1__actions_spreadBackground__["a" /* SpreadBackgroundActionKeys */].SET_IS_SPREAD_BACKGROUND_ACTIVE:
            return __assign({}, state, { isDisplayed: action.isActive });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].MOVE_EDIT_PANEL:
            return __assign({}, state, { x: action.x, y: action.y });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET:
            return editPanelInitialState;
        default:
            return state;
    }
};
var activeItem = function (state, action) {
    if (state === void 0) { state = activeItemInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_ACTIVE_ITEM: {
            var id = action.id, page = action.page, parentId = action.parentId;
            return __assign({}, state, { id: id,
                page: page,
                parentId: parentId });
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET_ACTIVE_ITEM:
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET:
            return activeItemInitialState;
        default:
            return state;
    }
};
var version = function (state, action) {
    if (state === void 0) { state = 0; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_VERSION:
            return action.version;
        default:
            return state;
    }
};
var spreadZoom = function (state, action) {
    if (state === void 0) { state = 1; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].ZOOM_PAGE: {
            if (action.zoom === __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* ZoomType */].FIT) {
                return 1;
            }
            else {
                var step = action.zoom === __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* ZoomType */].IN ? __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* ZOOM_STEP */] : -__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* ZOOM_STEP */];
                var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["A" /* getRoundedValue */])(state += step, 10);
                return newValue < __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* ZOOM_STEP */] ? __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* ZOOM_STEP */] : newValue;
            }
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET:
            return 1;
        default:
            return state;
    }
};
var lockedEditorPopup = function (state, action) {
    if (state === void 0) { state = lockedEditorPopupInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SHOW_LOCKED_EDITOR_POPUP:
            return __assign({}, state, { isDisplayed: true, userName: action.userName });
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].HIDE_LOCKED_EDITOR_POPUP:
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].RESET:
            return lockedEditorPopupInitialState;
        default:
            return state;
    }
};
var isAccessibleVersion = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_ui__["a" /* UiActionKeys */].SET_IS_ACCESSIBLE_VERSION:
            return action.isAccessibleVersion;
        default:
            return state;
    }
};


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createEditableItemReducer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return editableTextFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return editableMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return editableLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editableButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return editableIframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editableEnrichments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return editableSliders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return themedItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return duplicatedItemsInSpread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;




var EditableItemName;
(function (EditableItemName) {
    EditableItemName["TEXT_FIELD"] = "editableTextFields";
    EditableItemName["MEDIA"] = "editableMedia";
    EditableItemName["LINK"] = "editableLinks";
    EditableItemName["BUTTON"] = "editableButtons";
    EditableItemName["IFRAME"] = "editableIframes";
    EditableItemName["ENRICHMENT"] = "editableEnrichments";
    EditableItemName["SLIDER"] = "editableSliders";
    EditableItemName["THEMED_ITEM"] = "themedItems";
    EditableItemName["DUPLICATED_ITEM_IN_SPREAD"] = "duplicatedItemsInSpread";
})(EditableItemName || (EditableItemName = {}));
var editableItemActionMap = new Map([
    [
        EditableItemName.TEXT_FIELD,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_TEXT_FIELD,
    ],
    [
        EditableItemName.MEDIA,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_MEDIA,
    ],
    [
        EditableItemName.LINK,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_LINK,
    ],
    [
        EditableItemName.BUTTON,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_BUTTON,
    ],
    [
        EditableItemName.IFRAME,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_IFRAME,
    ],
    [
        EditableItemName.ENRICHMENT,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_ENRICHMENT,
    ],
    [
        EditableItemName.SLIDER,
        __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].UPDATE_EDITABLE_SLIDER,
    ],
    [
        EditableItemName.THEMED_ITEM,
        undefined,
    ],
    [
        EditableItemName.DUPLICATED_ITEM_IN_SPREAD,
        undefined,
    ],
]);
var editableTextFieldsInitialState = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _a);
var editableMediaInitialState = (_b = {},
    _b[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _b);
var editableLinksInitialState = (_c = {},
    _c[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _c);
var editableButtonsInitialState = (_d = {},
    _d[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _d);
var editableIframesInitialState = (_e = {},
    _e[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _e);
var editableEnrichmentsInitialState = (_f = {},
    _f[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _f);
var editableSlidersInitialState = (_g = {},
    _g[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _g);
var themedItemsInitialState = (_h = {},
    _h[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _h);
var duplicatedItemsInSpreadInitialState = (_j = {},
    _j[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INITIAL_PAGE */]] = {},
    _j);
var createEditableItemReducer = function (initialState, editableItemName) {
    return function editableItem(state, action) {
        if (state === void 0) { state = initialState; }
        var _a, _b, _c;
        var updateAction = editableItemActionMap.get(editableItemName);
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__actions_editableItems__["a" /* EditableItemsActionKeys */].SET_EDITABLE_ITEMS_DATA:
                if (!action.data[editableItemName]) {
                    return state;
                }
                return __assign({}, state, (_a = {}, _a[action.page] = __assign({}, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].itemsToById(action.data[editableItemName])), _a));
            case updateAction:
                return __assign({}, state, (_b = {}, _b[action.page] = __assign({}, state[action.page], (_c = {}, _c[action.id] = __assign({}, state[action.page][action.id], action.data, { isEditedFromBackoffice: 'isEditedFromBackoffice' in action.data && action.data.isEditedFromBackoffice !== undefined
                        ? action.data.isEditedFromBackoffice
                        : true }), _c)), _b));
            case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
                return initialState;
            default:
                return state;
        }
    };
};
var editableTextFields = createEditableItemReducer(editableTextFieldsInitialState, EditableItemName.TEXT_FIELD);
var editableMedia = createEditableItemReducer(editableMediaInitialState, EditableItemName.MEDIA);
var editableLinks = createEditableItemReducer(editableLinksInitialState, EditableItemName.LINK);
var editableButtons = createEditableItemReducer(editableButtonsInitialState, EditableItemName.BUTTON);
var editableIframes = createEditableItemReducer(editableIframesInitialState, EditableItemName.IFRAME);
var editableEnrichments = createEditableItemReducer(editableEnrichmentsInitialState, EditableItemName.ENRICHMENT);
var editableSliders = createEditableItemReducer(editableSlidersInitialState, EditableItemName.SLIDER);
var themedItems = createEditableItemReducer(themedItemsInitialState, EditableItemName.THEMED_ITEM);
var duplicatedItemsInSpread = createEditableItemReducer(duplicatedItemsInSpreadInitialState, EditableItemName.DUPLICATED_ITEM_IN_SPREAD);


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagesSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_pagesSelection__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var pagesSelectionInitialState = {
    isActive: false,
    spreadIndices: [],
    lastSelectedSpreadIndex: -1,
    lastSelectedShiftSpreadIndex: -1,
};
var pagesSelection = function (state, action) {
    if (state === void 0) { state = pagesSelectionInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_pagesSelection__["a" /* PagesSelectionActionKeys */].SET_PAGES_SELECTION:
            return __assign({}, state, { isActive: true, spreadIndices: [action.currentSpreadIndex], lastSelectedSpreadIndex: action.currentSpreadIndex });
        case __WEBPACK_IMPORTED_MODULE_0__actions_pagesSelection__["a" /* PagesSelectionActionKeys */].SELECT_PAGE_SPREAD: {
            var spreadIndex = action.spreadIndex, allSpreads = action.allSpreads, isCtrlPressed = action.isCtrlPressed, isShiftPressed = action.isShiftPressed;
            var spreadIndices = state.spreadIndices, lastSelectedSpreadIndex = state.lastSelectedSpreadIndex, lastSelectedShiftSpreadIndex = state.lastSelectedShiftSpreadIndex;
            return __assign({}, state, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["D" /* getSelectedSpreads */])(spreadIndex, allSpreads, spreadIndices, lastSelectedSpreadIndex, lastSelectedShiftSpreadIndex, isCtrlPressed, isShiftPressed));
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_pagesSelection__["a" /* PagesSelectionActionKeys */].RESTORE_PAGES_SELECTION:
            return __assign({}, state, { isActive: true, spreadIndices: action.spreadIndices, lastSelectedSpreadIndex: action.spreadIndices[0] });
        case __WEBPACK_IMPORTED_MODULE_0__actions_pagesSelection__["a" /* PagesSelectionActionKeys */].RESET_PAGES_SELECTION:
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return pagesSelectionInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return themes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectedThemeId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_themes__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var themesInitialState = null;
var themes = function (state, action) {
    if (state === void 0) { state = themesInitialState; }
    var _a, _b, _c;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].SET_THEMES:
            return action.themes;
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].DUPLICATE_THEME:
            return __assign({}, state, (_a = {}, _a[action.theme.id] = action.theme, _a));
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].REMOVE_THEME: {
            var newState = __assign({}, state);
            delete newState[action.id];
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].RENAME_THEME:
            return __assign({}, state, (_b = {}, _b[action.id] = __assign({}, state[action.id], { name: action.name }), _b));
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].CHANGE_THEME_COLOR:
            return __assign({}, state, (_c = {}, _c[action.themeId] = __assign({}, state[action.themeId], { colors: state[action.themeId].colors.map(function (color, index) { return (index === action.colorIndex ? action.colorValue : color); }) }), _c));
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return themesInitialState;
        default:
            return state;
    }
};
var selectedThemeId = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].SELECT_THEME:
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].DUPLICATE_THEME:
            return action.id;
        case __WEBPACK_IMPORTED_MODULE_0__actions_themes__["a" /* ThemesActionKeys */].REMOVE_THEME:
            return action.newSelectedThemeId;
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return null;
        default:
            return state;
    }
};


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return combo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_combo__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var externalPublicationInitialState = {
    globalId: null,
    spreads: [],
    configs: __WEBPACK_IMPORTED_MODULE_3__configs__["c" /* configsDataInitialState */],
    thumbnails: [],
    thumbnailPath: '',
    isLoading: false,
    itemsInRow: 'AUTO',
    selection: {
        spreadIndices: [],
        lastSelectedSpreadIndex: -1,
        lastSelectedShiftSpreadIndex: -1,
    },
};
var isCombining = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].CREATE_COMBO:
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].FINISH_COMBO:
        case __WEBPACK_IMPORTED_MODULE_2__actions_ui__["a" /* UiActionKeys */].RESET:
            return false;
        default:
            return state;
    }
};
var percentage = function (state, action) {
    if (state === void 0) { state = 0; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].UPDATE_COMBO_PERCENTAGE:
            return action.percentage;
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].FINISH_COMBO:
        case __WEBPACK_IMPORTED_MODULE_2__actions_ui__["a" /* UiActionKeys */].RESET:
            return 0;
        default:
            return state;
    }
};
var externalPublication = function (state, action) {
    if (state === void 0) { state = externalPublicationInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].GET_EXTERNAL_PUBLICATION_DATA:
            return __assign({}, state, { isLoading: true });
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].SET_EXTERNAL_PUBLICATION_DATA:
            return __assign({}, state, action.data, { isLoading: false });
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].SELECT_EXTERNAL_SPREAD: {
            var spreadIndex = action.spreadIndex, allSpreads = action.allSpreads, isCtrlPressed = action.isCtrlPressed, isShiftPressed = action.isShiftPressed;
            var _a = state.selection, spreadIndices = _a.spreadIndices, lastSelectedSpreadIndex = _a.lastSelectedSpreadIndex, lastSelectedShiftSpreadIndex = _a.lastSelectedShiftSpreadIndex;
            return __assign({}, state, { selection: __assign({}, state.selection, Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["D" /* getSelectedSpreads */])(spreadIndex, allSpreads, spreadIndices, lastSelectedSpreadIndex, lastSelectedShiftSpreadIndex, isCtrlPressed, isShiftPressed, true)) });
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].SELECT_ALL_EXTERNAL_SPREADS:
            return __assign({}, state, { selection: __assign({}, state.selection, { spreadIndices: state.spreads.map(function (item, index) { return index; }) }) });
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].DESELECT_ALL_EXTERNAL_SPREADS:
            return __assign({}, state, { selection: __assign({}, state.selection, { spreadIndices: [] }) });
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].ZOOM_EXTERNAL_SPREADS: {
            var MIN_ITEMS = 2;
            var MAX_ITEMS = 6;
            var zoom = action.zoom, autoItemsInRow = action.autoItemsInRow;
            var itemsInRow = state.itemsInRow;
            if (zoom === __WEBPACK_IMPORTED_MODULE_5__constants__["o" /* ZoomType */].FIT) {
                itemsInRow = 'AUTO';
            }
            else {
                if (itemsInRow === 'AUTO') {
                    itemsInRow = autoItemsInRow;
                }
                var step = action.zoom === __WEBPACK_IMPORTED_MODULE_5__constants__["o" /* ZoomType */].OUT ? 1 : -1;
                itemsInRow += step;
                if (itemsInRow < MIN_ITEMS) {
                    itemsInRow = MIN_ITEMS;
                }
                if (itemsInRow > MAX_ITEMS) {
                    itemsInRow = MAX_ITEMS;
                }
            }
            return __assign({}, state, { itemsInRow: itemsInRow });
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions_combo__["a" /* ComboActionKeys */].RESET_EXTERNAL_PUBLICATION_DATA:
        case __WEBPACK_IMPORTED_MODULE_2__actions_ui__["a" /* UiActionKeys */].RESET:
            return externalPublicationInitialState;
        default:
            return state;
    }
};
var combo = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    isCombining: isCombining,
    percentage: percentage,
    externalPublication: externalPublication,
});


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_settings__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var settingsInitialState = {
    isDisplayed: false,
    fields: {},
    projectUrl: '',
    pdfSettings: {},
    pdfImportingStatus: null,
    serverErrors: {},
};
var settings = function (state, action) {
    if (state === void 0) { state = settingsInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_settings__["a" /* SettingsActionKeys */].TOGGLE_SETTINGS_PANEL: {
            return __assign({}, state, { isDisplayed: !state.isDisplayed });
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_settings__["a" /* SettingsActionKeys */].SET_SETTINGS:
            return __assign({}, state, { fields: __assign({}, state.fields, action.fields), pdfSettings: __assign({}, state.pdfSettings, action.pdfSettings), projectUrl: action.projectUrl || state.projectUrl });
        case __WEBPACK_IMPORTED_MODULE_0__actions_settings__["a" /* SettingsActionKeys */].SET_SETTINGS_ERROR: {
            var newState = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].deepCopy(state);
            if (action.value === null) {
                delete newState.serverErrors[action.name];
            }
            else {
                newState.serverErrors[action.name] = action.value;
            }
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_0__actions_settings__["a" /* SettingsActionKeys */].SET_PDF_IMPORTING_STATUS:
            return __assign({}, state, { pdfImportingStatus: action.status });
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return settingsInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return preprodPublication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_preprodPublication__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var preprodPublicationInitialState = {
    tempGId: null,
    lastUpdateDate: null,
    isUpdating: false,
    urlWithPin: '',
};
var preprodPublication = function (state, action) {
    if (state === void 0) { state = preprodPublicationInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_preprodPublication__["a" /* PreprodPublicationKeys */].SET_DATA:
            return __assign({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_0__actions_preprodPublication__["a" /* PreprodPublicationKeys */].SET_IS_UPDATING:
            return __assign({}, state, { isUpdating: action.isUpdating });
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return action.isIntermediate ? state : preprodPublicationInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return externalResources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_externalResources__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var externalResourcesInitialState = {};
var externalResources = function (state, action) {
    if (state === void 0) { state = externalResourcesInitialState; }
    var _a, _b, _c;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_externalResources__["a" /* ExternalResourcesActionKeys */].GET_DATA:
            return __assign({}, state, (_a = {}, _a[action.id] = __assign({}, state[action.id], { isLoading: true }), _a));
        case __WEBPACK_IMPORTED_MODULE_0__actions_externalResources__["a" /* ExternalResourcesActionKeys */].SET_DATA:
            return __assign({}, state, (_b = {}, _b[action.id] = __assign({}, state[action.id], action.data, { isLoading: false }), _b));
        case __WEBPACK_IMPORTED_MODULE_0__actions_externalResources__["a" /* ExternalResourcesActionKeys */].RESET_LOADING:
            return __assign({}, state, (_c = {}, _c[action.id] = __assign({}, state[action.id], { isLoading: false }), _c));
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return externalResourcesInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return spreadBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_spreadBackground__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_ui__ = __webpack_require__(35);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var spreadBackgroundInitialState = {
    isActive: false,
    isEdited: false,
    pagesData: {},
};
var spreadBackground = function (state, action) {
    if (state === void 0) { state = spreadBackgroundInitialState; }
    var _a, _b;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_spreadBackground__["a" /* SpreadBackgroundActionKeys */].SET_IS_SPREAD_BACKGROUND_ACTIVE:
            return __assign({}, state, { isActive: action.isActive, isEdited: action.isActive ? state.isEdited : false });
        case __WEBPACK_IMPORTED_MODULE_0__actions_spreadBackground__["a" /* SpreadBackgroundActionKeys */].SET_SPREAD_BACKGROUND:
            return __assign({}, state, { isEdited: action.shouldSetIsEdited, pagesData: action.data
                    ? state.pagesData
                    : __assign({}, state.pagesData, (_a = {}, _a[action.spread[0]] = {}, _a)) });
        case __WEBPACK_IMPORTED_MODULE_0__actions_spreadBackground__["a" /* SpreadBackgroundActionKeys */].UPDATE_SPREAD_BACKGROUND_SERVICE_DATA: {
            return __assign({}, state, { pagesData: __assign({}, state.pagesData, (_b = {}, _b[action.page] = __assign({}, state.pagesData[action.page], action.data), _b)) });
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions_ui__["a" /* UiActionKeys */].RESET:
            return spreadBackgroundInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export byId */
/* unused harmony export filesQueue */
/* unused harmony export remainingImportTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return importManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var byId = function (state, action) {
    if (state === void 0) { state = {}; }
    var _a, _b;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].ADD_FILE_IN_IMPORT:
            return __assign({}, state, (_a = {}, _a[action.id] = __assign({}, state[action.id], action.data), _a));
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].ADD_FILES_IN_IMPORT: {
            var filesList = action.files.map(function (file, index) { return ({
                id: action.ids[index],
                folderId: action.folderId,
                file: file,
                percentage: 0,
                error: null,
                shouldDisplayInToast: true,
            }); });
            return __assign({}, state, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].itemsToById(filesList));
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].UPDATE_FILE_IN_IMPORT:
            if (!state[action.id]) {
                return state;
            }
            return __assign({}, state, (_b = {}, _b[action.id] = __assign({}, state[action.id], action.data), _b));
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].REMOVE_FILE_FROM_IMPORT: {
            var _c = action.id, id = state[_c], rest = __rest(state, [typeof _c === "symbol" ? _c : _c + ""]);
            return __assign({}, rest);
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].REMOVE_FILES_FROM_IMPORT: {
            var newState = __assign({}, state);
            for (var id in newState) {
                if (action.ids.includes(id)) {
                    delete newState[id];
                }
            }
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].CANCEL_FILES_IMPORT: {
            var newState = __assign({}, state);
            for (var id in newState) {
                if (action.ids.includes(id)) {
                    newState[id] = __assign({}, newState[id], { isImportCanceled: true });
                }
            }
            return newState;
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].RESTART_FILES_IMPORT: {
            var newState = __assign({}, state);
            for (var id in newState) {
                if (action.ids.includes(id)) {
                    newState[id] = __assign({}, newState[id], { isImportCanceled: false, percentage: 0 });
                }
            }
            return newState;
        }
        default:
            return state;
    }
};
var filesQueue = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].ADD_TO_FILES_QUEUE:
            return __spread(state, action.ids);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].REMOVE_FROM_FILES_QUEUE: {
            var index = state.findIndex(function (id) { return id === action.id; });
            return __spread(state.slice(0, index), state.slice(index + 1));
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].CANCEL_FILES_IMPORT:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].REMOVE_FILES_FROM_IMPORT:
            return [];
        default:
            return state;
    }
};
var remainingImportTime = function (state, action) {
    if (state === void 0) { state = 0; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].UPDATE_REMAINING_IMPORT_TIME:
            return action.time;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].CANCEL_FILES_IMPORT:
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ImportManagerActionKeys */].REMOVE_FILES_FROM_IMPORT:
            return 0;
        default:
            return state;
    }
};
var importManager = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    byId: byId,
    filesQueue: filesQueue,
    remainingImportTime: remainingImportTime,
});


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assetRenamePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(329);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    isOpen: false,
    name: '',
    error: null,
    assetId: -1,
};
function assetRenamePanel(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AssetRenamePanelActionKeys */].OPEN_PANEL:
            return __assign({}, state, { isOpen: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AssetRenamePanelActionKeys */].CLOSE_PANEL:
            return initialState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AssetRenamePanelActionKeys */].SET_NAME:
            return __assign({}, state, { name: action.name, error: null });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AssetRenamePanelActionKeys */].SET_ERROR:
            return __assign({}, state, { error: action.error });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* AssetRenamePanelActionKeys */].SET_DRIVE_ITEM_ID:
            return __assign({}, state, { assetId: action.id });
        default:
            return state;
    }
}



/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return externalLinkCreationPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(330);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    isOpen: false,
    fields: {
        name: '',
        url: '',
    },
    errors: {},
};
function externalLinkCreationPanel(state, action) {
    if (state === void 0) { state = initialState; }
    var _a, _b;
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ExternalLinkCreationPanelActionKeys */].OPEN_PANEL:
            return __assign({}, state, { isOpen: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ExternalLinkCreationPanelActionKeys */].CLOSE_PANEL:
            return initialState;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ExternalLinkCreationPanelActionKeys */].SET_VALUE:
            return __assign({}, state, { fields: __assign({}, state.fields, (_a = {}, _a[action.name] = action.value, _a)), errors: __assign({}, state.errors, (_b = {}, _b[action.name] = action.error, _b)) });
        default:
            return state;
    }
}



/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noSaveAsPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(237);

var initialState = {
    isDisplayed: false,
};
function noSaveAsPopup(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* NoSaveAsPopupActionKeys */].CLOSE:
            return {
                isDisplayed: false,
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* NoSaveAsPopupActionKeys */].OPEN:
            return {
                isDisplayed: true,
            };
        default:
            return state;
    }
}


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backToPublication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(303);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    publicationId: undefined,
    page: undefined,
};
function backToPublication(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* BackToPublicationActionKeys */].SET_LAST_PUBLICATION:
            return __assign({}, state, { publicationId: action.publicationId, page: action.page });
        default:
            return state;
    }
}



/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shareWithUserPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(331);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var shareWithUserPopupInitialState = {
    isDisplayed: false,
    isLoading: false,
    users: [],
    selectedUserId: null,
    resourceGId: null,
};
var shareWithUserPopup = function (state, action) {
    if (state === void 0) { state = shareWithUserPopupInitialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ShareWithUserPopupActionKeys */].GET_USERS:
            return __assign({}, state, { resourceGId: action.resourceGId, isDisplayed: true, isLoading: true });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ShareWithUserPopupActionKeys */].SET_USERS:
            return __assign({}, state, { users: action.users, selectedUserId: action.users[0] ? action.users[0].id : null, isLoading: false });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ShareWithUserPopupActionKeys */].SELECT_USER:
            return __assign({}, state, { selectedUserId: action.userId });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* ShareWithUserPopupActionKeys */].RESET:
            return shareWithUserPopupInitialState;
        default:
            return state;
    }
};


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coverImagePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(332);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    isDisplayed: false,
    driveItem: null,
};
var coverImagePanel = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CoverImagePanelActionKeys */].OPEN_PANEL:
            return __assign({}, state, { isDisplayed: true, driveItem: action.driveItem });
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CoverImagePanelActionKeys */].CLOSE_PANEL:
            return initialState;
        default:
            return state;
    }
};


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__ = __webpack_require__(6);


function sessionChecker() {
    return function (api) { return function (next) { return function (action) {
        if (!api) {
            return next(action);
        }
        var _a = api.getState(), isConfigLoaded = _a.galleryInfos.isConfigLoaded, _b = _a.multiAppAuthenticationInfos, credentials = _b.credentials, oneSessPerUser = _b.oneSessPerUser, profile = _a.profile;
        var isLoggedIn = !!(credentials && credentials.login);
        // in mobile app we get flag oneSessPerUser in appLogin call
        // in browser version external login page is used so this flag is gotten from getProfileInfo call
        var shouldCheckSession = __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__["a" /* default */].isMobileApp
            ? oneSessPerUser
            : profile.oneSessPerUser;
        if (isConfigLoaded &&
            isLoggedIn &&
            shouldCheckSession &&
            __WEBPACK_IMPORTED_MODULE_1__utils_userAgent__["a" /* default */].isOnline() &&
            action.type !== __WEBPACK_IMPORTED_MODULE_0__containers_MultiAppAuthentication_actions__["a" /* MultiAppAuthenticationInfosActionKeys */].TOGGLE_CHECK_SESSION_STATUS) {
            api.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__containers_MultiAppAuthentication_actions__["c" /* checkSession */])());
        }
        return next(action);
    }; }; };
}
/* harmony default export */ __webpack_exports__["a"] = (sessionChecker);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MultiAppAuthentication_reducer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotificationBar__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CookieNotification__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Gallery__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MultiAppAuthentication__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MultiAppAuthentication_actions__ = __webpack_require__(34);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















var svgSpritePath = __webpack_require__(357);
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStatusBar = function () {
            setTimeout(function () { _this.requestHasStatusBar(); }, 250);
        };
        _this.requestHasStatusBar = function () {
            __WEBPACK_IMPORTED_MODULE_5__utils_nativeApi__["b" /* default */].hasStatusBar()
                .then(function (hasStatusBar) {
                if (typeof hasStatusBar === 'boolean') {
                    _this.setState({ hasStatusBar: hasStatusBar });
                }
                else {
                    _this.handleStatusBar();
                }
            })
                .catch(function () { return _this.handleStatusBar(); });
        };
        _this.handleVisibilityChange = function () {
            var isConfigLoaded = _this.props.galleryInfos.isConfigLoaded;
            if (__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp && !document.hidden && isConfigLoaded) {
                _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__MultiAppAuthentication_actions__["b" /* checkActiveSession */])(true));
            }
        };
        _this.state = {
            svgSprites: '',
            hasStatusBar: false
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp) {
            this.handleStatusBar();
        }
        this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["c" /* initializeApp */])());
        __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].promiseXHR('GET', svgSpritePath, undefined, undefined, undefined, undefined, undefined, true)
            .then(function (response) { return _this.setState({ svgSprites: response.responseText }); });
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    };
    App.prototype.componentWillUnmount = function () {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    };
    App.prototype.render = function () {
        var _a = this.props, children = _a.children, galleryInfos = _a.galleryInfos, appInfos = _a.appInfos, profile = _a.profile, multiAppAuthenticationInfos = _a.multiAppAuthenticationInfos, params = _a.params, locale = _a.locale;
        var _b = this.state, svgSprites = _b.svgSprites, hasStatusBar = _b.hasStatusBar;
        var template = galleryInfos.template, customCSS = galleryInfos.customCSS;
        var theme = template && template.commonStyles ? template.commonStyles : __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__["e" /* defaultTemplate */].commonStyles;
        var type = appInfos.type;
        var aspConnexionStatus = multiAppAuthenticationInfos.aspConnexionStatus;
        var isConnectedToAsp = aspConnexionStatus === __WEBPACK_IMPORTED_MODULE_8__MultiAppAuthentication_reducer__["a" /* AspConnexionStatus */].SUCCESS;
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp;
        var shouldDisplayMultiAppAuthentication = isMobileApp && type === __WEBPACK_IMPORTED_MODULE_7__reducer__["a" /* AppType */].Multiple && !isConnectedToAsp;
        var AppInnerContainerClass = "AppInnerContainer " + locale;
        if (params && params.origin) {
            AppInnerContainerClass += " origin-" + params.origin;
        }
        if (params && params.originParam && params.origin !== 'search') {
            AppInnerContainerClass += " originParam-" + params.originParam;
        }
        if (profile && profile.id) {
            AppInnerContainerClass += " user-" + profile.id;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeProvider */], { theme: theme },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* AppContainer */], { hasStatusBar: hasStatusBar, customCSS: customCSS },
                type &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["b" /* AppInnerContainer */], { className: AppInnerContainerClass }, shouldDisplayMultiAppAuthentication ?
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__MultiAppAuthentication__["a" /* default */], null)
                        :
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Gallery__["a" /* default */], null, children)),
                !!svgSprites &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "svgSprites", dangerouslySetInnerHTML: { __html: svgSprites } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NotificationBar__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_CookieNotification__["a" /* default */], null))));
    };
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var appInfos = state.appInfos, galleryInfos = state.galleryInfos, multiAppAuthenticationInfos = state.multiAppAuthenticationInfos, profile = state.profile, locale = state.i18n.locale;
    return { appInfos: appInfos, galleryInfos: galleryInfos, multiAppAuthenticationInfos: multiAppAuthenticationInfos, profile: profile, locale: locale };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(App));


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotificationBar__ = __webpack_require__(1074);


var mapStateToProps = function (state) {
    var notificationBar = state.notificationBar;
    return { notificationBar: notificationBar };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NotificationBar__["a" /* default */]));


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var Translate = __webpack_require__(5).Translate;



var NotificationBar = function (_a) {
    var notificationBar = _a.notificationBar;
    var notifications = notificationBar.history;
    var errors = notifications.filter(function (notification, index, self) {
        return notification.barType === __WEBPACK_IMPORTED_MODULE_1__containers_NotificationBar_actions__["a" /* BarType */].Error && index === self.findIndex(function (selfNotification) {
            if (notification.args && selfNotification.args) {
                return selfNotification.message === notification.message
                    && selfNotification.args.id === notification.args.id;
            }
            return selfNotification.message === notification.message;
        });
    });
    var infos = notifications.filter(function (notification) { return notification.barType === __WEBPACK_IMPORTED_MODULE_1__containers_NotificationBar_actions__["a" /* BarType */].Info; });
    var successes = notifications.filter(function (notification) { return notification.barType === __WEBPACK_IMPORTED_MODULE_1__containers_NotificationBar_actions__["a" /* BarType */].Success; });
    var info = infos.length > 0
        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, __assign({ value: infos[0].barType + "." + infos[0].message }, infos[0].args, { dangerousHTML: true })))
        : '';
    var success = successes.length > 0
        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, __assign({ value: successes[0].barType + "." + successes[0].message }, successes[0].args, { dangerousHTML: true })))
        : '';
    var error;
    if (errors.length > 1) {
        error = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: errors[0].barType + ".bundle_" + errors[0].message, number: errors.length, dangerousHTML: true }));
    }
    else if (errors.length === 1) {
        error = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, __assign({ value: errors[0].barType + "." + errors[0].message }, errors[0].args, { dangerousHTML: true })));
    }
    else {
        error = '';
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledNotificationBar */], { isShown: !!notifications.length },
        !!errors.length &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledNotificationText */], { color: __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Red }, error),
        !!infos.length &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledNotificationText */], { color: __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White }, info),
        !!successes.length &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledNotificationText */], { color: __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Green }, success)));
};
/* harmony default export */ __webpack_exports__["a"] = (NotificationBar);


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledNotificationBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledNotificationText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledNotificationBar = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: column wrap;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: fixed;\n\tbottom: 0;\n\tz-index: 95;\n\theight: 75px;\n\tline-height: 20px;\n\tbackground: ", ";\n\topacity: 0.8;\n\twidth: 100%;\n\tcolor: ", ";\n\tfont-size: 14px;\n\tfont-style: italic;\n\ttransform: ", ";\n\ttransition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-flow: column wrap;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: fixed;\n\tbottom: 0;\n\tz-index: 95;\n\theight: 75px;\n\tline-height: 20px;\n\tbackground: ", ";\n\topacity: 0.8;\n\twidth: 100%;\n\tcolor: ", ";\n\tfont-size: 14px;\n\tfont-style: italic;\n\ttransform: ", ";\n\ttransition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return props.isShown ? 'translate(0, 0)' : 'translate(0, 100%)'; });
var StyledNotificationText = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n\n\ta {\n\t\tcolor: currentColor;\n\t}\n"], ["\n\tcolor: ", ";\n\n\ta {\n\t\tcolor: currentColor;\n\t}\n"])), function (props) { return props.color; });
var templateObject_1, templateObject_2;


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AppInnerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var statusBarHeight = function (props) { return props.hasStatusBar ? '20px' : 0; };
var customCSS = function (props) { return props.customCSS || ''; };
__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].init();
var AppContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tpadding-top: ", ";\n\tbackground-color: ", ";\n\n\t::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: ", ";\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground: ", ";\n\t}\n\n\t", "\n\n\t", "\n\n\t@media print {\n\t\t.svgSprites {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t", "\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tpadding-top: ", ";\n\tbackground-color: ", ";\n\n\t::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: ", ";\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground: ", ";\n\t}\n\n\t",
    "\n\n\t",
    "\n\n\t@media print {\n\t\t.svgSprites {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t", "\n"])), statusBarHeight, function (props) { return props.theme.primary.backgroundColor; }, statusBarHeight, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.topnavColor, props.theme.primary.topnavOpacity); }, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\n\t\t::before {\n\t\t\theight: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\t}\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\n\t\t\t::before {\n\t\t\t\theight: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\t}\n\t\t}\n\t", customCSS);
var AppInnerContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\theight: 100%;\n"], ["\n\tposition: relative;\n\theight: 100%;\n"])));

var templateObject_1, templateObject_2;


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_CookieNotification_StandardCookie__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_CookieNotification_GDPRCookie__ = __webpack_require__(1081);



var CookieNotification = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_CookieNotification_StandardCookie__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_CookieNotification_GDPRCookie__["a" /* default */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (CookieNotification);


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CookieNotification_StandardCookie__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(514);



var mapStateToProps = function (state) {
    var cookie = state.galleryInfos.template.cookie, areCookieAccepted = state.appInfos.areCookieAccepted, locale = state.i18n.locale;
    return {
        isDisplayed: !!cookie && cookie.enabled === 'true' && cookie.gdpr === 'false' &&
            !areCookieAccepted,
        url: cookie && cookie.url || __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DEFAULT_COOKIE_URLS */][locale],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CookieNotification_StandardCookie__["a" /* default */]));


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_App_actions__ = __webpack_require__(111);

var Translate = __webpack_require__(5).Translate;



var StandardCookie = function (_a) {
    var isDisplayed = _a.isDisplayed, url = _a.url, dispatch = _a.dispatch;
    var handleClick = function () {
        __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].setCookie('areCookieAccepted', 'true', 90);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_App_actions__["b" /* acceptCookie */])());
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Container */], { isDisplayed: isDisplayed },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* CloseButton */], { onClick: handleClick }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_close-2')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.cookie_notification", url: url, dangerousHTML: true })));
};
/* harmony default export */ __webpack_exports__["a"] = (StandardCookie);


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Container = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\tbottom: 20px;\n\twidth: 600px;\n\tleft: calc(50% - 300px);\n\tbackground: ", ";\n\tcolor: ", ";\n\tz-index: 500;\n\tpadding: 35px 45px 35px 35px;\n\tborder-radius: 5px;\n\tfont-size: 12px;\n\tbox-sizing: border-box;\n\tline-height: 1.5;\n\n\ttransition: opacity 0.5s;\n\t", "\n\n\t@media(max-width: 700px) {\n\t\twidth: calc(100vw - 40px);\n\t\tleft: 20px;\n\t}\n\n\t& > * > a {\n\t\tcolor: ", ";\n\t}\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: fixed;\n\tbottom: 20px;\n\twidth: 600px;\n\tleft: calc(50% - 300px);\n\tbackground: ", ";\n\tcolor: ", ";\n\tz-index: 500;\n\tpadding: 35px 45px 35px 35px;\n\tborder-radius: 5px;\n\tfont-size: 12px;\n\tbox-sizing: border-box;\n\tline-height: 1.5;\n\n\ttransition: opacity 0.5s;\n\t",
    "\n\n\t@media(max-width: 700px) {\n\t\twidth: calc(100vw - 40px);\n\t\tleft: 20px;\n\t}\n\n\t& > * > a {\n\t\tcolor: ", ";\n\t}\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, 70), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, function (props) { return props.isDisplayed
    ? "opacity: 1;"
    : "opacity: 0;\n\t\t\tpointer-events: none;"; }, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100);
var CloseButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100);

var templateObject_1, templateObject_2;


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CookieNotification_GDPRCookie__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(514);




var mapStateToProps = function (state) {
    var galleryInfos = state.galleryInfos, appInfos = state.appInfos, offlineManager = state.offlineManager, isDisplayed = state.GDPRCookie.isDisplayed, cookie = state.galleryInfos.template.cookie, locale = state.i18n.locale;
    var isGdprEnabled = !!cookie && cookie.gdpr === 'true';
    var isGalleryReady = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isGalleryReady(galleryInfos, offlineManager, appInfos);
    var shouldInit = isGdprEnabled && isGalleryReady;
    var url = cookie && cookie.url || __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DEFAULT_COOKIE_URLS */][locale];
    var language = locale.split('_')[0];
    return {
        shouldInit: shouldInit,
        isDisplayed: isDisplayed,
        url: url,
        language: language,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CookieNotification_GDPRCookie__["a" /* default */]));


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Gallery_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_CookieNotification_GDPRCookie_actions__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1084);






var GDPRCookie = function (_a) {
    var shouldInit = _a.shouldInit, isDisplayed = _a.isDisplayed, url = _a.url, language = _a.language, dispatch = _a.dispatch;
    var openPrivacyPolicy = function () { return window.open(url, '_blank'); };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__["b" /* addBannerCloseListener */])(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_CookieNotification_GDPRCookie_actions__["b" /* closeGDPRBanner */])()); });
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__["c" /* addBannerOpenListener */])(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_CookieNotification_GDPRCookie_actions__["c" /* openGDPRBanner */])()); });
        if (shouldInit) {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__["e" /* initGDPR */])(language, url, function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Gallery_actions__["b" /* initStatistics */])()); });
        }
    }, [shouldInit]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["e" /* Container */], { isDisplayed: isDisplayed },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["g" /* Message */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "messages.gdpr_message" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["f" /* Group */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* ButtonAllowAll */], { onClick: __WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__["a" /* acceptAll */] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "messages.gdpr_allowAll" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* ButtonPersonalize */], { onClick: __WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__["f" /* openPanel */] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "messages.gdpr_personalize" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["f" /* Group */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* ButtonPrivacyPolicy */], { onClick: openPrivacyPolicy },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "messages.gdpr_privacy_policy" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* ButtonRejectAll */], { onClick: __WEBPACK_IMPORTED_MODULE_2__utils_GDPRApi__["d" /* denyAll */] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "messages.gdpr_reject_all" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (GDPRCookie);


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initGDPR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return denyAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return openPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addBannerOpenListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addBannerCloseListener; });
var UprezStatsKey = 'uprezStats';
var closeBannerEventName = 'tac.close_alert';
var openBannerEventName = 'tac.open_alert';
var loadTarteaucitron = function () {
    /*
        A few things to note about the tarteaucitron library:

        1) The library tarteaucitron is supposed to be initiated in <body> and a part of the init is attached to window.onload.
        We can't do that because we need to know from a config if gallApp must be gdpr compliant
        This method contains the code that is supposed to be executed after the page is loaded
        If you upgrade the tarteaucitron library, replace this code by the part attached on window.onload in the library's code.

        2) If you add new translations to project, make sure to add them to this library too.

        3) The EdgeHTML webview currently used in the windows version of the application does not allow the creation of cookies for a local domain.
        For this reason, for apps on this OS, the consent can't be stored in a cookie and should be stored in the localStorage instead.
        In commit 534286b, we modified the tarteaucitron.js file to detect if local cookies are working and using localStorage when needed.

        4) The library isn't compatible with Webpack so it is placed in public/.gallery/static/libs.
    */
    window.tarteaucitron.load();
    window.tarteaucitron.fallback(['tarteaucitronOpenPanel'], function (elem) {
        elem.addEventListener('click', function (event) {
            window.tarteaucitron.userInterface.openPanel();
            event.preventDefault();
        }, false);
    }, true);
};
var initGDPR = function (language, privacyUrl, onAccept) {
    window.tarteaucitronForceLanguage = language;
    window.tarteaucitron.init({
        'privacyUrl': privacyUrl,
        'hashtag': '#tarteaucitron',
        'cookieName': 'tarteaucitron',
        'orientation': 'bottom',
        'showAlertBig': false,
        'showAlertSmall': false,
        'cookieslist': false,
        'showIcon': false,
        'iconPosition': 'BottomRight',
        'adblocker': false,
        'DenyAllCta': true,
        'AcceptAllCta': true,
        'highPrivacy': true,
        'handleBrowserDNTRequest': false,
        'removeCredit': true,
        'moreInfoLink': false,
        'useExternalCss': false,
        'readmoreLink': privacyUrl,
        'mandatory': false,
    });
    window.tarteaucitron.services.uprezStats = {
        'key': UprezStatsKey,
        'type': 'analytic',
        'name': 'Google Analytics',
        'uri': 'https://support.google.com/analytics/answer/6004245',
        'needConsent': true,
        'cookies': ['_ga', '_gat', '_gid', '__utma', '__utmb', '__utmc', '__utmt', '__utmz'],
        'js': function () {
            'use strict';
            // When user allows service
            onAccept();
        },
    };
    (window.tarteaucitron.job = window.tarteaucitron.job || []).push(UprezStatsKey);
    loadTarteaucitron();
};
var acceptAll = function () { return window.tarteaucitron.userInterface.respondAll(true); };
var denyAll = function () { return window.tarteaucitron.userInterface.respondAll(false); };
var openPanel = function () { return window.tarteaucitron.userInterface.openPanel(); };
var addBannerOpenListener = function (method) { return window.addEventListener(openBannerEventName, method); };
var addBannerCloseListener = function (method) { return window.addEventListener(closeBannerEventName, method); };



/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Group; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonAllowAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonPersonalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonPrivacyPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonRejectAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Container = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px;\n\tbackground-color: ", ";\n\tz-index: 500;\n\topacity: 1;\n\n\ttransition: opacity 200ms, bottom 200ms;\n\t", "\n\n\t@media(max-width: 1200px) {\n\t\tflex-direction: column;\n\t}\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px;\n\tbackground-color: ", ";\n\tz-index: 500;\n\topacity: 1;\n\n\ttransition: opacity 200ms, bottom 200ms;\n\t",
    "\n\n\t@media(max-width: 1200px) {\n\t\tflex-direction: column;\n\t}\n\n\t@media print {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return props.isDisplayed
    ? "opacity: 1;\n\t\t\tbottom: 0;"
    : "opacity: 0;\n\t\t\tbottom: -100px;\n\t\t\tpointer-events:none;"; });
var Message = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 15px;\n\tcolor: ", ";\n"], ["\n\tfont-size: 15px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);
var Group = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: 20px;\n\n\t@media(max-width: 1200px) {\n\t\tpadding-top:10px;\n\t\tmargin: 0;\n\t}\n"], ["\n\tmargin-left: 20px;\n\n\t@media(max-width: 1200px) {\n\t\tpadding-top:10px;\n\t\tmargin: 0;\n\t}\n"])));
var ButtonAllowAll = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding: 5px 10px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder: 0;\n\tborder-radius: 3px;\n\tmargin-right: 20px;\n\tcursor: pointer;\n"], ["\n\tpadding: 5px 10px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder: 0;\n\tborder-radius: 3px;\n\tmargin-right: 20px;\n\tcursor: pointer;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var ButtonPersonalize = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: 5px 10px;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 3px;\n\tcursor: pointer;\n"], ["\n\tpadding: 5px 10px;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 3px;\n\tcursor: pointer;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);
var ButtonPrivacyPolicy = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tborder: 0;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n"], ["\n\tborder: 0;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);
var ButtonRejectAll = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tbackground-color: transparent;\n\tborder: 0;\n\tcolor: ", ";\n\ttext-align: center;\n\tcursor: pointer;\n"], ["\n\tbackground-color: transparent;\n\tborder: 0;\n\tcolor: ", ";\n\ttext-align: center;\n\tcursor: pointer;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export svgSpritePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dnd_html5_backend__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dnd_touch_backend__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dnd_multi_backend__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_iframeApi_BackofficeModeManager__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MenuManager_Left__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Splashscreen__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MenuManager_actions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Authentication_styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Authentication__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DownloadAllPopup__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Share_WebpublicationForm__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Share_UprezForm__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ContextualMenu__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FolderCreationPanel__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PublicationCreator__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AssetRenamePanel__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ExternalLinkCreationPanel__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__NoSaveAsPopup__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__MultiAppAuthentication_AnotherUserLoginPopup__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__MultiAppAuthentication_SessionExpiredPopup__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__NotesEditorPanel__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CoverImagePanel__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__DownloadGroupToast__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ContentStructureToast__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ShareWithUserPopup__ = __webpack_require__(1359);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


































var svgSpritePath = __webpack_require__(357);
var HTML5toTouch = {
    backends: [
        {
            backend: __WEBPACK_IMPORTED_MODULE_3_react_dnd_html5_backend__["a" /* default */],
        },
        {
            backend: __WEBPACK_IMPORTED_MODULE_4_react_dnd_touch_backend__["a" /* default */],
            preview: true,
            transition: __WEBPACK_IMPORTED_MODULE_5_react_dnd_multi_backend__["b" /* TouchTransition */],
        },
    ],
};
var Gallery = /** @class */ (function (_super) {
    __extends(Gallery, _super);
    function Gallery(props) {
        var _this = _super.call(this, props) || this;
        _this.onConnectionIsUp = function () {
            var authentication = _this.props.authentication;
            var mode = authentication.userInfos.mode;
            if (__WEBPACK_IMPORTED_MODULE_15__utils_authentication__["a" /* default */].needReconnecting(mode) && __WEBPACK_IMPORTED_MODULE_15__utils_authentication__["a" /* default */].isOnCache(mode)) {
                _this.setState({ needConnectionFromCache: true });
            }
        };
        _this.setPageTitle = function (currentPath, params, props) { return __awaiter(_this, void 0, void 0, function () {
            var galleryInfos, appInfos, driveList, dispatch, authentication, offlineManager, config, mode, isReady, isWaitingAuthentication, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        galleryInfos = props.galleryInfos, appInfos = props.appInfos, driveList = props.driveList, dispatch = props.dispatch, authentication = props.authentication, offlineManager = props.offlineManager;
                        config = galleryInfos.config;
                        mode = authentication.userInfos.mode;
                        isReady = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].isGalleryReady(galleryInfos, offlineManager, appInfos);
                        isWaitingAuthentication = authentication.userInfos.needCredentials && __WEBPACK_IMPORTED_MODULE_15__utils_authentication__["a" /* default */].isNotConnected(mode);
                        if (!(isReady && !isWaitingAuthentication)) return [3 /*break*/, 2];
                        _a = document;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getPageTitle(currentPath, params, config, driveList, dispatch)];
                    case 1:
                        _a.title = _b.sent();
                        if (document.title) {
                            this.isDocumentTitleSet = true;
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.onWindowResize = _this.onWindowResize.bind(_this);
        _this.onConnectionIsUp = _this.onConnectionIsUp.bind(_this);
        _this.state = {
            screenFormat: __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getScreenFormat(),
            needConnectionFromCache: false
        };
        __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].subscribeToConnectionIsUp(function () {
            _this.onConnectionIsUp();
        });
        _this.isDocumentTitleSet = false;
        return _this;
    }
    Gallery.prototype.componentDidMount = function () {
        var _a = this.props, dispatch = _a.dispatch, routerParamsHistory = _a.routerParamsHistory, galleryInfos = _a.galleryInfos;
        var _b = routerParamsHistory[routerParamsHistory.length - 1], params = _b.params, routes = _b.routes;
        var template = galleryInfos.template;
        // Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.onWindowResize, true);
        }
        else {
            window.addEventListener('resize', this.onWindowResize, true);
        }
        if (__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isAndroidApp()) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions__["h" /* emptyDownloadCache */])());
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["c" /* initializeGallery */])());
        if (!__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp) {
            var currentPath = routes[routes.length - 1].path;
            this.setPageTitle(currentPath, params, this.props);
        }
        if (template) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__MenuManager_actions__["e" /* setMenuConfigMode */])(this.state.screenFormat));
        }
        window.parent.postMessage({
            target: 'GallApp',
            action: 'redirection',
            params: {
                src: window.location.href
            }
            // tslint:disable-next-line:align
        }, '*');
    };
    Gallery.prototype.componentWillReceiveProps = function (props) {
        var galleryInfos = props.galleryInfos, dispatch = props.dispatch, routerParamsHistory = props.routerParamsHistory, authentication = props.authentication;
        var needConnectionFromCache = this.state.needConnectionFromCache;
        var isLocalTemplateLoaded = galleryInfos.isLocalTemplateLoaded, template = galleryInfos.template;
        var mode = authentication.userInfos.mode;
        var prevMode = this.props.authentication.userInfos.mode;
        var prevTemplate = this.props.galleryInfos.template;
        if (!__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp) {
            var backOfficeModeKey = 'backofficeMode';
            var isBackofficeModeEnabled = window.location.href.includes(backOfficeModeKey);
            var isBackofficeModeManagerCreated = this.backofficeModeManager !== undefined;
            var prevRouterParamsHistory = this.props.routerParamsHistory;
            var prevRoutes = prevRouterParamsHistory[prevRouterParamsHistory.length - 1] && prevRouterParamsHistory[prevRouterParamsHistory.length - 1].routes;
            var _a = routerParamsHistory[routerParamsHistory.length - 1], params = _a.params, routes = _a.routes;
            if (isBackofficeModeEnabled && isLocalTemplateLoaded && !isBackofficeModeManagerCreated) {
                this.backofficeModeManager = new __WEBPACK_IMPORTED_MODULE_8__utils_iframeApi_BackofficeModeManager__["a" /* default */](dispatch);
            }
            var currentPath = routes[routes.length - 1].path;
            if (prevRoutes !== routes) {
                this.isDocumentTitleSet = false;
            }
            if (!this.isDocumentTitleSet) {
                this.setPageTitle(currentPath, params, props);
            }
        }
        if (prevTemplate !== template) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__MenuManager_actions__["e" /* setMenuConfigMode */])(this.state.screenFormat));
        }
        if (mode !== prevMode) {
            if (__WEBPACK_IMPORTED_MODULE_15__utils_authentication__["a" /* default */].isConnected(mode) && (!__WEBPACK_IMPORTED_MODULE_15__utils_authentication__["a" /* default */].isOnCache(mode) && needConnectionFromCache)) {
                this.setState({ needConnectionFromCache: false });
            }
        }
    };
    Gallery.prototype.componentWillUnmount = function () {
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.onWindowResize);
        }
        else {
            window.removeEventListener('resize', this.onWindowResize);
        }
    };
    Gallery.prototype.render = function () {
        var _a = this.props, children = _a.children, galleryInfos = _a.galleryInfos, offlineManager = _a.offlineManager, authentication = _a.authentication, menuManager = _a.menuManager, appInfos = _a.appInfos, isReadOnlyApp = _a.isReadOnlyApp;
        var needConnectionFromCache = this.state.needConnectionFromCache;
        var forceViewUpdateCount = galleryInfos.forceViewUpdateCount, forceSplashScreen = galleryInfos.forceSplashScreen;
        var _b = authentication.userInfos, needCredentials = _b.needCredentials, mode = _b.mode;
        var menuModes = menuManager.menuModes;
        var isWaitingAuthentication = needCredentials && __WEBPACK_IMPORTED_MODULE_15__utils_authentication__["a" /* default */].isNotConnected(mode);
        var isGalleryReady = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].isGalleryReady(galleryInfos, offlineManager, appInfos);
        var shouldDisplaySplashScreen = !(isGalleryReady || isWaitingAuthentication) || forceSplashScreen;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_dnd__["b" /* DndProvider */], { backend: __WEBPACK_IMPORTED_MODULE_5_react_dnd_multi_backend__["c" /* default */], options: HTML5toTouch },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["b" /* GalleryContainer */], null,
                isGalleryReady && menuModes && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__MenuManager_Left__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].isMultiApp(appInfos)
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Share_UprezForm__["a" /* default */], null)
                    : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__Share_WebpublicationForm__["a" /* default */], null),
                isGalleryReady || isWaitingAuthentication ?
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* GalleryChildrenContainer */], { key: forceViewUpdateCount }, children)
                    :
                        null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__DownloadAllPopup__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__ContextualMenu__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29__NotesEditorPanel__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32__ContentStructureToast__["a" /* default */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__DownloadGroupToast__["a" /* default */], null))),
                !isReadOnlyApp &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__FolderCreationPanel__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__PublicationCreator__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26__NoSaveAsPopup__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__AssetRenamePanel__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__ExternalLinkCreationPanel__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__MultiAppAuthentication_AnotherUserLoginPopup__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__MultiAppAuthentication_SessionExpiredPopup__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_33__ShareWithUserPopup__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30__CoverImagePanel__["a" /* default */], null)),
                needConnectionFromCache && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Authentication__["a" /* default */], { origin: __WEBPACK_IMPORTED_MODULE_16__components_Authentication_styles__["j" /* SamlIframeOrigin */].App }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_Splashscreen__["a" /* default */], { display: shouldDisplaySplashScreen }))));
    };
    Gallery.prototype.onWindowResize = function () {
        var _a = this.props, galleryInfos = _a.galleryInfos, menuManager = _a.menuManager, dispatch = _a.dispatch;
        var screenFormat = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getScreenFormat();
        if (galleryInfos.template && !menuManager.menuModes || screenFormat !== this.state.screenFormat) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__MenuManager_actions__["e" /* setMenuConfigMode */])(screenFormat));
            this.setState({ screenFormat: screenFormat });
        }
    };
    return Gallery;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var appInfos = state.appInfos, galleryInfos = state.galleryInfos, offlineManager = state.offlineManager, authentication = state.authentication, driveList = state.driveList, routerParamsHistory = state.routerParamsHistory, menuManager = state.menuManager, profile = state.profile;
    return {
        appInfos: appInfos,
        galleryInfos: galleryInfos,
        offlineManager: offlineManager,
        authentication: authentication,
        driveList: driveList,
        routerParamsHistory: routerParamsHistory,
        menuManager: menuManager,
        isReadOnlyApp: __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].isReadOnlyApp(profile.role),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Gallery));


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DndContext__ = __webpack_require__(333);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DndContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DndProvider__ = __webpack_require__(1111);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__DndProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DragPreviewImage__ = __webpack_require__(1112);
/* unused harmony namespace reexport */




/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interfaces__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__factories__ = __webpack_require__(1088);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__factories__["a"]; });



/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDragDropManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DragDropManagerImpl__ = __webpack_require__(1089);

function createDragDropManager(backendFactory, globalContext, backendOptions, debugMode) {
  var manager = new __WEBPACK_IMPORTED_MODULE_0__DragDropManagerImpl__["a" /* default */](debugMode);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropManagerImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_dragDrop__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DragDropMonitorImpl__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HandlerRegistryImpl__ = __webpack_require__(1105);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







function makeStoreInstance(debugMode) {
  // TODO: if we ever make a react-native version of this,
  // we'll need to consider how to pull off dev-tooling
  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* createStore */])(__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */], debugMode && reduxDevTools && reduxDevTools({
    name: 'dnd-core',
    instanceId: 'dnd-core'
  }));
}

var DragDropManagerImpl =
/*#__PURE__*/
function () {
  function DragDropManagerImpl() {
    var _this = this;

    var debugMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _classCallCheck(this, DragDropManagerImpl);

    this.isSetUp = false;

    this.handleRefCountChange = function () {
      var shouldSetUp = _this.store.getState().refCount > 0;

      if (_this.backend) {
        if (shouldSetUp && !_this.isSetUp) {
          _this.backend.setup();

          _this.isSetUp = true;
        } else if (!shouldSetUp && _this.isSetUp) {
          _this.backend.teardown();

          _this.isSetUp = false;
        }
      }
    };

    var store = makeStoreInstance(debugMode);
    this.store = store;
    this.monitor = new __WEBPACK_IMPORTED_MODULE_3__DragDropMonitorImpl__["a" /* default */](store, new __WEBPACK_IMPORTED_MODULE_4__HandlerRegistryImpl__["a" /* default */](store));
    store.subscribe(this.handleRefCountChange);
  }

  _createClass(DragDropManagerImpl, [{
    key: "receiveBackend",
    value: function receiveBackend(backend) {
      this.backend = backend;
    }
  }, {
    key: "getMonitor",
    value: function getMonitor() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function getBackend() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      /* eslint-disable-next-line @typescript-eslint/no-this-alias */
      var manager = this;
      var dispatch = this.store.dispatch;

      function bindActionCreator(actionCreator) {
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var action = actionCreator.apply(manager, args);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      var actions = Object(__WEBPACK_IMPORTED_MODULE_2__actions_dragDrop__["g" /* default */])(this);
      return Object.keys(actions).reduce(function (boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.store.dispatch(action);
    }
  }]);

  return DragDropManagerImpl;
}();



/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* unused harmony export applyMiddleware */
/* unused harmony export bindActionCreators */
/* unused harmony export combineReducers */
/* unused harmony export compose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(284);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dragOffset__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dragOperation__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__refCount__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dirtyHandlerIds__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stateId__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js_utils__ = __webpack_require__(145);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    dirtyHandlerIds: Object(__WEBPACK_IMPORTED_MODULE_3__dirtyHandlerIds__["a" /* default */])(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread({}, action.payload, {
        prevTargetIds: Object(__WEBPACK_IMPORTED_MODULE_5__utils_js_utils__["a" /* get */])(state, 'dragOperation.targetIds', [])
      })
    }),
    dragOffset: Object(__WEBPACK_IMPORTED_MODULE_0__dragOffset__["a" /* default */])(state.dragOffset, action),
    refCount: Object(__WEBPACK_IMPORTED_MODULE_2__refCount__["a" /* default */])(state.refCount, action),
    dragOperation: Object(__WEBPACK_IMPORTED_MODULE_1__dragOperation__["a" /* default */])(state.dragOperation, action),
    stateId: Object(__WEBPACK_IMPORTED_MODULE_4__stateId__["a" /* default */])(state.stateId)
  };
}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dragOffset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_equality__ = __webpack_require__(517);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function dragOffset() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["e" /* INIT_COORDS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["a" /* BEGIN_DRAG */]:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["d" /* HOVER */]:
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_equality__["b" /* areCoordsEqual */])(state.clientOffset, payload.clientOffset)) {
        return state;
      }

      return _objectSpread({}, state, {
        clientOffset: payload.clientOffset
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["c" /* END_DRAG */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["b" /* DROP */]:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBeginDrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__local_setClientOffset__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js_utils__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(122);




var ResetCoordinatesAction = {
  type: __WEBPACK_IMPORTED_MODULE_3__types__["e" /* INIT_COORDS */],
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(manager) {
  return function beginDrag() {
    var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      publishSource: true
    };
    var _options$publishSourc = options.publishSource,
        publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc,
        clientOffset = options.clientOffset,
        getSourceClientOffset = options.getSourceClientOffset;
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry(); // Initialize the coordinates using the client offset

    manager.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__local_setClientOffset__["a" /* setClientOffset */])(clientOffset));
    verifyInvariants(sourceIds, monitor, registry); // Get the draggable source

    var sourceId = getDraggableSource(sourceIds, monitor);

    if (sourceId === null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    } // Get the source client offset


    var sourceClientOffset = null;

    if (clientOffset) {
      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
      sourceClientOffset = getSourceClientOffset(sourceId);
    } // Initialize the full coordinates


    manager.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__local_setClientOffset__["a" /* setClientOffset */])(clientOffset, sourceClientOffset));
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId);
    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
      type: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* BEGIN_DRAG */],
      payload: {
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}

function verifyInvariants(sourceIds, monitor, registry) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
  sourceIds.forEach(function (sourceId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
  });
}

function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}

function verifyItemIsObject(item) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js_utils__["c" /* isObject */])(item), 'Item must be an object.');
}

function getDraggableSource(sourceIds, monitor) {
  var sourceId = null;

  for (var i = sourceIds.length - 1; i >= 0; i--) {
    if (monitor.canDragSource(sourceIds[i])) {
      sourceId = sourceIds[i];
      break;
    }
  }

  return sourceId;
}

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setClientOffset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(122);

function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* INIT_COORDS */],
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPublishDragSource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(122);

function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();

    if (monitor.isDragging()) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* PUBLISH_DRAG_SOURCE */]
      };
    }
  };
}

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createHover;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_matchesType__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(122);



function createHover(manager) {
  return function hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        clientOffset = _ref.clientOffset;

    verifyTargetIdsIsArray(targetIdsArg);
    var targetIds = targetIdsArg.slice(0);
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    checkInvariants(targetIds, monitor, registry);
    var draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* HOVER */],
      payload: {
        targetIds: targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}

function verifyTargetIdsIsArray(targetIdsArg) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}

function checkInvariants(targetIds, monitor, registry) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(monitor.isDragging(), 'Cannot call hover while not dragging.');
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!monitor.didDrop(), 'Cannot call hover after drop.');

  for (var i = 0; i < targetIds.length; i++) {
    var targetId = targetIds[i];
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
    var target = registry.getTarget(targetId);
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(target, 'Expected targetIds to be registered.');
  }
}

function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  // Remove those targetIds that don't match the targetType.  This
  // fixes shallow isOver which would only be non-shallow because of
  // non-matching targets.
  for (var i = targetIds.length - 1; i >= 0; i--) {
    var targetId = targetIds[i];
    var targetType = registry.getTargetType(targetId);

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_matchesType__["a" /* default */])(targetType, draggedItemType)) {
      targetIds.splice(i, 1);
    }
  }
}

function hoverAllTargets(targetIds, monitor, registry) {
  // Finally call hover on all matching targets.
  targetIds.forEach(function (targetId) {
    var target = registry.getTarget(targetId);
    target.hover(monitor, targetId);
  });
}

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDrop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js_utils__ = __webpack_require__(145);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function createDrop(manager) {
  return function drop() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyInvariants(monitor);
    var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action

    targetIds.forEach(function (targetId, index) {
      var dropResult = determineDropResult(targetId, index, registry, monitor);
      var action = {
        type: __WEBPACK_IMPORTED_MODULE_1__types__["b" /* DROP */],
        payload: {
          dropResult: _objectSpread({}, options, {}, dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}

function verifyInvariants(monitor) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(monitor.isDragging(), 'Cannot call drop while not dragging.');
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}

function determineDropResult(targetId, index, registry, monitor) {
  var target = registry.getTarget(targetId);
  var dropResult = target ? target.drop(monitor, targetId) : undefined;
  verifyDropResultType(dropResult);

  if (typeof dropResult === 'undefined') {
    dropResult = index === 0 ? {} : monitor.getDropResult();
  }

  return dropResult;
}

function verifyDropResultType(dropResult) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof dropResult === 'undefined' || Object(__WEBPACK_IMPORTED_MODULE_2__utils_js_utils__["c" /* isObject */])(dropResult), 'Drop result must either be an object or undefined.');
}

function getDroppableTargets(monitor) {
  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEndDrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(122);


function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();
    var source = registry.getSource(sourceId, true);
    source.endDrag(monitor, sourceId);
    registry.unpinSource();
    return {
      type: __WEBPACK_IMPORTED_MODULE_1__types__["c" /* END_DRAG */]
    };
  };
}

function verifyIsDragging(monitor) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dragOperation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_registry__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js_utils__ = __webpack_require__(145);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var initialState = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};
function dragOperation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["a" /* BEGIN_DRAG */]:
      return _objectSpread({}, state, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["f" /* PUBLISH_DRAG_SOURCE */]:
      return _objectSpread({}, state, {
        isSourcePublic: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["d" /* HOVER */]:
      return _objectSpread({}, state, {
        targetIds: payload.targetIds
      });

    case __WEBPACK_IMPORTED_MODULE_1__actions_registry__["d" /* REMOVE_TARGET */]:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }

      return _objectSpread({}, state, {
        targetIds: Object(__WEBPACK_IMPORTED_MODULE_2__utils_js_utils__["d" /* without */])(state.targetIds, payload.targetId)
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["b" /* DROP */]:
      return _objectSpread({}, state, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["c" /* END_DRAG */]:
      return _objectSpread({}, state, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });

    default:
      return state;
  }
}

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = refCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_registry__ = __webpack_require__(241);

function refCount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_registry__["a" /* ADD_SOURCE */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_registry__["b" /* ADD_TARGET */]:
      return state + 1;

    case __WEBPACK_IMPORTED_MODULE_0__actions_registry__["c" /* REMOVE_SOURCE */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_registry__["d" /* REMOVE_TARGET */]:
      return state - 1;

    default:
      return state;
  }
}

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dirtyHandlerIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_registry__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_equality__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_js_utils__ = __webpack_require__(145);





function dirtyHandlerIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__["b" /* NONE */];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["d" /* HOVER */]:
      break;

    case __WEBPACK_IMPORTED_MODULE_1__actions_registry__["a" /* ADD_SOURCE */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_registry__["b" /* ADD_TARGET */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_registry__["d" /* REMOVE_TARGET */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_registry__["c" /* REMOVE_SOURCE */]:
      return __WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__["b" /* NONE */];

    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["a" /* BEGIN_DRAG */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["f" /* PUBLISH_DRAG_SOURCE */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["c" /* END_DRAG */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_dragDrop__["b" /* DROP */]:
    default:
      return __WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__["a" /* ALL */];
  }

  var _action$payload = action.payload,
      _action$payload$targe = _action$payload.targetIds,
      targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
      _action$payload$prevT = _action$payload.prevTargetIds,
      prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = Object(__WEBPACK_IMPORTED_MODULE_4__utils_js_utils__["e" /* xor */])(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !Object(__WEBPACK_IMPORTED_MODULE_2__utils_equality__["a" /* areArraysEqual */])(targetIds, prevTargetIds);

  if (!didChange) {
    return __WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__["b" /* NONE */];
  } // Check the target ids at the innermost position. If they are valid, add them
  // to the result


  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];

  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }

    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }

  return result;
}

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stateId;
function stateId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropMonitorImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_matchesType__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_coords__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__ = __webpack_require__(518);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var DragDropMonitorImpl =
/*#__PURE__*/
function () {
  function DragDropMonitorImpl(store, registry) {
    _classCallCheck(this, DragDropMonitorImpl);

    this.store = store;
    this.registry = registry;
  }

  _createClass(DragDropMonitorImpl, [{
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        handlerIds: undefined
      };
      var handlerIds = options.handlerIds;
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof listener === 'function', 'listener must be a function.');
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
      var prevStateId = this.store.getState().stateId;

      var handleChange = function handleChange() {
        var state = _this.store.getState();

        var currentStateId = state.stateId;

        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !Object(__WEBPACK_IMPORTED_MODULE_3__utils_dirtiness__["c" /* areDirty */])(state.dirtyHandlerIds, handlerIds);

          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof listener === 'function', 'listener must be a function.');
      var previousState = this.store.getState().dragOffset;

      var handleChange = function handleChange() {
        var nextState = _this2.store.getState().dragOffset;

        if (nextState === previousState) {
          return;
        }

        previousState = nextState;
        listener();
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId);
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(source, 'Expected to find a valid source.');

      if (this.isDragging()) {
        return false;
      }

      return source.canDrag(this, sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var target = this.registry.getTarget(targetId);
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(target, 'Expected to find a valid target.');

      if (!this.isDragging() || this.didDrop()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_matchesType__["a" /* default */])(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.getItemType());
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      // undefined on initial render
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId, true);
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(source, 'Expected to find a valid source.');

      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }

      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();

      if (sourceType !== draggedItemType) {
        return false;
      }

      return source.isDragging(this, sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shallow: false
      };

      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var shallow = options.shallow;

      if (!this.isDragging()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();

      if (draggedItemType && !Object(__WEBPACK_IMPORTED_MODULE_1__utils_matchesType__["a" /* default */])(targetType, draggedItemType)) {
        return false;
      }

      var targetIds = this.getTargetIds();

      if (!targetIds.length) {
        return false;
      }

      var index = targetIds.indexOf(targetId);

      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.store.getState().dragOperation.isSourcePublic;
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_coords__["b" /* getSourceClientOffset */])(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_coords__["a" /* getDifferenceFromInitialOffset */])(this.store.getState().dragOffset);
    }
  }]);

  return DragDropMonitorImpl;
}();



/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* harmony export (immutable) */ __webpack_exports__["b"] = getSourceClientOffset;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDifferenceFromInitialOffset;
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */
function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */

function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */

function getSourceClientOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset,
      initialSourceClientOffset = state.initialSourceClientOffset;

  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }

  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */

function getDifferenceFromInitialOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset;

  if (!clientOffset || !initialClientOffset) {
    return null;
  }

  return subtract(clientOffset, initialClientOffset);
}

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandlerRegistryImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_registry__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getNextUniqueId__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contracts__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__react_dnd_asap__ = __webpack_require__(1108);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








function getNextHandlerId(role) {
  var id = Object(__WEBPACK_IMPORTED_MODULE_2__utils_getNextUniqueId__["a" /* default */])().toString();

  switch (role) {
    case __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].SOURCE:
      return "S".concat(id);

    case __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].TARGET:
      return "T".concat(id);

    default:
      throw new Error("Unknown Handler Role: ".concat(role));
  }
}

function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case 'S':
      return __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].SOURCE;

    case 'T':
      return __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].TARGET;

    default:
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(false, "Cannot parse handler ID: ".concat(handlerId));
  }
}

function mapContainsValue(map, searchValue) {
  var entries = map.entries();
  var isDone = false;

  do {
    var _entries$next = entries.next(),
        done = _entries$next.done,
        _entries$next$value = _slicedToArray(_entries$next.value, 2),
        value = _entries$next$value[1];

    if (value === searchValue) {
      return true;
    }

    isDone = !!done;
  } while (!isDone);

  return false;
}

var HandlerRegistryImpl =
/*#__PURE__*/
function () {
  function HandlerRegistryImpl(store) {
    _classCallCheck(this, HandlerRegistryImpl);

    this.types = new Map();
    this.dragSources = new Map();
    this.dropTargets = new Map();
    this.pinnedSourceId = null;
    this.pinnedSource = null;
    this.store = store;
  }

  _createClass(HandlerRegistryImpl, [{
    key: "addSource",
    value: function addSource(type, source) {
      Object(__WEBPACK_IMPORTED_MODULE_4__contracts__["c" /* validateType */])(type);
      Object(__WEBPACK_IMPORTED_MODULE_4__contracts__["a" /* validateSourceContract */])(source);
      var sourceId = this.addHandler(__WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].SOURCE, type, source);
      this.store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_registry__["e" /* addSource */])(sourceId));
      return sourceId;
    }
  }, {
    key: "addTarget",
    value: function addTarget(type, target) {
      Object(__WEBPACK_IMPORTED_MODULE_4__contracts__["c" /* validateType */])(type, true);
      Object(__WEBPACK_IMPORTED_MODULE_4__contracts__["b" /* validateTargetContract */])(target);
      var targetId = this.addHandler(__WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].TARGET, type, target);
      this.store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_registry__["f" /* addTarget */])(targetId));
      return targetId;
    }
  }, {
    key: "containsHandler",
    value: function containsHandler(handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
  }, {
    key: "getSource",
    value: function getSource(sourceId) {
      var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.isSourceId(sourceId), 'Expected a valid source ID.');
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    }
  }, {
    key: "getTarget",
    value: function getTarget(targetId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.dropTargets.get(targetId);
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(sourceId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.isSourceId(sourceId), 'Expected a valid source ID.');
      return this.types.get(sourceId);
    }
  }, {
    key: "getTargetType",
    value: function getTargetType(targetId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.types.get(targetId);
    }
  }, {
    key: "isSourceId",
    value: function isSourceId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function isTargetId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].TARGET;
    }
  }, {
    key: "removeSource",
    value: function removeSource(sourceId) {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.getSource(sourceId), 'Expected an existing source.');
      this.store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_registry__["g" /* removeSource */])(sourceId));
      Object(__WEBPACK_IMPORTED_MODULE_5__react_dnd_asap__["a" /* asap */])(function () {
        _this.dragSources.delete(sourceId);

        _this.types.delete(sourceId);
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(targetId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.getTarget(targetId), 'Expected an existing target.');
      this.store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_registry__["h" /* removeTarget */])(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    }
  }, {
    key: "pinSource",
    value: function pinSource(sourceId) {
      var source = this.getSource(sourceId);
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(source, 'Expected an existing source.');
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    }
  }, {
    key: "unpinSource",
    value: function unpinSource() {
      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(this.pinnedSource, 'No source is pinned at the time.');
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function addHandler(role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);

      if (role === __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === __WEBPACK_IMPORTED_MODULE_3__interfaces__["a" /* HandlerRole */].TARGET) {
        this.dropTargets.set(id, handler);
      }

      return id;
    }
  }]);

  return HandlerRegistryImpl;
}();



/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNextUniqueId;
var nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSourceContract;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateTargetContract;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


function validateSourceContract(source) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof target.hover === 'function', 'Expected hover to be a function.');
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(function (t) {
      return validateType(t, false);
    });
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof type === 'string' || _typeof(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asap__ = __webpack_require__(1109);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__asap__["a"]; });


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__raw__ = __webpack_require__(1110);
 // rawAsap provides everything we need except exception management.
// RawTasks are recycled to reduce GC churn.

var freeTasks = []; // We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.

var pendingErrors = [];
var requestErrorThrow = __WEBPACK_IMPORTED_MODULE_0__raw__["a" /* rawAsap */].makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
  if (pendingErrors.length) {
    throw pendingErrors.shift();
  }
}
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */


function asap(task) {
  var rawTask;

  if (freeTasks.length) {
    rawTask = freeTasks.pop();
  } else {
    rawTask = new RawTask();
  }

  rawTask.task = task;
  Object(__WEBPACK_IMPORTED_MODULE_0__raw__["a" /* rawAsap */])(rawTask);
} // We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.

var RawTask =
/** @class */
function () {
  function RawTask() {}

  RawTask.prototype.call = function () {
    try {
      this.task.call();
    } catch (error) {
      if (asap.onerror) {
        // This hook exists purely for testing purposes.
        // Its name will be periodically randomized to break any code that
        // depends on its existence.
        asap.onerror(error);
      } else {
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        pendingErrors.push(error);
        requestErrorThrow();
      }
    } finally {
      this.task = null;
      freeTasks[freeTasks.length] = this;
    }
  };

  return RawTask;
}();

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = rawAsap;
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
function rawAsap(task) {
  if (!queue.length) {
    requestFlush();
    flushing = true;
  } // Equivalent to push, but avoids a function call.


  queue[queue.length] = task;
}
var queue = []; // Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
// @ts-ignore

var flushing = false; // `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.

var requestFlush; // The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.

var index = 0; // If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.

var capacity = 1024; // The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.

function flush() {
  while (index < queue.length) {
    var currentIndex = index; // Advance the index before calling the task. This ensures that we will
    // begin flushing on the next task the task throws an error.

    index = index + 1;
    queue[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
    // If we call `asap` within tasks scheduled by `asap`, the queue will
    // grow, but to avoid an O(n) walk for every task we execute, we don't
    // shift tasks off the queue after they have been executed.
    // Instead, we periodically shift 1024 tasks off the queue.

    if (index > capacity) {
      // Manually shift all values starting at the index back to the
      // beginning of the queue.
      for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
        queue[scan] = queue[scan + index];
      }

      queue.length -= index;
      index = 0;
    }
  }

  queue.length = 0;
  index = 0;
  flushing = false;
} // `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */


var scope = typeof global !== 'undefined' ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver; // MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7

if (typeof BrowserMutationObserver === 'function') {
  requestFlush = makeRequestCallFromMutationObserver(flush); // MessageChannels are desirable because they give direct access to the HTML
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
} else {
  requestFlush = makeRequestCallFromTimer(flush);
} // `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.


rawAsap.requestFlush = requestFlush; // To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".

function makeRequestCallFromMutationObserver(callback) {
  var toggle = 1;
  var observer = new BrowserMutationObserver(callback);
  var node = document.createTextNode('');
  observer.observe(node, {
    characterData: true
  });
  return function requestCall() {
    toggle = -toggle;
    node.data = toggle;
  };
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.


function makeRequestCallFromTimer(callback) {
  return function requestCall() {
    // We dispatch a timeout with a specified delay of 0 for engines that
    // can reliably accommodate that request. This will usually be snapped
    // to a 4 milisecond delay, but once we're flushing, there's no delay
    // between events.
    var timeoutHandle = setTimeout(handleTimer, 0); // However, since this timer gets frequently dropped in Firefox
    // workers, we enlist an interval handle that will try to fire
    // an event 20 times per second until it succeeds.

    var intervalHandle = setInterval(handleTimer, 50);

    function handleTimer() {
      // Whichever timer succeeds will cancel both timers and
      // execute the callback.
      clearTimeout(timeoutHandle);
      clearInterval(intervalHandle);
      callback();
    }
  };
} // This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.


rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DndProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DndContext__ = __webpack_require__(333);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var refCount = 0;
/**
 * A React component that provides the React-DnD context
 */

var DndProvider = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _getDndContextValue = getDndContextValue(props),
      _getDndContextValue2 = _slicedToArray(_getDndContextValue, 2),
      manager = _getDndContextValue2[0],
      isGlobalInstance = _getDndContextValue2[1]; // memoized from props

  /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */


  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (isGlobalInstance) {
      refCount++;
    }

    return function () {
      if (isGlobalInstance) {
        refCount--;

        if (refCount === 0) {
          var context = getGlobalContext();
          context[instanceSymbol] = null;
        }
      }
    };
  }, []);
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__DndContext__["a" /* DndContext */].Provider, {
    value: manager
  }, children);
});
DndProvider.displayName = 'DndProvider';

function getDndContextValue(props) {
  if ('manager' in props) {
    var _manager = {
      dragDropManager: props.manager
    };
    return [_manager, false];
  }

  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  var isGlobalInstance = !props.context;
  return [manager, isGlobalInstance];
}

var instanceSymbol = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');

function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var debugMode = arguments.length > 3 ? arguments[3] : undefined;
  var ctx = context;

  if (!ctx[instanceSymbol]) {
    ctx[instanceSymbol] = Object(__WEBPACK_IMPORTED_MODULE_1__DndContext__["b" /* createDndContext */])(backend, context, options, debugMode);
  }

  return ctx[instanceSymbol];
}

function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DragPreviewImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/*
 * A utility for rendering a drag preview image
 */

var DragPreviewImage = __WEBPACK_IMPORTED_MODULE_0_react__["memo"](function (_ref) {
  var connect = _ref.connect,
      src = _ref.src;

  if (typeof Image !== 'undefined') {
    var img = new Image();
    img.src = src;

    img.onload = function () {
      return connect(img);
    };
  }

  return null;
});
DragPreviewImage.displayName = 'DragPreviewImage';

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useDrag__ = __webpack_require__(1114);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useDrag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useDrop__ = __webpack_require__(1117);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__useDrop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useDragLayer__ = __webpack_require__(1119);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__useDragLayer__["a"]; });




/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDrag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_useMonitorOutput__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_useIsomorphicLayoutEffect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_drag__ = __webpack_require__(1115);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * useDragSource hook
 * @param sourceSpec The drag source specification *
 */

function useDrag(spec) {
  var specRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(spec);
  specRef.current = spec; // TODO: wire options into createSourceConnector

  Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__["a" /* invariant */])(spec.item != null, 'item must be defined');
  Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__["a" /* invariant */])(spec.item.type != null, 'item type must be defined');

  var _useDragSourceMonitor = Object(__WEBPACK_IMPORTED_MODULE_4__internal_drag__["b" /* useDragSourceMonitor */])(),
      _useDragSourceMonitor2 = _slicedToArray(_useDragSourceMonitor, 2),
      monitor = _useDragSourceMonitor2[0],
      connector = _useDragSourceMonitor2[1];

  Object(__WEBPACK_IMPORTED_MODULE_4__internal_drag__["a" /* useDragHandler */])(specRef, monitor, connector);
  var result = Object(__WEBPACK_IMPORTED_MODULE_2__internal_useMonitorOutput__["a" /* useMonitorOutput */])(monitor, specRef.current.collect || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
  var connectDragSource = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return connector.hooks.dragSource();
  }, [connector]);
  var connectDragPreview = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return connector.hooks.dragPreview();
  }, [connector]);
  Object(__WEBPACK_IMPORTED_MODULE_3__internal_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    connector.dragSourceOptions = specRef.current.options || null;
    connector.reconnect();
  }, [connector]);
  Object(__WEBPACK_IMPORTED_MODULE_3__internal_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    connector.dragPreviewOptions = specRef.current.previewOptions || null;
    connector.reconnect();
  }, [connector]);
  return [result, connectDragSource, connectDragPreview];
}

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useDragSourceMonitor;
/* harmony export (immutable) */ __webpack_exports__["a"] = useDragHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_registration__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useDragDropManager__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_DragSourceMonitorImpl__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SourceConnector__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useIsomorphicLayoutEffect__ = __webpack_require__(146);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }








function useDragSourceMonitor() {
  var manager = Object(__WEBPACK_IMPORTED_MODULE_3__useDragDropManager__["a" /* useDragDropManager */])();
  var monitor = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_4__common_DragSourceMonitorImpl__["a" /* DragSourceMonitorImpl */](manager);
  }, [manager]);
  var connector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_5__common_SourceConnector__["a" /* SourceConnector */](manager.getBackend());
  }, [manager]);
  return [monitor, connector];
}
function useDragHandler(spec, monitor, connector) {
  var manager = Object(__WEBPACK_IMPORTED_MODULE_3__useDragDropManager__["a" /* useDragDropManager */])();
  var handler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      beginDrag: function beginDrag() {
        var _spec$current = spec.current,
            begin = _spec$current.begin,
            item = _spec$current.item;

        if (begin) {
          var beginResult = begin(monitor);
          Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__["a" /* invariant */])(beginResult == null || _typeof(beginResult) === 'object', 'dragSpec.begin() must either return an object, undefined, or null');
          return beginResult || item || {};
        }

        return item || {};
      },
      canDrag: function canDrag() {
        if (typeof spec.current.canDrag === 'boolean') {
          return spec.current.canDrag;
        } else if (typeof spec.current.canDrag === 'function') {
          return spec.current.canDrag(monitor);
        } else {
          return true;
        }
      },
      isDragging: function isDragging(globalMonitor, target) {
        var isDragging = spec.current.isDragging;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
      },
      endDrag: function endDrag() {
        var end = spec.current.end;

        if (end) {
          end(monitor.getItem(), monitor);
        }

        connector.reconnect();
      }
    };
  }, []);
  Object(__WEBPACK_IMPORTED_MODULE_6__useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function registerHandler() {
    var _registerSource = Object(__WEBPACK_IMPORTED_MODULE_2__common_registration__["a" /* registerSource */])(spec.current.item.type, handler, manager),
        _registerSource2 = _slicedToArray(_registerSource, 2),
        handlerId = _registerSource2[0],
        unregister = _registerSource2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, []);
}

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneWithRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__ = __webpack_require__(37);



function setRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else {
    ref.current = node;
  }
}

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__["a" /* invariant */])(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(element, {
      ref: newRef
    });
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(element, {
      ref: function ref(node) {
        setRef(previousRef, node);
        setRef(newRef, node);
      }
    });
  }
}

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDrop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_useMonitorOutput__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_useIsomorphicLayoutEffect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_drop__ = __webpack_require__(1118);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






/**
 * useDropTarget Hook
 * @param spec The drop target specification
 */

function useDrop(spec) {
  var specRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(spec);
  specRef.current = spec;
  Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_invariant__["a" /* invariant */])(spec.accept != null, 'accept must be defined');

  var _useDropTargetMonitor = Object(__WEBPACK_IMPORTED_MODULE_4__internal_drop__["b" /* useDropTargetMonitor */])(),
      _useDropTargetMonitor2 = _slicedToArray(_useDropTargetMonitor, 2),
      monitor = _useDropTargetMonitor2[0],
      connector = _useDropTargetMonitor2[1];

  Object(__WEBPACK_IMPORTED_MODULE_4__internal_drop__["a" /* useDropHandler */])(specRef, monitor, connector);
  var result = Object(__WEBPACK_IMPORTED_MODULE_2__internal_useMonitorOutput__["a" /* useMonitorOutput */])(monitor, specRef.current.collect || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
  var connectDropTarget = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return connector.hooks.dropTarget();
  }, [connector]);
  Object(__WEBPACK_IMPORTED_MODULE_3__internal_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    connector.dropTargetOptions = spec.options || null;
    connector.reconnect();
  }, [spec.options]);
  return [result, connectDropTarget];
}

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useDropTargetMonitor;
/* harmony export (immutable) */ __webpack_exports__["a"] = useDropHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_registration__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useDragDropManager__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_TargetConnector__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_DropTargetMonitorImpl__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useIsomorphicLayoutEffect__ = __webpack_require__(146);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







function useDropTargetMonitor() {
  var manager = Object(__WEBPACK_IMPORTED_MODULE_2__useDragDropManager__["a" /* useDragDropManager */])();
  var monitor = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_4__common_DropTargetMonitorImpl__["a" /* DropTargetMonitorImpl */](manager);
  }, [manager]);
  var connector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_3__common_TargetConnector__["a" /* TargetConnector */](manager.getBackend());
  }, [manager]);
  return [monitor, connector];
}
function useDropHandler(spec, monitor, connector) {
  var manager = Object(__WEBPACK_IMPORTED_MODULE_2__useDragDropManager__["a" /* useDragDropManager */])();
  var handler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      canDrop: function canDrop() {
        var canDrop = spec.current.canDrop;
        return canDrop ? canDrop(monitor.getItem(), monitor) : true;
      },
      hover: function hover() {
        var hover = spec.current.hover;

        if (hover) {
          hover(monitor.getItem(), monitor);
        }
      },
      drop: function drop() {
        var drop = spec.current.drop;

        if (drop) {
          return drop(monitor.getItem(), monitor);
        }
      }
    };
  }, [monitor]);
  Object(__WEBPACK_IMPORTED_MODULE_5__useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function registerHandler() {
    var _registerTarget = Object(__WEBPACK_IMPORTED_MODULE_1__common_registration__["b" /* registerTarget */])(spec.current.accept, handler, manager),
        _registerTarget2 = _slicedToArray(_registerTarget, 2),
        handlerId = _registerTarget2[0],
        unregister = _registerTarget2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [monitor, connector]);
}

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDragLayer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_useDragDropManager__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_useCollector__ = __webpack_require__(520);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 * useDragLayer Hook
 * @param collector The property collector
 */

function useDragLayer(collect) {
  var dragDropManager = Object(__WEBPACK_IMPORTED_MODULE_1__internal_useDragDropManager__["a" /* useDragDropManager */])();
  var monitor = dragDropManager.getMonitor();

  var _useCollector = Object(__WEBPACK_IMPORTED_MODULE_2__internal_useCollector__["a" /* useCollector */])(monitor, collect),
      _useCollector2 = _slicedToArray(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    return monitor.subscribeToOffsetChange(updateCollected);
  });
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    return monitor.subscribeToStateChange(updateCollected);
  });
  return collected;
}

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DragSource__ = __webpack_require__(1121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropTarget__ = __webpack_require__(1124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DragLayer__ = __webpack_require__(1126);
/* unused harmony namespace reexport */




/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DragSource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js_utils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorateHandler__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_registration__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DragSourceMonitorImpl__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_SourceConnector__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_isValidType__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createSourceFactory__ = __webpack_require__(1123);









/**
 * Decorates a component as a dragsource
 * @param type The dragsource type
 * @param spec The drag source specification
 * @param collect The props collector function
 * @param options DnD options
 */

function DragSource(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* checkDecoratorArguments */])('DragSource', 'type, spec, collect[, options]', type, spec, collect, options);
  var getType = type;

  if (typeof type !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_isValidType__["a" /* isValidType */])(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', type);

    getType = function getType() {
      return type;
    };
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js_utils__["b" /* isPlainObject */])(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', spec);
  var createSource = Object(__WEBPACK_IMPORTED_MODULE_8__createSourceFactory__["a" /* default */])(spec);
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js_utils__["b" /* isPlainObject */])(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
  return function decorateSource(DecoratedComponent) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__decorateHandler__["a" /* default */])({
      containerDisplayName: 'DragSource',
      createHandler: createSource,
      registerHandler: __WEBPACK_IMPORTED_MODULE_4__common_registration__["a" /* registerSource */],
      createConnector: function createConnector(backend) {
        return new __WEBPACK_IMPORTED_MODULE_6__common_SourceConnector__["a" /* SourceConnector */](backend);
      },
      createMonitor: function createMonitor(manager) {
        return new __WEBPACK_IMPORTED_MODULE_5__common_DragSourceMonitorImpl__["a" /* DragSourceMonitorImpl */](manager);
      },
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Disposable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompositeDisposable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SerialDisposable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js_utils__ = __webpack_require__(123);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Provides a set of static methods for creating Disposables.
 * @param {Function} action Action to run during the first call to dispose.
 * The action is guaranteed to be run at most once.
 */

var Disposable =
/*#__PURE__*/
function () {
  function Disposable(action) {
    _classCallCheck(this, Disposable);

    this.isDisposed = false;
    this.action = Object(__WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["a" /* isFunction */])(action) ? action : __WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["c" /* noop */];
  }
  /**
   * Validates whether the given object is a disposable
   * @param {Object} Object to test whether it has a dispose method
   * @returns {Boolean} true if a disposable object, else false.
   */


  _createClass(Disposable, [{
    key: "dispose",

    /** Performs the task of cleaning up resources. */
    value: function dispose() {
      if (!this.isDisposed) {
        this.action();
        this.isDisposed = true;
      }
    }
  }], [{
    key: "isDisposable",
    value: function isDisposable(d) {
      return d && Object(__WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["a" /* isFunction */])(d.dispose);
    }
  }, {
    key: "_fixup",
    value: function _fixup(result) {
      return Disposable.isDisposable(result) ? result : Disposable.empty;
    }
    /**
     * Creates a disposable object that invokes the specified action when disposed.
     * @param {Function} dispose Action to run during the first call to dispose.
     * The action is guaranteed to be run at most once.
     * @return {Disposable} The disposable object that runs the given action upon disposal.
     */

  }, {
    key: "create",
    value: function create(action) {
      return new Disposable(action);
    }
  }]);

  return Disposable;
}();
/**
 * Gets the disposable that does nothing when disposed.
 */

Disposable.empty = {
  dispose: __WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["c" /* noop */]
};
/**
 * Represents a group of disposable resources that are disposed together.
 * @constructor
 */

var CompositeDisposable =
/*#__PURE__*/
function () {
  function CompositeDisposable() {
    _classCallCheck(this, CompositeDisposable);

    this.isDisposed = false;

    for (var _len = arguments.length, disposables = new Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    this.disposables = disposables;
  }
  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Any} item Disposable to add.
   */


  _createClass(CompositeDisposable, [{
    key: "add",
    value: function add(item) {
      if (this.isDisposed) {
        item.dispose();
      } else {
        this.disposables.push(item);
      }
    }
    /**
     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
     * @param {Any} item Disposable to remove.
     * @returns {Boolean} true if found; false otherwise.
     */

  }, {
    key: "remove",
    value: function remove(item) {
      var shouldDispose = false;

      if (!this.isDisposed) {
        var idx = this.disposables.indexOf(item);

        if (idx !== -1) {
          shouldDispose = true;
          this.disposables.splice(idx, 1);
          item.dispose();
        }
      }

      return shouldDispose;
    }
    /**
     *  Disposes all disposables in the group and removes them from the group but
     *  does not dispose the CompositeDisposable.
     */

  }, {
    key: "clear",
    value: function clear() {
      if (!this.isDisposed) {
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var i = 0; i < len; i++) {
          currentDisposables[i] = this.disposables[i];
        }

        this.disposables = [];

        for (var _i = 0; _i < len; _i++) {
          currentDisposables[_i].dispose();
        }
      }
    }
    /**
     *  Disposes all disposables in the group and removes them from the group.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var i = 0; i < len; i++) {
          currentDisposables[i] = this.disposables[i];
        }

        this.disposables = [];

        for (var _i2 = 0; _i2 < len; _i2++) {
          currentDisposables[_i2].dispose();
        }
      }
    }
  }]);

  return CompositeDisposable;
}();
/**
 * Represents a disposable resource whose underlying disposable resource can
 * be replaced by another disposable resource, causing automatic disposal of
 * the previous underlying disposable resource.
 */

var SerialDisposable =
/*#__PURE__*/
function () {
  function SerialDisposable() {
    _classCallCheck(this, SerialDisposable);

    this.isDisposed = false;
  }
  /**
   * Gets the underlying disposable.
   * @returns {Any} the underlying disposable.
   */


  _createClass(SerialDisposable, [{
    key: "getDisposable",
    value: function getDisposable() {
      return this.current;
    }
  }, {
    key: "setDisposable",
    value: function setDisposable(value) {
      var shouldDispose = this.isDisposed;

      if (!shouldDispose) {
        var old = this.current;
        this.current = value;

        if (old) {
          old.dispose();
        }
      }

      if (shouldDispose && value) {
        value.dispose();
      }
    }
    /** Performs the task of cleaning up resources. */

  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var old = this.current;
        this.current = undefined;

        if (old) {
          old.dispose();
        }
      }
    }
  }]);

  return SerialDisposable;
}();

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSourceFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js_utils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(147);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

var SourceImpl =
/*#__PURE__*/
function () {
  function SourceImpl(spec, monitor, ref) {
    var _this = this;

    _classCallCheck(this, SourceImpl);

    this.props = null;

    this.beginDrag = function () {
      if (!_this.props) {
        return;
      }

      var item = _this.spec.beginDrag(_this.props, _this.monitor, _this.ref.current);

      if (false) {
        invariant(isPlainObject(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', item);
      }

      return item;
    };

    this.spec = spec;
    this.monitor = monitor;
    this.ref = ref;
  }

  _createClass(SourceImpl, [{
    key: "receiveProps",
    value: function receiveProps(props) {
      this.props = props;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      if (!this.props) {
        return false;
      }

      if (!this.spec.canDrag) {
        return true;
      }

      return this.spec.canDrag(this.props, this.monitor);
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, sourceId) {
      if (!this.props) {
        return false;
      }

      if (!this.spec.isDragging) {
        return sourceId === globalMonitor.getSourceId();
      }

      return this.spec.isDragging(this.props, this.monitor);
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      if (!this.props) {
        return;
      }

      if (!this.spec.endDrag) {
        return;
      }

      this.spec.endDrag(this.props, this.monitor, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getDecoratedComponent */])(this.ref));
    }
  }]);

  return SourceImpl;
}();

function createSourceFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', ALLOWED_SPEC_METHODS.join(', '), key);
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
  });
  REQUIRED_SPEC_METHODS.forEach(function (key) {
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
  });
  return function createSource(monitor, ref) {
    return new SourceImpl(spec, monitor, ref);
  };
}

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DropTarget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js_utils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_registration__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isValidType__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_TargetConnector__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DropTargetMonitorImpl__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__decorateHandler__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createTargetFactory__ = __webpack_require__(1125);









function DropTarget(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* checkDecoratorArguments */])('DropTarget', 'type, spec, collect[, options]', type, spec, collect, options);
  var getType = type;

  if (typeof type !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_isValidType__["a" /* isValidType */])(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', type);

    getType = function getType() {
      return type;
    };
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js_utils__["b" /* isPlainObject */])(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', spec);
  var createTarget = Object(__WEBPACK_IMPORTED_MODULE_8__createTargetFactory__["a" /* default */])(spec);
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
  Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js_utils__["b" /* isPlainObject */])(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
  return function decorateTarget(DecoratedComponent) {
    return Object(__WEBPACK_IMPORTED_MODULE_7__decorateHandler__["a" /* default */])({
      containerDisplayName: 'DropTarget',
      createHandler: createTarget,
      registerHandler: __WEBPACK_IMPORTED_MODULE_2__common_registration__["b" /* registerTarget */],
      createMonitor: function createMonitor(manager) {
        return new __WEBPACK_IMPORTED_MODULE_5__common_DropTargetMonitorImpl__["a" /* DropTargetMonitorImpl */](manager);
      },
      createConnector: function createConnector(backend) {
        return new __WEBPACK_IMPORTED_MODULE_4__common_TargetConnector__["a" /* TargetConnector */](backend);
      },
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTargetFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js_utils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(147);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

var TargetImpl =
/*#__PURE__*/
function () {
  function TargetImpl(spec, monitor, ref) {
    _classCallCheck(this, TargetImpl);

    this.props = null;
    this.spec = spec;
    this.monitor = monitor;
    this.ref = ref;
  }

  _createClass(TargetImpl, [{
    key: "receiveProps",
    value: function receiveProps(props) {
      this.props = props;
    }
  }, {
    key: "receiveMonitor",
    value: function receiveMonitor(monitor) {
      this.monitor = monitor;
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      if (!this.spec.canDrop) {
        return true;
      }

      return this.spec.canDrop(this.props, this.monitor);
    }
  }, {
    key: "hover",
    value: function hover() {
      if (!this.spec.hover) {
        return;
      }

      this.spec.hover(this.props, this.monitor, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getDecoratedComponent */])(this.ref));
    }
  }, {
    key: "drop",
    value: function drop() {
      if (!this.spec.drop) {
        return undefined;
      }

      var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);

      if (false) {
        invariant(typeof dropResult === 'undefined' || isPlainObject(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', dropResult);
      }

      return dropResult;
    }
  }]);

  return TargetImpl;
}();

function createTargetFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', ALLOWED_SPEC_METHODS.join(', '), key);
    Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', key, key, spec[key]);
  });
  return function createTarget(monitor, ref) {
    return new TargetImpl(spec, monitor, ref);
  };
}

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DragLayer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js_utils__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(147);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








function DragLayer(collect) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* checkDecoratorArguments */])('DragLayer', 'collect[, options]', collect, options);
  Object(__WEBPACK_IMPORTED_MODULE_3__react_dnd_invariant__["a" /* invariant */])(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', collect);
  Object(__WEBPACK_IMPORTED_MODULE_3__react_dnd_invariant__["a" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_5__utils_js_utils__["b" /* isPlainObject */])(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', options);
  return function decorateLayer(DecoratedComponent) {
    var Decorated = DecoratedComponent;
    var _options$arePropsEqua = options.arePropsEqual,
        arePropsEqual = _options$arePropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__["a" /* shallowEqual */] : _options$arePropsEqua;
    var displayName = Decorated.displayName || Decorated.name || 'Component';

    var DragLayerContainer =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(DragLayerContainer, _React$Component);

      function DragLayerContainer() {
        var _this;

        _classCallCheck(this, DragLayerContainer);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(DragLayerContainer).apply(this, arguments));
        _this.isCurrentlyMounted = false;
        _this.ref = __WEBPACK_IMPORTED_MODULE_0_react__["createRef"]();

        _this.handleChange = function () {
          if (!_this.isCurrentlyMounted) {
            return;
          }

          var nextState = _this.getCurrentState();

          if (!Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__["a" /* shallowEqual */])(nextState, _this.state)) {
            _this.setState(nextState);
          }
        };

        return _this;
      }

      _createClass(DragLayerContainer, [{
        key: "getDecoratedComponentInstance",
        value: function getDecoratedComponentInstance() {
          Object(__WEBPACK_IMPORTED_MODULE_3__react_dnd_invariant__["a" /* invariant */])(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
          return this.ref.current;
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !arePropsEqual(nextProps, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_1__react_dnd_shallowequal__["a" /* shallowEqual */])(nextState, this.state);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.isCurrentlyMounted = true;
          this.handleChange();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isCurrentlyMounted = false;

          if (this.unsubscribeFromOffsetChange) {
            this.unsubscribeFromOffsetChange();
            this.unsubscribeFromOffsetChange = undefined;
          }

          if (this.unsubscribeFromStateChange) {
            this.unsubscribeFromStateChange();
            this.unsubscribeFromStateChange = undefined;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__index__["a" /* DndContext */].Consumer, null, function (_ref) {
            var dragDropManager = _ref.dragDropManager;

            if (dragDropManager === undefined) {
              return null;
            }

            _this2.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state


            if (!_this2.isCurrentlyMounted) {
              return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Decorated, Object.assign({}, _this2.props, _this2.state, {
              ref: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isRefable */])(Decorated) ? _this2.ref : null
            }));
          });
        }
      }, {
        key: "receiveDragDropManager",
        value: function receiveDragDropManager(dragDropManager) {
          if (this.manager !== undefined) {
            return;
          }

          this.manager = dragDropManager;
          Object(__WEBPACK_IMPORTED_MODULE_3__react_dnd_invariant__["a" /* invariant */])(_typeof(dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to render a DndProvider component in your top-level component. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
          var monitor = this.manager.getMonitor();
          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
        }
      }, {
        key: "getCurrentState",
        value: function getCurrentState() {
          if (!this.manager) {
            return {};
          }

          var monitor = this.manager.getMonitor();
          return collect(monitor, this.props);
        }
      }]);

      return DragLayerContainer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    DragLayerContainer.displayName = "DragLayer(".concat(displayName, ")");
    DragLayerContainer.DecoratedComponent = DecoratedComponent;
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(DragLayerContainer, DecoratedComponent);
  };
}

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTML5Backend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnterLeaveCounter__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowserDetector__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OffsetUtils__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeDragSources__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeTypes__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionsReader__ = __webpack_require__(1135);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }








var HTML5Backend =
/*#__PURE__*/
function () {
  function HTML5Backend(manager, globalContext) {
    var _this = this;

    _classCallCheck(this, HTML5Backend);

    this.sourcePreviewNodes = new Map();
    this.sourcePreviewNodeOptions = new Map();
    this.sourceNodes = new Map();
    this.sourceNodeOptions = new Map();
    this.dragStartSourceIds = null;
    this.dropTargetIds = [];
    this.dragEnterTargetIds = [];
    this.currentNativeSource = null;
    this.currentNativeHandle = null;
    this.currentDragSourceNode = null;
    this.altKeyPressed = false;
    this.mouseMoveTimeoutTimer = null;
    this.asyncEndDragFrameId = null;
    this.dragOverTargetIds = null;

    this.getSourceClientOffset = function (sourceId) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__OffsetUtils__["c" /* getNodeClientOffset */])(_this.sourceNodes.get(sourceId));
    };

    this.endDragNativeItem = function () {
      if (!_this.isDraggingNativeItem()) {
        return;
      }

      _this.actions.endDrag();

      _this.registry.removeSource(_this.currentNativeHandle);

      _this.currentNativeHandle = null;
      _this.currentNativeSource = null;
    };

    this.isNodeInDocument = function (node) {
      // Check the node either in the main document or in the current context
      return _this.document && _this.document.body && document.body.contains(node);
    };

    this.endDragIfSourceWasRemovedFromDOM = function () {
      var node = _this.currentDragSourceNode;

      if (_this.isNodeInDocument(node)) {
        return;
      }

      if (_this.clearCurrentDragSourceNode()) {
        _this.actions.endDrag();
      }
    };

    this.handleTopDragStartCapture = function () {
      _this.clearCurrentDragSourceNode();

      _this.dragStartSourceIds = [];
    };

    this.handleTopDragStart = function (e) {
      if (e.defaultPrevented) {
        return;
      }

      var dragStartSourceIds = _this.dragStartSourceIds;
      _this.dragStartSourceIds = null;
      var clientOffset = Object(__WEBPACK_IMPORTED_MODULE_2__OffsetUtils__["b" /* getEventClientOffset */])(e); // Avoid crashing if we missed a drop event or our previous drag died

      if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      } // Don't publish the source just yet (see why below)


      _this.actions.beginDrag(dragStartSourceIds || [], {
        publishSource: false,
        getSourceClientOffset: _this.getSourceClientOffset,
        clientOffset: clientOffset
      });

      var dataTransfer = e.dataTransfer;
      var nativeType = Object(__WEBPACK_IMPORTED_MODULE_3__NativeDragSources__["b" /* matchNativeItemType */])(dataTransfer);

      if (_this.monitor.isDragging()) {
        if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
          // Use custom drag image if user specifies it.
          // If child drag source refuses drag but parent agrees,
          // use parent's node as drag image. Neither works in IE though.
          var sourceId = _this.monitor.getSourceId();

          var sourceNode = _this.sourceNodes.get(sourceId);

          var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;

          if (dragPreview) {
            var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(),
                anchorX = _this$getCurrentSourc.anchorX,
                anchorY = _this$getCurrentSourc.anchorY,
                offsetX = _this$getCurrentSourc.offsetX,
                offsetY = _this$getCurrentSourc.offsetY;

            var anchorPoint = {
              anchorX: anchorX,
              anchorY: anchorY
            };
            var offsetPoint = {
              offsetX: offsetX,
              offsetY: offsetY
            };
            var dragPreviewOffset = Object(__WEBPACK_IMPORTED_MODULE_2__OffsetUtils__["a" /* getDragPreviewOffset */])(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }
        }

        try {
          // Firefox won't drag without setting data
          dataTransfer.setData('application/json', {});
        } catch (err) {} // IE doesn't support MIME types in setData
        // Store drag source node so we can check whether
        // it is removed from DOM and trigger endDrag manually.


        _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?


        var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(),
            captureDraggingState = _this$getCurrentSourc2.captureDraggingState;

        if (!captureDraggingState) {
          // Usually we want to publish it in the next tick so that browser
          // is able to screenshot the current (not yet dragging) state.
          //
          // It also neatly avoids a situation where render() returns null
          // in the same tick for the source element, and browser freaks out.
          setTimeout(function () {
            return _this.actions.publishDragSource();
          }, 0);
        } else {
          // In some cases the user may want to override this behavior, e.g.
          // to work around IE not supporting custom drag previews.
          //
          // When using a custom drag layer, the only way to prevent
          // the default drag preview from drawing in IE is to screenshot
          // the dragging state in which the node itself has zero opacity
          // and height. In this case, though, returning null from render()
          // will abruptly end the dragging, which is not obvious.
          //
          // This is the reason such behavior is strictly opt-in.
          _this.actions.publishDragSource();
        }
      } else if (nativeType) {
        // A native item (such as URL) dragged from inside the document
        _this.beginDragNativeItem(nativeType);
      } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
        // Just let it drag. It's a native type (URL or text) and will be picked up in
        // dragenter handler.
        return;
      } else {
        // If by this time no drag source reacted, tell browser not to drag.
        e.preventDefault();
      }
    };

    this.handleTopDragEndCapture = function () {
      if (_this.clearCurrentDragSourceNode()) {
        // Firefox can dispatch this event in an infinite loop
        // if dragend handler does something like showing an alert.
        // Only proceed if we have not handled it already.
        _this.actions.endDrag();
      }
    };

    this.handleTopDragEnterCapture = function (e) {
      _this.dragEnterTargetIds = [];

      var isFirstEnter = _this.enterLeaveCounter.enter(e.target);

      if (!isFirstEnter || _this.monitor.isDragging()) {
        return;
      }

      var dataTransfer = e.dataTransfer;
      var nativeType = Object(__WEBPACK_IMPORTED_MODULE_3__NativeDragSources__["b" /* matchNativeItemType */])(dataTransfer);

      if (nativeType) {
        // A native item (such as file or URL) dragged from outside the document
        _this.beginDragNativeItem(nativeType, dataTransfer);
      }
    };

    this.handleTopDragEnter = function (e) {
      var dragEnterTargetIds = _this.dragEnterTargetIds;
      _this.dragEnterTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        return;
      }

      _this.altKeyPressed = e.altKey;

      if (!Object(__WEBPACK_IMPORTED_MODULE_1__BrowserDetector__["a" /* isFirefox */])()) {
        // Don't emit hover in `dragenter` on Firefox due to an edge case.
        // If the target changes position as the result of `dragenter`, Firefox
        // will still happily dispatch `dragover` despite target being no longer
        // there. The easy solution is to only fire `hover` in `dragover` on FF.
        _this.actions.hover(dragEnterTargetIds, {
          clientOffset: Object(__WEBPACK_IMPORTED_MODULE_2__OffsetUtils__["b" /* getEventClientOffset */])(e)
        });
      }

      var canDrop = dragEnterTargetIds.some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // IE requires this to fire dragover events
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      }
    };

    this.handleTopDragOverCapture = function () {
      _this.dragOverTargetIds = [];
    };

    this.handleTopDragOver = function (e) {
      var dragOverTargetIds = _this.dragOverTargetIds;
      _this.dragOverTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        // Prevent default "drop and blow away the whole document" action.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }

        return;
      }

      _this.altKeyPressed = e.altKey;

      _this.actions.hover(dragOverTargetIds || [], {
        clientOffset: Object(__WEBPACK_IMPORTED_MODULE_2__OffsetUtils__["b" /* getEventClientOffset */])(e)
      });

      var canDrop = (dragOverTargetIds || []).some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // Show user-specified drop effect.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      } else if (_this.isDraggingNativeItem()) {
        // Don't show a nice cursor but still prevent default
        // "drop and blow away the whole document" action.
        e.preventDefault();
      } else {
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }
      }
    };

    this.handleTopDragLeaveCapture = function (e) {
      if (_this.isDraggingNativeItem()) {
        e.preventDefault();
      }

      var isLastLeave = _this.enterLeaveCounter.leave(e.target);

      if (!isLastLeave) {
        return;
      }

      if (_this.isDraggingNativeItem()) {
        _this.endDragNativeItem();
      }
    };

    this.handleTopDropCapture = function (e) {
      _this.dropTargetIds = [];
      e.preventDefault();

      if (_this.isDraggingNativeItem()) {
        _this.currentNativeSource.loadDataTransfer(e.dataTransfer);
      }

      _this.enterLeaveCounter.reset();
    };

    this.handleTopDrop = function (e) {
      var dropTargetIds = _this.dropTargetIds;
      _this.dropTargetIds = [];

      _this.actions.hover(dropTargetIds, {
        clientOffset: Object(__WEBPACK_IMPORTED_MODULE_2__OffsetUtils__["b" /* getEventClientOffset */])(e)
      });

      _this.actions.drop({
        dropEffect: _this.getCurrentDropEffect()
      });

      if (_this.isDraggingNativeItem()) {
        _this.endDragNativeItem();
      } else {
        _this.endDragIfSourceWasRemovedFromDOM();
      }
    };

    this.handleSelectStart = function (e) {
      var target = e.target; // Only IE requires us to explicitly say
      // we want drag drop operation to start

      if (typeof target.dragDrop !== 'function') {
        return;
      } // Inputs and textareas should be selectable


      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      } // For other targets, ask IE
      // to enable drag and drop


      e.preventDefault();
      target.dragDrop();
    };

    this.options = new __WEBPACK_IMPORTED_MODULE_5__OptionsReader__["a" /* OptionsReader */](globalContext);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.enterLeaveCounter = new __WEBPACK_IMPORTED_MODULE_0__EnterLeaveCounter__["a" /* default */](this.isNodeInDocument);
  } // public for test


  _createClass(HTML5Backend, [{
    key: "setup",
    value: function setup() {
      if (this.window === undefined) {
        return;
      }

      if (this.window.__isReactDndBackendSetUp) {
        throw new Error('Cannot have two HTML5 backends at the same time.');
      }

      this.window.__isReactDndBackendSetUp = true;
      this.addEventListeners(this.window);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      if (this.window === undefined) {
        return;
      }

      this.window.__isReactDndBackendSetUp = false;
      this.removeEventListeners(this.window);
      this.clearCurrentDragSourceNode();

      if (this.asyncEndDragFrameId) {
        this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this2 = this;

      this.sourcePreviewNodeOptions.set(sourceId, options);
      this.sourcePreviewNodes.set(sourceId, node);
      return function () {
        _this2.sourcePreviewNodes.delete(sourceId);

        _this2.sourcePreviewNodeOptions.delete(sourceId);
      };
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node, options) {
      var _this3 = this;

      this.sourceNodes.set(sourceId, node);
      this.sourceNodeOptions.set(sourceId, options);

      var handleDragStart = function handleDragStart(e) {
        return _this3.handleDragStart(e, sourceId);
      };

      var handleSelectStart = function handleSelectStart(e) {
        return _this3.handleSelectStart(e);
      };

      node.setAttribute('draggable', 'true');
      node.addEventListener('dragstart', handleDragStart);
      node.addEventListener('selectstart', handleSelectStart);
      return function () {
        _this3.sourceNodes.delete(sourceId);

        _this3.sourceNodeOptions.delete(sourceId);

        node.removeEventListener('dragstart', handleDragStart);
        node.removeEventListener('selectstart', handleSelectStart);
        node.setAttribute('draggable', 'false');
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this4 = this;

      var handleDragEnter = function handleDragEnter(e) {
        return _this4.handleDragEnter(e, targetId);
      };

      var handleDragOver = function handleDragOver(e) {
        return _this4.handleDragOver(e, targetId);
      };

      var handleDrop = function handleDrop(e) {
        return _this4.handleDrop(e, targetId);
      };

      node.addEventListener('dragenter', handleDragEnter);
      node.addEventListener('dragover', handleDragOver);
      node.addEventListener('drop', handleDrop);
      return function () {
        node.removeEventListener('dragenter', handleDragEnter);
        node.removeEventListener('dragover', handleDragOver);
        node.removeEventListener('drop', handleDrop);
      };
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.addEventListener) {
        return;
      }

      target.addEventListener('dragstart', this.handleTopDragStart);
      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
      target.addEventListener('dragenter', this.handleTopDragEnter);
      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.addEventListener('dragover', this.handleTopDragOver);
      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
      target.addEventListener('drop', this.handleTopDrop);
      target.addEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.removeEventListener) {
        return;
      }

      target.removeEventListener('dragstart', this.handleTopDragStart);
      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
      target.removeEventListener('dragenter', this.handleTopDragEnter);
      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.removeEventListener('dragover', this.handleTopDragOver);
      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
      target.removeEventListener('drop', this.handleTopDrop);
      target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "getCurrentSourceNodeOptions",
    value: function getCurrentSourceNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
      return _objectSpread({
        dropEffect: this.altKeyPressed ? 'copy' : 'move'
      }, sourceNodeOptions || {});
    }
  }, {
    key: "getCurrentDropEffect",
    value: function getCurrentDropEffect() {
      if (this.isDraggingNativeItem()) {
        // It makes more sense to default to 'copy' for native resources
        return 'copy';
      }

      return this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: "getCurrentSourcePreviewNodeOptions",
    value: function getCurrentSourcePreviewNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
      return _objectSpread({
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      }, sourcePreviewNodeOptions || {});
    }
  }, {
    key: "isDraggingNativeItem",
    value: function isDraggingNativeItem() {
      var itemType = this.monitor.getItemType();
      return Object.keys(__WEBPACK_IMPORTED_MODULE_4__NativeTypes__).some(function (key) {
        return __WEBPACK_IMPORTED_MODULE_4__NativeTypes__[key] === itemType;
      });
    }
  }, {
    key: "beginDragNativeItem",
    value: function beginDragNativeItem(type, dataTransfer) {
      this.clearCurrentDragSourceNode();
      this.currentNativeSource = Object(__WEBPACK_IMPORTED_MODULE_3__NativeDragSources__["a" /* createNativeDragSource */])(type, dataTransfer);
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);
    }
  }, {
    key: "setCurrentDragSourceNode",
    value: function setCurrentDragSourceNode(node) {
      var _this5 = this;

      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869

      var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
      // means it has ended and the drag source node disappeared from DOM,
      // so the browser didn't dispatch the dragend event.
      //
      // We need to wait before we start listening for mousemove events.
      // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
      // immediately in some browsers.
      //
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869
      //

      this.mouseMoveTimeoutTimer = setTimeout(function () {
        return _this5.window && _this5.window.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
      }, MOUSE_MOVE_TIMEOUT);
    }
  }, {
    key: "clearCurrentDragSourceNode",
    value: function clearCurrentDragSourceNode() {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;

        if (this.window) {
          this.window.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
          this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }

        this.mouseMoveTimeoutTimer = null;
        return true;
      }

      return false;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e, sourceId) {
      if (e.defaultPrevented) {
        return;
      }

      if (!this.dragStartSourceIds) {
        this.dragStartSourceIds = [];
      }

      this.dragStartSourceIds.unshift(sourceId);
    }
  }, {
    key: "handleDragEnter",
    value: function handleDragEnter(e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e, targetId) {
      if (this.dragOverTargetIds === null) {
        this.dragOverTargetIds = [];
      }

      this.dragOverTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e, targetId) {
      this.dropTargetIds.unshift(targetId);
    }
  }, {
    key: "window",
    get: function get() {
      return this.options.window;
    }
  }, {
    key: "document",
    get: function get() {
      return this.options.document;
    }
  }]);

  return HTML5Backend;
}();



/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnterLeaveCounter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js_utils__ = __webpack_require__(531);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var EnterLeaveCounter =
/*#__PURE__*/
function () {
  function EnterLeaveCounter(isNodeInDocument) {
    _classCallCheck(this, EnterLeaveCounter);

    this.entered = [];
    this.isNodeInDocument = isNodeInDocument;
  }

  _createClass(EnterLeaveCounter, [{
    key: "enter",
    value: function enter(enteringNode) {
      var _this = this;

      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = Object(__WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["b" /* union */])(this.entered.filter(isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;
      this.entered = Object(__WEBPACK_IMPORTED_MODULE_0__utils_js_utils__["c" /* without */])(this.entered.filter(this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.entered = [];
    }
  }]);

  return EnterLeaveCounter;
}();



/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getNodeClientOffset;
/* harmony export (immutable) */ __webpack_exports__["b"] = getEventClientOffset;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDragPreviewOffset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserDetector__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MonotonicInterpolant__ = __webpack_require__(1130);


var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    x: left,
    y: top
  };
}
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

function isImageNode(node) {
  return node.nodeName === 'IMG' && (Object(__WEBPACK_IMPORTED_MODULE_0__BrowserDetector__["a" /* isFirefox */])() || !document.documentElement.contains(node));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers

  if (Object(__WEBPACK_IMPORTED_MODULE_0__BrowserDetector__["b" /* isSafari */])() && isImage) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }

  return {
    dragPreviewWidth: dragPreviewWidth,
    dragPreviewHeight: dragPreviewHeight
  };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
  // The browsers will use the image intrinsic size under different conditions.
  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
  var isImage = isImageNode(dragPreview);
  var dragPreviewNode = isImage ? sourceNode : dragPreview;
  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  var offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };
  var sourceWidth = sourceNode.offsetWidth,
      sourceHeight = sourceNode.offsetHeight;
  var anchorX = anchorPoint.anchorX,
      anchorY = anchorPoint.anchorY;

  var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
      dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
      dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

  var calculateYOffset = function calculateYOffset() {
    var interpolantY = new __WEBPACK_IMPORTED_MODULE_1__MonotonicInterpolant__["a" /* default */]([0, 0.5, 1], [// Dock to the top
    offsetFromDragPreview.y, // Align at the center
    offsetFromDragPreview.y / sourceHeight * dragPreviewHeight, // Dock to the bottom
    offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
    var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug

    if (Object(__WEBPACK_IMPORTED_MODULE_0__BrowserDetector__["b" /* isSafari */])() && isImage) {
      // We'll have to wait for @3x to see if this is entirely correct
      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
    }

    return y;
  };

  var calculateXOffset = function calculateXOffset() {
    // Interpolate coordinates depending on anchor point
    // If you know a simpler way to do this, let me know
    var interpolantX = new __WEBPACK_IMPORTED_MODULE_1__MonotonicInterpolant__["a" /* default */]([0, 0.5, 1], [// Dock to the left
    offsetFromDragPreview.x, // Align at the center
    offsetFromDragPreview.x / sourceWidth * dragPreviewWidth, // Dock to the right
    offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
    return interpolantX.interpolate(anchorX);
  }; // Force offsets if specified in the options.


  var offsetX = offsetPoint.offsetX,
      offsetY = offsetPoint.offsetY;
  var isManualOffsetX = offsetX === 0 || offsetX;
  var isManualOffsetY = offsetY === 0 || offsetY;
  return {
    x: isManualOffsetX ? offsetX : calculateXOffset(),
    y: isManualOffsetY ? offsetY : calculateYOffset()
  };
}

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonotonicInterpolant; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MonotonicInterpolant =
/*#__PURE__*/
function () {
  function MonotonicInterpolant(xs, ys) {
    _classCallCheck(this, MonotonicInterpolant);

    var length = xs.length; // Rearrange xs and ys so that xs is sorted

    var indexes = [];

    for (var i = 0; i < length; i++) {
      indexes.push(i);
    }

    indexes.sort(function (a, b) {
      return xs[a] < xs[b] ? -1 : 1;
    }); // Get consecutive differences and slopes

    var dys = [];
    var dxs = [];
    var ms = [];
    var dx;
    var dy;

    for (var _i = 0; _i < length - 1; _i++) {
      dx = xs[_i + 1] - xs[_i];
      dy = ys[_i + 1] - ys[_i];
      dxs.push(dx);
      dys.push(dy);
      ms.push(dy / dx);
    } // Get degree-1 coefficients


    var c1s = [ms[0]];

    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
      var m2 = ms[_i2];
      var mNext = ms[_i2 + 1];

      if (m2 * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[_i2];
        var dxNext = dxs[_i2 + 1];
        var common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
      }
    }

    c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients

    var c2s = [];
    var c3s = [];
    var m;

    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
      m = ms[_i3];
      var c1 = c1s[_i3];
      var invDx = 1 / dxs[_i3];

      var _common = c1 + c1s[_i3 + 1] - m - m;

      c2s.push((m - c1 - _common) * invDx);
      c3s.push(_common * invDx * invDx);
    }

    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }

  _createClass(MonotonicInterpolant, [{
    key: "interpolate",
    value: function interpolate(x) {
      var xs = this.xs,
          ys = this.ys,
          c1s = this.c1s,
          c2s = this.c2s,
          c3s = this.c3s; // The rightmost point in the dataset should give an exact result

      var i = xs.length - 1;

      if (x === xs[i]) {
        return ys[i];
      } // Search for the interval x is in, returning the corresponding y if x is one of the original xs


      var low = 0;
      var high = c3s.length - 1;
      var mid;

      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];

        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }

      i = Math.max(0, high); // Interpolate

      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
  }]);

  return MonotonicInterpolant;
}();



/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createNativeDragSource;
/* harmony export (immutable) */ __webpack_exports__["b"] = matchNativeItemType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeTypesConfig__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NativeDragSource__ = __webpack_require__(1134);


function createNativeDragSource(type, dataTransfer) {
  var result = new __WEBPACK_IMPORTED_MODULE_1__NativeDragSource__["a" /* NativeDragSource */](__WEBPACK_IMPORTED_MODULE_0__nativeTypesConfig__["a" /* nativeTypesConfig */][type]);
  result.loadDataTransfer(dataTransfer);
  return result;
}
function matchNativeItemType(dataTransfer) {
  if (!dataTransfer) {
    return null;
  }

  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
  return Object.keys(__WEBPACK_IMPORTED_MODULE_0__nativeTypesConfig__["a" /* nativeTypesConfig */]).filter(function (nativeItemType) {
    var matchesTypes = __WEBPACK_IMPORTED_MODULE_0__nativeTypesConfig__["a" /* nativeTypesConfig */][nativeItemType].matchesTypes;
    return matchesTypes.some(function (t) {
      return dataTransferTypes.indexOf(t) > -1;
    });
  })[0] || null;
}

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nativeTypesConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeTypes__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDataFromDataTransfer__ = __webpack_require__(1133);
var _nativeTypesConfig;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, __WEBPACK_IMPORTED_MODULE_0__NativeTypes__["FILE"], {
  exposeProperties: {
    files: function files(dataTransfer) {
      return Array.prototype.slice.call(dataTransfer.files);
    },
    items: function items(dataTransfer) {
      return dataTransfer.items;
    }
  },
  matchesTypes: ['Files']
}), _defineProperty(_nativeTypesConfig, __WEBPACK_IMPORTED_MODULE_0__NativeTypes__["URL"], {
  exposeProperties: {
    urls: function urls(dataTransfer, matchesTypes) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__getDataFromDataTransfer__["a" /* getDataFromDataTransfer */])(dataTransfer, matchesTypes, '').split('\n');
    }
  },
  matchesTypes: ['Url', 'text/uri-list']
}), _defineProperty(_nativeTypesConfig, __WEBPACK_IMPORTED_MODULE_0__NativeTypes__["TEXT"], {
  exposeProperties: {
    text: function text(dataTransfer, matchesTypes) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__getDataFromDataTransfer__["a" /* getDataFromDataTransfer */])(dataTransfer, matchesTypes, '');
    }
  },
  matchesTypes: ['Text', 'text/plain']
}), _nativeTypesConfig);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDataFromDataTransfer;
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, '');
  return result != null ? result : defaultValue;
}

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NativeDragSource; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NativeDragSource =
/*#__PURE__*/
function () {
  function NativeDragSource(config) {
    _classCallCheck(this, NativeDragSource);

    this.config = config;
    this.item = {};
    this.initializeExposedProperties();
  }

  _createClass(NativeDragSource, [{
    key: "initializeExposedProperties",
    value: function initializeExposedProperties() {
      var _this = this;

      Object.keys(this.config.exposeProperties).forEach(function (property) {
        Object.defineProperty(_this.item, property, {
          configurable: true,
          enumerable: true,
          get: function get() {
            // eslint-disable-next-line no-console
            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
            return null;
          }
        });
      });
    }
  }, {
    key: "loadDataTransfer",
    value: function loadDataTransfer(dataTransfer) {
      var _this2 = this;

      if (dataTransfer) {
        var newProperties = {};
        Object.keys(this.config.exposeProperties).forEach(function (property) {
          newProperties[property] = {
            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
            configurable: true,
            enumerable: true
          };
        });
        Object.defineProperties(this.item, newProperties);
      }
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      return true;
    }
  }, {
    key: "beginDrag",
    value: function beginDrag() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function isDragging(monitor, handle) {
      return handle === monitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {// empty
    }
  }]);

  return NativeDragSource;
}();

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionsReader; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OptionsReader =
/*#__PURE__*/
function () {
  function OptionsReader(globalContext) {
    _classCallCheck(this, OptionsReader);

    this.globalContext = globalContext;
  }

  _createClass(OptionsReader, [{
    key: "window",
    get: function get() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== 'undefined') {
        return window;
      }

      return undefined;
    }
  }, {
    key: "document",
    get: function get() {
      if (this.window) {
        return this.window.document;
      }

      return undefined;
    }
  }]);

  return OptionsReader;
}();

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getEmptyImage;
var emptyImage;
function getEmptyImage() {
  if (!emptyImage) {
    emptyImage = new Image();
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  return emptyImage;
}

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TouchBackend__ = __webpack_require__(1138);


var createBackend = function createBackend(manager, context) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new __WEBPACK_IMPORTED_MODULE_0__TouchBackend__["a" /* default */](manager, context, options);
};

/* harmony default export */ __webpack_exports__["a"] = (createBackend);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interfaces__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_predicates__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_offsets__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_supportsPassive__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OptionsReader__ = __webpack_require__(1143);
var _eventNames;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var eventNames = (_eventNames = {}, _defineProperty(_eventNames, __WEBPACK_IMPORTED_MODULE_1__interfaces__["a" /* ListenerType */].mouse, {
  start: 'mousedown',
  move: 'mousemove',
  end: 'mouseup',
  contextmenu: 'contextmenu'
}), _defineProperty(_eventNames, __WEBPACK_IMPORTED_MODULE_1__interfaces__["a" /* ListenerType */].touch, {
  start: 'touchstart',
  move: 'touchmove',
  end: 'touchend'
}), _defineProperty(_eventNames, __WEBPACK_IMPORTED_MODULE_1__interfaces__["a" /* ListenerType */].keyboard, {
  keydown: 'keydown'
}), _eventNames);

var TouchBackend =
/*#__PURE__*/
function () {
  function TouchBackend(manager, context, options) {
    var _this = this;

    _classCallCheck(this, TouchBackend);

    this.getSourceClientOffset = function (sourceId) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_offsets__["b" /* getNodeClientOffset */])(_this.sourceNodes[sourceId]);
    };

    this.handleTopMoveStartCapture = function (e) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_predicates__["b" /* eventShouldStartDrag */])(e)) {
        return;
      }

      _this.moveStartSourceIds = [];
    };

    this.handleMoveStart = function (sourceId) {
      // Just because we received an event doesn't necessarily mean we need to collect drag sources.
      // We only collect start collecting drag sources on touch and left mouse events.
      if (Array.isArray(_this.moveStartSourceIds)) {
        _this.moveStartSourceIds.unshift(sourceId);
      }
    };

    this.handleTopMoveStart = function (e) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_predicates__["b" /* eventShouldStartDrag */])(e)) {
        return;
      } // Don't prematurely preventDefault() here since it might:
      // 1. Mess up scrolling
      // 2. Mess up long tap (which brings up context menu)
      // 3. If there's an anchor link as a child, tap won't be triggered on link


      var clientOffset = Object(__WEBPACK_IMPORTED_MODULE_3__utils_offsets__["a" /* getEventClientOffset */])(e);

      if (clientOffset) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_predicates__["c" /* isTouchEvent */])(e)) {
          _this.lastTargetTouchFallback = e.targetTouches[0];
        }

        _this._mouseClientOffset = clientOffset;
      }

      _this.waitingForDelay = false;
    };

    this.handleTopMoveStartDelay = function (e) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_predicates__["b" /* eventShouldStartDrag */])(e)) {
        return;
      }

      var delay = e.type === eventNames.touch.start ? _this.options.delayTouchStart : _this.options.delayMouseStart;
      _this.timeout = setTimeout(_this.handleTopMoveStart.bind(_this, e), delay);
      _this.waitingForDelay = true;
    };

    this.handleTopMoveCapture = function () {
      _this.dragOverTargetIds = [];
    };

    this.handleMove = function (_, targetId) {
      if (_this.dragOverTargetIds) {
        _this.dragOverTargetIds.unshift(targetId);
      }
    };

    this.handleTopMove = function (e) {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }

      if (!_this.document || _this.waitingForDelay) {
        return;
      }

      var moveStartSourceIds = _this.moveStartSourceIds,
          dragOverTargetIds = _this.dragOverTargetIds;
      var enableHoverOutsideTarget = _this.options.enableHoverOutsideTarget;
      var clientOffset = Object(__WEBPACK_IMPORTED_MODULE_3__utils_offsets__["a" /* getEventClientOffset */])(e, _this.lastTargetTouchFallback);

      if (!clientOffset) {
        return;
      } // If the touch move started as a scroll, or is is between the scroll angles


      if (_this._isScrolling || !_this.monitor.isDragging() && Object(__WEBPACK_IMPORTED_MODULE_4__utils_math__["b" /* inAngleRanges */])(_this._mouseClientOffset.x || 0, _this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, _this.options.scrollAngleRanges)) {
        _this._isScrolling = true;
        return;
      } // If we're not dragging and we've moved a little, that counts as a drag start


      if (!_this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
      _this._mouseClientOffset.hasOwnProperty('x') && moveStartSourceIds && Object(__WEBPACK_IMPORTED_MODULE_4__utils_math__["a" /* distance */])(_this._mouseClientOffset.x || 0, _this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (_this.options.touchSlop ? _this.options.touchSlop : 0)) {
        _this.moveStartSourceIds = undefined;

        _this.actions.beginDrag(moveStartSourceIds, {
          clientOffset: _this._mouseClientOffset,
          getSourceClientOffset: _this.getSourceClientOffset,
          publishSource: false
        });
      }

      if (!_this.monitor.isDragging()) {
        return;
      }

      var sourceNode = _this.sourceNodes[_this.monitor.getSourceId()];

      _this.installSourceNodeRemovalObserver(sourceNode);

      _this.actions.publishDragSource();

      e.preventDefault(); // Get the node elements of the hovered DropTargets

      var dragOverTargetNodes = (dragOverTargetIds || []).map(function (key) {
        return _this.targetNodes[key];
      }); // Get the a ordered list of nodes that are touched by

      var elementsAtPoint = _this.options.getDropTargetElementsAtPoint ? _this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : _this.document.elementsFromPoint(clientOffset.x, clientOffset.y); // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)

      var elementsAtPointExtended = [];

      for (var nodeId in elementsAtPoint) {
        // eslint-disable-next-line no-prototype-builtins
        if (!elementsAtPoint.hasOwnProperty(nodeId)) {
          continue;
        }

        var currentNode = elementsAtPoint[nodeId];
        elementsAtPointExtended.push(currentNode);

        while (currentNode) {
          currentNode = currentNode.parentElement;

          if (elementsAtPointExtended.indexOf(currentNode) === -1) {
            elementsAtPointExtended.push(currentNode);
          }
        }
      }

      var orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
      .filter(function (node) {
        return dragOverTargetNodes.indexOf(node) > -1;
      }) // Map back the nodes elements to targetIds
      .map(function (node) {
        for (var targetId in _this.targetNodes) {
          if (node === _this.targetNodes[targetId]) {
            return targetId;
          }
        }

        return undefined;
      }) // Filter off possible null rows
      .filter(function (node) {
        return !!node;
      }).filter(function (id, index, ids) {
        return ids.indexOf(id) === index;
      }); // Invoke hover for drop targets when source node is still over and pointer is outside

      if (enableHoverOutsideTarget) {
        for (var targetId in _this.targetNodes) {
          if (_this.targetNodes[targetId] && _this.targetNodes[targetId].contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
            orderedDragOverTargetIds.unshift(targetId);
            break;
          }
        }
      } // Reverse order because dnd-core reverse it before calling the DropTarget drop methods


      orderedDragOverTargetIds.reverse();

      _this.actions.hover(orderedDragOverTargetIds, {
        clientOffset: clientOffset
      });
    };

    this.handleTopMoveEndCapture = function (e) {
      _this._isScrolling = false;
      _this.lastTargetTouchFallback = undefined;

      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_predicates__["a" /* eventShouldEndDrag */])(e)) {
        return;
      }

      if (!_this.monitor.isDragging() || _this.monitor.didDrop()) {
        _this.moveStartSourceIds = undefined;
        return;
      }

      e.preventDefault();
      _this._mouseClientOffset = {};

      _this.uninstallSourceNodeRemovalObserver();

      _this.actions.drop();

      _this.actions.endDrag();
    };

    this.handleCancelOnEscape = function (e) {
      if (e.key === 'Escape' && _this.monitor.isDragging()) {
        _this._mouseClientOffset = {};

        _this.uninstallSourceNodeRemovalObserver();

        _this.actions.endDrag();
      }
    };

    this.options = new __WEBPACK_IMPORTED_MODULE_6__OptionsReader__["a" /* OptionsReader */](options, context);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.sourceNodes = {};
    this.sourcePreviewNodes = {};
    this.sourcePreviewNodeOptions = {};
    this.targetNodes = {};
    this.listenerTypes = [];
    this._mouseClientOffset = {};
    this._isScrolling = false;

    if (this.options.enableMouseEvents) {
      this.listenerTypes.push(__WEBPACK_IMPORTED_MODULE_1__interfaces__["a" /* ListenerType */].mouse);
    }

    if (this.options.enableTouchEvents) {
      this.listenerTypes.push(__WEBPACK_IMPORTED_MODULE_1__interfaces__["a" /* ListenerType */].touch);
    }

    if (this.options.enableKeyboardEvents) {
      this.listenerTypes.push(__WEBPACK_IMPORTED_MODULE_1__interfaces__["a" /* ListenerType */].keyboard);
    }
  } // public for test


  _createClass(TouchBackend, [{
    key: "setup",
    value: function setup() {
      if (!this.window) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__react_dnd_invariant__["a" /* invariant */])(!TouchBackend.isSetUp, 'Cannot have two Touch backends at the same time.');
      TouchBackend.isSetUp = true;
      this.addEventListener(this.window, 'start', this.getTopMoveStartHandler());
      this.addEventListener(this.window, 'start', this.handleTopMoveStartCapture, true);
      this.addEventListener(this.window, 'move', this.handleTopMove);
      this.addEventListener(this.window, 'move', this.handleTopMoveCapture, true);
      this.addEventListener(this.window, 'end', this.handleTopMoveEndCapture, true);

      if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) {
        this.addEventListener(this.window, 'contextmenu', this.handleTopMoveEndCapture);
      }

      if (this.options.enableKeyboardEvents) {
        this.addEventListener(this.window, 'keydown', this.handleCancelOnEscape, true);
      }
    }
  }, {
    key: "teardown",
    value: function teardown() {
      if (!this.window) {
        return;
      }

      TouchBackend.isSetUp = false;
      this._mouseClientOffset = {};
      this.removeEventListener(this.window, 'start', this.handleTopMoveStartCapture, true);
      this.removeEventListener(this.window, 'start', this.handleTopMoveStart);
      this.removeEventListener(this.window, 'move', this.handleTopMoveCapture, true);
      this.removeEventListener(this.window, 'move', this.handleTopMove);
      this.removeEventListener(this.window, 'end', this.handleTopMoveEndCapture, true);

      if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) {
        this.removeEventListener(this.window, 'contextmenu', this.handleTopMoveEndCapture);
      }

      if (this.options.enableKeyboardEvents) {
        this.removeEventListener(this.window, 'keydown', this.handleCancelOnEscape, true);
      }

      this.uninstallSourceNodeRemovalObserver();
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(subject, event, handler, capture) {
      var options = __WEBPACK_IMPORTED_MODULE_5__utils_supportsPassive__["a" /* default */] ? {
        capture: capture,
        passive: false
      } : capture;
      this.listenerTypes.forEach(function (listenerType) {
        var evt = eventNames[listenerType][event];

        if (evt) {
          subject.addEventListener(evt, handler, options);
        }
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(subject, event, handler, capture) {
      var options = __WEBPACK_IMPORTED_MODULE_5__utils_supportsPassive__["a" /* default */] ? {
        capture: capture,
        passive: false
      } : capture;
      this.listenerTypes.forEach(function (listenerType) {
        var evt = eventNames[listenerType][event];

        if (evt) {
          subject.removeEventListener(evt, handler, options);
        }
      });
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node) {
      var _this2 = this;

      var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
      this.sourceNodes[sourceId] = node;
      this.addEventListener(node, 'start', handleMoveStart);
      return function () {
        delete _this2.sourceNodes[sourceId];

        _this2.removeEventListener(node, 'start', handleMoveStart);
      };
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this3 = this;

      this.sourcePreviewNodeOptions[sourceId] = options;
      this.sourcePreviewNodes[sourceId] = node;
      return function () {
        delete _this3.sourcePreviewNodes[sourceId];
        delete _this3.sourcePreviewNodeOptions[sourceId];
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this4 = this;

      if (!this.document) {
        return function () {
          return null;
        };
      }

      var handleMove = function handleMove(e) {
        if (!_this4.document || !_this4.monitor.isDragging()) {
          return;
        }

        var coords;
        /**
         * Grab the coordinates for the current mouse/touch position
         */

        switch (e.type) {
          case eventNames.mouse.move:
            coords = {
              x: e.clientX,
              y: e.clientY
            };
            break;

          case eventNames.touch.move:
            coords = {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY
            };
            break;
        }
        /**
         * Use the coordinates to grab the element the drag ended on.
         * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
         */


        var droppedOn = coords != null ? _this4.document.elementFromPoint(coords.x, coords.y) : undefined;
        var childMatch = droppedOn && node.contains(droppedOn);

        if (droppedOn === node || childMatch) {
          return _this4.handleMove(e, targetId);
        }
      };
      /**
       * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
       */


      this.addEventListener(this.document.body, 'move', handleMove);
      this.targetNodes[targetId] = node;
      return function () {
        if (_this4.document) {
          delete _this4.targetNodes[targetId];

          _this4.removeEventListener(_this4.document.body, 'move', handleMove);
        }
      };
    }
  }, {
    key: "getTopMoveStartHandler",
    value: function getTopMoveStartHandler() {
      if (!this.options.delayTouchStart && !this.options.delayMouseStart) {
        return this.handleTopMoveStart;
      }

      return this.handleTopMoveStartDelay;
    }
  }, {
    key: "installSourceNodeRemovalObserver",
    value: function installSourceNodeRemovalObserver(node) {
      var _this5 = this;

      this.uninstallSourceNodeRemovalObserver();
      this.draggedSourceNode = node;
      this.draggedSourceNodeRemovalObserver = new MutationObserver(function () {
        if (node && !node.parentElement) {
          _this5.resurrectSourceNode();

          _this5.uninstallSourceNodeRemovalObserver();
        }
      });

      if (!node || !node.parentElement) {
        return;
      }

      this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
        childList: true
      });
    }
  }, {
    key: "resurrectSourceNode",
    value: function resurrectSourceNode() {
      if (this.document && this.draggedSourceNode) {
        this.draggedSourceNode.style.display = 'none';
        this.draggedSourceNode.removeAttribute('data-reactid');
        this.document.body.appendChild(this.draggedSourceNode);
      }
    }
  }, {
    key: "uninstallSourceNodeRemovalObserver",
    value: function uninstallSourceNodeRemovalObserver() {
      if (this.draggedSourceNodeRemovalObserver) {
        this.draggedSourceNodeRemovalObserver.disconnect();
      }

      this.draggedSourceNodeRemovalObserver = undefined;
      this.draggedSourceNode = undefined;
    }
  }, {
    key: "window",
    get: function get() {
      return this.options.window;
    } // public for test

  }, {
    key: "document",
    get: function get() {
      if (this.window) {
        return this.window.document;
      }

      return undefined;
    }
  }]);

  return TouchBackend;
}();



/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListenerType; });
var ListenerType;

(function (ListenerType) {
  ListenerType["mouse"] = "mouse";
  ListenerType["touch"] = "touch";
  ListenerType["keyboard"] = "keyboard";
})(ListenerType || (ListenerType = {}));

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getNodeClientOffset;
/* unused harmony export getEventClientTouchOffset */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEventClientOffset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__predicates__ = __webpack_require__(533);

var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return undefined;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    x: left,
    y: top
  };
}
function getEventClientTouchOffset(e, lastTargetTouchFallback) {
  if (e.targetTouches.length === 1) {
    return getEventClientOffset(e.targetTouches[0]);
  } else if (lastTargetTouchFallback && e.touches.length === 1) {
    if (e.touches[0].target === lastTargetTouchFallback.target) {
      return getEventClientOffset(e.touches[0]);
    }
  }
}
function getEventClientOffset(e, lastTargetTouchFallback) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__predicates__["c" /* isTouchEvent */])(e)) {
    return getEventClientTouchOffset(e, lastTargetTouchFallback);
  } else {
    return {
      x: e.clientX,
      y: e.clientY
    };
  }
}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = distance;
/* harmony export (immutable) */ __webpack_exports__["b"] = inAngleRanges;
function distance(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function inAngleRanges(x1, y1, x2, y2, angleRanges) {
  if (!angleRanges) {
    return false;
  }

  var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;

  for (var i = 0; i < angleRanges.length; ++i) {
    if ((angleRanges[i].start == null || angle >= angleRanges[i].start) && (angleRanges[i].end == null || angle <= angleRanges[i].end)) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var supportsPassive = function () {
  // simular to jQuery's test
  var supported = false;

  try {
    addEventListener('test', function () {// do nothing
    }, Object.defineProperty({}, 'passive', {
      get: function get() {
        supported = true;
        return true;
      }
    }));
  } catch (e) {// do nothing
  }

  return supported;
}();

/* harmony default export */ __webpack_exports__["a"] = (supportsPassive);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionsReader; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OptionsReader =
/*#__PURE__*/
function () {
  function OptionsReader(incoming, context) {
    var _this = this;

    _classCallCheck(this, OptionsReader);

    this.enableTouchEvents = true;
    this.enableMouseEvents = false;
    this.enableKeyboardEvents = false;
    this.ignoreContextMenu = false;
    this.enableHoverOutsideTarget = false;
    this.touchSlop = 0;
    this.scrollAngleRanges = undefined;
    this.context = context;
    this.delayTouchStart = incoming.delayTouchStart || incoming.delay || 0;
    this.delayMouseStart = incoming.delayMouseStart || incoming.delay || 0;
    Object.keys(incoming).forEach(function (key) {
      if (incoming[key] != null) {
        ;
        _this[key] = incoming[key];
      }
    });
  }

  _createClass(OptionsReader, [{
    key: "window",
    get: function get() {
      if (this.context && this.context.window) {
        return this.context.window;
      } else if (typeof window !== 'undefined') {
        return window;
      }

      return undefined;
    }
  }, {
    key: "document",
    get: function get() {
      if (this.window) {
        return this.window.document;
      }

      return undefined;
    }
  }]);

  return OptionsReader;
}();

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchTransition; });
/* unused harmony export HTML5DragTransition */
/* unused harmony export MouseTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createTransition__ = __webpack_require__(536);

var TouchTransition = Object(__WEBPACK_IMPORTED_MODULE_0__createTransition__["a" /* default */])('touchstart', function (event) {
  return event.touches != null; // eslint-disable-line no-eq-null, eqeqeq
});
var HTML5DragTransition = Object(__WEBPACK_IMPORTED_MODULE_0__createTransition__["a" /* default */])('dragstart', function (event) {
  if (event.type) {
    return event.type.indexOf('drag') !== -1 || event.type.indexOf('drop') !== -1;
  }

  return false;
});
var MouseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__createTransition__["a" /* default */])('mousedown', function (event) {
  if (event.type) {
    return event.type.indexOf('touch') === -1 && event.type.indexOf('mouse') !== -1;
  }

  return false;
});

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreviewManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectAssign__ = __webpack_require__(1146);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PreviewList = function PreviewList() {
  var _this = this;

  _classCallCheck(this, PreviewList);

  this.register = function (preview) {
    _this.previews.push(preview);
  };

  this.unregister = function (preview) {
    var index;

    while ((index = _this.previews.indexOf(preview)) !== -1) {
      _this.previews.splice(index, 1);
    }
  };

  this.backendChanged = function (backend) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _this.previews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var preview = _step.value;
        preview.backendChanged(backend);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  this.previews = [];
};

var PreviewManager = new PreviewList();

var _default = function _default(manager, context, sourceOptions) {
  var _this2 = this;

  _classCallCheck(this, _default);

  this.setup = function () {
    if (typeof window === 'undefined') {
      return;
    }

    if (_this2.constructor.isSetUp) {
      throw new Error('Cannot have two MultiBackends at the same time.');
    }

    _this2.constructor.isSetUp = true;

    _this2.addEventListeners(window);

    _this2.backends[_this2.current].instance.setup();
  };

  this.teardown = function () {
    if (typeof window === 'undefined') {
      return;
    }

    _this2.constructor.isSetUp = false;

    _this2.removeEventListeners(window);

    _this2.backends[_this2.current].instance.teardown();
  };

  this.connectDragSource = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _this2.connectBackend('connectDragSource', args);
  };

  this.connectDragPreview = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.connectBackend('connectDragPreview', args);
  };

  this.connectDropTarget = function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.connectBackend('connectDropTarget', args);
  };

  this.previewEnabled = function () {
    return _this2.backends[_this2.current].preview;
  };

  this.addEventListeners = function (target) {
    _this2.backends.forEach(function (backend) {
      if (backend.transition) {
        target.addEventListener(backend.transition.event, _this2.backendSwitcher, true);
      }
    });
  };

  this.removeEventListeners = function (target) {
    _this2.backends.forEach(function (backend) {
      if (backend.transition) {
        target.removeEventListener(backend.transition.event, _this2.backendSwitcher, true);
      }
    });
  };

  this.backendSwitcher = function (event) {
    var oldBackend = _this2.current;
    var i = 0;

    _this2.backends.some(function (backend) {
      if (i !== _this2.current && backend.transition && backend.transition.check(event)) {
        _this2.current = i;
        return true;
      }

      i += 1;
      return false;
    });

    if (_this2.current !== oldBackend) {
      _this2.backends[oldBackend].instance.teardown();

      Object.keys(_this2.nodes).forEach(function (id) {
        var node = _this2.nodes[id];
        node.handler();
        node.handler = _this2.callBackend(node.func, node.args);
      });
      PreviewManager.backendChanged(_this2);
      var newBackend = _this2.backends[_this2.current];
      newBackend.instance.setup();

      if (newBackend.skipDispatchOnTransition) {
        return;
      }

      var newEvent = null;

      try {
        newEvent = new event.constructor(event.type, event);
      } catch (_e) {
        newEvent = document.createEvent('Event');
        newEvent.initEvent(event.type, event.bubbles, event.cancelable);
      }

      event.target.dispatchEvent(newEvent);
    }
  };

  this.callBackend = function (func, args) {
    var _this2$backends$_this;

    return (_this2$backends$_this = _this2.backends[_this2.current].instance)[func].apply(_this2$backends$_this, _toConsumableArray(args));
  };

  this.connectBackend = function (func, args) {
    var nodeId = "".concat(func, "_").concat(args[0]);

    var handler = _this2.callBackend(func, args);

    _this2.nodes[nodeId] = {
      func: func,
      args: args,
      handler: handler
    };
    return function () {
      var _this2$nodes$nodeId;

      var r = (_this2$nodes$nodeId = _this2.nodes[nodeId]).handler.apply(_this2$nodes$nodeId, arguments);

      delete _this2.nodes[nodeId];
      return r;
    };
  };

  var options = Object(__WEBPACK_IMPORTED_MODULE_0__objectAssign__["a" /* default */])({
    backends: []
  }, sourceOptions || {});

  if (options.backends.length < 1) {
    throw new Error("You must specify at least one Backend, if you are coming from 2.x.x (or don't understand this error)\n        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-2xx");
  }

  this.current = 0;
  this.backends = [];
  options.backends.forEach(function (backend) {
    if (!backend.backend) {
      throw new Error("You must specify a 'backend' property in your Backend entry: ".concat(backend));
    }

    var transition = backend.transition;

    if (transition && !transition._isMBTransition) {
      throw new Error("You must specify a valid 'transition' property (either undefined or the return of 'createTransition') in your Backend entry: ".concat(backend));
    }

    _this2.backends.push({
      instance: backend.backend(manager, context, backend.options),
      preview: backend.preview || false,
      transition: transition,
      skipDispatchOnTransition: Boolean(backend.skipDispatchOnTransition)
    });
  });
  this.nodes = {};
} // DnD Backend API
;



/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var name in source) {
      if (Object.prototype.hasOwnProperty.call(source, name)) {
        target[name] = source[name];
      }
    }
  });
  return target;
});

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_preview__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dnd_multi_backend__ = __webpack_require__(535);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var Preview = function Preview(props) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      enabled = _useState2[0],
      setEnabled = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var observer = {
      backendChanged: function backendChanged(backend) {
        setEnabled(backend.previewEnabled());
      }
    };
    __WEBPACK_IMPORTED_MODULE_2_dnd_multi_backend__["a" /* PreviewManager */].register(observer);
    return function () {
      __WEBPACK_IMPORTED_MODULE_2_dnd_multi_backend__["a" /* PreviewManager */].unregister(observer);
    };
  });

  if (!enabled) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_dnd_preview__["b" /* default */], props);
};

Preview.Context = __WEBPACK_IMPORTED_MODULE_1_react_dnd_preview__["a" /* Context */];
Preview.propTypes = __WEBPACK_IMPORTED_MODULE_1_react_dnd_preview__["b" /* default */].propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Preview);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd__ = __webpack_require__(70);



var PreviewContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();

var getStyle = function getStyle(currentOffset) {
  var transform = "translate(".concat(currentOffset.x, "px, ").concat(currentOffset.y, "px)");
  return {
    pointerEvents: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    transform: transform,
    WebkitTransform: transform
  };
};

var Preview = function Preview(props) {
  var collectedProps = Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["d" /* useDragLayer */])(function (monitor) {
    return {
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
      itemType: monitor.getItemType(),
      item: monitor.getItem()
    };
  });

  if (!collectedProps.isDragging || collectedProps.currentOffset === null) {
    return null;
  }

  var data = {
    itemType: collectedProps.itemType,
    item: collectedProps.item,
    style: getStyle(collectedProps.currentOffset)
  };
  var child;

  if (props.children && typeof props.children === 'function') {
    child = props.children(data);
  } else if (props.children) {
    child = props.children;
  } else {
    child = props.generator(data);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PreviewContext.Provider, {
    value: data
  }, child);
};

Preview.propTypes = {
  generator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
var Context = PreviewContext;
/* harmony default export */ __webpack_exports__["b"] = (Preview);

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1150)();
}


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1151);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BackofficeModeManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReaderApi__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Gallery_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var BackofficeModeManager = /** @class */ (function () {
    function BackofficeModeManager(dispatch) {
        var readerApi = new __WEBPACK_IMPORTED_MODULE_0__ReaderApi__["c" /* default */]();
        readerApi.init().then(function (response) {
            // logo
            readerApi.addListener('brand.getObject', function (response) {
                var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
                var template = storeState.galleryInfos.template;
                if (template && template.brand) {
                    var _a = template.brand, logo = _a.logo, url = _a.url;
                    response.resolve({
                        logo: logo,
                        url: url,
                    });
                }
            });
            readerApi.addListener('brand.update', function (data) {
                data.resolve(dispatch({
                    type: __WEBPACK_IMPORTED_MODULE_1__containers_Gallery_actions__["a" /* GalleryInfosActionKeys */].UPDATE_TEMPLATE_BRAND,
                    value: data.arguments[0],
                }));
            });
            // background media
            readerApi.addListener('backgroundUrl.getObject', function (response) {
                var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
                var applicationGallery = storeState.galleryInfos.config.applicationGallery, driveItems = storeState.driveList.driveItems;
                if (__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isGalleryMetaFetched()) {
                    var bgMedia = driveItems[applicationGallery].bgMedia;
                    response.resolve(bgMedia);
                }
            });
            readerApi.addListener('backgroundUrl.update', function (data) {
                var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
                var applicationGallery = storeState.galleryInfos.config.applicationGallery, driveItems = storeState.driveList.driveItems;
                if (__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isGalleryMetaFetched()) {
                    var driveItem = driveItems[applicationGallery];
                    driveItem.bgMedia = data.arguments[0];
                    data.resolve(dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__["b" /* DriveItemListActionKeys */].UPDATE_DRIVE_ITEM,
                        item: driveItem,
                    }));
                }
            });
            // folder icon
            readerApi.addListener('folderIconUrl.getObject', function (response) {
                var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
                var applicationGallery = storeState.galleryInfos.config.applicationGallery, driveItems = storeState.driveList.driveItems;
                if (__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isGalleryMetaFetched()) {
                    var defaultCover = driveItems[applicationGallery].defaultCover;
                    response.resolve(defaultCover);
                }
            });
            readerApi.addListener('folderIconUrl.update', function (data) {
                var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
                var applicationGallery = storeState.galleryInfos.config.applicationGallery, driveItems = storeState.driveList.driveItems;
                if (__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isGalleryMetaFetched()) {
                    var driveItem = driveItems[applicationGallery];
                    driveItem.defaultCover = data.arguments[0];
                    data.resolve(dispatch({
                        type: __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__["b" /* DriveItemListActionKeys */].UPDATE_DRIVE_ITEM,
                        item: driveItem,
                    }));
                }
            });
            // common styles
            readerApi.addListener('commonStyles.getObject', function (response) {
                var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
                var template = storeState.galleryInfos.template;
                if (template && template.commonStyles) {
                    response.resolve(template.commonStyles);
                }
            });
            readerApi.addListener('commonStyles.update', function (data) {
                data.resolve(dispatch({
                    type: __WEBPACK_IMPORTED_MODULE_1__containers_Gallery_actions__["a" /* GalleryInfosActionKeys */].UPDATE_TEMPLATE_COMMONSTYLES,
                    value: data.arguments[0],
                }));
            });
        });
    }
    return BackofficeModeManager;
}());

/* harmony default export */ __webpack_exports__["a"] = (BackofficeModeManager);


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(20)))

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiEvents; });
var ApiEvents = /** @class */ (function () {
    function ApiEvents() {
        this.listeners = {};
        this.iName = 'ApiEvent';
    }
    ApiEvents.prototype.addListener = function (type, listener) {
        if (typeof this.listeners[type] === 'undefined') {
            this.listeners[type] = [];
        }
        if (!this.listeners[type].includes(listener)) {
            this.listeners[type].push(listener);
        }
    };
    ApiEvents.prototype.fire = function (event) {
        var i = 0;
        var L = 0;
        var listeners;
        var listenersClone;
        if (!event.target) {
            event.target = this;
        }
        if (!event.context) {
            event.context = this;
        }
        if (this.listeners[event.type] instanceof Array) {
            listeners = this.listeners[event.type];
            listenersClone = [];
            var action = void 0;
            L = listeners.length;
            for (; i < L; i++) {
                listenersClone.push(listeners[i]);
            }
            while (action = listenersClone.shift()) {
                if (listeners.includes(action)) {
                    action(event);
                }
            }
        }
    };
    ApiEvents.prototype.removeListener = function (type, listener) {
        var L = 0;
        var i = 0;
        var listeners;
        if (this.listeners[type] instanceof Array) {
            listeners = this.listeners[type];
            L = listeners.length;
            for (; i < L; i++) {
                if (listener !== null && listeners[i] === listener) {
                    listeners.splice(i, 1);
                    break;
                }
                else if (listener === null) {
                    listeners.splice(i, 1);
                }
            }
        }
    };
    return ApiEvents;
}());



/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MenuManager_Left__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_menu__ = __webpack_require__(40);






var mapStateToProps = function (_a) {
    var menuManager = _a.menuManager, authentication = _a.authentication, appInfos = _a.appInfos, lastPublicationId = _a.backToPublication.publicationId, galleryInfos = _a.galleryInfos, galleryConfig = _a.galleryInfos.config, newDriveItems = _a.newDriveItems, driveList = _a.driveList, profile = _a.profile;
    var privateDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getPrivateDirId(driveList, galleryConfig);
    var sharedDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSharedDirId(driveList, galleryConfig);
    var archiveDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getArchiveDirId(driveList, galleryConfig);
    var mode = authentication.userInfos.mode;
    var menuModes = menuManager.menuModes, leftMenuIsOpen = menuManager.leftMenuIsOpen;
    var burger = menuModes.burger;
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMultiApp(appInfos);
    var isMobileApp = __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp;
    var isConnectedSingleApp = !isMultiApp && !__WEBPACK_IMPORTED_MODULE_3__utils_authentication__["a" /* default */].isSaml(mode) && __WEBPACK_IMPORTED_MODULE_3__utils_authentication__["a" /* default */].isConnected(mode);
    var isReadOnlyApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isReadOnlyApp(profile.role);
    var isGalleryButtonNeeded = galleryInfos.isConfigLoaded && __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isTemplateLoaded(appInfos, galleryInfos) && galleryInfos.template.welcomepage;
    var newItemsNb = newDriveItems.ids.length;
    var hasLogOutButton = isMobileApp && isConnectedSingleApp;
    var hasProfile = isMultiApp;
    var hasProposalStatsPage = isMultiApp && !!privateDirId;
    var hasCreateNoteButton = Object.values(menuModes).some(function (menuPosition) { return (menuPosition.some(function (_a) {
        var type = _a.type;
        return type === __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].CreateNote;
    })); });
    var hasNotesPage = isMultiApp && hasCreateNoteButton;
    var hasCookieSettings = galleryInfos.template.cookie && galleryInfos.template.cookie.enabled === 'true' && galleryInfos.template.cookie.gdpr === 'true';
    var hasLastPublication = !!lastPublicationId;
    var filteredMenuItems = burger.filter(function (item) {
        switch (item.type) {
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Gallery:
                return isGalleryButtonNeeded;
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].New:
                return __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isOnline() || !__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMaster(galleryInfos.config);
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Downloads:
                return isMobileApp;
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].CreateButton:
                return isMultiApp && !!privateDirId && !isReadOnlyApp;
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Documents:
                return isMultiApp && !isReadOnlyApp;
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].BackToPublication:
                return hasLastPublication;
            default:
                return item;
        }
    });
    return {
        isOpen: leftMenuIsOpen,
        newItemsNb: newItemsNb,
        filteredMenuItems: filteredMenuItems,
        hasLogOutButton: hasLogOutButton,
        hasProfile: hasProfile,
        hasProposalStatsPage: hasProposalStatsPage,
        hasCookieSettings: hasCookieSettings,
        hasNotesPage: hasNotesPage,
        privateDirId: privateDirId,
        sharedDirId: sharedDirId,
        archiveDirId: archiveDirId,
        isProfileLoaded: hasProfile && !!profile.clientId,
        hasDownloads: isMobileApp &&
            isReadOnlyApp &&
            !filteredMenuItems.some(function (_a) {
                var type = _a.type;
                return type === __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Downloads;
            }),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MenuManager_Left__["a" /* default */]));


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_actions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageOverlay_styles__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_MenuManager_Left_MenuItem__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_MenuManager_Header_Logo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_ProfilePage_UserAvatar__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_ProfilePage_reducer__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_ProfilePage_UserInfo__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_ButtonCreate__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_ButtonCreateNote__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_BackToPublication__ = __webpack_require__(544);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var LeftSideMenu = /** @class */ (function (_super) {
    __extends(LeftSideMenu, _super);
    function LeftSideMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.renderMenuItem = function (item, index) {
            if (item) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_MenuManager_Left_MenuItem__["a" /* default */], { menuItem: item, key: index, badge: item.badge }));
            }
            return null;
        };
        _this.handleOverlayClick = function () {
            var dispatch = _this.props.dispatch;
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_actions__["a" /* MenuActionKeys */].REQUEST_CLOSE_LEFT_MENU });
        };
        _this.handleAvatarClick = function () {
            __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathProfile());
        };
        _this.getMenuItems = function (items) {
            var _a = _this.props, hasLogOutButton = _a.hasLogOutButton, hasProposalStatsPage = _a.hasProposalStatsPage, hasCookieSettings = _a.hasCookieSettings, hasNotesPage = _a.hasNotesPage, hasDownloads = _a.hasDownloads, privateDirId = _a.privateDirId, sharedDirId = _a.sharedDirId, archiveDirId = _a.archiveDirId, dispatch = _a.dispatch;
            if (hasDownloads) {
                var donwloadsItem = { type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Downloads };
                items.push(donwloadsItem);
            }
            if (hasProposalStatsPage) {
                var proposalStatsButton = { type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].ProposalStats };
                items.push(proposalStatsButton);
            }
            if (hasNotesPage) {
                var notesButton = { type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Notes };
                items.push(notesButton);
            }
            if (hasCookieSettings) {
                var cookieSettingsItem = { type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CookieSettings };
                items.push(cookieSettingsItem);
            }
            if (hasLogOutButton) {
                var logOutButtonItem = { type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].LogOut };
                items.push(logOutButtonItem);
            }
            return items.map(function (_a, index) {
                var type = _a.type, icon = _a.icon, label = _a.label, target = _a.target, options = _a.options;
                var itemArgs;
                switch (type) {
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Home:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Home,
                            label: label || 'messages.home',
                            icon: icon || 'iconset_home',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathHome()
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Gallery:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Gallery,
                            label: label || 'messages.my_gallery',
                            icon: icon || 'iconset_image',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, null)
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].New:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].New,
                            label: label || 'messages.new',
                            icon: icon || 'iconset_uprez_menu_news',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].New, null),
                            badge: _this.props.newItemsNb
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Selection:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Selection,
                            label: label || 'messages.my_selection',
                            icon: icon || 'iconset_uprez_menu_selection',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Selection, null)
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Downloads:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Downloads,
                            label: label || 'messages.my_downloads',
                            icon: icon || 'iconset_uprez_download_bold',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads, null)
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SharedWithMe:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SharedWithMe,
                            label: label || 'messages.shared_with_me',
                            icon: icon || 'iconset_shared_with_me',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, String(sharedDirId))
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Documents:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Documents,
                            label: label || 'messages.my_documents',
                            icon: icon || 'iconset_uprez_menu_folder',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, String(privateDirId)),
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Parameters:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Parameters,
                            label: label || 'messages.parameters',
                            icon: icon || 'iconset_parameters',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathParameters()
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Profile:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Profile,
                            label: label || 'messages.profile',
                            icon: icon || 'iconset_uprez_profile',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathProfile(),
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].ProposalStats:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].ProposalStats,
                            label: label || 'messages.my_sent',
                            icon: icon || 'iconset_uprez_send',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathProposalStats(),
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].ProposalArchive:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].ProposalArchive,
                            label: label || 'messages.archive_noun',
                            icon: icon || 'iconset_uprez_archive',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, String(archiveDirId)),
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Notes:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Notes,
                            label: label || 'messages.my_notes',
                            icon: icon || 'iconset_uprez_notes',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathNotes(),
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SearchButton:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SearchButton,
                            label: label || 'messages.search',
                            icon: icon || 'iconset_uprez_menu_search',
                            target: __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search, null),
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Link:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Link,
                            label: label || 'Link',
                            icon: icon || 'iconset_link',
                            target: target,
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Asset:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Asset,
                            label: label || 'Asset',
                            icon: icon || 'iconset_file',
                            target: target,
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Folder:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Folder,
                            label: label || 'Folder',
                            icon: icon || 'iconset_folder',
                            target: target,
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Page:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Page,
                            label: label || 'Page',
                            icon: icon || 'iconset_page',
                            target: target,
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CookieSettings:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CookieSettings,
                            label: label || 'messages.cookie_settings',
                            icon: icon || 'iconset_cookie',
                            target: '',
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].LogOut:
                        itemArgs = {
                            type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].LogOut,
                            label: label || 'messages.log_out',
                            icon: icon || 'iconset_logout',
                            target: ''
                        };
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CreateButton:
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__containers_ButtonCreate__["a" /* default */], { key: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CreateButton, position: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["c" /* MenuPosition */].burger, options: options, onOptionClick: function () { return dispatch({ type: __WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_actions__["a" /* MenuActionKeys */].REQUEST_CLOSE_LEFT_MENU }); } }));
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CreateNote:
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__containers_ButtonCreateNote__["a" /* default */], { key: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CreateNote, position: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["c" /* MenuPosition */].burger, label: label, icon: icon }));
                    case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].BackToPublication:
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__containers_BackToPublication__["a" /* default */], { key: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].BackToPublication, position: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["c" /* MenuPosition */].burger, label: label, icon: icon }));
                }
                return _this.renderMenuItem(itemArgs, index);
            });
        };
        _this.getMenuItems = _this.getMenuItems.bind(_this);
        return _this;
    }
    LeftSideMenu.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, filteredMenuItems = _a.filteredMenuItems, hasProfile = _a.hasProfile;
        var menuItems = this.getMenuItems(filteredMenuItems);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PageOverlay_styles__["a" /* PageOverlay */], { isOpen: isOpen, onClick: this.handleOverlayClick }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* StyledLeftSideMenu */], { className: "StyledLeftSideMenu", isOpen: isOpen },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MenuItemsWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* HeaderMenuItem */], { className: "HeaderMenuItem", hasProfile: hasProfile }, hasProfile
                        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* UserInfoWrapper */], { onClick: this.handleAvatarClick },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__containers_ProfilePage_UserAvatar__["a" /* default */], { size: __WEBPACK_IMPORTED_MODULE_10__containers_ProfilePage_reducer__["a" /* AvatarSize */].SMALL }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__containers_ProfilePage_UserInfo__["a" /* default */], { isSmall: true })))
                        : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_MenuManager_Header_Logo__["a" /* default */], null)),
                    menuItems))));
    };
    return LeftSideMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LeftSideMenu);


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledLeftSideMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuItemsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderMenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UserInfoWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var menuWidth = '380px';
var menuWidthSmartphone = '300px';
var StyledLeftSideMenu = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tmargin: 0;\n\tbackground-color: ", ";\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\tpadding: 0;\n\ttransition: left 0.2s;\n\tz-index: 11;\n\tcolor: ", ";\n\twidth: ", ";\n\tleft: ", ";\n\n\t@media ", " {\n\t\twidth: ", ";\n\t\tleft: ", ";\n\t}\n\n\t", "\n\n\t", "\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tmargin: 0;\n\tbackground-color: ", ";\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\tpadding: 0;\n\ttransition: left 0.2s;\n\tz-index: 11;\n\tcolor: ", ";\n\twidth: ", ";\n\tleft: ", ";\n\n\t@media ", " {\n\t\twidth: ", ";\n\t\tleft: ", ";\n\t}\n\n\t",
    "\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey500, menuWidth, function (props) { return props.isOpen ? 0 : "-" + menuWidth; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, menuWidthSmartphone, function (props) { return props.isOpen ? 0 : "-" + menuWidthSmartphone; }, __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var HeaderMenuItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: ", ";\n\tborder-bottom: 1px solid ", ";\n\tposition: relative;\n\tmargin-left: 0;\n\tpadding-left: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\n\t", "\n\n\t", "\n"], ["\n\theight: ", ";\n\tborder-bottom: 1px solid ", ";\n\tposition: relative;\n\tmargin-left: 0;\n\tpadding-left: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\n\t",
    "\n\n\t",
    "\n"])), function (props) { return props.hasProfile ? 'auto' : '70px'; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50, function (props) { return props.hasProfile ? '0' : '15px'; }, __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var MenuItemsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex: 1 0 auto;\n"], ["\n\tflex: 1 0 auto;\n"])));
var UserInfoWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 20px;\n\tcursor: pointer;\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 20px;\n\tcursor: pointer;\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuManager_Left_MenuItem__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__ = __webpack_require__(11);





var LocationPathName;
(function (LocationPathName) {
    LocationPathName["Folder"] = "/list/folder";
    LocationPathName["Page"] = "/page";
    LocationPathName["Search"] = "/list/search";
})(LocationPathName || (LocationPathName = {}));
var mapStateToProps = function (state, ownProps) {
    var appInfos = state.appInfos, pathname = state.routing.locationBeforeTransitions.pathname, search = state.search, config = state.galleryInfos.config, routerParamsHistory = state.routerParamsHistory, driveList = state.driveList;
    var menuItem = ownProps.menuItem;
    var type = menuItem.type, target = menuItem.target;
    var isShown = search.isShown, searchString = search.searchString;
    var driveItems = driveList.driveItems;
    var isRoute = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMenuItemTypeRoute(menuItem.type);
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMultiApp(appInfos);
    var isItemActive = function () {
        if (menuItem) {
            var targetId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getMediaId(target);
            if (type === __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Folder) {
                return pathname === LocationPathName.Folder + "/" + targetId;
            }
            else if (type === __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Page) {
                return pathname === LocationPathName.Page + "/" + targetId;
            }
            else if (type === __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SearchButton) {
                return isShown || pathname === LocationPathName.Search + "/" + searchString;
            }
            else if (type === __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Documents) {
                var currentFolderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getCurrentFolderId(config.applicationGallery, routerParamsHistory);
                var privateDirId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getPrivateDirId(driveList, config);
                var sharedDirId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSharedDirId(driveList, config);
                return pathname.includes(LocationPathName.Folder) &&
                    __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, privateDirId, driveItems) &&
                    !__WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, sharedDirId, driveItems);
            }
            else if (type === __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SharedWithMe) {
                var currentFolderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getCurrentFolderId(config.applicationGallery, routerParamsHistory);
                var sharedDirId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSharedDirId(driveList, config);
                return pathname.includes(LocationPathName.Folder) &&
                    __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, sharedDirId, driveItems);
            }
            else if (isRoute) {
                return pathname === "/" + target;
            }
        }
        return false;
    };
    return {
        isActive: isItemActive(),
        isRoute: isRoute,
        isMultiApp: isMultiApp
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components_MenuManager_Left_MenuItem__["a" /* default */]));


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_MenuManager_actions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Authentication_actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_Search_actions__ = __webpack_require__(144);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var I18n = __webpack_require__(5).I18n;
// Make i18n return the whole key in case of a missing translation and not only the last item.
var HandleMissingTranslation = function (key) { return key; };
I18n.setHandleMissingTranslation(HandleMissingTranslation);
var LeftMenuItem = /** @class */ (function (_super) {
    __extends(LeftMenuItem, _super);
    function LeftMenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    LeftMenuItem.prototype.handleClick = function () {
        var _a = this.props, isMultiApp = _a.isMultiApp, isRoute = _a.isRoute, menuItem = _a.menuItem, dispatch = _a.dispatch;
        var type = menuItem.type, target = menuItem.target;
        if (type === __WEBPACK_IMPORTED_MODULE_2__typings_menu__["b" /* MenuItemType */].LogOut) {
            if (isMultiApp) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_actions__["k" /* signOut */])());
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Authentication_actions__["b" /* disconnect */])());
            }
        }
        else if (type === __WEBPACK_IMPORTED_MODULE_2__typings_menu__["b" /* MenuItemType */].SearchButton) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_Search_actions__["c" /* toggleSearchFieldVisibility */])());
        }
        else if (type === __WEBPACK_IMPORTED_MODULE_2__typings_menu__["b" /* MenuItemType */].CookieSettings) {
            window.tarteaucitron.userInterface.openPanel();
        }
        else if (isRoute) {
            __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].historyPush(target);
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_MenuManager_actions__["b" /* openCustomItem */])(type, target));
        }
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_3__containers_MenuManager_actions__["a" /* MenuActionKeys */].REQUEST_CLOSE_LEFT_MENU });
    };
    LeftMenuItem.prototype.render = function () {
        var _a = this.props, menuItem = _a.menuItem, badge = _a.badge, isActive = _a.isActive;
        var icon = menuItem.icon;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledMenuItem */], { onClick: this.handleClick, isActive: isActive, className: "menu-item " + menuItem.type },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* StyledMenuItemLink */], null,
                __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon(icon),
                I18n.t(menuItem.label),
                !!badge && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* MenuItemBadge */], null, badge))));
    };
    return LeftMenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LeftMenuItem);


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Gallery_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_MenuManager_actions__ = __webpack_require__(99);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var HeaderLogo = /** @class */ (function (_super) {
    __extends(HeaderLogo, _super);
    function HeaderLogo(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            var _a = _this.props, isDisabled = _a.isDisabled, brandUrl = _a.brandUrl, isCurrentPageHome = _a.isCurrentPageHome, dispatch = _a.dispatch;
            if (isDisabled) {
                return;
            }
            if (brandUrl) {
                window.open(brandUrl);
            }
            else {
                if (isCurrentPageHome) {
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_6__containers_Gallery_actions__["a" /* GalleryInfosActionKeys */].FORCE_VIEW_UPDATE });
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_7__containers_MenuManager_actions__["a" /* MenuActionKeys */].REQUEST_CLOSE_LEFT_MENU });
                }
                else {
                    window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getPathHome();
                }
            }
        };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    HeaderLogo.prototype.render = function () {
        var _a = this.props, brandLogoUrl = _a.brandLogoUrl, brandUrl = _a.brandUrl, isDisabled = _a.isDisabled;
        var tooltipId = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].generateId();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Logo */], { "data-tip": true, "data-for": tooltipId, isSvg: __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getFileExtension(brandLogoUrl) === 'svg', isDisabled: isDisabled },
            brandLogoUrl &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: brandLogoUrl, onClick: this.handleClick }),
            (__WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isDesktop() && brandUrl) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Tooltip__["a" /* default */], { id: tooltipId, text: brandUrl, isCustom: true })));
    };
    return HeaderLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (HeaderLogo);


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Logo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Logo = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tmax-height: ", ";\n\tmax-width: 200px;\n\n\t& > img {\n\t\tmax-width: 100%;\n\t\tmax-height: calc(", " - 2px);\n\t\tcursor: ", ";\n\t\t", "\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tmax-height: ", ";\n\tmax-width: 200px;\n\n\t& > img {\n\t\tmax-width: 100%;\n\t\tmax-height: calc(", " - 2px);\n\t\tcursor: ", ";\n\t\t", "\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], function (props) { return props.isDisabled ? 'default' : 'pointer'; }, function (props) { return props.isSvg ? "height: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */] + ";" : ''; });

var templateObject_1;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

/* Decoraters */


/* Utils */


/* CSS */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(64);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(141);

var _classnames2 = _interopRequireDefault(_classnames);

var _staticMethods = __webpack_require__(1163);

var _staticMethods2 = _interopRequireDefault(_staticMethods);

var _windowListener = __webpack_require__(1164);

var _windowListener2 = _interopRequireDefault(_windowListener);

var _customEvent = __webpack_require__(1165);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isCapture = __webpack_require__(1166);

var _isCapture2 = _interopRequireDefault(_isCapture);

var _getEffect = __webpack_require__(1167);

var _getEffect2 = _interopRequireDefault(_getEffect);

var _trackRemoval = __webpack_require__(1168);

var _trackRemoval2 = _interopRequireDefault(_trackRemoval);

var _getPosition = __webpack_require__(1169);

var _getPosition2 = _interopRequireDefault(_getPosition);

var _getTipContent = __webpack_require__(1170);

var _getTipContent2 = _interopRequireDefault(_getTipContent);

var _aria = __webpack_require__(1171);

var _nodeListToArray = __webpack_require__(1172);

var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);

var _style = __webpack_require__(1173);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  function ReactTooltip(props) {
    _classCallCheck(this, ReactTooltip);

    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));

    _this.state = {
      place: 'top', // Direction of tooltip
      type: 'dark', // Color theme of tooltip
      effect: 'float', // float or fixed
      show: false,
      border: false,
      placeholder: '',
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null, // Current mouse event
      currentTarget: null, // Current target of mouse event
      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
      isEmptyTip: false,
      disable: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.intervalUpdateContent = null;
    return _this;
  }

  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: 'bind',
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          insecure = _props.insecure,
          resizeHide = _props.resizeHide;

      if (insecure) {
        this.setStyleHeader(); // Set the style to the <link>
      }
      this.bindListener(); // Bind listener for tooltip
      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var ariaProps = this.state.ariaProps;

      var newAriaProps = (0, _aria.parseAria)(props);

      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (isChanged) {
        this.setState({ ariaProps: newAriaProps });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mount = false;

      this.clearTimer();

      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }

    /**
     * Pick out corresponded target elements
     */

  }, {
    key: 'getTargetArray',
    value: function getTargetArray(id) {
      var targetArray = void 0;
      if (!id) {
        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
      }
      // targetArray is a NodeList, convert it to a real array
      return (0, _nodeListToArray2.default)(targetArray);
    }

    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: 'bindListener',
    value: function bindListener() {
      var _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          globalEventOff = _props2.globalEventOff;

      var targetArray = this.getTargetArray(id);

      targetArray.forEach(function (target) {
        var isCaptureMode = _this3.isCapture(target);
        var effect = _this3.getEffect(target);
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }
        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customBindListener(target);
          return;
        }

        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
        if (effect === 'float') {
          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
        }
        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
      });

      // Global event to hide tooltip
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, false);
      }

      // Track removal of targetArray elements from DOM
      this.bindRemovalTracker();
    }

    /**
     * Unbind listeners on target elements
     */

  }, {
    key: 'unbindListener',
    value: function unbindListener() {
      var _this4 = this;

      var _props3 = this.props,
          id = _props3.id,
          globalEventOff = _props3.globalEventOff;

      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        _this4.unbindBasicListener(target);
        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
      });

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }

    /**
     * Invoke this before bind listener and ummount the compont
     * it is necessary to invloke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: 'unbindBasicListener',
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }

    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: 'showTooltip',
    value: function showTooltip(e, isGlobalCall) {
      var _this5 = this;

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || this.state.show) return;
      }
      // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected
      var _props4 = this.props,
          children = _props4.children,
          multiline = _props4.multiline,
          getContent = _props4.getContent;

      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

      // Generate tootlip content
      var content = void 0;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0]();
        } else {
          content = getContent();
        }
      }
      var placeholder = (0, _getTipContent2.default)(originTooltip, children, content, isMultiline);
      var isEmptyTip = typeof placeholder === 'string' && placeholder === '' || placeholder === null;

      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

      // if it needs to skip adding hide listener to scroll
      var scrollHide = true;
      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }

      // To prevent previously created timers from triggering
      this.clearTimer();

      this.setState({
        placeholder: placeholder,
        isEmptyTip: isEmptyTip,
        desiredPlace: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
      }, function () {
        if (scrollHide) _this5.addScrollListener(e);
        _this5.updateTooltip(e);

        if (getContent && Array.isArray(getContent)) {
          _this5.intervalUpdateContent = setInterval(function () {
            if (_this5.mount) {
              var _getContent = _this5.props.getContent;

              var _placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
              var _isEmptyTip = typeof _placeholder === 'string' && _placeholder === '';
              _this5.setState({
                placeholder: _placeholder,
                isEmptyTip: _isEmptyTip
              });
            }
          }, getContent[1]);
        }
      });
    }

    /**
     * When mouse hover, updatetooltip
     */

  }, {
    key: 'updateTooltip',
    value: function updateTooltip(e) {
      var _this6 = this;

      var _state = this.state,
          delayShow = _state.delayShow,
          show = _state.show,
          isEmptyTip = _state.isEmptyTip,
          disable = _state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.state.placeholder;

      var delayTime = show ? 0 : parseInt(delayShow, 10);
      var eventTarget = e.currentTarget;

      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this6.state.show;
          _this6.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this6.updatePosition();
            if (isInvisible && afterShow) afterShow();
          });
        }
      };

      clearTimeout(this.delayShowLoop);
      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }

    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: 'hideTooltip',
    value: function hideTooltip(e, hasTarget) {
      var _this7 = this;

      var _state2 = this.state,
          delayHide = _state2.delayHide,
          isEmptyTip = _state2.isEmptyTip,
          disable = _state2.disable;
      var afterHide = this.props.afterHide;

      if (!this.mount) return;
      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }
      var resetState = function resetState() {
        var isVisible = _this7.state.show;
        _this7.setState({
          show: false
        }, function () {
          _this7.removeScrollListener();
          if (isVisible && afterHide) afterHide();
        });
      };

      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }

    /**
     * Add scroll eventlistener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: 'addScrollListener',
    value: function addScrollListener(e) {
      var isCaptureMode = this.isCapture(e.currentTarget);
      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.hideTooltip);
    }

    // Calculation the position

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _this8 = this;

      var _state3 = this.state,
          currentEvent = _state3.currentEvent,
          currentTarget = _state3.currentTarget,
          place = _state3.place,
          desiredPlace = _state3.desiredPlace,
          effect = _state3.effect,
          offset = _state3.offset;

      var node = _reactDom2.default.findDOMNode(this);
      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this8.updatePosition();
        });
      }
      // Set tooltip position
      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }

    /**
     * Set style tag in header
     * in this way we can insert default css
     */

  }, {
    key: 'setStyleHeader',
    value: function setStyleHeader() {
      var head = document.getElementsByTagName('head')[0];
      if (!head.querySelector('style[id="react-tooltip"]')) {
        var tag = document.createElement('style');
        tag.id = 'react-tooltip';
        tag.innerHTML = _style2.default;
        head.insertBefore(tag, head.firstChild);
      }
    }

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state4 = this.state,
          placeholder = _state4.placeholder,
          extraClass = _state4.extraClass,
          html = _state4.html,
          ariaProps = _state4.ariaProps,
          disable = _state4.disable,
          isEmptyTip = _state4.isEmptyTip;

      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });

      var Wrapper = this.props.wrapper;
      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      if (html) {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
          id: this.props.id
        }, ariaProps, {
          'data-id': 'tooltip',
          dangerouslySetInnerHTML: { __html: placeholder } }));
      } else {
        return _react2.default.createElement(
          Wrapper,
          _extends({ className: tooltipClass + ' ' + extraClass,
            id: this.props.id
          }, ariaProps, {
            'data-id': 'tooltip' }),
          placeholder
        );
      }
    }
  }]);

  return ReactTooltip;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.any,
  place: _propTypes2.default.string,
  type: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  offset: _propTypes2.default.object,
  multiline: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  insecure: _propTypes2.default.bool,
  class: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  html: _propTypes2.default.bool,
  delayHide: _propTypes2.default.number,
  delayShow: _propTypes2.default.number,
  event: _propTypes2.default.string,
  eventOff: _propTypes2.default.string,
  watchWindow: _propTypes2.default.bool,
  isCapture: _propTypes2.default.bool,
  globalEventOff: _propTypes2.default.string,
  getContent: _propTypes2.default.any,
  afterShow: _propTypes2.default.func,
  afterHide: _propTypes2.default.func,
  disable: _propTypes2.default.bool,
  scrollHide: _propTypes2.default.bool,
  resizeHide: _propTypes2.default.bool,
  wrapper: _propTypes2.default.string
}, _class2.defaultProps = {
  insecure: true,
  resizeHide: true,
  wrapper: 'div'
}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;

/* export default not fit for standalone, it will exports {default:...} */


module.exports = ReactTooltip;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
  };

  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */
  target.rebuild = function () {
    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
  };

  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */
  target.show = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = { currentTarget: event.detail.target };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
    }
  };
};

var _constant = __webpack_require__(538);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatibale with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event = void 0;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: opts });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);

    // ReactTooltip.rebuild
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);

    // ReactTooltip.show
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
};

var _constant = __webpack_require__(538);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;

    return event || !!ele.getAttribute('data-event');
  };

  /* Bind listener for custom event */
  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff;

    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;

    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListener);
      customListener = checkStatus.bind(_this, dataEventOff);
      ele.addEventListener(event, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };

  /* Unbind listener for custom event */
  target.prototype.customUnbindListener = function (ele) {
    var _state2 = this.state,
        event = _state2.event,
        eventOff = _state2.eventOff;

    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');

    ele.removeEventListener(dataEvent, customListener);
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
};

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */

var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;

  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
  var currentItem = e.currentTarget.getAttribute('currentItem');

  if (!isCapture) e.stopPropagation();
  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListener = void 0;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
  };
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;

    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];
        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];
          if (element === _this.state.currentTarget) {
            _this.hideTooltip();
            return;
          }
        }
      }
    });

    observer.observe(window.document, { childList: true, subtree: true });

    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
};

/**
 * Tracking target removing from DOM.
 * It's nessesary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */

// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
  var tipWidth = node.clientWidth;
  var tipHeight = node.clientHeight;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft;

  // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };
  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  };

  // Judge if the tooltip has over the window(screen)
  var outsideVertical = function outsideVertical() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideLeft = function outsideLeft() {
    var _outsideVertical = outsideVertical(),
        result = _outsideVertical.result,
        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority


    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
      result = true; // If vertical ok, but let out of side and right won't out of side
      newPlace = 'right';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideRight = function outsideRight() {
    var _outsideVertical2 = outsideVertical(),
        result = _outsideVertical2.result,
        newPlace = _outsideVertical2.newPlace;

    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };

  var outsideHorizontal = function outsideHorizontal() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
      result = true;
      newPlace = 'right';
    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideTop = function outsideTop() {
    var _outsideHorizontal = outsideHorizontal(),
        result = _outsideHorizontal.result,
        newPlace = _outsideHorizontal.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideBottom = function outsideBottom() {
    var _outsideHorizontal2 = outsideHorizontal(),
        result = _outsideHorizontal2.result,
        newPlace = _outsideHorizontal2.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };

  // Return new state to change the placement to the reverse if possible
  var outsideLeftResult = outsideLeft();
  var outsideRightResult = outsideRight();
  var outsideTopResult = outsideTop();
  var outsideBottomResult = outsideBottom();

  if (place === 'left' && outsideLeftResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideLeftResult.newPlace }
    };
  } else if (place === 'right' && outsideRightResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideRightResult.newPlace }
    };
  } else if (place === 'top' && outsideTopResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideTopResult.newPlace }
    };
  } else if (place === 'bottom' && outsideBottomResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideBottomResult.newPlace }
    };
  }

  // Change back to original place if possible
  if (place !== desiredPlace) {
    if (desiredPlace === 'top' && !outsideTopResult.result) {
      return {
        isNewState: true,
        newState: { place: 'top' }
      };
    } else if (desiredPlace === 'left' && !outsideLeftResult.result) {
      return {
        isNewState: true,
        newState: { place: 'left' }
      };
    } else if (desiredPlace === 'right' && !outsideRightResult.result) {
      return {
        isNewState: true,
        newState: { place: 'right' }
      };
    } else if (desiredPlace === 'bottom' && !outsideBottomResult.result) {
      return {
        isNewState: true,
        newState: { place: 'bottom' }
      };
    }
  }

  // Return tooltip offset position
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
};

// Get current mouse offset
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;
  var targetWidth = currentTarget.clientWidth;
  var targetHeight = currentTarget.clientHeight;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};

// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {OBject} {left: {Number}, top: {Number}}
 */
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top = void 0;
  var right = void 0;
  var bottom = void 0;
  var left = void 0;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return { top: top, bottom: bottom, left: left, right: right };
};

// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
  }
  for (var key in offset) {
    if (key === 'top') {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
};

// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;

  return { parentTop: parentTop, parentLeft: parentLeft };
};

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
  if (getContent === null) return null; // Tip not exist and childern is null or undefined

  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map(function (d, i) {
    return _react2.default.createElement(
      'span',
      { key: i, className: 'multi-line' },
      d
    );
  });
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return (/(^aria-\w+$|^role$)/.test(prop)
    );
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });

  return ariaObj;
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var TooltipContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 4px;\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tborder: 1px solid ", ";\n"], ["\n\tpadding: 4px;\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\tbackground-color: ",
    ";\n\tcolor: ",
    ";\n\tborder: 1px solid ", ";\n"])), function (props) {
    var opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.topnavColor, opacity);
}, function (props) {
    var opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
    var iconsColor = props.theme.primary.iconsColor ? props.theme.primary.iconsColor : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black;
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(iconsColor, opacity);
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100);

var templateObject_1;


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);




var UserAvatar = function (_a) {
    var imageSrc = _a.imageSrc, x = _a.x, y = _a.y, width = _a.width, height = _a.height, size = _a.size;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Image */], { x: x, y: y, width: width, height: height, size: size }, imageSrc && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline()
        ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: imageSrc, alt: "" })
        : __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_uprez-user_avatar')));
};
/* harmony default export */ __webpack_exports__["a"] = (UserAvatar);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1177);



var UserInfo = function (_a) {
    var name = _a.name, position = _a.position, email = _a.email, phone = _a.phone, isSmall = _a.isSmall;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeProvider */], { theme: { isSmall: isSmall } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* Wrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Name */], null, name),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Position */], null, position),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Contact */], null, email),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Contact */], null, phone))));
};
/* harmony default export */ __webpack_exports__["a"] = (UserInfo);


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Contact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: ", ";\n\tmin-width: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\tword-break: break-all;\n\tword-break: break-word;\n"], ["\n\tmargin: ", ";\n\tmin-width: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\tword-break: break-all;\n\tword-break: break-word;\n"])), function (props) { return props.theme.isSmall ? '0' : '0 45px'; }, function (props) { return props.theme.isSmall ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 80) : function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 95.2); }; });
var Name = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-bottom: ", ";\n\tfont-size: ", ";\n\tline-height: 1.2;\n"], ["\n\tmargin-bottom: ", ";\n\tfont-size: ", ";\n\tline-height: 1.2;\n"])), function (props) { return props.theme.isSmall ? '5px' : '15px'; }, function (props) { return props.theme.isSmall ? '17px' : '34px'; });
var Position = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-weight: ", ";\n\tfont-size: ", ";\n\tline-height: 1.3;\n"], ["\n\tfont-weight: ", ";\n\tfont-size: ", ";\n\tline-height: 1.3;\n"])), function (props) { return props.theme.isSmall ? '700' : '400'; }, function (props) { return props.theme.isSmall ? '12px' : '15px'; });
var Contact = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmin-height: ", ";\n\tfont-size: ", ";\n\tline-height: ", ";\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"], ["\n\tmin-height: ", ";\n\tfont-size: ", ";\n\tline-height: ", ";\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])), function (props) { return props.theme.isSmall ? '14px' : '20px'; }, function (props) { return props.theme.isSmall ? '12px' : '15px'; }, function (props) { return props.theme.isSmall ? '14px' : '20px'; }, function (props) { return props.theme.isSmall ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 40) : function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 47.6); }; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropdownMenu__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ImportDesktopFile__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_FolderCreationPanel_actions__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ExternalLinkCreationPanel_actions__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_PublicationCreator_reducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MenuManager_Left_MenuItem_styles__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_customHooks_useClickOutside__ = __webpack_require__(149);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};













var ButtonCreate = function (_a) {
    var options = _a.options, position = _a.position, dispatch = _a.dispatch, onOptionClick = _a.onOptionClick;
    var _b;
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isMenuDisplayed = _c[0], setIsMenuDisplayed = _c[1];
    Object(__WEBPACK_IMPORTED_MODULE_12__utils_customHooks_useClickOutside__["a" /* default */])(wrapperElement, isMenuDisplayed, function () { return setIsMenuDisplayed(false); });
    var handleOptionClick = function () {
        setIsMenuDisplayed(false);
        if (onOptionClick) {
            onOptionClick();
        }
    };
    var config = (_b = {},
        _b[__WEBPACK_IMPORTED_MODULE_9__typings_menu__["a" /* CreateButtonOption */].folder] = {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.create_folder'),
            icon: 'iconset_uprez-create_folder',
            onClick: function () {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_FolderCreationPanel_actions__["d" /* openPanel */])());
                handleOptionClick();
            },
            hasSeparator: true,
        },
        _b[__WEBPACK_IMPORTED_MODULE_9__typings_menu__["a" /* CreateButtonOption */].publicationFromTemplate] = {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.create_from_template'),
            icon: 'iconset_uprez-create_publication_template',
            onClick: function () {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["m" /* showPublicationCreator */])(__WEBPACK_IMPORTED_MODULE_8__containers_PublicationCreator_reducer__["c" /* PublicationSource */].TEMPLATE));
                handleOptionClick();
            },
        },
        _b[__WEBPACK_IMPORTED_MODULE_9__typings_menu__["a" /* CreateButtonOption */].proposalFromFile] = {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.create_proposal_from_file'),
            icon: 'iconset_uprez-create_proposal_file',
            onClick: function () {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["m" /* showPublicationCreator */])(__WEBPACK_IMPORTED_MODULE_8__containers_PublicationCreator_reducer__["c" /* PublicationSource */].FILE));
                handleOptionClick();
            },
            hasSeparator: true,
        },
        _b[__WEBPACK_IMPORTED_MODULE_9__typings_menu__["a" /* CreateButtonOption */].importFile] = {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.import_file'),
            component: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ImportDesktopFile__["a" /* default */], { onClick: handleOptionClick }),
        },
        _b[__WEBPACK_IMPORTED_MODULE_9__typings_menu__["a" /* CreateButtonOption */].externalLink] = {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.create_external_link'),
            icon: 'iconset_uprez-create_ext_link',
            onClick: function () {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_ExternalLinkCreationPanel_actions__["d" /* openPanel */])());
                handleOptionClick();
            },
        },
        _b);
    if (options.length === 0) {
        return null;
    }
    var filteredConfig = Object.keys(config).reduce(function (acc, current) {
        if (options.includes(current)) {
            acc[current] = config[current];
        }
        return acc;
    }, {});
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Wrapper */], { ref: wrapperElement, position: position },
        position === __WEBPACK_IMPORTED_MODULE_9__typings_menu__["c" /* MenuPosition */].burger
            ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__MenuManager_Left_MenuItem_styles__["b" /* StyledMenuItem */], { isActive: isMenuDisplayed, onClick: function () { return setIsMenuDisplayed(function (prevState) { return !prevState; }); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__MenuManager_Left_MenuItem_styles__["c" /* StyledMenuItemLink */], null,
                    __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].getSvgIcon('iconset_plus'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.create" }))))
            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledButton */], { type: "button", isActive: isMenuDisplayed, onClick: function () { return setIsMenuDisplayed(function (prevState) { return !prevState; }); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.create" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__DropdownMenu__["a" /* default */], { config: filteredConfig, isDisplayed: isMenuDisplayed, position: position })));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonCreate);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_menu__ = __webpack_require__(40);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tmargin: ", ";\n\n\t> ul {\n\t\tmax-height: 300px;\n\t}\n\n\t", "\n\n\t@media ", " {\n\t\t", "\n\t}\n"], ["\n\tposition: relative;\n\tmargin: ", ";\n\n\t> ul {\n\t\tmax-height: 300px;\n\t}\n\n\t",
    "\n\n\t@media ", " {\n\t\t",
    "\n\t}\n"])), function (_a) {
    var position = _a.position;
    return position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].burger ? 0 : '0 10px';
}, function (_a) {
    var position = _a.position;
    return position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].burger
        ? "\n\t\t\t> ul {\n\t\t\t\tleft: 10px;\n\t\t\t\twidth: calc(100% - 20px);\n\t\t\t}\n\t\t"
        : "\n\t\t\t> ul {\n\t\t\t\tleft: " + (position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].right ? 'auto' : '-32px') + ";\n\t\t\t\tright: " + (position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].right ? 0 : 'auto') + ";\n\t\t\t}\n\t\t";
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, function (_a) {
    var position = _a.position;
    return position !== __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].burger && "\n\t\t\ttransform: scale(0.8) translateX(" + (position === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["c" /* MenuPosition */].right ? '12%' : '-12%') + ");\n\t\t";
});
var StyledButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 10px 40px 10px 20px;\n\tborder-radius: 20px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tbox-shadow: 0 0 1px 0 ", ",\n\t\t\t\t1px 2px 3px 0 ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 19px;\n\t\tright: 17px;\n\t\twidth: 14px;\n\t\theight: 2px;\n\t\tbackground-color: currentColor;\n\t}\n\n\t&::after {\n\t\ttransform: rotate(90deg);\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 10px 40px 10px 20px;\n\tborder-radius: 20px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tbackground-color: ",
    ";\n\tcolor: ", ";\n\tbox-shadow: 0 0 1px 0 ", ",\n\t\t\t\t1px 2px 3px 0 ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 19px;\n\t\tright: 17px;\n\t\twidth: 14px;\n\t\theight: 2px;\n\t\tbackground-color: currentColor;\n\t}\n\n\t&::after {\n\t\ttransform: rotate(90deg);\n\t}\n"])), function (props) { return props.isActive
    ? "" + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.iconsColor, 20)
    : "" + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.topnavColor, 40); }, function (props) { return props.theme.primary.iconsColor; }, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 29), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 17), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.iconsColor, 20); });

var templateObject_1, templateObject_2;


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile__ = __webpack_require__(1181);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile__["a" /* default */]));


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ImportManager__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DropdownMenu_styles__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);






var ImportDesktopFile = function (_a) {
    var onClick = _a.onClick, dispatch = _a.dispatch;
    var handleImport = function (files) {
        if (onClick) {
            onClick();
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_ImportManager_actions__["g" /* importDesktopFiles */])(files));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ImportManager__["a" /* default */], { id: "import-desktop-file", triggerComponent: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__DropdownMenu_styles__["b" /* StyledMenuButton */], { as: "div" },
            __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_import_file'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.import_file" })), isMultiple: true, customImportHandler: handleImport }));
};
/* harmony default export */ __webpack_exports__["a"] = (ImportDesktopFile);


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);




var ImportManager = function (_a) {
    var id = _a.id, triggerComponent = _a.triggerComponent, extensions = _a.extensions, isMultiple = _a.isMultiple, _b = _a.onImport, onImport = _b === void 0 ? function () { return undefined; } : _b, customImportHandler = _a.customImportHandler, fileType = _a.fileType, isOptimizedImageImport = _a.isOptimizedImageImport, isPublicationDependency = _a.isPublicationDependency, dispatch = _a.dispatch;
    var inputElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var isCorrectFileType = function (fileName, extensions) {
        if (!extensions) {
            return true;
        }
        var fileExtension = "." + __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getFileExtension(fileName);
        return extensions.includes(fileExtension.toLowerCase());
    };
    var handleChange = function (_a) {
        var files = _a.target.files;
        if (!files) {
            return;
        }
        var filesArray = Array.from(files);
        var validFiles = filesArray.filter(function (file) { return isCorrectFileType(file.name, extensions); });
        var isCorrectFileTypes = filesArray.every(function (file) { return isCorrectFileType(file.name, extensions); });
        if (customImportHandler) {
            customImportHandler(isMultiple ? validFiles : validFiles[0], isCorrectFileTypes);
        }
        else {
            if (isCorrectFileTypes) {
                filesArray.forEach(function (file) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_ImportManager_actions__["h" /* importFile */])({
                    id: id,
                    file: file,
                    onImport: onImport,
                    fileType: fileType,
                    isOptimizedImageImport: isOptimizedImageImport,
                    isPublicationDependency: isPublicationDependency,
                })); });
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_ImportManager_actions__["d" /* addFileInImport */])(id, {
                    id: id,
                    percentage: 100,
                    error: __WEBPACK_IMPORTED_MODULE_1__containers_ImportManager_actions__["a" /* FileError */].TYPE,
                }));
            }
        }
        if (inputElement.current) {
            inputElement.current.value = '';
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "file", ref: inputElement, id: id, multiple: isMultiple, 
            // on Android file dialog isn't opened if accept param is set
            accept: __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isAndroidApp() ? undefined : extensions, hidden: true, onChange: handleChange }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: id }, triggerComponent)));
};
/* harmony default export */ __webpack_exports__["a"] = (ImportManager);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MenuManager_Left_MenuItem_styles__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_menuManager__ = __webpack_require__(54);










var ButtonCreateNote = function (_a) {
    var isActive = _a.isActive, position = _a.position, iconSrc = _a.iconSrc, label = _a.label, dispatch = _a.dispatch;
    if (position === __WEBPACK_IMPORTED_MODULE_7__typings_menu__["c" /* MenuPosition */].burger) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__MenuManager_Left_MenuItem_styles__["b" /* StyledMenuItem */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["g" /* toggleNotesEditor */])()); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__MenuManager_Left_MenuItem_styles__["c" /* StyledMenuItemLink */], null,
                Object(__WEBPACK_IMPORTED_MODULE_9__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_uprez_write'),
                label || __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.create_note" }))));
    }
    var tooltipId = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].generateId();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { type: "button", isActive: isActive, "data-tip": true, "data-for": tooltipId, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["g" /* toggleNotesEditor */])()); } },
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_create_note'),
        __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isDesktop() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Tooltip__["a" /* default */], { id: tooltipId, text: label || 'messages.create_note' })));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonCreateNote);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuManager_Header_HeaderButton_styles__ = __webpack_require__(244);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__MenuManager_Header_HeaderButton_styles__["c" /* StyledHeaderButton */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\ttop: 1px;\n\tleft: 2px;\n"], ["\n\tposition: relative;\n\ttop: 1px;\n\tleft: 2px;\n"])));

var templateObject_1;


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuManager_Left_MenuItem_styles__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_menuManager__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MenuManager_Header_HeaderButton_styles__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_BackToPublication_actions__ = __webpack_require__(303);










var BackToPublication = function (_a) {
    var publicationId = _a.publicationId, page = _a.page, position = _a.position, iconSrc = _a.iconSrc, label = _a.label, dispatch = _a.dispatch;
    if (position === __WEBPACK_IMPORTED_MODULE_2__typings_menu__["c" /* MenuPosition */].burger) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MenuManager_Left_MenuItem_styles__["b" /* StyledMenuItem */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_BackToPublication_actions__["b" /* resumeLastPublication */])(publicationId, page)); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MenuManager_Left_MenuItem_styles__["c" /* StyledMenuItemLink */], null,
                Object(__WEBPACK_IMPORTED_MODULE_4__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_back_to_publication-bold'),
                label || __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.resuming" }))));
    }
    var tooltipId = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].generateId();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__MenuManager_Header_HeaderButton_styles__["c" /* StyledHeaderButton */], { type: "button", "data-tip": true, "data-for": tooltipId, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_BackToPublication_actions__["b" /* resumeLastPublication */])(publicationId, page)); } },
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_back_to_publication'),
        __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isDesktop() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Tooltip__["a" /* default */], { id: tooltipId, text: label || 'messages.resuming' })));
};
/* harmony default export */ __webpack_exports__["a"] = (BackToPublication);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_OfflineManager_reducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var I18n = __webpack_require__(5).I18n;
var Splashscreen = /** @class */ (function (_super) {
    __extends(Splashscreen, _super);
    function Splashscreen(props) {
        return _super.call(this, props) || this;
    }
    Splashscreen.prototype.render = function () {
        var _a = this.props, galleryInfos = _a.galleryInfos, offlineManager = _a.offlineManager, offlineManagerStatus = _a.offlineManagerStatus, display = _a.display, loadingTheme = _a.loadingTheme, loadingStatus = _a.loadingStatus, isMultiApp = _a.isMultiApp;
        var isInitError = offlineManagerStatus === __WEBPACK_IMPORTED_MODULE_2__containers_OfflineManager_reducer__["d" /* OfflineManagerStatus */].ERROR;
        var brandLogoUrl = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getBrandLogoUrl(galleryInfos, offlineManager, true, isMultiApp);
        var shouldDisplayLogo = galleryInfos.isLocalTemplateLoaded || galleryInfos.isRemoteTemplateLoaded;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* StyledSplashscreen */], { shouldDisplay: display, loadingTheme: loadingTheme },
            shouldDisplayLogo &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: brandLogoUrl }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* LoadingContainer */], null, !isInitError &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, loadingStatus))));
    };
    return Splashscreen;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var galleryInfos = state.galleryInfos, offlineManager = state.offlineManager, driveList = state.driveList, appInfos = state.appInfos;
    var fetchAllFetchStatus = driveList.fetchAllFetchStatus;
    var offlineManagerStatus = offlineManager.status;
    var isDownloadingThumbs = offlineManager.isDownloadingThumbs, isDownloadingRequiredItems = offlineManager.isDownloadingRequiredItems;
    var template = galleryInfos.template;
    var loadingTheme = {
        background: template && template.applicationSplash && template.applicationSplash.background ? template.applicationSplash.background : __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__["c" /* StyleColor */].White,
        color: template && template.applicationSplash && template.applicationSplash.spinnerWheelColor ? template.applicationSplash.spinnerWheelColor : __WEBPACK_IMPORTED_MODULE_6__utils_styles_constants__["c" /* StyleColor */].Black,
        logo: template && template.brand && template.brand.logoHome ? template.brand.logoHome : ''
    };
    var loadingStatus;
    if (fetchAllFetchStatus === __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_reducer__["a" /* FetchStatus */].FETCHING) {
        loadingStatus = I18n.t('messages.loading_fetch_content');
    }
    else if (isDownloadingRequiredItems) {
        loadingStatus = I18n.t('messages.loading_required_items');
    }
    else if (isDownloadingThumbs) {
        loadingStatus = I18n.t('messages.loading_thumbnails');
    }
    else {
        loadingStatus = I18n.t('messages.loading');
    }
    return {
        galleryInfos: galleryInfos,
        loadingTheme: loadingTheme,
        offlineManagerStatus: offlineManagerStatus,
        offlineManager: offlineManager,
        loadingStatus: loadingStatus,
        isMultiApp: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isMultiApp(appInfos)
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Splashscreen));


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledSplashscreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledSplashscreen = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 5;\n\tpadding: 20px;\n\tbackground: ", ";\n\tcolor: ", ";\n\ttransition: opacity 0.5s;\n\t", "\n\n\t& > img {\n\t\twidth: 100%;\n\t\tmax-width: 300px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 5;\n\tpadding: 20px;\n\tbackground: ", ";\n\tcolor: ", ";\n\ttransition: opacity 0.5s;\n\t",
    "\n\n\t& > img {\n\t\twidth: 100%;\n\t\tmax-width: 300px;\n\t}\n"])), function (props) { return props.loadingTheme.background; }, function (props) { return props.loadingTheme.color; }, function (props) {
    return props.shouldDisplay ?
        "opacity: 1;"
        :
            "opacity: 0;\n\t\t\tpointer-events: none;\n\t\t\t";
});
var LoadingContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\ttop: 85%;\n\twidth: 100%;\n\ttext-align: center;\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\ttop: 85%;\n\twidth: 100%;\n\ttext-align: center;\n"])));
var templateObject_1, templateObject_2;


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Authentication_reducer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Gallery_styles__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Gallery_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_MenuManager_Header_Logo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_iframeApi_ReaderApi__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_localStorage_manager__ = __webpack_require__(168);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

















var Authentication = /** @class */ (function (_super) {
    __extends(Authentication, _super);
    function Authentication(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSamlAuthentication = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var _a, dispatch, galleryInfos, authentication, config, forceSplashScreen, mode, _b, target, action, params, isOnCache;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, dispatch = _a.dispatch, galleryInfos = _a.galleryInfos, authentication = _a.authentication;
                        config = galleryInfos.config, forceSplashScreen = galleryInfos.forceSplashScreen;
                        mode = authentication.userInfos.mode;
                        _b = e.data, target = _b.target, action = _b.action, params = _b.params;
                        if (!(target === __WEBPACK_IMPORTED_MODULE_12__utils_iframeApi_ReaderApi__["b" /* PostMessageTarget */].GallApp)) return [3 /*break*/, 3];
                        if (!(action === __WEBPACK_IMPORTED_MODULE_12__utils_iframeApi_ReaderApi__["a" /* PostMessageAction */].Authentication && params)) return [3 /*break*/, 3];
                        isOnCache = __WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isOnCache(mode);
                        if (!params.success) return [3 /*break*/, 2];
                        if (!isOnCache) {
                            // The splashscreen is forced back to hide the redirection in the iframe (which is a browser version of the gallery)
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Gallery_actions__["g" /* setForceSplashscreen */])(true));
                        }
                        __WEBPACK_IMPORTED_MODULE_15__utils_localStorage_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery, params.login);
                        __WEBPACK_IMPORTED_MODULE_14__utils_indexedDB_manager__["a" /* default */].setGalleryPrefix(config.applicationGallery, params.login);
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__["f" /* updateCredentials */])({
                            login: params.login,
                            password: params.password
                        }));
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_7__containers_Gallery_actions__["d" /* migrateAppContainerLocalStorageToIndexedDB */])()];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (!isOnCache) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_NotificationBar_actions__["c" /* createNotification */])('error.login_or_password_incorrect'));
                            if (forceSplashScreen) {
                                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Gallery_actions__["g" /* setForceSplashscreen */])(false));
                            }
                        }
                        else {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__["f" /* updateCredentials */])({
                                mode: __assign({}, mode, { status: __WEBPACK_IMPORTED_MODULE_2__containers_Authentication_reducer__["a" /* ConnectionStatus */].NOT_CONNECTED, onCache: false })
                            }));
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_NotificationBar_actions__["c" /* createNotification */])('error.authentication_needed'));
                            __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].getPathAuthentication());
                        }
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleChangeLoginField = _this.handleChangeLoginField.bind(_this);
        _this.handleChangePasswordField = _this.handleChangePasswordField.bind(_this);
        _this.handleExcelAuthentication = _this.handleExcelAuthentication.bind(_this);
        _this.handleSamlAuthentication = _this.handleSamlAuthentication.bind(_this);
        _this.state = {
            iframeLocation: ''
        };
        return _this;
    }
    Authentication.prototype.componentWillMount = function () {
        var authentication = this.props.authentication;
        var mode = authentication.userInfos.mode;
        if (__WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isSaml(mode)) {
            window.addEventListener('message', this.handleSamlAuthentication);
        }
    };
    Authentication.prototype.componentDidMount = function () {
        var authentication = this.props.authentication;
        var _a = authentication.userInfos, mode = _a.mode, needCredentials = _a.needCredentials;
        if (!needCredentials || __WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isConnected(mode)) {
            __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].getPathDefault());
        }
    };
    Authentication.prototype.componentWillUnmount = function () {
        var authentication = this.props.authentication;
        var mode = authentication.userInfos.mode;
        if (__WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isSaml(mode)) {
            window.removeEventListener('message', this.handleSamlAuthentication);
        }
    };
    Authentication.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, dispatch = _a.dispatch, authentication = _a.authentication, galleryInfos = _a.galleryInfos;
        var mode = authentication.userInfos.mode;
        if (__WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isSaml(mode)) {
            // Okta redirects to the homepage (in the iframe) after the session cookie is set
            // The redirection needs to be completed before further calls to the ASP are made
            if (__WEBPACK_IMPORTED_MODULE_13__utils_url__["b" /* default */].isSamlIframeRedirectionUrl(nextState.iframeLocation, galleryInfos.config)) {
                var isOnCache = __WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isOnCache(mode);
                if (!isOnCache) {
                    var updatedMode = __assign({}, mode, { status: isOnCache ? __WEBPACK_IMPORTED_MODULE_2__containers_Authentication_reducer__["a" /* ConnectionStatus */].CONNECTED : __WEBPACK_IMPORTED_MODULE_2__containers_Authentication_reducer__["a" /* ConnectionStatus */].CONNECTING, onCache: isOnCache ? false : undefined });
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__["f" /* updateCredentials */])({ mode: updatedMode }));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Gallery_actions__["c" /* initializeGallery */])());
                }
            }
        }
    };
    Authentication.prototype.handleExcelAuthentication = function (e) {
        e.preventDefault();
        var _a = this.props, dispatch = _a.dispatch, authentication = _a.authentication;
        if (!__WEBPACK_IMPORTED_MODULE_8__utils_userAgent__["a" /* default */].isOnline()) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_NotificationBar_actions__["c" /* createNotification */])('info.offline_login'));
            return;
        }
        var form = authentication.form;
        var login = form.login, password = form.password;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__["d" /* sendAuthentication */])(login, password));
    };
    Authentication.prototype.handleChangeLoginField = function (e) {
        var dispatch = this.props.dispatch;
        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__["a" /* AuthenticationActionKeys */].SET_FORM_LOGIN,
            value: e.currentTarget.value
        });
    };
    Authentication.prototype.handleChangePasswordField = function (e) {
        var dispatch = this.props.dispatch;
        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_3__containers_Authentication_actions__["a" /* AuthenticationActionKeys */].SET_FORM_PASSWORD,
            value: e.currentTarget.value
        });
    };
    Authentication.prototype.render = function () {
        var _this = this;
        var _a = this.props, authentication = _a.authentication, origin = _a.origin;
        var form = authentication.form, _b = authentication.userInfos, mode = _b.mode, login = _b.login, password = _b.password;
        var iframeParams = __WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].needReconnecting(mode) ? "?user=" + login + "&pass=" + password : ''; // Params are added in case of an automated reauthentication on IOS
        var iframeOrigin = origin === __WEBPACK_IMPORTED_MODULE_1__styles__["j" /* SamlIframeOrigin */].App ? __WEBPACK_IMPORTED_MODULE_1__styles__["j" /* SamlIframeOrigin */].App : __WEBPACK_IMPORTED_MODULE_1__styles__["j" /* SamlIframeOrigin */].Authentication;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["k" /* StyledAuthentication */], null, __WEBPACK_IMPORTED_MODULE_11__utils_authentication__["a" /* default */].isSaml(mode)
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* SamlAuthenticationIframe */], { origin: iframeOrigin, src: __WEBPACK_IMPORTED_MODULE_13__utils_url__["b" /* default */].getSamlAuthenticationPage(iframeParams), ref: function (iframe) {
                    if (iframe) {
                        _this.iframeElement = iframe;
                    }
                }, onLoad: function () {
                    // Change of location in iframe needs to be recorded to know if the redirection has been completed
                    if (_this.iframeElement.contentWindow) {
                        _this.setState({ iframeLocation: _this.iframeElement.contentWindow.location.href });
                    }
                } })
            : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* ExcelAuthenticationContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* AuthenticationHeader */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__containers_MenuManager_Header_Logo__["a" /* default */], null)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_Gallery_styles__["c" /* Page */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* AuthenticationContent */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* AuthenticationForm */], { onSubmit: this.handleExcelAuthentication },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* AuthenticationInputWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* AuthenticateFormInput */], { value: form.login, onChange: this.handleChangeLoginField, required: true, type: "text", key: "login", ref: function (ref) {
                                        if (ref) {
                                            ref.setAttribute('autocorrect', 'none');
                                            ref.setAttribute('autocapitalize', 'off');
                                            ref.setAttribute('spellcheck', 'false');
                                        }
                                    }, placeholder: __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["I18n"].t('messages.placeholder_login') })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* AuthenticationInputWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* AuthenticateFormInput */], { value: form.password, onChange: this.handleChangePasswordField, required: true, type: "password", key: "password", placeholder: __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["I18n"].t('messages.placeholder_password') })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* AuthenticationButtonWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* AuthenticateButton */], { type: "submit" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "messages.connect" })))))))));
    };
    return Authentication;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Authentication);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageOverlay_styles__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DownloadAllPopupContent__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_driveItem__ = __webpack_require__(11);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};












var DownloadAllPopup = /** @class */ (function (_super) {
    __extends(DownloadAllPopup, _super);
    function DownloadAllPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.close = _this.close.bind(_this);
        _this.startDownloadAll = _this.startDownloadAll.bind(_this);
        _this.onCheckboxChange = _this.onCheckboxChange.bind(_this);
        _this.state = {
            isDontAskMeAgainChecked: false,
        };
        return _this;
    }
    DownloadAllPopup.prototype.close = function () {
        var dispatch = this.props.dispatch;
        var isDontAskMeAgainChecked = this.state.isDontAskMeAgainChecked;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* closeDownloadAllPopup */])(isDontAskMeAgainChecked));
    };
    DownloadAllPopup.prototype.onCheckboxChange = function (e) {
        this.setState({
            isDontAskMeAgainChecked: e.target.checked
        });
    };
    DownloadAllPopup.prototype.startDownloadAll = function () {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions__["e" /* downloadAll */])());
        this.close();
    };
    DownloadAllPopup.prototype.render = function () {
        var e_1, _a;
        var _b = this.props, appInfos = _b.appInfos, galleryInfos = _b.galleryInfos, offlineManager = _b.offlineManager, closedByUser = _b.downloadAllPopup.closedByUser, downloadManager = _b.downloadManager, driveList = _b.driveList;
        var isDontAskMeAgainChecked = this.state.isDontAskMeAgainChecked;
        var isGalleryReady = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* default */].isGalleryReady(galleryInfos, offlineManager, appInfos);
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isMobileApp;
        var config = galleryInfos.config;
        var driveItems = driveList.driveItems;
        var items = downloadManager.items;
        var downloadedIds = Object.keys(items)
            .filter(function (key) { return items[Number(key)].mode === __WEBPACK_IMPORTED_MODULE_8__DownloadManager_reducer__["c" /* DownloadMode */].Requested; })
            .map(Number);
        var hasUpdatableDependencies = false;
        if (downloadedIds.length > 0) {
            try {
                for (var downloadedIds_1 = __values(downloadedIds), downloadedIds_1_1 = downloadedIds_1.next(); !downloadedIds_1_1.done; downloadedIds_1_1 = downloadedIds_1.next()) {
                    var id = downloadedIds_1_1.value;
                    hasUpdatableDependencies = __WEBPACK_IMPORTED_MODULE_11__utils_driveItem__["d" /* default */].hasUpdatableDependencies(driveItems[id], downloadManager);
                    if (hasUpdatableDependencies) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (downloadedIds_1_1 && !downloadedIds_1_1.done && (_a = downloadedIds_1.return)) _a.call(downloadedIds_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var isEnabled = config && config.downloadAllPopup && config.downloadAllPopup.enabled === true;
        var hasItemsToDownload = __WEBPACK_IMPORTED_MODULE_7__utils_downloadManager__["a" /* default */].hasItemsToDownload(downloadManager, driveList, galleryInfos, []);
        var isOnline = __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isOnline();
        var isPopupOpened = isMobileApp
            && isGalleryReady && !galleryInfos.forceSplashScreen
            && (hasItemsToDownload || hasUpdatableDependencies)
            && !closedByUser
            && isEnabled
            && isOnline;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* StyledDownloadAllPopup */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_PageOverlay_styles__["a" /* PageOverlay */], { isOpen: isPopupOpened, onClick: this.close }),
            isPopupOpened && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_DownloadAllPopupContent__["a" /* default */], { startDownloadAll: this.startDownloadAll, isDontAskMeAgainChecked: isDontAskMeAgainChecked, onCheckboxChange: this.onCheckboxChange, close: this.close })));
    };
    return DownloadAllPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var appInfos = state.appInfos, galleryInfos = state.galleryInfos, offlineManager = state.offlineManager, downloadAllPopup = state.downloadAllPopup, driveList = state.driveList, downloadManager = state.downloadManager;
    return { appInfos: appInfos, galleryInfos: galleryInfos, offlineManager: offlineManager, downloadAllPopup: downloadAllPopup, driveList: driveList, downloadManager: downloadManager };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DownloadAllPopup));


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DownloadAllPopupContent = /** @class */ (function (_super) {
    __extends(DownloadAllPopupContent, _super);
    function DownloadAllPopupContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DownloadAllPopupContent.prototype.render = function () {
        var _a = this.props, close = _a.close, onCheckboxChange = _a.onCheckboxChange, startDownloadAll = _a.startDownloadAll, isDontAskMeAgainChecked = _a.isDontAskMeAgainChecked;
        var checkboxName = 'dontAskMeAgainCheckbox';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* StyledDownloadAllPopupContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* DownloadAllPopupClose */], { onClick: close }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_close-1')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* DownloadAllPopupLabel */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.new_content_available_start_download" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* StartDownloadAllButton */], { onClick: startDownloadAll },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.start_to_download" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* KeepForLaterButton */], { onClick: close },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.keep_it_for_later" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* DontAskMeAgainContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", checked: isDontAskMeAgainChecked, onChange: onCheckboxChange, id: checkboxName }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* DontAskMeAgainLabel */], { htmlFor: checkboxName },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.dont_ask_me_again" })))));
    };
    return DownloadAllPopupContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DownloadAllPopupContent);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledDownloadAllPopupContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DownloadAllPopupClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DownloadAllPopupLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StartDownloadAllButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return KeepForLaterButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DontAskMeAgainContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DontAskMeAgainLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_styles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledDownloadAllPopupContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 100px 65px 90px 65px;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 12;\n\talign-items: center;\n\n\tposition: relative;\n\tpointer-events: auto;\n"], ["\n\tpadding: 100px 65px 90px 65px;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 12;\n\talign-items: center;\n\n\tposition: relative;\n\tpointer-events: auto;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White);
var DownloadAllPopupClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 30px;\n\tright: 30px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 19px;\n\t\theight: 19px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 30px;\n\tright: 30px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 19px;\n\t\theight: 19px;\n\t}\n"])));
var DownloadAllPopupLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tcolor: ", ";\n\tmargin-bottom: 35px;\n"], ["\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tcolor: ", ";\n\tmargin-bottom: 35px;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey800);
var StartDownloadAllButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Button_styles__["a" /* BigButton */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-bottom: 30px;\n"], ["\n\tmargin-bottom: 30px;\n"])));
var KeepForLaterButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Button_styles__["a" /* BigButton */])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tmargin-bottom: 30px;\n"], ["\n\tbackground-color: ", ";\n\tmargin-bottom: 30px;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Green);
var DontAskMeAgainContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin-right: auto;\n"], ["\n\tmargin-right: auto;\n"])));
var DontAskMeAgainLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('label')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin-left: 10px;\n\tuser-select: none;\n"], ["\n\tmargin-left: 10px;\n\tuser-select: none;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDownloadAllPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledDownloadAllPopup = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpointer-events: none;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpointer-events: none;\n"])));
var templateObject_1;


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_WebpublicationForm__ = __webpack_require__(1194);


var mapStateToProps = function (state) {
    var sharePanel = state.sharePanel;
    var selectedResources = sharePanel.selectedResources, isOpen = sharePanel.isOpen, isProcessing = sharePanel.isProcessing, form = sharePanel.form;
    return { selectedResources: selectedResources, isOpen: isOpen, isProcessing: isProcessing, form: form };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Share_WebpublicationForm__["a" /* default */]));


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PageOverlay_styles__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var I18n = __webpack_require__(5).I18n;
var WebpublicationShareForm = /** @class */ (function (_super) {
    __extends(WebpublicationShareForm, _super);
    function WebpublicationShareForm(props) {
        var _this = _super.call(this, props) || this;
        _this.closePanel = function () {
            var dispatch = _this.props.dispatch;
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__["b" /* SharePanelActionKeys */].CLOSE_PANEL });
        };
        _this.closePanel = _this.closePanel.bind(_this);
        _this.handleChangeFormField = _this.handleChangeFormField.bind(_this);
        _this.handleSendForm = _this.handleSendForm.bind(_this);
        return _this;
    }
    WebpublicationShareForm.prototype.handleChangeFormField = function (name) {
        var _this = this;
        return function (e) {
            var dispatch = _this.props.dispatch;
            dispatch({
                type: __WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__["b" /* SharePanelActionKeys */].SET_FORM_FIELD,
                name: name,
                value: e.currentTarget.value
            });
        };
    };
    WebpublicationShareForm.prototype.handleSendForm = function (e) {
        e.preventDefault();
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__["l" /* shareItems */])());
    };
    WebpublicationShareForm.prototype.render = function () {
        var isOpen = this.props.isOpen;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__PageOverlay_styles__["a" /* PageOverlay */], { isOpen: isOpen, onClick: this.closePanel }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["s" /* StyledSharePanel */], { isOpen: isOpen },
                this.renderHeader(),
                this.renderContent())));
    };
    WebpublicationShareForm.prototype.renderHeader = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["o" /* SharePanelHeader */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["q" /* SharePanelHeaderContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["r" /* SharePanelHeaderTitle */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.share_my_selection" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["p" /* SharePanelHeaderClose */], { onClick: this.closePanel },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.close" })))));
    };
    WebpublicationShareForm.prototype.renderContent = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* SharePanelContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* SharePanelContentContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["l" /* SharePanelContentSelection */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["n" /* SharePanelContentSelectionTitle */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.my_selection" })),
                    this.renderSelectionContent()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["k" /* SharePanelContentRight */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* SharePanelContentForm */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["j" /* SharePanelContentFormTitle */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.share_by_email" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* SharePanelContentFormContent */], { onSubmit: this.handleSendForm },
                            this.renderFormLeft(),
                            this.renderFormRight()))))));
    };
    WebpublicationShareForm.prototype.renderSelectionContent = function () {
        var selectedResources = this.props.selectedResources;
        return selectedResources.map(function (driveItem, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["m" /* SharePanelContentSelectionContent */], { key: index }, __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__["d" /* default */].getDisplayName(driveItem))); });
    };
    WebpublicationShareForm.prototype.renderFormLeft = function () {
        var form = this.props.form;
        var userName = form.userName, userEmail = form.userEmail, contactEmail = form.contactEmail;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* SharePanelContentFormContentLeft */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ShareInput */], { value: userName, onChange: this.handleChangeFormField('userName'), placeholder: I18n.t('messages.placeholder_share_name'), required: true, type: "text", key: "userName" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ShareInput */], { value: userEmail, onChange: this.handleChangeFormField('userEmail'), placeholder: I18n.t('messages.placeholder_share_user_email'), required: true, type: "email", key: "userEmail" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* ShareInputLast */], { value: contactEmail, onChange: this.handleChangeFormField('contactEmail'), placeholder: I18n.t('messages.placeholder_share_contact_email'), required: true, type: "email", key: "contactEmail" })));
    };
    WebpublicationShareForm.prototype.renderFormRight = function () {
        var _a = this.props, form = _a.form, isProcessing = _a.isProcessing;
        var message = form.message;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* SharePanelContentFormContentRight */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Form_styles__["b" /* TextArea */], { value: message, onChange: this.handleChangeFormField('message'), placeholder: I18n.t('messages.placeholder_share_message'), required: true, key: "message" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ShareButton */], { type: "submit", disabled: isProcessing },
                isProcessing && __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.send_my_selection" }))));
    };
    return WebpublicationShareForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WebpublicationShareForm);


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return StyledSharePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SharePanelHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SharePanelHeaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SharePanelHeaderTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SharePanelHeaderClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SharePanelContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SharePanelContentContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SharePanelContentSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SharePanelContentSelectionTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SharePanelContentSelectionContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SharePanelContentRight; });
/* unused harmony export SharePanelContentRightMethods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SharePanelContentForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SharePanelContentFormTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SharePanelContentFormContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SharePanelContentFormContentLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SharePanelContentFormContentRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShareInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ShareInputLast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Button_styles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var panelHeight = 470;
var panelHeightSmartphone = 800;
var statusBarHeight = 20;
var panelAndShadowHeightSmartphone = panelHeightSmartphone + 2 + statusBarHeight;
var StyledSharePanel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tbox-shadow: ", " 1px 1px 1px;\n\theight: ", "px;\n\twidth: 100%;\n\tposition: absolute;\n\ttop: ", "px;\n\tz-index: 15;\n\ttransition: top 0.4s;\n\t/*\n\tpanelAndShadowHeightSmartphone is used for the top property because of visual bug :\n\tthe panel was appearing for 0.1s when resizing window width from 1200px to 1199px\n\t*/\n\n\t@media ", ", ", ", ", " {\n\t\ttop: ", "px;\n\t\theight: 100%;\n\t\tmax-height:", "px;\n\t}\n\n\t@media print {\n\t\t", ";\n\t}\n"], ["\n\tbackground-color: ", ";\n\tbox-shadow: ", " 1px 1px 1px;\n\theight: ", "px;\n\twidth: 100%;\n\tposition: absolute;\n\ttop: ", "px;\n\tz-index: 15;\n\ttransition: top 0.4s;\n\t/*\n\tpanelAndShadowHeightSmartphone is used for the top property because of visual bug :\n\tthe panel was appearing for 0.1s when resizing window width from 1200px to 1199px\n\t*/\n\n\t@media ", ", ", ", ", " {\n\t\ttop: ", "px;\n\t\theight: 100%;\n\t\tmax-height:", "px;\n\t}\n\n\t@media print {\n\t\t", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey300, panelHeight, function (props) { return props.isOpen ? 0 : '-' + panelAndShadowHeightSmartphone; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop, function (props) { return props.isOpen ? 0 : '-' + panelAndShadowHeightSmartphone; }, panelHeightSmartphone, function (props) { return props.isOpen ? 'top: 0' : 'display: none'; });
var SharePanelHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: ", ";\n\twidth: 100%;\n\tborder-bottom: 1px solid ", ";\n"], ["\n\theight: ", ";\n\twidth: 100%;\n\tborder-bottom: 1px solid ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey300);
var SharePanelHeaderContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin: 0 90px;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\n\t@media ", " {\n\t\tmargin: 0 45px;\n\t}\n"], ["\n\tmargin: 0 90px;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\n\t@media ", " {\n\t\tmargin: 0 45px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var SharePanelHeaderTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tcolor: ", ";\n"], ["\n\tflex-grow: 1;\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey700);
var SharePanelHeaderClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tcolor: ", ";\n\tcursor: pointer;\n\tfont-weight: regular;\n"], ["\n\tfont-size: 13px;\n\tcolor: ", ";\n\tcursor: pointer;\n\tfont-weight: regular;\n"])), function (props) { return props.theme.primary.actionColor; });
var SharePanelContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\theight: 425px;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t-webkit-overflow-scrolling: touch;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\n\t@media ", ", ", ", ", " {\n\t\theight: calc( 100% - 45px );\n\t\tmax-height: 760px;\n\t}\n"], ["\n\theight: 425px;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t-webkit-overflow-scrolling: touch;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\n\t@media ", ", ", ", ", " {\n\t\theight: calc( 100% - 45px );\n\t\tmax-height: 760px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\twidth: 1140px;\n\theight: 300px;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t@media ", ", ", ", ", " {\n\t\tflex-direction: column;\n\t\talign-self: flex-start;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tmargin-top: 25px;\n\t\tmargin-left: 35px;\n\t\tmargin-right: 35px;\n\t\twidth: calc(100% - 70px);\n\t\tmax-width: 710px;\n\t}\n"], ["\n\twidth: 1140px;\n\theight: 300px;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t@media ", ", ", ", ", " {\n\t\tflex-direction: column;\n\t\talign-self: flex-start;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tmargin-top: 25px;\n\t\tmargin-left: 35px;\n\t\tmargin-right: 35px;\n\t\twidth: calc(100% - 70px);\n\t\tmax-width: 710px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentSelection = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tpadding: 35px 30px;\n\twidth:360px;\n\toverflow-y: auto;\n\t-webkit-overflow-scrolling: touch;\n\n\t@media ", ", ", ", ", " {\n\t\twidth: calc(100% - 60px);\n\t}\n"], ["\n\tbackground-color: ", ";\n\tpadding: 35px 30px;\n\twidth:360px;\n\toverflow-y: auto;\n\t-webkit-overflow-scrolling: touch;\n\n\t@media ", ", ", ", ", " {\n\t\twidth: calc(100% - 60px);\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentSelectionTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\ttext-transform: uppercase;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\tmargin-bottom: 20px;\n"], ["\n\ttext-transform: uppercase;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\tmargin-bottom: 20px;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey500);
var SharePanelContentSelectionContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n"], ["\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);
var SharePanelContentRight = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\twidth: 710px;\n\tmargin-left:30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-left: 0;\n\t\twidth: 100%;\n\t}\n"], ["\n\twidth: 710px;\n\tmargin-left:30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-left: 0;\n\t\twidth: 100%;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentRightMethods = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tmin-height: 60px;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-top: 20px;\n\t\tjustify-content: space-around;\n\t}\n\t@media ", " {\n\t\tmin-height: 35px;\n\t}\n"], ["\n\tmin-height: 60px;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-top: 20px;\n\t\tjustify-content: space-around;\n\t}\n\t@media ", " {\n\t\tmin-height: 35px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var SharePanelContentForm = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tmargin-top: 30px;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-top: 0;\n\t}\n"], ["\n\tmargin-top: 30px;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-top: 0;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentFormTitle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\tmargin-bottom: 20px;\n\theight: 20px;\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\n\t@media ", ", ", ", ", " {\n\t\tmargin: 20px 0;\n\t\tfont-size: 20px;\n\t\tfont-weight: 400;\n\t}\n"], ["\n\tmargin-bottom: 20px;\n\theight: 20px;\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tcolor: ", ";\n\n\t@media ", ", ", ", ", " {\n\t\tmargin: 20px 0;\n\t\tfont-size: 20px;\n\t\tfont-weight: 400;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey700, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentFormContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('form')(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t@media ", ", ", ", ", " {\n\t\tflex-direction: column;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t@media ", ", ", ", ", " {\n\t\tflex-direction: column;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentFormContentLeft = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 360px;\n\n\t@media ", ", ", ", ", " {\n\t\twidth: 100%;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 360px;\n\n\t@media ", ", ", ", ", " {\n\t\twidth: 100%;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var SharePanelContentFormContentRight = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 360px;\n\tmargin-left: 30px;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-left: 0;\n\t\twidth: 100%;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 360px;\n\tmargin-left: 30px;\n\n\t@media ", ", ", ", ", " {\n\t\tmargin-left: 0;\n\t\twidth: 100%;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop);
var ShareInput = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__components_Form_styles__["a" /* Input */])(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n\tmargin-bottom: 10px;\n"], ["\n\tmargin-bottom: 10px;\n"])));
var ShareInputLast = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__components_Form_styles__["a" /* Input */])(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n\tmargin-bottom: 0px;\n"], ["\n\tmargin-bottom: 0px;\n"])));
var ShareButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__components_Button_styles__["b" /* Button */])(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmargin: 10px 0 0 0;\n\tmax-height: 50px;\n\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\n\t@media ", ", ", ", ", " {\n\t\talign-self: center;\n\t\twidth: 260px;\n\t\tmax-width: 260px;\n\t\theight: 60px;\n\t\tmargin: 25px 0;\n\t}\n\n\t&:disabled {\n\t\tcolor: ", ";\n\t\tborder-color: ", ";\n\t\tbackground-color: transparent;\n\t}\n\n\t&:disabled svg {\n\t\tmargin-left: 10px;\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tanimation: ", ";\n\t}\n"], ["\n\tborder-color: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tmargin: 10px 0 0 0;\n\tmax-height: 50px;\n\n\t@media (hover: hover) {\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\n\t@media ", ", ", ", ", " {\n\t\talign-self: center;\n\t\twidth: 260px;\n\t\tmax-width: 260px;\n\t\theight: 60px;\n\t\tmargin: 25px 0;\n\t}\n\n\t&:disabled {\n\t\tcolor: ", ";\n\t\tborder-color: ", ";\n\t\tbackground-color: transparent;\n\t}\n\n\t&:disabled svg {\n\t\tmargin-left: 10px;\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tanimation: ", ";\n\t}\n"])), function (props) { return props.theme.primary.actionColor; }, function (props) { return props.theme.primary.actionColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return props.theme.primary.actionColor; }, function (props) { return props.theme.primary.actionColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey400, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey400, __WEBPACK_IMPORTED_MODULE_4__utils_style__["e" /* spin */]);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};







var mapStateToProps = function (state) {
    var sharePanel = state.sharePanel, routerParamsHistory = state.routerParamsHistory, profile = state.profile;
    var form = sharePanel.form, isOpen = sharePanel.isOpen, isShareActionsPopupOpen = sharePanel.isShareActionsPopupOpen, isProcessing = sharePanel.isProcessing, isPublicationShare = sharePanel.isPublicationShare, selectedResources = sharePanel.selectedResources, selectedNotes = sharePanel.selectedNotes, foldersContent = sharePanel.foldersContent, callbackAction = sharePanel.callbackAction;
    var isCreateDealAvailable = __spread(selectedResources, foldersContent).some(function (item) { return (__WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].isProposal(item.format)); });
    var currentRoute = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentRoute(routerParamsHistory);
    var isEditorOpened = currentRoute.includes(__WEBPACK_IMPORTED_MODULE_4__routes_constants__["a" /* RoutePath */].Editor);
    return {
        form: form,
        selectedResources: selectedResources,
        selectedNotes: selectedNotes,
        isOpen: isOpen,
        isShareActionsPopupOpen: isShareActionsPopupOpen && !isPublicationShare,
        isProcessing: isProcessing,
        isCreateDealAvailable: isCreateDealAvailable,
        actionButtonColor: isEditorOpened ? __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["c" /* StyleColor */].Blue600 : '',
        isReadOnlyApp: __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].isReadOnlyApp(profile.role),
        callbackAction: callbackAction,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm__["a" /* default */]));


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Share_SharedDocuments__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Share_SharedNotes__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HeaderBlock__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Share_UprezForm_Field__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ShareActionPopup__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Share_UprezForm_ShareViaCopyPopup__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Form_Switch__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__typings_api__ = __webpack_require__(10);
















var headerFields = [
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Email,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Subject,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Message
];
var contactFields = [
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Firstname,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Surname,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Company,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Email,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Phone,
    __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Position
];
var UprezShareForm = function (_a) {
    var form = _a.form, selectedResources = _a.selectedResources, selectedNotes = _a.selectedNotes, isOpen = _a.isOpen, isShareActionsPopupOpen = _a.isShareActionsPopupOpen, isProcessing = _a.isProcessing, isCreateDealAvailable = _a.isCreateDealAvailable, actionButtonColor = _a.actionButtonColor, isReadOnlyApp = _a.isReadOnlyApp, callbackAction = _a.callbackAction, dispatch = _a.dispatch;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isOpen && !isReadOnlyApp) {
            __WEBPACK_IMPORTED_MODULE_14__utils_api__["a" /* default */].getCrmAccounts()
                .then(function (crmContacts) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["i" /* setCrmContacts */])(crmContacts)); })
                .catch(function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["i" /* setCrmContacts */])([])); });
        }
    }, [isOpen, isReadOnlyApp]);
    var handleSendForm = function (e) {
        e.preventDefault();
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["l" /* shareItems */])());
    };
    var renderFields = function (fields, isHeader) {
        return fields.map(function (field, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__containers_Share_UprezForm_Field__["a" /* default */], { key: "" + name + index, fieldName: field, isHeader: isHeader })); });
    };
    var handleCreateDealChange = function () {
        var createDeal = form.createDeal;
        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["b" /* SharePanelActionKeys */].SET_FORM_FIELD,
            name: __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].CreateDeal,
            value: !createDeal,
        });
    };
    var handleShareViaCopy = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["g" /* initiateShare */])(selectedResources, false, __WEBPACK_IMPORTED_MODULE_15__typings_api__["a" /* Api */].ShareNetwork.Copy, callbackAction));
    };
    var handleShareViaUprez = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["c" /* closeShareActionsPopup */])());
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["g" /* initiateShare */])(selectedResources, false, __WEBPACK_IMPORTED_MODULE_15__typings_api__["a" /* Api */].ShareNetwork.Uprez, callbackAction));
    };
    var contactEmail = form.contactEmail, createDeal = form.createDeal;
    var hasMultipleContacts = contactEmail.includes(',');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ShareActionPopup__["a" /* default */], { isDisplayed: isShareActionsPopupOpen, isProcessing: isProcessing, onShareViaCopy: handleShareViaCopy, onShareViaUprez: handleShareViaUprez, onCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["c" /* closeShareActionsPopup */])(true)); } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__containers_Share_UprezForm_ShareViaCopyPopup__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["l" /* SharePanelContainer */], { isOpen: isOpen },
            isProcessing &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["k" /* Loader */], null,
                    __WEBPACK_IMPORTED_MODULE_13__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Form */], { onSubmit: handleSendForm },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* FormHeader */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonCancel */], { type: "button", onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["f" /* finishShare */])()); }, color: actionButtonColor },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
                    isCreateDealAvailable && !isReadOnlyApp &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Form_Switch__["a" /* default */], { name: "createDeal", isActive: createDeal, style: {
                                activeColor: actionButtonColor,
                            }, onChange: handleCreateDealChange, label: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["m" /* SwitchLabel */], { value: "messages.create_deal_in_crm", dangerousHTML: true })) }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonSend */], { type: "submit", disabled: isProcessing, color: actionButtonColor },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.send" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* FormBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* FormBodyInner */], null,
                        renderFields(headerFields, true),
                        !hasMultipleContacts &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Accordion__["a" /* default */], { title: "share." + __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Contact, isOpened: false }, renderFields(contactFields, false)),
                        selectedResources.length > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* DocumentsBlock */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__HeaderBlock__["a" /* default */], { title: "share." + __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Documents }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_Share_SharedDocuments__["a" /* default */], null)),
                        selectedNotes.length > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* DocumentsBlock */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__HeaderBlock__["a" /* default */], { title: "share." + __WEBPACK_IMPORTED_MODULE_3__typings__["a" /* FormField */].Notes }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_Share_SharedNotes__["a" /* default */], null))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (UprezShareForm);


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledAccordion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AccordionTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ToggleButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderBlock_styles__ = __webpack_require__(341);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledAccordion = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\tmargin: 4px 0;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\tmargin: 4px 0;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), function (props) { return props.theme.primary.strongColor; });
var AccordionHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__HeaderBlock_styles__["a" /* HeaderBlockContainer */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding-right: 15px;\n"], ["\n\tpadding-right: 15px;\n"])));
var AccordionTitle = __WEBPACK_IMPORTED_MODULE_2__HeaderBlock_styles__["b" /* HeaderBlockTitle */];
var ToggleButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t& > svg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n\n\t", "\n"], ["\n\t& > svg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n\n\t", "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey600, function (props) { return props.isOpened ? '' : "transform: rotate(-90deg);"; });

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_SharedDocuments__ = __webpack_require__(1200);


var mapStateToProps = function (state) {
    var selectedResources = state.sharePanel.selectedResources;
    return { selectedResources: selectedResources };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Share_SharedDocuments__["a" /* default */]));


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);



var SharedDocuments = function (_a) {
    var selectedResources = _a.selectedResources;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Container */], null, selectedResources.map(function (driveItem) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Content */], { key: driveItem.id }, __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getDisplayName(driveItem))); })));
};
/* harmony default export */ __webpack_exports__["a"] = (SharedDocuments);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_SharedNotes__ = __webpack_require__(1202);


var mapStateToProps = function (state) {
    var selectedNotes = state.sharePanel.selectedNotes;
    return { selectedNotes: selectedNotes };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Share_SharedNotes__["a" /* default */]));


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SharedDocuments_styles__ = __webpack_require__(546);


var SharedNotes = function (_a) {
    var selectedNotes = _a.selectedNotes;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SharedDocuments_styles__["a" /* Container */], null, selectedNotes.map(function (_a) {
        var id = _a.id, title = _a.title;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SharedDocuments_styles__["b" /* Content */], { key: id }, title));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (SharedNotes);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(341);



var HeaderBlock = function (props) {
    var title = props.title, subtitle = props.subtitle;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* HeaderBlockContainer */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* HeaderBlockTitle */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Title */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: title })),
            subtitle &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* Subtitle */], null, subtitle))));
};
/* harmony default export */ __webpack_exports__["a"] = (HeaderBlock);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm_Field__ = __webpack_require__(1205);


var mapStateToProps = function (state, props) {
    var sharePanel = state.sharePanel;
    var form = sharePanel.form, isOpen = sharePanel.isOpen, crmContacts = sharePanel.crmContacts;
    var fieldName = props.fieldName;
    return { fieldValue: form[fieldName], isOpen: isOpen, crmContacts: crmContacts };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm_Field__["a" /* default */]));


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Share_UprezForm_CrmAutocompleteChoices__ = __webpack_require__(1206);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var UprezShareFormField = /** @class */ (function (_super) {
    __extends(UprezShareFormField, _super);
    function UprezShareFormField(props) {
        var _this = _super.call(this, props) || this;
        _this.fillField = _this.fillField.bind(_this);
        _this.state = {
            hasFocus: false
        };
        return _this;
    }
    UprezShareFormField.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, dispatch = _a.dispatch, fieldName = _a.fieldName, isOpen = _a.isOpen;
        var fieldIsMessage = fieldName === __WEBPACK_IMPORTED_MODULE_1__typings__["a" /* FormField */].Message;
        if (fieldIsMessage && !prevProps.isOpen && isOpen) {
            dispatch({
                type: __WEBPACK_IMPORTED_MODULE_2__containers_Share_actions__["b" /* SharePanelActionKeys */].SET_FORM_FIELD,
                name: __WEBPACK_IMPORTED_MODULE_1__typings__["a" /* FormField */].Message,
                value: __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["I18n"].t('share.email_greeting') + "\r" + __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["I18n"].t('share.email_body')
            });
        }
    };
    UprezShareFormField.prototype.handleFocus = function (hasFocus) {
        var _this = this;
        if (hasFocus) {
            clearTimeout(this.focusTimer);
            this.setHasFocus(true);
        }
        else {
            // a delay of 300ms is used because onblur uses onmousedown which make the choice element disappear before the onclick fire
            // we can't use onmousedown to select the choice or scrolling won't be possible on mobile
            // TODO: find a better way of closing the contact choices list
            // global.setTimeout() is used because of typescript compiler thinking setTimeout() returns a number
            this.focusTimer = global.setTimeout(function () {
                _this.setHasFocus(false);
            }, 300);
        }
    };
    UprezShareFormField.prototype.setHasFocus = function (hasFocus) {
        this.setState({
            hasFocus: hasFocus
        });
    };
    UprezShareFormField.prototype.fillField = function (e) {
        var _a = this.props, dispatch = _a.dispatch, fieldName = _a.fieldName;
        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_2__containers_Share_actions__["b" /* SharePanelActionKeys */].SET_FORM_FIELD,
            name: fieldName,
            value: e.currentTarget.value
        });
    };
    UprezShareFormField.prototype.render = function () {
        var _this = this;
        var _a = this.props, fieldValue = _a.fieldValue, fieldName = _a.fieldName, isHeader = _a.isHeader, crmContacts = _a.crmContacts;
        var hasFocus = this.state.hasFocus;
        var fieldIsEmail = fieldName === __WEBPACK_IMPORTED_MODULE_1__typings__["a" /* FormField */].Email;
        var fieldIsMessage = fieldName === __WEBPACK_IMPORTED_MODULE_1__typings__["a" /* FormField */].Message;
        // We don't use type "email" for email fields as the "multiple" property doesn't work well with React
        // When a comma + space is typed to separate addresses, the cursor goes back to the start of the input
        // Browser side email validation doesn't work on IOS so we check for it during the share action
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* FormFieldContainer */], { isHeader: isHeader, fieldIsMessage: fieldIsMessage }, fieldIsMessage
                ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* EmailText */], { onChange: this.fillField, value: fieldValue })
                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "share." + fieldName }),
                    ":",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["j" /* InputField */], { onChange: this.fillField, onFocus: function () { return _this.handleFocus(true); }, onBlur: function () { return _this.handleFocus(false); }, value: fieldValue, required: fieldIsEmail, type: "text", autoCorrect: "off", autoComplete: "off", autoCapitalize: "none" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Share_UprezForm_CrmAutocompleteChoices__["a" /* default */], { hasFocus: hasFocus, fieldName: fieldName, crmContacts: crmContacts, fieldValue: fieldValue })))));
    };
    return UprezShareFormField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UprezShareFormField);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm_CrmAutocompleteChoices__ = __webpack_require__(1207);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm_CrmAutocompleteChoices__["a" /* default */]));


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropdownMenu__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_optimization__ = __webpack_require__(461);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var CrmAutocompleteChoices = function (_a) {
    var fieldName = _a.fieldName, fieldValue = _a.fieldValue, hasFocus = _a.hasFocus, crmContacts = _a.crmContacts, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"]([]), 2), filteredContacts = _c[0], setFilteredContacts = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), filterChoicesTimeout = _d[0], setFilterChoicesTimeout = _d[1];
    var minimumFieldCharacters = 3;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var shouldOpen = hasFocus && minimumFieldCharacters <= fieldValue.length;
        setIsOpen(shouldOpen);
    }, [fieldValue, hasFocus]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (filterChoicesTimeout) {
            clearTimeout(filterChoicesTimeout);
        }
        var maximumSuggestions = 15;
        var filterChoices = function (contact, fieldName, fieldValue) {
            var contactField = contact[__WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__["e" /* contactKeyByFieldName */][fieldName]];
            return !!(contactField && contactField.toLowerCase().includes(fieldValue.toLowerCase()));
        };
        setFilterChoicesTimeout(global.setTimeout(function () {
            if (minimumFieldCharacters <= fieldValue.length) {
                var filteredContacts_1 = Array.from(Object(__WEBPACK_IMPORTED_MODULE_3__utils_optimization__["a" /* filterWithMax */])(crmContacts, function (contact) { return filterChoices(contact, fieldName, fieldValue); }, maximumSuggestions));
                setFilteredContacts(filteredContacts_1);
            }
            else {
                setFilteredContacts([]);
            }
        }, 300));
    }, [fieldValue, fieldName, crmContacts]);
    var getContactLabel = function (contact) {
        var firstname = contact.firstName || '';
        var separator1 = firstname ? ' ' : '';
        var lastname = contact.lastName || '';
        var separator2 = firstname || lastname ? ' - ' : '';
        var email = contact.email || '';
        var separator3 = email ? ' ' : '';
        var company = contact.company || '';
        return "" + firstname + separator1 + lastname + separator2 + email + separator3 + company;
    };
    var renderContacts = function (contacts) {
        var menuConfig = {};
        contacts.forEach(function (contact, index) {
            menuConfig[String(index)] = {
                label: getContactLabel(contact),
                onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Share_actions__["j" /* setFormFieldsByContact */])(contact)); },
                hasSeparator: true,
            };
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DropdownMenu__["a" /* default */], { config: menuConfig, isDisplayed: isOpen }));
    };
    return renderContacts(filteredContacts);
};
/* harmony default export */ __webpack_exports__["a"] = (CrmAutocompleteChoices);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1210);




var ShareActionPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, isProcessing = _a.isProcessing, onShareViaCopy = _a.onShareViaCopy, onShareViaUprez = _a.onShareViaUprez, onCancel = _a.onCancel, label = _a.label, actionButtonColor = _a.actionButtonColor;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, isLoading: isProcessing, label: label || __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.share'), actionButtonColor: actionButtonColor, onCancel: onCancel },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* PopupBodyWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onShareViaCopy },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.share_via_copy" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onShareViaUprez },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.share_via_uprez" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShareActionPopup);


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OverlayBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PopupContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PopupHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PopupContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PopupBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PopupFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Overlay = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 100;\n\tbackground: ", ";\n\t", ";\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 100;\n\tbackground: ",
    ";\n\t", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["b" /* isSupportingBackdropBlur */])()
    ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 50)
    : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, 90), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["c" /* overlayAnimation */])(props.isOpen); });
var OverlayBlur = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n"], ["\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["b" /* isSupportingBackdropBlur */])() ? 'backdrop-filter: blur(20px);' : '');
var PopupContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: calc(100% - 20px);\n\tmax-width: 480px;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 35px 0 ", ";\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\twidth: calc(100% - 20px);\n\tmax-width: 480px;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 35px 0 ", ";\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["b" /* isSupportingBackdropBlur */])() ? 20 : 50), function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900 + ";\n\t";
});
var PopupHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 20px;\n\tborder-bottom: 2px solid ", ";\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 20px;\n\tborder-bottom: 2px solid ", ";\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tborder-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 10) + ";\n\t";
});
var PopupContentWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: relative;\n"], ["\n\tposition: relative;\n"])));
var getButtonCommonStyles = function (color) { return "\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: " + color + ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n"; };
var ButtonCancel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n\tposition: absolute;\n\ttop: 19px;\n\tleft: 15px;\n\n\t", "\n"], ["\n\t", "\n\tposition: absolute;\n\ttop: 19px;\n\tleft: 15px;\n\n\t",
    "\n"])), function (props) { return getButtonCommonStyles(props.color || props.theme.primary.actionColor); }, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 + ";\n\t";
});
var ButtonConfirm = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t", "\n\tposition: absolute;\n\ttop: 19px;\n\tright: 15px;\n\n\t", "\n\n\t", "\n"], ["\n\t", "\n\tposition: absolute;\n\ttop: 19px;\n\tright: 15px;\n\n\t",
    "\n\n\t",
    "\n"])), function (props) { return getButtonCommonStyles(props.color || props.theme.primary.actionColor); }, function (props) { return props.disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t"; }, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 + ";\n\t";
});
var PopupBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tbox-sizing: border-box;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black);
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: block;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n\n\t", "\n"], ["\n\tdisplay: block;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\t";
});
var PopupFooter = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tpadding: 20px;\n\tborder-top: 2px solid ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t", "\n"], ["\n\tpadding: 20px;\n\tborder-top: 2px solid ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tborder-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 10) + ";\n\t";
});
var ButtonAccept = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t", "\n\n\t", "\n"], ["\n\t", "\n\n\t",
    "\n"])), function (props) { return getButtonCommonStyles(props.theme.primary.actionColor); }, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* PopupTheme */].DARK && "\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 + ";\n\t";
});
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 10px;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tz-index: 10;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 10px;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tz-index: 10;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_3__utils_style__["e" /* spin */]);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopupBodyWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var PopupBodyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding-bottom: 10px;\n"], ["\n\tpadding-bottom: 10px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 50px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 50px;\n\tcolor: ", ";\n\ttext-align: center;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:not(:first-of-type) {\n\t\tborder-top: 1px solid ", ";\n\t}\n"], ["\n\twidth: 100%;\n\theight: 50px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 50px;\n\tcolor: ", ";\n\ttext-align: center;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:not(:first-of-type) {\n\t\tborder-top: 1px solid ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey300);

var templateObject_1, templateObject_2;


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm_ShareViaCopyPopup__ = __webpack_require__(1212);


var mapStateToProps = function (state) {
    var _a = state.sharePanel, isShareViaCopyPopupOpen = _a.isShareViaCopyPopupOpen, shareViaCopyData = _a.shareViaCopyData, pin = _a.pin, isProcessing = _a.isProcessing, copyMode = _a.copyMode, theme = _a.theme, callbackAction = _a.callbackAction;
    return {
        isDisplayed: isShareViaCopyPopupOpen,
        resourceList: shareViaCopyData,
        pin: pin,
        isProcessing: isProcessing,
        copyMode: copyMode,
        theme: theme,
        callbackAction: callbackAction,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Share_UprezForm_ShareViaCopyPopup__["a" /* default */]));


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_Select__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Share_reducer__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__ = __webpack_require__(12);











var getPlainText = function (resourceList, pin) {
    var mailText = '';
    resourceList.forEach(function (_a) {
        var url = _a.url, label = _a.label;
        if (resourceList.length === 1) {
            mailText += url + "\n";
        }
        else {
            mailText += label + "\n" + url + "\n";
        }
        if (pin) {
            mailText += __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.pin_code') + ": " + pin + "\n\n";
        }
    });
    return mailText;
};
var getHtmlText = function (resourceList, pin) {
    var mailText = '<ul style="list-style-type: \'- \';">';
    resourceList.forEach(function (_a) {
        var url = _a.url, label = _a.label;
        mailText += "<li><a href=\"" + url + "\">" + label + "</a>";
        if (pin) {
            mailText += "<br>" + __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.pin_code') + ": " + pin;
        }
        mailText += '</li>';
    });
    mailText += '</ul>';
    return mailText;
};
var copyModeOptions = [
    {
        value: __WEBPACK_IMPORTED_MODULE_7__containers_Share_reducer__["a" /* CopyMode */].html,
        label: 'messages.copy_mode_html',
    },
    {
        value: __WEBPACK_IMPORTED_MODULE_7__containers_Share_reducer__["a" /* CopyMode */].text,
        label: 'messages.copy_mode_text',
    },
];
var ShareViaCopyPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, isProcessing = _a.isProcessing, resourceList = _a.resourceList, pin = _a.pin, copyMode = _a.copyMode, theme = _a.theme, callbackAction = _a.callbackAction, dispatch = _a.dispatch;
    var popupFooter = {
        label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.copy'),
        onAccept: function () {
            if (copyMode === __WEBPACK_IMPORTED_MODULE_7__containers_Share_reducer__["a" /* CopyMode */].text) {
                __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__(getPlainText(resourceList, pin));
            }
            else {
                if (__WEBPACK_IMPORTED_MODULE_8__utils_userAgent__["a" /* default */].isAndroidApp()) {
                    __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__["b" /* default */].copyHtmlToClipboard(getPlainText(resourceList, pin), getHtmlText(resourceList, pin));
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__(getHtmlText(resourceList, pin), { format: 'text/html' });
                }
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["A" /* runCallbackAction */])(callbackAction));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__["d" /* closeShareViaCopyPopup */])());
        },
    };
    var handleChange = function (_a) {
        var value = _a.value;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__["h" /* setCopyMode */])(value));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* default */], { isDisplayed: isDisplayed, isLoading: isProcessing, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.share_via_copy'), onCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__["d" /* closeShareViaCopyPopup */])()); }, footer: popupFooter, theme: theme },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* PopupBody */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Message */], { value: "messages.copy_links_to_share", theme: theme }),
            !__WEBPACK_IMPORTED_MODULE_8__utils_userAgent__["a" /* default */].isWindowsApp() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Form_Select__["b" /* default */], { value: copyMode, options: copyModeOptions, theme: theme === __WEBPACK_IMPORTED_MODULE_3__Popup__["a" /* PopupTheme */].DARK ? __WEBPACK_IMPORTED_MODULE_4__Form_Select__["a" /* SelectTheme */].DARK : __WEBPACK_IMPORTED_MODULE_4__Form_Select__["a" /* SelectTheme */].LIGHT, onChange: handleChange }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShareViaCopyPopup);


/***/ }),
/* 1213 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SelectValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SelectOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectOptionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n"], ["\n\tposition: relative;\n"])));
var SelectValue = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tpadding: 15px 60px 15px 30px;\n\tborder: 1px solid ", ";\n\tborder-radius: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\n\t", "\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tright: 30px;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n\n\t", ";\n"], ["\n\tposition: relative;\n\tpadding: 15px 60px 15px 30px;\n\tborder: 1px solid ", ";\n\tborder-radius: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\n\t",
    "\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tright: 30px;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t}\n\n\t",
    ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* SelectTheme */].DARK && "\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\t\tborder-color: currentColor;\n\t";
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600, function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && "\n\t\tborder-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600 + ";\n\n\t\tsvg {\n\t\t\ttransform: rotate(180deg) translateY(-50%);\n\t\t\ttransform-origin: 50% 0;\n\t\t}\n\t";
});
var SelectDropdown = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tright: 0;\n\tpadding: 5px 0;\n\tborder: 1px solid ", ";\n\tborder-radius: 10px;\n\tbackground-color: ", ";\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tright: 0;\n\tpadding: 5px 0;\n\tborder: 1px solid ", ";\n\tborder-radius: 10px;\n\tbackground-color: ", ";\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* SelectTheme */].DARK && "\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900 + ";\n\t\tborder-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\t";
});
var SelectOptions = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\tmax-height: 200px;\n\toverflow-y: auto;\n\n\tli + li {\n\t\tborder-top: 1px solid ", ";\n\t}\n\n\t", "\n"], ["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\tmax-height: 200px;\n\toverflow-y: auto;\n\n\tli + li {\n\t\tborder-top: 1px solid ", ";\n\t}\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, function (_a) {
    var theme = _a.theme.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* SelectTheme */].DARK && "\n\t\tli + li {\n\t\t\tborder-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\t\t}\n\t";
});
var SelectOptionButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\twidth: 100%;\n\tmargin: 0;\n\tpadding: 15px 30px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: left;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t", ";\n\n\t", "\n"], ["\n\twidth: 100%;\n\tmargin: 0;\n\tpadding: 15px 30px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: left;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t",
    ";\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue50, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600, function (_a) {
    var isActive = _a.isActive;
    return isActive && "\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue50 + ";\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600 + ";\n\t";
}, function (_a) {
    var theme = _a.theme.theme, isActive = _a.isActive;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* SelectTheme */].DARK && "\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900 + ";\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\n\t\t&:hover {\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 25) + ";\n\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t\t}\n\n\t\t" + (isActive && "\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 25) + ";\n\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t\t") + ";\n\t";
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopupBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(29);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var PopupBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 10px 15px;\n"], ["\n\tpadding: 10px 15px;\n"])));
var Message = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-bottom: 10px;\n\n\t", "\n"], ["\n\tdisplay: block;\n\tmargin-bottom: 10px;\n\n\t",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme === __WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* PopupTheme */].DARK && "\n\t\tcolor: " + Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75) + ";\n\t";
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1217);


var Switch = function (_a) {
    var name = _a.name, isActive = _a.isActive, onChange = _a.onChange, label = _a.label, style = _a.style;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Wrapper */], null,
        label,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledSwitch */], { isActive: isActive, style: style },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", name: name, checked: isActive, onChange: onChange }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Switch);


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledSwitch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var StyledSwitch = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('label')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tflex: 0 0 auto;\n\twidth: 55px;\n\theight: 31px;\n\tborder: 2px solid ", ";\n\tborder-radius: 20px;\n\tbackground-color: ", ";\n\ttransition: all 0.2s ease;\n\tcursor: pointer;\n\n\t&::before {\n\t\tcontent: '';\n\t\tbox-sizing: border-box;\n\t\tposition: absolute;\n\t\twidth: 27px;\n\t\theight: 27px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ", ";\n\t\ttransition: transform 0.2s ease;\n\n\t\t", "\n\t}\n\n\tinput {\n\t\tdisplay: none;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tflex: 0 0 auto;\n\twidth: 55px;\n\theight: 31px;\n\tborder: 2px solid ",
    ";\n\tborder-radius: 20px;\n\tbackground-color: ",
    ";\n\ttransition: all 0.2s ease;\n\tcursor: pointer;\n\n\t&::before {\n\t\tcontent: '';\n\t\tbox-sizing: border-box;\n\t\tposition: absolute;\n\t\twidth: 27px;\n\t\theight: 27px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ", ";\n\t\ttransition: transform 0.2s ease;\n\n\t\t", "\n\t}\n\n\tinput {\n\t\tdisplay: none;\n\t}\n"])), function (_a) {
    var isActive = _a.isActive, style = _a.style, theme = _a.theme;
    return isActive
        ? style && style.activeColor || theme.primary.actionColor
        : 'transparent';
}, function (_a) {
    var isActive = _a.isActive, style = _a.style, theme = _a.theme;
    return isActive
        ? style && style.activeColor || theme.primary.actionColor
        : style && style.inactiveColor || Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 15);
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var isActive = _a.isActive;
    return isActive && 'transform: translateX(24px);';
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContextualMenu__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);



var mapStateToProps = function (state) {
    var _a = state.driveList, contextualMenu = _a.contextualMenu, isLocked = _a.contextualMenu.isLocked, driveItems = _a.driveItems, tagClasses = state.galleryInfos.template.tagClasses;
    var driveItem;
    if (!contextualMenu.isOpened) {
        return {
            buttons: {},
            isOpened: false,
            isLocked: isLocked,
            driveItem: driveItem,
            tagClasses: tagClasses,
        };
    }
    var driveItemId = contextualMenu.driveItemId;
    driveItem = driveItems[driveItemId];
    var buttons = __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getContextualMenuButtons(driveItem, state);
    return {
        buttons: buttons,
        isOpened: true,
        isLocked: isLocked,
        driveItem: driveItem,
        tagClasses: tagClasses,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ContextualMenu__["a" /* default */]));


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageOverlay_styles__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ContextualMenu_Item__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Spinner_styles__ = __webpack_require__(344);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var ContextualMenu = /** @class */ (function (_super) {
    __extends(ContextualMenu, _super);
    function ContextualMenu(props) {
        return _super.call(this, props) || this;
    }
    ContextualMenu.prototype.onOverlayClick = function () {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__["f" /* closeContextualMenu */])());
    };
    ContextualMenu.prototype.getItemsType = function () {
        var buttons = this.props.buttons;
        var itemsType = [];
        Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ContextualMenuItemType */])
            .forEach(function (key) {
            var contextualMenuItemType = __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ContextualMenuItemType */][key];
            if (buttons[key]) {
                itemsType.push(contextualMenuItemType);
            }
        });
        return itemsType;
    };
    ContextualMenu.prototype.renderItems = function () {
        var itemsData = this.getItemsType();
        return itemsData.map(function (itemType) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ContextualMenu_Item__["a" /* default */], { type: itemType, key: itemType })); });
    };
    ContextualMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpened = _a.isOpened, isLocked = _a.isLocked, driveItem = _a.driveItem, tagClasses = _a.tagClasses;
        var className = __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__["d" /* default */].getItemClassName('ContextualMenu', driveItem, tagClasses);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__PageOverlay_styles__["a" /* PageOverlay */], { isOpen: isOpened, onClick: function () { return _this.onOverlayClick(); } }),
            isOpened &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* DropdownContainer */], { className: className },
                    isLocked && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* SpinnerContainer */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Spinner_styles__["a" /* Spinner */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* DropDownList */], null, this.renderItems()))));
    };
    return ContextualMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ContextualMenu);


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDownList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SpinnerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleDropdownMenu_styles__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var SpinnerContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tinset: 0;\n\tz-index: 13;\n\tbackground-color: ", ";\n\topacity: 0.66;\n\tborder-radius: 16px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n"], ["\n\tposition: absolute;\n\tinset: 0;\n\tz-index: 13;\n\tbackground-color: ", ";\n\topacity: 0.66;\n\tborder-radius: 16px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black);
var DropdownContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: 12;\n"], ["\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: 12;\n"])));
var DropDownList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__SimpleDropdownMenu_styles__["a" /* DropdownMenuList */])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmin-width: 340px;\n\n\t@media ", " {\n\t\tmin-width: 280px;\n\t}\n"], ["\n\tmin-width: 340px;\n\n\t@media ", " {\n\t\tmin-width: 280px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortrait);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContextualMenu_Item_Container__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var mapStateToProps = function (state) {
    var driveList = state.driveList, _a = state.galleryInfos, galleryConfig = _a.config, clientId = _a.config.clientId, selected = state.downloadManager.downloadGroups.selected, downloadManager = state.downloadManager;
    var contextualMenu = driveList.contextualMenu;
    var driveItem;
    var isTemplate = false;
    var isDownloaded = false;
    var driveItems = driveList.driveItems;
    var privateDirId = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getPrivateDirId(driveList, galleryConfig);
    var privateDir = privateDirId && driveItems[privateDirId];
    if (contextualMenu.isOpened) {
        var ids = driveList.customTemplates.ids;
        var driveItemId = contextualMenu.driveItemId;
        driveItem = driveItems[driveItemId];
        isTemplate = ids.includes(driveItemId);
    }
    var isDownloadAllPendingSelectedItems = !selected.isDownloading && selected.status === __WEBPACK_IMPORTED_MODULE_2__DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started;
    if (driveItem) {
        isDownloaded = __WEBPACK_IMPORTED_MODULE_3__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, driveItem.id);
    }
    return {
        driveItem: driveItem,
        clientId: clientId,
        isTemplate: isTemplate,
        isDownloadAllPendingSelectedItems: isDownloadAllPendingSelectedItems,
        isDownloaded: isDownloaded,
        driveItems: driveItems,
        privateDir: privateDir,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ContextualMenu_Item_Container__["a" /* default */]));


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_ShareWithUserPopup_actions__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_PublicationCreator_actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_AssetRenamePanel_actions__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_NoSaveAsPopup_actions__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_CoverImagePanel_actions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_DownloadManager_actions_store__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_DownloadManager_actions_download__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_api__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





















var ContextualMenuItemContainer = /** @class */ (function (_super) {
    __extends(ContextualMenuItemContainer, _super);
    function ContextualMenuItemContainer(props) {
        return _super.call(this, props) || this;
    }
    ContextualMenuItemContainer.prototype.close = function () {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["f" /* closeContextualMenu */])());
    };
    ContextualMenuItemContainer.prototype.onDownloadClick = function () {
        var _a = this.props, driveItem = _a.driveItem, dispatch = _a.dispatch, isDownloadAllPendingSelectedItems = _a.isDownloadAllPendingSelectedItems;
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp;
        if (driveItem) {
            __WEBPACK_IMPORTED_MODULE_6__utils_statistics__["a" /* default */].trackDownload([driveItem]);
            if (!isMobileApp) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["m" /* requestWebDownloadItem */])(driveItem));
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__containers_DownloadManager_actions_store__["d" /* addSelectedDownloadItem */])(driveItem.id));
                if (!isDownloadAllPendingSelectedItems) {
                    __WEBPACK_IMPORTED_MODULE_6__utils_statistics__["a" /* default */].trackDownloadSelected();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__containers_DownloadManager_actions_store__["u" /* startDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_19__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["l" /* requestMobileAppDownload */])(driveItem, __WEBPACK_IMPORTED_MODULE_19__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested, undefined, true));
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__containers_DownloadManager_actions_download__["d" /* downloadSelectedAssets */])());
                }
            }
        }
        this.close();
    };
    ContextualMenuItemContainer.prototype.onUpdateClick = function () {
        var _a = this.props, driveItem = _a.driveItem, dispatch = _a.dispatch, isDownloaded = _a.isDownloaded;
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp;
        if (driveItem) {
            if (!isMobileApp) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["m" /* requestWebDownloadItem */])(driveItem));
            }
            else {
                if (isDownloaded) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["l" /* requestMobileAppDownload */])(driveItem, __WEBPACK_IMPORTED_MODULE_19__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested, undefined, true));
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["l" /* requestMobileAppDownload */])(driveItem, __WEBPACK_IMPORTED_MODULE_19__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested));
                }
            }
        }
        this.close();
    };
    ContextualMenuItemContainer.prototype.onDeleteClick = function () {
        var _a = this.props, driveItem = _a.driveItem, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["c" /* deleteItem */])(driveItem));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onShareClick = function () {
        var _a = this.props, dispatch = _a.dispatch, driveItem = _a.driveItem;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Share_actions__["k" /* share */])([driveItem]));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onShareWithUserClick = function () {
        var _a = this.props, dispatch = _a.dispatch, id = _a.driveItem.id;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_ShareWithUserPopup_actions__["b" /* getShareUsers */])(id));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onEditClick = function () {
        var _a = this.props, clientId = _a.clientId, id = _a.driveItem.id;
        __WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].getPathEditor(clientId, id));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onProposalNoSaveAs = function () {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__containers_NoSaveAsPopup_actions__["c" /* openNoSaveAsPopup */])());
        this.close();
    };
    ContextualMenuItemContainer.prototype.onPublicationCopy = function () {
        var _a = this.props, driveItem = _a.driveItem, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_PublicationCreator_actions__["g" /* openPublicationCreatorForSaveAs */])(driveItem));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onRename = function () {
        var _a = this.props, driveItem = _a.driveItem, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__containers_AssetRenamePanel_actions__["c" /* openAssetRenamePanel */])(driveItem));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onEditCoverImageClick = function () {
        var _a = this.props, driveItem = _a.driveItem, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__containers_CoverImagePanel_actions__["d" /* openCoverImagePanel */])(driveItem));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onDeleteFromAspClick = function () {
        var _a = this.props, driveItem = _a.driveItem, clientId = _a.clientId, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["g" /* deleteFromAsp */])(clientId, driveItem));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onSetAsTemplateClick = function () {
        var _a = this.props, id = _a.driveItem.id, clientId = _a.clientId, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_PublicationCreator_actions__["k" /* setAsTemplate */])(clientId, id));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onRemoveTemplateClick = function () {
        var _a = this.props, id = _a.driveItem.id, clientId = _a.clientId, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_PublicationCreator_actions__["i" /* removeTemplate */])(clientId, id));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onArchiveClick = function () {
        var _a = this.props, driveItem = _a.driveItem, clientId = _a.clientId, dispatch = _a.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["e" /* archiveProposal */])(clientId, driveItem));
        this.close();
    };
    ContextualMenuItemContainer.prototype.onCheckForUpdateClick = function () {
        var driveItem = this.props.driveItem;
        this.updateMetaAndThumbnail(driveItem).then();
        this.close();
    };
    ContextualMenuItemContainer.prototype.formatCurrentDate = function () {
        var separators = ['/', '/', '', ':', ':'];
        var separatorIndex = 0;
        return new Date().toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).replace(/,/g, function (match, offset) { return separators[separatorIndex++]; });
    };
    ContextualMenuItemContainer.prototype.createProposal = function (mustOpenEditor) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, id, label, clientId, privateDir, dispatch, requestId, formattedDate, globalId, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, _b = _a.driveItem, id = _b.id, label = _b.label, clientId = _a.clientId, privateDir = _a.privateDir, dispatch = _a.dispatch;
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["n" /* lockContextualMenu */])());
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        requestId = 'create-proposal';
                        formattedDate = this.formatCurrentDate();
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_20__utils_api__["a" /* default */].createProposalFromDriveItem(privateDir.id, clientId, id, label + "-" + formattedDate, requestId)];
                    case 2:
                        globalId = (_c.sent()).globalId;
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(privateDir.id, true, true, true))];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["i" /* fetchDriveItem */])(globalId, privateDir.id, true))];
                    case 4:
                        _c.sent();
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["L" /* viewDriveItem */])(privateDir, __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].List));
                        if (mustOpenEditor) {
                            __WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_10__utils_routes__["a" /* default */].getPathEditor(clientId, globalId));
                        }
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["G" /* unlockContextualMenu */])());
                        this.close();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _c.sent();
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["G" /* unlockContextualMenu */])());
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ContextualMenuItemContainer.prototype.onCreateProposalClick = function () {
        this.createProposal(false);
    };
    ContextualMenuItemContainer.prototype.onCreateCustomizedProposalClick = function () {
        this.createProposal(true);
    };
    ContextualMenuItemContainer.prototype.updateMetaAndThumbnail = function (driveItem) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, dispatch, isDownloaded, meta, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, dispatch = _a.dispatch, isDownloaded = _a.isDownloaded;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(driveItem.id, true, true, true))];
                    case 2:
                        meta = _b.sent();
                        if (meta.id) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__containers_OfflineManager_actions__["e" /* downloadThumb */])(driveItem.id, __WEBPACK_IMPORTED_MODULE_16__utils_nativeApi__["a" /* DownloadPriority */].High, false, meta, true));
                        }
                        if (isDownloaded) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__containers_DownloadManager_actions_download__["h" /* updateDriveItemWithDependencies */])(driveItem, true)).then();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        console.error("[CheckForUpdate] ERROR item " + driveItem.id + ":", error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContextualMenuItemContainer.prototype.getItemAttributes = function (type) {
        var _this = this;
        var defaultSize = 20;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Download:
                return {
                    label: __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp ? 'messages.activate_offline_mode' : 'messages.download',
                    iconName: __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp ? 'iconset_uprez_check_circle' : 'iconset_uprez_download_bold',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onDownloadClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Download,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Update:
                return {
                    label: 'messages.update',
                    iconName: 'iconset_update',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600,
                    size: defaultSize + 2,
                    onClick: function () { return _this.onUpdateClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Update,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Delete:
                return {
                    label: 'messages.available_offline',
                    iconName: 'iconset_uprez_check_circle_green',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen,
                    size: defaultSize + 2,
                    onClick: function () { return _this.onDeleteClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Delete,
                    hoverLabel: 'messages.deactivate_offline_mode',
                    hoverIconName: 'iconset_delete',
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Share:
                return {
                    label: 'messages.share',
                    iconName: 'iconset_uprez_share_bold',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onShareClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Share,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].ShareWithUser:
                return {
                    label: 'messages.invite_coworker',
                    iconName: 'iconset_uprez_invite',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black,
                    size: defaultSize + 2,
                    onClick: function () { return _this.onShareWithUserClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].ShareWithUser,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Edit:
                return {
                    label: 'messages.edit',
                    iconName: 'iconset_uprez_write',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onEditClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Edit,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].ProposalNoSaveAs:
                return {
                    label: 'messages.save_as',
                    iconName: 'iconset_uprez_info',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Red,
                    size: defaultSize + 2,
                    onClick: function () { return _this.onProposalNoSaveAs(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].ProposalNoSaveAs,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].PublicationSaveAs:
                return {
                    label: 'messages.save_as',
                    iconName: 'iconset_uprez_save_as',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onPublicationCopy(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].PublicationSaveAs,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Rename:
                return {
                    label: 'messages.rename',
                    iconName: 'iconset_uprez_rename',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize + 2,
                    onClick: function () { return _this.onRename(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Rename,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].EditCoverImage:
                return {
                    label: 'messages.change_cover_image',
                    iconName: 'iconset_uprez_cover_image',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onEditCoverImageClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].EditCoverImage,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].DeleteFromAsp:
                return {
                    label: 'messages.delete',
                    iconName: 'iconset_uprez_delete',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize + 1,
                    onClick: function () { return _this.onDeleteFromAspClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].DeleteFromAsp,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].SetAsTemplate:
                var isTemplate_1 = this.props.isTemplate;
                return {
                    label: isTemplate_1 ? 'messages.available_as_template' : 'messages.set_as_template',
                    iconName: isTemplate_1 ? 'iconset_uprez_check_circle_green' : 'iconset_uprez_set_as_template',
                    color: isTemplate_1 ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: isTemplate_1 ? defaultSize + 2 : defaultSize,
                    onClick: function () {
                        if (isTemplate_1) {
                            _this.onRemoveTemplateClick();
                        }
                        else {
                            _this.onSetAsTemplateClick();
                        }
                    },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].SetAsTemplate,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].RemoveTemplate:
                return {
                    label: 'messages.remove_template',
                    iconName: 'iconset_uprez_delete',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onRemoveTemplateClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].RemoveTemplate,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Archive:
                return {
                    label: 'messages.archive_verb',
                    iconName: 'iconset_uprez_archive',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onArchiveClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].Archive,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].CheckForUpdate:
                return {
                    label: 'messages.check_for_updates',
                    iconName: 'iconset_uprez_check_for_updates',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onCheckForUpdateClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].CheckForUpdate,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].CreateProposal:
                return {
                    label: 'messages.create_proposal',
                    iconName: 'iconset_uprez_create_proposal',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onCreateProposalClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].CreateProposal,
                };
            case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].CreateCustomizedProposal:
                return {
                    label: 'messages.create_customized_proposal',
                    iconName: 'iconset_uprez_create_customized_proposal',
                    color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black,
                    size: defaultSize,
                    onClick: function () { return _this.onCreateCustomizedProposalClick(); },
                    className: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ContextualMenuItemType */].CreateProposal,
                };
        }
    };
    ContextualMenuItemContainer.prototype.render = function () {
        var type = this.props.type;
        var itemAttributes = this.getItemAttributes(type);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7____["a" /* default */], __assign({}, itemAttributes));
    };
    return ContextualMenuItemContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ContextualMenuItemContainer);


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ContextualMenuItem = /** @class */ (function (_super) {
    __extends(ContextualMenuItem, _super);
    function ContextualMenuItem(props) {
        return _super.call(this, props) || this;
    }
    ContextualMenuItem.prototype.render = function () {
        var _a = this.props, label = _a.label, color = _a.color, iconName = _a.iconName, size = _a.size, onClick = _a.onClick, hoverLabel = _a.hoverLabel, hoverIconName = _a.hoverIconName, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledContextualMenuItem */], { className: className, color: color, onClick: onClick, hasHoverIcon: !!hoverIconName, hasHoverLabel: !!hoverLabel },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { className: "menuLabel", value: label }),
            hoverLabel &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { className: "menuLabelHover", value: hoverLabel }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ContextualMenuItemIcon */], { className: "menuIcon", size: size }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon(iconName)),
            hoverIconName &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ContextualMenuItemIcon */], { className: "menuIconHover", size: size }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon(hoverIconName))));
    };
    return ContextualMenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ContextualMenuItem);


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledContextualMenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuItemIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleDropdownMenu_styles__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(222);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledContextualMenuItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__SimpleDropdownMenu_styles__["b" /* DropdownMenuListItem */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\ttext-align: left;\n\theight: 50px;\n\tcolor: ", ";\n\tfont-size: 17px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 500;\n\t", ";\n\n\t", ";\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\ttext-align: left;\n\theight: 50px;\n\tcolor: ", ";\n\tfont-size: 17px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 500;\n\t",
    ";\n\n\t",
    ";\n"])), function (props) { return props.color; }, function (props) { return props.hasHoverIcon && "\n\n\t\t.menuIconHover {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t:hover {\n\t\t\t.menuIcon {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t.menuIconHover {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t\t&." + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ContextualMenuItemType */].Delete + " .menuIconHover svg {\n\t\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Red + ";\n\t\t\t}\n\t\t}"; }, function (props) { return props.hasHoverLabel && "\n\n\t\t.menuLabelHover {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t:hover {\n\t\t\t.menuLabel {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t.menuLabelHover {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t\t&." + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ContextualMenuItemType */].Delete + " .menuLabelHover {\n\t\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Red + ";\n\t\t\t}\n\t\t}"; });
var ContextualMenuItemIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: ", "px;\n\theight: ", "px;\n\n\tsvg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tfill: currentColor;\n\t}\n"], ["\n\twidth: ", "px;\n\theight: ", "px;\n\n\tsvg {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tfill: currentColor;\n\t}\n"])), function (props) { return props.size; }, function (props) { return props.size; });

var templateObject_1, templateObject_2;


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FolderCreationPanel__ = __webpack_require__(1226);


var mapStateToProps = function (state) {
    var folderCreationPanel = state.folderCreationPanel;
    var isOpen = folderCreationPanel.isOpen, name = folderCreationPanel.name, useSelection = folderCreationPanel.useSelection;
    return { isOpen: isOpen, name: name, useSelection: useSelection };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_FolderCreationPanel__["a" /* default */]));


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourceCreationPanel__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_FolderCreationPanel_actions__ = __webpack_require__(235);



var FolderCreationPanel = function (_a) {
    var isOpen = _a.isOpen, name = _a.name, useSelection = _a.useSelection, dispatch = _a.dispatch;
    var fieldsConfig = {
        name: {
            value: name,
        },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ResourceCreationPanel__["a" /* default */], { isOpen: isOpen, icon: "iconset_doc_default", fields: fieldsConfig, onFieldChange: function (name, value) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_FolderCreationPanel_actions__["e" /* setName */])(value)); }, onConfirm: function (_a) {
            var name = _a.name;
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_FolderCreationPanel_actions__["c" /* createFolder */])(name.value, useSelection));
        }, onCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_FolderCreationPanel_actions__["b" /* closePanel */])()); } }));
};
/* harmony default export */ __webpack_exports__["a"] = (FolderCreationPanel);


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);



var BlurPanel = function (_a) {
    var isOpen = _a.isOpen, onCancelClick = _a.onCancelClick, onOkClick = _a.onOkClick, children = _a.children, label = _a.label;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* StyledBlurPanel */], { isOpen: isOpen },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* BlurPanelHeader */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* BlurPanelHeaderButton */], { isLeft: true, onClick: onCancelClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
            label &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* BlurPanelHeaderLabel */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: label })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* BlurPanelHeaderButton */], { isRight: true, onClick: onOkClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.ok" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* BlurPanelContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* BlurPanelContentBackground */], null, children))));
};
/* harmony default export */ __webpack_exports__["a"] = (BlurPanel);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledBlurPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BlurPanelHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BlurPanelHeaderButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BlurPanelHeaderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlurPanelContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BlurPanelContentBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledBlurPanel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\tz-index: 11;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"], ["\n\t", ";\n\tz-index: 11;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["c" /* overlayAnimation */])(props.isOpen); });
var BlurPanelHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\theight: ", ";\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: ", ";\n\tfont-size: 16px;\n\tcolor: ", ";\n\n\t", "\n\n\t", "\n"], ["\n\tposition: absolute;\n\theight: ", ";\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: ", ";\n\tfont-size: 16px;\n\tcolor: ", ";\n\n\t",
    "\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return props.theme.primary.actionColor; }, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var BlurPanelHeaderButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 6px;\n\tleft: ", ";\n\tright: ", ";\n\tpadding: 10px;\n\tcursor: pointer;\n\n\t@media ", " {\n\t\tleft: ", ";\n\t\tright: ", ";\n\t}\n\n\t", "\n\n\t", "\n\n"], ["\n\tposition: absolute;\n\ttop: 6px;\n\tleft: ", ";\n\tright: ", ";\n\tpadding: 10px;\n\tcursor: pointer;\n\n\t@media ", " {\n\t\tleft: ", ";\n\t\tright: ", ";\n\t}\n\n\t",
    "\n\n\t",
    "\n\n"])), function (props) { return props.isLeft ? '50px' : 'auto'; }, function (props) { return props.isRight ? '50px' : 'auto'; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortrait, function (props) { return props.isLeft ? 0 : 'auto'; }, function (props) { return props.isRight ? 0 : 'auto'; }, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\ttop: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\ttop: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var BlurPanelHeaderLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tcolor: ", ";\n\n\t@media ", " {\n\t\tmax-width: 50%;\n\t\ttext-align: center;\n\t}\n"], ["\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tcolor: ", ";\n\n\t@media ", " {\n\t\tmax-width: 50%;\n\t\ttext-align: center;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallSmartphonePortrait);
var BlurPanelContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbackdrop-filter: blur(20px);\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"], ["\n\tbackdrop-filter: blur(20px);\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */]);
var BlurPanelContentBackground = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\theight: 100%;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n"], ["\n\theight: 100%;\n\tbackground-color: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["d" /* blurredBackgroundColor */]);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceCreationContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResourceCreationIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ResourceCreationInputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResourceCreationInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ResourceCreationInputLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResourceCreationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ResourceCreationInputClear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ResourceCreationLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};








var ResourceCreationContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('form')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\tmax-width: 450px;\n\tmargin: 0 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n"], ["\n\twidth: 100%;\n\tmax-width: 450px;\n\tmargin: 0 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n"])));
var getMediaQueries = function (inputBoxNumber) {
    var mediaQueries = '';
    for (var i = 1; i < __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* mediaQueryStyleConfigs */].length; i++) {
        var mediaQueryConditionConfig = __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* mediaQueryStyleConfigs */][i - 1];
        var mediaQueryStyleConfig = __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* mediaQueryStyleConfigs */][i];
        if (mediaQueryStyleConfig) {
            mediaQueries += getMediaQuery(mediaQueryConditionConfig, mediaQueryStyleConfig, inputBoxNumber);
        }
    }
    return mediaQueries;
};
var getMediaQuery = function (mediaQueryConditionConfig, mediaQueryStyleConfig, inputBoxNumber) {
    return "\n\t\t@media " + getMediaQueryCondition(mediaQueryConditionConfig, inputBoxNumber) + " {\n\t\t\t" + getMediaQueryStyle(mediaQueryStyleConfig) + "\n\t\t}\n\t";
};
var getMediaQueryCondition = function (mediaQueryStyleConfig, inputBoxNumber) {
    var maxHeight = getMediaQueryConditionMaxHeight(mediaQueryStyleConfig, inputBoxNumber);
    return "only screen and (max-height: " + maxHeight + "px)";
};
var marginBetweenInputBoxes = 35;
var getMediaQueryConditionMaxHeight = function (_a, inputBoxNumber) {
    var marginTop = _a.marginTop, height = _a.height;
    return parseInt(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["h" /* navBarHeight */], 10)
        + marginTop
        + height
        + inputBoxNumber * (__WEBPACK_IMPORTED_MODULE_4__Form_styles__["c" /* inputBoxHeight */] + marginBetweenInputBoxes)
        + (__WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isIOS() ? 2 * __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getKeyboardHeight() : 0);
};
var getMediaQueryStyle = function (_a) {
    var marginTop = _a.marginTop, height = _a.height;
    return "\n\t\tmargin-top: " + marginTop + "px;\n\t\theight: " + height + "px;\n\t";
};
var ResourceCreationIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\n\t& > svg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\n\t", "\n"], ["\n\t", "\n\n\t& > svg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\n\t", "\n"])), getMediaQueryStyle(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* defaultStyle */]), function (props) { return getMediaQueries(props.inputBoxNumber); });
var ResourceCreationInputWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\twidth: 100%;\n\tmargin-top: ", "px;\n"], ["\n\tposition: relative;\n\twidth: 100%;\n\tmargin-top: ", "px;\n"])), marginBetweenInputBoxes);
var ResourceCreationInput = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Form_styles__["a" /* Input */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tborder-radius: 6px;\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tfont-size: 22px;\n\ttext-align: center;\n\n\t", ";\n"], ["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tborder-radius: 6px;\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tfont-size: 22px;\n\ttext-align: center;\n\n\t", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey100, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, function (props) { return !!props.value && 'padding: 0 40px;'; });
var labelStyles = "\n\tposition: absolute;\n\tbottom: calc(100% + 5px);\n\tleft: 0;\n\tright: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\ttext-align: center;\n";
var ResourceCreationInputLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('label')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\tcolor: ", ";\n"], ["\n\t", "\n\tcolor: ", ";\n"])), labelStyles, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black);
var ResourceCreationError = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n\tcolor: ", ";\n"], ["\n\t", "\n\tcolor: ", ";\n"])), labelStyles, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Red);
var ResourceCreationInputClear = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 15px;\n\tright: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\toutline: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 7px;\n\t\theight: 7px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 15px;\n\tright: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\toutline: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 7px;\n\t\theight: 7px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White);
var ResourceCreationLoader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, 75), __WEBPACK_IMPORTED_MODULE_3__utils_style__["e" /* spin */]);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mediaQueryStyleConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultStyle; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var defaultStyle = {
    marginTop: 175,
    height: 175,
};
var landscapeStyle = __assign({}, defaultStyle, { marginTop: 30 });
var smartphoneStyle = __assign({}, defaultStyle, { marginTop: 10, height: 100 });
var smartphoneLandscapeStyle = __assign({}, defaultStyle, { marginTop: 10, height: 0 });
var mediaQueryStyleConfigs = [
    defaultStyle,
    landscapeStyle,
    smartphoneStyle,
    smartphoneLandscapeStyle,
];



/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(87);



var mapStateToProps = function (state) {
    var _a = state.publicationCreator, isDisplayed = _a.isDisplayed, source = _a.source;
    return {
        isDisplayed: isDisplayed,
        isFromFile: source === __WEBPACK_IMPORTED_MODULE_2__reducer__["c" /* PublicationSource */].FILE,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator__["a" /* default */]));


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_PublicationCreator_FromFile__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_PublicationCreator_FromTemplate__ = __webpack_require__(1326);



var PublicationCreator = function (_a) {
    var isDisplayed = _a.isDisplayed, isFromFile = _a.isFromFile;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_PublicationCreator_FromFile__["a" /* default */], { isDisplayed: isFromFile && isDisplayed }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_PublicationCreator_FromTemplate__["a" /* default */], { isDisplayed: !isFromFile && isDisplayed })));
};
/* harmony default export */ __webpack_exports__["a"] = (PublicationCreator);


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator_FromFile__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(87);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var _a = state.publicationCreator.fromFile, status = _a.status, percentage = _a.percentage, error = _a.error;
    return __assign({}, ownProps, { isImportingFile: status && [
            __WEBPACK_IMPORTED_MODULE_2__reducer__["b" /* PublicationCreationStatus */].IMPORTING,
            __WEBPACK_IMPORTED_MODULE_2__reducer__["b" /* PublicationCreationStatus */].PROCESSING,
        ].includes(status), importingStatus: status, importingPercentage: percentage, importingError: error });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator_FromFile__["a" /* default */]));


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceSelector__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_PublicationCreator_actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__ = __webpack_require__(11);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};







var id = 'create-proposal';
var desktopFileExtensions = __spread(__WEBPACK_IMPORTED_MODULE_6__utils_driveItem__["d" /* default */].publicationExtensions, __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__["d" /* default */].imageExtensions);
var FromFile = function (_a) {
    var isDisplayed = _a.isDisplayed, isImportingFile = _a.isImportingFile, importingStatus = _a.importingStatus, importingPercentage = _a.importingPercentage, importingError = _a.importingError, dispatch = _a.dispatch;
    var getLabel = function () { return (importingStatus
        ? "messages." + importingStatus.toLowerCase()
        : 'messages.create_proposal'); };
    var handleCancelClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_PublicationCreator_actions__["f" /* hidePublicationCreator */])());
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t(getLabel()), onCancel: handleCancelClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* PopupBodyWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ResourceSelector__["b" /* default */], { id: id, fileExtensions: desktopFileExtensions, isFileExtensionsDisplayed: false, isValidResourceFromApp: __WEBPACK_IMPORTED_MODULE_6__utils_driveItem__["d" /* default */].isValidResourceForPublication, isImportingFile: isImportingFile, importingPercentage: importingPercentage, importingError: importingError, isProcessingVideo: false, onSelect: function (_a) {
                    var _b = __read(_a, 1), resource = _b[0];
                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_PublicationCreator_actions__["c" /* createProposalFromDriveItem */])(resource, id));
                }, customImportHandler: function (file, isCorrectFileType) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_PublicationCreator_actions__["b" /* createProposalFromDesktopFile */])(file, isCorrectFileType, id)); }, onFileImportCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_PublicationCreator_actions__["h" /* removeFromCreationProgress */])()); }, dispatch: dispatch }))));
};
/* harmony default export */ __webpack_exports__["a"] = (FromFile);


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_Header_Logo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toggle__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Breadcrumbs__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DriveItemList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_customHooks_useResetDrivePage__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_Editor_CombinePanel_SpreadsSelector__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_styles_constants__ = __webpack_require__(4);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

















var RootDriveLabels;
(function (RootDriveLabels) {
    RootDriveLabels["my_documents"] = "messages.my_documents";
    RootDriveLabels["my_app"] = "messages.my_app";
    RootDriveLabels["my_drive"] = "messages.my_drive";
})(RootDriveLabels || (RootDriveLabels = {}));
var emptyFolderResources = { resources: [], extraDriveIds: [] };
var getFolderResources = function (currentDriveId, _a, privateDirId, sharedDirId, sourcesDirId) {
    var driveItems = _a.driveItems;
    if (!currentDriveId) {
        return emptyFolderResources;
    }
    var resources;
    var driveFolder = driveItems[currentDriveId];
    if (!driveFolder || !driveFolder.resources) {
        return emptyFolderResources;
    }
    resources = driveFolder.resources;
    var isPrivateDir = currentDriveId === privateDirId;
    var extraDriveIds = isPrivateDir ? [sharedDirId, sourcesDirId] : [];
    return { resources: resources, extraDriveIds: extraDriveIds };
};
var FromApp = function (_a) {
    var driveList = _a.driveList, currentDriveId = _a.currentDriveId, privateDirId = _a.privateDirId, sharedDirId = _a.sharedDirId, sourcesDirId = _a.sourcesDirId, applicationId = _a.applicationId, isValidResource = _a.isValidResource, onClose = _a.onClose, onSelect = _a.onSelect, dispatch = _a.dispatch, actionButtonColor = _a.actionButtonColor, isMultipleSelection = _a.isMultipleSelection, className = _a.className;
    var _b;
    var rootDriveConfig = (_b = {},
        _b[applicationId] = {
            id: applicationId,
            label: __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isEmbedMode() ? RootDriveLabels.my_drive : RootDriveLabels.my_app,
        },
        _b[privateDirId] = {
            id: privateDirId,
            label: RootDriveLabels.my_documents,
        },
        _b);
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](applicationId), 2), rootDriveId = _c[0], setRootDriveId = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"]([]), 2), selectedItemsIds = _d[0], setSelectedItemsIds = _d[1];
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](), 2), selectedItemId = _e[0], setSelectedItemId = _e[1];
    var _f = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isSpreadsSelectorDisplayed = _f[0], setIsSpreadsSelectorDisplayed = _f[1];
    var shouldResetDrivePage = Object(__WEBPACK_IMPORTED_MODULE_13__utils_customHooks_useResetDrivePage__["a" /* default */])([currentDriveId]);
    var getFolder = function (id, label) {
        var isSharedDir = id === sharedDirId;
        if (id === sharedDirId) {
            label = 'messages.shared_with_me';
        }
        if (id === sourcesDirId) {
            label = 'messages.sources';
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["B" /* setBreadcrumbs */])({ id: id, label: label }));
        setSelectedItemsIds([]);
        if (id && (!__WEBPACK_IMPORTED_MODULE_12__utils_userAgent__["a" /* default */].isMobileApp || isSharedDir)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id, true, true, isSharedDir));
        }
    };
    var handleRootDriveToggleClick = function (id) {
        setRootDriveId(id);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["w" /* resetBreadcrumbs */])());
        getFolder(id, rootDriveConfig[id].label);
    };
    var handleBreadcrumbClick = function (id, label) {
        getFolder(id, label);
    };
    var handleDriveItemClick = function (item) {
        var type = item.type, id = item.id, label = item.label;
        if (type === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Directory) {
            return getFolder(id, label);
        }
        if (isMultipleSelection) {
            setSelectedItemsIds(function (prevSelectedItemsIds) { return (prevSelectedItemsIds.includes(id)
                ? prevSelectedItemsIds.filter(function (itemId) { return itemId !== id; })
                : __spread(prevSelectedItemsIds, [id])); });
        }
        else {
            if (__WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isEmptyPlaylistMode()) {
                setSelectedItemId(item.id);
                setIsSpreadsSelectorDisplayed(true);
            }
            else if (onSelect) {
                onSelect([item]);
            }
            onClose();
        }
    };
    var handleConfirm = function () {
        var selectedItems = selectedItemsIds.map(function (id) { return driveList.driveItems[id]; });
        if (onSelect) {
            onSelect(selectedItems);
        }
        onClose();
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        getFolder(rootDriveId, rootDriveConfig[rootDriveId].label);
        return function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["w" /* resetBreadcrumbs */])());
        };
    }, []);
    var driveItems = driveList.driveItems, driveItemsFetchStatus = driveList.driveItemsFetchStatus, breadcrumbs = driveList.breadcrumbs;
    var isFetching = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* isFetchingState */])(currentDriveId, driveItemsFetchStatus);
    var _g = getFolderResources(currentDriveId, driveList, privateDirId, sharedDirId, sourcesDirId), resources = _g.resources, extraDriveIds = _g.extraDriveIds;
    var driveItemIds = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* getDriveItemIds */])(resources, driveList, isValidResource, extraDriveIds, function (_a) {
        var id = _a.id;
        return id !== privateDirId;
    });
    var isEmptyFolder = !isFetching && driveItemIds.length < 1;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (__WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isPlaylistMode()) {
            resources
                .forEach(function (resource) {
                if (!driveItems[resource.id]) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["i" /* fetchDriveItem */])(resource.id, currentDriveId)).then();
                }
            });
        }
    }, [resources]);
    var selectItemLabel = __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isPlaylistMode() ? 'messages.select_playlist_item' : 'messages.select_publication_item';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        !isSpreadsSelectorDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Portal__["a" /* default */], { parentNode: document.body },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* Wrapper */], { className: className },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* Header */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_Header_Logo__["a" /* default */], { isDisabled: true }),
                        isMultipleSelection &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* ButtonConfirm */], { type: "button", onClick: handleConfirm, color: actionButtonColor, disabled: selectedItemsIds.length === 0 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.ok" }))),
                    !__WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isEmbedMode() &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Toggle__["a" /* default */], { items: Object.values(rootDriveConfig), activeId: rootDriveId, onItemClick: handleRootDriveToggleClick }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* HeaderWithBorder */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonClose */], { iconWidth: "10px", iconHeight: "10px", onClick: onClose, color: __WEBPACK_IMPORTED_MODULE_16__utils_styles_constants__["b" /* NewStyleColor */].Black, disabled: __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isEmptyPlaylistMode() }, __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].getSvgIcon('iconset_close-2')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* TitleBlack */], { value: selectItemLabel })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Breadcrumbs__["a" /* default */], { items: breadcrumbs, onItemClick: handleBreadcrumbClick }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* DriveListWrapper */], null,
                        isEmptyFolder && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* EmptyFolderLabel */], { value: "messages.no_assets" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__DriveItemList__["a" /* default */], { hasBottomBar: false, searchConfig: undefined, displayType: __WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row, storeDriveItems: driveItems, driveItemIdsToDisplay: driveItemIds, folderId: currentDriveId, sharedDirId: undefined, sourcesDirId: undefined, isPrivateDir: false, isFetching: isFetching, showUnreadBadge: false, hasActions: false, hasSelectionIcon: false, navigationItems: [], shouldGetCustomTemplates: false, isEditMode: false, isEditButtonDisplayed: false, isDisplayTypeDropdownDisplayed: false, isLoading: false, isTheaterOpened: false, shouldResetPage: shouldResetDrivePage, onDriveItemClick: handleDriveItemClick, isMultipleSelection: isMultipleSelection, selectedItemsIds: selectedItemsIds, dispatch: dispatch })))),
        isSpreadsSelectorDisplayed && __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isPlaylistMode() && selectedItemId &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__containers_Editor_CombinePanel_SpreadsSelector__["a" /* default */], { resourceId: selectedItemId, onClose: function () { return setIsSpreadsSelectorDisplayed(false); } })));
};
/* harmony default export */ __webpack_exports__["a"] = (FromApp);


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 0 0 50px;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 0 0 50px;\n"])));
var ButtonsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding: 3px;\n\tborder-radius: 10px;\n\tbackground-color: ", ";\n"], ["\n\tpadding: 3px;\n\tborder-radius: 10px;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50);
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmin-width: ", ";\n\tpadding: 5px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: ", ";\n\tborder-radius: inherit;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t&:not(:first-child) {\n\t\tmargin-left: 2px;\n\t}\n\n\t", "\n"], ["\n\tmin-width: ", ";\n\tpadding: 5px;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: ", ";\n\tborder-radius: inherit;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t&:not(:first-child) {\n\t\tmargin-left: 2px;\n\t}\n\n\t",
    "\n"])), function (props) { return props.width ? props.width : '150px'; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, function (props) { return props.isActive && "\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t\tbox-shadow: 0 0 2px 0 " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 25) + ";\n\t"; });

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var List = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin: 0;\n\tpadding: 10px 48px;\n\tlist-style-type: none;\n\n\t@media ", ", ", " {\n\t\tpadding: 10px 32px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin: 0;\n\tpadding: 10px 48px;\n\tlist-style-type: none;\n\n\t@media ", ", ", " {\n\t\tpadding: 10px 32px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape);
var ListItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tpadding-right: 20px;\n\n\t&:only-child {\n\t\tbutton {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 5px;\n\t\theight: 30px;\n\t\twidth: 10px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: relative;\n\tpadding-right: 20px;\n\n\t&:only-child {\n\t\tbutton {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 5px;\n\t\theight: 30px;\n\t\twidth: 10px;\n\t\tfill: currentColor;\n\t}\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\theight: 30px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: ", ";\n\tfont-size: 13px;\n\tline-height: 30px;\n\tcolor: currentColor;\n\tcursor: ", ";\n"], ["\n\theight: 30px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: ", ";\n\tfont-size: 13px;\n\tline-height: 30px;\n\tcolor: currentColor;\n\tcursor: ", ";\n"])), function (props) { return props.disabled ? '700' : '400'; }, function (props) { return props.disabled ? 'default' : 'pointer'; });

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItem__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_actions__ = __webpack_require__(12);







var DriveItem = function (_a) {
    var driveItem = _a.driveItem, showUnreadBadge = _a.showUnreadBadge, displayType = _a.displayType, dispatch = _a.dispatch, isSelectedForContextualMenu = _a.isSelectedForContextualMenu, isDownloading = _a.isDownloading, isDownloaded = _a.isDownloaded, isDownloadInProgress = _a.isDownloadInProgress, isUpdating = _a.isUpdating, isDeletionInProgress = _a.isDeletionInProgress, isMarkingItemForDeletion = _a.isMarkingItemForDeletion, loaderStep = _a.loaderStep, thumbnailDescriptor = _a.thumbnailDescriptor, isUnread = _a.isUnread, isDraggable = _a.isDraggable, index = _a.index, _b = _a.hasActions, hasActions = _b === void 0 ? true : _b, _c = _a.hasSelectionIcon, hasSelectionIcon = _c === void 0 ? true : _c, onClick = _a.onClick, itemsCount = _a.itemsCount, draggableItemsCount = _a.draggableItemsCount, isDragPreview = _a.isDragPreview, isEditMode = _a.isEditMode, isMultipleSelection = _a.isMultipleSelection, isSelectedInMultipleSelection = _a.isSelectedInMultipleSelection, tagClasses = _a.tagClasses;
    var handleClick = function () {
        if (onClick) {
            return onClick();
        }
        var isDirectory = driveItem.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory;
        var isImage = driveItem.type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Image;
        var isAlwaysViewable = isDirectory || isImage;
        var isOnline = __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isOnline();
        var isNotViewable = !isOnline && !isDownloaded && !isAlwaysViewable;
        if (isNotViewable) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NotificationBar_actions__["c" /* createNotification */])('info.offline_download_single_asset'));
            return;
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_actions__["L" /* viewDriveItem */])(driveItem, __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].List));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ListItem__["a" /* default */], { onClick: handleClick, showUnreadBadge: showUnreadBadge, displayType: displayType, itemType: driveItem.type, itemId: driveItem.id, hasActionButton: hasActions, hasSelectionIcon: hasSelectionIcon, label: __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getDisplayName(driveItem), isSelectedForContextualMenu: isSelectedForContextualMenu, isDownloading: isDownloading, isDownloaded: isDownloaded, isDownloadInProgress: isDownloadInProgress, isMarkingItemForDeletion: isMarkingItemForDeletion, isUpdating: isUpdating, isDeletionInProgress: isDeletionInProgress, loaderStep: loaderStep, thumbnailDescriptor: thumbnailDescriptor, isUnread: isUnread, isEditMode: isEditMode, isDraggable: isEditMode && isDraggable, index: index, item: driveItem, itemsCount: itemsCount, draggableItemsCount: draggableItemsCount, isDragPreview: isDragPreview, isMultipleSelection: isMultipleSelection, isSelectedInMultipleSelection: isSelectedInMultipleSelection, tagClasses: tagClasses }));
};
/* harmony default export */ __webpack_exports__["a"] = (DriveItem);


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Selection_Toggler__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var favElement = function (props) {
    var hasSelectionIcon = props.hasSelectionIcon, selectionId = props.selectionId, displayType = props.displayType, thumbnailDescriptor = props.thumbnailDescriptor, selectionType = props.selectionType;
    var isImage = thumbnailDescriptor.isImage;
    return hasSelectionIcon && selectionId ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_Selection_Toggler__["a" /* default */], { itemId: selectionId, displayMode: __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["c" /* ResolutionDisplayType */].Card, needBottomPadding: isImage && displayType === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry, isRowView: displayType === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row, selectionType: selectionType })) : null;
};
var selectElement = function (props) {
    var isMultipleSelection = props.isMultipleSelection, isSelectedInMultipleSelection = props.isSelectedInMultipleSelection;
    if (!isMultipleSelection) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* IconCheck */], { isChecked: isSelectedInMultipleSelection }, isSelectedInMultipleSelection && __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_check-3-bold')));
};
var loaderElement = function (props) {
    var isDownloading = props.isDownloading, loaderStep = props.loaderStep, isDownloadInProgress = props.isDownloadInProgress, isUpdating = props.isUpdating, isDeletionInProgress = props.isDeletionInProgress, isMarkingItemForDeletion = props.isMarkingItemForDeletion;
    if (!isDownloading && !isDeletionInProgress && !isMarkingItemForDeletion) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Loader__["c" /* default */], { loaderStep: loaderStep ? loaderStep : { step: __WEBPACK_IMPORTED_MODULE_5__Loader__["a" /* LoaderStepName */].Downloading }, type: __WEBPACK_IMPORTED_MODULE_5__Loader__["b" /* LoaderType */].ListItem, isDownloadInProgress: isDownloadInProgress, isUpdating: isUpdating, isDeletionInProgress: isDeletionInProgress, isMarkingItemForDeletion: isMarkingItemForDeletion }));
};
var getImageComponent = function (displayType, isWrapper) {
    switch (displayType) {
        case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row:
            return isWrapper ? __WEBPACK_IMPORTED_MODULE_4__styles__["h" /* RowImageWrapper */] : __WEBPACK_IMPORTED_MODULE_4__styles__["g" /* RowBackgroundImage */];
        case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid:
        case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Coverflow:
            return isWrapper ? __WEBPACK_IMPORTED_MODULE_4__styles__["c" /* GridImageWrapper */] : __WEBPACK_IMPORTED_MODULE_4__styles__["b" /* GridBackgroundImage */];
        case __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry:
            return isWrapper ? __WEBPACK_IMPORTED_MODULE_4__styles__["f" /* MasonryImageWrapper */] : __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* MasonryImage */];
    }
};
var ImageComponent = function (props) {
    var displayType = props.displayType, thumbnailDescriptor = props.thumbnailDescriptor, isActivated = props.isActivated;
    var src = thumbnailDescriptor.src, fallbackSrc = thumbnailDescriptor.fallbackSrc;
    var imageRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var ImageWrapper = getImageComponent(displayType, true);
    var StyledImage = getImageComponent(displayType, false);
    // Preload images for non-Masonry/backgroundImage types to trigger error handler
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (displayType !== __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry && fallbackSrc && fallbackSrc !== src) {
            var img = new Image();
            img.src = src;
            img.onerror = function () {
                if (imageRef.current && fallbackSrc) {
                    imageRef.current.style.backgroundImage = "url('" + fallbackSrc + "')";
                }
            };
        }
    }, [src, fallbackSrc, displayType]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ImageWrapper, { isActivated: isActivated, className: "ImageWrapper" },
        displayType === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Masonry ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledImage, { src: src, onError: function (e) {
                var target = e.target;
                if (fallbackSrc && target.src !== fallbackSrc) {
                    target.src = fallbackSrc;
                }
            } })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledImage, { ref: imageRef, imgURL: src })),
        favElement(props),
        selectElement(props),
        loaderElement(props)));
};
var SvgComponent = function (props) {
    var displayType = props.displayType, thumbnailDescriptor = props.thumbnailDescriptor;
    var src = thumbnailDescriptor.src;
    var SvgWrapper = displayType !== __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row ? __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* BlockSvgWrapper */] : __WEBPACK_IMPORTED_MODULE_4__styles__["i" /* RowSvgWrapper */];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SvgWrapper, { className: "SvgWrapper" },
        __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon(src),
        favElement(props),
        selectElement(props),
        loaderElement(props)));
};
var ListItemThumbnail = function (props) {
    var thumbnailDescriptor = props.thumbnailDescriptor;
    var isImage = thumbnailDescriptor.isImage;
    return isImage ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ImageComponent, __assign({}, props)) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SvgComponent, __assign({}, props));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemThumbnail);


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectionToggler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_style__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var notInSelectionIcon = 'iconset_uprez_selection';
var inSelectionIcon = 'iconset_uprez_selection-bold';
var SelectionToggler = /** @class */ (function (_super) {
    __extends(SelectionToggler, _super);
    function SelectionToggler(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    SelectionToggler.prototype.render = function () {
        var _a = this.props, displayMode = _a.displayMode, color = _a.color, needBottomPadding = _a.needBottomPadding, isInSelection = _a.isInSelection, isRowView = _a.isRowView;
        var svgIcon = __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon(!isInSelection && displayMode === __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["c" /* ResolutionDisplayType */].Detail ? notInSelectionIcon : inSelectionIcon);
        var isCard = displayMode === __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["c" /* ResolutionDisplayType */].Card;
        var isDetail = displayMode === __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["c" /* ResolutionDisplayType */].Detail;
        var isCoverFlow = displayMode === __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["c" /* ResolutionDisplayType */].Coverflow;
        var tooltipId = __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].generateId();
        var tooltipText = isInSelection ? 'messages.remove_from_selection' : 'messages.add_to_selection';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledDriveItemSelectionIcon */], { onClick: this.handleClick, isCard: isCard, isInSelection: isInSelection, needBottomPadding: needBottomPadding, fillColor: color, strokeColor: !isInSelection ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey400, 100) : '', "data-tip": isDetail, "data-for": tooltipId, isRowView: isRowView, isCoverFlow: isCoverFlow },
            svgIcon,
            (__WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isDesktop() && isDetail) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Tooltip__["a" /* default */], { id: tooltipId, text: tooltipText })));
    };
    SelectionToggler.prototype.handleClick = function (e) {
        var _a = this.props, itemId = _a.itemId, selectionType = _a.selectionType, dispatch = _a.dispatch;
        e.stopPropagation();
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Selection_actions__["f" /* toggleSelection */])(itemId, selectionType));
    };
    return SelectionToggler;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* unused harmony default export */ var _unused_webpack_default_export = (SelectionToggler);


/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GridImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RowSvgWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RowImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RowBackgroundImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockSvgWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MasonryImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MasonryImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GridBackgroundImage; });
/* unused harmony export driveItemRowImageSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconCheck; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var driveItemRowImageSize = '150px';
var RowSvgWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder-radius: 9px 0 0 9px;\n\tposition: relative;\n\tbackground: ", ";\n\twidth: ", ";\n\theight: ", ";\n\n\t:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground-color: ", ";\n\t\tborder-radius: 9px 0 0 9px;\n\t}\n\n\t> svg {\n\t\theight: 60%;\n\t\twidth: 60%;\n\t\tfill: ", ";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n"], ["\n\tborder-radius: 9px 0 0 9px;\n\tposition: relative;\n\tbackground: ", ";\n\twidth: ", ";\n\theight: ", ";\n\n\t:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground-color: ", ";\n\t\tborder-radius: 9px 0 0 9px;\n\t}\n\n\t> svg {\n\t\theight: 60%;\n\t\twidth: 60%;\n\t\tfill: ", ";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n"])), function (props) { return props.theme.primary.cardColor; }, driveItemRowImageSize, driveItemRowImageSize, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 5); }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey200);
var BlockWrapperStyle = "\n\twidth: 100%;\n\tpadding-top: 100%;\n\theight: 0;\n\tposition: relative;\n\ttext-align: center;\n\toverflow: hidden;\n";
var blockUnactiveBorder = function (props) { return "\n\t" + (!props.isActivated && "box-shadow: 0 9px 39px 1px rgba(0,0,0,0.1);") + "\n"; };
var BlockSvgWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n\tbackground: ", ";\n\tborder-radius: 9px;\n\t", "\n\n\t:before {\n\t\tdisplay: block;\n\t\tcontent: \"\";\n\t\tbackground-color: ", ";\n\t\theight: auto;\n\t\twidth: 100%;\n\t\tborder-radius: 9px;\n\n\t}\n\n\t& > svg {\n\t\twidth: 39%;\n\t\theight: 39%;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\tfill: ", ";\n\t}\n"], ["\n\t", ";\n\tbackground: ", ";\n\tborder-radius: 9px;\n\t", "\n\n\t:before {\n\t\tdisplay: block;\n\t\tcontent: \"\";\n\t\tbackground-color: ", ";\n\t\theight: auto;\n\t\twidth: 100%;\n\t\tborder-radius: 9px;\n\n\t}\n\n\t& > svg {\n\t\twidth: 39%;\n\t\theight: 39%;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\tfill: ", ";\n\t}\n"])), BlockWrapperStyle, function (props) { return props.theme.primary.cardColor; }, blockUnactiveBorder, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey200);
var GridImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n\t", "\n\tborder-radius: 9px;\n"], ["\n\t", ";\n\t", "\n\tborder-radius: 9px;\n"])), BlockWrapperStyle, blockUnactiveBorder);
var MasonryImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: auto;\n\tposition: relative;\n\tborder-radius: 9px;\n\tbackground-color: ", ";\n\t", "\n"], ["\n\twidth: 100%;\n\theight: auto;\n\tposition: relative;\n\tborder-radius: 9px;\n\tbackground-color: ", ";\n\t", "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, blockUnactiveBorder);
var RowImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tborder-radius: 9px 0 0 9px;\n"], ["\n\tbackground-color: ", ";\n\tborder-radius: 9px 0 0 9px;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey100);
var MasonryImage = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('img')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\twidth: 100%;\n\tmin-height: 35px;\n\theight: auto;\n\tborder-radius: 9px;\n\tvertical-align: middle;\n"], ["\n\twidth: 100%;\n\tmin-height: 35px;\n\theight: auto;\n\tborder-radius: 9px;\n\tvertical-align: middle;\n"])));
var backgroundImage = function (props) { return "\n\tbackground-image: url('" + props.imgURL + "');\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n"; };
var RowBackgroundImage = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tborder-radius: 9px 0 0 9px;\n\twidth: ", ";\n\theight: ", ";\n\tflex-shrink: 0;\n\t", "\n"], ["\n\tborder-radius: 9px 0 0 9px;\n\twidth: ", ";\n\theight: ", ";\n\tflex-shrink: 0;\n\t", "\n"])), driveItemRowImageSize, driveItemRowImageSize, backgroundImage);
var GridBackgroundImage = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t", "\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 9px;\n"], ["\n\t", "\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 9px;\n"])), backgroundImage);
var IconCheck = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 10px;\n\twidth: 30px;\n\theight: 30px;\n\tcolor: ", ";\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\t", "\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 10px;\n\twidth: 30px;\n\theight: 30px;\n\tcolor: ", ";\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\t", "\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfill: currentColor;\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primary.actionColor;
}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 80), function (_a) {
    var isChecked = _a.isChecked;
    return isChecked && 'border: 0;';
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListItem_Infos__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__ = __webpack_require__(11);





var mapStateToProps = function (state, ownProps) {
    var downloadManager = state.downloadManager, driveList = state.driveList;
    var itemId = ownProps.itemId;
    var isUpToDate = false;
    var isUpdatable = false;
    var isEmptyContextualMenu = false;
    var proposalStats;
    var itemType;
    var publicationFormat;
    var isDownloading = false;
    if (ownProps.itemType === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].AdditionalItemType.Note) {
        return {
            itemType: __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].AdditionalItemType.Note,
            isUpToDate: isUpToDate,
            isUpdatable: isUpdatable,
            proposalStats: proposalStats,
            publicationFormat: publicationFormat,
        };
    }
    if (itemId) {
        var driveItem = driveList.driveItems[itemId];
        itemType = driveItem.type;
        proposalStats = driveItem.proposalStats;
        publicationFormat = driveItem.format;
        var isDownloaded = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, itemId);
        if (isDownloaded) {
            var downloadedItem = downloadManager.items[itemId];
            isUpToDate = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isLatestVersion(driveItem.version, downloadedItem.version)
                && !__WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].hasUpdatableDependencies(driveItem, downloadManager);
            isUpdatable = !isUpToDate;
            isDownloading = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDownloading(downloadManager, driveItem.id);
        }
        isEmptyContextualMenu = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].isEmptyContextualMenu(driveItem, state);
    }
    return {
        itemType: itemType,
        isUpToDate: isUpToDate,
        isUpdatable: isUpdatable,
        proposalStats: proposalStats,
        publicationFormat: publicationFormat,
        isEmptyContextualMenu: isEmptyContextualMenu,
        isDownloading: isDownloading,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ListItem_Infos__["a" /* default */]));


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ListItem_ActionButton__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DownloadStatus__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProposalStatus__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__ = __webpack_require__(11);








var ListItemInfos = function (props) {
    var label = props.label, itemType = props.itemType, itemId = props.itemId, isUpToDate = props.isUpToDate, isUpdatable = props.isUpdatable, proposalStats = props.proposalStats, hasActionButton = props.hasActionButton, isActiveIcon = props.isActiveIcon, isRowView = props.isRowView, onContextualMenuHover = props.onContextualMenuHover, publicationFormat = props.publicationFormat, isEmptyContextualMenu = props.isEmptyContextualMenu, isDownloading = props.isDownloading;
    var resolvedItemType = itemType ? itemType : __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory;
    var itemTypeKey = publicationFormat === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].PublicationFormat.EPUB_PLAYLIST
        ? 'fileFormat.PLAYLIST'
        : __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].getAssetTypeTranslationKey(resolvedItemType, publicationFormat);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ItemInfos */], { isRowView: isRowView, className: "ItemInfos" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ItemLabel */], { isRowView: isRowView }, label),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* ItemSubLabel */], { isRowView: isRowView },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: itemTypeKey }),
            proposalStats && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ProposalStatus__["a" /* default */], { stats: proposalStats }),
            publicationFormat === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].PublicationFormat.EPUB_PREVIEW &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ItemStatus */], null,
                    '| ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.preview" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DownloadStatus__["a" /* default */], { isUpToDate: isUpToDate, isUpdatable: isUpdatable, isRowView: isRowView, isDownloading: isDownloading }),
        hasActionButton && !isEmptyContextualMenu && itemId && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ListItem_ActionButton__["a" /* default */], { isRowView: isRowView, itemId: itemId, onContextualMenuHover: onContextualMenuHover, isActiveIcon: isActiveIcon }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemInfos);


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ItemLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ItemSubLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ItemStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var itemRowImageSize = '150px';
var itemInfosHorizontalPadding = '13px';
var ItemInfos = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t",
    "\n"])), function (props) { return props.isRowView
    ? "padding: 15px " + itemInfosHorizontalPadding + ";\n\t\t\twidth: calc(100% - " + itemRowImageSize + " - 2 * " + itemInfosHorizontalPadding + ");\n\t\t\tbackground-color: " + props.theme.primary.cardColor + ";\n\t\t\tborder-radius: 0 9px 9px 0;\n\n\t\t\t@media print {\n\t\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50 + ";\n\t\t\t}\n\t\t\t"
    : "padding: 15px 5px;\n\t\t\theight: 40px;\n\n\t\t\t@media print {\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t\t"; });
var ItemLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\n\t", "\n\tfont-weight: 500;\n\tcolor: ", ";\n\ttext-overflow: ellipsis;\n\tletter-spacing: 0.7px;\n\tline-height: 1.3;\n\toverflow: hidden;\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\t",
    "\n\n\t",
    "\n\tfont-weight: 500;\n\tcolor: ", ";\n\ttext-overflow: ellipsis;\n\tletter-spacing: 0.7px;\n\tline-height: 1.3;\n\toverflow: hidden;\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), function (props) { return props.isRowView
    ? "font-size: 14px;\n\t\t\tposition: relative;\n\t\t\ttop: -4px;"
    : "font-size: 16px;\n\t\t\twidth: calc(100% - 40px);\n\n\t\t\t@media print {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t"; }, function (props) { return props.isRowView
    ? "/* The max-height and display block are for IE not recognizing display box and line-clamp */\n\t\t\tdisplay: block;\n\t\t\tmax-height: 75px;\n\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 4;\n\t\t\t-webkit-box-orient: vertical;"
    : "display: block;\n\t\t\twhite-space: nowrap\n\n\t\t\t@media print {\n\t\t\t\twhite-space: normal;\n\t\t\t}"; }, function (props) { return props.theme.primary.contentColor; });
var ItemSubLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: 12px;\n\t", "\n\tposition: relative;\n\tvertical-align: text-top;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tline-height: 1.3;\n\n\t> svg {\n\t\tdisplay: inline-block;\n\t}\n\n\t@media print {\n\t\tcolor: ", ";\n\t}\n"], ["\n\tfont-size: 12px;\n\t",
    "\n\tposition: relative;\n\tvertical-align: text-top;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tline-height: 1.3;\n\n\t> svg {\n\t\tdisplay: inline-block;\n\t}\n\n\t@media print {\n\t\tcolor: ", ";\n\t}\n"])), function (props) { return props.isRowView
    ? "top: -2px;"
    : "top: 3px;"; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.contentColor, 50); }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);
var ItemStatus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-left: 4px;\n\tcolor: ", ";\n"], ["\n\tmargin-left: 4px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey450);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);





var ListItemActionButton = function (_a) {
    var dispatch = _a.dispatch, itemId = _a.itemId, isActiveIcon = _a.isActiveIcon, onContextualMenuHover = _a.onContextualMenuHover, isRowView = _a.isRowView;
    var onContextualMenuClick = function (e) {
        e.stopPropagation();
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_actions__["q" /* openContextualMenu */])(itemId));
    };
    var contextualMenuIconName = isActiveIcon ? 'iconset_3dots-active' : 'iconset_3dots';
    var onHover = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isDesktop()) {
            onContextualMenuHover(e);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ItemContextualMenu */], { onClick: onContextualMenuClick, onMouseOver: onHover, isRowView: isRowView }, __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon(contextualMenuIconName)));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemActionButton);


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProposalStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var ProposalStatus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding-left: 4px;\n\tcolor: ", ";\n\tdisplay: inline-block;\n"], ["\n\tpadding-left: 4px;\n\tcolor: ", ";\n\tdisplay: inline-block;\n"])), function (props) { return props.color; });

var templateObject_1;


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_DropTarget__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var mapStateToProps = function (state) {
    var galleryInfos = state.galleryInfos, routerParamsHistory = state.routerParamsHistory;
    var applicationGallery = galleryInfos.config.applicationGallery;
    return {
        folderId: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getCurrentFolderId(applicationGallery, routerParamsHistory),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_DropTarget__["a" /* default */]));


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_dnd__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_actions__ = __webpack_require__(12);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var DropTarget = function (_a) {
    var folderId = _a.folderId, index = _a.index, isLast = _a.isLast, dispatch = _a.dispatch;
    var _b = __read(Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["e" /* useDrop */])({
        accept: __WEBPACK_IMPORTED_MODULE_3__typings_dnd__["a" /* DndItemTypes */].DRIVE_ITEM,
        canDrop: function (item, monitor) {
            var sourceIndex = monitor.getItem().index;
            return index !== sourceIndex && index !== sourceIndex + 1;
        },
        drop: function (item, monitor) {
            var sourceIndex = monitor.getItem().index;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_actions__["o" /* moveDriveItem */])(folderId, sourceIndex, index));
        },
        collect: function (monitor) { return ({
            isOver: !!monitor.isOver(),
            canDrop: !!monitor.canDrop(),
        }); },
    }), 2), _c = _b[0], isOver = _c.isOver, canDrop = _c.canDrop, drop = _b[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledDropTarget */], { ref: drop, canDrop: isOver && canDrop, isLast: isLast }));
};
/* harmony default export */ __webpack_exports__["a"] = (DropTarget);


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDropTarget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledDropTarget = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: ", ";\n\tleft: -3px;\n\tright: -3px;\n\tz-index: -1;\n\theight: 100%;\n\n\t", "\n\n\t.is-dragging & {\n\t\tz-index: 10;\n\t}\n\n\t@media ", ", ", ", ", ", ", " {\n \t\ttop: -3px;\n\t\tbottom: -3px;\n\t\tleft: ", ";\n\t\tright: auto;\n\t\twidth: 100%;\n\t\theight: auto;\n\n\t\t", "\n\t}\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: ", ";\n\tleft: -3px;\n\tright: -3px;\n\tz-index: -1;\n\theight: 100%;\n\n\t",
    "\n\n\t.is-dragging & {\n\t\tz-index: 10;\n\t}\n\n\t@media ", ", ", ", ", ", ", " {\n \t\ttop: -3px;\n\t\tbottom: -3px;\n\t\tleft: ", ";\n\t\tright: auto;\n\t\twidth: 100%;\n\t\theight: auto;\n\n\t\t",
    "\n\t}\n\n\t",
    "\n"])), function (_a) {
    var isLast = _a.isLast;
    return isLast ? 'auto' : '-50%';
}, function (_a) {
    var isLast = _a.isLast;
    return isLast ? '-52%' : 'auto';
}, function (_a) {
    var canDrop = _a.canDrop, theme = _a.theme;
    return canDrop && "\n\t\tbackground: linear-gradient(0deg, transparent 0%, transparent 50%, " + Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 20) + " 50%, transparent 100%);\n\t";
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphoneLandscape, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].MediumDesktop, function (_a) {
    var isLast = _a.isLast;
    return isLast ? 'calc(50% + 11px)' : '-50%';
}, function (_a) {
    var canDrop = _a.canDrop, isLast = _a.isLast, theme = _a.theme;
    return canDrop && "\n\t\t\tbackground: " + (isLast
        ? 'none'
        : "linear-gradient(90deg, transparent 0%, transparent 49%, " + Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 20) + " 49%, transparent 75%)") + ";\n\t\t";
}, function (_a) {
    var canDrop = _a.canDrop, theme = _a.theme;
    return canDrop && "\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: calc(50% - 5px);\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\theight: 6px;\n\t\t\tborder-radius: 3px;\n\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 80) + ";\n\n\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphoneLandscape + ", " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Tablet + ", " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmallDesktop + ", " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].MediumDesktop + " {\n\t\t\t\ttop: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tleft: calc(50% - 7px);\n\t\t\t\twidth: 6px;\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t}\n\t";
});

var templateObject_1;


/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_dnd__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_actions__ = __webpack_require__(12);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var FolderDropTarget = function (_a) {
    var folderId = _a.folderId, isSmall = _a.isSmall, dispatch = _a.dispatch;
    var _b = __read(Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["e" /* useDrop */])({
        accept: __WEBPACK_IMPORTED_MODULE_3__typings_dnd__["a" /* DndItemTypes */].DRIVE_ITEM,
        canDrop: function (item, monitor) {
            var id = monitor.getItem().driveItem.id;
            return folderId !== id;
        },
        drop: function (item, monitor) {
            var id = monitor.getItem().driveItem.id;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_actions__["p" /* moveDriveItemInFolder */])(folderId, id));
        },
        collect: function (monitor) { return ({
            isOver: !!monitor.isOver(),
            canDrop: !!monitor.canDrop(),
        }); },
    }), 2), _c = _b[0], isOver = _c.isOver, canDrop = _c.canDrop, drop = _b[1];
    var DropTarget = isSmall ? __WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledSmallDropTarget */] : __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledDropTarget */];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DropTarget, { ref: drop, canDrop: isOver && canDrop }));
};
/* harmony default export */ __webpack_exports__["a"] = (FolderDropTarget);


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDropTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledSmallDropTarget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledDropTarget = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 25%;\n\tbottom: 25%;\n\tleft: 0;\n\tright: 0;\n\tz-index: -1;\n\n\t", "\n\n\t@media ", ", ", ", ", ", ", " {\n\t\ttop: 9px;\n\t\tbottom: 9px;\n\t\tleft: ", ";\n\t\tright: ", ";\n\t}\n\n\t.is-dragging & {\n\t\tz-index: 11;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 25%;\n\tbottom: 25%;\n\tleft: 0;\n\tright: 0;\n\tz-index: -1;\n\n\t",
    "\n\n\t@media ", ", ", ", ", ", ", " {\n\t\ttop: 9px;\n\t\tbottom: 9px;\n\t\tleft: ", ";\n\t\tright: ", ";\n\t}\n\n\t.is-dragging & {\n\t\tz-index: 11;\n\t}\n"])), function (_a) {
    var canDrop = _a.canDrop, theme = _a.theme;
    return canDrop && "\n\t\ttop: 9px;\n\t\tbottom: 9px;\n\t\tleft: 9px;\n\t\tright: 9px;\n\t\tborder-radius: 9px;\n\t\tbackground: " + Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 25) + ";\n\t";
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphoneLandscape, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Tablet, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmallDesktop, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].MediumDesktop, function (_a) {
    var canDrop = _a.canDrop;
    return canDrop ? '9px' : '25%';
}, function (_a) {
    var canDrop = _a.canDrop;
    return canDrop ? '9px' : '25%';
});
var StyledSmallDropTarget = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: -1;\n\tborder-radius: 5px;\n\tborder: ", ";\n\n\t", "\n\n\t.is-dragging & {\n\t\tz-index: 11;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: -1;\n\tborder-radius: 5px;\n\tborder: ", ";\n\n\t",
    "\n\n\t.is-dragging & {\n\t\tz-index: 11;\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return "1px dashed " + theme.primary.actionColor;
}, function (_a) {
    var canDrop = _a.canDrop, theme = _a.theme;
    return canDrop && "\n\t\tbackground: " + Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(theme.primary.actionColor, 25) + ";\n\t\tborder: none;\n\t";
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DriveItemListContainer; });
/* unused harmony export ListStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LoadingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledDriveItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledInfiniteScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TitleWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_infinite_scroller__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Page_styles__ = __webpack_require__(151);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var DriveItemListContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t", "\n\n\t", "\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t",
    "\n\n\t", "\n"])), function (props) { return !props.isEmpty && "\n\t\tflex: 1;\n\t\toverflow-x: hidden;\n\t\toverflow-y: auto;\n\t"; }, function (props) { return props.hasBottomBar && !props.isEmpty && "padding-bottom: " + __WEBPACK_IMPORTED_MODULE_4__Page_styles__["b" /* BottomBarHeight */] + ";"; });
var StyledDriveItemList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex: 1;\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\t-webkit-overflow-scrolling: touch;\n\tpadding: ", ";\n\n\t", "\n\n\t@media ", ", ", " {\n\t\tpadding: ", ";\n\t}\n\n\t@media print {\n\t\tposition: absolute;\n\t\ttop: 40mm;\n\t\tmargin: 0;\n\t\tdisplay: inline-block;\n\t\theight: auto;\n\t\tz-index: 100;\n\t}\n\n"], ["\n\tflex: 1;\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\t-webkit-overflow-scrolling: touch;\n\tpadding: ", ";\n\n\t", "\n\n\t@media ", ", ", " {\n\t\tpadding: ", ";\n\t}\n\n\t@media print {\n\t\tposition: absolute;\n\t\ttop: 40mm;\n\t\tmargin: 0;\n\t\tdisplay: inline-block;\n\t\theight: auto;\n\t\tz-index: 100;\n\t}\n\n"])), function (props) { return props.isCoverFlow ? '0' : '0 38px'; }, function (props) { return props.isEditMode && 'user-select: none;'; }, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].SmartphoneLandscape, function (props) { return props.isCoverFlow ? '0' : '0 22px'; });
var ListStatus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('h2')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding-left: 9px;\n"], ["\n\tpadding-left: 9px;\n"])));
var LoadingStatus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["",
    ""])), Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin: 10px 9px;\n\tfont-size: 21px;\n\tfont-weight: bold;\n\tdisplay: flex;\n\talign-items: center;\n\n\t& > svg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tmargin: 10px 9px;\n\tfont-size: 21px;\n\tfont-weight: bold;\n\tdisplay: flex;\n\talign-items: center;\n\n\t& > svg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]));
var StyledInfiniteScroll = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_infinite_scroller__)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\ttransform: translate3d(0,0,0);\n"], ["\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\ttransform: translate3d(0,0,0);\n"])));
var TitleWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\tpadding: 20px 38px 10px 38px;\n\n\t@media ", ", ", " {\n\t\tpadding: 20px 22px 10px 22px;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\tpadding: 20px 38px 10px 38px;\n\n\t@media ", ", ", " {\n\t\tpadding: 20px 22px 10px 22px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].SmartphoneLandscape);
var ButtonsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: flex-start;\n\tflex: 0 0 auto;\n\tflex-grow: 1;\n\tmargin-left: 10px;\n"], ["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: flex-start;\n\tflex: 0 0 auto;\n\tflex-grow: 1;\n\tmargin-left: 10px;\n"])));
var ButtonEdit = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tmin-width: 50px;\n\tpadding: 5px 10px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n"], ["\n\tmin-width: 50px;\n\tpadding: 5px 10px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tbackground-color: transparent;\n\tcolor: ",
    ";\n\tcursor: pointer;\n"])), function (props) { return props.isEditMode
    ? __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Green
    : props.theme.primary.actionColor; });
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, 80), __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_resize_detector__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CustomMasonry = /** @class */ (function (_super) {
    __extends(CustomMasonry, _super);
    function CustomMasonry(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeComponent = function () {
            _this.htmlElements = [];
            _this.isHtmlInitialized = false;
        };
        _this.updateChildrenRendering = function (_a) {
            var children = _a.children;
            _this.masonryItems = children.map(function (element, index) { return ({ element: element, index: index }); });
            _this.setState({
                masonryArray: _this.getMasonryArray(_this.columnNb),
            });
        };
        _this.initializeResizeListener = function () {
            if (!_this.isResizeDetectorInitialized && _this.mainContainer) {
                _this.resizeDetector = __WEBPACK_IMPORTED_MODULE_1_element_resize_detector__({ strategy: 'object' });
                _this.resizeDetector.listenTo(_this.mainContainer, function () { return _this.handleResize(); });
                _this.isResizeDetectorInitialized = true;
            }
        };
        _this.getColumnNb = function () {
            if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].SmartphoneLandscape).matches || window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Tablet).matches) {
                return 2;
            }
            else if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].SmallDesktop).matches) {
                return 3;
            }
            else if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].MediumDesktop).matches) {
                return 4;
            }
            return 1;
        };
        _this.getItemHeight = function (item) {
            var htmlElement = _this.htmlElements[item.index];
            return htmlElement ? htmlElement.offsetHeight : 1;
        };
        _this.handleResize = function () {
            var columnNb = _this.getColumnNb();
            var columnNbHasChanged = _this.columnNb !== columnNb;
            var newContainerSize = {
                width: _this.mainContainer ? _this.mainContainer.offsetWidth : 0,
                height: _this.mainContainer ? _this.mainContainer.offsetHeight : 0
            };
            var hasOnlyHeightChanged = newContainerSize.height !== _this.containerSize.height && newContainerSize.width === _this.containerSize.width;
            _this.containerSize = newContainerSize;
            if (_this.isHtmlInitialized && !hasOnlyHeightChanged && !columnNbHasChanged) {
                return;
            }
            _this.isHtmlInitialized = (_this.htmlElements && _this.htmlElements.length > 0) || _this.masonryItems.length === 0;
            _this.columnNb = columnNb;
            var masonryArray = _this.getMasonryArray(columnNb);
            _this.setState({ masonryArray: masonryArray });
        };
        _this.getMasonryArray = function (columnNb) {
            var columnHeights = [];
            var masonryArray = [];
            for (var i = 0; i < columnNb; i++) {
                columnHeights.push(0);
                masonryArray.push([]);
            }
            _this.masonryItems.forEach(function (item) {
                var itemHeight = _this.getItemHeight(item);
                var minColumn = 0;
                columnHeights.forEach(function (columnHeight, columnIndex) {
                    if (columnHeight < columnHeights[minColumn]) {
                        minColumn = columnIndex;
                    }
                });
                masonryArray[minColumn].push(item);
                columnHeights[minColumn] += itemHeight;
            });
            return masonryArray;
        };
        _this.state = { masonryArray: [] };
        _this.columnNb = _this.getColumnNb();
        _this.mainContainer = null;
        _this.isResizeDetectorInitialized = false;
        _this.containerSize = { width: 0, height: 0 };
        return _this;
    }
    CustomMasonry.prototype.componentDidMount = function () {
        this.initializeResizeListener();
        this.initializeComponent();
        this.updateChildrenRendering(this.props);
    };
    CustomMasonry.prototype.componentWillReceiveProps = function (nextProps) {
        this.initializeResizeListener();
        if (this.props.children !== nextProps.children) {
            var oldChildrenKeys = this.props.children.map(function (item) { return item.key; });
            var newChildrenKeys = nextProps.children.map(function (item) { return item.key; });
            if (oldChildrenKeys.toString() !== newChildrenKeys.toString()) {
                this.initializeComponent();
            }
            this.updateChildrenRendering(nextProps);
        }
    };
    CustomMasonry.prototype.componentWillUnmount = function () {
        if (this.mainContainer) {
            this.resizeDetector.uninstall(this.mainContainer);
        }
    };
    CustomMasonry.prototype.render = function () {
        var _this = this;
        var masonryArray = this.state.masonryArray;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledCustomMasonry */], { ref: function (element) { _this.mainContainer = element; } }, masonryArray.map(function (column, columnIndex) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MasonryColumn */], { key: columnIndex }, column.map(function (item, itemIndex) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: itemIndex, ref: function (element) { _this.htmlElements[item.index] = element; } }, item.element)); }))); })));
    };
    return CustomMasonry;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomMasonry);


/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledCustomMasonry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MasonryColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var gridGutter = '11px'; // Will be configurable in the admin in the future
var StyledCustomMasonry = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n"])));
var MasonryColumn = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\n\t@media ", ", ", " {\n\t\twidth: calc((100% - ", ") / 2);\n\t}\n\n\t@media ", " {\n\t\twidth: calc((100% - ", " * 2) / 3);\n\t}\n\n\t@media ", " {\n\t\twidth: calc((100% - ", " * 3) / 4);\n\t}\n"], ["\n\twidth: 100%;\n\n\t@media ", ", ", " {\n\t\twidth: calc((100% - ", ") / 2);\n\t}\n\n\t@media ", " {\n\t\twidth: calc((100% - ", " * 2) / 3);\n\t}\n\n\t@media ", " {\n\t\twidth: calc((100% - ", " * 3) / 4);\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet, gridGutter, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmallDesktop, gridGutter, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].MediumDesktop, gridGutter);

var templateObject_1, templateObject_2;


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Breadcrumbs__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Selection_Clearer__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);





var Title = function (props) {
    var hasBreadCrumbs = props.hasBreadCrumbs, hasClearButton = props.hasClearButton, title = props.title;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, hasBreadCrumbs
        ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_Breadcrumbs__["a" /* default */], null)
        : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* PageTitle */], { hasClearButton: hasClearButton }, title &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: title }),
                hasClearButton &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Selection_Clearer__["a" /* default */], null)))));
};
/* harmony default export */ __webpack_exports__["a"] = (Title);


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Breadcrumbs__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);




var mapStateToProps = function (state) {
    var driveList = state.driveList, galleryInfos = state.galleryInfos, routerParamsHistory = state.routerParamsHistory;
    var config = galleryInfos.config, galleryId = galleryInfos.config.applicationGallery, _a = galleryInfos.config.breadcrumbs, isCustomHomeLink = _a === void 0 ? false : _a;
    var driveItems = driveList.driveItems, isEditMode = driveList.isEditMode;
    var sharedDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSharedDirId(driveList, config);
    var archiveDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getArchiveDirId(driveList, config);
    var currentFolderId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getCurrentFolderId(galleryId, routerParamsHistory);
    var rootDirIdForEditMode = __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].getRootDirIdForEditMode(state);
    return {
        galleryId: galleryId,
        sharedDirId: sharedDirId,
        currentFolderId: currentFolderId,
        driveItems: driveItems,
        archiveDirId: archiveDirId,
        isEditMode: isEditMode,
        rootDirIdForEditMode: rootDirIdForEditMode,
        isCustomHomeLink: isCustomHomeLink
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Breadcrumbs__["a" /* default */]));


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_lib_hashHistory__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_lib_hashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_lib_hashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_FolderDropTarget__ = __webpack_require__(555);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};









var grandParentFolderLabel = '...';
var Breadcrumbs = /** @class */ (function (_super) {
    __extends(Breadcrumbs, _super);
    function Breadcrumbs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { folderTree: [] };
        return _this;
    }
    Breadcrumbs.prototype.componentDidMount = function () {
        this.computeFolderTree(this.props);
    };
    Breadcrumbs.prototype.componentWillReceiveProps = function (nextProps) {
        this.computeFolderTree(nextProps);
    };
    Breadcrumbs.prototype.render = function () {
        var folderTree = this.state.folderTree;
        var isLoaded = folderTree.length > 0;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* BreadcrumbThreadContainer */], { className: "BreadcrumbThreadContainer" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* BreadcrumbThread */], null, !isLoaded
                ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null)
                : this.renderFolderTree())));
    };
    Breadcrumbs.prototype.renderFolderTree = function () {
        var stateFolderTree = this.state.folderTree;
        var _a = this.props, galleryId = _a.galleryId, sharedDirId = _a.sharedDirId, driveItems = _a.driveItems, currentFolderId = _a.currentFolderId, archiveDirId = _a.archiveDirId;
        var folderTree = stateFolderTree;
        var isArchiveDirDescendant = __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, archiveDirId, driveItems);
        if (isArchiveDirDescendant) {
            var archiveDirIndex = folderTree.findIndex(function (_a) {
                var id = _a.id;
                return id === archiveDirId;
            });
            folderTree.splice(0, archiveDirIndex);
        }
        var isInGallery = folderTree[0].id === galleryId;
        var shouldUseSharedDirTree = !isInGallery && !isArchiveDirDescendant;
        if (shouldUseSharedDirTree
            && sharedDirId
            && currentFolderId
            && driveItems[sharedDirId]
            && driveItems[currentFolderId]) {
            folderTree = [{
                    label: __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].getDisplayName(driveItems[sharedDirId]),
                    id: sharedDirId,
                }];
            if (sharedDirId !== currentFolderId) {
                folderTree.push({
                    label: __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].getDisplayName(driveItems[currentFolderId]),
                    id: currentFolderId,
                });
            }
        }
        if (folderTree.length > 3) {
            var removedItems = folderTree.length - 3;
            var antepenultimateId = folderTree[folderTree.length - 3].id;
            folderTree.splice(1, removedItems, { id: antepenultimateId, label: grandParentFolderLabel });
        }
        return folderTree.map(this.mapFolderTreeToElements.bind(this));
    };
    Breadcrumbs.prototype.mapFolderTreeToElements = function (item, index) {
        var _a = this.props, currentFolderId = _a.currentFolderId, galleryId = _a.galleryId, driveItems = _a.driveItems, rootDirIdForEditMode = _a.rootDirIdForEditMode, isEditMode = _a.isEditMode, isCustomHomeLink = _a.isCustomHomeLink;
        if (item.id !== currentFolderId) {
            var path = "" + __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, galleryId === item.id ? '' : item.id.toString());
            if (isCustomHomeLink && galleryId === item.id) {
                path = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getPathHome();
            }
            var shouldAddDropTarget = isEditMode && __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].isDirDescendantOf(item.id, rootDirIdForEditMode, driveItems);
            return [
                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* StyledLink */], { to: "" + path + __WEBPACK_IMPORTED_MODULE_4_react_router_lib_hashHistory___default.a.getCurrentLocation().search, key: item.id },
                    shouldAddDropTarget &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_FolderDropTarget__["a" /* default */], { folderId: item.id, isSmall: true }),
                    item.label)),
                __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_forth', { key: "chevron-" + item.id })
            ];
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: item.id }, item.label);
    };
    Breadcrumbs.prototype.computeFolderTree = function (props) {
        var currentFolderId = props.currentFolderId;
        var folderTree = this.getFolderTree(currentFolderId, props);
        this.setState({ folderTree: folderTree });
    };
    Breadcrumbs.prototype.getFolderTree = function (folderId, props) {
        var galleryId = props.galleryId, sharedDirId = props.sharedDirId, driveItems = props.driveItems, dispatch = props.dispatch;
        var folder = folderId ? driveItems[folderId] : undefined;
        if (folderId) {
            if (folder) {
                var id = folder.id;
                var label = __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].getDisplayName(folder);
                var parentFolderId = __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].getParentFolderId(folder);
                if (label && id) {
                    var isRootGallery = folderId === galleryId;
                    var isRootSharedDir = sharedDirId && folderId === sharedDirId;
                    var isRoot = isRootGallery || isRootSharedDir;
                    var parentTree = parentFolderId && !isRoot ? this.getFolderTree(parentFolderId, props) : [];
                    return __spread(parentTree, [{ label: label, id: id }]);
                }
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_actions__["i" /* fetchDriveItem */])(folderId));
            }
        }
        return [];
    };
    return Breadcrumbs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Breadcrumbs);


/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BreadcrumbThreadContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbThread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(130);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var BreadcrumbThreadContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n"], ["\n\tdisplay: block;\n"])));
var BreadcrumbThread = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\talign-items: center;\n\tline-height: 10px;\n\tpadding: 0 10px;\n\tbox-sizing: border-box;\n\tfont-size: 13px;\n\n\t& > * {\n\t\tcolor: ", ";\n\t\ttext-decoration: none;\n\t\tline-height: 1.2;\n\n\t\t@media print {\n\t\t\tcolor: #000;\n\t\t}\n\t}\n\n\t& > span {\n\t\tfont-weight: 600;\n\t\tletter-spacing: 0.5px;\n\n\t\t&:first-child {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\n\t& > svg {\n\t\theight: 30px;\n\t\twidth: 10px;\n\t\tmargin: 0 5px;\n\t\tfill: ", ";\n\n\t\t@media print {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\talign-items: center;\n\tline-height: 10px;\n\tpadding: 0 10px;\n\tbox-sizing: border-box;\n\tfont-size: 13px;\n\n\t& > * {\n\t\tcolor: ", ";\n\t\ttext-decoration: none;\n\t\tline-height: 1.2;\n\n\t\t@media print {\n\t\t\tcolor: #000;\n\t\t}\n\t}\n\n\t& > span {\n\t\tfont-weight: 600;\n\t\tletter-spacing: 0.5px;\n\n\t\t&:first-child {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\n\t& > svg {\n\t\theight: 30px;\n\t\twidth: 10px;\n\t\tmargin: 0 5px;\n\t\tfill: ", ";\n\n\t\t@media print {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n"])), function (props) { return props.theme.primary.strongColor; }, function (props) { return props.theme.primary.strongColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey450);
var StyledLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tpadding: 3px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\n\t@media ", " {\n\t\tmax-width: 70px;\n\t}\n\n\t@media ", " {\n\t\tmax-width: 200px;\n\t}\n"], ["\n\tposition: relative;\n\tpadding: 3px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\n\t@media ", " {\n\t\tmax-width: 70px;\n\t}\n\n\t@media ", " {\n\t\tmax-width: 200px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Selection_Clearer__ = __webpack_require__(1261);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_Selection_Clearer__["a" /* default */]));


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toggler_styles__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);




var SelectionClearer = function (props) {
    var dispatch = props.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Toggler_styles__["a" /* SelectionClearerButton */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Selection_actions__["c" /* clearSelection */])()); } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.clear_selection" })));
};
/* harmony default export */ __webpack_exports__["a"] = (SelectionClearer);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItem__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings_dnd__ = __webpack_require__(101);





var getItemStyles = function (initialOffset, currentOffset) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        };
    }
    var x = currentOffset.x, y = currentOffset.y;
    var transform = "translate(" + x + "px, " + y + "px)";
    return {
        transform: transform,
        WebkitTransform: transform,
        opacity: 0.75,
    };
};
var DesktopDragPreview = function (_a) {
    var displayType = _a.displayType;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["d" /* useDragLayer */])(function (monitor) { return ({
        item: monitor.getItem(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    }); }), item = _b.item, initialOffset = _b.initialOffset, currentOffset = _b.currentOffset, isDragging = _b.isDragging;
    if (!isDragging || item.type !== __WEBPACK_IMPORTED_MODULE_4__typings_dnd__["a" /* DndItemTypes */].DRIVE_ITEM) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Layer */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: getItemStyles(initialOffset, currentOffset) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_DriveItem__["a" /* default */], { driveItem: item.driveItem, showUnreadBadge: false, displayType: displayType, hasActions: false, isDragPreview: true }))));
};
/* harmony default export */ __webpack_exports__["a"] = (DesktopDragPreview);


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Layer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var Layer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 100;\n\twidth: 100%;\n\theight: 100%;\n\tpointer-events: none;\n"], ["\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 100;\n\twidth: 100%;\n\theight: 100%;\n\tpointer-events: none;\n"])));

var templateObject_1;


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_multi_backend__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItem__ = __webpack_require__(348);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var generatePreview = function (_a) {
    var item = _a.item, style = _a.style;
    var newStyle = __assign({}, style, { zIndex: 100, width: '100%', opacity: 0.95 });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: newStyle },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_DriveItem__["a" /* default */], { driveItem: item.driveItem, showUnreadBadge: false, displayType: item.displayType, hasActions: false, isDragPreview: true })));
};
var TouchDragPreview = function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_dnd_multi_backend__["a" /* Preview */], null, generatePreview); };
/* harmony default export */ __webpack_exports__["a"] = (TouchDragPreview);


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragScrollerPosition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_dnd__ = __webpack_require__(101);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var DragScrollerPosition;
(function (DragScrollerPosition) {
    DragScrollerPosition["top"] = "top";
    DragScrollerPosition["bottom"] = "bottom";
})(DragScrollerPosition || (DragScrollerPosition = {}));
var scrollingInterval;
var DragScroller = function (_a) {
    var position = _a.position, container = _a.container;
    var _b = __read(Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["e" /* useDrop */])({
        accept: __WEBPACK_IMPORTED_MODULE_3__typings_dnd__["a" /* DndItemTypes */].DRIVE_ITEM,
        collect: function (monitor) { return ({
            isOver: !!monitor.isOver(),
        }); },
    }), 2), isOver = _b[0].isOver, drop = _b[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isOver) {
            var PIXELS_TO_SCROLL_1 = 20;
            scrollingInterval = global.setInterval(function () {
                var scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, clientHeight = container.clientHeight;
                var isTopEdge = position === DragScrollerPosition.top && scrollTop === 0;
                var isBottomEdge = position === DragScrollerPosition.bottom && scrollHeight - scrollTop === clientHeight;
                if (isTopEdge || isBottomEdge) {
                    clearInterval(scrollingInterval);
                }
                container.scrollTop += position === DragScrollerPosition.top
                    ? -PIXELS_TO_SCROLL_1
                    : PIXELS_TO_SCROLL_1;
            }, 10);
        }
        else {
            clearInterval(scrollingInterval);
        }
    }, [isOver]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledDragScroller */], { ref: drop, isTop: position === DragScrollerPosition.top }));
};
/* harmony default export */ __webpack_exports__["b"] = (DragScroller);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDragScroller; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledDragScroller = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.is-dragging & {\n\t\tposition: absolute;\n\t\ttop: ", ";\n\t\tbottom: ", ";\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: 10;\n\t\theight: 70px;\n\t}\n"], ["\n\t.is-dragging & {\n\t\tposition: absolute;\n\t\ttop: ", ";\n\t\tbottom: ", ";\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: 10;\n\t\theight: 70px;\n\t}\n"])), function (props) { return props.isTop ? 0 : 'auto'; }, function (props) { return !props.isTop ? 0 : 'auto'; });

var templateObject_1;


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_constants__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DriveItemListPage_constants__ = __webpack_require__(23);






var mapStateToProps = function (state) {
    var routerParamsHistory = state.routerParamsHistory;
    var currentRoute = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentRoute(routerParamsHistory);
    var currentOrigin = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentOrigin(routerParamsHistory);
    var isFolder = currentRoute === __WEBPACK_IMPORTED_MODULE_4__routes_constants__["a" /* RoutePath */].DriveItemListPage && currentOrigin === __WEBPACK_IMPORTED_MODULE_5__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder;
    var filesToDisplay = Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* getFilesToDisplay */])(state);
    return {
        isDisplayed: isFolder && filesToDisplay.length > 0,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast__["a" /* default */]));


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_ImportDesktopFile_Toast_Header__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ImportDesktopFile_Toast_SubHeader__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ImportDesktopFile_Toast_List__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(184);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var Toast = function (_a) {
    var isDisplayed = _a.isDisplayed;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](true), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["q" /* Wrapper */], { isDisplayed: isDisplayed },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_ImportDesktopFile_Toast_Header__["a" /* default */], { isToastExpanded: isExpanded, onToggle: function () { return setIsExpanded(!isExpanded); } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ImportDesktopFile_Toast_SubHeader__["a" /* default */], null),
        isExpanded && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ImportDesktopFile_Toast_List__["a" /* default */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (Toast);


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_Header__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(175);



var mapStateToProps = function (state) {
    return {
        filesIds: __WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* getFilesToDisplayIds */](state),
        importedFilesNumber: __WEBPACK_IMPORTED_MODULE_2__selectors__["e" /* getImportedFilesNumber */](state),
        isFilesWithError: __WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getFilesWithErrorNumber */](state) > 0,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_Header__["a" /* default */]));


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);




var Header = function (_a) {
    var filesIds = _a.filesIds, importedFilesNumber = _a.importedFilesNumber, isFilesWithError = _a.isFilesWithError, isToastExpanded = _a.isToastExpanded, onToggle = _a.onToggle, dispatch = _a.dispatch;
    var handleClose = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_ImportManager_actions__["j" /* removeFilesFromImport */])(filesIds));
    };
    var isAllFilesImported = filesIds.length === importedFilesNumber;
    var title = isAllFilesImported
        ? 'messages.imported_all_files'
        : 'messages.importing_files_status';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["k" /* StyledHeader */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["o" /* Title */], { value: title, importedFiles: importedFilesNumber, totalFiles: filesIds.length }),
        isFilesWithError && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* ErrorBadge */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["p" /* Toggle */], { type: "button", isExpanded: isToastExpanded, onClick: onToggle }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_down')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonClose */], { type: "button", onClick: handleClose }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_close-2'))));
};
/* harmony default export */ __webpack_exports__["a"] = (Header);


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_SubHeader__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(175);



var mapStateToProps = function (state) {
    var remainingImportTime = state.importManager.remainingImportTime;
    var filesToDisplay = __WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* getFilesToDisplay */](state);
    var importedFilesNumber = __WEBPACK_IMPORTED_MODULE_2__selectors__["e" /* getImportedFilesNumber */](state);
    var filesWithErrorNumber = __WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getFilesWithErrorNumber */](state);
    var canceledFilesNumber = __WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* getCanceledFilesNumber */](state);
    var notImportedFiles = filesToDisplay.length - filesWithErrorNumber;
    var isDisplayed = importedFilesNumber < notImportedFiles;
    var isRestartAllEnabled = notImportedFiles - importedFilesNumber === canceledFilesNumber;
    return {
        isDisplayed: isDisplayed,
        isRestartAllEnabled: isRestartAllEnabled,
        files: __WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* getFilesToDisplay */](state),
        remainingImportTime: Math.ceil(remainingImportTime),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_SubHeader__["a" /* default */]));


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemainingTimeLabel__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);






var SubHeader = function (_a) {
    var isDisplayed = _a.isDisplayed, isRestartAllEnabled = _a.isRestartAllEnabled, files = _a.files, remainingImportTime = _a.remainingImportTime, dispatch = _a.dispatch;
    var handleCancelAll = function () {
        var ids = files
            .filter(function (_a) {
            var isImportFinished = _a.isImportFinished, error = _a.error;
            return !isImportFinished && !error;
        })
            .map(function (_a) {
            var id = _a.id;
            return id;
        });
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_ImportManager_actions__["f" /* cancelFilesImport */])(ids));
    };
    var handleRestartAll = function () {
        var ids = files
            .filter(function (_a) {
            var isImportCanceled = _a.isImportCanceled;
            return isImportCanceled;
        })
            .map(function (_a) {
            var id = _a.id;
            return id;
        });
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_ImportManager_actions__["k" /* restartFilesImport */])(ids));
    };
    if (!isDisplayed) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["n" /* StyledSubHeader */], null, isRestartAllEnabled
        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* ButtonRestart */], { type: "button", onClick: handleRestartAll },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.restart_all" }),
            __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_refresh')))
        : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__RemainingTimeLabel__["a" /* default */], { seconds: remainingImportTime }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ButtonCancelAll */], { type: "button", onClick: handleCancelAll },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SubHeader);


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);


var RemainingTimeLabel = function (_a) {
    var seconds = _a.seconds;
    var DENOMINATOR = 60;
    if (seconds < DENOMINATOR) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.less_than_minute_left" });
    }
    var minutes = Math.ceil(seconds / DENOMINATOR);
    if (minutes < DENOMINATOR) {
        var messageKey_1 = minutes === 1 ? 'one_minute_left' : 'minutes_left';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages." + messageKey_1, minutes: minutes.toString() }));
    }
    var hours = Math.ceil(seconds / DENOMINATOR / DENOMINATOR);
    var messageKey = hours === 1 ? 'one_hour_left' : 'hours_left';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages." + messageKey, hours: hours.toString() }));
};
/* harmony default export */ __webpack_exports__["a"] = (RemainingTimeLabel);


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_List__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(175);



var mapStateToProps = function (state) {
    return {
        filesIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* getFilesToDisplayIds */])(state),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_List__["a" /* default */]));


/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ImportDesktopFile_Toast_ListItem__ = __webpack_require__(1276);



var List = function (_a) {
    var filesIds = _a.filesIds;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["l" /* StyledList */], null, filesIds.map(function (id) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ImportDesktopFile_Toast_ListItem__["a" /* default */], { key: id, id: id })); })));
};
/* harmony default export */ __webpack_exports__["a"] = (List);


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_ListItem__ = __webpack_require__(1277);


var mapStateToProps = function (state, ownProps) {
    var byId = state.importManager.byId;
    return {
        file: byId[ownProps.id],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_Toast_ListItem__["a" /* default */]));


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProgressCircle__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);






var getFileIconName = function (fileType) {
    if (fileType.includes('image')) {
        return 'iconset_gallery-bold';
    }
    else if (fileType.includes('video')) {
        return 'iconset_video-bold';
    }
    else {
        return 'iconset_uprez_file';
    }
};
var getFileStatus = function (_a, dispatch) {
    var id = _a.id, percentage = _a.percentage, error = _a.error, isImportCanceled = _a.isImportCanceled, isImportFinished = _a.isImportFinished;
    if (error) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* StatusError */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.error" }),
            __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_info2')));
    }
    else if (isImportFinished) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* StatusDone */], null, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_check_circle')));
    }
    else if (isImportCanceled) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* ButtonRestart */], { type: "button", onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_ImportManager_actions__["k" /* restartFilesImport */])([id])); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.restart" }),
            __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_refresh')));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ProgressCircle__["a" /* default */], { size: 20, strokeWidth: 2, percentage: percentage }));
    }
};
var ListItem = function (_a) {
    var file = _a.file, dispatch = _a.dispatch;
    var id = file.id, source = file.file, error = file.error, isImportCanceled = file.isImportCanceled, isImportFinished = file.isImportFinished;
    var isCancelEnabled = !error && !isImportCanceled && !isImportFinished;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["m" /* StyledListItem */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* FileIcon */], null, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon(getFileIconName(source.type))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* FileLabel */], null, source.name),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* FileStatus */], null,
            getFileStatus(file, dispatch),
            isCancelEnabled &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ButtonFileCancel */], { type: "button", onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_ImportManager_actions__["e" /* cancelFileImport */])(id)); } }, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_close-2')))));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["memo"](ListItem));


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1279);


var MAX_VALUE = 100;
var ProgressCircle = function (_a) {
    var percentage = _a.percentage, size = _a.size, strokeWidth = _a.strokeWidth;
    var coordinate = Math.round(size / 2);
    var radius = Math.round(coordinate - (strokeWidth / 2));
    var circleLength = radius * 2 * Math.PI;
    var currentPercentsLength = (1 - (percentage / MAX_VALUE)) * circleLength;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            percentage,
            "%"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* CircleWrapper */], { width: size, height: size, viewBox: "0 0 " + size + " " + size },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* BackCircle */], { r: radius, cx: coordinate, cy: coordinate, strokeDasharray: circleLength, strokeWidth: strokeWidth }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* FrontCircle */], { r: radius, cx: coordinate, cy: coordinate, strokeDasharray: circleLength, strokeDashoffset: currentPercentsLength, strokeWidth: strokeWidth }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ProgressCircle);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CircleWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FrontCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tmin-width: 50px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 10px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tmin-width: 50px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 10px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), function (props) { return props.theme.primary.actionColor; });
var CircleWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('svg')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: 8px;\n\ttransform: rotate(-90deg);\n"], ["\n\tmargin-left: 8px;\n\ttransform: rotate(-90deg);\n"])));
var BackCircle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('circle')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfill: transparent;\n\tstroke: ", ";\n"], ["\n\tfill: transparent;\n\tstroke: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey200);
var FrontCircle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('circle')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfill: transparent;\n\tstroke: ", ";\n\ttransition: stroke-dashoffset 0.5s linear;\n"], ["\n\tfill: transparent;\n\tstroke: ", ";\n\ttransition: stroke-dashoffset 0.5s linear;\n"])), function (props) { return props.theme.primary.actionColor; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_FilesDndUploader__ = __webpack_require__(1281);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_ImportDesktopFile_FilesDndUploader__["a" /* default */]));


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings_dnd__ = __webpack_require__(101);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var FilesDndUploader = function (_a) {
    var dispatch = _a.dispatch;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["d" /* useDragLayer */])(function (monitor) { return ({
        itemType: monitor.getItemType(),
        isDragging: monitor.isDragging(),
    }); }), itemType = _b.itemType, isDragging = _b.isDragging;
    var _c = __read(Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["e" /* useDrop */])({
        accept: __WEBPACK_IMPORTED_MODULE_4__typings_dnd__["a" /* DndItemTypes */].NATIVE_FILE,
        drop: function (item, monitor) {
            var files = monitor.getItem().files;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_ImportManager_actions__["g" /* importDesktopFiles */])(files));
        },
    }), 2), drop = _c[1];
    if (!isDragging || itemType !== __WEBPACK_IMPORTED_MODULE_4__typings_dnd__["a" /* DndItemTypes */].NATIVE_FILE) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Layer */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* DropTarget */], { ref: drop })));
};
/* harmony default export */ __webpack_exports__["a"] = (FilesDndUploader);


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Layer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropTarget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Layer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 100;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: ", ";\n"], ["\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 100;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: ", ";\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.actionColor, 20); });
var DropTarget = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n"])));

var templateObject_1, templateObject_2;


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_CoverFlow_ItemInfo__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_customHooks_usePreviousValue__ = __webpack_require__(345);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var INITIAL_SLIDE_INDEX = 0;
var CoverFlow = function (_a) {
    var folderId = _a.folderId, children = _a.children, idsToDisplay = _a.idsToDisplay, driveItems = _a.driveItems, onFolderChange = _a.onFolderChange, onSlideChange = _a.onSlideChange, _b = _a.navigationItemsLength, navigationItemsLength = _b === void 0 ? 0 : _b, _c = _a.additionalItemsLength, additionalItemsLength = _c === void 0 ? 0 : _c;
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](INITIAL_SLIDE_INDEX), 2), currentSlideIndex = _d[0], setCurrentSlideIndex = _d[1];
    var slidesLength = idsToDisplay.length + navigationItemsLength + additionalItemsLength;
    var prevSlidesLength = Object(__WEBPACK_IMPORTED_MODULE_3__utils_customHooks_usePreviousValue__["a" /* default */])(slidesLength);
    var handleSlideChange = function (index) {
        onSlideChange(index);
        setCurrentSlideIndex(index);
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        onFolderChange();
        setCurrentSlideIndex(INITIAL_SLIDE_INDEX);
    }, [folderId]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!prevSlidesLength) {
            return;
        }
        var isSlideAdded = slidesLength > prevSlidesLength;
        var isSlideRemoved = slidesLength < prevSlidesLength;
        if (isSlideAdded) {
            setCurrentSlideIndex(INITIAL_SLIDE_INDEX);
        }
        if (isSlideRemoved && currentSlideIndex === prevSlidesLength - 1) {
            setCurrentSlideIndex(currentSlideIndex - 1);
        }
    }, [slidesLength]);
    var navigationItemsIndexes = Array.from({ length: navigationItemsLength }, function (v, i) { return i; });
    var isNavigationItem = navigationItemsIndexes.includes(currentSlideIndex);
    var additionalItemsIndexes = Array.from({ length: additionalItemsLength }, function (v, i) { return i + navigationItemsLength + idsToDisplay.length; });
    var isAdditionalItem = additionalItemsIndexes.includes(currentSlideIndex);
    var currentDriveItem = driveItems[idsToDisplay[currentSlideIndex - navigationItemsLength]];
    var label = '';
    if (isNavigationItem && children) {
        currentDriveItem = children[currentSlideIndex].props;
        label = children[currentSlideIndex].props.itemLabel;
    }
    if (isAdditionalItem && children) {
        currentDriveItem = children[currentSlideIndex].props;
    }
    if (!currentDriveItem) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Slider__["a" /* default */], { slidesLength: slidesLength, currentSlideIndex: currentSlideIndex, onSlideChange: handleSlideChange }, children),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_CoverFlow_ItemInfo__["a" /* default */], { currentDriveItem: currentDriveItem, isNavigationItem: isNavigationItem, label: label })));
};
/* harmony default export */ __webpack_exports__["a"] = (CoverFlow);


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__ = __webpack_require__(4);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var BREAKPOINTS;
(function (BREAKPOINTS) {
    BREAKPOINTS[BREAKPOINTS["SmartphonePortrait"] = 481] = "SmartphonePortrait";
    BREAKPOINTS[BREAKPOINTS["Desktop"] = 1200] = "Desktop";
})(BREAKPOINTS || (BREAKPOINTS = {}));
var SLIDES_TO_SHOW;
(function (SLIDES_TO_SHOW) {
    SLIDES_TO_SHOW[SLIDES_TO_SHOW["SmartphonePortrait"] = 1] = "SmartphonePortrait";
    SLIDES_TO_SHOW[SLIDES_TO_SHOW["SmartphoneLandscape"] = 5] = "SmartphoneLandscape";
    SLIDES_TO_SHOW[SLIDES_TO_SHOW["Tablet"] = 3] = "Tablet";
    SLIDES_TO_SHOW[SLIDES_TO_SHOW["Desktop"] = 5] = "Desktop";
})(SLIDES_TO_SHOW || (SLIDES_TO_SHOW = {}));
var IS_PHONE = window.matchMedia(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["a" /* Format */].Smartphone).matches || window.matchMedia(__WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["a" /* Format */].SmartphoneLandscape).matches;
// manually set slide width for correct display when there are few items in slider
var SLIDES_LENGTH_TO_CORRECT_WIDTH = 5;
var getOptimalSlidesToShow = function (slidesLength, breakpointSlidesToShow) { return (Math.min(slidesLength - 1 || 1, breakpointSlidesToShow)); };
var getResponsiveConfig = function (slidesLength) { return ([
    {
        breakpoint: BREAKPOINTS.Desktop,
        settings: {
            slidesToShow: getOptimalSlidesToShow(slidesLength, IS_PHONE ? SLIDES_TO_SHOW.SmartphoneLandscape : SLIDES_TO_SHOW.Tablet),
        },
    },
    {
        breakpoint: BREAKPOINTS.SmartphonePortrait,
        settings: {
            slidesToShow: SLIDES_TO_SHOW.SmartphonePortrait,
        },
    },
]); };
var getSlidesToShow = function (slidesLength, sliderWidth) {
    if (sliderWidth < BREAKPOINTS.SmartphonePortrait) {
        return SLIDES_TO_SHOW.SmartphonePortrait;
    }
    else if (sliderWidth >= BREAKPOINTS.Desktop) {
        return getOptimalSlidesToShow(slidesLength, SLIDES_TO_SHOW.Desktop);
    }
    else {
        return getOptimalSlidesToShow(slidesLength, IS_PHONE ? SLIDES_TO_SHOW.SmartphoneLandscape : SLIDES_TO_SHOW.Tablet);
    }
};
var getSlideWidth = function (sliderWidth, sliderHeight, slidesLength) {
    var MAX_SLIDE_WIDTH = 350;
    var SCALE_COEF = 1.3; // is needed as center slide is scaled
    var width = sliderWidth / getSlidesToShow(slidesLength, sliderWidth);
    if (width > sliderHeight) {
        width = sliderHeight;
    }
    width = width / SCALE_COEF;
    width = Math.min(width, MAX_SLIDE_WIDTH);
    return width;
};
var Arrow = function (_a) {
    var className = _a.className, style = _a.style, onClick = _a.onClick, direction = _a.direction;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* StyledArrow */], { className: className, style: __assign({}, style), onClick: onClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use", { xlinkHref: "#svgicon-iconset_slider-" + direction })));
};
var Slider = function (_a) {
    var slidesLength = _a.slidesLength, currentSlideIndex = _a.currentSlideIndex, children = _a.children, onSlideChange = _a.onSlideChange;
    // is needed to reinit SlickSlider on resize
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"]('reinit'), 2), sliderKey = _b[0], setSliderKey = _b[1];
    var isSlideClicked = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
    var handleMouseDown = function () {
        isSlideClicked.current = true;
    };
    var handleMouseMove = function () {
        if (isSlideClicked.current) {
            document.body.classList.add('is-dragging');
        }
    };
    var handleMouseUp = function () {
        if (isSlideClicked.current) {
            document.body.classList.remove('is-dragging');
            isSlideClicked.current = false;
        }
    };
    var setSlidesWidth = function () {
        var slider = document.querySelector('.slick-slider');
        if (!slider || slidesLength > SLIDES_LENGTH_TO_CORRECT_WIDTH) {
            return;
        }
        var clientWidth = slider.clientWidth, clientHeight = slider.clientHeight;
        var slideWidth = getSlideWidth(clientWidth, clientHeight, slidesLength);
        var slides = slider.querySelectorAll('.slick-slide');
        slides.forEach(function (slide) {
            slide.style.width = slideWidth + "px";
        });
        if (slidesLength === 2) {
            // to not show a lot of duplicated items on wide screen
            var correctedSliderWidth = slideWidth * 3;
            if (correctedSliderWidth < clientWidth) {
                var correctionCoef = clientWidth > BREAKPOINTS.Desktop ? 15 : 2;
                var padding = (clientWidth - correctedSliderWidth) / 2 - correctionCoef;
                slider.style.padding = "0 " + padding + "px";
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        window.addEventListener('mouseup', handleMouseUp);
        return function () {
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (slidesLength > SLIDES_LENGTH_TO_CORRECT_WIDTH) {
            return;
        }
        setSlidesWidth();
        var handleResize = function () {
            setSliderKey(sliderKey + "-" + Date.now());
        };
        // Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', handleResize);
        }
        else {
            window.addEventListener('resize', handleResize);
        }
        return function () {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', handleResize);
            }
            else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [slidesLength]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* Wrapper */], { slidesLength: slidesLength, currentSlideIndex: currentSlideIndex, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseUp: handleMouseUp },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_slick___default.a, { key: sliderKey, variableWidth: slidesLength <= SLIDES_LENGTH_TO_CORRECT_WIDTH, centerMode: true, slidesToShow: getOptimalSlidesToShow(slidesLength, SLIDES_TO_SHOW.Desktop), dots: false, infinite: true, speed: 500, lazyLoad: slidesLength > SLIDES_LENGTH_TO_CORRECT_WIDTH ? 'ondemand' : undefined, swipeToSlide: true, initialSlide: currentSlideIndex, responsive: getResponsiveConfig(slidesLength), prevArrow: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Arrow, { direction: "previous" }), nextArrow: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Arrow, { direction: "next" }), onReInit: setSlidesWidth, afterChange: onSlideChange }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (Slider);


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _innerSlider = __webpack_require__(1286);

var _json2mq = _interopRequireDefault(__webpack_require__(1293));

var _defaultProps = _interopRequireDefault(__webpack_require__(1295));

var _innerSliderUtils = __webpack_require__(249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1296);

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
      } else {
        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push(_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push(_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push(_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return _react["default"].createElement("div", {
          className: className
        }, newChildren);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return _react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _initialState = _interopRequireDefault(__webpack_require__(1287));

var _lodash = _interopRequireDefault(__webpack_require__(1288));

var _classnames = _interopRequireDefault(__webpack_require__(141));

var _innerSliderUtils = __webpack_require__(249);

var _track = __webpack_require__(1289);

var _dots = __webpack_require__(1290);

var _arrows = __webpack_require__(1291);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(1292));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, {}, _this.state);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom["default"].findDOMNode(_this.track)) return;

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, {}, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread({}, _this.props, {}, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
        index: index
      }, _this.props, {}, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), _react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread({}, _initialState["default"], {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(141));

var _innerSliderUtils = __webpack_require__(249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread({
        outline: "none"
      }, child.props.style || {}, {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react["default"].createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(141));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames["default"])({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react["default"].createElement("li", {
          key: i,
          className: className
        }, _react["default"].cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(141));

var _innerSliderUtils = __webpack_require__(249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
      } else {
        prevArrow = _react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
      } else {
        nextArrow = _react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(1294);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(1297);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(1298);
var Util = __webpack_require__(560);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(1299);
var each = __webpack_require__(560).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 1299 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledArrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: calc(100% - 60px);\n\n\t.slick-slider {\n\t\theight: 100%;\n\t\tmargin: 0 auto;\n\n\t\t.slick-track {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t", "\n\t\t}\n\n\t\t.slick-slide {\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t.slick-list,\n\t.slick-track,\n\t.slick-active > div {\n\t\theight: 100%;\n\t}\n\n\t.slick-center {\n\t\tposition: relative;\n\t\tz-index: 100;\n\t}\n\n\t.slick-slide {\n\t\ttransform-style: preserve-3d;\n\t\tperspective: 500px;\n\t\tbackface-visibility: hidden;\n\t\ttransition: all 0.5s ease;\n\t\toutline: none;\n\n\t\t> div {\n\t\t\ttransition: all 0.5s ease;\n\t\t\t-webkit-box-reflect: below 1px -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0));\n\t\t}\n\n\t\t.is-dragging & {\n\t\t\t> div {\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.slick-slide:not(.slick-current) {\n\t\t> div {\n\t\t\ttransform: rotateY(15deg);\n\t\t}\n\t}\n\n\t.slick-current ~ .slick-slide > div {\n\t\ttransform: rotateY(-15deg);\n\t}\n\n\t.slick-current > div {\n\t\ttransform: scale(1.2);\n\t\tborder-radius: 9px;\n\t\tbox-shadow: 0 10px 10px 5px ", ";\n\t}\n\n\t", "\n"], ["\n\theight: calc(100% - 60px);\n\n\t.slick-slider {\n\t\theight: 100%;\n\t\tmargin: 0 auto;\n\n\t\t.slick-track {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t", "\n\t\t}\n\n\t\t.slick-slide {\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t.slick-list,\n\t.slick-track,\n\t.slick-active > div {\n\t\theight: 100%;\n\t}\n\n\t.slick-center {\n\t\tposition: relative;\n\t\tz-index: 100;\n\t}\n\n\t.slick-slide {\n\t\ttransform-style: preserve-3d;\n\t\tperspective: 500px;\n\t\tbackface-visibility: hidden;\n\t\ttransition: all 0.5s ease;\n\t\toutline: none;\n\n\t\t> div {\n\t\t\ttransition: all 0.5s ease;\n\t\t\t-webkit-box-reflect: below 1px -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0));\n\t\t}\n\n\t\t.is-dragging & {\n\t\t\t> div {\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.slick-slide:not(.slick-current) {\n\t\t> div {\n\t\t\ttransform: rotateY(15deg);\n\t\t}\n\t}\n\n\t.slick-current ~ .slick-slide > div {\n\t\ttransform: rotateY(-15deg);\n\t}\n\n\t.slick-current > div {\n\t\ttransform: scale(1.2);\n\t\tborder-radius: 9px;\n\t\tbox-shadow: 0 10px 10px 5px ", ";\n\t}\n\n\t",
    "\n"])), function (_a) {
    var slidesLength = _a.slidesLength;
    return slidesLength === 1 && 'justify-content: center;';
}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 10), function (_a) {
    var currentSlideIndex = _a.currentSlideIndex;
    return "\n\t\t.slick-slide:not(.slick-current)[data-index=\"" + (currentSlideIndex - 1) + "\"],\n\t\t.slick-slide:not(.slick-current)[data-index=\"" + (currentSlideIndex + 1) + "\"] {\n\t\t\t> div {\n\t\t\t\topacity: 0.9;\n\t\t\t}\n\t\t}\n\n\t\t.slick-slide[data-index=\"" + (currentSlideIndex - 2) + "\"],\n\t\t.slick-slide[data-index=\"" + (currentSlideIndex + 2) + "\"] {\n\t\t\t> div {\n\t\t\t\topacity: 0.8;\n\t\t\t}\n\t\t}\n\n\t\t.slick-slide[data-index=\"" + (currentSlideIndex - 3) + "\"],\n\t\t.slick-slide[data-index=\"" + (currentSlideIndex + 3) + "\"] {\n\t\t\t> div {\n\t\t\t\topacity: 0.7;\n\t\t\t}\n\t\t}\n\t";
});
var StyledArrow = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('svg')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tz-index: 1;\n\tfill: ", ";\n\tpointer-events: all;\n\n\t&.slick-prev,\n\t&.slick-next {\n\t\tbox-sizing: border-box;\n\t\twidth: 40px;\n\t\theight: 100px;\n\t\tpadding: 0 14px;\n\t}\n\n\t&.slick-prev {\n\t\tleft: 0;\n\t}\n\n\t&.slick-next {\n\t\tright: 0;\n\t}\n"], ["\n\tz-index: 1;\n\tfill: ", ";\n\tpointer-events: all;\n\n\t&.slick-prev,\n\t&.slick-next {\n\t\tbox-sizing: border-box;\n\t\twidth: 40px;\n\t\theight: 100px;\n\t\tpadding: 0 14px;\n\t}\n\n\t&.slick-prev {\n\t\tleft: 0;\n\t}\n\n\t&.slick-next {\n\t\tright: 0;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black);

var templateObject_1, templateObject_2;


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CoverFlow_ItemInfo__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);



var mapStateToProps = function (state, _a) {
    var currentDriveItem = _a.currentDriveItem;
    return {
        isEmptyContextualMenu: __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].isEmptyContextualMenu(currentDriveItem, state),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CoverFlow_ItemInfo__["a" /* default */]));


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ListItem_ActionButton__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Selection_Toggler__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_CoverFlow_UnreadBadge__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_CoverFlow_DownloadStatus__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListItem_ProposalStatus__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_indexedDB_manager__ = __webpack_require__(21);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












var ItemInfo = function (_a) {
    var currentDriveItem = _a.currentDriveItem, isNavigationItem = _a.isNavigationItem, label = _a.label, isEmptyContextualMenu = _a.isEmptyContextualMenu;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](''), 2), noteLabel = _b[0], setNoteLabel = _b[1];
    var id = currentDriveItem.id, type = currentDriveItem.type;
    var _c = currentDriveItem, format = _c.format, proposalStats = _c.proposalStats;
    var driveItemTypeKey = __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].getAssetTypeTranslationKey(type, format);
    var isNote = type === __WEBPACK_IMPORTED_MODULE_10__typings_api__["a" /* Api */].AdditionalItemType.Note;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isNote) {
            __WEBPACK_IMPORTED_MODULE_11__utils_indexedDB_manager__["a" /* default */].getNote(id).then(function (note) {
                if (note) {
                    setNoteLabel(note.title);
                }
            });
        }
    }, [id]);
    var getLabel = function () {
        if (isNavigationItem) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label });
        }
        else if (isNote) {
            return noteLabel;
        }
        return __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].getDisplayName(currentDriveItem);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Label */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, getLabel()),
            '|',
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: driveItemTypeKey }),
            proposalStats && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ListItem_ProposalStatus__["a" /* default */], { stats: proposalStats }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_CoverFlow_UnreadBadge__["a" /* default */], { id: id }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_CoverFlow_DownloadStatus__["a" /* default */], { id: id, isRowView: false })),
        !isNavigationItem &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ActionsWrapper */], null,
                !isEmptyContextualMenu && !isNote &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ListItem_ActionButton__["a" /* default */], { isRowView: false, itemId: id, onContextualMenuHover: function () { return undefined; }, isActiveIcon: false }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Selection_Toggler__["a" /* default */], { itemId: id, displayMode: __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["c" /* ResolutionDisplayType */].Coverflow, selectionType: isNote ? __WEBPACK_IMPORTED_MODULE_5__containers_Selection_actions__["b" /* SelectionType */].NOTES : __WEBPACK_IMPORTED_MODULE_5__containers_Selection_actions__["b" /* SelectionType */].RESOURCES }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ItemInfo);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItem_ActionButton_styles__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItem_styles__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListItem_DownloadStatus_styles__ = __webpack_require__(553);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: 60px;\n\tpadding: 10px 20px;\n\tbackground-color: ", ";\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\theight: 60px;\n\tpadding: 10px 20px;\n\tbackground-color: ", ";\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey700);
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\n\t&:not(:only-child) {\n\t\twidth: calc(100% - 100px);\n\t\tmargin-right: 20px;\n\t}\n\n\t> span {\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t> *:not(:first-child) {\n\t\tflex: 0 0 auto;\n\t}\n\n\t> span:first-of-type {\n\t\tmargin-right: 4px;\n\t}\n\n\t> span:last-of-type {\n\t\tmargin-left: 4px;\n\t}\n\n\t", " {\n\t\tposition: relative;\n\t\ttop: 1px;\n\t\tleft: 0;\n\t\tmargin-left: 10px;\n\t}\n\n\t", " svg {\n\t\tposition: relative;\n\t\ttop: -1px;\n\t\tvertical-align: middle;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\n\t&:not(:only-child) {\n\t\twidth: calc(100% - 100px);\n\t\tmargin-right: 20px;\n\t}\n\n\t> span {\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t> *:not(:first-child) {\n\t\tflex: 0 0 auto;\n\t}\n\n\t> span:first-of-type {\n\t\tmargin-right: 4px;\n\t}\n\n\t> span:last-of-type {\n\t\tmargin-left: 4px;\n\t}\n\n\t", " {\n\t\tposition: relative;\n\t\ttop: 1px;\n\t\tleft: 0;\n\t\tmargin-left: 10px;\n\t}\n\n\t", " svg {\n\t\tposition: relative;\n\t\ttop: -1px;\n\t\tvertical-align: middle;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__ListItem_styles__["e" /* ListItemUnreadBadge */], __WEBPACK_IMPORTED_MODULE_4__ListItem_DownloadStatus_styles__["a" /* DownloadStatus */]);
var ActionsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\n\t", " {\n\t\tposition: static;\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tdisplay: flex;\n\n\t", " {\n\t\tposition: static;\n\t\tmargin-right: 20px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__ListItem_ActionButton_styles__["a" /* ItemContextualMenu */]);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CoverFlow_UnreadBadge__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);




var mapStateToProps = function (state, _a) {
    var id = _a.id;
    var driveList = state.driveList, readStatus = state.readStatus, routerParamsHistory = state.routerParamsHistory;
    return {
        isUnread: ['new', 'downloads'].includes(__WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentOrigin(routerParamsHistory)) && __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].isUnread(driveList, readStatus, id),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CoverFlow_UnreadBadge__["a" /* default */]));


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListItem_styles__ = __webpack_require__(350);


var UnreadBadge = function (_a) {
    var isUnread = _a.isUnread;
    if (!isUnread) {
        return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ListItem_styles__["e" /* ListItemUnreadBadge */], null);
};
/* harmony default export */ __webpack_exports__["a"] = (UnreadBadge);


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListItem_DownloadStatus__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);



var mapStateToProps = function (state, _a) {
    var id = _a.id;
    var downloadManager = state.downloadManager, driveList = state.driveList;
    var isUpToDate = false;
    var isUpdatable = false;
    if (id) {
        var driveItem = driveList.driveItems[id];
        var isDownloaded = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, id);
        if (isDownloaded) {
            var downloadedItem = downloadManager.items[id];
            isUpToDate = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isLatestVersion(driveItem.version, downloadedItem.version);
            isUpdatable = !isUpToDate;
        }
    }
    return {
        isUpToDate: isUpToDate,
        isUpdatable: isUpdatable,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ListItem_DownloadStatus__["a" /* default */]));


/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DropdownMenu__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_customHooks_useClickOutside__ = __webpack_require__(149);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var DisplayTypeDropdown = function (_a) {
    var displayType = _a.displayType, folderId = _a.folderId, dispatch = _a.dispatch;
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isMenuDisplayed = _b[0], setIsMenuDisplayed = _b[1];
    Object(__WEBPACK_IMPORTED_MODULE_7__utils_customHooks_useClickOutside__["a" /* default */])(wrapperElement, isMenuDisplayed, function () { return setIsMenuDisplayed(false); });
    var config = Object.values(__WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */]).reduce(function (acc, current) {
        if (current === __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_constants__["b" /* ListDisplayType */].Default) {
            return acc;
        }
        acc[current] = {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t("messages." + current.toLowerCase()),
            icon: "iconset_uprez_" + current.toLowerCase(),
            isActive: displayType === current,
            onClick: function () {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["C" /* setFolderDisplayType */])(folderId, current));
                setIsMenuDisplayed(false);
            },
            hasSeparator: true,
        };
        return acc;
    }, {});
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* Wrapper */], { ref: wrapperElement },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Button */], { type: "button", isMenuDisplayed: isMenuDisplayed, onClick: function () { return setIsMenuDisplayed(function (prevState) { return !prevState; }); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.view" }),
            __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_triangle-1')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__DropdownMenu__["a" /* default */], { config: config, isDisplayed: isMenuDisplayed })));
};
/* harmony default export */ __webpack_exports__["a"] = (DisplayTypeDropdown);


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropdownMenu_styles__ = __webpack_require__(337);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\n\t", " {\n\t\tleft: auto;\n\t\tright: 0;\n\t\twidth: 200px;\n\t}\n\n\t", " svg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: relative;\n\n\t", " {\n\t\tleft: auto;\n\t\tright: 0;\n\t\twidth: 200px;\n\t}\n\n\t", " svg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: currentColor;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__DropdownMenu_styles__["a" /* StyledMenu */], __WEBPACK_IMPORTED_MODULE_1__DropdownMenu_styles__["b" /* StyledMenuButton */]);
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmin-width: 50px;\n\tpadding: 5px 10px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 7px;\n\t\theight: 8px;\n\t\tmargin-left: 5px;\n\t\tfill: currentColor;\n\n\t\t", "\n\t}\n"], ["\n\tmin-width: 50px;\n\tpadding: 5px 10px;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 7px;\n\t\theight: 8px;\n\t\tmargin-left: 5px;\n\t\tfill: currentColor;\n\n\t\t", "\n\t}\n"])), function (props) { return props.theme.primary.actionColor; }, function (_a) {
    var isMenuDisplayed = _a.isMenuDisplayed;
    return isMenuDisplayed && 'transform: rotate(180deg);';
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_url__ = __webpack_require__(26);







var TagType;
(function (TagType) {
    TagType["Tag"] = "tag";
    TagType["Keyword"] = "keyword";
})(TagType || (TagType = {}));
var TagTrail = function (_a) {
    var categorySeparator = _a.categorySeparator, originParam = _a.originParam;
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var setSearchString = function (originParam) {
        if (!originParam) {
            return null;
        }
        var regex = /tags\[(.*)\]/g;
        var match = regex.exec(originParam);
        if (match) {
            return __WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].removeTrailingChar(originParam.replace(match[0], '').trim());
        }
        return originParam;
    };
    var setTagTrailObject = function (originParam) {
        if (!originParam) {
            return null;
        }
        var searchTrail = decodeURIComponent(originParam);
        var tagsIndex = searchTrail.indexOf(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["b" /* TagMarkers */].Start);
        var structuredTagTrail = [];
        var tagsString;
        if (tagsIndex !== -1) {
            tagsString = searchTrail.substring(tagsIndex + __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["b" /* TagMarkers */].Start.length, searchTrail.length - 1);
        }
        if (tagsString) {
            var categories = tagsString.split(',');
            categories.forEach(function (category) {
                var tags = category.split('||');
                var tagCategory = { tags: [] };
                tags.forEach(function (tag) {
                    if (!categorySeparator || tag.indexOf(categorySeparator) === -1) {
                        tagCategory.tags.push(tag);
                        return;
                    }
                    tagCategory.tags.push(tag.substring(tag.indexOf(categorySeparator) + categorySeparator.length, tag.length));
                    if (!tagCategory.hasOwnProperty('name')) {
                        tagCategory.name = tag.substring(0, tag.indexOf(categorySeparator));
                    }
                });
                structuredTagTrail.push(tagCategory);
            });
            return structuredTagTrail;
        }
        return null;
    };
    var tagTrailToString = function (structuredTagTrail, exclude) {
        var categories = [];
        structuredTagTrail.forEach(function (category) {
            var tagIds = [];
            category.tags.forEach(function (tag) {
                var tagId = category.name && categorySeparator ? category.name + categorySeparator + tag : tag;
                if (tagId && tagId !== exclude) {
                    tagIds.push(tagId);
                }
            });
            if (tagIds.length) {
                categories.push(tagIds.join('||'));
            }
        });
        return categories.join(',');
    };
    var handleRemoveTag = function (id, type) {
        var searchQuery = '';
        if (searchString && type === TagType.Tag) {
            searchQuery += searchString + '&';
        }
        if (structuredTagTrail) {
            var nextTagsString = tagTrailToString(structuredTagTrail, id);
            if (nextTagsString) {
                searchQuery += __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["b" /* TagMarkers */].Start + nextTagsString + __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["b" /* TagMarkers */].End;
            }
        }
        if (!searchQuery) {
            return __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].getPathHome());
        }
        window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search, encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].removeTrailingChar(searchQuery)));
    };
    var renderTagElement = function (type, name, tagId, key) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Tag */], { className: "Tag", key: key || tagId },
            name,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* RemoveTag */], { onClick: function () { return handleRemoveTag(tagId, type); } }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_close-1'))));
    };
    var renderTagCategories = function (category, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Category */], { key: i },
        category.name && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* CategoryName */], null, category.name)),
        category.tags.map(function (tag, j) {
            var tagId = category.name && categorySeparator ? category.name + categorySeparator + tag : tag;
            return renderTagElement(TagType.Tag, tag, tagId, j);
        }))); };
    var searchString = setSearchString(originParam);
    var structuredTagTrail = setTagTrailObject(originParam);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* TagTrailWrapper */], { ref: wrapperElement, className: "TagTrailWrapper" },
        searchString && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Category */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* CategoryName */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.search_phrase" })),
            renderTagElement(TagType.Keyword, searchString, searchString))),
        structuredTagTrail && structuredTagTrail.map(renderTagCategories)));
};
/* harmony default export */ __webpack_exports__["a"] = (TagTrail);


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TagTrailWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CategoryName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Tag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RemoveTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var TagTrailWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 100%;\n\tpadding: 5px 48px;\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 100%;\n\tpadding: 5px 48px;\n"])));
var Category = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tmargin-right: 20px;\n"], ["\n\tdisplay: inline-block;\n\tmargin-right: 20px;\n"])));
var CategoryName = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-weight: 600;\n\tpadding-right: 5px;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"], ["\n\tfont-weight: 600;\n\tpadding-right: 5px;\n\tcolor: ", ";\n\n\t@media print {\n\t\tcolor: #000;\n\t}\n"])), function (props) { return props.theme.primary.contentColor; });
var Tag = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbackground: ", ";\n\tborder-radius: 20px;\n\tdisplay: inline-block;\n\tpadding: 5px 10px;\n\tmargin: 5px 5px 5px 0;\n\tcolor: ", ";\n\n\t@media print {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t}\n"], ["\n\tbackground: ", ";\n\tborder-radius: 20px;\n\tdisplay: inline-block;\n\tpadding: 5px 10px;\n\tmargin: 5px 5px 5px 0;\n\tcolor: ", ";\n\n\t@media print {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.contentColor, 15); }, function (props) { return props.theme.primary.contentColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey100, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800);
var RemoveTag = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tmargin-left: 5px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tmargin-left: 5px;\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.theme.primary.actionColor; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonPDF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var ButtonPDF = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tcursor: pointer;\n\tpadding: 5px;\n\tborder-radius: 6px;\n\n\tspan {\n\t\tfont-size: 12px;\n\t\tcolor: ", ";\n\t}\n\n\tsvg {\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\tmargin-right: 5px;\n\t\tposition: relative;\n\t\ttop: 3px;\n\t\tfill: ", ";\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", "\n\t}\n"], ["\n\tposition: relative;\n\tcursor: pointer;\n\tpadding: 5px;\n\tborder-radius: 6px;\n\n\tspan {\n\t\tfont-size: 12px;\n\t\tcolor: ", ";\n\t}\n\n\tsvg {\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\tmargin-right: 5px;\n\t\tposition: relative;\n\t\ttop: 3px;\n\t\tfill: ", ";\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", "\n\t}\n"])), function (props) { return props.theme.primary.actionColor; }, function (props) { return props.theme.primary.actionColor; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_1__utils_style__["a" /* hexToRgba */])(props.theme.primary.actionColor, 10); });

var templateObject_1;


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ButtonZoom__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_CombinePanel_SpreadsSelector_Grid__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Spinner__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);










var SpreadsSelector = function (_a) {
    var resourceId = _a.resourceId, isLoading = _a.isLoading, isCombining = _a.isCombining, selectedSpreadIndices = _a.selectedSpreadIndices, isSelectedAll = _a.isSelectedAll, spreads = _a.spreads, onClose = _a.onClose, dispatch = _a.dispatch;
    var bodyElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["j" /* getExternalPublicationData */])(resourceId));
        return function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["B" /* resetExternalPublicationData */])());
        };
    }, [resourceId]);
    var handleItemClick = function (index, isCtrlPressed, isShiftPressed) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["G" /* selectExternalSpread */])(index, spreads, isCtrlPressed, isShiftPressed));
    };
    var handleSelectAllClick = function () {
        if (isSelectedAll) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["f" /* deselectAllExternalSpreads */])());
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["F" /* selectAllExternalSpreads */])());
        }
    };
    var handleCombineClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["e" /* createComboWithExternalSpreads */])(function () {
            // Reload resource in react-admin after adding reference/s to an empty playlist in the Editor
            if (__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].isEmptyPlaylistMode()) {
                var parentOrigin = new URL(document.referrer).origin;
                window.parent.postMessage(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_constants__["d" /* EditorMessageTypes */].RELOAD_PUBLICATION_SETTINGS, parentOrigin);
            }
        }));
    };
    var handleZoomClick = function (zoom) {
        if (bodyElement.current) {
            var grid = bodyElement.current.firstElementChild;
            var gridItem = grid.firstElementChild;
            var gridWidth = grid.getBoundingClientRect().width;
            var width = gridItem.getBoundingClientRect().width;
            var _a = window.getComputedStyle(gridItem), marginLeft = _a.marginLeft, marginRight = _a.marginRight;
            var margin = parseFloat(marginLeft) + parseFloat(marginRight);
            var itemsInRow = Math.floor(gridWidth / (width + margin));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["_9" /* zoomExternalSpreads */])(zoom, itemsInRow));
        }
    };
    var combineButtonLabel = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].isPlaylistMode() ? 'messages.add' : 'messages.combine';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* Header */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Header_styles__["b" /* HeaderButton */], { iconWidth: "10px", iconHeight: "10px", onClick: onClose }, __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_close-2')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* Title */], { value: "messages.combine_by_selecting_pages" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ButtonSelectAll */], { disabled: isLoading, onClick: handleSelectAllClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages." + (isSelectedAll ? 'deselect_all' : 'select_all') })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ButtonZoom__["a" /* default */], { isDisabled: isLoading || isCombining, onClick: handleZoomClick }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonCombine */], { disabled: selectedSpreadIndices.length === 0 || isCombining, onClick: handleCombineClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: combineButtonLabel }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Body */], { ref: bodyElement },
            isLoading
                ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Loader */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinner__["a" /* default */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })))
                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_CombinePanel_SpreadsSelector_Grid__["a" /* default */], { onItemClick: handleItemClick }),
            isCombining && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Loader */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinner__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.combining", percentage: "0" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SpreadsSelector);


/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Body; });
/* unused harmony export Footer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonCombine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonSelectAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 11;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: ", ";\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 11;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black);
var Header = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 0 0 50px;\n\tpadding: 0 12px;\n\tborder-bottom: 1px solid ", ";\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 0 0 50px;\n\tpadding: 0 12px;\n\tborder-bottom: 1px solid ", ";\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey450, 50), __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMacApp() && "padding-top: " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["f" /* macTopBarHeight */] + ";");
var Body = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t", "\n"], ["\n\tposition: relative;\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__styles__["j" /* getEditorScrollStyles */])());
var Footer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex: 0 0 50px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: 0 20px;\n\tbackground-color: ", ";\n"], ["\n\tflex: 0 0 50px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: 0 20px;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Grey900);
var Title = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tmargin-left: 6px;\n\tmargin-right: auto;\n\tpadding-right: 6px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 600;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tmargin-left: 6px;\n\tmargin-right: auto;\n\tpadding-right: 6px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 600;\n\tfont-size: 15px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White);
var ButtonCombine = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 30px;\n\tmargin-left: 10px;\n\tpadding: 5px 20px;\n\tborder: 0;\n\tborder-radius: 15px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 19px;\n\tcolor: ", ";\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 30px;\n\tmargin-left: 10px;\n\tpadding: 5px 20px;\n\tborder: 0;\n\tborder-radius: 15px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 19px;\n\tcolor: ", ";\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Blue450, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
});
var ButtonSelectAll = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 90px;\n\twidth: 90px;\n\tmin-width: 82px;\n\theight: 35px;\n\tpadding: 7px;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tmargin-right: 6px;\n\n\t& + & {\n\t\tmargin-right: 6px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 90px;\n\twidth: 90px;\n\tmin-width: 82px;\n\theight: 35px;\n\tpadding: 7px;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tmargin-right: 6px;\n\n\t& + & {\n\t\tmargin-right: 6px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White, 12), function (_a) {
    var color = _a.color;
    return color || __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White;
});
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: ", ";\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: ", ";\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].Black, 75), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["b" /* NewStyleColor */].White);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel_SpreadsSelector_Grid__ = __webpack_require__(1315);


var mapStateToProps = function (state) {
    var spreads = state.editor.combo.externalPublication.spreads;
    return {
        spreads: spreads,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel_SpreadsSelector_Grid__["a" /* default */]));


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_CombinePanel_SpreadsSelector_Grid_Item__ = __webpack_require__(1317);



var Grid = function (_a) {
    var spreads = _a.spreads, onItemClick = _a.onItemClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* List */], null, spreads.map(function (spread, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_CombinePanel_SpreadsSelector_Grid_Item__["a" /* default */], { key: spread[0], spread: spread, spreadIndex: index, onClick: onItemClick })); })));
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var List = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-content: flex-start;\n\tmargin: 0;\n\tpadding: 15px 25px 8px;\n\tlist-style-type: none;\n"], ["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-content: flex-start;\n\tmargin: 0;\n\tpadding: 15px 25px 8px;\n\tlist-style-type: none;\n"])));

var templateObject_1;


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel_SpreadsSelector_Grid_Item__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_url__ = __webpack_require__(26);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var mapStateToProps = function (state, ownProps) {
    var galleryConfig = state.galleryInfos.config, _a = state.editor, _b = _a.combo.externalPublication, globalId = _b.globalId, selectedSpreadIndices = _b.selection.spreadIndices, thumbnails = _b.thumbnails, thumbnailPath = _b.thumbnailPath, spreadPath = _b.spreadPath, editableData = _b.configs.generalData.editablePublication, itemsInRow = _b.itemsInRow, version = _a.version;
    var spread = ownProps.spread, spreadIndex = ownProps.spreadIndex;
    var thumbnailsData = [];
    if (spreadPath) {
        thumbnailsData.push(__assign({}, thumbnails[spread[0] - 1], { imageSrc: __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, globalId, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* getPageHtmlPath */])(spreadPath, spreadIndex + 1) + "?version=" + version) }));
    }
    else {
        thumbnailsData = spread.map(function (page) {
            var position = thumbnails[page - 1].position;
            return __assign({}, thumbnails[page - 1], { imageSrc: __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, globalId, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* getPageHtmlPath */])(thumbnailPath, position) + "?version=" + version) });
        });
    }
    return {
        thumbnailsData: thumbnailsData,
        isActive: selectedSpreadIndices.includes(spreadIndex),
        isEditable: spread.some(function (page) { return Object.keys(editableData).includes(page.toString()); }),
        itemsInRow: itemsInRow,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel_SpreadsSelector_Grid_Item__["a" /* default */]));


/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Thumbnails_Item_styles__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Thumbnails_Item_ImageWrapper__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Thumbnails_Item_ItemInfo__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Thumbnails_constants__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);






var Item = function (_a) {
    var spreadIndex = _a.spreadIndex, thumbnailsData = _a.thumbnailsData, isActive = _a.isActive, isEditable = _a.isEditable, itemsInRow = _a.itemsInRow, onClick = _a.onClick;
    var handleClick = function (e) {
        onClick(spreadIndex, e.ctrlKey || e.metaKey, e.shiftKey);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Thumbnails_Item_styles__["f" /* Wrapper */], { type: __WEBPACK_IMPORTED_MODULE_4__Thumbnails_constants__["a" /* ThumbnailType */].GRID, isActive: isActive, itemsInRow: itemsInRow, onClick: handleClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Thumbnails_Item_ImageWrapper__["a" /* default */], { thumbnailsData: thumbnailsData }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Thumbnails_Item_ItemInfo__["a" /* default */], { spreadIndex: spreadIndex, label: thumbnailsData[0].label }),
        isEditable &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Thumbnails_Item_styles__["b" /* IconEdit */], null, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_edit'))));
};
/* harmony default export */ __webpack_exports__["a"] = (Item);


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n"])));

var templateObject_1;


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1321);


var Image = function (_a) {
    var imageSrc = _a.imageSrc, side = _a.side;
    var image = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (image.current) {
            // is needed to update image in lazysizes library
            image.current.classList.add('lazyload');
        }
    }, [imageSrc]);
    return (imageSrc ?
        (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Wrapper */], { side: side },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { ref: image, className: "lazyload", "data-src": imageSrc, alt: "" })))
        :
            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* EmptyWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null))));
};
/* harmony default export */ __webpack_exports__["a"] = (Image);


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__ = __webpack_require__(9);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 1 0 50%;\n\tpadding-top: 75%;\n\n\timg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t\twidth: auto;\n\t\theight: auto;\n\t\tmargin: auto;\n\t\tborder-radius: 4px;\n\n\t\t", ";\n\t}\n"], ["\n\tposition: relative;\n\tflex: 1 0 50%;\n\tpadding-top: 75%;\n\n\timg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t\twidth: auto;\n\t\theight: auto;\n\t\tmargin: auto;\n\t\tborder-radius: 4px;\n\n\t\t",
    ";\n\t}\n"])), function (_a) {
    var side = _a.side;
    switch (side) {
        case __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["m" /* ShowAloneSide */].LEFT:
            return "\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tborder-radius: 4px 0 0 4px;\n\t\t\t\t\t";
        case __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["m" /* ShowAloneSide */].RIGHT:
            return "\n\t\t\t\t\t\tright: auto;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tborder-radius: 0 4px 4px 0;\n\t\t\t\t\t";
        case __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["m" /* ShowAloneSide */].CENTER:
        default:
            return "\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t";
    }
});
var EmptyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 1 0 50%;\n\tpadding-top: 75%;\n\ttop: 0;\n\tbottom: 0;\n\tmax-width: 53%;\n\tmax-height: 100%;\n\twidth: auto;\n\theight: auto;\n\tmargin: auto;\n\tborder-radius: 4px;\n\tleft: 0;\n\tright: 0;\n\tbackground-color: white;\n"], ["\n\tposition: relative;\n\tflex: 1 0 50%;\n\tpadding-top: 75%;\n\ttop: 0;\n\tbottom: 0;\n\tmax-width: 53%;\n\tmax-height: 100%;\n\twidth: auto;\n\theight: auto;\n\tmargin: auto;\n\tborder-radius: 4px;\n\tleft: 0;\n\tright: 0;\n\tbackground-color: white;\n"])));

var templateObject_1, templateObject_2;


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 4px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 4px;\n"])));
var Position = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex: 0 0 24px;\n\tfont-weight: bold;\n\tfont-size: 12px;\n\tline-height: 16px;\n"], ["\n\tflex: 0 0 24px;\n\tfont-weight: bold;\n\tfont-size: 12px;\n\tline-height: 16px;\n"])));
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-weight: 500;\n\tfont-size: 12px;\n\tline-height: 16px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tfont-weight: 500;\n\tfont-size: 12px;\n\tline-height: 16px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var spinnerKeyFrame = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t0% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n"], ["\n\t0% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n"])));
var spinnerAnimation = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", " ", ""], ["", " ", ""])), spinnerKeyFrame, '1.2s linear infinite;');
var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 80px;\n\theight: 80px;\n\ttransform: scale(0.5);\n\n\tdiv {\n\t\ttransform-origin: 40px 40px;\n\t\tanimation: ", ";\n\t}\n\n\tdiv::after {\n\t\tcontent: ' ';\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 37px;\n\t\twidth: 4px;\n\t\theight: 15px;\n\t\tborder-radius: 20%;\n\t\tbackground: ", ";\n\t}\n\n\tdiv:nth-child(1) {\n\t\ttransform: rotate(0deg);\n\t\tanimation-delay: -1.1s;\n\t}\n\n\tdiv:nth-child(2) {\n\t\ttransform: rotate(30deg);\n\t\tanimation-delay: -1s;\n\t}\n\n\tdiv:nth-child(3) {\n\t\ttransform: rotate(60deg);\n\t\tanimation-delay: -0.9s;\n\t}\n\n\tdiv:nth-child(4) {\n\t\ttransform: rotate(90deg);\n\t\tanimation-delay: -0.8s;\n\t}\n\n\tdiv:nth-child(5) {\n\t\ttransform: rotate(120deg);\n\t\tanimation-delay: -0.7s;\n\t}\n\n\tdiv:nth-child(6) {\n\t\ttransform: rotate(150deg);\n\t\tanimation-delay: -0.6s;\n\t}\n\n\tdiv:nth-child(7) {\n\t\ttransform: rotate(180deg);\n\t\tanimation-delay: -0.5s;\n\t}\n\n\tdiv:nth-child(8) {\n\t\ttransform: rotate(210deg);\n\t\tanimation-delay: -0.4s;\n\t}\n\n\tdiv:nth-child(9) {\n\t\ttransform: rotate(240deg);\n\t\tanimation-delay: -0.3s;\n\t}\n\n\tdiv:nth-child(10) {\n\t\ttransform: rotate(270deg);\n\t\tanimation-delay: -0.2s;\n\t}\n\n\tdiv:nth-child(11) {\n\t\ttransform: rotate(300deg);\n\t\tanimation-delay: -0.1s;\n\t}\n\n\tdiv:nth-child(12) {\n\t\ttransform: rotate(330deg);\n\t\tanimation-delay: 0s;\n\t}\n"], ["\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 80px;\n\theight: 80px;\n\ttransform: scale(0.5);\n\n\tdiv {\n\t\ttransform-origin: 40px 40px;\n\t\tanimation: ", ";\n\t}\n\n\tdiv::after {\n\t\tcontent: ' ';\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 3px;\n\t\tleft: 37px;\n\t\twidth: 4px;\n\t\theight: 15px;\n\t\tborder-radius: 20%;\n\t\tbackground: ", ";\n\t}\n\n\tdiv:nth-child(1) {\n\t\ttransform: rotate(0deg);\n\t\tanimation-delay: -1.1s;\n\t}\n\n\tdiv:nth-child(2) {\n\t\ttransform: rotate(30deg);\n\t\tanimation-delay: -1s;\n\t}\n\n\tdiv:nth-child(3) {\n\t\ttransform: rotate(60deg);\n\t\tanimation-delay: -0.9s;\n\t}\n\n\tdiv:nth-child(4) {\n\t\ttransform: rotate(90deg);\n\t\tanimation-delay: -0.8s;\n\t}\n\n\tdiv:nth-child(5) {\n\t\ttransform: rotate(120deg);\n\t\tanimation-delay: -0.7s;\n\t}\n\n\tdiv:nth-child(6) {\n\t\ttransform: rotate(150deg);\n\t\tanimation-delay: -0.6s;\n\t}\n\n\tdiv:nth-child(7) {\n\t\ttransform: rotate(180deg);\n\t\tanimation-delay: -0.5s;\n\t}\n\n\tdiv:nth-child(8) {\n\t\ttransform: rotate(210deg);\n\t\tanimation-delay: -0.4s;\n\t}\n\n\tdiv:nth-child(9) {\n\t\ttransform: rotate(240deg);\n\t\tanimation-delay: -0.3s;\n\t}\n\n\tdiv:nth-child(10) {\n\t\ttransform: rotate(270deg);\n\t\tanimation-delay: -0.2s;\n\t}\n\n\tdiv:nth-child(11) {\n\t\ttransform: rotate(300deg);\n\t\tanimation-delay: -0.1s;\n\t}\n\n\tdiv:nth-child(12) {\n\t\ttransform: rotate(330deg);\n\t\tanimation-delay: 0s;\n\t}\n"])), spinnerAnimation, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResourceSelector_DrivePicker_FromSelection__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var mapStateToProps = function (state) {
    var config = state.galleryInfos.config, driveList = state.driveList, selection = state.selection;
    var breadcrumbs = driveList.breadcrumbs;
    return {
        selectionIds: selection.resources,
        driveList: driveList,
        sharedDirId: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSharedDirId(driveList, config),
        sourcesDirId: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSourcesDirId(driveList, config),
        currentDriveId: breadcrumbs.length === 0
            ? undefined
            : breadcrumbs[breadcrumbs.length - 1].id,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ResourceSelector_DrivePicker_FromSelection__["a" /* default */]));


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_Header_Logo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Breadcrumbs__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriveItemList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_customHooks_useResetDrivePage__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(563);













var ROOT_FOLDER_ID = -1;
var getFolderResources = function (currentDriveId, _a, selectionIds) {
    var driveItems = _a.driveItems;
    if (!currentDriveId) {
        return [];
    }
    var resources;
    if (currentDriveId === ROOT_FOLDER_ID) {
        resources = selectionIds.map(function (id) {
            // tempItem is used before actual item is fetched and can be filtered
            var tempItem = { id: id, type: 0 };
            return driveItems[id] || tempItem;
        });
    }
    else {
        var driveFolder = driveItems[currentDriveId];
        if (!driveFolder || !driveFolder.resources) {
            return [];
        }
        resources = driveFolder.resources;
    }
    return resources;
};
var FromSelection = function (_a) {
    var selectionIds = _a.selectionIds, driveList = _a.driveList, currentDriveId = _a.currentDriveId, sharedDirId = _a.sharedDirId, sourcesDirId = _a.sourcesDirId, isValidResource = _a.isValidResource, onClose = _a.onClose, onSelect = _a.onSelect, dispatch = _a.dispatch, actionButtonColor = _a.actionButtonColor, className = _a.className;
    var shouldResetDrivePage = Object(__WEBPACK_IMPORTED_MODULE_11__utils_customHooks_useResetDrivePage__["a" /* default */])([currentDriveId]);
    var getFolder = function (id, label) {
        var isSharedDir = id === sharedDirId;
        if (id === sharedDirId) {
            label = 'messages.shared_with_me';
        }
        if (id === sourcesDirId) {
            label = 'messages.sources';
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_actions__["B" /* setBreadcrumbs */])({ id: id, label: label }));
        if (id && id !== ROOT_FOLDER_ID && (!__WEBPACK_IMPORTED_MODULE_10__utils_userAgent__["a" /* default */].isMobileApp || isSharedDir)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(id, true, true, isSharedDir));
        }
    };
    var handleBreadcrumbClick = function (id, label) {
        getFolder(id, label);
    };
    var handleDriveItemClick = function (item) {
        var type = item.type, id = item.id, label = item.label;
        if (type === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Directory) {
            getFolder(id, label);
        }
        else {
            onSelect([item]);
            onClose();
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_actions__["B" /* setBreadcrumbs */])({ id: ROOT_FOLDER_ID, label: 'messages.my_selection' }));
        return function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_DriveItemList_actions__["w" /* resetBreadcrumbs */])());
        };
    }, []);
    var driveItems = driveList.driveItems, driveItemsFetchStatus = driveList.driveItemsFetchStatus, breadcrumbs = driveList.breadcrumbs;
    var isFetching = currentDriveId === ROOT_FOLDER_ID
        ? false
        : Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* isFetchingState */])(currentDriveId, driveItemsFetchStatus);
    var folderResources = getFolderResources(currentDriveId, driveList, selectionIds);
    var driveItemIds = Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* getDriveItemIds */])(folderResources, driveList, isValidResource);
    var isEmptyFolder = !isFetching && driveItemIds.length < 1;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Portal__["a" /* default */], { parentNode: document.body },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* Wrapper */], { className: className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* Header */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_MenuManager_Header_Logo__["a" /* default */], { isDisabled: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ButtonCancel */], { type: "button", onClick: onClose, color: actionButtonColor },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Breadcrumbs__["a" /* default */], { items: breadcrumbs, onItemClick: handleBreadcrumbClick }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* DriveListWrapper */], null,
                isEmptyFolder && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* EmptyFolderLabel */], { value: "messages.no_assets" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__DriveItemList__["a" /* default */], { hasBottomBar: false, searchConfig: undefined, displayType: __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_constants__["b" /* ListDisplayType */].Row, storeDriveItems: driveItems, driveItemIdsToDisplay: driveItemIds, folderId: currentDriveId, sharedDirId: undefined, sourcesDirId: undefined, isPrivateDir: false, isFetching: isFetching, showUnreadBadge: false, hasActions: false, hasSelectionIcon: false, navigationItems: [], shouldGetCustomTemplates: false, isEditMode: false, isEditButtonDisplayed: false, isDisplayTypeDropdownDisplayed: false, isLoading: false, isTheaterOpened: false, shouldResetPage: shouldResetDrivePage, onDriveItemClick: handleDriveItemClick, dispatch: dispatch })))));
};
/* harmony default export */ __webpack_exports__["a"] = (FromSelection);


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator_FromTemplate__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(87);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var _a = state.publicationCreator, source = _a.source, _b = _a.fromTemplate, selectedTemplate = _b.selectedTemplate, name = _b.name, error = _b.error, _c = _a.fromFile, status = _c.status, percentage = _c.percentage, importingError = _c.error;
    return __assign({}, ownProps, { source: source,
        selectedTemplate: selectedTemplate,
        name: name,
        error: error, isImportingFile: status && [
            __WEBPACK_IMPORTED_MODULE_2__reducer__["b" /* PublicationCreationStatus */].IMPORTING,
            __WEBPACK_IMPORTED_MODULE_2__reducer__["b" /* PublicationCreationStatus */].PROCESSING,
        ].includes(status), importingStatus: status, importingPercentage: percentage, importingError: importingError });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator_FromTemplate__["a" /* default */]));


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_PublicationCreator_PublicationTemplates__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceCreationPanel__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResourceSelector_ProgressBar__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_PublicationCreator_reducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__ = __webpack_require__(11);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var FromTemplate = function (_a) {
    var isDisplayed = _a.isDisplayed, source = _a.source, selectedTemplate = _a.selectedTemplate, name = _a.name, error = _a.error, isImportingFile = _a.isImportingFile, importingStatus = _a.importingStatus, importingPercentage = _a.importingPercentage, importingError = _a.importingError, dispatch = _a.dispatch;
    var isFromTemplate = source === __WEBPACK_IMPORTED_MODULE_8__containers_PublicationCreator_reducer__["c" /* PublicationSource */].TEMPLATE;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](isFromTemplate), 2), isTemplatesDisplayed = _b[0], setIsTemplatesDisplayed = _b[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setIsTemplatesDisplayed(isFromTemplate && isDisplayed);
    }, [isDisplayed]);
    var handleTemplateSelect = function (data) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["j" /* selectTemplate */])(data));
        setIsTemplatesDisplayed(false);
    };
    var handlePublicationNameConfirm = function (name, selectedTemplate) {
        var isCustomTemplate = selectedTemplate.isCustomTemplate, id = selectedTemplate.id, format = selectedTemplate.format;
        if (isCustomTemplate) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["c" /* createProposalFromDriveItem */])({ id: id, label: name }, id.toString()));
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["d" /* createPublicationFromMasterTemplate */])(id, name, format));
        }
    };
    var handlePublicationNameCancel = function () {
        if (isFromTemplate) {
            setIsTemplatesDisplayed(true);
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["f" /* hidePublicationCreator */])());
        }
    };
    var getProgressBarLabel = function () {
        if (importingStatus) {
            return "messages." + importingStatus.toLowerCase();
        }
        return selectedTemplate && __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].isProposal(selectedTemplate.format)
            ? 'messages.create_proposal'
            : 'messages.create_publication';
    };
    var getResourceCreationPanelLabel = function () { return (selectedTemplate && __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].isProposal(selectedTemplate.format)
        ? 'messages.proposal_name'
        : 'messages.publication_name'); };
    var handlePublicationCreationCancel = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["h" /* removeFromCreationProgress */])());
        setIsTemplatesDisplayed(true);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        (isFromTemplate ? isDisplayed : isTemplatesDisplayed) &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_PublicationCreator_PublicationTemplates__["a" /* default */], { onSelect: handleTemplateSelect, onClose: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["f" /* hidePublicationCreator */])()); } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Popup__["b" /* default */], { isDisplayed: isImportingFile && isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t(getProgressBarLabel()), onCancel: handlePublicationCreationCancel },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* PopupBodyWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ResourceSelector_ProgressBar__["a" /* default */], { percentage: importingPercentage, error: importingError, hasCancelButton: true, onCancel: handlePublicationCreationCancel }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ResourceCreationPanel__["a" /* default */], { label: getResourceCreationPanelLabel(), isOpen: !isImportingFile && isDisplayed && !isTemplatesDisplayed, autoFocus: false, icon: "iconset_uprez_proposal-blue", fields: { name: { value: name } }, errors: { name: error }, onFieldChange: function (name, value) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_actions__["l" /* setName */])(value)); }, onConfirm: function (_a) {
                var name = _a.name;
                return handlePublicationNameConfirm(name.value, selectedTemplate);
            }, onCancel: handlePublicationNameCancel })));
};
/* harmony default export */ __webpack_exports__["a"] = (FromTemplate);


/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator_PublicationTemplates__ = __webpack_require__(1329);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var mapStateToProps = function (state, ownProps) {
    var _a = state.publicationCreator, _b = _a.fromTemplate, masterTemplatesIds = _b.masterTemplatesIds, customTemplatesIds = _b.customTemplatesIds, loadingStatus = _b.loadingStatus, isDisplayed = _a.isDisplayed, driveItems = state.driveList.driveItems;
    return __assign({}, ownProps, { masterTemplatesIds: masterTemplatesIds,
        customTemplatesIds: customTemplatesIds,
        loadingStatus: loadingStatus,
        isDisplayed: isDisplayed,
        driveItems: driveItems });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_PublicationCreator_PublicationTemplates__["a" /* default */]));


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toggle__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_Header_Logo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DriveItemList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_PublicationCreator_actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_customHooks_useResetDrivePage__ = __webpack_require__(351);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;











var TemplateSource;
(function (TemplateSource) {
    TemplateSource["MASTER_TEMPLATES"] = "MASTER_TEMPLATES";
    TemplateSource["CUSTOM_TEMPLATES"] = "CUSTOM_TEMPLATES";
})(TemplateSource || (TemplateSource = {}));
var templateSourceConfig = (_a = {},
    _a[TemplateSource.MASTER_TEMPLATES] = {
        id: TemplateSource.MASTER_TEMPLATES,
        label: 'messages.templates',
    },
    _a[TemplateSource.CUSTOM_TEMPLATES] = {
        id: TemplateSource.CUSTOM_TEMPLATES,
        label: 'messages.my_templates',
    },
    _a);
var PublicationTemplates = function (_a) {
    var isDisplayed = _a.isDisplayed, loadingStatus = _a.loadingStatus, masterTemplatesIds = _a.masterTemplatesIds, customTemplatesIds = _a.customTemplatesIds, driveItems = _a.driveItems, onClose = _a.onClose, onSelect = _a.onSelect, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](TemplateSource.MASTER_TEMPLATES), 2), templateSource = _b[0], setTemplateSource = _b[1];
    var shouldResetDrivePage = Object(__WEBPACK_IMPORTED_MODULE_10__utils_customHooks_useResetDrivePage__["a" /* default */])([templateSource]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isDisplayed && loadingStatus === __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__["a" /* LoadingStatus */].NOT_LOADED) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_PublicationCreator_actions__["e" /* getPublicationTemplates */])());
        }
        if (loadingStatus === __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__["a" /* LoadingStatus */].LOADED && masterTemplatesIds.length === 0 && customTemplatesIds.length > 0) {
            setTemplateSource(TemplateSource.CUSTOM_TEMPLATES);
        }
    }, [isDisplayed, loadingStatus]);
    var handleTemplateSelect = function (_a) {
        var id = _a.id, label = _a.label, format = _a.format;
        onSelect({
            id: id,
            label: label,
            format: format,
            isCustomTemplate: templateSource === TemplateSource.CUSTOM_TEMPLATES,
        });
    };
    var hasTemplates = templateSource === TemplateSource.MASTER_TEMPLATES
        ? masterTemplatesIds.length > 0
        : customTemplatesIds.length > 0;
    var templatesIdsToDisplay = templateSource === TemplateSource.MASTER_TEMPLATES
        ? masterTemplatesIds
        : customTemplatesIds;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Header */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_Header_Logo__["a" /* default */], { isDisabled: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ButtonClose */], { type: "button", onClick: onClose },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" }))),
        loadingStatus === __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__["a" /* LoadingStatus */].LOADING &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Loader */], null,
                __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
        loadingStatus === __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__["a" /* LoadingStatus */].LOADED &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Toggle__["a" /* default */], { items: Object.values(templateSourceConfig), activeId: templateSource, onItemClick: function (id) { return setTemplateSource(id); } }),
                hasTemplates
                    ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DriveItemList__["a" /* default */], { hasBottomBar: false, searchConfig: undefined, displayType: __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemList_constants__["b" /* ListDisplayType */].Grid, storeDriveItems: driveItems, driveItemIdsToDisplay: templatesIdsToDisplay, sharedDirId: undefined, sourcesDirId: undefined, isPrivateDir: false, isFetching: false, showUnreadBadge: false, hasSelectionIcon: false, hasActions: templateSource === TemplateSource.CUSTOM_TEMPLATES, navigationItems: [], shouldGetCustomTemplates: true, isEditMode: false, isEditButtonDisplayed: false, isDisplayTypeDropdownDisplayed: false, isLoading: false, isTheaterOpened: false, onDriveItemClick: handleTemplateSelect, shouldResetPage: shouldResetDrivePage, dispatch: dispatch }))
                    : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* NoTemplatesLabel */], { value: "messages.no_templates" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (PublicationTemplates);


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Loader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NoTemplatesLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var headerHeight = '50px';
var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t", "\n\n\t", "\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var backgroundColor = _a.theme.primary.backgroundColor;
    return backgroundColor !== 'transparent' ? backgroundColor : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White;
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), headerHeight, __WEBPACK_IMPORTED_MODULE_4__utils_style__["e" /* spin */]);
var Header = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 0 0 ", ";\n\n\t", "\n\n\t", "\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 0 0 ", ";\n\n\t",
    "\n\n\t",
    "\n"])), headerHeight, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var ButtonClose = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 15px;\n\tright: 20px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t", "\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 15px;\n\tright: 20px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t",
    "\n\n\t",
    "\n"])), function (props) { return props.theme.primary.actionColor; }, __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMac() && "\n\t\ttop: " + (parseInt(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["f" /* macTopBarHeight */], 10) + 15) + "px;\n\t", __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\ttop: " + (parseInt(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["j" /* notchHeight */], 10) + 15) + "px;\n\t\t}\n\t");
var NoTemplatesLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AssetRenamePanel__ = __webpack_require__(1332);


var mapStateToProps = function (state) {
    var assetRenamePanel = state.assetRenamePanel;
    var isOpen = assetRenamePanel.isOpen, name = assetRenamePanel.name, assetId = assetRenamePanel.assetId, error = assetRenamePanel.error;
    return { isOpen: isOpen, name: name, assetId: assetId, error: error };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_AssetRenamePanel__["a" /* default */]));


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourceCreationPanel__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_AssetRenamePanel_actions__ = __webpack_require__(329);



var AssetRenamePanel = function (_a) {
    var isOpen = _a.isOpen, name = _a.name, assetId = _a.assetId, error = _a.error, dispatch = _a.dispatch;
    var fieldsConfig = {
        name: {
            value: name,
        },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ResourceCreationPanel__["a" /* default */], { isOpen: isOpen, icon: "iconset_doc_default", fields: fieldsConfig, errors: { name: error }, onFieldChange: function (name, value) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_AssetRenamePanel_actions__["e" /* setName */])(value)); }, onConfirm: function (_a) {
            var name = _a.name;
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_AssetRenamePanel_actions__["d" /* renameAsset */])(assetId, name.value));
        }, onCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_AssetRenamePanel_actions__["b" /* closePanel */])()); } }));
};
/* harmony default export */ __webpack_exports__["a"] = (AssetRenamePanel);


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ExternalLinkCreationPanel__ = __webpack_require__(1334);


var mapStateToProps = function (state) {
    var _a = state.externalLinkCreationPanel, isOpen = _a.isOpen, fields = _a.fields, errors = _a.errors;
    return {
        isOpen: isOpen,
        fields: fields,
        errors: errors,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ExternalLinkCreationPanel__["a" /* default */]));


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceCreationPanel__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ExternalLinkCreationPanel_actions__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_validation__ = __webpack_require__(139);





var getError = function (name, value) {
    var error = null;
    if (name === 'url') {
        if (value && !__WEBPACK_IMPORTED_MODULE_4__utils_validation__["a" /* default */].isValidUrl(value)) {
            error = 'error.invalid_url';
        }
    }
    return error;
};
var ExternalLinkCreationPanel = function (_a) {
    var isOpen = _a.isOpen, fields = _a.fields, errors = _a.errors, dispatch = _a.dispatch;
    var fieldsConfig = {
        name: {
            value: fields.name,
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.description'),
        },
        url: {
            value: fields.url,
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.url'),
        },
    };
    var handleFieldChange = function (name, value) {
        var error = getError(name, value);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_ExternalLinkCreationPanel_actions__["e" /* setValue */])(name, value, error));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ResourceCreationPanel__["a" /* default */], { isOpen: isOpen, icon: "iconset_uprez_ext_link", fields: fieldsConfig, errors: errors, onFieldChange: function (name, value) { return handleFieldChange(name, value); }, onConfirm: function (_a) {
            var name = _a.name, url = _a.url;
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_ExternalLinkCreationPanel_actions__["c" /* createExternalLink */])(name.value, url.value));
        }, onCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_ExternalLinkCreationPanel_actions__["b" /* closePanel */])()); } }));
};
/* harmony default export */ __webpack_exports__["a"] = (ExternalLinkCreationPanel);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoSaveAsPopup__ = __webpack_require__(1336);


var mapStateToProps = function (state) {
    var isDisplayed = state.noSaveAsPopup.isDisplayed;
    return { isDisplayed: isDisplayed };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NoSaveAsPopup__["a" /* default */]));


/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_NoSaveAsPopup_actions__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_PublicationCreator_actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__ = __webpack_require__(87);








var NoSaveAsPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, dispatch = _a.dispatch;
    var onCancel = function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NoSaveAsPopup_actions__["b" /* closeNoSaveAsPopup */])()); };
    var popupFooter = {
        label: __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["I18n"].t('messages.create_proposal_from_template'),
        onAccept: function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_PublicationCreator_actions__["m" /* showPublicationCreator */])(__WEBPACK_IMPORTED_MODULE_7__containers_PublicationCreator_reducer__["c" /* PublicationSource */].TEMPLATE));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NoSaveAsPopup_actions__["b" /* closeNoSaveAsPopup */])());
        },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["I18n"].t('messages.save_as'), onCancel: onCancel, footer: popupFooter },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* PopupWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* StyledIcon */], null, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_uprez_info')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* NoSaveAsInfo */], { value: "messages.no_save_as_info" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (NoSaveAsPopup);


/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopupWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoSaveAsInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var PopupWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n\tpadding: 30px 40px;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n\tpadding: 30px 40px;\n"])));
var StyledIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t> svg {\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n\tmargin-bottom: 13px;\n"], ["\n\t> svg {\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n\tmargin-bottom: 13px;\n"])));
var NoSaveAsInfo = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 18px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 18px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_AnotherUserLoginPopup__ = __webpack_require__(1339);


var mapStateToProps = function (state) {
    var isAnotherUserLogin = state.multiAppAuthenticationInfos.isAnotherUserLogin;
    return {
        isDisplayed: isAnotherUserLogin,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_AnotherUserLoginPopup__["a" /* default */]));


/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationPopup__ = __webpack_require__(571);



var AnotherUserLoginPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NotificationPopup__["a" /* default */], { isDisplayed: isDisplayed, dispatch: dispatch },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "error.another_user_login" })));
};
/* harmony default export */ __webpack_exports__["a"] = (AnotherUserLoginPopup);


/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopupBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var PopupBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tpadding: 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 18px;\n\tline-height: 20px;\n\ttext-align: center;\n"], ["\n\tbox-sizing: border-box;\n\tpadding: 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 18px;\n\tline-height: 20px;\n\ttext-align: center;\n"])));

var templateObject_1;


/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_SessionExpiredPopup__ = __webpack_require__(1342);


var mapStateToProps = function (state) {
    var isSessionExpired = state.multiAppAuthenticationInfos.isSessionExpired;
    return {
        isDisplayed: isSessionExpired,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_SessionExpiredPopup__["a" /* default */]));


/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationPopup__ = __webpack_require__(571);



var SessionExpiredPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NotificationPopup__["a" /* default */], { isDisplayed: isDisplayed, dispatch: dispatch },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "error.session_expired" })));
};
/* harmony default export */ __webpack_exports__["a"] = (SessionExpiredPopup);


/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesEditorPanel__ = __webpack_require__(1344);


var mapStateToProps = function (state) {
    var _a = state.notes.editor, isOpened = _a.isOpened, noteId = _a.noteId, locale = state.i18n.locale;
    return {
        isOpened: isOpened,
        noteId: noteId,
        locale: locale,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NotesEditorPanel__["a" /* default */]));


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_notes_editor__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_notes_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_notes_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_actions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_customHooks_useClickOutside__ = __webpack_require__(149);








var NotesEditorPanel = function (_a) {
    var isOpened = _a.isOpened, locale = _a.locale, noteId = _a.noteId, dispatch = _a.dispatch;
    var DEFAULT_TITLE = __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["I18n"].t('messages.untitled_note');
    var noteTitle = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](DEFAULT_TITLE);
    var editorElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    Object(__WEBPACK_IMPORTED_MODULE_7__utils_customHooks_useClickOutside__["a" /* default */])(editorElement, isOpened, function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_actions__["g" /* toggleNotesEditor */])()); });
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var notesEditor;
        var onTitleChange = function (value) { return noteTitle.current = value; };
        var onClose = function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_actions__["g" /* toggleNotesEditor */])()); };
        if (isOpened) {
            if (!noteId) {
                // @ts-ignore
                notesEditor = new __WEBPACK_IMPORTED_MODULE_1_notes_editor__["NotesEditor"](editorElement.current, onTitleChange, noteTitle.current, '', '', locale, onClose);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_6__utils_indexedDB_manager__["a" /* default */].getNote(noteId).then(function (note) {
                    if (note) {
                        var title = note.title, content = note.content, drawing = note.drawing;
                        noteTitle.current = title;
                        // @ts-ignore
                        notesEditor = new __WEBPACK_IMPORTED_MODULE_1_notes_editor__["NotesEditor"](editorElement.current, onTitleChange, title, content, drawing, locale, onClose);
                    }
                });
            }
        }
        return function () {
            if (!notesEditor) {
                return;
            }
            var _a = notesEditor.getDataToSave(), text = _a.text, image = _a.image;
            var shouldCreateNote = !noteId && (text.plainText || image);
            if (noteId) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_actions__["h" /* updateNote */])(noteId, {
                    title: noteTitle.current,
                    content: text.formattedText,
                    drawing: image,
                }));
            }
            else if (shouldCreateNote) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_actions__["b" /* createNote */])(noteTitle.current, text, image));
            }
            noteTitle.current = DEFAULT_TITLE;
            notesEditor.destroy();
        };
    }, [isOpened, noteId, locale]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        noteTitle.current = DEFAULT_TITLE;
    }, [locale]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, isOpened &&
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Portal__["a" /* default */], { parentNode: document.body },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Wrapper */], { ref: editorElement }))));
};
/* harmony default export */ __webpack_exports__["a"] = (NotesEditorPanel);


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*! For license information please see index.js.LICENSE.txt */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["notes-editor"]=e():t["notes-editor"]=e()}(self,(function(){return function(){var t={829:function(t,e,n){"use strict";var r=n(645),o=n.n(r)()((function(t){return t[1]}));o.push([t.id,"/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  -o-tab-size: 4;\n     tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.ql-snow.ql-toolbar:after,\n.ql-snow .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-snow.ql-toolbar button svg,\n.ql-snow .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover,\n.ql-snow .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type=file],\n.ql-snow .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n  color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke,\n.ql-snow .ql-toolbar button:hover .ql-stroke,\n.ql-snow.ql-toolbar button:focus .ql-stroke,\n.ql-snow .ql-toolbar button:focus .ql-stroke,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #06c;\n}\n@media (pointer: coarse) {\n  .ql-snow.ql-toolbar button:hover:not(.ql-active),\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n    color: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #444;\n  }\n}\n.ql-snow {\n  box-sizing: border-box;\n}\n.ql-snow * {\n  box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n  display: none;\n}\n.ql-snow .ql-out-bottom,\n.ql-snow .ql-out-top {\n  visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n  position: absolute;\n  transform: translateY(10px);\n}\n.ql-snow .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n  transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-snow .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow .ql-stroke {\n  fill: none;\n  stroke: #444;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-snow .ql-stroke-miter {\n  fill: none;\n  stroke: #444;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-snow .ql-fill,\n.ql-snow .ql-stroke.ql-fill {\n  fill: #444;\n}\n.ql-snow .ql-empty {\n  fill: none;\n}\n.ql-snow .ql-even {\n  fill-rule: evenodd;\n}\n.ql-snow .ql-thin,\n.ql-snow .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n  opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n  display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-snow .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-snow .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-snow .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-snow .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n  text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-snow .ql-editor code,\n.ql-snow .ql-editor pre {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-snow .ql-editor pre {\n  white-space: pre-wrap;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n  font-size: 85%;\n  padding: 2px 4px;\n}\n.ql-snow .ql-editor pre.ql-syntax {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-snow .ql-editor img {\n  max-width: 100%;\n}\n.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-snow .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-snow .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #ccc;\n  z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-snow .ql-color-picker,\n.ql-snow .ql-icon-picker {\n  width: 28px;\n}\n.ql-snow .ql-color-picker .ql-picker-label,\n.ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-snow .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n  border: 1px solid transparent;\n  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type=text] {\n  display: none;\n  border: 1px solid #ccc;\n  font-size: 13px;\n  height: 26px;\n  margin: 0px;\n  padding: 3px 5px;\n  width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 16px;\n  padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n  line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type=text] {\n  display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode=link]::before {\n  content: \"Enter link:\";\n}\n.ql-snow .ql-tooltip[data-mode=formula]::before {\n  content: \"Enter formula:\";\n}\n.ql-snow .ql-tooltip[data-mode=video]::before {\n  content: \"Enter video:\";\n}\n.ql-snow a {\n  color: #06c;\n}\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n}\n",""]),e.Z=o},681:function(t,e,n){"use strict";var r=n(645),o=n.n(r),i=n(829),l=n(667),a=n.n(l),s=n(500),u=n(387),c=o()((function(t){return t[1]}));c.i(i.Z);var f=a()(s),d=a()(u);c.push([t.id,"[hidden] {\r\n\tdisplay: none !important;\r\n}\r\n\r\n/* COMMON STYLES */\r\n\r\n#wp-notes-editor {\r\n\tbox-sizing: border-box;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tpadding: 30px;\r\n\tbackground-color: #fff;\r\n}\r\n\r\n#wp-notes-editor *,\r\n#wp-notes-editor *::before,\r\n#wp-notes-editor *::after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n#wp-text-editor,\r\n#wp-draw-editor {\r\n\tflex: 1;\r\n\tborder: 1px solid #ccc;\r\n}\r\n\r\n#wp-text-editor {\r\n\toverflow-y: auto;\r\n}\r\n\r\n#wp-text-editor.ql-container {\r\n\tfont-family: inherit;\r\n}\r\n\r\n#wp-draw-editor {\r\n\tposition: relative;\r\n}\r\n\r\n.wp-draw-editor-scroll-wrapper {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tz-index: 1;\r\n\toverflow-x: hidden;\r\n\toverflow-y: auto;\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t    -ms-user-select: none;\r\n\t        user-select: none;\r\n\t-webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.is-touch-supported .wp-draw-editor-scroll-wrapper {\r\n\tright: -30px;\r\n\tpadding-right: 30px;\r\n}\r\n\r\n.wp-draw-editor-canvas-wrapper {\r\n\toverflow: hidden;\r\n}\r\n\r\n.wp-draw-editor-canvas {\r\n\ttransform-origin: 0 0;\r\n\tcursor: url("+f+") 0 24, auto;\r\n\ttouch-action: none;\r\n}\r\n\r\n.wp-draw-editor-canvas.is-erasing {\r\n\tcursor: url("+d+") 6 18, auto;\r\n}\r\n\r\n@-webkit-keyframes scroll_arrow_animation {\r\n\t25% {\r\n\t\ttransform: translate(-50%, 0);\r\n\t}\r\n\r\n\t42% {\r\n\t\ttransform: translate(-50%, 5px);\r\n\t}\r\n\r\n\t50% {\r\n\t\ttransform: translate(-50%, 0);\r\n\t}\r\n\r\n\t59% {\r\n\t\ttransform: translate(-50%, 3px);\r\n\t}\r\n\r\n\t75% {\r\n\t\ttransform: translate(-50%, 0);\r\n\t}\r\n}\r\n\r\n@keyframes scroll_arrow_animation {\r\n\t25% {\r\n\t\ttransform: translate(-50%, 0);\r\n\t}\r\n\r\n\t42% {\r\n\t\ttransform: translate(-50%, 5px);\r\n\t}\r\n\r\n\t50% {\r\n\t\ttransform: translate(-50%, 0);\r\n\t}\r\n\r\n\t59% {\r\n\t\ttransform: translate(-50%, 3px);\r\n\t}\r\n\r\n\t75% {\r\n\t\ttransform: translate(-50%, 0);\r\n\t}\r\n}\r\n\r\n.wp-draw-editor-scroll-arrow {\r\n\tposition: absolute;\r\n\tbottom: 3px;\r\n\tleft: 50%;\r\n\tz-index: 2;\r\n\ttransform: translateX(-50%);\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tcolor: #555;\r\n\t-webkit-animation: scroll_arrow_animation 2.5s ease-in-out infinite;\r\n\t        animation: scroll_arrow_animation 2.5s ease-in-out infinite;;\r\n\tfill: currentColor;\r\n}\r\n\r\n/* MODE TOGGLE (TEXT/DRAW) */\r\n\r\n.wp-notes-editor-mode-wrapper {\r\n\tposition: relative;\r\n\tflex: 0 0 auto;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\twidth: 100px;\r\n\theight: 50px;\r\n\tpadding: 0 8px;\r\n\tborder-radius: 50px;\r\n\tbackground-color: #fff;\r\n\tbox-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.wp-notes-editor-mode-wrapper::before {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: 4px;\r\n\tbottom: 4px;\r\n\tleft: 50%;\r\n\twidth: 1px;\r\n\tbackground-color: #d3d3d3;\r\n}\r\n\r\n.wp-notes-editor-mode {\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tbackground-color: transparent;\r\n\toutline: 0;\r\n\tcolor: #7f7f83;\r\n\tcursor: pointer;\r\n}\r\n\r\n.wp-notes-editor-mode svg {\r\n\tfill: currentColor;\r\n\tpointer-events: none;\r\n}\r\n\r\n.wp-notes-editor-mode.is-active {\r\n\tcolor: #087dff;\r\n}\r\n\r\n/* TOOLBAR */\r\n\r\n.wp-notes-editor-toolbar {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tpadding: 10px;\r\n\tborder: 1px solid #ccc;\r\n\tborder-bottom: 0;\r\n\tbackground-color: #f5f5f5;\r\n}\r\n\r\n.wp-notes-editor-toolbar.is-text-editor {\r\n\tjustify-content: space-between;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.wp-notes-editor-toolbar.is-draw-editor {\r\n\tposition: relative;\r\n\tjustify-content: space-around;\r\n}\r\n\r\n.wp-notes-editor-toolbar-actions {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: flex-end;\r\n}\r\n\r\n.is-text-editor .wp-notes-editor-toolbar-actions {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.is-text-editor .wp-notes-editor-note-title {\r\n\twidth: 50%;\r\n\tmax-width: 300px;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.is-draw-editor .wp-notes-editor-toolbar-actions {\r\n\torder: 2;\r\n}\r\n\r\n.wp-notes-editor-toolbar-buttons-wrapper {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-around;\r\n\tflex: 1 1 auto;\r\n}\r\n\r\n.wp-notes-editor-toolbar-buttons-group {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.wp-notes-editor-toolbar-button {\r\n\twidth: 43px;\r\n\theight: 70px;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\toutline: 0;\r\n\tbackground-color: transparent;\r\n\tcursor: pointer;\r\n}\r\n\r\n.wp-notes-editor-toolbar-button:not(.is-color) {\r\n\ttransform: translateY(25px);\r\n\ttransition: transform 0.2s ease;\r\n}\r\n\r\n.wp-notes-editor-toolbar-button:not(.is-color) svg {\r\n\tposition: relative;\r\n\tleft: -8px;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tpointer-events: none;\r\n}\r\n\r\n.wp-notes-editor-toolbar-button:not(.is-color).is-active {\r\n\ttransform: translateY(10px);\r\n}\r\n\r\n.wp-notes-editor-toolbar-button.is-color {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tmargin-right: 10px;\r\n\tborder: 0;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.wp-notes-editor-toolbar-button.is-color.is-active {\r\n\tposition: relative;\r\n}\r\n\r\n.wp-notes-editor-toolbar-button.is-active.is-color::after {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: 2px;\r\n\tleft: 2px;\r\n\twidth: calc(100% - 4px);\r\n\theight: calc(100% - 4px);\r\n\tborder: 2px solid #fff;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n/* TEXT EDITOR TOOLBAR */\r\n\r\n@media screen and (min-width: 768px) {\r\n\t.wp-notes-editor-toolbar.is-text-editor {\r\n\t\tflex-wrap: nowrap;\r\n\t\tjustify-content: flex-end;\r\n\t}\r\n\r\n\t.is-text-editor .ql-toolbar {\r\n\t\tmargin-left: auto;\r\n\t}\r\n\r\n\t.is-text-editor .wp-notes-editor-toolbar-actions {\r\n\t\torder: 2;\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n\t.is-text-editor .wp-notes-editor-close-btn {\r\n\t\tmargin-left: 30px;\r\n\t}\r\n\r\n\t.is-text-editor .ql-toolbar {\r\n\t\tflex: 0 0 550px;\r\n\t}\r\n}\r\n\r\n/* FULL WIDTH DRAW EDITOR TOOLBAR (SMARTPHONE) */\r\n\r\n@media screen and (min-width: 540px) {\r\n\t.wp-notes-editor-toolbar.is-draw-editor {\r\n\t\tposition: absolute;\r\n\t\tbottom: 10px;\r\n\t\tleft: 50%;\r\n\t\ttransform: translateX(-50%);\r\n\t\tz-index: 3;\r\n\t\twidth: calc(100% - 60px);\r\n\t\tpadding: 0 20px;\r\n\t\tborder-radius: 50px;\r\n\t\tborder: 0;\r\n\t\tbox-shadow: 0 0 12px 2px rgba(255, 255, 255, 0.13);\r\n\t\toverflow: hidden;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-buttons-wrapper {\r\n\t\tflex: 0 0 auto;\r\n\t\tjustify-content: flex-start;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-button:not(.is-color) svg {\r\n\t\tposition: static;\r\n\t\tleft: auto;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-buttons-group.color-group {\r\n\t\tflex-wrap: wrap;\r\n\t\twidth: 110px;\r\n\t\tmargin-left: 10px;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-button {\r\n\t\twidth: 48px;\r\n\t\theight: 105px;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-button.is-color {\r\n\t\twidth: 24px;\r\n\t\theight: 24px;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-button.is-color:nth-child(-n+3) {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-button.is-color:nth-child(3) {\r\n\t\tmargin-right: 0;\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 610px) {\r\n\t.wp-notes-editor-toolbar-button {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-button.is-color {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t}\r\n\r\n\t.wp-notes-editor-toolbar-buttons-group.color-group {\r\n\t\tmargin-left: 20px;\r\n\t}\r\n}\r\n\r\n/* FULL WIDTH DRAW EDITOR TOOLBAR (TABLET AND DESKTOP) */\r\n\r\n@media screen and (min-width: 768px) {\r\n\t.wp-notes-editor-toolbar.is-draw-editor {\r\n\t\tmax-width: 650px;\r\n\t\tpadding: 0 30px;\r\n\t}\r\n\r\n\t.is-draw-editor .wp-notes-editor-mode-wrapper {\r\n\t\twidth: 126px;\r\n\t\theight: 66px;\r\n\t\tpadding: 0px 18px;\r\n\t}\r\n\r\n\t.is-draw-editor .wp-notes-editor-close-btn {\r\n\t\tmargin-left: 30px;\r\n\t}\r\n}\r\n\r\n.wp-notes-editor-toolbar .ql-toolbar {\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tfont-family: inherit;\r\n}\r\n\r\n/* CLOSE BUTTON */\r\n\r\n.wp-notes-editor-close-btn {\r\n\tposition: relative;\r\n\ttop: -1px;\r\n\tflex: 0 0 auto;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin-left: 7px;\r\n\tpadding: 0;\r\n\tborder-radius: 50%;\r\n\tborder: 0;\r\n\toutline: 0;\r\n\tbackground-color: #fff;\r\n\tbox-shadow: 0px 3px 2px 0 #ccc;\r\n\tcursor: pointer;\r\n}\r\n\r\n.wp-notes-editor-close-btn::before,\r\n.wp-notes-editor-close-btn::after {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 5px;\r\n\twidth: 16px;\r\n\theight: 2px;\r\n\tbackground-color: #202020;\r\n}\r\n\r\n.wp-notes-editor-close-btn::before {\r\n\ttransform: rotate(45deg);\r\n}\r\n\r\n.wp-notes-editor-close-btn::after {\r\n\ttransform: rotate(-45deg);\r\n}\r\n\r\n/* DROPDOWN MENU */\r\n\r\n.wp-notes-editor-menu {\r\n\tposition: absolute;\r\n\ttop: 100%;\r\n\tz-index: 5;\r\n\twidth: 150px;\r\n\tpadding: 20px;\r\n\tborder-radius: 15px;\r\n\tbackground-color: #fff;\r\n\tbox-shadow: 0px 4px 10px 3px #ccc;\r\n}\r\n\r\n.wp-notes-editor-menu::before {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: -9px;\r\n\tleft: 32px;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tborder-radius: 2px;\r\n\tbackground-color: inherit;\r\n\ttransform: rotate(45deg);\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 24px;\r\n\theight: 24px;\r\n\tborder-radius: 6px;\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width.is-active {\r\n\tbackground-color: #087dff;\r\n\ttransform: none;\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width::after {\r\n\tcontent: '';\r\n\theight: 16px;\r\n\tborder-radius: 4px;\r\n\tbackground-color: #000;\r\n\ttransform: rotate(-45deg);\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width.is-active::after {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width:first-child::after {\r\n\twidth: 6px;\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width:nth-child(2)::after {\r\n\twidth: 4px;\r\n}\r\n\r\n.wp-notes-editor-menu .is-line-width:last-child::after {\r\n\twidth: 2px;\r\n}\r\n\r\n.wp-notes-editor-menu.is-line-width-menu .wp-notes-editor-toolbar-buttons-wrapper {\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.wp-notes-editor-menu.is-color-menu .wp-notes-editor-toolbar-buttons-wrapper {\r\n\tflex-wrap: wrap;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.wp-notes-editor-menu .is-color {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.wp-notes-editor-menu .is-color:nth-child(4),\r\n.wp-notes-editor-menu .is-color:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.wp-notes-editor-menu .is-color:nth-child(3) {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.wp-notes-editor-menu .wp-notes-editor-toolbar-button {\r\n\ttransform: none;\r\n}\r\n\r\n.wp-notes-editor-note-title {\r\n\tpadding: 5px;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: 4px;\r\n\tbackground-color: transparent;\r\n\tfont-family: inherit;\r\n\tfont-weight: 700;\r\n\tfont-size: 18px;\r\n\tline-height: 20px;\r\n\tcolor: #292929;\r\n\ttext-overflow: ellipsis;\r\n\t-webkit-appearance: none;\r\n}\r\n\r\n.wp-notes-editor-note-title:focus {\r\n\tborder-color: #d3d3d3;\r\n\tbackground-color: #fff;\r\n\toutline: none;\r\n}\r\n\r\n.wp-notes-editor-note-title::-ms-clear {\r\n\tdisplay: none;\r\n}\r\n\r\n/* TEXT EDITOR */\r\n\r\n.wp-notes-editor-toolbar .ql-toolbar *:focus {\r\n\toutline-color: #06c;\r\n}\r\n\r\n.is-touch-supported #wp-text-editor {\r\n\tpadding-top: 20px; /* needed to prevent toolbar overlap by touch screen tooltip */\r\n}\r\n\r\n/* TRANSLATIONS FOR TEXT EDITOR */\r\n\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before,\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before {\r\n\tcontent: 'Petit';\r\n}\r\n\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-item::before,\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-label::before {\r\n\tcontent: 'Ordinaire';\r\n}\r\n\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before,\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before {\r\n\tcontent: 'Grand';\r\n}\r\n\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before,\r\n.fr .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before {\r\n\tcontent: 'Énorme';\r\n}\r\n\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before,\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before {\r\n\tcontent: 'Pequeño';\r\n}\r\n\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-item::before,\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-label::before {\r\n\tcontent: 'Normal';\r\n}\r\n\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before,\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before {\r\n\tcontent: 'Grande';\r\n}\r\n\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before,\r\n.es .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before {\r\n\tcontent: 'Enorme';\r\n}\r\n",""]),e.Z=c},645:function(t){"use strict";t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=t(e);return e[2]?"@media ".concat(e[2]," {").concat(n,"}"):n})).join("")},e.i=function(t,n,r){"string"==typeof t&&(t=[[null,t,""]]);var o={};if(r)for(var i=0;i<this.length;i++){var l=this[i][0];null!=l&&(o[l]=!0)}for(var a=0;a<t.length;a++){var s=[].concat(t[a]);r&&o[s[0]]||(n&&(s[2]?s[2]="".concat(n," and ").concat(s[2]):s[2]=n),e.push(s))}},e}},667:function(t){"use strict";t.exports=function(t,e){return e||(e={}),"string"!=typeof(t=t&&t.__esModule?t.default:t)?t:(/^['"].*['"]$/.test(t)&&(t=t.slice(1,-1)),e.hash&&(t+=e.hash),/["'() \t\n]/.test(t)||e.needQuotes?'"'.concat(t.replace(/"/g,'\\"').replace(/\n/g,"\\n"),'"'):t)}},95:function(t){var e;"undefined"!=typeof self&&self,e=function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=109)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(17),o=n(18),i=n(19),l=n(45),a=n(46),s=n(47),u=n(48),c=n(49),f=n(12),d=n(32),p=n(33),h=n(31),y=n(1),b={Scope:y.Scope,create:y.create,find:y.find,query:y.query,register:y.register,Container:r.default,Format:o.default,Leaf:i.default,Embed:u.default,Scroll:l.default,Block:s.default,Inline:a.default,Text:c.default,Attributor:{Attribute:f.default,Class:d.default,Style:p.default,Store:h.default}};e.default=b},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){function e(e){var n=this;return e="[Parchment] "+e,(n=t.call(this,e)||this).message=e,n.name=n.constructor.name,n}return o(e,t),e}(Error);e.ParchmentError=i;var l,a={},s={},u={},c={};function f(t,e){var n;if(void 0===e&&(e=l.ANY),"string"==typeof t)n=c[t]||a[t];else if(t instanceof Text||t.nodeType===Node.TEXT_NODE)n=c.text;else if("number"==typeof t)t&l.LEVEL&l.BLOCK?n=c.block:t&l.LEVEL&l.INLINE&&(n=c.inline);else if(t instanceof HTMLElement){var r=(t.getAttribute("class")||"").split(/\s+/);for(var o in r)if(n=s[r[o]])break;n=n||u[t.tagName]}return null==n?null:e&l.LEVEL&n.scope&&e&l.TYPE&n.scope?n:null}e.DATA_KEY="__blot",function(t){t[t.TYPE=3]="TYPE",t[t.LEVEL=12]="LEVEL",t[t.ATTRIBUTE=13]="ATTRIBUTE",t[t.BLOT=14]="BLOT",t[t.INLINE=7]="INLINE",t[t.BLOCK=11]="BLOCK",t[t.BLOCK_BLOT=10]="BLOCK_BLOT",t[t.INLINE_BLOT=6]="INLINE_BLOT",t[t.BLOCK_ATTRIBUTE=9]="BLOCK_ATTRIBUTE",t[t.INLINE_ATTRIBUTE=5]="INLINE_ATTRIBUTE",t[t.ANY=15]="ANY"}(l=e.Scope||(e.Scope={})),e.create=function(t,e){var n=f(t);if(null==n)throw new i("Unable to create "+t+" blot");var r=n,o=t instanceof Node||t.nodeType===Node.TEXT_NODE?t:r.create(e);return new r(o,e)},e.find=function t(n,r){return void 0===r&&(r=!1),null==n?null:null!=n[e.DATA_KEY]?n[e.DATA_KEY].blot:r?t(n.parentNode,r):null},e.query=f,e.register=function t(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];if(e.length>1)return e.map((function(e){return t(e)}));var r=e[0];if("string"!=typeof r.blotName&&"string"!=typeof r.attrName)throw new i("Invalid definition");if("abstract"===r.blotName)throw new i("Cannot register abstract class");if(c[r.blotName||r.attrName]=r,"string"==typeof r.keyName)a[r.keyName]=r;else if(null!=r.className&&(s[r.className]=r),null!=r.tagName){Array.isArray(r.tagName)?r.tagName=r.tagName.map((function(t){return t.toUpperCase()})):r.tagName=r.tagName.toUpperCase();var o=Array.isArray(r.tagName)?r.tagName:[r.tagName];o.forEach((function(t){null!=u[t]&&null!=r.className||(u[t]=r)}))}return r}},function(t,e,n){var r=n(51),o=n(11),i=n(3),l=n(20),a=String.fromCharCode(0),s=function(t){Array.isArray(t)?this.ops=t:null!=t&&Array.isArray(t.ops)?this.ops=t.ops:this.ops=[]};s.prototype.insert=function(t,e){var n={};return 0===t.length?this:(n.insert=t,null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n))},s.prototype.delete=function(t){return t<=0?this:this.push({delete:t})},s.prototype.retain=function(t,e){if(t<=0)return this;var n={retain:t};return null!=e&&"object"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n)},s.prototype.push=function(t){var e=this.ops.length,n=this.ops[e-1];if(t=i(!0,{},t),"object"==typeof n){if("number"==typeof t.delete&&"number"==typeof n.delete)return this.ops[e-1]={delete:n.delete+t.delete},this;if("number"==typeof n.delete&&null!=t.insert&&(e-=1,"object"!=typeof(n=this.ops[e-1])))return this.ops.unshift(t),this;if(o(t.attributes,n.attributes)){if("string"==typeof t.insert&&"string"==typeof n.insert)return this.ops[e-1]={insert:n.insert+t.insert},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this;if("number"==typeof t.retain&&"number"==typeof n.retain)return this.ops[e-1]={retain:n.retain+t.retain},"object"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this}}return e===this.ops.length?this.ops.push(t):this.ops.splice(e,0,t),this},s.prototype.chop=function(){var t=this.ops[this.ops.length-1];return t&&t.retain&&!t.attributes&&this.ops.pop(),this},s.prototype.filter=function(t){return this.ops.filter(t)},s.prototype.forEach=function(t){this.ops.forEach(t)},s.prototype.map=function(t){return this.ops.map(t)},s.prototype.partition=function(t){var e=[],n=[];return this.forEach((function(r){(t(r)?e:n).push(r)})),[e,n]},s.prototype.reduce=function(t,e){return this.ops.reduce(t,e)},s.prototype.changeLength=function(){return this.reduce((function(t,e){return e.insert?t+l.length(e):e.delete?t-e.delete:t}),0)},s.prototype.length=function(){return this.reduce((function(t,e){return t+l.length(e)}),0)},s.prototype.slice=function(t,e){t=t||0,"number"!=typeof e&&(e=1/0);for(var n=[],r=l.iterator(this.ops),o=0;o<e&&r.hasNext();){var i;o<t?i=r.next(t-o):(i=r.next(e-o),n.push(i)),o+=l.length(i)}return new s(n)},s.prototype.compose=function(t){var e=l.iterator(this.ops),n=l.iterator(t.ops),r=[],i=n.peek();if(null!=i&&"number"==typeof i.retain&&null==i.attributes){for(var a=i.retain;"insert"===e.peekType()&&e.peekLength()<=a;)a-=e.peekLength(),r.push(e.next());i.retain-a>0&&n.next(i.retain-a)}for(var u=new s(r);e.hasNext()||n.hasNext();)if("insert"===n.peekType())u.push(n.next());else if("delete"===e.peekType())u.push(e.next());else{var c=Math.min(e.peekLength(),n.peekLength()),f=e.next(c),d=n.next(c);if("number"==typeof d.retain){var p={};"number"==typeof f.retain?p.retain=c:p.insert=f.insert;var h=l.attributes.compose(f.attributes,d.attributes,"number"==typeof f.retain);if(h&&(p.attributes=h),u.push(p),!n.hasNext()&&o(u.ops[u.ops.length-1],p)){var y=new s(e.rest());return u.concat(y).chop()}}else"number"==typeof d.delete&&"number"==typeof f.retain&&u.push(d)}return u.chop()},s.prototype.concat=function(t){var e=new s(this.ops.slice());return t.ops.length>0&&(e.push(t.ops[0]),e.ops=e.ops.concat(t.ops.slice(1))),e},s.prototype.diff=function(t,e){if(this.ops===t.ops)return new s;var n=[this,t].map((function(e){return e.map((function(n){if(null!=n.insert)return"string"==typeof n.insert?n.insert:a;throw new Error("diff() called "+(e===t?"on":"with")+" non-document")})).join("")})),i=new s,u=r(n[0],n[1],e),c=l.iterator(this.ops),f=l.iterator(t.ops);return u.forEach((function(t){for(var e=t[1].length;e>0;){var n=0;switch(t[0]){case r.INSERT:n=Math.min(f.peekLength(),e),i.push(f.next(n));break;case r.DELETE:n=Math.min(e,c.peekLength()),c.next(n),i.delete(n);break;case r.EQUAL:n=Math.min(c.peekLength(),f.peekLength(),e);var a=c.next(n),s=f.next(n);o(a.insert,s.insert)?i.retain(n,l.attributes.diff(a.attributes,s.attributes)):i.push(s).delete(n)}e-=n}})),i.chop()},s.prototype.eachLine=function(t,e){e=e||"\n";for(var n=l.iterator(this.ops),r=new s,o=0;n.hasNext();){if("insert"!==n.peekType())return;var i=n.peek(),a=l.length(i)-n.peekLength(),u="string"==typeof i.insert?i.insert.indexOf(e,a)-a:-1;if(u<0)r.push(n.next());else if(u>0)r.push(n.next(u));else{if(!1===t(r,n.next(1).attributes||{},o))return;o+=1,r=new s}}r.length()>0&&t(r,{},o)},s.prototype.transform=function(t,e){if(e=!!e,"number"==typeof t)return this.transformPosition(t,e);for(var n=l.iterator(this.ops),r=l.iterator(t.ops),o=new s;n.hasNext()||r.hasNext();)if("insert"!==n.peekType()||!e&&"insert"===r.peekType())if("insert"===r.peekType())o.push(r.next());else{var i=Math.min(n.peekLength(),r.peekLength()),a=n.next(i),u=r.next(i);if(a.delete)continue;u.delete?o.push(u):o.retain(i,l.attributes.transform(a.attributes,u.attributes,e))}else o.retain(l.length(n.next()));return o.chop()},s.prototype.transformPosition=function(t,e){e=!!e;for(var n=l.iterator(this.ops),r=0;n.hasNext()&&r<=t;){var o=n.peekLength(),i=n.peekType();n.next(),"delete"!==i?("insert"===i&&(r<t||!e)&&(t+=o),r+=o):t-=Math.min(o,t-r)}return t},t.exports=s},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r=Object.prototype.toString,o=Object.defineProperty,i=Object.getOwnPropertyDescriptor,l=function(t){return"function"==typeof Array.isArray?Array.isArray(t):"[object Array]"===r.call(t)},a=function(t){if(!t||"[object Object]"!==r.call(t))return!1;var e,o=n.call(t,"constructor"),i=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!o&&!i)return!1;for(e in t);return void 0===e||n.call(t,e)},s=function(t,e){o&&"__proto__"===e.name?o(t,e.name,{enumerable:!0,configurable:!0,value:e.newValue,writable:!0}):t[e.name]=e.newValue},u=function(t,e){if("__proto__"===e){if(!n.call(t,e))return;if(i)return i(t,e).value}return t[e]};t.exports=function t(){var e,n,r,o,i,c,f=arguments[0],d=1,p=arguments.length,h=!1;for("boolean"==typeof f&&(h=f,f=arguments[1]||{},d=2),(null==f||"object"!=typeof f&&"function"!=typeof f)&&(f={});d<p;++d)if(null!=(e=arguments[d]))for(n in e)r=u(f,n),f!==(o=u(e,n))&&(h&&o&&(a(o)||(i=l(o)))?(i?(i=!1,c=r&&l(r)?r:[]):c=r&&a(r)?r:{},s(f,{name:n,newValue:t(h,c,o)})):void 0!==o&&s(f,{name:n,newValue:o}));return f}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BlockEmbed=e.bubbleFormats=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=f(n(3)),l=f(n(2)),a=f(n(0)),s=f(n(16)),u=f(n(6)),c=f(n(7));function f(t){return t&&t.__esModule?t:{default:t}}function d(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function p(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function h(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var y=function(t){function e(){return d(this,e),p(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return h(e,t),r(e,[{key:"attach",value:function(){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"attach",this).call(this),this.attributes=new a.default.Attributor.Store(this.domNode)}},{key:"delta",value:function(){return(new l.default).insert(this.value(),(0,i.default)(this.formats(),this.attributes.values()))}},{key:"format",value:function(t,e){var n=a.default.query(t,a.default.Scope.BLOCK_ATTRIBUTE);null!=n&&this.attributes.attribute(n,e)}},{key:"formatAt",value:function(t,e,n,r){this.format(n,r)}},{key:"insertAt",value:function(t,n,r){if("string"==typeof n&&n.endsWith("\n")){var i=a.default.create(b.blotName);this.parent.insertBefore(i,0===t?this:this.next),i.insertAt(0,n.slice(0,-1))}else o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r)}}]),e}(a.default.Embed);y.scope=a.default.Scope.BLOCK_BLOT;var b=function(t){function e(t){d(this,e);var n=p(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.cache={},n}return h(e,t),r(e,[{key:"delta",value:function(){return null==this.cache.delta&&(this.cache.delta=this.descendants(a.default.Leaf).reduce((function(t,e){return 0===e.length()?t:t.insert(e.value(),v(e))}),new l.default).insert("\n",v(this))),this.cache.delta}},{key:"deleteAt",value:function(t,n){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),this.cache={}}},{key:"formatAt",value:function(t,n,r,i){n<=0||(a.default.query(r,a.default.Scope.BLOCK)?t+n===this.length()&&this.format(r,i):o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,Math.min(n,this.length()-t-1),r,i),this.cache={})}},{key:"insertAt",value:function(t,n,r){if(null!=r)return o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);if(0!==n.length){var i=n.split("\n"),l=i.shift();l.length>0&&(t<this.length()-1||null==this.children.tail?o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,Math.min(t,this.length()-1),l):this.children.tail.insertAt(this.children.tail.length(),l),this.cache={});var a=this;i.reduce((function(t,e){return(a=a.split(t,!0)).insertAt(0,e),e.length}),t+l.length)}}},{key:"insertBefore",value:function(t,n){var r=this.children.head;o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n),r instanceof s.default&&r.remove(),this.cache={}}},{key:"length",value:function(){return null==this.cache.length&&(this.cache.length=o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"length",this).call(this)+1),this.cache.length}},{key:"moveChildren",value:function(t,n){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"moveChildren",this).call(this,t,n),this.cache={}}},{key:"optimize",value:function(t){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.cache={}}},{key:"path",value:function(t){return o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t,!0)}},{key:"removeChild",value:function(t){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"removeChild",this).call(this,t),this.cache={}}},{key:"split",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(n&&(0===t||t>=this.length()-1)){var r=this.clone();return 0===t?(this.parent.insertBefore(r,this),this):(this.parent.insertBefore(r,this.next),r)}var i=o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"split",this).call(this,t,n);return this.cache={},i}}]),e}(a.default.Block);function v(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null==t?e:("function"==typeof t.formats&&(e=(0,i.default)(e,t.formats())),null==t.parent||"scroll"==t.parent.blotName||t.parent.statics.scope!==t.statics.scope?e:v(t.parent,e))}b.blotName="block",b.tagName="P",b.defaultChild="break",b.allowedChildren=[u.default,a.default.Embed,c.default],e.bubbleFormats=v,e.BlockEmbed=y,e.default=b},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.overload=e.expandConfig=void 0;var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();n(50);var l=b(n(2)),a=b(n(14)),s=b(n(8)),u=b(n(9)),c=b(n(0)),f=n(15),d=b(f),p=b(n(3)),h=b(n(10)),y=b(n(34));function b(t){return t&&t.__esModule?t:{default:t}}function v(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function g(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var m=(0,h.default)("quill"),q=function(){function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(g(this,t),this.options=w(e,r),this.container=this.options.container,null==this.container)return m.error("Invalid Quill container",e);this.options.debug&&t.debug(this.options.debug);var o=this.container.innerHTML.trim();this.container.classList.add("ql-container"),this.container.innerHTML="",this.container.__quill=this,this.root=this.addContainer("ql-editor"),this.root.classList.add("ql-blank"),this.root.setAttribute("data-gramm",!1),this.scrollingContainer=this.options.scrollingContainer||this.root,this.emitter=new s.default,this.scroll=c.default.create(this.root,{emitter:this.emitter,whitelist:this.options.formats}),this.editor=new a.default(this.scroll),this.selection=new d.default(this.scroll,this.emitter),this.theme=new this.options.theme(this,this.options),this.keyboard=this.theme.addModule("keyboard"),this.clipboard=this.theme.addModule("clipboard"),this.history=this.theme.addModule("history"),this.theme.init(),this.emitter.on(s.default.events.EDITOR_CHANGE,(function(t){t===s.default.events.TEXT_CHANGE&&n.root.classList.toggle("ql-blank",n.editor.isBlank())})),this.emitter.on(s.default.events.SCROLL_UPDATE,(function(t,e){var r=n.selection.lastRange,o=r&&0===r.length?r.index:void 0;_.call(n,(function(){return n.editor.update(null,e,o)}),t)}));var i=this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">"+o+"<p><br></p></div>");this.setContents(i),this.history.clear(),this.options.placeholder&&this.root.setAttribute("data-placeholder",this.options.placeholder),this.options.readOnly&&this.disable()}return i(t,null,[{key:"debug",value:function(t){!0===t&&(t="log"),h.default.level(t)}},{key:"find",value:function(t){return t.__quill||c.default.find(t)}},{key:"import",value:function(t){return null==this.imports[t]&&m.error("Cannot import "+t+". Are you sure it was registered?"),this.imports[t]}},{key:"register",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if("string"!=typeof t){var o=t.attrName||t.blotName;"string"==typeof o?this.register("formats/"+o,t,e):Object.keys(t).forEach((function(r){n.register(r,t[r],e)}))}else null==this.imports[t]||r||m.warn("Overwriting "+t+" with",e),this.imports[t]=e,(t.startsWith("blots/")||t.startsWith("formats/"))&&"abstract"!==e.blotName?c.default.register(e):t.startsWith("modules")&&"function"==typeof e.register&&e.register()}}]),i(t,[{key:"addContainer",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if("string"==typeof t){var n=t;(t=document.createElement("div")).classList.add(n)}return this.container.insertBefore(t,e),t}},{key:"blur",value:function(){this.selection.setRange(null)}},{key:"deleteText",value:function(t,e,n){var r=this,i=x(t,e,n),l=o(i,4);return t=l[0],e=l[1],n=l[3],_.call(this,(function(){return r.editor.deleteText(t,e)}),n,t,-1*e)}},{key:"disable",value:function(){this.enable(!1)}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.scroll.enable(t),this.container.classList.toggle("ql-disabled",!t)}},{key:"focus",value:function(){var t=this.scrollingContainer.scrollTop;this.selection.focus(),this.scrollingContainer.scrollTop=t,this.scrollIntoView()}},{key:"format",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.default.sources.API;return _.call(this,(function(){var r=n.getSelection(!0),o=new l.default;if(null==r)return o;if(c.default.query(t,c.default.Scope.BLOCK))o=n.editor.formatLine(r.index,r.length,v({},t,e));else{if(0===r.length)return n.selection.format(t,e),o;o=n.editor.formatText(r.index,r.length,v({},t,e))}return n.setSelection(r,s.default.sources.SILENT),o}),r)}},{key:"formatLine",value:function(t,e,n,r,i){var l,a=this,s=x(t,e,n,r,i),u=o(s,4);return t=u[0],e=u[1],l=u[2],i=u[3],_.call(this,(function(){return a.editor.formatLine(t,e,l)}),i,t,0)}},{key:"formatText",value:function(t,e,n,r,i){var l,a=this,s=x(t,e,n,r,i),u=o(s,4);return t=u[0],e=u[1],l=u[2],i=u[3],_.call(this,(function(){return a.editor.formatText(t,e,l)}),i,t,0)}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=void 0;n="number"==typeof t?this.selection.getBounds(t,e):this.selection.getBounds(t.index,t.length);var r=this.container.getBoundingClientRect();return{bottom:n.bottom-r.top,height:n.height,left:n.left-r.left,right:n.right-r.left,top:n.top-r.top,width:n.width}}},{key:"getContents",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=x(t,e),r=o(n,2);return t=r[0],e=r[1],this.editor.getContents(t,e)}},{key:"getFormat",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.getSelection(!0),e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return"number"==typeof t?this.editor.getFormat(t,e):this.editor.getFormat(t.index,t.length)}},{key:"getIndex",value:function(t){return t.offset(this.scroll)}},{key:"getLength",value:function(){return this.scroll.length()}},{key:"getLeaf",value:function(t){return this.scroll.leaf(t)}},{key:"getLine",value:function(t){return this.scroll.line(t)}},{key:"getLines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return"number"!=typeof t?this.scroll.lines(t.index,t.length):this.scroll.lines(t,e)}},{key:"getModule",value:function(t){return this.theme.modules[t]}},{key:"getSelection",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return t&&this.focus(),this.update(),this.selection.getRange()[0]}},{key:"getText",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=x(t,e),r=o(n,2);return t=r[0],e=r[1],this.editor.getText(t,e)}},{key:"hasFocus",value:function(){return this.selection.hasFocus()}},{key:"insertEmbed",value:function(e,n,r){var o=this,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:t.sources.API;return _.call(this,(function(){return o.editor.insertEmbed(e,n,r)}),i,e)}},{key:"insertText",value:function(t,e,n,r,i){var l,a=this,s=x(t,0,n,r,i),u=o(s,4);return t=u[0],l=u[2],i=u[3],_.call(this,(function(){return a.editor.insertText(t,e,l)}),i,t,e.length)}},{key:"isEnabled",value:function(){return!this.container.classList.contains("ql-disabled")}},{key:"off",value:function(){return this.emitter.off.apply(this.emitter,arguments)}},{key:"on",value:function(){return this.emitter.on.apply(this.emitter,arguments)}},{key:"once",value:function(){return this.emitter.once.apply(this.emitter,arguments)}},{key:"pasteHTML",value:function(t,e,n){this.clipboard.dangerouslyPasteHTML(t,e,n)}},{key:"removeFormat",value:function(t,e,n){var r=this,i=x(t,e,n),l=o(i,4);return t=l[0],e=l[1],n=l[3],_.call(this,(function(){return r.editor.removeFormat(t,e)}),n,t)}},{key:"scrollIntoView",value:function(){this.selection.scrollIntoView(this.scrollingContainer)}},{key:"setContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.default.sources.API;return _.call(this,(function(){t=new l.default(t);var n=e.getLength(),r=e.editor.deleteText(0,n),o=e.editor.applyDelta(t),i=o.ops[o.ops.length-1];return null!=i&&"string"==typeof i.insert&&"\n"===i.insert[i.insert.length-1]&&(e.editor.deleteText(e.getLength()-1,1),o.delete(1)),r.compose(o)}),n)}},{key:"setSelection",value:function(e,n,r){if(null==e)this.selection.setRange(null,n||t.sources.API);else{var i=x(e,n,r),l=o(i,4);e=l[0],n=l[1],r=l[3],this.selection.setRange(new f.Range(e,n),r),r!==s.default.sources.SILENT&&this.selection.scrollIntoView(this.scrollingContainer)}}},{key:"setText",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.default.sources.API,n=(new l.default).insert(t);return this.setContents(n,e)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s.default.sources.USER,e=this.scroll.update(t);return this.selection.update(t),e}},{key:"updateContents",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.default.sources.API;return _.call(this,(function(){return t=new l.default(t),e.editor.applyDelta(t,n)}),n,!0)}}]),t}();function w(t,e){if((e=(0,p.default)(!0,{container:t,modules:{clipboard:!0,keyboard:!0,history:!0}},e)).theme&&e.theme!==q.DEFAULTS.theme){if(e.theme=q.import("themes/"+e.theme),null==e.theme)throw new Error("Invalid theme "+e.theme+". Did you register it?")}else e.theme=y.default;var n=(0,p.default)(!0,{},e.theme.DEFAULTS);[n,e].forEach((function(t){t.modules=t.modules||{},Object.keys(t.modules).forEach((function(e){!0===t.modules[e]&&(t.modules[e]={})}))}));var r=Object.keys(n.modules).concat(Object.keys(e.modules)).reduce((function(t,e){var n=q.import("modules/"+e);return null==n?m.error("Cannot load "+e+" module. Are you sure you registered it?"):t[e]=n.DEFAULTS||{},t}),{});return null!=e.modules&&e.modules.toolbar&&e.modules.toolbar.constructor!==Object&&(e.modules.toolbar={container:e.modules.toolbar}),e=(0,p.default)(!0,{},q.DEFAULTS,{modules:r},n,e),["bounds","container","scrollingContainer"].forEach((function(t){"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))})),e.modules=Object.keys(e.modules).reduce((function(t,n){return e.modules[n]&&(t[n]=e.modules[n]),t}),{}),e}function _(t,e,n,r){if(this.options.strict&&!this.isEnabled()&&e===s.default.sources.USER)return new l.default;var o=null==n?null:this.getSelection(),i=this.editor.delta,a=t();if(null!=o&&(!0===n&&(n=o.index),null==r?o=k(o,a,e):0!==r&&(o=k(o,n,r,e)),this.setSelection(o,s.default.sources.SILENT)),a.length()>0){var u,c,f=[s.default.events.TEXT_CHANGE,a,i,e];(u=this.emitter).emit.apply(u,[s.default.events.EDITOR_CHANGE].concat(f)),e!==s.default.sources.SILENT&&(c=this.emitter).emit.apply(c,f)}return a}function x(t,e,n,o,i){var l={};return"number"==typeof t.index&&"number"==typeof t.length?"number"!=typeof e?(i=o,o=n,n=e,e=t.length,t=t.index):(e=t.length,t=t.index):"number"!=typeof e&&(i=o,o=n,n=e,e=0),"object"===(void 0===n?"undefined":r(n))?(l=n,i=o):"string"==typeof n&&(null!=o?l[n]=o:i=n),[t,e,l,i=i||s.default.sources.API]}function k(t,e,n,r){if(null==t)return null;var i=void 0,a=void 0;if(e instanceof l.default){var u=[t.index,t.index+t.length].map((function(t){return e.transformPosition(t,r!==s.default.sources.USER)})),c=o(u,2);i=c[0],a=c[1]}else{var d=[t.index,t.index+t.length].map((function(t){return t<e||t===e&&r===s.default.sources.USER?t:n>=0?t+n:Math.max(e,t+n)})),p=o(d,2);i=p[0],a=p[1]}return new f.Range(i,a-i)}q.DEFAULTS={bounds:null,formats:null,modules:{},placeholder:"",readOnly:!1,scrollingContainer:null,strict:!0,theme:"default"},q.events=s.default.events,q.sources=s.default.sources,q.version="1.3.7",q.imports={delta:l.default,parchment:c.default,"core/module":u.default,"core/theme":y.default},e.expandConfig=w,e.overload=x,e.default=q},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=a(n(7)),l=a(n(0));function a(t){return t&&t.__esModule?t:{default:t}}function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var c=function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"formatAt",value:function(t,n,r,i){if(e.compare(this.statics.blotName,r)<0&&l.default.query(r,l.default.Scope.BLOT)){var a=this.isolate(t,n);i&&a.wrap(r,i)}else o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,i)}},{key:"optimize",value:function(t){if(o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.parent instanceof e&&e.compare(this.statics.blotName,this.parent.statics.blotName)>0){var n=this.parent.isolate(this.offset(),this.length());this.moveChildren(n),n.wrap(this)}}}],[{key:"compare",value:function(t,n){var r=e.order.indexOf(t),o=e.order.indexOf(n);return r>=0||o>=0?r-o:t===n?0:t<n?-1:1}}]),e}(l.default.Inline);c.allowedChildren=[c,l.default.Embed,i.default],c.order=["cursor","inline","underline","strike","italic","bold","script","link","code"],e.default=c},function(t,e,n){"use strict";var r;function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=n(0))&&r.__esModule?r:{default:r}).default.Text);e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=l(n(54));function l(t){return t&&t.__esModule?t:{default:t}}var a=(0,l(n(10)).default)("quill:events");["selectionchange","mousedown","mouseup","click"].forEach((function(t){document.addEventListener(t,(function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];[].slice.call(document.querySelectorAll(".ql-container")).forEach((function(t){var n;t.__quill&&t.__quill.emitter&&(n=t.__quill.emitter).handleDOM.apply(n,e)}))}))}));var s=function(t){function e(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var t=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t.listeners={},t.on("error",a.error),t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"emit",value:function(){a.log.apply(a,arguments),o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"emit",this).apply(this,arguments)}},{key:"handleDOM",value:function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];(this.listeners[t.type]||[]).forEach((function(e){var r=e.node,o=e.handler;(t.target===r||r.contains(t.target))&&o.apply(void 0,[t].concat(n))}))}},{key:"listenDOM",value:function(t,e,n){this.listeners[t]||(this.listeners[t]=[]),this.listeners[t].push({node:e,handler:n})}}]),e}(i.default);s.events={EDITOR_CHANGE:"editor-change",SCROLL_BEFORE_UPDATE:"scroll-before-update",SCROLL_OPTIMIZE:"scroll-optimize",SCROLL_UPDATE:"scroll-update",SELECTION_CHANGE:"selection-change",TEXT_CHANGE:"text-change"},s.sources={API:"api",SILENT:"silent",USER:"user"},e.default=s},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};r(this,t),this.quill=e,this.options=n};o.DEFAULTS={},e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=["error","warn","log","info"],o="warn";function i(t){if(r.indexOf(t)<=r.indexOf(o)){for(var e,n=arguments.length,i=Array(n>1?n-1:0),l=1;l<n;l++)i[l-1]=arguments[l];(e=console)[t].apply(e,i)}}function l(t){return r.reduce((function(e,n){return e[n]=i.bind(console,n,t),e}),{})}i.level=l.level=function(t){o=t},e.default=l},function(t,e,n){var r=Array.prototype.slice,o=n(52),i=n(53),l=t.exports=function(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||"object"!=typeof t&&"object"!=typeof e?n.strict?t===e:t==e:function(t,e,n){var u,c;if(a(t)||a(e))return!1;if(t.prototype!==e.prototype)return!1;if(i(t))return!!i(e)&&(t=r.call(t),e=r.call(e),l(t,e,n));if(s(t)){if(!s(e))return!1;if(t.length!==e.length)return!1;for(u=0;u<t.length;u++)if(t[u]!==e[u])return!1;return!0}try{var f=o(t),d=o(e)}catch(t){return!1}if(f.length!=d.length)return!1;for(f.sort(),d.sort(),u=f.length-1;u>=0;u--)if(f[u]!=d[u])return!1;for(u=f.length-1;u>=0;u--)if(c=f[u],!l(t[c],e[c],n))return!1;return typeof t==typeof e}(t,e,n))};function a(t){return null==t}function s(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length||"function"!=typeof t.copy||"function"!=typeof t.slice||t.length>0&&"number"!=typeof t[0])}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t,e,n){void 0===n&&(n={}),this.attrName=t,this.keyName=e;var o=r.Scope.TYPE&r.Scope.ATTRIBUTE;null!=n.scope?this.scope=n.scope&r.Scope.LEVEL|o:this.scope=r.Scope.ATTRIBUTE,null!=n.whitelist&&(this.whitelist=n.whitelist)}return t.keys=function(t){return[].map.call(t.attributes,(function(t){return t.name}))},t.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.setAttribute(this.keyName,e),!0)},t.prototype.canAdd=function(t,e){return null!=r.query(t,r.Scope.BLOT&(this.scope|r.Scope.TYPE))&&(null==this.whitelist||("string"==typeof e?this.whitelist.indexOf(e.replace(/["']/g,""))>-1:this.whitelist.indexOf(e)>-1))},t.prototype.remove=function(t){t.removeAttribute(this.keyName)},t.prototype.value=function(t){var e=t.getAttribute(this.keyName);return this.canAdd(t,e)&&e?e:""},t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Code=void 0;var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=f(n(2)),a=f(n(0)),s=f(n(4)),u=f(n(6)),c=f(n(7));function f(t){return t&&t.__esModule?t:{default:t}}function d(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function p(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function h(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var y=function(t){function e(){return d(this,e),p(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return h(e,t),e}(u.default);y.blotName="code",y.tagName="CODE";var b=function(t){function e(){return d(this,e),p(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return h(e,t),o(e,[{key:"delta",value:function(){var t=this,e=this.domNode.textContent;return e.endsWith("\n")&&(e=e.slice(0,-1)),e.split("\n").reduce((function(e,n){return e.insert(n).insert("\n",t.formats())}),new l.default)}},{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n){var o=this.descendant(c.default,this.length()-1),l=r(o,1)[0];null!=l&&l.deleteAt(l.length()-1,1),i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}},{key:"formatAt",value:function(t,n,r,o){if(0!==n&&null!=a.default.query(r,a.default.Scope.BLOCK)&&(r!==this.statics.blotName||o!==this.statics.formats(this.domNode))){var i=this.newlineIndex(t);if(!(i<0||i>=t+n)){var l=this.newlineIndex(t,!0)+1,s=i-l+1,u=this.isolate(l,s),c=u.next;u.format(r,o),c instanceof e&&c.formatAt(0,t-l+n-s,r,o)}}}},{key:"insertAt",value:function(t,e,n){if(null==n){var o=this.descendant(c.default,t),i=r(o,2),l=i[0],a=i[1];l.insertAt(a,e)}}},{key:"length",value:function(){var t=this.domNode.textContent.length;return this.domNode.textContent.endsWith("\n")?t:t+1}},{key:"newlineIndex",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(e)return this.domNode.textContent.slice(0,t).lastIndexOf("\n");var n=this.domNode.textContent.slice(t).indexOf("\n");return n>-1?t+n:-1}},{key:"optimize",value:function(t){this.domNode.textContent.endsWith("\n")||this.appendChild(a.default.create("text","\n")),i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&this.statics.formats(this.domNode)===n.statics.formats(n.domNode)&&(n.optimize(t),n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t),[].slice.call(this.domNode.querySelectorAll("*")).forEach((function(t){var e=a.default.find(t);null==e?t.parentNode.removeChild(t):e instanceof a.default.Embed?e.remove():e.unwrap()}))}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("spellcheck",!1),n}},{key:"formats",value:function(){return!0}}]),e}(s.default);b.blotName="code-block",b.tagName="PRE",b.TAB="  ",e.Code=y,e.default=b},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=v(n(2)),a=v(n(20)),s=v(n(0)),u=v(n(13)),c=v(n(24)),f=n(4),d=v(f),p=v(n(16)),h=v(n(21)),y=v(n(11)),b=v(n(3));function v(t){return t&&t.__esModule?t:{default:t}}var g=/^[ -~]*$/,m=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.scroll=e,this.delta=this.getDelta()}return i(t,[{key:"applyDelta",value:function(t){var e=this,n=!1;this.scroll.update();var i=this.scroll.length();return this.scroll.batchStart(),(t=function(t){return t.reduce((function(t,e){if(1===e.insert){var n=(0,h.default)(e.attributes);return delete n.image,t.insert({image:e.attributes.image},n)}if(null==e.attributes||!0!==e.attributes.list&&!0!==e.attributes.bullet||((e=(0,h.default)(e)).attributes.list?e.attributes.list="ordered":(e.attributes.list="bullet",delete e.attributes.bullet)),"string"==typeof e.insert){var r=e.insert.replace(/\r\n/g,"\n").replace(/\r/g,"\n");return t.insert(r,e.attributes)}return t.push(e)}),new l.default)}(t)).reduce((function(t,l){var u=l.retain||l.delete||l.insert.length||1,c=l.attributes||{};if(null!=l.insert){if("string"==typeof l.insert){var p=l.insert;p.endsWith("\n")&&n&&(n=!1,p=p.slice(0,-1)),t>=i&&!p.endsWith("\n")&&(n=!0),e.scroll.insertAt(t,p);var h=e.scroll.line(t),y=o(h,2),v=y[0],g=y[1],m=(0,b.default)({},(0,f.bubbleFormats)(v));if(v instanceof d.default){var q=v.descendant(s.default.Leaf,g),w=o(q,1)[0];m=(0,b.default)(m,(0,f.bubbleFormats)(w))}c=a.default.attributes.diff(m,c)||{}}else if("object"===r(l.insert)){var _=Object.keys(l.insert)[0];if(null==_)return t;e.scroll.insertAt(t,_,l.insert[_])}i+=u}return Object.keys(c).forEach((function(n){e.scroll.formatAt(t,u,n,c[n])})),t+u}),0),t.reduce((function(t,n){return"number"==typeof n.delete?(e.scroll.deleteAt(t,n.delete),t):t+(n.retain||n.insert.length||1)}),0),this.scroll.batchEnd(),this.update(t)}},{key:"deleteText",value:function(t,e){return this.scroll.deleteAt(t,e),this.update((new l.default).retain(t).delete(e))}},{key:"formatLine",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this.scroll.update(),Object.keys(r).forEach((function(o){if(null==n.scroll.whitelist||n.scroll.whitelist[o]){var i=n.scroll.lines(t,Math.max(e,1)),l=e;i.forEach((function(e){var i=e.length();if(e instanceof u.default){var a=t-e.offset(n.scroll),s=e.newlineIndex(a+l)-a+1;e.formatAt(a,s,o,r[o])}else e.format(o,r[o]);l-=i}))}})),this.scroll.optimize(),this.update((new l.default).retain(t).retain(e,(0,h.default)(r)))}},{key:"formatText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return Object.keys(r).forEach((function(o){n.scroll.formatAt(t,e,o,r[o])})),this.update((new l.default).retain(t).retain(e,(0,h.default)(r)))}},{key:"getContents",value:function(t,e){return this.delta.slice(t,t+e)}},{key:"getDelta",value:function(){return this.scroll.lines().reduce((function(t,e){return t.concat(e.delta())}),new l.default)}},{key:"getFormat",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=[],r=[];0===e?this.scroll.path(t).forEach((function(t){var e=o(t,1)[0];e instanceof d.default?n.push(e):e instanceof s.default.Leaf&&r.push(e)})):(n=this.scroll.lines(t,e),r=this.scroll.descendants(s.default.Leaf,t,e));var i=[n,r].map((function(t){if(0===t.length)return{};for(var e=(0,f.bubbleFormats)(t.shift());Object.keys(e).length>0;){var n=t.shift();if(null==n)return e;e=q((0,f.bubbleFormats)(n),e)}return e}));return b.default.apply(b.default,i)}},{key:"getText",value:function(t,e){return this.getContents(t,e).filter((function(t){return"string"==typeof t.insert})).map((function(t){return t.insert})).join("")}},{key:"insertEmbed",value:function(t,e,n){return this.scroll.insertAt(t,e,n),this.update((new l.default).retain(t).insert(function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}({},e,n)))}},{key:"insertText",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return e=e.replace(/\r\n/g,"\n").replace(/\r/g,"\n"),this.scroll.insertAt(t,e),Object.keys(r).forEach((function(o){n.scroll.formatAt(t,e.length,o,r[o])})),this.update((new l.default).retain(t).insert(e,(0,h.default)(r)))}},{key:"isBlank",value:function(){if(0==this.scroll.children.length)return!0;if(this.scroll.children.length>1)return!1;var t=this.scroll.children.head;return t.statics.blotName===d.default.blotName&&!(t.children.length>1)&&t.children.head instanceof p.default}},{key:"removeFormat",value:function(t,e){var n=this.getText(t,e),r=this.scroll.line(t+e),i=o(r,2),a=i[0],s=i[1],c=0,f=new l.default;null!=a&&(c=a instanceof u.default?a.newlineIndex(s)-s+1:a.length()-s,f=a.delta().slice(s,s+c-1).insert("\n"));var d=this.getContents(t,e+c).diff((new l.default).insert(n).concat(f)),p=(new l.default).retain(t).concat(d);return this.applyDelta(p)}},{key:"update",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,r=this.delta;if(1===e.length&&"characterData"===e[0].type&&e[0].target.data.match(g)&&s.default.find(e[0].target)){var o=s.default.find(e[0].target),i=(0,f.bubbleFormats)(o),a=o.offset(this.scroll),u=e[0].oldValue.replace(c.default.CONTENTS,""),d=(new l.default).insert(u),p=(new l.default).insert(o.value()),h=(new l.default).retain(a).concat(d.diff(p,n));t=h.reduce((function(t,e){return e.insert?t.insert(e.insert,i):t.push(e)}),new l.default),this.delta=r.compose(t)}else this.delta=this.getDelta(),t&&(0,y.default)(r.compose(t),this.delta)||(t=r.diff(this.delta,n));return t}}]),t}();function q(t,e){return Object.keys(e).reduce((function(n,r){return null==t[r]||(e[r]===t[r]?n[r]=e[r]:Array.isArray(e[r])?e[r].indexOf(t[r])<0&&(n[r]=e[r].concat([t[r]])):n[r]=[e[r],t[r]]),n}),{})}e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.Range=void 0;var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=u(n(0)),l=u(n(21)),a=u(n(11)),s=u(n(8));function u(t){return t&&t.__esModule?t:{default:t}}function c(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function f(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var d=(0,u(n(10)).default)("quill:selection"),p=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;f(this,t),this.index=e,this.length=n},h=function(){function t(e,n){var r=this;f(this,t),this.emitter=n,this.scroll=e,this.composing=!1,this.mouseDown=!1,this.root=this.scroll.domNode,this.cursor=i.default.create("cursor",this),this.lastRange=this.savedRange=new p(0,0),this.handleComposition(),this.handleDragging(),this.emitter.listenDOM("selectionchange",document,(function(){r.mouseDown||setTimeout(r.update.bind(r,s.default.sources.USER),1)})),this.emitter.on(s.default.events.EDITOR_CHANGE,(function(t,e){t===s.default.events.TEXT_CHANGE&&e.length()>0&&r.update(s.default.sources.SILENT)})),this.emitter.on(s.default.events.SCROLL_BEFORE_UPDATE,(function(){if(r.hasFocus()){var t=r.getNativeRange();null!=t&&t.start.node!==r.cursor.textNode&&r.emitter.once(s.default.events.SCROLL_UPDATE,(function(){try{r.setNativeRange(t.start.node,t.start.offset,t.end.node,t.end.offset)}catch(t){}}))}})),this.emitter.on(s.default.events.SCROLL_OPTIMIZE,(function(t,e){if(e.range){var n=e.range,o=n.startNode,i=n.startOffset,l=n.endNode,a=n.endOffset;r.setNativeRange(o,i,l,a)}})),this.update(s.default.sources.SILENT)}return o(t,[{key:"handleComposition",value:function(){var t=this;this.root.addEventListener("compositionstart",(function(){t.composing=!0})),this.root.addEventListener("compositionend",(function(){if(t.composing=!1,t.cursor.parent){var e=t.cursor.restore();if(!e)return;setTimeout((function(){t.setNativeRange(e.startNode,e.startOffset,e.endNode,e.endOffset)}),1)}}))}},{key:"handleDragging",value:function(){var t=this;this.emitter.listenDOM("mousedown",document.body,(function(){t.mouseDown=!0})),this.emitter.listenDOM("mouseup",document.body,(function(){t.mouseDown=!1,t.update(s.default.sources.USER)}))}},{key:"focus",value:function(){this.hasFocus()||(this.root.focus(),this.setRange(this.savedRange))}},{key:"format",value:function(t,e){if(null==this.scroll.whitelist||this.scroll.whitelist[t]){this.scroll.update();var n=this.getNativeRange();if(null!=n&&n.native.collapsed&&!i.default.query(t,i.default.Scope.BLOCK)){if(n.start.node!==this.cursor.textNode){var r=i.default.find(n.start.node,!1);if(null==r)return;if(r instanceof i.default.Leaf){var o=r.split(n.start.offset);r.parent.insertBefore(this.cursor,o)}else r.insertBefore(this.cursor,n.start.node);this.cursor.attach()}this.cursor.format(t,e),this.scroll.optimize(),this.setNativeRange(this.cursor.textNode,this.cursor.textNode.data.length),this.update()}}}},{key:"getBounds",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=this.scroll.length();t=Math.min(t,n-1),e=Math.min(t+e,n-1)-t;var o=void 0,i=this.scroll.leaf(t),l=r(i,2),a=l[0],s=l[1];if(null==a)return null;var u=a.position(s,!0),c=r(u,2);o=c[0],s=c[1];var f=document.createRange();if(e>0){f.setStart(o,s);var d=this.scroll.leaf(t+e),p=r(d,2);if(a=p[0],s=p[1],null==a)return null;var h=a.position(s,!0),y=r(h,2);return o=y[0],s=y[1],f.setEnd(o,s),f.getBoundingClientRect()}var b="left",v=void 0;return o instanceof Text?(s<o.data.length?(f.setStart(o,s),f.setEnd(o,s+1)):(f.setStart(o,s-1),f.setEnd(o,s),b="right"),v=f.getBoundingClientRect()):(v=a.domNode.getBoundingClientRect(),s>0&&(b="right")),{bottom:v.top+v.height,height:v.height,left:v[b],right:v[b],top:v.top,width:0}}},{key:"getNativeRange",value:function(){var t=document.getSelection();if(null==t||t.rangeCount<=0)return null;var e=t.getRangeAt(0);if(null==e)return null;var n=this.normalizeNative(e);return d.info("getNativeRange",n),n}},{key:"getRange",value:function(){var t=this.getNativeRange();return null==t?[null,null]:[this.normalizedToRange(t),t]}},{key:"hasFocus",value:function(){return document.activeElement===this.root}},{key:"normalizedToRange",value:function(t){var e=this,n=[[t.start.node,t.start.offset]];t.native.collapsed||n.push([t.end.node,t.end.offset]);var o=n.map((function(t){var n=r(t,2),o=n[0],l=n[1],a=i.default.find(o,!0),s=a.offset(e.scroll);return 0===l?s:a instanceof i.default.Container?s+a.length():s+a.index(o,l)})),l=Math.min(Math.max.apply(Math,c(o)),this.scroll.length()-1),a=Math.min.apply(Math,[l].concat(c(o)));return new p(a,l-a)}},{key:"normalizeNative",value:function(t){if(!y(this.root,t.startContainer)||!t.collapsed&&!y(this.root,t.endContainer))return null;var e={start:{node:t.startContainer,offset:t.startOffset},end:{node:t.endContainer,offset:t.endOffset},native:t};return[e.start,e.end].forEach((function(t){for(var e=t.node,n=t.offset;!(e instanceof Text)&&e.childNodes.length>0;)if(e.childNodes.length>n)e=e.childNodes[n],n=0;else{if(e.childNodes.length!==n)break;n=(e=e.lastChild)instanceof Text?e.data.length:e.childNodes.length+1}t.node=e,t.offset=n})),e}},{key:"rangeToNative",value:function(t){var e=this,n=t.collapsed?[t.index]:[t.index,t.index+t.length],o=[],i=this.scroll.length();return n.forEach((function(t,n){t=Math.min(i-1,t);var l,a=e.scroll.leaf(t),s=r(a,2),u=s[0],c=s[1],f=u.position(c,0!==n),d=r(f,2);l=d[0],c=d[1],o.push(l,c)})),o.length<2&&(o=o.concat(o)),o}},{key:"scrollIntoView",value:function(t){var e=this.lastRange;if(null!=e){var n=this.getBounds(e.index,e.length);if(null!=n){var o=this.scroll.length()-1,i=this.scroll.line(Math.min(e.index,o)),l=r(i,1)[0],a=l;if(e.length>0){var s=this.scroll.line(Math.min(e.index+e.length,o));a=r(s,1)[0]}if(null!=l&&null!=a){var u=t.getBoundingClientRect();n.top<u.top?t.scrollTop-=u.top-n.top:n.bottom>u.bottom&&(t.scrollTop+=n.bottom-u.bottom)}}}}},{key:"setNativeRange",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:e,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(d.info("setNativeRange",t,e,n,r),null==t||null!=this.root.parentNode&&null!=t.parentNode&&null!=n.parentNode){var i=document.getSelection();if(null!=i)if(null!=t){this.hasFocus()||this.root.focus();var l=(this.getNativeRange()||{}).native;if(null==l||o||t!==l.startContainer||e!==l.startOffset||n!==l.endContainer||r!==l.endOffset){"BR"==t.tagName&&(e=[].indexOf.call(t.parentNode.childNodes,t),t=t.parentNode),"BR"==n.tagName&&(r=[].indexOf.call(n.parentNode.childNodes,n),n=n.parentNode);var a=document.createRange();a.setStart(t,e),a.setEnd(n,r),i.removeAllRanges(),i.addRange(a)}}else i.removeAllRanges(),this.root.blur(),document.body.focus()}}},{key:"setRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.default.sources.API;if("string"==typeof e&&(n=e,e=!1),d.info("setRange",t),null!=t){var r=this.rangeToNative(t);this.setNativeRange.apply(this,c(r).concat([e]))}else this.setNativeRange(null);this.update(n)}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s.default.sources.USER,e=this.lastRange,n=this.getRange(),o=r(n,2),i=o[0],u=o[1];if(this.lastRange=i,null!=this.lastRange&&(this.savedRange=this.lastRange),!(0,a.default)(e,this.lastRange)){var c;!this.composing&&null!=u&&u.native.collapsed&&u.start.node!==this.cursor.textNode&&this.cursor.restore();var f,d=[s.default.events.SELECTION_CHANGE,(0,l.default)(this.lastRange),(0,l.default)(e),t];(c=this.emitter).emit.apply(c,[s.default.events.EDITOR_CHANGE].concat(d)),t!==s.default.sources.SILENT&&(f=this.emitter).emit.apply(f,d)}}}]),t}();function y(t,e){try{e.parentNode}catch(t){return!1}return e instanceof Text&&(e=e.parentNode),t.contains(e)}e.Range=p,e.default=h},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0};function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"insertInto",value:function(t,n){0===t.children.length?i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertInto",this).call(this,t,n):this.remove()}},{key:"length",value:function(){return 0}},{key:"value",value:function(){return""}}],[{key:"value",value:function(){}}]),e}(((r=n(0))&&r.__esModule?r:{default:r}).default.Embed);s.blotName="break",s.tagName="BR",e.default=s},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(44),l=n(30),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.build(),n}return o(e,t),e.prototype.appendChild=function(t){this.insertBefore(t)},e.prototype.attach=function(){t.prototype.attach.call(this),this.children.forEach((function(t){t.attach()}))},e.prototype.build=function(){var t=this;this.children=new i.default,[].slice.call(this.domNode.childNodes).reverse().forEach((function(e){try{var n=u(e);t.insertBefore(n,t.children.head||void 0)}catch(t){if(t instanceof a.ParchmentError)return;throw t}}))},e.prototype.deleteAt=function(t,e){if(0===t&&e===this.length())return this.remove();this.children.forEachAt(t,e,(function(t,e,n){t.deleteAt(e,n)}))},e.prototype.descendant=function(t,n){var r=this.children.find(n),o=r[0],i=r[1];return null==t.blotName&&t(o)||null!=t.blotName&&o instanceof t?[o,i]:o instanceof e?o.descendant(t,i):[null,-1]},e.prototype.descendants=function(t,n,r){void 0===n&&(n=0),void 0===r&&(r=Number.MAX_VALUE);var o=[],i=r;return this.children.forEachAt(n,r,(function(n,r,l){(null==t.blotName&&t(n)||null!=t.blotName&&n instanceof t)&&o.push(n),n instanceof e&&(o=o.concat(n.descendants(t,r,i))),i-=l})),o},e.prototype.detach=function(){this.children.forEach((function(t){t.detach()})),t.prototype.detach.call(this)},e.prototype.formatAt=function(t,e,n,r){this.children.forEachAt(t,e,(function(t,e,o){t.formatAt(e,o,n,r)}))},e.prototype.insertAt=function(t,e,n){var r=this.children.find(t),o=r[0],i=r[1];if(o)o.insertAt(i,e,n);else{var l=null==n?a.create("text",e):a.create(e,n);this.appendChild(l)}},e.prototype.insertBefore=function(t,e){if(null!=this.statics.allowedChildren&&!this.statics.allowedChildren.some((function(e){return t instanceof e})))throw new a.ParchmentError("Cannot insert "+t.statics.blotName+" into "+this.statics.blotName);t.insertInto(this,e)},e.prototype.length=function(){return this.children.reduce((function(t,e){return t+e.length()}),0)},e.prototype.moveChildren=function(t,e){this.children.forEach((function(n){t.insertBefore(n,e)}))},e.prototype.optimize=function(e){if(t.prototype.optimize.call(this,e),0===this.children.length)if(null!=this.statics.defaultChild){var n=a.create(this.statics.defaultChild);this.appendChild(n),n.optimize(e)}else this.remove()},e.prototype.path=function(t,n){void 0===n&&(n=!1);var r=this.children.find(t,n),o=r[0],i=r[1],l=[[this,t]];return o instanceof e?l.concat(o.path(i,n)):(null!=o&&l.push([o,i]),l)},e.prototype.removeChild=function(t){this.children.remove(t)},e.prototype.replace=function(n){n instanceof e&&n.moveChildren(this),t.prototype.replace.call(this,n)},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=this.clone();return this.parent.insertBefore(n,this.next),this.children.forEachAt(t,this.length(),(function(t,r,o){t=t.split(r,e),n.appendChild(t)})),n},e.prototype.unwrap=function(){this.moveChildren(this.parent,this.next),this.remove()},e.prototype.update=function(t,e){var n=this,r=[],o=[];t.forEach((function(t){t.target===n.domNode&&"childList"===t.type&&(r.push.apply(r,t.addedNodes),o.push.apply(o,t.removedNodes))})),o.forEach((function(t){if(!(null!=t.parentNode&&"IFRAME"!==t.tagName&&document.body.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY)){var e=a.find(t);null!=e&&(null!=e.domNode.parentNode&&e.domNode.parentNode!==n.domNode||e.detach())}})),r.filter((function(t){return t.parentNode==n.domNode})).sort((function(t,e){return t===e?0:t.compareDocumentPosition(e)&Node.DOCUMENT_POSITION_FOLLOWING?1:-1})).forEach((function(t){var e=null;null!=t.nextSibling&&(e=a.find(t.nextSibling));var r=u(t);r.next==e&&null!=r.next||(null!=r.parent&&r.parent.removeChild(n),n.insertBefore(r,e||void 0))}))},e}(l.default);function u(t){var e=a.find(t);if(null==e)try{e=a.create(t)}catch(n){e=a.create(a.Scope.INLINE),[].slice.call(t.childNodes).forEach((function(t){e.domNode.appendChild(t)})),t.parentNode&&t.parentNode.replaceChild(e.domNode,t),e.attach()}return e}e.default=s},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(12),l=n(31),a=n(17),s=n(1),u=function(t){function e(e){var n=t.call(this,e)||this;return n.attributes=new l.default(n.domNode),n}return o(e,t),e.formats=function(t){return"string"==typeof this.tagName||(Array.isArray(this.tagName)?t.tagName.toLowerCase():void 0)},e.prototype.format=function(t,e){var n=s.query(t);n instanceof i.default?this.attributes.attribute(n,e):e&&(null==n||t===this.statics.blotName&&this.formats()[t]===e||this.replaceWith(t,e))},e.prototype.formats=function(){var t=this.attributes.values(),e=this.statics.formats(this.domNode);return null!=e&&(t[this.statics.blotName]=e),t},e.prototype.replaceWith=function(e,n){var r=t.prototype.replaceWith.call(this,e,n);return this.attributes.copy(r),r},e.prototype.update=function(e,n){var r=this;t.prototype.update.call(this,e,n),e.some((function(t){return t.target===r.domNode&&"attributes"===t.type}))&&this.attributes.build()},e.prototype.wrap=function(n,r){var o=t.prototype.wrap.call(this,n,r);return o instanceof e&&o.statics.scope===this.statics.scope&&this.attributes.move(o),o},e}(a.default);e.default=u},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(30),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.value=function(t){return!0},e.prototype.index=function(t,e){return this.domNode===t||this.domNode.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY?Math.min(e,1):-1},e.prototype.position=function(t,e){var n=[].indexOf.call(this.parent.domNode.childNodes,this.domNode);return t>0&&(n+=1),[this.parent.domNode,n]},e.prototype.value=function(){var t;return(t={})[this.statics.blotName]=this.statics.value(this.domNode)||!0,t},e.scope=l.Scope.INLINE_BLOT,e}(i.default);e.default=a},function(t,e,n){var r=n(11),o=n(3),i={attributes:{compose:function(t,e,n){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var r=o(!0,{},e);for(var i in n||(r=Object.keys(r).reduce((function(t,e){return null!=r[e]&&(t[e]=r[e]),t}),{})),t)void 0!==t[i]&&void 0===e[i]&&(r[i]=t[i]);return Object.keys(r).length>0?r:void 0},diff:function(t,e){"object"!=typeof t&&(t={}),"object"!=typeof e&&(e={});var n=Object.keys(t).concat(Object.keys(e)).reduce((function(n,o){return r(t[o],e[o])||(n[o]=void 0===e[o]?null:e[o]),n}),{});return Object.keys(n).length>0?n:void 0},transform:function(t,e,n){if("object"!=typeof t)return e;if("object"==typeof e){if(!n)return e;var r=Object.keys(e).reduce((function(n,r){return void 0===t[r]&&(n[r]=e[r]),n}),{});return Object.keys(r).length>0?r:void 0}}},iterator:function(t){return new l(t)},length:function(t){return"number"==typeof t.delete?t.delete:"number"==typeof t.retain?t.retain:"string"==typeof t.insert?t.insert.length:1}};function l(t){this.ops=t,this.index=0,this.offset=0}l.prototype.hasNext=function(){return this.peekLength()<1/0},l.prototype.next=function(t){t||(t=1/0);var e=this.ops[this.index];if(e){var n=this.offset,r=i.length(e);if(t>=r-n?(t=r-n,this.index+=1,this.offset=0):this.offset+=t,"number"==typeof e.delete)return{delete:t};var o={};return e.attributes&&(o.attributes=e.attributes),"number"==typeof e.retain?o.retain=t:"string"==typeof e.insert?o.insert=e.insert.substr(n,t):o.insert=e.insert,o}return{retain:1/0}},l.prototype.peek=function(){return this.ops[this.index]},l.prototype.peekLength=function(){return this.ops[this.index]?i.length(this.ops[this.index])-this.offset:1/0},l.prototype.peekType=function(){return this.ops[this.index]?"number"==typeof this.ops[this.index].delete?"delete":"number"==typeof this.ops[this.index].retain?"retain":"insert":"retain"},l.prototype.rest=function(){if(this.hasNext()){if(0===this.offset)return this.ops.slice(this.index);var t=this.offset,e=this.index,n=this.next(),r=this.ops.slice(this.index);return this.offset=t,this.index=e,[n].concat(r)}return[]},t.exports=i},function(t,e){var n=function(){"use strict";function t(t,e){return null!=e&&t instanceof e}var e,n,r;try{e=Map}catch(t){e=function(){}}try{n=Set}catch(t){n=function(){}}try{r=Promise}catch(t){r=function(){}}function o(i,a,s,u,c){"object"==typeof a&&(s=a.depth,u=a.prototype,c=a.includeNonEnumerable,a=a.circular);var f=[],d=[],p="undefined"!=typeof Buffer;return void 0===a&&(a=!0),void 0===s&&(s=1/0),function i(s,h){if(null===s)return null;if(0===h)return s;var y,b;if("object"!=typeof s)return s;if(t(s,e))y=new e;else if(t(s,n))y=new n;else if(t(s,r))y=new r((function(t,e){s.then((function(e){t(i(e,h-1))}),(function(t){e(i(t,h-1))}))}));else if(o.__isArray(s))y=[];else if(o.__isRegExp(s))y=new RegExp(s.source,l(s)),s.lastIndex&&(y.lastIndex=s.lastIndex);else if(o.__isDate(s))y=new Date(s.getTime());else{if(p&&Buffer.isBuffer(s))return y=Buffer.allocUnsafe?Buffer.allocUnsafe(s.length):new Buffer(s.length),s.copy(y),y;t(s,Error)?y=Object.create(s):void 0===u?(b=Object.getPrototypeOf(s),y=Object.create(b)):(y=Object.create(u),b=u)}if(a){var v=f.indexOf(s);if(-1!=v)return d[v];f.push(s),d.push(y)}for(var g in t(s,e)&&s.forEach((function(t,e){var n=i(e,h-1),r=i(t,h-1);y.set(n,r)})),t(s,n)&&s.forEach((function(t){var e=i(t,h-1);y.add(e)})),s){var m;b&&(m=Object.getOwnPropertyDescriptor(b,g)),m&&null==m.set||(y[g]=i(s[g],h-1))}if(Object.getOwnPropertySymbols){var q=Object.getOwnPropertySymbols(s);for(g=0;g<q.length;g++){var w=q[g];(!(x=Object.getOwnPropertyDescriptor(s,w))||x.enumerable||c)&&(y[w]=i(s[w],h-1),x.enumerable||Object.defineProperty(y,w,{enumerable:!1}))}}if(c){var _=Object.getOwnPropertyNames(s);for(g=0;g<_.length;g++){var x,k=_[g];(x=Object.getOwnPropertyDescriptor(s,k))&&x.enumerable||(y[k]=i(s[k],h-1),Object.defineProperty(y,k,{enumerable:!1}))}}return y}(i,s)}function i(t){return Object.prototype.toString.call(t)}function l(t){var e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),e}return o.clonePrototype=function(t){if(null===t)return null;var e=function(){};return e.prototype=t,new e},o.__objToStr=i,o.__isDate=function(t){return"object"==typeof t&&"[object Date]"===i(t)},o.__isArray=function(t){return"object"==typeof t&&"[object Array]"===i(t)},o.__isRegExp=function(t){return"object"==typeof t&&"[object RegExp]"===i(t)},o.__getRegExpFlags=l,o}();"object"==typeof t&&t.exports&&(t.exports=n)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=p(n(0)),a=p(n(8)),s=n(4),u=p(s),c=p(n(16)),f=p(n(13)),d=p(n(25));function p(t){return t&&t.__esModule?t:{default:t}}function h(t){return t instanceof u.default||t instanceof s.BlockEmbed}var y=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.emitter=n.emitter,Array.isArray(n.whitelist)&&(r.whitelist=n.whitelist.reduce((function(t,e){return t[e]=!0,t}),{})),r.domNode.addEventListener("DOMNodeInserted",(function(){})),r.optimize(),r.enable(),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"batchStart",value:function(){this.batch=!0}},{key:"batchEnd",value:function(){this.batch=!1,this.optimize()}},{key:"deleteAt",value:function(t,n){var o=this.line(t),l=r(o,2),a=l[0],u=l[1],d=this.line(t+n),p=r(d,1)[0];if(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"deleteAt",this).call(this,t,n),null!=p&&a!==p&&u>0){if(a instanceof s.BlockEmbed||p instanceof s.BlockEmbed)return void this.optimize();if(a instanceof f.default){var h=a.newlineIndex(a.length(),!0);if(h>-1&&(a=a.split(h+1))===p)return void this.optimize()}else if(p instanceof f.default){var y=p.newlineIndex(0);y>-1&&p.split(y+1)}var b=p.children.head instanceof c.default?null:p.children.head;a.moveChildren(p,b),a.remove()}this.optimize()}},{key:"enable",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.domNode.setAttribute("contenteditable",t)}},{key:"formatAt",value:function(t,n,r,o){(null==this.whitelist||this.whitelist[r])&&(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"formatAt",this).call(this,t,n,r,o),this.optimize())}},{key:"insertAt",value:function(t,n,r){if(null==r||null==this.whitelist||this.whitelist[n]){if(t>=this.length())if(null==r||null==l.default.query(n,l.default.Scope.BLOCK)){var o=l.default.create(this.statics.defaultChild);this.appendChild(o),null==r&&n.endsWith("\n")&&(n=n.slice(0,-1)),o.insertAt(0,n,r)}else{var a=l.default.create(n,r);this.appendChild(a)}else i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertAt",this).call(this,t,n,r);this.optimize()}}},{key:"insertBefore",value:function(t,n){if(t.statics.scope===l.default.Scope.INLINE_BLOT){var r=l.default.create(this.statics.defaultChild);r.appendChild(t),t=r}i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n)}},{key:"leaf",value:function(t){return this.path(t).pop()||[null,-1]}},{key:"line",value:function(t){return t===this.length()?this.line(t-1):this.descendant(h,t)}},{key:"lines",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE,n=function t(e,n,r){var o=[],i=r;return e.children.forEachAt(n,r,(function(e,n,r){h(e)?o.push(e):e instanceof l.default.Container&&(o=o.concat(t(e,n,i))),i-=r})),o};return n(this,t,e)}},{key:"optimize",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!0!==this.batch&&(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t,n),t.length>0&&this.emitter.emit(a.default.events.SCROLL_OPTIMIZE,t,n))}},{key:"path",value:function(t){return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"path",this).call(this,t).slice(1)}},{key:"update",value:function(t){if(!0!==this.batch){var n=a.default.sources.USER;"string"==typeof t&&(n=t),Array.isArray(t)||(t=this.observer.takeRecords()),t.length>0&&this.emitter.emit(a.default.events.SCROLL_BEFORE_UPDATE,n,t),i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"update",this).call(this,t.concat([])),t.length>0&&this.emitter.emit(a.default.events.SCROLL_UPDATE,n,t)}}}]),e}(l.default.Scroll);y.blotName="scroll",y.className="ql-editor",y.tagName="DIV",y.defaultChild="block",y.allowedChildren=[u.default,s.BlockEmbed,d.default],e.default=y},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SHORTKEY=e.default=void 0;var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=y(n(21)),a=y(n(11)),s=y(n(3)),u=y(n(2)),c=y(n(20)),f=y(n(0)),d=y(n(5)),p=y(n(10)),h=y(n(9));function y(t){return t&&t.__esModule?t:{default:t}}function b(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var v=(0,p.default)("quill:keyboard"),g=/Mac/i.test(navigator.platform)?"metaKey":"ctrlKey",m=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.bindings={},Object.keys(r.options.bindings).forEach((function(e){("list autofill"!==e||null==t.scroll.whitelist||t.scroll.whitelist.list)&&r.options.bindings[e]&&r.addBinding(r.options.bindings[e])})),r.addBinding({key:e.keys.ENTER,shiftKey:null},k),r.addBinding({key:e.keys.ENTER,metaKey:null,ctrlKey:null,altKey:null},(function(){})),/Firefox/i.test(navigator.userAgent)?(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0},w),r.addBinding({key:e.keys.DELETE},{collapsed:!0},_)):(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0,prefix:/^.?$/},w),r.addBinding({key:e.keys.DELETE},{collapsed:!0,suffix:/^.?$/},_)),r.addBinding({key:e.keys.BACKSPACE},{collapsed:!1},x),r.addBinding({key:e.keys.DELETE},{collapsed:!1},x),r.addBinding({key:e.keys.BACKSPACE,altKey:null,ctrlKey:null,metaKey:null,shiftKey:null},{collapsed:!0,offset:0},w),r.listen(),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),i(e,null,[{key:"match",value:function(t,e){return e=A(e),!["altKey","ctrlKey","metaKey","shiftKey"].some((function(n){return!!e[n]!==t[n]&&null!==e[n]}))&&e.key===(t.which||t.keyCode)}}]),i(e,[{key:"addBinding",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=A(t);if(null==r||null==r.key)return v.warn("Attempted to add invalid keyboard binding",r);"function"==typeof e&&(e={handler:e}),"function"==typeof n&&(n={handler:n}),r=(0,s.default)(r,e,n),this.bindings[r.key]=this.bindings[r.key]||[],this.bindings[r.key].push(r)}},{key:"listen",value:function(){var t=this;this.quill.root.addEventListener("keydown",(function(n){if(!n.defaultPrevented){var i=n.which||n.keyCode,l=(t.bindings[i]||[]).filter((function(t){return e.match(n,t)}));if(0!==l.length){var s=t.quill.getSelection();if(null!=s&&t.quill.hasFocus()){var u=t.quill.getLine(s.index),c=o(u,2),d=c[0],p=c[1],h=t.quill.getLeaf(s.index),y=o(h,2),b=y[0],v=y[1],g=0===s.length?[b,v]:t.quill.getLeaf(s.index+s.length),m=o(g,2),q=m[0],w=m[1],_=b instanceof f.default.Text?b.value().slice(0,v):"",x=q instanceof f.default.Text?q.value().slice(w):"",k={collapsed:0===s.length,empty:0===s.length&&d.length()<=1,format:t.quill.getFormat(s),offset:p,prefix:_,suffix:x};l.some((function(e){if(null!=e.collapsed&&e.collapsed!==k.collapsed)return!1;if(null!=e.empty&&e.empty!==k.empty)return!1;if(null!=e.offset&&e.offset!==k.offset)return!1;if(Array.isArray(e.format)){if(e.format.every((function(t){return null==k.format[t]})))return!1}else if("object"===r(e.format)&&!Object.keys(e.format).every((function(t){return!0===e.format[t]?null!=k.format[t]:!1===e.format[t]?null==k.format[t]:(0,a.default)(e.format[t],k.format[t])})))return!1;return!(null!=e.prefix&&!e.prefix.test(k.prefix)||null!=e.suffix&&!e.suffix.test(k.suffix)||!0===e.handler.call(t,s,k))}))&&n.preventDefault()}}}}))}}]),e}(h.default);function q(t,e){var n,r=t===m.keys.LEFT?"prefix":"suffix";return b(n={key:t,shiftKey:e,altKey:null},r,/^$/),b(n,"handler",(function(n){var r=n.index;t===m.keys.RIGHT&&(r+=n.length+1);var i=this.quill.getLeaf(r);return!(o(i,1)[0]instanceof f.default.Embed&&(t===m.keys.LEFT?e?this.quill.setSelection(n.index-1,n.length+1,d.default.sources.USER):this.quill.setSelection(n.index-1,d.default.sources.USER):e?this.quill.setSelection(n.index,n.length+1,d.default.sources.USER):this.quill.setSelection(n.index+n.length+1,d.default.sources.USER),1))})),n}function w(t,e){if(!(0===t.index||this.quill.getLength()<=1)){var n=this.quill.getLine(t.index),r=o(n,1)[0],i={};if(0===e.offset){var l=this.quill.getLine(t.index-1),a=o(l,1)[0];if(null!=a&&a.length()>1){var s=r.formats(),u=this.quill.getFormat(t.index-1,1);i=c.default.attributes.diff(s,u)||{}}}var f=/[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(e.prefix)?2:1;this.quill.deleteText(t.index-f,f,d.default.sources.USER),Object.keys(i).length>0&&this.quill.formatLine(t.index-f,f,i,d.default.sources.USER),this.quill.focus()}}function _(t,e){var n=/^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(e.suffix)?2:1;if(!(t.index>=this.quill.getLength()-n)){var r={},i=0,l=this.quill.getLine(t.index),a=o(l,1)[0];if(e.offset>=a.length()-1){var s=this.quill.getLine(t.index+1),u=o(s,1)[0];if(u){var f=a.formats(),p=this.quill.getFormat(t.index,1);r=c.default.attributes.diff(f,p)||{},i=u.length()}}this.quill.deleteText(t.index,n,d.default.sources.USER),Object.keys(r).length>0&&this.quill.formatLine(t.index+i-1,n,r,d.default.sources.USER)}}function x(t){var e=this.quill.getLines(t),n={};if(e.length>1){var r=e[0].formats(),o=e[e.length-1].formats();n=c.default.attributes.diff(o,r)||{}}this.quill.deleteText(t,d.default.sources.USER),Object.keys(n).length>0&&this.quill.formatLine(t.index,1,n,d.default.sources.USER),this.quill.setSelection(t.index,d.default.sources.SILENT),this.quill.focus()}function k(t,e){var n=this;t.length>0&&this.quill.scroll.deleteAt(t.index,t.length);var r=Object.keys(e.format).reduce((function(t,n){return f.default.query(n,f.default.Scope.BLOCK)&&!Array.isArray(e.format[n])&&(t[n]=e.format[n]),t}),{});this.quill.insertText(t.index,"\n",r,d.default.sources.USER),this.quill.setSelection(t.index+1,d.default.sources.SILENT),this.quill.focus(),Object.keys(e.format).forEach((function(t){null==r[t]&&(Array.isArray(e.format[t])||"link"!==t&&n.quill.format(t,e.format[t],d.default.sources.USER))}))}function E(t){return{key:m.keys.TAB,shiftKey:!t,format:{"code-block":!0},handler:function(e){var n=f.default.query("code-block"),r=e.index,i=e.length,l=this.quill.scroll.descendant(n,r),a=o(l,2),s=a[0],u=a[1];if(null!=s){var c=this.quill.getIndex(s),p=s.newlineIndex(u,!0)+1,h=s.newlineIndex(c+u+i),y=s.domNode.textContent.slice(p,h).split("\n");u=0,y.forEach((function(e,o){t?(s.insertAt(p+u,n.TAB),u+=n.TAB.length,0===o?r+=n.TAB.length:i+=n.TAB.length):e.startsWith(n.TAB)&&(s.deleteAt(p+u,n.TAB.length),u-=n.TAB.length,0===o?r-=n.TAB.length:i-=n.TAB.length),u+=e.length+1})),this.quill.update(d.default.sources.USER),this.quill.setSelection(r,i,d.default.sources.SILENT)}}}}function O(t){return{key:t[0].toUpperCase(),shortKey:!0,handler:function(e,n){this.quill.format(t,!n.format[t],d.default.sources.USER)}}}function A(t){if("string"==typeof t||"number"==typeof t)return A({key:t});if("object"===(void 0===t?"undefined":r(t))&&(t=(0,l.default)(t,!1)),"string"==typeof t.key)if(null!=m.keys[t.key.toUpperCase()])t.key=m.keys[t.key.toUpperCase()];else{if(1!==t.key.length)return null;t.key=t.key.toUpperCase().charCodeAt(0)}return t.shortKey&&(t[g]=t.shortKey,delete t.shortKey),t}m.keys={BACKSPACE:8,TAB:9,ENTER:13,ESCAPE:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46},m.DEFAULTS={bindings:{bold:O("bold"),italic:O("italic"),underline:O("underline"),indent:{key:m.keys.TAB,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","+1",d.default.sources.USER)}},outdent:{key:m.keys.TAB,shiftKey:!0,format:["blockquote","indent","list"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format("indent","-1",d.default.sources.USER)}},"outdent backspace":{key:m.keys.BACKSPACE,collapsed:!0,shiftKey:null,metaKey:null,ctrlKey:null,altKey:null,format:["indent","list"],offset:0,handler:function(t,e){null!=e.format.indent?this.quill.format("indent","-1",d.default.sources.USER):null!=e.format.list&&this.quill.format("list",!1,d.default.sources.USER)}},"indent code-block":E(!0),"outdent code-block":E(!1),"remove tab":{key:m.keys.TAB,shiftKey:!0,collapsed:!0,prefix:/\t$/,handler:function(t){this.quill.deleteText(t.index-1,1,d.default.sources.USER)}},tab:{key:m.keys.TAB,handler:function(t){this.quill.history.cutoff();var e=(new u.default).retain(t.index).delete(t.length).insert("\t");this.quill.updateContents(e,d.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index+1,d.default.sources.SILENT)}},"list empty enter":{key:m.keys.ENTER,collapsed:!0,format:["list"],empty:!0,handler:function(t,e){this.quill.format("list",!1,d.default.sources.USER),e.format.indent&&this.quill.format("indent",!1,d.default.sources.USER)}},"checklist enter":{key:m.keys.ENTER,collapsed:!0,format:{list:"checked"},handler:function(t){var e=this.quill.getLine(t.index),n=o(e,2),r=n[0],i=n[1],l=(0,s.default)({},r.formats(),{list:"checked"}),a=(new u.default).retain(t.index).insert("\n",l).retain(r.length()-i-1).retain(1,{list:"unchecked"});this.quill.updateContents(a,d.default.sources.USER),this.quill.setSelection(t.index+1,d.default.sources.SILENT),this.quill.scrollIntoView()}},"header enter":{key:m.keys.ENTER,collapsed:!0,format:["header"],suffix:/^$/,handler:function(t,e){var n=this.quill.getLine(t.index),r=o(n,2),i=r[0],l=r[1],a=(new u.default).retain(t.index).insert("\n",e.format).retain(i.length()-l-1).retain(1,{header:null});this.quill.updateContents(a,d.default.sources.USER),this.quill.setSelection(t.index+1,d.default.sources.SILENT),this.quill.scrollIntoView()}},"list autofill":{key:" ",collapsed:!0,format:{list:!1},prefix:/^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,handler:function(t,e){var n=e.prefix.length,r=this.quill.getLine(t.index),i=o(r,2),l=i[0],a=i[1];if(a>n)return!0;var s=void 0;switch(e.prefix.trim()){case"[]":case"[ ]":s="unchecked";break;case"[x]":s="checked";break;case"-":case"*":s="bullet";break;default:s="ordered"}this.quill.insertText(t.index," ",d.default.sources.USER),this.quill.history.cutoff();var c=(new u.default).retain(t.index-a).delete(n+1).retain(l.length()-2-a).retain(1,{list:s});this.quill.updateContents(c,d.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index-n,d.default.sources.SILENT)}},"code exit":{key:m.keys.ENTER,collapsed:!0,format:["code-block"],prefix:/\n\n$/,suffix:/^\s+$/,handler:function(t){var e=this.quill.getLine(t.index),n=o(e,2),r=n[0],i=n[1],l=(new u.default).retain(t.index+r.length()-i-2).retain(1,{"code-block":null}).delete(1);this.quill.updateContents(l,d.default.sources.USER)}},"embed left":q(m.keys.LEFT,!1),"embed left shift":q(m.keys.LEFT,!0),"embed right":q(m.keys.RIGHT,!1),"embed right shift":q(m.keys.RIGHT,!0)}},e.default=m,e.SHORTKEY=g},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=a(n(0)),l=a(n(7));function a(t){return t&&t.__esModule?t:{default:t}}var s=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.selection=n,r.textNode=document.createTextNode(e.CONTENTS),r.domNode.appendChild(r.textNode),r._length=0,r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,null,[{key:"value",value:function(){}}]),o(e,[{key:"detach",value:function(){null!=this.parent&&this.parent.removeChild(this)}},{key:"format",value:function(t,n){if(0!==this._length)return r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);for(var o=this,l=0;null!=o&&o.statics.scope!==i.default.Scope.BLOCK_BLOT;)l+=o.offset(o.parent),o=o.parent;null!=o&&(this._length=e.CONTENTS.length,o.optimize(),o.formatAt(l,e.CONTENTS.length,t,n),this._length=0)}},{key:"index",value:function(t,n){return t===this.textNode?0:r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"length",value:function(){return this._length}},{key:"position",value:function(){return[this.textNode,this.textNode.data.length]}},{key:"remove",value:function(){r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this),this.parent=null}},{key:"restore",value:function(){if(!this.selection.composing&&null!=this.parent){var t=this.textNode,n=this.selection.getNativeRange(),r=void 0,o=void 0,a=void 0;if(null!=n&&n.start.node===t&&n.end.node===t){var s=[t,n.start.offset,n.end.offset];r=s[0],o=s[1],a=s[2]}for(;null!=this.domNode.lastChild&&this.domNode.lastChild!==this.textNode;)this.domNode.parentNode.insertBefore(this.domNode.lastChild,this.domNode);if(this.textNode.data!==e.CONTENTS){var u=this.textNode.data.split(e.CONTENTS).join("");this.next instanceof l.default?(r=this.next.domNode,this.next.insertAt(0,u),this.textNode.data=e.CONTENTS):(this.textNode.data=u,this.parent.insertBefore(i.default.create(this.textNode),this),this.textNode=document.createTextNode(e.CONTENTS),this.domNode.appendChild(this.textNode))}if(this.remove(),null!=o){var c=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}([o,a].map((function(t){return Math.max(0,Math.min(r.data.length,t-1))})),2);return o=c[0],a=c[1],{startNode:r,startOffset:o,endNode:r,endOffset:a}}}}},{key:"update",value:function(t,e){var n=this;if(t.some((function(t){return"characterData"===t.type&&t.target===n.textNode}))){var r=this.restore();r&&(e.range=r)}}},{key:"value",value:function(){return""}}]),e}(i.default.Embed);s.blotName="cursor",s.className="ql-cursor",s.tagName="span",s.CONTENTS="\ufeff",e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=l(n(0)),o=n(4),i=l(o);function l(t){return t&&t.__esModule?t:{default:t}}function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(r.default.Container);u.allowedChildren=[i.default,o.BlockEmbed,u],e.default=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.ColorStyle=e.ColorClass=e.ColorAttributor=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=(r=n(0))&&r.__esModule?r:{default:r};function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"value",value:function(t){var n=i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t);return n.startsWith("rgb(")?"#"+(n=n.replace(/^[^\d]+/,"").replace(/[^\d]+$/,"")).split(",").map((function(t){return("00"+parseInt(t).toString(16)).slice(-2)})).join(""):n}}]),e}(l.default.Attributor.Style),c=new l.default.Attributor.Class("color","ql-color",{scope:l.default.Scope.INLINE}),f=new u("color","color",{scope:l.default.Scope.INLINE});e.ColorAttributor=u,e.ColorClass=c,e.ColorStyle=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.sanitize=e.default=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0};function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"format",value:function(t,n){if(t!==this.statics.blotName||!n)return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n);n=this.constructor.sanitize(n),this.domNode.setAttribute("href",n)}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return t=this.sanitize(t),n.setAttribute("href",t),n.setAttribute("rel","noopener noreferrer"),n.setAttribute("target","_blank"),n}},{key:"formats",value:function(t){return t.getAttribute("href")}},{key:"sanitize",value:function(t){return u(t,this.PROTOCOL_WHITELIST)?t:this.SANITIZED_URL}}]),e}(((r=n(6))&&r.__esModule?r:{default:r}).default);function u(t,e){var n=document.createElement("a");n.href=t;var r=n.href.slice(0,n.href.indexOf(":"));return e.indexOf(r)>-1}s.blotName="link",s.tagName="A",s.SANITIZED_URL="about:blank",s.PROTOCOL_WHITELIST=["http","https","mailto","tel"],e.default=s,e.sanitize=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=a(n(23)),l=a(n(107));function a(t){return t&&t.__esModule?t:{default:t}}var s=0;function u(t,e){t.setAttribute(e,!("true"===t.getAttribute(e)))}var c=function(){function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.select=e,this.container=document.createElement("span"),this.buildPicker(),this.select.style.display="none",this.select.parentNode.insertBefore(this.container,this.select),this.label.addEventListener("mousedown",(function(){n.togglePicker()})),this.label.addEventListener("keydown",(function(t){switch(t.keyCode){case i.default.keys.ENTER:n.togglePicker();break;case i.default.keys.ESCAPE:n.escape(),t.preventDefault()}})),this.select.addEventListener("change",this.update.bind(this))}return o(t,[{key:"togglePicker",value:function(){this.container.classList.toggle("ql-expanded"),u(this.label,"aria-expanded"),u(this.options,"aria-hidden")}},{key:"buildItem",value:function(t){var e=this,n=document.createElement("span");return n.tabIndex="0",n.setAttribute("role","button"),n.classList.add("ql-picker-item"),t.hasAttribute("value")&&n.setAttribute("data-value",t.getAttribute("value")),t.textContent&&n.setAttribute("data-label",t.textContent),n.addEventListener("click",(function(){e.selectItem(n,!0)})),n.addEventListener("keydown",(function(t){switch(t.keyCode){case i.default.keys.ENTER:e.selectItem(n,!0),t.preventDefault();break;case i.default.keys.ESCAPE:e.escape(),t.preventDefault()}})),n}},{key:"buildLabel",value:function(){var t=document.createElement("span");return t.classList.add("ql-picker-label"),t.innerHTML=l.default,t.tabIndex="0",t.setAttribute("role","button"),t.setAttribute("aria-expanded","false"),this.container.appendChild(t),t}},{key:"buildOptions",value:function(){var t=this,e=document.createElement("span");e.classList.add("ql-picker-options"),e.setAttribute("aria-hidden","true"),e.tabIndex="-1",e.id="ql-picker-options-"+s,s+=1,this.label.setAttribute("aria-controls",e.id),this.options=e,[].slice.call(this.select.options).forEach((function(n){var r=t.buildItem(n);e.appendChild(r),!0===n.selected&&t.selectItem(r)})),this.container.appendChild(e)}},{key:"buildPicker",value:function(){var t=this;[].slice.call(this.select.attributes).forEach((function(e){t.container.setAttribute(e.name,e.value)})),this.container.classList.add("ql-picker"),this.label=this.buildLabel(),this.buildOptions()}},{key:"escape",value:function(){var t=this;this.close(),setTimeout((function(){return t.label.focus()}),1)}},{key:"close",value:function(){this.container.classList.remove("ql-expanded"),this.label.setAttribute("aria-expanded","false"),this.options.setAttribute("aria-hidden","true")}},{key:"selectItem",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.container.querySelector(".ql-selected");if(t!==n&&(null!=n&&n.classList.remove("ql-selected"),null!=t&&(t.classList.add("ql-selected"),this.select.selectedIndex=[].indexOf.call(t.parentNode.children,t),t.hasAttribute("data-value")?this.label.setAttribute("data-value",t.getAttribute("data-value")):this.label.removeAttribute("data-value"),t.hasAttribute("data-label")?this.label.setAttribute("data-label",t.getAttribute("data-label")):this.label.removeAttribute("data-label"),e))){if("function"==typeof Event)this.select.dispatchEvent(new Event("change"));else if("object"===("undefined"==typeof Event?"undefined":r(Event))){var o=document.createEvent("Event");o.initEvent("change",!0,!0),this.select.dispatchEvent(o)}this.close()}}},{key:"update",value:function(){var t=void 0;if(this.select.selectedIndex>-1){var e=this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];t=this.select.options[this.select.selectedIndex],this.selectItem(e)}else this.selectItem(null);var n=null!=t&&t!==this.select.querySelector("option[selected]");this.label.classList.toggle("ql-active",n)}}]),t}();e.default=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=v(n(0)),o=v(n(5)),i=n(4),l=v(i),a=v(n(16)),s=v(n(25)),u=v(n(24)),c=v(n(35)),f=v(n(6)),d=v(n(22)),p=v(n(7)),h=v(n(55)),y=v(n(42)),b=v(n(23));function v(t){return t&&t.__esModule?t:{default:t}}o.default.register({"blots/block":l.default,"blots/block/embed":i.BlockEmbed,"blots/break":a.default,"blots/container":s.default,"blots/cursor":u.default,"blots/embed":c.default,"blots/inline":f.default,"blots/scroll":d.default,"blots/text":p.default,"modules/clipboard":h.default,"modules/history":y.default,"modules/keyboard":b.default}),r.default.register(l.default,a.default,u.default,f.default,d.default,p.default),e.default=o.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(1),o=function(){function t(t){this.domNode=t,this.domNode[r.DATA_KEY]={blot:this}}return Object.defineProperty(t.prototype,"statics",{get:function(){return this.constructor},enumerable:!0,configurable:!0}),t.create=function(t){if(null==this.tagName)throw new r.ParchmentError("Blot definition missing tagName");var e;return Array.isArray(this.tagName)?("string"==typeof t&&(t=t.toUpperCase(),parseInt(t).toString()===t&&(t=parseInt(t))),e="number"==typeof t?document.createElement(this.tagName[t-1]):this.tagName.indexOf(t)>-1?document.createElement(t):document.createElement(this.tagName[0])):e=document.createElement(this.tagName),this.className&&e.classList.add(this.className),e},t.prototype.attach=function(){null!=this.parent&&(this.scroll=this.parent.scroll)},t.prototype.clone=function(){var t=this.domNode.cloneNode(!1);return r.create(t)},t.prototype.detach=function(){null!=this.parent&&this.parent.removeChild(this),delete this.domNode[r.DATA_KEY]},t.prototype.deleteAt=function(t,e){this.isolate(t,e).remove()},t.prototype.formatAt=function(t,e,n,o){var i=this.isolate(t,e);if(null!=r.query(n,r.Scope.BLOT)&&o)i.wrap(n,o);else if(null!=r.query(n,r.Scope.ATTRIBUTE)){var l=r.create(this.statics.scope);i.wrap(l),l.format(n,o)}},t.prototype.insertAt=function(t,e,n){var o=null==n?r.create("text",e):r.create(e,n),i=this.split(t);this.parent.insertBefore(o,i)},t.prototype.insertInto=function(t,e){void 0===e&&(e=null),null!=this.parent&&this.parent.children.remove(this);var n=null;t.children.insertBefore(this,e),null!=e&&(n=e.domNode),this.domNode.parentNode==t.domNode&&this.domNode.nextSibling==n||t.domNode.insertBefore(this.domNode,n),this.parent=t,this.attach()},t.prototype.isolate=function(t,e){var n=this.split(t);return n.split(e),n},t.prototype.length=function(){return 1},t.prototype.offset=function(t){return void 0===t&&(t=this.parent),null==this.parent||this==t?0:this.parent.children.offset(this)+this.parent.offset(t)},t.prototype.optimize=function(t){null!=this.domNode[r.DATA_KEY]&&delete this.domNode[r.DATA_KEY].mutations},t.prototype.remove=function(){null!=this.domNode.parentNode&&this.domNode.parentNode.removeChild(this.domNode),this.detach()},t.prototype.replace=function(t){null!=t.parent&&(t.parent.insertBefore(this,t.next),t.remove())},t.prototype.replaceWith=function(t,e){var n="string"==typeof t?r.create(t,e):t;return n.replace(this),n},t.prototype.split=function(t,e){return 0===t?this:this.next},t.prototype.update=function(t,e){},t.prototype.wrap=function(t,e){var n="string"==typeof t?r.create(t,e):t;return null!=this.parent&&this.parent.insertBefore(n,this.next),n.appendChild(this),n},t.blotName="abstract",t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(12),o=n(32),i=n(33),l=n(1),a=function(){function t(t){this.attributes={},this.domNode=t,this.build()}return t.prototype.attribute=function(t,e){e?t.add(this.domNode,e)&&(null!=t.value(this.domNode)?this.attributes[t.attrName]=t:delete this.attributes[t.attrName]):(t.remove(this.domNode),delete this.attributes[t.attrName])},t.prototype.build=function(){var t=this;this.attributes={};var e=r.default.keys(this.domNode),n=o.default.keys(this.domNode),a=i.default.keys(this.domNode);e.concat(n).concat(a).forEach((function(e){var n=l.query(e,l.Scope.ATTRIBUTE);n instanceof r.default&&(t.attributes[n.attrName]=n)}))},t.prototype.copy=function(t){var e=this;Object.keys(this.attributes).forEach((function(n){var r=e.attributes[n].value(e.domNode);t.format(n,r)}))},t.prototype.move=function(t){var e=this;this.copy(t),Object.keys(this.attributes).forEach((function(t){e.attributes[t].remove(e.domNode)})),this.attributes={}},t.prototype.values=function(){var t=this;return Object.keys(this.attributes).reduce((function(e,n){return e[n]=t.attributes[n].value(t.domNode),e}),{})},t}();e.default=a},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});function i(t,e){return(t.getAttribute("class")||"").split(/\s+/).filter((function(t){return 0===t.indexOf(e+"-")}))}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("class")||"").split(/\s+/).map((function(t){return t.split("-").slice(0,-1).join("-")}))},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(this.remove(t),t.classList.add(this.keyName+"-"+e),!0)},e.prototype.remove=function(t){i(t,this.keyName).forEach((function(e){t.classList.remove(e)})),0===t.classList.length&&t.removeAttribute("class")},e.prototype.value=function(t){var e=(i(t,this.keyName)[0]||"").slice(this.keyName.length+1);return this.canAdd(t,e)?e:""},e}(n(12).default);e.default=l},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});function i(t){var e=t.split("-"),n=e.slice(1).map((function(t){return t[0].toUpperCase()+t.slice(1)})).join("");return e[0]+n}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute("style")||"").split(";").map((function(t){return t.split(":")[0].trim()}))},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.style[i(this.keyName)]=e,!0)},e.prototype.remove=function(t){t.style[i(this.keyName)]="",t.getAttribute("style")||t.removeAttribute("style")},e.prototype.value=function(t){var e=t.style[i(this.keyName)];return this.canAdd(t,e)?e:""},e}(n(12).default);e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.quill=e,this.options=n,this.modules={}}return r(t,[{key:"init",value:function(){var t=this;Object.keys(this.options.modules).forEach((function(e){null==t.modules[e]&&t.addModule(e)}))}},{key:"addModule",value:function(t){var e=this.quill.constructor.import("modules/"+t);return this.modules[t]=new e(this.quill,this.options.modules[t]||{}),this.modules[t]}}]),t}();o.DEFAULTS={modules:{}},o.themes={default:o},e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=a(n(0)),l=a(n(7));function a(t){return t&&t.__esModule?t:{default:t}}var s="\ufeff",u=function(t){function e(t){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var n=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.contentNode=document.createElement("span"),n.contentNode.setAttribute("contenteditable",!1),[].slice.call(n.domNode.childNodes).forEach((function(t){n.contentNode.appendChild(t)})),n.leftGuard=document.createTextNode(s),n.rightGuard=document.createTextNode(s),n.domNode.appendChild(n.leftGuard),n.domNode.appendChild(n.contentNode),n.domNode.appendChild(n.rightGuard),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"index",value:function(t,n){return t===this.leftGuard?0:t===this.rightGuard?1:o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"index",this).call(this,t,n)}},{key:"restore",value:function(t){var e=void 0,n=void 0,r=t.data.split(s).join("");if(t===this.leftGuard)if(this.prev instanceof l.default){var o=this.prev.length();this.prev.insertAt(o,r),e={startNode:this.prev.domNode,startOffset:o+r.length}}else n=document.createTextNode(r),this.parent.insertBefore(i.default.create(n),this),e={startNode:n,startOffset:r.length};else t===this.rightGuard&&(this.next instanceof l.default?(this.next.insertAt(0,r),e={startNode:this.next.domNode,startOffset:r.length}):(n=document.createTextNode(r),this.parent.insertBefore(i.default.create(n),this.next),e={startNode:n,startOffset:r.length}));return t.data=s,e}},{key:"update",value:function(t,e){var n=this;t.forEach((function(t){if("characterData"===t.type&&(t.target===n.leftGuard||t.target===n.rightGuard)){var r=n.restore(t.target);r&&(e.range=r)}}))}}]),e}(i.default.Embed);e.default=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AlignStyle=e.AlignClass=e.AlignAttribute=void 0;var r,o=(r=n(0))&&r.__esModule?r:{default:r},i={scope:o.default.Scope.BLOCK,whitelist:["right","center","justify"]},l=new o.default.Attributor.Attribute("align","align",i),a=new o.default.Attributor.Class("align","ql-align",i),s=new o.default.Attributor.Style("align","text-align",i);e.AlignAttribute=l,e.AlignClass=a,e.AlignStyle=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.BackgroundStyle=e.BackgroundClass=void 0;var r,o=(r=n(0))&&r.__esModule?r:{default:r},i=n(26),l=new o.default.Attributor.Class("background","ql-bg",{scope:o.default.Scope.INLINE}),a=new i.ColorAttributor("background","background-color",{scope:o.default.Scope.INLINE});e.BackgroundClass=l,e.BackgroundStyle=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DirectionStyle=e.DirectionClass=e.DirectionAttribute=void 0;var r,o=(r=n(0))&&r.__esModule?r:{default:r},i={scope:o.default.Scope.BLOCK,whitelist:["rtl"]},l=new o.default.Attributor.Attribute("direction","dir",i),a=new o.default.Attributor.Class("direction","ql-direction",i),s=new o.default.Attributor.Style("direction","direction",i);e.DirectionAttribute=l,e.DirectionClass=a,e.DirectionStyle=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.FontClass=e.FontStyle=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=(r=n(0))&&r.__esModule?r:{default:r};function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u={scope:l.default.Scope.INLINE,whitelist:["serif","monospace"]},c=new l.default.Attributor.Class("font","ql-font",u),f=new(function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"value",value:function(t){return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t).replace(/["']/g,"")}}]),e}(l.default.Attributor.Style))("font","font-family",u);e.FontStyle=f,e.FontClass=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SizeStyle=e.SizeClass=void 0;var r,o=(r=n(0))&&r.__esModule?r:{default:r},i=new o.default.Attributor.Class("size","ql-size",{scope:o.default.Scope.INLINE,whitelist:["small","large","huge"]}),l=new o.default.Attributor.Style("size","font-size",{scope:o.default.Scope.INLINE,whitelist:["10px","18px","32px"]});e.SizeClass=i,e.SizeStyle=l},function(t,e,n){"use strict";t.exports={align:{"":n(76),center:n(77),right:n(78),justify:n(79)},background:n(80),blockquote:n(81),bold:n(82),clean:n(83),code:n(58),"code-block":n(58),color:n(84),direction:{"":n(85),rtl:n(86)},float:{center:n(87),full:n(88),left:n(89),right:n(90)},formula:n(91),header:{1:n(92),2:n(93)},italic:n(94),image:n(95),indent:{"+1":n(96),"-1":n(97)},link:n(98),list:{ordered:n(99),bullet:n(100),check:n(101)},script:{sub:n(102),super:n(103)},strike:n(104),underline:n(105),video:n(106)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getLastChangeIndex=e.default=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=l(n(0)),i=l(n(5));function l(t){return t&&t.__esModule?t:{default:t}}var a=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.lastRecorded=0,r.ignoreChange=!1,r.clear(),r.quill.on(i.default.events.EDITOR_CHANGE,(function(t,e,n,o){t!==i.default.events.TEXT_CHANGE||r.ignoreChange||(r.options.userOnly&&o!==i.default.sources.USER?r.transform(e):r.record(e,n))})),r.quill.keyboard.addBinding({key:"Z",shortKey:!0},r.undo.bind(r)),r.quill.keyboard.addBinding({key:"Z",shortKey:!0,shiftKey:!0},r.redo.bind(r)),/Win/i.test(navigator.platform)&&r.quill.keyboard.addBinding({key:"Y",shortKey:!0},r.redo.bind(r)),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),r(e,[{key:"change",value:function(t,e){if(0!==this.stack[t].length){var n=this.stack[t].pop();this.stack[e].push(n),this.lastRecorded=0,this.ignoreChange=!0,this.quill.updateContents(n[t],i.default.sources.USER),this.ignoreChange=!1;var r=s(n[t]);this.quill.setSelection(r)}}},{key:"clear",value:function(){this.stack={undo:[],redo:[]}}},{key:"cutoff",value:function(){this.lastRecorded=0}},{key:"record",value:function(t,e){if(0!==t.ops.length){this.stack.redo=[];var n=this.quill.getContents().diff(e),r=Date.now();if(this.lastRecorded+this.options.delay>r&&this.stack.undo.length>0){var o=this.stack.undo.pop();n=n.compose(o.undo),t=o.redo.compose(t)}else this.lastRecorded=r;this.stack.undo.push({redo:t,undo:n}),this.stack.undo.length>this.options.maxStack&&this.stack.undo.shift()}}},{key:"redo",value:function(){this.change("redo","undo")}},{key:"transform",value:function(t){this.stack.undo.forEach((function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)})),this.stack.redo.forEach((function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)}))}},{key:"undo",value:function(){this.change("undo","redo")}}]),e}(l(n(9)).default);function s(t){var e=t.reduce((function(t,e){return t+(e.delete||0)}),0),n=t.length()-e;return function(t){var e=t.ops[t.ops.length-1];return null!=e&&(null!=e.insert?"string"==typeof e.insert&&e.insert.endsWith("\n"):null!=e.attributes&&Object.keys(e.attributes).some((function(t){return null!=o.default.query(t,o.default.Scope.BLOCK)})))}(t)&&(n-=1),n}a.DEFAULTS={delay:1e3,maxStack:100,userOnly:!1},e.default=a,e.getLastChangeIndex=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BaseTooltip=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=h(n(3)),l=h(n(2)),a=h(n(8)),s=h(n(23)),u=h(n(34)),c=h(n(59)),f=h(n(60)),d=h(n(28)),p=h(n(61));function h(t){return t&&t.__esModule?t:{default:t}}function y(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function b(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function v(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var g=[!1,"center","right","justify"],m=["#000000","#e60000","#ff9900","#ffff00","#008a00","#0066cc","#9933ff","#ffffff","#facccc","#ffebcc","#ffffcc","#cce8cc","#cce0f5","#ebd6ff","#bbbbbb","#f06666","#ffc266","#ffff66","#66b966","#66a3e0","#c285ff","#888888","#a10000","#b26b00","#b2b200","#006100","#0047b2","#6b24b2","#444444","#5c0000","#663d00","#666600","#003700","#002966","#3d1466"],q=[!1,"serif","monospace"],w=["1","2","3",!1],_=["small",!1,"large","huge"],x=function(t){function e(t,n){y(this,e);var r=b(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return t.emitter.listenDOM("click",document.body,(function e(n){if(!document.body.contains(t.root))return document.body.removeEventListener("click",e);null==r.tooltip||r.tooltip.root.contains(n.target)||document.activeElement===r.tooltip.textbox||r.quill.hasFocus()||r.tooltip.hide(),null!=r.pickers&&r.pickers.forEach((function(t){t.container.contains(n.target)||t.close()}))})),r}return v(e,t),r(e,[{key:"addModule",value:function(t){var n=o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"addModule",this).call(this,t);return"toolbar"===t&&this.extendToolbar(n),n}},{key:"buildButtons",value:function(t,e){t.forEach((function(t){(t.getAttribute("class")||"").split(/\s+/).forEach((function(n){if(n.startsWith("ql-")&&(n=n.slice("ql-".length),null!=e[n]))if("direction"===n)t.innerHTML=e[n][""]+e[n].rtl;else if("string"==typeof e[n])t.innerHTML=e[n];else{var r=t.value||"";null!=r&&e[n][r]&&(t.innerHTML=e[n][r])}}))}))}},{key:"buildPickers",value:function(t,e){var n=this;this.pickers=t.map((function(t){if(t.classList.contains("ql-align"))return null==t.querySelector("option")&&E(t,g),new f.default(t,e.align);if(t.classList.contains("ql-background")||t.classList.contains("ql-color")){var n=t.classList.contains("ql-background")?"background":"color";return null==t.querySelector("option")&&E(t,m,"background"===n?"#ffffff":"#000000"),new c.default(t,e[n])}return null==t.querySelector("option")&&(t.classList.contains("ql-font")?E(t,q):t.classList.contains("ql-header")?E(t,w):t.classList.contains("ql-size")&&E(t,_)),new d.default(t)})),this.quill.on(a.default.events.EDITOR_CHANGE,(function(){n.pickers.forEach((function(t){t.update()}))}))}}]),e}(u.default);x.DEFAULTS=(0,i.default)(!0,{},u.default.DEFAULTS,{modules:{toolbar:{handlers:{formula:function(){this.quill.theme.tooltip.edit("formula")},image:function(){var t=this,e=this.container.querySelector("input.ql-image[type=file]");null==e&&((e=document.createElement("input")).setAttribute("type","file"),e.setAttribute("accept","image/png, image/gif, image/jpeg, image/bmp, image/x-icon"),e.classList.add("ql-image"),e.addEventListener("change",(function(){if(null!=e.files&&null!=e.files[0]){var n=new FileReader;n.onload=function(n){var r=t.quill.getSelection(!0);t.quill.updateContents((new l.default).retain(r.index).delete(r.length).insert({image:n.target.result}),a.default.sources.USER),t.quill.setSelection(r.index+1,a.default.sources.SILENT),e.value=""},n.readAsDataURL(e.files[0])}})),this.container.appendChild(e)),e.click()},video:function(){this.quill.theme.tooltip.edit("video")}}}}});var k=function(t){function e(t,n){y(this,e);var r=b(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.textbox=r.root.querySelector('input[type="text"]'),r.listen(),r}return v(e,t),r(e,[{key:"listen",value:function(){var t=this;this.textbox.addEventListener("keydown",(function(e){s.default.match(e,"enter")?(t.save(),e.preventDefault()):s.default.match(e,"escape")&&(t.cancel(),e.preventDefault())}))}},{key:"cancel",value:function(){this.hide()}},{key:"edit",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"link",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.root.classList.remove("ql-hidden"),this.root.classList.add("ql-editing"),null!=e?this.textbox.value=e:t!==this.root.getAttribute("data-mode")&&(this.textbox.value=""),this.position(this.quill.getBounds(this.quill.selection.savedRange)),this.textbox.select(),this.textbox.setAttribute("placeholder",this.textbox.getAttribute("data-"+t)||""),this.root.setAttribute("data-mode",t)}},{key:"restoreFocus",value:function(){var t=this.quill.scrollingContainer.scrollTop;this.quill.focus(),this.quill.scrollingContainer.scrollTop=t}},{key:"save",value:function(){var t,e,n=this.textbox.value;switch(this.root.getAttribute("data-mode")){case"link":var r=this.quill.root.scrollTop;this.linkRange?(this.quill.formatText(this.linkRange,"link",n,a.default.sources.USER),delete this.linkRange):(this.restoreFocus(),this.quill.format("link",n,a.default.sources.USER)),this.quill.root.scrollTop=r;break;case"video":n=(e=(t=n).match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/)||t.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/))?(e[1]||"https")+"://www.youtube.com/embed/"+e[2]+"?showinfo=0":(e=t.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/))?(e[1]||"https")+"://player.vimeo.com/video/"+e[2]+"/":t;case"formula":if(!n)break;var o=this.quill.getSelection(!0);if(null!=o){var i=o.index+o.length;this.quill.insertEmbed(i,this.root.getAttribute("data-mode"),n,a.default.sources.USER),"formula"===this.root.getAttribute("data-mode")&&this.quill.insertText(i+1," ",a.default.sources.USER),this.quill.setSelection(i+2,a.default.sources.USER)}}this.textbox.value="",this.hide()}}]),e}(p.default);function E(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];e.forEach((function(e){var r=document.createElement("option");e===n?r.setAttribute("selected","selected"):r.setAttribute("value",e),t.appendChild(r)}))}e.BaseTooltip=k,e.default=x},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(){this.head=this.tail=null,this.length=0}return t.prototype.append=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.insertBefore(t[0],null),t.length>1&&this.append.apply(this,t.slice(1))},t.prototype.contains=function(t){for(var e,n=this.iterator();e=n();)if(e===t)return!0;return!1},t.prototype.insertBefore=function(t,e){t&&(t.next=e,null!=e?(t.prev=e.prev,null!=e.prev&&(e.prev.next=t),e.prev=t,e===this.head&&(this.head=t)):null!=this.tail?(this.tail.next=t,t.prev=this.tail,this.tail=t):(t.prev=null,this.head=this.tail=t),this.length+=1)},t.prototype.offset=function(t){for(var e=0,n=this.head;null!=n;){if(n===t)return e;e+=n.length(),n=n.next}return-1},t.prototype.remove=function(t){this.contains(t)&&(null!=t.prev&&(t.prev.next=t.next),null!=t.next&&(t.next.prev=t.prev),t===this.head&&(this.head=t.next),t===this.tail&&(this.tail=t.prev),this.length-=1)},t.prototype.iterator=function(t){return void 0===t&&(t=this.head),function(){var e=t;return null!=t&&(t=t.next),e}},t.prototype.find=function(t,e){void 0===e&&(e=!1);for(var n,r=this.iterator();n=r();){var o=n.length();if(t<o||e&&t===o&&(null==n.next||0!==n.next.length()))return[n,t];t-=o}return[null,0]},t.prototype.forEach=function(t){for(var e,n=this.iterator();e=n();)t(e)},t.prototype.forEachAt=function(t,e,n){if(!(e<=0))for(var r,o=this.find(t),i=o[0],l=t-o[1],a=this.iterator(i);(r=a())&&l<t+e;){var s=r.length();t>l?n(r,t-l,Math.min(e,l+s-t)):n(r,0,Math.min(s,t+e-l)),l+=s}},t.prototype.map=function(t){return this.reduce((function(e,n){return e.push(t(n)),e}),[])},t.prototype.reduce=function(t,e){for(var n,r=this.iterator();n=r();)e=t(e,n);return e},t}();e.default=r},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(17),l=n(1),a={attributes:!0,characterData:!0,characterDataOldValue:!0,childList:!0,subtree:!0},s=function(t){function e(e){var n=t.call(this,e)||this;return n.scroll=n,n.observer=new MutationObserver((function(t){n.update(t)})),n.observer.observe(n.domNode,a),n.attach(),n}return o(e,t),e.prototype.detach=function(){t.prototype.detach.call(this),this.observer.disconnect()},e.prototype.deleteAt=function(e,n){this.update(),0===e&&n===this.length()?this.children.forEach((function(t){t.remove()})):t.prototype.deleteAt.call(this,e,n)},e.prototype.formatAt=function(e,n,r,o){this.update(),t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){this.update(),t.prototype.insertAt.call(this,e,n,r)},e.prototype.optimize=function(e,n){var r=this;void 0===e&&(e=[]),void 0===n&&(n={}),t.prototype.optimize.call(this,n);for(var o=[].slice.call(this.observer.takeRecords());o.length>0;)e.push(o.pop());for(var a=function(t,e){void 0===e&&(e=!0),null!=t&&t!==r&&null!=t.domNode.parentNode&&(null==t.domNode[l.DATA_KEY].mutations&&(t.domNode[l.DATA_KEY].mutations=[]),e&&a(t.parent))},s=function(t){null!=t.domNode[l.DATA_KEY]&&null!=t.domNode[l.DATA_KEY].mutations&&(t instanceof i.default&&t.children.forEach(s),t.optimize(n))},u=e,c=0;u.length>0;c+=1){if(c>=100)throw new Error("[Parchment] Maximum optimize iterations reached");for(u.forEach((function(t){var e=l.find(t.target,!0);null!=e&&(e.domNode===t.target&&("childList"===t.type?(a(l.find(t.previousSibling,!1)),[].forEach.call(t.addedNodes,(function(t){var e=l.find(t,!1);a(e,!1),e instanceof i.default&&e.children.forEach((function(t){a(t,!1)}))}))):"attributes"===t.type&&a(e.prev)),a(e))})),this.children.forEach(s),o=(u=[].slice.call(this.observer.takeRecords())).slice();o.length>0;)e.push(o.pop())}},e.prototype.update=function(e,n){var r=this;void 0===n&&(n={}),(e=e||this.observer.takeRecords()).map((function(t){var e=l.find(t.target,!0);return null==e?null:null==e.domNode[l.DATA_KEY].mutations?(e.domNode[l.DATA_KEY].mutations=[t],e):(e.domNode[l.DATA_KEY].mutations.push(t),null)})).forEach((function(t){null!=t&&t!==r&&null!=t.domNode[l.DATA_KEY]&&t.update(t.domNode[l.DATA_KEY].mutations||[],n)})),null!=this.domNode[l.DATA_KEY].mutations&&t.prototype.update.call(this,this.domNode[l.DATA_KEY].mutations,n),this.optimize(e,n)},e.blotName="scroll",e.defaultChild="block",e.scope=l.Scope.BLOCK_BLOT,e.tagName="DIV",e}(i.default);e.default=s},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){if(n.tagName!==e.tagName)return t.formats.call(this,n)},e.prototype.format=function(n,r){var o=this;n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):(this.children.forEach((function(t){t instanceof i.default||(t=t.wrap(e.blotName,!0)),o.attributes.copy(t)})),this.unwrap())},e.prototype.formatAt=function(e,n,r,o){null!=this.formats()[r]||l.query(r,l.Scope.ATTRIBUTE)?this.isolate(e,n).format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n);var r=this.formats();if(0===Object.keys(r).length)return this.unwrap();var o=this.next;o instanceof e&&o.prev===this&&function(t,e){if(Object.keys(t).length!==Object.keys(e).length)return!1;for(var n in t)if(t[n]!==e[n])return!1;return!0}(r,o.formats())&&(o.moveChildren(this),o.remove())},e.blotName="inline",e.scope=l.Scope.INLINE_BLOT,e.tagName="SPAN",e}(i.default);e.default=a},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){var r=l.query(e.blotName).tagName;if(n.tagName!==r)return t.formats.call(this,n)},e.prototype.format=function(n,r){null!=l.query(n,l.Scope.BLOCK)&&(n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):this.replaceWith(e.blotName))},e.prototype.formatAt=function(e,n,r,o){null!=l.query(r,l.Scope.BLOCK)?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){if(null==r||null!=l.query(n,l.Scope.INLINE))t.prototype.insertAt.call(this,e,n,r);else{var o=this.split(e),i=l.create(n,r);o.parent.insertBefore(i,o)}},e.prototype.update=function(e,n){navigator.userAgent.match(/Trident/)?this.build():t.prototype.update.call(this,e,n)},e.blotName="block",e.scope=l.Scope.BLOCK_BLOT,e.tagName="P",e}(i.default);e.default=a},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(t){},e.prototype.format=function(e,n){t.prototype.formatAt.call(this,0,this.length(),e,n)},e.prototype.formatAt=function(e,n,r,o){0===e&&n===this.length()?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.formats=function(){return this.statics.formats(this.domNode)},e}(n(19).default);e.default=i},function(t,e,n){"use strict";var r,o=this&&this.__extends||(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var i=n(19),l=n(1),a=function(t){function e(e){var n=t.call(this,e)||this;return n.text=n.statics.value(n.domNode),n}return o(e,t),e.create=function(t){return document.createTextNode(t)},e.value=function(t){var e=t.data;return e.normalize&&(e=e.normalize()),e},e.prototype.deleteAt=function(t,e){this.domNode.data=this.text=this.text.slice(0,t)+this.text.slice(t+e)},e.prototype.index=function(t,e){return this.domNode===t?e:-1},e.prototype.insertAt=function(e,n,r){null==r?(this.text=this.text.slice(0,e)+n+this.text.slice(e),this.domNode.data=this.text):t.prototype.insertAt.call(this,e,n,r)},e.prototype.length=function(){return this.text.length},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n),this.text=this.statics.value(this.domNode),0===this.text.length?this.remove():this.next instanceof e&&this.next.prev===this&&(this.insertAt(this.length(),this.next.value()),this.next.remove())},e.prototype.position=function(t,e){return void 0===e&&(e=!1),[this.domNode,t]},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=l.create(this.domNode.splitText(t));return this.parent.insertBefore(n,this.next),this.text=this.statics.value(this.domNode),n},e.prototype.update=function(t,e){var n=this;t.some((function(t){return"characterData"===t.type&&t.target===n.domNode}))&&(this.text=this.statics.value(this.domNode))},e.prototype.value=function(){return this.text},e.blotName="text",e.scope=l.Scope.INLINE_BLOT,e}(i.default);e.default=a},function(t,e,n){"use strict";var r=document.createElement("div");if(r.classList.toggle("test-class",!1),r.classList.contains("test-class")){var o=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return arguments.length>1&&!this.contains(t)==!e?e:o.call(this,t)}}String.prototype.startsWith||(String.prototype.startsWith=function(t,e){return e=e||0,this.substr(e,t.length)===t}),String.prototype.endsWith||(String.prototype.endsWith=function(t,e){var n=this.toString();("number"!=typeof e||!isFinite(e)||Math.floor(e)!==e||e>n.length)&&(e=n.length),e-=t.length;var r=n.indexOf(t,e);return-1!==r&&r===e}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null===this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var e,n=Object(this),r=n.length>>>0,o=arguments[1],i=0;i<r;i++)if(e=n[i],t.call(o,e,i,n))return e}}),document.addEventListener("DOMContentLoaded",(function(){document.execCommand("enableObjectResizing",!1,!1),document.execCommand("autoUrlDetect",!1,!1)}))},function(t,e){var n=-1;function r(t,e,s){if(t==e)return t?[[0,t]]:[];(s<0||t.length<s)&&(s=null);var c=i(t,e),f=t.substring(0,c);c=l(t=t.substring(c),e=e.substring(c));var d=t.substring(t.length-c),p=function(t,e){var a;if(!t)return[[1,e]];if(!e)return[[n,t]];var s=t.length>e.length?t:e,u=t.length>e.length?e:t,c=s.indexOf(u);if(-1!=c)return a=[[1,s.substring(0,c)],[0,u],[1,s.substring(c+u.length)]],t.length>e.length&&(a[0][0]=a[2][0]=n),a;if(1==u.length)return[[n,t],[1,e]];var f=function(t,e){var n=t.length>e.length?t:e,r=t.length>e.length?e:t;if(n.length<4||2*r.length<n.length)return null;function o(t,e,n){for(var r,o,a,s,u=t.substring(n,n+Math.floor(t.length/4)),c=-1,f="";-1!=(c=e.indexOf(u,c+1));){var d=i(t.substring(n),e.substring(c)),p=l(t.substring(0,n),e.substring(0,c));f.length<p+d&&(f=e.substring(c-p,c)+e.substring(c,c+d),r=t.substring(0,n-p),o=t.substring(n+d),a=e.substring(0,c-p),s=e.substring(c+d))}return 2*f.length>=t.length?[r,o,a,s,f]:null}var a,s,u,c,f,d=o(n,r,Math.ceil(n.length/4)),p=o(n,r,Math.ceil(n.length/2));return d||p?(a=p?d&&d[4].length>p[4].length?d:p:d,t.length>e.length?(s=a[0],u=a[1],c=a[2],f=a[3]):(c=a[0],f=a[1],s=a[2],u=a[3]),[s,u,c,f,a[4]]):null}(t,e);if(f){var d=f[0],p=f[1],h=f[2],y=f[3],b=f[4],v=r(d,h),g=r(p,y);return v.concat([[0,b]],g)}return function(t,e){for(var r=t.length,i=e.length,l=Math.ceil((r+i)/2),a=l,s=2*l,u=new Array(s),c=new Array(s),f=0;f<s;f++)u[f]=-1,c[f]=-1;u[a+1]=0,c[a+1]=0;for(var d=r-i,p=d%2!=0,h=0,y=0,b=0,v=0,g=0;g<l;g++){for(var m=-g+h;m<=g-y;m+=2){for(var q=a+m,w=(O=m==-g||m!=g&&u[q-1]<u[q+1]?u[q+1]:u[q-1]+1)-m;O<r&&w<i&&t.charAt(O)==e.charAt(w);)O++,w++;if(u[q]=O,O>r)y+=2;else if(w>i)h+=2;else if(p&&(k=a+d-m)>=0&&k<s&&-1!=c[k]&&O>=(x=r-c[k]))return o(t,e,O,w)}for(var _=-g+b;_<=g-v;_+=2){for(var x,k=a+_,E=(x=_==-g||_!=g&&c[k-1]<c[k+1]?c[k+1]:c[k-1]+1)-_;x<r&&E<i&&t.charAt(r-x-1)==e.charAt(i-E-1);)x++,E++;if(c[k]=x,x>r)v+=2;else if(E>i)b+=2;else if(!p){var O;if((q=a+d-_)>=0&&q<s&&-1!=u[q]&&(w=a+(O=u[q])-q,O>=(x=r-x)))return o(t,e,O,w)}}}return[[n,t],[1,e]]}(t,e)}(t=t.substring(0,t.length-c),e=e.substring(0,e.length-c));return f&&p.unshift([0,f]),d&&p.push([0,d]),a(p),null!=s&&(p=function(t,e){var r=function(t,e){if(0===e)return[0,t];for(var r=0,o=0;o<t.length;o++){var i=t[o];if(i[0]===n||0===i[0]){var l=r+i[1].length;if(e===l)return[o+1,t];if(e<l){t=t.slice();var a=e-r,s=[i[0],i[1].slice(0,a)],u=[i[0],i[1].slice(a)];return t.splice(o,1,s,u),[o+1,t]}r=l}}throw new Error("cursor_pos is out of bounds!")}(t,e),o=r[1],i=r[0],l=o[i],a=o[i+1];if(null==l)return t;if(0!==l[0])return t;if(null!=a&&l[1]+a[1]===a[1]+l[1])return o.splice(i,2,a,l),u(o,i,2);if(null!=a&&0===a[1].indexOf(l[1])){o.splice(i,2,[a[0],l[1]],[0,l[1]]);var s=a[1].slice(l[1].length);return s.length>0&&o.splice(i+2,0,[a[0],s]),u(o,i,3)}return t}(p,s)),function(t){for(var e=!1,r=function(t){return t.charCodeAt(0)>=56320&&t.charCodeAt(0)<=57343},o=2;o<t.length;o+=1)0===t[o-2][0]&&((i=t[o-2][1]).charCodeAt(i.length-1)>=55296&&i.charCodeAt(i.length-1)<=56319)&&t[o-1][0]===n&&r(t[o-1][1])&&1===t[o][0]&&r(t[o][1])&&(e=!0,t[o-1][1]=t[o-2][1].slice(-1)+t[o-1][1],t[o][1]=t[o-2][1].slice(-1)+t[o][1],t[o-2][1]=t[o-2][1].slice(0,-1));var i;if(!e)return t;var l=[];for(o=0;o<t.length;o+=1)t[o][1].length>0&&l.push(t[o]);return l}(p)}function o(t,e,n,o){var i=t.substring(0,n),l=e.substring(0,o),a=t.substring(n),s=e.substring(o),u=r(i,l),c=r(a,s);return u.concat(c)}function i(t,e){if(!t||!e||t.charAt(0)!=e.charAt(0))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(i,o)==e.substring(i,o)?i=n=o:r=o,o=Math.floor((r-n)/2+n);return o}function l(t,e){if(!t||!e||t.charAt(t.length-1)!=e.charAt(e.length-1))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(t.length-o,t.length-i)==e.substring(e.length-o,e.length-i)?i=n=o:r=o,o=Math.floor((r-n)/2+n);return o}function a(t){t.push([0,""]);for(var e,r=0,o=0,s=0,u="",c="";r<t.length;)switch(t[r][0]){case 1:s++,c+=t[r][1],r++;break;case n:o++,u+=t[r][1],r++;break;case 0:o+s>1?(0!==o&&0!==s&&(0!==(e=i(c,u))&&(r-o-s>0&&0==t[r-o-s-1][0]?t[r-o-s-1][1]+=c.substring(0,e):(t.splice(0,0,[0,c.substring(0,e)]),r++),c=c.substring(e),u=u.substring(e)),0!==(e=l(c,u))&&(t[r][1]=c.substring(c.length-e)+t[r][1],c=c.substring(0,c.length-e),u=u.substring(0,u.length-e))),0===o?t.splice(r-s,o+s,[1,c]):0===s?t.splice(r-o,o+s,[n,u]):t.splice(r-o-s,o+s,[n,u],[1,c]),r=r-o-s+(o?1:0)+(s?1:0)+1):0!==r&&0==t[r-1][0]?(t[r-1][1]+=t[r][1],t.splice(r,1)):r++,s=0,o=0,u="",c=""}""===t[t.length-1][1]&&t.pop();var f=!1;for(r=1;r<t.length-1;)0==t[r-1][0]&&0==t[r+1][0]&&(t[r][1].substring(t[r][1].length-t[r-1][1].length)==t[r-1][1]?(t[r][1]=t[r-1][1]+t[r][1].substring(0,t[r][1].length-t[r-1][1].length),t[r+1][1]=t[r-1][1]+t[r+1][1],t.splice(r-1,1),f=!0):t[r][1].substring(0,t[r+1][1].length)==t[r+1][1]&&(t[r-1][1]+=t[r+1][1],t[r][1]=t[r][1].substring(t[r+1][1].length)+t[r+1][1],t.splice(r+1,1),f=!0)),r++;f&&a(t)}var s=r;function u(t,e,n){for(var r=e+n-1;r>=0&&r>=e-1;r--)if(r+1<t.length){var o=t[r],i=t[r+1];o[0]===i[1]&&t.splice(r,2,[o[0],o[1]+i[1]])}return t}s.INSERT=1,s.DELETE=n,s.EQUAL=0,t.exports=s},function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}(t.exports="function"==typeof Object.keys?Object.keys:n).shim=n},function(t,e){var n="[object Arguments]"==function(){return Object.prototype.toString.call(arguments)}();function r(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function o(t){return t&&"object"==typeof t&&"number"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,"callee")&&!Object.prototype.propertyIsEnumerable.call(t,"callee")||!1}(e=t.exports=n?r:o).supported=r,e.unsupported=o},function(t,e){"use strict";var n=Object.prototype.hasOwnProperty,r="~";function o(){}function i(t,e,n){this.fn=t,this.context=e,this.once=n||!1}function l(){this._events=new o,this._eventsCount=0}Object.create&&(o.prototype=Object.create(null),(new o).__proto__||(r=!1)),l.prototype.eventNames=function(){var t,e,o=[];if(0===this._eventsCount)return o;for(e in t=this._events)n.call(t,e)&&o.push(r?e.slice(1):e);return Object.getOwnPropertySymbols?o.concat(Object.getOwnPropertySymbols(t)):o},l.prototype.listeners=function(t,e){var n=r?r+t:t,o=this._events[n];if(e)return!!o;if(!o)return[];if(o.fn)return[o.fn];for(var i=0,l=o.length,a=new Array(l);i<l;i++)a[i]=o[i].fn;return a},l.prototype.emit=function(t,e,n,o,i,l){var a=r?r+t:t;if(!this._events[a])return!1;var s,u,c=this._events[a],f=arguments.length;if(c.fn){switch(c.once&&this.removeListener(t,c.fn,void 0,!0),f){case 1:return c.fn.call(c.context),!0;case 2:return c.fn.call(c.context,e),!0;case 3:return c.fn.call(c.context,e,n),!0;case 4:return c.fn.call(c.context,e,n,o),!0;case 5:return c.fn.call(c.context,e,n,o,i),!0;case 6:return c.fn.call(c.context,e,n,o,i,l),!0}for(u=1,s=new Array(f-1);u<f;u++)s[u-1]=arguments[u];c.fn.apply(c.context,s)}else{var d,p=c.length;for(u=0;u<p;u++)switch(c[u].once&&this.removeListener(t,c[u].fn,void 0,!0),f){case 1:c[u].fn.call(c[u].context);break;case 2:c[u].fn.call(c[u].context,e);break;case 3:c[u].fn.call(c[u].context,e,n);break;case 4:c[u].fn.call(c[u].context,e,n,o);break;default:if(!s)for(d=1,s=new Array(f-1);d<f;d++)s[d-1]=arguments[d];c[u].fn.apply(c[u].context,s)}}return!0},l.prototype.on=function(t,e,n){var o=new i(e,n||this),l=r?r+t:t;return this._events[l]?this._events[l].fn?this._events[l]=[this._events[l],o]:this._events[l].push(o):(this._events[l]=o,this._eventsCount++),this},l.prototype.once=function(t,e,n){var o=new i(e,n||this,!0),l=r?r+t:t;return this._events[l]?this._events[l].fn?this._events[l]=[this._events[l],o]:this._events[l].push(o):(this._events[l]=o,this._eventsCount++),this},l.prototype.removeListener=function(t,e,n,i){var l=r?r+t:t;if(!this._events[l])return this;if(!e)return 0==--this._eventsCount?this._events=new o:delete this._events[l],this;var a=this._events[l];if(a.fn)a.fn!==e||i&&!a.once||n&&a.context!==n||(0==--this._eventsCount?this._events=new o:delete this._events[l]);else{for(var s=0,u=[],c=a.length;s<c;s++)(a[s].fn!==e||i&&!a[s].once||n&&a[s].context!==n)&&u.push(a[s]);u.length?this._events[l]=1===u.length?u[0]:u:0==--this._eventsCount?this._events=new o:delete this._events[l]}return this},l.prototype.removeAllListeners=function(t){var e;return t?(e=r?r+t:t,this._events[e]&&(0==--this._eventsCount?this._events=new o:delete this._events[e])):(this._events=new o,this._eventsCount=0),this},l.prototype.off=l.prototype.removeListener,l.prototype.addListener=l.prototype.on,l.prototype.setMaxListeners=function(){return this},l.prefixed=r,l.EventEmitter=l,void 0!==t&&(t.exports=l)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.matchText=e.matchSpacing=e.matchNewline=e.matchBlot=e.matchAttributor=e.default=void 0;var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),l=m(n(3)),a=m(n(2)),s=m(n(0)),u=m(n(5)),c=m(n(10)),f=m(n(9)),d=n(36),p=n(37),h=m(n(13)),y=n(26),b=n(38),v=n(39),g=n(40);function m(t){return t&&t.__esModule?t:{default:t}}function q(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var w=(0,c.default)("quill:clipboard"),_="__ql-matcher",x=[[Node.TEXT_NODE,R],[Node.TEXT_NODE,M],["br",function(t,e){return T(e,"\n")||e.insert("\n"),e}],[Node.ELEMENT_NODE,M],[Node.ELEMENT_NODE,P],[Node.ELEMENT_NODE,D],[Node.ELEMENT_NODE,S],[Node.ELEMENT_NODE,function(t,e){var n={},r=t.style||{};return r.fontStyle&&"italic"===N(t).fontStyle&&(n.italic=!0),r.fontWeight&&(N(t).fontWeight.startsWith("bold")||parseInt(N(t).fontWeight)>=700)&&(n.bold=!0),Object.keys(n).length>0&&(e=A(e,n)),parseFloat(r.textIndent||0)>0&&(e=(new a.default).insert("\t").concat(e)),e}],["li",function(t,e){var n=s.default.query(t);if(null==n||"list-item"!==n.blotName||!T(e,"\n"))return e;for(var r=-1,o=t.parentNode;!o.classList.contains("ql-clipboard");)"list"===(s.default.query(o)||{}).blotName&&(r+=1),o=o.parentNode;return r<=0?e:e.compose((new a.default).retain(e.length()-1).retain(1,{indent:r}))}],["b",C.bind(C,"bold")],["i",C.bind(C,"italic")],["style",function(){return new a.default}]],k=[d.AlignAttribute,b.DirectionAttribute].reduce((function(t,e){return t[e.keyName]=e,t}),{}),E=[d.AlignStyle,p.BackgroundStyle,y.ColorStyle,b.DirectionStyle,v.FontStyle,g.SizeStyle].reduce((function(t,e){return t[e.keyName]=e,t}),{}),O=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.root.addEventListener("paste",r.onPaste.bind(r)),r.container=r.quill.addContainer("ql-clipboard"),r.container.setAttribute("contenteditable",!0),r.container.setAttribute("tabindex",-1),r.matchers=[],x.concat(r.options.matchers).forEach((function(t){var e=o(t,2),i=e[0],l=e[1];(n.matchVisual||l!==D)&&r.addMatcher(i,l)})),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),i(e,[{key:"addMatcher",value:function(t,e){this.matchers.push([t,e])}},{key:"convert",value:function(t){if("string"==typeof t)return this.container.innerHTML=t.replace(/\>\r?\n +\</g,"><"),this.convert();var e=this.quill.getFormat(this.quill.selection.savedRange.index);if(e[h.default.blotName]){var n=this.container.innerText;return this.container.innerHTML="",(new a.default).insert(n,q({},h.default.blotName,e[h.default.blotName]))}var r=this.prepareMatching(),i=o(r,2),l=i[0],s=i[1],u=L(this.container,l,s);return T(u,"\n")&&null==u.ops[u.ops.length-1].attributes&&(u=u.compose((new a.default).retain(u.length()-1).delete(1))),w.log("convert",this.container.innerHTML,u),this.container.innerHTML="",u}},{key:"dangerouslyPasteHTML",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.default.sources.API;if("string"==typeof t)this.quill.setContents(this.convert(t),e),this.quill.setSelection(0,u.default.sources.SILENT);else{var r=this.convert(e);this.quill.updateContents((new a.default).retain(t).concat(r),n),this.quill.setSelection(t+r.length(),u.default.sources.SILENT)}}},{key:"onPaste",value:function(t){var e=this;if(!t.defaultPrevented&&this.quill.isEnabled()){var n=this.quill.getSelection(),r=(new a.default).retain(n.index),o=this.quill.scrollingContainer.scrollTop;this.container.focus(),this.quill.selection.update(u.default.sources.SILENT),setTimeout((function(){r=r.concat(e.convert()).delete(n.length),e.quill.updateContents(r,u.default.sources.USER),e.quill.setSelection(r.length()-n.length,u.default.sources.SILENT),e.quill.scrollingContainer.scrollTop=o,e.quill.focus()}),1)}}},{key:"prepareMatching",value:function(){var t=this,e=[],n=[];return this.matchers.forEach((function(r){var i=o(r,2),l=i[0],a=i[1];switch(l){case Node.TEXT_NODE:n.push(a);break;case Node.ELEMENT_NODE:e.push(a);break;default:[].forEach.call(t.container.querySelectorAll(l),(function(t){t[_]=t[_]||[],t[_].push(a)}))}})),[e,n]}}]),e}(f.default);function A(t,e,n){return"object"===(void 0===e?"undefined":r(e))?Object.keys(e).reduce((function(t,n){return A(t,n,e[n])}),t):t.reduce((function(t,r){return r.attributes&&r.attributes[e]?t.push(r):t.insert(r.insert,(0,l.default)({},q({},e,n),r.attributes))}),new a.default)}function N(t){if(t.nodeType!==Node.ELEMENT_NODE)return{};var e="__ql-computed-style";return t[e]||(t[e]=window.getComputedStyle(t))}function T(t,e){for(var n="",r=t.ops.length-1;r>=0&&n.length<e.length;--r){var o=t.ops[r];if("string"!=typeof o.insert)break;n=o.insert+n}return n.slice(-1*e.length)===e}function j(t){if(0===t.childNodes.length)return!1;var e=N(t);return["block","list-item"].indexOf(e.display)>-1}function L(t,e,n){return t.nodeType===t.TEXT_NODE?n.reduce((function(e,n){return n(t,e)}),new a.default):t.nodeType===t.ELEMENT_NODE?[].reduce.call(t.childNodes||[],(function(r,o){var i=L(o,e,n);return o.nodeType===t.ELEMENT_NODE&&(i=e.reduce((function(t,e){return e(o,t)}),i),i=(o[_]||[]).reduce((function(t,e){return e(o,t)}),i)),r.concat(i)}),new a.default):new a.default}function C(t,e,n){return A(n,t,!0)}function S(t,e){var n=s.default.Attributor.Attribute.keys(t),r=s.default.Attributor.Class.keys(t),o=s.default.Attributor.Style.keys(t),i={};return n.concat(r).concat(o).forEach((function(e){var n=s.default.query(e,s.default.Scope.ATTRIBUTE);null!=n&&(i[n.attrName]=n.value(t),i[n.attrName])||(null==(n=k[e])||n.attrName!==e&&n.keyName!==e||(i[n.attrName]=n.value(t)||void 0),null==(n=E[e])||n.attrName!==e&&n.keyName!==e||(n=E[e],i[n.attrName]=n.value(t)||void 0))})),Object.keys(i).length>0&&(e=A(e,i)),e}function P(t,e){var n=s.default.query(t);if(null==n)return e;if(n.prototype instanceof s.default.Embed){var r={},o=n.value(t);null!=o&&(r[n.blotName]=o,e=(new a.default).insert(r,n.formats(t)))}else"function"==typeof n.formats&&(e=A(e,n.blotName,n.formats(t)));return e}function M(t,e){return T(e,"\n")||(j(t)||e.length()>0&&t.nextSibling&&j(t.nextSibling))&&e.insert("\n"),e}function D(t,e){if(j(t)&&null!=t.nextElementSibling&&!T(e,"\n\n")){var n=t.offsetHeight+parseFloat(N(t).marginTop)+parseFloat(N(t).marginBottom);t.nextElementSibling.offsetTop>t.offsetTop+1.5*n&&e.insert("\n")}return e}function R(t,e){var n=t.data;if("O:P"===t.parentNode.tagName)return e.insert(n.trim());if(0===n.trim().length&&t.parentNode.classList.contains("ql-clipboard"))return e;if(!N(t.parentNode).whiteSpace.startsWith("pre")){var r=function(t,e){return(e=e.replace(/[^\u00a0]/g,"")).length<1&&t?" ":e};n=(n=n.replace(/\r\n/g," ").replace(/\n/g," ")).replace(/\s\s+/g,r.bind(r,!0)),(null==t.previousSibling&&j(t.parentNode)||null!=t.previousSibling&&j(t.previousSibling))&&(n=n.replace(/^\s+/,r.bind(r,!1))),(null==t.nextSibling&&j(t.parentNode)||null!=t.nextSibling&&j(t.nextSibling))&&(n=n.replace(/\s+$/,r.bind(r,!1)))}return e.insert(n)}O.DEFAULTS={matchers:[],matchVisual:!0},e.default=O,e.matchAttributor=S,e.matchBlot=P,e.matchNewline=M,e.matchSpacing=D,e.matchText=R},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0};function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"optimize",value:function(t){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t),this.domNode.tagName!==this.statics.tagName[0]&&this.replaceWith(this.statics.blotName)}}],[{key:"create",value:function(){return i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this)}},{key:"formats",value:function(){return!0}}]),e}(((r=n(6))&&r.__esModule?r:{default:r}).default);s.blotName="bold",s.tagName=["STRONG","B"],e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.addControls=e.default=void 0;var r=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=c(n(2)),l=c(n(0)),a=c(n(5)),s=c(n(10)),u=c(n(9));function c(t){return t&&t.__esModule?t:{default:t}}function f(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var d=(0,s.default)("quill:toolbar"),p=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var o,i=f(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if(Array.isArray(i.options.container)){var l=document.createElement("div");y(l,i.options.container),t.container.parentNode.insertBefore(l,t.container),i.container=l}else"string"==typeof i.options.container?i.container=document.querySelector(i.options.container):i.container=i.options.container;return i.container instanceof HTMLElement?(i.container.classList.add("ql-toolbar"),i.controls=[],i.handlers={},Object.keys(i.options.handlers).forEach((function(t){i.addHandler(t,i.options.handlers[t])})),[].forEach.call(i.container.querySelectorAll("button, select"),(function(t){i.attach(t)})),i.quill.on(a.default.events.EDITOR_CHANGE,(function(t,e){t===a.default.events.SELECTION_CHANGE&&i.update(e)})),i.quill.on(a.default.events.SCROLL_OPTIMIZE,(function(){var t=i.quill.selection.getRange(),e=r(t,1)[0];i.update(e)})),i):(o=d.error("Container required for toolbar",i.options),f(i,o))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"addHandler",value:function(t,e){this.handlers[t]=e}},{key:"attach",value:function(t){var e=this,n=[].find.call(t.classList,(function(t){return 0===t.indexOf("ql-")}));if(n){if(n=n.slice("ql-".length),"BUTTON"===t.tagName&&t.setAttribute("type","button"),null==this.handlers[n]){if(null!=this.quill.scroll.whitelist&&null==this.quill.scroll.whitelist[n])return void d.warn("ignoring attaching to disabled format",n,t);if(null==l.default.query(n))return void d.warn("ignoring attaching to nonexistent format",n,t)}var o="SELECT"===t.tagName?"change":"click";t.addEventListener(o,(function(o){var s=void 0;if("SELECT"===t.tagName){if(t.selectedIndex<0)return;var u=t.options[t.selectedIndex];s=!u.hasAttribute("selected")&&(u.value||!1)}else s=!t.classList.contains("ql-active")&&(t.value||!t.hasAttribute("value")),o.preventDefault();e.quill.focus();var c=e.quill.selection.getRange(),f=r(c,1)[0];if(null!=e.handlers[n])e.handlers[n].call(e,s);else if(l.default.query(n).prototype instanceof l.default.Embed){if(!(s=prompt("Enter "+n)))return;e.quill.updateContents((new i.default).retain(f.index).delete(f.length).insert(function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}({},n,s)),a.default.sources.USER)}else e.quill.format(n,s,a.default.sources.USER);e.update(f)})),this.controls.push([n,t])}}},{key:"update",value:function(t){var e=null==t?{}:this.quill.getFormat(t);this.controls.forEach((function(n){var o=r(n,2),i=o[0],l=o[1];if("SELECT"===l.tagName){var a=void 0;if(null==t)a=null;else if(null==e[i])a=l.querySelector("option[selected]");else if(!Array.isArray(e[i])){var s=e[i];"string"==typeof s&&(s=s.replace(/\"/g,'\\"')),a=l.querySelector('option[value="'+s+'"]')}null==a?(l.value="",l.selectedIndex=-1):a.selected=!0}else if(null==t)l.classList.remove("ql-active");else if(l.hasAttribute("value")){var u=e[i]===l.getAttribute("value")||null!=e[i]&&e[i].toString()===l.getAttribute("value")||null==e[i]&&!l.getAttribute("value");l.classList.toggle("ql-active",u)}else l.classList.toggle("ql-active",null!=e[i])}))}}]),e}(u.default);function h(t,e,n){var r=document.createElement("button");r.setAttribute("type","button"),r.classList.add("ql-"+e),null!=n&&(r.value=n),t.appendChild(r)}function y(t,e){Array.isArray(e[0])||(e=[e]),e.forEach((function(e){var n=document.createElement("span");n.classList.add("ql-formats"),e.forEach((function(t){if("string"==typeof t)h(n,t);else{var e=Object.keys(t)[0],r=t[e];Array.isArray(r)?function(t,e,n){var r=document.createElement("select");r.classList.add("ql-"+e),n.forEach((function(t){var e=document.createElement("option");!1!==t?e.setAttribute("value",t):e.setAttribute("selected","selected"),r.appendChild(e)})),t.appendChild(r)}(n,e,r):h(n,e,r)}})),t.appendChild(n)}))}p.DEFAULTS={},p.DEFAULTS={container:null,handlers:{clean:function(){var t=this,e=this.quill.getSelection();if(null!=e)if(0==e.length){var n=this.quill.getFormat();Object.keys(n).forEach((function(e){null!=l.default.query(e,l.default.Scope.INLINE)&&t.quill.format(e,!1)}))}else this.quill.removeFormat(e,a.default.sources.USER)},direction:function(t){var e=this.quill.getFormat().align;"rtl"===t&&null==e?this.quill.format("align","right",a.default.sources.USER):t||"right"!==e||this.quill.format("align",!1,a.default.sources.USER),this.quill.format("direction",t,a.default.sources.USER)},indent:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e),r=parseInt(n.indent||0);if("+1"===t||"-1"===t){var o="+1"===t?1:-1;"rtl"===n.direction&&(o*=-1),this.quill.format("indent",r+o,a.default.sources.USER)}},link:function(t){!0===t&&(t=prompt("Enter link URL:")),this.quill.format("link",t,a.default.sources.USER)},list:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e);"check"===t?"checked"===n.list||"unchecked"===n.list?this.quill.format("list",!1,a.default.sources.USER):this.quill.format("list","unchecked",a.default.sources.USER):this.quill.format("list",t,a.default.sources.USER)}}},e.default=p,e.addControls=y},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.label.innerHTML=n,r.container.classList.add("ql-color-picker"),[].slice.call(r.container.querySelectorAll(".ql-picker-item"),0,7).forEach((function(t){t.classList.add("ql-primary")})),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"buildItem",value:function(t){var n=i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"buildItem",this).call(this,t);return n.style.backgroundColor=t.getAttribute("value")||"",n}},{key:"selectItem",value:function(t,n){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n);var r=this.label.querySelector(".ql-color-label"),o=t&&t.getAttribute("data-value")||"";r&&("line"===r.tagName?r.style.stroke=o:r.style.fill=o)}}]),e}(((r=n(28))&&r.__esModule?r:{default:r}).default);e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=function(t){function e(t,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var r=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.container.classList.add("ql-icon-picker"),[].forEach.call(r.container.querySelectorAll(".ql-picker-item"),(function(t){t.innerHTML=n[t.getAttribute("data-value")||""]})),r.defaultItem=r.container.querySelector(".ql-selected"),r.selectItem(r.defaultItem),r}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"selectItem",value:function(t,n){i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"selectItem",this).call(this,t,n),t=t||this.defaultItem,this.label.innerHTML=t.innerHTML}}]),e}(((r=n(28))&&r.__esModule?r:{default:r}).default);e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function(){function t(e,n){var r=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.quill=e,this.boundsContainer=n||document.body,this.root=e.addContainer("ql-tooltip"),this.root.innerHTML=this.constructor.TEMPLATE,this.quill.root===this.quill.scrollingContainer&&this.quill.root.addEventListener("scroll",(function(){r.root.style.marginTop=-1*r.quill.root.scrollTop+"px"})),this.hide()}return r(t,[{key:"hide",value:function(){this.root.classList.add("ql-hidden")}},{key:"position",value:function(t){var e=t.left+t.width/2-this.root.offsetWidth/2,n=t.bottom+this.quill.root.scrollTop;this.root.style.left=e+"px",this.root.style.top=n+"px",this.root.classList.remove("ql-flip");var r=this.boundsContainer.getBoundingClientRect(),o=this.root.getBoundingClientRect(),i=0;if(o.right>r.right&&(i=r.right-o.right,this.root.style.left=e+i+"px"),o.left<r.left&&(i=r.left-o.left,this.root.style.left=e+i+"px"),o.bottom>r.bottom){var l=o.bottom-o.top,a=t.bottom-t.top+l;this.root.style.top=n-a+"px",this.root.classList.add("ql-flip")}return i}},{key:"show",value:function(){this.root.classList.remove("ql-editing"),this.root.classList.remove("ql-hidden")}}]),t}();e.default=o},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=d(n(3)),l=d(n(8)),a=n(43),s=d(a),u=d(n(27)),c=n(15),f=d(n(41));function d(t){return t&&t.__esModule?t:{default:t}}function p(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function h(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function y(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var b=[[{header:["1","2","3",!1]}],["bold","italic","underline","link"],[{list:"ordered"},{list:"bullet"}],["clean"]],v=function(t){function e(t,n){p(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=b);var r=h(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-snow"),r}return y(e,t),o(e,[{key:"extendToolbar",value:function(t){t.container.classList.add("ql-snow"),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),f.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),f.default),this.tooltip=new g(this.quill,this.options.bounds),t.container.querySelector(".ql-link")&&this.quill.keyboard.addBinding({key:"K",shortKey:!0},(function(e,n){t.handlers.link.call(t,!n.format.link)}))}}]),e}(s.default);v.DEFAULTS=(0,i.default)(!0,{},s.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){if(t){var e=this.quill.getSelection();if(null==e||0==e.length)return;var n=this.quill.getText(e);/^\S+@\S+\.\S+$/.test(n)&&0!==n.indexOf("mailto:")&&(n="mailto:"+n),this.quill.theme.tooltip.edit("link",n)}else this.quill.format("link",!1)}}}}});var g=function(t){function e(t,n){p(this,e);var r=h(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.preview=r.root.querySelector("a.ql-preview"),r}return y(e,t),o(e,[{key:"listen",value:function(){var t=this;r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector("a.ql-action").addEventListener("click",(function(e){t.root.classList.contains("ql-editing")?t.save():t.edit("link",t.preview.textContent),e.preventDefault()})),this.root.querySelector("a.ql-remove").addEventListener("click",(function(e){if(null!=t.linkRange){var n=t.linkRange;t.restoreFocus(),t.quill.formatText(n,"link",!1,l.default.sources.USER),delete t.linkRange}e.preventDefault(),t.hide()})),this.quill.on(l.default.events.SELECTION_CHANGE,(function(e,n,r){if(null!=e){if(0===e.length&&r===l.default.sources.USER){var o=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}(t.quill.scroll.descendant(u.default,e.index),2),i=o[0],a=o[1];if(null!=i){t.linkRange=new c.Range(e.index-a,i.length());var s=u.default.formats(i.domNode);return t.preview.textContent=s,t.preview.setAttribute("href",s),t.show(),void t.position(t.quill.getBounds(t.linkRange))}}else delete t.linkRange;t.hide()}}))}},{key:"show",value:function(){r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"show",this).call(this),this.root.removeAttribute("data-mode")}}]),e}(a.BaseTooltip);g.TEMPLATE=['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>','<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">','<a class="ql-action"></a>','<a class="ql-remove"></a>'].join(""),e.default=v},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=M(n(29)),o=n(36),i=n(38),l=n(64),a=M(n(65)),s=M(n(66)),u=n(67),c=M(u),f=n(37),d=n(26),p=n(39),h=n(40),y=M(n(56)),b=M(n(68)),v=M(n(27)),g=M(n(69)),m=M(n(70)),q=M(n(71)),w=M(n(72)),_=M(n(73)),x=n(13),k=M(x),E=M(n(74)),O=M(n(75)),A=M(n(57)),N=M(n(41)),T=M(n(28)),j=M(n(59)),L=M(n(60)),C=M(n(61)),S=M(n(108)),P=M(n(62));function M(t){return t&&t.__esModule?t:{default:t}}r.default.register({"attributors/attribute/direction":i.DirectionAttribute,"attributors/class/align":o.AlignClass,"attributors/class/background":f.BackgroundClass,"attributors/class/color":d.ColorClass,"attributors/class/direction":i.DirectionClass,"attributors/class/font":p.FontClass,"attributors/class/size":h.SizeClass,"attributors/style/align":o.AlignStyle,"attributors/style/background":f.BackgroundStyle,"attributors/style/color":d.ColorStyle,"attributors/style/direction":i.DirectionStyle,"attributors/style/font":p.FontStyle,"attributors/style/size":h.SizeStyle},!0),r.default.register({"formats/align":o.AlignClass,"formats/direction":i.DirectionClass,"formats/indent":l.IndentClass,"formats/background":f.BackgroundStyle,"formats/color":d.ColorStyle,"formats/font":p.FontClass,"formats/size":h.SizeClass,"formats/blockquote":a.default,"formats/code-block":k.default,"formats/header":s.default,"formats/list":c.default,"formats/bold":y.default,"formats/code":x.Code,"formats/italic":b.default,"formats/link":v.default,"formats/script":g.default,"formats/strike":m.default,"formats/underline":q.default,"formats/image":w.default,"formats/video":_.default,"formats/list/item":u.ListItem,"modules/formula":E.default,"modules/syntax":O.default,"modules/toolbar":A.default,"themes/bubble":S.default,"themes/snow":P.default,"ui/icons":N.default,"ui/picker":T.default,"ui/icon-picker":L.default,"ui/color-picker":j.default,"ui/tooltip":C.default},!0),e.default=r.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.IndentClass=void 0;var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=(r=n(0))&&r.__esModule?r:{default:r};function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var u=new(function(t){function e(){return a(this,e),s(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"add",value:function(t,n){if("+1"===n||"-1"===n){var r=this.value(t)||0;n="+1"===n?r+1:r-1}return 0===n?(this.remove(t),!0):i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"add",this).call(this,t,n)}},{key:"canAdd",value:function(t,n){return i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,n)||i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"canAdd",this).call(this,t,parseInt(n))}},{key:"value",value:function(t){return parseInt(i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"value",this).call(this,t))||void 0}}]),e}(l.default.Attributor.Class))("indent","ql-indent",{scope:l.default.Scope.BLOCK,whitelist:[1,2,3,4,5,6,7,8]});e.IndentClass=u},function(t,e,n){"use strict";var r;function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=n(4))&&r.__esModule?r:{default:r}).default);l.blotName="blockquote",l.tagName="blockquote",e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var a=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,null,[{key:"formats",value:function(t){return this.tagName.indexOf(t.tagName)+1}}]),e}(((r=n(4))&&r.__esModule?r:{default:r}).default);a.blotName="header",a.tagName=["H1","H2","H3","H4","H5","H6"],e.default=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.ListItem=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=s(n(0)),l=s(n(4)),a=s(n(25));function s(t){return t&&t.__esModule?t:{default:t}}function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function c(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function f(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var d=function(t){function e(){return u(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return f(e,t),r(e,[{key:"format",value:function(t,n){t!==p.blotName||n?o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n):this.replaceWith(i.default.create(this.statics.scope))}},{key:"remove",value:function(){null==this.prev&&null==this.next?this.parent.remove():o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"remove",this).call(this)}},{key:"replaceWith",value:function(t,n){return this.parent.isolate(this.offset(this.parent),this.length()),t===this.parent.statics.blotName?(this.parent.replaceWith(t,n),this):(this.parent.unwrap(),o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t,n))}}],[{key:"formats",value:function(t){return t.tagName===this.tagName?void 0:o(e.__proto__||Object.getPrototypeOf(e),"formats",this).call(this,t)}}]),e}(l.default);d.blotName="list-item",d.tagName="LI";var p=function(t){function e(t){u(this,e);var n=c(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t)),r=function(e){if(e.target.parentNode===t){var r=n.statics.formats(t),o=i.default.find(e.target);"checked"===r?o.format("list","unchecked"):"unchecked"===r&&o.format("list","checked")}};return t.addEventListener("touchstart",r),t.addEventListener("mousedown",r),n}return f(e,t),r(e,null,[{key:"create",value:function(t){var n="ordered"===t?"OL":"UL",r=o(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,n);return"checked"!==t&&"unchecked"!==t||r.setAttribute("data-checked","checked"===t),r}},{key:"formats",value:function(t){return"OL"===t.tagName?"ordered":"UL"===t.tagName?t.hasAttribute("data-checked")?"true"===t.getAttribute("data-checked")?"checked":"unchecked":"bullet":void 0}}]),r(e,[{key:"format",value:function(t,e){this.children.length>0&&this.children.tail.format(t,e)}},{key:"formats",value:function(){return t={},e=this.statics.blotName,n=this.statics.formats(this.domNode),e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t;var t,e,n}},{key:"insertBefore",value:function(t,n){if(t instanceof d)o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"insertBefore",this).call(this,t,n);else{var r=null==n?this.length():n.offset(this),i=this.split(r);i.parent.insertBefore(t,i)}}},{key:"optimize",value:function(t){o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"optimize",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&n.domNode.tagName===this.domNode.tagName&&n.domNode.getAttribute("data-checked")===this.domNode.getAttribute("data-checked")&&(n.moveChildren(this),n.remove())}},{key:"replace",value:function(t){if(t.statics.blotName!==this.statics.blotName){var n=i.default.create(this.statics.defaultChild);t.moveChildren(n),this.appendChild(n)}o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replace",this).call(this,t)}}]),e}(a.default);p.blotName="list",p.scope=i.default.Scope.BLOCK_BLOT,p.tagName=["OL","UL"],p.defaultChild="list-item",p.allowedChildren=[d],e.ListItem=d,e.default=p},function(t,e,n){"use strict";var r;function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=n(56))&&r.__esModule?r:{default:r}).default);l.blotName="italic",l.tagName=["EM","I"],e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0};function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var s=function(t){function e(){return l(this,e),a(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,null,[{key:"create",value:function(t){return"super"===t?document.createElement("sup"):"sub"===t?document.createElement("sub"):i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t)}},{key:"formats",value:function(t){return"SUB"===t.tagName?"sub":"SUP"===t.tagName?"super":void 0}}]),e}(((r=n(6))&&r.__esModule?r:{default:r}).default);s.blotName="script",s.tagName=["SUB","SUP"],e.default=s},function(t,e,n){"use strict";var r;function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=n(6))&&r.__esModule?r:{default:r}).default);l.blotName="strike",l.tagName="S",e.default=l},function(t,e,n){"use strict";var r;function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}Object.defineProperty(e,"__esModule",{value:!0});var l=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(((r=n(6))&&r.__esModule?r:{default:r}).default);l.blotName="underline",l.tagName="U",e.default=l},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=(r=n(0))&&r.__esModule?r:{default:r},a=n(27);function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var c=["alt","height","width"],f=function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"format",value:function(t,n){c.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return c.reduce((function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e}),{})}},{key:"match",value:function(t){return/\.(jpe?g|gif|png)$/.test(t)||/^data:image\/.+;base64/.test(t)}},{key:"sanitize",value:function(t){return(0,a.sanitize)(t,["http","https","data"])?t:"//:0"}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(l.default.Embed);f.blotName="image",f.tagName="IMG",e.default=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},l=n(4),a=(r=n(27))&&r.__esModule?r:{default:r};function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}var c=["height","width"],f=function(t){function e(){return s(this,e),u(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),o(e,[{key:"format",value:function(t,n){c.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):i(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"format",this).call(this,t,n)}}],[{key:"create",value:function(t){var n=i(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return n.setAttribute("frameborder","0"),n.setAttribute("allowfullscreen",!0),n.setAttribute("src",this.sanitize(t)),n}},{key:"formats",value:function(t){return c.reduce((function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e}),{})}},{key:"sanitize",value:function(t){return a.default.sanitize(t)}},{key:"value",value:function(t){return t.getAttribute("src")}}]),e}(l.BlockEmbed);f.blotName="video",f.className="ql-video",f.tagName="IFRAME",e.default=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.FormulaBlot=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=s(n(35)),l=s(n(5)),a=s(n(9));function s(t){return t&&t.__esModule?t:{default:t}}function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function c(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function f(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var d=function(t){function e(){return u(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return f(e,t),r(e,null,[{key:"create",value:function(t){var n=o(e.__proto__||Object.getPrototypeOf(e),"create",this).call(this,t);return"string"==typeof t&&(window.katex.render(t,n,{throwOnError:!1,errorColor:"#f00"}),n.setAttribute("data-value",t)),n}},{key:"value",value:function(t){return t.getAttribute("data-value")}}]),e}(i.default);d.blotName="formula",d.className="ql-formula",d.tagName="SPAN";var p=function(t){function e(){u(this,e);var t=c(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));if(null==window.katex)throw new Error("Formula module requires KaTeX.");return t}return f(e,t),r(e,null,[{key:"register",value:function(){l.default.register(d,!0)}}]),e}(a.default);e.FormulaBlot=d,e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.CodeToken=e.CodeBlock=void 0;var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},i=s(n(0)),l=s(n(5)),a=s(n(9));function s(t){return t&&t.__esModule?t:{default:t}}function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function c(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function f(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var d=function(t){function e(){return u(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return f(e,t),r(e,[{key:"replaceWith",value:function(t){this.domNode.textContent=this.domNode.textContent,this.attach(),o(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"replaceWith",this).call(this,t)}},{key:"highlight",value:function(t){var e=this.domNode.textContent;this.cachedText!==e&&((e.trim().length>0||null==this.cachedText)&&(this.domNode.innerHTML=t(e),this.domNode.normalize(),this.attach()),this.cachedText=e)}}]),e}(s(n(13)).default);d.className="ql-syntax";var p=new i.default.Attributor.Class("token","hljs",{scope:i.default.Scope.INLINE}),h=function(t){function e(t,n){u(this,e);var r=c(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if("function"!=typeof r.options.highlight)throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");var o=null;return r.quill.on(l.default.events.SCROLL_OPTIMIZE,(function(){clearTimeout(o),o=setTimeout((function(){r.highlight(),o=null}),r.options.interval)})),r.highlight(),r}return f(e,t),r(e,null,[{key:"register",value:function(){l.default.register(p,!0),l.default.register(d,!0)}}]),r(e,[{key:"highlight",value:function(){var t=this;if(!this.quill.selection.composing){this.quill.update(l.default.sources.USER);var e=this.quill.getSelection();this.quill.scroll.descendants(d).forEach((function(e){e.highlight(t.options.highlight)})),this.quill.update(l.default.sources.SILENT),null!=e&&this.quill.setSelection(e,l.default.sources.SILENT)}}}]),e}(a.default);h.DEFAULTS={highlight:null==window.hljs?null:function(t){return window.hljs.highlightAuto(t).value},interval:1e3},e.CodeBlock=d,e.CodeToken=p,e.default=h},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>'},function(t,e){t.exports='<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>'},function(t,e){t.exports='<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>'},function(t,e){t.exports='<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>'},function(t,e){t.exports='<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>'},function(t,e){t.exports='<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=e.BubbleTooltip=void 0;var r=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if("value"in o)return o.value;var l=o.get;return void 0!==l?l.call(r):void 0},o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=f(n(3)),l=f(n(8)),a=n(43),s=f(a),u=n(15),c=f(n(41));function f(t){return t&&t.__esModule?t:{default:t}}function d(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function p(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function h(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var y=[["bold","italic","link"],[{header:1},{header:2},"blockquote"]],b=function(t){function e(t,n){d(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=y);var r=p(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add("ql-bubble"),r}return h(e,t),o(e,[{key:"extendToolbar",value:function(t){this.tooltip=new v(this.quill,this.options.bounds),this.tooltip.root.appendChild(t.container),this.buildButtons([].slice.call(t.container.querySelectorAll("button")),c.default),this.buildPickers([].slice.call(t.container.querySelectorAll("select")),c.default)}}]),e}(s.default);b.DEFAULTS=(0,i.default)(!0,{},s.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){t?this.quill.theme.tooltip.edit():this.quill.format("link",!1)}}}}});var v=function(t){function e(t,n){d(this,e);var r=p(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.on(l.default.events.EDITOR_CHANGE,(function(t,e,n,o){if(t===l.default.events.SELECTION_CHANGE)if(null!=e&&e.length>0&&o===l.default.sources.USER){r.show(),r.root.style.left="0px",r.root.style.width="",r.root.style.width=r.root.offsetWidth+"px";var i=r.quill.getLines(e.index,e.length);if(1===i.length)r.position(r.quill.getBounds(e));else{var a=i[i.length-1],s=r.quill.getIndex(a),c=Math.min(a.length()-1,e.index+e.length-s),f=r.quill.getBounds(new u.Range(s,c));r.position(f)}}else document.activeElement!==r.textbox&&r.quill.hasFocus()&&r.hide()})),r}return h(e,t),o(e,[{key:"listen",value:function(){var t=this;r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"listen",this).call(this),this.root.querySelector(".ql-close").addEventListener("click",(function(){t.root.classList.remove("ql-editing")})),this.quill.on(l.default.events.SCROLL_OPTIMIZE,(function(){setTimeout((function(){if(!t.root.classList.contains("ql-hidden")){var e=t.quill.getSelection();null!=e&&t.position(t.quill.getBounds(e))}}),1)}))}},{key:"cancel",value:function(){this.show()}},{key:"position",value:function(t){var n=r(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"position",this).call(this,t),o=this.root.querySelector(".ql-tooltip-arrow");if(o.style.marginLeft="",0===n)return n;o.style.marginLeft=-1*n-o.offsetWidth/2+"px"}}]),e}(a.BaseTooltip);v.TEMPLATE=['<span class="ql-tooltip-arrow"></span>','<div class="ql-tooltip-editor">','<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">','<a class="ql-close"></a>',"</div>"].join(""),e.BubbleTooltip=v,e.default=b},function(t,e,n){t.exports=n(63)}]).default},t.exports=e()},382:function(t,e,n){"use strict";n.r(e);var r=n(379),o=n.n(r),i=n(681);o()(i.Z,{insert:"head",singleton:!1}),e.default=i.Z.locals||{}},379:function(t,e,n){"use strict";var r,o=function(){var t={};return function(e){if(void 0===t[e]){var n=document.querySelector(e);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(t){n=null}t[e]=n}return t[e]}}(),i=[];function l(t){for(var e=-1,n=0;n<i.length;n++)if(i[n].identifier===t){e=n;break}return e}function a(t,e){for(var n={},r=[],o=0;o<t.length;o++){var a=t[o],s=e.base?a[0]+e.base:a[0],u=n[s]||0,c="".concat(s," ").concat(u);n[s]=u+1;var f=l(c),d={css:a[1],media:a[2],sourceMap:a[3]};-1!==f?(i[f].references++,i[f].updater(d)):i.push({identifier:c,updater:y(d,e),references:1}),r.push(c)}return r}function s(t){var e=document.createElement("style"),r=t.attributes||{};if(void 0===r.nonce){var i=n.nc;i&&(r.nonce=i)}if(Object.keys(r).forEach((function(t){e.setAttribute(t,r[t])})),"function"==typeof t.insert)t.insert(e);else{var l=o(t.insert||"head");if(!l)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");l.appendChild(e)}return e}var u,c=(u=[],function(t,e){return u[t]=e,u.filter(Boolean).join("\n")});function f(t,e,n,r){var o=n?"":r.media?"@media ".concat(r.media," {").concat(r.css,"}"):r.css;if(t.styleSheet)t.styleSheet.cssText=c(e,o);else{var i=document.createTextNode(o),l=t.childNodes;l[e]&&t.removeChild(l[e]),l.length?t.insertBefore(i,l[e]):t.appendChild(i)}}function d(t,e,n){var r=n.css,o=n.media,i=n.sourceMap;if(o?t.setAttribute("media",o):t.removeAttribute("media"),i&&"undefined"!=typeof btoa&&(r+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i))))," */")),t.styleSheet)t.styleSheet.cssText=r;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(r))}}var p=null,h=0;function y(t,e){var n,r,o;if(e.singleton){var i=h++;n=p||(p=s(e)),r=f.bind(null,n,i,!1),o=f.bind(null,n,i,!0)}else n=s(e),r=d.bind(null,n,e),o=function(){!function(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t)}(n)};return r(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;r(t=e)}else o()}}t.exports=function(t,e){(e=e||{}).singleton||"boolean"==typeof e.singleton||(e.singleton=(void 0===r&&(r=Boolean(window&&document&&document.all&&!window.atob)),r));var n=a(t=t||[],e);return function(t){if(t=t||[],"[object Array]"===Object.prototype.toString.call(t)){for(var r=0;r<n.length;r++){var o=l(n[r]);i[o].references--}for(var s=a(t,e),u=0;u<n.length;u++){var c=l(n[u]);0===i[c].references&&(i[c].updater(),i.splice(c,1))}n=s}}}},766:function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DrawManager=void 0;var r,o=n(161),i=n(928);!function(t){t.DRAW="DRAW",t.ERASE="ERASE"}(r||(r={}));var l=function(){function t(t){this.scale=o.DEFAULT_SCALE,this.drawSettings={lineWidth:o.DEFAULT_LINE_WIDTH,lineColor:o.DEFAULT_LINE_COLOR,mode:r.DRAW},this.handlePointerDown=this.handlePointerDown.bind(this),this.handlePointerUp=this.handlePointerUp.bind(this),this.handlePointerMove=this.handlePointerMove.bind(this),this.handlePointerOut=this.handlePointerOut.bind(this),this.initCanvas(t)}return t.prototype.initCanvas=function(t){this.canvas=document.querySelector(t),this.context=this.canvas.getContext("2d"),this.fillBackground(),this.isDrawing=!1,this.isDrawingDot=!1,this.pointerPosition={x:0,y:0},this.lastPosition=this.pointerPosition,this.addEventListeners()},t.prototype.destroy=function(){this.removeEventListeners()},t.prototype.setScale=function(t){this.scale=t},t.prototype.getImage=function(){return this.isBlank?"":this.getTrimmedByHeightImage()},t.prototype.setImage=function(t){var e=this,n=new Image;n.src=t,n.onload=function(){e.context.drawImage(n,0,0)}},t.prototype.setColor=function(t){this.drawSettings.mode=r.DRAW,this.canvas.classList.remove("is-erasing"),this.drawSettings.lineColor=t},t.prototype.setLineWidth=function(t){this.drawSettings.mode=r.DRAW,this.canvas.classList.remove("is-erasing"),this.drawSettings.lineWidth=t},t.prototype.erase=function(){this.drawSettings.mode=r.ERASE,this.canvas.classList.add("is-erasing")},Object.defineProperty(t.prototype,"lineWidth",{get:function(){var t=this.drawSettings,e=t.mode,n=t.lineWidth;return e===r.DRAW?n:o.DEFAULT_ERASE_WIDTH},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"lineColor",{get:function(){var t=this.drawSettings,e=t.mode,n=t.lineColor;return e===r.DRAW?n:o.BACKGROUND_COLOR},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isBlank",{get:function(){return new Uint32Array(this.context.getImageData(0,0,this.canvas.width,this.canvas.height).data.buffer).every((function(t){return t===o.BACKGROUND_COLOR_ABGR}))},enumerable:!1,configurable:!0}),t.prototype.getTrimmedByHeightImage=function(){for(var t=this.canvas,e=t.width,n=t.height,r=this.context.getImageData(0,0,e,n),l=i.getRGBValuesFromHexColor(o.BACKGROUND_COLOR),a=n;a-1>0&&this.isBlankRow(r,l,e,a-1);)a--;var s=this.context.getImageData(0,0,e,a),u=this.canvas.ownerDocument.createElement("canvas");return u.width=s.width,u.height=s.height,u.getContext("2d").putImageData(s,0,0),u.toDataURL("image/jpeg",1)},t.prototype.isBlankRow=function(t,e,n,r){for(var o=t.data,i=e[0],l=e[1],a=e[2],s=0;s<n;s++){var u=r*n*4;if(o[u+4*s]!==i||o[u+4*s+1]!==l||o[u+4*s+2]!==a)return!1}return!0},t.prototype.fillBackground=function(){this.context.fillStyle=o.BACKGROUND_COLOR,this.context.fillRect(0,0,this.canvas.width,this.canvas.height)},t.prototype.addEventListeners=function(){this.canvas.addEventListener("pointerdown",this.handlePointerDown),this.canvas.addEventListener("pointerup",this.handlePointerUp),this.canvas.addEventListener("pointermove",this.handlePointerMove),this.canvas.addEventListener("pointerout",this.handlePointerOut)},t.prototype.removeEventListeners=function(){this.canvas.removeEventListener("pointerdown",this.handlePointerDown),this.canvas.removeEventListener("pointerup",this.handlePointerUp),this.canvas.removeEventListener("pointermove",this.handlePointerMove),this.canvas.removeEventListener("pointerout",this.handlePointerOut)},t.prototype.handlePointerDown=function(t){this.isDrawing=!0,this.isDrawingDot=!0,this.lastPosition=this.getPointerPosition(t)},t.prototype.handlePointerUp=function(){this.isDrawing=!1,this.isDrawingDot&&this.drawDot()},t.prototype.handlePointerMove=function(t){this.isDrawingDot=!1,this.pointerPosition=this.getPointerPosition(t),this.isDrawing&&this.drawLine()},t.prototype.handlePointerOut=function(){this.isDrawing&&this.drawSettings.mode===r.DRAW&&(this.isDrawing=!1)},t.prototype.getPointerPosition=function(t){var e=this.canvas.getBoundingClientRect(),n=e.left,r=e.top;return{x:t.clientX-n,y:t.clientY-r}},t.prototype.drawLine=function(){this.context.strokeStyle=this.lineColor,this.context.beginPath(),this.context.lineJoin="round",this.context.lineWidth=this.lineWidth,this.context.moveTo(this.lastPosition.x*this.scale,this.lastPosition.y*this.scale),this.context.lineTo(this.pointerPosition.x*this.scale,this.pointerPosition.y*this.scale),this.context.closePath(),this.context.stroke(),this.lastPosition=this.pointerPosition},t.prototype.drawDot=function(){this.context.fillStyle=this.lineColor,this.context.beginPath(),this.context.arc(this.lastPosition.x*this.scale,this.lastPosition.y*this.scale,this.lineWidth/2,0,2*Math.PI),this.context.fill(),this.context.closePath(),this.isDrawingDot=!1},t}();e.DrawManager=l},161:function(t,e){"use strict";var n,r;Object.defineProperty(e,"__esModule",{value:!0}),e.BIG_DRAW_TOOLBAR_MEDIA_QUERY=e.DEFAULT_LINE_COLOR=e.DEFAULT_LINE_WIDTH=e.DEFAULT_ERASE_WIDTH=e.BACKGROUND_COLOR_ABGR=e.BACKGROUND_COLOR=e.DEFAULT_SCALE=e.CANVAS_ID=e.CANVAS_HEIGHT=e.CANVAS_WIDTH=e.LineColor=e.LineWidth=void 0,function(t){t[t.THIN=3]="THIN",t[t.MEDIUM=5]="MEDIUM",t[t.BOLD=7]="BOLD"}(n||(n={})),e.LineWidth=n,function(t){t.BLACK="#000",t.BLUE="#007dff",t.GREEN="#00db59",t.YELLOW="#ffcf00",t.RED="#ff0037"}(r||(r={})),e.LineColor=r,e.CANVAS_WIDTH=1024,e.CANVAS_HEIGHT=3072,e.CANVAS_ID="wp-notes-editor-canvas",e.BACKGROUND_COLOR="#ffffff",e.BACKGROUND_COLOR_ABGR=4294967295,e.DEFAULT_SCALE=1,e.DEFAULT_ERASE_WIDTH=25;var o=n.MEDIUM;e.DEFAULT_LINE_WIDTH=o;var i=r.BLACK;e.DEFAULT_LINE_COLOR=i,e.BIG_DRAW_TOOLBAR_MEDIA_QUERY="(min-width: 540px)"},153:function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DrawEditor=void 0;var r=n(766),o=n(41),i=n(161),l=n(928),a=n(254),s=function(){function t(t,e,n,r){this.parentElement=t,this.toolbarElement=e,this.init(n,r),this.handleResize=this.handleResize.bind(this)}return t.prototype.destroy=function(){this.removeEventListeners(),clearTimeout(this.scrollArrowTimer),this.drawManager.destroy()},t.prototype.toggleVisibility=function(t){var e=this;t?(l.showElement(this.wrapperElement),this.scaleCanvas(),this.addEventListeners(),!this.scrollArrow&&l.isTouchSupported()&&(this.renderScrollArrow(),this.scrollArrowTimer=window.setTimeout((function(){e.removeScrollArrow()}),5e3))):(l.hideElement(this.wrapperElement),this.removeEventListeners(),this.scrollArrow&&l.isTouchSupported()&&(this.removeScrollArrow(),clearTimeout(this.scrollArrowTimer))),this.toolbar.toggleVisibility(t)},t.prototype.getDataToSave=function(){return this.drawManager.getImage()},t.prototype.init=function(t,e){this.renderWrapper(t),this.renderScrollWrapper(),this.renderCanvasWrapper(),this.renderCanvas(),this.drawManager=new r.DrawManager("#"+i.CANVAS_ID),e&&this.drawManager.setImage(e),this.toolbar=new o.Toolbar(this.toolbarElement,this.drawManager,t)},t.prototype.addEventListeners=function(){window.visualViewport?window.visualViewport.addEventListener("resize",this.handleResize):window.addEventListener("resize",this.handleResize)},t.prototype.removeEventListeners=function(){window.visualViewport?window.visualViewport.removeEventListener("resize",this.handleResize):window.removeEventListener("resize",this.handleResize)},t.prototype.renderWrapper=function(t){this.wrapperElement=document.createElement("div"),this.wrapperElement.id="wp-draw-editor",t||l.hideElement(this.wrapperElement),this.parentElement.appendChild(this.wrapperElement)},t.prototype.renderScrollWrapper=function(){this.scrollWrapperElement=document.createElement("div"),this.scrollWrapperElement.className="wp-draw-editor-scroll-wrapper",this.wrapperElement.appendChild(this.scrollWrapperElement)},t.prototype.renderCanvasWrapper=function(){this.canvasWrapperElement=document.createElement("div"),this.canvasWrapperElement.className="wp-draw-editor-canvas-wrapper",this.scrollWrapperElement.appendChild(this.canvasWrapperElement)},t.prototype.renderCanvas=function(){this.canvasElement=document.createElement("canvas"),this.canvasElement.id=i.CANVAS_ID,this.canvasElement.width=i.CANVAS_WIDTH,this.canvasElement.height=i.CANVAS_HEIGHT,this.canvasElement.className="wp-draw-editor-canvas",this.canvasWrapperElement.appendChild(this.canvasElement)},t.prototype.renderScrollArrow=function(){this.scrollArrow=a.getSvgIcon("arrowDown","wp-draw-editor-scroll-arrow"),this.wrapperElement.appendChild(this.scrollArrow)},t.prototype.removeScrollArrow=function(){this.wrapperElement.removeChild(this.scrollArrow),this.scrollArrow=void 0},t.prototype.scaleCanvas=function(){var t=this.canvasWrapperElement.clientWidth/i.CANVAS_WIDTH;this.canvasWrapperElement.style.height=i.CANVAS_HEIGHT*t+"px",this.canvasElement.style.transform="scale("+t+")",this.drawManager.setScale(1/t)},t.prototype.handleResize=function(){this.scaleCanvas(),this.scrollWrapperElement.scrollTop=0},t}();e.DrawEditor=s},41:function(t,e,n){"use strict";var r;Object.defineProperty(e,"__esModule",{value:!0}),e.LineColor=e.LineWidth=e.Toolbar=void 0;var o=n(161);Object.defineProperty(e,"LineColor",{enumerable:!0,get:function(){return o.LineColor}}),Object.defineProperty(e,"LineWidth",{enumerable:!0,get:function(){return o.LineWidth}});var i=n(928),l=n(254),a=((r={})[o.LineWidth.THIN]="penThin",r[o.LineWidth.MEDIUM]="penMedium",r[o.LineWidth.BOLD]="penBold",r),s=function(){function t(t,e,n){this.toolbarElement=t,this.drawManager=e,this.init(n),this.toggleButtonsVisibility=this.toggleButtonsVisibility.bind(this),this.handleMenuClickOutside=this.handleMenuClickOutside.bind(this)}return t.prototype.toggleVisibility=function(t){t?(i.showElement(this.wrapperElement),this.toggleButtonsVisibility(),this.addEventListeners()):(i.hideElement(this.wrapperElement),this.removeEventListeners())},t.prototype.init=function(t){this.renderButtonsWrapper(t),this.renderLineWidthButtons(),this.renderEraseButton(),this.renderLineColorButtons()},t.prototype.addEventListeners=function(){window.visualViewport?window.visualViewport.addEventListener("resize",this.toggleButtonsVisibility):window.addEventListener("resize",this.toggleButtonsVisibility)},t.prototype.removeEventListeners=function(){window.visualViewport?window.visualViewport.removeEventListener("resize",this.toggleButtonsVisibility):window.removeEventListener("resize",this.toggleButtonsVisibility)},t.prototype.toggleButtonsVisibility=function(){var t=this,e=document.querySelectorAll(".wp-notes-editor-toolbar-button.is-line-width, .wp-notes-editor-toolbar-button.is-color"),n=document.querySelector(".wp-notes-editor-toolbar-button.is-erase");e.forEach((function(e){if(t.isBigToolbar)i.showElement(e);else{var r=e.classList.contains("is-line-width"),l=e.classList.contains("is-color");r&&(n.classList.contains("is-active")?+e.getAttribute("data-line-width")!==o.DEFAULT_LINE_WIDTH&&i.hideElement(e):e.classList.contains("is-active")||i.hideElement(e)),l&&(e.classList.contains("is-active")||i.hideElement(e))}})),this.isBigToolbar&&this.hideMenu()},t.prototype.renderButtonsWrapper=function(t){this.wrapperElement=document.createElement("div"),this.wrapperElement.className="wp-notes-editor-toolbar-buttons-wrapper",t||i.hideElement(this.wrapperElement),this.toolbarElement.appendChild(this.wrapperElement)},t.prototype.renderLineWidthButtons=function(){var t=this,e=document.createElement("div");e.className="wp-notes-editor-toolbar-buttons-group line-width-group",this.wrapperElement.appendChild(e),Object.values(o.LineWidth).reverse().filter((function(t){return"string"==typeof t})).forEach((function(n){var r=t.createLineWidthButton(o.LineWidth[n],!0);o.LineWidth[n]===o.DEFAULT_LINE_WIDTH&&r.classList.add("is-active"),r.addEventListener("click",(function(e){t.isBigToolbar?t.handleLineWidthButtonClick(e):t.renderLineWidthButtonsMenu(r)})),e.appendChild(r)}))},t.prototype.renderLineWidthButtonsMenu=function(t){var e=this,n=document.createElement("div");n.className="wp-notes-editor-toolbar-buttons-wrapper",Object.values(o.LineWidth).reverse().filter((function(t){return"string"==typeof t})).forEach((function(t){var r=e.createLineWidthButton(o.LineWidth[t]);o.LineWidth[t]===e.drawManager.lineWidth&&r.classList.add("is-active"),r.addEventListener("click",(function(t){return e.handleLineWidthButtonClick(t)})),n.appendChild(r)})),t===this.menuTriggerElement?this.hideMenu():this.showMenu(t,n,"is-line-width-menu")},t.prototype.createLineWidthButton=function(t,e){var n=document.createElement("button");if(n.type="button",n.className="wp-notes-editor-toolbar-button is-line-width",n.dataset.lineWidth=t.toString(),e){var r=l.getSvgIcon(a[t]);n.appendChild(r)}return n},t.prototype.handleLineWidthButtonClick=function(t){var e=t.target.dataset.lineWidth;this.drawManager.setLineWidth(+e);var n=this.wrapperElement.querySelectorAll(".wp-notes-editor-toolbar-button.is-line-width"),r=this.wrapperElement.querySelector(".wp-notes-editor-toolbar-button.is-erase");n.forEach((function(e){e===t.target?e.classList.add("is-active"):e.classList.remove("is-active")})),r.classList.remove("is-active"),this.isBigToolbar||(this.toolbarElement.querySelectorAll(".line-width-group .wp-notes-editor-toolbar-button").forEach((function(t){t.dataset.lineWidth===e?(i.showElement(t),t.classList.add("is-active")):(i.hideElement(t),t.classList.remove("is-active"))})),this.hideMenu())},t.prototype.renderEraseButton=function(){var t=this,e=document.createElement("button");e.type="button",e.className="wp-notes-editor-toolbar-button is-erase";var n=l.getSvgIcon("eraser");e.appendChild(n),e.addEventListener("click",(function(){t.drawManager.erase(),t.wrapperElement.querySelectorAll(".wp-notes-editor-toolbar-button.is-line-width").forEach((function(t){t.classList.remove("is-active")})),e.classList.add("is-active")})),this.wrapperElement.appendChild(e)},t.prototype.renderLineColorButtons=function(){var t=this,e=document.createElement("div");e.className="wp-notes-editor-toolbar-buttons-group color-group",this.wrapperElement.appendChild(e),Object.values(o.LineColor).forEach((function(n){var r=t.createLineColorButton(n);n===o.DEFAULT_LINE_COLOR&&r.classList.add("is-active"),r.addEventListener("click",(function(e){t.isBigToolbar?t.handleLineColorButtonClick(e):t.renderLineColorButtonsMenu(r)})),e.appendChild(r)}))},t.prototype.renderLineColorButtonsMenu=function(t){var e=this,n=document.createElement("div");n.className="wp-notes-editor-toolbar-buttons-wrapper",Object.values(o.LineColor).forEach((function(t){var r=e.createLineColorButton(t),i=e.drawManager.lineColor;(t===i||i===o.BACKGROUND_COLOR&&t===Array.from(e.toolbarElement.querySelectorAll(".color-group .wp-notes-editor-toolbar-button")).find((function(t){return t.classList.contains("is-active")})).dataset.lineColor)&&r.classList.add("is-active"),r.addEventListener("click",(function(t){return e.handleLineColorButtonClick(t)})),n.appendChild(r)})),t===this.menuTriggerElement?this.hideMenu():this.showMenu(t,n,"is-color-menu")},t.prototype.createLineColorButton=function(t){var e=document.createElement("button");return e.type="button",e.className="wp-notes-editor-toolbar-button is-color",e.dataset.lineColor=t,e.style.backgroundColor=t,e},t.prototype.handleLineColorButtonClick=function(t){var e=this,n=t.target.dataset.lineColor;this.drawManager.setColor(n);var r=this.toolbarElement.querySelectorAll(".wp-notes-editor-toolbar-button.is-color"),o=this.toolbarElement.querySelector(".wp-notes-editor-toolbar-button.is-erase"),l=this.toolbarElement.querySelectorAll(".wp-notes-editor-toolbar-button.is-line-width");r.forEach((function(t){t.dataset.lineColor===n?t.classList.add("is-active"):t.classList.remove("is-active")})),o.classList.remove("is-active"),l.forEach((function(t){+t.dataset.lineWidth===e.drawManager.lineWidth&&t.classList.add("is-active")})),this.isBigToolbar||(this.toolbarElement.querySelectorAll(".color-group .wp-notes-editor-toolbar-button.is-color").forEach((function(t){t.dataset.lineColor===n?i.showElement(t):i.hideElement(t)})),this.hideMenu())},t.prototype.showMenu=function(t,e,n){void 0===n&&(n=""),this.hideMenu(),this.menuTriggerElement=t,this.menuElement=document.createElement("div"),this.menuElement.className="wp-notes-editor-menu "+n,this.menuElement.style.left=t.offsetLeft-30+"px",this.menuElement.appendChild(e),this.toolbarElement.appendChild(this.menuElement),window.addEventListener("click",this.handleMenuClickOutside)},t.prototype.hideMenu=function(){this.menuElement&&(this.toolbarElement.removeChild(this.menuElement),this.menuElement=null,this.menuTriggerElement=null,window.removeEventListener("click",this.handleMenuClickOutside))},t.prototype.handleMenuClickOutside=function(t){t.target!==this.menuTriggerElement&&(this.menuElement.contains(t.target)||this.hideMenu())},Object.defineProperty(t.prototype,"isBigToolbar",{get:function(){return window.matchMedia(o.BIG_DRAW_TOOLBAR_MEDIA_QUERY).matches},enumerable:!1,configurable:!0}),t}();e.Toolbar=s},742:function(t,e,n){"use strict";var r;Object.defineProperty(e,"__esModule",{value:!0}),e.NotesEditor=void 0;var o,i=n(687),l=n(153),a=n(928),s=n(247),u=n(254);!function(t){t.TEXT="TEXT",t.DRAW="DRAW"}(o||(o={}));var c=o.TEXT,f=((r={})[o.TEXT]={className:"is-text-editor",icon:"textMode"},r[o.DRAW]={className:"is-draw-editor",icon:"drawMode"},r),d=function(){function t(t,e,n,r,o,i,l){void 0===i&&(i="en_UK"),this.parentElement=t,this.init(e,n,r,o,l),s.updateTranslations(i)}return t.prototype.destroy=function(){this.parentElement.removeChild(this.wrapperElement),this.drawEditor.destroy()},t.prototype.updateTranslations=function(t){s.updateTranslations(t)},t.prototype.getDataToSave=function(){return{text:this.textEditor.getDataToSave(),image:this.drawEditor.getDataToSave()}},t.prototype.init=function(t,e,n,r,o){this.renderWrapper(),this.renderToolbar(),this.renderTitleInput(t,e),this.renderModeToggle(),o&&this.renderCloseButton(o),this.textEditor=new i.TextEditor(this.wrapperElement,this.toolbarElement,!0,n),this.drawEditor=new l.DrawEditor(this.wrapperElement,this.toolbarElement,!1,r)},t.prototype.renderWrapper=function(){this.wrapperElement=document.createElement("div"),this.wrapperElement.id="wp-notes-editor",a.isTouchSupported()&&(this.wrapperElement.className="is-touch-supported"),this.parentElement.appendChild(this.wrapperElement)},t.prototype.renderToolbar=function(){this.toolbarElement=document.createElement("div"),this.toolbarElement.className="wp-notes-editor-toolbar "+f[c].className,this.toolbarActionsElement=document.createElement("div"),this.toolbarActionsElement.className="wp-notes-editor-toolbar-actions",this.toolbarElement.appendChild(this.toolbarActionsElement),this.wrapperElement.appendChild(this.toolbarElement)},t.prototype.renderModeToggle=function(){var t=this,e=document.createElement("div");e.className="wp-notes-editor-mode-wrapper",this.toolbarActionsElement.appendChild(e),Object.values(o).forEach((function(n){var r=document.createElement("button");r.type="button",r.className="wp-notes-editor-mode",n===c&&r.classList.add("is-active");var o=u.getSvgIcon(f[n].icon);r.appendChild(o),r.addEventListener("click",(function(r){e.querySelectorAll(".wp-notes-editor-mode").forEach((function(t){t===r.target?t.classList.add("is-active"):t.classList.remove("is-active")})),t.toggleMode(n)})),e.appendChild(r)}))},t.prototype.renderCloseButton=function(t){var e=document.createElement("button");e.type="button",e.className="wp-notes-editor-close-btn",e.addEventListener("click",t),this.toolbarActionsElement.appendChild(e)},t.prototype.renderTitleInput=function(t,e){void 0===e&&(e="Untitled note"),this.titleInputElement=document.createElement("input"),this.titleInputElement.type="text",this.titleInputElement.value=e,this.titleInputElement.className="wp-notes-editor-note-title",this.titleInputElement.addEventListener("input",(function(e){return t(e.target.value)})),this.toolbarElement.insertBefore(this.titleInputElement,this.toolbarElement.firstChild)},t.prototype.toggleTitleInputVisibility=function(t){t===o.TEXT?a.showElement(this.titleInputElement):a.hideElement(this.titleInputElement)},t.prototype.toggleMode=function(t){var e=this;Object.values(f).forEach((function(t){var n=t.className;e.toolbarElement.classList.remove(n)})),this.toolbarElement.classList.add(f[t].className),this.textEditor.toggleVisibility(t===o.TEXT),this.drawEditor.toggleVisibility(t===o.DRAW),this.toggleTitleInputVisibility(t)},t}();e.NotesEditor=d},687:function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.TextEditor=void 0;var o=r(n(95)),i=n(928),l=function(){function t(t,e,n,r){this.parentElement=t,this.toolbarElement=e,this.init(n,r)}return t.prototype.toggleVisibility=function(t){t?(i.showElement(this.wrapperElement),i.showElement(this.quillToolbarElement)):(i.hideElement(this.wrapperElement),i.hideElement(this.quillToolbarElement))},t.prototype.getDataToSave=function(){var t=this.quill.getText(),e=this.quill.getContents(),n=1===t.length;return{plainText:n?"":t.replace(/\n/g," ").trim(),formattedText:n?"":JSON.stringify(e)}},t.prototype.init=function(t,e){this.renderWrapper(t),this.initQuill(e),this.renderToolbar(t)},t.prototype.initQuill=function(t){this.quill=new o.default("#wp-text-editor",{modules:{toolbar:[["bold","italic","underline"],[{color:[]},{background:[]}],[{font:[]},{size:["small",!1,"large","huge"]}],[{list:"ordered"},{list:"bullet"}],[{align:[]}],["clean"]]},theme:"snow"}),t&&this.quill.setContents(JSON.parse(t))},t.prototype.renderWrapper=function(t){this.wrapperElement=document.createElement("div"),this.wrapperElement.id="wp-text-editor",t||i.hideElement(this.wrapperElement),this.parentElement.appendChild(this.wrapperElement)},t.prototype.renderToolbar=function(t){this.quillToolbarElement=document.querySelector(".ql-toolbar"),t||i.hideElement(this.quillToolbarElement),this.toolbarElement.appendChild(this.quillToolbarElement)},t}();e.TextEditor=l},247:function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.updateTranslations=void 0,e.updateTranslations=function(t){document.querySelector("#wp-notes-editor").classList.add(""+t.substring(0,2))}},254:function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getSvgIcon=void 0;var n={arrowDown:{viewBox:"0 0 30 30",width:"30",height:"30",content:'<path d="M30,8.9c0,0.6-0.2,0.9-0.6,1.3L16.3,23.4c-0.8,0.7-1.9,0.7-2.6,0L0.6,10.3c-0.8-0.7-0.8-1.9,0-2.6s1.9-0.7,2.6,0L15,19.4\n\t\tL26.8,7.6c0.8-0.7,1.9-0.7,2.6,0C29.8,8,30,8.4,30,8.9z"/>'},drawMode:{viewBox:"0 0 32 32",width:"32",height:"32",content:'<path d="M15.813 0c8.733 0 15.812 7.08 15.812 15.813s-7.08 15.812-15.813 15.812S0 24.545 0 15.812 7.08 0 15.813 0zm2.467 18.328h-5.657c-.236 0-.44.165-.489.395L10.1 28.22c1.738.802 3.673 1.249 5.713 1.249 1.759 0 3.44-.333 4.985-.939l-2.028-9.803c-.048-.232-.253-.399-.49-.399zM15.812 2.156C8.27 2.156 2.156 8.27 2.156 15.812c0 4.85 2.529 9.11 6.339 11.533l.13-.392 1.913-8.926c.142-.663.728-1.136 1.405-1.136h.276l1.833-7.946c.179-.774.95-1.256 1.724-1.078.536.124.954.542 1.078 1.078l1.834 7.946h.275c.678 0 1.263.473 1.405 1.136l1.913 8.926.196.782c4.172-2.337 6.992-6.8 6.992-11.922 0-7.543-6.114-13.657-13.657-13.657z"/>'},eraser:{viewBox:"0 0 30 66",width:"30",height:"66",content:'<defs>\n\t\t\t<linearGradient id="7nfweohfcc" x1="43.388%" x2="56.173%" y1="100%" y2="3.128%">\n\t\t\t\t<stop offset="0%"/>\n\t\t\t\t<stop offset="57.879%"/>\n\t\t\t\t<stop offset="100%" stop-color="#7E7E7E"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="2s4vfte0qd" x1="100%" x2="0%" y1="40.708%" y2="40.708%">\n\t\t\t\t<stop offset="0%" stop-color="#DADADA"/>\n\t\t\t\t<stop offset="14.695%" stop-color="#F5F5F5"/>\n\t\t\t\t<stop offset="44.51%" stop-color="#FAF7F7"/>\n\t\t\t\t<stop offset="74.988%" stop-color="#E1E1E1"/>\n\t\t\t\t<stop offset="86.083%" stop-color="#DCDDDC"/>\n\t\t\t\t<stop offset="97.354%" stop-color="#E4E4E4"/>\n\t\t\t\t<stop offset="100%" stop-color="#E4E4E4"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="t7yxh7ey0e" x1="100%" x2="0%" y1="56.785%" y2="56.785%">\n\t\t\t\t<stop offset="0%" stop-color="#D8918F"/>\n\t\t\t\t<stop offset="25.026%" stop-color="#F79E9D"/>\n\t\t\t\t<stop offset="48.606%" stop-color="#F79E9D"/>\n\t\t\t\t<stop offset="83.794%" stop-color="#D9807F"/>\n\t\t\t\t<stop offset="100%" stop-color="#DB9191"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="lb6zriw85g" x1="50%" x2="50%" y1="0%" y2="7.756%">\n\t\t\t\t<stop offset="0%" stop-color="#D27977"/>\n\t\t\t\t<stop offset="100%" stop-color="#525252" stop-opacity="0"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="x84q161gxj" x1="100%" x2="0%" y1="40.708%" y2="40.708%">\n\t\t\t\t<stop offset="0%" stop-color="#DADADA"/>\n\t\t\t\t<stop offset="16.9%" stop-color="#F5F5F5"/>\n\t\t\t\t<stop offset="44.51%" stop-color="#FAF7F7"/>\n\t\t\t\t<stop offset="74.988%" stop-color="#E1E1E1"/>\n\t\t\t\t<stop offset="91.178%" stop-color="#DCDDDC"/>\n\t\t\t\t<stop offset="97.354%" stop-color="#E4E4E4"/>\n\t\t\t\t<stop offset="100%" stop-color="#E4E4E4"/>\n\t\t\t</linearGradient>\n\t\t\t<path id="o2mou1ripa" d="M0 -7H30V98H0z"/>\n\t\t\t<path id="yg6bfjih3f" d="M3 0h10c1.657 0 3 1.343 3 3v21H0V3c0-1.657 1.343-3 3-3z"/>\n\t\t\t<path id="3k2qp1q15i" d="M16 13v14H0V13h16zm-4.701 3.906c-.32-.32-.84-.32-1.16 0l-1.895 1.895L6.542 17.1c-.342-.342-.896-.342-1.238 0-.342.342-.342.896 0 1.237l1.702 1.702-1.894 1.895c-.32.32-.32.84 0 1.16.32.321.84.321 1.16 0L8.167 21.2 9.869 22.9c.341.342.895.342 1.237 0 .342-.342.342-.896 0-1.237L9.404 19.96l1.895-1.894c.32-.32.32-.84 0-1.16z"/>\n\t\t\t<filter id="w3jslsxg3h" width="101.2%" height="102.9%" x="-.6%" y="-.7%" filterUnits="objectBoundingBox">\n\t\t\t\t<feOffset dy=".2" in="SourceAlpha" result="shadowOffsetOuter1"/>\n\t\t\t\t<feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\n\t\t\t</filter>\n\t\t</defs>\n\t\t<g fill="none" fill-rule="evenodd">\n\t\t\t<g>\n\t\t\t\t<mask id="g3hr2b9uub" fill="#fff">\n\t\t\t\t\t<use xlink:href="#o2mou1ripa"/>\n\t\t\t\t</mask>\n\t\t\t\t<g mask="url(#g3hr2b9uub)">\n\t\t\t\t\t<g transform="translate(8 9)">\n\t\t\t\t\t\t<rect width="4" height="11" x="6" y="11" fill="url(#7nfweohfcc)" rx="2"/>\n\t\t\t\t\t\t<path fill="url(#2s4vfte0qd)" d="M4.5 1h7c.552 0 1 .448 1 1v4.086c0 .859.221 1.703.642 2.451l2.216 3.94c.42.749.642 1.593.642 2.451V57H0V14.928c0-.858.221-1.702.642-2.45l2.216-3.94c.42-.75.642-1.593.642-2.452V2c0-.552.448-1 1-1z"/>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<use fill="url(#t7yxh7ey0e)" xlink:href="#yg6bfjih3f"/>\n\t\t\t\t\t\t\t<use fill="url(#lb6zriw85g)" xlink:href="#yg6bfjih3f"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<use fill="#000" filter="url(#w3jslsxg3h)" xlink:href="#3k2qp1q15i"/>\n\t\t\t\t\t\t\t<use fill="url(#x84q161gxj)" xlink:href="#3k2qp1q15i"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>'},penBold:{viewBox:"0 0 30 66",width:"30",height:"66",content:'<defs>\n\t\t\t<linearGradient id="tabbhj8dld" x1="31.065%" x2="67.678%" y1="100%" y2="3.128%">\n\t\t\t\t<stop offset="0%"/>\n\t\t\t\t<stop offset="23.485%"/>\n\t\t\t\t<stop offset="100%" stop-color="#7E7E7E"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="604suk65ue" x1="100%" x2="0%" y1="40.708%" y2="40.708%">\n\t\t\t\t<stop offset="0%" stop-color="#DADADA"/>\n\t\t\t\t<stop offset="14.695%" stop-color="#F5F5F5"/>\n\t\t\t\t<stop offset="44.51%" stop-color="#FAF7F7"/>\n\t\t\t\t<stop offset="74.988%" stop-color="#E1E1E1"/>\n\t\t\t\t<stop offset="86.083%" stop-color="#DCDDDC"/>\n\t\t\t\t<stop offset="97.354%" stop-color="#E4E4E4"/>\n\t\t\t\t<stop offset="100%" stop-color="#E4E4E4"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="1e4y2s0n5f" x1="0%" x2="100%" y1="50%" y2="50%">\n\t\t\t\t<stop offset="0%" stop-color="#DBB32A"/>\n\t\t\t\t<stop offset="28.494%" stop-color="#EBC53F"/>\n\t\t\t\t<stop offset="51.208%" stop-color="#FAD65B"/>\n\t\t\t\t<stop offset="78.592%" stop-color="#FCD757"/>\n\t\t\t\t<stop offset="100%" stop-color="#E1BC3C"/>\n\t\t\t</linearGradient>\n\t\t\t<filter id="dkvh97levc" width="200%" height="161.5%" x="-50%" y="-30.8%" filterUnits="objectBoundingBox">\n\t\t\t\t<feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>\n\t\t\t\t<feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1"/>\n\t\t\t\t<feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.254261364 0"/>\n\t\t\t\t<feMerge>\n\t\t\t\t\t<feMergeNode in="shadowMatrixOuter1"/>\n\t\t\t\t\t<feMergeNode in="SourceGraphic"/>\n\t\t\t\t</feMerge>\n\t\t\t</filter>\n\t\t\t<path id="95bssnf1xa" d="M0 0H30V105H0z"/>\n\t\t</defs>\n\t\t<g fill="none" fill-rule="evenodd">\n\t\t\t<g>\n\t\t\t\t<mask id="e746gslvsb" fill="#fff">\n\t\t\t\t\t<use xlink:href="#95bssnf1xa"/>\n\t\t\t\t</mask>\n\t\t\t\t<g mask="url(#e746gslvsb)">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<g fill="url(#tabbhj8dld)" filter="url(#dkvh97levc)" transform="translate(7 9) translate(4)">\n\t\t\t\t\t\t\t\t<path d="M.055 6.39C.61 5.313 1.391 4.365 2.4 3.545 3.343 2.78 4.96 1.74 7.251.425c.24-.137.545-.054.683.186.043.075.066.161.066.248V13H0V6.62c0-.08.019-.159.055-.23z"/>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t<path fill="url(#604suk65ue)" d="M4.5 8h7c.552 0 1 .448 1 1v4.086c0 .859.221 1.703.642 2.451l2.216 3.94c.42.749.642 1.593.642 2.451V57H0V21.928c0-.858.221-1.702.642-2.45l2.216-3.94c.42-.75.642-1.593.642-2.452V9c0-.552.448-1 1-1z" transform="translate(7 9)"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t\t<path fill="url(#1e4y2s0n5f)" d="M0 24H16V27H0z" transform="translate(7 9)"/>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>'},penMedium:{viewBox:"0 0 30 66",width:"30",height:"66",content:'<defs>\n\t\t\t<linearGradient id="s6v7fmxp9c" x1="35.124%" x2="63.889%" y1="100%" y2="3.128%">\n\t\t\t\t<stop offset="0%"/>\n\t\t\t\t<stop offset="57.879%"/>\n\t\t\t\t<stop offset="100%" stop-color="#7E7E7E"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="sk77f3u02d" x1="100%" x2="0%" y1="40.708%" y2="40.708%">\n\t\t\t\t<stop offset="0%" stop-color="#DADADA"/>\n\t\t\t\t<stop offset="14.695%" stop-color="#F5F5F5"/>\n\t\t\t\t<stop offset="44.51%" stop-color="#FAF7F7"/>\n\t\t\t\t<stop offset="74.988%" stop-color="#E1E1E1"/>\n\t\t\t\t<stop offset="86.083%" stop-color="#DCDDDC"/>\n\t\t\t\t<stop offset="97.354%" stop-color="#E4E4E4"/>\n\t\t\t\t<stop offset="100%" stop-color="#E4E4E4"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="wajppj3a4e" x1="0%" x2="100%" y1="50%" y2="50%">\n\t\t\t\t<stop offset="0%" stop-color="#DBB32A"/>\n\t\t\t\t<stop offset="28.494%" stop-color="#EBC53F"/>\n\t\t\t\t<stop offset="51.208%" stop-color="#FAD65B"/>\n\t\t\t\t<stop offset="78.592%" stop-color="#FCD757"/>\n\t\t\t\t<stop offset="100%" stop-color="#E1BC3C"/>\n\t\t\t</linearGradient>\n\t\t\t<path id="avt2rr451a" d="M0 0H30V105H0z"/>\n\t\t</defs>\n\t\t<g fill="none" fill-rule="evenodd">\n\t\t\t<g>\n\t\t\t\t<mask id="cqac48i6ob" fill="#fff">\n\t\t\t\t\t<use xlink:href="#avt2rr451a"/>\n\t\t\t\t</mask>\n\t\t\t\t<g mask="url(#cqac48i6ob)">\n\t\t\t\t\t<g transform="translate(7 10)">\n\t\t\t\t\t\t<rect width="6" height="11" x="5" fill="url(#s6v7fmxp9c)" rx="1"/>\n\t\t\t\t\t\t<path fill="url(#sk77f3u02d)" d="M4.5 7h7c.552 0 1 .448 1 1v4.086c0 .859.221 1.703.642 2.451l2.216 3.94c.42.749.642 1.593.642 2.451V56H0V20.928c0-.858.221-1.702.642-2.45l2.216-3.94c.42-.75.642-1.593.642-2.452V8c0-.552.448-1 1-1z"/>\n\t\t\t\t\t\t<path fill="url(#wajppj3a4e)" d="M0 23H16V26H0z"/>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>'},penThin:{viewBox:"0 0 30 66",width:"30",height:"66",content:'<defs>\n\t\t\t<linearGradient id="fmz7hgfufc" x1="43.388%" x2="56.173%" y1="100%" y2="3.128%">\n\t\t\t\t<stop offset="0%"/>\n\t\t\t\t<stop offset="57.879%"/>\n\t\t\t\t<stop offset="100%" stop-color="#7E7E7E"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="ou9gq0igvd" x1="100%" x2="0%" y1="40.708%" y2="40.708%">\n\t\t\t\t<stop offset="0%" stop-color="#DADADA"/>\n\t\t\t\t<stop offset="14.695%" stop-color="#F5F5F5"/>\n\t\t\t\t<stop offset="44.51%" stop-color="#FAF7F7"/>\n\t\t\t\t<stop offset="74.988%" stop-color="#E1E1E1"/>\n\t\t\t\t<stop offset="86.083%" stop-color="#DCDDDC"/>\n\t\t\t\t<stop offset="97.354%" stop-color="#E4E4E4"/>\n\t\t\t\t<stop offset="100%" stop-color="#E4E4E4"/>\n\t\t\t</linearGradient>\n\t\t\t<linearGradient id="z5w0tdl7ge" x1="0%" x2="100%" y1="50%" y2="50%">\n\t\t\t\t<stop offset="0%" stop-color="#DBB32A"/>\n\t\t\t\t<stop offset="28.494%" stop-color="#EBC53F"/>\n\t\t\t\t<stop offset="51.208%" stop-color="#FAD65B"/>\n\t\t\t\t<stop offset="78.592%" stop-color="#FCD757"/>\n\t\t\t\t<stop offset="100%" stop-color="#E1BC3C"/>\n\t\t\t</linearGradient>\n\t\t\t<path id="n8osxbtwca" d="M0 0H30V105H0z"/>\n\t\t</defs>\n\t\t<g fill="none" fill-rule="evenodd">\n\t\t\t<g>\n\t\t\t\t<mask id="3vmi2htz4b" fill="#fff">\n\t\t\t\t\t<use xlink:href="#n8osxbtwca"/>\n\t\t\t\t</mask>\n\t\t\t\t<g mask="url(#3vmi2htz4b)">\n\t\t\t\t\t<g transform="translate(7 9)">\n\t\t\t\t\t\t<rect width="4" height="11" x="6" fill="url(#fmz7hgfufc)" rx="2"/>\n\t\t\t\t\t\t<path fill="url(#ou9gq0igvd)" d="M5.356 7h5.288c.493 0 .912.359.988.846l.729 4.658c.092.59.289 1.158.581 1.678l2.416 4.295c.42.749.642 1.593.642 2.451V57H0V20.928c0-.858.221-1.702.642-2.45l2.416-4.296c.292-.52.49-1.088.581-1.678l.729-4.658c.076-.487.495-.846.988-.846z"/>\n\t\t\t\t\t\t<path fill="url(#z5w0tdl7ge)" d="M0 23H16V26H0z"/>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t\t'},textMode:{viewBox:"0 0 32 32",width:"32",height:"32",content:'<g><path d="M22.9,13.4c-0.5-0.3-1.1-0.4-2-0.4h-1.4v1.5h1.2c0.4,0,0.8,0.1,1,0.2c0.2,0.1,0.4,0.3,0.4,0.5   c0.1,0.2,0.1,0.5,0.1,0.8c-0.5-0.3-1.1-0.4-1.8-0.4c-0.9,0-1.5,0.2-2,0.7c-0.5,0.4-0.7,1-0.7,1.8c0,0.8,0.2,1.4,0.7,1.8   c0.5,0.4,1.1,0.7,1.9,0.7c0.4,0,0.7-0.1,1-0.2c0.3-0.1,0.6-0.3,1-0.6v0.7h1.8v-4.3c0-0.7-0.1-1.2-0.2-1.6   C23.7,14,23.4,13.7,22.9,13.4z M22.3,18.4c-0.6,0.5-1.1,0.7-1.7,0.7c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.9   c0-0.4,0.1-0.7,0.4-0.9c0.2-0.2,0.6-0.3,1-0.3c0.5,0,1,0.1,1.4,0.4V18.4z"/><path d="M11.1,10.3L7.5,20.4h1.8l0.9-2.5h4l0.9,2.5H17l-3.6-10.1H11.1z M10.8,16.3l1.4-4.1l1.5,4.1H10.8z"/><path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2 s14,6.3,14,14S23.7,30,16,30z"/></g>'}};e.getSvgIcon=function(t,e){var r=n[t],o=r.viewBox,i=r.width,l=r.height,a=r.content,s=document.createElementNS("http://www.w3.org/2000/svg","svg");return s.setAttribute("viewBox",o),s.setAttribute("width",i),s.setAttribute("height",l),s.innerHTML=a,e&&s.classList.add(e),s}},928:function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.hideElement=e.showElement=e.getRGBValuesFromHexColor=e.isTouchSupported=void 0,e.isTouchSupported=function(){return"ontouchstart"in window||navigator.maxTouchPoints>0||navigator.msMaxTouchPoints>0},e.getRGBValuesFromHexColor=function(t){return[parseInt(t.substring(1,3),16),parseInt(t.substring(3,5),16),parseInt(t.substring(5,7),16)]},e.showElement=function(t){t.removeAttribute("hidden")},e.hideElement=function(t){t.setAttribute("hidden","true")}},387:function(t){"use strict";t.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEWSURBVEhLrZExTsNAFAUdIaWKKCASbVpqSg6QI9AnV6Cg5TgcgGskghYhORKiQkpNkzDP2Y/seL279nqkUWzv9/wouSjymOIt/jpHZY1feMQffMDReMLDsYbucaXDXFpxQ88xa0ln3NA5DloSjRuaw15LkuOG5vFeL8foHTd476UqBBgcF7y7qyod5MY/8VkhH7nxdyzxBluMFV9gC8U1NPRPjcb/w/XrFJhPjxu+Zz6YC8aX2BkKnQnOg3Hx6mY7Yca7hOfRuPhw80GYayzhPikuHvHbvReEuWoJn8lxcYkbLKtKBOZkcty4wi0Gl3De65ufc41v6F3C86y4MUeF7KeoOyg+cZ91Znh3umygxfvTZSpF8QcsEJ5rypCADgAAAABJRU5ErkJggg=="},500:function(t){"use strict";t.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAExSURBVEhL7ZU9TsMwGIYT7sAROnEGrsEKQ4VgYawysDEwIqEsXXsIhEBiyZqpEgoX4AQMtOInfV73cxRUBbDrgYFXeuTfPI7tqM0SZmRl8pzCE7Qwh0NIlit4gXFrob6AC9g6kktYm7sLfVpkDNFxb26yBipn7oW+R4hKJ/ehvbEIbRF88RtyH/q7RSiPIXgHg3IfxrVIrXkQdAc/yn2YJy710G8TIteb/8u/RvPg78jPYWnPfxvmBct34BlMMRzmBMuVfXgD/dwO7oKxKLlyDbeSVFU1o75wxl7oi5a74ynLcmqutiiKM/q6RahHyxV3PE3THOB6hU+THoHKJUTLFR3P3bqa7cJJnucPlB+gi59AdPzXcwP38G5tLaqdaXyr6E9Bx5BU2k8Oe5BUuk6WrQD6NzRJA3TpOwAAAABJRU5ErkJggg=="}},e={};function n(r){var o=e[r];if(void 0!==o)return o.exports;var i=e[r]={id:r,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.exports}n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,{a:e}),e},n.d=function(t,e){for(var r in e)n.o(e,r)&&!n.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:e[r]})},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var r={};return function(){"use strict";var t=r;Object.defineProperty(t,"__esModule",{value:!0}),t.NotesEditor=void 0,n(382);var e=n(742);Object.defineProperty(t,"NotesEditor",{enumerable:!0,get:function(){return e.NotesEditor}})}(),r}()}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213).Buffer))

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: auto;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 3;\n\theight: calc(100vh - ", ");\n\n\t", "\n\n\t", "\n\n\t#wp-notes-editor {\n\t\tpadding-top: 10px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: auto;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 3;\n\theight: calc(100vh - ", ");\n\n\t",
    "\n\n\t",
    "\n\n\t#wp-notes-editor {\n\t\tpadding-top: 10px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\theight: calc(100vh - " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */] + " - " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ");\n\t", __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortrait + " and (max-aspect-ratio: 1/2) {\n\t\t\theight: calc(100vh - " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */] + " - " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ");\n\t\t}\n\t");

var templateObject_1;


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CoverImagePanel__ = __webpack_require__(1348);


var mapStateToProps = function (state) {
    var _a = state.coverImagePanel, driveItem = _a.driveItem, isDisplayed = _a.isDisplayed, byId = state.importManager.byId;
    return {
        driveItem: driveItem,
        isDisplayed: isDisplayed,
        isImportingFile: !!byId[__WEBPACK_IMPORTED_MODULE_1__components_CoverImagePanel__["b" /* importManagerId */]],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CoverImagePanel__["a" /* default */]));


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return importManagerId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ResourceSelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_CoverImagePanel_actions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_api__ = __webpack_require__(10);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var importManagerId = 'cover-image';
var isDefaultCover = function (driveItem) {
    if (!driveItem) {
        return true;
    }
    var icon = driveItem.icon, src = driveItem.src;
    return !icon || Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(src) === Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["u" /* getNumberFromString */])(icon);
};
var CoverImagePanel = function (_a) {
    var driveItem = _a.driveItem, isDisplayed = _a.isDisplayed, isImportingFile = _a.isImportingFile, dispatch = _a.dispatch;
    var popupFooter = isDefaultCover(driveItem) || isImportingFile
        ? undefined
        : {
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.reset_to_default'),
            onAccept: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_CoverImagePanel_actions__["b" /* changeCoverImage */])(-1)); },
        };
    var handleCancelClick = function () {
        if (isImportingFile) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId));
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_CoverImagePanel_actions__["c" /* closeCoverImagePanel */])());
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.change_cover_image'), footer: popupFooter, onCancel: handleCancelClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* PopupBodyWrapper */], { hasFooter: !!popupFooter },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ResourceSelector__["a" /* default */], { id: importManagerId, fileExtensions: __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].imageWithGifExtensions, isFileExtensionsDisplayed: false, isValidResourceFromApp: function (_a) {
                    var type = _a.type;
                    return type === __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].DriveItemType.Image;
                }, onSelect: function (_a) {
                    var _b = __read(_a, 1), resource = _b[0];
                    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_CoverImagePanel_actions__["b" /* changeCoverImage */])(resource.id));
                }, isOptimizedImageImport: true }))));
};
/* harmony default export */ __webpack_exports__["a"] = (CoverImagePanel);


/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopupBodyWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceSelector_ProgressBar_styles__ = __webpack_require__(354);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var PopupBodyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\n\t", " li:not(:last-child) {\n\t\tmargin-bottom: 0;\n\n\t\t", " {\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t}\n\t}\n\n\t", " {\n\t\theight: 50px;\n\t\tborder-radius: 0;\n\t\tline-height: 50px;\n\t\tcolor: ", ";\n\t}\n\n\t", " {\n\t\tmargin: 20px;\n\t}\n\n\t", " {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\t", "\n\n\t", " li:not(:last-child) {\n\t\tmargin-bottom: 0;\n\n\t\t", " {\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t}\n\t}\n\n\t", " {\n\t\theight: 50px;\n\t\tborder-radius: 0;\n\t\tline-height: 50px;\n\t\tcolor: ", ";\n\t}\n\n\t", " {\n\t\tmargin: 20px;\n\t}\n\n\t", " {\n\t\tbackground-color: ", ";\n\t}\n"])), function (_a) {
    var hasFooter = _a.hasFooter;
    return !hasFooter && 'margin-bottom: 10px;';
}, __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__["b" /* ButtonsList */], __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__["a" /* Button */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_2__ResourceSelector_styles__["a" /* Button */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_3__ResourceSelector_ProgressBar_styles__["f" /* Wrapper */], __WEBPACK_IMPORTED_MODULE_3__ResourceSelector_ProgressBar_styles__["a" /* Bar */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey100);

var templateObject_1;


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DownloadGroupToast__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__ = __webpack_require__(28);




var mapStateToProps = function (state) {
    var downloadManager = state.downloadManager, _a = state.downloadManager, isDownloadToastClosed = _a.isDownloadToastClosed, downloadGroups = _a.downloadGroups, pendingSelectedDownloads = _a.pendingSelectedDownloads, totalSelectedDownloadsCount = _a.totalSelectedDownloadsCount, driveList = state.driveList, _b = state.galleryInfos.config, applicationGallery = _b.applicationGallery, importantAssets = _b.importantAssets;
    var pendingSelectedDownloadsCount = Object.keys(pendingSelectedDownloads).length;
    var isDownloadGroupStarted = [
        downloadGroups.all.status,
        downloadGroups.important.status,
        downloadGroups.selected.status,
    ].includes(__WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started);
    var enabledImportantTags = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getEnabledImportantTags(importantAssets);
    var downloadingGroup = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getDownloadingGroup(downloadGroups);
    var startedDownloadGroup = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getStartedDownloadGroup(downloadGroups);
    var isDownloading = downloadingGroup !== null;
    var loaderStepTagParam = downloadingGroup === __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT ? enabledImportantTags : [];
    var loaderStep = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getGalleryLoaderStep(downloadManager, driveList, applicationGallery, isDownloading, loaderStepTagParam);
    var isDownloadingSelectedGroup = downloadingGroup === __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED;
    var downloadedCount;
    var totalCount;
    if (isDownloadingSelectedGroup) {
        downloadedCount = totalSelectedDownloadsCount - pendingSelectedDownloadsCount;
        totalCount = totalSelectedDownloadsCount;
    }
    else if (loaderStep) {
        downloadedCount = loaderStep.itemsDownloaded;
        totalCount = loaderStep.itemsToDownload;
    }
    else {
        downloadedCount = 0;
        totalCount = 0;
    }
    // Show widget if download group is started
    var isDisplayed = (isDownloadGroupStarted && !isDownloadToastClosed);
    return {
        isDisplayed: isDisplayed,
        downloadedItems: downloadedCount,
        totalItems: totalCount,
        startedDownloadGroup: startedDownloadGroup,
        isCheckingForUpdates: totalCount > 0 && totalCount === downloadedCount && !isDownloadingSelectedGroup && isDownloadGroupStarted,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    dispatch: dispatch,
}); };
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DownloadGroupToast__["a" /* default */]));


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DownloadGroupToast_Content__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions_download__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DownloadManager_actions_store__ = __webpack_require__(112);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var DownloadGroupToast = function (_a) {
    var isDisplayed = _a.isDisplayed, downloadedItems = _a.downloadedItems, totalItems = _a.totalItems, dispatch = _a.dispatch, startedDownloadGroup = _a.startedDownloadGroup, isCheckingForUpdates = _a.isCheckingForUpdates;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](true), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* Wrapper */], { isDisplayed: isDisplayed },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], { isToastExpanded: isExpanded, onToggle: function () { return setIsExpanded(!isExpanded); }, downloadedItems: downloadedItems, totalItems: totalItems, onClose: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DownloadManager_actions__["b" /* closeDownloadGroupToast */])()); }, isCheckingForUpdates: isCheckingForUpdates }),
        isExpanded &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_DownloadGroupToast_Content__["a" /* default */], { onContinueClick: function () {
                    switch (startedDownloadGroup) {
                        case __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DownloadManager_actions__["f" /* downloadImportantAssets */])());
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].ALL:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DownloadManager_actions__["e" /* downloadAll */])());
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions_download__["d" /* downloadSelectedAssets */])());
                            break;
                        default:
                            break;
                    }
                }, onCancelClick: function () {
                    switch (startedDownloadGroup) {
                        case __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_DownloadManager_actions_store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT));
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].ALL:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_DownloadManager_actions_store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].ALL));
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5__containers_DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED:
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_DownloadManager_actions_store__["o" /* resetSelectedDownloadItems */])());
                            break;
                        default:
                            break;
                    }
                }, isCheckingForUpdates: isCheckingForUpdates })));
};
/* harmony default export */ __webpack_exports__["a"] = (DownloadGroupToast);


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var Header = function (_a) {
    var isToastExpanded = _a.isToastExpanded, downloadedItems = _a.downloadedItems, totalItems = _a.totalItems, onToggle = _a.onToggle, onClose = _a.onClose, isCheckingForUpdates = _a.isCheckingForUpdates;
    var title = '';
    if (totalItems === 0) {
        title = 'messages.downloading';
    }
    else if (isCheckingForUpdates) {
        title = 'messages.download_manager';
    }
    else {
        title = 'messages.download_toast_status';
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* StyledHeader */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* Title */], { value: title, downloadedItems: downloadedItems, totalItems: totalItems }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* Toggle */], { type: "button", isExpanded: isToastExpanded, onClick: onToggle }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_down')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ButtonClose */], { type: "button", onClick: onClose }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_close-2'))));
};
/* harmony default export */ __webpack_exports__["a"] = (Header);


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DownloadGroupToast_Content__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions_download__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions_store__ = __webpack_require__(112);










var mapStateToProps = function (state) {
    var downloadGroups = state.downloadManager.downloadGroups, routerParamsHistory = state.routerParamsHistory;
    var currentOrigin = __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getCurrentOrigin(routerParamsHistory);
    var isDownloadsFolder = currentOrigin === __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads;
    var startedDownloadGroup = __WEBPACK_IMPORTED_MODULE_6__utils_downloadManager__["a" /* default */].getStartedDownloadGroup(downloadGroups);
    var downloadingGroup = __WEBPACK_IMPORTED_MODULE_6__utils_downloadManager__["a" /* default */].getDownloadingGroup(downloadGroups);
    var isDownloading = downloadingGroup !== null;
    var linkToDownloadsPage = isDownloadsFolder
        ? undefined
        : "#" + __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads, null) + __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* hashHistory */].getCurrentLocation().search;
    var message = getMessage(downloadingGroup, startedDownloadGroup);
    return {
        isDownloading: isDownloading,
        message: message,
        linkToDownloadsPage: linkToDownloadsPage,
        startedDownloadGroup: startedDownloadGroup,
    };
};
var getMessage = function (downloadingGroup, startedDownloadGroup) {
    if (downloadingGroup === __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].ALL) {
        return 'messages.download_all_toast_in_progress';
    }
    if (downloadingGroup === __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT) {
        return 'messages.download_importants_toast_in_progress';
    }
    if (downloadingGroup === __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED) {
        return 'messages.download_selected_toast_in_progress';
    }
    if (startedDownloadGroup === __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].ALL) {
        return 'messages.download_all_toast_paused';
    }
    if (startedDownloadGroup === __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT) {
        return 'messages.download_importants_toast_paused';
    }
    if (startedDownloadGroup === __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED) {
        return 'messages.download_selected_toast_paused';
    }
    return '';
};
var mapDispatchToProps = function (dispatch, ownProps) {
    var startedDownloadGroup = ownProps.startedDownloadGroup, parentOnContinueClick = ownProps.onContinueClick, parentOnCancelClick = ownProps.onCancelClick, isCheckingForUpdates = ownProps.isCheckingForUpdates;
    // If parent provides handlers, use them; otherwise use our own
    return {
        isCheckingForUpdates: isCheckingForUpdates || false,
        onContinueClick: parentOnContinueClick || (function () {
            switch (startedDownloadGroup) {
                case __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DownloadManager_actions__["f" /* downloadImportantAssets */])());
                    break;
                case __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].ALL:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__DownloadManager_actions__["e" /* downloadAll */])());
                    break;
                case __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__DownloadManager_actions_download__["d" /* downloadSelectedAssets */])());
                    break;
                default:
                    break;
            }
        }),
        onCancelClick: parentOnCancelClick || (function () {
            switch (startedDownloadGroup) {
                case __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions_store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].IMPORTANT));
                    break;
                case __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].ALL:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions_store__["f" /* finishDownloadGroup */])(__WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].ALL));
                    break;
                case __WEBPACK_IMPORTED_MODULE_1__DownloadManager_reducer__["a" /* DownloadGroupName */].SELECTED:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DownloadManager_actions_store__["o" /* resetSelectedDownloadItems */])());
                    break;
                default:
                    break;
            }
        }),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_DownloadGroupToast_Content__["a" /* default */]));


/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);

var Translate = __webpack_require__(5).Translate;




var Content = function (_a) {
    var isDownloading = _a.isDownloading, message = _a.message, linkToDownloadsPage = _a.linkToDownloadsPage, onContinueClick = _a.onContinueClick, onCancelClick = _a.onCancelClick, isCheckingForUpdates = _a.isCheckingForUpdates;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* ContentWrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "icon-and-text" },
            isCheckingForUpdates && __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_loading'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: isCheckingForUpdates ? 'messages.checking_for_updates' : message, dangerousHTML: true })),
        isDownloading && linkToDownloadsPage && !isCheckingForUpdates &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* LinkToDownloadsPage */], { value: "messages.download_toast_link_to_downloads", url: linkToDownloadsPage, dangerousHTML: true }),
        !isDownloading && !isCheckingForUpdates &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ButtonContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* ContentButton */], { type: "button", onClick: onContinueClick, backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue50, 70) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.continue" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* ContentButton */], { type: "button", onClick: onCancelClick, backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey300, 70), color: __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey500 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.cancel" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (Content);


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContentStructureToast__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__ = __webpack_require__(28);





var mapStateToProps = function (state) {
    var offlineManager = state.offlineManager, _a = state.downloadManager, downloadGroups = _a.downloadGroups, isDownloadToastClosed = _a.isDownloadToastClosed;
    var isPreparingContentStructure = offlineManager.isPreparingContentStructure;
    var isContentStructureToastClosed = offlineManager.isContentStructureToastClosed;
    // Check if download manager widget is active
    var isDownloadGroupStarted = [
        downloadGroups.all.status,
        downloadGroups.important.status,
        downloadGroups.selected.status,
    ].includes(__WEBPACK_IMPORTED_MODULE_4__DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started);
    var isDownloadManagerActive = isDownloadGroupStarted && !isDownloadToastClosed;
    // Check if content structure was never completed
    // When offline, always show widget if content structure was never completed, regardless of status
    // When online, only show widget if content structure is actively being prepared/initialized
    // This prevents showing the "incomplete" message when online and not actively preparing
    var isOffline = !__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline();
    var needsContentStructureCompletion = !offlineManager.contentStructureEverCompleted && (isOffline // Only show "incomplete" message when offline
    );
    // Show widget if:
    // - Content structure is being prepared/updated
    // - Content structure is ready (to show completion message or thumbnail download progress)
    // - Thumbnails are still downloading (keep widget open until they're done)
    // - OR we need content structure completion (offline with incomplete structure, or online actively preparing incomplete structure)
    // But respect user's choice to close it (unless needsContentStructureCompletion is true, which is critical)
    var shouldShow = (isPreparingContentStructure || offlineManager.contentStructureReady || offlineManager.isDownloadingThumbs || needsContentStructureCompletion);
    var isDisplayed = shouldShow && (!isContentStructureToastClosed || needsContentStructureCompletion);
    return {
        isDisplayed: isDisplayed,
        isPreparingContentStructure: isPreparingContentStructure,
        contentStructureReady: offlineManager.contentStructureReady,
        needsContentStructureCompletion: needsContentStructureCompletion,
        contentStructureEverCompleted: offlineManager.contentStructureEverCompleted,
        isDownloadingThumbs: offlineManager.isDownloadingThumbs,
        isDownloadManagerActive: isDownloadManagerActive,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    onRetryContentStructure: function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__["f" /* initializeOfflineManager */])());
    },
    onClose: function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__OfflineManager_actions__["c" /* closeContentStructureToast */])());
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ContentStructureToast__["a" /* default */]));


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content__ = __webpack_require__(1358);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var ContentStructureToast = function (_a) {
    var isDisplayed = _a.isDisplayed, isPreparingContentStructure = _a.isPreparingContentStructure, contentStructureReady = _a.contentStructureReady, needsContentStructureCompletion = _a.needsContentStructureCompletion, contentStructureEverCompleted = _a.contentStructureEverCompleted, _b = _a.isDownloadingThumbs, isDownloadingThumbs = _b === void 0 ? false : _b, _c = _a.isDownloadManagerActive, isDownloadManagerActive = _c === void 0 ? false : _c, _d = _a.screenWidth, screenWidth = _d === void 0 ? typeof window !== 'undefined' ? (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) : 0 : _d, onRetryContentStructure = _a.onRetryContentStructure, onClose = _a.onClose;
    // Initialize expanded state - always start expanded when content structure completion is needed
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](true), 2), isExpanded = _e[0], setIsExpanded = _e[1];
    var _f = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](screenWidth), 2), currentScreenWidth = _f[0], setCurrentScreenWidth = _f[1];
    // Update screen width on resize
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var handleResize = function () {
            setCurrentScreenWidth(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
        };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    // Ensure widget stays expanded when content structure completion is needed
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (needsContentStructureCompletion) {
            setIsExpanded(true);
        }
    }, [needsContentStructureCompletion]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* Wrapper */], { isDisplayed: isDisplayed, isDownloadManagerActive: isDownloadManagerActive, screenWidth: currentScreenWidth },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], { isToastExpanded: isExpanded, onToggle: function () { return setIsExpanded(!isExpanded); }, onClose: onClose || (function () {
                // No-op: close handler is optional
            }), isPreparingContentStructure: isPreparingContentStructure, contentStructureReady: contentStructureReady, needsContentStructureCompletion: needsContentStructureCompletion, contentStructureEverCompleted: contentStructureEverCompleted, isDownloadingThumbs: isDownloadingThumbs }),
        isExpanded &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Content__["a" /* default */], { isPreparingContentStructure: isPreparingContentStructure, contentStructureReady: contentStructureReady, needsContentStructureCompletion: needsContentStructureCompletion, onRetryContentStructure: onRetryContentStructure, contentStructureEverCompleted: contentStructureEverCompleted, isDownloadingThumbs: isDownloadingThumbs })));
};
/* harmony default export */ __webpack_exports__["a"] = (ContentStructureToast);


/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var Header = function (_a) {
    var isToastExpanded = _a.isToastExpanded, onToggle = _a.onToggle, onClose = _a.onClose, isPreparingContentStructure = _a.isPreparingContentStructure, contentStructureReady = _a.contentStructureReady, needsContentStructureCompletion = _a.needsContentStructureCompletion, contentStructureEverCompleted = _a.contentStructureEverCompleted, _b = _a.isDownloadingThumbs, isDownloadingThumbs = _b === void 0 ? false : _b;
    var title = '';
    if (needsContentStructureCompletion) {
        // Show "Content structure incomplete" when offline and content was never completed
        title = 'messages.content_structure_incomplete';
    }
    else if (isPreparingContentStructure) {
        // Show different message for first time vs update
        var isFirstTime = !contentStructureEverCompleted;
        title = isFirstTime ? 'messages.preparing_content_structure' : 'messages.updating_content_structure';
    }
    else if (contentStructureReady && isDownloadingThumbs) {
        // Show "Downloading thumbnails..." when content structure is ready but thumbnails are still downloading
        title = 'messages.downloading_thumbnails_for_offline_use';
    }
    else if (contentStructureReady) {
        // Show "Content structure is now available for offline use" when ready and thumbnails are done
        title = 'messages.content_structure_ready';
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* StyledHeader */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* Title */], { value: title }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* Toggle */], { type: "button", isExpanded: isToastExpanded, onClick: onToggle }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_down')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ButtonClose */], { type: "button", onClick: onClose }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_close-2'))));
};
/* harmony default export */ __webpack_exports__["a"] = (Header);


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);

var Translate = __webpack_require__(5).Translate;





var Content = function (_a) {
    var isPreparingContentStructure = _a.isPreparingContentStructure, contentStructureReady = _a.contentStructureReady, needsContentStructureCompletion = _a.needsContentStructureCompletion, onRetryContentStructure = _a.onRetryContentStructure, contentStructureEverCompleted = _a.contentStructureEverCompleted, _b = _a.isDownloadingThumbs, isDownloadingThumbs = _b === void 0 ? false : _b;
    // When offline and content structure was never completed, show message with retry button
    if (needsContentStructureCompletion) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* ContentWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "icon-and-text" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.content_structure_never_completed", dangerousHTML: true })),
            __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isOnline() && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ButtonContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* ContentButton */], { type: "button", onClick: onRetryContentStructure, backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue50, 70) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.retry" }))))));
    }
    // When preparing content structure, show different messages for first time vs update
    if (isPreparingContentStructure) {
        var isFirstTime = !contentStructureEverCompleted;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* ContentWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "icon-and-text" },
                __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: isFirstTime ? 'messages.preparing_content_structure' : 'messages.updating_content_structure', dangerousHTML: true }),
                    isFirstTime && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.do_not_close_app", dangerousHTML: true }))))));
    }
    // When content structure is ready but thumbnails are still downloading, show thumbnail download message
    if (contentStructureReady && isDownloadingThumbs) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* ContentWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "icon-and-text" },
                __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.downloading_thumbnails_for_offline_use", dangerousHTML: true })))));
    }
    // When content structure is ready and thumbnails are done, show completion message
    if (contentStructureReady && !isDownloadingThumbs) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* ContentWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "icon-and-text" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.content_structure_ready", dangerousHTML: true }))));
    }
    // Fallback: if widget is displayed but no specific condition matches, show a default message
    // This should not happen in normal flow, but prevents empty widget display
    return null;
};
/* harmony default export */ __webpack_exports__["a"] = (Content);


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareWithUserPopup__ = __webpack_require__(1360);


var mapStateToProps = function (state) {
    var _a = state.shareWithUserPopup, isDisplayed = _a.isDisplayed, isLoading = _a.isLoading, users = _a.users, selectedUserId = _a.selectedUserId;
    return {
        isDisplayed: isDisplayed,
        isLoading: isLoading,
        users: users,
        selectedUserId: selectedUserId,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ShareWithUserPopup__["a" /* default */]));


/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_Select__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ShareWithUserPopup_actions__ = __webpack_require__(331);






var ShareWithUserPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, isLoading = _a.isLoading, users = _a.users, selectedUserId = _a.selectedUserId, dispatch = _a.dispatch;
    var isNoUsers = !isLoading && users.length === 0;
    var popupFooter = isNoUsers
        ? undefined
        : ({
            label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.invite_coworker'),
            onAccept: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ShareWithUserPopup_actions__["e" /* shareWithUser */])()); },
        });
    var handleChange = function (_a) {
        var value = _a.value;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ShareWithUserPopup_actions__["d" /* selectUser */])(value));
    };
    var usersOptions = users.map(function (_a) {
        var id = _a.id, name = _a.name, email = _a.email;
        return ({
            value: id,
            label: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* UserName */], null, name),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* UserEmail */], null, email))),
        });
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, isLoading: isLoading, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.choose_coworker'), onCancel: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ShareWithUserPopup_actions__["c" /* reset */])()); }, footer: popupFooter },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Wrapper */], { hasUsers: !isNoUsers }, isNoUsers
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Message */], { value: "messages.no_share_users" })
            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Form_Select__["b" /* default */], { value: selectedUserId, options: usersOptions, onChange: handleChange })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShareWithUserPopup);


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tpadding: 20px;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tpadding: 20px;\n\n\t", "\n"])), function (_a) {
    var hasUsers = _a.hasUsers;
    return hasUsers && 'min-height: 117px;';
});
var Message = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: block;\n\ttext-align: center;\n"], ["\n\tdisplay: block;\n\ttext-align: center;\n"])));
var UserName = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"], ["\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])));
var UserEmail = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-top: 5px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tcolor: ", ";\n"], ["\n\tmargin-top: 5px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey600);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication__ = __webpack_require__(1363);


var mapStateToProps = function (state) {
    var multiAppAuthenticationInfos = state.multiAppAuthenticationInfos, appInfos = state.appInfos, config = state.galleryInfos.config;
    var accessibleApps = multiAppAuthenticationInfos.accessibleApps, credentials = multiAppAuthenticationInfos.credentials, orgAuthMethods = multiAppAuthenticationInfos.orgAuthMethods, form = multiAppAuthenticationInfos.form;
    // userLocale is sent as a prop, to allow the rerendering of placeholders when the language is switched
    var userLocale = appInfos.userLocale;
    // credentials.login are used in case of login failure if the user tries re-submitting without changing the form.login
    var login = credentials && credentials.login && !form.login ? credentials.login : form.login;
    var company = credentials && credentials.company && !form.company ? credentials.company : form.company;
    return { accessibleApps: accessibleApps, credentials: credentials, orgAuthMethods: orgAuthMethods, login: login, company: company, userLocale: userLocale, galleryConfig: config };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication__["a" /* default */]));


/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MultiAppAuthentication */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_MultiAppAuthentication_Popup__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_Form__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_LanguageSwitcher__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Form__ = __webpack_require__(358);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var MultiAppAuthentication = /** @class */ (function (_super) {
    __extends(MultiAppAuthentication, _super);
    function MultiAppAuthentication(props) {
        var _this = _super.call(this, props) || this;
        _this.logoClickCount = 0;
        _this.onPopupClosed = function () {
            _this.setState({ isSelectPopupOpen: false, isServerSelect: false });
        };
        _this.handleLogoClick = function () {
            _this.logoClickCount++;
            if (_this.logoClickCount > 9) {
                _this.setState({ isSelectPopupOpen: true, isServerSelect: true });
                _this.logoClickCount = 0;
            }
        };
        _this.switchToDemoView = function () {
            _this.switchViewMode(__WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Creation);
        };
        _this.switchToLoginView = function () {
            _this.switchViewMode(__WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Login);
        };
        _this.switchToCompanyView = function () {
            _this.switchViewMode(__WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Company);
        };
        _this.switchViewMode = function (viewMode) {
            _this.setState({ viewMode: viewMode });
        };
        _this.setLoader = function (hasLoader) {
            _this.setState({ hasLoader: hasLoader });
        };
        _this.isLoginView = function (viewMode) {
            return __WEBPACK_IMPORTED_MODULE_10__utils_authentication__["a" /* default */].isLoginView(viewMode || _this.state.viewMode);
        };
        _this.isOrgLoginView = function (viewMode) {
            return __WEBPACK_IMPORTED_MODULE_10__utils_authentication__["a" /* default */].isOrgLoginView(viewMode || _this.state.viewMode);
        };
        _this.isPasswordView = function (viewMode) {
            return __WEBPACK_IMPORTED_MODULE_10__utils_authentication__["a" /* default */].isPasswordView(viewMode || _this.state.viewMode);
        };
        _this.isCompanyView = function (viewMode) {
            return __WEBPACK_IMPORTED_MODULE_10__utils_authentication__["a" /* default */].isCompanyView(viewMode || _this.state.viewMode);
        };
        _this.isMethodView = function (viewMode) {
            return __WEBPACK_IMPORTED_MODULE_10__utils_authentication__["a" /* default */].isMethodView(viewMode || _this.state.viewMode);
        };
        _this.isCreationView = function (viewMode) {
            return __WEBPACK_IMPORTED_MODULE_10__utils_authentication__["a" /* default */].isCreationView(viewMode || _this.state.viewMode);
        };
        _this.renderMethodButtons = function () {
            var orgAuthMethods = _this.props.orgAuthMethods;
            if (orgAuthMethods.length === 1) {
                return;
            }
            return orgAuthMethods.map(function (method) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["g" /* MultiAppAuthenticationMethodButton */], { onClick: function () { return _this.selectAuthMethod(method); }, key: "button-" + method },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "" + __WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["b" /* AUTH_METHODS */][method].text })));
            });
        };
        var accessibleApps = props.accessibleApps;
        _this.state = {
            isSelectPopupOpen: accessibleApps.length > 1,
            isServerSelect: false,
            shouldRememberCredentials: true,
            viewMode: __WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].Login,
            hasLoader: false
        };
        return _this;
    }
    MultiAppAuthentication.prototype.componentDidMount = function () {
        if (this.props.orgAuthMethods.length === 1) {
            this.setState({ method: this.props.orgAuthMethods[0] });
        }
    };
    MultiAppAuthentication.prototype.componentDidUpdate = function (prevProps, prevState) {
        var viewMode = this.state.viewMode;
        var _a = this.props, credentials = _a.credentials, galleryConfig = _a.galleryConfig, accessibleApps = _a.accessibleApps, orgAuthMethods = _a.orgAuthMethods, dispatch = _a.dispatch;
        var company = credentials && credentials.company || '';
        if (prevProps.accessibleApps !== accessibleApps) {
            this.setState({ isSelectPopupOpen: accessibleApps.length > 1 });
        }
        if (!this.isOrgLoginView(prevState.viewMode) &&
            this.isOrgLoginView(viewMode)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_actions__["h" /* orgLogin */])(galleryConfig, company));
        }
        if (prevProps.orgAuthMethods !== orgAuthMethods) {
            if (orgAuthMethods.length === 1) {
                this.setState({ method: orgAuthMethods[0] });
            }
        }
    };
    MultiAppAuthentication.prototype.selectAuthMethod = function (method) {
        this.setState({ method: method });
        if (method === __WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["c" /* AuthMethod */].Webpublication) {
            return this.switchToLoginView();
        }
        else {
            return this.switchToOrgLoginView();
        }
    };
    MultiAppAuthentication.prototype.switchToOrgLoginView = function () {
        this.switchViewMode(__WEBPACK_IMPORTED_MODULE_6__containers_MultiAppAuthentication_constants__["d" /* MultiAppAuthenticationViewMode */].OrgLogin);
    };
    Object.defineProperty(MultiAppAuthentication.prototype, "viewTitle", {
        get: function () {
            var _a = this, isLoginView = _a.isLoginView, isCompanyView = _a.isCompanyView, isMethodView = _a.isMethodView, isPasswordView = _a.isPasswordView;
            if (isCompanyView()) {
                return { key: 'messages.your_company_account' };
            }
            if (isLoginView()) {
                var company = this.props.company;
                return { key: 'messages.or_sign_in', appendCompany: !!company };
            }
            if (isMethodView()) {
                return { key: 'messages.or_sign_in' };
            }
            if (isPasswordView()) {
                return { key: 'messages.enter_password' };
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    MultiAppAuthentication.prototype.renderBackButtonBlock = function () {
        var _this = this;
        var _a = this, isMethodView = _a.isMethodView, isCreationView = _a.isCreationView, isPasswordView = _a.isPasswordView;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["n" /* SwitchLoginViewBlock */], { isCreationView: isCreationView(), onClick: function () {
                if (isMethodView()) {
                    _this.switchToCompanyView();
                }
                else {
                    var dispatch = _this.props.dispatch;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_actions__["i" /* setFormValue */])(__WEBPACK_IMPORTED_MODULE_11__Form__["a" /* InputName */].Company, ''));
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_actions__["l" /* updateCredentials */])({ company: '' }));
                    _this.switchToLoginView();
                }
            } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["a" /* BackLink */], null,
                __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_back'),
                isPasswordView()
                    ? this.props.login
                    : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.back_to_" + (isMethodView() ? 'company' : 'login') }))));
    };
    MultiAppAuthentication.prototype.renderAuthenticationBlock = function () {
        var _a = this, isMethodView = _a.isMethodView, isOrgLoginView = _a.isOrgLoginView, isLoginView = _a.isLoginView;
        var viewMode = this.state.viewMode;
        var company = this.props.company;
        var showBackButton = !isLoginView() && !isOrgLoginView();
        var viewTitle = this.viewTitle;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__containers_LanguageSwitcher__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["e" /* MultiAppAuthenticationContainer */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["q" /* WebpublicationLogo */], { onClick: this.handleLogoClick }, __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('uprez')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["c" /* FormWrapper */], null,
                    isLoginView() &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["p" /* SwitchToDemoViewBlock */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["o" /* SwitchToDemoFormButton */], { onClick: this.switchToDemoView },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: "messages.test_our_demo" }))),
                    showBackButton &&
                        this.renderBackButtonBlock(),
                    viewTitle &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["j" /* MultiAppAuthenticationTitle */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_redux_i18n__["Translate"], { value: viewTitle.key }),
                            viewTitle.appendCompany && company ? " " + company : ''),
                    !isMethodView() ?
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_MultiAppAuthentication_Form__["a" /* default */], { viewMode: viewMode, switchViewMode: this.switchViewMode, setLoader: this.setLoader })
                        : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["h" /* MultiAppAuthenticationMethods */], null, this.renderMethodButtons())))));
    };
    MultiAppAuthentication.prototype.render = function () {
        var _a = this.state, isSelectPopupOpen = _a.isSelectPopupOpen, shouldRememberCredentials = _a.shouldRememberCredentials, hasLoader = _a.hasLoader, isServerSelect = _a.isServerSelect;
        var _b = this, isOrgLoginView = _b.isOrgLoginView, isCreationView = _b.isCreationView, isPasswordView = _b.isPasswordView;
        var showLoader = hasLoader && (isCreationView() || isPasswordView());
        var loaderStep = isCreationView() ? { step: __WEBPACK_IMPORTED_MODULE_3__Loader__["a" /* LoaderStepName */].Creating } : { step: __WEBPACK_IMPORTED_MODULE_3__Loader__["a" /* LoaderStepName */].LoggingIn };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_MultiAppAuthentication_styles__["k" /* StyledMultiAppAuthentication */], null,
            showLoader &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Loader__["c" /* default */], { loaderStep: loaderStep, type: __WEBPACK_IMPORTED_MODULE_3__Loader__["b" /* LoaderType */].Overlay }),
            isSelectPopupOpen &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_MultiAppAuthentication_Popup__["a" /* default */], { onClose: this.onPopupClosed, shouldSaveGalleryConfig: shouldRememberCredentials, isServerSelect: isServerSelect }),
            !isOrgLoginView() && this.renderAuthenticationBlock()));
    };
    return MultiAppAuthentication;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (MultiAppAuthentication);


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_Popup__ = __webpack_require__(1365);


var mapStateToProps = function (state) {
    var multiAppAuthenticationInfos = state.multiAppAuthenticationInfos;
    var accessibleApps = multiAppAuthenticationInfos.accessibleApps;
    return { accessibleApps: accessibleApps };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_Popup__["a" /* default */]));


/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MultiAppAuthenticationPopup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_styles__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageOverlay_styles__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MultiAppAuthentication_Popup_styles__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Authentication_styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_constants__ = __webpack_require__(67);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var availableServers = [
    __WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_constants__["e" /* Server */].FR,
    __WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_constants__["e" /* Server */].AR,
    __WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_constants__["e" /* Server */].AU,
    __WEBPACK_IMPORTED_MODULE_8__containers_MultiAppAuthentication_constants__["e" /* Server */].MIGRATIONV3
];
var MultiAppAuthenticationPopup = /** @class */ (function (_super) {
    __extends(MultiAppAuthenticationPopup, _super);
    function MultiAppAuthenticationPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    MultiAppAuthenticationPopup.prototype.onSubmit = function (e) {
        var _a = this.props, shouldSaveGalleryConfig = _a.shouldSaveGalleryConfig, accessibleApps = _a.accessibleApps, isServerSelect = _a.isServerSelect;
        if (this.selectRef) {
            if (isServerSelect) {
                var server = availableServers[this.selectRef.selectedIndex];
                this.props.dispatch({ type: __WEBPACK_IMPORTED_MODULE_3__containers_MultiAppAuthentication_actions__["a" /* MultiAppAuthenticationInfosActionKeys */].UPDATE_SERVER, server: server });
                this.props.onClose();
            }
            else {
                var _b = accessibleApps[this.selectRef.selectedIndex], clientId = _b.clientId, globalId = _b.globalId;
                this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_MultiAppAuthentication_actions__["g" /* loadGallery */])(clientId, globalId, shouldSaveGalleryConfig));
            }
        }
    };
    MultiAppAuthenticationPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, accessibleApps = _a.accessibleApps, isServerSelect = _a.isServerSelect;
        var appOptions = accessibleApps.map(function (accessibleApp, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { value: accessibleApp.globalId, key: index }, accessibleApp.genericItemName);
        });
        var serverOptions = availableServers.map(function (server, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { value: server, key: index }, server);
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_PageOverlay_styles__["a" /* PageOverlay */], { isOpen: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_MultiAppAuthentication_Popup_styles__["e" /* StyledMultiAppAuthenticationPopup */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_MultiAppAuthentication_Popup_styles__["d" /* CloseButton */], { onClick: function () { return _this.props.onClose(); } }, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_close-2')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_MultiAppAuthentication_styles__["j" /* MultiAppAuthenticationTitle */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: isServerSelect ? 'messages.select_server' : 'messages.select_application' })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_MultiAppAuthentication_Popup_styles__["c" /* AccessibleAppSelectWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_MultiAppAuthentication_Popup_styles__["a" /* AccessibleAppSelect */], { ref: function (ref) { return _this.selectRef = ref; } }, isServerSelect ? serverOptions : appOptions),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_MultiAppAuthentication_Popup_styles__["b" /* AccessibleAppSelectIcon */], null, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_down'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Authentication_styles__["a" /* AuthenticateButton */], { onClick: this.onSubmit },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: isServerSelect ? 'messages.select_this_server' : 'messages.select_this_application' })))));
    };
    return MultiAppAuthenticationPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (MultiAppAuthenticationPopup);


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledMultiAppAuthenticationPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CloseButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AccessibleAppSelectWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessibleAppSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AccessibleAppSelectIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledMultiAppAuthenticationPopup = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\tleft: 50%;\n\ttop: 50%;\n\tz-index: 11;\n\tbackground: ", ";\n\tpadding: 60px 40px;\n\ttransform: translate(-50%, -50%);\n\twidth: 90%;\n\tmax-width: 400px;\n\tbox-sizing: border-box;\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n"], ["\n\tposition: fixed;\n\tleft: 50%;\n\ttop: 50%;\n\tz-index: 11;\n\tbackground: ", ";\n\tpadding: 60px 40px;\n\ttransform: translate(-50%, -50%);\n\twidth: 90%;\n\tmax-width: 400px;\n\tbox-sizing: border-box;\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var CloseButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tpadding: 9px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tpadding: 9px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey500);
var AccessibleAppSelectWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\tmargin-bottom: 15px;\n\tposition: relative;\n"], ["\n\twidth: 100%;\n\tmargin-bottom: 15px;\n\tposition: relative;\n"])));
var AccessibleAppSelect = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('select')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 100%;\n\tborder: 1px solid ", ";\n\theight: 40px;\n\tcolor: ", ";\n\tbackground: ", ";\n\tpadding: 0 15px;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\toutline: none;\n"], ["\n\twidth: 100%;\n\tborder: 1px solid ", ";\n\theight: 40px;\n\tcolor: ", ";\n\tbackground: ", ";\n\tpadding: 0 15px;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\toutline: none;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey400, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey500, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var AccessibleAppSelectIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 7.5px;\n\tright: 7.5px;\n\tpointer-events: none;\n\n\t> svg {\n\t\twidth: 16px;\n\t\theight: 25px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 7.5px;\n\tright: 7.5px;\n\tpointer-events: none;\n\n\t> svg {\n\t\twidth: 16px;\n\t\theight: 25px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey500);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MultiAppAuthentication_Form__ = __webpack_require__(358);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var multiAppAuthenticationInfos = state.multiAppAuthenticationInfos, appInfos = state.appInfos, config = state.galleryInfos.config;
    var form = multiAppAuthenticationInfos.form, aspConnexionStatus = multiAppAuthenticationInfos.aspConnexionStatus, credentials = multiAppAuthenticationInfos.credentials;
    var userLocale = appInfos.userLocale;
    var isLoginView = __WEBPACK_IMPORTED_MODULE_1__utils_authentication__["a" /* default */].isLoginView(ownProps.viewMode);
    var isPasswordView = __WEBPACK_IMPORTED_MODULE_1__utils_authentication__["a" /* default */].isPasswordView(ownProps.viewMode);
    var isCompanyView = __WEBPACK_IMPORTED_MODULE_1__utils_authentication__["a" /* default */].isCompanyView(ownProps.viewMode);
    var isCreationView = __WEBPACK_IMPORTED_MODULE_1__utils_authentication__["a" /* default */].isCreationView(ownProps.viewMode);
    var login = getFieldValue(__WEBPACK_IMPORTED_MODULE_2__components_MultiAppAuthentication_Form__["a" /* InputName */].Login, form, credentials);
    var password = getFieldValue(__WEBPACK_IMPORTED_MODULE_2__components_MultiAppAuthentication_Form__["a" /* InputName */].Password, form, credentials);
    var company = getFieldValue(__WEBPACK_IMPORTED_MODULE_2__components_MultiAppAuthentication_Form__["a" /* InputName */].Company, form, credentials);
    return {
        form: __assign({}, form, { login: login, password: password, company: company }),
        aspConnexionStatus: aspConnexionStatus,
        userLocale: userLocale,
        isLoginView: isLoginView,
        isPasswordView: isPasswordView,
        isCompanyView: isCompanyView,
        isCreationView: isCreationView,
        galleryConfig: config,
        credentials: credentials,
    };
};
var getFieldValue = function (inputName, form, credentials) {
    if (form[inputName]) {
        return form[inputName];
    }
    if (credentials && credentials[inputName]) {
        return (credentials)[inputName];
    }
    return '';
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components_MultiAppAuthentication_Form__["b" /* MultiAppAuthenticationForm */]));


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiAppAuthenticationInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Authentication_styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonReveal__ = __webpack_require__(1369);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var getType = function (name) {
    switch (name) {
        case __WEBPACK_IMPORTED_MODULE_3____["a" /* InputName */].Login:
            return 'email';
        case __WEBPACK_IMPORTED_MODULE_3____["a" /* InputName */].Password:
            return 'password';
        case __WEBPACK_IMPORTED_MODULE_3____["a" /* InputName */].Phone:
            return 'tel';
        default:
            return 'text';
    }
};
var MultiAppAuthenticationInput = /** @class */ (function (_super) {
    __extends(MultiAppAuthenticationInput, _super);
    function MultiAppAuthenticationInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRevealButtonClick = function () {
            var isPasswordVisible = _this.state.isPasswordVisible;
            _this.setState({ isPasswordVisible: !isPasswordVisible });
        };
        _this.state = {
            isPasswordVisible: false,
        };
        return _this;
    }
    MultiAppAuthenticationInput.prototype.render = function () {
        var _a = this.props, value = _a.value, errorMessage = _a.errorMessage, onChange = _a.onChange, name = _a.name, autoFocus = _a.autoFocus;
        var isPasswordVisible = this.state.isPasswordVisible;
        var type = getType(name);
        if (getType(name) === 'password' && isPasswordVisible) {
            type = 'text';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Authentication_styles__["g" /* AuthenticationInputWrapper */], null,
            errorMessage &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* MultiAppAuthenticationError */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: errorMessage })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Authentication_styles__["b" /* AuthenticateFormInput */], { value: value, onChange: onChange, required: true, "data-error": errorMessage ? errorMessage : undefined, type: type, ref: name === __WEBPACK_IMPORTED_MODULE_3____["a" /* InputName */].Login
                    ? function (ref) {
                        if (ref) {
                            ref.setAttribute('autocorrect', 'none');
                            ref.setAttribute('autocapitalize', 'off');
                            ref.setAttribute('spellcheck', 'false');
                        }
                    } : undefined, minLength: name === __WEBPACK_IMPORTED_MODULE_3____["a" /* InputName */].Password ? 6 : undefined, placeholder: __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["I18n"].t("messages.placeholder_" + name), autoFocus: autoFocus, name: name }),
            name === __WEBPACK_IMPORTED_MODULE_3____["a" /* InputName */].Password &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ButtonReveal__["a" /* default */], { onClick: this.handleRevealButtonClick })));
    };
    return MultiAppAuthenticationInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1370);



var RevealButton = function (_a) {
    var onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledRevealButton */], { onClick: onClick }, __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_eye')));
};
/* harmony default export */ __webpack_exports__["a"] = (RevealButton);


/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledRevealButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledRevealButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 24px;\n\theight: 43px;\n\tposition: absolute;\n\tright: 10px;\n\tbottom: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"], ["\n\twidth: 24px;\n\theight: 43px;\n\tposition: absolute;\n\tright: 10px;\n\tbottom: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"])));

var templateObject_1;


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_setLocales__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SimpleDropdownMenu_styles__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_actions__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__ = __webpack_require__(21);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};








var LanguageSwitcher = /** @class */ (function (_super) {
    __extends(LanguageSwitcher, _super);
    function LanguageSwitcher(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLanguageMenuOpen: false,
        };
        _this.toggleLanguageMenu = _this.toggleLanguageMenu.bind(_this);
        _this.setLanguage = _this.setLanguage.bind(_this);
        return _this;
    }
    LanguageSwitcher.prototype.componentDidMount = function () {
        this.restoreStoredLocale().then();
    };
    LanguageSwitcher.prototype.toggleLanguageMenu = function () {
        var isLanguageMenuOpen = this.state.isLanguageMenuOpen;
        this.setState({ isLanguageMenuOpen: !isLanguageMenuOpen });
    };
    LanguageSwitcher.prototype.openLanguageMenu = function () {
        this.setState({ isLanguageMenuOpen: true });
    };
    LanguageSwitcher.prototype.closeLanguageMenu = function () {
        this.setState({ isLanguageMenuOpen: false });
    };
    LanguageSwitcher.prototype.setLanguage = function (locale, setLocalStorage) {
        if (setLocalStorage === void 0) { setLocalStorage = true; }
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__App_actions__["d" /* setUserLocale */])(locale, false, setLocalStorage));
    };
    LanguageSwitcher.prototype.renderLanguageList = function () {
        var _this = this;
        return Object.keys(__WEBPACK_IMPORTED_MODULE_2__store_setLocales__["a" /* Locales */]).map(function (locale) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_SimpleDropdownMenu_styles__["b" /* DropdownMenuListItem */], { key: locale, onClick: function () { return _this.setLanguage(locale); } }, __WEBPACK_IMPORTED_MODULE_2__store_setLocales__["a" /* Locales */][locale]));
        });
    };
    Object.defineProperty(LanguageSwitcher.prototype, "isLanguageMenuOpen", {
        get: function () {
            return this.state.isLanguageMenuOpen;
        },
        enumerable: true,
        configurable: true
    });
    LanguageSwitcher.prototype.render = function () {
        var _this = this;
        var isLanguageMenuOpen = this.isLanguageMenuOpen;
        var language = this.props.language;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* LanguageSwitcherContainer */], { onClick: function () { return _this.toggleLanguageMenu(); }, isOpen: isLanguageMenuOpen },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* LanguageSwitcherButton */], null,
                __WEBPACK_IMPORTED_MODULE_2__store_setLocales__["a" /* Locales */][language],
                __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_down')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* LanguageSwitcherDropdown */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_SimpleDropdownMenu_styles__["a" /* DropdownMenuList */], null, this.renderLanguageList()))));
    };
    LanguageSwitcher.prototype.restoreStoredLocale = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storedUserLocale;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__utils_indexedDB_manager__["a" /* default */].getUserLocale(false)];
                    case 1:
                        storedUserLocale = _a.sent();
                        if (storedUserLocale) {
                            this.setLanguage(storedUserLocale, false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return LanguageSwitcher;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var locale = state.i18n.locale;
    return { language: locale };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(LanguageSwitcher));


/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LanguageSwitcherContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguageSwitcherButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LanguageSwitcherDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Button_styles__ = __webpack_require__(88);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var pageMargin = '25px';
var LanguageSwitcherContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: calc(100% - ", ");\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\ttext-align: right;\n\tposition: relative;\n\tpadding-top: ", ";\n\tpadding-right: ", ";\n\n\t> button svg {\n\t\ttransition: 0.2s;\n\t\ttransform: ", ";\n\t}\n\n\t> div {\n\t\ttransition: 0.2s;\n\t\tright: ", ";\n\t\t", "\n\t}\n"], ["\n\twidth: calc(100% - ", ");\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\ttext-align: right;\n\tposition: relative;\n\tpadding-top: ", ";\n\tpadding-right: ", ";\n\n\t> button svg {\n\t\ttransition: 0.2s;\n\t\ttransform: ", ";\n\t}\n\n\t> div {\n\t\ttransition: 0.2s;\n\t\tright: ", ";\n\t\t",
    "\n\t}\n"])), pageMargin, pageMargin, pageMargin, function (props) { return props.isOpen ? 'rotate(180deg)' : 'rotate(0)'; }, pageMargin, function (props) { return props.isOpen
    ? "z-index: 2;\n\t\t\t\topacity: 1;\n\t\t\t\ttop: calc(42px + " + pageMargin + ");"
    : "z-index: -1;\n\t\t\t\topacity: 0;\n\t\t\t\ttop: calc(40px + " + pageMargin + ");"; });
var LanguageSwitcherButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__components_Button_styles__["b" /* Button */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 90px;\n\theight: 33px;\n\tborder-radius: 24px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tborder: 1px solid ", ";\n\tposition: relative;\n\tpadding-right: 25px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 400;\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 18px;\n\t\theight: 33px;\n\t\twidth: 15px;\n\t\tfill: ", ";\n\t}\n"], ["\n\twidth: 90px;\n\theight: 33px;\n\tborder-radius: 24px;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tborder: 1px solid ", ";\n\tposition: relative;\n\tpadding-right: 25px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 400;\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 18px;\n\t\theight: 33px;\n\t\twidth: 15px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue500, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue500, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var LanguageSwitcherDropdown = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: 0;\n"], ["\n\tposition: absolute;\n\tright: 0;\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(510);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



/* harmony default export */ __webpack_exports__["a"] = (function (Component) {
    var SetRouteParams = /** @class */ (function (_super) {
        __extends(SetRouteParams, _super);
        function SetRouteParams() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SetRouteParams.prototype.componentWillMount = function () {
            this.props.setRouteParams(this.props.params, this.props.routes);
        };
        SetRouteParams.prototype.componentWillUpdate = function (nextProps) {
            this.props.setRouteParams(nextProps.params, nextProps.routes);
        };
        SetRouteParams.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, __assign({}, this.props));
        };
        return SetRouteParams;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, { setRouteParams: __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* setRouteParams */] })(SetRouteParams);
});


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(1375);



var getWelcomePageId = function (template) {
    var welcomePageUrl = template && template.welcomepage && template.welcomepage.url;
    if (!welcomePageUrl) {
        return undefined;
    }
    return __WEBPACK_IMPORTED_MODULE_1__utils_index__["d" /* default */].getMediaId(welcomePageUrl);
};
var mapStateToProps = function (_a, ownProps) {
    var template = _a.galleryInfos.template;
    return ({
        welcomePageId: getWelcomePageId(template)
    });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]));


/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemListPage_constants__ = __webpack_require__(23);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




var Home = function (_a) {
    var dispatch = _a.dispatch, welcomePageId = _a.welcomePageId;
    var redirectToWelcomePage = function (welcomePageId) { return __awaiter(_this, void 0, void 0, function () {
        var welcomePage, notRedirected, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!welcomePageId) {
                        redirectToRootFolder();
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(welcomePageId))];
                case 2:
                    welcomePage = _a.sent();
                    if (Object.keys(welcomePage).length === 0) { // handle case where driveItem is {}
                        redirectToRootFolder();
                        return [2 /*return*/];
                    }
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["L" /* viewDriveItem */])(welcomePage, __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].List, undefined, true));
                    notRedirected = !__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["M" /* viewableInGallery */].includes(welcomePage.type);
                    if (notRedirected) {
                        redirectToRootFolder();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    redirectToRootFolder();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var redirectToRootFolder = function () {
        __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, null));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        redirectToWelcomePage(welcomePageId);
    }, [welcomePageId]);
    return null;
};
/* harmony default export */ __webpack_exports__["a"] = (Home);


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StaticPage_Router__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_authentication__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);







var isGalleryLoaded = function (galleryInfos, appInfos) {
    var template = galleryInfos.template, isConfigLoaded = galleryInfos.isConfigLoaded;
    var isTemplateLoaded = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isTemplateLoaded(appInfos, galleryInfos);
    var isMenuLoaded = !!(template && template.menu);
    return isConfigLoaded && isTemplateLoaded && isMenuLoaded;
};
var needsConnection = function (userInfos) {
    // Can only be true in secured galleries, not in Uprez app
    var needCredentials = userInfos.needCredentials, mode = userInfos.mode;
    return needCredentials && __WEBPACK_IMPORTED_MODULE_4__utils_authentication__["a" /* default */].isNotConnected(mode);
};
var hasFetchError = function (driveList, component) {
    if (!component) {
        return false;
    }
    var fetchStatus = driveList.driveItemsFetchStatus[component] && driveList.driveItemsFetchStatus[component].metaFetchStatus;
    return fetchStatus === __WEBPACK_IMPORTED_MODULE_5__DriveItemList_reducer__["a" /* FetchStatus */].ERROR;
};
var isNotComponent = function (driveList, component) {
    if (!component) {
        return true;
    }
    var driveItem = driveList.driveItems[component];
    if (!driveItem) {
        return false;
    }
    return driveItem.type !== __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Component;
};
var mapStateToProps = function (state) {
    var routerParamsHistory = state.routerParamsHistory, galleryInfos = state.galleryInfos, appInfos = state.appInfos, driveList = state.driveList, userInfos = state.authentication.userInfos;
    var component = __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getCurrentRouterParam(routerParamsHistory).params.component;
    return {
        isGalleryLoaded: isGalleryLoaded(galleryInfos, appInfos),
        needsConnection: needsConnection(userInfos),
        hasFetchError: hasFetchError(driveList, component),
        isNotComponent: isNotComponent(driveList, component),
        component: component,
        driveList: driveList,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_StaticPage_Router__["a" /* default */]));


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_StaticPage__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);



var StaticPageRouter = function (_a) {
    var isGalleryLoaded = _a.isGalleryLoaded, needsConnection = _a.needsConnection, hasFetchError = _a.hasFetchError, isNotComponent = _a.isNotComponent, component = _a.component;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (needsConnection || hasFetchError || isNotComponent) {
            __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getPageNotFound();
            return;
        }
    }, [needsConnection, hasFetchError, isNotComponent]);
    var isNotOpenable = !isGalleryLoaded
        || needsConnection
        || hasFetchError
        || isNotComponent;
    if (isNotOpenable || !component) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_StaticPage__["a" /* default */], { componentId: parseInt(component, 10) }));
};
/* harmony default export */ __webpack_exports__["a"] = (StaticPageRouter);


/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StaticPage__ = __webpack_require__(1379);




var getIframeUrl = function (galleryInfos, downloadManager, locale, componentId) {
    var isAvailableOffline = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, componentId);
    var componentUrl = __WEBPACK_IMPORTED_MODULE_1__utils_index__["d" /* default */].getComponentUrl(galleryInfos, componentId, isAvailableOffline, locale);
    return componentUrl;
};
var mapStateToProps = function (state, ownProps) {
    var galleryInfos = state.galleryInfos, downloadManager = state.downloadManager, driveList = state.driveList, selection = state.selection, locale = state.i18n.locale;
    var componentId = ownProps.componentId;
    var iframeUrl = getIframeUrl(galleryInfos, downloadManager, locale, componentId);
    return { downloadManager: downloadManager, driveList: driveList, selection: selection, iframeUrl: iframeUrl };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3__components_StaticPage__["a" /* default */]));


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StaticPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_App_actions__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Selection_actions__ = __webpack_require__(53);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var StaticPage = /** @class */ (function (_super) {
    __extends(StaticPage, _super);
    function StaticPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFrameTasks = function (e) {
            if (e.data.target === 'GallApp') {
                if (e.data.action === 'goTo' && e.data.params && e.data.params.url) {
                    _this.handleMessageGoTo(e.data);
                }
                if (e.data.action === 'openDriveItem' && e.data.params && e.data.params.id) {
                    _this.handleMessageOpenDriveItem(e.data);
                }
                if (e.data.action === 'switchLocale' && e.data.params && e.data.params.locale) {
                    _this.handleMessageSwitchLocale(e.data);
                }
                if (e.data.action === 'toggleSelection' && e.data.params && e.data.params.id) {
                    _this.handleMessageToggleSelection(e.data);
                }
                if (e.data.action === 'getSelection') {
                    _this.handleMessageGetSelection();
                }
            }
        };
        return _this;
    }
    StaticPage.prototype.componentDidMount = function () {
        window.addEventListener('message', this.handleFrameTasks);
    };
    StaticPage.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.handleFrameTasks);
    };
    StaticPage.prototype.sendMessageToIframe = function (message) {
        var iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage(message, '*');
        }
    };
    StaticPage.prototype.handleMessageSwitchLocale = function (messageSwitchLocale) {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_App_actions__["d" /* setUserLocale */])(messageSwitchLocale.params.locale, true));
    };
    StaticPage.prototype.handleMessageToggleSelection = function (messageToggleSelection) {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_Selection_actions__["f" /* toggleSelection */])(messageToggleSelection.params.id, __WEBPACK_IMPORTED_MODULE_11__containers_Selection_actions__["b" /* SelectionType */].RESOURCES));
    };
    StaticPage.prototype.handleMessageGetSelection = function () {
        var selection = this.props.selection;
        this.sendMessageToIframe({ 'dataType': 'selection', 'content': selection.resources });
    };
    StaticPage.prototype.handleMessageGoTo = function (messageGoto) {
        __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].historyPush(messageGoto.params.url);
    };
    StaticPage.prototype.handleMessageOpenDriveItem = function (messageOpenDriveItem) {
        var _a = this.props, dispatch = _a.dispatch, driveList = _a.driveList, downloadManager = _a.downloadManager;
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp, isOnline = __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline;
        var isAsync = isMobileApp;
        var _b = messageOpenDriveItem.params, driveItemId = _b.id, forceSameTab = _b.forceSameTab, page = _b.page, hideWelcomePage = _b.hideWelcomePage, customSearchParams = _b.customSearchParams;
        var publicationOptions = {
            page: page,
            hideWelcomePage: hideWelcomePage,
            customSearchParams: customSearchParams,
        };
        var driveItemMeta = driveList.driveItems[driveItemId];
        var needFetching = !driveItemMeta && isOnline();
        var isDownloaded = __WEBPACK_IMPORTED_MODULE_4__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, driveItemId);
        var isAccessible = driveItemMeta && (isOnline() || isDownloaded || driveItemMeta.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Directory || driveItemMeta.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Image);
        if (needFetching) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(driveItemId, false, isAsync))
                .then(function (driveItem) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["L" /* viewDriveItem */])(driveItem, __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].Menu, publicationOptions, forceSameTab));
            });
        }
        else if (isAccessible) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["L" /* viewDriveItem */])(driveItemMeta, __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].Menu, publicationOptions, forceSameTab));
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_NotificationBar_actions__["c" /* createNotification */])('info.offline_download_single_asset'));
            return;
        }
    };
    StaticPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_9__containers_Page_constants__["a" /* PageType */].StaticPage },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StaticPageIframe */], { allowFullScreen: true, className: "StaticPageIframe", src: this.props.iframeUrl })));
    };
    return StaticPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (StaticPage);


/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StaticPageIframe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StaticPageIframe = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('iframe')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\tvertical-align: top;\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\tvertical-align: top;\n"])));
var templateObject_1;


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_MenuManager_Header__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Title__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Page_BottomBar__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_Search_Field__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Page_constants__ = __webpack_require__(71);








var Page = function (_a) {
    var children = _a.children, driveItems = _a.driveItems, pageType = _a.pageType, title = _a.title, showSearchField = _a.showSearchField, origin = _a.origin, originParam = _a.originParam, hasBottomBar = _a.hasBottomBar, _b = _a.isScrollable, isScrollable = _b === void 0 ? true : _b, _c = _a.backgroundUrl, backgroundUrl = _c === void 0 ? '' : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? '' : _d, isVideoBackground = _a.isVideoBackground;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_MenuManager_Header__["a" /* default */], { driveItems: driveItems }),
        showSearchField &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_Search_Field__["a" /* default */], { searchText: origin === __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search ? originParam : '' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* PageWrapper */], { pageType: pageType, isScrollable: isScrollable, backgroundUrl: backgroundUrl, backgroundColor: backgroundColor, isVideoBackground: isVideoBackground, className: "PageWrapper" },
            isVideoBackground && pageType === __WEBPACK_IMPORTED_MODULE_7__containers_Page_constants__["a" /* PageType */].DrivePage &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* VideoBackground */], { key: backgroundUrl, autoPlay: true, playsInline: true, muted: true, loop: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("source", { src: backgroundUrl, type: "video/mp4" })),
            title &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* TitleWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Title__["a" /* default */], { title: title })),
            children),
        hasBottomBar &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Page_BottomBar__["a" /* default */], { selection: driveItems || [] })));
};
/* harmony default export */ __webpack_exports__["a"] = (Page);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_reducer__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MenuManager_Header__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__ = __webpack_require__(11);








var mapStateToProps = function (state) {
    var _a = state.galleryInfos, galleryConfig = _a.config, _b = _a.template, sharedMethods = (_b === void 0 ? { sharedMethods: undefined } : _b).sharedMethods, menuManager = state.menuManager, routerParamsHistory = state.routerParamsHistory, authentication = state.authentication, appInfos = state.appInfos, search = state.search, sharePanel = state.sharePanel, profile = state.profile, lastPublicationId = state.backToPublication.publicationId;
    var menuModes = Object(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* getHeaderMenuModes */])(search, sharePanel, menuManager.menuModes);
    var needCredentials = authentication.userInfos.needCredentials;
    var origin = routerParamsHistory[routerParamsHistory.length - 1].params.origin;
    var type = appInfos.type || __WEBPACK_IMPORTED_MODULE_3__App_reducer__["a" /* AppType */].Single;
    var isDownloadable = sharedMethods && sharedMethods.includes(__WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].ShareMethod.Download);
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMultiApp(appInfos);
    var isReadOnlyApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isReadOnlyApp(profile.role);
    // Secured galleries can't share the root gallery
    var isSecure = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isSecure(type, needCredentials);
    var isGalleryRoot = __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].isGalleryRoot(routerParamsHistory);
    var isShareable = __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].isShareable(sharedMethods, galleryConfig) && !(isGalleryRoot && isSecure);
    var hasLastPublication = !!lastPublicationId;
    return {
        galleryConfig: galleryConfig, menuModes: menuModes, isShareable: isShareable, isDownloadable: isDownloadable,
        origin: origin, isMultiApp: isMultiApp, isReadOnlyApp: isReadOnlyApp, hasLastPublication: hasLastPublication
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4__components_MenuManager_Header__["a" /* default */]));


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_MenuManager_Header_Section__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__ = __webpack_require__(23);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.filterMenuItems = function (menuItems) {
        var _a = this.props, galleryConfig = _a.galleryConfig, origin = _a.origin, driveItems = _a.driveItems, isDownloadable = _a.isDownloadable, isShareable = _a.isShareable, isMultiApp = _a.isMultiApp, isReadOnlyApp = _a.isReadOnlyApp, hasLastPublication = _a.hasLastPublication;
        var hasDriveItems = driveItems !== undefined && driveItems.length > 0;
        if (menuItems) {
            return menuItems.filter(function (item) {
                switch (item.type) {
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].New:
                        return __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isOnline() || !__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMaster(galleryConfig);
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].Downloads:
                        return __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp;
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].DownloadButton:
                        return origin !== __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads && hasDriveItems && isDownloadable;
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].ShareButton:
                        return hasDriveItems && isShareable;
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].Documents:
                        return isMultiApp && !isReadOnlyApp;
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].SharedWithMe:
                        return isMultiApp;
                    case __WEBPACK_IMPORTED_MODULE_4__typings_menu__["b" /* MenuItemType */].BackToPublication:
                        return hasLastPublication;
                    default:
                        return item;
                }
            });
        }
        return [];
    };
    Header.prototype.render = function () {
        var _a = this.props, driveItems = _a.driveItems, menuModes = _a.menuModes;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, menuModes &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledHeader */], { className: "StyledHeader" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_MenuManager_Header_Section__["a" /* default */], { position: __WEBPACK_IMPORTED_MODULE_4__typings_menu__["c" /* MenuPosition */].left, menuItems: this.filterMenuItems(menuModes.left), driveItems: driveItems }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_MenuManager_Header_Section__["a" /* default */], { position: __WEBPACK_IMPORTED_MODULE_4__typings_menu__["c" /* MenuPosition */].center, menuItems: this.filterMenuItems(menuModes.center), driveItems: driveItems }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_MenuManager_Header_Section__["a" /* default */], { position: __WEBPACK_IMPORTED_MODULE_4__typings_menu__["c" /* MenuPosition */].right, menuItems: this.filterMenuItems(menuModes.right), driveItems: driveItems }))));
    };
    return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Header);


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MenuManager_Header_Section__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_constants__ = __webpack_require__(59);





var mapStateToProps = function (_a) {
    var driveList = _a.driveList, appInfos = _a.appInfos, config = _a.galleryInfos.config, sharePanel = _a.sharePanel, search = _a.search, routerParamsHistory = _a.routerParamsHistory, profile = _a.profile;
    var privateDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getPrivateDirId(driveList, config);
    var sharedDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSharedDirId(driveList, config);
    var currentRoute = __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].getCurrentRoute(routerParamsHistory);
    var isSettingsPage = [
        __WEBPACK_IMPORTED_MODULE_4__routes_constants__["a" /* RoutePath */].ParametersPage,
        __WEBPACK_IMPORTED_MODULE_4__routes_constants__["a" /* RoutePath */].ProfilePage,
    ].includes(currentRoute);
    return {
        privateDirId: privateDirId,
        sharedDirId: sharedDirId,
        isButtonCreateAvailable: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMultiApp(appInfos) &&
            profile.role &&
            !__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isReadOnlyApp(profile.role) &&
            !!privateDirId &&
            !sharePanel.isOpen &&
            !search.isShown &&
            !isSettingsPage,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MenuManager_Header_Section__["a" /* default */]));


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_MenuManager_Header_Logo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_Header_HeaderButton__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Share_ShareButton__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_Search_Button__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DriveItem_DownloadButton__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Title_styles__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HeaderButton_CancelButton__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_ButtonCreate__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_ButtonCreateNote__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_BackToPublication__ = __webpack_require__(544);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


















var HeaderSection = /** @class */ (function (_super) {
    __extends(HeaderSection, _super);
    function HeaderSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderSection.prototype.render = function () {
        var _this = this;
        var _a = this.props, menuItems = _a.menuItems, position = _a.position;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* StyledHeaderSection */], { position: position }, menuItems
            ? menuItems.map(function (menuItem, index) { return _this.getMenuItemElement(menuItem, "header-button-" + index); })
            : null));
    };
    HeaderSection.prototype.getMenuItemElement = function (_a, key) {
        var type = _a.type, icon = _a.icon, label = _a.label, target = _a.target, options = _a.options;
        var _b = this.props, driveItems = _b.driveItems, privateDirId = _b.privateDirId, sharedDirId = _b.sharedDirId, isButtonCreateAvailable = _b.isButtonCreateAvailable, position = _b.position;
        var itemArgs;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Home:
                itemArgs = {
                    icon: icon || 'iconset_home',
                    label: label || 'messages.home',
                    type: type,
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathHome(),
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Gallery:
                itemArgs = {
                    icon: icon || 'iconset_image',
                    label: label || 'messages.my_gallery',
                    type: type,
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, null),
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].BurgerButton:
                itemArgs = {
                    icon: icon || 'iconset_uprez_menu',
                    label: label || 'messages.menu',
                    type: type,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Logo:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_MenuManager_Header_Logo__["a" /* default */], { key: key, icon: icon, label: label }));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].DownloadButton:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_DriveItem_DownloadButton__["a" /* default */], { key: key, driveItems: driveItems ? driveItems : [], style: __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["b" /* ActionButtonStyle */].Icon, icon: icon, label: label }));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].ShareButton:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Share_ShareButton__["a" /* default */], { key: key, driveItems: driveItems ? driveItems : [], shareOrigin: __WEBPACK_IMPORTED_MODULE_11__containers_Share_actions__["a" /* ShareOrigin */].Selection, icon: icon, label: label, isInMenuBar: true }));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SearchButton:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_DriveItemList_Search_Button__["a" /* default */], { key: key, icon: icon, label: label }));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CancelButton:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HeaderButton_CancelButton__["a" /* default */], { key: key, actionOrigin: target }));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Selection:
                itemArgs = {
                    icon: icon || 'iconset_uprez_selection',
                    label: label || 'messages.my_selection',
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Selection, null),
                    type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Selection,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Title:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Title_styles__["b" /* StyledTitle */], { key: key },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_redux_i18n__["Translate"], { value: label })));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].New:
                itemArgs = {
                    icon: icon || 'iconset_news',
                    label: label || 'messages.new',
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].New, null),
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Documents:
                itemArgs = {
                    icon: icon || 'iconset_uprez_documents',
                    label: label || 'messages.my_documents',
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, String(privateDirId)),
                    type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Documents,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].SharedWithMe:
                itemArgs = {
                    icon: icon || 'iconset_shared_with_me',
                    label: label || 'messages.shared_with_me',
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, String(sharedDirId))
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Downloads:
                itemArgs = {
                    icon: icon || 'iconset_uprez_download',
                    label: label || 'messages.downloads',
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_8__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Downloads, null),
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Parameters:
                itemArgs = {
                    icon: icon || 'iconset_parameters',
                    label: label || 'messages.parameters',
                    target: __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPathParameters(),
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Link:
                itemArgs = {
                    type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Link,
                    label: label || 'Link',
                    icon: icon || 'iconset_link',
                    target: target,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Asset:
                itemArgs = {
                    type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Asset,
                    label: label || 'Asset',
                    icon: icon || 'iconset_file',
                    target: target,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Folder:
                itemArgs = {
                    type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Folder,
                    label: label || 'Folder',
                    icon: icon || 'iconset_folder',
                    target: target,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Page:
                itemArgs = {
                    type: __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].Page,
                    label: label || 'Page',
                    icon: icon || 'iconset_page',
                    target: target,
                };
                break;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CreateButton:
                return isButtonCreateAvailable
                    ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__containers_ButtonCreate__["a" /* default */], { key: key, options: options, position: position }))
                    : null;
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].CreateNote:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__containers_ButtonCreateNote__["a" /* default */], { key: key, position: position, label: label, icon: icon }));
            case __WEBPACK_IMPORTED_MODULE_1__typings_menu__["b" /* MenuItemType */].BackToPublication:
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__containers_BackToPublication__["a" /* default */], { key: key, position: position, label: label, icon: icon }));
        }
        if (itemArgs) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_MenuManager_Header_HeaderButton__["a" /* default */], __assign({}, itemArgs, { key: key })));
        }
        return null;
    };
    return HeaderSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (HeaderSection);


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuManager_Header_HeaderButton__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_menuManager__ = __webpack_require__(54);






var LocationPathName;
(function (LocationPathName) {
    LocationPathName["Folder"] = "/list/folder";
    LocationPathName["Selection"] = "/list/selection";
})(LocationPathName || (LocationPathName = {}));
var mapStateToProps = function (state, ownProps) {
    var appInfos = state.appInfos, config = state.galleryInfos.config, driveList = state.driveList, pathname = state.routing.locationBeforeTransitions.pathname, routerParamsHistory = state.routerParamsHistory, thumbMap = state.offlineManager.thumbMap;
    var driveItems = driveList.driveItems, resolutions = driveList.resolutions;
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].isMultiApp(appInfos);
    var icon = ownProps.icon, type = ownProps.type;
    var iconSrc = Object(__WEBPACK_IMPORTED_MODULE_5__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveItems, config, thumbMap, resolutions);
    var isItemActive = function () {
        if (type === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["b" /* MenuItemType */].Selection) {
            return pathname === LocationPathName.Selection;
        }
        else if (type === __WEBPACK_IMPORTED_MODULE_3__typings_menu__["b" /* MenuItemType */].Documents) {
            var currentFolderId = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getCurrentFolderId(config.applicationGallery, routerParamsHistory);
            var privateDirId = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getPrivateDirId(driveList, config);
            var sharedDirId = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSharedDirId(driveList, config);
            return pathname.includes(LocationPathName.Folder) &&
                __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, privateDirId, driveItems) &&
                !__WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].isDirDescendantOf(currentFolderId, sharedDirId, driveItems);
        }
        return false;
    };
    return {
        isMultiApp: isMultiApp,
        iconSrc: iconSrc,
        isActive: isItemActive(),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components_MenuManager_Header_HeaderButton__["a" /* default */]));


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_menu__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_MenuManager_actions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_menuManager__ = __webpack_require__(54);










var HeaderButton = function (props) {
    var handleClick = function () {
        var target = props.target, type = props.type, dispatch = props.dispatch;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Link:
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Asset:
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Folder:
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Page:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_MenuManager_actions__["b" /* openCustomItem */])(type, target));
                break;
            case __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].BurgerButton:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_MenuManager_actions__["d" /* requestOpenLeftSideMenu */])());
                break;
            default:
                __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].historyPush(target);
                break;
        }
    };
    var icon = props.icon, iconSrc = props.iconSrc, label = props.label, type = props.type, isMultiApp = props.isMultiApp, isActive = props.isActive;
    var tooltipId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].generateId();
    var isCustom = type === __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Link || type === __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Asset || type === __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Page || type === __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].Folder;
    var StyledButton = type !== __WEBPACK_IMPORTED_MODULE_5__typings_menu__["b" /* MenuItemType */].BurgerButton ? __WEBPACK_IMPORTED_MODULE_3__styles__["c" /* StyledHeaderButton */] : __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* StyledBurgerButton */];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StyledButton, { className: "StyledButton-" + type, onClick: handleClick, "data-tip": true, "data-for": tooltipId, isMultiApp: isMultiApp, isActive: isActive },
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc),
        !icon && label &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* TextButton */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label })),
        (__WEBPACK_IMPORTED_MODULE_6__utils_userAgent__["a" /* default */].isDesktop() && label) &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Tooltip__["a" /* default */], { id: tooltipId, text: label, isCustom: isCustom })));
};
/* harmony default export */ __webpack_exports__["a"] = (HeaderButton);


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_menuManager__ = __webpack_require__(54);








var ShareButton = function (_a) {
    var sharedItems = _a.sharedItems, sharedNotesIds = _a.sharedNotesIds, iconSrc = _a.iconSrc, label = _a.label, isInBottomBar = _a.isInBottomBar, isInMenuBar = _a.isInMenuBar, dispatch = _a.dispatch;
    var handleClick = function (e) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Share_actions__["k" /* share */])(sharedItems, sharedNotesIds));
    };
    var tooltipId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].generateId();
    var isTooltipDisplayed = __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isDesktop() && !isInBottomBar;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* StyledShareButton */], { isInBottomBar: isInBottomBar, isInMenuBar: isInMenuBar, onClick: handleClick, "data-tip": true, "data-for": tooltipId },
        isInMenuBar
            ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_uprez_share')
            : __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_uprez_share'),
        isInBottomBar &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ShareButtonLabel */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: 'messages.share_my_selection' })),
        isTooltipDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tooltip__["a" /* default */], { id: tooltipId, text: label || 'messages.share' })));
};
/* harmony default export */ __webpack_exports__["a"] = (ShareButton);


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledShareButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareButtonLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Page_styles__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledShareButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\n\t", "\n\n\t& > svg {\n\t\t", "\n\t}\n\n\t", "\n"], ["\n\tcursor: pointer;\n\n\t",
    "\n\n\t& > svg {\n\t\t",
    "\n\t}\n\n\t",
    "\n"])), function (p) { return p.isInBottomBar
    ? "\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tpadding: 15px;\n\t\t"
    : "\n\t\t\t" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["g" /* navBarButtonWrapperStyle */] + "\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t"; }, function (p) { return p.isInBottomBar
    ? "\n\t\t\t\tflex: 0 0 auto;\n\t\t\t\tfill: " + __WEBPACK_IMPORTED_MODULE_1__Page_styles__["g" /* bottomBarColor */] + ";\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t"
    : "\n\t\t\t\t" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["i" /* navBarIconStyle */] + "\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tfill: " + p.theme.primary.iconsColor + ";\n\t\t\t"; }, function (p) { return p.isInMenuBar && "\n\t\t& > img {\n\t\t\tmax-height: 30px;\n\t\t\tmax-width: 100%;\n\t\t\tmin-width: 30px;\n\t\t\tmargin: 0 10px;\n\t\t}\n\t"; });
var ShareButtonLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tcolor: ", ";\n\tmargin-left: 10px;\n"], ["\n\tfont-size: 13px;\n\tcolor: ", ";\n\tmargin-left: 10px;\n"])), __WEBPACK_IMPORTED_MODULE_1__Page_styles__["g" /* bottomBarColor */]);

var templateObject_1, templateObject_2;


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_Search_Button__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_menuManager__ = __webpack_require__(54);



var searchPathname = '/list/search';
var mapStateToProps = function (state, ownProps) {
    var isShown = state.search.isShown, pathname = state.routing.locationBeforeTransitions.pathname, config = state.galleryInfos.config, _a = state.driveList, driveItems = _a.driveItems, resolutions = _a.resolutions, thumbMap = state.offlineManager.thumbMap;
    var icon = ownProps.icon;
    return {
        iconSrc: Object(__WEBPACK_IMPORTED_MODULE_2__utils_menuManager__["b" /* getMenuButtonIconSrc */])(icon, driveItems, config, thumbMap, resolutions),
        isActive: isShown || pathname.includes(searchPathname),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_Search_Button__["a" /* default */]));


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_Search_actions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_menuManager__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var SearchButton = /** @class */ (function (_super) {
    __extends(SearchButton, _super);
    function SearchButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    SearchButton.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, iconSrc = _a.iconSrc, label = _a.label;
        var tooltipId = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].generateId();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* SearchButtonContainer */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledSearchButton */], { onClick: this.handleClick, "data-tip": true, "data-for": tooltipId, isActive: isActive },
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_uprez_search'),
                __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isDesktop() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tooltip__["a" /* default */], { id: tooltipId, text: label || 'messages.search' }))));
    };
    SearchButton.prototype.handleClick = function () {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_Search_actions__["c" /* toggleSearchFieldVisibility */])());
    };
    return SearchButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SearchButton);


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledSearchButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var SearchButtonContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\talign-items: center;\n"])));
var StyledSearchButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcursor: pointer;\n\t", "\n\tpadding: 4px 1px 2px;\n\tborder-color: transparent;\n\tbackground-color: transparent;\n\tbox-sizing: border-box;\n\ttransition: .1s ease-in-out;\n\ttransition-property: opacity, border-color;\n\n\t&:focus {\n\t\toutline: 0;\n\t}\n\n\t& > svg {\n\t\t", "\n\t\tfill: ", ";\n\t}\n\n\t& > img {\n\t\tmax-height: 30px;\n\t\tmax-width: 100%;\n\t\tmin-width: 30px;\n\t\tmargin: 0 10px;\n\t}\n\n\t&:active {\n\t\topacity: 0.3;\n\t}\n"], ["\n\tcursor: pointer;\n\t", "\n\tpadding: 4px 1px 2px;\n\tborder-color: transparent;\n\tbackground-color: transparent;\n\tbox-sizing: border-box;\n\ttransition: .1s ease-in-out;\n\ttransition-property: opacity, border-color;\n\n\t&:focus {\n\t\toutline: 0;\n\t}\n\n\t& > svg {\n\t\t", "\n\t\tfill: ",
    ";\n\t}\n\n\t& > img {\n\t\tmax-height: 30px;\n\t\tmax-width: 100%;\n\t\tmin-width: 30px;\n\t\tmargin: 0 10px;\n\t}\n\n\t&:active {\n\t\topacity: 0.3;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["g" /* navBarButtonWrapperStyle */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["i" /* navBarIconStyle */], function (props) { return props.isActive
    ? props.theme.primary.actionColor
    : props.theme.primary.iconsColor; });

var templateObject_1, templateObject_2;


/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Tooltip__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loader__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_menuManager__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var RESET_DELAY = 3000;
var DriveItemDownloadButton = /** @class */ (function (_super) {
    __extends(DriveItemDownloadButton, _super);
    function DriveItemDownloadButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, driveItems = _a.driveItems, dispatch = _a.dispatch, galleryInfos = _a.galleryInfos, action = _a.action;
            var isMobileApp = __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isMobileApp;
            if (action !== __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["a" /* ActionButton */].Update) {
                __WEBPACK_IMPORTED_MODULE_11__utils_statistics__["a" /* default */].trackDownload(driveItems);
            }
            var driveItemsIds = driveItems.map(function (driveItem) { return driveItem.id; });
            if (isMobileApp) {
                if (driveItems.length === 1) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions__["l" /* requestMobileAppDownload */])(driveItems[0], __WEBPACK_IMPORTED_MODULE_10__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested));
                    return;
                }
                driveItemsIds.forEach(function (itemId) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions__["g" /* downloadRecursively */])(itemId, __WEBPACK_IMPORTED_MODULE_10__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested));
                });
                return;
            }
            _this.setState({ clicked: true });
            setTimeout(function () { return _this.setState({ clicked: false }); }, RESET_DELAY);
            if (driveItems.length === 1) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions__["m" /* requestWebDownloadItem */])(driveItems[0]));
                return;
            }
            window.location.href = __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getResourcesGroupUrl(galleryInfos.config, driveItemsIds);
        };
        _this.renderButtonContent = function () {
            var _a = _this.props, style = _a.style, action = _a.action, isDownloading = _a.isDownloading, loaderStep = _a.loaderStep, iconSrc = _a.iconSrc;
            var isPhone = __WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isPhone();
            if (style === __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["b" /* ActionButtonStyle */].Icon) {
                return Object(__WEBPACK_IMPORTED_MODULE_12__utils_menuManager__["a" /* getMenuButtonIcon */])(iconSrc, 'iconset_uprez_download');
            }
            if (isDownloading) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_Loader__["c" /* default */], { loaderStep: loaderStep ? loaderStep : { step: __WEBPACK_IMPORTED_MODULE_9__components_Loader__["a" /* LoaderStepName */].Downloading }, type: __WEBPACK_IMPORTED_MODULE_9__components_Loader__["b" /* LoaderType */].Button }));
            }
            if (action === __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["a" /* ActionButton */].Update) {
                return isPhone ? __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_update') : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.update" });
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.download" });
        };
        _this.state = { clicked: false };
        return _this;
    }
    DriveItemDownloadButton.prototype.render = function () {
        var _a = this.props, action = _a.action, style = _a.style, isDownloading = _a.isDownloading, isDeletingAll = _a.isDeletingAll, label = _a.label, strongColor = _a.galleryInfos.template.commonStyles.primary.strongColor;
        var clicked = this.state.clicked;
        var isFlickering = isDownloading || clicked;
        var tooltipId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].generateId();
        var DownloadButton = __WEBPACK_IMPORTED_MODULE_5__styles__["a" /* DownloadButtonVariants */][style];
        return !isDeletingAll ?
            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DownloadButton, { onClick: this.handleClick, isFlickering: isFlickering, color: strongColor, action: action, "data-tip": style === __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["b" /* ActionButtonStyle */].Icon, "data-for": tooltipId },
                this.renderButtonContent(),
                (__WEBPACK_IMPORTED_MODULE_4__utils_userAgent__["a" /* default */].isDesktop() && style === __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["b" /* ActionButtonStyle */].Icon) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_Tooltip__["a" /* default */], { id: tooltipId, text: label || 'messages.download' }))) :
            null;
    };
    return DriveItemDownloadButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DriveItemDownloadButton);


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadButtonVariants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_styles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ParametersPage_styles__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;







var flicker = function (color) { return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["",
    ""])), Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t0% {fill: ", "; opacity:0;}\n\t25% {fill: ", "; opacity:0.5;}\n\t50% {fill: ", "; opacity:1;}\n"], ["\n\t0% {fill: ", "; opacity:0;}\n\t25% {fill: ", "; opacity:0.5;}\n\t50% {fill: ", "; opacity:1;}\n"])), color, color, color)); };
var DownloadButtonVariants = (_a = {},
    _a['Bar'] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Button_styles__["b" /* Button */])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tmargin: 20px 5px;\n\t\t", "\n\t"], ["\n\t\tmargin: 20px 5px;\n\t\t",
        "\n\t"])), function (props) { return props.action === __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["a" /* ActionButton */].Update
        ? "& > svg {\n\t\t\t\t\tfill: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue300 + ";\n\t\t\t\t}\n\n\t\t\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone + " {\n\t\t\t\t\tflex-basis: 25%;\n\t\t\t\t}"
        : "\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone + ", " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Tablet + "{\n\t\t\t\t\tflex: 0 0 content;\n\t\t\t\t}\n\t\t\t"; }),
    _a['Icon'] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\t", "\n\t\ttransition: all 0.2s;\n\n\t\t& > svg {\n\t\t\t", "\n\t\t\tfill: ", ";\n\t\t}\n\n\t\t& > img {\n\t\t\tmax-height: 30px;\n\t\t\tmax-width: 100%;\n\t\t\tmin-width: 30px;\n\t\t\tmargin: 0 10px;\n\t\t}\n\n\t\t& > svg,\n\t\t& > img {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t", "\n\t\ttransition: all 0.2s;\n\n\t\t& > svg {\n\t\t\t", "\n\t\t\tfill: ", ";\n\t\t}\n\n\t\t& > img {\n\t\t\tmax-height: 30px;\n\t\t\tmax-width: 100%;\n\t\t\tmin-width: 30px;\n\t\t\tmargin: 0 10px;\n\t\t}\n\n\t\t& > svg,\n\t\t& > img {\n\t\t\t", "\n\t\t}\n\t"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["g" /* navBarButtonWrapperStyle */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["i" /* navBarIconStyle */], function (props) { return props.theme.primary.iconsColor; }, function (props) { return props.isFlickering ? Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["animation: ", " 1s linear infinite;"], ["animation: ", " 1s linear infinite;"])), flicker(props.color)) : ''; }),
    _a['ParametersPage'] = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__ParametersPage_styles__["d" /* ParametersPageButton */])(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\n\t\t& div {\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t"], ["\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\n\t\t& div {\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600, 10); }, function (props) { return props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_5__utils_style__["a" /* hexToRgba */])(props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600, 15); }, function (props) { return props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600; }),
    _a);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Page_BottomBar__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var mapStateToProps = function (state) {
    var appInfos = state.appInfos, driveList = state.driveList, config = state.galleryInfos.config, profile = state.profile;
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isMultiApp(appInfos);
    var isReadOnlyApp = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isReadOnlyApp(profile.role);
    var privateDirId = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getPrivateDirId(driveList, config);
    return {
        showFolderCreation: isMultiApp && !isReadOnlyApp && !!privateDirId
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Page_BottomBar__["a" /* default */]));


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Share_ShareButton__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_FolderCreatorFromSelection__ = __webpack_require__(1397);





var PageBottomBar = function (props) {
    var selection = props.selection, showFolderCreation = props.showFolderCreation;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* StyledBottomBar */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* BottomBarBackground */], null,
            showFolderCreation &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_FolderCreatorFromSelection__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Share_ShareButton__["a" /* default */], { shareOrigin: __WEBPACK_IMPORTED_MODULE_3__containers_Share_actions__["a" /* ShareOrigin */].Selection, driveItems: selection, isInBottomBar: true }))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageBottomBar);


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FolderCreatorFromSelection__ = __webpack_require__(1398);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_FolderCreatorFromSelection__["a" /* default */]));


/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_FolderCreationPanel_actions__ = __webpack_require__(235);





var FolderCreatorFromSelection = function (_a) {
    var dispatch = _a.dispatch;
    var handleClick = function (e) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_FolderCreationPanel_actions__["d" /* openPanel */])(true));
    };
    var tooltipId = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].generateId();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* StyledFolderCreator */], { onClick: handleClick, "data-tip": true, "data-for": tooltipId },
        __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_uprez_documents'),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* FolderCreatorLabel */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: 'messages.save_in_documents' }))));
};
/* harmony default export */ __webpack_exports__["a"] = (FolderCreatorFromSelection);


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledFolderCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FolderCreatorLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Page_styles__ = __webpack_require__(151);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledFolderCreator = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 15px;\n\tcursor: pointer;\n\n\t& > svg {\n\t\tflex: 0 0 auto;\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 15px;\n\tcursor: pointer;\n\n\t& > svg {\n\t\tflex: 0 0 auto;\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__Page_styles__["g" /* bottomBarColor */]);
var FolderCreatorLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 13px;\n\tcolor: ", ";\n\tmargin-left: 10px;\n"], ["\n\tfont-size: 13px;\n\tcolor: ", ";\n\tmargin-left: 10px;\n"])), __WEBPACK_IMPORTED_MODULE_1__Page_styles__["g" /* bottomBarColor */]);

var templateObject_1, templateObject_2;


/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_Search_Field__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var mapStateToProps = function (state) {
    var search = state.search, driveList = state.driveList, _a = state.galleryInfos, config = _a.config, searchConfig = _a.template.search;
    var galleryMeta = __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getGalleryMeta(driveList, config);
    return {
        search: search,
        isTagsListDisplayed: searchConfig && searchConfig.showTags,
        availableTags: galleryMeta.availableTags,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItemList_Search_Field__["a" /* default */]));


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_Search_actions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagsList__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_keys__ = __webpack_require__(118);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};









var SearchField = /** @class */ (function (_super) {
    __extends(SearchField, _super);
    function SearchField(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClearClick = _this.handleClearClick.bind(_this);
        _this.handleCancelClick = _this.handleCancelClick.bind(_this);
        _this.handleConfirmClick = _this.handleConfirmClick.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleSearchTextChange = _this.handleSearchTextChange.bind(_this);
        _this.handleTagToggle = _this.handleTagToggle.bind(_this);
        _this.state = {
            searchText: '',
            tags: SearchField.getTagsFromSearchString(props.availableTags),
        };
        return _this;
    }
    SearchField.getTagsFromSearchString = function (availableTags) {
        if (!availableTags) {
            return [];
        }
        return availableTags.map(function (tag) { return ({
            label: tag,
            isActive: false,
        }); });
    };
    SearchField.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.handleKeyDown);
    };
    SearchField.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.handleKeyDown);
    };
    SearchField.prototype.render = function () {
        var _this = this;
        var isTagsListDisplayed = this.props.isTagsListDisplayed;
        var _a = this.state, searchText = _a.searchText, tags = _a.tags;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* SearchFieldContainer */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* SearchFieldHeader */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* SearchFieldHeaderSection */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ButtonAction */], { onClick: this.handleCancelClick },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* SearchFieldHeaderSection */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* SearchFieldHeaderLabel */], { value: "messages.search" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* SearchFieldHeaderSection */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ButtonAction */], { disabled: this.isSearchDisabled, onClick: this.handleConfirmClick },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.ok" })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* SearchFieldBody */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* SearchFieldBar */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* SearchFieldIcon */], null, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_uprez_menu_search')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* SearchFieldInput */], { ref: function (element) { _this.inputElement = element; }, value: searchText, onChange: this.handleSearchTextChange, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.placeholder_search_drive_item'), autoFocus: true }),
                    searchText &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* ButtonClear */], { onClick: this.handleClearClick }, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon('iconset_close_bar'))),
                isTagsListDisplayed && tags.length > 0 &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TagsList__["a" /* default */], { tags: tags, onTagToggle: this.handleTagToggle }))));
    };
    Object.defineProperty(SearchField.prototype, "isSearchDisabled", {
        get: function () {
            var _a = this.state, searchText = _a.searchText, tags = _a.tags;
            return !searchText && tags.every(function (_a) {
                var isActive = _a.isActive;
                return !isActive;
            });
        },
        enumerable: true,
        configurable: true
    });
    SearchField.prototype.handleCancelClick = function () {
        this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_Search_actions__["c" /* toggleSearchFieldVisibility */])());
    };
    SearchField.prototype.handleConfirmClick = function () {
        if (this.isSearchDisabled) {
            return;
        }
        var dispatch = this.props.dispatch;
        var _a = this.state, searchText = _a.searchText, tags = _a.tags;
        var searchString = searchText;
        var activeTags = tags
            .filter(function (_a) {
            var isActive = _a.isActive;
            return isActive;
        })
            .map(function (_a) {
            var label = _a.label;
            return label;
        });
        if (activeTags.length > 0) {
            searchString += "" + __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemListPage_constants__["b" /* TagMarkers */].Start + activeTags.join(',') + __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemListPage_constants__["b" /* TagMarkers */].End;
        }
        window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_7__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Search, encodeURIComponent(searchString));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_DriveItemList_Search_actions__["c" /* toggleSearchFieldVisibility */])());
    };
    SearchField.prototype.handleKeyDown = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_8__utils_keys__["a" /* default */].isEnter(e.key)) {
            e.preventDefault();
            this.handleConfirmClick();
        }
        if (__WEBPACK_IMPORTED_MODULE_8__utils_keys__["a" /* default */].isEsc(e.key)) {
            e.preventDefault();
            this.handleCancelClick();
        }
    };
    SearchField.prototype.handleClearClick = function (e) {
        e.preventDefault();
        this.setState({ searchText: '' });
        this.inputElement.focus();
    };
    SearchField.prototype.handleSearchTextChange = function (e) {
        this.setState({ searchText: e.currentTarget.value });
    };
    SearchField.prototype.handleTagToggle = function (index) {
        this.setState({
            tags: __spread(this.state.tags.slice(0, index), [
                __assign({}, this.state.tags[index], { isActive: !this.state.tags[index].isActive })
            ], this.state.tags.slice(index + 1)),
        });
    };
    return SearchField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SearchField);


/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SearchFieldContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SearchFieldHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SearchFieldHeaderSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SearchFieldHeaderLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchFieldBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SearchFieldInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SearchFieldBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SearchFieldIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonClear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var SearchFieldContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\twidth: 100%;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 10;\n\ttransition: all 0.3s;\n\tbackground-color: ", ";\n\tbox-shadow: 0 5px 10px 1px ", ";\n\n\t", "\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\twidth: 100%;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 10;\n\ttransition: all 0.3s;\n\tbackground-color: ", ";\n\tbox-shadow: 0 5px 10px 1px ", ";\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var backgroundColor = _a.theme.primary.backgroundColor;
    return backgroundColor !== 'transparent' ? backgroundColor : __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White;
}, Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Black, 10), __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var SearchFieldHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 50px;\n\tpadding: 0 20px;\n\n\t@media ", " {\n\t\tpadding: 0 10px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 50px;\n\tpadding: 0 20px;\n\n\t@media ", " {\n\t\tpadding: 0 10px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Smartphone);
var SearchFieldHeaderSection = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex: 1 1 33.33%;\n\tdisplay: flex;\n\n\t&:nth-child(2) {\n\t\tjustify-content: center;\n\t}\n\n\t&:last-child {\n\t\tjustify-content: flex-end;\n\t}\n"], ["\n\tflex: 1 1 33.33%;\n\tdisplay: flex;\n\n\t&:nth-child(2) {\n\t\tjustify-content: center;\n\t}\n\n\t&:last-child {\n\t\tjustify-content: flex-end;\n\t}\n"])));
var SearchFieldBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 15px 50px;\n\n\t@media ", " {\n\t\tpadding: 10px 25px;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 15px 50px;\n\n\t@media ", " {\n\t\tpadding: 10px 25px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["a" /* Format */].Smartphone);
var ButtonAction = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t", "\n"], ["\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n\n\t",
    "\n"])), function (props) { return props.theme.primary.actionColor; }, function (props) { return props.disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t"; });
var SearchFieldHeaderLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n"])), function (props) { return props.theme.primary.strongColor; });
var SearchFieldBar = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\ttransition: all 0.2s;\n\toverflow: hidden;\n\tbackground: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 10px;\n\theight: 36px;\n\twidth: 100%;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\ttransition: all 0.2s;\n\toverflow: hidden;\n\tbackground: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 10px;\n\theight: 36px;\n\twidth: 100%;\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey50, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey100);
var SearchFieldInput = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('input')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tbackground: ", ";\n\tflex-grow: 1;\n\toutline: 0;\n\ttext-overflow: ellipsis;\n\tcolor: ", ";\n\tfont-size: 15px;\n\tletter-spacing: 0.15px;\n\tborder: 0;\n\n\t::placeholder{\n\t\tcolor: ", ";\n\t};\n\n\t/* removes the clear field \"X\" button automatically added by IE & Edge*/\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n"], ["\n\tbackground: ", ";\n\tflex-grow: 1;\n\toutline: 0;\n\ttext-overflow: ellipsis;\n\tcolor: ", ";\n\tfont-size: 15px;\n\tletter-spacing: 0.15px;\n\tborder: 0;\n\n\t::placeholder{\n\t\tcolor: ", ";\n\t};\n\n\t/* removes the clear field \"X\" button automatically added by IE & Edge*/\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey50, Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Black, 50), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Black, 50));
var SearchFieldIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0 10px;\n\tpadding: 1px 6px;\n\n\tsvg {\n\t\tfill: ", ";\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0 10px;\n\tpadding: 1px 6px;\n\n\tsvg {\n\t\tfill: ", ";\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Black, 50));
var ButtonClear = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0 10px;\n\tpadding: 1px 6px;\n\tborder: 0;\n\tbackground: none;\n\toutline: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\tfill: ", ";\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"], ["\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0 10px;\n\tpadding: 1px 6px;\n\tborder: 0;\n\tbackground: none;\n\toutline: 0;\n\tcursor: pointer;\n\n\tsvg {\n\t\tfill: ", ";\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].Grey500);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;


/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tag__ = __webpack_require__(1404);



var TagsList = function (_a) {
    var tags = _a.tags, onTagToggle = _a.onTagToggle;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledLabel */], { value: "messages.select_your_tags" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* StyledTagsList */], null, tags.map(function (_a, index) {
            var label = _a.label, isActive = _a.isActive;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: index },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tag__["a" /* default */], { index: index, label: label, isActive: isActive, onToggle: function () { return onTagToggle(index); } })));
        }))));
};
/* harmony default export */ __webpack_exports__["a"] = (TagsList);


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(574);


var Tag = function (_a) {
    var index = _a.index, label = _a.label, isActive = _a.isActive, onToggle = _a.onToggle;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledTag */], { isActive: isActive, onClick: function () { return onToggle(index); } }, label));
};
/* harmony default export */ __webpack_exports__["a"] = (Tag);


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_lib_hashHistory__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_lib_hashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_lib_hashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var NotFoundPage = /** @class */ (function (_super) {
    __extends(NotFoundPage, _super);
    function NotFoundPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headElement = document.getElementsByTagName('head')[0];
        return _this;
    }
    NotFoundPage.prototype.componentDidMount = function () {
        if (this.headElement) {
            var linkNode = document.createElement('link');
            linkNode.setAttribute('rel', 'canonical');
            linkNode.setAttribute('href', location.origin + location.pathname + "#/error404");
            this.headElement.appendChild(linkNode);
        }
    };
    NotFoundPage.prototype.componentWillUnmount = function () {
        if (this.headElement) {
            var linkNodes = this.headElement.getElementsByTagName('link');
            for (var i = 0; i < linkNodes.length; i++) {
                var linkNode = linkNodes[i];
                if (linkNode.rel === 'canonical') {
                    var linknodeParent = linkNode.parentElement;
                    if (linknodeParent) {
                        linknodeParent.removeChild(linkNode);
                    }
                }
            }
        }
    };
    NotFoundPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_4__containers_Page_constants__["a" /* PageType */].ParametersPage, title: "messages.page_not_found" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#" + __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getPathHome() + __WEBPACK_IMPORTED_MODULE_3_react_router_lib_hashHistory___default.a.getCurrentLocation().search },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__["Translate"], { value: "messages.back_to_home" }))));
    };
    return NotFoundPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ViewDriveItemPage__ = __webpack_require__(1407);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_ViewDriveItemPage__["a" /* default */]));


/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




var ViewDriveItemPage = function (_a) {
    var dispatch = _a.dispatch, params = _a.params;
    var redirectToDriveItemPage = function () { return __awaiter(_this, void 0, void 0, function () {
        var driveItemId, page, driveItem, publicationOption, notRedirected, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    driveItemId = getDriveItemId();
                    page = getPage();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(driveItemId))];
                case 2:
                    driveItem = _a.sent();
                    if (Object.keys(driveItem).length === 0) { // handle case where driveItem is {}
                        redirectToHome();
                        return [2 /*return*/];
                    }
                    publicationOption = {
                        page: page,
                        hideWelcomePage: !!page,
                    };
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["L" /* viewDriveItem */])(driveItem, __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["c" /* DriveItemOrigin */].List, publicationOption, true));
                    notRedirected = !__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["M" /* viewableInGallery */].includes(driveItem.type) && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp;
                    if (notRedirected) {
                        redirectToHome();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    redirectToHome();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getDriveItemId = function () {
        return parseInt(params.driveItemId, 10);
    };
    var getPage = function () {
        if (params.page) {
            return parseInt(params.page, 10);
        }
        return undefined;
    };
    var redirectToHome = function () {
        __WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].historyPush(__WEBPACK_IMPORTED_MODULE_2__utils_routes__["a" /* default */].getPathHome());
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        redirectToDriveItemPage();
    }, [params]);
    return null;
};
/* harmony default export */ __webpack_exports__["a"] = (ViewDriveItemPage);


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DriveItemListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extends_Downloads__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extends_Selection__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extends_Folder__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extends_New__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__extends_Search__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extends_Assortment__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_driveItem__ = __webpack_require__(11);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var DriveItemListPage = /** @class */ (function (_super) {
    __extends(DriveItemListPage, _super);
    function DriveItemListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeView(props);
        _this.isGalleryMetaFetched = props.isGalleryMetaFetched;
        return _this;
    }
    DriveItemListPage.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.params.origin !== this.props.params.origin) {
            this.initializeView(nextProps);
        }
        if (!this.isGalleryMetaFetched && nextProps.isGalleryMetaFetched) {
            this.isGalleryMetaFetched = nextProps.isGalleryMetaFetched;
        }
    };
    DriveItemListPage.prototype.render = function () {
        var ResolvedDriveItemListPage = this.resolvedDriveItemListPage;
        if (ResolvedDriveItemListPage && this.isGalleryMetaFetched) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ResolvedDriveItemListPage, __assign({}, this.props));
        }
        return null;
    };
    Object.defineProperty(DriveItemListPage.prototype, "resolvedDriveItemListPage", {
        get: function () {
            switch (this.props.params.origin) {
                case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */].Folder:
                    return __WEBPACK_IMPORTED_MODULE_5__extends_Folder__["a" /* default */];
                case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */].Selection:
                    return __WEBPACK_IMPORTED_MODULE_4__extends_Selection__["a" /* default */];
                case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */].New:
                    return __WEBPACK_IMPORTED_MODULE_6__extends_New__["a" /* default */];
                case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */].Search:
                    return __WEBPACK_IMPORTED_MODULE_7__extends_Search__["a" /* default */];
                case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */].Assortment:
                    return __WEBPACK_IMPORTED_MODULE_8__extends_Assortment__["a" /* default */];
                case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */].Downloads:
                    return __WEBPACK_IMPORTED_MODULE_3__extends_Downloads__["a" /* default */];
            }
        },
        enumerable: true,
        configurable: true
    });
    DriveItemListPage.prototype.initializeView = function (props) {
        for (var item in __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */]) {
            if (__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DriveItemListOrigin */][item] === props.params.origin) {
                return;
            }
        }
        __WEBPACK_IMPORTED_MODULE_9__utils_routes__["a" /* default */].getPageNotFound();
    };
    return DriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var mapStateToProps = function (state) {
    var driveList = state.driveList, downloadManager = state.downloadManager, routerParamsHistory = state.routerParamsHistory, galleryId = state.galleryInfos.config.applicationGallery, profile = state.profile;
    var folderId = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* default */].getCurrentFolderId(galleryId, routerParamsHistory);
    return {
        galleryId: galleryId,
        driveList: driveList,
        downloadManager: downloadManager,
        isGalleryMetaFetched: __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* default */].isGalleryMetaFetched(),
        displayType: __WEBPACK_IMPORTED_MODULE_11__utils_driveItem__["d" /* default */].getDisplayType(driveList, routerParamsHistory, folderId),
        isReadOnlyApp: __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* default */].isReadOnlyApp(profile.role),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(DriveItemListPage));


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var DownloadsDriveItemListPage = /** @class */ (function (_super) {
    __extends(DownloadsDriveItemListPage, _super);
    function DownloadsDriveItemListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerLabel = 'messages.downloads';
        _this.noItemsLabel = 'messages.no_downloads';
        _this.showUnreadBadge = true;
        return _this;
    }
    DownloadsDriveItemListPage.prototype.initializeView = function (props) {
        return;
    };
    DownloadsDriveItemListPage.prototype.getDriveItemIds = function () {
        var _a = this.props, downloadManager = _a.downloadManager, driveList = _a.driveList;
        var downloadedItems = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getDownloadedItems(downloadManager).reverse();
        var downloadingItems = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getDownloadingItems(downloadManager).reverse();
        var displayableDownloadedItems = downloadedItems
            .filter(function (id) { return driveList.driveItems[id]
            && __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, id); });
        var displayableDownloadingItems = downloadingItems
            .filter(function (id) { return driveList.driveItems[id] && __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].isRequestedItem(downloadManager, id); });
        return __spread(displayableDownloadedItems, displayableDownloadingItems);
    };
    Object.defineProperty(DownloadsDriveItemListPage.prototype, "sliderKey", {
        get: function () {
            return this.props.params.origin;
        },
        enumerable: true,
        configurable: true
    });
    DownloadsDriveItemListPage.prototype.renderAdditionalItems = function () {
        return null;
    };
    DownloadsDriveItemListPage.prototype.getAdditionalItemsLength = function () {
        return 0;
    };
    return DownloadsDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_1__abstract__["a" /* default */]));
var mapStateToProps = function (state) {
    var downloadManager = state.downloadManager;
    return { downloadManager: downloadManager };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(DownloadsDriveItemListPage));


/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItemList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_constants__ = __webpack_require__(59);






var mapStateToProps = function (state, ownProps) {
    var driveList = state.driveList, routerParamsHistory = state.routerParamsHistory, galleryInfos = state.galleryInfos, searchConfig = state.galleryInfos.template.search, appInfos = state.appInfos, profile = state.profile;
    var isMultiApp = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMultiApp(appInfos);
    var driveItems = driveList.driveItems, isEditMode = driveList.isEditMode, isLoading = driveList.isLoading;
    var folderId = ownProps.folderId;
    var privateDirId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getPrivateDirId(driveList, galleryInfos.config);
    var currentFolderId = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getCurrentFolderId(galleryInfos.config.applicationGallery, routerParamsHistory);
    var isPrivateDir = privateDirId === currentFolderId;
    var isReadOnlyApp = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isReadOnlyApp(profile.role);
    var currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
    var routes = currentRoute.routes;
    var rootDirIdForEditMode = __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getRootDirIdForEditMode(state);
    var isEditButtonDisplayed = __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].isDirDescendantOf(folderId, rootDirIdForEditMode, driveItems) && !isReadOnlyApp;
    return {
        displayType: __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getDisplayType(driveList, routerParamsHistory, folderId),
        storeDriveItems: driveItems,
        isPrivateDir: isPrivateDir,
        sharedDirId: __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSharedDirId(driveList, galleryInfos.config),
        sourcesDirId: __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSourcesDirId(driveList, galleryInfos.config),
        searchConfig: searchConfig,
        isEditMode: isEditMode,
        isEditButtonDisplayed: isEditButtonDisplayed,
        isLoading: isLoading,
        shouldGetCustomTemplates: isMultiApp && !isReadOnlyApp,
        isTheaterOpened: __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].doesRoutesContainsPath(__WEBPACK_IMPORTED_MODULE_5__routes_constants__["a" /* RoutePath */].TheaterList, routes),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItemList__["a" /* default */]));


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuManager_Header_HeaderButton_CancelButton__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuManager_constants__ = __webpack_require__(217);




var Translate = __webpack_require__(5).Translate;
var TheaterHeader = function (props) {
    var leavePage = props.leavePage, sliderIndex = props.sliderIndex, sliderLength = props.sliderLength;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* StyledTheaterHeader */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* LeftBlock */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* CenterBlock */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Translate, { value: "messages.page_index", index: sliderIndex, count: sliderLength, dangerousHTML: true })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* RightBlock */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_MenuManager_Header_HeaderButton_CancelButton__["a" /* default */], { actionOrigin: __WEBPACK_IMPORTED_MODULE_3__MenuManager_constants__["a" /* CancelActionOrigin */].Theater, leavePage: leavePage }))));
};
/* harmony default export */ __webpack_exports__["a"] = (TheaterHeader);


/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledTheaterHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LeftBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CenterBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RightBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledTheaterHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\theight: ", ";\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\twidth: 100%;\n\talign-items: center;\n\tflex-direction: row;\n\tpadding: 0 10px;\n"], ["\n\tdisplay: flex;\n\theight: ", ";\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\twidth: 100%;\n\talign-items: center;\n\tflex-direction: row;\n\tpadding: 0 10px;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["h" /* navBarHeight */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var LeftBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\ttext-align: left;\n\tflex-basis: 33.3%;\n"], ["\n\ttext-align: left;\n\tflex-basis: 33.3%;\n"])));
var CenterBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\ttext-align: center;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tflex-basis: 33.3%;\n"], ["\n\ttext-align: center;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tflex-basis: 33.3%;\n"])));
var RightBlock = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex-basis: 33.3%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t& svg {\n\t\tfill: ", ";\n\t}\n"], ["\n\tflex-basis: 33.3%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t& svg {\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Selection_Toggler__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_statistics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DownloadManager_reducer__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);










var TheaterFooter = function (_a) {
    var driveItem = _a.driveItem, isDownloadable = _a.isDownloadable, dispatch = _a.dispatch;
    var extension = __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getExtension(driveItem);
    var label = __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].getDisplayName(driveItem);
    var handleDownloadClick = function () {
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp;
        __WEBPACK_IMPORTED_MODULE_6__utils_statistics__["a" /* default */].trackDownload([driveItem]);
        if (!isMobileApp) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_DownloadManager_actions__["m" /* requestWebDownloadItem */])(driveItem));
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_DownloadManager_actions__["l" /* requestMobileAppDownload */])(driveItem, __WEBPACK_IMPORTED_MODULE_7__containers_DownloadManager_reducer__["c" /* DownloadMode */].Requested));
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledTheaterFooter */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Extension */], null, extension),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Label */], null, label),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ActionIcons */], null,
            isDownloadable &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* DownloadButton */], { type: "button", onClick: handleDownloadClick }, __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_uprez_download_bold')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Selection_Toggler__["a" /* default */], { itemId: driveItem.id, displayMode: __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["c" /* ResolutionDisplayType */].Theater }))));
};
var mapStateToProps = function (state, ownProps) {
    var sharedMethods = state.galleryInfos.template.sharedMethods, downloadManager = state.downloadManager;
    return {
        downloadManager: downloadManager,
        sharedMethods: sharedMethods,
        isDownloadable: __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].isDownloadable(ownProps.driveItem, downloadManager, sharedMethods),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TheaterFooter));


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledTheaterFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Extension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DownloadButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledTheaterFooter = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground: ", ";\n\tcolor: ", ";\n\twidth: 100%;\n\tmin-height: 60px;\n\tflex-shrink: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 14px;\n\tpadding: 15px 10px 15px 25px;\n\tbox-sizing: border-box;\n\tfill: ", ";\n"], ["\n\tbackground: ", ";\n\tcolor: ", ";\n\twidth: 100%;\n\tmin-height: 60px;\n\tflex-shrink: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 14px;\n\tpadding: 15px 10px 15px 25px;\n\tbox-sizing: border-box;\n\tfill: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey800, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey600);
var Extension = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbackground-color: rgba(0,0,0,.5);\n\tborder-radius: 2px;\n\tborder: 1px solid rgba(255,255,255,.5);\n\tcolor: ", ";\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\tpadding: 4px 8px;\n\tmargin-right: 15px;\n"], ["\n\tbackground-color: rgba(0,0,0,.5);\n\tborder-radius: 2px;\n\tborder: 1px solid rgba(255,255,255,.5);\n\tcolor: ", ";\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\tpadding: 4px 8px;\n\tmargin-right: 15px;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex-grow: 1;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tflex-grow: 1;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var ActionIcons = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmin-width: 160px;\n\n\t> * {\n\t\t", ";\n\t}\n\n\tsvg {\n\t\t", "\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmin-width: 160px;\n\n\t> * {\n\t\t", ";\n\t}\n\n\tsvg {\n\t\t", "\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["g" /* navBarButtonWrapperStyle */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["i" /* navBarIconStyle */], __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey600);
var DownloadButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n"], ["\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TheaterItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TheaterOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheaterContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var TheaterItem = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight:100%;\n"], ["\n\theight:100%;\n"])));
var TheaterOverlay = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 10;\n\tbackground: ", ";\n\ttransition: opacity .4s cubic-bezier(.25,.8,.25,1);\n\n\t", "\n\n\t", "\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 10;\n\tbackground: ", ";\n\ttransition: opacity .4s cubic-bezier(.25,.8,.25,1);\n\n\t",
    "\n\n\t",
    "\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isMacApp() && "\n\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["f" /* macTopBarHeight */] + ";\n\t", __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isIOS() && "\n\t\t@media " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphonePortraitNotch + " {\n\t\t\tpadding-top: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t\ttop: -" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["j" /* notchHeight */] + ";\n\t\t}\n\t");
var TheaterContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\theight: 100%;\n"], ["\n\theight: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoPlayer__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AudioPlayer__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_downloadManager__ = __webpack_require__(41);











var TheaterContent = function (props) {
    var driveItem = props.driveItem, resolutions = props.resolutions, galleryInfos = props.galleryInfos, downloadManager = props.downloadManager, thumbMap = props.offlineManager.thumbMap;
    var galleryConfig = galleryInfos.config;
    var isOnline = __WEBPACK_IMPORTED_MODULE_9__utils_userAgent__["a" /* default */].isOnline();
    var isDownloaded = false;
    if (driveItem !== undefined) {
        isDownloaded = __WEBPACK_IMPORTED_MODULE_10__utils_downloadManager__["a" /* default */].isItemDownloaded(downloadManager, driveItem.id);
    }
    var element;
    if (driveItem) {
        var fileUrl = void 0;
        if (isOnline || isDownloaded) {
            if (isDownloaded) {
                fileUrl = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getPersistentDownloadsFolder() + "/" + __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getDownloadedFileName(driveItem);
            }
            else {
                fileUrl = __WEBPACK_IMPORTED_MODULE_7__utils_url__["b" /* default */].getItemOriginalFileUrl(galleryConfig, driveItem.originalFile);
            }
            switch (driveItem.type) {
                case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Movie:
                    element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_VideoPlayer__["a" /* default */], { url: fileUrl });
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Image:
                    var imgSrc = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getTheaterImage(driveItem, galleryInfos.config, resolutions);
                    element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Image */], { src: isDownloaded ? fileUrl : imgSrc });
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Sound:
                    element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_AudioPlayer__["a" /* default */], { url: fileUrl });
                    break;
                default:
                    if (__WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].hasIcon(driveItem)) {
                        var thumbSrc = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getThumbnail(driveItem, galleryInfos.config, resolutions, true);
                        element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Image */], { src: thumbSrc });
                    }
                    else {
                        var svgIcon = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getDefaultThumbnail(driveItem);
                        element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* SvgIcon */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use", { xlinkHref: "#svgicon-" + svgIcon }));
                    }
                    break;
            }
        }
        else {
            if (__WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].hasIcon(driveItem)) {
                fileUrl = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getDeviceThumbnailPath(galleryInfos.config, thumbMap, driveItem, resolutions, false);
                element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Image */], { src: fileUrl });
            }
            else {
                var svgIcon = __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].getDefaultThumbnail(driveItem);
                element = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* SvgIcon */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use", { xlinkHref: "#svgicon-" + svgIcon }));
            }
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* StyledTheaterContent */], null, element));
};
var mapStateToProps = function (state) {
    var downloadManager = state.downloadManager, offlineManager = state.offlineManager;
    return { downloadManager: downloadManager, offlineManager: offlineManager };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TheaterContent));


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_react__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_video_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_video_react_dist_video_react_css__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_video_react_dist_video_react_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_video_react_dist_video_react_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var VideoPlayer = /** @class */ (function (_super) {
    __extends(VideoPlayer, _super);
    function VideoPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoPlayer.prototype.render = function () {
        var url = this.props.url;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_video_react__["Player"], { autoPlay: true, playsInline: true, fluid: false, height: '100%', src: url },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_video_react__["BigPlayButton"], { position: "center" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_video_react__["ControlBar"], { autoHide: false })));
    };
    return VideoPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (VideoPlayer);


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video["default"];
  }
});
Object.defineProperty(exports, "BigPlayButton", {
  enumerable: true,
  get: function get() {
    return _BigPlayButton["default"];
  }
});
Object.defineProperty(exports, "LoadingSpinner", {
  enumerable: true,
  get: function get() {
    return _LoadingSpinner["default"];
  }
});
Object.defineProperty(exports, "PosterImage", {
  enumerable: true,
  get: function get() {
    return _PosterImage["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "Bezel", {
  enumerable: true,
  get: function get() {
    return _Bezel["default"];
  }
});
Object.defineProperty(exports, "Shortcut", {
  enumerable: true,
  get: function get() {
    return _Shortcut["default"];
  }
});
Object.defineProperty(exports, "ControlBar", {
  enumerable: true,
  get: function get() {
    return _ControlBar["default"];
  }
});
Object.defineProperty(exports, "PlayToggle", {
  enumerable: true,
  get: function get() {
    return _PlayToggle["default"];
  }
});
Object.defineProperty(exports, "ForwardControl", {
  enumerable: true,
  get: function get() {
    return _ForwardControl["default"];
  }
});
Object.defineProperty(exports, "ReplayControl", {
  enumerable: true,
  get: function get() {
    return _ReplayControl["default"];
  }
});
Object.defineProperty(exports, "FullscreenToggle", {
  enumerable: true,
  get: function get() {
    return _FullscreenToggle["default"];
  }
});
Object.defineProperty(exports, "ProgressControl", {
  enumerable: true,
  get: function get() {
    return _ProgressControl["default"];
  }
});
Object.defineProperty(exports, "SeekBar", {
  enumerable: true,
  get: function get() {
    return _SeekBar["default"];
  }
});
Object.defineProperty(exports, "PlayProgressBar", {
  enumerable: true,
  get: function get() {
    return _PlayProgressBar["default"];
  }
});
Object.defineProperty(exports, "LoadProgressBar", {
  enumerable: true,
  get: function get() {
    return _LoadProgressBar["default"];
  }
});
Object.defineProperty(exports, "MouseTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _MouseTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "VolumeMenuButton", {
  enumerable: true,
  get: function get() {
    return _VolumeMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRateMenuButton", {
  enumerable: true,
  get: function get() {
    return _PlaybackRateMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRate", {
  enumerable: true,
  get: function get() {
    return _PlaybackRate["default"];
  }
});
Object.defineProperty(exports, "ClosedCaptionButton", {
  enumerable: true,
  get: function get() {
    return _ClosedCaptionButton["default"];
  }
});
Object.defineProperty(exports, "RemainingTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _RemainingTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "CurrentTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _CurrentTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "DurationDisplay", {
  enumerable: true,
  get: function get() {
    return _DurationDisplay["default"];
  }
});
Object.defineProperty(exports, "TimeDivider", {
  enumerable: true,
  get: function get() {
    return _TimeDivider["default"];
  }
});
Object.defineProperty(exports, "MenuButton", {
  enumerable: true,
  get: function get() {
    return _MenuButton["default"];
  }
});
Object.defineProperty(exports, "playerReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.playerReducer;
  }
});
Object.defineProperty(exports, "operationReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.operationReducer;
  }
});
exports.videoActions = exports.playerActions = void 0;

var _Player = _interopRequireDefault(__webpack_require__(1419));

var _Video = _interopRequireDefault(__webpack_require__(581));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(578));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(579));

var _PosterImage = _interopRequireDefault(__webpack_require__(580));

var _Slider = _interopRequireDefault(__webpack_require__(364));

var _Bezel = _interopRequireDefault(__webpack_require__(583));

var _Shortcut = _interopRequireDefault(__webpack_require__(584));

var _ControlBar = _interopRequireDefault(__webpack_require__(585));

var _PlayToggle = _interopRequireDefault(__webpack_require__(591));

var _ForwardControl = _interopRequireDefault(__webpack_require__(592));

var _ReplayControl = _interopRequireDefault(__webpack_require__(594));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(595));

var _ProgressControl = _interopRequireDefault(__webpack_require__(586));

var _SeekBar = _interopRequireDefault(__webpack_require__(587));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(588));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(589));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(590));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(600));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(365));

var _PlaybackRate = _interopRequireDefault(__webpack_require__(1441));

var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(1442));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(596));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(597));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(598));

var _TimeDivider = _interopRequireDefault(__webpack_require__(599));

var _MenuButton = _interopRequireDefault(__webpack_require__(366));

var playerActions = _interopRequireWildcard(__webpack_require__(251));

exports.playerActions = playerActions;

var videoActions = _interopRequireWildcard(__webpack_require__(363));

exports.videoActions = videoActions;

var _reducers = __webpack_require__(576);

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(361));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(362));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _Manager = _interopRequireDefault(__webpack_require__(1425));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(578));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(579));

var _PosterImage = _interopRequireDefault(__webpack_require__(580));

var _Video = _interopRequireDefault(__webpack_require__(581));

var _Bezel = _interopRequireDefault(__webpack_require__(583));

var _Shortcut = _interopRequireDefault(__webpack_require__(584));

var _ControlBar = _interopRequireDefault(__webpack_require__(585));

var browser = _interopRequireWildcard(__webpack_require__(1440));

var _dom = __webpack_require__(252);

var _utils = __webpack_require__(72);

var _fullscreen = _interopRequireDefault(__webpack_require__(577));

var propTypes = {
  children: _propTypes["default"].any,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  fluid: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  aspectRatio: _propTypes["default"].string,
  className: _propTypes["default"].string,
  videoId: _propTypes["default"].string,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  store: _propTypes["default"].object
};
var defaultProps = {
  fluid: true,
  muted: false,
  playsInline: false,
  preload: 'auto',
  aspectRatio: 'auto'
};

var Player =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Player, _Component);

  function Player(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Player);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
    _this.controlsHideTimer = null;
    _this.video = null; // the Video component

    _this.manager = new _Manager["default"](props.store);
    _this.actions = _this.manager.getActions();

    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));

    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);

      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener
      window.removeEventListener('resize', this.handleResize);

      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);

      if (this.controlsHideTimer) {
        window.clearTimeout(this.controlsHideTimer);
      }
    }
  }, {
    key: "getDefaultChildren",
    value: function getDefaultChildren(originalChildren) {
      var _this2 = this;

      return [_react["default"].createElement(_Video["default"], {
        ref: function ref(c) {
          _this2.video = c;
          _this2.manager.video = _this2.video;
        },
        key: "video",
        order: 0.0
      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
        key: "poster-image",
        order: 1.0
      }), _react["default"].createElement(_LoadingSpinner["default"], {
        key: "loading-spinner",
        order: 2.0
      }), _react["default"].createElement(_Bezel["default"], {
        key: "bezel",
        order: 3.0
      }), _react["default"].createElement(_BigPlayButton["default"], {
        key: "big-play-button",
        order: 4.0
      }), _react["default"].createElement(_ControlBar["default"], {
        key: "control-bar",
        order: 5.0
      }), _react["default"].createElement(_Shortcut["default"], {
        key: "shortcut",
        order: 99.0
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren(props) {
      var _ = props.className,
          originalChildren = props.children,
          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);

      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
        return !(0, _utils.isVideoChild)(e);
      });

      var defaultChildren = this.getDefaultChildren(originalChildren);
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
    }
  }, {
    key: "setWidthOrHeight",
    value: function setWidthOrHeight(style, name, value) {
      var styleVal;

      if (typeof value === 'string') {
        if (value === 'auto') {
          styleVal = 'auto';
        } else if (value.match(/\d+%/)) {
          styleVal = value;
        }
      } else if (typeof value === 'number') {
        styleVal = "".concat(value, "px");
      }

      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          fluid = _this$props.fluid,
          propsAspectRatio = _this$props.aspectRatio,
          propsHeight = _this$props.height,
          propsWidth = _this$props.width;

      var _this$manager$getStat = this.manager.getState(),
          player = _this$manager$getStat.player;

      var style = {};
      var width;
      var height;
      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.

      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
        // Use any aspectRatio that's been specifically set
        aspectRatio = propsAspectRatio;
      } else if (player.videoWidth) {
        // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
      } else {
        // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
      } // Get the ratio as a decimal we can use to calculate dimensions


      var ratioParts = aspectRatio.split(':');
      var ratioMultiplier = ratioParts[1] / ratioParts[0];

      if (propsWidth !== undefined) {
        // Use any width that's been specifically set
        width = propsWidth;
      } else if (propsHeight !== undefined) {
        // Or calulate the width from the aspect ratio if a height has been set
        width = propsHeight / ratioMultiplier;
      } else {
        // Or use the video's metadata, or use the video el's default of 300
        width = player.videoWidth || 400;
      }

      if (propsHeight !== undefined) {
        // Use any height that's been specifically set
        height = propsHeight;
      } else {
        // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
      }

      if (fluid) {
        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
      } else {
        // If Width contains "auto", set "auto" in style
        this.setWidthOrHeight(style, 'width', width);
        this.setWidthOrHeight(style, 'height', height);
      }

      return style;
    } // get redux state
    // { player, operation }

  }, {
    key: "getState",
    value: function getState() {
      return this.manager.getState();
    } // get playback rate

  }, {
    key: "play",
    // play the video
    value: function play() {
      this.video.play();
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      this.video.seek(time);
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.video.forward(seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.video.replay(seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      this.video.toggleFullscreen();
    } // subscribe to player state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      return this.manager.subscribeToPlayerStateChange(listener);
    } // player resize

  }, {
    key: "handleResize",
    value: function handleResize() {}
  }, {
    key: "handleFullScreenChange",
    value: function handleFullScreenChange(event) {
      if (event.target === this.manager.rootElement) {
        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      this.startControlsTimer();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.startControlsTimer();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown() {
      this.startControlsTimer();
    }
  }, {
    key: "startControlsTimer",
    value: function startControlsTimer() {
      var _this3 = this;

      var controlBarActiveTime = 3000;

      _react["default"].Children.forEach(this.props.children, function (element) {
        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
          return;
        }

        var autoHideTime = element.props.autoHideTime;

        if (typeof autoHideTime === 'number') {
          controlBarActiveTime = autoHideTime;
        }
      });

      this.actions.userActivate(true);
      clearTimeout(this.controlsHideTimer);
      this.controlsHideTimer = setTimeout(function () {
        _this3.actions.userActivate(false);
      }, controlBarActiveTime);
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      if (state.isFullscreen !== prevState.isFullscreen) {
        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276

        (0, _dom.focusNode)(this.manager.rootElement);
      }

      this.forceUpdate(); // re-render
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.actions.activate(true);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.actions.activate(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var fluid = this.props.fluid;

      var _this$manager$getStat2 = this.manager.getState(),
          player = _this$manager$getStat2.player;

      var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;
      var props = (0, _objectSpread2["default"])({}, this.props, {
        player: player,
        actions: this.actions,
        manager: this.manager,
        store: this.manager.store,
        video: this.video ? this.video.video : null
      });
      var children = this.getChildren(props);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-controls-enabled': true,
          'video-react-has-started': hasStarted,
          'video-react-paused': paused,
          'video-react-playing': !paused,
          'video-react-waiting': waiting,
          'video-react-seeking': seeking,
          'video-react-fluid': fluid,
          'video-react-fullscreen': isFullscreen,
          'video-react-user-inactive': !userActivity,
          'video-react-user-active': userActivity,
          'video-react-workinghover': !browser.IS_IOS
        }, 'video-react', this.props.className),
        style: this.getStyle(),
        ref: function ref(c) {
          _this4.manager.rootElement = c;
        },
        role: "region",
        onTouchStart: this.handleMouseDown,
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleMouseMove,
        onMouseMove: this.handleMouseMove,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: "-1"
      }, children);
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Player;
}(_react.Component);

exports["default"] = Player;
Player.contextTypes = {
  store: _propTypes["default"].object
};
Player.propTypes = propTypes;
Player.defaultProps = defaultProps;
Player.displayName = 'Player';

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1424);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _redux = __webpack_require__(1426);

var _reducers = _interopRequireDefault(__webpack_require__(576));

var playerActions = _interopRequireWildcard(__webpack_require__(251));

var videoActions = _interopRequireWildcard(__webpack_require__(363));

var Manager =
/*#__PURE__*/
function () {
  function Manager(store) {
    (0, _classCallCheck2["default"])(this, Manager);
    this.store = store || (0, _redux.createStore)(_reducers["default"]);
    this.video = null;
    this.rootElement = null;
  }

  (0, _createClass2["default"])(Manager, [{
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;
      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);

      function bindActionCreator(actionCreator) {
        return function bindAction() {
          // eslint-disable-next-line prefer-rest-params
          var action = actionCreator.apply(manager, arguments);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      return Object.keys(actions).filter(function (key) {
        return typeof actions[key] === 'function';
      }).reduce(function (boundActions, key) {
        boundActions[key] = bindActionCreator(actions[key]);
        return boundActions;
      }, {});
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    } // subscribe state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, getState) {
      if (!getState) {
        getState = this.getState.bind(this);
      }

      var prevState = getState();

      var handleChange = function handleChange() {
        var state = getState();

        if (state === prevState) {
          return;
        }

        var prevStateCopy = prevState;
        prevState = state;
        listener(state, prevStateCopy);
      };

      return this.store.subscribe(handleChange);
    } // subscribe to operation state change

  }, {
    key: "subscribeToOperationStateChange",
    value: function subscribeToOperationStateChange(listener) {
      var _this = this;

      return this.subscribeToStateChange(listener, function () {
        return _this.getState().operation;
      });
    } // subscribe to player state change

  }, {
    key: "subscribeToPlayerStateChange",
    value: function subscribeToPlayerStateChange(listener) {
      var _this2 = this;

      return this.subscribeToStateChange(listener, function () {
        return _this2.getState().player;
      });
    }
  }]);
  return Manager;
}();

exports["default"] = Manager;

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1427);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1428);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = player;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _video = __webpack_require__(363);

var _player = __webpack_require__(251);

var initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false,
  activeTextTrack: null
};

function player() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.USER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        userActivity: action.activity
      });

    case _player.PLAYER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        isActive: action.activity
      });

    case _player.FULLSCREEN_CHANGE:
      return (0, _objectSpread2["default"])({}, state, {
        isFullscreen: !!action.isFullscreen
      });

    case _video.SEEKING_TIME:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: action.time
      });

    case _video.END_SEEKING:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: 0
      });

    case _video.LOAD_START:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        hasStarted: false,
        ended: false
      });

    case _video.CAN_PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.WAITING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: true
      });

    case _video.CAN_PLAY_THROUGH:
    case _video.PLAYING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        hasStarted: true
      });

    case _video.PAUSE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        paused: true
      });

    case _video.END:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: true
      });

    case _video.SEEKING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: true
      });

    case _video.SEEKED:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: false
      });

    case _video.ERROR:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        error: 'UNKNOWN ERROR',
        ended: true
      });

    case _video.DURATION_CHANGE:
    case _video.TIME_UPDATE:
    case _video.VOLUME_CHANGE:
    case _video.PROGRESS_CHANGE:
    case _video.RATE_CHANGE:
    case _video.SUSPEND:
    case _video.ABORT:
    case _video.EMPTIED:
    case _video.STALLED:
    case _video.LOADED_META_DATA:
    case _video.LOADED_DATA:
    case _video.RESIZE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps);

    case _video.ACTIVATE_TEXT_TRACK:
      return (0, _objectSpread2["default"])({}, state, {
        activeTextTrack: action.textTrack
      });

    default:
      return state;
  }
}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = operation;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _player = __webpack_require__(251);

var initialState = {
  count: 0,
  operation: {
    action: '',
    source: ''
  }
};

function operation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.OPERATE:
      return (0, _objectSpread2["default"])({}, state, {
        count: state.count + 1,
        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
      });

    default:
      return state;
  }
}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PopupButton;

var _extends2 = _interopRequireDefault(__webpack_require__(186));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(104));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(601));

var _Popup = _interopRequireDefault(__webpack_require__(1435));

var propTypes = {
  inline: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;
  var ps = (0, _objectSpread2["default"])({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, {
      'video-react-menu-button-inline': !!inline,
      'video-react-menu-button-popup': !inline
    }, 'video-react-control video-react-button video-react-menu-button')
  }, ps), _react["default"].createElement(_Popup["default"], props));
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;
PopupButton.displayName = 'PopupButton';

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  player: _propTypes["default"].object,
  children: _propTypes["default"].any
};

var Popup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Popup, _Component);

  function Popup(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Popup, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("div", {
        className: "video-react-menu",
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: "video-react-menu-content"
      }, children));
    }
  }]);
  return Popup;
}(_react.Component);

exports["default"] = Popup;
Popup.propTypes = propTypes;
Popup.displayName = 'Popup';

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(186));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _Slider = _interopRequireDefault(__webpack_require__(364));

var _VolumeLevel = _interopRequireDefault(__webpack_require__(1437));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};

var VolumeBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeBar, _Component);

  function VolumeBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
    _this.state = {
      percentage: '0%'
    };
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "getPercent",
    value: function getPercent() {
      var player = this.props.player;

      if (player.muted) {
        return 0;
      }

      return player.volume;
    }
  }, {
    key: "checkMuted",
    value: function checkMuted() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (player.muted) {
        actions.mute(false);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      this.checkMuted();
      var distance = this.slider.calculateDistance(event);
      actions.changeVolume(distance);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      this.checkMuted();
      actions.changeVolume(player.volume + 0.1);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions;
      this.checkMuted();
      actions.changeVolume(player.volume - 0.1);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handlePercentageChange",
    value: function handlePercentageChange(percentage) {
      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          player = _this$props4.player,
          className = _this$props4.className;
      var volume = (player.volume * 100).toFixed(2);
      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
        ref: function ref(c) {
          _this2.slider = c;
        },
        label: "volume level",
        valuenow: volume,
        valuetext: "".concat(volume, "%"),
        onMouseMove: this.handleMouseMove,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        sliderActive: this.handleFocus,
        sliderInactive: this.handleBlur,
        getPercent: this.getPercent,
        onPercentageChange: this.handlePercentageChange,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, this.props, {
        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
    }
  }]);
  return VolumeBar;
}(_react.Component);

VolumeBar.propTypes = propTypes;
VolumeBar.displayName = 'VolumeBar';
var _default = VolumeBar;
exports["default"] = _default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  percentage: _propTypes["default"].string,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  percentage: '100%',
  vertical: false
};

function VolumeLevel(_ref) {
  var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;
  var style = {};

  if (vertical) {
    style.height = percentage;
  } else {
    style.width = percentage;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
    style: style
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }));
}

VolumeLevel.propTypes = propTypes;
VolumeLevel.defaultProps = defaultProps;
VolumeLevel.displayName = 'VolumeLevel';
var _default = VolumeLevel;
exports["default"] = _default;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  children: _propTypes["default"].any
};

var Menu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Menu, _Component);

  function Menu(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "video-react-menu video-react-lock-showing",
        role: "presentation",
        onClick: this.handleClick
      }, _react["default"].createElement("ul", {
        className: "video-react-menu-content"
      }, this.props.children));
    }
  }]);
  return Menu;
}(_react.Component);

exports["default"] = Menu;
Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  activateIndex: _propTypes["default"].number,
  onSelectItem: _propTypes["default"].func
};

var MenuItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuItem, _Component);

  function MenuItem(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          index = _this$props.index,
          onSelectItem = _this$props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          index = _this$props2.index,
          activateIndex = _this$props2.activateIndex;
      return _react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          'video-react-menu-item': true,
          'video-react-selected': index === activateIndex
        }),
        role: "menuitem",
        onClick: this.handleClick
      }, item.label, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }));
    }
  }]);
  return MenuItem;
}(_react.Component);

exports["default"] = MenuItem;
MenuItem.propTypes = propTypes;
MenuItem.displayName = 'MenuItem';

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */

var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/

exports.IS_IPAD = IS_IPAD;
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
exports.IS_IPHONE = IS_IPHONE;
var IS_IPOD = /iPod/i.test(USER_AGENT);
exports.IS_IPOD = IS_IPOD;
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
exports.IS_IOS = IS_IOS;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(365));

var _utils = __webpack_require__(72);

var PlaybackRate =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRate, _Component);

  function PlaybackRate(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRate);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRate, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
    }
  }]);
  return PlaybackRate;
}(_react.Component);

exports["default"] = PlaybackRate;
PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(27);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(24));

var _createClass2 = _interopRequireDefault(__webpack_require__(25));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(30));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(32));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(31));

var _inherits2 = _interopRequireDefault(__webpack_require__(33));

var _propTypes = _interopRequireDefault(__webpack_require__(18));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(22));

var _MenuButton = _interopRequireDefault(__webpack_require__(366));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  offMenuText: _propTypes["default"].string,
  showOffMenu: _propTypes["default"].bool,
  kinds: _propTypes["default"].array
};
var defaultProps = {
  offMenuText: 'Off',
  showOffMenu: true,
  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.

};

var ClosedCaptionButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClosedCaptionButton, _Component);

  function ClosedCaptionButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = _this.getTextTrackItems();
    return _this;
  }

  (0, _createClass2["default"])(ClosedCaptionButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateState();
    }
  }, {
    key: "getTextTrackItems",
    value: function getTextTrackItems() {
      var _this$props = this.props,
          kinds = _this$props.kinds,
          player = _this$props.player,
          offMenuText = _this$props.offMenuText,
          showOffMenu = _this$props.showOffMenu;
      var textTracks = player.textTracks,
          activeTextTrack = player.activeTextTrack;
      var textTrackItems = {
        items: [],
        selectedIndex: 0
      };
      var tracks = Array.from(textTracks || []);

      if (tracks.length === 0) {
        return textTrackItems;
      }

      if (showOffMenu) {
        textTrackItems.items.push({
          label: offMenuText || 'Off',
          value: null
        });
      }

      tracks.forEach(function (textTrack) {
        // ignore invalid text track kind
        if (kinds.length && !kinds.includes(textTrack.kind)) {
          return;
        }

        textTrackItems.items.push({
          label: textTrack.label,
          value: textTrack.language
        });
      });
      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
        return activeTextTrack && activeTextTrack.language === item.value;
      });

      if (textTrackItems.selectedIndex === -1) {
        textTrackItems.selectedIndex = 0;
      }

      return textTrackItems;
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var textTrackItems = this.getTextTrackItems();

      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
        this.setState(textTrackItems);
      }
    }
  }, {
    key: "textTrackItemsAreEqual",
    value: function textTrackItemsAreEqual(items1, items2) {
      if (items1.length !== items2.length) {
        return false;
      }

      for (var i = 0; i < items1.length; i++) {
        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          showOffMenu = _this$props2.showOffMenu;
      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
      // so all subtitles will be turned off

      Array.from(textTracks).forEach(function (textTrack, i) {
        // if it shows the `Off` menu, the first item is `Off`
        if (index === (showOffMenu ? i + 1 : i)) {
          textTrack.mode = 'showing';
          actions.activateTextTrack(textTrack);
        } else {
          textTrack.mode = 'hidden';
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          items = _this$state.items,
          selectedIndex = _this$state.selectedIndex;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Closed Caption"));
    }
  }]);
  return ClosedCaptionButton;
}(_react.Component);

ClosedCaptionButton.propTypes = propTypes;
ClosedCaptionButton.defaultProps = defaultProps;
ClosedCaptionButton.displayName = 'ClosedCaptionButton';
var _default = ClosedCaptionButton;
exports["default"] = _default;

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AudioPlayer = /** @class */ (function (_super) {
    __extends(AudioPlayer, _super);
    function AudioPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AudioPlayer.prototype.render = function () {
        var url = this.props.url;
        var isChrome = __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isChrome();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledAudioPlayer */], { ref: function (audio) {
                if (audio && isChrome) {
                    audio.setAttribute('controlsList', 'nodownload');
                }
            }, controls: true, autoPlay: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("source", { src: url })));
    };
    return AudioPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AudioPlayer);


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledAudioPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledAudioPlayer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('audio')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\t-webkit-transform: translate(-50%,-50%);\n\t-ms-transform: translate(-50%,-50%);\n\ttransform: translate(-50%,-50%);\n\tmax-width: 100%;\n\tmax-height: 100%;\n"], ["\n\tcursor: pointer;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\t-webkit-transform: translate(-50%,-50%);\n\t-ms-transform: translate(-50%,-50%);\n\ttransform: translate(-50%,-50%);\n\tmax-width: 100%;\n\tmax-height: 100%;\n"])));
var templateObject_1;


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledTheaterContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SvgIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledTheaterContent = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"])));
var SvgIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('svg')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\tfill: ", ";\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\tfill: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var Image = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('img')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%,-50%);\n\tmax-width: 100%;\n\tmax-height: 100%;\n"], ["\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%,-50%);\n\tmax-width: 100%;\n\tmax-height: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_css__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





function SliderPreviousArrow(props) {
    return SliderArrow(props, 'previous');
}
function SliderNextArrow(props) {
    return SliderArrow(props, 'next');
}
function SliderArrow(props, direction) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* SvgArrow */], { className: className, style: __assign({}, style), onClick: onClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use", { xlinkHref: "#svgicon-iconset_slider-" + direction })));
}
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slider.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.shouldReRender;
    };
    Slider.prototype.render = function () {
        var children = this.props.children;
        var prevArrow = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SliderPreviousArrow, null);
        var nextArrow = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SliderNextArrow, null);
        var sliderSettings = Object.assign({}, this.props.sliderSettings, { prevArrow: prevArrow, nextArrow: nextArrow });
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledSliderContainer */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_slick___default.a, __assign({ key: this.props.sliderKey }, sliderSettings), children)));
    };
    return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Slider);


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledSliderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SvgArrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledSliderContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 40px;\n\tbackground: ", ";\n\theight: calc( 100% - 45px - 64px );/* 100% - header.height - footer.height */\n\tbox-sizing: border-box;\n\n\t.slick-slider,\n\t.slick-list,\n\t.slick-track,\n\t.slick-slide > div {\n\t\theight: 100%;\n\t}\n\n\t@media ", " {\n\t\tpadding: 15px 30px;\n\t}\n"], ["\n\tpadding: 40px;\n\tbackground: ", ";\n\theight: calc( 100% - 45px - 64px );/* 100% - header.height - footer.height */\n\tbox-sizing: border-box;\n\n\t.slick-slider,\n\t.slick-list,\n\t.slick-track,\n\t.slick-slide > div {\n\t\theight: 100%;\n\t}\n\n\t@media ", " {\n\t\tpadding: 15px 30px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var SvgArrow = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('svg')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\topacity: 0.75;\n\tpointer-events: all;\n\tfill: ", ";\n\n\t&.slick-disabled{\n\t\topacity: 0.25;\n\t}\n\n\t&:not(.slick-disabled):hover {\n\t\topacity: 1;\n\t}\n"], ["\n\topacity: 0.75;\n\tpointer-events: all;\n\tfill: ", ";\n\n\t&.slick-disabled{\n\t\topacity: 0.25;\n\t}\n\n\t&:not(.slick-disabled):hover {\n\t\topacity: 1;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var templateObject_1, templateObject_2;


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListPageWrapper; });
/* unused harmony export DriveItemListActionButtons */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoItemsContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Page_styles__ = __webpack_require__(151);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var ListPageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tflex-direction: column;\n\theight: 100%;\n\n\t@media ", " and (min-aspect-ratio: 2/1) {\n\t\tpadding: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tflex-direction: column;\n\theight: 100%;\n\n\t@media ", " and (min-aspect-ratio: 2/1) {\n\t\tpadding: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].SmartphoneLandscape, __WEBPACK_IMPORTED_MODULE_2__utils_userAgent__["a" /* default */].isIOS() ? '0 20px' : 0);
var DriveItemListActionButtons = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t& > * > button > svg, & > * > svg {\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t& > * > button > svg, & > * > svg {\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.theme.primary.iconsColor; });
var NoItemsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: ", ";\n"], ["\n\tflex: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__components_Page_styles__["b" /* BottomBarHeight */]);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItem__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var NavigationListItem = /** @class */ (function (_super) {
    __extends(NavigationListItem, _super);
    function NavigationListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    NavigationListItem.prototype.handleClick = function () {
        var _a = this.props, type = _a.type, navigationPath = _a.navigationPath, url = _a.url;
        if (type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory && navigationPath) {
            __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].historyPush(navigationPath);
        }
        if (type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.ExternalLink && url) {
            window.open(url, '_blank');
        }
    };
    NavigationListItem.prototype.render = function () {
        var _a = this.props, displayType = _a.displayType, type = _a.type, image = _a.image, itemLabel = _a.itemLabel, isEditMode = _a.isEditMode;
        var thumbnailDescriptor;
        if (image) {
            thumbnailDescriptor = {
                isImage: true,
                src: image,
            };
        }
        else {
            thumbnailDescriptor = {
                isImage: false,
                src: type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Directory ? 'iconset_doc_default' : 'iconset_link',
            };
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ListItem__["a" /* default */], { key: itemLabel, onClick: this.handleClick, showUnreadBadge: false, displayType: displayType, itemType: type, hasActionButton: false, label: __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["I18n"].t(itemLabel), isSelectedForContextualMenu: false, isDownloading: false, isDownloaded: false, isDownloadInProgress: false, isUpdating: false, loaderStep: undefined, thumbnailDescriptor: thumbnailDescriptor, isUnread: false, isEditMode: isEditMode, isDeletionInProgress: false, isMarkingItemForDeletion: false }));
    };
    return NavigationListItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (NavigationListItem);


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectionDriveItemListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotesPage_NoteListItem__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings_api__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SelectionDriveItemListPage = /** @class */ (function (_super) {
    __extends(SelectionDriveItemListPage, _super);
    function SelectionDriveItemListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerLabel = 'messages.my_selection';
        _this.noItemsLabel = 'messages.no_selection';
        _this.hasShareButton = true;
        _this.hasDownloadButton = true;
        _this.hasBottomBar = true;
        return _this;
    }
    SelectionDriveItemListPage.prototype.initializeView = function (props) {
        return;
    };
    SelectionDriveItemListPage.prototype.getDriveItemIds = function () {
        return this.props.selectedResources;
    };
    SelectionDriveItemListPage.prototype.renderAdditionalItems = function () {
        var _a = this.props, selectedNotes = _a.selectedNotes, displayType = _a.displayType;
        if (!selectedNotes) {
            return null;
        }
        return selectedNotes.map(function (id) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NotesPage_NoteListItem__["a" /* default */], { key: id, id: id, displayType: displayType, type: __WEBPACK_IMPORTED_MODULE_4__typings_api__["a" /* Api */].AdditionalItemType.Note })); });
    };
    SelectionDriveItemListPage.prototype.getAdditionalItemsLength = function () {
        return this.props.selectedNotes.length;
    };
    return SelectionDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_2__abstract__["a" /* default */]));

var mapStateToProps = function (state) {
    var selection = state.selection;
    return {
        selectedResources: selection.resources,
        selectedNotes: selection.notes,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SelectionDriveItemListPage));


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesPage_NoteListItem__ = __webpack_require__(1453);


var mapStateToProps = function (state) {
    var _a = state.notes, isOpened = _a.editor.isOpened, loadingStatus = _a.loadingStatus;
    return {
        isOpened: isOpened,
        loadingStatus: loadingStatus,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NotesPage_NoteListItem__["a" /* default */]));


/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_NotesPage_actions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_NotesPage_reducer__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListItem__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_customHooks_usePreviousValue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__typings_api__ = __webpack_require__(10);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var NoteListItem = function (_a) {
    var id = _a.id, isOpened = _a.isOpened, loadingStatus = _a.loadingStatus, displayType = _a.displayType, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](''), 2), imageSrc = _b[0], setImageSrc = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](''), 2), label = _c[0], setLabel = _c[1];
    var prevIsOpened = Object(__WEBPACK_IMPORTED_MODULE_6__utils_customHooks_usePreviousValue__["a" /* default */])(isOpened);
    var prevLoadingStatus = Object(__WEBPACK_IMPORTED_MODULE_6__utils_customHooks_usePreviousValue__["a" /* default */])(loadingStatus);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getNote(id).then(function (note) {
            if (note) {
                setImageSrc(note.drawing);
                setLabel(note.title);
            }
        });
    }, [id]);
    // is needed to update note title/image
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var isLocalNoteChanged = prevIsOpened && !isOpened;
        var isSharedNoteChanged = prevLoadingStatus === __WEBPACK_IMPORTED_MODULE_3__containers_NotesPage_reducer__["a" /* LoadingStatus */].SAVING && loadingStatus === __WEBPACK_IMPORTED_MODULE_3__containers_NotesPage_reducer__["a" /* LoadingStatus */].LOADED;
        if (isLocalNoteChanged || isSharedNoteChanged) {
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_5__utils_indexedDB_manager__["a" /* default */].getNote(id).then(function (note) {
                    if (note) {
                        setImageSrc(note.drawing);
                        setLabel(note.title);
                    }
                });
            }, 0);
        }
    }, [id, isOpened, loadingStatus]);
    var handleClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_NotesPage_actions__["g" /* toggleNotesEditor */])(id));
    };
    var thumbnailDescriptor = {
        isImage: !!imageSrc,
        src: imageSrc || 'iconset_uprez_notes',
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ListItem__["a" /* default */], { itemId: id, onClick: handleClick, showUnreadBadge: false, displayType: displayType, itemType: __WEBPACK_IMPORTED_MODULE_7__typings_api__["a" /* Api */].AdditionalItemType.Note, hasActionButton: false, label: label, isSelectedForContextualMenu: false, isDownloading: false, isDownloaded: false, isDownloadInProgress: false, isUpdating: false, loaderStep: undefined, thumbnailDescriptor: thumbnailDescriptor, isUnread: false, isEditMode: false, selectionType: __WEBPACK_IMPORTED_MODULE_1__containers_Selection_actions__["b" /* SelectionType */].NOTES, isDeletionInProgress: false, isMarkingItemForDeletion: false }));
};
/* harmony default export */ __webpack_exports__["a"] = (NoteListItem);


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FolderDriveItemListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__typings_api__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};








var FolderDriveItemListPage = /** @class */ (function (_super) {
    __extends(FolderDriveItemListPage, _super);
    function FolderDriveItemListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerLabel = 'messages.folder';
        _this.noItemsLabel = 'messages.no_assets';
        _this.filterOutMyDocumentsFromRoot = function (resourceId) {
            var _a = _this.props, galleryId = _a.galleryId, privateDirId = _a.privateDirId;
            var driveFolderId = _this.getDriveFolderId();
            var isMyDocumentsInRoot = driveFolderId === galleryId && resourceId === privateDirId;
            return !(isMyDocumentsInRoot && !_this.isSpecialPrivateDir(resourceId));
        };
        return _this;
    }
    FolderDriveItemListPage.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props, params = _a.params, privateDirId = _a.privateDirId, sharedDirId = _a.sharedDirId;
        if (params !== nextProps.params
            || privateDirId !== nextProps.privateDirId
            || sharedDirId !== nextProps.sharedDirId) {
            this.initializeView(nextProps);
        }
    };
    FolderDriveItemListPage.prototype.initializeView = function (props) {
        var driveFolderId = this.getDriveFolderId(props);
        var isSharedDir = this.isSharedDir(props);
        var _a = props.driveList, driveItems = _a.driveItems, driveItemsFetchStatus = _a.driveItemsFetchStatus, dispatch = props.dispatch;
        var isFolderLoaded = driveFolderId && !!driveItems[driveFolderId];
        var driveFolderFetchStatus = driveFolderId ? Object(__WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveItemsFetchStatus, driveFolderId) : null;
        var isFolderMetaFetched = driveFolderFetchStatus && driveFolderFetchStatus.metaFetchStatus === __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["a" /* FetchStatus */].FETCHED;
        // In mobile app mode when online, fetch folders on-demand if not already loaded
        // This allows navigation to work while getAllDriveItems() runs in the background
        var shouldFetchFolder = driveFolderId && (!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp ||
            isSharedDir ||
            (__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline() && !isFolderLoaded));
        if (shouldFetchFolder && driveFolderId) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(driveFolderId, true, true, isSharedDir))
                .then(function (folderMeta) {
                // Once folder metadata is loaded, fetch the first content block to get the items
                // This ensures items appear immediately when navigating to a folder
                // Cast to DriveFolderInfo since folders have the resources property
                var driveFolder = folderMeta;
                if (driveFolder && driveFolder.id && driveFolder.resources && driveFolder.resources.length > 0 && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline() && driveFolderId) {
                    var resolutionsBlock = driveFolder.resolutionsBlock || 1;
                    var firstResource = driveFolder.resources[0];
                    var firstBlock = firstResource && firstResource.block ? firstResource.block : resolutionsBlock;
                    // Fetch the first content block to load the items
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["h" /* fetchContentBlock */])(driveFolderId, firstBlock));
                }
            })
                .catch(function () {
                // Error handling is done in getOrFetchDriveItemMeta
            });
        }
        else if (isFolderMetaFetched && __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline() && driveFolderId) {
            // Folder metadata is loaded but content block might not be fetched yet
            // Fetch the first content block if needed
            var driveFolder = driveItems[driveFolderId];
            if (driveFolder && driveFolder.resources && driveFolder.resources.length > 0) {
                var resolutionsBlock = driveFolder.resolutionsBlock || 1;
                var firstResource = driveFolder.resources[0];
                var firstBlock = firstResource && firstResource.block ? firstResource.block : resolutionsBlock;
                var firstBlockStatus = driveFolderFetchStatus && driveFolderFetchStatus.contentBlocksStatus[firstBlock];
                // Fetch first content block if not already fetched or fetching
                if (firstBlockStatus !== __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["a" /* FetchStatus */].FETCHED && firstBlockStatus !== __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["a" /* FetchStatus */].FETCHING) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_actions__["h" /* fetchContentBlock */])(driveFolderId, firstBlock));
                }
            }
        }
        this.setState({
            navigationItems: this.getNavigationItems(props)
        });
    };
    FolderDriveItemListPage.prototype.getDriveItemIds = function () {
        var _a = this.props, driveItemsStore = _a.driveList.driveItems, sharedDirId = _a.sharedDirId, sourcesDirId = _a.sourcesDirId, archiveDirId = _a.archiveDirId;
        var driveFolderId = this.getDriveFolderId();
        var isPrivateDir = this.isPrivateDir(this.props);
        if (driveFolderId) {
            var driveFolder = driveItemsStore[driveFolderId];
            if (driveFolder) {
                var resources = driveFolder.resources;
                if (resources) {
                    var additionalFolders = isPrivateDir
                        ? [sharedDirId, sourcesDirId, archiveDirId].filter(Boolean)
                        : [];
                    if (this.isSpecialPrivateDir(driveFolderId)) {
                        additionalFolders = [];
                    }
                    return __spread(additionalFolders, resources
                        .map(function (resource) { return resource.id; })
                        .filter(this.filterOutMyDocumentsFromRoot));
                }
            }
        }
        return [];
    };
    FolderDriveItemListPage.prototype.isFetching = function (driveItemIds) {
        var driveFolderId = this.getDriveFolderId();
        // In mobile app mode when online, check fetching status to show loading state
        // This allows proper feedback while folders are being fetched on-demand
        if (driveFolderId && (!__WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isMobileApp || __WEBPACK_IMPORTED_MODULE_3__utils_userAgent__["a" /* default */].isOnline())) {
            var driveItemsFetchStatus = this.props.driveList.driveItemsFetchStatus;
            var driveFolderFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveItemsFetchStatus, driveFolderId);
            var contentBlocksStatus = driveFolderFetchStatus.contentBlocksStatus, metaFetchStatus = driveFolderFetchStatus.metaFetchStatus;
            if (metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["a" /* FetchStatus */].FETCHED && metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["a" /* FetchStatus */].ERROR) {
                return true;
            }
            var blocks = Object.keys(contentBlocksStatus);
            for (var i = 0; i < blocks.length; i++) {
                var block = blocks[i];
                var blockStatus = contentBlocksStatus[block];
                if (blockStatus === __WEBPACK_IMPORTED_MODULE_4__DriveItemList_reducer__["a" /* FetchStatus */].FETCHING) {
                    return true;
                }
            }
        }
        return false;
    };
    FolderDriveItemListPage.prototype.getNavigationItems = function (props) {
        var galleryId = props.galleryId, params = props.params;
        var originParam = params.originParam;
        var isPrivateDir = this.isPrivateDir(props);
        var driveFolderId = originParam ? parseInt(originParam, 10) : galleryId;
        var isSpecialPrivateDir = driveFolderId && this.isSpecialPrivateDir(driveFolderId);
        return isPrivateDir && !isSpecialPrivateDir ? __spread([
            this.getTutorialNavigationItem(props.locale)
        ], __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* myDocumentsNavItems */]) : [];
    };
    FolderDriveItemListPage.prototype.getTutorialNavigationItem = function (locale) {
        var tutorialsByLocale = {
            'ca_ES': {
                url: 'https://fr.zone-secure.net/149562/.uprez-tutorial',
                image: './.gallery/static/images/tutorial_uprez_cover_ES.jpg',
            },
            'en_UK': {
                url: 'https://fr.zone-secure.net/149574/1170924/',
                image: './.gallery/static/images/tutorial_uprez_cover_EN.jpg',
            },
            'es_ES': {
                url: 'https://fr.zone-secure.net/149562/.uprez-tutorial',
                image: './.gallery/static/images/tutorial_uprez_cover_ES.jpg',
            },
            'fr_FR': {
                url: 'https://fr.zone-secure.net/149574/1150789/',
                image: './.gallery/static/images/tutorial_uprez_cover_FR.jpg',
            },
            'de_DE': {
                url: 'https://fr.zone-secure.net/149574/1170924/',
                image: './.gallery/static/images/tutorial_uprez_cover_EN.jpg',
            },
            'it_IT': {
                url: 'https://fr.zone-secure.net/149574/1170924/',
                image: './.gallery/static/images/tutorial_uprez_cover_EN.jpg',
            },
        };
        return __assign({ label: 'tutorial_uprez', type: __WEBPACK_IMPORTED_MODULE_7__typings_api__["a" /* Api */].DriveItemType.ExternalLink }, tutorialsByLocale[locale]);
    };
    FolderDriveItemListPage.prototype.isSpecialPrivateDir = function (resourceId) {
        var specialPrivateDirIds = this.props.specialPrivateDirIds;
        return specialPrivateDirIds && specialPrivateDirIds.includes(resourceId);
    };
    FolderDriveItemListPage.prototype.isPrivateDir = function (props) {
        return this.getDriveFolderId(props) === props.privateDirId;
    };
    FolderDriveItemListPage.prototype.isSharedDir = function (props) {
        return this.getDriveFolderId(props) === props.sharedDirId;
    };
    FolderDriveItemListPage.prototype.renderAdditionalItems = function () {
        return null;
    };
    FolderDriveItemListPage.prototype.getAdditionalItemsLength = function () {
        return 0;
    };
    return FolderDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_1__abstract__["a" /* default */]));

var mapStateToProps = function (_a) {
    var driveList = _a.driveList, galleryConfig = _a.galleryInfos.config, locale = _a.i18n.locale;
    var privateDirId = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getPrivateDirId(driveList, galleryConfig);
    var sharedDirId = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSharedDirId(driveList, galleryConfig);
    var sourcesDirId = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSourcesDirId(driveList, galleryConfig);
    var archiveDirId = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getArchiveDirId(driveList, galleryConfig);
    var specialPrivateDirIds = galleryConfig.specialPrivateDirIds || [];
    return {
        privateDirId: privateDirId,
        sharedDirId: sharedDirId,
        sourcesDirId: sourcesDirId,
        archiveDirId: archiveDirId,
        locale: locale,
        specialPrivateDirIds: specialPrivateDirIds,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(FolderDriveItemListPage));


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewDriveItemListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_New_actions__ = __webpack_require__(166);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var NewDriveItemListPage = /** @class */ (function (_super) {
    __extends(NewDriveItemListPage, _super);
    function NewDriveItemListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.headerLabel = 'messages.new';
        _this.noItemsLabel = 'messages.no_new';
        _this.showUnreadBadge = true;
        var dispatch = props.dispatch, newDriveItems = props.newDriveItems;
        var isFetching = newDriveItems.isFetching;
        if (!isFetching) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_New_actions__["b" /* fetchNewDriveItems */])());
        }
        return _this;
    }
    NewDriveItemListPage.prototype.initializeView = function (props) {
        return;
    };
    NewDriveItemListPage.prototype.getDriveItemIds = function () {
        var ids = this.props.newDriveItems.ids;
        return ids;
    };
    NewDriveItemListPage.prototype.isFetching = function () {
        return this.props.newDriveItems.isFetching;
    };
    NewDriveItemListPage.prototype.renderAdditionalItems = function () {
        return null;
    };
    NewDriveItemListPage.prototype.getAdditionalItemsLength = function () {
        return 0;
    };
    return NewDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_1__abstract__["a" /* default */]));

var mapStateToProps = function (state) {
    var newDriveItems = state.newDriveItems;
    return { newDriveItems: newDriveItems };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(NewDriveItemListPage));


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchDriveItemListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DriveItemList_Search_actions__ = __webpack_require__(144);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var SearchDriveItemListPage = /** @class */ (function (_super) {
    __extends(SearchDriveItemListPage, _super);
    function SearchDriveItemListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerLabel = 'messages.search_results';
        _this.noItemsLabel = 'messages.no_results';
        return _this;
    }
    SearchDriveItemListPage.prototype.initializeView = function (props) {
        var dispatch = props.dispatch, originParam = props.params.originParam, search = props.search;
        var isFetching = search.isFetching;
        if (!isFetching) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__DriveItemList_Search_actions__["b" /* searchDriveItems */])(originParam || ''));
        }
    };
    SearchDriveItemListPage.prototype.getDriveItemIds = function () {
        var _a = this.props.search, isFetching = _a.isFetching, driveItemIds = _a.driveItemIds;
        return isFetching ? [] : driveItemIds;
    };
    SearchDriveItemListPage.prototype.isFetching = function (driveItemIds) {
        return this.props.search.isFetching;
    };
    SearchDriveItemListPage.prototype.renderAdditionalItems = function () {
        return null;
    };
    SearchDriveItemListPage.prototype.getAdditionalItemsLength = function () {
        return 0;
    };
    return SearchDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_1__abstract__["a" /* default */]));

var mapStateToProps = function (state) {
    var search = state.search;
    return { search: search };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(SearchDriveItemListPage));


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract__ = __webpack_require__(152);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AssortmentDriveItemListPage = /** @class */ (function (_super) {
    __extends(AssortmentDriveItemListPage, _super);
    function AssortmentDriveItemListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerLabel = 'messages.assortment';
        _this.noItemsLabel = 'messages.no_assortment';
        return _this;
    }
    AssortmentDriveItemListPage.prototype.initializeView = function (props) {
        return;
    };
    AssortmentDriveItemListPage.prototype.getDriveItemIds = function () {
        var originParam = this.props.params.originParam;
        return originParam ? originParam.split(',').map(function (id) { return parseInt(id, 10); }) : [];
    };
    AssortmentDriveItemListPage.prototype.renderAdditionalItems = function () {
        return null;
    };
    AssortmentDriveItemListPage.prototype.getAdditionalItemsLength = function () {
        return 0;
    };
    return AssortmentDriveItemListPage;
}(__WEBPACK_IMPORTED_MODULE_0__abstract__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (AssortmentDriveItemListPage);


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MenuManager_Header_styles__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Gallery_styles__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DriveItem_Detail_styles__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DriveItemList_reducer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DriveItem_Detail__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Selection_Toggler__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Share_ShareButton__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_routes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Share_actions__ = __webpack_require__(43);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



















var DriveItemDetailPage = /** @class */ (function (_super) {
    __extends(DriveItemDetailPage, _super);
    function DriveItemDetailPage(props) {
        var _this = _super.call(this, props) || this;
        _this.leavePage = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, params, driveList, galleryInfos, routerParamsHistory, driveItemId, folderId, _b, originParam;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, params = _a.params, driveList = _a.driveList, galleryInfos = _a.galleryInfos, routerParamsHistory = _a.routerParamsHistory;
                        if (!(__WEBPACK_IMPORTED_MODULE_15__utils_userAgent__["a" /* default */].isMobileApp || routerParamsHistory.length > 1)) return [3 /*break*/, 1];
                        window.history.back();
                        return [3 /*break*/, 5];
                    case 1:
                        driveItemId = parseInt(params.driveItemId, 10);
                        if (!params.folderId) return [3 /*break*/, 2];
                        _b = parseInt(params.folderId, 10);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_9__DriveItemList_actions__["z" /* resolveParentId */])(driveItemId, driveList)];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        folderId = _b;
                        originParam = folderId === galleryInfos.config.applicationGallery || !folderId ? '' : folderId.toString();
                        window.location.hash = "#" + __WEBPACK_IMPORTED_MODULE_13__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_14__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, originParam);
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.leavePage = _this.leavePage.bind(_this);
        return _this;
    }
    DriveItemDetailPage.prototype.componentDidMount = function () {
        this.initializeView(this.props);
    };
    DriveItemDetailPage.prototype.componentWillReceiveProps = function (nextProps) {
        this.initializeView(nextProps);
    };
    DriveItemDetailPage.prototype.render = function () {
        var leavePage = this.leavePage;
        var _a = this.props, _b = _a.galleryInfos, config = _b.config, sharedMethods = _b.template.sharedMethods, _c = _a.driveList, resolutions = _c.resolutions, driveItems = _c.driveItems;
        var isShareable = __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__["d" /* default */].isShareable(sharedMethods, config);
        var driveItemId = this.getDriveItemId();
        var driveItem = driveItems[driveItemId];
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_MenuManager_Header_styles__["b" /* StyledHeader */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, driveItem &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__styles__["a" /* BackButton */], { onClick: leavePage }, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_back'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_MenuManager_Header_styles__["a" /* PageTitle */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "messages.details" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__DriveItem_Detail_styles__["h" /* DriveItemActionIcons */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Selection_Toggler__["a" /* default */], { itemId: driveItemId, displayMode: __WEBPACK_IMPORTED_MODULE_5__utils_driveItem__["c" /* ResolutionDisplayType */].Detail }),
                    isShareable &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Share_ShareButton__["a" /* default */], { driveItems: [driveItem], shareOrigin: __WEBPACK_IMPORTED_MODULE_18__Share_actions__["a" /* ShareOrigin */].Detail }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Gallery_styles__["c" /* Page */], null, (driveItem && resolutions) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__DriveItem_Detail__["a" /* default */], { driveItem: driveItem, resolutions: resolutions }))));
    };
    DriveItemDetailPage.prototype.initializeView = function (props) {
        var dispatch = props.dispatch, driveList = props.driveList;
        var driveItems = driveList.driveItems;
        var driveItemId = this.getDriveItemId();
        var driveItem = driveItems[driveItemId];
        var metaFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_8__DriveItemList_reducer__["c" /* getDriveItemStatusFromMap */])(driveList.driveItemsFetchStatus, driveItemId).metaFetchStatus;
        if (!driveItem) {
            if (metaFetchStatus !== __WEBPACK_IMPORTED_MODULE_8__DriveItemList_reducer__["a" /* FetchStatus */].ERROR) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DriveItemList_actions__["i" /* fetchDriveItem */])(driveItemId));
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* hashHistory */].replace('');
                return;
            }
        }
        if (!props.params.folderId && __WEBPACK_IMPORTED_MODULE_15__utils_userAgent__["a" /* default */].isOnline()) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__DriveItemList_actions__["j" /* getAllDriveItems */])());
        }
    };
    DriveItemDetailPage.prototype.getDriveItemId = function () {
        var params = this.props.params;
        return parseInt(params.driveItemId, 10);
    };
    return DriveItemDetailPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var galleryInfos = state.galleryInfos, driveList = state.driveList, routerParamsHistory = state.routerParamsHistory;
    return { galleryInfos: galleryInfos, driveList: driveList, routerParamsHistory: routerParamsHistory };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DriveItemDetailPage));


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeleteButton__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DownloadButton__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var I18n = __webpack_require__(5).I18n;
var Localize = __webpack_require__(5).Localize;
var MAX_PUBLICATION_THUMB = 5;
var Format;
(function (Format) {
    Format["Date"] = "date";
    Format["Locale"] = "locale";
    Format["Extension"] = "extension";
})(Format || (Format = {}));
var DriveItemDetail = /** @class */ (function (_super) {
    __extends(DriveItemDetail, _super);
    function DriveItemDetail(props) {
        var _this = _super.call(this, props) || this;
        _this.getImgElement = function () {
            var _a = _this.props, driveItem = _a.driveItem, offlineManager = _a.offlineManager, galleryInfos = _a.galleryInfos, resolutions = _a.resolutions;
            var thumbnailDescriptor = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getThumbnailDescriptor(driveItem, false, offlineManager, galleryInfos.config, resolutions);
            var isImage = thumbnailDescriptor.isImage, src = thumbnailDescriptor.src;
            if (isImage) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* BackgroundImage */], { src: src });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon(src);
            }
        };
        _this.getPublicationCovers = function () {
            var _a = _this.props, driveItem = _a.driveItem, isPersistentlyDownloaded = _a.isPersistentlyDownloaded, galleryInfos = _a.galleryInfos;
            var publicationCoversUrls = [];
            var publicationCovers = [];
            if (driveItem.type === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Publication && driveItem.pages && driveItem.thumbsPath) {
                for (var i = 0; i < driveItem.pages && i < MAX_PUBLICATION_THUMB; i++) {
                    if (isPersistentlyDownloaded) {
                        var path = __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getPersistentDownloadsFolder();
                        var cover = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getPublicationCover(driveItem.thumbsPath, i + 1);
                        publicationCoversUrls.push(path + "/" + driveItem.id + "/" + cover);
                    }
                    else {
                        publicationCoversUrls.push(__WEBPACK_IMPORTED_MODULE_6__utils_url__["b" /* default */].getPublicationCoverUrl(galleryInfos.config, driveItem, i));
                    }
                }
                publicationCovers = publicationCoversUrls.map(function (url, i) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["o" /* PublicationCoverImage */], { key: i, src: url }); });
            }
            return publicationCovers;
        };
        _this.renderInfoRow = function (message, data, formatting) {
            var infoText = function () {
                switch (formatting) {
                    case Format.Date:
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Localize, { value: data, dateFormat: "date_format.long" });
                    case Format.Locale:
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__["Translate"], { value: data });
                    default:
                        return data;
                }
            };
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* Container */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["l" /* InfoRow */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["k" /* InfoLabel */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__["Translate"], { value: message })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["m" /* InfoText */], { uppercase: formatting === Format.Extension }, infoText()))));
        };
        _this.getImgElement = _this.getImgElement.bind(_this);
        _this.getPublicationCovers = _this.getPublicationCovers.bind(_this);
        return _this;
    }
    DriveItemDetail.prototype.render = function () {
        var _a = this.props, dispatch = _a.dispatch, driveItem = _a.driveItem, galleryInfos = _a.galleryInfos, isPersistentlyDownloaded = _a.isPersistentlyDownloaded, isRequested = _a.isRequested, isRequired = _a.isRequired, version = _a.version;
        var template = galleryInfos.template;
        var title = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getDisplayName(driveItem);
        var itemTypeKey = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getAssetTypeTranslationKey(driveItem.type, driveItem.format);
        var subtitle = I18n.t(itemTypeKey);
        var fileSize = driveItem.originalFileSize ? __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].formatFileSize(driveItem.originalFileSize) : null;
        var description = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getDescription(driveItem, template);
        var extension = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getExtension(driveItem);
        var locale = __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["d" /* default */].getLocale(driveItem);
        var sharedMethods = template.sharedMethods;
        var hasDownloadRights = sharedMethods && sharedMethods.includes(__WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].ShareMethod.Download);
        var isDesktop = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isDesktop();
        var isMobileApp = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp;
        var isOnline = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isOnline();
        var isSafariMobile = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isSafari() && (!isDesktop && !isMobileApp);
        var isReadable = false;
        var isDownloadable = false;
        switch (driveItem.type) {
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Directory:
                isReadable = true;
                isDownloadable = false;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.File:
                isReadable = isOnline || isPersistentlyDownloaded ? true : false;
                isDownloadable = isOnline && hasDownloadRights && (!isMobileApp || !isPersistentlyDownloaded) ? true : false;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Image:
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Movie:
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Sound:
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Publication:
                isReadable = isOnline || isPersistentlyDownloaded || driveItem.type === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Image ? true : false;
                isDownloadable = isOnline && hasDownloadRights && (!isMobileApp || !isPersistentlyDownloaded) && !isSafariMobile
                    ? true
                    : false; // Safari Mobile opens assets instead of downloading them
                break;
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.ExternalLink:
                isReadable = isOnline;
                isDownloadable = false;
                break;
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Component:
                isReadable = isOnline || isPersistentlyDownloaded ? true : false;
                isDownloadable = isOnline && isMobileApp && !isPersistentlyDownloaded;
                break;
            default:
                break;
        }
        var isUpdatable = isOnline && hasDownloadRights && isPersistentlyDownloaded && version < driveItem.version;
        var hasActionButtons = isReadable || isDownloadable || isUpdatable || isPersistentlyDownloaded;
        var publicationCovers = this.getPublicationCovers();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["q" /* StyledDriveItemDetail */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["i" /* Header */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* Container */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["j" /* HeaderInner */], null,
                        this.getImgElement(),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["t" /* TitleContainer */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["s" /* Title */], null, title),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["r" /* SubTitle */], null, subtitle))))),
            hasActionButtons &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* ActionButtons */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* Container */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* ActionButtonsInner */], null,
                            isReadable &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["p" /* StandardButton */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__["L" /* viewDriveItem */])(driveItem, __WEBPACK_IMPORTED_MODULE_3__DriveItemList_actions__["c" /* DriveItemOrigin */].Details)); } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__["Translate"], { value: "messages." + __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["a" /* ActionButton */].Read })),
                            (isDownloadable || isUpdatable) &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__DownloadButton__["a" /* default */], { driveItems: [driveItem], style: __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["b" /* ActionButtonStyle */].Bar, action: isUpdatable ? __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["a" /* ActionButton */].Update : __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["a" /* ActionButton */].Download }),
                            isRequired &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["p" /* StandardButton */], { disabled: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__["Translate"], { value: "messages.downloaded" })),
                            isRequested &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__DeleteButton__["a" /* default */], { driveItem: driveItem, style: __WEBPACK_IMPORTED_MODULE_4__utils_driveItem__["b" /* ActionButtonStyle */].Bar })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                description &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* Container */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["f" /* DescriptionRow */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* DescriptionLabel */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__["Translate"], { value: "messages.description" })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["g" /* DescriptionText */], { dangerouslySetInnerHTML: { __html: __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].nl2br(description) } }))),
                extension &&
                    this.renderInfoRow('messages.format', extension, Format.Extension),
                driveItem.resolution &&
                    this.renderInfoRow('messages.resolution', driveItem.resolution + " px"),
                fileSize && (driveItem.type !== __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Publication && driveItem.type !== __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].DriveItemType.Component) &&
                    this.renderInfoRow('messages.file_size', fileSize),
                driveItem.creationDate &&
                    this.renderInfoRow('messages.creation_date', driveItem.creationDate, Format.Date),
                driveItem.lastUpdateDate &&
                    this.renderInfoRow('messages.last_update_date', driveItem.lastUpdateDate, Format.Date),
                driveItem.endDate &&
                    this.renderInfoRow('messages.end_date', driveItem.endDate, Format.Date),
                locale &&
                    this.renderInfoRow('messages.language', "languages." + locale, Format.Locale),
                !!publicationCovers.length && (isOnline || isPersistentlyDownloaded) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* Container */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["n" /* PublicationCoverContainer */], null, publicationCovers)))));
    };
    return DriveItemDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state, props) {
    var galleryInfos = state.galleryInfos, downloadManager = state.downloadManager, offlineManager = state.offlineManager;
    var driveItem = props.driveItem;
    var isPersistentlyDownloaded = __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].isItemPersistentlyDownloaded(downloadManager, driveItem.id);
    var isRequired = __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].isRequiredItem(downloadManager, driveItem.id);
    var isRequested = isPersistentlyDownloaded && __WEBPACK_IMPORTED_MODULE_9__utils_downloadManager__["a" /* default */].isRequestedItem(downloadManager, driveItem.id);
    var version = downloadManager.items[driveItem.id] && downloadManager.items[driveItem.id].version;
    return { galleryInfos: galleryInfos, offlineManager: offlineManager, isPersistentlyDownloaded: isPersistentlyDownloaded, isRequired: isRequired, isRequested: isRequested, version: version };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(DriveItemDetail));


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeleteAllPopup__ = __webpack_require__(1462);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var DriveItemDeleteButton = /** @class */ (function (_super) {
    __extends(DriveItemDeleteButton, _super);
    function DriveItemDeleteButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, driveItem = _a.driveItem, style = _a.style, dispatch = _a.dispatch, isDeletingAll = _a.isDeletingAll;
            e.stopPropagation();
            if (style !== __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].ParametersPage && driveItem) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["c" /* deleteItem */])(driveItem));
            }
            else if (style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].ParametersPage && !isDeletingAll) {
                _this.setState({ isPopupDisplayed: true });
            }
        };
        _this.handleDeleteSequentially = function () {
            var dispatch = _this.props.dispatch;
            _this.setState({ isPopupDisplayed: false });
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["j" /* removeAllDownloads */])());
        };
        _this.handleResetAll = function () {
            var dispatch = _this.props.dispatch;
            _this.setState({ isPopupDisplayed: false });
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["n" /* resetAllDownloads */])());
        };
        _this.handleCancelPopup = function () {
            _this.setState({ isPopupDisplayed: false });
        };
        _this.renderButtonContent = function () {
            var _a = _this.props, style = _a.style, isDeletingAll = _a.isDeletingAll;
            var isPhone = __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isPhone();
            if (style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].Bar && !isPhone) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__["Translate"], { value: "messages.delete" });
            }
            else if (style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].Icon || (style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].Bar && isPhone)) {
                return __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_uprez_delete');
            }
            else if (style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].ParametersPage) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    isDeletingAll && __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_redux_i18n__["Translate"], { value: "messages.delete_data" })));
            }
            else {
                return;
            }
        };
        _this.state = {
            isPopupDisplayed: false,
        };
        _this.handleClick = _this.handleClick.bind(_this);
        _this.renderButtonContent = _this.renderButtonContent.bind(_this);
        _this.handleDeleteSequentially = _this.handleDeleteSequentially.bind(_this);
        _this.handleResetAll = _this.handleResetAll.bind(_this);
        _this.handleCancelPopup = _this.handleCancelPopup.bind(_this);
        return _this;
    }
    DriveItemDeleteButton.prototype.render = function () {
        var _a = this.props, style = _a.style, isDownloadingGroup = _a.isDownloadingGroup, isDeletingAll = _a.isDeletingAll;
        var isPopupDisplayed = this.state.isPopupDisplayed;
        var DeleteButton = __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* DeleteButtonVariants */][style];
        var isDisabled = style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].ParametersPage && isDownloadingGroup;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DeleteButton, { onClick: this.handleClick, disabled: isDisabled }, this.renderButtonContent()),
            style === __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["b" /* ActionButtonStyle */].ParametersPage && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__DeleteAllPopup__["a" /* default */], { isDisplayed: isPopupDisplayed, onDeleteSequentially: this.handleDeleteSequentially, onResetAll: this.handleResetAll, onCancel: this.handleCancelPopup, isProcessing: isDeletingAll }))));
    };
    return DriveItemDeleteButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DriveItemDeleteButton);


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteButtonVariants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button_styles__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ParametersPage_styles__ = __webpack_require__(103);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;





var DeleteButtonVariants = (_a = {},
    _a['Bar'] = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__components_Button_styles__["b" /* Button */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t\tmargin: 20px 5px;\n\n\t\t& > svg {\n\t\t\theight: 35px;\n\t\t\twidth: 35px;\n\t\t\tfill: ", ";\n\t\t}\n\n\t\t@media ", " {\n\t\t\tflex-basis: 25%;\n\t\t}\n\n\t\t@media (hover: hover) {\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tborder-color: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t"], ["\n\t\tborder-color: ", ";\n\t\tcolor: ", ";\n\t\tmargin: 20px 5px;\n\n\t\t& > svg {\n\t\t\theight: 35px;\n\t\t\twidth: 35px;\n\t\t\tfill: ", ";\n\t\t}\n\n\t\t@media ", " {\n\t\t\tflex-basis: 25%;\n\t\t}\n\n\t\t@media (hover: hover) {\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tborder-color: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["a" /* Format */].Smartphone, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White),
    _a['Icon'] = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tcursor: pointer;\n\t\t& > svg {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t}"], ["\n\t\tcursor: pointer;\n\t\t& > svg {\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t}"]))),
    _a['ParametersPage'] = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__components_ParametersPage_styles__["d" /* ParametersPageButton */])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["",
        ""])), Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tbackground-color: ", "};\n\t\tcolor: ", ";\n\t\topacity: ", ";\n\n\t\t& > div {\n\t\t\tdisplay: flex;\n\t\t\tflex-flow: row nowrap;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\n\t\t\t& > svg {\n\t\t\t\tposition: relative;\n\t\t\t\tleft: 5px;\n\t\t\t\theight: 25px;\n\t\t\t\twidth: 25px;\n\t\t\t\tanimation: ", ";\n\t\t\t}\n\n\t\t\t& > span {\n\t\t\t\tmargin: auto;\n\t\t\t}\n\t\t}\n\n\t\t@media (hover: hover) {\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t"], ["\n\t\tbackground-color: ", "};\n\t\tcolor: ", ";\n\t\topacity: ", ";\n\n\t\t& > div {\n\t\t\tdisplay: flex;\n\t\t\tflex-flow: row nowrap;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\n\t\t\t& > svg {\n\t\t\t\tposition: relative;\n\t\t\t\tleft: 5px;\n\t\t\t\theight: 25px;\n\t\t\t\twidth: 25px;\n\t\t\t\tanimation: ", ";\n\t\t\t}\n\n\t\t\t& > span {\n\t\t\t\tmargin: auto;\n\t\t\t}\n\t\t}\n\n\t\t@media (hover: hover) {\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, function (props) { return props.disabled ? 0.4 : 1; }, __WEBPACK_IMPORTED_MODULE_0__utils_style__["e" /* spin */], Object(__WEBPACK_IMPORTED_MODULE_0__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Red200, 10), Object(__WEBPACK_IMPORTED_MODULE_0__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 50))),
    _a);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1463);




var DeleteAllPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, isProcessing = _a.isProcessing, onDeleteSequentially = _a.onDeleteSequentially, onResetAll = _a.onResetAll, onCancel = _a.onCancel, label = _a.label, actionButtonColor = _a.actionButtonColor;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, isLoading: isProcessing, label: label || __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.delete_data'), actionButtonColor: actionButtonColor, onCancel: onCancel },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* PopupBodyWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onDeleteSequentially },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.delete_assets_sequentially" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onResetAll },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.reset_all_downloads" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DeleteAllPopup);


/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PopupBodyWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var PopupBodyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding-bottom: 10px;\n"], ["\n\tpadding-bottom: 10px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 50px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 50px;\n\tcolor: ", ";\n\ttext-align: center;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:not(:first-of-type) {\n\t\tborder-top: 1px solid ", ";\n\t}\n"], ["\n\twidth: 100%;\n\theight: 50px;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 50px;\n\tcolor: ", ";\n\ttext-align: center;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t&:not(:first-of-type) {\n\t\tborder-top: 1px solid ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey300);

var templateObject_1, templateObject_2;


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var BackButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tcolor: ", ";\n\n\t& > svg {\n\t\theight: 30px;\n\t\twidth: 10px;\n\t\tmargin: -10px 0;\n\t\tpadding: 0 10px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tcolor: ", ";\n\n\t& > svg {\n\t\theight: 30px;\n\t\twidth: 10px;\n\t\tmargin: -10px 0;\n\t\tpadding: 0 10px;\n\t\tfill: ", ";\n\t}\n"])), function (props) { return props.theme.primary.iconsColor; }, function (props) { return props.theme.primary.iconsColor; });
var templateObject_1;


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ParametersPage_Language__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ParametersPage_Navigation__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ParametersPage_AppInfos__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ParametersPage_ActionButtons__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Page_constants__ = __webpack_require__(71);







var ParametersPage = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_6__containers_Page_constants__["a" /* PageType */].ParametersPage, title: "messages.my_parameters" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ParametersPage_Language__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ParametersPage_Navigation__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ParametersPage_AppInfos__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_ParametersPage_ActionButtons__["a" /* default */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (ParametersPage);


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_Language__ = __webpack_require__(1467);


var mapStateToProps = function (state) {
    var locale = state.i18n.locale;
    return { language: locale };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_Language__["a" /* default */]));


/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_setLocales__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_App_actions__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(103);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var LanguageSelector = /** @class */ (function (_super) {
    __extends(LanguageSelector, _super);
    function LanguageSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.setLanguage = _this.setLanguage.bind(_this);
        return _this;
    }
    LanguageSelector.prototype.setLanguage = function (locale) {
        var dispatch = this.props.dispatch;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_App_actions__["d" /* setUserLocale */])(locale, true));
    };
    LanguageSelector.prototype.renderLanguageList = function () {
        var _this = this;
        var language = this.props.language;
        return Object.keys(__WEBPACK_IMPORTED_MODULE_2__store_setLocales__["a" /* Locales */]).map(function (locale) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* InfosFields */], { key: locale, onClick: function () { return _this.setLanguage(locale); }, isActive: language === locale },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["Translate"], { value: "languages." + locale })));
        });
    };
    LanguageSelector.prototype.render = function () {
        var language = this.props.language;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Accordion__["a" /* default */], { title: "messages.language", selectedOption: "languages." + language, isOpened: false }, this.renderLanguageList()));
    };
    return LanguageSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LanguageSelector);


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_Navigation__ = __webpack_require__(1469);


var mapStateToProps = function (state) {
    var displayType = state.driveList.displayType;
    return { displayType: displayType };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_Navigation__["a" /* default */]));


/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form_Checkbox__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(103);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var NavigationSelector = /** @class */ (function (_super) {
    __extends(NavigationSelector, _super);
    function NavigationSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { shouldResetFoldersDisplayType: false };
        _this.setDisplayType = _this.setDisplayType.bind(_this);
        _this.toggleResetFoldersDisplayType = _this.toggleResetFoldersDisplayType.bind(_this);
        return _this;
    }
    NavigationSelector.prototype.setDisplayType = function (newType) {
        var dispatch = this.props.dispatch;
        var shouldResetFoldersDisplayType = this.state.shouldResetFoldersDisplayType;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["K" /* updateListDisplayType */])(newType));
        if (shouldResetFoldersDisplayType) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_DriveItemList_actions__["y" /* resetFoldersDisplayType */])());
        }
    };
    NavigationSelector.prototype.toggleResetFoldersDisplayType = function () {
        this.setState({
            shouldResetFoldersDisplayType: !this.state.shouldResetFoldersDisplayType,
        });
    };
    NavigationSelector.prototype.renderDisplayTypesList = function () {
        var _this = this;
        var displayType = this.props.displayType;
        return Object.keys(__WEBPACK_IMPORTED_MODULE_4__containers_DriveItemList_constants__["b" /* ListDisplayType */]).map(function (type) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* InfosFields */], { key: type, onClick: function () { return _this.setDisplayType(type); }, isActive: displayType === type },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages." + __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].uncapitalize(type) }))); });
    };
    NavigationSelector.prototype.render = function () {
        var displayType = this.props.displayType;
        var shouldResetFoldersDisplayType = this.state.shouldResetFoldersDisplayType;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Accordion__["a" /* default */], { title: "messages.display_mode", selectedOption: "messages." + __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].uncapitalize(displayType), isOpened: false },
            this.renderDisplayTypesList(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* CheckboxWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Form_Checkbox__["a" /* default */], { name: "reset-display-mode", label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.reset_my_preferences" }), isChecked: shouldResetFoldersDisplayType, onChange: this.toggleResetFoldersDisplayType }))));
    };
    return NavigationSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (NavigationSelector);


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\n\tlabel {\n\t\tbox-sizing: border-box;\n\t\tposition: relative;\n\t\tpadding-left: 30px;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tbox-sizing: inherit;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tborder: 2px solid currentColor;\n\t\t\tborder-radius: 4px;\n\t\t}\n\n\t\tinput {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tsvg {\n\t\t\tposition: absolute;\n\t\t\ttop: 3px;\n\t\t\tleft: 3px;\n\t\t\twidth: 14px;\n\t\t\theight: 14px;\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\n\tlabel {\n\t\tbox-sizing: border-box;\n\t\tposition: relative;\n\t\tpadding-left: 30px;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tbox-sizing: inherit;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tborder: 2px solid currentColor;\n\t\t\tborder-radius: 4px;\n\t\t}\n\n\t\tinput {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tsvg {\n\t\t\tposition: absolute;\n\t\t\ttop: 3px;\n\t\t\tleft: 3px;\n\t\t\twidth: 14px;\n\t\t\theight: 14px;\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey500);

var templateObject_1;


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_AppInfos__ = __webpack_require__(1472);


var mapStateToProps = function (state) {
    var parametersPage = state.parametersPage;
    var usedSpace = parametersPage.usedSpace, freeSpace = parametersPage.freeSpace;
    return { usedSpace: usedSpace, freeSpace: freeSpace };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_AppInfos__["a" /* default */]));


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_version__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_version__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_nativeApi__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ParametersPage_actions__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(103);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var AppInfos = /** @class */ (function (_super) {
    __extends(AppInfos, _super);
    function AppInfos(props) {
        var _this = _super.call(this, props) || this;
        if (__WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp) {
            _this.setAppSpaceInfos();
        }
        return _this;
    }
    AppInfos.prototype.setAppSpaceInfos = function () {
        var dispatch = this.props.dispatch;
        __WEBPACK_IMPORTED_MODULE_6__utils_nativeApi__["b" /* default */].getUsedSpace().then(function (value) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_ParametersPage_actions__["c" /* setUsedSpace */])(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].formatFileSize(value)));
        });
        __WEBPACK_IMPORTED_MODULE_6__utils_nativeApi__["b" /* default */].getFreeSpace().then(function (value) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_ParametersPage_actions__["b" /* setFreeSpace */])(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].formatFileSize(value)));
        });
    };
    AppInfos.prototype.render = function () {
        var _a = this.props, freeSpace = _a.freeSpace, usedSpace = _a.usedSpace;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Accordion__["a" /* default */], { title: "messages.my_app", isOpened: true },
            __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* InfosFields */], { key: "usedSpace" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.used_space" }),
                        usedSpace),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* InfosFields */], { key: "freeSpace" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.free_space" }),
                        freeSpace)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* InfosFields */], { key: "version" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["Translate"], { value: "messages.version" }),
                __WEBPACK_IMPORTED_MODULE_1__utils_version__)));
    };
    return AppInfos;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AppInfos);


/***/ }),
/* 1473 */
/***/ (function(module, exports) {

// generated by genversion
module.exports = '3.72.0';


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_ActionButtons__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DownloadManager_reducer__ = __webpack_require__(28);



var mapStateToProps = function (state) {
    var downloadManager = state.downloadManager, _a = state.galleryInfos.config.importantAssets, importantAssetsEnabled = (_a === void 0 ? { enabled: false } : _a).enabled;
    var items = downloadManager.items;
    var downloadsIds = Object.keys(items);
    var hasDownloadedItems = false;
    downloadsIds.forEach(function (key) {
        var item = items[key];
        if (!hasDownloadedItems && item.mode !== __WEBPACK_IMPORTED_MODULE_2__DownloadManager_reducer__["c" /* DownloadMode */].Required) {
            hasDownloadedItems = true;
        }
    });
    return {
        hasDownloadedItems: hasDownloadedItems,
        importantAssetsEnabled: importantAssetsEnabled,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_ActionButtons__["a" /* default */]));


/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItem_DeleteButton__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DriveItem_DownloadGroupButton__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ParametersPage_ActionButtons_UpdateFolderTreeButton__ = __webpack_require__(1479);







var ActionButtons = function (props) {
    var hasDownloadedItems = props.hasDownloadedItems, importantAssetsEnabled = props.importantAssetsEnabled;
    var isMobileApp = __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ButtonContainer */], null,
        isMobileApp &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_DriveItem_DownloadGroupButton__["a" /* default */], null),
                importantAssetsEnabled &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_DriveItem_DownloadGroupButton__["a" /* default */], { isOnlyImportants: true })),
        hasDownloadedItems &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_DriveItem_DeleteButton__["a" /* default */], { style: __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["b" /* ActionButtonStyle */].ParametersPage }),
        isMobileApp && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_ParametersPage_ActionButtons_UpdateFolderTreeButton__["a" /* default */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (ActionButtons);


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadGroupButton__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__ = __webpack_require__(28);




var mapStateToProps = function (state, props) {
    var galleryInfos = state.galleryInfos, _a = state.galleryInfos, strongColor = _a.template.commonStyles.primary.strongColor, _b = _a.config, applicationGallery = _b.applicationGallery, importantAssets = _b.importantAssets, downloadManager = state.downloadManager, _c = state.downloadManager, downloadGroups = _c.downloadGroups, isDeletingAll = _c.isDeletingAll, driveList = state.driveList;
    var isOnlyImportants = props.isOnlyImportants;
    var downloadGroup = isOnlyImportants ? downloadGroups.important : downloadGroups.all;
    var isDownloading = downloadGroup.isDownloading, status = downloadGroup.status;
    var enabledImportantTags = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getEnabledImportantTags(importantAssets);
    var importantTagsParam = isOnlyImportants ? enabledImportantTags : [];
    var hasItemsToDownload = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].hasItemsToDownload(downloadManager, driveList, galleryInfos, importantTagsParam);
    var loaderStep = __WEBPACK_IMPORTED_MODULE_2__utils_downloadManager__["a" /* default */].getGalleryLoaderStep(downloadManager, driveList, applicationGallery, isDownloading, importantTagsParam);
    var downloadGroupButtonStatus = getDownloadGroupButtonStatus(status, hasItemsToDownload);
    return {
        strongColor: strongColor,
        isDownloading: isDownloading,
        isDeletingAll: isDeletingAll,
        loaderStep: loaderStep,
        status: downloadGroupButtonStatus,
    };
};
var getDownloadGroupButtonStatus = function (downloadAllStatus, hasItemsToDownload) {
    switch (downloadAllStatus) {
        case __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__["b" /* DownloadGroupStatus */].NotStarted:
            return __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadGroupButton__["a" /* DownloadGroupButtonStatus */].Download;
        case __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__["b" /* DownloadGroupStatus */].Started:
            return __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadGroupButton__["a" /* DownloadGroupButtonStatus */].ContinueDownloading;
        case __WEBPACK_IMPORTED_MODULE_3__DownloadManager_reducer__["b" /* DownloadGroupStatus */].Finished:
            return hasItemsToDownload ? __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadGroupButton__["a" /* DownloadGroupButtonStatus */].Update : __WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadGroupButton__["a" /* DownloadGroupButtonStatus */].DownloadComplete;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_DriveItem_DownloadGroupButton__["b" /* default */]));


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadGroupButtonStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions_store__ = __webpack_require__(112);







var DownloadGroupButtonStatus;
(function (DownloadGroupButtonStatus) {
    DownloadGroupButtonStatus["Download"] = "download_all";
    DownloadGroupButtonStatus["ContinueDownloading"] = "continue_downloading";
    DownloadGroupButtonStatus["DownloadComplete"] = "download_complete";
    DownloadGroupButtonStatus["Update"] = "update_all";
})(DownloadGroupButtonStatus || (DownloadGroupButtonStatus = {}));
var DownloadGroupButton = function (_a) {
    var isOnlyImportants = _a.isOnlyImportants, isDownloading = _a.isDownloading, loaderStep = _a.loaderStep, action = _a.action, status = _a.status, isDeletingAll = _a.isDeletingAll, strongColor = _a.strongColor, dispatch = _a.dispatch;
    if (isDeletingAll) {
        return null;
    }
    var handleClick = function () {
        if (isOnlyImportants) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["f" /* downloadImportantAssets */])());
            return;
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_DownloadManager_actions_store__["o" /* resetSelectedDownloadItems */])());
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_DownloadManager_actions__["e" /* downloadAll */])());
    };
    var renderButtonContent = function () {
        if (isDownloading) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Loader__["c" /* default */], { loaderStep: loaderStep ? loaderStep : { step: __WEBPACK_IMPORTED_MODULE_5__Loader__["a" /* LoaderStepName */].Downloading }, type: __WEBPACK_IMPORTED_MODULE_5__Loader__["b" /* LoaderType */].Button }));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages." + status + (isOnlyImportants ? '_important' : '') });
    };
    var isDownloadCompleted = status === DownloadGroupButtonStatus.DownloadComplete;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* StyledDownloadGroupButton */], { onClick: !isDownloadCompleted && handleClick, color: isDownloadCompleted ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Green : strongColor, action: action }, renderButtonContent()));
};
/* harmony default export */ __webpack_exports__["b"] = (DownloadGroupButton);


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDownloadGroupButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParametersPage_styles__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var StyledDownloadGroupButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__ParametersPage_styles__["d" /* ParametersPageButton */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t& div {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n"], ["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\n\t& div {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600, 10); }, function (props) { return props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600, 15); }, function (props) { return props.color || __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600; });

var templateObject_1;


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_ActionButtons_UpdateFolderTreeButton__ = __webpack_require__(1480);


var mapStateToProps = function (state) {
    var isUpdating = state.driveList.folderTreeUpdate.isUpdating;
    return { isUpdatingFolderTree: isUpdating };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ParametersPage_ActionButtons_UpdateFolderTreeButton__["a" /* default */]));


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var UpdateFolderTreeButton = function (_a) {
    var isUpdatingFolderTree = _a.isUpdatingFolderTree, dispatch = _a.dispatch;
    var onClick = function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["J" /* updateFolderTree */])(true)); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* StyledUpdateFolderTreeButton */], { isUpdating: isUpdatingFolderTree, onClick: onClick },
        isUpdatingFolderTree && __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_loading'),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.update_folder_tree" })));
};
/* harmony default export */ __webpack_exports__["a"] = (UpdateFolderTreeButton);


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledUpdateFolderTreeButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParametersPage_styles__ = __webpack_require__(103);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledUpdateFolderTreeButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__ParametersPage_styles__["d" /* ParametersPageButton */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: ", "\n\n\t& > svg {\n\t\tposition: relative;\n\t\tleft: 5px;\n\t\theight: 25px;\n\t\twidth: 25px;\n\t\tanimation: ", ";\n\t}\n\n\t", "\n"], ["\n\tcolor: ", "\n\n\t& > svg {\n\t\tposition: relative;\n\t\tleft: 5px;\n\t\theight: 25px;\n\t\twidth: 25px;\n\t\tanimation: ", ";\n\t}\n\n\t",
    "\n"])), function (props) { return props.theme.primary.strongColor; }, __WEBPACK_IMPORTED_MODULE_1__utils_style__["e" /* spin */], function (p) { return p.isUpdating && "\n\t& > span {\n\t\tmargin-left: 15px;\n\t}"; });

var templateObject_1;


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var mapStateToProps = function (state) {
    var clientId = state.galleryInfos.config.clientId, _a = state.profile, profileClientId = _a.clientId, name = _a.name, email = _a.email, position = _a.position, phone = _a.phone, isLoading = _a.isLoading, crmProviders = _a.crmProviders, emailProvider = _a.emailProvider, role = _a.role;
    return {
        clientId: clientId,
        name: name || '',
        email: email || '',
        position: position || '',
        phone: phone || '',
        isLoading: isLoading,
        crmProviders: crmProviders,
        emailProvider: emailProvider,
        isProfileLoaded: !!profileClientId,
        isReadOnlyApp: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isReadOnlyApp(role),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage__["a" /* default */]));


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ProfilePage_reducer__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_UserAvatar__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_EditableUserAvatar__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_ProfilePage_UserInfo__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_ProfilePage_CRMSelector__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_ProfilePage_EmailIntegration__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_MultiAppAuthentication_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_userAgent__ = __webpack_require__(6);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

















var FieldNames;
(function (FieldNames) {
    FieldNames["name"] = "name";
    FieldNames["email"] = "email";
    FieldNames["position"] = "position";
    FieldNames["phone"] = "phone";
    FieldNames["password"] = "password";
    FieldNames["confirmPassword"] = "confirmPassword";
})(FieldNames || (FieldNames = {}));
var NAME_MIN_LENGTH = 4;
var PASSWORD_MIN_LENGTH = 6;
var isError = function (name, value, data) {
    if (data === void 0) { data = {}; }
    return ((name === FieldNames.name && value.length < NAME_MIN_LENGTH) ||
        (name === FieldNames.password && value && value.length < PASSWORD_MIN_LENGTH) ||
        (name === FieldNames.confirmPassword && value !== data.password));
};
var ProfilePage = function (_a) {
    var clientId = _a.clientId, initialName = _a.name, initialEmail = _a.email, initialPosition = _a.position, initialPhone = _a.phone, isLoading = _a.isLoading, isProfileLoaded = _a.isProfileLoaded, crmProviders = _a.crmProviders, emailProvider = _a.emailProvider, isReadOnlyApp = _a.isReadOnlyApp, dispatch = _a.dispatch;
    var initialState = {
        name: initialName,
        position: initialPosition,
        phone: initialPhone,
        password: '',
        confirmPassword: '',
        crmProviders: null,
        editedFields: {},
        errors: {},
    };
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialState), 2), state = _b[0], setState = _b[1];
    var handleFormSubmit = function (e) {
        e.preventDefault();
        var editedFields = Object.keys(state.editedFields).reduce(function (acc, key) {
            if (state.editedFields[key]) {
                acc[key] = state[key];
            }
            return acc;
        }, {});
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_ProfilePage_actions__["h" /* saveProfileData */])(editedFields));
    };
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setState(function (state) {
            var _a, _b, _c;
            return (__assign({}, state, (_a = {}, _a[name] = value, _a.editedFields = __assign({}, state.editedFields, (_b = {}, _b[name] = true, _b)), _a.errors = __assign({}, state.errors, (_c = {}, _c[name] = isError(name, value), _c)), _a)));
        });
    };
    var handlePasswordChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setState(function (state) {
            var _a, _b, _c;
            return (__assign({}, state, (_a = {}, _a[name] = value, _a.editedFields = __assign({}, state.editedFields, (_b = {}, _b[name] = !!value, _b)), _a.errors = __assign({}, state.errors, (_c = {}, _c[name] = isError(name, value), _c[FieldNames.confirmPassword] = isError(FieldNames.confirmPassword, confirmPassword, { password: value }), _c)), _a)));
        });
    };
    var handleConfirmPasswordChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setState(function (state) {
            var _a, _b, _c;
            return (__assign({}, state, (_a = {}, _a[name] = value, _a.editedFields = __assign({}, state.editedFields, (_b = {}, _b[name] = !!value, _b)), _a.errors = __assign({}, state.errors, (_c = {}, _c[name] = isError(name, value, { password: password }), _c)), _a)));
        });
    };
    var handleCRMProviderChange = function (crmProvider) {
        setState(function (state) { return (__assign({}, state, { crmProviders: crmProvider === __WEBPACK_IMPORTED_MODULE_14__typings_api__["a" /* Api */].CRMProviders.NONE ? [] : null, editedFields: __assign({}, state.editedFields, { crmProviders: true }) })); });
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_ProfilePage_actions__["e" /* getProfileData */])(clientId));
    }, [clientId]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isLoading) {
            setState(initialState);
        }
    }, [isLoading]);
    var name = state.name, position = state.position, phone = state.phone, password = state.password, confirmPassword = state.confirmPassword, errors = state.errors;
    var isSaveDisabled = Object.values(errors).includes(true);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_3__containers_Page_constants__["a" /* PageType */].ProfilePage, title: "messages.my_profile" },
        isLoading &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["g" /* Loader */], null,
                __WEBPACK_IMPORTED_MODULE_15__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["d" /* Header */], null,
            !__WEBPACK_IMPORTED_MODULE_16__utils_userAgent__["a" /* default */].isOnline() && !isProfileLoaded &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["h" /* Message */], { value: "messages.profile_offline_message" }),
            isProfileLoaded &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["k" /* UserInfoWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_16__utils_userAgent__["a" /* default */].isOnline()
                        ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_EditableUserAvatar__["a" /* default */], null)
                        : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_UserAvatar__["a" /* default */], { size: __WEBPACK_IMPORTED_MODULE_5__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_ProfilePage_UserInfo__["a" /* default */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* ButtonLogout */], { type: "button", onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__containers_MultiAppAuthentication_actions__["k" /* signOut */])()); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.log_out" }))),
        !__WEBPACK_IMPORTED_MODULE_16__utils_userAgent__["a" /* default */].isOnline() && isProfileLoaded &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["h" /* Message */], { value: "messages.profile_offline_message" }),
        __WEBPACK_IMPORTED_MODULE_16__utils_userAgent__["a" /* default */].isOnline() && isProfileLoaded &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { onSubmit: handleFormSubmit, className: "ProfileForm" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Accordion__["a" /* default */], { title: "messages.profile", isOpened: true },
                    errors.name &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["c" /* Error */], { value: "error.field_must_have_at_least", charsCount: NAME_MIN_LENGTH.toString() }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["e" /* Input */], { type: "text", name: FieldNames.name, value: name, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.name_surname'), isError: errors.name, onChange: handleInputChange }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["e" /* Input */], { type: "text", name: FieldNames.position, value: position, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.position'), onChange: handleInputChange }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["e" /* Input */], { type: "text", name: FieldNames.email, value: initialEmail, readOnly: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["e" /* Input */], { type: "text", name: FieldNames.phone, value: phone, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.phone_number'), onChange: handleInputChange })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Accordion__["a" /* default */], { title: "messages.password", isOpened: true },
                    errors.password &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["c" /* Error */], { value: "error.field_must_have_at_least", charsCount: PASSWORD_MIN_LENGTH.toString() }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["e" /* Input */], { type: "password", name: FieldNames.password, value: password, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.change_password'), isError: errors.password, onChange: handlePasswordChange }),
                    errors.confirmPassword &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["c" /* Error */], { value: "error.passwords_do_not_match" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["e" /* Input */], { type: "password", name: FieldNames.confirmPassword, value: confirmPassword, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.confirm_password'), isError: errors.confirmPassword, onChange: handleConfirmPasswordChange })),
                !isReadOnlyApp &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                        crmProviders && crmProviders.length > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__containers_ProfilePage_CRMSelector__["a" /* default */], { onChange: handleCRMProviderChange }),
                        emailProvider && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__containers_ProfilePage_EmailIntegration__["a" /* default */], null)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__styles__["b" /* ButtonSave */], { type: "submit", disabled: isSaveDisabled },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.save" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ProfilePage);


/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_EditableUserAvatar__ = __webpack_require__(1485);


var mapStateToProps = function (state) {
    var _a = state.profile, _b = _a.userAvatar, file = _b.file, isEdited = _b.isEdited, photoPath = _a.photoPath;
    return {
        hasAvatar: !!file || !!photoPath,
        isEdited: isEdited,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_EditableUserAvatar__["a" /* default */]));


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_MediaEditor__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ProfilePage_EditableUserAvatar_Image__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ImportManager__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_reducer__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__ = __webpack_require__(11);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};











var EditableUserAvatar = function (_a) {
    var hasAvatar = _a.hasAvatar, isEdited = _a.isEdited, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isActive = _b[0], setIsActive = _b[1];
    var handleLoad = function (width, height) {
        var positionAndSize = Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_utils_helpers__["n" /* getImageCenteredPositionAndSize */])(__WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG, __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG, width, height);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_actions__["i" /* updateUserAvatar */])(positionAndSize));
    };
    var isEditedRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](isEdited);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        isEditedRef.current = isEdited;
    });
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        return function () {
            // reset changes if it was not saved on the server
            if (isEditedRef.current) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_actions__["g" /* resetUserAvatar */])());
            }
        };
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* ImageWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ImageFrame */], null, hasAvatar
                ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_MediaEditor__["a" /* default */], { type: __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].image, page: -1, editableMediaItem: { id: '' }, frameWidth: __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG, frameHeight: __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG, pageScale: 1, isActive: isActive, canDragAndResize: true, isCustom: true, MediaComponent: __WEBPACK_IMPORTED_MODULE_3__containers_ProfilePage_EditableUserAvatar_Image__["a" /* default */], onLoad: handleLoad, onFrameClick: function () { return setIsActive(true); }, onFrameClickOutside: function () { return setIsActive(false); }, onMediaClickOutside: function (positionAndSize) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_actions__["i" /* updateUserAvatar */])(positionAndSize)); } }))
                : __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_uprez-user_avatar')),
            !isActive && !hasAvatar &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_ImportManager__["a" /* default */], { id: "user-avatar", triggerComponent: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Button */], { as: "div", isRemove: false }, __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_close-2')), extensions: __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].imageWithSvgExtensions.join(','), customImportHandler: function (file, isCorrectFileType) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_actions__["c" /* addUserAvatar */])(file, isCorrectFileType)); } }),
            !isActive && hasAvatar &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Button */], { type: "button", isRemove: true, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_ProfilePage_actions__["f" /* removeUserAvatar */])()); } }, __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_close-2')))));
};
/* harmony default export */ __webpack_exports__["a"] = (EditableUserAvatar);


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImageFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__ = __webpack_require__(120);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1;\n"], ["\n\tflex: 1;\n"])));
var ImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tz-index: 1;\n\twidth: ", "px;\n\theight: ", "px;\n\tmargin: 0 auto;\n"], ["\n\tposition: relative;\n\tz-index: 1;\n\twidth: ", "px;\n\theight: ", "px;\n\tmargin: 0 auto;\n"])), __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG, __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG);
var ImageFrame = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: ", "px;\n\t\theight: ", "px;\n\t}\n"], ["\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: ", "px;\n\t\theight: ", "px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey100, __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG, __WEBPACK_IMPORTED_MODULE_2__containers_ProfilePage_reducer__["a" /* AvatarSize */].BIG);
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 32px;\n\theight: 32px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: ", ";\n\t\t", ";\n\t}\n"], ["\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 32px;\n\theight: 32px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tfill: ", ";\n\t\t", ";\n\t}\n"])), function (props) { return props.isRemove ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Red300 : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600; }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (props) { return !props.isRemove && 'transform: rotate(45deg);'; });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_MediaPanel__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_EditPanel_LinkPanel__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_MediaEditor_MediaItem__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_VisibilityToggle__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinner_styles__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};













var MediaEditor = function (_a) {
    var _b = _a.editorType, editorType = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].INDESIGN : _b, type = _a.type, page = _a.page, frameWidth = _a.frameWidth, frameHeight = _a.frameHeight, pageScale = _a.pageScale, frameAspectRatio = _a.frameAspectRatio, isDefaultMedia = _a.isDefaultMedia, defaultStyle = _a.defaultStyle, parentContainer = _a.parentContainer, iframeContainer = _a.iframeContainer, isEditPanelDisplayed = _a.isEditPanelDisplayed, isActive = _a.isActive, canDragAndResize = _a.canDragAndResize, hasLink = _a.hasLink, linkData = _a.linkData, isProcessingVideo = _a.isProcessingVideo, dispatch = _a.dispatch, isCustom = _a.isCustom, _c = _a.isVisible, isVisible = _c === void 0 ? true : _c, isInsideButton = _a.isInsideButton, _d = _a.MediaComponent, MediaComponent = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_6__containers_Editor_MediaEditor_MediaItem__["a" /* default */] : _d, onLoad = _a.onLoad, onFrameClick = _a.onFrameClick, onFrameClickOutside = _a.onFrameClickOutside, onMediaClickOutside = _a.onMediaClickOutside, isAccessibleVersion = _a.isAccessibleVersion, editableMediaItem = _a.editableMediaItem;
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](editableMediaItem.altAttr), 2), altAttr = _e[0], setAltAttr = _e[1];
    var _f = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](editableMediaItem.driveLink || editableMediaItem.defaultLink), 2), src = _f[0], setSrc = _f[1];
    var _g = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isFocusedInEditPanel = _g[0], setIsFocusedInEditPanel = _g[1];
    var id = editableMediaItem.id;
    var isResizeListenerInitialized = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
    var handleItemAfterLoad = function () {
        if (isActive && parentContainer) {
            parentContainer.classList.add('is-active');
        }
    };
    var handleClick = function () {
        if (!isActive) {
            if (isCustom && onFrameClick) {
                return onFrameClick();
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (parentContainer) {
                parentContainer.classList.add('is-active');
                if (editorType === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].HTML) {
                    resetCustomMediaStyle();
                }
            }
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var handleLinkChange = function (linkData) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["_1" /* updateEditableLink */])(page, id, { linkData: linkData }));
    };
    var handleVisibilityToggle = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, {
            isVisible: !isVisible,
        }));
    };
    var handleBlur = function () {
        var currentSrc = editableMediaItem.driveLink || editableMediaItem.defaultLink;
        if (altAttr !== editableMediaItem.altAttr || src !== currentSrc) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, {
                altAttr: altAttr,
                driveLink: src,
            }));
        }
    };
    var renderEditPanel = function () {
        var _a;
        var editPanels = (_a = {},
            _a[type] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_MediaPanel__["a" /* default */], { type: type, page: page, editableMediaItem: editableMediaItem, altAttr: altAttr, setAltAttr: setAltAttr, src: src, setSrc: setSrc })),
            _a);
        if (hasLink) {
            editPanels[__WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["c" /* EditableType */].link] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_EditPanel_LinkPanel__["a" /* default */], { linkData: linkData, onChange: handleLinkChange, onFocus: function () { return setIsFocusedInEditPanel(true); }, onBlur: function () { return setIsFocusedInEditPanel(false); } }));
        }
        return (isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel__["a" /* default */], { defaultType: type, panels: editPanels })));
    };
    var setCustomMediaStyle = function () {
        if (parentContainer) {
            var style = "position:relative;overflow:hidden;width:100%;height:" + frameHeight + "px;" + defaultStyle;
            parentContainer.setAttribute('style', style);
        }
    };
    var resetCustomMediaStyle = function () {
        if (parentContainer) {
            if (defaultStyle) {
                parentContainer.setAttribute('style', defaultStyle);
            }
            else {
                parentContainer.removeAttribute('style');
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].HTML) {
            return;
        }
        var handleWindowClick = function (e) {
            var mediaSelector = '.uprez-media-frame';
            var element = e.target;
            var isMedia = !!element.closest(mediaSelector);
            if (!isMedia) {
                if (isCustom && onFrameClickOutside) {
                    onFrameClickOutside();
                }
                if (parentContainer) {
                    parentContainer.classList.remove('is-active');
                }
            }
        };
        window.addEventListener('mousedown', handleWindowClick);
        return function () {
            window.removeEventListener('mousedown', handleWindowClick);
        };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].INDESIGN || !isActive) {
            return;
        }
        var handleWindowClick = function (e) {
            var mediaSelector = '.uprez-media-frame';
            var element = e.target;
            var isMedia = !!element.closest(mediaSelector);
            if (!isMedia && !element.closest("." + __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */])) {
                if (parentContainer) {
                    parentContainer.classList.remove('is-active');
                    if (isDefaultMedia) {
                        resetCustomMediaStyle();
                        if (type === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["c" /* EditableType */].video) {
                            parentContainer.classList.remove('is-video-cover');
                        }
                    }
                    else {
                        setCustomMediaStyle();
                        if (type === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["c" /* EditableType */].video) {
                            parentContainer.classList.add('is-video-cover');
                        }
                    }
                }
            }
        };
        window.addEventListener('mousedown', handleWindowClick);
        if (iframeContainer) {
            iframeContainer.contentDocument.addEventListener('mousedown', handleWindowClick);
        }
        return function () {
            window.removeEventListener('mousedown', handleWindowClick);
            if (iframeContainer) {
                iframeContainer.contentDocument.removeEventListener('mousedown', handleWindowClick);
            }
        };
    }, [isActive, isDefaultMedia]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType !== __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].HTML || !parentContainer || isActive) {
            return;
        }
        // set styles on parentContainer when frame sizes are changed
        if (isDefaultMedia) {
            resetCustomMediaStyle();
        }
        else {
            setCustomMediaStyle();
        }
    }, [isActive, isDefaultMedia, frameWidth, frameHeight]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType !== __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].HTML || !parentContainer || type !== __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["c" /* EditableType */].video) {
            return;
        }
        if (isDefaultMedia) {
            parentContainer.classList.add('is-default-video');
            parentContainer.classList.remove('is-video-cover');
        }
        else {
            parentContainer.classList.add('is-video-cover');
            parentContainer.classList.remove('is-default-video');
        }
    }, [isDefaultMedia]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType !== __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].HTML || !iframeContainer || !parentContainer || isDefaultMedia) {
            return;
        }
        var handleResize = function () {
            var width = parentContainer.getBoundingClientRect().width;
            // this checking is needed to handle a case when parentContainer becomes invisible in viewport (width = 0)
            // (e.g., change an image in slider and click on next slide)
            if (width) {
                if (defaultStyle && Object(__WEBPACK_IMPORTED_MODULE_11__containers_Editor_utils_helpers__["_0" /* isStyleIncludesHeight */])(defaultStyle)) {
                    return;
                }
                parentContainer.style.height = width * frameAspectRatio + "px";
            }
        };
        if (!isResizeListenerInitialized.current && !isActive) {
            if (iframeContainer.contentWindow.visualViewport) {
                iframeContainer.contentWindow.visualViewport.addEventListener('resize', handleResize);
            }
            else {
                iframeContainer.contentWindow.addEventListener('resize', handleResize);
            }
            isResizeListenerInitialized.current = true;
        }
        if (isResizeListenerInitialized.current && isActive) {
            if (iframeContainer.contentWindow.visualViewport) {
                iframeContainer.contentWindow.visualViewport.removeEventListener('resize', handleResize);
            }
            else {
                iframeContainer.contentWindow.removeEventListener('resize', handleResize);
            }
            isResizeListenerInitialized.current = false;
        }
    }, [isDefaultMedia, isActive]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].INDESIGN && !isCustom && !isInsideButton && parentContainer) {
            parentContainer.style.overflow = 'visible';
        }
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isActive && isAccessibleVersion) {
            handleBlur();
        }
    }, [isActive]);
    var frameClasses = __WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].getCssClasses(__WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] + " uprez-media-frame", {
        'is-active': isActive,
        'can-drag': canDragAndResize,
        'is-video-cover': type === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["c" /* EditableType */].video,
    });
    var frameBorderClasses = __WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].getCssClasses('uprez-media-frame-border', {
        'is-active': isActive,
    });
    // is needed for rendering in iframe (for html editor)
    var frameStyle = {
        width: frameWidth ? frameWidth + "px" : undefined,
        height: frameHeight ? frameHeight + "px" : undefined,
    };
    if (editorType === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].HTML && !isActive) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MediaComponent, { type: type, editableMediaItem: editableMediaItem, scale: pageScale, isActive: isActive, isKeyActionsDisabled: !isActive || isFocusedInEditPanel, canDragAndResize: false, isCustom: isCustom, onAfterLoad: handleItemAfterLoad, onLoad: onLoad, onClick: handleClick, onClickOutside: onMediaClickOutside, parentContainer: parentContainer }));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        editorType === __WEBPACK_IMPORTED_MODULE_10__containers_Editor_constants__["e" /* EditorType */].INDESIGN && !isCustom && !isInsideButton &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_Editor_VisibilityToggle__["a" /* default */], { isVisible: isVisible, isParentActive: isActive, pageScale: pageScale, onToggle: handleVisibilityToggle }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* Frame */], { className: frameClasses, isActive: isActive, canDragAndResize: canDragAndResize, mediaType: type, width: frameWidth, height: frameHeight, style: frameStyle, onClick: handleClick, onTouchEnd: handleClick, isAccessibleVersion: isAccessibleVersion },
            (isActive || !isVisible) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* FrameBorder */], { className: frameBorderClasses, isActive: isActive, borderWidth: Object(__WEBPACK_IMPORTED_MODULE_11__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) }),
            isProcessingVideo &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* FrameLoader */], { className: "uprez-media-frame-loader", borderWidth: Object(__WEBPACK_IMPORTED_MODULE_11__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* FrameMask */], { className: "uprez-media-frame-mask" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* FrameLoaderInner */], { className: "uprez-media-frame-loader-inner", scale: pageScale },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinner_styles__["a" /* Spinner */], { className: "uprez-media-frame-spinner", width: "45px", height: "45px" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.video_processing" }))),
            isVisible &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MediaComponent, { type: type, editableMediaItem: editableMediaItem, scale: pageScale, isActive: isActive, isKeyActionsDisabled: !isActive || isFocusedInEditPanel, canDragAndResize: canDragAndResize, isCustom: isCustom, onAfterLoad: handleItemAfterLoad, onLoad: onLoad, onClickOutside: onMediaClickOutside, iframeContainer: iframeContainer }),
            renderEditPanel())));
};
/* harmony default export */ __webpack_exports__["a"] = (MediaEditor);


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_MediaPanel__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);



var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, editorType = _a.type, id = _a.activeItem.id, isAccessibleVersion = _a.isAccessibleVersion, byId = state.importManager.byId;
    var page = ownProps.page, editableMediaItem = ownProps.editableMediaItem;
    var label = editableMediaItem.label, defaultLink = editableMediaItem.defaultLink, driveLink = editableMediaItem.driveLink, externalLink = editableMediaItem.externalLink, isExternalLinkActive = editableMediaItem.isExternalLinkActive, frameWidth = editableMediaItem.frameWidth, frameHeight = editableMediaItem.frameHeight, importManagerId = editableMediaItem.importManagerId;
    return {
        page: page,
        id: id,
        label: label,
        defaultLink: defaultLink,
        driveLink: driveLink,
        externalLink: externalLink,
        isExternalLinkActive: isExternalLinkActive,
        frameWidth: frameWidth,
        frameHeight: frameHeight,
        importManagerId: importManagerId,
        isImporting: !!byId[importManagerId],
        isPercentageValues: editorType === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].HTML,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_MediaPanel__["a" /* default */]));


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourcePanel__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YoutubeLinkPanel__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(36);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};













var IMAGE_MAX_WIDTH = 1920;
var SKIP_OPTIMIZATION_IMAGE_FORMAT = 'png';
var MediaPanel = function (_a) {
    var type = _a.type, id = _a.id, page = _a.page, label = _a.label, defaultLink = _a.defaultLink, driveLink = _a.driveLink, externalLink = _a.externalLink, isExternalLinkActive = _a.isExternalLinkActive, frameWidth = _a.frameWidth, frameHeight = _a.frameHeight, importManagerId = _a.importManagerId, isImporting = _a.isImporting, dispatch = _a.dispatch, isPercentageValues = _a.isPercentageValues, isAccessibleVersion = _a.isAccessibleVersion, altAttr = _a.altAttr, setAltAttr = _a.setAltAttr, src = _a.src, setSrc = _a.setSrc;
    var _b;
    var altAttrInputElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var srcInputElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var config = (_b = {},
        _b[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].image] = {
            iconName: 'iconset_uprez_image',
            defaultLabel: 'messages.default_image',
            isValidResourceFromApp: function (_a) {
                var type = _a.type;
                return type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Image;
            },
            fileExtensions: __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].imageWithPdfExtensions,
            canDragAndResize: true,
            isOptimizedImageImport: true,
        },
        _b[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].video] = {
            iconName: 'iconset_uprez_video',
            defaultLabel: 'messages.default_video',
            isValidResourceFromApp: function (_a) {
                var type = _a.type;
                return type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Movie;
            },
            fileExtensions: __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].videoExtensions,
            canDragAndResize: false,
            linkPanel: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__YoutubeLinkPanel__["a" /* default */], { value: externalLink, onChange: function (value) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, {
                        externalLink: value,
                        isExternalLinkActive: true,
                        canDragAndResize: false,
                    }));
                } })),
        },
        _b[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].animation] = {
            iconName: 'iconset_uprez_animation',
            defaultLabel: 'messages.default_animation',
            isValidResourceFromApp: function (_a) {
                var type = _a.type;
                return type === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].DriveItemType.Component;
            },
            fileExtensions: __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].componentExtensions,
            canDragAndResize: false,
            fileType: __WEBPACK_IMPORTED_MODULE_6__containers_ImportManager_actions__["b" /* FileType */].COMPONENT,
        },
        _b);
    var _c = config[type], iconName = _c.iconName, defaultLabel = _c.defaultLabel, isValidResourceFromApp = _c.isValidResourceFromApp, fileExtensions = _c.fileExtensions, canDragAndResize = _c.canDragAndResize, linkPanel = _c.linkPanel, fileType = _c.fileType, isOptimizedImageImport = _c.isOptimizedImageImport;
    var handleResourceSelect = function (driveItem) {
        var src = driveItem.src, label = driveItem.label, name = driveItem.name, resolution = driveItem.resolution;
        var newDriveLink = src;
        var width = frameWidth;
        var height = frameHeight;
        if (resolution) {
            width = +resolution.split('x')[0];
            height = +resolution.split('x')[1];
        }
        var canOptimizeImage = type === __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].image &&
            width > IMAGE_MAX_WIDTH &&
            __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getFileExtension(name) !== SKIP_OPTIMIZATION_IMAGE_FORMAT;
        if (canOptimizeImage) {
            var optimizedImage = Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__["v" /* getOptimizedImage */])(driveItem, width, height, IMAGE_MAX_WIDTH);
            width = optimizedImage.width;
            height = optimizedImage.height;
            newDriveLink = optimizedImage.src;
        }
        var isSameImage = type === __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].image && driveLink === newDriveLink;
        if (isSameImage) {
            // we have to add some hash to url in order to make browser to load the same file
            newDriveLink += "?" + Math.random() + "&";
        }
        if (type === __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].animation) {
            newDriveLink += '/index.html';
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, __assign({}, Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__["n" /* getImageCenteredPositionAndSize */])(frameWidth, frameHeight, width, height, isPercentageValues), { driveLink: newDriveLink, label: label, isExternalLinkActive: false, isLoaded: false, canDragAndResize: canDragAndResize })));
    };
    var handleResourceReset = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, {
            label: '',
            driveLink: '',
            externalLink: Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__["T" /* getYoutubeLink */])(defaultLink) ? defaultLink : '',
            isExternalLinkActive: !!Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__["T" /* getYoutubeLink */])(defaultLink),
            canDragAndResize: false,
        }));
    };
    var isResetButtonDisplayed = isExternalLinkActive
        ? !!externalLink && externalLink !== defaultLink
        : !!driveLink;
    var handleAltAttrChange = function (e) {
        setAltAttr(e.target.value);
    };
    var handleImageSrcChange = function (e) {
        setSrc(e.target.value);
    };
    return (isAccessibleVersion
        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Label */], { value: "messages.alt_attribute" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styles__["g" /* InputWrapper */], { hasButtonRemove: false, hasLabel: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { ref: altAttrInputElement, type: "text", id: id, value: altAttr, placeholder: __WEBPACK_IMPORTED_MODULE_10_react_redux_i18n__["I18n"].t('messages.enter_image_description'), onChange: handleAltAttrChange, autoFocus: true })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Label */], { value: "messages.image_source" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styles__["g" /* InputWrapper */], { hasButtonRemove: false, hasLabel: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { ref: srcInputElement, type: "text", id: id + "-src", value: src, placeholder: __WEBPACK_IMPORTED_MODULE_10_react_redux_i18n__["I18n"].t('messages.enter_image_source'), onChange: handleImageSrcChange }))))
        : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ResourcePanel__["a" /* default */], { iconName: iconName, label: driveLink ? label : defaultLabel, isExternalLinkActive: isExternalLinkActive, linkPanel: linkPanel, importManagerId: importManagerId, isImporting: isImporting, isResetButtonDisplayed: isResetButtonDisplayed, isValidResourceFromApp: isValidResourceFromApp, fileExtensions: fileExtensions, isFileExtensionsDisplayed: true, isOptimizedImageImport: isOptimizedImageImport, fileType: fileType, dispatch: dispatch, onResourceSelect: handleResourceSelect, onResourceReset: handleResourceReset })));
};
/* harmony default export */ __webpack_exports__["a"] = (MediaPanel);


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var MainView = function (_a) {
    var iconName = _a.iconName, label = _a.label, isResetButtonDisplayed = _a.isResetButtonDisplayed, onReplaceClick = _a.onReplaceClick, onResetClick = _a.onResetClick, isExternalLinkActive = _a.isExternalLinkActive, linkPanel = _a.linkPanel;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        isExternalLinkActive && linkPanel
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, linkPanel)
            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* Label */], { value: "messages.your_file" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* FileName */], null,
                    __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon(iconName),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label })))),
        isResetButtonDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onResetClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.reset_to_default" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: onReplaceClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.replace" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (MainView);


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LinkTypeToggle__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ResourcePanel__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkPanelInput__ = __webpack_require__(1494);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;











var getTypeFromLinkData = function (linkData) { return linkData ? linkData.type : __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["h" /* LinkType */].unsupported; };
var LinkPanel = function (_a) {
    var linkData = _a.linkData, isImporting = _a.isImporting, _b = _a.spreads, spreads = _b === void 0 ? [] : _b, _c = _a.canAddLink, canAddLink = _c === void 0 ? true : _c, _d = _a.canAddPopupAction, canAddPopupAction = _d === void 0 ? false : _d, isUrlLinkOnly = _a.isUrlLinkOnly, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, dispatch = _a.dispatch;
    var initialType = getTypeFromLinkData(linkData);
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialType), 2), type = _e[0], setType = _e[1];
    var isPublicationPopup = linkData && linkData.type === __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["h" /* LinkType */].popup && linkData.data.item.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemFileTypes.PUBLICATION;
    var initialPublicationPage = '1';
    if (isPublicationPopup) {
        initialPublicationPage = linkData.data.page.toString();
    }
    var _f = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialPublicationPage), 2), publicationPage = _f[0], setPublicationPage = _f[1];
    var handleTypeChange = function (newType) {
        setType(newType);
    };
    var renderSettings = function (isDriveResource) {
        return isDriveResource ?
            renderDriveAssetSettings() :
            renderLinkSettings();
    };
    var renderLinkSettings = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__LinkPanelInput__["a" /* default */], { linkData: linkData, type: type, spreads: spreads, canAddLink: canAddLink, onChange: onChange, onFocus: onFocus, onBlur: onBlur })); };
    var onPublicationPageChange = function (page) {
        setPublicationPage(page);
        var newLinkData = __assign({}, linkData);
        var pageNumber = parseInt(page, 10);
        newLinkData.data.page = pageNumber ? pageNumber : 1;
        onChange(newLinkData);
    };
    var onResourceSelect = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var aspDriveItem, publicationPage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_DriveItemList_actions__["k" /* getAspDriveItem */])(item.id))];
                case 1:
                    aspDriveItem = _a.sent();
                    publicationPage = 1;
                    setPublicationPage(publicationPage.toString());
                    onChange({
                        type: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["h" /* LinkType */].popup,
                        data: {
                            item: aspDriveItem,
                            page: publicationPage,
                        },
                        originalParams: linkData && linkData.type === __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["h" /* LinkType */].popup && linkData.originalParams
                            ? linkData.originalParams
                            : undefined,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var renderPublicationPageInput = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* PageTitle */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.page" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* PageInput */], { onChange: function (event) { return onPublicationPageChange(event.currentTarget.value); }, value: publicationPage })));
    };
    var renderDriveAssetSettings = function () {
        var linkPopupData = linkData;
        var fileExtensions = __spread(__WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].publicationExtensions, __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].imageWithSvgExtensions, __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].videoExtensions, __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["d" /* default */].componentExtensions);
        var openableDriveItemTypes = [
            __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Component,
            __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Image,
            __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Movie,
            __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].DriveItemType.Publication,
        ];
        var isPublication = linkPopupData.data.item && linkPopupData.data.item.type === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].AssetItemFileTypes.PUBLICATION;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ResourcePanel__["a" /* default */], { iconName: 'iconset_uprez_file', label: linkPopupData.data.item ? linkPopupData.data.item.label : __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.no_target_selected'), isExternalLinkActive: false, importManagerId: 'linkPanel', isImporting: isImporting, isResetButtonDisplayed: false, isValidResourceFromApp: function (driveItem) { return openableDriveItemTypes.includes(driveItem.type); }, fileExtensions: fileExtensions, isFileExtensionsDisplayed: true, isOptimizedImageImport: false, fileType: undefined, onResourceSelect: onResourceSelect, dispatch: dispatch }),
            isPublication && renderPublicationPageInput()));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        // update state when value from props was changed (when switch between links)
        var type = getTypeFromLinkData(linkData);
        setType(type);
    }, [linkData]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* InputWrapper */], { hasButtonAdd: true, hasButtonRemove: true }, renderSettings(type === __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["h" /* LinkType */].popup)),
        !isUrlLinkOnly &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__LinkTypeToggle__["a" /* default */], { canAddPopupAction: canAddPopupAction, type: type, onChange: handleTypeChange })));
};
/* harmony default export */ __webpack_exports__["a"] = (LinkPanel);


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_RadioBox__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(609);





var getLabel = function (type) {
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].goToPage:
            return 'messages.goto_page';
        case __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].goToChapterId:
            return 'messages.goto_page_id';
        case __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].mailto:
            return 'messages.email';
        case __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].popup:
            return 'messages.popup_label';
        case __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].url:
        default:
            return 'messages.url';
    }
};
var LinkTypeToggle = function (_a) {
    var canAddPopupAction = _a.canAddPopupAction, type = _a.type, onChange = _a.onChange;
    var handleChange = function (e) {
        var value = e.target.value;
        onChange(value);
    };
    var linkTypes = [__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].url, __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].mailto, __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].goToPage, __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].goToChapterId];
    if (canAddPopupAction) {
        linkTypes.push(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["h" /* LinkType */].popup);
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* RadioButtons */], null, linkTypes.map(function (linkType) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Form_RadioBox__["b" /* default */], { key: linkType, name: "linkType", label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: getLabel(linkType) }), value: linkType, isChecked: type === linkType, onChange: handleChange, theme: __WEBPACK_IMPORTED_MODULE_3__Form_RadioBox__["a" /* RadioBoxTheme */].DARK })); })));
};
/* harmony default export */ __webpack_exports__["a"] = (LinkTypeToggle);


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('label')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: inline-flex;\n\tpadding-left: 25px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\n\t&:not(:last-of-type) {\n\t\tmargin-right: 15px;\n\t}\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n\n\tcolor: ", ";\n\n\t", "\n\n\t", "\n\n\tinput {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: relative;\n\tdisplay: inline-flex;\n\tpadding-left: 25px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\n\t&:not(:last-of-type) {\n\t\tmargin-right: 15px;\n\t}\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n\n\tcolor: ", ";\n\n\t", "\n\n\t",
    "\n\n\tinput {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black, function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Black : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey500;
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && "opacity: 0.5;";
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* RadioBoxTheme */].DARK && "\n\t\tcolor: " + (isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 50)) + ";\n\n\t\t&:hover {\n\t\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White + ";\n\t\t}\n\t";
});
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 20px;\n\theight: 20px;\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\tcolor: ", ";\n\n\t", "\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 20px;\n\theight: 20px;\n\tborder: 2px solid currentColor;\n\tborder-radius: 50%;\n\tcolor: ", ";\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue300 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Grey500;
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && "\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 4px;\n\t\t\tleft: 4px;\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: currentColor;\n\t\t}\n\t";
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return theme === __WEBPACK_IMPORTED_MODULE_1__index__["a" /* RadioBoxTheme */].DARK && "\n\t\tcolor: " + (isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 50)) + ";\n\t";
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonRemove__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_validation__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(36);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;








var isValidValue = function (value, totalSpreads) {
    var _a;
    return (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].url] = __WEBPACK_IMPORTED_MODULE_6__utils_validation__["a" /* default */].isValidUrl(value),
        _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].mailto] = value.includes('@'),
        _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToPage] = +value > 0 && +value <= totalSpreads,
        _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToChapterId] = value.trim().length > 0,
        _a);
};
var errorMessages = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].url] = 'error.invalid_url',
    _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].mailto] = 'error.invalid_email_address',
    _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToPage] = 'error.invalid_page_number',
    _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToChapterId] = 'error.invalid_chapter_id',
    _a);
var getPlaceholder = function (type) {
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToPage:
            return __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.page');
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToChapterId:
            return __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.page_id');
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].mailto:
            return __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.email');
        case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].url:
        default:
            return 'https://yourlink.com';
    }
};
var getInputValueFromLinkData = function (linkData) {
    return linkData ? linkData.data.href : '';
};
var LinkPanelInput = function (_a) {
    var linkData = _a.linkData, type = _a.type, _b = _a.spreads, spreads = _b === void 0 ? [] : _b, _c = _a.canAddLink, canAddLink = _c === void 0 ? true : _c, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var initialInputValue = getInputValueFromLinkData(linkData);
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialInputValue), 2), inputValue = _d[0], setInputValue = _d[1];
    var _e = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isError = _e[0], setIsError = _e[1];
    var handleInputChange = function (_a) {
        var value = _a.target.value;
        setInputValue(value);
        setIsError(!!value && !isValidValue(value, spreads.length)[type]);
    };
    var handleButtonAddClick = function () {
        onChange(getNewLinkData());
    };
    var getNewLinkData = function () {
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToPage:
                var spreadIndex = +inputValue - 1;
                var correctedValue = spreads[spreadIndex][0].toString();
                return {
                    type: type,
                    data: {
                        href: inputValue,
                        correctedHref: correctedValue,
                    }
                };
            case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToChapterId:
                var originalChapterParams = linkData && linkData.type === __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].goToChapterId
                    ? linkData.originalParams
                    : undefined;
                var updatedChapterParams = originalChapterParams
                    ? __assign({}, originalChapterParams, { params: __assign({}, originalChapterParams.params, { chapterId: inputValue }) }) : undefined;
                return {
                    type: type,
                    data: {
                        href: inputValue,
                    },
                    originalParams: updatedChapterParams,
                };
            case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].mailto:
            case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].url:
                return {
                    type: type,
                    data: {
                        href: inputValue,
                    },
                };
            case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].popup:
            case __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["h" /* LinkType */].unsupported:
            default:
                return null;
        }
    };
    var handleButtonRemoveClick = function () {
        setInputValue('');
        setIsError(false);
        if (linkData) {
            onChange(null);
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        // update state when value from props was changed (when switch between links)
        var inputValue = getInputValueFromLinkData(linkData);
        setInputValue(inputValue);
        setIsError(!!inputValue && !isValidValue(inputValue, spreads.length)[type]);
    }, [linkData, type]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        isError && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* InputError */], { value: errorMessages[type] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* IconLink */], null, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_uprez_link')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", value: inputValue, placeholder: getPlaceholder(type), disabled: !linkData && !canAddLink, onChange: handleInputChange, onFocus: onFocus, onBlur: onBlur, style: { marginLeft: '40px' } }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonAdd */], { type: "button", disabled: !inputValue || isError, onClick: handleButtonAddClick }, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* default */].getSvgIcon('iconset_check-1-bold')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ButtonRemove__["a" /* default */], { onClick: handleButtonRemoveClick, isDisabled: !inputValue })));
};
/* harmony default export */ __webpack_exports__["a"] = (LinkPanelInput);


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_MediaEditor_MediaItem__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, editorType = _a.type, isAccessibleVersion = _a.isAccessibleVersion, config = state.galleryInfos.config;
    var resourceId = __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */]().tempGId;
    var canDragAndResize = ownProps.canDragAndResize, editableMediaItem = ownProps.editableMediaItem;
    var type = editableMediaItem.type, defaultLink = editableMediaItem.defaultLink, driveLink = editableMediaItem.driveLink, externalLink = editableMediaItem.externalLink, isExternalLinkActive = editableMediaItem.isExternalLinkActive;
    var link = (isExternalLinkActive ? externalLink : driveLink) || defaultLink;
    var isDefaultMedia = isExternalLinkActive ? externalLink === defaultLink : !driveLink;
    var src = __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["z" /* getResourceUrl */](link, config, resourceId, editorType === __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* EditorType */].HTML);
    if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* EditableType */].video) {
        var isDefaultVideoInHtmlEditor = editorType === __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* EditorType */].HTML && isDefaultMedia;
        src = isExternalLinkActive
            ? __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["U" /* getYoutubeVideoCover */](src)
            : __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["S" /* getVideoCover */](src, isDefaultVideoInHtmlEditor);
    }
    if (type === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* EditableType */].animation) {
        src = __WEBPACK_IMPORTED_MODULE_2__utils_helpers__["d" /* getAnimationCover */](src);
    }
    return __assign({}, editableMediaItem, { canDragAndResize: canDragAndResize,
        editorType: editorType,
        src: src,
        isDefaultMedia: isDefaultMedia,
        isAccessibleVersion: isAccessibleVersion });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_MediaEditor_MediaItem__["a" /* default */]));


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_rnd__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var MediaRnd = /** @class */ (function (_super) {
    __extends(MediaRnd, _super);
    function MediaRnd(props) {
        var _this = _super.call(this, props) || this;
        _this.updateStore = function () {
            var _a = _this.props, frameWidth = _a.frameWidth, frameHeight = _a.frameHeight, width = _a.width, height = _a.height, x = _a.x, y = _a.y, page = _a.page, id = _a.id, isLoaded = _a.isLoaded, isCustom = _a.isCustom, isPercentageValues = _a.isPercentageValues, onClickOutside = _a.onClickOutside, dispatch = _a.dispatch;
            var _b = _this.state, currentWidth = _b.width, currentHeight = _b.height, currentX = _b.x, currentY = _b.y;
            var prevWidth = isPercentageValues ? MediaRnd.getSizeInPx(width, frameWidth) : width;
            var prevHeight = isPercentageValues ? MediaRnd.getSizeInPx(height, frameHeight) : height;
            var prevX = isPercentageValues ? MediaRnd.getSizeInPx(x, frameWidth) : x;
            var prevY = isPercentageValues ? MediaRnd.getSizeInPx(y, frameHeight) : y;
            var isSizeChanged = prevWidth !== currentWidth || prevHeight !== currentHeight;
            var isPositionChanged = prevX !== currentX || prevY !== currentY;
            if (isSizeChanged || isPositionChanged) {
                var positionAndSize = {
                    width: isPercentageValues ? MediaRnd.getSizeInPercent(currentWidth, frameWidth) : currentWidth,
                    height: isPercentageValues ? MediaRnd.getSizeInPercent(currentHeight, frameHeight) : currentHeight,
                    x: isPercentageValues ? MediaRnd.getSizeInPercent(currentX, frameWidth) : currentX,
                    y: isPercentageValues ? MediaRnd.getSizeInPercent(currentY, frameHeight) : currentY,
                };
                if (isCustom && onClickOutside) {
                    onClickOutside(positionAndSize);
                }
                else {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__["_2" /* updateEditableMedia */])(page, id, __assign({}, positionAndSize, { isLoaded: isLoaded })));
                }
            }
        };
        _this.handleDragStop = function (e, _a) {
            var x = _a.x, y = _a.y;
            var _b = _this.state, width = _b.width, height = _b.height, currentX = _b.x, currentY = _b.y;
            var isPositionChanged = Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(x) !== currentX || Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(y) !== currentY;
            if (isPositionChanged) {
                _this.setState({
                    width: width,
                    height: height,
                    x: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(x),
                    y: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(y),
                });
            }
        };
        _this.handleResizeStart = function () {
            var iframeContainer = _this.props.iframeContainer;
            document.body.classList.add('no-user-select');
            if (iframeContainer && iframeContainer.contentDocument) {
                iframeContainer.contentDocument.body.classList.add('no-user-select');
            }
        };
        _this.handleResize = function (e, direction, _a, delta, _b) {
            var offsetWidth = _a.offsetWidth, offsetHeight = _a.offsetHeight;
            var x = _b.x, y = _b.y;
            // prevent scroll during resize on touch devices
            e.preventDefault();
            _this.setState({
                width: offsetWidth,
                height: offsetHeight,
                x: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(x),
                y: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(y),
            });
        };
        _this.handleResizeStop = function () {
            var iframeContainer = _this.props.iframeContainer;
            document.body.classList.remove('no-user-select');
            if (iframeContainer && iframeContainer.contentDocument) {
                iframeContainer.contentDocument.body.classList.remove('no-user-select');
            }
        };
        _this.handleKeyDown = function (e) {
            if (_this.props.isKeyActionsDisabled) {
                return;
            }
            var _a = _this.state, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
            var currentX = x;
            var currentY = y;
            e.preventDefault();
            if (__WEBPACK_IMPORTED_MODULE_5__utils_keys__["a" /* default */].isArrowLeft(e.key)) {
                currentX -= 1;
            }
            if (__WEBPACK_IMPORTED_MODULE_5__utils_keys__["a" /* default */].isArrowRight(e.key)) {
                currentX += 1;
            }
            if (__WEBPACK_IMPORTED_MODULE_5__utils_keys__["a" /* default */].isArrowUp(e.key)) {
                currentY -= 1;
            }
            if (__WEBPACK_IMPORTED_MODULE_5__utils_keys__["a" /* default */].isArrowDown(e.key)) {
                currentY += 1;
            }
            _this.setState({
                width: width,
                height: height,
                x: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(currentX),
                y: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(currentY),
            });
        };
        var frameWidth = props.frameWidth, frameHeight = props.frameHeight, width = props.width, height = props.height, x = props.x, y = props.y, isLoaded = props.isLoaded, isPercentageValues = props.isPercentageValues;
        _this.state = {
            width: isPercentageValues ? MediaRnd.getSizeInPx(width, frameWidth) : width,
            height: isPercentageValues ? MediaRnd.getSizeInPx(height, frameHeight) : height,
            x: isPercentageValues ? MediaRnd.getSizeInPx(x, frameWidth) : x,
            y: isPercentageValues ? MediaRnd.getSizeInPx(y, frameHeight) : y,
            isLoaded: isLoaded,
        };
        return _this;
    }
    MediaRnd.getResizeControlStyles = function (scale) {
        var DEFAULT_SIZE = 5;
        var DEFAULT_POSITION = 3;
        var DEFAULT_BORDER_WIDTH = 1.5;
        var MIN_SCALE = 1;
        var correctedScale = Math.max(MIN_SCALE, Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(scale, DEFAULT_BORDER_WIDTH));
        var size = {
            width: DEFAULT_SIZE * correctedScale + "px",
            height: DEFAULT_SIZE * correctedScale + "px",
        };
        return {
            bottom: __assign({}, size, { bottom: "-" + DEFAULT_POSITION * correctedScale + "px", left: '50%', transform: 'translateX(-50%)' }),
            bottomLeft: __assign({}, size, { bottom: "-" + DEFAULT_POSITION * correctedScale + "px", left: "-" + DEFAULT_POSITION * correctedScale + "px" }),
            bottomRight: __assign({}, size, { bottom: "-" + DEFAULT_POSITION * correctedScale + "px", right: "-" + DEFAULT_POSITION * correctedScale + "px" }),
            left: __assign({}, size, { top: '50%', left: "-" + DEFAULT_POSITION * correctedScale + "px", transform: 'translateY(-50%)' }),
            right: __assign({}, size, { top: '50%', right: "-" + DEFAULT_POSITION * correctedScale + "px", transform: 'translateY(-50%)' }),
            top: __assign({}, size, { top: "-" + DEFAULT_POSITION * correctedScale + "px", left: '50%', transform: 'translateX(-50%)' }),
            topLeft: __assign({}, size, { top: "-" + DEFAULT_POSITION * correctedScale + "px", left: "-" + DEFAULT_POSITION * correctedScale + "px" }),
            topRight: __assign({}, size, { top: "-" + DEFAULT_POSITION * correctedScale + "px", right: "-" + DEFAULT_POSITION * correctedScale + "px" }),
        };
    };
    MediaRnd.getSizeInPx = function (sizeInPercent, frameSizeInPx) {
        return (sizeInPercent / 100) * frameSizeInPx;
    };
    MediaRnd.getSizeInPercent = function (sizeInPx, frameSizeInPx) {
        return (sizeInPx / frameSizeInPx) * 100;
    };
    MediaRnd.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.handleKeyDown);
        var iframeContainer = this.props.iframeContainer;
        if (iframeContainer) {
            iframeContainer.contentDocument.addEventListener('keydown', this.handleKeyDown);
        }
    };
    MediaRnd.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, isLoaded = _a.isLoaded, isActive = _a.isActive, isPercentageValues = _a.isPercentageValues, frameWidth = _a.frameWidth, frameHeight = _a.frameHeight, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
        // as a result of undo/redo actions
        var isSizeOrPositionChanged = width !== prevProps.width ||
            height !== prevProps.height ||
            x !== prevProps.x ||
            y !== prevProps.y;
        var isNewMediaLoaded = isLoaded !== prevProps.isLoaded;
        if (isSizeOrPositionChanged || isNewMediaLoaded) {
            this.setState({
                width: isPercentageValues ? MediaRnd.getSizeInPx(width, frameWidth) : width,
                height: isPercentageValues ? MediaRnd.getSizeInPx(height, frameHeight) : height,
                x: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(isPercentageValues ? MediaRnd.getSizeInPx(x, frameWidth) : x),
                y: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["A" /* getRoundedValue */])(isPercentageValues ? MediaRnd.getSizeInPx(y, frameHeight) : y),
                isLoaded: isLoaded,
            });
        }
        // update store when item becomes inactive
        if (!isActive && isActive !== prevProps.isActive) {
            this.updateStore();
        }
    };
    MediaRnd.prototype.componentWillUnmount = function () {
        this.updateStore();
        window.removeEventListener('keydown', this.handleKeyDown);
        var iframeContainer = this.props.iframeContainer;
        if (iframeContainer) {
            iframeContainer.contentDocument.removeEventListener('keydown', this.handleKeyDown);
        }
    };
    MediaRnd.prototype.render = function () {
        var _a = this.props, scale = _a.scale, isActive = _a.isActive, isLoaded = _a.isLoaded, children = _a.children;
        var size = { width: this.state.width, height: this.state.height };
        var position = { x: this.state.x, y: this.state.y };
        var resizeHandleWrapperClass = this.state.isLoaded ? 'editor-media-controls' : '';
        var resizeHandleStyles = this.state.isLoaded ? MediaRnd.getResizeControlStyles(scale) : undefined;
        var mediaRndClasses = __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getCssClasses('uprez-media-rnd', {
            'is-active': isActive && isLoaded,
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledMediaRnd */], { className: mediaRndClasses, isActive: isActive && isLoaded, outlineWidth: Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(scale) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_rnd__["a" /* Rnd */], { resizeHandleWrapperClass: resizeHandleWrapperClass, resizeHandleStyles: resizeHandleStyles, scale: scale, size: size, position: position, lockAspectRatio: true, onDragStop: this.handleDragStop, onResizeStart: this.handleResizeStart, onResize: this.handleResize, onResizeStop: this.handleResizeStop }, children)));
    };
    return MediaRnd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MediaRnd);


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledMediaRnd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledMediaRnd = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpointer-events: auto;\n\n\t", "\n"], ["\n\tpointer-events: auto;\n\n\t",
    "\n"])), function (props) { return props.isActive && "\n\t\tz-index: -1;\n\n\t\timg {\n\t\t\toutline: " + props.outlineWidth + "px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t\t}\n\n\t\t.editor-media-controls div {\n\t\t\t&::before,\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t}\n\n\t\t\t&::before {\n\t\t\t\twidth: 400%;\n\t\t\t\theight: 400%;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\toutline: 1px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t\t\t}\n\t\t}\n\t"; });

var templateObject_1;


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);




var VisibilityToggle = function (_a) {
    var isVisible = _a.isVisible, isParentActive = _a.isParentActive, pageScale = _a.pageScale, spreadZoom = _a.spreadZoom, onToggle = _a.onToggle, isAccessibleVersion = _a.isAccessibleVersion;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* PageElementActionButton */], { className: __WEBPACK_IMPORTED_MODULE_2__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */], isActive: isParentActive, pageScale: pageScale, spreadZoom: spreadZoom, onClick: onToggle, isAccessibleVersion: isAccessibleVersion, isVisible: isVisible }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon(isVisible ? 'iconset_uprez_eye' : 'iconset_uprez_eye_crossed')));
};
/* harmony default export */ __webpack_exports__["a"] = (VisibilityToggle);


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Frame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FrameBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FrameLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FrameLoaderInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FrameMask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Frame = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\twidth: ", ";\n\theight: ", ";\n\toverflow: ", ";\n\tpointer-events: ", ";\n\tborder-radius: inherit;\n\n\t[class*=\"is-rounded\"] & {\n\t\tborder-radius: 50%;\n\t}\n\n\timg, svg {\n\t\tposition: ", ";\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmax-width: ", ";\n\t\tmax-height: ", ";\n\t\twidth: ", ";\n\t\theight: auto;\n\t\tmargin: auto;\n\t\tpointer-events: auto;\n\t}\n\n\timg {\n\t\t", "\n\t}\n\n\tsvg {\n\t\twidth: 50%;\n\t\theight: 50%;\n\t\tfill: ", ";\n\t}\n"], ["\n\tposition: relative;\n\twidth: ", ";\n\theight: ", ";\n\toverflow: ", ";\n\tpointer-events: ", ";\n\tborder-radius: inherit;\n\n\t[class*=\"is-rounded\"] & {\n\t\tborder-radius: 50%;\n\t}\n\n\timg, svg {\n\t\tposition: ", ";\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmax-width: ", ";\n\t\tmax-height: ", ";\n\t\twidth: ", ";\n\t\theight: auto;\n\t\tmargin: auto;\n\t\tpointer-events: auto;\n\t}\n\n\timg {\n\t\t",
    "\n\t}\n\n\tsvg {\n\t\twidth: 50%;\n\t\theight: 50%;\n\t\tfill: ", ";\n\t}\n"])), function (_a) {
    var width = _a.width;
    return width + "px";
}, function (_a) {
    var height = _a.height;
    return height + "px";
}, function (_a) {
    var isActive = _a.isActive;
    return isActive ? 'visible' : 'hidden';
}, function (_a) {
    var isActive = _a.isActive, canDragAndResize = _a.canDragAndResize;
    return isActive && canDragAndResize ? 'none' : 'auto';
}, function (_a) {
    var isAccessibleVersion = _a.isAccessibleVersion;
    return isAccessibleVersion ? 'relative' : 'absolute';
}, function (_a) {
    var isAccessibleVersion = _a.isAccessibleVersion;
    return isAccessibleVersion ? undefined : '100%';
}, function (_a) {
    var isAccessibleVersion = _a.isAccessibleVersion;
    return isAccessibleVersion ? undefined : '100%';
}, function (_a) {
    var mediaType = _a.mediaType;
    return mediaType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["c" /* EditableType */].video ? 'auto' : '100%';
}, function (_a) {
    var mediaType = _a.mediaType;
    return mediaType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["c" /* EditableType */].animation && "\n\t\t\tmax-height: none;\n\t\t\tmargin: 0;\n\t\t";
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey400);
var FrameBorder = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n\n\t", "\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var isActive = _a.isActive;
    return isActive ? "" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : "" + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey400;
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && 'z-index: 1;';
});
var FrameLoader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: ", ";\n\tleft: ", ";\n\tright: ", ";\n\tz-index: 1;\n"], ["\n\tposition: absolute;\n\ttop: ", ";\n\tbottom: ", ";\n\tleft: ", ";\n\tright: ", ";\n\tz-index: 1;\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
});
var FrameLoaderInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: ", ";\n\tpadding: 5px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n\n\tspan {\n\t\tdisplay: block;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: ", ";\n\tpadding: 5px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n\n\tspan {\n\t\tdisplay: block;\n\t}\n"])), function (_a) {
    var scale = _a.scale;
    return "translate(-50%, -50%) scale(" + 1 / scale + ")";
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey800);
var FrameMask = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground-color: ", ";\n\topacity: 0.9;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground-color: ", ";\n\topacity: 0.9;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_MediaEditor_MediaItem__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(95);



var mapStateToProps = function (state) {
    var _a = state.profile.userAvatar, _b = _a.config, x = _b.x, y = _b.y, width = _b.width, height = _b.height, isLoaded = _a.isLoaded;
    return {
        src: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* getAvatarUrl */])(state),
        width: width,
        height: height,
        x: x,
        y: y,
        isLoaded: isLoaded,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_MediaEditor_MediaItem__["a" /* default */]));


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_CRMSelector__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var _a = state.profile, crmProviders = _a.crmProviders, role = _a.role;
    return __assign({}, ownProps, { crmProviders: crmProviders, isUserEditor: role === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].CustomerContextRoles.ROLE_APPLICATION_USER });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_CRMSelector__["a" /* default */]));


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ProfilePage_CRMSelector_SalesforcePopup__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_userAgent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__ = __webpack_require__(39);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};










var getOptions = function (crmProviders) { return (__spread([
    {
        value: __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].CRMProviders.NONE,
        label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.none" }),
    }
], crmProviders.map(function (_a) {
    var provider = _a.provider;
    return ({
        value: provider,
        label: provider.toLowerCase(),
    });
}))); };
var openIntegrationUrl = function (crmProvider, crmProviders) {
    var DELAY_TO_OPEN_URL = 500;
    var enabledCrmProvider = crmProviders.find(function (_a) {
        var provider = _a.provider;
        return provider === crmProvider;
    });
    if (enabledCrmProvider) {
        var integrationUrl_1 = enabledCrmProvider.integrationUrl;
        if (__WEBPACK_IMPORTED_MODULE_8__utils_userAgent__["a" /* default */].isMobileApp) {
            setTimeout(function () { return __WEBPACK_IMPORTED_MODULE_9__utils_nativeApi__["b" /* default */].openFrame(integrationUrl_1); }, DELAY_TO_OPEN_URL);
        }
        else {
            setTimeout(function () { return window.open(integrationUrl_1); }, DELAY_TO_OPEN_URL);
        }
    }
};
var CRMSelector = function (_a) {
    var crmProviders = _a.crmProviders, isUserEditor = _a.isUserEditor, onChange = _a.onChange, dispatch = _a.dispatch;
    var enabledCrmProvider = crmProviders.find(function (_a) {
        var enabled = _a.enabled;
        return enabled;
    });
    var initialValue = enabledCrmProvider
        ? enabledCrmProvider.provider
        : __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].CRMProviders.NONE;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialValue), 2), currentValue = _b[0], setCurrentValue = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isSalesforcePopupDisplayed = _c[0], setIsSalesforcePopupDisplayed = _c[1];
    var handleChange = function (e) {
        var value = e.target.value;
        setCurrentValue(value);
        onChange(value);
        var shouldOpenSalesforcePopup = value === __WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].CRMProviders.SALESFORCE && !isUserEditor;
        if (shouldOpenSalesforcePopup) {
            setIsSalesforcePopupDisplayed(true);
        }
        else {
            openIntegrationUrl(value, crmProviders);
        }
    };
    var handleSalesforcePopupClose = function () {
        setIsSalesforcePopupDisplayed(false);
    };
    var handleSalesforcePopupConfirm = function (clientId, clientSecret) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ProfilePage_actions__["b" /* activateSalesforce */])(clientId, clientSecret, function () {
            setIsSalesforcePopupDisplayed(false);
            openIntegrationUrl(__WEBPACK_IMPORTED_MODULE_6__typings_api__["a" /* Api */].CRMProviders.SALESFORCE, crmProviders);
        }));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (currentValue !== initialValue) {
            setCurrentValue(initialValue);
        }
    }, [crmProviders]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Accordion__["a" /* default */], { title: "messages.crm", isOpened: true },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Wrapper */], null, getOptions(crmProviders).map(function (_a) {
            var value = _a.value, label = _a.label;
            var isChecked = currentValue === value;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* Row */], { key: value },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Cell */], { isFirst: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Label */], null, label)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Cell */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Icon */], { isChecked: isChecked },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "radio", name: "CRM", value: value, checked: isChecked, onChange: handleChange }),
                            isChecked && __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_check-3-bold'))))));
        })),
        !isUserEditor &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ProfilePage_CRMSelector_SalesforcePopup__["a" /* default */], { isDisplayed: isSalesforcePopupDisplayed, onConfirm: handleSalesforcePopupConfirm, onCancel: handleSalesforcePopupClose })));
};
/* harmony default export */ __webpack_exports__["a"] = (CRMSelector);


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: table;\n\twidth: 100%;\n\tmargin-bottom: -4px;\n"], ["\n\tdisplay: table;\n\twidth: 100%;\n\tmargin-bottom: -4px;\n"])));
var Row = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: table-row;\n"], ["\n\tdisplay: table-row;\n"])));
var Cell = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: table-cell;\n\theight: 60px;\n\tpadding: 10px 15px;\n\tborder-bottom: 1px solid ", ";\n\tvertical-align: middle;\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: table-cell;\n\theight: 60px;\n\tpadding: 10px 15px;\n\tborder-bottom: 1px solid ", ";\n\tvertical-align: middle;\n\n\t",
    "\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 11.9); }, function (props) { return props.isFirst && "\n\t\twidth: 1px;\n\t\twhite-space: nowrap;\n\t"; });
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding-right: 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-transform: capitalize;\n"], ["\n\tpadding-right: 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\ttext-transform: capitalize;\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 59.5); });
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 50%;\n\n\t", "\n\n\tinput {\n\t\tdisplay: none;\n\t}\n\n\tlabel {\n\t\tdisplay: block;\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tcursor: pointer;\n\t}\n\n\tsvg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tbox-sizing: border-box;\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 50%;\n\n\t", "\n\n\tinput {\n\t\tdisplay: none;\n\t}\n\n\tlabel {\n\t\tdisplay: block;\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tcursor: pointer;\n\t}\n\n\tsvg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfill: ", ";\n\t}\n"])), function (_a) {
    var isChecked = _a.isChecked, theme = _a.theme;
    return !isChecked && "border: 2px solid " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(theme.primary.strongColor, 11.9) + ";";
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_CRMSelector_SalesforcePopup__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var _a = state.profile, crmProviders = _a.crmProviders, isLoading = _a.isLoading;
    var salesforceProvider = crmProviders
        ? crmProviders.find(function (_a) {
            var provider = _a.provider;
            return provider === __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].CRMProviders.SALESFORCE;
        })
        : undefined;
    return __assign({}, ownProps, { clientId: salesforceProvider ? salesforceProvider.clientId : undefined, clientSecret: salesforceProvider ? salesforceProvider.clientSecret : undefined, isLoading: isLoading });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_CRMSelector_SalesforcePopup__["a" /* default */]));


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spinner_styles__ = __webpack_require__(344);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var SalesforcePopup = function (_a) {
    var isDisplayed = _a.isDisplayed, onCancel = _a.onCancel, onConfirm = _a.onConfirm, isLoading = _a.isLoading, initialClientId = _a.clientId, initialClientSecret = _a.clientSecret;
    var initialState = {
        clientId: initialClientId || '',
        clientSecret: initialClientSecret || '',
    };
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialState), 2), state = _b[0], setState = _b[1];
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setState(function (state) {
            var _a;
            return (__assign({}, state, (_a = {}, _a[name] = value, _a)));
        });
    };
    var isError = function () { return !(state.clientId && state.clientSecret); };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var clientId = state.clientId, clientSecret = state.clientSecret;
        if (initialClientId !== clientId || initialClientSecret !== clientSecret) {
            setState(function (state) { return (__assign({}, state, { clientId: initialClientId || '', clientSecret: initialClientSecret || '' })); });
        }
    }, [initialClientId, initialClientSecret, isDisplayed]);
    var clientId = state.clientId, clientSecret = state.clientSecret;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.salesforce_activation'), onCancel: onCancel, onConfirm: function () { return onConfirm(clientId, clientSecret); }, isConfirmDisabled: isError() || isLoading },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* PopupBody */], null,
            isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["j" /* PopupLoader */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Spinner_styles__["a" /* Spinner */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* InputLabel */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.client_id" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Input */], { type: "text", name: "clientId", value: clientId, isError: !clientId, onChange: handleInputChange })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* InputLabel */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.client_secret" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Input */], { type: "text", name: "clientSecret", value: clientSecret, isError: !clientSecret, onChange: handleInputChange })))));
};
/* harmony default export */ __webpack_exports__["a"] = (SalesforcePopup);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_EmailIntegration__ = __webpack_require__(1507);


var mapStateToProps = function (state) {
    var clientId = state.galleryInfos.config.clientId, _a = state.profile, email = _a.email, emailProvider = _a.emailProvider;
    return {
        clientId: clientId,
        userEmail: email,
        emailProvider: emailProvider,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProfilePage_EmailIntegration__["a" /* default */]));


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmailIntegrationPopup__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_actions__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_api__ = __webpack_require__(17);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var EmailIntegration = function (_a) {
    var clientId = _a.clientId, userEmail = _a.userEmail, _b = _a.emailProvider, integrationUrl = _b.integrationUrl, email = _b.email, enabled = _b.enabled, dispatch = _a.dispatch;
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isIntegrationPopupDisplayed = _c[0], setIsIntegrationPopupDisplayed = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isRemovePopupDisplayed = _d[0], setIsRemovePopupDisplayed = _d[1];
    var openIntegrationUrl = function (email) {
        var url = "" + integrationUrl + encodeURIComponent(email) + "&wpToken=" + __WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* default */].token;
        window.open(url, '_blank');
    };
    var handleIntegrationPopupConfirm = function (email) {
        setIsIntegrationPopupDisplayed(false);
        openIntegrationUrl(email);
    };
    var handleRemovePopupConfirm = function () {
        setIsRemovePopupDisplayed(false);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_actions__["h" /* saveProfileData */])({
            emailProvider: { enabled: false },
        }));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var handleVisibilityChange = function () {
            if (!document.hidden) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_ProfilePage_actions__["e" /* getProfileData */])(clientId, false));
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Accordion__["a" /* default */], { title: "messages.email_integration", isOpened: true },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* Wrapper */], null,
            enabled &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* StatusLabel */], null,
                    __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_check-3-bold'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.enabled" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* InnerWrapper */], null,
                enabled &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* EmailWrapper */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Email */], null, email),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonRemove */], { type: "button", onClick: function () { return setIsRemovePopupDisplayed(true); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_close-2'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ButtonIntegrate */], { type: "button", onClick: function () { return setIsIntegrationPopupDisplayed(true); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.integrate" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmailIntegrationPopup__["a" /* default */], { isDisplayed: isIntegrationPopupDisplayed, onCancel: function () { return setIsIntegrationPopupDisplayed(false); }, onConfirm: handleIntegrationPopupConfirm, email: email || userEmail }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["b" /* default */], { isDisplayed: isRemovePopupDisplayed, onCancel: function () { return setIsRemovePopupDisplayed(false); }, onConfirm: handleRemovePopupConfirm, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.confirmation') },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* PopupBody */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.remove_email_integration" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (EmailIntegration);


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InnerWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StatusLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EmailWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonIntegrate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 15px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tpadding: 15px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 59.5); });
var InnerWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n"])));
var StatusLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\n\tsvg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-right: 10px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\n\tsvg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-right: 10px;\n\t\tfill: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].VibrantGreen);
var EmailWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\tmargin-right: 20px;\n\toverflow: hidden;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\tmargin-right: 20px;\n\toverflow: hidden;\n"])));
var Email = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"], ["\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])));
var ButtonRemove = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 26px;\n\twidth: 26px;\n\theight: 26px;\n\tmargin-left: 10px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 26px;\n\twidth: 26px;\n\theight: 26px;\n\tmargin-left: 10px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tfill: ", ";\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.strongColor, 11.9); }, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey450);
var ButtonIntegrate = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tmin-width: 145px;\n\theight: 50px;\n\tmargin-bottom: 10px;\n\tpadding: 0 10px;\n\tborder: 0;\n\tborder-radius: 9px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 18px;\n\tline-height: 50px;\n\tcursor: pointer;\n\ttransition: background-color 0.2s;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tmin-width: 145px;\n\theight: 50px;\n\tmargin-bottom: 10px;\n\tpadding: 0 10px;\n\tborder: 0;\n\tborder-radius: 9px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 700;\n\tfont-size: 18px;\n\tline-height: 50px;\n\tcursor: pointer;\n\ttransition: background-color 0.2s;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"])), function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.actionColor, 10); }, function (props) { return props.theme.primary.actionColor; }, function (props) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(props.theme.primary.actionColor, 25); });

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_validation__ = __webpack_require__(139);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var EmailIntegrationPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, onCancel = _a.onCancel, onConfirm = _a.onConfirm, initialEmail = _a.email;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialEmail), 2), email = _b[0], setEmail = _b[1];
    var handleInputChange = function (e) {
        setEmail(e.target.value);
    };
    var isError = function () { return !__WEBPACK_IMPORTED_MODULE_4__utils_validation__["a" /* default */].isValidEmail(email); };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (initialEmail !== email) {
            setEmail(initialEmail);
        }
    }, [initialEmail, isDisplayed]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.email_integration'), onCancel: onCancel, onConfirm: function () { return onConfirm(email); }, isConfirmDisabled: isError() },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["i" /* PopupBody */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* InputLabel */], null,
                isError()
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Error */], { value: "error.invalid_email_address" })
                    : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.email" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Input */], { type: "email", name: "email", ref: function (ref) {
                        if (ref) {
                            ref.setAttribute('autocorrect', 'none');
                            ref.setAttribute('autocapitalize', 'off');
                            ref.setAttribute('spellcheck', 'false');
                        }
                    }, value: email, isError: isError(), onChange: handleInputChange })))));
};
/* harmony default export */ __webpack_exports__["a"] = (EmailIntegrationPopup);


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Theater__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes__ = __webpack_require__(13);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TheaterPage = /** @class */ (function (_super) {
    __extends(TheaterPage, _super);
    function TheaterPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TheaterPage.prototype.render = function () {
        var routerParamsHistory = this.props.routerParamsHistory;
        var driveItemId = routerParamsHistory[routerParamsHistory.length - 1].params.driveItemId;
        var itemId = parseInt(driveItemId, 10);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Theater__["a" /* default */], { origin: __WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, sliderKey: '', driveItemId: itemId, driveItemIds: [itemId], isLoading: false, leavePage: this.leavePage }));
    };
    TheaterPage.prototype.leavePage = function () {
        window.location.hash = "" + __WEBPACK_IMPORTED_MODULE_4__utils_routes__["a" /* default */].getPathDriveItemListPage(__WEBPACK_IMPORTED_MODULE_3__DriveItemListPage_constants__["a" /* DriveItemListOrigin */].Folder, null);
    };
    return TheaterPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    var routerParamsHistory = state.routerParamsHistory;
    return { routerParamsHistory: routerParamsHistory };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TheaterPage));


/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SharePage__ = __webpack_require__(1512);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])()(__WEBPACK_IMPORTED_MODULE_1__components_SharePage__["a" /* default */]));


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Share_actions__ = __webpack_require__(43);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;





var SharePage = function (_a) {
    var _b = _a.params, driveItemId = _b.driveItemId, page = _b.page, dispatch = _a.dispatch;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var onLoad = function () { return __awaiter(_this, void 0, void 0, function () {
            var driveItem, callbackAction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!driveItemId) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["m" /* getOrFetchDriveItemMeta */])(+driveItemId))];
                    case 1:
                        driveItem = _a.sent();
                        callbackAction = {
                            type: __WEBPACK_IMPORTED_MODULE_1__containers_DriveItemList_actions__["a" /* ActionType */].VIEW_DRIVE_ITEM,
                            assetId: +driveItemId,
                            page: page ? +page : undefined,
                        };
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Share_actions__["k" /* share */])([driveItem], undefined, undefined, callbackAction));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        onLoad();
    }, [driveItemId]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_3__containers_Page_constants__["a" /* PageType */].ParametersPage, title: "messages.share" }));
};
/* harmony default export */ __webpack_exports__["a"] = (SharePage);


/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var mapStateToProps = function (state) {
    var _a = state.editor, type = _a.type, previewPages = _a.previewPages, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, isEditorLoaded = _a.isEditorLoaded, isCombining = _a.combo.isCombining, pdfImportingStatus = _a.settings.pdfImportingStatus, isUpdating = _a.preprodPublication.isUpdating;
    var _c = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _c.clientId, tempGId = _c.tempGId, originalGId = _c.originalGId;
    var spread = spreads[currentSpreadIndex];
    var isPreviewPagesSpread = spread ? spread.some(function (page) { return previewPages.includes(page); }) : false;
    var isAccessibleVersion = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].isAccessibleVersionMode();
    return {
        type: type,
        clientId: clientId,
        originalGId: originalGId,
        tempGId: tempGId,
        isEditorLoaded: isEditorLoaded,
        isPreviewPagesSpread: isPreviewPagesSpread,
        isProcessing: isCombining ||
            pdfImportingStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* PdfImportingStatus */].PROCESSING ||
            isUpdating,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor__["a" /* default */]));


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_ResourcesLoader__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_Header__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_Thumbnails_Column__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_Spread__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_PreviewPagesSpread__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_ProcessingLoader__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_LockedEditorPopup__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinner__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_api__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_ResourceSelector_DrivePicker_FromApp__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_Editor_actions_ui__ = __webpack_require__(35);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;




















var Editor = function (_a) {
    var type = _a.type, clientId = _a.clientId, originalGId = _a.originalGId, tempGId = _a.tempGId, isEditorLoaded = _a.isEditorLoaded, isPreviewPagesSpread = _a.isPreviewPagesSpread, isProcessing = _a.isProcessing, dispatch = _a.dispatch, isAccessibleVersion = _a.isAccessibleVersion;
    var container = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var tempGIdRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](tempGId);
    // need for resource refresh if it was previously downloaded
    var updateResourceMeta = function () { return __awaiter(_this, void 0, void 0, function () {
        var resource;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_14__utils_api__["a" /* default */].getMeta(originalGId)];
                case 1:
                    resource = _a.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__containers_DriveItemList_actions__["H" /* updateDriveItem */])(resource));
                    return [2 /*return*/];
            }
        });
    }); };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__containers_Editor_actions_ui__["k" /* setIsAccessibleVersion */])(isAccessibleVersion));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_Editor_actions__["i" /* getData */])(clientId, originalGId));
        return function () {
            try {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_Editor_actions__["z" /* reset */])());
                __WEBPACK_IMPORTED_MODULE_14__utils_api__["a" /* default */].releaseLock(clientId, tempGIdRef.current);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_Editor_actions__["_8" /* updateThumbnailsIfNeeded */])(clientId, tempGIdRef.current));
                updateResourceMeta();
                // tslint:disable-next-line
            }
            catch (error) { }
        };
    }, [clientId, originalGId, isAccessibleVersion]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        // ref is used to prevent a call of useEffect above
        tempGIdRef.current = tempGId;
    }, [tempGId]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_16__utils__["d" /* default */].isEmptyPlaylistMode()
        ?
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__containers_ResourceSelector_DrivePicker_FromApp__["a" /* default */], { isValidResource: __WEBPACK_IMPORTED_MODULE_17__utils_driveItem__["d" /* default */].isValidResourceForPlaylist, onSelect: function () { return null; }, onClose: function () { return null; }, actionButtonColor: __WEBPACK_IMPORTED_MODULE_18__utils_styles_constants__["b" /* NewStyleColor */].Blue450, isMultipleSelection: false })
        :
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_ResourcesLoader__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["c" /* EditorContainer */], { ref: container },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_Header__["a" /* default */], { isEditorLoaded: isEditorLoaded }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["d" /* EditorWrapper */], null, isEditorLoaded
                        ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                            isProcessing && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_Editor_ProcessingLoader__["a" /* default */], null),
                            type === __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["e" /* EditorType */].INDESIGN && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_Thumbnails_Column__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["b" /* ContentWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ContentInner */], null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["i" /* SpreadWrapper */], null,
                                        isPreviewPagesSpread && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_Editor_PreviewPagesSpread__["a" /* default */], null),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_Spread__["a" /* default */], { isHidden: isPreviewPagesSpread, editorContainer: container.current }))))))
                        : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["f" /* Loader */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinner__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" }))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Editor_LockedEditorPopup__["a" /* default */], null))));
};
/* harmony default export */ __webpack_exports__["a"] = (Editor);


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ResourcesLoader__ = __webpack_require__(1516);


var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, prevSpreadIndex = _b.prevSpreadIndex, pages = _a.pages, _c = _a.resources, css = _c.css, themesCss = _c.themesCss, scripts = _c.scripts, externalResources = _a.externalResources, isAccessibleVersion = _a.isAccessibleVersion;
    var currentSpreadFirstPage = !isAccessibleVersion ? spreads[currentSpreadIndex][0] : currentSpreadIndex + 1;
    var prevSpreadFirstPage = !isAccessibleVersion ? spreads[prevSpreadIndex][0] : prevSpreadIndex + 1;
    var page = pages[currentSpreadFirstPage] ? currentSpreadFirstPage : prevSpreadFirstPage;
    var externalId = pages[page].externalId;
    return {
        css: externalId ? externalResources[externalId].css : css,
        themesCss: externalId ? externalResources[externalId].themesCss : themesCss,
        scripts: externalId ? externalResources[externalId].scripts : scripts,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ResourcesLoader__["a" /* default */]));


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ResourceType;
(function (ResourceType) {
    ResourceType["STYLE"] = "style";
    ResourceType["SCRIPT"] = "script";
})(ResourceType || (ResourceType = {}));
var STYLE_ID = 'editor-styles';
var THEMES_STYLE_ID = 'editor-themes-styles';
var SCRIPTS_ID = 'editor-scripts';
var addResource = function (type, id, resource) {
    var element = document.createElement(type);
    element.id = id;
    element.innerHTML = resource;
    document.head.appendChild(element);
};
var removeResource = function (id) {
    var element = document.querySelector("#" + id);
    if (element) {
        element.parentNode.removeChild(element);
    }
};
var addStyles = function (css) { return addResource(ResourceType.STYLE, STYLE_ID, css); };
var removeStyles = function () { return removeResource(STYLE_ID); };
var addThemesStyles = function (themesCss) { return addResource(ResourceType.STYLE, THEMES_STYLE_ID, themesCss); };
var removeThemesStyles = function () { return removeResource(THEMES_STYLE_ID); };
var addScripts = function (scripts) { return addResource(ResourceType.SCRIPT, SCRIPTS_ID, scripts); };
var removeScripts = function () { return removeResource(SCRIPTS_ID); };
var ResourcesLoader = function (_a) {
    var css = _a.css, themesCss = _a.themesCss, scripts = _a.scripts;
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        addStyles(css);
        if (scripts) {
            addScripts(scripts);
        }
        return function () {
            removeStyles();
            removeScripts();
        };
    }, [css, scripts]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (themesCss) {
            addThemesStyles(themesCss);
        }
        return function () {
            removeThemesStyles();
        };
    }, [themesCss]);
    return null;
};
/* harmony default export */ __webpack_exports__["a"] = (ResourcesLoader);


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Header__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfilePage_selectors__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typings_api__ = __webpack_require__(10);









var mapStateToProps = function (state) {
    var driveItems = state.driveList.driveItems, publicationSettings = state.galleryInfos.template.publicationSettings, _a = state.editor, isCombining = _a.combo.isCombining, pdfImportingStatus = _a.settings.pdfImportingStatus, isUpdating = _a.preprodPublication.isUpdating, themes = _a.themes, isAccessibleVersion = _a.isAccessibleVersion;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["g" /* getClientAndResourceIds */])(), originalGId = _b.originalGId, tempGId = _b.tempGId;
    var resource = driveItems[originalGId];
    var format = resource ? resource.format : undefined;
    var isEpubPreview = originalGId === tempGId && format === __WEBPACK_IMPORTED_MODULE_8__typings_api__["a" /* Api */].PublicationFormat.EPUB_PREVIEW;
    return {
        isButtonEditDisplayed: Object(__WEBPACK_IMPORTED_MODULE_3__selectors__["y" /* isEditableSpread */])(state),
        isButtonSettingsDisplayed: Object(__WEBPACK_IMPORTED_MODULE_4__ProfilePage_selectors__["b" /* getIsAccountManagerOrAdmin */])(state) && (__WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].isModifiablePublication(format) && !!publicationSettings ||
            !!themes),
        isButtonPublishDisplayed: !isEpubPreview &&
            (__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].isEmbedMode()
                ? !__WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].isProposal(format) || __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].isMasterProposal(format)
                : true),
        shouldDisableButtons: isCombining ||
            pdfImportingStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* PdfImportingStatus */].PROCESSING ||
            isUpdating,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Header__["a" /* default */]));


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_Title__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_ButtonBack__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_ButtonPreview__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_ButtonPublish__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_ButtonEdit__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonZoom__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_ButtonSettings__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_ButtonsUndoRedo__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1);












var Header = function (_a) {
    var isEditorLoaded = _a.isEditorLoaded, isButtonEditDisplayed = _a.isButtonEditDisplayed, isButtonSettingsDisplayed = _a.isButtonSettingsDisplayed, isButtonPublishDisplayed = _a.isButtonPublishDisplayed, shouldDisableButtons = _a.shouldDisableButtons, dispatch = _a.dispatch, isAccessibleVersion = _a.isAccessibleVersion;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["c" /* Wrapper */], null,
        !__WEBPACK_IMPORTED_MODULE_11__utils__["d" /* default */].isEmbedMode() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_ButtonBack__["a" /* default */], null),
        isEditorLoaded &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_Editor_Title__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonZoom__["a" /* default */], { isDisabled: shouldDisableButtons, onClick: function (zoom) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__containers_Editor_actions__["_10" /* zoomPage */])(zoom)); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Editor_ButtonsUndoRedo__["a" /* default */], { isBothDisabled: shouldDisableButtons }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ButtonsGroup */], null,
                    isButtonEditDisplayed && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_ButtonEdit__["a" /* default */], null),
                    isButtonSettingsDisplayed && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_Editor_ButtonSettings__["a" /* default */], { isDisabled: shouldDisableButtons })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ButtonsGroup */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_ButtonPreview__["a" /* default */], { isDisabled: shouldDisableButtons }),
                    isButtonPublishDisplayed && !isAccessibleVersion && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_ButtonPublish__["a" /* default */], { isDisabled: shouldDisableButtons })))));
};
/* harmony default export */ __webpack_exports__["a"] = (Header);


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Title__ = __webpack_require__(1520);


var mapStateToProps = function (state) {
    var _a = state.editor.label, label = _a.label, isError = _a.isError;
    return {
        label: label,
        isError: isError,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Title__["a" /* default */]));


/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var Title = function (_a) {
    var label = _a.label, isError = _a.isError, dispatch = _a.dispatch;
    var inputElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](label), 2), value = _b[0], setValue = _b[1];
    var handleBlur = function () {
        if (!value) {
            return;
        }
        if (value !== label) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["J" /* sendRenameRequest */])(value));
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["L" /* setIsRenaming */])(false));
        }
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        inputElement.current.blur();
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setValue(label);
    }, [label]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isError) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["P" /* setRenameError */])(false));
        }
    }, [value]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { onSubmit: handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Input */], { type: "text", ref: inputElement, value: value, isError: isError, onChange: function (e) { return setValue(e.target.value); }, onFocus: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["L" /* setIsRenaming */])(true)); }, onBlur: handleBlur, disabled: __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isEmbedMode() }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "submit", hidden: true }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Title);


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 0 1 460px;\n\tmargin-left: 10px;\n\tmargin-right: auto;\n\n\tform {\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tflex: 0 1 460px;\n\tmargin-left: 10px;\n\tmargin-right: auto;\n\n\tform {\n\t\tmargin-right: 20px;\n\t}\n"])));
var Input = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('input')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tpadding: 8px 5px;\n\tborder: 1px solid ", ";\n\toutline: 0;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: bold;\n\tfont-size: 15px;\n\tline-height: 17px;\n\tcolor: ", ";\n\t-webkit-appearance: none;\n\n\t", "\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tpadding: 8px 5px;\n\tborder: 1px solid ", ";\n\toutline: 0;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: bold;\n\tfont-size: 15px;\n\tline-height: 17px;\n\tcolor: ", ";\n\t-webkit-appearance: none;\n\n\t", "\n\n\t&:focus {\n\t\tborder-color: ",
    ";\n\t}\n\n\t::-ms-clear {\n\t\tdisplay: none;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450, function (_a) {
    var isError = _a.isError, value = _a.value;
    return (isError || !value) && "border-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Red100 + ";";
}, function (_a) {
    var isError = _a.isError, value = _a.value;
    return (isError || !value)
        ? "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Red100
        : 'currentColor';
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonBack__ = __webpack_require__(1523);


var mapStateToProps = function (state) {
    var parentFolderId = state.editor.parentFolderId;
    return {
        parentId: parentFolderId,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonBack__["a" /* default */]));


/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes__ = __webpack_require__(13);




var ButtonBack = function (_a) {
    var parentId = _a.parentId;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["b" /* HeaderButton */], { iconWidth: "10px", iconHeight: "10px", onClick: function () { return __WEBPACK_IMPORTED_MODULE_3__utils_routes__["a" /* default */].redirectToParentDir(parentId); } }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_close-2')));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonBack);


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonPreview__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(17);





var mapStateToProps = function (state) {
    var _a = state.editor, label = _a.label.label, urlWithPin = _a.preprodPublication.urlWithPin, accessibleUrl = _a.paths.accessibleUrl, isAccessibleVersion = _a.isAccessibleVersion, driveItems = state.driveList.driveItems, sharedNetworks = state.galleryInfos.template.sharedNetworks;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _b.clientId, tempGId = _b.tempGId, originalGId = _b.originalGId;
    var driveItem = driveItems[tempGId] || driveItems[originalGId];
    var accessibleUrlWithToken = accessibleUrl ? accessibleUrl + (__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getUrlSeparator(accessibleUrl) + "token=" + __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].token) : '';
    return {
        url: isAccessibleVersion ? accessibleUrlWithToken : urlWithPin,
        clientId: clientId,
        tempGId: tempGId,
        label: label,
        driveItem: driveItem,
        isAccessibleVersion: isAccessibleVersion,
        isShareByCopyEnabled: __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isEmbedMode() ||
            __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isShareOnlyViaCopyEnabled(sharedNetworks) ||
            __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMultipleShareEnabled(sharedNetworks),
        isShareByEmailEnabled: !__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isEmbedMode() && !isAccessibleVersion && (__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isShareOnlyViaUprezEnabled(sharedNetworks) ||
            __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMultipleShareEnabled(sharedNetworks)),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonPreview__["a" /* default */]));


/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_Dropdown__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__typings_api__ = __webpack_require__(10);











var ButtonPreview = function (_a) {
    var url = _a.url, driveItem = _a.driveItem, clientId = _a.clientId, tempGId = _a.tempGId, label = _a.label, isShareByCopyEnabled = _a.isShareByCopyEnabled, isShareByEmailEnabled = _a.isShareByEmailEnabled, isDisabled = _a.isDisabled, dispatch = _a.dispatch, isAccessibleVersion = _a.isAccessibleVersion;
    var isProposal = __WEBPACK_IMPORTED_MODULE_9__utils_driveItem__["d" /* default */].isProposal(driveItem.format);
    var handleOpenPreviewClick = function () {
        if (isAccessibleVersion) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["s" /* openAccessibleVersionPreview */])());
            return;
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["t" /* openPreview */])(driveItem.id));
        }
    };
    var handleGetUrlClick = function () {
        if (isProposal) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__["m" /* sharePublicationViaCopy */])(clientId, tempGId, label, driveItem.format, __WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* PopupTheme */].DARK));
            return;
        }
        if (url) {
            __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__(url);
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_NotificationBar_actions__["c" /* createNotification */])('info.url_copied'));
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_NotificationBar_actions__["c" /* createNotification */])('error.get_publication_url'));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_Editor_actions__["k" /* getPreprodPublicationUrl */])(clientId, tempGId, label, true));
        }
    };
    var handleSendByEmailClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Share_actions__["g" /* initiateShare */])([driveItem], true, __WEBPACK_IMPORTED_MODULE_10__typings_api__["a" /* Api */].ShareNetwork.Uprez));
    };
    var options = [];
    if (!isProposal) {
        options.push({
            label: 'messages.see_preview',
            icon: {
                name: 'iconset_uprez_eye',
                width: '23px',
                height: '16px',
            },
            onClick: handleOpenPreviewClick,
        });
        if (isShareByCopyEnabled) {
            options.push({
                label: 'messages.get_url',
                icon: {
                    name: 'iconset_uprez_link2',
                    width: '23px',
                    height: '23px',
                },
                onClick: handleGetUrlClick,
            });
        }
        if (isShareByEmailEnabled) {
            options.push({
                label: 'messages.send_by_email',
                icon: {
                    name: 'iconset_uprez_send2',
                    width: '23px',
                    height: '23px',
                },
                onClick: handleSendByEmailClick,
            });
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Header_Dropdown__["a" /* default */], { buttonLabel: "messages.preview", dropdownTitle: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.preview'), color: __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Blue450, isDisabled: isDisabled, options: options, onButtonClick: isProposal ? handleOpenPreviewClick : undefined }));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonPreview);


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OptionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t& + & {\n\t\tmargin-left: 10px;\n\t}\n"], ["\n\t& + & {\n\t\tmargin-left: 10px;\n\t}\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 30px;\n\tpadding: 5px 20px;\n\tborder: 0;\n\tborder-radius: 15px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 19px;\n\tcolor: ", ";\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t", "\n\n\t", "\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 11px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: currentColor;\n\t\ttransform: translateY(-50%);\n\n\t\t", "\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 30px;\n\tpadding: 5px 20px;\n\tborder: 0;\n\tborder-radius: 15px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 13px;\n\tline-height: 19px;\n\tcolor: ", ";\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t",
    "\n\n\t",
    "\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 11px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: currentColor;\n\t\ttransform: translateY(-50%);\n\n\t\t",
    "\n\t}\n"])), function (_a) {
    var color = _a.color;
    return color;
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
}, function (_a) {
    var hasDropdown = _a.hasDropdown;
    return hasDropdown && "\n\t\tpadding-right: 30px;\n\t";
}, function (_a) {
    var isOpened = _a.isOpened;
    return isOpened && "\n\t\t\ttransform: translateY(-50%) rotate(90deg);\n\t\t";
});
var Content = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: fixed;\n\ttop: calc(", "px + 10px);\n\tright: 12px;\n\tz-index: 20;\n\twidth: 375px;\n\tpadding: 15px;\n\tborder-radius: 11px;\n\tbackground: ", ";\n\tbox-shadow: 0 -2px 45px 0 ", ";\n"], ["\n\tbox-sizing: border-box;\n\tposition: fixed;\n\ttop: calc(", "px + 10px);\n\tright: 12px;\n\tz-index: 20;\n\twidth: 375px;\n\tpadding: 15px;\n\tborder-radius: 11px;\n\tbackground: ", ";\n\tbox-shadow: 0 -2px 45px 0 ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__styles__["e" /* HEADER_HEIGHT */], __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black, 64));
var ContentHeader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 15px;\n\tfont-weight: bold;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n\n\t> span {\n\t\tline-height: 24px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 15px;\n\tfont-weight: bold;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n\n\t> span {\n\t\tline-height: 24px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White);
var OptionButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 10px 17px;\n\tborder: 0;\n\tborder-radius: 10px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 24px;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t& + & {\n\t\tmargin-top: 15px;\n\t}\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t\tanimation: ", ";\n\t\tanimation-duration: ", ";\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 10px 17px;\n\tborder: 0;\n\tborder-radius: 10px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 24px;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t& + & {\n\t\tmargin-top: 15px;\n\t}\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t\tanimation: ", ";\n\t\tanimation-duration: ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 10), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 25), function (_a) {
    var iconWidth = _a.iconWidth;
    return iconWidth;
}, function (_a) {
    var iconHeight = _a.iconHeight;
    return iconHeight;
}, __WEBPACK_IMPORTED_MODULE_3__utils_style__["e" /* spin */], function (_a) {
    var isRotatingIcon = _a.isRotatingIcon;
    return isRotatingIcon ? '1s' : '0s';
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonPublish__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings_api__ = __webpack_require__(10);





var mapStateToProps = function (state) {
    var _a = state.editor, label = _a.label.label, _b = _a.preprodPublication, lastUpdateDate = _b.lastUpdateDate, isUpdating = _b.isUpdating, urlWithPin = _b.urlWithPin, projectUrl = _a.settings.projectUrl, invoiceStatus = _a.invoiceStatus, _c = _a.publishPrice.actionCredits, actionCredits = _c === void 0 ? {} : _c, driveItems = state.driveList.driveItems, sharedNetworks = state.galleryInfos.template.sharedNetworks, accType = state.profile.customer.accType;
    var _d = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])(), clientId = _d.clientId, originalGId = _d.originalGId, tempGId = _d.tempGId;
    var driveItem = driveItems[originalGId];
    var isPublishDue = accType === __WEBPACK_IMPORTED_MODULE_4__typings_api__["a" /* Api */].AccountType.PREPAID
        && invoiceStatus === __WEBPACK_IMPORTED_MODULE_4__typings_api__["a" /* Api */].AssetItemInvoiceStatus.DEMO;
    var hasActionCredits = Object.keys(actionCredits).length > 0;
    return {
        projectUrl: projectUrl,
        urlWithPin: urlWithPin,
        clientId: clientId,
        originalGId: originalGId,
        tempGId: tempGId,
        label: label,
        driveItem: driveItem,
        isShareByCopyEnabled: __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isEmbedMode() ||
            __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isShareOnlyViaCopyEnabled(sharedNetworks) ||
            __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMultipleShareEnabled(sharedNetworks),
        isShareByEmailEnabled: !__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isEmbedMode() && (__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isShareOnlyViaUprezEnabled(sharedNetworks) ||
            __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].isMultipleShareEnabled(sharedNetworks)),
        lastUpdateDate: lastUpdateDate,
        isUpdating: isUpdating,
        isPublishDue: isPublishDue,
        actionCredits: hasActionCredits ? actionCredits : {},
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonPublish__["a" /* default */]));


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_Dropdown__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Share_actions__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CombinePanel_styles__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_Editor_actions_sources__ = __webpack_require__(68);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};














var getButtonLabel = function (isProposal) { return (isProposal ? 'messages.send' : 'messages.publish'); };
var getDropdownTitle = function (lastUpdateDate, isProposal, isPublished) {
    if (isProposal) {
        return null;
    }
    if (!isPublished) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.publish" });
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.published" }),
        ':',
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* PublishDate */], null, lastUpdateDate &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Localize"], { value: lastUpdateDate, dateFormat: "date_format.long" }))));
};
var extraPaidActionsModalMessage = function (credits, message) { return Object.keys(credits).map(function (key, index) {
    if (!credits[key]) {
        return null;
    }
    var action = __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t("messages." + key);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__CombinePanel_styles__["b" /* Message */], { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { key: index, value: "messages." + message, 
                // @ts-ignore
                dangerousHTML: true, credits: credits[key], action: action }))));
}); };
var ButtonPublish = function (_a) {
    var projectUrl = _a.projectUrl, urlWithPin = _a.urlWithPin, driveItem = _a.driveItem, _b = _a.driveItem, published = _b.published, format = _b.format, id = _b.id, lastUpdateDate = _a.lastUpdateDate, clientId = _a.clientId, originalGId = _a.originalGId, tempGId = _a.tempGId, label = _a.label, isShareByCopyEnabled = _a.isShareByCopyEnabled, isShareByEmailEnabled = _a.isShareByEmailEnabled, isUpdating = _a.isUpdating, isDisabled = _a.isDisabled, dispatch = _a.dispatch, isPublishDue = _a.isPublishDue, actionCredits = _a.actionCredits;
    var isProposal = __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].isProposal(format) && !__WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].isMasterProposal(format);
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isPaymentConfirmationDisplayed = _c[0], setIsPaymentConfirmationDisplayed = _c[1];
    var handleOpenPublishedClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["t" /* openPreview */])(id));
    };
    var handleUpdateClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["_6" /* updateOriginal */])(tempGId, originalGId));
    };
    var handlePublishClick = function () {
        if (isPublishDue) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__containers_Editor_actions_sources__["e" /* getPublishPrice */])(id))
                .then(function () {
                setIsPaymentConfirmationDisplayed(true);
            });
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["u" /* publish */])(originalGId));
        }
    };
    var handleGetUrlClick = function () {
        if (isProposal) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Share_actions__["m" /* sharePublicationViaCopy */])(clientId, originalGId, label, format, __WEBPACK_IMPORTED_MODULE_11__Popup__["a" /* PopupTheme */].DARK));
            return;
        }
        var url = published ? projectUrl : urlWithPin;
        if (url) {
            __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__(url);
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_NotificationBar_actions__["c" /* createNotification */])('info.url_copied'));
        }
        else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_NotificationBar_actions__["c" /* createNotification */])('error.get_publication_url'));
            if (published) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["m" /* getPublishedPublicationUrl */])(originalGId));
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["k" /* getPreprodPublicationUrl */])(clientId, tempGId, label, true));
            }
        }
    };
    var handleSendByEmailClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Share_actions__["g" /* initiateShare */])([driveItem], true, __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].ShareNetwork.Uprez));
    };
    var options = [];
    if (!isProposal) {
        if (published) {
            options.push({
                label: isUpdating ? 'messages.updating' : 'messages.update_published',
                icon: {
                    name: 'iconset_uprez_update-2',
                    width: '26px',
                    height: '26px',
                    isRotating: isUpdating,
                },
                onClick: handleUpdateClick,
            });
            options.push({
                label: 'messages.view_published',
                icon: {
                    name: 'iconset_uprez_eye',
                    width: '23px',
                    height: '16px',
                },
                onClick: handleOpenPublishedClick,
            });
        }
        else {
            options.push({
                label: isUpdating ? 'messages.publishing' : 'messages.publish',
                icon: {
                    name: 'iconset_uprez_rocket',
                    width: '22px',
                    height: '22px',
                },
                onClick: handlePublishClick,
            });
        }
    }
    if (isShareByCopyEnabled) {
        options.push({
            label: 'messages.get_url',
            icon: {
                name: 'iconset_uprez_link2',
                width: '23px',
                height: '23px',
            },
            onClick: handleGetUrlClick,
        });
    }
    if (isShareByEmailEnabled) {
        options.push({
            label: 'messages.send_by_email',
            icon: {
                name: 'iconset_uprez_send2',
                width: '23px',
                height: '23px',
            },
            onClick: handleSendByEmailClick,
        });
    }
    var message = extraPaidActionsModalMessage(actionCredits, 'notification_credits_multiline');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Header_Dropdown__["a" /* default */], { buttonLabel: getButtonLabel(isProposal), dropdownTitle: getDropdownTitle(lastUpdateDate, isProposal, published), color: __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Blue350, isDisabled: isDisabled, options: options }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Popup__["b" /* default */], { isDisplayed: isPaymentConfirmationDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.publish_publication'), onConfirm: function () {
                setIsPaymentConfirmationDisplayed(false);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["u" /* publish */])(originalGId));
            }, onCancel: function () { return setIsPaymentConfirmationDisplayed(false); }, actionButtonColor: __WEBPACK_IMPORTED_MODULE_5__utils_styles_constants__["b" /* NewStyleColor */].Blue450, theme: __WEBPACK_IMPORTED_MODULE_11__Popup__["a" /* PopupTheme */].DARK },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__CombinePanel_styles__["c" /* PopupBodyWrapper */], null, message))));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonPublish);


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublishDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var PublishDate = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-weight: 400;\n\tfont-size: 14px;\n\n\t&:not(:empty) {\n\t\tpadding: 2px 10px;\n\t}\n"], ["\n\tmargin-left: auto;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-weight: 400;\n\tfont-size: 14px;\n\n\t&:not(:empty) {\n\t\tpadding: 2px 10px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue400);

var templateObject_1;


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonEdit__ = __webpack_require__(1531);


var mapStateToProps = function (state) {
    var _a = state.editor, activeItem = _a.activeItem, spreadBackground = _a.spreadBackground;
    return {
        isDisabled: !activeItem.id && !spreadBackground.isActive,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonEdit__["a" /* default */]));


/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);






var ButtonEdit = function (_a) {
    var isDisabled = _a.isDisabled, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["b" /* HeaderButton */], { className: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] + " " + __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["l" /* SPREAD_BACKGROUND_CLICK_CLASSNAME */], iconWidth: "35px", iconHeight: "35px", disabled: isDisabled, color: isDisabled ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].Blue600, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__["U" /* toggleEditPanel */])()); } }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_uprez_edit')));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonEdit);


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonSettings__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);



var mapStateToProps = function (state) {
    var publicationSettings = state.galleryInfos.template.publicationSettings, _a = state.editor, isDisplayed = _a.settings.isDisplayed, themes = _a.themes;
    var publicationId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().originalGId;
    return {
        publicationId: publicationId,
        isActive: isDisplayed,
        hasPublicationSettings: !!publicationSettings,
        hasThemes: !!themes,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonSettings__["a" /* default */]));


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditPanel_constants__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_EditPanel_SettingsPanel__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_EditPanel_ThemesPanel__ = __webpack_require__(154);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};









var ButtonSettings = function (_a) {
    var publicationId = _a.publicationId, isActive = _a.isActive, isDisabled = _a.isDisabled, hasPublicationSettings = _a.hasPublicationSettings, hasThemes = _a.hasThemes, dispatch = _a.dispatch;
    var buttonElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (hasPublicationSettings) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["l" /* getPublicationSettings */])(publicationId));
        }
    }, [hasPublicationSettings, publicationId]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isActive) {
            return;
        }
        var handleClickOutside = function (e) {
            if (e.target === buttonElement.current) {
                return;
            }
            var elementsToCheck = document.querySelectorAll("." + __WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["k" /* SETTINGS_PANEL_CLASSNAME */]);
            if (__spread(elementsToCheck).every(function (element) { return !element.contains(e.target); })) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["V" /* toggleSettingsPanel */])());
            }
        };
        window.addEventListener('pointerdown', handleClickOutside);
        return function () {
            window.removeEventListener('pointerdown', handleClickOutside);
        };
    }, [isActive]);
    var panels = {};
    if (hasPublicationSettings) {
        panels[__WEBPACK_IMPORTED_MODULE_5__EditPanel_constants__["a" /* AdditionalPanelType */].settings] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_Editor_EditPanel_SettingsPanel__["a" /* default */], null);
    }
    if (hasThemes) {
        panels[__WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["c" /* EditableType */].themes] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Editor_EditPanel_ThemesPanel__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["k" /* SETTINGS_PANEL_CLASSNAME */] });
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["b" /* HeaderButton */], { ref: buttonElement, iconWidth: "35px", iconHeight: "35px", disabled: isDisabled, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["V" /* toggleSettingsPanel */])()); } }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_uprez_settings')),
        isActive &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["k" /* SETTINGS_PANEL_CLASSNAME */], defaultType: hasPublicationSettings ? __WEBPACK_IMPORTED_MODULE_5__EditPanel_constants__["a" /* AdditionalPanelType */].settings : __WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["c" /* EditableType */].themes, panels: panels })));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonSettings);


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SettingsPanel__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);



var mapStateToProps = function (state) {
    var publicationSettings = state.galleryInfos.template.publicationSettings, _a = state.editor.settings, fields = _a.fields, serverErrors = _a.serverErrors;
    var publicationId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().originalGId;
    return {
        publicationId: publicationId,
        settingNames: publicationSettings,
        settings: fields,
        serverErrors: serverErrors,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SettingsPanel__["a" /* default */]));


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldPanel__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SettingsPanel_PdfSettingsPanel__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_SettingsPanel_CopyPublicationUrl__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_validation__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;











var SETTINGS_CONFIG = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationSettingName.downloadPdf] = {
        label: 'messages.add_pdf_to_download',
        getCustomPanel: function (props) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SettingsPanel_PdfSettingsPanel__["a" /* default */], __assign({}, props)); }
    },
    _a[__WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationSettingName.customUrl] = {
        label: 'messages.customize_url',
        data: {
            name: __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationSettingName.customUrl,
            label: 'messages.your_url',
            icon: 'iconset_uprez_link2',
            placeholder: 'messages.campaign_name',
            hint: 'messages.customize_url_hint',
            getMaskedValue: function (value) { return value.replace(/\s/g, '_'); },
            renderChildren: function (value) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_SettingsPanel_CopyPublicationUrl__["a" /* default */], { customUrl: value }); },
        },
    },
    _a[__WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationSettingName.googleAnalyticsUa] = {
        label: 'messages.integrate_ua_code',
        data: {
            name: __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationSettingName.googleAnalyticsUa,
            label: 'messages.your_ua_code',
            icon: 'iconset_uprez_tracking_stats',
            placeholder: 'UA-000000-2',
            hint: 'messages.integrate_ua_code_hint',
            checkIsValid: function (value) {
                var uaCodes = value.replace(/\s/g, '').split(/,|;/);
                return uaCodes.every(function (code) { return __WEBPACK_IMPORTED_MODULE_8__utils_validation__["a" /* default */].isGoogleAnalyticsUaCode(code); });
            },
        },
    },
    _a);
var SettingsPanel = function (_a) {
    var publicationId = _a.publicationId, settingNames = _a.settingNames, settings = _a.settings, serverErrors = _a.serverErrors, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), activeSetting = _b[0], setActiveSetting = _b[1];
    var prevEditedSetting = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var handleSettingSave = function (name, value) {
        var _a;
        prevEditedSetting.current = name;
        setActiveSetting(null);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["E" /* savePublicationSettings */])(publicationId, (_a = {},
            _a[name] = value,
            _a)));
    };
    var resetServerError = function (name) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["Q" /* setSettingsError */])(name, null));
        prevEditedSetting.current = null;
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["l" /* getPublicationSettings */])(publicationId));
    }, [publicationId]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!__WEBPACK_IMPORTED_MODULE_10__utils__["d" /* default */].isEmptyObject(serverErrors)) {
            if (prevEditedSetting.current) {
                setActiveSetting(prevEditedSetting.current);
            }
        }
    }, [serverErrors]);
    var getActiveSettingPanel = function () {
        var _a = SETTINGS_CONFIG[activeSetting], getCustomPanel = _a.getCustomPanel, data = _a.data;
        if (getCustomPanel) {
            return getCustomPanel({
                onClose: function () { return setActiveSetting(null); },
            });
        }
        if (data) {
            var name_1 = data.name;
            var serverError = serverErrors[name_1];
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__FieldPanel__["a" /* default */], __assign({}, data, { value: settings[name_1] || '', serverError: serverError, onConfirm: handleSettingSave, onClose: function () { return setActiveSetting(null); }, resetServerError: resetServerError })));
        }
        return null;
    };
    if (activeSetting) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, getActiveSettingPanel());
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* StyledList */], null, Object.entries(SETTINGS_CONFIG).map(function (_a, index) {
        var _b = __read(_a, 2), key = _b[0], label = _b[1].label;
        if (settingNames.includes(key)) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: index },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* Button */], { type: "button", onClick: function () { return setActiveSetting(key); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label }))));
        }
        return null;
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (SettingsPanel);


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InnerPanel__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonRemove__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var FieldPanel = function (_a) {
    var name = _a.name, initialValue = _a.value, label = _a.label, icon = _a.icon, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, hint = _a.hint, serverError = _a.serverError, renderChildren = _a.renderChildren, checkIsValid = _a.checkIsValid, getMaskedValue = _a.getMaskedValue, onConfirm = _a.onConfirm, onClose = _a.onClose, resetServerError = _a.resetServerError;
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialValue), 2), value = _c[0], setValue = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isError = _d[0], setIsError = _d[1];
    var inputElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var resetErrors = function () {
        if (isError) {
            setIsError(false);
        }
        if (serverError) {
            resetServerError(name);
        }
    };
    var handleChange = function (e) {
        setValue(e.target.value);
        resetErrors();
    };
    var handleClear = function () {
        setValue('');
        resetErrors();
        if (inputElement.current) {
            inputElement.current.focus();
        }
    };
    var handleConfirm = function () {
        if (value === initialValue) {
            return onClose();
        }
        var isValid = checkIsValid && value ? checkIsValid(value) : true;
        setIsError(!isValid);
        if (isValid) {
            var valueToSave = getMaskedValue ? getMaskedValue(value) : value;
            onConfirm(name, valueToSave);
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (serverError) {
            setIsError(true);
        }
        return function () {
            if (serverError) {
                resetServerError(name);
            }
        };
    }, [serverError]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setValue(initialValue);
    }, [initialValue]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__InnerPanel__["a" /* default */], { onConfirm: handleConfirm, onClose: onClose, isError: isError },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* Label */], { htmlFor: name },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* InputWrapper */], { hasButtonRemove: true, isError: isError },
            serverError && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* InputError */], { value: serverError }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* Icon */], null, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* default */].getSvgIcon(icon)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { ref: inputElement, type: "text", id: name, value: value, placeholder: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t(placeholder), onChange: handleChange, autoFocus: true }),
            value && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ButtonRemove__["a" /* default */], { onClick: handleClear })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Hint */], { value: hint }),
        renderChildren && renderChildren(value)));
};
/* harmony default export */ __webpack_exports__["a"] = (FieldPanel);


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('label')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75));
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 13px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 13px;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfill: currentColor;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75));
var Hint = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 16px;\n\tcolor: ", ";\n"], ["\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 16px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["c" /* StyleColor */].White, 75));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SettingsPanel_PdfSettingsPanel__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state) {
    var _a = state.editor.settings, pdfSettings = _a.pdfSettings, pdfImportingStatus = _a.pdfImportingStatus;
    var publicationId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().tempGId;
    return __assign({}, pdfSettings, { publicationId: publicationId,
        pdfImportingStatus: pdfImportingStatus });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SettingsPanel_PdfSettingsPanel__["a" /* default */]));


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InnerPanel__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_RadioBox__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonRemove__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ResourceSelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResourceSelector__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Form_Checkbox__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
















var getRadioBoxLabel = function (pdfOption) {
    switch (pdfOption) {
        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].PublicationPdfOption.FULL:
            return 'messages.full_pdf';
        case __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].PublicationPdfOption.CUSTOM:
        default:
            return 'messages.custom_pdf';
    }
};
var getIconName = function (globalId) { return (globalId ? 'iconset_page-bold' : 'iconset_uprez_adobe_pdf'); };
var getImportingLabel = function (status) {
    switch (status) {
        case __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__["j" /* PdfImportingStatus */].IMPORTING:
            return 'messages.importing';
        case __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__["j" /* PdfImportingStatus */].PROCESSING:
            return 'messages.processing';
        case __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__["j" /* PdfImportingStatus */].REMOVING:
            return 'messages.removing';
        default:
            return '';
    }
};
var isValidResourceFromApp = function (_a) {
    var type = _a.type;
    return (type === __WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].DriveItemType.Publication);
};
var PdfSettingsPanel = function (_a) {
    var publicationId = _a.publicationId, label = _a.label, globalId = _a.globalId, initialPdfOption = _a.pdfOption, pdfImportingStatus = _a.pdfImportingStatus, onClose = _a.onClose, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialPdfOption), 2), pdfOption = _b[0], setPdfOption = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isPopupDisplayed = _c[0], setIsPopupDisplayed = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), shouldUpdateThumbs = _d[0], setShouldUpdateThumbs = _d[1];
    var sourceFile = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var sourcePublicationId = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var importManagerId = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
        return Object(__WEBPACK_IMPORTED_MODULE_14__containers_Editor_utils_helpers__["y" /* getPublicationPdfImportingId */])(publicationId, __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__["j" /* PdfImportingStatus */].IMPORTING);
    }, [publicationId]);
    var handlePdfOptionChange = function (e) {
        setPdfOption(e.target.value);
    };
    var handleFileSelect = function (file, isCorrectFileType) {
        setIsPopupDisplayed(true);
        sourceFile.current = { file: file, isCorrectFileType: isCorrectFileType };
    };
    var handlePublicationSelect = function (_a) {
        var _b = __read(_a, 1), _c = _b[0], id = _c.id, label = _c.label;
        sourcePublicationId.current = id;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_actions__["n" /* importPublicationPdf */])(publicationId, importManagerId, null, { id: id, label: label }, shouldUpdateThumbs, pdfOption));
    };
    var handlePopupConfirm = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_actions__["n" /* importPublicationPdf */])(publicationId, importManagerId, sourceFile.current, null, shouldUpdateThumbs, pdfOption));
        handlePopupClose();
    };
    var handlePopupClose = function () {
        setIsPopupDisplayed(false);
        setShouldUpdateThumbs(false);
        sourceFile.current = null;
    };
    var handleConfirm = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_actions__["D" /* savePublicationPdfOption */])(publicationId, pdfOption));
        onClose();
    };
    var handleButtonRemoveClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_actions__["n" /* importPublicationPdf */])(publicationId, importManagerId, null, { id: -1, label: '' }, shouldUpdateThumbs, pdfOption));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!pdfImportingStatus && sourcePublicationId.current) {
            sourcePublicationId.current = null;
        }
    }, [pdfImportingStatus]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__InnerPanel__["a" /* default */], { onConfirm: handleConfirm, onClose: onClose },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_ResourceSelector__["a" /* default */], { id: importManagerId, className: __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__["k" /* SETTINGS_PANEL_CLASSNAME */], isValidResourceFromApp: isValidResourceFromApp, fileExtensions: ['.pdf'], theme: __WEBPACK_IMPORTED_MODULE_8__ResourceSelector__["a" /* ResourceSelectorTheme */].DARK, customImportHandler: handleFileSelect, onSelect: handlePublicationSelect }),
            (label || pdfImportingStatus) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["d" /* FileLabelWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["c" /* FileLabelInner */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["e" /* Icon */], null, __WEBPACK_IMPORTED_MODULE_15__utils__["d" /* default */].getSvgIcon(getIconName(globalId || sourcePublicationId.current))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* FileLabel */], { isImporting: !!pdfImportingStatus }, pdfImportingStatus
                            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: getImportingLabel(pdfImportingStatus) })
                            : label)),
                    globalId &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ButtonRemove__["a" /* default */], { onClick: handleButtonRemoveClick })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["f" /* Label */], { value: "messages.pdf_type" }),
            Object.values(__WEBPACK_IMPORTED_MODULE_1__typings_api__["a" /* Api */].PublicationPdfOption).map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Form_RadioBox__["b" /* default */], { key: option, name: "pdfOption", label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: getRadioBoxLabel(option) }), value: option, isChecked: option === pdfOption, theme: __WEBPACK_IMPORTED_MODULE_4__Form_RadioBox__["a" /* RadioBoxTheme */].DARK, onChange: handlePdfOptionChange })); })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Portal__["a" /* default */], { parentNode: document.body },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Popup__["b" /* default */], { className: "prevent-drag " + __WEBPACK_IMPORTED_MODULE_13__containers_Editor_constants__["k" /* SETTINGS_PANEL_CLASSNAME */], isDisplayed: isPopupDisplayed, label: __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["I18n"].t('messages.update_pdf_thumb'), theme: __WEBPACK_IMPORTED_MODULE_10__Popup__["a" /* PopupTheme */].DARK, onConfirm: handlePopupConfirm, onCancel: handlePopupClose },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["g" /* PopupBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.update_pdf_thumb_message" }),
                    sourceFile.current &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* CheckboxWrapper */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Form_Checkbox__["a" /* default */], { name: "update-pdf-thumb-accept", label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.update_pdf_thumb_accept" }), isChecked: shouldUpdateThumbs, onChange: function () { return setShouldUpdateThumbs(function (isChecked) { return !isChecked; }); } })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PdfSettingsPanel);


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FileLabelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FileLabelInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FileLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PopupBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckboxWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var FileLabelWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 20px 0;\n\tpadding: 10px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\tbutton {\n\t\tflex: 0 0 20px;\n\t\tmargin-left: 15px;\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 20px 0;\n\tpadding: 10px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\tbutton {\n\t\tflex: 0 0 20px;\n\t\tmargin-left: 15px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 10));
var FileLabelInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex: 1 1 auto;\n\theight: 50px;\n\tpadding: 0;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\toverflow: hidden;\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex: 1 1 auto;\n\theight: 50px;\n\tpadding: 0;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\toverflow: hidden;\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 25));
var FileLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\t", "\n"], ["\n\twidth: 100%;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 14px;\n\tcolor: ", ";\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\t",
    "\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75), function (_a) {
    var isImporting = _a.isImporting;
    return isImporting && "\n\t\t&::after {\n\t\t\tcontent: '...';\n\t\t}\n\t";
});
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 50px;\n\theight: 50px;\n\n\tsvg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex: 0 0 50px;\n\theight: 50px;\n\n\tsvg {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tfill: ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var PopupBody = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n"], ["\n\tpadding: 20px;\n\tcolor: ", ";\n\ttext-align: center;\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var CheckboxWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin-top: 20px;\n\n\tlabel {\n\t\tcolor: ", ";\n\n\t\tspan {\n\t\t\tfont-size: 16px;\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"], ["\n\tmargin-top: 20px;\n\n\tlabel {\n\t\tcolor: ", ";\n\n\t\tspan {\n\t\t\tfont-size: 16px;\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* Label */])(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin-top: 20px;\n\tpadding-left: 0;\n"], ["\n\tmargin-top: 20px;\n\tpadding-left: 0;\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SettingsPanel_CopyPublicationUrl__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);




var mapStateToProps = function (state) {
    var _a = state.editor.settings, projectUrl = _a.projectUrl, serverErrors = _a.serverErrors;
    var publicationId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().originalGId;
    return {
        publicationId: publicationId,
        projectUrl: projectUrl,
        isDisabled: !!serverErrors[__WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].PublicationSettingName.customUrl],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SettingsPanel_CopyPublicationUrl__["a" /* default */]));


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_NotificationBar_actions__ = __webpack_require__(15);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;







var getPublicationUrl = function (projectUrl, customUrl, publicationId) {
    var customUrlSeparator = '/.';
    var isCustomUrlInProjectUrl = projectUrl.includes(customUrlSeparator);
    var pathRegExp = isCustomUrlInProjectUrl
        ? /\/\..*/
        : new RegExp("\\/" + publicationId + "\\/?");
    var domain = projectUrl.replace(pathRegExp, '');
    var newPath = customUrl ? "." + customUrl.replace(/\s/g, '_') : publicationId;
    return domain + "/" + newPath + "/";
};
var CopyPublicationUrl = function (_a) {
    var publicationId = _a.publicationId, customUrl = _a.customUrl, projectUrl = _a.projectUrl, isDisabled = _a.isDisabled, dispatch = _a.dispatch;
    var initialCustomUrl = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](customUrl);
    var handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var publicationUrl, newPublicationUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    publicationUrl = getPublicationUrl(projectUrl, customUrl, publicationId);
                    __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__(publicationUrl);
                    if (!(customUrl !== initialCustomUrl.current)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["E" /* savePublicationSettings */])(publicationId, {
                            customUrl: customUrl.replace(/\s/g, '_'),
                        }))];
                case 1:
                    newPublicationUrl = _a.sent();
                    // server can change publicationUrl in some cases, e.g., 'my/url' will be cut to just 'my'
                    if (newPublicationUrl && newPublicationUrl !== publicationUrl) {
                        __WEBPACK_IMPORTED_MODULE_2_copy_to_clipboard__(newPublicationUrl);
                    }
                    initialCustomUrl.current = customUrl;
                    _a.label = 2;
                case 2:
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotificationBar_actions__["c" /* createNotification */])('info.url_copied'));
                    return [2 /*return*/];
            }
        });
    }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Label */], { value: "messages.project_url" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* InputWrapper */], { hasNoIcon: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", value: getPublicationUrl(projectUrl, customUrl, publicationId), disabled: true })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Button */], { onClick: handleClick, disabled: isDisabled },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.copy" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (CopyPublicationUrl);


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin: 15px 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tdisplay: block;\n\tmargin: 15px 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75));

var templateObject_1;


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\n\tli:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n"], ["\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\n\tli:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n"])));

var templateObject_1;


/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuplicateTheme__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RemoveTheme__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RenameTheme__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectTheme__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ColorsList__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(127);







var ThemesPanel = function (_a) {
    var themes = _a.themes, selectedThemeId = _a.selectedThemeId, className = _a.className, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__SelectTheme__["a" /* default */], { themes: themes, themeId: selectedThemeId, dispatch: dispatch }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ColorsList__["a" /* default */], { themeId: selectedThemeId, colors: themes[selectedThemeId].colors, dispatch: dispatch }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* ButtonsWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__RenameTheme__["a" /* default */], { themeId: selectedThemeId, themes: themes, className: className, dispatch: dispatch }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__DuplicateTheme__["a" /* default */], { themeId: selectedThemeId, themes: themes, className: className, dispatch: dispatch }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__RemoveTheme__["a" /* default */], { themeId: selectedThemeId, themes: themes, className: className, dispatch: dispatch }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ThemesPanel);


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__ = __webpack_require__(14);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var getNewThemeName = function (initialName, themes) {
    var newName = initialName + "-copy";
    var usedThemeNames = Object.values(themes).map(function (_a) {
        var name = _a.name;
        return name;
    });
    return usedThemeNames.includes(newName)
        ? getNewThemeName(newName, themes)
        : newName;
};
var DuplicateTheme = function (_a) {
    var themeId = _a.themeId, themes = _a.themes, className = _a.className, dispatch = _a.dispatch;
    var initialName = themes[themeId].name;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialName), 2), name = _b[0], setName = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), error = _c[0], setError = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isPopupDisplayed = _d[0], setIsPopupDisplayed = _d[1];
    var handleButtonClick = function () {
        setInitialState();
        setIsPopupDisplayed(true);
    };
    var handleInputChange = function (e) {
        setName(e.target.value);
        setError(null);
    };
    var handleConfirm = function () {
        if (!name) {
            return;
        }
        var usedThemeNames = Object.values(themes).map(function (_a) {
            var name = _a.name;
            return name;
        });
        if (usedThemeNames.includes(name)) {
            return setError('error.duplicate_theme');
        }
        setIsPopupDisplayed(false);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["h" /* duplicateTheme */])(themeId, name));
        setInitialState();
    };
    var setInitialState = function () {
        var newThemeName = getNewThemeName(initialName, themes);
        setName(newThemeName);
        setError(null);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { onClick: handleButtonClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.duplicate" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Portal__["a" /* default */], { parentNode: document.body },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["b" /* default */], { className: "prevent-drag " + (className || ''), isDisplayed: isPopupDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.duplicate_theme'), theme: __WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* PopupTheme */].DARK, isConfirmDisabled: !name || !!error, onConfirm: handleConfirm, onCancel: function () { return setIsPopupDisplayed(false); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* PopupBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* PopupInputWrapper */], { isError: !!error },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* PopupInputLabel */], { value: error || 'messages.theme_name' }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Form_styles__["a" /* Input */], { type: "text", value: name, onChange: handleInputChange })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (DuplicateTheme);


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__ = __webpack_require__(14);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var RemoveTheme = function (_a) {
    var themeId = _a.themeId, themes = _a.themes, className = _a.className, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isPopupDisplayed = _b[0], setIsPopupDisplayed = _b[1];
    var handleConfirm = function () {
        setIsPopupDisplayed(false);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["x" /* removeTheme */])(themeId));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { disabled: Object.keys(themes).length === 1, onClick: function () { return setIsPopupDisplayed(true); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.remove" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Portal__["a" /* default */], { parentNode: document.body },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Popup__["b" /* default */], { className: "prevent-drag " + (className || ''), isDisplayed: isPopupDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.remove_theme'), theme: __WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* PopupTheme */].DARK, onConfirm: handleConfirm, onCancel: function () { return setIsPopupDisplayed(false); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* PopupBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.remove_theme_question" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (RemoveTheme);


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_styles__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__ = __webpack_require__(14);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var RenameTheme = function (_a) {
    var themeId = _a.themeId, themes = _a.themes, className = _a.className, dispatch = _a.dispatch;
    var initialName = themes[themeId].name;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialName), 2), name = _b[0], setName = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), error = _c[0], setError = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isPopupDisplayed = _d[0], setIsPopupDisplayed = _d[1];
    var handleButtonClick = function () {
        setInitialState();
        setIsPopupDisplayed(true);
    };
    var handleInputChange = function (e) {
        setName(e.target.value);
        setError(null);
    };
    var handleConfirm = function () {
        if (!name) {
            return;
        }
        if (name === initialName) {
            return setIsPopupDisplayed(false);
        }
        var usedThemeNames = Object.values(themes).map(function (_a) {
            var name = _a.name;
            return name;
        });
        if (usedThemeNames.includes(name)) {
            return setError('error.duplicate_theme');
        }
        setIsPopupDisplayed(false);
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["y" /* renameTheme */])(themeId, name));
        setInitialState();
    };
    var setInitialState = function () {
        setName(initialName);
        setError(null);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { onClick: handleButtonClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.rename" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Portal__["a" /* default */], { parentNode: document.body },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["b" /* default */], { className: "prevent-drag " + (className || ''), isDisplayed: isPopupDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.rename_theme'), theme: __WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* PopupTheme */].DARK, isConfirmDisabled: !name || !!error, onConfirm: handleConfirm, onCancel: function () { return setIsPopupDisplayed(false); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* PopupBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* PopupInputWrapper */], { isError: !!error },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* PopupInputLabel */], { value: error || 'messages.theme_name' }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Form_styles__["a" /* Input */], { type: "text", value: name, onChange: handleInputChange })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (RenameTheme);


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__ = __webpack_require__(14);





var SelectTheme = function (_a) {
    var themes = _a.themes, themeId = _a.themeId, dispatch = _a.dispatch;
    var options = Object.values(themes).map(function (_a) {
        var id = _a.id, name = _a.name, colors = _a.colors;
        return ({
            values: [id],
            label: name,
            displayedLabel: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Option */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* OptionLabel */], null, name),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* OptionColorsList */], null, colors.map(function (color, index) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Color */], { key: index, color: color }); })))),
        });
    });
    var handleChange = function (value) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__["I" /* selectTheme */])(value, true));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], { label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.theme') + ":", value: themeId, options: options, optionsLabel: "messages.your_themes", onChange: handleChange }));
};
/* harmony default export */ __webpack_exports__["a"] = (SelectTheme);


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OptionLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OptionColorsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var Option = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n"])));
var OptionLabel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-right: 10px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"], ["\n\tmargin-right: 10px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])));
var OptionColorsList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n"], ["\n\tdisplay: flex;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n"])));
var Color = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('li')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\t& + & {\n\t\tmargin-left: 6px;\n\t}\n"], ["\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\t& + & {\n\t\tmargin-left: 6px;\n\t}\n"])), function (_a) {
    var color = _a.color;
    return color;
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorPicker__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var ColorsList = function (_a) {
    var themeId = _a.themeId, colors = _a.colors, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), activeColorIndex = _b[0], setActiveColorIndex = _b[1];
    var handleColorButtonClick = function (index) {
        setActiveColorIndex(index);
    };
    var handleColorPickerConfirm = function (color) {
        var colorIndex = activeColorIndex;
        if (color !== colors[colorIndex]) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["c" /* changeThemeColor */])(themeId, colorIndex, color));
        }
        setActiveColorIndex(null);
    };
    var handleColorPickerCancel = function () {
        setActiveColorIndex(null);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Wrapper */], null,
        colors.map(function (color, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ColorButton */], { key: index, color: color, onClick: function () { return handleColorButtonClick(index); } })); }),
        activeColorIndex !== null &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ColorPicker__["a" /* default */], { initialColor: colors[activeColorIndex], onConfirm: handleColorPickerConfirm, onCancel: handleColorPickerCancel })));
};
/* harmony default export */ __webpack_exports__["a"] = (ColorsList);


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: 30px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-top: 30px;\n"])));
var ColorButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 46px;\n\theight: 46px;\n\tpadding: 0;\n\tborder: 1px solid ", ";\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t& + & {\n\t\tmargin-left: 13px;\n\t}\n"], ["\n\twidth: 46px;\n\theight: 46px;\n\tpadding: 0;\n\tborder: 1px solid ", ";\n\tborder-radius: 50%;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcursor: pointer;\n\n\t& + & {\n\t\tmargin-left: 13px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 10), function (_a) {
    var color = _a.color;
    return color;
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_colorful__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var ColorPicker = function (_a) {
    var initialColor = _a.initialColor, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialColor), 2), color = _b[0], setColor = _b[1];
    var handleConfirmClick = function () {
        onConfirm(color);
    };
    var handleHexColorInputChange = function (hexColor) {
        // ignore invalid hex values
        if (hexColor.length < 7) {
            return;
        }
        var alpha = Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["d" /* rgbaToHexAndAlpha */])(color).alpha;
        var rgbaColor = Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(hexColor, alpha * 100);
        setColor(rgbaColor);
    };
    var handleOpacityInputChange = function (e) {
        var value = e.target.value;
        if (isNaN(+value) || +value < 0 || +value > 100) {
            return;
        }
        var hexColor = Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["d" /* rgbaToHexAndAlpha */])(color).hexColor;
        var rgbaColor = Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(hexColor, +value);
        setColor(rgbaColor);
    };
    var _c = Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["d" /* rgbaToHexAndAlpha */])(color), hexColor = _c.hexColor, alpha = _c.alpha;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Overlay */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ButtonsWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { onClick: onCancel },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { onClick: handleConfirmClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux_i18n__["Translate"], { value: "messages.ok" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* ControlsWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_colorful__["b" /* RgbaStringColorPicker */], { color: color, onChange: setColor }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* InputWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* Sign */], null, "#"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_colorful__["a" /* HexColorInput */], { color: hexColor, onChange: handleHexColorInputChange })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* InputWrapper */], { isOpacity: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", value: Math.round(alpha * 100), onChange: handleOpacityInputChange }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* Sign */], null, "%"))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Me; });
/* unused harmony export HexColorPicker */
/* unused harmony export HslColorPicker */
/* unused harmony export HslStringColorPicker */
/* unused harmony export HslaColorPicker */
/* unused harmony export HslaStringColorPicker */
/* unused harmony export HsvColorPicker */
/* unused harmony export HsvStringColorPicker */
/* unused harmony export HsvaColorPicker */
/* unused harmony export HsvaStringColorPicker */
/* unused harmony export RgbColorPicker */
/* unused harmony export RgbStringColorPicker */
/* unused harmony export RgbaColorPicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return me; });
/* unused harmony export setNonce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function l(){return(l=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o])}return e}).apply(this,arguments)}function u(e,r){if(null==e)return{};var t,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r.indexOf(t=a[o])>=0||(n[t]=e[t]);return n}var c="undefined"!=typeof window?__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"]:__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];function i(e){var r=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(e);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){r.current=e}),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){return r.current&&r.current(e)},[])}var s,f=function(e,r,t){return void 0===r&&(r=0),void 0===t&&(t=1),e>t?t:e<r?r:e},v=function(e){return"touches"in e},d=function(e,r){var t=e.getBoundingClientRect(),o=v(r)?r.touches[0]:r;return{left:f((o.pageX-(t.left+window.pageXOffset))/t.width),top:f((o.pageY-(t.top+window.pageYOffset))/t.height)}},h=function(e){!v(e)&&e.preventDefault()},m=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(r){var t=r.onMove,s=r.onKey,f=u(r,["onMove","onKey"]),m=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),g=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(!1),p=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!1),b=p[0],_=p[1],C=i(t),x=i(s),E=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){h(e),(v(e)?e.touches.length>0:e.buttons>0)&&m.current?C(d(m.current,e)):_(!1)},[C]),H=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){var r,t=e.nativeEvent,o=m.current;h(t),r=t,g.current&&!v(r)||(g.current||(g.current=v(r)),0)||!o||(o.focus(),C(d(o,t)),_(!0))},[C]),M=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){var r=e.which||e.keyCode;r<37||r>40||(e.preventDefault(),x({left:39===r?.05:37===r?-.05:0,top:40===r?.05:38===r?-.05:0}))},[x]),N=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){return _(!1)},[]),w=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){var r=e?window.addEventListener:window.removeEventListener;r(g.current?"touchmove":"mousemove",E),r(g.current?"touchend":"mouseup",N)},[E,N]);return c(function(){return w(b),function(){b&&w(!1)}},[b,w]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",l({},f,{className:"react-colorful__interactive",ref:m,onTouchStart:H,onMouseDown:H,onKeyDown:M,tabIndex:0,role:"slider"}))}),g=function(e){return e.filter(Boolean).join(" ")},p=function(r){var t=r.color,o=r.left,n=r.top,a=void 0===n?.5:n,l=g(["react-colorful__pointer",r.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:l,style:{top:100*a+"%",left:100*o+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-colorful__pointer-fill",style:{backgroundColor:t}}))},b=function(e,r,t){return void 0===r&&(r=0),void 0===t&&(t=Math.pow(10,r)),Math.round(t*e)/t},_={grad:.9,turn:360,rad:360/(2*Math.PI)},C=function(e){return"#"===e[0]&&(e=e.substr(1)),e.length<6?{r:parseInt(e[0]+e[0],16),g:parseInt(e[1]+e[1],16),b:parseInt(e[2]+e[2],16),a:1}:{r:parseInt(e.substr(0,2),16),g:parseInt(e.substr(2,2),16),b:parseInt(e.substr(4,2),16),a:1}},x=function(e,r){return void 0===r&&(r="deg"),Number(e)*(_[r]||1)},E=function(e){var r=/hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);return r?M({h:x(r[1],r[2]),s:Number(r[3]),l:Number(r[4]),a:void 0===r[5]?1:Number(r[5])/(r[6]?100:1)}):{h:0,s:0,v:0,a:1}},H=E,M=function(e){var r=e.s,t=e.l;return{h:e.h,s:(r*=(t<50?t:100-t)/100)>0?2*r/(t+r)*100:0,v:t+r,a:e.a}},N=function(e){var r=e.s,t=e.v,o=e.a,n=(200-r)*t/100;return{h:b(e.h),s:b(n>0&&n<200?r*t/100/(n<=100?n:200-n)*100:0),l:b(n/2),a:b(o,2)}},w=function(e){var r=N(e);return"hsl("+r.h+", "+r.s+"%, "+r.l+"%)"},y=function(e){var r=N(e);return"hsla("+r.h+", "+r.s+"%, "+r.l+"%, "+r.a+")"},q=function(e){var r=e.h,t=e.s,o=e.v,n=e.a;r=r/360*6,t/=100,o/=100;var a=Math.floor(r),l=o*(1-t),u=o*(1-(r-a)*t),c=o*(1-(1-r+a)*t),i=a%6;return{r:b(255*[o,u,l,l,c,o][i]),g:b(255*[c,o,o,u,l,l][i]),b:b(255*[l,l,c,o,o,u][i]),a:b(n,2)}},k=function(e){var r=/hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);return r?K({h:x(r[1],r[2]),s:Number(r[3]),v:Number(r[4]),a:void 0===r[5]?1:Number(r[5])/(r[6]?100:1)}):{h:0,s:0,v:0,a:1}},O=k,I=function(e){var r=/rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);return r?B({r:Number(r[1])/(r[2]?100/255:1),g:Number(r[3])/(r[4]?100/255:1),b:Number(r[5])/(r[6]?100/255:1),a:void 0===r[7]?1:Number(r[7])/(r[8]?100:1)}):{h:0,s:0,v:0,a:1}},j=I,z=function(e){var r=e.toString(16);return r.length<2?"0"+r:r},B=function(e){var r=e.r,t=e.g,o=e.b,n=e.a,a=Math.max(r,t,o),l=a-Math.min(r,t,o),u=l?a===r?(t-o)/l:a===t?2+(o-r)/l:4+(r-t)/l:0;return{h:b(60*(u<0?u+6:u)),s:b(a?l/a*100:0),v:b(a/255*100),a:n}},K=function(e){return{h:b(e.h),s:b(e.s),v:b(e.v),a:b(e.a,2)}},A=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(r){var t=r.hue,o=r.onChange,n=g(["react-colorful__hue",r.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:n},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,{onMove:function(e){o({h:360*e.left})},onKey:function(e){o({h:f(t+360*e.left,0,360)})},"aria-label":"Hue","aria-valuetext":b(t)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,{className:"react-colorful__hue-pointer",left:t/360,color:w({h:t,s:100,v:100,a:1})})))}),L=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(r){var t=r.hsva,o=r.onChange,n={backgroundColor:w({h:t.h,s:100,v:100,a:1})};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-colorful__saturation",style:n},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,{onMove:function(e){o({s:100*e.left,v:100-100*e.top})},onKey:function(e){o({s:f(t.s+100*e.left,0,100),v:f(t.v-100*e.top,0,100)})},"aria-label":"Color","aria-valuetext":"Saturation "+b(t.s)+"%, Brightness "+b(t.v)+"%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,{className:"react-colorful__saturation-pointer",top:1-t.v/100,left:t.s/100,color:w(t)})))}),D=function(e,r){if(e===r)return!0;for(var t in e)if(e[t]!==r[t])return!1;return!0},F=function(e,r){return e.replace(/\s/g,"")===r.replace(/\s/g,"")};function S(e,r,l){var u=i(l),c=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return e.toHsva(r)}),s=c[0],f=c[1],v=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({color:r,hsva:s});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!e.equal(r,v.current.color)){var t=e.toHsva(r);v.current={hsva:t,color:r},f(t)}},[r,e]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var r;D(s,v.current.hsva)||e.equal(r=e.fromHsva(s),v.current.color)||(v.current={hsva:s,color:r},u(r))},[s,e,u]);var d=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){f(function(r){return Object.assign({},r,e)})},[]);return[s,d]}var P,T=function(){return s||( true?__webpack_require__.nc:void 0)},X=function(e){s=e},Y=function(){c(function(){if("undefined"!=typeof document&&!P){(P=document.createElement("style")).innerHTML='.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}';var e=T();e&&P.setAttribute("nonce",e),document.head.appendChild(P)}},[])},$=function(r){var t=r.className,o=r.colorModel,n=r.color,a=void 0===n?o.defaultColor:n,c=r.onChange,i=u(r,["className","colorModel","color","onChange"]);Y();var s=S(o,a,c),f=s[0],v=s[1],d=g(["react-colorful",t]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",l({},i,{className:d}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(L,{hsva:f,onChange:v}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A,{hue:f.h,onChange:v,className:"react-colorful__last-control"}))},R={defaultColor:"000",toHsva:function(e){return B(C(e))},fromHsva:function(e){return t=(r=q(e)).g,o=r.b,"#"+z(r.r)+z(t)+z(o);var r,t,o},equal:function(e,r){return e.toLowerCase()===r.toLowerCase()||D(C(e),C(r))}},G=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:R}))},J=function(r){var t=r.className,o=r.hsva,n=r.onChange,a={backgroundImage:"linear-gradient(90deg, "+y(Object.assign({},o,{a:0}))+", "+y(Object.assign({},o,{a:1}))+")"},l=g(["react-colorful__alpha",t]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:l},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-colorful__alpha-gradient",style:a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,{onMove:function(e){n({a:e.left})},onKey:function(e){n({a:f(o.a+e.left)})},"aria-label":"Alpha","aria-valuetext":b(100*o.a)+"%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,{className:"react-colorful__alpha-pointer",left:o.a,color:y(o)})))},Q=function(r){var t=r.className,o=r.colorModel,n=r.color,a=void 0===n?o.defaultColor:n,c=r.onChange,i=u(r,["className","colorModel","color","onChange"]);Y();var s=S(o,a,c),f=s[0],v=s[1],d=g(["react-colorful",t]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",l({},i,{className:d}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(L,{hsva:f,onChange:v}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A,{hue:f.h,onChange:v}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(J,{hsva:f,onChange:v,className:"react-colorful__last-control"}))},U={defaultColor:{h:0,s:0,l:0,a:1},toHsva:M,fromHsva:N,equal:D},V=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Q,l({},r,{colorModel:U}))},W={defaultColor:"hsla(0, 0%, 0%, 1)",toHsva:E,fromHsva:y,equal:F},Z=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Q,l({},r,{colorModel:W}))},ee={defaultColor:{h:0,s:0,l:0},toHsva:function(e){return M({h:e.h,s:e.s,l:e.l,a:1})},fromHsva:function(e){return{h:(r=N(e)).h,s:r.s,l:r.l};var r},equal:D},re=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:ee}))},te={defaultColor:"hsl(0, 0%, 0%)",toHsva:H,fromHsva:w,equal:F},oe=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:te}))},ne={defaultColor:{h:0,s:0,v:0,a:1},toHsva:function(e){return e},fromHsva:K,equal:D},ae=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Q,l({},r,{colorModel:ne}))},le={defaultColor:"hsva(0, 0%, 0%, 1)",toHsva:k,fromHsva:function(e){var r=K(e);return"hsva("+r.h+", "+r.s+"%, "+r.v+"%, "+r.a+")"},equal:F},ue=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Q,l({},r,{colorModel:le}))},ce={defaultColor:{h:0,s:0,v:0},toHsva:function(e){return{h:e.h,s:e.s,v:e.v,a:1}},fromHsva:function(e){var r=K(e);return{h:r.h,s:r.s,v:r.v}},equal:D},ie=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:ce}))},se={defaultColor:"hsv(0, 0%, 0%)",toHsva:O,fromHsva:function(e){var r=K(e);return"hsv("+r.h+", "+r.s+"%, "+r.v+"%)"},equal:F},fe=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:se}))},ve={defaultColor:{r:0,g:0,b:0,a:1},toHsva:B,fromHsva:q,equal:D},de=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Q,l({},r,{colorModel:ve}))},he={defaultColor:"rgba(0, 0, 0, 1)",toHsva:I,fromHsva:function(e){var r=q(e);return"rgba("+r.r+", "+r.g+", "+r.b+", "+r.a+")"},equal:F},me=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Q,l({},r,{colorModel:he}))},ge={defaultColor:{r:0,g:0,b:0},toHsva:function(e){return B({r:e.r,g:e.g,b:e.b,a:1})},fromHsva:function(e){return{r:(r=q(e)).r,g:r.g,b:r.b};var r},equal:D},pe=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:ge}))},be={defaultColor:"rgb(0, 0, 0)",toHsva:j,fromHsva:function(e){var r=q(e);return"rgb("+r.r+", "+r.g+", "+r.b+")"},equal:F},_e=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement($,l({},r,{colorModel:be}))},Ce=/^#?[0-9A-F]{3}$/i,xe=/^#?[0-9A-F]{6}$/i,Ee=function(e){return xe.test(e)||Ce.test(e)},He=function(e){return e.replace(/([^0-9A-F]+)/gi,"").substr(0,6)},Me=function(r){var n=r.color,c=void 0===n?"":n,s=r.onChange,f=r.onBlur,v=r.prefixed,d=u(r,["color","onChange","onBlur","prefixed"]),h=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return He(c)}),m=h[0],g=h[1],p=i(s),b=i(f),_=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){var r=He(e.target.value);g(r),Ee(r)&&p("#"+r)},[p]),C=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){Ee(e.target.value)||g(He(c)),b(e)},[c,b]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){g(He(c))},[c]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",l({},d,{value:(v?"#":"")+m,spellCheck:"false",onChange:_,onBlur:C}))};
//# sourceMappingURL=index.module.js.map


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ControlsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Sign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Overlay = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tpadding: 15px;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tpadding: 15px;\n\tborder-radius: 13px;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey900);
var ControlsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\n\t.react-colorful {\n\t\twidth: 175px;\n\t\theight: 175px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\n\t.react-colorful {\n\t\twidth: 175px;\n\t\theight: 175px;\n\t}\n"])));
var InputWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: ", ";\n\theight: 34px;\n\tmargin: ", ";\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 34px;\n\tcolor: ", ";\n\n\tinput {\n\t\tbox-sizing: border-box;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: inherit;\n\t\theight: inherit;\n\t\tpadding: 10px;\n\t\tborder: 1px solid transparent;\n\t\toutline: 0;\n\t\tborder-radius: inherit;\n\t\tbackground-color: inherit;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\tline-height: 19px;\n\t\ttext-transform: uppercase;\n\t\tcolor: inherit;\n\t\t-webkit-appearance: none;\n\n\t\t", "\n\n\t\t&:focus {\n\t\t\tborder-color: ", "\n\t\t}\n\n\t\t::-ms-clear {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: ", ";\n\theight: 34px;\n\tmargin: ", ";\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 16px;\n\tline-height: 34px;\n\tcolor: ", ";\n\n\tinput {\n\t\tbox-sizing: border-box;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: inherit;\n\t\theight: inherit;\n\t\tpadding: 10px;\n\t\tborder: 1px solid transparent;\n\t\toutline: 0;\n\t\tborder-radius: inherit;\n\t\tbackground-color: inherit;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\tline-height: 19px;\n\t\ttext-transform: uppercase;\n\t\tcolor: inherit;\n\t\t-webkit-appearance: none;\n\n\t\t",
    "\n\n\t\t&:focus {\n\t\t\tborder-color: ", "\n\t\t}\n\n\t\t::-ms-clear {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n"])), function (_a) {
    var isOpacity = _a.isOpacity;
    return isOpacity ? '70px' : '100px';
}, function (_a) {
    var isOpacity = _a.isOpacity;
    return isOpacity ? '0 auto' : '0 0 20px';
}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 10), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var isOpacity = _a.isOpacity;
    return isOpacity
        ? 'padding-right: 25px;'
        : 'padding-left: 20px;';
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var ButtonsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 17px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 17px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n"], ["\n\tbox-sizing: border-box;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tcursor: pointer;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450);
var Sign = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 1;\n\n\t&:first-child {\n\t\tleft: 7px;\n\t}\n\n\t&:last-child {\n\t\tright: 7px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 1;\n\n\t&:first-child {\n\t\tleft: 7px;\n\t}\n\n\t&:last-child {\n\t\tright: 7px;\n\t}\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonsUndoRedo__ = __webpack_require__(1557);


var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.history, undos = _b.undos, redos = _b.redos, editableTextFields = _a.editableTextFields, _c = _a.activeItem, id = _c.id, page = _c.page;
    return {
        isUndoDisabled: undos.length === 0,
        isRedoDisabled: redos.length === 0,
        isSomeTextFieldActive: id && page && !!editableTextFields[page][id],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonsUndoRedo__["a" /* default */]));


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_styles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var ButtonsUndoRedo = function (_a) {
    var isUndoDisabled = _a.isUndoDisabled, isRedoDisabled = _a.isRedoDisabled, isBothDisabled = _a.isBothDisabled, isSomeTextFieldActive = _a.isSomeTextFieldActive, dispatch = _a.dispatch;
    var config = [
        {
            icon: 'iconset_uprez_undo',
            isDisabled: isUndoDisabled,
            action: __WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["X" /* undo */],
        },
        {
            icon: 'iconset_uprez_redo',
            action: __WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["v" /* redo */],
            isDisabled: isRedoDisabled,
        },
    ];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isBothDisabled || isSomeTextFieldActive) {
            // return if some text field is active to prevent conflicts with built-in history in slate.js library
            return;
        }
        var handleKeyDown = function (e) {
            var isUndoShortcut = (e.ctrlKey || e.metaKey) && e.key === 'z';
            var isRedoShortcut = ((e.ctrlKey || e.metaKey) && e.key === 'y') ||
                (e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'Z';
            if (!isUndoDisabled && isUndoShortcut) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["X" /* undo */])());
            }
            if (!isRedoDisabled && isRedoShortcut) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["v" /* redo */])());
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isBothDisabled, isUndoDisabled, isRedoDisabled, isSomeTextFieldActive]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["a" /* ButtonsGroup */], null, config.map(function (_a) {
        var icon = _a.icon, isDisabled = _a.isDisabled, action = _a.action;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header_styles__["b" /* HeaderButton */], { key: icon, iconWidth: "20px", iconHeight: "20px", className: __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] + " " + __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["l" /* SPREAD_BACKGROUND_CLICK_CLASSNAME */], disabled: isDisabled || isBothDisabled, onClick: function () { return dispatch(action()); } }, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon(icon)));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonsUndoRedo);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column__ = __webpack_require__(1559);


var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.thumbnails, isDisplayed = _b.isDisplayed, width = _b.width, _c = _a.pagesController, currentSpreadIndex = _c.currentSpreadIndex, spreads = _c.spreads, accessiblePages = _c.accessiblePages, activeItem = _a.activeItem, _d = _a.pagesSelection, isActive = _d.isActive, spreadIndices = _d.spreadIndices, isAccessibleVersion = _a.isAccessibleVersion;
    return {
        isDisplayed: isDisplayed,
        width: width,
        currentSpreadIndex: currentSpreadIndex,
        spreads: spreads,
        isSomeEditableItemActive: !!activeItem.id,
        isPagesSelectionActive: isActive,
        selectedSpreadIndices: spreadIndices,
        accessiblePages: accessiblePages,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column__["a" /* default */]));


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_Thumbnails_Column_DraggableItem__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_Thumbnails_Column_Toggle__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_Thumbnails_Column_ButtonsPanel__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typings_dnd__ = __webpack_require__(101);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









var ThumbnailsColumn = function (_a) {
    var isDisplayed = _a.isDisplayed, width = _a.width, currentSpreadIndex = _a.currentSpreadIndex, spreads = _a.spreads, isSomeEditableItemActive = _a.isSomeEditableItemActive, isPagesSelectionActive = _a.isPagesSelectionActive, selectedSpreadIndices = _a.selectedSpreadIndices, dispatch = _a.dispatch, isAccessibleVersion = _a.isAccessibleVersion, accessiblePages = _a.accessiblePages;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), activeDraggingItem = _b[0], setActiveDraggingItem = _b[1];
    var listElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var handleDragStart = function (_a) {
        var source = _a.source;
        if (isPagesSelectionActive) {
            setActiveDraggingItem(source.index);
        }
    };
    var handleDragEnd = function (_a) {
        var source = _a.source, destination = _a.destination;
        if (isPagesSelectionActive) {
            setActiveDraggingItem(null);
        }
        var spreadsToMove = isPagesSelectionActive
            ? selectedSpreadIndices
            : [source.index];
        if (!destination || spreadsToMove.includes(destination.index)) {
            return;
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["r" /* movePages */])(spreadsToMove, destination.index));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isDisplayed || isSomeEditableItemActive || isPagesSelectionActive) {
            return;
        }
        var handleKeyDown = function (e) {
            if (__WEBPACK_IMPORTED_MODULE_7__utils_keys__["a" /* default */].isArrowUp(e.key)) {
                e.preventDefault();
                if (currentSpreadIndex > 0) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["b" /* changePageSpread */])(currentSpreadIndex - 1));
                }
            }
            if (__WEBPACK_IMPORTED_MODULE_7__utils_keys__["a" /* default */].isArrowDown(e.key)) {
                e.preventDefault();
                if (currentSpreadIndex < spreads.length - 1) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["b" /* changePageSpread */])(currentSpreadIndex + 1));
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentSpreadIndex, spreads, isDisplayed, isSomeEditableItemActive, isPagesSelectionActive]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Inner */], { ref: listElement, isDisplayed: isDisplayed, style: { width: width + "px" } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["a" /* DragDropContext */], { onDragStart: handleDragStart, onDragEnd: handleDragEnd },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["c" /* Droppable */], { droppableId: "thumbnails", type: __WEBPACK_IMPORTED_MODULE_8__typings_dnd__["a" /* DndItemTypes */].EDITOR_THUMBNAIL, isDropDisabled: isAccessibleVersion }, function (provided, snapshot) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* List */], __assign({ ref: provided.innerRef }, provided.droppableProps, { isDraggingOver: snapshot.isDraggingOver }),
                    !isAccessibleVersion
                        ? spreads.map(function (spread, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_Thumbnails_Column_DraggableItem__["a" /* default */], { key: spread[0], spread: spread, spreadIndex: index, activeDraggingPosition: activeDraggingItem })); })
                        : Array.from({ length: accessiblePages }).map(function (_, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_Thumbnails_Column_DraggableItem__["a" /* default */], { key: index, spread: [index], spreadIndex: index, activeDraggingPosition: activeDraggingItem })); }),
                    provided.placeholder)); })),
            !isAccessibleVersion ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_Thumbnails_Column_ButtonsPanel__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { paddingTop: '20px' } })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_Thumbnails_Column_Toggle__["a" /* default */], { listElement: listElement })));
};
/* harmony default export */ __webpack_exports__["a"] = (ThumbnailsColumn);


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCallback; });
/* unused harmony export useCallbackOne */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useMemo; });
/* unused harmony export useMemoOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(initial);
  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;




/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_create__);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1563);

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1564);
var $Object = __webpack_require__(90).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(155);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(1571) });


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1566);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(615);
var createDesc = __webpack_require__(1570);
module.exports = __webpack_require__(156) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(156) && !__webpack_require__(259)(function () {
  return Object.defineProperty(__webpack_require__(616)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(258);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(369);
var dPs = __webpack_require__(1572);
var enumBugKeys = __webpack_require__(622);
var IE_PROTO = __webpack_require__(621)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(616)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1581).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(615);
var anObject = __webpack_require__(369);
var getKeys = __webpack_require__(260);

module.exports = __webpack_require__(156) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(617);
var toIObject = __webpack_require__(370);
var arrayIndexOf = __webpack_require__(1575)(false);
var IE_PROTO = __webpack_require__(621)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1574 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(370);
var toLength = __webpack_require__(1576);
var toAbsoluteIndex = __webpack_require__(1577);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(620);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(620);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(90);
var global = __webpack_require__(257);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(1579) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(257).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__);

function _extends() {
  _extends = __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default.a || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1584);
module.exports = __webpack_require__(90).Object.assign;


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(155);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1585) });


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(156);
var getKeys = __webpack_require__(260);
var gOPS = __webpack_require__(1586);
var pIE = __webpack_require__(624);
var toObject = __webpack_require__(625);
var IObject = __webpack_require__(618);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(259)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1586 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport batch */
/* unused harmony reexport useDispatch */
/* unused harmony reexport createDispatchHook */
/* unused harmony reexport useSelector */
/* unused harmony reexport createSelectorHook */
/* unused harmony reexport useStore */
/* unused harmony reexport createStoreHook */
/* unused harmony reexport shallowEqual */










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(371);





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1590)();
}


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1591);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(629);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1599);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(632);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(632);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(633);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1600);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(634);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDispatchHook */
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(635);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch =
/*#__PURE__*/
createDispatchHook();

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSelectorHook */
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useReduxContext__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(128);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {
      throw new Error("You must pass a selector to useSelectors");
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    return useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector =
/*#__PURE__*/
createSelectorHook();

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return offset; });
/* unused harmony export shrink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_invariant__ = __webpack_require__(309);


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : Object(__WEBPACK_IMPORTED_MODULE_0_tiny_invariant__["a" /* default */])(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};




/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1607);

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1608);
module.exports = __webpack_require__(90).Object.values;


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(155);
var $values = __webpack_require__(1609)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(156);
var getKeys = __webpack_require__(260);
var toIObject = __webpack_require__(370);
var isEnum = __webpack_require__(624).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1611);

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1612);
module.exports = __webpack_require__(90).Object.keys;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(625);
var $keys = __webpack_require__(260);

__webpack_require__(1613)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(155);
var core = __webpack_require__(90);
var fails = __webpack_require__(259);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ __webpack_exports__["a"] = (rafSchd);


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1616);

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1617);
module.exports = __webpack_require__(90).Date.now;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(155);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1619);

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1620);
module.exports = __webpack_require__(90).Number.isInteger;


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(155);

$export($export.S, 'Number', { isInteger: __webpack_require__(1621) });


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(258);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Editor_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_reducer_thumbnails__ = __webpack_require__(328);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\tbackground-color: ", ";\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\tbackground-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey900);
var Inner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: ", "px;\n\tmax-width: ", "px;\n\toverflow: hidden;\n\tvisibility: ", ";\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: ", "px;\n\tmax-width: ", "px;\n\toverflow: hidden;\n\tvisibility: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__containers_Editor_reducer_thumbnails__["c" /* MIN_WIDTH */], __WEBPACK_IMPORTED_MODULE_3__containers_Editor_reducer_thumbnails__["b" /* MAX_WIDTH */], function (_a) {
    var isDisplayed = _a.isDisplayed;
    return isDisplayed ? 'visible' : 'hidden';
});
var List = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t", "\n"], ["\n\tflex: 1 1 auto;\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__Editor_styles__["j" /* getEditorScrollStyles */])());

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column_DraggableItem__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_url__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_selectionManager__ = __webpack_require__(462);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var mapStateToProps = function (state, ownProps) {
    var galleryConfig = state.galleryInfos.config, _a = state.editor, thumbnails = _a.thumbnails, _b = _a.pagesController, currentSpreadIndex = _b.currentSpreadIndex, spreads = _b.spreads, editableData = _a.configs.generalData.editablePublication, _c = _a.paths, thumbnailPath = _c.thumbnailPath, spreadPath = _c.spreadPath, version = _a.version, pagesSelection = _a.pagesSelection, isAccessibleVersion = _a.isAccessibleVersion;
    var resourceId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().tempGId;
    var spread = ownProps.spread, spreadIndex = ownProps.spreadIndex, activeDraggingPosition = ownProps.activeDraggingPosition;
    var thumbnailsData = [];
    if (spreadPath && !isAccessibleVersion) {
        var leftPage = thumbnails.items[spread[0]];
        var rightPage = thumbnails.items[spread[1]];
        var selfVersion = leftPage.version || 0;
        if (rightPage) {
            selfVersion += (rightPage.version || 0);
        }
        thumbnailsData.push(__assign({}, thumbnails.items[spread[0]], { imageSrc: __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, resourceId, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* getPageHtmlPath */])(spreadPath, spreadIndex + 1) + "?version=" + (version + selfVersion)) }));
    }
    else if (isAccessibleVersion) {
        var numberOfItems = Object.keys(thumbnails.items).length;
        if (spreadIndex < numberOfItems) {
            thumbnailsData = [__assign({}, thumbnails.items[spreadIndex + 1], { extPage: false, imageSrc: __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, resourceId, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* getPageHtmlPath */])(thumbnailPath, spreadIndex + 1) + "?version=" + version) })];
        }
        else {
            var labelKey = '1';
            thumbnailsData = [{
                    extPage: false,
                    imageSrc: '',
                    label: thumbnails.items[labelKey].label,
                    position: spreadIndex + 1,
                }];
        }
    }
    else {
        thumbnailsData = spread.map(function (page) {
            var _a = thumbnails.items[page], position = _a.position, _b = _a.version, selfVersion = _b === void 0 ? 0 : _b;
            return __assign({}, thumbnails.items[page], { imageSrc: __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getEditorResourceUrl(galleryConfig, resourceId, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* getPageHtmlPath */])(thumbnailPath, position) + "?version=" + (version + selfVersion)) });
        });
    }
    var isActive = pagesSelection.isActive
        ? pagesSelection.spreadIndices.includes(spreadIndex)
        : spreadIndex === currentSpreadIndex;
    return {
        thumbnailsData: thumbnailsData,
        isActive: isActive,
        isEditable: !isAccessibleVersion ? spread.some(function (page) { return Object.keys(editableData).includes(page.toString()); }) : true,
        isPagesSelectionActive: pagesSelection.isActive,
        selectedPagesNumber: isActive ? pagesSelection.spreadIndices.length : undefined,
        activeDraggingPosition: isActive ? activeDraggingPosition : null,
        isAllPagesSelected: pagesSelection.spreadIndices.length === spreads.length,
        isGapInSelectedPages: isActive && __WEBPACK_IMPORTED_MODULE_4__utils_selectionManager__["a" /* default */].isGapInSelectedItems(pagesSelection.spreadIndices),
        isPagesSelectionAvailable: spreads.length > 1,
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column_DraggableItem__["a" /* default */]));


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item_styles__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item_ImageWrapper__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item_ItemInfo__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var DraggableItem = function (_a) {
    var spreadIndex = _a.spreadIndex, thumbnailsData = _a.thumbnailsData, isActive = _a.isActive, isEditable = _a.isEditable, isPagesSelectionActive = _a.isPagesSelectionActive, activeDraggingPosition = _a.activeDraggingPosition, isAllPagesSelected = _a.isAllPagesSelected, isGapInSelectedPages = _a.isGapInSelectedPages, isPagesSelectionAvailable = _a.isPagesSelectionAvailable, selectedPagesNumber = _a.selectedPagesNumber, dispatch = _a.dispatch, isAccessibleVersion = _a.isAccessibleVersion;
    var thumbnailElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var handleClick = function (e) {
        var isPagesSelectionMode = isPagesSelectionAvailable && (e.ctrlKey || e.metaKey || e.shiftKey);
        if (isPagesSelectionMode) {
            if (!isPagesSelectionActive) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["N" /* setPagesSelection */])());
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["H" /* selectPageSpread */])(spreadIndex, e.ctrlKey || e.metaKey, e.shiftKey));
        }
        else {
            if (isPagesSelectionActive) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["C" /* resetPagesSelection */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["b" /* changePageSpread */])(spreadIndex));
            }
            else if (!isActive) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_actions__["b" /* changePageSpread */])(spreadIndex));
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        // is needed for automatic scrolling to active thumbnail after pages manipulation (move/remove/duplicate)
        if (isActive && thumbnailElement.current) {
            thumbnailElement.current.focus();
        }
    }, [isActive]);
    var isDragDisabled = isAccessibleVersion || isPagesSelectionActive && (!isActive ||
        isGapInSelectedPages ||
        isAllPagesSelected);
    var isBlurred = isPagesSelectionActive &&
        isActive &&
        activeDraggingPosition &&
        spreadIndex !== activeDraggingPosition;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_beautiful_dnd__["b" /* Draggable */], { draggableId: spreadIndex.toString(), index: spreadIndex, isDragDisabled: isDragDisabled }, function (provided, _a) {
        var isDragging = _a.isDragging;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item_styles__["f" /* Wrapper */], __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { type: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ThumbnailType */].COLUMN, isActive: isActive, isBlurred: isBlurred, onClick: handleClick }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item_styles__["d" /* Inner */], { ref: thumbnailElement, tabIndex: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Item_ImageWrapper__["a" /* default */], { thumbnailsData: thumbnailsData }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Item_ItemInfo__["a" /* default */], { spreadIndex: spreadIndex, label: thumbnailsData[0].label }),
                isEditable && !isPagesSelectionActive &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item_styles__["b" /* IconEdit */], null, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_uprez_edit')),
                thumbnailsData[0].extPage && !isPagesSelectionActive &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item_styles__["c" /* IconReference */], null, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_uprez_reference')),
                isPagesSelectionActive && !isDragging &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item_styles__["a" /* IconCheck */], { isChecked: isActive }),
                isPagesSelectionActive && selectedPagesNumber && selectedPagesNumber > 1 && isDragging &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item_styles__["e" /* SelectedNumber */], null, selectedPagesNumber))));
    }));
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["memo"](DraggableItem));


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column_Toggle__ = __webpack_require__(1626);


var mapStateToProps = function (state) {
    var isDisplayed = state.editor.thumbnails.isDisplayed;
    return {
        isOpened: isDisplayed,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column_Toggle__["a" /* default */]));


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_reducer_thumbnails__ = __webpack_require__(328);





var Toggle = function (_a) {
    var isOpened = _a.isOpened, listElement = _a.listElement, dispatch = _a.dispatch;
    var toggleElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var resizeData = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]({
        isResizing: false,
        startX: 0,
        initialWidth: __WEBPACK_IMPORTED_MODULE_4__containers_Editor_reducer_thumbnails__["a" /* INITIAL_WIDTH */],
        diff: 0,
    });
    var handlePointerDown = function (e) {
        e.preventDefault();
        var clientX = e.clientX, pointerId = e.pointerId;
        if (toggleElement.current) {
            toggleElement.current.setPointerCapture(pointerId);
        }
        resizeData.current.isResizing = true;
        resizeData.current.startX = clientX;
    };
    var handlePointerMove = function (_a) {
        var clientX = _a.clientX;
        var _b = resizeData.current, isResizing = _b.isResizing, startX = _b.startX, initialWidth = _b.initialWidth;
        if (!isResizing) {
            return;
        }
        if (!isOpened) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["W" /* toggleThumbnails */])());
        }
        var diff = clientX - startX;
        resizeData.current.diff = diff;
        if (listElement.current) {
            var isClosed = startX < initialWidth;
            // if thumbnails column was previously closed its width should be set to MIN_WIDTH to prevent a visual bug when moving a pointer to right
            // resizeData.initialWidth can't be set to MIN_WIDTH in handlePointerUp because it won't allow to open hidden thubmnails by click on toggle
            var correctedInitialWidth = isClosed
                ? __WEBPACK_IMPORTED_MODULE_4__containers_Editor_reducer_thumbnails__["c" /* MIN_WIDTH */]
                : initialWidth;
            var newWidth = correctedInitialWidth + diff;
            listElement.current.style.width = newWidth + "px";
        }
    };
    var handlePointerUp = function () {
        var _a = resizeData.current, diff = _a.diff, initialWidth = _a.initialWidth;
        var isClick = Math.abs(diff) <= 2;
        var shouldHideThumbnails = isOpened &&
            initialWidth + diff <= __WEBPACK_IMPORTED_MODULE_4__containers_Editor_reducer_thumbnails__["d" /* WIDTH_TO_HIDE */] &&
            diff < 0;
        if (isClick || shouldHideThumbnails) {
            var newWidth = isOpened ? __WEBPACK_IMPORTED_MODULE_4__containers_Editor_reducer_thumbnails__["c" /* MIN_WIDTH */] : initialWidth;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["W" /* toggleThumbnails */])());
            // is needed to update Spread sizes
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["S" /* setThumbnailsWidth */])(newWidth));
            listElement.current.style.width = newWidth + "px";
        }
        else {
            resizeData.current.initialWidth = listElement.current.clientWidth;
            // is needed to update Spread sizes
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["S" /* setThumbnailsWidth */])(listElement.current.clientWidth));
        }
        resizeData.current.isResizing = false;
        resizeData.current.startX = 0;
        resizeData.current.diff = 0;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Wrapper */], { type: "button", ref: toggleElement, onPointerDown: handlePointerDown, onPointerMove: handlePointerMove, onPointerUp: handlePointerUp, 
        // is needed to prevent unwanted clicks on thumbnail item when close thumbnails and on spread content when open thumbnails
        onTouchEnd: function (e) { return e.preventDefault(); }, onDragStart: function () { return false; } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Inner */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Icon */], { isOpened: isOpened }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_triangle-2')))));
};
/* harmony default export */ __webpack_exports__["a"] = (Toggle);


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Inner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 100%;\n\tz-index: 10;\n\ttransform: translateY(-50%);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin: 0;\n\tpadding: 6px 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\ttouch-action: none;\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 100%;\n\tz-index: 10;\n\ttransform: translateY(-50%);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin: 0;\n\tpadding: 6px 0;\n\tborder: 0;\n\toutline: 0;\n\tbackground-color: transparent;\n\tcursor: pointer;\n\ttouch-action: none;\n"])));
var Inner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 0 50% 50% 0;\n\tbackground-color: ", ";\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tborder: 11px solid transparent;\n\t\tborder-left: 17px solid ", ";\n\t}\n\n\t&::before {\n\t\ttop: -10px;\n\t}\n\n\t&::after {\n\t\ttop: 12px;\n\t}\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 0 50% 50% 0;\n\tbackground-color: ", ";\n\n\t&::before,\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tborder: 11px solid transparent;\n\t\tborder-left: 17px solid ", ";\n\t}\n\n\t&::before {\n\t\ttop: -10px;\n\t}\n\n\t&::after {\n\t\ttop: 12px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey900, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey900);
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: ", ";\n\t\ttransform: ", ";\n        margin: 0;\n\t}\n"], ["\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: ", ";\n\t\ttransform: ", ";\n        margin: 0;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 77), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey900, function (_a) {
    var isOpened = _a.isOpened;
    return "rotate(" + (isOpened ? '90deg' : '270deg') + ")";
});

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column_ButtonsPanel__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);



var mapStateToProps = function (state) {
    var _a = state.editor, type = _a.type, spreads = _a.pagesController.spreads;
    return {
        isButtonRemoveDisplayed: spreads.length > 1,
        isButtonDuplicateDisplayed: type === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EditorType */].INDESIGN,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Thumbnails_Column_ButtonsPanel__["a" /* default */]));


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ButtonCombine__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_ButtonRemoveSpread__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_ButtonDuplicateSpread__ = __webpack_require__(1635);





var ButtonsPanel = function (_a) {
    var isButtonDuplicateDisplayed = _a.isButtonDuplicateDisplayed, isButtonRemoveDisplayed = _a.isButtonRemoveDisplayed;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Wrapper */], null,
        isButtonDuplicateDisplayed && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_ButtonDuplicateSpread__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ButtonCombine__["a" /* default */], null),
        isButtonRemoveDisplayed && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_ButtonRemoveSpread__["a" /* default */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonsPanel);


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Thumbnails_Column_ButtonsPanel_styles__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_CombinePanel__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var ButtonCombine = function () {
    var _a = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isCombinePanelDisplayed = _a[0], setIsCombinePanelDisplayed = _a[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Thumbnails_Column_ButtonsPanel_styles__["a" /* Button */], { iconWidth: "20px", iconHeight: "20px", onClick: function () { return setIsCombinePanelDisplayed(true); } }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_uprez_plus_in_circle')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_CombinePanel__["a" /* default */], { importManagerId: "combine", isDisplayed: isCombinePanelDisplayed, onCancel: function () { return setIsCombinePanelDisplayed(false); } })));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonCombine);


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);




var mapStateToProps = function (state, ownProps) {
    var byId = state.importManager.byId, selection = state.selection, combineOptions = state.profile.combineOptions;
    var isDisplayed = ownProps.isDisplayed, importManagerId = ownProps.importManagerId;
    return {
        isDisplayed: isDisplayed,
        isImporting: !!byId[importManagerId],
        hasFromSelectionPicker: selection.resources.length > 0 && !__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].isEmbedMode(),
        canSelectPublicationPages: [__WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].CombineOption.ADVANCED, __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].CombineOption.MULTISELECT, __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].CombineOption.PLAYLIST].includes(combineOptions),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_CombinePanel__["a" /* default */]));


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ResourceSelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResourceSelector__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_CombinePanel_SpreadsSelector__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_ResourceSelector_DrivePicker_FromApp__ = __webpack_require__(347);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};














var desktopFileExtensions = __spread(__WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].publicationExtensions, __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].imageWithSvgExtensions, __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].videoExtensions);
var CombinePanel = function (_a) {
    var importManagerId = _a.importManagerId, isDisplayed = _a.isDisplayed, isImporting = _a.isImporting, hasFromSelectionPicker = _a.hasFromSelectionPicker, canSelectPublicationPages = _a.canSelectPublicationPages, onCancel = _a.onCancel, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), resource = _b[0], setResource = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isOptionsDisplayed = _c[0], setIsOptionsDisplayed = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isSpreadsSelectorDisplayed = _d[0], setIsSpreadsSelectorDisplayed = _d[1];
    var handleCancelClick = function () {
        if (isImporting) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__containers_ImportManager_actions__["i" /* removeFileFromImport */])(importManagerId));
        }
        onCancel();
    };
    var handleFullPublicationClick = function () {
        if (resource) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["d" /* createCombo */])(resource));
            setIsOptionsDisplayed(false);
            onCancel();
        }
    };
    var handlePagesSelectionClick = function () {
        setIsSpreadsSelectorDisplayed(true);
        setIsOptionsDisplayed(false);
        onCancel();
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (resource && !isImporting && !__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].isPlaylistMode()) {
            if (resource.type === __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].DriveItemType.Publication &&
                resource.format && resource.format.includes(__WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationFormat.EPUB) &&
                canSelectPublicationPages && resource.format !== __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].PublicationFormat.EPUB_PLAYLIST) {
                setIsOptionsDisplayed(true);
            }
            else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["d" /* createCombo */])(resource));
                onCancel();
            }
        }
        else if (__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].isPlaylistMode() && resource && !isImporting) {
            setIsSpreadsSelectorDisplayed(true);
            setIsOptionsDisplayed(false);
            onCancel();
        }
    }, [resource, isImporting, canSelectPublicationPages, __WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].isPlaylistMode()]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed && !isOptionsDisplayed && !isSpreadsSelectorDisplayed && !__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].isPlaylistMode(), label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.combine'), onCancel: handleCancelClick, actionButtonColor: __WEBPACK_IMPORTED_MODULE_11__utils_styles_constants__["b" /* NewStyleColor */].Blue450, theme: __WEBPACK_IMPORTED_MODULE_2__Popup__["a" /* PopupTheme */].DARK },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* PopupBodyWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ResourceSelector__["a" /* default */], { id: importManagerId, fileExtensions: desktopFileExtensions, isFileExtensionsDisplayed: false, isValidResourceFromApp: __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].isValidResourceForPublication, isFromSelection: hasFromSelectionPicker, isPublicationDependency: true, actionButtonColor: __WEBPACK_IMPORTED_MODULE_11__utils_styles_constants__["b" /* NewStyleColor */].Blue450, theme: __WEBPACK_IMPORTED_MODULE_5__ResourceSelector__["a" /* ResourceSelectorTheme */].DARK, onSelect: function (_a) {
                        var _b = __read(_a, 1), item = _b[0];
                        return setResource(item);
                    } }))),
        isDisplayed && !isSpreadsSelectorDisplayed && __WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].isPlaylistMode() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__containers_ResourceSelector_DrivePicker_FromApp__["a" /* default */], { isValidResource: __WEBPACK_IMPORTED_MODULE_10__utils_driveItem__["d" /* default */].isValidResourceForPlaylist, onSelect: function (_a) {
                    var _b = __read(_a, 1), item = _b[0];
                    return setResource(item);
                }, onClose: handleCancelClick, actionButtonColor: __WEBPACK_IMPORTED_MODULE_11__utils_styles_constants__["b" /* NewStyleColor */].Blue450, isMultipleSelection: false }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isOptionsDisplayed && !isSpreadsSelectorDisplayed && !__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].isPlaylistMode(), label: "\u00A0", onCancel: function () { return setIsOptionsDisplayed(false); }, actionButtonColor: __WEBPACK_IMPORTED_MODULE_11__utils_styles_constants__["b" /* NewStyleColor */].Blue450, theme: __WEBPACK_IMPORTED_MODULE_2__Popup__["a" /* PopupTheme */].DARK },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* PopupBodyWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { onClick: handleFullPublicationClick },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.combine" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { onClick: handlePagesSelectionClick },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.pages_selection" })),
                resource && !resource.published &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Message */], null,
                        __WEBPACK_IMPORTED_MODULE_12__utils__["d" /* default */].getSvgIcon('iconset_uprez_info2'),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.pages_selection_tooltip" })))),
        isSpreadsSelectorDisplayed && resource &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_Editor_CombinePanel_SpreadsSelector__["a" /* default */], { resourceId: resource.id, onClose: function () { return setIsSpreadsSelectorDisplayed(false); } })));
};
/* harmony default export */ __webpack_exports__["a"] = (CombinePanel);


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonRemoveSpread__ = __webpack_require__(1634);


var mapStateToProps = function (state) {
    var _a = state.editor, allSpreads = _a.pagesController.spreads, _b = _a.pagesSelection, isActive = _b.isActive, spreadIndices = _b.spreadIndices;
    return {
        isDisabled: isActive && (spreadIndices.length === 0 || spreadIndices.length === allSpreads.length),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonRemoveSpread__["a" /* default */]));


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Thumbnails_Column_ButtonsPanel_styles__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);




var ButtonRemoveSpread = function (_a) {
    var isDisabled = _a.isDisabled, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Thumbnails_Column_ButtonsPanel_styles__["a" /* Button */], { iconWidth: "16px", iconHeight: "20px", disabled: isDisabled, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["w" /* removePages */])()); } }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_uprez_trash')));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonRemoveSpread);


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonDuplicateSpread__ = __webpack_require__(1636);


var mapStateToProps = function (state) {
    var spreadIndices = state.editor.pagesSelection.spreadIndices;
    return {
        isDisabled: spreadIndices.length > 1,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonDuplicateSpread__["a" /* default */]));


/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Thumbnails_Column_ButtonsPanel_styles__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);




var ButtonDuplicateSpread = function (_a) {
    var isDisabled = _a.isDisabled, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Thumbnails_Column_ButtonsPanel_styles__["a" /* Button */], { iconWidth: "16px", iconHeight: "19px", disabled: isDisabled, onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["g" /* duplicatePages */])()); } }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_uprez_duplicate')));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonDuplicateSpread);


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Spread__ = __webpack_require__(1638);


var mapStateToProps = function (state) {
    var _a = state.editor, type = _a.type, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, prevSpreadIndex = _b.prevSpreadIndex, pages = _a.pages, thumbnails = _a.thumbnails, spreadZoom = _a.spreadZoom, scripts = _a.resources.scripts, externalResources = _a.externalResources, isAccessibleVersion = _a.isAccessibleVersion;
    var prevSpreadFirstPage = !isAccessibleVersion ? spreads[prevSpreadIndex][0] : prevSpreadIndex + 1;
    var currentSpreadFirstPage = !isAccessibleVersion ? spreads[currentSpreadIndex][0] : currentSpreadIndex + 1;
    var page = pages[currentSpreadFirstPage] ? currentSpreadFirstPage : prevSpreadFirstPage;
    var _c = !isAccessibleVersion ? pages[page] : pages[currentSpreadIndex + 1], pageWidth = _c.width, pageHeight = _c.height, externalId = _c.externalId;
    return {
        editorType: type,
        spread: spreads[currentSpreadIndex],
        pageWidth: pageWidth,
        pageHeight: pageHeight,
        zoom: spreadZoom,
        isThumbnailsDisplayed: thumbnails.isDisplayed,
        thumbnailsWidth: thumbnails.width,
        scripts: externalId ? externalResources[externalId].scripts : scripts,
        isAccessibleVersion: isAccessibleVersion,
        currentSpreadIndex: currentSpreadIndex,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Spread__["a" /* default */]));


/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isequal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_Spread_Background__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_Page__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__ = __webpack_require__(6);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};








var Spread = function (_a) {
    var editorType = _a.editorType, spread = _a.spread, pageWidth = _a.pageWidth, pageHeight = _a.pageHeight, zoom = _a.zoom, isHidden = _a.isHidden, isThumbnailsDisplayed = _a.isThumbnailsDisplayed, thumbnailsWidth = _a.thumbnailsWidth, editorContainer = _a.editorContainer, scripts = _a.scripts, isAccessibleVersion = _a.isAccessibleVersion, currentSpreadIndex = _a.currentSpreadIndex;
    var initialState = {
        containerWidth: 0,
        containerHeight: 0,
        currentWidth: pageWidth,
        currentHeight: pageHeight,
        currentScale: zoom,
    };
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialState), 2), _c = _b[0], containerWidth = _c.containerWidth, containerHeight = _c.containerHeight, currentWidth = _c.currentWidth, currentHeight = _c.currentHeight, currentScale = _c.currentScale, setState = _b[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"]([]), 2), loadedPages = _d[0], setLoadedPages = _d[1];
    var container = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var setPageSize = function () {
        var offsetWidth = container.current.offsetWidth;
        var offsetHeight = window.innerHeight - __WEBPACK_IMPORTED_MODULE_3__styles__["e" /* HEADER_HEIGHT */] - __WEBPACK_IMPORTED_MODULE_3__styles__["g" /* PAGE_PADDING */] * 2;
        var isKeyboardAppeared = __WEBPACK_IMPORTED_MODULE_7__utils_userAgent__["a" /* default */].isMobileApp &&
            offsetWidth === containerWidth &&
            offsetHeight < containerHeight;
        if (isKeyboardAppeared) {
            return;
        }
        var newWidth = isAccessibleVersion ? pageWidth : offsetWidth / spread.length;
        var newScale = isAccessibleVersion ? newWidth : newWidth / pageWidth;
        var newHeight = pageHeight * newScale;
        var isPageHigherThanContainer = newHeight > offsetHeight;
        if (isPageHigherThanContainer) {
            newHeight = offsetHeight;
            newScale = newHeight / pageHeight;
            newWidth = pageWidth * newScale;
        }
        setState({
            containerWidth: offsetWidth,
            containerHeight: offsetHeight,
            currentWidth: newWidth * zoom,
            currentHeight: newHeight * zoom,
            currentScale: newScale * zoom,
        });
    };
    var handlePageLoad = function (page) {
        setLoadedPages(function (prevPages) { return __spread(prevPages, [page]); });
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__["e" /* EditorType */].HTML || isHidden) {
            return;
        }
        setPageSize();
        // Standard window 'resize' event isn't triggered in webview on iOS13, it should be listened on window.visualViewport
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', setPageSize);
        }
        else {
            window.addEventListener('resize', setPageSize);
        }
        return function () {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', setPageSize);
            }
            else {
                window.removeEventListener('resize', setPageSize);
            }
        };
    }, [spread, pageWidth, pageHeight, zoom, isThumbnailsDisplayed, thumbnailsWidth, isHidden, editorType]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__["e" /* EditorType */].HTML || isHidden) {
            return;
        }
        setLoadedPages([]);
    }, [editorType, isHidden, spread]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__["e" /* EditorType */].HTML || isHidden) {
            return;
        }
        var isAllPagesLoaded = __WEBPACK_IMPORTED_MODULE_1_lodash_isequal___default()(loadedPages.sort(function (a, b) { return a - b; }), spread);
        if (!isAllPagesLoaded) {
            return;
        }
        var runScripts = function () {
            var pageContentElements = __spread(container.current.querySelectorAll('div[data-page] > div'));
            var pageContentWithLoadEvent = pageContentElements.find(function (element) { return element.hasAttribute('onload'); });
            if (pageContentWithLoadEvent && pageContentWithLoadEvent.onload) {
                pageContentWithLoadEvent.onload(new Event('load'));
            }
        };
        if (scripts) {
            runScripts();
        }
    }, [editorType, isHidden, loadedPages, spread, scripts]);
    if (editorType === __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__["e" /* EditorType */].HTML) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* PagesWrapper */], { ref: container, hidden: isHidden, editorType: editorType, zoom: zoom },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_Page__["a" /* default */], { page: spread[0], width: currentWidth, height: currentHeight, spreadZoom: zoom, pageScale: currentScale, isLoaded: loadedPages.includes(spread[0]), editorContainer: editorContainer })));
    }
    if (isAccessibleVersion) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* PagesWrapper */], { ref: container, hidden: isHidden, editorType: editorType, zoom: zoom },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_Page__["a" /* default */], { page: currentSpreadIndex + 1, editorContainer: editorContainer, width: pageWidth * zoom, height: pageHeight * zoom, spreadZoom: zoom, pageScale: currentScale, onLoad: handlePageLoad, isLoaded: loadedPages.includes(currentSpreadIndex + 1) })));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_Spread_Background__["a" /* default */], { isHidden: isHidden, editorContainer: editorContainer },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* PagesWrapper */], { ref: container, hidden: isHidden, editorType: editorType, zoom: zoom }, spread.map(function (page) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_Page__["a" /* default */], { key: page, page: page, editorContainer: editorContainer, width: currentWidth, height: currentHeight, spreadZoom: zoom, pageScale: currentScale, isLoaded: loadedPages.includes(page), onLoad: handlePageLoad })); }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Spread);


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagesWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__ = __webpack_require__(9);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var PagesWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\n\t", "\n\n\t", "\n\n\t", "\n\n\t", "\n"], ["\n\tflex: 1 1 auto;\n\tdisplay: flex;\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var editorType = _a.editorType;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].INDESIGN && "\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin: auto;\n\t";
}, function (_a) {
    var editorType = _a.editorType;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].HTML && "\n\t\tposition: relative;\n\t\tflex-direction: column;\n\t";
}, function (_a) {
    var editorType = _a.editorType, zoom = _a.zoom;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].INDESIGN && zoom <= 1 && "\n\t\toverflow: hidden;\n\t";
}, function (_a) {
    var editorType = _a.editorType, zoom = _a.zoom;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].HTML && zoom !== 1 && "\n\t\ttransform: scale(" + zoom + ");\n\t\ttransform-origin: " + (zoom < 1 ? 'center top' : '0 0') + ";\n\t";
});

var templateObject_1;


/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Spread_Background__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(8);





var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, isActive = _a.spreadBackground.isActive, isEditPanelDisplayed = _a.editPanel.isDisplayed, thumbnails = _a.thumbnails, config = state.galleryInfos.config;
    var resourceId = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */]().tempGId;
    var backgroundData = Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["w" /* getSpreadBgData */])(state, spreads[currentSpreadIndex]) || Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getGeneralBgData */])(state);
    var url = '';
    var mediaType = __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* BackgroundMediaType */].IMAGE;
    var defaultMediaType = __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* BackgroundMediaType */].IMAGE;
    var colors;
    var position;
    if (backgroundData) {
        var currentMedia = backgroundData.currentMedia, defaultMedia = backgroundData.defaultMedia, defaultColors = backgroundData.defaultColors;
        if (currentMedia) {
            var type = currentMedia.type;
            if (type === __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* BackgroundMediaType */].SLIDER && 'slides' in currentMedia) {
                if (currentMedia.slides[0]) {
                    var _c = currentMedia.slides[0], relUrl = _c.relUrl, iconName = _c.iconName, externalRelUrl = _c.externalRelUrl, isExternalLink = _c.isExternalLink;
                    url = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["F" /* getSliderPreviewUrl */](config, relUrl, isExternalLink, externalRelUrl, iconName);
                }
            }
            else if ('relUrl' in currentMedia) {
                url = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["z" /* getResourceUrl */](currentMedia.relUrl, config, resourceId);
                if (type === __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* BackgroundMediaType */].MOVIE) {
                    url = __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["S" /* getVideoCover */](url);
                }
            }
            mediaType = type;
        }
        else if (defaultColors.some(Boolean)) {
            colors = defaultColors;
        }
        if ((currentMedia || defaultMedia) && mediaType !== __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* BackgroundMediaType */].SLIDER) {
            position = (currentMedia || defaultMedia).position;
        }
        if (defaultMedia) {
            defaultMediaType = defaultMedia.type;
        }
        else if (currentMedia) {
            defaultMediaType = currentMedia.type;
        }
    }
    return {
        url: url,
        colors: colors,
        position: position,
        isEditable: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["y" /* isEditableSpread */])(state),
        isActive: isActive,
        isEditPanelDisplayed: isEditPanelDisplayed,
        mediaType: mediaType,
        defaultMediaType: defaultMediaType,
        thumbnailsWidth: thumbnails.width,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Spread_Background__["c" /* default */]));


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var DESKTOP_WIDTH = 992;
var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tdisplay: ", ";\n\tpadding: ", "px;\n\toverflow: auto;\n\n\t", "\n\n\t", "\n"], ["\n\tflex: 1 1 auto;\n\tdisplay: ", ";\n\tpadding: ", "px;\n\toverflow: auto;\n\n\t",
    "\n\n\t", "\n"])), function (_a) {
    var isHidden = _a.isHidden;
    return isHidden ? 'none' : 'flex';
}, __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* PAGE_PADDING */], function (_a) {
    var colors = _a.colors;
    if (!colors) {
        return '';
    }
    return "\n\t\t\t" + (colors.length === 1
        ? "background-color: " + (colors[0] || 'transparent') + ";"
        : "background: linear-gradient(90deg, " + (colors[0] || 'transparent') + " 50%, " + (colors[1] || 'transparent') + " 50%);") + "\n\t\t\tbackground-clip: content-box;\n\t\t";
}, Object(__WEBPACK_IMPORTED_MODULE_2__styles__["j" /* getEditorScrollStyles */])());
var ImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: ", "px;\n\tbottom: ", "px;\n\tleft: ", "px;\n\tright: ", "px;\n\toverflow: hidden;\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: ", "px;\n\tbottom: ", "px;\n\tleft: ", "px;\n\tright: ", "px;\n\toverflow: hidden;\n\n\t", "\n"])), __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* PAGE_PADDING */], __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* PAGE_PADDING */], __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* PAGE_PADDING */], __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* PAGE_PADDING */], function (_a) {
    var isActive = _a.isActive;
    return isActive && "outline: 2px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";";
});
var Image = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground: ", ";\n\tbackground-size: cover;\n\tbackground-position: ", ";\n\n\t", "\n\n\t@media screen and (min-width: ", "px) {\n\t\tbackground-position: ", ";\n\n\t\t", "\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground: ", ";\n\tbackground-size: cover;\n\tbackground-position: ", ";\n\n\t", "\n\n\t@media screen and (min-width: ", "px) {\n\t\tbackground-position: ", ";\n\n\t\t", "\n\t}\n"])), function (_a) {
    var url = _a.url;
    return "url(" + url + ") no-repeat";
}, function (_a) {
    var _b = _a.position.phone, left = _b.left, top = _b.top;
    return left + "% " + top + "%";
}, function (_a) {
    var scale = _a.position.phone.scale;
    return "transform: scale(" + scale + ");";
}, function (_a) {
    var thumbnailsWidth = _a.thumbnailsWidth;
    return thumbnailsWidth + __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* PAGE_PADDING */] * 2 + DESKTOP_WIDTH;
}, function (_a) {
    var _b = _a.position.desktop, left = _b.left, top = _b.top;
    return left + "% " + top + "%";
}, function (_a) {
    var scale = _a.position.desktop.scale;
    return "transform: scale(" + scale + ");";
});

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SpreadBackgroundPanel__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);



var getImportManagerId = function (page) {
    var prefix = 'bgMedia';
    return prefix + "-" + page;
};
var mapStateToProps = function (state) {
    var _a = state.editor.pagesController, spreads = _a.spreads, currentSpreadIndex = _a.currentSpreadIndex, byId = state.importManager.byId;
    var spread = spreads[currentSpreadIndex];
    var page = spread[0];
    var backgroundData = Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["w" /* getSpreadBgData */])(state, spread) || Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getGeneralBgData */])(state);
    var currentBgMediaData;
    var defaultBgMediaData;
    if (backgroundData) {
        currentBgMediaData = backgroundData.currentMedia;
        defaultBgMediaData = backgroundData.defaultMedia;
    }
    var importManagerId = getImportManagerId(page);
    return {
        spread: spread,
        currentBgMediaData: currentBgMediaData,
        hasCustomBgMediaData: !!defaultBgMediaData,
        isGeneralBgData: !Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["w" /* getSpreadBgData */])(state, spread) && !!Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getGeneralBgData */])(state),
        importManagerId: importManagerId,
        isImporting: !!byId[importManagerId],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SpreadBackgroundPanel__["a" /* default */]));


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourcePanel__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_SpreadBackgroundPanel_MediaPreview__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_reducer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__ = __webpack_require__(11);
var _a;








var config = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].image] = {
        isValidResourceFromApp: function (_a) {
            var type = _a.type;
            return type === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].DriveItemType.Image;
        },
        fileExtensions: __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].imageWithPdfExtensions,
    },
    _a[__WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].video] = {
        isValidResourceFromApp: function (_a) {
            var type = _a.type;
            return type === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].DriveItemType.Movie;
        },
        fileExtensions: __WEBPACK_IMPORTED_MODULE_7__utils_driveItem__["d" /* default */].videoExtensions,
    },
    _a);
var SpreadBackgroundPanel = function (_a) {
    var type = _a.type, spread = _a.spread, currentBgMediaData = _a.currentBgMediaData, hasCustomBgMediaData = _a.hasCustomBgMediaData, importManagerId = _a.importManagerId, isImporting = _a.isImporting, isGeneralBgData = _a.isGeneralBgData, position = _a.position, onPositionChange = _a.onPositionChange, dispatch = _a.dispatch;
    var _b = config[type], isValidResourceFromApp = _b.isValidResourceFromApp, fileExtensions = _b.fileExtensions;
    var handleResourceSelect = function (driveItem) {
        var id = driveItem.id, label = driveItem.label, src = driveItem.src, type = driveItem.type;
        var mediaType = type === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].DriveItemType.Image
            ? __WEBPACK_IMPORTED_MODULE_6__containers_Editor_reducer__["a" /* BackgroundMediaType */].IMAGE
            : __WEBPACK_IMPORTED_MODULE_6__containers_Editor_reducer__["a" /* BackgroundMediaType */].MOVIE;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["R" /* setSpreadBackground */])(spread, {
            globalId: id,
            label: label,
            relUrl: src,
            type: mediaType,
        }, isGeneralBgData));
    };
    var handleResourceReset = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["R" /* setSpreadBackground */])(spread, null, isGeneralBgData));
    };
    var mediaType = currentBgMediaData ? currentBgMediaData.type : __WEBPACK_IMPORTED_MODULE_6__containers_Editor_reducer__["a" /* BackgroundMediaType */].IMAGE;
    var label = currentBgMediaData && 'label' in currentBgMediaData ? currentBgMediaData.label : '';
    var iconName = mediaType === __WEBPACK_IMPORTED_MODULE_6__containers_Editor_reducer__["a" /* BackgroundMediaType */].IMAGE
        ? 'iconset_uprez_image'
        : 'iconset_uprez_video';
    var hasMediaPreview = currentBgMediaData &&
        currentBgMediaData.type !== __WEBPACK_IMPORTED_MODULE_6__containers_Editor_reducer__["a" /* BackgroundMediaType */].SLIDER &&
        !isImporting;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        hasMediaPreview &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_SpreadBackgroundPanel_MediaPreview__["a" /* default */], { bgMediaData: currentBgMediaData, spread: spread, isGeneralBgData: isGeneralBgData, position: position, onPositionChange: onPositionChange })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ResourcePanel__["a" /* default */], { iconName: iconName, label: label, importManagerId: importManagerId, isImporting: isImporting, isValidResourceFromApp: isValidResourceFromApp, isOptimizedImageImport: type === __WEBPACK_IMPORTED_MODULE_4__containers_Editor_constants__["c" /* EditableType */].image, fileExtensions: fileExtensions, isFileExtensionsDisplayed: true, isResetButtonDisplayed: hasCustomBgMediaData, dispatch: dispatch, onResourceSelect: handleResourceSelect, onResourceReset: handleResourceReset })));
};
/* harmony default export */ __webpack_exports__["a"] = (SpreadBackgroundPanel);


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SpreadBackgroundPanel_MediaPreview__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typings_api__ = __webpack_require__(10);




var mapStateToProps = function (state, ownProps) {
    var galleryInfos = state.galleryInfos;
    var resourceId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().tempGId;
    var _a = ownProps.bgMediaData, relUrl = _a.relUrl, type = _a.type;
    var url = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["z" /* getResourceUrl */])(relUrl, galleryInfos.config, resourceId);
    if (type === __WEBPACK_IMPORTED_MODULE_3__typings_api__["a" /* Api */].AssetItemFileTypes.MOVIE) {
        url = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["S" /* getVideoCover */])(url);
    }
    return {
        url: url,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SpreadBackgroundPanel_MediaPreview__["a" /* default */]));


/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_RangeSlider__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tooltip__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spread_Background__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__ = __webpack_require__(14);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var PositionParam;
(function (PositionParam) {
    PositionParam["TOP"] = "top";
    PositionParam["LEFT"] = "left";
    PositionParam["SCALE"] = "scale";
})(PositionParam || (PositionParam = {}));
var MediaPreview = function (_a) {
    var url = _a.url, spread = _a.spread, bgMediaData = _a.bgMediaData, isGeneralBgData = _a.isGeneralBgData, position = _a.position, onPositionChange = _a.onPositionChange, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP), 2), activeMode = _b[0], setActiveMode = _b[1];
    var handleChange = function (param, value) {
        var _a, _b;
        onPositionChange(__assign({}, position, (_a = {}, _a[activeMode] = __assign({}, position[activeMode], (_b = {}, _b[param] = value, _b)), _a)));
    };
    var handleFinalChange = function (param, value) {
        var _a, _b;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["R" /* setSpreadBackground */])(spread, __assign({}, bgMediaData, { position: __assign({}, bgMediaData.position, (_a = {}, _a[activeMode] = __assign({}, (bgMediaData.position || {})[activeMode], (_b = {}, _b[param] = value, _b)), _a)) }), isGeneralBgData));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* Wrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* MediaWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* MediaWrapperColumn */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Label */], { value: "messages.desktop", isActive: activeMode === __WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* MediaInner */], { isActive: activeMode === __WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP, onClick: function () { return setActiveMode(__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Image */], { url: url, top: position[__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP].top, left: position[__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP].left, scale: position[__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].DESKTOP].scale }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* MediaWrapperColumn */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Label */], { value: "messages.phone", isActive: activeMode === __WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].PHONE }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* MediaInner */], { isActive: activeMode === __WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].PHONE, onClick: function () { return setActiveMode(__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].PHONE); }, isPhone: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Image */], { url: url, top: position[__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].PHONE].top, left: position[__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].PHONE].left, scale: position[__WEBPACK_IMPORTED_MODULE_4__Spread_Background__["b" /* PreviewMode */].PHONE].scale })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* RangeSliderWrapper */], { hasTooltip: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Form_RangeSlider__["a" /* default */], { labels: {
                    left: 'messages.top',
                    right: 'messages.bottom',
                }, step: 1, min: 0, max: 100, value: position[activeMode].top, onChange: function (value) { return handleChange(PositionParam.TOP, value); }, onFinalChange: function (value) { return handleFinalChange(PositionParam.TOP, value); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tooltip__["a" /* default */], { message: "messages.bg_cover_top_tooltip" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* RangeSliderWrapper */], { hasTooltip: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Form_RangeSlider__["a" /* default */], { labels: {
                    left: 'messages.left',
                    right: 'messages.right',
                }, step: 1, min: 0, max: 100, value: position[activeMode].left, onChange: function (value) { return handleChange(PositionParam.LEFT, value); }, onFinalChange: function (value) { return handleFinalChange(PositionParam.LEFT, value); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tooltip__["a" /* default */], { message: "messages.bg_cover_left_tooltip" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* RangeSliderWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Form_RangeSlider__["a" /* default */], { labels: {
                    left: 'messages.scale',
                }, step: 0.01, min: 1, max: 2, value: position[activeMode].scale, onChange: function (value) { return handleChange(PositionParam.SCALE, value); }, onFinalChange: function (value) { return handleFinalChange(PositionParam.SCALE, value); } }))));
};
/* harmony default export */ __webpack_exports__["a"] = (MediaPreview);


/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_range__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1649);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




var RangeSlider = function (_a) {
    var step = _a.step, min = _a.min, max = _a.max, value = _a.value, onChange = _a.onChange, onFinalChange = _a.onFinalChange, labels = _a.labels;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        labels &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Labels */], null,
                labels.left && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: labels.left }),
                labels.right && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: labels.right })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_range__["Range"], { step: step, min: min, max: max, values: [value], direction: __WEBPACK_IMPORTED_MODULE_2_react_range__["Direction"].Right, allowOverlap: false, draggableTrack: false, disabled: false, rtl: false, onChange: function (_a) {
                var _b = __read(_a, 1), value = _b[0];
                return onChange(value);
            }, onFinalChange: function (_a) {
                var _b = __read(_a, 1), value = _b[0];
                return onFinalChange(value);
            }, renderTrack: function (_a) {
                var props = _a.props, children = _a.children;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Track */], __assign({}, props), children));
            }, renderThumb: function (_a) {
                var props = _a.props;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Thumb */], __assign({}, props)));
            } })));
};
/* harmony default export */ __webpack_exports__["a"] = (RangeSlider);


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkValuesAgainstBoundaries = exports.relativeValue = exports.useThumbOverlap = exports.Direction = exports.getTrackBackground = exports.Range = void 0;
var Range_1 = __importDefault(__webpack_require__(1648));
exports.Range = Range_1.default;
var utils_1 = __webpack_require__(637);
Object.defineProperty(exports, "getTrackBackground", { enumerable: true, get: function () { return utils_1.getTrackBackground; } });
Object.defineProperty(exports, "useThumbOverlap", { enumerable: true, get: function () { return utils_1.useThumbOverlap; } });
Object.defineProperty(exports, "relativeValue", { enumerable: true, get: function () { return utils_1.relativeValue; } });
Object.defineProperty(exports, "checkValuesAgainstBoundaries", { enumerable: true, get: function () { return utils_1.checkValuesAgainstBoundaries; } });
var types_1 = __webpack_require__(375);
Object.defineProperty(exports, "Direction", { enumerable: true, get: function () { return types_1.Direction; } });


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(__webpack_require__(0));
var utils_1 = __webpack_require__(637);
var types_1 = __webpack_require__(375);
var INCREASE_KEYS = ['ArrowRight', 'ArrowUp', 'k', 'PageUp'];
var DECREASE_KEYS = ['ArrowLeft', 'ArrowDown', 'j', 'PageDown'];
var Range = /** @class */ (function (_super) {
    __extends(Range, _super);
    function Range(props) {
        var _this = _super.call(this, props) || this;
        _this.trackRef = React.createRef();
        _this.thumbRefs = [];
        _this.markRefs = [];
        _this.state = {
            draggedTrackPos: [-1, -1],
            draggedThumbIndex: -1,
            thumbZIndexes: new Array(_this.props.values.length).fill(0).map(function (t, i) { return i; }),
            isChanged: false,
            markOffsets: []
        };
        _this.getOffsets = function () {
            var _a = _this.props, direction = _a.direction, values = _a.values, min = _a.min, max = _a.max;
            var trackElement = _this.trackRef.current;
            var trackRect = trackElement.getBoundingClientRect();
            var trackPadding = utils_1.getPaddingAndBorder(trackElement);
            return _this.getThumbs().map(function (thumb, index) {
                var thumbOffsets = { x: 0, y: 0 };
                var thumbRect = thumb.getBoundingClientRect();
                var thumbMargins = utils_1.getMargin(thumb);
                switch (direction) {
                    case types_1.Direction.Right:
                        thumbOffsets.x = (thumbMargins.left + trackPadding.left) * -1;
                        thumbOffsets.y =
                            ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
                        thumbOffsets.x +=
                            trackRect.width * utils_1.relativeValue(values[index], min, max) -
                                thumbRect.width / 2;
                        return thumbOffsets;
                    case types_1.Direction.Left:
                        thumbOffsets.x = (thumbMargins.right + trackPadding.right) * -1;
                        thumbOffsets.y =
                            ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
                        thumbOffsets.x +=
                            trackRect.width -
                                trackRect.width * utils_1.relativeValue(values[index], min, max) -
                                thumbRect.width / 2;
                        return thumbOffsets;
                    case types_1.Direction.Up:
                        thumbOffsets.x =
                            ((thumbRect.width - trackRect.width) / 2 +
                                thumbMargins.left +
                                trackPadding.left) *
                                -1;
                        thumbOffsets.y = -trackPadding.left;
                        thumbOffsets.y +=
                            trackRect.height -
                                trackRect.height * utils_1.relativeValue(values[index], min, max) -
                                thumbRect.height / 2;
                        return thumbOffsets;
                    case types_1.Direction.Down:
                        thumbOffsets.x =
                            ((thumbRect.width - trackRect.width) / 2 +
                                thumbMargins.left +
                                trackPadding.left) *
                                -1;
                        thumbOffsets.y = -trackPadding.left;
                        thumbOffsets.y +=
                            trackRect.height * utils_1.relativeValue(values[index], min, max) -
                                thumbRect.height / 2;
                        return thumbOffsets;
                    default:
                        return utils_1.assertUnreachable(direction);
                }
            });
        };
        _this.getThumbs = function () {
            if (_this.trackRef && _this.trackRef.current) {
                return Array.from(_this.trackRef.current.children).filter(function (el) {
                    return el.hasAttribute('aria-valuenow');
                });
            }
            console.warn('No thumbs found in the track container. Did you forget to pass & spread the `props` param in renderTrack?');
            return [];
        };
        _this.getTargetIndex = function (e) {
            return _this.getThumbs().findIndex(function (child) { return child === e.target || child.contains(e.target); });
        };
        _this.addTouchEvents = function (e) {
            document.addEventListener('touchmove', _this.schdOnTouchMove, {
                passive: false
            });
            document.addEventListener('touchend', _this.schdOnEnd, {
                passive: false
            });
            document.addEventListener('touchcancel', _this.schdOnEnd, {
                passive: false
            });
        };
        _this.addMouseEvents = function (e) {
            document.addEventListener('mousemove', _this.schdOnMouseMove);
            document.addEventListener('mouseup', _this.schdOnEnd);
        };
        _this.onMouseDownTrack = function (e) {
            var _a;
            if (e.button !== 0)
                return;
            e.persist();
            e.preventDefault();
            _this.addMouseEvents(e.nativeEvent);
            if (_this.props.values.length > 1 && _this.props.draggableTrack) {
                if (_this.thumbRefs.some(function (thumbRef) { var _a; return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target); }))
                    return;
                // handle dragging the whole track
                _this.setState({
                    draggedTrackPos: [e.clientX, e.clientY]
                }, function () { return _this.onMove(e.clientX, e.clientY); });
            }
            else {
                // get the index of the thumb that is closest to the place where the track is clicked
                var draggedThumbIndex = utils_1.getClosestThumbIndex(_this.thumbRefs.map(function (t) { return t.current; }), e.clientX, e.clientY, _this.props.direction);
                // move the thumb which is closest to the place where the track is clicked
                (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
                _this.setState({
                    draggedThumbIndex: draggedThumbIndex
                }, function () { return _this.onMove(e.clientX, e.clientY); });
            }
        };
        _this.onResize = function () {
            utils_1.translateThumbs(_this.getThumbs(), _this.getOffsets(), _this.props.rtl);
            _this.calculateMarkOffsets();
        };
        _this.onTouchStartTrack = function (e) {
            var _a;
            e.persist();
            _this.addTouchEvents(e.nativeEvent);
            if (_this.props.values.length > 1 && _this.props.draggableTrack) {
                if (_this.thumbRefs.some(function (thumbRef) { var _a; return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target); }))
                    return;
                // handle dragging the whole track
                _this.setState({
                    draggedTrackPos: [e.touches[0].clientX, e.touches[0].clientY]
                }, function () { return _this.onMove(e.touches[0].clientX, e.touches[0].clientY); });
            }
            else {
                // get the index of the thumb that is closest to the place where the track is clicked
                var draggedThumbIndex = utils_1.getClosestThumbIndex(_this.thumbRefs.map(function (t) { return t.current; }), e.touches[0].clientX, e.touches[0].clientY, _this.props.direction);
                // move the thumb which is closest to the place where the track is clicked
                (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
                _this.setState({
                    draggedThumbIndex: draggedThumbIndex
                }, function () { return _this.onMove(e.touches[0].clientX, e.touches[0].clientY); });
            }
        };
        _this.onMouseOrTouchStart = function (e) {
            if (_this.props.disabled)
                return;
            var isTouch = utils_1.isTouchEvent(e);
            if (!isTouch && e.button !== 0)
                return;
            var index = _this.getTargetIndex(e);
            if (index === -1)
                return;
            if (isTouch) {
                _this.addTouchEvents(e);
            }
            else {
                _this.addMouseEvents(e);
            }
            _this.setState({
                draggedThumbIndex: index,
                thumbZIndexes: _this.state.thumbZIndexes.map(function (t, i) {
                    if (i === index) {
                        return Math.max.apply(Math, _this.state.thumbZIndexes);
                    }
                    return t <= _this.state.thumbZIndexes[index] ? t : t - 1;
                })
            });
        };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            _this.onMove(e.clientX, e.clientY);
        };
        _this.onTouchMove = function (e) {
            e.preventDefault();
            _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        };
        _this.onKeyDown = function (e) {
            var _a = _this.props, values = _a.values, onChange = _a.onChange, step = _a.step, rtl = _a.rtl, direction = _a.direction;
            var isChanged = _this.state.isChanged;
            var index = _this.getTargetIndex(e.nativeEvent);
            var inverter = rtl || direction === types_1.Direction.Left || direction === types_1.Direction.Down
                ? -1
                : 1;
            if (index === -1)
                return;
            if (INCREASE_KEYS.includes(e.key)) {
                e.preventDefault();
                _this.setState({
                    draggedThumbIndex: index,
                    isChanged: true
                });
                onChange(utils_1.replaceAt(values, index, _this.normalizeValue(values[index] + inverter * (e.key === 'PageUp' ? step * 10 : step), index)));
            }
            else if (DECREASE_KEYS.includes(e.key)) {
                e.preventDefault();
                _this.setState({
                    draggedThumbIndex: index,
                    isChanged: true
                });
                onChange(utils_1.replaceAt(values, index, _this.normalizeValue(values[index] -
                    inverter * (e.key === 'PageDown' ? step * 10 : step), index)));
            }
            else if (e.key === 'Tab') {
                _this.setState({ draggedThumbIndex: -1 }, function () {
                    // If key pressed when thumb was moving, fire onFinalChange
                    if (isChanged) {
                        _this.fireOnFinalChange();
                    }
                });
            }
            else {
                if (isChanged) {
                    _this.fireOnFinalChange();
                }
            }
        };
        _this.onKeyUp = function (e) {
            var isChanged = _this.state.isChanged;
            _this.setState({
                draggedThumbIndex: -1
            }, function () {
                if (isChanged) {
                    _this.fireOnFinalChange();
                }
            });
        };
        _this.onMove = function (clientX, clientY) {
            var _a = _this.state, draggedThumbIndex = _a.draggedThumbIndex, draggedTrackPos = _a.draggedTrackPos;
            var _b = _this.props, direction = _b.direction, min = _b.min, max = _b.max, onChange = _b.onChange, values = _b.values, step = _b.step, rtl = _b.rtl;
            if (draggedThumbIndex === -1 &&
                draggedTrackPos[0] === -1 &&
                draggedTrackPos[1] === -1)
                return null;
            var trackElement = _this.trackRef.current;
            // If component was closed down prematurely, A last onMove could be triggered based on requestAnimationFrame()
            if (!trackElement)
                return null;
            var trackRect = trackElement.getBoundingClientRect();
            var trackLength = utils_1.isVertical(direction)
                ? trackRect.height
                : trackRect.width;
            if (draggedTrackPos[0] !== -1 && draggedTrackPos[1] !== -1) {
                // calculate how much it moved since the last update
                var dX = clientX - draggedTrackPos[0];
                var dY = clientY - draggedTrackPos[1];
                // calculate the delta of the value
                var deltaValue = 0;
                switch (direction) {
                    case types_1.Direction.Right:
                    case types_1.Direction.Left:
                        deltaValue = (dX / trackLength) * (max - min);
                        break;
                    case types_1.Direction.Down:
                    case types_1.Direction.Up:
                        deltaValue = (dY / trackLength) * (max - min);
                        break;
                    default:
                        utils_1.assertUnreachable(direction);
                }
                // invert for RTL
                if (rtl) {
                    deltaValue *= -1;
                }
                if (Math.abs(deltaValue) >= step / 2) {
                    // adjust delta so it fits into the range
                    for (var i = 0; i < _this.thumbRefs.length; i++) {
                        if ((values[i] === max && Math.sign(deltaValue) === 1) ||
                            (values[i] === min && Math.sign(deltaValue) === -1))
                            return;
                        var thumbValue = values[i] + deltaValue;
                        if (thumbValue > max)
                            deltaValue = max - values[i];
                        else if (thumbValue < min)
                            deltaValue = min - values[i];
                    }
                    // add the delta to each thumb
                    var newValues = values.slice(0);
                    for (var i = 0; i < _this.thumbRefs.length; i++) {
                        newValues = utils_1.replaceAt(newValues, i, _this.normalizeValue(values[i] + deltaValue, i));
                    }
                    _this.setState({
                        draggedTrackPos: [clientX, clientY]
                    });
                    onChange(newValues);
                }
            }
            else {
                var newValue = 0;
                switch (direction) {
                    case types_1.Direction.Right:
                        newValue =
                            ((clientX - trackRect.left) / trackLength) * (max - min) + min;
                        break;
                    case types_1.Direction.Left:
                        newValue =
                            ((trackLength - (clientX - trackRect.left)) / trackLength) *
                                (max - min) +
                                min;
                        break;
                    case types_1.Direction.Down:
                        newValue =
                            ((clientY - trackRect.top) / trackLength) * (max - min) + min;
                        break;
                    case types_1.Direction.Up:
                        newValue =
                            ((trackLength - (clientY - trackRect.top)) / trackLength) *
                                (max - min) +
                                min;
                        break;
                    default:
                        utils_1.assertUnreachable(direction);
                }
                // invert for RTL
                if (rtl) {
                    newValue = max + min - newValue;
                }
                if (Math.abs(values[draggedThumbIndex] - newValue) >= step / 2) {
                    onChange(utils_1.replaceAt(values, draggedThumbIndex, _this.normalizeValue(newValue, draggedThumbIndex)));
                }
            }
        };
        _this.normalizeValue = function (value, index) {
            var _a = _this.props, min = _a.min, max = _a.max, step = _a.step, allowOverlap = _a.allowOverlap, values = _a.values;
            return utils_1.normalizeValue(value, index, min, max, step, allowOverlap, values);
        };
        _this.onEnd = function (e) {
            e.preventDefault();
            document.removeEventListener('mousemove', _this.schdOnMouseMove);
            document.removeEventListener('touchmove', _this.schdOnTouchMove);
            document.removeEventListener('mouseup', _this.schdOnEnd);
            document.removeEventListener('touchend', _this.schdOnEnd);
            document.removeEventListener('touchcancel', _this.schdOnEnd);
            if (_this.state.draggedThumbIndex === -1 &&
                _this.state.draggedTrackPos[0] === -1 &&
                _this.state.draggedTrackPos[1] === -1)
                return null;
            _this.setState({ draggedThumbIndex: -1, draggedTrackPos: [-1, -1] }, function () {
                _this.fireOnFinalChange();
            });
        };
        _this.fireOnFinalChange = function () {
            _this.setState({ isChanged: false });
            var _a = _this.props, onFinalChange = _a.onFinalChange, values = _a.values;
            if (onFinalChange) {
                onFinalChange(values);
            }
        };
        _this.calculateMarkOffsets = function () {
            if (!_this.props.renderMark ||
                !_this.trackRef ||
                _this.trackRef.current === null)
                return;
            var elStyles = window.getComputedStyle(_this.trackRef.current);
            var trackWidth = parseInt(elStyles.width, 10);
            var trackHeight = parseInt(elStyles.height, 10);
            var paddingLeft = parseInt(elStyles.paddingLeft, 10);
            var paddingTop = parseInt(elStyles.paddingTop, 10);
            var res = [];
            for (var i = 0; i < _this.numOfMarks + 1; i++) {
                var markHeight = 9999;
                var markWidth = 9999;
                if (_this.markRefs[i].current) {
                    var markRect = _this.markRefs[i].current.getBoundingClientRect();
                    markHeight = markRect.height;
                    markWidth = markRect.width;
                }
                if (_this.props.direction === types_1.Direction.Left ||
                    _this.props.direction === types_1.Direction.Right) {
                    res.push([
                        Math.round((trackWidth / _this.numOfMarks) * i + paddingLeft - markWidth / 2),
                        -Math.round((markHeight - trackHeight) / 2)
                    ]);
                }
                else {
                    res.push([
                        Math.round((trackHeight / _this.numOfMarks) * i + paddingTop - markHeight / 2),
                        -Math.round((markWidth - trackWidth) / 2)
                    ]);
                }
            }
            _this.setState({ markOffsets: res });
        };
        if (props.step === 0) {
            throw new Error('"step" property should be a positive number');
        }
        _this.numOfMarks = (props.max - props.min) / _this.props.step;
        _this.schdOnMouseMove = utils_1.schd(_this.onMouseMove);
        _this.schdOnTouchMove = utils_1.schd(_this.onTouchMove);
        _this.schdOnEnd = utils_1.schd(_this.onEnd);
        _this.thumbRefs = props.values.map(function () { return React.createRef(); });
        for (var i = 0; i < _this.numOfMarks + 1; i++) {
            _this.markRefs[i] = React.createRef();
        }
        return _this;
    }
    Range.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, values = _a.values, min = _a.min, step = _a.step;
        this.resizeObserver = window.ResizeObserver
            ? new window.ResizeObserver(this.onResize)
            : {
                observe: function () { return window.addEventListener('resize', _this.onResize); },
                unobserve: function () { return window.removeEventListener('resize', _this.onResize); }
            };
        document.addEventListener('touchstart', this.onMouseOrTouchStart, {
            passive: false
        });
        document.addEventListener('mousedown', this.onMouseOrTouchStart, {
            passive: false
        });
        !this.props.allowOverlap && utils_1.checkInitialOverlap(this.props.values);
        this.props.values.forEach(function (value) {
            return utils_1.checkBoundaries(value, _this.props.min, _this.props.max);
        });
        this.resizeObserver.observe(this.trackRef.current);
        utils_1.translateThumbs(this.getThumbs(), this.getOffsets(), this.props.rtl);
        this.calculateMarkOffsets();
        values.forEach(function (value) {
            if (!utils_1.isStepDivisible(min, value, step)) {
                console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
            }
        });
    };
    Range.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, max = _a.max, min = _a.min, step = _a.step, values = _a.values, rtl = _a.rtl;
        if (prevProps.max !== max ||
            prevProps.min !== min ||
            prevProps.step !== step) {
            this.markRefs = [];
            this.numOfMarks = (max - min) / step;
            for (var i = 0; i < this.numOfMarks + 1; i++) {
                this.markRefs[i] = React.createRef();
            }
        }
        utils_1.translateThumbs(this.getThumbs(), this.getOffsets(), rtl);
        // ensure offsets are calculated when the refs for the marks have been created
        // and those refs have been mounted to the dom
        // on the state update in calculateOffsets with new markOffsets are calculated
        if (prevProps.max !== max ||
            prevProps.min !== min ||
            prevProps.step !== step ||
            prevState.markOffsets.length !== this.state.markOffsets.length) {
            this.calculateMarkOffsets();
            values.forEach(function (value) {
                if (!utils_1.isStepDivisible(min, value, step)) {
                    console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
                }
            });
        }
    };
    Range.prototype.componentWillUnmount = function () {
        var options = {
            passive: false
        };
        document.removeEventListener('mousedown', this.onMouseOrTouchStart, options);
        // These need to be removed!!
        document.removeEventListener('mousemove', this.schdOnMouseMove);
        document.removeEventListener('touchmove', this.schdOnTouchMove);
        document.removeEventListener('touchstart', this.onMouseOrTouchStart);
        document.removeEventListener('mouseup', this.schdOnEnd);
        document.removeEventListener('touchend', this.schdOnEnd);
        this.resizeObserver.unobserve(this.trackRef.current);
    };
    Range.prototype.render = function () {
        var _this = this;
        var _a = this.props, renderTrack = _a.renderTrack, renderThumb = _a.renderThumb, _b = _a.renderMark, renderMark = _b === void 0 ? function () { return null; } : _b, values = _a.values, min = _a.min, max = _a.max, allowOverlap = _a.allowOverlap, disabled = _a.disabled;
        var _c = this.state, draggedThumbIndex = _c.draggedThumbIndex, thumbZIndexes = _c.thumbZIndexes, markOffsets = _c.markOffsets;
        return renderTrack({
            props: {
                style: {
                    // creates stacking context that prevents z-index applied to thumbs
                    // interfere with other elements
                    transform: 'scale(1)',
                    cursor: draggedThumbIndex > -1
                        ? 'grabbing'
                        : this.props.draggableTrack
                            ? utils_1.isVertical(this.props.direction)
                                ? 'ns-resize'
                                : 'ew-resize'
                            : values.length === 1 && !disabled
                                ? 'pointer'
                                : 'inherit'
                },
                onMouseDown: disabled ? utils_1.voidFn : this.onMouseDownTrack,
                onTouchStart: disabled ? utils_1.voidFn : this.onTouchStartTrack,
                ref: this.trackRef
            },
            isDragged: this.state.draggedThumbIndex > -1,
            disabled: disabled,
            children: __spreadArrays(markOffsets.map(function (offset, index, arr) {
                return renderMark({
                    props: {
                        style: _this.props.direction === types_1.Direction.Left ||
                            _this.props.direction === types_1.Direction.Right
                            ? {
                                position: 'absolute',
                                left: offset[0] + "px",
                                marginTop: offset[1] + "px"
                            }
                            : {
                                position: 'absolute',
                                top: offset[0] + "px",
                                marginLeft: offset[1] + "px"
                            },
                        key: "mark" + index,
                        ref: _this.markRefs[index]
                    },
                    index: index
                });
            }), values.map(function (value, index) {
                var isDragged = _this.state.draggedThumbIndex === index;
                return renderThumb({
                    index: index,
                    value: value,
                    isDragged: isDragged,
                    props: {
                        style: {
                            position: 'absolute',
                            zIndex: thumbZIndexes[index],
                            cursor: disabled ? 'inherit' : isDragged ? 'grabbing' : 'grab',
                            userSelect: 'none',
                            touchAction: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        },
                        key: index,
                        tabIndex: disabled ? undefined : 0,
                        'aria-valuemax': allowOverlap ? max : values[index + 1] || max,
                        'aria-valuemin': allowOverlap ? min : values[index - 1] || min,
                        'aria-valuenow': value,
                        draggable: false,
                        ref: _this.thumbRefs[index],
                        role: 'slider',
                        onKeyDown: disabled ? utils_1.voidFn : _this.onKeyDown,
                        onKeyUp: disabled ? utils_1.voidFn : _this.onKeyUp
                    }
                });
            }))
        });
    };
    Range.defaultProps = {
        step: 1,
        direction: types_1.Direction.Right,
        rtl: false,
        disabled: false,
        allowOverlap: false,
        draggableTrack: false,
        min: 0,
        max: 100
    };
    return Range;
}(React.Component));
exports.default = Range;


/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Labels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Track; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Thumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Labels = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var Track = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\theight: 23px;\n\tmargin: 0 10px;\n\tpadding: 10px 0;\n\n\t&::after {\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\twidth: calc(100% + 20px);\n\t\theight: 3px;\n\t\tmargin: 0 -10px;\n\t\tborder-radius: 2px;\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tbox-sizing: border-box;\n\theight: 23px;\n\tmargin: 0 10px;\n\tpadding: 10px 0;\n\n\t&::after {\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\twidth: calc(100% + 20px);\n\t\theight: 3px;\n\t\tmargin: 0 -10px;\n\t\tborder-radius: 2px;\n\t\tbackground-color: ", ";\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450);
var Thumb = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 23px;\n\theight: 23px;\n\tborder-radius: 50%;\n\tbox-shadow: 0 0 10px 0 ", ";\n\tbackground-color: ", ";\n\n\t&:focus {\n\t\toutline: 0;\n\t}\n"], ["\n\twidth: 23px;\n\theight: 23px;\n\tborder-radius: 50%;\n\tbox-shadow: 0 0 10px 0 ", ";\n\tbackground-color: ", ";\n\n\t&:focus {\n\t\toutline: 0;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White);

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_customHooks_useClickOutside__ = __webpack_require__(149);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var Tooltip = function (_a) {
    var message = _a.message;
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isDisplayed = _b[0], setIsDisplayed = _b[1];
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_customHooks_useClickOutside__["a" /* default */])(wrapperElement, isDisplayed, function () { return setIsDisplayed(false); });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Wrapper */], { ref: wrapperElement },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Icon */], { onClick: function () { return setIsDisplayed(function (prevState) { return !prevState; }); } }, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon('iconset_uprez_info2')),
        isDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Content */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: message }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 4px;\n\tright: 10px;\n"], ["\n\tposition: absolute;\n\ttop: 4px;\n\tright: 10px;\n"])));
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfill: ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 90));
var Content = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 100%;\n\tright: 0;\n\tz-index: 1;\n\twidth: 295px;\n\tpadding: 16px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 35px 0 ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 22px;\n\tcolor: ", ";\n"], ["\n\tposition: absolute;\n\ttop: 100%;\n\tright: 0;\n\tz-index: 1;\n\twidth: 295px;\n\tpadding: 16px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\tbox-shadow: 0 3px 35px 0 ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 22px;\n\tcolor: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey800, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black, 50), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MediaWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MediaWrapperColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MediaInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RangeSliderWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spread_Background__ = __webpack_require__(374);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-bottom: 15px;\n"], ["\n\tmargin-bottom: 15px;\n"])));
var MediaWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 16px;\n\tpadding: 16px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 16px;\n\tpadding: 16px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 10));
var MediaWrapperColumn = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t&:last-child {\n\t\ttext-align: right;\n\t}\n"], ["\n\t&:last-child {\n\t\ttext-align: right;\n\t}\n"])));
var MediaInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: ", ";\n\theight: 148px;\n\tborder: 2px solid ", ";\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\toverflow: hidden;\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: ", ";\n\theight: 148px;\n\tborder: 2px solid ", ";\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\toverflow: hidden;\n"])), function (_a) {
    var isPhone = _a.isPhone;
    return isPhone ? '70px' : '230px';
}, function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 10);
}, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey900);
var Image = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground: ", ";\n\tbackground-size: cover;\n\tbackground-position: ", ";\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground: ", ";\n\tbackground-size: cover;\n\tbackground-position: ", ";\n\n\t",
    "\n"])), function (_a) {
    var url = _a.url;
    return "url(" + url + ") no-repeat";
}, function (_a) {
    var left = _a.left, top = _a.top;
    return left + "% " + top + "%";
}, function (_a) {
    var scale = _a.scale;
    return scale !== __WEBPACK_IMPORTED_MODULE_4__Spread_Background__["a" /* DEFAULT_SCALE */] && "\n\t\ttransform: scale(" + scale + ");\n\t";
});
var RangeSliderWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 16px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\n\t", "\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 10px;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\tpadding: 16px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\n\t", "\n\n\t&:not(:last-of-type) {\n\t\tmargin-bottom: 10px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 10), function (_a) {
    var hasTooltip = _a.hasTooltip;
    return hasTooltip && 'padding-top: 30px;';
});
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-bottom: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tdisplay: block;\n\tmargin-bottom: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 17px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 75);
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SpreadBackgroundPanel_SliderPanel__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(180);




var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, pagesData = _a.spreadBackground.pagesData;
    var spread = spreads[currentSpreadIndex];
    var backgroundData = Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["w" /* getSpreadBgData */])(state, spread) || Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getGeneralBgData */])(state);
    var currentMedia = backgroundData.currentMedia, defaultMedia = backgroundData.defaultMedia;
    var slides = (currentMedia && currentMedia.type === __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* BackgroundMediaType */].SLIDER && 'slides' in currentMedia
        ? currentMedia
        : defaultMedia).slides;
    var page = spread[0];
    var id = "bg-slider-" + page;
    var importingSlides = pagesData[page] && pagesData[page].importingSlides || [];
    var deps = pagesData[page] && pagesData[page].deps || [];
    return {
        spread: spread,
        page: page,
        id: id,
        idInConfigs: id,
        slides: slides,
        importingSlides: importingSlides,
        deps: deps,
        bgMediaData: currentMedia,
        isGeneralBgData: !Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["w" /* getSpreadBgData */])(state, spread) && !!Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* getGeneralBgData */])(state),
        hasCustomBgMediaData: !!defaultMedia,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SpreadBackgroundPanel_SliderPanel__["a" /* default */]));


/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_SliderManager__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SpreadBackgroundPanel_SliderPanel_Slide__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__ = __webpack_require__(14);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var SliderPanel = function (_a) {
    var spread = _a.spread, page = _a.page, id = _a.id, idInConfigs = _a.idInConfigs, slides = _a.slides, importingSlides = _a.importingSlides, deps = _a.deps, bgMediaData = _a.bgMediaData, isGeneralBgData = _a.isGeneralBgData, hasCustomBgMediaData = _a.hasCustomBgMediaData, dispatch = _a.dispatch;
    var handleReset = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["R" /* setSpreadBackground */])(spread, null, isGeneralBgData));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_SliderManager__["a" /* default */], { page: page, id: id, idInConfigs: idInConfigs, slides: slides, importingSlides: importingSlides, deps: deps, SlideComponent: __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SpreadBackgroundPanel_SliderPanel_Slide__["a" /* default */], sliderWidth: 1024, sliderHeight: 768, shouldScaleImage: true, isBackgroundSlider: true, onImportSlides: function (page, id, idInConfigs, newSlidesData, isFromDesktop) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["p" /* importSlidesToSpreadBackground */])(page, newSlidesData, isFromDesktop)); }, onUpdateSliderConfig: function (page, id, data, isFirstSlideChanged) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["R" /* setSpreadBackground */])(spread, __assign({}, bgMediaData, { slides: data }), isGeneralBgData, true, isFirstSlideChanged));
            }, onUpdateSliderElement: function (page, id, data, shouldSave, isFirstSlideChanged) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_actions__["_7" /* updateSpreadBackgroundServiceData */])(page, data, shouldSave, isFirstSlideChanged)); } }),
        hasCustomBgMediaData &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ButtonReset */], { type: "button", onClick: handleReset },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.reset_to_default" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (SliderPanel);


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SlideSelector__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Slide_TextEditor__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ResourceSelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResourceSelector__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__YoutubeLinkPanel__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_ImportManager_actions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__typings_dnd__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_driveItem__ = __webpack_require__(11);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;
















var SelectorType;
(function (SelectorType) {
    SelectorType["ADD"] = "ADD";
    SelectorType["EDIT"] = "EDIT";
})(SelectorType || (SelectorType = {}));
var fileExtensions = __spread(__WEBPACK_IMPORTED_MODULE_15__utils_driveItem__["d" /* default */].imageWithPdfExtensions, __WEBPACK_IMPORTED_MODULE_15__utils_driveItem__["d" /* default */].videoExtensions);
var isValidResourceFromApp = function (_a) {
    var type = _a.type;
    return ([__WEBPACK_IMPORTED_MODULE_13__typings_api__["a" /* Api */].DriveItemType.Image, __WEBPACK_IMPORTED_MODULE_13__typings_api__["a" /* Api */].DriveItemType.Movie].includes(type));
};
var getSlideData = function (_a, slideId, slideText) {
    var selectedItem = _a.selectedItem, url = _a.url;
    var slideData = {
        globalId: null,
        label: '',
        genericItemId: null,
        parentDriveGId: null,
        relUrl: '',
        externalRelUrl: '',
        isExternalLink: false,
        type: __WEBPACK_IMPORTED_MODULE_13__typings_api__["a" /* Api */].AssetItemFileTypes.DEFAULT,
        id: slideId,
        slideText: slideText,
    };
    if (selectedItem) {
        var type = selectedItem.type, label = selectedItem.label, relUrl = selectedItem.relUrl, genericItemId = selectedItem.genericItemId, globalId = selectedItem.globalId, resolution = selectedItem.resolution, iconName = selectedItem.iconName;
        slideData = __assign({}, slideData, { type: type,
            label: label, relUrl: Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_utils_helpers__["t" /* getMediaUrl */])(relUrl), genericItemId: genericItemId,
            globalId: globalId,
            resolution: resolution,
            iconName: iconName, isExternalLink: false, externalRelUrl: '' });
    }
    if (url) {
        slideData = __assign({}, slideData, { externalRelUrl: url, isExternalLink: true });
    }
    return slideData;
};
var SliderManager = function (_a) {
    var page = _a.page, id = _a.id, idInConfigs = _a.idInConfigs, slides = _a.slides, importingSlides = _a.importingSlides, deps = _a.deps, SlideComponent = _a.SlideComponent, sliderWidth = _a.sliderWidth, sliderHeight = _a.sliderHeight, shouldScaleImage = _a.shouldScaleImage, isBackgroundSlider = _a.isBackgroundSlider, config = _a.config, dispatch = _a.dispatch, onImportSlides = _a.onImportSlides, onUpdateSliderConfig = _a.onUpdateSliderConfig, onUpdateSliderElement = _a.onUpdateSliderElement;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), selectorType = _b[0], setSelectorType = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](null), 2), activeSlideIndex = _c[0], setActiveSlideIndex = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isTextEditorDisplayed = _d[0], setIsTextEditorDisplayed = _d[1];
    var lastSlideElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var getNewSlideId = function (index) {
        if (index === void 0) { index = 0; }
        return Date.now() + "-" + (slides.length + importingSlides.length + index);
    };
    var handleAddButtonClick = function () {
        setSelectorType(SelectorType.ADD);
    };
    var handleEditButtonClick = function (index) {
        setActiveSlideIndex(index);
        setSelectorType(SelectorType.EDIT);
    };
    var handleButtonEditTextClick = function () {
        setIsTextEditorDisplayed(true);
        setSelectorType(null);
    };
    var handleTextEditorClose = function () {
        setIsTextEditorDisplayed(false);
        setActiveSlideIndex(null);
    };
    var handleAddSlidesFromDesktopFiles = function (files) {
        setSelectorType(null);
        var newSlidesData = files.map(function (file, index) { return (__assign({}, getSlideData({}, getNewSlideId(index)), { label: file.name, file: file })); });
        onImportSlides(page, id, idInConfigs, newSlidesData, true);
        scrollToLastSlide();
    };
    var handleAddSlideFromLink = function (url) {
        setSelectorType(null);
        var slideData = getSlideData({ url: url }, getNewSlideId());
        var prevSlides = __spread(slides);
        var isFirstSlideChanged = prevSlides.length === 0;
        onUpdateSliderConfig(page, idInConfigs, __spread(prevSlides, [slideData]), isFirstSlideChanged);
        if (isFirstSlideChanged) {
            // is needed for thumbnail regeneration
            onUpdateSliderElement(page, id, {}, true, true);
        }
        scrollToLastSlide();
    };
    var handleEditSlide = function (_a) {
        var selectedItem = _a.selectedItem, url = _a.url;
        setSelectorType(null);
        var slideIndex = activeSlideIndex;
        var _b = slides[slideIndex], slideId = _b.id, oldGlobalId = _b.globalId, slideText = _b.slideText;
        var slideData = getSlideData({ selectedItem: selectedItem, url: url }, slideId, slideText);
        var newGlobalId = slideData.globalId;
        var newSlides = __spread(slides.slice(0, slideIndex), [
            slideData
        ], slides.slice(slideIndex + 1));
        var isFirstSlideChanged = slideIndex === 0;
        onUpdateSliderConfig(page, idInConfigs, newSlides, isFirstSlideChanged);
        var newDeps = __spread(deps);
        if (oldGlobalId) {
            newDeps = newDeps.filter(function (dep) { return !dep.includes(oldGlobalId.toString()); });
        }
        if (newGlobalId) {
            newDeps.push(Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_utils_helpers__["j" /* getDependencyString */])(newGlobalId));
        }
        onUpdateSliderElement(page, id, {
            deps: newDeps,
        }, true, isFirstSlideChanged);
        setActiveSlideIndex(null);
    };
    var handleEditSlideText = function (slideText) {
        var slideIndex = activeSlideIndex;
        var newSlides = __spread(slides.slice(0, slideIndex), [
            __assign({}, slides[slideIndex], { slideText: slideText })
        ], slides.slice(slideIndex + 1));
        onUpdateSliderConfig(page, idInConfigs, newSlides);
    };
    var handleRemoveSlide = function (slideId, index) {
        var isImportingSlide = importingSlides.map(function (_a) {
            var id = _a.id;
            return id;
        }).includes(slideId);
        if (isImportingSlide) {
            onUpdateSliderElement(page, id, {
                importingSlides: importingSlides.filter(function (_a) {
                    var id = _a.id;
                    return id !== slideId;
                }),
            }, false);
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__containers_ImportManager_actions__["i" /* removeFileFromImport */])(slideId));
            return;
        }
        var globalId = slides[index].globalId;
        var newSlides = slides.filter(function (slide, slideIndex) { return slideIndex !== index; });
        var isFirstSlideChanged = index === 0;
        onUpdateSliderConfig(page, idInConfigs, newSlides, isFirstSlideChanged);
        onUpdateSliderElement(page, id, {
            deps: globalId ? deps.filter(function (dep) { return !dep.includes(globalId.toString()); }) : deps,
        }, true, isFirstSlideChanged);
    };
    var handleDragEndSlide = function (_a) {
        var source = _a.source, destination = _a.destination;
        if (!destination || source.index === destination.index) {
            return;
        }
        var slideData = slides[source.index];
        var newSlides = slides.filter(function (slide, slideIndex) { return slideIndex !== source.index; });
        newSlides = __spread(newSlides.slice(0, destination.index), [
            slideData
        ], newSlides.slice(destination.index));
        var isFirstSlideChanged = source.index === 0 || destination.index === 0;
        onUpdateSliderConfig(page, idInConfigs, newSlides, isFirstSlideChanged);
        if (isFirstSlideChanged) {
            // is needed for thumbnail regeneration
            onUpdateSliderElement(page, id, {}, true, true);
        }
    };
    var handleResourceSelect = function (_a) {
        var _b = __read(_a, 1), driveItem = _b[0];
        return __awaiter(_this, void 0, void 0, function () {
            var aspDriveItem;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setSelectorType(null);
                        return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__containers_DriveItemList_actions__["k" /* getAspDriveItem */])(driveItem.id))];
                    case 1:
                        aspDriveItem = _c.sent();
                        handleEditSlide({ selectedItem: aspDriveItem });
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleMultipleResourcesSelect = function (selectedItems) {
        setSelectorType(null);
        var newSlidesData = selectedItems.map(function (_a, index) {
            var label = _a.label, id = _a.id;
            return (__assign({}, getSlideData({}, getNewSlideId(index)), { label: label, globalId: id }));
        });
        onImportSlides(page, id, idInConfigs, newSlidesData);
        scrollToLastSlide();
    };
    var handleLinkChange = function (url) {
        if (selectorType === SelectorType.ADD) {
            handleAddSlideFromLink(url);
        }
        if (selectorType === SelectorType.EDIT) {
            handleEditSlide({ url: url });
        }
    };
    var scrollToLastSlide = function () {
        // is needed for waiting when importing slides are added to the list
        setTimeout(function () {
            if (lastSlideElement.current) {
                lastSlideElement.current.scrollIntoView();
            }
        }, 0);
    };
    var renderSlideSelector = function () {
        if (selectorType === SelectorType.ADD) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SlideSelector__["a" /* default */], { label: "messages.add_slide", onCancel: function () { return setSelectorType(null); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_ResourceSelector__["a" /* default */], { id: "add-slide", isValidResourceFromApp: isValidResourceFromApp, fileExtensions: fileExtensions, isFileExtensionsDisplayed: true, isOptimizedImageImport: true, isPublicationDependency: true, isMultipleSelection: true, linkPanel: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__YoutubeLinkPanel__["a" /* default */], { value: "", onChange: handleLinkChange })), theme: __WEBPACK_IMPORTED_MODULE_8__ResourceSelector__["a" /* ResourceSelectorTheme */].DARK, customImportHandler: function (files) { return handleAddSlidesFromDesktopFiles(files); }, onSelect: handleMultipleResourcesSelect })));
        }
        if (selectorType === SelectorType.EDIT) {
            var _a = slides[activeSlideIndex], slideId = _a.id, externalRelUrl = _a.externalRelUrl, slideText = _a.slideText;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SlideSelector__["a" /* default */], { label: "messages.modify_slide", onCancel: function () { return setSelectorType(null); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_ResourceSelector__["a" /* default */], { id: slideId, isValidResourceFromApp: isValidResourceFromApp, fileExtensions: fileExtensions, isFileExtensionsDisplayed: true, isOptimizedImageImport: true, isPublicationDependency: true, linkPanel: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__YoutubeLinkPanel__["a" /* default */], { value: externalRelUrl, onChange: handleLinkChange })), theme: __WEBPACK_IMPORTED_MODULE_8__ResourceSelector__["a" /* ResourceSelectorTheme */].DARK, onSelect: handleResourceSelect }),
                slideText && slideText.value &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ButtonEditText */], { onClick: handleButtonEditTextClick },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.edit_text" }))));
        }
        return null;
    };
    if (isTextEditorDisplayed) {
        var _e = slides[activeSlideIndex], relUrl = _e.relUrl, externalRelUrl = _e.externalRelUrl, isExternalLink = _e.isExternalLink, iconName = _e.iconName, slideText = _e.slideText;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Slide_TextEditor__["a" /* default */], { previewUrl: Object(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_utils_helpers__["F" /* getSliderPreviewUrl */])(config, relUrl, isExternalLink, externalRelUrl, iconName), previewWidth: sliderWidth, previewHeight: sliderHeight, shouldScalePreview: shouldScaleImage, isBackgroundSlide: isBackgroundSlider, text: slideText, slidesLength: slides.length, onConfirm: handleEditSlideText, onCancel: handleTextEditorClose }));
    }
    if (selectorType) {
        return renderSlideSelector();
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* Label */], { value: "messages.create_your_slider" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { disabled: importingSlides.length > 0, onClick: handleAddButtonClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.add_slide" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["a" /* DragDropContext */], { onDragEnd: handleDragEndSlide },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["c" /* Droppable */], { droppableId: "slider", type: __WEBPACK_IMPORTED_MODULE_14__typings_dnd__["a" /* DndItemTypes */].EDITABLE_SLIDE }, function (provided) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* SlidesList */], __assign({ ref: provided.innerRef }, provided.droppableProps),
                slides.map(function (slide, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { ref: index === slides.length - 1 ? lastSlideElement : undefined, key: index },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SlideComponent, { page: page, sliderId: id, item: slide, index: index, onEdit: handleEditButtonClick, onRemove: handleRemoveSlide }))); }),
                importingSlides.map(function (slide, index) {
                    var slideIndex = slides.length + index;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: slideIndex },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SlideComponent, { page: page, sliderId: id, item: slide, index: slideIndex, onEdit: handleEditButtonClick, onRemove: handleRemoveSlide })));
                }),
                provided.placeholder)); }))));
};
/* harmony default export */ __webpack_exports__["a"] = (SliderManager);


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SlidesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonEditText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(36);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var SlidesList = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('ul')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: 16px 0 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\tuser-select: none;\n\n\tli + li {\n\t\tmargin-top: 6px;\n\t}\n"], ["\n\tmargin: 16px 0 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\tuser-select: none;\n\n\tli + li {\n\t\tmargin-top: 6px;\n\t}\n"])));
var ButtonEditText = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Button */])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-top: 12px;\n"], ["\n\tmargin-top: 12px;\n"])));

var templateObject_1, templateObject_2;


/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(36);



var SlideSelector = function (_a) {
    var label = _a.label, children = _a.children, onCancel = _a.onCancel;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Header */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* HeaderButton */], { onClick: onCancel },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* HeaderLabel */], { value: label })),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (SlideSelector);


/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SlidePreview__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1661);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var getTextForTextArea = function (text) { return (text.replace(/\<br \/\>/g, '\n')); };
var getTextForSlide = function (text) { return (text.replace(/\n\r?/g, '<br />')); };
var TextEditor = function (_a) {
    var previewUrl = _a.previewUrl, previewWidth = _a.previewWidth, previewHeight = _a.previewHeight, shouldScalePreview = _a.shouldScalePreview, isBackgroundSlide = _a.isBackgroundSlide, initialText = _a.text, slidesLength = _a.slidesLength, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](initialText.value), 2), textValue = _b[0], setTextValue = _b[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setTextValue(initialText.value);
    }, [initialText.value]);
    var handleTextAreaChange = function (e) {
        setTextValue(e.target.value);
    };
    var handleConfirm = function () {
        var valueToSave = getTextForSlide(textValue);
        if (valueToSave !== initialText.value) {
            onConfirm(__assign({}, initialText, { value: getTextForSlide(textValue) }));
        }
        onCancel();
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Header */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* HeaderButton */], { onClick: onCancel },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.cancel" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* HeaderLabel */], { value: "messages.edit_text" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* HeaderButton */], { onClick: handleConfirm },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.ok" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__SlidePreview__["a" /* default */], { url: previewUrl, width: previewWidth, height: previewHeight, shouldImageScale: shouldScalePreview, isBackgroundSlide: isBackgroundSlide, textValue: getTextForSlide(textValue), textFontFamily: initialText.font.family, textSize: initialText.font.size, textColor: initialText.font.color, textBackgroundColor: initialText.font.backgroundColor, textShadowColor: initialText.font.shadowColor, textPosition: initialText.position, slidesLength: slidesLength }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Label */], { value: "messages.enter_your_text" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* TextArea */], { value: getTextForTextArea(textValue), onChange: handleTextAreaChange })));
};
/* harmony default export */ __webpack_exports__["a"] = (TextEditor);


/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



var MAX_DOTS = 5;
var SlidePreview = function (_a) {
    var url = _a.url, width = _a.width, height = _a.height, shouldImageScale = _a.shouldImageScale, isBackgroundSlide = _a.isBackgroundSlide, textValue = _a.textValue, textFontFamily = _a.textFontFamily, textSize = _a.textSize, textColor = _a.textColor, textBackgroundColor = _a.textBackgroundColor, textShadowColor = _a.textShadowColor, textPosition = _a.textPosition, slidesLength = _a.slidesLength;
    var wrapperElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](1), 2), textScale = _b[0], setTextScale = _b[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"](function () {
        if (wrapperElement.current) {
            var offsetWidth = wrapperElement.current.offsetWidth;
            setTextScale(offsetWidth / width);
        }
    }, [width]);
    var dotsLength = Math.min(slidesLength, MAX_DOTS);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* Wrapper */], { ref: wrapperElement },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* ImageWrapper */], { width: width, height: height },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Image */], { src: url, shouldScale: shouldImageScale }),
            !isBackgroundSlide &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Dots */], { itemsLength: dotsLength }, Array.from({ length: dotsLength }, function (v, i) { return i + 1; }).map(function (i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Dot */], { key: i })); })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Arrow */], null, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_back')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Arrow */], { isRight: true }, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].getSvgIcon('iconset_back')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* TextWrapper */], { position: textPosition, isBackgroundSlide: isBackgroundSlide },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* Text */], { dangerouslySetInnerHTML: { __html: textValue }, fontFamily: textFontFamily, size: textSize * textScale, color: textColor, backgroundColor: textBackgroundColor, shadowColor: textShadowColor, position: textPosition }))));
};
/* harmony default export */ __webpack_exports__["a"] = (SlidePreview);


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ImageWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TextWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Dots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Dot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__ = __webpack_require__(325);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n"])));
var ImageWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 100%;\n\tpadding-top: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 6px;\n\toverflow: hidden;\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\twidth: 100%;\n\tpadding-top: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 6px;\n\toverflow: hidden;\n"])), function (_a) {
    var width = _a.width, height = _a.height;
    return (height / width) * 100 + "%";
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White);
var Image = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('img')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\twidth: auto;\n\theight: auto;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tmargin: auto;\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\twidth: auto;\n\theight: auto;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tmargin: auto;\n\n\t",
    "\n"])), function (_a) {
    var shouldScale = _a.shouldScale;
    return shouldScale && "\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tobject-fit: cover;\n\t";
});
var TextWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\n\t", "\n\n\t", "\n"], ["\n\tposition: ",
    ";\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\n\t",
    "\n\n\t",
    "\n"])), function (_a) {
    var y = _a.position.y;
    return ([
        __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].ABOVE_SLIDE,
        __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].UNDER_SLIDE,
    ].includes(y) ? 'static' : 'absolute');
}, function (_a) {
    var x = _a.position.x;
    switch (x) {
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["a" /* SlideTextXPosition */].LEFT:
            return 'justify-content: flex-start;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["a" /* SlideTextXPosition */].CENTER:
            return 'justify-content: center;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["a" /* SlideTextXPosition */].RIGHT:
            return 'justify-content: flex-end;';
    }
}, function (_a) {
    var y = _a.position.y, isBackgroundSlide = _a.isBackgroundSlide;
    switch (y) {
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].BOTTOM:
            return "bottom: " + (isBackgroundSlide ? 0 : 20) + "px;";
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].CENTER:
            return "\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t";
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].TOP:
            return 'top: 0;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].ABOVE_SLIDE:
            return 'order: -1;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["b" /* SlideTextYPosition */].UNDER_SLIDE:
            return '';
    }
});
var Text = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: 5px;\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tline-height: 1.2;\n\tcolor: ", ";\n\t", ";\n\t", ";\n\n\t", "\n"], ["\n\tpadding: 5px;\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tline-height: 1.2;\n\tcolor: ", ";\n\t", ";\n\t", ";\n\n\t",
    "\n"])), function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily;
}, function (_a) {
    var size = _a.size;
    return size + "px";
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor && "background-color: " + backgroundColor;
}, function (_a) {
    var shadowColor = _a.shadowColor;
    return shadowColor && "text-shadow: 1px 1px 2px " + shadowColor;
}, function (_a) {
    var x = _a.position.x;
    switch (x) {
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["a" /* SlideTextXPosition */].LEFT:
            return 'text-align: left;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["a" /* SlideTextXPosition */].CENTER:
            return 'text-align: center;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_utils_indesignEditor_editableSliders_getData__["a" /* SlideTextXPosition */].RIGHT:
            return 'text-align: right;';
    }
});
var Dots = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 5px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tdisplay: flex;\n\talign-items: center;\n\twidth: ", ";\n"], ["\n\tposition: absolute;\n\tbottom: 5px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tdisplay: flex;\n\talign-items: center;\n\twidth: ", ";\n"])), function (_a) {
    var itemsLength = _a.itemsLength;
    return itemsLength * 11 + "px";
});
var Dot = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tflex: 0 0 6px;\n\theight: 6px;\n\tmargin: 2px 2.5px;\n\tborder-radius: 50%;\n\tbackground: ", ";\n\topacity: 0.6;\n\tbox-shadow: 1px 1px 2px 1px ", ";\n"], ["\n\tflex: 0 0 6px;\n\theight: 6px;\n\tmargin: 2px 2.5px;\n\tborder-radius: 50%;\n\tbackground: ", ";\n\topacity: 0.6;\n\tbox-shadow: 1px 1px 2px 1px ", ";\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, 30));
var Arrow = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 27px;\n\theight: 27px;\n\tborder-radius: 8px;\n\tbackground: ", ";\n\n\t", ";\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: ", ";\n\n\t\t", ";\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 27px;\n\theight: 27px;\n\tborder-radius: 8px;\n\tbackground: ", ";\n\n\t", ";\n\n\tsvg {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tfill: ", ";\n\n\t\t", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 90), function (_a) {
    var isRight = _a.isRight;
    return isRight ? 'right: 5px;' : 'left: 5px;';
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Black, function (_a) {
    var isRight = _a.isRight;
    return isRight && 'transform: rotate(180deg);';
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmargin-top: 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tcolor: ", ";\n"], ["\n\tdisplay: block;\n\tmargin-top: 20px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tcolor: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, 75));
var TextArea = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('textarea')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100px;\n\tpadding: 10px;\n\tresize: none;\n\toutline: 0;\n\tborder-radius: 6px;\n\tborder: 1px solid transparent;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\n\t&:hover,\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100px;\n\tpadding: 10px;\n\tresize: none;\n\toutline: 0;\n\tborder-radius: 6px;\n\tborder: 1px solid transparent;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tcolor: ", ";\n\n\t&:hover,\n\t&:focus {\n\t\tborder-color: ", ";\n\t}\n\n\t", "\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, 10), __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_3__utils_styles_constants__["c" /* StyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_2__styles__["j" /* getEditorScrollStyles */])({ width: 4 }));

var templateObject_1, templateObject_2;


/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderManager_Slide__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);



var mapStateToProps = function (state, ownProps) {
    var pagesData = state.editor.spreadBackground.pagesData, config = state.galleryInfos.config, importManager = state.importManager;
    var page = ownProps.page, item = ownProps.item;
    var iconName = item.iconName, relUrl = item.relUrl, externalRelUrl = item.externalRelUrl, isExternalLink = item.isExternalLink;
    var importingSlides = pagesData[page] && pagesData[page].importingSlides || [];
    var previewUrl = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["F" /* getSliderPreviewUrl */])(config, relUrl, isExternalLink, externalRelUrl, iconName);
    var importData = importManager.byId[item.id];
    return {
        page: page,
        previewUrl: previewUrl,
        isImporting: importingSlides.map(function (_a) {
            var id = _a.id;
            return id;
        }).includes(item.id),
        importPercentage: importData ? importData.percentage : 0,
        importError: importData ? importData.error : undefined,
        isDragDisabled: importingSlides.length > 0,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderManager_Slide__["a" /* default */]));


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PreviewWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Preview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tposition: relative;\n\theight: 70px;\n\tpadding: 8px 84px 0 33px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tposition: relative;\n\theight: 70px;\n\tpadding: 8px 84px 0 33px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\n\t",
    "\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 10), function (_a) {
    var isDragging = _a.isDragging;
    return isDragging && "\n\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450, 30) + ";\n\t";
});
var IconMove = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 0;\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 33px;\n\theight: 33px;\n\tpadding-top: 3px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 17px;\n\t\theight: 19px;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 0;\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 33px;\n\theight: 33px;\n\tpadding-top: 3px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 17px;\n\t\theight: 19px;\n\t\tfill: currentColor;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 50));
var PreviewWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 220px;\n\tmargin-left: 10px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 220px;\n\tmargin-left: 10px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 50));
var IconType = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: relative;\n\tflex: 0 0 38px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 38px;\n\theight: 38px;\n\tborder-radius: 4px 0 0 4px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tfill: currentColor;\n\t}\n\n\t", "\n"], ["\n\tposition: relative;\n\tflex: 0 0 38px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 38px;\n\theight: 38px;\n\tborder-radius: 4px 0 0 4px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tfill: currentColor;\n\t}\n\n\t",
    "\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75), function (_a) {
    var hasText = _a.hasText;
    return hasText && "\n\t\t&::after {\n\t\t\tcontent: 'T';\n\t\t\tposition: absolute;\n\t\t\tbottom: 5px;\n\t\t\tright: 1px;\n\t\t\tfont-family: serif;\n\t\t\tfont-size: 10px;\n\t\t}\n\t";
});
var Preview = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('img')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 38px;\n\tborder-radius: 0 4px 4px 0;\n\tobject-fit: cover;\n"], ["\n\twidth: 100%;\n\theight: 38px;\n\tborder-radius: 0 4px 4px 0;\n\tobject-fit: cover;\n"])));
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\twidth: 220px;\n\tmargin-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 10px;\n\tline-height: 20px;\n\tletter-spacing: 0.15px;\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"], ["\n\twidth: 220px;\n\tmargin-left: 10px;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 10px;\n\tline-height: 20px;\n\tletter-spacing: 0.15px;\n\tcolor: ", ";\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75));
var ActionsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 17px;\n\tright: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 50px;\n"], ["\n\tposition: absolute;\n\ttop: 17px;\n\tright: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 50px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder-radius: 50%;\n\tborder: 2px solid ", ";\n\toutline: 0;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\t&:only-child {\n\t\tmargin-left: auto;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\tborder-radius: 50%;\n\tborder: 2px solid ", ";\n\toutline: 0;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t> svg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\n\t&:only-child {\n\t\tmargin-left: auto;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var isRemoveButton = _a.isRemoveButton;
    return isRemoveButton ? '8px' : '16px';
}, function (_a) {
    var isRemoveButton = _a.isRemoveButton;
    return isRemoveButton ? '8px' : '16px';
});

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1665);



var getMessage = function (percentage, error) {
    if (!error) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.importing_with_percentage", percentage: percentage.toString() }));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "error.file_import_error_short" }));
};
var ProgressBar = function (_a) {
    var percentage = _a.percentage, error = _a.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Wrapper */], { isError: !!error },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Inner */], { width: percentage, isError: !!error }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Label */], null, getMessage(percentage, error))));
};
/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tborder: 1px solid currentColor;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\ttext-align: center;\n\tline-height: 36px;\n\toverflow: hidden;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1;\n\tborder: 1px solid currentColor;\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\ttext-align: center;\n\tline-height: 36px;\n\toverflow: hidden;\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey700, function (_a) {
    var isError = _a.isError;
    return isError ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Red : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White;
});
var Inner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\twidth: ", ";\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\ttransition: width 0.1s ease-in;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\twidth: ", ";\n\tborder-radius: inherit;\n\tbackground-color: ", ";\n\ttransition: width 0.1s ease-in;\n"])), function (_a) {
    var width = _a.width;
    return width + "%";
}, function (_a) {
    var isError = _a.isError;
    return isError ? 'transparent' : Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 50);
});
var Label = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n\tz-index: 1;\n"], ["\n\tposition: relative;\n\tz-index: 1;\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonReset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(36);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var ButtonReset = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Button */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-top: 16px;\n"], ["\n\tmargin-top: 16px;\n"])));

var templateObject_1;


/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Page__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_url__ = __webpack_require__(26);






var mapStateToProps = function (state, _a) {
    var page = _a.page;
    var _b = state.editor, type = _b.type, _c = _b.pagesController, spreads = _c.spreads, prevSpreadIndex = _c.prevSpreadIndex, pages = _b.pages, activeItem = _b.activeItem, pagesData = _b.configs.pagesData, isAccessibleVersion = _b.isAccessibleVersion, editableMedia = _b.editableMedia, galleryInfos = state.galleryInfos;
    var resourceId = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* getClientAndResourceIds */])().tempGId;
    var prevPage = !isAccessibleVersion ? spreads[prevSpreadIndex][0] : prevSpreadIndex + 1; // for HTML editor only
    var _d = pages[pages[page] ? page : prevPage], fontsPath = _d.fontsPath, googleFontsPath = _d.googleFontsPath;
    var showAloneSide = type === __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* EditorType */].INDESIGN && pagesData[page - 1]
        ? pagesData[page - 1].showAloneSide
        : undefined;
    return {
        editorType: type,
        html: pages[page] ? pages[page].html : '',
        isEditable: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["x" /* isEditablePage */])(state, page) || isAccessibleVersion,
        editableTextFieldsIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["u" /* getPageEditableTextFieldsIds */])(state, page),
        pageEditableMedia: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["p" /* getPageEditableMedia */])(state, page),
        editableMediaIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["q" /* getPageEditableMediaIds */])(state, page),
        editableLinksIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["o" /* getPageEditableLinksIds */])(state, page),
        editableButtonsIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["i" /* getPageEditableButtonsIds */])(state, page),
        editableIframesIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["m" /* getPageEditableIframesIds */])(state, page),
        editableEnrichmentsIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["k" /* getPageEditableEnrichmentsIds */])(state, page),
        editableSlidersIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["s" /* getPageEditableSlidersIds */])(state, page),
        themedItemsIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["v" /* getPageThemedItemsIds */])(state, page),
        isSomeEditableItemActive: !!activeItem.id && activeItem.page === page,
        iframeUrl: __WEBPACK_IMPORTED_MODULE_5__utils_url__["b" /* default */].getComponentUrl(galleryInfos, resourceId),
        fontsPath: fontsPath,
        googleFontsPath: googleFontsPath,
        isTransparent: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["e" /* getIsTransparentPage */])(state, page),
        showAloneSide: showAloneSide,
        isAccessibleVersion: isAccessibleVersion,
        editableMedia: editableMedia,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Page__["a" /* default */]));


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_Page_Content__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_RichTextEditor__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_MediaEditor__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_LinkEditor__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_ButtonEditor__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_IframeEditor__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Editor_EnrichmentEditor__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Editor_SliderEditor__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Editor_ThemedItemEditor__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Portal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_Editor_utils_indesignEditor_constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_NotificationBar_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(1);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _this = this;



















var svgSpritePath = __webpack_require__(357);
var Page = function (_a) {
    var editorType = _a.editorType, page = _a.page, width = _a.width, height = _a.height, spreadZoom = _a.spreadZoom, pageScale = _a.pageScale, isLoaded = _a.isLoaded, html = _a.html, iframeUrl = _a.iframeUrl, fontsPath = _a.fontsPath, googleFontsPath = _a.googleFontsPath, isEditable = _a.isEditable, editableTextFieldsIds = _a.editableTextFieldsIds, editableLinksIds = _a.editableLinksIds, editableButtonsIds = _a.editableButtonsIds, editableIframesIds = _a.editableIframesIds, editableEnrichmentsIds = _a.editableEnrichmentsIds, editableSlidersIds = _a.editableSlidersIds, themedItemsIds = _a.themedItemsIds, isSomeEditableItemActive = _a.isSomeEditableItemActive, editorContainer = _a.editorContainer, isTransparent = _a.isTransparent, showAloneSide = _a.showAloneSide, dispatch = _a.dispatch, _b = _a.onLoad, onLoad = _b === void 0 ? function () { return undefined; } : _b, isAccessibleVersion = _a.isAccessibleVersion, pageEditableMedia = _a.pageEditableMedia, editableMediaIds = _a.editableMediaIds, editableMedia = _a.editableMedia;
    // is needed for initial render to prevent page jumping (when page sizes are not calculated)
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isDisplayed = _c[0], setIsDisplayed = _c[1];
    var _d = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isIframeDocumentReady = _d[0], setIsIframeDocumentReady = _d[1];
    var iframe = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        setIsDisplayed(true);
        return function () {
            setIsDisplayed(false);
        };
    }, [page]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (!isSomeEditableItemActive) {
            return;
        }
        var handleWindowClick = function (e) {
            var element = e.target;
            var shouldIgnoreClick = !!element.closest("." + __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */]);
            if (!shouldIgnoreClick) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__containers_Editor_actions__["A" /* resetActiveItem */])());
            }
        };
        if (editorContainer) {
            editorContainer.addEventListener('mousedown', handleWindowClick);
        }
        if (iframe.current) {
            iframe.current.contentDocument.addEventListener('mousedown', handleWindowClick);
        }
        if (__WEBPACK_IMPORTED_MODULE_18__utils__["d" /* default */].isEmbedMode()) {
            window.parent.addEventListener('mousedown', handleWindowClick);
        }
        return function () {
            if (editorContainer) {
                editorContainer.removeEventListener('mousedown', handleWindowClick);
            }
            if (iframe.current) {
                iframe.current.contentDocument.removeEventListener('mousedown', handleWindowClick);
            }
            if (__WEBPACK_IMPORTED_MODULE_18__utils__["d" /* default */].isEmbedMode()) {
                window.parent.removeEventListener('mousedown', handleWindowClick);
            }
        };
    }, [isSomeEditableItemActive]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["e" /* EditorType */].HTML) {
            setIsIframeDocumentReady(false);
        }
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["e" /* EditorType */].INDESIGN) {
            return;
        }
        // load fonts to main document to render them in text edit panel
        var addEditorFonts = function () {
            var addLinkElement = function (id, href) {
                var linkElement = document.createElement('link');
                linkElement.id = id;
                linkElement.rel = 'stylesheet';
                linkElement.href = href;
                document.head.appendChild(linkElement);
            };
            if (fontsPath) {
                if (fontsPath) {
                    addLinkElement(__WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__["e" /* editorFontsId */], iframeUrl.replace('index.html', fontsPath));
                }
            }
            if (googleFontsPath) {
                addLinkElement(__WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__["f" /* editorGoogleFontsId */], googleFontsPath);
            }
        };
        var removeEditorFonts = function () {
            var removeLinkElement = function (id) {
                var linkElement = document.querySelector("#" + id);
                if (linkElement) {
                    linkElement.parentNode.removeChild(linkElement);
                }
            };
            removeLinkElement(__WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__["e" /* editorFontsId */]);
            removeLinkElement(__WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__["f" /* editorGoogleFontsId */]);
        };
        addEditorFonts();
        return function () { return removeEditorFonts(); };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"](function () {
        if (editorType === __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["e" /* EditorType */].INDESIGN && isLoaded && spreadZoom >= 1) {
            scaleLockedIcons(pageScale);
        }
    }, [editorType, isLoaded, pageScale, spreadZoom]);
    var scaleLockedIcons = function (pageScale) {
        var lockedIcons = __spread(document.querySelectorAll("." + __WEBPACK_IMPORTED_MODULE_13__containers_Editor_utils_indesignEditor_constants__["c" /* default */].lockedIconClassName));
        lockedIcons.forEach(function (icon) {
            icon.style.transform = "scale(" + 1 / pageScale + ")";
        });
    };
    var handleIframeLoad = function () { return __awaiter(_this, void 0, void 0, function () {
        var addEditorStyles, addSvgSprite, iframeDocument, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    addEditorStyles = function (iframeDocument) {
                        var editorStyleElement = iframeDocument.createElement('style');
                        editorStyleElement.id = __WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__["g" /* editorStylesId */];
                        editorStyleElement.innerHTML = __WEBPACK_IMPORTED_MODULE_2__styles__["e" /* htmlEditorStyles */];
                        iframeDocument.head.appendChild(editorStyleElement);
                    };
                    addSvgSprite = function (iframeDocument) { return __awaiter(_this, void 0, void 0, function () {
                        var svgSprite, div;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_18__utils__["d" /* default */].promiseXHR('GET', svgSpritePath, undefined, undefined, undefined, undefined, undefined, true)];
                                case 1:
                                    svgSprite = _a.sent();
                                    div = iframeDocument.createElement('div');
                                    div.innerHTML = svgSprite.responseText;
                                    iframeDocument.body.appendChild(div);
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    iframeDocument = iframe.current.contentDocument;
                    addEditorStyles(iframeDocument);
                    iframeDocument.body.innerHTML = html;
                    return [4 /*yield*/, addSvgSprite(iframeDocument)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__containers_NotificationBar_actions__["c" /* createNotification */])('error.parse_editor_data_error'));
                    return [3 /*break*/, 5];
                case 4:
                    setIsIframeDocumentReady(true);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getParentContainer = function (id) {
        var selector = editorType === __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["e" /* EditorType */].INDESIGN
            ? "[data-page=\"" + page + "\"] #" + id
            : "[" + __WEBPACK_IMPORTED_MODULE_16__containers_Editor_utils_htmlEditor_constants__["c" /* editableId */] + "=" + id + "]";
        var pageDocument = iframe.current ? iframe.current.contentDocument : document;
        if (!pageDocument) {
            return null;
        }
        return pageDocument.querySelector(selector);
    };
    var renderRichTextEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, editableTextFieldsIds.map(function (id) {
        // tslint:disable-next-line: max-line-length
        // We have to render <RichTextEditor /> in corresponding DOM nodes in <Background /> to keep all parents of text frames generated by inDesign
        // (e.g., text frames inside groups or animated frames)
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_RichTextEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale, isEdited: parentContainer.classList.contains(__WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["q" /* editedElementClassName */]) })));
    }))); };
    var renderMediaEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        isAccessibleVersion && pageEditableMedia.map(function (editableMediaItem) {
            var id = editableMediaItem.id;
            var parentContainer = getParentContainer(id);
            return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_MediaEditor__["a" /* default */], { page: page, editableMediaItem: editableMediaItem, pageScale: pageScale, parentContainer: parentContainer, iframeContainer: iframe.current })));
        }),
        !isAccessibleVersion && editableMediaIds.map(function (id) {
            var editableMediaItem = editableMedia[page][id];
            var parentContainer = getParentContainer(id);
            return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_MediaEditor__["a" /* default */], { page: page, editableMediaItem: editableMediaItem, pageScale: pageScale, parentContainer: parentContainer, iframeContainer: iframe.current })));
        }))); };
    var renderLinkEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, editableLinksIds.map(function (id) {
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_Editor_LinkEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale })));
    }))); };
    var renderButtonEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, editableButtonsIds.map(function (id) {
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_Editor_ButtonEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale, parentContainer: parentContainer })));
    }))); };
    var renderIframeEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, editableIframesIds.map(function (id) {
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Editor_IframeEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale, parentContainer: parentContainer })));
    }))); };
    var renderEnrichmentEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, editableEnrichmentsIds.map(function (id) {
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__containers_Editor_EnrichmentEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale })));
    }))); };
    var renderSliderEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, editableSlidersIds.map(function (id) {
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__containers_Editor_SliderEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale, parentContainer: parentContainer })));
    }))); };
    var renderThemedItemEditors = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, themedItemsIds.map(function (id) {
        var parentContainer = getParentContainer(id);
        return parentContainer && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], { key: id, parentNode: parentContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__containers_Editor_ThemedItemEditor__["a" /* default */], { page: page, id: id, pageScale: pageScale })));
    }))); };
    if (editorType === __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["e" /* EditorType */].HTML) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            !isIframeDocumentReady &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Loader */], null,
                    __WEBPACK_IMPORTED_MODULE_18__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* StyledIframe */], { ref: iframe, src: iframeUrl, isLoading: !isIframeDocumentReady, onLoad: handleIframeLoad }),
            isEditable && isIframeDocumentReady && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                renderRichTextEditors(),
                renderMediaEditors(),
                renderLinkEditors()))));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* StyledPage */], { className: isTransparent ? __WEBPACK_IMPORTED_MODULE_15__containers_Editor_constants__["l" /* SPREAD_BACKGROUND_CLICK_CLASSNAME */] : '', width: isDisplayed ? width : 0, height: isDisplayed ? height : 0, isTransparent: isTransparent, showAloneSide: showAloneSide, isSomeEditableItemActive: isSomeEditableItemActive, isAccessibleVersion: isAccessibleVersion },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* PageInner */], { scale: pageScale },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_Page_Content__["a" /* default */], { page: page, onLoad: onLoad }),
            isEditable &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    renderRichTextEditors(),
                    renderMediaEditors(),
                    renderLinkEditors(),
                    renderButtonEditors(),
                    renderIframeEditors(),
                    renderEnrichmentEditors(),
                    renderSliderEditors(),
                    renderThemedItemEditors()))));
};
/* harmony default export */ __webpack_exports__["a"] = (Page);


/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return htmlEditorStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_userAgent__ = __webpack_require__(6);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






var StyledPage = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tz-index: ", ";\n\twidth: ", ";\n\theight: ", ";\n\tbackground-color: ", ";\n\t", ";\n\n\t", ";\n\n\t", ";\n\n\t/* this style is needed for proper line-height handling */\n\t[class*=", "] p span {\n\t\tvertical-align: bottom;\n\t}\n\n\t[class*=", "] {\n\t\tbackground: none !important; /* remove background images generated by inDesign (e.g., underline for hyperlink or bullets for list items) */\n\t\tcursor: text;\n\n\t\t&.edited {\n\t\t\toverflow: visible;\n\t\t}\n\t}\n\n\t.is-visible:not([class*=", "]) {\n\t\toverflow: visible !important;\n\n\t\t> * {\n\t\t\toverflow: visible !important;\n\t\t}\n\t}\n\n\t[class*=", "] {\n\t\toverflow: visible !important;\n\n\t\t&.is-active {\n\t\t\tz-index: 2;\n\t\t}\n\n\t\timg {\n\t\t\tmin-width: auto !important;\n\t\t}\n\t}\n\n\t/* we have to disable pointer-events on all elements for selecting editable text fields and images\n\t(for example, when there are buttons, links or layers above text fields and images) */\n\t> * {\n\t\tpointer-events: none;\n\t}\n\n\t[class*=", "] > div {\n\t\tpointer-events: auto;\n\n\t\ta {\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t._idGenButton {\n\t\tcursor: default;\n\t}\n\n\t._idGenButton[data-hidden],\n\t[class*=", "][data-hidden] {\n\t\tdisplay: block !important; /* to overwrite plugin's style and display editor */\n\t}\n\n\t.editable-button-link .edited[class*=", "],\n\t.editable-button-link .edited[class*=", "] * {\n\t\tpointer-events: auto;\n\t}\n\n\t[class*=", "] {\n\t\tbackground-color: ", ";\n\t}\n\n\t[class*=", "] {\n\t\tpointer-events: none !important;\n\n\t\t* {\n\t\t\tpointer-events: none !important;\n\t\t}\n\t}\n\n\t[class^=", "] {\n\t\tbackground: ", " url('./.gallery/static/images/slider.svg');\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 30% auto;\n\t\tbackground-position: center;\n\t}\n"], ["\n\tposition: relative;\n\tz-index: ", ";\n\twidth: ", ";\n\theight: ", ";\n\tbackground-color: ",
    ";\n\t", ";\n\n\t",
    ";\n\n\t", ";\n\n\t/* this style is needed for proper line-height handling */\n\t[class*=", "] p span {\n\t\tvertical-align: bottom;\n\t}\n\n\t[class*=", "] {\n\t\tbackground: none !important; /* remove background images generated by inDesign (e.g., underline for hyperlink or bullets for list items) */\n\t\tcursor: text;\n\n\t\t&.edited {\n\t\t\toverflow: visible;\n\t\t}\n\t}\n\n\t.is-visible:not([class*=", "]) {\n\t\toverflow: visible !important;\n\n\t\t> * {\n\t\t\toverflow: visible !important;\n\t\t}\n\t}\n\n\t[class*=", "] {\n\t\toverflow: visible !important;\n\n\t\t&.is-active {\n\t\t\tz-index: 2;\n\t\t}\n\n\t\timg {\n\t\t\tmin-width: auto !important;\n\t\t}\n\t}\n\n\t/* we have to disable pointer-events on all elements for selecting editable text fields and images\n\t(for example, when there are buttons, links or layers above text fields and images) */\n\t> * {\n\t\tpointer-events: none;\n\t}\n\n\t[class*=", "] > div {\n\t\tpointer-events: auto;\n\n\t\ta {\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t._idGenButton {\n\t\tcursor: default;\n\t}\n\n\t._idGenButton[data-hidden],\n\t[class*=", "][data-hidden] {\n\t\tdisplay: block !important; /* to overwrite plugin's style and display editor */\n\t}\n\n\t.editable-button-link .edited[class*=", "],\n\t.editable-button-link .edited[class*=", "] * {\n\t\tpointer-events: auto;\n\t}\n\n\t[class*=", "] {\n\t\tbackground-color: ", ";\n\t}\n\n\t[class*=", "] {\n\t\tpointer-events: none !important;\n\n\t\t* {\n\t\t\tpointer-events: none !important;\n\t\t}\n\t}\n\n\t[class^=", "] {\n\t\tbackground: ", " url('./.gallery/static/images/slider.svg');\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 30% auto;\n\t\tbackground-position: center;\n\t}\n"])), function (_a) {
    var isSomeEditableItemActive = _a.isSomeEditableItemActive;
    return isSomeEditableItemActive ? 2 : 1;
}, function (_a) {
    var width = _a.width;
    return width + "px";
}, function (_a) {
    var height = _a.height;
    return height + "px";
}, function (_a) {
    var isTransparent = _a.isTransparent, isAccessibleVersion = _a.isAccessibleVersion;
    if (isTransparent && isAccessibleVersion) {
        return __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey50;
    }
    else if (isTransparent) {
        return 'transparent';
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White;
    }
}, function (_a) {
    var isAccessibleVersion = _a.isAccessibleVersion;
    return isAccessibleVersion ? 'overflow: auto;' : '';
}, function (_a) {
    var showAloneSide = _a.showAloneSide;
    switch (showAloneSide) {
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["m" /* ShowAloneSide */].LEFT:
            return 'margin-right: auto;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["m" /* ShowAloneSide */].RIGHT:
            return 'margin-left: auto;';
        case __WEBPACK_IMPORTED_MODULE_3__containers_Editor_constants__["m" /* ShowAloneSide */].CENTER:
        default:
            return '';
    }
}, function (_a) {
    var isSomeEditableItemActive = _a.isSomeEditableItemActive, isAccessibleVersion = _a.isAccessibleVersion;
    return !isSomeEditableItemActive && (isAccessibleVersion ? "overflow: auto;" : "overflow: hidden;");
}, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].textFieldClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].textFieldClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].scrollableAreaClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].imageClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].scrollableAreaClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].sliderClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].textFieldClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].textFieldClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].lockedClassName, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey300, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].animationStartClassName, __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_indesignEditor_constants__["c" /* default */].sliderClassName, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey200);
var PageInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\ttransform: scale(", ");\n\ttransform-origin: 0 0;\n"], ["\n\ttransform: scale(", ");\n\ttransform-origin: 0 0;\n"])), function (_a) {
    var scale = _a.scale;
    return scale;
});
var StyledIframe = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('iframe')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tpadding: 27px;\n\tborder: 0;\n\toverflow: hidden;\n\ttransition: opacity ease 1s;\n\n\t", "\n"], ["\n\tflex: 1 1 auto;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tpadding: 27px;\n\tborder: 0;\n\toverflow: hidden;\n\ttransition: opacity ease 1s;\n\n\t", "\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return isLoading && 'opacity: 0;';
});
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tcolor: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]);
// these styles are injected in iframe for styling editable components (RichTextEditor, MediaEditor, LinkEditor)
var htmlEditorStyles = "\n\t@keyframes spin {\n\t\t0% {\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n\n\t.uprez-rte-wrapper {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tpointer-events: auto;\n\t}\n\n\t.uprez-rte-wrapper.is-active {\n\t\toutline: 2px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t}\n\n\t.uprez-rte-wrapper > div {\n\t\theight: 100%;\n\t}\n\n\t.uprez-rte-wrapper a {\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\t}\n\n\t.uprez-rte {\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t\tpadding-right: 6px;\n\t\tscrollbar-width: thin;\n\t\tscrollbar-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey500 + " " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey100 + ";\n\t}\n\n\t.uprez-rte::-webkit-scrollbar {\n\t\twidth: 5px;\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey100 + ";\n\t}\n\n\t.uprez-rte::-webkit-scrollbar-track {\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey100 + ";\n\t\tborder-radius: 3px;\n\t}\n\n\t.uprez-rte::-webkit-scrollbar-thumb {\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey500 + ";\n\t\tborder-radius: 3px;\n\t}\n\n\t[data-uprez-image],\n\t[data-uprez-video] {\n\t\tposition: relative;\n\t\tdisplay: inline-block; /* to keep centered image/video in case parent element has text-align: center; property */\n\t\tvertical-align: middle;\n\t}\n\n\t[data-uprez-image] > img,\n\t[data-uprez-video] > img {\n\t\twidth: 100%;\n\t\tvertical-align: bottom;\n\t}\n\n\t.uprez-media-frame {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tpointer-events: auto;\n\t\tborder-radius: inherit;\n\t}\n\n\t.uprez-media-frame.is-active {\n\t\tz-index: 100; /* to overlap other elements on the page when drag or resize image */\n\t\toverflow: visible;\n\t}\n\n\t.uprez-media-frame.is-active:not(.is-video-cover) img {\n\t\twidth: 100%;\n\t}\n\n\t.uprez-media-frame.is-active.can-drag {\n\t\tpointer-events: none;\n\t}\n\n\t[class*=\"is-rounded\"] .uprez-media-frame {\n\t\tborder-radius: 50%;\n\t}\n\n\t.is-video-cover img,\n\t[data-uprez-image] svg,\n\t[data-uprez-video] svg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t\twidth: auto;\n\t\theight: auto;\n\t\tmargin: auto;\n\t\tpointer-events: auto;\n\t}\n\n\t.is-default-video {\n\t\toverflow: hidden;\n\t}\n\n\t.is-default-video img {\n\t\twidth: 100%;\n\t\tmax-height: none;\n\t\tmargin: 0;\n\t}\n\n\t[data-uprez-image] svg,\n\t[data-uprez-video] svg {\n\t\twidth: 50%;\n\t\theight: 50%;\n\t\tfill: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400 + ";\n\t}\n\n\t.uprez-media-frame-border {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: 1;\n\t\tborder: 2px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400 + ";\n\t\tborder-radius: inherit;\n\t}\n\n\t.uprez-media-frame-border.is-active {\n\t\tborder-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t}\n\n\t.uprez-media-rnd {\n\t\tpointer-events: auto;\n\t}\n\n\t.uprez-media-rnd.is-active {\n\t\tz-index: -1;\n\t}\n\n\t.uprez-media-rnd.is-active img {\n\t\toutline: 2px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t}\n\n\t.uprez-media-rnd.is-active .editor-media-controls div::before,\n\t.uprez-media-rnd.is-active .editor-media-controls div::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\t-webkit-transform: translate(-50%, -50%);\n\t\ttransform: translate(-50%, -50%);\n\t}\n\n\t.uprez-media-rnd.is-active .editor-media-controls div::before {\n\t\twidth: 400%;\n\t\theight: 400%;\n\t}\n\n\t.uprez-media-rnd.is-active .editor-media-controls div::after {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toutline: 1px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t}\n\n\t.uprez-media-frame-loader {\n\t\tposition: absolute;\n\t\ttop: 2px;\n\t\tbottom: 2px;\n\t\tleft: 2px;\n\t\tright: 2px;\n\t\tz-index: 1;\n\t}\n\n\t.uprez-media-frame-mask {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t\topacity: 0.9;\n\t}\n\n\t.uprez-media-frame-loader-inner {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\t-webkit-transform: translate(-50%, -50%);\n\t\ttransform: translate(-50%, -50%);\n\t\tpadding: 5px;\n\t\tfont-family: HelveticaNeue, sans-serif;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey800 + ";\n\t\ttext-align: center;\n\t}\n\n\t.uprez-media-frame-loader-inner span {\n\t\tdisplay: block;\n\t}\n\n\t.uprez-media-frame-spinner {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\twidth: 45px;\n\t\theight: 45px;\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Blue600 + ";\n\t\tborder-radius: 50%;\n\t\tanimation: spin 2s linear infinite;\n\t}\n\n\t.uprez-media-frame-spinner::before,\n\t.uprez-media-frame-spinner::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tborder-radius: 50%;\n\t}\n\n\t.uprez-media-frame-spinner::before {\n\t\tborder: 4px solid currentColor;\n\t\topacity: 0.2;\n\t}\n\n\t.uprez-media-frame-spinner::after {\n\t\tborder: 4px solid currentColor;\n\t\tborder-top-color: transparent;\n\t}\n\n\t.uprez-link-editor {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: 1;\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400 + ";\n\t\tborder: 2px dashed currentColor;\n\t\tpointer-events: auto;\n\t}\n\n\t.uprez-link-editor.is-active {\n\t\tcolor: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 + ";\n\t}\n\n\t.uprez-link-editor.has-image {\n\t\tpointer-events: none;\n\t}\n\n\t.uprez-link-editor-icon {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-pack: center;\n\t\t-ms-flex-pack: center;\n\t\tjustify-content: center;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: currentColor;\n\t}\n\n\t.uprez-link-editor-icon svg {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t\tfill: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t}\n\n\t.rte-underline .rte-font-color {\n\t\ttext-decoration: underline !important;\n\t}\n\n\tbody:not(.no-user-select) * {\n\t\tuser-select: auto !important;\n\t}\n\n\tbody.no-user-select {\n\t\tuser-select: none;\n\t}\n\n\thtml {\n\t\tbackground: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White + ";\n\t}\n\n\t" + (!__WEBPACK_IMPORTED_MODULE_5__utils_userAgent__["a" /* default */].isMobileApp
    ? "\n\t\t\tbody::-webkit-scrollbar {\n\t\t\t\twidth: 16px;\n\t\t\t}\n\n\t\t\tbody::-webkit-scrollbar-track,\n\t\t\tbody::-webkit-scrollbar-corner {\n\t\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey900 + ";\n\t\t\t}\n\n\t\t\tbody::-webkit-scrollbar-thumb {\n\t\t\t\tbackground-color: " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 20) + ";\n\t\t\t}\n\t\t"
    : '') + "\n";

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_Page_Content__ = __webpack_require__(1671);


var mapStateToProps = function (state, _a) {
    var page = _a.page;
    var pages = state.editor.pages;
    return {
        html: pages[page] ? pages[page].html : '',
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_Page_Content__["a" /* default */]));


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__ = __webpack_require__(9);
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var Content = function (_a) {
    var page = _a.page, html = _a.html, onLoad = _a.onLoad;
    var element = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var addDOMLoadedObserver = function (observer) {
        observer.observe(element.current, {
            childList: true,
        });
    };
    var removeDOMLoadedObserver = function (observer) {
        observer.disconnect();
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var observer = new MutationObserver(function (mutationsList) {
            var e_1, _a;
            try {
                for (var mutationsList_1 = __values(mutationsList), mutationsList_1_1 = mutationsList_1.next(); !mutationsList_1_1.done; mutationsList_1_1 = mutationsList_1.next()) {
                    var mutation = mutationsList_1_1.value;
                    var type = mutation.type, addedNodes = mutation.addedNodes;
                    if (type === 'childList' && __spread(addedNodes).some(function (_a) {
                        var nodeName = _a.nodeName;
                        return nodeName === 'DIV';
                    })) {
                        onLoad(page);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (mutationsList_1_1 && !mutationsList_1_1.done && (_a = mutationsList_1.return)) _a.call(mutationsList_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        addDOMLoadedObserver(observer);
        return function () {
            removeDOMLoadedObserver(observer);
        };
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: element, className: __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["i" /* PAGE_CONTENT_CLASSNAME */], dangerouslySetInnerHTML: { __html: html }, "data-page": page }));
};
/* harmony default export */ __webpack_exports__["a"] = (Content);


/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_RichTextEditor__ = __webpack_require__(1673);


var isPropInData = function (prop, data) { return (prop in data ? data[prop] : undefined); };
var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, type = _a.type, editableTextFields = _a.editableTextFields, activeItem = _a.activeItem, isEditPanelDisplayed = _a.editPanel.isDisplayed, spreads = _a.pagesController.spreads, isAccessibleVersion = _a.isAccessibleVersion;
    var page = ownProps.page, id = ownProps.id, isEdited = ownProps.isEdited;
    var data = editableTextFields[page][id];
    var width = data.width, height = data.height, content = data.content;
    var isActive = id === activeItem.id && page === activeItem.page;
    return {
        editorType: type,
        width: width,
        height: height,
        content: content,
        isActive: isActive,
        activeParentId: activeItem.parentId,
        isEditPanelDisplayed: isEditPanelDisplayed,
        shouldShowScrollbar: isActive || isEdited || !!isPropInData('isEditedFromBackoffice', data),
        selfScale: isPropInData('selfScale', data),
        transformStyle: isPropInData('transformStyle', data),
        parentId: isPropInData('parentId', data),
        verticalAlignClassName: isPropInData('verticalAlignClassName', data),
        spreads: spreads,
        isThemedItem: isPropInData('isThemedItem', data),
        isAccessibleVersion: isAccessibleVersion,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_RichTextEditor__["a" /* default */]));


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_druide_slate_react__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Editor_EditPanel_TextPanel__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Editor_EditPanel_LinkPanel__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_Editor_EditPanel_ThemesPanel__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};














var RichTextEditor = /** @class */ (function (_super) {
    __extends(RichTextEditor, _super);
    function RichTextEditor(props) {
        var _this = _super.call(this, props) || this;
        var DEFAULT_CONTENT = '<p></p>';
        _this.state = {
            value: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].html.deserialize(props.content || DEFAULT_CONTENT),
        };
        _this.currentMarks = _this.state.value.marks;
        _this.textPanelActions = {
            onFontFamilyChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_FAMILY),
            onFontSizeChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_SIZE),
            onColorChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].COLOR),
            onLineHeightChange: _this.handleLineHeightChange.bind(_this),
            onLetterSpacingChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].LETTER_SPACING),
            onFontWeightClick: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_WEIGHT),
            onFontStyleClick: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_STYLE),
            onTextDecorationChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].TEXT_DECORATION),
            onTextTransformChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM),
            onTextScriptChange: _this.handleMarkChange.bind(_this, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT),
            onTextAlignChange: _this.handleTextAlignChange.bind(_this),
            onVerticalAlignChange: _this.handleVerticalAlignChange.bind(_this),
            onListTypeChange: _this.handleListTypeChange.bind(_this),
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleLinkChange = _this.handleLinkChange.bind(_this);
        return _this;
    }
    RichTextEditor.isEmpty = function (value) {
        return !value.document.text.trim();
    };
    RichTextEditor.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, isActive = _a.isActive, shouldShowScrollbar = _a.shouldShowScrollbar, content = _a.content, verticalAlignClassName = _a.verticalAlignClassName;
        return isActive ||
            isActive !== nextProps.isActive ||
            shouldShowScrollbar !== nextProps.shouldShowScrollbar ||
            content !== nextProps.content ||
            verticalAlignClassName !== nextProps.verticalAlignClassName;
    };
    RichTextEditor.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, isActive = _a.isActive, id = _a.id, parentId = _a.parentId, activeParentId = _a.activeParentId, isEditPanelDisplayed = _a.isEditPanelDisplayed, content = _a.content, verticalAlignClassName = _a.verticalAlignClassName;
        if (content !== prevProps.content) {
            this.setState({
                value: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].html.deserialize(content),
            }, function () {
                // is needed to re-render when content from props was changed (otherwise there won't be a visual change because of shouldComponentUpdate)
                _this.forceUpdate();
            });
        }
        if (verticalAlignClassName !== prevProps.verticalAlignClassName) {
            var container = document.querySelector("#" + id);
            Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["_6" /* setVerticalAlignClassName */])(container, verticalAlignClassName);
        }
        if (!prevProps.isEditPanelDisplayed && isEditPanelDisplayed) {
            this.hideTouchKeyboard();
        }
        var isBecomeActive = !prevProps.isActive && isActive;
        var isBecomeInActive = prevProps.isActive && !isActive;
        if (isBecomeInActive) {
            this.hideTouchKeyboard();
            this.handleBlur();
        }
        if (parentId) {
            var isParentIdChanged = prevProps.activeParentId !== activeParentId;
            var parentContainer = document.querySelector("#" + parentId);
            if (parentContainer) {
                if (isBecomeActive) {
                    parentContainer.classList.add('is-visible');
                }
                if (isBecomeInActive && isParentIdChanged) {
                    parentContainer.classList.remove('is-visible');
                }
            }
        }
    };
    RichTextEditor.prototype.hideTouchKeyboard = function () {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    };
    RichTextEditor.prototype.handleChange = function (_a) {
        var _this = this;
        var value = _a.value;
        var _b = this.props, isActive = _b.isActive, editorType = _b.editorType;
        if (!isActive) {
            return;
        }
        if (editorType === __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["e" /* EditorType */].INDESIGN) {
            var shouldUpdateCurrentMarks = value.marks.size && !__WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(this.currentMarks, value.marks);
            if (shouldUpdateCurrentMarks) {
                this.currentMarks = value.marks;
            }
            this.setState({ value: value }, function () {
                // By default Slate removes all marks when there is no text in paragraph. We need to keep previous marks and apply them for proper text format
                var shouldCorrectMarks = !value.marks.size && !!_this.currentMarks.size;
                if (shouldCorrectMarks) {
                    _this.editor.withoutSaving(function () {
                        _this.currentMarks.forEach(function (mark) { return _this.editor.addMark(mark); });
                    });
                }
            });
        }
        else {
            this.setState({ value: value });
        }
    };
    RichTextEditor.prototype.handleBlur = function () {
        var _a = this.props, content = _a.content, page = _a.page, id = _a.id, dispatch = _a.dispatch, isAccessibleVersion = _a.isAccessibleVersion;
        var value = this.state.value;
        var serializedContent = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].html.serialize(value) ? __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].html.serialize(value) : '<p></p>';
        var isContentChanged = serializedContent !== content;
        if (isContentChanged) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["_5" /* updateEditableTextField */])(page, id, {
                content: serializedContent,
                isEmpty: RichTextEditor.isEmpty(value),
            }, true, isAccessibleVersion));
        }
    };
    RichTextEditor.prototype.handleMouseDown = function () {
        var _a = this.props, id = _a.id, page = _a.page, parentId = _a.parentId, isActive = _a.isActive, isEditPanelDisplayed = _a.isEditPanelDisplayed, dispatch = _a.dispatch;
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["K" /* setActiveItem */])(id, page, parentId));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    RichTextEditor.prototype.handleMarkChange = function (type, param) {
        var _this = this;
        var _a = this.state.value, marks = _a.marks, activeMarks = _a.activeMarks, fragment = _a.fragment;
        var newMark;
        var correctMarks = this.isSomeMarkChanged ? activeMarks : marks;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_FAMILY:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getFontFamilyMark(param);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_SIZE:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getFontSizeMark(param);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].COLOR:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getColorMark(param);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_STYLE:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getFontStyleMark(correctMarks);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_WEIGHT:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getFontWeightMark(correctMarks);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].TEXT_DECORATION:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getTextDecorationMark(correctMarks, param);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].TEXT_TRANSFORM:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getTextTransformMark(correctMarks, param);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].TEXT_SCRIPT:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getTextScriptMark(correctMarks, param);
                break;
            case __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].LETTER_SPACING:
                newMark = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getLetterSpacingMark(param);
                break;
            default:
                return;
        }
        __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getMarksByType(marks, type).map(function (mark) { return _this.editor.removeMark(mark); });
        this.editor.addMark(newMark);
        this.isSomeMarkChanged = true;
        this.editor.focus();
        var isListInFragment = fragment.nodes.some(function (node) { return (!!node &&
            node.object === 'block' &&
            [__WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* BLOCK_TYPES */].ul, __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* BLOCK_TYPES */].ol].includes(node.type)); });
        if ([
            __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_FAMILY,
            __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_SIZE,
            __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].COLOR,
            __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_STYLE,
            __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["h" /* STYLE_TYPES */].FONT_WEIGHT,
        ].includes(type) && isListInFragment) {
            __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].updateListItemsStyles(this.editor, newMark.data.style);
        }
        setTimeout(function () {
            _this.isSomeMarkChanged = false;
            _this.hideTouchKeyboard();
        }, 0);
    };
    RichTextEditor.prototype.handleBlockFormatChange = function (data) {
        var _this = this;
        var blocks = this.state.value.blocks;
        if (blocks) {
            blocks.forEach(function (_a) {
                var key = _a.key, type = _a.type, currentData = _a.data;
                var newData = {
                    style: __assign({}, currentData.get('style'), data),
                };
                _this.editor.setNodeByKey(key, {
                    type: type,
                    data: newData,
                });
            });
        }
        setTimeout(function () {
            _this.hideTouchKeyboard();
        }, 0);
    };
    RichTextEditor.prototype.handleTextAlignChange = function (textAlign) {
        this.handleBlockFormatChange({
            textAlign: textAlign,
            textAlignLast: 'auto',
        });
    };
    RichTextEditor.prototype.handleLineHeightChange = function (lineHeight) {
        this.handleBlockFormatChange({
            lineHeight: lineHeight,
            minHeight: lineHeight,
        });
    };
    RichTextEditor.prototype.handleVerticalAlignChange = function (newVerticalAlignClassName) {
        var _a = this.props, page = _a.page, id = _a.id, verticalAlignClassName = _a.verticalAlignClassName, dispatch = _a.dispatch;
        if (verticalAlignClassName !== newVerticalAlignClassName) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_actions__["_5" /* updateEditableTextField */])(page, id, {
                verticalAlignClassName: newVerticalAlignClassName,
            }));
            var container = document.querySelector("#" + id);
            Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["_6" /* setVerticalAlignClassName */])(container, newVerticalAlignClassName);
        }
    };
    RichTextEditor.prototype.handleListTypeChange = function (listType) {
        var _this = this;
        var _a = this.state, value = _a.value, blocks = _a.value.blocks;
        if (listType === __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["d" /* LIST_TYPE */].NONE) {
            __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].removeList(this.editor);
            // remove unneeded styles in case previously it was a list item
            __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].removeListItemsStyles(this.editor);
        }
        else {
            var isList = blocks.some(function (block) { return !!block && block.type === __WEBPACK_IMPORTED_MODULE_3__helpers_constants__["b" /* BLOCK_TYPES */].li; });
            if (isList) {
                var currentListType = __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getListType(value);
                if (currentListType !== listType) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].updateList(this.editor, listType);
                    __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].addListItemsStyles(this.editor);
                }
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].addList(this.editor, listType);
                __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].addListItemsStyles(this.editor);
            }
        }
        this.editor.focus();
        setTimeout(function () {
            _this.hideTouchKeyboard();
        }, 0);
    };
    RichTextEditor.prototype.handleLinkChange = function (linkData) {
        var value = this.state.value;
        __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].updateLink(this.editor, value, linkData);
    };
    RichTextEditor.prototype.renderEditPanel = function () {
        var _a;
        var _b = this.props, isActive = _b.isActive, isEditPanelDisplayed = _b.isEditPanelDisplayed, page = _b.page, verticalAlignClassName = _b.verticalAlignClassName, spreads = _b.spreads, isThemedItem = _b.isThemedItem;
        var value = this.state.value;
        var blocks = value.blocks, inlines = value.inlines, selection = value.selection, marks = value.marks, activeMarks = value.activeMarks;
        var correctMarks = this.isSomeMarkChanged ? activeMarks : marks;
        var panels = (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["c" /* EditableType */].text] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__containers_Editor_EditPanel_TextPanel__["a" /* default */], { page: page, fontFamily: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getFontFamily(marks), fontSize: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getFontSize(marks), color: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getColor(marks), lineHeight: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getLineHeight(blocks), letterSpacing: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getLetterSpacing(marks), isBoldActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isFontWeightBold(correctMarks), isItalicActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isFontStyleItalic(correctMarks), isUnderlineActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextDecorationUnderline(correctMarks), isLineThroughActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextDecorationLineThrough(correctMarks), isCapitalizeActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextTransformCapitalize(correctMarks), isUpperCaseActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextTransformUpperCase(correctMarks), isLowerCaseActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextTransformLowerCase(correctMarks), isSuperScriptActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isSuperScript(correctMarks), isSubScriptActive: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isSubScript(correctMarks), isTextAlignLeft: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextAlignLeft(blocks), isTextAlignCenter: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextAlignCenter(blocks), isTextAlignRight: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextAlignRight(blocks), isTextAlignJustify: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].isTextAlignJustify(blocks), isVerticalAlignTop: !verticalAlignClassName, isVerticalAlignCenter: verticalAlignClassName === __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["n" /* VerticalAlignClassName */].CENTER, isVerticalAlignBottom: verticalAlignClassName === __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["n" /* VerticalAlignClassName */].BOTTOM, listType: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getListType(value), hasColorPicker: !isThemedItem, actions: this.textPanelActions })),
            _a[__WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["c" /* EditableType */].link] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__containers_Editor_EditPanel_LinkPanel__["a" /* default */], { linkData: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].getLinkData(inlines, spreads), canAddLink: selection.isExpanded, onChange: this.handleLinkChange })),
            _a);
        if (isThemedItem) {
            panels[__WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["c" /* EditableType */].themes] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__containers_Editor_EditPanel_ThemesPanel__["a" /* default */], null);
        }
        return isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__containers_Editor_EditPanel__["a" /* default */], { defaultType: __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["c" /* EditableType */].text, panels: panels }));
    };
    RichTextEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, editorType = _a.editorType, isActive = _a.isActive, width = _a.width, height = _a.height, transformStyle = _a.transformStyle, _b = _a.pageScale, pageScale = _b === void 0 ? 1 : _b, _c = _a.selfScale, selfScale = _c === void 0 ? 1 : _c, shouldShowScrollbar = _a.shouldShowScrollbar, isAccessibleVersion = _a.isAccessibleVersion;
        var value = this.state.value;
        // is needed for rendering in iframe (for html editor)
        // width is set on parent container to avoid incorrect width calculation in case it is set in %
        var style = {
            height: height,
        };
        var editorClasses = __WEBPACK_IMPORTED_MODULE_13__utils__["d" /* default */].getCssClasses(__WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] + " uprez-rte-wrapper", {
            'is-active': isActive,
        });
        var isEmpty = RichTextEditor.isEmpty(value);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* StyledEditorWrapper */], { className: editorClasses, editorType: editorType, isActive: isActive, isEmpty: isEmpty, width: width, height: height, transform: transformStyle, outlineWidth: Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale * selfScale), style: editorType === __WEBPACK_IMPORTED_MODULE_12__containers_Editor_constants__["e" /* EditorType */].HTML ? style : undefined, shouldShowScrollbar: shouldShowScrollbar && !isEmpty, isAccessibleVersion: isAccessibleVersion },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_druide_slate_react__["a" /* Editor */], { ref: function (editor) { _this.editor = editor; }, className: "uprez-rte", value: value, onMouseDown: this.handleMouseDown, onTouchStart: this.handleMouseDown, onChange: this.handleChange, onBeforeInput: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].handleBeforeInput, onCopy: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].handleCopy, onCut: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].handleCopy, onPaste: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].handlePaste, onKeyDown: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].handleKeyDown, renderBlock: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].renderBlock, renderInline: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].renderInline, renderMark: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* default */].renderMark }),
            this.renderEditPanel()));
    };
    return RichTextEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (RichTextEditor);


/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Editor$1; });
/* unused harmony export cloneFragment */
/* unused harmony export findDOMNode */
/* unused harmony export findDOMPoint */
/* unused harmony export findDOMRange */
/* unused harmony export findNode */
/* unused harmony export findPath */
/* unused harmony export findPoint */
/* unused harmony export findRange */
/* unused harmony export getEventRange */
/* unused harmony export getEventTransfer */
/* unused harmony export setEventTransfer */
/* unused harmony export ReactPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slate__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_get_window__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_get_window___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_get_window__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selection_is_backward__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selection_is_backward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_selection_is_backward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_throttle__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_omit__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_slate_base64_serializer__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_slate_plain_serializer__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tiny_invariant__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_slate_react_placeholder__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_memoize_one__ = __webpack_require__(1695);





















/**
 * Event handlers used by Slate plugins.
 *
 * @type {Array}
 */

var EVENT_HANDLERS = ['onBeforeInput', 'onBlur', 'onClick', 'onContextMenu', 'onCompositionEnd', 'onCompositionStart', 'onCopy', 'onCut', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onInput', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseUp', 'onPaste', 'onSelect'];

/**
 * Export.
 *
 * @type {Array}
 */

/**
 * Other handlers used by Slate plugins.
 *
 * @type {Array}
 */

var OTHER_HANDLERS = ['decorateNode', 'renderAnnotation', 'renderBlock', 'renderDecoration', 'renderDocument', 'renderEditor', 'renderInline', 'renderMark'];

/**
 * Export.
 *
 * @type {Array}
 */

/**
 * DOM data attribute strings that refer to Slate concepts.
 *
 * @type {String}
 */

var DATA_ATTRS = {
  EDITOR: 'data-slate-editor',
  FRAGMENT: 'data-slate-fragment',
  KEY: 'data-key',
  LEAF: 'data-slate-leaf',
  LENGTH: 'data-slate-length',
  OBJECT: 'data-slate-object',
  OFFSET_KEY: 'data-offset-key',
  SPACER: 'data-slate-spacer',
  STRING: 'data-slate-string',
  TEXT: 'data-slate-object',
  VOID: 'data-slate-void',
  ZERO_WIDTH: 'data-slate-zero-width'
};

var SELECTORS = {
  BLOCK: '[' + DATA_ATTRS.OBJECT + '="block"]',
  EDITOR: '[' + DATA_ATTRS.EDITOR + ']',
  INLINE: '[' + DATA_ATTRS.OBJECT + '="inline"]',
  KEY: '[' + DATA_ATTRS.KEY + ']',
  LEAF: '[' + DATA_ATTRS.LEAF + ']',
  OBJECT: '[' + DATA_ATTRS.OBJECT + ']',
  STRING: '[' + DATA_ATTRS.STRING + ']',
  TEXT: '[' + DATA_ATTRS.OBJECT + '="text"]',
  VOID: '[' + DATA_ATTRS.VOID + ']',
  ZERO_WIDTH: '[' + DATA_ATTRS.ZERO_WIDTH + ']'
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};





var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Offset key parser regex.
 *
 * @type {RegExp}
 */

var PARSER = /^([\w-]+)(?::(\d+))?$/;

/**
 * Parse an offset key `string`.
 *
 * @param {String} string
 * @return {Object}
 */

function parse(string) {
  var matches = PARSER.exec(string);

  if (!matches) {
    throw new Error("Invalid offset key string \"" + string + "\".");
  }

  var _matches = slicedToArray(matches, 3),
      original = _matches[0],
      key = _matches[1],
      index = _matches[2]; // eslint-disable-line no-unused-vars


  return {
    key: key,
    index: parseInt(index, 10)
  };
}

/**
 * Stringify an offset key `object`.
 *
 * @param {Object} object
 *   @property {String} key
 *   @property {Number} index
 * @return {String}
 */

function stringify(object) {
  return object.key + ":" + object.index;
}

/**
 * Export.
 *
 * @type {Object}
 */

var OffsetKey = {
  parse: parse,
  stringify: stringify
};

var TextString = function TextString(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? '' : _ref$text,
      _ref$isTrailing = _ref.isTrailing,
      isTrailing = _ref$isTrailing === undefined ? false : _ref$isTrailing;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    defineProperty({}, DATA_ATTRS.STRING, true),
    text,
    isTrailing ? '\n' : null
  );
};

/**
 * Leaf strings without text, render as zero-width strings.
 *
 * @type {Component}
 */

var ZeroWidthString = function ZeroWidthString(_ref3) {
  var _ref4;

  var _ref3$length = _ref3.length,
      length = _ref3$length === undefined ? 0 : _ref3$length,
      _ref3$isLineBreak = _ref3.isLineBreak,
      isLineBreak = _ref3$isLineBreak === undefined ? false : _ref3$isLineBreak;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    (_ref4 = {}, defineProperty(_ref4, DATA_ATTRS.ZERO_WIDTH, isLineBreak ? 'n' : 'z'), defineProperty(_ref4, DATA_ATTRS.LENGTH, length), _ref4),
    '\uFEFF',
    isLineBreak ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null) : null
  );
};

/**
 * Individual leaves in a text node with unique formatting.
 *
 * @type {Component}
 */

var Leaf = function Leaf(props) {
  var _attrs;

  var marks = props.marks,
      annotations = props.annotations,
      decorations = props.decorations,
      node = props.node,
      index = props.index,
      offset = props.offset,
      text = props.text,
      editor = props.editor,
      parent = props.parent,
      block = props.block,
      leaves = props.leaves;


  var offsetKey = OffsetKey.stringify({
    key: node.key,
    index: index
  });

  var children = void 0;

  if (editor.query('isVoid', parent)) {
    // COMPAT: Render text inside void nodes with a zero-width space.
    // So the node can contain selection but the text is not visible.
    children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZeroWidthString, { length: parent.text.length });
  } else if (text === '' && parent.object === 'block' && parent.text === '' && parent.nodes.last() === node) {
    // COMPAT: If this is the last text node in an empty block, render a zero-
    // width space that will convert into a line break when copying and pasting
    // to support expected plain text.
    children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZeroWidthString, { isLineBreak: true });
  } else if (text === '') {
    // COMPAT: If the text is empty, it's because it's on the edge of an inline
    // node, so we render a zero-width space so that the selection can be
    // inserted next to it still.
    children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZeroWidthString, null);
  } else {
    // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
    // so we need to add an extra trailing new lines to prevent that.
    var lastText = block.getLastText();
    var lastChar = text.charAt(text.length - 1);
    var isLastText = node === lastText;
    var isLastLeaf = index === leaves.size - 1;

    if (isLastText && isLastLeaf && lastChar === '\n') {
      children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TextString, { isTrailing: true, text: text });
    } else {
      children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TextString, { text: text });
    }
  }

  var renderProps = {
    editor: editor,
    marks: marks,
    annotations: annotations,
    decorations: decorations,
    node: node,
    offset: offset,
    text: text

    // COMPAT: Having the `data-` attributes on these leaf elements ensures that
    // in certain misbehaving browsers they aren't weirdly cloned/destroyed by
    // contenteditable behaviors. (2019/05/08)
  };var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = marks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var mark = _step.value;

      var ret = editor.run('renderMark', _extends({}, renderProps, {
        mark: mark,
        children: children,
        attributes: defineProperty({}, DATA_ATTRS.OBJECT, 'mark')
      }));

      if (ret) {
        children = ret;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = decorations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var decoration = _step2.value;

      var ret = editor.run('renderDecoration', _extends({}, renderProps, {
        decoration: decoration,
        children: children,
        attributes: defineProperty({}, DATA_ATTRS.OBJECT, 'decoration')
      }));

      if (ret) {
        children = ret;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = annotations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var annotation = _step3.value;

      var ret = editor.run('renderAnnotation', _extends({}, renderProps, {
        annotation: annotation,
        children: children,
        attributes: defineProperty({}, DATA_ATTRS.OBJECT, 'annotation')
      }));

      if (ret) {
        children = ret;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  var attrs = (_attrs = {}, defineProperty(_attrs, DATA_ATTRS.LEAF, true), defineProperty(_attrs, DATA_ATTRS.OFFSET_KEY, offsetKey), _attrs);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    attrs,
    children
  );
};

/**
 * Prop types.
 *
 * @type {Object}
 */

Leaf.propTypes = {
  annotations: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.list.isRequired,
  block: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].block.isRequired,
  decorations: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.list.isRequired,
  editor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  leaves: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  marks: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].marks.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  parent: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired

  /**
   * A memoized version of `Leaf` that updates less frequently.
   *
   * @type {Component}
   */

};var MemoizedLeaf = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Leaf, function (prev, next) {
  return next.block === prev.block && next.index === prev.index && next.marks === prev.marks && next.parent === prev.parent && next.text === prev.text && next.annotations.equals(prev.annotations) && next.decorations.equals(prev.decorations);
});

/**
 * Export.
 *
 * @type {Component}
 */

var Text = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
  var _ref;

  var annotations = props.annotations,
      block = props.block,
      decorations = props.decorations,
      node = props.node,
      parent = props.parent,
      editor = props.editor,
      style = props.style;
  var key = node.key;

  var leaves = node.getLeaves(annotations, decorations);
  var at = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    _extends({
      ref: ref,
      style: style
    }, (_ref = {}, defineProperty(_ref, DATA_ATTRS.OBJECT, node.object), defineProperty(_ref, DATA_ATTRS.KEY, key), _ref)),
    leaves.map(function (leaf, index) {
      var text = leaf.text;

      var offset = at;
      at += text.length;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MemoizedLeaf, {
        key: node.key + '-' + index,
        block: block,
        editor: editor,
        index: index,
        annotations: leaf.annotations,
        decorations: leaf.decorations,
        marks: leaf.marks,
        node: node,
        offset: offset,
        parent: parent,
        leaves: leaves,
        text: text
      });
    })
  );
});

/**
 * Prop types.
 *
 * @type {Object}
 */

Text.propTypes = {
  annotations: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map.isRequired,
  block: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].block,
  decorations: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.list.isRequired,
  editor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  parent: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object

  /**
   * A memoized version of `Text` that updates less frequently.
   *
   * @type {Component}
   */

};var MemoizedText = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Text, function (prev, next) {
  return (
    // PERF: There are cases where it will have
    // changed, but it's properties will be exactly the same (eg. copy-paste)
    // which this won't catch. But that's rare and not a drag on performance, so
    // for simplicity we just let them through.
    next.node === prev.node &&
    // If the node parent is a block node, and it was the last child of the
    // block, re-render to cleanup extra `\n`.
    next.parent.object === 'block' && prev.parent.nodes.last() === prev.node && next.parent.nodes.last() !== next.node &&
    // The formatting hasn't changed.
    next.annotations.equals(prev.annotations) && next.decorations.equals(prev.decorations)
  );
});

/**
 * Export.
 *
 * @type {Component}
 */

var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:void');

/**
 * Void.
 *
 * @type {Component}
 */

var Void = function (_React$Component) {
  inherits(Void, _React$Component);

  function Void() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Void);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Void.__proto__ || Object.getPrototypeOf(Void)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
  }
  /**
   * Property types.
   *
   * @type {Object}
   */

  /**
   * Debug.
   *
   * @param {String} message
   * @param {Mixed} ...args
   */

  createClass(Void, [{
    key: 'render',


    /**
     * Render.
     *
     * @return {Element}
     */

    value: function render() {
      var _attrs;

      var props = this.props;
      var children = props.children,
          node = props.node,
          readOnly = props.readOnly;

      var Tag = node.object === 'block' ? 'div' : 'span';
      var style = {
        height: '0',
        color: 'transparent',
        outline: 'none',
        position: 'absolute'
      };

      var spacerAttrs = defineProperty({}, DATA_ATTRS.SPACER, true);

      var spacer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ style: style }, spacerAttrs),
        this.renderText()
      );

      var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        { contentEditable: readOnly ? null : false },
        children
      );

      this.debug('render', { props: props });

      var attrs = (_attrs = {}, defineProperty(_attrs, DATA_ATTRS.VOID, true), defineProperty(_attrs, DATA_ATTRS.KEY, node.key), _attrs);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({
          contentEditable: readOnly || node.object === 'block' ? null : false
        }, attrs),
        readOnly ? null : spacer,
        content
      );
    }

    /**
     * Render the void node's text node, which will catch the cursor when it the
     * void node is navigated to with the arrow keys.
     *
     * Having this text node there means the browser continues to manage the
     * selection natively, so it keeps track of the right offset when moving
     * across the block.
     *
     * @return {Element}
     */

  }]);
  return Void;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * Export.
 *
 * @type {Component}
 */

Void.propTypes = {
  block: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].block,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
  editor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  parent: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.debug = function (message) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var node = _this2.props.node;
    var key = node.key,
        type = node.type;

    var id = key + ' (' + type + ')';
    debug.apply(undefined, [message, '' + id].concat(args));
  };

  this.renderText = function () {
    var _props = _this2.props,
        annotations = _props.annotations,
        block = _props.block,
        decorations = _props.decorations,
        node = _props.node,
        readOnly = _props.readOnly,
        editor = _props.editor,
        textRef = _props.textRef;

    var child = node.getFirstText();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MemoizedText, {
      ref: textRef,
      annotations: annotations,
      block: node.object === 'block' ? node : block,
      decorations: decorations,
      editor: editor,
      key: child.key,
      node: child,
      parent: node,
      readOnly: readOnly
    });
  };
};

var debug$1 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:node');

/**
 * Node.
 *
 * @type {Component}
 */

var Node$1 = function (_React$Component) {
  inherits(Node$$1, _React$Component);

  function Node$$1() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Node$$1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Node$$1.__proto__ || Object.getPrototypeOf(Node$$1)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps$1.call(_this), _temp), possibleConstructorReturn(_this, _ret);
  }
  /**
   * Property types.
   *
   * @type {Object}
   */

  /**
   * Temporary values.
   *
   * @type {Object}
   */

  /**
   * A ref for the contenteditable DOM node.
   *
   * @type {Object}
   */

  /**
   * Debug.
   *
   * @param {String} message
   * @param {Mixed} ...args
   */

  createClass(Node$$1, [{
    key: 'shouldComponentUpdate',


    /**
     * Should the node update?
     *
     * @param {Object} nextProps
     * @param {Object} value
     * @return {Boolean}
     */

    value: function shouldComponentUpdate(nextProps) {
      var props = this.props;
      var editor = props.editor;

      var shouldUpdate = editor.run('shouldNodeComponentUpdate', props, nextProps);
      var n = nextProps;
      var p = props;

      // If the `Component` has a custom logic to determine whether the component
      // needs to be updated or not, return true if it returns true. If it returns
      // false, we need to ignore it, because it shouldn't be allowed it.
      if (shouldUpdate != null) {
        Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `shouldNodeComponentUpdate` middleware is deprecated. You can pass specific values down the tree using React\'s built-in "context" construct instead.');

        if (shouldUpdate) {
          return true;
        }

        Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(shouldUpdate !== false, "Returning false in `shouldNodeComponentUpdate` does not disable Slate's internal `shouldComponentUpdate` logic. If you want to prevent updates, use React's `shouldComponentUpdate` instead.");
      }

      // If the `readOnly` status has changed, re-render in case there is any
      // user-land logic that depends on it, like nested editable contents.
      if (n.readOnly !== p.readOnly) {
        return true;
      }

      // If the node has changed, update. PERF: There are cases where it will have
      // changed, but it's properties will be exactly the same (eg. copy-paste)
      // which this won't catch. But that's rare and not a drag on performance, so
      // for simplicity we just let them through.
      if (n.node !== p.node) {
        return true;
      }

      // If the selection value of the node or of some of its children has changed,
      // re-render in case there is any user-land logic depends on it to render.
      // if the node is selected update it, even if it was already selected: the
      // selection value of some of its children could have been changed and they
      // need to be rendered again.
      if (!n.selection && p.selection || n.selection && !p.selection || n.selection && p.selection && !n.selection.equals(p.selection)) {
        return true;
      }

      // If the annotations have changed, update.
      if (!n.annotations.equals(p.annotations)) {
        return true;
      }

      // If the decorations have changed, update.
      if (!n.decorations.equals(p.decorations)) {
        return true;
      }

      // Otherwise, don't update.
      return false;
    }

    /**
     * Render.
     *
     * @return {Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _attributes;

      this.debug('render', this);
      var _props = this.props,
          annotations = _props.annotations,
          block = _props.block,
          decorations = _props.decorations,
          editor = _props.editor,
          node = _props.node,
          parent = _props.parent,
          readOnly = _props.readOnly,
          selection = _props.selection;


      var newDecorations = node.getDecorations(editor);
      var children = node.nodes.toArray().map(function (child, i) {
        var Component = child.object === 'text' ? MemoizedText : Node$$1;
        var sel = selection && getRelativeRange(node, i, selection);

        var decs = newDecorations.concat(decorations).map(function (d) {
          return getRelativeRange(node, i, d);
        }).filter(function (d) {
          return d;
        });

        var anns = annotations.map(function (a) {
          return getRelativeRange(node, i, a);
        }).filter(function (a) {
          return a;
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, {
          block: node.object === 'block' ? node : block,
          editor: editor,
          annotations: anns,
          decorations: decs,
          selection: sel,
          key: child.key,
          node: child,
          parent: node,
          readOnly: readOnly
          // COMPAT: We use this map of refs to lookup a DOM node down the
          // tree of components by path.
          , ref: function ref(_ref2) {
            if (_ref2) {
              _this2.tmp.nodeRefs[i] = _ref2;
            } else {
              delete _this2.tmp.nodeRefs[i];
            }
          }
        });
      });

      // Attributes that the developer must mix into the element in their
      // custom node renderer component.
      var attributes = (_attributes = {}, defineProperty(_attributes, DATA_ATTRS.OBJECT, node.object), defineProperty(_attributes, DATA_ATTRS.KEY, node.key), defineProperty(_attributes, 'ref', this.ref), _attributes);

      // If it's a block node with inline children, add the proper `dir` attribute
      // for text direction.
      if (node.isLeafBlock()) {
        var direction = node.getTextDirection();
        if (direction === 'rtl') attributes.dir = 'rtl';
      }

      var render = void 0;

      if (node.object === 'block') {
        render = 'renderBlock';
      } else if (node.object === 'document') {
        render = 'renderDocument';
      } else if (node.object === 'inline') {
        render = 'renderInline';
      }

      var element = editor.run(render, {
        attributes: attributes,
        children: children,
        editor: editor,
        isFocused: !!selection && selection.isFocused,
        isSelected: !!selection,
        node: node,
        parent: parent,
        readOnly: readOnly
      });

      return editor.isVoid(node) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Void,
        _extends({}, this.props, {
          textRef: function textRef(ref) {
            if (ref) {
              _this2.tmp.nodeRefs[0] = ref;
            } else {
              delete _this2.tmp.nodeRefs[0];
            }
          }
        }),
        element
      ) : element;
    }
  }]);
  return Node$$1;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * Return a `range` relative to a child at `index`.
 *
 * @param {Range} range
 * @param {Number} index
 * @return {Range}
 */

Node$1.propTypes = {
  annotations: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map.isRequired,
  block: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].block,
  decorations: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.list.isRequired,
  editor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node.isRequired,
  parent: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].node,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  selection: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].selection };

var _initialiseProps$1 = function _initialiseProps() {
  var _this3 = this;

  this.tmp = {
    nodeRefs: {} };
  this.ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();

  this.debug = function (message) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var node = _this3.props.node;
    var key = node.key,
        type = node.type;

    debug$1.apply(undefined, [message, key + ' (' + type + ')'].concat(args));
  };
};

function getRelativeRange(node, index, range) {
  if (range.isUnset) {
    return null;
  }

  var child = node.nodes.get(index);
  var _range = range,
      start = _range.start,
      end = _range.end;
  var _start = start,
      startPath = _start.path;
  var _end = end,
      endPath = _end.path;

  var startIndex = startPath.first();
  var endIndex = endPath.first();

  if (startIndex === index) {
    start = start.setPath(startPath.rest());
  } else if (startIndex < index && index <= endIndex) {
    if (child.object === 'text') {
      start = start.moveTo(__WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].create([index]), 0).setKey(child.key);
    } else {
      var _child$texts = child.texts(),
          _child$texts2 = slicedToArray(_child$texts, 1),
          first = _child$texts2[0];

      var _first = slicedToArray(first, 2),
          firstNode = _first[0],
          firstPath = _first[1];

      start = start.moveTo(firstPath, 0).setKey(firstNode.key);
    }
  } else {
    start = null;
  }

  if (endIndex === index) {
    end = end.setPath(endPath.rest());
  } else if (startIndex <= index && index < endIndex) {
    if (child.object === 'text') {
      var length = child.text.length;
      end = end.moveTo(__WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].create([index]), length).setKey(child.key);
    } else {
      var _child$texts3 = child.texts({ direction: 'backward' }),
          _child$texts4 = slicedToArray(_child$texts3, 1),
          last = _child$texts4[0];

      var _last = slicedToArray(last, 2),
          lastNode = _last[0],
          lastPath = _last[1];

      end = end.moveTo(lastPath, lastNode.text.length).setKey(lastNode.key);
    }
  } else {
    end = null;
  }

  if (!start || !end) {
    return null;
  }

  range = range.setAnchor(start);
  range = range.setFocus(end);
  return range;
}

/**
 * Export.
 *
 * @type {Component}
 */

var OVERFLOWS = ['auto', 'overlay', 'scroll'];

/**
 * Detect whether we are running IOS version 11
 */

var IS_IOS_11 = __WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["f" /* IS_IOS */] && !!window.navigator.userAgent.match(/os 11_/i);

/**
 * Find the nearest parent with scrolling, or window.
 *
 * @param {el} Element
 */

function findScrollContainer(el, window) {
  var parent = el.parentNode;
  var scroller = void 0;

  while (!scroller) {
    if (!parent.parentNode) break;

    var style = window.getComputedStyle(parent);
    var overflowY = style.overflowY;


    if (OVERFLOWS.includes(overflowY)) {
      scroller = parent;
      break;
    }

    parent = parent.parentNode;
  }

  // COMPAT: Because Chrome does not allow doucment.body.scrollTop, we're
  // assuming that window.scrollTo() should be used if the scrollable element
  // turns out to be document.body or document.documentElement. This will work
  // unless body is intentionally set to scrollable by restricting its height
  // (e.g. height: 100vh).
  if (!scroller) {
    return window.document.body;
  }

  return scroller;
}

/**
 * Scroll the current selection's focus point into view if needed.
 *
 * @param {Selection} selection
 */

function scrollToSelection(selection) {
  if (IS_IOS_11) return;
  if (!selection.anchorNode) return;

  var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(selection.anchorNode);
  var scroller = findScrollContainer(selection.anchorNode, window);
  var isWindow = scroller === window.document.body || scroller === window.document.documentElement;
  var backward = __WEBPACK_IMPORTED_MODULE_8_selection_is_backward___default()(selection);

  var range = selection.getRangeAt(0).cloneRange();
  range.collapse(backward);
  var cursorRect = range.getBoundingClientRect();

  // COMPAT: range.getBoundingClientRect() returns 0s in Safari when range is
  // collapsed. Expanding the range by 1 is a relatively effective workaround
  // for vertical scroll, although horizontal may be off by 1 character.
  // https://bugs.webkit.org/show_bug.cgi?id=138949
  // https://bugs.chromium.org/p/chromium/issues/detail?id=435438
  if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["h" /* IS_SAFARI */]) {
    if (range.collapsed && cursorRect.top === 0 && cursorRect.height === 0) {
      if (range.startOffset === 0) {
        range.setEnd(range.endContainer, 1);
      } else {
        range.setStart(range.startContainer, range.startOffset - 1);
      }

      cursorRect = range.getBoundingClientRect();

      if (cursorRect.top === 0 && cursorRect.height === 0) {
        if (range.getClientRects().length) {
          cursorRect = range.getClientRects()[0];
        }
      }
    }
  }

  var width = void 0;
  var height = void 0;
  var yOffset = void 0;
  var xOffset = void 0;
  var scrollerTop = 0;
  var scrollerLeft = 0;
  var scrollerBordersY = 0;
  var scrollerBordersX = 0;
  var scrollerPaddingTop = 0;
  var scrollerPaddingBottom = 0;
  var scrollerPaddingLeft = 0;
  var scrollerPaddingRight = 0;

  if (isWindow) {
    var innerWidth = window.innerWidth,
        innerHeight = window.innerHeight,
        pageYOffset = window.pageYOffset,
        pageXOffset = window.pageXOffset;

    width = innerWidth;
    height = innerHeight;
    yOffset = pageYOffset;
    xOffset = pageXOffset;
  } else {
    var offsetWidth = scroller.offsetWidth,
        offsetHeight = scroller.offsetHeight,
        scrollTop = scroller.scrollTop,
        scrollLeft = scroller.scrollLeft;

    var _window$getComputedSt = window.getComputedStyle(scroller),
        borderTopWidth = _window$getComputedSt.borderTopWidth,
        borderBottomWidth = _window$getComputedSt.borderBottomWidth,
        borderLeftWidth = _window$getComputedSt.borderLeftWidth,
        borderRightWidth = _window$getComputedSt.borderRightWidth,
        paddingTop = _window$getComputedSt.paddingTop,
        paddingBottom = _window$getComputedSt.paddingBottom,
        paddingLeft = _window$getComputedSt.paddingLeft,
        paddingRight = _window$getComputedSt.paddingRight;

    var scrollerRect = scroller.getBoundingClientRect();
    width = offsetWidth;
    height = offsetHeight;
    scrollerTop = scrollerRect.top + parseInt(borderTopWidth, 10);
    scrollerLeft = scrollerRect.left + parseInt(borderLeftWidth, 10);

    scrollerBordersY = parseInt(borderTopWidth, 10) + parseInt(borderBottomWidth, 10);

    scrollerBordersX = parseInt(borderLeftWidth, 10) + parseInt(borderRightWidth, 10);

    scrollerPaddingTop = parseInt(paddingTop, 10);
    scrollerPaddingBottom = parseInt(paddingBottom, 10);
    scrollerPaddingLeft = parseInt(paddingLeft, 10);
    scrollerPaddingRight = parseInt(paddingRight, 10);
    yOffset = scrollTop;
    xOffset = scrollLeft;
  }

  var cursorTop = cursorRect.top + yOffset - scrollerTop;
  var cursorLeft = cursorRect.left + xOffset - scrollerLeft;

  var x = xOffset;
  var y = yOffset;

  if (cursorLeft < xOffset) {
    // selection to the left of viewport
    x = cursorLeft - scrollerPaddingLeft;
  } else if (cursorLeft + cursorRect.width + scrollerBordersX > xOffset + width) {
    // selection to the right of viewport
    x = cursorLeft + scrollerBordersX + scrollerPaddingRight - width;
  }

  if (cursorTop < yOffset) {
    // selection above viewport
    y = cursorTop - scrollerPaddingTop;
  } else if (cursorTop + cursorRect.height + scrollerBordersY > yOffset + height) {
    // selection below viewport
    y = cursorTop + scrollerBordersY + scrollerPaddingBottom + cursorRect.height - height;
  }

  if (isWindow) {
    window.scrollTo(x, y);
  } else {
    scroller.scrollTop = y;
    scroller.scrollLeft = x;
  }
}

/**
 * Export.
 *
 * @type {Function}
 */

function removeAllRanges(domSelection) {
  // COMPAT: In IE 11, if the selection contains nested tables, then
  // `removeAllRanges` will throw an error.
  if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["e" /* IS_IE */]) {
    var range = window.document.body.createTextRange();
    range.collapse();
    range.select();
  } else {
    domSelection.removeAllRanges();
  }
}

/**
 * Export.
 *
 * @type {Function}
 */

var FIREFOX_NODE_TYPE_ACCESS_ERROR = /Permission denied to access property "nodeType"/;

/**
 * Debug.
 *
 * @type {Function}
 */

var debug$2 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:content');

/**
 * Separate debug to easily see when the DOM has updated either by render or
 * changing selection.
 *
 * @type {Function}
 */

debug$2.update = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:update');

/**
 * Content.
 *
 * @type {Component}
 */

var Content = function (_React$Component) {
  inherits(Content, _React$Component);

  function Content() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Content);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Content.__proto__ || Object.getPrototypeOf(Content)).call.apply(_ref, [this].concat(args))), _this), _this.tmp = {
      isUpdatingSelection: false,
      nodeRef: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(),
      nodeRefs: {},
      contentKey: 0,
      nativeSelection: {} // Native selection object stored to check if `onNativeSelectionChange` has triggered yet


      /**
       * A ref for the contenteditable DOM node.
       *
       * @type {Object}
       */

    }, _this.ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(), _this.setRef = function (el) {
      _this.ref.current = el;
      _this.props.editor.el = el;
    }, _this.handlers = EVENT_HANDLERS.reduce(function (obj, handler) {
      obj[handler] = function (event) {
        return _this.onEvent(handler, event);
      };
      return obj;
    }, {}), _this.updateSelection = function () {
      var editor = _this.props.editor;
      var value = editor.value;
      var selection = value.selection;
      var isBackward$$1 = selection.isBackward;

      var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(_this.ref.current);
      var native = window.getSelection();
      var activeElement = window.document.activeElement;


      if (debug$2.update.enabled) {
        debug$2.update('updateSelection', { selection: selection.toJSON() });
      }

      // COMPAT: In Firefox, there's a but where `getSelection` can return `null`.
      // https://bugzilla.mozilla.org/show_bug.cgi?id=827585 (2018/11/07)
      if (!native) {
        return;
      }

      var rangeCount = native.rangeCount,
          anchorNode = native.anchorNode;

      var updated = false;

      // If the Slate selection is blurred, but the DOM's active element is still
      // the editor, we need to blur it.
      if (selection.isBlurred && activeElement === _this.ref.current) {
        _this.ref.current.blur();
        updated = true;
      }

      // If the Slate selection is unset, but the DOM selection has a range
      // selected in the editor, we need to remove the range.
      // However we should _not_ remove the range if the selection as
      // reported by `getSelection` is not equal to `this.tmp.nativeSelection`
      // as this suggests `onNativeSelectionChange` has not triggered yet (which can occur in Firefox)
      // See: https://github.com/ianstormtaylor/slate/pull/2995

      var propsToCompare = ['anchorNode', 'anchorOffset', 'focusNode', 'focusOffset', 'isCollapsed', 'rangeCount', 'type'];

      var selectionsEqual = true;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = propsToCompare[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var prop = _step.value;

          if (_this.tmp.nativeSelection[prop] !== native[prop]) {
            selectionsEqual = false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (selection.isUnset && rangeCount && _this.isInEditor(anchorNode) && selectionsEqual) {
        removeAllRanges(native);
        updated = true;
      }

      // If the Slate selection is focused, but the DOM's active element is not
      // the editor, we need to focus it. We prevent scrolling because we handle
      // scrolling to the correct selection.
      if (selection.isFocused && activeElement !== _this.ref.current) {
        _this.ref.current.focus({ preventScroll: true });
        updated = true;
      }

      // Otherwise, figure out which DOM nodes should be selected...
      if (selection.isFocused && selection.isSet) {
        var current = !!native.rangeCount && native.getRangeAt(0);
        var range = editor.findDOMRange(selection);

        if (!range) {
          Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'Unable to find a native DOM range from the current selection.');

          return;
        }

        var startContainer = range.startContainer,
            startOffset = range.startOffset,
            endContainer = range.endContainer,
            endOffset = range.endOffset;

        // If the new range matches the current selection, there is nothing to fix.
        // COMPAT: The native `Range` object always has it's "start" first and "end"
        // last in the DOM. It has no concept of "backwards/forwards", so we have
        // to check both orientations here. (2017/10/31)

        if (current) {
          if (startContainer === current.startContainer && startOffset === current.startOffset && endContainer === current.endContainer && endOffset === current.endOffset || startContainer === current.endContainer && startOffset === current.endOffset && endContainer === current.startContainer && endOffset === current.startOffset) {
            return;
          }
        }

        // Otherwise, set the `isUpdatingSelection` flag and update the selection.
        updated = true;
        _this.tmp.isUpdatingSelection = true;
        removeAllRanges(native);

        // COMPAT: IE 11 does not support `setBaseAndExtent`. (2018/11/07)
        if (native.setBaseAndExtent) {
          // COMPAT: Since the DOM range has no concept of backwards/forwards
          // we need to check and do the right thing here.
          if (isBackward$$1) {
            native.setBaseAndExtent(range.endContainer, range.endOffset, range.startContainer, range.startOffset);
          } else {
            native.setBaseAndExtent(range.startContainer, range.startOffset, range.endContainer, range.endOffset);
          }
        } else {
          native.addRange(range);
        }

        // Only scroll to selection when a user action is performed
        if (editor.userActionPerformed() === true) {
          // Scroll to the selection, in case it's out of view.
          scrollToSelection(native);
        }

        // Then unset the `isUpdatingSelection` flag after a delay, to ensure that
        // it is still set when selection-related events from updating it fire.
        setTimeout(function () {
          // COMPAT: In Firefox, it's not enough to create a range, you also need
          // to focus the contenteditable element too. (2016/11/16)
          if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["d" /* IS_FIREFOX */] && _this.ref.current) {
            _this.ref.current.focus();
          }

          _this.tmp.isUpdatingSelection = false;

          debug$2.update('updateSelection:setTimeout', {
            anchorOffset: window.getSelection().anchorOffset
          });
        });
      }

      if (updated && (debug$2.enabled || debug$2.update.enabled)) {
        debug$2('updateSelection', { selection: selection, native: native, activeElement: activeElement });

        debug$2.update('updateSelection:applied', {
          selection: selection.toJSON(),
          native: {
            anchorOffset: native.anchorOffset,
            focusOffset: native.focusOffset
          }
        });
      }
    }, _this.isInEditor = function (target) {
      var el = void 0;

      try {
        // COMPAT: In Firefox, sometimes the node can be comment which doesn't
        // have .closest and it crashes.
        if (target.nodeType === 8) {
          return false;
        }

        // COMPAT: Text nodes don't have `isContentEditable` property. So, when
        // `target` is a text node use its parent node for check.
        el = target.nodeType === 3 ? target.parentNode : target;
      } catch (err) {
        // COMPAT: In Firefox, `target.nodeType` will throw an error if target is
        // originating from an internal "restricted" element (e.g. a stepper
        // arrow on a number input)
        // see github.com/ianstormtaylor/slate/issues/1819
        if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["d" /* IS_FIREFOX */] && FIREFOX_NODE_TYPE_ACCESS_ERROR.test(err.message)) {
          return false;
        }

        throw err;
      }

      return el.isContentEditable && (el === _this.ref.current || el.closest(SELECTORS.EDITOR) === _this.ref.current);
    }, _this.onNativeSelectionChange = __WEBPACK_IMPORTED_MODULE_10_lodash_throttle___default()(function (event) {
      if (_this.props.readOnly) return;

      var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
      var activeElement = window.document.activeElement;


      var native = window.getSelection();

      debug$2.update('onNativeSelectionChange', {
        anchorOffset: native.anchorOffset
      });

      if (activeElement !== _this.ref.current) return;

      _this.tmp.nativeSelection = {
        anchorNode: native.anchorNode,
        anchorOffset: native.anchorOffset,
        focusNode: native.focusNode,
        focusOffset: native.focusOffset,
        isCollapsed: native.isCollapsed,
        rangeCount: native.rangeCount,
        type: native.type
      };

      _this.props.onEvent('onSelect', event);
    }, 100), _temp), possibleConstructorReturn(_this, _ret);
  }
  /**
   * Property types.
   *
   * @type {Object}
   */

  /**
   * Default properties.
   *
   * @type {Object}
   */

  createClass(Content, [{
    key: 'componentDidCatch',


    /**
     * An error boundary. If there is a render error, we increment `errorKey`
     * which is part of the container `key` which forces a re-render from
     * scratch.
     *
     * @param {Error} error
     * @param {String} info
     */

    value: function componentDidCatch(error, info) {
      debug$2('componentDidCatch', { error: error, info: info });
      // The call to `setState` is required despite not setting a value.
      // Without this call, React will not try to recreate the component tree.
      this.setState({});
    }

    /**
     * Temporary values.
     *
     * @type {Object}
     */

    /**
     * Set both `this.ref` and `editor.el`
     *
     * @type {DOMElement}
     */

    /**
     * Create a set of bound event handlers.
     *
     * @type {Object}
     */

  }, {
    key: 'componentDidMount',


    /**
     * When the editor first mounts in the DOM we need to:
     *
     *   - Add native DOM event listeners.
     *   - Update the selection, in case it starts focused.
     */

    value: function componentDidMount() {
      var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(this.ref.current);

      window.document.addEventListener('selectionchange', this.onNativeSelectionChange);

      // COMPAT: Restrict scope of `beforeinput` to clients that support the
      // Input Events Level 2 spec, since they are preventable events.
      if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["a" /* HAS_INPUT_EVENTS_LEVEL_2 */]) {
        this.ref.current.addEventListener('beforeinput', this.handlers.onBeforeInput);
      }

      this.updateSelection();

      this.props.onEvent('onComponentDidMount');
    }

    /**
     * When unmounting, remove DOM event listeners.
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(this.ref.current);

      if (window) {
        window.document.removeEventListener('selectionchange', this.onNativeSelectionChange);
      }

      if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["a" /* HAS_INPUT_EVENTS_LEVEL_2 */]) {
        this.ref.current.removeEventListener('beforeinput', this.handlers.onBeforeInput);
      }

      this.props.onEvent('onComponentWillUnmount');
    }

    /**
     * On update, update the selection.
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      debug$2.update('componentDidUpdate');

      this.updateSelection();
      this.props.editor.clearUserActionPerformed();

      this.props.onEvent('onComponentDidUpdate');
    }

    /**
     * Update the native DOM selection to reflect the internal model.
     */

    /**
     * Check if an event `target` is fired from within the contenteditable
     * element. This should be false for edits happening in non-contenteditable
     * children, such as void nodes and other nested Slate editors.
     *
     * @param {Element} target
     * @return {Boolean}
     */

  }, {
    key: 'onEvent',


    /**
     * On `event` with `handler`.
     *
     * @param {String} handler
     * @param {Event} event
     */

    value: function onEvent(handler, event) {
      debug$2('onEvent', handler);

      var nativeEvent = event.nativeEvent || event;
      var isUndoRedo = event.type === 'keydown' && (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isUndo(nativeEvent) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isRedo(nativeEvent));

      // Ignore `onBlur`, `onFocus` and `onSelect` events generated
      // programmatically while updating selection.
      if ((this.tmp.isUpdatingSelection || isUndoRedo) && (handler === 'onSelect' || handler === 'onBlur' || handler === 'onFocus')) {
        return;
      }

      // COMPAT: There are situations where a select event will fire with a new
      // native selection that resolves to the same internal position. In those
      // cases we don't need to trigger any changes, since our internal model is
      // already up to date, but we do want to update the native selection again
      // to make sure it is in sync. (2017/10/16)
      //
      // ANDROID: The updateSelection causes issues in Android when you are
      // at the end of a block. The selection ends up to the left of the inserted
      // character instead of to the right. This behavior continues even if
      // you enter more than one character. (2019/01/03)
      if (!__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["b" /* IS_ANDROID */] && handler === 'onSelect') {
        var editor = this.props.editor;
        var value = editor.value;
        var selection = value.selection;

        var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
        var domSelection = window.getSelection();
        var range = editor.findRange(domSelection);

        if (range && range.equals(selection.toRange())) {
          this.updateSelection();
          return;
        }
      }

      // Don't handle drag and drop events coming from embedded editors.
      if (handler === 'onDragEnd' || handler === 'onDragEnter' || handler === 'onDragExit' || handler === 'onDragLeave' || handler === 'onDragOver' || handler === 'onDragStart' || handler === 'onDrop') {
        var closest = event.target.closest(SELECTORS.EDITOR);

        if (closest !== this.ref.current) {
          return;
        }
      }

      // Some events require being in editable in the editor, so if the event
      // target isn't, ignore them.
      if (handler === 'onBeforeInput' || handler === 'onBlur' || handler === 'onCompositionEnd' || handler === 'onCompositionStart' || handler === 'onCopy' || handler === 'onCut' || handler === 'onFocus' || handler === 'onInput' || handler === 'onKeyDown' || handler === 'onKeyUp' || handler === 'onPaste' || handler === 'onSelect') {
        if (!this.isInEditor(event.target)) {
          return;
        }
      }

      this.props.onEvent(handler, event);
    }

    /**
     * On native `selectionchange` event, trigger the `onSelect` handler. This is
     * needed to account for React's `onSelect` being non-standard and not firing
     * until after a selection has been released. This causes issues in situations
     * where another change happens while a selection is being made.
     *
     * @param {Event} event
     */

  }, {
    key: 'render',


    /**
     * Render the editor content.
     *
     * @return {Element}
     */

    value: function render() {
      var _data;

      var props = this.props,
          handlers = this.handlers;
      var id = props.id,
          className = props.className,
          readOnly = props.readOnly,
          editor = props.editor,
          tabIndex = props.tabIndex,
          role = props.role,
          tagName = props.tagName,
          spellCheck = props.spellCheck;
      var value = editor.value;

      var Container = tagName;
      var document = value.document,
          selection = value.selection;


      var style = _extends({
        // Prevent the default outline styles.
        outline: 'none',
        // Preserve adjacent whitespace and new lines.
        whiteSpace: 'pre-wrap',
        // Allow words to break if they are too long.
        wordWrap: 'break-word'
      }, readOnly ? {} : { WebkitUserModify: 'read-write-plaintext-only' }, props.style);

      // console.log('rerender content', this.tmp.contentKey, document.text)

      debug$2('render', { props: props });
      debug$2.update('render', this.tmp.contentKey, document.text);

      this.props.onEvent('onRender');

      var data = (_data = {}, defineProperty(_data, DATA_ATTRS.EDITOR, true), defineProperty(_data, DATA_ATTRS.KEY, document.key), _data);

      var domProps = __WEBPACK_IMPORTED_MODULE_11_lodash_omit___default()(this.props, Object.keys(Content.propTypes));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Container,
        _extends({}, domProps, {
          key: this.tmp.contentKey
        }, handlers, data, {
          ref: this.setRef,
          contentEditable: readOnly ? null : true,
          suppressContentEditableWarning: true,
          id: id,
          className: className,
          autoCorrect: props.autoCorrect ? 'on' : 'off',
          spellCheck: spellCheck,
          style: style,
          role: readOnly ? null : role || 'textbox',
          tabIndex: tabIndex
          // COMPAT: The Grammarly Chrome extension works by changing the DOM out
          // from under `contenteditable` elements, which leads to weird behaviors
          // so we have to disable it like this. (2017/04/24)

          // just the existence of the flag is disabling the extension irrespective of its value
          , 'data-gramm': domProps['data-gramm'] ? undefined : false
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Node$1, {
          annotations: value.annotations,
          block: null,
          decorations: Object(__WEBPACK_IMPORTED_MODULE_12_immutable__["List"])(),
          editor: editor,
          node: document,
          parent: null,
          readOnly: readOnly,
          selection: selection,
          ref: this.tmp.nodeRef
        })
      );
    }
  }]);
  return Content;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * Export.
 *
 * @type {Component}
 */

Content.propTypes = {
  autoCorrect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  editor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  spellCheck: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tagName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string };
Content.defaultProps = {
  style: {},
  tagName: 'div' };

var PROPS = [].concat(toConsumableArray(EVENT_HANDLERS), ['commands', 'decorateNode', 'queries', 'renderAnnotation', 'renderBlock', 'renderDecoration', 'renderDocument', 'renderEditor', 'renderInline', 'renderMark', 'schema']);

/**
 * The top-level editor props in a plugin.
 *
 * @param {Object} options
 * @return {Object}
 */

function EditorPropsPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var plugin = PROPS.reduce(function (memo, prop) {
    if (prop in options) memo[prop] = options[prop];
    return memo;
  }, {});

  return plugin;
}

/**
 * Export.
 *
 * @type {Function}
 */

function Rendering() {
  return {
    decorateNode: function decorateNode() {
      return [];
    },
    renderAnnotation: function renderAnnotation(_ref) {
      var attributes = _ref.attributes,
          children = _ref.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        attributes,
        children
      );
    },
    renderBlock: function renderBlock(_ref2) {
      var attributes = _ref2.attributes,
          children = _ref2.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, { style: { position: 'relative' } }),
        children
      );
    },
    renderDecoration: function renderDecoration(_ref3) {
      var attributes = _ref3.attributes,
          children = _ref3.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        attributes,
        children
      );
    },
    renderDocument: function renderDocument(_ref4) {
      var children = _ref4.children;

      return children;
    },
    renderEditor: function renderEditor(_ref5) {
      var children = _ref5.children;

      return children;
    },
    renderInline: function renderInline(_ref6) {
      var attributes = _ref6.attributes,
          children = _ref6.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        _extends({}, attributes, { style: { position: 'relative' } }),
        children
      );
    },
    renderMark: function renderMark(_ref7) {
      var attributes = _ref7.attributes,
          children = _ref7.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        attributes,
        children
      );
    }
  };
}

/**
 * Export.
 *
 * @type {Function}
 */

/**
 * A set of commands for the React plugin.
 *
 * @return {Object}
 */

function CommandsPlugin() {
  /**
   * Takes a `node`, find the matching `domNode` and uses it to set the text
   * in the `node`.
   *
   * @param {Editor} editor
   * @param {Node} node
   */

  function reconcileNode(editor, node) {
    var value = editor.value;
    var document = value.document,
        selection = value.selection;

    var path = document.getPath(node.key);

    var domElement = editor.findDOMNode(path);
    var block = document.getClosestBlock(path);

    // Get text information
    var text = node.text;
    var domText = domElement.textContent;


    var isLastNode = block.nodes.last() === node;
    var lastChar = domText.charAt(domText.length - 1);

    // COMPAT: If this is the last leaf, and the DOM text ends in a new line,
    // we will have added another new line in <Leaf>'s render method to account
    // for browsers collapsing a single trailing new lines, so remove it.
    if (isLastNode && lastChar === '\n') {
      domText = domText.slice(0, -1);
    }

    // If the text is no different, abort.
    if (text === domText) return;

    var entire = selection.moveAnchorTo(path, 0).moveFocusTo(path, text.length);

    entire = document.resolveRange(entire);

    // Change the current value to have the leaf's text replaced.
    editor.insertTextAtRange(entire, domText, node.marks);
    return;
  }

  /**
   * Takes text from the `domNode` and uses it to set the text in the matching
   * `node` in Slate.
   *
   * @param {Editor} editor
   * @param {DOMNode} domNode
   */

  function reconcileDOMNode(editor, domNode) {
    var domElement = domNode.parentElement.closest('[data-key]');
    var node = editor.findNode(domElement);

    if (node.object === 'text') {
      editor.reconcileNode(node);
    } else {
      node.getTexts().forEach(function (textNode) {
        editor.reconcileNode(textNode);
      });
    }
  }

  return {
    commands: {
      reconcileNode: reconcileNode,
      reconcileDOMNode: reconcileDOMNode
    }
  };
}

function QueriesPlugin() {
  /**
   * Find the native DOM element for a node at `path`.
   *
   * @param {Editor} editor
   * @param {Array|List} path
   * @return {DOMNode|Null}
   */

  function findDOMNode(editor, path) {
    path = __WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].create(path);
    var content = editor.tmp.contentRef.current;

    if (!content) {
      return null;
    }

    if (!path.size) {
      return content.ref.current || null;
    }

    var search = function search(instance, p) {
      if (!instance) {
        return null;
      }

      if (!p.size) {
        if (instance.ref) {
          return instance.ref.current || null;
        } else {
          return instance || null;
        }
      }

      var index = p.first();
      var rest = p.rest();
      var ref = instance.tmp.nodeRefs[index];
      return search(ref, rest);
    };

    var document = content.tmp.nodeRef.current;
    var el = search(document, path);
    return el;
  }

  /**
   * Find a native DOM selection point from a Slate `point`.
   *
   * @param {Editor} editor
   * @param {Point} point
   * @return {Object|Null}
   */

  function findDOMPoint(editor, point) {
    var el = editor.findDOMNode(point.path);
    var start = 0;

    if (!el) {
      return null;
    }

    // For each leaf, we need to isolate its content, which means filtering to its
    // direct text and zero-width spans. (We have to filter out any other siblings
    // that may have been rendered alongside them.)
    var texts = Array.from(el.querySelectorAll(SELECTORS.STRING + ', ' + SELECTORS.ZERO_WIDTH));

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = texts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var text = _step.value;

        var node = text.childNodes[0];
        var domLength = node.textContent.length;
        var slateLength = domLength;

        if (text.hasAttribute(DATA_ATTRS.LENGTH)) {
          slateLength = parseInt(text.getAttribute(DATA_ATTRS.LENGTH), 10);
        }

        var end = start + slateLength;

        if (point.offset <= end) {
          var offset = Math.min(domLength, Math.max(0, point.offset - start));
          return { node: node, offset: offset };
        }

        start = end;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  }

  /**
   * Find a native DOM range from a Slate `range`.
   *
   * @param {Editor} editor
   * @param {Range} range
   * @return {DOMRange|Null}
   */

  function findDOMRange(editor, range) {
    var anchor = range.anchor,
        focus = range.focus,
        isBackward$$1 = range.isBackward,
        isCollapsed = range.isCollapsed;

    var domAnchor = editor.findDOMPoint(anchor);
    var domFocus = isCollapsed ? domAnchor : editor.findDOMPoint(focus);

    if (!domAnchor || !domFocus) {
      return null;
    }

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(domAnchor.node);
    var r = window.document.createRange();
    var start = isBackward$$1 ? domFocus : domAnchor;
    var end = isBackward$$1 ? domAnchor : domFocus;
    r.setStart(start.node, start.offset);
    r.setEnd(end.node, end.offset);
    return r;
  }

  /**
   * Find a Slate node from a native DOM `element`.
   *
   * @param {Editor} editor
   * @param {Element} element
   * @return {List|Null}
   */

  function findNode(editor, element) {
    var path = editor.findPath(element);

    if (!path) {
      return null;
    }

    var value = editor.value;
    var document = value.document;

    var node = document.getNode(path);
    return node;
  }

  /**
   * Get the target range from a DOM `event`.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @return {Range}
   */

  function findEventRange(editor, event) {
    if (event.nativeEvent) {
      event = event.nativeEvent;
    }

    var _event = event,
        x = _event.clientX,
        y = _event.clientY,
        target = _event.target;

    if (x == null || y == null) return null;

    var value = editor.value;
    var document = value.document;

    var path = editor.findPath(event.target);
    if (!path) return null;

    var node = document.getNode(path);

    // If the drop target is inside a void node, move it into either the next or
    // previous node, depending on which side the `x` and `y` coordinates are
    // closest to.
    if (editor.isVoid(node)) {
      var rect = target.getBoundingClientRect();
      var isPrevious = node.object === 'inline' ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;

      var _range = document.createRange();
      var move = isPrevious ? 'moveToEndOfNode' : 'moveToStartOfNode';
      var entry = document[isPrevious ? 'getPreviousText' : 'getNextText'](path);

      if (entry) {
        return _range[move](entry);
      }

      return null;
    }

    // Else resolve a range from the caret position where the drop occured.
    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(target);
    var native = void 0;

    // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)
    if (window.document.caretRangeFromPoint) {
      native = window.document.caretRangeFromPoint(x, y);
    } else if (window.document.caretPositionFromPoint) {
      var position = window.document.caretPositionFromPoint(x, y);
      native = window.document.createRange();
      native.setStart(position.offsetNode, position.offset);
      native.setEnd(position.offsetNode, position.offset);
    } else if (window.document.body.createTextRange) {
      // COMPAT: In IE, `caretRangeFromPoint` and
      // `caretPositionFromPoint` don't exist. (2018/07/11)
      native = window.document.body.createTextRange();

      try {
        native.moveToPoint(x, y);
      } catch (error) {
        // IE11 will raise an `unspecified error` if `moveToPoint` is
        // called during a dropEvent.
        return null;
      }
    }

    // Resolve a Slate range from the DOM range.
    var range = editor.findRange(native);
    return range;
  }

  /**
   * Find the path of a native DOM `element` by searching React refs.
   *
   * @param {Editor} editor
   * @param {Element} element
   * @return {List|Null}
   */

  function findPath(editor, element) {
    var content = editor.tmp.contentRef.current;
    var nodeElement = element;

    // If element does not have a key, it is likely a string or
    // mark, return the closest parent Node that can be looked up.
    if (!nodeElement.hasAttribute(DATA_ATTRS.KEY)) {
      nodeElement = nodeElement.closest(SELECTORS.KEY);
    }

    if (!nodeElement || !nodeElement.getAttribute(DATA_ATTRS.KEY)) {
      return null;
    }

    if (nodeElement === content.ref.current) {
      return __WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].create([]);
    }

    var search = function search(instance, p) {
      if (nodeElement === instance) {
        return p;
      }

      if (!instance.ref) {
        return null;
      }

      if (nodeElement === instance.ref.current) {
        return p;
      }

      // If there's no `tmp` then we're at a leaf node without success.
      if (!instance.tmp) {
        return null;
      }

      var nodeRefs = instance.tmp.nodeRefs;

      var keys = Object.keys(nodeRefs);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var i = _step2.value;

          var ref = nodeRefs[i];
          var n = parseInt(i, 10);
          var _path = search(ref, [].concat(toConsumableArray(p), [n]));

          if (_path) {
            return _path;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    };

    var document = content.tmp.nodeRef.current;
    var path = search(document, []);

    if (!path) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].create(path);
  }

  /**
   * Find a Slate point from a DOM selection's `nativeNode` and `nativeOffset`.
   *
   * @param {Editor} editor
   * @param {Element} nativeNode
   * @param {Number} nativeOffset
   * @return {Point}
   */

  function findPoint(editor, nativeNode, nativeOffset) {
    var _normalizeNodeAndOffs = normalizeNodeAndOffset(nativeNode, nativeOffset),
        nearestNode = _normalizeNodeAndOffs.node,
        nearestOffset = _normalizeNodeAndOffs.offset;

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(nativeNode);
    var parentNode = nearestNode.parentNode;

    var leafNode = parentNode.closest(SELECTORS.LEAF);
    var textNode = void 0;
    var offset = void 0;
    var node = void 0;

    // Calculate how far into the text node the `nearestNode` is, so that we can
    // determine what the offset relative to the text node is.
    if (leafNode) {
      textNode = leafNode.closest(SELECTORS.TEXT);
      var range = window.document.createRange();
      range.setStart(textNode, 0);
      range.setEnd(nearestNode, nearestOffset);
      var contents = range.cloneContents();
      var zeroWidths = contents.querySelectorAll(SELECTORS.ZERO_WIDTH);

      Array.from(zeroWidths).forEach(function (el) {
        el.parentNode.removeChild(el);
      });

      // COMPAT: Edge has a bug where Range.prototype.toString() will convert \n
      // into \r\n. The bug causes a loop when slate-react attempts to reposition
      // its cursor to match the native position. Use textContent.length instead.
      // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/
      offset = contents.textContent.length;
      node = textNode;
    } else {
      // For void nodes, the element with the offset key will be a cousin, not an
      // ancestor, so find it by going down from the nearest void parent.
      var voidNode = parentNode.closest(SELECTORS.VOID);

      if (!voidNode) {
        return null;
      }

      leafNode = voidNode.querySelector(SELECTORS.LEAF);

      if (!leafNode) {
        return null;
      }

      textNode = leafNode.closest(SELECTORS.TEXT);
      node = leafNode;
      offset = node.textContent.length;
    }

    // COMPAT: If the parent node is a Slate zero-width space, this is because the
    // text node should have no characters. However, during IME composition the
    // ASCII characters will be prepended to the zero-width space, so subtract 1
    // from the offset to account for the zero-width space character.
    if (offset === node.textContent.length && parentNode.hasAttribute(DATA_ATTRS.ZERO_WIDTH)) {
      offset--;
    }

    // COMPAT: If someone is clicking from one Slate editor into another, the
    // select event fires twice, once for the old editor's `element` first, and
    // then afterwards for the correct `element`. (2017/03/03)
    var path = editor.findPath(textNode);

    if (!path) {
      return null;
    }

    var value = editor.value;
    var document = value.document;

    var point = document.createPoint({ path: path, offset: offset });
    return point;
  }

  /**
   * Find a Slate range from a DOM range or selection.
   *
   * @param {Editor} editor
   * @param {Selection} domRange
   * @return {Range}
   */

  function findRange(editor, domRange) {
    var el = domRange.anchorNode || domRange.startContainer;

    if (!el) {
      return null;
    }

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(el);

    // If the `domRange` object is a DOM `Range` or `StaticRange` object, change it
    // into something that looks like a DOM `Selection` instead.
    if (domRange instanceof window.Range || window.StaticRange && domRange instanceof window.StaticRange) {
      domRange = {
        anchorNode: domRange.startContainer,
        anchorOffset: domRange.startOffset,
        focusNode: domRange.endContainer,
        focusOffset: domRange.endOffset
      };
    }

    var _domRange = domRange,
        anchorNode = _domRange.anchorNode,
        anchorOffset = _domRange.anchorOffset,
        focusNode = _domRange.focusNode,
        focusOffset = _domRange.focusOffset,
        isCollapsed = _domRange.isCollapsed;
    var value = editor.value;

    var anchor = editor.findPoint(anchorNode, anchorOffset);
    var focus = isCollapsed ? anchor : editor.findPoint(focusNode, focusOffset);

    if (!anchor || !focus) {
      return null;
    }

    var document = value.document;

    var range = document.createRange({
      anchor: anchor,
      focus: focus
    });

    return range;
  }

  /**
   * Find a Slate selection from a DOM selection.
   *
   * @param {Editor} editor
   * @param {Selection} domSelection
   * @return {Range}
   */

  function findSelection(editor, domSelection) {
    var value = editor.value;
    var document = value.document;

    // If there are no ranges, the editor was blurred natively.

    if (!domSelection.rangeCount) {
      return null;
    }

    // Otherwise, determine the Slate selection from the native one.
    var range = editor.findRange(domSelection);

    if (!range) {
      return null;
    }

    var _range2 = range,
        anchor = _range2.anchor,
        focus = _range2.focus;

    var anchorText = document.getNode(anchor.path);
    var focusText = document.getNode(focus.path);
    var anchorInline = document.getClosestInline(anchor.path);
    var focusInline = document.getClosestInline(focus.path);
    var focusBlock = document.getClosestBlock(focus.path);
    var anchorBlock = document.getClosestBlock(anchor.path);

    // COMPAT: If the anchor point is at the start of a non-void, and the
    // focus point is inside a void node with an offset that isn't `0`, set
    // the focus offset to `0`. This is due to void nodes <span>'s being
    // positioned off screen, resulting in the offset always being greater
    // than `0`. Since we can't know what it really should be, and since an
    // offset of `0` is less destructive because it creates a hanging
    // selection, go with `0`. (2017/09/07)
    if (anchorBlock && !editor.isVoid(anchorBlock) && anchor.offset === 0 && focusBlock && editor.isVoid(focusBlock) && focus.offset !== 0) {
      range = range.setFocus(focus.setOffset(0));
    }

    // COMPAT: If the selection is at the end of a non-void inline node, and
    // there is a node after it, put it in the node after instead. This
    // standardizes the behavior, since it's indistinguishable to the user.
    if (anchorInline && !editor.isVoid(anchorInline) && anchor.offset === anchorText.text.length) {
      var block = document.getClosestBlock(anchor.path);
      var depth = document.getDepth(block.key);
      var relativePath = __WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].drop(anchor.path, depth);

      var _block$texts = block.texts({ path: relativePath }),
          _block$texts2 = slicedToArray(_block$texts, 1),
          next = _block$texts2[0];

      if (next) {
        var _next = slicedToArray(next, 2),
            nextPath = _next[1];

        var absolutePath = anchor.path.slice(0, depth).concat(nextPath);
        range = range.moveAnchorTo(absolutePath, 0);
      }
    }

    if (focusInline && !editor.isVoid(focusInline) && focus.offset === focusText.text.length) {
      var _block = document.getClosestBlock(focus.path);
      var _depth = document.getDepth(_block.key);
      var _relativePath = __WEBPACK_IMPORTED_MODULE_6_slate__["j" /* PathUtils */].drop(focus.path, _depth);

      var _block$texts3 = _block.texts({ path: _relativePath }),
          _block$texts4 = slicedToArray(_block$texts3, 1),
          _next2 = _block$texts4[0];

      if (_next2) {
        var _next3 = slicedToArray(_next2, 2),
            _nextPath = _next3[1];

        var _absolutePath = focus.path.slice(0, _depth).concat(_nextPath);
        range = range.moveFocusTo(_absolutePath, 0);
      }
    }

    var selection = document.createSelection(range);

    // COMPAT: Ensure that the `isFocused` argument is set.
    selection = selection.setIsFocused(true);

    // COMPAT: Preserve the marks, since we have no way of knowing what the DOM
    // selection's marks were. They will be cleared automatically by the
    // `select` command if the selection moves.
    selection = selection.set('marks', value.selection.marks);

    return selection;
  }

  return {
    queries: {
      findDOMNode: findDOMNode,
      findDOMPoint: findDOMPoint,
      findDOMRange: findDOMRange,
      findEventRange: findEventRange,
      findNode: findNode,
      findPath: findPath,
      findPoint: findPoint,
      findRange: findRange,
      findSelection: findSelection
    }
  };
}

/**
 * From a DOM selection's `node` and `offset`, normalize so that it always
 * refers to a text node.
 *
 * @param {Element} node
 * @param {Number} offset
 * @return {Object}
 */

function normalizeNodeAndOffset(node, offset) {
  // If it's an element node, its offset refers to the index of its children
  // including comment nodes, so try to find the right text child node.
  if (node.nodeType === 1 && node.childNodes.length) {
    var isLast = offset === node.childNodes.length;
    var direction = isLast ? 'backward' : 'forward';
    var index = isLast ? offset - 1 : offset;
    node = getEditableChild(node, index, direction);

    // If the node has children, traverse until we have a leaf node. Leaf nodes
    // can be either text nodes, or other void DOM nodes.
    while (node.nodeType === 1 && node.childNodes.length) {
      var i = isLast ? node.childNodes.length - 1 : 0;
      node = getEditableChild(node, i, direction);
    }

    // Determine the new offset inside the text node.
    offset = isLast ? node.textContent.length : 0;
  }

  // Return the node and offset.
  return { node: node, offset: offset };
}

/**
 * Get the nearest editable child at `index` in a `parent`, preferring
 * `direction`.
 *
 * @param {Element} parent
 * @param {Number} index
 * @param {String} direction ('forward' or 'backward')
 * @return {Element|Null}
 */

function getEditableChild(parent, index, direction) {
  var childNodes = parent.childNodes;

  var child = childNodes[index];
  var i = index;
  var triedForward = false;
  var triedBackward = false;

  // While the child is a comment node, or an element node with no children,
  // keep iterating to find a sibling non-void, non-comment node.
  while (child.nodeType === 8 || child.nodeType === 1 && child.childNodes.length === 0 || child.nodeType === 1 && child.getAttribute('contenteditable') === 'false') {
    if (triedForward && triedBackward) break;

    if (i >= childNodes.length) {
      triedForward = true;
      i = index - 1;
      direction = 'backward';
      continue;
    }

    if (i < 0) {
      triedBackward = true;
      i = index + 1;
      direction = 'forward';
      continue;
    }

    child = childNodes[i];
    if (direction === 'forward') i++;
    if (direction === 'backward') i--;
  }

  return child || null;
}

/**
 * Export.
 *
 * @type {Function}
 */

/**
 * Returns the number of characters that are the same at the beginning of the
 * String.
 *
 * @param {String} prev
 * @param {String} next
 */

function getDiffStart(prev, next) {
  var length = Math.min(prev.length, next.length);

  for (var i = 0; i < length; i++) {
    if (prev.charAt(i) !== next.charAt(i)) return i;
  }

  if (prev.length !== next.length) return length;
  return null;
}

/**
 * Returns the number of characters that are the same at the end of the String
 * up to `max`. Max prevents double-counting characters when there are
 * multiple duplicate characters around the diff area.
 *
 * @param {String} prev
 * @param {String} next
 * @param {Number} max
 */

function getDiffEnd(prev, next, max) {
  var prevLength = prev.length;
  var nextLength = next.length;
  var length = Math.min(prevLength, nextLength, max);

  for (var i = 0; i < length; i++) {
    var prevChar = prev.charAt(prevLength - i - 1);
    var nextChar = next.charAt(nextLength - i - 1);
    if (prevChar !== nextChar) return i;
  }

  if (prev.length !== next.length) return length;
  return null;
}

/**
 * Takes two strings and returns an object representing two offsets. The
 * first, `start` represents the number of characters that are the same at
 * the front of the String. The `end` represents the number of characters
 * that are the same at the end of the String.
 *
 * Returns null if they are identical.
 *
 * @param {String} prev
 * @param {String} next
 */

function getDiffOffsets(prev, next) {
  if (prev === next) return null;
  var start = getDiffStart(prev, next);
  var maxEnd = Math.min(prev.length - start, next.length - start);
  var end = getDiffEnd(prev, next, maxEnd);
  return { start: start, end: end, total: start + end };
}

/**
 * Takes a text string and returns a slice from the string at the given offses
 *
 * @param {String} text
 * @param {Object} offsets
 */

function sliceText(text, offsets) {
  return text.slice(offsets.start, text.length - offsets.end);
}

/**
 * Takes two strings and returns a smart diff that can be used to describe the
 * change in a way that can be used as operations like inserting, removing or
 * replacing text.
 *
 * @param {String} prev
 * @param {String} next
 */

function diff(prev, next) {
  var offsets = getDiffOffsets(prev, next);
  if (offsets == null) return null;
  var insertText = sliceText(next, offsets);
  var removeText = sliceText(prev, offsets);
  return {
    start: offsets.start,
    end: prev.length - offsets.end,
    cursor: offsets.start + insertText.length,
    insertText: insertText,
    removeText: removeText
  };
}

/**
 * @type {Debug}
 */

var debug$3 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:composition-manager');

/**
 * Unicode String for a ZERO_WIDTH_SPACE
 *
 * @type {String}
 */

var ZERO_WIDTH_SPACE = String.fromCharCode(65279);

/**
 * https://github.com/facebook/draft-js/commit/cda13cb8ff9c896cdb9ff832d1edeaa470d3b871
 */

var flushControlled = __WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.unstable_flushControlled;

function renderSync(editor, fn) {
  flushControlled(function () {
    fn();
    editor.controller.flush();
  });
}

function isPointsEqual(point1, point2) {
  return point1.offset === point2.offset && point1.key === point2.key;
}

function isRangesEqual(range1, range2) {
  return isPointsEqual(range1.anchor, range2.anchor) && isPointsEqual(range1.focus, range2.focus);
}

/**
 * Takes text from a dom node and an offset within that text and returns an
 * object with fixed text and fixed offset which removes zero width spaces
 * and adjusts the offset.
 *
 * Optionally, if an `isLastNode` argument is passed in, it will also remove
 * a trailing newline.
 *
 * @param {String} text
 * @param {Number} offset
 * @param {Boolean} isLastNode
 */

function fixTextAndOffset(prevNode) {
  var prevOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isLastNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var prevText = prevNode.textContent;
  var nextOffset = prevOffset;
  var nextText = prevText;
  var index = 0;

  // We must account for previous sibling text nodes. The fact that dom text nodes
  // may be adjacent to each other must not influence slate coordinate system.
  while (prevNode.previousSibling != null) {
    prevNode = prevNode.previousSibling;
    nextText = prevNode.textContent + nextText;
    nextOffset += prevNode.textContent.length;
  }

  while (index !== -1) {
    index = nextText.indexOf(ZERO_WIDTH_SPACE, index);
    if (index === -1) break;
    if (nextOffset > index) nextOffset--;
    nextText = '' + nextText.slice(0, index) + nextText.slice(index + 1);
  }

  // remove the last newline if we are in the last node of a block
  var lastChar = nextText.charAt(nextText.length - 1);

  if (isLastNode && lastChar === '\n') {
    nextText = nextText.slice(0, -1);
  }

  var maxOffset = nextText.length;

  if (nextOffset > maxOffset) nextOffset = maxOffset;
  return { text: nextText, offset: nextOffset };
}

/**
 * Based loosely on:
 *
 * https://github.com/facebook/draft-js/blob/master/src/component/handlers/composition/DOMObserver.js
 * https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
 *
 * But is an analysis mainly for `backspace` and `enter` as we handle
 * compositions as a single operation.
 *
 * @param {} element
 */

function CompositionManager(editor) {
  /**
   * A MutationObserver that flushes to the method `flush`
   *
   * @type {MutationObserver}
   */

  var observer = new window.MutationObserver(flush);

  var win = null;

  /**
   * Object that keeps track of the most recent state
   *
   * @type {Range}
   */

  var last = {
    rootEl: null, // root element that MutationObserver is attached to
    diff: null, // last text node diff between Slate and DOM
    range: null, // last range selected
    domNode: null // last DOM node the cursor was in


    /**
     * Connect the MutationObserver to a specific editor root element
     */

  };function connect() {
    var rootEl = editor.findDOMNode([]);

    debug$3('connect', { rootEl: rootEl });

    if (last.rootEl === rootEl) return;

    debug$3('connect:run');

    win = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(rootEl);

    observer.observe(rootEl, {
      childList: true,
      characterData: true,
      attributes: true,
      subtree: true,
      characterDataOldValue: true
    });
  }

  function disconnect() {
    debug$3('disconnect');
    observer.disconnect();
    last.rootEl = null;
  }

  function clearDiff() {
    debug$3('clearDIff');
    last.diff = null;
  }

  /**
   * Clear the `last` properties related to an action only
   */

  function clearAction() {
    debug$3('clearAction');
    last.diff = null;
    last.domNode = null;
  }

  /**
   * Compute the selection at the cursor inside a diff
   */

  function endDiffSelection() {
    var diff$$1 = last.diff;

    if (diff$$1 == null) return null;

    return editor.value.selection.moveFocusTo(diff$$1.path, diff$$1.cursor + diff$$1.start).moveToFocus();
  }

  /**
   * Apply the last `diff`
   *
   * We don't want to apply the `diff` at the time it is created because we
   * may be in a composition. There are a few things that trigger the applying
   * of the saved diff. Sometimeson its own and sometimes immediately before
   * doing something else with the Editor.
   *
   * - `onCompositionEnd` event
   * - `onSelect` event only when the user has moved into a different node
   * - The user hits `enter`
   * - The user hits `backspace` and removes an inline node
   * - The user hits `backspace` and merges two blocks
   */

  function applyDiff() {
    debug$3('applyDiff');
    var diff$$1 = last.diff;

    if (diff$$1 == null) return;
    debug$3('applyDiff:run');
    var document = editor.value.document;


    var entire = editor.value.selection.moveAnchorTo(diff$$1.path, diff$$1.start).moveFocusTo(diff$$1.path, diff$$1.end);

    entire = document.resolveRange(entire);

    editor.insertTextAtRange(entire, diff$$1.insertText);
  }

  /**
   * Handle `enter` that splits block
   */

  function splitBlock() {
    debug$3('splitBlock');

    renderSync(editor, function () {
      var nextSelection = last.range != null ? last.range : endDiffSelection();

      applyDiff();

      if (nextSelection != null) {
        editor.select(nextSelection);
      } else {
        debug$3('splitBlock:NO-SELECTION');
      }

      editor.splitBlock().focus().restoreDOM();

      clearAction();
    });
  }

  /**
   * Handle `backspace` that merges blocks
   */

  function mergeBlock() {
    debug$3('mergeBlock');

    /**
     * The delay is required because hitting `enter`, `enter` then `backspace`
     * in a word results in the cursor being one position to the right in
     * Android 9.
     *
     * Slate sets the position to `0` and we even check it immediately after
     * setting it and it is correct, but somewhere Android moves it to the right.
     *
     * This happens only when using the virtual keyboard. Hitting enter on a
     * hardware keyboard does not trigger this bug.
     *
     * The call to `focus` is required because when we switch examples then
     * merge a block, we lose focus in Android 9 (possibly others).
     */

    win.requestAnimationFrame(function () {
      renderSync(editor, function () {
        applyDiff();

        if (last.range != null) {
          editor.select(last.range);
        } else {
          debug$3('mergeBlock:NO-SELECTION');
        }

        var selection = editor.value.selection;

        if (selection.focus.offset === 0 && selection.isCollapsed) {
          editor.deleteBackward().focus().restoreDOM();

          clearAction();
        } else {
          debug$3('mergeBlock:invalid', 'Invalid range', selection.toJS());
        }
      });
    });
  }

  /**
   * The requestId used to the save selection
   *
   * @type {Any}
   */

  var onSelectTimeoutId = null;

  var bufferedMutations = [];
  var startActionFrameId = null;
  var isFlushing = false;

  /**
   * Mark the beginning of an action. The action happens when the
   * `requestAnimationFrame` expires.
   *
   * If `startAction` is called again, it pushes the `action` to a new
   * `requestAnimationFrame` and cancels the old one.
   */

  function startAction() {
    if (onSelectTimeoutId) {
      window.cancelAnimationFrame(onSelectTimeoutId);
      onSelectTimeoutId = null;
    }

    isFlushing = true;

    if (startActionFrameId) window.cancelAnimationFrame(startActionFrameId);

    startActionFrameId = window.requestAnimationFrame(function () {
      if (bufferedMutations.length > 0) {
        flushAction(bufferedMutations);
      }

      startActionFrameId = null;
      bufferedMutations = [];
      isFlushing = false;
    });
  }

  /**
   * Handle MutationObserver flush
   *
   * @param {MutationList} mutations
   */

  function flush(mutations) {
    var _bufferedMutations;

    debug$3('flush');
    (_bufferedMutations = bufferedMutations).push.apply(_bufferedMutations, toConsumableArray(mutations));
    startAction();
  }

  /**
   * Handle a `requestAnimationFrame` long batch of mutations.
   *
   * @param {Array} mutations
   */

  function flushAction(mutations) {
    debug$3('flushAction', mutations.length, mutations);

    // If there is an expanded collection, delete it
    if (last.range && !last.range.isCollapsed) {
      renderSync(editor, function () {
        editor.select(last.range).deleteBackward().focus().restoreDOM();
      });
      return;
    }

    if (mutations.length > 1) {
      // check if one of the mutations matches the signature of an `enter`
      // which we use to signify a `splitBlock`
      var splitBlockMutation = mutations.find(function (m) {
        if (m.type !== 'childList') return false;
        if (m.addedNodes.length === 0) return false;
        var addedNode = m.addedNodes[0];

        // If a text node is created anywhere with a newline in it, it's an
        // enter
        if (addedNode.nodeType === window.Node.TEXT_NODE && addedNode.textContent === '\n') return true;

        // If an element is created with a key that matches a block in our
        // document, that means the mutation is splitting an existing block
        // by creating a new element with the same key.
        if (addedNode.nodeType !== window.Node.ELEMENT_NODE) return false;
        var dataset = addedNode.dataset;
        var key = dataset.key;
        if (key == null) return false;
        var block = editor.value.document.getClosestBlock(key);
        return !!block;
      });

      if (splitBlockMutation) {
        splitBlock();
        return;
      }
    }

    // If we haven't matched a more specific mutation already, these general
    // mutation catchers will try and determine what the user was trying to
    // do.

    var firstMutation = mutations[0];

    var matchCharacterDataParent = function matchCharacterDataParent() {
      if (firstMutation.target.parentNode && firstMutation.target.parentNode.closest('[data-slate-editor]')) {
        return firstMutation.target.parentNode;
      } else {
        var mutationRemoveTarget = mutations.find(function (m) {
          if (m.type !== 'childList') return false;
          return m.removedNodes[0] === firstMutation.target;
        });

        return mutationRemoveTarget && mutationRemoveTarget.target;
      }
    };

    // Here we want to filter BR nodes out.
    // When the content editable choose to remove a node instead of
    // a 'characterData' mutation, it is usually the only mutation, unless
    // it's the last node. When it's the last node, the browser also adds a BR.
    // We want to filter it out so we match the mutation correctly and call `removeNode`
    var filterBr = function filterBr() {
      return mutations.filter(function (m) {
        return !(m.addedNodes[0] && m.addedNodes[0].nodeName === 'BR');
      });
    };

    if (firstMutation.type === 'characterData') {
      var parent = matchCharacterDataParent();

      if (parent) {
        resolveDOMNode(matchCharacterDataParent());
      }
    } else if (firstMutation.type === 'childList') {
      if (firstMutation.removedNodes.length > 0) {
        if (filterBr().length === 1) {
          removeNode(firstMutation.removedNodes[0]);
        } else {
          mergeBlock();
        }
      } else if (firstMutation.addedNodes.length > 0) {
        splitBlock();
      }
    }
  }

  /**
   * Takes a DOM Node and resolves it against Slate's Document.
   *
   * Saves the changes to `last.diff` which can be applied later using
   * `applyDiff()`
   *
   * @param {DOMNode} domNode
   */

  function resolveDOMNode(domNode) {
    debug$3('resolveDOMNode');

    var value = editor.value;
    var document = value.document;


    var dataElement = domNode.closest('[data-key]');
    var key = dataElement.dataset.key;
    var path = document.getPath(key);
    var block = document.getClosestBlock(key);
    var node = document.getDescendant(key);
    var prevText = node.text;

    // COMPAT: If this is the last leaf, and the DOM text ends in a new line,
    // we will have added another new line in <Leaf>'s render method to account
    // for browsers collapsing a single trailing new lines, so remove it.
    var isLastNode = block.nodes.last() === node;

    var fix = fixTextAndOffset(domNode, 0, isLastNode);

    var nextText = fix.text;

    // If the text is no different, there is no diff.
    if (nextText === prevText) {
      last.diff = null;
      return;
    }

    var diff$$1 = diff(prevText, nextText);

    last.diff = {
      path: path,
      start: diff$$1.start,
      end: diff$$1.end,
      insertText: diff$$1.insertText,
      cursor: diff$$1.cursor
    };

    last.range = null;

    debug$3('resolveDOMNode:diff', last.diff);
  }

  /**
   * Remove an Inline DOM Node.
   *
   * Happens when you delete the last character in an Inline DOM Node
   */

  function removeNode(domNode) {
    debug$3('removeNode');
    if (domNode.nodeType !== window.Node.ELEMENT_NODE) return;
    var value = editor.value;
    var document = value.document,
        selection = value.selection;

    var node = editor.findNode(domNode);
    var nodeSelection = document.resolveRange(selection.moveToRangeOfNode(node));

    renderSync(editor, function () {
      editor.select(nodeSelection).delete().restoreDOM();
    });
  }

  /**
   * handle `onCompositionStart`
   */

  function onCompositionStart() {
    debug$3('onCompositionStart');
  }

  /**
   * handle `onCompositionEnd`
   */

  function onCompositionEnd() {
    debug$3('onCompositionEnd');

    /**
     * The timing on the `setTimeout` with `20` ms is sensitive.
     *
     * It cannot use `requestAnimationFrame` because it is too short.
     *
     * Android 9, for example, when you type `it ` the space will first trigger
     * a `compositionEnd` for the `it` part before the mutation for the ` `.
     * This means that we end up with `it` if we trigger too soon because it
     * is on the wrong value.
     */

    window.setTimeout(function () {
      if (last.diff) {
        debug$3('onCompositionEnd:applyDiff');

        renderSync(editor, function () {
          applyDiff();

          /**
           * We must call `restoreDOM` even though this is applying a `diff` which
           * should not require it. But if you type `it me. no.` on a blank line
           * with a block following it, the next line will merge with the this
           * line. A mysterious `keydown` with `input` of backspace appears in the
           * event stream which the user not React caused.
           *
           * `focus` is required as well because otherwise we lose focus on hitting
           * `enter` in such a scenario.
           */

          editor.restoreDOM();
        });
      }

      clearAction();
    }, 20);
  }

  /**
   * Handle `onSelect` event
   *
   * Save the selection after a `requestAnimationFrame`
   *
   * - If we're not in the middle of flushing mutations
   * - and cancel save if a mutation runs before the `requestAnimationFrame`
   */

  function onSelect(event) {
    debug$3('onSelect:try');

    // Event can be Synthetic React or native. Grab only the native one so
    // that we don't have to call `event.perist` for performance.
    event = event.nativeEvent ? event.nativeEvent : event;

    window.cancelAnimationFrame(onSelectTimeoutId);
    onSelectTimeoutId = null;

    // Don't capture the last selection if the selection was made during the
    // flushing of DOM mutations. This means it is all part of one user action.
    if (isFlushing) return;

    onSelectTimeoutId = window.requestAnimationFrame(function () {
      debug$3('onSelect:save-selection');

      var domSelection = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target).getSelection();
      var range = editor.findRange(domSelection);

      var anchorFix = fixTextAndOffset(domSelection.anchorNode, domSelection.anchorOffset);

      var focusFix = fixTextAndOffset(domSelection.focusNode, domSelection.focusOffset);

      if (range.anchor.offset !== anchorFix.offset) {
        range = range.set('anchor', range.anchor.set('offset', anchorFix.offset));
      }

      if (range.focus.offset !== focusFix.offset) {
        range = range.set('focus', range.focus.set('offset', focusFix.offset));
      }

      debug$3('onSelect:save-data', {
        domSelection: normalizeDOMSelection(domSelection),
        range: range.toJS()
      });

      // If the `domSelection` has moved into a new node, then reconcile with
      // `applyDiff`
      if (domSelection.isCollapsed && last.node !== domSelection.anchorNode && last.diff != null) {
        debug$3('onSelect:applyDiff', last.diff);
        applyDiff();
        clearAction();
      }

      // It's important that we don't run the select middleware or commit the
      // selection to the value when the diff has a value. When the diff is
      // non-null, the text structure in the value is different compared to the DOM.
      if (last.diff === null && !isRangesEqual(editor.value.selection, range)) {
        debug$3('onSelect:applySelection', range.toJS());

        // The editor might not be focused when receiving this selection event, we assume focus
        editor.select({
          anchor: range.anchor,
          focus: range.focus,
          isFocused: true
        });
      }

      last.range = range;
      last.node = domSelection.anchorNode;
    });
  }

  return {
    clearDiff: clearDiff,
    connect: connect,
    disconnect: disconnect,
    onKeyDown: startAction,
    onCompositionStart: onCompositionStart,
    onCompositionEnd: onCompositionEnd,
    onSelect: onSelect,
    hasPendingCompositionDiff: function hasPendingCompositionDiff() {
      return last.diff != null;
    }
  };
}

function normalizeDOMSelection(selection) {
  return {
    anchorNode: selection.anchorNode,
    anchorOffset: selection.anchorOffset,
    focusNode: selection.focusNode,
    focusOffset: selection.focusOffset
  };
}

function fixSelectionInZeroWidthBlock(window) {
  var domSelection = window.getSelection();
  var anchorNode = domSelection.anchorNode;

  if (anchorNode == null) return;
  var dataset = anchorNode.parentElement.dataset;

  var isZeroWidth = dataset ? dataset.slateZeroWidth === 'n' : false;

  if (isZeroWidth && anchorNode.textContent.length === 1 && domSelection.anchorOffset !== 0) {
    var range = window.document.createRange();
    range.setStart(anchorNode, 0);
    range.setEnd(anchorNode, 0);
    domSelection.removeAllRanges();
    domSelection.addRange(range);
  }
}

/**
 * Android Plugin
 *
 * @param {Editor} options.editor
 */

function AndroidPlugin(_ref) {
  var editor = _ref.editor;

  var observer = new CompositionManager(editor);

  /**
   * handle `onCompositionStart`
   */

  function onCompositionStart(event, e, next) {
    observer.onCompositionStart();
    return next();
  }

  /**
   * handle `onCompositionEnd`
   */

  function onCompositionEnd(event, e, next) {
    observer.onCompositionEnd();
    return next();
  }

  /**
   * handle `onSelect`
   *
   * @param {Event} event
   */

  function onSelect(event, e, next) {
    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    fixSelectionInZeroWidthBlock(window);
    observer.onSelect(event);
    return next();
  }

  /**
   * handle `onComponentDidMount`
   */

  function onComponentDidMount(event, e, next) {
    observer.connect();
    return next();
  }

  /**
   * handle `onComponentDidUpdate`
   */

  function onComponentDidUpdate(event, e, next) {
    observer.connect();
    return next();
  }

  /**
   * handle `onComponentWillUnmount`
   *
   * @param {Event} event
   */

  function onComponentWillUnmount(event, e, next) {
    observer.disconnect();
    return next();
  }

  /**
   * handle `onRender`
   *
   * @param {Event} event
   */

  function onRender(event, e, next) {
    observer.disconnect();

    // We don't want the `diff` from a previous render to apply to a
    // potentially different value (e.g. when we switch examples)
    observer.clearDiff();
    return next();
  }

  return {
    onComponentDidMount: onComponentDidMount,
    onComponentDidUpdate: onComponentDidUpdate,
    onComponentWillUnmount: onComponentWillUnmount,
    onCompositionEnd: onCompositionEnd,
    onCompositionStart: onCompositionStart,
    onRender: onRender,
    onSelect: onSelect,
    queries: {
      hasPendingCompositionDiff: function hasPendingCompositionDiff() {
        return observer.hasPendingCompositionDiff();
      }
    }
  };
}

function NoopPlugin() {
  /**
   * Plugin Object
   *
   * @type {Object}
   */

  var plugin = {};

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = EVENT_HANDLERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      plugin[eventName] = function (event, editor, next) {};
    }

    /**
     * Return the plugin.
     *
     * @type {Object}
     */
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return plugin;
}

/**
 * Export.
 *
 * @type {Function}
 */

/**
 * The transfer types that Slate recognizes.
 *
 * @type {Object}
 */

var TRANSFER_TYPES = {
  FRAGMENT: 'application/x-slate-fragment',
  HTML: 'text/html',
  NODE: 'application/x-slate-node',
  RICH: 'text/rtf',
  TEXT: 'text/plain'
};

var FRAGMENT = TRANSFER_TYPES.FRAGMENT;
var HTML = TRANSFER_TYPES.HTML;
var TEXT = TRANSFER_TYPES.TEXT;

/**
 * Prepares a Slate document fragment to be copied to the clipboard.
 *
 * @param {Event} event
 * @param {Editor} editor
 */

function cloneFragment(event, editor) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return undefined;
  };

  Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(!__WEBPACK_IMPORTED_MODULE_6_slate__["n" /* Value */].isValue(editor), 'As of Slate 0.42.0, the `cloneFragment` utility takes an `editor` instead of a `value`.');

  var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
  var native = window.getSelection();
  var value = editor.value;
  var document = value.document,
      fragment = value.fragment,
      selection = value.selection;
  var start = selection.start,
      end = selection.end;

  var startVoid = document.getClosestVoid(start.path, editor);
  var endVoid = document.getClosestVoid(end.path, editor);

  // If the selection is collapsed, and it isn't inside a void node, abort.
  if (native.isCollapsed && !startVoid) return;

  // Create a fake selection so that we can add a Base64-encoded copy of the
  // fragment to the HTML, to decode on future pastes.
  var encoded = __WEBPACK_IMPORTED_MODULE_15_slate_base64_serializer__["a" /* default */].serializeNode(fragment);
  var range = native.getRangeAt(0);
  var contents = range.cloneContents();
  var attach = contents.childNodes[0];

  // Make sure attach is a non-empty node, since empty nodes will not get copied
  contents.childNodes.forEach(function (node) {
    if (node.textContent && node.textContent.trim() !== '') {
      attach = node;
    }
  });

  // COMPAT: If the end node is a void node, we need to move the end of the
  // range from the void node's spacer span, to the end of the void node's
  // content, since the spacer is before void's content in the DOM.
  if (endVoid) {
    var r = range.cloneRange();
    var path = document.getPath(endVoid.key);

    if (path) {
      var node = editor.findDOMNode(path);
      r.setEndAfter(node);
      contents = r.cloneContents();
    }
  }

  // COMPAT: If the start node is a void node, we need to attach the encoded
  // fragment to the void node's content node instead of the spacer, because
  // attaching it to empty `<div>/<span>` nodes will end up having it erased by
  // most browsers. (2018/04/27)
  if (startVoid) {
    attach = contents.childNodes[0].childNodes[1].firstChild;
  }

  // Remove any zero-width space spans from the cloned DOM so that they don't
  // show up elsewhere when pasted.
  [].slice.call(contents.querySelectorAll(SELECTORS.ZERO_WIDTH)).forEach(function (zw) {
    var isNewline = zw.getAttribute(DATA_ATTRS.ZERO_WIDTH) === 'n';
    zw.textContent = isNewline ? '\n' : '';
  });

  // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
  // in the HTML, and can be used for intra-Slate pasting. If it's a text
  // node, wrap it in a `<span>` so we have something to set an attribute on.
  if (attach.nodeType === 3) {
    var span = window.document.createElement('span');

    // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
    // then leading and trailing spaces will be ignored. (2017/09/21)
    span.style.whiteSpace = 'pre';

    span.appendChild(attach);
    contents.appendChild(span);
    attach = span;
  }

  attach.setAttribute(DATA_ATTRS.FRAGMENT, encoded);

  //  Creates value from only the selected blocks
  //  Then gets plaintext for clipboard with proper linebreaks for BLOCK elements
  //  Via Plain serializer
  var valFromSelection = __WEBPACK_IMPORTED_MODULE_6_slate__["n" /* Value */].create({ document: fragment });
  var plainText = __WEBPACK_IMPORTED_MODULE_16_slate_plain_serializer__["a" /* default */].serialize(valFromSelection);

  // Add the phony content to a div element. This is needed to copy the
  // contents into the html clipboard register.
  var div = window.document.createElement('div');
  div.appendChild(contents);

  // For browsers supporting it, we set the clipboard registers manually,
  // since the result is more predictable.
  // COMPAT: IE supports the setData method, but only in restricted sense.
  // IE doesn't support arbitrary MIME types or common ones like 'text/plain';
  // it only accepts "Text" (which gets mapped to 'text/plain') and "Url"
  // (mapped to 'text/url-list'); so, we should only enter block if !IS_IE
  if (event.clipboardData && event.clipboardData.setData && !__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["e" /* IS_IE */]) {
    event.preventDefault();
    event.clipboardData.setData(TEXT, plainText);
    event.clipboardData.setData(FRAGMENT, encoded);
    event.clipboardData.setData(HTML, div.innerHTML);
    callback();
    return;
  }

  // COMPAT: For browser that don't support the Clipboard API's setData method,
  // we must rely on the browser to natively copy what's selected.
  // So we add the div (containing our content) to the DOM, and select it.
  var editorEl = event.target.closest(SELECTORS.EDITOR);
  div.setAttribute('contenteditable', true);
  div.style.position = 'absolute';
  div.style.left = '-9999px';
  editorEl.appendChild(div);
  native.selectAllChildren(div);

  // Revert to the previous selection right after copying.
  window.requestAnimationFrame(function () {
    editorEl.removeChild(div);
    removeAllRanges(native);
    native.addRange(range);
    callback();
  });
}

var FRAGMENT$1 = TRANSFER_TYPES.FRAGMENT;
var HTML$1 = TRANSFER_TYPES.HTML;
var NODE = TRANSFER_TYPES.NODE;
var RICH = TRANSFER_TYPES.RICH;
var TEXT$1 = TRANSFER_TYPES.TEXT;

/**
 * Fragment matching regexp for HTML nodes.
 *
 * @type {RegExp}
 */

var FRAGMENT_MATCHER = / data-slate-fragment="([^\s"]+)"/;

/**
 * Get the transfer data from an `event`.
 *
 * @param {Event} event
 * @return {Object}
 */

function getEventTransfer(event) {
  // COMPAT: IE 11 doesn't populate nativeEvent with either
  // dataTransfer or clipboardData. We'll need to use the base event
  // object (2018/14/6)
  if (!__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["e" /* IS_IE */] && event.nativeEvent) {
    event = event.nativeEvent;
  }

  var transfer = event.dataTransfer || event.clipboardData;
  var fragment = getType(transfer, FRAGMENT$1);
  var node = getType(transfer, NODE);
  var html = getType(transfer, HTML$1);
  var rich = getType(transfer, RICH);
  var text = getType(transfer, TEXT$1);
  var files = void 0;

  // If there isn't a fragment, but there is HTML, check to see if the HTML is
  // actually an encoded fragment.
  if (!fragment && html && ~html.indexOf(' ' + DATA_ATTRS.FRAGMENT + '="')) {
    var matches = FRAGMENT_MATCHER.exec(html);

    var _matches = slicedToArray(matches, 2),
        full = _matches[0],
        encoded = _matches[1]; // eslint-disable-line no-unused-vars


    if (encoded) fragment = encoded;
  }

  // COMPAT: Edge doesn't handle custom data types
  // These will be embedded in text/plain in this case (2017/7/12)
  if (text) {
    var embeddedTypes = getEmbeddedTypes(text);

    if (embeddedTypes[FRAGMENT$1]) fragment = embeddedTypes[FRAGMENT$1];
    if (embeddedTypes[NODE]) node = embeddedTypes[NODE];
    if (embeddedTypes[TEXT$1]) text = embeddedTypes[TEXT$1];
  }

  // Decode a fragment or node if they exist.
  if (fragment) fragment = __WEBPACK_IMPORTED_MODULE_15_slate_base64_serializer__["a" /* default */].deserializeNode(fragment);
  if (node) node = __WEBPACK_IMPORTED_MODULE_15_slate_base64_serializer__["a" /* default */].deserializeNode(node);

  // COMPAT: Edge sometimes throws 'NotSupportedError'
  // when accessing `transfer.items` (2017/7/12)
  try {
    // Get and normalize files if they exist.
    if (transfer.items && transfer.items.length) {
      files = Array.from(transfer.items).map(function (item) {
        return item.kind === 'file' ? item.getAsFile() : null;
      }).filter(function (exists) {
        return exists;
      });
    } else if (transfer.files && transfer.files.length) {
      files = Array.from(transfer.files);
    }
  } catch (err) {
    if (transfer.files && transfer.files.length) {
      files = Array.from(transfer.files);
    }
  }

  // Determine the type of the data.
  var data = { files: files, fragment: fragment, html: html, node: node, rich: rich, text: text };
  data.type = getTransferType(data);
  return data;
}

/**
 * Takes text input, checks whether contains embedded data
 * and returns object with original text +/- additional data
 *
 * @param {String} text
 * @return {Object}
 */

function getEmbeddedTypes(text) {
  var prefix = 'SLATE-DATA-EMBED::';

  if (text.substring(0, prefix.length) !== prefix) {
    return { TEXT: text };
  }

  // Attempt to parse, if fails then just standard text/plain
  // Otherwise, already had data embedded
  try {
    return JSON.parse(text.substring(prefix.length));
  } catch (err) {
    throw new Error('Unable to parse custom Slate drag event data.');
  }
}

/**
 * Get the type of a transfer from its `data`.
 *
 * @param {Object} data
 * @return {String}
 */

function getTransferType(data) {
  if (data.fragment) return 'fragment';
  if (data.node) return 'node';

  // COMPAT: Microsoft Word adds an image of the selected text to the data.
  // Since files are preferred over HTML or text, this would cause the type to
  // be considered `files`. But it also adds rich text data so we can check
  // for that and properly set the type to `html` or `text`. (2016/11/21)
  if (data.rich && data.html) return 'html';
  if (data.rich && data.text) return 'text';

  if (data.files && data.files.length) return 'files';
  if (data.html) return 'html';
  if (data.text) return 'text';
  return 'unknown';
}

/**
 * Get one of types `TYPES.FRAGMENT`, `TYPES.NODE`, `text/html`, `text/rtf` or
 * `text/plain` from transfers's `data` if possible, otherwise return null.
 *
 * @param {Object} transfer
 * @param {String} type
 * @return {String}
 */

function getType(transfer, type) {
  if (!transfer.types || !transfer.types.length) {
    // COMPAT: In IE 11, there is no `types` field but `getData('Text')`
    // is supported`. (2017/06/23)
    return type === TEXT$1 ? transfer.getData('Text') || null : null;
  }

  // COMPAT: In Edge, transfer.types doesn't respond to `indexOf`. (2017/10/25)
  var types = Array.from(transfer.types);

  return types.indexOf(type) !== -1 ? transfer.getData(type) || null : null;
}

/**
 * Export.
 *
 * @type {Function}
 */

var TEXT$2 = TRANSFER_TYPES.TEXT;

/**
 * Set data with `type` and `content` on an `event`.
 *
 * COMPAT: In Edge, custom types throw errors, so embed all non-standard
 * types in text/plain compound object. (2017/7/12)
 *
 * @param {Event} event
 * @param {String} type
 * @param {String} content
 */

function setEventTransfer(event, type, content) {
  var mime = TRANSFER_TYPES[type.toUpperCase()];

  if (!mime) {
    throw new Error('Cannot set unknown transfer type "' + mime + '".');
  }

  if (event.nativeEvent) {
    event = event.nativeEvent;
  }

  var transfer = event.dataTransfer || event.clipboardData;

  try {
    transfer.setData(mime, content);
    // COMPAT: Safari needs to have the 'text' (and not 'text/plain') value in dataTransfer
    // to display the cursor while dragging internally.
    transfer.setData('text', transfer.getData('text'));
  } catch (err) {
    var prefix = 'SLATE-DATA-EMBED::';
    var text = transfer.getData(TEXT$2);
    var obj = {};

    // If the existing plain text data is prefixed, it's Slate JSON data.
    if (text.substring(0, prefix.length) === prefix) {
      try {
        obj = JSON.parse(text.substring(prefix.length));
      } catch (e) {
        throw new Error('Failed to parse Slate data from `DataTransfer` object.');
      }
    } else {
      // Otherwise, it's just set it as is.
      obj[TEXT$2] = text;
    }

    obj[mime] = content;
    var string = '' + prefix + JSON.stringify(obj);
    transfer.setData(TEXT$2, string);
  }
}

/**
 * Export.
 *
 * @type {Function}
 */

var debug$4 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:after');

/**
 * A plugin that adds the "after" browser-specific logic to the editor.
 *
 * @param {Object} options
 * @return {Object}
 */

function AfterPlugin() {
  var isDraggingInternally = null;
  var isMouseDown = false;
  var isComposing = false;

  /**
   * On before input.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onBeforeInput(event, editor, next) {
    var value = editor.value;

    var isSynthetic = !!event.nativeEvent;

    // If the event is synthetic, it's React's polyfill of `beforeinput` that
    // isn't a true `beforeinput` event with meaningful information. It only
    // gets triggered for character insertions, so we can just insert directly.
    if (isSynthetic) {
      event.preventDefault();
      editor.insertText(event.data);
      return next();
    }

    // Otherwise, we can use the information in the `beforeinput` event to
    // figure out the exact change that will occur, and prevent it.

    var _event$getTargetRange = event.getTargetRanges(),
        _event$getTargetRange2 = slicedToArray(_event$getTargetRange, 1),
        targetRange = _event$getTargetRange2[0];

    if (!targetRange) return next();

    debug$4('onBeforeInput', { event: event });

    event.preventDefault();

    var document = value.document,
        selection = value.selection;

    var range = editor.findRange(targetRange);

    switch (event.inputType) {
      case 'deleteByDrag':
      case 'deleteByCut':
      case 'deleteContent':
      case 'deleteContentBackward':
      case 'deleteContentForward':
        {
          editor.deleteAtRange(range);
          break;
        }

      case 'deleteWordBackward':
        {
          editor.deleteWordBackwardAtRange(range);
          break;
        }

      case 'deleteWordForward':
        {
          editor.deleteWordForwardAtRange(range);
          break;
        }

      case 'deleteSoftLineBackward':
      case 'deleteHardLineBackward':
        {
          editor.deleteLineBackwardAtRange(range);
          break;
        }

      case 'deleteSoftLineForward':
      case 'deleteHardLineForward':
        {
          editor.deleteLineForwardAtRange(range);
          break;
        }

      case 'insertLineBreak':
      case 'insertParagraph':
        {
          var hasVoidParent = document.hasVoidParent(selection.start.path, editor);

          if (hasVoidParent) {
            editor.moveToStartOfNextText();
          } else {
            editor.splitBlockAtRange(range);
          }

          break;
        }

      case 'insertFromYank':
      case 'insertReplacementText':
      case 'insertText':
        {
          // COMPAT: `data` should have the text for the `insertText` input type
          // and `dataTransfer` should have the text for the
          // `insertReplacementText` input type, but Safari uses `insertText` for
          // spell check replacements and sets `data` to `null`. (2018/08/09)
          var text = event.data == null ? event.dataTransfer.getData('text/plain') : event.data;

          if (text == null) break;

          editor.insertTextAtRange(range, text, selection.marks);

          // If the text was successfully inserted, and the selection had marks
          // on it, unset the selection's marks.
          if (selection.marks && value.document !== editor.value.document) {
            editor.select({ marks: null });
          }

          break;
        }
    }

    next();
  }

  /**
   * On blur.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onBlur(event, editor, next) {
    debug$4('onBlur', { event: event });
    editor.blur();
    next();
  }

  /**
   * On click.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onClick(event, editor, next) {
    if (editor.readOnly) return next();

    var value = editor.value;
    var document = value.document;

    var path = editor.findPath(event.target);
    if (!path) return next();

    debug$4('onClick', { event: event });

    var node = document.getNode(path);
    var ancestors = document.getAncestors(path);
    var isVoid = node && (editor.isVoid(node) || ancestors.some(function (a) {
      return editor.isVoid(a);
    }));

    if (isVoid) {
      // COMPAT: In Chrome & Safari, selections that are at the zero offset of
      // an inline node will be automatically replaced to be at the last offset
      // of a previous inline node, which screws us up, so we always want to set
      // it to the end of the node. (2016/11/29)
      editor.focus().moveToEndOfNode(node);
    }

    next();
  }

  /**
   * On copy.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCopy(event, editor, next) {
    debug$4('onCopy', { event: event });
    cloneFragment(event, editor);
    next();
  }

  /**
   * On cut.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCut(event, editor, next) {
    debug$4('onCut', { event: event });

    // Once the fake cut content has successfully been added to the clipboard,
    // delete the content in the current selection.
    cloneFragment(event, editor, function () {
      // If user cuts a void block node or a void inline node,
      // manually removes it since selection is collapsed in this case.
      var value = editor.value;
      var document = value.document,
          selection = value.selection;
      var end = selection.end,
          isCollapsed = selection.isCollapsed;

      var voidPath = void 0;

      if (isCollapsed) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = document.ancestors(end.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var node = _ref2[0];
            var path = _ref2[1];

            if (editor.isVoid(node)) {
              voidPath = path;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (voidPath) {
        editor.removeNodeByKey(voidPath);
      } else {
        editor.delete();
      }
    });

    next();
  }

  /**
   * On drag end.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragEnd(event, editor, next) {
    debug$4('onDragEnd', { event: event });
    isDraggingInternally = null;
    next();
  }

  /**
   * On drag start.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragStart(event, editor, next) {
    debug$4('onDragStart', { event: event });

    isDraggingInternally = true;

    var value = editor.value;
    var document = value.document;

    var path = editor.findPath(event.target);
    var node = document.getNode(path);
    var ancestors = document.getAncestors(path);
    var isVoid = node && (editor.isVoid(node) || ancestors.some(function (a) {
      return editor.isVoid(a);
    }));
    var selectionIncludesNode = value.blocks.some(function (block) {
      return block === node;
    });

    // If a void block is dragged and is not selected, select it (necessary for local drags).
    if (isVoid && !selectionIncludesNode) {
      editor.moveToRangeOfNode(node);
    }

    var fragment = editor.value.fragment;
    var encoded = __WEBPACK_IMPORTED_MODULE_15_slate_base64_serializer__["a" /* default */].serializeNode(fragment);
    setEventTransfer(event, 'fragment', encoded);
    next();
  }

  /**
   * On drop.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDrop(event, editor, next) {
    var value = editor.value;
    var document = value.document,
        selection = value.selection;

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    var target = editor.findEventRange(event);

    if (!target) {
      return next();
    }

    debug$4('onDrop', { event: event });

    var transfer = getEventTransfer(event);
    var type = transfer.type,
        fragment = transfer.fragment,
        text = transfer.text;


    editor.focus();

    // COMPAT: React's onSelect event breaks after an onDrop event
    // has fired in a node: https://github.com/facebook/react/issues/11379.
    // Until this is fixed in React, we dispatch a mouseup event on that
    // DOM node, since that will make it go back to normal.
    var el = editor.findDOMNode(target.focus.path);

    if (el) {
      el.dispatchEvent(new MouseEvent('mouseup', {
        view: window,
        bubbles: true,
        cancelable: true
      }));
    }

    var draggedRange = selection;

    editor.select(target);

    if (isDraggingInternally) {
      editor.deleteAtRange(draggedRange);
    }

    if (type === 'text' || type === 'html') {
      var anchor = target.anchor;

      var hasVoidParent = document.hasVoidParent(anchor.path, editor);

      if (hasVoidParent) {
        var p = anchor.path;
        var n = document.getNode(anchor.path);

        while (hasVoidParent) {
          var _document$texts = document.texts({ path: p }),
              _document$texts2 = slicedToArray(_document$texts, 1),
              nxt = _document$texts2[0];

          if (!nxt) {
            break;
          }

          
          var _nxt = slicedToArray(nxt, 2);

          n = _nxt[0];
          p = _nxt[1];

          hasVoidParent = document.hasVoidParent(p, editor);
        }

        if (n) editor.moveToStartOfNode(n);
      }

      if (text) {
        text.split('\n').forEach(function (line, i) {
          if (i > 0) editor.splitBlock();
          editor.insertText(line);
        });
      }
    }

    if (type === 'fragment') {
      editor.insertFragment(fragment);
    }

    next();
  }

  /**
   * On focus.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onFocus(event, editor, next) {
    debug$4('onFocus', { event: event });

    // COMPAT: If the focus event is a mouse-based one, it will be shortly
    // followed by a `selectionchange`, so we need to deselect here to prevent
    // the old selection from being set by the `updateSelection` of `<Content>`,
    // preventing the `selectionchange` from firing. (2018/11/07)
    if (isMouseDown && !__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["e" /* IS_IE */] && !__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["c" /* IS_EDGE */]) {
      editor.deselect().focus();
    } else {
      editor.focus();
    }

    next();
  }

  /**
   * On input.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onInput(event, editor, next) {
    debug$4('onInput');

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    var domSelection = window.getSelection();
    var selection = editor.findSelection(domSelection);

    if (selection) {
      editor.select(selection);
    } else {
      editor.blur();
    }

    var anchorNode = domSelection.anchorNode;

    editor.reconcileDOMNode(anchorNode);

    next();
  }

  /**
   * On key down.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onKeyDown(event, editor, next) {
    debug$4('onKeyDown', { event: event });

    var value = editor.value;
    var document = value.document,
        selection = value.selection;
    var start = selection.start;

    var hasVoidParent = document.hasVoidParent(start.path, editor);

    // COMPAT: In iOS, some of these hotkeys are handled in the
    // `onNativeBeforeInput` handler of the `<Content>` component in order to
    // preserve native autocorrect behavior, so they shouldn't be handled here.
    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isSplitBlock(event) && !__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["f" /* IS_IOS */]) {
      return hasVoidParent ? editor.moveToStartOfNextText() : editor.splitBlock();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteBackward(event) && !__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["f" /* IS_IOS */]) {
      return editor.deleteCharBackward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteForward(event) && !__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["f" /* IS_IOS */]) {
      return editor.deleteCharForward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteLineBackward(event)) {
      return editor.deleteLineBackward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteLineForward(event)) {
      return editor.deleteLineForward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteWordBackward(event)) {
      return editor.deleteWordBackward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteWordForward(event)) {
      return editor.deleteWordForward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isRedo(event)) {
      return editor.redo();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isUndo(event)) {
      return editor.undo();
    }

    // COMPAT: Certain browsers don't handle the selection updates properly. In
    // Chrome, the selection isn't properly extended. And in Firefox, the
    // selection isn't properly collapsed. (2017/10/17)
    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isMoveLineBackward(event)) {
      event.preventDefault();
      return editor.moveToStartOfBlock();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isMoveLineForward(event)) {
      event.preventDefault();
      return editor.moveToEndOfBlock();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isExtendLineBackward(event)) {
      event.preventDefault();
      return editor.moveFocusToStartOfBlock();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isExtendLineForward(event)) {
      event.preventDefault();
      return editor.moveFocusToEndOfBlock();
    }

    // COMPAT: If a void node is selected, or a zero-width text node adjacent to
    // an inline is selected, we need to handle these hotkeys manually because
    // browsers won't know what to do.
    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isMoveBackward(event)) {
      event.preventDefault();

      if (!selection.isCollapsed) {
        return editor.moveToStart();
      }

      return editor.moveBackward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isMoveForward(event)) {
      event.preventDefault();

      if (!selection.isCollapsed) {
        return editor.moveToEnd();
      }

      return editor.moveForward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isMoveWordBackward(event)) {
      event.preventDefault();
      return editor.moveWordBackward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isMoveWordForward(event)) {
      event.preventDefault();
      return editor.moveWordForward();
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isExtendBackward(event)) {
      var startText = document.getNode(start.path);

      var _document$texts3 = document.texts({
        path: start.path,
        direction: 'backward'
      }),
          _document$texts4 = slicedToArray(_document$texts3, 1),
          prevEntry = _document$texts4[0];

      var isPrevInVoid = false;

      if (prevEntry) {
        var _prevEntry = slicedToArray(prevEntry, 2),
            prevPath = _prevEntry[1];

        isPrevInVoid = document.hasVoidParent(prevPath, editor);
      }

      if (hasVoidParent || isPrevInVoid || startText.text === '') {
        event.preventDefault();
        return editor.moveFocusBackward();
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isExtendForward(event)) {
      var _startText = document.getNode(start.path);

      var _document$texts5 = document.texts({ path: start.path }),
          _document$texts6 = slicedToArray(_document$texts5, 1),
          nextEntry = _document$texts6[0];

      var isNextInVoid = false;

      if (nextEntry) {
        var _nextEntry = slicedToArray(nextEntry, 2),
            nextPath = _nextEntry[1];

        isNextInVoid = document.hasVoidParent(nextPath, editor);
      }

      if (hasVoidParent || isNextInVoid || _startText.text === '') {
        event.preventDefault();
        return editor.moveFocusForward();
      }
    }

    next();
  }

  /**
   * On mouse down.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onMouseDown(event, editor, next) {
    debug$4('onMouseDown', { event: event });
    isMouseDown = true;
    next();
  }

  /**
   * On mouse up.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onMouseUp(event, editor, next) {
    debug$4('onMouseUp', { event: event });
    isMouseDown = false;
    next();
  }

  /**
   * On paste.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onPaste(event, editor, next) {
    debug$4('onPaste', { event: event });

    var value = editor.value;

    var transfer = getEventTransfer(event);
    var type = transfer.type,
        fragment = transfer.fragment,
        text = transfer.text;


    if (type === 'fragment') {
      editor.insertFragment(fragment);
    }

    if (type === 'text' || type === 'html') {
      if (!text) return next();
      var document = value.document,
          selection = value.selection,
          startBlock = value.startBlock;

      if (editor.isVoid(startBlock)) return next();

      var defaultBlock = startBlock;
      var defaultMarks = document.getInsertMarksAtRange(selection);
      var frag = __WEBPACK_IMPORTED_MODULE_16_slate_plain_serializer__["a" /* default */].deserialize(text, { defaultBlock: defaultBlock, defaultMarks: defaultMarks }).document;
      editor.insertFragment(frag);
    }

    next();
  }

  /**
   * On select.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onSelect(event, editor, next) {
    debug$4('onSelect', { event: event });
    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    var domSelection = window.getSelection();
    var selection = editor.findSelection(domSelection);

    if (selection) {
      editor.select(selection);
    } else {
      editor.blur();
    }

    // COMPAT: reset the `isMouseDown` state here in case a `mouseup` event
    // happens outside the editor. This is needed for `onFocus` handling.
    isMouseDown = false;

    next();
  }

  /**
   * On composition start.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCompositionStart(event, editor, next) {
    debug$4('onCompositionStart', { event: event });
    isComposing = true;

    next();
  }

  /**
   * On composition start.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCompositionEnd(event, editor, next) {
    debug$4('onCompositionEnd', { event: event });
    isComposing = false;

    next();
  }

  /**
   * Return the plugin.
   *
   * @type {Object}
   */

  return {
    onBeforeInput: onBeforeInput,
    onBlur: onBlur,
    onClick: onClick,
    onCopy: onCopy,
    onCut: onCut,
    onDragEnd: onDragEnd,
    onDragStart: onDragStart,
    onDrop: onDrop,
    onFocus: onFocus,
    onInput: onInput,
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onPaste: onPaste,
    onSelect: onSelect,
    onCompositionStart: onCompositionStart,
    onCompositionEnd: onCompositionEnd,
    queries: {
      hasPendingCompositionDiff: function hasPendingCompositionDiff() {
        return isComposing;
      }
    }
  };
}

/**
 * Export.
 *
 * @type {Function}
 */

var debug$5 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:before');

/**
 * A plugin that adds the "before" browser-specific logic to the editor.
 *
 * @return {Object}
 */

function BeforePlugin() {
  var activeElement = null;
  var compositionCount = 0;
  var isComposing = false;
  var isCopying = false;
  var isDragging = false;
  var isUserActionPerformed = false;

  /**
   * On before input.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onBeforeInput(event, editor, next) {
    var isSynthetic = !!event.nativeEvent;
    if (editor.readOnly) return;
    isUserActionPerformed = true;

    // COMPAT: If the browser supports Input Events Level 2, we will have
    // attached a custom handler for the real `beforeinput` events, instead of
    // allowing React's synthetic polyfill, so we need to ignore synthetics.
    if (isSynthetic && __WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["a" /* HAS_INPUT_EVENTS_LEVEL_2 */]) return;

    debug$5('onBeforeInput', { event: event });
    next();
  }

  /**
   * On blur.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onBlur(event, editor, next) {
    if (isCopying) return;
    if (editor.readOnly) return;

    var relatedTarget = event.relatedTarget,
        target = event.target;

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(target);

    // COMPAT: If the current `activeElement` is still the previous one, this is
    // due to the window being blurred when the tab itself becomes unfocused, so
    // we want to abort early to allow to editor to stay focused when the tab
    // becomes focused again.
    if (activeElement === window.document.activeElement) return;

    // COMPAT: The `relatedTarget` can be null when the new focus target is not
    // a "focusable" element (eg. a `<div>` without `tabindex` set).
    if (relatedTarget) {
      var el = editor.findDOMNode([]);

      // COMPAT: The event should be ignored if the focus is returning to the
      // editor from an embedded editable element (eg. an <input> element inside
      // a void node).
      if (relatedTarget === el) return;

      // COMPAT: The event should be ignored if the focus is moving from the
      // editor to inside a void node's spacer element.
      if (relatedTarget.hasAttribute(DATA_ATTRS.SPACER)) return;

      // COMPAT: The event should be ignored if the focus is moving to a non-
      // editable section of an element that isn't a void node (eg. a list item
      // of the check list example).
      var node = editor.findNode(relatedTarget);

      if (el.contains(relatedTarget) && node && !editor.isVoid(node)) {
        return;
      }
    }

    debug$5('onBlur', { event: event });
    next();
  }

  /**
   * On composition end.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCompositionEnd(event, editor, next) {
    var n = compositionCount;
    isUserActionPerformed = true;

    // The `count` check here ensures that if another composition starts
    // before the timeout has closed out this one, we will abort unsetting the
    // `isComposing` flag, since a composition is still in affect.
    window.requestAnimationFrame(function () {
      if (compositionCount > n) return;
      isComposing = false;
    });

    debug$5('onCompositionEnd', { event: event });
    next();
  }

  /**
   * On click.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onClick(event, editor, next) {
    debug$5('onClick', { event: event });
    isUserActionPerformed = true;
    next();
  }

  /**
   * On composition start.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCompositionStart(event, editor, next) {
    isComposing = true;
    compositionCount++;

    var value = editor.value;
    var selection = value.selection;

    isUserActionPerformed = true;

    if (!selection.isCollapsed) {
      // https://github.com/ianstormtaylor/slate/issues/1879
      // When composition starts and the current selection is not collapsed, the
      // second composition key-down would drop the text wrapping <spans> which
      // resulted on crash in content.updateSelection after composition ends
      // (because it cannot find <span> nodes in DOM). This is a workaround that
      // erases selection as soon as composition starts and preventing <spans>
      // to be dropped.
      editor.delete();
    }

    debug$5('onCompositionStart', { event: event });
    next();
  }

  /**
   * On copy.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCopy(event, editor, next) {
    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    isCopying = true;
    window.requestAnimationFrame(function () {
      return isCopying = false;
    });

    debug$5('onCopy', { event: event });
    next();
  }

  /**
   * On cut.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onCut(event, editor, next) {
    if (editor.readOnly) return;

    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    isCopying = true;
    window.requestAnimationFrame(function () {
      return isCopying = false;
    });

    debug$5('onCut', { event: event });
    next();
  }

  /**
   * On drag end.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragEnd(event, editor, next) {
    isDragging = false;
    debug$5('onDragEnd', { event: event });
    next();
  }

  /**
   * On drag enter.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragEnter(event, editor, next) {
    debug$5('onDragEnter', { event: event });
    next();
  }

  /**
   * On drag exit.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragExit(event, editor, next) {
    debug$5('onDragExit', { event: event });
    next();
  }

  /**
   * On drag leave.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragLeave(event, editor, next) {
    debug$5('onDragLeave', { event: event });
    next();
  }

  /**
   * On drag over.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragOver(event, editor, next) {
    // If the target is inside a void node, and only in this case,
    // call `preventDefault` to signal that drops are allowed.
    // When the target is editable, dropping is already allowed by
    // default, and calling `preventDefault` hides the cursor.
    var node = editor.findNode(event.target);

    if (!node || editor.isVoid(node)) {
      event.preventDefault();
    }

    // COMPAT: IE won't call onDrop on contentEditables unless the
    // default dragOver is prevented:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/913982/
    // (2018/07/11)
    if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["e" /* IS_IE */]) {
      event.preventDefault();
    }

    // If a drag is already in progress, don't do this again.
    if (!isDragging) {
      isDragging = true;

      // COMPAT: IE will raise an `unspecified error` if dropEffect is
      // set. (2018/07/11)
      if (!__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["e" /* IS_IE */]) {
        event.nativeEvent.dataTransfer.dropEffect = 'move';
      }
    }

    debug$5('onDragOver', { event: event });
    next();
  }

  /**
   * On drag start.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDragStart(event, editor, next) {
    isDragging = true;
    debug$5('onDragStart', { event: event });
    next();
  }

  /**
   * On drop.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onDrop(event, editor, next) {
    if (editor.readOnly) return;
    isUserActionPerformed = true;

    // Prevent default so the DOM's value isn't corrupted.
    event.preventDefault();

    debug$5('onDrop', { event: event });
    next();
  }

  /**
   * On focus.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onFocus(event, editor, next) {
    if (isCopying) return;
    if (editor.readOnly) return;

    var el = editor.findDOMNode([]);

    // Save the new `activeElement`.
    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    activeElement = window.document.activeElement;

    // COMPAT: If the editor has nested editable elements, the focus can go to
    // those elements. In Firefox, this must be prevented because it results in
    // issues with keyboard navigation. (2017/03/30)
    if (__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["d" /* IS_FIREFOX */] && event.target !== el) {
      el.focus();
      return;
    }

    debug$5('onFocus', { event: event });
    next();
  }

  /**
   * On input.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onInput(event, editor, next) {
    if (isComposing) return;
    if (editor.value.selection.isBlurred) return;
    isUserActionPerformed = true;
    debug$5('onInput', { event: event });
    next();
  }

  /**
   * On key down.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onKeyDown(event, editor, next) {
    if (editor.readOnly) return;

    // When composing, we need to prevent all hotkeys from executing while
    // typing. However, certain characters also move the selection before
    // we're able to handle it, so prevent their default behavior.
    if (isComposing) {
      if (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isCompose(event)) event.preventDefault();
      return;
    }

    // Certain hotkeys have native editing behaviors in `contenteditable`
    // elements which will editor the DOM and cause our value to be out of sync,
    // so they need to always be prevented.
    if (!__WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["f" /* IS_IOS */] && (__WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isBold(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteBackward(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteForward(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteLineBackward(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteLineForward(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteWordBackward(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isDeleteWordForward(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isItalic(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isRedo(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isSplitBlock(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isTransposeCharacter(event) || __WEBPACK_IMPORTED_MODULE_13_slate_hotkeys__["a" /* default */].isUndo(event))) {
      event.preventDefault();
    }

    isUserActionPerformed = true;
    debug$5('onKeyDown', { event: event });
    next();
  }

  /**
   * On paste.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onPaste(event, editor, next) {
    if (editor.readOnly) return;
    isUserActionPerformed = true;

    // Prevent defaults so the DOM state isn't corrupted.
    event.preventDefault();

    debug$5('onPaste', { event: event });
    next();
  }

  /**
   * On select.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {Function} next
   */

  function onSelect(event, editor, next) {
    if (isCopying) return;
    if (isComposing) return;

    if (editor.readOnly) return;

    // Save the new `activeElement`.
    var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(event.target);
    activeElement = window.document.activeElement;
    isUserActionPerformed = true;

    debug$5('onSelect', { event: event });
    next();
  }

  function userActionPerformed() {
    return isUserActionPerformed;
  }

  function clearUserActionPerformed() {
    isUserActionPerformed = false;
    return null;
  }

  /**
   * Return the plugin.
   *
   * @type {Object}
   */

  return {
    onBeforeInput: onBeforeInput,
    onBlur: onBlur,
    onClick: onClick,
    onCompositionEnd: onCompositionEnd,
    onCompositionStart: onCompositionStart,
    onCopy: onCopy,
    onCut: onCut,
    onDragEnd: onDragEnd,
    onDragEnter: onDragEnter,
    onDragExit: onDragExit,
    onDragLeave: onDragLeave,
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop,
    onFocus: onFocus,
    onInput: onInput,
    onKeyDown: onKeyDown,
    onPaste: onPaste,
    onSelect: onSelect,
    queries: { userActionPerformed: userActionPerformed },
    commands: { clearUserActionPerformed: clearUserActionPerformed }
  };
}

/**
 * Export.
 *
 * @type {Function}
 */

function DOMPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$plugins = options.plugins,
      plugins = _options$plugins === undefined ? [] : _options$plugins;

  var beforePlugin = BeforePlugin();
  var afterPlugin = AfterPlugin();

  // Activate NoopPlugin only for debugging purposes
  var noopPluginActivated = false;

  // COMPAT: Add Android specific handling separately before it gets to the
  // other plugins because it is specific (other browser don't need it) and
  // finicky (it has to come before other plugins to work).
  var androidPlugins = __WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["b" /* IS_ANDROID */] ? [AndroidPlugin(options), noopPluginActivated ? NoopPlugin(options) : undefined] : [];

  return [].concat(androidPlugins, [beforePlugin], toConsumableArray(plugins), [afterPlugin]);
}

/**
 * Export.
 *
 * @type {Function}
 */

function RestoreDOMPlugin() {
  /**
   * Makes sure that on the next Content `render` the DOM is restored.
   * This gets us around issues where the DOM is in a different state than
   * React's virtual DOM and would crash.
   *
   * @param {Editor} editor
   */

  function restoreDOM(editor) {
    var tmp = editor.tmp.contentRef.current.tmp;
    tmp.contentKey = tmp.contentKey + 1;
  }

  return {
    commands: {
      restoreDOM: restoreDOM
    }
  };
}

/**
 * Takes a React Synthetic Event or a DOM Event and turns it into a String that
 * is easy to log. It's succinct and keeps info to a bare minimum.
 *
 * @param {Event} event
 */

function stringifyEvent(event) {
  var e = event.nativeEvent || event;

  switch (e.type) {
    case 'keydown':
      return e.type + ' ' + JSON.stringify(e.key);
    case 'input':
    case 'beforeinput':
    case 'textInput':
      return e.type + ':' + e.inputType + ' ' + JSON.stringify(e.data);
    default:
      return e.type;
  }
}

var debug$6 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:events');

/**
 * A plugin that sends short easy to digest debug info about each event to
 * browser.
 *
 * @return {Object}
 */

function DebugEventsPlugin() {
  /**
   * Plugin Object
   *
   * @type {Object}
   */

  var plugin = {};

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = EVENT_HANDLERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      plugin[eventName] = function (event, editor, next) {
        var s = stringifyEvent(event);
        debug$6(s);
        next();
      };
    }

    /**
     * Return the plugin.
     *
     * @type {Object}
     */
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return plugin;
}

/**
 * Export.
 *
 * @type {Function}
 */

var INTERVAL = 2000;

/**
 * Debug events function.
 *
 * @type {Function}
 */

var debug$7 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:batch-events');

/**
 * A plugin that sends short easy to digest debug info about each event to
 * browser.
 *
 * @return {Object}
 */

function DebugBatchEventsPlugin() {
  /**
   * When the batch started
   *
   * @type {Date}
   */

  var startDate = null;

  /**
   * The timeoutId used to cancel the timeout
   *
   * @type {Any}
   */

  var timeoutId = null;

  /**
   * An array of events not yet dumped with `debug`
   *
   * @type {Array}
   */

  var events = [];

  /**
   * Send all events to debug
   *
   * Note: Formatted so it can easily be cut and pasted as text for analysis or
   * documentation.
   */

  function dumpEvents() {
    debug$7('\n' + events.join('\n'));
    events.length = 0;
  }

  /**
   * Push an event on to the Array of events for debugging in a batch
   *
   * @param {Event} event
   */

  function pushEvent(event) {
    if (events.length === 0) {
      startDate = new Date();
    }

    var s = stringifyEvent(event);
    var now = new Date();
    events.push('- ' + (now - startDate) + ' - ' + s);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(dumpEvents, INTERVAL);
  }

  /**
   * Plugin Object
   *
   * @type {Object}
   */

  var plugin = {};

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = EVENT_HANDLERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      plugin[eventName] = function (event, editor, next) {
        pushEvent(event);
        next();
      };
    }

    /**
     * Return the plugin.
     *
     * @type {Object}
     */
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return plugin;
}

/**
 * Export.
 *
 * @type {Function}
 */

var debug$8 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:mutations');

/**
 * Properties on a MutationRecord
 *
 * @type {Object}
 */

var MUTATION_PROPERTIES = ['type', 'oldValue', 'target', 'addedNodes', 'removedNodes', 'attributeName', 'attributeNamespace', 'nextSibling', 'previousSibling'];

/**
 * Takes a DOM node and returns an easily readable version of it.
 *
 * @param {DOMNode} node
 */

function normalizeNode(node) {
  if (node.nodeType === window.Node.TEXT_NODE) {
    return node.textContent;
  } else if (node.nodeType === window.Node.ELEMENT_NODE) {
    var outerHTML = node.outerHTML,
        innerHTML = node.innerHTML;

    if (outerHTML == null) return JSON.stringify(node.textContent);
    return outerHTML.slice(0, outerHTML.indexOf(innerHTML));
  } else {
    return 'Node(type=' + node.nodeType;
  }
}

/**
 * A plugin that sends short easy to digest debug info about each dom mutation
 * to browser.
 *
 * More information about mutations here:
 *
 * <https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver>
 * <https://developer.mozilla.org/en-US/docs/Web/API/MutationRecord>
 *
 * @param {Object} options
 */

function DebugMutationsPlugin() {
  var observer = new window.MutationObserver(function (mutations) {
    var array = Array.from(mutations).map(function (mutationRecord) {
      var object = {};

      // Only add properties that provide meaningful values to the object
      // to make the debug info easier to read
      MUTATION_PROPERTIES.forEach(function (key) {
        var value = mutationRecord[key];
        if (value == null) return;

        // Make NodeList easier to read
        if (value instanceof window.NodeList) {
          if (value.length === 0) return;

          object[key] = Array.from(value).map(normalizeNode).join(', ');
          return;
        }

        // Make Node easier to read
        if (value instanceof window.Node) {
          value = normalizeNode(value);
        }

        object[key] = value;
      });

      return object;
    });

    // The first argument must not be the array as `debug` renders the first
    // argument in a different way than the rest
    debug$8.apply(undefined, [array.length + ' Mutations'].concat(toConsumableArray(array)));
  });

  /**
   * The previously observed DOM node
   *
   * @type {DOMNode}
   */

  var prevRootEl = null;

  /**
   * Start observing the DOM node for mutations if it isn't being observed
   */

  function start(event, editor, next) {
    var rootEl = editor.findDOMNode([]);

    if (rootEl === prevRootEl) return next();

    debug$8('start');

    observer.observe(rootEl, {
      childList: true,
      characterData: true,
      attributes: true,
      subtree: true,
      characterDataOldValue: true
    });

    prevRootEl = rootEl;

    next();
  }

  /**
   * Stop observing the DOM node for mutations
   */

  function stop(event, editor, next) {
    debug$8('stop');

    observer.disconnect();
    prevRootEl = null;
    next();
  }

  return {
    onComponentDidMount: start,
    onComponentDidUpdate: start,
    onComponentWillUnmount: stop
  };
}

function ReactPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$placeholder = options.placeholder,
      placeholder = _options$placeholder === undefined ? '' : _options$placeholder;

  var debugEventsPlugin = __WEBPACK_IMPORTED_MODULE_4_debug___default.a.enabled('slate:events') ? DebugEventsPlugin(options) : null;
  var debugBatchEventsPlugin = __WEBPACK_IMPORTED_MODULE_4_debug___default.a.enabled('slate:batch-events') ? DebugBatchEventsPlugin(options) : null;
  var debugMutationsPlugin = __WEBPACK_IMPORTED_MODULE_4_debug___default.a.enabled('slate:mutations') ? DebugMutationsPlugin(options) : null;
  var renderingPlugin = Rendering(options);
  var commandsPlugin = CommandsPlugin(options);
  var queriesPlugin = QueriesPlugin(options);
  var editorPropsPlugin = EditorPropsPlugin(options);
  var domPlugin = DOMPlugin(options);
  var restoreDomPlugin = RestoreDOMPlugin();

  // Disable placeholder for Android because it messes with reconciliation
  // and doesn't disappear until composition is complete.
  // e.g. In empty, type "h" and autocomplete on Android 9 and deletes all text.
  var placeholderPlugin = __WEBPACK_IMPORTED_MODULE_9_slate_dev_environment__["b" /* IS_ANDROID */] ? null : Object(__WEBPACK_IMPORTED_MODULE_18_slate_react_placeholder__["a" /* default */])({
    placeholder: placeholder,
    when: function when(editor, node) {
      return node.object === 'document' && node.text === '' && node.nodes.size === 1 && Array.from(node.texts()).length === 1;
    }
  });

  return [debugEventsPlugin, debugBatchEventsPlugin, debugMutationsPlugin, editorPropsPlugin, domPlugin, restoreDomPlugin, placeholderPlugin, renderingPlugin, commandsPlugin, queriesPlugin];
}

/**
 * Export.
 *
 * @type {Function}
 */

var debug$9 = __WEBPACK_IMPORTED_MODULE_4_debug___default()('slate:editor');

/**
 * Editor.
 *
 * @type {Component}
 */

var Editor$1 = function (_React$Component) {
  inherits(Editor$$1, _React$Component);

  function Editor$$1() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Editor$$1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Editor$$1.__proto__ || Object.getPrototypeOf(Editor$$1)).call.apply(_ref, [this].concat(args))), _this), _this.state = { value: _this.props.defaultValue, contentKey: 0

      /**
       * Temporary values.
       *
       * @type {Object}
       */

    }, _this.tmp = {
      mounted: false,
      change: null,
      resolves: 0,
      updates: 0,
      contentRef: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef()

      /**
       * When the component first mounts, flush a queued change if one exists.
       */

    }, _this.resolveController = Object(__WEBPACK_IMPORTED_MODULE_19_memoize_one__["a" /* default */])(function () {
      var TheReactPlugin = arguments[5];

      // If we've resolved a few times already, and it's exactly in line with
      // the updates, then warn the user that they may be doing something wrong.
      Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(_this.tmp.resolves < 5 || _this.tmp.resolves !== _this.tmp.updates, 'A Slate <Editor> component is re-resolving the `plugins`, `schema`, `commands`, `queries` or `placeholder` prop on each update, which leads to poor performance. This is often due to passing in a new references for these props with each render by declaring them inline in your render function. Do not do this! Declare them outside your render function, or memoize them instead.');

      _this.tmp.resolves++;
      var react = TheReactPlugin(_extends({}, _this.props, {
        editor: _this,
        value: _this.props.value || _this.state.value
      }));

      var onChange = function onChange(change) {
        if (_this.tmp.mounted) {
          _this.handleChange(change);
        } else {
          _this.tmp.change = change;
        }
      };

      _this.controller = new __WEBPACK_IMPORTED_MODULE_6_slate__["e" /* Editor */]({ plugins: [react], onChange: onChange }, { controller: _this, construct: false });

      _this.controller.run('onConstruct');
    }), _temp), possibleConstructorReturn(_this, _ret);
  }
  /**
   * Property types.
   *
   * @type {Object}
   */

  /**
   * Default properties.
   *
   * @type {Object}
   */

  /**
   * Initial state.
   *
   * @type {Object}
   */

  createClass(Editor$$1, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.tmp.mounted = true;
      this.tmp.updates++;

      if (this.props.autoFocus) {
        this.focus();
      }

      if (this.tmp.change) {
        this.handleChange(this.tmp.change);
        this.tmp.change = null;
      }
    }

    /**
     * When the component updates, flush a queued change if one exists.
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.tmp.updates++;

      if (this.tmp.change) {
        this.handleChange(this.tmp.change);
        this.tmp.change = null;
      }
    }

    /**
     * When the component unmounts, make sure async commands don't trigger react updates.
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.tmp.mounted = false;
    }

    /**
     * Render the editor.
     *
     * @return {Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      debug$9('render', this);

      // Re-resolve the controller if needed based on memoized props.
      var _props = this.props,
          commands = _props.commands,
          placeholder = _props.placeholder,
          plugins = _props.plugins,
          queries = _props.queries,
          schema = _props.schema;


      this.resolveController(plugins, schema, commands, queries, placeholder, ReactPlugin);

      // Set the current props on the controller.
      var _props2 = this.props,
          options = _props2.options,
          readOnly = _props2.readOnly,
          valueFromProps = _props2.value;
      var valueFromState = this.state.value;

      var value = valueFromProps || valueFromState;
      var contentKey = this.state.contentKey;

      this.controller.setReadOnly(readOnly);
      this.controller.setValue(value, options);

      var _props3 = this.props,
          autoCorrect = _props3.autoCorrect,
          className = _props3.className,
          id = _props3.id,
          role = _props3.role,
          spellCheck = _props3.spellCheck,
          tabIndex = _props3.tabIndex,
          style = _props3.style,
          tagName = _props3.tagName;


      var domProps = __WEBPACK_IMPORTED_MODULE_11_lodash_omit___default()(this.props, Object.keys(Editor$$1.propTypes));

      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content, _extends({}, domProps, {
        ref: this.tmp.contentRef,
        autoCorrect: autoCorrect,
        className: className,
        contentKey: contentKey,
        editor: this,
        id: id,
        onEvent: function onEvent(handler, event) {
          return _this2.run(handler, event);
        },
        readOnly: readOnly,
        role: role,
        spellCheck: spellCheck,
        style: style,
        tabIndex: tabIndex,
        tagName: tagName
      }));

      // Render the editor's children with the controller.
      var element = this.controller.run('renderEditor', _extends({}, this.props, {
        editor: this,
        children: children
      }));

      return element;
    }

    /**
     * Resolve an editor controller from the passed-in props. This method takes
     * all of the props as individual arguments to be able to properly memoize
     * against anything that could change and invalidate the old editor.
     *
     * @param {Array} plugins
     * @param {Object} schema
     * @param {Object} commands
     * @param {Object} queries
     * @param {String} placeholder
     * @return {Editor}
     */

  }, {
    key: 'handleChange',
    value: function handleChange(change) {
      var onChange = this.props.onChange;
      var value = this.state.value;


      if (value) {
        // Syncing value inside this component since parent does not want control of it (defaultValue was used)
        this.setState({ value: change.value });
      }

      onChange(change);
    }

    /**
     * Mimic the API of the `Editor` controller, so that this component instance
     * can be passed in its place to plugins.
     */

  }, {
    key: 'applyOperation',
    value: function applyOperation() {
      var _controller;

      return (_controller = this.controller).applyOperation.apply(_controller, arguments);
    }
  }, {
    key: 'command',
    value: function command() {
      var _controller2;

      return (_controller2 = this.controller).command.apply(_controller2, arguments);
    }
  }, {
    key: 'hasCommand',
    value: function hasCommand() {
      var _controller3;

      return (_controller3 = this.controller).hasCommand.apply(_controller3, arguments);
    }
  }, {
    key: 'hasQuery',
    value: function hasQuery() {
      var _controller4;

      return (_controller4 = this.controller).hasQuery.apply(_controller4, arguments);
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      var _controller5;

      return (_controller5 = this.controller).normalize.apply(_controller5, arguments);
    }
  }, {
    key: 'query',
    value: function query() {
      var _controller6;

      return (_controller6 = this.controller).query.apply(_controller6, arguments);
    }
  }, {
    key: 'registerCommand',
    value: function registerCommand() {
      var _controller7;

      return (_controller7 = this.controller).registerCommand.apply(_controller7, arguments);
    }
  }, {
    key: 'registerQuery',
    value: function registerQuery() {
      var _controller8;

      return (_controller8 = this.controller).registerQuery.apply(_controller8, arguments);
    }
  }, {
    key: 'run',
    value: function run() {
      var _controller9;

      return (_controller9 = this.controller).run.apply(_controller9, arguments);
    }
  }, {
    key: 'withoutNormalizing',
    value: function withoutNormalizing() {
      var _controller10;

      return (_controller10 = this.controller).withoutNormalizing.apply(_controller10, arguments);
    }

    /**
     * Deprecated.
     */

  }, {
    key: 'call',
    value: function call() {
      var _controller11;

      return (_controller11 = this.controller).call.apply(_controller11, arguments);
    }
  }, {
    key: 'change',
    value: function change() {
      var _controller12;

      return (_controller12 = this.controller).change.apply(_controller12, arguments);
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      var _controller13;

      return (_controller13 = this.controller).onChange.apply(_controller13, arguments);
    }
  }, {
    key: 'applyOperations',
    value: function applyOperations() {
      var _controller14;

      return (_controller14 = this.controller).applyOperations.apply(_controller14, arguments);
    }
  }, {
    key: 'setOperationFlag',
    value: function setOperationFlag() {
      var _controller15;

      return (_controller15 = this.controller).setOperationFlag.apply(_controller15, arguments);
    }
  }, {
    key: 'getFlag',
    value: function getFlag() {
      var _controller16;

      return (_controller16 = this.controller).getFlag.apply(_controller16, arguments);
    }
  }, {
    key: 'unsetOperationFlag',
    value: function unsetOperationFlag() {
      var _controller17;

      return (_controller17 = this.controller).unsetOperationFlag.apply(_controller17, arguments);
    }
  }, {
    key: 'withoutNormalization',
    value: function withoutNormalization() {
      var _controller18;

      return (_controller18 = this.controller).withoutNormalization.apply(_controller18, arguments);
    }
  }, {
    key: 'operations',
    get: function get$$1() {
      return this.controller.operations;
    }
  }, {
    key: 'readOnly',
    get: function get$$1() {
      return this.controller.readOnly;
    }
  }, {
    key: 'value',
    get: function get$$1() {
      return this.controller.value;
    }
  }, {
    key: 'editor',
    get: function get$$1() {
      return this.controller.editor;
    }
  }, {
    key: 'schema',
    get: function get$$1() {
      Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor.schema` property no longer exists, and its functionality has been folded into the editor itself. Use the `editor` instead.');
    }
  }, {
    key: 'stack',
    get: function get$$1() {
      Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(false, 'As of Slate 0.42, the `editor.stack` property no longer exists, and its functionality has been folded into the editor itself. Use the `editor` instead.');
    }
  }]);
  return Editor$$1;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * Export.
 *
 * @type {Component}
 */

Editor$1.propTypes = _extends({
  autoCorrect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultValue: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].value,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  spellCheck: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_2_slate_prop_types__["a" /* default */].value
}, EVENT_HANDLERS.reduce(function (obj, handler) {
  obj[handler] = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func;
  return obj;
}, {}), OTHER_HANDLERS.reduce(function (obj, handler) {
  obj[handler] = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func;
  return obj;
}, {}));
Editor$1.defaultProps = {
  autoFocus: false,
  autoCorrect: true,
  onChange: function onChange() {},
  options: {},
  placeholder: '',
  plugins: [],
  readOnly: false,
  schema: {},
  spellCheck: true };

function findDOMNode(key) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findDOMNode(key)` helper is deprecated in favor of `editor.findDOMNode(path)`.');

  if (__WEBPACK_IMPORTED_MODULE_6_slate__["i" /* Node */].isNode(key)) {
    key = key.key;
  }

  var el = win.document.querySelector('[' + DATA_ATTRS.KEY + '="' + key + '"]');

  if (!el) {
    throw new Error('Unable to find a DOM node for "' + key + '". This is often because of forgetting to add `props.attributes` to a custom component.');
  }

  return el;
}

/**
 * Export.
 *
 * @type {Function}
 */

function findDOMPoint(point) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findDOMPoint(point)` helper is deprecated in favor of `editor.findDOMPoint(point)`.');

  var el = findDOMNode(point.key, win);
  var start = 0;

  // For each leaf, we need to isolate its content, which means filtering to its
  // direct text and zero-width spans. (We have to filter out any other siblings
  // that may have been rendered alongside them.)
  var texts = Array.from(el.querySelectorAll(SELECTORS.STRING + ', ' + SELECTORS.ZERO_WIDTH));

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = texts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var text = _step.value;

      var node = text.childNodes[0];
      var domLength = node.textContent.length;
      var slateLength = domLength;

      if (text.hasAttribute(DATA_ATTRS.LENGTH)) {
        slateLength = parseInt(text.getAttribute(DATA_ATTRS.LENGTH), 10);
      }

      var end = start + slateLength;

      if (point.offset <= end) {
        var offset = Math.min(domLength, Math.max(0, point.offset - start));
        return { node: node, offset: offset };
      }

      start = end;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

/**
 * Export.
 *
 * @type {Function}
 */

function findDOMRange(range) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findDOMRange(range)` helper is deprecated in favor of `editor.findDOMRange(range)`.');

  var anchor = range.anchor,
      focus = range.focus,
      isBackward$$1 = range.isBackward,
      isCollapsed = range.isCollapsed;

  var domAnchor = findDOMPoint(anchor, win);
  var domFocus = isCollapsed ? domAnchor : findDOMPoint(focus, win);

  if (!domAnchor || !domFocus) return null;

  var r = win.document.createRange();
  var start = isBackward$$1 ? domFocus : domAnchor;
  var end = isBackward$$1 ? domAnchor : domFocus;
  r.setStart(start.node, start.offset);
  r.setEnd(end.node, end.offset);
  return r;
}

/**
 * Export.
 *
 * @type {Function}
 */

function findNode(element, editor) {
  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findNode(element)` helper is deprecated in favor of `editor.findNode(element)`.');

  Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(!__WEBPACK_IMPORTED_MODULE_6_slate__["n" /* Value */].isValue(editor), 'As of Slate 0.42.0, the `findNode` utility takes an `editor` instead of a `value`.');

  var closest = element.closest(SELECTORS.KEY);
  if (!closest) return null;

  var key = closest.getAttribute(DATA_ATTRS.KEY);
  if (!key) return null;

  var value = editor.value;
  var document = value.document;

  var node = document.getNode(key);
  return node || null;
}

/**
 * Export.
 *
 * @type {Function}
 */

function findPath(element, editor) {
  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findPath(element)` helper is deprecated in favor of `editor.findPath(element)`.');

  var node = findNode(element, editor);

  if (!node) {
    return null;
  }

  var value = editor.value;
  var document = value.document;

  var path = document.getPath(node);
  return path;
}

/**
 * Export.
 *
 * @type {Function}
 */

function findPoint(nativeNode, nativeOffset, editor) {
  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findPoint(node, offset)` helper is deprecated in favor of `editor.findPoint(node, offset)`.');

  Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(!__WEBPACK_IMPORTED_MODULE_6_slate__["n" /* Value */].isValue(editor), 'As of Slate 0.42.0, the `findPoint` utility takes an `editor` instead of a `value`.');

  var _normalizeNodeAndOffs = normalizeNodeAndOffset$1(nativeNode, nativeOffset),
      nearestNode = _normalizeNodeAndOffs.node,
      nearestOffset = _normalizeNodeAndOffs.offset;

  var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(nativeNode);
  var parentNode = nearestNode.parentNode;

  var rangeNode = parentNode.closest(SELECTORS.LEAF);
  var offset = void 0;
  var node = void 0;

  // Calculate how far into the text node the `nearestNode` is, so that we can
  // determine what the offset relative to the text node is.
  if (rangeNode) {
    var range = window.document.createRange();
    var textNode = rangeNode.closest(SELECTORS.TEXT);
    range.setStart(textNode, 0);
    range.setEnd(nearestNode, nearestOffset);
    node = textNode;

    // COMPAT: Edge has a bug where Range.prototype.toString() will convert \n
    // into \r\n. The bug causes a loop when slate-react attempts to reposition
    // its cursor to match the native position. Use textContent.length instead.
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/
    var fragment = range.cloneContents();
    var zeroWidthNodes = fragment.querySelectorAll('[' + DATA_ATTRS.ZERO_WIDTH + ']');
    offset = fragment.textContent.length - zeroWidthNodes.length;
  } else {
    // For void nodes, the element with the offset key will be a cousin, not an
    // ancestor, so find it by going down from the nearest void parent.
    var voidNode = parentNode.closest(SELECTORS.VOID);
    if (!voidNode) return null;
    rangeNode = voidNode.querySelector(SELECTORS.LEAF);
    if (!rangeNode) return null;
    node = rangeNode;
    offset = node.textContent.length;
  }

  // COMPAT: If the parent node is a Slate zero-width space, this is because the
  // text node should have no characters. However, during IME composition the
  // ASCII characters will be prepended to the zero-width space, so subtract 1
  // from the offset to account for the zero-width space character.
  if (offset === node.textContent.length && parentNode.hasAttribute(DATA_ATTRS.ZERO_WIDTH)) {
    offset--;
  }

  // Get the string value of the offset key attribute.
  var offsetKey = rangeNode.getAttribute(DATA_ATTRS.OFFSET_KEY);
  if (!offsetKey) return null;

  var _OffsetKey$parse = OffsetKey.parse(offsetKey),
      key = _OffsetKey$parse.key;

  // COMPAT: If someone is clicking from one Slate editor into another, the
  // select event fires twice, once for the old editor's `element` first, and
  // then afterwards for the correct `element`. (2017/03/03)


  var value = editor.value;

  if (!value.document.hasDescendant(key)) return null;

  var point = value.document.createPoint({ key: key, offset: offset });
  return point;
}

/**
 * From a DOM selection's `node` and `offset`, normalize so that it always
 * refers to a text node.
 *
 * @param {Element} node
 * @param {Number} offset
 * @return {Object}
 */

function normalizeNodeAndOffset$1(node, offset) {
  // If it's an element node, its offset refers to the index of its children
  // including comment nodes, so try to find the right text child node.
  if (node.nodeType === 1 && node.childNodes.length) {
    var isLast = offset === node.childNodes.length;
    var direction = isLast ? 'backward' : 'forward';
    var index = isLast ? offset - 1 : offset;
    node = getEditableChild$1(node, index, direction);

    // If the node has children, traverse until we have a leaf node. Leaf nodes
    // can be either text nodes, or other void DOM nodes.
    while (node.nodeType === 1 && node.childNodes.length) {
      var i = isLast ? node.childNodes.length - 1 : 0;
      node = getEditableChild$1(node, i, direction);
    }

    // Determine the new offset inside the text node.
    offset = isLast ? node.textContent.length : 0;
  }

  // Return the node and offset.
  return { node: node, offset: offset };
}

/**
 * Get the nearest editable child at `index` in a `parent`, preferring
 * `direction`.
 *
 * @param {Element} parent
 * @param {Number} index
 * @param {String} direction ('forward' or 'backward')
 * @return {Element|Null}
 */

function getEditableChild$1(parent, index, direction) {
  var childNodes = parent.childNodes;

  var child = childNodes[index];
  var i = index;
  var triedForward = false;
  var triedBackward = false;

  // While the child is a comment node, or an element node with no children,
  // keep iterating to find a sibling non-void, non-comment node.
  while (child.nodeType === 8 || child.nodeType === 1 && child.childNodes.length === 0 || child.nodeType === 1 && child.getAttribute('contenteditable') === 'false') {
    if (triedForward && triedBackward) break;

    if (i >= childNodes.length) {
      triedForward = true;
      i = index - 1;
      direction = 'backward';
      continue;
    }

    if (i < 0) {
      triedBackward = true;
      i = index + 1;
      direction = 'forward';
      continue;
    }

    child = childNodes[i];
    if (direction === 'forward') i++;
    if (direction === 'backward') i--;
  }

  return child || null;
}

/**
 * Export.
 *
 * @type {Function}
 */

function findRange(native, editor) {
  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `findRange(selection)` helper is deprecated in favor of `editor.findRange(selection)`.');

  Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(!__WEBPACK_IMPORTED_MODULE_6_slate__["n" /* Value */].isValue(editor), 'As of Slate 0.42.0, the `findNode` utility takes an `editor` instead of a `value`.');

  var el = native.anchorNode || native.startContainer;
  if (!el) return null;

  var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(el);

  // If the `native` object is a DOM `Range` or `StaticRange` object, change it
  // into something that looks like a DOM `Selection` instead.
  if (native instanceof window.Range || window.StaticRange && native instanceof window.StaticRange) {
    native = {
      anchorNode: native.startContainer,
      anchorOffset: native.startOffset,
      focusNode: native.endContainer,
      focusOffset: native.endOffset
    };
  }

  var _native = native,
      anchorNode = _native.anchorNode,
      anchorOffset = _native.anchorOffset,
      focusNode = _native.focusNode,
      focusOffset = _native.focusOffset,
      isCollapsed = _native.isCollapsed;
  var value = editor.value;

  var anchor = findPoint(anchorNode, anchorOffset, editor);
  var focus = isCollapsed ? anchor : findPoint(focusNode, focusOffset, editor);
  if (!anchor || !focus) return null;

  var document = value.document;

  var range = document.createRange({
    anchor: anchor,
    focus: focus
  });

  return range;
}

/**
 * Export.
 *
 * @type {Function}
 */

function getEventRange(event, editor) {
  Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false, 'As of slate-react@0.22 the `getEventRange(event, editor)` helper is deprecated in favor of `editor.findEventRange(event)`.');

  Object(__WEBPACK_IMPORTED_MODULE_17_tiny_invariant__["a" /* default */])(!__WEBPACK_IMPORTED_MODULE_6_slate__["n" /* Value */].isValue(editor), 'As of Slate 0.42.0, the `findNode` utility takes an `editor` instead of a `value`.');

  if (event.nativeEvent) {
    event = event.nativeEvent;
  }

  var _event = event,
      x = _event.clientX,
      y = _event.clientY,
      target = _event.target;

  if (x == null || y == null) return null;

  var value = editor.value;
  var document = value.document;

  var path = findPath(event.target, editor);
  if (!path) return null;

  var node = document.getNode(path);

  // If the drop target is inside a void node, move it into either the next or
  // previous node, depending on which side the `x` and `y` coordinates are
  // closest to.
  if (editor.isVoid(node)) {
    var rect = target.getBoundingClientRect();
    var isPrevious = node.object === 'inline' ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;

    var _range = document.createRange();
    var move = isPrevious ? 'moveToEndOfNode' : 'moveToStartOfNode';
    var entry = document[isPrevious ? 'getPreviousText' : 'getNextText'](path);

    if (entry) {
      return _range[move](entry);
    }

    return null;
  }

  // Else resolve a range from the caret position where the drop occured.
  var window = __WEBPACK_IMPORTED_MODULE_7_get_window___default()(target);
  var native = void 0;

  // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)
  if (window.document.caretRangeFromPoint) {
    native = window.document.caretRangeFromPoint(x, y);
  } else if (window.document.caretPositionFromPoint) {
    var position = window.document.caretPositionFromPoint(x, y);
    native = window.document.createRange();
    native.setStart(position.offsetNode, position.offset);
    native.setEnd(position.offsetNode, position.offset);
  } else if (window.document.body.createTextRange) {
    // COMPAT: In IE, `caretRangeFromPoint` and
    // `caretPositionFromPoint` don't exist. (2018/07/11)
    native = window.document.body.createTextRange();

    try {
      native.moveToPoint(x, y);
    } catch (error) {
      // IE11 will raise an `unspecified error` if `moveToPoint` is
      // called during a dropEvent.
      return null;
    }
  }

  // Resolve a Slate range from the DOM range.
  var range = findRange(native, editor);
  if (!range) return null;

  return range;
}

/**
 * Export.
 *
 * @type {Function}
 */

var index = {
  Editor: Editor$1,
  cloneFragment: cloneFragment,
  findDOMNode: findDOMNode,
  findDOMPoint: findDOMPoint,
  findDOMRange: findDOMRange,
  findNode: findNode,
  findPath: findPath,
  findPoint: findPoint,
  findRange: findRange,
  getEventRange: getEventRange,
  getEventTransfer: getEventTransfer,
  setEventTransfer: setEventTransfer,
  ReactPlugin: ReactPlugin
};

/* unused harmony default export */ var _unused_webpack_default_export = (index);

//# sourceMappingURL=slate-react.es.js.map


/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slate__ = __webpack_require__(176);


/**
 * Create a prop type checker for Slate objects with `name` and `validate`.
 *
 * @param {String} name
 * @param {Function} validate
 * @return {Function}
 */

function create(name, validate) {
  function check(isRequired, props, propName, componentName, location) {
    var value = props[propName];

    if (value == null && !isRequired) {
      return null;
    }

    if (value == null && isRequired) {
      return new Error('The ' + location + ' `' + propName + '` is marked as required in `' + componentName + '`, but it was not supplied.');
    }

    if (validate(value)) {
      return null;
    }

    return new Error('Invalid ' + location + ' `' + propName + '` supplied to `' + componentName + '`, expected a Slate `' + name + '` but received: ' + value);
  }

  function propType() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return check.apply(undefined, [false].concat(args));
  }

  propType.isRequired = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return check.apply(undefined, [true].concat(args));
  };

  return propType;
}

/**
 * Prop type checkers.
 *
 * @type {Object}
 */

var Types = {
  block: create('Block', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["a" /* Block */].isBlock(v);
  }),
  blocks: create('List<Block>', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["a" /* Block */].isBlockList(v);
  }),
  change: create('Change', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["b" /* Change */].isChange(v);
  }),
  data: create('Data', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["c" /* Data */].isData(v);
  }),
  document: create('Document', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["d" /* Document */].isDocument(v);
  }),
  inline: create('Inline', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["f" /* Inline */].isInline(v);
  }),
  inlines: create('Inline', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["f" /* Inline */].isInlineList(v);
  }),
  leaf: create('Leaf', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["g" /* Leaf */].isLeaf(v);
  }),
  leaves: create('List<Leaf>', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["g" /* Leaf */].isLeafList(v);
  }),
  mark: create('Mark', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["h" /* Mark */].isMark(v);
  }),
  marks: create('Set<Mark>', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["h" /* Mark */].isMarkSet(v);
  }),
  node: create('Node', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["i" /* Node */].isNode(v);
  }),
  nodes: create('List<Node>', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["i" /* Node */].isNodeList(v);
  }),
  range: create('Range', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["k" /* Range */].isRange(v);
  }),
  ranges: create('List<Range>', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["k" /* Range */].isRangeList(v);
  }),
  selection: create('Selection', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["l" /* Selection */].isSelection(v);
  }),
  value: create('Value', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["n" /* Value */].isValue(v);
  }),
  text: create('Text', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["m" /* Text */].isText(v);
  }),
  texts: create('List<Text>', function (v) {
    return __WEBPACK_IMPORTED_MODULE_0_slate__["m" /* Text */].isTextList(v);
  })

  /**
   * Export.
   *
   * @type {Object}
   */

};

/* harmony default export */ __webpack_exports__["a"] = (Types);
//# sourceMappingURL=slate-prop-types.es.js.map


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */


var Immutable = __webpack_require__(177);

var ANONYMOUS = "<<anonymous>>";

var ImmutablePropTypes = {
  listOf: createListOfTypeChecker,
  mapOf: createMapOfTypeChecker,
  orderedMapOf: createOrderedMapOfTypeChecker,
  setOf: createSetOfTypeChecker,
  orderedSetOf: createOrderedSetOfTypeChecker,
  stackOf: createStackOfTypeChecker,
  iterableOf: createIterableOfTypeChecker,
  recordOf: createRecordOfTypeChecker,
  shape: createShapeChecker,
  contains: createShapeChecker,
  mapContains: createMapContainsChecker,
  // Primitive Types
  list: createImmutableTypeChecker("List", Immutable.List.isList),
  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
  record: createImmutableTypeChecker("Record", function (isRecord) {
    return isRecord instanceof Immutable.Record;
  }),
  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
};

function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return "array";
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }
  if (propValue instanceof Immutable.Iterable) {
    return "Immutable." + propValue.toSource().split(" ")[0];
  }
  return propType;
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    propFullName = propFullName || propName;
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      var locationName = location;
      if (isRequired) {
        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
      }
    } else {
      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var locationName = location;
      var propType = getPropType(propValue);
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }

    if (typeof typeChecker !== "function") {
      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var propValues = propValue.toArray();
    for (var i = 0, len = propValues.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createKeysTypeChecker(typeChecker) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (typeof typeChecker !== "function") {
      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var keys = propValue.keySeq().toArray();
    for (var i = 0, len = keys.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createListOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
}

function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
  function validate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
  }

  return createChainableTypeChecker(validate);
}

function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
}

function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
}

function createSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
}

function createOrderedSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
}

function createStackOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
}

function createIterableOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
}

function createRecordOfTypeChecker(recordKeys) {
  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!(propValue instanceof Immutable.Record)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
    }
    for (var key in recordKeys) {
      var checker = recordKeys[key];
      if (!checker) {
        continue;
      }
      var mutablePropValue = propValue.toObject();
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function createShapeTypeChecker(shapeTypes) {
  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }
    var mutablePropValue = propValue.toObject();
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createShapeChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes);
}

function createMapContainsChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
}

module.exports = ImmutablePropTypes;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"./.gallery"}).DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__(1678)(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__(1679);
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */


  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;



/***/ }),
/* 1679 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var getDocument = __webpack_require__(1681);

/**
 * Module exports.
 */

module.exports = getWindow;

var needsIEFallback = __webpack_require__(1682);

/**
 * Returns `true` if `w` is a Window object, or `false` otherwise.
 *
 * @param {Mixed} w - Window object, maybe
 * @return {Boolean}
 * @private
 */

function isWindow (w) {
  return w && w.window === w;
}

/**
 * Returns the `window` object associated with the given `node`, which may be
 * a DOM element, the Window object, a Selection, a Range. Basically any DOM
 * object that references the Window in some way, this function will find it.
 *
 * @param {Mixed} node - DOM node, selection, or range in which to find the `window` object
 * @return {Window} the `window` object associated with `node`
 * @public
 */

function getWindow(node) {
  if (isWindow(node)) {
    return node;
  }

  var doc = getDocument(node);

  if (needsIEFallback) {
    // In IE 6-8, only the variable 'window' can be used to connect events (others
    // may be only copies).
    doc.parentWindow.execScript('document._parentWindow = window;', 'Javascript');
    var win = doc._parentWindow;
    // to prevent memory leak, unset it after use
    // another possibility is to add an onUnload handler,
    // (which seems overkill to @liucougar)
    doc._parentWindow = null;
    return win;
  } else {
    // standards-compliant and newer IE
    return doc.defaultView || doc.parentWindow;
  }
}


/***/ }),
/* 1681 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = getDocument;

// defined by w3c
var DOCUMENT_NODE = 9;

/**
 * Returns `true` if `w` is a Document object, or `false` otherwise.
 *
 * @param {?} d - Document object, maybe
 * @return {Boolean}
 * @private
 */

function isDocument (d) {
  return d && d.nodeType === DOCUMENT_NODE;
}

/**
 * Returns the `document` object associated with the given `node`, which may be
 * a DOM element, the Window object, a Selection, a Range. Basically any DOM
 * object that references the Document in some way, this function will find it.
 *
 * @param {Mixed} node - DOM node, selection, or range in which to find the `document` object
 * @return {Document} the `document` object associated with `node`
 * @public
 */

function getDocument(node) {
  if (isDocument(node)) {
    return node;

  } else if (isDocument(node.ownerDocument)) {
    return node.ownerDocument;

  } else if (isDocument(node.document)) {
    return node.document;

  } else if (node.parentNode) {
    return getDocument(node.parentNode);

  // Range support
  } else if (node.commonAncestorContainer) {
    return getDocument(node.commonAncestorContainer);

  } else if (node.startContainer) {
    return getDocument(node.startContainer);

  // Selection support
  } else if (node.anchorNode) {
    return getDocument(node.anchorNode);
  }
}


/***/ }),
/* 1682 */
/***/ (function(module, exports) {

// this is a browser-only module. There is a non-browser equivalent in the same
// directory. This is done using a `package.json` browser field.
// old-IE fallback logic: http://stackoverflow.com/a/10260692
module.exports =  !!document.attachEvent && window !== document.parentWindow;


/***/ }),
/* 1683 */
/***/ (function(module, exports) {

function isBackward(selection) {
    var startNode = selection.anchorNode;
    var startOffset = selection.anchorOffset;
    var endNode = selection.focusNode;
    var endOffset = selection.focusOffset;

    var position = startNode.compareDocumentPosition(endNode);

    return !(position === 4 || (position === 0 && startOffset < endOffset));
}

module.exports = isBackward;


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1686),
    isObject = __webpack_require__(86);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86),
    now = __webpack_require__(1687),
    toNumber = __webpack_require__(1688);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86),
    isSymbol = __webpack_require__(228);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_hotkey__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_hotkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_hotkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slate_dev_environment__ = __webpack_require__(640);



/**
 * Hotkey mappings for each platform.
 *
 * @type {Object}
 */

var HOTKEYS = {
  bold: 'mod+b',
  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
  moveBackward: 'left',
  moveForward: 'right',
  moveWordBackward: 'ctrl+left',
  moveWordForward: 'ctrl+right',
  deleteBackward: 'shift?+backspace',
  deleteForward: 'shift?+delete',
  extendBackward: 'shift+left',
  extendForward: 'shift+right',
  italic: 'mod+i',
  splitBlock: 'shift?+enter',
  undo: 'mod+z'
};

var APPLE_HOTKEYS = {
  moveLineBackward: 'opt+up',
  moveLineForward: 'opt+down',
  moveWordBackward: 'opt+left',
  moveWordForward: 'opt+right',
  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
  deleteForward: ['ctrl+delete', 'ctrl+d'],
  deleteLineBackward: 'cmd+shift?+backspace',
  deleteLineForward: ['cmd+shift?+delete', 'ctrl+k'],
  deleteWordBackward: 'opt+shift?+backspace',
  deleteWordForward: 'opt+shift?+delete',
  extendLineBackward: 'opt+shift+up',
  extendLineForward: 'opt+shift+down',
  redo: 'cmd+shift+z',
  transposeCharacter: 'ctrl+t'
};

var WINDOWS_HOTKEYS = {
  deleteWordBackward: 'ctrl+shift?+backspace',
  deleteWordForward: 'ctrl+shift?+delete',
  redo: 'ctrl+y'

  /**
   * Hotkeys.
   *
   * @type {Object}
   */

};var Hotkeys = {};

var IS_APPLE = __WEBPACK_IMPORTED_MODULE_1_slate_dev_environment__["f" /* IS_IOS */] || __WEBPACK_IMPORTED_MODULE_1_slate_dev_environment__["g" /* IS_MAC */];
var IS_WINDOWS = !IS_APPLE;
var KEYS = [].concat(Object.keys(HOTKEYS)).concat(Object.keys(APPLE_HOTKEYS)).concat(Object.keys(WINDOWS_HOTKEYS));

KEYS.forEach(function (key) {
  var method = 'is' + key[0].toUpperCase() + key.slice(1);
  if (Hotkeys[method]) return;

  var generic = HOTKEYS[key];
  var apple = APPLE_HOTKEYS[key];
  var windows = WINDOWS_HOTKEYS[key];

  var isGeneric = generic && Object(__WEBPACK_IMPORTED_MODULE_0_is_hotkey__["isKeyHotkey"])(generic);
  var isApple = apple && Object(__WEBPACK_IMPORTED_MODULE_0_is_hotkey__["isKeyHotkey"])(apple);
  var isWindows = windows && Object(__WEBPACK_IMPORTED_MODULE_0_is_hotkey__["isKeyHotkey"])(windows);

  Hotkeys[method] = function (event) {
    if (isGeneric && isGeneric(event)) return true;
    if (IS_APPLE && isApple && isApple(event)) return true;
    if (IS_WINDOWS && isWindows && isWindows(event)) return true;
    return false;
  };
});

/* harmony default export */ __webpack_exports__["a"] = (Hotkeys);
//# sourceMappingURL=slate-hotkeys.es.js.map


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?');

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key') {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

exports.default = isHotkey;
exports.isHotkey = isHotkey;
exports.isCodeHotkey = isCodeHotkey;
exports.isKeyHotkey = isKeyHotkey;
exports.parseHotkey = parseHotkey;
exports.compareHotkey = compareHotkey;
exports.toKeyCode = toKeyCode;
exports.toKeyName = toKeyName;

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slate__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_base64__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_base64__);



/**
 * Encode a JSON `object` as base-64 `string`.
 *
 * @param {Object} object
 * @return {String}
 */

function encode(object) {
  var string = JSON.stringify(object);
  var encoded = Object(__WEBPACK_IMPORTED_MODULE_1_isomorphic_base64__["btoa"])(encodeURIComponent(string));
  return encoded;
}

/**
 * Decode a base-64 `string` to a JSON `object`.
 *
 * @param {String} string
 * @return {Object}
 */

function decode(string) {
  var decoded = decodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_1_isomorphic_base64__["atob"])(string));
  var object = JSON.parse(decoded);
  return object;
}

/**
 * Deserialize a Value `string`.
 *
 * @param {String} string
 * @return {Value}
 */

function deserialize(string, options) {
  var raw = decode(string);
  var value = __WEBPACK_IMPORTED_MODULE_0_slate__["n" /* Value */].fromJSON(raw, options);
  return value;
}

/**
 * Deserialize a Node `string`.
 *
 * @param {String} string
 * @return {Node}
 */

function deserializeNode(string, options) {
  var raw = decode(string);
  var node = __WEBPACK_IMPORTED_MODULE_0_slate__["i" /* Node */].fromJSON(raw, options);
  return node;
}

/**
 * Serialize a `value`.
 *
 * @param {Value} value
 * @return {String}
 */

function serialize(value, options) {
  var raw = value.toJSON(options);
  var encoded = encode(raw);
  return encoded;
}

/**
 * Serialize a `node`.
 *
 * @param {Node} node
 * @return {String}
 */

function serializeNode(node, options) {
  var raw = node.toJSON(options);
  var encoded = encode(raw);
  return encoded;
}

/**
 * Export.
 *
 * @type {Object}
 */

var index = {
  deserialize: deserialize,
  deserializeNode: deserializeNode,
  serialize: serialize,
  serializeNode: serializeNode
};

/* harmony default export */ __webpack_exports__["a"] = (index);
//# sourceMappingURL=slate-base64-serializer.es.js.map


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.atob = self.atob.bind(self);
exports.btoa = self.btoa.bind(self);


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slate__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Deserialize a plain text `string` to a Slate value.
 *
 * @param {String} string
 * @param {Object} options
 *   @property {Boolean} toJSON
 *   @property {String|Object|Block} defaultBlock
 *   @property {Array|Set} defaultMarks
 * @return {Value}
 */

function deserialize(string) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$defaultBlock = options.defaultBlock,
      defaultBlock = _options$defaultBlock === undefined ? 'line' : _options$defaultBlock,
      _options$defaultMarks = options.defaultMarks,
      defaultMarks = _options$defaultMarks === undefined ? [] : _options$defaultMarks,
      _options$delimiter = options.delimiter,
      delimiter = _options$delimiter === undefined ? '\n' : _options$delimiter,
      _options$toJSON = options.toJSON,
      toJSON = _options$toJSON === undefined ? false : _options$toJSON;


  if (__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"].isSet(defaultMarks)) {
    defaultMarks = defaultMarks.toArray();
  }

  defaultBlock = __WEBPACK_IMPORTED_MODULE_0_slate__["i" /* Node */].createProperties(defaultBlock);
  defaultMarks = defaultMarks.map(__WEBPACK_IMPORTED_MODULE_0_slate__["h" /* Mark */].createProperties);

  var json = {
    object: 'value',
    document: {
      object: 'document',
      data: {},
      nodes: string.split(delimiter).map(function (line) {
        return _extends({}, defaultBlock, {
          object: 'block',
          data: {},
          nodes: [{
            object: 'text',
            text: line,
            marks: defaultMarks
          }]
        });
      })
    }
  };

  var ret = toJSON ? json : __WEBPACK_IMPORTED_MODULE_0_slate__["n" /* Value */].fromJSON(json);
  return ret;
}

/**
 * Serialize a Slate `value` to a plain text string.
 *
 * @param {Value} value
 * @return {String}
 */

function serialize(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return serializeNode(value.document, options);
}

/**
 * Serialize a `node` to plain text.
 *
 * @param {Node} node
 * @return {String}
 */

function serializeNode(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$delimiter2 = options.delimiter,
      delimiter = _options$delimiter2 === undefined ? '\n' : _options$delimiter2;


  if (node.object === 'document' || node.object === 'block' && __WEBPACK_IMPORTED_MODULE_0_slate__["a" /* Block */].isBlockList(node.nodes)) {
    return node.nodes.map(serializeNode).join(delimiter);
  } else {
    return node.text;
  }
}

/**
 * Export.
 *
 * @type {Object}
 */

var index = {
  deserialize: deserialize,
  serialize: serialize
};

/* harmony default export */ __webpack_exports__["a"] = (index);
//# sourceMappingURL=slate-plain-serializer.es.js.map


/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var isProduction = "development" === 'production';
var prefix = 'Invariant failed';
var index = (function (condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};





















var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Instance counter to enable unique marks for multiple Placeholder instances.
 */

var instanceCounter = 0;

/**
 * A plugin that renders a React placeholder for a given Slate node.
 *
 * @param {Object} options
 * @return {Object}
 */

function SlateReactPlaceholder() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var instanceId = instanceCounter++;
  var placeholder = options.placeholder,
      when = options.when,
      _options$style = options.style,
      style = _options$style === undefined ? {} : _options$style;


  index(typeof placeholder === 'string', 'You must pass `SlateReactPlaceholder` an `options.placeholder` string.');

  index(typeof when === 'string' || typeof when === 'function', 'You must pass `SlateReactPlaceholder` an `options.when` query.');

  /**
   * Decorate a match node with a placeholder mark when it fits the query.
   *
   * @param {Node} node
   * @param {Editor} editor
   * @param {Function} next
   * @return {Array}
   */

  function decorateNode(node, editor, next) {
    if (!editor.query(when, node)) {
      return next();
    }

    var others = next();

    var _node$texts = node.texts(),
        _node$texts2 = slicedToArray(_node$texts, 1),
        first = _node$texts2[0];

    var _node$texts3 = node.texts({ direction: 'backward' }),
        _node$texts4 = slicedToArray(_node$texts3, 1),
        last = _node$texts4[0];

    var _first = slicedToArray(first, 2),
        firstNode = _first[0],
        firstPath = _first[1];

    var _last = slicedToArray(last, 2),
        lastNode = _last[0],
        lastPath = _last[1];

    var decoration = {
      type: 'placeholder',
      data: { key: instanceId },
      anchor: { key: firstNode.key, offset: 0, path: firstPath },
      focus: {
        key: lastNode.key,
        offset: lastNode.text.length,
        path: lastPath
      }
    };

    return [].concat(toConsumableArray(others), [decoration]);
  }

  /**
   * Render an inline placeholder for the placeholder mark.
   *
   * @param {Object} props
   * @param {Editor} editor
   * @param {Function} next
   * @return {Element}
   */

  function renderDecoration(props, editor, next) {
    var children = props.children,
        deco = props.decoration;


    if (deco.type === 'placeholder' && deco.data.get('key') === instanceId) {
      var placeHolderStyle = _extends({
        pointerEvents: 'none',
        display: 'inline-block',
        width: '0',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        opacity: '0.333',
        verticalAlign: 'text-top'
      }, style);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { contentEditable: false, style: placeHolderStyle },
          placeholder
        ),
        children
      );
    }

    return next();
  }

  /**
   * Return the plugin.
   *
   * @return {Object}
   */

  return { decorateNode: decorateNode, renderDecoration: renderDecoration };
}

/* harmony default export */ __webpack_exports__["a"] = (SlateReactPlaceholder);
//# sourceMappingURL=slate-react-placeholder.es.js.map


/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledEditorWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var StyledEditorWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: ", ";\n\theight: ", ";\n\ttransform: ", ";\n\toverflow: hidden;\n\tpointer-events: auto;\n\n\t", "\n\n\t", "\n\n\t", "\n\n\t> div {\n\t\theight: 100%;\n\t\t-webkit-user-modify: read-write !important; // Fix for Chrome 105+\n\t}\n\n\t", "\n\n\ta {\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\t}\n\n\tul, ol {\n\t\tmargin: 0;\n\t\tpadding-left: 1.5em;\n\t}\n\n\t.", ",\n\t.", " {\n\t\tposition: relative;\n\t\tfont-size: 75%;\n\t}\n\n\t.", " {\n\t\ttop: 0.35em;\n\t}\n\n\t.", " {\n\t\ttop: -0.35em;\n\t}\n\n\t", "\n"], ["\n\twidth: ", ";\n\theight: ", ";\n\ttransform: ", ";\n\toverflow: hidden;\n\tpointer-events: auto;\n\n\t",
    "\n\n\t",
    "\n\n\t",
    "\n\n\t> div {\n\t\theight: 100%;\n\t\t-webkit-user-modify: read-write !important; // Fix for Chrome 105+\n\t}\n\n\t",
    "\n\n\ta {\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\t}\n\n\tul, ol {\n\t\tmargin: 0;\n\t\tpadding-left: 1.5em;\n\t}\n\n\t.", ",\n\t.", " {\n\t\tposition: relative;\n\t\tfont-size: 75%;\n\t}\n\n\t.", " {\n\t\ttop: 0.35em;\n\t}\n\n\t.", " {\n\t\ttop: -0.35em;\n\t}\n\n\t",
    "\n"])), function (_a) {
    var width = _a.width;
    return width ? width + "px" : '';
}, function (_a) {
    var height = _a.height;
    return height ? height + "px" : '';
}, function (_a) {
    var transform = _a.transform;
    return transform ? transform : '';
}, function (_a) {
    var editorType = _a.editorType;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].HTML &&
        'position: relative;';
}, function (_a) {
    var editorType = _a.editorType, isActive = _a.isActive, isEmpty = _a.isEmpty, isAccessibleVersion = _a.isAccessibleVersion;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].INDESIGN && (isActive || isEmpty) && "\n\t\tposition: " + (isAccessibleVersion ? 'relative' : 'absolute') + ";\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tz-index: 1;\n\t";
}, function (_a) {
    var isActive = _a.isActive, isEmpty = _a.isEmpty, outlineWidth = _a.outlineWidth, editorType = _a.editorType;
    return (isActive || isEmpty) &&
        "outline: " + (editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].INDESIGN ? outlineWidth : 2) + "px solid " + (isActive ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey400) + ";";
}, function (_a) {
    var editorType = _a.editorType;
    return editorType === __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["e" /* EditorType */].INDESIGN && "\n\t\t> div {\n\t\t\tposition: relative;\n\t\t\ttop: -1px;\n\t\t}\n\t";
}, __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["t" /* subScriptClassName */], __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["u" /* superScriptClassName */], __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["t" /* subScriptClassName */], __WEBPACK_IMPORTED_MODULE_1__containers_Editor_constants__["u" /* superScriptClassName */], function (_a) {
    var shouldShowScrollbar = _a.shouldShowScrollbar;
    return shouldShowScrollbar && "\n\t\t> div {\n\t\t\t/* show scrollbar on editable text fields like in the reader */\n\t\t\toverflow-y: auto;\n\t\t\toverflow-x: hidden;\n\t\t\tpadding-right: 4px;\n\n\t\t\t/* custom scrollbar on firefox */\n\t\t\tscrollbar-width: thin;\n\t\t\tscrollbar-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey500 + " " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey100 + ";\n\n\t\t\t/* custom scrollbar on chrome */\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 3px;\n\t\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey100 + ";\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey100 + ";\n\t\t\t\tborder-radius: 1px;\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey500 + ";\n\t\t\t\tborder-radius: 1px;\n\t\t\t}\n\n\t\t\t.editable-button-link & {\n\t\t\t\toverflow-y: hidden;\n\t\t\t\tpadding-right: 0;\n\t\t\t}\n\t\t}\n\t";
});

var templateObject_1;


/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_TextPanel__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var mapStateToProps = function (state, ownProps) {
    var page = ownProps.page;
    return __assign({}, ownProps, { fontFamilyOptions: __WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* getFontFamilyOptions */](state, page), fontSizeOptions: __WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* getFontSizeOptions */](state, page), colorOptions: __WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* getColorOptions */](state, page), lineHeightOptions: __WEBPACK_IMPORTED_MODULE_2__selectors__["g" /* getLineHeightOptions */](state, page), letterSpacingOptions: __WEBPACK_IMPORTED_MODULE_2__selectors__["f" /* getLetterSpacingOptions */](state, page) });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_TextPanel__["a" /* default */]));


/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Select_styles__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);









var listTypeOptions = [
    {
        label: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Select_styles__["g" /* ListTypeOption */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.bulleted" }),
            __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_bulleted_list'))),
        values: [__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["d" /* LIST_TYPE */].UNORDERED],
    },
    {
        label: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Select_styles__["g" /* ListTypeOption */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.numbered" }),
            __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_numbered_list'))),
        values: [__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["d" /* LIST_TYPE */].ORDERED],
    },
    {
        label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.none" }),
        values: [__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["d" /* LIST_TYPE */].NONE],
    },
];
var TextPanel = function (_a) {
    var fontFamily = _a.fontFamily, fontSize = _a.fontSize, color = _a.color, lineHeight = _a.lineHeight, letterSpacing = _a.letterSpacing, isBoldActive = _a.isBoldActive, isItalicActive = _a.isItalicActive, isUnderlineActive = _a.isUnderlineActive, isLineThroughActive = _a.isLineThroughActive, isCapitalizeActive = _a.isCapitalizeActive, isUpperCaseActive = _a.isUpperCaseActive, isLowerCaseActive = _a.isLowerCaseActive, isSuperScriptActive = _a.isSuperScriptActive, isSubScriptActive = _a.isSubScriptActive, isTextAlignLeft = _a.isTextAlignLeft, isTextAlignCenter = _a.isTextAlignCenter, isTextAlignRight = _a.isTextAlignRight, isTextAlignJustify = _a.isTextAlignJustify, isVerticalAlignTop = _a.isVerticalAlignTop, isVerticalAlignCenter = _a.isVerticalAlignCenter, isVerticalAlignBottom = _a.isVerticalAlignBottom, listType = _a.listType, hasColorPicker = _a.hasColorPicker, fontFamilyOptions = _a.fontFamilyOptions, fontSizeOptions = _a.fontSizeOptions, colorOptions = _a.colorOptions, lineHeightOptions = _a.lineHeightOptions, letterSpacingOptions = _a.letterSpacingOptions, _b = _a.actions, onFontFamilyChange = _b.onFontFamilyChange, onFontSizeChange = _b.onFontSizeChange, onColorChange = _b.onColorChange, onLineHeightChange = _b.onLineHeightChange, onLetterSpacingChange = _b.onLetterSpacingChange, onFontWeightClick = _b.onFontWeightClick, onFontStyleClick = _b.onFontStyleClick, onTextDecorationChange = _b.onTextDecorationChange, onTextTransformChange = _b.onTextTransformChange, onTextScriptChange = _b.onTextScriptChange, onTextAlignChange = _b.onTextAlignChange, onVerticalAlignChange = _b.onVerticalAlignChange, onListTypeChange = _b.onListTypeChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* Label */], { value: "messages.text_style" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Section */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { label: "messages.font", value: fontFamily, isFontSelect: true, options: fontFamilyOptions, onChange: onFontFamilyChange }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonsWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isBoldActive, isBold: true, onClick: onFontWeightClick }, "B"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isItalicActive, isItalic: true, onClick: onFontStyleClick }, "I"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isUnderlineActive, isUnderline: true, onClick: function () { return onTextDecorationChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["j" /* TEXT_DECORATION */].UNDERLINE); } }, "U"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isLineThroughActive, isLineThrough: true, onClick: function () { return onTextDecorationChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["j" /* TEXT_DECORATION */].LINE_THROUGH); } }, "S")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { label: "messages.size", value: fontSize, options: fontSizeOptions, onChange: onFontSizeChange }),
            hasColorPicker &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { label: "messages.color", value: color, isColorSelect: true, options: colorOptions, onChange: onColorChange }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonsWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isCapitalizeActive, onClick: function () { return onTextTransformChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["l" /* TEXT_TRANSFORM */].CAPITALIZE); } }, "Aa"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isUpperCaseActive, onClick: function () { return onTextTransformChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["l" /* TEXT_TRANSFORM */].UPPERCASE); } }, "AA"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isLowerCaseActive, onClick: function () { return onTextTransformChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["l" /* TEXT_TRANSFORM */].LOWERCASE); } }, "aa"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isSuperScriptActive, onClick: function () { return onTextScriptChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["k" /* TEXT_SCRIPT */].SUPER); } },
                    "A",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* SuperScript */], null, "1")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isSubScriptActive, onClick: function () { return onTextScriptChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["k" /* TEXT_SCRIPT */].SUB); } },
                    "A",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* SubScript */], null, "1")))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Section */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonsWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isTextAlignLeft, onClick: function () { return onTextAlignChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["i" /* TEXT_ALIGN */].LEFT); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_text-align-left')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isTextAlignCenter, onClick: function () { return onTextAlignChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["i" /* TEXT_ALIGN */].CENTER); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_text-align-center')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isTextAlignRight, onClick: function () { return onTextAlignChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["i" /* TEXT_ALIGN */].RIGHT); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_text-align-right')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isTextAlignJustify, onClick: function () { return onTextAlignChange(__WEBPACK_IMPORTED_MODULE_6__RichTextEditor_helpers_constants__["i" /* TEXT_ALIGN */].JUSTIFY); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_text-align-justify'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonsWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isVerticalAlignTop, onClick: function () { return onVerticalAlignChange(''); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_vertical_align_top')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isVerticalAlignCenter, onClick: function () { return onVerticalAlignChange(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["n" /* VerticalAlignClassName */].CENTER); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_vertical_align_center')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Button */], { isActive: isVerticalAlignBottom, onClick: function () { return onVerticalAlignChange(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_constants__["n" /* VerticalAlignClassName */].BOTTOM); } }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_vertical_align_bottom')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Section */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { label: "messages.line_height", value: lineHeight, isLineHeightSelect: true, options: lineHeightOptions, onChange: onLineHeightChange }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { label: "messages.spacing", value: letterSpacing, options: letterSpacingOptions, onChange: onLetterSpacingChange })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Section */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { label: "messages.list_type", value: listType, isListTypeSelect: true, options: listTypeOptions, onChange: onListTypeChange }))));
};
/* harmony default export */ __webpack_exports__["a"] = (TextPanel);


/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Section; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SubScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SuperScript; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Section = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 0 5px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\n\t& + & {\n\t\tmargin-top: 15px;\n\t}\n\n\t>:not(:last-child) {\n\t\tborder-bottom: 1px solid ", ";\n\t}\n"], ["\n\tpadding: 0 5px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\n\t& + & {\n\t\tmargin-top: 15px;\n\t}\n\n\t>:not(:last-child) {\n\t\tborder-bottom: 1px solid ", ";\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 10), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].Grey450, 30));
var ButtonsWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 51px;\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 51px;\n"])));
var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button').attrs({
    type: 'button',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tflex: 1 1 33.33%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 43px;\n\tmargin: 0;\n\tpadding: 0 10px;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 18px;\n\tline-height: 43px;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t& + & {\n\t\tmargin-left: 3px;\n\t}\n\n\tsvg {\n\t\twidth: 23px;\n\t\theight: 24px;\n\t\tfill: currentColor;\n\t}\n\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tflex: 1 1 33.33%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 43px;\n\tmargin: 0;\n\tpadding: 0 10px;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 18px;\n\tline-height: 43px;\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n\n\t& + & {\n\t\tmargin-left: 3px;\n\t}\n\n\tsvg {\n\t\twidth: 23px;\n\t\theight: 24px;\n\t\tfill: currentColor;\n\t}\n\n\t",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : 'transparent';
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 10);
}, function (props) {
    if (props.isBold) {
        return "font-weight: bold;";
    }
    if (props.isItalic) {
        return "\n\t\t\t\tfont-family: Times, 'Times New Roman', serif;\n\t\t\t\tfont-style: italic;\n\t\t\t";
    }
    if (props.isUnderline) {
        return "text-decoration: underline;";
    }
    if (props.isLineThrough) {
        return "text-decoration: line-through;";
    }
    return;
});
var SubScript = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: relative;\n\ttop: 0.35em;\n\tpadding-left: 3px;\n\tfont-size: 60%;\n"], ["\n\tposition: relative;\n\ttop: 0.35em;\n\tpadding-left: 3px;\n\tfont-size: 60%;\n"])));
var SuperScript = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('span')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: relative;\n\ttop: -0.35em;\n\tpadding-left: 2px;\n\tfont-size: 60%;\n"], ["\n\tposition: relative;\n\ttop: -0.35em;\n\tpadding-left: 2px;\n\tfont-size: 60%;\n"])));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_LinkEditor__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(61);



var mapStateToProps = function (state, _a) {
    var page = _a.page, id = _a.id;
    var _b = state.editor, editableLinks = _b.editableLinks, activeItem = _b.activeItem, isEditPanelDisplayed = _b.editPanel.isDisplayed, spreadZoom = _b.spreadZoom;
    var _c = editableLinks[page][id], linkData = _c.linkData, isThemedItem = _c.isThemedItem;
    var editableMediaIds = Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["q" /* getPageEditableMediaIds */])(state, page);
    return {
        linkData: linkData,
        isActive: id === activeItem.id && page === activeItem.page,
        isEditPanelDisplayed: isEditPanelDisplayed,
        hasEditableImage: editableMediaIds.includes(id),
        isThemedItem: isThemedItem,
        spreadZoom: spreadZoom,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_LinkEditor__["a" /* default */]));


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_LinkPanel__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_ThemesPanel__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);









var LinkEditor = function (_a) {
    var page = _a.page, id = _a.id, pageScale = _a.pageScale, spreadZoom = _a.spreadZoom, isActive = _a.isActive, linkData = _a.linkData, isEditPanelDisplayed = _a.isEditPanelDisplayed, hasEditableImage = _a.hasEditableImage, isThemedItem = _a.isThemedItem, dispatch = _a.dispatch;
    if (hasEditableImage) {
        return null;
    }
    var handleClick = function () {
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var handleChange = function (linkData) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["_1" /* updateEditableLink */])(page, id, { linkData: linkData }));
    };
    var renderEditPanel = function () {
        var _a;
        var panels = (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].link] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_LinkPanel__["a" /* default */], { linkData: linkData, onChange: handleChange })),
            _a);
        if (isThemedItem) {
            panels[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].themes] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_ThemesPanel__["a" /* default */], null);
        }
        return (isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].link, panels: panels })));
    };
    var editorClasses = __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getCssClasses(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] + " uprez-link-editor", {
        'is-active': isActive,
        'has-image': hasEditableImage,
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* Wrapper */], { className: editorClasses, isActive: isActive, onClick: handleClick, onTouchEnd: handleClick },
            isActive &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* Border */], { isActive: isActive, borderWidth: Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* IconLink */], { className: "uprez-link-editor-icon", pageScale: pageScale, spreadZoom: spreadZoom }, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_link2'))),
        renderEditPanel()));
};
/* harmony default export */ __webpack_exports__["a"] = (LinkEditor);


/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tcolor: ", ";\n\tpointer-events: auto;\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tcolor: ", ";\n\tpointer-events: auto;\n\n\t", "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Black;
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && 'z-index: 1;';
});
var Border = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var isActive = _a.isActive;
    return isActive ? "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400;
});
var IconLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* PageElementActionButton */])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tsvg {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n"], ["\n\tsvg {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n"])));

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonEditor__ = __webpack_require__(1704);


var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, editableButtons = _a.editableButtons, activeItem = _a.activeItem, isEditPanelDisplayed = _a.editPanel.isDisplayed;
    var page = ownProps.page, id = ownProps.id;
    var _b = editableButtons[page][id], isVisible = _b.isVisible, isThemedItem = _b.isThemedItem, hasLink = _b.hasLink, linkData = _b.linkData, inDesignAction = _b.inDesignAction, isLocked = _b.isLocked;
    return {
        isActive: id === activeItem.id && page === activeItem.page,
        isVisible: isVisible,
        isEditPanelDisplayed: isEditPanelDisplayed,
        isThemedItem: isThemedItem,
        hasLink: hasLink,
        linkData: linkData,
        inDesignAction: inDesignAction,
        isLocked: isLocked,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ButtonEditor__["a" /* default */]));


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_ThemesPanel__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_LinkPanel__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_ActionsPanel__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ActionsPanel__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Editor_utils_indesignEditor_constants__ = __webpack_require__(42);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};











var ButtonState;
(function (ButtonState) {
    ButtonState["NORMAL"] = "NORMAL";
    ButtonState["HOVER"] = "HOVER";
    ButtonState["CLICK"] = "CLICK";
})(ButtonState || (ButtonState = {}));
var STATE_CLASSNAME_MAP = new Map([
    [ButtonState.NORMAL, __WEBPACK_IMPORTED_MODULE_10__containers_Editor_utils_indesignEditor_constants__["c" /* default */].buttonStateClassName + "-Normal"],
    [ButtonState.HOVER, __WEBPACK_IMPORTED_MODULE_10__containers_Editor_utils_indesignEditor_constants__["c" /* default */].buttonStateClassName + "-Rollover"],
    [ButtonState.CLICK, __WEBPACK_IMPORTED_MODULE_10__containers_Editor_utils_indesignEditor_constants__["c" /* default */].buttonStateClassName + "-Click"],
]);
var ButtonEditor = function (_a) {
    var page = _a.page, id = _a.id, isActive = _a.isActive, isVisible = _a.isVisible, pageScale = _a.pageScale, parentContainer = _a.parentContainer, isEditPanelDisplayed = _a.isEditPanelDisplayed, isThemedItem = _a.isThemedItem, hasLink = _a.hasLink, linkData = _a.linkData, inDesignAction = _a.inDesignAction, isLocked = _a.isLocked, dispatch = _a.dispatch;
    var buttonStateElements = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]([]);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"]([]), 2), states = _b[0], setStates = _b[1];
    var _c = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](ButtonState.NORMAL), 2), activeState = _c[0], setActiveState = _c[1];
    var handleClick = function () {
        if (!isThemedItem && !hasLink) {
            return;
        }
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var handleActionsPanelClick = function () {
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
        }
    };
    var handleChange = function (linkData) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["Y" /* updateEditableButton */])(page, id, { linkData: linkData }));
    };
    var renderEditPanel = function () {
        var editPanels = {};
        if (hasLink) {
            editPanels[__WEBPACK_IMPORTED_MODULE_9__containers_Editor_constants__["c" /* EditableType */].link] = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_LinkPanel__["a" /* default */], { linkData: linkData, canAddPopupAction: true, onChange: handleChange }));
        }
        if (isThemedItem) {
            editPanels[__WEBPACK_IMPORTED_MODULE_9__containers_Editor_constants__["c" /* EditableType */].themes] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_ThemesPanel__["a" /* default */], null);
        }
        return (hasLink || isThemedItem) && isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: hasLink ? __WEBPACK_IMPORTED_MODULE_9__containers_Editor_constants__["c" /* EditableType */].link : __WEBPACK_IMPORTED_MODULE_9__containers_Editor_constants__["c" /* EditableType */].themes, panels: editPanels }));
    };
    var getActions = function () {
        var actions = [];
        if (!isLocked) {
            actions.push({
                type: __WEBPACK_IMPORTED_MODULE_6__ActionsPanel__["a" /* ActionType */].TOGGLE_VISIBILITY,
                onClick: function () {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["Y" /* updateEditableButton */])(page, id, {
                        isVisible: !isVisible,
                    }));
                },
                isInverted: !isVisible,
            });
            if (hasLink) {
                actions.push({
                    type: __WEBPACK_IMPORTED_MODULE_6__ActionsPanel__["a" /* ActionType */].EDIT_LINK,
                    onClick: function () {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
                    },
                    isDisabled: !isVisible,
                });
            }
            if (states.length > 1) {
                actions.push({
                    type: __WEBPACK_IMPORTED_MODULE_6__ActionsPanel__["a" /* ActionType */].TOGGLE_BUTTON_STATE,
                    onClick: function () {
                        var currentStateIndex = states.indexOf(activeState);
                        var isLastState = currentStateIndex === states.length - 1;
                        var nextState = isLastState ? states[0] : states[currentStateIndex + 1];
                        setActiveState(nextState);
                    },
                    isDisabled: !isVisible,
                });
            }
        }
        if (inDesignAction) {
            actions.push({
                type: __WEBPACK_IMPORTED_MODULE_6__ActionsPanel__["a" /* ActionType */].RUN_INDESIGN_ACTION,
                onClick: function () {
                    if (!isVisible) {
                        return;
                    }
                    new Function(inDesignAction)();
                    // tslint:disable-next-line: max-line-length
                    // Timeout is needed to give inDesign scripts time to apply changes to DOM (change classes). MutationObserver on button can't be used because in some cases inDesign scripts change class on button's parent element (e.g., add class to hide it and its content) or on another element which is located above or below button in DOM (e.g., add class to show hidden content)
                    var DELAY_TO_HIDE = 300;
                    setTimeout(function () {
                        if (Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_utils_helpers__["Z" /* isElementOverlapped */])(parentContainer) || Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_utils_helpers__["Y" /* isElementHidden */])(parentContainer)) {
                            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["A" /* resetActiveItem */])());
                        }
                    }, DELAY_TO_HIDE);
                },
                isDisabled: !isVisible,
            });
        }
        return actions;
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isVisible) {
            parentContainer.removeAttribute('data-hidden');
        }
        else {
            parentContainer.setAttribute('data-hidden', 'true');
        }
    }, [isVisible]);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        // do not cut actions button
        parentContainer.style.overflow = 'visible';
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        var e_1, _a;
        buttonStateElements.current = __spread(parentContainer.querySelectorAll("[class*=" + __WEBPACK_IMPORTED_MODULE_10__containers_Editor_utils_indesignEditor_constants__["c" /* default */].buttonStateClassName + "]"));
        if (buttonStateElements.current.length < 2) {
            return;
        }
        var states = [];
        var _loop_1 = function (state, className) {
            var buttonStateElement = buttonStateElements.current.find(function (_a) {
                var classList = _a.classList;
                return classList.contains(className);
            });
            if (buttonStateElement) {
                states.push(state);
            }
        };
        try {
            for (var STATE_CLASSNAME_MAP_1 = __values(STATE_CLASSNAME_MAP), STATE_CLASSNAME_MAP_1_1 = STATE_CLASSNAME_MAP_1.next(); !STATE_CLASSNAME_MAP_1_1.done; STATE_CLASSNAME_MAP_1_1 = STATE_CLASSNAME_MAP_1.next()) {
                var _b = __read(STATE_CLASSNAME_MAP_1_1.value, 2), state = _b[0], className = _b[1];
                _loop_1(state, className);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (STATE_CLASSNAME_MAP_1_1 && !STATE_CLASSNAME_MAP_1_1.done && (_a = STATE_CLASSNAME_MAP_1.return)) _a.call(STATE_CLASSNAME_MAP_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        setStates(states);
        setActiveState(states[0]);
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (states.length < 2) {
            return;
        }
        var activeStateClassName = STATE_CLASSNAME_MAP.get(activeState);
        buttonStateElements.current.forEach(function (stateElement) {
            var visibilityStyle = stateElement.classList.contains(activeStateClassName)
                ? 'visible'
                : 'hidden';
            stateElement.style.visibility = visibilityStyle;
        });
    }, [states, activeState]);
    var actions = getActions();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* Wrapper */], { className: __WEBPACK_IMPORTED_MODULE_9__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* EditorToggle */], { isVisible: isVisible, onClick: handleClick, onTouchEnd: handleClick }),
            (isActive || !isVisible) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* Border */], { borderWidth: Object(__WEBPACK_IMPORTED_MODULE_7__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale), isActive: isActive }),
            actions.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_Editor_ActionsPanel__["a" /* default */], { actions: actions, pageScale: pageScale, onToggle: handleActionsPanelClick })),
        renderEditPanel()));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonEditor);


/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ActionsPanel__ = __webpack_require__(376);


var mapStateToProps = function (state) {
    var _a = state.editor, spreadZoom = _a.spreadZoom, activeItem = _a.activeItem;
    return {
        spreadZoom: spreadZoom,
        id: activeItem.id,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ActionsPanel__["b" /* default */]));


/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Panel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PanelInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconMove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var Toggle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* PageElementActionButton */])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n"], ["\n\tbackground-color: ", ";\n"])), function (_a) {
    var isOpened = _a.isOpened;
    return isOpened ? __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Blue450 : __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black;
});
var Panel = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\twidth: 50px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tbox-shadow: 0 2px 14px 0 ", ";\n\tcursor: default;\n"], ["\n\tbox-sizing: border-box;\n\twidth: 50px;\n\tborder-radius: 8px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tbox-shadow: 0 2px 14px 0 ", ";\n\tcursor: default;\n"])), __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Grey1000, __WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].Black, 32));
var PanelInner = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding: 6px;\n"], ["\n\tpadding: 6px;\n"])));
var IconMove = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 22px;\n\tmargin: 0 auto;\n\tcursor: move;\n\n\tsvg {\n\t\twidth: 19px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t\ttransform: rotate(90deg);\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 22px;\n\tmargin: 0 auto;\n\tcursor: move;\n\n\tsvg {\n\t\twidth: 19px;\n\t\theight: 18px;\n\t\tfill: ", ";\n\t\ttransform: rotate(90deg);\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_2__utils_styles_constants__["b" /* NewStyleColor */].White, 35));

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;


/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1708);




var getIcons = function (type) {
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ActionType */].EDIT_LINK:
            return {
                icon: {
                    name: 'iconset_uprez_link2',
                    width: '22px',
                    height: '22px',
                },
            };
        case __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ActionType */].RUN_INDESIGN_ACTION:
            return {
                icon: {
                    name: 'iconset_uprez_pointer',
                    width: '16px',
                    height: '19px',
                },
            };
        case __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ActionType */].TOGGLE_BUTTON_STATE:
            return {
                icon: {
                    name: 'iconset_uprez_multistate',
                    width: '18px',
                    height: '19px',
                },
            };
        case __WEBPACK_IMPORTED_MODULE_2__index__["a" /* ActionType */].TOGGLE_VISIBILITY:
            return {
                icon: {
                    name: 'iconset_uprez_eye',
                    width: '21px',
                    height: '14px',
                },
                invertedIcon: {
                    name: 'iconset_uprez_eye_crossed',
                    width: '21px',
                    height: '17px',
                },
            };
    }
};
var ActionButton = function (_a) {
    var type = _a.type, onClick = _a.onClick, isInverted = _a.isInverted, isDisabled = _a.isDisabled;
    var _b = getIcons(type), icon = _b.icon, invertedIcon = _b.invertedIcon;
    var _c = isInverted ? invertedIcon : icon, name = _c.name, width = _c.width, height = _c.height;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { iconWidth: width, iconHeight: height, isInverted: isInverted, disabled: isDisabled, onClick: onClick }, __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* default */].getSvgIcon(name)));
};
/* harmony default export */ __webpack_exports__["a"] = (ActionButton);


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var Button = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div').attrs({
    type: 'button',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 38px;\n\theight: 38px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t", "\n\n\t& + & {\n\t\tmargin-top: 6px;\n\t}\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 38px;\n\theight: 38px;\n\tpadding: 0;\n\tborder: 0;\n\tborder-radius: 6px;\n\toutline: 0;\n\tbackground-color: ",
    ";\n\tcolor: ", ";\n\tcursor: pointer;\n\n\t",
    "\n\n\t& + & {\n\t\tmargin-top: 6px;\n\t}\n\n\tsvg {\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tfill: currentColor;\n\t}\n"])), function (_a) {
    var isActive = _a.isActive, isInverted = _a.isInverted;
    if (isActive) {
        return __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue450;
    }
    if (isInverted) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 20);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 10);
}, __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n\t\tcursor: default;\n\t\topacity: 0.5;\n\t";
}, function (_a) {
    var iconWidth = _a.iconWidth;
    return iconWidth;
}, function (_a) {
    var iconHeight = _a.iconHeight;
    return iconHeight;
});

var templateObject_1;


/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditorToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\n\t/* hide all button's children except editor */\n\t/* DO NOT ADD any prop to this component as it will create a new className and break this rule */\n\t._idGenButton[data-hidden] > :not(&) {\n\t\tdisplay: none;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\n\t/* hide all button's children except editor */\n\t/* DO NOT ADD any prop to this component as it will create a new className and break this rule */\n\t._idGenButton[data-hidden] > :not(&) {\n\t\tdisplay: none;\n\t}\n"])));
var EditorToggle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n\n\t", "\n"])), function (_a) {
    var isVisible = _a.isVisible;
    return isVisible && 'z-index: -1;';
});
var Border = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", ";\n\tborder-radius: inherit;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", ";\n\tborder-radius: inherit;\n"])), function (_a) {
    var borderWidth = _a.borderWidth, isActive = _a.isActive;
    return borderWidth + "px solid " + (isActive ? __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400);
});

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_IframeEditor__ = __webpack_require__(1711);


var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, editableIframes = _a.editableIframes, activeItem = _a.activeItem, isEditPanelDisplayed = _a.editPanel.isDisplayed;
    var page = ownProps.page, id = ownProps.id;
    var _b = editableIframes[page][id], src = _b.src, isVisible = _b.isVisible;
    return {
        src: src,
        isActive: id === activeItem.id && page === activeItem.page,
        isVisible: isVisible,
        isEditPanelDisplayed: isEditPanelDisplayed,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_IframeEditor__["a" /* default */]));


/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_IframePanel__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_VisibilityToggle__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1714);








var IframeEditor = function (_a) {
    var page = _a.page, id = _a.id, src = _a.src, isActive = _a.isActive, isVisible = _a.isVisible, pageScale = _a.pageScale, isEditPanelDisplayed = _a.isEditPanelDisplayed, parentContainer = _a.parentContainer, dispatch = _a.dispatch;
    var handleClick = function () {
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var handleVisibilityToggle = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["_0" /* updateEditableIframe */])(page, id, {
            isVisible: !isVisible,
        }));
    };
    var renderEditPanel = function () {
        var _a;
        return (isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].iframe, panels: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].iframe] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_IframePanel__["a" /* default */], { page: page }),
                _a) })));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        parentContainer.style.overflow = 'visible';
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledIframeEditor */], { className: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */], onClick: handleClick, onTouchEnd: handleClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("iframe", { src: src, hidden: !isVisible }),
            (isActive || !isVisible) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* Border */], { isActive: isActive, borderWidth: Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_VisibilityToggle__["a" /* default */], { isVisible: isVisible, isParentActive: isActive, pageScale: pageScale, onToggle: handleVisibilityToggle }),
        renderEditPanel()));
};
/* harmony default export */ __webpack_exports__["a"] = (IframeEditor);


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_IframePanel__ = __webpack_require__(1713);


var mapStateToProps = function (state, _a) {
    var page = _a.page;
    var _b = state.editor, id = _b.activeItem.id, editableIframes = _b.editableIframes;
    var _c = editableIframes[page][id], src = _c.src, defaultSrc = _c.defaultSrc;
    return {
        page: page,
        id: id,
        src: src,
        defaultSrc: defaultSrc,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_IframePanel__["a" /* default */]));


/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_LinkPanel__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__ = __webpack_require__(8);






var IframePanel = function (_a) {
    var page = _a.page, id = _a.id, src = _a.src, defaultSrc = _a.defaultSrc, dispatch = _a.dispatch;
    var handleChange = function (linkData) {
        var newSrc = linkData.data.href;
        if (newSrc !== src) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__["_0" /* updateEditableIframe */])(page, id, {
                src: newSrc,
            }));
        }
    };
    var handleResetClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__["_0" /* updateEditableIframe */])(page, id, {
            src: defaultSrc,
        }));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_LinkPanel__["a" /* default */], { linkData: Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__["s" /* getLinkUrlData */])(src), onChange: handleChange, isUrlLinkOnly: true }),
        src !== defaultSrc &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */], { type: "button", onClick: handleResetClick },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.reset_to_default" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (IframePanel);


/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledIframeEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledIframeEditor = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n\n\tiframe {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tpointer-events: none;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n\n\tiframe {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tpointer-events: none;\n\t}\n"])));
var Border = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var isActive = _a.isActive;
    return isActive ? "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400;
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EnrichmentEditor__ = __webpack_require__(1716);


var mapStateToProps = function (state, ownProps) {
    var _a = state.editor, editableEnrichments = _a.editableEnrichments, activeItem = _a.activeItem, isEditPanelDisplayed = _a.editPanel.isDisplayed;
    var page = ownProps.page, id = ownProps.id;
    var _b = editableEnrichments[page][id], type = _b.type, isThemedItem = _b.isThemedItem;
    return {
        type: type,
        isActive: id === activeItem.id && page === activeItem.page,
        isEditPanelDisplayed: isEditPanelDisplayed,
        isThemedItem: isThemedItem,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EnrichmentEditor__["a" /* default */]));


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_EnrichmentPanel__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_ThemesPanel__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1719);








var EnrichmentEditor = function (_a) {
    var page = _a.page, id = _a.id, type = _a.type, isActive = _a.isActive, pageScale = _a.pageScale, isEditPanelDisplayed = _a.isEditPanelDisplayed, isThemedItem = _a.isThemedItem, dispatch = _a.dispatch;
    var handleClick = function () {
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var renderEditPanel = function () {
        var _a;
        var panels = (_a = {},
            _a[type] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_EnrichmentPanel__["a" /* default */], { page: page }),
            _a);
        if (isThemedItem) {
            panels[__WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__["c" /* EditableType */].themes] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_ThemesPanel__["a" /* default */], null);
        }
        return (isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: type, panels: panels })));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledEnrichmentEditor */], { className: __WEBPACK_IMPORTED_MODULE_6__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */], onClick: handleClick, onTouchEnd: handleClick }, isActive &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* Border */], { borderWidth: Object(__WEBPACK_IMPORTED_MODULE_5__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) })),
        renderEditPanel()));
};
/* harmony default export */ __webpack_exports__["a"] = (EnrichmentEditor);


/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_EnrichmentPanel__ = __webpack_require__(1718);


var mapStateToProps = function (state, _a) {
    var page = _a.page;
    var _b = state.editor, id = _b.activeItem.id, editableEnrichments = _b.editableEnrichments, byId = state.importManager.byId;
    var _c = editableEnrichments[page][id], resource = _c.resource, defaultResource = _c.defaultResource, importManagerId = _c.importManagerId;
    return {
        page: page,
        id: id,
        resource: resource,
        defaultResource: defaultResource,
        importManagerId: importManagerId,
        isImporting: !!byId[importManagerId],
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_EnrichmentPanel__["a" /* default */]));


/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourcePanel__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_LinkPanel__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__ = __webpack_require__(8);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;







var getIconName = function (type) {
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].AssetItemFileTypes.PUBLICATION:
            return 'iconset_page-bold';
        case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].AssetItemFileTypes.IMAGE:
            return 'iconset_uprez_image';
        case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].AssetItemFileTypes.MOVIE:
            return 'iconset_uprez_video';
        case __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].AssetItemFileTypes.COMPONENT:
            return 'iconset_template-bold';
        default:
            return 'iconset_uprez_file';
    }
};
var EnrichmentPanel = function (_a) {
    var page = _a.page, id = _a.id, resource = _a.resource, _b = _a.resource, label = _b.label, type = _b.type, relUrl = _b.relUrl, externalRelUrl = _b.externalRelUrl, isExternalLink = _b.isExternalLink, defaultResource = _a.defaultResource, importManagerId = _a.importManagerId, isImporting = _a.isImporting, dispatch = _a.dispatch;
    var handleResourceSelect = function (driveItem) { return __awaiter(_this, void 0, void 0, function () {
        var aspDriveItem, globalId, genericItemId, parentDriveGId, label_1, type_1, relUrl_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_DriveItemList_actions__["k" /* getAspDriveItem */])(driveItem.id))];
                case 1:
                    aspDriveItem = _a.sent();
                    if (aspDriveItem) {
                        globalId = aspDriveItem.globalId, genericItemId = aspDriveItem.genericItemId, parentDriveGId = aspDriveItem.parentDriveGId, label_1 = aspDriveItem.label, type_1 = aspDriveItem.type, relUrl_1 = aspDriveItem.relUrl;
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["Z" /* updateEditableEnrichment */])(page, id, {
                            resource: __assign({}, resource, { globalId: globalId,
                                genericItemId: genericItemId,
                                parentDriveGId: parentDriveGId,
                                label: label_1,
                                type: type_1,
                                relUrl: relUrl_1, deps: Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["j" /* getDependencyString */])(globalId), isExternalLink: false }),
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleExternalLinkChange = function (value) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["Z" /* updateEditableEnrichment */])(page, id, {
            resource: __assign({}, resource, { globalId: null, genericItemId: null, parentDriveGId: null, label: '', type: __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].AssetItemFileTypes.DEFAULT, relUrl: '', externalRelUrl: value.data.href, deps: undefined, isExternalLink: true }),
        }));
    };
    var handleResourceReset = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_Editor_actions__["Z" /* updateEditableEnrichment */])(page, id, {
            resource: defaultResource,
        }));
    };
    var defaultRelUrl = defaultResource.isExternalLink
        ? defaultResource.externalRelUrl
        : defaultResource.relUrl;
    var isDefaultResource = (isExternalLink ? externalRelUrl : relUrl) === defaultRelUrl;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ResourcePanel__["a" /* default */], { iconName: getIconName(type), label: isDefaultResource ? 'messages.default_file' : label, importManagerId: importManagerId, isImporting: isImporting, isResetButtonDisplayed: !isDefaultResource, isExternalLinkActive: isExternalLink, linkPanel: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_EditPanel_LinkPanel__["a" /* default */], { linkData: Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["s" /* getLinkUrlData */])(externalRelUrl), onChange: handleExternalLinkChange, isUrlLinkOnly: true })), dispatch: dispatch, onResourceSelect: handleResourceSelect, onResourceReset: handleResourceReset }));
};
/* harmony default export */ __webpack_exports__["a"] = (EnrichmentPanel);


/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledEnrichmentEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledEnrichmentEditor = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n"])));
var Border = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", ";\n\tborder-radius: inherit;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", ";\n\tborder-radius: inherit;\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100;
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_SliderEditor__ = __webpack_require__(1721);


var mapStateToProps = function (state, _a) {
    var page = _a.page, id = _a.id;
    var _b = state.editor, editableSliders = _b.editableSliders, activeItem = _b.activeItem, isEditPanelDisplayed = _b.editPanel.isDisplayed;
    var isVisible = editableSliders[page][id].isVisible;
    return {
        isActive: id === activeItem.id && page === activeItem.page,
        isVisible: isVisible,
        isEditPanelDisplayed: isEditPanelDisplayed,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_SliderEditor__["a" /* default */]));


/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SliderPanel__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_VisibilityToggle__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);









var SliderEditor = function (_a) {
    var page = _a.page, id = _a.id, isActive = _a.isActive, isVisible = _a.isVisible, pageScale = _a.pageScale, isEditPanelDisplayed = _a.isEditPanelDisplayed, parentContainer = _a.parentContainer, dispatch = _a.dispatch;
    var handleClick = function () {
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var handleVisibilityToggle = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["_3" /* updateEditableSlider */])(page, id, {
            isVisible: !isVisible,
        }, true, true, true));
    };
    var renderEditPanel = function () {
        var _a;
        return (isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].slider, panels: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].slider] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_SliderPanel__["a" /* default */], { page: page }),
                _a) })));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        parentContainer.style.overflow = 'visible';
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* StyledSliderEditor */], { className: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */], isVisible: isVisible, onClick: handleClick, onTouchEnd: handleClick },
            isVisible &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* IconWrapper */], null, __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* default */].getSvgIcon('iconset_uprez_slider')),
            (isActive || !isVisible) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* Border */], { isActive: isActive, borderWidth: Object(__WEBPACK_IMPORTED_MODULE_6__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Editor_VisibilityToggle__["a" /* default */], { isVisible: isVisible, isParentActive: isActive, pageScale: pageScale, onToggle: handleVisibilityToggle }),
        renderEditPanel()));
};
/* harmony default export */ __webpack_exports__["a"] = (SliderEditor);


/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderPanel__ = __webpack_require__(1723);


var mapStateToProps = function (state, _a) {
    var page = _a.page;
    var _b = state.editor, id = _b.activeItem.id, pagesData = _b.configs.pagesData, editableSliders = _b.editableSliders;
    var _c = editableSliders[page][id], idInConfigs = _c.idInConfigs, deps = _c.deps, importingSlides = _c.importingSlides, width = _c.width, height = _c.height;
    var sliders = pagesData[page - 1].sliders;
    var sliderData = sliders[idInConfigs];
    var slides = 'slides' in sliderData ? sliderData.slides : sliderData;
    var settings = 'settings' in sliderData ? sliderData.settings : undefined;
    return {
        page: page,
        id: id,
        idInConfigs: idInConfigs,
        slides: slides,
        importingSlides: importingSlides,
        deps: deps,
        sliderWidth: width,
        sliderHeight: height,
        shouldScaleImage: settings && !!settings.scaleImage,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderPanel__["a" /* default */]));


/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_EditPanel_SliderPanel_Slide__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_SliderManager__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__ = __webpack_require__(14);




var SliderPanel = function (_a) {
    var page = _a.page, id = _a.id, idInConfigs = _a.idInConfigs, slides = _a.slides, importingSlides = _a.importingSlides, deps = _a.deps, sliderWidth = _a.sliderWidth, sliderHeight = _a.sliderHeight, shouldScaleImage = _a.shouldScaleImage, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel_SliderManager__["a" /* default */], { page: page, id: id, idInConfigs: idInConfigs, slides: slides, importingSlides: importingSlides, deps: deps, SlideComponent: __WEBPACK_IMPORTED_MODULE_1__containers_Editor_EditPanel_SliderPanel_Slide__["a" /* default */], sliderWidth: sliderWidth, sliderHeight: sliderHeight, shouldScaleImage: shouldScaleImage, onImportSlides: function (page, id, idInConfigs, newSlidesData, isFromDesktop) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["o" /* importSlides */])(page, id, idInConfigs, newSlidesData, isFromDesktop)); }, onUpdateSliderConfig: function (page, id, data) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["_4" /* updateEditableSliderConfig */])(page, id, data)); }, onUpdateSliderElement: function (page, id, data, shouldSave, isFirstSlideChanged) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Editor_actions__["_3" /* updateEditableSlider */])(page, id, data, shouldSave, isFirstSlideChanged)); } }));
};
/* harmony default export */ __webpack_exports__["a"] = (SliderPanel);


/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderManager_Slide__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);



var mapStateToProps = function (state, ownProps) {
    var editableSliders = state.editor.editableSliders, config = state.galleryInfos.config, importManager = state.importManager;
    var page = ownProps.page, sliderId = ownProps.sliderId, item = ownProps.item;
    var iconName = item.iconName, relUrl = item.relUrl, externalRelUrl = item.externalRelUrl, isExternalLink = item.isExternalLink;
    var importingSlides = editableSliders[page][sliderId].importingSlides;
    var previewUrl = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["F" /* getSliderPreviewUrl */])(config, relUrl, isExternalLink, externalRelUrl, iconName);
    var importData = importManager.byId[item.id];
    return {
        page: page,
        previewUrl: previewUrl,
        isImporting: importingSlides.map(function (_a) {
            var id = _a.id;
            return id;
        }).includes(item.id),
        importPercentage: importData ? importData.percentage : 0,
        importError: importData ? importData.error : undefined,
        isDragDisabled: importingSlides.length > 0,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_EditPanel_SliderManager_Slide__["a" /* default */]));


/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledSliderEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledSliderEditor = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n\n\t", "\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n\n\t",
    "\n"])), function (_a) {
    var isVisible = _a.isVisible;
    return isVisible && "\n\t\tbackground-color: " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey200 + ";\n\t";
});
var IconWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 30%;\n\tmax-width: 150px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 100%;\n\t\tfill: currentColor;\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 30%;\n\tmax-width: 150px;\n\tcolor: ", ";\n\n\tsvg {\n\t\twidth: 100%;\n\t\tfill: currentColor;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400);
var Border = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", "\n\t\tsolid\n\t\t", ";\n\tborder-radius: inherit;\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px";
}, function (_a) {
    var isActive = _a.isActive;
    return isActive ? "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100 : "" + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Grey400;
});

var templateObject_1, templateObject_2, templateObject_3;


/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ThemedItemEditor__ = __webpack_require__(1727);


var mapStateToProps = function (state, _a) {
    var page = _a.page, id = _a.id;
    var _b = state.editor, activeItem = _b.activeItem, isEditPanelDisplayed = _b.editPanel.isDisplayed;
    return {
        isActive: id === activeItem.id && page === activeItem.page,
        isEditPanelDisplayed: isEditPanelDisplayed,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ThemedItemEditor__["a" /* default */]));


/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_ThemesPanel__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1728);







var ThemedItemEditor = function (_a) {
    var page = _a.page, id = _a.id, isActive = _a.isActive, pageScale = _a.pageScale, isEditPanelDisplayed = _a.isEditPanelDisplayed, dispatch = _a.dispatch;
    var handleClick = function () {
        if (!isActive) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["K" /* setActiveItem */])(id, page, null));
            if (!isEditPanelDisplayed) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__containers_Editor_actions__["U" /* toggleEditPanel */])());
            }
        }
    };
    var renderEditPanel = function () {
        var _a;
        return (isActive && isEditPanelDisplayed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Editor_EditPanel__["a" /* default */], { defaultType: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].themes, panels: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["c" /* EditableType */].themes] = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Editor_EditPanel_ThemesPanel__["a" /* default */], null),
                _a) })));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* StyledThemedItemEditor */], { className: __WEBPACK_IMPORTED_MODULE_5__containers_Editor_constants__["f" /* IGNORE_PAGE_CLICK_CLASSNAME */], onClick: handleClick, onTouchEnd: handleClick }, isActive &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* Border */], { borderWidth: Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_utils_helpers__["e" /* getBorderWidth */])(pageScale) })),
        renderEditPanel()));
};
/* harmony default export */ __webpack_exports__["a"] = (ThemedItemEditor);


/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledThemedItemEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var StyledThemedItemEditor = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpointer-events: auto;\n"])));
var Border = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", ";\n\tborder-radius: inherit;\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tborder: ", ";\n\tborder-radius: inherit;\n"])), function (_a) {
    var borderWidth = _a.borderWidth;
    return borderWidth + "px solid " + __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].Blue100;
});

var templateObject_1, templateObject_2;


/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_PreviewPagesSpread__ = __webpack_require__(1730);


var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.pagesController, spreads = _b.spreads, currentSpreadIndex = _b.currentSpreadIndex, spreadZoom = _a.spreadZoom;
    return {
        spread: spreads[currentSpreadIndex],
        zoom: spreadZoom,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_PreviewPagesSpread__["a" /* default */]));


/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Editor_PreviewPagesSpread_PreviewPage__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(641);



var PreviewPagesSpread = function (_a) {
    var spread = _a.spread, zoom = _a.zoom;
    var pageContainer = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var handleLoad = function () {
        if (pageContainer.current) {
            pageContainer.current.scrollIntoView();
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Wrapper */], { ref: pageContainer, zoom: zoom }, spread.map(function (page) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_Editor_PreviewPagesSpread_PreviewPage__["a" /* default */], { key: page, page: page, onLoad: handleLoad })); })));
};
/* harmony default export */ __webpack_exports__["a"] = (PreviewPagesSpread);


/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_PreviewPagesSpread_PreviewPage__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_url__ = __webpack_require__(26);




var mapStateToProps = function (state, _a) {
    var page = _a.page;
    var config = state.galleryInfos.config, _b = state.editor, imagePath = _b.paths.imagePath, version = _b.version;
    var resourceId = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])().tempGId;
    return {
        src: __WEBPACK_IMPORTED_MODULE_3__utils_url__["b" /* default */].getEditorResourceUrl(config, resourceId, Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["w" /* getPageHtmlPath */])(imagePath, page) + "?version=" + version),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_PreviewPagesSpread_PreviewPage__["a" /* default */]));


/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_NotificationBar_actions__ = __webpack_require__(15);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _this = this;




var PreviewPage = function (_a) {
    var src = _a.src, onLoad = _a.onLoad, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isError = _b[0], setError = _b[1];
    var handleError = function () { return __awaiter(_this, void 0, void 0, function () {
        var status_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* default */].promiseXHR('GET', src)];
                case 2:
                    status_1 = (_a.sent()).status;
                    if (status_1 === 200) {
                        setError(false);
                    }
                    else {
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__containers_NotificationBar_actions__["c" /* createNotification */])('error.fetch_editor_data_error'));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (isError) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* PreviewPageWrapper */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: src, onLoad: onLoad, onError: handleError })));
};
/* harmony default export */ __webpack_exports__["a"] = (PreviewPage);


/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_ProcessingLoader__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(8);




var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.combo, isCombining = _b.isCombining, combiningPercentage = _b.percentage, pdfImportingStatus = _a.settings.pdfImportingStatus, isUpdating = _a.preprodPublication.isUpdating, importManager = state.importManager;
    var resourceId = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["g" /* getClientAndResourceIds */])().tempGId;
    var percentage;
    if (isCombining) {
        percentage = combiningPercentage;
    }
    if (pdfImportingStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* PdfImportingStatus */].PROCESSING) {
        var importId = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["y" /* getPublicationPdfImportingId */])(resourceId, __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* PdfImportingStatus */].PROCESSING);
        var importData = importManager.byId[importId];
        percentage = importData ? importData.percentage : 0;
    }
    var type;
    if (isCombining) {
        type = __WEBPACK_IMPORTED_MODULE_1__components_Editor_ProcessingLoader__["a" /* ProcessingLoaderType */].COMBINING;
    }
    else if (isUpdating) {
        type = __WEBPACK_IMPORTED_MODULE_1__components_Editor_ProcessingLoader__["a" /* ProcessingLoaderType */].PUBLISHING_OR_UPDATING;
    }
    else {
        type = __WEBPACK_IMPORTED_MODULE_1__components_Editor_ProcessingLoader__["a" /* ProcessingLoaderType */].PDF_PROCESSING;
    }
    return {
        type: type,
        percentage: percentage,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_ProcessingLoader__["b" /* default */]));


/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessingLoaderType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner__ = __webpack_require__(353);




var ProcessingLoaderType;
(function (ProcessingLoaderType) {
    ProcessingLoaderType["COMBINING"] = "COMBINING";
    ProcessingLoaderType["PDF_PROCESSING"] = "PDF_PROCESSING";
    ProcessingLoaderType["PUBLISHING_OR_UPDATING"] = "PUBLISHING_OR_UPDATING";
})(ProcessingLoaderType || (ProcessingLoaderType = {}));
var getLabel = function (type) {
    switch (type) {
        case ProcessingLoaderType.COMBINING:
            return 'messages.combining';
        case ProcessingLoaderType.PDF_PROCESSING:
            return 'messages.pdf_processing';
        case ProcessingLoaderType.PUBLISHING_OR_UPDATING:
            return '';
        default:
            return 'messages.loading';
    }
};
var ProcessingLoader = function (_a) {
    var type = _a.type, percentage = _a.percentage;
    if (type === ProcessingLoaderType.PUBLISHING_OR_UPDATING) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* Loader */], { isProcessing: true });
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* Loader */], { isProcessing: true },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Spinner__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: getLabel(type), percentage: percentage.toString() })));
};
/* harmony default export */ __webpack_exports__["b"] = (ProcessingLoader);


/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Editor_LockedEditorPopup__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__ = __webpack_require__(11);




var mapStateToProps = function (state) {
    var _a = state.editor, _b = _a.lockedEditorPopup, isDisplayed = _b.isDisplayed, userName = _b.userName, parentFolderId = _a.parentFolderId, driveItems = state.driveList.driveItems;
    var _c = Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* getClientAndResourceIds */])(), tempGId = _c.tempGId, originalGId = _c.originalGId;
    var driveItem = driveItems[tempGId] || driveItems[originalGId];
    return {
        isDisplayed: isDisplayed,
        userName: userName,
        parentId: parentFolderId,
        isProposal: driveItem && __WEBPACK_IMPORTED_MODULE_3__utils_driveItem__["d" /* default */].isProposal(driveItem.format),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_Editor_LockedEditorPopup__["a" /* default */]));


/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routes__ = __webpack_require__(13);






var LockedEditorPopup = function (_a) {
    var isDisplayed = _a.isDisplayed, userName = _a.userName, parentId = _a.parentId, isProposal = _a.isProposal, dispatch = _a.dispatch;
    var handleCancelClick = function () {
        __WEBPACK_IMPORTED_MODULE_5__utils_routes__["a" /* default */].redirectToParentDir(parentId);
    };
    var popupFooter = {
        label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.unlock'),
        onAccept: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__containers_Editor_actions__["a" /* acquireLock */])()); },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* default */], { isDisplayed: isDisplayed, label: __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.notification'), onCancel: handleCancelClick, footer: popupFooter, theme: __WEBPACK_IMPORTED_MODULE_2__Popup__["a" /* PopupTheme */].DARK },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* PopupBodyWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: isProposal ? 'messages.proposal_locked' : 'messages.publication_locked', userName: userName || __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["I18n"].t('messages.another_user').toLowerCase() }))));
};
/* harmony default export */ __webpack_exports__["a"] = (LockedEditorPopup);


/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopupBodyWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var PopupBodyWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 15px;\n\tcolor: ", ";\n\ttext-align: center;\n"], ["\n\tpadding: 15px;\n\tcolor: ", ";\n\ttext-align: center;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["b" /* NewStyleColor */].White, 75));

var templateObject_1;


/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage__ = __webpack_require__(1739);


var mapStateToProps = function (state) {
    var _a = state.proposalStats, proposalStatus = _a.proposalStatus, _b = _a.paginator, page = _b.page, totalPages = _b.totalPages, allIds = _a.allIds, isLoading = _a.isLoading;
    return {
        proposalStatus: proposalStatus,
        page: page,
        totalPages: totalPages,
        isResetNeeded: page === 0 && allIds.length === 0,
        isLoading: isLoading,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage__["a" /* default */]));


/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toggle__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProposalStatsPage_Table__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1);
var _a;











var proposalStatusConfig = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].ProposalStatus.SEEN] = {
        id: __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].ProposalStatus.SEEN,
        label: 'messages.status_read',
    },
    _a[__WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].ProposalStatus.SENT] = {
        id: __WEBPACK_IMPORTED_MODULE_9__typings_api__["a" /* Api */].ProposalStatus.SENT,
        label: 'messages.unread',
    },
    _a);
var ProposalStatsPage = function (_a) {
    var proposalStatus = _a.proposalStatus, page = _a.page, totalPages = _a.totalPages, isResetNeeded = _a.isResetNeeded, isLoading = _a.isLoading, dispatch = _a.dispatch;
    var tableContainer = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var hasMoreItems = !isLoading && page + 1 < totalPages;
    var isLoaderDisplayed = isLoading && page === 0;
    var loadMoreItems = function () {
        if (hasMoreItems) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__["b" /* getProposals */])(page + 1));
        }
    };
    var handleProposalStatusChange = function (proposalStatus) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__["e" /* setProposalStatus */])(proposalStatus));
    };
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__["b" /* getProposals */])());
        return function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__["d" /* reset */])());
        };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (isResetNeeded && tableContainer.current) {
            tableContainer.current.scrollTop = 0;
        }
    }, [isResetNeeded]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_4__containers_Page_constants__["a" /* PageType */].ProposalStatsPage, title: "messages.my_sent" },
        isLoaderDisplayed &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* Loader */], null,
                __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.loading" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Toggle__["a" /* default */], { items: Object.values(proposalStatusConfig), activeId: proposalStatus, onItemClick: handleProposalStatusChange, width: "110px" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* TableWrapper */], { ref: tableContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__, { initialLoad: false, hasMore: hasMoreItems, loadMore: loadMoreItems, useWindow: false },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__containers_ProposalStatsPage_Table__["a" /* default */], null)))));
};
/* harmony default export */ __webpack_exports__["a"] = (ProposalStatsPage);


/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage_Table__ = __webpack_require__(1741);


var mapStateToProps = function (state) {
    var _a = state.proposalStats, proposalStatus = _a.proposalStatus, allIds = _a.allIds;
    return {
        proposalStatus: proposalStatus,
        allIds: allIds,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage_Table__["a" /* default */]));


/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_Table_ButtonSort__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ProposalStatsPage_Table_Row__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProposalStatsPage_reducer__ = __webpack_require__(513);







var Table = function (_a) {
    var proposalStatus = _a.proposalStatus, allIds = _a.allIds;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* StyledTable */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_Table_ButtonSort__["a" /* default */], { field: __WEBPACK_IMPORTED_MODULE_6__containers_ProposalStatsPage_reducer__["a" /* SortOn */].TYPE, label: "messages.type" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_Table_ButtonSort__["a" /* default */], { field: __WEBPACK_IMPORTED_MODULE_6__containers_ProposalStatsPage_reducer__["a" /* SortOn */].LABEL, label: "messages.resource_name" })),
                proposalStatus === __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].ProposalStatus.SEEN &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { as: "th" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_Table_ButtonSort__["a" /* default */], { field: __WEBPACK_IMPORTED_MODULE_6__containers_ProposalStatsPage_reducer__["a" /* SortOn */].READ, label: "messages.status_read", isDefaultDesc: true })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { as: "th" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.downloads" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_Table_ButtonSort__["a" /* default */], { field: __WEBPACK_IMPORTED_MODULE_6__containers_ProposalStatsPage_reducer__["a" /* SortOn */].SENT, label: "messages.sent_date", isDefaultDesc: true })),
                proposalStatus === __WEBPACK_IMPORTED_MODULE_5__typings_api__["a" /* Api */].ProposalStatus.SEEN &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { as: "th" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_Table_ButtonSort__["a" /* default */], { field: __WEBPACK_IMPORTED_MODULE_6__containers_ProposalStatsPage_reducer__["a" /* SortOn */].OPENED, label: "messages.opened_date", isDefaultDesc: true })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null, allIds.length > 0
            ? allIds.map(function (id) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ProposalStatsPage_Table_Row__["a" /* default */], { key: id, id: id }); })
            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* TableCell */], { colSpan: 5 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.no_data_found" })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Table);


/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage_Table_ButtonSort__ = __webpack_require__(1743);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var mapStateToProps = function (state, ownProps) {
    var _a = state.proposalStats, _b = _a.sort, sortOn = _b.sortOn, ascending = _b.ascending, allIds = _a.allIds;
    return __assign({}, ownProps, { sortOn: sortOn, isAscending: ascending, isDisabled: allIds.length < 2 });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage_Table_ButtonSort__["a" /* default */]));


/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_actions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);





var ButtonSort = function (_a) {
    var field = _a.field, label = _a.label, sortOn = _a.sortOn, isAscending = _a.isAscending, isDisabled = _a.isDisabled, isDefaultDesc = _a.isDefaultDesc, dispatch = _a.dispatch;
    var handleClick = function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_ProposalStatsPage_actions__["f" /* sort */])({
            sortOn: field,
            ascending: field === sortOn ? !isAscending : !isDefaultDesc,
        }));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* StyledButton */], { type: "button", disabled: isDisabled, isActive: field === sortOn, isAscending: field === sortOn ? isAscending : false, onClick: handleClick },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: label }),
        !isDisabled && __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* default */].getSvgIcon('iconset_triangle-1')));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonSort);


/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledButton = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('button')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 4px;\n\tpadding-left: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 11px;\n\tline-height: 12px;\n\tbackground-color: transparent;\n\tcolor: ", ";\n\tcursor: ", ";\n\n\tsvg {\n\t\tflex: 0 0 auto;\n\t\twidth: 8px;\n\t\theight: 9px;\n\t\tmargin-left: 5px;\n\t\tfill: ", "\n\n\t\t", "\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 4px;\n\tpadding-left: 0;\n\tborder: 0;\n\toutline: 0;\n\tfont-family: HelveticaNeue, sans-serif;\n\tfont-size: 11px;\n\tline-height: 12px;\n\tbackground-color: transparent;\n\tcolor: ",
    ";\n\tcursor: ", ";\n\n\tsvg {\n\t\tflex: 0 0 auto;\n\t\twidth: 8px;\n\t\theight: 9px;\n\t\tmargin-left: 5px;\n\t\tfill: ", "\n\n\t\t", "\n\t}\n"])), function (props) { return props.isActive && !props.disabled
    ? props.theme.primary.actionColor
    : props.theme.primary.strongColor; }, function (props) { return props.disabled ? 'default' : 'pointer'; }, function (props) { return props.theme.primary.actionColor; }, function (props) { return props.isAscending && 'transform: rotate(180deg);'; });

var templateObject_1;


/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage_Table_Row__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__ = __webpack_require__(11);



var mapStateToProps = function (state, ownProps) {
    var _a = state.proposalStats, proposalStatus = _a.proposalStatus, byId = _a.byId;
    var _b = byId[ownProps.id], type = _b.type, fileType = _b.fileType, format = _b.format, label = _b.label, recipientEmail = _b.recipientEmail, readsNbr = _b.readsNbr, downloads = _b.downloads, sendingDate = _b.sendingDate, openingDate = _b.openingDate, relUrl = _b.relUrl;
    return {
        proposalStatus: proposalStatus,
        type: type,
        fileType: fileType,
        isProposal: __WEBPACK_IMPORTED_MODULE_2__utils_driveItem__["d" /* default */].isProposal(format),
        label: label,
        recipientEmail: recipientEmail,
        readsNbr: readsNbr,
        downloads: downloads,
        sendingDate: sendingDate,
        openingDate: openingDate,
        relUrl: relUrl,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ProposalStatsPage_Table_Row__["a" /* default */]));


/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceIcon__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__ = __webpack_require__(238);






var Row = function (_a) {
    var proposalStatus = _a.proposalStatus, type = _a.type, fileType = _a.fileType, isProposal = _a.isProposal, label = _a.label, recipientEmail = _a.recipientEmail, readsNbr = _a.readsNbr, downloads = _a.downloads, sendingDate = _a.sendingDate, openingDate = _a.openingDate, relUrl = _a.relUrl, dispatch = _a.dispatch;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCell */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__containers_ProposalStatsPage_actions__["c" /* openPreview */])(relUrl, type)); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ResourceIcon__["a" /* default */], { type: type, fileFormat: fileType, isProposal: isProposal })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCell */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* TableCellInner */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* TableCellInnerContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Label */], null, label),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Email */], null, recipientEmail)))),
        proposalStatus === __WEBPACK_IMPORTED_MODULE_4__typings_api__["a" /* Api */].ProposalStatus.SEEN &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCell */], null, readsNbr),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCell */], null, downloads === undefined ? '-' : downloads)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCell */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Localize"], { value: sendingDate, dateFormat: "date_format.digital_slash" })),
        openingDate &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCell */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Localize"], { value: openingDate, dateFormat: "date_format.digital_slash" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Row);


/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typings_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);




var getIconName = function (type, fileFormat, isProposal) {
    if (isProposal) {
        return 'iconset_uprez_proposal-blue';
    }
    var isFileIcon = [
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.DOCUMENT,
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.PDF,
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.PRESENTATION,
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.SPREADSHEET,
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.INDESIGN,
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.ILLUSTRATOR,
        __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.PHOTOSHOP,
    ].includes(fileFormat);
    if (isFileIcon) {
        switch (fileFormat) {
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.DOCUMENT:
                return 'iconset_uprez_file-document-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.PDF:
                return 'iconset_uprez_file-pdf-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.PRESENTATION:
                return 'iconset_uprez_file-presentation-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.SPREADSHEET:
                return 'iconset_uprez_file-spreadsheet-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.INDESIGN:
                return 'iconset_uprez_file-indesign-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.ILLUSTRATOR:
                return 'iconset_uprez_file-illustrator-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileFormats.PHOTOSHOP:
                return 'iconset_uprez_file-photoshop-blue';
            default:
                return 'iconset_uprez_file-blue';
        }
    }
    else {
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileTypes.PUBLICATION:
                return 'iconset_uprez_publication-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileTypes.IMAGE:
                return 'iconset_uprez_image-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileTypes.MOVIE:
                return 'iconset_uprez_movie-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileTypes.COMPONENT:
                return 'iconset_uprez_component-blue';
            case __WEBPACK_IMPORTED_MODULE_2__typings_api__["a" /* Api */].AssetItemFileTypes.EXTERNAL_LINK:
                return 'iconset_uprez_link-blue';
            default:
                return 'iconset_uprez_file-blue';
        }
    }
};
var ResourceIcon = function (_a) {
    var type = _a.type, fileFormat = _a.fileFormat, isProposal = _a.isProposal;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledResourceIcon */], null, __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* default */].getSvgIcon(getIconName(type, fileFormat, isProposal))));
};
/* harmony default export */ __webpack_exports__["a"] = (ResourceIcon);


/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledResourceIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var StyledResourceIcon = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 32px;\n\t\theight: 42px;\n\t}\n"], ["\n\tdisplay: flex;\n\tcursor: pointer;\n\n\tsvg {\n\t\twidth: 32px;\n\t\theight: 42px;\n\t}\n"])));

var templateObject_1;


/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var TableWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1;\n\tmargin: 30px -50px 0;\n\tpadding: 0 50px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t@media ", " {\n\t\tmargin: 30px -25px 0;\n\t\tpadding: 0 25px;\n\t}\n"], ["\n\tflex: 1;\n\tmargin: 30px -50px 0;\n\tpadding: 0 50px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t@media ", " {\n\t\tmargin: 30px -25px 0;\n\t\tpadding: 0 25px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 80), __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]);

var templateObject_1, templateObject_2;


/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesPage__ = __webpack_require__(1751);


var mapStateToProps = function (state) {
    var _a = state.notes, currentStatus = _a.currentStatus, loadingStatus = _a.loadingStatus;
    return {
        notesStatus: currentStatus,
        loadingStatus: loadingStatus,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NotesPage__["a" /* default */]));


/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Page__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Page_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Toggle__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_Table__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
var _a;










var notesStatusConfig = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["b" /* NotesStatus */].LOCAL] = {
        id: __WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["b" /* NotesStatus */].LOCAL,
        label: 'messages.local',
    },
    _a[__WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["b" /* NotesStatus */].SHARED] = {
        id: __WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["b" /* NotesStatus */].SHARED,
        label: 'messages.shared',
    },
    _a);
var NotesPage = function (_a) {
    var notesStatus = _a.notesStatus, loadingStatus = _a.loadingStatus, dispatch = _a.dispatch;
    var tableContainer = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["c" /* getNotes */])());
        return function () {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["e" /* resetNotes */])());
        };
    }, []);
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        if (tableContainer.current) {
            tableContainer.current.scrollTop = 0;
        }
    }, [notesStatus]);
    var isLoading = [__WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["a" /* LoadingStatus */].LOADING, __WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["a" /* LoadingStatus */].SAVING].includes(loadingStatus);
    var loaderMessage = loadingStatus === __WEBPACK_IMPORTED_MODULE_7__containers_NotesPage_reducer__["a" /* LoadingStatus */].SAVING
        ? 'messages.saving'
        : 'messages.loading';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_Page__["a" /* default */], { pageType: __WEBPACK_IMPORTED_MODULE_3__containers_Page_constants__["a" /* PageType */].NotesPage, title: "messages.my_notes" },
        isLoading &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* Loader */], null,
                __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* default */].getSvgIcon('iconset_loading'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: loaderMessage })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Toggle__["a" /* default */], { items: Object.values(notesStatusConfig), activeId: notesStatus, onItemClick: function (status) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["f" /* setNotesStatus */])(status)); }, width: "110px" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* TableWrapper */], { ref: tableContainer },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__containers_NotesPage_Table__["a" /* default */], null))));
};
/* harmony default export */ __webpack_exports__["a"] = (NotesPage);


/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesPage_Table__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(1757);



var mapStateToProps = function (state) {
    return {
        allIds: Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* getSortedByDateIds */])(state),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NotesPage_Table__["a" /* default */]));


/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_NotesPage_Table_Row__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(377);




var Table = function (_a) {
    var allIds = _a.allIds;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* StyledTable */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.title" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.title_and_preview" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.preview" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.last_update_date" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TableCell */], { as: "th" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.options" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null, allIds.length > 0
            ? allIds.map(function (id) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_NotesPage_Table_Row__["a" /* default */], { key: id, id: id }); })
            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TableCell */], { colSpan: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Translate"], { value: "messages.no_data_found" })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Table);


/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NotesPage_Table_Row__ = __webpack_require__(1755);


var mapStateToProps = function (state, ownProps) {
    var notes = state.notes, currentStatus = state.notes.currentStatus;
    var _a = notes[currentStatus][ownProps.id], title = _a.title, date = _a.date, modifiedOn = _a.modifiedOn, hasImage = _a.hasImage;
    return {
        title: title,
        date: date,
        modifiedOn: modifiedOn,
        hasImage: hasImage,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_NotesPage_Table_Row__["a" /* default */]));


/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Selection_Toggler__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Selection_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_indexedDB_manager__ = __webpack_require__(21);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var Row = function (_a) {
    var id = _a.id, title = _a.title, date = _a.date, modifiedOn = _a.modifiedOn, hasImage = _a.hasImage, dispatch = _a.dispatch;
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](''), 2), imageSrc = _b[0], setImageSrc = _b[1];
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
        __WEBPACK_IMPORTED_MODULE_9__utils_indexedDB_manager__["a" /* default */].getNote(id).then(function (note) {
            if (note) {
                setImageSrc(note.drawing);
            }
        });
    }, [modifiedOn, date]);
    var renderButtons = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* TableCellButton */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["g" /* toggleNotesEditor */])(id)); } }, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_uprez_write')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* TableCellButton */], { onClick: function () { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__containers_NotesPage_actions__["d" /* removeNote */])(id)); } }, __WEBPACK_IMPORTED_MODULE_7__utils__["d" /* default */].getSvgIcon('iconset_uprez_delete')))); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* TableCell */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* TableCellInner */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_Selection_Toggler__["a" /* default */], { itemId: id, displayMode: __WEBPACK_IMPORTED_MODULE_8__utils_driveItem__["c" /* ResolutionDisplayType */].RowItem, selectionType: __WEBPACK_IMPORTED_MODULE_5__containers_Selection_actions__["b" /* SelectionType */].NOTES }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Title__["a" /* default */], { id: id, title: title, dispatch: dispatch })),
            imageSrc &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* TableCellImageWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCellImage */], { src: imageSrc }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* TableCell */], { hasImage: hasImage }, imageSrc &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* TableCellImageWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* TableCellImage */], { src: imageSrc }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* TableCell */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux_i18n__["Localize"], { value: modifiedOn || date, dateFormat: "date_format.digital_slash" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* TableCellInner */], null, renderButtons())),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* TableCell */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* TableCellInner */], null, renderButtons()))));
};
/* harmony default export */ __webpack_exports__["a"] = (Row);


/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_NotesPage_actions__ = __webpack_require__(121);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



var Title = function (_a) {
    var id = _a.id, title = _a.title, dispatch = _a.dispatch;
    var divElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var textAreaElement = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var titleHeight = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](0);
    var _b = __read(__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false), 2), isEditing = _b[0], setIsEditing = _b[1];
    var handleClick = function () {
        titleHeight.current = divElement.current.clientHeight;
        setIsEditing(true);
        setTimeout(function () {
            if (textAreaElement.current) {
                textAreaElement.current.focus();
                var titleLength = title.length * 2;
                textAreaElement.current.setSelectionRange(titleLength, titleLength);
                textAreaElement.current.style.height = titleHeight.current + "px";
            }
        }, 0);
    };
    var handleBlur = function (value) {
        if (value !== title) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__containers_NotesPage_actions__["h" /* updateNote */])(id, { title: value || '-' }, false));
        }
        setIsEditing(false);
        titleHeight.current = 0;
    };
    if (isEditing) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* TableCellTitle */], { as: "textarea", ref: textAreaElement, defaultValue: title, maxLength: 255, onBlur: function (e) { return handleBlur(e.target.value); } }));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* TableCellTitle */], { as: "div", ref: divElement, onClick: handleClick }, title));
};
/* harmony default export */ __webpack_exports__["a"] = (Title);


/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSortedByDateIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(114);

var getNotes = function (state) { return state.notes; };
var getCurrentStatus = function (state) { return state.notes.currentStatus; };
var getSortedByDateIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getNotes, getCurrentStatus, function (notes, currentStatus) { return Object.values(notes[currentStatus])
    .sort(function (a, b) {
    var dateA = a.modifiedOn || a.date;
    var dateB = b.modifiedOn || b.date;
    return dateB - dateA;
})
    .map(function (_a) {
    var id = _a.id;
    return id;
}); });


/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_style__ = __webpack_require__(7);
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var TableWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1;\n\tmargin: 30px -50px 0;\n\tpadding: 0 50px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t@media ", " {\n\t\tmargin: 30px -25px 0;\n\t\tpadding: 0 25px;\n\t}\n"], ["\n\tflex: 1;\n\tmargin: 30px -50px 0;\n\tpadding: 0 50px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\n\t@media ", " {\n\t\tmargin: 30px -25px 0;\n\t\tpadding: 0 25px;\n\t}\n"])), __WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["a" /* Format */].Smartphone);
var Loader = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"], ["\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: bold;\n\tfont-size: 21px;\n\tbackground-color: ", ";\n\n\tsvg {\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tanimation: ", ";\n\t\tmargin-right: 20px;\n\t}\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__utils_style__["a" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_1__utils_styles_constants__["c" /* StyleColor */].White, 80), __WEBPACK_IMPORTED_MODULE_2__utils_style__["e" /* spin */]);

var templateObject_1, templateObject_2;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.d8fa7120.js